(function() {
    'use strict';

    angular
        .module('gatewayApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'angular-loading-bar',
            'ncy-angular-breadcrumb',
            'bckrueger.angular-currency',
		    'ui.dashboard',
		    'file-model',
		    'ui.mask',
		    'as.sortable',
		    'ngIdle',
		    'ae-datetimepicker',
            'ngCordova',
            'fileLogger'
	    ])
        .run(["$templateCache", function($templateCache) {$templateCache.put("multiple-autocomplete-tpl.html","<div ng-class=\"disabledClass\" class=\"ng-ms form-item-container\" >\r\n    <ul class=\"list-inline\">\r\n        <li ng-repeat=\"item in modelArr\">\r\n			<span ng-if=\"displayColumn == undefined || displayColumn == \'\'\">\r\n				{{item}} <span class=\"remove\" ng-click=\"removeAddedValues(item)\">\r\n                <i class=\"glyphicon glyphicon-remove\"></i></span>&nbsp;\r\n			</span>\r\n            <span ng-if=\"displayColumn != undefined && displayColumn != \'\'\">\r\n				{{item[displayColumn]}} <span class=\"remove\" ng-click=\"removeAddedValues(item)\">\r\n                <i class=\"glyphicon glyphicon-remove\"></i></span>&nbsp;\r\n			</span>\r\n        </li>\r\n        <li>\r\n            <input name=\"{{name}}\" ng-model=\"inputValue\" placeholder=\"\" ng-keydown=\"keyParser($event)\"\r\n    ng-show=\"controlEnabled\"              err-msg-required=\"{{errMsgRequired}}\"\r\n                   ng-focus=\"onFocus()\" ng-blur=\"onBlur()\" ng-required=\"!modelArr.length && isRequired\"\r\n                    ng-change=\"onChange()\">\r\n        </li>\r\n    </ul>\r\n</div>\r\n<div class=\"autocomplete-list\" ng-show=\"isFocused || isHover\" ng-mouseenter=\"onMouseEnter()\" ng-mouseleave=\"onMouseLeave()\">\r\n    <ul ng-if=\"displayColumn == undefined || displayColumn == \'\'\">\r\n        <li ng-class=\"{\'autocomplete-active\' : selectedItemIndex == $index}\"\r\n            ng-repeat=\"suggestion in suggestionsArr | filter : inputValue | filter : alreadyAddedValues\"\r\n            ng-click=\"onSuggestedItemsClick(suggestion)\" ng-mouseenter=\"mouseEnterOnItem($index)\">\r\n            {{suggestion}}\r\n        </li>\r\n    </ul>\r\n    <ul ng-if=\"displayColumn != undefined && displayColumn != \'\'\">\r\n        <li ng-class=\"{\'autocomplete-active\' : selectedItemIndex == $index}\"\r\n            ng-repeat=\"suggestion in suggestionsArr | filter : inputValue | filter : alreadyAddedValues\"\r\n            ng-click=\"onSuggestedItemsClick(suggestion)\" ng-mouseenter=\"mouseEnterOnItem($index)\">\r\n   <i ng-if=\"displayColumn2 == undefined || objectPropertyCodeName == \'\'\">\r\n           {{suggestion[displayColumn]}}\r\n        </i>  <i ng-if=\"displayColumn2 != undefined && objectPropertyCodeName != \'\'\">\r\n           {{suggestion[displayColumn]}} :: {{suggestion[displayColumn2]}} \r\n        </i></li>\r\n    </ul>\r\n</div>");}])
        .directive('csplMultipleAutocomplete', ['$filter','AppLookup', 'GlobalValues', '$rootScope', '$sessionStorage', 'DateUtils',
            function ($filter,AppLookup, GlobalValues, $rootScope, $sessionStorage, DateUtils) {
                return {
                    restrict: 'EA',
                    scope : {
                        suggestionsArr : '=?',
                        modelArr : '=ngModel',
                        beforeSelectItem : '=?',
                        afterSelectItem : '=?',
                        beforeRemoveItem : '=?',
                        afterRemoveItem : '=?',
                        filterValue : '=',
                        lookupName: '@',
                        displayColumn : '@',
                        displayColumn2 : '@',
                        controlEnabled : "="
                    },
                    templateUrl: 'multiple-autocomplete-tpl.html',

                    link : function(scope, element, attr){
                	scope.disabledClass= '';
                        scope.selectedItemIndex = 0;
                        scope.name = attr.name;
                        scope.isRequired = attr.required;
                        scope.errMsgRequired = attr.errMsgRequired;
                        scope.isHover = false;
                        scope.isFocused = false;

                        if(scope.controlEnabled==null || scope.controlEnabled=="")
                            scope.controlEnabled = true;

                        if(scope.controlEnabled=="false" || scope.controlEnabled==false)
                             scope.disabledClass = 'div-disabled';

                        scope.$watch("controlEnabled",function(value){
                            if(value=="false" || value==false)
                             scope.disabledClass = 'div-disabled';
                         else
                             scope.disabledClass = '';
                        });

                        var getSuggestionsList = function () {
                            scope.suggestionsArr  = AppLookup.getLookupValue(scope.lookupName, "");
                        };

                        if(scope.suggestionsArr == null || scope.suggestionsArr == ""){
                            if(scope.lookupName != null && scope.lookupName != "")
                                getSuggestionsList();
                            else{
                                console.log("*****There is no suggestion list added ****");
                            }
                        }

                        if(scope.controlEnabled ==null || scope.controlEnabled ==""){
                            scope.controlEnabled = true;
                        }

                        scope.$watch("filterValue",function(value){
                	    if(value != null && value != "") {
                	    if(scope.modelArr != null && scope.modelArr != "") {
                		var index =0;
                		for(index =0 ; index< value.length; index++){
                		var itemIndex = 0
                		for (itemIndex =0; itemIndex < scope.suggestionsArr.length; itemIndex++)
                		    if(scope.suggestionsArr[itemIndex][scope.displayColumn] == value[index][scope.displayColumn])
                                {
                                scope.suggestionsArr.splice(itemIndex, 1);
                                var removeIndex =0;
                                for (removeIndex =0; removeIndex < scope.modelArr.length; removeIndex++)
                    		 if(scope.modelArr[removeIndex][scope.displayColumn] == value[index][scope.displayColumn])
                                    {
                    		     var item = scope.modelArr[removeIndex][scope.displayColumn];
                                    if(scope.beforeRemoveItem && typeof(scope.beforeRemoveItem) == 'function')
                                        scope.beforeRemoveItem(item);

                                    scope.modelArr.splice(removeIndex, 1);

                                    if(scope.afterRemoveItem && typeof(scope.afterRemoveItem) == 'function')
                                        scope.afterRemoveItem(item);
                                }
                                }
                            }
                	    }
                	    }

                	},true);



                        if(scope.modelArr == null || scope.modelArr == ""){
                            scope.modelArr = [];
                        }
                        scope.onFocus = function () {
                            scope.isFocused=true
                        };

                        scope.onMouseEnter = function () {
                            scope.isHover = true
                        };

                        scope.onMouseLeave = function () {
                            scope.isHover = false;
                        };

                        scope.onBlur = function () {
                            scope.isFocused=false;
                        };

                        scope.onChange = function () {
                            scope.selectedItemIndex = 0;
                        };

                        scope.keyParser = function ($event) {
                            var keys = {
                                38: 'up',
                                40: 'down',
                                8 : 'backspace',
                                13: 'enter',
                                9 : 'tab',
                                27: 'esc'
                            };
                            var key = keys[$event.keyCode];
                            if(key == 'backspace' && scope.inputValue == ""){
                                if(scope.modelArr.length != 0){
                                    scope.removeAddedValues(scope.modelArr[scope.modelArr.length-1]);
                                    // scope.modelArr.pop();
                                }
                            }
                            else if(key == 'down'){
                                var filteredSuggestionArr = $filter('filter')(scope.suggestionsArr, scope.inputValue);
                                filteredSuggestionArr = $filter('filter')(filteredSuggestionArr, scope.alreadyAddedValues);
                                if(scope.selectedItemIndex < filteredSuggestionArr.length -1)
                                    scope.selectedItemIndex++;
                            }
                            else if(key == 'up' && scope.selectedItemIndex > 0){
                                scope.selectedItemIndex--;
                            }
                            else if(key == 'esc'){
                                scope.isHover = false;
                                scope.isFocused=false;
                            }
                            else if(key == 'enter'){
                                var filteredSuggestionArr = $filter('filter')(scope.suggestionsArr, scope.inputValue);
                                filteredSuggestionArr = $filter('filter')(filteredSuggestionArr, scope.alreadyAddedValues);
                                if(scope.selectedItemIndex < filteredSuggestionArr.length)
                                    scope.onSuggestedItemsClick(filteredSuggestionArr[scope.selectedItemIndex]);
                            }
                        };

                        scope.onSuggestedItemsClick = function (selectedValue) {
                            if(scope.beforeSelectItem && typeof(scope.beforeSelectItem) == 'function')
                                scope.beforeSelectItem(selectedValue);

                            scope.modelArr.push(selectedValue);

                            if(scope.afterSelectItem && typeof(scope.afterSelectItem) == 'function')
                                scope.afterSelectItem(selectedValue);
                            scope.inputValue = "";
                        };

                        var isDuplicate = function (arr, item) {
                            var duplicate = false;
                            if(arr == null || arr == "")
                                return duplicate;

                            for(var i=0;i<arr.length;i++){
                                duplicate = angular.equals(arr[i], item);
                                if(duplicate)
                                    break;
                            }
                            return duplicate;
                        };

                        scope.alreadyAddedValues = function (item) {
                            var isAdded = true;
                            isAdded = !isDuplicate(scope.modelArr, item);
                            // if(scope.modelArr != null && scope.modelArr !=
							// ""){
                            // isAdded = scope.modelArr.indexOf(item) == -1;
                            // console.log("****************************");
                            // console.log(item);
                            // console.log(scope.modelArr);
                            // console.log(isAdded);
                            // }
                            return isAdded;
                        };

                        scope.removeAddedValues = function (item) {
                            if(scope.modelArr != null && scope.modelArr != "") {
                                var itemIndex = scope.modelArr.indexOf(item);
                                if (itemIndex != -1) {
                                    if(scope.beforeRemoveItem && typeof(scope.beforeRemoveItem) == 'function')
                                        scope.beforeRemoveItem(item);

                                    scope.modelArr.splice(itemIndex, 1);

                                    if(scope.afterRemoveItem && typeof(scope.afterRemoveItem) == 'function')
                                        scope.afterRemoveItem(item);
                                }
                            }
                        };

                        scope.mouseEnterOnItem = function (index) {
                            scope.selectedItemIndex = index;
                        };
                    }
                };
            }
        ])
		.directive("fileread", [function () {
		    return {
		        scope: {
		            fileread: "="
		        },
		        link: function (scope, element, attributes) {
		            element.bind("change", function (changeEvent) {
		                var reader = new FileReader();
		                reader.onload = function (loadEvent) {
		                    scope.$apply(function () {
		                        scope.fileread = changeEvent.target.files[0];
		                    });
		                }
		                reader.readAsDataURL(changeEvent.target.files[0]);
		            });
		        }
		    }
		}])       
       .directive('csplAch', ['AppLookup', '$rootScope', '$sessionStorage', function(AppLookup, $rootScope, $sessionStorage) {
            return {
                template: '<input type="text" role="combobox" id="{{controlId}}" autocomplete="off" ng-model="controlModel" ng-disabled="controlDisabled || overrideDisabled"  ng-change="updateModel()" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" typeahead-append-to-body="appendToBody" typeahead-popup-template-url="app/cspl-ach-dropdown-template.html" uib-typeahead="lookupName as customTypeAcheadLabel(lookupName, displayColumn) for lookupName in lookupValues | filter:$viewValue | limitTo:50" class="form-control" typeahead-editable="false" typeahead-min-length="1" ng-attr-style="background:url({{imageurl}}) no-repeat scroll 5px 5px; background-position: bottom 5px right 5px; background-color:{{bgColor}}; border-color:{{boColor}}; color:{{colorValue}}; padding-right:30px; margin-bottom: 8px;" placeholder="{{controlPlaceHolder}}"><span ng-show="Error != null && Error != \'\'" class="help-block-error" >{{Error}}</span><span ng-show="errorText != null && errorText!= \'\' && showErrorText" class="help-block-warning-error arrow-up" style="position: absolute;margin: 0px 2px 2px 0px; right: 0px; background: #ffffff; padding: 3px 1px; border-radius: 4px; border-right: 5px solid transparent; border-top: 5px solid black; z-index: 1000; top: 25px; white-space: nowrap;">{{errorText}}</span><span ng-show="(helpText != null && showHelpText)" class="help-block">{{helpText}}</span>',
                restrict: 'E',
                scope: {
                    controlModel: '=',
                    controlRequired: '=',
                    controlDisabled: "=",
                    controlValueChange: '=',
                    form: '=',
                    controlId: '@',
                    appendToBody: '@',
                    lookupName: '@',
                    displayColumn: '@',
                    filterValue: '@',
                    helpText: '@',
                    themeType: '@',
                    controlModified:'=',
                    controlPlaceHolder:'@',
                    showErrorText: '=',
                    defaultValue: '=' 
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        var previousFilter = "";
                        // typeahead-min-length="0"

                        $scope.boColor = "#BB8557";
                        $scope.overrideDisabled = false;

                        if ($scope.appendToBody == null) {
                            $scope.appendToBody = false;
                        }


                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }
                        
                        $scope.customTypeAcheadLabel = function(lookup, displayColumn) {
                            if (lookup == null || lookup == undefined)
                               return;

                            $scope.displayColumnArr = displayColumn.split(","); 
                            $scope.numberOfColumns = $scope.displayColumnArr.length; 
                            if (lookup[$scope.displayColumnArr[0]] == '' || lookup[$scope.displayColumnArr[0]] == undefined) {
                                return '';
                             }
                             
                            var label = lookup[$scope.displayColumnArr[0]];
                            return label;
                        }

                        $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == "true" || value == true)) {
                                // element.attr('required', true);
                            	// attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "achrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                // element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                    $scope.Error = "";
                                    $scope.errorText = "";
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled || $scope.overrideDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#BB8557";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                                if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && ($scope.controlModel == null || $scope.controlModel == "" || $scope.controlModel== undefined)) {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "achrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                        $scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else if((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && ($scope.controlModel != null && $scope.controlModel != "" && $scope.controlModel!=undefined)){
                                     if ($scope.form != null) {
                                         $scope.form.$setValidity(attributes.controlId + "achrequired", true);   
                                     }
                                    $scope.Error = "";
                                    if ($scope.controlDisabled) {
                                        $scope.bgColor = "#333333";
                                        if($scope.themeType=='light'){
                                            // $scope.bgColor = "#FFFFFF";
                                            $scope.boColor = "#BB8557";
                                        }
                                        if($scope.themeType=='light'){
                                            $scope.bgColor = "#E0E0E0";
                                        }
                                    } else {
                                        $scope.bgColor = "#0B0B0B";
                                        if($scope.themeType=='light'){
                                            $scope.bgColor = "#FEFAEE";
                                            $scope.boColor = "#BB8557";
                                        }
                                    }
                                    
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                        $scope.Error = ""
                                    }
                                    if ($scope.controlDisabled) {
                                        $scope.bgColor = "#333333";
                                        if($scope.themeType=='light'){
                                            $scope.bgColor = "#E0E0E0";
                                            $scope.boColor = "#C2C2C2";
                                        }
                                    } else {
                                        $scope.bgColor = "#0B0B0B";
                                        if($scope.themeType=='light'){
                                            $scope.bgColor = "#FFFFFF";
                                            $scope.boColor = "#C2C2C2";
                                        }
                                    }
                                    $scope.boColor = "#595959";
                                    if($scope.themeType=='light'){
                                        $scope.boColor = "#C2C2C2";
                                    }
                                }
                            }
                            if ($scope.controlModel != null && $scope.controlModel != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if ( (attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && ($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "achrequired", false);
                                }
                                $scope.boColor = "#BB8557";
                               
                            } else if ( (attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && !($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                }
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                            		$scope.bgColor = "#FEFAEE";
                            	}
                            }
                        })

                        $scope.onFocus = function(){
                        	$scope.boColor = "#FFC000";
                            $scope.errorText = "";
                        }
                        
                        $scope.onBlur = function(value){
                            if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true")) {
                                $scope.boColor = "#BB8557";
                                if(value==undefined || value=='' || value==null){
                                    /*
                                     * if($scope.showError!="false"){
                                     * $scope.Error = "This field cannot be left
                                     * blank"; }
                                     */
                                    if($scope.showErrorText!=true){
                                        $scope.Error = "This field cannot be left blank";
                                    }
                                    $scope.errorText = "This field cannot be left blank";
                                    $scope.boColor = "#FF3737";
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        }

                        $scope.$watch('controlModel', function(value) {
                            if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value == null || value == "" || value== undefined)) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "achrequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else if((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value != null && value != "" && value!=undefined)){
                                 if ($scope.form != null) {
                                     $scope.form.$setValidity(attributes.controlId + "achrequired", true);   
                                     $scope.boColor = "#BB8557";
                                 }
                                $scope.Error = "";
                                $scope.errorText = "";
                                if ($scope.controlDisabled || $scope.overrideDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	// $scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#BB8557";
                                    }
                                    if($scope.themeType=='light'){
                                		$scope.bgColor = "#E0E0E0";
                                	}
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    	$scope.boColor = "#BB8557";
                                    }
                                }
                                
                            } else {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                    $scope.Error = "";
                                    $scope.errorText = "";
                                }
                                if ($scope.controlDisabled || $scope.overrideDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }

                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                                if (attributes.required != null && (value != null && value != "")) {
                                	$scope.boColor = "#BB8557";
                                }
                            }
                        })

                        if (attributes.darkTheme == null) {
                            $scope.colorValue = "#F2F2F2";
                            $scope.imageurl = "assets/images/search.png";
                        } else {
                            $scope.colorValue = "#7F7F7F";
                            $scope.imageurl = "assets/images/search.png";
                        }
                        if ($scope.themeType == 'light'){
                            $scope.imageurl = "assets/images/search.png";
                        	$scope.colorValue = '#262626';	
                        }

                        if (attributes.filterValue == null) {
                            $scope.lookupValues = AppLookup.getLookupValue($scope.lookupName, "");
                            // $scope.controlModel =
							// {shortName:'SudarshanIndia'};
                        } else {
   
                            if(($scope.lookupName!=undefined && $scope.lookupName!=null && $scope.lookupName!='') && ($scope.lookupName=='fcyCurrencyPair' || $scope.lookupName=='orderCurrencyPair')){
                                                         
attributes.$observe('filterValue', function(value) {
    if (previousFilter == "") {
        previousFilter = value;
    } else if (previousFilter != value && previousFilter != null && previousFilter != "") {
        previousFilter = value;
        $scope.controlModel = null;
    }

    var promise = AppLookup.getLookupValue($scope.lookupName, $scope.filterValue);
    if (!angular.isUndefined(promise) && _.keys(promise) != "") {
        promise.$promise.then(function(result) {
            $scope.lookupValues = result;

            if (result != null && result.length > 0) {
                if ($scope.controlModel != null && $scope.controlModel != undefined) {
                    // ✅ Check if current controlModel exists in list
                    var existingItem = result.find(function(item) {
                        return item.id === $scope.controlModel.id; // 🔁 change to your key
                    });

                    // if (existingItem) {
                    //     // ✅ Found — re-assign to refresh binding
                    //     $scope.controlModel = existingItem;
                    // } else {
                        // ❌ Not found — check default value
                        selectDefaultOrFirst(result);
                   // }
                } else {
                    // No current model — check default value
                    selectDefaultOrFirst(result);
                }
            } else {
                $scope.lookupValues = null;
                $scope.controlModel = null;
            }
        });
    } else {
        $scope.lookupValues = null;
        $scope.controlModel = null;
    }
});
                            }else{
attributes.$observe('filterValue', function(value) {
                                if (previousFilter == "") {
                                    previousFilter = value;
                                } else if (previousFilter != value && previousFilter != null && previousFilter != "") {
                                    previousFilter = value;
                                    $scope.controlModel = null;
                                }
                                //$scope.lookupValues = AppLookup.getLookupValue($scope.lookupName, value);
                                var promise = AppLookup.getLookupValue($scope.lookupName, $scope.filterValue);
                                if (!angular.isUndefined(promise) && _.keys(promise)!="") {
                                    promise.$promise.then(function(result) {
                                        $scope.lookupValues = result;
                                        if (result!= "" && result.length == 1 
                                            && ($scope.controlModel == null || $scope.controlModel == undefined)
                                            && ($scope.lookupName == "validBranchDetailsForBank" || $scope.lookupName == "validStatusBranchesForBank")) {
                                            $scope.controlModel = result[0];
                                        }
                                    });
                                }else{
                                	$scope.lookupValues = null;
                                }
                            });
                        
                        }

// ✅ Helper function
function selectDefaultOrFirst(result) {
    if ($scope.defaultValue != null && $scope.defaultValue != undefined) {
        // Check if defaultValue exists in list
        var defaultItem = result.find(function(item) {
            return item.id === $scope.defaultValue.id; // 🔁 change to your key
        });

        if (defaultItem) {
            // ✅ Default found in list — select it
            $scope.controlModel = defaultItem;
        } else {
            // ❌ Default not in list — select first
            $scope.controlModel = result[0];
        }
    } else {
        // No default provided — select first
        $scope.controlModel = result[0];
    }
}
                        }
                        attributes.$observe('required', function(value) {
                        	if(value==null || value==undefined){
                        		// element.removeAttr('required');
                        		if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                        	}else{
                        		// attributes.$set("required", true);
                        		if ($scope.controlModel == null || $scope.controlModel == "" || $scope.controlModel == undefined) {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "achrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                        	
                        	}
                        });
                        /*
						 * $scope.getLookupValues = function(filterText){
						 * if($scope.loadDynamicData){ if(filterText!=null &&
						 * filterText!=undefined && filterText!=''){
						 * $timeout(function(){ $scope.lookupValues =
						 * AppLookup.getLookupValue($scope.lookupName,
						 * filterText, function(result){ console.log(result);
						 * return result; }); },0.0000); return
						 * $scope.lookupValues; } }else{ //do nothing return
						 * $scope.lookupValues; } }
						 */
                        
                        $rootScope.$on('gatewayApp:loadLookupComplete', function(event, result) {
                           // if ($scope.controlModel == null && result.length == 1 && ($scope.lookupName == "validBranchDetailsForBank" || $scope.lookupName == "validStatusBranchesForBank")) {
                           //      $scope.controlModel = result[0];
                           //  }
                        });
                        $scope.$watch('controlModified', function(value) {
                         if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                $scope.boColor = "#00B0F0";
                                
                            }
                        
                        })

                   }
                    return linkFunction;
                }
            };
        }])
        .directive('csplDtp', ['DateUtils', '$filter', '$timeout', function(DateUtils, $filter, $timeout) {
            var controllerName = 'dateEditCtrl';
            return {
                controller: function() {
                    this.popupOpen = false;
                    this.openPopup = function($event) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        this.popupOpen = true;
                    };
                },
                controllerAs: controllerName,
                template: '<div class="input-group" ng-disabled="controlDisabled"><input name="cspl-dtp" id="controlId" type="text" ng-disabled="controlDisabled" ng-attr-placeholder="{{controlPlaceHolder}}" autocomplete="off" class="form-control" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" ng-attr-style="background-color:{{bgColor}};border-color:{{boColor}};color:{{colorValue}}; margin-bottom:8px;" uib-datepicker-popup="d!-M!-yyyy" datepicker-append-to-body="appendToBody" datepicker-options="{ minDate: controlMinDate, maxDate: controlMaxDate}" ng-model="controlModel" ui-mask="99-99-9999" ui-mask-placeholder="" ui-mask-placeholder-char="space" model-view-value="true" is-open="dateEditCtrl.popupOpen" /><span class="input-group-btn"><button type="button" tabindex="-1" ng-disabled="controlDisabled" class="btn btn-primary" ng-attr-style="border-color:{{boColor}}; background:{{bgColor}}; border-left:0.25px solid {{boColor}}; height:34px; margin-bottom:8px;" ng-click="dateEditCtrl.openPopup($event)" ><i class="glyphicon glyphicon-calendar"></i></button></span></div><span ng-show="Error != null && Error!= \'\'" class="help-block-error">{{Error}}</span><span ng-show="errorText != null && errorText!= \'\' && showErrorText" class="help-block-warning-error arrow-up" style="position: absolute;margin: 0px 2px 2px 0px; right: 0px; background: #ffffff; padding: 3px 1px; border-radius: 4px; border-right: 5px solid transparent; border-top: 5px solid black; z-index: 1000; top: 25px; white-space: nowrap;">{{errorText}}</span><span ng-show="(helpText != null && showHelpText)" class="help-block">{{helpText}}</span>',
                restrict: 'E',
                scope: {
                    controlMinDate: '=',
                    controlMaxDate: '=',
                    controlRequired: '=',
                    controlModel: '=',
                    controlDisabled: '=',
                    controlValueChange: '=',
                    appendToBody: '@',
                    form: '=',
                    controlEnterKey: '&',
                    controlLeaveKey: '&',
                    controlId: '@',
                    helpText: '@',
                    themeType: '@',
                    holidayList: '=',
                    showErrorText: '=',
                    orderEntryControl: '=',
                    controlPlaceHolder: '@',
                    controlModified:'='
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.boColor = "#BB8557";
                        // if($scope.controlMinDate==null || $scope.controlMinDate==undefined || $scope.controlMinDate==''){
                        // 	$scope.controlMinDate = new Date("1900-01-01");
                        // }
                        // if($scope.controlMaxDate==null || $scope.controlMaxDate==undefined || $scope.controlMaxDate==''){
                        // 	$scope.controlMaxDate = new Date("9999-12-31");
                        // }

                        element.bind("keydown keypress", function (event) {
        		            if(event.which === 13) {
        		            	$scope.$apply(function (){
        		            		$scope.$parent.$eval(attributes.controlEnterKey);
        		                });
        		
        		                event.preventDefault();
        		            }
        		        });

                        element.bind("change", function (event) {
                            $timeout(function (){
                                $scope.$parent.$eval(attributes.controlLeaveKey);
                            },200);

                            event.preventDefault();
                
                        });
                        if($scope.controlPlaceHolder == null || $scope.controlPlaceHolder ==undefined){
                        	
                        	$scope.controlPlaceHolder = 'dd-mm-yyyy';
                        }
                        if ($scope.appendToBody == null) {
                            $scope.appendToBody = false;
                        }

                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                        $scope.$watch('dateEditCtrl.popupOpen', function(value){
                            if(value!=true){
                                $scope.onBlur($scope.controlModel);
                            }
                        })

                         $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	//attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    }
                                    $scope.Error = "";
                                    $scope.errorText = "";
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                                validateGivenDate($scope.controlModel);
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.Error = "";
                                $scope.errorText = "";
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                    $scope.bgColor = "#E0E0E0";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                    $scope.bgColor = "#FEFAEE";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                            }

                            if (value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if ( (attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && ($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.boColor = "#BB8557";
                               
                            } else if ( (attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && !($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                    $scope.bgColor = "#FEFAEE";
                                }
                            }
                        })

                        $scope.onFocus = function(){
                        	$scope.boColor = "#FFC000";
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		// $scope.Error = "This field cannot be left
									// blank";
                                    $scope.errorText = "Invalid date";
                                    if($scope.showErrorText!=true){
                                        $scope.Error = "Invalid date";
                                    }
                               		$scope.boColor = "#FF3737";
                                }else{
                                    validateGivenDate(value);
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                                validateGivenDate(value);
                            }
                        }

                        function validateGivenDate(value){
                            if(value!=null && value!=undefined && value!=''){
                                $scope.errorText = "";
                                $scope.Error = "";
                                angular.forEach($scope.holidayList, function(value1){
                                    if(value1==DateUtils.convertLocalDateToServer(value)){
                                        $scope.errorText = "Date should not be a holiday";
                                        if($scope.showErrorText!=true){
                                            $scope.Error = "Date should not be a holiday";
                                        }
                                        if($scope.orderEntryControl!=null && $scope.orderEntryControl!=undefined && $scope.orderEntryControl==true){
                                            $scope.errorText = "Settlement date cannot be a holiday";
                                        }
                                        $scope.boColor = "#FF3737";
                                        if($scope.form!=null){
                                            $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                        }
                                    }
                                }) 
                                //validate max date and min date
                                var maxdateFromUI = angular.copy($scope.controlMaxDate);
                                if(maxdateFromUI==null || maxdateFromUI==undefined || maxdateFromUI==''){
                                    maxdateFromUI = new Date('9999-12-31');
                                }
                                var mindateFromUI = angular.copy($scope.controlMinDate);
                                if(mindateFromUI==null || mindateFromUI==undefined || mindateFromUI==''){
                                    mindateFromUI = new Date('1900-01-01');
                                }
                                var maxdate = DateUtils.convertLocalDateToServer(maxdateFromUI);
                                var mindate = DateUtils.convertLocalDateToServer(mindateFromUI);
                                if(moment(maxdate).isBefore(DateUtils.convertLocalDateToServer(value))){
                                    $scope.errorText = "Allowed last date is " + $filter('date')(new Date($scope.controlMaxDate),'dd-MMM-yyyy');
                                    if($scope.showErrorText!=true){
                                        $scope.Error = "Allowed last date is " + $filter('date')(new Date($scope.controlMaxDate),'dd-MMM-yyyy');
                                    }
                                    $scope.boColor = "#FF3737";
                                    if($scope.form!=null){
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", false);    
                                    }
                                }
                                if(moment(mindate).isAfter(DateUtils.convertLocalDateToServer(value))){
                                /*	MessageBox.openMessageBox("Alert", "date - " + $scope.controlMinDate );
                                	var dateDisplay = new Date($scope.controlMinDate).toLocaleDateString("en-US", { day: 'numeric' }) + "-"+
                                	date.toLocaleDateString("en-US", { month: 'short' }) + "-" +
                                	date.toLocaleDateString("en-US", { year: 'numeric' })
                                	MessageBox.openMessageBox("Alert", "date - " + dateDisplay );*/
                                	$scope.errorText = "Allowed earliest date is " + $filter('date')(new Date($scope.controlMinDate),'dd-MMM-yyyy');
                                    if($scope.showErrorText!=true){
                                        $scope.Error = "Allowed earliest date is " + $filter('date')(new Date($scope.controlMinDate),'dd-MMM-yyyy');
                                    }
                                    
                                    if($scope.orderEntryControl!=null && $scope.orderEntryControl!=undefined && $scope.orderEntryControl==true){
                                        var spotDate = new Date($scope.controlMinDate);
                                        spotDate.setDate(spotDate.getDate()-1);
                                        $scope.errorText = "Date must be greater than SPOT date " + $filter('date')(new Date(spotDate),'dd-MMM-yyyy');
                                    }
                                    $scope.boColor = "#FF3737";
                                    if($scope.form!=null){
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                    }
                                }
                            }else{
                                $scope.errorText = "";
                                $scope.Error = "";
                                $scope.controlModel = null;
                            }
                        }

                        $scope.$watch('controlModel', function(value) {
                        	if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value == null || value == "" || value== undefined)) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else if((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value != null && value != "" && value!=undefined)){
                            	 if ($scope.form != null) {
                            		 $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                     $scope.boColor = "#BB8557";	 
                            	 }
                            	$scope.Error = "";
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	// $scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#BB8557";
                                    }
                                    if($scope.themeType=='light'){
                                		$scope.bgColor = "#E0E0E0";
                                	}
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    	$scope.boColor = "#BB8557";
                                    }
                                }
                                
                            } else {
                                $scope.updateModel();
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    $scope.Error = "";
                                    $scope.errorText = "";
                                }
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                                if (attributes.required != null && (value != null && value != "")) {
                                	$scope.boColor = "#BB8557";
                                	/*
									 * if($scope.themeType=='light'){
									 * $scope.bgColor = "#FEFAEE"; }
									 */
                                	
                                }
                            }
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                    $scope.bgColor = "#E0E0E0";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                    $scope.bgColor = "#FEFAEE";
                                }
                            }
                            if(value!=null && value!=undefined && value!=''){
                                $scope.errorText = "";
                                $scope.Error = "";
                                angular.forEach($scope.holidayList, function(value1){
                                    if(value1==DateUtils.convertLocalDateToServer(value)){
                                        $scope.errorText = "Date should not be a holiday";
                                        if($scope.showErrorText!=true){
                                            $scope.Error = "Date should not be a holiday";
                                        }
                                        if($scope.orderEntryControl!=null && $scope.orderEntryControl!=undefined && $scope.orderEntryControl==true){
                                            $scope.errorText = "Settlement date cannot be a holiday";
                                        }
                                        $scope.boColor = "#FF3737";
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                    }
                                }) 

                                if($scope.errorText==""){
                                    validateGivenDate(value);
                                }
                            }
                        })

                        if (attributes.darkTheme == null) {
                            $scope.colorValue = "#F2F2F2";
                        } else {
                            $scope.colorValue = "#7F7F7F";
                        }
                        if ($scope.themeType == 'light'){
                        	$scope.colorValue = '#262626';	
                        }

                        $scope.$watch('controlModified', function(value) {
                            if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                $scope.boColor = "#00B0F0";
                                
                            }
                        
                        });

                    }


                    return linkFunction;
                }
            };
        }])
        .directive('csplDtpWithoutErrorAndInfo', function() {
            var controllerName = 'dateEditCtrl';
            return {
                controller: function() {
                    this.popupOpen = false;
                    this.openPopup = function($event) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        this.popupOpen = true;
                    };
                },
                controllerAs: controllerName,
                template: '<div class="input-group" ng-disabled="controlDisabled"><input name="cspl-dtp" id="{{controlId}}" type="text" ng-disabled="controlDisabled" placeholder="dd-mm-yyyy" autocomplete="off" class="form-control" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" ng-attr-style="background-color:{{bgColor}};border-color:{{boColor}};color:{{colorValue}}; margin-bottom:8px;" uib-datepicker-popup="d!-M!-yyyy" datepicker-append-to-body="appendToBody" datepicker-options="{ minDate: controlMinDate, maxDate: controlMaxDate}" ng-model="controlModel" ui-mask="99-99-9999" ui-mask-placeholder="" ui-mask-placeholder-char="space" model-view-value="true" is-open="dateEditCtrl.popupOpen" /><span class="input-group-btn"><button type="button" tabindex="-1" ng-disabled="controlDisabled" class="btn btn-primary" ng-attr-style="border-color:{{boColor}}; background:{{bgColor}}; border-left:0.25px solid {{boColor}}; height:34px; margin-bottom:8px;" ng-click="dateEditCtrl.openPopup($event)" ><i class="glyphicon glyphicon-calendar"></i></button></span></div>',
                restrict: 'E',
                scope: {
                    controlMinDate: '=',
                    controlMaxDate: '=',
                    controlRequired: '=',
                    controlModel: '=',
                    controlDisabled: '=',
                    controlValueChange: '=',
                    appendToBody: '@',
                    form: '=',
                    controlEnterKey: '&',
                    controlId: '@',
                    helpText: '@',
                    themeType: '@'
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.boColor = "#BB8557";

                        element.bind("keydown keypress", function (event) {
        		            if(event.which === 13) {
        		            	$scope.$apply(function (){
        		            		$scope.$parent.$eval(attributes.controlEnterKey);
        		                });
        		
        		                event.preventDefault();
        		            }
        		        });
                        
                        if ($scope.appendToBody == null) {
                            $scope.appendToBody = false;
                        }

                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                         $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#FFC000";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    }
                                    $scope.Error = "";
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.Error = "";
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                            }

                            if (value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if (attributes.required != null && ($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            }
                        })

                        $scope.onFocus = function(){
                        	$scope.boColor = "#FFC000";
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null) {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		// $scope.Error = "This field cannot be left
									// blank";
                            		$scope.Error = "Invalid date";
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        }

                        $scope.$watch('controlModel', function(value) {
                        	if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value == null || value == "" || value== undefined)) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else if((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value != null && value != "" && value!=undefined)){
                            	 if ($scope.form != null) {
                            		 $scope.form.$setValidity(attributes.controlId + "dtprequired", true);	 
                            	 }
                            	$scope.Error = "";
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	// $scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#BB8557";
                                    }
                                    if($scope.themeType=='light'){
                                		$scope.bgColor = "#E0E0E0";
                                	}
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    	$scope.boColor = "#BB8557";
                                    }
                                }
                                
                            } else {
                                $scope.updateModel();
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    $scope.Error = "";
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                                if (attributes.required != null && (value != null && value != "")) {
                                	$scope.boColor = "#BB8557";
                                	/*
									 * if($scope.themeType=='light'){
									 * $scope.bgColor = "#FEFAEE"; }
									 */
                                	
                                }
                            }
                        })

                        if (attributes.darkTheme == null) {
                            $scope.colorValue = "#F2F2F2";
                        } else {
                            $scope.colorValue = "#7F7F7F";
                        }
                        if ($scope.themeType == 'light'){
                        	$scope.colorValue = '#262626';	
                        }
                    }
                    return linkFunction;
                }
            };
        })
         .directive('csplDayMonth', function() {
            var controllerName = 'dateEditCtrl';
            return {
                controller: function() {
                    this.popupOpen = false;
                    this.openPopup = function($event) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        this.popupOpen = true;
                    };
                },
                controllerAs: controllerName,
                template: '<div class="input-group" ng-disabled="controlDisabled"><input name="cspl-day-month" id="controlId" type="text" ng-disabled="controlDisabled" placeholder="dd/MM" autocomplete="off" class="form-control" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" ng-attr-style="background-color:{{bgColor}};border-color:{{boColor}};color:{{colorValue}}; margin-bottom:8px;" uib-datepicker-popup="d!/M!" datepicker-append-to-body="appendToBody" datepicker-options="{ minDate: controlMinDate, maxDate: controlMaxDate, maxMode: controlMaxMode}" ng-model="controlModel" ui-mask="99/99" ui-mask-placeholder="" ui-mask-placeholder-char="space" model-view-value="true" is-open="dateEditCtrl.popupOpen" /><span class="input-group-btn"><button type="button" tabindex="-1" ng-disabled="controlDisabled" class="btn btn-primary" ng-attr-style="border-color:{{boColor}}; background:{{bgColor}}; border-left:0.25px solid #0B0B0B; height:34px; margin-bottom:8px;" ng-click="dateEditCtrl.openPopup($event)" ><i class="glyphicon glyphicon-calendar"></i></button></span></div><span ng-show="Error != null" class="help-block-error">{{Error}}</span><span ng-show="(helpText != null && showHelpText)" class="help-block">{{helpText}}</span>',
                restrict: 'E',
                scope: {
                    controlMinDate: '=',
                    controlMaxDate: '=',
                    controlRequired: '=',
                    controlModel: '=',
                    controlDisabled: '=',
                    controlValueChange: '=',
                    appendToBody: '@',
                    form: '=',
                    controlId: '=',
                    helpText: '@',
                    themeType: '@',
                    controlMaxMode:'='
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.boColor = "#BB8557";

                        if ($scope.appendToBody == null) {
                            $scope.appendToBody = false;
                        }

                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                            }

                            if (value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !(value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            }
                        })

                         $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#FFC000";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.onFocus = function(){
                        	$scope.boColor = "#FFC000";
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null) {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		// $scope.Error = "This field cannot be left
									// blank";
                            		$scope.Error = "Invalid date";
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        }

                        $scope.$watch('controlModel', function(value) {
                            if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else {
                                $scope.updateModel();
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    $scope.Error = "";
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                                if (attributes.required != null && (value != null && value != "")) {
                                	$scope.boColor = "#BB8557";
                                	/*
									 * if($scope.themeType=='light'){
									 * $scope.bgColor = "#FEFAEE"; }
									 */
                                	
                                }
                            }
                        })

                        if (attributes.darkTheme == null) {
                            $scope.colorValue = "#F2F2F2";
                        } else {
                            $scope.colorValue = "#7F7F7F";
                        }
                        if ($scope.themeType == 'light'){
                        	$scope.colorValue = '#262626';	
                        }
                    }
                    return linkFunction;
                }
            };
        })
        .directive('csplDtpWithDay', function() {
            var controllerName = 'dateEditCtrl';
            return {
                controller: function() {
                    this.popupOpen = false;
                    this.openPopup = function($event) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        this.popupOpen = true;
                    };
                },
                controllerAs: controllerName,
                template: '<div class="input-group" ng-disabled="controlDisabled"><input name="cspl-dtp" id="controlId" type="text" ng-disabled="controlDisabled" placeholder="dd-mm-yyyy" autocomplete="off" class="form-control" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" ng-attr-style="background-color:{{bgColor}};border-color:{{boColor}};color:{{colorValue}}; margin-bottom:8px;" uib-datepicker-popup="d!-M!-yyyy EEE" datepicker-append-to-body="appendToBody" datepicker-options="{ minDate: controlMinDate, maxDate: controlMaxDate}" readonly="true" ng-model="controlModel" ui-mask="99-99-9999  AAA" ui-mask-placeholder="" ui-mask-placeholder-char="space" model-view-value="true" is-open="dateEditCtrl.popupOpen" /><span class="input-group-btn"><button type="button" tabindex="-1" ng-disabled="controlDisabled" class="btn btn-primary" ng-attr-style="border-color:{{boColor}}; background:{{bgColor}}; border-left:0.25px solid #0B0B0B; height:34px; margin-bottom:8px;" ng-click="dateEditCtrl.openPopup($event)" ><i class="glyphicon glyphicon-calendar"></i></button></span></div><span class="help-block">{{ controlModel | date : "EEEE"}}</span><span ng-show="Error != null" class="help-block-error">{{Error}}</span><span ng-show="(helpText != null && showHelpText)" class="help-block">{{helpText}}</span>',
                restrict: 'E',
                scope: {
                    controlMinDate: '=',
                    controlMaxDate: '=',
                    controlRequired: '=',
                    controlModel: '=',
                    controlDisabled: '=',
                    controlValueChange: '=',
                    appendToBody: '@',
                    form: '=',
                    controlId: '=',
                    helpText: '@',
                    themeType: '@'
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.boColor = "#BB8557";

                        if ($scope.appendToBody == null) {
                            $scope.appendToBody = false;
                        }

                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                            }

                            if (value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !(value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            }
                        })

                         $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#FFC000";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.onFocus = function(){
                        	$scope.boColor = "#FFC000";
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null) {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		// $scope.Error = "This field cannot be left
									// blank";
                            		$scope.Error = "Invalid date";
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        }

                        $scope.$watch('controlModel', function(value) {
                            if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else {
                                $scope.updateModel();
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    $scope.Error = "";
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                                if (attributes.required != null && (value != null && value != "")) {
                                	$scope.boColor = "#BB8557";
                                }
                            }
                        })

                        if (attributes.darkTheme == null) {
                            $scope.colorValue = "#F2F2F2";
                        } else {
                            $scope.colorValue = "#7F7F7F";
                        }
                        if ($scope.themeType == 'light'){
                        	$scope.colorValue = '#262626';	
                        }
                    }
                    return linkFunction;
                }
            };
        })
        .directive('csplMandatory', [function() {
            return {
                restrict: 'A',
                scope: {},
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        element.append('&nbsp;*&nbsp;&nbsp;');
                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplText', ['$compile', function($compile) {
            return {

                template: '<input type="{{controlInputType}}" maxlength="{{controlMaxlength}}" ng-class = "controlType" class="form-control" ng-model="controlModel" placeholder="{{controlPlaceHolder}}" ng-disabled="controlDisabled"  autocomplete="off" id="{{controlId}}" ng-change="updateModel()" ng-focus="onFocus()"  ng-blur="onBlur(controlModel)" ng-attr-style="background-color:{{bgColor}};border-color:{{boColor}};text-transform: {{textTransformation}};" ng-pattern="{{controlPattern}}" /><span ng-show="Error != null" class="help-block-error">{{Error}}</span><span ng-show="(helpText != null && showHelpText)" class="help-block">{{helpText}}</span>',
                
                restrict: 'E',
                scope: {
                    controlModel: '=',
                    controlType: '@',
                    controlRequired: '=',
                    controlDisabled: '=',
                    controlMinlength: '@',
                    controlMaxlength: '@',
                    form: '=',
                    controlValueChange: '=',
                    controlId: '@',
                    helpText: '@',
                    themeType: '@',
                    controlInputType:'@',
                    controlMinvalue:'@',
                    controlMaxvalue:'@',
                    controlModified:'=',
                    controlPlaceHolder:'@',
                    controlEnterKey: '&',
                    autoComplete: '@'
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {

        		        element.bind("keydown keypress", function (event) {
        		            if(event.which === 13) {
        		            	$scope.$apply(function (){
        		            		$scope.$parent.$eval(attributes.controlEnterKey);
        		                });
        		
        		                event.preventDefault();
        		            }
        		        });
                    	
                        $scope.boColor = "#BB8557";
                        $scope.controlMinlength = 0;
                        $scope.controlMaxlength = 500;
                        $scope.Error = "";
                        $scope.controlType = 'Normal';
                        $scope.textTransformation = "none";
                        $scope.controlPattern = "/^[_'.A-Za-z0-9-]*$/";
                        $scope.helpText = "";
                        $scope.showHelpText = false;
                        $scope.themeType = 'dark';
                        $scope.autoComplete = 'nope';
                        if($scope.controlInputType==null || $scope.controlInputType==undefined){
                        	$scope.controlInputType = 'text';
                        }
                        
                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }

                            if ($scope.controlType != null && $scope.controlType == 'DealRefNo' && $scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.split(' ').join('');
                            }
                        }

                        $scope.$watch('controlType', function(value) {
                            if (value == "ShortName") {
                                $scope.controlPattern = "/^[_'.A-Za-z0-9-]*$/";
                                $scope.textTransformation = "uppercase";
                            }
                            else if (value == "Alphanumeric" || value == "AlphanumericWithCaps") {
                                $scope.controlPattern = "/^[_'.A-Za-z0-9-]*$/";
                            }
                            else if (value == "Small") {
                                $scope.controlPattern = "/^[_'.A-Za-z0-9-]*$/";
                                $scope.textTransformation = "lowercase";
                            }
                        })

                        $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	//attributes.$set("required", true);
                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#595959";
                                if($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true){
                            		$scope.boColor = "#00B0F0";
                            	}
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled ) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }                           
                            else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                                if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && ($scope.controlModel == null || $scope.controlModel == "" || $scope.controlModel== undefined)) {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else if((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && ($scope.controlModel != null && $scope.controlModel != "" && $scope.controlModel!=undefined)){
                                	 if ($scope.form != null) {
                                		 $scope.form.$setValidity(attributes.controlId + "txtrequired", true);	 
                                	 }
                                	$scope.Error = "";
                                    if ($scope.controlDisabled) {
                                        $scope.bgColor = "#333333";
                                        if($scope.themeType=='light'){
                                        	// $scope.bgColor = "#FFFFFF";
                                        	$scope.boColor = "#BB8557";
                                        }
                                        if($scope.themeType=='light'){
                                    		$scope.bgColor = "#E0E0E0";
                                    	}
                                    } else {
                                        $scope.bgColor = "#0B0B0B";
                                        if($scope.themeType=='light'){
                                        	$scope.bgColor = "#FEFAEE";
                                        	$scope.boColor = "#BB8557";
                                        }
                                    }
                                    
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                        $scope.Error = ""
                                    }
                                    if ($scope.controlDisabled) {
                                        $scope.bgColor = "#333333";
                                        if($scope.themeType=='light'){
                                        	$scope.bgColor = "#E0E0E0";
                                        	$scope.boColor = "#C2C2C2";
                                        }
                                    } else {
                                        $scope.bgColor = "#0B0B0B";
                                        if($scope.themeType=='light'){
                                        	$scope.bgColor = "#FFFFFF";
                                        	$scope.boColor = "#C2C2C2";
                                        }
                                    }
                                    $scope.boColor = "#595959";
                                    if($scope.themeType=='light'){
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                            }
                            if ($scope.controlModel != null && $scope.controlModel != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if (attributes.required != null && ($scope.controlModel == null || $scope.controlModel == "")) {
                            	if(attributes.required){
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                    }
                            	}
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !($scope.controlModel == null || $scope.controlModel == "")) {
                            	if(attributes.required){
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    }
                            	}
                                $scope.boColor = "#BB8557";
                            }
                            if($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true){
                                $scope.boColor = "#00B0F0";
                            }
                            
                        })
                        $scope.onFocus = function(){
                        	$scope.boColor = "#FFC000";
                        	$scope.showHelpText = true;
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		$scope.Error = "This field cannot be left blank";
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if(value!=undefined && value!='' && value!=null){
                                if($scope.controlType=="Number" || $scope.controlType=="NegativeNumber"){
                                	if(($scope.controlMinlength == $scope.controlMaxlength) && (value.length != $scope.controlMaxlength)){
                                		$scope.Error = "This field should be of " + $scope.controlMaxlength + " digits";
                                		$scope.boColor = "#FF3737";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                	}else if(value.length < $scope.controlMinlength){
                                		$scope.Error = "This field should have minimum of " + $scope.controlMinlength + " digits";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(value.length > $scope.controlMaxlength){
                                		$scope.Error = "This field should have maximum of " + $scope.controlMaxlength + " digits";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(Number(value) > Number($scope.controlMaxvalue)){
                                		$scope.Error = "Maximum value for this field is " + $scope.controlMaxvalue;
                                		$scope.boColor = "#FF3737";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                	}else if(Number(value) < Number($scope.controlMinvalue)){
                                		$scope.Error = "Minimum value for this field is " + $scope.controlMinvalue;
                                		$scope.boColor = "#FF3737";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                	}else{
                                		$scope.Error = "";
                                	}

                                }
                                else if($scope.controlType=="Normal" || $scope.controlType=="ShortName"  || $scope.controlType=="Small" || $scope.controlType=="Alphanumeric" || $scope.controlType=="AlphanumericWithCaps"){
                                	if(($scope.controlMinlength == $scope.controlMaxlength) && (value.length != $scope.controlMaxlength)){
                                		$scope.Error = "This field should be of " + $scope.controlMaxlength + " characters";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(value.length < $scope.controlMinlength){
                                		$scope.Error = "This field should have minimum of " + $scope.controlMinlength + " characters";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(value.length > $scope.controlMaxlength){
                                		$scope.Error = "This field should have maximum of " + $scope.controlMaxlength + " characters";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else{
                                		$scope.Error = "";
                                	}
                                }else if($scope.controlType=="Email"){
                                	var mailFormat=/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;                               	
                                	if (!value.match(mailFormat)){
                                		$scope.Error = "Invalid email id";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else{
                                		var emailTextArr = value.split("@");
                                		if(emailTextArr[0]!=null && emailTextArr[0]!=undefined && emailTextArr[0].length > 64){ //standard email should have less than or equal to 64 characters before @ symbol
                                    		$scope.Error = "Invalid email id";
                                    		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                    		$scope.boColor = "#FF3737";
                                		}else{
                                			$scope.Error = "";
                                		}
                                	}
                                }
                            }
                        	$scope.showHelpText = false;
                        }
                        
                        $scope.$watch('controlModel', function(value) {
                             if ($scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.toString().replace(/^[^a-zA-Z0-9]+/g, '');
                            }  
                            if ($scope.controlType == "ShortName" && $scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.toUpperCase();
                                $scope.controlModel = $scope.controlModel.replace(/[\s]/g, '');
                            	$scope.controlModel = $scope.controlModel.replace(/[^a-zA-Z]/g, "");
                            } else if($scope.controlType == "Small" && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.replace(/[\s]/g, '');
                            	$scope.controlModel = $scope.controlModel.replace(/[^a-zA-Z0-9]/g, "");
                            	$scope.controlModel = $scope.controlModel.toLowerCase();
                            } else if($scope.controlType == "Alphanumeric" && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.replace(/[\s]/g, '');
                            	$scope.controlModel = $scope.controlModel.replace(/[^a-zA-Z0-9]/g, "");
                            } else if($scope.controlType == "AlphanumericWithCaps" && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.replace(/[\s]/g, '');
                            	$scope.controlModel = $scope.controlModel.replace(/[^a-zA-Z0-9]/g, "");
                            	$scope.controlModel = $scope.controlModel.toUpperCase();
                            }  else if($scope.controlType == "AlphaOnly" && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.replace(/[\s]/g, '');
                            	$scope.controlModel = $scope.controlModel.replace(/[^a-zA-Z]/g, "");
                            }  else if($scope.controlType == "Email" && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.replace(/[\s]/g, '');
                                $scope.controlModel = $scope.controlModel.toLowerCase();
                            }else if($scope.controlType == "AlphaWithSpace" && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.replace(/[^a-zA-Z\s]/g, "");
                            }else if($scope.controlType == "StringWithoutComma" && $scope.controlModel != null){
                                $scope.controlModel = $scope.controlModel.replace(/(,)/gm,"");
                            }else if($scope.controlType == "StringWithoutCommaWithScriptValidation" && $scope.controlModel != null){
                            $scope.controlModel = $scope.controlModel.toString().replace(/[{}<>,]/g,''); 
                            }else if(($scope.controlType == "Number") && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.toString().replace(/[^0-9]/g, '');
                            	$scope.controlModel = $scope.controlModel.toString().replace(/(?!-)[^0-9]/g,'');
                            }
                            else if(($scope.controlType == "NegativeNumber") && $scope.controlModel != null){
                            	
                            	$scope.controlModel = $scope.controlModel.toString().replace(/(?!-)[^0-9]/g,'');
                            }
                            else if(($scope.controlType=="IPAddress") && $scope.controlModel!=null){
                            	$scope.controlModel = $scope.controlModel.replace(/[\s]/g, '');
                            	$scope.controlModel = $scope.controlModel.replace(/[^0-9.]/g, "");
                            }
                            else if(($scope.controlType == "AllowedCharsRegex") && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.toString().replace(/[^a-zA-Z0-9 \[\]\(\)&\-]/g,'');   

                            }else if($scope.controlModel!=null){
                                    $scope.controlModel = $scope.controlModel.toString().replace(/[{}<>]/g,'');
                                                  
                            }  
                            
                            if ($scope.controlModel != null){
                            	if(value==undefined || value=='' || value==null){
                            		if(attributes.required != null){
                                		$scope.Error = "This field cannot be left blank";
                                   		$scope.boColor = "#FF3737";
                            		}
                                }else if($scope.controlType=="Number" || $scope.controlType=="NegativeNumber" ){
                                	if(($scope.controlMinlength == $scope.controlMaxlength) && (value.length != $scope.controlMaxlength)){
                                		$scope.Error = "This field should be of " + $scope.controlMaxlength + " digits";
                                		$scope.boColor = "#FF3737";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                	}else if(value.length < $scope.controlMinlength){
                                		$scope.Error = "This field should have minimum of " + $scope.controlMinlength + " digits";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(value.length > $scope.controlMaxlength){
                                		$scope.Error = "This field should have maximum of " + $scope.controlMaxlength + " digits";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(Number(value) > Number($scope.controlMaxvalue)){
                                		$scope.Error = "Maximum value for this field is " + $scope.controlMaxvalue;
                                		$scope.boColor = "#FF3737";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                	}else if(Number(value) < Number($scope.controlMinvalue)){
                                		$scope.Error = "Minimum value for this field is " + $scope.controlMinvalue;
                                		$scope.boColor = "#FF3737";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                	}else{
                                		$scope.Error = "";
                                	}

                                }
                                else if($scope.controlType=="Normal" || $scope.controlType=="ShortName" || $scope.controlType=="Small"
                                		|| $scope.controlType=="Alphanumeric" || $scope.controlType=="AlphanumericWithCaps" || $scope.controlType=="AlphaOnly"){
                                	if(($scope.controlMinlength == $scope.controlMaxlength) && (value.length != $scope.controlMaxlength)){
                                		$scope.Error = "This field should be of " + $scope.controlMaxlength + " characters";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(value.length < $scope.controlMinlength){
                                		$scope.Error = "This field should have minimum of " + $scope.controlMinlength + " characters";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(value.length > $scope.controlMaxlength){
                                		$scope.Error = "This field should have maximum of " + $scope.controlMaxlength + " characters";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else{
                                		$scope.Error = "";
                                	}
                                }else if($scope.controlType=="Email"){
                                	var mailFormat=/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;                               	
                                	/*
									 * var mailformat =
									 * /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|com|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum)/;
									 */
                                	if (!value.match(mailFormat)){
                                		$scope.Error = "Invalid email id";
                                		value = null;
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}
                                }
                            	//to replace non printable special characters with empty string
                            	//fixed for exposure sub type null issue in Mock env. on 9-Mar-2021 
//                            	if(value!=null && value!=undefined && value!=''){ 
//                            		$scope.controlModel = $scope.controlModel.toString().replace(/[^\x20-\x7E]/g, ''); 
//                            	}
                            }	
                            if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value == null || value == "" || value== undefined)) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else if((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value != null && value != "" && value!=undefined)){
                            	 if ($scope.form != null) {
                            		 $scope.form.$setValidity(attributes.controlId + "txtrequired", true);	 
                            	 }
                            	$scope.Error = "";
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	// $scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#BB8557";
                                    }
                                    if($scope.themeType=='light'){
                                		$scope.bgColor = "#E0E0E0";
                                	}
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    	$scope.boColor = "#BB8557";
                                    }
                                }
                                
                            } else {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    $scope.Error = ""
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true){
                            		$scope.boColor = "#00B0F0";
                            	}
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if (attributes.required != null && (value != null && value != "")) {
                            	$scope.boColor = "#BB8557";
                            	/*
								 * if($scope.themeType=='light'){ $scope.boColor =
								 * "#FEFAEE"; }
								 */
                            	
                            }

                        });
                         $scope.$watch('controlModified', function(value) {
                        	 if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                 $scope.boColor = "#00B0F0";
                                 
                             }
                         
                         })

                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplMultilineText', ['$compile', function($compile) {
            return {
                template: '<textarea class="form-control" placeholder="{{controlPlaceHolder}}" autocomplete="nope" maxlength="{{controlMaxlength}}" ng-keypress="keyPress($event)" ng-minlength=controlMinlength ng-maxlength=controlMaxlength rows="{{controlRows}}" cols="{{controlCols}}" ng-model="controlModel" ng-disabled="controlDisabled" autocomplete="off" id="controlId" ng-change="updateModel()" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" ng-attr-style="background-color:{{bgColor}};border-color:{{boColor}};text-transform: {{textTransformation}}; max-width:100%;" ng-pattern="controlPattern" /><span ng-show="Error != null" class="help-block-error">{{Error}}</span>',
                restrict: 'E',
                scope: {
                    controlModel: '=',
                    controlType: '@',
                    controlRequired: '=',
                    controlDisabled: '=',
                    controlMinlength: '@',
                    controlMaxlength: '@',
                    controlRows: '@',
                    controlCols: '@',
                    form: '=',
                    controlValueChange: '=',
                    controlId: '=',
                    themeType: '@',
                    controlPlaceHolder:'@',
                    controlPattern:'@'
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {

                        $scope.boColor = "#BB8557";
                        $scope.controlMinlength = 0;
                        $scope.controlMaxlength = 500;
                        $scope.controlRows = 4;
                        $scope.controlCols = 7;
                        $scope.Error = "";
                        $scope.controlType = 'Normal';
                        $scope.textTransformation = "none";
                        /* $scope.controlPattern = '/^[^<>/]*$/';
                        $scope.controlPattern = "/^[_'.A-Za-z0-9-]*$/";
                        if(attributes.controlId == 'txtMessageContent'||attributes.controlId == 'txtDescription'){
                     	$scope.controlPattern = '^(?:(?!<\/|\/>).)+$';
                       }
                       if( $scope.controlPattern == null || $scope.controlPattern == undefined){
                        	//removed apostrohe and added the whitespace character
                       	$scope.controlPattern ='^(?:(?!<|>|\/>).)+$';
                       }*/
                        $scope.themeType = "dark";
                        $scope.allowEnter = true;
                        if(attributes.allowEnter != null && attributes.allowEnter!= undefined &&attributes.allowEnter == 'false'){
                        	$scope.allowEnter = false;
                        }
                        

                        
                        $scope.keyPress = function (event) {
                        	if(event.keyCode == 13 && $scope.allowEnter == false){
                        		event.preventDefault();
                        	}
                        }
                       
                        
                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }

                            if ($scope.controlType != null && $scope.controlType == 'DealRefNo' && $scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.split(' ').join('');
                            }
                        }

                        $scope.$watch('controlType', function(value) {
                            if (value == "ShortName") {
                                $scope.textTransformation = "uppercase";
                            }
                            /*
							 * else{ $scope.textTransformation = "capitalize"; }
							 */
                        })

                        $scope.$watch('controlRows', function(value) {
                            if (value != null && value != "") {
                                $scope.controlRows = value;
                            }
                            /*
							 * else{ $scope.textTransformation = "capitalize"; }
							 */
                        })

                        $scope.onFocus = function onFocus(){
                        	$scope.boColor = "#FFC000";
                        }
                        
                        $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#FFC000";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if (value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                }
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !(value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            }
                        })
                        
                        $scope.onBlur = function onBlur(value){
                        	if (attributes.required != null) {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		$scope.Error = "This field cannot be left blank";
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        }

                        $scope.$watch('controlModel', function(value) {
                              if ($scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.toString().replace(/^[^a-zA-Z0-9]+/g, '');
                            }  
                            if ($scope.controlType == "ShortName" && $scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.toUpperCase();
                            } 
                            else if(($scope.controlType == "SMSSettings") && $scope.controlModel != null){
                                $scope.controlModel = $scope.controlModel.toString().replace(/\/>|<\/|[{}]/g,'');
                                }else{
                                     if($scope.controlModel != null){
                                      $scope.controlModel = $scope.controlModel.toString().replace(/[{}<>]/g,'');
                                     }
                                }
                            if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    $scope.Error = ""
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if (attributes.required != null && (value != null && value != "")) {
                            	$scope.boColor = "#BB8557";
                            	/*
								 * if($scope.themeType=='light'){ $scope.bgColor =
								 * "#FEFAEE"; }
								 */
                            	
                            }
                        	//to replace non printable special characters with empty string
                        	//fixed for exposure sub type null issue in Mock env. on 9-Mar-2021 
//                        	if(value!=null && value!=undefined && value!=''){ 
//                        		$scope.controlModel = $scope.controlModel.toString().replace(/[^\x20-\x7E]/g, ''); 
//                        	}
                        })

                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplNumeric', ['$compile','$filter', '$window', function($compile,$filter,$window) {
            return {
                template: '<div ng-class="{ \'input-group\' : showCurrencyCode || showPayOrReceive || showToggle }">'+
                            '<span class="input-group-btn" ng-show="showToggle">'+
                                '<button class="btn " ng-class = "{ \'btn-approve\':  toggleColor, \'btn-reject\':  !toggleColor, \'avoid-clicks\': controlDisabled }" ng-attr-style="height: 34px;" type="button" ng-click="toggleCallback({ character : toggleCharacter, toggle : toggleColor})" tabindex="-1"><i ng-attr-style="font-size: 20px;"></i></button>'+
                            '</span>'+
                            '<input type="text" class="form-control" aria-label="{{controlId}}" ng-model="controlModel" angular-currency="angularCurrency" variable-options="true"  data-m-dec = "6"  ng-disabled="controlDisabled" autocomplete="off" id="{{controlId}}" ng-change="updateModel()" ng-keypress="keyPress($event)" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" ng-attr-style="text-align:right;background-color:{{bgColor}};border-color:{{boColor}};text-transform: {{textTransformation}};" ng-pattern="{{controlPattern}}" tabindex="{{controlTabIndex}}"/>'+
                            '<span ng-show="Error != null" class="help-block-error">{{Error}}</span>'+
                            '<span ng-show="errorText != null && errorText!= \'\' && showErrorText" style="position:relative;"><span ng-show="errorText != null && errorText!= \'\' && showErrorText" class="help-block-warning-error arrow-up" style="position: absolute;margin: 0px 2px 2px 0px; right: 0px; background: #ffffff; padding: 6px 1px; border-radius: 4px; border-right: 5px solid transparent; border-top: 5px solid black;">{{errorText}}</span></span>'+
                            '<span ng-show="(helpText != null && helpText!= \'\' && showHelpText)" style="position:relative;"><span ng-show="(helpText != null && helpText!= \'\' && showHelpText)" class="help-block-warning arrow-up" style="position: absolute;margin: 0px 2px 2px 0px; right: 0px; background: #ffffff; padding: 6px 1px; border-radius: 4px; border-right: 5px solid transparent; border-top: 5px solid black;">{{helpText}}</span></span>{{ currencyCodeElement }}'+
                            '<span class="input-group-addon" ng-show="showCurrencyCode"><b>{{ currencyCode }}</b></span>'+
                            '<span class="input-group-btn" ng-show="showPayOrReceive">'+
                                '<button class="btn " ng-class = "{ \'btn-approve\':  controlModel >= 0, \'btn-reject\':  controlModel < 0, \'avoid-clicks\': controlDisabled }" style="height: 34px;" type="button" ng-click="negateControlModel()" tabindex="-1"><i style="font-size: 20px;"></i></button>'+
                            '</span>'+
                          '</div>',

                restrict: 'E',
                scope: {
                    controlModel: '=',
                    controlType: '@',
                    controlRequired: '=',
                    controlDisabled: '=',
                    form: '=',
                    controlValueChange: '=',
                    controlId: '@',
                    currencySymbol: '@',
                    noOfDecimals: '@',
                    controlMin: '@',
                    helpText: '@',
                    showErrorText: '=',
                    controlMax: '@',
                    angularCurrency: '@',
                    currencyCode: '@',
                    payOrReceiveCurrency: '@',
                    toggleCharacter: '@',
                    toggleColor: '@',
                    toggleCallback: '&',
                    themeType: '@',
                    controlTabIndex:'@',
                    controlModified:'=',
                   // showModification:'=',
                    controlInvalid:'='
                },
                compile: function(element, attributes) {
                    var linkFunction = function($scope, element, attributes) {

                        // $scope.showErrorText = false;
                        $scope.showHelpText = false;
                        $scope.boColor = "#BB8557";
                        $scope.currencySymbol = "";
                        $scope.Error = "";
                        $scope.controlType = 'Normal';
                        $scope.textTransformation = "none";
                        $scope.showCurrencyCode = false;
                        $scope.showPayOrReceive = false;
                        $scope.payOrReceive = 'Receive'
                        $scope.showToggle = false;
                        $scope.themeType = 'dark';
                        $scope.helpText = "";
                        $scope.errorText = "";

                        $scope.negateControlModel = function(){
                            $scope.controlModel = -1 * $scope.controlModel;
                        }

                        $scope.onFocus = function onFocus(){
                        	$scope.boColor = "#FFC000";
                        	$scope.showHelpText = true;
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null) {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		$scope.errorText = "This field cannot be left blank";
                            		if($scope.showErrorText!=true){
                            			$scope.Error = "This field cannot be left blank";
                            		}
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	if($scope.controlInvalid!=undefined && $scope.controlInvalid!=null && $scope.controlInvalid==true){
                            		$scope.boColor = "#FF3737";
                            	}else if($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true){
                            		$scope.boColor = "#00B0F0";
                            	}
                            	else{
                            		$scope.boColor = "#595959";
                                    if($scope.themeType=='light'){
                                    	$scope.boColor = "#C2C2C2";
                                    }
                            	}
                            	
                            }
                        	$scope.showHelpText = false;
                        }

                        /* $scope.controlPattern = "/^[_'.A-Za-z0-9-]*$/"; */
                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                        $scope.$watch('payOrReceiveCurrency', function(value){
                            if(value != null && value != "" && value != undefined){
                                $scope.faPayOrReceiveCurrency = 'fa fa-' + $filter('lowercase')($scope.payOrReceiveCurrency);
                                $scope.showPayOrReceive = true;
                                element.find("i").removeClass();
                                element.find("i").addClass($scope.faPayOrReceiveCurrency);
                            }
                        });

                        $scope.$watch('toggleCharacter', function(value){
                            if(value != null && value != "" && value != undefined){
                                $scope.faPayOrReceiveCurrency = 'fa fa-' + $filter('lowercase')($scope.toggleCharacter);
                                $scope.showToggle = true;
                                element.find("i").removeClass();
                                element.find("i").addClass($scope.faPayOrReceiveCurrency);
                            }
                        });

                        $scope.$watch('toggleColor', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                $scope.bgColor = "#e2f0d9";
                                $scope.boColor = "#37a36a";
                                $scope.toggleColor = true;
                            } if (value != null && value != "" && (value == false || value == "false")) {
                                $scope.bgColor = "#ffebeb";
                                $scope.boColor = "#f34931";
                                $scope.toggleColor = false;
                            }
                        });

                        $scope.$watch('currencyCode', function(value){
                            if(value != null && value != "" && value != undefined){
                                $scope.showCurrencyCode = true;
                            }
                        });

                        $scope.$watch('controlType', function(value) {
                            if (value == "ShortName") {
                                $scope.textTransformation = "uppercase";
                            }
                            /*
							 * else{ $scope.textTransformation = "capitalize"; }
							 */
                        })

                        $scope.$watch('currencySymbol', function(value) {
                            if (value != null && value != "") {
                                $scope.currencySymbol = value;

                            }
                            $scope.setAngularCurrency();
                        })
                        $scope.setAngularCurrency = function() {
                            $scope.angularCurrency = {
                                aSign: $scope.currencySymbol,
                                mDec: $scope.noOfDecimals,
                                vMin: $scope.controlMin,
                                vMax: $scope.controlMax
                            };
                        };
                        $scope.$watch('noOfDecimals', function(value) {
                            if (value != null && value != "") {
                                $scope.noOfDecimals = value;
                            }
                            $scope.setAngularCurrency();
                        })

                        $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#595959";
                                if($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true){
                            		$scope.boColor = "#00B0F0";
                            	}                                
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	// $scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	// $scope.boColor = "#C2C2C2";
                                }
                            }
                            if(value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                               // $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#595959";
                            }else if (attributes.required != null && ($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                }
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            }
                        })
                        
                        $scope.keyPress = function (event) {
                        	var value = String.fromCharCode(event.which);
                        	var multiplier = 1;
                            if(value == 'm' || value == 'M'){
                            	multiplier = 1000000;
                            }
                            else if(value == 'l' || value == 'L'){
                            	multiplier = 100000;
                            }
                            else if(value == 'c' || value == 'C'){
                            	multiplier = 10000000;
                            }
                            else if(value == 'b' || value == 'B'){
                            	multiplier = 1000000000;
                            }
                            else if(value == 'k' || value == 'K'){
                            	multiplier = 1000;
                            }
                            
                            if($scope.controlModel!=null && $scope.controlModel!=undefined && multiplier != 1){
                            	$scope.controlModel = ($scope.controlModel * multiplier);
                            	$scope.$apply();
                            }

                        };
                        
                        element.bind('click', function (event) {
                            if (!$window.getSelection().toString()) {
                            	this.children[0].children[1].select();
                            }
                          });

                        $scope.$watch('controlModel', function(value) {
                            if ($scope.controlType == "ShortName" && $scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.toUpperCase();
                            }
                            if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value == null || value == "" || value== undefined)) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else if((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value != null && value != "" && value!=undefined)){
                            	 if ($scope.form != null) {
                            		 $scope.form.$setValidity(attributes.controlId + "txtrequired", true);	 
                            	 }
                            	$scope.Error = "";
								$scope.errorText = "";
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	// $scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#BB8557";
                                    }
                                    if($scope.themeType=='light'){
                                		$scope.bgColor = "#E0E0E0";
                                	}
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    	$scope.boColor = "#BB8557";
                                    }
                                }
                                
                            } else {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    $scope.errorText = "";
                                    if($scope.showErrorText!=true){
                            			$scope.Error = "";
										$scope.errorText = "";
                            		}
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	// $scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	// $scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true){
                            		$scope.boColor = "#00B0F0";
                            	}  
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if (attributes.required != null && (value != null && value != "")) {
                            	$scope.boColor = "#BB8557";
                            	/*
								 * if($scope.themeType=='light'){ $scope.bgColor =
								 * "#FEFAEE"; }
								 */
                            }
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	// $scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	// $scope.boColor = "#C2C2C2";
                                }
                            }
                            if($scope.showPayOrReceive){
                                if($scope.controlModel >= 0){
                                    $scope.bgColor = "#e2f0d9";
                                    $scope.boColor = "#37a36a";
                                }else if($scope.controlModel < 0){
                                    $scope.bgColor = "#ffebeb";
                                    $scope.boColor = "#f34931";
                                }
                            }
                            if($scope.showToggle){
                                if($scope.toggleColor){
                                    $scope.bgColor = "#e2f0d9";
                                    $scope.boColor = "#37a36a";
                                }else {
                                    $scope.bgColor = "#ffebeb";
                                    $scope.boColor = "#f34931";
                                }
                            }
                        })
                        $scope.$watch('controlModified', function(value) {
                        	 if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                 $scope.boColor = "#00B0F0";
                                 
                             }
                         
                         });
                        $scope.$watch('controlInvalid', function(value) {
                       	 if ($scope.controlInvalid!=undefined && $scope.controlInvalid!=null && $scope.controlInvalid==true) {
                       		$scope.boColor = "#FF3737";
                                
                            }
                        
                        })

                    }
                    return linkFunction;
                }
            };
        }])

        .directive('csplCustomNumeric', ['$compile','$filter', '$window', function($compile,$filter,$window) {
            return {
                template: '<div class="input-group">'+
                            '<input type="text" class="form-control" ng-model="controlModel" angular-currency="angularCurrency" '+
                            'ng-disabled="controlDisabled" ng-required="controlRequired" autocomplete="off" '+
                            'id="{{controlId}}" variable-options="true"  data-m-dec = "6" '+
                            'ng-change="updateModel()" ng-keypress="keyPress($event)" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" '+
                            'ng-attr-style="text-align:right;background-color:{{bgColor}};border-color:{{boColor}};text-transform: {{textTransformation}};" '+
                            'tabindex="{{controlTabIndex}}" form="form"/>'+
                            '<span ng-show="Error != null" class="help-block-error">{{Error}}</span>'+
                          '</div>',

                restrict: 'E',
                scope: {
                    controlModel: '=',
                    controlRequired: '=',
                    controlDisabled: '=',
                    form: '=',
                    controlValueChange: '=',
                    controlId: '@',
                    currencySymbol: '@',
                    noOfDecimals: '@',
                    controlMin: '@',
                    controlMax: '@',
                    angularCurrency: '@',
                    themeType: '@',
                    controlTabIndex:'@',
                    controlModified:'='
                },
                compile: function(element, attributes) {
                    var linkFunction = function($scope, element, attributes) {

                        $scope.boColor = "#BB8557";
                        $scope.currencySymbol = "";
                        $scope.Error = "";
                        $scope.textTransformation = "none";
                        $scope.themeType = 'dark';

                        $scope.onFocus = function onFocus(){
                        	$scope.boColor = "#FFC000";
                        }
                        
                        $scope.onBlur = function(value){
                            if ($scope.controlRequired != null && $scope.controlRequired != "" && ($scope.controlRequired == true || $scope.controlRequired == "true")) {
                            	$scope.boColor = "#BB8557";
                            	if((value==undefined || value=='' || value==null) && value!=0){
                            		$scope.Error = "This field cannot be left blank";
                               		$scope.boColor = "#FF3737";
                                }else{
                                    $scope.Error = "";
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                $scope.boColor = "#595959";
                                if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                    $scope.boColor = "#00B0F0";    
                                }
                                if($scope.themeType=='light'){
                                    $scope.boColor = "#C2C2C2";
                                }
                            }
                        }

                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                        $scope.$watch('currencySymbol', function(value) {
                            if (value != null && value != "") {
                                $scope.currencySymbol = value;

                            }
                            $scope.setAngularCurrency();
                        })

                        $scope.setAngularCurrency = function() {
                            $scope.angularCurrency = {
                                aSign: $scope.currencySymbol,
                                mDec: $scope.noOfDecimals,
                                vMin: $scope.controlMin,
                                vMax: $scope.controlMax
                            };
                        };

                        $scope.$watch('noOfDecimals', function(value) {
                            if (value != null && value != "") {
                                $scope.noOfDecimals = value;
                            }
                            $scope.setAngularCurrency();
                        })

                        $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                if (($scope.controlModel == null || $scope.controlModel == "") && $scope.controlModel!=0) {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#595959";
                                if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                    $scope.boColor = "#00B0F0";   
                                }
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                }
                            }
                            if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                $scope.boColor = "#00B0F0";
                                
                            }
                            else if(value != null && value != "") {
                                $scope.boColor = "#595959";
                            }else if (($scope.controlRequired != null && $scope.controlRequired != "" && ($scope.controlRequired == true || $scope.controlRequired == "true")) 
                            && (($scope.controlModel == null || $scope.controlModel == "") && $scope.controlModel != 0)) {
                                $scope.boColor = "#BB8557";
                            } else if (($scope.controlRequired != null && $scope.controlRequired != "" && ($scope.controlRequired == true || $scope.controlRequired == "true")) 
                            && !(($scope.controlModel == null || $scope.controlModel == "") && $scope.controlModel != 0)) {
                                $scope.boColor = "#BB8557";
                            }
                        })
                        $scope.$watch('controlModified', function(value) {
                            if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                $scope.boColor = "#00B0F0";
                                
                            }
                        
                        });
                        
                        $scope.keyPress = function (event) {
                        	var value = String.fromCharCode(event.which);
                        	var multiplier = 1;
                            if(value == 'm' || value == 'M'){
                            	multiplier = 1000000;
                            }
                            else if(value == 'l' || value == 'L'){
                            	multiplier = 100000;
                            }
                            else if(value == 'c' || value == 'C'){
                            	multiplier = 10000000;
                            }
                            else if(value == 'b' || value == 'B'){
                            	multiplier = 1000000000;
                            }
                            else if(value == 'k' || value == 'K'){
                            	multiplier = 1000;
                            }
                            
                            if($scope.controlModel!=null && $scope.controlModel!=undefined && multiplier != 1){
                            	$scope.controlModel = ($scope.controlModel * multiplier);
                            	$scope.$apply();
                            }

                        };
                        
                        element.bind('click', function (event) {
                            if (!$window.getSelection().toString()) {
                            	this.children[0].children[1].select();
                            }
                        });
                    }
                    return linkFunction;
                }
            };
        }])

        .directive('csplMenu', function() {
            return {
                templateUrl: 'app/layouts/navbar/navbar.html',
                restrict: 'E',
            };
        })
        .directive('checklistModel', ['$parse', '$compile', '$rootScope', function($parse, $compile, $rootScope) {
            // contains
            function contains(arr, item, comparator) {
                if (angular.isArray(arr)) {
                    for (var i = arr.length; i--;) {
                        if (comparator(arr[i], item)) {
                            return true;
                        }
                    }
                }
                return false;
            }

            // add
            function add(arr, item, comparator) {
                arr = angular.isArray(arr) ? arr : [];
                if (!contains(arr, item, comparator)) {
                    arr.push(item);
                }
                return arr;
            }

            // remove
            function remove(arr, item, comparator) {
                if (angular.isArray(arr)) {
                    for (var i = arr.length; i--;) {
                        if (comparator(arr[i], item)) {
                            arr.splice(i, 1);
                            break;
                        }
                    }
                }
                return arr;
            }

            // http://stackoverflow.com/a/19228302/1458162
            function postLinkFn(scope, elem, attrs) {
                // exclude recursion, but still keep the model
                var checklistModel = attrs.checklistModel;
                attrs.$set("checklistModel", null);
                // compile with `ng-model` pointing to `checked`
                $compile(elem)(scope);
                attrs.$set("checklistModel", checklistModel);

                // getter / setter for original model
                var getter = $parse(checklistModel);
                var setter = getter.assign;
                var checklistChange = $parse(attrs.checklistChange);
                var checklistBeforeChange = $parse(attrs.checklistBeforeChange);

                // value added to list
                var value = attrs.checklistValue ? $parse(attrs.checklistValue)(scope.$parent) : attrs.value;


                var comparator = angular.equals;

                if (attrs.hasOwnProperty('checklistComparator')) {
                    if (attrs.checklistComparator[0] == '.') {
                        var comparatorExpression = attrs.checklistComparator.substring(1);
                        comparator = function(a, b) {
                            return a[comparatorExpression] === b[comparatorExpression];
                        };

                    } else {
                        comparator = $parse(attrs.checklistComparator)(scope.$parent);
                    }
                }

                // watch UI checked change
                scope.$watch(attrs.ngModel, function(newValue, oldValue) {
                    if (newValue === oldValue) {
                        return;
                    }

                    if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
                        scope[attrs.ngModel] = contains(getter(scope.$parent), value, comparator);
                        return;
                    }

                    setValueInChecklistModel(value, newValue);

                    if (checklistChange) {
                        checklistChange(scope);
                        $rootScope.$emit('gatewayApp:checklistModelChanged', {});
                    }
                });

                function setValueInChecklistModel(value, checked) {
                    var current = getter(scope.$parent);
                    if (angular.isFunction(setter)) {
                        if (checked === true) {
                            setter(scope.$parent, add(current, value, comparator));
                        } else {
                            setter(scope.$parent, remove(current, value, comparator));
                        }
                    }

                }

                // declare one function to be used for both $watch functions
                function setChecked(newArr, oldArr) {
                    if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
                        setValueInChecklistModel(value, scope[attrs.ngModel]);
                        return;
                    }
                    scope[attrs.ngModel] = contains(newArr, value, comparator);
                }

                // watch original model change
                // use the faster $watchCollection method if it's available
                if (angular.isFunction(scope.$parent.$watchCollection)) {
                    scope.$parent.$watchCollection(checklistModel, setChecked);
                } else {
                    scope.$parent.$watch(checklistModel, setChecked, true);
                }
            }

            return {
                restrict: 'A',
                priority: 1000,
                terminal: true,
                scope: true,
                compile: function(tElement, tAttrs) {
                    if ((tElement[0].tagName !== 'INPUT' || tAttrs.type !== 'checkbox') && (tElement[0].tagName !== 'MD-CHECKBOX') && (!tAttrs.btnCheckbox)) {
                        throw 'checklist-model should be applied to `input[type="checkbox"]` or `md-checkbox`.';
                    }

                    if (!tAttrs.checklistValue && !tAttrs.value) {
                        throw 'You should provide `value` or `checklist-value`.';
                    }

                    // by default ngModel is 'checked', so we set it if not
					// specified
                    if (!tAttrs.ngModel) {
                        // local scope var storing individual checkbox model
                        tAttrs.$set("ngModel", "checked");
                    }

                    return postLinkFn;
                }
            };
        }])
        .directive('csplPagination', [function() {
            return {
                template: '<uib-pagination class="pagination-sm pagination" total-items="recordCount" ng-model="controlModel" items-per-page="itemsPerPage"></uib-pagination>',
                restrict: 'E',
                scope: {
                    controlModel: '=',
                    recordCount: '=',
                    itemsPerPage: '='
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {

                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplTableSearch', ['EntityPermissions', function(EntityPermissions) {
            return {
                template: '<input type="text" class="form-control search" style="border-color:#333333;" placeholder="Search" ng-model="controlModel" id="{{controlId}}" />',
                restrict: 'E',
                scope: {
                    controlModel: '=',
                    controlId: '@',
                    isSearchAlone: '='
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.permissionToExport = EntityPermissions.hasPermission('CommonEntity.EXPORT');
                        if ($scope.permissionToExport && ($scope.isSearchAlone == null || $scope.isSearchAlone == false)) {
                            $scope.marginTop = '-25px';
                        } else {
                            $scope.marginTop = '0px';
                        }
                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplTableSort', [function() {
            return {
                template: '<a ng-click="sortTypeModel = sortTypeName; sortReverseModel = !sortReverseModel"><span data-translate={{headerText}}></span><span ng-show="sortTypeModel == sortTypeName && !sortReverseModel" class="fa fa-caret-down"></span><span ng-show="sortTypeModel == sortTypeName && sortReverseModel" class="fa fa-caret-up"></span></a>',
                restrict: 'E',
                scope: {
                    sortTypeModel: '=',
                    sortTypeName: '&',
                    sortReverseModel: '=',
                    defaultSort: '@defaultSort',
                    headerText: '='
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {

                        $scope.sortReverseModel = false;

                        $scope.$watch('defaultSort', function(value) {
                            if (value == "desc") {
                                $scope.sortTypeModel = $scope.sortTypeName;
                                $scope.sortReverseModel = true;
                            } else if (value == "asc") {
                                $scope.sortTypeModel = $scope.sortTypeName;
                                $scope.sortReverseModel = false;
                            }
                        });
                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplTableExport', ['EntityPermissions','GlobalValues', function(EntityPermissions,GlobalValues) {
            var controllerName = 'csplTableExportCtrl';
            return {
                controller: ['$rootScope', '$scope', '$timeout', '$filter', function($rootScope, $scope, $timeout, $filter) {
                    var noOfRecordsPerPage = 0;
                    var isExportMode = false;
                    var exportOption = '';
                    var pageIndex = 1;
                    var noOfRecordsPerPageCopy=0;

                    this.exportToFile = function(option) {
                        if ($scope.totalRecordCount != null && $scope.totalRecordCount > 0) {
                            exportOption = option;
                            pageIndex = $scope.pageNo;
                            noOfRecordsPerPage = $scope.noOfRecordsPerPage;
                            noOfRecordsPerPageCopy = $scope.noOfRecordsPerPage;
                            checkAndProcessExport();
                        }
                    };

                    $rootScope.$on('gatewayApp:csplTableRepeatComplete', function(event, result) {
                        if (isExportMode && result == $scope.tableName) {
                            isExportMode = false;
                            $timeout(function() {
                                processExport();
                            });
                        }
                    });
                    function checkAndProcessExport() {
                        if (($scope.filterText == null || $scope.filterText == "") && ($scope.totalRecordCount > $scope.noOfRecordsPerPage)) {
                            $scope.noOfRecordsPerPage = $scope.totalRecordCount;
                            noOfRecordsPerPage = $scope.noOfRecordsPerPage;
                            isExportMode = true; 
                            $timeout(function() {
                                processExport();
                            });
                       } else {
                            processExport();
                        }
                    }

                    function processExport() {
                    	$scope.sheetName =  $scope.fileName;
                    	var fileName = $scope.fileName + "_"+ $filter('date')(new Date(), "dd")  + "_"+ $filter('date')(new Date(), "MMM") + "_"+
                    						$filter('date')(new Date(), "yyyy") + "_"+ $filter('date')(new Date(), "HH") + "_"+ $filter('date')(new Date(), "mm");
                    	
                        if (exportOption == 'csv') {
                            $('#' + $scope.tableName).tableExport({ type: 'csv', escape: 'false' ,fileName : fileName,ignoreColumn : $scope.ignoreColumn, sheetName : $scope.sheetName, footer : $scope.footer,enviromentName:GlobalValues.getEnvironmentName()});
                        } else if (exportOption == 'excel') {
                            $('#' + $scope.tableName).tableExport({ type: 'excel', escape: 'false' ,fileName : fileName,ignoreColumn : $scope.ignoreColumn, sheetName : $scope.sheetName, footer : $scope.footer,enviromentName:GlobalValues.getEnvironmentName()});
                        } else if (exportOption == 'pdf') {
                            $('#' + $scope.tableName).tableExport({ type: 'pdf', pdfFontSize: '7', escape: 'false' ,fileName : fileName,ignoreColumn : $scope.ignoreColumn});
                        } else if (exportOption == 'png') {
                            $('#' + $scope.tableName).tableExport({ type: 'png', escape: 'false',fileName : fileName,ignoreColumn : $scope.ignoreColumn });
                        } else if (exportOption == 'doc') {
                            $('#' + $scope.tableName).tableExport({ type: 'doc', escape: 'false' ,fileName : fileName,ignoreColumn : $scope.ignoreColumn});
                        } else if (exportOption == 'txt') {
                            $('#' + $scope.tableName).tableExport({ type: 'txt', escape: 'false' ,fileName : fileName,ignoreColumn : $scope.ignoreColumn});
                        } else if (exportOption == 'powerpoint') {
                            $('#' + $scope.tableName).tableExport({ type: 'powerpoint', escape: 'false' ,fileName : fileName,ignoreColumn : $scope.ignoreColumn});
                        }
                        $scope.pageNo = pageIndex;
                        $scope.noOfRecordsPerPage = noOfRecordsPerPageCopy;
                    }
                }],
                controllerAs: controllerName,
                templateUrl: 'app/csplTableExport.html',
                restrict: 'E',
                scope: {
                    tableName: '@',
                    totalRecordCount: '=',
                    noOfRecordsPerPage: '=',
                    filterText: '=',
                    pageNo: '=',
                    fileName: '@',
                    ignoreColumn : '@',
                    sheetName : '@',
                    footer: '@'
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.permissionToExport = true;
                        $scope.tableName = attributes.tableName;
                       
                        $scope.fileName = attributes.fileName;
                        $scope.sheetName = attributes.sheetName;
                        $scope.footer = attributes.footer;
                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplTableImport', ['EntityPermissions', function(EntityPermissions) {
            var controllerName = 'csplTableImportCtrl';
            return {
                controller: ['$rootScope', '$scope', '$timeout', 'ImportFile', function($rootScope, $scope, $timeout, ImportFile) {

                    this.importFile = function() {
                    	$('#uploadFile').click();
                    };

                    this.generateTemplate = function() {
                    if(($scope.uploadType) == 'BankImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    }		
                    
                    if(($scope.uploadType) == 'BranchImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    	
                    }		
                    
                    if(($scope.uploadType) == 'MarkupImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    	
                    }
                    if(($scope.uploadType) == 'LimitSettingsImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    	
                    }
                    if(($scope.uploadType) == 'AMCImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    	
                    }
                    if(($scope.uploadType) == 'OneTimeRegistrationChargesImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    }
                    
                    if(($scope.uploadType) == 'GSTSettingsImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    	
                    }
                    
                    if(($scope.uploadType) == 'TransactionChargesImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    	
                    }
                    if(($scope.uploadType) == 'SwapQuotesImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    	
                    }
                    
                    
                    };
                    
                    
                                        
                    $scope.$watch('fileContent', function(value){
                    	if(value!=null && value!=undefined){
                    		ImportFile.importFile($scope.uploadType, value);
                    		angular.element("input[type='file']").val(null);
                    	}
                    })
                    
                }],
                controllerAs: controllerName,
                templateUrl: 'app/csplTableImport.html',
                restrict: 'E',
                scope: {
                    uploadType: '@',
                    fileContent: '='
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.permissionToImport = true;
                        $scope.uploadType = attributes.uploadType;
                        
                        
                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplNgRepeatEnd', ['$rootScope', function($rootScope) {
            return function(scope, element, attrs) {
                if (scope.$last) {
                    $rootScope.$emit('gatewayApp:csplTableRepeatComplete', attrs.csplNgRepeatEnd);
                }
            };
        }])
        .directive('dynamicColspan', function() {
            return {
                restrict: 'A',
                template: '',
                link: function(scope, elem, attr) {
                    function setColspan() {
                        var colsToSpan = scope.$eval(attr.dynamicColspan);
                        if (angular.isObject(colsToSpan)) {
                            angular.forEach(colsToSpan, function(condition, key) {
                                if (condition && isFinite(key)) {
                                    colsToSpan = key;
                                }
                            });
                        }

                        elem.attr('colspan', parseInt(colsToSpan, 10));
                    }
                    setColspan();
                    scope.$watch(attr.dynamicColspan, setColspan);
                }
            }
        })

        .directive('csplLegend', function () {
		    return {
		        template: '<a data-toggle="collapse" data-parent="#accordion"  data-target="#searchtab">' + '<i class = "fa" ng-class = "{\'fa-chevron-circle-down\': openBox, \'fa fa-chevron-circle-up\': \'!openBox\'}" ng-click = "openBoxFunc()" style="color: grey;"></i></a>',
		        controller: ['$scope', function ($scope) {
		            $scope.openBox = true;
		            $scope.openBoxFunc = function () {
		                $scope.openBox = !$scope.openBox;
		            }
		        }]
		    }
		})

        .directive('priceVolatilityWidget', function() {
            return {
                restrict: 'EA',
                templateUrl: 'app/widget/price-volatility-widget.html',
                scope: {
                    currencyPair: '=',
                    currentRate: '=',
                    volatilityList: '=',
                    rateList: '=',
                    priceListNoofMonth: '=',
                    pattern: '=',
                    rateDate : '='

                },
                link: function(scope, element, attributes){
                    if(scope.pattern =='pattern1')
                    	element.addClass('widget-xs-a');
                    else if(scope.pattern =='pattern2')
                    	element.addClass('widget-xs-b');
                    else if(scope.pattern =='pattern3')
                    	element.addClass('widget-xs-c');
                    else if(scope.pattern =='pattern4')
                    	element.addClass('widget-xs-d');
                  },
                controller: function() {
                    this.sparkline1options = {
                        defaultPixelsPerValue: 10,
                        width: "100%",
                        height: 30,
                        lineColor: '#fff',
                        fillColor: false,
                        spotColor: 'rgba(256, 256, 256, 0.5)',
                        minSpotColor: 'rgba(256, 256, 256, 0.5)',
                        maxSpotColor: 'rgba(256, 256, 256, 0.5)',
                        spotRadius: 3,
                        highlightSpotColor: 'rgba(256, 256, 256, 0.8)',
                        highlightLineColor: 'rgba(256, 256, 256, 0.8)',
                        lineWidth: 2
                    };
                    this.space = ' ';
                },

                controllerAs: 'priceVolatilityWidgetCtrl'
            };
        })
        .directive('csplFav', [function() {
            return {
                scope: {
                    index: '=',
                    view: '=',
                    callback: '&'
                },
                replace: true,
                template: '<a href="" data-toggle="tooltip" data-container="body" data-placement="bottom" title="Save Favorite" style="position: fixed; right: 50px; color: #fff;"><i class="fa" ng-click="callback({index:index})" ng-class="{\'fa-star-o\': !view[index], \'fa-star\': view[index]}" style="font-size:20px;"></i></a>',
                restrict: 'E',
                link: function(scope, element, attrs) {
                    $(element).hover(function() {
                        // on mouseenter
                        $(element).tooltip('show');
                    }, function() {
                        // on mouseleave
                        $(element).tooltip('hide');
                    });
                }
            }
        }]).directive('onFinishRender',['$timeout', function($timeout) {
            return {
                restrict: 'A',
                link: function(scope, element, attr) {
                    if (scope.$last === true) {
                        $timeout(function() {
                            scope.$emit(attr.onFinishRender);
                        });
                    }
                }
            }
        }])
        .directive('csplEntityLookup', ['GlobalValues', 'User', function(GlobalValues, User) {
            return {
                restrict: 'E',
                replace: false,
                scope: {
                	userEntityOwnerType: '=',
                	selectedEntityOwnerType: '=',
                	bankValue: '=',
                	branchValue: '=',
                	customerValue: "=",
                	userValue: '=',
                	userListValue: '=',
                	controlForm: '=',
                	controlClass: "@",
                	showUser:'=',
                	userLookup:'=',
                	showClearCorp:'=',
                	showTerminatedBranch:'='
                },
                templateUrl: 'app/csplEntityLookup.html',
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                    	$scope.userListValue = [];
                    	$scope.$watchGroup(['selectedEntityOwnerType', 'bankValue', 'branchValue', 'customerValue', 'userValue', 'userLookup'],  function(newValues, oldValues, scope){
							var userList = [];
							$scope.userListValue = [];
							if(newValues[4]!=null && newValues[4]!=""){
								userList.push(newValues[4].id);
								$scope.userListValue = userList;
							}else if($scope.userLookup == 'userForTurnOverReport'){
								var userEntityOwnerType = $scope.userEntityOwnerType;
								if(newValues[0]!="" && newValues[0]!=null){
									if (newValues[0]==userEntityOwnerType && userEntityOwnerType!="Branch"){
										User.getUsersByOrganisationAndEntityOwnerTypeTurnOverReport({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType},onSuccess, onFailure);
									}else if (newValues[0]==userEntityOwnerType && userEntityOwnerType=="Branch"){
										 User.getUsersForBranchTurnOverReport({"bankId":GlobalValues.getBankId(),"branchId": GlobalValues.getBranch().id},onSuccess, onFailure);
									}else if(userEntityOwnerType=="Clearcorp" && newValues[0]=="Bank"  && (newValues[1]!="" && newValues[1]!=null) ){
										User.getUsersByOrganisationAndEntityOwnerTypeTurnOverReport({"orgId": newValues[1].id, entityOwnerType: 'Bank'},onSuccess, onFailure);
									}else if((userEntityOwnerType=="Clearcorp" || userEntityOwnerType=="Bank") && newValues[0]=="Branch" && (newValues[2]!="" && newValues[2]!=null)){
										User.getUsersForBranchTurnOverReport({"bankId":GlobalValues.getOrgId(),"branchId": newValues[2].id},onSuccess, onFailure);
									}else if((userEntityOwnerType=="Clearcorp" || userEntityOwnerType=="Bank" || userEntityOwnerType=="Branch") && (newValues[0]=="MultiUserCustomer" || newValues[0]=="SingleUserCustomer") && ( newValues[3]!="" && newValues[3]!=null)){
										 User.getUsersByOrganisationAndEntityOwnerTypeTurnOverReport({"orgId": newValues[3].id, entityOwnerType: newValues[0]},onSuccess, onFailure);
									}
								}else if(userEntityOwnerType=="MultiUserCustomer" || userEntityOwnerType=="SingleUserCustomer"){
									 User.getUsersByOrganisationAndEntityOwnerTypeTurnOverReport({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType}, onSuccess, onFailure);
								}else{
									User.getUsersForOrganisationTurnOverReport({"orgId": newValues[3].id},onSuccess, onFailure);
								}
							}else{
								
								if(newValues[0]!="" && newValues[0]!=null){
									if (newValues[0]==$scope.userEntityOwnerType && $scope.userEntityOwnerType!="Branch"){
										User.getAllUsersByOrganisationAndEntityOwnerType({"orgId": GlobalValues.getOrgId(), entityOwnerType: $scope.userEntityOwnerType}, onSuccess, onFailure);
									}else if (newValues[0]==$scope.userEntityOwnerType && $scope.userEntityOwnerType=="Branch"){
										User.getAllUsersForBranch({"bankId":GlobalValues.getBankId(),"branchId": GlobalValues.getBranch().id}, onSuccess, onFailure);
									}else if($scope.userEntityOwnerType=="Clearcorp" && newValues[0]=="Bank" && (newValues[1]!="" && newValues[1]!=null)){
										User.getAllUsersByOrganisationAndEntityOwnerType({"orgId": newValues[1].id, entityOwnerType: 'Bank'}, onSuccess, onFailure);
									}else if(($scope.userEntityOwnerType=="Clearcorp" || $scope.userEntityOwnerType=="Bank") && newValues[0]=="Branch" && (newValues[2]!="" && newValues[2]!=null)){
										User.getAllUsersForBranch({"bankId":GlobalValues.getOrgId(),"branchId": newValues[2].id}, onSuccess, onFailure);
									}else if(($scope.userEntityOwnerType=="Clearcorp" || $scope.userEntityOwnerType=="Bank" || $scope.userEntityOwnerType=="Branch") && (newValues[0]=="MultiUserCustomer" || newValues[0]=="SingleUserCustomer") && (newValues[3]!="" && newValues[3]!=null)){
										User.getAllUsersByOrganisationAndEntityOwnerType({"orgId": newValues[3].id, entityOwnerType: newValues[0]}, onSuccess, onFailure);
									}
								}else if($scope.userEntityOwnerType=="MultiUserCustomer" || $scope.userEntityOwnerType=="SingleUserCustomer"){
									User.getAllUsersByOrganisationAndEntityOwnerType({"orgId": GlobalValues.getOrgId(), entityOwnerType: $scope.userEntityOwnerType}, onSuccess, onFailure);
								}
							}
							
							function onSuccess(result){
								if(result!=null ){
									angular.forEach(result, function(value){
										userList.push(value.id);
									})
									$scope.userListValue = userList;
								}
							}
							function onFailure(){
								
							}
                    	})
                    	
                    }
                    return linkFunction;
                }
            };
        }
        ])
        
        .directive('otpInputDirective', ['$timeout', function($timeout) {
    return {
        restrict: 'A', // restrict by attribute
        scope: {
            options: "=",
            controlDisabled: "="
        },
        template: "<div>" +
        "<input type='{{type}}' ng-repeat=\"c in characters\" autocomplete='off' ng-disabled='controlDisabled' ng-keyup='onKeyUp($index,$event)' ng-keydown='onKeyDown($index,$event)' ng-model='c.value' id='otpInput{{c.index}}' name='otpInput{{c.index}}' ng-style=\"style\" placeholder=\"{{placeholder}}\" maxlength=\"1\"  />\n" +
        "</div>",
        link: function($scope, elem) {
            var size = parseInt($scope.options.size) || 6;
            var width = 100 / (size + 1);
            var margin = width / size;
            var tmp = [],
                elementArr = [];
            var DEFAULT_COLOR = "#6f6d6d";
            // generating a random number to attach to id
            var randomNumber = Math.floor(Math.random() * 10000) + 100
            $scope.style = {
                "margin-right": margin + "%",
                "border": "none",
                "border-bottom": "2px solid",
                "border-radius": "0",
                "display": "inline-block",
                "width": width + "%",
                "text-align": "center",
                "padding": "5px 0px",
                "outline":"none",
                "box-shadow":"none",
                "background":"transparent",
                "border-color": $scope.options.style && $scope.options.style.lineColor ? $scope.options.style.lineColor : DEFAULT_COLOR,
                "color": $scope.options.style && $scope.options.style.color ? $scope.options.style.color : "blue",
                "font-size": $scope.options.style && $scope.options.style.fontSize ? scope.options.style.fontSize : "13px"
            };

            $scope.type = $scope.options.type ? $scope.options.type : "text";
            $scope.placeholder = $scope.options.placeholder && $scope.options.placeholder.length === 1 ? $scope.options.placeholder : "";

            $scope.setOtpValue = function() {
                $scope.options.value = "";
                var done = true;
                angular.forEach($scope.characters, function(v, k) {
                    if (v.value.length !== 1) {
                        done = false;
                        return false;
                    }
                    $scope.options.value = $scope.options.value + v.value;
                });
                if (done) {
                    if (typeof($scope.options.onDone) === "function") {
                        $scope.options.onDone($scope.options.value);
                    }
                }
            };

            $scope.$watch('controlDisabled', function(value){
            	$scope.controlDisabled = value;
            	if(value==false){
            		angular.forEach($scope.characters, function(val) {
            			val.value='';
                    });
            	}
            })
            
            $scope.onKeyUp = function(index, e) {
                var key = e.keyCode || e.which;
                var old = $scope.options.value;
                $scope.setOtpValue();
                if ($scope.characters[index].value.length > 0 && key !== 8 && index != size - 1) {
                    $timeout(function() {
                        elementArr[index + 1][0].focus();
                    });
                }
                if (typeof($scope.options.onChange) === "function" && old !== $scope.options.value) {
                    $scope.options.onChange($scope.options.value);
                }

            };

            $scope.onKeyDown = function(index, e) {
                var key = e.keyCode || e.which;
                if (key === 8 && $scope.characters[index].value === "" && index !== 0) {
                    $timeout(function() {
                        elementArr[index - 1][0].focus();
                    });
                }
            };

            for (var i = 0; i < size; i++) {
                tmp.push({
                    index: randomNumber + "-" + i,
                    value: ""
                });
            }
            $scope.characters = tmp;

            $timeout(function() {
                for (var i = 0; i < size; i++) {
                    elementArr.push(angular.element(document.querySelector("#otpInput" + randomNumber + "-" + i)));
                }
            });

        }
    }
}])
	.directive('modalDialog', function(){
               return {
                 restrict: 'AC',
                 link: function($scope, element) {
                     var draggableStr = "draggableModal";
                     var header = $(".modal-header", element);
                     header.on('mousedown', function(mouseDownEvent) {
                       var modalDialog = element;
                       var offset = header.offset();
                       modalDialog.addClass(draggableStr).parents().on('mousemove', function(mouseMoveEvent) {
                             $("." + draggableStr, modalDialog.parents()).offset({
                                 top: mouseMoveEvent.pageY - (mouseDownEvent.pageY - offset.top),
                                 left: mouseMoveEvent.pageX - (mouseDownEvent.pageX - offset.left)
                             });
                         }).on('mouseup', function() {
                              modalDialog.removeClass(draggableStr);
                         });
                     });   
                  }
               } 
      })
       .directive('csplTimePicker', function() {
           
            return {
                
                template: '<div class="input-group" ng-disabled="controlDisabled"> <input onkeydown="return false" name="cspl-time-picker" id="controlId" type="text" datetimepicker ng-disabled="controlDisabled" options="formatOptions"  placeholder="hh:mm A" autocomplete="off" class="form-control" ng-focus="onFocus()" ng-blur="onBlur(controlModel)"  style="text-align:right;background-color:{{bgColor}};border-color:{{boColor}};color:{{colorValue}};"  on-change="updateModel()" ng-model="controlModel" /> <span class="input-group-addon " style="border-color:{{boColor}}; background:{{bgColor}}; "> <i class="glyphicon glyphicon-time"></i></span>'+
            		 			'</div> <span ng-show="Error != null" class="help-block-error">{{Error}}</span><span ng-show="(helpText != null && showHelpText)" class="help-block">{{helpText}}</span>',
                restrict: 'E',
                scope: {
                  
                    controlRequired: '=',
                    controlModel: '=',
                    controlDisabled: '=',
                    controlValueChange: '&',
                    control24HrFormat:'=',
                    controlMinDate: '=',
                    controlMaxDate: '=',
                    form: '=',
                    controlId: '=',
                    helpText: '@',
                    themeType: '@',
                    timeZone: '=',
                    horizontalPosition: '@',
                    verticalPosition: '@'
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.boColor = "#BB8557";
                        $scope.formatOptions = {};
                        $scope.formatOptions.widgetPositioning = {
                        		horizontal: 'auto',
                         		vertical:  'auto'
                        }
                        if($scope.horizontalPosition){
                        	
                        	$scope.formatOptions.widgetPositioning.horizontal = $scope.horizontalPosition;
                        }
                        if($scope.verticalPosition){
                       	 	
                        	$scope.formatOptions.widgetPositioning.vertical = $scope.verticalPosition;
                       }
                       
                        if($scope.control24HrFormat){
                        	$scope.formatOptions.format =  'HH:mm' ;
                        }else{
                        	$scope.formatOptions.format = 'hh:mm A' ;
                        }
                        
                        if($scope.controlMinDate){
                        	$scope.formatOptions.minDate  = $scope.controlMinDate;
                        }else{
                        	$scope.formatOptions.minDate  = moment().startOf('day');
                        }
                        
                        if($scope.controlMaxDate){
                        	$scope.formatOptions.maxDate  = $scope.controlMaxDate;
                        }else{
                        	
                        	$scope.formatOptions.maxDate = moment().endOf('day');
                        } 
                        if($scope.timeZone){
                        	$scope.formatOptions.timeZone  = $scope.timeZone;
                        }else{
                        	
                        	$scope.formatOptions.timeZone = moment.tz;
                        } 
                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                            }

                            if (value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "timepickerequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "timepickerequired", false);
                                }
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !(value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "timepickerequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            }
                        })

                         $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "timepickerequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#FFC000";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "timepickerequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "timepickerequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.onFocus = function(){
                        	$scope.boColor = "#FFC000";
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null) {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		// $scope.Error = "This field cannot be left
									// blank";
                            		$scope.Error = "Invalid Time";
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        }

                        $scope.$watch('controlModel', function(value) {
                        	
                        		if( typeof value == 'string'){
                        			// alert("app.module");
                        			value = moment(value, 'YYYY-MM-DD').toDate();
                        			console.log(value);
                        		}
                        		
                        	
                            if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "timepickerequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else {
                                $scope.updateModel();
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "timepickerequired", true);
                                    $scope.Error = "";
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                                if (attributes.required != null && (value != null && value != "")) {
                                	$scope.boColor = "#BB8557";
                                	/*
									 * if($scope.themeType=='light'){
									 * $scope.bgColor = "#FEFAEE"; }
									 */
                                	
                                }
                            }
                        })

                        if (attributes.darkTheme == null) {
                            $scope.colorValue = "#F2F2F2";
                        } else {
                            $scope.colorValue = "#7F7F7F";
                        }
                        if ($scope.themeType == 'light'){
                        	$scope.colorValue = '#262626';	
                        }
                    }
                    return linkFunction;
                }
            };
        })
        .directive('csplFromToTimePicker', function() {
           
            return {
                
                template: '<div style="width:100%;">'+
							'<div style="width:50%;display:table-cell;padding-right:8px;">'+      	 
								'<cspl-time-picker control-model="fromModel" control-id="controlId" time-zone="timeZone" control-required="controlRequired" control-disabled="controlFromDisabled" control-value-change="fromControlValueChange" '+
								  ' control24HrFormat="control24HrFormat" form="form" control-min-date="minValueForFrom" control-max-date="maxValueForFrom" help-text = "{{fromHelpText}}" theme_type="{{themeType}}" ></cspl-time-picker>'+								   
							'</div>'+		  
							'<div  style="width:50%;display:table-cell;padding-left:8px;">'+    			        	 
								'<cspl-time-picker control-model="toModel" control-id="toId" time-zone="timeZone" control-required="controlRequired" control-disabled="controlToDisabled" control-value-change="toControlValueChange" '+
								  ' control24HrFormat="control24HrFormat" form="form" control-min-date="minValueForTo" control-max-date="maxValueForTo" help-text = "{{toHelpText}}" theme_type="{{themeType}}"></cspl-time-picker>'+
							'</div>'+
						'</div> ',
                restrict: 'E',
                scope: {
                  
                	fromModel: '=',
                	toModel: '=',
                	maxValueForFrom: '=?',
                	maxValueForTo: '=?',
                	minValueForFrom: '=?',
                	minValueForTo: '=?',
                	timeDifference:'=',
                	controlId: '=',
                	controlRequired: '=',
                	controlFromDisabled: '=',
                	controlToDisabled: '=',
                	control24HrFormat: '=',
                	fromControlValueChange: '&',
                	toControlValueChange: '&',
                	timeZone:  '=',
                	themeType: '@',
                	form: '=',
                	fromHelpText: '@',
                	toHelpText: '@',
                	setDefaultValues: '='
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.boColor = "#BB8557";
                        $scope.defaultDuration = "01:00:00";
                        if($scope.controlId){
                        	$scope.toId = $scope.controlId+'ToControl';
                        }else{
                        	$scope.controlId= "timePickerPairFromControl"
                        		$scope.toId= "timePickerPairToControl"	
                        }
                        if($scope.minValueForFrom){
                        	
                        }else{
                        	$scope.minValueForFrom  = moment().startOf('day');
                        }
                                              
                        
                        $scope.subtractDurationFromGivenValue = function(toValue) {
                        	 if(toValue !=null && toValue !=undefined && toValue != ""){
                        		 var duration = $scope.timeDifference;
                        		 if(duration==null || duration ==undefined ||  duration==""){
                        			 duration = moment.duration( $scope.defaultDuration);
                        		 }
                        		 return angular.copy(toValue).subtract(duration);
                        	 }else{
                        		 
                        		 return null;
                        	 }
                        }
                        $scope.addDurationFromGivenValue = function(fromValue) {
                       	 if(fromValue !=null && fromValue !=undefined && fromValue != ""){
                       		 var duration = $scope.timeDifference;
                       		 if(duration==null || duration ==undefined ||  duration==""){
                       			 duration = moment.duration( $scope.defaultDuration);
                       		 }
                       		 return angular.copy(fromValue).add(duration);
                       	 }else{
                       		 
                       		 return null;
                       	 }
                       }
                        if($scope.toModel != null && $scope.toModel != undefined && $scope.toModel !=""){
                           
                            $scope.fromModel =  $scope.subtractDurationFromGivenValue($scope.toModel);
                           
                        }else{
                        	if($scope.setDefaultValues){
                        		var  currentMoment = moment();
                        		$scope.toModel = angular.copy(currentMoment);                        		 
                        		$scope.fromModel =  $scope.subtractDurationFromGivenValue($scope.toModel);
                        	}
                        }
                        if(  $scope.maxValueForFrom == null || $scope.maxValueForFrom == undefined || $scope.maxValueForFrom == ""  ){
                        	if($scope.setDefaultValues)
                        		$scope.maxValueForFrom =  angular.copy($scope.fromModel);
                        	else
                        		$scope.maxValueForFrom = moment().endOf('day');
                        }
                        if( ($scope.maxValueForTo == null || $scope.maxValueForTo == undefined || $scope.maxValueForTo == "") ){
                        	if($scope.setDefaultValues)
                        		$scope.maxValueForTo =  angular.copy($scope.toModel);
                        	else
                        		$scope.maxValueForTo = moment().endOf('day');
                        }
                        $scope.$watch('fromModel', function(value) {
                        	// change to value if from value is changed
                    		if(value!=null && value!=undefined && value!='') {                    			
                    			$scope.toModel =  $scope.addDurationFromGivenValue(value);
                               
                    		}
                    })

                    }
                    return linkFunction;
                }
            };
        })
        .directive('csplNumberText', ['$compile','$filter', '$window', function($compile,$filter,$window) {
            return {
                template: '<div ng-class="{ \'input-group\' : showCurrencyCode || showPayOrReceive || showToggle }">'+
                            '<span class="input-group-btn" ng-show="showToggle">'+
                                '<button class="btn " ng-class = "{ \'btn-approve\':  toggleColor, \'btn-reject\':  !toggleColor, \'avoid-clicks\': controlDisabled }" style="height: 34px;" type="button" ng-click="toggleCallback({ character : toggleCharacter, toggle : toggleColor})" tabindex="-1"><i style="font-size: 20px;"></i></button>'+
                            '</span>'+
                            '<input type="text" class="form-control"  ng-model="controlModel" angular-currency="angularCurrency" variable-options="true"  data-m-dec = "6"  ng-disabled="controlDisabled" autocomplete="off" id="{{controlId}}" ng-change="updateModel()" ng-keypress="keyPress($event)" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" style="text-align:center;background-color:{{bgColor}};border-color:#BFBFBF;text-transform: {{textTransformation}};line-height:inherit;height:inherit;font-size:inherit;width:100%;margin: 0 auto;" ng-pattern="{{controlPattern}}" tabindex="{{controlTabIndex}}"/>'+
                            '<span ng-show="Error != null" class="help-block-error">{{Error}}</span>'+
                            '<span ng-show="errorText != null && errorText!= \'\' && showErrorText" style="position:relative;"><span ng-show="errorText != null && errorText!= \'\' && showErrorText" class="help-block-warning-error arrow-up" style="position: absolute;margin: 0px 2px 2px 0px; right: 0px; background: #ffffff; padding: 6px 1px; border-radius: 4px; border-right: 5px solid transparent; border-top: 5px solid black;">{{errorText}}</span></span>'+
                            '<span ng-show="(helpText != null && helpText!= \'\' && showHelpText)" style="position:relative;"><span ng-show="(helpText != null && helpText!= \'\' && showHelpText)" class="help-block-warning arrow-up" style="position: absolute;margin: 0px 2px 2px 0px; right: 0px; background: #ffffff; padding: 6px 1px; border-radius: 4px; border-right: 5px solid transparent; border-top: 5px solid black;">{{helpText}}</span></span>{{ currencyCodeElement }}'+
                            '<span class="input-group-addon" ng-show="showCurrencyCode"><b>{{ currencyCode }}</b></span>'+
                            '<span class="input-group-btn" ng-show="showPayOrReceive">'+
                                '<button class="btn " ng-class = "{ \'btn-approve\':  controlModel >= 0, \'btn-reject\':  controlModel < 0, \'avoid-clicks\': controlDisabled }" style="height: 34px;" type="button" ng-click="negateControlModel()" tabindex="-1"><i style="font-size: 20px;"></i></button>'+
                            '</span>'+
                          '</div>',

                restrict: 'E',
                scope: {
                    controlModel: '=',
                    controlType: '@',
                    controlRequired: '=',
                    controlDisabled: '=',
                    form: '=',
                    controlValueChange: '=',
                    controlId: '@',
                    currencySymbol: '@',
                    noOfDecimals: '@',
                    controlMin: '@',
                    helpText: '@',
                    showErrorText: '=',
                    controlMax: '@',
                    angularCurrency: '@',
                    currencyCode: '@',
                    payOrReceiveCurrency: '@',
                    toggleCharacter: '@',
                    toggleColor: '@',
                    toggleCallback: '&',
                    themeType: '@',
                    controlTabIndex:'@',
                    controlModified:'=',
                    controlInvalid:'='
                },
                compile: function(element, attributes) {
                    var linkFunction = function($scope, element, attributes) {

                        $scope.showErrorText = false;
                        $scope.showHelpText = false;
                        $scope.boColor = "#BB8557";
                        $scope.currencySymbol = "";
                        $scope.Error = "";
                        $scope.controlType = 'Normal';
                        $scope.textTransformation = "none";
                        $scope.showCurrencyCode = false;
                        $scope.showPayOrReceive = false;
                        $scope.payOrReceive = 'Receive'
                        $scope.showToggle = false;
                        $scope.themeType = 'dark';
                        $scope.helpText = "";
                        $scope.errorText = "";

                        $scope.negateControlModel = function(){
                            $scope.controlModel = -1 * $scope.controlModel;
                        }

                        $scope.onFocus = function onFocus(){
                        	$scope.boColor = "#FFC000";
                        	$scope.showHelpText = true;
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null) {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		$scope.errorText = "This field cannot be left blank";
                            		if($scope.showErrorText==true){
                            			$scope.Error = "This field cannot be left blank";
                            		}
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	if($scope.controlInvalid!=undefined && $scope.controlInvalid!=null && $scope.controlInvalid==true){
                            		$scope.boColor = "#FF3737";
                            	}else{
                            		$scope.boColor = "#595959";
                                    if($scope.themeType=='light'){
                                    	$scope.boColor = "#C2C2C2";
                                    }
                            	}
                            	
                            }
                        	$scope.showHelpText = false;
                        }

                        /* $scope.controlPattern = "/^[_'.A-Za-z0-9-]*$/"; */
                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                        $scope.$watch('payOrReceiveCurrency', function(value){
                            if(value != null && value != "" && value != undefined){
                                $scope.faPayOrReceiveCurrency = 'fa fa-' + $filter('lowercase')($scope.payOrReceiveCurrency);
                                $scope.showPayOrReceive = true;
                                element.find("i").removeClass();
                                element.find("i").addClass($scope.faPayOrReceiveCurrency);
                            }
                        });

                        $scope.$watch('toggleCharacter', function(value){
                            if(value != null && value != "" && value != undefined){
                                $scope.faPayOrReceiveCurrency = 'fa fa-' + $filter('lowercase')($scope.toggleCharacter);
                                $scope.showToggle = true;
                                element.find("i").removeClass();
                                element.find("i").addClass($scope.faPayOrReceiveCurrency);
                            }
                        });

                        $scope.$watch('toggleColor', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                $scope.bgColor = "#e2f0d9";
                                $scope.boColor = "#37a36a";
                                $scope.toggleColor = true;
                            } if (value != null && value != "" && (value == false || value == "false")) {
                                $scope.bgColor = "#ffebeb";
                                $scope.boColor = "#f34931";
                                $scope.toggleColor = false;
                            }
                        });

                        $scope.$watch('currencyCode', function(value){
                            if(value != null && value != "" && value != undefined){
                                $scope.showCurrencyCode = true;
                            }
                        });

                        $scope.$watch('controlType', function(value) {
                            if (value == "ShortName") {
                                $scope.textTransformation = "uppercase";
                            }
                            /*
							 * else{ $scope.textTransformation = "capitalize"; }
							 */
                        })

                        $scope.$watch('currencySymbol', function(value) {
                            if (value != null && value != "") {
                                $scope.currencySymbol = value;

                            }
                            $scope.setAngularCurrency();
                        })
                        $scope.setAngularCurrency = function() {
                            $scope.angularCurrency = {
                                aSign: $scope.currencySymbol,
                                mDec: $scope.noOfDecimals,
                                vMin: $scope.controlMin,
                                vMax: $scope.controlMax
                            };
                        };
                        $scope.$watch('noOfDecimals', function(value) {
                            if (value != null && value != "") {
                                $scope.noOfDecimals = value;
                            }
                            $scope.setAngularCurrency();
                        })

                        $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if(value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                               // $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#595959";
                            }else if (attributes.required != null && ($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                }
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            }
                        })
                        
                        $scope.keyPress = function (event) {
                        	var value = String.fromCharCode(event.which);
                        	var multiplier = 1;
                            if(value == 'm' || value == 'M'){
                            	multiplier = 1000000;
                            }
                            else if(value == 'l' || value == 'L'){
                            	multiplier = 100000;
                            }
                            else if(value == 'c' || value == 'C'){
                            	multiplier = 10000000;
                            }
                            else if(value == 'b' || value == 'B'){
                            	multiplier = 1000000000;
                            }
                            else if(value == 'k' || value == 'K'){
                            	multiplier = 1000;
                            }
                            
                            if($scope.controlModel!=null && $scope.controlModel!=undefined && multiplier != 1){
                            	$scope.controlModel = ($scope.controlModel * multiplier);
                            	$scope.$apply();
                            }

                        };
                        
                        element.bind('click', function (event) {
                            if (!$window.getSelection().toString()) {
                            	this.children[0].children[1].select();
                            }
                          });

                        $scope.$watch('controlModel', function(value) {
                            if ($scope.controlType == "ShortName" && $scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.toUpperCase();
                            }
                            if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    $scope.errorText = "";
                                    if($scope.showErrorText!=true){
                            			$scope.Error = "";
                            		}
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if (attributes.required != null && (value != null && value != "")) {
                            	$scope.boColor = "#BB8557";
                            	/*
								 * if($scope.themeType=='light'){ $scope.bgColor =
								 * "#FEFAEE"; }
								 */
                            }
                            if($scope.showPayOrReceive){
                                if($scope.controlModel >= 0){
                                    $scope.bgColor = "#e2f0d9";
                                    $scope.boColor = "#37a36a";
                                }else if($scope.controlModel < 0){
                                    $scope.bgColor = "#ffebeb";
                                    $scope.boColor = "#f34931";
                                }
                            }
                            if($scope.showToggle){
                                if($scope.toggleColor){
                                    $scope.bgColor = "#e2f0d9";
                                    $scope.boColor = "#37a36a";
                                }else {
                                    $scope.bgColor = "#ffebeb";
                                    $scope.boColor = "#f34931";
                                }
                            }
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })
                        $scope.$watch('controlModified', function(value) {
                        	 if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                 $scope.boColor = "#00B0F0";
                                 
                             }
                         
                         });
                        $scope.$watch('controlInvalid', function(value) {
                       	 if ($scope.controlInvalid!=undefined && $scope.controlInvalid!=null && $scope.controlInvalid==true) {
                       		$scope.boColor = "#FF3737";
                                
                            }
                        
                        })

                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplShortcuts', function () {
		    return function (scope, element, attrs) {
		        element.bind("keydown", function (event) {
                	var code = event.which;
                	scope.value = '';
                    
                    if(code == 38){
                    	scope.value = 'UpArrow';
                    }
                    else if(code == 40){
                    	scope.value = 'DownArrow';
                    }
                    else if(code == 107){
                    	scope.value = '+';
                    }
                    else if(code == 109){
                    	scope.value = '-';
                    }
// else if(code == 37){
// key = 'LeftArrow';
// }
// else if(code == 39){
// key = 'RightArrow';
// }
                    
                    if(scope.value != ''){
                    	scope.$eval(attrs.csplShortcuts);
 		                event.preventDefault();
                    }
                });
		        
                element.bind("keypress", function (event) {
                	scope.value = String.fromCharCode(event.which);
                    if(scope.value != ''){
                    	scope.$eval(attrs.csplShortcuts);
                    }
                });
		    };
		})
		/*
		 * .directive('combo', function () { return { restrict: 'E', template: '<select
		 * ng-model="controlModel" ng-change="changeEvent()" >' + '<option
		 * ng-value="model" ng-repeat="model in items">{{model[displayItem]}}</option></select>',
		 * replace: true, scope: { items: '=', defaultItem: '=', changeEvent:
		 * '&', displayItem: '@' }, controller: function ($scope) {
		 * console.log(displayItem); }, link: function (scope, element, attrs) {
		 * 
		 * scope.controlModel = scope.items[scope.defaultItem];
		 * scope.changeEvent = function () { //console.log("changed");
		 * console.log(scope.controlModel); } } }; })
		 */
		.directive('csplSelect', ['$compile', function($compile) {
            return {

                templateUrl: 'app/csplSelect.html',
                controllerAs: 'csplSelectCtrl',
                restrict: 'E',
                scope: {
		            items: '=',
		            defaultItem: '=',
		            changeEvent: '&',
		            displayItem: '@'
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
    		            $scope.controlModel = $scope.items[$scope.defaultItem];
                    }
                    return linkFunction;
                }
            };
        }])
		 .directive('fileReader', function() {
		  return {
		    scope: {
		      fileReader:"="
		    },
		    link: function(scope, element) {
		      $(element).on('change', function(changeEvent) {
		        var files = changeEvent.target.files;
		        if (files.length) {
		          var r = new FileReader();
		          r.onload = function(e) {
		              var contents = e.target.result;
		              scope.$apply(function () {
		                scope.fileReader = contents;
		              });
		          };
		          
		          r.readAsText(files[0]);
		        }
		      });
		    }
		  };
		})
	   .directive('myEnter', function () {
			return function (scope, element, attrs) {
				element.bind("keydown keypress", function (event) {
            		if(event.which === 13) {
                		scope.$apply(function (){
                			scope.$eval(attrs.myEnter);
                		});

                		event.preventDefault();
            		}
        		});
    		};
		})


.directive('draggable', ['$document', function($document) {
    return {
        restrict: 'A',
        link: function(scope, elm, attrs) {
            var startX, startY, initialMouseX, initialMouseY;
            elm.css({ position: 'absolute' });

            elm.bind('mousedown', function($event) {
                startX = elm.prop('offsetLeft');
                startY = elm.prop('offsetTop');
                initialMouseX = $event.clientX;
                initialMouseY = $event.clientY;
                $document.bind('mousemove', mousemove);
                $document.bind('mouseup', mouseup);
                return false;
            });

            function mousemove($event) {
                var dx = $event.clientX - initialMouseX;
                var dy = $event.clientY - initialMouseY;
                elm.css({
                    top: startY + dy + 'px',
                    left: startX + dx + 'px'
                });
                return false;
            }

            function mouseup() {
                $document.unbind('mousemove', mousemove);
                $document.unbind('mouseup', mouseup);
            }
        }
    };
}])


        .filter('split', function() {
				return function(input, splitChar, splitIndex) {
					// do some bounds checking here to ensure it has that index
					if (input != null && input != undefined && input != '') {
						var textArr = input.toString().split(splitChar);
						if (splitIndex <= textArr.length - 1) {
							return input.toString().split(splitChar)[splitIndex];
						} else {
							return input;
						}
					} else {
						return input;
					}
				}
		})
	.config(['IdleProvider', 'KeepaliveProvider', function(IdleProvider, KeepaliveProvider) {
            // IdleProvider.idle(30); // in seconds
            // IdleProvider.timeout(2); // in seconds
            // KeepaliveProvider.interval(2); // in seconds
        }])    
        
        // used to convert money to indian formatting
         .filter('amount',function(){
        	 return function(input){
        			if (input != null && input != undefined) {
        		
        				var wholeNoPart=input.toFixed().toString();
        				var formattedAmount="";
        				var formattedAmountInReverse="";
        				var a=0;
        				var b=0;
        				var i=0;
        				if(wholeNoPart.localeCompare("0")==0 && wholeNoPart.length==1)
        					return "-";
        				for(i=((wholeNoPart.length)-1);i>=0;i--)
        					{        				
        						if(a<3)
        							{
        								formattedAmount+=wholeNoPart.charAt(i);
        								a=a+1;
        							}
        						else if(b<2)
        							{
        							 	if (b == 0) {
        							 		formattedAmount+=",";
        							 		formattedAmount+=wholeNoPart.charAt(i);      							 	
        							 		b=b+1;
        							 	}
        							 	else
        							 	{
        							 		formattedAmount+=wholeNoPart.charAt(i);       							 		
        							 		b = 0;
        							 	}
        							}
        					}
        					for(i=((formattedAmount.length)-1);i>=0;i--)
        						{
        							formattedAmountInReverse+=formattedAmount.charAt(i)
        				
        						}

        						return formattedAmountInReverse;
        				}
        	 }
         })
         
         // To replace blank if the tax is 0.00%
         .filter('percentage',function(){
        	 return function(input){
        			if (input != null && input != undefined) {
        					if((input.toString()).match(/^[0].[0]+$/))
        						return " ";
        					else
        						return input;
        						
        			}
        	 }
         })
         
         .filter('charges',function(){
        	 return function(input, chargesPercentage){
     			if ((input != null && input != undefined)&&(chargesPercentage != null && chargesPercentage != undefined)) {
     					return input + ' @ ' +  chargesPercentage + '%';    						
     			}
     	 }
      })

	.filter('round',['$filter',function ($filter) {
		    /*
			 * Use this $filter to round Numbers UP, DOWN and to his nearest
			 * neighbour. You can also use multiples
			 */
		
		    /*
			 * Usage Examples: - Round Nearest: {{ 4.4 | round }} // result is 4 -
			 * Round Up: {{ 4.4 | round:'':'up' }} // result is 5 - Round Down: {{
			 * 4.6 | round:'':'down' }} // result is 4 * Multiples - Round by
			 * multiples of 10 {{ 5 | round:10 }} // result is 10 - Round UP by
			 * multiples of 10 {{ 4 | round:10:'up' }} // result is 10 - Round
			 * DOWN by multiples of 10 {{ 6 | round:10:'down' }} // result is 0
			 */
		    return function (value, mult, dir, decimals) {
			        dir = dir || 'nearest';
			        mult = mult || Number(0.01);
			        value = !value ? 0 : Number(value);
			        if (dir === 'up') {
			        	
			            return $filter('number')(Math.ceil(Math.round(parseFloat(value) * 10000) / Math.round(parseFloat(mult) * 10000)) * mult, decimals);
			        } else if (dir === 'down') {
			        	
			            return $filter('number')(Math.floor(Math.round(parseFloat(value) * 10000) / Math.round(parseFloat(mult) * 10000)) * mult, decimals);
			        } else {
			        	
			           return $filter('number')(Math.round(Math.round(parseFloat(value) * 10000) / Math.round(parseFloat(mult) * 10000)) * mult, decimals);
			        }
			    }
		}])
        .run(run);

   
    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
  
    
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function () {
	'use strict';

	angular
		.module('gatewayApp')
		.service("WebSocket", WebSocket);

	WebSocket.$inject = ['$rootScope', 'MarketWatch', '$filter', 'Notifications', 'GlobalValues', 'MessageBox', 'entityConstants', 'DateUtils', '$interval'];

	function WebSocket($rootScope, MarketWatch, $filter, Notifications, GlobalValues, MessageBox, entityConstants, DateUtils, $interval) {

		var isSubscribed = false;
		var isConnected = false;
		var isConnectInprogress = false;
		var isDisconnected = false;
		var isForciblyDisconnected = false;
		var user = 0;
		var globalValues = GlobalValues;
		var stompClient;
		var service = {
			subscribeWebSocket: subscribeWebSocket,
			reSubscribeWebSocket: reSubscribeWebSocket,
			disconnecteWebSocket: disconnecteWebSocket,
			subscribe: function (scope, callback) {
				var handler = $rootScope.$on('orderFeed', callback);
				scope.$on('$destroy', handler);
			}
		};
		return service;

		function disconnecteWebSocket(isSessionExpired) {
			if (isConnected) {
				isSubscribed = false;
				isConnected = false;
				isForciblyDisconnected = true;
				if (!isSessionExpired) {
					if ($rootScope.userPreference.showInteractiveMsgPopup == null || $rootScope.userPreference.showInteractiveMsgPopup.toLowerCase() == 'yes') {
						$.growl.alert({ title: "Session Message", message: "Session expired." });
					}
				}
				console.log('websocket disconnect from disconnect msg received from WBS');
				stompClient.disconnect();
			}
		}

		function subscribeWebSocket(userId) {
			user = userId;

			if (isConnected == false) {
				isConnectInprogress = true;
				console.log("Attempting to connect");
				var headers = { 'session': userId };
				stompClient = webstomp.over(new SockJS("/websocket/tracker"));
				stompClient.connect(headers, function (frame) {
					console.log('Connect success');
					isConnected = true;
					if (isSubscribed == false) {
						isSubscribed = true;
						console.log('Attempting to subscribe');
						isForciblyDisconnected = false;
						stompClient.subscribe("/topic/cspl", function (d) {
							console.log(d.body);
						});

						stompClient.subscribe("/user/topic/disconnect", function (d) {
							disconnecteWebSocket(false);
						});

						stompClient.subscribe("/user/topic/order", function (d) {
							console.log('User - ' + d.body);
							if (d.body != null && d.body != undefined && d.body != '') {
								var object = angular.fromJson(d.body);
								if (object != null && object != undefined) {
									orderFeed(object);
								}
							}
						});

						stompClient.subscribe("/user/topic/market", function (d) {
							console.log('User - ' + d.body);
							if (d.body != null && d.body != undefined && d.body != '') {
								var object = angular.fromJson(d.body);
								if (object != null && object != undefined) {
									marketFeed(object);
								}
							}
						});

						stompClient.subscribe("/topic/allusers", function (d) {
							console.log('User - ' + d.body);
							if (d.body != null && d.body != undefined && d.body != '') {
								var object = angular.fromJson(d.body);
								if (object != null && object != undefined) {
									intradayFeed(object);
								}
							}
						});

						stompClient.subscribe("/topic/server/status", function (d) {
							console.log('User - ' + d.body);
							if (d.body != null && d.body != undefined && d.body != '') {
								var object = angular.fromJson(d.body);
								if (object != null && object != undefined) {
									updateConnectionStatus(object);
								}
							}
						});

						stompClient.subscribe("/user/topic/process", function (d) {
							console.log('User - ' + d.body);
							if (d.body != null && d.body != undefined && d.body != '') {
								var object = angular.fromJson(d.body);
								console.log("process - " + object);
								if (object != null && object != undefined) {

									processFeed(object);
								}
							}
						});

						stompClient.subscribe("/user/topic/others", function (d) {
							console.log('User - ' + d.body);
							if (d.body != null && d.body != undefined && d.body != '') {
								var object = angular.fromJson(d.body);
								if (object != null && object != undefined) {
									othersFeed(object);
								}
							}
						});

						isConnectInprogress = false;

						// $interval(function(){
						//     $rootScope.pendingOrders = $rootScope.pendingOrdersMemory;
						//     $rootScope.trades = $rootScope.tradesMemory;
						//     $rootScope.outstandingTrades = $rootScope.outstandingTradesMemory;
						//     $rootScope.limitsAvailableForSelectedInstrument = $rootScope.limitsAvailableForSelectedInstrumentMemory;
						//     $rootScope.bankComparativeDTOInPrice = $rootScope.bankComparativeDTOInPriceMemory;
						//     $rootScope.retailSpotMarketDepth = $rootScope.retailSpotMarketDepthMemory;
						//     $rootScope.retailSpotMarketWatch =$rootScope.retailSpotMarketWatchMemory;
						//     $rootScope.ibSpotMarketDepth = $rootScope.ibSpotMarketDepthMemory;
						//     $rootScope.ibSpotMarketWatch = $rootScope.ibSpotMarketWatchMemory;
						//     $rootScope.userMarketWatchList = $rootScope.userMarketWatchListMemory;
						//     $rootScope.outrightRatesList = $rootScope.outrightRatesListMemory;
						// },500);

						//to refresh home page reports from database after websocket reconnection
						//timeout is to sync db writer process
						if (isDisconnected) {
							setTimeout(function () {
								$rootScope.refreshreportscount = 0;
								$rootScope.$emit('refreshreports');
								isDisconnected = false;
							}, 1500);
						}
					}
				},
					function (message) {
						console.log('Error in connection');
						handlingFailure(message);
					});
			}
		}

		function handlingFailure(message) {
			console.log('Retrying due to ' + message.code + ' - ' + message.reason +
				'. Connect progress status - ' + isConnectInprogress +
				". Connect status - " + isConnected);

			if (!isConnectInprogress || !isConnected) {
				isConnectInprogress = true;
				if (stompClient != null) {
					console.log('Forcibly disconnected due to error started');
					stompClient.disconnect();
					console.log('Forcibly disconnected due to error complete');
				}
				$rootScope.$emit('websocketDisconnected', message.reason);
				isSubscribed = false;
				isConnected = false;
				isDisconnected = true;
				reSubscribeWebSocket();
			}
		}

		function reSubscribeWebSocket() {
			if (!isForciblyDisconnected) {
				console.log('subscribe websocket from resubscribeWebsocket');
				subscribeWebSocket(user);
			}

		}

		function orderFeed(object) {
			if (object.topic == 'PendingOrderUpdate') {
				var pendingOrder = object.object;
				pendingOrdersFeed(object.object);
			} else if (object.topic == 'LimitUpdate') {
				var limit = object.object;
				limitUpdateFeed(object.object);
			} else if (object.topic == 'TradeNotification') {
				var trade = object.object;
				frameTradeNotification(object.object);
				tradeNotificationHandling(object.object);
			} else if (object.topic == 'OrderNotification') {
				var order = object.object;
				frameOrderNotification(object.object);
			} else if (object.topic == 'MarkUpUpdate') {
				markupChange(object.object);
			} else if (object.topic == 'TradeOutStandingNotification') {
				var limit = object.object;
				tradeOutstandingUpdate(object.object);
			} if (object.topic == 'TacAgreeUpdate') {
				tacAgreedChange(object.object);
			}
			$rootScope.$digest();
		}

		function marketFeed(object) {

			if (object.topic == 'MarketDepthRetailSpot' || object.topic == 'MarketDepthInterbank') {
				marketDepthChanges(object.object);
			} else if (object.topic == 'SessionStatusChange' || object.topic == 'InstrumentMasterUpdate') {
				marketSettingsChanges(object.object);
			} else if (object.topic == 'SwapQuoteChange') {
				swapQuoteChanges(object.object);
			} else if (object.topic == 'IntraDayMemberBreachUpdate') {
				frameMemberBreachedNotification(object.object, object.notificationId);
			} else if (object.topic == 'PreCashSessionCloseIntimation') {
				framePreCashSessionCloseIntimationNotification(object.object, object.notificationId);
			}
			$rootScope.$digest();
		}

		/*
		 * Intraday Feed 
		 */
		function intradayFeed(object) {
			if (object.topic == 'SessionStatusChange' || object.topic == 'InstrumentMasterUpdate') {
				marketSettingsChanges(object.object);
			} else if (object.topic == 'SwapQuoteChange') {
				swapQuoteChanges(object.object);
			} else if (object.topic == 'IntraDayMemberBreachUpdate') {
				frameMemberBreachedNotification(object.object, object.notificationId);
			} else if (object.topic == 'BroadcastMessage') {
				frameBroadcastMessage(object);
			} else if (object.topic == 'PreCashSessionCloseIntimation') {
				framePreCashSessionCloseIntimationNotification(object.object, object.notificationId);
			} else if (object.topic == 'OperationStatusIntimation') {
				serverComponentStatusChange(object.object);
			}
			$rootScope.$digest();
		}

		function othersFeed(object) {
			if (object.topic == 'TacNotification') {
				tacNotificationFeed(object);
			}
			if (object.topic == 'TacAgreeUpdate') {
				tacAgreedChange(object.object);
			}
			$rootScope.$digest();
		}

		function marketDepthChanges(marketDepthDTO) {
			//setTimeout(function(){
			//$scope.$apply(function(){

			//if(marketDepthDTO.baseCurrenc === 'USD'){

			if (
				marketDepthDTO.currencyPairId === 1 ||
				(
    $rootScope.currencyPairInstrumentDetails &&
    (
      Object.keys($rootScope.currencyPairInstrumentDetails).length === 0 ||
      $rootScope.currencyPairInstrumentDetails[marketDepthDTO.currencyPairId]
    )
  )
			) {
				var marketDepth = {};
				var existingMarketDepth = angular.copy($rootScope.marketDepth);
				//console.log('Before processing' + angular.toJson(existingMarketDepth));

				// if(existingMarketDepth == null || existingMarketDepth == undefined || existingMarketDepth.length == 0){
				// 	existingMarketDepth = [];
				// 	existingMarketDepth[0]= MarketWatch.getMarketDepth(marketDepthDTO);
				// }else if( existingMarketDepth.length == 1 && existingMarketDepth[0].instrumentID!=marketDepthDTO.instrumentID){
				// 	existingMarketDepth[1] = MarketWatch.getMarketDepth(marketDepthDTO);
				// }
				// else{
				// 	angular.forEach(existingMarketDepth, function(value, index){
				// 		if(value.instrumentID==marketDepthDTO.instrumentID){
				// 		//	console.log('processing');
				// 			marketDepth = MarketWatch.getMarketDepth(marketDepthDTO);
				// 			existingMarketDepth[index] = marketDepth;
				// 		}
				// 	});
				// }

				if (!existingMarketDepth) {
					existingMarketDepth = [];
				}

				var index = existingMarketDepth.findIndex(function (item) {
					return item.instrumentID === marketDepthDTO.instrumentID;
				});

				if (index !== -1) {
					existingMarketDepth[index] = MarketWatch.getMarketDepth(marketDepthDTO);
				} else {
					existingMarketDepth.push(
						MarketWatch.getMarketDepth(marketDepthDTO)
					);
				}

				//console.log('After processing' + angular.toJson(existingMarketDepth));
				$rootScope.marketDepth = existingMarketDepth;

				getMarketDepthDetailsForReport(existingMarketDepth);

				//get cash and tom market watch
				//getCashAndTomMarketWatch($rootScope.retailSpotMarketWatchMemory, $rootScope.defaultBankSpread);
				if ($rootScope.bankComparativeDTO != null && $rootScope.bankComparativeDTO != undefined
					&& $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList != null
					&& $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList.length > 0) {
					prepareBankComparativeQuotesInPrice($rootScope.bankComparativeDTO, $rootScope.retailSpotMarketWatch);

					//update user market watch list online
					prepareUserMarketWatchOnline();

					//update outright comparison when market depth changes received
					prepareOutrightComparision($rootScope.outrightRateSettlementDate, $rootScope.outrightRateInstrument);
				}

				//set previous ticker price
				var previousTickerPrice = angular.copy($rootScope.tickerPrice);
				$rootScope.previousTickerPrice = previousTickerPrice;
				//get ticker price

				if (marketDepthDTO.baseCurrency !== 'USD') {

					var previousFCYTicker = $rootScope.tickerPriceFCY[marketDepthDTO.sequenceNo];

					var tickerPrice = MarketWatch.getTickerPrice(marketDepthDTO, previousFCYTicker, $rootScope.previousDayClosingPriceForSpot, $rootScope.previousDayClosingPriceForIbSpot);

					$rootScope.tickerPriceFCY[marketDepthDTO.sequenceNo] = tickerPrice;
				}
				else {
					$rootScope.tickerPrice = MarketWatch.getTickerPrice(marketDepthDTO, previousTickerPrice, $rootScope.previousDayClosingPriceForSpot, $rootScope.previousDayClosingPriceForIbSpot);
					;
				}
			}
			else {
				MarketWatch.syncMarketData();
			}
			//else{



			// angular.forEach($rootScope.marketDepth, function (depth) {
			// 	if(depth.baseCurrency!=='USD'){
			// updateRetailSpotMarketWatch(marketDepthDTO);
			//}
			//});



			//$rootScope.marketArray=Array.from($rootScope.marketWatchMap.entries());

			//		}
			//})
			//}, 500)
}

		function marketSettingsChanges(marketSessionSettings) {
			//$rootScope.marketSessionSettingsList = marketSessionSettings;
			setMarketSettings(marketSessionSettings);
		}

		function tacNotificationFeed(object) {
			if (object != null && object != undefined && Number(object.notificationId.substring(1)) > $rootScope.queryServerNotificationLastId) {
				var notification = object.object;
				var dateFromServer = DateUtils.convertLocalDateToServer(notification.enforcingDate);
				var date = $filter('date')(dateFromServer, "dd-MMM-yyyy");
				$rootScope.messageString = "";
				if (notification.tacTypeId == 1) {
					$rootScope.messageString = "Clearcorp has revised the terms & conditions for the customers. Kindly agree it before the enforcing date " + date + " in order to avoid any restrictions in order related activity on the platform." + "<br>" + "Direction: Menus -> Settings -> Terms & Conditions View";
				} else if (notification.tacTypeId == 2) {
					$rootScope.messageString = "Clearcorp has revised the terms & conditions for the member banks. Kindly agree it before the enforcing date " + date + " to avoid any restrictions in approvals of new customers/add bank requests." + "<br>" + "Direction: Menus -> Settings -> Clearcorp's Terms & Conditions View";
				} else {
					$rootScope.messageString = "Your relationship bank " + notification.orgName + " has revised the terms & conditions. Kindly agree it before the enforcing date " + date + " in order to avoid any restrictions in order related activity on the platform with " + notification.orgName + "." + "<br>" + "Direction: Menus -> Settings -> Terms & Conditions View";
				}
				if ($rootScope.userPreference.showInteractiveMsgPopup == null || $rootScope.userPreference.showInteractiveMsgPopup.toLowerCase() == 'yes') {
					$.growl.alert({ title: "Terms & Conditions", message: $rootScope.messageString });
				}
				var msgString = "Terms & Conditions~~" + $rootScope.messageString;
				insertPopupNotifications(msgString, object.notificationId);
			}

		}

		function pendingOrdersFeed(pendingOrder) {

			//get pending orders from feed
			//setTimeout(function(){
			//$scope.$apply(function(){
			var existingPendingOrders = [];
			var pendingOrderIndex = -1;
			if ($rootScope.pendingOrders != null && $rootScope.pendingOrders != undefined) {
				if ($rootScope.pendingOrders.length > 0) {
					existingPendingOrders = angular.copy($rootScope.pendingOrders);
				}
			}
			var merged = false;
			if (pendingOrder != null && pendingOrder != undefined) {
				pendingOrder.expiryTimeString = moment(pendingOrder.expiryTime, 'YYYYMMDDHHmmss').format();
				if (existingPendingOrders != null && existingPendingOrders != undefined) {
					if (existingPendingOrders.length > 0) {
						angular.forEach(existingPendingOrders, function (value, index) {
							//if new order placed, order seq no will be 0 initially before the order confirmed 
							if (value.clientOrderID == pendingOrder.clientOrderID) {
								existingPendingOrders[index] = pendingOrder;
								pendingOrderIndex = index;
								merged = true;
							} else if (value.orderSequenceNumber == pendingOrder.clientOrderID) {
								existingPendingOrders[index] = pendingOrder;
								pendingOrderIndex = index;
								merged = true;
							} else if (value.orderSequenceNumber == pendingOrder.orderSequenceNumber) {
								existingPendingOrders[index] = pendingOrder;
								pendingOrderIndex = index;
								merged = true;
							}
						});
					} else {
						if ($rootScope.bankFilterForPO != null && pendingOrder.bankId == $rootScope.bankFilterForPO.id && $rootScope.branchFilterForPO != null && pendingOrder.branchId == $rootScope.branchFilterForPO.id
							&& $rootScope.customerFilterForPO != null && pendingOrder.customerId == $rootScope.customerFilterForPO.id
						    && $rootScope.currencyPairFilterForPO!=null && $rootScope.currencyPairFilterForPO.code == pendingOrder.currencyPairCode) {
							if ($rootScope.instrumentFilterForPO == null) {
								existingPendingOrders.push(pendingOrder);
								pendingOrderIndex = existingPendingOrders.length - 1;
								merged = true;
							} else if (pendingOrder.retailOrderInstID == $rootScope.instrumentFilterForPO.id) {
								existingPendingOrders.push(pendingOrder);
								pendingOrderIndex = existingPendingOrders.length - 1;
								merged = true;
							}
						}
					}
				}

				if (!merged) {
					if ($rootScope.bankFilterForPO != null && pendingOrder.bankId == $rootScope.bankFilterForPO.id && $rootScope.branchFilterForPO != null && pendingOrder.branchId == $rootScope.branchFilterForPO.id
						&& $rootScope.customerFilterForPO != null && pendingOrder.customerId == $rootScope.customerFilterForPO.id && $rootScope.currencyPairFilterForPO!=null && $rootScope.currencyPairFilterForPO.code == pendingOrder.currencyPairCode) {
						if ($rootScope.instrumentFilterForPO == null) {
							existingPendingOrders.push(pendingOrder);
							pendingOrderIndex = existingPendingOrders.length - 1;
							merged = true;
						} else if (pendingOrder.retailOrderInstID == $rootScope.instrumentFilterForPO.id) {
							existingPendingOrders.push(pendingOrder);
							pendingOrderIndex = existingPendingOrders.length - 1;
							merged = true;
						}
					} else if ($rootScope.bankFilterForPO == null && $rootScope.branchFilterForPO != null && pendingOrder.branchId == $rootScope.branchFilterForPO.id
						&& $rootScope.customerFilterForPO != null && pendingOrder.customerId == $rootScope.customerFilterForPO.id &&  $rootScope.currencyPairFilterForPO!=null && $rootScope.currencyPairFilterForPO.code == pendingOrder.currencyPairCode) {
						if ($rootScope.instrumentFilterForPO == null) {
							existingPendingOrders.push(pendingOrder);
							pendingOrderIndex = existingPendingOrders.length - 1;
							merged = true;
						} else if (pendingOrder.retailOrderInstID == $rootScope.instrumentFilterForPO.id) {
							existingPendingOrders.push(pendingOrder);
							pendingOrderIndex = existingPendingOrders.length - 1;
							merged = true;
						}
					} else if ($rootScope.bankFilterForPO == null && $rootScope.branchFilterForPO == null && $rootScope.customerFilterForPO != null && pendingOrder.customerId == $rootScope.customerFilterForPO.id && $rootScope.currencyPairFilterForPO!=null && $rootScope.currencyPairFilterForPO.code == pendingOrder.currencyPairCode) {
						if ($rootScope.instrumentFilterForPO == null) {
							existingPendingOrders.push(pendingOrder);
							pendingOrderIndex = existingPendingOrders.length - 1;
							merged = true;
						} else if (pendingOrder.retailOrderInstID == $rootScope.instrumentFilterForPO.id) {
							existingPendingOrders.push(pendingOrder);
							pendingOrderIndex = existingPendingOrders.length - 1;
							merged = true;
						}
					} else if ($rootScope.bankFilterForPO == null && $rootScope.branchFilterForPO == null && $rootScope.customerFilterForPO == null && $rootScope.currencyPairFilterForPO!=null && $rootScope.currencyPairFilterForPO.code == pendingOrder.currencyPairCode) {
						if ($rootScope.instrumentFilterForPO == null) {
							existingPendingOrders.push(pendingOrder);
							pendingOrderIndex = existingPendingOrders.length - 1;
							merged = true;
						} else if (pendingOrder.retailOrderInstID == $rootScope.instrumentFilterForPO.id) {
							existingPendingOrders.push(pendingOrder);
							pendingOrderIndex = existingPendingOrders.length - 1;
							merged = true;
						}
					}
					else if ($rootScope.bankFilterForPO == null && $rootScope.branchFilterForPO == null && $rootScope.customerFilterForPO == null && $rootScope.currencyPairFilterForPO==null) {
						if ($rootScope.instrumentFilterForPO == null) {
							existingPendingOrders.push(pendingOrder);
							pendingOrderIndex = existingPendingOrders.length - 1;
							merged = true;
						} else if (pendingOrder.retailOrderInstID == $rootScope.instrumentFilterForPO.id) {
							existingPendingOrders.push(pendingOrder);
							pendingOrderIndex = existingPendingOrders.length - 1;
							merged = true;
						}
					}
				}
			}

			if (merged) {
				if (existingPendingOrders != null && existingPendingOrders != undefined && existingPendingOrders.length > 0) {
					var orderStatus = $filter('filter')($rootScope.orderStatusList, { id: existingPendingOrders[pendingOrderIndex].orderStatusId });
					var eventType = $filter('filter')($rootScope.eventTypes, { id: existingPendingOrders[pendingOrderIndex].eventTypeId });
					existingPendingOrders[pendingOrderIndex].orderStatus = orderStatus[0].name;
					existingPendingOrders[pendingOrderIndex].eventTypeName = eventType[0].name;
					if (orderStatus[0].name == 'Cancelled' || orderStatus[0].name == 'Traded' || orderStatus[0].name == 'Filled'
						|| orderStatus[0].name == 'Rejected' || orderStatus[0].name == 'Rejected By RMS' || orderStatus[0].name == 'Cancelled By RMS') {
						existingPendingOrders.splice(pendingOrderIndex, 1);
					}
				}
			}

			$rootScope.pendingOrders = existingPendingOrders;
			//            	setTimeout(function(){$scope.$apply(function(){$rootScope.pendingOrdersMemory = existingPendingOrders;})});
			//})
			//}, 500)


		}

		//update limits from the feed 
		function limitUpdateFeed(limit) {
			//setTimeout(function(){
			//$scope.$apply(function(){
			var existinglimit = [];
			var merged = false;
			if ($rootScope.limitsAvailableForSelectedInstrument != null && $rootScope.limitsAvailableForSelectedInstrument != undefined) {
				if ($rootScope.limitsAvailableForSelectedInstrument.length > 0) {
					if (limit.instrumentName != 'ALL') {
						angular.forEach($rootScope.limitsAvailableForSelectedInstrument, function (limitvalue, limitindex) {
							if (limitvalue.instrumentName == 'ALL') {
								$rootScope.limitsAvailableForSelectedInstrument.splice(limitindex, 1);
							}
						})
						if (limit.instrumentName == 'SPOT' || limit.instrumentName == 'CASH' || limit.instrumentName == 'TOM') {
							angular.forEach($rootScope.limitsAvailableForSelectedInstrument, function (limitvalue1, limitindex1) {
								if (limitvalue1.instrumentName == 'Upto SPOT') {
									$rootScope.limitsAvailableForSelectedInstrument.splice(limitindex1, 1);
								}
							})
						}
						if (limit.instrumentName == 'Upto SPOT') {
							angular.forEach($rootScope.limitsAvailableForSelectedInstrument, function (limitvalue2, limitindex2) {
								if (limitvalue2.instrumentName == 'SPOT') {
									$rootScope.limitsAvailableForSelectedInstrument.splice(limitindex2, 1);
								}
							})
							angular.forEach($rootScope.limitsAvailableForSelectedInstrument, function (limitvalue3, limitindex3) {
								if (limitvalue3.instrumentName == 'TOM') {
									$rootScope.limitsAvailableForSelectedInstrument.splice(limitindex3, 1);
								}
							})
							angular.forEach($rootScope.limitsAvailableForSelectedInstrument, function (limitvalue4, limitindex4) {
								if (limitvalue4.instrumentName == 'CASH') {
									$rootScope.limitsAvailableForSelectedInstrument.splice(limitindex4, 1);
								}
							})
						}

						existinglimit = $rootScope.limitsAvailableForSelectedInstrument;
					}

				}
			}
			if (limit != null && limit != undefined) {
				if (existinglimit != null && existinglimit != undefined && existinglimit.length > 0) {
					//if(existinglimit.length>0){
					angular.forEach(existinglimit, function (value, index) {
						//if new order placed, order seq no will be 0 initially before the order confirmed 
						if (value.bankId == limit.bankId && value.branchId == limit.branchId && value.customerId == limit.customerId && (value.instId == limit.instId || value.instId == null)) {
							if (limit.active == true) {
								existinglimit[index] = limit;
								merged = true;
								//getLimitsForEachInstrument(limit);
							} else if (limit.active == false) {
								existinglimit.splice(index, 1);
								merged = true;
								fillZeroIfLimitIsNotDefinedForInstrumentCode(limit.instrumentCode);
							}
						}
					});
					//}
				} else {
					if ($rootScope.instrumentFilterForLimit == null || $rootScope.instrumentFilterForLimit == undefined) {
						existinglimit.push(limit);
						merged = true;
					} else if ($rootScope.instrumentFilterForLimit.id == limit.instId || limit.instId == 0) {
						merged = true;
						existinglimit.push(limit);
					}
				}
				if (!merged) {
					if ($rootScope.instrumentFilterForLimit == null || $rootScope.instrumentFilterForLimit == undefined) {
						existinglimit.push(limit);
						merged = true;
					} else if ($rootScope.instrumentFilterForLimit.id == limit.instId || limit.instId == 0) {
						merged = true;
						existinglimit.push(limit);
					}
				}
				if ($rootScope.defaultTradingBank != null && $rootScope.defaultTradingBank.id == limit.bankId && limit.active == true) {
					//if reset action type is spot window, then clear existing limits on forward
					if (limit.resetActionType == 'SPOTWINDOW') {
						fillZeroIfLimitIsNotDefinedForInstrumentCode('Forward');
					} else if (limit.resetActionType == 'FORWARD') {
						//if reset action type is forward, then clear existing limits on SPOT window
						fillZeroIfLimitIsNotDefinedForInstrumentCode('SPOT');
						fillZeroIfLimitIsNotDefinedForInstrumentCode('TOM');
						fillZeroIfLimitIsNotDefinedForInstrumentCode('CASH');
					}
					getLimitsForEachInstrument(limit);
				} else if ($rootScope.defaultTradingBank != null && $rootScope.defaultTradingBank.id == limit.bankId && limit.active == false) {
					fillZeroIfLimitIsNotDefinedForInstrumentCode(limit.instrumentCode);
				}

				if ($rootScope.account.organisation.organisationType.shortName == 'CUSTOMER'
					&& $rootScope.account.organisation.id == limit.customerId
					&& $rootScope.bankFilterForLimit.id == limit.bankId && limit.active == true) {
					$rootScope.limitAvailableForSlectBankFilterInReport = true;
				} else if ($rootScope.account.organisation.organisationType.shortName == 'CUSTOMER'
					&& $rootScope.account.organisation.id == limit.customerId
					&& $rootScope.bankFilterForLimit.id == limit.bankId && limit.active == false) {
					$rootScope.limitAvailableForSlectBankFilterInReport = false;
				}
			}

			angular.forEach(existinglimit, function (limit, index) {
				if (limit.active == false) {
					existinglimit.splice(index, 1);
					fillZeroIfLimitIsNotDefinedForInstrumentCode(limit.instrumentCode);
				}
			})

			//            	setTimeout(function(){$scope.$apply(function(){$rootScope.limitsAvailableForSelectedInstrumentMemory = existinglimit;})});
			$rootScope.limitsAvailableForSelectedInstrument = existinglimit;


			//apply credit factor
			var creditFactor = MarketWatch.getCreditFactorValue($rootScope.defaultInstrumentCode, angular.copy($rootScope.tradeSettlementDate), $rootScope.selectedCreditFactor, GlobalValues.getConfigSettings().defaultCreditFactorSettingsInPercentage);
			$rootScope.forwardBuyLimitWithCF = MarketWatch.computeLimitAmountApplyingCreditFactor(angular.copy($rootScope.forwardBuyLimit), creditFactor);
			$rootScope.forwardSellLimitWithCF = MarketWatch.computeLimitAmountApplyingCreditFactor(angular.copy($rootScope.forwardSellLimit), creditFactor);

			//});
			//}, 500)
		}

		function fillZeroIfLimitIsNotDefinedForInstrumentCode(instrumentCode) {
			if (instrumentCode == 'SPOT') {
				$rootScope.retailSpotBuyLimit = 0;
				$rootScope.retailSpotSellLimit = 0;
			} else if (instrumentCode == 'CASH') {
				$rootScope.cashBuyLimit = 0;
				$rootScope.cashSellLimit = 0;
			} else if (instrumentCode == 'TOM') {
				$rootScope.tomBuyLimit = 0;
				$rootScope.tomSellLimit = 0;
			} else if (instrumentCode == 'UptoSPOT') {
				$rootScope.retailSpotBuyLimit = 0;
				$rootScope.retailSpotSellLimit = 0;
				$rootScope.cashBuyLimit = 0;
				$rootScope.cashSellLimit = 0;
				$rootScope.tomBuyLimit = 0;
				$rootScope.tomSellLimit = 0;
			} else if (instrumentCode == 'Forward') {
				$rootScope.forwardBuyLimit = 0;
				$rootScope.forwardSellLimit = 0;
				$rootScope.forwardBuyLimitWithCF = 0;
				$rootScope.forwardSellLimitWithCF = 0;
				$rootScope.maxForwardTenorDate = null;
			} else if (instrumentCode == 'ALL' || instrumentCode == null || instrumentCode == undefined) {
				$rootScope.retailSpotBuyLimit = 0;
				$rootScope.retailSpotSellLimit = 0;
				$rootScope.cashBuyLimit = 0;
				$rootScope.cashSellLimit = 0;
				$rootScope.tomBuyLimit = 0;
				$rootScope.tomSellLimit = 0;
				$rootScope.forwardBuyLimit = 0;
				$rootScope.forwardSellLimit = 0;
				$rootScope.forwardBuyLimitWithCF = 0;
				$rootScope.forwardSellLimitWithCF = 0;
				$rootScope.maxForwardTenorDate = null;
			}
		}


		//trade notificatoins handling
		function tradeNotificationHandling(trade) {
			//setTimeout(function(){
			//$scope.$apply(function(){
			//get trades from feed
			var existingTrades = [];
			if ($rootScope.trades != null && $rootScope.trades != undefined) {
				if ($rootScope.trades.length > 0) {
					existingTrades = $rootScope.trades;
				}
			}
			var merged = false;
			if (trade != null && trade != undefined) {
				var eventType = $filter('filter')($rootScope.eventTypes, { id: trade.eventTypeId });
				trade.eventTypeName = eventType[0].name;
				trade.tradeTime = moment(trade.tradeTime, 'YYYYMMDDHHmmss.SSSSSSSSS').format();
				if ($rootScope.bankFilterForTrade != null && trade.bankId == $rootScope.bankFilterForTrade.id && $rootScope.branchFilterForTrade != null && trade.branchId == $rootScope.branchFilterForTrade.id
					&& $rootScope.customerFilterForTrade != null && trade.customerId == $rootScope.customerFilterForTrade.id && $rootScope.currencyPairFilterForTrade!=null && $rootScope.currencyPairFilterForTrade.code == trade.currencyPair) {
					if ($rootScope.instrumentFilterForTrade == null) {
						existingTrades.push(trade);
					} else if (trade.retailOrderInstId == $rootScope.instrumentFilterForTrade.id) {
						existingTrades.push(trade);
					}
				} else if ($rootScope.bankFilterForTrade == null && $rootScope.branchFilterForTrade != null && trade.branchId == $rootScope.branchFilterForTrade.id
					&& $rootScope.customerFilterForTrade != null && trade.customerId == $rootScope.customerFilterForTrade.id && $rootScope.currencyPairFilterForTrade!=null && $rootScope.currencyPairFilterForTrade.code == trade.currencyPair) {
					if ($rootScope.instrumentFilterForTrade == null) {
						existingTrades.push(trade);
					} else if (trade.retailOrderInstId == $rootScope.instrumentFilterForTrade.id) {
						existingTrades.push(trade);
					}
				} else if ($rootScope.bankFilterForTrade == null && $rootScope.branchFilterForTrade == null && $rootScope.customerFilterForTrade != null && trade.customerId == $rootScope.customerFilterForTrade.id && $rootScope.currencyPairFilterForTrade!=null && $rootScope.currencyPairFilterForTrade.code == trade.currencyPair) {
					if ($rootScope.instrumentFilterForTrade == null) {
						existingTrades.push(trade);
					} else if (trade.retailOrderInstId == $rootScope.instrumentFilterForTrade.id) {
						existingTrades.push(trade);
					}
				}
				else if ($rootScope.bankFilterForTrade == null && $rootScope.branchFilterForTrade == null && $rootScope.customerFilterForTrade == null && $rootScope.currencyPairFilterForTrade!=null && $rootScope.currencyPairFilterForTrade.code == trade.currencyPair) {
					if ($rootScope.instrumentFilterForTrade == null) {
						existingTrades.push(trade);
					} else if (trade.retailOrderInstId == $rootScope.instrumentFilterForTrade.id) {
						existingTrades.push(trade);
					}
				}
				 else if ($rootScope.bankFilterForTrade == null && $rootScope.branchFilterForTrade == null && $rootScope.customerFilterForTrade == null && $rootScope.currencyPairFilterForTrade==null) {
					if ($rootScope.instrumentFilterForTrade == null) {
						existingTrades.push(trade);
					} else if (trade.retailOrderInstId == $rootScope.instrumentFilterForTrade.id) {
						existingTrades.push(trade);
					}
				}
			}

			var summaryBuyTrades = existingTrades.filter(function (val) {
				return val.buySellIndicator == "BUYY";
			})

			var summarySellTrades = existingTrades.filter(function (val) {
				return val.buySellIndicator == "SELL";
			})

			var totalUSDBought = summaryBuyTrades.reduce(function (a, b) { return a + b.tradedAmount; }, 0);
			var totalUSDSold = summarySellTrades.reduce(function (a, b) { return a + b.tradedAmount; }, 0);
			var totalINRSold = summaryBuyTrades.reduce(function (a, b) { return a + b.tradedValue; }, 0);
			var totalINRBought = summarySellTrades.reduce(function (a, b) { return a + b.tradedValue; }, 0);

			$rootScope.trades = existingTrades;
			//                setTimeout(function(){$scope.$apply(function(){$rootScope.tradesMemory = existingTrades;})});
			//});
			//}, 500)

			if ($rootScope.instrumentFilterForTrade != null) {
				$rootScope.totalUSDBought = totalUSDBought;
				$rootScope.totalUSDSold = totalUSDSold;
				$rootScope.totalINRSold = totalINRSold;
				$rootScope.totalINRBought = totalINRBought;
				$rootScope.weightedAverageBuy = Math.abs(totalINRSold / totalUSDBought);
				$rootScope.weightedAverageSell = Math.abs(totalINRBought / totalUSDSold);
				$rootScope.usdNet = totalUSDBought - totalUSDSold;
				$rootScope.inrNet = totalINRBought - totalINRSold;
				$rootScope.netWeightedAveragePrice = Math.abs((totalINRBought - totalINRSold) / (totalUSDBought - totalUSDSold));

				if (isNaN(Math.abs(totalINRSold / totalUSDBought)) || Math.abs(totalINRSold / totalUSDBought) == Infinity)
					$rootScope.weightedAverageBuy = null;
				if (isNaN(Math.abs((totalINRBought - totalINRSold) / (totalUSDBought - totalUSDSold))) ||
					(Math.abs((totalINRBought - totalINRSold) / (totalUSDBought - totalUSDSold))) == Infinity)
					$rootScope.netWeightedAveragePrice = null;

				if (isNaN(Math.abs(totalINRBought / totalUSDSold)) || Math.abs(totalINRBought / totalUSDSold) == Infinity)
					$rootScope.weightedAverageSell = null;
			} else {
				$rootScope.totalUSDBought = null;
				$rootScope.totalUSDSold = null;
				$rootScope.totalINRSold = null;
				$rootScope.totalINRBought = null;
				$rootScope.weightedAverageBuy = null;
				$rootScope.weightedAverageSell = null;
				$rootScope.usdNet = null;
				$rootScope.inrNet = null;
				$rootScope.netWeightedAveragePrice = null;
			}

		}

		function tacAgreedChange(tacAgreed) {
			console.log("tacAgreedChange");
			angular.forEach($rootScope.agreedTACList, function (value) {
				if (tacAgreed.tacMasterOrgId == value.providerId) {
					value.isAgreed = true;
				}
			})
		}

		function swapQuoteChanges(swapQuote) {
			//var existingQuotes = $rootScope.bankComparativeQuotes;
			angular.forEach($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, function (value, index) {
				if (value.bank.bankName == swapQuote.bank.bankName) {
					var swapQuotesTenorDateDTO = angular.copy($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList[index]);

					angular.forEach(swapQuote.swapQuotesForTenorDatesList, function (quote) {
						angular.forEach(swapQuotesTenorDateDTO.swapQuotesForTenorDatesList, function (existingQuote, existingQuoteIndex) {
							if (quote.tenorName == existingQuote.tenorName) {
								swapQuotesTenorDateDTO.swapQuotesForTenorDatesList[existingQuoteIndex] = quote;
							}
						})
					})
					$rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList[index] = swapQuotesTenorDateDTO;
					//change swap quotes in home page
					prepareSwapQuotes();

				}
			})
			//$rootScope.bankComparativeQuotes = existingQuotes;
		}

		function markupChange(markup) {
			var merged = false;
			var existingMarkup = [];
			if ($rootScope.markupSettings != null && $rootScope.markupSettings != undefined) {
				if ($rootScope.markupSettings.length > 0) {
					existingMarkup = angular.copy($rootScope.markupSettings);
				}
			}
			if (existingMarkup != null && existingMarkup != undefined) {
				if (existingMarkup.length > 0) {
					angular.forEach(existingMarkup, function (value, index) {
						if (value.bankId == markup.bankId && value.customerId == markup.customerId) {
							existingMarkup[index] = markup;
							merged = true;
						}
					});
				}
			}

			if (!merged && $rootScope.account.organisation.organisationType.shortName == 'CUSTOMER' && markup.customerId == $rootScope.account.organisation.id) {
				existingMarkup.push(markup);
				merged = true;
			}

			$rootScope.markupSettings = existingMarkup;
		}

		function tradeOutstandingUpdate(outstandingTrade) {

			var existingOutstandingTrades = [];
			var tradeOutstanidngIndex = -1;
			var fromSettDate = null;
			var toSettDate = null;

			//if the from date is null then provide the minimum possible date , else send the selected date 
			if ($rootScope.fromSettlementDate == null && $rootScope.fromSettlementDate == undefined) {
				fromSettDate = new Date(1900, 0, 1);
			} else {
				fromSettDate = $rootScope.fromSettlementDate;
			}

			// if to date is null then provide the maximum possible date , else send the selected date 
			if ($rootScope.toSettlementDate == null && $rootScope.toSettlementDate == undefined) {
				toSettDate = new Date(9999, 11, 31);
			} else {
				toSettDate = $rootScope.toSettlementDate;
			}
			fromSettDate = DateUtils.convertLocalDateToServer(fromSettDate);
			toSettDate = DateUtils.convertLocalDateToServer(toSettDate);

			if ($rootScope.outstandingTrades != null && $rootScope.outstandingTrades != undefined) {
				if ($rootScope.outstandingTrades.length > 0) {
					existingOutstandingTrades = angular.copy($rootScope.outstandingTrades);
				}
			}
			var merged = false;
			if (outstandingTrade != null && outstandingTrade != undefined) {
				outstandingTrade.tradeTime = moment(outstandingTrade.tradeTime, 'YYYYMMDDHHmmss.SSSSSSSSS').format();
				if (existingOutstandingTrades != null && existingOutstandingTrades != undefined) {
					if (existingOutstandingTrades.length > 0) {
						angular.forEach(existingOutstandingTrades, function (value, index) {
							if (outstandingTrade.orderSequenceNumber != null && outstandingTrade.tradeSequenceNumber != undefined) {
								if (value.orderSequenceNumber == outstandingTrade.orderSequenceNumber &&
									value.tradeSequenceNumber == outstandingTrade.tradeSequenceNumber) {
									existingOutstandingTrades[index] = outstandingTrade;
									tradeOutstanidngIndex = index;
									merged = true;
								}
							}
						});
					} else {
						if ($rootScope.bankFilterForOT != null && outstandingTrade.bankId == $rootScope.bankFilterForOT.id && $rootScope.branchFilterForOT != null && outstandingTrade.branchId == $rootScope.branchFilterForOT.id
							&& $rootScope.customerFilterForOT != null && outstandingTrade.customerId == $rootScope.customerFilterForOT.id
							&& outstandingTrade.tradeSettlementDate >= fromSettDate && outstandingTrade.tradeSettlementDate <= toSettDate
							&& $rootScope.currencyPairFilterForOT!=null && $rootScope.currencyPairFilterForOT.code == outstandingTrade.currencyPair) {
							if ($rootScope.instrumentFilterForOT == null) {
								existingOutstandingTrades.push(outstandingTrade);
								tradeOutstanidngIndex = existingOutstandingTrades.length - 1;
								merged = true;
							} else if (outstandingTrade.retailOrderInstID == $rootScope.instrumentFilterForOT.id) {
								existingOutstandingTrades.push(outstandingTrade);
								tradeOutstanidngIndex = existingOutstandingTrades.length - 1;
								merged = true;
							}
						}
					}
				}

				if (!merged) {
					if ($rootScope.bankFilterForOT != null && outstandingTrade.bankId == $rootScope.bankFilterForOT.id && $rootScope.branchFilterForOT != null && outstandingTrade.branchId == $rootScope.branchFilterForOT.id
						&& $rootScope.customerFilterForOT != null && outstandingTrade.customerId == $rootScope.customerFilterForOT.id
						&& outstandingTrade.tradeSettlementDate >= fromSettDate && outstandingTrade.tradeSettlementDate <= toSettDate && $rootScope.currencyPairFilterForOT!=null && $rootScope.currencyPairFilterForOT.code == outstandingTrade.currencyPair) {
						if ($rootScope.instrumentFilterForOT == null) {
							existingOutstandingTrades.push(outstandingTrade);
							tradeOutstanidngIndex = existingOutstandingTrades.length - 1;
							merged = true;
						} else if (outstandingTrade.retailOrderInstId == $rootScope.instrumentFilterForOT.id) {
							existingOutstandingTrades.push(outstandingTrade);
							tradeOutstanidngIndex = existingOutstandingTrades.length - 1;
							merged = true;
						}
					} else if ($rootScope.bankFilterForOT == null && $rootScope.branchFilterForOT != null && outstandingTrade.branchId == $rootScope.branchFilterForOT.id
						&& $rootScope.customerFilterForOT != null && outstandingTrade.customerId == $rootScope.customerFilterForOT.id
						&& outstandingTrade.tradeSettlementDate >= fromSettDate && outstandingTrade.tradeSettlementDate <= toSettDate && $rootScope.currencyPairFilterForOT!=null && $rootScope.currencyPairFilterForOT.code == outstandingTrade.currencyPair) {
						if ($rootScope.instrumentFilterForOT == null) {
							existingOutstandingTrades.push(outstandingTrade);
							tradeOutstanidngIndex = existingOutstandingTrades.length - 1;
							merged = true;
						} else if (outstandingTrade.retailOrderInstId == $rootScope.instrumentFilterForOT.id) {
							existingOutstandingTrades.push(outstandingTrade);
							tradeOutstanidngIndex = existingOutstandingTrades.length - 1;
							merged = true;
						}
					} else if ($rootScope.bankFilterForOT == null && $rootScope.branchFilterForOT == null && $rootScope.customerFilterForOT != null && outstandingTrade.customerId == $rootScope.customerFilterForOT.id
						&& outstandingTrade.tradeSettlementDate >= fromSettDate && outstandingTrade.tradeSettlementDate <= toSettDate && $rootScope.currencyPairFilterForOT!=null && $rootScope.currencyPairFilterForOT.code == outstandingTrade.currencyPair) {
						if ($rootScope.instrumentFilterForOT == null) {
							existingOutstandingTrades.push(outstandingTrade);
							tradeOutstanidngIndex = existingOutstandingTrades.length - 1;
							merged = true;
						} else if (outstandingTrade.retailOrderInstId == $rootScope.instrumentFilterForOT.id) {
							existingOutstandingTrades.push(outstandingTrade);
							tradeOutstanidngIndex = existingOutstandingTrades.length - 1;
							merged = true;
						}
					} else if ($rootScope.bankFilterForOT == null && $rootScope.branchFilterForOT == null && $rootScope.customerFilterForOT == null
						&& outstandingTrade.tradeSettlementDate >= fromSettDate && outstandingTrade.tradeSettlementDate <= toSettDate && $rootScope.currencyPairFilterForOT!=null && $rootScope.currencyPairFilterForOT.code == outstandingTrade.currencyPair) {
						if ($rootScope.instrumentFilterForOT == null) {
							existingOutstandingTrades.push(outstandingTrade);
							tradeOutstanidngIndex = existingOutstandingTrades.length - 1;
							merged = true;
						} else if (outstandingTrade.retailOrderInstId == $rootScope.instrumentFilterForOT.id) {
							existingOutstandingTrades.push(outstandingTrade);
							tradeOutstanidngIndex = existingOutstandingTrades.length - 1;
							merged = true;
						}
					}
					else if ($rootScope.bankFilterForOT == null && $rootScope.branchFilterForOT == null && $rootScope.customerFilterForOT == null
						&& outstandingTrade.tradeSettlementDate >= fromSettDate && outstandingTrade.tradeSettlementDate <= toSettDate && $rootScope.currencyPairFilterForOT==null) {
						if ($rootScope.instrumentFilterForOT == null) {
							existingOutstandingTrades.push(outstandingTrade);
							tradeOutstanidngIndex = existingOutstandingTrades.length - 1;
							merged = true;
						} else if (outstandingTrade.retailOrderInstId == $rootScope.instrumentFilterForOT.id) {
							existingOutstandingTrades.push(outstandingTrade);
							tradeOutstanidngIndex = existingOutstandingTrades.length - 1;
							merged = true;
						}
					}
				}
			}

			if (merged) {
				if (existingOutstandingTrades != null && existingOutstandingTrades != undefined && existingOutstandingTrades.length > 0) {
					var orderStatus = $filter('filter')($rootScope.orderStatusList, { id: existingOutstandingTrades[tradeOutstanidngIndex].orderStatusId });
					var eventType = $filter('filter')($rootScope.eventTypes, { id: existingOutstandingTrades[tradeOutstanidngIndex].eventTypeId });
					var tradeStatus = $filter('filter')($rootScope.tradeStatusList, { id: existingOutstandingTrades[tradeOutstanidngIndex].tradeStatusId });
					existingOutstandingTrades[tradeOutstanidngIndex].eventTypeName = eventType[0].name;
					existingOutstandingTrades[tradeOutstanidngIndex].orderStatus = orderStatus[0].name;
					existingOutstandingTrades[tradeOutstanidngIndex].tradeStatusName = tradeStatus[0].name;
					if (existingOutstandingTrades[tradeOutstanidngIndex].outStandingAmount <= 0) {
						existingOutstandingTrades.splice(tradeOutstanidngIndex, 1);
					}
				}
			}

			$rootScope.outstandingTrades = existingOutstandingTrades;

		}

		function getLimitsForEachInstrument(limit) {
			$rootScope.limitType = limit.limitType;
			$rootScope.limitNotDefined = false;
			if (limit.instrumentCode == 'SPOT') {
				$rootScope.retailSpotBuyLimit = getBuyingPower(limit);
				$rootScope.retailSpotSellLimit = getSellingPower(limit);
			} else if (limit.instrumentCode == 'CASH') {
				$rootScope.cashBuyLimit = getBuyingPower(limit);
				$rootScope.cashSellLimit = getSellingPower(limit);
			} else if (limit.instrumentCode == 'TOM') {
				$rootScope.tomBuyLimit = getBuyingPower(limit);
				$rootScope.tomSellLimit = getSellingPower(limit);
			} else if (limit.instrumentCode == 'Forward') {
				$rootScope.forwardBuyLimit = getBuyingPower(limit);
				$rootScope.forwardSellLimit = getSellingPower(limit);
				$rootScope.maxForwardTenorDate = MarketWatch.getMaxForwardTenorDate(limit, new Date($rootScope.retailSpotMarketSession.settlementDate));
			}

			if (limit.instrumentCode == 'ALL' || $rootScope.limitInstrumentCode == 'ALL' || limit.instrumentCode == null) {
				var buyingPower = getBuyingPower(limit);
				var sellingPower = getSellingPower(limit);
				$rootScope.retailSpotBuyLimit = buyingPower;
				$rootScope.retailSpotSellLimit = sellingPower;
				$rootScope.tomBuyLimit = buyingPower;
				$rootScope.tomSellLimit = sellingPower;
				$rootScope.cashBuyLimit = buyingPower;
				$rootScope.cashSellLimit = sellingPower;
				$rootScope.forwardBuyLimit = buyingPower;
				$rootScope.forwardSellLimit = sellingPower;
				$rootScope.maxForwardTenorDate = MarketWatch.getMaxForwardTenorDate(limit, new Date($rootScope.retailSpotMarketSession.settlementDate));
			}
			if (limit.instrumentCode == 'UptoSPOT') {
				var buyingPower = getBuyingPower(limit);
				var sellingPower = getSellingPower(limit);
				$rootScope.retailSpotBuyLimit = buyingPower;
				$rootScope.retailSpotSellLimit = sellingPower;
				$rootScope.tomBuyLimit = buyingPower;
				$rootScope.tomSellLimit = sellingPower;
				$rootScope.cashBuyLimit = buyingPower;
				$rootScope.cashSellLimit = sellingPower;
			}
			if ($rootScope.account.organisation.organisationType.shortName == 'CUSTOMER') {
				fillLimitsInMarketWatch();
			}
		}

		function getBuyingPower(limit) {
			var buyingPower = 0;
			var totalBuy = limit.totalPendingBuyOrderValue + limit.totalBuyTradeValue + limit.previousDayBuyTradeValue;
			var totalSell = limit.totalPendingSellOrderValue + limit.totalSellTradeValue + limit.previousDaySellTradeValue;
            var limitAllocated = 0;
			if(limit.currencyPair != 'USDINR'){
              limitAllocated = limit.limitAllocatedInFCY;
            }else{
              limitAllocated =  limit.limitAllocatedInUSD
            }
			if (limit.limitType == 'GROSSSELL') {
				buyingPower = 0;
			} else if (limit.limitType == 'GROSSBUY') {
				buyingPower = limitAllocated - (totalBuy);
			} else if (limit.limitType == 'GLOBALGROSS') {
				buyingPower = limitAllocated - (totalBuy + totalSell);
			} else if (limit.limitType == 'NET') {
				totalBuy = limit.totalPendingBuyOrderValue + ((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue));
				totalSell = limit.totalPendingSellOrderValue + ((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue));
				var xVals = [];
				xVals.push(totalBuy);
				xVals.push(totalSell);
				buyingPower = limitAllocated - totalBuy;
			}
			buyingPower = (Math.round(parseFloat(buyingPower) * 100) / 100);
			return buyingPower;
		}

		function getSellingPower(limit) {
			var sellingPower = 0;
			var totalBuy = limit.totalPendingBuyOrderValue + (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue);
			var totalSell = limit.totalPendingSellOrderValue + (limit.totalSellTradeValue + limit.previousDaySellTradeValue);
            var limitAllocated = 0;
			if(limit.currencyPair != 'USDINR'){
              limitAllocated = limit.limitAllocatedInFCY;
            }else{
              limitAllocated =  limit.limitAllocatedInUSD
            }

			if (limit.limitType == 'GROSSSELL') {
				sellingPower = limitAllocated - (totalSell);
			} else if (limit.limitType == 'GROSSBUY') {
				sellingPower = 0;
			} else if (limit.limitType == 'GLOBALGROSS') {
				sellingPower = limitAllocated - (totalBuy + totalSell);
			} else if (limit.limitType == 'NET') {
				totalBuy = limit.totalPendingBuyOrderValue + ((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue));
				totalSell = limit.totalPendingSellOrderValue + ((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue));
				var xVals = [];
				xVals.push(totalBuy);
				xVals.push(totalSell);
				sellingPower = limitAllocated - totalSell;
			}
			sellingPower = (Math.round(parseFloat(sellingPower) * 100) / 100);
			return sellingPower;
		}

		function fillLimitsInMarketWatch() {
			$rootScope.retailSpotBuyLimitForMkt = $rootScope.retailSpotBuyLimit;
			$rootScope.retailSpotSellLimitForMkt = $rootScope.retailSpotSellLimit;
			$rootScope.tomBuyLimitForMkt = $rootScope.tomBuyLimit;
			$rootScope.tomSellLimitForMkt = $rootScope.tomSellLimit;
			$rootScope.cashBuyLimitForMkt = $rootScope.cashBuyLimit;
			$rootScope.cashSellLimitForMkt = $rootScope.cashSellLimit;
			$rootScope.forwardBuyLimitForMkt = $rootScope.forwardBuyLimit;
			$rootScope.forwardSellLimitForMkt = $rootScope.forwardSellLimit;
		}

		function prepareSwapQuotes() {
			//get best offer and bid spread for Cash/spot and tom/spot, frwd/spot.
			getBestSpreadRates($rootScope.bankComparativeDTO);

			//if($rootScope.defaultTab=='comparitive_tab2' || $rootScope.defaultTab=='comparitive_tab4'){
			//prepare bank comparativeQuotes in price
			prepareBankComparativeQuotesInPrice($rootScope.bankComparativeDTO, $rootScope.retailSpotMarketWatch);
			//}


			if ($rootScope.bankComparativeDTO != null && $rootScope.bankComparativeDTO != undefined
				&& $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList != null
				&& $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList.length == 1) {
				$rootScope.defaultBankSpread = $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList[0].swapQuotesForTenorDatesList;
			} else {
				// get default bank swap quotes for the customer user
				console.log('prepare swap quotes in home controller');
				console.log($rootScope.defaultTradingBank);
				if ($rootScope.defaultTradingBank != null && $rootScope.defaultTradingBank != undefined) {
					$rootScope.defaultBankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, $rootScope.defaultTradingBank.id);
				}
			}

			//update user market watch online
			prepareUserMarketWatchOnline();

			//update outright comparison when swap quote changes received
			prepareOutrightComparision($rootScope.outrightRateSettlementDate, $rootScope.outrightRateInstrument);
		}

		function prepareBankComparativeQuotesInPrice(bankComparativeDTO, retailSpotMarketWatch) {
			$rootScope.bankComparativeDTOInPrice = {};
			$rootScope.bankComparativeDTOInPrice.header = bankComparativeDTO.header;
			$rootScope.bankComparativeDTOInPrice.swapQuotesTenorDateDTOList = [];
			angular.forEach(bankComparativeDTO.swapQuotesTenorDateDTOList, function (swapQuotesTenorDateDTO) {
				var swapQuotesTenorDateDTOInPrice = {};
				swapQuotesTenorDateDTOInPrice.bank = swapQuotesTenorDateDTO.bank;
				swapQuotesTenorDateDTOInPrice.businessDate = swapQuotesTenorDateDTO.businessDate;
				swapQuotesTenorDateDTOInPrice.swapQuotesForTenorDatesList = [];
				angular.forEach(swapQuotesTenorDateDTO.swapQuotesForTenorDatesList, function (swapQuotesForTenorDates) {
					var swapQuotesForTenorDatesInPrice = {};
					swapQuotesForTenorDatesInPrice = angular.copy(swapQuotesForTenorDates);
					// prepare bank quotes in price
					swapQuotesForTenorDatesInPrice = MarketWatch.getBankSwapQuotesInPrice(swapQuotesForTenorDatesInPrice, retailSpotMarketWatch);
					swapQuotesTenorDateDTOInPrice.swapQuotesForTenorDatesList.push(swapQuotesForTenorDatesInPrice)
				})
				$rootScope.bankComparativeDTOInPrice.swapQuotesTenorDateDTOList.push(swapQuotesTenorDateDTOInPrice);
			})

		}

		function getBestSpreadRates(bankComparativeDTO) {

			if (bankComparativeDTO != null && bankComparativeDTO != undefined && bankComparativeDTO.swapQuotesTenorDateDTOList != null
				&& bankComparativeDTO.swapQuotesTenorDateDTOList.length > 0) {
				var swapQuotesForTenorDatesList = [];
				angular.forEach(bankComparativeDTO.swapQuotesTenorDateDTOList, function (swapQuotesTenorDateDTO) {
					swapQuotesForTenorDatesList = swapQuotesForTenorDatesList.concat(swapQuotesTenorDateDTO.swapQuotesForTenorDatesList);
				})

				$rootScope.bestBankQuoteList = [];
				angular.forEach(bankComparativeDTO.header, function (header) {
					var bestBankQuote = {};
					bestBankQuote.tenorName = header;
					var bankQuotesForTenorForBid = _.filter(angular.copy(swapQuotesForTenorDatesList), { 'tenorName': header });
					var bankQuotesForTenorForOffer = _.filter(angular.copy(swapQuotesForTenorDatesList), { 'tenorName': header });
					bestBankQuote.bestBidSpread = Math.max.apply(Math, bankQuotesForTenorForBid.map(function (item) { return item.bidSpread; }).filter(function (val) { return val !== null }));
					bestBankQuote.bestOfferSpread = Math.min.apply(Math, bankQuotesForTenorForOffer.map(function (item) { return item.offerSpread; }).filter(function (val) { return val !== null }));
					$rootScope.bestBankQuoteList.push(bestBankQuote);
				})
			}

			angular.forEach($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, function (swapQuotesTenorDateDTO) {
				angular.forEach(swapQuotesTenorDateDTO.swapQuotesForTenorDatesList, function (swapQuotesForTenorDates) {
					swapQuotesForTenorDates.isBestBid = false;
					swapQuotesForTenorDates.isBestOffer = false;
					angular.forEach($rootScope.bestBankQuoteList, function (bestBankQuote) {
						if (swapQuotesForTenorDates.tenorName == bestBankQuote.tenorName) {
							if (swapQuotesForTenorDates.bidSpread == bestBankQuote.bestBidSpread) {
								swapQuotesForTenorDates.isBestBid = true;
							}
							if (swapQuotesForTenorDates.offerSpread == bestBankQuote.bestOfferSpread) {
								swapQuotesForTenorDates.isBestOffer = true;
							}
						}
					})
				})
			})
		}


		function getCashAndTomMarketWatch(spotMarketWatch, bankSpread) {
			$rootScope.cashMarketWatch = MarketWatch.getMarketWatchForGivenInstrument(spotMarketWatch, bankSpread, 'CASH');
			$rootScope.tomMarketWatch = MarketWatch.getMarketWatchForGivenInstrument(spotMarketWatch, bankSpread, 'TOM');
		}
		function setMarketSettings(value) {
			//loop market session settings and get $rootScope.retailSpotMarketSession, $rootScope.cashMarketSession, $rootScope.tomMarketSession..
			//angular.forEach($rootScope.marketSessionSettings, function(value){

			if (value.baseCurrency == 'USD') {

				if (value.instrumentCode == 'SPOT') {
					$rootScope.retailSpotMarketSession = value;
				} else if (value.instrumentCode == 'TOM') {
					$rootScope.tomMarketSession = value;
				} else if (value.instrumentCode == 'CASH') {
					$rootScope.cashMarketSession = value;
				} else if (value.instrumentCode == 'Forward') {
					$rootScope.forwardMarketSession = value;
				}

				//prepare user market watch online
				prepareUserMarketWatchOnline();
			}


			else {
				$rootScope.marketSessionMap[value.tokenSequenceNumber] = value;
			}
		}

		function getMarketDepthDetailsForReport(marketDepth) {

			//        	setTimeout(function(){
			//        		var existingSpotMarketDepth = angular.copy($rootScope.retailSpotMarketDepthMemory);
			//            	//get market depth for SPOT
			//            	existingSpotMarketDepth = MarketWatch.getRetailSpotMarketDepth($rootScope.marketDepth);

			MarketWatch.getRetailSpotMarketDepth(marketDepth);

			if ($rootScope.retailSpotMarketDepth != null && $rootScope.retailSpotMarketDepth != undefined) {
				getRetailSpotMarketWatch($rootScope.retailSpotMarketDepth);
			}

			var existingIbSpotMarketDepth = $rootScope.ibSpotMarketDepth;
			//get market depth for IB SPOT
			existingIbSpotMarketDepth = MarketWatch.getIBSpotMarketDepth(marketDepth);
			//$rootScope.ibSpotMarketDepth = existingIbSpotMarketDepth;

			if ($rootScope.ibSpotMarketDepth != null && $rootScope.ibSpotMarketDepth != undefined) {
				//get ibSpotMarketWatch
				var existingIbSpotMarketWatch = $rootScope.ibSpotMarketWatch;
				existingIbSpotMarketWatch = MarketWatch.getIBSpotMarketWatch($rootScope.ibSpotMarketDepth);
				$rootScope.ibSpotMarketWatch = existingIbSpotMarketWatch;
			}


			MarketWatch.updateFCYMarketWatch($rootScope.fcyMarketDepthArray);

		//	$rootScope.marketArray = Object.entries($rootScope.marketWatchMap);

			//            	$scope.$apply();
			//        	}, 100)
		}


		function getRetailSpotMarketWatch(marketDepth) {
			var existingSpotMarketWatch = $rootScope.retailSpotMarketWatch;
			//get retailSpot market watch
			existingSpotMarketWatch = MarketWatch.getRetailSpotMarketWatch(marketDepth);
			$rootScope.retailSpotMarketWatch = existingSpotMarketWatch;
			if ($rootScope.retailSpotMarketWatch != null && $rootScope.retailSpotMarketWatch != undefined) {
				//get swap quotes
				//getSwapQuotes()
			}
		}

		function getSwapQuotes() {
			//if the user is customer user, get spread for the banks in which the customer has relationship with.
			//if the user is bank/branch user, get spread for that particular bank.
			if ($rootScope.account.organisation.organisationType.shortName == 'CLEARCORP') {
				SwapQuotes.getSwapQuotesForAllBanks(onGetSwapQuotesSuccess, onGetSwapQuotesFailure);
			} else if ($rootScope.account.organisation.organisationType.shortName == 'BANK') {
				SwapQuotes.getSwapQuotesForGivenBank({ bankId: $rootScope.account.organisation.id }, onGetSwapQuotesSuccess, onGetSwapQuotesFailure);
			} else if ($rootScope.account.organisation.organisationType.shortName == 'CUSTOMER') {
				SwapQuotes.getSwapQuotesForGivenCustomer({ customerId: $rootScope.account.organisation.id }, onGetSwapQuotesSuccess, onGetSwapQuotesFailure);
			}
		}

		function onGetSwapQuotesSuccess(result) {
			//result will be list of swap quotes for the bank(s)
			//if result length is 1, then that is default bank for that user(customer user) and for bank/branch user, the result length will be 1. 
			if (result.length > 0) {
				//get bank swap quotes array to display in the bank comparative quotes section
				$rootScope.bankComparativeDTO = result;

				//fill defatult bank for clearcorp users
				//fillDefaultBankForClearcorpUsers(result);

				//change swap quotes in home page
				prepareSwapQuotes();

			}
		}

		function onGetSwapQuotesFailure() {

		}

		function frameOrderNotification(order) {

			if (order != null && order != undefined && Number(order.notificationId.substring(1)) > $rootScope.orderServerNotificationLastId) {

				if (order.exceptionNumber != null && order.exceptionNumber != "" && order.exceptionNumber != undefined) {

					//get rejection reason for error message
					angular.forEach($rootScope.errorMessageList, function (value) {
						if ((value.messageNumber == 8300 || value.messageNumber == 8021) && value.code == order.exceptionNumber) {
							$rootScope.rejectionReason = value.rejectionReason;
							order.errorMessage = value.rejectionReason;
						}
					});

				}

				if (order.buySellIndicator.toUpperCase() == 'BUYY') {
					order.buySellIndicator = 'BUY'
				}

				var orderAmount = 0;
				if ((order.messageNumber == '8300' || order.messageNumber == '8021') && (order.activityIndicator == 'CNCL' || order.activityIndicatorRequested == 'CNCL')) {
					orderAmount = order.remainingAmount;
				} else {
					orderAmount = order.orderAmount;
				}

				var baseCurrency = order.instrumentCode.split('/')[0];
				//build the initial notification string
				if (order.typeOfOrder == 'MRKT') {
					$rootScope.initialString = order.buySellIndicator + " " + order.instrumentCode + " " + order.currencyPairCode + " " + $filter('number')(orderAmount, 2) + " @ Market " +
						"for customer " + order.customerCode + " by " + order.retailUserCode;
				} else {
					$rootScope.initialString = order.buySellIndicator + " " + order.instrumentCode + " " + order.currencyPairCode + " " + $filter('number')(orderAmount, 2) + " @ " + $filter('number')(order.limitExchangeRate, 4) +
						" for customer " + order.customerCode + " by " + order.retailUserCode;
				}





				/*	$rootScope.initialString = order.buySellIndicator + " order for client" + " " + order.customerCode + ", " + order.instrumentCode + " for " + order.orderAmount + " at " 
						+ order.typeOfOrder + " " + order.limitExchangeRate + " " + order.timeLimitIndicator + " by " + order.retailUserCode;*/


				//notification string if message number is 2021/2300

				buildNotificationString(order);



			}
		}



		//build notification based on message number

		function buildNotificationString(order) {


			if (order.messageNumber == '2300' || order.messageNumber == '2021') {

				buildStringForOrderRequest(order);
			}

			else if (order.messageNumber == '8300' || order.messageNumber == '8021') {

				buildStringForOrderResponse(order);
			} else if (order.messageNumber == '8302' || order.messageNumber == '8026') {
				buildStringForAdminCancel(order);
			}


		}

		//notification string for message number 2021/2300

		function buildStringForOrderRequest(order) {
			var isBankBreachedMsg = "";
			if (order.isBankBreached) {
				isBankBreachedMsg = "and accepted for restricted matching";
			}

			if (order.errorMessage != '') {
				//	$rootScope.rejectionString = $rootScope.initialString + " rejected due to " + "&quot;" + order.errorMessage + "&quot;";
				if (order.activityIndicator == 'PLAC') {
					$rootScope.messageString = "NEW order request is rejected with error: " + order.errorMessage + "; " + $rootScope.initialString;
				} else if (order.activityIndicator == 'MDFY') {
					$rootScope.messageString = "MODIFY request for order No. " + order.orderSequenceNumber + " is rejected with error: " + order.errorMessage + "; " + $rootScope.initialString;
				} else if (order.activityIndicator == 'CNCL') {
					$rootScope.messageString = "CANCEL request for order No. " + order.orderSequenceNumber + " is rejected with error: " + order.errorMessage + "; " + $rootScope.initialString;
				}
				if ($rootScope.userPreference.showInteractiveMsgPopup == null || $rootScope.userPreference.showInteractiveMsgPopup.toLowerCase() == 'yes') {
					$.growl.error({ title: "Order Rejection", message: $rootScope.messageString });
				}
				var RejectionString = "Order Rejection~~" + $rootScope.messageString;
				insertPopupNotifications(RejectionString, order.notificationId);
			} else {
				if (order.exceptionNumber == 0) {
					if (order.activityIndicator == 'PLAC') {
						if (order.eventTypeId == 2 || order.eventTypeId == 3) { //if event type is rollover or early delivery
							$rootScope.messageString = "NEW order request submitted for execution with order No. " + order.orderSequenceNumber + "; " + $rootScope.initialString;
						} else {
							$rootScope.messageString = "NEW order request is risk validated " + isBankBreachedMsg + "; " + $rootScope.initialString;
						}
					} else if (order.activityIndicator == 'MDFY') {
						$rootScope.messageString = "MODIFICATION request for order No. " + order.orderSequenceNumber + " is risk validated " + isBankBreachedMsg + "; " + $rootScope.initialString;
					} else if (order.activityIndicator == 'CNCL') {
						$rootScope.messageString = "CANCELLATION request for order No. " + order.orderSequenceNumber + " is risk validated; " + $rootScope.initialString;
					}
					if ($rootScope.userPreference.showInteractiveMsgPopup == null || $rootScope.userPreference.showInteractiveMsgPopup.toLowerCase() == 'yes') {
						$.growl.notice({ title: "Order Acceptance", message: $rootScope.messageString });
					}
					var AcceptanceString = "Order Acceptance~~" + $rootScope.messageString;
					insertPopupNotifications(AcceptanceString, order.notificationId);
				}
				else if (order.exceptionNumber != 11) {
					if (order.activityIndicator == 'PLAC') {
						$rootScope.messageString = "NEW order request is rejected with error: " + order.errorMessage + "; " + $rootScope.initialString;
					} else if (order.activityIndicator == 'MDFY') {
						$rootScope.messageString = "MODIFY request for order No. " + order.orderSequenceNumber + " is rejected with error: " + order.errorMessage + "; " + $rootScope.initialString;
					} else if (order.activityIndicator == 'CNCL') {
						$rootScope.messageString = "CANCEL request for order No. " + order.orderSequenceNumber + " is rejected with error: " + order.errorMessage + "; " + $rootScope.initialString;
					}
					if ($rootScope.userPreference.showInteractiveMsgPopup == null || $rootScope.userPreference.showInteractiveMsgPopup.toLowerCase() == 'yes') {
						$.growl.error({ title: "Order Rejection", message: $rootScope.messageString });
					}
					var RejectionString = "Order Rejection~~" + $rootScope.messageString;
					insertPopupNotifications(RejectionString, order.notificationId);
				}
			}


		}

		//notification string if message number is 8021/8300

		function buildStringForOrderResponse(order) {

			//check exception numbers which are treated as successful response
			if (order.exceptionNumber != 0) {
				if ($rootScope.negligibleExceptionNumberList != undefined) {
					if ($rootScope.negligibleExceptionNumberList.indexOf(order.exceptionNumber.toString()) !== -1) {
						order.exceptionNumber = 0;
					}
				}
			}
			if (order.exceptionNumber == 0) {
				//$rootScope.acceptanceMessage = $rootScope.initialString + " accepted by Host. Order Sequence Number - " + order.orderSequenceNumber;
				if (order.activityIndicator == 'PLAC') {
					$rootScope.messageString = "NEW order request submitted for execution with order No. " + order.orderSequenceNumber + "; " + $rootScope.initialString;
				} else if (order.activityIndicator == 'MDFY') {
					$rootScope.messageString = "MODIFY request with order No. " + order.orderSequenceNumber + " is submitted for execution; " + $rootScope.initialString;
				} else if (order.activityIndicator == 'CNCL') {
					$rootScope.messageString = "CANCEL request for order No. " + order.orderSequenceNumber + " is submitted for execution; " + $rootScope.initialString;
				}
				if ($rootScope.userPreference.showInteractiveMsgPopup == null || $rootScope.userPreference.showInteractiveMsgPopup.toLowerCase() == 'yes') {
					$.growl.notice({ title: "Order Confirmation", message: $rootScope.messageString });
				}
				var ConfirmationString = "Order Confirmation~~" + $rootScope.messageString;
				insertPopupNotifications(ConfirmationString, order.notificationId);
			}
			else {
				//$rootScope.rejectionString = $rootScope.initialString + " rejected due to " + "&quot;" + $rootScope.rejectionReason + "&quot;";
				if (order.exceptionNumber == 1801) {
					order.errorMessage = $rootScope.rejectionReason;
				}
				if (order.activityIndicatorRequested == 'PLAC') {
					$rootScope.messageString = "NEW order request is rejected with error: " + order.errorMessage + "; " + $rootScope.initialString;
				} else if (order.activityIndicatorRequested == 'MDFY') {
					$rootScope.messageString = "MODIFY request for order No. " + order.orderSequenceNumber + " is rejected with error: " + order.errorMessage + "; " + $rootScope.initialString;
				} else if (order.activityIndicatorRequested == 'CNCL') {
					$rootScope.messageString = "CANCEL request for order No. " + order.orderSequenceNumber + " is rejected with error: " + order.errorMessage + "; " + $rootScope.initialString;
				}

				if ($rootScope.userPreference.showInteractiveMsgPopup == null || $rootScope.userPreference.showInteractiveMsgPopup.toLowerCase() == 'yes') {
					$.growl.error({ title: "Order Rejection", message: $rootScope.messageString });
				}
				var RejectionString = "Order Rejection~~" + $rootScope.messageString;
				insertPopupNotifications(RejectionString, order.notificationId);

			}


		}

		function buildStringForAdminCancel(order) {

			var baseCurrency = order.instrumentCode.split('/')[0];
			if (order.typeOfOrder == 'MRKT') {
				$rootScope.message = order.buySellIndicator + " " + order.instrumentCode + " " + order.currencyPairCode + " " + $filter('number')(order.orderAmount, 2) + " @ Market " +
					"for customer " + order.customerCode;
			} else {
				$rootScope.message = order.buySellIndicator + " " + order.instrumentCode + " " + order.currencyPairCode + " " + $filter('number')(order.orderAmount, 2) + " @ " + $filter('number')(order.limitExchangeRate, 4) +
					" for customer " + order.customerCode;
			}
			$rootScope.messageString = "Order No. " + order.orderSequenceNumber + " is cancelled by Admin/Session close; " + $rootScope.message;
			if ($rootScope.userPreference.showInteractiveMsgPopup == null || $rootScope.userPreference.showInteractiveMsgPopup.toLowerCase() == 'yes') {
				$.growl.notice({ title: "Order Cancellation-by Admin/Session close", message: $rootScope.messageString });
			}
			var ConfirmationString = "Order Cancellation-by Admin/Session close~~" + $rootScope.messageString;
			insertPopupNotifications(ConfirmationString, order.notificationId);
		}

		$rootScope.initialTradeMessage = "";


		//prepare trade notification
		function frameTradeNotification(trade) {
			var tradeMessage = angular.copy(trade);
			if (Number(trade.notificationId.substring(1)) > $rootScope.orderServerNotificationLastId) {
				if (tradeMessage != null && tradeMessage != undefined) {

					if (tradeMessage.buySellIndicator.toUpperCase() == 'BUYY') {
						tradeMessage.buySellIndicator = 'BUY';
					}

					/*	$rootScope.initialTradeMessage = trade.buySellIndicator + " trade " + trade.tradeSequenceNumber + " for " + trade.customerCode + ", " + trade.instrumentCode + 
						  " for " + trade.tradedAmount + " at " + trade.tradedExchangeRate + " for order number " + trade.orderSequenceNumber;*/


					var baseCurrency = tradeMessage.instrumentCode.split('/')[0];
					$rootScope.initialTradeMessage = "TRADE No. " + tradeMessage.tradeSequenceNumber + " confirmed for order No. " + tradeMessage.orderSequenceNumber + "; "
						+ tradeMessage.buySellIndicator + " " + tradeMessage.instrumentCode + " " + tradeMessage.currencyPair + " " + $filter('number')(tradeMessage.tradedAmount, 2) + " traded @ " + $filter('number')(tradeMessage.tradedExchangeRate, 4) + " for customer "
						+ tradeMessage.customerCode;
					if ($rootScope.userPreference.showInteractiveMsgPopup == null || $rootScope.userPreference.showInteractiveMsgPopup.toLowerCase() == 'yes') {
						$.growl.warning({ title: "Trade Confirmation", message: $rootScope.initialTradeMessage });
					}
				}
				var tradeConfirmation = "Trade Confirmation~~" + $rootScope.initialTradeMessage;
				insertPopupNotifications(tradeConfirmation, trade.notificationId);
			}
		}


		function insertPopupNotifications(msg, notificationId) {
			//update last notification id
			if (notificationId.includes("O")) {
				$rootScope.orderServerNotificationLastId = angular.copy(Number(notificationId.substring(1)));
			} else if (notificationId.includes("P")) {
				$rootScope.pushNotificationLastId = angular.copy(Number(notificationId.substring(1)));
			}
			else if (notificationId.includes("Q")) {
				$rootScope.queryServerNotificationLastId = angular.copy(Number(notificationId.substring(1)));
			}

			var notificaiton = preparePopupNotificationObj(msg, notificationId);
			//Notifications.insertNotifications({message :msg},onInsertNotificationSuccess,onInsertNotificationFailure);
			onInsertNotificationSuccess(notificaiton);
		}

		function preparePopupNotificationObj(msg, notificationId) {
			var notification = {};
			notification.entity = $rootScope.dashboardEntity;
			notification.message = msg;
			notification.status = 'PENDING';
			notification.notificationId = notificationId;
			notification.createdDateTime = new Date();
			return notification;
		}

		function onInsertNotificationSuccess(result) {
			//$rootScope.$emit("getNotifications", {});
			$rootScope.notificationsDTO.popupNotifications.splice(0, 0, result);
			$rootScope.notificationsDTO.popupNotificationsCount += 1;
			console.log($rootScope.notificationsDTO);
			//getNotifications();
		}



		function onInsertNotificationFailure() {

		}

		function processFeed(object) {
			if (object.object != undefined && object.object != null && object.object.operation == 'SOD') {

				//updateProcessList(object.object, $rootScope.sodProcessList);
				console.log("socket " + object.object.processID);
				$rootScope.$emit('orderServiceSODProcessUpdate', object.object);
			} else if (object.object != undefined && object.object != null && object.object.operation == 'EOD') {
				$rootScope.$emit('orderServiceEODProcessUpdate', object.object);
				//updateProcessList(object.object, $rootScope.eodProcessList);
			} else if (object.object != undefined && object.object != null && object.object.operationName == 'HEStatusChange') {
				$rootScope.$emit('heStatusUpdate', object.object);
				frameHeNotification(object.object);

			} else if (object.object != undefined && object.object != null && object.object.operationName == 'OrderServerManualLogin') {
				$rootScope.$emit('orderServerManualLogin', object.object);
				frameOrderServerMAnualLoginNotification(object.object);

			}
		}

		function frameMemberBreachedNotification(breachedMemberDetails, notificationId) {
			//var breachedMemberDetailsCopy = angular.copy(breachedMemberDetails);

			if (breachedMemberDetails != null && breachedMemberDetails != undefined && breachedMemberDetails.id != null && breachedMemberDetails.id != undefined && breachedMemberDetails.id != ''
				&& Number(notificationId.substring(1)) > $rootScope.orderServerNotificationLastId) {
				//console.log("breachedMemberDetails " + breachedMemberDetails.id)    	

				var messageTobeDisplayed = '';
				var popupMessage = '';
				if (breachedMemberDetails.marginFlag == 'Y' || breachedMemberDetails.exposureLimitBuyFlag == 'Y' || breachedMemberDetails.exposureLimitSellFlag == 'Y') {
					messageTobeDisplayed = "Restricted matching is <span style='color:#f04a4a;'>enabled</span> for " + breachedMemberDetails.bankName;
					popupMessage = "Breached Member Details~~" + messageTobeDisplayed;
				} else {
					messageTobeDisplayed = "Restricted matching is <span style='color:#00ff00'>disabled</span> for " + breachedMemberDetails.bankName;
					popupMessage = "Breached Member Details~~" + messageTobeDisplayed;
				}
				if (globalValues.getEntityOwnerType().shortName == "Clearcorp") {

					showBreachedMemberNotification(messageTobeDisplayed, popupMessage, notificationId);
				} else if (globalValues.getEntityOwnerType().shortName == "Bank" || globalValues.getEntityOwnerType().shortName == "Branch") {

					if (globalValues.getBank() != null && globalValues.getBank() != undefined && globalValues.getBank() != '' && globalValues.getBank().id == breachedMemberDetails.id) {
						//console.log("breachedMemberDetails bank id:" + globalValues.getBank().id);
						showBreachedMemberNotification(messageTobeDisplayed, popupMessage, notificationId);
					}
				} else if (globalValues.getEntityOwnerType().shortName == "SingleUserCustomer" || globalValues.getEntityOwnerType().shortName == "MultiUserCustomer") {

					angular.forEach($rootScope.tradingRelationsForCustomer, function (item) {
						//console.log("breachedMemberDetails customer bank id:" + item.id);
						if (item.bank.id == breachedMemberDetails.id) {
							showBreachedMemberNotification(messageTobeDisplayed, popupMessage, notificationId);
						}
					});


				}

			}


		}

		function frameBroadcastMessage(object) {
			if (object != null && object != undefined && Number(object.notificationId.substring(1)) > $rootScope.orderServerNotificationLastId) {
				if ($rootScope.userPreference.showInteractiveMsgPopup == null || $rootScope.userPreference.showInteractiveMsgPopup.toLowerCase() == 'yes') {
					$.growl.alert({ title: "Clearcorp Broadcast", message: object.object });
				}
				var msgString = "Clearcorp Broadcast~~" + object.object;
				insertPopupNotifications(msgString, object.notificationId);
			}
		}

		function framePreCashSessionCloseIntimationNotification(object, notificationId) {
			if (Number(notificationId.substring(1)) > $rootScope.pushNotificationLastId) {
				var sessioncloseIntimation = "CASH Session is about to close in another " + object + " minutes...!";
				if ($rootScope.userPreference.showInteractiveMsgPopup == null || $rootScope.userPreference.showInteractiveMsgPopup.toLowerCase() == 'yes') {
					$.growl.alert({ title: "CASH Session Close Intimation", message: sessioncloseIntimation });
				}
				var intimationMsg = "CASH Session Close Intimation~~" + sessioncloseIntimation;
				insertPopupNotifications(intimationMsg, notificationId);
			}
		}

		function serverComponentStatusChange(object) {
			if (object.operationName == 'BroadcastRecoveryStart') {
				$rootScope.broadcastServerDown = true;
			} else if (object.operationName == 'BroadcastRecoveryCompleted') {
				$rootScope.broadcastServerDown = false;
			}
		}

		function updateConnectionStatus(object) {
			if (object.participant == 'OPS') {

				if (object.isConnected == true) {
					$rootScope.orderServerDown = false;
				} else {
					$rootScope.orderServerDown = true;
				}
				$rootScope.$digest();
			}
			else if (object.participant == 'PNS') {

				if (object.isConnected == true) {
					$rootScope.broadcastServerDown = false;
				} else {
					$rootScope.broadcastServerDown = true;
				}
				$rootScope.$digest();
			}

		}
		function showBreachedMemberNotification(messageTobeDisplayed, popupMessage, notificationId) {
			if ($rootScope.userPreference.showInteractiveMsgPopup == null || $rootScope.userPreference.showInteractiveMsgPopup.toLowerCase() == 'yes') {
				$.growl.alert({ title: "Breached Member Details", message: messageTobeDisplayed });
			}
			insertPopupNotifications(popupMessage, notificationId);
		}
		function frameHeNotification(data) {
			var messageTobeDisplayed = "";
			var title = "";
			var isError = false;
			if (data.message == "success") {
				messageTobeDisplayed = "HE status update completed successfully";
				isError = false;
				title = "HE Status Update Completed";
			} else {
				messageTobeDisplayed = data.message;
				isError = true;
				title = "HE Status Update Failed";
			}

			var popupMessage = title + "~~" + messageTobeDisplayed;
			showStatusNotification(messageTobeDisplayed, popupMessage, title, isError);
		}
		function frameOrderServerMAnualLoginNotification(data) {

			var messageTobeDisplayed = "";
			var title = "Order Server Manual Login Intimation";
			var isError = false;
			var title = "";
			if (data.message == "success") {
				messageTobeDisplayed = "Order Server manual login completed succesfully";
				isError = false;
				title = "Order Server Manual Login Completed";
			} else {
				messageTobeDisplayed = data.message;
				isError = true;
				title = "Order Server Manual Login Failed";
			}
			var popupMessage = title + "~~" + messageTobeDisplayed;
			showStatusNotification(messageTobeDisplayed, popupMessage, title, isError);

		}
		function showStatusNotification(messageTobeDisplayed, popupMessage, title, isError) {
			if ($rootScope.userPreference.showInteractiveMsgPopup == null || $rootScope.userPreference.showInteractiveMsgPopup.toLowerCase() == 'yes') {
				if (isError) {
					$.growl.error({ title: title, message: messageTobeDisplayed });
				} else {
					$.growl.notice({ title: title, message: messageTobeDisplayed });
				}
			}
			insertPopupNotifications(popupMessage);


		}

		// get tick size
		function gettickSizeForGivenInstrument(instrumentCode) {
			if (instrumentCode == 'SPOT') {
				return $rootScope.tickSize.usd.spot;
			} else if (instrumentCode == 'CASH') {
				return $rootScope.tickSize.usd.cash;
			} else if (instrumentCode == 'TOM') {
				return $rootScope.tickSize.usd.tom;
			} else if (instrumentCode == 'Forward') {
				return $rootScope.tickSize.usd.forward;
			}
		}

		//get session status for instrument code
		function getSessionStatusForInstrument(instrumentCode) {
			var status = 'CLOSED';
			if (instrumentCode == 'SPOT') {
				status = $rootScope.retailSpotMarketSession.sessionTimingsDTO.status;
			} else if (instrumentCode == 'CASH') {
				status = $rootScope.cashMarketSession.sessionTimingsDTO.status;
			} else if (instrumentCode == 'TOM') {
				status = $rootScope.tomMarketSession.sessionTimingsDTO.status;
			} else if (instrumentCode == 'Forward') {
				status = $rootScope.forwardMarketSession.sessionTimingsDTO.status;
			}
			return status;
		}

		//prepare user market watch online
		function prepareUserMarketWatchOnline() {
			angular.forEach($rootScope.userMarketWatchList, function (userMarketWatch) {
				var tickSize = gettickSizeForGivenInstrument(userMarketWatch.instrument);
				userMarketWatch.sessionStatus = getSessionStatusForInstrument(userMarketWatch.instrument);
				userMarketWatch = MarketWatch.fillBidOfferSpreadInUserMarketWatch(userMarketWatch, $rootScope.bankComparativeDTO, $rootScope.defaultBankSpread, $rootScope.retailSpotMarketSession.settlementDate, tickSize);
				userMarketWatch = MarketWatch.fillBidOfferPriceInUserMarketWatch(userMarketWatch, $rootScope.retailSpotMarketWatch);
			})
		}

		function prepareOutrightComparision(settlementDate, instrument) {
			$rootScope.outrightRatesList = [];
			$rootScope.outrightRateSettlementDate = settlementDate;
			$rootScope.outrightRateInstrument = instrument;
			angular.forEach($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, function (swapQuotesTenorDateDTO) {
				var outrightRates = {};
				outrightRates.bank = swapQuotesTenorDateDTO.bank;
				outrightRates.instrument = instrument;
				outrightRates.settlementDate = settlementDate;
				var tickSize = gettickSizeForGivenInstrument(outrightRates.instrument);
				outrightRates.sessionStatus = getSessionStatusForInstrument(outrightRates.instrument);
				outrightRates = MarketWatch.fillBidOfferSpreadInUserMarketWatch(outrightRates, $rootScope.bankComparativeDTO, swapQuotesTenorDateDTO.swapQuotesForTenorDatesList, $rootScope.retailSpotMarketSession.settlementDate, tickSize);
				outrightRates = MarketWatch.fillBidOfferPriceInUserMarketWatch(outrightRates, $rootScope.retailSpotMarketWatch);
				$rootScope.outrightRatesList.push(outrightRates);
			});
			console.log('outright');
			console.log($rootScope.outrightRatesList);
			$rootScope.outrightRatesList = MarketWatch.sortOutrightRatesList($rootScope.outrightRatesList);
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("OrderUtil", OrderUtil);

        OrderUtil.$inject = ['$rootScope','DateUtils','$filter','MarketWatch','GlobalValues'];

    function OrderUtil($rootScope,DateUtils,$filter,MarketWatch,GlobalValues) {

    	var service = {
            validateOrderDTOForNull: validateOrderDTOForNull,
            validateSettlementDate:validateSettlementDate,
            validateOptionSettlementDate : validateOptionSettlementDate,
            validateOptionPeriods: validateOptionPeriods,
            validateSession : validateSession,
            validateSessionStatus: validateSessionStatus,
            validateAgreedTAC : validateAgreedTAC,
            validateLimitCheck: validateLimitCheck,
            validateOrderAmount: validateOrderAmount,
            validateLimitExchangeRateHardCheck:validateLimitExchangeRateHardCheck,
            validateSpreadUsed:validateSpreadUsed,
            getEventTypeForShortName : getEventTypeForShortName,
            gettickSizeForGivenInstrument : gettickSizeForGivenInstrument,
            getSettlementDate : getSettlementDate,
            getCloseTimeForInstrumentCode : getCloseTimeForInstrumentCode,
            validateOrderDTOIsNull : validateOrderDTOIsNull,
            validateSessionStatusUsingTokenSeqNo:validateSessionStatusUsingTokenSeqNo,
            validateClearCorpAgreedTAC:validateClearCorpAgreedTAC
    	};
    	return service;

        //validate order DTO
        function validateOrderDTOForNull(orderDTO){
            var isValidOrder = true;
            if (orderDTO.activityIndicator == null || orderDTO.activityIndicator == undefined
                || orderDTO.bankId == null || orderDTO.bankId == undefined
                || orderDTO.bankMemberNumber == null || orderDTO.bankMemberNumber == undefined
                || orderDTO.branchCode == null || orderDTO.branchCode == undefined
                || orderDTO.branchId == null || orderDTO.branchId == undefined
                || orderDTO.buySellIndicator == null || orderDTO.buySellIndicator == undefined
                || orderDTO.customerCode == null || orderDTO.customerCode == undefined
                || orderDTO.customerId == null || orderDTO.customerId == undefined
                || orderDTO.eventType == null || orderDTO.eventType == undefined
                || orderDTO.eventTypeId == null || orderDTO.eventTypeId == undefined
                || orderDTO.expiryTime == null || orderDTO.expiryTime == undefined
                || orderDTO.instrumentCode == null || orderDTO.instrumentCode == undefined
                || orderDTO.instrumentId == null || orderDTO.instrumentId == undefined
                || orderDTO.limitExchangeRate == null || orderDTO.limitExchangeRate == undefined
                || orderDTO.orderAmount == null || orderDTO.orderAmount == undefined
                || orderDTO.retailUserCode == null || orderDTO.retailUserCode == undefined
                || orderDTO.stopExchangeRate == null || orderDTO.stopExchangeRate == undefined
                || orderDTO.timeLimitIndicator == null || orderDTO.timeLimitIndicator == undefined
                || orderDTO.typeOfOrder == null || orderDTO.typeOfOrder == undefined
                || orderDTO.userEntityOwnerId == null || orderDTO.userEntityOwnerId == undefined
                || orderDTO.userId == null || orderDTO.userId == undefined

                || orderDTO.settlementIFSCCode == null ||orderDTO.settlementIFSCCode == undefined
                || orderDTO.deliveryMode == null || orderDTO.deliveryMode == undefined || orderDTO.noOfTrades == null || orderDTO.noOfTrades == undefined
                || orderDTO.tradeTotalPrice == null || orderDTO.tradeTotalPrice == undefined || orderDTO.sourceAppId == null
                || orderDTO.sourceAppId == undefined){
                isValidOrder = false;
                var orderDTOObj = angular.copy(angular.toJson(orderDTO));
                console.log(orderDTOObj);
            }
            //if given instrument is forward and then validate tradeSettlementDate, exposureType, exposureSubType
            else if(orderDTO.instrumentCode == 'Forward' && (orderDTO.tradeSettlementDate == null || orderDTO.tradeSettlementDate == undefined)){
                isValidOrder = false;
                var orderDTOObj = angular.copy(angular.toJson(orderDTO));
                console.log(orderDTOObj);
            }

            return isValidOrder;
        }

        function validateOptionSettlementDate(instrumentCode ,isOptionPeriod ,  settlementDate, dateFromOrTo){
            // do validateion only if forwards and option period is true else skip validation
        	if(instrumentCode != 'Forward' ||  (instrumentCode == 'Forward' && isOptionPeriod != true ) ){
         	   return {
                isValid: true,
                errorString : errorString
            }
            }
            var isValid = true;
            var errorString = "";
            var selectedDateText = "Selected Forward Option Period " + dateFromOrTo + " date ";
           // var errorText = "errorInOptionPeriod" + dateFromOrTo;
            var serverSettlemntDate = DateUtils.convertLocalDateToServer(settlementDate);

            var holidayList = _.filter($rootScope.holidayListAfterBusinessDate, function(s){return s.indexOf(serverSettlemntDate)!==-1;});


            if(settlementDate == null || settlementDate == undefined ){
            	isValid = false;
            	errorString = "Forward Option Period " + dateFromOrTo + " date is mandatory..!";
            	//MessageBox.openMessageBox("Alert", "Option Period " + dateFromOrTo + " date is mandatory", "Ok", errorText);

            }else if(holidayList!=null && holidayList!=undefined && holidayList.length>0){

            	isValid = false;
                errorString = selectedDateText +"is a Holiday. For Holiday List, kindly refer to Holiday View screen in General Reports menu...!";
               //MessageBox.openMessageBox("Alert", , "Ok", errorText);

            }else{
            	 //validate sett. date should not be greater than the maximum renor/value defined in the limits
            	if($rootScope.maxForwardTenorDate !=null && $rootScope.maxForwardTenorDate != undefined && moment(settlementDate).isAfter($rootScope.maxForwardTenorDate, 'day')){

            		isValid = false;
                    errorString = selectedDateText +"is greater than the" + " maximum tenor/value date defined by the Relationship Bank. Please refer the Limit Tab for more info on maximum tenor/value date allowed...!";
                    // MessageBox.openMessageBox("Alert", , "Ok", errorText);
                }else if( moment(settlementDate).isBefore( moment($rootScope.spotNextDate), 'day') || moment(settlementDate).isAfter( moment($rootScope.maxTenorDate), 'day')){
                    //validate sett. date should not be less than spot next date. and should not be greater than last tenor value
                	isValid = false;
                	errorString = selectedDateText +"should be between Spot Next Date and maximum tenor date...!";
                    //MessageBox.openMessageBox("Alert", , "Ok", errorText);

                }
            }
            return {
                isValid: isValid,
                errorString : errorString
            }
        }

        function validateOptionPeriods(instrumentCode, isOptionPeriod, from,to){
            // do validateion only if forwards and option period is true else skip validation
        	if(instrumentCode != 'Forward' ||  (instrumentCode == 'Forward' && isOptionPeriod != true ) ){
          	  return {
                isValid: true,
                errorString : errorString
            }
        }
        	//validate sett. date should be fall in holiday
            var isValid = true;
            var errorString = "";
            var errorShortString = "";
            //var errorText = "errorInOptionPeriodFRomAndTo";
                //validate sett. date should not be spot date. since, spot mkt watch is in separate section.
                //and sett. date should not be less than current business date.
                if( moment(from).isSame(moment(to), 'day') ){
                    isValid = false;
                    errorString = "Forward Option Period Start date and End date cannot be same...!";
                    errorShortString = "Start date and End date cannot be same";
                   // MessageBox.openMessageBox("Alert", "Option Period From and To cannot be same...!", "Ok", errorText);

                }else if(moment(from).isAfter(moment(to), 'day')){
                	isValid = false;
                	errorString = "Forward Option Period Start date cannot be greater than End date...!";
                    errorShortString = "Start date cannot be greater than End date"
                    //MessageBox.openMessageBox("Alert", "Option Period From is greater than To...!", "Ok", errorText);
                }
                else if(moment(to).diff(moment(from) ,'day') > $rootScope.maximumOptionPeriodDuration){
                	isValid = false;
                	errorString = "Forward Option Period date range cannot be more than "+ $rootScope.maximumOptionPeriodDuration+" days...!";
                    errorShortString = "Option Period date range cannot be more than "+ $rootScope.maximumOptionPeriodDuration+" days";
                    //MessageBox.openMessageBox("Alert", , "Ok", errorText);
                }

            return {
                isValid:isValid,
                errorString: errorString,
                errorShortString : errorShortString
            }
        }
        function validateSettlementDate(instrumentCode ,isOptionPeriod ,  settlementDate, dateFromOrTo){
            // do validateion only if forwards and option period is true else skip validation
        	if(instrumentCode != 'Forward' ||  (instrumentCode == 'Forward' && isOptionPeriod != false ) ){
         	   return {
                isValid: true,
                errorString : errorString
            }
            }
            var isValid = true;
            var errorString = "";
            var selectedDateText = "Selected " + dateFromOrTo + " date ";
            var serverSettlemntDate = DateUtils.convertLocalDateToServer(settlementDate);

            var holidayList = _.filter($rootScope.holidayListAfterBusinessDate, function(s){return s.indexOf(serverSettlemntDate)!==-1;});


            if(settlementDate == null || settlementDate == undefined ){
            	isValid = false;
            	errorString =  dateFromOrTo + " date is mandatory..!";

            }else if(holidayList!=null && holidayList!=undefined && holidayList.length>0){

                isValid = false;
                errorString = selectedDateText +"is a Holiday. For Holiday List, kindly refer to Holiday View screen in General Reports menu...!";


            }else{
            	 if( moment(settlementDate).isBefore( moment($rootScope.spotNextDate), 'day') || moment(settlementDate).isAfter( moment($rootScope.maxTenorDate), 'day')){
                     //validate sett. date should not be less than spot next date. and should not be greater than last tenor value
                	isValid = false;
                	errorString = selectedDateText +"should be between Spot Next Date and maximum tenor date...!";

                 }
            }
            return {
                isValid: isValid,
                errorString : errorString
            }
        }

        function validateSession(instrumentCode, priceCondtion,tokenSequenceNo){
        	if(!validateSessionStatus(instrumentCode)&&$rootScope.currencyCode == 'USD'){
        		return false;
        	}
            else{
                if(!validateSessionStatusUsingTokenSeqNo(instrumentCode,tokenSequenceNo)){
                    return false;
                }
            }

            if(!validateAgreedTAC()){
                return false;
            }
        	return true;
        }

        // validate session status
        function validateSessionStatus(instrumentCode){
        	var status = "";
        	var errorString = "";
        	 if(instrumentCode == 'SPOT'){
        	 	status = $rootScope.retailSpotMarketSession.sessionTimingsDTO.status;
        	 }else if(instrumentCode == 'CASH'){
        	 	status = $rootScope.cashMarketSession.sessionTimingsDTO.status;
        	 }else if(instrumentCode == 'TOM'){
        	 	status = $rootScope.tomMarketSession.sessionTimingsDTO.status;
        	 }else if(instrumentCode == 'Forward'){
                 status = $rootScope.forwardMarketSession.sessionTimingsDTO.status;
             }
        	
        	if(status!='OPEN'){
        		errorString = "Session is closed for " + instrumentCode + " market...!"
        		return {
                    isValid:false,
                    errorString :  errorString
                }
        	}

        	 return {
                isValid:true,
                errorString :  ""
            }
        }


        // validate session status
        function validateSessionStatusUsingTokenSeqNo(tokenSequenceNo,instrumentCode){
        	var status = "";
        	var errorString = "";

           status = $rootScope.marketSessionMap[tokenSequenceNo].sessionTimingsDTO.status;
           var instrumentDetails = $rootScope.marketSessionMap[tokenSequenceNo];
        	// if(instrumentCode == 'SPOT'){
        	// 	status = $rootScope.retailSpotMarketSession.sessionTimingsDTO.status;
        	// }else if(instrumentCode == 'CASH'){
        	// 	status = $rootScope.cashMarketSession.sessionTimingsDTO.status;
        	// }else if(instrumentCode == 'TOM'){
        	// 	status = $rootScope.tomMarketSession.sessionTimingsDTO.status;
        	// }else if(instrumentCode == 'Forward'){
            //     status = $rootScope.forwardMarketSession.sessionTimingsDTO.status;
            // }
        if (!instrumentDetails.instrumentApplicable) {
            errorString = "Unavailable for " + instrumentCode + " market...!"
                return {
                    isValid:false,
                    errorString :  errorString
                }
        }else if(status!='OPEN'){
        		errorString = "Session is closed for " + instrumentCode + " market...!"
        		return {
                    isValid:false,
                    errorString :  errorString
                }
        }else if (instrumentDetails.isSettlementDateHoliday) {
                    errorString = " Holiday for " + instrumentCode + " market...!"
                return {
                    isValid:false,
                    errorString :  errorString
                }
        }
            return {
                isValid:true,
                errorString :  ""
            }
        }


        function validateAgreedTAC(tradingBank){
            var isValid = true;
            var errorString = "";
            if($rootScope.account!=null && $rootScope.account.organisation.organisationType.shortName=='CUSTOMER'){
                if($rootScope.agreedTACList!=null && $rootScope.agreedTACList!=undefined && $rootScope.agreedTACList.length>0){
                    //validate clearcorp TAC
                    if($rootScope.agreedTACList[0].isAgreed){
                        //validate selected trading bank TAC
                        if(tradingBank!=null && tradingBank!=undefined){
                            var agreedTACListForBank = _.filter(angular.copy($rootScope.agreedTACList), {'providerId': tradingBank.id});
                            if(agreedTACListForBank!=null && agreedTACListForBank!=undefined && agreedTACListForBank.length>0){
                                if(!agreedTACListForBank[0].isAgreed){
                                   errorString = "This activity cannot be completed. Kindly accept the revised Clearcorp/Relationship Bank Terms and Conditions by accessing from the “Settings menu >> Terms and Conditions view” menu in order to proceed with Order activity.";
                                    isValid = false;
                                }
                            }else{
                                errorString = "This activity cannot be completed. Kindly accept the revised Clearcorp/Relationship Bank Terms and Conditions by accessing from the “Settings menu >> Terms and Conditions view” menu in order to proceed with Order activity.";
                                isValid= false;
                            }
                        }else{
                            errorString = "Trading bank should be selected to place order...!";
                            isValid= false;
                        }
                    }else{
                        errorString = "This activity cannot be completed. Kindly accept the revised Clearcorp/Relationship Bank Terms and Conditions by accessing from the “Settings menu >> Terms and Conditions view” menu in order to proceed with Order activity.";
                        isValid =  false;
                    }

                }
            }
            return {
                isValid:isValid,
                errorString :  errorString
            }

        }

        function validateClearCorpAgreedTAC(){
            var isValid = true;
            var errorString = "";
            if($rootScope.account!=null && $rootScope.account.organisation.organisationType.shortName=='CUSTOMER'){
                if($rootScope.agreedTACList!=null && $rootScope.agreedTACList!=undefined && $rootScope.agreedTACList.length>0){
                    //validate clearcorp TAC
                    if(! $rootScope.agreedTACList[0].isAgreed  ){
                        errorString = "Kindly accept the revised Clearcorp Terms and Conditions by accessing from the “Settings menu >> Terms and Conditions view” ";
                        isValid =  false;
                    }
                }
            }
            return {
                isValid:isValid,
                errorString :  errorString
            }

        }

        function validateLimitCheck(oldOrderAmount, activityIndicator, orderAmount, instrumentCode, buySellFlag, priceCondition, tradeSettlementDate){
            var isValid = true;
            var errorObject = { message: "" };
        	// if($rootScope.limitNotDefined){
    		// 	errorString = "Trading limits are not defined. Order entry not possible...!";
    		// 	isValid =  false;
        	// }
            //valdiate max tenor date
            if(instrumentCode=='Forward'){
                if(moment(tradeSettlementDate).isAfter($rootScope.maxForwardTenorDate, 'day')){
                    //vm.errorString = "Settlement date is beyond the given limit maximum tenor date. Cannot place order...!";
                    errorObject.message = "Order entry not possible. Settlement date selected is greater than the" +
                    " maximum tenor/value date defined by the Relationship Bank. Please refer the Limit Tab for more info on maximum tenor/value date allowed.";

                    isValid = false;
                }
            }
        	if(buySellFlag=='SELL'){
        		if(!validateSellLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount, priceCondition)){
        			errorObject.message = "Sell trading limit breached. Order entry not possible...!";
        			isValid = false;
        		}
        	}else if(buySellFlag=='BUYY'){
        		if(!validateBuyLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount, priceCondition)){
        			errorObject.message = "Buy trading limit breached. Order entry not possible...!";
        			isValid = false;
        		}
        	}else if(buySellFlag=='SELLBUY'){
        		if(priceCondition=='MRKT'){
            		if(instrumentCode=='SPOT'){
            			if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.retailSpotBuyLimitForMkt, $rootScope.retailSpotSellLimitForMkt,errorObject)){
            				isValid = false;
            			}
            		}else if(instrumentCode=='CASH'){
            			if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.cashBuyLimitForMkt, $rootScope.cashSellLimitForMkt,errorObject)){
            				isValid = false;
            			}
            		}else if(instrumentCode=='TOM'){
            			if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.tomBuyLimitForMkt, $rootScope.tomSellLimitForMkt,errorObject)){
            				isValid = false;
            			}
            		}else if(instrumentCode=='Forward'){
                        if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.forwardBuyLimitWithCF, $rootScope.forwardSellLimitWithCF,errorObject)){
                            isValid = false;
                        }
                    }
        		}else{
            		if(instrumentCode=='SPOT'){
            			if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.retailSpotBuyLimit, $rootScope.retailSpotSellLimit,errorObject)){
            				isValid = false;
            			}
            		}else if(instrumentCode=='CASH'){
            			if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.cashBuyLimit, $rootScope.cashSellLimit,errorObject)){
            				isValid = false;
            			}
            		}else if(instrumentCode=='TOM'){
            			if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.tomBuyLimit, $rootScope.tomSellLimit,errorObject)){
            				isValid = false;
            			}
            		}else if(instrumentCode=='Forward'){
                        if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.forwardBuyLimitWithCF, $rootScope.forwardSellLimitWithCF,errorObject)){
                            isValid = false;
                        }
                    }
        		}
        	}
        	return {
                isValid: isValid,
                errorString : errorObject.message
            }
        }

        /*
		 * validate sell limit
		 */
        function validateSellLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount, priceCondition){
        	if(priceCondition=='MRKT'){
        		if(activityIndicator=='PLAC'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotSellLimitForMkt){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashSellLimitForMkt){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomSellLimitForMkt){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardSellLimitWithCF){
                            return false;
                        }
                    }
            	}else if(activityIndicator=='MDFY'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotSellLimitForMkt + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashSellLimitForMkt + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomSellLimitForMkt + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardSellLimitWithCF + oldOrderAmount){
                            return false;
                        }
                    }
            	}
        	}else{
        		if(activityIndicator=='PLAC'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotSellLimit){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashSellLimit){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomSellLimit){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardSellLimitWithCF){
                            return false;
                        }
                    }
            	}else if(activityIndicator=='MDFY'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotSellLimit + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashSellLimit + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomSellLimit + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardSellLimitWithCF + oldOrderAmount){
                            return false;
                        }
                    }
            	}
        	}
        	return true;
        }

        /*
		 * validate buy limit
		 */
        function validateBuyLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount, priceCondition){
        	if(priceCondition=='MRKT'){
        		if(activityIndicator=='PLAC'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotBuyLimitForMkt){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashBuyLimitForMkt){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomBuyLimitForMkt){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardBuyLimitWithCF){
                            return false;
                        }
                    }
            	}else if(activityIndicator=='MDFY'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotBuyLimitForMkt + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashBuyLimitForMkt + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomBuyLimitForMkt + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardBuyLimitWithCF + oldOrderAmount){
                            return false;
                        }
                    }
            	}
        	}else{
        		if(activityIndicator=='PLAC'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotBuyLimit){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashBuyLimit){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomBuyLimit){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardBuyLimitWithCF){
                            return false;
                        }
                    }
            	}else if(activityIndicator=='MDFY'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotBuyLimit + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashBuyLimit + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomBuyLimit + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardBuyLimitWithCF + oldOrderAmount){
                            return false;
                        }
                    }
            	}
        	}

            return true;
        }

         /*
		 * validate limits for sell and buy order
		 */
         function validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, buyLimit, sellLimit,errorObject){
            var isValid = true;
        	if($rootScope.limitType == 'GLOBALGROSS' && orderAmount > (buyLimit/2)){
				errorObject.message = "Global gross limit breached. Order entry is not possible...!";
				isValid = false;
			}
    		if(orderAmount > buyLimit){
    			errorObject.message = "Buy trading limit breached. Order entry is not possible...!";
    			isValid = false;
    		}else if(orderAmount > sellLimit){
    			errorObject.message = "Sell trading limit breached. Order entry is not possible...!";
    			isValid = false;
    		}
    		return isValid;
        }


        // validate order amount
        function validateOrderAmount(orderAmount){
        	// orderAmount = orderAmount.replace(/,/g, '');
            var isValid = true;
            var errorString = "";
            var errorShortString = "";
            var configSettings = $rootScope.configurationSettingsForOrder;
            var userPreference = angular.copy($rootScope.userPreferenceForOrder);
            var noOfDecimalsForAmount = angular.copy($rootScope.noOfDecimalsForAmountForOrder);
            var transactionParametersSettings = angular.copy($rootScope.transactionParametersSettingsForOrder);
            var currencyPair =  angular.copy($rootScope.currencyPairForOrder);

        	if(Math.round(parseFloat(orderAmount) * 100) / Math.round(parseFloat(1) * 100) ==0){
        		errorString = 'Order value should be greater than zero...! ';
                errorShortString = errorString;
        		isValid = false;
        	}else if(Number(orderAmount) < 0){
        		errorString = 'Order value should be positive...!';
                errorShortString = 'Order Quantity cannot be negative;';
        		isValid = false;
            }else{

                var transactionParamterMinimumOrderValue = GlobalValues.getTransactionParameterValue(currencyPair.id, "MinimumOrderValue");
                var transactionParamterMaximumOrderValue = GlobalValues.getTransactionParameterValue(currencyPair.id, "MaximumOrderValueHardCheck");

                // Get the currency specific user preference limit for hard check
                var userMaxHardCheck = null;
                var userMaxSoftCheck = null;
                if ($rootScope.currencyWiseUserPreferenceSettings) {
                    var pref = $rootScope.currencyWiseUserPreferenceSettings[currencyPair.id];
                    if (pref) {
                        userMaxHardCheck = pref.configs[1];
                        userMaxSoftCheck = pref.configs[2];
                    }
                }

                if(transactionParamterMinimumOrderValue!=null && transactionParamterMaximumOrderValue!=null){
                    if(Number(orderAmount) < Number(transactionParamterMinimumOrderValue)){
                        errorString = 'Order value should be greater than or equal to CCIL minimum order value ('+currencyPair.baseCurrency.code + ' ' + $filter('number')(transactionParamterMinimumOrderValue, noOfDecimalsForAmount) + '). Order entry restricted..!';
                        errorShortString = 'Hard check should be greater than ('+currencyPair.baseCurrency.code + ' ' + $filter('number')(transactionParamterMinimumOrderValue, noOfDecimalsForAmount) + ')';
                        isValid = false;
                    }else if(Number(orderAmount) > Number(transactionParamterMaximumOrderValue)){
                        errorString = 'Breach of CCIL maximum order value </br> <span class="hardcheck-value">('+currencyPair.baseCurrency.code + ' ' + $filter('number')(transactionParamterMaximumOrderValue, noOfDecimalsForAmount) + ')</span> hard check.</br> Order entry restricted..!';
                        errorShortString = 'Hard check ( '+currencyPair.baseCurrency.code + ' ' + $filter('number')(transactionParamterMaximumOrderValue, noOfDecimalsForAmount) + ') Breached';
                        isValid = false;
                    }else if(userMaxHardCheck != null && Number(orderAmount) > Number(userMaxHardCheck)){
                        errorString = 'Breach of user level maximum order value </br> <span class="hardcheck-value">('+currencyPair.baseCurrency.code + ' ' + $filter('number')(userMaxHardCheck, noOfDecimalsForAmount) + ')</span> hard check.</br> Order entry restricted..!';
                        errorShortString = 'Hard check User Level ( '+currencyPair.baseCurrency.code + ' ' + $filter('number')(userMaxHardCheck, noOfDecimalsForAmount) + ') Breached';
                        isValid = false;
                    }else if(((Math.round(parseFloat(orderAmount) * 10000)) % (Math.round(parseFloat(configSettings.orderLotSize) * 10000)))!=0){
                        errorString = "Order value should be in multiples of lot size " + $filter('number')(configSettings.orderLotSize, noOfDecimalsForAmount) + "...!";
                        errorShortString = 'Order value should be in multiples of lot size ('+ currencyPair.baseCurrency.code + ' ' + $filter('number')(configSettings.orderLotSize, noOfDecimalsForAmount);
                        isValid = false;
                    }
                }

            }

        	return {
                isValid: isValid,
                errorString : errorString,
                errorShortString : errorShortString
            }
        }



        function validateLimitExchangeRateHardCheck(buySellFlag, priceCondtion, selectedBankSpread, instrumentCode, activityIndicator, orderAmount, oldOrderAmount,limitExchangeRate,limitExchangeRateInSpot,buyLimitExchangeRate,buyLimitExchangeRateInSpot,sellLimitExchangeRate,sellLimitExchangeRateInSpot,currencyPair,currencyPairId,defaultInstrumentTokenSequenceNo){
        	var ordertickSize = "";


            var transactionParametersSettings = angular.copy($rootScope.transactionParametersSettingsForOrder);

            var currencyPairValue =  angular.copy($rootScope.currencyPairForOrder);

             var configSettings = $rootScope.configurationSettingsForOrder;

             var alertInstrumentCode = instrumentCode;

            var allowedOrderPriceDeviationFromMarketPriceInPercentage = 0;
            var userAllowedOrderPriceDeviationFromMarketPriceInPercentage = 0;

            var transactionParamterValue = GlobalValues.getTransactionParameterValue(currencyPairValue.id, "AllowedOrderPriceDeviationFromMarketPriceInPercentage");

            if(transactionParamterValue != null){
                allowedOrderPriceDeviationFromMarketPriceInPercentage = transactionParamterValue;
            }else{
                allowedOrderPriceDeviationFromMarketPriceInPercentage = configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage;
            }

            // Get user level deviation from currency wise settings
            if ($rootScope.currencyWiseUserPreferenceSettings) {
                var pref = $rootScope.currencyWiseUserPreferenceSettings[currencyPairValue.id];
                if (pref) {
                   userAllowedOrderPriceDeviationFromMarketPriceInPercentage = pref.configs[3];
                }
            }

            if(currencyPairValue.code==='USDINR'){
              ordertickSize =  gettickSizeForGivenInstrument(instrumentCode);
              alertInstrumentCode = 'Spot';
            }
            else{

                var instrumentDetails = $rootScope.marketWatchMap[currencyPairId].instruments[getIndexBasedOnInstrument(instrumentCode)];

               ordertickSize = gettickSizeForGivenInstrument(instrumentCode,'',instrumentDetails.tokenSequenceNo);
            }
        	var ltp = 0
            var userPreference = angular.copy($rootScope.userPreferenceForOrder);
            var errorObject = { message: "" ,shortMessage:""};
            var isValid = true;
        	if(buySellFlag!='SELLBUY'){
            	ltp = getLtpValue(currencyPairValue,defaultInstrumentTokenSequenceNo);
            	if(!validateLimitExchangeRate(buySellFlag, activityIndicator, priceCondtion, limitExchangeRate, limitExchangeRateInSpot, ordertickSize, ltp, allowedOrderPriceDeviationFromMarketPriceInPercentage, userAllowedOrderPriceDeviationFromMarketPriceInPercentage,errorObject,currencyPair,defaultInstrumentTokenSequenceNo,alertInstrumentCode)){
            		isValid = false;
            	}
        	}else if(buySellFlag=='SELLBUY'){
            	var ltp = getLtpValue(currencyPairValue,defaultInstrumentTokenSequenceNo);
            	if(!validateLimitExchangeRate('BUYY', activityIndicator, priceCondtion, buyLimitExchangeRate, buyLimitExchangeRateInSpot, ordertickSize, ltp, allowedOrderPriceDeviationFromMarketPriceInPercentage, userAllowedOrderPriceDeviationFromMarketPriceInPercentage,errorObject,currencyPair,defaultInstrumentTokenSequenceNo,alertInstrumentCode)){
            		// return false;
            	}
            	if(!validateLimitExchangeRate('SELL', activityIndicator, priceCondtion, sellLimitExchangeRate, sellLimitExchangeRateInSpot, ordertickSize, ltp, allowedOrderPriceDeviationFromMarketPriceInPercentage, userAllowedOrderPriceDeviationFromMarketPriceInPercentage,errorObject,currencyPair,defaultInstrumentTokenSequenceNo,alertInstrumentCode)){
            		// return false;
            	}
            	if(errorObject.message!='' && errorObject.message!=null && errorObject.message!=undefined){
            		isValid = false;
            	}
        	}
        	return {
                isValid: isValid,
                errorString : errorObject.message,
                errorShortString : errorObject.shortMessage
            }
        }
        // get tick size
       function gettickSizeForGivenInstrument(instrumentCode,baseCurrency,tokenSequenceNo){
        if(baseCurrency==='USD'){
        	if(instrumentCode=='SPOT'){
        		return $rootScope.tickSize.usd.spot;
        	}else if(instrumentCode=='CASH'){
        		return $rootScope.tickSize.usd.cash;
        	}else if(instrumentCode=='TOM'){
        		return $rootScope.tickSize.usd.tom;
        	}else if(instrumentCode=='Forward'){
                return $rootScope.tickSize.usd.forward;
            }
        }
         else{

            var tikSizeValues = $rootScope.tickSize.other[tokenSequenceNo];

            if(instrumentCode=='SPOT'){
        		return tikSizeValues.spot;
        	}else if(instrumentCode=='CASH'){
        		return tikSizeValues.cash;
        	}else if(instrumentCode=='TOM'){
        		return tikSizeValues.tom;
        	}

         }
    }
    function gettickSizeForGivenInstrument(instrumentCode){
        if(instrumentCode=='SPOT'){
            return $rootScope.tickSize.usd.spot;
        }else if(instrumentCode=='CASH'){
            return $rootScope.tickSize.usd.cash;
        }else if(instrumentCode=='TOM'){
            return $rootScope.tickSize.usd.tom;
        }else if(instrumentCode=='Forward'){
            return $rootScope.tickSize.usd.forward;
        }
    }

    // get ltp for given instrument and buy sell flag
    // function getLtpValue(currencyPair,tokenSeqNo){

    //     if(currencyPair=='USDINR'){
    //     if($rootScope.ibSpotMarketDepth!=null && $rootScope.ibSpotMarketDepth!=undefined){
    //         if($rootScope.ibSpotMarketDepth.ltp!=null && $rootScope.ibSpotMarketDepth.ltp!=undefined && $rootScope.ibSpotMarketDepth.ltp>0){
    //             return $rootScope.ibSpotMarketDepth.ltp;
    //         }else{
    //             return $rootScope.previousDayClosingPriceForIbSpot;
    //         }
    //     }else{
    //         return $rootScope.previousDayClosingPriceForIbSpot;
    //     }
    // }
    //       else{
    //         $rootScope.dailyClosingPriceFCY[tokenSeqNo].previouseDayClosingPrice;
    //     }
    // }

  function getLtpValue(currencyPair,tokenSequenceNo) {
            if(currencyPair.code=='USDINR'){
            if ($rootScope.ibSpotMarketDepth != null && $rootScope.ibSpotMarketDepth != undefined) {
                if ($rootScope.ibSpotMarketDepth.ltp != null && $rootScope.ibSpotMarketDepth.ltp != undefined && $rootScope.ibSpotMarketDepth.ltp > 0) {
                    return $rootScope.ibSpotMarketDepth.ltp;
                } else {
                    return $rootScope.previousDayClosingPriceForIbSpot;
                }
            } else {
                return $rootScope.previousDayClosingPriceForIbSpot;
            }
        }
        else{

             if ($rootScope.tickerPriceFCY[tokenSequenceNo] != null && $rootScope.tickerPriceFCY[tokenSequenceNo] != undefined) {
                if ($rootScope.tickerPriceFCY[tokenSequenceNo].ltp != null && $rootScope.tickerPriceFCY[tokenSequenceNo].ltp != undefined && $rootScope.tickerPriceFCY[tokenSequenceNo].ltp > 0) {
                    return $rootScope.tickerPriceFCY[tokenSequenceNo].ltp;
                } else {
                    return $rootScope.dailyClosingPriceFCY[tokenSequenceNo].previouseDayClosingPrice;
                }
            } else {

            return $rootScope.dailyClosingPriceFCY[tokenSequenceNo].previouseDayClosingPrice;
            }
        }
        }


    function validateLimitExchangeRate(buySellFlag, activityIndicator, priceCondition, limitExchangeRate,limitExchangeRateInSpot, ordertickSize, ltp, allowedOrderPriceDeviationInPercent, allowedOrderPriceDeviationInPercentUserSettings,errorObject,currencyPair,defaultInstrumentTokenSequenceNo,alertInstrumentCode){
        ltp = Number(ltp);

        if(priceCondition!='MRKT'){
            if(Number(limitExchangeRate)<0){
                if(buySellFlag=='BUYY'){
                    errorObject.message = 'Buy limit price should be positive...!';
                    errorObject.shortMessage = 'Buy limit price cannot be negative';
                }else{
                    errorObject.message = 'Sell limit price should be positive...!';
                    errorObject.shortMessage = 'Sell limit price cannot be negative';
                }
                return false;
            }
        }

        if((priceCondition!='MRKT' && Number(limitExchangeRate)==0) || (priceCondition=='MRKT' && activityIndicator=='MDFY' && Number(limitExchangeRate)==0)){
            if(buySellFlag=='BUYY'){
                errorObject.message = 'Buy limit price should be greater than zero...!';
            }else{
                errorObject.message = 'Sell limit price should be greater than zero...!';
            }
            errorObject.shortMessage = errorObject.message;
            return false;
        }
        var tickSizeRemainder = (Math.round(parseFloat(limitExchangeRate)*10000)) % (Math.round(parseFloat(ordertickSize)*10000));
        if(tickSizeRemainder!=0 && priceCondition!='MRKT'){
            if(buySellFlag=='BUYY'){
                errorObject.message = 'Buy limit price should be in multiples of tick size ' + Number(ordertickSize) + '...!';
            }else{
                errorObject.message = 'Sell limit price should be in multiples of tick size ' + Number(ordertickSize) + '...!';
            }
            errorObject.shortMessage = 'Price should be in multiples of tick size '+ Number(ordertickSize);
            return false;
        }

       // if(currencyPair=='USDINR'){
        if(!validateLimitExchangeRateRange(limitExchangeRateInSpot, allowedOrderPriceDeviationInPercentUserSettings, ltp, ordertickSize, priceCondition, buySellFlag, 'user',errorObject,currencyPair,defaultInstrumentTokenSequenceNo,alertInstrumentCode)){
            return false;
        }
    //}

        if(!validateLimitExchangeRateRange(limitExchangeRateInSpot, allowedOrderPriceDeviationInPercent, ltp, ordertickSize, priceCondition, buySellFlag, 'clearcorp',errorObject,currencyPair,defaultInstrumentTokenSequenceNo,alertInstrumentCode)){
            return false;
        }

        return true;
    }

    function validateLimitExchangeRateRange(limitExchangeRateInSpot, allowedOrderPriceDeviationInPercent, ltp, ordertickSize, priceCondition, buySellFlag, level,errorObject,currencyPair,defaultInstrumentTokenSequenceNo,alertInstrumentCode){
        var isValid = true;

        if(currencyPair == 'USDINR'){
        var higherCutOffPrice = $rootScope.previousDayClosingPriceForIbSpot + ($rootScope.previousDayClosingPriceForIbSpot * Number(allowedOrderPriceDeviationInPercent/100));
        var lowerCutOffPrice = $rootScope.previousDayClosingPriceForIbSpot - ($rootScope.previousDayClosingPriceForIbSpot * Number(allowedOrderPriceDeviationInPercent/100));
        }else{
                    var previousDayClosingPrice = $rootScope.dailyClosingPriceFCY[defaultInstrumentTokenSequenceNo].previouseDayClosingPrice
                    var higherCutOffPrice = previousDayClosingPrice + ($rootScope.previousDayClosingPriceForIbSpot * Number(allowedOrderPriceDeviationInPercent/100));
                    var lowerCutOffPrice =previousDayClosingPrice - ($rootScope.previousDayClosingPriceForIbSpot * Number(allowedOrderPriceDeviationInPercent/100));

        }
        var noOfDecimalsForRate = $rootScope.noOfDecimalsForRateForOrder;
        if(currencyPair == 'USDINR'){
        if(ltp>0 && ltp!=undefined && ltp!=null){
            higherCutOffPrice = ltp + (ltp * Number(allowedOrderPriceDeviationInPercent/100));
            lowerCutOffPrice = ltp - (ltp * Number(allowedOrderPriceDeviationInPercent/100));
        }}else{
            higherCutOffPrice = ltp + (ltp * Number(allowedOrderPriceDeviationInPercent/100));
            lowerCutOffPrice = ltp - (ltp * Number(allowedOrderPriceDeviationInPercent/100));
        }
        higherCutOffPrice = (Math.round(parseFloat(higherCutOffPrice)*10000)/10000);
        lowerCutOffPrice = (Math.round(parseFloat(lowerCutOffPrice)*10000)/10000)
        var higherCutOffPriceRemainder = (Math.round(parseFloat(((Math.round(parseFloat(higherCutOffPrice)*10000)) % (Math.round(parseFloat(ordertickSize)*10000))/10000))*10000)/10000);
        higherCutOffPrice = (Math.round(parseFloat(higherCutOffPrice)*10000)/10000) - (Math.round(parseFloat(higherCutOffPriceRemainder)*10000)/10000);

            var lowerCutOffPriceRemainder = (Math.round(parseFloat(((Math.round(parseFloat(lowerCutOffPrice)*10000)) % (Math.round(parseFloat(ordertickSize)*10000))/10000))*10000)/10000);
        if(lowerCutOffPriceRemainder!=0){
            lowerCutOffPrice = (Math.round(parseFloat(lowerCutOffPrice)*10000)/10000) - (Math.round(parseFloat(lowerCutOffPriceRemainder)*10000)/10000) + (Math.round(parseFloat(ordertickSize)*10000)/10000);
        }else{
            lowerCutOffPrice = (Math.round(parseFloat(lowerCutOffPrice)*10000)/10000);
        }

            if(priceCondition!='MRKT' && (Math.round(parseFloat(limitExchangeRateInSpot)*10000) < Math.round(parseFloat(lowerCutOffPrice)*10000) ||  Math.round(parseFloat(limitExchangeRateInSpot)*10000) > Math.round(parseFloat(higherCutOffPrice)*10000))){
            if(buySellFlag=='BUYY'){
                if(level=='user'){
                    errorObject.message = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached User level limit price Hard check.</br> BUY Equivalent Spot Price should be between </br>' +"<span class='hardcheck-value'>" +  $filter('number')(lowerCutOffPrice, noOfDecimalsForRate) +"</span> "+  ' and ' +"<span class='hardcheck-value'>" +  $filter('number')(higherCutOffPrice, noOfDecimalsForRate)+"</span> ";
                    errorObject.shortMessage = 'Equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price User level Hard check breached. Price should be between '+$filter('number')(lowerCutOffPrice, noOfDecimalsForRate) +  ' and ' +  $filter('number')(higherCutOffPrice, noOfDecimalsForRate);
                }else{
                    errorObject.message = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached CCIL limit price Hard check.</br> BUY Equivalent Spot Price should be between </br> ' +"<span class='hardcheck-value'>"+ $filter('number')(lowerCutOffPrice, noOfDecimalsForRate)+"</span> " +  ' and ' + "<span class='hardcheck-value'>"+$filter('number')(higherCutOffPrice, noOfDecimalsForRate) +"</span> ";
                    errorObject.shortMessage = 'Equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price CCIL Hard check breached. Price should be between '+$filter('number')(lowerCutOffPrice, noOfDecimalsForRate) +  ' and ' +  $filter('number')(higherCutOffPrice, noOfDecimalsForRate);

                }
            }else{
                if(level=='user'){
                    if(errorObject.message!=''){
                        errorObject.message = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached User level limit price Hard check.</br> BUY and SELL Equivalent Spot Price should be between </br>' +"<span class='hardcheck-value'>"+ $filter('number')(lowerCutOffPrice, noOfDecimalsForRate)+"</span> " +  ' and ' +"<span class='hardcheck-value'>"+ $filter('number')(higherCutOffPrice, noOfDecimalsForRate) +"</span> ";
                    }else{
                        errorObject.message = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached User level limit price Hard check.</br> SELL Equivalent Spot Price should be between </br>' + "<span class='hardcheck-value'>"+$filter('number')(lowerCutOffPrice, noOfDecimalsForRate) +"</span> "+  ' and ' +"<span class='hardcheck-value'>"+ $filter('number')(higherCutOffPrice, noOfDecimalsForRate)+"</span> ";
                        errorObject.shortMessage = 'Equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price User level Hard check breached. Price should be between '+$filter('number')(lowerCutOffPrice, noOfDecimalsForRate) +  ' and ' +  $filter('number')(higherCutOffPrice, noOfDecimalsForRate);
                    }
                }else{
                    if(errorObject.message!=''){
                        errorObject.message = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached CCIL limit price Hard check.</br> BUY and SELL Equivalent Spot Price should be between </br>' +"<span class='hardcheck-value'>"+ $filter('number')(lowerCutOffPrice, noOfDecimalsForRate)+"</span> " +  ' and ' +"<span class='hardcheck-value'>"+ $filter('number')(higherCutOffPrice, noOfDecimalsForRate)+"</span> ";
                    }else{
                        errorObject.message = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached CCIL limit price Hard check.</br> SELL Equivalent Spot Price should be between </br>' +"<span class='hardcheck-value'>"+ $filter('number')(lowerCutOffPrice, noOfDecimalsForRate)+"</span> " +  ' and ' + "<span class='hardcheck-value'>"+$filter('number')(higherCutOffPrice, noOfDecimalsForRate)+"</span> ";
                        errorObject.shortMessage = 'Equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price CCIL Hard check breached. Price should be between '+$filter('number')(lowerCutOffPrice, noOfDecimalsForRate) +  ' and ' +  $filter('number')(higherCutOffPrice, noOfDecimalsForRate);

                    }
                }
            }
            isValid = false;
        }
        return isValid;
    }

    function validateSpreadUsed(selectedBankSpread, instrumentCode, buySellFlag){
        var errorString ='';
        var isValid = true;
        if(instrumentCode!='SPOT'){
            var tickSize = gettickSizeForGivenInstrument(instrumentCode);
            var settlementDate = getSettlementDate(instrumentCode, buySellFlag);
            var spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate(selectedBankSpread, instrumentCode, buySellFlag,
                DateUtils.convertLocalDateToServer(settlementDate), $rootScope.retailSpotMarketSession.settlementDate,
                tickSize);
            //var spreadUsed = getSpreadUsed(selectedBankSpread, buySellFlag, instrumentCode);
            if((spreadUsed==null || spreadUsed==undefined || spreadUsed=='') && spreadUsed!=0){
                if(buySellFlag=='BUYY'){
                    if(instrumentCode=='CASH'){
                        errorString = 'CASH/SPOT bid spread is not given by the bank. Order entry not possible...!';
                    }else if(instrumentCode=='TOM'){
                        errorString = 'TOM/SPOT bid spread is not given by the bank. Order entry not possible...!';
                    }else if(instrumentCode=='Forward'){
                        errorString = 'Order entry not possible as FORWARD offer spread for the selected settlement date ('+  $filter('date')(settlementDate,'dd-MMM-yyyy') +') is not provided by your Relationship bank.';
                    }
                }else if(buySellFlag=='SELL'){
                    if(instrumentCode=='CASH'){
                        errorString = 'CASH/SPOT offer spread is not given by the bank. Order entry not possible...!';
                    }else if(instrumentCode=='TOM'){
                        errorString = 'TOM/SPOT offer spread is not given by the bank. Order entry not possible...!';
                    }else if(instrumentCode=='Forward'){
                        errorString = 'Order entry not possible as FORWARD bid spread for the selected settlement date ('+  $filter('date')(settlementDate,'dd-MMM-yyyy') +') is not provided by your Relationship bank.';
                    }
                }
                isValid = false;
            }
        }
        return {
            isValid:isValid,
            errorString:errorString
        }
    }

    /* get settlemnt date based on the order type, instrument and tenor name*/
    function getSettlementDate( instrumentCode, orderType){
        var settlementDate = angular.copy($rootScope.tradeSettlementDateFororder);
        if( $rootScope.tenor !=null){
            console.log('instrumentCode - ' + instrumentCode + ' orderType - ' + orderType + ' tenorName - ' + $rootScope.tenor.tenorName);
        }
        if(instrumentCode == 'Forward' && $rootScope.tenor !=null && $rootScope.tenor != undefined && $rootScope.tenor.tenorName == 'Option Period'){
            if( orderType =="SELL" ){
                settlementDate = angular.copy($rootScope.tradeSettlementDateFrom);
            }else
            {
                settlementDate = angular.copy($rootScope.tradeSettlementDateFororder);
            }
        }
        return settlementDate;
    }

    function getEventTypeForShortName(eventTypeShortName){
        var eventType = {};
        angular.forEach($rootScope.eventTypes, function(value){
            if(value.shortName==eventTypeShortName){
                eventType = value;
            }
        })
        return eventType;
    }
    function getCloseTimeForInstrumentCode(instrument){
        if(instrument=='SPOT'){
            return $rootScope.retailSpotMarketSession.sessionTimingsDTO.closeTime;
        }else if(instrument=='CASH'){
            return $rootScope.cashMarketSession.sessionTimingsDTO.closeTime;
        }else if(instrument=='TOM'){
            return $rootScope.tomMarketSession.sessionTimingsDTO.closeTime;
        }else if(instrument=='Forward'){
            return $rootScope.forwardMarketSession.sessionTimingsDTO.closeTime;
        }
    }

    function validateOrderDTOIsNull (orderDTO){
        //validate sett. date should be fall in holiday
        var isValid = true;
        var errorString = "";
        var errorShortString = "";

        // do validateion only if forwards and option period is true else skip validation
        if(orderDTO.instrumentCode != 'Forward' ||  (orderDTO.instrumentCode == 'Forward' && orderDTO.isOptionPeriod != true ) ){
            return {
                isValid: true,
                errorString : errorString
            }
        }

            if(orderDTO.activityIndicator == null || orderDTO.activityIndicator == undefined ){
                errorString = 'Activity Indicator should be NULL ...!';
                errorShortString = 'Activity Indicator  cannot be NULL;';
        		isValid = false;

            }else if( orderDTO.bankId == null || orderDTO.bankId == undefined){
                errorString = 'Bank Id should be NULL ...!';
                errorShortString = 'Bank Id  cannot be NULL;';
        		isValid = false;

            }else if( orderDTO.bankMemberNumber == null || orderDTO.bankMemberNumber == undefined){
                errorString = 'Bank Member Number should be NULL ...!';
                errorShortString = 'Bank Member Number  cannot be NULL;';
        		isValid = false;
              }else if( orderDTO.branchCode == null || orderDTO.branchCode == undefined){
                errorString = 'Branch Code should be NULL ...!';
                errorShortString = 'Branch Code  cannot be NULL;';
        		isValid = false;
               }else if( orderDTO.branchId == null || orderDTO.branchId == undefined ){
                errorString = 'Branch Id should be NULL ...!';
                errorShortString = 'Branch Id  cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.buySellIndicator == null || orderDTO.buySellIndicator == undefined){
                errorString = 'Buy Sell Indicator should be NULL ...!';
                errorShortString = 'Buy Sell Indicator  cannot be NULL;';
        		isValid = false;
                }else if(orderDTO.customerCode == null || orderDTO.customerCode == undefined){
                errorString = 'Customer Code should be NULL ...!';
                errorShortString = 'Customer Code  cannot be NULL;';
        		isValid = false;
               }else if( orderDTO.customerId == null || orderDTO.customerId == undefined){
                errorString = 'Customer Id should be NULL ...!';
                errorShortString = 'Customer Id  cannot be NULL;';
        		isValid = false;
                }else if(orderDTO.eventType == null || orderDTO.eventType == undefined){
                errorString = 'Event Type should be NULL ...!';
                errorShortString = 'Event Type  cannot be NULL;';
        		isValid = false;
               }else if( orderDTO.eventTypeId == null || orderDTO.eventTypeId == undefined){
                errorString = 'Event Type Id should be NULL ...!';
                errorShortString = 'Event Type Id  cannot be NULL;';
        		isValid = false;
               }else if( orderDTO.expiryTime == null || orderDTO.expiryTime == undefined){
                errorString = 'Expiry Time should be NULL ...!';
                errorShortString = 'Expiry Time  cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.instrumentCode == null || orderDTO.instrumentCode == undefined){
                errorString = 'Instrument Code should be NULL ...!';
                errorShortString = 'Instrument Code  cannot be NULL;';
        		isValid = false;
               }else if( orderDTO.instrumentId == null || orderDTO.instrumentId == undefined){
                errorString = 'Instrument Id should be NULL ...!';
                errorShortString = 'Instrument Id  cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.limitExchangeRate == null || orderDTO.limitExchangeRate == undefined){
                errorString = 'Limit Exchange Rate should be NULL ...!';
                errorShortString = 'Limit Exchange Rate cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.orderAmount == null || orderDTO.orderAmount == undefined){
                errorString = 'Order Amount should be NULL ...!';
                errorShortString = 'Order Amount cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.retailUserCode == null || orderDTO.retailUserCode == undefined){
                errorString = 'Retail User Code should be NULL ...!';
                errorShortString = 'Retail User Code cannot be NULL;';
        		isValid = false;
                }else if(orderDTO.stopExchangeRate == null || orderDTO.stopExchangeRate == undefined){
                errorString = 'Stop Exchange Rate should be NULL ...!';
                errorShortString = 'Stop Exchange Rate cannot be NULL;';
        		isValid = false;
                }else if(orderDTO.timeLimitIndicator == null || orderDTO.timeLimitIndicator == undefined){
                errorString = 'Time Limit Indicator should be NULL ...!';
                errorShortString = 'Time Limit Indicator  cannot be NULL;';
        		isValid = false;
               }else if( orderDTO.typeOfOrder == null || orderDTO.typeOfOrder == undefined){
                errorString = 'Type Of Orderr should be NULL ...!';
                errorShortString = 'Type Of Order cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.userEntityOwnerId == null || orderDTO.userEntityOwnerId == undefined){
                errorString = 'User Entity Owner Id should be NULL ...!';
                errorShortString = 'User Entity Owner Id  cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.userId == null || orderDTO.userId == undefined ){
                errorString = 'User Id should be NULL ...!';
                errorShortString = 'User Id Indicator  cannot be NULL;';
        		isValid = false;

            }else if( orderDTO.settlementIFSCCode == null ||orderDTO.settlementIFSCCode == undefined){
                errorString = 'Settlement IFSC Code should be NULL ...!';
                errorShortString = 'Settlement IFSC Code  cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.deliveryMode == null || orderDTO.deliveryMode == undefined ){
                errorString = 'Delivery Mode should be NULL ...!';
                errorShortString = 'Delivery Mode  cannot be NULL;';
        		isValid = false;
                }else if(orderDTO.noOfTrades == null || orderDTO.noOfTrades == undefined ){
                errorString = 'No Of Trades should be NULL ...!';
                errorShortString = 'No Of Trades  cannot be NULL;';
        		isValid = false;
            } else if (orderDTO.tradeTotalPrice == null || orderDTO.tradeTotalPrice == undefined) {
                errorString = 'Trade Total Price should be NULL ...!';
                errorShortString = 'Trade Total Price  cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.sourceAppId == null|| orderDTO.sourceAppId == undefined){
                errorString = 'Source App Id should be NULL ...!';
                errorShortString = 'Source App Id  cannot be NULL;';
        		isValid = false;
            }
            return {
                isValid: isValid,
                errorString : errorString,
                errorShortString : errorShortString
            }
        }

           function getIndexBasedOnInstrument(instrumentCode){

if (instrumentCode === 'SPOT') {
    return 0;
} else if (instrumentCode === 'TOM') {
   return 1;
} else if (instrumentCode === 'CASH') {
  return 2;
}

        }


    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("MarketWatch", MarketWatch);

    MarketWatch.$inject = ['$sessionStorage', '$filter','$rootScope'];

    function MarketWatch($sessionStorage, $filter,$rootScope) {

        var NA_LimitTenorTypeId = 1;
        var MAXIMUMTENORVALUE_LimitTenorTypeId = 2;
        var MAXIMUMVALUEDATE_LimitTenorTypeId = 3;

    	var service = {
    		getTickerPrice: getTickerPrice,
    		getDefaultBankSwapQuotes: getDefaultBankSwapQuotes,
    		getRetailSpotMarketDepth: getRetailSpotMarketDepth,
            updateFCYMarketWatch:updateFCYMarketWatch,
    		getIBSpotMarketDepth: getIBSpotMarketDepth,
    		getRetailSpotMarketWatch: getRetailSpotMarketWatch,
    		getIBSpotMarketWatch: getIBSpotMarketWatch,
    		getMarketWatchForGivenInstrument: getMarketWatchForGivenInstrument,
    		getBankSwapQuotesInPrice: getBankSwapQuotesInPrice,
    		getMarketDepth: getMarketDepth,
            getSpreadForTenorAndSettlementDate: getSpreadForTenorAndSettlementDate,
            getBestBidOfferForUserMarketWatch: getBestBidOfferForUserMarketWatch,
            getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice: getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice,
            fillTenorNameAndSettlementDate: fillTenorNameAndSettlementDate,
            getTenorNameForSettlementDateInUserMarketWatch: getTenorNameForSettlementDateInUserMarketWatch,
            fillBidOfferSpreadInUserMarketWatch: fillBidOfferSpreadInUserMarketWatch,
            fillBidOfferPriceInUserMarketWatch: fillBidOfferPriceInUserMarketWatch,
            getAndFillBidOfferSpreadForDateInUserMarketWatch: getAndFillBidOfferSpreadForDateInUserMarketWatch,
            sortOutrightRatesList: sortOutrightRatesList,
            gettickSizeForGivenInstrument: gettickSizeForGivenInstrument,
            getInstrumentCodeForSettlement: getInstrumentCodeForSettlement,
            computeTenorDatesForGivenCreditFactorSettingsHeaderList: computeTenorDatesForGivenCreditFactorSettingsHeaderList,
            computeTenorDatesForGivenCreditFactorSettingsHeader: computeTenorDatesForGivenCreditFactorSettingsHeader,
            getCreditFactorValue: getCreditFactorValue,
            getCreditFactorSettingsForGivenBank: getCreditFactorSettingsForGivenBank,
            computeLimitAmountApplyingCreditFactor: computeLimitAmountApplyingCreditFactor,
            getMaxForwardTenorDate: getMaxForwardTenorDate,
            addDaysToGivenDate: addDaysToGivenDate,
            syncMarketData: syncMarketData

    	};
    	return service;
    	
    	/*function getTickerPrice(marketDepth, currentTickerPrice, previousDayClosingPriceForSpot, previousDayClosingPriceForIbSpot){
    		var tickerPrice = {};
    		tickerPrice = angular.copy(currentTickerPrice);
    		//angular.forEach(marketDepth, function(value){
    			if(marketDepth!=null && marketDepth!=undefined){
    				if(marketDepth.instrumentID==3){
    					tickerPrice.retailSpot = marketDepth.ltp;
    					if(marketDepth.ltp > 0){
    						if(currentTickerPrice.retailSpot>0 && marketDepth.ltt!=tickerPrice.lttSpot){
        						tickerPrice.retailSpotDifference = marketDepth.ltp - currentTickerPrice.retailSpot;	
    						}else if(currentTickerPrice.retailSpot<=0){
        						tickerPrice.retailSpotDifference = marketDepth.ltp - previousDayClosingPriceForSpot;	
    						}
    					}else{
    						tickerPrice.retailSpot = previousDayClosingPriceForSpot;
    						tickerPrice.retailSpotDifference = 0;
    					}
    					if(marketDepth.ltt!=null && marketDepth.ltt!=undefined && marketDepth.ltt!=''){
    						tickerPrice.lttSpot = marketDepth.ltt;
    					}
					}else if(marketDepth.instrumentID==4){
    					tickerPrice.ibSpot = marketDepth.ltp;
    					if(marketDepth.ltp > 0){
    						if(currentTickerPrice.ibSpot > 0 && marketDepth.ltt!=tickerPrice.lttIbSpot){
        						tickerPrice.ibSpotDifference = marketDepth.ltp - currentTickerPrice.ibSpot;	
    						}if(currentTickerPrice.ibSpot<=0){
    							if(previousDayClosingPriceForIbSpot!=null && previousDayClosingPriceForIbSpot!=undefined){
    								tickerPrice.ibSpotDifference = marketDepth.ltp - previousDayClosingPriceForIbSpot;
    							}
    						}
    					}else{
    						if(previousDayClosingPriceForIbSpot!=null && previousDayClosingPriceForIbSpot!=undefined){
        						tickerPrice.ibSpot = previousDayClosingPriceForIbSpot;
    						}
    						tickerPrice.ibSpotDifference = 0;
    					}
    					if(marketDepth.ltt!=null && marketDepth.ltt!=undefined && marketDepth.ltt!=''){
    						tickerPrice.lttIbSpot = marketDepth.ltt;
    					}
					}
    			}
    		//});
    		return tickerPrice;
    	}*/
    	
    	function getTickerPrice(marketDepth, currentTickerPrice, previousDayClosingPriceForSpot, previousDayClosingPriceForIbSpot){
    		var tickerPrice = {};
    		tickerPrice = angular.copy(currentTickerPrice);
    		//angular.forEach(marketDepth, function(value){
    			if(marketDepth!=null && marketDepth!=undefined){
    				if(marketDepth.instrumentID==3){
    					tickerPrice.retailSpot = marketDepth.ltp;
    					if(marketDepth.ltp > 0){
    						if(tickerPrice.retailSpot>0){
    							tickerPrice.retailSpotDifference = marketDepth.ltp - previousDayClosingPriceForSpot;
    						}
    					}else{
    						if(previousDayClosingPriceForSpot!=null && previousDayClosingPriceForSpot!=undefined){
        						tickerPrice.retailSpot = previousDayClosingPriceForSpot;
    						}
    						tickerPrice.retailSpotDifference = 0;
    					}
					}else if(marketDepth.instrumentID==4){
    					tickerPrice.ibSpot = marketDepth.ltp;
    					if(marketDepth.ltp > 0){
    						if(tickerPrice.ibSpot > 0){
    							if(previousDayClosingPriceForIbSpot!=null && previousDayClosingPriceForIbSpot!=undefined){
    								tickerPrice.ibSpotDifference = marketDepth.ltp - previousDayClosingPriceForIbSpot;
    							}else{
    								tickerPrice.ibSpotDifference = 0;
    							}
    						}
    					}else{
    						if(previousDayClosingPriceForIbSpot!=null && previousDayClosingPriceForIbSpot!=undefined){
        						tickerPrice.ibSpot = previousDayClosingPriceForIbSpot;
    						}
    						tickerPrice.ibSpotDifference = 0;
    					}
					}else{

var tickerPrice = $rootScope.tickerPriceFCY[marketDepth.sequenceNo];

//  create new object if not present
if (!tickerPrice) {
    tickerPrice = {
        ltp: 0,
        difference: 0,
        previousDayPrice : 0
    };
}

if (marketDepth.ltp && marketDepth.ltp > 0) {
    tickerPrice.ltp = marketDepth.ltp;

    if (tickerPrice.previousDayPrice != null) {
        tickerPrice.difference = tickerPrice.ltp - tickerPrice.previousDayPrice;
    } else {
        tickerPrice.difference = 0;
    }

} else {
    if (tickerPrice.previousDayPrice != null) {
        tickerPrice.ltp = tickerPrice.previousDayPrice;
    }

    tickerPrice.difference = 0;
}


    $rootScope.tickerPriceFCY[marketDepth.sequenceNo] =  tickerPrice;

                    }
    			}
    		//});
    		return tickerPrice;
    	}
    	
    	//get default or selected trading bank
    	function getDefaultBankSwapQuotes(swapQuotesList, defaultTradingBankId){
    		//loop swap quotes list
    		//match the bank of the swap quotes with default bank
    		//get that bank swap quotes and return
    		var defaultBankSwapQuotes = [];
    		angular.forEach(swapQuotesList, function(value){
    			if(value.bank.id==defaultTradingBankId){
    				defaultBankSwapQuotes = value.swapQuotesForTenorDatesList;
    			}
    		});
    		return defaultBankSwapQuotes;
    	}
    	
    	function getRetailSpotMarketDepth(marketDepth){
    		//loop market depth
    		//get retailSpot market depth and return
			var spotMarketDepth = {};
            var ibSpotMarketDepth = {};
            var fcyMarketDepth = [];
    		angular.forEach(marketDepth, function(value){
                if (value.baseCurrency === 'USD') {
    			if(value.instrumentID == 3){
    				var details = getMarketDepthDetails(value);
    				spotMarketDepth = value;
    				spotMarketDepth.marketDepthDetails = details;
                    

                    $rootScope.retailSpotMarketDepth = spotMarketDepth;
    			}
                else if(value.instrumentID == 4){
    				var details = getMarketDepthDetails(value);
    				ibSpotMarketDepth = value;
    				ibSpotMarketDepth.marketDepthDetails = details;
                    $rootScope.ibSpotMarketDepth = ibSpotMarketDepth;
    			}
            }
            else{
                if(
    $rootScope.currencyPairInstrumentDetails &&
    (
      Object.keys($rootScope.currencyPairInstrumentDetails).length === 0 ||
      $rootScope.currencyPairInstrumentDetails[value.currencyPairId]
    )
  ){
            value.marketDepthDetails = getMarketDepthDetails(value);
            fcyMarketDepth.push(value);
  }
            }
        }
    		)
    		$rootScope.fcyMarketDepthArray = fcyMarketDepth;
    		/*var spotMaketDepth = {};
    		if(marketDepth!=null && marketDepth!=undefined && marketDepth.length > 1){
        		spotMaketDepth = marketDepth[1];
    		}
    		return spotMaketDepth;*/
    	}

        function updateFCYMarketWatch(fcyMarketDepth){
            angular.forEach(fcyMarketDepth, function (depth) {
 					//if(depth.baseCurrency!=='USD'){
                          updateRetailSpotMarketWatch(depth);
					//}
 });

        }


function updateRetailSpotMarketWatch(retailSpotMarketDepth) {
    if (!retailSpotMarketDepth) return;

    var currencyId = retailSpotMarketDepth.currencyPairId;
    var instrumentCode = retailSpotMarketDepth.instrumentCode;

    if (!currencyId || !instrumentCode) return;

    // Get existing object from map
    var obj = $rootScope.marketWatchMap[currencyId];

    if (!obj) {
        obj = {
            baseCurrency: retailSpotMarketDepth.baseCurrency,
            instruments: [null, null, null] // SPOT, TOM, CASH
        };
    }

    var marketWatch = getRetailSpotMarketWatch(retailSpotMarketDepth);
    marketWatch.instrumentCode = instrumentCode;
    
    marketWatch.tokenSequenceNo = retailSpotMarketDepth.sequenceNo;
	
    switch (instrumentCode.toUpperCase()) {
        case "SPOT":
            obj.instruments[0] = marketWatch;
            break;
        case "TOM":
            obj.instruments[1] = marketWatch;
            break;
        case "CASH":
            obj.instruments[2] = marketWatch;
            break;
        default:
            console.warn("Unknown instrumentCode:", instrumentCode);
    }
    
             $rootScope.marketWatchMap[currencyId] =  obj;

             $rootScope.marketArray = Object.entries($rootScope.marketWatchMap);
}

function syncMarketData() {
  const instrumentMap = $rootScope.currencyPairInstrumentDetails || {};

  Object.keys($rootScope.marketWatchMap || {}).forEach(function(key) {
    const item = $rootScope.marketWatchMap[key];

    if (
      !item ||
      (
        item.currencyPairId !== 1 &&
        !instrumentMap[item.currencyPairId]
      )
    ) {
      delete $rootScope.marketWatchMap[key];
    }
  });

  $rootScope.marketArray = Object.entries($rootScope.marketWatchMap || {});
}

    	
    	function getIBSpotMarketDepth(marketDepth){
    		//loop market depth
    		//get IB spot market depth and return
    		var ibSpotMarketDepth = [];
    		angular.forEach(marketDepth, function(value){
    			if(value.instrumentID == 4){
    				var details = getMarketDepthDetails(value);
    				ibSpotMarketDepth = value;
    				ibSpotMarketDepth.marketDepthDetails = details;
    			}
    		})
    		return ibSpotMarketDepth;
    	}
    	
    	//get market depth from market depth dto coming from push notification server
    	function getMarketDepth(marketDepthDTO){
    		var marketDepth = {};
			var details = getMarketDepthDetails(marketDepthDTO);
			marketDepth = marketDepthDTO;
			marketDepth.marketDepthDetails = details;
			return marketDepth;
    	}
    	
    	function getMarketDepthDetails(marketDepth){
    		var spotMarketDepth = [];
    		angular.forEach(marketDepth.bidDetails, function(value, index){
    			if(spotMarketDepth.length>index){
					spotMarketDepth[index].bidPrice = value.price;
					spotMarketDepth[index].bidVolume = value.volume;
    			}else{
        			var spotMarketDepthDetail = {};
        			//spotMarketDepthDetail.levelNo = value.levelNo;
    				spotMarketDepthDetail.bidPrice = value.price;
    				spotMarketDepthDetail.bidVolume = value.volume;
        			spotMarketDepth.push(spotMarketDepthDetail);
    			}
    		})
    		
    		angular.forEach(marketDepth.offerDetails, function(value, index){
    			if(spotMarketDepth.length>index){
					spotMarketDepth[index].offerPrice = value.price;
					spotMarketDepth[index].offerVolume = value.volume;
    			}else{
        			var spotMarketDepthDetail = {};
        			//spotMarketDepthDetail.levelNo = value.levelNo;
    				spotMarketDepthDetail.offerPrice = value.price;
    				spotMarketDepthDetail.offerVolume = value.volume;
        			spotMarketDepth.push(spotMarketDepthDetail);
    			}
    		})
    		
    		return spotMarketDepth;
    		
    	}

     	
    	function getRetailSpotMarketWatch(retailSpotMarketDepth){
    		//loop market depth
    		//get first record of the market depth 
    		//fill best bid price, offer price, last traded bid qty, last traded offer qty to variable and return it.
    		var retailSpotMarketWatch = {};
    		if(retailSpotMarketDepth!=null && retailSpotMarketDepth!=undefined){
    			if(retailSpotMarketDepth.marketDepthDetails!=null && retailSpotMarketDepth.marketDepthDetails!=undefined && retailSpotMarketDepth.marketDepthDetails.length>0){
    				if(retailSpotMarketDepth.marketDepthDetails[0].bidPrice>0){
        				retailSpotMarketWatch.bidPrice = retailSpotMarketDepth.marketDepthDetails[0].bidPrice.toString();
    				}
    				if(retailSpotMarketDepth.marketDepthDetails[0].offerPrice>0){
        				retailSpotMarketWatch.offerPrice = retailSpotMarketDepth.marketDepthDetails[0].offerPrice.toString();
    				}
    				retailSpotMarketWatch.bidVolume = retailSpotMarketDepth.marketDepthDetails[0].bidVolume;
    				retailSpotMarketWatch.offerVolume = retailSpotMarketDepth.marketDepthDetails[0].offerVolume;
    			}
    		}
    		return retailSpotMarketWatch;
    	}
    	
    	function getIBSpotMarketWatch(ibSpotMarketDepth){
    		//loop market depth
    		//get first record of the market depth 
    		//fill best bid price, offer price, last traded bid qty, last traded offer qty to variable and return it. 
    		var ibSpotMarketWatch = {};
    		if(ibSpotMarketDepth!=null && ibSpotMarketDepth!=undefined){
    			if(ibSpotMarketDepth.marketDepthDetails!=null && ibSpotMarketDepth.marketDepthDetails!=undefined && ibSpotMarketDepth.marketDepthDetails.length>0){
    				if(ibSpotMarketDepth.marketDepthDetails[0].bidPrice>0){
        				ibSpotMarketWatch.bidPrice = ibSpotMarketDepth.marketDepthDetails[0].bidPrice.toString();
    				}
    				if(ibSpotMarketDepth.marketDepthDetails[0].offerPrice>0){
        				ibSpotMarketWatch.offerPrice = ibSpotMarketDepth.marketDepthDetails[0].offerPrice.toString();
    				}
    				ibSpotMarketWatch.bidVolume = ibSpotMarketDepth.marketDepthDetails[0].bidVolume;
    				ibSpotMarketWatch.offerVolume = ibSpotMarketDepth.marketDepthDetails[0].offerVolume;
    			}
    		}
    		return ibSpotMarketWatch;
    	}
    	
    	/*function getMarketWatchForGivenInstrument(retailSpotMarketDepth, defaultBankSpread, instrument){
    		//compute cash/tom market watch by using retailSpot market watch and bank spread
    		//bid value for cash/tom = bid value of retailSpot mkt - offer spread cash/tom
    		//offer value for cash/tom = offer value of retailSpot mkt - bid spread cash/tom
    		var marketWatch = {};
			if(retailSpotMarketDepth.ltp!=null && retailSpotMarketDepth.ltp!=undefined){
	    		if(instrument=='CASH'){
	        		marketWatch.bidPrice = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(retailSpotMarketDepth.ltp, defaultBankSpread.cashSpotOfferSpread);
	        		marketWatch.offerPrice = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(retailSpotMarketDepth.ltp, defaultBankSpread.cashSpotBidSpread);
	    		}else if(instrument=='TOM'){
	        		marketWatch.bidPrice = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(retailSpotMarketDepth.ltp, defaultBankSpread.tomSpotOfferSpread);
	        		marketWatch.offerPrice = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(retailSpotMarketDepth.ltp, defaultBankSpread.tomSpotBidSpread);
	    		}
	    		marketWatch.bidVolume = retailSpotMarketDepth.ltq;
	    		marketWatch.offerVolume = retailSpotMarketDepth.ltq; 
			}
    		return marketWatch;
    	}*/
    	
    	function getMarketWatchForGivenInstrument(retailSpotMarketWatch, defaultBankSpread, instrument){
    		//compute cash/tom market watch by using retailSpot market watch and bank spread
    		//bid value for cash/tom = bid value of retailSpot mkt - offer spread cash/tom
    		//offer value for cash/tom = offer value of retailSpot mkt - bid spread cash/tom
    		var marketWatch = {};
			if(retailSpotMarketWatch.bidVolume!=null && retailSpotMarketWatch.offerVolume!=undefined){
	    		if(instrument=='CASH'){
	        		marketWatch.bidPrice = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(retailSpotMarketWatch.bidPrice, defaultBankSpread.cashSpotOfferSpread);
	        		marketWatch.offerPrice = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(retailSpotMarketWatch.offerPrice, defaultBankSpread.cashSpotBidSpread);
	    		}else if(instrument=='TOM'){
	        		marketWatch.bidPrice = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(retailSpotMarketWatch.bidPrice, defaultBankSpread.tomSpotOfferSpread);
	        		marketWatch.offerPrice = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(retailSpotMarketWatch.offerPrice, defaultBankSpread.tomSpotBidSpread);
	    		}
	    		marketWatch.bidVolume = retailSpotMarketWatch.bidVolume;
	    		marketWatch.offerVolume = retailSpotMarketWatch.offerVolume; 
			}
    		return marketWatch;
    	}
    	
    	function getBankSwapQuotesInPrice(swapQuotesForTenorDatesInPrice, spotMarketWatch){
            var swapQuotesInPrice = angular.copy(swapQuotesForTenorDatesInPrice);
            if(swapQuotesInPrice.tenorName=='CASH' || swapQuotesInPrice.tenorName=='TOM'){
                var isBestBid = angular.copy(swapQuotesInPrice.isBestBid);
                var isBestOffer = angular.copy(swapQuotesInPrice.isBestOffer);
                if(isBestBid){
                    swapQuotesInPrice.isBestOffer = true;
                    if(!isBestOffer){
                        swapQuotesInPrice.isBestBid = false;
                    }
                }
                if(isBestOffer){
                    swapQuotesInPrice.isBestBid = true;
                    if(!isBestBid){
                        swapQuotesInPrice.isBestOffer = false;
                    }
                }
                var bidSpread = swapQuotesInPrice.bidSpread;
                var offerSpread = swapQuotesInPrice.offerSpread;
                swapQuotesInPrice.bidSpread = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(spotMarketWatch.bidPrice,offerSpread);
                swapQuotesInPrice.offerSpread = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(spotMarketWatch.offerPrice,bidSpread);
            }else{
                var isBestBid = angular.copy(swapQuotesInPrice.isBestBid);
                var isBestOffer = angular.copy(swapQuotesInPrice.isBestOffer);
                var bidSpread = angular.copy(swapQuotesInPrice.bidSpread);
                var offerSpread = angular.copy(swapQuotesInPrice.offerSpread);

                //for forward, if bid spread is best, then offer price will be the best, 
                //so, alter spread is taken as best here
                /*if(isBestBid){
                    swapQuotesInPrice.isBestOffer = true;
                    swapQuotesInPrice.isBestBid = false;
                }
                if(isBestOffer){
                    swapQuotesInPrice.isBestBid = true;
                    swapQuotesInPrice.isBestOffer = false;
                }*/
                if(offerSpread!=null && offerSpread!=undefined){
                    var forwardOfferSpread = offerSpread * -1;
                    swapQuotesInPrice.offerSpread = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(spotMarketWatch.offerPrice,forwardOfferSpread);
                }else{
                    swapQuotesInPrice.offerSpread = null;
                }

                if(bidSpread!=null && bidSpread!=undefined){
                    var forwardBidSpread = bidSpread * -1;
                    swapQuotesInPrice.bidSpread = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(spotMarketWatch.bidPrice,forwardBidSpread);
                }else{
                    swapQuotesInPrice.bidSpread = null;
                }
            }

            return swapQuotesInPrice;
    	}
    	
    	function getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(price, spread){
    		if(spread!=null && spread!=undefined && price!=null && price!= undefined && price!=''){
        		var eqvPrice = (Math.round(parseFloat(price)*10000)/10000) -  ((Math.round(parseFloat(spread)*100)/100)/100);
        		if(eqvPrice>0){
        			return (Math.round(parseFloat(eqvPrice)*10000)/10000);
        		}else{
        			return null;
        		}
    		}else{
    			return null;
    		}
    		
    	}

        //get best bid/offer for user market watch having broken date tenor
        function getBestBidOfferForUserMarketWatch(userMarketWatch, bankComparativeDTO, spotDate, tickSize){
            var bankQuoteList = [];
            userMarketWatch.isBestBid = false;
            userMarketWatch.isBestOffer = false;
            if(userMarketWatch.bidSpread!=null || userMarketWatch.offerSpread!=null){
                //get best bid/offer only when customer has more than one trading bank
                //hence check swapQuotesTenorDateDTOList lenght is more than one
                if(bankComparativeDTO!=null && bankComparativeDTO!=undefined 
                    && bankComparativeDTO.swapQuotesTenorDateDTOList!=null 
                     && bankComparativeDTO.swapQuotesTenorDateDTOList.length>1){
                    angular.forEach(bankComparativeDTO.swapQuotesTenorDateDTOList, function(swapQuotesTenorDateDTO){
                        var bankQuote = {};

                        var bidBuySellFlag = 'BUYY';
                        var offerBuySellFlag = 'SELL';
                        if(userMarketWatch.instrument=='Forward'){
                            bidBuySellFlag = 'SELL';
                            offerBuySellFlag = 'BUYY';
                        }
                        //since spread computation is for forward, buySellFlag is SELL for bidSpread & BUYY for offerSpread
                        bankQuote.bidSpread = getSpreadForTenorAndSettlementDate(swapQuotesTenorDateDTO.swapQuotesForTenorDatesList, 
                            userMarketWatch.instrument, bidBuySellFlag, userMarketWatch.settlementDate, spotDate, tickSize);
                        bankQuote.offerSpread = getSpreadForTenorAndSettlementDate(swapQuotesTenorDateDTO.swapQuotesForTenorDatesList, 
                            userMarketWatch.instrument, offerBuySellFlag, userMarketWatch.settlementDate, spotDate, tickSize);
                        bankQuoteList.push(bankQuote);
                    })
                    //get best bid and offer spread
                    var bestBidSpread = null;
                    var bestOfferSpread = null;
                    bestBidSpread = Math.max.apply(Math,bankQuoteList.map(function(item){return item.bidSpread;}).filter(function(val){return val !== null}));
                    bestOfferSpread = Math.min.apply(Math,bankQuoteList.map(function(item){return item.offerSpread;}).filter(function(val){return val !== null}));

                    //check best Bid/Offer should not be null and equal to bid/Offer spread of user market watch
                    if(bestBidSpread!=null && bestBidSpread!=undefined && userMarketWatch.bidSpread==bestBidSpread){
                        if(userMarketWatch.instrument=='Forward'){
                            userMarketWatch.isBestOffer = true;    
                        }else{
                            userMarketWatch.isBestBid = true;
                        }
                        
                    }
                    if(bestOfferSpread!=null && bestOfferSpread!=undefined && userMarketWatch.offerSpread==bestOfferSpread){
                        if(userMarketWatch.instrument=='Forward'){
                            userMarketWatch.isBestBid = true;    
                        }else{
                            userMarketWatch.isBestOffer = true;
                        }
                        
                    }
                }
            }
            return userMarketWatch;
        }
    	
        function getSpreadForTenorAndSettlementDate(defaultBankSpread, tenor, buyOrSell, settlementDate, spotDate, tickSize){
            var spread = null;
            if(tenor!='Forward'){
                var spreadForTenor = _.filter(angular.copy(defaultBankSpread), { 'tenorName': tenor });
                if(spreadForTenor!=null && spreadForTenor!=undefined && spreadForTenor.length>0){
                    if(buyOrSell=='BUYY' || buyOrSell=='MODIFYBUY'){
                        spread = spreadForTenor[0].bidSpread;
                    }else{
                        spread = spreadForTenor[0].offerSpread;
                    }
                }
                return spread;
            }else{
                if(settlementDate > spotDate){
                    var spreadForTenor = _.filter(angular.copy(defaultBankSpread), { 'settlementDate': settlementDate });
                    if(spreadForTenor!=null && spreadForTenor!=undefined && spreadForTenor.length>0){
                        if(buyOrSell=='BUYY' || buyOrSell=='MODIFYBUY'){
                            spread = spreadForTenor[0].offerSpread;
                        }else{
                            spread = spreadForTenor[0].bidSpread;
                        }
                    }
                    if(spread!=null && spread!=undefined){
                        return spread;
                    }else{
                        spread = getSpreadUsingInterpolation(defaultBankSpread, buyOrSell, settlementDate, spotDate, tickSize);
                        return spread;
                    }
                }else{
                    return null;
                }
            }
        }

        function getSpreadUsingInterpolation(defaultBankSpread, buyOrSell, settlementDate, spotDate, tickSize){
            var bankSpreadForComputation = angular.copy(defaultBankSpread);
            var swapQuoteDefined = getSwapQuoteListDefined(bankSpreadForComputation, buyOrSell);

            if(swapQuoteDefined.length>0){
                var lastTenorDate = swapQuoteDefined[swapQuoteDefined.length-1].settlementDate;
                if(settlementDate>lastTenorDate){
                    return null;
                }else{
                    var nextTenor = getNextTenor(swapQuoteDefined, buyOrSell, settlementDate);
                    var previousTenor =  getPreviousTenor(swapQuoteDefined, buyOrSell, settlementDate, spotDate);
                    var spread = getTenorRate(previousTenor, nextTenor, buyOrSell, settlementDate, tickSize);
                    return spread;
                }
            }else{
                return null;
            }
        }

        function getSwapQuoteListDefined(bankSpreadList, buyOrSell){
            var swapQuoteDefined = [];
            if(buyOrSell=='BUYY' || buyOrSell=='MODIFYBUY'){
                swapQuoteDefined = _.filter(bankSpreadList, function(bankSpread) {
                                            return (bankSpread.offerSpread!=null && bankSpread.offerSpread!=undefined);
                                        });
            }else{
                swapQuoteDefined = _.filter(bankSpreadList, function(bankSpread) {
                                            return (bankSpread.bidSpread!=null && bankSpread.bidSpread!=undefined);
                                        });
            }
            return swapQuoteDefined;
        }

        function getNextTenor(swapQuoteDefined, buyOrSell, settlementDate){
            var nextTenorList = _.filter(swapQuoteDefined, function(swapQuote){
                return (swapQuote.settlementDate>settlementDate);
            });
            var nextTenor = nextTenorList[0];
            return nextTenor;
        }

        function getPreviousTenor(swapQuoteDefined, buyOrSell, settlementDate, spotDate){
            var previousTenorList = _.filter(swapQuoteDefined, function(swapQuote){
                return (swapQuote.settlementDate<settlementDate);
            });
            
            var previousTenor = null;
            
            if(previousTenorList.length==0 || previousTenorList[previousTenorList.length-1].tenorName=='TOM' || previousTenorList[previousTenorList.length-1].tenorName=='CASH'){
                var tenor = {};
                tenor.settlementDate = spotDate;
                tenor.offerSpread = 0;
                tenor.bidSpread = 0;
                tenor.tenorName = 'SPOT';
                previousTenor = tenor;
            }else{
                previousTenor = previousTenorList[previousTenorList.length-1];
            }

            return previousTenor;
        }

        function getTenorRate(previousTenor, nextTenor, buyOrSell, settlementDate, tickSize){
            var nextTenorSpread = null;
            var previousTenorSpread = null;
            if(buyOrSell=='BUYY' || buyOrSell=='MODIFYBUY'){
                nextTenorSpread = nextTenor.offerSpread;
                previousTenorSpread = previousTenor.offerSpread;
            }else{
                nextTenorSpread = nextTenor.bidSpread;
                previousTenorSpread = previousTenor.bidSpread;
            }

            var diffBetweenSettDateAndPreviousTenor = getDifferenceBetweenDatesInDays(settlementDate, previousTenor.settlementDate);
            var diffBetweenNextTenorAndPreviousTenor = getDifferenceBetweenDatesInDays(nextTenor.settlementDate, previousTenor.settlementDate);

            var spreadUsed = previousTenorSpread + diffBetweenSettDateAndPreviousTenor * ((nextTenorSpread - previousTenorSpread)/(diffBetweenNextTenorAndPreviousTenor))
            spreadUsed = (Math.round(parseFloat(spreadUsed)*100)/100);
    
            var spreadUsedRemainder = (Math.round(parseFloat(((Math.round(parseFloat(spreadUsed)*100)) % (Math.round(parseFloat(tickSize)*10000))/100))*100)/100);
            if(spreadUsedRemainder!=0){
                var halfTickSize = (Math.round(parseFloat(tickSize)*10000)/100) / 2;
                if(Math.abs(angular.copy(spreadUsedRemainder))>=halfTickSize){
                    if(spreadUsedRemainder<0){
                        spreadUsed = (Math.round(parseFloat(spreadUsed)*100)/100) - (Math.round(parseFloat(spreadUsedRemainder)*10000)/10000) + (Math.round(parseFloat(tickSize * -1)*10000)/100);    
                    }else{
                        spreadUsed = (Math.round(parseFloat(spreadUsed)*100)/100) - (Math.round(parseFloat(spreadUsedRemainder)*10000)/10000) + (Math.round(parseFloat(tickSize)*10000)/100);    
                    }
                }else{
                    spreadUsed = (Math.round(parseFloat(spreadUsed)*100)/100) - (Math.round(parseFloat(spreadUsedRemainder)*10000)/10000);
                }
            }else{
                spreadUsed = (Math.round(parseFloat(spreadUsed)*10000)/10000);
            }            
            return spreadUsed;
        }

        function getDifferenceBetweenDatesInDays(fromDate, toDate){
            var start = moment(fromDate, "YYYY-MM-DD");
            var end = moment(toDate, "YYYY-MM-DD");

            //Difference in number of days
            var differenceInDays = moment.duration(start.diff(end)).asDays();
            return differenceInDays;
        }

        //fill tenor name and settlement date in user market watch list
        function fillTenorNameAndSettlementDate(userMarketWatch, userMarketWatchFromDB, tenors, cashMarketSession, tomMarketSession){
            if(userMarketWatchFromDB.tenorSettlementDateDetails!=null &&
                userMarketWatchFromDB.tenorSettlementDateDetails!=undefined){
                //if tenorSettlementDateDetails is not null, set tenor name and settlement date from the obj
                userMarketWatch.tenorName = userMarketWatchFromDB.tenorSettlementDateDetails.tenorName;
                userMarketWatch.settlementDate = userMarketWatchFromDB.tenorSettlementDateDetails.settlementDate;
                if(userMarketWatch.tenorName=='CASH' || userMarketWatch.tenorName=='TOM'){
                    userMarketWatch.instrument = userMarketWatch.tenorName;
                }else{
                    userMarketWatch.instrument = 'Forward';
                }
            }else{
                //if tenorSettlementDateDetails is null, then its a broken date tenor, 
                //to get tenor name for broken date tenor
                userMarketWatch.tenorName = getTenorNameForSettlementDateInUserMarketWatch(userMarketWatchFromDB.settlementDate, tenors, cashMarketSession, tomMarketSession)
                userMarketWatch.instrument = 'Forward';
            }
            return userMarketWatch;
        }

        //get tenor name for settlement date to display in user market watch list
        function getTenorNameForSettlementDateInUserMarketWatch(settlementDate, tenors, cashMarketSession, tomMarketSession){
            var tenorName = '';
            angular.forEach(tenors, function(value){
                if(value.settlementDate==settlementDate){
                    tenorName = value.tenorName;
                }
            })
            if(tenorName==null || tenorName == undefined || tenorName == '' || tenorName == 'Broken Date'){
                if(settlementDate==tomMarketSession.settlementDate){
                    tenorName = 'TOM';
                }else if(settlementDate==cashMarketSession.settlementDate){
                    tenorName = 'CASH';
                }else{
                    tenorName = $filter('date')(new Date(settlementDate),'ddMMMyy')
                }
                
            }
            return tenorName;
        }

        //fill bid offer spread in user market watch
        function fillBidOfferSpreadInUserMarketWatch(userMarketWatch, bankComparativeDTO, defaultBankSpread, spotDate, tickSize){
            //filter default bank quotes with tenor name, if it is found, then bid/offer spread and best bid/offer flag is taken from the obj filtered.
            if(userMarketWatch.tenorSettlementDateDetails!=null && userMarketWatch.tenorSettlementDateDetails!=undefined){
                var spreadForTenor = _.filter(angular.copy(defaultBankSpread), { 'tenorName': userMarketWatch.tenorSettlementDateDetails.tenorName });
                if(spreadForTenor!=null && spreadForTenor!=undefined && spreadForTenor.length>0){
                    userMarketWatch.bidSpread = spreadForTenor[0].bidSpread;
                    userMarketWatch.offerSpread = spreadForTenor[0].offerSpread;
                    userMarketWatch.isBestBid = false;
                    userMarketWatch.isBestOffer = false;
                    if(userMarketWatch.instrument=='Forward'){ 
                    //for forward, if bid spread is best, then offer price will be the best, 
                    //so, alter spread is taken as best here
                        /*if(spreadForTenor[0].isBestBid){
                            userMarketWatch.isBestOffer = true;
                            userMarketWatch.isBestBid = false;
                        }
                        if(spreadForTenor[0].isBestOffer){
                            userMarketWatch.isBestBid = true;
                            userMarketWatch.isBestOffer = false;
                        }*/
                        //get spread if it is not defined.
                        var bidSpread = angular.copy(userMarketWatch.bidSpread);
                        var offerSpread = angular.copy(userMarketWatch.offerSpread);
                        if(userMarketWatch.bidSpread==null || userMarketWatch.bidSpread==undefined){
                            userMarketWatch.bidSpread = getSpreadForTenorAndSettlementDate(defaultBankSpread, userMarketWatch.instrument, 'SELL', 
                            userMarketWatch.settlementDate, spotDate, tickSize);
                        }
                        if(userMarketWatch.offerSpread==null || userMarketWatch.offerSpread==undefined){
                            userMarketWatch.offerSpread = getSpreadForTenorAndSettlementDate(defaultBankSpread, userMarketWatch.instrument, 'BUYY', 
                            userMarketWatch.settlementDate, spotDate, tickSize);
                        }
                        //if(bidSpread==null || bidSpread==undefined || offerSpread==null || offerSpread==undefined){
                        userMarketWatch = getBestBidOfferForUserMarketWatch(userMarketWatch, bankComparativeDTO, spotDate, tickSize);    
                        //}
                    }else{
                        // userMarketWatch.isBestBid = spreadForTenor[0].isBestBid;
                        // userMarketWatch.isBestOffer = spreadForTenor[0].isBestOffer;
                        userMarketWatch = getBestBidOfferForUserMarketWatch(userMarketWatch, bankComparativeDTO, spotDate, tickSize);
                    }
                }
            }else{ //if not found, get bid offer spread using interpolation method
                 userMarketWatch = getAndFillBidOfferSpreadForDateInUserMarketWatch(userMarketWatch, bankComparativeDTO, defaultBankSpread, spotDate, tickSize);
            }
            return userMarketWatch;
        }

        //get and fill bid offer spread for given date in user market watch
        function getAndFillBidOfferSpreadForDateInUserMarketWatch(userMarketWatch, bankComparativeDTO, defaultBankSpread, spotDate, tickSize){
            var bidBuySellFlag = 'BUYY';
            var offerBuySellFlag = 'SELL';
            if(userMarketWatch.instrument=='Forward'){ //for forward bid spread is computed for offer, offer spread is computed for bid
                bidBuySellFlag = 'SELL';
                offerBuySellFlag = 'BUYY';
            }

            //get bid and offer spread using interpolation method
            userMarketWatch.bidSpread = getSpreadForTenorAndSettlementDate(defaultBankSpread, userMarketWatch.instrument, bidBuySellFlag, 
            userMarketWatch.settlementDate, spotDate, tickSize);
            userMarketWatch.offerSpread = getSpreadForTenorAndSettlementDate(defaultBankSpread, userMarketWatch.instrument, offerBuySellFlag, 
            userMarketWatch.settlementDate, spotDate, tickSize);

            //get best bid/offer for user market watch (broken date tenor)
            userMarketWatch = getBestBidOfferForUserMarketWatch(userMarketWatch, bankComparativeDTO, spotDate, tickSize);
            return userMarketWatch;
        }

        //fill bid offer price in user market watch
        function fillBidOfferPriceInUserMarketWatch(userMarketWatch, retailSpotMarketWatch){
            userMarketWatch.bidPrice = null;
            userMarketWatch.offerPrice = null;
            if(userMarketWatch.offerSpread!=null && userMarketWatch.offerSpread!=undefined){
                if(userMarketWatch.instrument!='Forward'){
                    userMarketWatch.bidPrice = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(retailSpotMarketWatch.bidPrice, userMarketWatch.offerSpread);
                }else{ //for forward instrument, bid spread is used to compute offer price
                    userMarketWatch.offerPrice = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(retailSpotMarketWatch.offerPrice, (userMarketWatch.offerSpread * -1));
                }
            }

            if(userMarketWatch.bidSpread!=null && userMarketWatch.bidSpread!=undefined){
                if(userMarketWatch.instrument!='Forward'){
                    userMarketWatch.offerPrice = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(retailSpotMarketWatch.offerPrice, userMarketWatch.bidSpread);
                }else{ //for forward instrument, offer spread is used to compute bid price
                    userMarketWatch.bidPrice = getEquivalentInstrumentPriceForGivenSpreadAndSpotPrice(retailSpotMarketWatch.bidPrice, (userMarketWatch.bidSpread * -1));
                }
            }
            return userMarketWatch;
        }

        function sortOutrightRatesList(outrightsList){
            var outrightRatesList = angular.copy(outrightsList);
            var sortedOutrightRatesList = [];
            var bestBidOfferBankArr = [];
            var bestBidBankArr = [];
            var bestOfferBankArr = [];
            var nonBestBankArr = [];
            var bestBidBank = null;
            var bestOfferBank = null;

            angular.forEach(outrightRatesList, function(value, index){
                if(value.isBestBid==true && value.isBestOffer==true){
                    bestBidOfferBankArr.push(value);
                }else if(value.isBestBid==true){
                    bestBidBankArr.push(value);
                }else if(value.isBestOffer==true){
                    bestOfferBankArr.push(value);
                }else{
                    nonBestBankArr.push(value);
                }

                // if(value.isBestBid==true){
                //     bestBidBank = value.bank;
                //     sortedOutrightRatesList.push(value); //push best bid bank
                // }
                // if(value.isBestOffer==true){
                //     bestOfferBank = value.bank;
                //     if(bestBidBank!=bestOfferBank){
                //         sortedOutrightRatesList.push(value); //push best offer bank
                //     }
                // }
            });

            if(bestBidOfferBankArr.length>0){
                sortedOutrightRatesList = sortedOutrightRatesList.concat(bestBidOfferBankArr);
            }

            if(bestBidBankArr.length>0){
                sortedOutrightRatesList = sortedOutrightRatesList.concat(bestBidBankArr);
            }

            if(bestOfferBankArr.length>0){
                sortedOutrightRatesList = sortedOutrightRatesList.concat(bestOfferBankArr);
            }

            if(nonBestBankArr.length>0){
                sortedOutrightRatesList = sortedOutrightRatesList.concat(nonBestBankArr);
            }

            // angular.forEach(outrightRatesList, function(outright1, index1){ //remove best bid bank from org list
            //     if(outright1.bank==bestBidBank){
            //         outrightRatesList.splice(index1,1);
            //     }
            // })

            // angular.forEach(outrightRatesList, function(outright2, index2){ //remove best bid bank from org list
            //     if(outright2.bank==bestOfferBank){
            //         outrightRatesList.splice(index2,1);
            //     }
            // })

            // angular.forEach(outrightRatesList, function(outright3){ //add other banks
            //     sortedOutrightRatesList.push(outright3);
            // })

            // outrightsList = sortedOutrightRatesList;

            return sortedOutrightRatesList;
        }

        // get tick size
        function gettickSizeForGivenInstrument(instrumentCode, tickSize){
            if(instrumentCode=='SPOT'){
                return tickSize.spot;
            }else if(instrumentCode=='CASH'){
                return tickSize.cash;
            }else if(instrumentCode=='TOM'){
                return tickSize.tom;
            }else if(instrumentCode=='Forward'){
                return tickSize.forward;
            }
        }

        //get instrument code for settlement date
        function getInstrumentCodeForSettlement(tradeSettlementDate, tenors, retailSpotMarketSession, cashMarketSession, tomMarketSession){
            var tenor = null;
            angular.forEach(tenors, function(value){
                if(value.settlementDate==tradeSettlementDate){
                    tenor = value;
                }
            })
            if(tenor==null || tenor == undefined){
                if(tradeSettlementDate==retailSpotMarketSession.settlementDate){
                    return 'SPOT';
                }else if(tradeSettlementDate==cashMarketSession.settlementDate){
                    return 'CASH';
                }else if(tradeSettlementDate==tomMarketSession.settlementDate){
                    return 'TOM';
                }else {
                    tenor = tenors[0];
                    return 'Forward';
                }
            }else{
                return 'Forward';
            }
        }

        function computeTenorDatesForGivenCreditFactorSettingsHeaderList(creditFactorSettingsHeaderList, spotDate, cashDate){
            var computedCreditFactorSettingsHeaderList = angular.copy(creditFactorSettingsHeaderList);
            angular.forEach(computedCreditFactorSettingsHeaderList, function(header){

                header = computeTenorDatesForGivenCreditFactorSettingsHeader(header, spotDate, cashDate);

            });

            return computedCreditFactorSettingsHeaderList;

        }

        function computeTenorDatesForGivenCreditFactorSettingsHeader(creditFactorSettingsHeader, spotDate, cashDate){
            angular.forEach(creditFactorSettingsHeader.creditFactorSettingsDetailsList, function(detail, index){
                if(creditFactorSettingsHeader.tenorType=='Days'){
                    detail.tenorFromDate = addDaysToGivenDate(spotDate, detail.tenorFrom);
                    detail.tenorToDate = addDaysToGivenDate(spotDate, detail.tenorTo);
                }else{
                    detail.tenorFromDate = addDaysToGivenDate(spotDate, 1);
                    detail.tenorFromDate = addMonthsToGivenDate(detail.tenorFromDate, Number(detail.tenorFrom)-1);
                    detail.tenorToDate = addMonthsToGivenDate(spotDate, detail.tenorTo);
                }

                //set cash date as starting date for the first tenor. bcos CASH/TOM/SPOT may also comes in FRWD utilisation.
                if(index==0){
                    detail.tenorFromDate = cashDate;
                }
            });
            return creditFactorSettingsHeader;
        }

        function addDaysToGivenDate(tenorDate, tenorDays){
             var date = moment(tenorDate, 'YYYY-MM-DD');
             date.add(tenorDays, 'days');
             var resultdate = new Date(date.toDate());
             return resultdate;
        }

        function addMonthsToGivenDate(tenorDate, tenorMonths){
             var date = moment(tenorDate, 'YYYY-MM-DD');
             date.add(tenorMonths, 'months');
             var resultdate = new Date(date.toDate());
             return resultdate;
        }

        function getCreditFactorValueForGivenSettlementDate(settlementDate, creditFactorSettingsHeader, defaultCreditFactor){
            var creditFactor = defaultCreditFactor;
            if(creditFactorSettingsHeader!=null && creditFactorSettingsHeader!=undefined
                && creditFactorSettingsHeader.creditFactorSettingsDetailsList!=null 
                    && creditFactorSettingsHeader.creditFactorSettingsDetailsList!=undefined 
                    && creditFactorSettingsHeader.creditFactorSettingsDetailsList.length>0){

                angular.forEach(creditFactorSettingsHeader.creditFactorSettingsDetailsList, function(detail){
                    if((moment(detail.tenorFromDate).isSame(settlementDate, 'day') || moment(detail.tenorFromDate).isBefore(settlementDate, 'day'))
                        && (moment(detail.tenorToDate).isSame(settlementDate, 'day') || moment(detail.tenorToDate).isAfter(settlementDate, 'day'))){

                        creditFactor = detail.creditFactor;

                    }
                });
            }
            // return default credit factor from config ,if no tenors matches
            return creditFactor;
        }

        //get credit factor settings from given bank
        function getCreditFactorSettingsForGivenBank(creditFactorSettingsHeaderList, defaultTradingBankId){
            var creditFactorSettingsHeader = {};
            angular.forEach(creditFactorSettingsHeaderList, function(header){
                if(header.bank.id == defaultTradingBankId){
                    creditFactorSettingsHeader = header;
                }
            })
            return creditFactorSettingsHeader;
        }

        function getCreditFactorValue(instrumentCode, settlementDate, creditFactorSettingsHeader, defaultCreditFactor){
            var creditFactor = defaultCreditFactor;
            if(instrumentCode!='Forward'){
                //no need to compute
            }else{
                creditFactor = getCreditFactorValueForGivenSettlementDate(settlementDate, creditFactorSettingsHeader, defaultCreditFactor);
            }
            return creditFactor;
        }

        function computeLimitAmountApplyingCreditFactor(incomingLimitAmount, creditFactor){
            var cfAppliedLimit = incomingLimitAmount * (100/parseFloat(creditFactor));
            cfAppliedLimit = (Math.round(parseFloat(cfAppliedLimit)*100)/100); //to round off to 2 decimals
            return cfAppliedLimit;
        }

        function getMaxForwardTenorDate(limitDTO, spotDate){
            var maxTenorDate = null;
            if(limitDTO.limitTenorTypeId==NA_LimitTenorTypeId){
                //do nothing
            }else if(limitDTO.limitTenorTypeId==MAXIMUMTENORVALUE_LimitTenorTypeId){
                if(limitDTO.maximumTenorValue!=null && limitDTO.maximumTenorValue!=undefined){
                    if(limitDTO.maximumTenorType=='Days'){
                        maxTenorDate = addDaysToGivenDate(spotDate, limitDTO.maximumTenorValue);               
                    }else{
                        maxTenorDate = addMonthsToGivenDate(spotDate, limitDTO.maximumTenorValue);
                    }             
                }

            }else if(limitDTO.limitTenorTypeId==MAXIMUMVALUEDATE_LimitTenorTypeId){
                if(limitDTO.maximumValueDate!=null && limitDTO.maximumValueDate!=undefined){
                    maxTenorDate = new Date(limitDTO.maximumValueDate);    
                }
            }
            return maxTenorDate;
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('Market', Market);

    Market.$inject = ['$resource'];

    function Market ($resource) {
        var resourceUrl =  'api/market/:id';

        return $resource(resourceUrl, {}, {
            'getMarketDepth': {
                method: 'GET',
                isArray: true,
                url: 'api/market-depth-summary',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getLTPForLimits': {
                method: 'GET',
                isArray: true,
                url: 'api/ltp-for-limits',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getLTPForLimitsForInstrument': {
                method: 'GET',
                url: 'api/instrument/:instrument/ltp-for-limits',
                params: {instrument: '@instrument'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getDailyClosingPrice': {
                method: 'GET',
                isArray: true,
                url: 'api/daily-closing-price',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
			'placeOrder' : {
				method : 'POST',
				url : 'order/placeorderrequest',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
           	
			'modifyOrder' : {
				method : 'POST',
				url : 'order/modifyorderrequest',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
           	
			'cancelOrder' : {
				method : 'POST',
				url : 'order/cancelorderrequest',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'cancelOrderList' : {
				method : 'POST',
				url : 'order/cancelorderrequestlist',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'cancelOrderListWithSingleObject' : {
				method : 'POST',
				url : 'order/cancelorderrequestlistwithlistobject',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
            'cancelOrderListWithSingleObjectForClearCorp' : {
				method : 'POST',
				url : 'order/cancelorderrequestlistwithlistobjectforclearcorp',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
            'cancelAllPendingOrdersForClearCorp' : {
				method : 'POST',
				url : 'order/cancelAllPendingOrdersForClearCorp',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
            'getMarketSessionSettings': {
                method: 'GET',
                url: 'api/market-session-settings',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },'getCurrentDateTime': {

				method : 'GET',				
				url : 'api/current-date-time',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('StaticLookUp', StaticLookUp);

    StaticLookUp.$inject = ['$resource'];

    function StaticLookUp ($resource) {

    	 var resourceUrl =  'api/entity-owner-type';
        return $resource(resourceUrl,{}, {
        	'getAllHolidayType':{
        		 method: 'GET',
        		 url: 'api/get-holiday-types',
                 isArray: true,
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
        	},
        
            'getEntityOwnerTypes': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getEntityOwnerTypesForOrganisationType': {
                method: 'GET',
                url: 'api/organisationType/:organisationTypeId/entity-owner-type',
                params: {organisationTypeId: '@organisationTypeId'},
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getEntityOwnerTypesForUserEntityOwnerType': {
                method: 'GET',
                url: 'api/user-entity-owner-type/:entityOwnerTypeId/entity-owner-type',
                params: {entityOwnerTypeId: '@entityOwnerTypeId'},
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getEntityOwnerTypeForShortName': {
                method: 'GET',
                url: 'api/entityOwnerType/:entityOwnerType/entity-owner-type',
                params: {entityOwnerType: '@entityOwnerType'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getStatesForCountry': {
            	method: 'GET',
                url: 'api/public/country/:countryId/states-for-country',
                isArray: true,
                params: {countryId: '@countryId'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getCustomerTypes': {
                method: 'GET',
                isArray: true,
                url: 'api/public/customer-type',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAllCustomerTypes': {
                method: 'GET',
                isArray: true,
                url: 'api/public/all-customer-types',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getConfigSettings': {
                method: 'GET',
                url: 'api/configuration-settings',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getConfigSettingsPreLogin': {
                method: 'GET',
                url: 'api/configuration-settings-pre-login',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getHomeBranchDetails': {
                method: 'GET',
                isArray: true,
                async: false,
                url: 'api/public/home-branch-details/:filterText',
                params: {filterText: '@filterText'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getEntity': {
                method: 'GET',
                url:'api/entity/:entityOwnerType/entityOwnerType',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getCurrency': {
            	
            	method: 'GET',
                url:'api/currency',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
             },
              'getCurrencyLimit': {
            	
            	method: 'GET',
                url:'api/currency-limit',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
             },
            // 'getCurrencyPair': {
            	
            // 	method: 'GET',
            //     url:'api/currency-pair',
            //     isArray: true,
            //     transformResponse: function (data) {
            //         if (data) {
            //             data = angular.fromJson(data);
            //         }
            //         return data;
            //     }
            // },
             'getDayNumberList':{
        	   method: 'GET',
               url: 'api/day-number',
               isArray: true,
               transformResponse: function (data) {
                   if (data) {
                       data = angular.fromJson(data);
                   }
                   return data;
               }
           },
           'getWeekNumberList':{
        	   method: 'GET',
               url: 'api/week-number',
               isArray: true,
               transformResponse: function (data) {
                   if (data) {
                       data = angular.fromJson(data);
                   }
                   return data;
               }
           },
           'getMarkupTypes': {
                method: 'GET',
                isArray: true,
                url: 'api/markup-type',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getInstrumentType':{
            	isArray: true,
                url: 'api/instrument-type',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getLimitType':{
            	isArray: true,
                url: 'api/limit-type',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getOrderStatus':{
            	isArray: true,
                url: 'api/order-status',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getUserStatusExceptDelinked':{
                isArray: true,
                url: 'api/user-status-except-delinked',
                params: {selectedEntity: '@selectedEntity'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getSodWorkFlow' :{
            	isArray: true,
                url: 'api/sod-process-workflow',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getEodWorkFlow' :{
            	isArray: true,
                url: 'api/eod-process-workflow',
               /*transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }*/
            },
            'getErrorMessages' :{
            	isArray: true,
                url: 'api/error-messages',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getProcessErrorMessages' :{
            	isArray: true,
                url: 'api/process/error-messages',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getFinancialYear' :{
            	
                url: 'api/financial-year-details',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getCustomerChargesType':{
            	isArray: true,
                url: 'api/customer-charges-type',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getChargesType':{
            	isArray: true,
                url: 'api/charges-type',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getPastAndPresentFinancialYears':{
            	isArray: true,
                url: 'api/get-past-and-present-financial-years',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getTradesToBeSettledReportFilter':{
            	isArray: true,
                url: 'api/get-trades-to-be-settled-report-filter',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAlertTypes':{
            	isArray: true,
                url: 'api/get-alert-types',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getMarketInstrumentTypes':{
            	isArray: true,
                url: 'api/market-intrument-types',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getTenorsWithBrokenDate':{
                isArray: true,
                url: 'api/tenors-with-broken-date',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getTenorsForLookup':{
                isArray: true,
                url: 'api/tenors-lookup',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getEventTypeList':{
                isArray: true,
                url: 'api/event-type-list',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getTradeStatusList':{
                isArray: true,
                url: 'api/trade-status-list',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getLimitInstrumentGroupList':{
                isArray: true,
                url: 'api/limit-instrument-group-list',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getLimitReinstateTypeList':{
                isArray: true,
                url: 'api/limit-reinstate-type-list',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getLimitTenorTypeList':{
                isArray: true,
                url: 'api/limit-tenor-type-list',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRoEdApplicabilityMethodList':{
                isArray: true,
                url: 'api/ro-ed-applicability-method-list',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getCustomerTypeWiseInputDetails':{
                isArray: true,
                url: 'api/public/customer-type-wise-input-details',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getVersionNo':{
                isArray: false,
                url: 'api/public/version-no',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAllVirtualDemoDetails':{
                method: 'GET',
                isArray: true,
                url: 'api/public/get-all-virtual-demo-details',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAllRestrictionReaons':{
                isArray: true,
                url: 'api/get-restriction-reasons',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getsourceOfIntro': {
                method: 'GET',
                isArray: true,
                url: 'api/public/get-source-of-intro',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getStateobject': {
                method: 'GET',
                params: {stateName:'@stateName'},
                url: 'api/public/state-name/:stateName',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getBankCategory': {
                method: 'GET',
                isArray: true,
                url: 'api/public/get-bank-category',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },'getSourceAppList':{
                isArray: true,
                url: 'api/source-App-list',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getWaterMarkDetails':{
                isArray: false,
                url: 'api/public/watermark-details',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRecaptcha':{
                isArray: false,
                url: 'api/public/reCaptcha-details',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },            
            'getCurrencyPair':{
                isArray: true,
                 params: {bankId:'@bankId'},
                url: 'api/currency-pair/:bankId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
             'getOrderCurrencyPair':{
                isArray: true,
                 params: {bankId:'@bankId'},
                url: 'api/order-currency-pair/:bankId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getCurrencyPairInstruments':{
                isArray: true,
                 params: {bankId:'@bankId'},
                url: 'api/currency-pair/instrument/:bankId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getCodeCurrencyPair':{
                isArray: false,
                 params: {code:'@code'},
                url: 'api/currency-pair/code/:code',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        'transactionParametersSetting' : {
            isArray: true,
				method : 'GET',
				url : 'api/transaction-parameters-setting-all-currency',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
            'getFCYCurrencyPair':{
                isArray: true,
                 params: {bankId:'@bankId'},
                url: 'api/fcy-currency-pair/:bankId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getCurrencyPairBankName':{
                isArray: true,
                 params: {bankName:'@bankName'},
                url: 'api/currencyPair/bankName/:bankName',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
        
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ScreenLogService', ScreenLogService);

    ScreenLogService.$inject = ['$resource'];

    function ScreenLogService ($resource) {
        var resourceUrl =  '/api/screen-log';

        return $resource(resourceUrl, {}, {
            'screenLog': {
                method: 'GET',
                params: {entityName:'@entityName', entityRecordId:'@entityRecordId', action:'@action'},
                url: 'api/screen-log/:entityName/:entityRecordId/:action'
            },
            'screenActionLog': {
                method: 'GET',
                params: {screenLogId:'@screenLogId', action:'@action'},
                url: 'api/screen-action-log/:screenLogId/:action'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("ScreenLog", ScreenLog);

    ScreenLog.$inject = ['ScreenLogService'];

    function ScreenLog(ScreenLogService) {

        var corp = null;

    	var service = {
    		screenLog: screenLog,
    	};
    	return service;
    	
    	function screenLog(entityName, entityRecordId, action){
    		ScreenLogService.screenLog({entityName: entityName, entityRecordId:entityRecordId, action:action});
    	}
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("CSPLPagination", CSPLPagination);
       
    CSPLPagination.$inject = ['$rootScope'];

    function CSPLPagination ($rootScope) {
    	
		var pagableValuesCollection = {}
		var itemsPerPage = 10;
		var pagedValue = {};
		
    	var service = {
    			initialisePagination: initialisePagination,
    			getPagedValues: getPagedValues,
    			getItemsPerPage: getItemsPerPage,
    			setPage:setPage,
    			getTotalRecordCount: getTotalRecordCount
    	};
    	return service;
    	
    	function getItemsPerPage(paginationName){
    		return itemsPerPage;
    	}
    	
    	function getTotalRecordCount(paginationName){
    		return pagableValuesCollection[paginationName].length;
    	}
    	
    	function getPagedValues(paginationName){
    		return pagedValue[paginationName].values;
    	}
    	
    	function initialisePagination(paginationName, pagableValues){
    		pagableValuesCollection[paginationName] = pagableValues;
    	}
    	
    	function setPage(paginationName, currentPage){
      	  var begin = (currentPage - 1) * itemsPerPage;
    	  var end = begin + itemsPerPage;

	       pagedValue[paginationName] = {
	    	    values: pagableValuesCollection[paginationName].slice(begin, end)
	    	  }
	    };
    }
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ImportFileService', ImportFileService);

    ImportFileService.$inject = ['$resource'];

    function ImportFileService ($resource) {
        var resourceUrl =  '/api/screen-log';

        return $resource(resourceUrl, {}, {
		 'importFile': {
         	headers: {'Content-Type': undefined},	
         	method: 'POST', 
         	isArray: true,
             params: {uploadType:"@uploadType"},
             url: 'api/files/:uploadType/import',
             transformResponse: function (data) {
                 if (data) {
                     data = angular.fromJson(data);
                 }
                 return data;
             }
		 },
		 'orderImport': {
	         	headers: {'Content-Type': undefined},	
	         	method: 'POST', 
	         	isArray: true,
	             params: {uploadType:"@uploadType"},
	             url: 'order/files/:uploadType/import',
	             transformResponse: function (data) {
	                 if (data) {
	                     data = angular.fromJson(data);
	                 }
	                 return data;
	             }
			 }
        });
    }
})();

(function() {
	'use strict';

	angular.module('gatewayApp').service("ImportFile", ImportFile);

	ImportFile.$inject = [ 'ImportFileService', 'MessageBox', '$state', '$rootScope','GlobalValues'];

	function ImportFile(ImportFileService, MessageBox, $state, $rootScope,GlobalValues) {

		var corp = null;
		var uploadTypeName = null;
		var progressInstance = null;
		var service = {
			importFile : importFile,
			generateTemplate : generateTemplate,
			exportException : exportException
		};
		return service;

		function importFile(uploadType, fileContent) {
			if(uploadType == 'BankImport'){
				if(fileContent.name != 'BankImport.csv'){
					MessageBox.showMessageBox("Alert", "Invalid File Name", "Ok");
				}else {
					var fd = new FormData();
		        	fd.append("file", fileContent);
		        	console.log(fileContent);
		        	console.log(fd);
					uploadTypeName = uploadType;
					ImportFileService.importFile({"uploadType" : uploadType}, fd, onImportSuccess, onImportFailure);	
				}	
			}
			
			if(uploadType == 'BranchImport'){
				if(fileContent.name != 'BranchImport.csv'){
					MessageBox.showMessageBox("Alert", "Invalid File Name", "Ok");
				}else {
					var fd = new FormData();
		        	fd.append("file", fileContent);
		        	console.log(fileContent);
		        	console.log(fd);
					uploadTypeName = uploadType;
					ImportFileService.importFile({"uploadType" : uploadType}, fd, onImportSuccess, onImportFailure);	
				}	
			}
			
			if(uploadType == 'MarkupImport'){
				if(fileContent.name != 'MarkupImport.csv'){
					MessageBox.showMessageBox("Alert", "Invalid File Name", "Ok");
				}else {
					var fd = new FormData();
		        	fd.append("file", fileContent);
		        	console.log(fileContent);
		        	console.log(fd);
					uploadTypeName = uploadType;
					ImportFileService.importFile({"uploadType" : uploadType}, fd, onImportSuccess, onImportFailure);	
				}	
			}
			if(uploadType == 'LimitSettingsImport'){
				if(fileContent.name != 'LimitSettingsImport.csv'){
					MessageBox.showMessageBox("Alert", "Invalid File Name", "Ok");
				}else if(fileContent.size == 0){
					 MessageBox.showMessageBox("Alert", "Invalid File", "Ok");    
				}else {
					var fd = new FormData();
		        	fd.append("file", fileContent);
		        	console.log(fileContent);
		        	console.log(fd);
					uploadTypeName = uploadType;
					ImportFileService.orderImport({"uploadType" : uploadType}, fd, onImportSuccess, onImportFailure);	
				}	
			}
			if(uploadType == 'AMCImport'){
				if(fileContent.name != 'AMCImport.csv'){
					MessageBox.showMessageBox("Alert", "Invalid File Name", "Ok");
				}else {
					var fd = new FormData();
		        	fd.append("file", fileContent);
		        	console.log(fileContent);
		        	console.log(fd);
					uploadTypeName = uploadType;
					ImportFileService.importFile({"uploadType" : uploadType}, fd, onImportSuccess, onImportFailure);	
				}	
			}
			if(uploadType == 'OneTimeRegistrationChargesImport'){
				if(fileContent.name != 'OneTimeRegistrationChargesImport.csv'){
					MessageBox.showMessageBox("Alert", "Invalid File Name", "Ok");
				}else {
					var fd = new FormData();
		        	fd.append("file", fileContent);
		        	console.log(fileContent);
		        	console.log(fd);
					uploadTypeName = uploadType;
					ImportFileService.importFile({"uploadType" : uploadType}, fd, onImportSuccess, onImportFailure);	
				}	
			}
			if(uploadType == 'GSTSettingsImport'){
				if(fileContent.name != 'GSTSettingsImport.csv'){
					MessageBox.showMessageBox("Alert", "Invalid File Name", "Ok");
				}else {
					var fd = new FormData();
		        	fd.append("file", fileContent);
		        	console.log(fileContent);
		        	console.log(fd);
					uploadTypeName = uploadType;
					ImportFileService.importFile({"uploadType" : uploadType}, fd, onImportSuccess, onImportFailure);	
				}	
			}
			
			if(uploadType == 'TransactionChargesImport'){
				if(fileContent.name != 'TransactionChargesImport.csv'){
					MessageBox.showMessageBox("Alert", "Invalid File Name", "Ok");
				}else {
					var fd = new FormData();
		        	fd.append("file", fileContent);
		        	console.log(fileContent);
		        	console.log(fd);
					uploadTypeName = uploadType;
					ImportFileService.importFile({"uploadType" : uploadType}, fd, onImportSuccess, onImportFailure);	
				}	
			}

			if(uploadType == 'HomeBranchImport'){
				if(fileContent.name != 'homebranchupload.xls' && fileContent.name != 'homebranchupload.xlsx'  ){
					MessageBox.showMessageBox("Alert", "Invalid File Name", "Ok");
				}else {
					$rootScope.homebranchUploadInProgress = true;
					progressInstance = MessageBox
						.showMessageBox(
								"Alert",
								"Upload is in progress... Please wait",
								"autocloseImport");
					var fd = new FormData();
		        	fd.append("file", fileContent);
		        	console.log(fileContent);
		        	console.log(fd);
					uploadTypeName = uploadType;
					ImportFileService.importFile({"uploadType" : uploadType}, fd, onImportSuccess, onImportFailure);	
				}	
			}
			if(uploadType == 'SwapQuotesImport'){
				if(fileContent.name != 'SwapQuotesImport.csv'){
					MessageBox.showMessageBox("Alert", "Invalid File Name", "Ok");
				}else {
					var fd = new FormData();
		        	fd.append("file", fileContent);
		        	console.log(fileContent);
		        	console.log(fd);
					uploadTypeName = uploadType;
					ImportFileService.importFile({"uploadType" : uploadType}, fd, onImportSuccess, onImportFailure);	
				}	
			}
			
		}
		
		

		function generateTemplate(uploadType) {

			if(uploadType == 'BankImport'){
                var csvstring = 'Bank Name,Bank Short Name,CCIL Membership ID,Bank Member No,NG Code,Date Of Joining (dd-MMM-yyyy),Permissible Users,Legal Name,Trade Name,Primary Contact Name,Primary Email,Primary Mobile Country Code,Primary Mobile,Address Line1,Address Line2,City,Postal Code,GSTIN,Country,State,Bank PAN,Bank Category,User1 First Name,User1 Middle Name,User1 Last Name,User1 Gender (M/F/O),User1 DOB (dd-MMM-yyyy),User1 Login Name,User1 Email,User1 Mobile Country Code,User1 Mobile,User1 Address Line1,User1 Address Line2,User1 City,User1 Country,User1 State,User1 Postal Code,User2 First Name,User2 Middle Name,User2 Last Name,User2 Gender (M/F/O),User2 DOB (dd-MMM-yyyy),User2 Login Name,User2 Email,User2 Mobile Country Code,User2 Mobile,User2 Address Line1,User2 Address Line2,User2 City,User2 Country,User2 State,User2 Postal Code';
                           	
            	//csv = 'test, test'
    			/*var uri = 'data:text/csv;charset=UTF-8,' + escape(csvstring);
    			var link = document.createElement("a");
    			link.href = uri;
    			
    			link.style = 'hidden';
    			link.download = uploadType + '.csv';*/
    			
    			var base64data = "base64," + $.base64.encode(csvstring);
                var blob = new Blob([csvstring], { type: "application/" + "csv" + ';' + base64data })
                window.saveAs(blob, uploadType + "."  + "csv");
//    			document.body.appendChild(link);
//    			link.click();
//    			document.body.removeChild(link);
			}
			
			if(uploadType == 'BranchImport'){
				var csvstring = 'Bank Name,Branch Name,Branch IFSC Or Swift Code,Primary Contact Name,Primary Email,Primary Mobile Country Code,Primary Mobile,Branch Customer Care No,Address1,Address2,City,Country,State,Postal Code,Is User1 Required?(TRUE/FALSE),User1 First Name,User1 Middle Name,User1 Last Name,User1 Gender (M/F/O),User1 DOB (dd-MMM-yyyy),User1 Login Name,User1 Email,User1 Mobile Country Code,User1 Mobile,User1 Address Line1,User1 Address Line2,User1 City,User1 Country,User1 State,User1 Postal Code,Is User2 Required?(TRUE/FALSE),User2 First Name,User2 Middle Name,User2 Last Name,User2 Gender (M/F/O),User2 DOB (dd-MMM-yyyy),User2 Login Name,User2 Email,User2 Mobile Country Code,User2 Mobile,User2 Address Line1,User2 Address Line2,User2 City,User2 Country,User2 State,User2 Postal Code';
                         	
            	//csv = 'test, test'
    			/*var uri = 'data:text/csv;charset=UTF-8,' + escape(csvstring);
    			
    			var link = document.createElement("a");
    			link.href = uri;
    			
    			link.style = 'hidden';
    			link.download = uploadType + '.csv';
    			
    			document.body.appendChild(link);
    			link.click();
    			document.body.removeChild(link);*/
    			var base64data = "base64," + $.base64.encode(csvstring);
                var blob = new Blob([csvstring], { type: "application/" + "csv" + ';' + base64data })
                window.saveAs(blob, uploadType + "."  + "csv");
			}
			
			if(uploadType == 'MarkupImport'){
				var csvstring = 'Branch Name,Cust ID,Markup Type,Markup Value,Tax on Markup (%),RO/ED Applicability';
                         	
            	//csv = 'test, test'
    			/*var uri = 'data:text/csv;charset=UTF-8,' + escape(csvstring);
    			
    			var link = document.createElement("a");
    			link.href = uri;
    			
    			link.style = 'hidden';
    			link.download = uploadType + '.csv';
    			
    			document.body.appendChild(link);
    			link.click();
    			document.body.removeChild(link);*/
    			var base64data = "base64," + $.base64.encode(csvstring);
                var blob = new Blob([csvstring], { type: "application/" + "csv" + ';' + base64data })
                window.saveAs(blob, uploadType + "."  + "csv");
			}
			if(uploadType == 'LimitSettingsImport'){
				var csvstring = 'Branch Name,Customer ID,Operation Type (Add/Edit/Reset To All/Reset To Spot/Reset To Forward),Limit to be set for (SpotWindow/Forward/All),' +
					'Limit Type (Global Gross/Gross Buy/Gross Sell/Net),Limit Currency Code (USD/INR),CASH Limit Amount,TOM Limit Amount,SPOT Limit Amount,Upto Spot Limit Amount,'+ 
					'FORWARD Limit Amount, ALL Instr. Limit Amount,Limit on Tenors Type (Not Applicable/Maximum Tenor/Maximum Value Date),Maximum Tenor Type (Days/Months),'+ 
					'Maximum Tenor (No of days/months),Maximum Value Date(dd-MMM-yyyy),Effective To date(dd-MMM-yyyy),Limit Reinstatement Method (Not Applicable/Daily/Settled Trades),Remarks';
				
            	//csv = 'test, test'
    			/*var uri = 'data:text/csv;charset=UTF-8,' + escape(csvstring);
    			
    			var link = document.createElement("a");
    			link.href = uri;
    			
    			link.style = 'hidden';
    			link.download = uploadType + '.csv';
    			
    			document.body.appendChild(link);
    			link.click();
    			document.body.removeChild(link);*/
    			var base64data = "base64," + $.base64.encode(csvstring);
                var blob = new Blob([csvstring], { type: "application/" + "csv" + ';' + base64data })
                window.saveAs(blob, uploadType + "."  + "csv");
			}
			if(uploadType == 'AMCImport'){
				var csvstring = 'Bank Name, AMC';
                         	
            	//csv = 'test, test'
    			/*var uri = 'data:text/csv;charset=UTF-8,' + escape(csvstring);
    			
    			var link = document.createElement("a");
    			link.href = uri;
    			
    			link.style = 'hidden';
    			link.download = uploadType + '.csv';
    			
    			document.body.appendChild(link);
    			link.click();
    			document.body.removeChild(link);*/
    			var base64data = "base64," + $.base64.encode(csvstring);
                var blob = new Blob([csvstring], { type: "application/" + "csv" + ';' + base64data })
                window.saveAs(blob, uploadType + "."  + "csv");
			}
			if(uploadType == 'OneTimeRegistrationChargesImport'){
				var csvstring = 'Customer Type, Charges';
                         	
            	//csv = 'test, test'
    			/*var uri = 'data:text/csv;charset=UTF-8,' + escape(csvstring);
    			
    			var link = document.createElement("a");
    			link.href = uri;
    			
    			link.style = 'hidden';
    			link.download = uploadType + '.csv';
    			
    			document.body.appendChild(link);
    			link.click();
    			document.body.removeChild(link);*/
    			var base64data = "base64," + $.base64.encode(csvstring);
                var blob = new Blob([csvstring], { type: "application/" + "csv" + ';' + base64data })
                window.saveAs(blob, uploadType + "."  + "csv");
			}
			if(uploadType == 'GSTSettingsImport'){
				var csvstring = 'State, CGST(in %), SGST(in %), IGST(in %), UTGST(in %)';
                         	
            	//csv = 'test, test'
    			/*var uri = 'data:text/csv;charset=UTF-8,' + escape(csvstring);
    			
    			var link = document.createElement("a");
    			link.href = uri;
    			
    			link.style = 'hidden';
    			link.download = uploadType + '.csv';
    			
    			document.body.appendChild(link);
    			link.click();
    			document.body.removeChild(link);*/
    			var base64data = "base64," + $.base64.encode(csvstring);
                var blob = new Blob([csvstring], { type: "application/" + "csv" + ';' + base64data })
                window.saveAs(blob, uploadType + "."  + "csv");
			}
			
			
			if(uploadType == 'TransactionChargesImport'){
				var csvstring = 'Customer Type, Cumulative Amount From, Cumulative Amount To, Charges %';
                         	
            	//csv = 'test, test'
    			/*var uri = 'data:text/csv;charset=UTF-8,' + escape(csvstring);
    			
    			var link = document.createElement("a");
    			link.href = uri;
    			
    			link.style = 'hidden';
    			link.download = uploadType + '.csv';
    			
    			document.body.appendChild(link);
    			link.click();
    			document.body.removeChild(link);*/
    			var base64data = "base64," + $.base64.encode(csvstring);
                var blob = new Blob([csvstring], { type: "application/" + "csv" + ';' + base64data })
                window.saveAs(blob, uploadType + "."  + "csv");
			}
			
			if(uploadType == 'SwapQuotesImport'){
				
				/*var csvstring = 'Instrument,Settlement Date,Bid Spread,Offer Spread';
    			var base64data = "base64," + $.base64.encode(csvstring);
                var blob = new Blob([csvstring], { type: "application/" + "csv" + ';' + base64data })
                window.saveAs(blob, uploadType + "."  + "csv");*/
			}
			
		}

		function onImportSuccess(result) {
			if(uploadTypeName == 'HomeBranchImport'){
				$rootScope.homebranchUploadInProgress = false;
				MessageBox.closeMessageBox("autocloseImport");
			}
				MessageBox.showMessageBox("Alert", " File has been uploaded successfully. ", "Ok");
			//$state.go($state.current, {}, {});
			
			
		}

		function onImportFailure(result) {
			if(uploadTypeName == 'HomeBranchImport'){
				$rootScope.homebranchUploadInProgress = false;
				MessageBox.closeMessageBox("autocloseImport");
			}
			console.log(result);
			if(result.data!="") {
        		exportException(result.data, true, uploadTypeName + '_error');
        	}else{
                MessageBox.showMessageBox("Alert",uploadTypeName + " - Invalid File", "Ok");    
        	}
			//$state.go($state.current, {}, {});
		}

		function exportException(JSONData, showHeader, fileName) {

			if (JSONData != "") {
				var arrData = typeof (JSONData) != 'object' ? JSON
						.parse(JSONData) : JSONData;
						var out = arrData[arrData.length-1];

				
						if (out == "failure") {
					MessageBox.showMessageBox("Alert",
							"File upload failed! Please check the error log. ",
							"Ok");
					generateFile(arrData,fileName);
				} 
					else if(out=="invalid"){
						MessageBox.showMessageBox("Alert",
								uploadTypeName + " - Invalid file",
								"Ok");
					}
										
				
					else {
					MessageBox
							.showMessageBox(
									"Alert",
									"Partial success! Please check the error log for the failed records.  ",
									"Ok");
					generateFile(arrData,fileName);
				}

				
			}

		}
		
		function generateFile(arrData,fileName){
			var csv = "";

			for (var i = 0; i <= arrData.length-2; i++) {

				var row = "";

				
				
				row += arrData[i];
				
				/*for ( var index in arrData[i]) {
					
				}
*/
				row = row.slice(0, row.length - 1);

				csv += row + '\r\n';

			}
			
			console.log(csv);

			if (csv != '') {
				//csv = 'test, test'
				/*var uri = 'data:text/csv;charset=UTF-8,' + escape(csv);

				var link = document.createElement("a");
				link.href = uri;

				link.style = 'hidden';
				link.download = fileName + '.csv';

				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);*/
    			//var base64data = "base64," + $.base64.encode(csv);
                //var blob = new Blob([csv], { type: "application/" + "csv" + ';' + base64data })
				var blob = new Blob([csv], { type: "application/" + "csv" })
                window.saveAs(blob, fileName + "."  + "csv");
			}
		}

	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("GlobalValues", GlobalValues);

    GlobalValues.$inject = ['$sessionStorage','OrganisationTypeEnum', 'CryptoUtil'];

    function GlobalValues($sessionStorage,OrganisationTypeEnum, CryptoUtil) {

        var corp = null;
        var entityOwnerType = null;
        var branch = null;
        var bank = null;
        var customer = null;
        var user = null;
        var configSettings = null;
        var systemSettings = null;
        var country=null;
        var errorMessages = null;
        var sessionTimedOut = false;
        var financialYear = null;
        var environmentName = '';
        var recaptchaSiteKey = '';

        var transactionParametersSettings = null;
        var transactionParametersSettingsMap = null;
        var defaultCurrencyPairId = null;

    	var service = {
    		getCorpId: getCorpId,
    		clearPreviousValues: clearPreviousValues,
    		setCorp: setCorp,
    		setEntityOwnerType:setEntityOwnerType,
    		setBranch:setBranch,
    		setBank:setBank,
    		setCustomer:setCustomer,
    		setUser:setUser,
    		setConfigurationSettings:setConfigurationSettings,
    		setSystemSettings:setSystemSettings,
    		setCountry:setCountry,
            setTransactionParametersSettings:setTransactionParametersSettings,

            setDefaultCurrencyPairId:setDefaultCurrencyPairId,
 		getCorporate: getCorporate,
    		getNumberOfDecimalsForRate:getNumberOfDecimalsForRate,
    		getNumberOfDecimalsForRateInReports:getNumberOfDecimalsForRateInReports,
    		getNumberOfDecimalsForInputRate : getNumberOfDecimalsForInputRate,
    		getNumberOfDecimalsForDays:getNumberOfDecimalsForDays,
    		getNumberOfDecimalsForPercent:getNumberOfDecimalsForPercent,
    		getNumberOfDecimalsForAmount:getNumberOfDecimalsForAmount,
    		getOrgId:getOrgId,
    		getEntityOwnerTypeId:getEntityOwnerTypeId,
    		getBranchId:getBranchId,
    		getBankId:getBankId,
    		getCustomerId:getCustomerId,
    		getUserId:getUserId,
    		getOrganisation:getOrganisation,
    		getEntityOwnerType:getEntityOwnerType,
    		getConfigSettings:getConfigSettings,
    		getSystemSettings:getSystemSettings,
    		getBranch:getBranch,
    		getBank:getBank,
    		getCustomer:getCustomer,
    		getUser:getUser,
    		getCountry:getCountry,
    		checkAndSetSelectedOrganisation:checkAndSetSelectedOrganisation,
    		checkAndSetSelectedEntityOwnerType:checkAndSetSelectedEntityOwnerType,
    		checkAndSetSelectedBranch:checkAndSetSelectedBranch,
    		checkAndSetSelectedBank:checkAndSetSelectedBank,
    		checkAndSetSelectedCustomer:checkAndSetSelectedCustomer,
    		checkAndSetSelectedUser:checkAndSetSelectedUser,
    		checkAndSetSelectedConfigurationSettings:checkAndSetSelectedConfigurationSettings,
    		checkAndSetSelectedSystemSettings:checkAndSetSelectedSystemSettings,
            checkAndSetSelectedTransactionParametersSettings:checkAndSetSelectedTransactionParametersSettings,
            checkAndSetSelectedDefaultCurrencyPairId : checkAndSetSelectedDefaultCurrencyPairId,
	        setSelectedUser:setSelectedUser,
    		getUserOrganisation:getUserOrganisation,
    		getNoOfRecordsPerPageInPagination:getNoOfRecordsPerPageInPagination,
    		checkAndSetSelectedCountry:checkAndSetSelectedCountry,
    		formatCamelCaseToStringWithSpace:formatCamelCaseToStringWithSpace,
    		checkAndSetErrorMessages : checkAndSetErrorMessages,
    		getErrorMessages:getErrorMessages,
    		setErrorMessages:setErrorMessages,
    		checkAndSetSelectedErrorMessages : checkAndSetSelectedErrorMessages,
    		getSessionTimedOut: getSessionTimedOut,
    		setSessionTimedOut: setSessionTimedOut,
    		getFinancialYear : getFinancialYear,
    		setFinancialYear : setFinancialYear,
    		checkAndSetSelectedFinancialYear : checkAndSetSelectedFinancialYear,
            getLoginUrlParam : getLoginUrlParam,
            getEnvironmentName:getEnvironmentName,
            getPlatformENCCode:getPlatformENCCode,
            getRecaptchaToken:getRecaptchaToken,
            checkAndSetRecaptchaSiteKey:checkAndSetRecaptchaSiteKey,
            getTransactionParametersSettings : getTransactionParametersSettings,
            getTransactionParameterValue: getTransactionParameterValue,
            getDefaultCurrencyPairId : getDefaultCurrencyPairId,
            getClearCorpTACPopup : getClearCorpTACPopup,
            setClearCorpTACPopup : setClearCorpTACPopup

    	};
    	return service;

    	function getNumberOfDecimalsForRate(){
    		return 4;
    	}

        function formatCamelCaseToStringWithSpace(camelCaseString){
        	if(camelCaseString.trim().indexOf(' ') > -1){
        		return camelCaseString;
        	}
        	else {
            	var CAMEL_CASE_REGEXP1 = /([A-Z]+)/g;
            	var CAMEL_CASE_REGEXP2 = /([A-Z][a-z])/g;
            	var separator = " ";
                return camelCaseString.replace(CAMEL_CASE_REGEXP1, separator + "$1").replace(CAMEL_CASE_REGEXP2, separator + "$1").trim();
        	}
        }
        //get enviramentName in configration settings
        function getEnvironmentName(){
            if($sessionStorage.configSettings!=null){
                checkAndSetEnvironmentName();
            }
            return environmentName;
        }
    	function getNumberOfDecimalsForRateInReports(){
    		return 2;
    	}
    	function getNumberOfDecimalsForInputRate(){
    		return 6;
    	}

        function getNumberOfDecimalsForDays() {
    		return 0;
    	}

        function getNumberOfDecimalsForPercent() {
    		return 3;
    	}
    	function getNumberOfDecimalsForAmount(){
    		return 2;
    	}

        function clearPreviousValues() {
            corp = null;
            entityOwnerType = null;
            branch = null;
            bank = null;
            customer = null;
            user = null;
            country=null;
            configSettings = null;
            systemSettings = null;
            errorMessages = null;
            sessionTimedOut = false;
            financialYear = null;
            environmentName = '';
            $sessionStorage.corp = null;
            $sessionStorage.entityOwnerType = null;
            $sessionStorage.branch = null;
            $sessionStorage.bank = null;
            $sessionStorage.customer = null;
            $sessionStorage.user = null;
            $sessionStorage.configSettings = null;
            $sessionStorage.systemSettings = null;
            $sessionStorage.country=null;
            $sessionStorage.errorMessages = null;
            $sessionStorage.sessionTimedOut = false;
            $sessionStorage.financialYear = null;
            recaptchaSiteKey = null;
            $sessionStorage.recaptchaSiteKey = null;
            $sessionStorage.transactionParametersSettings = null;
            $sessionStorage.isClearCorpTACPopupShowed = false;
    	}

        function setCorp(selectedcorp) {
    		corp = selectedcorp;
    		$sessionStorage.corp = selectedcorp;
        }



   	   	function setEntityOwnerType(selectedEntityOwnerType) {
   	   		entityOwnerType = selectedEntityOwnerType;
    		$sessionStorage.entityOwnerType = selectedEntityOwnerType;
        }

   	   	function setBranch(selectedBranch) {
   	   		branch = selectedBranch;
    		$sessionStorage.branch = selectedBranch;
        }

   	   	function setBank(selectedBank) {
   	   		bank = selectedBank;
    		$sessionStorage.bank = selectedBank;
        }

   	   	function setCustomer(selectedCustomer) {
   	   		customer = selectedCustomer;
    		$sessionStorage.customer = selectedCustomer;
        }

   	   	function setUser(selectedUser) {
   	   		user = selectedUser;
    		$sessionStorage.user = selectedUser;
        }


        function setRecaptchaToken(siteKey){
          recaptchaSiteKey = siteKey;
          $sessionStorage.recaptchaSiteKey = siteKey;
        }

        function getRecaptchaToken(){
            return $sessionStorage.recaptchaSiteKey;
        }

   	   	function setConfigurationSettings(selectedConfigSettings) {
   	   		configSettings = selectedConfigSettings;
    		$sessionStorage.configSettings = selectedConfigSettings;
        }

        function setSystemSettings(selectedSystemSettings) {
   	   		systemSettings = selectedSystemSettings;
    		$sessionStorage.systemSettings = selectedSystemSettings;
        }

        function setCountry(selectedCountry) {
   	   		country = selectedCountry;
    		$sessionStorage.country = selectedCountry;
        }

        function setFinancialYear(selectedFinancialYear) {
	   		 financialYear = selectedFinancialYear;
	 		$sessionStorage.financialYear = selectedFinancialYear;
	     }
        function setTransactionParametersSettings(selectedTransactionParametersSettings) {
   	   		transactionParametersSettings = selectedTransactionParametersSettings;
    		$sessionStorage.transactionParametersSettings = selectedTransactionParametersSettings;
            transactionParametersSettingsMap = buildTransactionParametersSettingsMap(selectedTransactionParametersSettings);
        }

        function buildTransactionParametersSettingsMap(selectedTransactionParametersSettings) {
            var transactionParameterMap = {};
            if (selectedTransactionParametersSettings) {
                angular.forEach(selectedTransactionParametersSettings, function (item) {
                    var currencyId = item.currencyPair.id;
                    if (!transactionParameterMap[currencyId]) {
                        transactionParameterMap[currencyId] = {};
                    }
                    transactionParameterMap[currencyId][item.shortName] = item;
                });
            }
            return transactionParameterMap;
        }

        function setDefaultCurrencyPairId(selectedDefaultCurrencyPairId) {
   	   		defaultCurrencyPairId = selectedDefaultCurrencyPairId;
    		$sessionStorage.defaultCurrencyPairId = selectedDefaultCurrencyPairId;
        }

        function getUserOrganisation() {
            return corp;
        }

        function getCorpId() {
            checkAndSetCorporate();
            return corp.id;
        }

        function getOrgId() {
            checkAndSetCorporate();
            return corp.id;
        }

        function getEntityOwnerTypeId() {
            checkAndSetEntityOwnerType();
            return entityOwnerType.id;
        }

        function getBranchId() {
            checkAndSetBranch();
            return branch.id;
        }

        function getBankId() {
            checkAndSetBank();
            return bank.id;
        }

        function getCustomerId() {
            checkAndSetCustomer();
            return customer.id;
        }

        function getUserId() {
            checkAndSetUser();
            return user.id;
        }

        function getNoOfRecordsPerPageInPagination() {
            return 10;
        }

        function checkAndSetSelectedOrganisation(selectedOrganisation) {
            //if ($sessionStorage.corp == null) {
                setCorp(selectedOrganisation);
            //} else {
            //    setCorp($sessionStorage.corp);
            //}
        }


        function checkAndSetRecaptchaSiteKey(siteKey){
            setRecaptchaToken(siteKey);
            if (siteKey && siteKey.recaptchaSiteKey && window.initializeRecaptcha) {
                var decryptedKey = CryptoUtil.decrypt(siteKey.recaptchaSiteKey, getPlatformENCCode());
                window.initializeRecaptcha(decryptedKey);
            }
        }

        function checkAndSetSelectedEntityOwnerType(selectedEntityOwnerType) {
//            if ($sessionStorage.entityOwnerType == null) {
                setEntityOwnerType(selectedEntityOwnerType);
//            } else {
//            	setEntityOwnerType($sessionStorage.entityOwnerType);
//            }
        }

        function checkAndSetSelectedBranch(selectedBranch) {
            //if ($sessionStorage.branch == null) {
                setBranch(selectedBranch);
            //} else {
            //	setBranch($sessionStorage.branch);
            //}
        }

        function checkAndSetSelectedBank(selectedBank) {
            //if ($sessionStorage.bank == null) {
                setBank(selectedBank);
            /*} else {
            	setBank($sessionStorage.bank);
            }*/
        }

        function checkAndSetSelectedCustomer(selectedCustomer) {
//            if ($sessionStorage.customer == null) {
                setCustomer(selectedCustomer);
//            } else {
//            	setCustomer($sessionStorage.customer);
//            }
        }

        function checkAndSetSelectedUser(selectedUser) {
//            if ($sessionStorage.user == null) {
                setUser(selectedUser);
//            } else {
//            	setUser($sessionStorage.user);
//            }
        }

        function checkAndSetSelectedConfigurationSettings(selectedConfigSettings) {
//            if ($sessionStorage.configSettings == null) {
                setConfigurationSettings(selectedConfigSettings);
//            } else {
//            	setConfigurationSettings($sessionStorage.configSettings);
//            }
        }

        function checkAndSetSelectedSystemSettings(selectedSystemSettings) {
//            if ($sessionStorage.systemSettings == null) {
                setSystemSettings(selectedSystemSettings);
//            } else {
//            	setSystemSettings($sessionStorage.systemSettings);
//            }
        }

 function checkAndSetSelectedTransactionParametersSettings(selectedTransactionParametersSettings){
            setTransactionParametersSettings(selectedTransactionParametersSettings);
        }

        function checkAndSetSelectedDefaultCurrencyPairId(selectedDefaultCurrencyPairId){
            setDefaultCurrencyPairId(selectedDefaultCurrencyPairId);
        }


        function checkAndSetSelectedCountry(selectedCountry) {
//        	 if ($sessionStorage.country == null) {
                 setCountry(selectedCountry);
//             } else {
//             	setCountry($sessionStorage.country);
//             }
         }


        function checkAndSetSelectedFinancialYear(selectedFinancialYear) {
//       	 	if ($sessionStorage.financialYear == null) {
                setFinancialYear(selectedFinancialYear);
//            } else {
//            	setFinancialYear($sessionStorage.financialYear);
//            }
        }
        function checkAndSetEnvironmentName(){
            if ($sessionStorage.configSettings.environmentName != null && $sessionStorage.configSettings.environmentName != ''
                    && $sessionStorage.configSettings.environmentName!=undefined){
                  environmentName=$sessionStorage.configSettings.environmentName.toUpperCase();
           }
        }

        function checkAndSetCorporate() {
        	if ($sessionStorage.corp != null) {
                corp = $sessionStorage.corp;
            }
        }

         function checkAndSetCorporate() {
        	if ($sessionStorage.corp != null) {
                corp = $sessionStorage.corp;
            }
        }

        function checkAndSetEntityOwnerType() {
        	if ($sessionStorage.entityOwnerType != null) {
        		entityOwnerType = $sessionStorage.entityOwnerType;
            }
        }

        function checkAndSetBranch() {
        	if ($sessionStorage.branch != null) {
        		branch = $sessionStorage.branch;
            }
        }

        function checkAndSetBank() {
        	if ($sessionStorage.bank != null) {
        		bank = $sessionStorage.bank;
            }
        }

        function checkAndSetCustomer() {
        	if ($sessionStorage.customer != null) {
        		customer = $sessionStorage.customer;
            }
        }

        function checkAndSetUser() {
        	if ($sessionStorage.user != null) {
        		user = $sessionStorage.user;
            }
        }

        function checkAndSetConfigurationSettings() {
        	if ($sessionStorage.configSettings != null) {
        		configSettings = $sessionStorage.configSettings;
            }
        }
        function checkAndTransactionParametersSettings() {
        	if ($sessionStorage.transactionParametersSettings != null) {
        		transactionParametersSettings = $sessionStorage.transactionParametersSettings;
                if(!transactionParametersSettingsMap){
                    transactionParametersSettingsMap = buildTransactionParametersSettingsMap(transactionParametersSettings);
                }
            }
        }
        function checkAndDefaultCurrencyPairId() {
        	if ($sessionStorage.defaultCurrencyPairId != null) {
        		defaultCurrencyPairId = $sessionStorage.defaultCurrencyPairId;
            }
        }
        function checkAndSetSystemSettings() {
        	if ($sessionStorage.systemSettings != null) {
        		systemSettings = $sessionStorage.systemSettings;
            }
        }

        function checkAndSetCountry() {
        	if ($sessionStorage.country != null) {
        		country = $sessionStorage.country;
            }
        }

        function checkAndSetFinancialYear() {
        	if ($sessionStorage.financialYear != null) {
        		financialYear = $sessionStorage.financialYear;
            }
        }

        function getCorporate() {
            checkAndSetCorporate();
            return corp;
        }

        function getOrganisation() {
            checkAndSetCorporate();
            return corp;
        }

        function getEntityOwnerType() {
            checkAndSetEntityOwnerType();
            return entityOwnerType;
        }

        function getBranch() {
            checkAndSetBranch();
            return branch;
        }

        function getBank() {
            checkAndSetBank();
            return bank;
        }

        function getCustomer() {
            checkAndSetCustomer();
            return customer;
        }

        function getUser() {
            checkAndSetUser();
            return user;
        }

        function getConfigSettings() {
            checkAndSetConfigurationSettings();
            return configSettings;
        }

 function getTransactionParametersSettings() {
            checkAndTransactionParametersSettings()
            return transactionParametersSettings;
        }

        function getTransactionParameterValue(currencyPairId, shortName) {
            checkAndTransactionParametersSettings();
            if (transactionParametersSettingsMap && transactionParametersSettingsMap[currencyPairId]) {
                if (transactionParametersSettingsMap[currencyPairId][shortName]) {
                    return transactionParametersSettingsMap[currencyPairId][shortName].value;
                }
            }
            return null;
        }
         function getDefaultCurrencyPairId() {
            checkAndDefaultCurrencyPairId()
            return defaultCurrencyPairId;
        }
        function getSystemSettings() {
            checkAndSetSystemSettings();
            return systemSettings;
        }

        function setSelectedUser(selectedUser){
        	setUser(selectedUser);
        }

        function getCountry() {
            checkAndSetCountry();
            return country;
        }

        function getFinancialYear() {
            checkAndSetFinancialYear();
            return financialYear;
        }
        function getErrorMessages(){
        	checkAndSetErrorMessages();
        	return errorMessages;
        }
        function checkAndSetSelectedErrorMessages(selectedErrorMessages) {
        	 if ($sessionStorage.errorMessages == null || $sessionStorage.errorMessages == undefined) {
                 setErrorMessages(selectedErrorMessages);
             } else {
            	 setErrorMessages($sessionStorage.errorMessages);
             }
        }
        function setErrorMessages(selectedErrorMessages) {
        	errorMessages = selectedErrorMessages;
        	$sessionStorage.errorMessages = selectedErrorMessages;
        }
        function checkAndSetErrorMessages() {
        	if ($sessionStorage.errorMessages != null) {
        		errorMessages = $sessionStorage.errorMessages;
            }
        }

        function setSessionTimedOut(status){
        	sessionTimedOut = status;
    		$sessionStorage.sessionTimedOut = status;
        }

        function getSessionTimedOut(){
        	return $sessionStorage.sessionTimedOut;
        }
        function getLoginUrlParam(){
            if(getOrganisation() != undefined && getOrganisation() != null){
                if(getOrganisation().organisationType.shortName == OrganisationTypeEnum.CLEARCORP){
                    return OrganisationTypeEnum.ADMIN;
                }
            }
            return "";
        }
        function getPlatformENCCode(){
            return "tV1f3EtXyUjBrf8JbbW7bSYf7JgyxZpVXYJvwAyM34Q=";
        }

        function getClearCorpTACPopup()
        {
            return $sessionStorage.isClearCorpTACPopupShowed;
        }

        function setClearCorpTACPopup()
        {
            $sessionStorage.isClearCorpTACPopupShowed = true;
        }
    }
})();

(function() {
	'use strict';

	angular.module('gatewayApp').service("ExportFile", ExportFile);

	ExportFile.$inject = ['$rootScope','GlobalValues','$timeout', '$filter'];

	function ExportFile($rootScope,GlobalValues, $timeout, $filter) {

        var tableName = "";
        var totalRecordCount = 0;
        var filterText = "";
        var pageNo = 0;
        var fileName = "";
        var ignoreColumn = "";
        var sheetName = "";
        var footer = "";
        var noOfRecordsPerPage = 0;
        var isExportMode = false;
        var exportOption = '';
        var pageIndex = 1;
        var noOfRecordsPerPageCopy=0;
	
		var service = {
			exportFile : exportFile
		};
		return service;

        //export file public call
        function exportFile(OPTION,TABLENAME, TOTALRECORDS,NOOFRECORDSPERPAGE,FILTERTEXT,PAGENO,FILENAME,IGNORECOLUMN,SHEETNAME,FOOTER) {
            tableName = TABLENAME;
            totalRecordCount=TOTALRECORDS;
            //noOfRecordsPerPage = NOOFRECORDSPERPAGE;
            filterText = FILTERTEXT;
            fileName = FILENAME;
            ignoreColumn = IGNORECOLUMN;
            sheetName = SHEETNAME;
            footer = FOOTER;

            if (TOTALRECORDS != null && TOTALRECORDS > 0) {
                exportOption = OPTION;
                pageIndex = PAGENO;
                noOfRecordsPerPage = NOOFRECORDSPERPAGE;
                noOfRecordsPerPageCopy = noOfRecordsPerPage;
                checkAndProcessExport();
            }


        }

        
        function checkAndProcessExport() {
            if ((filterText == null || filterText == "") && (totalRecordCount > noOfRecordsPerPage)) {
                $rootScope.noOfRecordsPerPage = totalRecordCount;
                //noOfRecordsPerPage = noOfRecordsPerPage;
                isExportMode = true; 
                $timeout(function() {
                    processExport();
                });
           } else {
                processExport();
            }
        }
        
        function processExport() {
            sheetName =  fileName;
            var fileFullName = fileName + "_"+ $filter('date')(new Date(), "dd")  + "_"+ $filter('date')(new Date(), "MMM") + "_"+
                                $filter('date')(new Date(), "yyyy") + "_"+ $filter('date')(new Date(), "HH") + "_"+ $filter('date')(new Date(), "mm");
            
            if (exportOption == 'csv') {
                $('#' + tableName).tableExport({ type: 'csv', escape: 'false' ,fileName : fileFullName,ignoreColumn : ignoreColumn, sheetName : sheetName, footer : footer,enviromentName:GlobalValues.getEnvironmentName()});
            } else if (exportOption == 'excel') {
                $('#' + tableName).tableExport({ type: 'excel', escape: 'false' ,fileName : fileFullName,ignoreColumn : ignoreColumn, sheetName : sheetName, footer : footer,enviromentName:GlobalValues.getEnvironmentName()});
            } else if (exportOption == 'pdf') {
                $('#' + tableName).tableExport({ type: 'pdf', pdfFontSize: '7', escape: 'false' ,fileName : fileFullName,ignoreColumn : ignoreColumn});
            } else if (exportOption == 'png') {
                $('#' + tableName).tableExport({ type: 'png', escape: 'false',fileName : fileFullName,ignoreColumn : ignoreColumn });
            } else if (exportOption == 'doc') {
                $('#' + tableName).tableExport({ type: 'doc', escape: 'false' ,fileName : fileFullName,ignoreColumn : ignoreColumn});
            } else if (exportOption == 'txt') {
                $('#' + tableName).tableExport({ type: 'txt', escape: 'false' ,fileName : fileFullName,ignoreColumn : ignoreColumn});
            } else if (exportOption == 'powerpoint') {
                $('#' + tableName).tableExport({ type: 'powerpoint', escape: 'false' ,fileName : fileFullName,ignoreColumn : ignoreColumn});
            }
            pageNo = pageIndex;
            $rootScope.noOfRecordsPerPage = noOfRecordsPerPageCopy;
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("EntityPermissions", EntityPermissions);
       
    EntityPermissions.$inject = ['SecurityPolicy', 'GlobalValues', '$rootScope', '$q'];

    function EntityPermissions (SecurityPolicy, GlobalValues, $rootScope, $q) {
    	
    	var entityPermission = null;
		var entityPermissionFetchInProgress = true;
		var modalDefer;

    	var service = {
    			hasPermission: hasPermission,
    			getEntityPermission: getEntityPermission,
    			clearEntityPermission: clearEntityPermission,
                hasScreenActionPermission : hasScreenActionPermission,
				hasPermissionPromise : hasPermissionPromise,
				hasScreenActionPermissionPromise : hasScreenActionPermissionPromise
    	};
    	return service;
    	
    	function clearEntityPermission(){
    		entityPermission = null;
    	}
    	
    	function hasPermission(entity){            
    		if(entityPermission == null){
    			getEntityPermission();
    		}
    		
    		var entityDetails = entity.split('.');    		
    		if (entityDetails.length == 2){
    			return hasEntityActionPermission(entityDetails[0], entityDetails[1]);
    		}
    		else{
    			return hasEntityPermission(entityDetails[0]);
    		}
    	}
    	
    	function getEntityPermission(){
			entityPermissionFetchInProgress = true;
    		entityPermission = SecurityPolicy.getEntityPermissions({orgId : GlobalValues.getOrgId()}, entityPermissionFetchSuccess, entityPermissionFetchFailure);
    	}
    	
    	function entityPermissionFetchSuccess(data){
			if(modalDefer != undefined) {
				modalDefer.resolve(data);
			}
			entityPermissionFetchInProgress = false;
    		entityPermission = data;
    		$rootScope.$emit("gatewayApp.entityPermissionFetched");
    	}
    	
    	function entityPermissionFetchFailure(){
    		entityPermissionFetchInProgress = false;
    	}
    	
    	function hasEntityPermission(entity){
    		if ( getIndexOfEntity(entity) > -1){
    			return true;
    		}
    		else{
    			return false;
    		}
    	}
    	
    	function hasEntityActionPermission(entity,action){
    		if(hasEntityPermission(entity)){
    			if (entityPermission[getIndexOfEntity(entity)].entityActions.indexOf(action) > -1){
    				return true
    			}
    			else{
    				return false;
    			}
    		}
    		else{
    			return false;
    		}
    	}
    	
    	function getIndexOfEntity(entity){
    		for (var i = 0; i <= entityPermission.length-1; i++){
    			if (entityPermission[i].entityName==entity){
    				return i;
    			}
    		}
    		return -1;
    	}

        function hasScreenActionPermission(screen, action) {
            return hasEntityActionPermission(screen, action);
        }

		function hasPermissionPromise(screen) {

			if(entityPermissionFetchInProgress){
				modalDefer = $q.defer();
				SecurityPolicy.getEntityPermissions({orgId : GlobalValues.getOrgId()}, entityPermissionFetchSuccess, entityPermissionFetchFailure);
				return modalDefer.promise;
			}
			else{
				return hasPermission(screen);
			}
            
        }

		function hasScreenActionPermissionPromise(screen, action){
			if(entityPermissionFetchInProgress){
				modalDefer = $q.defer();
				SecurityPolicy.getEntityPermissions({orgId : GlobalValues.getOrgId()}, entityPermissionFetchSuccess, entityPermissionFetchFailure);
				return modalDefer.promise;
			}
			else{
				return hasScreenActionPermission(screen, action);
			}
		}
    	
    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("EntityLookup", EntityLookup);

    EntityLookup.$inject = ['GlobalValues', 'User'];

    function EntityLookup(GlobalValues, User) {

		var returnValue = null;
		var userList = [];

    	var service = {
    		getUserList: getUserList,
    	};
    	return service;
    	
    	function getUserList(selectedEntityOwnerType, bankId, bracnhId, customerId){
    		var userEntityOwnerType = GlobalValues.getEntityOwnerType().shortName;
			if(selectedEntityOwnerType!="" && selectedEntityOwnerType!=null){
				if (selectedEntityOwnerType==userEntityOwnerType && userEntityOwnerType!="Branch"){
					returnValue = User.getUsersByOrganisationAndEntityOwnerType({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType}, onSuccess, onFailure);
				}else if (selectedEntityOwnerType==userEntityOwnerType && userEntityOwnerType=="Branch"){
					returnValue = User.getUsersForBranch({"branchId": GlobalValues.getBranch().id}, onSuccess, onFailure);
				}else if(userEntityOwnerType=="Clearcorp" && selectedEntityOwnerType=="Bank" && (bankId!="" && bankId!=null)){
					returnValue = User.getUsersByOrganisationAndEntityOwnerType({"orgId": bankId, entityOwnerType: 'Bank'}, onSuccess, onFailure);
				}else if((userEntityOwnerType=="Clearcorp" || userEntityOwnerType=="Bank") && selectedEntityOwnerType=="Branch" && (branchId!="" && branchId!=null)){
					returnValue = User.getUsersForBranch({"branchId": branchId}, onSuccess, onFailure);
				}else if((userEntityOwnerType=="Clearcorp" || userEntityOwnerType=="Bank" || userEntityOwnerType=="Branch") && (selectedEntityOwnerType=="MultiUserCustomer" || selectedEntityOwnerType=="SingleUserCustomer") && (customerId!="" && customerId!=null)){
					returnValue = User.getUsersByOrganisationAndEntityOwnerType({"orgId": customerId, entityOwnerType: selectedEntityOwnerType}, onSuccess, onFailure);
				}
			}else if(userEntityOwnerType=="MultiUserCustomer" || userEntityOwnerType=="SingleUserCustomer"){
				returnValue = User.getUsersByOrganisationAndEntityOwnerType({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType}, onSuccess, onFailure);
			}
			
			function onSuccess(result){
				if(returnValue!=null){
					angular.forEach(returnValue, function(value){
						userList.push(value.id);
					})
					console.log(userList);
					return userList;
				}
			}
			
			function onFailure(){
				
			}
			
    	}
        
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset-password-request', {}, {
        	
        	'save': {
            	method: 'POST',
            	url: 'api/account/reset-password-request',
            	transformRequest : function(data) {
					var copy = angular.copy(data);

					return angular.toJson(copy);
				}
            }
        
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change-password', {}, {
        	'save': {
            	method: 'POST',
//            	params: {login: '@login', loginpassword:'@loginpassword', password: '@password'},
            	url: 'api/account/change-password',
            	
            	transformRequest : function(data) {
					var copy = angular.copy(data);

					return angular.toJson(copy);
				}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('Notifications', Notifications);

    Notifications.$inject = ['$resource'];

    function Notifications ($resource) {
        var resourceUrl = 'api/';

        return $resource(resourceUrl, {}, {

            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },

            'getPopupNotificationsByUserId': {
          	  method: 'GET',
          	  isArray: false,
          	  url: 'api/popup-notifications',
              transformResponse: function (data) {
                      if (data) {
                          data = angular.fromJson(data);
                      }
                      return data;
                  }
           },
           
           'getPopupNotificationsCount': {
           	  method: 'GET',
           	  isArray: false,
           	  url: 'api/popup-notifications-count',
               transformResponse: function (data) {
                       if (data) {
                           //data = parseInt(data, 10);
                       }
                       return data;
                   }
            },
            
          'updatePopupNotificationStatus': {
                method: 'POST',
                params: {notificationId:'@notificationId'},
                url: 'api/popup-notifications-status/:notificationId',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                }                
            },
            'insertNotifications':{
            	method:'POST',
            	
                url: 'api/insert-notifications/message',
                params: {message:'@message'},
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'broadcastMessage':{
            	method:'POST',
                url: 'order/broadcast-message/message',
                transformRequest: function (data) {
                	var copy = angular.toJson(data);
                    return copy;
                }
            }
            
            
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate','$uibModalStack','Principal', 'AuthServerProvider', 'Account','WebSocket','LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish','GlobalValues'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate,$uibModalStack, Principal, AuthServerProvider, Account,WebSocket,LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish,GlobalValues) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            sessionlogout:sessionlogout
        };
        // sessionlogout();
        function sessionlogout(){
           
            	
           GlobalValues.clearPreviousValues();
           WebSocket.disconnecteWebSocket(true);
            Account.logout();
            authorize(true);
            $rootScope.sessionExpired = true;
            $uibModalStack.dismissAll();
            $state.go('login', null, {reload:'login'});
           // Account.deleteUser();
            window.location.reload();


        }
        
       
        return service;
       

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    /*var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);*/
                	/*as we dont need this above requirement in ccil fx retail application*/
                }

                if ((!isAuthenticated && $rootScope.toState.name == "home") || ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities))) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
                
                /*if(Principal.hasAnyAuthority('ROLE_TEMP_PASSWORD'))
                {
                     // user authenticated, but has to change password. stow the state they wanted before you
                    // send them to the change-password service, so you can return them when you're done
                    storePreviousState($rootScope.toState.name, $rootScope.toStateParams);
                  
                     // now, send them to the change-password state so they can change password
                   $state.go('change-password')
                }*/
                
               /* Account.get(function(result){                	
                	//console.log(result.data);
                	//console.log(result.data.isForceToResetPassword);
                	 if(result.data.isForceToResetPassword == true)
                    {
                         // user authenticated, but has to change password. stow the state they wanted before you
                        // send them to the change-password service, so you can return them when you're done
                        //storePreviousState('login', $rootScope.toStateParams);
                      
                         // now, send them to the change-password state so they can change password
                       $state.go('change-password-expiry', {login: result.data.login})
                    }
                	
                });*/
                
                
                
            }
        }

        function changePassword (login, loginpassword, newPassword, callback) {
            var cb = callback || angular.noop;

            var loginCredentials = {};
            loginCredentials.login = login;
            loginCredentials.loginpassword = loginpassword;
            loginCredentials.newpassword = newPassword;
            return Password.save(loginCredentials, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, mobile, orgType, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save({email: mail, mobile: mobile, orgType: orgType}, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
       

    }
})();

(function () {
    "use strict";

    angular
        .module("gatewayApp")
        .factory("AuthServerProvider", AuthServerProvider);

    AuthServerProvider.$inject = [
        "$http",
        "$localStorage",
        "$sessionStorage",
        "$q",
        "OrganisationTypeEnum"
    ];

    function AuthServerProvider(
        $http,
        $localStorage,
        $sessionStorage,
        $q,
        OrganisationTypeEnum
    ) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken() {
            return (
                $localStorage.authenticationToken ||
                $sessionStorage.authenticationToken
            );
        }

        function login(credentials) {
            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe,
                skipOTP: credentials.skipOTP,
                orgType: credentials.orgType,
                captchaContent: credentials.captchaContent,
                captchaText: credentials.captchaText,
                recaptchaToken: credentials.recaptchaToken,
                sourceType: credentials.sourceType,
                source: credentials.source
            };
            //check organisation type others then, add investor in url
            if (OrganisationTypeEnum.OTHERS == credentials.orgType) {
                var url = "api/authenticate/others";
            }
            //check organisation type CLEARCORP then, add admin in url
            else if (OrganisationTypeEnum.CLEARCORP == credentials.orgType) {
                var url = "api/authenticate/admin";
            }
            return $http.post(url, data).success(authenticateSuccess);

            function authenticateSuccess(data, status, headers) {
                var bearerToken = headers("Authorization");
                if (
                    angular.isDefined(bearerToken) &&
                    bearerToken.slice(0, 7) === "Bearer "
                ) {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(
                        jwt,
                        credentials.rememberMe
                    );
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if (rememberMe) {
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout() {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            },
            'unlockAccount': {
            	method: 'POST',
            	url: 'api/unlock-account',
            	transformRequest : function(data) {
					var copy = angular.copy(data);

					return angular.toJson(copy);
				}
            },
            'logout' : {
				method : 'POST',
				url : 'api/logout',
			},
			'sendOTP' : {
				method : 'POST',
				params : {login : '@login'},
				url : 'api/send-otp-login/login/:login',
				transformRequest : function(data) {
					var copy = angular.copy(data);

					return angular.toJson(copy);
				}
			},
			'verifyOTP' : {
				method : 'POST',
				url : 'api/verify-otp-login',
			},
			'checkPasswordExpiry' : {
				method : 'POST',
				//params : {login : '@login', otp: '@otp'},
				url : 'api/check-password-expiry-warning'
			},
			'preAuthorize': {
				method : 'POST',
				params : {orgType : '@orgType'},
				url : 'api/pre-authenticate/:orgType'
			},
			'deleteUser' : {
				method : 'POST',
				url : 'api/delete-user'
			}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', '$sessionStorage', 'EntityPermissions', 'GlobalValues', 'User', 
    	'Account','OrderStatusDetails','MessageBox','$rootScope','$scope', '$localStorage', 'WebSocket', 'Idle', '$fileLogger'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService, $sessionStorage, EntityPermissions, GlobalValues, User, 
    		Account, OrderStatusDetails, MessageBox, $rootScope,$scope, $localStorage, WebSocket, Idle, $fileLogger) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.globalValues = GlobalValues;
        var yesMessageEvent = null;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            if($rootScope.eodInProgress!=null && $rootScope.eodInProgress!=undefined && $rootScope.eodInProgress==true){
                $fileLogger.info('user logged out');
            }
        	OrderStatusDetails.getPendingOrdersForUser(onGettingPendingOrderSuccess, onGettingPendingOrderFailure);
        	
        }
        
        function logoutAccount(){
        	//update session log
        	User.updateSessionLog(onSessionUpdateSuccess, onSessionUpdateFailure);
        }
        
        function onSessionUpdateSuccess(){
            Account.logout(function(result){
                var orgTypeParam = GlobalValues.getLoginUrlParam();
                GlobalValues.clearPreviousValues();
                EntityPermissions.clearEntityPermission();
                $sessionStorage.isAuth = false;
                collapseNavbar();
                Auth.logout();
                //$localStorage.authenticationToken = null;
                $sessionStorage.authenticationToken = null;
                WebSocket.disconnecteWebSocket(true);
                Idle.unwatch();
                $state.go('login', {orgType : orgTypeParam}, {reload:'login'});
                //window.location.reload();
            });
        }
        
        function onSessionUpdateFailure(){
        	
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
        
        function onGettingPendingOrderSuccess(result){
        	if(result.length > 0){
        		MessageBox.openMessageBox("Alert", "There are pending orders...! Are you sure to logout?", "YesNo", "pendingOrderSignoutAlert");
        	}else{
        		logoutAccount();
        	}
        }
        
        function onGettingPendingOrderFailure(){
        	
        }
        
        yesMessageEvent = $rootScope.$on('gatewayApp.messagebox.yes.pendingOrderSignoutAlert', function (event, data) {
        	logoutAccount();
        });
        
        $scope.$on('$destroy', function() {
    		  if (yesMessageEvent!=null )
    			  	yesMessageEvent();
  	        });
          
  		
  		$rootScope.$on('gatewayApp.messagebox.no.pendingOrderSignoutAlert', function (event, data) {
  			//do nothing
      	});
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();


(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            ncyBreadcrumb: {
                label: 'Home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('orderActivity');
                    $translatePartialLoader.addPart('swapQuotes');
                    $translatePartialLoader.addPart('error');
                    return $translate.refresh();
                }]
            }
        })
        .state('cspl-control', {
            parent: 'app',
            url: '/cspl-control',
            data: {
           	 authorities: ['ROLE_USER'],
             pageTitle: 'gatewayApp.businessUnit.home.title'
            },
            ncyBreadcrumb: {
                label: 'CSPL Controls',
                parent: 'home'
              },
            views: {
                'content@': {
                    templateUrl: 'app/controllers/csplcontrol/csplcontrol.html',
                    controller: 'CSPLControlController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('swapQuotes');
                    return $translate.refresh();
                }]
            }
        })
       .state('pre-order-confirmation', {
            parent: 'home',
            url: '/pre-order-confirmation',
            params: {closeTime: null, showPreOrderConfirmation: null, sessionTimedOut: null, cancelSelected: null,showOrderConfirmationForSplitOrder:null,noOfSplit:null},
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.preOrderConfirmation.main" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function($stateParams, $state, $uibModal,$rootScope) {
                $uibModal.open({
                    templateUrl: 'app/entities/pre-order-confirmation/pre-order-confirmation.html',
                    controller: 'PreOrderConfirmationController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        },
                        systemTime: ['Market',  function(Market ) {
         					return   Market.getCurrentDateTime().$promise;
                         }],
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:false});
                }, function() {
                    $rootScope.$emit('orderplacedsuccess');
                    $state.go('home', null, {reload:false});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('pre-order-confirmation');
                	$translatePartialLoader.addPart('expiry-time');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
       .state('add-remarks', {
            parent: 'home',
            url: '/add-remarks',
            params: {remarks: null},
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.addRemarks.main" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/add-remarks/add-remarks.html',
                    controller: 'AddRemarksController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:false});
                }, function() {
                    $state.go('home', null, {reload:false});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('add-remarks');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
       .state('expiry-time', {
            parent: 'home',
            url: '/expiry-time',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.expiryTime.main" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/expiry-time/expiry-time.html',
                    controller: 'ExpiryTimeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:false});
                }, function() {
                    $state.go('home', null, {reload:false});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('expiry-time');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
       .state('market-depth-expand', {
            parent: 'home',
            url: '/market-depth',
            params: {instrument: null, marketDepth: null, ibMarketDepth: null},
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.marketDepthExpand.main" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/market-depth/market-depth-expand.html',
                    controller: 'MarketDepthExpandController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:false});
                }, function() {
                    $state.go('home', null, {reload:false});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('market-depth-expand');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
       .state('market-statistics', {
            parent: 'home',
            url: '/market-statistics',
            params: {instrument: null, currentBusinessDate: null},
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.marketStatistics.main" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/market-statistics/market-statistics.html',
                    controller: 'MarketStatisticsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: ['MarketMovement', 'GlobalValues', function(MarketMovement, GlobalValues) {
                            return MarketMovement.query({instrument : $stateParams.instrument, businessDate : $stateParams.currentBusinessDate, currencyPairCode : 'USDINR'}).$promise;
                        }],
                        prevClose: ['MarketMovement', 'GlobalValues', function(MarketMovement, GlobalValues) {
                            return MarketMovement.getDailyClosingPriceList({"instrument": $stateParams.instrument}).$promise;
                        }]
                        
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:false});
                }, function() {
                    $state.go('home', null, {reload:false});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('market-statistics');
                    $translatePartialLoader.addPart('marketMovement');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
       .state('order-config', {
            parent: 'home',
            url: '/order-config',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.orderConfig.main" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-config/order-config.html',
                    controller: 'OrderConfigController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:true});
                }, function() {
                    $state.go('home', null, {reload:false});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('order-config');
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('home-page-reports', {
            parent: 'home',
            url: '/home-page-reports',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.homePageReports.main" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/home-page-reports/home-page-reports.html',
                    controller: 'HomePageReportsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:false});
                }, function() {
                    $state.go('home', null, {reload:false});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('swap-quotes-home-page', {
            parent: 'home',
            url: '/swap-quotes-home-page',
            params: {account: null, defaultTradingBank: null,
                bankComparativeDTO: null,
                bankComparativeDTOInPrice: null,
                markupSettings: null
            },
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.swapQuotesHomePage.main" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes-view/swap-quotes-home-page.html',
                    controller: 'SwapQuotesHomePageController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function(){
                            
                        }
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:false});
                }, function() {
                    $state.go('home', null, {reload:false});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
          .state('fx-support', {
            parent: 'home',
            url: '/fx-support',
           
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.contactUs.title" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contact-us/contact-us.html',
                    controller: 'ContactUsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function(){
                            
                        }
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:false});
                }, function() {
                    $state.go('home', null, {reload:false});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('login');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('split-order-confirmation', {
            parent: 'home',
            url: '/split-order-confirmation',
            params: {orderDTOList:[],showOrderConfirmationForSplitOrder:null},
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.orderUploadConfirmationStatus.main" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function($stateParams, $state, $uibModal,$rootScope) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-upload-confirmation-status/order-upload-confirmation-status.html',
                    controller: 'OrderUploadConfirmationStatusController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function(){
                        	
                        },
                        systemTime: ['Market',  function(Market ) {
         					return   Market.getCurrentDateTime().$promise;
                         }],
                         screenInfo : function(){
                            return "OrderConfirmation";
                        },
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('orderUploadConfirmationStatus');
                	$translatePartialLoader.addPart('expiry-time');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('split-order-status', {
            parent: 'home',
            url: '/split-order-status',
            params: {orderDTOList:[]},
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.splitOrderStatus.main" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function($stateParams, $state, $uibModal,$rootScope) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-upload-confirmation-status/order-upload-confirmation-status.html',
                    controller: 'OrderUploadConfirmationStatusController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function(){
                        	
                        },
                        systemTime: ['Market',  function(Market ) {
         					return   Market.getCurrentDateTime().$promise;
                         }],
                         screenInfo : function(){
                            return "OrderSubmission";
                        },
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('orderUploadConfirmationStatus');
                	$translatePartialLoader.addPart('expiry-time');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        }),
        $stateProvider.state('fcy-market-depth', {
            parent: 'home',
            url: 'fcy-market-depth',
            data: {
                authorities: []
            },
            ncyBreadcrumb: {
                label: 'Home'
            },
             onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function($stateParams, $state, $uibModal,$rootScope) {
                $uibModal.open({
                    templateUrl: 'app/home/home-market-depth.html',
                    controller: 'FCYMarketDepthController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    }
                }).result.then(function() {
                    $state.go('home', null, { reload: false });
                }, function() {
                    $state.go('home', null, {reload:false});
                });
            }],
          
            resolve: {
                 translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', '$rootScope', 'Principal', 'LoginService', '$sessionStorage', '$state', 'GlobalValues',
        'EntityPermissions', 'Notifications', '$sce', '$filter', 'Branch', 'StaticLookUp', 'BankRegistration', 'Country', 'workflowSharedService', '$window',
        'UserProfile', 'CurrencyPair', 'MarketWatch', 'Market', 'SwapQuotes', 'DefaultMarket', 'CustomerRegistration', 'CustomerBankRelationshipReport',
        '$timeout', 'OrderStatusDetails', 'LimitSettings', 'IntradayMarket', 'DateUtils', 'MessageBox', 'User', 'ErrorMessages', 'WebSocket', 'GenerateDealTicket',
        'Idle', 'ServerComponentStatus', 'Markup', '$interval', 'entityConstants', 'TradesDownload', 'DealingAdminApplicationWideSettings', 'EODProcess', '$document',
        'HolidayReport', 'SwapQuotesForTenorDates', 'TACViewForEntitiesService', 'ExposureType', 'ExposureSubType', '$fileLogger', 'OrderUtil', 'CreditFactorSettings'];

    function HomeController($scope, $rootScope, Principal, LoginService, $sessionStorage, $state, GlobalValues,
        EntityPermissions, Notifications, $sce, $filter, Branch, StaticLookUp, BankRegistration, Country, workflowSharedService, $window,
        UserProfile, CurrencyPair, MarketWatch, Market, SwapQuotes, DefaultMarket, CustomerRegistration, CustomerBankRelationshipReport,
        $timeout, OrderStatusDetails, LimitSettings, IntradayMarket, DateUtils, MessageBox, User, ErrorMessages, WebSocket, GenerateDealTicket,
        Idle, ServerComponentStatus, Markup, $interval, entityConstants, TradesDownload, DealingAdminApplicationWideSettings, EODProcess, $document,
        HolidayReport, SwapQuotesForTenorDates, TACViewForEntitiesService, ExposureType, ExposureSubType, $fileLogger, OrderUtil, CreditFactorSettings) {
        var vm = this;
        // window.onpopstate = function (e) { history.pushState(null, null,
        // window.location.href); }
        $fileLogger.setTimestampFormat('dd-MMM-yyyy HH:mm:ss:sss', '+0530');
        if ($rootScope.eodInProgress != null && $rootScope.eodInProgress != undefined && $rootScope.eodInProgress == true) {
            $fileLogger.info('Home page controller loaded')
        }
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.ltpForOrderPrevious = null;
        console.log("view from",workflowSharedService.viewFrom);
        //         $rootScope.marketArray  = [
        //   [
        //     11,
        //     {
        //         baseCurrency:"EUR",
        //         instruments: [
        //       { instrumentCode: 'SPOT', bidPrice: 66.6975, offerPrice: 86.00, baseCurrency:'EUR',tokenSequenceNo :10000003},
        //       { instrumentCode: 'TOM',  bidPrice: 66.7050, offerPrice: 86.01, baseCurrency: 'EUR',tokenSequenceNo :2 },
        //       { instrumentCode: 'CASH', bidPrice: 67.7050, offerPrice: 86.02, baseCurrency: 'EUR',tokenSequenceNo :1 }
        //         ]
        //     }
        //   ],
        //   [
        //     102,
        //     { baseCurrency : "GBP",
        //         instruments : [
        //       { instrumentCode: 'SPOT', bidPrice: 66.6778, offerPrice: 86.00, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'TOM',  bidPrice: 65.6778, offerPrice: 86.01, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'CASH', bidPrice: 67.6778, offerPrice: 86.02, baseCurrency: 'EUR',tokenSequenceNo :10000002 }
        //         ]}
        //   ],
        //   [
        //     103,
        //     { baseCurrency : "SBP",
        //         instruments : [
        //       { instrumentCode: 'SPOT', bidPrice: 85.86, offerPrice: 86.00, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'TOM',  bidPrice: 85.87, offerPrice: 86.01, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'CASH', bidPrice: 85.88, offerPrice: 86.02, baseCurrency: 'EUR',tokenSequenceNo :10000002 }
        //         ]}
        //   ],
        //   [
        //     104,
        //     { baseCurrency : "SBP",
        //         instruments : [
        //       { instrumentCode: 'SPOT', bidPrice: 85.86, offerPrice: 86.00, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'TOM',  bidPrice: 85.87, offerPrice: 86.01, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'CASH', bidPrice: 85.88, offerPrice: 86.02, baseCurrency: 'EUR',tokenSequenceNo :10000002 }
        //         ]}
        //   ],
        //   [
        //     105,
        //     { baseCurrency : "SBP",
        //         instruments : [
        //       { instrumentCode: 'SPOT', bidPrice: 85.86, offerPrice: 86.00, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'TOM',  bidPrice: 85.87, offerPrice: 86.01, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'CASH', bidPrice: 85.88, offerPrice: 86.02, baseCurrency: 'EUR',tokenSequenceNo :10000002 }
        //         ]}
        //   ],
        //   [
        //     106,
        //     { baseCurrency : "SBP",
        //         instruments : [
        //       { instrumentCode: 'SPOT', bidPrice: 85.86, offerPrice: 86.00, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'TOM',  bidPrice: 85.87, offerPrice: 86.01, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'CASH', bidPrice: 85.88, offerPrice: 86.02, baseCurrency: 'EUR',tokenSequenceNo :10000002 }
        //         ]}
        //   ],
        //   [
        //     107,
        //     { baseCurrency : "SBP",
        //         instruments : [
        //       { instrumentCode: 'SPOT', bidPrice: 85.86, offerPrice: 86.00, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'TOM',  bidPrice: 85.87, offerPrice: 86.01, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'CASH', bidPrice: 85.88, offerPrice: 86.02, baseCurrency: 'EUR',tokenSequenceNo :10000002 }
        //         ]}
        //   ],
        //   [
        //     108,
        //     { baseCurrency : "SBP",
        //         instruments : [
        //       { instrumentCode: 'SPOT', bidPrice: 85.86, offerPrice: 86.00, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'TOM',  bidPrice: 85.87, offerPrice: 86.01, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'CASH', bidPrice: 85.88, offerPrice: 86.02, baseCurrency: 'EUR',tokenSequenceNo :10000002 }
        //         ]}
        //   ],
        //   [
        //     109,
        //     { baseCurrency : "SBP",
        //         instruments : [
        //       { instrumentCode: 'SPOT', bidPrice: 85.86, offerPrice: 86.00, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'TOM',  bidPrice: 85.87, offerPrice: 86.01, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'CASH', bidPrice: 85.88, offerPrice: 86.02, baseCurrency: 'EUR',tokenSequenceNo :10000002 }
        //         ]}
        //   ],
        //   [
        //     1031,
        //     { baseCurrency : "SBP",
        //         instruments : [
        //       { instrumentCode: 'SPOT', bidPrice: 85.86, offerPrice: 86.00, baseCurrency: 'EUR',tokenSequenceNo :10000002},
        //       { instrumentCode: 'TOM',  bidPrice: 85.87, offerPrice: 86.01, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'CASH', bidPrice: 85.88, offerPrice: 86.02, baseCurrency: 'EUR',tokenSequenceNo :10000002 }
        //         ]}
        //   ]

        // ];


        $rootScope.marketSessionMap = {};
        $rootScope.marketWatchMap = {};
        $rootScope.fcyMarketDepthArray = [];
        $rootScope.tickerPriceFCY = {};
        $rootScope.dailyClosingPriceFCY = {};
$rootScope.enableOtherCurrencyTab = false;
        $rootScope.loadBoardCurrency = 'USD';
  $rootScope.currencyPairInstrumentDetails = {};

        //         $rootScope.marketWatchMap.set(11, {
        //     baseCurrency: "EUR",
        //     instruments: [
        //         { instrumentCode: 'SPOT', bidPrice: 66.6975, offerPrice: 66.6775, baseCurrency: 'EUR',tokenSequenceNo :10000003 },
        //         { instrumentCode: 'TOM',  bidPrice: 66.6875, offerPrice: 66.6765, baseCurrency: 'EUR',tokenSequenceNo :2 },
        //         { instrumentCode: 'CASH', bidPrice: 67.7050, offerPrice: 67.6025, baseCurrency: 'EUR',tokenSequenceNo :1 }
        //     ]
        // });

        // $rootScope.marketWatchMap.set(102,
        //     { baseCurrency : "GBP",
        //         instruments : [
        //       { instrumentCode: 'SPOT', bidPrice: 66.6778, offerPrice: 86.00, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'TOM',  bidPrice: 65.6778, offerPrice: 86.01, baseCurrency: 'EUR',tokenSequenceNo :10000002 },
        //       { instrumentCode: 'CASH', bidPrice: 67.6778, offerPrice: 86.02, baseCurrency: 'EUR',tokenSequenceNo :10000002 }
        //         ]});


        vm.register = register;
        vm.hasPermission = EntityPermissions.hasPermission;
        //rootScope.notificationsDTO = {};
        vm.globalValues = GlobalValues;
        $rootScope.globalValues = GlobalValues;
        vm.screenName = "Home";
        vm.screenType = "Home";
        vm.setFromIndex = setFromIndex;
        vm.selectedCurrency = null;
        vm.isFromIndex = false;
        var isSubscribed = false;
        $rootScope.tradingRelationsForCustomer = null;
        vm.executeplaceOrderShortcut = executeplaceOrderShortcut;
        vm.executeValueHistoryShortcut = executeValueHistoryShortcut;
        vm.checkOrUncheckPendingOrders = checkOrUncheckPendingOrders;
        vm.checkOrUncheckPendingOrderItem = checkOrUncheckPendingOrderItem;
        vm.broadcastMessage = broadcastMessage;
        $rootScope.orderServerDown = false;
        vm.expandTradePosition = false;
        vm.exportTradesToCsvFile = exportTradesToCsvFile;
        vm.exportTradesToExcelFile = exportTradesToExcelFile;
        vm.clicked = false;
        vm.sampleAmount = 72.3212;
        vm.showMWData = showMWData;
        vm.addRow = addRow;
        vm.deleteRow = deleteRow;
        vm.updateRow = updateRow;
        vm.resetUserMarketWatch = resetUserMarketWatch;
        vm.bankQuotesPaginationNoOfRecordsPerPage = 3;
        vm.bootupCompleted = false;
        //vm.selectedInstrumentDate = new Date();
        vm.getOutstandingTrades = getOutstandingTrades;
        vm.prepareOutrightComparision = prepareOutrightComparision;
        getJPYconfigvalue();
        vm.outrightView = 'Price';
        $rootScope.maximumOptionPeriodDuration = 30;
        $rootScope.tenor = null;


        vm.value = 70.1234;
        vm.clickUpdateRow = false;
        vm.regularAndSplitOrder = 'Regular';
        vm.noOfSplits = '';
        vm.decimalValue = false;
        $scope.errorTextOrderAmount = "";
        $scope.errorTextNoOfSplits = "";
        vm.minNoOfSplit = 0;
        vm.maxNoOfSplit = 0;
        vm.currencyPairInstrumentDetails = {};
        vm.isOtherCurrencyEnable = true;
        vm.usdCurrency = null;
        vm.currencyPair = null;
        $rootScope.limitsAvailableForSelectedInstrument = [];


        getMinAndMaxNoOfSplit();

        getSiteKeyForRecaptch();


        function getSiteKeyForRecaptch(){
             StaticLookUp.getRecaptcha(function (result) {
                vm.globalValues.checkAndSetRecaptchaSiteKey(result);
                console.log(result);
            });
        }

        function updateRow(index){
        	if(vm.clickUpdateRow == false){
        		vm.clickUpdateRow = true;
        		if(vm.selectedInstrumentDate!=null && vm.selectedInstrumentDate!=undefined){
        			var settlementDate = DateUtils.convertLocalDateToServer(angular.copy(vm.selectedInstrumentDate));
        			if(validateSettlementDate(settlementDate)){
        				var userMarketWatch = prepareUserMarketWatchToUpdate(settlementDate);
        				$rootScope.userMarketWatchList[index] = userMarketWatch;
        				//save to db
        				UserProfile.saveUserMarketWatchList($rootScope.userMarketWatchList);
                        //$rootScope.userMarketWatchListMemory = $rootScope.userMarketWatchList;
                        //vm.selectedInstrumentDate = vm.tenors[0].settlementDate;
                        vm.clickUpdateRow = false;
                    }
                } else {
                    MessageBox.openMessageBox("Alert", "Invalid date...!", "Ok", "errorInSettlementDate");

                }
            }
        }


       function getJPYconfigvalue(){
         DealingAdminApplicationWideSettings.getConfigValueForConfigName({ "configName": "JPYQuotation" }, function (result) {
                      vm.configJPYCurrency = result.value;
            })
        }

        function validateSettlementDate(settlementDate) {
            //validate sett. date should be fall in holiday
            var isValid = true;
            var holidayList = _.filter(vm.holidayListAfterBusinessDate, function (s) { return s.indexOf(settlementDate) !== -1; });
            if (holidayList != null && holidayList != undefined && holidayList.length > 0) {
                isValid = false;
                MessageBox.openMessageBox("Alert", "Instrument cannot be added as selected date is a Holiday. For Holiday List, kindly refer to Holiday View screen in General Reports menu", "Ok", "errorInSettlementDate");
            } else {
                //validate sett. date should not be spot date. since, spot mkt watch is in separate section.
                //and sett. date should not be less than current business date.
                if (settlementDate == $rootScope.retailSpotMarketSession.settlementDate) {
                    isValid = false;
                    MessageBox.openMessageBox("Alert", "Date should not be a spot settlement date...!", "Ok", "errorInSettlementDate");
                } else if (settlementDate < vm.currentDate) {
                    isValid = false;
                    MessageBox.openMessageBox("Alert", "Date should not be less than current business date...!", "Ok", "errorInSettlementDate");
                } else if (vm.tenors != null && vm.tenors != undefined && vm.tenors.length > 0 && settlementDate > vm.tenors[vm.tenors.length - 1].settlementDate) {
                    isValid = false;
                    MessageBox.openMessageBox("Alert", "Date should not be greater than the last standard tenor date " + $filter('date')(new Date(vm.tenors[vm.tenors.length - 1].settlementDate), 'dd-MMM-yyyy') + "...!", "Ok", "errorInSettlementDate");
                } else { //sett. date should not already be exists in user mkt watch
                    var existingMktWatch = _.filter(angular.copy($rootScope.userMarketWatchList), { 'settlementDate': settlementDate });
                    if (existingMktWatch != null && existingMktWatch != undefined && existingMktWatch.length > 0) {
                        isValid = false;
                        MessageBox.openMessageBox("Alert", "The instrument is already available for the given date...!", "Ok", "errorInSettlementDate");
                    }
                }
            }
            return isValid;
        }


        function validateOptionSettlementDate(instrumentCode, isOptionPeriod, settlementDate, dateFromOrTo) {
            // do validateion only if forwards and option period is true else skip validation
            if (instrumentCode != 'Forward' || (instrumentCode == 'Forward' && isOptionPeriod != true)) {
                return true;
            }
            var isValid = true;
            var selectedDateText = "Selected Forward Option Period " + dateFromOrTo + " date ";
            // var errorText = "errorInOptionPeriod" + dateFromOrTo;
            var serverSettlemntDate = DateUtils.convertLocalDateToServer(settlementDate);

            var holidayList = _.filter(vm.holidayListAfterBusinessDate, function (s) { return s.indexOf(serverSettlemntDate) !== -1; });


            if (settlementDate == null || settlementDate == undefined) {
                isValid = false;
                vm.errorString = "Forward Option Period " + dateFromOrTo + " date is mandatory..!";
                //MessageBox.openMessageBox("Alert", "Option Period " + dateFromOrTo + " date is mandatory", "Ok", errorText);

            } else if (holidayList != null && holidayList != undefined && holidayList.length > 0) {

                isValid = false;
                vm.errorString = selectedDateText + "is a Holiday. For Holiday List, kindly refer to Holiday View screen in General Reports menu...!";
                //MessageBox.openMessageBox("Alert", , "Ok", errorText);

            } else {
                //validate sett. date should not be greater than the maximum renor/value defined in the limits
                if ($rootScope.maxForwardTenorDate != null && $rootScope.maxForwardTenorDate != undefined && moment(settlementDate).isAfter($rootScope.maxForwardTenorDate, 'day')) {

                    isValid = false;
                    vm.errorString = selectedDateText + "is greater than the" + " maximum tenor/value date defined by the Relationship Bank. Please refer the Limit Tab for more info on maximum tenor/value date allowed...!";
                    // MessageBox.openMessageBox("Alert", , "Ok", errorText);
                } else if (moment(settlementDate).isBefore(moment(vm.spotNextDate), 'day') || moment(settlementDate).isAfter(moment(vm.maxTenorDate), 'day')) {
                    //validate sett. date should not be less than spot next date. and should not be greater than last tenor value
                    isValid = false;
                    vm.errorString = selectedDateText + "should be between Spot Next Date and maximum tenor date...!";
                    //MessageBox.openMessageBox("Alert", , "Ok", errorText);

                }
            }
            return isValid;
        }
        function validateOptionPeriods(instrumentCode, isOptionPeriod, from, to) {
            // do validateion only if forwards and option period is true else skip validation
            if (instrumentCode != 'Forward' || (instrumentCode == 'Forward' && isOptionPeriod != true)) {
                return true;
            }
            //validate sett. date should be fall in holiday
            var isValid = true;
            //var errorText = "errorInOptionPeriodFRomAndTo";
            //validate sett. date should not be spot date. since, spot mkt watch is in separate section.
            //and sett. date should not be less than current business date.
            if (moment(from).isSame(moment(to), 'day')) {
                isValid = false;
                vm.errorString = "Forward Option Period Start date and End date cannot be same...!";
                // MessageBox.openMessageBox("Alert", "Option Period From and To cannot be same...!", "Ok", errorText);

            } else if (moment(from).isAfter(moment(to), 'day')) {
                isValid = false;
                vm.errorString = "Forward Option Period Start date cannot be greater than End date...!";
                //MessageBox.openMessageBox("Alert", "Option Period From is greater than To...!", "Ok", errorText);
            }
            else if (moment(to).diff(moment(from), 'day') > $rootScope.maximumOptionPeriodDuration) {
                isValid = false;
                vm.errorString = "Forward Option Period date range cannot be more than " + $rootScope.maximumOptionPeriodDuration + " days...!";
                //MessageBox.openMessageBox("Alert", , "Ok", errorText);
            }

            return isValid;
        }

        $rootScope.$on('gatewayApp.messagebox.clear.errorInSettlementDate', function (event, data) {
            vm.clickUpdateRow = false;
            vm.selectedInstrumentDate = null;
        });

        $rootScope.$on('gatewayApp.messagebox.ok.errorInSettlementDate', function (event, data) {
            //set default value in settlement date
            vm.selectedInstrumentDate = null;
            vm.clickUpdateRow = false;
        });

        $rootScope.$on('gatewayApp.messagebox.ok.hasAtleastOneRow', function (event, data) {
            //do nothing
            $rootScope.clickDeleteRow = true;
        });

        //prepare user market watch for newly added settlement date
        function prepareUserMarketWatchToUpdate(settlementDate) {
            var userMarketWatch = {};
            //get tenor name
            userMarketWatch.tenorName = MarketWatch.getTenorNameForSettlementDateInUserMarketWatch(settlementDate, vm.tenors, $rootScope.cashMarketSession, $rootScope.tomMarketSession);
            userMarketWatch.editable = false;
            userMarketWatch.settlementDate = settlementDate;
            //set instrument
            if (userMarketWatch.tenorName == 'CASH' || userMarketWatch.tenorName == 'TOM') {
                userMarketWatch.instrument = userMarketWatch.tenorName;
            } else {
                userMarketWatch.instrument = 'Forward';
            }
            var tickSize = gettickSizeForGivenInstrument(userMarketWatch.instrument);
            userMarketWatch.sessionStatus = getSessionStatusForInstrument(userMarketWatch.instrument);
            //get bid offer spread and best bid/offer flag
            userMarketWatch = MarketWatch.getAndFillBidOfferSpreadForDateInUserMarketWatch(userMarketWatch, $rootScope.bankComparativeDTO, $rootScope.defaultBankSpread, $rootScope.retailSpotMarketSession.settlementDate, tickSize);
            //fill bid/offer price
            userMarketWatch = MarketWatch.fillBidOfferPriceInUserMarketWatch(userMarketWatch, $rootScope.retailSpotMarketWatch);
            return userMarketWatch;
        }

        function showMWData() {
            console.log($rootScope.userMarketWatchList);
        }

        function addRow(index) {
            vm.selectedInstrumentDate = null;
            angular.forEach($rootScope.userMarketWatchList, function (value, index1) {
                if (value.tenorName == null || value.tenorName == undefined || value.tenorName == '') {
                    if (index1 < index) {
                        index = index - 1;
                    }
                    $rootScope.userMarketWatchList.splice(index1, 1);
                }
            })
            $rootScope.userMarketWatchList.splice(index, 0, { 'id': 0, 'tenorName': '', 'bidPrice': 0, 'offerPrice': 0, 'settlementDate': '', 'isBestBuy': false, 'isBestSell': false, 'editable': true });
            if (($rootScope.userMarketWatchList.length - 1) == index) {//if it is last row
                setTimeout(function () {
                    document.getElementById('userMarketWatch').scrollTop = document.getElementById('userMarketWatch').scrollHeight;
                }, 10);
            }
            //$rootScope.userMarketWatchListMemory = $rootScope.userMarketWatchList;
        }

        $rootScope.clickDeleteRow = true

        function deleteRow(index) {
            if ($rootScope.clickDeleteRow == true) {
                if ($rootScope.userMarketWatchList[index].tenorName == null || $rootScope.userMarketWatchList[index].tenorName == undefined || $rootScope.userMarketWatchList[index].tenorName == ''
                    || $rootScope.userMarketWatchList[index].settlementDate == '' || $rootScope.userMarketWatchList[index].settlementDate == null || $rootScope.userMarketWatchList[index].settlementDate == undefined) {
                    $rootScope.userMarketWatchList.splice(index, 1);
                    //$rootScope.userMarketWatchListMemory = $rootScope.userMarketWatchList;
                } else {
                    $rootScope.clickDeleteRow = false;
                    var validUserMarketWatch = angular.copy($rootScope.userMarketWatchList).map(function (item) { return item.tenorName; }).filter(function (val) { return (val !== null && val !== undefined && val !== '') });
                    if (validUserMarketWatch.length > 1) {
                        $rootScope.indexToBeDeleted = angular.copy(index);

                        MessageBox.openMessageBox("Alert", 'Are you sure to remove the selected instrument?', "YesNo", "continuedeletemktwatch");
                    } else {

                        MessageBox.openMessageBox("Alert", "Cannot be removed, the market watch should have at least one instrument.", "Ok", "hasAtleastOneRow");
                    }
                }
            }
        }

        $rootScope.$on('gatewayApp.messagebox.yes.continuedeletemktwatch', function (event, data) {
            if ($rootScope.indexToBeDeleted != null && $rootScope.indexToBeDeleted != undefined) {
                $rootScope.userMarketWatchList.splice($rootScope.indexToBeDeleted, 1);
                UserProfile.saveUserMarketWatchList($rootScope.userMarketWatchList);
                //$rootScope.userMarketWatchListMemory = $rootScope.userMarketWatchList;
                $rootScope.indexToBeDeleted = null; //to prevent duplicate execution
            }
            $rootScope.clickDeleteRow = true;
        });

        $rootScope.$on('gatewayApp.messagebox.no.continuedeletemktwatch', function (event, data) {
            //do nothing
            $rootScope.clickDeleteRow = true;
        });

        $rootScope.$on('gatewayApp.messagebox.clear.continuedeletemktwatch', function (event, data) {
            $rootScope.clickDeleteRow = true;
        });

        $rootScope.$on('gatewayApp.messagebox.clear.hasAtleastOneRow', function (event, data) {
            $rootScope.clickDeleteRow = true;
        });

        $scope.sortableOptions = {
            containment: '#items',
            orderChanged: function (event) {
                //Things to do on order changed
                UserProfile.saveUserMarketWatchList($rootScope.userMarketWatchList);
                //$rootScope.userMarketWatchListMemory = $rootScope.userMarketWatchList;
            },
            placeholder: function (itemScope) {
                var tr = itemScope.element[0];
                var placeholder = $document[0].createElement("tr");
                placeholder.style.display = 'table-row';
                placeholder.style.backgroundColor = '#000';

                var cell = placeholder.insertCell(0);
                cell.innerHTML = tr.cells[0].innerHTML;
                cell.style.fontSize = '17px';
                cell.style.color = '#f0cba6';

                return placeholder;
            }
        };

        function resetUserMarketWatch() {
            $rootScope.resetDone = false;
            MessageBox.openMessageBox("Alert", 'Are you sure to restore the market watch?', "YesNo", "continueresetmarketwatch");
        }

        $rootScope.$on('gatewayApp.messagebox.yes.continueresetmarketwatch', function (event, data) {
            if ($rootScope.resetDone == false) {
                UserProfile.resetUserMarketWatchList(onResetUserMarketWatchSuccess, onResetUserMarketWatchFailure);
                $rootScope.resetDone = true; //to prevent duplicate execution
            }
        });

        $rootScope.$on('gatewayApp.messagebox.no.continueresetmarketwatch', function (event, data) {
            //do nothing
        });

        function onResetUserMarketWatchSuccess(result) {
            //do what done in get user market watch list success
            onGetUserMarketWatchSuccess(result);
        }

        function onResetUserMarketWatchFailure() {

        }

        // $.growl({ title: "Order Confirmation", message: "Your order for 100
        // USD @ 65.45 is placed successfully with the host." });
        /*
          * ---- Get pending task --- $rootScope.pendingTasksCount ="";
          * UserProfile.getPendingTaskCount(onGetCountSuccess,onGetCountFailure);
          *
          * function loadPeningTaskCount(){ console.log("get pending task ");
          * if(vm.globalValues!=null && vm.globalValues!=undefined &&
          * vm.globalValues.getUser() !=null && vm.globalValues!=undefined){
          * UserProfile.getPendingTaskCount(onGetCountSuccess,onGetCountFailure); } }
          *
          * $interval( loadPeningTaskCount , 60000); function
          * onGetCountSuccess(result){ $rootScope.pendingTasksCount =
          * result.count; } function onGetCountFailure(error){ console.log("error
          * in getting the pending task count" + error); }
          */

        function setFromIndex() {
            console.log('Set Index From')
            vm.isFromIndex = true;
        }

        function executeplaceOrderShortcut(value, orderVolume, instrumentType, instrumentId, bidPrice, offerPrice) {
            if (value == '+' && offerPrice > 0 && orderVolume != null && orderVolume != undefined && orderVolume != '') {
                vm.placeMarketOrder('BUYY', orderVolume, instrumentType, instrumentId, offerPrice)
            }
            else if (value == '-' && bidPrice > 0 && orderVolume != null && orderVolume != undefined && orderVolume != '') {
                vm.placeMarketOrder('SELL', orderVolume, instrumentType, instrumentId, bidPrice)
            }
        }

        function executeValueHistoryShortcut(value, type) {
            // alert(value);
            if (value == 'UpArrow') {
                getPreviousValueAndSet(type);
            } else if (value == 'DownArrow') {
                getNextValueAndSet(type);
            }
        }

        function getPreviousValueAndSet(type) {
            if (type == 'limit') {
                vm.currentLimitPriceIndex = vm.currentLimitPriceIndex - 1;
                if (vm.currentLimitPriceIndex < 0) {
                    vm.currentLimitPriceIndex = vm.limitPriceArray.length - 1;
                }
            } else if (type == 'buylimit') {
                vm.currentBuyLimitPriceIndex = vm.currentBuyLimitPriceIndex - 1;
                if (vm.currentBuyLimitPriceIndex < 0) {
                    vm.currentBuyLimitPriceIndex = vm.buyLimitPriceArray.length - 1;
                }
            } else if (type == 'selllimit') {
                vm.currentSellLimitPriceIndex = vm.currentSellLimitPriceIndex - 1;
                if (vm.currentSellLimitPriceIndex < 0) {
                    vm.currentSellLimitPriceIndex = vm.sellLimitPriceArray.length - 1;
                }
            }
            getValueFromPriceIndex(type);
        }

        function getNextValueAndSet(type) {
            vm.currentLimitPriceIndex = vm.currentLimitPriceIndex + 1;
            if (vm.currentLimitPriceIndex > vm.limitPriceArray.length - 1) {
                vm.currentLimitPriceIndex = 0;
            }
            getValueFromPriceIndex(type);
        }

        function getValueFromPriceIndex(type) {
            if (type == 'limit') {
                vm.orderDTO.limitExchangeRate = vm.limitPriceArray[vm.currentLimitPriceIndex];
            } else if (type == 'buylimit') {
                vm.orderDTO.buyLimitExchangeRate = vm.buyLimitPriceArray[vm.currentBuyLimitPriceIndex];
            } else if (type == 'selllimit') {
                vm.orderDTO.sellLimitExchangeRate = vm.sellLimitPriceArray[vm.currentSellLimitPriceIndex];
            }
        }

        function addLimitPriceToArray(limitPrice) {
            vm.limitPriceArray.push(limitPrice);
            vm.currentLimitPriceIndex = vm.limitPriceArray.length;
        }

        function addSellLimitPriceToArray(limitPrice) {
            vm.sellLimitPriceArray.push(limitPrice);
            vm.currentSellLimitPriceIndex = vm.limitPriceArray.length;
        }

        function addBuyLimitPriceToArray(limitPrice) {
            vm.buyLimitPriceArray.push(limitPrice);
            vm.currentBuyLimitPriceIndex = vm.limitPriceArray.length;
        }

        console.log("INSIDE CONTROLLER - " + vm.isFromIndex);

        if ($sessionStorage.isAuth == true) {
            getAccount();
            $timeout(function () {
                DealingAdminApplicationWideSettings.getConfigValueForConfigName({ "configName": "MinimumIdleTimeToRestrictOrderActivity" }, function (result) {
                    Idle.unwatch();
                    Idle.setIdle(Number(result.value) * 60);
                    Idle.watch();
                })
            }, 100);
        }

        $scope.$on('authenticationSuccess', function () {
            $sessionStorage.isAuth = true;
            EntityPermissions.clearEntityPermission();
            getAccount();
            // getNotifications();
            $timeout(function () {
                DealingAdminApplicationWideSettings.getConfigValueForConfigName({ "configName": "MinimumIdleTimeToRestrictOrderActivity" }, function (result) {
                    Idle.unwatch();
                    Idle.setIdle(Number(result.value) * 60);
                    Idle.watch();
                })
            }, 100)
        });

        $scope.$on('IdleStart', function () {
        });

        $scope.$on('IdleWarn', function (e, countdown) {

        });

        $scope.$on('IdleTimeout', function () {
            console.log('Timed out');
            vm.globalValues.setSessionTimedOut(true);
            console.log(vm.globalValues.getSessionTimedOut());
            // write your code here
        });

        $scope.$on('IdleEnd', function () {

        });

        $scope.$on('Keepalive', function () {

        });

        $rootScope.$on('gatewayApp.entityPermissionFetched', function (event, result) {
            clearAndSetPermission();
        });

        vm.openUserProfile = function openUserProfile() {
            $state.go('user-profile', { userId: vm.account.id })
        }

        vm.openHelp = function openHelp() {
            /*
               * var day = new Date(); var id = day.getTime(); var popup =
               * $window.open("help.html", id,
               * "width=500,height=500,left=400,top=150"); popup.screenName =
               * vm.screenName; popup.screenType = vm.screenType;
               * if($state.current.name=='home'){ popup.screenName = "Home";
               * popup.screenType = "Home"; }
               */
            if (vm.account.organisation.organisationType.shortName == 'CLEARCORP') {
                CustomerRegistration.getHelpContent({ type: 'User_Manual_Clearcorp' }, onGetHelpContentsSuccess, onGetHelpContentsFailure);
            } else if (vm.account.organisation.organisationType.shortName == 'BANK') {
                CustomerRegistration.getHelpContent({ type: 'User_Manual_Bank' }, onGetHelpContentsSuccess, onGetHelpContentsFailure);
            } else if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                CustomerRegistration.getHelpContent({ type: 'User_Manual_Customer' }, onGetHelpContentsSuccess, onGetHelpContentsFailure);
            }
        }

        function base64ToArrayBuffer(base64) {
            var binary_string = window.atob(base64);
            var len = binary_string.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }
            return bytes.buffer;
        }

        function onGetHelpContentsSuccess(result) {
            if (result.contents != null && result.contents != undefined) {
                var contentByteArray = base64ToArrayBuffer(result.contents);

                var file = new Blob([contentByteArray], { type: 'application/pdf' });
                var fileURL = URL.createObjectURL(file);

                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file, "FXRetail_User_Manual.pdf");
                }
                else {
                    window.open(fileURL, "FXRetail_User_Manual.pdf");
                }
            }
        }

        function onGetHelpContentsFailure() {

        }

        vm.openApplicationWideSettings = function openApplicationWideSettings() {
            $state.go('application-wide-settings', { userId: vm.account.id })
        }

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                $rootScope.account = account;
                if (account != null) {
                    if (account.entityOwnerType.shortName == 'Branch') {
                        Branch.getBranchForUser({ userId: account.id }, function (result) {
                            GlobalValues.checkAndSetSelectedBranch(result);
                        })
                    }
                    if (account.entityOwnerType.shortName == 'Bank' || account.entityOwnerType.shortName == 'Branch') {
                        BankRegistration.get({ id: account.organisation.id }, function (result) {
                            GlobalValues.checkAndSetSelectedBank(result);
                            if (!vm.isFromIndex) {
                                $timeout(function () { bootUp(); }, 50);
                                //getNotifications();
                            } else {
                                //Market.getDailyClosingPrice(onGetLtpForLimitSuccess, onGetLtpForLimitFailure);
                                //CurrencyPair.query(onGetCurrencyPairSuccess, onGetCurrencyPairFailure);
                                loadPageHeader();
                            }
                        })
                    }
                    if (account.entityOwnerType.shortName == 'MultiUserCustomer' || account.entityOwnerType.shortName == 'SingleUserCustomer') {
                        CustomerRegistration.getCustomer({ id: account.organisation.id }, function (result) {
                            GlobalValues.checkAndSetSelectedCustomer(result);
                            if (!vm.isFromIndex) {
                                $timeout(function () { bootUp(); }, 50);
                                //getNotifications();
                                // set tradingbank to rootscope
                                CustomerBankRelationshipReport.getCustomerTradingBanks({ customerId: account.organisation.id }, function (result) {
                                    $rootScope.tradingRelationsForCustomer = result;
                                })
                                // get customer agreed tac list
                                TACViewForEntitiesService.getCustomerAgreedTACList({ customerId: account.organisation.id }, function (result) {
                                    $rootScope.agreedTACList = result;

                                    // Validate and Show Clearcop TAC Agree Popup Alert
                                    if(! GlobalValues.getClearCorpTACPopup() )
                                    {
                                        GlobalValues.setClearCorpTACPopup(true)
                                        clearCorpTacAgreePopUp();
                                    }

                                })
                            } else {
                                //Market.getDailyClosingPrice(onGetLtpForLimitSuccess, onGetLtpForLimitFailure);
                                //CurrencyPair.query(onGetCurrencyPairSuccess, onGetCurrencyPairFailure);
                                loadPageHeader();
                            }
                        })
                    }
                    if (account.entityOwnerType.shortName == 'Clearcorp') {
                        if (!vm.isFromIndex) {
                            $timeout(function () { bootUp(); }, 50);
                            //getNotifications();
                        } else {
                            //Market.getDailyClosingPrice(onGetLtpForLimitSuccess, onGetLtpForLimitFailure);
                            //CurrencyPair.query(onGetCurrencyPairSuccess, onGetCurrencyPairFailure);
                            loadPageHeader();
                        }
                    }
                    if ($rootScope.lookupFilled == null && $rootScope.lookupFilled == undefined) {
                        GlobalValues.checkAndSetSelectedUser(account);
                        GlobalValues.checkAndSetSelectedOrganisation(account.organisation);
                        GlobalValues.checkAndSetSelectedEntityOwnerType(account.entityOwnerType);
                        //GlobalValues.checkAndSetSelectedConfigurationSettings(StaticLookUp.getConfigSettings());
                        StaticLookUp.getConfigSettings(function (result) {
                            GlobalValues.checkAndSetSelectedConfigurationSettings(result);
                        })
                        GlobalValues.checkAndSetSelectedSystemSettings(IntradayMarket.getCurrentBusinessDate());
                        GlobalValues.checkAndSetSelectedCountry(Country.getCountryForUser({ shortName: 'INDIA' }));
                        GlobalValues.checkAndSetSelectedFinancialYear(StaticLookUp.getFinancialYear());
                        GlobalValues.setSessionTimedOut(false);
                        GlobalValues.checkAndSetSelectedDefaultCurrencyPairId(1);
                   //clearAndSetPermission();
                        // DefaultMarket.marketInstruments(onGetInstrumentSuccess, onGetInstrumentFailure);
                        // StaticLookUp.getTenorsWithBrokenDate(onGetTenorSuccess, onGetTenorFailure);
                        // StaticLookUp.getTenorsForLookup(onGetTenorLookupSuccess, onGetTenorLookupFailure);

                        // vm.isAuthenticated = Principal.isAuthenticated;
                        console.log('subscribe websocket from home controller');

                        subscribeWebSocket();
                        $rootScope.lookupFilled = 'yes';
                    }
                    clearAndSetPermission();
                    StaticLookUp.getConfigSettings(function (result) {
                        onGetConfigSuccess(result);
                    })


                    StaticLookUp.transactionParametersSetting(onGetTransactionSuccess,onGetTransactionFailure)

                    //DefaultMarket.marketInstruments(onGetInstrumentSuccess, onGetInstrumentFailure);
                    getInstrumentMatchedCurrencypair();
                    StaticLookUp.getTenorsWithBrokenDate(onGetTenorSuccess, onGetTenorFailure);
                    StaticLookUp.getTenorsForLookup(onGetTenorLookupSuccess, onGetTenorLookupFailure);
                    ExposureType.getAllExposureTypes(onGetAllExposureLookupSuccess, onGetAllExposureLookupFailure);
                    ExposureType.getEnabledExposureTypes(onGetEnabledExposureLookupSuccess, onGetEnabledExposureLookupFailure);
                    ExposureSubType.getAllExposureSubTypes(onGetAllSubExposureLookupSuccess, onGetAllSubExposureLookupFailure);
                    ExposureSubType.getEnabledExposureSubTypes(onGetEnabledSubExposureLookupSuccess, onGetEnabledSubExposureLookupFailure);

                    vm.isAuthenticated = Principal.isAuthenticated;

                }
            });
        }


        function onGetTransactionSuccess(result){

            console.log("transanction success");
            GlobalValues.checkAndSetSelectedTransactionParametersSettings(result);

        }


        function onGetTransactionFailure(result){
            console.log("failure transaction get");
        }
        /*
         * load page header for page refresh JIRA 1065
         */
        function loadPageHeader() {

            // get server status
            //ServerComponentStatus.getServerComponentStatus(onGetServerStatusSuccess, onGetServerStatusFailure);
            //market status
            setIntradayMarketSessionDetails();
            //daily closing price - Not required since the ticker price is not shown in index.html top and only showed in home page
            // Market.getDailyClosingPrice(onGetLtpForLimitSuccess, onGetLtpForLimitFailure);
            //currency pair
            //get notification
            getNotifications();

            //get user preference on refresh from any other pages rather than home page
            UserProfile.get({ userId: vm.account.id }, onGetUserPreferenceSuccess, onGetUserPreferenceFailure);

           // UserProfile.getCurrencytUserPreference({ userId: vm.account.id }, onGetCurrencyWiseUserPreferenceSuccess, onGetCurrencyWiseUserPreferenceFailure);



        }




        function onGetUserPreferenceSuccess(result) {
            vm.userPreference = result;
            $rootScope.userPreference = result;
            onGetCurrencyWiseUserPreferenceSuccess(vm.userPreference.currencyWiseUserPreferenceSettingsDTOList)
        }

        function onGetUserPreferenceFailure() {

        }

        function onGetCurrencyWiseUserPreferenceSuccess(result) {
           $rootScope.currencyWiseUserPreferenceSettings = [];


            angular.forEach(result,function(value){



    var currencyId = value.currencyPair.id;
    var shortName = value.shortName;

    if (!currencyId || !shortName) return;

    // Get existing object from map
    var obj = $rootScope.currencyWiseUserPreferenceSettings[currencyId];

    if (!obj) {
        obj = {
            currencyPair: value.currencyPair.code,
            configs: [null, null, null,null] // SPOT, TOM, CASH
        };
    }

    switch (shortName) {
        case "AllowedOrderPriceDeviationFromMarketPriceInPaise":
            obj.configs[0] = value.configValue;
            break;
        case "MaximumOrderValueHardCheck":
            obj.configs[1] = value.configValue;
            break;
        case "MaximumOrderValueSoftCheck":
            obj.configs[2] = value.configValue;
            break;
        case "AllowedOrderPriceDeviationFromMarketPriceInPercentage":
            obj.configs[3] = value.configValue;
            break;
        default:
            console.warn("Unknown instrumentCode:", shortName);
    }

             $rootScope.currencyWiseUserPreferenceSettings[currencyId] =  obj;

            });
        }

        function onGetCurrencyWiseUserPreferenceFailure() {

        }

        function subscribeWebSocket() {
            WebSocket.subscribeWebSocket(vm.account.id);
        }


        function register() {
            $state.go('register');
        }

        function clearAndSetPermission() {
            clearPermission();
            setPermission();
        }

        // function clearPermission() {
        //     vm.permitdashboardToDo = false;
        //     vm.permitsecurityPolicyRoles = false;
        //     vm.permitsecurityPolicyUsers = false;
        //     vm.permitsecurityPolicyClearance = false;
        //     vm.permitsecurityPolicySecurity = false;
        //     vm.permitsecurityPolicyApproval = false;
        //     vm.permitglobalSecurityPolicySecurity = false;
        //     vm.permitglobalSecurityPolicyApproval = false;
        //     vm.permitorganisationOrgProfile = false;
        //     vm.permitdashboardToDo = false;
        //     vm.permitAlertConfiguration = false;
        //     vm.permitManageFAQ = false;
        //     vm.permitExecuteAlertNotifications = false;
        //     vm.permitUserManagement = false;
        //     vm.permitBankRegistration = false;
        //     vm.permitBranchRegistration = false;
        //     vm.permitcustomerViewReport = false;
        //     vm.permitsmsFailureReport = false;
        //     vm.permitUserAdminApplicationWideSettings = false;
        //     vm.permitDealingAdminApplicationWideSettings = false;
        //     vm.permitSMSSettings = false;
        //     vm.permitAuditLogReport = false;
        //     vm.permitHistoryReport = false;
        //     vm.permitCustomerOnBoardingExceptionReport = false;
        //     vm.permitcustomerToDo = false;
        //     vm.permitCustomerBankRelationshipReport = false;
        //     vm.permitCustomerSpecificSettings = false;
        //     vm.permitAddBankRegistration = false;
        //     vm.permitAddBranchRegistration = false;
        //     vm.permitSessionLogReport = false;
        //     vm.permitCustomerInfoUpdateStatus = false;
        //     vm.permitEODProcess = false;
        //     vm.permitRegularHoliday = false;
        //     vm.permitSpecialHoliday = false;
        //     vm.permitSwapQuotes = false;
        //     vm.permitSwapQuotesEditEntityAction = false;
        //     vm.permitDefaultMarkupSettings = false;
        //     vm.permitMarkupSettings = false;
        //     vm.permitHeConnectivitySettings = false;
        //     vm.permitInstrumentView = false;
        //     vm.permitIntradayMarketSessionSettings = false;
        //     vm.permitDefaultMarketSessionSettings = false;
        //     vm.permitEmailSettings = false;
        //     vm.permitUserRestriction = false;
        //     vm.permitLimitSettings = false;
        //     vm.permitCustomerLimitSettings = false;
        //     vm.permitMarkupReport = false;
        //     vm.permitOrderStatusReport = false;
        //     vm.permitSettlementReport = false;
        //     vm.permitEntityRestriction = false;
        //     vm.permitMarketMovement = false;
        //     vm.permitTradingDashboard = false;
        //     vm.permitNewOrderEntry = false;
        //     vm.permitModifyOrderEntry = false;
        //     vm.permitCancelOrderEntry = false;
        //     vm.permitSODProcess = false;
        //     vm.permitUserwiseTurnoverReport = false;
        //     vm.permitOrderHistory = false;
        //     vm.permitTradeHistory = false;
        //     vm.permitAMCSettings = false;
        //     vm.permitNoOfAvailalbeUsersReport = false;
        //     vm.permitNoOfLoggedInUsersReport = false;
        //     vm.permitCustomerChargesSettings = false;
        //     vm.permitGSTSettings = false;
        //     vm.permitInvoiceView = false;
        //     vm.permitTransactionCharges = false;
        //     vm.permitBroadcastMessages = false;
        //     vm.permitServerComponentStatusView = false;
        //     vm.permitGenericUsers = false;
        //     vm.permitTransactionChargesSettings = false;
        //     vm.permitUploadParticipantCertificates = false;
        //     vm.permitTradesDownload = false;
        //     vm.permitHomeBranchUpload = false;
        //     vm.permitPendingOrderView = false;
        //     vm.permitSwapQuotesView = false;
        //     vm.permitTradesForTheDay = false;
        //     vm.permitLimitUtilisationReport = false;
        //     vm.permitCustomerMarkupView = false;
        //     vm.permitStandardTenorView = false;
        //     vm.permitSystemAmendedTrades = false;
        //     vm.permitClearcorpTAC = false;
        //     vm.permitCustomerTACUpload = false;
        //     vm.permitTermsAndConditionsView = false;
        //     vm.permitEInvoiceUpload = false;
        //     vm.permitOTRSummary = false;
        //     vm.permitTransactionChargesSummary = false;
        //     vm.permitAMCSummary = false;
        //     vm.permitLoggedInUsersForBank = false;
        //     vm.permitUserAccessView = false;
        //     vm.permitExposureType = false;
        //     vm.permitExposureSubType = false;
        //     vm.permitCreditFactorSettings = false;
        //     vm.permitLimitUtilisationSplitupReport = false;
        //     vm.permitOutstandingTradesReport = false;
        //     vm.permitPendingLimitRequestsView = false;
        //     vm.permitCreditFactorRequestsView = false;
        //     vm.permitMemberFeesAndCharges = false;
        //     vm.permitFeesAndChargesUpload = false;
        //     vm.relationshipBankFeesAndCharges = false;
        //     vm.permitCancelledOrdersReport = false;
        //     vm.permitOTRSummaryForBank = false;
        //     vm.permitOrderActivityLog = false;
        //     vm.permitOrderUpload = false;
        //     vm.permitRefreshLimit = false;
        //     vm.permitAddManageHomeBranch = false;
        //     vm.permitBankSpecificSettings = false;
        //     vm.permitAddForexConfigurations = false;
        // }


        function clearPermission() {
            var permKeys = [
                'permitdashboardToDo','permitsecurityPolicyRoles','permitsecurityPolicyUsers',
                'permitsecurityPolicyClearance','permitsecurityPolicySecurity','permitsecurityPolicyApproval',
                'permitglobalSecurityPolicySecurity','permitglobalSecurityPolicyApproval',
                'permitorganisationOrgProfile','permitAlertConfiguration','permitManageFAQ',
                'permitExecuteAlertNotifications','permitUserManagement','permitBankRegistration',
                'permitBranchRegistration','permitcustomerViewReport','permitsmsFailureReport',
                'permitUserAdminApplicationWideSettings','permitDealingAdminApplicationWideSettings',
                'permitSMSSettings','permitAuditLogReport','permitHistoryReport',
                'permitCustomerOnBoardingExceptionReport','permitcustomerToDo',
                'permitCustomerBankRelationshipReport','permitCustomerSpecificSettings',
                'permitAddBankRegistration','permitAddBranchRegistration','permitSessionLogReport',
                'permitCustomerInfoUpdateStatus','permitEODProcess','permitRegularHoliday',
                'permitSpecialHoliday','permitSwapQuotes','permitSwapQuotesEditEntityAction',
                'permitDefaultMarkupSettings','permitMarkupSettings','permitHeConnectivitySettings',
                'permitInstrumentView','permitIntradayMarketSessionSettings',
                'permitDefaultMarketSessionSettings','permitEmailSettings','permitUserRestriction',
                'permitLimitSettings','permitCustomerLimitSettings','permitMarkupReport',
                'permitOrderStatusReport','permitSettlementReport','permitEntityRestriction',
                'permitMarketMovement','permitTradingDashboard','permitNewOrderEntry',
                'permitModifyOrderEntry','permitCancelOrderEntry','permitSODProcess',
                'permitUserwiseTurnoverReport','permitOrderHistory','permitTradeHistory',
                'permitAMCSettings','permitNoOfAvailalbeUsersReport','permitNoOfLoggedInUsersReport',
                'permitCustomerChargesSettings','permitGSTSettings','permitInvoiceView',
                'permitTransactionCharges','permitBroadcastMessages','permitServerComponentStatusView',
                'permitGenericUsers','permitTransactionChargesSettings',
                'permitUploadParticipantCertificates','permitTradesDownload','permitHomeBranchUpload',
                'permitPendingOrderView','permitSwapQuotesView','permitTradesForTheDay',
                'permitLimitUtilisationReport','permitCustomerMarkupView','permitStandardTenorView',
                'permitSystemAmendedTrades','permitClearcorpTAC','permitCustomerTACUpload',
                'permitTermsAndConditionsView','permitEInvoiceUpload','permitOTRSummary',
                'permitTransactionChargesSummary','permitAMCSummary','permitLoggedInUsersForBank',
                'permitUserAccessView','permitExposureType','permitExposureSubType',
                'permitCreditFactorSettings','permitLimitUtilisationSplitupReport',
                'permitOutstandingTradesReport','permitPendingLimitRequestsView',
                'permitCreditFactorRequestsView','permitMemberFeesAndCharges',
                'permitFeesAndChargesUpload','relationshipBankFeesAndCharges',
                'permitCancelledOrdersReport','permitOTRSummaryForBank','permitOrderActivityLog',
                'permitOrderUpload','permitRefreshLimit','permitAddManageHomeBranch',
                'permitBankSpecificSettings','permitAddForexConfigurations'
            ];
            for (var i = 0; i < permKeys.length; i++) {
                vm[permKeys[i]] = false;
            }
        }


        function setPermission() {
            vm.permitdashboardToDo = vm.hasPermission('ToDo');
            vm.permitsecurityPolicyRoles = vm.hasPermission('OrganisationRole');
            vm.permitsecurityPolicyUsers = vm.hasPermission('UserRole');
            vm.permitsecurityPolicyClearance = vm.hasPermission('UserClearance');
            vm.permitsecurityPolicySecurity = vm.hasPermission('SecurityPolicy');
            vm.permitsecurityPolicyApproval = vm.hasPermission('ApprovalProcess');
            vm.permitglobalSecurityPolicySecurity = vm.hasPermission('GlobalSecurityPolicy');
            vm.permitglobalSecurityPolicyApproval = vm.hasPermission('GlobalApprovalProcess');
            vm.permitorganisationOrgProfile = vm.hasPermission('Organisation');
            vm.permitdashboardToDo = vm.hasPermission('ToDo');
            vm.permitAlertConfiguration = vm.hasPermission('AlertConfiguration');
            vm.permitManageFAQ = vm.hasPermission('FAQ');
            vm.permitExecuteAlertNotifications = vm.hasPermission('ExecuteAlertNotifications');
            vm.permitUserManagement = vm.hasPermission('UserManagement');
            vm.permitBankRegistration = vm.hasPermission('BankRegistration');
            vm.permitBranchRegistration = vm.hasPermission('BranchRegistration');
            vm.permitcustomerViewReport = vm.hasPermission('CustomerViewReport');
            vm.permitsmsFailureReport = vm.hasPermission('SMSFailureReport');
            vm.permitUserAdminApplicationWideSettings = vm.hasPermission('UserAdminApplicationWideSettings');
            vm.permitDealingAdminApplicationWideSettings = vm.hasPermission('DealingAdminApplicationWideSettings');
            vm.permitSMSSettings = vm.hasPermission('SMSSettings');
            vm.permitAuditLogReport = vm.hasPermission('AuditLogReport');
            vm.permitHistoryReport = vm.hasPermission('HistoryReport');
            vm.permitCustomerOnBoardingExceptionReport = vm.hasPermission('CustomerOnboardingExceptionReport');
            vm.permitcustomerToDo = vm.hasPermission('CustomerApproval');
            vm.permitCustomerBankRelationshipReport = vm.hasPermission('TradingBankList');
            vm.permitCustomerSpecificSettings = vm.hasPermission('CustomerSpecificSettings');
            vm.permitAddBankRegistration = vm.hasPermission('BankRegistration.CREATE');
            vm.permitAddBranchRegistration = vm.hasPermission('BranchRegistration.CREATE');
            vm.permitSessionLogReport = vm.hasPermission('SessionLogReport');
            vm.permitCustomerInfoUpdateStatus = vm.hasPermission('Customer');
            vm.permitEODProcess = vm.hasPermission('EODProcess');
            vm.permitRegularHoliday = vm.hasPermission('RegularHolidays');
            vm.permitSpecialHoliday = vm.hasPermission('SpecialHoliday');
            vm.permitSwapQuotes = vm.hasPermission('SwapQuotes');
            vm.permitSwapQuotesEditEntityAction = vm.hasPermission("SwapQuotes.EDIT");
            vm.permitDefaultMarkupSettings = vm.hasPermission('DefaultMarkupSettings');
            vm.permitMarkupSettings = vm.hasPermission('MarkupSettings');
            vm.permitHeConnectivitySettings = vm.hasPermission('HEConnectivitySettings');
            vm.permitInstrumentView = vm.hasPermission('InstrumentView');
            vm.permitIntradayMarketSessionSettings = vm.hasPermission('IntradayMarketSessionSettings');
            vm.permitDefaultMarketSessionSettings = vm.hasPermission('DefaultMarketSessionSettings');
            vm.permitEmailSettings = vm.hasPermission('EmailSettings');
            vm.permitUserRestriction = vm.hasPermission('UserRestriction');
            vm.permitLimitSettings = vm.hasPermission('LimitSettings');
            vm.permitCustomerLimitSettings = vm.hasPermission('CustomerLimitChangeRequest');
            vm.permitMarkupReport = vm.hasPermission('MarkupReport');
            vm.permitOrderStatusReport = vm.hasPermission('OrderStatusReport');
            vm.permitSettlementReport = vm.hasPermission('TradesToBeSettledReport');
            vm.permitEntityRestriction = vm.hasPermission('EntityRestriction');
            vm.permitMarketMovement = vm.hasPermission('MarketMovement');
            vm.permitTradingDashboard = vm.hasPermission('TradeOrderManagementDashboard');
            vm.permitNewOrderEntry = vm.hasPermission('OrderEntry.CREATE');
            vm.permitModifyOrderEntry = vm.hasPermission('OrderEntry.EDIT');
            vm.permitCancelOrderEntry = vm.hasPermission('OrderEntry.DELETE');
            vm.permitSODProcess = vm.hasPermission('SODProcess');
            vm.permitUserwiseTurnoverReport = vm.hasPermission('UserwiseTurnoverReport');
            vm.permitOrderHistory = vm.hasPermission('OrderHistory');
            vm.permitTradeHistory = vm.hasPermission('TradeHistory');
            vm.permitAMCSettings = vm.hasPermission('AMCSettings');
            vm.permitNoOfAvailalbeUsersReport = vm.hasPermission('NoOfAvailableUsers');
            vm.permitNoOfLoggedInUsersReport = vm.hasPermission('NoOfLoggedInUsers');
            vm.permitCustomerChargesSettings = vm.hasPermission('CustomerCharges');
            vm.permitGSTSettings = vm.hasPermission('GSTSettings');
            vm.permitInvoiceView = vm.hasPermission('InvoiceView');
            vm.permitTransactionCharges = vm.hasPermission('TransactionChargesReport');
            vm.permitBroadcastMessages = vm.hasPermission('BroadcastMessages');
            vm.permitServerComponentStatusView = vm.hasPermission('ServerComponentStatus');
            vm.permitTransactionChargesSettings = vm.hasPermission('TransactionChargesSettings');
            vm.permitUploadParticipantCertificates = vm.hasPermission('UploadDownloadParticipantCertificate');
            vm.permitTradesDownload = vm.hasPermission('TradesDownload');
            vm.permitHomeBranchUpload = vm.hasPermission('HomeBranchIFSCUpload');
            vm.permitPendingOrderView = vm.hasPermission('PendingOrderReport');
            vm.permitTradesForTheDay = vm.hasPermission('TradesForTheDay');
            vm.permitSwapQuotesView = vm.hasPermission('SwapQuotesView');
            vm.permitLimitUtilisationReport = vm.hasPermission('LimitUtilisationReport');
            vm.permitCustomerMarkupView = vm.hasPermission('CustomerMarkupView');
            vm.permitStandardTenorView = vm.hasPermission('StandardTenorView');/**/
            vm.permitSystemAmendedTrades = vm.hasPermission('SystemAmendedTradesReport');
            vm.permitCustomerTACUpload = vm.hasPermission('CustomerTermsAndConditionsUpload');
            vm.permitTermsAndConditionsView = vm.hasPermission('TermsAndConditionsView');
            vm.permitEInvoiceUpload = vm.hasPermission('eInvoiceUpload');
            vm.permitOTRSummary = vm.hasPermission("OTRSummary");
            vm.permitTransactionChargesSummary = vm.hasPermission("TransactionChargesSummary");
            vm.permitAMCSummary = vm.hasPermission("AMCSummary");
            vm.permitLoggedInUsersForBank = vm.hasPermission("NoOfLoggedInUsersForBank");
            vm.permitUserAccessView = vm.hasPermission("UserAccessView");
            vm.permitExposureType = vm.hasPermission("ExposureType");
            vm.permitExposureSubType = vm.hasPermission("ExposureSubType");
            vm.permitCreditFactorSettings = vm.hasPermission("CreditFactorSettings");
            vm.permitLimitUtilisationSplitupReport = vm.hasPermission("LimitUtilisationSplitupReport");
            vm.permitOutstandingTradesReport = vm.hasPermission("OutstandingTradesReport");
            vm.permitPendingLimitRequestsView = vm.hasPermission("PendingLimitRequestsView");
            vm.permitCreditFactorRequestsView = vm.hasPermission("CreditFactorSettingsView");
           vm.permitMemberFeesAndCharges = vm.hasPermission("BankFeesAndChargesView");
           vm.permitFeesAndChargesUpload = vm.hasPermission("BankFeesChargesUpload");

           vm.relationshipBankFeesAndCharges = true; //always true since all customers users can view it vm.hasPermission("BankFeesAndChargesView");
           vm.permitCancelledOrdersReport = vm.hasPermission('CancelledOrdersReport');
           vm.permitOTRSummaryForBank = vm.hasPermission('OTRSummaryForBank');
           vm.permitOrderActivityLog=vm.hasPermission('OrderActivityLog');
           vm.permitOrderUpload = vm.hasPermission('OrderUpload');
           vm.permitRefreshLimit = vm.hasPermission('RefreshLimit');
           vm.permitAddManageHomeBranch = vm.hasPermission('ManageHomeBranch');
           vm.permitBankSpecificSettings=vm.hasPermission('BankNotificationSettings');
           vm.permitAddForexConfigurations = vm.hasPermission('ManageForexConfigurations');
            vm.permitCurrencyPairConfiguration = vm.hasPermission('ManageCurrencyPairConfiguration');
 	    vm.permitManageBBPSSettings = vm.hasPermission('ManageBBPSSettings');

 	    	//if(vm.globalValues.getConfigSettings().showGenericUsers == 'Yes')
 	    	//	vm.permitGenericUsers = true;
        }

        function onGetConfigSuccess(result) {
            if (result.showGenericUsers == 'Yes') {
                vm.permitGenericUsers = true;
            }

            if (result.allowOrderImport == 'Yes') {
                vm.allTradingBanks = CustomerBankRelationshipReport.query();
            }

            if (result.negligibleExceptionNumbers != undefined && result.negligibleExceptionNumbers != '') {
                $rootScope.negligibleExceptionNumberList = result.negligibleExceptionNumbers.split(',');
            }
            if (result.maximumOptionPeriodDuration != undefined && result.maximumOptionPeriodDuration != null && result.maximumOptionPeriodDuration != '') {
                $rootScope.maximumOptionPeriodDuration = parseInt(result.maximumOptionPeriodDuration, 10);
            }

        }

        // getNotifications();

        vm.getNotifications = function getNotifications() {
            Notifications.getPopupNotificationsByUserId(onGetNotificationSuccess, onGetNotificationFailure);
        }

        vm.getNotificationsFromIndex = function getNotificationsFromIndex(event) {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            Notifications.getPopupNotificationsByUserId(onGetNotificationSuccess, onGetNotificationFailure);
            if ($scope.toggle == false) {
                $timeout(function () {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        }

        function getNotifications() {
            Notifications.getPopupNotificationsByUserId(onGetNotificationSuccess, onGetNotificationFailure);
        }

        function onGetNotificationSuccess(result) {
            $rootScope.notificationsDTO = result;
            console.log($rootScope.notificationsDTO);
            if ($rootScope.notificationsDTO != null) {
                $rootScope.orderServerNotificationLastId = angular.copy($rootScope.notificationsDTO.orderServerNotificationLastId);
                $rootScope.pushNotificationLastId = angular.copy($rootScope.notificationsDTO.pushNotificationLastId);
                $rootScope.queryServerNotificationLastId = angular.copy($rootScope.notificationsDTO.queryServerNotificationLastId);
            }
        }

        function onGetNotificationFailure() {

        }

        vm.getMessage = function getMessage(notificationList) {
            var messageArr = {};

            switch (angular.lowercase(notificationList.entity.shortName)) {

                case 'termsandconditionsupload':
                    var notificationArray = notificationList.message.split("~~");
                    var message = notificationArray[1];
                    return $sce.trustAsHtml('<div style="padding:5px"><span style="font-weight:bold;color:#158a8d;font-size:12px"><b>' + notificationArray[0] + '</b></span>' +
                        '<span style="float:right;color:#989898">' + $filter('date')(new Date(notificationList.createdDateTime), 'HH:mm:ss') + '</span><br>' +
                        '<div style="padding-top:5px"><span style="word-wrap:break-word;white-space:normal;margin-bottom:10px">' + message +
                        '</span></div></div>');
                    break;
                case 'customertermsandconditionsupload':
                    var notificationArray = notificationList.message.split("~~");
                    var message = notificationArray[1];
                    return $sce.trustAsHtml('<div style="padding:5px"><span style="font-weight:bold;color:#158a8d;font-size:12px"><b>' + notificationArray[0] + '</b></span>' +
                        '<span style="float:right;color:#989898">' + $filter('date')(new Date(notificationList.createdDateTime), 'HH:mm:ss') + '</span><br>' +
                        '<div style="padding-top:5px"><span style="word-wrap:break-word;white-space:normal;margin-bottom:10px">' + message +
                        '</span></div></div>');
                    break;
                case 'customer':
                    messageArr = JSON.parse(notificationList.message);
                    return $sce.trustAsHtml('<div style="padding:5px"><span style="font-weight:bold;color:#7F55FF;font-size:12px"><b>Customer Address Change</b></span>'
                        + '<span style="float:right;color:#989898">' + $filter('date')(new Date(notificationList.createdDateTime), 'HH:mm:ss') + '</span><br><div style="padding-top:5px"><span">' + $filter('date')(new Date(notificationList.runDate), 'dd-MMM-yyyy') +
                        '</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span>Customer Info Update' +
                        '</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span>' + messageArr.customer.customerCode +
                        '</span>&nbsp;&nbsp;|&nbsp;&nbsp;</br><span">' + messageArr.customer.customerType.shortName +
                        '</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span>' + messageArr.customer.customerFirstName +
                        '</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span >' + messageArr.customer.panNumber +
                        '</span></div></div>');
                    break;
                case 'tradeordermanagementdashboard':
                    var notificationArray = notificationList.message.split("~~");
                    var message = notificationArray[1];
                    if (notificationArray[0] == "Order Confirmation" || notificationArray[0] == "Order Acceptance" || notificationArray[0] == "Order Cancellation-by Admin/Session close" ||
                        notificationArray[0] == "Order Server Manual Login Completed" || notificationArray[0] == "HE Status Update Completed") {

                        return $sce.trustAsHtml('<div style="padding:5px"><span style="font-weight:bold;color:#49993C;font-size:12px"><b>' + notificationArray[0] + '</b></span>'
                            + '<span style="float:right;color:#989898">' + $filter('date')(new Date(notificationList.createdDateTime), 'HH:mm:ss') + '</span><br><span>' +
                            '</span><div style="padding-top:5px"><span style="word-wrap:break-word;white-space:normal;margin-bottom:10px">' + message +
                            '</span></div></div>');
                    } else if (notificationArray[0] == "Trade Confirmation" || notificationArray[0] == "CASH Session Close Intimation"
                    ) {

                        return $sce.trustAsHtml('<div style="padding:5px"><span style="font-weight:bold;color:#D54C0F;font-size:12px"><b>' + notificationArray[0] + '</b></span>'
                            + '<span style="float:right;color:#989898">' + $filter('date')(new Date(notificationList.createdDateTime), 'HH:mm:ss') + '</span><br><span>' +
                            '</span><div style="padding-top:5px"><span style="word-wrap:break-word;white-space:normal;">' + message +
                            '</span></div></div>');
                    } else if (notificationArray[0] == "Order Rejection" || notificationArray[0] == "HE Status Update Failed" || notificationArray[0] == "Order Server Manual Login Failed") {

                        return $sce.trustAsHtml('<div style="padding:5px"><span style="font-weight:bold;color:#CD0000;font-size:12px"><b>' + notificationArray[0] + '</b></span>'
                            + '<span style="float:right;color:#989898">' + $filter('date')(new Date(notificationList.createdDateTime), 'HH:mm:ss') + '</span><br><span>' +
                            '</span><div style="padding-top:5px"><span style="word-wrap:break-word;white-space:normal;">' + message +
                            '</span></div></div>');
                    } else if (notificationArray[0] == "Clearcorp Broadcast") {

                        return $sce.trustAsHtml('<div style="padding:5px"><span style="font-weight:bold;color:#158A8D;font-size:12px"><b>' + notificationArray[0] + '</b></span>'
                            + '<span style="float:right;color:#989898">' + $filter('date')(new Date(notificationList.createdDateTime), 'HH:mm:ss') + '</span><br><span>' +
                            '</span><div style="padding-top:5px"><span style="word-wrap:break-word;white-space:normal;">' + message +
                            '</span></div></div>');
                    } else if (notificationArray[0] == "Breached Member Details") {
                        //
                        return $sce.trustAsHtml('<div style="padding:5px"><span style="font-weight:bold;color:#158A8D;font-size:12px"><b>' + notificationArray[0] + '</b></span>'
                            + '<span style="float:right;color:#989898">' + $filter('date')(new Date(notificationList.createdDateTime), 'HH:mm:ss') + '</span><br><span>' +
                            '</span><div style="padding-top:5px"><span style="word-wrap:break-word;white-space:normal;">' + message +
                            '</span></div></div>');
                    } else if (notificationArray[0] == "Others") {
                        return $sce.trustAsHtml('<div style="padding:5px"><span style="font-weight:bold;color:#158a8d;font-size:12px"><b>' + notificationArray[0] + '</b></span>' +
                            '<span style="float:right;color:#989898">' + $filter('date')(new Date(notificationList.createdDateTime), 'HH:mm:ss') + '</span><br>' +
                            '<div style="padding-top:5px"><span style="word-wrap:break-word;white-space:normal;margin-bottom:10px">' + message +
                            '</span></div></div>');
                    } else if (notificationArray[0] == "Terms & Conditions") {
                        return $sce.trustAsHtml('<div style="padding:5px"><span style="font-weight:bold;color:#158a8d;font-size:12px"><b>' + notificationArray[0] + '</b></span>' +
                            '<span style="float:right;color:#989898">' + $filter('date')(new Date(notificationList.createdDateTime), 'HH:mm:ss') + '</span><br>' +
                            '<div style="padding-top:5px"><span style="word-wrap:break-word;white-space:normal;margin-bottom:10px">' + message +
                            '</span></div></div>');
                    }


                    break;
                default:
                    messageArr = JSON.parse(notificationList.message);
                    return $sce.trustAsHtml('<span style="margin-left:15px;">' + messageArr.bank +
                        '</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span>' + messageArr.currency +
                        '</span>&nbsp;&nbsp;<span>' + $filter('number')(messageArr.amount, messageArr.numofDecimals) +
                        '</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span>for ' +
                        $filter('date')(new Date(messageArr.dueDate), 'dd-MMM-yyyy') +
                        '</span>&nbsp;&nbsp;|&nbsp;&nbsp;</br><span style="margin-left:15px;">' + messageArr.tradeRefNo +
                        '</span>');

            }

        }

        vm.notify = function notify(notification) {
            if (notification.status != 'VISITED') {
                notification.status = "VISITED";
                Notifications.updatePopupNotificationStatus({
                    'notificationId': notification.notificationId
                });
                $rootScope.notificationsDTO.popupNotificationsCount -= 1;
            }
            switch (angular.lowercase(notification.entity.shortName)) {
                case 'customer':
                    $rootScope.payload = JSON.parse(notification.message);
                    workflowSharedService.viewFrom = "customerinfoupdateintimationview";
                    $state.go('customer-info-update-intimation-view');
            }

        }

        $scope.setIndicator = function (eventType) {
            if (eventType.nature == "Upcoming") {
                return "Notification_Blue.png"
            } else if (eventType.nature == "Overdue") {
                return "Notification_Yellow.png"
            } else {
                return "Notification_Red.png"
            }
        }

        $scope.setBgColor = function (notification) {

            if (notification.status == "PENDING" && (notification.entity.shortName == "TradeOrderManagementDashboard" || notification.entity.shortName == "Customer" || notification.entity.shortName == "TermsAndConditionsUpload" || notification.entity.shortName == "CustomerTermsAndConditionsUpload")) {
                return {
                    background: '#212121',
                    color: '#FFFFFF',
                    marginLeft: '3px',
                    borderLeft: '3px solid #A6A6A6'
                }
            } else if (notification.status == "VISITED" && (notification.entity.shortName == "TradeOrderManagementDashboard" || notification.entity.shortName == "Customer" || notification.entity.shortName == "TermsAndConditionsUpload" || notification.entity.shortName == "CustomerTermsAndConditionsUpload")) {
                return {
                    background: '#000000',
                    color: '#FFFFFF'
                }
            }
            else if (notification.status == "PENDING") {
                return {
                    background: '#1FA9E1',
                    color: '#000000'
                }
            } else if (notification.status == "VISITED") {
                return {
                    background: '#F7FAFF'
                }
            }


        }

        vm.setScreenName = function setScreenName(screenName) {
            vm.screenName = screenName;
            vm.screenType = "Individual";
        }

        vm.today = new Date();
        vm.formattedDate = $filter('date')(vm.today, 'ddMMyyyyHHmm');
        vm.downloadData = downloadData;

        // vm.allTradingBanks=CustomerBankRelationshipReport.query();

        function convertArrayOfObjectsToCSV(args) {
            var result, ctr, keys, columnDelimiter, lineDelimiter, data;

            data = args.data || null;
            if (data == null || !data.length) {
                return null;
            }

            columnDelimiter = args.columnDelimiter || ',';
            lineDelimiter = args.lineDelimiter || '\n';

            keys = Object.keys(data[0]);

            result = '';
            result += keys.join(columnDelimiter);
            result += lineDelimiter;

            data.forEach(function (item) {
                ctr = 0;
                keys.forEach(function (key) {
                    if (ctr > 0) result += columnDelimiter;

                    result += item[key];
                    ctr++;
                });
                result += lineDelimiter;
            });

            return result;
        }

        $scope.$watch('vm.content', function (value) {
            if (value != undefined && value != null) {

                var array = vm.content.split(/\n/);
                var tempHeader = array[0].trim();
                var headerErr = "Error Message";
                var tempHeaderErr = headerErr.trim();
                vm.newArray = tempHeader + "," + tempHeaderErr;

                for (var i = 1; i < array.length; i++) {

                    if (array[i] != "") {
                        vm.orderRequestDTO = array[i].split(',');
                        if (vm.orderRequestDTO != null && vm.orderRequestDTO != '' && vm.orderRequestDTO != "") {
                            vm.orderImport = {};


                            vm.importErrorString = "";
                            vm.bankForTrading = "";

                            validateTradingBankRelationship(vm.orderRequestDTO[13], vm.orderRequestDTO[14], vm.orderRequestDTO[15]);

                            if (vm.importErrorString == "") {

                                vm.orderImport.buySellIndicator = vm.orderRequestDTO[2];
                                vm.orderImport.activityIndicator = vm.orderRequestDTO[0];
                                vm.orderImport.typeOfOrder = vm.orderRequestDTO[6];
                                vm.orderImport.instrumentCode = vm.orderRequestDTO[12];
                                vm.orderImport.orderAmount = vm.orderRequestDTO[3];
                                if (vm.orderImport.typeOfOrder != "MRKT") {
                                    vm.orderImport.limitExchangeRate = vm.orderRequestDTO[7];
                                }
                                if (vm.orderImport.typeOfOrder == "STLS" || vm.orderImport.typeOfOrder == "TKPR") {
                                    vm.orderImport.stopExchangeRate = vm.orderRequestDTO[8];
                                }

                                if (vm.orderImport.activityIndicator != "PLAC") {
                                    vm.orderImport.orderSequenceNumber = vm.orderRequestDTO[1];
                                    vm.orderImport.oldOrderAmount = vm.orderRequestDTO[19];
                                }


                                angular.forEach(vm.instrumentTypes, function (value) {
                                    if (value.instrumentCode == vm.orderImport.instrumentCode) {
                                        vm.orderImport.instrumentId = value.id;
                                    }
                                });
                                fillUploadDTO(vm.orderImport.buySellIndicator, vm.orderImport.activityIndicator, vm.orderImport.typeOfOrder, vm.orderImport.instrumentCode,
                                    vm.orderImport.orderAmount, vm.orderImport.limitExchangeRate, vm.orderImport.stopExchangeRate, vm.orderImport.oldOrderAmount);

                            }

                            if (vm.importErrorString != "") {


                                var tempArr = array[i].trim();
                                var tempErr = vm.importErrorString.trim();
                                vm.newArray += "\n" + tempArr + "," + tempErr;


                            }

                        }
                    }
                }
                if (vm.importErrorString != "") {
                    downloadCSV({ filename: "order-import.csv", input: vm.newArray });
                }

                angular.element("input[type='file']").val(null);
                vm.content = null;

            }
            else {
                angular.element("input[type='file']").val(null);

            }
        })


        function downloadCSV(args) {

            var data, filename, link;

            if (args.input == vm.newArray) {
                var csv = args.input;
            } else {

                var csv = convertArrayOfObjectsToCSV({
                    data: args.input
                });
            }


            if (csv == null)
                return;

            filename = args.filename || 'export.csv';

            var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, filename)
            }
            else {
                var link = document.createElement("a");
                if (link.download !== undefined) {


                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style = "visibility:hidden";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }

        }


        function validateTradingBankRelationship(bankMemberNumber, branchCode, customerCode) {

            angular.forEach(vm.allTradingBanks, function (value) {
                if (value.bank.bankMemberNo == bankMemberNumber && value.tradingBranch.branchId == branchCode && value.customer.customerCode == customerCode) {
                    vm.orderImport.branchId = value.tradingBranch.id;
                    vm.orderImport.branchName = value.tradingBranch.branchName;
                    vm.orderImport.branchCode = value.tradingBranch.branchId;
                    vm.orderImport.customerId = value.customer.id;
                    vm.orderImport.customerName = value.customer.customerFirstName;
                    vm.orderImport.customerCode = value.customer.customerCode;
                    vm.orderImport.bankName = value.bank.bankName;
                    vm.orderImport.bankId = value.bank.id;
                    vm.orderImport.bankMemberNumber = value.bank.bankMemberNo;
                    vm.bankForTrading = value.bank;
                }

            });
            if (vm.bankForTrading == null || vm.bankForTrading == undefined || vm.bankForTrading == "") {
                vm.importErrorString = vm.importErrorString = "There is no trading relationship for the customer with the bank or branch."
            }
        }

        function fillUploadDTO(buySellFlag, activityIndicator, typeOfOrder, instrumentCode, orderAmount, limitExRate, stopExRate, oldOrderAmount) {

            var selectedBankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, vm.bankForTrading.id);
            if (validateOrderUpload(buySellFlag, typeOfOrder, selectedBankSpread, instrumentCode, orderAmount, limitExRate, stopExRate, activityIndicator, oldOrderAmount)) {


                vm.orderImport.dqAmount = vm.orderRequestDTO[4];
                vm.orderImport.mfAmount = vm.orderRequestDTO[5];

                vm.orderImport.timeLimitIndicator = vm.orderRequestDTO[9];
                if (vm.orderImport.timeLimitIndicator == "GTTM") {
                    vm.orderImport.expiryTime = vm.orderRequestDTO[10];
                }

                if (vm.orderImport.activityIndicator != "PLAC") {
                    vm.orderImport.revisionTimeStamp = vm.orderRequestDTO[11];
                }

                vm.orderImport.userId = vm.orderRequestDTO[16];
                vm.orderImport.retailUserCode = vm.orderRequestDTO[17];
                vm.orderImport.userEntityOwnerId = vm.orderRequestDTO[18];

                /*    	vm.orderImport.remarks1 = vm.remarks1;
                       vm.orderImport.remarks2=  vm.remarks2;
                       vm.orderImport.remarks3= vm.remarks3;
                       vm.orderImport.remarks4= vm.remarks4; */
                vm.orderImport.spreadUsed = getSpreadUsed(selectedBankSpread, buySellFlag, instrumentCode);
                if (vm.orderImport.typeOfOrder == "MRKT" && vm.orderImport.activityIndicator == "MDFY") {
                    vm.orderImport.typeOfOrder = "LIMT";
                }


                if (activityIndicator == 'PLAC') {
                    placeOrderRequest(vm.orderImport)
                } else if (activityIndicator == 'MDFY') {
                    Market.modifyOrder(vm.orderImport, onOrderSuccess, onOrderFailure);
                } else if (activityIndicator == 'CNCL') {
                    Market.cancelOrder(vm.orderImport, onOrderSuccess, onOrderFailure);
                }

            } else {
                vm.importErrorString = vm.importErrorString + vm.errorString;
            }
        }


        function validateOrderUpload(buySellFlag, priceCondtion, selectedBankSpread, instrumentCode, orderAmount, limitExRate, stopExRate, activityIndicator, oldOrderAmount) {

            vm.configSettings = vm.globalValues.getConfigSettings();
            vm.transactionParametersSettings = vm.globalValues.getTransactionParametersSettings();
            if (vm.defaultInstrumentCode == 'CASH') {
                if (buySellFlag == 'SELL' || buySellFlag == 'MODIFYSELL') {
                    limitExRateInSpot = getSpotRateForGivenRateAndSpread(limitExRate, selectedBankSpread.cashSpotOfferSpread);

                } else if (buySellFlag == 'BUYY' || buySellFlag == 'MODIFYBUY') {
                    limitExRateInSpot = getSpotRateForGivenRateAndSpread(limitExRate, selectedBankSpread.cashSpotBidSpread);
                }
            } else if (vm.defaultInstrumentCode == 'TOM') {
                if (buySellFlag == 'SELL' || buySellFlag == 'MODIFYSELL') {
                    limitExRateInSpot = getSpotRateForGivenRateAndSpread(limitExRate, selectedBankSpread.tomSpotOfferSpread);
                } else if (buySellFlag == 'BUYY' || buySellFlag == 'MODIFYBUY') {
                    limitExRateInSpot = getSpotRateForGivenRateAndSpread(limitExRate, selectedBankSpread.tomSpotBidSpread);
                }
            } else {
                limitExRateInSpot = limitExRate;
            }

            if (!validateOrderAmount(orderAmount)) {
                return false;
            }

            if (!validateLimitCheck(oldOrderAmount, activityIndicator, orderAmount, instrumentCode, buySellFlag, priceCondtion)) {

                return false;
            }

            // ordertickSize
            // ltp
            var ordertickSize = gettickSizeForGivenInstrument(instrumentCode);
            var ltp = 0

                if (buySellFlag != 'SELLBUY') {
                    ltp = getLtpValue(vm.currencyPair,vm.defaultInstrumentTokenSequenceNo);
                    console.log(ltp);
                    var userAllowedOrderPriceDeviationFromMarketPriceInPercentage = 0;
                    if ($rootScope.currencyWiseUserPreferenceSettings) {
                        var pref = $rootScope.currencyWiseUserPreferenceSettings[vm.currencyPair.id];
                        if (pref) {
                            userAllowedOrderPriceDeviationFromMarketPriceInPercentage = pref.allowedOrderPriceDeviationFromMarketPriceInPercentage;
                        }
                    }
                    if (!validateLimitExchangeRate(buySellFlag, activityIndicator, priceCondtion, limitExRate, limitExRateInSpot, ordertickSize, ltp, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage, userAllowedOrderPriceDeviationFromMarketPriceInPercentage)) {
                        return false;
                    }
                if (!validateStopExchangeRate(priceCondtion, buySellFlag, limitExRate, stopExRate, ordertickSize)) {
                    return false;
                }
                if (vm.errorString != '') {
                    return false;
                }
                if (!validateSpreadUsed(selectedBankSpread, instrumentCode, buySellFlag)) {
                    return false;
                }
            } else if (buySellFlag == 'SELLBUY') {
                var ltp = getLtpValue(vm.currencyPair,vm.defaultInstrumentTokenSequenceNo);
                var userAllowedOrderPriceDeviationFromMarketPriceInPercentage = 0;
                if ($rootScope.currencyWiseUserPreferenceSettings) {
                    var pref = $rootScope.currencyWiseUserPreferenceSettings[vm.currencyPair.id];
                    if (pref) {
                        userAllowedOrderPriceDeviationFromMarketPriceInPercentage = pref.allowedOrderPriceDeviationFromMarketPriceInPercentage;
                    }
                }
                if (!validateLimitExchangeRate('BUYY', activityIndicator, priceCondtion, limitExRate, limitExRateInSpot, ordertickSize, ltp, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage, userAllowedOrderPriceDeviationFromMarketPriceInPercentage)) {
                    return false;
                }
                if (!validateLimitExchangeRate('SELL', activityIndicator, priceCondtion, limitExRate, limitExRateInSpot, ordertickSize, ltp, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage, userAllowedOrderPriceDeviationFromMarketPriceInPercentage)) {
                    return false;
                }
                if (!validateStopExchangeRate(priceCondtion, 'BUYY', limitExRate, stopExRate, ordertickSize)) {
                    // return false;
                }
                if (!validateStopExchangeRate(priceCondtion, 'SELL', limitExRate, stopExRate, ordertickSize)) {
                    return false;
                }
                if (vm.errorString != '') {
                    return false;
                }
                if (!validateSpreadUsed(selectedBankSpread, instrumentCode, 'BUYY')) {
                    return false;
                }
                if (!validateSpreadUsed(selectedBankSpread, instrumentCode, 'SELL')) {
                    return false;
                }
            }

            return true;
        }

        function downloadData() {

            if (vm.orderArr != null || vm.orderArr != undefined || vm.orderArr.length == 0) {
                downloadCSV({ filename: "order_activity" + vm.formattedDate + ".csv", input: vm.orderArr });

                vm.orderArr = [];
            }

            if (vm.pendingArr != null || vm.pendingArr != undefined || vm.pendingArr.length == 0) {
                downloadCSV({ filename: "pending_orders" + vm.formattedDate + ".csv", input: vm.pendingArr });
                vm.pendingArr = [];
            }
            if (vm.tradeArr != null || vm.tradeArr != undefined || vm.tradeArr.length == 0) {
                downloadCSV({ filename: "trades" + vm.formattedDate + ".csv", input: vm.tradeArr });
                vm.tradeArr = [];
            }
            if (vm.limitArr != null || vm.limitArr != undefined || vm.limitArr.length == 0) {
                downloadCSV({ filename: "limits" + vm.formattedDate + ".csv", input: vm.limitArr });
                vm.limitArr = [];
            }


        }


        /* trading home page */
        // initializing
        $rootScope.tickerPrice = {};
        $rootScope.tickerPrice.retailSpot = 0;
        $rootScope.tickerPrice.ibSpot = 0;
        $rootScope.tickerPrice.retailSpotDifference = 0;
        $rootScope.tickerPrice.ibSpotDifference = 0;
        $rootScope.tickerPrice.lttIbSpot = '';
        $rootScope.tickerPrice.lttSpot = '';
        vm.orderType = 'BUYY';
        vm.selectedInstrument = 'SPOT';
        $rootScope.retailSpotMarketWatch = {};


        vm.orderDTO = {};
        vm.remarksDTO = {};
        vm.orderFromMarketWatch = false;
        vm.orderDTOList = [];
        //$rootScope.retailSpotMarketWatch.bidPrice = 72.000;
        vm.getPendingOrdersReport = getPendingOrdersReport;
        vm.getLimitUtilisedReport = getLimitUtilisedReport;
        vm.getTradesReport = getTradesReport;
        vm.getPendingOrders = getPendingOrders;
        vm.getTrades = getTrades;
        vm.getLimitsAvailable = getLimitsAvailable;
        vm.changeInstrument = changeInstrument;
        vm.changeCurrencyPair = changeCurrencyPair;
        vm.changeDefaultPriceCondition = changeDefaultPriceCondition;
        vm.modifyOrder = modifyOrder;
        vm.cancelTrade = cancelTrade;
        vm.rolloverTrade = rolloverTrade;
        vm.earlyDeliveryTrade = earlyDeliveryTrade;
        vm.placeOrder = placeOrder;
        vm.placeOrderForRollover = placeOrderForRollover;
        vm.placeMarketOrder = placeMarketOrder;
        vm.cancelOrder = cancelOrder;
        vm.cancelModifyOrderAction = cancelModifyOrderAction;
        vm.cancelPendingOrdersSelected = cancelPendingOrdersSelected;
        vm.cancelAllOrders = cancelAllOrders;
        vm.cancelOutStandingTrade = cancelOutStandingTrade;
        vm.showPriceIcon = true;
        vm.generateInvoice = generateInvocie;
        vm.asyncGenerateInvoice = asyncGenerateInvoice;
        $rootScope.invoiceGenerated = false;
        $rootScope.asyncInvoiceGenerated = false;

        vm.addRemarks = addRemarks;
        vm.expandMarketDepth = expandMarketDepth;
        vm.expandMarketDepthForBothInstrument = expandMarketDepthForBothInstrument;
        vm.openMarketStatistics = openMarketStatistics;
        vm.expandReports = expandReports;
        vm.expandFCYMarketDepth = expandFCYMarketDepth;
        vm.expandSwapQuote = expandSwapQuote;
        vm.orderDTO.activityIndicator = 'PLAC';
        vm.openOrderPreference = openOrderPreference;
        vm.limitChangeRequest = limitChangeRequest;
        vm.changeRequest = changeRequest;
        vm.newLimitRequest = newLimitRequest;
        vm.getBuyingPower = getBuyingPower;
        vm.getSellingPower = getSellingPower;
        vm.onChangingBankInSwapQuotes = onChangingBankInSwapQuotes;
        vm.onChangingBankInMarkup = onChangingBankInMarkup;
        vm.softCheckDeviationForLimitExchangeRate = softCheckDeviationForLimitExchangeRate;
        vm.softCheckDeviationForBuyLimitExchangeRate = softCheckDeviationForBuyLimitExchangeRate;
        vm.softCheckDeviationForSellLimitExchangeRate = softCheckDeviationForSellLimitExchangeRate;
        vm.printDealTicket = printDealTicket;
        vm.printDealTicketOutstandingTrade = printDealTicketOutstandingTrade;
        vm.pendingArr = [];
        vm.tradeArr = [];
        vm.limitArr = [];
        vm.orderArr = [];
        vm.pinBoard = pinBoard;
        vm.editSwapQuotes = editSwapQuotes;
        vm.limitPriceArray = [];
        vm.sellLimitPriceArray = [];
        vm.buyLimitPriceArray = [];
        vm.removeOrderEntryFocus = removeOrderEntryFocus;
        vm.setOrderEntryFocus = setOrderEntryFocus;
        $rootScope.broadcastServerDown = false;

        // initialiize limits
        $rootScope.retailSpotBuyLimit = 0;
        $rootScope.retailSpotSellLimit = 0;
        $rootScope.cashBuyLimit = 0;
        $rootScope.cashSellLimit = 0;
        $rootScope.tomBuyLimit = 0;
        $rootScope.tomSellLimit = 0;
        $rootScope.toggle = true;

        // initialize tick price
        $rootScope.tickSize = {};

        // initialize holiday list
        $rootScope.holidayListAfterBusinessDate = {};

        function onGetInstrumentSuccess(result) {
            vm.instrumentTypes = result;
            $rootScope.instrumentTypes = result;
            // get tick size for each instrument
            $rootScope.tickSize = {
                usd: {},
                other: {}
            };

            angular.forEach(vm.instrumentTypes, function (value) {

                if (value.baseCurrency === 'USD') {

                    // USD → single object
                    switch (value.instrumentCode) {
                        case 'SPOT':
                            $rootScope.tickSize.usd.spot = value.tickSize;
                            var spotNextDate = new Date(value.settlementDate);
                            spotNextDate.setDate(spotNextDate.getDate()+1);
                            vm.spotNextDate = spotNextDate;
                            $rootScope.spotNextDate =  vm.spotNextDate;
                            vm.maxFromSettlementDate = moment(spotNextDate).add(1, 'days');
                            break;
                        case 'CASH':
                            vm.holidayListAfterBusinessDate = HolidayReport.getHolidayListAfterGivenDate({'givenDate': value.settlementDate});
                            $rootScope.holidayListAfterBusinessDate = vm.holidayListAfterBusinessDate;
                            $rootScope.tickSize.usd.cash = value.tickSize;
                            break;
                        case 'TOM':
                            $rootScope.tickSize.usd.tom = value.tickSize;
                            break;
                        case 'InterbankSPOT':
                            $rootScope.tickSize.usd.ibSpot = value.tickSize;
                            break;
                        case 'Forward':
                            $rootScope.tickSize.usd.forward = value.tickSize;
                            break;
                    }

                } else {
                    // OTHER currencies → keyed by tokenSequenceNumber
                    var token = value.tokenSequenceNumber;
                    if (!token) return;

                    if (!$rootScope.tickSize.other[token]) {
                        $rootScope.tickSize.other[token] = {
                            currency: value.baseCurrency,
                            spot: 0,
                            cash: 0,
                            tom: 0
                        };
                    }

                    switch (value.instrumentCode) {
                        case 'SPOT':
                            $rootScope.tickSize.other[token].spot = value.tickSize;
                            break;
                        case 'CASH':
                            $rootScope.tickSize.other[token].cash = value.tickSize;
                            break;
                        case 'TOM':
                            $rootScope.tickSize.other[token].tom = value.tickSize;
                            break;
                    }
                }
            });
        }

        function onGetInstrumentFailure() {

        }

        function onGetTenorSuccess(result) {
            vm.tenors = result;
            $rootScope.tenors = result;
            // vm.tenor = result[0];
            // $timeout(function() {
            //     vm.tradeSettlementDate = new Date(vm.tenor.settlementDate);
            // }, 100);
            if (vm.tenors != null && vm.tenors != undefined && vm.tenors.length > 0) {
                vm.maxTenorDate = new Date(vm.tenors[vm.tenors.length - 1].settlementDate);
                $rootScope.maxTenorDate = vm.maxTenorDate;
            }
        }

        function onGetTenorFailure() {

        }

        function onGetTenorLookupSuccess(result) {
            vm.tenorsLookup = result;
            vm.tenorsLookupWithoutOption = _.filter(angular.copy(result), function (s) { return s.id != -1; });
            vm.tenor = result[0];
            $timeout(function () {
                vm.tradeSettlementDate = new Date(vm.tenor.settlementDate);
            }, 100);
            $rootScope.tenor = vm.tenor;
        }

        function onGetTenorLookupFailure() {

        }

        function onGetAllExposureLookupSuccess(result) {
            vm.allExposureLookup = result;
        }

        function onGetAllExposureLookupFailure() {

        }

        function onGetEnabledExposureLookupSuccess(result) {
            vm.enabledExposureLookup = result;
        }

        function onGetEnabledExposureLookupFailure() {

        }

        function onGetAllSubExposureLookupSuccess(result) {
            vm.allSubExposureLookup = result;
        }

        function onGetAllSubExposureLookupFailure() {

        }

        function onGetEnabledSubExposureLookupSuccess(result) {
            vm.enabledSubExposureLookup = result;
        }

        function onGetEnabledSubExposureLookupFailure() {

        }

        $rootScope.getMarketWatchEntries = function () {
            return Object.entries($rootScope.marketWatchMap);
        };


        function setExposureTypeFromAllExposureLookup(exposureType) {
            if (exposureType == null || exposureType == undefined || exposureType == '') {
                exposureType = vm.userPreference.userExposureType;
            }
            angular.forEach(vm.allExposureLookup, function (value) {
                if (value.name == exposureType) {
                    vm.exposureType = value;
                }
            })
        }

        function setExposureSubTypeFromAllSubExposureLookup(exposureSubType) {
            if (exposureSubType == null || exposureSubType == undefined || exposureSubType == '') {
                exposureSubType = vm.userPreference.userExposureSubType;
            }
            angular.forEach(vm.allSubExposureLookup, function (value) {
                if (value.name == exposureSubType) {
                    vm.exposureSubType = value;
                }
            })
        }

        function setExposureTypeFromEnabledExposureLookup(exposureType) {
            if (exposureType == null || exposureType == undefined || exposureType == '') {
                exposureType = vm.userPreference.userExposureType;
            }
            angular.forEach(vm.enabledExposureLookup, function (value) {
                if (value.name == exposureType) {
                    vm.exposureType = value;
                }
            })
            if (vm.exposureType != null && (vm.exposureType.id == null || vm.exposureType.id == undefined)) {
                vm.exposureType = null;
            }
        }

        function setExposureSubTypeFromEnabledSubExposureLookup(exposureSubType) {
            if (exposureSubType == null || exposureSubType == undefined || exposureSubType == '') {
                exposureSubType = vm.userPreference.userExposureSubType;
            }
            angular.forEach(vm.enabledSubExposureLookup, function (value) {
                if (value.name == exposureSubType) {
                    vm.exposureSubType = value;
                }
            })
            if (vm.exposureSubType != null && (vm.exposureSubType.id == null || vm.exposureSubType.id == undefined)) {
                vm.exposureSubType = null;
            }
        }

        function editSwapQuotes() {
            workflowSharedService.viewFrom = "swapQuotes";
            $state.go('swap-quotes-change', { businessDate: vm.globalValues.getSystemSettings().businessDate });
        }

        $scope.$watch('vm.defaultTradingCustomerControl', function (value) {
            if (vm.account != null && vm.account != undefined && vm.account.organisation.organisationType.shortName == 'BANK') {
                vm.defaultTradingCustomer = value;
                pinBoard();
            }
        })




        vm.getMarkupReport = function getMarkupReport(currencyPairCode) {
            if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                Markup.getAllMarkupForCustomerAndCurrencyPair({ customerId: vm.account.organisation.id, currencyPairCode: currencyPairCode, }, onGetMarkupSuccess, onGetMarkupFailure);
            }
        }

        function onGetMarkupSuccess(result) {
            if (result.length > 0) {
                $rootScope.markupSettings = result;
            }
        }
        function onGetMarkupFailure() {

        }



        // pinboard
        function pinBoard() {
            if (vm.account != null && vm.account != undefined) {
                if (vm.account.entityOwnerType.shortName == 'Bank') {
                    if (vm.defaultTradingCustomerControl != null && vm.defaultTradingCustomerControl != undefined) {
                        CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({ bankId: vm.globalValues.getOrganisation().id, customerId: vm.defaultTradingCustomerControl.id }, function (result) {
                            vm.tradingBranch = result;
                            vm.defaultTradingBranch = result;

                            // fill default values
                            fillDefaultValuesToControlsForPinBoard();
                            // get swap quotes for the logged in bank
                            getSwapQuotes();
                            // get pending orders, trades, limits reports
                            $timeout(function () {
                                getReportsToDisplay();
                            }, 100);
                        })
                    } else {
                        vm.defaultTradingCustomer = null;
                        vm.defaultTradingBranch = null;

                        // fill default values
                        fillDefaultValuesToControlsForPinBoard();
                        // get swap quotes for the logged in bank
                        getSwapQuotes();
                        // get pending orders, trades, limits reports
                        $timeout(function () {
                            getReportsToDisplay();
                        }, 100);
                    }
                } else {
                    // fill default values
                    fillDefaultValuesToControlsForPinBoard();
                    // get swap quotes for the logged in bank
                    getSwapQuotes();
                    // get pending orders, trades, limits reports
                    $timeout(function () {
                        getReportsToDisplay();
                    }, 100);
                }
            }
        }

        function fillDefaultValuesToControlsForPinBoard() {
            vm.defaultTradingBank = vm.globalValues.getBank();
            vm.tradingBank = vm.defaultTradingBank;
            $rootScope.defaultTradingBank = vm.globalValues.getBank();

            //vm.defaultTradingCustomer = vm.defaultTradingCustomerControl;
            if (vm.account.entityOwnerType.shortName == 'Bank' && vm.userPreference) {
                fillDefaultValuesToReportFilters(vm.defaultTradingBank, vm.defaultTradingBranch, vm.defaultTradingCustomer, vm.userPreference.currencyPair);
            } else if (vm.account.entityOwnerType.shortName == 'Branch' && vm.userPreference) {
                fillDefaultValuesToReportFilters(vm.defaultTradingBank, vm.globalValues.getBranch(), vm.defaultTradingCustomer, vm.userPreference.currencyPair);
            }
        }

        // bootup home page
        function bootUp() {

            if (vm.account != null) {
                getConfigForGenerate();
                // get user specific settings for the logged in user
                // we can get default trading bank, branch and customer for the
                // logged in user from the user preference data.
                // fill the filters of branch and customer with the default
                // trading branch and customer we get it from user preference.
                vm.configSettings = vm.globalValues.getConfigSettings();
                vm.transactionParametersSettings = vm.globalValues.getTransactionParametersSettings();

                /*
                 * StaticLookUp.getConfigSettings(function(result){
                 * vm.configSettings = result; })
                 */

                // if(vm.configSettings.allowOrderImport=='Yes'){
                //     vm.allTradingBanks=CustomerBankRelationshipReport.query();
                // }

                UserProfile.get({ userId: vm.account.id }, onGetUserSpecSettingSuccess, onGetUserSpecSettingFailure)
                // get currency pair and make USDINR default.
                //CurrencyPair.query(onGetCurrencyPairSuccess, onGetCurrencyPairFailure);

                Market.getDailyClosingPrice(onGetLtpForLimitSuccess, onGetLtpForLimitFailure);

                getStaticDataFromDb();

                vm.noOfRecordsPerPage = 5;
                vm.page = 1;
                vm.noOfRecordsPerPageOP = 5;
                vm.pageOP = 1;
                vm.noOfRecordsPerPageOT = 5;
                vm.pageOT = 1;
                vm.noOfRecordsPerPageTrade = 5;
                vm.pageTrade = 1;
                vm.noOfRecordsPerPageLimit = 5;
                vm.pageLimit = 1;
                $scope.swapPage = 1;

                $rootScope.dashboardEntity = { shortName: entityConstants.ENTITY_SHORT_NAME.TRADEORDERMANAGEMENTDASHBOARD };
                $rootScope.termsAndConditionsUploadEntity = { shortName: entityConstants.ENTITY_SHORT_NAME.TRADEORDERMANAGEMENTDASHBOARD };

                setSwapQuotesView();

            }
        }

        function setSwapQuotesView() {
            if (vm.account.organisation.organisationType.shortName != 'BANK') {
                vm.defaultTab = 'comparitive_tab1';
            } else {
                vm.defaultTab = 'comparitive_tab3';
            }
            vm.reportTab = 'PendingOrders';
            vm.showExpandIcon = true;
            vm.bootupCompleted = true;
        }

        $scope.$watch('vm.defaultTab', function (value) {
            $rootScope.defaultTab = value;
            if (value == 'comparitive_tab2' || value == 'comparitive_tab4') {
                // prepare bank comparativeQuotes in price
                if ($rootScope.bankComparativeDTO != null && $rootScope.bankComparativeDTO != undefined
                    && $rootScope.retailSpotMarketWatch != null && $rootScope.retailSpotMarketWatch != undefined) {
                    prepareBankComparativeQuotesInPrice($rootScope.bankComparativeDTO, $rootScope.retailSpotMarketWatch);
                }
            }
        })

        function onGetUserSpecSettingSuccess(result) {
            vm.userPreference = result;
            $rootScope.userPreference = result;


            CurrencyPair.query(onGetCurrencyPairSuccess, onGetCurrencyPairFailure);


        }

        function onInitialBankCurrencySuccess(result){


           initialiseCurrencyPairInstruments(result);


                 // fill default values
       //   getUserPreferenceAndFillDefaultControls();
           initialiseMarketWatchMap(result);

            // vm.currentDate = new Date();
            IntradayMarket.getCurrentBusinessDate(function (result) {
                vm.currentDate = result.businessDate;
                vm.currentDate = DateUtils.convertLocalDateToServer(vm.currentDate);
                vm.fromSettlementDate = DateUtils.convertLocalDateFromServer(vm.currentDate);
                var year = vm.fromSettlementDate.getFullYear();
                var month = vm.fromSettlementDate.getMonth();
                vm.toSettlementDate = new Date(year, month + 2, 0);
                // get market session settings. to display status. market
                // session settings will be available for SPOT, cash TOM
                IntradayMarket.getMarketSessionSettings({ "currentBusinessDate": vm.currentDate }, onGetMarketSessionSuccess, onGetMarketSessionFailure);

                if (vm.account.organisation.organisationType.shortName != 'CLEARCORP') {
                    // $timeout(function(){
                    //     getReportsToDisplay();
                    // }, 100);
                }
            })

        }

        function onBankCurrencyFailure(){

        }


        function initialiseMarketWatchMap(result) {
    //$rootScope.bankWiseCurrencyPair = result;
    for (var i = 0; i < result.length; i++) {
        var value = result[i];
        var currencyPair = value.currencyPair;
        if (!currencyPair || currencyPair.code === 'USDINR') continue;

        var currencyId   = currencyPair.id;
        var instrumentCode = value.instrumentCode ? value.instrumentCode.toUpperCase() : null;
        if (!currencyId || !instrumentCode) continue;

        var obj = $rootScope.marketWatchMap[currencyId] || {
            baseCurrency: value.baseCurrency,
            instruments: [null, null, null]
        };

        var marketWatch = { instrumentCode: instrumentCode, tokenSequenceNo: value.tokenSequenceNumber };
        var slot = instrumentCode === 'SPOT' ? 0 : instrumentCode === 'TOM' ? 1 : instrumentCode === 'CASH' ? 2 : -1;
        if (slot >= 0) {
            obj.instruments[slot] = marketWatch;
            $rootScope.marketWatchMap[currencyId] =  obj;
        }
    }
}


        function initialiseCurrencyPairInstruments(result){
            $rootScope.bankWiseCurrencyPair = result;

       if (vm.defaultInstrumentCode && vm.currencyPair) {

    var defaultInstrument = result.find(function(item) {
        return item.currencyPair
            && item.currencyPair.id === vm.currencyPair.id
            && item.instrumentCode
            && item.instrumentCode.toUpperCase() === vm.defaultInstrumentCode.toUpperCase();
    });

    if (defaultInstrument) {
        console.log("token ",defaultInstrument);
        vm.defaultInstrumentTokenSequenceNo = defaultInstrument.tokenSequenceNumber;
        vm.defaultInstrumentId = defaultInstrument.id;
    }

    console.log("instrument", vm.defaultInstrumentCode);
}

        console.log("result size",result.length);
         //   angular.forEach(result,function(value){
                for(var i=0;i<result.length;i++){
                   var value = result[i];
                if(value!=null){
                var currencyPair = vm.currencyPairInstrumentDetails[value.currencyPair.id];

    if (!currencyPair) {
        currencyPair = {
            id: value.currencyPair.id,
            instruments: [null, null, null] // SPOT, TOM, CASH
        };
    }

    var currencyData = {};
    currencyData.instrumentCode = value.instrumentCode;
    currencyData.instrumentId = value.id;

    if(value.currencyPair.code!=='USDINR'){
    currencyData.tokenSequenceNo = value.tokenSequenceNumber;
    }

    switch (value.instrumentCode.toUpperCase()) {
        case "SPOT":
            currencyPair.instruments[0] = currencyData;
            break;
        case "TOM":
            currencyPair.instruments[1] = currencyData;
            break;
        case "CASH":
            currencyPair.instruments[2] = currencyData;
            break;
        default:
            console.warn("Unknown instrumentCode:", value.instrumentCode);
    }

    vm.currencyPairInstrumentDetails[value.currencyPair.id] = currencyPair;

     $rootScope.currencyPairInstrumentDetails[value.currencyPair.id] = currencyPair;

                }
            }}


        function setIntradayMarketSessionDetails() {

            IntradayMarket.getCurrentBusinessDate(function (result) {
                vm.currentDate = result.businessDate;
                vm.currentDate = DateUtils.convertLocalDateToServer(vm.currentDate);
                vm.fromSettlementDate = DateUtils.convertLocalDateFromServer(vm.currentDate);
                var year = vm.fromSettlementDate.getFullYear();
                var month = vm.fromSettlementDate.getMonth();
                vm.toSettlementDate = new Date(year, month + 1, 0);
                // get market session settings. to display status. market
                // session settings will be available for SPOT, cash TOM
                IntradayMarket.getMarketSessionSettings({ "currentBusinessDate": vm.currentDate }, function (result) {
                    $rootScope.marketSessionSettings = result;
                    // store session settings in separate variables for each and every
                    // instrument
                    setMarketSettings();
                }, onGetMarketSessionFailure);

            });
        }

        function onGetUserSpecSettingFailure() {

        }

        function onGetCurrencyPairSuccess(result) {
            $rootScope.currencyPairList = result;

    //            const currencyPair = angular.copy(
    //              $rootScope.enableOtherCurrencyTab
    //             ? $rootScope.currencyPairList[2]
    //             : $rootScope.currencyPairList[0]
    //    );

             vm.currencyPair = $rootScope.currencyPairList[0];

             console.log("value ",$rootScope.enableOtherCurrencyTab);



             CustomerBankRelationshipReport.getApplicableInstruments(onGetInstrumentSuccessForBootup, onGetInstrumentFailure);

            //DefaultMarket.csInstruments({currencyPairId:currencyPair.id},onGetInstrumentSuccessForBootup, onGetInstrumentFailure);


        }

         function onGetInstrumentSuccessForBootup(result) {

            onGetInstrumentSuccess(result);

            getUserPreferenceAndFillDefaultControls();

            console.log("instrument", $rootScope.tickSize);

             var bankId = vm.tradingBank && vm.tradingBank.id ? vm.tradingBank.id : 0;

StaticLookUp.getCurrencyPairInstruments(
  { bankId: bankId },
  onInitialBankCurrencySuccess,
  onBankCurrencyFailure
);

         }

        function onGetCurrencyPairFailure() {

        }

    //      $scope.$watch('vm.currencyPair', function (value) {
    //          if (value != undefined) {
    //             $rootScope.currencyPair = value;
    //             vm.currencyPairCode = value.code;
    //             vm.currencyPairId = value.id;
    //             vm.orderDTO.currencyPairId = vm.currencyPairId;

    //             var currencyPair = vm.currencyPairInstrumentDetails.get(value.id);
    // var index = getIndexBasedOnInstrument(vm.defaultInstrumentCode);

    // var seqNo = vm.defaultInstrumentTokenSequenceNo;

    // if (currencyPair && currencyPair.instruments && currencyPair.instruments[index]) {
    //   vm.defaultInstrumentId = currencyPair.instruments[index].instrumentID;

    //  seqNo = currencyPair.instruments[index].tokenSequenceNo;
    // }if(currencyPair == 'JPYINR'){
    //  validateJPYCurerency();
    // }

    // var status = vm.getInstrumentStatus(seqNo);

    // if (status === 'CLOSED' || status === 'HOLIDAY' || status === 'UNAVAILABLE') {
    //   console.warn('Instrument change blocked due to status:', status);
    //   vm.defaultInstrumentCode = undefined;
    // }

    // if(vm.defaultInstrumentCode!=null){
    //             //   vm.orderDTO.currencyPair = vm.currencyPair;
    //             fillDefaultInstIdForInstCode(vm.defaultInstrumentCode);
    // }
    //         }

    //     })


        function onGetLtpForLimitSuccess(result) {
            vm.ltpForLimitsForAllInstrument = result;
            angular.forEach(vm.ltpForLimitsForAllInstrument, function (value) {
                if (value.instrument.id == 3) {
                    $rootScope.previousDayClosingPriceForSpot = value.fxRate;
                } else if (value.instrument.id == 4) {
                    $rootScope.previousDayClosingPriceForIbSpot = value.fxRate;
                }else{

                    if(value.instrument.tokenSequenceNumber!=null){
                    var ticker = $rootScope.tickerPriceFCY[value.instrument.tokenSequenceNumber];


                    if(ticker==undefined || ticker == null){
                        var obj = {};
                        obj.previouseDayClosingPrice = value.fxRate;
                        $rootScope.tickerPriceFCY[value.instrument.tokenSequenceNumber] = obj;
                        $rootScope.dailyClosingPriceFCY[value.instrument.tokenSequenceNumber] = obj;

                    }
                    else{
                        ticker.previouseDayClosingPrice = value.fxRate;
                        $rootScope.tickerPriceFCY[value.instrument.tokenSequenceNumber] = ticker;
                        $rootScope.dailyClosingPriceFCY[value.instrument.tokenSequenceNumber]  = ticker;
                    }
                }
                }


            })
            if (vm.isFromIndex) {
                Market.getMarketDepth(onGetMarketDepthSuccess, onGetMarketDepthFailure);
            }
        }

        function onGetLtpForLimitFailure() {

        }

    function validateJPYCurerency(){
         if (vm.orderDTO.orderAmount % vm.configJPYCurrency != 0) {
                    vm.clicked = true;
                    $scope.errorTextOrderAmount = "The Order quantity should be multiple of JPY quotation "+ vm.configJPYCurrency;
        }else{
                    vm.clicked = false;
                    $scope.errorTextOrderAmount = "";
        }
    }

        function getStaticDataFromDb() {

            // get order status list from db and stored in array for displaying
            // the order status in pending order.
            OrderStatusDetails.getOrderStatusList(onGetOrderStatusListSuccess, onGetOrderStatusListFailure);

            if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                vm.custCode = vm.globalValues.getCustomer().customerCode;
            }

            vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
            vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
            vm.noOfDecimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();

            if (vm.account.organisation.organisationType.shortName == 'BANK') {
                vm.showLA = false;
            } else {
                vm.showLA = true;
            }

            // if(vm.globalValues.getConfigSettings().negligibleExceptionNumbers!=undefined && vm.globalValues.getConfigSettings().negligibleExceptionNumbers!=''){
            //     $rootScope.negligibleExceptionNumberList = vm.globalValues.getConfigSettings().negligibleExceptionNumbers.split(',');
            // }

            // get server status
            ServerComponentStatus.getServerComponentStatus(onGetServerStatusSuccess, onGetServerStatusFailure);

            $rootScope.errorMessageList = ErrorMessages.query();

            //get event types and stored in public variable
            $rootScope.eventTypes = StaticLookUp.getEventTypeList();

            //get source App
            $rootScope.sourceApp = StaticLookUp.getSourceAppList();

            //get trade status list and stored in public variable that will be used in report online update
            $rootScope.tradeStatusList = StaticLookUp.getTradeStatusList();

        }

        function onGetOrderStatusListSuccess(result) {
            $rootScope.orderStatusList = result;
        }

        function onGetOrderStatusListFailure() {

        }

        function onGetServerStatusSuccess(result) {
            if (result != null && result != undefined) {
                angular.forEach(result, function (value) {
                    if (value.processCode == 'PNS') {
                        if (value.isActive == true) {
                            $rootScope.broadcastServerDown = false;
                        } else {
                            $rootScope.broadcastServerDown = true;
                        }
                    } else if (value.processCode == 'OPS') {
                        if (value.isActive == true) {
                            $rootScope.orderServerDown = false;
                        } else {
                            $rootScope.orderServerDown = true;
                        }
                    }
                })
            }
        }

        function onGetServerStatusFailure() {

        }

        function onGetUserMarketWatchSuccess(result) {
            //prepare user market watch list to display
            prepareUserMarketWatchToDisplay(result);

            if ($rootScope.userMarketWatchList != null && $rootScope.userMarketWatchList != undefined && $rootScope.userMarketWatchList.length > 0) {
                if ($rootScope.userMarketWatchList[0] != null && $rootScope.userMarketWatchList[0] != undefined && $rootScope.userMarketWatchList[0].sessionStatus != null && $rootScope.userMarketWatchList[0].sessionStatus == 'OPEN') {
                    prepareOutrightComparision($rootScope.userMarketWatchList[0].settlementDate, $rootScope.userMarketWatchList[0].instrument);
                } else if ($rootScope.userMarketWatchList[1] != null && $rootScope.userMarketWatchList[1] != undefined && $rootScope.userMarketWatchList[1].sessionStatus != null && $rootScope.userMarketWatchList[1].sessionStatus == 'OPEN') {
                    prepareOutrightComparision($rootScope.userMarketWatchList[1].settlementDate, $rootScope.userMarketWatchList[1].instrument);
                }
            }
        }

        function setSelectedCurrecy(currencyPairId,activityIndicator) {
            var selectedCurrency = null;

            var isEnabled = false;

              angular.forEach($rootScope.bankWiseCurrencyPair, function (cp) {
                if (cp.currencyPair.id == currencyPairId) {
                    isEnabled = true;
                }
            });


                  if(!isEnabled){
             MessageBox.openMessageBox("Alert", "The selected currency not enabled by Bank", "Ok", "selectedorders");
             return "";
                  }


            angular.forEach($rootScope.currencyPairList, function (cp) {
                if (cp.id == currencyPairId) {
                    selectedCurrency = cp;
                }
            });


            //vm.currencyPair = angular.copy(selectedCurrency);
            if(selectedCurrency.code=='USDINR' ){
                     $timeout(function () { vm.currencyPairUSD = angular.copy(selectedCurrency);},650);
                      $rootScope.enableOtherCurrencyTab = false;
                       $rootScope.loadBoardCurrency = 'USD';
            }else if(activityIndicator == 'MDFY' ){
                      $timeout(function () {vm.currencyPairUSD = angular.copy(selectedCurrency);},650);
                     if(selectedCurrency.code=='USDINR'){
                         $rootScope.enableOtherCurrencyTab = false;
                         $rootScope.loadBoardCurrency = 'USD';
                     }else{
                         $rootScope.enableOtherCurrencyTab = true;
                         $rootScope.loadBoardCurrency = 'OTHER';
                     }

            } else{
                     $timeout(function () {vm.currencyPairFCY = angular.copy(selectedCurrency);},650);
                    $rootScope.enableOtherCurrencyTab = true;
                    $rootScope.loadBoardCurrency = 'OTHER';
            }

            $rootScope.currencyPair = selectedCurrency;
            console.log("selected currency",selectedCurrency);
            vm.currencyPair =  $rootScope.currencyPair;
            console.log(" currency",vm.currencyPair);

            vm.currencyPairId = selectedCurrency ? selectedCurrency.id : null;

             //vm.onCurrencyPairChanged(selectedCurrency);
        }


        //prepare user market watch to display when loading from database
        function prepareUserMarketWatchToDisplay(userMarketWatchListFromDB) {
            $rootScope.userMarketWatchList = [];

            angular.forEach(userMarketWatchListFromDB, function (value) {
                var userMarketWatch = {};
                userMarketWatch = value;
                userMarketWatch.bidPrice = null;
                userMarketWatch.offerPrice = null;
                userMarketWatch.bidSpread = null;
                userMarketWatch.offerSpread = null;
                userMarketWatch.user = null;
                userMarketWatch = MarketWatch.fillTenorNameAndSettlementDate(userMarketWatch, value, vm.tenors, $rootScope.cashMarketSession, $rootScope.tomMarketSession);
                userMarketWatch.sessionStatus = getSessionStatusForInstrument(userMarketWatch.instrument);
                var tickSize = gettickSizeForGivenInstrument(userMarketWatch.instrument);
                userMarketWatch = MarketWatch.fillBidOfferSpreadInUserMarketWatch(userMarketWatch, $rootScope.bankComparativeDTO, $rootScope.defaultBankSpread, $rootScope.retailSpotMarketSession.settlementDate, tickSize);
                userMarketWatch = MarketWatch.fillBidOfferPriceInUserMarketWatch(userMarketWatch, $rootScope.retailSpotMarketWatch);
                if (value.tenorSettlementDateDetails != null && value.tenorSettlementDateDetails != undefined) {
                    userMarketWatch.isSettlementHoliday = !(value.tenorSettlementDateDetails.active);
                } else {
                    userMarketWatch.isSettlementHoliday = false;
                }
                $rootScope.userMarketWatchList.push(userMarketWatch);
            })
            //$rootScope.userMarketWatchListMemory = $rootScope.userMarketWatchList;
            console.log('mkt watch list');
            console.log($rootScope.userMarketWatchList);
        }

        //prepare user market watch online
        function prepareUserMarketWatchOnline() {
            angular.forEach($rootScope.userMarketWatchList, function (userMarketWatch) {
                var tickSize = gettickSizeForGivenInstrument(userMarketWatch.instrument);
                userMarketWatch.sessionStatus = getSessionStatusForInstrument(userMarketWatch.instrument);
                userMarketWatch = MarketWatch.fillBidOfferSpreadInUserMarketWatch(userMarketWatch, $rootScope.bankComparativeDTO, $rootScope.defaultBankSpread, $rootScope.retailSpotMarketSession.settlementDate, tickSize);
                userMarketWatch = MarketWatch.fillBidOfferPriceInUserMarketWatch(userMarketWatch, $rootScope.retailSpotMarketWatch);
            })
            //$rootScope.userMarketWatchListMemory = $rootScope.userMarketWatchList;
        }

        function prepareOutrightComparision(settlementDate, instrument) {
            $rootScope.outrightRatesList = [];
            $rootScope.outrightRateSettlementDate = settlementDate;
            $rootScope.outrightRateInstrument = instrument;
            if ($rootScope.bankComparativeDTO != null && $rootScope.bankComparativeDTO != undefined) {
                angular.forEach($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, function (swapQuotesTenorDateDTO) {
                    var outrightRates = {};
                    outrightRates.bank = swapQuotesTenorDateDTO.bank;
                    outrightRates.instrument = instrument;
                    outrightRates.settlementDate = settlementDate;
                    var tickSize = gettickSizeForGivenInstrument(outrightRates.instrument);
                    outrightRates.sessionStatus = getSessionStatusForInstrument(outrightRates.instrument);
                    outrightRates = MarketWatch.fillBidOfferSpreadInUserMarketWatch(outrightRates, $rootScope.bankComparativeDTO, swapQuotesTenorDateDTO.swapQuotesForTenorDatesList, $rootScope.retailSpotMarketSession.settlementDate, tickSize);
                    outrightRates = MarketWatch.fillBidOfferPriceInUserMarketWatch(outrightRates, $rootScope.retailSpotMarketWatch);
                    $rootScope.outrightRatesList.push(outrightRates);
                });
            }
            console.log('outright');
            console.log($rootScope.outrightRatesList);
            $rootScope.outrightRatesList = MarketWatch.sortOutrightRatesList($rootScope.outrightRatesList);
            //$rootScope.outrightRatesListMemory = $rootScope.outrightRatesList;
        }

        function onGetUserMarketWatchFailure() {

        }

        // fill default values to variables and controls with user preference
        function
        getUserPreferenceAndFillDefaultControls() {
            vm.configSettings = vm.globalValues.getConfigSettings();
            vm.transactionParametersSettings = vm.globalValues.getTransactionParametersSettings();
            // filling rootscope variables, so that when feed arives, web socket
            // service can use those variables.
            if (vm.account.organisation.organisationType.shortName != 'CLEARCORP') {
                vm.defaultTradingBank = vm.userPreference.tradingBank;
                $rootScope.defaultTradingBank = vm.userPreference.tradingBank;
                vm.defaultTradingBankControl = vm.userPreference.tradingBank;
                vm.defaultTradingBranch = vm.userPreference.tradingBranch;
                $rootScope.defaultTradingBranch = vm.userPreference.tradingBranch;
               // vm.defaultCurrencyPair = vm.userPreference.currencyPair;

                vm.defaultCurrencyPairData =  vm.userPreference.currencyPair;
                console.log("defalult currency pair",vm.defaultCurrencyPairData);
                $rootScope.defaultCurrencyPair = vm.userPreference.currencyPair;
            } else {
                // $timeout(function(){
                BankRegistration.getBankLookup(onGetBankListSuccess, onGetBankListFailure);
                // }, 100)
            }

            $timeout(function () {
                if (vm.account.organisation.organisationType.shortName != 'CUSTOMER') {
                    vm.defaultTradingCustomer = vm.userPreference.tradingCustomer;
                    $rootScope.defaultTradingCustomer = vm.userPreference.tradingCustomer;
                    if (vm.account.organisation.organisationType.shortName == 'BANK') {
                        vm.defaultTradingCustomerControl = vm.userPreference.tradingCustomer;
                    }
                } else {
                    vm.defaultTradingCustomer = vm.globalValues.getCustomer();
                    $rootScope.defaultTradingCustomer = vm.globalValues.getCustomer();
                }
            }, 100);

            // fill default values to order value, price condition, instrument
            // to the controls.
            if (vm.userPreference.userPriceCondition == 'STLS' && vm.configSettings.isAllowStopLossOrder != 'Yes') {
                vm.userPreference.userPriceCondition = 'LIMT';
            }
            if (vm.userPreference.userPriceCondition == 'TKPR' && vm.configSettings.isAllowTakeProfitOrder != 'Yes') {
                vm.userPreference.userPriceCondition = 'LIMT';
            }
            if (vm.userPreference.userPriceCondition == 'MRKT' && vm.configSettings.isAllowMarketOrder != 'Yes') {
                vm.userPreference.userPriceCondition = 'LIMT';
            }
            fillDefaultValuesToControls();
        }

        function onGetBankListSuccess(result) {
            if (result.length > 0) {
                vm.defaultTradingBank = result[0];
                $rootScope.defaultTradingBank = result[0];
                vm.tradingBank = result[0];

                vm.bankFilterForPO = result[0];
                vm.bankFilterForLimit = result[0];
                vm.bankFilterForTrade = result[0];
                vm.bankFilterForOT = result[0];
                $rootScope.bankFilterForPO = result[0];
                $rootScope.bankFilterForLimit = result[0];
                $rootScope.bankFilterForTrade = result[0];
                $rootScope.bankFilterForOT = result[0];
                //getReportsToDisplay();
            }
        }

        function onGetBankListFailure() {

        }

        // fill default values to controls and variables
        function fillDefaultValuesToControls() {
            // fill order value, price condition, instrument type, order type to
            // controls
            if (vm.userPreference != null && vm.userPreference != undefined) {
                vm.orderVolumeSpotMkt = vm.userPreference.userOrderValue;
                vm.orderVolumeCashMkt = vm.userPreference.userOrderValue;
                vm.orderVolumeTomMkt = vm.userPreference.userOrderValue;
                vm.defaultTimeCondition = vm.userPreference.userTimeCondition;
  vm.defaultInstrumentCode = vm.userPreference.userInstrumentCode;
                vm.updateDefaultInstrumentDetails(vm.userPreference.userInstrumentCode);

             //  vm.currencyPair = vm.userPreference.currencyPair;

                //fillDefaultInstIdForInstCode(vm.defaultInstrumentCode);


                defaultOrderEntry();
                // setSelectedCurrecy(vm.userPreference.currencyPair.id);

                vm.loadBoardInstrumentCode = vm.userPreference.userInstrumentCode;
                $rootScope.loadBoardInstrumentCode = vm.userPreference.userInstrumentCode;
                vm.tradingBank = vm.defaultTradingBank;
                // vm.currencyPairCode = vm.defaultCurrencyPair;
                //vm.selectedInstrument = vm.userPreference.instrument;
                fillInstrumentTypeFiltersForReports();

                //set exposure type and exposure sub type
                setExposureTypeFromEnabledExposureLookup(vm.userPreference.userExposureType);
                setExposureSubTypeFromEnabledSubExposureLookup(vm.userPreference.userExposureSubType);



                if (vm.account.organisation.organisationType.shortName == 'BANK' && vm.account.entityOwnerType.shortName == 'Bank') {
                    fillDefaultValuesToReportFilters(vm.globalValues.getBank(), vm.userPreference.tradingBranch, vm.userPreference.tradingCustomer, vm.userPreference.currencyPair);
                } else if (vm.account.organisation.organisationType.shortName == 'BANK' && vm.account.entityOwnerType.shortName == 'Branch') {
                    fillDefaultValuesToReportFilters(vm.globalValues.getBank(), vm.globalValues.getBranch(), vm.userPreference.tradingCustomer, vm.userPreference.currencyPair);
                } else if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                    fillDefaultValuesToReportFilters(vm.userPreference.tradingBank, vm.userPreference.tradingBranch, vm.globalValues.getCustomer(), vm.userPreference.currencyPair);
                }


                //vm.remarks = "";
                setDefaultRemark();
            }
        }

        vm.fillDefaultInstIdForInstCode = fillDefaultInstIdForInstCode;
        function fillDefaultInstIdForInstCode(instCode) {
            angular.forEach(vm.instrumentTypes, function (value) {
                if (value.instrumentCode == instCode && value.currencyPair.id === vm.currencyPair.id) {
                    vm.defaultInstrumentId = value.id;
                    vm.defaultInstrumentTokenSequenceNo = value.tokenSequenceNumber;
                }
            })
        }

        function getInstIdForInstCode(instCode) {
            var instId = null;
            angular.forEach(vm.instrumentTypes, function (value) {
                if (value.instrumentCode == instCode) {
                    instId = value.id;
                }
            });
            return instId;
        }

        function fillInstrumentTypeFiltersForReports() {
            vm.instrumentFilterForPO = null;
            vm.instrumentFilterForTrade = null;
            vm.instrumentFilterForLimit = null;
            vm.instrumentFilterForOT = null;
            $rootScope.instrumentFilterForPO = null;
            $rootScope.instrumentFilterForTrade = null;
            $rootScope.instrumentFilterForLimit = null;
            $rootScope.instrumentFilterForOT = null;

        }

        function fillDefaultValuesToReportFilters(bank, branch, customer, currencyPair) {
            vm.tradingBank = bank;
            vm.tradingBranch = branch;

            $timeout(function () {
                vm.tradingCustomer = customer;
                vm.customerFilterForPO = customer;
                vm.customerFilterForTrade = customer;
                vm.customerFilterForLimit = customer;
                vm.customerFilterForOT = customer;
                $rootScope.customerFilterForPO = customer;
                $rootScope.customerFilterForOT = customer;
                $rootScope.customerFilterForTrade = customer;
                $rootScope.customerFilterForLimit = customer;
                //vm.defaultTradingCustomerControl = customer;
            }, 100);
            vm.bankFilterForPO = bank;
            vm.branchFilterForPO = branch;
            vm.bankFilterForTrade = bank;
            vm.branchFilterForTrade = branch;
            vm.bankFilterForLimit = bank;
            vm.branchFilterForLimit = branch;
            $rootScope.bankFilterForPO = bank;
            $rootScope.branchFilterForPO = branch;
            $rootScope.bankFilterForTrade = bank;
            $rootScope.branchFilterForTrade = branch;
            $rootScope.bankFilterForLimit = bank;
            $rootScope.branchFilterForLimit = branch;


            vm.bankFilterForOT = bank;
            vm.branchFilterForOT = branch;
            $rootScope.bankFilterForOT = bank;
            $rootScope.branchFilterForOT = branch;

            if($rootScope.enableOtherCurrencyTab){
            vm.currencyPairForPO = currencyPair;
            vm.currencyPairForOT = currencyPair;
            vm.currencyPairForTrade = currencyPair;
            vm.currencyPairForLimit = currencyPair;
            vm.currencyPairForMarkup = currencyPair;

            $rootScope.currencyPair = currencyPair
            $rootScope.currencyPairForPO = currencyPair;
            $rootScope.currencyPairForOT = currencyPair;
            $rootScope.currencyPairForTrade = currencyPair;
            $rootScope.currencyPairForLimit = currencyPair;
            $rootScope.currencyPairForMarkup = currencyPair;
            }else{
            vm.currencyPairForPO = vm.currencyPairUSD;
            vm.currencyPairForOT = vm.currencyPairUSD;
            vm.currencyPairForTrade = vm.currencyPairUSD;
            vm.currencyPairForLimit = vm.currencyPairUSD;
            vm.currencyPairForMarkup = vm.currencyPairUSD;
            }
        }

        // fill default values to order entry screen
        function defaultOrderEntry() {
            if (vm.userPreference != null && vm.userPreference != undefined) {
                console.log("defalut order entry is called");
                vm.orderDTO = {};
                vm.orderDTO.orderAmount = vm.userPreference.userOrderValue;
                vm.orderDTO.timeLimitIndicator = vm.userPreference.userTimeCondition;
                vm.orderDTO.typeOfOrder = vm.userPreference.userPriceCondition;
                vm.orderDTO.instrumentCode = vm.defaultInstrumentCode;
                vm.orderDTO.currencyPairId = vm.currencyPair.id;
                vm.orderDTO.contractCancellation = false;
                vm.showPreOrderConfirmation = vm.userPreference.showPreOrderConfirmation;
                vm.orderDTO.activityIndicator = 'PLAC';
                // vm.orderDTO.currencyPair = vm.userPreference.currencyPair;
                vm.orderDTO.SystemUniqueSNo = null;
                vm.noOfSplits = '';
                vm.showSplitedOrderAmount = null;
                // vm.orderType = 'SELL';
                //vm.remarks = "";
                setDefaultRemark();
                vm.regularAndSplitOrder = 'Regular';
                vm.submitting = false;
                //added this for JIRA #1405, suspects that, vm.clicked is not set after order success/failure.
                //hence added this order entry section refresh
                vm.clicked = false;
                vm.orderDTO.forwardType = '';

                // if(vm.tenors!=null && vm.tenors!=undefined && vm.tenors.length>0){
                //     vm.tradeSettlementDate = new Date(vm.tenors[0].settlementDate);
                //     setTenorForSettlementDate(vm.tradeSettlementDate);
                // }
                changeOrderType(vm.orderType, vm.orderDTO.activityIndicator);
                //added for preventing vm.defaultTimeCondition no to be undefined
                vm.defaultTimeCondition = vm.userPreference.userTimeCondition;
                setDefaultPriceCondition(vm.userPreference.userPriceCondition);
                //set exposure type and exposure sub type
                setExposureTypeFromEnabledExposureLookup(vm.userPreference.userExposureType);
                setExposureSubTypeFromEnabledSubExposureLookup(vm.userPreference.userExposureSubType);
                vm.orderFromMarketWatch = false;
                $rootScope.orderDTO = vm.orderDTO;
                if (vm.regularAndSplitOrder == 'Regular') {
                    vm.orderDTO.isSplitOrder = false;
                } else {
                    vm.orderDTO.isSplitOrder = true;
                }
            }
        }

        function changeOrderType(buySellFlag, activityIndicator) {
            if (buySellFlag == 'BUYY' && activityIndicator == 'PLAC') {
                vm.orderType = 'BUYY';
                setTimeout(function () { document.getElementById('sellbuyTab').click() });
                setTimeout(function () { document.getElementById('buyTab').click() });
                // document.getElementById('buyTab').click();
            } else if (buySellFlag == 'SELL' && activityIndicator == 'PLAC') {
                vm.orderType = 'SELL';
                setTimeout(function () { document.getElementById('sellbuyTab').click() });
                setTimeout(function () { document.getElementById('sellTab').click() });
                // document.getElementById('sellTab').click();
            } else if (buySellFlag == 'BUYY' && activityIndicator == 'MDFY') {
                vm.orderType = 'MODIFYBUY';
                setTimeout(function () { document.getElementById('modifybuyTab').click() }, 50);
                // document.getElementById('buyTab').click();
            } else if (buySellFlag == 'SELL' && activityIndicator == 'MDFY') {
                vm.orderType = 'MODIFYSELL';
                setTimeout(function () { document.getElementById('modifysellTab').click() }, 50);
                // document.getElementById('sellTab').click();
            } else if (buySellFlag == 'BUYY' && activityIndicator == 'TRAD') {
                vm.orderType = 'BUYY';
                setTimeout(function () { document.getElementById('tradebuyTab').click() }, 50);
                // document.getElementById('buyTab').click();
            } else if (buySellFlag == 'SELL' && activityIndicator == 'TRAD') {
                vm.orderType = 'SELL';
                setTimeout(function () { document.getElementById('tradesellTab').click() }, 50);
                // document.getElementById('sellTab').click();
            } else if (buySellFlag == 'BUYY' && activityIndicator == 'ROLL') {
                vm.orderType = 'BUYY';
                setTimeout(function () { document.getElementById('rolloverbuyTab').click() }, 50);
            } else if (buySellFlag == 'SELL' && activityIndicator == 'ROLL') {
                vm.orderType = 'SELL';
                setTimeout(function () { document.getElementById('rolloversellTab').click() }, 50);
            } else if (buySellFlag == 'BUYY' && activityIndicator == 'EARL') {
                vm.orderType = 'BUYY';
                setTimeout(function () { document.getElementById('earlydeliverybuyTab').click() }, 50);
            } else if (buySellFlag == 'SELL' && activityIndicator == 'EARL') {
                vm.orderType = 'SELL';
                setTimeout(function () { document.getElementById('earlydeliverysellTab').click() }, 50);
            } else if (buySellFlag == 'SELLBUY' && activityIndicator == 'PLAC') {
                vm.orderType = 'SELLBUY';
                setTimeout(function () { document.getElementById('buyTab').click() });
                setTimeout(function () { document.getElementById('sellbuyTab').click() });
                // document.getElementById('sellTab').click();
            }
            setTimeout(function () { document.getElementById("marketwatchdiv").click(); }, 50);
        }

        function setDefaultPriceCondition(priceCondition) {
            vm.defaultPriceCondition = priceCondition;
            // if(!$scope.$$phase){
            if (priceCondition == 'LIMT') {
                setTimeout(function () { document.getElementById('limitTab').click() }, 50);
                // document.getElementById('limitTab').click();
            } else if (priceCondition == 'STLS') {
                setTimeout(function () { document.getElementById('stoplossTab').click() }, 50);
                // document.getElementById('stoplossTab').click();
            } else if (priceCondition == 'TKPR') {
                setTimeout(function () { document.getElementById('takeprofitTab').click() }, 50);
                // document.getElementById('takeprofitTab').click();
            } else if (priceCondition == 'MRKT') {
                setTimeout(function () { document.getElementById('stoplossTab').click() }, 50);
                setTimeout(function () { document.getElementById('takeprofitTab').click() }, 50);
                setTimeout(function () { document.getElementById('limitTab').click() }, 50);
                setTimeout(function () { document.getElementById('marketTab').click() }, 50);
                // document.getElementById('marketTab').click();
            }
            setTimeout(function () { document.getElementById("marketwatchdiv").click(); }, 50);
            // }
        }

        function getReportsToDisplay() {
            // get limits available for customer and bank and branch
            // we can derive limits available for each and every instruments
            // here and stored in separate variables to display in market
            // watch..
            var bankId = getBankIdForLoggedInUser();
            var customerId = getCustomerIdForLoggedInUser();
            if (bankId != 0 && customerId != 0) {
                getLimitsAvailableForAllInstruments(bankId, customerId);
            }

            // get report details for selected instrument(to display in report
            // section)
            // For customer user, get limits available of the customer and
            // default/selected bank. we can get default bank/branch from user
            // specific settings.
            // For bank/branch user, get limits available of the
            // default/selected customer for the bank. we can get default
            // customer for bnak/branch user from user specific settings
            getReportDetailsForSelectedInstrument();

        }

        function getBankIdForLoggedInUser() {
            var bankId = 0;
            if (vm.account.organisation.organisationType.shortName == 'CLEARCORP') {
                if (vm.defaultTradingBank != null) {
                    bankId = vm.defaultTradingBank.id;
                }
            } else if (vm.account.organisation.organisationType.shortName == 'BANK') {
                bankId = vm.globalValues.getOrganisation().id;
            } else if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                if (vm.defaultTradingBank != null) {
                    bankId = vm.defaultTradingBank.id;
                }
            }
            return bankId;
        }

        function getCustomerIdForLoggedInUser() {
            var customerId = 0;
            if (vm.account.organisation.organisationType.shortName == 'CLEARCORP' || vm.account.organisation.organisationType.shortName == 'BANK') {
                if (vm.defaultTradingCustomer != null) {
                    customerId = vm.defaultTradingCustomer.id;
                }
            } else if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                customerId = vm.globalValues.getOrganisation().id;
            }
            return customerId;
        }


//         $scope.$watch(
//             vm.currencyPairUSD,// watch ID, not object
//     function (value, oldValue) {
//         if (value !== oldValue && value != null) {
//             vm.onCurrencyPairChanged(value);
//         }
//     }
// );


//       $scope.$watch(
//         vm.currencyPairFCY,// watch ID, not object
//     function (value, oldValue) {
//         if (value !== oldValue && value != null) {
//             vm.onCurrencyPairChanged(value);
//         }
//     }
// );

        $scope.$watch('vm.currencyPairFCY', function (value) {
            if(value!=undefined && value!=null){
            console.log("fcy lookup",value);
             vm.onCurrencyPairChanged(value);
            }
        });


        $scope.$watch('vm.currencyPairUSD', function (value) {
            if(value!=undefined && value!=null){
            console.log("usd lookup",value);
             vm.onCurrencyPairChanged(value);
            }
        });


         $scope.$watch('vm.defaultInstrumentCode', function (value) {
            if(value!=undefined && value!=null){
                 $rootScope.defaultInstrumentCode = value;
                 console.log("watch instrument" ,$rootScope.defaultInstrumentCode);
            }
        })


      vm.onCurrencyPairChanged = function onCurrencyPairChanged(value) {

    if (!value) return;

    console.log("currency pair watch is called");

        // in usd tab forward selected , when come with same instrument in fcy change to spot default
    if($rootScope.enableOtherCurrencyTab && vm.defaultInstrumentCode=='Forward'){
        $rootScope.defaultInstrumentCode = 'SPOT';
        vm.defaultInstrumentCode = 'SPOT';
        $rootScope.loadBoardInstrumentCode = 'SPOT';
    }

    // Basic assignments
    $rootScope.currencyPair = value;
    vm.currencyPair = value;
    vm.currencyPairCode = value.code;
    vm.currencyPairId = value.id;
    vm.orderDTO.currencyPairId = vm.currencyPairId;
    vm.orderDTO.currencyCode = vm.currencyPairCode;
    vm.orderDTO.currencyPairCode = vm.currencyPairCode;
    vm.currencyPairForPO = vm.currencyPair;
    vm.currencyPairForOT = vm.currencyPair;
    vm.currencyPairForTrade = vm.currencyPair;
    vm.currencyPairForLimit = vm.currencyPair;
    vm.currencyPairForMarkup = vm.currencyPair;

    var currencyPair = $rootScope.currencyPairInstrumentDetails[value.id];

    console.log("currency pair instrument id ",$rootScope.currencyPairInstrumentDetails[value.id]);

    if (!currencyPair || !currencyPair.instruments) return;

    var index = getIndexBasedOnInstrument($rootScope.defaultInstrumentCode);

    if (index == null || !currencyPair.instruments[index]) return;

    var selectedInstrument = currencyPair.instruments[index];

    // Set default instrument details
    vm.defaultInstrumentId = selectedInstrument.instrumentId;

    if (value.code !== 'USDINR') {
        vm.defaultInstrumentTokenSequenceNo = selectedInstrument.tokenSequenceNo;
    }


    console.log("bank",vm.defaultTradingBankControl);
    // JPY validation (fix comparison)
    if (value.code === 'JPYINR') {
        validateJPYCurerency();
    }else{
        vm.clicked = false;
        $scope.errorTextOrderAmount = "";
    }

    console.log("inside watch ",vm.currencyPair);
    vm.updateCurrencyInstrument();
    vm.getMarkupReport( vm.currencyPairCode);
}


vm.updateCurrencyInstrument = function() {
    var bank = $rootScope.tradingBank || vm.defaultTradingBank;
    var customer = $rootScope.tradingCustomer || vm.defaultTradingCustomer;
    if (bank && customer) {
        getLimitsAvailableForAllInstruments(bank.id, customer.id);
          $timeout(function() {
        console.log("data currency change",$rootScope.currencyPairFilterForPO.id);
         getReportDetailsForSelectedInstrument();
 }, 100);

    }
    vm.updateDefaultInstrumentDetails($rootScope.defaultInstrumentCode);
}

vm.updateDefaultInstrumentDetails = function updateDefaultInstrumentDetails(value) {
  // ---- private helper (local to this function) ----
  function applyInstrumentChange(code) {
    console.log("instrument update",code);
    vm.defaultInstrumentCode = code;
    $rootScope.loadBoardInstrumentCode = code;
    $rootScope.defaultInstrumentCode = code;

    var currencyPair = $rootScope.currencyPairInstrumentDetails[vm.currencyPair.id];
    var index = getIndexBasedOnInstrument(code);

    if (currencyPair && currencyPair.instruments && currencyPair.instruments[index]) {
      vm.defaultInstrumentId = currencyPair.instruments[index].instrumentId;

    vm.defaultInstrumentTokenSequenceNo = currencyPair.instruments[index].tokenSequenceNo;
    }

    vm.getLimitExchangeRateForInstrument(code);
  }

  // ---- Non-USDINR logic ----
  if (vm.currencyPair.code !== 'USDINR') {

    var currencyPair = $rootScope.currencyPairInstrumentDetails[vm.currencyPair.id];
    var index = getIndexBasedOnInstrument(value);

    var seqNo = vm.defaultInstrumentTokenSequenceNo;

    if (currencyPair && currencyPair.instruments && currencyPair.instruments[index]) {
      vm.defaultInstrumentId = currencyPair.instruments[index].instrumentId;

     seqNo = currencyPair.instruments[index].tokenSequenceNo;
    }

   //  var status = vm.getInstrumentStatus(seqNo);
    vm.tradeFCYSettlementDate =  new Date($rootScope.marketSessionMap[seqNo].settlementDate)

    // if (status === 'CLOSED' || status === 'HOLIDAY' || status === 'UNAVAILABLE') {
    //   console.warn('Instrument change blocked due to status:', status);
    //   return;
    // }

    applyInstrumentChange(value);
    return;
  }else{

  // ---- USDINR logic ----
  var sessionMap = {
    SPOT:  $rootScope.retailSpotMarketSession,
    TOM:   $rootScope.tomMarketSession,
    CASH:  $rootScope.cashMarketSession,
    Forward:$rootScope.forwardMarketSession
  };

  var session = sessionMap[value];

//   if (!session || !session.sessionTimingsDTO) {
//     console.warn('No session info for instrument:', value);
//     return;
//   }

//   if (session.sessionTimingsDTO.status === 'CLOSED' || session.isSettlementHoliday) {
//     console.warn(value, 'market session is CLOSED or holiday');
//     return;
//   }

  applyInstrumentChange(value);
  }

};

        function getLimitsAvailableForAllInstruments(bankId, customerId) {
            // For customer user, get limits available of the customer and
            // default/selected bank.
            // For bank/branch user, get limits available of the
            // default/selected customer for the bank.
            var currencyPairCode = 'USDINR';
            console.log("currency",vm.currencyPair);
            if (!vm.currencyPair != null && vm.currencyPair != undefined) {
                console.log("limit currency is valid ",vm.currencyPair.code);
                currencyPairCode = vm.currencyPair.code;
            }
            console.log("limit currency ",currencyPairCode);
            LimitSettings.getLimitUtilisationDetailsForAllInstrumentForOrder({ bankId: bankId, customerId: customerId, currencyPairCode: currencyPairCode }, onGetLimitsAvailableSuccess, onGetLimitsAvailableFailure);
        }

        function onGetLimitsAvailableSuccess(result) {

            // this is for market watch section
            vm.limitsAvailableForAllInstrument = result;

            // if(vm.currencyPair==null){
            //     if($rootScope.enableOtherCurrencyTab){
            //     vm.currencyPair = $rootScope.currencyPairList[2];
            //     }
            //     else{
            //         vm.currencyPair = $rootScope.currencyPairList[0];
            //     }
            // }else if(vm.currencyPair.code != 'USDINR' && !$rootScope.enableOtherCurrencyTab){
            //     vm.currencyPair = $rootScope.currencyPairList[0];
            // }else if($rootScope.enableOtherCurrencyTab){
            //     if(vm.currencyPair.code=='USDINR'){
            //     vm.currencyPair = $rootScope.currencyPairList[2];
            //     }
            // }

            // vm.orderDTO = angular.copy(vm.orderDTOCopy);
            // $rootScope.orderDTO = vm.orderDTO;

    //          vm.currencyPair = angular.copy(
    //     $rootScope.enableOtherCurrencyTab
    //         ? $rootScope.currencyPairList[2]
    //         : $rootScope.currencyPairList[0]
    // );
            fillZeroIfLimitIsNotDefined();
            if (result != null && result != undefined) {
                if (result.length > 0) {
                    $rootScope.limitNotDefined = false;
                    if (result[0].instrumentCode == 'ALL') {
                        vm.limitInstrumentCode = 'ALL';
                    } else {
                        vm.limitInstrumentCode = 'INDIVIDUAL';
                    }
                } else {
                    fillZeroIfLimitIsNotDefined();
                }
            } else {
                fillZeroIfLimitIsNotDefined();
            }
            // we can get limits for the instrument(spot, cash, tom or all) and
            // limit type(gross, gross buy, gross sell, net).
            angular.forEach(vm.limitsAvailableForAllInstrument, function (value) {
                // get limits for each instrument and assign it to separate
                // variables to display in market watch
                getLimitsForEachInstrument(value);
            })

            //get credit factor for settlement date apply with limit
            getCreditFactorAndApplyOnLimits();

        }

        function onGetLimitsAvailableFailure() {

        }

        function getInstrumentMatchedCurrencypair(){
            var currencyPairId = vm.globalValues.getDefaultCurrencyPairId();
            if (!vm.currencyPair != null && vm.currencyPair != undefined) {
                currencyPairId = vm.currencyPair.id;
            }
          // DefaultMarket.csInstruments({currencyPairId:currencyPairId},onGetInstrumentSuccess, onGetInstrumentFailure);

        }
        function getInstrumentMatchedCurrencypairReport(value){
            var currencyPairId = vm.globalValues.getDefaultCurrencyPairId();
            if (!value != null && value != undefined) {
                currencyPairId = value.id;
            }
            DefaultMarket.csInstruments({currencyPairId:currencyPairId},onGetInstrumentSuccessForReport
                , onGetInstrumentFailure);

        }


        function onGetInstrumentSuccessForReport(result) {
            vm.instrumentTypes = result;
         //   $rootScope.instrumentTypes = result;
        }
        function fillZeroIfLimitIsNotDefined() {
            $rootScope.limitNotDefined = true;
            $rootScope.retailSpotBuyLimit = 0;
            $rootScope.retailSpotSellLimit = 0;
            $rootScope.cashBuyLimit = 0;
            $rootScope.cashSellLimit = 0;
            $rootScope.tomBuyLimit = 0;
            $rootScope.tomSellLimit = 0;
            $rootScope.forwardBuyLimit = 0;
            $rootScope.forwardSellLimit = 0;
            $rootScope.forwardBuyLimitWithCF = 0;
            $rootScope.forwardSellLimitWithCF = 0;
            $rootScope.maxForwardTenorDate = null;
            // if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
            fillLimitsInMarketWatch();
            // }
        }

        function getLimitsForEachInstrument(limit) {
            $rootScope.limitType = limit.limitType;
            $rootScope.limitNotDefined = false;
            if (limit.instrumentCode == 'SPOT') {
                $rootScope.retailSpotBuyLimit = getBuyingPower(limit);
                $rootScope.retailSpotSellLimit = getSellingPower(limit);
            } else if (limit.instrumentCode == 'CASH') {
                $rootScope.cashBuyLimit = getBuyingPower(limit);
                $rootScope.cashSellLimit = getSellingPower(limit);
            } else if (limit.instrumentCode == 'TOM') {
                $rootScope.tomBuyLimit = getBuyingPower(limit);
                $rootScope.tomSellLimit = getSellingPower(limit);
            } else if (limit.instrumentCode == 'Forward') {
                $rootScope.forwardBuyLimit = getBuyingPower(limit);
                $rootScope.forwardSellLimit = getSellingPower(limit);
                $rootScope.maxForwardTenorDate = MarketWatch.getMaxForwardTenorDate(limit, new Date($rootScope.retailSpotMarketSession.settlementDate));
            }

            if (limit.instrumentCode == 'ALL' || vm.limitInstrumentCode == 'ALL') {
                var buyingPower = getBuyingPower(limit);
                var sellingPower = getSellingPower(limit);
                $rootScope.retailSpotBuyLimit = buyingPower;
                $rootScope.retailSpotSellLimit = sellingPower;
                $rootScope.tomBuyLimit = buyingPower;
                $rootScope.tomSellLimit = sellingPower;
                $rootScope.cashBuyLimit = buyingPower;
                $rootScope.cashSellLimit = sellingPower;
                $rootScope.forwardBuyLimit = buyingPower;
                $rootScope.forwardSellLimit = sellingPower;
                $rootScope.maxForwardTenorDate = MarketWatch.getMaxForwardTenorDate(limit, new Date($rootScope.retailSpotMarketSession.settlementDate));
            }
            if (limit.instrumentCode == 'UptoSPOT') {
                var buyingPower = getBuyingPower(limit);
                var sellingPower = getSellingPower(limit);
                $rootScope.retailSpotBuyLimit = buyingPower;
                $rootScope.retailSpotSellLimit = sellingPower;
                $rootScope.tomBuyLimit = buyingPower;
                $rootScope.tomSellLimit = sellingPower;
                $rootScope.cashBuyLimit = buyingPower;
                $rootScope.cashSellLimit = sellingPower;
            }
            if (vm.account.organisation.organisationType.shortName == 'CUSTOMER' || (vm.account.organisation.organisationType.shortName != 'CUSTOMER' && vm.defaultTradingCustomerControl.id == limit.customerId)) {
                fillLimitsInMarketWatch();
            }
        }

        function fillLimitsInMarketWatch() {
            $rootScope.retailSpotBuyLimitForMkt = $rootScope.retailSpotBuyLimit;
            $rootScope.retailSpotSellLimitForMkt = $rootScope.retailSpotSellLimit;
            $rootScope.tomBuyLimitForMkt = $rootScope.tomBuyLimit;
            $rootScope.tomSellLimitForMkt = $rootScope.tomSellLimit;
            $rootScope.cashBuyLimitForMkt = $rootScope.cashBuyLimit;
            $rootScope.cashSellLimitForMkt = $rootScope.cashSellLimit;
            $rootScope.forwardBuyLimitForMkt = $rootScope.forwardBuyLimit;
            $rootScope.forwardSellLimitForMkt = $rootScope.forwardSellLimit;
        }

        // get report details for given instrument
        function getReportDetailsForSelectedInstrument() {

            getPendingOrderReportForInstrument();
            getLimitUtilisedReportForInstrument();
            getTradesReportForInstrument();
            getOutstandingTradeReportForInstrument();

        }

        vm.getOutstandingTradeReportForInstrument = getOutstandingTradeReportForInstrument;
        function getOutstandingTradeReportForInstrument() {
            var bankId = getBankIdForReportFilters('OT');
            var branchId = getBranchIdForReportFilters('OT');
            var customerId = getCustomerIdForReportFilters('OT');
            var instrumentId = getInstrumentIdForReportFilters('OT');
            var currencyPairId = getCurrencyPairId('OT');


            if (vm.account.organisation.organisationType.shortName == 'CLEARCORP') {
                getOutstandingTrades(bankId, branchId, customerId, instrumentId, $rootScope.fromSettlementDate, $rootScope.toSettlementDate, currencyPairId);
            } else if (vm.account.organisation.organisationType.shortName == 'BANK' && vm.globalValues.getEntityOwnerType().shortName != 'Branch') {
                if (bankId != 0) {
                    getOutstandingTrades(bankId, branchId, customerId, instrumentId, $rootScope.fromSettlementDate, $rootScope.toSettlementDate, currencyPairId);
                }
            } else if (vm.account.organisation.organisationType.shortName == 'BANK' && vm.globalValues.getEntityOwnerType().shortName == 'Branch') {
                if (bankId != 0 && branchId != 0) {
                    getOutstandingTrades(bankId, branchId, customerId, instrumentId, $rootScope.fromSettlementDate, $rootScope.toSettlementDate, currencyPairId);
                }
            } else if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                if (customerId != 0) {
                    getOutstandingTrades(bankId, branchId, customerId, instrumentId, $rootScope.fromSettlementDate, $rootScope.toSettlementDate, currencyPairId);
                }
            }
        }


        function getCurrencyPairId(reportType) {
            var currencyPairId = 0;

            if($rootScope.enableOtherCurrencyTab){
            if (reportType == 'PO') {
                if ($rootScope.currencyPairFilterForPO != null) {
                    currencyPairId = $rootScope.currencyPairFilterForPO.id;
                }
            } else if (reportType == 'OT') {
                if ($rootScope.currencyPairFilterForOT != null) {
                    currencyPairId = $rootScope.currencyPairFilterForOT.id;
                }
            } else if (reportType == 'Trade') {
                if ($rootScope.currencyPairFilterForTrade != null) {
                    currencyPairId = $rootScope.currencyPairFilterForTrade.id;
                }
            }else if (reportType == 'Limit') {
                if ($rootScope.currencyPairFilterForLimit != null) {
                    currencyPairId = $rootScope.currencyPairFilterForLimit.code;
                }
            }}
            else{
                    return 1;
            }


            return currencyPairId;
        }

        // get pending orders reports for given instrument
        function getPendingOrderReportForInstrument() {
            var bankId = getBankIdForReportFilters('PO');
            var branchId = getBranchIdForReportFilters('PO');
            var customerId = getCustomerIdForReportFilters('PO');
            var instrumentId = getInstrumentIdForReportFilters('PO');
            var currencyPairId = getCurrencyPairId('PO');

            if (vm.account.organisation.organisationType.shortName == 'CLEARCORP') {
                getPendingOrders(bankId, branchId, customerId, instrumentId, currencyPairId);
            } else if (vm.account.organisation.organisationType.shortName == 'BANK' && vm.globalValues.getEntityOwnerType().shortName != 'Branch') {
                if (bankId != 0) {
                    getPendingOrders(bankId, branchId, customerId, instrumentId, currencyPairId);
                }
            } else if (vm.account.organisation.organisationType.shortName == 'BANK' && vm.globalValues.getEntityOwnerType().shortName == 'Branch') {
                if (bankId != 0 && branchId != 0) {
                    getPendingOrders(bankId, branchId, customerId, instrumentId, currencyPairId);
                }
            } else if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                if (customerId != 0) {
                    getPendingOrders(bankId, branchId, customerId, instrumentId, currencyPairId);
                }
            }
        }

        function getOutstandingTrades(bankId, branchId, customerId, instrumentId, fromDate, toDate, currencyPairId) {

            var fromSettDate = null
            var toSettDate = null;

            //if the from date is null then provide the minimum possible date , else send the selected date
            if (fromDate == null && fromDate == undefined) {
                fromSettDate = new Date(1900, 0, 1);
            } else {
                fromSettDate = fromDate;
            }

            // if to date is null then provide the maximum possible date , else send the selected date
            if (toDate == null && toDate == undefined) {
                toSettDate = new Date(9999, 11, 31);
            } else {
                toSettDate = toDate;
            }

            OrderStatusDetails.getTradesOutstandingList({ bankId: bankId, branchId: branchId, customerId: customerId, instrumentId: instrumentId, fromSetDate: DateUtils.convertLocalDateToServer(fromSettDate), toSetDate: DateUtils.convertLocalDateToServer(toSettDate), currencyPairId: currencyPairId }, onOutstandingTradesSuccess, onGetOutstandingTradesFailure);

            // if(moment(fromSettDate).isAfter(toSettDate,'day')){
            // 	MessageBox.openMessageBox("Alert","From date cannot be greater than the To date.", "Ok", "homepage");
            // }

            // else{
            // 	OrderStatusDetails.getTradesOutstandingList({bankId: bankId, branchId: branchId, customerId: customerId,  instrumentId: instrumentId, fromSetDate : DateUtils.convertLocalDateToServer(fromSettDate),toSetDate :DateUtils.convertLocalDateToServer(toSettDate) }, onOutstandingTradesSuccess, onGetOutstandingTradesFailure);
            // }
        }

        function validateTradesOutstandingDates(fromDate, toDate) {
            var validFilterDates = true;
            var fromSettDate = null
            var toSettDate = null;

            //if the from date is null then provide the minimum possible date , else send the selected date
            if (fromDate == null && fromDate == undefined) {
                fromSettDate = new Date(1900, 0, 1);
            } else {
                fromSettDate = fromDate;
            }

            // if to date is null then provide the maximum possible date , else send the selected date
            if (toDate == null && toDate == undefined) {
                toSettDate = new Date(9999, 11, 31);
            } else {
                toSettDate = toDate;
            }

            if (moment(fromSettDate).isAfter(toSettDate, 'day')) {
                validFilterDates = false;
            }

            return validFilterDates;
        }

        function onOutstandingTradesSuccess(result) {

            angular.forEach(result, function (value) {
                value.tradeTime = moment(value.tradeTime, 'YYYYMMDDHHmmss.SSSSSSSSS').format();
                value.select = false;
            });

            $rootScope.outstandingTrades = result;
            //$rootScope.outstandingTradesMemory = result;
            vm.clickedReport = false;
        }

        function onGetOutstandingTradesFailure() {
            vm.clickedReport = false;
        }

        function getPendingOrders(bankId, branchId, customerId, instrumentId, currencyPairId) {

            OrderStatusDetails.getPendingOrders({ bankId: bankId, branchId: branchId, customerId: customerId, instrumentId: instrumentId, currencyPairId: currencyPairId }, onGetPendingOrdersSuccess, onGetPendingOrdersFailure);

        }


        function onGetPendingOrdersSuccess(result) {
            $rootScope.pendingOrders = result;
            vm.clickedReport = false;
            angular.forEach($rootScope.pendingOrders, function (value, index) {
                angular.forEach($rootScope.orderStatusList, function (orderStatus) {
                    if (value.orderStatusId == orderStatus.id) {
                        $rootScope.pendingOrders[index].orderStatus = orderStatus.name;
                    }
                    value.expiryTimeString = moment(value.expiryTime, 'YYYYMMDDHHmmss').format();
                })
            })
            //$rootScope.pendingOrdersMemory = $rootScope.pendingOrders;
        }

        function onGetPendingOrdersFailure() {
            vm.clickedReport = false;
        }

        // get bank, branch and customer id from report filters
        function getBankIdForReportFilters(reportType) {
            var bankId = 0;
            if ($rootScope.account.organisation.organisationType.shortName == 'CLEARCORP' || $rootScope.account.organisation.organisationType.shortName == 'CUSTOMER') {
                if (reportType == 'PO') {
                    if ($rootScope.bankFilterForPO != null) {
                        bankId = $rootScope.bankFilterForPO.id;
                    }
                } else if (reportType == 'Limit') {
                    if ($rootScope.bankFilterForLimit != null) {
                        bankId = $rootScope.bankFilterForLimit.id;
                    }
                } else if (reportType == 'Trade') {
                    if ($rootScope.bankFilterForTrade != null) {
                        bankId = $rootScope.bankFilterForTrade.id;
                    }
                }
                else if (reportType == 'OT') {
                    if ($rootScope.bankFilterForOT != null) {
                        bankId = $rootScope.bankFilterForOT.id;
                    }
                }
            } else if ($rootScope.account.organisation.organisationType.shortName == 'BANK') {
                bankId = $rootScope.account.organisation.id;
            }

            return bankId;
        }

        function getBranchIdForReportFilters(reportType) {
            var branchId = 0;
            if (reportType == 'PO') {
                if ($rootScope.branchFilterForPO != null) {
                    branchId = $rootScope.branchFilterForPO.id;
                }
            } else if (reportType == 'Limit') {
                if ($rootScope.branchFilterForLimit != null) {
                    branchId = $rootScope.branchFilterForLimit.id;
                }
            } else if (reportType == 'Trade') {
                if ($rootScope.branchFilterForTrade != null) {
                    branchId = $rootScope.branchFilterForTrade.id;
                }
            }
            else if (reportType == 'OT') {
                if ($rootScope.branchFilterForOT != null) {
                    branchId = $rootScope.branchFilterForOT.id;
                }
            }
            return branchId;
        }

        function getInstrumentIdForReportFilters(reportType) {
            var instrumentId = 0;
            if (reportType == 'PO') {
                if ($rootScope.instrumentFilterForPO != null) {
                    instrumentId = $rootScope.instrumentFilterForPO.id;
                }
            } else if (reportType == 'Limit') {
                if ($rootScope.instrumentFilterForLimit != null) {
                    instrumentId = $rootScope.instrumentFilterForLimit.id;
                }
            } else if (reportType == 'Trade') {
                if ($rootScope.instrumentFilterForTrade != null) {
                    instrumentId = $rootScope.instrumentFilterForTrade.id;
                }
            }
            else if (reportType == 'OT') {
                if ($rootScope.instrumentFilterForOT != null) {
                    instrumentId = $rootScope.instrumentFilterForOT.id;
                }
            }
            return instrumentId;
        }

        function getCustomerIdForReportFilters(reportType) {
            var customerId = 0;
            if ($rootScope.account.organisation.organisationType.shortName == 'CLEARCORP' || $rootScope.account.organisation.organisationType.shortName == 'BANK') {
                if (reportType == 'PO') {
                    if ($rootScope.customerFilterForPO != null) {
                        customerId = $rootScope.customerFilterForPO.id;
                    }
                } else if (reportType == 'Limit') {
                    if ($rootScope.customerFilterForLimit != null) {
                        customerId = $rootScope.customerFilterForLimit.id;
                    }
                } else if (reportType == 'Trade') {
                    if ($rootScope.customerFilterForTrade != null) {
                        customerId = $rootScope.customerFilterForTrade.id;
                    }
                }
                else if (reportType == 'OT') {
                    if ($rootScope.customerFilterForOT != null) {
                        customerId = $rootScope.customerFilterForOT.id;
                    }
                }
            } else if ($rootScope.account.organisation.organisationType.shortName == 'CUSTOMER') {
                customerId = getCustomerIdForLoggedInUser();
            }
            return customerId;
        }

        // get limit utilisation reports for given instrument
        function getLimitUtilisedReportForInstrument() {
            var bankId = getBankIdForReportFilters('Limit');
            var branchId = getBranchIdForReportFilters('Limit');
            var customerId = getCustomerIdForReportFilters('Limit');
            var instrumentId = getInstrumentIdForReportFilters('Limit');

            var currencyCode = '';

            if($rootScope.currencyPairFilterForLimit!=undefined && $rootScope.currencyPairFilterForLimit!=null){
             currencyCode = $rootScope.currencyPairFilterForLimit.code;
            }

            if (vm.account.organisation.organisationType.shortName == 'CLEARCORP') {
                getLimitsAvailable(bankId, branchId, customerId, instrumentId,currencyCode);
            } else if (vm.account.organisation.organisationType.shortName == 'BANK' && vm.globalValues.getEntityOwnerType().shortName != 'Branch') {
                if (bankId != 0) {
                    getLimitsAvailable(bankId, branchId, customerId, instrumentId,currencyCode);
                }
            } else if (vm.account.organisation.organisationType.shortName == 'BANK' && vm.globalValues.getEntityOwnerType().shortName == 'Branch') {
                if (bankId != 0 && branchId != 0) {
                    getLimitsAvailable(bankId, branchId, customerId, instrumentId,currencyCode);
                }
            } else if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                if (customerId != 0) {
                    getLimitsAvailable(bankId, branchId, customerId, instrumentId,currencyCode);
                }
            }
        }

        function getLimitsAvailable(bankId, branchId, customerId, instrumentId,currencyCode) {

            LimitSettings.getLimitUtilsationDetailsForInstrument({ bankId: bankId, branchId: branchId, customerId: customerId, instrumentId: instrumentId,currencyCode:currencyCode}, onGetLimitsSuccess, onGetLimitsFailure);

        }

        function onGetLimitsSuccess(result) {
            $rootScope.limitsAvailableForSelectedInstrument = result;
            vm.limit = result;
            vm.limitCurrencyCode = vm.limit.currencyCode;
            vm.clickedReport = false;
            //$rootScope.limitsAvailableForSelectedInstrumentMemory = result;
        }

        function onGetLimitsFailure() {
            vm.clickedReport = false;

        }

        // get trades report for given instrument
        function getTradesReportForInstrument() {
            var bankId = getBankIdForReportFilters('Trade');
            var branchId = getBranchIdForReportFilters('Trade');
            var customerId = getCustomerIdForReportFilters('Trade');
            var instrumentId = getInstrumentIdForReportFilters('Trade');
            var currencyPairId = getCurrencyPairId('Trade');

            if (vm.account.organisation.organisationType.shortName == 'CLEARCORP') {
                getTrades(bankId, branchId, customerId, instrumentId, currencyPairId);
            } else if (vm.account.organisation.organisationType.shortName == 'BANK' && vm.globalValues.getEntityOwnerType().shortName != 'Branch') {
                if (bankId != 0) {
                    getTrades(bankId, branchId, customerId, instrumentId, currencyPairId);
                }
            } else if (vm.account.organisation.organisationType.shortName == 'BANK' && vm.globalValues.getEntityOwnerType().shortName == 'Branch') {
                if (bankId != 0 && branchId != 0) {
                    getTrades(bankId, branchId, customerId, instrumentId, currencyPairId);
                }
            } else if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                if (customerId != 0) {
                    getTrades(bankId, branchId, customerId, instrumentId, currencyPairId);
                }
            }
        }

        function getTrades(bankId, branchId, customerId, instrumentId, currencyPairId) {

            OrderStatusDetails.getTradesForSelectedInstrument({ bankId: bankId, branchId: branchId, customerId: customerId, instrumentId: instrumentId, currencyPairId: currencyPairId }, onGetTradesSuccess, onGetTradesFailure);

        }

        function onGetTradesSuccess(result) {
            angular.forEach(result, function (value) {
                value.tradeTime = moment(value.tradeTime, 'YYYYMMDDHHmmss.SSSSSSSSS').format();
            });


            vm.summaryBuyTrades = result.filter(function (val) {
                return val.buySellIndicator == "BUYY";
            })

            vm.summarySellTrades = result.filter(function (val) {
                return val.buySellIndicator == "SELL";
            })

            vm.totalUSDBought = vm.summaryBuyTrades.reduce(function (a, b) {
                return a + b.tradedAmount;
            }, 0);
            vm.totalUSDSold = vm.summarySellTrades.reduce(function (a, b) { return a + b.tradedAmount; }, 0);
            vm.totalINRSold = vm.summaryBuyTrades.reduce(function (a, b) { return a + b.tradedValue; }, 0);
            vm.totalINRBought = vm.summarySellTrades.reduce(function (a, b) { return a + b.tradedValue; }, 0);


            $rootScope.trades = result;
            vm.clickedReport = false;
            //$rootScope.tradesMemory = result;
            vm.expandTradePosition = false;
            if (vm.instrumentFilterForTrade != null) {
                $rootScope.totalUSDBought = vm.totalUSDBought;
                $rootScope.totalUSDSold = vm.totalUSDSold;
                $rootScope.totalINRSold = vm.totalINRSold;
                $rootScope.totalINRBought = vm.totalINRBought;
                $rootScope.weightedAverageBuy = Math.abs(vm.totalINRSold / vm.totalUSDBought);
                $rootScope.weightedAverageSell = Math.abs(vm.totalINRBought / vm.totalUSDSold);
                $rootScope.usdNet = vm.totalUSDBought - vm.totalUSDSold;
                $rootScope.inrNet = vm.totalINRBought - vm.totalINRSold;
                $rootScope.netWeightedAveragePrice = Math.abs((vm.totalINRBought - vm.totalINRSold) / (vm.totalUSDBought - vm.totalUSDSold));

                if (isNaN(Math.abs(vm.totalINRSold / vm.totalUSDBought)) || Math.abs(vm.totalINRSold / vm.totalUSDBought) == Infinity)
                    $rootScope.weightedAverageBuy = null;
                if (isNaN(Math.abs((vm.totalINRBought - vm.totalINRSold) / (vm.totalUSDBought - vm.totalUSDSold))) ||
                    (Math.abs((vm.totalINRBought - vm.totalINRSold) / (vm.totalUSDBought - vm.totalUSDSold))) == Infinity)
                    $rootScope.netWeightedAveragePrice = null;

                if (isNaN(Math.abs(vm.totalINRBought / vm.totalUSDSold)) || Math.abs(vm.totalINRBought / vm.totalUSDSold) == Infinity)
                    $rootScope.weightedAverageSell = null;
            } else {
                $rootScope.totalUSDBought = null;
                $rootScope.totalUSDSold = null;
                $rootScope.totalINRSold = null;
                $rootScope.totalINRBought = null;
                $rootScope.weightedAverageBuy = null;
                $rootScope.weightedAverageSell = null;
                $rootScope.usdNet = null;
                $rootScope.inrNet = null;
                $rootScope.netWeightedAveragePrice = null;
            }

        }

        function onGetTradesFailure() {
            vm.clickedReport = false;
        }

        function onGetMarketSessionSuccess(result) {
            $rootScope.marketSessionSettings = result;
            // store session settings in separate variables for each and every
            // instrument
            setMarketSettings();

            //get credit factor settings
            getCreditFactorSettings();

            // get market depth
            Market.getMarketDepth(onGetMarketDepthSuccess, onGetMarketDepthFailure);

            // onGetMarketDepthSuccess(vm.marketDepth);
            // Market.getMarketDepth(onGetMarketDepthSuccess,
            // onGetMarketDepthFailure);
        }

        function onGetMarketSessionFailure() {

        }

        // set market settings
        function setMarketSettings() {
            // loop market session settings and get
            // $rootScope.retailSpotMarketSession, $rootScope.cashMarketSession,
            // $rootScope.tomMarketSession..
           var settings = $rootScope.marketSessionSettings;
    for (var i = 0; i < settings.length; i++) {
        var s = settings[i];
        if (s.baseCurrency === 'USD') {
            if      (s.instrumentCode === 'SPOT')    $rootScope.retailSpotMarketSession = s;
            else if (s.instrumentCode === 'TOM')     $rootScope.tomMarketSession = s;
            else if (s.instrumentCode === 'CASH')    $rootScope.cashMarketSession = s;
            else if (s.instrumentCode === 'Forward') $rootScope.forwardMarketSession = s;
        } else {
             $rootScope.marketSessionMap[s.tokenSequenceNumber] = s;
        }
    }
        }

        function onGetMarketDepthSuccess(result) {
            var existing = $rootScope.marketDepth || [];
    var indexMap = Object.create(null);  // build once per call
    for (var i = 0; i < existing.length; i++) {
        indexMap[existing[i].instrumentID] = i;
    }
    for (var j = 0; j < result.length; j++) {
        var dto = result[j];
        var idx = indexMap[dto.instrumentID];
        if (idx !== undefined) {
            existing[idx] = MarketWatch.getMarketDepth(dto);
        } else {
            existing.push(MarketWatch.getMarketDepth(dto));
        }
    }
    $rootScope.marketDepth = existing;





			//console.log('Before processing' + angular.toJson(existingMarketDepth));

			// if(existingMarketDepth == null || existingMarketDepth == undefined || existingMarketDepth.length == 0){
			// 	existingMarketDepth = [];
			// 	existingMarketDepth[0]= MarketWatch.getMarketDepth(marketDepthDTO);
			// }else if( existingMarketDepth.length == 1 && existingMarketDepth[0].instrumentID!=marketDepthDTO.instrumentID){
			// 	existingMarketDepth[1] = MarketWatch.getMarketDepth(marketDepthDTO);
			// }
			// else{
			// 	angular.forEach(existingMarketDepth, function(value, index){
			// 		if(value.instrumentID==marketDepthDTO.instrumentID){
			// 		//	console.log('processing');
			// 			marketDepth = MarketWatch.getMarketDepth(marketDepthDTO);
			// 			existingMarketDepth[index] = marketDepth;
			// 		}
			// 	});
			// }

            prepareMarketDepthDisplay();



        }

        function onGetMarketDepthFailure() {

        }

        function getCreditFactorSettings() {
            if (vm.account.organisation.organisationType.shortName == 'BANK') {
                CreditFactorSettings.query({ orgId: vm.account.organisation.id }, onGetCFSettingsForBankSuccess, onGetCFSettingsForBankFailure);
            } else if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                CreditFactorSettings.getCreditFactorsForCustomer({ customerId: vm.account.organisation.id }, onGetCFSettingsForCustomerSuccess, onGetCFSettingsForCustomerFailure);
            }
        }

        function onGetCFSettingsForBankSuccess(result) {
            if (result != null && result != undefined) {
                $rootScope.selectedCreditFactor = MarketWatch.computeTenorDatesForGivenCreditFactorSettingsHeader(result, new Date($rootScope.retailSpotMarketSession.settlementDate), new Date($rootScope.cashMarketSession.settlementDate));
            }
        }

        function onGetCFSettingsForBankFailure() {

        }

        function onGetCFSettingsForCustomerSuccess(result) {
            if (result != null && result != undefined && result.length > 0) {
                $rootScope.creditFactorList = MarketWatch.computeTenorDatesForGivenCreditFactorSettingsHeaderList(result, new Date($rootScope.retailSpotMarketSession.settlementDate), new Date($rootScope.cashMarketSession.settlementDate));

                $rootScope.selectedCreditFactor = MarketWatch.getCreditFactorSettingsForGivenBank($rootScope.creditFactorList, vm.defaultTradingBank.id);
            }
        }

        function onGetCFSettingsForCustomerFailure() {

        }

        function prepareMarketDepthDisplay() {
            // get market depth for both retail spot and interbank spot
            getMarketDepthDetailsForReport();
            // if(!vm.isFromIndex){
            setTimeout(function () { getSwapQuotes(); });
            setTimeout(function () { getMarkup(); });
            // }

            // set previous ticker price
            /*
             * var previousTickerPrice = angular.copy($rootScope.tickerPrice);
             * vm.previousTickerPrice = previousTickerPrice;
             */
            // get ticker price
            if ($rootScope.marketDepth != null && $rootScope.marketDepth != undefined && $rootScope.marketDepth != '' && $rootScope.marketDepth.length > 0) {
                angular.forEach($rootScope.marketDepth, function (marketDepthDTO) {

                    	if(marketDepthDTO.baseCurrency!=='USD'){

				var previousFCYTicker = $rootScope.tickerPriceFCY[marketDepthDTO.sequenceNo];

				var tickerPrice = MarketWatch.getTickerPrice(marketDepthDTO, previousFCYTicker, $rootScope.previousDayClosingPriceForSpot, $rootScope.previousDayClosingPriceForIbSpot);

				$rootScope.tickerPriceFCY[marketDepthDTO.sequenceNo,tickerPrice];
			}
			else{
				                    var previousTickerPrice = angular.copy($rootScope.tickerPrice);
                    $rootScope.previousTickerPrice = previousTickerPrice;
                    if(marketDepthDTO.instrumentId!=1)
                    $rootScope.tickerPrice = MarketWatch.getTickerPrice(marketDepthDTO, previousTickerPrice, $rootScope.previousDayClosingPriceForSpot, $rootScope.previousDayClosingPriceForIbSpot);

			}

                })
            } else {
                $rootScope.tickerPrice.retailSpot = $rootScope.previousDayClosingPriceForSpot;
                $rootScope.tickerPrice.ibSpot = $rootScope.previousDayClosingPriceForIbSpot;
            }

             getLimitExchangeRateForInstrument(vm.defaultInstrumentCode);
            // setLTPPriceAsDefaultValueForLimitOrder();
        }

        function getMarketDepthDetailsForReport() {

            // setTimeout(function(){
            // var existingSpotMarketDepth = angular.copy($rootScope.retailSpotMarketDepth);
            // //get market depth for SPOT
            // existingSpotMarketDepth =
            // MarketWatch.getRetailSpotMarketDepth(vm.marketDepth);

            MarketWatch.getRetailSpotMarketDepth($rootScope.marketDepth);
            //$rootScope.retailSpotMarketDepthMemory = $rootScope.retailSpotMarketDepth;

            if ($rootScope.retailSpotMarketDepth != null && $rootScope.retailSpotMarketDepth != undefined) {
                getRetailSpotMarketWatch();
            }

            //var existingIbSpotMarketDepth = $rootScope.ibSpotMarketDepth;
            // get market depth for IB SPOT
            //existingIbSpotMarketDepth =
            // MarketWatch.getIBSpotMarketDepth($rootScope.marketDepth);
            //$rootScope.ibSpotMarketDepth = existingIbSpotMarketDepth;
            //$rootScope.ibSpotMarketDepthMemory = existingIbSpotMarketDepth;

            if ($rootScope.ibSpotMarketDepth != null && $rootScope.ibSpotMarketDepth != undefined) {
                // get ibSpotMarketWatch
                var existingIbSpotMarketWatch = $rootScope.ibSpotMarketWatch;
                existingIbSpotMarketWatch = MarketWatch.getIBSpotMarketWatch($rootScope.ibSpotMarketDepth);
                $rootScope.ibSpotMarketWatch = existingIbSpotMarketWatch;
                //$rootScope.ibSpotMarketWatchMemory = existingIbSpotMarketWatch;
            }


            //MarketWatch.getFCYMarketDepth($rootScope.marketDepth);

            MarketWatch.updateFCYMarketWatch($rootScope.fcyMarketDepthArray);

            $rootScope.marketArray = Object.entries($rootScope.marketWatchMap);
            // bank allowed currency only in market depth , sync the data if exist remove from market watch
          //  MarketWatch.syncMarketData();
            // $scope.$apply();
            // }, 100)
        }

        function getSwapQuotes() {

            // if the user is customer user, get spread for the banks in which
            // the customer has relationship with.
            // if the user is bank/branch user, get spread for that particular
            // bank.
            if (vm.account.organisation.organisationType.shortName == 'CLEARCORP') {
                SwapQuotesForTenorDates.getSwapQuotesForAllBanks(onGetSwapQuotesSuccess, onGetSwapQuotesFailure);
            } else if (vm.account.organisation.organisationType.shortName == 'BANK') {
                SwapQuotesForTenorDates.getSwapQuotesForGivenBank({ bankId: vm.account.organisation.id }, onGetSwapQuotesSuccess, onGetSwapQuotesFailure);
            } else if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                SwapQuotesForTenorDates.getSwapQuotesForGivenCustomer({ customerId: vm.account.organisation.id }, onGetSwapQuotesSuccess, onGetSwapQuotesFailure);
            }
        }

        function onGetSwapQuotesSuccess(result) {
            // result will be list of swap quotes for the bank(s)
            // if result length is 1, then that is default bank for that
            // user(customer user) and for bank/branch user, the result length
            // will be 1.
            if (result != null && result != undefined && result.swapQuotesTenorDateDTOList != null && result.swapQuotesTenorDateDTOList != null
                && result.swapQuotesTenorDateDTOList.length > 0) {
                // get bank swap quotes array to display in the bank comparative
                // quotes section
                $rootScope.bankComparativeDTO = result;

                // $rootScope.userMarketWatchList = [{'id' : 1, 'instrument' : 'Instrument 1', 'buyValue': 0, 'sellValue': 0, 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 2, 'instrument' : 'Instrument 2', 'buyValue': '72.313', 'sellValue': '72.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 3, 'instrument' : 'Instrument 3', 'buyValue': '73.313', 'sellValue': '73.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 4, 'instrument' : 'Instrument 4', 'buyValue': '74.313', 'sellValue': '74.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': true, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 5, 'instrument' : 'Instrument 5', 'buyValue': '75.313', 'sellValue': '75.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 6, 'instrument' : 'Instrument 6', 'buyValue': '76.313', 'sellValue': '76.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 7, 'instrument' : 'Instrument 7', 'buyValue': '77.313', 'sellValue': '77.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 8, 'instrument' : 'Instrument 8', 'buyValue': '78.313', 'sellValue': '78.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 9, 'instrument' : 'Instrument 9', 'buyValue': '79.313', 'sellValue': '79.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': true, 'editable': false}
                // 	,{'id' : 10, 'instrument' : 'Instrument 10', 'buyValue': '70.313', 'sellValue': '70.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 11, 'instrument' : 'Instrument 11', 'buyValue': '71.313', 'sellValue': '71.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 12, 'instrument' : 'Instrument 12', 'buyValue': '72.313', 'sellValue': '72.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 13, 'instrument' : 'Instrument 13', 'buyValue': '73.313', 'sellValue': '73.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': true, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 14, 'instrument' : 'Instrument 14', 'buyValue': '74.313', 'sellValue': '74.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 15, 'instrument' : 'Instrument 15', 'buyValue': '75.313', 'sellValue': '75.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 16, 'instrument' : 'Instrument 16', 'buyValue': '76.313', 'sellValue': '76.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': true, 'editable': false}
                // 	,{'id' : 17, 'instrument' : 'Instrument 17', 'buyValue': '77.313', 'sellValue': '77.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 18, 'instrument' : 'Instrument 18', 'buyValue': '78.313', 'sellValue': '78.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 19, 'instrument' : 'Instrument 19', 'buyValue': '79.313', 'sellValue': '79.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}
                // 	,{'id' : 20, 'instrument' : 'Instrument 20', 'buyValue': '70.313', 'sellValue': '70.333', 'settlementDate': '23-Dec-2020', 'isBestBuy': false, 'isBestSell': false, 'editable': false}];


                // fill defatult bank for clearcorp users
                // fillDefaultBankForClearcorpUsers(result);

                // change swap quotes in home page
                prepareSwapQuotes();

            }

            //get user market watch settings list
            UserProfile.getUserMarketWatchSettingsList(onGetUserMarketWatchSuccess, onGetUserMarketWatchFailure);

        }

        function onGetSwapQuotesFailure() {

        }

        function getMarkup() {
            if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                Markup.getAllMarkupForCustomer({ customerId: vm.account.organisation.id }, onGetMarkupSuccess, onGetMarkupFailure);
            }
        }

        function onGetMarkupSuccess(result) {
            if (result.length > 0) {
                $rootScope.markupSettings = result;
            }
        }

        function onGetMarkupFailure() {

        }

        function fillDefaultBankForClearcorpUsers(bankComparativeQuotes) {

            vm.defaultTradingBank = bankComparativeQuotes[0].bank;
            $rootScope.defaultTradingBank = bankComparativeQuotes[0].bank;

            vm.tradingBank = vm.defaultTradingBank;

        }

        function getRetailSpotMarketWatch() {
            var existingSpotMarketWatch = $rootScope.retailSpotMarketWatch;
            // get retailSpot market watch
            existingSpotMarketWatch = MarketWatch.getRetailSpotMarketWatch($rootScope.retailSpotMarketDepth);
            $rootScope.retailSpotMarketWatch = existingSpotMarketWatch;
            //$rootScope.retailSpotMarketWatchMemory = existingSpotMarketWatch;
            // $rootScope.retailSpotMarketWatch.bidPrice = 72.2500;
            // $rootScope.retailSpotMarketWatch.offerPrice = 72.3500;
            // $rootScope.retailSpotMarketWatch.bidVolume = 10000000.00;
            // $rootScope.retailSpotMarketWatch.offerVolume = 12000000.00;
        }

        $rootScope.$on('onChangingBankInSwapQuotes', function (event, result) {
            if ($rootScope.bankFromSwapQuote != null) {
                onChangingBankInSwapQuotes($rootScope.bankFromSwapQuote);
            }
        });

        $rootScope.$on('onChangingBankInMarkup', function (event, result) {
            if ($rootScope.bankFromMarkup != null) {
                onChangingBankInMarkup($rootScope.bankFromMarkup);
            }
        });

        function onChangingBankInMarkup(bankName) {
            BankRegistration.getBankForShortName({ bankName: bankName }, function (result) {
                onChangingBankInSwapQuotes(result);
            });
        }

        function onChangingBankInSwapQuotes(bank) {
            vm.defaultTradingBank = bank;
            $rootScope.defaultTradingBank = bank;
            $timeout(function () {
                if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                    vm.defaultTradingCustomer = vm.globalValues.getCustomer();
                    vm.tradingCustomer = vm.globalValues.getCustomer();
                    $rootScope.defaultTradingCustomer = vm.globalValues.getCustomer();
                }
            }, 100)
            vm.tradingBank = vm.defaultTradingBank;
            //     	if(vm.globalValues.getOrganisation().organisationType.shortName=='CUSTOMER'){
            //     		CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: bank.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
            // 	vm.defaultTradingBranch = result;
            // 	if(vm.orderDTO.activityIndicator!='PLAC'){
            // 		fillDefaultValuesToControls();
            // 	}
            // 	vm.tradingBank = vm.defaultTradingBank;
            // 	vm.bankFilterForPO = bank;
            // 	vm.bankFilterForLimit = bank;
            // 	vm.bankFilterForTrade = bank;
            // 	vm.branchFilterForPO = result;
            // 	vm.branchFilterForLimit = result;
            // 	vm.branchFilterForTrade = result;
            // 	vm.customerFilterForPO = vm.globalValues.getCustomer();
            // 	vm.customerFilterForLimit = vm.globalValues.getCustomer();
            // 	vm.customerFilterForTrade = vm.globalValues.getCustomer();
            // 	$rootScope.bankFilterForPO = bank;
            // 	$rootScope.bankFilterForLimit = bank;
            // 	$rootScope.bankFilterForTrade = bank;
            // 	$rootScope.branchFilterForPO = result;
            // 	$rootScope.branchFilterForLimit = result;
            // 	$rootScope.branchFilterForTrade = result;
            // 	$rootScope.customerFilterForPO = vm.globalValues.getCustomer();
            // 	$rootScope.customerFilterForLimit = vm.globalValues.getCustomer();
            // 	$rootScope.customerFilterForTrade = vm.globalValues.getCustomer();

            // 	vm.bankFilterForOT = bank;
            // 	vm.branchFilterForOT = result;
            // 	vm.customerFilterForOT = vm.globalValues.getCustomer();
            // 	$rootScope.bankFilterForOT = bank;
            // 	$rootScope.branchFilterForOT = result;
            // 	$rootScope.customerFilterForOT = vm.globalValues.getCustomer();

            // 	prepareSwapQuotes();
            // 	getReportsToDisplay();
            // });
            //     	}else if(vm.globalValues.getOrganisation().organisationType.shortName=='CLEARCORP'){
            //     		vm.bankFilterForPO = bank;
            //     		vm.bankFilterForLimit = bank;
            //     		vm.bankFilterForTrade = bank;
            //     		vm.bankFilterForOT = bank;
            //     		vm.tradingBank = bank;
            //     		prepareSwapQuotes();
            //     		$timeout(function(){
            //             	getReportsToDisplay();
            // 			}, 100);
            //     	}
        }

        $scope.$watch('vm.defaultTradingBankControl', function (value) {
            if (vm.account != null && vm.account != undefined) {
                var bank = value;
                vm.defaultTradingBank = bank;
                $rootScope.defaultTradingBank = bank;
                //$timeout(function(){
                if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                    vm.defaultTradingCustomer = vm.globalValues.getCustomer();
                    vm.tradingCustomer = vm.globalValues.getCustomer();
                    $rootScope.defaultTradingCustomer = vm.globalValues.getCustomer();
                }
                //},100)
                if (vm.globalValues.getOrganisation().organisationType.shortName == 'CUSTOMER') {
                    vm.defaultTradingBranch = null;
                    // if (vm.orderDTO.activityIndicator != 'PLAC') {
                    //     fillDefaultValuesToControls();
                    // }
                    vm.tradingBank = vm.defaultTradingBank;
                    vm.bankFilterForPO = bank;
                    vm.bankFilterForLimit = bank;
                    vm.bankFilterForTrade = bank;
                    vm.branchFilterForPO = null;
                    vm.branchFilterForLimit = null;
                    vm.branchFilterForTrade = null;
                    vm.customerFilterForPO = vm.globalValues.getCustomer();
                    vm.customerFilterForLimit = vm.globalValues.getCustomer();
                    vm.customerFilterForTrade = vm.globalValues.getCustomer();
                    $rootScope.bankFilterForPO = bank;
                    $rootScope.bankFilterForLimit = bank;
                    $rootScope.bankFilterForTrade = bank;
                    $rootScope.branchFilterForPO = null;
                    $rootScope.branchFilterForLimit = null;
                    $rootScope.branchFilterForTrade = null;
                    $rootScope.customerFilterForPO = vm.globalValues.getCustomer();
                    $rootScope.customerFilterForLimit = vm.globalValues.getCustomer();
                    $rootScope.customerFilterForTrade = vm.globalValues.getCustomer();

                    vm.bankFilterForOT = bank;
                    vm.branchFilterForOT = null;
                    vm.customerFilterForOT = vm.globalValues.getCustomer();
                    $rootScope.bankFilterForOT = bank;
                    $rootScope.branchFilterForOT = null;
                    $rootScope.customerFilterForOT = vm.globalValues.getCustomer();
                    if (bank != null && bank != undefined) {
                        //CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: bank.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
                        var result = _.filter(angular.copy($rootScope.tradingRelationsForCustomer), function (item) { return item.bank.id == bank.id; });
                        vm.defaultTradingBranch = result[0].tradingBranch;
                        // if (vm.orderDTO.activityIndicator != 'PLAC') {
                        //     fillDefaultValuesToControls();
                        // }
                        vm.branchFilterForPO = result[0].tradingBranch;
                        vm.branchFilterForLimit = result[0].tradingBranch;
                        vm.branchFilterForTrade = result[0].tradingBranch;
                        vm.customerFilterForPO = vm.globalValues.getCustomer();
                        vm.customerFilterForLimit = vm.globalValues.getCustomer();
                        vm.customerFilterForTrade = vm.globalValues.getCustomer();
                        $rootScope.branchFilterForPO = result[0].tradingBranch;
                        $rootScope.branchFilterForLimit = result[0].tradingBranch;
                        $rootScope.branchFilterForTrade = result[0].tradingBranch;
                        $rootScope.customerFilterForPO = vm.globalValues.getCustomer();
                        $rootScope.customerFilterForLimit = vm.globalValues.getCustomer();
                        $rootScope.customerFilterForTrade = vm.globalValues.getCustomer();
                        vm.branchFilterForOT = result[0].tradingBranch;
                        vm.customerFilterForOT = vm.globalValues.getCustomer();
                        $rootScope.branchFilterForOT = result[0].tradingBranch;
                        $rootScope.customerFilterForOT = vm.globalValues.getCustomer();

                        prepareSwapQuotes();
                        getReportsToDisplay();
                        //});
                    } else {
                        if (vm.bootupCompleted) {
                            prepareSwapQuotes();
                            getReportsToDisplay();
                            $rootScope.defaultBankSpread = null;
                        }
                    }
                } else if (vm.globalValues.getOrganisation().organisationType.shortName == 'CLEARCORP') {
                    vm.bankFilterForPO = bank;
                    vm.bankFilterForLimit = bank;
                    vm.bankFilterForTrade = bank;
                    vm.bankFilterForOT = bank;
                    vm.tradingBank = bank;
                    prepareSwapQuotes();
                    if (value != null && value != undefined) {
                        $timeout(function () {
                            getReportsToDisplay();
                        }, 100);
                    }
                }

                //get user market watch settings list
                //UserProfile.getUserMarketWatchSettingsList(onGetUserMarketWatchSuccess, onGetUserMarketWatchFailure);
                prepareUserMarketWatchToDisplay($rootScope.userMarketWatchList);

                if (value == null || value == undefined) {
                    if ($rootScope.userMarketWatchList != null && $rootScope.userMarketWatchList != undefined && $rootScope.userMarketWatchList.length > 0) {
                        if ($rootScope.userMarketWatchList[0] != null && $rootScope.userMarketWatchList[0] != undefined && $rootScope.userMarketWatchList[0].sessionStatus != null && $rootScope.userMarketWatchList[0].sessionStatus == 'OPEN') {
                            prepareOutrightComparision($rootScope.userMarketWatchList[0].settlementDate, $rootScope.userMarketWatchList[0].instrument);
                        } else if ($rootScope.userMarketWatchList[1] != null && $rootScope.userMarketWatchList[1] != undefined && $rootScope.userMarketWatchList[1].sessionStatus != null && $rootScope.userMarketWatchList[1].sessionStatus == 'OPEN') {
                            prepareOutrightComparision($rootScope.userMarketWatchList[1].settlementDate, $rootScope.userMarketWatchList[1].instrument);
                        }
                    }
                }
            }
        })

        function prepareSwapQuotes() {

            // get best offer and bid spread for both Cash/spot and tom/spot.
            getBestSpreadRates($rootScope.bankComparativeDTO);

            // prepare bank comparativeQuotes in price
            //prepareBankComparativeQuotesInPrice($rootScope.bankComparativeDTO, $rootScope.retailSpotMarketWatch);

            if ($rootScope.bankComparativeDTO != null && $rootScope.bankComparativeDTO != undefined
                && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList != null
                && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList.length == 1) {
                $rootScope.defaultBankSpread = $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList[0].swapQuotesForTenorDatesList;
            } else {
                // get default bank swap quotes for the customer user
                console.log('prepare swap quotes in home controller');
                console.log(vm.defaultTradingBank);
                if (vm.defaultTradingBank != null && vm.defaultTradingBank != undefined && $rootScope.bankComparativeDTO != null && $rootScope.bankComparativeDTO != undefined
                    && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList != null
                    && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList.length > 0) {
                    $rootScope.defaultBankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, vm.defaultTradingBank.id);
                }
            }
            /*if($rootScope.bankComparativeQuotes.length==1){
                $rootScope.defaultBankSpread = $rootScope.bankComparativeQuotes[0];
            }else{
                // get default bank swap quotes for the customer user
                console.log('prepare swap quotes in home controller');
                console.log(vm.defaultTradingBank);
                if(vm.defaultTradingBank!=null && vm.defaultTradingBank!=undefined){
                    $rootScope.defaultBankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeQuotes, vm.defaultTradingBank.id);
                }
            }
            if($rootScope.defaultBankSpread!=null && $rootScope.defaultBankSpread!=undefined){
                // get cash and tom market watch
                getCashAndTomMarketWatch($rootScope.retailSpotMarketWatch, $rootScope.defaultBankSpread);
            }*/
        }

        function prepareBankComparativeQuotesInPrice(bankComparativeDTO, retailSpotMarketWatch) {
            console.log('compute swap quote in price start - ' + $filter('date')(new Date(), 'yyyy-MM-ddTHH:mm:ss.sssZ'));
            if (bankComparativeDTO != null && bankComparativeDTO != undefined) {
                $rootScope.bankComparativeDTOInPrice = {};
                $rootScope.bankComparativeDTOInPrice.header = bankComparativeDTO.header;
                $rootScope.bankComparativeDTOInPrice.swapQuotesTenorDateDTOList = [];
                angular.forEach(bankComparativeDTO.swapQuotesTenorDateDTOList, function (swapQuotesTenorDateDTO) {
                    var swapQuotesTenorDateDTOInPrice = {};
                    swapQuotesTenorDateDTOInPrice.bank = swapQuotesTenorDateDTO.bank;
                    swapQuotesTenorDateDTOInPrice.businessDate = swapQuotesTenorDateDTO.businessDate;
                    swapQuotesTenorDateDTOInPrice.swapQuotesForTenorDatesList = [];
                    angular.forEach(swapQuotesTenorDateDTO.swapQuotesForTenorDatesList, function (swapQuotesForTenorDates) {
                        var swapQuotesForTenorDatesInPrice = {};
                        swapQuotesForTenorDatesInPrice = angular.copy(swapQuotesForTenorDates);
                        // prepare bank quotes in price
                        swapQuotesForTenorDatesInPrice = MarketWatch.getBankSwapQuotesInPrice(swapQuotesForTenorDatesInPrice, retailSpotMarketWatch);
                        swapQuotesTenorDateDTOInPrice.swapQuotesForTenorDatesList.push(swapQuotesForTenorDatesInPrice)
                    })
                    $rootScope.bankComparativeDTOInPrice.swapQuotesTenorDateDTOList.push(swapQuotesTenorDateDTOInPrice);
                })
                //$rootScope.bankComparativeDTOInPriceMemory = $rootScope.bankComparativeDTOInPrice;
            }
            console.log('compute swap quote in price end - ' + $filter('date')(new Date(), 'yyyy-MM-ddTHH:mm:ss.sssZ'));
        }

        function getBestSpreadRates(bankComparativeDTO) {

            if (bankComparativeDTO != null && bankComparativeDTO != undefined && bankComparativeDTO.swapQuotesTenorDateDTOList != null
                && bankComparativeDTO.swapQuotesTenorDateDTOList.length > 0) {
                var swapQuotesForTenorDatesList = [];
                angular.forEach(bankComparativeDTO.swapQuotesTenorDateDTOList, function (swapQuotesTenorDateDTO) {
                    swapQuotesForTenorDatesList = swapQuotesForTenorDatesList.concat(swapQuotesTenorDateDTO.swapQuotesForTenorDatesList);
                })

                $rootScope.bestBankQuoteList = [];
                angular.forEach(bankComparativeDTO.header, function (header) {
                    var bestBankQuote = {};
                    bestBankQuote.tenorName = header;
                    var bankQuotesForTenorForBid = _.filter(angular.copy(swapQuotesForTenorDatesList), { 'tenorName': header });
                    var bankQuotesForTenorForOffer = _.filter(angular.copy(swapQuotesForTenorDatesList), { 'tenorName': header });
                    bestBankQuote.bestBidSpread = Math.max.apply(Math, bankQuotesForTenorForBid.map(function (item) { return item.bidSpread; }).filter(function (val) { return val !== null }));
                    bestBankQuote.bestOfferSpread = Math.min.apply(Math, bankQuotesForTenorForOffer.map(function (item) { return item.offerSpread; }).filter(function (val) { return val !== null }));
                    $rootScope.bestBankQuoteList.push(bestBankQuote);
                })
            }

            if ($rootScope.bankComparativeDTO != null && $rootScope.bankComparativeDTO != undefined) {
                angular.forEach($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, function (swapQuotesTenorDateDTO) {
                    angular.forEach(swapQuotesTenorDateDTO.swapQuotesForTenorDatesList, function (swapQuotesForTenorDates) {
                        swapQuotesForTenorDates.isBestBid = false;
                        swapQuotesForTenorDates.isBestOffer = false;
                        angular.forEach($rootScope.bestBankQuoteList, function (bestBankQuote) {
                            if (swapQuotesForTenorDates.tenorName == bestBankQuote.tenorName) {
                                if (swapQuotesForTenorDates.bidSpread == bestBankQuote.bestBidSpread) {
                                    swapQuotesForTenorDates.isBestBid = true;
                                }
                                if (swapQuotesForTenorDates.offerSpread == bestBankQuote.bestOfferSpread) {
                                    swapQuotesForTenorDates.isBestOffer = true;
                                }
                            }
                        })
                    })
                })
            }
        }

        function getCashAndTomMarketWatch(spotMarketWatch, bankSpread) {
            $rootScope.cashMarketWatch = MarketWatch.getMarketWatchForGivenInstrument(spotMarketWatch, bankSpread, 'CASH');
            $rootScope.tomMarketWatch = MarketWatch.getMarketWatchForGivenInstrument(spotMarketWatch, bankSpread, 'TOM');
        }

        // clear numeric controls
        function clearNumericControls() {
            //setFieldValues("txtlimitorderprice", "");
            // setFieldValues("txtlimitorderprice",
            // $filter('number')($rootScope.tickerPrice.retailSpot,4));
            setFieldValues("txtsltriggerprice", "");
            //setFieldValues("txtsllimitprice", "");
            setFieldValues("txttptriggerprice", "");
            //setFieldValues("txttplimitprice", "");
            //setFieldValues("txtsellbuyslbuylimitprice", "");
            setFieldValues("txtsellbuyslbuytriggerprice", "");
            //setFieldValues("txtsellbuyslselllimitprice", "");
            setFieldValues("txtsellbuyslselltriggerprice", "");
            //setFieldValues("txtsellbuytpbuylimitprice", "");
            setFieldValues("txtsellbuytpbuytriggerprice", "");
            //setFieldValues("txtsellbuytpselllimitprice", "");
            setFieldValues("txtsellbuytpselltriggerprice", "");
            //setFieldValues("txtsellbuylimitbuyorderprice", "");
            // setFieldValues("txtsellbuylimitbuyorderprice",
            // $filter('number')($rootScope.tickerPrice.retailSpot,4));
            //setFieldValues("txtsellbuylimitsellorderprice", "");
            // setFieldValues("txtsellbuylimitsellorderprice",
            // $filter('number')($rootScope.tickerPrice.retailSpot,4));
        }


        function setFieldValues(fieldName, value) {
            if (document.getElementById(fieldName) != null && document.getElementById(fieldName) != undefined) {
                // document.getElementById(fieldName).focus=true;
                document.getElementById(fieldName).value = value;
                // document.getElementById(fieldName).blur=true;
            }
        }

        $scope.$watch('loadBoardInstrumentCode', function (value1) {
            if ($rootScope.orderDTO != null && $rootScope.orderDTO != undefined && $rootScope.orderDTO.activityIndicator == 'PLAC' && ($rootScope.orderDTO.contractCancellation == false || $rootScope.orderDTO.contractCancellation == undefined)) {
                angular.forEach(vm.instrumentTypes, function (value) {
                    if (value.instrumentCode == value1 && value.instrumentCode == $rootScope.loadBoardInstrumentCode) {
                        // vm.instrumentFilterForPO = value;
                        // vm.instrumentFilterForTrade = value;
                        // vm.instrumentFilterForLimit = value
                        // vm.instrumentFilterForOT = value;;
                        // $rootScope.instrumentFilterForPO = value;
                        // $rootScope.instrumentFilterForTrade = value;
                        // $rootScope.instrumentFilterForLimit = value;
                        // $rootScope.instrumentFilterForOT = value;
                        vm.selectedInstrument = value;
                        vm.updateDefaultInstrumentDetails(value.instrumentCode);
                       // vm.defaultInstrumentId = value.id;
                       // vm.defaultInstrumentCode = value.code;
                        //vm.defaultInstrumentTokenSequenceNo = value.tokenSequenceNo;
                        // change report details according to load board instrument
                        //getReportDetailsForSelectedInstrument("");
                    }
                })
            }
        })

        function changeInstrument(instrumentCode) {
            $rootScope.loadBoardInstrumentCode = instrumentCode;
            if ($rootScope.orderDTO != null && $rootScope.orderDTO != undefined && $rootScope.orderDTO.activityIndicator == 'PLAC' && ($rootScope.orderDTO.contractCancellation == false || $rootScope.orderDTO.contractCancellation == undefined)) {
                // vm.instrumentFilterForPO = instrumentCode;
                selectInstrumentInOrderEntry(instrumentCode);
            }
        }

        /**
         * change the mode of currency
         * usd or fcy
         * @param {*} currencyPair
         */

function changeCurrencyPair(currencyPair) {
                        if (currencyPair !== "USD") {
        vm.isOtherCurrencyEnable = false;
    }


    $rootScope.loadBoardCurrency = currencyPair;

     $rootScope.outstandingTrades = [];
    $rootScope.pendingOrder = [];
    $rootScope.trades = [];

    StaticLookUp.getLimitType(limitTypeSuccess, limitTypeFailure);

    // make some time delay fetch the reports
//      $timeout(function() {

//  }, 500);


}


function limitTypeSuccess(result){

         getReportsToDisplay();
          $rootScope.enableOtherCurrencyTab = ($rootScope.loadBoardCurrency !== "USD");
}

function limitTypeFailure(){

}

// $scope.$watch('loadBoardInstrumentCode', function (value1) {


//     // ✅ Set value first — outside async
//     vm.currencyPair = angular.copy(
//         currencyPair !== "USD"
//             ? $rootScope.currencyPairList[2]
//             : $rootScope.currencyPairList[0]
//     );

//     console.log("instrument on currency tab ", vm.defaultInstrumentCode);
//     console.log("data", vm.currencyPair);
//     console.log("currency pair ", $rootScope.enableOtherCurrencyTab);

//     // ✅ Then trigger digest — so other methods get updated value
//    // $timeout(function() {
//         setSelectedCurrecy(vm.currencyPair.id);
//    // }, 500);

// });






        function selectInstrumentInOrderEntry(instrumentCode) {
            if (instrumentCode == 'SPOT') {
                setTimeout(function () { document.getElementById('spotInstrument').click() });
            } else if (instrumentCode == 'CASH') {
                setTimeout(function () { document.getElementById('cashInstrument').click() });
                // document.getElementById('cashInstrument').click();
            } else if (instrumentCode == 'TOM') {
                setTimeout(function () { document.getElementById('tomInstrument').click() });
                // document.getElementById('tomInstrument').click();
            } else if (instrumentCode == 'Forward') {
                setTimeout(function () { document.getElementById('forwardInstrument').click() });
                // document.getElementById('forwardInstrument').click();
            }
        }

        function selectTimeConditionInOrderEntry(timeCondition) {
            if (timeCondition == 'DAYY') {
                setTimeout(function () { document.getElementById('dayTimeCondition').click() });
            } else if (timeCondition == 'IOCC') {
                setTimeout(function () { document.getElementById('iocTimeCondition').click() });
            } else if (timeCondition == 'GTTM') {
                setTimeout(function () { document.getElementById('gttTimeCondition').click() });
            }
        }

        function changeDefaultPriceCondition(priceCondition) {
            vm.defaultPriceCondition = priceCondition;
        }

        function onCashMarketWatchSuccess(result) {
            vm.cashMarketWacth = result;
        }

        function onTomMarketWatchSuccess(result) {
            vm.tomMarketWacth = result;
        }

        function onTomMarketWatchFailure() {

        }

        function fillZeroIfLimitIsNotDefinedForInstrumentCode(instrumentCode) {
            if (instrumentCode == 'SPOT') {
                $rootScope.retailSpotBuyLimit = 0;
                $rootScope.retailSpotSellLimit = 0;
            } else if (instrumentCode == 'CASH') {
                $rootScope.cashBuyLimit = 0;
                $rootScope.cashSellLimit = 0;
            } else if (instrumentCode == 'TOM') {
                $rootScope.tomBuyLimit = 0;
                $rootScope.tomSellLimit = 0;
            } else if (instrumentCode == 'Forward') {
                $rootScope.forwardBuyLimit = 0;
                $rootScope.forwardSellLimit = 0;
                $rootScope.forwardBuyLimitWithCF = 0;
                $rootScope.forwardSellLimitWithCF = 0;
                $rootScope.maxForwardTenorDate = null;
            } else if (instrumentCode == 'ALL') {
                $rootScope.retailSpotBuyLimit = 0;
                $rootScope.retailSpotSellLimit = 0;
                $rootScope.cashBuyLimit = 0;
                $rootScope.cashSellLimit = 0;
                $rootScope.tomBuyLimit = 0;
                $rootScope.tomSellLimit = 0;
                $rootScope.forwardBuyLimit = 0;
                $rootScope.forwardSellLimit = 0;
                $rootScope.forwardBuyLimitWithCF = 0;
                $rootScope.forwardSellLimitWithCF = 0;
                $rootScope.maxForwardTenorDate = null;
            } else if (instrumentCode == 'UPTOSPOT') {
                $rootScope.retailSpotBuyLimit = 0;
                $rootScope.retailSpotSellLimit = 0;
                $rootScope.cashBuyLimit = 0;
                $rootScope.cashSellLimit = 0;
                $rootScope.tomBuyLimit = 0;
                $rootScope.tomSellLimit = 0;
            }
        }

        function getPendingOrdersReport() {
            vm.clickedReport = true;
            var instrumentTypeId = 0;
            if (vm.instrumentFilterForPO != null && vm.instrumentFilterForPO != undefined) {
                instrumentTypeId = vm.instrumentFilterForPO.id;
                vm.pendingOrderInstrumentCode = 'ALL';
            }

            getPendingOrderReportForInstrument(instrumentTypeId);
            resetPendingOrderCheckboxSelection(false);
        }

        function getTradesReport() {
            vm.clickedReport = true;
            var instrumentTypeId = 0;
            if (vm.instrumentFilterForTrade != null && vm.instrumentFilterForTrade != undefined) {
                instrumentTypeId = vm.instrumentFilterForTrade.id;
                vm.tradeInstrumentCode = 'ALL';
            }

            getTradesReportForInstrument(instrumentTypeId);
        }

        function getLimitUtilisedReport() {
            vm.clickedReport = true;
            var instrumentTypeId = 0;
            if (vm.instrumentFilterForLimit != null && vm.instrumentFilterForLimit != undefined) {
                instrumentTypeId = vm.instrumentFilterForLimit.id;
                vm.limitInstrumentCode = 'ALL';
            }

            getLimitUtilisedReportForInstrument(instrumentTypeId);

        }

        vm.getOutstandingTradesReport = getOutstandingTradesReport;
        function getOutstandingTradesReport() {
            vm.clickedReport = true;
            var instrumentTypeId = 0;
            if (vm.instrumentFilterForOT != null && vm.instrumentFilterForOT != undefined) {
                instrumentTypeId = vm.instrumentFilterForOT.id;
            }

            if (validateTradesOutstandingDates($rootScope.fromSettlementDate, $rootScope.toSettlementDate)) {
                getOutstandingTradeReportForInstrument(instrumentTypeId);
            } else {
                MessageBox.openMessageBox("Alert", "From date cannot be greater than the To date.", "Ok", "homepage");
            }
        }

        // place market order - not used
        function placeMarketOrder(buySellFlag, orderVolume, instrumentType, instrumentId, limitExcahngeRate) {
            vm.errorString = '';
            var orderDTO = {};
            orderDTO.typeOfOrder = 'LIMT';
            orderDTO.activityIndicator = 'PLAC';
            orderDTO.instrumentCode = instrumentType;
            orderDTO.buySellIndicator = buySellFlag;
            orderDTO.orderAmount = parseFloat(orderVolume.replace(/,/g, ''));
            orderDTO.instrumentId = instrumentId;
            orderDTO.timeLimitIndicator = 'IOCC';
            orderDTO.expiryTime = 0;

            // fill bank, branch, customer details into order request dto
            fillBankBranchCustomerDetailsFromMktWatch(orderDTO)
            fillDefaultInstIdForInstCode(vm.defaultInstrumentCode);
            if (vm.account.organisation.organisationType.shortName != 'CUSTOMER') {
                if (vm.defaultTradingCustomerControl != null && vm.defaultTradingCustomerControl != undefined) {
                    orderDTO.customerId = vm.defaultTradingCustomerControl.id;
                    orderDTO.customerName = vm.defaultTradingCustomerControl.customerFirstName;
                    orderDTO.customerCode = vm.defaultTradingCustomerControl.customerCode;
                } else {
                    // MessageBox.openMessageBox("Alert", "Please select the
                    // trading customer to proceed.", "Ok",
                    // "selectdefaultcustomer");
                }
            }

            // vm.orderDTO.customerName =
            // vm.globalValues.getCustomer().customerFirstName;
            orderDTO.userId = vm.globalValues.getUserId();
            orderDTO.retailUserCode = vm.globalValues.getUser().login;
            orderDTO.userEntityOwnerId = vm.globalValues.getEntityOwnerTypeId();
            var valuelimitExchangeRate = angular.copy(vm.orderDTO.limitExchangeRate);
            var valueStopExchangeRate = angular.copy(vm.orderDTO.stopExchangeRate);
            vm.orderDTO.limitExchangeRate = angular.copy(limitExcahngeRate);
            orderDTO.limitExchangeRate = angular.copy(limitExcahngeRate);
            orderDTO.limitExchangeRate = $filter('number')(orderDTO.limitExchangeRate, vm.noOfDecimalsForRate);
            vm.orderDTO.stopExchangeRate = 0;
            orderDTO.stopExchangeRate = 0;

            var selectedBankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, vm.tradingBank.id);
            vm.orderDTO.spreadUsed = getSpreadUsed(selectedBankSpread, buySellFlag, instrumentType);
            vm.orderDTO.currencyPairCode = vm.currencyPair.code;
            vm.orderDTO.currencyPairId = vm.currencyPair.id;
            vm.orderDTO.currencyPair = vm.currencyPair.code;
            // set rootscope variables to access soft check confirmation if
            // value exceeds soft check validation
            $rootScope.buySellFlagForOrder = angular.copy(buySellFlag);
            $rootScope.defaultPriceConditionForOrder = angular.copy(vm.defaultPriceCondition);
            $rootScope.tradingBankForOrder = angular.copy(vm.tradingBank);
            $rootScope.tradingBranchForOrder = angular.copy(vm.tradingBranch);
            $rootScope.defaultInstrumentCodeForOrder = angular.copy(instrumentType);
            $rootScope.defaultInstrumentTokenSequenceNo = fillDefaultInstIdForInstCode(instrumentType);
            $rootScope.activityIndicatorForOrder = angular.copy(vm.activityIndicator);
            $rootScope.orderDTOForOrder = angular.copy(orderDTO);
            $rootScope.tradingCustomerForOrder = angular.copy(vm.tradingCustomer);
            $rootScope.tickSizeForOrder = angular.copy($rootScope.tickSize);
            $rootScope.userPreferenceForOrder = angular.copy(vm.userPreference);
            $rootScope.executeOrderFromMktWatch = true;
            $rootScope.configurationSettingsForOrder = vm.configSettings;
            $rootScope.transactionParametersSettingsForOrder = angular.copy(vm.transactionParametersSettings);
            $rootScope.noOfDecimalsForRateForOrder = angular.copy(vm.noOfDecimalsForRate);
            $rootScope.noOfDecimalsForAmountForOrder = angular.copy(vm.noOfDecimalsForAmount);
            $rootScope.noOfDecimalsForPercentForOrder = angular.copy(vm.noOfDecimalsForPercent);
            $rootScope.currencyPairForOrder = angular.copy(vm.currencyPair);
            //$rootScope.sourceApp = 'FXRETAIL';
            // $rootScope.remarksForOrder = angular.copy(vm.remarks);
            $rootScope.remarksForOrder1 = angular.copy(vm.remarks1);
            $rootScope.remarksForOrder2 = angular.copy(vm.remarks2);
            $rootScope.remarksForOrder3 = angular.copy(vm.remarks3);
            $rootScope.remarksForOrder4 = angular.copy(vm.remarks4);
            $rootScope.clickedForOrder = angular.copy(vm.clicked);

            if (validateLimitAvailability(buySellFlag, orderDTO.typeOfOrder, orderDTO.activityIndicator, instrumentType, orderDTO.orderAmount, 0, orderDTO.eventType, vm.tradeSettlementDate, orderDTO)) {
                var validateOrderAmount = OrderUtil.validateOrderAmount(vm.orderDTO.orderAmount);
                if (validateOrderAmount.isValid) {
                    if (validateOrderAmountSoftCheck(orderDTO.orderAmount)) {
                        if (validateOrder(buySellFlag, orderDTO.typeOfOrder, selectedBankSpread, instrumentType, orderDTO.activityIndicator, orderDTO.orderAmount, 0, $rootScope.defaultInstrumentTokenSequenceNo) && validateMarketOrder()) {
                            if (vm.userPreference.showPreOrderConfirmation == 'yes' || vm.globalValues.getSessionTimedOut()) {
                                $rootScope.orderDTO = orderDTO;
                                $state.go('pre-order-confirmation', { closeTime: '', showPreOrderConfirmation: vm.userPreference.showPreOrderConfirmation, sessionTimedOut: vm.globalValues.getSessionTimedOut() });
                            } else {
                                // send order request to server
                                //on 18-Nov-2020. db writer null issue - added call back procedures while sending orders
                                sendNewOrder(orderDTO);
                            }
                            /*
                              * $timeout(function(){
                              * vm.orderDTO.limitExchangeRate =
                              * valuelimitExchangeRate;
                              * vm.orderDTO.stopExchangeRate =
                              * valueStopExchangeRate; },100)
                              */
                            resetPendingOrderCheckboxSelection(false);
                            resetTradesOutstandingCheckboxSelection();
                            defaultOrderEntry();
                            // remove foucs on order entry screen
                            removeOrderEntryFocus();
                            // clear numeric controls
                            clearNumericControls();

                            removeFocusFromMarketWatch();

                        } else {
                            vm.clicked = false;
                            MessageBox.openMessageBox("Alert", vm.errorString, "Ok", "homepage");
                        }
                    } else {
                        $rootScope.orderExecutedForAmountSoftCheck = false;
                        var userMaxSoftCheck = null;
                        if ($rootScope.currencyWiseUserPreferenceSettings) {
                            var pref = $rootScope.currencyWiseUserPreferenceSettings[vm.currencyPair.id];
                            if (pref) {
                                userMaxSoftCheck = pref.maximumOrderValueSoftCheck;
                            }
                        }
                        MessageBox.openAlertMessageBox("Alert", 'Order quantity exceeds the maximum order value soft check </br> <span class="softcheck-value"> (' + vm.currencyPair.baseCurrency.code + ' ' + $filter('number')(userMaxSoftCheck, vm.noOfDecimalsForAmount) + ')</span>  in “My preference” setting.</br> Do you want to proceed anyway?', "YesNo", "continueorderamountsoftcheck");
                    }
                } else {
                    vm.clicked = false;
                    MessageBox.openAlertMessageBox("Alert", validateOrderAmount.errorString, "Ok", "homepage", "Quantity Alert", "danger");
                }
            } else {
                vm.clicked = false;
                MessageBox.openMessageBox("Alert", vm.errorString, "Ok", "homepage");
            }
        }

        $rootScope.$on('gatewayApp.messagebox.ok.orderrequestfailure', function (event, data) {
            vm.clicked = false;
        });

        $rootScope.$on('gatewayApp.messagebox.clear.orderrequestfailure', function (event, data) {
            vm.clicked = false;
        });

        function placeOrderForRollover() {
            LimitSettings.checkIsExistingTradeConsumesLimit(vm.orderDTO, function (result) {
                vm.orderDTO.isExistingTradeConsumesLimit = result.checkIsExistingTradeConsumesLimit;

                //place order
                placeOrder();
            })
        }

        // place/modify/cancel order
        function placeOrder() {

            console.log("value",vm.currencyPairUSD);
            console.log("place value",vm.currencyPair);
            vm.clicked = true;
            vm.buySellFlag = '';
            vm.activityIndicator = '';
            vm.errorString = '';
            vm.currencyPairId = vm.currencyPair.id;
            vm.currencyPairCode = vm.currencyPair.code;
            vm.orderDTO.currencyPairId = vm.currencyPair.id;
            vm.orderDTO.currencyPairCode = vm.currencyPair.code;
            fillDefaultInstIdForInstCode(vm.defaultInstrumentCode);
            setBuySellFlagAndActivityIndicator();
            if (vm.orderDTO.contractCancellation != null && vm.orderDTO.contractCancellation != undefined && vm.orderDTO.contractCancellation == true) {
                var eventType = {};
                //if contract cancellation order is modified or cancelled, event type is filled as contract cancellation
                if (vm.orderDTO.activityIndicator == 'TRAD' || vm.orderDTO.activityIndicator == 'MDFY' || vm.orderDTO.activityIndicator == 'CNCL') {
                    eventType = getEventTypeForShortName('ContractCancellation');
                } else if (vm.orderDTO.activityIndicator == 'ROLL') {
                    eventType = getEventTypeForShortName('Rollover');
                } else if (vm.orderDTO.activityIndicator == 'EARL') {
                    eventType = getEventTypeForShortName('EarlyDelivery');
                }
                vm.orderDTO.eventTypeId = eventType.id;
                vm.orderDTO.eventType = eventType.shortName;
            } else {
                var eventType = getEventTypeForShortName('Booking');
                vm.orderDTO.eventTypeId = eventType.id;
                vm.orderDTO.eventType = eventType.shortName;
                vm.orderDTO.settlementLegId = null;
            }
            setOptionPeriodForPlaceOrder();
            // set rootscope variables to access soft check confirmation if
            // value exceeds soft check validation
            $rootScope.buySellFlagForOrder = angular.copy(vm.buySellFlag);
            $rootScope.defaultPriceConditionForOrder = angular.copy(vm.defaultPriceCondition);
            $rootScope.tradingBankForOrder = angular.copy(vm.tradingBank);
            $rootScope.tradingBranchForOrder = angular.copy(vm.tradingBranch);
            $rootScope.defaultInstrumentCodeForOrder = angular.copy(vm.defaultInstrumentCode);
            $rootScope.defaultInstrumentTokenSequenceNumberForOrder = angular.copy(vm.defaultInstrumentTokenSequenceNo);
            $rootScope.activityIndicatorForOrder = angular.copy(vm.activityIndicator);
            $rootScope.orderDTOForOrder = angular.copy(vm.orderDTO);
            $rootScope.tradingCustomerForOrder = angular.copy(vm.tradingCustomer);
            $rootScope.tickSizeForOrder = angular.copy($rootScope.tickSize);
            $rootScope.userPreferenceForOrder = angular.copy(vm.userPreference);
            $rootScope.executeOrderFromMktWatch = false;
            $rootScope.configurationSettingsForOrder = angular.copy(vm.configSettings);
            $rootScope.transactionParametersSettingsForOrder = angular.copy(vm.transactionParametersSettings);
            $rootScope.defaultTimeConditionForOrder = angular.copy(vm.defaultTimeCondition);
            $rootScope.activityIndicatorForOrder = angular.copy(vm.activityIndicator);
            $rootScope.noOfDecimalsForRateForOrder = angular.copy(vm.noOfDecimalsForRate);
            $rootScope.noOfDecimalsForAmountForOrder = angular.copy(vm.noOfDecimalsForAmount);
            $rootScope.noOfDecimalsForPercentForOrder = angular.copy(vm.noOfDecimalsForPercent);
            $rootScope.defaultInstrumentIdForOrder = angular.copy(vm.defaultInstrumentId);
            $rootScope.tradeSettlementDateFororder = angular.copy(vm.tradeSettlementDate);
            $rootScope.currencyPairForOrder = angular.copy(vm.currencyPair);
            //$rootScope.remarksForOrder = angular.copy(vm.remarks);
            //$rootScope.sourceApp = 'FXRETAIL';
            $rootScope.remarksForOrder1 = angular.copy(vm.remarks1);
            $rootScope.remarksForOrder2 = angular.copy(vm.remarks2);
            $rootScope.remarksForOrder3 = angular.copy(vm.remarks3);
            $rootScope.remarksForOrder4 = angular.copy(vm.remarks4);
            $rootScope.clickedForOrder = angular.copy(vm.clicked);
            $rootScope.account = angular.copy(vm.account);
            $rootScope.instrumentTypesForOrder = angular.copy(vm.instrumentTypes);
            $rootScope.exposureTypeForOrder = angular.copy(vm.exposureType);
            $rootScope.exposureSubTypeForOrder = angular.copy(vm.exposureSubType);
            $rootScope.noOfSplit = angular.copy(vm.noOfSplits);

            var valuelimitExchangeRate = angular.copy(vm.orderDTO.limitExchangeRate);
            var valueStopExchangeRate = angular.copy(vm.orderDTO.stopExchangeRate);
            var selectedBankSpread = null;
            if ($rootScope.bankComparativeDTO != null && $rootScope.bankComparativeDTO != undefined
                && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList != null && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList != undefined
                && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList.length > 0) {
                selectedBankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, vm.tradingBank.id);
            }
            var validateOptionStartSettlementDate = OrderUtil.validateOptionSettlementDate(vm.defaultInstrumentCode, vm.orderDTO.isOptionPeriod, vm.tradeSettlementDateFrom, 'Start');
            var validateOptionEndSettlementDate = OrderUtil.validateOptionSettlementDate(vm.defaultInstrumentCode, vm.orderDTO.isOptionPeriod, vm.tradeSettlementDate, 'End');
            var validateOptionPeriods = OrderUtil.validateOptionPeriods(vm.defaultInstrumentCode, vm.orderDTO.isOptionPeriod, vm.tradeSettlementDateFrom, vm.tradeSettlementDate);
            if (validateOptionStartSettlementDate.isValid && validateOptionEndSettlementDate.isValid && validateOptionPeriods.isValid) {

                if (validateSession(vm.defaultInstrumentCode, vm.defaultPriceCondition, vm.defaultInstrumentTokenSequenceNo) && validateCancellationLegSessionStatus(vm.activityIndicator, vm.orderDTO.cancelledLegInstrumentCode)) {
                    if (validateLimitAvailability(vm.buySellFlag, vm.defaultPriceCondition, vm.activityIndicator, vm.defaultInstrumentCode, vm.orderDTO.orderAmount, vm.orderDTO.oldOrderAmount, vm.orderDTO.eventType, vm.tradeSettlementDate, vm.orderDTO)) {
                        var validateOrderAmount = OrderUtil.validateOrderAmount(vm.orderDTO.orderAmount);
                        if (validateOrderAmount.isValid) {
                            if (validateOrderAmountSoftCheck(vm.orderDTO.orderAmount)) {
                                var validateLimitExchangeRateHardCheck = OrderUtil.validateLimitExchangeRateHardCheck(vm.buySellFlag, vm.defaultPriceCondition, selectedBankSpread, vm.defaultInstrumentCode, vm.activityIndicator, vm.orderDTO.orderAmount, vm.orderDTO.oldOrderAmount, vm.orderDTO.limitExchangeRate, vm.orderDTO.limitExchangeRateInSpot, vm.orderDTO.buyLimitExchangeRate, vm.orderDTO.buyLimitExchangeRateInSpot, vm.orderDTO.sellLimitExchangeRate, vm.orderDTO.sellLimitExchangeRateInSpot, vm.currencyPair.code, vm.currencyPair.id,vm.defaultInstrumentTokenSequenceNo);
                                if (validateLimitExchangeRateHardCheck.isValid) {
                                    if (validateLimitExchangeRateSoftCheck(vm.buySellFlag)) {
                                        if (!splitTheOrderQuntity()) {
                                            executeOrder();
                                        } else {
                                            vm.clicked = false;
                                            MessageBox.openMessageBox("Alert", "Orders should be Split evenly", "Ok", "homepage");
                                        }
                                    } else {
                                        $rootScope.orderExecuted = false;
                                        MessageBox.openAlertMessageBox("Alert", vm.limitPriceDeviationWarning, "YesNo", "continueorderpricesoftcheck", "Price Alert", "warning");
                                    }
                                } else {
                                    vm.clicked = false;
                                    MessageBox.openAlertMessageBox("Alert", validateLimitExchangeRateHardCheck.errorString, "Ok", "homepage", "Price Alert", "danger");
                                }
                            } else {
                                $rootScope.orderExecutedForAmountSoftCheck = false;
                            }
                        } else {
                            vm.clicked = false;
                            MessageBox.openAlertMessageBox("Alert", validateOrderAmount.errorString, "Ok", "homepage", "Quantity Alert", "danger");
                        }
                    } else {
                        vm.clicked = false;
                        MessageBox.openMessageBox("Alert", vm.errorString, "Ok", "homepage");
                    }
                } else {
                    vm.clicked = false;
                    MessageBox.openMessageBox("Alert", vm.errorString, "Ok", "homepage");
                }
            } else {
                vm.clicked = false;
                if (!validateOptionStartSettlementDate.isValid)
                    MessageBox.openMessageBox("Alert", validateOptionStartSettlementDate.errorString, "Ok", "homepage");
                else if (!validateOptionEndSettlementDate.isValid)
                    MessageBox.openMessageBox("Alert", validateOptionEndSettlementDate.errorString, "Ok", "homepage");
                else
                    MessageBox.openMessageBox("Alert", validateOptionPeriods.errorString, "Ok", "homepage");
            }
        }

        function executeOrder() {
            var valuelimitExchangeRate = angular.copy($rootScope.orderDTOForOrder.limitExchangeRate);
            var valueStopExchangeRate = angular.copy($rootScope.orderDTOForOrder.stopExchangeRate);
            var selectedBankSpread = null;
            if ($rootScope.bankComparativeDTO != null && $rootScope.bankComparativeDTO != undefined
                && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList != null && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList != undefined
                && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList.length > 0) {
                selectedBankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, $rootScope.tradingBankForOrder.id);

            }
            //var selectedBankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, $rootScope.tradingBankForOrder.id);
            if (validateOrder(vm.buySellFlag, vm.defaultPriceCondition, selectedBankSpread, vm.defaultInstrumentCode, vm.activityIndicator, vm.orderDTO.orderAmount, vm.orderDTO.oldOrderAmount)) {
                if (vm.activityIndicator == 'MDFY' && vm.defaultPriceCondition == 'MRKT') {
                    vm.defaultPriceCondition = 'LIMT';
                }
                if (vm.defaultPriceCondition == 'MRKT' && vm.buySellFlag != 'SELLBUY') {
                    vm.orderDTO.limitExchangeRate = 0;
                    vm.orderDTO.stopExchangeRate = 0;
                } else if (vm.defaultPriceCondition == 'MRKT' && vm.buySellFlag == 'SELLBUY') {
                    vm.orderDTO.buyLimitExchangeRate = Number(0);
                    vm.orderDTO.sellLimitExchangeRate = Number(0);
                    vm.orderDTO.buyStopExchangeRate = 0;
                    vm.orderDTO.sellStopExchangeRate = 0;
                }
                if (vm.defaultPriceCondition == 'LIMT' && vm.buySellFlag != 'SELLBUY') {
                    vm.orderDTO.stopExchangeRate = 0;
                } else if (vm.defaultPriceCondition == 'LIMT' && vm.buySellFlag == 'SELLBUY') {
                    vm.orderDTO.buyStopExchangeRate = 0;
                    vm.orderDTO.sellStopExchangeRate = 0;
                }
                //this is set to display the settlement date in pre order confirmation
                vm.orderDTO.rebookingSettlementDate = angular.copy(vm.orderDTO.tradeSettlementDate);
                if (vm.defaultInstrumentCode != 'Forward') {
                    vm.orderDTO.tradeSettlementDate = null;
                    vm.orderDTO.tradeSettlementDateFrom = null;
                } else {
                    vm.orderDTO.tradeSettlementDate = DateUtils.convertLocalDateToServer(vm.tradeSettlementDate);
                    if (vm.orderDTO.tradeSettlementDateFrom != null) {
                        vm.orderDTO.tradeSettlementDateFrom = DateUtils.convertLocalDateToServer(angular.copy(vm.orderDTO.tradeSettlementDateFrom));
                    }
                }

                if (vm.activityIndicator == 'PLAC' || vm.activityIndicator == 'TRAD' || vm.activityIndicator == 'ROLL' || vm.activityIndicator == 'EARL') {
                    vm.orderDTO.typeOfOrder = vm.defaultPriceCondition;
                    if (vm.defaultTimeCondition == null || vm.defaultTimeCondition == undefined || vm.defaultTimeCondition == '') {
                        vm.orderDTO.timeLimitIndicator = 'DAYY'
                    } else {
                        vm.orderDTO.timeLimitIndicator = vm.defaultTimeCondition;
                    }
                    if (vm.defaultInstrumentCode == 'Forward') {
                        vm.orderDTO.exposureTypeId = vm.exposureType.id;
                        vm.orderDTO.exposureSubTypeId = vm.exposureSubType.id;
                        vm.orderDTO.exposureTypeName = vm.exposureType.name;
                        vm.orderDTO.exposureSubTypeName = vm.exposureSubType.name;
                    }
                }
                if (vm.activityIndicator == 'PLAC') {
                    vm.orderDTO.activityIndicator = vm.activityIndicator;
                    vm.orderDTO.instrumentCode = vm.defaultInstrumentCode;
                    console.log('instrument id before - ' + vm.defaultInstrumentId);
                    console.log('instrument code before - ' + vm.defaultInstrumentCode);
                    //console.log('instrument types');
                    console.log(vm.instrumentTypes);
                    //if(vm.defaultInstrumentId==null || vm.defaultInstrumentId==undefined || vm.defaultInstrumentId==''){
                    fillDefaultInstIdForInstCode(vm.defaultInstrumentCode);
                    //}
                    console.log('instrument id after - ' + vm.defaultInstrumentId);
                    vm.orderDTO.instrumentId = vm.defaultInstrumentId;
                    console.log(vm.orderDTO.instrumentId);
                    vm.orderDTO.buySellIndicator = vm.buySellFlag;
                    if (vm.orderDTO.contractCancellation != null && vm.orderDTO.contractCancellation != undefined && vm.orderDTO.contractCancellation == true) {
                        var eventType = getEventTypeForShortName('ContractCancellation');
                        vm.orderDTO.eventTypeId = eventType.id;
                        vm.orderDTO.eventType = eventType.shortName;
                    } else {
                        var eventType = getEventTypeForShortName('Booking');
                        vm.orderDTO.eventTypeId = eventType.id;
                        vm.orderDTO.eventType = eventType.shortName;
                        vm.orderDTO.settlementLegId = null;
                    }

                    // vm.orderDTO.currencyPairCode = vm.currencyPair.code;
                    // vm.orderDTO.currencyPairId = vm.currencyPair.id;
                    // fill bank, branch, customer details into order request
                    // dto
                    fillBankBranchCustomerDetails()
                }

                if(vm.orderDTO.currencyPairCode == 'USDINR'){
                $rootScope.enableOtherCurrencyTab = false;
                $rootScope.loadBoardCurrency = 'USD';
                }else{
                   $rootScope.enableOtherCurrencyTab = true;
                   $rootScope.loadBoardCurrency = 'OTHER';
                }
                vm.orderDTO.userId = vm.globalValues.getUserId();
                vm.orderDTO.retailUserCode = vm.globalValues.getUser().login;
                vm.orderDTO.userEntityOwnerId = vm.globalValues.getEntityOwnerTypeId();
                var sourceApp = getSourceApp('FXRETAIL');
                vm.orderDTO.sourceAppId = sourceApp.id;
                vm.orderDTO.sourceAppName = sourceApp.name;

                vm.orderDTO.deliveryMode = '';
                vm.orderDTO.settlementIFSCCode = '';
                vm.orderDTO.noOfTrades = 0;
                vm.orderDTO.tradeTotalPrice = 0;
            //    vm.orderDTO.currencyPairCode = vm.currencyPair.code;
             //   vm.orderDTO.currencyCode = vm.currencyPair.code;
                vm.orderDTO.limitCurrencyCode = vm.limitCurrencyCode;

                //vm.orderDTO.remarks = angular.copy(vm.remarks);
                vm.orderDTO.remarks = angular.copy(vm.remarks1);
                vm.orderDTO.remarks2 = angular.copy(vm.remarks2);
                vm.orderDTO.remarks3 = angular.copy(vm.remarks3);
                vm.orderDTO.remarks4 = angular.copy(vm.remarks4);
                if (vm.defaultInstrumentCode != 'SPOT') {
                    var tickSize = gettickSizeForGivenInstrument(vm.defaultInstrumentCode);
                    vm.orderDTO.spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate(selectedBankSpread, vm.defaultInstrumentCode, vm.buySellFlag,
                        DateUtils.convertLocalDateToServer(angular.copy(vm.tradeSettlementDate)), vm.currencyPair.code === 'USDINR' ? $rootScope.retailSpotMarketSession.settlementDate : $rootScope.marketSessionMap[vm.defaultInstrumentTokenSequenceNo].settlementDate,
                        tickSize);
                }
                //vm.orderDTO.spreadUsed = getSpreadUsed(selectedBankSpread, vm.buySellFlag, vm.defaultInstrumentCode);

                if (vm.orderDTO.timeLimitIndicator != 'GTTM') {
                    vm.orderDTO.expiryTime = 0;
                }
                // format exchange rates to four decimals before sending it to
                // order server
                formattingRates();
                vm.submitting = true;
                if (vm.userPreference.showPreOrderConfirmation == 'yes' || vm.defaultTimeCondition == 'GTTM' || vm.globalValues.getSessionTimedOut()) {
                    $rootScope.orderDTO = vm.orderDTO;
                    console.log(vm.orderDTO);

                    var index = getIndexBasedOnInstrument(vm.orderDTO.instrumentCode);

                    if (vm.currencyPair.code == 'USDINR') {
                        var closeTime = getCloseTimeForInstrumentCode(vm.orderDTO.instrumentCode);

                    } else {

                        var closeTime = $rootScope.marketSessionMap[vm.defaultInstrumentTokenSequenceNo].sessionTimingsDTO.closeTime;
                    }

                   // $rootScope.orderDTO = vm.orderDTO;
                    //User.get({userId: vm.globalValues.getUser().id}, function(result){

                    $state.go('pre-order-confirmation', { closeTime: closeTime, showPreOrderConfirmation: vm.userPreference.showPreOrderConfirmation, sessionTimedOut: vm.globalValues.getSessionTimedOut(), showOrderConfirmationForSplitOrder: vm.userPreference.showOrderConfirmationForSplitOrder, noOfSplit: vm.noOfSplits });
                    //});
                    /*  if pre order not show and split order confirmation shoud show and it is split order */
                } else if (vm.userPreference.showPreOrderConfirmation == 'no' && vm.userPreference.showOrderConfirmationForSplitOrder == 'yes' && vm.orderDTO.isSplitOrder == true && vm.activityIndicator != 'MDFY') {
                    vm.orderDTOList = [];
                    splitTheOrder(vm.orderDTO, vm.noOfSplits);
                    workflowSharedService.viewFrom = 'SplitOrder';
                    $state.go('split-order-confirmation', { orderDTOList: vm.orderDTOList, showOrderConfirmationForSplitOrder: vm.showOrderConfirmationForSplitOrder })
                    /*  if pre order and order confirmation  not show but split  it is split order*/
                } else if (vm.userPreference.showPreOrderConfirmation == 'no' && vm.userPreference.showOrderConfirmationForSplitOrder == 'no' && vm.orderDTO.isSplitOrder == true && vm.activityIndicator != 'MDFY') {
                    vm.orderDTOList = [];
                    splitTheOrder(vm.orderDTO, vm.noOfSplits);
                    workflowSharedService.viewFrom = 'SplitOrder';
                    $state.go('split-order-status', { orderDTOList: vm.orderDTOList })
                } else {
                    //to remove focus from order entry before placing order
                    //after double enter on buy or sell, the focus can be removed after the first enter execution
                    //code added on 07-Sep-2020 for double enter issue fix.
                    setTimeout(function () { document.getElementById('ibspotMktSell').focus() }, 10);
                    //on 18-Nov-2020. db writer null issue - added call back procedures while sending orders
                    if (vm.activityIndicator == 'PLAC' || vm.activityIndicator == 'TRAD' || vm.activityIndicator == 'ROLL' || vm.activityIndicator == 'EARL') {
                        vm.orderDTO.activityIndicator = 'PLAC';
                        placeOrderRequest(vm.orderDTO);
                    } else if (vm.activityIndicator == 'MDFY') {
                        sendModifyOrder(vm.orderDTO);
                    } else if (vm.activityIndicator == 'CNCL') {
                        sendCancelOrder(vm.orderDTO);
                    }
                    // defaultOrderEntry();

                    // remove foucs on order entry screen
                    // removeOrderEntryFocus();
                    // clear numeric controls
                    // clearNumericControls();
                    // setLTPPriceAsDefaultValueForLimitOrder();
                    //$rootScope.orderPlacedSuccessCount = 0;
                    //$scope.$emit('orderplacedsuccess');
                }
                resetPendingOrderCheckboxSelection(false);
                resetTradesOutstandingCheckboxSelection();
            } else {
                vm.clicked = false;
                MessageBox.openMessageBox("Alert", vm.errorString, "Ok", "homepage");
            }
        }

        function sendModifyOrder(orderDTO) {
            if (OrderUtil.validateOrderDTOForNull(orderDTO)) {
                Market.modifyOrder(orderDTO, onOrderSuccess, onOrderFailure);
            } else {
                MessageBox.openMessageBox("Alert", "The order request is not processed, please submit again.", "Ok", "orderrequestfailure");
            }
        }

        function sendCancelOrder(orderDTO) {
            if (OrderUtil.validateOrderDTOForNull(orderDTO)) {
                Market.cancelOrder(orderDTO, onOrderSuccess, onOrderFailure);
            } else {
                MessageBox.openMessageBox("Alert", "The order request is not processed, please submit again.", "Ok", "orderrequestfailure");
            }
        }

        function onOrderSuccess(result) {
            $rootScope.orderPlacedSuccessCount = 0;
            $scope.$emit('orderplacedsuccess');
        }

        function onOrderFailure() {
            $rootScope.orderPlacedSuccessCount = 0;
            $scope.$emit('orderplacedsuccess');
        }

        function executeMarketOrder() {
            var buySellFlag = angular.copy($rootScope.buySellFlagForOrder);
            vm.defaultPriceCondition = angular.copy($rootScope.defaultPriceConditionForOrder);
            vm.tradingBank = angular.copy($rootScope.tradingBankForOrder);
            var instrumentType = angular.copy($rootScope.defaultInstrumentCodeForOrder);
            var instrumentTokenSequenceNumber = angular.copy($rootScope.defaultInstrumentTokenSequenceNumberForOrder);
            vm.activityIndicator = angular.copy($rootScope.activityIndicatorForOrder);
            var orderDTO = angular.copy($rootScope.orderDTOForOrder);
            vm.tradingCustomer = angular.copy($rootScope.tradingCustomerForOrder);
            $rootScope.tickSize = angular.copy($rootScope.tickSizeForOrder);
            vm.userPreference = angular.copy($rootScope.userPreferenceForOrder);
            vm.configSettings = angular.copy($rootScope.configurationSettingsForOrder);
            vm.transactionParametersSettings = angular.copy($rootScope.transactionParametersSettingsForOrder);
            vm.tradingBranch = angular.copy($rootScope.tradingBranchForOrder);
            vm.defaultTimeCondition = angular.copy($rootScope.defaultTimeConditionForOrder);
            vm.noOfDecimalsForRate = angular.copy($rootScope.noOfDecimalsForRateForOrder);
            vm.noOfDecimalsForAmount = angular.copy($rootScope.noOfDecimalsForAmountForOrder);
            vm.noOfDecimalsForPercent = angular.copy($rootScope.noOfDecimalsForPercentForOrder);
            //vm.currencyPair = angular.copy($rootScope.currencyPairForOrder);
            // vm.remarks = angular.copy($rootScope.remarksForOrder);
            vm.remarks1 = angular.copy($rootScope.remarksForOrder1);
            vm.remarks2 = angular.copy($rootScope.remarksForOrder2);
            vm.remarks3 = angular.copy($rootScope.remarksForOrder3);
            vm.remarks4 = angular.copy($rootScope.remarksForOrder4);
            vm.clicked = angular.copy($rootScope.clickedForOrder);

            var valuelimitExchangeRate = angular.copy(vm.orderDTO.limitExchangeRate);
            var valueStopExchangeRate = angular.copy(vm.orderDTO.stopExchangeRate);
            var selectedBankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, vm.tradingBank.id);
            if (validateOrder(buySellFlag, orderDTO.typeOfOrder, selectedBankSpread, instrumentType, orderDTO.activityIndicator, orderDTO.orderAmount, 0, instrumentTokenSequenceNumber) && validateMarketOrder()) {
                if (vm.userPreference.showPreOrderConfirmation == 'yes' || vm.globalValues.getSessionTimedOut()) {
                    $rootScope.orderDTO = orderDTO;
                    $state.go('pre-order-confirmation', { closeTime: '', showPreOrderConfirmation: vm.userPreference.showPreOrderConfirmation, sessionTimedOut: vm.globalValues.getSessionTimedOut() });
                } else {
                    // send order request to server
                    //on 18-Nov-2020. db writer null issue - added call back procedures while sending orders
                    if (OrderUtil.validateOrderDTOForNull(orderDTO)) {
                        Market.placeOrder(orderDTO, onOrderFromMktSuccess, onOrderFromMktFailure);
                    } else {
                        MessageBox.openMessageBox("Alert", "The order request is not processed, please submit again.", "Ok", "orderrequestfailure");
                    }
                }
                /*
                  * $timeout(function(){ vm.orderDTO.limitExchangeRate =
                  * valuelimitExchangeRate; vm.orderDTO.stopExchangeRate =
                  * valueStopExchangeRate; },100)
                  */
                //resetPendingOrderCheckboxSelection(false);
                //resetTradesOutstandingCheckboxSelection();
                //defaultOrderEntry();
                // remove foucs on order entry screen
                //removeOrderEntryFocus();
                // clear numeric controls
                //clearNumericControls();

                //removeFocusFromMarketWatch();

            } else {
                MessageBox.openMessageBox("Alert", vm.errorString, "Ok", "homepage");
            }
        }


        function onOrderFromMktSuccess(result) {
            resetPendingOrderCheckboxSelection(false);
            resetTradesOutstandingCheckboxSelection();
            defaultOrderEntry();
            // remove foucs on order entry screen
            removeOrderEntryFocus();
            // clear numeric controls
            clearNumericControls();

            removeFocusFromMarketWatch();
        }

        function onOrderFromMktFailure() {
            resetPendingOrderCheckboxSelection(false);
            resetTradesOutstandingCheckboxSelection();
            defaultOrderEntry();
            // remove foucs on order entry screen
            removeOrderEntryFocus();
            // clear numeric controls
            clearNumericControls();

            removeFocusFromMarketWatch();
        }

function validateOrderAmountSoftCheck(orderAmount) {
    if (!$rootScope.currencyWiseUserPreferenceSettings) return true;

    var pref = $rootScope.currencyWiseUserPreferenceSettings[vm.currencyPair.id];
    if (!pref) return true;

    // 2 is index of maximum order value soft check
    var maxVal = Number(pref.configs[2]);

    if (Number(orderAmount) > maxVal) {
        MessageBox.openAlertMessageBox(
            "Alert",
            'Order quantity exceeds the maximum order value soft check </br>' +
            '<span class="softcheck-value">(' + vm.currencyPair.baseCurrency.code + ' ' +
            $filter('number')(maxVal, vm.noOfDecimalsForAmount) +
            ')</span> in "My preference" setting.</br> Do you want to proceed anyway?',
            "YesNo", "continueorderamountsoftcheck", "Quantity Alert", "warning"
        );
        return false;
    }
    return true;
}

        $rootScope.$on('gatewayApp.messagebox.yes.continueorderamountsoftcheck', function (event, data) {
            if (!$rootScope.orderExecutedForAmountSoftCheck) {
                if (!$rootScope.executeOrderFromMktWatch) {
                    // get value from $rootScope variables
                    vm.buySellFlag = angular.copy($rootScope.buySellFlagForOrder);
                    vm.defaultPriceCondition = angular.copy($rootScope.defaultPriceConditionForOrder);
                    vm.tradingBank = angular.copy($rootScope.tradingBankForOrder);
                    vm.defaultInstrumentCode = angular.copy($rootScope.defaultInstrumentCodeForOrder);
                    vm.defaultInstrumentTokenSequenceNo = angular.copy($rootScope.defaultInstrumentTokenSequenceNumberForOrder);
                    vm.activityIndicator = angular.copy($rootScope.activityIndicatorForOrder);
                    vm.orderDTO = angular.copy($rootScope.orderDTOForOrder);
                    vm.tradingCustomer = angular.copy($rootScope.tradingCustomerForOrder);
                    $rootScope.tickSize = angular.copy($rootScope.tickSizeForOrder);
                    vm.userPreference = angular.copy($rootScope.userPreferenceForOrder);
                    vm.configSettings = angular.copy($rootScope.configurationSettingsForOrder);
                    vm.transactionParametersSettings = angular.copy($rootScope.transactionParametersSettingsForOrder);
                    vm.tradingBranch = angular.copy($rootScope.tradingBranchForOrder);
                    vm.defaultTimeCondition = angular.copy($rootScope.defaultTimeConditionForOrder);
                    vm.noOfDecimalsForRate = angular.copy($rootScope.noOfDecimalsForRateForOrder);
                    vm.noOfDecimalsForAmount = angular.copy($rootScope.noOfDecimalsForAmountForOrder);
                    vm.noOfDecimalsForPercent = angular.copy($rootScope.noOfDecimalsForPercentForOrder);
                    vm.defaultInstrumentId = angular.copy($rootScope.defaultInstrumentIdForOrder);
                    vm.tradeSettlementDate = angular.copy($rootScope.tradeSettlementDateFororder);
                   // vm.currencyPair = angular.copy($rootScope.currencyPairForOrder);
                    //vm.remarks = angular.copy($rootScope.remarksForOrder);
                    vm.remarks1 = angular.copy($rootScope.remarksForOrder1);
                    vm.remarks2 = angular.copy($rootScope.remarksForOrder2);
                    vm.remarks3 = angular.copy($rootScope.remarksForOrder3);
                    vm.remarks4 = angular.copy($rootScope.remarksForOrder4);
                    vm.clicked = angular.copy($rootScope.clickedForOrder);
                    vm.account = angular.copy($rootScope.account);
                    vm.instrumentTypes = angular.copy($rootScope.instrumentTypesForOrder);
                    vm.exposureType = angular.copy($rootScope.exposureTypeForOrder);
                    vm.exposureSubType = angular.copy($rootScope.exposureSubTypeForOrder);
                    vm.globalValues = GlobalValues;
                    vm.noOfSplits = angular.copy($rootScope.noOfSplit);
                    vm.tradeSettlementDateFrom = new Date(angular.copy($rootScope.orderDTOForOrder.tradeSettlementDateFrom));
                    changeTenor(vm.tradeSettlementDateFrom, $rootScope.orderDTOForOrder.isOptionPeriod);
                    var valuelimitExchangeRate = angular.copy($rootScope.orderDTOForOrder.limitExchangeRate);
                    var valueStopExchangeRate = angular.copy($rootScope.orderDTOForOrder.stopExchangeRate);
                    var selectedBankSpread = null;

                    if ($rootScope.bankComparativeDTO != null && $rootScope.bankComparativeDTO != undefined
                        && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList != null && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList != undefined
                        && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList.length > 0) {
                        selectedBankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, $rootScope.tradingBankForOrder.id);

                    }
                    //var selectedBankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, $rootScope.tradingBankForOrder.id);
                   // if (validateLimitExchangeRateHardCheck(vm.buySellFlag, vm.defaultPriceCondition, selectedBankSpread, vm.defaultInstrumentCode, vm.activityIndicator, vm.orderDTO.orderAmount, vm.orderDTO.oldOrderAmount)) {
                    var validateLimitExchangeRateHardCheck = OrderUtil.validateLimitExchangeRateHardCheck(vm.buySellFlag, vm.defaultPriceCondition, selectedBankSpread, vm.defaultInstrumentCode, vm.activityIndicator, vm.orderDTO.orderAmount, vm.orderDTO.oldOrderAmount, vm.orderDTO.limitExchangeRate, vm.orderDTO.limitExchangeRateInSpot, vm.orderDTO.buyLimitExchangeRate, vm.orderDTO.buyLimitExchangeRateInSpot, vm.orderDTO.sellLimitExchangeRate, vm.orderDTO.sellLimitExchangeRateInSpot, vm.currencyPair.code, vm.currencyPair.id,vm.defaultInstrumentTokenSequenceNo);
                    if (validateLimitExchangeRateHardCheck.isValid) {
                             if (validateLimitExchangeRateSoftCheck(vm.buySellFlag)) {
                            executeOrder();
                        } else {
                            $rootScope.orderExecuted = false;
                            MessageBox.openAlertMessageBox("Alert", vm.limitPriceDeviationWarning, "YesNo", "continueorderpricesoftcheck", "Price Alert", "warning");
                        }
                    } else {
                        vm.clicked = false;
                       // MessageBox.openAlertMessageBox("Alert", vm.errorString, "Ok", "homepage", "Price Alert", "danger");
                          MessageBox.openAlertMessageBox("Alert", validateLimitExchangeRateHardCheck.errorString, "Ok", "homepage", "Price Alert", "danger");

                    }
                } else {
                    executeMarketOrder();
                }
                $rootScope.orderExecutedForAmountSoftCheck = true;
            }
        });

        $rootScope.$on('gatewayApp.messagebox.no.continueorderamountsoftcheck', function (event, data) {
            vm.clicked = false;
        });

        $rootScope.$on('gatewayApp.messagebox.clear.continueorderamountsoftcheck', function (event, data) {
            vm.clicked = false;
        });

        $rootScope.$on('gatewayApp.messagebox.ok.homepage', function (event, data) {
            vm.clicked = false;
        });

        $rootScope.$on('gatewayApp.messagebox.clear.homepage', function (event, data) {
            vm.clicked = false;
        });

        $rootScope.$on('gatewayApp.messagebox.yes.continueorderpricesoftcheck', function (event, data) {
            if (!$rootScope.orderExecuted) {
                // get value from $rootScope variables
                vm.buySellFlag = angular.copy($rootScope.buySellFlagForOrder);
                vm.defaultPriceCondition = angular.copy($rootScope.defaultPriceConditionForOrder);
                vm.tradingBank = angular.copy($rootScope.tradingBankForOrder);
                vm.tradingBranch = angular.copy($rootScope.tradingBranchForOrder);
                vm.defaultInstrumentCode = angular.copy($rootScope.defaultInstrumentCodeForOrder);
                vm.defaultInstrumentTokenSequenceNo = angular.copy($rootScope.defaultInstrumentTokenSequenceNumberForOrder);
                vm.activityIndicator = angular.copy($rootScope.activityIndicatorForOrder);
                vm.orderDTO = angular.copy($rootScope.orderDTOForOrder);
                vm.tradingCustomer = angular.copy($rootScope.tradingCustomerForOrder);
                $rootScope.tickSize = angular.copy($rootScope.tickSizeForOrder);
                vm.userPreference = angular.copy($rootScope.userPreferenceForOrder);
                vm.configSettings = angular.copy($rootScope.configurationSettingsForOrder);
                vm.transactionParametersSettings = angular.copy($rootScope.transactionParametersSettingsForOrder);
                vm.defaultTimeCondition = angular.copy($rootScope.defaultTimeConditionForOrder);
                vm.noOfDecimalsForRate = angular.copy($rootScope.noOfDecimalsForRateForOrder);
                vm.noOfDecimalsForAmount = angular.copy($rootScope.noOfDecimalsForAmountForOrder);
                vm.noOfDecimalsForPercent = angular.copy($rootScope.noOfDecimalsForPercentForOrder);
                vm.defaultInstrumentId = angular.copy($rootScope.defaultInstrumentIdForOrder);
                vm.tradeSettlementDate = angular.copy($rootScope.tradeSettlementDateFororder);
                vm.exposureType = angular.copy($rootScope.exposureTypeForOrder);
                vm.exposureSubType = angular.copy($rootScope.exposureSubTypeForOrder);
               // vm.currencyPair = angular.copy($rootScope.currencyPairForOrder);
                //vm.remarks = angular.copy($rootScope.remarksForOrder);
                vm.remarks1 = angular.copy($rootScope.remarksForOrder1);
                vm.remarks2 = angular.copy($rootScope.remarksForOrder2);
                vm.remarks3 = angular.copy($rootScope.remarksForOrder3);
                vm.remarks4 = angular.copy($rootScope.remarksForOrder4);
                vm.clicked = angular.copy($rootScope.clickedForOrder);
                vm.account = angular.copy($rootScope.account);
                vm.instrumentTypes = angular.copy($rootScope.instrumentTypesForOrder);
                vm.exposureType = angular.copy($rootScope.exposureTypeForOrder);
                vm.exposureSubType = angular.copy($rootScope.exposureSubTypeForOrder);
                vm.globalValues = GlobalValues;
                vm.tradeSettlementDateFrom = new Date(angular.copy($rootScope.orderDTOForOrder.tradeSettlementDateFrom));
                vm.noOfSplits = angular.copy($rootScope.noOfSplit);
                changeTenor(vm.tradeSettlementDateFrom, $rootScope.orderDTOForOrder.isOptionPeriod);
                executeOrder();
                $rootScope.orderExecuted = true;
            }

        });

        $rootScope.$on('gatewayApp.messagebox.no.continueorderpricesoftcheck', function (event, data) {
            vm.clicked = false;
        });

        $rootScope.$on('gatewayApp.messagebox.clear.continueorderpricesoftcheck', function (event, data) {
            vm.clicked = false;
        });

        function validateLimitExchangeRateHardCheck(buySellFlag, priceCondtion, selectedBankSpread, instrumentCode, activityIndicator, orderAmount, oldOrderAmount) {
            var ordertickSize = gettickSizeForGivenInstrument(instrumentCode);
            var alertInstrumentCode = instrumentCode;

            if(vm.currencyPair.code=='USDINR'){
                alertInstrumentCode = 'Spot'
            }
            var ltp = 0
            vm.errorString = "";

            if (buySellFlag != 'SELLBUY') {
                ltp = getLtpValue(vm.currencyPair,vm.defaultInstrumentTokenSequenceNo);
                var userAllowedOrderPriceDeviationFromMarketPriceInPercentage = 0;
                if ($rootScope.currencyWiseUserPreferenceSettings) {
                    var pref = $rootScope.currencyWiseUserPreferenceSettings[vm.currencyPair.id];
                    if (pref) {
                        userAllowedOrderPriceDeviationFromMarketPriceInPercentage = pref.configs[3];
                    }
                }
                if (!validateLimitExchangeRate(buySellFlag, activityIndicator, priceCondtion, vm.orderDTO.limitExchangeRate, vm.orderDTO.limitExchangeRateInSpot, ordertickSize, ltp, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage, userAllowedOrderPriceDeviationFromMarketPriceInPercentage,alertInstrumentCode)) {
                    return false;
                }
            } else if (buySellFlag == 'SELLBUY') {
                var ltp = getLtpValue(vm.currencyPair,vm.defaultInstrumentTokenSequenceNo);
                var userAllowedOrderPriceDeviationFromMarketPriceInPercentage = 0;
                if ($rootScope.currencyWiseUserPreferenceSettings) {
                    var pref = $rootScope.currencyWiseUserPreferenceSettings[vm.currencyPair.id];
                    if (pref) {
                        userAllowedOrderPriceDeviationFromMarketPriceInPercentage = pref.allowedOrderPriceDeviationFromMarketPriceInPercentage;
                    }
                }
                if (!validateLimitExchangeRate('BUYY', activityIndicator, priceCondtion, vm.orderDTO.buyLimitExchangeRate, vm.orderDTO.buyLimitExchangeRateInSpot, ordertickSize, ltp, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage, userAllowedOrderPriceDeviationFromMarketPriceInPercentage,alertInstrumentCode)) {
                    // return false;
                }
                if (!validateLimitExchangeRate('SELL', activityIndicator, priceCondtion, vm.orderDTO.sellLimitExchangeRate, vm.orderDTO.sellLimitExchangeRateInSpot, ordertickSize, ltp, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage, userAllowedOrderPriceDeviationFromMarketPriceInPercentage,alertInstrumentCode)) {
                    // return false;
                }
                if (vm.errorString != '' && vm.errorString != null && vm.errorString != undefined) {
                    return false;
                }
            }
            return true;
        }

        function validateLimitExchangeRateSoftCheck(buySellFlag) {
            vm.limitPriceDeviationWarning = '';
            if (buySellFlag != 'SELLBUY') {
                vm.limitPriceDeviationWarning = validateLimitPriceSoftCheck(buySellFlag, vm.orderDTO.limitExchangeRateInSpot,vm.currencyPair,vm.defaultInstrumentTokenSequenceNo);
                if (vm.limitPriceDeviationWarning != '') {
                    vm.limitPriceDeviationWarning = vm.limitPriceDeviationWarning + 'Do you want to proceed anyway?';
                    return false;
                }
            } else if (buySellFlag == 'SELLBUY') {
                vm.buyLimitPriceDeviationWarning = validateLimitPriceSoftCheck('BUYY', vm.orderDTO.buyLimitExchangeRateInSpot,vm.currencyPair,vm.defaultInstrumentTokenSequenceNo);
                vm.sellLimitPriceDeviationWarning = validateLimitPriceSoftCheck('SELL', vm.orderDTO.sellLimitExchangeRateInSpot,vm.currencyPair,vm.defaultInstrumentTokenSequenceNo);
                vm.limitPriceDeviationWarning = vm.buyLimitPriceDeviationWarning + vm.sellLimitPriceDeviationWarning;
                if (vm.buyLimitPriceDeviationWarning != '' && vm.sellLimitPriceDeviationWarning == '') {
                    vm.limitPriceDeviationWarning = vm.buyLimitPriceDeviationWarning;
                } else if (vm.buyLimitPriceDeviationWarning == '' && vm.sellLimitPriceDeviationWarning != '') {
                    vm.limitPriceDeviationWarning = vm.sellLimitPriceDeviationWarning;
                } else if (vm.buyLimitPriceDeviationWarning != '' && vm.sellLimitPriceDeviationWarning != '') {
                    var userPaiseDeviation = 0;
                    if ($rootScope.currencyWiseUserPreferenceSettings) {
                        var pref = $rootScope.currencyWiseUserPreferenceSettings[vm.currencyPair.id];
                        if (pref) {
                            userPaiseDeviation = pref.configs[0];
                        }
                    }
                    vm.limitPriceDeviationWarning = 'BUY and SELL limit price deviate by more than </br>' + "<span class='softcheck-value'>" + userPaiseDeviation + "&nbsp;paise" + "</span> " + ' from the Last Traded Price (LTP).\u003c/br\u003e '
                } else if (vm.buyLimitPriceDeviationWarning == '' && vm.sellLimitPriceDeviationWarning == '') {
                    vm.limitPriceDeviationWarning = '';
                }
                if (vm.limitPriceDeviationWarning != '') {
                    vm.limitPriceDeviationWarning = vm.limitPriceDeviationWarning + 'Do you want to proceed anyway?';
                    return false;
                }
            }
            return true;
        }

        function validateLimitPriceSoftCheck(buySellFlag, limitExchangeRate,currencyPair,tokenSequenceNo) {

            var deviationWarningString = '';

            var price = 0;

            if(currencyPair.code==='USDINR'){
                    price = $rootScope.previousDayClosingPriceForIbSpot;
            }else{
                 price = $rootScope.tickerPriceFCY[tokenSequenceNo].previouseDayClosingPrice
            }
            if (limitExchangeRate != null && limitExchangeRate != undefined && limitExchangeRate != '') {
                var userPaiseDeviation = 0;
                if ($rootScope.currencyWiseUserPreferenceSettings) {
                    var pref = $rootScope.currencyWiseUserPreferenceSettings[vm.currencyPair.id];
                    if (pref) {
                        userPaiseDeviation = pref.configs[0];
                    }
                }
                var higherCutOffPriceSoft = price + Number(userPaiseDeviation / 100);
                var lowerCutOffPriceSoft = price - Number(userPaiseDeviation / 100);
                var ltp = getLtpValue(currencyPair,tokenSequenceNo);
                if (ltp > 0 && ltp != undefined && ltp != null) {
                    higherCutOffPriceSoft = ltp + (Number(userPaiseDeviation / 100));
                    lowerCutOffPriceSoft = ltp - (Number(userPaiseDeviation / 100));
                }

                if (vm.defaultPriceCondition != 'MRKT') {
                    deviationWarningString = softCheckDeviation(limitExchangeRate.toString(), higherCutOffPriceSoft, lowerCutOffPriceSoft, userPaiseDeviation);
                }
            }
            if (deviationWarningString != '') {
                if (buySellFlag == 'BUYY') {
                    deviationWarningString = 'BUY limit price ' + deviationWarningString;
                } else if (buySellFlag == 'SELL') {
                    deviationWarningString = 'SELL limit price ' + deviationWarningString;
                }
            }
            return deviationWarningString;
        }

        function formattingRates() {
            if (vm.orderDTO.buySellIndicator != 'SELLBUY') {
                vm.orderDTO.limitExchangeRate = $filter('number')(vm.orderDTO.limitExchangeRate, vm.noOfDecimalsForRate);
                vm.orderDTO.stopExchangeRate = $filter('number')(vm.orderDTO.stopExchangeRate, vm.noOfDecimalsForRate);
            } else {
                vm.orderDTO.buyLimitExchangeRate = $filter('number')(vm.orderDTO.buyLimitExchangeRate, vm.noOfDecimalsForRate);
                vm.orderDTO.sellLimitExchangeRate = $filter('number')(vm.orderDTO.sellLimitExchangeRate, vm.noOfDecimalsForRate);
                vm.orderDTO.buyStopExchangeRate = $filter('number')(vm.orderDTO.buyStopExchangeRate, vm.noOfDecimalsForRate);
                vm.orderDTO.sellStopExchangeRate = $filter('number')(vm.orderDTO.sellStopExchangeRate, vm.noOfDecimalsForRate);
            }
        }

        function setBuySellFlagAndActivityIndicator() {
            if (vm.orderType == 'SELL' && vm.orderDTO.activityIndicator == 'PLAC') {
                vm.buySellFlag = 'SELL';
                vm.activityIndicator = 'PLAC';
            } else if (vm.orderType == 'BUYY' && vm.orderDTO.activityIndicator == 'PLAC') {
                vm.buySellFlag = 'BUYY';
                vm.activityIndicator = 'PLAC';
            } else if (vm.orderType == 'SELL' && vm.orderDTO.activityIndicator == 'MDFY') {
                vm.buySellFlag = 'SELL';
                vm.activityIndicator = 'MDFY';
            } else if (vm.orderType == 'BUYY' && vm.orderDTO.activityIndicator == 'MDFY') {
                vm.buySellFlag = 'BUYY';
                vm.activityIndicator = 'MDFY';
            } else if (vm.orderType == 'SELL' && vm.orderDTO.activityIndicator == 'TRAD') {
                vm.buySellFlag = 'SELL';
                vm.activityIndicator = 'TRAD';
            } else if (vm.orderType == 'BUYY' && vm.orderDTO.activityIndicator == 'TRAD') {
                vm.buySellFlag = 'BUYY';
                vm.activityIndicator = 'TRAD';
            } else if (vm.orderType == 'SELL' && vm.orderDTO.activityIndicator == 'ROLL') {
                vm.buySellFlag = 'SELL';
                vm.activityIndicator = 'ROLL';
            } else if (vm.orderType == 'BUYY' && vm.orderDTO.activityIndicator == 'ROLL') {
                vm.buySellFlag = 'BUYY';
                vm.activityIndicator = 'ROLL';
            } else if (vm.orderType == 'SELL' && vm.orderDTO.activityIndicator == 'EARL') {
                vm.buySellFlag = 'SELL';
                vm.activityIndicator = 'EARL';
            } else if (vm.orderType == 'BUYY' && vm.orderDTO.activityIndicator == 'EARL') {
                vm.buySellFlag = 'BUYY';
                vm.activityIndicator = 'EARL';
            } else if (vm.orderType == 'SELL' && vm.orderDTO.activityIndicator == 'CNCL') {
                vm.buySellFlag = 'SELL';
                vm.activityIndicator = 'CNCL';
            } else if (vm.orderType == 'BUYY' && vm.orderDTO.activityIndicator == 'CNCL') {
                vm.buySellFlag = 'BUYY';
                vm.activityIndicator = 'CNCL';
            } else if (vm.orderType == 'SELLBUY' && vm.orderDTO.activityIndicator == 'PLAC') {
                vm.buySellFlag = 'SELLBUY';
                vm.activityIndicator = 'PLAC';
            }
        }

        function validateMarketOrder() {
            if (vm.account.organisation.organisationType.shortName != 'CUSTOMER') {
                if (vm.defaultTradingCustomerControl != null && vm.defaultTradingCustomerControl != undefined) {
                    // proceed
                } else {
                    vm.errorString = "Please select the trading customer to proceed.";
                    return false;
                }
            }
            return true;
        }

        function fillBankBranchCustomerDetails() {
            if (vm.globalValues.getEntityOwnerType().shortName == 'Clearcorp') {
                vm.orderDTO.branchCode = vm.tradingBranch.branchId;
                vm.orderDTO.branchId = vm.tradingBranch.id;
                vm.orderDTO.branchName = vm.tradingBranch.branchName;
                vm.orderDTO.bankId = vm.tradingBank.id;
                vm.orderDTO.bankName = vm.tradingBank.bankName;
                vm.orderDTO.bankMemberNumber = vm.tradingBank.bankMemberNo;
                vm.orderDTO.customerId = vm.tradingCustomer.id;
                vm.orderDTO.customerName = vm.tradingCustomer.customerFirstName;
                vm.orderDTO.customerCode = vm.tradingCustomer.customerCode;
             //   vm.orderDTO.currencyPairCode = vm.currencyPair.code;
               // vm.orderDTO.currencyCode = vm.currencyPair.code;
                vm.orderDTO.limitCurrencyCode = vm.limitCurrencyCode;
            } else if (vm.globalValues.getEntityOwnerType().shortName == 'Bank') {
                vm.orderDTO.branchCode = vm.tradingBranch.branchId;
                vm.orderDTO.branchId = vm.tradingBranch.id;
                vm.orderDTO.branchName = vm.tradingBranch.branchName;
                vm.orderDTO.bankId = vm.globalValues.getBank().id;
                vm.orderDTO.bankName = vm.globalValues.getBank().bankName;
                vm.orderDTO.bankMemberNumber = vm.globalValues.getBank().bankMemberNo;
                vm.orderDTO.customerId = vm.tradingCustomer.id;
                vm.orderDTO.customerName = vm.tradingCustomer.customerFirstName;
                vm.orderDTO.customerCode = vm.tradingCustomer.customerCode;
              //  vm.orderDTO.currencyPairCode = vm.currencyPair.code;
              //  vm.orderDTO.currencyCode = vm.currencyPair.code;
                vm.orderDTO.limitCurrencyCode = vm.limitCurrencyCode;
            } else if (vm.globalValues.getEntityOwnerType().shortName == 'Branch') {
                vm.orderDTO.branchCode = vm.globalValues.getBranch().branchId;
                vm.orderDTO.branchId = vm.globalValues.getBranch().id;
                vm.orderDTO.branchName = vm.globalValues.getBranch().branchName;
                vm.orderDTO.bankId = vm.globalValues.getBank().id;
                vm.orderDTO.bankName = vm.globalValues.getBank().bankName;
                vm.orderDTO.bankMemberNumber = vm.globalValues.getBank().bankMemberNo;
                vm.orderDTO.customerId = vm.tradingCustomer.id;
                vm.orderDTO.customerName = vm.tradingCustomer.customerFirstName;
                vm.orderDTO.customerCode = vm.tradingCustomer.customerCode;
              //  vm.orderDTO.currencyPairCode = vm.currencyPair.code;
              //  vm.orderDTO.currencyCode = vm.currencyPair.code;
                vm.orderDTO.limitCurrencyCode = vm.limitCurrencyCode;
            } else if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                if ($rootScope.tradingBranchForOrder != null && $rootScope.tradingBranchForOrder != undefined) {
                    vm.tradingBranch = angular.copy($rootScope.tradingBranchForOrder);
                }
                if (vm.tradingBranch.id == null || vm.tradingBranch.id == undefined) {
                    MessageBox.openMessageBox("Alert", "Customer bank relationship does not exist...!", "Ok", "homepage");
                }
                vm.orderDTO.branchCode = vm.tradingBranch.branchId;
                vm.orderDTO.branchId = vm.tradingBranch.id;
                vm.orderDTO.branchName = vm.tradingBranch.branchName;
                vm.orderDTO.bankId = vm.tradingBank.id;
                vm.orderDTO.bankName = vm.tradingBank.bankName;
                vm.orderDTO.bankMemberNumber = vm.tradingBank.bankMemberNo;
                vm.orderDTO.customerId = vm.globalValues.getCustomer().id;
                vm.orderDTO.customerName = vm.globalValues.getCustomer().customerFirstName;
                vm.orderDTO.customerCode = vm.globalValues.getCustomer().customerCode;
              //  vm.orderDTO.currencyPairCode = vm.currencyPair.code;
              //  vm.orderDTO.currencyCode = vm.currencyPair.code;
                vm.orderDTO.limitCurrencyCode = vm.limitCurrencyCode;
            }
        }

        function fillBankBranchCustomerDetailsFromMktWatch(orderDTO) {
            if (vm.globalValues.getEntityOwnerType().shortName == 'Clearcorp') {
                orderDTO.branchCode = vm.tradingBranch.branchId;
                orderDTO.branchId = vm.tradingBranch.id;
                orderDTO.branchName = vm.tradingBranch.branchName;
                orderDTO.bankId = vm.tradingBank.id;
                orderDTO.bankName = vm.tradingBank.bankName;
                orderDTO.bankMemberNumber = vm.tradingBank.bankMemberNo;
                orderDTO.customerId = vm.tradingCustomer.id;
                orderDTO.customerName = vm.tradingCustomer.customerFirstName;
                orderDTO.customerCode = vm.tradingCustomer.customerCode;
                orderDTO.currencyPairCode = vm.currencyPair.code;
                orderDTO.currencyCode = vm.currencyPair.code;
                orderDTO.limitCurrencyCode = vm.limitCurrencyCode;
            } else if (vm.globalValues.getEntityOwnerType().shortName == 'Bank') {
                orderDTO.branchCode = vm.tradingBranch.branchId;
                orderDTO.branchId = vm.tradingBranch.id;
                orderDTO.branchName = vm.tradingBranch.branchName;
                orderDTO.bankId = vm.globalValues.getBank().id;
                orderDTO.bankName = vm.globalValues.getBank().bankName;
                orderDTO.bankMemberNumber = vm.globalValues.getBank().bankMemberNo;
                orderDTO.customerId = vm.tradingCustomer.id;
                orderDTO.customerName = vm.tradingCustomer.customerFirstName;
                orderDTO.customerCode = vm.tradingCustomer.customerCode;
                orderDTO.currencyPairCode = vm.currencyPair.code;
                orderDTO.currencyCode = vm.currencyPair.code;
                orderDTO.limitCurrencyCode = vm.limitCurrencyCode;
            } else if (vm.globalValues.getEntityOwnerType().shortName == 'Branch') {
                orderDTO.branchCode = vm.globalValues.getBranch().branchId;
                orderDTO.branchId = vm.globalValues.getBranch().id;
                orderDTO.branchName = vm.globalValues.getBranch().branchName;
                orderDTO.bankId = vm.globalValues.getBank().id;
                orderDTO.bankName = vm.globalValues.getBank().bankName;
                orderDTO.bankMemberNumber = vm.globalValues.getBank().bankMemberNo;
                orderDTO.customerId = vm.tradingCustomer.id;
                orderDTO.customerName = vm.tradingCustomer.customerFirstName;
                orderDTO.customerCode = vm.tradingCustomer.customerCode;
                orderDTO.currencyPairCode = vm.currencyPair.code;
                orderDTO.currencyCode = vm.currencyPair.code;
                orderDTO.limitCurrencyCode = vm.limitCurrencyCode;
            } else if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                if (vm.tradingBranch.id == null || vm.tradingBranch.id == undefined) {
                    MessageBox.openMessageBox("Alert", "Customer bank relationship does not exist...!", "Ok", "homepage");
                }
                orderDTO.branchCode = vm.tradingBranch.branchId;
                orderDTO.branchId = vm.tradingBranch.id;
                orderDTO.branchName = vm.tradingBranch.branchName;
                orderDTO.bankId = vm.tradingBank.id;
                orderDTO.bankName = vm.tradingBank.bankName;
                orderDTO.bankMemberNumber = vm.tradingBank.bankMemberNo;
                orderDTO.customerId = vm.globalValues.getCustomer().id;
                orderDTO.customerName = vm.globalValues.getCustomer().customerFirstName;
                orderDTO.customerCode = vm.globalValues.getCustomer().customerCode;
                orderDTO.currencyPairCode = vm.currencyPair.code;
                orderDTO.currencyCode = vm.currencyPair.code;
                orderDTO.limitCurrencyCode = vm.limitCurrencyCode;
            }

            return orderDTO;
        }

        function getCloseTimeForInstrumentCode(instrument) {
            if (instrument == 'SPOT') {
                return $rootScope.retailSpotMarketSession.sessionTimingsDTO.closeTime;
            } else if (instrument == 'CASH') {
                return $rootScope.cashMarketSession.sessionTimingsDTO.closeTime;
            } else if (instrument == 'TOM') {
                return $rootScope.tomMarketSession.sessionTimingsDTO.closeTime;
            } else if (instrument == 'Forward') {
                return $rootScope.forwardMarketSession.sessionTimingsDTO.closeTime;
            }
        }

        function validateOrder(buySellFlag, priceCondtion, selectedBankSpread, instrumentCode, activityIndicator, orderAmount, oldOrderAmount) {

            vm.errorString = "";
            vm.configSettings = vm.globalValues.getConfigSettings();
            vm.transactionParametersSettings =  vm.globalValues.getTransactionParametersSettings();

            /*
             * if(!validateSessionStatus(instrumentCode)){ return false; }
             *
             * if(priceCondtion=='STLS'){ if(!isAllowedStopLossOrders()){ return
             * false; } }
             *
             * if(priceCondtion=='TKPR'){ if(!isAllowedTakeProfitOrders()){
             * return false; } }
             */

            if (activityIndicator != 'CNCL') {
                /*
                 * if(!validateOrderAmount(orderAmount)){ return false; }
                 */

                // no need to check limits while cancelling orders
                /*
                 * if(activityIndicator=='CNCL' ||
                 * ($rootScope.account.organisation.organisationType.shortName=='CUSTOMER' &&
                 * vm.tradingCustomer.isProp==true) || (priceCondtion=='MRKT' &&
                 * $rootScope.account.organisation.organisationType.shortName!='CUSTOMER' &&
                 * vm.tradingCustomer.isProp==true) || (priceCondtion!='MRKT' &&
                 * $rootScope.account.organisation.organisationType.shortName!='CUSTOMER' &&
                 * vm.tradingCustomer.isProp==true)){ //proceed }else{
                 * if(!validateLimitCheck(oldOrderAmount, activityIndicator,
                 * orderAmount, instrumentCode, buySellFlag, priceCondtion)){
                 * return false; } }
                 */

                // ordertickSize
                // ltp
                var ordertickSize = "";
                if (vm.defaultInstrumentTokenSequenceNo && vm.currencyPair.code !== 'USDINR') {
                    ordertickSize = OrderUtil.gettickSizeForGivenInstrument(instrumentCode, vm.currencyPair.code, vm.defaultInstrumentTokenSequenceNo);
                } else {
                    ordertickSize = OrderUtil.gettickSizeForGivenInstrument(instrumentCode, 'USD');
                }
                var ltp = 0

                if (buySellFlag != 'SELLBUY') {
                    ltp = getLtpValue(vm.currencyPair,vm.defaultInstrumentTokenSequenceNo);
                    console.log('hard check');
                    console.log($rootScope.retailSpotMarketDepth);
                    console.log(ltp);
                    /*
                     * if(!validateLimitExchangeRate(buySellFlag,
                     * activityIndicator, priceCondtion,
                     * vm.orderDTO.limitExchangeRate,
                     * vm.orderDTO.limitExchangeRateInSpot, ordertickSize, ltp,
                     * vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage,
                     * vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise)){
                     * return false; }
                     */
                    if (!validateStopExchangeRate(priceCondtion, buySellFlag, vm.orderDTO.limitExchangeRate, vm.orderDTO.stopExchangeRate, ordertickSize)) {
                        return false;
                    }
                    //  var validateSpreadUsed = OrderUtil.validateSpreadUsed(selectedBankSpread, instrumentCode, buySellFlag);
                    if (!validateSpreadUsed(selectedBankSpread, instrumentCode, buySellFlag)) {
                        //vm.errorString = validateSpreadUsed.errorString;
                        return false;
                    }
                    if (vm.errorString != '') {
                        return false;
                    }
                } else if (buySellFlag == 'SELLBUY') {
                    var ltp = getLtpValue(vm.currencyPair,vm.defaultInstrumentTokenSequenceNo);
                    /*
                     * if(!validateLimitExchangeRate('BUYY', activityIndicator,
                     * priceCondtion, vm.orderDTO.buyLimitExchangeRate,
                     * vm.orderDTO.buyLimitExchangeRateInSpot, ordertickSize,
                     * ltp,
                     * vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage,
                     * vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise)){
                     * return false; } if(!validateLimitExchangeRate('SELL',
                     * activityIndicator, priceCondtion,
                     * vm.orderDTO.sellLimitExchangeRate,
                     * vm.orderDTO.sellLimitExchangeRateInSpot, ordertickSize,
                     * ltp,
                     * vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage,
                     * vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise)){
                     * return false; }
                     */
                    if (!validateStopExchangeRate(priceCondtion, 'BUYY', vm.orderDTO.buyLimitExchangeRate, vm.orderDTO.buyStopExchangeRate, ordertickSize)) {
                        // return false;
                    }
                    if (!validateStopExchangeRate(priceCondtion, 'SELL', vm.orderDTO.sellLimitExchangeRate, vm.orderDTO.sellStopExchangeRate, ordertickSize)) {
                        return false;
                    }
                    if (vm.errorString != '') {
                        return false;
                    }
                    //  var validateSpreadUsedBuy = OrderUtil.validateSpreadUsed(selectedBankSpread, instrumentCode, 'BUYY');
                    // var validateSpreadUsedSell = OrderUtil.validateSpreadUsed(selectedBankSpread, instrumentCode, 'SELL');
                    if (!validateSpreadUsed(selectedBankSpread, instrumentCode, 'BUYY')) {
                        //  vm.errorString = validateSpreadUsedBuy.errorString;
                        return false;
                    }
                    if (!validateSpreadUsed(selectedBankSpread, instrumentCode, 'BUYY')) {
                        //  vm.errorString = validateSpreadUsedSell.errorString;
                        return false;
                    }
                }
            }

            return true;
        }

        function isAllowedStopLossOrders() {
            if (vm.configSettings.isAllowStopLossOrder == 'Yes') {
                return true;
            } else {
                vm.errorString = "Stop loss orders are not allowed.";
                return false;
            }
        }

        function isAllowedTakeProfitOrders() {
            if (vm.configSettings.isAllowTakeProfitOrder == 'Yes') {
                return true;
            } else {
                vm.errorString = "Take profit orders are not allowed.";
                return false;
            }
        }

        function validateTradingBankStatus() {
            CustomerBankRelationshipReport.getTradingBanksForCustomer({ customerId: vm.globalValues.getCustomer().id }, function (result) {
                if (result.length > 0) {
                    angular.forEach(result, function (value) {
                        if (value.shortName == vm.tradingBank.shortName) {
                            return true;
                        }
                    })
                }
                return false;
            })
        }

        // validate session status
        function validateSessionStatus(instrumentCode, tokenSequenceNo) {
            var status = "";


            status = $rootScope.marketSessionMap[tokenSequenceNo];

            // if(instrumentCode == 'SPOT'){
            // 	status = $rootScope.retailSpotMarketSession.sessionTimingsDTO.status;
            // }else if(instrumentCode == 'CASH'){
            // 	status = $rootScope.cashMarketSession.sessionTimingsDTO.status;
            // }else if(instrumentCode == 'TOM'){
            // 	status = $rootScope.tomMarketSession.sessionTimingsDTO.status;
            // }else if(instrumentCode == 'Forward'){
            //     status = $rootScope.forwardMarketSession.sessionTimingsDTO.status;
            // }

            if (status != 'OPEN') {
                vm.errorString = "Session is closed for " + instrumentCode + " market...!"
                return false;
            }

            return true;
        }
        /**
         * Valdate cancellation leg session status before placing ROLL or EARLY delivery
         */
        function validateCancellationLegSessionStatus(activityIndicator, cancellationLegInstrument) {
            if (activityIndicator == 'ROLL' || activityIndicator == 'EARL') {
                var isValidSessionStatus  = OrderUtil.validateSessionStatus(cancellationLegInstrument);
                if (!isValidSessionStatus) {
                    vm.errorString = "Session is closed for Cancellation Leg instrument " + cancellationLegInstrument + "...!";
                }
                return isValidSessionStatus;
            }
            return true;
        }

        function validateAgreedTAC() {
            if ($rootScope.account != null && $rootScope.account.organisation.organisationType.shortName == 'CUSTOMER') {
                if ($rootScope.agreedTACList != null && $rootScope.agreedTACList != undefined && $rootScope.agreedTACList.length > 0) {
                    //validate clearcorp TAC
                    if ($rootScope.agreedTACList[0].isAgreed) {
                        //validate selected trading bank TAC
                        if (vm.tradingBank != null && vm.tradingBank != undefined) {
                            var agreedTACListForBank = _.filter(angular.copy($rootScope.agreedTACList), { 'providerId': vm.tradingBank.id });
                            if (agreedTACListForBank != null && agreedTACListForBank != undefined && agreedTACListForBank.length > 0) {
                                if (!agreedTACListForBank[0].isAgreed) {
                                    vm.errorString = "This activity cannot be completed. Kindly accept the revised Clearcorp/Relationship Bank Terms and Conditions by accessing from the “Settings menu >> Terms and Conditions view” menu in order to proceed with Order activity.";
                                    return false;
                                }
                            } else {
                                vm.errorString = "This activity cannot be completed. Kindly accept the revised Clearcorp/Relationship Bank Terms and Conditions by accessing from the “Settings menu >> Terms and Conditions view” menu in order to proceed with Order activity.";
                                return false;
                            }
                        } else {
                            vm.errorString = "Trading bank should be selected to place order...!";
                            return false;
                        }
                    } else {
                        vm.errorString = "This activity cannot be completed. Kindly accept the revised Clearcorp/Relationship Bank Terms and Conditions by accessing from the “Settings menu >> Terms and Conditions view” menu in order to proceed with Order activity.";
                        return false;
                    }

                }
            }

            return true;
        }

        //get session status for instrument code
        function getSessionStatusForInstrument(instrumentCode) {
            var status = 'CLOSED';
            if (instrumentCode == 'SPOT') {
                status = $rootScope.retailSpotMarketSession.sessionTimingsDTO.status;
            } else if (instrumentCode == 'CASH') {
                if ($rootScope.cashMarketSession != null && $rootScope.cashMarketSession != undefined) {
                    status = $rootScope.cashMarketSession.sessionTimingsDTO.status;
                }
            } else if (instrumentCode == 'TOM') {
                status = $rootScope.tomMarketSession.sessionTimingsDTO.status;
            } else if (instrumentCode == 'Forward') {
                status = $rootScope.forwardMarketSession.sessionTimingsDTO.status;
            }
            return status;
        }

        // validate limit availability
        function validateLimitAvailability(buySellFlag, priceCondtion, activityIndicator, instrumentCode, orderAmount, oldOrderAmount, eventType, tradeSettlementDate, orderDTO) {
            if (activityIndicator != 'CNCL' && eventType != 'ContractCancellation' && eventType != 'Rollover' && eventType != 'EarlyDelivery') {
                if (activityIndicator == 'CNCL' || ($rootScope.account.organisation.organisationType.shortName == 'CUSTOMER' && vm.tradingCustomer.isProp == true)
                    || (priceCondtion == 'MRKT' && $rootScope.account.organisation.organisationType.shortName != 'CUSTOMER' && vm.tradingCustomer.isProp == true)
                    || (priceCondtion != 'MRKT' && $rootScope.account.organisation.organisationType.shortName != 'CUSTOMER' && vm.tradingCustomer.isProp == true)) {
                    // proceed
                } else {
                    var validateLimitCheck = OrderUtil.validateLimitCheck(oldOrderAmount, activityIndicator, orderAmount, instrumentCode, buySellFlag, priceCondtion, tradeSettlementDate);
                    if (!validateLimitCheck.isValid) {
                        vm.errorString = validateLimitCheck.errorString;
                        return false;
                    }
                }
            }
            if (activityIndicator == 'TRAD' || activityIndicator == 'ROLL' || activityIndicator == 'EARL' || (activityIndicator == 'MDFY' && (eventType == 'ContractCancellation' || eventType == 'Contract Cancellation' || eventType == 'Rollover' || eventType == 'Early Delivery'))) {
                //old order amount variable contains the amount(outstanding amount - blocked amount)
                //so, if ordered amount greater than that, will not allow to process
                if (orderAmount > oldOrderAmount) {
                    vm.errorString = "Order quantity cannot be more than the original trade outstanding quantity...!";
                    return false;
                }
            }

            //validate limit for rollover trade
            if (activityIndicator == 'ROLL' && vm.tradingCustomer.isProp == false) {
                if (!validateLimitCheckForRollover(orderAmount, instrumentCode, buySellFlag, orderDTO, tradeSettlementDate)) {
                    return false;
                }
            }

            return true;
        }

        function validateLimitCheckForRollover(orderAmount, instrumentCode, buySellFlag, orderDTO, tradeSettlementDate) {
            if ($rootScope.limitNotDefined) {
                vm.errorString = "Trading limits are not defined. Order entry not possible...!";
                return false;
            }
            //valdiate max tenor date
            if (instrumentCode == 'Forward') {
                if (moment(tradeSettlementDate).isAfter($rootScope.maxForwardTenorDate, 'day')) {
                    vm.errorString = "Order entry not possible. Settlement date selected is greater than the" +
                        " maximum tenor/value date defined by the Relationship Bank. Please refer the Limit Tab for more info on maximum tenor/value date allowed.";
                    return false;
                }
            }

            if (orderDTO.isExistingTradeConsumesLimit) {
                //find limit to be cancelled from old buket
                //get credit factor value of cancellation bucket
                vm.cancellationLegCF = MarketWatch.getCreditFactorValue(instrumentCode, angular.copy(orderDTO.cancellationTradeSettlementDate), $rootScope.selectedCreditFactor, vm.configSettings.defaultCreditFactorSettingsInPercentage);
                vm.limitToBeCancelled = MarketWatch.computeLimitAmountApplyingCreditFactor(orderAmount, vm.cancellationLegCF);
            }
            else {
                vm.limitToBeCancelled = 0;
            }


            //find limit to be consumed for rebooking bucket
            //get credit factor value of rebooking bucket
            vm.rebookingLegCF = MarketWatch.getCreditFactorValue(instrumentCode, angular.copy(orderDTO.tradeSettlementDate), $rootScope.selectedCreditFactor, vm.configSettings.defaultCreditFactorSettingsInPercentage);

            vm.limitToBeConsumedForRebooking = MarketWatch.computeLimitAmountApplyingCreditFactor(orderAmount, vm.rebookingLegCF);

            vm.limitToBeConsumed = vm.limitToBeConsumedForRebooking - vm.limitToBeCancelled;
            vm.limitToBeConsumed = (Math.round(parseFloat(vm.limitToBeConsumed) * 100) / 100);

            //check this limitToBeConsumed with available limit

            //if buySellFlag is buy,
            //check limitToBeConsumed is lesser than or equal to $rootScope.forwardBuyLimitWithCF
            //if buySellFlag is sell,
            //check limitToBeConsumed is lesser than or equal to $rootScope.forwardSellLimitWithCF
            if (buySellFlag == 'BUYY') {
                if (vm.limitToBeConsumed > $rootScope.forwardBuyLimitWithCF) {
                    vm.errorString = "Buy trading limit breached. Order entry not possible...!";
                    return false;
                }
            } else {
                if (vm.limitToBeConsumed > $rootScope.forwardSellLimitWithCF) {
                    vm.errorString = "Sell trading limit breached. Order entry not possible...!";
                    return false;
                }
            }

            //if above validation pass, then return true, else return false
            return true;

        }

        // get tick size
        function gettickSizeForGivenInstrument(instrumentCode) {
            if(vm.currencyPair){
            if (vm.currencyPair.code === 'USDINR') {
                if (instrumentCode == 'SPOT') {
                    return $rootScope.tickSize.usd.spot;
                } else if (instrumentCode == 'CASH') {
                    return $rootScope.tickSize.usd.cash;
                } else if (instrumentCode == 'TOM') {
                    return $rootScope.tickSize.usd.tom;
                } else if (instrumentCode == 'Forward') {
                    return $rootScope.tickSize.usd.forward;
                }
            }
            else {

                var tikSizeValues = $rootScope.tickSize.other[vm.defaultInstrumentTokenSequenceNo];
            if(tikSizeValues != undefined && tikSizeValues != null){
                if (instrumentCode == 'SPOT') {
                    return tikSizeValues.spot;
                } else if (instrumentCode == 'CASH') {
                    return tikSizeValues.cash;
                } else if (instrumentCode == 'TOM') {
                    return tikSizeValues.tom;
                }
            }
              }
            }
        }


        $rootScope.gettickSizeForGivenInstrument = gettickSizeForGivenInstrument;

        // get ltp for given instrument and buy sell flag
        function getLtpValue(currencyPair,tokenSequenceNo) {
            if(currencyPair.code=='USDINR'){
            if ($rootScope.ibSpotMarketDepth != null && $rootScope.ibSpotMarketDepth != undefined) {
                if ($rootScope.ibSpotMarketDepth.ltp != null && $rootScope.ibSpotMarketDepth.ltp != undefined && $rootScope.ibSpotMarketDepth.ltp > 0) {
                    return $rootScope.ibSpotMarketDepth.ltp;
                } else {
                    return $rootScope.previousDayClosingPriceForIbSpot;
                }
            } else {
                return $rootScope.previousDayClosingPriceForIbSpot;
            }
        }
        else{

             if ($rootScope.tickerPriceFCY[tokenSequenceNo] != null && $rootScope.tickerPriceFCY[tokenSequenceNo] != undefined) {
                if ($rootScope.tickerPriceFCY[tokenSequenceNo].ltp != null && $rootScope.tickerPriceFCY[tokenSequenceNo].ltp != undefined && $rootScope.tickerPriceFCY[tokenSequenceNo].ltp > 0) {
                    return $rootScope.tickerPriceFCY[tokenSequenceNo].ltp;
                } else {
                    return $rootScope.dailyClosingPriceFCY[tokenSequenceNo].previouseDayClosingPrice;
                }
            } else {

            return $rootScope.dailyClosingPriceFCY[tokenSequenceNo].previouseDayClosingPrice;
            }
        }
        }

        function getLTPOrPreviousDayLTPForInstrumentAndBuySellFlag(instrumentCode, buySellFlag) {
            if (instrumentCode == 'SPOT') {
                if ($rootScope.retailSpotMarketDepth.ltp > 0) {
                    return $rootScope.retailSpotMarketDepth.ltp;
                }
            } else if (instrumentCode == 'CASH') {
                if (vm.cashMarketDepth.ltp > 0) {
                    return vm.cashMarketDepth.ltp;
                }
            } else if (instrumentCode == 'TOM') {
                if (vm.tomMarketDepth.ltp > 0) {
                    return vm.tomMarketDepth.ltp;
                }
            } else if (instrumentCode == 'Forward') {
                if (vm.forwardMarketDepth.ltp > 0) {
                    return vm.forwardMarketDepth.ltp;
                }
            }
            return $rootScope.previousDayClosingPriceForSpot;
        }

        function validateSession(instrumentCode, priceCondtion, tokenSequenceNo) {

            var validateSessionStatus = false;
            if (vm.currencyPair.code != 'USDINR') {
                validateSessionStatus = OrderUtil.validateSessionStatusUsingTokenSeqNo(tokenSequenceNo,instrumentCode);
            }
            else {
                validateSessionStatus = OrderUtil.validateSessionStatus(instrumentCode);
            }
            if (!validateSessionStatus.isValid) {
                vm.errorString = validateSessionStatus.errorString;
                return false;
            }
            // var validateAgreedTAC = OrderUtil.validateAgreedTAC(vm.tradingBank);
            // if (!validateAgreedTAC.isValid) {
            //     vm.errorString = validateAgreedTAC.errorString;
            //     return false;
            // }

            if (priceCondtion == 'STLS') {
                if (!isAllowedStopLossOrders()) {
                    return false;
                }
            }

            if (priceCondtion == 'TKPR') {
                if (!isAllowedTakeProfitOrders()) {
                    return false;
                }
            }
            return true;
        }

        function clearCorpTacAgreePopUp()
        {
            var validateAgreedTAC = OrderUtil.validateClearCorpAgreedTAC();

            if (!validateAgreedTAC.isValid) {
                MessageBox.openMessageBox("Alert", validateAgreedTAC.errorString, "Ok", "homepage");
            }
        }

        // validate order amount
        function validateOrderAmount(orderAmount) {
            var configSettings = $rootScope.configurationSettingsForOrder;
            var userPreference = angular.copy($rootScope.userPreferenceForOrder);
            var noOfDecimalsForAmount = angular.copy($rootScope.noOfDecimalsForAmountForOrder);
            var transactionParametersSettings = angular.copy($rootScope.transactionParametersSettingsForOrder);
            var currencyPair =  angular.copy($rootScope.currencyPairForOrder);
            // orderAmount = orderAmount.replace(/,/g, '');
            if (Math.round(parseFloat(orderAmount) * 100) / Math.round(parseFloat(1) * 100) == 0) {
                vm.errorString = 'Order value must be greater than zero...! ';
                return false;
            } else if (Number(orderAmount) < 0) {
                vm.errorString = 'Order value must be positive...!';
                return false;
            } else {
                var transactionParamterMinimumOrderValue = vm.globalValues.getTransactionParameterValue(currencyPair.id, "MinimumOrderValue");
                var transactionParamterMaximumOrderValue = vm.globalValues.getTransactionParameterValue(currencyPair.id, "MaximumOrderValueHardCheck");

                var userMaxHardCheck = null;
                if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.get) {
                    var pref = vm.currencyWiseUserPreferenceSettings.get(currencyPair.id);
                    if (pref && pref.maxOrderValueHardCheck != null) {
                        userMaxHardCheck = pref.maxOrderValueHardCheck;
                    }
                }

                if (transactionParamterMinimumOrderValue != null && transactionParamterMaximumOrderValue != null) {
                    if (Number(orderAmount) < Number(transactionParamterMinimumOrderValue)) {
                        vm.errorString = 'Order value should be greater than or equal to CCIL minimum order value (' + currencyPair.baseCurrency.code + ' ' + $filter('number')(transactionParamterMinimumOrderValue, noOfDecimalsForAmount) + '). Order entry restricted..!';
                        return false;
                    } else if (Number(orderAmount) > Number(transactionParamterMaximumOrderValue)) {
                        vm.errorString = 'Breach of CCIL maximum order value </br> <span class="hardcheck-value">(' + currencyPair.baseCurrency.code + ' ' + $filter('number')(transactionParamterMaximumOrderValue, noOfDecimalsForAmount) + ')</span> hard check.</br> Order entry restricted..!';
                        return false;
                    } else if (userMaxHardCheck != null && Number(orderAmount) > Number(userMaxHardCheck)) {
                        vm.errorString = 'Breach of user level maximum order value </br> <span class="hardcheck-value">(' + currencyPair.baseCurrency.code + ' ' + $filter('number')(userMaxHardCheck, noOfDecimalsForAmount) + ')</span> hard check.</br> Order entry restricted..!';
                        return false;
                    } else if (((Math.round(parseFloat(orderAmount) * 10000)) % (Math.round(parseFloat(configSettings.orderLotSize) * 10000))) != 0) {
                        vm.errorString = "Order value should be in multiples of lot size " + $filter('number')(configSettings.orderLotSize, noOfDecimalsForAmount) + "...!";
                        return false;
                    }
                }
            }
            return true;
        }

        function validateLimitCheck(oldOrderAmount, activityIndicator, orderAmount, instrumentCode, buySellFlag, priceCondition, tradeSettlementDate) {
            if ($rootScope.limitNotDefined) {
                vm.errorString = "Trading limits are not defined. Order entry not possible...!";
                return false;
            }
            //valdiate max tenor date
            if (instrumentCode == 'Forward') {
                if (moment(tradeSettlementDate).isAfter($rootScope.maxForwardTenorDate, 'day')) {
                    //vm.errorString = "Settlement date is beyond the given limit maximum tenor date. Cannot place order...!";
                    vm.errorString = "Order entry not possible. Settlement date selected is greater than the" +
                        " maximum tenor/value date defined by the Relationship Bank. Please refer the Limit Tab for more info on maximum tenor/value date allowed.";

                    return false;
                }
            }
            if (buySellFlag == 'SELL') {
                if (!validateSellLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount, priceCondition)) {
                    vm.errorString = "Sell trading limit breached. Order entry not possible...!";
                    return false;
                }
            } else if (buySellFlag == 'BUYY') {
                if (!validateBuyLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount, priceCondition)) {
                    vm.errorString = "Buy trading limit breached. Order entry not possible...!";
                    return false;
                }
            } else if (buySellFlag == 'SELLBUY') {
                if (priceCondition == 'MRKT') {
                    if (instrumentCode == 'SPOT') {
                        if (!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.retailSpotBuyLimitForMkt, $rootScope.retailSpotSellLimitForMkt)) {
                            return false;
                        }
                    } else if (instrumentCode == 'CASH') {
                        if (!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.cashBuyLimitForMkt, $rootScope.cashSellLimitForMkt)) {
                            return false;
                        }
                    } else if (instrumentCode == 'TOM') {
                        if (!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.tomBuyLimitForMkt, $rootScope.tomSellLimitForMkt)) {
                            return false;
                        }
                    } else if (instrumentCode == 'Forward') {
                        if (!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.forwardBuyLimitWithCF, $rootScope.forwardSellLimitWithCF)) {
                            return false;
                        }
                    }
                } else {
                    if (instrumentCode == 'SPOT') {
                        if (!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.retailSpotBuyLimit, $rootScope.retailSpotSellLimit)) {
                            return false;
                        }
                    } else if (instrumentCode == 'CASH') {
                        if (!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.cashBuyLimit, $rootScope.cashSellLimit)) {
                            return false;
                        }
                    } else if (instrumentCode == 'TOM') {
                        if (!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.tomBuyLimit, $rootScope.tomSellLimit)) {
                            return false;
                        }
                    } else if (instrumentCode == 'Forward') {
                        if (!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.forwardBuyLimitWithCF, $rootScope.forwardSellLimitWithCF)) {
                            return false;
                        }
                    }
                }
            }
            return true;
        }

        /*
         * validate limits for sell and buy order
         */
        function validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, buyLimit, sellLimit) {
            if ($rootScope.limitType == 'GLOBALGROSS' && orderAmount > (buyLimit / 2)) {
                vm.errorString = "Global gross limit breached. Order entry is not possible...!";
                return false;
            }
            if (orderAmount > buyLimit) {
                vm.errorString = "Buy trading limit breached. Order entry is not possible...!";
                return false;
            } else if (orderAmount > sellLimit) {
                vm.errorString = "Sell trading limit breached. Order entry is not possible...!";
                return false;
            }
            return true;
        }

        /*
         * validate sell limit
         */
        function validateSellLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount, priceCondition) {
            if (priceCondition == 'MRKT') {
                if (activityIndicator == 'PLAC') {
                    if (instrumentCode == 'SPOT') {
                        if (orderAmount > $rootScope.retailSpotSellLimitForMkt) {
                            return false;
                        }
                    } else if (instrumentCode == 'CASH') {
                        if (orderAmount > $rootScope.cashSellLimitForMkt) {
                            return false;
                        }
                    } else if (instrumentCode == 'TOM') {
                        if (orderAmount > $rootScope.tomSellLimitForMkt) {
                            return false;
                        }
                    } else if (instrumentCode == 'Forward') {
                        if (orderAmount > $rootScope.forwardSellLimitWithCF) {
                            return false;
                        }
                    }
                } else if (activityIndicator == 'MDFY') {
                    if (instrumentCode == 'SPOT') {
                        if (orderAmount > $rootScope.retailSpotSellLimitForMkt + oldOrderAmount) {
                            return false;
                        }
                    } else if (instrumentCode == 'CASH') {
                        if (orderAmount > $rootScope.cashSellLimitForMkt + oldOrderAmount) {
                            return false;
                        }
                    } else if (instrumentCode == 'TOM') {
                        if (orderAmount > $rootScope.tomSellLimitForMkt + oldOrderAmount) {
                            return false;
                        }
                    } else if (instrumentCode == 'Forward') {
                        if (orderAmount > $rootScope.forwardSellLimitWithCF + oldOrderAmount) {
                            return false;
                        }
                    }
                }
            } else {
                if (activityIndicator == 'PLAC') {
                    if (instrumentCode == 'SPOT') {
                        if (orderAmount > $rootScope.retailSpotSellLimit) {
                            return false;
                        }
                    } else if (instrumentCode == 'CASH') {
                        if (orderAmount > $rootScope.cashSellLimit) {
                            return false;
                        }
                    } else if (instrumentCode == 'TOM') {
                        if (orderAmount > $rootScope.tomSellLimit) {
                            return false;
                        }
                    } else if (instrumentCode == 'Forward') {
                        if (orderAmount > $rootScope.forwardSellLimitWithCF) {
                            return false;
                        }
                    }
                } else if (activityIndicator == 'MDFY') {
                    if (instrumentCode == 'SPOT') {
                        if (orderAmount > $rootScope.retailSpotSellLimit + oldOrderAmount) {
                            return false;
                        }
                    } else if (instrumentCode == 'CASH') {
                        if (orderAmount > $rootScope.cashSellLimit + oldOrderAmount) {
                            return false;
                        }
                    } else if (instrumentCode == 'TOM') {
                        if (orderAmount > $rootScope.tomSellLimit + oldOrderAmount) {
                            return false;
                        }
                    } else if (instrumentCode == 'Forward') {
                        if (orderAmount > $rootScope.forwardSellLimitWithCF + oldOrderAmount) {
                            return false;
                        }
                    }
                }
            }
            return true;
        }

        /*
         * validate buy limit
         */
        function validateBuyLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount, priceCondition) {
            if (priceCondition == 'MRKT') {
                if (activityIndicator == 'PLAC') {
                    if (instrumentCode == 'SPOT') {
                        if (orderAmount > $rootScope.retailSpotBuyLimitForMkt) {
                            return false;
                        }
                    } else if (instrumentCode == 'CASH') {
                        if (orderAmount > $rootScope.cashBuyLimitForMkt) {
                            return false;
                        }
                    } else if (instrumentCode == 'TOM') {
                        if (orderAmount > $rootScope.tomBuyLimitForMkt) {
                            return false;
                        }
                    } else if (instrumentCode == 'Forward') {
                        if (orderAmount > $rootScope.forwardBuyLimitWithCF) {
                            return false;
                        }
                    }
                } else if (activityIndicator == 'MDFY') {
                    if (instrumentCode == 'SPOT') {
                        if (orderAmount > $rootScope.retailSpotBuyLimitForMkt + oldOrderAmount) {
                            return false;
                        }
                    } else if (instrumentCode == 'CASH') {
                        if (orderAmount > $rootScope.cashBuyLimitForMkt + oldOrderAmount) {
                            return false;
                        }
                    } else if (instrumentCode == 'TOM') {
                        if (orderAmount > $rootScope.tomBuyLimitForMkt + oldOrderAmount) {
                            return false;
                        }
                    } else if (instrumentCode == 'Forward') {
                        if (orderAmount > $rootScope.forwardBuyLimitWithCF + oldOrderAmount) {
                            return false;
                        }
                    }
                }
            } else {
                if (activityIndicator == 'PLAC') {
                    if (instrumentCode == 'SPOT') {
                        if (orderAmount > $rootScope.retailSpotBuyLimit) {
                            return false;
                        }
                    } else if (instrumentCode == 'CASH') {
                        if (orderAmount > $rootScope.cashBuyLimit) {
                            return false;
                        }
                    } else if (instrumentCode == 'TOM') {
                        if (orderAmount > $rootScope.tomBuyLimit) {
                            return false;
                        }
                    } else if (instrumentCode == 'Forward') {
                        if (orderAmount > $rootScope.forwardBuyLimitWithCF) {
                            return false;
                        }
                    }
                } else if (activityIndicator == 'MDFY') {
                    if (instrumentCode == 'SPOT') {
                        if (orderAmount > $rootScope.retailSpotBuyLimit + oldOrderAmount) {
                            return false;
                        }
                    } else if (instrumentCode == 'CASH') {
                        if (orderAmount > $rootScope.cashBuyLimit + oldOrderAmount) {
                            return false;
                        }
                    } else if (instrumentCode == 'TOM') {
                        if (orderAmount > $rootScope.tomBuyLimit + oldOrderAmount) {
                            return false;
                        }
                    } else if (instrumentCode == 'Forward') {
                        if (orderAmount > $rootScope.forwardBuyLimitWithCF + oldOrderAmount) {
                            return false;
                        }
                    }
                }
            }

            return true;
        }

        function validateLimitExchangeRate(buySellFlag, activityIndicator, priceCondition, limitExchangeRate, limitExchangeRateInSpot, ordertickSize, ltp, allowedOrderPriceDeviationInPercent, allowedOrderPriceDeviationInPercentUserSettings,alertInstrumentCode) {
            ltp = Number(ltp);
            if (priceCondition != 'MRKT') {
                if (Number(limitExchangeRate) < 0) {
                    if (buySellFlag == 'BUYY') {
                        vm.errorString = 'Buy limit price must be positive...!';
                    } else {
                        vm.errorString = 'Sell limit price must be positive...!';
                    }
                    return false;
                }
            }

            if ((priceCondition != 'MRKT' && Number(limitExchangeRate) == 0) || (priceCondition == 'MRKT' && activityIndicator == 'MDFY' && Number(limitExchangeRate) == 0)) {
                if (buySellFlag == 'BUYY') {
                    vm.errorString = 'Buy limit price must be greater than zero...!';
                } else {
                    vm.errorString = 'Sell limit price must be greater than zero...!';
                }
                return false;
            }
            var tickSizeRemainder = (Math.round(parseFloat(limitExchangeRate) * 10000)) % (Math.round(parseFloat(ordertickSize) * 10000));
            if (tickSizeRemainder != 0 && priceCondition != 'MRKT') {
                if (buySellFlag == 'BUYY') {
                    vm.errorString = 'Buy limit price should be in multiples of tick size ' + Number(ordertickSize) + '...!';
                } else {
                    vm.errorString = 'Sell limit price should be in multiples of tick size ' + Number(ordertickSize) + '...!';
                }
                return false;
            }
            /*
             * var higherCutOffPrice =
             * $rootScope.previousDayClosingPriceForIbSpot +
             * ($rootScope.previousDayClosingPriceForIbSpot *
             * Number(allowedOrderPriceDeviationInPercent/100)); var
             * lowerCutOffPrice = $rootScope.previousDayClosingPriceForIbSpot -
             * ($rootScope.previousDayClosingPriceForIbSpot *
             * Number(allowedOrderPriceDeviationInPercent/100));
             *
             * if(ltp>0 && ltp!=undefined && ltp!=null){ higherCutOffPrice = ltp +
             * (ltp * Number(allowedOrderPriceDeviationInPercent/100));
             * lowerCutOffPrice = ltp - (ltp *
             * Number(allowedOrderPriceDeviationInPercent/100)); }
             * higherCutOffPrice =
             * (Math.round(parseFloat(higherCutOffPrice)*10000)/10000);
             * lowerCutOffPrice =
             * (Math.round(parseFloat(lowerCutOffPrice)*10000)/10000) var
             * higherCutOffPriceRemainder =
             * ((Math.round(parseFloat(higherCutOffPrice)*10000)/10000) %
             * (Math.round(parseFloat(ordertickSize)*10000)/10000));
             * higherCutOffPrice =
             * (Math.round(parseFloat(higherCutOffPrice)*10000)/10000) -
             * (Math.round(parseFloat(higherCutOffPriceRemainder)*10000)/10000);
             *
             * var lowerCutOffPriceRemainder =
             * ((Math.round(parseFloat(lowerCutOffPrice)*10000)/10000) %
             * (Math.round(parseFloat(ordertickSize)*10000)c0));
             * lowerCutOffPrice =
             * (Math.round(parseFloat(lowerCutOffPrice)*10000)/10000) -
             * (Math.round(parseFloat(lowerCutOffPriceRemainder)*10000)/10000) +
             * (Math.round(parseFloat(ordertickSize)*10000)/10000);
             *
             * if(priceCondition!='MRKT' &&
             * (Math.round(parseFloat(limitExchangeRateInSpot)*10000) <
             * Math.round(parseFloat(lowerCutOffPrice)*10000) ||
             * Math.round(parseFloat(limitExchangeRateInSpot)*10000) >
             * Math.round(parseFloat(higherCutOffPrice)*10000))){
             * if(buySellFlag=='BUYY'){ vm.errorString = 'Buy limit price range
             * should be in between ' + $filter('number')(lowerCutOffPrice, 4) + '
             * and ' + $filter('number')(higherCutOffPrice, 4) + '...!'; }else{
             * vm.errorString = 'Sell limit price range should be in between ' +
             * $filter('number')(lowerCutOffPrice, 4) + ' and ' +
             * $filter('number')(higherCutOffPrice, 4) + '...!'; } return false; }
             */

            if (!validateLimitExchangeRateRange(limitExchangeRateInSpot, allowedOrderPriceDeviationInPercentUserSettings, ltp, ordertickSize, priceCondition, buySellFlag, 'user',alertInstrumentCode)) {
                return false;
            }

            if (!validateLimitExchangeRateRange(limitExchangeRateInSpot, allowedOrderPriceDeviationInPercent, ltp, ordertickSize, priceCondition, buySellFlag, 'clearcorp',alertInstrumentCode)) {
                return false;
            }

            return true;
        }

        function validateLimitExchangeRateRange(limitExchangeRateInSpot, allowedOrderPriceDeviationInPercent, ltp, ordertickSize, priceCondition, buySellFlag, level,alertInstrumentCode) {
            var higherCutOffPrice = $rootScope.previousDayClosingPriceForIbSpot + ($rootScope.previousDayClosingPriceForIbSpot * Number(allowedOrderPriceDeviationInPercent / 100));
            var lowerCutOffPrice = $rootScope.previousDayClosingPriceForIbSpot - ($rootScope.previousDayClosingPriceForIbSpot * Number(allowedOrderPriceDeviationInPercent / 100));

            if (ltp > 0 && ltp != undefined && ltp != null) {
                higherCutOffPrice = ltp + (ltp * Number(allowedOrderPriceDeviationInPercent / 100));
                lowerCutOffPrice = ltp - (ltp * Number(allowedOrderPriceDeviationInPercent / 100));
            }
            higherCutOffPrice = (Math.round(parseFloat(higherCutOffPrice) * 10000) / 10000);
            lowerCutOffPrice = (Math.round(parseFloat(lowerCutOffPrice) * 10000) / 10000)
            var higherCutOffPriceRemainder = (Math.round(parseFloat(((Math.round(parseFloat(higherCutOffPrice) * 10000)) % (Math.round(parseFloat(ordertickSize) * 10000)) / 10000)) * 10000) / 10000);
            higherCutOffPrice = (Math.round(parseFloat(higherCutOffPrice) * 10000) / 10000) - (Math.round(parseFloat(higherCutOffPriceRemainder) * 10000) / 10000);

            var lowerCutOffPriceRemainder = (Math.round(parseFloat(((Math.round(parseFloat(lowerCutOffPrice) * 10000)) % (Math.round(parseFloat(ordertickSize) * 10000)) / 10000)) * 10000) / 10000);
            if (lowerCutOffPriceRemainder != 0) {
                lowerCutOffPrice = (Math.round(parseFloat(lowerCutOffPrice) * 10000) / 10000) - (Math.round(parseFloat(lowerCutOffPriceRemainder) * 10000) / 10000) + (Math.round(parseFloat(ordertickSize) * 10000) / 10000);
            } else {
                lowerCutOffPrice = (Math.round(parseFloat(lowerCutOffPrice) * 10000) / 10000);
            }

            if (priceCondition != 'MRKT' && (Math.round(parseFloat(limitExchangeRateInSpot) * 10000) < Math.round(parseFloat(lowerCutOffPrice) * 10000) || Math.round(parseFloat(limitExchangeRateInSpot) * 10000) > Math.round(parseFloat(higherCutOffPrice) * 10000))) {
                if (buySellFlag == 'BUYY') {
                    if (level == 'user') {
                        vm.errorString = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached User level limit price Hard check.</br> BUY Equivalent Spot Price should be between </br>' + "<span class='hardcheck-value'>" + $filter('number')(lowerCutOffPrice, vm.noOfDecimalsForRate) + "</span> " + ' and ' + "<span class='hardcheck-value'>" + $filter('number')(higherCutOffPrice, vm.noOfDecimalsForRate) + "</span> ";
                    } else {
                        vm.errorString = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached CCIL limit price Hard check.</br> BUY Equivalent Spot Price should be between </br> ' + "<span class='hardcheck-value'>" + $filter('number')(lowerCutOffPrice, vm.noOfDecimalsForRate) + "</span> " + ' and ' + "<span class='hardcheck-value'>" + $filter('number')(higherCutOffPrice, vm.noOfDecimalsForRate) + "</span> ";
                    }
                } else {
                    if (level == 'user') {
                        if (vm.errorString != '') {
                            vm.errorString = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached User level limit price Hard check.</br> BUY and SELL Equivalent Spot Price should be between </br>' + "<span class='hardcheck-value'>" + $filter('number')(lowerCutOffPrice, vm.noOfDecimalsForRate) + "</span> " + ' and ' + "<span class='hardcheck-value'>" + $filter('number')(higherCutOffPrice, vm.noOfDecimalsForRate) + "</span> ";
                        } else {
                            vm.errorString = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached User level limit price Hard check.</br> SELL Equivalent Spot Price should be between </br>' + "<span class='hardcheck-value'>" + $filter('number')(lowerCutOffPrice, vm.noOfDecimalsForRate) + "</span> " + ' and ' + "<span class='hardcheck-value'>" + $filter('number')(higherCutOffPrice, vm.noOfDecimalsForRate) + "</span> ";
                        }
                    } else {
                        if (vm.errorString != '') {
                            vm.errorString = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached CCIL limit price Hard check.</br> BUY and SELL Equivalent Spot Price should be between </br>' + "<span class='hardcheck-value'>" + $filter('number')(lowerCutOffPrice, vm.noOfDecimalsForRate) + "</span> " + ' and ' + "<span class='hardcheck-value'>" + $filter('number')(higherCutOffPrice, vm.noOfDecimalsForRate) + "</span> ";
                        } else {
                            vm.errorString = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached CCIL limit price Hard check.</br> SELL Equivalent Spot Price should be between </br>' + "<span class='hardcheck-value'>" + $filter('number')(lowerCutOffPrice, vm.noOfDecimalsForRate) + "</span> " + ' and ' + "<span class='hardcheck-value'>" + $filter('number')(higherCutOffPrice, vm.noOfDecimalsForRate) + "</span> ";
                        }
                    }
                }
                return false;
            }
            return true;
        }

        function validateStopExchangeRate(priceCondition, buySellFlag, limitExchangeRate, stopExchangeRate, ordertickSize) {
            if (Number(stopExchangeRate) < 0) {
                vm.errorString = 'Trigger price must be positive...!';
                return false;
            }

            if (priceCondition != 'MRKT' && priceCondition != 'LIMT' && Number(stopExchangeRate) == 0) {
                vm.errorString = 'Trigger price cannot be zero...!';
                return false;
            }

            if (priceCondition == 'STLS' || priceCondition == 'TKPR') {
                if (buySellFlag == 'BUYY' && Number(stopExchangeRate) > Number(limitExchangeRate)) {
                    vm.errorString = 'Buy trigger price should be less than or equal to the buy limit price...!';
                    // return false;
                }
                if (buySellFlag == 'SELL' && Number(stopExchangeRate) < Number(limitExchangeRate)) {
                    if (vm.errorString != '') {
                        vm.errorString = vm.errorString + ' And sell trigger price should be greater than or equal to the sell limit price...!';
                    } else {
                        vm.errorString = 'Sell trigger price should be greater than or equal to the sell limit price...!';
                    }
                    return false;
                }
                var tickSizeRemainder = (Math.round(parseFloat(stopExchangeRate) * 10000)) % (Math.round(parseFloat(ordertickSize) * 10000));
                if (tickSizeRemainder != 0) {
                    if (buySellFlag == 'BUYY') {
                        vm.errorString = 'Buy trigger price should be in multiples of tick size ' + Number(ordertickSize) + '...!';
                    } else if (buySellFlag == 'SELL') {
                        if (vm.errorString != '') {
                            vm.errorString = vm.errorString + ' And sell trigger price should be in multiples of tick size ' + Number(ordertickSize) + '...!';
                        } else {
                            vm.errorString = 'Sell trigger price should be in multiples of tick size ' + Number(ordertickSize) + '...!';
                        }
                        return false;
                    }
                }
            }
            return true;
        }

        function validateSpreadUsed(selectedBankSpread, instrumentCode, buySellFlag) {
            if (instrumentCode != 'SPOT' && vm.currencyPair.code === 'USDINR') {
                var tickSize = gettickSizeForGivenInstrument(instrumentCode);
                var settlementDate = getSettlementDate(instrumentCode, buySellFlag);


                var settlementFromInstrumentAndCurrency = $rootScope.marketSessionMap[vm.defaultInstrumentTokenSequenceNo];

                var spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate(selectedBankSpread, instrumentCode, buySellFlag,
                    DateUtils.convertLocalDateToServer(settlementDate), vm.currencyPair.code === 'USDINR' ? $rootScope.retailSpotMarketSession.settlementDate : settlementFromInstrumentAndCurrency.settlementDate,
                    tickSize);
                //var spreadUsed = getSpreadUsed(selectedBankSpread, buySellFlag, instrumentCode);
                if ((spreadUsed == null || spreadUsed == undefined || spreadUsed == '') && spreadUsed != 0) {
                    if (buySellFlag == 'BUYY') {
                        if (instrumentCode == 'CASH') {
                            vm.errorString = 'CASH/SPOT bid spread is not given by the bank. Order entry not possible...!';
                        } else if (instrumentCode == 'TOM') {
                            vm.errorString = 'TOM/SPOT bid spread is not given by the bank. Order entry not possible...!';
                        } else if (instrumentCode == 'Forward') {
                            vm.errorString = 'Order entry not possible as FORWARD offer spread for the selected settlement date (' + $filter('date')(settlementDate, 'dd-MMM-yyyy') + ') is not provided by your Relationship bank.';
                        }
                    } else if (buySellFlag == 'SELL') {
                        if (instrumentCode == 'CASH') {
                            vm.errorString = 'CASH/SPOT offer spread is not given by the bank. Order entry not possible...!';
                        } else if (instrumentCode == 'TOM') {
                            vm.errorString = 'TOM/SPOT offer spread is not given by the bank. Order entry not possible...!';
                        } else if (instrumentCode == 'Forward') {
                            vm.errorString = 'Order entry not possible as FORWARD bid spread for the selected settlement date (' + $filter('date')(settlementDate, 'dd-MMM-yyyy') + ') is not provided by your Relationship bank.';
                        }
                    }
                    return false;
                }
            }
            return true;
        }

        function getSpreadUsed(selectedBankSwapQuote, buySellFlag, instrumentCode) {
            if (buySellFlag == 'BUYY') {
                if (instrumentCode == 'CASH') {
                    return selectedBankSwapQuote.cashSpotBidSpread;
                } else if (instrumentCode == 'TOM') {
                    return selectedBankSwapQuote.tomSpotBidSpread;
                } else if (instrumentCode == 'Forward') {
                    return selectedBankSwapQuote.forwardSpotBidSpread;
                }
            } else if (buySellFlag == 'SELL') {
                if (instrumentCode == 'CASH') {
                    return selectedBankSwapQuote.cashSpotOfferSpread;
                } else if (instrumentCode == 'TOM') {
                    return selectedBankSwapQuote.tomSpotOfferSpread;
                } else if (instrumentCode == 'Forward') {
                    return selectedBankSwapQuote.forwardSpotOfferSpread;
                }
            }
        }

        function placeOrderRequest(orderDTO) {

            console.log("place currency ",vm.currencyPair);
            //on 18-Nov-2020. db writer issue - added call back procedures while sending orders
            if (orderDTO.buySellIndicator != 'SELLBUY') {
                addLimitPriceToArray(orderDTO.limitExchangeRate);
                sendNewOrder(orderDTO);
            } else if (orderDTO.buySellIndicator == 'SELLBUY') {
                var sellOrderDTO = getSellOrderDTO(orderDTO);
                var buyOrderDTO = getBuyOrderDTO(orderDTO);
                addSellLimitPriceToArray(sellOrderDTO.limitExchangeRate);
                if (OrderUtil.validateOrderDTOForNull(sellOrderDTO) && OrderUtil.validateOrderDTOForNull(buyOrderDTO)) {
                    Market.placeOrder(sellOrderDTO);
                    addBuyLimitPriceToArray(buyOrderDTO.limitExchangeRate);
                    Market.placeOrder(buyOrderDTO, onOrderSuccess, onOrderFailure);
                } else {
                    MessageBox.openMessageBox("Alert", "The order request is not processed, please submit again.", "Ok", "orderrequestfailure");
                }
            }
        }

        function sendNewOrder(orderDTO) {
            if (OrderUtil.validateOrderDTOForNull(orderDTO)) {
                Market.placeOrder(orderDTO, onOrderSuccess, onOrderFailure);
            } else {
                MessageBox.openMessageBox("Alert", "The order request is not processed, please submit again.", "Ok", "orderrequestfailure");
            }
        }

        // function onPlaceOrderSuccess(result) {
        //     //vm.remarks = "";
        //     setDefaultRemark();
        //     fillDefaultValuesToControls();
        // }

        // function onPlaceOrderFailure(result) {
        //     console.log(result);
        //     if (result.data == "Access Denied") {

        //     }
        // }

        function getBuyOrderDTO(orderDTO) {
            var buyOrderDTO = angular.copy(orderDTO);
            buyOrderDTO.buySellIndicator = 'BUYY';
            buyOrderDTO.limitExchangeRate = orderDTO.buyLimitExchangeRate;
            buyOrderDTO.stopExchangeRate = orderDTO.buyStopExchangeRate;
            return buyOrderDTO;
        }

        function getSellOrderDTO(orderDTO) {
            var sellOrderDTO = angular.copy(orderDTO);
            sellOrderDTO.buySellIndicator = 'SELL';
            sellOrderDTO.limitExchangeRate = orderDTO.sellLimitExchangeRate;
            sellOrderDTO.stopExchangeRate = orderDTO.sellStopExchangeRate;
            return sellOrderDTO;
        }

        $scope.$watch(    function () {
        return vm.tradingBank;
    },
    function (newValue, oldValue) {

        if (newValue && newValue !== oldValue) {
            var value = newValue;
            if (vm.account != null && vm.account != undefined && value != null && value != undefined) {
                vm.defaultTradingBankControl = value;
                $rootScope.tradingBank = value;
                if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                    //CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
                    var result = _.filter(angular.copy($rootScope.tradingRelationsForCustomer), function (item) { return item.bank.id == value.id; });
                    vm.tradingBranch = result[0].tradingBranch;
                    //})
                    $timeout(function () {
                        vm.tradingCustomer = vm.globalValues.getCustomer();
                    }, 100)

                    if ($rootScope.bankComparativeDTO != null && $rootScope.bankComparativeDTO != undefined && $rootScope.bankComparativeDTO != null &&
                        $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList.length > 0) {
                        $rootScope.defaultBankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, vm.tradingBank.id);
                    }

                    $rootScope.selectedCreditFactor = MarketWatch.getCreditFactorSettingsForGivenBank($rootScope.creditFactorList, vm.tradingBank.id);

                    if (vm.account.organisation.organisationType.shortName == 'CLEARCORP') {
                        if (vm.defaultTradingCustomer != null && vm.defaultTradingCustomer != undefined) {
                            getLimitsAvailableForAllInstruments(vm.tradingBank.id, vm.defaultTradingCustomer.id);
                        }
                    } else if (vm.account.organisation.organisationType.shortName == 'BANK') {
                        if (vm.defaultTradingCustomer != null && vm.defaultTradingCustomer != undefined) {
                            getLimitsAvailableForAllInstruments(vm.globalValues.getOrganisation().id, vm.defaultTradingCustomer.id);
                        }
                    } else if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                        getLimitsAvailableForAllInstruments(vm.tradingBank.id, vm.globalValues.getCustomer().id);
                    }
                }

                StaticLookUp.getCurrencyPairInstruments({"bankId": vm.tradingBank.id},onBankCurrencySuccess,onBankCurrencyFailure);

                //prepare user market watch list online while change of trading bank
                prepareUserMarketWatchOnline();

                //prepareOutrightComparision($rootScope.outrightRateSettlementDate, $rootScope.outrightRateInstrument);
            } else {
                vm.tradingBranch = null;
            }
        }
        })

        function onBankCurrencySuccess(result){
            initialiseCurrencyPairInstruments(result);
            initialiseMarketWatchMap(result);
            getMarketDepthDetailsForReport();
        }

         $scope.$watch(    function () {
        return vm.tradingCustomer;
    },
    function (newValue, oldValue) {

         if (newValue && newValue !== oldValue) {

            var value = newValue;
            if (vm.account != null && vm.account != undefined && value != null && value != undefined) {
                $rootScope.tradingCustomer = value;
                if (vm.account.organisation.organisationType.shortName != 'CUSTOMER') {
                    /*
                     * vm.defaultTradingCustomer = vm.tradingCustomer;
                     * $rootScope.defaultTradingCustomer = vm.tradingCustomer;
                     */
                    vm.defaultTradingCustomerControl = vm.tradingCustomer;
                    $timeout(function () {
                        if (vm.account.organisation.organisationType.shortName == 'CLEARCORP') {
                            if (vm.defaultTradingCustomer != null && vm.defaultTradingCustomer != undefined) {
                                getLimitsAvailableForAllInstruments(vm.tradingBank.id, vm.tradingCustomer.id);
                            }
                        } else if (vm.account.organisation.organisationType.shortName == 'BANK') {
                            if (vm.tradingCustomer != null && vm.tradingCustomer != undefined) {
                                getLimitsAvailableForAllInstruments(vm.globalValues.getOrganisation().id, vm.tradingCustomer.id);
                            }
                        } else if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                            getLimitsAvailableForAllInstruments(vm.tradingBank.id, vm.tradingCustomer.id);
                        }
                    }, 100)
                }

                //     StaticLookUp.getCurrencyPairInstruments({"bankId": vm.tradingBank.id},onBankCurrencySuccess,onBankCurrencyFailure);


                if (vm.account.entityOwnerType.shortName == 'Bank') {
                    CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({ bankId: vm.globalValues.getOrganisation().id, customerId: value.id }, function (result) {
                        vm.tradingBranch = result;
                    })
                }
            }
          }
        })

        $scope.$watch('vm.bankFilterForLimit', function (value) {
            if (vm.account != null && vm.account != undefined && value != null && value != undefined) {
                $rootScope.bankFilterForLimit = value;
                if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                    //CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
                    var result = _.filter(angular.copy($rootScope.tradingRelationsForCustomer), function (item) { return item.bank.id == value.id; });
                    vm.branchFilterForLimit = result[0].tradingBranch;
                    $rootScope.branchFilterForLimit = result[0].tradingBranch;
                    //});
                    // get the limits when the bakFilterForLimit changes\
                    //this is commented on phase 3 implementation,. to change 'change request' and 'new limit request' buttons' behaviour depend on lookup controls
                    //LimitSettings.getLimitsAvailableForAllInstruments({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, checkLimitOnBankFilterChangeSuccess, onGetLimitsAvailableFailure);
                }
            } else {
                vm.branchFilterForLimit = null;
                $rootScope.bankFilterForLimit = null;
                $rootScope.branchFilterForLimit = null;
                // $rootScope.limitAvailableForSlectBankFilterInReport = false;
            }
        })

        function checkLimitOnBankFilterChangeSuccess(result) {
            if (result != null && result != undefined && result.length > 0) {
                $rootScope.limitAvailableForSlectBankFilterInReport = true;
            } else {
                $rootScope.limitAvailableForSlectBankFilterInReport = false;
            }
        }


        $scope.$watch('vm.bankFilterForOT', function (value) {
            if (vm.account != null && vm.account != undefined && value != null && value != undefined) {
                $rootScope.bankFilterForOT = value;
                if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                    //CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
                    var result = _.filter(angular.copy($rootScope.tradingRelationsForCustomer), function (item) { return item.bank.id == value.id; });
                    vm.branchFilterForOT = result[0].tradingBranch;
                    $rootScope.branchFilterForOT = result[0].tradingBranch;
                    //})
                }
            } else {
                vm.branchFilterForOT = null;
                $rootScope.bankFilterForOT = null;
                $rootScope.branchFilterForOT = null;
            }
        })

        $scope.$watch('vm.bankFilterForPO', function (value) {
            if (vm.account != null && vm.account != undefined && value != null && value != undefined) {
                $rootScope.bankFilterForPO = value;
                if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                    //CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
                    var result = _.filter(angular.copy($rootScope.tradingRelationsForCustomer), function (item) { return item.bank.id == value.id; });
                    vm.branchFilterForPO = result[0].tradingBranch;
                    $rootScope.branchFilterForPO = result[0].tradingBranch;
                    //})
                }
            } else {
                vm.branchFilterForPO = null;
                $rootScope.bankFilterForPO = null;
                $rootScope.branchFilterForPO = null;
            }
        })

        $scope.$watch('vm.bankFilterForTrade', function (value) {
            if (vm.account != null && vm.account != undefined && value != null && value != undefined) {
                $rootScope.bankFilterForTrade = value;
                if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                    //CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
                    var result = _.filter(angular.copy($rootScope.tradingRelationsForCustomer), function (item) { return item.bank.id == value.id; });
                    vm.branchFilterForTrade = result[0].tradingBranch;
                    $rootScope.branchFilterForTrade = result[0].tradingBranch;
                    //})
                }
            } else {
                vm.branchFilterForTrade = null;
                $rootScope.bankFilterForTrade = null;
                $rootScope.branchFilterForTrade = null;
            }
        })

        //events emitted from the expanded reports view
        var modifypendingorder = $rootScope.$on('modifypendingorder', function (event, result) {
            if ($rootScope.pendingOrderToModify != null && $rootScope.modifyCount > 0) {
                console.log('modifypendingorder');
                modifyOrder($rootScope.pendingOrderToModify);
            }
            $rootScope.modifyCount = $rootScope.modifyCount + 1;
        });

        var cancelpendingtrade = $rootScope.$on('cancelpendingtrade', function (event, result) {
            if ($rootScope.cancelTradeCount > 0) {
                console.log('cancelcontractcancellation');
                prepareOrderDTOToCancelTrade($rootScope.outstandingTradeToCancel);
            }
            $rootScope.cancelTradeCount = $rootScope.cancelTradeCount + 1;
        });

        var rolloverpendingtrade = $rootScope.$on('rolloverpendingtrade', function (event, result) {
            if ($rootScope.rolloverTradeCount > 0) {
                console.log('rollovertrade');
                prepareOrderDTOToRollOverTrade($rootScope.outstandingTradeToRollover);
            }
            $rootScope.rolloverTradeCount = $rootScope.rolloverTradeCount + 1;
        });

        var earlydeliverypendingtrade = $rootScope.$on('earlydeliverypendingtrade', function (event, result) {
            if ($rootScope.earlyDeliveryTradeCount > 0) {
                console.log('earlydeliverytrade');
                prepareOrderDTOToEarlyDeliveryTrade($rootScope.outstandingTradeToEarlyDelivery);
            }
            $rootScope.earlyDeliveryTradeCount = $rootScope.earlyDeliveryTradeCount + 1;
        });

        var cancelpendingorder = $rootScope.$on('cancelpendingorder', function (event, result) {
            if ($rootScope.pendingOrderToCancel != null && $rootScope.cancelCount > 0) {
                console.log('cancelpendingorder');
                setTimeout(function () {
                    cancelOrder($rootScope.pendingOrderToCancel);
                }, 100);
            }
            $rootScope.cancelCount = $rootScope.cancelCount + 1;
        });

        var cancelselectedpendingorders = $rootScope.$on('cancelselectedpendingorders', function (event, result) {
            if ($rootScope.cancelSelectedCount > 0) {
                cancelPendingOrdersSelected();
            }
            $rootScope.cancelSelectedCount = $rootScope.cancelSelectedCount + 1;
        })

        var cancelallpendingorders = $rootScope.$on('cancelallpendingorders', function (event, result) {
            if ($rootScope.cancelSelectedCount > 0) {
                cancelAllOrders();
            }

            $rootScope.cancelSelectedCount = $rootScope.cancelSelectedCount + 1;
        })

        var cancelselectedfrompreorderconfirmation = $rootScope.$on('cancelselectedfrompreorderconfirmation', function (event, result) {
            if ($rootScope.cancelSelectedOrderCount > 0) {
                cancelSelectedOrders();
            }
            $rootScope.cancelSelectedOrderCount = $rootScope.cancelSelectedOrderCount + 1;
        })

        var limitchangerequestfromexp = $rootScope.$on('limitchangerequestfromexp', function (event, result) {
            if ($rootScope.limitChangeRequestCount > 0) {
                setTimeout(function () {
                    limitChangeRequest($rootScope.selectedLimit);
                }, 100)
            }
            $rootScope.limitChangeRequestCount = $rootScope.limitChangeRequestCount + 1;
        })

        var newlimitrequestfromexp = $rootScope.$on('newlimitrequestfromexp', function (event, result) {
            if ($rootScope.newLimitRequestCount > 0) {
                setTimeout(function () {
                    newLimitRequest();
                }, 100)
            }
            $rootScope.newLimitRequestCount = $rootScope.newLimitRequestCount + 1;
        })

        var syncinputs = $rootScope.$on('syncinputs', function (event, result) {
            vm.customerFilterForPO = $rootScope.customerFilterForPO;
            vm.customerFilterForLimit = $rootScope.customerFilterForLimit;
            vm.customerFilterForTrade = $rootScope.customerFilterForTrade;
            vm.customerFilterForOT = $rootScope.customerFilterForOT;

            vm.bankFilterForPO = $rootScope.bankFilterForPO;
            vm.bankFilterForLimit = $rootScope.bankFilterForLimit;
            vm.bankFilterForTrade = $rootScope.bankFilterForTrade;
            vm.bankFilterForOT = $rootScope.bankFilterForOT;

            vm.branchFilterForPO = $rootScope.branchFilterForPO;
            vm.branchFilterForLimit = $rootScope.branchFilterForLimit;
            vm.branchFilterForTrade = $rootScope.branchFilterForTrade;
            vm.branchFilterForOT = $rootScope.branchFilterForOT;

            vm.instrumentFilterForPO = $rootScope.instrumentFilterForPO;
            vm.instrumentFilterForLimit = $rootScope.instrumentFilterForLimit;
            vm.instrumentFilterForTrade = $rootScope.instrumentFilterForTrade;
            vm.instrumentFilterForOT = $rootScope.instrumentFilterForOT;

            vm.currencyPairForPO = $rootScope.currencyPairForPO;
            vm.currencyPairForOT = $rootScope.currencyPairForOT;
            vm.currencyPairForTrade = $rootScope.currencyPairForTrade;
            vm.currencyPairForLimit = $rootScope.currencyPairForLimit;
            vm.currencyPairForMarkup = $rootScope.currencyPairForMarkup;

            vm.fromSettlementDate = $rootScope.fromSettlementDate;
            vm.toSettlementDate = $rootScope.toSettlementDate;
            vm.selectAll = $rootScope.selectAll;
            vm.reportTab = $rootScope.reportTab;
        });

        //to refresh home page reports from database after websocket reconnection
        var refreshreports = $rootScope.$on("refreshreports", function (event) {
            if ($rootScope.refreshreportscount > 0) {
                setIntradayMarketSessionDetails();
                getPendingOrdersReport();
                getOutstandingTradesReport();
                getTradesReport();
                getLimitUtilisedReport();
                getNotifications();
            }
            $rootScope.refreshreportscount = $rootScope.refreshreportscount + 1;
        });

        $scope.$on('$destroy', function () {
            modifypendingorder();
            cancelpendingorder();
            syncinputs();
            cancelpendingtrade();
            rolloverpendingtrade();
            earlydeliverypendingtrade();
            cancelselectedpendingorders();
            cancelallpendingorders();
            limitchangerequestfromexp();
            newlimitrequestfromexp();
            cancelselectedfrompreorderconfirmation();
            orderplacedsuccess();
            refreshreports();
            proceedCancelAllOrders();
            $rootScope.lookupFilled = null;
        });

        // modify selected order
        function modifyOrder(pendingOrder) {
            //vm.remarks = "";
            setDefaultRemark();

            if(pendingOrder.currencyPair==null){
                            angular.forEach($rootScope.currencyPairList, function (cp) {
                if (cp.id === pendingOrder.currencyPairId) {
                    pendingOrder.currencyPair = cp;
                }
            });
            }

            setSelectedCurrecy(pendingOrder.currencyPairId,'MDFY');
            prepareOrderDTO(pendingOrder, 'MDFY');
        }

        function cancelTrade() {
            //vm.remarks = "";
            setDefaultRemark();
            var outstandingTrades = angular.copy($rootScope.outstandingTrades);
            var outstandingTrade = _.filter(outstandingTrades, { 'select': true });
            if (validateOutstandingTrade(outstandingTrade)) {
                prepareOrderDTOToCancelTrade(outstandingTrade[0]);
            }
        }

        function validateOutstandingTrade(outstandingTrade) {
            var isValid = true;

            if (outstandingTrade.length > 0) {
                //validate selected contract is forward contract
                if (outstandingTrade[0].instrumentCode != 'Forward') {	//&& outstandingTrade[0].eventTypeName!='Early Delivery'
                    isValid = false;
                    MessageBox.openMessageBox("Alert", "The SPOT/TOM/CASH contract cannot be cancelled.", "Ok", "selectedorders");
                } else {
                    //validate outstanding amount
                    var cancellationSettlementDate = getSettlementDateForContractCancellation(outstandingTrade[0]);
                    var instrumentCode = getInstrumentCodeForSettlement(cancellationSettlementDate);
                    if ((outstandingTrade[0].outStandingAmount - outstandingTrade[0].blockedAmount) <= 0) {
                        isValid = false;
                        MessageBox.openMessageBox("Alert", "Cancellation order(s) is already pending for execution, the operation is not permitted...!", "Ok", "selectedorders");
                    }
                    //validate spread
                    if (instrumentCode != 'SPOT') {
                        var tickSize = gettickSizeForGivenInstrument(instrumentCode);
                        var buySellIndicator = 'BUYY';
                        if (outstandingTrade[0].buySellIndicator == 'BUYY') {
                            buySellIndicator = 'SELL';
                        }
                        var bankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, outstandingTrade[0].bankId);
                        var spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate(bankSpread, instrumentCode, buySellIndicator,
                            DateUtils.convertLocalDateToServer(angular.copy(cancellationSettlementDate)), vm.currencyPair.code === 'USDINR' ? $rootScope.retailSpotMarketSession.settlementDate : $rootScope.marketSessionMap[vm.defaultInstrumentTokenSequenceNo].settlementDate,
                            tickSize);
                        if (spreadUsed == null || spreadUsed == undefined) {
                            isValid = false;
                            if (buySellIndicator == 'BUYY') {
                                if (instrumentCode == 'Forward') {
                                    MessageBox.openMessageBox("Alert", "Order entry not possible as FORWARD offer spread for the selected settlement date (" + $filter('date')(cancellationSettlementDate, 'dd-MMM-yyyy') + ") is not provided by your Relationship bank.", "Ok", "selectedorders");
                                } else {
                                    MessageBox.openMessageBox("Alert", instrumentCode + "/SPOT bid spread is not given by the bank. Order entry not possible...!", "Ok", "selectedorders");
                                }
                            } else {
                                if (instrumentCode == 'Forward') {
                                    MessageBox.openMessageBox("Alert", "Order entry not possible as FORWARD bid spread for the selected settlement date (" + $filter('date')(cancellationSettlementDate, 'dd-MMM-yyyy') + ") is not provided by your Relationship bank.", "Ok", "selectedorders");
                                } else {
                                    MessageBox.openMessageBox("Alert", instrumentCode + "/SPOT offer spread is not given by the bank. Order entry not possible...!", "Ok", "selectedorders");
                                }
                            }
                        }
                    }
                }
            } else {
                isValid = false;
                MessageBox.openMessageBox("Alert", "Please select a trade to proceed.", "Ok", "selectedorders");
            }
            return isValid;
        }

        vm.prepareOrderDTOToCancelTrade = prepareOrderDTOToCancelTrade;
        function prepareOrderDTOToCancelTrade(outstandingTradeObj) {
            //on 18-Nov-2020. db writer null issue - intermediate variable introduced to prevent online changes impact on orderDTO.
            var outstandingTrade = angular.copy(outstandingTradeObj);
            //on 18-Nov-2020. filling of bank/branch/customer moved first due to issue found MDFY/CNCL order entry formation when user preferred bank is empty.
            vm.orderFromMarketWatch = false;

            //change bank, branch and customer controls from outstanding trade obj
            changeBankBranchCustomerControlsFromOutstandingTradeObj(outstandingTrade);
            vm.outstandtradedatefrom = angular.copy(outstandingTrade.tradeSettlementDateFrom);
            $timeout(function () {
                vm.orderDTO.activityIndicator = 'TRAD';
                vm.orderDTO.contractCancellation = true;

                // outstandingTrade.isOptionPeriod = true
                var cancellationSettlementDate = getSettlementDateForContractCancellation(outstandingTrade);

                vm.orderDTO.instrumentCode = getInstrumentCodeForSettlement(cancellationSettlementDate);
                vm.defaultInstrumentCode = vm.orderDTO.instrumentCode;
                fillDefaultInstIdForInstCode(vm.defaultInstrumentCode);
                if (outstandingTrade.buySellIndicator == 'BUYY') {
                    vm.orderDTO.buySellIndicator = 'SELL';
                } else {
                    vm.orderDTO.buySellIndicator = 'BUYY';
                }
                vm.orderDTO.timeLimitIndicator = outstandingTrade.timeCondition;
                if (vm.orderDTO.timeCondition == 'GTTM') {
                    //vm.orderDTO.expiryTime = outstandingTrade.expiryTime;
                    //vm.orderDTO.expiryTimeString = outstandingTrade.expiryTimeString;
                }
                if (vm.orderDTO.instrumentCode == 'Forward') {
                    vm.tradeSettlementDate = new Date(cancellationSettlementDate);
                    vm.orderDTO.tradeSettlementDate = cancellationSettlementDate;
                    // during contract cancellation the option  period is false
                    changeTenor(cancellationSettlementDate, false);
                    //set exposure type properies and fill values in lookup control
                    setExposureTypeFromAllExposureLookup(outstandingTrade.exposureTypeName);
                    setExposureSubTypeFromAllSubExposureLookup(outstandingTrade.exposureSubTypeName);
                }
                //fill option period details, set option period details as null as it is cancel contract
                fillOptionPeriodDetails(outstandingTrade, false);
                vm.orderDTO.instrumentId = vm.defaultInstrumentId;

                //fill bank, branch, customer details in order DTO
                fillBankBranchCustomerDetailsFromOutstandingTrade(outstandingTrade);

                var eventType = getEventTypeForShortName('ContractCancellation');
                vm.orderDTO.eventTypeId = eventType.id;
                vm.orderDTO.eventType = eventType.shortName;

                var sourceApp = getSourceApp('FXRETAIL');
                vm.orderDTO.sourceAppId = sourceApp.id;
                vm.orderDTO.sourceAppName = sourceApp.name;

                vm.orderDTO.deliveryMode = outstandingTrade.deliveryMode;
                vm.orderDTO.noOfTrades = outstandingTrade.noOfTrades;
                vm.orderDTO.tradeTotalPrice = outstandingTrade.tradeTotalPrice;
                vm.orderDTO.settlementIFSCCode = outstandingTrade.settlementIFSCCode;
                vm.orderDTO.currencyPairCode = outstandingTrade.currencyPair;
                vm.orderDTO.currencyCode = outstandingTrade.currencyPair.substring(0,3);
                vm.orderDTO.limitCurrencyCode = vm.limitCurrencyCode;


                //fill order/trade sequence, settlement leg and amount details
                fillOrderSequenceAndAmountDetails(outstandingTrade);

                vm.orderDTO.sourceInstrumentCode = outstandingTrade.instrumentCode;
                vm.orderDTO.sourceInstrumentId = getInstIdForInstCode(vm.orderDTO.sourceInstrumentCode);

                vm.orderDTO.typeOfOrder = 'LIMT';
                vm.defaultPriceCondition = 'LIMT';
                vm.orderDTO.timeLimitIndicator = 'DAYY';
                vm.defaultTimeCondition = 'DAYY';

                setDefaultPriceCondition(vm.defaultPriceCondition);
                // changeInstrument(pendingOrder.instrumentCode);
                selectInstrumentInOrderEntry(vm.orderDTO.instrumentCode);
                selectTimeConditionInOrderEntry(vm.defaultTimeCondition);
                changeOrderType(vm.orderDTO.buySellIndicator, vm.orderDTO.activityIndicator);

                //get limit exchange rate from ltp for instrument code
                getLimitExchangeRateForCancellingOutstandingTrade(vm.defaultInstrumentCode);

                $rootScope.orderDTO = vm.orderDTO;
            }, 300);
        }

        function rolloverTrade() {
            // vm.remarks = "";
            setDefaultRemark();
            var outstandingTrades = angular.copy($rootScope.outstandingTrades);
            var outstandingTrade = _.filter(outstandingTrades, { 'select': true });
            //validate spread is available for cancellation leg
            if (validateOutstandingTradeForRollover(outstandingTrade)) {
                prepareOrderDTOToRollOverTrade(outstandingTrade[0]);
            }
        }

        function validateOutstandingTradeForRollover(outstandingTrade) {
            var isValid = true;
            if (outstandingTrade.length > 0) {
                //validate selected contract is forward contract
                if (outstandingTrade[0].instrumentCode != 'Forward') {//&& outstandingTrade[0].eventTypeName=='Booking'
                    isValid = false;
                    MessageBox.openMessageBox("Alert", "The SPOT/TOM/CASH contract cannot be rolled over...!", "Ok", "traderollover");

                }
                else if (outstandingTrade[0].instrumentCode == 'Forward' && outstandingTrade[0].isOptionPeriod == true) {
                    isValid = false;
                    MessageBox.openMessageBox("Alert", "The Forward Option Period contract cannot be rolled over...!", "Ok", "traderollover");
                }
                else {

                    //validate outstanding amount
                    //get instrument code for cancellation leg to check the session close
                    var instrumentCode = getInstrumentCodeForSettlement(outstandingTrade[0].tradeSettlementDate);
                    /* if(outstandingTrade[0].instrumentCode!='Forward' && outstandingTrade[0].eventTypeName=='Early Delivery'){
                         isValid = false;
                         MessageBox.openMessageBox("Alert", "The Early Delivery SPOT/TOM/CASH contract cannot be rolled over...!", "Ok", "traderollover");
                     }else */
                    var cancellationLegSpread = findCancellationLegSpread(instrumentCode, outstandingTrade[0].tradeSettlementDate, findBuyySellIndicatorForCancellationLeg(outstandingTrade[0].buySellIndicator));
                    if ((outstandingTrade[0].outStandingAmount - outstandingTrade[0].blockedAmount) <= 0) {
                        isValid = false;
                        MessageBox.openMessageBox("Alert", "Order(s) is already pending for execution, the operation is not permitted...!", "Ok", "traderollover");
                    } else if (!validateCancellationLegSessionStatus('ROLL', instrumentCode)) {
                        isValid = false;
                        MessageBox.openMessageBox("Alert", vm.errorString, "Ok", "traderollover");
                    } else if (cancellationLegSpread == null || cancellationLegSpread == undefined) {
                        isValid = false;
                        MessageBox.openMessageBox("Alert", "Contract cannot be rolled over. Cancellation Leg Swap Point for " + $filter('date')(outstandingTrade[0].tradeSettlementDate, 'dd-MMM-yyyy') + " is not provided by Relationship bank...!", "Ok", "traderollover");

                    }

                    //validate spread
                    // if(instrumentCode!='SPOT'){
                    //     var tickSize = gettickSizeForGivenInstrument(instrumentCode);
                    //     var buySellIndicator = 'BUYY';
                    //     if(outstandingTrade[0].buySellIndicator=='BUYY'){
                    //         buySellIndicator = 'SELL';
                    //     }
                    //     var bankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, outstandingTrade[0].bankId);
                    //     var spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate(bankSpread, instrumentCode, buySellIndicator,
                    //         DateUtils.convertLocalDateToServer(angular.copy(outstandingTrade[0].tradeSettlementDate)), $rootScope.retailSpotMarketSession.settlementDate,
                    //         tickSize);
                    //     if(spreadUsed==null || spreadUsed==undefined){
                    //         isValid = false;
                    //         if(buySellIndicator == 'BUYY'){
                    //            if(instrumentCode=='Forward'){
                    //               MessageBox.openMessageBox("Alert", "Order entry not possible as FORWARD offer spread for the selected settlement date is not provided by your Relationship bank.", "Ok", "traderollover");
                    //            }else{
                    //               MessageBox.openMessageBox("Alert", instrumentCode + "/SPOT bid spread is not given by the bank. Order entry not possible...!", "Ok", "traderollover");
                    //            }
                    //         }else{
                    //            if(instrumentCode=='Forward'){
                    //               MessageBox.openMessageBox("Alert", "Order entry not possible as FORWARD bid spread for the selected settlement date is not provided by your Relationship bank.", "Ok", "traderollover");
                    //            }else{
                    //               MessageBox.openMessageBox("Alert", instrumentCode + "/SPOT offer spread is not given by the bank. Order entry not possible...!", "Ok", "traderollover");
                    //            }
                    //         }
                    //     }
                    // }
                }
            } else {
                isValid = false;
                MessageBox.openMessageBox("Alert", "Please select a trade to proceed.", "Ok", "traderollover");
            }
            return isValid;
        }

        function prepareOrderDTOToRollOverTrade(outstandingTradeObj) {
            //on 18-Nov-2020. db writer null issue - intermediate variable introduced to prevent online changes impact on orderDTO.
            var outstandingTrade = angular.copy(outstandingTradeObj);
            //on 18-Nov-2020. filling of bank/branch/customer moved first due to issue found MDFY/CNCL order entry formation when user preferred bank is empty.
            vm.orderFromMarketWatch = false;

            //change bank, branch and customer controls from outstanding trade obj
            changeBankBranchCustomerControlsFromOutstandingTradeObj(outstandingTrade);

            $timeout(function () {
                vm.orderDTO.activityIndicator = 'ROLL';
                vm.orderDTO.contractCancellation = true;

                //fill trade settlement date in control and get tenor for that settlement date
                //fill default trade rebooking date as trade settlement date + 1 day
                //vm.tradeSettlementDate = MarketWatch.addDaysToGivenDate(angular.copy(outstandingTrade.tradeSettlementDate), 1);
                vm.tradeSettlementDate = new Date(angular.copy(outstandingTrade.tradeSettlementDate));
                vm.orderDTO.tradeSettlementDate = angular.copy(vm.tradeSettlementDate);
                //vm.minimumTradeSettlementDate = angular.copy(vm.tradeSettlementDate);
                vm.minimumTradeSettlementDate = MarketWatch.addDaysToGivenDate(angular.copy(outstandingTrade.tradeSettlementDate), 1);

                //get instrument for the selected trade settlement date
                vm.orderDTO.instrumentCode = getInstrumentCodeForSettlement(DateUtils.convertLocalDateToServer(angular.copy(vm.tradeSettlementDate)));
                vm.defaultInstrumentCode = vm.orderDTO.instrumentCode;
                fillDefaultInstIdForInstCode(vm.defaultInstrumentCode);
                vm.orderDTO.instrumentId = vm.defaultInstrumentId;

                //fill source instrument code
                //get instrument for the orginal trade settlement date
                vm.orderDTO.cancellationTradeSettlementDate = angular.copy(outstandingTrade.tradeSettlementDate);
                vm.orderDTO.sourceInstrumentCode = outstandingTrade.instrumentCode;
                vm.orderDTO.sourceInstrumentId = getInstIdForInstCode(vm.orderDTO.sourceInstrumentCode);

                //fill buy/sell indicator, time condition and price condition
                vm.orderDTO.buySellIndicator = outstandingTrade.buySellIndicator;
                vm.defaultPriceCondition = 'LIMT';
                vm.orderDTO.typeOfOrder = vm.defaultPriceCondition;
                vm.defaultTimeCondition = 'IOCC';
                vm.orderDTO.timeLimitIndicator = vm.defaultTimeCondition;

                //change tenor control with rebooking trade settlement date
                // for rolloverover there is no option period
                changeTenor(vm.orderDTO.tradeSettlementDate, false);

                //fill event type
                var eventType = getEventTypeForShortName('Rollover');
                vm.orderDTO.eventTypeId = eventType.id;
                vm.orderDTO.eventType = eventType.shortName;

                var sourceApp = getSourceApp('FXRETAIL');
                vm.orderDTO.sourceAppId = sourceApp.id;
                vm.orderDTO.sourceAppName = sourceApp.name;

                vm.orderDTO.deliveryMode = outstandingTrade.deliveryMode;
                vm.orderDTO.noOfTrades = outstandingTrade.noOfTrades;
                vm.orderDTO.tradeTotalPrice = outstandingTrade.tradeTotalPrice;
                vm.orderDTO.settlementIFSCCode = outstandingTrade.settlementIFSCCode;
                vm.orderDTO.currencyPairCode = outstandingTrade.currencyPair;

                vm.orderDTO.currencyCode = outstandingTrade.currencyPair.substring(0,3);
                vm.orderDTO.limitCurrencyCode = vm.limitCurrencyCode;
                //fill order request DTO from outstanding trade obj
                fillOrderDTOFromOutstandingTradeForRollOver(outstandingTrade);
                //fill option period details, set option period details as null as it is rollover
                fillOptionPeriodDetails(outstandingTrade, false);
                //set price condition, time condition, instrument and buy/sell indicator on controls
                setDefaultPriceCondition(vm.defaultPriceCondition);
                selectInstrumentInOrderEntry(vm.orderDTO.instrumentCode);
                selectTimeConditionInOrderEntry(vm.defaultTimeCondition);
                changeOrderType(vm.orderDTO.buySellIndicator, vm.orderDTO.activityIndicator);

                //fill indicative cancellation/spot/rebooking rates and forward swap point
                fillIndicativeRatesAndSwapPoints();

                /* //find whether the existing trade is consuming limit or not
                 vm.orderDTO.isExistingTradeConsumesLimit = false;
                 LimitSettings.checkIsExistingTradeConsumesLimit(vm.orderDTO, function(result){
                     vm.orderDTO.isExistingTradeConsumesLimit = result.checkIsExistingTradeConsumesLimit;
                 })
 */
                $rootScope.orderDTO = vm.orderDTO;
            }, 300);
        }

        function fillOrderDTOFromOutstandingTradeForRollOver(outstandingTrade) {

            //fill bank, branch, customer details in order DTO
            fillBankBranchCustomerDetailsFromOutstandingTrade(outstandingTrade);

            //fill exposure type/sub-type - FRWD check is commented because the exposure type is not filled when the cancellation leg is in CASH/TOM/SPOT.
            //  if(vm.orderDTO.instrumentCode=='Forward'){
            //set exposure type properies and fill values in lookup control
            setExposureTypeFromAllExposureLookup(outstandingTrade.exposureTypeName);
            setExposureSubTypeFromAllSubExposureLookup(outstandingTrade.exposureSubTypeName);
            // }

            //fill order sequence, settlement leg and amount details
            fillOrderSequenceAndAmountDetails(outstandingTrade);

        }

        function fillOrderDTOFromOutstandingTradeForEarlyDelivery(outstandingTrade) {

            //fill bank, branch, customer details in order DTO
            fillBankBranchCustomerDetailsFromOutstandingTrade(outstandingTrade);

            //fill exposure type/sub-type
            if (vm.orderDTO.instrumentCode == 'Forward') {
                //set exposure type properies and fill values in lookup control
                setExposureTypeFromAllExposureLookup(outstandingTrade.exposureTypeName);
                setExposureSubTypeFromAllSubExposureLookup(outstandingTrade.exposureSubTypeName);
            }

            //fill order sequence, settlement leg and amount details
            fillOrderSequenceAndAmountDetails(outstandingTrade);

        }

        function fillBankBranchCustomerDetailsFromOutstandingTrade(outstandingTrade) {
            vm.orderDTO.branchCode = outstandingTrade.branchCode;
            vm.orderDTO.branchId = outstandingTrade.branchId;
            vm.orderDTO.branchName = outstandingTrade.branchName;
            vm.orderDTO.bankId = outstandingTrade.bankId;
            vm.orderDTO.bankName = outstandingTrade.bankName;
            vm.orderDTO.bankMemberNumber = outstandingTrade.bankMemberNo;
            vm.orderDTO.customerId = outstandingTrade.customerId;
            vm.orderDTO.customerCode = outstandingTrade.customerCode;
            vm.orderDTO.customerName = outstandingTrade.customerName;
        }

        function fillOrderSequenceAndAmountDetails(outstandingTrade) {
            vm.orderDTO.settlementLegId = outstandingTrade.settlementLegId;
            vm.orderDTO.orderSequenceNumber = 0;
            vm.orderDTO.revisionTimeStamp = 0;
            vm.orderDTO.sourceOrderSequenceNumber = outstandingTrade.orderSequenceNumber;
            vm.orderDTO.sourceTradeSequenceNumber = outstandingTrade.tradeSequenceNumber;
            //get order amount
            vm.orderDTO.outStandingAmount = outstandingTrade.outStandingAmount - outstandingTrade.blockedAmount;
            vm.orderDTO.oldOrderAmount = vm.orderDTO.outStandingAmount;
            vm.orderDTO.orderAmount = vm.orderDTO.outStandingAmount;
            //vm.remarks = outstandingTrade.userRemarks;
            vm.remarksDTO.remarks1 = outstandingTrade.userRemarks;
            vm.remarksDTO.remarks2 = outstandingTrade.remarks2;
            vm.remarksDTO.remarks3 = outstandingTrade.remarks3;
            vm.remarksDTO.remarks4 = outstandingTrade.remarks4;

            setRemark();
        }

        function fillIndicativeRatesAndSwapPoints() {

            //fill indicative IB spot rate.
            vm.orderDTO.indicativeSpotRate = getLtpValue(vm.currencyPair,vm.defaultInstrumentTokenSequenceNo);

            //compute indicative cancellation rate
            //fixed issue in RO, when forward trade comes to spot window (cash date), and when it is rolled over,
            //and having spread in cash and tom alone. if sourceInstCode(forward) is used for computing spread, spread will not be calculated properly for this.

            /*var instCodeForCancellation = getInstrumentCodeForSettlement(vm.orderDTO.cancellationTradeSettlementDate);
            fillIndicativeCancellationRate(instCodeForCancellation, vm.orderDTO.cancellationTradeSettlementDate, vm.orderDTO.buySellIndicator);*/

            fillCancellationLegDetails(vm.orderDTO.cancellationTradeSettlementDate, vm.orderDTO.buySellIndicator);
            fillIndicativeCancellationRate(vm.orderDTO.cancelledLegInstrumentCode, vm.orderDTO.cancellationTradeSettlementDate, vm.orderDTO.cancelledLegBuySellIndicator);

            //compute indicative re-booking rate
            fillIndicativeRebookingRate(vm.orderDTO.instrumentCode, vm.orderDTO.tradeSettlementDate, vm.orderDTO.buySellIndicator);

            //find forward swap points
            //cancellation leg spread, rebooking spread and order type will be sent as input
            fillForwardSwapPoints(vm.orderDTO.cancellationLegSpread, vm.orderDTO.rebookingLegSpread);
        }
        // this functionality is invoked during validation and also during the trade date settlement change
        function findCancellationLegSpread(instCode, tradeCancellationSettlementDate, orderTypeOfCancellationLeg) {

            //get tick size for instcode and stored in variable
            var tickSize = gettickSizeForGivenInstrument(instCode);

            if (instCode == 'SPOT') { //if given instrument is SPOT, then set cancellation leg spread as 0
                return 0;
            } else {
                //get spread for given settlement date,  order type of cancellation leg
                return MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, instCode, orderTypeOfCancellationLeg,
                    DateUtils.convertLocalDateToServer(angular.copy(tradeCancellationSettlementDate)), $rootScope.retailSpotMarketSession.settlementDate,
                    tickSize);
            }
        }

        function fillIndicativeCancellationRate(instCode, tradeCancellationSettlementDate, orderTypeOfCancellationLeg) {


            //order type for cancellation leg is determined by orderTypeOfTrade.
            //if orderTypeOfTrade is buy, then order type of cancellation leg will be sell, and vice versa
            /*if(orderTypeOfTrade=='BUYY'){
                vm.orderTypeOfCancellationLeg = 'SELL';
            }else{
                vm.orderTypeOfCancellationLeg = 'BUYY';
            }*/
            vm.orderDTO.cancellationLegSpread = findCancellationLegSpread(instCode, tradeCancellationSettlementDate, orderTypeOfCancellationLeg);

            if (vm.orderDTO.cancellationLegSpread != null && vm.orderDTO.cancellationLegSpread != undefined) {
                vm.orderDTO.indicativeCancellationRate = convertSpotRateToLimitExchangeRate(vm.orderDTO.indicativeSpotRate, vm.orderDTO.cancellationLegSpread, instCode);
            } else {
                vm.orderDTO.indicativeCancellationRate = null;
            }

        }
        function findBuyySellIndicatorForCancellationLeg(orderTypeOfTrade) {
            //order type for cancellation leg is determined by orderTypeOfTrade.
            //if orderTypeOfTrade is buy, then order type of cancellation leg will be sell, and vice versa
            if (orderTypeOfTrade == 'BUYY') {
                return 'SELL';
            } else {
                return 'BUYY';
            }
        }
        $rootScope.findBuyySellIndicatorForCancellationLeg = findBuyySellIndicatorForCancellationLeg;
        function fillCancellationLegDetails(tradeCancellationSettlementDate, orderTypeOfTrade) {

            var instCodeForCancellation = getInstrumentCodeForSettlement(tradeCancellationSettlementDate);

            vm.orderTypeOfCancellationLeg = findBuyySellIndicatorForCancellationLeg(orderTypeOfTrade);
            //set Cencellation leg buy sell indicator to display in pre order confirmation
            vm.orderDTO.cancelledLegBuySellIndicator = vm.orderTypeOfCancellationLeg;
            //set Instrument Code for cancellation leg to display in pre order confirmation
            vm.orderDTO.cancelledLegInstrumentCode = instCodeForCancellation;

        }

        function fillIndicativeRebookingRate(instCode, tradeCancellationSettlementDate, orderTypeOfTrade) {
            //get tick size for instcode and stored in variable
            var tickSize = gettickSizeForGivenInstrument(instCode);

            if (instCode == 'SPOT') { //if given instrument is SPOT, then set rebooking leg spread as 0
                vm.orderDTO.rebookingLegSpread = 0;
            } else {
                //get spread for given settlement date,  order type of trade to be rolled over
                vm.orderDTO.rebookingLegSpread = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, instCode, orderTypeOfTrade,
                    DateUtils.convertLocalDateToServer(angular.copy(tradeCancellationSettlementDate)), $rootScope.retailSpotMarketSession.settlementDate,
                    tickSize);
            }

            if (vm.orderDTO.rebookingLegSpread != null && vm.orderDTO.rebookingLegSpread != undefined) {
                vm.orderDTO.limitExchangeRate = convertSpotRateToLimitExchangeRate(vm.orderDTO.indicativeSpotRate, vm.orderDTO.rebookingLegSpread, instCode);
            } else { //if rebooking leg spread is not defined or unable to compute, then rebooking limit exchange rate will be null and cleared.
                vm.orderDTO.limitExchangeRate = null;
                if (vm.orderDTO.activityIndicator == 'ROLL') {
                    setFieldValues("txtlimitorderprice3", null);
                } else if (vm.orderDTO.activityIndicator == 'EARL') {
                    setFieldValues("txtlimitorderprice4", null);
                }
            }
        }

        function fillForwardSwapPoints(cancellationLegSpread, rebookingLegSpread) {
            //if rebookingLegSpread is not defined, forward swap point is returned as null
            //else forward swap point = rebookingLegSpread - cancellationLegSpread;
            if (rebookingLegSpread != null && rebookingLegSpread != undefined && cancellationLegSpread != null && cancellationLegSpread != undefined) {
                vm.orderDTO.forwardSwapPoints = rebookingLegSpread - cancellationLegSpread;
                vm.orderDTO.forwardSwapPoints = (Math.round(parseFloat(vm.orderDTO.forwardSwapPoints) * 100) / 100);
            } else {
                vm.orderDTO.forwardSwapPoints = null;
            }
        }

        function changeBankBranchCustomerControlsFromOutstandingTradeObj(outstandingTrade) {
            //fill bank control
            if ((vm.tradingBank != null && vm.tradingBank != undefined && vm.tradingBank.id != outstandingTrade.bankId) || (vm.tradingBank == null || vm.tradingBank == undefined)) {
                changeTradingBank(outstandingTrade.bankId);
            }

            //fill branch control
            if ((vm.tradingBranch != null && vm.tradingBranch != undefined && vm.tradingBranch.id != outstandingTrade.branchId) || (vm.tradingBranch == null || vm.tradingBranch == undefined)) {
                $timeout(function () {
                    changeTradingBranch(outstandingTrade.branchId);
                }, 100)
            }

            //fill customer control
            if ((vm.tradingCustomer != null && vm.tradingCustomer != undefined && vm.tradingCustomer.id != outstandingTrade.customerId) || (vm.tradingCustomer == null || vm.tradingCustomer == undefined)) {
                $timeout(function () {
                    changeTradingCustomer(outstandingTrade.customerId);
                }, 100)
            }
        }

        $scope.$watchGroup(['vm.tradeSettlementDate', 'vm.tenor', 'defaultBankSpread', 'ibSpotMarketDepth'], function (value) {
            if (value != null && value != undefined) {
                if (vm.orderDTO.activityIndicator == 'ROLL' || vm.orderDTO.activityIndicator == 'EARL') {
                    //if vm.orderDTO.activityIndicator is roll over,
                    //then find indicative rebooking rate and forward swap points for tradeSettlement Date

                    //get instrument for the selected trade settlement date
                    //depending on insturment found, change instrument on control also.
                    vm.orderDTO.instrumentCode = getInstrumentCodeForSettlement(DateUtils.convertLocalDateToServer(angular.copy(vm.tradeSettlementDate)));
                    vm.defaultInstrumentCode = vm.orderDTO.instrumentCode;
                    fillDefaultInstIdForInstCode(vm.defaultInstrumentCode);
                    vm.orderDTO.instrumentId = vm.defaultInstrumentId;
                    vm.orderDTO.tradeSettlementDate = angular.copy(vm.tradeSettlementDate);

                    fillIndicativeRatesAndSwapPoints();
                }
            }
        })

        function earlyDeliveryTrade() {
            //vm.remarks = "";
            setDefaultRemark();
            var outstandingTrades = angular.copy($rootScope.outstandingTrades);
            var outstandingTrade = _.filter(outstandingTrades, { 'select': true });
            //validate spread is available for cancellation leg
            if (validateOutstandingTradeForEarlyDelivery(outstandingTrade)) {
                prepareOrderDTOToEarlyDeliveryTrade(outstandingTrade[0]);
            }
        }

        function validateOutstandingTradeForEarlyDelivery(outstandingTrade) {
            var isValid = true;
            if (outstandingTrade.length > 0) {
                //validate selected contract is forward contract
                if (outstandingTrade[0].instrumentCode != 'Forward') { //&& outstandingTrade[0].eventTypeName=='Booking'
                    isValid = false;
                    MessageBox.openMessageBox("Alert", "The SPOT/TOM/CASH contract cannot be early delivered...!", "Ok", "tradeearlydelivery");
                } else if (outstandingTrade[0].instrumentCode == 'Forward' && outstandingTrade[0].isOptionPeriod == true && !isEventAppliedBeforeOptionPeriod(outstandingTrade[0])) {
                    isValid = false;
                    MessageBox.openMessageBox("Alert", "The Forward Option Period contract cannot be early delivered during the option period...!", "Ok", "tradeearlydelivery");
                } else {
                    //validate outstanding amount
                    //var instrumentCode = getInstrumentCodeForSettlement(outstandingTrade[0].tradeSettlementDate);

                    /* if(outstandingTrade[0].instrumentCode!='Forward' && outstandingTrade[0].eventTypeName=='Early Delivery'){
                         isValid = false;
                         MessageBox.openMessageBox("Alert", "The Early Delivery SPOT/TOM/CASH contract cannot be early delivered...!", "Ok", "tradeearlydelivery");
                     }else*/

                    if ((outstandingTrade[0].outStandingAmount - outstandingTrade[0].blockedAmount) <= 0) {
                        isValid = false;
                        MessageBox.openMessageBox("Alert", "Order(s) is already pending for execution, the operation is not permitted...!", "Ok", "tradeearlydelivery");
                    }

                    var tradeSettlementDateForCancellation = getSettlementDateForContractCancellation(outstandingTrade[0]);
                    var cancellationLegInstrumentCode = getInstrumentCodeForSettlement(tradeSettlementDateForCancellation);
                    var cancellationLegSpread = findCancellationLegSpread(cancellationLegInstrumentCode, tradeSettlementDateForCancellation, findBuyySellIndicatorForCancellationLeg(outstandingTrade[0].buySellIndicator));

                    var instrumentCode = getInstrumentCodeForSettlement(outstandingTrade[0].tradeSettlementDate);
                    if (instrumentCode == 'CASH') {
                        isValid = false;
                        MessageBox.openMessageBox("Alert", "Contract cannot be early delivered as the contract entered into CASH instrument...!", "Ok", "tradeearlydelivery");
                    } else if (!validateCancellationLegSessionStatus('EARL', cancellationLegInstrumentCode)) {
                        isValid = false;
                        MessageBox.openMessageBox("Alert", vm.errorString, "Ok", "tradeearlydelivery");
                    } else if (cancellationLegSpread == null || cancellationLegSpread == undefined) {
                        isValid = false;
                        MessageBox.openMessageBox("Alert", "Contract cannot be early delivered. Cancellation Leg Swap Point for " + $filter('date')(tradeSettlementDateForCancellation, 'dd-MMM-yyyy') + " is not provided by Relationship bank...!", "Ok", "tradeearlydelivery");

                    }

                    //validate spread
                    // if(instrumentCode!='SPOT'){
                    //     var buySellIndicator = 'BUYY';
                    //     if(outstandingTrade[0].buySellIndicator=='BUYY'){
                    //         buySellIndicator = 'SELL';
                    //     }
                    //     var spreadUsed = getSpreadForOutstandingTrade(outstandingTrade, instrumentCode);
                    //     if(spreadUsed==null || spreadUsed==undefined){
                    //         isValid = false;
                    //         throwExceptionForSpreadNotDefined(buySellIndicator, instrumentCode);
                    //     }
                    // }
                }
            } else {
                isValid = false;
                MessageBox.openMessageBox("Alert", "Please select a trade to proceed.", "Ok", "tradeearlydelivery");
            }
            return isValid;
        }
        /* this method is not in use */
        function getSpreadForOutstandingTrade(outstandingTrade, instrumentCode) {
            var tickSize = gettickSizeForGivenInstrument(instrumentCode);
            var buySellIndicator = 'BUYY';
            if (outstandingTrade[0].buySellIndicator == 'BUYY') {
                buySellIndicator = 'SELL';
            }
            var bankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, outstandingTrade[0].bankId);
            var spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate(bankSpread, instrumentCode, buySellIndicator,
                DateUtils.convertLocalDateToServer(angular.copy(outstandingTrade[0].tradeSettlementDate)), $rootScope.retailSpotMarketSession.settlementDate,
                tickSize);
            return spreadUsed;
        }

        function throwExceptionForSpreadNotDefined(buySellIndicator, instrumentCode) {
            if (buySellIndicator == 'BUYY') {
                if (instrumentCode == 'Forward') {
                    MessageBox.openMessageBox("Alert", "Order entry not possible as FORWARD offer spread for the selected settlement date is not provided by your Relationship bank.", "Ok", "traderollover");
                } else {
                    MessageBox.openMessageBox("Alert", instrumentCode + "/SPOT bid spread is not given by the bank. Order entry not possible...!", "Ok", "traderollover");
                }
            } else {
                if (instrumentCode == 'Forward') {
                    MessageBox.openMessageBox("Alert", "Order entry not possible as FORWARD bid spread for the selected settlement date is not provided by your Relationship bank.", "Ok", "traderollover");
                } else {
                    MessageBox.openMessageBox("Alert", instrumentCode + "/SPOT offer spread is not given by the bank. Order entry not possible...!", "Ok", "traderollover");
                }
            }
        }

        function prepareOrderDTOToEarlyDeliveryTrade(outstandingTradeObj) {
            //on 18-Nov-2020. db writer null issue - intermediate variable introduced to prevent online changes impact on orderDTO.
            var outstandingTrade = angular.copy(outstandingTradeObj);
            //on 18-Nov-2020. filling of bank/branch/customer moved first due to issue found MDFY/CNCL order entry formation when user preferred bank is empty.
            vm.orderFromMarketWatch = false;

            //change bank, branch and customer controls from outstanding trade obj
            changeBankBranchCustomerControlsFromOutstandingTradeObj(outstandingTrade);

            $timeout(function () {
                vm.orderDTO.activityIndicator = 'EARL';
                vm.orderDTO.contractCancellation = true;
                //fill option period details, set option period details as null as it is cancel contract
                fillOptionPeriodDetails(outstandingTrade, false);
                //fill trade settlement date in control and get tenor for that settlement date
                //fill default trade rebooking date as trade settlement date - 1 day
                //vm.tradeSettlementDate = MarketWatch.addDaysToGivenDate(angular.copy(outstandingTrade.tradeSettlementDate), -1);
                //set tradeSettlementDate from outstanding trade settlement start date
                if (outstandingTrade.tradeSettlementDateFrom != null) {
                    vm.tradeSettlementDate = new Date(angular.copy(outstandingTrade.tradeSettlementDateFrom));
                } else {
                    vm.tradeSettlementDate = new Date(angular.copy(outstandingTrade.tradeSettlementDate));
                }
                vm.outstandtradedatefrom = angular.copy(outstandingTrade.tradeSettlementDateFrom);
                //  vm.tradeSettlementDate = new Date(angular.copy(outstandingTrade.tradeSettlementDate));
                vm.orderDTO.tradeSettlementDate = angular.copy(vm.tradeSettlementDate);


                //set maximum trade settlement date from outstanding trade settlement start date

                if (outstandingTrade.tradeSettlementDateFrom != null)
                    vm.maximumTradeSettlementDate = MarketWatch.addDaysToGivenDate(angular.copy(outstandingTrade.tradeSettlementDateFrom), -1);
                else
                    vm.maximumTradeSettlementDate = MarketWatch.addDaysToGivenDate(angular.copy(outstandingTrade.tradeSettlementDate), -1);

                //cash date will be minimum trade settlement date to be given for early delvery
                //if cash is holiday, then tom date will be minimum date,
                //if tom is also holiday, then spot date will be minimum date
                if (!$rootScope.cashMarketSession.isSettlementDateHoliday) {
                    vm.minimumTradeSettlementDate = new Date($rootScope.cashMarketSession.settlementDate);
                } else if (!$rootScope.tomMarketSession.isSettlementDateHoliday) {
                    vm.minimumTradeSettlementDate = new Date($rootScope.tomMarketSession.settlementDate);
                } else {
                    vm.minimumTradeSettlementDate = new Date(vm.currencyPair.code === 'USDINR' ? $rootScope.retailSpotMarketSession.settlementDate : $rootScope.marketSessionMap[vm.defaultInstrumentTokenSequenceNo].settlementDate);
                }

                //get instrument for the selected trade settlement date
                vm.orderDTO.instrumentCode = getInstrumentCodeForSettlement(DateUtils.convertLocalDateToServer(angular.copy(vm.tradeSettlementDate)));
                vm.defaultInstrumentCode = vm.orderDTO.instrumentCode;
                fillDefaultInstIdForInstCode(vm.defaultInstrumentCode);
                vm.orderDTO.instrumentId = vm.defaultInstrumentId;

                //fill source instrument code
                //get instrument for the orginal trade settlement date
                //vm.orderDTO.cancellationTradeSettlementDate = angular.copy(outstandingTrade.tradeSettlementDate);
                vm.orderDTO.cancellationTradeSettlementDate = angular.copy(getSettlementDateForContractCancellation(outstandingTrade));
                vm.orderDTO.sourceInstrumentCode = outstandingTrade.instrumentCode;
                vm.orderDTO.sourceInstrumentId = getInstIdForInstCode(vm.orderDTO.sourceInstrumentCode);

                //fill buy/sell indicator, time condition and price condition
                vm.orderDTO.buySellIndicator = outstandingTrade.buySellIndicator;
                vm.defaultPriceCondition = 'LIMT';
                vm.orderDTO.typeOfOrder = vm.defaultPriceCondition;
                vm.defaultTimeCondition = 'IOCC';
                vm.orderDTO.timeLimitIndicator = vm.defaultTimeCondition;

                //change tenor control with rebooking trade settlement date
                //for ealry delivery there is no
                changeTenor(vm.orderDTO.tradeSettlementDate, false);

                //fill event type
                var eventType = getEventTypeForShortName('EarlyDelivery');
                vm.orderDTO.eventTypeId = eventType.id;
                vm.orderDTO.eventType = eventType.shortName;

                var sourceApp = getSourceApp('FXRETAIL');
                vm.orderDTO.sourceAppId = sourceApp.id;

                vm.orderDTO.deliveryMode = outstandingTrade.deliveryMode;
                vm.orderDTO.noOfTrades = outstandingTrade.noOfTrades;
                vm.orderDTO.tradeTotalPrice = outstandingTrade.tradeTotalPrice;
                vm.orderDTO.settlementIFSCCode = outstandingTrade.settlementIFSCCode;
                vm.orderDTO.currencyPairCode = outstandingTrade.currencyPair;
                vm.orderDTO.currencyCode = outstandingTrade.currencyPair.substring(0,3);
                vm.orderDTO.limitCurrencyCode = vm.limitCurrencyCode;

                //fill order request DTO from outstanding trade obj
                fillOrderDTOFromOutstandingTradeForEarlyDelivery(outstandingTrade);

                //set price condition, time condition, instrument and buy/sell indicator on controls
                setDefaultPriceCondition(vm.defaultPriceCondition);
                selectInstrumentInOrderEntry(vm.orderDTO.instrumentCode);
                selectTimeConditionInOrderEntry(vm.defaultTimeCondition);
                changeOrderType(vm.orderDTO.buySellIndicator, vm.orderDTO.activityIndicator);

                //fill indicative cancellation/spot/rebooking rates and forward swap point

                $rootScope.orderDTO = vm.orderDTO;
            }, 300);
        }

        vm.getMarkData = function (tokenSeqNo) {
            return $rootScope.marketSessionMap[tokenSeqNo];
        };

        vm.getTickerPrice = function (tokenSeqNo) {
            return $rootScope.tickerPriceFCY[tokenSeqNo];
        };

       vm.getInstrumentStatus = function (tokenSeqNo) {
    var data = vm.getMarkData(tokenSeqNo);
    if (!data) return null;

    if (data.sessionTimingsDTO.status === 'CLOSED') {
        return 'CLOSED';
    }

    if (!data.instrumentApplicable) {
        return 'UNAVAILABLE';
    }

    if (data.isSettlementDateHoliday) {
        return 'HOLIDAY';
    }







    return null;
};


vm.getStatusText = function (inst) {
    var status = vm.getMarkData(inst.tokenSequenceNo).sessionTimingsDTO.status;
    return status === 'HOLIDAY' ? 'Holiday'
         : status === 'CLOSED' ? 'Closed'
         : status === 'UNAVAILABLE' ? 'Unavailable'
         : '';
};



        vm.prepareOrderDTOFromMarketWatch = prepareOrderDTOFromMarketWatch;
        function prepareOrderDTOFromMarketWatch(buySellFlag, instrumentType, limitExcahngeRate, settlementDate, sessionStatus, currencyPairId) {
            if (limitExcahngeRate != null && limitExcahngeRate != undefined && limitExcahngeRate != '' && limitExcahngeRate > 0 && sessionStatus == 'OPEN') {
                vm.orderFromMarketWatch = false;
                vm.errorString = '';
                if (currencyPairId != undefined) {
                    vm.orderDTO.currencyPairId = currencyPairId

                    var currency = $rootScope.marketWatchMap[currencyPairId];
                    vm.currencyPairCode = currency.baseCurrency + 'INR';
                    vm.currencyPairId = currencyPairId;
                    vm.orderDTO.currencyPairCode = vm.currencyPairCode;
                }
                else {
                    console.log("usd inr market");
                    vm.orderDTO.currencyPairId = 1;
                    vm.orderDTO.currencyPairCode = 'USDINR';
                }

                vm.defaultInstrumentCode = instrumentType;
                $rootScope.defaultInstrumentCode = instrumentType;

                setSelectedCurrecy(vm.orderDTO.currencyPairId,'');
                //vm.orderDTO = {};
                vm.orderDTO.typeOfOrder = 'LIMT';
                vm.orderDTO.activityIndicator = 'PLAC';
                vm.orderDTO.instrumentCode = instrumentType;
                vm.orderDTO.buySellIndicator = buySellFlag;
                var orderVolume = vm.userPreference.userOrderValue;
                vm.orderDTO.orderAmount = parseFloat(orderVolume.replace(/,/g, ''));
                fillDefaultInstIdForInstCode(instrumentType);
                //vm.orderDTO.instrumentId = fillDefaultInstIdForInstCode(instrumentType);
                vm.orderDTO.timeLimitIndicator = 'DAYY';  //'IOCC';
                vm.orderDTO.expiryTime = 0;

                // fill bank, branch, customer details into order request dto
                vm.orderDTO = fillBankBranchCustomerDetailsFromMktWatch(vm.orderDTO)

                if (vm.account.organisation.organisationType.shortName != 'CUSTOMER') {
                    if (vm.defaultTradingCustomerControl != null && vm.defaultTradingCustomerControl != undefined) {
                        vm.orderDTO.customerId = vm.defaultTradingCustomerControl.id;
                        vm.orderDTO.customerName = vm.defaultTradingCustomerControl.customerFirstName;
                        vm.orderDTO.customerCode = vm.defaultTradingCustomerControl.customerCode;
                    } else {
                        // MessageBox.openMessageBox("Alert", "Please select the
                        // trading customer to proceed.", "Ok",
                        // "selectdefaultcustomer");
                    }
                }

                // vm.orderDTO.customerName =
                // vm.globalValues.getCustomer().customerFirstName;
                vm.orderDTO.userId = vm.globalValues.getUserId();
                vm.orderDTO.retailUserCode = vm.globalValues.getUser().login;
                vm.orderDTO.userEntityOwnerId = vm.globalValues.getEntityOwnerTypeId();
                vm.orderDTO.orderSequenceNumber = 0;
                vm.orderDTO.revisionTimeStamp = 0;
                vm.orderDTO.sourceOrderSequenceNumber = 0;
                vm.orderDTO.sourceTradeSequenceNumber = 0;
                vm.orderDTO.contractCancellation = false;
                var valuelimitExchangeRate = angular.copy(vm.orderDTO.limitExchangeRate);
                var valueStopExchangeRate = angular.copy(vm.orderDTO.stopExchangeRate);
                vm.orderDTO.limitExchangeRate = angular.copy(limitExcahngeRate);
                vm.orderDTO.limitExchangeRate = $filter('number')(vm.orderDTO.limitExchangeRate, vm.noOfDecimalsForRate);
                vm.orderDTO.stopExchangeRate = 0;
                vm.orderDTO.stopExchangeRate = 0;

                vm.defaultPriceCondition = 'LIMT';

                setDefaultPriceCondition(vm.defaultPriceCondition);
                // changeInstrument(pendingOrder.instrumentCode);
                selectInstrumentInOrderEntry(vm.orderDTO.instrumentCode);
                selectTimeConditionInOrderEntry(vm.orderDTO.timeLimitIndicator);
                changeOrderType(vm.orderDTO.buySellIndicator, vm.orderDTO.activityIndicator);
                if ((vm.tradingBank != null && vm.tradingBank != undefined && vm.tradingBank.id != vm.orderDTO.bankId) || (vm.tradingBank == null || vm.tradingBank == undefined)) {
                    changeTradingBank(vm.orderDTO.bankId);
                }

                if ((vm.tradingBranch != null && vm.tradingBranch != undefined && vm.tradingBranch.id != vm.orderDTO.branchId) || (vm.tradingBranch == null || vm.tradingBranch == undefined)) {
                    changeTradingBranch(vm.orderDTO.branchId);
                }

                if ((vm.tradingCustomer != null && vm.tradingCustomer != undefined && vm.tradingCustomer.id != vm.orderDTO.customerId) || (vm.tradingCustomer == null || vm.tradingCustomer == undefined)) {
                    $timeout(function () {
                        changeTradingCustomer(vm.orderDTO.customerId);
                    }, 100)
                }

                if (instrumentType == 'Forward') {
                    //from market watch the forward cannot be option period initially
                    changeTenor(settlementDate, false);
                    vm.tradeSettlementDate = new Date(settlementDate);
                    //set exposure type properies and fill values in lookup control
                    setExposureTypeFromAllExposureLookup(vm.userPreference.userExposureType);
                    setExposureSubTypeFromAllSubExposureLookup(vm.userPreference.userExposureSubType);
                    vm.orderDTO.exposureTypeId = vm.exposureType.id;
                    vm.orderDTO.exposureSubTypeId = vm.exposureSubType.id;
                    vm.orderDTO.exposureTypeName = vm.exposureType.name;
                    vm.orderDTO.exposureSubTypeName = vm.exposureSubType.name;

                }
                //fill option period details, set option period details as null as it is order from market watch
                fillOptionPeriodDetails(null, false);
                setTimeout(function () {
                    vm.orderFromMarketWatch = true;
                }, 20);
            }
        }

        vm.prepareOrderDTOFromOutrights = prepareOrderDTOFromOutrights;
        function prepareOrderDTOFromOutrights(bank, buySellFlag, instrumentType, limitExcahngeRate, settlementDate, sessionStatus) {
            if (vm.tradingBank != null && vm.tradingBank != undefined && vm.tradingBank.id != bank.id) {
                //CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: bank.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
                var result = _.filter(angular.copy($rootScope.tradingRelationsForCustomer), function (item) { return item.bank.id == bank.id; });
                vm.tradingBank = bank;
                vm.tradingBranch = result[0].tradingBranch;
                //prepare order entry screen from outright as orderEntry from market watch
                prepareOrderDTOFromMarketWatch(buySellFlag, instrumentType, limitExcahngeRate, settlementDate, sessionStatus);
                //})
            } else {
                //prepare order entry screen from outright as orderEntry from market watch
                prepareOrderDTOFromMarketWatch(buySellFlag, instrumentType, limitExcahngeRate, settlementDate, sessionStatus);
            }
        }

        function getEventTypeForShortName(eventTypeShortName) {
            var eventType = {};
            angular.forEach($rootScope.eventTypes, function (value) {
                if (value.shortName == eventTypeShortName) {
                    eventType = value;
                }
            })
            return eventType;
        }

        function getSourceApp(sourceAppName) {
            var sourceApp = {};
            angular.forEach($rootScope.sourceApp, function (value) {
                if (value.shortName == sourceAppName) {
                    sourceApp = value;
                }
            })
            return sourceApp;
        }

        // re-assing default values to controls
        function cancelModifyOrderAction() {
            //vm.remarks = "";
            setDefaultRemark();
            defaultOrderEntry();
            // remove foucs on order entry screen
            removeOrderEntryFocus();
            clearNumericControls();
            // setLTPPriceAsDefaultValueForLimitOrder();
        }

        function getCustomerId() {
            if (vm.account.organisation.organisationType.shortName == 'CLEARCORP') {
                return vm.defaultTradingCustomer.id;
            } else if (vm.account.organisation.organisationType.shortName == 'BANK') {
                return vm.defaultTradingCustomer.id;
            } else if (vm.account.organisation.organisationType.shortName == 'CUSTOMER') {
                vm.globalValues.getCustomer().id
            }
        }


        function fillOptionPeriodDetailsForCancelOrder(poOrOsTradeObj, optionPeriodCheckRequired, orderDTO) {
            if (poOrOsTradeObj != null && poOrOsTradeObj != undefined && optionPeriodCheckRequired == true) {
                if (orderDTO.instrumentCode == 'Forward' && poOrOsTradeObj.isOptionPeriod == true) {
                    orderDTO.isOptionPeriod = true;
                    orderDTO.tradeSettlementDateFrom = poOrOsTradeObj.tradeSettlementDateFrom;

                }
                else {
                    orderDTO.isOptionPeriod = false;
                    orderDTO.tradeSettlementDateFrom = null;

                }
            } else {
                orderDTO.isOptionPeriod = false;
                orderDTO.tradeSettlementDateFrom = null;

            }
        }

        function fillOptionPeriodDetails(poOrOsTradeObj, optionPeriodCheckRequired) {
            if (poOrOsTradeObj != null && poOrOsTradeObj != undefined && optionPeriodCheckRequired == true) {
                if (vm.orderDTO.instrumentCode == 'Forward' && poOrOsTradeObj.isOptionPeriod == true) {
                    vm.orderDTO.isOptionPeriod = true;
                    vm.orderDTO.tradeSettlementDateFrom = poOrOsTradeObj.tradeSettlementDateFrom;
                    vm.tradeSettlementDateFrom = new Date(poOrOsTradeObj.tradeSettlementDateFrom);
                }
                else {
                    vm.orderDTO.isOptionPeriod = false;
                    vm.orderDTO.tradeSettlementDateFrom = null;
                    //vm.tradeSettlementDateFrom = null;
                }
            } else {
                vm.orderDTO.isOptionPeriod = false;
                vm.orderDTO.tradeSettlementDateFrom = null;
                //vm.tradeSettlementDateFrom = null;
            }
        }

        // prepare orderDTO to modify/cancel order from pending order details
        function prepareOrderDTO(pendingOrderObj, activityIndicator) {
            //on 18-Nov-2020. db writer null issue - intermediate variable introduced to prevent online changes impact on orderDTO.
            var pendingOrder = angular.copy(pendingOrderObj);
            //on 18-Nov-2020. filling of bank/branch/customer moved first due to issue found MDFY/CNCL order entry formation when user preferred bank is empty.
            if ((vm.tradingBank != null && vm.tradingBank != undefined && vm.tradingBank.id != pendingOrder.bankId) || (vm.tradingBank == null || vm.tradingBank == undefined)) {
                changeTradingBank(pendingOrder.bankId);
            }

            if ((vm.tradingBranch != null && vm.tradingBranch != undefined && vm.tradingBranch.id != pendingOrder.branchId) || (vm.tradingBranch == null || vm.tradingBranch == undefined)) {
                $timeout(function () {
                    changeTradingBranch(pendingOrder.branchId);
                }, 100)
            }

            changeTenor(pendingOrder.tradeSettlementDate, pendingOrder.isOptionPeriod);
            setExposureTypeFromEnabledExposureLookup(pendingOrder.exposureTypeName);
            setExposureSubTypeFromEnabledSubExposureLookup(pendingOrder.exposureSubTypeName);

            if ((vm.tradingCustomer != null && vm.tradingCustomer != undefined && vm.tradingCustomer.id != pendingOrder.customerId) || (vm.tradingCustomer == null || vm.tradingCustomer == undefined)) {
                $timeout(function () {
                    changeTradingCustomer(pendingOrder.customerId);
                }, 100)
            }

            vm.orderFromMarketWatch = false;
            $rootScope.outstandingQuantity = 0;
            //vm.orderDTO = {};

            $timeout(function () {
                console.log("impacting in code alues");
                vm.orderDTO.contractCancellation = false;
                vm.orderDTO.activityIndicator = activityIndicator;
                vm.orderDTO.orderAmount = pendingOrder.pendingOrderAmount;
                vm.orderDTO.typeOfOrder = pendingOrder.typeOfOrder;
                vm.orderDTO.instrumentCode = pendingOrder.instrumentCode;
                vm.orderDTO.buySellIndicator = pendingOrder.buySellInd;
                vm.orderDTO.timeLimitIndicator = pendingOrder.timeLimitIndicator;
                vm.orderDTO.currencyPairId = pendingOrder.currencyPairId;
                vm.orderDTO.currencyPair = pendingOrder.currencyPairCode;
                if (vm.orderDTO.timeLimitIndicator == 'GTTM') {
                    vm.orderDTO.expiryTime = pendingOrder.expiryTime;
                    vm.orderDTO.expiryTimeString = pendingOrder.expiryTimeString;
                }
                if (vm.orderDTO.instrumentCode == 'Forward') {
                    vm.tradeSettlementDate = new Date(pendingOrder.tradeSettlementDate);
                    vm.orderDTO.tradeSettlementDate = pendingOrder.tradeSettlementDate;
                    //set exposure type properies
                    vm.orderDTO.exposureTypeId = pendingOrder.exposureTypeId;
                    vm.orderDTO.exposureSubTypeId = pendingOrder.exposureSubTypeId;
                    vm.orderDTO.exposureTypeName = pendingOrder.exposureTypeName;
                    vm.orderDTO.exposureSubTypeName = pendingOrder.exposureSubTypeName;
                }
                //fill option period details
                fillOptionPeriodDetails(pendingOrder, true);
                vm.orderDTO.instrumentId = pendingOrder.retailOrderInstID;
                vm.orderDTO.branchCode = pendingOrder.branchCode;
                vm.orderDTO.branchId = pendingOrder.branchId;
                vm.orderDTO.branchName = pendingOrder.branchName;
                vm.orderDTO.bankId = pendingOrder.bankId;
                vm.orderDTO.bankName = pendingOrder.bankName;
                vm.orderDTO.bankMemberNumber = pendingOrder.bankMemberNumber;
                vm.orderDTO.customerId = pendingOrder.customerId;
                vm.orderDTO.customerCode = pendingOrder.customerCode;
                vm.orderDTO.customerName = pendingOrder.customerName;
                vm.orderDTO.limitExchangeRate = pendingOrder.limitExchangeRate;
                vm.orderDTO.stopExchangeRate = pendingOrder.stopExchangeRate;
                vm.orderDTO.orderSequenceNumber = pendingOrder.orderSequenceNumber;
                vm.orderDTO.sourceTradeSequenceNumber = pendingOrder.sourceTradeSequenceNumber;
                vm.orderDTO.sourceOrderSequenceNumber = pendingOrder.sourceOrderSequenceNumber;
                vm.orderDTO.sourceInstrumentId = pendingOrder.sourceInstrumentId;
                vm.orderDTO.sourceInstrumentCode = pendingOrder.sourceInstrumentCode;
                vm.orderDTO.sourceAppId = pendingOrder.sourceAppId;

                vm.orderDTO.deliveryMode = pendingOrder.deliveryMode;
                vm.orderDTO.noOfTrades = pendingOrder.noOfTrades;
                vm.orderDTO.tradeTotalPrice = pendingOrder.tradeTotalPrice;
                vm.orderDTO.settlementIFSCCode = pendingOrder.settlementIFSCCode;
                vm.orderDTO.currencyPairCode = pendingOrder.currencyPair.code;
                vm.orderDTO.currencyCode = pendingOrder.currencyPair.baseCurrency.code;
                vm.orderDTO.limitCurrencyCode = vm.limitCurrencyCode;

                vm.orderDTO.oldOrderAmount = pendingOrder.oldOrderAmount;
                vm.orderDTO.isSplitOrder = pendingOrder.isSplitOrder;
                vm.regularAndSplitOrder = 'Regular';
                vm.noOfSplits = '';


                if (activityIndicator != 'PLAC') {
                    vm.orderDTO.revisionTimeStamp = pendingOrder.revisiontTimestampString;
                    vm.orderDTO.orderStatusId = pendingOrder.orderStatusId;
                    vm.orderDTO.eventTypeId = pendingOrder.eventTypeId;
                    vm.orderDTO.eventType = pendingOrder.eventTypeName;
                    if (vm.orderDTO.eventType == 'ContractCancellation' || vm.orderDTO.eventType == 'Contract Cancellation') {
                        vm.orderDTO.contractCancellation = true;
                        vm.orderDTO.oldOrderAmount = 0;
                        getOutstandingQuantityFromOrderServer(pendingOrder);
                    }
                    vm.orderDTO.settlementLegId = pendingOrder.settlementLegId;
                }

                if (pendingOrder.typeOfOrder == 'MRKT') {
                    vm.orderDTO.typeOfOrder = 'LIMT';
                    vm.defaultPriceCondition = 'LIMT';
                    vm.orderDTO.limitExchangeRate = getDefaultLimitPriceForModifyingMarketOrder(pendingOrder.instrumentCode, pendingOrder.buySellInd);
                }
                vm.orderDTO.sourceAppId = pendingOrder.sourceAppId;
                vm.orderDTO.sourceAppName = pendingOrder.sourceAppName;

                vm.orderDTO.deliveryMode = pendingOrder.deliveryMode;
                vm.orderDTO.noOfTrades = pendingOrder.noOfTrades;
                vm.orderDTO.tradeTotalPrice = pendingOrder.tradeTotalPrice;
                vm.orderDTO.settlementIFSCCode = pendingOrder.settlementIFSCCode;
                vm.orderDTO.currencyPairCode = pendingOrder.currencyPair.code;
                vm.orderDTO.currencyCode = pendingOrder.currencyPair.baseCurrency.code;
                vm.orderDTO.limitCurrencyCode = vm.limitCurrencyCode;


                // vm.remarks = pendingOrder.remarks;
                vm.remarksDTO.remarks1 = pendingOrder.remarks;
                vm.remarksDTO.remarks2 = pendingOrder.remarks2;
                vm.remarksDTO.remarks3 = pendingOrder.remarks3;
                vm.remarksDTO.remarks4 = pendingOrder.remarks4;

                setRemark();
                setDefaultPriceCondition(pendingOrder.typeOfOrder);
                // changeInstrument(pendingOrder.instrumentCode);
                selectInstrumentInOrderEntry(pendingOrder.instrumentCode);
                selectTimeConditionInOrderEntry(pendingOrder.timeLimitIndicator);
                changeOrderType(pendingOrder.buySellInd, vm.orderDTO.activityIndicator);

                //changeFocusToOrderEntry(pendingOrder.typeOfOrder);
                $rootScope.orderDTO = vm.orderDTO;
            }, 300)
        }

        function changeFocusToOrderEntry(priceCondition) {
            if (priceCondition == 'LIMT') {
                setTimeout(function () { document.getElementById('txtlimitorderprice1').focus() }, 10);
            } else if (priceCondition == 'STLS') {
                setTimeout(function () { document.getElementById('txtsllimitprice1').focus() }, 10);
            } else if (priceCondition == 'TKPR') {
                setTimeout(function () { document.getElementById('txttplimitprice1').focus() }, 10);
            }
        }

        function getOutstandingQuantityFromOrderServer(pendingOrder) {
            $rootScope.outstandingQuantity = 0;
            LimitSettings.getOutstandingQuantityForPendingOrder(pendingOrder, function (result1) {
                $rootScope.outstandingQuantity = result1.outstandingQuantity;
                vm.orderDTO.oldOrderAmount = $rootScope.outstandingQuantity;
            });
        }

        function onGetOutstandingQuantitySuccess(result) {
            $rootScope.outstandingQuantity = result;
            console.log(result);
        }

        function onGetOutstandingQuantityFailure() {

        }

        function getDefaultLimitPriceForModifyingMarketOrder(instrumentCode, buySellFlag) {
            if (buySellFlag == 'BUYY') {
                if (instrumentCode == 'SPOT') {
                    return $rootScope.retailSpotMarketWatch.bidPrice;
                } else if (instrumentCode == 'CASH') {
                    return $rootScope.cashMarketWatch.bidPrice;
                } else if (instrumentCode == 'TOM') {
                    return $rootScope.tomMarketWatch.bidPrice;
                } else if (instrumentCode == 'Forward') {
                    return $rootScope.forwardMarketWatch.bidPrice;
                }

            } else if (buySellFlag == 'SELL') {
                if (instrumentCode == 'SPOT') {
                    return $rootScope.retailSpotMarketWatch.offerPrice;
                } else if (instrumentCode == 'CASH') {
                    return $rootScope.cashMarketWatch.offerPrice;
                } else if (instrumentCode == 'TOM') {
                    return $rootScope.tomMarketWatch.offerPrice;
                } else if (instrumentCode == 'Forward') {
                    return $rootScope.forwardMarketWatch.offerPrice;
                }
            }

        }

        function prepareOrderDTOToCancel(pendingOrderObj) {
            //on 18-Nov-2020. db writer null issue - intermediate variable introduced to prevent online changes impact on orderDTO.
            var pendingOrder = angular.copy(pendingOrderObj);
            vm.orderFromMarketWatch = false;
            var orderDTO = {};
            orderDTO.activityIndicator = 'CNCL';
            orderDTO.orderAmount = pendingOrder.pendingOrderAmount;
            orderDTO.originalOrderAmount = pendingOrder.orderAmount;
            orderDTO.tradedAmount = pendingOrder.tradedAmount;
            orderDTO.typeOfOrder = pendingOrder.typeOfOrder;
            orderDTO.instrumentCode = pendingOrder.instrumentCode;
            orderDTO.instrumentId = pendingOrder.retailOrderInstID;
            orderDTO.buySellIndicator = pendingOrder.buySellInd;
            orderDTO.timeLimitIndicator = pendingOrder.timeLimitIndicator;
            orderDTO.orderStatus = pendingOrder.orderStatus;
            orderDTO.isSplitOrder = pendingOrder.isSplitOrder;
            if (orderDTO.timeLimitIndicator == 'GTTM') {
                // orderDTO.expiryTime = pendingOrder.expiryTime;
                /*
                 * var localDateFromServer =
                 * DateUtils.convertDateTimeFromServer(
                 * pendingOrder.expiryTime); orderDTO.expiryTime =
                 * moment(localDateFromServer,'YYYYMMDDHHmmss').format('YYYYMMDDHHmmss') +
                 * '00';
                 */
                orderDTO.expiryTime = pendingOrder.expiryTime;
                orderDTO.expiryTimeString = pendingOrder.expiryTimeString;
            } else {
                orderDTO.expiryTime = 0;
                orderDTO.expiryTimeString = "";
            }
            orderDTO.branchCode = pendingOrder.branchCode;
            orderDTO.branchName = pendingOrder.branchName;
            orderDTO.branchId = pendingOrder.branchId;
            orderDTO.bankId = pendingOrder.bankId;
            orderDTO.bankMemberNumber = pendingOrder.bankMemberNumber;
            orderDTO.bankName = pendingOrder.bankName;
            orderDTO.customerId = pendingOrder.customerId;
            orderDTO.customerName = pendingOrder.customerName;
            orderDTO.customerCode = pendingOrder.customerCode;
            orderDTO.spotLimitPrice = pendingOrder.spotlimitExchangeRate;
            orderDTO.limitExchangeRate = pendingOrder.limitExchangeRate;
            orderDTO.stopExchangeRate = pendingOrder.stopExchangeRate;
            orderDTO.orderSequenceNumber = pendingOrder.orderSequenceNumber;
            orderDTO.userId = vm.globalValues.getUserId();
            orderDTO.retailUserCode = vm.globalValues.getUser().login;
            orderDTO.userEntityOwnerId = vm.globalValues.getEntityOwnerTypeId();
            orderDTO.eventTypeId = pendingOrder.eventTypeId;
            orderDTO.eventType = pendingOrder.eventTypeName;
            orderDTO.settlementLegId = pendingOrder.settlementLegId;
            orderDTO.sourceOrderSequenceNumber = pendingOrder.sourceOrderSequenceNumber;
            orderDTO.sourceTradeSequenceNumber = pendingOrder.sourceTradeSequenceNumber;
            orderDTO.sourceInstrumentId = pendingOrder.sourceInstrumentId;
            orderDTO.sourceInstrumentCode = pendingOrder.sourceInstrumentCode;
            orderDTO.sourceAppId = pendingOrder.sourceAppId;

            orderDTO.deliveryMode = pendingOrder.deliveryMode;
            orderDTO.noOfTrades = pendingOrder.noOfTrades;
            orderDTO.tradeTotalPrice = pendingOrder.tradeTotalPrice;
            orderDTO.settlementIFSCCode = pendingOrder.settlementIFSCCode;
            orderDTO.currencyPairId = pendingOrder.currencyPair.id;
            orderDTO.currencyPair = pendingOrder.currencyPair.code;

            orderDTO.currencyPairCode = pendingOrder.currencyPair.code;
            orderDTO.currencyCode = pendingOrder.currencyPair.baseCurrency.code;
            orderDTO.limitCurrencyCode = vm.limitCurrencyCode;
            orderDTO.tokenSequenceNumber = pendingOrder.tokenSequenceNumber;

            orderDTO.tradeSettlementDate = DateUtils.convertLocalDateToServer(angular.copy(pendingOrder.tradeSettlementDate));
            if (orderDTO.instrumentCode == 'Forward') {
                //set exposure type properies
                orderDTO.exposureTypeId = pendingOrder.exposureTypeId;
                orderDTO.exposureSubTypeId = pendingOrder.exposureSubTypeId;
                orderDTO.exposureTypeName = pendingOrder.exposureTypeName;
                orderDTO.exposureSubTypeName = pendingOrder.exposureSubTypeName;
            }
            //fill option period details -
            fillOptionPeriodDetailsForCancelOrder(pendingOrder, true, orderDTO);
            console.log('prepare order to cancel');
            console.log(vm.tradingBank);
            var selectedBankSpread = null;
            if ($rootScope.bankComparativeDTO != null && $rootScope.bankComparativeDTO != undefined
                && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList != null && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList != undefined
                && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList.length > 0) {
                selectedBankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, pendingOrder.bankId);

            }
            //var selectedBankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, pendingOrder.bankId);
            if (orderDTO.instrumentCode != 'SPOT') {
                var tickSize = gettickSizeForGivenInstrument(pendingOrder.instrumentCode);
                orderDTO.spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate(selectedBankSpread, pendingOrder.instrumentCode, pendingOrder.buySellInd,
                    DateUtils.convertLocalDateToServer(angular.copy(orderDTO.tradeSettlementDate)), vm.currencyPair.code === 'USDINR' ? $rootScope.retailSpotMarketSession.settlementDate : $rootScope.marketSessionMap[vm.defaultInstrumentTokenSequenceNo].settlementDate,
                    tickSize);
            }
            //orderDTO.spreadUsed = getSpreadUsed(selectedBankSpread, pendingOrder.buySellInd, pendingOrder.instrumentCode);

            orderDTO.revisionTimeStamp = pendingOrder.revisiontTimestampString;


            return orderDTO;
        }

        function changeTradingBank(bankId) {
            if ((vm.tradingBank != null && vm.tradingBank != undefined && vm.tradingBank.id != bankId) || (vm.tradingBank == null || vm.tradingBank == undefined)) {
                BankRegistration.get({ id: bankId }, function (result) {
                    vm.tradingBank = result;
                })
            }
        }

        function changeTradingCustomer(customerId) {
            CustomerRegistration.getCustomer({ id: customerId }, function (result) {
                vm.tradingCustomer = result;
            })
        }

        function changeTradingBranch(branchId) {
            Branch.get({ id: branchId }, function (result) {
                vm.tradingBranch = result;
            })
        }

        /*  old method , upgraded below for option period
         function changeTenor(tradeSettlementDate){
              vm.tenor = null;
              angular.forEach(vm.tenorsLookup, function(value){
                  //2414 - mantis issue fix, tenor name is broken date always even if the tradesettlement date is end point, this occurs for rollover and earlydelivery
                  // this method is invoked in pending order modification, cancelTrade , early delivery, rollover, order form loading from user  market watch
                  if(value.settlementDate==DateUtils.convertLocalDateToServer(tradeSettlementDate)){
                      vm.tenor = value;
                  }
              })
              if(vm.tenor==null || vm.tenor == undefined){
                  vm.tenor = vm.tenorsLookup[0];
              }
          }*/

        /* if optios period is true then tenor is shown as Option period and settlement date will be empty if plac order else settlement dates from and to taken from pending order */
        function changeTenor(tradeSettlementDate, isOptionPeriod) {
            vm.tenor = null;
            if (isOptionPeriod == false || isOptionPeriod == undefined || isOptionPeriod == null) {
                angular.forEach(vm.tenorsLookup, function (value) {
                    //2414 - mantis issue fix, tenor name is broken date always even if the tradesettlement date is end point, this occurs for rollover and earlydelivery
                    // this method is invoked in pending order modification, cancelTrade , early delivery, rollover, order form loading from user  market watch
                    if (value.settlementDate == DateUtils.convertLocalDateToServer(tradeSettlementDate)) {
                        vm.tenor = value;
                    }
                })
                if (vm.tenor == null || vm.tenor == undefined) {
                    vm.tenor = vm.tenorsLookup[0];
                }
            } else {
                var filteredTenor = $filter('filter')(vm.tenorsLookup, { tenorName: 'Option Period' });
                if (filteredTenor != null && filteredTenor != undefined)
                    vm.tenor = filteredTenor[0];
            }
            $rootScope.tenor = vm.tenor;
        }

        function getInstrumentCodeForSettlement(tradeSettlementDate) {
            var tenor = null;
            angular.forEach(vm.tenors, function (value) {
                if (value.settlementDate == tradeSettlementDate) {
                    tenor = value;
                }
            })
            if (tenor == null || tenor == undefined) {
                if (tradeSettlementDate == $rootScope.retailSpotMarketSession.settlementDate) {
                    return 'SPOT';
                } else if (tradeSettlementDate == $rootScope.cashMarketSession.settlementDate) {
                    return 'CASH';
                } else if (tradeSettlementDate == $rootScope.tomMarketSession.settlementDate) {
                    return 'TOM';
                } else {
                    tenor = vm.tenors[0];
                    return 'Forward';
                }
            } else {
                return 'Forward';
            }
        }

        // to cancel order
        function cancelOrder(pendingOrder) {
            // prepareOrderDTO(pendingOrder, 'CNCL');
            //vm.remarks = "";
            setDefaultRemark();
            var orderDTO = {};

             if(pendingOrder.currencyPair==null){
                            angular.forEach($rootScope.currencyPairList, function (cp) {
                if (cp.id === pendingOrder.currencyPairId) {
                    pendingOrder.currencyPair = cp;
                }
            });
        }

            orderDTO = prepareOrderDTOToCancel(pendingOrder);
            if(orderDTO.currencyPairCode =='USDINR'){
                 $rootScope.enableOtherCurrencyTab = false;
            }else{
                  $rootScope.enableOtherCurrencyTab = true;
            }
            orderDTO.userId = vm.globalValues.getUserId();
            orderDTO.retailUserCode = vm.globalValues.getUser().login;
            orderDTO.userEntityOwnerId = vm.globalValues.getEntityOwnerTypeId();

            if (vm.userPreference.showPreOrderConfirmation == 'yes' || vm.globalValues.getSessionTimedOut()) {
                $rootScope.orderDTO = orderDTO;
                var closeTime = getCloseTimeForInstrumentCode(orderDTO.instrumentCode);
                //to remove focus from delete icon in pending orders report before pre-order confirmation.
                //after double enter on pre-order confirmation, the focus can be removed
                //code added on 07-Sep-2020 for double enter issue fix.
                setTimeout(function () { document.getElementById('ibspotMktSell').focus() }, 10);
                $state.go('pre-order-confirmation', { closeTime: closeTime, showPreOrderConfirmation: vm.userPreference.showPreOrderConfirmation, sessionTimedOut: vm.globalValues.getSessionTimedOut() });
            } else {
                //on 18-Nov-2020. db writer null issue - added call back procedures while sending orders
                if (OrderUtil.validateOrderDTOForNull(orderDTO)) {
                    Market.cancelOrder(orderDTO, onOrderCancelSuccess, onOrderCancelFailure);
                } else {
                    MessageBox.openMessageBox("Alert", "The order request is not processed, please submit again.", "Ok", "orderrequestfailure");
                }
                //defaultOrderEntry();
                // clear numeric controls
                //clearNumericControls();
                // setLTPPriceAsDefaultValueForLimitOrder();
            }
        }

        function onOrderCancelSuccess(result) {
            defaultOrderEntry();
            // clear numeric controls
            clearNumericControls();
        }

        function onOrderCancelFailure() {
            defaultOrderEntry();
            // clear numeric controls
            clearNumericControls();
        }

        /*
          * $scope.$watch('$rootScope.selectAll', function(value){
          * if(value==true){ angular.forEach($rootScope.pendingOrders,
          * function(value, index){ if(value.orderStatus!="Risk Validated"){
          * $rootScope.pendingOrders[index].select = true; } }) }else{
          * angular.forEach($rootScope.pendingOrders, function(value, index){
          * $rootScope.pendingOrders[index].select = false; }) } })
          */

        /*function checkOrUncheckOutstandingTrades(event){

            changeOutstandingTradesSelection(event.target.checked);

        }*/
        function checkOrUncheckPendingOrders(event) {

            changePendingOrderItemSelection(event.target.checked);

        }
        /*function changeOutstandingTradesSelection(value){
            if(value){
                angular.forEach($rootScope.outstandingTrades, function(value, index){
                        $rootScope.pendingOrders[index].select = true;
                });
            }
        }*/
        function changePendingOrderItemSelection(value) {
            if (value) {
                angular.forEach($rootScope.pendingOrders, function (value, index) {
                    if (value.orderStatus != "Risk Validated") {
                        $rootScope.pendingOrders[index].select = true;
                    }
                });
            } else {
                angular.forEach($rootScope.pendingOrders, function (value, index) {
                    $rootScope.pendingOrders[index].select = false;
                });
            }
        }

        vm.checkOrUncheckOutstandingTradesItem = checkOrUncheckOutstandingTradesItem;
        function checkOrUncheckOutstandingTradesItem(outstandingValue, event) {
            var selectedValue = event.target.checked;
            angular.forEach($rootScope.outstandingTrades, function (value, index) {
                value.select = false;
            })
            //$rootScope.outstandingTradesMemory = $rootScope.outstandingTrades;
            outstandingValue.select = selectedValue;
            // if(selectedValue==true && outstandingValue.instrumentCode!='Forward'){
            //     outstandingValue.select = false;
            //     MessageBox.openMessageBox("Alert", outstandingValue.instrumentCode + " contract cannot be selected for cancellation...!", "Ok", "selectedorders");
            // }
        }

        function checkOrUncheckPendingOrderItem() {
            var allSelected = true;

            angular.forEach($rootScope.pendingOrders, function (value, index) {
                if (!$rootScope.pendingOrders[index].select) {
                    allSelected = false
                }
            });

            if (allSelected) {
                vm.selectAll = true;
                // if(document.getElementById("selectAll")!=null ||
                // document.getElementById("selectAll")!=undefined)
                document.getElementById("selectAll").checked = true;
            } else {
                vm.selectAll = false;
                // if(document.getElementById("selectAll")!=null ||
                // document.getElementById("selectAll")!=undefined)
                document.getElementById("selectAll").checked = false;
            }
        }

        $scope.$watch('vm.selectAll', function (value) {
            $rootScope.selectAll = value;
        })

        $scope.$watch('vm.reportTab', function (value) {
            $rootScope.reportTab = vm.reportTab;
        })

        function cancelOutStandingTrade() {

            $rootScope.selectedTradesOutstanding = [];
            $rootScope.selectedTradesOutstanding = $filter('filter')($rootScope.outstandingTrades, { select: true });
            if ($rootScope.outstandingTrades.length > 0) {
                if (vm.globalValues.getSessionTimedOut()) {
                    $state.go('pre-order-confirmation', { closeTime: '', showPreOrderConfirmation: 'no', sessionTimedOut: vm.globalValues.getSessionTimedOut(), cancelSelected: true });
                } else {
                    MessageBox.openMessageBox("Alert", "Do you want to proceed to cancel selected Outstanding Trade?", "ProceedCancel", "cancelselectedoutstandingtrades");
                }
            } else {
                MessageBox.openMessageBox("Alert", "Please select a trade to proceed.", "Ok", "selectedorders");
            }
        }
        function cancelPendingOrdersSelected() {
            var ordersSelected = false;
            $rootScope.selectedPendingOrders = [];
            $rootScope.selectedPendingOrders = $filter('filter')($rootScope.pendingOrders, { select: true });
            if ($rootScope.selectedPendingOrders.length > 0) {
                // $scope.pendingOrders = $rootScope.pendingOrders;
                if (vm.globalValues.getSessionTimedOut()) {
                    $state.go('pre-order-confirmation', { closeTime: '', showPreOrderConfirmation: 'no', sessionTimedOut: vm.globalValues.getSessionTimedOut(), cancelSelected: true });
                } else {
                    MessageBox.openMessageBox("Alert", "Do you want to proceed to cancel selected order(s)?", "ProceedCancel", "cancelselectedorders");
                }
            } else {
                MessageBox.openMessageBox("Alert", "Please select the order(s) to proceed.", "Ok", "selectedorders");
            }
        }

        function cancelAllOrders() {
            // vm.selectAll = true;
            // angular.forEach($rootScope.pendingOrders, function(value, index){
            //     if(value.orderStatus!="Risk Validated"){
            //         $rootScope.pendingOrders[index].select = true;
            //     }
            // });
            //	$rootScope.selectedPendingOrders = [];
            //	$rootScope.selectedPendingOrders = $rootScope.pendingOrders;
            //	if($rootScope.selectedPendingOrders.length>0){
            // $scope.pendingOrders = $rootScope.pendingOrders;
            if (vm.globalValues.getSessionTimedOut()) {
                $state.go('pre-order-confirmation', { closeTime: '', showPreOrderConfirmation: 'no', sessionTimedOut: vm.globalValues.getSessionTimedOut(), cancelSelected: true });
            } else {
                $rootScope.proceedCancelAllOrders = 0;
                MessageBox.openMessageBox("Alert", "Do you want to proceed to cancel all order(s)?", "ProceedCancel", "cancelallorders");
            }
            //	} else{
            // 	MessageBox.openMessageBox("Alert", "Please select the order(s) to proceed.", "Ok", "allorders");
            // }
        }

        function cancelAllPendingOrders() {
            // if($rootScope.selectedPendingOrders.length>0){
            //     var orderDTOList = [];
            //     angular.forEach($rootScope.selectedPendingOrders, function(value, index){
            //         if(value){
            //             var orderDTO = {};
            //             orderDTO = prepareOrderDTOToCancel(value);
            //             orderDTOList.push(orderDTO);
            //             // place cancel order
            //         }
            //     })
            //     var orderRequestListDTO = {};
            //     orderRequestListDTO.orderRequestList = orderDTOList;
            if (vm.account.organisation.organisationType.shortName == 'CLEARCORP') {
                Market.cancelAllPendingOrdersForClearCorp(onCancelSelectedOrdersSuccess, onCancelSelectedOrdersFailure);
            } else {
                Market.cancelOrderListWithSingleObject(orderRequestListDTO, onCancelSelectedOrdersSuccess, onCancelSelectedOrdersFailure);
            }
            vm.selectAll = false;
            $rootScope.selectAll = false;
            $rootScope.selectedPendingOrders = [];
            defaultOrderEntry();
            // remove foucs on order entry screen
            removeOrderEntryFocus();
            // clear numeric controls
            clearNumericControls();
            //  }
        }
        function cancelSelectedOrders() {
            if ($rootScope.selectedPendingOrders.length > 0) {
                var orderDTOList = [];
                angular.forEach($rootScope.selectedPendingOrders, function (value, index) {
                    if (value.select) {
                        var orderDTO = {};

                        // if order receive from ops via feed set currency pair
                        if(value.currencyPair==null){
                            angular.forEach($rootScope.currencyPairList, function (cp) {
                if (cp.id === value.currencyPairId) {
                    value.currencyPair = cp;
                }
            });
                        }
                        //setSelectedCurrecy(value.currencyPairId);
                        orderDTO = prepareOrderDTOToCancel(value);
                        orderDTOList.push(orderDTO);
                        // place cancel order
                    }
                })
                var orderRequestListDTO = {};
                orderRequestListDTO.orderRequestList = orderDTOList;
                if (vm.account.organisation.organisationType.shortName == 'CLEARCORP') {
                    Market.cancelOrderListWithSingleObjectForClearCorp(orderRequestListDTO, onCancelSelectedOrdersSuccess, onCancelSelectedOrdersFailure);
                } else {
                    Market.cancelOrderListWithSingleObject(orderRequestListDTO, onCancelSelectedOrdersSuccess, onCancelSelectedOrdersFailure);
                }
                vm.selectAll = false;
                $rootScope.selectAll = false;
                $rootScope.selectedPendingOrders = [];
                defaultOrderEntry();
                // remove foucs on order entry screen
                removeOrderEntryFocus();
                // clear numeric controls
                clearNumericControls();
            }
        }
        function onCancelSelectedOrdersSuccess(result) {
            resetPendingOrderCheckboxSelection(false);
            if (vm.account.organisation.organisationType.shortName == 'CLEARCORP' && result.clientId == "Assigned") {
                MessageBox.openMessageBox("Alert", "A task has been submitted for approval", "Ok", "cancelorders")
            }

        }

        function onCancelSelectedOrdersFailure() {
            //do nothing
        }

        $rootScope.$on('gatewayApp.messagebox.proceed.cancelselectedoutstandingtrades', function (event, data) {
            if ($rootScope.selectedTradesOutstanding.length > 0) {
                var selectedTrades = angular.copy($rootScope.selectedTradesOutstanding);
                cancelTrade(selectedTrades);
                $rootScope.selectedTradesOutstanding = [];
            }
        })

        $rootScope.$on('gatewayApp.messagebox.proceed.cancelselectedorders', function (event, data) {
            if (document.getElementById('btnCancelSelected') != null) {
                setTimeout(function () {
                    document.getElementById('btnCancelSelected').blur();
                });
            }
            cancelSelectedOrders();
        });

        $rootScope.$on('gatewayApp.messagebox.ok.selectedorders', function (event, data) {
            if (document.getElementById('btnCancelSelected') != null) {
                setTimeout(function () {
                    document.getElementById('btnCancelSelected').blur();
                });
            }
        });

        $rootScope.$on('gatewayApp.messagebox.cancel.cancelselectedorders', function (event, data) {
            // do not proceed
            defaultOrderEntry();
            // clear numeric controls
            clearNumericControls();
        });

        var proceedCancelAllOrders = $rootScope.$on('gatewayApp.messagebox.proceed.cancelallorders', function (event, data) {
            if ($rootScope.proceedCancelAllOrders > 0) {
                if (document.getElementById('btnCancelAll') != null) {
                    setTimeout(function () {
                        document.getElementById('btnCancelAll').blur();
                    });
                }
                cancelAllPendingOrders();
            }
            $rootScope.proceedCancelAllOrders = $rootScope.proceedCancelAllOrders + 1;


        });

        $rootScope.$on('gatewayApp.messagebox.ok.allorders', function (event, data) {
            if (document.getElementById('btnCancelAll') != null) {
                setTimeout(function () {
                    document.getElementById('btnCancelAll').blur();
                });
            }
        });

        $rootScope.$on('gatewayApp.messagebox.cancel.cancelallorders', function (event, data) {
            // do not proceed
            defaultOrderEntry();
            // clear numeric controls
            clearNumericControls();
        });

        // get equivalent spot price for limit and trigger prices
        $scope.$watchGroup(['vm.orderDTO.limitExchangeRate', 'vm.defaultInstrumentCode', 'vm.orderType', 'vm.tradingBank', 'vm.tradeSettlementDate', 'vm.tradeSettlementDateFrom', 'vm.tenor', 'defaultBankSpread', 'marketSessionSettings'], function (value) {
            if ($rootScope.defaultBankSpread != null && $rootScope.defaultBankSpread != undefined
                && vm.orderDTO.limitExchangeRate != null && vm.orderDTO.limitExchangeRate != undefined && vm.orderDTO.limitExchangeRate > 0) {
                if (vm.defaultInstrumentCode != 'SPOT') {
                    var tickSize = gettickSizeForGivenInstrument(vm.defaultInstrumentCode);
                    /*vm.spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, vm.orderType,
                        DateUtils.convertLocalDateToServer(angular.copy(vm.tradeSettlementDate)), $rootScope.retailSpotMarketSession.settlementDate,
                        tickSize);*/
                    vm.spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, vm.orderType,
                        DateUtils.convertLocalDateToServer(getSettlementDate(vm.defaultInstrumentCode, vm.orderType)), vm.currencyPair.code === 'USDINR' ? $rootScope.retailSpotMarketSession.settlementDate : $rootScope.marketSessionMap[vm.defaultInstrumentTokenSequenceNo].settlementDate,
                        tickSize);
                    if (vm.defaultInstrumentCode != 'Forward') {
                        vm.orderDTO.limitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.limitExchangeRate, vm.spreadUsed);
                    } else {
                        vm.orderDTO.limitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.limitExchangeRate, (vm.spreadUsed * -1));
                    }
                } else {
                    vm.orderDTO.limitExchangeRateInSpot = vm.orderDTO.limitExchangeRate;
                }
            } else if ($rootScope.defaultBankSpread != null && $rootScope.defaultBankSpread != undefined && $rootScope.retailSpotMarketSession != null && $rootScope.retailSpotMarketSession != undefined) {
                if (vm.defaultInstrumentCode != 'SPOT') {
                    var tickSize = gettickSizeForGivenInstrument(vm.defaultInstrumentCode);
                    vm.spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, vm.orderType,
                        DateUtils.convertLocalDateToServer(getSettlementDate(vm.defaultInstrumentCode, vm.orderType)), vm.currencyPair.code === 'USDINR' ? $rootScope.retailSpotMarketSession.settlementDate : $rootScope.marketSessionMap[vm.defaultInstrumentTokenSequenceNo].settlementDate,
                        tickSize);
                }
            }
        })

        $scope.$watchGroup(['vm.orderDTO.limitExchangeRate', 'vm.defaultPriceCondition'], function (value) {
            if (vm.orderDTO.limitExchangeRate == null || vm.orderDTO.limitExchangeRate == undefined || vm.orderDTO.limitExchangeRate == '') {
                setFieldValues("txtlimitorderprice", "");
                setFieldValues("txtsllimitprice", "");
                setFieldValues("txttplimitprice", "");
                setFieldValues("txtlimitorderprice1", "");
                setFieldValues("txtsllimitprice1", "");
                setFieldValues("txttplimitprice1", "");
                setFieldValues("txtlimitorderprice2", "");
                setFieldValues("txtlimitorderprice3", "");
                setFieldValues("txtlimitorderprice4", "");
                setFieldValues("txtsllimitprice2", "");
                setFieldValues("txttplimitprice2", "");
                if (vm.defaultPriceCondition == 'STLS') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtlimitorderprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txttplimitprice" + "txtrequired", true);
                    }
                    if ($scope.mdfyOrderForm != null && $scope.mdfyOrderForm != undefined) {
                        $scope.mdfyOrderForm.$setValidity("txtlimitorderprice1" + "txtrequired", true);
                        $scope.mdfyOrderForm.$setValidity("txttplimitprice1" + "txtrequired", true);
                    }
                    if ($scope.tradeOrderForm != null && $scope.tradeOrderForm != undefined) {
                        $scope.tradeOrderForm.$setValidity("txtlimitorderprice2" + "txtrequired", true);
                        $scope.tradeOrderForm.$setValidity("txttplimitprice2" + "txtrequired", true);
                    }
                    if ($scope.rolloverOrderForm != null && $scope.rolloverOrderForm != undefined) {
                        $scope.rolloverOrderForm.$setValidity("txtlimitorderprice3" + "txtrequired", true);
                    }
                    if ($scope.earlyDeliveryOrderForm != null && $scope.earlyDeliveryOrderForm != undefined) {
                        $scope.earlyDeliveryOrderForm.$setValidity("txtlimitorderprice4" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'TKPR') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsllimitprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtlimitorderprice" + "txtrequired", true);
                    }
                    if ($scope.mdfyOrderForm != null && $scope.mdfyOrderForm != undefined) {
                        $scope.mdfyOrderForm.$setValidity("txtsllimitprice1" + "txtrequired", true);
                        $scope.mdfyOrderForm.$setValidity("txtlimitorderprice1" + "txtrequired", true);
                    }
                    if ($scope.tradeOrderForm != null && $scope.tradeOrderForm != undefined) {
                        $scope.mdfyOrderForm.$setValidity("txtsllimitprice2" + "txtrequired", true);
                        $scope.tradeOrderForm.$setValidity("txtlimitorderprice2" + "txtrequired", true);
                    }
                    if ($scope.rolloverOrderForm != null && $scope.rolloverOrderForm != undefined) {
                        $scope.rolloverOrderForm.$setValidity("txtlimitorderprice3" + "txtrequired", true);
                    }
                    if ($scope.earlyDeliveryOrderForm != null && $scope.earlyDeliveryOrderForm != undefined) {
                        $scope.earlyDeliveryOrderForm.$setValidity("txtlimitorderprice4" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'LIMT') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsllimitprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txttplimitprice" + "txtrequired", true);
                    }
                    if ($scope.mdfyOrderForm != null && $scope.mdfyOrderForm != undefined) {
                        $scope.mdfyOrderForm.$setValidity("txtsllimitprice1" + "txtrequired", true);
                        $scope.mdfyOrderForm.$setValidity("txttplimitprice1" + "txtrequired", true);
                    }
                    if ($scope.tradeOrderForm != null && $scope.tradeOrderForm != undefined) {
                        $scope.tradeOrderForm.$setValidity("txtsllimitprice2" + "txtrequired", true);
                        $scope.tradeOrderForm.$setValidity("txttplimitprice2" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'MRKT') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsllimitprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtlimitorderprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txttplimitprice" + "txtrequired", true);
                    }
                    if ($scope.mdfyOrderForm != null && $scope.mdfyOrderForm != undefined) {
                        $scope.mdfyOrderForm.$setValidity("txtsllimitprice1" + "txtrequired", true);
                        $scope.mdfyOrderForm.$setValidity("txtlimitorderprice1" + "txtrequired", true);
                        $scope.mdfyOrderForm.$setValidity("txttplimitprice1" + "txtrequired", true);
                    }
                    if ($scope.tradeOrderForm != null && $scope.tradeOrderForm != undefined) {
                        $scope.tradeOrderForm.$setValidity("txtsllimitprice2" + "txtrequired", true);
                        $scope.tradeOrderForm.$setValidity("txtlimitorderprice2" + "txtrequired", true);
                        $scope.tradeOrderForm.$setValidity("txttplimitprice2" + "txtrequired", true);
                    }
                    if ($scope.rolloverOrderForm != null && $scope.rolloverOrderForm != undefined) {
                        $scope.rolloverOrderForm.$setValidity("txtlimitorderprice3" + "txtrequired", true);
                    }
                    if ($scope.earlyDeliveryOrderForm != null && $scope.earlyDeliveryOrderForm != undefined) {
                        $scope.earlyDeliveryOrderForm.$setValidity("txtlimitorderprice4" + "txtrequired", true);
                    }
                }
            }
        })

        $scope.$watchGroup(['vm.orderDTO.buyLimitExchangeRate', 'vm.defaultPriceCondition'], function (value) {
            if (vm.orderDTO.buyLimitExchangeRate == null || vm.orderDTO.buyLimitExchangeRate == undefined || vm.orderDTO.buyLimitExchangeRate == '') {
                setFieldValues("txtsellbuyslbuylimitprice", "");
                setFieldValues("txtsellbuytpbuylimitprice", "");
                setFieldValues("txtsellbuylimitbuyorderprice", "");
                if (vm.defaultPriceCondition == 'MRKT') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuyslbuylimitprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtsellbuytpbuylimitprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtsellbuylimitbuyorderprice" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'STLS') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuytpbuylimitprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtsellbuylimitbuyorderprice" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'LIMT') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuyslbuylimitprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtsellbuytpbuylimitprice" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'TKPR') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuyslbuylimitprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtsellbuylimitbuyorderprice" + "txtrequired", true);
                    }
                }
            }
             else{
                console.log("buyy price check",vm.orderDTO.buyLimitExchangeRate);
                if(vm.defaultPriceCondition!=null && vm.defaultPriceCondition!=undefined){
                    console.log("price condition",vm.defaultPriceCondition);
                       if ($scope.orderForm.txtsellbuylimitsellorderprice.$invalid) {

        console.log("Field is invalid sell order price 2",vm.orderDTO.buyLimitExchangeRate);
    }

    if ($scope.orderForm.txtsellbuylimitbuyorderprice.$invalid) {
        console.log("Field is invalid sell order price 2",vm.orderDTO.buyLimitExchangeRate);
    }

                }else{
                    if ($scope.orderForm.txtsellbuylimitsellorderprice.$invalid) {
        console.log("Field is invalid sell order price 3",vm.orderDTO.buyLimitExchangeRate);
    }

    if ($scope.orderForm.txtsellbuylimitbuyorderprice.$invalid) {
        console.log("Field is invalid sell order price 3",vm.orderDTO.buyLimitExchangeRate);
    }
                }
            }
        })

        $scope.$watchGroup(['vm.orderDTO.sellLimitExchangeRate', 'vm.defaultPriceCondition'], function (value) {
            if (vm.orderDTO.sellLimitExchangeRate == null || vm.orderDTO.sellLimitExchangeRate == undefined || vm.orderDTO.sellLimitExchangeRate == '') {
                setFieldValues("txtsellbuyslselllimitprice", "");
                setFieldValues("txtsellbuytpselllimitprice", "");
                setFieldValues("txtsellbuylimitsellorderprice", "");
                if (vm.defaultPriceCondition == 'MRKT') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuyslselllimitprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtsellbuytpselllimitprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtsellbuylimitsellorderprice" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'STLS') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuytpselllimitprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtsellbuylimitsellorderprice" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'LIMT') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuyslselllimitprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtsellbuytpselllimitprice" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'TKPR') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuyslselllimitprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtsellbuylimitsellorderprice" + "txtrequired", true);
                    }
                }
            }
            else{
                console.log("sell price check",vm.orderDTO.sellLimitExchangeRate);

                if(vm.defaultPriceCondition!=null && vm.defaultPriceCondition!=undefined){
                    console.log("price condition 2",vm.defaultPriceCondition);
                       if ($scope.orderForm.txtsellbuylimitsellorderprice.$invalid) {
        console.log("Field is invalid sell order price",vm.orderDTO.sellLimitExchangeRate);
    }

    if ($scope.orderForm.txtsellbuylimitbuyorderprice.$invalid) {
        console.log("Field is invalid sell order price",vm.orderDTO.sellLimitExchangeRate);
    }

                }else{
                    if ($scope.orderForm.txtsellbuylimitsellorderprice.$invalid) {
        console.log("Field is invalid sell order price 1",vm.orderDTO.sellLimitExchangeRate);
    }

    if ($scope.orderForm.txtsellbuylimitbuyorderprice.$invalid) {
        console.log("Field is invalid sell order price 1",vm.orderDTO.sellLimitExchangeRate);
    }
                }
            }
        })

        $scope.$watchGroup(['vm.orderDTO.stopExchangeRate', 'vm.defaultPriceCondition'], function (value) {
            if (vm.orderDTO.stopExchangeRate == null || vm.orderDTO.stopExchangeRate == undefined || vm.orderDTO.stopExchangeRate == '') {
                setFieldValues("txtsltriggerprice", "");
                setFieldValues("txttptriggerprice", "");
                setFieldValues("txtsltriggerprice1", "");
                setFieldValues("txttptriggerprice1", "");
                setFieldValues("txtsltriggerprice2", "");
                setFieldValues("txttptriggerprice2", "");
                if (vm.defaultPriceCondition == 'MRKT') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsltriggerprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txttptriggerprice" + "txtrequired", true);
                    }
                    if ($scope.mdfyOrderForm != null && $scope.mdfyOrderForm != undefined) {
                        $scope.mdfyOrderForm.$setValidity("txtsltriggerprice1" + "txtrequired", true);
                        $scope.mdfyOrderForm.$setValidity("txttptriggerprice1" + "txtrequired", true);
                    }
                    if ($scope.tradeOrderForm != null && $scope.tradeOrderForm != undefined) {
                        $scope.tradeOrderForm.$setValidity("txtsltriggerprice2" + "txtrequired", true);
                        $scope.tradeOrderForm.$setValidity("txttptriggerprice2" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'STLS') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txttptriggerprice" + "txtrequired", true);
                    }
                    if ($scope.mdfyOrderForm != null && $scope.mdfyOrderForm != undefined) {
                        $scope.mdfyOrderForm.$setValidity("txttptriggerprice1" + "txtrequired", true);
                    }
                    if ($scope.tradeOrderForm != null && $scope.tradeOrderForm != undefined) {
                        $scope.tradeOrderForm.$setValidity("txttptriggerprice2" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'LIMT') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsltriggerprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txttptriggerprice" + "txtrequired", true);
                    }
                    if ($scope.mdfyOrderForm != null && $scope.mdfyOrderForm != undefined) {
                        $scope.mdfyOrderForm.$setValidity("txtsltriggerprice1" + "txtrequired", true);
                        $scope.mdfyOrderForm.$setValidity("txttptriggerprice1" + "txtrequired", true);
                    }
                    if ($scope.tradeOrderForm != null && $scope.tradeOrderForm != undefined) {
                        $scope.tradeOrderForm.$setValidity("txtsltriggerprice2" + "txtrequired", true);
                        $scope.tradeOrderForm.$setValidity("txttptriggerprice2" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'TKPR') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsltriggerprice" + "txtrequired", true);
                    }
                    if ($scope.mdfyOrderForm != null && $scope.mdfyOrderForm != undefined) {
                        $scope.mdfyOrderForm.$setValidity("txtsltriggerprice1" + "txtrequired", true);
                    }
                    if ($scope.tradeOrderForm != null && $scope.tradeOrderForm != undefined) {
                        $scope.tradeOrderForm.$setValidity("txtsltriggerprice2" + "txtrequired", true);
                    }
                }
            }
        })

        $scope.$watchGroup(['vm.orderDTO.buyStopExchangeRate', 'vm.defaultPriceCondition'], function (value) {
            if (vm.orderDTO.buyStopExchangeRate == null || vm.orderDTO.buyStopExchangeRate == undefined || vm.orderDTO.buyStopExchangeRate == '') {
                setFieldValues("txtsellbuyslbuytriggerprice", "");
                setFieldValues("txtsellbuytpbuytriggerprice", "");
                if (vm.defaultPriceCondition == 'MRKT') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuyslbuytriggerprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtsellbuytpbuytriggerprice" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'STLS') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuytpbuytriggerprice" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'LIMT') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuyslbuytriggerprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtsellbuytpbuytriggerprice" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'TKPR') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuyslbuytriggerprice" + "txtrequired", true);
                    }
                }
            }
        })

        $scope.$watchGroup(['vm.orderDTO.sellStopExchangeRate', 'vm.defaultPriceCondition'], function (value) {
            if (vm.orderDTO.sellStopExchangeRate == null || vm.orderDTO.sellStopExchangeRate == undefined || vm.orderDTO.sellStopExchangeRate == '') {
                setFieldValues("txtsellbuyslselltriggerprice", "");
                setFieldValues("txtsellbuytpselltriggerprice", "");
                if (vm.defaultPriceCondition == 'MRKT') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuyslselltriggerprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtsellbuytpselltriggerprice" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'STLS') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuytpselltriggerprice" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'LIMT') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuyslselltriggerprice" + "txtrequired", true);
                        $scope.orderForm.$setValidity("txtsellbuytpselltriggerprice" + "txtrequired", true);
                    }
                } else if (vm.defaultPriceCondition == 'TKPR') {
                    if ($scope.orderForm != null && $scope.orderForm != undefined) {
                        $scope.orderForm.$setValidity("txtsellbuyslselltriggerprice" + "txtrequired", true);
                    }
                }
            }
        })

        $scope.$watchGroup([' ', 'vm.defaultPriceCondition'], function (value) {
            if (vm.orderDTO.orderAmount == null || vm.orderDTO.orderAmount == undefined || vm.orderDTO.orderAmount == '') {
                setFieldValues("txtlimitordervalue", "");
                setFieldValues("txtsellbuylimitordervalue", "");
                setFieldValues("txtmktordervalue", "");
                setFieldValues("txtsellbuymktordervalue", "");
                setFieldValues("txtslordervalue", "");
                setFieldValues("txtsellbuyslordervalue", "");
                setFieldValues("txttpordervalue", "");
                setFieldValues("txtsellbuytpordervalue", "");
                if ($scope.orderForm != null && $scope.orderForm != undefined) {
                    $scope.orderForm.$setValidity("txtsellbuyslselltriggerprice" + "txtrequired", true);
                    $scope.orderForm.$setValidity("txtsellbuylimitordervalue" + "txtrequired", true);
                    $scope.orderForm.$setValidity("txtmktordervalue" + "txtrequired", true);
                    $scope.orderForm.$setValidity("txtsellbuymktordervalue" + "txtrequired", true);
                    $scope.orderForm.$setValidity("txtslordervalue" + "txtrequired", true);
                    $scope.orderForm.$setValidity("txtsellbuyslordervalue" + "txtrequired", true);
                    $scope.orderForm.$setValidity("txttpordervalue" + "txtrequired", true);
                    $scope.orderForm.$setValidity("txtsellbuytpordervalue" + "txtrequired", true);
                }
            }
            else if (vm.regularAndSplitOrder == 'Split' && vm.orderDTO.orderAmount != null && vm.orderDTO.orderAmount != undefined && vm.orderDTO.orderAmount != '') {
                splitorderValidation(vm.orderDTO.orderAmount, vm.noOfSplits);
            }
        })

        $scope.$watch('vm.orderDTO.orderAmount', function (value) {
                      if(vm.currencyPair && vm.currencyPair.code == 'JPYINR' && vm.orderDTO.orderAmount != null && vm.orderDTO.orderAmount != undefined && vm.orderDTO.orderAmount != '') {
                 validateJPYCurerency();
            }else{
                    vm.clicked = false;
                    $scope.errorTextOrderAmount = "";
            }
        })



        $scope.$watchGroup(['vm.defaultInstrumentCode', 'vm.tradeSettlementDate'], function (value) {
            if (vm.defaultInstrumentCode != 'Forward') {
                if ($scope.orderForm != null && $scope.orderForm != undefined) {
                    $scope.orderForm.$setValidity("dtpTradeSettlementDate1" + "txtrequired", true);
                    $scope.orderForm.$setValidity("dtpTradeSettlementDate2" + "txtrequired", true);
                    $scope.orderForm.$setValidity("dtpTradeSettlementDate3" + "txtrequired", true);
                    $scope.orderForm.$setValidity("dtpTradeSettlementDate4" + "txtrequired", true);
                }
            }
            $rootScope.defaultInstrumentCode = vm.defaultInstrumentCode;
            $rootScope.tradeSettlementDate = vm.tradeSettlementDate;
        })
        //if it is split order
        $scope.$watch('vm.noOfSplits', function (value) {
            if (value == null || value == undefined || value == '') {
                $scope.errorTextNoOfSplits = "";
                if ($scope.orderForm != null && $scope.orderForm != undefined) {
                    setFieldValues("txtNoOfSplitValue", "");
                    setFieldValues("txtsellbuylimitNoOfSplitValue", "");
                    $scope.orderForm.$setValidity("txtNoOfSplitValue" + "txtrequired", true);
                    $scope.orderForm.$setValidity("txtsellbuylimitNoOfSplitValue" + "txtrequired", true);
                }
            } else if (value != null && value != undefined && value != "") {
                splitorderValidation(vm.orderDTO.orderAmount, vm.noOfSplits);
            }
        })
        //if it is regular order empty to all split order action
        $scope.$watch('vm.regularAndSplitOrder', function (value) {
            if (vm.regularAndSplitOrder == 'Regular') {
                /*   $scope.orderForm.$setValidity("txtNoOfSplitValue" + "txtrequired", true);
                  $scope.orderForm.$setValidity("txtsellbuylimitNoOfSplitValue" + "txtrequired", true);  */
                vm.clicked = false;
                $rootScope.splitedOrderAmount = "";
                vm.noOfSplits = "";
                $scope.errorTextNoOfSplits = "";
                $scope.errorTextOrderAmount = "";
                vm.orderDTO.isSplitOrder = false;
            } else {
                $scope.orderForm.$setValidity("txtNoOfSplitValue" + "txtrequired", true);
                $scope.orderForm.$setValidity("txtsellbuylimitNoOfSplitValue" + "txtrequired", true);
            }

        })

        $scope.setForm = function (form) {
            $scope.orderForm = form;
        }

        $scope.setMdfyForm = function (form) {
            $scope.mdfyOrderForm = form;
        }

        $scope.setTradeForm = function (form) {
            $scope.tradeOrderForm = form;
        }

        // $scope.$watchGroup(['vm.orderDTO.limitExchangeRate', 'vm.defaultInstrumentCode', 'vm.orderType', 'vm.defaultPriceCondition',
        //     'vm.orderDTO.limitExchangeRate', 'vm.orderDTO.stopExchangeRate', 'vm.orderDTO.buyLimitExchangeRate', 'vm.orderDTO.sellLimitExchangeRate',
        //     'vm.orderDTO.buyStopExchangeRate', 'vm.orderDTO.sellStopExchangeRate'], function (value) {
        //         if (vm.account != null && vm.account != undefined) {
        //             if (vm.account.organisation.organisationType.shortName == 'BANK') {
        //                 if (vm.tradingCustomer != null && vm.tradingCustomer != undefined) {
        //                     getLimitsAvailableForAllInstruments(vm.globalValues.getOrganisation().id, vm.tradingCustomer.id);
        //                 }
        //             }
        //         }
        //     })



//         $scope.$watchGroup([
//     'vm.defaultInstrumentCode',
//     'vm.orderType',
//     'vm.defaultPriceCondition'
// ], function(newVal, oldVal) {
//     if (newVal === oldVal) return;
//     if (vm.account &&
//         vm.account.organisation.organisationType.shortName === 'BANK' &&
//         vm.tradingCustomer) {
//         // No debounce — instrument/order type change is a deliberate user action
//         getLimitsAvailableForAllInstruments(
//             vm.globalValues.getOrganisation().id,
//             vm.tradingCustomer.id
//         );
//     }
// });

// $scope.$watchGroup([
//     'vm.orderDTO.limitExchangeRate',
//     'vm.orderDTO.buyLimitExchangeRate',
//     'vm.orderDTO.sellLimitExchangeRate',
//     'vm.orderDTO.stopExchangeRate',
//     'vm.orderDTO.buyStopExchangeRate',
//     'vm.orderDTO.sellStopExchangeRate'
// ], function() {

//     if (!(vm.account &&
//         vm.account.organisation.organisationType.shortName === 'BANK' &&
//         vm.tradingCustomer)) {
//         return;
//     }

//     // cancel previous timer
//     if (_limitFetchDebounce) {
//         $timeout.cancel(_limitFetchDebounce);
//     }

//     // set new debounce
//     _limitFetchDebounce = $timeout(function () {
//         console.log("API CALLED"); // debug this
//         getLimitsAvailableForAllInstruments(
//             vm.globalValues.getOrganisation().id,
//             vm.tradingCustomer.id
//         );
//     }, 1200);
// });

        function setOrderEntryFocus() {
            // $timeout(function(){
            if (vm.account.organisation.organisationType.shortName == 'BANK') {
                if (vm.tradingCustomer != null && vm.tradingCustomer != undefined) {
                    getLimitsAvailableForAllInstruments(vm.globalValues.getOrganisation().id, vm.tradingCustomer.id);
                }
            }
            vm.showLA = true;

            // }, 1000)
        }

        function removeOrderEntryFocus() {
            if (vm.account.organisation.organisationType.shortName == 'BANK') {
                vm.showLA = false;
            }
        }

        function softCheckDeviationForLimitExchangeRate(value) {
            vm.limitPriceDeviationWarning = '';
            if (value != null && value != undefined && value != '') {
                var higherCutOffPriceSoft = $rootScope.previousDayClosingPriceForIbSpot + Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise / 100);
                var lowerCutOffPriceSoft = $rootScope.previousDayClosingPriceForIbSpot - Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise / 100);
                var ltp = getLtpValue(vm.currencyPair,vm.defaultInstrumentTokenSequenceNo);
                if (ltp > 0 && ltp != undefined && ltp != null) {
                    higherCutOffPriceSoft = ltp + (Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise / 100));
                    lowerCutOffPriceSoft = ltp - (Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise / 100));
                }

                /*
                 * if(vm.defaultPriceCondition!='MRKT' &&
                 * (Math.round(parseFloat(vm.orderDTO.limitExchangeRateInSpot)*10000) <
                 * Math.round(parseFloat(lowerCutOffPriceSoft)*10000) ||
                 * Math.round(parseFloat(vm.orderDTO.limitExchangeRateInSpot)*10000) >
                 * Math.round(parseFloat(higherCutOffPriceSoft)*10000))){
                 * vm.limitPriceDeviationWarning = 'Deviates by more than ' +
                 * vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise + '
                 * paise from the LTP'; }
                 */
                if (vm.defaultPriceCondition != 'MRKT') {
                    vm.limitPriceDeviationWarning = softCheckDeviation(vm.orderDTO.limitExchangeRateInSpot, higherCutOffPriceSoft, lowerCutOffPriceSoft, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise);
                }
            }
        }

        function softCheckDeviationForBuyLimitExchangeRate(value) {
            vm.buyLimitPriceDeviationWarning = '';
            if (value != null && value != undefined && value != '') {
                var higherCutOffPriceSoft = $rootScope.previousDayClosingPriceForIbSpot + Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise / 100);
                var lowerCutOffPriceSoft = $rootScope.previousDayClosingPriceForIbSpot - Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise / 100);
                var ltp = getLtpValue(vm.currencyPair,vm.defaultInstrumentTokenSequenceNo);
                if (ltp > 0 && ltp != undefined && ltp != null) {
                    higherCutOffPriceSoft = ltp + (Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise / 100));
                    lowerCutOffPriceSoft = ltp - (Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise / 100));
                }

                /*
                 * if(vm.defaultPriceCondition!='MRKT' &&
                 * (Math.round(parseFloat(vm.orderDTO.buyLimitExchangeRateInSpot)*10000) <
                 * Math.round(parseFloat(lowerCutOffPriceSoft)*10000) ||
                 * Math.round(parseFloat(vm.orderDTO.buyLimitExchangeRateInSpot)*10000) >
                 * Math.round(parseFloat(higherCutOffPriceSoft)*10000))){
                 * vm.buyLimitPriceDeviationWarning = 'Deviates by more than ' +
                 * vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise + '
                 * paise from the LTP'; }
                 */
                if (vm.defaultPriceCondition != 'MRKT') {
                    vm.buyLimitPriceDeviationWarning = softCheckDeviation(vm.orderDTO.buyLimitExchangeRateInSpot, higherCutOffPriceSoft, lowerCutOffPriceSoft, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise);
                }
            }
        }

        function softCheckDeviationForSellLimitExchangeRate(value) {
            vm.sellLimitPriceDeviationWarning = '';
            if (value != null && value != undefined && value != '') {
                var higherCutOffPriceSoft = $rootScope.previousDayClosingPriceForIbSpot + Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise / 100);
                var lowerCutOffPriceSoft = $rootScope.previousDayClosingPriceForIbSpot - Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise / 100);
                var ltp = getLtpValue(vm.currencyPair,vm.defaultInstrumentTokenSequenceNo);
                if (ltp > 0 && ltp != undefined && ltp != null) {
                    higherCutOffPriceSoft = ltp + (Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise / 100));
                    lowerCutOffPriceSoft = ltp - (Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise / 100));
                }

                /*
                 * if(vm.defaultPriceCondition!='MRKT' &&
                 * (Math.round(parseFloat(vm.orderDTO.sellLimitExchangeRateInSpot)*10000) <
                 * Math.round(parseFloat(lowerCutOffPriceSoft)*10000) ||
                 * Math.round(parseFloat(vm.orderDTO.sellLimitExchangeRateInSpot)*10000) >
                 * Math.round(parseFloat(higherCutOffPriceSoft)*10000))){
                 * vm.sellLimitPriceDeviationWarning = 'Deviates by more than ' +
                 * vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise + '
                 * paise from the LTP'; }
                 */
                if (vm.defaultPriceCondition != 'MRKT') {
                    vm.sellLimitPriceDeviationWarning = softCheckDeviation(vm.orderDTO.sellLimitExchangeRateInSpot, higherCutOffPriceSoft, lowerCutOffPriceSoft, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise);
                }
            }
        }

        vm.configSettings = vm.globalValues.getConfigSettings();
        vm.transactionParametersSettings =  vm.globalValues.getTransactionParametersSettings();
        function softCheckDeviation(limitExchangeRate, higherCutOff, lowerCutOff, deviationPriceInPaise) {
            var errorString = '';
            var firstLeg = 0;
            //        	var secondLeg = 0;
            if (limitExchangeRate != null && !isNaN(limitExchangeRate)) {
                firstLeg = Number(limitExchangeRate);
                //            	if(Number(limitExchangeRate) < 10){
                //            		firstLeg = Number(limitExchangeRate) * Number(10);
                //            		secondLeg = Number(firstLeg) + Number(9.9999);
                //            	}else{
                //            		firstLeg = Number(limitExchangeRate);
                //            		var splitByFloat = limitExchangeRate.split(".");
                //
                //            		var rx = /[0-9]/gi;
                //            		if(splitByFloat.length>1){
                //            			var decimalDigit = splitByFloat[1];
                //            			if(decimalDigit.match(rx).length>3){
                //            				secondLeg = Number(limitExchangeRate);
                //            			}else if(decimalDigit.match(rx).length>2){
                //            				secondLeg = Number(limitExchangeRate) + Number(0.0000);
                //            			}else if(decimalDigit.match(rx).length>1){
                //            				secondLeg = Number(limitExchangeRate) + Number(0.0000);
                //            			}else if(decimalDigit.match(rx).length>0){
                //            				secondLeg = Number(limitExchangeRate) + Number(0.0000);
                //            			}
                //            		}else if(splitByFloat.length==1){
                //            			secondLeg = Number(limitExchangeRate) + Number(0.0000);
                //            		}else{
                //            			secondLeg = Number(limitExchangeRate) + Number(0.0000);
                //            		}
                //            	}

                /*	if((Math.round(parseFloat(firstLeg)*10000) < Math.round(parseFloat(lowerCutOff)*10000) && Math.round(parseFloat(secondLeg)*10000) < Math.round(parseFloat(lowerCutOff)*10000))
                            || (Math.round(parseFloat(firstLeg)*10000) > Math.round(parseFloat(higherCutOff)*10000) && Math.round(parseFloat(secondLeg)*10000) > Math.round(parseFloat(higherCutOff)*10000))){
                        errorString = 'deviates by more than ' + deviationPriceInPaise + ' paise from the LTP. ';
                    }
                    */
                //The above set of coding is commented since there is an issue with soft check when given in whole numbers like 69, 70.
                //Only low softcheck gets failed due to secondleg calc. Therefore, only first leg calc is ok to check soft check.

                if ((Math.round(parseFloat(firstLeg) * 10000) < Math.round(parseFloat(lowerCutOff) * 10000))
                    || (Math.round(parseFloat(firstLeg) * 10000) > Math.round(parseFloat(higherCutOff) * 10000))) {
                    errorString = 'deviates by more than </br>' + "<span class='softcheck-value'>" + deviationPriceInPaise + "&nbsp;paise" + "</span> " + ' from the Last Traded Price (LTP).</br> ';
                }
            }
            return errorString;
        }

        // stop exchange rate
        $scope.$watchGroup(['vm.orderDTO.stopExchangeRate', 'vm.defaultInstrumentCode', 'vm.orderType', 'vm.tradingBank', 'vm.tradeSettlementDate', 'vm.tradeSettlementDateFrom', 'vm.tenor', 'defaultBankSpread', 'marketSessionSettings'], function (value) {
            if ($rootScope.defaultBankSpread != null && $rootScope.defaultBankSpread != undefined
                && vm.orderDTO.stopExchangeRate != null && vm.orderDTO.stopExchangeRate != undefined && vm.orderDTO.stopExchangeRate > 0) {

                if (vm.defaultInstrumentCode != 'SPOT') {
                    var tickSize = gettickSizeForGivenInstrument(vm.defaultInstrumentCode);
                    //angular.copy(vm.tradeSettlementDate)
                    vm.stopSpreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, vm.orderType,
                        DateUtils.convertLocalDateToServer(getSettlementDate(vm.defaultInstrumentCode, vm.orderType)), vm.currencyPair.code === 'USDINR' ? $rootScope.retailSpotMarketSession.settlementDate : $rootScope.marketSessionMap[vm.defaultInstrumentTokenSequenceNo].settlementDate,
                        tickSize);
                    if (vm.defaultInstrumentCode != 'Forward') {
                        vm.orderDTO.stopExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.stopExchangeRate, vm.stopSpreadUsed);
                    } else {
                        vm.orderDTO.stopExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.stopExchangeRate, (vm.stopSpreadUsed * -1));
                    }
                } else {
                    vm.orderDTO.stopExchangeRateInSpot = vm.orderDTO.stopExchangeRate;
                }
            } else if ($rootScope.defaultBankSpread != null && $rootScope.defaultBankSpread != undefined && $rootScope.retailSpotMarketSession != null && $rootScope.retailSpotMarketSession != undefined) {
                if (vm.defaultInstrumentCode != 'SPOT') {
                    var tickSize = gettickSizeForGivenInstrument(vm.defaultInstrumentCode);
                    vm.stopSpreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, vm.orderType,
                        DateUtils.convertLocalDateToServer(getSettlementDate(vm.defaultInstrumentCode, vm.orderType)), vm.currencyPair.code === 'USDINR' ? $rootScope.retailSpotMarketSession.settlementDate : $rootScope.marketSessionMap[vm.defaultInstrumentTokenSequenceNo].settlementDate,
                        tickSize);
                }
            }
            //get credit factor for settlement date apply with limit
            getCreditFactorAndApplyOnLimits();
        })

        // buy limit exchange rate
        $scope.$watchGroup(['vm.orderDTO.buyLimitExchangeRate', 'vm.defaultInstrumentCode', 'vm.orderType', 'vm.tradingBank', 'vm.tradeSettlementDate', 'vm.tradeSettlementDateFrom', 'vm.tenor', 'defaultBankSpread', 'marketSessionSettings'], function (value) {
            if (!vm.submitting) {
                if ($rootScope.defaultBankSpread != null && $rootScope.defaultBankSpread != undefined
                    && vm.orderDTO.buyLimitExchangeRate != null && vm.orderDTO.buyLimitExchangeRate != undefined && vm.orderDTO.buyLimitExchangeRate > 0) {

                    if (vm.defaultInstrumentCode != 'SPOT') {
                        var tickSize = gettickSizeForGivenInstrument(vm.defaultInstrumentCode);
                        vm.buySpreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, 'BUYY',
                            DateUtils.convertLocalDateToServer(getSettlementDate(vm.defaultInstrumentCode, 'BUYY')), vm.currencyPair.code === 'USDINR' ? $rootScope.retailSpotMarketSession.settlementDate : $rootScope.marketSessionMap[vm.defaultInstrumentTokenSequenceNo].settlementDate,
                            tickSize);
                        if (vm.defaultInstrumentCode != 'Forward') {
                            vm.orderDTO.buyLimitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.buyLimitExchangeRate, vm.buySpreadUsed);
                        } else {
                            vm.orderDTO.buyLimitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.buyLimitExchangeRate, (vm.buySpreadUsed * -1));
                        }
                    } else {
                        vm.orderDTO.buyLimitExchangeRateInSpot = vm.orderDTO.buyLimitExchangeRate;
                    }

                } else if ($rootScope.defaultBankSpread != null && $rootScope.defaultBankSpread != undefined && $rootScope.retailSpotMarketSession != null && $rootScope.retailSpotMarketSession != undefined) {
                    if (vm.defaultInstrumentCode != 'SPOT') {
                        var tickSize = gettickSizeForGivenInstrument(vm.defaultInstrumentCode);
                        vm.buySpreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, 'BUYY',
                            DateUtils.convertLocalDateToServer(getSettlementDate(vm.defaultInstrumentCode, 'BUYY')), vm.currencyPair.code === 'USDINR' ? $rootScope.retailSpotMarketSession.settlementDate : $rootScope.marketSessionMap[vm.defaultInstrumentTokenSequenceNo].settlementDate,
                            tickSize);
                    }
                }

                if (vm.userPreference != null && vm.userPreference != undefined) {
                    if (vm.userPreference.userBidSpread != null && vm.userPreference.userBidSpread != undefined && value[0] != null && value[0] != undefined) {
                        vm.orderDTO.sellLimitExchangeRate = (Math.round(parseFloat(value[0]) * 10000) + Math.round(parseFloat(vm.userPreference.userBidSpread) * 10000)) / 10000;
                    } else {
                        vm.orderDTO.sellLimitExchangeRate = null;
                    }
                }
            }
        })

        function setOptionPeriodForPlaceOrder() {
            //when forward set the options perid
            if (vm.defaultInstrumentCode == 'Forward' && vm.tenor != null && vm.tenor.tenorName == 'Option Period') {
                vm.orderDTO.tradeSettlementDateFrom = vm.tradeSettlementDateFrom;
                vm.orderDTO.isOptionPeriod = true;
            } else {
                //vm.tradeSettlementDateFrom  = null;
                vm.orderDTO.tradeSettlementDateFrom = null;
                vm.orderDTO.isOptionPeriod = false;
            }
        }

        // buy stop exchange rate
        $scope.$watchGroup(['vm.orderDTO.buyStopExchangeRate', 'vm.defaultInstrumentCode', 'vm.orderType', 'vm.tradingBank', 'vm.tradeSettlementDate', 'vm.tradeSettlementDateFrom', 'vm.tenor', 'defaultBankSpread', 'marketSessionSettings'], function (value) {
            if ($rootScope.defaultBankSpread != null && $rootScope.defaultBankSpread != undefined
                && vm.orderDTO.buyStopExchangeRate != null && vm.orderDTO.buyStopExchangeRate != undefined && vm.orderDTO.buyStopExchangeRate > 0) {

                if (vm.defaultInstrumentCode != 'SPOT') {
                    var tickSize = gettickSizeForGivenInstrument(vm.defaultInstrumentCode);
                    vm.buyStopSpreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, 'BUYY',
                        DateUtils.convertLocalDateToServer(getSettlementDate(vm.defaultInstrumentCode, 'BUYY')), $rootScope.retailSpotMarketSession.settlementDate,
                        tickSize);
                    if (vm.defaultInstrumentCode != 'Forward') {
                        vm.orderDTO.buyStopExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.buyStopExchangeRate, vm.buyStopSpreadUsed);
                    } else {
                        vm.orderDTO.buyStopExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.buyStopExchangeRate, (vm.buyStopSpreadUsed * -1));
                    }
                } else {
                    vm.orderDTO.buyStopExchangeRateInSpot = vm.orderDTO.buyStopExchangeRate;
                }

            } else if ($rootScope.defaultBankSpread != null && $rootScope.defaultBankSpread != undefined && $rootScope.retailSpotMarketSession != null && $rootScope.retailSpotMarketSession != undefined) {
                if (vm.defaultInstrumentCode != 'SPOT') {
                    var tickSize = gettickSizeForGivenInstrument(vm.defaultInstrumentCode);
                    vm.buyStopSpreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, 'BUYY',
                        DateUtils.convertLocalDateToServer(getSettlementDate(vm.defaultInstrumentCode, 'BUYY')), $rootScope.retailSpotMarketSession.settlementDate,
                        tickSize);
                }
            }
        })

        // sell limit exchange rate
        $scope.$watchGroup(['vm.orderDTO.sellLimitExchangeRate', 'vm.defaultInstrumentCode', 'vm.orderType', 'vm.tradingBank', 'vm.tradeSettlementDate', 'vm.tradeSettlementDateFrom', 'vm.tenor', 'defaultBankSpread', 'marketSessionSettings'], function (value) {
            if ($rootScope.defaultBankSpread != null && $rootScope.defaultBankSpread != undefined
                && vm.orderDTO.sellLimitExchangeRate != null && vm.orderDTO.sellLimitExchangeRate != undefined && vm.orderDTO.sellLimitExchangeRate > 0) {

                if (vm.defaultInstrumentCode != 'SPOT') {
                    var tickSize = gettickSizeForGivenInstrument(vm.defaultInstrumentCode);
                    vm.sellSpreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, 'SELL',
                        DateUtils.convertLocalDateToServer(getSettlementDate(vm.defaultInstrumentCode, 'SELL')), $rootScope.retailSpotMarketSession.settlementDate,
                        tickSize);
                    if (vm.defaultInstrumentCode != 'Forward') {
                        vm.orderDTO.sellLimitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.sellLimitExchangeRate, vm.sellSpreadUsed);
                    } else {
                        vm.orderDTO.sellLimitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.sellLimitExchangeRate, (vm.sellSpreadUsed * -1));
                    }
                } else {
                    vm.orderDTO.sellLimitExchangeRateInSpot = vm.orderDTO.sellLimitExchangeRate;
                }

            } else if ($rootScope.defaultBankSpread != null && $rootScope.defaultBankSpread != undefined && $rootScope.retailSpotMarketSession != null && $rootScope.retailSpotMarketSession != undefined) {
                if (vm.defaultInstrumentCode != 'SPOT') {
                    var tickSize = gettickSizeForGivenInstrument(vm.defaultInstrumentCode);
                    vm.sellSpreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, 'SELL',
                        DateUtils.convertLocalDateToServer(getSettlementDate(vm.defaultInstrumentCode, 'SELL')), $rootScope.retailSpotMarketSession.settlementDate,
                        tickSize);
                }
            }
        })

        // sell stop exchange rate
        $scope.$watchGroup(['vm.orderDTO.sellStopExchangeRate', 'vm.defaultInstrumentCode', 'vm.orderType', 'vm.tradingBank', 'vm.tradeSettlementDate', 'vm.tradeSettlementDateFrom', 'vm.tenor', 'defaultBankSpread', 'marketSessionSettings'], function (value) {
            if ($rootScope.defaultBankSpread != null && $rootScope.defaultBankSpread != undefined
                && vm.orderDTO.sellStopExchangeRate != null && vm.orderDTO.sellStopExchangeRate != undefined && vm.orderDTO.sellStopExchangeRate > 0) {

                if (vm.defaultInstrumentCode != 'SPOT') {
                    var tickSize = gettickSizeForGivenInstrument(vm.defaultInstrumentCode);
                    vm.sellStopSpreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, 'SELL',
                        DateUtils.convertLocalDateToServer(getSettlementDate(vm.defaultInstrumentCode, 'SELL')), $rootScope.retailSpotMarketSession.settlementDate,
                        tickSize);
                    if (vm.defaultInstrumentCode != 'Forward') {
                        vm.orderDTO.sellStopExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.sellStopExchangeRate, vm.sellStopSpreadUsed);
                    } else {
                        vm.orderDTO.sellStopExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.sellStopExchangeRate, (vm.sellStopSpreadUsed * -1));
                    }
                } else {
                    vm.orderDTO.sellStopExchangeRateInSpot = vm.orderDTO.sellStopExchangeRate;
                }

            } else if ($rootScope.defaultBankSpread != null && $rootScope.defaultBankSpread != undefined && $rootScope.retailSpotMarketSession != null && $rootScope.retailSpotMarketSession != undefined) {
                if (vm.defaultInstrumentCode != 'SPOT') {
                    var tickSize = gettickSizeForGivenInstrument(vm.defaultInstrumentCode);
                    vm.sellStopSpreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, 'SELL',
                        DateUtils.convertLocalDateToServer(getSettlementDate(vm.defaultInstrumentCode, 'SELL')), $rootScope.retailSpotMarketSession.settlementDate,
                        tickSize);
                }
            }
        })

        vm.onChangeTradeSettlementDate = onChangeTradeSettlementDate;
        function onChangeTradeSettlementDate(settlementDate) {
            if (vm.tenor.tenorName != 'Option Period' && settlementDate != null && settlementDate != undefined) {
                vm.maxFromSettlementDate = moment(settlementDate).add(1, 'days');
                angular.forEach(vm.tenorsLookup, function (value) {
                    if (value.settlementDate == DateUtils.convertLocalDateToServer(settlementDate)) {
                        vm.tenor = value;
                        $rootScope.tenor = vm.tenor;
                    }
                })
            }
        }
        /*   vm.onChangeTradeSettlementDateFrom = onChangeTradeSettlementDateFrom;
           function onChangeTradeSettlementDateFrom(fromSettlementDate){
               vm.minToTradeSettlementDate = moment(settlementDate).add(1, 'days');
           }*/

        function setTenorForSettlementDate(settlementDate) {
            if (settlementDate != null && settlementDate != undefined) {
                angular.forEach(vm.tenors, function (value) {
                    if (value.settlementDate == DateUtils.convertLocalDateToServer(settlementDate)) {
                        vm.tenor = value;
                    }
                })
            }
        }

        function getSpotRateForGivenRateAndSpread(rate, spread) {
            if (rate > 0) {
                var spotRate = Number(rate) + Number(spread) / 100;
                return spotRate;
            } else {
                return null;
            }
        }

        //convert spot rate to limit exchange rate for givne rate, spread and instrument code
        function convertSpotRateToLimitExchangeRate(rate, spread, instrumentCode) {
            if (rate > 0) {
                var spotRate = 0;
                if (instrumentCode == 'Forward') {
                    spotRate = Number(rate) + Number(spread) / 100;
                } else {
                    spotRate = Number(rate) - Number(spread) / 100;
                }
                return spotRate;
            } else {
                return null;
            }
        }

        // filter values chanages
        $scope.$watch('vm.instrumentFilterForPO', function (value) {
            $rootScope.instrumentFilterForPO = value;
        })
        // filter values chanages
        $scope.$watch('vm.instrumentFilterForLimit', function (value) {
            $rootScope.instrumentFilterForLimit = value;
        })
        // filter values chanages
        $scope.$watch('vm.instrumentFilterForTrade', function (value) {
            $rootScope.instrumentFilterForTrade = value;
            // vm.expandTradePosition = false;
        })
        $scope.$watch('vm.instrumentFilterForOT', function (value) {
            $rootScope.instrumentFilterForOT = value;

        })

        $scope.$watch('vm.branchFilterForOT', function (value) {
            $rootScope.branchFilterForOT = value;
        })
        $scope.$watch('vm.branchFilterForPO', function (value) {
            $rootScope.branchFilterForPO = value;
        })
        // filter values chanages
        $scope.$watch('vm.branchFilterForLimit', function (value) {
            $rootScope.branchFilterForLimit = value;
        })
        // filter values chanages
        $scope.$watch('vm.branchFilterForTrade', function (value) {
            $rootScope.branchFilterForTrade = value;
        })

        $scope.$watch('vm.customerFilterForPO', function (value) {
            $rootScope.customerFilterForPO = value;
        })
        $scope.$watch('vm.customerFilterForOT', function (value) {
            $rootScope.customerFilterForOT = value;
        })
        // filter values chanages
        $scope.$watch('vm.customerFilterForLimit', function (value) {
            $rootScope.customerFilterForLimit = value;
        })
        // filter values chanages
        $scope.$watch('vm.customerFilterForTrade', function (value) {
            $rootScope.customerFilterForTrade = value;
        })

        $scope.$watch('vm.fromSettlementDate', function (value) {
            $rootScope.fromSettlementDate = value;
        })

        $scope.$watch('vm.toSettlementDate', function (value) {
            $rootScope.toSettlementDate = value;
        })

        $scope.$watch('vm.selectAll', function (value) {
            $rootScope.selectAll = value;
        })
        $scope.$watch('vm.selectAll', function (value) {
            $rootScope.selectAll = value;
        })
        $scope.$watch('vm.selectAll', function (value) {
            $rootScope.selectAll = value;
        })
        $scope.$watch('vm.selectAll', function (value) {
            $rootScope.selectAll = value;
        })

        $rootScope.initialString = "";
        $rootScope.messageString = "";
        $rootScope.rejectionReason = "";
        $rootScope.rejectionString = "";
        $rootScope.acceptanceMessage = "";
        $rootScope.rejectionMessage = "";

        vm.initialTradeMessage = "";


        // add remarks for order request
        function addRemarks() {
            $state.go('add-remarks', { remarks: vm.remarksDTO });
        }

        $rootScope.$on('addRemarks', function (event, result) {
            if ($rootScope.remarks == null) {
                //vm.remarks = "";
                setDefaultRemark();
            } else {
                vm.remarksDTO = $rootScope.remarks;
                setRemark();
            }
        });

        $scope.$watch('vm.showPriceIcon', function (value) {
            if (value == true) {
                if (document.getElementById('comparitive_tab1') != null) {
                    setTimeout(function () {
                        document.getElementById('comparitive_tab1').click();
                    }, 100);
                }
            }
        })

        var orderplacedsuccess = $rootScope.$on('orderplacedsuccess', function (event, result) {
            if ($rootScope.orderPlacedSuccessCount > 0) {
                //vm.remarks = "";
                setDefaultRemark();
                vm.clicked = false;
                resetPendingOrderCheckboxSelection(false);
                resetTradesOutstandingCheckboxSelection();
                defaultOrderEntry();
                // remove foucs on order entry screen
                removeOrderEntryFocus();
                // clear numeric controls
                clearNumericControls();
                // setLTPPriceAsDefaultValueForLimitOrder();

                removeFocusFromMarketWatch();

                getLimitExchangeRateForInstrument(vm.defaultInstrumentCode);
            }
            $rootScope.orderPlacedSuccessCount = $rootScope.orderPlacedSuccessCount + 1;
        });

        function removeFocusFromMarketWatch() {
            setTimeout(function () { document.getElementById('ibspotMktSell').focus() }, 10);
            setTimeout(function () { document.getElementById('ibspotMktSell').blur() }, 10);
            setTimeout(function () { document.getElementById('ibspotMktBuy').blur() }, 10);
            //setTimeout(function(){document.getElementById('spotMktSell').focus()},10);
            setTimeout(function () { document.getElementById('spotMktSell').blur() }, 10);
            setTimeout(function () { document.getElementById('spotMktBuy').blur() }, 10);
            // setTimeout(function(){document.getElementById('cashMktSell').blur()},10);
            // setTimeout(function(){document.getElementById('cashMktBuy').blur()},10);
            // setTimeout(function(){document.getElementById('tomMktSell').blur()},10);
            // setTimeout(function(){document.getElementById('tomMktBuy').blur()},10);

        }

        var cancelselecteedsuccess = $rootScope.$on('cancelselectedsuccess', function (event, result) {
            $rootScope.selectedPendingOrders = [];
            resetPendingOrderCheckboxSelection(false);
        });

        // expand market depth tab
        function expandMarketDepth(instrumentCode, marketDepth) {
            // $rootScope.marketDepth = marketDepth;
            // $rootScope.instrument = instrumentCode;
            $state.go('market-depth-expand', { instrument: instrumentCode, marketDepth: marketDepth });
        }

        function expandMarketDepthForBothInstrument(instrumentCode, marketDepth, ibMarketDepth) {
            // $rootScope.marketDepth = marketDepth;
            // $rootScope.instrument = instrumentCode;
            $state.go('market-depth-expand', { instrument: instrumentCode, marketDepth: marketDepth, ibMarketDepth: ibMarketDepth });
        }

        // open market statistics tab
        function openMarketStatistics(instrumentCode) {
            // $rootScope.instrument = instrumentCode;
            var state = 'market-statistics';
            $rootScope.instrumentForStats = instrumentCode;
            $state.go(state, { instrument: instrumentCode, currentBusinessDate: vm.currentDate });
        }

        function expandReports() {
            var state = 'home-page-reports';
            $state.go(state);
        }

       function expandFCYMarketDepth(){
            var state = 'fcy-market-depth';
            $state.go(state);
       }

        function expandSwapQuote() {
            var state = 'swap-quotes-home-page';
            if ($rootScope.bankComparativeDTO != null && $rootScope.bankComparativeDTO != undefined
                && $rootScope.retailSpotMarketWatch != null && $rootScope.retailSpotMarketWatch != undefined) {
                prepareBankComparativeQuotesInPrice($rootScope.bankComparativeDTO, $rootScope.retailSpotMarketWatch);
            }
            $state.go(state, { account: vm.account, defaultTradingBank: vm.defaultTradingBank });
        }

        function openOrderPreference() {
            $state.go('order-config');
        }


        function onGetswapQuotesFeedFailure() {

        }

        function changeRequest() {
            var limits = angular.copy($rootScope.limitsAvailableForSelectedInstrument);
            var selectedLimits = _.filter(limits, { 'select': true });
            if (selectedLimits.length <= 0) {
                MessageBox.openMessageBox("Alert", "Please select a limit to proceed.", "Ok", "limitchangerequest");
            } else {
                limitChangeRequest(selectedLimits[0]);
            }
        }

        function limitChangeRequest(selectedLimit) {
            if ($rootScope.globalValues.getOrganisation().organisationType.shortName == 'CUSTOMER') {
                workflowSharedService.viewFrom = "customer_limitSettings";
                var customerId = selectedLimit.customerId;
                var bankId = selectedLimit.bankId;
                var limitInstrumentGroup = "";
                if (selectedLimit.instrumentCode == 'UptoSPOT' || selectedLimit.instrumentCode == 'SPOT' || selectedLimit.instrumentCode == 'TOM' || selectedLimit.instrumentCode == 'CASH') {
                    limitInstrumentGroup = "SPOTWINDOW";
                } else if (selectedLimit.instrumentCode == 'Forward') {
                    limitInstrumentGroup = "FORWARD";
                } else {
                    limitInstrumentGroup = "ALL";
                }
                var state = 'customer_limit_Settings';
                $state.go(state, { customerId: customerId, bankId: bankId, limitInstrumentGroup: limitInstrumentGroup });
            }
        }

        function newLimitRequest() {
            if ($rootScope.bankFilterForLimit != null && $rootScope.bankFilterForLimit != undefined && $rootScope.globalValues.getOrganisation().organisationType.shortName == 'CUSTOMER') {
                workflowSharedService.$rootScope = "";
                var customerId = $rootScope.globalValues.getOrganisation().id;
                var bankId = $rootScope.bankFilterForLimit.id;
                var instrumentCode = 'ALL';
                if ($rootScope.instrumentFilterForLimit != null) {
                    instrumentCode = $rootScope.instrumentFilterForLimit.instrumentCode;
                }
                var state = 'create-customer-limit-settings-limit-report';
                $state.go(state, { bankId: bankId, instrumentCode: instrumentCode });
            }
        }

        function getBuyingPower(limit) {
            var buyingPower = 0;
            var limitAllocated = 0;
            if(limit.currencyPair != 'USDINR'){
              limitAllocated = limit.limitAllocatedInFCY;
            }else{
              limitAllocated =  limit.limitAllocatedInUSD
            }
            var totalBuy = limit.totalPendingBuyOrderValue + limit.totalBuyTradeValue + limit.previousDayBuyTradeValue;
            var totalSell = limit.totalPendingSellOrderValue + limit.totalSellTradeValue + limit.previousDaySellTradeValue;
            if (limit.limitType == 'GROSSSELL') {
                buyingPower = 0;
            } else if (limit.limitType == 'GROSSBUY') {
                buyingPower = limitAllocated - (totalBuy);
            } else if (limit.limitType == 'GLOBALGROSS') {
                buyingPower = limitAllocated - (totalBuy + totalSell);
            } else if (limit.limitType == 'NET') {
                totalBuy = limit.totalPendingBuyOrderValue + ((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue));
                totalSell = limit.totalPendingSellOrderValue + ((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue));
                var xVals = [];
                xVals.push(totalBuy);
                xVals.push(totalSell);
                buyingPower = limitAllocated - totalBuy;
            }
            buyingPower = (Math.round(parseFloat(buyingPower) * 100) / 100);
            if (buyingPower < 0) {
                buyingPower = 0;
            }
            return buyingPower;
        }

        vm.getExposure = function getExposure(limit) {
            var exposure = 0;
            var totalBuy = 0;
            var totalSell = 0;
            if (limit.limitType != 'NET') {
                totalBuy = limit.totalPendingBuyOrderValue + limit.totalBuyTradeValue + limit.previousDayBuyTradeValue;
                totalSell = limit.totalPendingSellOrderValue + limit.totalSellTradeValue + limit.previousDaySellTradeValue;
                exposure = (limit.totalPendingBuyOrderValue + limit.totalBuyTradeValue + limit.previousDayBuyTradeValue + limit.totalPendingSellOrderValue + limit.totalSellTradeValue + limit.previousDaySellTradeValue) * 100 / limit.limitAllocatedInUSD;
            } else {
                totalBuy = limit.totalPendingBuyOrderValue + ((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue));
                totalSell = limit.totalPendingSellOrderValue + ((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue));

                var xVals = [];
                xVals.push(totalBuy);
                xVals.push(totalSell);
                exposure = Math.max.apply(Math, xVals) * 100 / limit.limitAllocatedInUSD;
            }
            exposure = (Math.round(parseFloat(exposure) * 100) / 100);
            return exposure;
        }

        function getSellingPower(limit) {
            var sellingPower = 0;
            var limitAllocated = 0;
            if(limit.currencyPair != 'USDINR'){
              limitAllocated = limit.limitAllocatedInFCY;
            }else{
              limitAllocated =  limit.limitAllocatedInUSD
            }
            var totalBuy = limit.totalPendingBuyOrderValue + (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue);
            var totalSell = limit.totalPendingSellOrderValue + (limit.totalSellTradeValue + limit.previousDaySellTradeValue);
            if (limit.limitType == 'GROSSSELL') {
                sellingPower = limitAllocated - (totalSell);
            } else if (limit.limitType == 'GROSSBUY') {
                sellingPower = 0;
            } else if (limit.limitType == 'GLOBALGROSS') {
                sellingPower = limitAllocated - (totalBuy + totalSell);
            } else if (limit.limitType == 'NET') {
                totalBuy = limit.totalPendingBuyOrderValue + ((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue));
                totalSell = limit.totalPendingSellOrderValue + ((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue));
                var xVals = [];
                xVals.push(totalBuy);
                xVals.push(totalSell);
                sellingPower = limitAllocated - totalSell;
            }
            sellingPower = (Math.round(parseFloat(sellingPower) * 100) / 100);
            if (sellingPower < 0) {
                sellingPower = 0;
            }
            return sellingPower;
        }

        function printDealTicket(trade) {
            vm.tradeResponse = angular.copy(trade);
            console.log(typeof vm.tradeResponse.tradeTime);
            vm.tradeResponse.tradeTime = moment(vm.tradeResponse.tradeTime).format('YYYYMMDDHHmmss.SSSSSSSSS');
            GenerateDealTicket.generate(vm.tradeResponse, function (result) {
                var file = new Blob([result.data], { type: 'application/pdf' });
                // var fileURL = URL.createObjectURL(file);
                // window.open(fileURL, "_blank", "fullscreen=yes");
                var fileURL = URL.createObjectURL(file);
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file, "DealTicket.pdf");
                }
                else {
                    window.open(fileURL, "_blank", "fullscreen=yes");
                }
            });
        }

        function printDealTicketOutstandingTrade(outstandingTrade) {
            vm.tradeResponse = angular.copy(outstandingTrade);
            console.log(typeof vm.tradeResponse.tradeTime);
            vm.tradeResponse.tradeTime = moment(vm.tradeResponse.tradeTime).format('YYYYMMDDHHmmss.SSSSSSSSS');
            GenerateDealTicket.generateOutstandingTrades(vm.tradeResponse, function (result) {
                var file = new Blob([result.data], { type: 'application/pdf' });
                var fileURL = URL.createObjectURL(file);
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file, "DealTicket.pdf");
                }
                else {
                    window.open(fileURL, "_blank", "fullscreen=yes");
                }
            });
        }
        function resetPendingOrderCheckboxSelection(value) {
            vm.selectAll = value;
            if (document.getElementById("selectAll") != null && document.getElementById("selectAll") != undefined) {
                document.getElementById("selectAll").checked = value;
            }
            changePendingOrderItemSelection(value);
        }

        function resetTradesOutstandingCheckboxSelection() {
            angular.forEach($rootScope.outstandingTrades, function (value) {
                value.select = false;
            });
            //$rootScope.outstandingTradesMemory = $rootScope.outstandingTrades;
        }

        function setLTPPriceAsDefaultValueForLimitOrder() {

            vm.orderDTO.limitExchangeRate = $rootScope.tickerPrice.retailSpot;
            vm.orderDTO.buyLimitExchangeRate = $rootScope.tickerPrice.retailSpot;
            vm.orderDTO.sellLimitExchangeRate = $rootScope.tickerPrice.retailSpot;
        }

        $('#myDropdown .dropdown-menu').on({
            "click": function (e) {
                e.stopPropagation();
            }
        });
        /*
         * $('#broadcastmsg .dropdown-menu').on({ "click":function(e){
         * e.stopPropagation(); } });
         */

        function broadcastMessage() {
            var message = {};
            message.message = vm.message;
            Notifications.broadcastMessage(message);
            vm.message = "";
        }

        vm.exportOTToExcelFile = exportOTToExcelFile;
        vm.exportOTToCsvFile = exportOTToCsvFile;
        vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm_ss';
        function exportOTToCsvFile() {
            if ($rootScope.outstandingTrades != null && $rootScope.outstandingTrades.length > 0) {
                vm.mimeType = 'text/csv';

                var baseString = 'OUTSTANDING_TRADES_' + moment().format(vm.reportFileTimestampFormat);
                vm.baseString = baseString + ".csv";
                var selectedTrades = angular.copy($rootScope.outstandingTrades);
                angular.forEach(selectedTrades, function (value, index) {
                    value.tradeTime = moment(value.tradeTime).format('YYYYMMDDHHmmss.SSSSSSSSS');
                });

                TradesDownload.getTradesOutstandingCSV(selectedTrades, processResponse);

            }
        }
        function exportOTToExcelFile() {
            if ($rootScope.outstandingTrades != null && $rootScope.outstandingTrades.length > 0) {
                vm.mimeType = 'application/vnd.ms-excel';
                var baseString = 'OUTSTANDING_TRADES_' + moment().format(vm.reportFileTimestampFormat);
                vm.baseString = baseString + ".xls";
                var selectedTrades = angular.copy($rootScope.outstandingTrades);
                angular.forEach(selectedTrades, function (value, index) {
                    value.tradeTime = moment(value.tradeTime).format('YYYYMMDDHHmmss.SSSSSSSSS');
                });

                TradesDownload.getTradesOutstandingExcel(selectedTrades, processResponse);


            }
        }

        function exportTradesToCsvFile() {
            if ($rootScope.trades != null && $rootScope.trades.length > 0) {

                vm.mimeType = 'text/csv';
                var baseString = moment(vm.currentDate).format('YYYYMMDD') + '_FXRETAIL_TRADES';
                vm.baseString = baseString + ".csv";
                var selectedTrades = angular.copy($rootScope.trades);
                angular.forEach(selectedTrades, function (value, index) {
                    value.tradeTime = moment(value.tradeTime).format('YYYYMMDDHHmmss.SSSSSSSSS');
                    console.log("tradetime " + value.tradeTime);

                });
                TradesDownload.getCSVForTrades(selectedTrades, processResponse);
            }
        }
        function exportTradesToExcelFile() {
            if ($rootScope.trades != null && $rootScope.trades.length > 0) {

                vm.mimeType = 'application/vnd.ms-excel';
                var baseString = moment(vm.currentDate).format('YYYYMMDD') + '_FXRETAIL_TRADES';
                vm.baseString = baseString + ".xls";
                var selectedTrades = angular.copy($rootScope.trades);
                angular.forEach(selectedTrades, function (value, index) {
                    value.tradeTime = moment(value.tradeTime).format('YYYYMMDDHHmmss.SSSSSSSSS');
                    console.log("tradetime " + value.tradeTime);

                });
                TradesDownload.getExcelForTrades(selectedTrades, processResponse);
            }
        }
        function processResponse(result){
      	  var fileData = null;
  		  fileData = result.data;
  		  var link = document.createElement("a");
  		  var bytes = new Uint8Array( fileData );   // convert uint8 to binary
													// array from arraybuffer


  	      var blob = new Blob([bytes], {type: vm.mimeType});
  	      if(window.navigator.msSaveOrOpenBlob) {
                  window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
  	      }else{
  	    	  link.href =  window.URL.createObjectURL(blob);
  	    	  link.download = vm.baseString;
  	    	  document.body.appendChild(link);
  	    	  link.click();
  	    	  document.body.removeChild(link);
  	      }
  	  }
        function getConfigForGenerate(){

        	  if(vm.account.entityOwnerType.shortName=='Clearcorp'){
            	  DealingAdminApplicationWideSettings.getConfigValueForConfigName(
                  		{"configName": "BillingEndDate"}, function(result){
                  			$rootScope.billingDate = result.value;
                  			 DealingAdminApplicationWideSettings.getConfigValueForConfigName(
                             		{"configName": "ShowGenerateTransactionCharges"}, function(result){
                             			$rootScope.showGenerateTransactionButton = result.value;
                             	});
                  	});

    		  }
        }

        function generateInvocie() {

            EODProcess.generateInvoice({
                "billingDate": $rootScope.billingDate, "orgId": vm.account.organisation.id
            }, generateInvocieSuccess, generateInvocieFailed);
        }
        function generateInvocieSuccess(result) {
            // alert("Transaction Invoice Generated Sucessfully");
            $rootScope.invoiceGenerated = true;
            $.growl.notice({ title: "Generate Invoice", message: "Invoice Generated Sucessfully." });
        }
        function generateInvocieFailed(error) {
            // alert("Generation of Transaction Invoice Failed!!!");
            $rootScope.invoiceGenerated = false;
            $.growl.error({ title: "Generate Transaction Invoice", message: "Generation of Transaction Invoice Failed!!!" });
        }

        function asyncGenerateInvoice() {

            EODProcess.aysncgenerateInvoice({
                "billingDate": $rootScope.billingDate, "orgId": vm.account.organisation.id
            }, regenerateInvocieSuccess, regenerateInvocieFailed);
        }
        function regenerateInvocieSuccess(result) {
            $rootScope.asyncInvoiceGenerated = true;
            $.growl.notice({ title: "Async Generate Invoice", message: "Async Invoice Generated Sucessfully." });
        }
        function regenerateInvocieFailed(error) {
            $rootScope.asyncInvoiceGenerated = false;
            $.growl.error({ title: "Async Generate Invoice", message: "Async Generation Invoice Failed!!!" });
        }

        vm.getMomentFromOrderRevisionTimeStamp = function (timestampString) {
            return moment(timestampString, 'YYYYMMDDHHmmss.SSSSSSSSS').format();
        }

        //when tenor lookup is changed, change settlement date also.
        // $scope.$watch('vm.tenor', function(value){
        //     if(value!=null && value!=undefined){
        //         if(value.tenorName=='Broken Date'){
        //             vm.tradeSettlementDate = new Date(vm.tenors[0].settlementDate);
        //         }else{
        //             vm.tradeSettlementDate = new Date(value.settlementDate);
        //         }
        //         if(vm.orderDTO.activityIndicator=='PLAC'){
        //             getLimitExchangeRateForInstrument('Forward');
        //         }
        //     }
        // })

        vm.onChangeTenor = onChangeTenor;
        function onChangeTenor(value) {
            if (value != null && value != undefined) {
                if (value.tenorName == 'Broken Date') {
                    vm.tradeSettlementDate = new Date(vm.tenors[0].settlementDate);
                } else if (value.tenorName == 'Option Period') {
                    vm.orderDTO.forwardType = 'Option Period';
                    vm.tradeSettlementDateFrom = null;
                    vm.tradeSettlementDate = null;
                }
                else {
                    vm.tradeSettlementDate = new Date(value.settlementDate);
                }
                if (vm.orderDTO.activityIndicator == 'PLAC') {
                    getLimitExchangeRateForInstrument('Forward');
                }
            }
        }

        /* get settlemnt date based on the order type, instrument and tenor name*/
        function getSettlementDate(instrumentCode, orderType) {
            var settlementDate = angular.copy(vm.tradeSettlementDate);
            if (vm.tenor != null) {
                console.log('instrumentCode - ' + instrumentCode + ' orderType - ' + orderType + ' tenorName - ' + vm.tenor.tenorName);
            }
            if (instrumentCode == 'Forward' && vm.tenor != null && vm.tenor != undefined && vm.tenor.tenorName == 'Option Period') {
                if (orderType == "SELL") {
                    settlementDate = angular.copy(vm.tradeSettlementDateFrom);
                } else if(orderType =="BUYY"  )
                {
                    settlementDate = angular.copy(vm.tradeSettlementDate);
                }
            }
            //console.log('settlementDate - ' + settlementDate);
            return settlementDate;
        }
        function getSettlementDateForContractCancellation(outstandingTrade) {

            var settlementDate = angular.copy(outstandingTrade.tradeSettlementDate);
            if (outstandingTrade.instrumentCode == 'Forward' && outstandingTrade.isOptionPeriod == true) {
                //if ccancellation is before theoption period from then the settlement date is calculated based on orginal trade buysellindicator
                if (isEventAppliedBeforeOptionPeriod(outstandingTrade)) {
                    //for both cancellation the original terade buysell indicator is taken not the cancellation buysellidnicaor
                    if (outstandingTrade.buySellIndicator == "SELL") {
                        settlementDate = angular.copy(outstandingTrade.tradeSettlementDateFrom);
                    } else //if(orderType =="BUYY"  )
                    {
                        settlementDate = angular.copy(outstandingTrade.tradeSettlementDate);
                    }
                } else {// if ccancellation is during the option period then always it is cash
                    settlementDate = angular.copy($rootScope.cashMarketSession.settlementDate);
                }

            }
            return settlementDate;
        }
        $rootScope.getSettlementDateForContractCancellation = getSettlementDateForContractCancellation;
        /* function getSettlementDateForEarlyDelivery( outstandingTrade){

             var settlementDate = angular.copy(outstandingTrade.tradeSettlementDate);
             if(outstandingTrade.instrumentCode == 'Forward' && getSettlementDateFromOutstandingTrade.isOptionPeriod){
                 //if ccancellation is before theoption period from then the settlement date is calculated based on orginal trade buysellindicator
                 if(isEventAppliedBeforeOptionPeriod(outstandingTrade)){
                     //for both cancellation the original terade buysell indicator is taken not the cancellation buysellidnicaor
                     if( outstandingTrade.buySellIndicator =="SELL" ){
                         settlementDate = angular.copy(outstandingTrade.tradeSettlementDateFrom);
                     }else //if(orderType =="BUYY"  )
                     {
                         settlementDate = angular.copy(outstandingTrade.tradeSettlementDate);
                     }
                 }else{// if ccancellation is during the option period then always it is cash
                     settlementDate = angular.copy($rootScope.cashMarketSession.settlementDate);
                 }

             }
             return settlementDate;
         }*/

        function isEventAppliedBeforeOptionPeriod(outstandingTrade) {
            if (moment(angular.copy($rootScope.cashMarketSession.settlementDate)).isBefore(moment(angular.copy(outstandingTrade.tradeSettlementDateFrom)), 'day')) {
                return true;
            } else return false;

        }
        $rootScope.isEventAppliedBeforeOptionPeriod = isEventAppliedBeforeOptionPeriod;

        vm.getLimitExchangeRateForInstrument = getLimitExchangeRateForInstrument;
        function getLimitExchangeRateForInstrument(instrumentCode) {
            //setTimeout(function() {
            if (vm.currencyPair.code === 'USDINR') {
                if ($rootScope.retailSpotMarketWatch != null && $rootScope.retailSpotMarketWatch != undefined && $rootScope.retailSpotMarketSession != null && $rootScope.retailSpotMarketSession != undefined) {
                    var tickSize = gettickSizeForGivenInstrument(instrumentCode, 'USD');
                    if (vm.orderType != "SELLBUY") {
                        vm.orderDTO.limitExchangeRate = null;
                        vm.spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, vm.orderType,
                            DateUtils.convertLocalDateToServer(getSettlementDate(instrumentCode, vm.orderType)), $rootScope.retailSpotMarketSession.settlementDate,
                            tickSize);
                    } else {
                        vm.orderDTO.buyLimitExchangeRate = null;
                        vm.buySpreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, 'BUYY',
                            DateUtils.convertLocalDateToServer(getSettlementDate(instrumentCode, 'BUYY')), $rootScope.retailSpotMarketSession.settlementDate,
                            tickSize);
                    }

                    if (instrumentCode != 'SPOT') {
                        if (instrumentCode != 'Forward') {
                            if (vm.orderType == 'BUYY') {
                                if (vm.spreadUsed != null && vm.spreadUsed != undefined) {
                                    vm.orderDTO.limitExchangeRate = getSpotRateForGivenRateAndSpread($rootScope.retailSpotMarketWatch.offerPrice, (vm.spreadUsed * -1));
                                } else {
                                    vm.orderDTO.limitExchangeRate = null;
                                }
                            } else if (vm.orderType == 'SELL') {
                                if (vm.spreadUsed != null && vm.spreadUsed != undefined) {
                                    vm.orderDTO.limitExchangeRate = getSpotRateForGivenRateAndSpread($rootScope.retailSpotMarketWatch.bidPrice, (vm.spreadUsed * -1));
                                } else {
                                    vm.orderDTO.limitExchangeRate = null;
                                }
                            } else {
                                if (vm.buySpreadUsed != null && vm.buySpreadUsed != undefined) {
                                    vm.orderDTO.buyLimitExchangeRate = getSpotRateForGivenRateAndSpread($rootScope.retailSpotMarketWatch.offerPrice, (vm.buySpreadUsed * -1));
                                } else {
                                    vm.orderDTO.buyLimitExchangeRate = null;
                                    vm.orderDTO.sellLimitExchangeRate = null;
                                }
                            }
                        } else {
                            if (vm.orderType == 'BUYY') {
                                if (vm.spreadUsed != null && vm.spreadUsed != undefined) {
                                    vm.orderDTO.limitExchangeRate = getSpotRateForGivenRateAndSpread($rootScope.retailSpotMarketWatch.offerPrice, vm.spreadUsed);
                                } else {
                                    vm.orderDTO.limitExchangeRate = null;
                                }
                            } else if (vm.orderType == 'SELL') {
                                if (vm.spreadUsed != null && vm.spreadUsed != undefined) {
                                    vm.orderDTO.limitExchangeRate = getSpotRateForGivenRateAndSpread($rootScope.retailSpotMarketWatch.bidPrice, vm.spreadUsed);
                                } else {
                                    vm.orderDTO.limitExchangeRate = null;
                                }
                            } else {
                                if (vm.buySpreadUsed != null && vm.buySpreadUsed != undefined) {
                                    vm.orderDTO.buyLimitExchangeRate = getSpotRateForGivenRateAndSpread($rootScope.retailSpotMarketWatch.offerPrice, vm.buySpreadUsed);
                                } else {
                                    vm.orderDTO.buyLimitExchangeRate = null;
                                    vm.orderDTO.sellLimitExchangeRate = null;
                                }
                            }
                        }
                    } else {
                        if (vm.orderType == 'BUYY') {
                            vm.orderDTO.limitExchangeRate = $rootScope.retailSpotMarketWatch.offerPrice;
                        } else if (vm.orderType == 'SELL') {
                            vm.orderDTO.limitExchangeRate = $rootScope.retailSpotMarketWatch.bidPrice;
                        } else {
                            vm.orderDTO.buyLimitExchangeRate = $rootScope.retailSpotMarketWatch.offerPrice;
                        }
                    }
                }
            }
            else {


                var instrumentDetails = $rootScope.marketWatchMap[vm.currencyPair.id].instruments[getIndexBasedOnInstrument(instrumentCode)];

                var marketArray = vm.getMarkData(instrumentDetails.tokenSequenceNo);

                if ($rootScope.marketWatchMap != null && $rootScope.marketWatchMap != undefined && $rootScope.marketWatchMap != null && marketArray != undefined) {
                    var tickSize = gettickSizeForGivenInstrument(instrumentCode, vm.currencyPair.code, instrumentDetails.tokenSequenceNo);
                    if (vm.orderType != "SELLBUY") {
                        //vm.orderDTO.limitExchangeRate = null;
                        // vm.spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, vm.orderType,
                        //     DateUtils.convertLocalDateToServer(getSettlementDate(instrumentCode, vm.orderType) ), marketArray.settlementDate,
                        //     tickSize);
                    } else {
                       // vm.orderDTO.buyLimitExchangeRate = null;
                        // vm.buySpreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, 'BUYY',
                        //     DateUtils.convertLocalDateToServer(getSettlementDate(instrumentCode, 'BUYY')), marketArray.settlementDate,
                        //     tickSize);
                    }

                    // if(instrumentCode!='SPOT'){
                    //     if(instrumentCode!='Forward'){
                    //         var index = getIndexBasedOnInstrument(instrumentCode);
                    //    if(vm.orderType=='BUYY'){
                    //             if(vm.spreadUsed!=null && vm.spreadUsed!=undefined){
                    //                 vm.orderDTO.limitExchangeRate = getSpotRateForGivenRateAndSpread(getPriceBasedOnIndexAndFlag(index,vm.orderType), (vm.spreadUsed * -1));
                    //                 console.log("spread", vm.orderDTO.limitExchangeRate);
                    //             }else{
                    //             	vm.orderDTO.limitExchangeRate = null;
                    //             }
                    //         }else if(vm.orderType=='SELL'){
                    //             if(vm.spreadUsed!=null && vm.spreadUsed!=undefined){
                    //                 vm.orderDTO.limitExchangeRate = getSpotRateForGivenRateAndSpread(getPriceBasedOnIndexAndFlag(index,vm.orderType), (vm.spreadUsed * -1));
                    //             console.log("spread sell", vm.orderDTO.limitExchangeRate);
                    //             }else{
                    //             	vm.orderDTO.limitExchangeRate = null;
                    //             }
                    //         }else{
                    //             if(vm.buySpreadUsed!=null && vm.buySpreadUsed!=undefined){
                    //                 vm.orderDTO.buyLimitExchangeRate = getSpotRateForGivenRateAndSpread(getPriceBasedOnIndexAndFlag(index,vm.orderType), (vm.buySpreadUsed * -1));
                    //             }else{
                    //             	vm.orderDTO.buyLimitExchangeRate = null;
                    //                 vm.orderDTO.sellLimitExchangeRate = null;
                    //             }
                    //         }
                    //     }
                    // }else{
                    if (vm.orderType == 'BUYY') {
                        vm.orderDTO.limitExchangeRate = (instrumentDetails && instrumentDetails.offerPrice) ? instrumentDetails.offerPrice : 0;
                    } else if (vm.orderType == 'SELL') {
                        vm.orderDTO.limitExchangeRate = (instrumentDetails && instrumentDetails.bidPrice) ? instrumentDetails.bidPrice : 0;

                    } else {
                        vm.orderDTO.buyLimitExchangeRate = (instrumentDetails && instrumentDetails.offerPrice) ? instrumentDetails.offerPrice : 0;
                    }

                    //  }
                }
            }
            //}, 100);
        }

        function getIndexBasedOnInstrument(instrumentCode) {

            if (instrumentCode === 'SPOT') {
                return 0;
            } else if (instrumentCode === 'TOM') {
                return 1;
            } else if (instrumentCode === 'CASH') {
                return 2;
            }

        }

        function getLimitExchangeRateForCancellingOutstandingTrade(instrumentCode) {
            if ($rootScope.tickerPrice != null && $rootScope.tickerPrice != undefined && $rootScope.retailSpotMarketSession != null && $rootScope.retailSpotMarketSession != undefined) {
                var tickSize = gettickSizeForGivenInstrument(instrumentCode);
                vm.orderDTO.limitExchangeRate = null;
                vm.spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.defaultInstrumentCode, vm.orderType,
                    DateUtils.convertLocalDateToServer(angular.copy(vm.tradeSettlementDate)), $rootScope.retailSpotMarketSession.settlementDate,
                    tickSize);

                if (instrumentCode != 'SPOT') {
                    if (instrumentCode != 'Forward') {
                        if (vm.spreadUsed != null && vm.spreadUsed != undefined) {
                            vm.orderDTO.limitExchangeRate = getSpotRateForGivenRateAndSpread($rootScope.tickerPrice.retailSpot, (vm.spreadUsed * -1));
                        }
                    } else {
                        if (vm.spreadUsed != null && vm.spreadUsed != undefined) {
                            vm.orderDTO.limitExchangeRate = getSpotRateForGivenRateAndSpread($rootScope.tickerPrice.retailSpot, vm.spreadUsed);
                        }
                    }
                } else {
                    vm.orderDTO.limitExchangeRate = $rootScope.tickerPrice.retailSpot;
                }
            }
        }

        vm.checkOrUncheckLimitItem = checkOrUncheckLimitItem;
        function checkOrUncheckLimitItem(limitValue, event) {
            var selectedValue = event.target.checked;
            angular.forEach($rootScope.limitsAvailableForSelectedInstrument, function (value, index) {
                value.select = false;
            })
            limitValue.select = selectedValue;
        }

        function getCreditFactorAndApplyOnLimits() {
            if (vm.configSettings != null && vm.configSettings != undefined) {
                var creditFactor = MarketWatch.getCreditFactorValue(vm.defaultInstrumentCode, angular.copy(vm.tradeSettlementDate), $rootScope.selectedCreditFactor, vm.configSettings.defaultCreditFactorSettingsInPercentage);
                $rootScope.forwardBuyLimitWithCF = MarketWatch.computeLimitAmountApplyingCreditFactor(angular.copy($rootScope.forwardBuyLimit), creditFactor);
                $rootScope.forwardSellLimitWithCF = MarketWatch.computeLimitAmountApplyingCreditFactor(angular.copy($rootScope.forwardSellLimit), creditFactor);
            }
        }

        // function getPriceBasedOnIndexAndFlag(index, buySellFlag) {
        //     if (buySellFlag == 'SELL') {
        //         return $rootScope.marketWatchMap
        //             .get(vm.orderDTO.currencyPairId)
        //             ?.instruments?.[index]?.bidPrice ?? 0;
        //     }

        //     if (buySellFlag == 'BUYY') {
        //         return $rootScope.marketWatchMap
        //             .get(vm.orderDTO.currencyPairId)
        //             ?.instruments?.[index]?.offerPrice ?? 0;
        //     }
        // }

        vm.getSwapPointsForTradesReport = function getSwapPointsForTradesReport(spotExchangeRate, tradeExchangeRate) {
            var swapPts = Math.abs(spotExchangeRate - tradeExchangeRate) * 100
            swapPts = (Math.round(parseFloat(swapPts) * 100) / 100);
            return swapPts;
        }

        vm.enableDisableInfoIcon = function enableDisableInfoIcon(yesOrNo) {
            $rootScope.userPreference.showInfoIcon = yesOrNo;
            //vm.userPreference.showInfoIcon = yesOrNo;
            //update preference in db
            UserProfile.updateGivenPreference({ userId: vm.globalValues.getUserId(), settingsName: 'ShowInfoIcon', value: yesOrNo });
        }

        vm.gotoSupport = function gotoSupport() {
            $state.go('fx-support');
            //TACViewForEntitiesService.sendemail();
        }
        function getMinAndMaxNoOfSplit() {

            DealingAdminApplicationWideSettings.getConfigValueForConfigName(
                { "configName": "MinimumNoOFSplits" }, function (result) {
                    vm.minNoOfSplit = result.value;
                    DealingAdminApplicationWideSettings.getConfigValueForConfigName(
                        { "configName": "MaximumNoOFSplits" }, function (result) {
                            vm.maxNoOfSplit = result.value;
                        });
                });

        }

        function setRemark() {
            if (vm.remarksDTO != '' && vm.remarksDTO != null && vm.remarksDTO != undefined) {
                vm.remarks1 = vm.remarksDTO.remarks1;

                vm.remarks2 = vm.remarksDTO.remarks2;

                vm.remarks3 = vm.remarksDTO.remarks3;

                vm.remarks4 = vm.remarksDTO.remarks4;
            }
        }
        function setDefaultRemark() {
            vm.remarks1 = "";
            vm.remarks2 = null;
            vm.remarks3 = null;
            vm.remarks4 = null;
            vm.remarksDTO.remarks1 = "";
            vm.remarksDTO.remarks2 = null;
            vm.remarksDTO.remarks3 = null;
            vm.remarksDTO.remarks4 = null;

        }

        //split order validatiomn
        function splitorderValidation(OrderAmount, noOfSplits) {
            vm.orderDTO.isSplitOrder = true;
            if (OrderAmount != null && OrderAmount != undefined && OrderAmount != "") {
                var orderAmountNo = Number(OrderAmount);
                if (orderAmountNo % 1 != 0) {
                    vm.clicked = true;
                    $scope.errorTextOrderAmount = "This field cannot be decimal value";
                } else {
                    vm.clicked = false;
                    $scope.errorTextOrderAmount = "";
                }
            }
            if (noOfSplits != null && noOfSplits != undefined && noOfSplits != "") {
                var noOfSplitsCount = Number(noOfSplits);

                if (noOfSplitsCount < vm.minNoOfSplit || noOfSplitsCount > vm.maxNoOfSplit) {
                    vm.clicked = true;
                    $scope.errorTextNoOfSplits = "Split value should be between " + vm.minNoOfSplit + " and " + vm.maxNoOfSplit;
                } else if (noOfSplitsCount % 1 != 0) {
                    vm.clicked = true;
                    $scope.errorTextNoOfSplits = "This field cannot be decimal value";

                } else if (orderAmountNo < noOfSplitsCount) {
                    vm.clicked = true;
                    $scope.errorTextNoOfSplits = "Split value cannot be greater than order quantity";
                } else if (splitTheOrderQuntity()) {
                    vm.clicked = true;
                    $scope.errorTextNoOfSplits = "Orders should be Split evenly";
                } else {
                    vm.clicked = false;
                    $scope.errorTextNoOfSplits = "";
                }
            }

        }
        // split the order quntity and check spliding order decimal
        function splitTheOrderQuntity() {
            if (vm.regularAndSplitOrder == 'Split' && vm.orderDTO.orderAmount != null && vm.orderDTO.orderAmount != undefined && vm.orderDTO.orderAmount != '') {
                var splitedOrderAmount = null;
                if (vm.noOfSplits != null && vm.noOfSplits != undefined && vm.noOfSplits != "") {
                    splitedOrderAmount = vm.orderDTO.orderAmount / vm.noOfSplits;
                    if (splitedOrderAmount % 1 != 0) {
                        return true;
                    } else {
                        vm.showSplitedOrderAmount = splitedOrderAmount;
                        return false;
                    }

                }
            }
        }

        //divide arder amount then split the order based on no of split and store to list  ;
        function splitTheOrder(orderDTO, noOfsplit) {
            vm.showSplitedOrderAmount = null;
            if (orderDTO.orderAmount != null && orderDTO.orderAmount != undefined && orderDTO.orderAmount != '') {
                if (noOfsplit != null && noOfsplit != undefined && noOfsplit != "") {
                    vm.splitedOrderAmount = orderDTO.orderAmount / noOfsplit;
                    for (var splitOrder = 0; splitOrder <= noOfsplit - 1; splitOrder++) {
                        vm.orderDTO.orderAmount = vm.splitedOrderAmount;
                        vm.orderDTO.SystemUniqueSNo = angular.copy(splitOrder);
                        orderDTO.uploadStatus = 'SUCCESS';
                        vm.orderDTOList.push(angular.copy(vm.orderDTO));
                    }
                }
            }
        }
            $scope.$watch('vm.currencyPairForPO', function(value){
          //  if(value != undefined ){
            getInstrumentMatchedCurrencypairReport(value);
           // currecncyPairChanges(value);
             vm.currencyPairForPO = value;
             $rootScope.currencyPairFilterForPO = value;
             $rootScope.currencyPairForPO = value;

           // }
        })
        $scope.$watch('vm.currencyPairForOT', function(value){
            getInstrumentMatchedCurrencypairReport(value);
           // currecncyPairChanges(value);
            vm.currencyPairForOT = value;
            $rootScope.currencyPairFilterForOT = value;
             $rootScope.currencyPairForOT = value;

        })
        $scope.$watch('vm.currencyPairForTrade', function(value){

            getInstrumentMatchedCurrencypairReport(value);
           // currecncyPairChanges(value);
            vm.currencyPairForTrade = value;
            $rootScope.currencyPairFilterForTrade = value;
              $rootScope.currencyPairForTrade = value;

        })
       $scope.$watch('vm.currencyPairForLimit', function(value){
            getInstrumentMatchedCurrencypairReport(value);
           // currecncyPairChanges(value);
             vm.currencyPairForLimit = value;
             $rootScope.currencyPairFilterForLimit = value;
             $rootScope.currencyPairForLimit = value;

        })
         $scope.$watch('vm.currencyPairForMarkup', function(value){
            getInstrumentMatchedCurrencypairReport(value);
           //  currecncyPairChanges(value);

             vm.currencyPairForMarkup = value;
             vm.currencyPairFilterForMarkup = value;
            vm.currencyPairForMarkup = value;


        })


        function currecncyPairChanges(value){
            vm.currencyPairForPO = value;
            vm.currencyPairForOT = value;
            vm.currencyPairForTrade = value;
            vm.currencyPairForLimit = value;
            vm.currencyPairForMarkup = value;


        }

        $rootScope.$on('onMarketOrderPrepared', function(event, data) {
        // Build the Order DTO
        prepareOrderDTOFromMarketWatch(data.side, data.orderType, data.offerPrice, data.settlementDate, data.sessionStatus, data.marketData)
    });

    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('FCYMarketDepthController', FCYMarketDepthController);

    FCYMarketDepthController.$inject = ['$scope', '$rootScope', '$state',  '$uibModalInstance', '$stateParams', 
    'GlobalValues', 'OrderStatusDetails', 'MessageBox', '$filter', 'DateUtils', 'DefaultMarket', 'LimitSettings',
    'TradesDownload', 'GenerateDealTicket','CustomerBankRelationshipReport', 'EntityPermissions', '$controller',
    'MarketWatch'];

    function FCYMarketDepthController($scope, $rootScope, $state, $uibModalInstance, $stateParams, 
        GlobalValues, OrderStatusDetails, MessageBox, $filter, DateUtils, DefaultMarket, LimitSettings,
        TradesDownload, GenerateDealTicket,CustomerBankRelationshipReport, EntityPermissions, $controller,
        MarketWatch) {
        var vm = this;
        
        vm.clear=clear;
        vm.hasPermission = EntityPermissions.hasPermission;

        vm.globalValues = GlobalValues;
        vm.noOfRecordsPerPageOP = 10;
        vm.pageOP = 1;
        vm.noOfRecordsPerPageTrade = 10;
        vm.pageTrade = 1;
        vm.noOfRecordsPerPageOT = 10;
        vm.pageOT = 1;
        vm.noOfRecordsPerPageLimit = 10;
        vm.pageLimit = 1;

 vm.prepareOrderDTOFromMarketWatch = function(side, orderType, offerPrice, settlementDate, sessionStatus, marketData) {        
        var orderPayload = {
            side: side,                         // 'BUY' or 'SELL'
            orderType: orderType,               // 'SPOT'
            offerPrice: offerPrice,
            settlementDate: settlementDate,
            sessionStatus: sessionStatus,
            marketData: marketData
        };
        clear();
         $rootScope.$emit('onMarketOrderPrepared', orderPayload);
        }


        vm.getMarkData = function (tokenSeqNo) {
            return $rootScope.marketSessionMap[tokenSeqNo];
        };

        vm.getTickerPrice = function (tokenSeqNo) {
            return $rootScope.tickerPriceFCY[tokenSeqNo];
        };

       vm.getInstrumentStatus = function (tokenSeqNo) {
    var data = vm.getMarkData(tokenSeqNo);
    if (!data) return null;

    if (data.sessionTimingsDTO.status === 'CLOSED') {
        return 'CLOSED';
    }

    if (data.settlementDateHoliday) {
        return 'HOLIDAY';
    }

    if (!data.instrumentApplicable) {
        return 'UNAVAILABLE';
    }

    return null;
};
  function clear () {
            $uibModalInstance.dismiss('cancel');
          
        }
        
        
    }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('userwise-turnover-report', {
            parent: 'entity',
            url: '/userwise-turnover-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.userwiseTurnoverReport.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/userwise-turnover-report/userwise-turnover-report.html',
                    controller: 'UserwiseTurnoverReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	userRoleList: ['OrderStatusDetails', function(OrderStatusDetails) {
                    return OrderStatusDetails.getUserRoleListFromUser().$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('orderStatusReport');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('userwiseTurnoverReport');
                    return $translate.refresh();
                }]
               
            }
        })
        
        
        
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('UserwiseTurnover', UserwiseTurnover);

    UserwiseTurnover.$inject = ['$resource'];

    function UserwiseTurnover ($resource) {
    	 var resourceUrl =  'api/userwiseTurnoverReport/:id';
        
        return $resource(resourceUrl, {}, {
			 'excelUserwiseTurnoverReport':{
				    method: 'POST',
	                params : {
	                	businessDate:'@businessDate'
					},
	                url: 'api/userwise-turnover-report/excel',
	                responseType: 'arraybuffer',
	                  transformRequest: function (data) {
	                     	var copy = angular.copy(data);
	                     	
	                         return angular.toJson(copy);
	                     },
	                    transformResponse: function(data, headers) {
	                  	  return {
	                            data: data,
	                            headers: headers
	                        };   
	                    }  
				},
				 'csvUserwiseTurnoverReport':{
					    method: 'POST',
		                params : {
		                	businessDate:'@businessDate'
						},
		                url: 'api/userwise-turnover-report/csv',
		                responseType: 'arraybuffer',
		                  transformRequest: function (data) {
		                     	var copy = angular.copy(data);
		                     	
		                         return angular.toJson(copy);
		                     },
		                    transformResponse: function(data, headers) {
		                  	  return {
		                            data: data,
		                            headers: headers
		                        };   
		                    }  
					}
        


              
        });
    }
})();



(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'userwiseTurnoverReport'
        })
        
        .controller('UserwiseTurnoverReportController', UserwiseTurnoverReportController);

    UserwiseTurnoverReportController.$inject = ['$scope', '$state', 'OrderStatusDetails', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 
    	'ScreenLog','entityConstants','$timeout','DateUtils','userRoleList','UserwiseTurnover'];

    function UserwiseTurnoverReportController($scope, $state, OrderStatusDetails , GlobalValues, workflowSharedService, EntityPermissions, 
    		ScreenLog,entityConstants,$timeout,DateUtils,userRoleList,UserwiseTurnover) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.USERWISETURNOVERREPORT;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        $scope.noOfRecordsPerPage1 = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page1 = 1;
        vm.globalValues=GlobalValues;
        //vm.loggedinEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.loggedInUser = vm.globalValues.getUser();
        vm.screenLog = ScreenLog;
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.userLookup = 'userForTurnOverReport';
		vm.bankId =  0;
    	vm.branchId = 0;
        vm.customerId = 0;
        vm.userwiseTurnoverDetails=[];
       // vm.todayDate = new Date();
        var currentBusinessDate =  vm.globalValues.getSystemSettings().businessDate;
        vm.todayDate = DateUtils.convertLocalDateFromServer(currentBusinessDate);
        vm.userEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
		vm.clicked=false;
        vm.getUserWiseTurnover = getUserWiseTurnover;
        vm.getUserwiseTurnoverDetails = getUserwiseTurnoverDetails;
        vm.exportToFile=exportToFile;
        vm.showCCIL= false;
        
        vm.ExpandOrCollapseUserwiseTurnoverReport=true;
        vm.isShowDetails=false;
        vm.hideUser=false;
        workflowSharedService.viewFrom = "userwiseTurnoverReport";
       if(userRoleList!=null && userRoleList!=undefined && userRoleList.length==0){
    	   vm.hideUser = true;
       }
       vm.mimeType= '';  	  
 	  	vm.baseString =   'Userwise_Turnover_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   
        logScreenAccess();
        
        if (vm.userEntityOwnerType =='SingleUserCustomer'){
        	vm.userListValue = [];
        	vm.userListValue.push(vm.loggedInUser.id);
        	getUserWiseTurnover();
        }/*else if(){
        	vm.userEntityOwnerType ==
        }*/

       function getUserWiseTurnover() {
			vm.bankId =  0;
    	   	vm.branchId = 0;
		  //prepare data to server for customers
		  prepareDataForCustomer();
		  //prepare data to server for bank,branch and clearcorp
		  prepareDataForOthers();
		  
    	   OrderStatusDetails.getUserWiseTurnoverHeader({ "bankId":vm.bankId ,"branchId":vm.branchId, "login":vm.userListValue,"customerId":vm.customerId},onGetUserWiseTurnoverHeaderSuccess,onGetUserwiseTurnoverHeaderFailure);

        }

		function prepareDataForCustomer() {
			if(vm.userEntityOwnerType == 'SingleUserCustomer' || vm.userEntityOwnerType == 'MultiUserCustomer')
				vm.customerId = vm.globalValues.getOrgId();
		}
		function prepareDataForOthers() {
			// if  bank user
			if (vm.userEntityOwnerType == 'Bank') {
				vm.bankId =  vm.globalValues.getOrgId();
			}
			// if branch user
			if (vm.userEntityOwnerType == 'Branch') {
				vm.bankId =  vm.globalValues.getOrgId();
				vm.branchId = vm.globalValues.getBranchId();
			}
			//if user manualy select bank and branch
			if(vm.bankValue!=null && vm.bankValue!=undefined){
    		   vm.bankId = vm.bankValue.id;
    	   	  }
    	   if(vm.branchValue!=null && vm.branchValue!=undefined){
    		   vm.branchId = vm.branchValue.id;
    	     }
		}
       
       function onGetUserWiseTurnoverHeaderSuccess(result){
    	   vm.userwiseTurnoverHeader=result;
    	   vm.isShowDetails=false;
    	   vm.userwiseTurnoverDetails=[];
    	   console.log(vm.userwiseTurnoverDetails.length);
		   vm.clicked=false;
       }
       function onGetUserwiseTurnoverHeaderFailure(){
		vm.clicked=false;
       }
       
       function getUserwiseTurnoverDetails(header){
    	  var bankId = header.bankId;
    	  var branchId = header.branchId;
    	  var userId = header.retailUserId;
    	  OrderStatusDetails.getUserWiseTurnoverDetails({"bankId":bankId,"branchId":branchId,"userId":userId,"customerId":vm.customerId},onGetUserwiseTurnoverDetailsSuccess,
    			   																													onGetUserwiseTurnoverDetailsFailure)
    	   
       }
       
       function onGetUserwiseTurnoverDetailsSuccess(result){
    	   vm.isShowDetails=true;
    	   angular.forEach(result,function(value){
    		   if(value.buySellFlag=='BUYY'){
    			   value.buySellFlag='Buy';
    		   }else{
    			   value.buySellFlag='Sell';
    		   }
    	   })
    	   vm.userwiseTurnoverDetails=result;
       }
       
       function onGetUserwiseTurnoverDetailsFailure(){
    	   
       }
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       $scope.$watch('vm.selectedEntityOwnerType', function(value){
    	   //clear table on change of the entity 
    	   vm.userwiseTurnoverHeader = null;
    	   vm.userwiseTurnoverDetails = null;
       });
       
       function exportToFile(fileType){

    	 	vm.baseString =   'Userwise_Turnover_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   
     	 vm.convertedTodayDate = DateUtils.convertLocalDateToServer(vm.todayDate);
 	
     	  if( vm.userwiseTurnoverHeader !=null &&  vm.userwiseTurnoverHeader!=undefined){
     		  if(fileType == 'csv'){
     			  vm.mimeType = 'text/csv'
     			  vm.baseString =vm.baseString+ ".csv";  
     			 UserwiseTurnover.csvUserwiseTurnoverReport({"businessDate":vm.convertedTodayDate}, vm.userwiseTurnoverHeader, onGenerateFileSuccess);
     		  }else if(fileType == 'excel'){
     			  vm.mimeType = 'application/vnd.ms-excel';
     			  vm.baseString = vm.baseString+ ".xls";
     			 UserwiseTurnover.excelUserwiseTurnoverReport({"businessDate":vm.convertedTodayDate}, vm.userwiseTurnoverHeader, onGenerateFileSuccess);
     		  }
     		 

     		  function onGenerateFileSuccess(result)
     		  {
     	    	  var fileData = null;
     			  fileData = result.data;
     			  var link = document.createElement("a");   
     			  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
     			  
     			  
     		      var blob = new Blob([bytes], {type: vm.mimeType});
     		      if(window.navigator.msSaveOrOpenBlob) {
     	                window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
     		      }else{
     		    	  link.href =  window.URL.createObjectURL(blob);      
     		    	  link.download = vm.baseString;
     		    	  document.body.appendChild(link);
     		    	  link.click();
     		    	  document.body.removeChild(link);
     		      }
     		  }
     		  
 
     		  
     	  }
       }	
       
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UserProfilePanImageController',UserProfilePanImageController);

    UserProfilePanImageController.$inject = ['$scope','$uibModalInstance','$stateParams', 'GlobalValues'];

    function UserProfilePanImageController($scope,$uibModalInstance,$stateParams, GlobalValues) {
    	var vm = this;
        vm.clear = clear;
        vm.image = $stateParams.image;
       
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

     
        
    }
})();

(function() {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function() {
		this.viewFrom = 'userprofile'
	})

	.controller('UserProfileController', UserProfileController);

	UserProfileController.$inject = [ '$scope', '$state',
			'workflowSharedService', 'UserProfile', 'GlobalValues', 'globalValue',
			'EntityPermissions', 'ScreenLog', 'DateUtils','$uibModalInstance','$stateParams',
			'$rootScope', 'CustomerBankRelationshipReport', 'User','AlertService','MessageBox',
			'$filter', 'entityConstants', 'CustomerInfoUtil','BankRegistration', '$timeout', 
			'CustomerRegistration', 'FileUtil', 'customerTypeWiseInputDetails', 'ExposureType',
			'ExposureSubType'];

	function UserProfileController($scope, $state, workflowSharedService,
			UserProfile, GlobalValues, globalValue, 
			EntityPermissions, ScreenLog, DateUtils,$uibModalInstance,$stateParams,
			$rootScope, CustomerBankRelationshipReport, User, AlertService ,MessageBox, 
			$filter,entityConstants, CustomerInfoUtil,BankRegistration, $timeout, 
			CustomerRegistration,FileUtil, customerTypeWiseInputDetails, ExposureType,
			ExposureSubType) {

		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenLog = ScreenLog;
		vm.userprofile = {};
		vm.user = {};
		vm.clear = clear;
		vm.userprofile.gender = "male";
		vm.save = save;
		vm.userId = $stateParams.userId;
		vm.ExpandOrCollapseChangePassword = false;
		vm.ExpandOrCollapseLoginInfo = false;
		vm.ExpandOrCollapseMyProfileDetails = false;
		vm.ExpandOrCollapseCustomerInfo=true;
		vm.restoreDefault = restoreDefault;
		vm.savePreferences = savePreferences;
		vm.isShowPreferences = true;
		var customerPreviousData  = {};
		var fd = new FormData();
		vm.isEnableTradingBranch = false;
		vm.password = "";
		$scope.showMyProfile=true;
		vm.currentMode = 'myprofile';
		$scope.showMyPreferences=false;
		$scope.showCustomerInfo=false;
		vm.invalidPanImageSize = false;
		vm.invalidPanImage = false;
		vm.invalidPanFileName = false;
		var Extensions = ["pdf","png","jpg","jpeg"];
		var imageExtensions = ["png","jpg","jpeg"];
		$scope.clicked=false;
		vm.launch = launch;
		vm.checkForChange = checkForChange;
		vm.tradingBank ={};
		vm.tradingBranch={};
		vm.tradingCustomer = {};
		vm.defaultForeignCurrencyPair = {};
		vm.exposureType = null;
		vm.exposureSubType = null;
		vm.configSettings = globalValue;
		vm.minimumOrderValue = vm.configSettings.minimumOrderValue;
        vm.isAllowStopLoss = vm.configSettings.isAllowStopLossOrder;
        vm.isAllowTakeProfit = vm.configSettings.isAllowTakeProfitOrder;
        vm.isAllowMarketOrder = vm.configSettings.isAllowMarketOrder;
        vm.maximumOrderValueHardCheck = vm.globalValues.getTransactionParameterValue(vm.globalValues.getDefaultCurrencyPairId(), "MaximumOrderValueHardCheck");
        vm.allowedOrderPriceDeviationFromMarketPriceInPercentage = vm.globalValues.getTransactionParameterValue(vm.globalValues.getDefaultCurrencyPairId(), "AllowedOrderPriceDeviationFromMarketPriceInPercentage");
        vm.allowedOrderPriceDeviationFromMarketPriceInPaise = vm.globalValues.getTransactionParameterValue(vm.globalValues.getDefaultCurrencyPairId(), "AllowedOrderPriceDeviationFromMarketPriceInPaise");
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
		vm.noOfDecimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
		vm.noOfDecimalsForPaise = vm.globalValues.getNumberOfDecimalsForRateInReports();
        vm.minimumFileSizeInKB = vm.configSettings.uploadedFileMinimumSize;
        vm.maximumFileSizeinKB = vm.configSettings.uploadedFileMaximumSize;
        vm.invalidPanImageSixeText = "";
        vm.invalidPanImageFileNameText = "";
        vm.invalidPanImageText = "";;
		vm.ExpandOrCollapseMyPreferences = false;
		vm.ExpandOrCollapseCurrencyPreferences = false;
        vm.maxFileNameLength = (vm.configSettings.uploadedFileNameLength != null && vm.configSettings.uploadedFileNameLength != undefined && vm.configSettings.uploadedFileNameLength != '') ?vm.configSettings.uploadedFileNameLength : 150 ;
        var minFileSizeinBytes = 0;
        var maxFileSizeinBytes = 100;
        if( vm.minimumFileSizeInKB != undefined &&  vm.minimumFileSizeInKB !=null &&  vm.minimumFileSizeInKB  !=''){
        	minFileSizeinBytes = vm.minimumFileSizeInKB*1024;
        }
        if( vm.maximumFileSizeinKB != undefined &&  vm.maximumFileSizeinKB !=null &&  vm.maximumFileSizeinKB  !=''){
        	maxFileSizeinBytes = vm.maximumFileSizeinKB*1024;
        }
        vm.errorText1 = '';
        vm.errorText2 = '';
        vm.errorText3 = '';
        vm.errorText4 = '';
        vm.errorText5 = '';
        vm.todayDate = new Date();
        vm.profileImageAction = '';
        var UPDATE_ACTION = 'update';
        var REMOVE_ACTION = 'remove';
        var userimageCopy = null;
		vm.getCurrencyWiseUserPreference = getCurrencyWiseUserPreference;
      
        //intialize customer type wise input details
        vm.customerTypeWiseInputDetails = customerTypeWiseInputDetails;
        
        //Indices of input details in customer type wise input details array
        $scope.firstNameIndex = 0;
        $scope.middleNameIndex = 1;
        $scope.lastNameIndex = 2;
        $scope.entityNameIndex = 3;
        $scope.panNoIndex = 4;
        $scope.panImageIndex = 5;
        $scope.legalEntityIdentifierIndex = 6;
        $scope.leiExpiryDateIndex = 7;
        $scope.cinIndex = 8;
        $scope.gstinIndex = 9;
        $scope.stateCodeIndex = 10;
        $scope.dobDoiIndex = 11;
		$scope.customerTypeSolePropId = 27;

        vm.validateOrderValue = function validateOrderValue(value){
        	vm.errorText1 = '';
        	if(value!=null && value!=undefined && value!=''){
                var maxHardCheck = vm.maximumOrderValueHardCheck;
                if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck) {
                    maxHardCheck = vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck;
                }
        		if(Number(value) < Number(vm.minimumOrderValue) || Number(value) > Number(maxHardCheck)){
        			vm.errorText1 = 'Value should be in between ' + $filter('number')(vm.minimumOrderValue,vm.noOfDecimalsForAmount) + ' and ' + $filter('number')(maxHardCheck,vm.noOfDecimalsForAmount) + '.';
        		}
				
        	}
        }
        
        vm.validateAllowedOrderPriceDeviationFromMarketPriceInPercentage = function validateAllowedOrderPriceDeviationFromMarketPriceInPercentage(value){
        	vm.errorText2 = '';
            var clearcorpMax = vm.allowedOrderPriceDeviationFromMarketPriceInPercentage;
            if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.currencyPair) {
                var paramValue = GlobalValues.getTransactionParameterValue(vm.currencyWiseUserPreferenceSettings.currencyPair.id, "AllowedOrderPriceDeviationFromMarketPriceInPercentage");
                if (paramValue != null) clearcorpMax = paramValue;
            }
        	if(Number(value) > Number(clearcorpMax)){
        		vm.errorText2 = "Value should be less than or equal to Clearcorp's hard check value " + $filter('number')(clearcorpMax,vm.noOfDecimalsForPercent) + '.';
        	}else if(Number(value) <= 0){
        		vm.errorText2 = "Value should be greater than 0.";
        	}
        }
        
        vm.validateMaximumOrderValueHardCheck = function validateMaximumOrderValueHardCheck(value){
        	vm.errorText3 = '';
            var clearcorpMax = vm.maximumOrderValueHardCheck;
            if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.currencyPair) {
                var paramValue = GlobalValues.getTransactionParameterValue(vm.currencyWiseUserPreferenceSettings.currencyPair.id, "MaximumOrderValueHardCheck");
                if (paramValue != null) clearcorpMax = paramValue;
            }
        	if(value!=null && value!=undefined && value!=''){
        		if(Number(value) > Number(clearcorpMax)){
        			vm.errorText3 = "Value should be less than or equal to Clearcorp's maximum order value hard check " + $filter('number')(clearcorpMax,vm.noOfDecimalsForAmount) + '.';
        		}else if(Number(value) <= Number(vm.minimumOrderValue)){
        			vm.errorText3 = "Value should be greater than Clearcorp's minimum order value " + $filter('number')(vm.minimumOrderValue,vm.noOfDecimalsForAmount) + '.';
        		}else if(Number(value) <= 0){
        			vm.errorText3 = "Value should be greater than 0.";
        		}
        	}
        }
        
        vm.validateMaximumOrderValueSoftCheck = function validateMaximumOrderValueSoftCheck(value){
        	vm.errorText4 = '';
            var clearcorpMax = vm.maximumOrderValueSoftCheck;
            var maxHardCheck = clearcorpMax;
            if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.currencyPair) {
                var paramValue = GlobalValues.getTransactionParameterValue(vm.currencyWiseUserPreferenceSettings.currencyPair.id, "MaximumOrderValueSoftCheck");
                if (paramValue != null) {
                    clearcorpMax = paramValue;
                    maxHardCheck = paramValue;
                }
            }
            if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck) {
                maxHardCheck = vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck;
            }
        	if(value!=null && value!=undefined && value!=''){
		        if(Number(value) > Number(clearcorpMax)){
        			vm.errorText4 = "Value should be less than or equal to Clearcorp's maximum order value hard check " + $filter('number')(clearcorpMax,vm.noOfDecimalsForAmount) + '.';
        		}else if(Number(value) > Number(maxHardCheck)){
		        	vm.errorText4 = "Value should be less than or equal to user level maximum order value hard check " + $filter('number')(maxHardCheck,vm.noOfDecimalsForAmount) + '.';
		        }else if(Number(value) <= 0){
		        	vm.errorText4 = "Value should be greater than 0.";
		        }
        	}
        }
        
        vm.validateAllowedOrderPriceDeviationFromMarketPriceInPaise = function validateAllowedOrderPriceDeviationFromMarketPriceInPaise(value){
        	vm.errorText5 = '';
            var clearcorpMax = vm.allowedOrderPriceDeviationFromMarketPriceInPaise;
            if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.currencyPair) {
                var paramValue = GlobalValues.getTransactionParameterValue(vm.currencyWiseUserPreferenceSettings.currencyPair.id, "AllowedOrderPriceDeviationFromMarketPriceInPaise");
                if (paramValue != null) clearcorpMax = paramValue;
            }
        	if(Number(value) > Number(clearcorpMax)){
        		vm.errorText5 = "Value should be less than or equal to Clearcorp's default value " + $filter('number')(clearcorpMax,vm.noOfDecimalsForPaise) + '.';
        	}else if(Number(value) <= 0){
        		vm.errorText5 = "Value should be greater than 0.";
        	}

        }
        
        function launch() {
			$state.go("user-profile");
		}
		
		logScreenAccess();
		loadAll();

		function loadAll() {
			UserProfile.get({
				"userId" : vm.userId
			}, onGetUserProfileSuccess, onGetUserProfileError);
			
			/*if(vm.globalValues.getEntityOwnerType().shortName == "Clearcorp"){
				vm.isShowPreferences = false;
				vm.isShowCustomer= false;
				vm.isShowTradingBranch = true;
				vm.isEnableTradingBranch = false;
			} else if(vm.globalValues.getEntityOwnerType().shortName == "Bank" || vm.globalValues.getEntityOwnerType().shortName == "Branch"){
				vm.isShowCustomer= false;
				vm.isShowTradingBranch = true;
				vm.isEnableTradingBranch = false;
			}else if(vm.globalValues.getEntityOwnerType().shortName == "SingleUserCustomer" ){
				loadCustomer();
				vm.hasCustomerInfoPermission=true;
				vm.isShowCustomer= false;
				vm.isShowTradingBranch = true;
				vm.isEnableTradingBranch = false;
				vm.isupdated = true;
				
			}else if(vm.globalValues.getEntityOwnerType().shortName == "MultiUserCustomer"){
				loadCustomer();
				vm.hasCustomerInfoPermission= EntityPermissions.hasPermission('Customer.EDIT');
				vm.isShowCustomer= false;
				vm.isShowTradingBranch = true;
				vm.isEnableTradingBranch = false;
				vm.isupdated = true;
				
			}			
			if(vm.globalValues.getEntityOwnerType().shortName == "Bank") {
				vm.isShowTradingBranch = false;
			}*/
			
		}

		function loadCustomer(){
			UserProfile.getCustomer({
				"customerId" : vm.globalValues.getOrganisation().id
			}, onGetCustomerSuccess, onGetCustomerError);
			
			
		}
		
		function checkForChange(mode){
			
			if(vm.currentMode != mode){
				$scope.mode = mode;
				var isChanged = true;
				if(vm.currentMode=='myprofile'){
					isChanged = $scope.userprofileForm.$pristine;
				}else if(vm.currentMode=='mypreference'){
					isChanged = $scope.myPreferencesForm.$pristine;
				}else if(vm.currentMode=='customerinfo'){
					isChanged = !CustomerInfoUtil.isCustomerProfileFormValuesChanged(customerPreviousData,vm.customerInfo,vm.image);
				}
				if(isChanged == false){
					MessageBox.openMessageBox("Alert", "Discard the changes?", "ProceedCancel", "userprofile");
				}else{
					if($scope.mode == 'myprofile'){
						$scope.showMyProfile=true;
						$scope.showMyPreferences=false;
						$scope.showCustomerInfo=false;
						vm.currentMode = ' 	';
					}else if($scope.mode == 'mypreference'){
						$scope.showMyProfile=false;
						$scope.showMyPreferences=true;
						$scope.showCustomerInfo=false;
						vm.currentMode = 'mypreference';
					}else if($scope.mode == 'customerinfo'){
						$scope.showMyProfile=false;
						$scope.showMyPreferences=false;
						$scope.showCustomerInfo=true;
						vm.currentMode = 'customerinfo';
					}
				}
			}
		}
		
		$rootScope.$on('gatewayApp.messagebox.proceed.userprofile', function (event, data) {
			loadAll();
			loadCustomer();
			vm.currentMode = $scope.mode;
			if($scope.mode == 'myprofile'){
				$scope.showMyProfile=true;
				$scope.showMyPreferences=false;
				$scope.showCustomerInfo=false;
				
			}else if($scope.mode == 'mypreference'){
				$scope.showMyProfile=false;
				$scope.showMyPreferences=true;
				$scope.showCustomerInfo=false;
			}else if($scope.mode == 'customerinfo'){
				$scope.showMyProfile=false;
				$scope.showMyPreferences=false;
				$scope.showCustomerInfo=true;
			}
			$scope.userprofileForm.$setPristine();
			$scope.myPreferencesForm.$setPristine();
			$scope.customerInfo.$setPristine();
    	});
		
		$rootScope.$on('gatewayApp.messagebox.cancel.userprofile', function (event, data) {
    	});
		
		function clear() {
            User.get({userId: vm.globalValues.getUser().id}, function(result){
				vm.globalValues.setSelectedUser(result);
			});
			$uibModalInstance.dismiss('cancel');
		}
		
		function onGetUserProfileSuccess(result) {
				
			
			vm.userprofile = result;

			updateCurrencyWiseUserPrefrencesForUser(vm.userprofile.currencyWiseUserPreferenceSettingsDTOList);
			
			if(vm.userprofile.userPriceCondition=='STLS' && vm.isAllowStopLoss!='Yes'){
        		vm.userprofile.userPriceCondition = 'LIMT';
        	}
        	if(vm.userprofile.userPriceCondition=='TKPR' && vm.isAllowTakeProfit!='Yes'){
        		vm.userprofile.userPriceCondition = 'LIMT';
        	}
			//need to check
			if(vm.isShowCustomer && vm.userprofile.userTradingBank!=null && vm.userprofile.userTradingBank!=" "){
				BankRegistration.getBankForShortName({bankName: vm.userprofile.userTradingBank},function(result){
					vm.userprofile.userTradingBank = result;
				});
			}
			vm.tradingBank = vm.userprofile.tradingBank;
			$timeout(function(){
				vm.tradingBranch = vm.userprofile.tradingBranch;
			}, 1000);
			$timeout(function(){
				vm.tradingCustomer = vm.userprofile.tradingCustomer;
			}, 1000);
			console.log(vm.userprofile);
			vm.exposureType = vm.userprofile.userExposureType;
			vm.exposureSubType = vm.userprofile.userExposureSubType;
			vm.user = vm.userprofile.userDTO;
			vm.displayFirstName = vm.user.firstName;
			vm.displayMiddleName = vm.user.middleName;
			vm.displayLastName = vm.user.lastName;
			userimageCopy = vm.user.image;			
			//vm.user.dob = new Date(vm.user.dob);
			$timeout(function(){
				vm.defaultForeignCurrencyPair = vm.userprofile.currencyPair;	
			}, 1000);
					
            if(vm.displayMiddleName == null){
                vm.displayMiddleName = '';
            }
            vm.userprofile.lastSuccessfulLogin = DateUtils.convertDateTimeFromServer(vm.userprofile.lastSuccessfulLogin);
            vm.userprofile.lastUnsuccessfulLogin = DateUtils.convertDateTimeFromServer(vm.userprofile.lastUnsuccessfulLogin);
			vm.user.dob = DateUtils.convertDateTimeFromServer(vm.user.dob);
			
			
			if(vm.globalValues.getEntityOwnerType().shortName == "Clearcorp"){
				vm.isShowPreferences = false;
				vm.isShowCustomer= false;
				vm.isShowTradingBranch = true;
				vm.isTradingBranchDisabled = true;
			} else if(vm.globalValues.getEntityOwnerType().shortName == "Bank" ){
				vm.isShowTradingBranch = false;
				vm.isShowTradingBank = false;
				vm.isTradingBranchDisabled = false;
				
				vm.isShowBank = true;
				vm.isShowBranch = true;
				vm.isShowCustomer= true;
				vm.isBankDisabled = true;
				
			} else if (vm.globalValues.getEntityOwnerType().shortName == "Branch") {
				vm.isShowTradingBank = false;	
				vm.isShowTradingBranch = false;
				
				vm.isBankDisabled = true;
				vm.isTradingBranchDisabled = true;
				
				vm.isShowBank = true;
				vm.isShowBranch = true;
				vm.isShowCustomer= true;
				
			}else if(vm.globalValues.getEntityOwnerType().shortName == "SingleUserCustomer" ){
				loadCustomer();
				vm.hasCustomerInfoPermission=true;
				vm.isShowCustomer= false;
				vm.isShowBank = false;
				vm.isShowBranch = false;
				
				vm.isShowTradingBranch = true;
				vm.isShowTradingBank = true;
				vm.isTradingBranchDisabled = false;
				vm.isupdated = true;
				
			}else if(vm.globalValues.getEntityOwnerType().shortName == "MultiUserCustomer"){
				loadCustomer();
				vm.hasCustomerInfoPermission= EntityPermissions.hasPermission('Customer.EDIT');
				vm.isShowCustomer= false;
				vm.isShowBank = false;
				vm.isShowBranch = false;
				
				vm.isShowTradingBank = true;
				vm.isShowTradingBranch = true;
				vm.isTradingBranchDisabled = false;
				vm.isupdated = true;
				
			}			
	        
	        //load lookup and values for exposure type and exposure sub type
			loadLookupAndValues(vm.userprofile.userExposureType, vm.userprofile.userExposureSubType);

	        console.log(vm.userprofile);
		
		}

		function onGetUserProfileError(error) {
			 AlertService.error(error.data.message);
		}
		
		
		function onGetCustomerSuccess(result) {
			// clear the image file after successfully updating
			
			$('#panImageFile').val(null);
			vm.image = null;
			fd = new FormData();
			customerPreviousData = angular.copy(result);
			vm.customerInfo={};
			vm.customerInfo.customer = result;
			vm.customerInfo.dobOrDoi = DateUtils.convertDateTimeFromServer(vm.customerInfo.customer.dobOrDoi);
			if( vm.customerInfo.customer.leiExpiryDate !=null && vm.customerInfo.customer.leiExpiryDate!=undefined 
       			 && vm.customerInfo.customer.leiExpiryDate!= ''){
				vm.customerInfo.leiExpiryDate = DateUtils.convertDateTimeFromServer(vm.customerInfo.customer.leiExpiryDate);
			}
			vm.customerInfo.isSuspendableAction = false;
    		vm.customerInfo.isApprovalRequired = false;
    		    		//console.log("result" + angular.toJson(customerPreviousData));
    		if(vm.customerInfo.customer.customerType!=null && vm.customerInfo.customer.customerType!=undefined){
                vm.inputDetailsForSelectedCustType = _.filter(vm.customerTypeWiseInputDetails, function(item) {
                    return item.customerType.id == vm.customerInfo.customer.customerType.id;
                });
				if(vm.customerInfo.customer.customerType.id == $scope.customerTypeSolePropId){
					vm.inputDetailsForSelectedCustType = [
						{customerType: null, fieldName: 'FirstName', display: false, isMandatory: false},
						{customerType: null, fieldName: 'MiddleName', display: false, isMandatory: false},
						{customerType: null, fieldName: 'LastName', display: false, isMandatory: false},
						{customerType: null, fieldName: 'EntityName', display: true, isMandatory: true},
						{customerType: null, fieldName: 'PANNo', display: true, isMandatory: true},
						{customerType: null, fieldName: 'PANImage', display: true, isMandatory: true},
						{customerType: null, fieldName: 'LegalEntityIdentifier', display: true, isMandatory: false},
						{customerType: null, fieldName: 'LEIExpiryDate', display: true, isMandatory: false},
						{customerType: null, fieldName: 'CIN', display: false, isMandatory: false},
						{customerType: null, fieldName: 'GSTIN', display: true, isMandatory: false},
						{customerType: null, fieldName: 'StateCode', display: true, isMandatory: false},
						{customerType: null, fieldName: 'DOBDOI', display: true, isMandatory: true}
					]
				}
            }else{
                vm.inputDetailsForSelectedCustType = [
                    {customerType: null, fieldName: 'FirstName', display: true, isMandatory: true},
                    {customerType: null, fieldName: 'MiddleName', display: true, isMandatory: false},
                    {customerType: null, fieldName: 'LastName', display: true, isMandatory: true},
                    {customerType: null, fieldName: 'EntityName', display: false, isMandatory: false},
                    {customerType: null, fieldName: 'PANNo', display: true, isMandatory: true},
                    {customerType: null, fieldName: 'PANImage', display: true, isMandatory: true},
                    {customerType: null, fieldName: 'LegalEntityIdentifier', display: true, isMandatory: false},
                    {customerType: null, fieldName: 'LEIExpiryDate', display: true, isMandatory: false},
                    {customerType: null, fieldName: 'CIN', display: false, isMandatory: false},
                    {customerType: null, fieldName: 'GSTIN', display: true, isMandatory: false},
                    {customerType: null, fieldName: 'StateCode', display: true, isMandatory: false},
                    {customerType: null, fieldName: 'DOBDOI', display: true, isMandatory: true}
                ]
            }
					
		}

		function onGetCustomerError(error) {
			// AlertService.error(error.data.message);
		}
		
		//load lookup and values for exposure type and exposure sub type
		function loadLookupAndValues(userExposureType, userExposureSubType){
			loadExposureTypeLookup(userExposureType);
			loadExposureSubTypeLookup(userExposureSubType);
		}
		
		//load lookup and value for exposure type 
		function loadExposureTypeLookup(userExposureType){
			ExposureType.getEnabledExposureTypes(function(result){
				vm.exposureTypes = result;
				angular.forEach(vm.exposureTypes, function(value){
                    if(value.name==userExposureType){
                    	vm.exposureType = value;
                    }
                })
                if(vm.exposureType.id==null || vm.exposureType.id==undefined){
                	vm.exposureType = null;
                }
			})
		}
			
		//load lookup and value for exposure sub  type 
		function loadExposureSubTypeLookup(userExposureSubType){
			ExposureSubType.getEnabledExposureSubTypes(function(result){
				vm.exposureSubTypes = result;
				angular.forEach(vm.exposureSubTypes, function(value){
                    if(value.name==userExposureSubType){
                    	vm.exposureSubType = value;
                    }
                })
                if(vm.exposureSubType.id==null || vm.exposureSubType.id==undefined){
                	vm.exposureSubType = null;
                }
			})
		}

		function restoreDefault() {
			if(vm.tradingBank!=null||vm.tradingBank!=undefined){
				vm.userprofile.userTradingBank = vm.tradingBank.bankName;
			}
			if(vm.tradingBranch!=null||vm.tradingBranch!=undefined){
				vm.userprofile.userTradingBranch = vm.tradingBranch.branchName;
			}

			if(vm.tradingCustomer!=null||vm.tradingCustomer!=undefined ){
				vm.userprofile.userCustomer = vm.tradingCustomer.customerCode;
			}

			if(vm.exposureType!=null||vm.exposureType!=undefined ){
				vm.userprofile.userExposureType = vm.exposureType.name;
			}

			if(vm.exposureSubType!=null||vm.exposureSubType!=undefined ){
				vm.userprofile.userExposureSubType = vm.exposureSubType.name;
			}
			if(vm.defaultForeignCurrencyPair !=null || vm.defaultForeignCurrencyPair !=undefined  ){
				vm.userprofile.defaultForeignCurrencyPair = vm.defaultForeignCurrencyPair.code;
			}

            UserProfile.restoreDefault(vm.userprofile, onSaveSuccess, onSaveError);

		}
		
		function fileSelected(input) {
		    $('#profile').val(input.files[0]);
		}
		
		function savePreferences() {
			if( vm.tradingBank!=null||vm.tradingBank!=undefined){
				vm.userprofile.userTradingBank = vm.tradingBank.bankName;
			}
			if( vm.tradingBranch!=null||vm.tradingBranch!=undefined){
				vm.userprofile.userTradingBranch = vm.tradingBranch.branchName;
			}
			
			if(vm.tradingCustomer!=null||vm.tradingCustomer!=undefined ){
				vm.userprofile.userCustomer = vm.tradingCustomer.customerCode;
			}

			if(vm.exposureType!=null||vm.exposureType!=undefined ){
				vm.userprofile.userExposureType = vm.exposureType.name;
			}

			if(vm.exposureSubType!=null||vm.exposureSubType!=undefined ){
				vm.userprofile.userExposureSubType = vm.exposureSubType.name;
			}
			if(vm.defaultForeignCurrencyPair !=null || vm.defaultForeignCurrencyPair !=undefined  ){
				vm.userprofile.defaultForeignCurrencyPair = vm.defaultForeignCurrencyPair.code;
			}
			if(vm.currencyWiseUserPreferenceSettings != undefined && vm.currencyWiseUserPreferenceSettings != null){
			UserProfile.UpdateCurrencyWiseUserPreferenceSettings(vm.currencyWiseUserPreferenceSettings);
			}
			UserProfile.updatePreferences(vm.userprofile, onSaveSuccess, onSaveError);
		}

		function launch() {
			$state.go("user-profile");
		}
		
			    
		vm.uploadImage = function uploadImage(){
			document.getElementById('txtpanCardUpload').click();
			
		}	
		
		vm.removeImage = function removeImage(){
			vm.removeButtonClicked = true;
			MessageBox.openMessageBox("Alert", "Are you sure you want to remove this profile picture?", "ProceedCancel", "userprofileremoveimage");
			vm.removeButtonClicked =false;	
			
		}	
		
	 	var  userprofileImageProceedAlert = $rootScope.$on('gatewayApp.messagebox.proceed.userprofileremoveimage', function (event, data) {
	 		vm.profileImageAction = REMOVE_ACTION;	
	 		vm.user.image = null;
	 		angular.element("input[type='file']").val(null);
        });
		
		var userprofileImageCancelAlert = $rootScope.$on('gatewayApp.messagebox.cancel.userprofileremoveimage', function (event, data) {
			//do nothing
			vm.profileImageAction = '';	
			if(vm.user.image == null){
				vm.user.image = userimageCopy;
			}
			
		});
		
		$scope.$watch('vm.panCardUpload', function(value){
			panCardUploadChange(value);
		});

	$scope.$watch('vm.currencyPair', function(value){

		if(value!=undefined && value!=null){
		vm.maximumOrderValueHardCheck = vm.globalValues.getTransactionParameterValue(value.id, "MaximumOrderValueHardCheck");
        vm.allowedOrderPriceDeviationFromMarketPriceInPercentage = vm.globalValues.getTransactionParameterValue(value.id, "AllowedOrderPriceDeviationFromMarketPriceInPercentage");
        vm.allowedOrderPriceDeviationFromMarketPriceInPaise = vm.globalValues.getTransactionParameterValue(value.id, "AllowedOrderPriceDeviationFromMarketPriceInPaise");
		vm.maximumOrderValueSoftCheck = vm.globalValues.getTransactionParameterValue(value.id, "MaximumOrderValueSoftCheck");
	     }
		});

		
		
		function panCardUploadChange(value){
			if(value!=null && value!=undefined){
							
					vm.inputImage=value.name;
					vm.panCardUpload = value;
					vm.fileExtension = vm.inputImage.substring(value.name.lastIndexOf(".") + 1);
					var fileNameWithoutExtension  =  vm.inputImage.substring(0,value.name.lastIndexOf("."));
					vm.profileImageAction = UPDATE_ACTION;
					if(imageExtensions.indexOf(vm.fileExtension.toLowerCase()) <= -1 ) {
			        	angular.element("input[type='file']").val(null);
			        	vm.panCardUpload=null;
			        	vm.profileImageAction = '';
			        	AlertService.error($filter('translate')('gatewayApp.userProfile.invalidImage'));
	    			 }else if(!FileUtil.isFileNameValid(fileNameWithoutExtension,vm.maxFileNameLength )){
	    				 angular.element("input[type='file']").val(null);
	    				 vm.panCardUpload=null;
				        vm.profileImageAction = '';
				        AlertService.error("Uploaded file name should not exceed " + vm.maxFileNameLength+ " charaters.");
	    			 }
					else{
	    				 if(!FileUtil.isFileSizeValid(value.size ,minFileSizeinBytes , maxFileSizeinBytes  )){
	    					 angular.element("input[type='file']").val(null);
	    			        	vm.panCardUpload=null;
	    			        	vm.profileImageAction = '';
	    			        	AlertService.error("The size of the image should be in between "+ vm.minimumFileSizeInKB +"KB and " + vm.maximumFileSizeinKB +" KB"  );
	    				 }else{
	    					 var reader = new FileReader();
	    					 reader.readAsArrayBuffer(value);
	    					 reader.onloadend = function(e){
	    						 if (e.target.readyState === FileReader.DONE) {
		    						  var arrayBuffer = e.target.result ;
		    					      var binary = '';
		    					      var bytes = new Uint8Array( arrayBuffer );
		    					      if(!FileUtil.checkImageFileExtension(bytes.subarray(0, 4))){
		    					    	  angular.element("input[type='file']").val(null);
		    					        	vm.panCardUpload=null;
		    					        	vm.profileImageAction = '';
		    					        	AlertService.error($filter('translate')('gatewayApp.userProfile.invalidImage'));
		    					      }else{
		    					    	  //var len = bytes.byteLength;
										  var len = bytes.byteLength;
    	            				       for (var i = 0; i < len; i++) {
    	            				           binary += String.fromCharCode( bytes[ i ] );
    	            				       }
    	            				      var data = window.btoa( binary );
		    					    	// var data = btoa(String.fromCharCode.apply(null, bytes)); 
		    					    	  vm.user.image =  data
		    					      }
		    					      $scope.$digest();
	    						 }
	    					    };
	    					 
	    					    
	    				 }
	    			 }
			
				}
			}
		
			function save() {
			if(moment(vm.user.dob).isAfter(vm.todayDate,'day')){
        		$scope.clicked=false;
        		 AlertService.error($filter('translate')('userManagement.futuredob'));
        		 
        	 }else{
        		 var fd1 = new FormData();
     			
     			vm.user.dob = DateUtils.convertLocalDateToServer(vm.user.dob);
     			fd1.append('user', JSON.stringify(vm.user));
                 
     			if(vm.profileImageAction == UPDATE_ACTION ){
     				if(vm.panCardUpload != undefined){
     					fd1.append('file', vm.panCardUpload);
     					UserProfile.updateWithImage( fd1, onSaveSuccess, onSaveError);	
     				}else{
     					UserProfile.update( fd1, onSaveSuccess, onSaveError);
     				}
     			}else if(vm.profileImageAction == REMOVE_ACTION ){
     				
     				UserProfile.updateUserProfileRemoveImage( fd1, onSaveSuccess, onSaveError);
     			}     			
     			else{
     				
     				UserProfile.update( fd1, onSaveSuccess, onSaveError);
     			}
        	 }
			
				
			
		}

		/*$rootScope.$on('changeMobileRefresh', function(event, result) {
			loadAll();
		});*/
		
		function onSaveSuccess(result) {


			$scope.clicked=false;
			//refresh data
			loadAll();

			$scope.userprofileForm.$setPristine();
			$scope.myPreferencesForm.$setPristine();
			$scope.customerInfo.$setPristine();
			// relaod the user profile image in home screen when save is success and action is update or remove
            if(vm.profileImageAction == REMOVE_ACTION || vm.profileImageAction == UPDATE_ACTION){
                vm.globalValues.getUser().image = vm.user.image;
            }
			$uibModalInstance.close(result);
	//	 UserProfile.getCurrencytUserPreference({ userId: result.userDTO.id }, onGetCurrencyWiseUserPreferenceSuccess, onGetCurrencyWiseUserPreferenceFailure);

			
		}

		function onSaveError(error) {
			$scope.clicked=false;

		}


		function updateCurrencyWiseUserPrefrencesForUser(result) {

           $rootScope.currencyWiseUserPreferenceSettings = [];


            angular.forEach(result,function(value){


                
    var currencyId = value.currencyPair.id;
    var shortName = value.shortName;

    if (!currencyId || !shortName) return;

    // Get existing object from map
    var obj = $rootScope.currencyWiseUserPreferenceSettings[currencyId];

    if (!obj) {
        obj = {
            currencyPair: value.currencyPair.code,
            configs: [null, null, null,null] // SPOT, TOM, CASH
        };
    }

    switch (shortName) {
        case "AllowedOrderPriceDeviationFromMarketPriceInPaise":
            obj.configs[0] = value.configValue;
            break;
        case "MaximumOrderValueHardCheck":
            obj.configs[1] = value.configValue;
            break;
        case "MaximumOrderValueSoftCheck":
            obj.configs[2] = value.configValue;
            break;
        case "AllowedOrderPriceDeviationFromMarketPriceInPercentage":
            obj.configs[3] = value.configValue;
            break;    
        default:
            console.warn("Unknown instrumentCode:", shortName);
    }
    
             $rootScope.currencyWiseUserPreferenceSettings[currencyId] =  obj;

            });

        }
		
		 vm.viewPanImage = function viewPanImage(){
			 CustomerRegistration.getPANImage({customerCode: vm.customerInfo.customer.customerCode}, function(result){
     			vm.customerInfo.customer.customerPanImage = result;
     			openPanImage();
     		})
	    }
		 
        function base64ToArrayBuffer(base64) {
    	    var binary_string =  window.atob(base64);
    	    var len = binary_string.length;
    	    var bytes = new Uint8Array( len );
    	    for (var i = 0; i < len; i++)        {
    	        bytes[i] = binary_string.charCodeAt(i);
    	    }
    	    return bytes.buffer;
    	}
        
		 function openPanImage(){
			 if(vm.customerInfo.customer.customerPanImage.fileExtension=='pdf'){
        		var contentByteArray = base64ToArrayBuffer(vm.customerInfo.customer.customerPanImage.image);
	    		  
	    		var file = new Blob([contentByteArray], { type: 'application/pdf' });
	            var fileURL = URL.createObjectURL(file);
	              
	            if(window.navigator.msSaveOrOpenBlob) {
	                  window.navigator.msSaveOrOpenBlob(file, "PAN.pdf");
	            }
	            else {
	                   window.open(fileURL, "PAN.pdf");    
	            }
		        	//var pdfWindow = window.open("");
	        		//pdfWindow.document.write("<iframe width='100%' height='100%'title='PAN'  src='data:application/pdf;base64, " + encodeURI(vm.customerInfo.customer.customerPanImage.image)+"' ></iframe>")
		     }else{
		        $state.go('view-panImage-customer-info-update', {image:vm.customerInfo.customer.customerPanImage.image});	
		     }
		 }
		 function perpareDataToBeSaved(){
			
			 vm.customerInfo.isSuspendableAction=false ;
			 vm.customerInfo.isApprovalRequired = false;
			
			 CustomerInfoUtil.checkForNameChangeWrokFlow(customerPreviousData , vm.customerInfo);
			// vm.customerInfo.customer.dobOrDoi = DateUtils.convertLocalDateToServer(vm.customerInfo.dobOrDoi);
			 
			 if( vm.customerInfo.leiExpiryDate !=null && vm.customerInfo.leiExpiryDate!=undefined 
	       			 && vm.customerInfo.leiExpiryDate!= ''){
					vm.customerInfo.customer.leiExpiryDate = DateUtils.convertLocalDateToServer(vm.customerInfo.leiExpiryDate);
				}
			 
			 if( vm.image === undefined || vm.image == ""){
				 vm.image = null;
			 }
			 fd = new FormData();
			 fd.append('pan', vm.image);
			 fd.append('customer', JSON.stringify( vm.customerInfo));
		 }
		 vm.saveCustomerInfo = function saveCustomerInfo(){
			
			 vm.screenLog.screenLog(entityConstants.ENTITY_SHORT_NAME.CUSTOMER,  vm.customerInfo.customer.id,  entityConstants.ENTITY_ACTION_TYPE.EDIT);
			 if(CustomerInfoUtil.isCustomerProfileFormValuesChanged(customerPreviousData,vm.customerInfo,vm.image )){
				 
				 perpareDataToBeSaved();
				 if(vm.customerInfo.customer.customerFirstName.includes(',')){
					 if(vm.inputDetailsForSelectedCustType!=null 
	                            && vm.inputDetailsForSelectedCustType[$scope.entityNameIndex]!= null 
	                            && vm.inputDetailsForSelectedCustType[$scope.entityNameIndex].display){
						 AlertService.error($filter('translate')('gatewayApp.userProfile.commaInEntityName'));
					 }else{
						 AlertService.error($filter('translate')('gatewayApp.userProfile.commaInFirstName'));
					 }
				 }else if(vm.customerInfo.isSuspendableAction==true){
					vm.isupdated = false;
					MessageBox.openMessageBox("Alert", $filter('translate')('gatewayApp.userProfile.suspendAlert'), "YesNo", "customerprofile");
				 }else{
					$scope.clicked = true;
					 UserProfile.updateCustomerInfo(fd, onCustomerSaveSuccess, onCustomerSaveError);
				 }
				 
			 }else{
				 AlertService.error($filter('translate')('gatewayApp.userProfile.noChangesMade'));
			 }
			
			
		 }
			 
		
		var customerProfileUpdate =	$rootScope.$on('gatewayApp.messagebox.yes.customerprofile', function (event, data) {
		 		if($state.current.name === 'user-profile' && !vm.isupdated){
		 			vm.isupdated = true;
					 $scope.clicked = true;
			 		UserProfile.updateCustomerInfo(fd, onCustomerSaveSuccess, onCustomerSaveError);
			 		
		 		}
		 		

	        });
			
			$rootScope.$on('gatewayApp.messagebox.no.customerprofile', function (event, data) {
				//do nothing
				if($state.current.name === 'user-profile')
					vm.isupdated = true;
			});
			function onCustomerSaveSuccess(result) {
				
				$scope.clicked = false;
				vm.customerInfo.isSuspendableAction=false;
				vm.customerInfo.isApprovalRequired = false;
				fd= new FormData();
				loadCustomer();
				
				
			}

			function onCustomerSaveError(error) {
				vm.customerInfo.isSuspendableAction=false;
				vm.customerInfo.isApprovalRequired = false;
				fd= new FormData();
				$scope.clicked = false;
				
				//AlertService.error(error.data.message);

			}
		vm.openChangeEmail = function openChangeEmail(){
			$state.go('change-email', {userId: vm.userId,email: vm.user.email, mode: 'userProfile', customerId: 0 });
		}
		
		vm.openChangeMobile = function openChangeMobile(){
			$state.go('change-mobile', {userId: vm.userId,mobile: vm.user.mobile,countryCode:vm.user.mobileCountryCode, mode: 'userProfile',customerId: 0});
		}
		
		vm.openChangeEmailForCustomer = function openChangeEmail(){
			console.log(vm.globalValues.getOrganisation().id);
			$state.go('change-email', {userId: vm.userId,email: vm.customerInfo.customer.primaryEmail, mode: 'customerinfo',customerId: vm.globalValues.getOrganisation().id});
		}
		
		vm.openChangeMobileForCustomer = function openChangeMobile(){
			$state.go('change-mobile', {userId: vm.userId,mobile: vm.customerInfo.customer.primaryMobile,countryCode:vm.customerInfo.customer.primaryMobileCountryCode, mode: 'customerinfo',customerId: vm.globalValues.getOrganisation().id});
		}
		
		$rootScope.$on('changeEmailRefresh', function(event, result) {
			vm.customerInfo.customer.primaryEmail = $rootScope.email;
		});

		$rootScope.$on('changeMobileRefresh', function(event, result) {
			vm.customerInfo.customer.primaryMobile = $rootScope.mobile;
		});
		
	$scope.$watch('vm.tradingBank', function(value){
			if(value!=null && value!=undefined && value.id!=null && value.id!=undefined){
				CustomerBankRelationshipReport.getValidTradingBranchForCustomerAndBank({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
					if(result!=null && result!=undefined){
						//if(result.entityRestrictionStatus.shortName!='Suspended' && result.entityRestrictionStatus.shortName!='Terminated'){
							vm.tradingBranch = result;
						//}
					}
				})	
			}
		});
		$scope.$watch('vm.customerInfo.customer.state', function(value){
			if(value!=null && value!=undefined && value.id!=null && value.id!=undefined){
				
				}else{
					
				}
			}
		);
		
		   //validate pan image size
        $scope.$watch('vm.image', function(value){
        	
        	if(value!= undefined && value!=null){
        		if(!FileUtil.isFileSizeValid(value.size ,minFileSizeinBytes , maxFileSizeinBytes  )){
        			vm.invalidPanImageSize = true;
        			vm.invalidPanFileName = false;
        			vm.invalidPanImageSixeText = "PAN image size should be in between "+ vm.minimumFileSizeInKB +"KB and " + vm.maximumFileSizeinKB +" KB";
        			vm.invalidPanImage = false;
        			angular.element("input[type='file']").val(null);
        			
        		}else{
        			vm.inputPanImage=vm.image.name;
        			vm.invalidPanImageSize = false;
        			vm.invalidPanImage = false;
        			vm.fileExtension = vm.inputPanImage.substring(vm.image.name.lastIndexOf(".") + 1);
        			var fileNameWithoutExtension  =  vm.inputPanImage.substring(0,vm.image.name.lastIndexOf("."));
        			//check for extension
        			 if(Extensions.indexOf(vm.fileExtension.toLowerCase()) <= -1) {
			        	angular.element("input[type='file']").val(null);
			        	vm.image=null;
			        	vm.inputPanImage=null;
			        	vm.invalidPanImage = true;
			        	 vm.invalidPanFileName = false;
			        	 vm.invalidPanImageSize = false;
			        	 vm.invalidPanImageText = "Invalid file format";
        			 }
        			 else if(!FileUtil.isFileNameValid(fileNameWithoutExtension,vm.maxFileNameLength )){
	    				 angular.element("input[type='file']").val(null);
	    				 vm.image=null;
				         vm.inputPanImage=null;
				         vm.invalidPanImage = false;
				         vm.invalidPanImageSize = false;
				         vm.invalidPanFileName = true;
				         vm.invalidPanImageFileNameText = "Uploaded pan file name should not exceed " + vm.maxFileNameLength+ " charaters.";
				         
	    			 }
        			 else{ // check for malicious file with correct extension
        				 var reader = new FileReader();
    					 reader.readAsArrayBuffer(value.slice(0,4));
    					 reader.onloadend = function(e){
    						 if (e.target.readyState === FileReader.DONE) {
    						  var arrayBuffer = e.target.result;
    					      var bytes = new Uint8Array( arrayBuffer );
    					      if(!FileUtil.checkPanImageFileExtension(bytes)){
    					    	  angular.element("input[type='file']").val(null);
    					        	vm.image=null;
    					        	vm.inputPanImage=null;
    					        	vm.invalidPanImage = true;
    					        	vm.invalidPanImageSize = false;
    							    vm.invalidPanFileName = false; 
    							    vm.invalidPanImageText = "Invalid file format";
    					      }
    					      else{
    					    	  vm.invalidPanImageSize = false;
  							      vm.invalidPanFileName = false; 
  							      vm.invalidPanImage =false;
    					      }
    					      $scope.$digest();
    						 }
    					    }; 
        			 }
        		}
        	}
        	else{
        		angular.element("input[type='file']").val(null);
        		
        		vm.inputPanImage=null;
        	}
        });
        
        function logScreenAccess(){
           	ScreenLog.screenLog( entityConstants.ENTITY_SHORT_NAME.USER_PROFILE,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }
        $scope.$on('$destroy', function() {
        	if(userprofileImageProceedAlert!=null){
        		userprofileImageProceedAlert();
        	}
        	if(userprofileImageCancelAlert!=null){
        		userprofileImageCancelAlert();
        	}
        	if(customerProfileUpdate!=null){
        		customerProfileUpdate();
        	}
        });

		function getCurrencyWiseUserPreference(currencyPair){
						UserProfile.getCurrencyWiseUserPreference({"currencyPairId": currencyPair.id,"userId" : vm.userId
			},ongetgetCurrencyWiseUserPreferenceSuccess, ongetCurrencyWiseUserPreferenceError);
		}

		function ongetgetCurrencyWiseUserPreferenceSuccess(result){
			vm.currencyWiseUserPreferenceSettings = result;
			vm.clicked=false;
		}

		function ongetCurrencyWiseUserPreferenceError(){
		vm.clicked=false;
		}
		
		

	}
})();

 (function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-profile', {
            parent: 'entity',
            url: '/user-profile/{userId}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.userProfile.userProfile" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-profile-preferences/user-profile.html',
                    controller: 'UserProfileController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function(){
                        	
                        },
                        customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                        }],
                        globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:true});
                }, function() {
                    $state.go('home', null, {reload:true});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('customer-registration');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
         };
    })();

(function() {
	'use strict';
	angular.module('gatewayApp').factory('UserProfile', UserProfile);

	UserProfile.$inject = [ '$resource', 'DateUtils' ];

	function UserProfile($resource, DateUtils) {
		var resourceUrl = 'api/bank/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				params : {
					userId : '@userId'
				},
				url : 'api/user-profile/:userId',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},

			'save' : {
				method : 'POST',
				url : 'api/user-profile/update-user',
				headers: {
                    'Content-Type': undefined
                },
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'updateWithImage' : {
				method : 'POST',
				url : 'api/user-profile/update-user-with-image',
				headers: {
                    'Content-Type': undefined
                }
			},
			'update' : {
				method : 'POST',
				url : 'api/user-profile/update-user',
				headers: {
                    'Content-Type': undefined
                }
			},
			'updatePreferences' : {
				method : 'PUT',
				url : 'api/user-profile/update-preferences',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'updateGivenPreference' : {
				method : 'PUT',
				params : {
					userId : '@userId', settingsName: '@settingsName', value: '@value'
				},
				url : 'api/user-profile/update-given-preference',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'updateCustomerInfo' : {
				method : 'POST',
				url : 'api/user-profile/update-customer-info',
				headers: {
                    'Content-Type': undefined
                }
			},
			'restoreDefault' : {
				method : 'PUT',
				url : 'api/user-profile/restore-default',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'getCustomer' : {
				method : 'GET',
				params : {
					customerId : '@customerId'
				},
				url : 'api/user-profile/get-customer-info/:customerId',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'updateUserProfileRemoveImage' : {
				method : 'POST',
				url : 'api/user-profile/update-user-remove-image',
				headers: {
                    'Content-Type': undefined
                }
			},
			
            'getPendingTaskCount':{
            	 method: 'GET',
            	 url: 'api/pending-tasks-for-user',
                 transformResponse: function (data) {
                	 if(data){
                     data = angular.fromJson(data);
                	 }
                     return data;
                 }
            },

            'getUserMarketWatchSettingsList':{
            	 method: 'GET',
            	 isArray : true,
            	 url: 'api/user-market-watch-list-for-user',
                 transformResponse: function (data) {
                	 if(data){
                     data = angular.fromJson(data);
                	 }
                     return data;
                 }
            },

            'saveUserMarketWatchList' : {
				method : 'POST',
				url : 'api/save-user-market-watch-list',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					angular.forEach(copy, function(value){
						value.settlementDate = DateUtils.convertLocalDateToServer(value.settlementDate);
					})
					return angular.toJson(copy);
				}
			},

            'resetUserMarketWatchList' : {
				method : 'POST',
				isArray : true,
				url : 'api/reset-user-market-watch-list',
                transformResponse: function (data) {
               	 if(data){
                    data = angular.fromJson(data);
               	 }
                    return data;
                }
			},
			
            'getCurrencyWiseUserPreference' : {
				method : 'GET',
				params : {
 					currencyPairId : '@currencyPairId',
					userId : '@userId'

 				},
				url : 'api/currency-wise-user-preference',
                transformResponse: function (data) {
               	 if(data){
                    data = angular.fromJson(data);
               	 }
                    return data;
                }
			},
			'UpdateCurrencyWiseUserPreferenceSettings' : {
				method : 'post',
				url : 'api/update-currency-wise-user-preference-settings',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			 'getCurrencytUserPreference' : {
				isArray : true,
				method : 'GET',
				params : {
					userId : '@userId'
 				},
				url : 'api/currency-user-preference',
                transformResponse: function (data) {
               	 if(data){
                    data = angular.fromJson(data);
               	 }
                    return data;
                }
			},

		});
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('CustomerInfoUtil', CustomerInfoUtil);

    CustomerInfoUtil.$inject = [];

    function CustomerInfoUtil() {

        var service = {
        		checkForNameChangeWrokFlow: checkForNameChangeWrokFlow,
        		isCustomerProfileFormValuesChanged: isCustomerProfileFormValuesChanged,
        		checkvalidityOfValues: checkvalidityOfValues
           
        };

        return service;


        function checkForNameChangeWrokFlow(customerPreviousData , customerInfo ){
        	
        	if(customerPreviousData.customerFirstName != customerInfo.customer.customerFirstName || 
        			customerPreviousData.customerMiddleName != customerInfo.customer.customerMiddleName  ||
        			customerPreviousData.customerLastName != customerInfo.customer.customerLastName  ){
        		
        		customerInfo.isSuspendableAction = true;
        		customerInfo.isApprovalRequired = true;
        		
        	/* }else if(customerPreviousData.address1 != customerInfo.customer.address1
        			|| customerPreviousData.address2 != customerInfo.customer.address2
        			|| customerPreviousData.city != customerInfo.customer.city
        			|| customerPreviousData.state.id != customerInfo.customer.state.id
        			|| customerPreviousData.pincode != customerInfo.customer.pincode
        			|| customerPreviousData.stateCode != customerInfo.customer.stateCode
        			|| customerPreviousData.gstin != customerInfo.customer.gstin) {
        		
        		customerInfo.isSuspendableAction = false;
        		customerInfo.isApprovalRequired = true; */
        	}else{
        		
        		customerInfo.isSuspendableAction = false;
        		customerInfo.isApprovalRequired = false;
        	}
        	
        	
        }  
        function isCustomerProfileFormValuesChanged(customerPreviousData,customerInfo,image ) {
        	customerInfo.fieldCheckArray = [];
        	var customerTypeSolePropId = 27;
    		var changesMade = false;
    		if(customerInfo.customer.customerType.customerUserType.shortName=='MultiUserCustomer' || customerInfo.customer.customerType.id == customerTypeSolePropId){
				var isField1 = checkvalidityOfValues(customerPreviousData.customerFirstName , customerInfo.customer.customerFirstName , "entityName" ,customerInfo ); 
			}else{
				var isField1 = checkvalidityOfValues(customerPreviousData.customerFirstName , customerInfo.customer.customerFirstName , "customerFirstName" ,customerInfo ); 
			}
    		
    		var isField2 =  checkvalidityOfValues( customerPreviousData.customerMiddleName , customerInfo.customer.customerMiddleName, "customerMiddleName", customerInfo);
    		var isField3 = checkvalidityOfValues(customerPreviousData.customerLastName , customerInfo.customer.customerLastName, "customerLastName", customerInfo);
    		//var isField4 =  (vm.image!=undefined &&  vm.image!=null && vm.image!='');
    		var isField5 =  checkvalidityOfValues(customerPreviousData.address1 , customerInfo.customer.address1, "address1", customerInfo);			
    		var isField6 =  checkvalidityOfValues(customerPreviousData.address2 , customerInfo.customer.address2 , "address2" , customerInfo);
    		var isField7 =  checkvalidityOfValues(customerPreviousData.city , customerInfo.customer.city, "city", customerInfo);
    		var isField8 =  checkvalidityOfValues(customerPreviousData.state.id , customerInfo.customer.state.id, "state",customerInfo);
    		var isField9 =  checkvalidityOfValues(customerPreviousData.pincode , customerInfo.customer.pincode, "pincode", customerInfo);			
    		var isField10 =  checkvalidityOfValues(customerPreviousData.stateCode , customerInfo.customer.stateCode, "stateCode", customerInfo);				
    		var isField11 = checkvalidityOfValues(customerPreviousData.gstin , customerInfo.customer.gstin, "gstin" , customerInfo);			
    		var isField12 =  checkvalidityOfValues(customerPreviousData.primaryContactName , customerInfo.customer.primaryContactName, "primaryContactName", customerInfo);
    		var isField13 =  checkvalidityOfValues(customerPreviousData.primaryEmail , customerInfo.customer.primaryEmail, "primaryEmail", customerInfo);
    		var isField14 =  checkvalidityOfValues(customerPreviousData.primaryMobileCountryCode , customerInfo.customer.primaryMobileCountryCode, "primaryMobileCountryCode", customerInfo);
    		var isField15 =  checkvalidityOfValues(customerPreviousData.primaryMobile , customerInfo.customer.primaryMobile, "primaryMobile", customerInfo);			
    		var isField16 =  checkvalidityOfValues(customerPreviousData.alternateContactName1 , customerInfo.customer.alternateContactName1, "alternateContactName1", customerInfo);
    		var isField17 =  checkvalidityOfValues(customerPreviousData.alternateEmail1 , customerInfo.customer.alternateEmail1, "alternateEmail1", customerInfo);
    		var isField18 =  checkvalidityOfValues(customerPreviousData.alternateMobileCountryCode1 , customerInfo.customer.alternateMobileCountryCode1, "alternateMobileCountryCode1" , customerInfo);				
    		var isField19 =  checkvalidityOfValues(customerPreviousData.alternateMobile1 , customerInfo.customer.alternateMobile1, "alternateMobile1", customerInfo);			
    		var isField20 =  checkvalidityOfValues(customerPreviousData.alternateContactName2 , customerInfo.customer.alternateContactName2, "alternateContactName2" , customerInfo);				
    		var isField21 =  checkvalidityOfValues(customerPreviousData.alternateMobileCountryCode2 , customerInfo.customer.alternateMobileCountryCode2, "alternateMobileCountryCode2", customerInfo) ;				
    		var isField22 =  checkvalidityOfValues(customerPreviousData.alternateMobile2 , customerInfo.customer.alternateMobile2, "alternateMobile2", customerInfo) ;		
    		var isField23 =  checkvalidityOfValues(customerPreviousData.alternateEmail2 , customerInfo.customer.alternateEmail2, "alternateEmail2"  ,customerInfo);
    		
			if( isField1 || isField2 ||	isField3 ||	(image!=undefined &&  image!=null && image!='') ||	isField5 ||	isField6 ||	isField7 ||
				isField8 ||	isField9 ||	isField10 || isField11 ||	isField12||	isField13 ||	isField14|| isField15 || isField16|| isField17|| isField18 ||isField19 ||				
				isField20||	isField21||	isField22 ||isField23){
				
				changesMade = true;
			 }
			if(image!=undefined &&  image!=null && image!=''){
				customerInfo.fieldCheckArray.push("customerPanImage"); 
        	}
			return changesMade;
        }
        function checkvalidityOfValues(previousValue, currentValue, fieldName , customerInfo){
        	
        	var isValueChanged = (!(previousValue == null && (currentValue == "" || currentValue== null)) && previousValue!=currentValue);
        	if(isValueChanged){
        		customerInfo.fieldCheckArray.push(fieldName);
        	}
        		
        	return isValueChanged;
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-access-view', {
            parent: 'entity',
            params:{screen: 'UserAccessView'},
            url: '/user-access-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.userAccessView.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-access-view/user-access-view.html',
                    controller: 'UserAccessViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userAccessView');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('orderActivity');
                    return $translate.refresh();
                }]
               
            }
        })
        
         
       };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('UserAccessView', UserAccessView);

    UserAccessView.$inject = ['$resource'];

    function UserAccessView ($resource) {
        var resourceUrl =  'api/security-policy-view';
        
        return $resource(resourceUrl, {}, {
        	
        	'getSecurityPolicyView':{
        		isArray:true,
				method: 'GET',
				params: {orgId : '@orgId', branchId : '@branchId', userId : '@userId', roleId :'@roleId',themeId:'@themeId',actionId:'@actionId',userStatusId:'@userStatusId', queryParam:'@queryParam'},
				url: 'api/orgId/:orgId/security-policy-view/:branchId/branch/:userId/user/:roleId/role/:themeId/theme/:actionId/action/:userStatusId/userStatus'
        	},
           'getApprovalPolicyView':{
        	  isArray:true,
        	  method: 'GET',
        	  params: {orgId : '@orgId', branchId : '@branchId', userId : '@userId', roleId :'@roleId', policyId:'@policyId', actionId:'@actionId', queryParam:'@queryParam'},
        	  url: 'api/orgId/:orgId/approval-policy-view/:branchId/branch/:userId/user/:roleId/role/:policyId/policy/:actionId/action'
           },
           'exportApprovalPolicyExcel':{
        	  method: 'POST',
              params: {orgId : '@orgId', queryParam:'@queryParam'},
              responseType: 'arraybuffer',
              url: 'api/orgId/:orgId/approval-policy-view/export/excel',
              transformRequest: function (data) {
                 	var copy = angular.copy(data);                 	
                     return angular.toJson(copy);
              },
              transformResponse: function(data, headers) {
				return {
					data: data,
					headers: headers
				};   
			}         
             
           },
           'exportApprovalPolicyCsv' : {
        	  method: 'POST',
        	  responseType: 'arraybuffer',
              params: {queryParam:'@queryParam'},
              url: 'api/orgId/:orgId/approval-policy-view/export/csv',
              transformRequest: function (data) {
               	var copy = angular.copy(data);                 	
                   return angular.toJson(copy);
              },
              transformResponse: function(data, headers) {
            	return {
					data: data,
					headers: headers
				};  
              }
           },'exportSecurityPolicyExcel':{
        	  method: 'POST',
              params: {orgId : '@orgId', queryParam:'@queryParam'},
              responseType: 'arraybuffer',
              url: 'api/orgId/:orgId/security-policy-view/export/excel',
              transformRequest: function (data) {
                 	var copy = angular.copy(data);                 	
                     return angular.toJson(copy);
              },
              transformResponse: function(data, headers) {
				return {
					data: data,
					headers: headers
				};   
			}         
             
           },'exportSecurityPolicyCsv':{
        	   method: 'POST',
         	  responseType: 'arraybuffer',
               params: {queryParam:'@queryParam'},
               url: 'api/orgId/:orgId/security-policy-view/export/csv',
               transformRequest: function (data) {
                	var copy = angular.copy(data);                 	
                    return angular.toJson(copy);
               },
               transformResponse: function(data, headers) {
             	return {
 					data: data,
 					headers: headers
 				};  
               }
           }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'UserAccessView'
        })
        
        .controller('UserAccessViewController', UserAccessViewController);

    UserAccessViewController.$inject = ['$scope', '$state', 'UserAccessView', 'GlobalValues', 
    'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout','StaticLookUp'];

    function UserAccessViewController($scope, $state, UserAccessView , GlobalValues, 
    	workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout,StaticLookUp) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.USERACCESSVIEW;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        $scope.noOfRecordsPerPage1 = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page1 = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        
        vm.todayDate = new Date();
        vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.orgId = vm.globalValues.getOrgId();
        vm.selectedEntityOwnerType = 'Bank';
        vm.policyType = 'SecurityPolicy';
        vm.ExpandOrCollapseFilterBy = false;
        vm.exportApprovalPolicyData = exportApprovalPolicyData;
        vm.exportSecurityPolicyData = exportSecurityPolicyData;
        vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
        vm.approvalPolicyfileName = "Approval_Policy_View_";
        vm.securityPolicyfileName = "Security_Policy_View_";
		vm.extension = "";
		vm.mimeType = "";
		vm.approvalPolicyQueryParamToExport = "";
		vm.securityPolicyQueryParamToExport = "";
		vm.selectedOrg= 0;
		vm.clicked=false;
		
		$scope.$watch('vm.selectedEntityOwnerType',function(value){
			vm.userStatusList = StaticLookUp.getUserStatusExceptDelinked({selectedEntity : value});
		});
        

        vm.ExpandOrCollapseUserAccessView=true;
        
        workflowSharedService.viewFrom = "UserAccessView";

        if(vm.entityOwnerType=='Bank'){
            vm.bank = vm.globalValues.getBank();
        }

        vm.getUserAccessView = getUserAccessView;

        //UserAccessView.getSecurityPolicyView({orgId: 2, branchId: 0, userId: 0, roleId: 0, themeId:0, actionId:0, userStatusId: 1}, onGetSecurityPolicyViewSuccess, onGetSecurityPolicyViewFailure);
        //UserAccessView.getApprovalPolicyView({orgId: 2, branchId: 0, userId: 0, roleId: 0, policyId:0, actionId:0}, onGetApprovalPolicyViewSuccess, onGetApprovalPolicyViewFailure);
        logScreenAccess();
        // loadCurrentBusinessDate();

        function logScreenAccess(){
        	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }

        function getUserAccessView(){
        	if(vm.policyType=='SecurityPolicy'){
        		getSecurityPolicyView();
        	}else if(vm.policyType=='ApprovalPolicy'){
        		getApprovalPolicyView();
        	}
        }

        function getSecurityPolicyView(){
			var orgId = 0;
			var branchId = 0;
			var userId = 0;
			var roleId = 0;
			var themeId = 0;
			var actionId = 0;
			var userStatusId=0;
			vm.securityPolicyQueryParamToExport = "";
			vm.selectedOrg= 0;
			
			if(vm.selectedEntityOwnerType=='Bank'){
				var orgId = vm.bank.id;
				if(vm.branch !=null){
					var branchId = vm.branch.id;
				}
			}else{
			    var orgId = vm.customer.id;
			}
			
			vm.selectedOrg= orgId;
			     
			
			if(vm.user !=null){
			    var userId = vm.user.id;
			}
			
			if(vm.role!=null){
			    var roleId = vm.role.id
			}
			
			if (vm.theme != null){
			    var themeId = vm.theme.id
			}
			
			if(vm.action != null){
			    var actionId = vm.action.id
			}
			
			if(vm.userStatus != null){
			    var userStatusId = vm.userStatus.id
			}
			
			var queryParam = prepareQueryParamString();
			vm.securityPolicyQueryParamToExport = angular.copy(queryParam);
			// parameters to be copied to vm variables that are used when user export the grid
			//copySecurityPolciyParameters(entityOwnerType, orgId, branchId, userId, roleId, themeId, actionId, userStatusId);
			
			UserAccessView.getSecurityPolicyView({orgId: orgId, branchId: branchId, userId: userId, roleId: roleId, themeId: themeId, actionId:actionId, userStatusId: userStatusId, queryParam:queryParam}, onGetSecurityPolicyViewSuccess, onGetSecurityPolicyViewFailure);
        }
		
		function onGetSecurityPolicyViewSuccess(result){
			vm.securityPolicies = result
			vm.clicked=false;
			console.log(vm.securityPolicies);
		}
		
		function onGetSecurityPolicyViewFailure(){
			vm.clicked=false;
		}
		
		function getApprovalPolicyView(){
			var orgId = 0;
			var branchId = 0;
			var userId = 0;
			var roleId = 0;
			var policyId = 0;
			var actionId = 0;
			vm.approvalPolicyQueryParamToExport ="";
			vm.selectedOrg= 0;
			
			if(vm.selectedEntityOwnerType=='Bank'){
				var orgId = vm.bank.id;
				if(vm.branch !=null){
				     var branchId = vm.branch.id;
				}
			}else{
				var orgId = vm.customer.id;
			}
			vm.selectedOrg= orgId;
						
			if(vm.user !=null){
			    var userId = vm.user.id;
			}
			
			if(vm.role!=null){
			    var roleId = vm.role.id
			}
			
			if (vm.policy != null){
			    var policyId = vm.policy.id
			}
			
			if(vm.action != null){
			    var actionId = vm.action.id
			}

			var queryParam = prepareQueryParamString();
			vm.approvalPolicyQueryParamToExport = angular.copy(queryParam);
			// parameters to be copied to vm variables that are used when user export the grid
			//copyApprovalPolicyParameters(entityOwnerType, orgId, branchId, userId, roleId, themeId, actionId);
			
			UserAccessView.getApprovalPolicyView({orgId: orgId, branchId: branchId, userId: userId, roleId: roleId, policyId:policyId, actionId:actionId, queryParam:queryParam}, onGetApprovalPolicyViewSuccess, onGetApprovalPolicyViewFailure);
		}
		
		function onGetApprovalPolicyViewSuccess(result){
			vm.approvalPolicies = result
			vm.clicked=false;
			console.log(vm.approvalPolicies);
		}
		
		function onGetApprovalPolicyViewFailure(){
			vm.clicked=false;
		}

		function prepareQueryParamString(){
			var queryParam = "";

			queryParam = "Entity Owner Type:";
			if(vm.selectedEntityOwnerType == 'Bank'){
				queryParam = queryParam + "BANK";
			}else{
				queryParam = queryParam + "MULTI-USER CUSTOMER";
			}
			

			if(vm.selectedEntityOwnerType=='Bank'){
				queryParam = queryParam + "; Bank:";
				queryParam = queryParam + vm.bank.bankName;
				queryParam = queryParam + "; Branch:";
				if(vm.branch!=null && vm.branch!=undefined){
					queryParam = queryParam + vm.branch.branchName;
				}else{
					queryParam = queryParam + "All";
				}
			}else{
				queryParam = queryParam + "; Customer:";
				queryParam = queryParam + vm.customer.customerName;
			}

			queryParam = queryParam + "; Policy Type:";
			if(vm.policyType == 'SecurityPolicy'){
				queryParam = queryParam + "SECURITY POLICY";
			}else{
				queryParam = queryParam + "APPROVAL POLICY";
			}
			

			queryParam = queryParam + "; User Login:";
			if(vm.user!=null && vm.user!=undefined){
				queryParam = queryParam + vm.user.login;
			}else{
				queryParam = queryParam + "All";
			}

			queryParam = queryParam + "; Role:";
			if(vm.role!=null && vm.role!=undefined){
				queryParam = queryParam + vm.role.name;
			}else{
				queryParam = queryParam + "All";
			}

			if(vm.policyType=='SecurityPolicy'){
				queryParam = queryParam + "; Theme:";
				if(vm.theme!=null && vm.theme!=undefined){
					queryParam = queryParam + vm.theme.shortName;
				}else{
					queryParam = queryParam + "All";
				}
			}else{
				queryParam = queryParam + "; Approval Policy:";
				if(vm.policy!=null && vm.policy!=undefined){
					queryParam = queryParam + vm.policy.shortName;
				}else{
					queryParam = queryParam + "All";
				}
			}

			queryParam = queryParam + "; Action:";
			if(vm.action!=null && vm.action!=undefined){
				queryParam = queryParam + vm.action.shortName;
			}else{
				queryParam = queryParam + "All";
			}

			if(vm.policyType=='SecurityPolicy'){
				queryParam = queryParam + "; User Status:";
				if(vm.userStatus!=null && vm.userStatus!=undefined){
					queryParam = queryParam + vm.userStatus.displayName;
				}else{
					queryParam = queryParam + "All";
				}
			}

			return queryParam;
		}

		function copyApprovalPolicyParameters(){

		}
		
		function exportApprovalPolicyData(fileType){

			
			if( vm.approvalPolicies !=null &&  vm.approvalPolicies != undefined && vm.approvalPolicies.length > 0){
				if(fileType == 'csv'){
					vm.mimeType = 'text/csv';
					vm.extension =  ".csv";  
					vm.baseString =   vm.approvalPolicyfileName + moment().format( vm.reportFileTimestampFormat ) +  vm.extension;
					UserAccessView.exportApprovalPolicyCsv({ orgId: vm.selectedOrg, queryParam:vm.approvalPolicyQueryParamToExport},vm.approvalPolicies, processResponse );
				}
				else if(fileType == 'xls'){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.extension = ".xls";  
					vm.baseString =   vm.approvalPolicyfileName + moment().format( vm.reportFileTimestampFormat ) +  vm.extension; 

					UserAccessView.exportApprovalPolicyExcel({ orgId: vm.selectedOrg, queryParam:vm.approvalPolicyQueryParamToExport},vm.approvalPolicies, processResponse);
				}
				

			}
		}
		
		function exportSecurityPolicyData(fileType){

			
			if( vm.securityPolicies !=null &&  vm.securityPolicies != undefined && vm.securityPolicies.length > 0){
				if(fileType == 'csv'){
					vm.mimeType = 'text/csv';
					vm.extension =  ".csv";  
					vm.baseString =   vm.securityPolicyfileName + moment().format( vm.reportFileTimestampFormat ) +  vm.extension;
					UserAccessView.exportSecurityPolicyCsv({ orgId: vm.selectedOrg, queryParam:vm.securityPolicyQueryParamToExport},vm.securityPolicies, processResponse );
				}
				else if(fileType == 'xls'){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.extension = ".xls";  
					vm.baseString =   vm.securityPolicyfileName + moment().format( vm.reportFileTimestampFormat ) +  vm.extension; 

					UserAccessView.exportSecurityPolicyExcel({ orgId: vm.selectedOrg, queryParam:vm.securityPolicyQueryParamToExport},vm.securityPolicies, processResponse);
				}
				

			}
		}
		
		function processResponse(result){        	  
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
			
			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}

		vm.getLength = function getLength(approvalPolicy){
			var len =0;
			angular.forEach(approvalPolicy.approvalPolicyViewRoleDetailsDTOList, function(value){
				angular.forEach(value.approvalPolicyViewDetailsDTOList, function(value1){
					len = len + 1;
				})
			})
			return len;
		}

       
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('upload-download-participant-certificate', {
            parent: 'entity',
            url: '/upload-download-participant-certificate',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.uploadDownloadCertificates.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/upload-download-participant-certificate/upload-download-participant-certificate.html',
                    controller: 'ParticipantCertificateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('uploadDownloadCertificates');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        
          .state('upload-participant-certificate', {
            parent: 'entity',
            url: '/upload-participant-certificate',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.uploadDownloadCertificates.ccTitle" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/upload-download-participant-certificate/upload-download-participant-certificate.html',
                    controller: 'ParticipantCertificateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('uploadDownloadCertificates');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        
        
         .state('participant-certificate-todolist', {
            parent: 'dashboard',
            url: '/participant-certificate-todo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/upload-download-participant-certificate/participant-certificate-dialog.html',
                    controller: 'ParticipantCertificateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('upload-download-participant-certificate', null, { reload: 'upload-download-participant-certificate' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('UploadDownloadParticipantCertificates', UploadDownloadParticipantCertificates);

    UploadDownloadParticipantCertificates.$inject = ['$resource'];

    function UploadDownloadParticipantCertificates ($resource) {
        var resourceUrl =  'api/upload-download-participant-certificate/:id';
        
        return $resource(resourceUrl, {}, {
        	
              
              'uploadCertificate':{
                	 
               
    				method: 'POST',
    				url: 'api/upload-participant-certificate',
    				headers: {
                        'Content-Type': undefined
                    }
                },
                'approve': {
                    method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/approve'
                },
                'reject': {
                    method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/reject'
                },
                'discard': {
                  	 method: 'GET',
                       params: {taskId:'@taskId'},
                       url: 'api/tasks/:taskId/discard'
                 },
                 'downloadCertificate':{
                	 
                     
     				method: 'GET',
     				url: 'api/download-participant-certificate',
     				 responseType: 'arraybuffer',
     				  transformResponse: function(data, headers) {
     	              	  return {
     	                        data: data,
     	                        headers: headers
     	                    };   
     	                } 
                 }
          
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'uploadDownloadParticipantCertificate'
        })
        
        .controller('ParticipantCertificateController', ParticipantCertificateController);

    ParticipantCertificateController.$inject = ['$scope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
    				'MessageBox','$rootScope','UploadDownloadParticipantCertificates','AlertService','$filter', '$window'];

    function ParticipantCertificateController($scope, $state , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
    				MessageBox,$rootScope,UploadDownloadParticipantCertificates, AlertService, $filter, $window) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.UPLOAD_DOWNLOAD_PARTICIPANT_CERTIFICATE;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.orgId = vm.globalValues.getOrgId();
        vm.clicked = false;

        
        vm.organisation = vm.globalValues.getOrganisation().organisationType.shortName;
       
        vm.selectedFilter='upload';
        vm.uploadCertificate = uploadCertificate;
        vm.downloadCertificate = downloadCertificate;
        
        if(vm.organisation == 'CUSTOMER'){
        	vm.participantCode = vm.globalValues.getCustomer().customerCode;
        }
        else if(vm.organisation == 'BANK'){
        	vm.participantCode = vm.globalValues.getBank().ccpMembershipId;
        }
        else{
        	vm.participantCode = 'CLEARCORP';
        }
       
        vm.participantName = vm.globalValues.getOrganisation().shortName;
        
        vm.todayDate = new Date();
       
      
        
  
   
        workflowSharedService.viewFrom = "uploadDownloadParticipantCertificate";
       
      
        logScreenAccess();
       // loadCurrentBusinessDate();
        
      
       function uploadCertificate() {
    	  
    	   if(vm.participantCode == 'CLEARCORP'){
    		   vm.code = 'APS';
    	   }
    	   else{
    		   vm.code = vm.participantCode;
    	   }
    	   var fd1 = new FormData();
    	   fd1.append('code', vm.code);
    	   fd1.append('certificate', vm.certificate);
    	   UploadDownloadParticipantCertificates.uploadCertificate(fd1, onUploadSuccess, onUploadFailure);
    	  
       }
       
       function onUploadSuccess(){
    	   angular.element("input[type='file']").val(null);
			 vm.certificate = null;
			 vm.inputFile = null;
			 vm.clicked = false;
       }
       
       function onUploadFailure(){
    	   angular.element("input[type='file']").val(null);
			 vm.certificate = null;
			 vm.inputFile = null;
			 vm.clicked = false;
       }
       
       function downloadCertificate() {
    	   var mimeType= '';
    	   var baseString =   'Server_Certificate_'+  moment().format( 'DD_MMM_YYYY_HH_mm') + '.cer';   
    	   UploadDownloadParticipantCertificates.downloadCertificate(function(result){
    		   
    		   if(result.data != null && result.data != undefined && result.data.byteLength != 0){
    			   
    			   vm.certificateFile = result.data;
				  
    	   			 
    				      var IEFile = new Blob([result.data], {type: mimeType});
    				      
    				     if(window.navigator.msSaveOrOpenBlob) {
    		                   window.navigator.msSaveOrOpenBlob(IEFile, baseString );
    		               }
    				      
    				      else{
    				    	  
    				    	  var link = document.createElement("a");   
    	    	   			  var bytes = new Uint8Array( vm.certificateFile );   
    	    	   			      			  
    	    				      var blob = new Blob([bytes], {type: mimeType});
    	    				      link.href =  window.URL.createObjectURL(blob);
    	    				      
    	    				      link.download = baseString;
    	        	   		   	  document.body.appendChild(link);
    	        	   		   	  link.click();
    	        	   			  document.body.removeChild(link);
    	    				      
    				      }
						  vm.clicked=false;
    				    
    		   }
    		   else{
    			   AlertService.error($filter('translate')('gatewayApp.uploadDownloadCertificates.fileNotExists'));
				   vm.clicked=false;
    		   }
    		  
   			  
   			 
    	   })
       }
        
       $scope.$watch('vm.certificate', function(value){
    	   if(vm.certificate != null && vm.certificate != undefined){
    		   if(vm.certificate.name != null && vm.certificate.name != undefined){
    			   
    			   vm.inputFile = vm.certificate.name;
    	    		 vm.fileExtension =  vm.inputFile.substring(vm.certificate.name.lastIndexOf(".") + 1);
    	    		 if(vm.fileExtension  != 'cer'){
    	    			 AlertService.error($filter('translate')('gatewayApp.uploadDownloadCertificates.invalidFile'));
    	    			 angular.element("input[type='file']").val(null);
    	    			 vm.certificate = null;
    	    			 vm.inputFile = null;
    	    		 }
    	    		 
    		   }
    		  
    	   }
       })
     
        	
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
     
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ParticipantCertificateDialogController', ParticipantCertificateDialogController);

    ParticipantCertificateDialogController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance',
    	'UploadDownloadParticipantCertificates','entity','DateUtils','Workflow','$filter'];

     function ParticipantCertificateDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance
    		 ,UploadDownloadParticipantCertificates,entity,DateUtils,Workflow, $filter) {
        var vm = this;
        vm.amcSetting=entity;   
        
        vm.clear=clear;
       
        vm.clicked=false;
        $scope.showButton = false;
        $scope.showApproveRejectButton=false;
        $scope.showDiscardButton = false;
    	$scope.showResubmitButton=false;
       
        vm.globalValues = GlobalValues;
        vm.discardCertificate = discardCertificate;
        vm.rejectCertificate= rejectCertificate;
        vm.approveCertificate= approveCertificate;
        vm.viewMode=false;
        
        vm.organisation = vm.globalValues.getOrganisation().organisationType.shortName;
       
        
        $scope.showButton = false;
        vm.orgId = vm.globalValues.getOrgId();
       
           
        if(workflowSharedService.viewFrom == 'participantCertificate'){
        	vm.certificate=entity;
        	vm.certificate.expiryDate = $filter('date')(vm.certificate.expiryDate, 'dd-MMM-yyyy');
        	vm.certificate.issueDate = $filter('date')(vm.certificate.issueDate, 'dd-MMM-yyyy');
        	$scope.showButton = true;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'participantCertificate_todolist_checker') {
        	vm.certificate =  angular.fromJson($rootScope.payload); 
        	vm.certificate.expiryDate = $filter('date')(vm.certificate.expiryDate, 'dd-MMM-yyyy');
        	vm.certificate.issueDate = $filter('date')(vm.certificate.issueDate, 'dd-MMM-yyyy');
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = true;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom == 'participantCertificate_todolist_maker') {
        	vm.certificate =  angular.fromJson($rootScope.payload); 
        	vm.certificate.expiryDate = $filter('date')(vm.certificate.expiryDate, 'dd-MMM-yyyy');
        	vm.certificate.issueDate = $filter('date')(vm.certificate.issueDate, 'dd-MMM-yyyy');
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = true;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom=='participantCertificate_auditlog'){
        	vm.certificate =  angular.fromJson($rootScope.payload); 
        	vm.certificate.expiryDate = $filter('date')(vm.certificate.expiryDate, 'dd-MMM-yyyy');
        	vm.certificate.issueDate = $filter('date')(vm.certificate.issueDate, 'dd-MMM-yyyy');
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
		

        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
      
        function approveCertificate() { 
        	UploadDownloadParticipantCertificates.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectCertificate() { Workflow.rejectTask($rootScope.taskID); }

        function discardCertificate() {
        	UploadDownloadParticipantCertificates.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }
        
        

       
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UploadDialogController', UploadDialogController);

    UploadDialogController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','UploadService','entity', 
    	'DateUtils', 'ScreenLog', 'Workflow','MessageBox','AlertService','$filter','entityConstants'];

     function UploadDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,UploadService,entity,
    		 DateUtils,ScreenLog,Workflow,MessageBox, AlertService, $filter, entityConstants) {
        var vm = this;
        vm.uploadData = [];
        vm.entity = entity;
        vm.screenName = 'MessageUpload';
        vm.screenLog = ScreenLog;
        vm.approve = approve;
        vm.reject = reject;
        vm.discard = discard;
        $scope.showButton = false;
        $scope.showDiscardButton = false;
        $scope.clicked=false;
        vm.globalValues = GlobalValues;
        vm.dataColumnSeperator = ",";
        vm.clear = clear;
        vm.alignmentArray = [];
        vm.rightAlignHeaderList = ['Bid Spread','Offer Spread'];

        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        
        if(workflowSharedService.viewFrom == 'messageuploadtodolist_checker') {
        	vm.entity = angular.fromJson($rootScope.payload); 
        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
        }
        else if(workflowSharedService.viewFrom == 'messageuploadtodolist_maker') {
        	vm.entity = angular.fromJson($rootScope.payload); 
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        }
        else if(workflowSharedService.viewFrom == 'messageuploadtodolist_auditLog') {
        	vm.entity = angular.fromJson($rootScope.payload); 
        	$scope.showButton=false;
        	$scope.showDiscardButton = false;
        }
        
        vm.businessDate = DateUtils.convertLocalDateFromServer(vm.entity.businessDate);
        if(vm.entity != null && vm.entity.fileContent != null){
            vm.uploadData = vm.entity.fileContent.replace('\r\n', '\n').split('\n');
            
            if(vm.uploadData != null && vm.uploadData.length > 0){
                vm.header = vm.uploadData[0];
                vm.uploadData.shift();
            	vm.messageType = vm.entity.shortName;	
            	var headerList = vm.header.split(',');
            	
            	angular.forEach(headerList, function(value,index) {
            			if(vm.rightAlignHeaderList.includes(value)){
            				vm.alignmentArray[index] = "right";
            			}
            			else{
            				vm.alignmentArray[index] = "left";
            			}
            		});
            }
            
            console.log(vm.header);
        }

        function approve() { 
        	if(   workflowSharedService.importType=='LimitSettings' ||  workflowSharedService.importType=='PendingOrderReport' ){
				if( workflowSharedService.importType == 'PendingOrderReport'){
					vm.screenLog.screenLog('PendingOrderReport', 0, entityConstants.ENTITY_ACTION_TYPE.APPROVE);
						//  MessageBox
						//  .showMessageBox(
						// 		 "Alert",
						// 		 "Cancel Order approval is still in progress... Please wait",
						// 		 "autocloseupload");
						UploadService.orderApprove({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);
					}else{
						UploadService.orderApproveImport({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);
					}
        	} else{
        		if( workflowSharedService.importType == 'HomeBranchIFSCUpload'){
                vm.screenLog.screenLog('HomeBranchIFSCUpload', 0, entityConstants.ENTITY_ACTION_TYPE.APPROVE);
        			 MessageBox
 					.showMessageBox(
 							"Alert",
 							"Home Branch Import approval is still in progress... Please wait",
 							"autocloseupload");
        		}
        		UploadService.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);   
        	}
        	      	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	if(   workflowSharedService.importType == 'HomeBranchIFSCUpload' 
			// ||  workflowSharedService.importType=='PendingOrderReport'
			){        			
   			 	MessageBox.closeMessageBox("autocloseupload");
        	}
        	if(workflowSharedService.importType!='PendingOrderReport' && result!="") {
        		exportException(result, true, 'Import' + '_error');
        	}else if(workflowSharedService.importType!='PendingOrderReport'){
        		//MessageBox.showMessageBox("Alert", " File has been uploaded successfully.  ", "Ok");
        		AlertService.success($filter('translate')('error.upload.success'));
        	}
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        
        function exportException(JSONData, showHeader, fileName) {

			if (JSONData != "") {
				var arrData = typeof (JSONData) != 'object' ? JSON
						.parse(JSONData) : JSONData;
						var out = arrData[arrData.length-1];
						if (out == "failure" || out == 1) {
							MessageBox.showMessageBox("Alert",
									"File upload failed! Please check the error log. ",
									"Ok");
							//generateFile(arrData,fileName);
						} 
						else if(out=="invalid"){
								MessageBox.showMessageBox("Alert",
										"Invalid file",
										"Ok");
							}
								else {
					MessageBox
							.showMessageBox(
									"Alert",
									"Partial success! Please check the error log for the failed records.  ",
									"Ok");
				}
						
				var csv = "";
				
				
				
				console.log(out);
				
				

				for (var i = 0; i <= arrData.length-2; i++) {

					var row = "";

					row += arrData[i];
					
					/*for ( var index in arrData[i]) {
						
					}
*/
					row = row.slice(0, row.length - 1);

					csv += row + '\r\n';

				}
				
				console.log(csv);

				if (csv != '') {
					//csv = 'test, test'
					var uri = 'data:text/csv;charset=UTF-8,' + escape(csv);

					var link = document.createElement("a");
					link.href = uri;

					link.style = 'hidden';
					link.download = fileName + '.csv';

					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

				}
			}

		}
        function onApproveError(error) {
        	if(   workflowSharedService.importType == 'HomeBranchIFSCUpload' 
		//	||  workflowSharedService.importType=='PendingOrderReport'
			){        			
   			 	MessageBox.closeMessageBox("autocloseupload");
        	}
        	$scope.clicked=false;
        }
       
        function reject() { Workflow.rejectTask($rootScope.taskID); }

        function discard() {
        	UploadService.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }
      
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        $rootScope.$on('gatewayApp.messagebox.clear.autocloseupload',function (event, data){
            //do nothing
        });

     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('upload-todolist', {
            parent: 'dashboard',
            url: '/uploadview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/upload/upload-dialog.html',
                    controller: 'UploadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('^');
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
            
        })
        
        .state('upload-todolist-auditLog', {
            parent: 'audit-log',
            url: '/uploadview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/upload/upload-dialog.html',
                    controller: 'UploadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('^');
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
            
        })
        
        .state('upload-todolist-historyReport', {
            parent: 'history-report',
            url: '/uploadview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/upload/upload-dialog.html',
                    controller: 'UploadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('^');
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
            
        })
        
      };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('UploadService', UploadService);

    UploadService.$inject = ['$resource'];

    function UploadService($resource) {
        var resourceUrl =  'api/upload/:id';

        return $resource(resourceUrl, {}, {
            'approve': {
                method: 'GET',
                isArray: true, 
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
              	 method: 'GET',
                   params: {taskId:'@taskId'},
                   url: 'api/tasks/:taskId/discard'
             },
             'orderApprove': {
                 method: 'GET',
                 isArray: false, 
                 params: {taskId:'@taskId'},
                 url: 'order/tasks/:taskId/approve'
             },
             'orderApproveImport': {
                method: 'GET', 
                isArray: 'true',
                params: {taskId:'@taskId'},
                url: 'order/tasks/:taskId/approve'
            }
        });
    }
})();

            

(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
		.state('transaction-charges-summary', {
			parent: 'entity',
			params:{screen: 'TransactionChargesSummary'},
			url: '/transaction-charges-summary',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'global.title'
			},
			ncyBreadcrumb: {
				label: '{{ "global.menu.transactionChargesSummary.main" | translate }}',
				parent: 'home'
			},
			views: {
				'content@': {
					templateUrl: 'app/entities/transaction-charges-summary/transaction-charges-summary.html',
					controller: 'TransactionChargesSummaryViewController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('transactionChargesSummary');
					$translatePartialLoader.addPart('error');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}],
				configSetting :['GlobalValues', function(GlobalValues) {
                    return GlobalValues.getConfigSettings();
                }],
                systemSettings: ['IntradayMarket', function(IntradayMarket) {
                    return IntradayMarket.getCurrentBusinessDate().$promise;
                }],
                previousSystemSettings:['TransactionChargesSummaryView',function(TransactionChargesSummaryView){
                	return TransactionChargesSummaryView.getPreviousBusinessDate().$promise;
                }],
				financialYears: ['StaticLookUp', function(StaticLookUp){
					return StaticLookUp.getPastAndPresentFinancialYears().$promise;
				}]

			}
		})   

	};
})();

(function() {
	'use strict';
	angular
	.module('gatewayApp')
	.factory('TransactionChargesSummaryView', TransactionChargesSummaryView);

	TransactionChargesSummaryView.$inject = ['$resource'];

	function TransactionChargesSummaryView ($resource) {
		var resourceUrl =  'api/transaction-charges-summary/:id';

		return $resource(resourceUrl, {}, {

			'getTransactionChargesSummaryReport':{          	 
				method: 'GET',
				params: {bankId : '@bankId',from : '@from', to: '@to',printorGenerateAfreshOption : '@printorGenerateAfreshOption'},  				
				url: 'api/transaction-charges-summary/get-transaction-charges-summary-details'
			},
			'exportTransactionChargesSummaryExcel':{
				method: 'POST',
				url: 'api/transaction-charges-summary/excel-download',
				responseType: 'arraybuffer',
				params: {freshOrPrintOption : '@freshOrPrintOption', bank : '@bank'},
				transformRequest: function (data) {
	                   	var copy = angular.copy(data);
	                   	
	                       return angular.toJson(copy);
	            },
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			},
			'downloadEInvoiceExcel':{
				method: 'POST',
				url: 'api/transaction-charges-summary/eInvoice-download',
				responseType: 'arraybuffer',
				params: {from : '@from', to: '@to',financialYearId : '@financialYearId'},
				transformRequest: function (data) {
	                   	var copy = angular.copy(data);
	                   	
	                       return angular.toJson(copy);
	            },
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			},
			'exportTransactionChargesSummaryCsv':{
				method: 'POST',
				url: 'api/transaction-charges-summary/csv-download',
				responseType: 'arraybuffer',
				params: {freshOrPrintOption : '@freshOrPrintOption', bank : '@bank'},
				transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
            },
			transformResponse: function(data, headers) {
				return {
					data: data,
					headers: headers
				};   
			}         
			},
			'exportTransactionChargesSummaryPdf':{
				method: 'POST',
				url: 'api/transaction-charges-summary/pdf-download',
				responseType: 'arraybuffer',
				params: {freshOrPrintOption : '@freshOrPrintOption', bank : '@bank'},
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			},
			'getPreviousBusinessDate':{
				method: 'GET',  
                url: 'api/get-previous-business-date',
                transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			}
			
		
		});
	}
})();

(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.service("workflowSharedService", function () {        	
		this.viewFrom= 'transactionChargesSummaryView'
	})

	.controller('TransactionChargesSummaryViewController', TransactionChargesSummaryViewController);

	TransactionChargesSummaryViewController.$inject = ['$scope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
		'DateUtils','AlertService','$filter',   'TransactionChargesSummaryView','systemSettings','configSetting','previousSystemSettings','financialYears'];

	function TransactionChargesSummaryViewController($scope, $state,  GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
			DateUtils,AlertService,$filter,  TransactionChargesSummaryView,systemSettings,configSetting,previousSystemSettings,financialYears) {
		var vm = this;
		vm.entityConstants = entityConstants;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.TRANSACTION_CHARGES_SUMMARY_VIEW;
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;

		$scope.noOfRecordsPerPageSummary = angular.copy($scope.noOfRecordsPerPage);
		$scope.pageSummary = 1;

		vm.globalValues=GlobalValues;
		vm.screenLog = ScreenLog;
		vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
		vm.configSettings = configSetting;
		vm.noOFMonthsToDisplayForReports = vm.configSettings.noOfMOnthsForHistoricalReportsView;
		vm.freshOrPrintOption = 'PrintGeneratedInvoice';
		vm.getTransactionChargesSummary = getTransactionChargesSummary;
		vm.exportDataToFile = exportDataToFile;
		vm.setDefaultValue = setDefaultValue;
		vm.getTransactionChargesSummaryDetails = getTransactionChargesSummaryDetails;
		vm.loadFinancialMonthOption = loadFinancialMonthOption;
		vm.clearAllValues = clearAllValues;
		vm.downloadEInvoice = downloadEInvoice;
		vm.filterData = {};
		vm.TransactionChargesfileName = "Transaction_Charges_Summary_Report_";
		vm.eInvoiceChargesfileName = "e-Invoice_";
		vm.fileName = vm.TransactionChargesfileName;
		vm.extension = "";
		vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
		vm.firstTimeLoad = null;
		vm.financialMonth = {};
		vm.previousFiancialMonthOptions = [];
		vm.transactionChargesSummarySelected = [];
		vm.transactionChargesSummaryDetails = null;
		vm.selectedBankName = "";
		vm.showDownloadEInvoice = false;
		vm.financialYear = vm.globalValues.getFinancialYear();
		vm.financialYearList=financialYears;
		logScreenAccess();
		vm.valid = false;
		vm.issuePresent = false;
		vm.clicked=false;

		if(vm.configSettings != null && vm.configSettings != undefined && vm.configSettings.noOfMOnthsForHistoricalReportsView != null && vm.configSettings.noOfMOnthsForHistoricalReportsView != undefined && !isNaN(vm.configSettings.noOfMOnthsForHistoricalReportsView)){
			vm.noOFMonthsToDisplayForReports = vm.configSettings.noOfMOnthsForHistoricalReportsView;
		}
		else{
			vm.noOFMonthsToDisplayForReports = 10;
		}

		if(systemSettings != null && systemSettings != undefined && previousSystemSettings != null && previousSystemSettings != undefined){
			vm.currentBusinessDate = systemSettings.businessDate;
			vm.previousBusinessDate = previousSystemSettings.businessDate;
			vm.currentBusinessDateMoment = moment(DateUtils.convertLocalDateFromServer(angular.copy(vm.currentBusinessDate)));
			vm.previousBusinessDateMoment = moment(DateUtils.convertLocalDateFromServer(angular.copy(vm.previousBusinessDate)));
			vm.minDate =  angular.copy(vm.currentBusinessDateMoment).subtract(vm.noOFMonthsToDisplayForReports,'months').startOf('month').toDate();		
			loadFinancialMonthOption();
			setDefaultValue(vm.freshOrPrintOption);
		}


		function getTransactionChargesSummary(){
			vm.transactionChargesSummaryDetails = [];
			vm.transactionChargesSummarySelected = [];
			vm.valid = true;
			vm.eInvoiceDisable = false;
			vm.bankId = 0;
			if(vm.freshOrPrintOption == 'PrintGeneratedInvoice'&& (vm.bank==null || vm.bank== undefined|| vm.bank=='')){
				vm.showDownloadEInvoice = true;
			}else{
				vm.showDownloadEInvoice = false;
			}

			if(vm.bank!=null && vm.bank !=undefined){
				vm.bankId = angular.copy(vm.bank.id);
			}

			if(moment(vm.minDate).isAfter(vm.fromDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.transactionChargesSummary.fromDateLesserThanMinDate'));
				vm.valid = false;
				vm.issuePresent = true;
			}else if(moment(vm.maxDate).isBefore(vm.fromDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.transactionChargesSummary.fromDateGreaterMaxDate'));
				vm.valid = false;
				vm.issuePresent = true;
			}
			else if(moment(vm.toDate).isAfter(vm.maxDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.transactionChargesSummary.toDateGreaterMaxDate'));
				vm.valid = false;
				vm.issuePresent = true;
			}
			else if(moment(vm.minDate).isAfter(vm.toDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.transactionChargesSummary.toDateLesserThanMinDate'));
				vm.valid = false;
				vm.issuePresent = true;
			}
			else if(moment(vm.fromDate).isAfter(vm.toDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.transactionChargesSummary.fromDateGreaterThanToDate'));
				vm.valid = false;
				vm.issuePresent = true;
			}
			else if(vm.fromDate.getMonth() != vm.toDate.getMonth()){
				AlertService.error($filter('translate')('gatewayApp.transactionChargesSummary.fromToNotSameMonth'));
				vm.valid = false;
				vm.issuePresent = true;
			}
			else{
				vm.issuePresent = false;
				vm.valid = true;
				vm.clicked=true;
				if(vm.bank != null && vm.bank != undefined){
					vm.selectedBankName = vm.bank.bankName;
				}else{
					vm.selectedBankName = '--All--';
				}
				vm.selectedPrintorRefresh = angular.copy(vm.freshOrPrintOption);
				clearAllValues();
				TransactionChargesSummaryView.getTransactionChargesSummaryReport({ bankId : vm.bankId,from : DateUtils.convertLocalDateToServer(vm.fromDate), to: DateUtils.convertLocalDateToServer(vm.toDate),printorGenerateAfreshOption : vm.selectedPrintorRefresh}, 
						onGetTransactionChargesSummarySuccess, onGetTransactionChargesSummaryFailure);  		
			}
			

		}
		function onGetTransactionChargesSummarySuccess(result){
			vm.transactionChargesSummaryDetails = result;
			vm.clicked=false;
		}
		function onGetTransactionChargesSummaryFailure(error){
			vm.clicked=false;
		}

		function logScreenAccess(){
			ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}

		//this method is used to set default value to both the from and to date or financial month
		function setDefaultValue(value){

			if(value == 'PrintGeneratedInvoice'){
				vm.maxDate =  angular.copy(vm.previousBusinessDateMoment).endOf('month').toDate();//previous bdate
				vm.financialMonth = angular.copy(vm.previousFiancialMonthOptions[0]);
				vm.fromDate = angular.copy( vm.financialMonth.date).toDate();
				vm.toDate =angular.copy( vm.financialMonth.date).endOf('month').toDate();
				
				//vm.minToDate = angular.copy(vm.financialMonth.date).toDate();
				//vm.maxToDate =  angular.copy(vm.toDate);		

			}else if(value == 'GenerateAfresh'){
				vm.maxDate =  angular.copy(vm.previousBusinessDateMoment).toDate();//previous bdate
				vm.fromDate = angular.copy(vm.previousBusinessDateMoment).startOf('month').toDate();//prev
				vm.toDate =  angular.copy(vm.previousBusinessDateMoment).toDate();//prev
				
				//vm.minToDate = angular.copy(vm.fromDate);
				//vm.maxToDate =  angular.copy(vm.previousBusinessDateMoment).toDate();//prev
				
				

			}
			
		}

		function loadFinancialMonthOption(){
			vm.previousFiancialMonthOptions = [];
			if(vm.configSettings.billingEndDate!=null && vm.configSettings.billingEndDate !=""){
				vm.previousFiancialMonthOptions.push(createMonthOptions(angular.copy(vm.currentBusinessDateMoment)));	//temporary
			}	
			var monthCount =1;
			for(monthCount =1; monthCount <= vm.noOFMonthsToDisplayForReports ;monthCount++) {
				vm.previousFiancialMonthOptions.push(createMonthOptions(angular.copy(vm.currentBusinessDateMoment).subtract(monthCount,'month')))
			}

		}

		vm.createMonthOptions = createMonthOptions;
		function createMonthOptions(dateMoment){
			var currentMonthOption = {}
			currentMonthOption.date =  angular.copy(dateMoment).startOf('month');
			currentMonthOption.monthDisplay = dateMoment.format('MMM - YYYY');
			return currentMonthOption;

		}
		vm.onFinacialMonthSelection = onFinacialMonthSelection;
		function onFinacialMonthSelection(value){
			var monthSelected = value.date; 
			vm.fromDate = angular.copy(monthSelected).toDate();
			vm.toDate  = angular.copy(monthSelected).endOf('month').toDate();
			loadFinancialYearDisplay(vm.fromDate)
			//vm.minToDate = angular.copy(vm.financialMonth.date).toDate();
			//vm.maxToDate =  angular.copy(vm.toDate);

		}
       
 		function downloadEInvoice(){
			vm.mimeType = 'application/vnd.ms-excel';
			vm.extension = ".xls"; 
			vm.fileName = vm.eInvoiceChargesfileName;
		 TransactionChargesSummaryView.downloadEInvoiceExcel({ from : DateUtils.convertLocalDateToServer(vm.fromDate), to: DateUtils.convertLocalDateToServer(vm.toDate),financialYearId :vm.financialYear.id}, processResponse );


         }

		 function loadFinancialYearDisplay(value){
			var yearCount = 0;
			if(vm.financialYearList != null && vm.financialYearList != undefined){
				for(yearCount = 0;yearCount < vm.financialYearList.length; yearCount++){
					var fromYear =  moment(DateUtils.convertLocalDateFromServer(angular.copy(vm.financialYearList[yearCount].financialYearStart)));
					var toYear = moment(DateUtils.convertLocalDateFromServer(angular.copy(vm.financialYearList[yearCount].financialYearEnd))); 
					var financialMonth= moment(angular.copy(value)); 
					if( fromYear.isBefore(financialMonth)&&toYear.isAfter(financialMonth)){
						vm.financialYear=vm.financialYearList[yearCount];
						
					}else{
						vm.financialYear=vm.globalValues.getFinancialYear();
					}
				
			}
		}
	}

		//dowmload button
		//show condition when banck field is empty and option is print generate invoice
		// api call - get excel 
		// byte array convert to excel file
	

		function exportDataToFile(fileType){
			vm.fileName = vm.TransactionChargesfileName;
			if( vm.transactionChargesSummaryDetails !=null &&  vm.transactionChargesSummaryDetails != undefined && vm.transactionChargesSummaryDetails.headerList.length > 0){
				if(fileType == 'csv'){
					vm.mimeType = 'text/csv';
					vm.extension =  ".csv";  
					TransactionChargesSummaryView.exportTransactionChargesSummaryCsv({freshOrPrintOption:vm.selectedPrintorRefresh,bank:vm.selectedBankName },vm.transactionChargesSummaryDetails, processResponse );
				}
				else if(fileType == 'xls'){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.extension = ".xls";  
					TransactionChargesSummaryView.exportTransactionChargesSummaryExcel({freshOrPrintOption:vm.selectedPrintorRefresh,bank:vm.selectedBankName },vm.transactionChargesSummaryDetails, processResponse );
				}
				else if(fileType == 'pdf'){
					vm.mimeType = 'application/pdf';
					vm.extension = ".pdf";  
					TransactionChargesSummaryView.exportTransactionChargesSummaryPdf({freshOrPrintOption:vm.selectedPrintorRefresh,bank:vm.selectedBankName },vm.transactionChargesSummaryDetails , processResponse );
				}

			}
		}

		function processResponse(result){        	  
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
			vm.baseString =   vm.fileName + moment().format( vm.reportFileTimestampFormat ) +  vm.extension; 

			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}

		

		$scope.$watch('vm.fromDate',function(value){
			if(value!= undefined && value!=null && (vm.firstTimeLoad != null && vm.firstTimeLoad != undefined)){
				
				if(vm.freshOrPrintOption == 'PrintGeneratedInvoice'){					
					//vm.maxToDate =   moment(angular.copy(value)).endOf('month').toDate();
					//vm.minToDate = angular.copy(value);
					vm.toDate = moment(angular.copy(value)).endOf('month').toDate();
				}else{
					
					if(!moment(value).isAfter(vm.maxDate) && !moment(value).isBefore(vm.minDate)){
						if(vm.previousBusinessDateMoment.isAfter(moment(angular.copy(value)).endOf('month'))){
							
							//vm.maxToDate =  moment(angular.copy(value)).endOf('month').toDate();
							//vm.minToDate = angular.copy(value);
							vm.toDate = new Date (moment(angular.copy(value)).endOf('month').toDate());
							
						}else{
							
							//vm.maxToDate = angular.copy(vm.previousBusinessDateMoment).toDate();
							//vm.minToDate = angular.copy(vm.previousBusinessDateMoment).startOf('month').toDate();
							vm.toDate = new Date(angular.copy(vm.previousBusinessDateMoment).toDate());
							
						}
					}
				}

			}
			vm.eInvoiceDisable = true;
			vm.firstTimeLoad = 'No';
		});

		$scope.$watch('vm.freshOrPrintOption',function(value){
			if(value!= undefined && value!=null ){
				setDefaultValue(value);
				
			}
		
		});
		
		$scope.$watch('vm.financialMonth',function(value){
			if(value!= undefined && value!=null ){
				onFinacialMonthSelection(value);
			}
		
		});
		
		function clearAllValues(){
			vm.transactionChargesSummaryDetails = null;
			vm.transactionChargesSummarySelected = [];
			$scope.filterText = null;
			$scope.filterTextSummary = null;
		}
		


		function getTransactionChargesSummaryDetails(transactionChargesDetails){
			vm.transactionChargesSummarySelected = vm.transactionChargesSummaryDetails.bankWiseCustomerDetails[transactionChargesDetails.bankChargesDTO.bankName];
			vm.transactionChargesSummaryCharges = vm.transactionChargesSummaryDetails.detailsListGrandTotalCharges[transactionChargesDetails.bankChargesDTO.bankName];

		}
	}
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TransactionChargesSettingsDialogController', TransactionChargesSettingsDialogController);

    TransactionChargesSettingsDialogController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues',
    	'workflowSharedService','$uibModalInstance','TransactionChargesSettings','entity','DateUtils','Workflow', 'AlertService', '$filter'];

     function TransactionChargesSettingsDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService, 
    		 $uibModalInstance,TransactionChargesSettings,entity,DateUtils,Workflow, AlertService, $filter) {
        var vm = this;
        vm.transactionCharges=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        $scope.showApproveRejectButton=false;
        $scope.showDiscardButton = false;
    	$scope.showResubmitButton=false;
        vm.resubmitCharges = resubmitCharges;
        vm.globalValues = GlobalValues;
        vm.discardCharges = discardCharges;
        vm.rejectCharges= rejectCharges;
        vm.approveCharges= approveCharges;
        vm.viewMode=false;
        vm.showEffectiveFrom=false;
        vm.addCharges = addCharges;
        vm.editCharges = editCharges;
        vm.removeCharges = removeCharges;
        vm.resetCharges = resetCharges;
        vm.noOfDecimals = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.noOfDecimalsForPercent = 4;
        
        $scope.showButton = false;
        vm.orgId = vm.globalValues.getOrgId();
        vm.transactionChargesDetailsList = [];
        vm.noOfDecimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.newTransactionCharges = { minimumTradedValue : 0.01, maximumTradedValue : null, charges : null, editable : true, valid: false}
        
        if(workflowSharedService.viewFrom == 'transactionChargesSettings'){
    		vm.transactionChargesDetailsList.push(angular.copy(vm.newTransactionCharges));
			if (entity != null && entity != undefined && entity.transactionChargesDetailsList != null && entity.transactionChargesDetailsList != undefined
					&& entity.transactionChargesDetailsList.length > 0) {
				vm.transactionCharges = entity;
				setValidForExistingChargesSlabs();
				prepareNewTransactionCharge(vm.transactionCharges.transactionChargesDetailsList);
				vm.transactionCharges.transactionChargesDetailsList.push(angular.copy(vm.newTransactionCharges));
				vm.transactionChargesDetailsList = angular.copy(vm.transactionCharges.transactionChargesDetailsList);
			}
        	$scope.showButton = true;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	vm.viewMode=false;
        	$scope.DisabledControl = false;
        }
        else if(workflowSharedService.viewFrom == 'transactionChargesSettingstodolist_resubmit') {
        	vm.transactionCharges = angular.copy( angular.fromJson($rootScope.payload));
        	setValidForExistingChargesSlabs();
        	prepareNewTransactionCharge(vm.transactionCharges.transactionChargesDetailsList);
        	vm.transactionCharges.transactionChargesDetailsList.push(angular.copy(vm.newTransactionCharges));
        	vm.transactionChargesDetailsList = angular.copy(vm.transactionCharges.transactionChargesDetailsList);
        	
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=true;
        	vm.viewMode=false;
        	$scope.DisabledControl = false;
        }
        else if(workflowSharedService.viewFrom == 'transactionChargesSettingstodolist_resubmit_delete') {
        	vm.transactionCharges = angular.copy( angular.fromJson($rootScope.payload));
        	
        	vm.transactionChargesDetailsList = angular.copy(vm.transactionCharges.transactionChargesDetailsList);
        	
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=true;
        	vm.viewMode=true;
        	$scope.DisabledControl = true;
        }
        else if(workflowSharedService.viewFrom == 'transactionChargesSettings_todolist_checker') {
        	vm.transactionCharges =  angular.fromJson($rootScope.payload); 
        	vm.transactionChargesDetailsList = angular.copy(vm.transactionCharges.transactionChargesDetailsList);
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = true;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	$scope.DisabledControl = true;
        }
        else if(workflowSharedService.viewFrom == 'transactionChargesSettings_todolist_maker') {
        	vm.transactionCharges =  angular.fromJson($rootScope.payload); 
        	vm.transactionChargesDetailsList = angular.copy(vm.transactionCharges.transactionChargesDetailsList);
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = true;
        	$scope.showResubmitButton=false;
        	$scope.DisabledControl = true;
        }
        else if(workflowSharedService.viewFrom=='transactionChargesSettings_auditlog'){
        	vm.transactionCharges =  angular.fromJson($rootScope.payload); 
        	vm.transactionChargesDetailsList = angular.copy(vm.transactionCharges.transactionChargesDetailsList);
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	$scope.DisabledControl = true;

        }
        
        //prepare new charge slab to enter. getting maximum transaction charges from the last slab and assigned it to minimum transaction charges of new slab
		function prepareNewTransactionCharge(transactionChargesDetailsList){
			if(transactionChargesDetailsList.length>0){
				var lastSlab = transactionChargesDetailsList[transactionChargesDetailsList.length-1];
				if(lastSlab!=null && lastSlab!=undefined){
					vm.newTransactionCharges.minimumTradedValue = Number(lastSlab.maximumTradedValue) + Number(0.01);
				}
			}
		}
		
		function setValidForExistingChargesSlabs(){
			angular.forEach(vm.transactionCharges.transactionChargesDetailsList, function(value,index){
				value.valid =true;
			})
		}
        
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	vm.transactionChargesDetailsList = getValidObject(vm.transactionChargesDetailsList);
        	if($scope.errorMsg!=''){
   				AlertService.error($filter('translate')($scope.errorMsg));
        	}else{
	        	vm.transactionCharges.transactionChargesDetailsList = vm.transactionChargesDetailsList;
	        	vm.transactionCharges.transactionChargesDetailsList = $filter('orderBy')(vm.transactionCharges.transactionChargesDetailsList, 'minimumTradedValue');
	        	if (vm.transactionCharges.id != null) {
	        		TransactionChargesSettings.update({
						"orgId" : GlobalValues.getOrgId()
					}, vm.transactionCharges, onSaveSuccess, onSaveError);
				} else {
					TransactionChargesSettings.save({
						"orgId" : GlobalValues.getOrgId()
					}, vm.transactionCharges, onSaveSuccess, onSaveError);
				}
        	}
         }
      
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
      
        function onSaveError () {
        	prepareNewTransactionCharge(vm.transactionChargesDetailsList);
			vm.transactionChargesDetailsList.push(angular.copy(vm.newTransactionCharges));
        	vm.clicked = false;
        }

        function resubmitCharges() {
        	vm.transactionChargesDetailsList = getValidObject(vm.transactionChargesDetailsList);
        	vm.transactionCharges.transactionChargesDetailsList = vm.transactionChargesDetailsList;
        
        	TransactionChargesSettings.resubmit({"taskId" : $rootScope.taskID}, vm.transactionCharges, onResubmitSuccess, onResubmitError);
       		
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        

        function onResubmitError(error) {
        	prepareNewTransactionCharge(vm.transactionChargesDetailsList);
			vm.transactionChargesDetailsList.push(angular.copy(vm.newTransactionCharges));
        	vm.clicked = false;
        }
        
        function approveCharges() { 
        	TransactionChargesSettings.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        

        function onApproveError(error) {
        	
        }
       
        function rejectCharges() { Workflow.rejectTask($rootScope.taskID); }

        function discardCharges() {
        	TransactionChargesSettings.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        

        function onDiscardError(error) {
        	
        }
        
        function addCharges(index){
        	$scope.errorMessage = '';
        	
        	$scope.errorMessage = validateList(index);
    		if($scope.errorMessage == ''){
        		vm.transactionChargesDetailsList[index].editable = false;
        		vm.transactionChargesDetailsList[index].valid = true;
        		vm.transactionChargesDetailsList[index].maximumTradedValue = (Math.round(parseFloat(vm.transactionChargesDetailsList[index].maximumTradedValue) * 10000)/10000)
        		vm.transactionChargesDetailsList[index].minimumTradedValue = (Math.round(parseFloat(vm.transactionChargesDetailsList[index].minimumTradedValue) * 10000)/10000)
            	if(vm.transactionChargesDetailsList[index+ 1] != null && vm.transactionChargesDetailsList[index+ 1] != undefined){
            		vm.transactionChargesDetailsList[index+ 1].minimumTradedValue = Number(vm.transactionChargesDetailsList[index].maximumTradedValue) + Number(0.01);
    			}
        		prepareNewTransactionCharge(vm.transactionChargesDetailsList);
				vm.transactionChargesDetailsList.push(angular.copy(vm.newTransactionCharges));
    		}
   			else{
   				vm.transactionChargesDetailsList[index].valid = false;
   				//AlertService.error($filter('translate')(errorMessage));
   				$scope.errorMessage = $filter('translate')($scope.errorMessage);
   			}
        	
        }
        
        function editCharges(editIndex){
        	
        	angular.forEach(vm.transactionChargesDetailsList, function(value, index){
        		
        		if(angular.equals(value, vm.newTransactionCharges) && vm.transactionChargesDetailsList.length>1){
        			vm.transactionChargesDetailsList.splice(index, 1);
        		}
        		
        		if(!value.valid && vm.transactionChargesDetailsList.length>1){
        			vm.transactionChargesDetailsList.splice(index, 1);
        		}
        		
        		value.editable = false;
        		
        		if(index>0 && index == vm.transactionChargesDetailsList.length -1){
        			
        				vm.transactionChargesDetailsList.splice(index,1);
        			
        		}
        		
        	})
        	
        	if(vm.transactionChargesDetailsList[editIndex] != null && vm.transactionChargesDetailsList[editIndex] != undefined)
        		vm.transactionChargesDetailsList[editIndex].editable = true;
        }
        
        function removeCharges(index){
        	if(vm.transactionChargesDetailsList[index+ 1] != null && vm.transactionChargesDetailsList[index+ 1] != undefined){
        		if(index==0){
        			vm.transactionChargesDetailsList[index+ 1].minimumTradedValue = Number('0.01');
        		}else{
        			vm.transactionChargesDetailsList[index+ 1].minimumTradedValue = Number(vm.transactionChargesDetailsList[index-1].maximumTradedValue) + Number(0.01);
        		}
			}
        	vm.transactionChargesDetailsList.splice(index, 1);
        }
        
        function resetCharges(index){
        	var maxValueCtrl = "txtMaxValue_" + index;
        	var chargesCtrl = "txtCharges_" + index;
        	document.getElementById(maxValueCtrl).value = "";
        	vm.transactionChargesDetailsList[index].maximumTradedValue = null;
        	document.getElementById(chargesCtrl).value = "";
        	vm.transactionChargesDetailsList[index].charges = null;
        	vm.transactionChargesDetailsList[index].valid = false;
        }
        
        
        function getValidObject(transactionChargesDetails) {
        	$scope.errorMsg = '';
        	angular.forEach(transactionChargesDetails, function(value,index) {
				if (angular.equals(value, vm.newTransactionCharges)) {
					transactionChargesDetails.splice(index, 1);

				} else if (value.editable == true) {
					if(vm.transactionChargesDetailsList[index].maximumTradedValue!=null && vm.transactionChargesDetailsList[index].charges!=null){
						$scope.errorMsg = 'gatewayApp.transactionChargesSettings.incompleteSlab';
						vm.clicked = false;
					}else{
						if(vm.transactionChargesDetailsList[index+ 1] != null && vm.transactionChargesDetailsList[index+ 1] != undefined){
	                		if(index==0){
	                			vm.transactionChargesDetailsList[index+ 1].minimumTradedValue = Number('0.01');
	                		}else{
	                			vm.transactionChargesDetailsList[index+ 1].minimumTradedValue = Number(vm.transactionChargesDetailsList[index-1].maximumTradedValue) + Number(0.01);
	                		}
	        			}
						transactionChargesDetails.splice(index, 1);
					}
				}
				
			});

			vm.transactionChargesDetailsList = transactionChargesDetails;

			return vm.transactionChargesDetailsList;
		}

        
        function validateList(index){
        	
        	if(Number(vm.transactionChargesDetailsList[index].minimumTradedValue) > Number(vm.transactionChargesDetailsList[index].maximumTradedValue) 
        			|| vm.transactionChargesDetailsList[index].maximumTradedValue=='' || vm.transactionChargesDetailsList[index].maximumTradedValue==undefined){
				
    			//AlertService.error($filter('translate')('gatewayApp.transactionChargesSettings.maxLessThanMin'));
    			return 'gatewayApp.transactionChargesSettings.maxLessThanMin';
			}
			
			else if(vm.transactionChargesDetailsList[index-1] != null && vm.transactionChargesDetailsList[index-1] != undefined
					&& Number(vm.transactionChargesDetailsList[index].minimumTradedValue)
					<= Number(vm.transactionChargesDetailsList[index-1].maximumTradedValue)){
				
				//AlertService.error($filter('translate')('gatewayApp.transactionChargesSettings.greaterMin'));
				return 'gatewayApp.transactionChargesSettings.greaterMin';
			}
        	
			else if(vm.transactionChargesDetailsList[index+ 1] != null && vm.transactionChargesDetailsList[index+ 1] != undefined
					&& Number(vm.transactionChargesDetailsList[index].maximumTradedValue)
					>= Number(vm.transactionChargesDetailsList[index+ 1].maximumTradedValue)){
			//	AlertService.error($filter('translate')('gatewayApp.transactionChargesSettings.greaterMax'));
				return 'gatewayApp.transactionChargesSettings.greaterMax';
			}
			else if(vm.transactionChargesDetailsList[index+ 1] != null && vm.transactionChargesDetailsList[index+ 1] != undefined
					&& Number(vm.transactionChargesDetailsList[index].maximumTradedValue)
					> Number(vm.transactionChargesDetailsList[index+ 1].minimumTradedValue)){
			//	AlertService.error($filter('translate')('gatewayApp.transactionChargesSettings.greaterMax'));
				//return 'gatewayApp.transactionChargesSettings.greaterMax';
				vm.transactionChargesDetailsList[index+ 1].minimumTradedValue = vm.transactionChargesDetailsList[index].maximumTradedValue;
			}
			else if(vm.transactionChargesDetailsList[index+ 1] != null && vm.transactionChargesDetailsList[index+ 1] != undefined){
				vm.transactionChargesDetailsList[index+ 1].minimumTradedValue = vm.transactionChargesDetailsList[index].maximumTradedValue;
			}
        	return '';
        }
       
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TransactionChargesSettingsDeleteController',TransactionChargesSettingsDeleteController);

    TransactionChargesSettingsDeleteController.$inject = ['$uibModalInstance', 'entity', 'TransactionChargesSettings', 'GlobalValues','$scope'];

    function TransactionChargesSettingsDeleteController($uibModalInstance, entity, TransactionChargesSettings, GlobalValues,$scope) {
        var vm = this;

        vm.transactionCharges = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        $scope.clicked=false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        
        function confirmDelete (id) {
        	TransactionChargesSettings.delete({"orgId": GlobalValues.getOrgId(),"id":id},
                    function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('transaction-charges-settings', {
            parent: 'entity',
            url: '/transaction-charges-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.transactionChargesSettings.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings.html',
                    controller: 'TransactionChargesSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('transactionChargesSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('transaction-charges-settings-new', {
            parent: 'transaction-charges-settings',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings-dialog.html',
                    controller: 'TransactionChargesSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	 id:null,  
                            	name:null                            	
                             
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('transaction-charges-settings', null, { reload: 'transaction-charges-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('transaction-charges-settings-edit', {
            parent: 'transaction-charges-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings-dialog.html',
                    controller: 'TransactionChargesSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['TransactionChargesSettings', 'GlobalValues', function(TransactionChargesSettings, GlobalValues) {
                                     return TransactionChargesSettings.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('transaction-charges-settings-delete', {
            parent: 'transaction-charges-settings',
            url: '/delete/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings-delete-dialog.html',
                    controller: 'TransactionChargesSettingsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TransactionChargesSettings', 'GlobalValues', function(TransactionChargesSettings, GlobalValues) {
                            return TransactionChargesSettings.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    //$state.go('^', null, { reload: true });
                	$state.go('transaction-charges-settings', null, { reload: 'transaction-charges-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('transaction-charges-settings-todolist', {
            parent: 'dashboard',
            url: '/transactionChargesSettingsToDo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings-dialog.html',
                    controller: 'TransactionChargesSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('transaction-charges-settings', null, { reload: 'transaction-charges-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('transaction-charges-settings-todolist-resubmit', {
            parent: 'dashboard',
            url: '/transactionChargesSettingsResubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings-dialog.html',
                    controller: 'TransactionChargesSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('transaction-charges-settings', null, { reload: 'transaction-charges-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        .state('transaction-charges-settings-auditLog', {
            parent: 'audit-log',
            url: '/transactionChargesSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings-dialog.html',
                    controller: 'TransactionChargesSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('transaction-charges-settings', null, { reload: 'transaction-charges-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
          .state('transaction-charges-settings-historyReport', {
            parent: 'history-report',
            url: '/transactionChargesSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-charges-settings/transaction-charges-settings-dialog.html',
                    controller: 'TransactionChargesSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('transaction-charges-settings', null, { reload: 'transaction-charges-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
        
        
         };
    })();

(function() {
	'use strict';
	angular.module('gatewayApp').factory('TransactionChargesSettings', TransactionChargesSettings);

	TransactionChargesSettings.$inject = [ '$resource' ];

	function TransactionChargesSettings($resource) {
		var resourceUrl = 'api/transaction-charges-settings/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				url: 'api/all-transaction-charges-settings',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},

			

			'save' : {
				method : 'POST',
				params : {
					orgId : '@orgId'
				},
				url : 'api/transaction-charges-settings/orgId/:orgId',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'update' : {
				method : 'PUT',
				params : {
					orgId : '@orgId'
				},
				url : 'api/transaction-charges-settings/orgId/:orgId',
				transformRequest : function(data) {
					var copy = angular.copy(data);

					return angular.toJson(copy);
				}
			},
			'delete' : {
				method : 'DELETE',
				params : {
					orgId : '@orgId',
					id : '@id'
				},
				url : 'api/transaction-charges/:orgId/:id'
			},

			'approve' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/approve'
			},
			'reject' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/reject'
			},
			'discard' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/discard'
			},
			
			'resubmit' : {
				method : 'PUT',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/resubmitForCreate/transaction-charges',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'resubmitForEdit' : {
				method : 'PUT',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/resubmitForEdit/transaction-charges',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			}
		

		});
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'transactionChargesSettings'
        })
        
        .controller('TransactionChargesSettingsController', TransactionChargesSettingsController);

    TransactionChargesSettingsController.$inject = ['$scope', '$state', 'TransactionChargesSettings', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout'];

    function TransactionChargesSettingsController($scope, $state, TransactionChargesSettings , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout) {
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.TRANSACTION_CHARGES;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "transactionChargesSettings";
        vm.bank = GlobalValues.getBank();
        $scope.refresh=refresh;
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.noOfDecimalsForPercent = 4;
        
        vm.launch=launch;
        function launch() {
        	$state.go("transaction-charges-settings-new");
        }
        
        
        vm.permitTransactionChargesAddEntityAction = EntityPermissions.hasPermission('TransactionChargesSettings.CREATE');
        vm.permitTransactionChargesDeleteEntityAction = EntityPermissions.hasPermission('TransactionChargesSettings.DELETE');
        vm.permitTransactionChargesEditEntityAction = EntityPermissions.hasPermission('TransactionChargesSettings.EDIT');
        vm.permitTransactionChargesImportEntityAction = EntityPermissions.hasPermission('TransactionChargesSettings.IMPORT');
        
        logScreenAccess();
        loadAll();

       function loadAll() {
    	   
    	   TransactionChargesSettings.query(getTransactionChargesSuccess, getTransactionChargesFailure);
    	 
        }      
       
       function getTransactionChargesSuccess(result){
    	   vm.transactionChargesHeaderList = result;
    	   vm.transactionCharges=[];
    	   
    	   angular.forEach(vm.transactionChargesHeaderList, function(value){
    		   angular.forEach(value.transactionChargesDetailsList, function(detail){
    			   vm.details = angular.copy(detail);
    			   vm.details.transactionChargesSlabHeader = value;
    			   vm.transactionCharges.push(vm.details);
    		   })
    		  
    	   })
       }
       
       function getTransactionChargesFailure(){}
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('transaction-charges', {
            parent: 'entity',
            url: '/transaction-charges',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.transactionCharges.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/transaction-charges-report/transaction-charges-report.html',
                    controller: 'TransactionChargesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('transactionCharges');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        
        
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('TransactionCharges', TransactionCharges);

    TransactionCharges.$inject = ['$resource'];

    function TransactionCharges ($resource) {
        var resourceUrl =  'api/transaction-charges/:id';
        
        return $resource(resourceUrl, {}, {
        	
        
        	'getTransactionChargesHeader':{
  				method: 'GET',
  				isArray:false,
  				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId',
  					 fromDate : '@fromDate', toDate : '@toDate'},  				
  				url: 'api/transaction-charges/get-transaction-charges-header',
  				 transformResponse: function(data, headers) {
  					if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                 }    
              },
             
              'exportTransactionChargesExcel': {
                  method: 'POST',
                  url: 'api/export-transaction-charges/excel',
                  responseType: 'arraybuffer',
                  transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   },
                  transformResponse: function(data, headers) {
                	  return {
                          data: data,
                          headers: headers
                      };   
                  }         
             },
              'exportTransactionChargesCsv': {
                  method: 'POST',
                  url: 'api/export-transaction-charges/csv',
                  responseType: 'arraybuffer',
                  transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   },
                  transformResponse: function(data, headers) {
                	  return {
                          data: data,
                          headers: headers
                      };   
                  }         
             }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'transactionCharges'
        })
        
        .controller('TransactionChargesController', TransactionChargesController);

    TransactionChargesController.$inject = ['$scope', '$state', 'TransactionCharges', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
    	'$timeout','DateUtils','AlertService','$filter', 'MarkupReport'];

    function TransactionChargesController($scope, $state, TransactionCharges , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
    		$timeout,DateUtils,AlertService,$filter, MarkupReport) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.TRANSACTION_CHARGES;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
		vm.clicked=false;
        vm.todayDate = new Date();
        vm.yesterdayDate = new Date();
        vm.yesterdayDate.setDate(vm.yesterdayDate.getDate() - 1);
        vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.orgId = vm.globalValues.getOrgId();
        vm.fromDate = DateUtils.convertDateTimeFromServer(vm.yesterdayDate);
        vm.toDate = DateUtils.convertDateTimeFromServer(vm.yesterdayDate);
        vm.exportToFile = exportToFile;
        vm.transactionCharges = [];
        vm.invoiceDTO = {};
        vm.dailyTransactions=[];
        vm.valid=false;
        vm.selectedCustomerTransaction = {};
        
        
        vm.noOfMonthsForHistoricalView = vm.globalValues.getConfigSettings().noOfMOnthsForHistoricalReportsView;
        
        vm.mimeType= '';  	  
  	  	vm.baseString =   'Transaction_Charges_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   	
        
        MarkupReport.getCurrentBusinessDate(getBusinnessDateSuccess, getBusinessDateFailed);
        
        function getBusinnessDateSuccess(result){
        	
        	if(result != null && result != undefined){
        		vm.yesterdayDate  = DateUtils.convertLocalDateFromServer(result.date);
        		vm.yesterdayDate.setDate(vm.yesterdayDate.getDate() - 1);
        		vm.fromDate = DateUtils.convertDateTimeFromServer(vm.yesterdayDate);
                vm.toDate = DateUtils.convertDateTimeFromServer(vm.yesterdayDate);
                vm.minDate = DateUtils.getMinimumLocalDate(vm.fromDate);
        	}
        	
        	
        }
        
        function getBusinessDateFailed(){
        	
        }
        
        if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
        	 vm.loggedInCustomer = vm.globalValues.getCustomerId();
        }
        if(vm.entityOwnerType=='Bank' || vm.entityOwnerType=='Branch'){
        	vm.bank = vm.globalValues.getBank();
        }
        if(vm.entityOwnerType=='Branch'){
        	vm.branch = vm.globalValues.getBranch();
        }
        
       
        vm.getTransactionHeader = getTransactionHeader;
        vm.getTransctionDetails = getTransctionDetails;
        vm.ExpandOrCollapseTransactionCharges=true;
        
        workflowSharedService.viewFrom = "transactionCharges";
       
        
        logScreenAccess();
      

       function getTransactionHeader() {
    	   
    	   vm.bankId = 0;
    	   vm.branchId = 0;
    	   vm.customerId= 0;
    	   vm.selectedCustomerTransaction = {};
    	   vm.showDetails = false;
    	   
    	   vm.invoiceDTO = {};
    	   vm.transactionCharges = [];
    	   
    	   if(moment(vm.fromDate).isAfter(vm.yesterdayDate,'day')){
	   			AlertService.error($filter('translate')('gatewayApp.transactionCharges.futureFromDate'));
	   			vm.valid=false;
	   		}
	   		else if(moment(vm.fromDate).isAfter(vm.toDate,'day')){
	   			AlertService.error($filter('translate')('gatewayApp.transactionCharges.greaterFromDate'));
	   			vm.valid=false;
	   		}else if(moment(vm.toDate).isAfter(vm.yesterdayDate,'day')){
	   			AlertService.error($filter('translate')('gatewayApp.transactionCharges.greaterToDate'));
	   			vm.valid=false;
	   		}else if(moment(vm.fromDate).isBefore(vm.minDate, 'day')){
	   			AlertService.error('Transaction Charges Reports are available only for a period of '  + vm.noOfMonthsForHistoricalView + ' months...!');
	   			vm.valid=false;
	   		}
	   		else{
	   				vm.valid=true;
					vm.clicked=true;
		    	   if (vm.entityOwnerType == 'Bank' || vm.entityOwnerType == 'Branch'){
		    		   vm.bankId = vm.globalValues.getOrganisation().id;
		    	   }else if(vm.bank!=null && vm.bank!=undefined){
		    		   if(vm.entityOwnerType == 'Clearcorp' || vm.entityOwnerType == 'MultiUserCustomer' || vm.entityOwnerType == 'SingleUserCustomer'){
			    			  vm.bankId = vm.bank.id;
			    		  }
		    	   }
		    	   
		    	   if(vm.entityOwnerType == 'Branch'){
		    		   vm.branchId = vm.globalValues.getBranch().id;
		    	   }else  if(vm.branch!=null && vm.branch!=undefined){
		    		   if(vm.entityOwnerType=='Clearcorp' || vm.entityOwnerType=='Bank'){
		    			   vm.branchId = vm.branch.id;
		    		   }
		    	   }
		    	   
		    	   if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
		    		   vm.customerId = vm.globalValues.getCustomerId();
		    	   } else  if(vm.customer!=null && vm.customer!=undefined){
		    		   if(vm.entityOwnerType!='MultiUserCustomer' && vm.entityOwnerType!='SingleUserCustomer'){
		    			   vm.customerId = vm.customer.id;
		    		   }
		    	   }
	    	   
	    	       	   
		    	   vm.convertedFromDate = DateUtils.convertLocalDateToServer(vm.fromDate);
		    	   vm.convertedToDate = DateUtils.convertLocalDateToServer(vm.toDate);
		    	   
		    	   TransactionCharges.getTransactionChargesHeader({"bankId": vm.bankId, "branchId":vm.branchId , "customerId" : vm.customerId ,
	    		   "fromDate": vm.convertedFromDate, "toDate" : vm.convertedToDate},function(result) {  
	    			   vm.invoiceDTO = result;
	    			   vm.transactionCharges = result.customerTransactionDTOList;
					   vm.clicked=false;
	             });        	
	   		}
    	  
        }      
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       function getTransctionDetails(transactionDetails){
    	   vm.dailyTransactions=[];
    	   vm.selectedCustomerTransaction = transactionDetails; 
    	   vm.dailyTransaction=vm.selectedCustomerTransaction.dailyTransactionSummationList;
    	   vm.showDetails = true;
       }
      function exportToFile(fileType){
    	  vm.baseString =   'Transaction_Charges_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   	
    	  if( vm.invoiceDTO !=null &&  vm.invoiceDTO!=undefined){
    		  if(fileType == 'csv'){
    			 vm.mimeType = 'text/csv'
    			 vm.baseString = vm.baseString+ ".csv";  
    			 TransactionCharges.exportTransactionChargesCsv(vm.invoiceDTO , processResponse )
    		  }else if(fileType == 'excel'){
    			  vm.mimeType = 'application/vnd.ms-excel';
    			  vm.baseString = vm.baseString+ ".xls";  
    			  TransactionCharges.exportTransactionChargesExcel(vm.invoiceDTO , processResponse );
    		  }
    	  }
      }	
      function processResponse(result){
    	  var fileData = null;
		  fileData = result.data;
		  var link = document.createElement("a");   
		  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
		  
		  
	      var blob = new Blob([bytes], {type: vm.mimeType});
	      if(window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
	      }else{
	    	  link.href =  window.URL.createObjectURL(blob);      
	    	  link.download = vm.baseString;
	    	  document.body.appendChild(link);
	    	  link.click();
	    	  document.body.removeChild(link);
	      }
	  }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trades-download', {
            parent: 'entity',
            params:{screen: 'TradesDownload'},
            url: '/trades-download',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.tradesDownlaod.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trades-download/trades-download.html',
                    controller: 'TradesDownlaodController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tradeDownload');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        
        
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('TradesDownload', TradesDownload);

    TradesDownload.$inject = ['$resource'];

    function TradesDownload($resource) {
    	 var resourceUrl =  'api/limit-settings';
         
         return $resource(resourceUrl, {}, {
        	 
        	 'getTradesOutstandingCSV':{
        		 method: 'POST',
 				url: 'api/trades-outstanding/export-csv',
 				responseType: 'arraybuffer',
 				transformRequest: function (data) {
 					var copy = angular.copy(data);
 					return angular.toJson(copy);
 				},
 				transformResponse: function(data, headers) {
 					return {
 						data: data,
 						headers: headers
 					};   
 				} 
        	 },
        	 'getTradesOutstandingExcel':{
        		 method: 'POST',
  				url: 'api/trades-outstanding/export-excel',
 				responseType: 'arraybuffer',
  				transformRequest: function (data) {
 					var copy = angular.copy(data);
 					return angular.toJson(copy);
 				},
 				transformResponse: function(data, headers) {
 					return {
 						data: data,
 						headers: headers
 					};   
 				} 
        	 },
        	 'getBytesForDownload':{
        	  
        	  params: {from: '@from', to : '@to'},  	
        	  method: 'POST',
              url: 'api/trades/csv-download',
              responseType: 'arraybuffer',
              transformResponse: function(data, headers) {
            	  return {
                      data: data,
                      headers: headers
                  };   
              } 
        	},
        	'getFixBytesForDownload':{
          	  
          	  params: {from: '@from', to : '@to'},  	
          	  method: 'POST',
                url: 'api/trades/fix-download',
                responseType: 'arraybuffer',
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                } 
          	},
          	'getCSVForTrades':{
          	   	
          	  method: 'POST',
                url: 'api/trades/home-csv-download',
                responseType: 'arraybuffer',
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                } 
          	},
        	'getExcelForTrades':{
          	   	
            	 method: 'POST',
          		 url: 'api/trades/home-excel-download',
          		 responseType: 'arraybuffer',
                 transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                } 
          	}
         });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'tradesDownlaod'
        })
        
        .controller('TradesDownlaodController', TradesDownlaodController);

    TradesDownlaodController.$inject = ['$scope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','TradesDownload',
    	'DateUtils','AlertService','$filter'];

    function TradesDownlaodController($scope, $state,  GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,TradesDownload,DateUtils, AlertService,$filter) {
    	var vm=this;
    	vm.globalValues = GlobalValues;
    	  var systemSettings = vm.globalValues.getSystemSettings();
    	  vm.screenName = entityConstants.ENTITY_SHORT_NAME.TRADES_DOWNLOAD
    	  vm.entityConstants = entityConstants;
          vm.screenLog = ScreenLog;;
          vm.selectTime = false;
          vm.disableTime = true; 
		  vm.clicked=false;
          vm.checkSelection = checkSelection;
          vm.downloadInCSV = cvDownload;
          vm.downloadInFIX  = fixDownload;
          
          
          
          if(systemSettings!=null && systemSettings!=undefined){
        	  vm.currentDate = DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
          }
         
         /* vm.fromTime =  moment(angular.copy(systemSettings.businessDate),'YYYY-MM-DD').startOf('day')     ;
      	 // vm.toTime =  angular.copy(vm.fromTime).endOf('day').subtract('seconds',1);
          vm.toTime =   moment(angular.copy(systemSettings.businessDate),'YYYY-MM-DD').set({ 	'hour':23,
				'minute':59,
				'second':59
				
			 });*/
          vm.fromTime =  moment().startOf('day')     ;
       	 // vm.toTime =  angular.copy(vm.fromTime).endOf('day').subtract('seconds',1);
           vm.toTime =   moment().set({ 	'hour':23,
 				'minute':59,
 				'second':59
 				
 			 });
      	  vm.maxDateTime =  angular.copy(vm.toTime);
      	  vm.minDateTime = angular.copy(vm.fromTime);;
          logScreenAccess();
          function logScreenAccess(){
             	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
          }
          function checkSelection(event){
            	
        	  changeTimeSelection(event.target.checked);
                 
          }
         function changeTimeSelection(value){
      	 	if(value){
      	 		vm.disableTime = false;
      	 		
      		}else{
      			vm.disableTime = true;
      			vm.fromTime =   angular.copy(vm.minDateTime);     ;
      	      	 // vm.toTime =  angular.copy(vm.fromTime).endOf('day').subtract('seconds',1);
      	        vm.toTime =  angular.copy(vm.maxDateTime);
      		}
          
          }
         
         function cvDownload(){
        	 var comparision =  vm.fromTime.isAfter(vm.toTime);
        	//console.log(vm.fromTime.format('YYYY-MM-DD HH:mm:ss'));
        	//console.log(vm.toTime.format('YYYY-MM-DD HH:mm:ss'));
       	  	//console.log(vm.currentDate);
       	 	//console.log(comparision);
      		if(!vm.disableTime && comparision ){
      			AlertService.error("From Time cannot be greater than To Time");
      		}
      		else if(vm.disableTime){
      			TradesDownload.getBytesForDownload({'from':null, 'to' :null},getCSVDataSuccess, getCSVDataFailure);
      		}
      		else{
      			TradesDownload.getBytesForDownload({'from':vm.fromTime.format('YYYYMMDDHHmmss.000000000'), 'to' :vm.toTime.format('YYYYMMDDHHmmss.000000000')},getCSVDataSuccess, getCSVDataFailure);
      		}
         }
         
         function getCSVDataSuccess(result){
        	 var fileData = result.data;
			 vm.clicked=false;
        	 var mimeType = 'text/csv'
        	 var baseString =    moment(vm.currentDate).format( 'YYYYMMDD')+'_FXRETAIL_TRADES';  
        	 if(fileData  !=null && fileData !=undefined && fileData.byteLength > 0){
			 /* var link = document.createElement("a");   
			  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer		  
			  
		      var blob = new Blob([bytes], {type: mimeType});
		      link.href =  window.URL.createObjectURL(blob);
		      
		   	  link.download = baseString;
		   	  document.body.appendChild(link);
		   	  link.click();
			  document.body.removeChild(link);*/
        		 var base64data = "base64," + $.base64.encode(fileData);
                 var blob = new Blob([fileData], { type: "application/" + "csv" + ';' + base64data })
                 window.saveAs(blob, baseString + "."  + "csv");
        	 }else{
        		 AlertService.error("No Records Found");
        	 }
         }
         function getCSVDataFailure(error){
        	 AlertService.error("Error in fetching data for Day trade download");
			 vm.clicked=false;
         }
         function fixDownload(){
        	 var comparision =  vm.fromTime.isAfter(vm.toTime);        	
      		if(!vm.disableTime && comparision ){
      			AlertService.error("From Time cannot be greater than To Time");
      		}
      		else if(vm.disableTime){
      			TradesDownload.getFixBytesForDownload({'from':null, 'to' :null},getFIXDataSuccess, getFIXDataFailure);
      		}
      		else{
      			TradesDownload.getFixBytesForDownload({'from':vm.fromTime.format('YYYYMMDDHHmmss.000000000'), 'to' :vm.toTime.format('YYYYMMDDHHmmss.000000000')},getFIXDataSuccess, getFIXDataFailure);
      		}
         }
         function getFIXDataSuccess(result){
        	 var fileData = result.data;
			 vm.clicked=false;
        	 var mimeType = 'text/plain'
        	 var baseString =    moment(vm.currentDate).format( 'YYYYMMDD')+'_FXRETAIL_TRADES';  
        	 if(fileData  !=null && fileData !=undefined && fileData.byteLength > 0){
			 
        		 var base64data = "base64," + $.base64.encode(fileData);
                 var blob = new Blob([fileData], { type: "text/plain" +  ';' + base64data })
                 window.saveAs(blob, baseString + "."  + "txt");
        	 }else{
        		 AlertService.error("No Records Found");
        	 }
         }
         function getFIXDataFailure(error){
			 vm.clicked=false;
        	 AlertService.error("Error in fetching data for Day trade download");
         }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trade-history', {
            parent: 'entity',
            url: '/trade-history',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.tradeHistory.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trade-history/trade-history.html',
                    controller: 'TradeHistoryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tradeHistory');
                    $translatePartialLoader.addPart('orderActivity');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        
        
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('TradeHistory', TradeHistory);

    TradeHistory.$inject = ['$resource'];

    function TradeHistory ($resource) {
        var resourceUrl =  'api/trade-history/:id';
        
        return $resource(resourceUrl, {}, {
        	
        
        	'getTradeHistory':{
           	 
             	isArray:true,
  				method: 'GET',
  				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId',
  					buySell : '@buySell',  fromDate : '@fromDate', toDate : '@toDate', currencyPairId : '@currencyPairId'},
  				
  				url: 'api/trade-history/get-trade-history-details'
              }
          
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'tradeHistory'
        })
        
        .controller('TradeHistoryController', TradeHistoryController);

    TradeHistoryController.$inject = ['$scope', '$state', 'TradeHistory', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
    	'$timeout','DateUtils','AlertService','$filter'];

    function TradeHistoryController($scope, $state, TradeHistory , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
    		$timeout,DateUtils,AlertService,$filter) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.TRADE_HISTORY;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        
        vm.todayDate = new Date();
        vm.yesterdayDate = new Date();
        vm.yesterdayDate.setDate(vm.yesterdayDate.getDate() - 1);
        vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.orgId = vm.globalValues.getOrgId();
        vm.fromDate = DateUtils.convertDateTimeFromServer(vm.yesterdayDate);
        vm.toDate = DateUtils.convertDateTimeFromServer(vm.yesterdayDate);
        vm.buySellIndicators=["BUY","SELL"];
        vm.valid=false;
		vm.clicked=false;
        
        vm.minDate = DateUtils.getSubtractMonth(new Date(),3);
        
        
        if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
        	 vm.loggedInCustomer = vm.globalValues.getCustomerId();
        }
        if(vm.entityOwnerType=='Bank' || vm.entityOwnerType=='Branch'){
        	vm.bank = vm.globalValues.getBank();
        }
        if(vm.entityOwnerType=='Branch'){
        	vm.branch = vm.globalValues.getBranch();
        }
        
        vm.noOfMonthsForHistoricalView = vm.globalValues.getConfigSettings().noOfMOnthsForHistoricalReportsView;
       
        vm.getTradeHistory = getTradeHistory;
        vm.ExpandOrCollapseTradeHistory=true;
        
        workflowSharedService.viewFrom = "tradeHistory";
       
        
        logScreenAccess();
      

       function getTradeHistory() {
    	   
    	   vm.bankId = null;
    	   vm.branchId = null;
    	   vm.customerId= null;
    	   vm.instrumentId = null;
    	   vm.buySellFlag=null;
		   vm.currencyPairId=null;
    	   
    	   
    	   if(moment(vm.fromDate).isAfter(vm.yesterdayDate,'day')){
	   			AlertService.error($filter('translate')('gatewayApp.tradeHistory.futureFromDate'));
	   			vm.valid=false;
	   		}
	   		else if(moment(vm.fromDate).isAfter(vm.toDate,'day')){
	   			AlertService.error($filter('translate')('gatewayApp.tradeHistory.greaterFromDate'));
	   			vm.valid=false;
	   		}else if(moment(vm.toDate).isAfter(vm.yesterdayDate,'day')){
	   			AlertService.error($filter('translate')('gatewayApp.tradeHistory.greaterToDate'));
	   			vm.valid=false;
	   		}
	   		else if(moment(vm.fromDate).isBefore(vm.minDate, 'day')){
	   			AlertService.error('Historical Reports are available only for a period of '  + vm.noOfMonthsForHistoricalView + ' months...!');
	   			vm.valid=false;
	   		}else if(!(moment(vm.fromDate).isSame(vm.toDate,'month'))){
				AlertService.error($filter('translate')('gatewayApp.tradeHistory.helpText'));
				vm.valid=false;
			}
	   		else{
				    vm.clicked=true;
	   				vm.valid=true;
		    	   if (vm.entityOwnerType == 'Bank' || vm.entityOwnerType == 'Branch'){
		    		   vm.bankId = vm.globalValues.getOrganisation().id;
		    	   }else if(vm.bank!=null && vm.bank!=undefined){
		    		   if(vm.entityOwnerType == 'Clearcorp' || vm.entityOwnerType == 'MultiUserCustomer' || vm.entityOwnerType == 'SingleUserCustomer'){
			    			  vm.bankId = vm.bank.id;
			    		  }
		    	   }
		    	   
		    	   if(vm.entityOwnerType == 'Branch'){
		    		   vm.branchId = vm.globalValues.getBranch().id;
		    	   }else  if(vm.branch!=null && vm.branch!=undefined){
		    		   if(vm.entityOwnerType=='Clearcorp' || vm.entityOwnerType=='Bank'){
		    			   vm.branchId = vm.branch.id;
		    		   }
		    	   }
		    	   
		    	   if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
		    		   vm.customerId = vm.globalValues.getCustomerId();
		    	   } else  if(vm.customer!=null && vm.customer!=undefined){
		    		   if(vm.entityOwnerType!='MultiUserCustomer' && vm.entityOwnerType!='SingleUserCustomer'){
		    			   vm.customerId = vm.customer.id;
		    		   }
		    	   }
	    	   
	    	   
		    	   if(vm.instrument!=null && vm.instrument!=undefined){
		    		   vm.instrumentId = vm.instrument.id;
		    	   }
		    	   
		    	  
		    	   if(vm.buySell!=null && vm.buySell!=undefined && vm.buySell!=""){
		    		   if(vm.buySell=='BUY'){
		    			   vm.buySellFlag = 'BUYY';
		    		   }else if(vm.buySell=='SELL'){
		    			   vm.buySellFlag='SELL';
		    		   }else{
		    			   vm.buySellFlag=null;
		    		   }
		    	   }

				   if(vm.currencyPair!=null && vm.currencyPair!=undefined){
		    		   vm.currencyPairId = vm.currencyPair.id;
		    	   }
		    	   
		    	   vm.convertedFromDate = DateUtils.convertLocalDateToServer(vm.fromDate);
		    	   vm.convertedToDate = DateUtils.convertLocalDateToServer(vm.toDate);
		    	   
	    	   TradeHistory.getTradeHistory({"bankId": vm.bankId, "branchId":vm.branchId , "customerId" : vm.customerId ,
	    		   "instrumentId" : vm.instrumentId , "buySell":vm.buySellFlag,
	    		   "fromDate": vm.convertedFromDate, "toDate" : vm.convertedToDate, "currencyPairId":vm.currencyPairId },function(result) {
	    	   
	                
	                angular.forEach(result, function(value){
	                	
	                	if(value.buySellIndicator.toUpperCase()=='BUYY'){
	                		value.buySellIndicator='Buy';
	                	}else if(value.buySellIndicator.toUpperCase()=='SELL'){
	                		value.buySellIndicator='Sell';
	                	}
	                	
	            	});
	                
	               
	                vm.tradeHistory = result;
					vm.clicked=false;
	             });        	
	   		}
    	  
        }      
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }

	   vm.getSwapPoints = function getSwapPoints(spotExchangeRate, tradeExchangeRate){
		  var swapPts = Math.abs(spotExchangeRate - tradeExchangeRate) * 100
		  swapPts = (Math.round(parseFloat(swapPts)*100)/100);
		  return swapPts;
	   }

       
      
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TermsAndConditionsApprovalController',TermsAndConditionsApprovalController);

    TermsAndConditionsApprovalController.$inject = ['$uibModalInstance','$stateParams', 'GlobalValues','ScreenLog', 'entityConstants','$filter', '$rootScope','$scope'
    	,'CustomerApproval'];

    function TermsAndConditionsApprovalController($uibModalInstance,$stateParams, GlobalValues, ScreenLog, entityConstants, $filter, $rootScope, $scope,
    		CustomerApproval) {
    	var vm = this;
    	vm.screenLog = ScreenLog;
    	vm.entityConstants = entityConstants;
    	vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMER_APPROVAL;
        vm.clear = clear;
       vm.approve = approve;
       vm.entityId =  $stateParams.entityId;
        $scope.clicked = false;
        

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function approve(){
        	$scope.rowID = vm.entityId;
            CustomerApproval.approve({ "taskId": vm.entityId }, onApproveSuccess, onApproveError);
            
        }
        
        function onApproveSuccess(result) {
            var flag = $filter('filter')(vm.tasks, { id: $scope.rowID });
            $rootScope.removeRow($scope.rowID);
            $uibModalInstance.dismiss('cancel');
        }
        
        

        function onApproveError(error) {
        	$scope.clicked=false;
        }

        
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TermsAndConditionsController',TermsAndConditionsController);

    TermsAndConditionsController.$inject = ['$uibModalInstance','$stateParams', 'GlobalValues','mode','$state'];

    function TermsAndConditionsController($uibModalInstance,$stateParams, GlobalValues, mode, $state) {
    	var vm = this;
        vm.clear = clear;
       
        vm.theme = $stateParams.theme;
        vm.printPage = printPage;
        vm.mode = mode;
        vm.viewPasswordPolicy = viewPasswordPolicy;
        vm.viewScheduleOfFees = viewScheduleOfFees;
        

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function printPage() {
        	  var printContents = document.getElementById("printPage").innerHTML;
        	  var popupWin = window.open('', '_blank');
        	  popupWin.document.open();
			  popupWin.opener=null;
        	  popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="styles.css" /></head><body style="-webkit-print-color-adjust:exact;border:none !important" onload="window.print()">' + printContents + '</body></html>');
        	  popupWin.document.close();
        	} 
        
        function viewPasswordPolicy(){
        	
        	if(vm.mode == 'customerOnBoarding'){
        		$state.go('password-policy-customer-onBoarding', {theme : vm.theme});
        	}
        	else if(vm.mode == 'customerViewApproval'){
        		$state.go('password-policy-customer-view-approval', {theme : vm.theme});
        	}
        	else if(vm.mode == 'customerToDo'){
        		$state.go('password-policy-customer-approval', {theme : vm.theme});
        	}
        	else if(vm.mode == 'tradingBankRelationship'){
        		$state.go('password-policy-bank-registration', {theme : vm.theme});
        	}
        }
        
        function viewScheduleOfFees(){
        	
        	if(vm.mode == 'customerOnBoarding'){
        		$state.go('schedule-of-fees-customer-onBoarding', {theme : vm.theme});
        	}
        	else if(vm.mode == 'customerViewApproval'){
        		$state.go('schedule-of-fees-customer-view-approval', {theme : vm.theme});
        	}
        	else if(vm.mode == 'customerToDo'){
        		$state.go('schedule-of-fees-customer-approval', {theme : vm.theme});
        	}
        	else if(vm.mode == 'tradingBankRelationship'){
        		$state.go('schedule-of-fees-bank-registration', {theme : vm.theme});
        	}
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ScheduleOfFeesController',ScheduleOfFeesController);

    ScheduleOfFeesController.$inject = ['$uibModalInstance','$stateParams', 'GlobalValues','ScreenLog', 'entityConstants','$filter', '$rootScope','$scope','$timeout'];

    function ScheduleOfFeesController($uibModalInstance,$stateParams, GlobalValues, ScreenLog, entityConstants, $filter, $rootScope, $scope,$timeout) {
    	var vm = this;
        vm.clear = clear;
        vm.theme = $stateParams.theme;
        vm.printPage = printPage;
        vm.displayPrint = true;
        

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
     
        function printPage() {
        	vm.displayPrint =false;
         $timeout( function(){  var printContents = document.getElementById("scheduleOfFees").innerHTML;
         var popupWin = window.open('', '_blank','fullscreen=yes');
         popupWin.opener=null;
         if (popupWin) {
           var relAttribute = document.createAttribute('rel');
           relAttribute.value = 'noopener noreferrer';
           popupWin.document.documentElement.setAttributeNode(relAttribute);
           // Write content to the new window's document
           popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + printContents + '</body></html>');
           popupWin.document.close();
        } else {
           console.error('Failed to open the window.');
        }
      	  }, 500);
         $timeout( function(){vm.displayPrint =true; }, 1000);
      
      	} 
        
        
    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('PasswordPolicyController',PasswordPolicyController);

    PasswordPolicyController.$inject = ['$uibModalInstance','$stateParams', 'GlobalValues','ScreenLog', 'entityConstants','$filter', '$rootScope','$scope'];

    function PasswordPolicyController($uibModalInstance,$stateParams, GlobalValues, ScreenLog, entityConstants, $filter, $rootScope, $scope) {
    	var vm = this;
        vm.clear = clear;
        vm.theme = $stateParams.theme;
        vm.printPage = printPage;
        

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function printPage() {
      	  var printContents = document.getElementById("passwordPolicy").innerHTML;
      	  var popupWin = window.open('', '_blank', 'fullscreen=yes');
          popupWin.opener=null;
      	  popupWin.document.open();
      	  popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + printContents + '</body></html>');
      	  popupWin.document.close();
      	} 
        
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ClearCorpScheduleOfFeesController',ClearCorpScheduleOfFeesController);

    ClearCorpScheduleOfFeesController.$inject = ['$uibModalInstance','$stateParams', 'GlobalValues','ScreenLog', 'entityConstants','$filter', '$rootScope','$scope','$timeout'];

    function ClearCorpScheduleOfFeesController($uibModalInstance,$stateParams, GlobalValues, ScreenLog, entityConstants, $filter, $rootScope, $scope,$timeout) {
    	var vm = this;
        vm.clear = clear;
        vm.theme = $stateParams.theme;
        vm.printPage = printPage;
        vm.displayPrint = true;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.CLEARCORP_FEES_AND_CHARGES_VIEW;
       logScreenAccess();
		function logScreenAccess(){
			ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}
        

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
     
        function printPage() {
        	vm.displayPrint =false;
         $timeout( function(){  var printContents = document.getElementById("scheduleOfFees").innerHTML;
         var popupWin = window.open('', '_blank','fullscreen=yes');
          popupWin.opener=null;
          if (popupWin) {
            var relAttribute = document.createAttribute('rel');
            relAttribute.value = 'noopener noreferrer';
            popupWin.document.documentElement.setAttributeNode(relAttribute);
            // Write content to the new window's document
            popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + printContents + '</body></html>');
            popupWin.document.close();
        } else {
            console.error('Failed to open the window.');
        }
      	  }, 500);
         $timeout( function(){vm.displayPrint =true; }, 1000);
      
      	} 
        
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('TacViewForEntitiesUtility', TacViewForEntitiesUtility);

    TacViewForEntitiesUtility.$inject = ['$rootScope', 'TACViewForEntitiesService','FileUtil', 'CustomerTACUploadByBank','$filter','MessageBox'];

    function TacViewForEntitiesUtility ($rootScope, TACViewForEntitiesService,FileUtil, CustomerTACUploadByBank,$filter,MessageBox ) {
    	var seletedFileName ="";
    	var messageBoxName = "";
        var service = {
        		loadAllTacAgreedDetails: loadAllTacAgreedDetails ,
        		previewTAC : previewTAC,
        		previewTACForArray : previewTACForArray,
        		onGetCcilTacForBank : onGetCcilTacForBank,
        		downloadTAC : downloadTAC,
        		downloadTACForArray : downloadTACForArray,
        };

        return service;

        function loadAllTacAgreedDetails(loggedinEntityOwnerType,organisationId ){
            
	        if (loggedinEntityOwnerType == 'Bank'){
	        	
	        	TACViewForEntitiesService.getBankTacAgreedDetails({"bankId" : organisationId}, tacAgreedDetailsSuccess, tacAgreedDetailsError);
	       
	        }else if(loggedinEntityOwnerType == 'MultiUserCustomer' || loggedinEntityOwnerType == 'SingleUserCustomer'){
	        	
	        	TACViewForEntitiesService.getCustomerTacAgreedDetails({"customerId" : organisationId}, tacAgreedDetailsSuccess, tacAgreedDetailsError);
	        }
        }
        function tacAgreedDetailsSuccess(result){
        	$rootScope.tacList  = result;
        }
        function tacAgreedDetailsError(error){
        	console.log("error in fetching TAC agreed details")
        }
        
        function previewTACForArray(arrayBuffer, pdfFileName){
        	//var y = window.outerHeight / 2 + window.screenY - ( 700 / 2);
			//var x = window.outerWidth / 2 + window.screenX - ( 700 / 2);
        	var file = new Blob([arrayBuffer], {type: 'application/pdf'});
      		var filename = pdfFileName;
            var fileURL = URL.createObjectURL(file);
            if(window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(file, filename);
            }
            else {
            	//window.open(fileURL, filename, "width=700,height=700,"+"top="+y+", left="+x);
               window.open(fileURL, filename, "fullscreen=yes");   
            	//window.open('assets/data/forex_trading_tutorial5.pdf', 'pdf_test.pdf');
            	/*var link = document.createElement("a");   
            	link.href =  fileURL;      
  	    	    link.download =filename;
  	    	    document.body.appendChild(link);
  	    	    link.click();
  	    	    document.body.removeChild(link);*/
            }
        }
        function downloadTACForArray(arrayBuffer, pdfFileName){
        	//var y = window.outerHeight / 2 + window.screenY - ( 700 / 2);
			//var x = window.outerWidth / 2 + window.screenX - ( 700 / 2);
        	var file = new Blob([arrayBuffer], {type: 'application/pdf'});
      		var filename = pdfFileName;
            var fileURL = URL.createObjectURL(file);
            if(window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(file, filename);
            }
            else {            
            	var link = document.createElement("a");   
            	link.href =  fileURL;      
  	    	    link.download =filename;
  	    	    document.body.appendChild(link);
  	    	    link.click();
  	    	    document.body.removeChild(link);
            }
        }
        function previewTAC(fileInbase64String, pdfFileName){
        	
        	var arrayBuffer =  FileUtil.base64ToArrayBuffer(fileInbase64String);
        	previewTACForArray(arrayBuffer, pdfFileName);
        	
        }
        function downloadTAC(fileInbase64String, pdfFileName){
        	
        	var arrayBuffer =  FileUtil.base64ToArrayBuffer(fileInbase64String);
        	downloadTACForArray(arrayBuffer, pdfFileName);
        	
        }
        
      /*  function onGetCcilTacForBank(tacList,screenName){
        	var tacAgreedDetail = null; 
        	if(tacList != null  && tacList != undefined &&  tacList !=  '' && tacList.length > 0 ){
        		tacAgreedDetail = tacList[0];
        	}        	
        	checkAndOpenTheTACFile(tacAgreedDetail,screenName)
        }
        
        function checkAndOpenTheTACFile(tacAgreedDetail,screenName){
        	//TODO - check for filename 
        	seletedFileName = tacAgreedDetail.fileName;
        	// if ccil has not uploaded a tac for memebr then do nothing
        	if(tacAgreedDetail == null){
        		//do nothing
        	}// if member has not agreed to the latest tac
        	else if( tacAgreedDetail.isAgreed == 'No'){
        		
       			MessageBox.openMessageBox('Alert',$filter('translate')('error.tacViewForEntities.bank.viewAgreedTAC') , 'Ok', screenName);
             
       		}else{
       			//call the service to fetch the merged details file content  if memebr has agreed to the latest tac     			
       			ClearcorpTACUpload.getTermsAndConditionsMerged(tacAgreedDetail, onMergeSuccess, onMergeError);
       			
       		}
        }

		function onMergeSuccess (result) {
			
			previewTACForArray(result.data, seletedFileName);	
		}
	
		function onMergeError () {
	
		}*/
        
        function onGetCcilTacForBank(orgId,screenName){
        	messageBoxName = screenName;
        	CustomerTACUploadByBank.getAgreedTacForBank({orgId:orgId},onGetTacSuccess,onGetTacFailure)
        }
        
        function onGetTacSuccess(result){

			if(result != null && result != undefined && result.tacMaster != null && result.tacMaster != undefined ){
				//previewTAC(result.tacMaster.tacFiles.fileContent, result.tacMaster.tacFiles.fileName);
				previewTAC(result.tacMaster.tacFiles.fileContent, "Clearcorp's Terms and Conditions for Member.pdf");
			}else{
				MessageBox.openMessageBox('Alert',$filter('translate')('error.tacViewForEntities.bank.viewAgreedTAC') , 'Ok', messageBoxName);
	             
			}
		}

		function onGetTacFailure(error){

		}
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TACViewForEntitiesDialogController',TACViewForEntitiesDialogController);

    TACViewForEntitiesDialogController.$inject = [ '$uibModalInstance',  'GlobalValues','$scope', 'Workflow','entity','entityConstants','$state','$rootScope','ScreenLog','workflowSharedService','TACViewForEntitiesService','DateUtils','TacViewForEntitiesUtility'];

    function TACViewForEntitiesDialogController( $uibModalInstance, GlobalValues,$scope, Workflow,entity, entityConstants, $state, $rootScope,ScreenLog,workflowSharedService,TACViewForEntitiesService,DateUtils,TacViewForEntitiesUtility) {
        
        var vm = this;
        vm.entityConstants = entityConstants;
        //TODO -change shortname
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.TERMS_AND_CONDITIONS_VIEW ;      
        vm.screenLog = ScreenLog;
        
        vm.clear=clear;
        vm.clicked=false;
              
        //vm.currentDate = new Date();
        vm.globalValues = GlobalValues;
        //vm.currentDate = vm.globalValues.getSystemSettings().businessDate;       
       
        $scope.showResubmitButton = false;
        $scope.showApproveRejectButton = false;
        $scope.showDiscardButton = false;
        $scope.showOk = false;
        
        vm.resubmit = resubmit;
        vm.approve = approve;
        vm.reject = reject;
        vm.discard = discard;
        vm.preview = preview;
        console.log($rootScope.payload);
        loadContentFromPayload();
        
        if(workflowSharedService.viewFrom == 'entited_tac_view_checker') {
        	
        	$scope.showResubmitButton = false;
        	$scope.showApproveRejectButton=true;
        	$scope.showDiscardButton = false;
        	
        }
        else if(workflowSharedService.viewFrom == 'entited_tac_view_maker') {
        	        	
        	$scope.showResubmitButton = false;
        	$scope.showApproveRejectButton=false;
        	$scope.showDiscardButton = true;
        }
        else if(workflowSharedService.viewFrom == 'entited_tac_view_resubmit') {
        	
        	
        	vm.screenLog.screenLog(vm.screenName, 0, entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
        	        	    	
        	$scope.showResubmitButton = true;
        	$scope.showApproveRejectButton=false;
        	$scope.showDiscardButton = false;
        }
       else if(workflowSharedService.viewFrom == 'entited_tac_view_auditLog') {    		   	 
        	
        	$scope.showResubmitButton = false;
        	$scope.showApproveRejectButton=false;
        	$scope.showDiscardButton = false;
        	$scope.showOk = true;
        }
        
       function loadContentFromPayload(){
        	
        	vm.tacAgreedEntityDetails = angular.fromJson(angular.copy($rootScope.payload));        	                                      
        	vm.latestRevisionDateTime = DateUtils.convertLocalDateFromServerTo12HrsString(
        			angular.copy(vm.tacAgreedEntityDetails.tacAgreedEntities.tacMaster.createdDate));
        	vm.enforcingDate =  DateUtils.convertLocalDateFromServer(angular.copy(vm.tacAgreedEntityDetails.tacAgreedEntities.tacMaster.enforcingDate));
        	vm.tacType = vm.tacAgreedEntityDetails.tacAgreedEntities.tacMaster.tacType.id;
        	vm.fileContent = vm.tacAgreedEntityDetails.tacAgreedEntities.tacMaster.tacFiles.fileContent;
        	if(vm.tacType == 1){
        		 vm.isTACForCCIL= true;
        		 vm.showClearcorpTACHelpText= true;
        	}else if( vm.tacType == 2){
        	 	vm.isTACForCCIL= true;
        		vm.showClearcorpTACHelpText= false;
        	}else if(vm.tacType == 3){
        		vm.isTACForCCIL= false;
        		vm.showClearcorpTACHelpText= false;
        	}
        }
        
  
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
       
		
        function resubmit() {
        	//this resubmit has nothing to do, they can have a preview
        	
        	vm.screenLog.screenLog(vm.screenName, vm.tacAgreedEntityDetails.tacAgreedEntities.tacMaster.id, entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
			
        	TACViewForEntitiesService.resubmit({"taskId" : $rootScope.taskID}, vm.tacAgreedEntityDetails, onResubmitSuccess, onResubmitError);
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {
        	vm.clicked = false;
        }
        
        function reject() { Workflow.rejectTask($rootScope.taskID); }

        function discard() {
        	TACViewForEntitiesService.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }

        function approve() {  
        	TACViewForEntitiesService.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
        

        function preview(){
        	//TODO - check for filename 
        	//vm.screenLog.screenLog(vm.screenName,vm.tacAgreedEntityDetails.tacAgreedEntities.tacMaster.id,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)
       		var file = vm.tacAgreedEntityDetails.tacAgreedEntities.tacMaster.tacFiles;
       		TacViewForEntitiesUtility.previewTAC(file.fileContent, file.fileName);
       		
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('entities-tac-view', {
            parent: 'entity',
            params:{screen:'TermsAndConditionsView'},
            url: '/entities-tac-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.tacViewForEntities.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tac-view-for-entities/tac-view-for-entities.html',
                    controller: 'TACViewForEntitiesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tacViewForEntities');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
       .state('entities-tac-todo-view', {
            parent: 'dashboard',
            url: '/entities-tac-view-todo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tac-view-for-entities/tac-view-for-entities-todo-dialog.html',
                    controller: 'TACViewForEntitiesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('entities-tac-view', null, { reload: 'entities-tac-view' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tacViewForEntities');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
            
        })        
         .state('entities-tac-todo-view.resubmit', {
            parent: 'dashboard',
            url: '/entities-tac-view-resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/entities/tac-view-for-entities/tac-view-for-entities-todo-dialog.html',
                    controller: 'TACViewForEntitiesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('entities-tac-view', null, { reload: 'entities-tac-view' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tacViewForEntities');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('entities-tac-view-auditLog', {
            parent: 'audit-log',
            url: '/entities-tac-view-audit-log-report',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/entities/tac-view-for-entities/tac-view-for-entities-todo-dialog.html',
                    controller: 'TACViewForEntitiesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('entities-tac-view', null, { reload: 'entities-tac-view' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tacViewForEntities');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('entities-tac-view-historyReport', {
            parent: 'history-report',
            url: '/entities-tac-view-history-report',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/entities/tac-view-for-entities/tac-view-for-entities-todo-dialog.html',
                    controller: 'TACViewForEntitiesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('entities-tac-view', null, { reload: 'entities-tac-view' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tacViewForEntities');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('tac-agree-confirmation', {
            parent: 'entities-tac-view',
            url: '/entities-tac-view-agree-confirmation/{tacTypeId}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/entities/tac-view-for-entities/tac-agree-confirmation-dialog.html',
                    controller: 'TACAgreeConfirmationController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('entities-tac-view', null, { reload: 'entities-tac-view' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tacViewForEntities');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('tac-agree-confirmation-todo', {
            parent: 'dashboard',
            url: '/entities-tac-view-agree-approval-confirmation/{tacTypeId}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/entities/tac-view-for-entities/tac-agree-confirmation-dialog.html',
                    controller: 'TACAgreeConfirmationController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('dashboard', null, { reload: 'dashboard' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tacViewForEntities');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
          
        
        
        
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('TACViewForEntitiesService', TACViewForEntitiesService);

    TACViewForEntitiesService.$inject = ['$resource'];

    function TACViewForEntitiesService ($resource) {
        var resourceUrl =  'api/tac-agreed-view/:id';

        return $resource(resourceUrl, {}, {
            
            
            'approve': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
              	 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/discard'
             },
             'resubmit': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/resubmit-tac-agreed-entities',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             },
            'getBankTacAgreedDetails':{
	           	 method: 'GET',
	             params: {bankId:'@bankId'},
	             url: 'api/tac-agreed-view/get-bank-ccil-tac',
	             isArray: true            	
            },
            'getCustomerTacAgreedDetails':{
	           	 method: 'GET',
	             params: {customerId:'@customerId'},
	             url: 'api/tac-agreed-view/get-customer-all-tac',
	             isArray: true            	
            },
            'getTacAgreedDetailsForGivenCustomer':{
	           	 method: 'GET',
	             params: {customerId:'@customerId'},
	             url: 'api/tac-agreed-view/get-all-agreed-tac-for-customer',
	             isArray: true            	
            },
            'agreeTAC' :{
            	 method: 'POST',
            	 url: 'api/tac-agreed-view/agree-tac',
	             transformRequest: function (data) {
	                 	var copy = angular.copy(data);
	                 	return angular.toJson(copy);
	                 }
            },
            'getAnnexure2':{
                method:'POST',
                url: 'api/terms-conditions-upload/annexure2',
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            },
            'getAnnexure1':{
                method:'POST',
                url: 'api/public/terms-conditions-upload/annexure1',
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            },
            'getBankExcel':{
                method:'POST',
                url: 'api/tac-agreed-view/excel',
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            },
            'getCustomerExcel':{
                method:'POST',
                url: 'api/tac-agreed-view/customer/excel',
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            },
            'getBankCsv':{
                method:'POST',
                url: 'api/tac-agreed-view/csv',
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            },
            'getCustomercsv':{
                method:'POST',
                url: 'api/tac-agreed-view/customer/csv',
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            },
            'getActiveTACForOrganisationAndTacType':{
                 method: 'GET',
                 params: {orgId:'@orgId'},
                 url: 'api/public/active-tac-master/:orgId/org/:tacTypeId/tac-type'
            },
            'getCustomerAgreedTACList':{
                isArray:true,
                method: 'GET',
                url: 'api/customer-agreed-tac-list/:customerId/customer'
            },
            'getClearCorpTAC': {
                method: 'GET',
                url: 'api/public/clearCorp-tac-master',
                responseType: 'arraybuffer', // This is correct for binary data like PDF
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            }

            
        });
    }
})();

            

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'tacViewForEntities'
        })
        .controller('TACViewForEntitiesController',TACViewForEntitiesController);

    TACViewForEntitiesController.$inject = [   'GlobalValues','$scope','ScreenLog','workflowSharedService','entityConstants','EntityPermissions','$state','TACViewForEntitiesService','$rootScope','$timeout','TacViewForEntitiesUtility','ClearcorpTACUpload','ScreenLogService'];

    function TACViewForEntitiesController(  GlobalValues,$scope,ScreenLog,workflowSharedService,entityConstants,EntityPermissions,$state,TACViewForEntitiesService,$rootScope, $timeout,TacViewForEntitiesUtility,ClearcorpTACUpload,ScreenLogService) {
        var vm = this;
        vm.globalValues = GlobalValues;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.screenLog = ScreenLog;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.TERMS_AND_CONDITIONS_VIEW ; 
        vm.entityConstants = entityConstants;
        //vm.permitTACAgreeEntityAction = EntityPermissions.hasPermission('TermsAndConditionsView.AGREE')
        //vm.permitTACViewEntityAction = EntityPermissions.hasPermission('TermsAndConditionsView.VIEW')
        // retain overflow visiblity in page refresh - Mantis 1579 10-Aug 2020
        vm.permitTACAgreeEntityAction = true;
        vm.permitTACViewEntityAction = true;
        vm.isCustomerEntity = false;
        vm.loggedInUsersORganisationName = "";       
        
        vm.loggedinEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.organisation = vm.globalValues.getOrganisation();
        vm.loggedInUsersOrganisationName  =  vm.organisation.name;
        vm.previewTAC = previewTAC;
        vm.confirmAgreeTAC = confirmAgreeTAC;
        $scope.refresh=refresh;
        vm.exportToFile = exportToFile;
        workflowSharedService.viewFrom= "tacViewForEntities";
        logScreenAccess();
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }
        
        loadAll();
        function loadAll(){
        
	        if (vm.loggedinEntityOwnerType == 'Bank'){
	        	vm.isCustomerEntity = false; 
	        	//TACViewForEntitiesService.getBankTacAgreedDetails({"bankId" : vm.organisation.id}, tacAgreedDetailsSuccess, tacAgreedDetailsError);
	       
	        }else if(vm.loggedinEntityOwnerType == 'MultiUserCustomer' || vm.loggedinEntityOwnerType == 'SingleUserCustomer'){
	        	vm.isCustomerEntity = true;     
	        	//TACViewForEntitiesService.getCustomerTacAgreedDetails({"customerId" : vm.organisation.id}, tacAgreedDetailsSuccess, tacAgreedDetailsError);
	        }
	        TacViewForEntitiesUtility.loadAllTacAgreedDetails(vm.loggedinEntityOwnerType, vm.organisation.id);
        }
       /* function tacAgreedDetailsSuccess(result){ 
        	vm.tacList  = result;
        }
        function tacAgreedDetailsError(error){
        	console.log("error in fetching TAC agreed details")
        }*/
        
        function confirmAgreeTAC(tacAgreedDetail){
        	console.log("create and set selected tac to rootscope")
        	var tacAgreedEntityDTO = {};
        	tacAgreedEntityDTO.agreedEntityName =  vm.loggedInUsersOrganisationName;
        	tacAgreedEntityDTO.tacProviderName = tacAgreedDetail.tacProviderName;
        	tacAgreedEntityDTO.tacAgreedEntities={};
        	tacAgreedEntityDTO.tacAgreedEntities.organisationId = vm.organisation.id;
        	tacAgreedEntityDTO.tacAgreedEntities.tacType = {};
        	tacAgreedEntityDTO.tacAgreedEntities.tacType.id= tacAgreedDetail.tacTypeId;
        	tacAgreedEntityDTO.tacAgreedEntities.tacMaster = {};
        	tacAgreedEntityDTO.tacAgreedEntities.tacMaster.id = tacAgreedDetail.tacMasterId;
        	tacAgreedEntityDTO.tacAgreedEntities.tacMaster.organisationId= tacAgreedDetail.tacProviderId;
        	tacAgreedEntityDTO.tacAgreedEntities.tacMaster.tacType = {}
        	tacAgreedEntityDTO.tacAgreedEntities.tacMaster.tacType.id= tacAgreedDetail.tacTypeId;
        	tacAgreedEntityDTO.tacAgreedEntities.tacMaster.enforcingDate = tacAgreedDetail.enforcingDate;
        	tacAgreedEntityDTO.tacAgreedEntities.tacMaster.createdDate = tacAgreedDetail.latestRevisionTime;
        	tacAgreedEntityDTO.tacAgreedEntities.tacMaster.tacFiles = {};
        	tacAgreedEntityDTO.tacAgreedEntities.tacMaster.tacFiles.id = tacAgreedDetail.tac_file_id;
        	tacAgreedEntityDTO.tacAgreedEntities.tacMaster.tacFiles.fileName = tacAgreedDetail.fileName;
        	tacAgreedEntityDTO.tacAgreedEntities.tacMaster.tacFiles.fileContent = tacAgreedDetail.fileContent;
        	$rootScope.selectedTacAgreedEntityDTO = tacAgreedEntityDTO;
        	var state = 'tac-agree-confirmation';
   			$state.go(state,{tacTypeId : tacAgreedEntityDTO.tacAgreedEntities.tacType.id} );
        	
        }
        
        function previewTAC(tacAgreedDetail){
        	//TODO - check for filename 
        	vm.seletedFileName = findFileNameForAgreedTac(tacAgreedDetail.tacTypeId);
        	//only on successful screen log , open the tac view
        	ScreenLogService.screenLog({entityName: vm.screenName, entityRecordId:tacAgreedDetail.tacMasterId, action:vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS},function(){
        		if(tacAgreedDetail.isAgreed == 'No'){
        			TacViewForEntitiesUtility.previewTAC(tacAgreedDetail.fileContent, tacAgreedDetail.fileName);
        		}else{
        			//call the service to fetch the merged details file content
        			if(vm.isCustomerEntity==false){
        				ClearcorpTACUpload.getTermsAndConditionsMerged(tacAgreedDetail, onMergeSuccess, onMergeError);
        			}else{
        				ClearcorpTACUpload.getTermsAndConditionsMergedCustomerView(tacAgreedDetail, onMergeSuccess, onMergeError);
        			}
        		}
        	});
        }
		function onMergeSuccess (result) {
			
			TacViewForEntitiesUtility.previewTACForArray(result.data, vm.seletedFileName);	
		}
	
		function onMergeError () {
	
		}
		
        $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
    	function exportToFile(fileType){
			vm.baseString =   'Terms_And_Conditions_View_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   	
			if( $rootScope.tacList !=null &&  $rootScope.tacList !=undefined){
				if(vm.isCustomerEntity){			
					if(fileType == 'csv' ){
						vm.mimeType = 'text/csv'
						vm.baseString = vm.baseString+ ".csv";  
						TACViewForEntitiesService.getCustomercsv($rootScope.tacList , processResponse );
					}else if(fileType == 'excel' ){
						vm.mimeType = 'application/vnd.ms-excel';
						vm.baseString = vm.baseString+ ".xls";  
						TACViewForEntitiesService.getCustomerExcel($rootScope.tacList , processResponse );
					}
				}
				else{			
					if(fileType == 'csv' ){
						vm.mimeType = 'text/csv'
						vm.baseString = vm.baseString+ ".csv";  
						TACViewForEntitiesService.getBankCsv($rootScope.tacList , processResponse );
					}else if(fileType == 'excel' ){
						vm.mimeType = 'application/vnd.ms-excel';
						vm.baseString = vm.baseString+ ".xls";  
						TACViewForEntitiesService.getBankExcel($rootScope.tacList , processResponse );
					}
				}
			}
		}
    	function processResponse(result){
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
			
		}
    	
    	function findFileNameForAgreedTac(tacTypeId){
    		if(tacTypeId == 1){
    	         
    	          return "Clearcorp's Terms and Conditions for Customer.pdf";
    	    }else if( tacTypeId == 2){
    	          
    	    	return "Clearcorp's Terms and Conditions for Member.pdf";
    	     }else if(tacTypeId == 3){
    	         
    	    	 return "Relationship Bank's Terms and Conditions for Customer.pdf";
    	     }else{
    	    	 return "Default";
    	     }
    		
    	}
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TACAgreeConfirmationController',TACAgreeConfirmationController);

    TACAgreeConfirmationController.$inject = ['$uibModalInstance','$stateParams', 'GlobalValues','ScreenLog','$filter', '$rootScope', '$scope','TACViewForEntitiesService','workflowSharedService' ,'entityConstants','TacViewForEntitiesUtility'];

    function TACAgreeConfirmationController($uibModalInstance,$stateParams,GlobalValues, ScreenLog, $filter, $rootScope, $scope,TACViewForEntitiesService,workflowSharedService, entityConstants,TacViewForEntitiesUtility) {
    	
    	var vm = this;
    	vm.screenLog = ScreenLog;
    	vm.entityConstants = entityConstants;
    	vm.screenName = entityConstants.ENTITY_SHORT_NAME.TERMS_AND_CONDITIONS_VIEW ;
        vm.clear = clear;
        vm.approve = approve;
        vm.tacTypeId =  $stateParams.tacTypeId;
        $scope.clicked = false;
    	vm.isTacDeclared = false;
    	vm.agreeTAC = agreeTAC;
    	 vm.loggedinEntityOwnerType = GlobalValues.getEntityOwnerType().shortName;
         vm.organisation = GlobalValues.getOrganisation();
         
    	checkForTacType();
        if( workflowSharedService.viewFrom == 'tacViewForEntities') {
        	vm.isViewFromToDo = false;
        	
        }else{
        	vm.isViewFromToDo = true;
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function approve(){
        	$scope.rowID = $rootScope.taskID;
        	TACViewForEntitiesService.approve({ "taskId":  $rootScope.taskID }, onApproveSuccess, onApproveError);
            
        }
        function agreeTAC(){
        	vm.screenLog.screenLog(vm.screenName,$rootScope.selectedTacAgreedEntityDTO.tacAgreedEntities.tacMaster.id,vm.entityConstants.ENTITY_ACTION_TYPE.AGREE);
        	console.log(angular.toJson($rootScope.selectedTacAgreedEntityDTO));
        	TACViewForEntitiesService.agreeTAC($rootScope.selectedTacAgreedEntityDTO,onAgreeSuccess, onAgreeFailure );
        }
        function onApproveSuccess(result) {
           
            $rootScope.removeRow( $rootScope.taskID );
            $uibModalInstance.dismiss('cancel');
        }

        function onApproveError(error) {
        	//$scope.clicked=false;
        	 $uibModalInstance.dismiss('cancel');        	
        }

        function onAgreeSuccess(result) {
        	
            $uibModalInstance.dismiss('cancel');
            TacViewForEntitiesUtility.loadAllTacAgreedDetails(vm.loggedinEntityOwnerType, vm.organisation.id);
        }

        function onAgreeFailure(error) {
        	//$scope.clicked=false;
        	 $uibModalInstance.dismiss('cancel');
        }
        function checkForTacType(){
        	
        	if( vm.tacTypeId  == 1  ){        
        		vm.isTACForCCIL = true;
        		vm.showClearcorpTACHelpText = true;
        	}else if( vm.tacTypeId == 2){
        		vm.isTACForCCIL = true;
        		vm.showClearcorpTACHelpText = false;
        	}else if(vm.tacType == 3){
        		vm.isTACForCCIL = false;
        		vm.showClearcorpTACHelpText = false;
        	}	
        }
        
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tacview', {
            parent: 'account',
            url: '/tac-view',
            data: {
                authorities: []
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/entities/tac-view/tac-view.html',
                    controller: 'TacViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    return $translate.refresh();
                }]
            }
        })

                
    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TacViewController', TacViewController);

		TacViewController.$inject = ['$scope', 'TACViewForEntitiesService'];

    function TacViewController ($scope,TACViewForEntitiesService ) {
        var vm = this;

        clearcorpTACFile();

   function clearcorpTACFile(){
	   TACViewForEntitiesService.getClearCorpTAC(function(result){
                vm.clearcorpTAC = result.data;
				previewTACForArray(vm.clearcorpTAC, 'ClearCorp_TAC.pdf');
				
	   })
	
    }

//    function clearcorpTACFile(){
//     // Your service call
//     TACViewForEntitiesService.getClearCorpTAC({}, function (response) {
//         vm.arrayBuffer = response.data;

//         vm.loadingTask = pdfjsLib.getDocument({ data:  vm.arrayBuffer });
//         vm.loadingTask.promise.then(function (pdf) {
//             vm.totalPages = pdf.numPages;
//             vm.pages = [];

//             for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
//                 pdf.getPage(pageNum).then(function (page) {
//                     var scale = 1.5;
//                     var viewport = page.getViewport({ scale: scale });

//                     var canvas = document.createElement('canvas');
//                     canvas.width = viewport.width;
//                     canvas.height = viewport.height;
//                     var context = canvas.getContext('2d');

//                     page.render({
//                         canvasContext: context,
//                         viewport: viewport
//                     }).promise.then(function () {
//                         // Store base64 image of the page
//                         var imgData = canvas.toDataURL();
//                         vm.pages[pageNum - 1] = imgData;

//                         // Trigger digest if needed
//                         if (!vm.$$phase) {
//                             $scope.$apply();
//                         }
//                     });
//                 });
//             }
//         });
//     });
// };



//  function previewTACForArray(arrayBuffer, pdfFileName) {
// var file = new Blob([arrayBuffer], {type: 'application/pdf'});
//       		var filename = pdfFileName;
//             var fileURL = URL.createObjectURL(file);
//             if(window.navigator.msSaveOrOpenBlob) {
//                 window.navigator.msSaveOrOpenBlob(file, filename);
//             }
//             else {
            	
//                window.open(fileURL, filename, "fullscreen=yes");   
            	
// }
//  }

function previewTACForArray(arrayBuffer, pdfFileName) {
    var file = new Blob([arrayBuffer], { type: 'application/pdf' });
    var fileURL = URL.createObjectURL(file);

    // instead of opening new window, show inside current page
    document.getElementById("pdfContainer").innerHTML =
        '<embed src="' + fileURL + '" type="application/pdf" width="100%" height="100%">';
}

 }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('system-amended-trades', {
            parent: 'entity',
            params:{screen: 'SystemAmendedTradesReport'},
            url: '/system-amended-trades',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.systemAmendedTrades.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/system-amended-trades/system-amended-trades.html',
                    controller: 'SystemAmendedTradesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('systemAmendedTrades');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                systemSettings: ['IntradayMarket', function(IntradayMarket) {
                    return IntradayMarket.getCurrentBusinessDate().$promise;
                }]
               
            }
        })
    };
})();

(function() {
	'use strict';
	angular
	.module('gatewayApp')
	.factory('SystemAmendedTrades', SystemAmendedTrades);

	SystemAmendedTrades.$inject = ['$resource'];

	function SystemAmendedTrades ($resource) {
		var resourceUrl =  'api/system-amended-trades/:orgId';

		return $resource(resourceUrl, {}, {  
			
			'getAllSystemAmendedTrades':{
				isArray:true,
  				method: 'GET',
  				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId',fromDate : '@fromDate', toDate : '@toDate'},				
  				url: 'api/system-amended-trades'
			}

		});
	}
})();


(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.service("workflowSharedService", function () {        	
		this.viewFrom= 'systemAmendedTrades'
	})

	.controller('SystemAmendedTradesController', SystemAmendedTradesController);

	SystemAmendedTradesController.$inject = ['$scope', '$state', 'workflowSharedService', 'GlobalValues', 'ScreenLog', 'entityConstants','DateUtils', 'AlertService', '$filter','SystemAmendedTrades','systemSettings'];
	function SystemAmendedTradesController($scope, $state, workflowSharedService, GlobalValues, ScreenLog , entityConstants, DateUtils, AlertService,$filter,SystemAmendedTrades,systemSettings) {

		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.SYSTEM_AMENDED_TRADES;
		vm.entityConstants = entityConstants;
		vm.screenLog = ScreenLog;
		vm.clicked=false;		
		vm.loadAll = loadData;
		vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
		vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();		
		vm.ExpandOrCollapseSystemAmendedTrades = true;
		vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
		vm.noOfMonthsForHistoricalView = vm.globalValues.getConfigSettings().noOfMOnthsForHistoricalReportsView;
		vm.yesterdayDate = new Date();
		vm.yesterdayDate.setDate(vm.yesterdayDate.getDate() - 1);
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;
		workflowSharedService.viewFrom = "systemAmendedTrades";

		if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
        	 vm.loggedInCustomer = vm.globalValues.getCustomerId();
        }
        if(vm.entityOwnerType=='Bank' || vm.entityOwnerType=='Branch'){
        	vm.bank = vm.globalValues.getBank();
        }
        if(vm.entityOwnerType=='Branch'){
        	vm.branch = vm.globalValues.getBranch();
        }
        
        if(systemSettings != null && systemSettings != undefined){
        	vm.currentDate = systemSettings.businessDate;
        	vm.fromDate = DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
        	vm.currentBusinessDate = DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
    		vm.toDate =DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
    		vm.minDate = DateUtils.getMinimumLocalDate(vm.fromDate);
	    	
	    }
        
        
		function loadData(){
			vm.bankId = 0;
			vm.branchId = 0;
			vm.customerId = 0;
			vm.currencyPairId = 0;
			vm.systemAmendedtradesDetails = [];
			if (vm.entityOwnerType == 'Bank' || vm.entityOwnerType == 'Branch'){
				vm.bankId = vm.globalValues.getOrganisation().id;
			}else if(vm.bank!=null && vm.bank!=undefined){
				if(vm.entityOwnerType == 'Clearcorp' || vm.entityOwnerType == 'MultiUserCustomer' || vm.entityOwnerType == 'SingleUserCustomer'){
					vm.bankId = vm.bank.id;
				}
			}

			if(vm.entityOwnerType == 'Branch'){
				vm.branchId = vm.globalValues.getBranch().id;
			}else  if(vm.branch!=null && vm.branch!=undefined){
				if(vm.entityOwnerType=='Clearcorp' || vm.entityOwnerType=='Bank'){
					vm.branchId = vm.branch.id;
				}
			}

			if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
				vm.customerId = vm.globalValues.getCustomerId();
			} else  if(vm.customer!=null && vm.customer!=undefined){
				if(vm.entityOwnerType!='MultiUserCustomer' && vm.entityOwnerType!='SingleUserCustomer'){
					vm.customerId = vm.customer.id;
				}
			}

			if(vm.currencyPair!=null && vm.currencyPair!=undefined){
                    vm.currencyPairId = vm.currencyPair.id;
            }

			var fromServerDate = DateUtils.convertLocalDateToServer(vm.fromDate);
			var toServerDate = DateUtils.convertLocalDateToServer(vm.toDate);
			
		    if(moment(vm.fromDate).isAfter(vm.toDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.systemAmendedTrades.fromDateError'));

			}
			else{
				vm.clicked=true;
				SystemAmendedTrades.getAllSystemAmendedTrades({ bankId: vm.bankId, branchId:vm.branchId , customerId : vm.customerId  , fromDate : fromServerDate, toDate : toServerDate } , function(result) {
					vm.systemAmendedtradesDetails = result;    
					vm.clicked=false;

					angular.forEach(vm.systemAmendedtradesDetails,function(value){
						value.tradeTime=moment(value.tradeTime,'YYYYMMDDHHmmss.SSSSSSSSS').format();
					});

				});


			}
		}

		logScreenAccess();

		function logScreenAccess(){
			ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}


	}
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('swap-quotes-view', {
            parent: 'entity',
            params:{screen: 'SwapQuotesView'}, 
            url: '/swap-quotes-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.swapQuotesView.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/swap-quotes-view/swap-quotes-view.html',
                    controller: 'SwapQuotesViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('SwapQuotesView');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                systemSettings: ['IntradayMarket', function(IntradayMarket) {
                    return IntradayMarket.getCurrentBusinessDate().$promise;
                }]
               
            }
        })
    };
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'SwapQuotesView'
        })
        
        .controller('SwapQuotesViewController', SwapQuotesViewController);

    SwapQuotesViewController.$inject = ['$scope', '$rootScope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
    	'DateUtils','AlertService','$filter',  'SwapQuotes','IntradayMarket','systemSettings'];

    function SwapQuotesViewController($scope, $rootScope, $state,  GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
    		DateUtils,AlertService,$filter,  SwapQuotes,IntradayMarket,systemSettings) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.SWAP_QUOTES_VIEW;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        vm.getSwapQuotesView = getSwapQuotesView; 
        vm.exportToFile = exportToFile;
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.configSettings = vm.globalValues.getConfigSettings();
        vm.ExpandOrCollapseSwapQuotesView = true;
	    vm.todayDate = new Date();
	    vm.exportDataToExcelFile = exportDataToExcelFile;
	    vm.exportDataToCsvFile = exportDataToCsvFile;
	    vm.exportDataToPdfFile = exportDataToPdfFile;
	    vm.filterData = {};
	    vm.fileName = "Swap_Quotes_View_";
	    vm.extension = "";
	    vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm_ss';
	    vm.valid=false;
		vm.clicked=false;
	    logScreenAccess();
	   
	    /*var systemSettings = vm.globalValues.getSystemSettings();
        if(systemSettings!=null && systemSettings!=undefined){
        	vm.todayDate  = new Date(systemSettings.businessDate);
            vm.fromDate = new Date(systemSettings.businessDate);
            vm.toDate = new Date(systemSettings.businessDate);
        }*/
	   if(systemSettings != null && systemSettings != undefined){
	    	vm.todayDate = DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
	    	vm.fromDate = DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
	    	vm.toDate = DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
	    	vm.minDate = DateUtils.getMinimumLocalDate(vm.fromDate);
	    	
	    }
        
        function logScreenAccess(){
           	ScreenLog.screenLog(vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }
        
        function getSwapQuotesView(){
        	vm.swapQuotesList = []; //to re-initialize the array
        	var bankId = 0;
        	if(vm.bank!=null && vm.bank!=undefined){
        		bankId = vm.bank.id;
        	}
        	
			var fromServerDate = DateUtils.convertLocalDateToServer(vm.fromDate);
			var toServerDate = DateUtils.convertLocalDateToServer(vm.toDate);
			copyFilterData();
			if(moment(vm.fromDate).isAfter(vm.todayDate,'day')){
    			AlertService.error($filter('translate')('gatewayApp.swapQuotesView.futureFromDate'));
    			vm.valid=false;
    		}
    		else if(moment(vm.fromDate).isAfter(vm.toDate,'day')){
    			AlertService.error($filter('translate')('gatewayApp.swapQuotesView.greaterFromDate'));
    			vm.valid=false;
    		}else if(moment(vm.toDate).isAfter(vm.todayDate,'day')){
    			AlertService.error($filter('translate')('gatewayApp.swapQuotesView.futureToDate'));
    			vm.valid=false;
    		}
    		else{
    			vm.valid=true;
				vm.clicked=true;
    			SwapQuotes.getSwapQuotesView({bankId: bankId, from: fromServerDate, to: toServerDate}, onGetSwapQuotesSuccess, onGetSwapQuotesFailure)
    		}
        }
        
        function onGetSwapQuotesSuccess(result){
        	vm.swapQuotesList = result;
			vm.clicked=false;
        }
        
        function onGetSwapQuotesFailure(){
        	vm.clicked=false;
        }
        
        function copyFilterData(){
        	if(vm.bank!=null && vm.bank!=""){
        		vm.filterData.bankName = vm.bank.bankName;
        	}else{
        		vm.filterData.bankName = "--All--";
        	}
        	
        	var from=$filter('date')(vm.fromDate, "dd-MM-yyyy");
        	var to=$filter('date')(vm.toDate, "dd-MM-yyyy");

        	vm.filterData.from = from;
    		vm.filterData.to = to;
        }
        
        function exportToFile(fileType){
        	if(fileType=='csv'){
        		exportDataToCsvFile();
        	}else if(fileType=='excel'){
        		exportDataToExcelFile();
        	}else if(fileType=='pdf'){
        		exportDataToPdfFile();
        	}
        	$rootScope.fileType = fileType;
        }

        function exportDataToExcelFile(){
      	  if(vm.swapQuotesList !=null &&  vm.swapQuotesList!=undefined && vm.swapQuotesList.length>0){
      		  vm.mimeType = 'application/vnd.ms-excel';
      		  vm.extension = ".xls";  
      		  SwapQuotes.exportData({bankName:  vm.filterData.bankName, from:  vm.filterData.from, to:  vm.filterData.to}, vm.swapQuotesList, onExportSuccess);
      	  }
        }
        
        function exportDataToCsvFile(){
        	if(vm.swapQuotesList !=null &&  vm.swapQuotesList!=undefined && vm.swapQuotesList.length>0){
        		vm.mimeType = 'text/csv';
        		vm.extension = ".csv";  
        		SwapQuotes.exportDataCSV({bankName:  vm.filterData.bankName, from:  vm.filterData.from, to:  vm.filterData.to}, vm.swapQuotesList, onExportSuccess);
        	}
        }
	    
        function exportDataToPdfFile(){
        	if(vm.swapQuotesList !=null &&  vm.swapQuotesList!=undefined && vm.swapQuotesList.length>0){
        		vm.mimeType = 'application/pdf';
        		vm.extension = ".pdf";  
	      		SwapQuotes.exportDataPdf({bankName:  vm.filterData.bankName, from:  vm.filterData.from, to:  vm.filterData.to}, vm.swapQuotesList, onExportSuccess);
        	}
        }
	    
	    function onExportSuccess(result){        	  
	      	  var fileData = null;
	  		  fileData = result.data;
	  		  var link = document.createElement("a");   
	  		  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
	  		  vm.baseString = vm.fileName + moment().format(vm.reportFileTimestampFormat) +  vm.extension; 
	  		  
	  	      var blob = new Blob([bytes], {type: vm.mimeType});
	  	      if(window.navigator.msSaveOrOpenBlob){
	                  window.navigator.msSaveOrOpenBlob(blob, vm.baseString);
	  	      }else{
	  	    	  link.href =  window.URL.createObjectURL(blob);      
	  	    	  link.download = vm.baseString;
	  	    	  document.body.appendChild(link);
	  	    	  link.click();
	  	    	  document.body.removeChild(link);
	  	      }
	  	}
    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('SwapQuotesHomePageController', SwapQuotesHomePageController);

    SwapQuotesHomePageController.$inject = ['$scope', '$rootScope', '$state',  '$uibModalInstance', 
    '$stateParams', 'GlobalValues', 'EntityPermissions', 'workflowSharedService'];

    function SwapQuotesHomePageController($scope, $rootScope, $state, $uibModalInstance, 
        $stateParams, GlobalValues, EntityPermissions, workflowSharedService) {
        var vm = this;
        
        vm.clear=clear;
        vm.globalValues = GlobalValues;

        vm.showPriceIcon=true;
        vm.bankQuotesPaginationNoOfRecordsPerPage = 10;
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.hasPermission = EntityPermissions.hasPermission;
        vm.permitSwapQuotesEditEntityAction = vm.hasPermission("SwapQuotes.EDIT");
        vm.editSwapQuotes = editSwapQuotes;
        vm.onChangingBankInSwapQuotes = onChangingBankInSwapQuotes;
        vm.onChangingBankInMarkup = onChangingBankInMarkup;

        vm.account=$stateParams.account;
        vm.defaultTradingBank = $stateParams.defaultTradingBank;

        if(vm.account.organisation.organisationType.shortName!='BANK'){
            vm.defaultTab = 'comparitive_tab1';
        }else{
            vm.defaultTab = 'comparitive_tab3';
        }
        vm.showExpandIcon = false;

        $scope.$watch('vm.defaultTab', function(value){
            $rootScope.defaultTab = value;
        })

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        $scope.$watch('vm.showPriceIcon', function(value){
            if(value==true){
                if(document.getElementById('comparitive_tab1')!=null){
                    setTimeout(function(){document.getElementById('comparitive_tab1').click()},100);    
                }
            }
        })

        function editSwapQuotes(){
            workflowSharedService.viewFrom = "swapQuotes";
            $state.go('swap-quotes-change-exp', {businessDate: vm.globalValues.getSystemSettings().businessDate});
        }

        function onChangingBankInSwapQuotes(bank){
            $rootScope.bankFromSwapQuote = bank;
            $scope.$emit('onChangingBankInSwapQuotes');
            $uibModalInstance.close();
        }

        function onChangingBankInMarkup(bank){
            $rootScope.bankFromMarkup = bank;
            $scope.$emit('onChangingBankInMarkup');
            $uibModalInstance.close();
        }

    }   
})();

(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.controller('SwapQuotesForTenorDatesDialogController', SwapQuotesForTenorDatesDialogController);

	SwapQuotesForTenorDatesDialogController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','SwapQuotes','entity', 'DateUtils', 'ScreenLog','entityConstants', 'AlertService', '$filter', 'Workflow','SwapQuotesForTenorDates','systemSettings'];

	function SwapQuotesForTenorDatesDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,SwapQuotes,entity,DateUtils,ScreenLog,entityConstants,AlertService,$filter, Workflow,SwapQuotesForTenorDates,systemSettings) {
		var vm = this;
		vm.swapQuotesForTenorDatesList=entity;  
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.SWAP_QUOTES;
		vm.stringBusinessDate = $state.params.businessDate;
		vm.businessDate = DateUtils.convertLocalDateFromServer(vm.stringBusinessDate);
		vm.entityConstants = entityConstants;
		vm.screenLog = ScreenLog;
		vm.clear=clear;
		vm.save=save;
		vm.clicked=false;
		$scope.showButton = false;
		vm.globalValues = GlobalValues;
		vm.currentDate = systemSettings.businessDate;
		vm.bank = vm.globalValues.getBank();
		vm.instrumentList = [];
		vm.bidErrorList = [];
		vm.offerErrorList = [];
		vm.swapQuotesForTenorDatesDTO ={};
		vm.checkWhetherBidValueIsModified = checkWhetherBidValueIsModified;
		vm.checkWhetherOfferValueIsModified = checkWhetherOfferValueIsModified;
		vm.isModified = isModified;
		
		
		$scope.showButton = false;
		$scope.showResubmitButton = false;
		$scope.showApproveRejectButton = false;
		$scope.showDiscardButton = false;
		vm.approveSwapQuotes = approveSwapQuotes;
		vm.rejectSwapQuotes = rejectSwapQuotes;
		vm.discardSwapQuotes = discardSwapQuotes;
		vm.resubmitSwapQuotes =resubmitSwapQuotes;
		vm.onSpreadValueChange = onSpreadValueChange;

		vm.removeErrorFromList = removeErrorFromList;
		vm.pushErrorToList = pushErrorToList;
		vm.isNotNewEdit = true;
		vm.checkForModification = false;
		//vm.spreadValueError = spreadValueError;
		//vm.tenorNameBidValueMap = {};
		//vm.tenorNameOfferValueMap = {};
		
		if(workflowSharedService.viewFrom == 'swapQuotes'){
			vm.swapQuotes=entity;
			SwapQuotesForTenorDates.getSettlementDateForCashTomFrwd(onInstrumentSuccess, onInstrumentFailure);
			vm.previousQuotes = angular.copy(vm.swapQuotes);
			$scope.showButton = true;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			vm.disableSpread=false;
			$scope.showResubmitButton = false;
			vm.isNotNewEdit = false;
			vm.checkForModification = true;
		}else if(workflowSharedService.viewFrom == 'swapQuotes_checker') {
			vm.swapQuotesForTenorDatesDTO =  angular.fromJson($rootScope.payload);
			vm.businessDate = DateUtils.convertLocalDateFromServer(vm.swapQuotesForTenorDatesDTO.businessDate);
			vm.swapQuotesForTenorDatesList = angular.copy(vm.swapQuotesForTenorDatesDTO.swapQuotesForTenorDatesList);
			SwapQuotesForTenorDates.getSettlementDateForCashTomFrwd(onInstrumentSuccess, onInstrumentFailure);
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton=true;
			$scope.showDiscardButton = false;
			vm.disableSpread=true;
			vm.checkForModification = false;
		}
		else if(workflowSharedService.viewFrom == 'swapQuotes_maker') {
			vm.swapQuotesForTenorDatesDTO =  angular.fromJson($rootScope.payload);
			vm.businessDate = DateUtils.convertLocalDateFromServer(vm.swapQuotesForTenorDatesDTO.businessDate);
			vm.swapQuotesForTenorDatesList = angular.copy(vm.swapQuotesForTenorDatesDTO.swapQuotesForTenorDatesList);
			SwapQuotesForTenorDates.getSettlementDateForCashTomFrwd(onInstrumentSuccess, onInstrumentFailure);
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton=false;
			$scope.showDiscardButton = true;
			vm.disableSpread=true;
			vm.checkForModification = false;
		}
		else if(workflowSharedService.viewFrom == 'swapQuotes_resubmit') {
			vm.swapQuotesForTenorDatesDTO =  angular.fromJson($rootScope.payload);
			vm.stringBusinessDate = vm.swapQuotesForTenorDatesDTO.businessDate;
			vm.businessDate = DateUtils.convertLocalDateFromServer(vm.swapQuotesForTenorDatesDTO.businessDate);
			vm.swapQuotesForTenorDatesList = vm.swapQuotesForTenorDatesDTO.swapQuotesForTenorDatesList;
			SwapQuotesForTenorDates.getSettlementDateForCashTomFrwd(onInstrumentSuccess, onInstrumentFailure);
			vm.screenLog.screenLog(vm.screenName, vm.swapQuotesForTenorDatesDTO.id==null?0:vm.swapQuotesForTenorDatesDTO.id, entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
			vm.disableForm = false;
			$scope.showButton=false;
			$scope.showResubmitButton = true;
			$scope.showApproveRejectButton=false;
			$scope.showDiscardButton = false;
			vm.disableSpread=false;
			vm.checkForModification = true;
			vm.isNotNewEdit = false;
		}
		else if(workflowSharedService.viewFrom == 'swapQuotes_auditLog') {
			vm.swapQuotesForTenorDatesDTO =  angular.fromJson($rootScope.payload);
			vm.swapQuotesForTenorDatesList = vm.swapQuotesForTenorDatesDTO.swapQuotesForTenorDatesList;
			vm.bank = vm.swapQuotesForTenorDatesDTO.bank;
			vm.stringBusinessDate = vm.swapQuotesForTenorDatesDTO.businessDate;
			vm.businessDate = DateUtils.convertLocalDateFromServer(vm.swapQuotesForTenorDatesDTO.businessDate);
			SwapQuotesForTenorDates.getSettlementDateForCashTomFrwd(onInstrumentSuccess, onInstrumentFailure);
			vm.disableForm = true;
			$scope.showButton=false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton=false;
			$scope.showDiscardButton = false;
			vm.disableSpread=true;
			vm.isNotNewEdit = false;
		}
		//vm.businessDate = DateUtils.convertLocalDateFromServer(vm.swapQuotes.businessDate)
		if(( workflowSharedService.viewFrom == 'swapQuotes_resubmit' || workflowSharedService.viewFrom == 'swapQuotes') && vm.stringBusinessDate != DateUtils.convertLocalDateToServer(vm.currentDate) ){
			vm.clicked=true;

			AlertService.error($filter('translate')('gatewayApp.swapQuotes.pastDateEditError'));
			vm.disableSpread=true;
			

		}
		
		angular.forEach(vm.swapQuotesForTenorDatesList , function(item){
			item.bidError = false;
			item.offerError = false;
			/*if( workflowSharedService.viewFrom == 'swapQuotes'){
				//vm.tenorNameBidValueMap[item.tenorName] = item.bidSpread;
				//vm.tenorNameOfferValueMap[item.tenorName] = item.offerSpread; 
				item.initialBidSpread = item.bidSpread;
				item.initialOfferSpread = item.offerSpread;
			}*/
		});

		function clear () {
			$uibModalInstance.dismiss('cancel');
		}

		function save () {        	    		

			if(vm.stringBusinessDate != DateUtils.convertLocalDateToServer(vm.currentDate) ){
				AlertService.error($filter('translate')('gatewayApp.swapQuotes.pastDateEditError'));
				vm.clicked=false;
			}
			vm.swapQuotesForTenorDatesDTO.swapQuotesForTenorDatesList = vm.swapQuotesForTenorDatesList;
			vm.swapQuotesForTenorDatesDTO.bank = vm.bank;
			vm.swapQuotesForTenorDatesDTO.businessDate = DateUtils.convertLocalDateToServer(vm.businessDate);
				
			SwapQuotesForTenorDates.update({ "orgId": GlobalValues.getOrgId()},vm.swapQuotesForTenorDatesDTO, onSaveSuccess, onSaveError);

		}

		function onSaveSuccess (result) {
			//$uibModalInstance.dismiss('cancel');
			angular.element("#BidSpread_0").focus();
		}

		function onSaveError () {

			vm.clicked = false;
			angular.element("#BidSpread_0").focus();
		}
		function resubmitSwapQuotes() {
			vm.swapQuotesForTenorDatesDTO.businessDate = DateUtils.convertLocalDateToServer(vm.businessDate);
			
			SwapQuotes.resubmit({"taskId" : $rootScope.taskID}, vm.swapQuotesForTenorDatesDTO, onResubmitSuccess, onResubmitError);
			$uibModalInstance.dismiss('cancel');
		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
		}        
		function onResubmitError(error) {
			vm.clicked = false;
			angular.element("#BidSpread_0").focus();
		}

		function rejectSwapQuotes() { Workflow.rejectTask($rootScope.taskID); }

		function discardSwapQuotes() {
			SwapQuotesForTenorDates.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
			$uibModalInstance.dismiss('cancel');	
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);        	
		}        
		function onDiscardError(error) {

		}

		function approveSwapQuotes() {  
			SwapQuotesForTenorDates.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
			$uibModalInstance.dismiss('cancel');     	
		}

		function onApproveSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);        	
		}        
		function onApproveError(error) {

		}


		function onInstrumentSuccess(result){
			vm.instrumentList = result;
			angular.forEach(  vm.instrumentList, function(item){

				if(item.instrumentCode =='CASH'){
					vm.cashTickSize = item.tickSize * 100; // convert to paise
					/*if(item.isSettlementDateHoliday==true){
       		 			vm.disableCashSpread= true;   		 			
       		 		}else{
       		 			vm.disableCashSpread= false;   		 		
       		 		}  */  
				}

				if (item.instrumentCode =='TOM' ){
					vm.tomTickSize = item.tickSize * 100;
					/*if(item.isSettlementDateHoliday==true){
       		 			vm.disableTOMSpread= true;       		 			
       		 		}else{
       		 			vm.disableTOMSpread= false;       		 	   
       		 		} */      		 		
				}
				if (item.instrumentCode =='Forward' ){
					vm.forwardTickSize = item.tickSize * 100;
					/*if(item.isSettlementDateHoliday==true){
    		 			vm.disableTOMSpread= true;       		 			
    		 		}else{
    		 			vm.disableTOMSpread= false;       		 	   
    		 		} */      		 		
				}

			});
		}
		function onInstrumentFailure(error){

		}

		function isValidSpreadValue(rowCount,spreadValue,tickSize,bidOrOffer){
			if(spreadValue !=null && spreadValue!=undefined && spreadValue!='' && tickSize!=undefined && tickSize!=null){

				// convert spread to float
				var intSpreadValue = Math.round(parseFloat(spreadValue) * 100);

				var tickSizeInPaise = Math.round(parseFloat(tickSize)*100);// convert tick size to fixed decimal
				

				var remainder = intSpreadValue % tickSizeInPaise;
				
				// fix remainder to 2 decimal
				if(remainder>0 || remainder<0){
					//set the error to the list based on the index
					if(bidOrOffer=='Bid'){
						vm.swapQuotesForTenorDatesList[rowCount].bidError = true;
					}else{
						vm.swapQuotesForTenorDatesList[rowCount].offerError = true;
					}
					pushErrorToList(bidOrOffer,rowCount);
				}else{
					//remove the error if present
					if(bidOrOffer=='Bid'){
						vm.swapQuotesForTenorDatesList[rowCount].bidError = false;
					}
					else{
						vm.swapQuotesForTenorDatesList[rowCount].offerError = false;
					}
					
					removeErrorFromList(bidOrOffer,rowCount);

				}

			}
			else if(( spreadValue==null || spreadValue==undefined || spreadValue=='' ) && tickSize!=undefined && tickSize!=null){
				if(bidOrOffer=='Bid'){
					vm.swapQuotesForTenorDatesList[rowCount].bidError = false;
				}
				else{
					vm.swapQuotesForTenorDatesList[rowCount].offerError = false;
				}
				
				removeErrorFromList(bidOrOffer,rowCount);
			}
			
			return true;
		}
		
		function removeErrorFromList(bidOrOffer,rowCount){
			if(bidOrOffer=='Bid'){
				angular.forEach(vm.bidErrorList, function(value){
					if(value==rowCount){
						if(vm.bidErrorList.length == 1){
							vm.bidErrorList = [];
						}
						else{
							vm.bidErrorList.splice(value,1);
						}
						
					}
				});
				
			}else{
				angular.forEach(vm.offerErrorList, function(value){
					if(value==rowCount){
						if(vm.offerErrorList.length == 1){
							vm.offerErrorList = [];
						}else{
							vm.offerErrorList.splice(value,1);
						}
						
					}
				});
			}
		}

		function pushErrorToList(bidOrOffer,rowCount){
			var errorPresent = 0;
			if(bidOrOffer=='Bid'){				
				angular.forEach(vm.bidErrorList, function(value){
					if(value==rowCount){
						errorPresent = 1;
						return true;
					}
				});
				if(errorPresent !=1){
					vm.bidErrorList.push(rowCount);
				}				
			}
			else{
				angular.forEach(vm.offerErrorList, function(value){
					if(value==rowCount){
						errorPresent = 1;
						return true;
					}
				});
				if(errorPresent != 1){
					vm.offerErrorList.push(rowCount);
				}
				
			}
			
		}
		
		/*function findErrorPresent(){
			angular.forEach(vm.errorList, function(item){
				if(item == "Bid" || item == "Offer"){
					return true;
				}
			});
						
				return false;
			
		}*/
		
		function onSpreadValueChange(rowCount, spreadValue,bidOrOffer,swapQuotes){
			if(swapQuotes.tenorName == "CASH"){
				isValidSpreadValue(rowCount,spreadValue,vm.cashTickSize,bidOrOffer)
			}
			else if(swapQuotes.tenorName == "TOM"){
				isValidSpreadValue(rowCount,spreadValue,vm.tomTickSize,bidOrOffer)

			}
			else{
				isValidSpreadValue(rowCount,spreadValue,vm.forwardTickSize,bidOrOffer)
			}
			
		}
		function checkWhetherBidValueIsModified(index, swapQuotes){
			//console.log("bid" + index);
			if(vm.checkForModification){
				if(workflowSharedService.viewFrom == 'swapQuotes_auditLog'){
					swapQuotes.isBidSpreadModified = false;
				}else{
				swapQuotes.isBidSpreadModified = checkForModification(swapQuotes.initialBidSpread,swapQuotes.bidSpread );
				}
			}
			//console.log("bid mod" + swapQuotes.isBidSpreadModified);
		}
		function checkWhetherOfferValueIsModified(index, swapQuotes){
			//console.log("offer" + index);
			if(vm.checkForModification){
				if(workflowSharedService.viewFrom == 'swapQuotes_auditLog'){
					swapQuotes.isOfferSpreadModified = false;
				}else{			
					swapQuotes.isOfferSpreadModified = checkForModification(swapQuotes.initialOfferSpread,swapQuotes.offerSpread);
				}
			}
			//console.log("offer mod" + swapQuotes.isOfferSpreadModified);
		}
		function checkForModification(intialSpread, givenSpread){
			console.log( intialSpread);
			console.log(givenSpread);
			if( ( (intialSpread===null || intialSpread === undefined ||  intialSpread ==="")
					&& ( givenSpread===null || givenSpread === undefined ||  givenSpread ==="") )	 ){
			//both null
					//console.log("first");
				return false;
			}else if( intialSpread === givenSpread){
				//console.log("third");
				return false;
			}else{
				//console.log("fourth");
					return  true;
			}
		}
		
		function isModified(isSpreadModified){
			return (vm.isNotNewEdit && isSpreadModified);
			
		}
	

	}   //
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('swap-quotes', {
            parent: 'entity',
            url: '/swap-quotes',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.swapQuotes.manageSwapQuotes" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/swap-quotes-for-tenor-date/swap-quotes-for-tenor-date.html',
                    controller: 'SwapQuotesTenorDatesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	systemSettings:['SwapQuotesForTenorDates',  function (SwapQuotesForTenorDates) {
                   
                    return SwapQuotesForTenorDates.getSystemSettings().$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('swapQuotes');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('swap-quotes.edit', {
            parent: 'swap-quotes',
            url: '/edit/{businessDate}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes-for-tenor-date/swap-quotes-for-tenor-dates-dialog.html',
                    controller: 'SwapQuotesForTenorDatesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {                 	
                            	 entity: ['SwapQuotesForTenorDates', 'GlobalValues', function(SwapQuotesForTenorDates, GlobalValues) {
                                     return SwapQuotesForTenorDates.get({orgId:GlobalValues.getBank().id,businessDate : $stateParams.businessDate}).$promise;
                                 }],
                                 systemSettings:['SwapQuotesForTenorDates',  function (SwapQuotesForTenorDates) {
                                     
                                     return SwapQuotesForTenorDates.getSystemSettings().$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
        .state('swap-quotes-change', {
            parent: 'home',
            url: '/swap-quotes-change/{businessDate}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes-for-tenor-date/swap-quotes-for-tenor-dates-dialog.html',
                    controller: 'SwapQuotesForTenorDatesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                    	 entity: ['SwapQuotesForTenorDates', 'GlobalValues', function(SwapQuotesForTenorDates, GlobalValues) {
                             return SwapQuotesForTenorDates.get({orgId:GlobalValues.getBank().id,businessDate : $stateParams.businessDate}).$promise;
                         }],
                         systemSettings:['SwapQuotesForTenorDates',  function (SwapQuotesForTenorDates) {
                             
                             return SwapQuotesForTenorDates.getSystemSettings().$promise;
                         }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
       
        .state('swap-quotes-change-exp', {
            parent: 'swap-quotes-home-page',
            url: '/swap-quote-change/{businessDate}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes-for-tenor-date/swap-quotes-for-tenor-dates-dialog.html',
                    controller: 'SwapQuotesForTenorDatesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        
                         entity: ['SwapQuotesForTenorDates', 'GlobalValues', function(SwapQuotesForTenorDates, GlobalValues) {
                             return SwapQuotesForTenorDates.get({orgId:GlobalValues.getBank().id,businessDate : $stateParams.businessDate}).$promise;
                         }],
                         systemSettings:['SwapQuotesForTenorDates',  function (SwapQuotesForTenorDates) {
                             
                             return SwapQuotesForTenorDates.getSystemSettings().$promise;
                         }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
       
         .state('swap-quotes-todolist', {
            parent: 'dashboard',
            url: '/swapQuotesView',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes-for-tenor-date/swap-quotes-for-tenor-dates-dialog.html',
                    controller: 'SwapQuotesForTenorDatesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        systemSettings:['SwapQuotesForTenorDates',  function (SwapQuotesForTenorDates) {
                            
                            return SwapQuotesForTenorDates.getSystemSettings().$promise;
                        }]
                        
                    }
                }).result.then(function() {
                	$state.go('swap-quotes', null, { reload: 'swap-quotes' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('swapQuotes');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
            
        })
        
         .state('swap-quotes-todolist.resubmit', {
            parent: 'dashboard',
            url: '/swapQuotesResubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes-for-tenor-date/swap-quotes-for-tenor-dates-dialog.html',
                    controller: 'SwapQuotesForTenorDatesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        },
                        systemSettings:['SwapQuotesForTenorDates',  function (SwapQuotesForTenorDates) {
                            
                            return SwapQuotesForTenorDates.getSystemSettings().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('swap-quotes', null, { reload: 'swap-quotes' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('swapQuotes');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('swapQuotes-auditLog', {
            parent: 'audit-log',
            url: '/swapQuotesauditlog',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes-for-tenor-date/swap-quotes-for-tenor-dates-dialog.html',
                    controller: 'SwapQuotesForTenorDatesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        },
                        systemSettings:['SwapQuotesForTenorDates',  function (SwapQuotesForTenorDates) {
                            
                            return SwapQuotesForTenorDates.getSystemSettings().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('swap-quotes', null, { reload: 'swap-quotes' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('swapQuotes');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('swapQuotes-historyReport', {
            parent: 'history-report',
            url: '/swapQuoteshistoryReport',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes-for-tenor-date/swap-quotes-for-tenor-dates-dialog.html',
                    controller: 'SwapQuotesForTenorDatesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        },
                        systemSettings:['SwapQuotesForTenorDates',  function (SwapQuotesForTenorDates) {
                            
                            return SwapQuotesForTenorDates.getSystemSettings().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('swap-quotes', null, { reload: 'swap-quotes' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('swapQuotes');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('old-swapQuotes-auditLog', {
            parent: 'audit-log',
            url: '/oldswapQuotesauditlog',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes/swap-quotes-dialog.html',
                    controller: 'SwapQuotesDialogController1',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('swap-quotes', null, { reload: 'swap-quotes' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('swapQuotes');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('old-swapQuotes-historyReport', {
            parent: 'history-report',
            url: '/oldswapQuoteshistroyreport',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes/swap-quotes-dialog.html',
                    controller: 'SwapQuotesDialogController1',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('swap-quotes', null, { reload: 'swap-quotes' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('swapQuotes');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
         };
    })();

(function() {
	'use strict';
	angular
	.module('gatewayApp')
	.factory('SwapQuotesForTenorDates', SwapQuotesForTenorDates);

	SwapQuotesForTenorDates.$inject = ['$resource'];

	function SwapQuotesForTenorDates ($resource) {
		var resourceUrl =  'api/swap-quotes-tenor-date/:orgId/:businessDate';

		return $resource(resourceUrl, {}, {  
			
			'getSystemSettings':{
				method: 'GET',			
				url:'api/swap-quotes-for-tenor-date/system-settings',
				transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
			},

			'get':{ 
				method: 'GET',
				params: {orgId:'@orgId', businessDate :'@businessDate' , toDate: '@toDate'},
				url:'api/swap-quotes-tenor-date/:orgId/:businessDate', 
				isArray:true,			

			},
			'update': {
            	method:'PUT',
            	params: {orgId:'@orgId'},
                url: 'api/swap-quotes-tenor-date/:orgId',
                isArray:true,
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
			'getAllSwapQuotes': {
				method: 'GET',
				params: {orgId:'@orgId', fromDate :'@fromDate' , toDate: '@toDate'},
				url:'api/swap-quotes-tenor-date/:orgId/:fromDate/:toDate', 
				isArray:true


			},
			'getSettlementDateForCashTomFrwd':{
				method: 'GET',
				url:'api/swap-quotes-for-tenor-date/csInstrumentList', 
				isArray:true
			},
			'approve': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
              	 method: 'GET',
                   params: {taskId:'@taskId'},
                   url: 'api/tasks/:taskId/discard'
             },
			'exportData':{
				method: 'POST',
				url: 'api/swap-quotes-view/export',
				responseType: 'arraybuffer',
				params : { orgId : '@orgId',from :'@from', to : '@to'},
				transformRequest: function (data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				},
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				} 
			},
			'generateTemplateCSV':{
				method: 'POST',
				url: 'api/swap-quotes-tenor-date/generate-template/:orgId/:businessDate',
				responseType: 'arraybuffer',
				params : { orgId : '@orgId', businessDate :'@businessDate'},
				transformRequest: function (data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				},
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				} 
			},
			'exportDataPdf':{
				method: 'POST',
				url: 'api/swap-quotes-tenor-dates-view/export-pdf',
				responseType: 'arraybuffer',
				params : {orgId : '@orgId',from :'@from', to : '@to'},
				transformRequest: function (data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				},
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				} 
			},
            'getSwapQuotesForAllBanks': {
                method: 'GET',
                url:'api/swap-quotes-tenor-for-all-banks', 
            },           

            'getSwapQuotesForGivenBank': {
                method: 'GET',
                params: {bankId:'@bankId'},
                url:'api/swap-quotes-tenor-for-given-bank/:bankId', 
            },           

            'getSwapQuotesForGivenCustomer': {
                method: 'GET',
                params: {customerId:'@customerId'},
                url:'api/swap-quotes-tenor-for-given-customer/:customerId', 
            }
		});
	}
})();



(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.service("workflowSharedService", function () {        	
		this.viewFrom= 'swapQuotes'
	})

	.controller('SwapQuotesTenorDatesController', SwapQuotesTenorDatesController);

	SwapQuotesTenorDatesController.$inject = ['$scope', '$state', 'workflowSharedService', 'SwapQuotes', 'GlobalValues', 'EntityPermissions', 'ScreenLog', 'entityConstants','DateUtils', 'AlertService', '$filter','SwapQuotesForTenorDates','ImportFile', 'systemSettings'];
	function SwapQuotesTenorDatesController($scope, $state, workflowSharedService, SwapQuotes, GlobalValues, EntityPermissions, ScreenLog , entityConstants, DateUtils, AlertService,$filter,SwapQuotesForTenorDates,ImportFile, systemSettings) {

		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.SWAP_QUOTES;
		vm.entityConstants = entityConstants;
		vm.screenLog = ScreenLog;
		vm.loadAll = loadData;
		vm.clicked=false;
		vm.editSwapQuotes = editSwapQuotes;		
		vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
		/*vm.exportDataToExcelFile = exportDataToExcelFile;
		vm.exportDataToCsvFile = exportDataToCsvFile;
		vm.exportDataToPdfFile = exportDataToPdfFile;*/
		vm.noOfMonthsForHistoricalView = vm.globalValues.getConfigSettings().noOfMOnthsForHistoricalReportsView;
		vm.generateSwapQuotesTemplate = generateSwapQuotesTemplate;
		vm.uploadedData =null;
		vm.checkSODCompleted = checkSODCompleted;
		//vm.importFile = importFile;
		var systemSettings = systemSettings;
		vm.systemSettings = systemSettings; 
		if(systemSettings!=null && systemSettings!=undefined){
			vm.currentDate = systemSettings.businessDate;
			vm.currentBusinessDate = systemSettings.businessDate;
			vm.fromDate = DateUtils.convertLocalDateFromServer(vm.currentBusinessDate);
			vm.toDate = DateUtils.convertLocalDateFromServer(vm.currentBusinessDate);
			vm.minDate = DateUtils.getMinimumLocalDate(DateUtils.convertLocalDateFromServer(vm.currentBusinessDate));
		}
		

		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;
		workflowSharedService.viewFrom = "swapQuotes";

		vm.permitSwapQuotesEditEntityAction = EntityPermissions.hasPermission( vm.screenName+'.' +vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);

		function loadData(){

			var fromServerDate = DateUtils.convertLocalDateToServer(vm.fromDate);
			var toServerDate = DateUtils.convertLocalDateToServer(vm.toDate);
			if(moment(vm.fromDate).isAfter(vm.currentDate,'day') || moment(vm.toDate).isAfter(vm.currentDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.swapQuotes.forwardDateViewError'));

			}else if(moment(vm.fromDate).isAfter(vm.toDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.swapQuotes.fromDateError'));

			}/*else if(moment(vm.fromDate).isBefore(vm.minDate, 'day')){
	   			AlertService.error('Historical Reports are available only for a period of '  + vm.noOfMonthsForHistoricalView + ' months...!');
	   			vm.valid=false;
	   		}*/
			else{
				vm.clicked=true;
				SwapQuotesForTenorDates.getAllSwapQuotes({ orgId : vm.globalValues.getOrganisation().id , fromDate : fromServerDate, toDate : toServerDate} , function(result) {
					vm.swapQuotesForTenorDates = result; 
					vm.clicked=false;                   
				});


			}
		}

		logScreenAccess();

		//SwapQuotesForTenorDates.getSystemSettings(onObtainSuccess);
		
		function logScreenAccess(){
			ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}

		function editSwapQuotes(swapQuotes,$event){			
		
			
			if(swapQuotes.businessDate != DateUtils.convertLocalDateToServer(vm.currentDate) ){
				AlertService.error($filter('translate')('gatewayApp.swapQuotes.pastDateEditError'));

			}
			else if(vm.systemSettings != null && vm.systemSettings !=undefined  && (vm.systemSettings.eodStatus == 'INCOMPLETE' || vm.systemSettings.eodStatus == 'INPROGRESS')){
				
					AlertService.error($filter('translate')('gatewayApp.swapQuotes.cannotEdit'));

			}
			else{
				ScreenLog.screenLog(vm.screenName,swapQuotes.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
				//$state.params = {id:swapQuotes.id}
				var state = '.edit';
				$state.go(state,{businessDate:swapQuotes.businessDate});
			}
		}

		/*function onObtainSuccess(result){
			vm.systemSettings = result 
		}*/
		
		 $scope.$watch('vm.uploadedData', function(value){
         	if(value!=null && value!=undefined){
         		if(checkSODCompleted() == true){
         			ImportFile.importFile("SwapQuotesImport", value);
             		angular.element("input[type='file']").val(null);
         		}
         		else{
         			AlertService.error($filter('translate')('gatewayApp.swapQuotes.sodIncomplete'));
         		}
         	}
         })
         
        function checkSODCompleted(){
			 if(systemSettings.sodStatus != 'COMPLETED'){
				 return false;
			 }else{
				 return true;
			 }
		 }
		
		function importFile(uploadType,fileContent){
			ImportFile.importFile(uploadType,fileContent);
		}
		
		function generateSwapQuotesTemplate(){
				vm.mimeType = 'text/csv';
				vm.extension = ".csv";  
				SwapQuotesForTenorDates.generateTemplateCSV({orgId: vm.globalValues.getOrganisation().id,businessDate:DateUtils.convertLocalDateToServer(vm.currentBusinessDate)}, onImportSuccess);
		}
		/*function exportDataToExcelFile(){
			if(vm.swapQuotesForTenorDates !=null &&  vm.swapQuotesForTenorDates!=undefined && vm.swapQuotesForTenorDates.length>0){
				vm.mimeType = 'application/vnd.ms-excel';
				vm.extension = ".xls";  
				SwapQuotesForTenorDates.exportData({orgId:  vm.globalValues.getOrganisation().id, from:  DateUtils.convertLocalDateToServer(vm.fromDate), to:  DateUtils.convertLocalDateToServer(vm.toDate)}, vm.swapQuotesForTenorDates, onExportSuccess);
			}
		}

		

		function exportDataToPdfFile(){
			if(vm.swapQuotesForTenorDates !=null &&  vm.swapQuotesForTenorDates!=undefined && vm.swapQuotesForTenorDates.length>0){
				vm.mimeType = 'application/pdf';
				vm.extension = ".pdf";  
				SwapQuotesForTenorDates.exportDataPdf({orgId:  vm.globalValues.getOrganisation().id, from:  DateUtils.convertLocalDateToServer(vm.fromDate), to:  DateUtils.convertLocalDateToServer(vm.toDate)}, vm.swapQuotesForTenorDates, onExportSuccess);
			}
		}
		*/
		 function onImportSuccess(result){        	  
	      	  var fileData = null;
	  		  fileData = result.data;
	  		  var link = document.createElement("a");   
	  		  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
	  		  vm.baseString = "SwapQuotesImport"+  vm.extension; 
	  		  
	  	      var blob = new Blob([bytes], {type: vm.mimeType});
	  	      if(window.navigator.msSaveOrOpenBlob){
	                  window.navigator.msSaveOrOpenBlob(blob, vm.baseString);
	  	      }else{
	  	    	  link.href =  window.URL.createObjectURL(blob);      
	  	    	  link.download = vm.baseString;
	  	    	  document.body.appendChild(link);
	  	    	  link.click();
	  	    	  document.body.removeChild(link);
	  	      }
	  	}


	}
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('SwapQuotesDialogController1', SwapQuotesDialogController1);

    SwapQuotesDialogController1.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','SwapQuotes','entity', 'DateUtils', 'ScreenLog','entityConstants', 'AlertService', '$filter', 'Workflow'];

     function SwapQuotesDialogController1($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,SwapQuotes,entity,DateUtils,ScreenLog,entityConstants,AlertService,$filter, Workflow) {
        var vm = this;
        vm.swapQuotes=entity;  
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.SWAP_QUOTES;
        vm.entityConstants = entityConstants;
        vm.screenLog = ScreenLog;
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        vm.resubmitSwapQuotes =resubmitSwapQuotes;
        //vm.currentDate = new Date();
        vm.globalValues = GlobalValues;
        vm.currentDate = vm.globalValues.getSystemSettings().businessDate;
        vm.disableSpread= false;
        $scope.showButton = false;
        $scope.showResubmitButton = false;
        $scope.showApproveRejectButton = false;
        $scope.showDiscardButton = false;
        vm.approveSwapQuotes = approveSwapQuotes;
        vm.rejectSwapQuotes = rejectSwapQuotes;
        vm.discardSwapQuotes = discardSwapQuotes;
        vm.previousQuotes = {};
        vm.disableCashSpread= false;
        vm.disableTOMSpread= false;
        vm.instrumentList = [];
        vm.showcashBidError=false;
        vm.showcashOfferError=false;
        vm.showtomBidError=false;
        vm.showtomOfferError=false;
                
        if(workflowSharedService.viewFrom == 'swapQuotes'){
        	vm.swapQuotes=entity;
        	 SwapQuotes.getSettlementDateForCashAndTOM(onInstrumentSuccess, onInstrumentFailure);
        	 vm.previousQuotes = angular.copy(vm.swapQuotes);
        	 $scope.showButton = true;
             $scope.showApproveRejectButton = false;
             $scope.showDiscardButton = false;
             vm.disableSpread=false;
             $scope.showResubmitButton = false;
        }else if(workflowSharedService.viewFrom == 'swapQuotes_checker') {
        	vm.swapQuotes =  angular.fromJson($rootScope.payload); 
        	 SwapQuotes.getSettlementDateForCashAndTOM(onInstrumentSuccess, onInstrumentFailure);
        	 $scope.showButton = false;
        	 $scope.showResubmitButton = false;
        	$scope.showApproveRejectButton=true;
        	$scope.showDiscardButton = false;
        	 vm.disableSpread=true;
        }
        else if(workflowSharedService.viewFrom == 'swapQuotes_maker') {
        	vm.swapQuotes =  angular.fromJson($rootScope.payload); 
        	 SwapQuotes.getSettlementDateForCashAndTOM(onInstrumentSuccess, onInstrumentFailure);
        	 $scope.showButton = false;
        	 $scope.showResubmitButton = false;
        	$scope.showApproveRejectButton=false;
        	$scope.showDiscardButton = true;
        	 vm.disableSpread=true;
        }
        else if(workflowSharedService.viewFrom == 'swapQuotes_resubmit') {
        	vm.swapQuotes = angular.fromJson($rootScope.payload); 
        	 SwapQuotes.getSettlementDateForCashAndTOM(onInstrumentSuccess, onInstrumentFailure);
        	vm.screenLog.screenLog(vm.screenName, vm.swapQuotes.id==null?0:vm.swapQuotes.id, entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
        	vm.disableForm = false;
        	$scope.showButton=false;
        	 $scope.showResubmitButton = true;
        	$scope.showApproveRejectButton=false;
        	$scope.showDiscardButton = false;
        	 vm.disableSpread=false;
        }
       else if(workflowSharedService.viewFrom == 'swapQuotes_auditLog') {
        	vm.swapQuotes = angular.fromJson($rootScope.payload); 
        	 SwapQuotes.getSettlementDateForCashAndTOM(onInstrumentSuccess, onInstrumentFailure);
        	vm.disableForm = true;
        	$scope.showButton=false;
        	$scope.showResubmitButton = false;
        	$scope.showApproveRejectButton=false;
        	$scope.showDiscardButton = false;
        	vm.disableSpread=true;
        }
		vm.businessDate = DateUtils.convertLocalDateFromServer(vm.swapQuotes.businessDate)
		if(( workflowSharedService.viewFrom == 'swapQuotes_resubmit' || workflowSharedService.viewFrom == 'swapQuotes') && vm.swapQuotes.businessDate != DateUtils.convertLocalDateToServer(vm.currentDate) ){
				vm.clicked=true;
				
				AlertService.error($filter('translate')('gatewayApp.swapQuotes.pastDateEditError'));
				vm.disableSpread=true;
				//$scope.clicked=false;
			
		
		}
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {        	    		
        	
       		if(vm.swapQuotes.businessDate != DateUtils.convertLocalDateToServer(vm.currentDate) ){
       			AlertService.error($filter('translate')('gatewayApp.swapQuotes.pastDateEditError'));
       			vm.clicked=false;
       			
       		}
       		
       		else if (vm.swapQuotes.id !== null) {
       			if(validateChange()){
       			 
       				SwapQuotes.update({ "orgId": GlobalValues.getOrgId() },vm.swapQuotes, onSaveSuccess, onSaveError);
       			}else{
       				AlertService.error($filter('translate')('gatewayApp.swapQuotes.noChangesMade'));
       				vm.clicked=false;
       			}
        		
             }else {
            	 SwapQuotes.save({ "orgId": GlobalValues.getOrgId() },vm.swapQuotes, onSaveSuccess, onSaveError);           
             }       	
       	
         }
     
        function onSaveSuccess (result) {
        	//$scope.clicked=true;
        //	$uibModalInstance.close(result);  
        }

        function onSaveError () {
        	//vm. = DateUtils.convertDateTimeFromServer(vm.swapQuotes.holidayDate);

        	vm.clicked = false;
        }
        function resubmitSwapQuotes() {
        	SwapQuotes.resubmit({"taskId" : $rootScope.taskID}, vm.swapQuotes, onResubmitSuccess, onResubmitError);
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {
        	vm.clicked = false;
        }
        
        function rejectSwapQuotes() { Workflow.rejectTask($rootScope.taskID); }

        function discardSwapQuotes() {
        	SwapQuotes.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }

        function approveSwapQuotes() {  
        	SwapQuotes.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
        function validateChange(){
        	var changesMade = false;
        	var field1 = checkvalidityOfValues(vm.previousQuotes.cashSpotBidSpread , vm.swapQuotes.cashSpotBidSpread);
        	var field2 = checkvalidityOfValues(vm.previousQuotes.cashSpotOfferSpread , vm.swapQuotes.cashSpotOfferSpread);
        	var field3 = checkvalidityOfValues(vm.previousQuotes.tomSpotBidSpread , vm.swapQuotes.tomSpotBidSpread);
        	var field4 = checkvalidityOfValues(vm.previousQuotes.tomSpotOfferSpread , vm.swapQuotes.tomSpotOfferSpread);
        	
        	if(field1 || field2 || field3 || field4 ){
        		changesMade = true;
        	}
        	return changesMade;
        }
        function checkvalidityOfValues(previousValue, currentValue){
        	//var isValueChanged = (!(previousValue == null && (currentValue == "" || currentValue== null)) && previousValue!=currentValue);
        	
        	
        	if(!(previousValue == null && (currentValue == "" || currentValue== null))){
        		if(previousValue==0 && currentValue==""){
        			return true;
        		}
        		if(previousValue!=currentValue){
        			return true;
        		}
        	}
        	return false;
        }
       function onInstrumentSuccess(result){
    	    vm.instrumentList = result;
    	    angular.forEach(  vm.instrumentList, function(item){
       		
       		 	if(item.instrumentCode =='CASH'){
       		 		vm.cashSettlementDate = item.settlementDate;
       		 		vm.cashTickSize = item.tickSize * 100; // convert to paise
       		 		if(item.isSettlementDateHoliday==true){
       		 			vm.disableCashSpread= true;   		 			
       		 		}else{
       		 			vm.disableCashSpread= false;   		 		
       		 		}    
       		 	}
       		 		  		 
       		 	if (item.instrumentCode =='TOM' ){
       		 		vm.tomSettlementDate = item.settlementDate;
       		 		vm.tomTickSize = item.tickSize * 100;
       		 		if(item.isSettlementDateHoliday==true){
       		 			vm.disableTOMSpread= true;       		 			
       		 		}else{
       		 			vm.disableTOMSpread= false;       		 	   
       		 		}       		 		
       		 	}
       		 		
    	   });
       }
       function onInstrumentFailure(error){
    	   
       }
       
       function isValidSpreadValue(tickSize, spreadValue){
    	  if(spreadValue !=null && spreadValue!=undefined && spreadValue!='' && tickSize!=undefined && tickSize!=null){
    		 
    		// var floatValue = parseFloat(spreadValue);// convert spread to float
    		 var intSpreadValue = Math.round(parseFloat(spreadValue) * 100);
    		 
    		 var tickSizeInPaise = Math.round(parseFloat(tickSize)*100);// convert tick size to fixed decimal
    		// var intTickSize = parseInt (tickSizeInPaise * 100);
    		 
    		 var remainder = intSpreadValue % tickSizeInPaise;
    		 // fix remainder to 2 decimal
    		 if(remainder>0 || remainder<0){
    			 return false;
    	  	}else{
    	  		return true;
    	  	}
    		 
    	  }
    	  return true;
       }
      $scope.$watch('vm.swapQuotes.cashSpotBidSpread' , function(value){
    	  
    	vm.showcashBidError=!isValidSpreadValue(vm.cashTickSize,value );
    	var element = angular.element('#cashBidSpread');
    	
    	  
      });
      $scope.$watch('vm.swapQuotes.cashSpotOfferSpread' , function(value){
    	
    	vm.showcashOfferError=!isValidSpreadValue(vm.cashTickSize,value );
    	  
      });
      $scope.$watch('vm.swapQuotes.tomSpotBidSpread' , function(value){
    	
    	  vm.showtomBidError=!isValidSpreadValue(vm.tomTickSize,value )
    	 
      });
      $scope.$watch('vm.swapQuotes.tomSpotOfferSpread' , function(value){
    	  
    	vm.showtomOfferError=!isValidSpreadValue(vm.tomTickSize,value );
    	  
      });
    	  
      
    	   
      		
     }   
})();

/*(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('swap-quotes', {
            parent: 'entity',
            url: '/swap-quotes',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.swapQuotes.manageSwapQuotes" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/swap-quotes/swap-quotes.html',
                    controller: 'SwapQuotesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('swapQuotes');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('swap-quotes.new', {
            parent: 'swap-quotes',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes/swap-quotes-dialog.html',
                    controller: 'SwapQuotesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	 id:null,  
                            	name:null                            	
                             
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('swap-quotes', null, { reload: 'swap-quotes' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('swap-quotes.view', {
            parent: 'swap-quotes',
            url: '/swap-quotes/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes/swap-quotes-detail.html',
                    controller: 'SwapQuotesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	
                            	 entity: ['SwapQuotes', 'GlobalValues', function(SwapQuotes, GlobalValues) {
                                     return SwapQuotes.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('swap-quotes.edit', {
            parent: 'swap-quotes',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes/swap-quotes-dialog.html',
                    controller: 'SwapQuotesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	
                            	 entity: ['SwapQuotes', 'GlobalValues', function(SwapQuotes, GlobalValues) {
                                     return SwapQuotes.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
        .state('swap-quotes-change', {
            parent: 'home',
            url: '/swap-quotes-change/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes/swap-quotes-dialog.html',
                    controller: 'SwapQuotesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['SwapQuotes', 'GlobalValues', function(SwapQuotes, GlobalValues) {
                                     return SwapQuotes.get({id : $stateParams.id}).$promise;
                                 }],
                                 translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                     $translatePartialLoader.addPart('swapQuotes');
                                     $translatePartialLoader.addPart('error');
                                     $translatePartialLoader.addPart('global');
                                     return $translate.refresh();
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
       
         .state('swap-quotes-todolist', {
            parent: 'dashboard',
            url: '/swapQuotesView',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes/swap-quotes-dialog.html',
                    controller: 'SwapQuotesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('swap-quotes', null, { reload: 'swap-quotes' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('swapQuotes');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
            
        })
        
         .state('swap-quotes-todolist.resubmit', {
            parent: 'dashboard',
            url: '/swapQuotesResubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes/swap-quotes-dialog.html',
                    controller: 'SwapQuotesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('swap-quotes', null, { reload: 'swap-quotes' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('swapQuotes');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('swapQuotes-auditLog', {
            parent: 'audit-log',
            url: '/swapQuotesauditlog',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes/swap-quotes-dialog.html',
                    controller: 'SwapQuotesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('swap-quotes', null, { reload: 'swap-quotes' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('swapQuotes');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('swapQuotes-historyReport', {
            parent: 'history-report',
            url: '/swapQuoteshistoryReport',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/swap-quotes/swap-quotes-dialog.html',
                    controller: 'SwapQuotesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('swap-quotes', null, { reload: 'swap-quotes' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('swapQuotes');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
         };
    })();
*/
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('SwapQuotes', SwapQuotes);

    SwapQuotes.$inject = ['$resource'];

    function SwapQuotes ($resource) {
        var resourceUrl =  'api/swap-quotes/:id';

        return $resource(resourceUrl, {}, {
            'get':{ method: 'GET', transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }},
            
            
            'gatAllSwapQuotes': {
                method: 'GET',
                params: {orgId:'@orgId', fromDate :'@fromDate' , toDate: '@toDate'},
                url:'api/swap-quotes/orgId/:orgId/fromDate/:fromDate/toDate/:toDate', 
                isArray:true
                     
                
            },           
            'getSwapQuotesForAllBanks': {
                method: 'GET',
                url:'api/swap-quotes-for-all-banks', 
                isArray:true
            },           

            'getSwapQuotesForGivenBank': {
                method: 'GET',
                params: {bankId:'@bankId'},
                url:'api/swap-quotes-for-given-bank/:bankId', 
                isArray:true
            },           

            'getSwapQuotesForGivenCustomer': {
                method: 'GET',
                params: {customerId:'@customerId'},
                url:'api/swap-quotes-for-given-customer/:customerId', 
                isArray:true
            },           

            'update': {
            	method:'PUT',
            	params: {orgId:'@orgId'},
                url: 'api/swap-quotes/:orgId',
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
            
            'approve': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
              	 method: 'GET',
                   params: {taskId:'@taskId'},
                   url: 'api/tasks/:taskId/discard'
             },
             'resubmit': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/resubmit/swap-quotes',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             },
             'getSettlementDateForCashAndTOM' :{
            	 method: 'GET',             
            	 url: 'api/swap-quotes/settlementDate',
            	 isArray:true
             },
             'getSwapQuotesView': {
                 method: 'GET',
                 params: {bankId:'@bankId', fromDate :'@fromDate' , toDate: '@toDate'},
                 url:'api/swap-quotes-view/:bankId/bank/:from/from/:to/to', 
                 isArray:true
             },           
             'exportData':{
   			    method: 'POST',
                   url: 'api/swap-quotes-view/export',
                   responseType: 'arraybuffer',
                   params : { bankName : '@bankName',from :'@from', to : '@to'},
                   transformRequest: function (data) {
                   	var copy = angular.copy(data);
                       return angular.toJson(copy);
                   },
                   transformResponse: function(data, headers) {
                 	  return {
                           data: data,
                           headers: headers
                       };   
                   } 
             },
             'exportDataCSV':{
    			    method: 'POST',
                    url: 'api/swap-quotes-view/export-csv',
                    responseType: 'arraybuffer',
                    params : { bankName : '@bankName',from :'@from', to : '@to'},
                    transformRequest: function (data) {
                    	var copy = angular.copy(data);
                        return angular.toJson(copy);
                    },
                    transformResponse: function(data, headers) {
                  	  return {
                            data: data,
                            headers: headers
                        };   
                    } 
              },
              'exportDataPdf':{
  			    method: 'POST',
                  url: 'api/swap-quotes-view/export-pdf',
                  responseType: 'arraybuffer',
                  params : { bankName : '@bankName',from :'@from', to : '@to'},
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                      return angular.toJson(copy);
                  },
                  transformResponse: function(data, headers) {
                	  return {
                          data: data,
                          headers: headers
                      };   
                  } 
            }
        });
    }
})();

            

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'swapQuotes'
        })
        
        .controller('SwapQuotesController', SwapQuotesController);

    SwapQuotesController.$inject = ['$scope', '$state', 'workflowSharedService', 'SwapQuotes', 'GlobalValues', 'EntityPermissions', 'ScreenLog', 'entityConstants','DateUtils', 'AlertService', '$filter'];
    function SwapQuotesController($scope, $state, workflowSharedService, SwapQuotes, GlobalValues, EntityPermissions, ScreenLog , entityConstants, DateUtils, AlertService,$filter ) {
    	
    	var vm = this;
        vm.globalValues = GlobalValues;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.SWAP_QUOTES;
        vm.entityConstants = entityConstants;
        vm.screenLog = ScreenLog;
        //vm.currentDate = new Date();
        vm.currentDate = vm.globalValues.getSystemSettings().businessDate;
       // DateUtils.convertDateTimeFromServer
       // DateUtils.convertLocalDateToServer
    //    vm.fromDate = angular.copy(vm.currentDate);
      //  vm.toDate = angular.copy(vm.currentDate);
        vm.loadAll = loadData;
        vm.editSwapQuotes = editSwapQuotes;
        vm.currentBusinessDate = vm.globalValues.getSystemSettings().businessDate;
       vm.fromDate = DateUtils.convertLocalDateFromServer(vm.currentBusinessDate);
       vm.toDate = DateUtils.convertLocalDateFromServer(vm.currentBusinessDate);
              
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;
		workflowSharedService.viewFrom = "swapQuotes";
		
		vm.permitSwapQuotesEditEntityAction = EntityPermissions.hasPermission( vm.screenName+'.' +vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
        
		function loadData(){
		
			var fromServerDate = DateUtils.convertLocalDateToServer(vm.fromDate);
			var toServerDate = DateUtils.convertLocalDateToServer(vm.toDate);
			if(moment(vm.fromDate).isAfter(vm.currentDate,'day') || moment(vm.toDate).isAfter(vm.currentDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.swapQuotes.forwardDateViewError'));
				//AlertService.error("Swap Quotes cannot be viewed for future dates");
			}else if(moment(vm.fromDate).isAfter(vm.toDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.swapQuotes.fromDateError'));
				//AlertService.error("");
			}else{
				SwapQuotes.gatAllSwapQuotes({ orgId : vm.globalValues.getOrganisation().id , fromDate : fromServerDate, toDate : toServerDate} , function(result) {
	                vm.swapQuotes = result;                
	            });
			
			
			}
		}
       
        logScreenAccess();
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }
        //loadData();
        function editSwapQuotes(swapQuotes,$event){
        	//$event.preventDefault();
        	if(swapQuotes.businessDate != DateUtils.convertLocalDateToServer(vm.currentDate) ){
       			AlertService.error($filter('translate')('gatewayApp.swapQuotes.pastDateEditError'));
       			
       		}else{
       			ScreenLog.screenLog(vm.screenName,swapQuotes.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
       			$state.params = {id:swapQuotes.id}
       			var state = '.edit';
       			$state.go(state,{id:swapQuotes.id});
       		}
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('standard-tenor-view', {
            parent: 'entity',
            params:{screen: 'StandardTenorView'}, 
            url: '/standard-tenor-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.standardTenor.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/standard-tenor-view/standard-tenor-view.html',
                    controller: 'StandardTenorViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('standardTenorView');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                systemSettings: ['IntradayMarket', function(IntradayMarket) {
                    return IntradayMarket.getCurrentBusinessDate().$promise;
                }]
               
            }
        })
    };
})();

(function() {
	'use strict';
	angular
	.module('gatewayApp')
	.factory('StandardTenorView', StandardTenorView);

	StandardTenorView.$inject = ['$resource'];

	function StandardTenorView ($resource) {
		var resourceUrl =  'api/standard-tenor-view';

		return $resource(resourceUrl, {}, {
			'get':{
				method: 'GET',
				isArray:true,
				transformResponse: function (data) {			
				if (data) {
					data = angular.fromJson(data);
				}
				return data;
			}},


			'exportData':{
				method: 'POST',
				url: 'api/standard-tenor-view/export-excel/:businessDate',
				responseType: 'arraybuffer',
				params : { businessDate : '@businessDate'},
				transformRequest: function (data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				},
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				} 
			},
			'exportDataCSV':{
				method: 'POST',
				url: 'api/standard-tenor-view/export-csv/:businessDate',
				responseType: 'arraybuffer',
				params : { businessDate : '@businessDate'},
				transformRequest: function (data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				},
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				} 
			}
		});
	}
})();



(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.service("workflowSharedService", function () {        	
		this.viewFrom= 'swap-quotes'
	})

	.controller('StandardTenorViewController', StandardTenorViewController);

	StandardTenorViewController.$inject = ['$scope', '$rootScope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
		'DateUtils',  'StandardTenorView','IntradayMarket','systemSettings'];

	function StandardTenorViewController($scope, $rootScope, $state,  GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
			DateUtils,  StandardTenorView,IntradayMarket,systemSettings) {
		var vm = this;
		vm.entityConstants = entityConstants;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.STANDARD_TENOR_VIEW;
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;
		vm.globalValues=GlobalValues;
		vm.screenLog = ScreenLog;
		vm.loadAll = loadAll; 
		vm.exportToFile = exportToFile;
		//loadCurrentBusinessDate();
		if(systemSettings != null && systemSettings != undefined){
			vm.businessDate  = DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
		}
		
		vm.ExpandOrCollapseStandardTenorView = true;
		vm.exportDataToExcelFile = exportDataToExcelFile;
		vm.exportDataToCsvFile = exportDataToCsvFile;
		vm.filterData = {};
		vm.fileName = "Standard_Tenor_View_";
		vm.extension = "";
		vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm_ss';
		vm.valid=false;
		logScreenAccess();
		loadAll();
		
		
		function logScreenAccess(){
			ScreenLog.screenLog(vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}

		function loadAll(){
			vm.standardTenorList = []; //to re-initialize the array
			StandardTenorView.get({businessDate:  DateUtils.convertLocalDateToServer(vm.businessDate)},onGetStandardTenorSuccess,onGetStandardTenorFailure)
		}

		function onGetStandardTenorSuccess(result){
			vm.standardTenorList = result;
		}

		function onGetStandardTenorFailure(){

		}


		function exportToFile(fileType){
			if(fileType=='csv'){
				exportDataToCsvFile();
			}else if(fileType=='excel'){
				exportDataToExcelFile();
			}
			$rootScope.fileType = fileType;
		}

		function exportDataToExcelFile(){
			if(vm.standardTenorList !=null &&  vm.standardTenorList!=undefined && vm.standardTenorList.length>0){
				vm.mimeType = 'application/vnd.ms-excel';
				vm.extension = ".xls";  
				StandardTenorView.exportData({businessDate:  DateUtils.convertLocalDateToServer(vm.businessDate)}, onExportSuccess);
			}
		}

		function exportDataToCsvFile(){
			if(vm.standardTenorList !=null &&  vm.standardTenorList!=undefined && vm.standardTenorList.length>0){
				vm.mimeType = 'text/csv';
				vm.extension = ".csv";  
				StandardTenorView.exportDataCSV({businessDate:  DateUtils.convertLocalDateToServer(vm.businessDate)}, onExportSuccess);
			}
		}


		function onExportSuccess(result){        	  
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
			vm.baseString = vm.fileName + moment().format(vm.reportFileTimestampFormat) +  vm.extension; 

			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob){
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString);
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	}
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('SpecialHolidaysDialogController', SpecialHolidaysDialogController);

    SpecialHolidaysDialogController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','SpecialHolidays','entity', 'DateUtils', 'ScreenLog','entityConstants'];

     function SpecialHolidaysDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,SpecialHolidays,entity,DateUtils,ScreenLog,entityConstants) {
        var vm = this;
        vm.specialHolidays=entity;  
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.SPECIAL_HOLIDAY;
        vm.entityConstants = entityConstants;
        vm.screenLog = ScreenLog;
        vm.clear=clear;
        vm.save=save;
        $scope.clicked=false;
        $scope.showButton = false;
        vm.resubmitSpecialHolidays =resubmitSpecialHolidays;
        vm.globalValues = GlobalValues;
        
        $scope.showButton = false;
        
        
                
        if(workflowSharedService.viewFrom == 'specialholidays'){
        	vm.specialHolidays=entity;
       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'specialholidays_resubmit') {
        	vm.specialHolidays = angular.fromJson($rootScope.payload); 
        	vm.screenLog.screenLog(vm.screenName, vm.specialHolidays.id==null?0:vm.specialHolidays.id, entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
        	vm.disableForm = false;
        	$scope.showButton=true;
        }
        else if(workflowSharedService.viewFrom == 'specialholidays_resubmit_delete') {
        	vm.specialHolidays = angular.fromJson($rootScope.payload); 
        	vm.disableForm = true;
        	$scope.showButton=true;
        }
		vm.specialHolidays.holidayDate = new Date(vm.specialHolidays.holidayDate);

        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {        	    		
        	 vm.specialHolidays.holidayDate = DateUtils.convertLocalDateToServer(vm.specialHolidays.holidayDate);
       		
        	 if (vm.specialHolidays.id !== null) {
                 SpecialHolidays.update({ "orgId": GlobalValues.getOrgId() },vm.specialHolidays, onSaveSuccess, onSaveError);
             } else {
            	 SpecialHolidays.save({ "orgId": GlobalValues.getOrgId() },vm.specialHolidays, onSaveSuccess, onSaveError);           
             }       	
        	
         }
     
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }

        function onSaveError () {
        	vm.specialHolidays.holidayDate = DateUtils.convertDateTimeFromServer(vm.specialHolidays.holidayDate);

        	$scope.clicked = false;
        }
        function resubmitSpecialHolidays() {
       		SpecialHolidays.resubmit({"taskId" : $rootScope.taskID}, vm.specialHolidays, onResubmitSuccess, onResubmitError);
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {}

       
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('SpecialHolidaysViewController', SpecialHolidaysViewController);

    SpecialHolidaysViewController.$inject = ['$scope', '$state','$rootScope','workflowSharedService','$uibModalInstance','SpecialHolidays','entity', 'Workflow', 'GlobalValues'];

    function SpecialHolidaysViewController($scope, $state, $rootScope, workflowSharedService, $uibModalInstance,SpecialHolidays,entity, Workflow, GlobalValues) {
        var vm = this;
        vm.clear=clear;
        vm.approveSpecialHolidays = approveSpecialHolidays;
        vm.rejectSpecialHolidays = rejectSpecialHolidays;
        vm.discardSpecialHolidays = discardSpecialHolidays;
        $scope.showButton = false;
        $scope.showDiscardButton = false;
        $scope.clicked=false;
        vm.globalValues = GlobalValues;
        
        
        
        if(workflowSharedService.viewFrom == 'specialholidays'){
        	vm.specialHolidays = entity;        	
       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'specialholidaystodolist_checker') {
        	vm.specialHolidays =  angular.fromJson($rootScope.payload); 
        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
        }
        else if(workflowSharedService.viewFrom == 'specialholidaystodolist_maker') {
        	vm.specialHolidays =  angular.fromJson($rootScope.payload); 
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        }
        else if(workflowSharedService.viewFrom == 'specialHoliday_auditLog') {
        	vm.specialHolidays =  angular.fromJson($rootScope.payload); 
        	$scope.showButton=false;
        	$scope.showDiscardButton = false;
        }
        
        vm.specialHolidays.holidayDate = new Date(vm.specialHolidays.holidayDate);

        function approveSpecialHolidays() { 
        	SpecialHolidays.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectSpecialHolidays() { Workflow.rejectTask($rootScope.taskID); }

        function discardSpecialHolidays() {
        	SpecialHolidays.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }

       
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('SpecialHolidaysDeleteController',SpecialHolidaysDeleteController);

    SpecialHolidaysDeleteController.$inject = ['$uibModalInstance', 'entity', 'SpecialHolidays', 'GlobalValues'];

    function SpecialHolidaysDeleteController($uibModalInstance, entity, SpecialHolidays, GlobalValues) {
        var vm = this;

        vm.specialHolidays = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        
        function confirmDelete (id) {
        	SpecialHolidays.delete({"orgId": GlobalValues.getOrgId(),"id":id},
                    function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('special-holidays', {
            parent: 'entity',
            url: '/special-holidays',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.specialHolidays.manageSpecialHolidays" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/special-holidays/special-holidays.html',
                    controller: 'SpecialHolidaysController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('specialHolidays');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('special-holidays.new', {
            parent: 'special-holidays',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/special-holidays/special-holidays-dialog.html',
                    controller: 'SpecialHolidaysDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	 id:null,  
                            	name:null                            	
                             
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('special-holidays', null, { reload: 'special-holidays' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('special-holidays.view', {
            parent: 'special-holidays',
            url: '/special-holidays/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/special-holidays/special-holidays-detail.html',
                    controller: 'SpecialHolidaysViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	
                            	 entity: ['SpecialHolidays', 'GlobalValues', function(SpecialHolidays, GlobalValues) {
                                     return SpecialHolidays.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('special-holidays.edit', {
            parent: 'special-holidays',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/special-holidays/special-holidays-dialog.html',
                    controller: 'SpecialHolidaysDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	
                            	 entity: ['SpecialHolidays', 'GlobalValues', function(SpecialHolidays, GlobalValues) {
                                     return SpecialHolidays.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('special-holidays.delete', {
            parent: 'special-holidays',
            url: '/delete/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/special-holidays/special-holidays-delete-dialog.html',
                    controller: 'SpecialHolidaysDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['SpecialHolidays', 'GlobalValues', function(SpecialHolidays, GlobalValues) {
                            return SpecialHolidays.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    //$state.go('^', null, { reload: true });
                	$state.go('special-holidays', null, { reload: 'special-holidays' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('special-holidays-todolist', {
            parent: 'dashboard',
            url: '/specialholidaysview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/special-holidays/special-holidays-detail.html',
                    controller: 'SpecialHolidaysViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('special-holidays', null, { reload: 'special-holidays' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('specialHolidays');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
            
        })
        
         .state('special-holidays-todolist.resubmit', {
            parent: 'dashboard',
            url: '/specialholidaysedit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/special-holidays/special-holidays-dialog.html',
                    controller: 'SpecialHolidaysDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('special-holidays', null, { reload: 'special-holidays' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('specialHolidays');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('specialHoliday-auditLog', {
            parent: 'audit-log',
            url: '/specialholidaysaudit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/special-holidays/special-holidays-detail.html',
                    controller: 'SpecialHolidaysViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('special-holidays', null, { reload: 'special-holidays' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('specialHolidays');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
            
        })
         .state('specialHoliday-historyReport', {
            parent: 'history-report',
            url: '/specialholidayshistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/special-holidays/special-holidays-detail.html',
                    controller: 'SpecialHolidaysViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('special-holidays', null, { reload: 'special-holidays' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('specialHolidays');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
            
        })
        
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('SpecialHolidays', SpecialHolidays);

    SpecialHolidays.$inject = ['$resource'];

    function SpecialHolidays ($resource) {
        var resourceUrl =  'api/special-holidays/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },           
           	
            'save': {
                method: 'POST',
                params: {orgId:'@orgId'},
                url: 'api/special-holidays/:orgId',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                }                
            },
            'update': {
            	method:'PUT',
            	params: {orgId:'@orgId'},
                url: 'api/special-holidays/:orgId',
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
            'delete':{
                method: 'DELETE',
                params: {orgId:'@orgId', id:'@id'},
                url: 'api/special-holidays/:orgId/:id'    
                },
         
            'approve': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
              	 method: 'GET',
                   params: {taskId:'@taskId'},
                   url: 'api/tasks/:taskId/discard'
             },
             'resubmit': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/resubmit/special-holidays',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             }
            
            
              });
    }
})();

            

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'specialholidays'
        })
        
        .controller('SpecialHolidaysController', SpecialHolidaysController);

    SpecialHolidaysController.$inject = ['$scope', '$state', 'workflowSharedService', 'SpecialHolidays', 'GlobalValues', 'EntityPermissions', 'ScreenLog', 'entityConstants'];

    function SpecialHolidaysController($scope, $state, workflowSharedService, SpecialHolidays, GlobalValues, EntityPermissions, ScreenLog , entityConstants) {
        
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.SPECIAL_HOLIDAY;
        vm.entityConstants = entityConstants;
        vm.screenLog = ScreenLog;
        vm.loadAll = loadAll;
        
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;

		workflowSharedService.viewFrom = "specialholidays";
		
        vm.launch=launch;
        function launch() {
        	$state.go("special-holidays.new");
        	//$state.go("special-holidays.view");
        }
        
        vm.permitSpecialHolidaysEditEntityAction = EntityPermissions.hasPermission( vm.screenName+'.' +vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
        vm.permitSpecialHolidaysCreateEntityAction = EntityPermissions.hasPermission( vm.screenName+'.' +vm.entityConstants.ENTITY_ACTION_TYPE.CREATE);
		vm.permitSpecialHolidaysViewEntityAction = EntityPermissions.hasPermission( vm.screenName+'.' +vm.entityConstants.ENTITY_ACTION_TYPE.VIEW);
		vm.permitSpecialHolidaysDeleteEntityAction = EntityPermissions.hasPermission( vm.screenName+'.' +vm.entityConstants.ENTITY_ACTION_TYPE.DELETE);
		
        var loadAll = function() {
            SpecialHolidays.query(function(result) {
                vm.specialHolidays = result;                
            });
        }

        loadAll();
        logScreenAccess();
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sod-process', {
            parent: 'entity',
            params:{screen: 'SODProcess'},
            url: '/sod-process',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.EODProcess.sodProcess" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sod-process/sod-process.html',
                    controller: 'SODProcessController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
              
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('sodProcess');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('SODProcess', SODProcess);

    SODProcess.$inject = ['$resource','DateUtils'];

    function SODProcess ($resource, DateUtils) {
        var resourceUrl = 'api/sod-Process';
        return $resource(resourceUrl, {}, {
            
           'getCurrentBusinessDate': {
                method: 'GET',  
                url: 'api/sod-process/system-settings',
                transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
            },
           
			/*'getNextValidBusinessDate' : {
				method : 'GET',
				params : {
					
					currentBusinessDate : '@currentBusinessDate'
					
				},
				url : 'api/sod-Process/get-next-system-date',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},*/			
			'processSOD' : {
				method : 'POST',
				params : {
					
					businessDate : '@businessDate',
					status : '@status'
					
				},
				url : 'api/sod-Process/updateProcessStatus',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'logOffUsersForcibly' : {
				method : 'POST',
				params : {
					
					currentBusinessDate : '@currentBusinessDate',
					processId : '@processId',
					executionCount : '@executionCount'
				},
				url : 'api/sod-Process/forcibleLogOff',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'initiateSODInOrderService' :{
				
				method : 'POST',				
				url : 'order/process/sod',
				/*params : {
					
					executionCount : '@executionCount',
					businessDate : '@businessDate',
				},*/
				transformRequest: function (data) {
                   	
                   	var copy =angular.toJson(data);
                   	
                       return copy;
                },
				transformResponse : function(data) {
					if(data!=null && data!=undefined && data !=''){
						if(data.substring(0,1)=='<'){
				
						}else {
							data = angular.fromJson(data);
							return data;
						}
					
					}
				}
				
			},
			'updateSODPRocessLog' : {
				method : 'POST',
				params : {
					
					businessDate : '@businessDate',
				},
				url : 'api/sod-Process/updateProcessStatusLog',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			
			/*'stopSODForcibly' :{
				method : 'POST',
				url : 'api/sod-process/stop-sod-forcibly',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},*/
			'insertProcessLog' :{
				method: 'POST',
				params : {
					
					currentBusinessDate : '@currentBusinessDate',
					processId : '@processId',
					executionCount : '@executionCount',
					errorMessageCode : '@errorMessageCode',
					isSuccess : '@isSuccess'
				},
				url : 'api/sod-process/insert-process-log',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			/*'getSodProcessStatus' :{
				method : 'GET',
				url : 'api/sod-process/get-sod-process-status',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},*/
			'getSodProcessStatusLog' :{
				
				method : 'GET',
				params : {
					
					currentBusinessDate : '@currentBusinessDate'
				},
				url : 'api/sod-process/get-sod-process-status-log',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			}
			
            
        });
    }
})();

(function () {
	'use strict';

	angular
		.module('gatewayApp')
		.controller('SODProcessController', SODProcessController);

	SODProcessController.$inject = ['$scope', '$state', '$stateParams', '$rootScope', 'GlobalValues', 'DateUtils', 'AlertService','SODProcess','MessageBox','$filter', 'ScreenLog','entityConstants', 'StaticLookUp','$interval', '$timeout','EntityPermissions','WebSocket','Account','Auth','$uibModalStack'];

	function SODProcessController($scope, $state, $stateParams, $rootScope, GlobalValues, DateUtils, AlertService,SODProcess,MessageBox,$filter, ScreenLog,entityConstants, StaticLookUp, $interval,$timeout,EntityPermissions,WebSocket,Account,Auth,$uibModalStack) {
		
		var vm = this;
		vm.globalValues = GlobalValues;
		vm.currentBusinessDate;
		vm.nextBusinessDate;
		vm.beginSODProcess = beginSODProcess;		
		var convertedNextBusinessDate ;
		var convertedCurrentBusinessDate ;
		$scope.refresh = refresh;
		vm.convertedTodayDate = DateUtils.convertLocalDateToServer(vm.today);		
		
		vm.disbleSod = true;
		vm.sodStatus='';
		vm.isRefreshDisabled=false;
		vm.isSodProcessSuccessfull=null;
		vm.isSodCompleted = false;
		//vm.newProcessStatusMap = {};
		//vm.processStatusMap = {};
		vm.today = new Date();
		vm.errorMessage = "";
		vm.forcibleLogOffID = 0;
		vm.connectToMQID = 0;
		vm.executionCount = 0;
		vm.sodProcessList = [];
		vm.sodProcessListFromDB = [];
		vm.newProcessResultMap = {};
		vm.processResultMap = {};
		vm.processErrorMap = {};
		vm.newProcessErrorMap = {};
		vm.errorList = {};
		var orderServiceSODProcessUpdateSubscription = null;
		vm.idArray = [];
		
		/****************load config for maximumWaitingtime to get response from orderservice , define timer to check whether response is received in time *******************/
		/*		
		vm.enableTimer = false;
		vm.maximumWaitTimeForOrderServiceResponse = 0 ; 
		vm.latestOrderSeviceRequestTimestamp = 0 ; 
		vm.latestProcess = 0;
		vm.configSettings = vm.globalValues.getConfigSettings();
		
		var maximumWaitTimeForResponseString  = vm.configSettings.timerIntervalforSODEODResponseWait;
		if(maximumWaitTimeForResponseString!=null && maximumWaitTimeForResponseString!=undefined && maximumWaitTimeForResponseString.trim()!=''){
			
			vm.maximumWaitTimeForOrderServiceResponse = parseInt(maximumWaitTimeForResponseString, 10) * 1000;
			//vm.maximumWaitTimeForOrderServiceResponse = 10*1000;
		}else{
			
			vm.maximumWaitTimeForOrderServiceResponse = 60000;//default 60 sec
		}
		
		vm.responseTimeCheckInterval = vm.maximumWaitTimeForOrderServiceResponse/2;
		
		$scope.checkForResponseTimeout = function() {
			
	        console.log("$scope.callAtInterval - Interval occurred");
	        var currentTimestamp = moment().valueOf();
	        if( (vm.enableTimer == true) && ( (currentTimestamp - vm.latestOrderSeviceRequestTimestamp ) >  vm.maximumWaitTimeForOrderServiceResponse )){
	        	
	        	// update the sod Process status log = INCOMPLETE
	        	if(vm.latestProcess!=null && vm.latestProcess!=undefined && vm.latestProcess.status == vm.INPROGRESS){
	        		updateRemarksInProcessList(vm.latestProcess.id ,"Response timeout occurred",  vm.FAILED);
	        		SODProcess.insertProcessLog({"currentBusinessDate" : convertedCurrentBusinessDate,
	    				"processId" : vm.latestProcess.id,
	    				"executionCount" : vm.executionCount,
	    				"errorMessageCode" : "7001",
	    				"isSuccess" : false});
	        	}
	        	vm.sodStatus = vm.INCOMPLETE;
				vm.disbleSod = disableSodProcess();			
				
				SODProcess.processSOD( {				
					"businessDate" : convertedCurrentBusinessDate,
					"status" : vm.INCOMPLETE
				}, endSODInUISuccess, endSODInUIError);
	        	
	        }
	    }
		

	 	$interval( function(){ 
	 		$scope.checkForResponseTimeout(); 
	 		}, vm.responseTimeCheckInterval);
	 	
		function endSODInUISuccess(result){
			vm.enableTimer = false;
			//destroy the event 
			unsubscribeToSODProcessUpdate();	

			// send kafka message to order service to stop the further process.
			SODProcess.stopSODForcibly();
			
			
			
        	
		}
		function endSODInUIError(error){
			//DO NOthing			
			unsubscribeToSODProcessUpdate();		
		}*/
		/************* Constants to be used in HTML file for displaying progress icons ********************/

		vm.INPROGRESS = "INPROGRESS";
		vm.COMPLETED = "COMPLETED";
		vm.FAILED = "FAILED";
		vm.NOTSTARTED = "NOTSTARTED";
		vm.OPEN = "TO_BE_INITIATED";
		vm.INCOMPLETE = "INCOMPLETE";
		/**********************************************************************/
		 vm.permitSODProcessAddEntityAction = EntityPermissions.hasPermission('SODProcess.CREATE');
		// if(vm.permitSODProcessAddEntityAction ==false){
		
		// 	//message box 
		// 	MessageBox.openMessageBox('Alert', 'Session expired. You will be redirected to login page...!', 'Ok', 'permitSODProcessAddEntityAction');
		// }

		// $rootScope.$on('gatewayApp.messagebox.ok.permitSODProcessAddEntityAction', function (event) {

		// 	Auth.sessionlogout();
		
		// });
		
		// $rootScope.$on('gatewayApp.messagebox.clear.permitSODProcessAddEntityAction', function (result){
		// 	Auth.sessionlogout();
			
		// })
		
		
		


		/*********** Set Initial status as NOTSTARTED for each process on page laod *****************/
		
		 function loadWorkFlowItems(){
        	 StaticLookUp.getSodWorkFlow(lookupWorkFlowSuccess, lookupWorkFlowFailure);
         }
        
		 function lookupWorkFlowSuccess(result){
			 vm.sodProcessListFromDB = result;
			 vm.idArray = [];
			 angular.forEach(vm.sodProcessListFromDB, function(item){               
	                vm.idArray.push( item.id);               
	            });
	    	 vm.sodProcessList = angular.copy(vm.sodProcessListFromDB); 
	    	// var getKeysArray = Object.keys( vm.sodProcessList);
	    	 if(vm.sodStatus == vm.OPEN || vm.sodStatus==vm.INCOMPLETE){
		    	  angular.forEach( vm.sodProcessList, function(item){	    	
		    		 if(item.processName == 'ForciblelogoffUsers' ){
		    			 vm.forcibleLogOffID =item.id;
		    			
		    		 }else if(item.processName.processName == 'ConnectToInteractiveMQ'){
		    			 vm.connectToMQID = item.id;
		    		 }
		    		
		    		item.status = vm.NOTSTARTED;
		    		item.remarks='';
		    		
		    		vm.newProcessResultMap[item.id] = null;
		    		vm.processResultMap[item.id] = null;
		    		vm.processErrorMap[item.id] = null;
		    		vm.newProcessErrorMap[item.id] = null;
		    		 
		    	 });	    	
	    	}
	    	if(vm.sodStatus==vm.INCOMPLETE || vm.sodStatus==vm.COMPLETED ||  vm.sodStatus==vm.INPROGRESS){
	    		loadworkFlowItemsWithStatus();
	    	}
		 }
		
		


		
         function reloadListAndMap(){
        	 vm.sodProcessList = angular.copy(vm.sodProcessListFromDB);
        	//var getKeysArray = Object.keys( vm.sodProcessList);
        	 vm.idArray = [];
         	 angular.forEach(vm.sodProcessList, function(item){               
                 vm.idArray.push(item.id);               
             });
        	 angular.forEach( vm.sodProcessList, function(item){
	    		 if(item.processName == 'ForciblelogoffUsers' ){
	    			 vm.forcibleLogOffID =item.id;
	    			
	    		 }else if(item.processName == 'ConnectToInteractiveMQ'){
	    			 vm.connectToMQID = item.id;
	    		 }
        	 });
        	 var indexOfForcibleLoggOff = vm.idArray.indexOf(vm.forcibleLogOffID);
        	 vm.sodProcessList[indexOfForcibleLoggOff].status = vm.NOTSTARTED;
    		 vm.sodProcessList[indexOfForcibleLoggOff].remarks='';
    		 
    		 var indexOfConnectToMQ = vm.idArray.indexOf(vm.connectToMQID);
        	 vm.sodProcessList[indexOfConnectToMQ].status = vm.NOTSTARTED;
    		 vm.sodProcessList[indexOfConnectToMQ].remarks='';
    		 
        	// vm.processStatusMap =  angular.copy(vm.newProcessStatusMap);
        	 vm.processResultMap =angular.copy(vm.newProcessResultMap);
        	 vm.processErrorMap = angular.copy(vm.newProcessErrorMap);
         }
         function lookupWorkFlowFailure(error){
        	 //do nothing
         }
		/**********************************END********************************************************/
		/******** FETCH ERROR MESSAGE AND SET TO GLOBAL VARIABLE *************************************/
         function loadErrorMEssages(){
        	 StaticLookUp.getProcessErrorMessages(loadErrorMEssagesSuccess, loadErrorMEssagesFailure);
         }
         function loadErrorMEssagesSuccess(result){
        	 vm.errorList  = result[0];
        	 //vm.globalValues.checkAndSetSelectedErrorMessages(result);        	
        	
         }
         function loadErrorMEssagesFailure(error){
        	 //do nothing
         }
         
        /******** END****************************************** *************************************/
		// if(vm.permitSODProcessAddEntityAction ==true){
			logScreenAccess();
			loadErrorMEssages();        
			loadDates();
	//    -

	
		/** set Intial State and initial status for each process and load the new businessDates *****/
		function loadDates() {
			
			
			// fetch the business date for which the SOD process is not done;
			SODProcess.getCurrentBusinessDate(loadSystemSettingsSuccess, loadSystemSettingsError);
			
			loadWorkFlowItems();
	
		}	
		
		function loadSystemSettingsSuccess(result){
			vm.lastSystemSetting = result;
			vm.sodStatus=vm.lastSystemSetting.sodStatus;
			vm.currentBusinessDate = DateUtils.convertLocalDateFromServer(vm.lastSystemSetting.businessDate);
			convertedCurrentBusinessDate = DateUtils.convertLocalDateToServer(vm.currentBusinessDate);
			vm.disbleSod = disableSodProcess();
			if(vm.sodStatus == vm.COMPLETED){
				AlertService.success($filter('translate')('gatewayApp.sodProcess.alreadyCompleted'));
			}else if(vm.sodStatus == vm.INPROGRESS){
				
				AlertService.error($filter('translate')('gatewayApp.sodProcess.alreadyInProgress'));
			}
		}
		function loadSystemSettingsError(){
			
		}
		
		// function to start the SOD process on start button click
		function beginSODProcess() {
			
			vm.isRefreshDisabled = false;
			vm.isSodProcessSuccessfull=null;
			vm.isSodCompleted = false;
			reloadListAndMap();
			if(vm.currentBusinessDate !=null && vm.currentBusinessDate !=undefined && vm.currentBusinessDate !=''){
				if ( vm.currentBusinessDate > vm.today ) {
					
					AlertService.error($filter('translate')('gatewayApp.sodProcess.forwardDateError'));
					
				}else if(vm.sodStatus == vm.COMPLETED){
					AlertService.success($filter('translate')('gatewayApp.sodProcess.alreadyCompleted'));
				}else if(vm.sodStatus == vm.INPROGRESS){
					
					AlertService.error($filter('translate')('gatewayApp.sodProcess.alreadyInProgress'));
				}
				else {
					//call the first process
					processSOD();
					//logOffUsersForcibly();
					
				}
			}
			

		}
		
		/*********************** Process methods before starting the sod process ********************************************/
		var processSOD = function processSOD(){
						
			SODProcess.processSOD( {				
				"businessDate" : convertedCurrentBusinessDate,
				"status" : vm.INPROGRESS
			}, processSODSucess, processSODError);
			
		}
		
		function processSODSucess(result){
			vm.executionCount = parseInt(result.executionCount);
			vm.executionCount = vm.executionCount+1;
			if(vm.sodStatus == vm.OPEN || vm.sodStatus == vm.INCOMPLETE){
				SODProcess.updateSODPRocessLog({"businessDate" : convertedCurrentBusinessDate},updateSODLogSuccess, updateSODLogFailure);
			}else{
				vm.sodStatus = vm.INPROGRESS;
				vm.disbleSod = true;			
				successProcessor(logOffUsersForcibly);
			}
		}
		function updateSODLogSuccess(result){
			
			vm.sodStatus = vm.INPROGRESS;
			vm.disbleSod = true;			
			successProcessor(logOffUsersForcibly);
			
		}function updateSODLogFailure(error){
			
			
		}
		
		function processSODError(error){
			var errorCode = errorProcessor(error);
			AlertService.error( errorCode );
		}
		
		/*********************** Process methods for forcible logoff users ********************************************/
		var logOffUsersForcibly = function logOffUsersForcibly(){
			
			//vm.forcibleLogOffUsersStatus = vm.INPROGRESS;	
			updateRemarksInProcessList(vm.forcibleLogOffID ,"",   vm.INPROGRESS);
			SODProcess.logOffUsersForcibly( {				
				"currentBusinessDate" : convertedCurrentBusinessDate,
				"processId" : vm.forcibleLogOffID,
				"executionCount" : vm.executionCount
			}, logOffUsersForciblySucccess, logOffUsersForciblyError);
		}
		function logOffUsersForciblySucccess(result){
			//vm.forcibleLogOffUsersStatus = vm.COMPLETED;	
			updateRemarksInProcessList(vm.forcibleLogOffID ,"",  vm.COMPLETED);
			//invoke next process - auto withdrawal of pending customers
			successProcessor(startSODInOrderService);
		}
		function logOffUsersForciblyError(error){
				
			//vm.forcibleLogOffUsersStatus = vm.FAILED;			
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.forcibleLogOffID ,errorCode , vm.FAILED );
			/*SODProcess.processSOD( {				
				"businessDate" : convertedCurrentBusinessDate,
				"status" : vm.INCOMPLETE
			}, processInCompleteSODSucess, processENDSODError)*/
		}
		/********** begin SOD in order service *************/
		var startSODInOrderService = function startSODInOrderService(){
			
			updateRemarksInProcessList(vm.connectToMQID ,"",   vm.INPROGRESS);
			//subscribe to notifications
			//subscribeToSODProcessUpdate();
			
			SODProcess.initiateSODInOrderService({
				"executionCount" : vm.executionCount,
				"businessDate" : convertedCurrentBusinessDate  },
					startSODInOrderServiceSuccess, startSODInOrderServiceFailure);
			
		}
		function startSODInOrderServiceSuccess(result){
			
			//do nothing as this is async call
		}
		function startSODInOrderServiceFailure(error){
			
			// SOD Failure
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.connectToMQID ,"",  vm.FAILED);
			SODProcess.processSOD( {				
				"businessDate" : convertedCurrentBusinessDate,
				"status" : vm.INCOMPLETE
			}, processInCompleteSODSucess, processENDSODError)
			AlertService.error( errorCode );
		}
		/********  begin SOD in order service *************/
		
		/*********************General method used in all process ***********************/
		function successProcessor(successProcessToInvoke){
			
			//if(vm.isSodProcessSuccessfull){				
				// next process is invoked only when previous one is is successful
				if(successProcessToInvoke!=null)
					successProcessToInvoke();
			//}
		}
		/*function updateRemarksInProcessList(processID, errorMessage, status){
			angular.forEach(vm.sodProcessList, function(item){
				if(item.id == processID  ){
					item.remarks = errorMessage;
					item.status = status ;
				}
			});
		}*/
		
		function updateRemarksInProcessList(processID, errorMessage, status){
			var indexOfProcess= vm.idArray.indexOf(processID);
			
			if(vm.sodProcessList[indexOfProcess]!=null && vm.sodProcessList[indexOfProcess]!=undefined && vm.sodProcessList[indexOfProcess] !='' ){
				vm.sodProcessList[indexOfProcess].remarks = errorMessage;
				vm.sodProcessList[indexOfProcess].status = status ;
			}
			
			
		}

		function errorProcessor(error){		
			var errorcode = "";
			if( error.message !=undefined &&  error.message !=null &&  error.message!=""){
				errorcode  = $filter('translate')( error.message ) //+  error.businessDate;				
				//vm.errorMessage = error.exceptionMessage +  errorcode ;
			}else if( !(error.data==undefined || error.data==null || error.data=='')){
				errorcode  = $filter('translate')( error.data.message );
				//vm.errorMessage = error.data.exceptionMessage +" "+  errorcode;
			}else{
				errorcode = $filter('translate')( "Service unavailable");
			}
			 		
			//AlertService.error( errorcode );
			vm.isSodProcessSuccessfull=false;
			return errorcode;
		}
		
		/********************************************/
		
		
		/***********************  END *************************************************************************************/
		/********** Refresh**********/
		  $scope.toggle = true;
	        function refresh() {
	            $scope.toggle = false;
	            $scope.refreshFlag = false;
	            refreshStatusAndProcessList();
	            if ($scope.toggle == false) {
	                $timeout(function() {
	                    $scope.toggle = true;
	                }, 2000);
	                $scope.refreshFlag = false;
	            }
	        };
	        function refreshStatusAndProcessList(){
				// fetch the business date for which the SOD process is not done;
				SODProcess.getCurrentBusinessDate(loadSystemSettingsSuccess, loadSystemSettingsError);
				loadworkFlowItemsWithStatus();
			}
			function loadworkFlowItemsWithStatus(){
				SODProcess.getSodProcessStatusLog({"currentBusinessDate" : convertedCurrentBusinessDate},loadworkFlowItemsWithStatusSuccess, lookupWorkFlowFailure);
	        }
	       
			 function loadworkFlowItemsWithStatusSuccess(result){
				 var sodProcessStatusLog= result['newSodProcessLogList'];
				 vm.idArray = [];
				 angular.forEach(vm.sodProcessListFromDB, function(item){               
		                vm.idArray.push( item.id);               
		            });
				 vm.sodProcessList = angular.copy(vm.sodProcessListFromDB);
		    	// if(vm.sodStatus == vm.OPEN || vm.sodStatus==vm.INCOMPLETE){
		    		 
		    	angular.forEach( sodProcessStatusLog, function(item){
		    		var indexOfProcess = vm.idArray.indexOf(item.process.id);
		    		 if(item.isCompleted==true){
		    			 if(vm.sodProcessList[indexOfProcess]!=undefined && vm.sodProcessList[indexOfProcess]!=null){
		    			 	vm.sodProcessList[indexOfProcess].status = vm.COMPLETED;
		    			 	vm.sodProcessList[indexOfProcess].remarks='';
		    		 	}
		    		 }else{
		    			 if(vm.sodProcessList[indexOfProcess]!=undefined && vm.sodProcessList[indexOfProcess]!=null){
		    				 vm.sodProcessList[indexOfProcess].status = vm.FAILED;
		    				 if(vm.errorList[item.errorMessage]!=null && vm.errorList[item.errorMessage]!=undefined){
		    					 vm.sodProcessList[indexOfProcess].remarks=vm.errorList[item.errorMessage].rejectionReason;
		    				 }
		    			 }
		    		 }
		    		
		    		 
		    	 });
		    	
		    	
		    	//}
			 }
		/***********END *************/
	    function logScreenAccess(){
	           ScreenLog.screenLog( entityConstants.ENTITY_SHORT_NAME.SOD_PROCESS,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
	        }
	    function disableSodProcess(){
	    	
	    	if(vm.currentBusinessDate ==undefined || vm.currentBusinessDate == null || vm.currentBusinessDate == ''){
	    		// no valid businessdate - disable start button
	    		return true;
	    	}else if(vm.sodStatus ==vm.OPEN ||vm.sodStatus==null || vm.sodStatus==undefined ||vm.sodStatus==''){
	    		// sodStatus is open for the business date then enable strat button
	    		vm.isRefreshDisabled=true;
	    		return false;
	    		
	    	}else if( vm.sodStatus ==vm.INCOMPLETE){
	    		vm.isRefreshDisabled=false;
	    		return false;
	    		
	    	}
	    	else if( (vm.sodStatus == vm.INPROGRESS ) && (vm.isSodProcessSuccessfull!=null && vm.isSodProcessSuccessfull==false)){
	    		// enable start button when sodStatus is in inprogress and sod process is not successfull
	    		vm.isRefreshDisabled=false;
	    		return  false;
	    	}else if( vm.sodStatus ==vm.INPROGRESS  && (vm.isSodProcessSuccessfull==null || vm.isSodProcessSuccessfull==true)){
	    		// disable start button when sodStatus is in inprogress and sod process is  successfull
	    		vm.isRefreshDisabled=false;
	    		return true;
	    	}else if( vm.COMPLETED ==vm.sodStatus ){
	    		vm.isRefreshDisabled=true;
	    		return true;
	    	}
	    	
	    }
	 // Watch for Process failure through the isSodProcessSuccessfull flag , if it is failed then enable the start button
	    $scope.$watch('vm.isSodProcessSuccessfull', function(value){
			if(value!=null && value!=undefined && value == false){
				
				//method to enable or disable start button if process is unsuccessfull
				vm.sodStatus = vm.INCOMPLETE;
				vm.disbleSod = disableSodProcess();
				/*SODProcess.processSOD( {				
					"businessDate" : convertedCurrentBusinessDate,
					"status" : vm.INCOMPLETE
				}, processInCompleteSODSucess, processENDSODError);*/
			}else if(value!=null && value!=undefined && value == true){
				vm.sodStatus = vm.INPROGRESS;
				vm.disbleSod = disableSodProcess();
			}
		
			});
	    $scope.$watch('vm.isSodCompleted', function(value){
			 if(value==true ){
				
				//method to enable or disable start button if process is unsuccessfull
					vm.sodStatus = vm.COMPLETED;
					vm.disbleSod = disableSodProcess();
					
					AlertService.success($filter('translate')('gatewayApp.sodProcess.sodProcesscompleted'));
					SODProcess.logOffUsersForcibly( {				
							"currentBusinessDate" : convertedCurrentBusinessDate,
							"processId" : 0,
							"executionCount" : vm.executionCount
					});	
				// update the status as completed when the isSODProcessSuccessful is true and inprogress
				/*SODProcess.processSOD( {				
					"businessDate" : convertedCurrentBusinessDate,
					"status" : vm.COMPLETED
				}, processENDSODSucess, processENDSODError);*/
			}
			});
	  //function subscribeToSODProcessUpdate(){
	    orderServiceSODProcessUpdateSubscription = $rootScope.$on("orderServiceSODProcessUpdate", function(event,result){
	    	
	    	if( result.success!=vm.processResultMap[result.processID]){
	    
	    		processStatusNotificationFromOrderService(result);
	    	}else if( result.success==false && result.exceptionNumber!=vm.processErrorMap[result.processID]){
	    		//update new error code
	    		processStatusNotificationFromOrderService(result);
	    	}
	    	
         });
	   //}
	   function unsubscribeToSODProcessUpdate(){
		   if(orderServiceSODProcessUpdateSubscription!=null){
			   // unscribe to order service update notification
			   orderServiceSODProcessUpdateSubscription();
		   }
	   }
	function processENDSODSucess(result){
		//unsubscribeToSODProcessUpdate();
		// need to check whether one more forcible log off is required
		//successProcessor(logOffUsersForcibly);
		if(vm.sodStatus == vm.COMPLETED){
			AlertService.success($filter('translate')('gatewayApp.sodProcess.sodProcesscompleted'));
			SODProcess.logOffUsersForcibly( {				
				"currentBusinessDate" : convertedCurrentBusinessDate,
				"processId" : 0,
				"executionCount" : vm.executionCount
		});	
		}
		 
		
		
		
	}
	function processInCompleteSODSucess(result){
		//unsubscribeToSODProcessUpdate();
		 /*if(vm.sodStatus == vm.INCOMPLETE){
			AlertService.error($filter('translate')('gatewayApp.sodProcess.sodProcessFailed'));
		}*/
	}
	function processENDSODError(error){
		//DO NOthing
		//unsubscribeToSODProcessUpdate();		
	}
	

	
	function processStatusNotificationFromOrderService(processStatus){
		
		//angular.forEach( vm.sodProcessList, function(item,index){
		var indexOfProcess = vm.idArray.indexOf(processStatus.processID);
		var item = vm.sodProcessList[indexOfProcess];
			//console.log("process", index);
			//console.log("process", item);
		
			if(item.id==processStatus.processID &&  processStatus.success==true ){
				
				item.status = vm.COMPLETED;
				item.remarks = "";
				
				//var keyArray = Object.keys(vm.sodProcessList);
				var keyArray = vm.idArray
				var index = keyArray.indexOf(processStatus.processID);
				var nextIndex = index+1;
				if(nextIndex < keyArray.length){
					var nextProcess = vm.sodProcessList[nextIndex];
    				if(nextProcess!=undefined && nextProcess!=null && nextProcess!='' && nextProcess.status != vm.COMPLETED && nextProcess.status !=vm.FAILED){
    					nextProcess.status = vm.INPROGRESS ;
    					
    				}
				}else if(nextIndex == keyArray.length){
					//vm.isSodProcessSuccessfull = true;
					vm.isSodCompleted  = true;
				}
				//vm.processStatusMap[processStatus.processID] =true;
				 vm.processResultMap[processStatus.processID] = processStatus.success;
				 vm.processErrorMap[processStatus.processID] = null;
				 vm.isSodProcessSuccessfull = true;
			
			}else if(item.id==processStatus.processID &&  processStatus.success==false){
			 					
				item.status = vm.FAILED;
				item.remarks = "Process Failed";
				vm.isSodProcessSuccessfull = false;	
				var errorKey = processStatus.exceptionNumber+""+processStatus.messageNumber;
				
				if( vm.errorList[errorKey]!=null && vm.errorList[errorKey]!=undefined 
						&& vm.errorList[errorKey]!='' ){
					item.remarks =  vm.errorList[errorKey].rejectionReason;
					
				}
				
				//vm.processStatusMap[processStatus.processID] =true;
				 vm.processResultMap[processStatus.processID] = processStatus.success;
				 vm.processErrorMap[processStatus.processID] = processStatus.exceptionNumber;
				
			}
		
			
		}
	
	  var webscoketDisconnect = $rootScope.$on("websocketDisconnected", function(event,result){
	    	
	    	console.log("web socket disconnected with reason" + result);
	    	angular.forEach( vm.sodProcessList, function(item){
	   		 	if(item.status == vm.INPROGRESS){
	   		 		item.status = vm.FAILED;
	   		 		item.remarks=vm.errorList["7001"].rejectionReason;
	   		 	}
	    		
	    	
	    	});
	    	
       });
		// unregister the event when destroying the controller
	  $scope.$on('$destroy', function() {
		  unsubscribeToSODProcessUpdate();
		  if(webscoketDisconnect!=null){
			  webscoketDisconnect();
		  }
      });
	 	
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('SMSSettingsViewDialogController', SMSSettingsViewDialogController);

    SMSSettingsViewDialogController.$inject = ['$scope', '$state','$rootScope','workflowSharedService','$uibModalInstance','SMSSettings','entity', 'Workflow', 'GlobalValues', 'ScreenLog'];

    function SMSSettingsViewDialogController($scope, $state, $rootScope, workflowSharedService, $uibModalInstance,SMSSettings,entity, Workflow, GlobalValues, ScreenLog) {
        var vm = this;
        vm.clear=clear;
        vm.approveSMSSettings = approveSMSSettings;
        vm.rejectSMSSettings = rejectSMSSettings;
        vm.discardSMSSettings = discardSMSSettings;
        $scope.showButton = false;
        $scope.showDiscardButton = false;
        $scope.clicked=false;
        vm.globalValues = GlobalValues;
        vm.disable=true;
        

        
        if(workflowSharedService.viewFrom == 'smssettings'){
        	vm.smsSettings = entity;        
       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'smssettingtodolist_checker') {
        	vm.smsSettings =  angular.fromJson($rootScope.payload); 
        	
        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
        }
        else if(workflowSharedService.viewFrom == 'smssettingstodolist_maker') {
        	vm.smsSettings =  angular.fromJson($rootScope.payload); 
        	
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        }
        else if(workflowSharedService.viewFrom=='smssettings_auditlog'){
        	vm.smsSettings =  angular.fromJson($rootScope.payload);        	 	
        	$scope.showButton=false;

        }
        
        function approveSMSSettings() { 
        	SMSSettings.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	$scope.clicked=false;
        }
       
        function rejectSMSSettings() { Workflow.rejectTask($rootScope.taskID); }

        function discardSMSSettings() {
        	SMSSettings.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }

       
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('SMSSettingsEditDialogController', SMSSettingsEditDialogController);

    SMSSettingsEditDialogController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','SMSSettings','entity'];

     function SMSSettingsEditDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,SMSSettings,entity) {
        var vm = this;
        vm.smsSettings=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        vm.resubmitSMSSettings =resubmitSMSSettings;
        vm.globalValues = GlobalValues;
        
        $scope.showButton = false;
       
                
        if(workflowSharedService.viewFrom == 'smssettings'){
        	vm.smsSettings=entity;
       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'smssettingstodolist_resubmit') {
        	vm.smsSettings =  angular.fromJson($rootScope.payload);
        	
        	vm.disableForm = false;
        	$scope.showButton=true;
        }
        else if(workflowSharedService.viewFrom == 'smssettings_resubmit_delete') {
        	vm.smsSettings = angular.fromJson($rootScope.payload); 
        	vm.disableForm = true;
        	$scope.showButton=true;
        }
		
		

        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	
                 SMSSettings.update({ "orgId": vm.globalValues.getOrgId() },vm.smsSettings, onSaveSuccess, onSaveError);
               	
         }
      
       
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	
        	vm.clicked = false;
        }
        function resubmitSMSSettings() {
        	
        		 SMSSettings.resubmit({"taskId" : $rootScope.taskID}, vm.smsSettings, onResubmitSuccess, onResubmitError);
        	
       		
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {
        	vm.clicked=false;
        }

       
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sms-settings', {
            parent: 'entity',
            url: '/sms-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.SMSSettings.manageSMSSettings" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sms-settings/sms-settings.html',
                    controller: 'SMSSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('smsSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('sms-settings.view', {
            parent: 'sms-settings',
            url: '/sms-settings/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-settings/sms-settings-view-dialog.html',
                    controller: 'SMSSettingsViewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['SMSSettings', 'GlobalValues', function(SMSSettings, GlobalValues) {
                                     return SMSSettings.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('sms-settings.edit', {
            parent: 'sms-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-settings/sms-settings-edit-dialog.html',
                    controller: 'SMSSettingsEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['SMSSettings', 'GlobalValues', function(SMSSettings, GlobalValues) {
                                     return SMSSettings.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('sms-settings-todolist', {
            parent: 'dashboard',
            url: '/smsSettings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-settings/sms-settings-view-dialog.html',
                    controller: 'SMSSettingsViewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('sms-settings', null, { reload: 'sms-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('sms-settings-todolist.resubmit', {
            parent: 'dashboard',
            url: '/smsSettingsEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-settings/sms-settings-edit-dialog.html',
                    controller: 'SMSSettingsEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('sms-settings', null, { reload: 'sms-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('sms-settings-auditLog', {
            parent: 'audit-log',
            url: '/smsSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-settings/sms-settings-view-dialog.html',
                    controller: 'SMSSettingsViewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('sms-settings', null, { reload: 'sms-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('sms-settings-historyReport', {
            parent: 'history-report',
            url: '/smsSettings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-settings/sms-settings-view-dialog.html',
                    controller: 'SMSSettingsViewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('sms-settings', null, { reload: 'sms-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();

(function() {
	'use strict';
	angular.module('gatewayApp').factory('SMSSettings', SMSSettings);

	SMSSettings.$inject = [ '$resource' ];

	function SMSSettings($resource) {
		var resourceUrl = 'api/sms-settings/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
				
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},

			'update' : {
				method : 'PUT',
				params : {
					orgId : '@orgId'
				},
				url : 'api/sms-settings/:orgId',
				transformRequest : function(data) {
					var copy = angular.copy(data);

					return angular.toJson(copy);
				}
			},
			'approve' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/approve'
			},
			'reject' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/reject'
			},
			'discard' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/discard'
			},
			'resubmit' : {
				method : 'PUT',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/resubmit/smsSetting',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			}
			
			

		});
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'smssettings'
        })
        
        .controller('SMSSettingsController', SMSSettingsController);

    SMSSettingsController.$inject = ['$scope', '$state', 'SMSSettings', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout'];

    function SMSSettingsController($scope, $state, SMSSettings, GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.SMS_SETTINGS;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "smssettings";
        $scope.refresh=refresh;
        
        vm.permitSMSSettingsEditEntityAction = EntityPermissions.hasPermission('SMSSettings.EDIT');
        vm.permitSMSSettingsViewEntityAction = EntityPermissions.hasPermission('SMSSettings.VIEW');
        
        logScreenAccess();
        loadAll();

       function loadAll() {
    	   SMSSettings.query(function(result) {
               vm.SMSSettings = result;                
           });       	
        }      
       function logScreenAccess(){
          	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
          }
        
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('SMSMessages', SMSMessages);

    SMSMessages.$inject = ['$resource'];

    function SMSMessages ($resource) {
        var resourceUrl =  'api/sms-messages/:id';

        return $resource(resourceUrl, {}, {
            
            
            'getSMSFailureReport':{
            	 
            	isArray:true,
 				method: 'GET',
 				params: {from:'@from',to:'@to',alertTypeId : '@alertTypeId', status : '@status'},
 				url: 'api/sms-messages/get-sms-details-for-report'
             },
        
            'getSMSFailureArchiveReport':{
            	 
             	isArray:true,
  				method: 'GET',
  				params: {from:'@from',to:'@to',alertTypeId : '@alertTypeId', status : '@status'},
  				url: 'api/sms-messages-archive/get-sms-details-for-report'
            },
         
        	'delete':{
        		method: 'POST',
        		url: 'api/delete-sms-failure-report/',
        		transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                    
                } 
            },
            
        	'deleteArchive':{
        		method: 'POST',
        		url: 'api/delete-sms-failure-report-archive/',
        		transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                    
                } 
            },
            
            'resend':{
            	method:'POST',
            	params:{smsId:'@smsId', isHistorical:'@isHistorical'},
            	url:'api/sms-messages/:smsId/:isHistorical/resend-message'
            },
            'exportData':{
  			    method: 'POST',
                  url: 'api/sms-report/export',
                  responseType: 'arraybuffer',
                  params : {
                	 alertType : '@alertType', status : '@status', from : '@from', to :'@to'
  				},
  				 transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	
                      return angular.toJson(copy);
                  },
                  transformResponse: function(data, headers) {
                	  return {
                          data: data,
                          headers: headers
                      };   
                  } 
  			}
            
             });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sms-failure-report', {
            parent: 'entity',
            params:{screen: 'SMSFailureReport'},
            url: '/sms-failure-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.SMSSettings.manageSMSReport" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sms-failure-report/sms-failure-report.html',
                    controller: 'SMSFailureReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('smsFailureReport');
                    return $translate.refresh();
                }],
                alertType: ['StaticLookUp', function(StaticLookUp) {
                    return StaticLookUp.getAlertTypes().$promise;
                }]
            }
        })
        
       
       };
    })();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('SMSFailureReportController', SMSFailureReportController);

    SMSFailureReportController.$inject = ['$scope', '$state', 'workflowSharedService','SMSMessages','$rootScope','MessageBox', 'GlobalValues','EntityPermissions','$filter',
    	'ScreenLog', 'DateUtils','entityConstants','AlertService','alertType','$window'];

    function SMSFailureReportController($scope, $state, workflowSharedService, SMSMessages,$rootScope, MessageBox, GlobalValues, EntityPermissions,$filter,
    		ScreenLog, DateUtils, entityConstants,AlertService, alertType, $window) {    
        var vm = this;
        vm.globalValues = GlobalValues;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
		vm.clicked=false;
        vm.getSMSFailureReport=getSMSFailureReport;
        vm.todayDate=new Date();
        vm.clearData=clearData;
        vm.resend=resend;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.SMS_FAILURE_REPORT;
        vm.screenLog = ScreenLog;
        vm.status = 'ALL';
        
        //vm.fromDate = DateUtils.convertDateTimeFromServer(vm.todayDate);
        //vm.toDate = DateUtils.convertDateTimeFromServer(vm.todayDate);
        logScreenAccess();
        vm.alertTypes = alertType;
        vm.exportToFile = exportToFile;
        vm.historicalOrCurrent = 'Current';
        
		vm.reportDate  = DateUtils.convertDateTimeFromServer(vm.todayDate);
		vm.yesterdayDate = angular.copy(vm.reportDate);
		vm.yesterdayDate.setDate(vm.yesterdayDate.getDate() - 1);
		vm.fromDate = angular.copy(vm.reportDate);
		vm.fromDate.setDate(vm.fromDate.getDate() -1);
	    vm.toDate = angular.copy(vm.reportDate);
	    vm.toDate.setDate(vm.toDate.getDate() -1);
        
        /*
         * Get details for report given from date, to date, successflag
         */
        function getSMSFailureReport()
        {   
        		vm.smsDetails = [];
        		var alertType = 0;
        		if(vm.historicalOrCurrent != 'Current' && moment(vm.fromDate).isAfter(vm.yesterdayDate,'day')){
        			AlertService.error($filter('translate')('gatewayApp.FailureReport.futureFromDate'));
                }else if(vm.historicalOrCurrent != 'Current' && moment(vm.fromDate).isAfter(vm.toDate,'day')){
        			AlertService.error($filter('translate')('gatewayApp.FailureReport.greaterFromDate'));
        		}else if(vm.historicalOrCurrent != 'Current' && moment(vm.toDate).isAfter(vm.yesterdayDate,'day')){
        			AlertService.error($filter('translate')('gatewayApp.FailureReport.greaterToDate'));
        		}
        		else{
				vm.clicked=true;
        		var from =  DateUtils.convertLocalDateToServer(vm.fromDate);
        		var to =  DateUtils.convertLocalDateToServer(vm.toDate);
        		
        		if(vm.alertType != null && vm.alertType != undefined){
        			alertType = vm.alertType.id;
        		}
        			
        		
        		if(vm.historicalOrCurrent == 'Current'){
            		from =  DateUtils.convertLocalDateToServer(vm.todayDate);
            		to =  DateUtils.convertLocalDateToServer(vm.todayDate);
            		SMSMessages.getSMSFailureReport({"from":from,"to":to, "alertTypeId": alertType, "status": vm.status},onGetSMSFailureReportSuccess,onGetSMSFailureReportError);
        		}else{
        			SMSMessages.getSMSFailureArchiveReport({"from":from,"to":to, "alertTypeId": alertType, "status": vm.status},onGetSMSFailureReportSuccess,onGetSMSFailureReportError);
        		}
        		
        		}
        	
        }
        function onGetSMSFailureReportSuccess(result)
        {
        	vm.successDetails = [];
        	vm.failureDetails = [];
        	
        	vm.smsDetails=result;
        	vm.clicked=false;
        		
        }
        
        
        function onGetSMSFailureReportError()
        {
        	vm.clicked=false;
        }
        
        /*
         * Clear data
         */
        
        function clearData()
        {
        	MessageBox.openMessageBox("Alert", "Are you sure to clear the data?", "ProceedCancel", "cleardata");
        }
        
        $rootScope.$on('gatewayApp.messagebox.proceed.cleardata', function(event,data) {
        	if(vm.historicalOrCurrent == 'Current'){
            	SMSMessages.delete(vm.smsFailureDetails, onDeleteSuccess, onDeleteFailure);
        	}else{
            	SMSMessages.deleteArchive(vm.smsFailureDetails, onDeleteSuccess, onDeleteFailure);
        	}
        	function onDeleteSuccess() {
        		
                $uibModalInstance.close(true);
               
                
            }
        	 $state.go('sms-failure-report', null, { reload: 'sms-failure-report' });
        	function onDeleteFailure() {
                
            }
		});
        
        $rootScope.$on('gatewayApp.messagebox.cancel.cleardata', function(event,data) {
        	
        });
        
        /*
         * Resend message
         */
        
        function resend(smsId){
        	if(vm.historicalOrCurrent == 'Current'){
            	SMSMessages.resend({"smsId" : smsId, "isHistorical": false}, onResendSuccess, onResendError);
        	}else{
            	SMSMessages.resend({"smsId" : smsId, "isHistorical": true}, onResendSuccess, onResendError);
        	}
        }
        
        function onResendSuccess () 
        {
        	
        	getSMSFailureReport();
       }
        
        function onResendError(){
        	getSMSFailureReport();
        }
        
        
        function exportToFile(fileType){
	      	  var mimeType= '';
	      	  var fileData = null;
	      	  var baseString =   'SMS_Report'+ moment().format( 'DD_MMM_YYYY_HH_mm');   
	      	  var viewFor = '';
	 		 
	      	  if( vm.successDetails.length > 0 || vm.failureDetails.length > 0){
	      		  if(fileType == 'csv'){
	      			  mimeType = 'text/csv'
	      			  baseString = baseString+ ".csv";  
	      		  }else if(fileType == 'excel'){
	      			  mimeType = 'application/vnd.ms-excel';
	      			  baseString = baseString+ ".xls";  
	      		  }
	      		  vm.convertedFromDate = DateUtils.convertLocalDateToServer(vm.fromDate);
	      		  vm.convertedToDate = DateUtils.convertLocalDateToServer(vm.toDate);
	 			
	 				SMSMessages.exportData({alertType : vm.alertType.alertTypeName, status : vm.status, from : vm.convertedFromDate, to : vm.convertedToDate}, vm.smsDetails, 
	 					function(result){
	 				
		      			 
		      			  fileData = result.data;
		      			  var link = document.createElement("a");   
		      			  var bytes = new Uint8Array( fileData );   
		      			      			  
		  			      var blob = new Blob([bytes], {type: mimeType});
		  			      link.href =  window.URL.createObjectURL(blob);
		  			      
		      		   	  link.download = baseString;
		      		   	  document.body.appendChild(link);
		      		   	  link.click();
		      			  document.body.removeChild(link);
		      		  });
	 			 
	 			 }
	      		
	      		  
	      		  
	      	  }
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }
        
     }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('settlement-report', {
            parent: 'entity',
            params:{screen: 'TradesToBeSettledReport'},
            url: '/trades-to-be-settled-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.settlementReport.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/settlement-report/settlement-report.html',
                    controller: 'SettlementReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settlementReport');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('orderActivity');
                    return $translate.refresh();
                }],
                filterBy: ['StaticLookUp', function(StaticLookUp) {
                    return StaticLookUp.getTradesToBeSettledReportFilter().$promise;
                }],
                systemSetting: ['IntradayMarket', function(IntradayMarket) {
                    return IntradayMarket.getCurrentBusinessDate().$promise;
                }]
               
            },
          
        })

        .state('trade-activity', {
            parent: 'settlement-report',
            url: '/order-activity-status/{orderNumber}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-activity/order-activity.html',
                    controller: 'OrderActivityController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    	
                            	 entity: ['OrderActivity', 'GlobalValues', function(OrderActivity, GlobalValues) {
                                     return OrderActivity.get({orderNumber : $stateParams.orderNumber}).$promise;
                                 }],
                                 businessDate: null
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })

        
        
    };
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('SettlementReport', SettlementReport);

    SettlementReport.$inject = ['$resource'];

    function SettlementReport ($resource) {
        var resourceUrl =  'api/settlement-report/:id';
        
        return $resource(resourceUrl, {}, {
        	
        	'getSettlementReport':{
             	isArray:true,
  				method: 'GET',
  				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId: '@instrumentId', 
                    tradeTypeId: '@tradeTypeId', entityOwnerType: '@entityOwnerType', customFilter : '@customFilter', 
                    viewFor : '@viewFor', fromDate:'@fromDate', toDate : '@toDate',currencyPairId : '@currencyPairId'},
  				
  				url: 'api/settlement-report-summary/bank/:bankId/branch/:branchId/customer/:customerId/instrumentId/:instrumentId/tradeTypeId/:tradeTypeId/entityOwnerType/:entityOwnerType/customFilter/:customFilter/viewFor/:viewFor/fromDate/:fromDate/toDate/:toDate/currencyPair/:currencyPairId'
              },
              'exportData':{
  			    method: 'POST',
                  url: 'api/settlement-report/export',
                  responseType: 'arraybuffer',
                  params : {
                	  
                	  bankName : '@bankName',branchName :'@branchName', branchCode : '@branchCode',
                	  customerName:'@customerName', customerCode : '@customerCode',
  					customFilter : '@customFilter',instrument : '@instrument',tradeType : '@tradeType',
  					viewFor : '@viewFor',fromDate:'@fromDate',toDate:'toDate',currencyPairCode : '@currencyPairCode'
  				},
  				 transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	
                      return angular.toJson(copy);
                  },
                  transformResponse: function(data, headers) {
                	  return {
                          data: data,
                          headers: headers
                      };   
                  } 
  			},
  			 'exportDataCSV':{
   			    method: 'POST',
                   url: 'api/settlement-report/export-csv',
                   responseType: 'arraybuffer',
                   params : {
                 	  
                 	  bankName : '@bankName',branchName :'@branchName', branchCode : '@branchCode',
                 	  customerName:'@customerName', customerCode : '@customerCode',
   					customFilter : '@customFilter',instrument : '@instrument',tradeType : '@tradeType',
   					viewFor : '@viewFor',fromDate:'@fromDate',toDate:'toDate',currencyPairCode : '@currencyPairCode'
   				},
   				 transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   },
                   transformResponse: function(data, headers) {
                 	  return {
                           data: data,
                           headers: headers
                       };   
                   } 
   			}
        	
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'orderStatusReport'
        })
        
        .controller('SettlementReportController', SettlementReportController);

    SettlementReportController.$inject = ['$scope', '$state', 'SettlementReport', 'GlobalValues', 'ScreenLog','entityConstants','$timeout','DateUtils', 'DefaultMarket','filterBy', '$filter','$window','systemSetting','AlertService', 'StaticLookUp'];

    function SettlementReportController($scope, $state, SettlementReport , GlobalValues, ScreenLog,entityConstants,$timeout,DateUtils,DefaultMarket, filterBy, $filter, $window, systemSetting,AlertService, StaticLookUp) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.TRADESTOBESETTLEDREPORT;
        $scope.noOfRecordsPerPage = 3;
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        // DefaultMarket.marketInstruments(function(result){
        // 	vm.instrumentTypes = result;
        // });
		getInstrumentMatchedCurrencypair();

		function onGetInstrumentSuccess(result) {
            vm.instrumentTypes = result;
            // get tick size for each instrument
		}

		function onGetInstrumentFailure() {

        }
		
		StaticLookUp.getEventTypeList(function(result){
			vm.eventTypes = result;
		});
		vm.clicked=false;
        vm.ExpandOrCollapse = true;
        vm.expandBuyTrades = true;
        vm.expandSellTrades = true;
        vm.expandPropBuyTrades = true;
        vm.expandPropSellTrades = true;
        vm.todayDate = new Date();
        vm.businessDate = DateUtils.convertLocalDateFromServer(vm.globalValues.getSystemSettings().businessDate);;
        vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.orgId = vm.globalValues.getOrgId();
        vm.settlementReportSummaryDTOList = [];
        var  index = 0;

        vm.queryfromDate =  null;
        vm.querytoDate = null;

        if(systemSetting != null && systemSetting != undefined){
        	vm.currentDate = DateUtils.convertDateTimeFromServer(systemSetting.businessDate);
        	vm.fromSetDate = DateUtils.convertDateTimeFromServer(systemSetting.businessDate);
        	vm.toSetDate = DateUtils.convertDateTimeFromServer(systemSetting.businessDate);
        	
        }
        	

        if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
        	 vm.customer = vm.globalValues.getCustomer();
        }
        if(vm.entityOwnerType=='Bank' || vm.entityOwnerType=='Branch'){
        	vm.bank = vm.globalValues.getBank();
        }
        if(vm.entityOwnerType=='Branch'){
        	vm.branch = vm.globalValues.getBranch();
        }
        vm.filterBy = filterBy;
        
        angular.forEach(vm.filterBy, function(value){
        	if(value.shortName == 'AllTrade'){
        		vm.selectedFilterBy = value;
        	}
        })
        vm.getSettlementReport = getSettlementReport;
        vm.exportToFile = exportToFile;

        logScreenAccess();
        vm.viewFor = 'CUSTOMER';

        function getSettlementReport() {
        	var bankId = 0;
        	var branchId = 0;
        	var customerId = 0;
        	var instrumentId = 0;
			var tradeTypeId = 0;
        	var customFilter = 'ALL';
        	var viewFor = null;
			var currencyPairId = 0;

        	vm.settlementReportSummaryDTOList = [];

        	if(moment(vm.fromSetDate).isAfter(vm.toSetDate,'day')){
        		AlertService.error($filter('translate')('gatewayApp.settlementReport.greaterFromDate'));
        		vm.valid=false;
        	}
        	else{
				vm.clicked=true;
        		if(vm.bank!=null){
        			bankId = vm.bank.id;
        		}
        		if(vm.branch!=null){
        			branchId = vm.branch.id;
        		}
        		if(vm.customer!=null){
        			customerId = vm.customer.id;
        		}
        		if(vm.instrument!=null){
        			instrumentId = vm.instrument.id;
        		}
				if(vm.tradeType!=null){
        			tradeTypeId = vm.tradeType.id;
        		}
        		if(vm.selectedFilterBy != null && vm.selectedFilterBy != undefined){
        			customFilter = vm.selectedFilterBy.shortName;
        		}
				if(vm.currencyPair!=null){
        			currencyPairId = vm.currencyPair.id;
        		}

        		if(vm.entityOwnerType == 'Clearcorp'){
        			viewFor = vm.viewFor;
        		}
        		else if(vm.entityOwnerType == 'SingleUserCustomer' || vm.entityOwnerType == 'MultiUserCustomer'){
        			viewFor = 'Customer';
        		}

        		else{
        			viewFor = vm.entityOwnerType;
        		}

        		SettlementReport.getSettlementReport({bankId: bankId, branchId: branchId, customerId: customerId, instrumentId: instrumentId, tradeTypeId: tradeTypeId,
        			entityOwnerType: vm.entityOwnerType, customFilter : customFilter, viewFor : viewFor, fromDate: DateUtils.convertLocalDateToServer(vm.fromSetDate),toDate : DateUtils.convertLocalDateToServer(vm.toSetDate), currencyPairId: currencyPairId}, onGetSetttlementReportSuccess, onGetSetttlementReportFailure)

        	}
        }
           
       
       function  onGetSetttlementReportSuccess(result){
    	   
    	   vm.queryfromDate = DateUtils.convertLocalDateToServer(vm.fromSetDate);
    	   vm.querytoDate = DateUtils.convertLocalDateToServer(vm.toSetDate);
    	   
    	   index  = 1;
    	   
    	   if(result.length > 0 && result[0].settlementReportDetailsDTOList.length > 0 && result[0].settlementReportDetailsDTOList.length > 0 &&
    			   result[0].settlementReportDetailsDTOList[0].tradeDTOList.length > 0){
    		   
    		    $filter('orderBy')(result[0].settlementReportDetailsDTOList[0].tradeDTOList, 'tradeSequenceNumber');
    		    
    		   angular.forEach(result[0].settlementReportDetailsDTOList[0].tradeDTOList, function(value){
    			  
    			   value.index = index++;
    		   })
    	   }
    	   
    	   if(result.length > 0 && result[0].settlementReportDetailsDTOList.length > 0 && result[0].settlementReportDetailsDTOList.length > 1 &&
    			   result[0].settlementReportDetailsDTOList[1].tradeDTOList.length > 0){
    		   
    		    $filter('orderBy')(result[0].settlementReportDetailsDTOList[1].tradeDTOList, 'tradeSequenceNumber');
    		   
    		   angular.forEach(result[0].settlementReportDetailsDTOList[1].tradeDTOList, function(value){
    			   value.index = index++;
    		   })
    	   }
    	   
    	   index = 1;
    	   
    	   if(result.length > 1 && result[1].settlementReportDetailsDTOList.length > 0 && result[1].settlementReportDetailsDTOList.length > 0 
    			   && result[1].settlementReportDetailsDTOList[0].tradeDTOList.length > 0){
    		   
    		    $filter('orderBy')(result[1].settlementReportDetailsDTOList[0].tradeDTOList, 'tradeSequenceNumber');
    		    
    		   angular.forEach(result[1].settlementReportDetailsDTOList[0].tradeDTOList, function(value){
    			   value.index = index++;
    		   })
    	   }
    	   
 if(result.length > 1 && result[1].settlementReportDetailsDTOList.length > 0 && result[1].settlementReportDetailsDTOList.length > 1 
		 && result[1].settlementReportDetailsDTOList[1].tradeDTOList.length > 0){
    		   
	  $filter('orderBy')(result[1].settlementReportDetailsDTOList[1].tradeDTOList, 'tradeSequenceNumber');
	  
    		   angular.forEach(result[1].settlementReportDetailsDTOList[1].tradeDTOList, function(value){
    			   value.index = index++;
    		   })
    	   }
    	   
  		 
    	   vm.settlementReportSummaryDTOList = result;
		   vm.clicked=false;
    	
					
       }
       
       function onGetSetttlementReportFailure(){
		vm.clicked=false;
       }
       
       function logScreenAccess(){
    	   ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       vm.checkForNoRecords = checkForNoRecords
       function checkForNoRecords(){
    	   
    	   
    	   if((vm.settlementReportSummaryDTOList.length > 0 && vm.settlementReportSummaryDTOList[0] != null && vm.settlementReportSummaryDTOList != undefined
    			   && vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList.length > 0
    			   && vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0].tradeDTOList.length > 0)
    			   
    	   ||
    	   (vm.settlementReportSummaryDTOList.length > 0 && vm.settlementReportSummaryDTOList[0] != null && vm.settlementReportSummaryDTOList != undefined
    			   && vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList.length > 1
    			   && vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1].tradeDTOList.length> 0)
    			   
    	   ||
    	   (vm.settlementReportSummaryDTOList.length > 0 && vm.settlementReportSummaryDTOList[1] != null && vm.settlementReportSummaryDTOList != undefined
    			   && vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList.length > 0
    			   && vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].tradeDTOList.length > 0)
    	   ||
    	   (vm.settlementReportSummaryDTOList.length > 1 && vm.settlementReportSummaryDTOList[0] != null && vm.settlementReportSummaryDTOList != undefined
    			   && vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList.length > 1
    			   && vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].tradeDTOList.length > 0)){
    		   
    		   return false;
    		   
    	   }
    	   else{
    		   return true;
    	   }
    	 
    	 /*  if(vm.settlementReportSummaryDTOList.length > 0){
    		   
    		   if(  (vm.settlementReportSummaryDTOList[0] == null || vm.settlementReportSummaryDTOList[0] == undefined ) 
        			   ||( (vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0] == null 
        					   || vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0] == undefined 
        					   ||  vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0].tradeDTOList.length==0)
        					  && (
        							  vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1] == null 
        	    					   || vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1] == undefined 
        	    					   ||  vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1].tradeDTOList.length==0)
        			   ) &&
        			   (vm.settlementReportSummaryDTOList[1] == null || vm.settlementReportSummaryDTOList[1] == undefined ) 
        			   ||( (vm.settlementReportSummaryDTOList[1] != null && vm.settlementReportSummaryDTOList[1] != undefined && vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0] == null 
        					   || vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0] == undefined 
        					   ||  vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].tradeDTOList.length==0)
        					  && (
        							  vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1] == null 
        	    					   || vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1] == undefined 
        	    					   ||  vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].tradeDTOList.length==0)
        			   )
          			   
          	   ){
        		   return true;
        	   }else {return false;}
    		   
    	   }*/
    	 
       }
       
       
       $scope.$watch('vm.viewFor', function(value){
    	   if(vm.entityOwnerType=='Clearcorp'){
          	 vm.customer = null;
          	 vm.bank = null;
          	 vm.branch = null;
          }
    	   
       })
       
       
       function exportToFile(fileType){
	      	
	      	 vm.fileType = fileType;
	      	  
	      	 
	      	  var viewFor = '';
	      	 vm.valid=true;
	      	
	 		   var bankName = 'ALL BANKS';
	 		   var branchName= 'ALL BRANCHES'
	 		  
	 		  
	 		   var customerName = 'ALL CUSTOMERS';
	 		   var customFilter = 'ALL';
	 		   var instrument = 'ALL INSTRUMENTS';
			   var tradeType = 'ALL TRADE TYPES';
			   var currencyPairCode = 'ALL CURRENCY PAIR'

	 		 
	 		   var branchCode = null;
	 		   var customerCode = null;
	 		   
	 		   if(vm.bank != undefined && vm.bank != null & vm.bank != ''){
	 			  
	 			  bankName = vm.bank.bankName;
	 		   }
	 		  if(vm.branch != undefined && vm.branch != null && vm.branch != ''){
	 			 branchName = vm.branch.branchName;
	 			 branchCode = vm.branch.ifscCode;
	 			
	 		   }
	 		 if(vm.customer != undefined && vm.customer != null && vm.customer != ''){
	 			customerCode = vm.customer.customerCode;
	 			
	 			customerName = vm.customer.customerName;
			   }
	 		 if(vm.instrument != null && vm.instrument != undefined){
	 			instrument = vm.instrument.instrumentCode;
	 			
	 		 }
	 		 if(vm.tradeType != null && vm.tradeType != undefined){
				tradeType = vm.tradeType.name;
			 }
			 
	 		 if(vm.selectedFilterBy != null && vm.selectedFilterBy != undefined){
	 			 customFilter = vm.selectedFilterBy.shortName;
	 		 }
			if(vm.currencyPair != null &&vm.currencyPair != undefined){
	 			 currencyPairCode = vm.currencyPair.code;
	 		 }
	 		 
	 		 if(vm.entityOwnerType == 'Clearcorp' && vm.viewFor != null && vm.viewFor != undefined && vm.viewFor != ''){
	 			 viewFor = vm.viewFor;
	 		 }
	      	  if( vm.settlementReportSummaryDTOList !=null &&  vm.settlementReportSummaryDTOList!=undefined && vm.settlementReportSummaryDTOList.length > 0){
	      		  if(vm.fileType == 'csv'){
	      			  
	      			  
	      			SettlementReport.exportDataCSV({bankName : bankName, branchCode : branchCode, customerCode : customerCode,
	 					customerName : customerName, branchName : branchName, customFilter : customFilter, instrument : instrument, tradeType: tradeType,
						viewFor : viewFor, fromDate: vm.queryfromDate,toDate : vm.querytoDate,currencyPairCode : currencyPairCode}, vm.settlementReportSummaryDTOList, onExportSuccess);
	      			
	      		  }else if(vm.fileType == 'excel'){
	      			  
	      			
	      			SettlementReport.exportData({bankName : bankName, branchCode : branchCode, customerCode : customerCode,
	 					customerName : customerName, branchName : branchName, customFilter : customFilter, instrument : instrument, tradeType: tradeType,
						viewFor : viewFor, fromDate: vm.queryfromDate,toDate : vm.querytoDate,currencyPairCode : currencyPairCode}, vm.settlementReportSummaryDTOList, onExportSuccess);
	      		  }
	      		
	 			 
	 			 }
	      		  
	      	  }
       
       function onExportSuccess(result){
    	   var mimeType= '';
    	   
    	   var baseString =   'Trades_To_Be_Settled_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   
    	   
    	   if(vm.fileType == 'csv'){
   			  
   			  mimeType = 'text/csv'
   			  baseString = baseString+ ".csv";  
    	   }
    	   else{
    		   mimeType = 'application/vnd.ms-excel';
     			baseString = baseString+ ".xls";  
    	   }
    	   
    	   var fileData = null;
    	   
    	   fileData = result.data;
			  
 			var IEFile = new Blob([result.data], {type: mimeType});
     		
             
             if(window.navigator.msSaveOrOpenBlob) {
                   window.navigator.msSaveOrOpenBlob(IEFile, baseString );
               }
             else{
           	  
           	  var link = document.createElement("a");   
     			  var bytes = new Uint8Array(fileData );   
     			      			  
 			      var blob = new Blob([bytes], {type: mimeType});
 			      link.href =  window.URL.createObjectURL(blob);
 			      
     		   	  link.download = baseString;
     		   	  document.body.appendChild(link);
     		   	  link.click();
     			  document.body.removeChild(link);
     			  
             }
       }
       
       
       $scope.$watch('vm.selectedFilterBy', function(value){
       	if(value != null && value != undefined && (vm.entityOwnerType == 'Bank' || vm.entityOwnerType == 'Branch' || vm.entityOwnerType == 'Clearcorp')){
       		vm.customer = null;
       	}
       })

	   

        $scope.$watch('vm.currencyPair', function (value) {
         if (value != null && value != undefined) {
			getInstrumentMatchedCurrencypair();
    	}
		})

		function getInstrumentMatchedCurrencypair(){
            var currencyPairId = vm.globalValues.getDefaultCurrencyPairId();
            if (!vm.currencyPair != null && vm.currencyPair != undefined) {
                currencyPairId = vm.currencyPair.id;
                DefaultMarket.csInstruments({currencyPairId:currencyPairId},onGetInstrumentSuccess, onGetInstrumentFailure);
            }
            
        }
	}
    
    
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('session-log', {
            parent: 'entity',
            url: '/session-log',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.AuditLog.sessionLog" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/session-log-report/session-log-report.html',
                    controller: 'SessionLogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('sessionLog');
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }],
                entity: function(){
                	
                }
            }
        })
        .state('session-manage-users-view', {
            parent: 'session-log',
            url: '/users/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-detail.html',
                    controller: 'UsersViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['User', 'GlobalValues', function(User, GlobalValues) {
                                    return User.get({userId : $stateParams.id}).$promise;

                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
       
       };
       
    })();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('SessionLog', SessionLog);

    SessionLog.$inject = ['$resource'];

    function SessionLog ($resource) {
        var resourceUrl =  'api/get-session-log/:id';

        return $resource(resourceUrl, {}, {
            
        	 'getSessionLogDetails':{
             	isArray:true,
  				method: 'GET',
  				params: {userIds:'@userIds',from:'@from',to:'@to',queryParams:'@queryParams',branchId:'@branchId',orgId:'@orgId'},
  				url: 'api/session-log-report/get-session-log-details'
              },
              
         	 'getSessionLogDetailsFromArchive':{
              	isArray:true,
   				method: 'GET',
   				params: {userIds:'@userIds',from:'@from',to:'@to',queryParams:'@queryParams',branchId:'@branchId',orgId:'@orgId'},
   				url: 'api/session-log-archive-report/get-session-log-details'
               }
             
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function() {
            this.viewFrom = ''
        })
        .controller('SessionLogController', SessionLogController);

    SessionLogController.$inject = ['$scope', '$state', 'workflowSharedService','$rootScope','MessageBox','GlobalValues','EntityPermissions','$filter', 'entity','DateUtils','SessionLog','ScreenLog', 'entityConstants','AlertService'];

    function SessionLogController($scope, $state, workflowSharedService, $rootScope, MessageBox, GlobalValues, EntityPermissions,$filter, entity,DateUtils,SessionLog,ScreenLog,entityConstants,AlertService) {    
        var vm = this;
        vm.globalValues = GlobalValues;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.getSessionLogDetails=getSessionLogDetails;
        vm.todayDate=new Date();
        vm.screenLog=ScreenLog;
        vm.userEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.userListValue={};
        vm.ExpandOrCollapseSessionLog = true;
        workflowSharedService.viewFrom = 'userRole';
        vm.valid=false;
		vm.clicked=false;

        vm.historicalOrCurrent = 'Current';
        
		vm.reportDate  = DateUtils.convertDateTimeFromServer(vm.todayDate);
		vm.yesterdayDate = angular.copy(vm.reportDate);
		vm.yesterdayDate.setDate(vm.yesterdayDate.getDate() - 1);
		vm.fromDate = angular.copy(vm.reportDate);
		vm.fromDate.setDate(vm.fromDate.getDate() -1);
	    vm.toDate = angular.copy(vm.reportDate);
	    vm.toDate.setDate(vm.toDate.getDate() -1);

        /*
         * Get details for session log given userId, from and to date
         */
        logScreenAccess();
        
        function getQueryParamsValue(){
        	vm.queryParams = "";
        	if(vm.userEntityOwnerType == 'Clearcorp'){
        		if(vm.selectedEntityOwnerType == 'Bank'){
        			vm.queryParams = 'Entity Owner Type : BANK;';
        			vm.queryParams = vm.queryParams +'Bank : '+ vm.bankValue.shortName +';';
        		}
        		else if(vm.selectedEntityOwnerType == 'Branch'){
        			vm.queryParams = 'Entity Owner Type : BRANCH;';
        			vm.queryParams = vm.queryParams +'Bank : '+ vm.bankValue.shortName +';'+ 'Branch : ' + vm.branchValue.shortName + ';';
        		}
        		else if(vm.selectedEntityOwnerType == 'MultiUserCustomer'){
        			vm.queryParams = 'Entity Owner Type : MULTIUSERCUSTOMER;';
        			vm.queryParams = vm.queryParams +'Bank : '+ vm.bankValue.shortName +';'+ 'Branch : ' + vm.branchValue.shortName + ';'+'Customer : ' + vm.customerValue.customerCode + ';';
        		}
        		else if(vm.selectedEntityOwnerType == 'SingleUserCustomer'){
        			vm.queryParams = 'Entity Owner Type : SINGLEUSERCUSTOMER;';
        			vm.queryParams = vm.queryParams +'Bank : '+ vm.bankValue.shortName +';'+ 'Branch : ' + vm.branchValue.shortName + ';'+'Customer : ' + vm.customerValue.customerCode + ';';
        		}else{
        			vm.queryParams = 'Entity Owner Type : CLEARCORP;';
        		}

        		if(vm.userValue != null){
        			vm.queryParams = vm.queryParams + 'User :  ' + vm.userValue.login + ';'
        		}else{
        			vm.queryParams = vm.queryParams + 'User : All;'
        		}
        		vm.queryParams = vm.queryParams + 'From Date : ' + $filter('date')(vm.fromDate, "dd-MMM-yyyy") + ';';
        		vm.queryParams = vm.queryParams + 'To Date : ' + $filter('date')(vm.toDate, "dd-MMM-yyyy");
        	}
        	else{
        		if(vm.user!=undefined && vm.user!=null){
        			vm.queryParams = vm.queryParams + 'Login Name :  ' + vm.user.login + ';'
        		}else{
        			vm.queryParams = vm.queryParams + 'Login Name : All;'
        		}
        		vm.queryParams = vm.queryParams + 'From Date : ' + $filter('date')(vm.fromDate, "dd-MMM-yyyy") + ';';
        		vm.queryParams = vm.queryParams + 'To Date : ' + $filter('date')(vm.toDate, "dd-MMM-yyyy");
        	}
        }

        
        
        function getInitialRequirements(){
        	if(vm.userEntityOwnerType == 'Clearcorp'){
        		if(vm.selectedEntityOwnerType == 'Bank' || vm.selectedEntityOwnerType == 'Branch'){
        			vm.organisationId = vm.bankValue.id; 
        		}else if(vm.selectedEntityOwnerType == 'MultiUserCustomer' || vm.selectedEntityOwnerType == 'SingleUserCustomer'){
        			vm.organisationId = vm.customerValue.id;
        		}else{
        			vm.organisationId = vm.globalValues.getOrganisation().id;
        		}
        		if(vm.selectedEntityOwnerType == 'Branch'){
        			vm.branchId = vm.branchValue.id;
        		}else{
        			vm.branchId = 0;
        		}
        		if(vm.userListValue == null || vm.userListValue == undefined || vm.userListValue.length == 0){
        			vm.userListValue.push(-1);
        		}
        	}else{
        		vm.userListValue = [];
        		vm.organisationId = vm.globalValues.getOrganisation().id;
        		if(vm.globalValues.getBranch() != null){
        			vm.branchId = vm.globalValues.getBranch().id;
        		}else{
        			vm.branchId = 0;
        		}
        		if(vm.user!=undefined && vm.user!=null){
        			var userId = vm.user.id;
        			vm.userListValue.push(userId);
        			
        		}else{
        			vm.userListValue.push(-1);
        		}
        		
        	}
        	getQueryParamsValue();
        }
        function getSessionLogDetails()
        {   
        	vm.sessionLogDetails = [];
        	if(vm.historicalOrCurrent != 'Current' && moment(vm.fromDate).isAfter(vm.yesterdayDate,'day')){
    			AlertService.error($filter('translate')('gatewayApp.SessionLog.futureFromDate'));
    			vm.valid=false;
    		}
    		else if(vm.historicalOrCurrent != 'Current' && moment(vm.fromDate).isAfter(vm.toDate,'day')){
    			AlertService.error($filter('translate')('gatewayApp.SessionLog.greaterFromDate'));
    			vm.valid=false;
    		}else if(vm.historicalOrCurrent != 'Current' && moment(vm.toDate).isAfter(vm.yesterdayDate,'day')){
    			AlertService.error($filter('translate')('gatewayApp.SessionLog.greaterToDate'));
    			vm.valid=false;
    		}
    		else{
				vm.clicked=true;
    			getInitialRequirements();
    			vm.valid=true;
    			var from=$filter('date')(vm.fromDate, "yyyy-MM-dd");
        		var to=$filter('date')(vm.toDate, "yyyy-MM-dd");
        		var userId = 0;
        		vm.selectedHistoryOrCurrent = angular.copy(vm.historicalOrCurrent);
        		
        		
        		if(vm.historicalOrCurrent == 'Current'){
	    			from = $filter('date')(vm.todayDate, "yyyy-MM-dd");
	        		to = $filter('date')(vm.todayDate, "yyyy-MM-dd");
        			SessionLog.getSessionLogDetails({"userIds":vm.userListValue,"from":from,"to":to,"queryParams":vm.queryParams,"branchId":vm.branchId,"orgId":vm.organisationId},onGetSessionLogSuccess,onGetSessionLogError);
        		}else{
        			SessionLog.getSessionLogDetailsFromArchive({"userIds":vm.userListValue,"from":from,"to":to,"queryParams":vm.queryParams,"branchId":vm.branchId,"orgId":vm.organisationId},onGetSessionLogSuccess,onGetSessionLogError);
        		}
    		}
        }
        //vm.fromDate = DateUtils.convertDateTimeFromServer(vm.todayDate);
        //vm.toDate = DateUtils.convertDateTimeFromServer(vm.todayDate);
        
        function onGetSessionLogSuccess(result)
        {
        	
        	vm.sessionLogDetails=result;
			vm.clicked=false;
        	
        }
        
        
        function onGetSessionLogError()
        {
        	vm.clicked=false;
        }
        
        function onGetSessionLogDetailsSuccess(result)
        {
        	
        	vm.sessionLogDetails=result;
        	
        }
        
        
        function onGetSessionLogDetailsError()
        {
        	
        }
        
        function logScreenAccess(){
           	ScreenLog.screenLog(  entityConstants.ENTITY_SHORT_NAME.SESSION_LOG_REPORT,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }

     }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('server-component-status', {
            parent: 'entity',
            params:{screen: 'ServerComponentStatus'},
            url: '/server-component-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.serverComponentStatus.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/server-component-status/server-component-status.html',
                    controller: 'ServerComponentStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('servercomponentstatus');
                    return $translate.refresh();
                }]
               
            }
        })
        
         
         };
    })();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ServerComponentStatus', ServerComponentStatus);

    ServerComponentStatus.$inject = ['$resource'];

    function ServerComponentStatus ($resource) {
        var resourceUrl =  'api/order-server-manual-login';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', 
        		isArray: true,
    			params: {orgId:'@orgId'},
    			url: 'api/orgId/:orgId/he-connectivity-settings'
    	 		},
        	
              'manualLogin': {
                  method: 'POST',
                  url: 'order/manual-login'
              },
              'changeStatus': {
                  method: 'POST',
                  params: {status:'@status'},
                  url: 'order/he-interactive-status-update'
              },
              'getServerComponentStatus': {
                  method: 'GET',
                  isArray: true,
                  url: 'api/server-component-status',
                  transformResponse: function (data) {
                      if (data) {
                          data = angular.fromJson(data);
                      }
                      return data;
                  }
              }
        });
    }
})();

(function() {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function() {
		this.viewFrom = 'serverComponentStatus'
	})

	.controller('ServerComponentStatusController',
			ServerComponentStatusController);

	ServerComponentStatusController.$inject = [ '$scope', '$state',
			'GlobalValues', 'workflowSharedService', 'EntityPermissions',
			'ScreenLog', 'entityConstants', '$timeout',
			'ServerComponentStatus', 'MessageBox', '$rootScope',
			'AlertService', '$filter', '$interval','Auth' ];

	function ServerComponentStatusController($scope, $state, GlobalValues,
			workflowSharedService, EntityPermissions, ScreenLog,
			entityConstants, $timeout, ServerComponentStatus, MessageBox,
			$rootScope, AlertService, $filter, $interval,Auth) {
		var vm = this;
		vm.entityConstants = entityConstants;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.SERVER_COMPONENT_STATUS;
		$scope.noOfRecordsPerPage = GlobalValues
				.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;
		vm.globalValues = GlobalValues;
		workflowSharedService.viewFrom = "serverComponentStatus";
		vm.screenLog = ScreenLog;
		var autoRefreshInterval = 3;
		vm.isRefreshCompelete = true;
		vm.autoRefreshCount = 1;
		var yesMessageEvent = null;
		var startRecoveryEvent = null;
		var yesHeMessageEvent = null;
		var statusUpdateEvent = null;
		logScreenAccess();

		vm.orderServerManualLogin = orderServerManualLogin;
		vm.sendHEStatusUpdate = sendHEStatusUpdate;

		vm.todayDate = new Date();
		vm.serverComponentStatus = {
			"Zero" : "Zero"
		};
		vm.permitServerComponentStatusViewAction = EntityPermissions.hasPermission('ServerComponentStatus.VIEW');
      /* if(vm.permitServerComponentStatusViewAction ==false){
			//message box 
			MessageBox.openMessageBox('Alert', 'Session expired. You will be redirected to login page...!', 'Ok', 'permitServerComponentStatusViewAction');
		}

		$rootScope.$on('gatewayApp.messagebox.ok.permitServerComponentStatusViewAction', function (event) {
			Auth.sessionlogout();
		});
		
		$rootScope.$on('gatewayApp.messagebox.clear.permitServerComponentStatusViewAction', function (result){
			Auth.sessionlogout();
		})*/

		loadAll();
		fetchAndSetServerComponentStatus();

		vm.autoRefreshCountDown = autoRefreshInterval;

		$interval(function() {
			if (vm.isRefreshCompelete) {
				if (vm.autoRefreshCountDown - 1 == 0) {
					vm.autoRefreshCountDown = autoRefreshInterval;
					vm.isRefreshCompelete = false;
				} else {
					vm.autoRefreshCountDown = vm.autoRefreshCountDown - 1;
				}
			}

		}, 1000);

		$interval(function() {
			fetchAndSetServerComponentStatus();
			vm.autoRefreshCount = vm.autoRefreshCount + 1;
		}, autoRefreshInterval * 1000);

		function logScreenAccess() {
			ScreenLog.screenLog(vm.screenName, 0,
					entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}

		function fetchAndSetServerComponentStatus() {
			ServerComponentStatus.getServerComponentStatus(function(result) {
				angular.forEach(result, function(value) {					
					vm.serverComponentStatus[value.processCode] = value;			
					if(value.processCode == 'WBS'){
						vm.connectedSite = value.activeNode;
					}
				});
			});	
			vm.isRefreshCompelete = true;
		}

		function loadAll() {
			ServerComponentStatus.query({
				"orgId" : GlobalValues.getOrgId()
			}, function(result) {
				vm.currentStatus = result[0].interactiveStatus;

				if (vm.currentStatus == 'Online') {
					vm.changedStatus = 'Offline';
				} else {
					vm.changedStatus = 'Online';
				}

			});

		}
		function sendHEStatusUpdate() {
			$scope.status = vm.changedStatus;
			MessageBox.openMessageBox("Alert",
					"Do you want to change the status from " + vm.currentStatus
							+ " to " + vm.changedStatus + "?", "YesNo",
					"changeHEStatus");
		}

		function orderServerManualLogin() {

			MessageBox.openMessageBox("Alert",
					"Do you want to manually login to order server?", "YesNo",
					"orderServerManualLogin");
		}

		yesMessageEvent = $rootScope.$on(
				'gatewayApp.messagebox.yes.orderServerManualLogin', function(
						event, data) {
					vm.orderServerManualLoginStatus = "PROGRESS";
					ServerComponentStatus.manualLogin(
							orderServerManualLoginSuccess,
							orderServerManualLoginFailure);

				});

		$rootScope.$on('gatewayApp.messagebox.no.orderServerManualLogin',
				function(event, data) {
					// do nothing
				});

		function orderServerManualLoginSuccess(error) {

		}

		function orderServerManualLoginFailure(error) {
			// alert(error.message);
			vm.orderServerManualLoginStatus = "";
			var errorString = "";
			if (error.status == 503) {

				// AlertService.error($filter('translate')(
				// "error.order.serviceUnavailable"));
				errorString = $filter('translate')(
						"error.order.serviceUnavailable");
				MessageBox.openMessageBox("Alert", errorString
						+ " Kindly contact support team.", "Ok", "alertError");
			} else if (error.status == 403) {
				// since session expiry popup is diplayed do not show any error
				// for 403 status

			} else {
				// AlertService.error($filter('translate')( error.data));
				errorString = error.data;
				MessageBox.openMessageBox("Alert", errorString
						+ " Kindly contact support team.", "Ok", "alertError");
			}

		}

		startRecoveryEvent = $rootScope.$on('orderServerManualLogin', function(
				event, data) {
			if (data != null) {

				if (data.message == "success") {
					// vm.orderServerManualLoginStatus = "SUCCESS";
					vm.orderServerManualLoginStatus = "";
					console.log("Order server manual login successful "
							+ data.message);
					// AlertService.success($filter('translate')('global.menu.orderServerManualLogin.success'));
					MessageBox.openMessageBox("Alert", $filter('translate')(
							'global.menu.orderServerManualLogin.success'),
							"Ok", "alertError");

				} else {
					// vm.orderServerManualLoginStatus = "FAILURE";
					vm.orderServerManualLoginStatus = "";
					console.log("Order server manual login failed "
							+ data.message);
					// AlertService.error(data.message);
					MessageBox.openMessageBox("Alert", data.message, "Ok",
							"alertError");
				}
			}

		});

		$scope.$on('$destroy', function() {

			if (startRecoveryEvent != null)
				startRecoveryEvent();

			if (yesHeMessageEvent != null)
				yesHeMessageEvent();

			if (yesMessageEvent != null)
				yesMessageEvent();

			if (statusUpdateEvent != null)
				statusUpdateEvent();

		});

		yesHeMessageEvent = $rootScope.$on(
				'gatewayApp.messagebox.yes.changeHEStatus', function(event,
						data) {
					if ($scope.status != null && $scope.status != undefined) {
						vm.heStatusUpdate = "PROGRESS";
						ServerComponentStatus.changeStatus({
							status : $scope.status
						}, changeStatusSuccess, changeStatusFailure);

					}

				});

		$rootScope.$on('gatewayApp.messagebox.no.changeHEStatus', function(
				event, data) {
			// do nothing
		});

		function changeStatusSuccess() {

		}

		function changeStatusFailure(error) {
			vm.heStatusUpdate = "";
			var errorString = "";
			if (error.status == 503) {

				// AlertService.error($filter('translate')(
				// "error.order.serviceUnavailable"));
				errorString = $filter('translate')(
						"error.order.serviceUnavailable");
				MessageBox.openMessageBox("Alert", errorString
						+ " Kindly contact support team.", "Ok", "alertError");
			} else if (error.status == 403) {
				// since session expiry popup is diplayed do not show any error
				// for 403 status

			} else {
				// AlertService.error($filter('translate')( error.data));
				errorString = error.data;
				MessageBox.openMessageBox("Alert", errorString
						+ " Kindly contact support team.", "Ok", "alertError");
			}

		}
		statusUpdateEvent = $rootScope.$on('heStatusUpdate', function(event,
				data) {
			if (data != null) {
				if (data.message == "success") {
					// vm.heStatusUpdate = "SUCCESS";
					vm.heStatusUpdate = "";
					console.log("He connection successful " + data.message);
					// AlertService.success($filter('translate')('gatewayApp.servercomponent.heSuccess'));
					loadAll();
					MessageBox.openMessageBox("Alert", $filter('translate')(
							'gatewayApp.servercomponent.heSuccess'), "Ok",
							"alertError");
				} else {
					// vm.heStatusUpdate = "FAILURE";
					vm.heStatusUpdate = "";
					console.log("He connection failed " + data.message);
					// AlertService.error(data.message);
					// AlertService.error($filter('translate')('gatewayApp.heStatusUpdate.error'));
					MessageBox.openMessageBox("Alert", $filter('translate')(
							'gatewayApp.heStatusUpdate.error'), "Ok",
							"alertError");
				}
			}

		});

		$rootScope.$on('gatewayApp.messagebox.Ok.alertError', function(event,
				data) {
			// do nothing
		});

	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('SecurityPolicyDialogController', SecurityPolicyDialogController);

    SecurityPolicyDialogController.$inject = ['Workflow', '$scope', '$state', '$stateParams', '$rootScope','workflowSharedService', 'GlobalValues', '$uibModalInstance', 'Role', 'SecurityPolicy','entity','ScreenLog','entityConstants'];

     function SecurityPolicyDialogController(Workflow, $scope, $state, $stateParams, $rootScope, workflowSharedService, GlobalValues, $uibModalInstance, Role, SecurityPolicy, entity,ScreenLog,entityConstants) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.SECURITY_POLICY;
        vm.screenLog = ScreenLog;
        vm.save = save;
        vm.clear = clear;
        vm.securityPolicyDTO ={};
        vm.clicked=false;
        
        vm.approveSecurityPolicy = approveSecurityPolicy;
        vm.rejectSecurityPolicy = rejectSecurityPolicy;
        vm.discardSecurityPolicy = discardSecurityPolicy;
        vm.resubmitSecurityPolicy = resubmitSecurityPolicy;
         Role.queryAll({orgId:GlobalValues.getOrgId()}, function(result){
        	 vm.roles = result;
        	if(workflowSharedService.viewFrom == 'securityPolicy'){
        		
    	        showButtonsViewScreen();    	       
    	        vm.selected = {orgRoleID: []};
    	        vm.securityPolicyDTO = entity;
    	        vm.screenLog.screenLog(vm.screenName, vm.securityPolicyDTO.themeID, entityConstants.ENTITY_ACTION_TYPE.MAP);
    	    	vm.selected.orgRoleID = vm.securityPolicyDTO.organisationRoleIDs;
            }
            else if(workflowSharedService.viewFrom == 'securityPolicytodolist_checker') {
            	vm.ViewDisable = true;
            	//vm.roles =  Role.queryAll({orgId:GlobalValues.getOrgId()});
    	        vm.selected = {orgRoleID: []};
            	vm.securityPolicyDTO =  angular.fromJson($rootScope.payload); 
            	vm.selected.orgRoleID = vm.securityPolicyDTO.organisationRoleIDs;
            	showButtonsViewCheckerScreen();
            }
            else if(workflowSharedService.viewFrom == 'securityPolicytodolist_maker') {
            	vm.ViewDisable = true;
            	//vm.roles =  Role.queryAll({orgId:GlobalValues.getOrgId()});
    	        vm.selected = {orgRoleID: []};
            	vm.securityPolicyDTO =  angular.fromJson($rootScope.payload); 
            	vm.selected.orgRoleID = vm.securityPolicyDTO.organisationRoleIDs;
            	showButtonsViewMakerScreen();
            }
            
            else if(workflowSharedService.viewFrom == 'securityPolicy_resubmit') {
            	vm.securityPolicyDTO = angular.fromJson($rootScope.payload); 
    	        vm.screenLog.screenLog(vm.screenName, vm.securityPolicyDTO.themeID, entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
    	        //vm.roles =  Role.queryAll({orgId:GlobalValues.getOrgId()});
    	        vm.selected = {orgRoleID: []};
            	vm.selected.orgRoleID = vm.securityPolicyDTO.organisationRoleIDs;
            	showButtonsResubmitScreen();
            }
            else if(workflowSharedService.viewFrom == 'securityPolicy_auditLog') {
            	vm.ViewDisable = true;
            	//vm.roles =  Role.queryAll({orgId:GlobalValues.getOrgId()});
    	        vm.selected = {orgRoleID: []};
            	vm.securityPolicyDTO =  angular.fromJson($rootScope.payload); 
            	vm.selected.orgRoleID = vm.securityPolicyDTO.organisationRoleIDs;
            	vm.btnClose=true;
            	vm.btnApproveReject=false;
            	
            }
        });
        
        function showButtonsViewScreen(){
        	vm.ViewDisable = false;
            vm.btnClose = false;
            vm.btnApproveReject = false;
            $scope.showDiscardButton = false;
            $scope.showSaveButton = true;
            $scope.showCancelButton = true;
            $scope.showResubmitButton = false;
        }
        function showButtonsViewCheckerScreen(){
        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
        	vm.btnClose = true;
        	$scope.showDiscardButton = false;
        	vm.btnApproveReject = true;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
        function showButtonsResubmitScreen(){
        	vm.btnClose = false;
        	$scope.showButton=true;
        	vm.btnApproveReject = false;
        	$scope.showDiscardButton = false;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = true;
            $scope.showResubmitButton = true;
        }
        function showButtonsViewMakerScreen(){
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        	vm.btnClose = true;
        	vm.btnApproveReject = false;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
		function clear () {
            $uibModalInstance.dismiss('cancel');
        }
		
		function save () {	
			
			vm.securityPolicyDTO.organisationRoleIDs = vm.selected.orgRoleID;
        	SecurityPolicy.save({"orgId":GlobalValues.getOrgId()},vm.securityPolicyDTO, onSaveSuccess, onSaveError);	
        }
     
        function onSaveSuccess (result) {
        	
            $uibModalInstance.close(result);  
        }

        function onSaveError () {
        	vm.clicked=false;
        }
        function approveSecurityPolicy() { 
        	SecurityPolicy.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	vm.clicked=false;
        }
       
        function rejectSecurityPolicy() { Workflow.rejectTask($rootScope.taskID); }

        function onRejectSuccess(result) {
        
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onRejectError(error) {}
        
        function discardSecurityPolicy() {
        	SecurityPolicy.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {

        }
        function resubmitSecurityPolicy() {
        	vm.securityPolicyDTO.organisationRoleIDs = vm.selected.orgRoleID;
         	SecurityPolicy.resubmit({"taskId" : $rootScope.taskID}, vm.securityPolicyDTO, onResubmitSuccess, onResubmitError);
          	$uibModalInstance.dismiss('cancel');
          }
          
          function onResubmitSuccess(result) {
         
          	$rootScope.removeRow($rootScope.taskID);
          }        
          function onResubmitError(error) {
        	  vm.clicked=false;
          }

     } 
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('security-policy', {
            parent: 'entity',
            url: '/security-policy',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.security.managesecuritypolicy" | translate }}',
                parent: 'home'
              },
            views: {
                'content@': {
                    templateUrl: 'app/entities/security-policy/security-policy.html',
                    controller: 'SecurityPolicyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('securityPolicy');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('security-policy.new', {
            parent: 'security-policy',
            url: '/security-policy/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$rootScope', '$uibModal', function($stateParams, $state, $rootScope, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/security-policy/security-policy-dialog.html',
                    controller: 'SecurityPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: ['SecurityPolicy', 'GlobalValues', function(SecurityPolicy, GlobalValues) {
                            return SecurityPolicy.get({orgId:GlobalValues.getOrgId(), themeID : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                	$rootScope.$emit('gatewayApp:securityPolicyRefresh');
                    $state.go('security-policy');
                }, function() {
                    $state.go('security-policy');
                });
            }]
        })
         .state('security-policy-todolist', {
            parent: 'dashboard',
            url: '/security-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/security-policy/security-policy-dialog.html',
                    controller: 'SecurityPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('security-policy', null, { reload: 'security-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
        .state('security-policy-todolist.resubmit', {
            parent: 'dashboard',
            url: '/security-policy-resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/security-policy/security-policy-dialog.html',
                    controller: 'SecurityPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                        	

                        }
                    }
                }).result.then(function() {
                    $state.go('security-policy', null, { reload: 'security-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
        })
        .state('security-policy-auditLog', {
            parent: 'audit-log',
            url: '/security-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/security-policy/security-policy-dialog.html',
                    controller: 'SecurityPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('security-policy', null, { reload: 'security-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
        .state('security-policy-historyReport', {
            parent: 'history-report',
            url: '/security-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/security-policy/security-policy-dialog.html',
                    controller: 'SecurityPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('security-policy', null, { reload: 'security-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
   };
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('SecurityPolicy', SecurityPolicy);

    SecurityPolicy.$inject = ['$resource'];

    function SecurityPolicy ($resource) {
        var resourceUrl =  'api/orgId/:orgId/security-policy/:themeID';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/orgId/:orgId/security-policy'
        	 },
        	 'getEntityPermissions':{
        		 params: {orgId:'@orgId'},
        		 isArray: true,
         	     url: 'api/orgId/:orgId/security-policy/entity-permissions'
        	 },
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
             'themesForOrganisation': { method: 'GET', isArray: true,
                params: {orgId:'@orgId'},
                url: 'api/orgId/:orgId/themes'
             },
             'actionsForOrgAndTheme': { method: 'GET', isArray: true,
                params: {orgId:'@orgId', themeId: '@themeId'},
                url: 'api/orgId/:orgId/actions-for-theme/:themeId/themeId'
             },
        	 'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/orgId/:orgId/security-policy',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 return angular.toJson(copy);
                 }                
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/security-policy',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'securityPolicy'
        })
        .controller('SecurityPolicyController', SecurityPolicyController);

    SecurityPolicyController.$inject = ['$scope', '$rootScope', '$state', 'workflowSharedService', 'SecurityPolicy', 'GlobalValues', 'EntityPermissions','ScreenLog', 'entityConstants','$timeout'];

    function SecurityPolicyController ($scope, $rootScope, $state, workflowSharedService, SecurityPolicy, GlobalValues, EntityPermissions,ScreenLog, entityConstants,$timeout) {
        var vm = this;
        vm.screenLog=ScreenLog;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.SECURITY_POLICY;
        vm.securityPolicies = [];
        
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        $scope.refresh=refresh;
        
        vm.permitSecurityPolicyMapEntityAction = EntityPermissions.hasPermission('SecurityPolicy.MAP');
                
        workflowSharedService.viewFrom = 'securityPolicy';
        
        $rootScope.$on('gatewayApp:securityPolicyRefresh', function(event, result) {
        	loadAll();
        });
        
        logScreenAccess();
        loadAll();

        function loadAll() {
        	SecurityPolicy.query({"orgId":GlobalValues.getOrgId()},function(result) {
        		vm.securityPolicies = result;
        	});
        	
        }
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }
        
        $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RoleViewController', RoleViewController);

    RoleViewController.$inject = ['Workflow', '$scope', '$rootScope', '$state',  '$uibModalInstance', 'workflowSharedService', 'Role', 'entity', 'ScreenLog'];

    function RoleViewController(Workflow, $scope, $rootScope, $state, $uibModalInstance, workflowSharedService, Role, entity, ScreenLog) {
        var vm = this;
        vm.role=entity;
        vm.clear=clear;
        vm.approveRole = approveRole;
        vm.rejectRole = rejectRole;
        vm.discardRole = discardRole;
        $scope.showButton = false;
        $scope.showDiscardButton = false;
        vm.clicked=false;
        if(workflowSharedService.viewFrom == 'role'){
        	vm.role = entity;
            //ScreenLog.screenLog({'entityName': 'OrganisationRole', 'entityRecordId': vm.role.id, 'action': 'VIEW'});
       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'roletodolist_checker') {
        	vm.role =  angular.fromJson($rootScope.payload); 
        	
        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
        }
        else if(workflowSharedService.viewFrom == 'roletodolist_maker') {
        	vm.role =  angular.fromJson($rootScope.payload); 
        
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        }
        if(workflowSharedService.viewFrom == 'role_auditLog'){
        	vm.role =  angular.fromJson($rootScope.payload); 
            //ScreenLog.screenLog({'entityName': 'OrganisationRole', 'entityRecordId': vm.role.id, 'action': 'VIEW'});
       	 	$scope.showButton=false;
        }
       
        function approveRole() { 
        	Role.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	vm.clicked=false;
        }
       
        function rejectRole() {Workflow.rejectTask($rootScope.taskID);}

        function discardRole() {
        	Role.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }
              
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        

        
       
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RoleController', RoleController);

    RoleController.$inject = ['$scope', '$rootScope', '$state',  '$uibModalInstance', 'Role', 'GlobalValues', 'entity', 'workflowSharedService', 'ScreenLog','entityConstants'];

    function RoleController($scope, $rootScope, $state, $uibModalInstance, Role, GlobalValues, entity, workflowSharedService, ScreenLog,entityConstants) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.ORGANISATION_ROLE;
        vm.screenLog = ScreenLog;
        vm.clear=clear;
        vm.save=save;
        $scope.showButton = false;
        vm.resubmitRole =resubmitRole;
        vm.clicked=false;
        $scope.showButton = false;
        
        
        if(workflowSharedService.viewFrom == 'role'){
        	vm.role=entity;
        	if(vm.role.id !== null){
                //ScreenLog.screenLog({'entityName': 'OrganisationRole', 'entityRecordId': vm.role.id, 'action': 'EDIT'});
        	}else{
                //ScreenLog.screenLog({'entityName': 'OrganisationRole', 'entityRecordId': 0, 'action': 'ADD'});
        	}
        	vm.role.organisation = null;
       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'role_resubmit') {
        	vm.role = angular.fromJson($rootScope.payload); 
            var entityRecordId = 0;
            if(vm.role.id!=null){
  	      		entityRecordId = vm.role.id;
  	      	}
            vm.screenLog.screenLog(vm.screenName, entityRecordId, entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);

        	$scope.showButton=true;
        }
        vm.role.organisation={};
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {	
        	if(vm.role.name!=""){
        	 if (vm.role.id !== null) {
                 Role.update({orgId: GlobalValues.getCorpId()}, vm.role, onSaveSuccess, onSaveError);
             } else {
            	 Role.save({orgId: GlobalValues.getCorpId()}, vm.role, onSaveSuccess, onSaveError);
             	
             }
        	}
         }
        
        
        	
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }

        function onSaveError (error) {
        	vm.clicked=false;
        }
        
        function resubmitRole() {
          vm.role.organisation.id= GlobalValues.getCorpId();
           	Role.resubmit({"taskId" : $rootScope.taskID}, vm.role, onResubmitSuccess, onResubmitError);
           	$uibModalInstance.dismiss('cancel');
        }
           
        function onResubmitSuccess(result) {
          
           	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {
        	vm.clicked=false;
        }
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RoleDeleteController',RoleDeleteController);

    RoleDeleteController.$inject = ['$uibModalInstance', 'entity', 'Role', 'GlobalValues', 'ScreenLog','$scope'];

    function RoleDeleteController($uibModalInstance, entity, Role, GlobalValues, ScreenLog,$scope) {
        var vm = this;

        vm.role = entity;
        //ScreenLog.screenLog({'entityName': 'OrganisationRole', 'entityRecordId': vm.role.id, 'action': 'DELETE'});
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        $scope.clicked=false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Role.delete({"orgId":GlobalValues.getCorpId(),id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('manage-role', {
            parent: 'entity',
            params:{screen: 'OrganisationRole'},
            url: '/manage-role',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.security.manageroles" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/role-definition/manage-role.html',
                    controller: 'ManageRoleController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('role');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('manage-role.new', {
            parent: 'manage-role',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/role-definition/role-dialog.html',
                    controller: 'RoleController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	 id:null,  
                            	name:null,
                            	organisation:null 
                            	
                             
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('manage-role', null, { reload: 'manage-role' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('manage-role.edit', {
            parent: 'manage-role',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/role-definition/role-dialog.html',
                    controller: 'RoleController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	
                            	 entity: ['Role', 'GlobalValues', function(Role, GlobalValues) {
                                     return Role.get({orgId: GlobalValues.getCorpId(),id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('manage-role.view', {
            parent: 'manage-role',
            url: '/{id}/view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/role-definition/role-view-dialog.html',
                    controller: 'RoleViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	
                            	 entity: ['Role', 'GlobalValues', function(Role, GlobalValues) {
                                     return Role.get({orgId: GlobalValues.getCorpId(),id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('manage-role.delete', {
            parent: 'manage-role',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/role-definition/role-delete-dialog.html',
                    controller: 'RoleDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['Role', 'GlobalValues', function(Role, GlobalValues) {
                        	return Role.get({orgId:GlobalValues.getCorpId(),id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('manage-role-todolist', {
            parent: 'dashboard',
            url: '/roleview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/role-definition/role-view-dialog.html',
                    controller: 'RoleViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('manage-role', null, { reload: 'manage-role' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('manage-role-todolist.resubmit', {
            parent: 'dashboard',
            url: '/roleedit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/role-definition/role-dialog.html',
                    controller: 'RoleController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                        	
                           /* return {
                                shortName: null,                            	
                                name: null,
                                effectiveFrom: null,
                                validTill: null,
                                permittedTradingPosition: null,
                                permittedOpenExposure: null,
                                isDefault: null,
                                id: null	                                                  
                            };*/
                        }
                    }
                }).result.then(function() {
                    $state.go('manage-role', null, { reload: 'manage-role' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('manage-role-auditLog', {
            parent: 'audit-log',
            url: '/roleview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/role-definition/role-view-dialog.html',
                    controller: 'RoleViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('manage-role', null, { reload: 'manage-role' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('manage-role-historyReport', {
            parent: 'history-report',
            url: '/roleview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/role-definition/role-view-dialog.html',
                    controller: 'RoleViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('manage-role', null, { reload: 'manage-role' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
   };
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('Role', Role);

    Role.$inject = ['$resource'];

    function Role ($resource) {
        var resourceUrl =  'api/orgId/:orgId/roles/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/orgId/:orgId/roles'
        	 },
         	'queryAll': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/orgId/:orgId/rolesAll'
        	 },
        	 'rolesAllForOrganisation': { method: 'GET', isArray: true,
         		params: {orgId:'@orgId'},
         	    url: 'api/orgId/:orgId/rolesAllForOrganisation'
         	 },
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
        	 'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/orgId/:orgId/roles',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }                
             },
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/orgId/:orgId/roles',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/role',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'role'
        })
        
        .controller('ManageRoleController', ManageRoleController);

    ManageRoleController.$inject = ['$scope', '$state', 'Role', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout'];

    function ManageRoleController($scope, $state, Role, GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.ORGANISATION_ROLE;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "role";
        vm.launch=launch;
        function launch() {
        	$state.go("manage-role.new");
        }
        $scope.refresh=refresh;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;

        
        vm.permitOrganisationRoleEditEntityAction = EntityPermissions.hasPermission('OrganisationRole.EDIT');
        vm.permitOrganisationRoleViewEntityAction = EntityPermissions.hasPermission('OrganisationRole.VIEW');
        vm.permitOrganisationRoleDeleteEntityAction = EntityPermissions.hasPermission('OrganisationRole.DELETE');
        vm.permitOrganisationRoleCreateEntityAction = EntityPermissions.hasPermission('OrganisationRole.CREATE');
        logScreenAccess();
        loadAll();

       function loadAll() {
            Role.query({"orgId": GlobalValues.getCorpId()},function(result) {
                vm.roles = result;
             });        	
        }      
       /*vm.screenLog = function screenLog(entityRecordId,action){
          	ScreenLog.screenLog({'entityName': 'OrganisationRole', 'entityRecordId': entityRecordId, 'action': action});
       }*/
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };
    }
})();

(function () {
    "use strict";

    angular
        .module("gatewayApp")
        .controller(
            "RequestReferenceNumberController",
            RequestReferenceNumberController
        );

    RequestReferenceNumberController.$inject = [
        "$scope",
        "$rootScope",
        "$state",
        "$uibModalInstance",
        "$stateParams",
        "configSettings",
        "AlertService",
        "CustomerRegistration",
        "CryptoUtil",
        "GlobalValues"
    ];

    function RequestReferenceNumberController(
        $scope,
        $rootScope,
        $state,
        $uibModalInstance,
        $stateParams,
        configSettings,
        AlertService,
        CustomerRegistration,
        CryptoUtil,
        GlobalValues
    ) {
        var vm = this;
        vm.clear = clear;
        vm.fetch = fetch;
        $scope.clicked = false;
        vm.refNo = $stateParams.refNo;
        vm.generateOTP = generateOTP;
        vm.resendOTP = resendOTP;
        vm.theme = "light";
        vm.globalValues = GlobalValues;
        vm.platformENCCode = "tV1f3EtXyUjBrf8JbbW7bSYf7JgyxZpVXYJvwAyM34Q=";

        vm.isOTPSend = false;

        $scope.otpInput = {
            size: configSettings.defaultOTPLength,
            type: "password",
            onDone: function (value) {
                vm.otp = value;
            },
            onChange: function (value) {
                if (
                    value == null ||
                    value == undefined ||
                    value == "" ||
                    (value != null &&
                        value != undefined &&
                        value.length !=
                            parseInt(configSettings.defaultOTPLength))
                ) {
                    vm.disableFetch = true;
                } else {
                    vm.disableFetch = false;
                }
                console.log(value);
            }
        };

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        $scope.$watch("vm.refNo", function (value) {
            if (value != null && value != undefined && value != "") {
                vm.disableGenerateOTP = false;
                vm.isOTPSend = false;
            }
        });

        function generateOTP() {
            // CustomerRegistration.validateRejectedRequestAndSendOTP(
            //     { requestReferenceNo: vm.refNo },
            //     onValidateSuccess,
            //     onValidateFailure
            // );

            grecaptcha.ready(function () {
                    grecaptcha
                        .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey,vm.platformENCCode), {
                            action: "otp_action"
                        })
                        .then(function (token) {
                            // DTO object
                            var recaptchaOtpDetailsDTO = {
                                requestReferenceNo: vm.refNo,
                                recaptchaToken: token,
                                sourceType: "send-otp",
                                source: "customer-onboarding-fetch"
                            };

                            CustomerRegistration.validateRejectedRequestAndSendOTP(
                                recaptchaOtpDetailsDTO,
                                onValidateSuccess,
                                onValidateFailure
                            );
                        })
                        .catch(function (error) {
                            console.error("reCAPTCHA error:", error);
                        });
                });
        }

        function onValidateSuccess(result) {
            vm.disableGenerateOTP = true;
            vm.wrongOTPAttemptCount = 0;
            AlertService.info(
                "OTP has been sent to your email id and mobile number"
            );
            vm.isOTPSend = true;
            setTimeout(function () {
                document.getElementById("ref-no").blur();
            });
        }

        function onValidateFailure() {
            vm.disableGenerateOTP = false;
        }

        function resendOTP() {
            // CustomerRegistration.validateRejectedRequestAndSendOTP(
            //     { requestReferenceNo: vm.refNo },
            //     onResendSuccess,
            //     onResendFailure
            // );
            grecaptcha.ready(function () {
                    grecaptcha
                        .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey,vm.platformENCCode), {
                            action: "otp_action"
                        })
                        .then(function (token) {
                            // DTO object
                            var recaptchaOtpDetailsDTO = {
                                requestReferenceNo: vm.refNo,
                                recaptchaToken: token,
                                sourceType: "resend-otp",
                                source: "customer-onboarding-fetch"
                            };

                            CustomerRegistration.validateRejectedRequestAndSendOTP(
                                recaptchaOtpDetailsDTO,
                                onValidateSuccess,
                                onValidateFailure
                            );
                        })
                        .catch(function (error) {
                            console.error("reCAPTCHA error:", error);
                        });
                });
        }

        function onResendSuccess(result) {
            vm.wrongOTPAttemptCount = 0;
            AlertService.info(
                "OTP has been resent to your email id and mobile number"
            );
        }

        function onResendFailure() {}

        function fetch() {
            if (
                vm.wrongOTPAttemptCount >=
                configSettings.maximumOTPWrongAttemptCount
            ) // check if the wrong otp was entered for 3 or more times
            {
                AlertService.error(
                    "Maximum wrong OTP attempt count is exceeded!<br>Please request for resend OTP."
                );
            } else {
                CustomerRegistration.verifyOTPAndGetCustomerRegistrationRequest(
                    { requestReferenceNo: vm.refNo, otp: vm.otp },
                    onVerifySuccess,
                    onVerifyFailure
                );
            }
            // else {
            //     vm.clicked = true; // disable button

            //     grecaptcha.ready(function () {
            //         grecaptcha
            //             .execute("6LcBaI0sAAAAAFhuGjYAEeHtnqcBulWTFbBsLxBg", {
            //                 action: "otp_action"
            //             })
            //             .then(function (token) {
            //                 // ✅ Add token + extra fields
            //                 var requestData = {
            //                     requestReferenceNo: vm.refNo,
            //                     otp: vm.otp,
            //                     recaptchaToken: token,
            //                     sourceType: "verify-otp",
            //                     source: "otp-action"
            //                 };

            //                 CustomerRegistration.verifyOTPAndGetCustomerRegistrationRequest(
            //                     requestData,
            //                     function (response) {
            //                         vm.clicked = false;
            //                         onVerifySuccess(response);
            //                     },
            //                     function (error) {
            //                         vm.clicked = false;
            //                         onVerifyFailure(error);
            //                     }
            //                 );
            //             })
            //             .catch(function (error) {
            //                 console.error("reCAPTCHA error:", error);
            //                 vm.clicked = false;
            //             });
            //     });
            // }
        }

        function onVerifySuccess(result) {
            $rootScope.refNo = vm.refNo;
            $rootScope.requestDetailsToResubmit = result;
            $scope.$emit("fetchRequest");
            $uibModalInstance.close();
        }

        function onVerifyFailure() {
            vm.disableFetch = false;
            vm.wrongOTPAttemptCount = vm.wrongOTPAttemptCount + 1;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	 $stateProvider
         .state('view-relationship-fees-charges', {
             parent: 'entity',
             url: '/relationship-bank-fees-charges',
             data: {
            	 authorities: ['ROLE_USER'],
                 pageTitle: 'global.title'
             },
             ncyBreadcrumb: {
                 label: '{{ "global.menu.relationshipBankFeesAndCharges.main" | translate }}',
                 parent: 'home'
             },
             views: {
                 'content@': {
                     templateUrl: 'app/entities/relationship-bank-fees-charge-view/relationship-bank-fees-charge-view.html',
                     controller: 'RelationshipBankFeesChargesViewController',
                     controllerAs: 'vm'
                 }
             },
             resolve: {
                 translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                 	$translatePartialLoader.addPart('error');
                     $translatePartialLoader.addPart('global');       
                 	$translatePartialLoader.addPart('relationshipBankFeesChargesView');
                
                     return $translate.refresh();
                 }],
                 entity: function(){
                 	
                 }
             }
         })
     
         
    };
    })();

(function() {
	'use strict';
	angular
	.module('gatewayApp')
	.factory('RelationshipBankFeeAndChargesViewService', RelationshipBankFeeAndChargesViewService);

	RelationshipBankFeeAndChargesViewService.$inject = ['$resource'];

	function RelationshipBankFeeAndChargesViewService($resource) {
		var resourceUrl =  '/api';

		return $resource(resourceUrl, {}, {
			'getRelationshipBankViewDto':{
				method: 'GET',
				isArray: true,
				params: {customerId : '@customerId'},
				url: '/api/relationship-bank-fees-charges-view/:customerId/customerId',
		//		relationship-bank-fees-charges-view/{customerId}/customerId
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}

			}
		
		

		});
	}
})();

(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.controller('RelationshipBankFeesChargesViewController', RelationshipBankFeesChargesViewController)

	RelationshipBankFeesChargesViewController.$inject = ['ScreenLog','$scope', '$state', '$rootScope', 'GlobalValues','RelationshipBankFeeAndChargesViewService', 'workflowSharedService', 'entityConstants','BankFeeViewForEntitiesUtility','$timeout'];

	function RelationshipBankFeesChargesViewController(ScreenLog,$scope, $state, $rootScope, GlobalValues,RelationshipBankFeeAndChargesViewService,workflowSharedService,entityConstants,BankFeeViewForEntitiesUtility,$timeout) {
		var vm = this;
		vm.bankFeeChargeDetails = [];
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.BANK_FEES_CHARGES_VIEW;
		vm.globalValues=GlobalValues;
		$scope.refresh=refresh;
		vm.orgId = vm.globalValues.getCustomer();  
		
		console.log(vm.orgId);
		vm.screenLog = ScreenLog;
		logScreenAccess();
		vm.loadAll = loadAll;
		vm.bankRegistration ={};
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;
		vm.openBankFeesChargesPreview = openBankFeesChargesPreview;
		function openBankFeesChargesPreview(bankFeesChargesFile){
			BankFeeViewForEntitiesUtility.previewBankFee(bankFeesChargesFile,'file');	
		}

		vm.loadAll();
	
		function logScreenAccess(){
			ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}

	
		function loadAll() {
			RelationshipBankFeeAndChargesViewService.getRelationshipBankViewDto({customerId:vm.orgId.id},onRetreiveSuccess,onRetreiveFailure);
				
				function onRetreiveSuccess(result) {
					console.log(result);
					
					vm.bankFeeChargeDetails = result;
					console.log(vm.bankFeeChargeDetails);

				}
				function onRetreiveFailure(error){
					console.log(error);
				}

			
		}
		
		$scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };

		

	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RegularHolidayViewController', RegularHolidayViewController);

    RegularHolidayViewController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','entity', 'StaticLookUp', 'RegularHoliday', 'DateUtils', 'Workflow'];

     function RegularHolidayViewController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,entity, StaticLookUp, RegularHoliday, DateUtils, Workflow) {
        var vm = this;
        vm.dayList=getDayList();
        vm.weekNumberList=getWeekNumberList();
        vm.approveRegularHoliday = approveRegularHoliday;
        vm.rejectRegularHoliday = rejectRegularHoliday;
        vm.discardRegularHoliday = discardRegularHoliday;
        vm.clear=clear;
        $scope.clicked=false;
        $scope.showButton = false;
        $scope.showDiscardButton = false;
        vm.globalValues = GlobalValues;
        vm.valid = true;
       	
        if(entity!=null){
            	vm.regularHolidaysHeader=entity;
            	//vm.regularHolidaysHeader.effectiveFrom = DateUtils.convertDateTimeFromServer(vm.regularHolidaysHeader.effectiveFrom);
            	getRegularHolidayDetailList();
           	 	$scope.showButton=false;
        }
        
        if(workflowSharedService.viewFrom == 'regularholidays'){
        	vm.regularHolidaysHeader = entity;
        	if(vm.regularHolidaysHeader!=null){
            	//vm.regularHolidaysHeader.effectiveFrom = DateUtils.convertDateTimeFromServer(vm.regularHolidaysHeader.effectiveFrom);
            	getRegularHolidayDetailList();
        	}
       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'regularholidaystodolist_checker') {
        	vm.regularHolidaysHeader =  angular.fromJson($rootScope.payload); 
        	if(vm.regularHolidaysHeader!=null){
            	//vm.regularHolidaysHeader.effectiveFrom = DateUtils.convertDateTimeFromServer(vm.regularHolidaysHeader.effectiveFrom);
            	getRegularHolidayDetailList();
        	}
        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
        }
        else if(workflowSharedService.viewFrom == 'regularholidaystodolist_maker') {
        	vm.regularHolidaysHeader =  angular.fromJson($rootScope.payload); 
        	if(vm.regularHolidaysHeader!=null){
            	//vm.regularHolidaysHeader.effectiveFrom = DateUtils.convertDateTimeFromServer(vm.regularHolidaysHeader.effectiveFrom);
            	getRegularHolidayDetailList();
        	}
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        }
        else if(workflowSharedService.viewFrom == 'regularHoliday_auditLog') {
        	vm.regularHolidaysHeader =  angular.fromJson($rootScope.payload); 
        	if(vm.regularHolidaysHeader!=null){
            	//vm.regularHolidaysHeader.effectiveFrom = DateUtils.convertDateTimeFromServer(vm.regularHolidaysHeader.effectiveFrom);
            	getRegularHolidayDetailList();
        	}
        	$scope.showButton=false;
        	$scope.showDiscardButton = false;
        }
        function getRegularHolidayDetailList(){
       	 var regularHolidaysDetailsArr = vm.regularHolidaysHeader.regularHolidaysDetailsList;
       	 vm.daySelectionNumberList = [];
       	 vm.weekSelectionNumberList = {};
            angular.forEach(regularHolidaysDetailsArr, function(value, key) 
            {
           	 var dayNumber = [];
           	 
           	 var index = value.dayNumber.id - 1;
           	 dayNumber.push(value.dayNumber);
           	 
           	if(vm.daySelectionNumberList[index]==null){vm.daySelectionNumberList[index] = [];} 
           	vm.daySelectionNumberList[index].push(value.dayNumber);
           	 if(vm.weekSelectionNumberList[index]==null){vm.weekSelectionNumberList[index] = [];} 
           	 vm.weekSelectionNumberList[index].push(value.weekNumber);
            });
            console.log("day Selection number List "+ angular.toJson(vm.daySelectionNumberList));
            console.log("weeek Selection number List "+ angular.toJson(vm.weekSelectionNumberList));
            
       }

        function getDayList(){
        	return StaticLookUp.getDayNumberList();
        }
        
        function getWeekNumberList(){
        	return StaticLookUp.getWeekNumberList();
        }

        function approveRegularHoliday() { 
        	RegularHoliday.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectRegularHoliday() { Workflow.rejectTask($rootScope.taskID); }

        function discardRegularHoliday() {
        	RegularHoliday.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
       
        

     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RegularHolidayDialogController', RegularHolidayDialogController);

    RegularHolidayDialogController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','entity', 'StaticLookUp', 'RegularHoliday', 'DateUtils', 'ScreenLog', 'entityConstants'];

     function RegularHolidayDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,entity, StaticLookUp, RegularHoliday, DateUtils, ScreenLog , entityConstants) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.REGULAR_HOLIDAY;
        vm.screenLog = ScreenLog;
        vm.regularHolidaysDetailsSet = [];
        vm.dayList=getDayList();
        vm.weekNumberList=getWeekNumberList();
        vm.clear=clear;
        vm.save=save;
        $scope.clicked=false;
        $scope.showButton = false;
        $scope.validationMessage = '';
        vm.globalValues = GlobalValues;

        vm.enableFields = enableFields;
        vm.valid = true;
        vm.resubmitRegularHoliday = resubmitRegularHoliday;
       	
        
        if(entity!=null){
            	vm.regularHolidaysHeader=entity;
            	//vm.regularHolidaysHeader.effectiveFromDate = DateUtils.convertDateTimeFromServer(vm.regularHolidaysHeader.effectiveFromDate);
            	getRegularHolidayDetailList();
           	 	$scope.showButton=false;
        }
		
        if(workflowSharedService.viewFrom == 'regularholidays'){
        	vm.regularHolidaysHeader=entity;
        	getRegularHolidayDetailList();
       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'regularholidays_resubmit') {
        	vm.regularHolidaysHeader = angular.fromJson($rootScope.payload); 
        	vm.screenLog.screenLog(vm.screenName, vm.regularHolidaysHeader.id==null?0:vm.regularHolidaysHeader.id, entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
        	getRegularHolidayDetailList();
        	vm.disableForm = false;
        	$scope.showButton=true;
        }
        else if(workflowSharedService.viewFrom == 'regularholidays_resubmit_delete') {
        	vm.regularHolidaysHeader = angular.fromJson($rootScope.payload);
        	getRegularHolidayDetailList();
        	vm.disableForm = true;
        	$scope.showButton=true;
        }
        
        function getRegularHolidayDetailList(){
        	 var regularHolidaysDetailsArr = vm.regularHolidaysHeader.regularHolidaysDetailsList;
        	 vm.daySelectionNumberList = {};
        	 vm.weekSelectionNumberList = {};
             angular.forEach(regularHolidaysDetailsArr, function(value, key) 
             {
            	 var dayNumber = [];
            	 
            	 var index = value.dayNumber.id - 1;
            	 dayNumber.push(value.dayNumber);
            	 if(vm.daySelectionNumberList[index]==null){vm.daySelectionNumberList[index] = [];} 
            	 vm.daySelectionNumberList[index].push(value.dayNumber);
            	 if(vm.weekSelectionNumberList[index]==null){vm.weekSelectionNumberList[index] = [];} 
            	 vm.weekSelectionNumberList[index].push(value.weekNumber);
             });
        }

        function getDayList(){
        	return StaticLookUp.getDayNumberList();
        }
        
        function getWeekNumberList(){
        	return StaticLookUp.getWeekNumberList();
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {  
        	prepareRegularHolidaysHeader();
        	saveRegularHolidays();
         }
        
        function prepareRegularHolidaysHeader(){
        	vm.regularHolidaysDetailsSet = [];
        	angular.forEach(vm.daySelectionNumberList, function(value, $index) {
        		if(value.length>0){
            		angular.forEach(vm.weekSelectionNumberList[$index], function(value2, i){
            			vm.regularHolidaysDetailsSet.push({'dayNumber': value[0], 'weekNumber': value2});
            		})
            		vm.regularHolidaysHeader.regularHolidaysDetailsList = angular.copy(vm.regularHolidaysDetailsSet);
        		}
        	});
        }
        
		
		function saveRegularHolidays(){
			//vm.regularHolidaysHeader.effectiveFromDate = new Date();
        	if(vm.regularHolidaysHeader.id==null){
        		RegularHoliday.save({orgId: GlobalValues.getOrgId()}, vm.regularHolidaysHeader, onSaveSuccess, onSaveError);
        	}else if(vm.regularHolidaysHeader.id!=null){
        		RegularHoliday.update({orgId: GlobalValues.getOrgId()}, vm.regularHolidaysHeader, onSaveSuccess, onSaveError);
        	}
		}

        
        function onSaveSuccess (result) {
        	$scope.$emit('regularHolidayRefresh');
        	 $uibModalInstance.close(result);  
        }

        function onSaveError () {
        	$scope.clicked = false;
        }
        
        function resubmitRegularHoliday() {
        	//vm.regularHolidaysHeader.effectiveFromDate = new Date();
        	prepareRegularHolidaysHeader();
       		RegularHoliday.resubmit({"taskId" : $rootScope.taskID}, vm.regularHolidaysHeader, onResubmitSuccess, onResubmitError);
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {}
        function enableFields(elementId){
        	var enableField= false;
        	var field = angular.element(elementId) ;
        	
        	console.log(angular.toJson(field));
        	var value = field.prop( "checked" );
        	console.log( elementId + "-" + angular.toJson(value));
        	if(field!==undefined){
        		enableField = value;
        	}
        	return enableField;
        }
        
       
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('regular-holiday', {
            parent: 'entity',
            url: '/regular-holiday',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.regularHoliday.manageRegularHolidays" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/regular-holiday/regular-holiday.html',
                    controller: 'RegularHolidayController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('regularHoliday');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('regular-holiday.new', {
            parent: 'regular-holiday',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regular-holiday/regular-holiday-dialog.html',
                    controller: 'RegularHolidayDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('regular-holiday', null, { reload: 'regular-holiday' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('regular-holiday.view', {
            parent: 'regular-holiday',
            url: '/regular-holiday/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regular-holiday/regular-holiday-view-dialog.html',
                    controller: 'RegularHolidayViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['RegularHoliday', 'GlobalValues', function(RegularHoliday, GlobalValues) {
                                     return RegularHoliday.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('regular-holiday.edit', {
            parent: 'regular-holiday',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regular-holiday/regular-holiday-dialog.html',
                    controller: 'RegularHolidayDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['RegularHoliday', 'GlobalValues', function(RegularHoliday, GlobalValues) {
                                     return RegularHoliday.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('regular-holiday.delete', {
            parent: 'regular-holiday',
            url: '/delete/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regular-holiday/regular-holiday-delete-dialog.html',
                    controller: 'RegularHolidayDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['RegularHoliday', 'GlobalValues', function(RegularHoliday, GlobalValues) {
                            return RegularHoliday.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    //$state.go('^', null, { reload: true });
                	$state.go('regular-holiday', null, { reload: 'regular-holiday' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('regular-holidays-todolist', {
            parent: 'dashboard',
            url: '/regularholidayview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regular-holiday/regular-holiday-view-dialog.html',
                    controller: 'RegularHolidayViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('regular-holidays', null, { reload: 'regular-holidays' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('regularHoliday');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
            
        })
         .state('regular-holidays-todolist.resubmit', {
            parent: 'dashboard',
            url: '/regularholidayedit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regular-holiday/regular-holiday-dialog.html',
                    controller: 'RegularHolidayDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('regular-holidays', null, { reload: 'regular-holidays' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('regularHoliday');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('regularHoliday-auditLog', {
            parent: 'audit-log',
            url: '/regularholidayaudit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regular-holiday/regular-holiday-view-dialog.html',
                    controller: 'RegularHolidayViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('regular-holidays', null, { reload: 'regular-holidays' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('regularHoliday');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
            
        })
        .state('regularHoliday-historyReport', {
            parent: 'history-report',
            url: '/regularholidayhistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regular-holiday/regular-holiday-view-dialog.html',
                    controller: 'RegularHolidayViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('regular-holidays', null, { reload: 'regular-holidays' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('regularHoliday');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
            
        })

       };
    })();

(function() {
	'use strict';
	angular.module('gatewayApp').factory('RegularHoliday', RegularHoliday);

	RegularHoliday.$inject = [ '$resource', 'DateUtils' ];

	function RegularHoliday($resource, DateUtils) {
		var resourceUrl = 'api/regular-holiday/:id';

		return $resource(
				resourceUrl,
				{},
				{
					'query' : {
						method : 'GET',
						isArray : true
					},
					'get' : {
						method : 'GET',
						isArray : false,
						transformResponse : function(data) {
							if (data) {
								data = angular.fromJson(data);
							}
							return data;
						}
					},

					'save' : {
						method : 'POST',
						url : 'api/regular-holiday/:orgId',
						params: {orgId:'@orgId'},
						transformRequest : function(data) {
							var copy = angular.copy(data);
	                    	copy.effectiveFromDate = DateUtils.convertLocalDateToServer(copy.effectiveFromDate);
							return angular.toJson(copy);
						}
					},
					'update' : {
						method : 'PUT',
						url : 'api/regular-holiday/:orgId',
						transformRequest : function(data) {
							var copy = angular.copy(data);
							copy.effectiveFromDate = DateUtils.convertLocalDateToServer(copy.effectiveFromDate);
							return angular.toJson(copy);
						}
					},
					'delete' : {
						method : 'DELETE',
						params : {
							id : '@id'
						},
						url : 'api/regular-holiday/:id'
					},
					'approve': {
		                method: 'GET',
		                params: {taskId:'@taskId'},
		                url: 'api/tasks/:taskId/approve'
		            },
		            'reject': {
		                method: 'GET',
		                params: {taskId:'@taskId'},
		                url: 'api/tasks/:taskId/reject'
		            },
		            'discard': {
		              	 method: 'GET',
		                   params: {taskId:'@taskId'},
		                   url: 'api/tasks/:taskId/discard'
		             },
		             'resubmit': {
		                 method: 'PUT',
		                 params: {taskId:'@taskId'},
		                 url: 'api/tasks/:taskId/resubmit/regular-holiday',
		                 transformRequest: function (data) {
		                 	var copy = angular.copy(data);
		                 	return angular.toJson(copy);
		                 }
		            }
				});
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'regularHolidays'
        })
        
        .controller('RegularHolidayController', RegularHolidayController);

    RegularHolidayController.$inject = ['$scope', '$state', 'workflowSharedService', 'RegularHoliday', 'GlobalValues', 'EntityPermissions', '$rootScope', 'StaticLookUp', 'ScreenLog', 'entityConstants'];

    function RegularHolidayController($scope, $state, workflowSharedService, RegularHoliday, GlobalValues, EntityPermissions, $rootScope, StaticLookUp, ScreenLog , entityConstants) {
        var vm = this;

        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.REGULAR_HOLIDAY;
        vm.screenLog = ScreenLog;
        vm.launch=launch;
        vm.dayList=getDayList();
        workflowSharedService.viewFrom = "regularHolidays";
        function launch() {
        	$state.go("regular-holiday.new");
        }
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;
        
       vm.permitRegularHolidayEditEntityAction = EntityPermissions.hasPermission( vm.screenName+'.' +vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
       vm.permitRegularHolidayCreateEntityAction = EntityPermissions.hasPermission(vm.screenName+'.' +vm.entityConstants.ENTITY_ACTION_TYPE.ADD);
       vm.permitRegularHolidayViewEntityAction = EntityPermissions.hasPermission(vm.screenName+'.' + vm.entityConstants.ENTITY_ACTION_TYPE.VIEW);
      
		
		loadAll();
		
        function loadAll(){
    		RegularHoliday.query(function(result){
                vm.regularHolidaysHeader = result;
            });
        }
        
        function getDayList(){
        	return StaticLookUp.getDayNumberList();
        }
        
        $rootScope.$on('regularHolidayRefresh', function(event, result) {
        });
        logScreenAccess();
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }
        
    }
})();


    (function() {
        'use strict';
    
        angular
            .module('gatewayApp')
            .config(stateConfig);
    
        stateConfig.$inject = ['$stateProvider'];
    
        function stateConfig($stateProvider) {
            $stateProvider
            .state('refresh-limit', {
                parent: 'entity',
                params:{screen: 'RefreshLimit'}, 
                url: '/refresh-limit',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.title'
                },
                ncyBreadcrumb: {
                    label: '{{ "global.menu.refreshLimit.main" | translate }}',
                    parent: 'home'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/refresh-limit/refresh-limit.html',
                        controller: 'RefreshLimitController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('refreshLimit');                    
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                   
                }
            })
            
             
             };
        })();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('RefreshLimit', RefreshLimit);

        RefreshLimit.$inject = ['$resource'];

    function RefreshLimit($resource) {
    	 var resourceUrl =  '';
        

         return $resource(resourceUrl, {}, {
         'ProcessRefreshLimits': {
            method: 'POST',
            params: {bankId:'@bankId',customerId:'@customerId'},
            url: 'order/refresh-limits-utilisation-details/bank/:bankId/customer/:customerId',
            transformRequest: function (data) {
                var copy = angular.toJson(data);
                return copy;
            }/* ,
            transformResponse: function(data, headers) {
                return {
                    data: angular.fromJson(data),
                    headers: headers
                };   
            }      */         
        },
        
        'ProcessRefreshLimtisForAllCustomers': {
            method: 'POST',
            url: 'order/refresh-limits-utilisation-details',
            transformRequest: function (data) {
                var copy = angular.toJson(data);
                return copy;
            }/* ,
            transformResponse: function(data, headers) {
                return {
                    data: angular.fromJson(data),
                    headers: headers
                };   
            }   */             
        },



        'ProcessRefreshLimtisForBankWiseCustomers': {
            method: 'POST',
            params: {bankId:'@bankId'},
            url: 'order/refresh-limits-utilisation-details/bank/:bankId',
            transformRequest: function (data) {
                var copy = angular.toJson(data);
                return copy;
            }/* ,
            transformResponse: function(data, headers) {
                return {
                    data: angular.fromJson(data),
                    headers: headers
                };   
            }     */            
        }

    });
    
  }
        
})();
(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {
            this.viewFrom = 'refreshLimit'
        })

        .controller('RefreshLimitController', RefreshLimitController);

        RefreshLimitController.$inject = ['$scope', '$state',  '$filter', 'GlobalValues','RefreshLimit','AlertService','IntradayMarket'];

    function RefreshLimitController($scope, $state, $filter,GlobalValues,RefreshLimit,AlertService,IntradayMarket) {
        
           var vm = this;
           vm.globalValues = GlobalValues;
           vm.bankId=0;
           vm.customerId=0;
           //vm.customerTypeList=['SingleCustomer','BankWiseCustomer','All'];
           vm.onRadioValueChange=onRadioValueChange;
           vm.systemSettings = vm.globalValues.getSystemSettings();
            vm.validateEodCompleted=validateEodCompleted;
            vm.status='TO_BE_INITIATED'
            vm.selectedType='customer'; //default customer type
            vm.submitRefreshLimit=submitRefreshLimit;
            vm.clicked=false;
            vm.cleaFilterValues=cleaFilterValues;
            setDisableAndRequiredControl(false,false, vm.emptyString,"");
            vm.allCustomer="--All--";
            vm.emptyString="";
            vm.isEODCompletedAndSessionIsOpen=false;
           vm.marketSessionStatus =true;
           vm.IsSessionMessageReceived;
        IntradayMarket.getMarketSessionSettings({ "currentBusinessDate": vm.systemSettings.businessDate }, onGetMarketSessionSuccess, onGetMarketSessionFailure);
        function onGetMarketSessionSuccess(result) {
            vm.marketSession = result;
            SplitInstrumetValue();
        }
        function onGetMarketSessionFailure() {
       
        }
        IntradayMarket.getMessagesInBCMQ(onGetMarketSessionMessageSuccess, onGetMarketSessionMessageFailure);
        function onGetMarketSessionMessageSuccess(result){
            vm.IsSessionMessageReceived=result;
        }
        function onGetMarketSessionMessageFailure(){

        }
        function SplitInstrumetValue() {
            angular.forEach(vm.marketSession, function (value) {
                if (value.sessionTimingsDTO.status == 'OPEN') {
                    vm.marketSessionStatus = false;
                }
            })
        }

            $scope.$watch('vm.selectedType', function(value){
                onRadioValueChange(value);
            });  


            //  user types changes when click radio button
            function onRadioValueChange(selectedType){
               
                 if(selectedType==='customer'){
                   setDisableAndRequiredControl(false,false, vm.emptyString,"");
                 cleaFilterValues(vm.emptyString,vm.emptyString);
                 vm.clicked=false;
                 vm.isEODCompletedAndSessionIsOpen=false;
                   
                }

                else if(selectedType=='bank'){
                    
        	        setDisableAndRequiredControl(false,true,vm.emptyString,vm.allCustomer);
                    validateEodCompleted();
                    cleaFilterValues(vm.emptyString,vm.emptyString);
                }

                else if(selectedType==='all'){
                    setDisableAndRequiredControl(true,true,vm.allCustomer, vm.allCustomer);
                    validateEodCompleted();
                    cleaFilterValues(vm.emptyString,vm.emptyString);                 

                }
            }

            
            //validate the eod is completed or not
            
           

            function validateEodCompleted(){
                if( vm.systemSettings.eodStatus===vm.status && vm.systemSettings.sodStatus===vm.status || vm.systemSettings.eodStatus===vm.status && vm.systemSettings.sodStatus==='COMPLETED'&& vm.marketSessionStatus && vm.IsSessionMessageReceived.IsSessionMessageReceived=="NOTRECEIVED"){
                    vm.clicked=false;   

                }
                else{
                    AlertService.error($filter('translate')('gatewayApp.refreshLimit.eodAndSessionOpenCompletionError'));
                    vm.clicked=true;
                    vm.isEODCompletedAndSessionIsOpen=true;
                }
            }


            
            //submitTheRefreshLimit when the submit button is click
            

            function submitRefreshLimit(){
                
                 
                 if(vm.selectedType==='customer'){
                    vm.bankId=vm.bank.id;
                    vm.customerId=vm.customer.id;
                  
                    RefreshLimit.ProcessRefreshLimits({"bankId":vm.bankId,"customerId":vm.customerId}, onRefreshLimitSucess, onRefreshLimitFailure);

                 }
                 else if(vm.selectedType==='bank')
                 {
                    vm.bankId=vm.bank.id;
                    RefreshLimit.ProcessRefreshLimtisForBankWiseCustomers({"bankId":vm.bankId}, onRefreshLimitSucess, onRefreshLimitFailure);
                 }

                 else if(vm.selectedType==='all'){
                    RefreshLimit.ProcessRefreshLimtisForAllCustomers(onRefreshLimitSucess, onRefreshLimitFailure);
                 }

                 else {
                    AlertService.error($filter('translate')('gatewayApp.refreshLimit.selectValidCustomerType'));
                 }
            }


            /**
             * 
             * @param {boolean} bankControl 
             * @param {boolean}} customerControl 
             *
             * @param {string} bankHolder 
             * @param {string} customerHolder 
             */

            function setDisableAndRequiredControl(bankControl,customerControl,bankHolder,customerHolder){
                vm.disableBankControl= bankControl;
                vm.disableCustomerControl= customerControl;
                vm.requiredBankControl=!bankControl;
                vm.requiredCustomerControl=!customerControl;
                vm.bankHolder=bankHolder;
                vm.customerHolder=customerHolder;
            }


            function onRefreshLimitSucess (result) {
               // AlertService.success(result);
                cleaFilterValues(vm.emptyString,vm.emptyString);
                vm.clicked = false;
           }
           
         
           function onRefreshLimitFailure (result) {
            // AlertService.error(result);
             vm.clicked = false;
           }


           
           //clear the filter values

           function cleaFilterValues(bankValue,customerValue){
            vm.bank=bankValue;             
            vm.customer=customerValue;
           }
}


})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('PreOrderConfirmationController', PreOrderConfirmationController);

    PreOrderConfirmationController.$inject = ['$scope', '$rootScope', '$uibModalInstance', 'Market', '$stateParams', 
		'MessageBox', 'User', 'GlobalValues', 'Idle', '$timeout','systemTime','OrderUtil','$state','workflowSharedService'];

    function PreOrderConfirmationController($scope, $rootScope, $uibModalInstance, Market, $stateParams, 
		MessageBox, User, GlobalValues, Idle, $timeout,systemTime,OrderUtil,$state,workflowSharedService) {
        var vm = this;
        vm.password=null;
        vm.allowedPasswordCharacters=/^[!@#^&*()\-_.:;a-zA-Z0-9]/;
        vm.clear=clear;
        vm.submit=submit;
        vm.add = add;
        vm.checkPassword = checkPassword;
        $scope.clicked=false;
        vm.orderDTO = $rootScope.orderDTO;
        vm.showRollOverOrEarlyDelivery = false;
        if(vm.orderDTO.activityIndicator == 'ROLL' || vm.orderDTO.activityIndicator == 'EARL' ){
        	vm.showRollOverOrEarlyDelivery = true;
        }

        vm.eventTypeName = getEventTypeForShortName(vm.orderDTO.eventType);
        if(vm.eventTypeName==null || vm.eventTypeName==undefined || vm.eventTypeName==''){
            vm.eventTypeName = vm.orderDTO.eventType;
        }
        /*if(vm.orderDTO.typeOfOrder=='MRKT' && vm.orderDTO.activityIndicator=='PLAC'){
			vm.orderDTO.sellLimitExchangeRate=0;
        	vm.orderDTO.buyLimitExchangeRate=0;
		}*/
        vm.showGTT = false;
        vm.showPreOrderConfirmation = true;
        vm.errorMessage = '';
        vm.errorString = '';
        vm.globalValues = GlobalValues;
        vm.submitAction = submitAction;
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.serverDateUTCOffset;
        vm.serverDateTimeZone = systemTime.timeZone;
		vm.showOrderConfirmationForSplitOrder=$stateParams.showOrderConfirmationForSplitOrder;
		vm.noOfSplits=$stateParams.noOfSplit;
		vm.orderDTOList=[];
		vm.currencyPairCode = vm.orderDTO.currencyPairCode.slice(0, 3);
        
        function clear () {
            $rootScope.orderPlacedSuccessCount = 0;
            $scope.$emit('orderplacedsuccess');
            $uibModalInstance.close();
        }
        
        vm.showPasswordWindow = $stateParams.sessionTimedOut;
        vm.cancelSelected = $stateParams.cancelSelected;
        vm.selectedOrders = $rootScope.selectedPendingOrders;
        if(!vm.cancelSelected){
        	if(vm.orderDTO.typeOfOrder=='MRKT' && vm.orderDTO.activityIndicator=='PLAC'){
    			vm.orderDTO.sellLimitExchangeRate=0;
            	vm.orderDTO.buyLimitExchangeRate=0;
    		}
        }
        
        if(!vm.cancelSelected){
            if(vm.orderDTO.timeLimitIndicator=='GTTM' && vm.orderDTO.activityIndicator!='CNCL'){
            	vm.showGTT = true;            	
            	vm.showPreOrderConfirmation = false;
            }else if(vm.orderDTO.timeLimitIndicator=='GTTM' && vm.orderDTO.activityIndicator=='CNCL'){
            	//fillDefaultTime();
            	Market.getCurrentDateTime(getTimeForOrderCancellation, getTimeFailure);
            	
            }
        }else{
        	//MessageBox.openMessageBox("Alert", "Do you want to proceed to cancel selected order(s)?", "ProceedCancel", "cancelselectedorders");
        }
        
        if(vm.showPasswordWindow){
        	vm.showGTT = false;
        	vm.showPreOrderConfirmation = false;
        	$timeout(function(){document.getElementById("verifyPasswordBtn").focus();}, 100);
        }
        
        vm.closeTime = $stateParams.closeTime;
        vm.showPreOrderConfirmationDisplay = $stateParams.showPreOrderConfirmation;
        if(vm.showGTT){
        	//fetch the server current time with time zone
        	Market.getCurrentDateTime(getTimeSuccess, getTimeFailure);
            //fillDefaultTime();
        }
        
        function fillDefaultTime(){
        	if(vm.orderDTO.activityIndicator=='MDFY' || vm.orderDTO.activityIndicator=='CNCL'){
        		vm.currentDate = moment(angular.copy(vm.orderDTO.expiryTimeString));
        		vm.serverDateUTCOffset =  vm.currentDate.utcOffset();
            	vm.expiryDateTime = addMinutes(vm.currentDate, 0);
        	}else{
        		//vm.currentDate = new Date();
        		vm.expiryDateTime = addMinutes(vm.currentDate, 1);
            	
        	}
        }
        
        function addMinutes(date, minutes) {
            //return new Date(date.getTime() + minutes*60000);
            return  moment(date).add(minutes , 'minutes');
        }
        
        $scope.$watch('vm.expiryDateTime', function(value){
        	if(value!=null && value!=undefined && value!=''){
            	vm.errorString = '';
            	return Market.getCurrentDateTime(getCurrentServerTimeAndValidate, getTimeFailure);
            }
        })
        
        function validateExpirtyTime(){
        	return Market.getCurrentDateTime(getCurrentServerTimeAndValidate, getTimeFailure);
        }
        
        function formatExpiryTime(){
        	var expiryTime;// = moment(vm.expiryDateTime, 'HH:mm').format( 'HH:mm');
        	if(vm.serverDateUTCOffset == moment().utcOffset()){
        		expiryTime = moment(vm.expiryDateTime, 'HH:mm').format( 'HH:mm');
         	}else{
         		expiryTime = moment(vm.expiryDateTime, 'HH:mm').utcOffset(vm.serverDateUTCOffset).format( 'HH:mm');
         	}
        	var expiryTimeInString = "";
        	if(expiryTime.split(':').length>1){
            	expiryTimeInString = expiryTime.split(':')[0] + expiryTime.split(':')[1] + '00';
            	//var todayDateString = $filter('date')(new Date(),'yyyy-MM-dd');
            	var todayDateString = moment(vm.currentDate).utcOffset(vm.serverDateUTCOffset).format( 'YYYYMMDD');
            	//todayDateString = todayDateString.replace(/-/g, '');
            	expiryTimeInString = todayDateString + expiryTimeInString;
        	}
        	vm.expiryTime = expiryTimeInString;
        }
        
        function add(){
        	//validateExpiryTime();
        	if(validateExpirtyTime()){
        		if(vm.serverDateUTCOffset == moment().utcOffset()){
    				vm.expiryTimeString=moment(vm.expiryDateTime, 'HH:mm').format( 'HH:mm');
             	}else{
             		vm.expiryTimeString= moment(vm.expiryDateTime, 'HH:mm').utcOffset(vm.serverDateUTCOffset).format( 'HH:mm');
             	}
            	formatExpiryTime();
            	vm.orderDTO.expiryTime = vm.expiryTime;
            	vm.orderDTO.expiryTimeString = vm.expiryTimeString;
            	if(vm.showPreOrderConfirmationDisplay=='yes'){
                	vm.showPreOrderConfirmation = true;
                	vm.showGTT = false;
                    $timeout(function(){$scope.clicked = false;}, 100);
                	$timeout(function(){document.getElementById("submitBtn").focus();}, 100);
                	
            	}else{
            		submit();
            	}
            	//$uibModalInstance.close();
            	//$scope.$emit('addExpiryTime');
        	}else{
        		//show error
        		//MessageBox.openMessageBox("Alert", vm.errorString, "Ok", "homepage");
        	}
        }
        
        function submitAction(preOrderConfirmation, addGTT, verifyUser){
        	var action = "";
        	if(preOrderConfirmation){
        		action='preOrderConfirmation';
        	}else if(addGTT){
        		action='addGTT';
        	}else if(verifyUser){
        		action='verifyUser';
        	}
        	
        	if(action=='preOrderConfirmation'){
        		submit();
        	}else if(action=='addGTT'){
        		add();
        	}else if(action=='verifyUser'){
        		checkPassword();
        	}
        }
        
        function submit(){
			console.log("pre ",vm.orderDTO.limitExchangeRate);
        	if(vm.cancelSelected!=true){
            	vm.errorMessage = '';
            	console.log(vm.orderDTO);
            	if(vm.orderDTO.buySellIndicator!='SELLBUY'){
		      if(OrderUtil.validateOrderDTOForNull(vm.orderDTO)){
                	if(vm.orderDTO.activityIndicator=='PLAC' || vm.orderDTO.activityIndicator=='TRAD' || vm.orderDTO.activityIndicator=='ROLL' || vm.orderDTO.activityIndicator=='EARL'){
                        vm.orderDTO.activityIndicator='PLAC';

						//check if split order then split the order amount 
				 		if(vm.orderDTO.isSplitOrder==true){
							splitTheOrder(vm.orderDTO,vm.noOfSplits);
							//if chech show split order is on in user profile 
							if(vm.showOrderConfirmationForSplitOrder=='yes'){
								if(vm.orderDTOList != null && vm.orderDTOList != undefined){
								
								$uibModalInstance.dismiss('cancel');
								workflowSharedService.viewFrom = 'SplitOrder';
									$state.go('split-order-confirmation',{orderDTOList:vm.orderDTOList}) .catch(function (error) {
										// if error occurs go to create state
										$state.go('split-order-confirmation',{orderDTOList:vm.orderDTOList});
									})
								}
							
						}else{
							//showOrderConfirmationForSplitOrder shoud not show
								if (vm.orderDTOList != null && vm.orderDTOList != undefined) {
				
									$uibModalInstance.dismiss('cancel');
									workflowSharedService.viewFrom = 'SplitOrder';
									$state.go('split-order-status',{orderDTOList:vm.orderDTOList}) .catch(function (error) {
										// if error occurs go to create state
										$state.go('split-order-status',{orderDTOList:vm.orderDTOList});
									})
				   
							   }
							
						}
					} else{
						//regular order
						Market.placeOrder(vm.orderDTO, onOrderSucess, onOrderFailure);
					}
                	}else if(vm.orderDTO.activityIndicator=='MDFY'){
                        Market.modifyOrder(vm.orderDTO, onOrderSucess, onOrderFailure);
            		}else if(vm.orderDTO.activityIndicator=='CNCL'){
                        Market.cancelOrder(vm.orderDTO, onOrderSucess, onOrderFailure);
            		}
		  }else{
			MessageBox.openMessageBox("Alert", "The order request is not processed, please submit again.", "Ok", "orderrequestfailure");
		  }
            	}else if(vm.orderDTO.buySellIndicator=='SELLBUY'){
            		if(vm.orderDTO.typeOfOrder=='MRKT'){
						vm.orderDTO.sellLimitExchangeRate=0;
						vm.orderDTO.buyLimitExchangeRate=0;
					}
					var sellOrderDTO = getSellOrderDTO();
					var buyOrderDTO = getBuyOrderDTO();
					if(OrderUtil.validateOrderDTOForNull(sellOrderDTO) && OrderUtil.validateOrderDTOForNull(buyOrderDTO)){
						Market.placeOrder(sellOrderDTO);
						Market.placeOrder(buyOrderDTO, onOrderSucess, onOrderFailure);
					}else{
						MessageBox.openMessageBox("Alert", "The order request is not processed, please submit again.", "Ok", "orderrequestfailure");
					}            	
		}
            	//onPlaceOrderSuccess();
        	}
        }

		$rootScope.$on('gatewayApp.messagebox.ok.orderrequestfailure', function (event, data) {
			$uibModalInstance.close();
		});

		$rootScope.$on('gatewayApp.messagebox.clear.orderrequestfailure', function (event, data) {
			$uibModalInstance.close();
		});

		function onOrderSucess(result){
            onPlaceOrderSuccess();
        }

        function onOrderFailure(){
            onPlaceOrderSuccess();
        }

        function onPlaceBuySuccess(result){
    		var sellOrderDTO = getSellOrderDTO();
    		Market.placeOrder(sellOrderDTO,  onPlaceOrderSuccess, onPlaceOrderFailure);
        }
        
        function onPlaceBuyFailure(){
        	
        }
        
        function getBuyOrderDTO(){
        	var orderDTO = angular.copy(vm.orderDTO);
        	orderDTO.buySellIndicator = 'BUYY';
        	orderDTO.limitExchangeRate = vm.orderDTO.buyLimitExchangeRate;
        	orderDTO.stopExchangeRate = vm.orderDTO.buyStopExchangeRate;
        	return orderDTO;
        }
        
        function getSellOrderDTO(){
        	var orderDTO = angular.copy(vm.orderDTO);
        	orderDTO.buySellIndicator = 'SELL';
        	orderDTO.limitExchangeRate = vm.orderDTO.sellLimitExchangeRate;
        	orderDTO.stopExchangeRate = vm.orderDTO.sellStopExchangeRate;
        	return orderDTO;
        }
        
        function onPlaceOrderSuccess(){
            $rootScope.orderPlacedSuccessCount = 0;
        	$scope.$emit('orderplacedsuccess');
        	//$uibModalInstance.close(result);
        	$uibModalInstance.close();
        }
        
        function onPlaceOrderFailure(result){
        	$scope.clicked = false;
        	if(result !=null && result != undefined){
        		if(result.data!=null && result.data!=undefined){
        			if(result.data=='Access Denied'){
        				//AlertService.error("Trading session is expired...! Re-login to continue trading.")
        				vm.errorMessage = 'Trading session is expired...! Re-login to continue trading.';
        			}
        		}
        	}
        }

        function checkPassword(){
     	   var userCredentials = {};
 			userCredentials.userId = vm.globalValues.getUserId();
 			userCredentials.password = vm.password;
			userCredentials.mobileEmailFlag = "";
 			User.checkPassword(userCredentials, onCheckPasswordSuccess, onCheckPasswordFailure);
        }
        
        function onCheckPasswordSuccess(result){
        	vm.globalValues.setSessionTimedOut(false);
        	Idle.watch();
        	if(vm.cancelSelected){
            	MessageBox.openMessageBox("Alert", "Do you want to proceed to cancel selected order(s)?", "ProceedCancel", "cancelselectedordersfrompreorder");
            }else if(vm.orderDTO.timeLimitIndicator=='GTTM' && vm.orderDTO.activityIndicator!='CNCL'){
            	vm.showGTT = true;
            	//fillDefaultTime();
            	Market.getCurrentDateTime(getTimeSuccess, getTimeFailure);
            	vm.showPreOrderConfirmation = false;
            	vm.showPasswordWindow = false;
                $scope.clicked = false;
            	$timeout(function(){document.getElementById("addGTTBtn").focus();}, 100);
            }else{
            	if(vm.showPreOrderConfirmationDisplay=='yes'){
                	vm.showPreOrderConfirmation = true;
                	vm.showGTT = false;
                	vm.showPasswordWindow = false;
                    $scope.clicked = false;
                	$timeout(function(){document.getElementById("submitBtn").focus();}, 100);
            	}else{
            		submit();
            	}
            }        	
        }
        
        function onCheckPasswordFailure(){
        	vm.showPasswordWindow = true;
        	vm.showGTT = false;
        	vm.showPreOrderConfirmation = false;
            $scope.clicked = false;
        	$timeout(function(){document.getElementById("verifyPasswordBtn").focus();}, 100);
        }
        
        var cancelselectedordersfrompreorder = $rootScope.$on('gatewayApp.messagebox.proceed.cancelselectedordersfrompreorder', function (event, data) {
        	// angular.forEach($rootScope.selectedPendingOrders, function(value, index){
        	// 	if(value.select){
        	// 		var orderDTO = {};
        	// 		orderDTO = MarketWatch.prepareOrderDTOToCancel(value, vm.globalValues.getUserId(), 
         //                vm.globalValues.getUser().login, $rootScope.bankComparativeDTO, 
         //                $rootScope.retailSpotMarketSession);
        	// 		//place cancel order
        	// 		Market.cancelOrder(orderDTO);
        	// 		//$rootScope.selectedPendingOrders.splice(index,1);
        	// 	}
        	// })
        	// $rootScope.selectedPendingOrders = [];
        	// $rootScope.selectAll = false;
            $rootScope.cancelSelectedOrderCount = 0;
        	$scope.$emit('cancelselectedfrompreorderconfirmation');
        	$uibModalInstance.dismiss('cancel');
    	});
		
        $scope.$on('$destroy', function() {
            cancelselectedordersfrompreorder(); 
        });

		$rootScope.$on('gatewayApp.messagebox.cancel.cancelselectedordersfrompreorder', function (event, data) {
			//do not proceed
			$uibModalInstance.dismiss('cancel');
		});
		
		
		/*
         * allow only 30 characters in password and only some special characters
         */
		 $scope.$watch('vm.password', function(newVal, oldVal) {
			 if(newVal!=null||newVal!=undefined)
	        	{
			       	  if(newVal.length > 30) {       
			       		  vm.password = oldVal;
			       	  }
			       	  if(!newVal.charAt((newVal.length)-1).match(vm.allowedPasswordCharacters))
			   		  {
			       		  vm.password = oldVal;
			   		  }
	        	}
	       	});
		 
		 function getTimeSuccess( result){
			 
			 // vm.currentDate = DateUtils.convertDateTimeFromServer(result.currentDateTime);
			 vm.currentDate = moment.parseZone(result.currentDateTime);			 
			 vm.serverDateUTCOffset =  vm.currentDate.utcOffset();
			 vm.serverDateTimeZone = result.timeZone;
			 //console.log("time zone " +vm.currentDate.format('Z'));
			 //console.log("utc offset " + vm.serverDateUTCOffset );
			 fillDefaultTime();
		 }
		 function getTimeFailure(error){
			 
		 }
		 function getCurrentServerTimeAndValidate(result){
			 
			//vm.currentDate = new Date();
			//vm.currentDate   =  DateUtils.convertDateTimeFromServer(result.currentDateTime);
			vm.currentDate = moment.parseZone(result.currentDateTime);
			vm.serverDateUTCOffset =  vm.currentDate.utcOffset();
         	vm.currentTime = moment.parseZone(vm.currentDate, 'HH:mm').utcOffset(vm.serverDateUTCOffset).format( 'HH:mm');  
         	if(vm.serverDateUTCOffset == moment().utcOffset()){
         		vm.expiryTime = moment(vm.expiryDateTime, 'HH:mm').format( 'HH:mm');
         	}else{
         		vm.expiryTime = moment(vm.expiryDateTime, 'HH:mm').utcOffset(vm.serverDateUTCOffset).format( 'HH:mm');
         	}
         	
         	
         	if(vm.expiryTime==null || vm.expiryTime==undefined || vm.expiryTime==''){
         		vm.errorSting = 'Invalid expiry time...!';
         		return false;
         	}
         	
         	//validate close time
         	if(vm.expiryTime.split(':')[0] > vm.closeTime.split(':')[0]){
         		vm.errorString = 'Expiry time cannot be greater than ' + vm.orderDTO.instrumentCode +  ' session close time '+ vm.closeTime + '...!';
         		return false;
         	}else if((vm.expiryTime.split(':')[0] == vm.closeTime.split(':')[0]) && (vm.expiryTime.split(':')[1] >= vm.closeTime.split(':')[1])){
         		vm.errorString = 'Expiry time cannot be greater than ' + vm.orderDTO.instrumentCode +  ' session close time '+ vm.closeTime + '...!';
         		return false;
         	}

         	//validate open time
         	if(vm.expiryTime.split(':')[0] < vm.currentTime.split(':')[0]){
         		vm.errorString = 'Expiry time must be greater than current time...!';
         		return false;
         	}else if((vm.expiryTime.split(':')[0] == vm.currentTime.split(':')[0]) && (vm.expiryTime.split(':')[1] <= vm.currentTime.split(':')[1])){
         		vm.errorString = 'Expiry time must be greater than current time...!';
         		return false;
         	}
         	
         	return true;
		 }
		function getTimeForOrderCancellation(result){
			//vm.currentDate   =  DateUtils.convertDateTimeFromServer(result.currentDateTime);
			vm.currentDate = moment.parseZone(result.currentDateTime);
			vm.serverDateUTCOffset =  vm.currentDate.utcOffset();			
			fillDefaultTime();
			formatExpiryTime();
			if(vm.serverDateUTCOffset == moment().utcOffset()){
				vm.expiryTimeString=moment(vm.expiryDateTime, 'HH:mm').format( 'HH:mm');
         	}else{
         		vm.expiryTimeString= moment(vm.expiryDateTime, 'HH:mm').utcOffset(vm.serverDateUTCOffset).format( 'HH:mm');
         	}
        	
        	//vm.orderDTO.expiryTime = vm.expiryTime;
		}

        function getEventTypeForShortName(eventTypeShortName){
            var eventType = '';
            angular.forEach($rootScope.eventTypes, function(value){
                if(value.shortName==eventTypeShortName){
                    eventType = value.name;
                }
            })
            return eventType;
        }
		//divide arder amount then split the order based on no of split and store to list  ;  
	  function splitTheOrder(orderDTO,noOfsplits){
		if (orderDTO.orderAmount != null && orderDTO.orderAmount != undefined && orderDTO.orderAmount != '') {
			if (noOfsplits != null && noOfsplits != undefined && noOfsplits != "") {
			  vm.splitedOrderAmount = orderDTO.orderAmount / noOfsplits;
			   for(var splitOrder=0;splitOrder<=noOfsplits-1;splitOrder++){
				vm.orderDTO.orderAmount=vm.splitedOrderAmount;
				vm.orderDTO.SystemUniqueSNo=angular.copy(splitOrder+1);
				orderDTO.uploadStatus='SUCCESS';
				vm.orderDTOList.push(angular.copy(vm.orderDTO));
			 } 
			}
		}
	}	
	
		
    }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pending-order-report', {
            parent: 'entity',
            params:{screen: 'PendingOrderReport'}, 
            url: '/pending-order-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.pendingOrderReport.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pending-order-report/pending-order-report.html',
                    controller: 'PendingOrderReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pendingOrderReport');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('orderActivity');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('order-activity-report', {
            parent: 'pending-order-report',
            url: '/order-activity-report/{orderNumber}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-activity/order-activity.html',
                    controller: 'OrderActivityController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    	
                            	 entity: ['OrderActivity', 'GlobalValues', function(OrderActivity, GlobalValues) {
                                     return OrderActivity.get({orderNumber : $stateParams.orderNumber}).$promise;
                                 }],
                                 businessDate: [ 'GlobalValues','DateUtils', function( GlobalValues,DateUtils) {
                                	 var systemSettings = GlobalValues.getSystemSettings();
                                     if(systemSettings!=null && systemSettings!=undefined){
                                     	return DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
                                     	 
                                     }else{
                                    	 return null;
                                     }
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
        
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('PendingOrderService', PendingOrderService);

    PendingOrderService.$inject = ['$resource'];

    function PendingOrderService ($resource) {
        var resourceUrl =  'api/pending-order-report/:id';
        
        return $resource(resourceUrl, {}, {
        	
        
        	 'getPendingOrdersForReport':{
          		isArray:true,
 				method: 'GET',
 				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'
 						, fromTime: '@fromTime' , toTime : '@toTime' , currencyPairId : '@currencyPairId'
 				},
 				url: 'api/pending-order-report'
           },
           'exportPendingOrderExcel':{
           	 method: 'GET',
                url: 'api/pending-order-report/excel-download',
                responseType: 'arraybuffer',
                params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'
						, fromTime: '@fromTime' , toTime : '@toTime', currencyPairId : '@currencyPairId'
                },
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                }      
           },
           'exportPendingOrderCsv':{
            	 method: 'GET',
                 url: 'api/pending-order-report/csv-download',
                 responseType: 'arraybuffer',
                 params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'
						, fromTime: '@fromTime' , toTime : '@toTime', currencyPairId : '@currencyPairId'
                 },
                 transformResponse: function(data, headers) {
               	  return {
                         data: data,
                         headers: headers
                     };   
                 }      
            },
            'exportPendingOrderPdf':{
             	 method: 'GET',
                  url: 'api/pending-order-report/pdf-download',
                  responseType: 'arraybuffer',
                  params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'
						, fromTime: '@fromTime' , toTime : '@toTime', currencyPairId : '@currencyPairId'
                  },
                  transformResponse: function(data, headers) {
                	  return {
                          data: data,
                          headers: headers
                      };   
                  }      
             }
        });
    }
   })();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'pendingOrderReport'
        })
        
        .controller('PendingOrderReportController', PendingOrderReportController);

    PendingOrderReportController.$inject = ['$scope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
    	'DateUtils','AlertService','$filter',   'PendingOrderService', 'SODProcess', 'DealingAdminApplicationWideSettings'];

    function PendingOrderReportController($scope, $state,  GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
    		DateUtils,AlertService,$filter,  PendingOrderService, SODProcess, DealingAdminApplicationWideSettings) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.PENDING_ORDER_REPORT;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
       
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.configSettings = vm.globalValues.getConfigSettings();
		
        vm.toTime = moment();    
        
        vm.defaultDuration = "01:00:00";
	    vm.maxDate = moment().subtract( vm.duration);
	    vm.todayDate = new Date();
	    vm.getPendingOrders = getPendingOrders;
	    vm.exportDataToExcelFile = exportDataToExcelFile;
	    vm.exportDataToCsvFile = exportDataToCsvFile;
	    vm.exportDataToPdfFile = exportDataToPdfFile;
	    vm.filterData = {};
	    vm.fileName = "Pending_Order_Report_";
	    vm.extension = "";
	    vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
	    
	    logScreenAccess();
	    vm.valid = false;
		vm.clicked=false;
	   
        function loadDates() {
        	
			SODProcess.getCurrentBusinessDate(loadSystemSettingsSuccess, loadSystemSettingsError);
		}
    	function loadSystemSettingsSuccess(result){
			vm.lastSystemSetting = result;
			vm.todayDate = DateUtils.convertLocalDateFromServer(vm.lastSystemSetting.businessDate);
    	}
    	
    	function loadSystemSettingsError(){
			
		}
        loadDates();
        
       var subtractDurationFromGivenValue = function(toValue) {
        	 if(toValue !=null && toValue !=undefined && toValue != ""){
        		 var duration = vm.duration;
        		 var hours = duration.hours();
        		 var minutes = duration.minutes();
        		 if(duration==null || duration ==undefined ||  duration=="" || ( hours == 0 && minutes == 0)){
        			 duration = moment.duration( vm.defaultDuration);
        		 }
        		 return angular.copy(toValue).subtract(duration);
        	 }else{
        		 
        		 return null;
        	 }
        }
       DealingAdminApplicationWideSettings.getConfigValueForConfigName(
        		{"configName": "TimeDifferenceForTimePickerControl"}, function(result){
        			if(result !=null && result !=undefined && result.value!=null && result.value !=undefined && result.value != ""){
        				vm.duration = moment.duration( parseInt( result.value), 'hours');
        			}else{
        				vm.duration = moment.duration( vm.defaultDuration);
        			}
        			 vm.fromTime = subtractDurationFromGivenValue( vm.toTime);
       });
      
     
       
        function setReportPeriod(){
        	vm.toDateTime = moment(angular.copy(vm.todayDate ) , 'YYYY-MM-DD');        	
        	vm.toDateTime.set(
       			 { 	'hour':vm.toTime.get('hour'),
       				'minute':vm.toTime.get('minute'),
       				'second':vm.toTime.get('second')
       				
       			 });
        	vm.fromDateTime = moment(angular.copy(vm.todayDate ) , 'YYYY-MM-DD');        	
        	vm.fromDateTime.set(
       			 { 	'hour':vm.fromTime.get('hour'),
       				'minute':vm.fromTime.get('minute'),
       				'second':vm.fromTime.get('second')
       				
       			 });
       	 
        	vm.fromTimeDateObject = new Date(vm.fromDateTime);
        	vm.toTimeDateObject = new Date(vm.toDateTime);
        }
        
        function validatePeriod(){
        	
        	
        }
        
        function copyFilterData(){
        	
        	 if(vm.bank!=null && vm.bank !=undefined){
        		 
        		 vm.filterData.bankId = angular.copy(vm.bank.id);
        	 }else{
        		
        		 vm.filterData.bankId = 0;
        	 }
        	 if(vm.branch!=null && vm.branch!=undefined){
        		
        		 vm.filterData.branchId = angular.copy(vm.branch.id);
        	}else{
        		 
        		vm.filterData.branchId = 0;
        	}if(vm.customer!=null && vm.customer!=undefined){
        		 
        		vm.filterData.customerId = angular.copy(vm.customer.id);
        	}else{
        		
        		vm.filterData.customerId = 0;
        	}
        	if(vm.instrument!=null && vm.instrument!=undefined){
        		 vm.filterData.instrumentId = angular.copy(vm.instrument.id);
        	}else{
        		vm.filterData.instrumentId = 0;
        	}
			if(vm.currencyPair!=null && vm.currencyPair!=undefined){
        		 vm.filterData.currencyPairId = angular.copy(vm.currencyPair.id);
        	}else{
        		vm.filterData.currencyPairId = 0;
        	}
        	 vm.filterData.fromTimeDateObject = angular.copy(vm.fromTimeDateObject );
        	 vm.filterData.toTimeDateObject = angular.copy(vm.toTimeDateObject);
        }
        
        function getPendingOrders(){
        	vm.valid = true;
        	if(vm.toTime.isAfter(moment())){
        		
        		AlertService.error("To Time should be less than or equal to current time");
        	}else if(vm.fromTime.isAfter( vm.toTime)){
        		
        		AlertService.error("From Time should be less than or equal to To Time");
        	}else{
				vm.clicked=true;
        		setReportPeriod();
            	copyFilterData();
        		PendingOrderService.getPendingOrdersForReport({bankId: vm.filterData.bankId, branchId: vm.filterData.branchId, 
        			customerId:vm.filterData.customerId,  instrumentId: vm.filterData.instrumentId, fromTime:vm.fromTimeDateObject , toTime:vm.toTimeDateObject, currencyPairId: vm.filterData.currencyPairId  }, 
        			onGetPendingOrdersSuccess, onGetPendingOrdersFailure);  		
        	}
        	
        	
        }
        function onGetPendingOrdersSuccess(result){
        	 angular.forEach(result, function(value){
             	value.revisionTimeStamp=moment(value.revisionTimeStamp,'YYYYMMDDHHmmss.SSSSSSSSS').format();
             	
             	if(value.expiryTime==0){
	              		var time = moment().toDate();
		              	time.setHours(0);
		              	time.setMinutes(0);
		              	time.setSeconds(0);
		              	time.setMilliseconds(0);
		              	value.expiryTime=time;
	              	}else{
	              		value.expiryTime=moment(value.expiryTime,'YYYYMMDDHHmmss').format();
	              	}
             	
             	if(value.buySellFlag.toUpperCase()=='BUYY'){
             		value.buySellFlag='Buy';
             	}else if(value.buySellFlag.toUpperCase()=='SELL'){
             		value.buySellFlag='Sell';
             	}
             	
             	
             	
             	if(value.timeCondition.toUpperCase()!='GTTM'){
             		value.expiryTime=null;
             	}
             	
             	if(value.timeCondition.toUpperCase()=='DAYY'){
             		value.timeCondition='DAY';
             	}else if(value.timeCondition.toUpperCase()=='GTTM'){
             		value.timeCondition='GTT';
             	}else if(value.timeCondition.toUpperCase()=='IOCC'){
             		value.timeCondition='IOC';
             	}
             	
             	if(value.priceCondition.shortName!='STLS' && value.priceCondition.shortName!='TKPR'){
             		value.stopExchangeRate=null;
             	}
             	
             	if(value.lastTradeSequenceNumber==0){
             		value.lastTradeSequenceNumber=0;
             	}
         	});
        	vm.pendingOrderDetails = result;
			vm.clicked=false;
        }
        function onGetPendingOrdersFailure(error){
        	vm.clicked=false;
        }
        
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }
        function exportDataToExcelFile(){
      	  	
      	  if( vm.pendingOrderDetails !=null &&  vm.pendingOrderDetails!=undefined && vm.pendingOrderDetails.length>0){
      		 
      			  vm.mimeType = 'application/vnd.ms-excel';
      			  vm.extension = ".xls";  
      			  PendingOrderService.exportPendingOrderExcel({bankId:  vm.filterData.bankId, branchId:  vm.filterData.branchId, 
        			customerId:  vm.filterData.customerId,  instrumentId:  vm.filterData.instrumentId, fromTime: vm.filterData.fromTimeDateObject , toTime: vm.filterData.toTimeDateObject, currencyPairId:  vm.filterData.currencyPairId  } 
      			, processResponse );
      		 
      	  }
        }
       
        function exportDataToCsvFile(){
        	
        		
        	  if( vm.pendingOrderDetails !=null &&  vm.pendingOrderDetails!=undefined && vm.pendingOrderDetails.length>0){
        		 
        			vm.mimeType = 'text/csv';
        			vm.extension =  ".csv";  
        			PendingOrderService.exportPendingOrderCsv({bankId:  vm.filterData.bankId, branchId:  vm.filterData.branchId, 
          			customerId:  vm.filterData.customerId,  instrumentId:  vm.filterData.instrumentId, fromTime: vm.filterData.fromTimeDateObject , toTime: vm.filterData.toTimeDateObject, currencyPairId:  vm.filterData.currencyPairId  } , processResponse );
        		 
        	  }
        }
	    function exportDataToPdfFile(){
	    	
	    		
	      	  if( vm.pendingOrderDetails !=null &&  vm.pendingOrderDetails!=undefined && vm.pendingOrderDetails.length>0){
	      		 
	      			  vm.mimeType = 'application/pdf';
	      			  vm.extension = ".pdf";  
	      			  PendingOrderService.exportPendingOrderPdf({bankId:  vm.filterData.bankId, branchId:  vm.filterData.branchId, 
	        			customerId:  vm.filterData.customerId,  instrumentId:  vm.filterData.instrumentId, fromTime: vm.filterData.fromTimeDateObject , toTime: vm.filterData.toTimeDateObject, currencyPairId:  vm.filterData.currencyPairId  } , processResponse );
	      		 
	      	  }
	    }
	    function processResponse(result){        	  
	      	  var fileData = null;
	  		  fileData = result.data;
	  		  var link = document.createElement("a");   
	  		  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
	  		  vm.baseString =   vm.fileName + moment().format( vm.reportFileTimestampFormat ) +  vm.extension; 
	  		  
	  	      var blob = new Blob([bytes], {type: vm.mimeType});
	  	      if(window.navigator.msSaveOrOpenBlob) {
	                  window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
	  	      }else{
	  	    	  link.href =  window.URL.createObjectURL(blob);      
	  	    	  link.download = vm.baseString;
	  	    	  document.body.appendChild(link);
	  	    	  link.click();
	  	    	  document.body.removeChild(link);
	  	      }
	  	}

		vm.getSwapPoints = function getSwapPoints(spotExchangeRate, tradeExchangeRate){
			var swapPts =0;
			if(spotExchangeRate!=0){
			 var swapPts = Math.abs(spotExchangeRate - tradeExchangeRate) * 100
			 swapPts = (Math.round(parseFloat(swapPts)*100)/100);
			 return swapPts;
			}else{
			 return swapPts;
			}
		}
    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pending-limit-requests-view', {
            parent: 'entity',
            params:{screen: 'PendingLimitRequestsView'},
            url: '/pending-limit-requests-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.pendingLimitRequestsView.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pending-limit-requests-view/pending-limit-requests-view.html',
                    controller: 'PendingLimitRequestsViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pendingLimitRequestsView');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                systemSetting: ['IntradayMarket', function(IntradayMarket) {
                    return IntradayMarket.getCurrentBusinessDate().$promise;
                }]

            }
        })
        };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('PendingLimitRequestsViewService', PendingLimitRequestsViewService);

    PendingLimitRequestsViewService.$inject = ['$resource'];

    function PendingLimitRequestsViewService($resource) {
        var resourceUrl =  'api/pending-limit-request-view/:id';
        
        return $resource(resourceUrl, {}, {
        	
        	'getPendingLimitRequestsView':{
        		isArray:true,
				method: 'GET',
				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId'},
				url: 'api/pending-limit-requests-view'
        	},
            'exportPendingLimitRequestsExcel':{
                method: 'POST',
                url: 'api/pending-limit-requests-view/export-excel',
                params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId'},
                responseType: 'arraybuffer',
                 transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            },
            'exportPendingLimitRequestsCsv':{
                method: 'POST',
                url: 'api/pending-limit-requests-view/export-csv',
                params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId'},
                responseType: 'arraybuffer',
                 transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            }
        });
    }
   })();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'pendingLimitRequestsView'
        })
        
        .controller('PendingLimitRequestsViewController', PendingLimitRequestsViewController);

    PendingLimitRequestsViewController.$inject = ['$scope', 'GlobalValues', 'ScreenLog','entityConstants', 
    	'DateUtils', 'PendingLimitRequestsViewService',  'systemSetting'];

    function PendingLimitRequestsViewController($scope, GlobalValues, ScreenLog,entityConstants, 
    		DateUtils, PendingLimitRequestsViewService, systemSetting) {
       
    	var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.PENDING_LIMIT_REQUESTS_VIEW;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
		$scope.noOfRecordsPerPageDetail = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.pageDetail = 1;

        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
       
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
       
	    vm.getPendingLimitRequestsView = getPendingLimitRequestsView;
		vm.getPendingLimitRequestDetails = getPendingLimitRequestDetails;
		vm.getTotalPendingLimitRequestDetails = getTotalPendingLimitRequestDetails;
	    vm.exportDataToExcelFile = exportDataToExcelFile;
	    vm.exportDataToCsvFile = exportDataToCsvFile;
	    
	    vm.filterData = {};
	    vm.fileName = "Pending_Limit_Requests_View_";
	    vm.extension = "";
	    vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
		vm.totalCustomerLimitRequests = 0;
    	vm.totalBankLimitRequests = 0;
		vm.pendingLimitRequestsViewList = [];
		vm.pendingRequestDetailsList = [];
		vm.requestType="";
	    
	    logScreenAccess();
	    vm.valid = false;
		vm.clicked=false;
	    if(systemSetting != null && systemSetting != undefined){
        	vm.currentDate = DateUtils.convertDateTimeFromServer(systemSetting.businessDate);	//not working
        }
	    vm.todayDate = new Date();
		vm.reportDate = DateUtils.convertDateTimeFromServer(vm.todayDate);
        
        function getPendingLimitRequestsView(){
			var bankId = 0;
        	var branchId = 0;
        	var customerId = 0;

        	vm.pendingLimitRequestsViewList = [];
			vm.pendingRequestDetailsList = [];

			vm.valid = true;
			if(vm.bank!=null){
				bankId = vm.bank.id;
			}
			if(vm.branch!=null){
				branchId = vm.branch.id;
			}
			if(vm.customer!=null){
				customerId = vm.customer.id;
			}

			copyFilterParams(bankId, branchId, customerId);

			PendingLimitRequestsViewService.getPendingLimitRequestsView({"bankId": bankId, "branchId": branchId, "customerId": customerId},
				onGetPendingLimitRequestsSuccess, onGetPendingLimitRequestsFailure);
        	
        }

        function onGetPendingLimitRequestsSuccess(result){
			vm.totalCustomerLimitRequests = 0;
    		vm.totalBankLimitRequests = 0;
			vm.pendingLimitRequestsViewList = result;
			calculateHeaderTotal(result);
			vm.clicked=false;
        }

		function onGetPendingLimitRequestsFailure(){
        	vm.clicked=false;
        }

		function calculateHeaderTotal(list){
    		vm.totalCustomerLimitRequests = 0;
    		vm.totalBankLimitRequests = 0;
    		
    		angular.forEach(list, function(value) {
    			vm.totalCustomerLimitRequests = vm.totalCustomerLimitRequests + value.customerLimitRequestsCount;  
    			vm.totalBankLimitRequests = vm.totalBankLimitRequests + value.bankLimitRequestsCount; 
    		});
    		
    	}

		function copyFilterParams(bankId, branchId, customerId){
			vm.filterData = {};
			
			vm.filterData.bankId = bankId;
			vm.filterData.branchId = branchId;
			vm.filterData.customerId = customerId;

		}

		function getPendingLimitRequestDetails(limitRequestSummaryDTO, requestType){
			vm.pendingRequestDetailsList = [];
			vm.requestType = requestType;
			if(requestType=='BANK'){
				vm.pendingRequestDetailsList = limitRequestSummaryDTO.pendingBankRequestedLimitList;
			}else{
				vm.pendingRequestDetailsList = limitRequestSummaryDTO.pendingCustomerRequestedLimitList;
			}
		}

		function getTotalPendingLimitRequestDetails(requestType){
			vm.pendingRequestDetailsList = [];
			vm.requestType = requestType;
			angular.forEach(vm.pendingLimitRequestsViewList, function(value){
				if(requestType=='BANK'){
					angular.forEach(value.pendingBankRequestedLimitList, function(value1){
						vm.pendingRequestDetailsList.push(value1);
					});
				}else{
					angular.forEach(value.pendingCustomerRequestedLimitList, function(value2){
						vm.pendingRequestDetailsList.push(value2);
					});
				}
			})

		}
        
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }

		function exportDataToExcelFile(){
      	 
      	  if(vm.pendingLimitRequestsViewList  !=null &&   vm.pendingLimitRequestsViewList !=undefined &&  vm.pendingLimitRequestsViewList .length>0){
      		 
      			vm.mimeType = 'application/vnd.ms-excel';
      			vm.extension = ".xls";  
				var selectedRequests = angular.copy(vm.pendingLimitRequestsViewList);
				
				PendingLimitRequestsViewService.exportPendingLimitRequestsExcel({bankId: vm.filterData.bankId, branchId: vm.filterData.branchId, 
					customerId: vm.filterData.customerId}, selectedRequests, processResponse);
      		 
      	  }
        }       
        function exportDataToCsvFile(){        	
        		
        	  if( vm.pendingLimitRequestsViewList !=null &&  vm.pendingLimitRequestsViewList!=undefined && vm.pendingLimitRequestsViewList.length>0){
        		 
        			vm.mimeType = 'text/csv';
        			vm.extension = ".csv";  
					var selectedRequests = angular.copy(vm.pendingLimitRequestsViewList);
					
					PendingLimitRequestsViewService.exportPendingLimitRequestsCsv({bankId: vm.filterData.bankId, branchId: vm.filterData.branchId, 
						customerId: vm.filterData.customerId}, selectedRequests, processResponse);
					 
        	  }
        }
	    
	    function processResponse(result){
	      	  var fileData = null;
	  		  fileData = result.data;
	  		  var link = document.createElement("a");   
	  		  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
	  		  vm.baseString =     vm.fileName + moment().format(vm.reportFileTimestampFormat) +  vm.extension;   	
	  		  
	  	      var blob = new Blob([bytes], {type: vm.mimeType});
	  	      if(window.navigator.msSaveOrOpenBlob) {
	                  window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
	  	      }else{
	  	    	  link.href =  window.URL.createObjectURL(blob);      
	  	    	  link.download = vm.baseString;
	  	    	  document.body.appendChild(link);
	  	    	  link.click();
	  	    	  document.body.removeChild(link);
	  	      }
	  	}

		//get length for rowspan
		vm.getLength = function getLength(limitRequestHeaderDTO){
			var len =0;
			angular.forEach(limitRequestHeaderDTO.limitRequestDetailsDTOList, function(value){
				len = len + 1;
			})
			return len;
		}

    }
})();
(function () {
	'use strict';

	angular
		.module('gatewayApp')
		.config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
			.state('otr-summary-for-bank', {
				parent: 'entity',
				params: { screen: 'OTRSummaryForBank' },
				url: '/otr-summary-for-bank',
				data: {
					authorities: ['ROLE_USER'],
					pageTitle: 'global.title'
				},
				ncyBreadcrumb: {
					label: '{{ "global.menu.otrSummary.main" | translate }}',
					parent: 'home'
				},
				views: {
					'content@': {
						templateUrl: 'app/entities/otr-summary-for-bank/otr-summary-for-bank.html',
						controller: 'OTRSummaryForBankViewController',
						controllerAs: 'vm'
					}
				},
				resolve: {
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('otrSummaryReport');
						$translatePartialLoader.addPart('error');
						$translatePartialLoader.addPart('global');
						return $translate.refresh();
					}],
					configSetting: ['GlobalValues', function (GlobalValues) {
						return GlobalValues.getConfigSettings();
					}],
					systemSettings: ['IntradayMarket', function (IntradayMarket) {
						return IntradayMarket.getCurrentBusinessDate().$promise;
					}]

				}
			})

	};
})();

(function () {
	'use strict';
	angular
		.module('gatewayApp')
		.factory('OTRSummaryForBankView', OTRSummaryForBankView);

	OTRSummaryForBankView.$inject = ['$resource'];

	function OTRSummaryForBankView($resource) {
		var resourceUrl = 'api/otr-summary-for-bank/:id';

		return $resource(resourceUrl, {}, {

			'getOTRSummaryForBankReport': {
				method: 'GET',
				isArray: true,
				params: { bankId: '@bankId', branchId: '@branchId', fromDate: '@fromDate', toDate: '@toDate' },
				url: 'api/otr-summary/get-otr-summary-details-for-bank'
			},
			'exportOTRSummaryForBankExcel': {
				method: 'POST',
				url: 'api/otr-summary-for-bank/excel-download',
				responseType: 'arraybuffer',
				params: { bankId: '@bankId', branchId: '@branchId', fromDate: '@fromDate', toDate: '@toDate' },
				transformRequest: function (data) {
					var copy = angular.copy(data);

					return angular.toJson(copy);
				},
				transformResponse: function (data, headers) {
					return {
						data: data,
						headers: headers
					};
				}
			},
			'exportOTRSummaryForBankCsv': {
				method: 'POST',
				url: 'api/otr-summary-for-bank/csv-download',
				responseType: 'arraybuffer',
				params: { bankId: '@bankId', branchId: '@branchId', fromDate: '@fromDate', toDate: '@toDate' },
				transformRequest: function (data) {
					var copy = angular.copy(data);

					return angular.toJson(copy);
				},
				transformResponse: function (data, headers) {
					return {
						data: data,
						headers: headers
					};
				}
			},


		});
	}
})();
(function () {
	'use strict';

	angular
		.module('gatewayApp')
		.service("workflowSharedService", function () {
			this.viewFrom = 'otrSummaryView'
		})

		.controller('OTRSummaryForBankViewController', OTRSummaryForBankViewController);

	OTRSummaryForBankViewController.$inject = ['$scope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog', 'entityConstants',
		'DateUtils', 'AlertService', '$filter', 'systemSettings', 'configSetting', 'OTRSummaryForBankView'];

	function OTRSummaryForBankViewController($scope, $state, GlobalValues, workflowSharedService, EntityPermissions, ScreenLog, entityConstants,
		DateUtils, AlertService, $filter, systemSettings, configSetting, OTRSummaryForBankView) {
		var vm = this;
		vm.entityConstants = entityConstants;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.OTR_SUMMARY_VIEW;
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;

		$scope.noOfRecordsPerPageSummary = angular.copy($scope.noOfRecordsPerPage);
		$scope.pageSummary = 1;
		vm.clicked=false;
		vm.globalValues = GlobalValues;
		vm.screenLog = ScreenLog;
		vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
		vm.configSettings = configSetting;
		vm.noOFMonthsToDisplayForReports = vm.configSettings.noOfMOnthsForHistoricalReportsView;
		vm.exportDataToFile = exportDataToFile;
		vm.setDefaultValue = setDefaultValue;
		vm.loadFinancialMonthOption = loadFinancialMonthOption;
		vm.clearAllValues = clearAllValues;
		vm.filterData = {};
		vm.otrSummaryfileName = "OTR_Summary_Report_";
		vm.fileName = vm.otrSummaryfileName;
		vm.extension = "";
		vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
		vm.firstTimeLoad = null;
		vm.financialMonth = {};
		vm.previousFiancialMonthOptions = [];
		vm.otrSummarySelected = [];
		vm.showNoRecordsFound = false;
		vm.financialYear = vm.globalValues.getFinancialYear();
		vm.otrSummaryDetails = [];
		vm.getOTRSummaryForBank = getOTRSummaryForBank;
		vm.OtrSummaryForBank = vm.globalValues.getBank();
		vm.userEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
		vm.otrSummarygrossCharges = 0;
		vm.isCurrenMonth = true;
		vm.OtrSummaryDate=true;
		logScreenAccess();
		vm.valid = false;
		if (vm.configSettings != null && vm.configSettings != undefined && vm.configSettings.noOfMOnthsForHistoricalReportsView != null && vm.configSettings.noOfMOnthsForHistoricalReportsView != undefined && !isNaN(vm.configSettings.noOfMOnthsForHistoricalReportsView)) {
			vm.noOFMonthsToDisplayForReports = vm.configSettings.noOfMOnthsForHistoricalReportsView;
		}
		else {
			vm.noOFMonthsToDisplayForReports = 2;
		}

		if (systemSettings != null && systemSettings != undefined) {
			vm.currentBusinessDate = systemSettings.businessDate;
			vm.currentBusinessDateMoment = moment(DateUtils.convertLocalDateFromServer(angular.copy(vm.currentBusinessDate)));
			//vm.maxDate =  angular.copy(vm.currentBusinessDateMoment).toDate();
			vm.minDate = angular.copy(vm.currentBusinessDateMoment).subtract(vm.noOFMonthsToDisplayForReports, 'months').startOf('month').toDate();
			loadFinancialMonthOption();
			setDefaultValue();
		}


		function getOTRSummaryForBank() {
			vm.bankId = vm.OtrSummaryForBank.id
			vm.otrSummarySelected = [];
			vm.valid = true;
			vm.branchId = 0;

			if (vm.bank != null && vm.bank != undefined) {
				vm.bankId = angular.copy(vm.bank.id);
			}
			if (vm.userEntityOwnerType == 'Branch') {
				vm.branchId = vm.globalValues.getBranchId();
			}
			if (moment(vm.minDate).isAfter(vm.fromDate, 'day')) {
				AlertService.error($filter('translate')('gatewayApp.otrSummaryReport.fromDateLesserThanMinDate'));
				vm.valid = false;
			} else if (moment(vm.maxDate).isBefore(vm.fromDate, 'day')) {
				AlertService.error($filter('translate')('gatewayApp.otrSummaryReport.fromDateGreaterMaxDate'));
				vm.valid = false;
			}
			else if (moment(vm.toDate).isAfter(vm.maxDate, 'day')) {
				AlertService.error($filter('translate')('gatewayApp.otrSummaryReport.toDateGreaterMaxDate'));
				vm.valid = false;
			}
			else if (moment(vm.minDate).isAfter(vm.toDate, 'day')) {
				AlertService.error($filter('translate')('gatewayApp.otrSummaryReport.toDateLesserThanMinDate'));
				vm.valid = false;
			}
			else if (moment(vm.fromDate).isAfter(vm.toDate, 'day')) {
				AlertService.error($filter('translate')('gatewayApp.otrSummaryReport.fromDateGreaterThanToDate'));
				vm.valid = false;
			}
			else if (vm.fromDate.getMonth() != vm.toDate.getMonth()) {
				AlertService.error($filter('translate')('gatewayApp.otrSummaryReport.fromToNotSameMonth'));
				vm.valid = false;
			}
			clearAllValues();
			vm.clicked=true;
			OTRSummaryForBankView.getOTRSummaryForBankReport({ bankId: vm.bankId, branchId: vm.branchId, fromDate: DateUtils.convertLocalDateToServer(vm.fromDate), toDate: DateUtils.convertLocalDateToServer(vm.toDate) },
				onGetOTRSummaryForBankSuccess, onGetOTRSummaryForBankFailure);


		}
		function onGetOTRSummaryForBankSuccess(result) {
			vm.otrSummaryDetails = result;
			totalGrossCharges();
			vm.clicked=false;
		}
		function onGetOTRSummaryForBankFailure(error) {
			vm.clicked=false;
		}

		function totalGrossCharges() {
			if (vm.otrSummaryDetails != null && vm.otrSummaryDetails != undefined) {
				var otrSummaryDetailsCount;
				vm.otrSummaryCharges = 0;
				for (otrSummaryDetailsCount = 0; otrSummaryDetailsCount <= vm.otrSummaryDetails.length -1; otrSummaryDetailsCount++) {
					vm.otrSummaryCharges = vm.otrSummaryCharges + vm.otrSummaryDetails[otrSummaryDetailsCount].chargeDetails.grossCharges;
				}
			}
		}

		function logScreenAccess() {
			ScreenLog.screenLog(vm.screenName, 0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}

		//this method is used to set default value to both the from and to date or financial month
		function setDefaultValue() {


			/*vm.selectedFinancialMonth  = vm.previousFiancialMonthOptions[0];*/
			vm.financialMonth = angular.copy(vm.previousFiancialMonthOptions[0]);
			vm.fromDate = angular.copy(vm.financialMonth.date).toDate();
			vm.toDate = angular.copy(vm.financialMonth.date).endOf('month').toDate();
			vm.maxDate = angular.copy(vm.currentBusinessDateMoment).endOf('month').toDate();//previous bdate	//temporary
			//vm.minToDate = angular.copy(vm.financialMonth.date).toDate();
			//vm.maxToDate =  angular.copy(vm.toDate);

		}
		function loadFinancialMonthOption() {
			vm.previousFiancialMonthOptions = [];
			vm.previousFiancialMonthOptions.push(createMonthOptions(angular.copy(vm.currentBusinessDateMoment))); //allways dispaly in current month
			var monthCount = 1;
			for (monthCount = 1; monthCount <= vm.noOFMonthsToDisplayForReports; monthCount++) {
				vm.previousFiancialMonthOptions.push(createMonthOptions(angular.copy(vm.currentBusinessDateMoment).subtract(monthCount, 'month')))
			}

		}
		vm.createMonthOptions = createMonthOptions;
		function createMonthOptions(dateMoment) {
			var currentMonthOption = {};
			currentMonthOption.date = angular.copy(dateMoment).startOf('month');
			currentMonthOption.monthDisplay = dateMoment.format('MMM - YYYY');
			return currentMonthOption;

		}
		vm.onFinacialMonthSelection = onFinacialMonthSelection;
		function onFinacialMonthSelection(value) {
			var monthSelected = value.date; 
			vm.fromDate = angular.copy(monthSelected).toDate();	
			var financialdate = angular.copy(monthSelected).toDate();
			var currentdate = angular.copy(vm.currentBusinessDateMoment).toDate();
			if (financialdate.getMonth() == currentdate.getMonth()) {
				vm.isCurrenMonth = false;
				vm.toDate  = angular.copy(vm.currentBusinessDateMoment).toDate();
			
			} else {
				vm.isCurrenMonth = true;
				vm.toDate  = angular.copy(monthSelected).endOf('month').toDate();
			}
		}
		function exportDataToFile(fileType) {
			if (vm.otrSummaryDetails != null && vm.otrSummaryDetails != undefined && vm.otrSummaryDetails.length > 0) {
				if (fileType == 'csv') {
					vm.mimeType = 'text/csv';
					vm.extension = ".csv";
					OTRSummaryForBankView.exportOTRSummaryForBankCsv({ bankId: vm.bankId, branchId: vm.branchId, fromDate: DateUtils.convertLocalDateToServer(vm.fromDate), toDate: DateUtils.convertLocalDateToServer(vm.toDate) }, processResponse);
				}
				else if (fileType == 'xls') {
					vm.mimeType = 'application/vnd.ms-excel';
					vm.extension = ".xls";
					OTRSummaryForBankView.exportOTRSummaryForBankExcel({ bankId: vm.bankId, branchId: vm.branchId, fromDate: DateUtils.convertLocalDateToServer(vm.fromDate), toDate: DateUtils.convertLocalDateToServer(vm.toDate) }, processResponse);
				}
			}
		}
		function processResponse(result) {
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");
			var bytes = new Uint8Array(fileData);   // convert uint8 to binary array from arraybuffer
			vm.baseString = vm.fileName + moment().format(vm.reportFileTimestampFormat) + vm.extension;

			var blob = new Blob([bytes], { type: vm.mimeType });
			if (window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString);
			} else {
				link.href = window.URL.createObjectURL(blob);
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
		$scope.$watch('vm.financialMonth', function (value) {
			if (value != undefined && value != null) {
				onFinacialMonthSelection(value);
			}

		});


		function clearAllValues() {
			vm.otrSummaryDetails = null;
			vm.otrSummarySelected = [];
			$scope.filterText = null;
			$scope.filterTextSummary = null;
		}
	}
})();
(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
		.state('otr-summary', {
			parent: 'entity',
			params:{screen: 'OTRSummary'},
			url: '/otr-summary',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'global.title'
			},
			ncyBreadcrumb: {
				label: '{{ "global.menu.otrSummary.main" | translate }}',
				parent: 'home'
			},
			views: {
				'content@': {
					templateUrl: 'app/entities/otr-summary/otr-summary.html',
					controller: 'OTRSummaryViewController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('otrSummaryReport');
					$translatePartialLoader.addPart('error');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}],
				configSetting :['GlobalValues', function(GlobalValues) {
                    return GlobalValues.getConfigSettings();
                }],
                systemSettings: ['IntradayMarket', function(IntradayMarket) {
                    return IntradayMarket.getCurrentBusinessDate().$promise;
                }],
				financialYears: ['StaticLookUp', function(StaticLookUp){
					return StaticLookUp.getPastAndPresentFinancialYears().$promise;
				}]

			}
		})   

	};
})();

(function() {
	'use strict';
	angular
	.module('gatewayApp')
	.factory('OTRSummaryView', OTRSummaryView);

	OTRSummaryView.$inject = ['$resource'];

	function OTRSummaryView ($resource) {
		var resourceUrl =  'api/otr-summary/:id';

		return $resource(resourceUrl, {}, {

			'getOTRSummaryReport':{          	 
				method: 'GET',
				params: {bankId : '@bankId',from : '@from', to: '@to',printorGenerateAfreshOption : '@printorGenerateAfreshOption'},  				
				url: 'api/otr-summary/get-otr-summary-details'
			},
			'exportOTRSummaryExcel':{
				method: 'POST',
				url: 'api/otr-summary/excel-download',
				responseType: 'arraybuffer',
				params: {freshOrPrintOption : '@freshOrPrintOption', bank : '@bank'},
				transformRequest: function (data) {
	                   	var copy = angular.copy(data);
	                   	
	                       return angular.toJson(copy);
	            },
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			},
			'downloadEInvoiceExcel':{
				method: 'POST',
				url: 'api/otr-summary/eInvoice-download',
				responseType: 'arraybuffer',
				params: {from : '@from', to: '@to',financialYearId : '@financialYearId'},
				transformRequest: function (data) {
	                   	var copy = angular.copy(data);
	                   	
	                       return angular.toJson(copy);
	            },
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			},
			'exportOTRSummaryCsv':{
				method: 'POST',
				url: 'api/otr-summary/csv-download',
				responseType: 'arraybuffer',
				params: {freshOrPrintOption : '@freshOrPrintOption', bank : '@bank'},
				transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
            },
			transformResponse: function(data, headers) {
				return {
					data: data,
					headers: headers
				};   
			}         
			},
			'exportOTRSummaryPdf':{
				method: 'POST',
				url: 'api/otr-summary/pdf-download',
				responseType: 'arraybuffer',
				params: {freshOrPrintOption : '@freshOrPrintOption', bank : '@bank'},
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			}

		});
	}
})();

(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.service("workflowSharedService", function () {        	
		this.viewFrom= 'otrSummaryView'
	})

	.controller('OTRSummaryViewController', OTRSummaryViewController);

	OTRSummaryViewController.$inject = ['$scope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
		'DateUtils','AlertService','$filter',   'OTRSummaryView','systemSettings','configSetting','financialYears'];

	function OTRSummaryViewController($scope, $state,  GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
			DateUtils,AlertService,$filter,  OTRSummaryView,systemSettings,configSetting,financialYears) {
		var vm = this;
		vm.entityConstants = entityConstants;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.OTR_SUMMARY_VIEW;
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;

		$scope.noOfRecordsPerPageSummary = angular.copy($scope.noOfRecordsPerPage);
		$scope.pageSummary = 1;

		vm.globalValues=GlobalValues;
		vm.screenLog = ScreenLog;
		vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
		vm.configSettings = configSetting;
		vm.noOFMonthsToDisplayForReports = vm.configSettings.noOfMOnthsForHistoricalReportsView;
		vm.freshOrPrintOption = 'PrintGeneratedInvoice';
		vm.getOTRSummary = getOTRSummary;
		vm.exportDataToFile = exportDataToFile;
		vm.setDefaultValue = setDefaultValue;
		vm.getOTRSummaryDetails = getOTRSummaryDetails;
		vm.loadFinancialMonthOption = loadFinancialMonthOption;
		vm.clearAllValues = clearAllValues;
		vm.filterData = {};
		vm.otrSummaryfileName = "OTR_Summary_Report_";
		vm.eInvoiceChargesfileName = "e-Invoice_";
		vm.fileName = vm.otrSummaryfileName;		
		vm.extension = "";
		vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
		vm.firstTimeLoad = null;
		vm.financialMonth = {};
		vm.previousFiancialMonthOptions = [];
		vm.otrSummarySelected = [];
		vm.showDownloadEInvoice = false;
		vm.showNoRecordsFound = false;
		vm.selectedBankName = "";
		vm.financialYear = vm.globalValues.getFinancialYear();
		vm.downloadEInvoice = downloadEInvoice;
		vm.financialYearList=financialYears;
		logScreenAccess();
		vm.valid = false;
		vm.issuePresent = false;

		if(vm.configSettings != null && vm.configSettings != undefined && vm.configSettings.noOfMOnthsForHistoricalReportsView != null && vm.configSettings.noOfMOnthsForHistoricalReportsView != undefined && !isNaN(vm.configSettings.noOfMOnthsForHistoricalReportsView)){
			vm.noOFMonthsToDisplayForReports = vm.configSettings.noOfMOnthsForHistoricalReportsView;
		}
		else{
			vm.noOFMonthsToDisplayForReports = 2;
		}

		if(systemSettings != null && systemSettings != undefined){
			vm.currentBusinessDate = systemSettings.businessDate;
			vm.currentBusinessDateMoment = moment(DateUtils.convertLocalDateFromServer(angular.copy(vm.currentBusinessDate)));
			//vm.maxDate =  angular.copy(vm.currentBusinessDateMoment).toDate();
			vm.minDate =  angular.copy(vm.currentBusinessDateMoment).subtract(vm.noOFMonthsToDisplayForReports,'months').startOf('month').toDate();		
			loadFinancialMonthOption();
			setDefaultValue(vm.freshOrPrintOption);
		}


		function getOTRSummary(){

			if(vm.freshOrPrintOption == 'PrintGeneratedInvoice'&& (vm.bank==null || vm.bank== undefined|| vm.bank=='')){
				vm.showDownloadEInvoice = true;
			}else{
				vm.showDownloadEInvoice = false;
			}
			vm.eInvoiceDisable = false;
			vm.otrSummaryDetails = [];
			vm.otrSummarySelected = [];
			vm.valid = true;
			vm.bankId = 0;
			if(vm.bank!=null && vm.bank !=undefined){
				vm.bankId = angular.copy(vm.bank.id);
			}

			if(moment(vm.minDate).isAfter(vm.fromDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.otrSummaryReport.fromDateLesserThanMinDate'));
				vm.valid = false;
				vm.issuePresent = true;
			}else if(moment(vm.maxDate).isBefore(vm.fromDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.otrSummaryReport.fromDateGreaterMaxDate'));
				vm.valid = false;
			}
			else if(moment(vm.toDate).isAfter(vm.maxDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.otrSummaryReport.toDateGreaterMaxDate'));
				vm.valid = false;
				vm.issuePresent = true;
			}
			else if(moment(vm.minDate).isAfter(vm.toDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.otrSummaryReport.toDateLesserThanMinDate'));
				vm.valid = false;
				vm.issuePresent = true;
			}
			else if(moment(vm.fromDate).isAfter(vm.toDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.otrSummaryReport.fromDateGreaterThanToDate'));
				vm.valid = false;
				vm.issuePresent = true;
			}
			else if(vm.fromDate.getMonth() != vm.toDate.getMonth()){
				AlertService.error($filter('translate')('gatewayApp.otrSummaryReport.fromToNotSameMonth'));
				vm.valid = false;
				vm.issuePresent = true;
			}
			else{
				vm.issuePresent = false;
				vm.valid = true;
				vm.selectedPrintorRefresh = angular.copy(vm.freshOrPrintOption);
				if(vm.bank != null && vm.bank != undefined){
					vm.selectedBankName = vm.bank.bankName;
				}else{
					vm.selectedBankName = '--All--';
				}
				clearAllValues();
				OTRSummaryView.getOTRSummaryReport({ bankId : vm.bankId,from : DateUtils.convertLocalDateToServer(vm.fromDate), to: DateUtils.convertLocalDateToServer(vm.toDate),printorGenerateAfreshOption : vm.selectedPrintorRefresh}, 
						onGetOTRSummarySuccess, onGetOTRSummaryFailure);  		
			}

		}
		function onGetOTRSummarySuccess(result){
			vm.otrSummaryDetails = result;
		}
		function onGetOTRSummaryFailure(error){

		}

		function logScreenAccess(){
			ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}

		//this method is used to set default value to both the from and to date or financial month
		function setDefaultValue(value){

			if(value == 'PrintGeneratedInvoice'){
				/*vm.selectedFinancialMonth  = vm.previousFiancialMonthOptions[0];*/
				vm.financialMonth = angular.copy(vm.previousFiancialMonthOptions[0]);
				vm.fromDate = angular.copy( vm.financialMonth.date).toDate();
				vm.toDate =angular.copy( vm.financialMonth.date).endOf('month').toDate();
				vm.maxDate =  angular.copy(vm.currentBusinessDateMoment).endOf('month').toDate();//previous bdate	//temporary
				//vm.minToDate = angular.copy(vm.financialMonth.date).toDate();
				//vm.maxToDate =  angular.copy(vm.toDate);
				
					

			}else if(value == 'GenerateAfresh'){

				vm.fromDate = angular.copy(vm.currentBusinessDateMoment).startOf('month').toDate();
				vm.toDate =  angular.copy(vm.currentBusinessDateMoment).toDate();
				
				//vm.minToDate = vm.fromDate;
				//vm.maxToDate =  angular.copy(vm.currentBusinessDateMoment).toDate();
				

			}
			
		}

		function loadFinancialMonthOption(){
			vm.previousFiancialMonthOptions = [];
			if(vm.configSettings.billingEndDate!=null && vm.configSettings.billingEndDate !=""){
				vm.previousFiancialMonthOptions.push(createMonthOptions(angular.copy(vm.currentBusinessDateMoment)));	//temporary
			}
			var monthCount =1;
			for(monthCount =1; monthCount <= vm.noOFMonthsToDisplayForReports ;monthCount++) {
				vm.previousFiancialMonthOptions.push(createMonthOptions(angular.copy(vm.currentBusinessDateMoment).subtract(monthCount,'month')))
			}

		}

		vm.createMonthOptions = createMonthOptions;
		function createMonthOptions(dateMoment){
			var currentMonthOption = {}
			currentMonthOption.date =  angular.copy(dateMoment).startOf('month');
			currentMonthOption.monthDisplay = dateMoment.format('MMM - YYYY');
			return currentMonthOption;

		}
		vm.onFinacialMonthSelection = onFinacialMonthSelection;
		function onFinacialMonthSelection(value){
			var monthSelected = value.date; 
			vm.fromDate = angular.copy(monthSelected).toDate();
			vm.toDate  = angular.copy(monthSelected).endOf('month').toDate();
			loadFinancialYearDisplay(vm.fromDate);
			//vm.minToDate = angular.copy(vm.financialMonth.date).toDate();
			//vm.maxToDate =  angular.copy(vm.toDate);

		}
		function loadFinancialYearDisplay(value){
			var yearCount = 0;
			if(vm.financialYearList != null && vm.financialYearList != undefined){
				for(yearCount = 0;yearCount < vm.financialYearList.length; yearCount++){
					var fromYear =  moment(DateUtils.convertLocalDateFromServer(angular.copy(vm.financialYearList[yearCount].financialYearStart)));
					var toYear = moment(DateUtils.convertLocalDateFromServer(angular.copy(vm.financialYearList[yearCount].financialYearEnd))); 
					var financialMonth= moment(angular.copy(value)); 
					if( fromYear.isBefore(financialMonth)&&toYear.isAfter(financialMonth)){
						vm.financialYear=vm.financialYearList[yearCount];
						
					}else{
						vm.financialYear=vm.globalValues.getFinancialYear();
					}
				
			}
		}
	}
		function downloadEInvoice(){
			vm.mimeType = 'application/vnd.ms-excel';
			vm.extension = ".xls"; 
			vm.fileName = vm.eInvoiceChargesfileName;
			OTRSummaryView.downloadEInvoiceExcel({ from : DateUtils.convertLocalDateToServer(vm.fromDate), to: DateUtils.convertLocalDateToServer(vm.toDate),financialYearId :vm.financialYear.id}, processResponse );


         }

		function exportDataToFile(fileType){

			vm.fileName = vm.otrSummaryfileName;
			if( vm.otrSummaryDetails !=null &&  vm.otrSummaryDetails != undefined && vm.otrSummaryDetails.headerList.length > 0){
				if(fileType == 'csv'){
					vm.mimeType = 'text/csv';
					vm.extension =  ".csv";  
					OTRSummaryView.exportOTRSummaryCsv({freshOrPrintOption:vm.selectedPrintorRefresh,bank:vm.selectedBankName },vm.otrSummaryDetails, processResponse );
				}
				else if(fileType == 'xls'){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.extension = ".xls";  
					OTRSummaryView.exportOTRSummaryExcel({freshOrPrintOption:vm.selectedPrintorRefresh,bank:vm.selectedBankName },vm.otrSummaryDetails, processResponse );
				}
				else if(fileType == 'pdf'){
					vm.mimeType = 'application/pdf';
					vm.extension = ".pdf";  
					OTRSummaryView.exportOTRSummaryPdf({freshOrPrintOption:vm.selectedPrintorRefresh,bank:vm.selectedBankName },vm.otrSummaryDetails , processResponse );
				}

			}
		}

		function processResponse(result){        	  
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
			vm.baseString =   vm.fileName + moment().format( vm.reportFileTimestampFormat ) +  vm.extension; 

			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}

		

		$scope.$watch('vm.fromDate',function(value){
			if(value!= undefined && value!=null && (vm.firstTimeLoad != null && vm.firstTimeLoad != undefined)){
				if(vm.freshOrPrintOption == 'PrintGeneratedInvoice'){
					vm.toDate = moment(angular.copy(value)).endOf('month').toDate();
					//vm.maxToDate =  angular.copy(vm.toDate);
					//vm.minToDate = value;
				}else{
					
					if(!moment(value).isAfter(vm.maxDate) && !moment(value).isBefore(vm.minDate)){
						if(vm.currentBusinessDateMoment.isAfter(moment(angular.copy(value)).endOf('month'))){
							vm.toDate = moment(angular.copy(value)).endOf('month').toDate();
							//vm.maxToDate =  angular.copy(vm.toDate);
							//vm.minToDate = value;
						}else{
							vm.toDate = angular.copy(vm.currentBusinessDateMoment).toDate();
							//vm.maxToDate =  angular.copy(vm.toDate);
							//vm.minToDate = angular.copy(vm.currentBusinessDateMoment).startOf('month').toDate();
						}	
					}
				}

			}
			vm.eInvoiceDisable = true;
			vm.firstTimeLoad = 'No';
		});

		$scope.$watch('vm.freshOrPrintOption',function(value){
			if(value!= undefined && value!=null ){				
				setDefaultValue(value);

			}

		});

		$scope.$watch('vm.financialMonth',function(value){
			if(value!= undefined && value!=null ){
				onFinacialMonthSelection(value);
			}
		
		});
		
		function clearAllValues(){
			vm.otrSummaryDetails = null;
			vm.otrSummarySelected = [];
			$scope.filterText = null;
			$scope.filterTextSummary = null;
		}
		


		function getOTRSummaryDetails(otrSummary){
			vm.otrSummarySelected = vm.otrSummaryDetails.bankWiseCustomerDetails[otrSummary.bankChargesDTO.bankName];
			vm.otrSummaryCharges = vm.otrSummaryDetails.detailsListGrandTotalCharges[otrSummary.bankChargesDTO.bankName];

		}
	}
})();
(function () {
    "use strict";

    angular
        .module("gatewayApp")
        .service("workflowSharedService", function () {
            this.viewFrom = "otpConfirmation";
        })

        .controller("OtpConfirmController", OtpConfirmController);

    OtpConfirmController.$inject = [
        "$scope",
        "$state",
        "GlobalValues",
        "mode",
        "$stateParams",
        "$uibModalInstance",
        "$rootScope",
        "CustomerRegistration",
        "globalValue",
        "AlertService",
        "CryptoUtil"
    ];

    function OtpConfirmController(
        $scope,
        $state,
        GlobalValues,
        mode,
        $stateParams,
        $uibModalInstance,
        $rootScope,
        CustomerRegistration,
        globalValue,
        AlertService,
        CryptoUtil
    ) {
        var vm = this;
        vm.mobile = $stateParams.mobile;
        vm.requestId = $stateParams.requestId;
        vm.mobileCountryCode = $stateParams.mobileCountryCode;
        vm.email = $stateParams.email;
        vm.refNo = $stateParams.refNo;
        vm.theme = $stateParams.theme;
        vm.clear = clear;
        vm.verify = verify;
        vm.globalValues = GlobalValues;
        
        vm.wrongOTPAttemptCount = 0;
                vm.platformENCCode = "tV1f3EtXyUjBrf8JbbW7bSYf7JgyxZpVXYJvwAyM34Q=";

        AlertService.info(
            "OTP has been sent to your email id and mobile number"
        );

        $scope.otpInput = {
    			size : globalValue.defaultOTPLength,
    			type : "password",
    			onDone : function(value) {
    				vm.otp = value;
    			},
    			onChange : function(value) {
                    if((value==null || value==undefined || value=='') || (value!=null && value!=undefined && value.length!=parseInt(globalValue.defaultOTPLength))){
                        vm.disableFetch = true;
                    }else{
                        vm.disableFetch = false;
                    }
    				//console.log(value);
    			}
    		};
        
        function verify(){
            if(vm.wrongOTPAttemptCount>=globalValue.maximumOTPWrongAttemptCount){ // check if the wrong otp was entered for 3 or more times 
                AlertService.error("Maximum wrong OTP attempt count is exceeded!<br>Please request for resend OTP.");
            }else if(mode=='customeronboardingwithdrawrequest' || mode=='customeronboardingwithdrawregrequest'){

               // var mobileNo = vm.mobileCountryCode + vm.mobile;
                vm.clicked=true;
                CustomerRegistration.verifyOTP({mobile:vm.mobile, otp: vm.otp,mobileCountryCode:vm.mobileCountryCode}, onMobileVerifySuccess,onMobileVerifyFailure);
              /*       if(result.isVerified){
                        if(mode=='customeronboardingwithdrawrequest' || mode=='customeronboardingwithdrawregrequest'){
                            $rootScope.requestId = vm.requestId;
                            $scope.$emit('withdrawOTPConfirm');
                        }
                        $uibModalInstance.dismiss('cancel');
                    }else{
                        vm.wrongOTPAttemptCount=vm.wrongOTPAttemptCount+1;
                        AlertService.error("The entered OTP is wrong");
                    } */
            } else if (
                mode == "customeronboardingfetchrequest" ||
                mode == "customeronboardingfetchregrequest"
            ) {
                vm.clicked = true;
                CustomerRegistration.verifyOTPAndGetCustomerRegistrationRequest(
                    { requestReferenceNo: vm.refNo, otp: vm.otp },
                    onVerifySuccess,
                    onVerifyFailure
                );
            }

            //     vm.clicked = true;

            // grecaptcha.ready(function () {
            //     grecaptcha
            //         .execute("6LcBaI0sAAAAAFhuGjYAEeHtnqcBulWTFbBsLxBg", {
            //             action: "otp_action"
            //         })
            //         .then(function (token) {
            //             // ✅ DTO
            //             var recaptchaOtpDetailsDTO = {
            //                 recaptchaToken: token,
            //                 sourceType: "verify-otp",
            //                 source: "otp-action",
            //                 requestReferenceNo: vm.refNo,
            //                 otp: vm.otp
            //             };

            //             // ✅ API call
            //             CustomerRegistration.verifyOTPAndGetCustomerRegistrationRequest(
            //                 recaptchaOtpDetailsDTO,
            //                 function (response) {
            //                     vm.clicked = false; // ✅ reset button
            //                     onVerifySuccess(response);
            //                 },
            //                 function (error) {
            //                     vm.clicked = false; // ✅ reset button
            //                     onVerifyFailure(error);
            //                 }
            //             );
            //         })
            //         .catch(function (error) {
            //             console.error("reCAPTCHA error:", error);
            //             vm.clicked = false;
            //         });
            // });
        }
        function onMobileVerifySuccess(result) {
            if (result.isVerified == "VERIFIED") {
                vm.clicked = false;
                if (
                    mode == "customeronboardingwithdrawrequest" ||
                    mode == "customeronboardingwithdrawregrequest"
                ) {
                    $rootScope.requestId = vm.requestId;
                    $scope.$emit("withdrawOTPConfirm");
                }
                $uibModalInstance.dismiss("cancel");
            }
        }
        function onMobileVerifyFailure() {
            vm.wrongOTPAttemptCount = vm.wrongOTPAttemptCount + 1;
            AlertService.error("The entered OTP is wrong");
            vm.clicked = false;
        }

        function onVerifySuccess(result) {
            $rootScope.requestDetailsToDisplay = result;
            $uibModalInstance.close(result);
            vm.clicked = false;
        }

        function onVerifyFailure() {
            vm.disableFetch = false;
            vm.wrongOTPAttemptCount = vm.wrongOTPAttemptCount + 1;
            vm.clicked = false;
        }
        // vm.resendOTP = function resendOTP(){
        //     if(mode=='customeronboardingwithdrawrequest' || mode=='customeronboardingwithdrawregrequest'){
        //         CustomerRegistration.sendOTPToMobileAndEmail({mobile: vm.mobile, mobileCountryCode : vm.mobileCountryCode, email: vm.email}, onResendOTPSuccess, onResendOTPError);
        //     }else if(mode=='customeronboardingfetchrequest' || mode=='customeronboardingfetchregrequest'){
        //         CustomerRegistration.sendOTPForRequestRefNo({requestReferenceNo: vm.refNo}, onResendOTPSuccess, onResendOTPError);
        //     }
        // }

        //Recaptcha Implementaion For Registration For WithDraw
        vm.resendOTP = function resendOTP() {
            if (
                mode == "customeronboardingwithdrawrequest" ||
                mode == "customeronboardingwithdrawregrequest"
            ) {
                // No recaptcha here (unchanged)
                // CustomerRegistration.sendOTPToMobileAndEmail(
                //     {
                //         mobile: vm.mobile,
                //         mobileCountryCode: vm.mobileCountryCode,
                //         email: vm.email
                //     },
                //     onResendOTPSuccess,
                //     onResendOTPError
                // );
                 //  Step 1: Execute reCAPTCHA
                    grecaptcha.ready(function () {
                        grecaptcha
                            .execute(
                                CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey,vm.globalValues.getPlatformENCCode()),
                                {
                                    action: "otp_action"
                                }
                            )
                            .then(function (token) {
                                //  Step 2: Call API with token
                                CustomerRegistration.sendOTPToMobileAndEmail(
                                    {
                                        mobile: vm.mobile,
                                       mobileCountryCode: vm.mobileCountryCode,
                                       email: vm.email,
                                        recaptchaToken: token,
                                        sourceType: "resend-otp",
                                        source: "customer-registration-withdraw"
                                    },
                                    onResendOTPSuccess,
                                    onResendOTPError
                                );
                            })
                            .catch(function (error) {
                                console.error("reCAPTCHA error:", error);
                                vm.disableGenerateOTP = false;
                            });
                    });
            } else if (
                mode == "customeronboardingfetchrequest" ||
                mode == "customeronboardingfetchregrequest"
            ) {
                // Add reCAPTCHA here
                grecaptcha.ready(function () {
                    grecaptcha
                        .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey,vm.platformENCCode), {
                            action: "otp_action"
                        })
                        .then(function (token) {
                            // DTO object
                            var recaptchaOtpDetailsDTO = {
                                requestReferenceNo: vm.refNo,
                                recaptchaToken: token,
                                sourceType: "resend-otp",
                                source: "customer-onboarding-fetch"
                            };

                            CustomerRegistration.sendOTPForRequestRefNo(
                                recaptchaOtpDetailsDTO,
                                onResendOTPSuccess,
                                onResendOTPError
                            );
                        })
                        .catch(function (error) {
                            console.error("reCAPTCHA error:", error);
                        });
                });
            }
        };

        function onResendOTPSuccess() {
            vm.wrongOTPAttemptCount = 0;
            AlertService.info(
                "OTP has been resent to your email id and mobile number"
            );
        }

        function onResendOTPError() {}

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('OrganisationType', OrganisationType);

    OrganisationType.$inject = ['$resource'];

    function OrganisationType ($resource) {
        var resourceUrl =  'api/organisation-type/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'organisationTypesForGlobalApprovalPolicy':{
            	method:'GET',
            	isArray:true,
            	params: {orgId:'@orgId'},
            	url: 'api/get-orgType-for-global-approval-policy/:orgId'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("OrganisationManipulation", OrganisationManipulation);
       
    OrganisationManipulation.$inject = [];

    function OrganisationManipulation() {
    	
    	var service = {
    		checkAndGetGivenObjectListWithOrganisation: checkAndGetGivenObjectListWithOrganisation,
    		checkAndGetGivenObjectListWithOrganisationDTO: checkAndGetGivenObjectListWithOrganisationDTO,
    		checkAndGetOrganisation: checkAndGetOrganisation,
    		checkAndGetOrganisationDTO: checkAndGetOrganisationDTO
    	};
    	return service;
    	
        function checkAndGetGivenObjectListWithOrganisation(inputObjectList){
          	var objectListWithOrganisation = [];
          	
          	inputObjectList.forEach(function(item) {
          		item.organisation = checkAndGetOrganisation(item.organisation);
          		objectListWithOrganisation.push(item);
          	});
          	
          	return objectListWithOrganisation;
          }
          
          function checkAndGetGivenObjectListWithOrganisationDTO(inputObjectList){
          	var objectListWithOrganisationDTO = [];
          	
          	inputObjectList.forEach(function(item) {
          		item.organisation = checkAndGetOrganisationDTO(item.organisation);
          		objectListWithOrganisationDTO.push(item);
          	});
          	
          	return objectListWithOrganisationDTO;
          }
          
          function checkAndGetOrganisation(organisationDTO){
        	if (organisationDTO == null){
        		return null;
        	}
        	else if (organisationDTO.corporate != null){
          		return organisationDTO.corporate;
          	} 
        	else if (organisationDTO.customer != null){
          		return organisationDTO.customer;
          	} 
        	else if (organisationDTO.bank != null){
          		return organisationDTO.bank;
          	} 
        	else if (organisationDTO.clearcorp != null){
          		return organisationDTO.clearcorp;
          	} 
          	else{
          		return organisationDTO.consultant;
          	}
          }
          
          function checkAndGetOrganisationDTO(organisation){
          	var organisationDTO = {}
          	
          	if (organisation.organisationType.shortName == "CLEARCORP"){
          		organisationDTO.clearcorp = organisation;
          	} 
          	else if (organisation.organisationType.shortName == "BANK"){
          		organisationDTO.bank = organisation;
          	}
          	else if (organisation.organisationType.shortName == "CUSTOMER"){
          		organisationDTO.customer = organisation;
          	}
          	else{
          		organisationDTO.consultant = organisation;
          	}
          	
          	return organisationDTO;
          }
    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('OrganisationDialogController', OrganisationDialogController);

    OrganisationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Organisation'];

    function OrganisationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Organisation) {
        var vm = this;

        vm.organisation = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.organisation.id !== null) {
                Organisation.update(vm.organisation, onSaveSuccess, onSaveError);
            } else {
                Organisation.save(vm.organisation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('gatewayApp:organisationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('OrganisationDetailController', OrganisationDetailController);

    OrganisationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Organisation'];

    function OrganisationDetailController($scope, $rootScope, $stateParams, previousState, entity, Organisation) {
        var vm = this;

        vm.organisation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('gatewayApp:organisationUpdate', function(event, result) {
            vm.organisation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('OrganisationDeleteController',OrganisationDeleteController);

    OrganisationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Organisation'];

    function OrganisationDeleteController($uibModalInstance, entity, Organisation) {
        var vm = this;

        vm.organisation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Organisation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('Organisation', Organisation);

    Organisation.$inject = ['$resource'];

    function Organisation ($resource) {
        var resourceUrl =  'api/organisations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('OrganisationController', OrganisationController);

    OrganisationController.$inject = ['$scope', '$state', 'Organisation', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OrganisationController ($scope, $state, Organisation, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Organisation.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.organisations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
	'use strict';
	angular
		.module('gatewayApp')
		.service("workflowSharedService", function () {
			this.viewFrom = 'OrderConfirmation'
		})
		.controller('OrderUploadConfirmationStatusController', OrderUploadConfirmationStatusController);
	OrderUploadConfirmationStatusController.$inject = ['$scope', '$state', '$rootScope', '$uibModalInstance', 'entityConstants', '$stateParams', 'screenInfo', 'Market','ExportFile','GlobalValues','MessageBox','AlertService', '$filter','$timeout','workflowSharedService'];

	function OrderUploadConfirmationStatusController($scope, $state, $rootScope, $uibModalInstance, entityConstants, $stateParams, screenInfo, Market,ExportFile,GlobalValues,MessageBox,AlertService, $filter,$timeout,workflowSharedService) {
		var vm = this;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.ORDER_CONFIRMATION;
		vm.ScreenInfo = screenInfo;
		vm.globalValues = GlobalValues;
		$scope.noOfRecordsPerPage = vm.globalValues.getNoOfRecordsPerPageInPagination();
		vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
		vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
		vm.clear = clear;
		vm.exportDataToExcelFile = exportDataToExcelFile;
		vm.orderDTOList = $stateParams.orderDTOList;
		vm.tableName = 'orderUploadConfirmationStatus';
		vm.splitOrderConfirmationfileName = "Split_Order_Confirmation_Report";
		vm.splitOrderfileName = "Split_Order_Status_Report";
		vm.bulkOrderfileName = "Bulk_Order_Status_Report";
		vm.bulkOrderConfirmationfileName = "Bulk_Order_Confirmation_Report";
		vm.submitplaceOrder = submitplaceOrder;
        vm.viewFrom=workflowSharedService.viewFrom;

		
		
		 if(vm.viewFrom == 'OrderUpload'){
		 	/*if (vm.ScreenInfo == "OrderConfirmation") {
				$timeout(function() {
					exportDataToExcelFile();
				}, 1000);
				
		 	}*/
		}
		if(vm.ScreenInfo == 'OrderSubmission'){
			placeAllOrder(vm.orderDTOList);
			
		}


	
		
		//click the submit order button in order confirmation screen call split order screen   
		function submitplaceOrder() {
			if (vm.orderDTOList != null && vm.orderDTOList != undefined) {
				$uibModalInstance.dismiss('cancel');
				if(workflowSharedService.viewFrom == 'OrderUpload'){
					
					$state.go('order-upload-status', { orderDTOList: vm.orderDTOList }).catch(function (error) {
						// if error occurs go to create state
						$state.go('order-upload-status', { orderDTOList: vm.orderDTOList });
					})
				}else if(workflowSharedService.viewFrom == 'SplitOrder'){
					
					$state.go('split-order-status', { orderDTOList: vm.orderDTOList }).catch(function (error) {
						// if error occurs go to create state
						$state.go('split-order-status', { orderDTOList: vm.orderDTOList });
					})
				}
				
			}
		}

		function placeAllOrder(orderDTOList) {
			console.time("BulkOrder");
			var promises = orderDTOList.map(function(orderDTO) {
				if (orderDTO.uploadStatus === 'SUCCESS') {
				return makeMarketOrder(orderDTO)
				.then(function(result) {
					onOrderSucess(orderDTO, result);
				})
				.catch(function(error) {
				  onOrderFailure(orderDTO, error);
				});
			} else {
				onOrderFailure(orderDTO, null);
			  }
			});
			return Promise.all(promises)
			  .then(function() {
				console.timeEnd("BulkOrder");
				$timeout(function() {
				  onPlaceOrderSuccess();
				  exportDataToExcelFile();
				  AlertService.success($filter('translate')('gatewayApp.orderUploadConfirmationStatus.orderSubmitted'));
				}, 1000);
			  });
		  }

		function makeMarketOrder(orderDTO) {
			return new Promise( function(resolve, reject) {
				Market.placeOrder(orderDTO, resolve, reject);
			});
		}
		function onOrderSucess(orderDTO, result) {
			angular.forEach(vm.orderDTOList, function (item) {
				if (item.SystemUniqueSNo === orderDTO.SystemUniqueSNo) {
					item.orderSubmission = 'SUCCESS';
					 return;
				}
			});
			//onPlaceOrderSuccess();
		}

		function onOrderFailure(orderDTO, result) {
			angular.forEach(vm.orderDTOList, function (item) {
				if (item.SystemUniqueSNo === orderDTO.SystemUniqueSNo) {
					item.orderSubmission = 'FAILED';
					return;
				}
			});
			//onPlaceOrderSuccess();
		}

		function onPlaceOrderSuccess() {

			$rootScope.orderPlacedSuccessCount = 0;
			$scope.$emit('orderplacedsuccess');
			//$uibModalInstance.close(result);

		}

		function exportDataToExcelFile(){
			var pageNo=1;
			$scope.noOfRecordsPerPage=vm.orderDTOList.length;
			if(workflowSharedService.viewFrom == 'OrderUpload'){
				if (vm.ScreenInfo == "OrderConfirmation") {
					ExportFile.exportFile('excel',vm.tableName,vm.orderDTOList.length,$scope.noOfRecordsPerPage,undefined,pageNo,vm.bulkOrderConfirmationfileName,undefined,undefined,undefined);
				} else {
					ExportFile.exportFile('excel',vm.tableName,vm.orderDTOList.length,$scope.noOfRecordsPerPage,undefined,pageNo,vm.bulkOrderfileName,undefined,undefined,undefined);	
				}
			}else if(workflowSharedService.viewFrom == 'SplitOrder'){
				if (vm.ScreenInfo == "OrderConfirmation") {
				ExportFile.exportFile('excel',vm.tableName,vm.orderDTOList.length,$scope.noOfRecordsPerPage,undefined,pageNo,vm.splitOrderConfirmationfileName,undefined,undefined,undefined);
				}else{
					ExportFile.exportFile('excel',vm.tableName,vm.orderDTOList.length,$scope.noOfRecordsPerPage,undefined,pageNo,vm.splitOrderfileName,undefined,undefined,undefined);
				}
			}
		}

		function clear() {
			if(vm.ScreenInfo== 'OrderConfirmation'){
				onPlaceOrderSuccess();
				MessageBox.openMessageBox("Alert", "Orders will not been submitted..! Are you sure to cancel?", "YesNo", "splitOrderConfirmationClear");
			
			}else{
				
				$uibModalInstance.dismiss('cancel');
			}
		}
		$rootScope.$on('gatewayApp.messagebox.yes.splitOrderConfirmationClear', function (event, data) {
				$uibModalInstance.dismiss('cancel');
			});

			 $rootScope.$on('gatewayApp.messagebox.no.splitOrderConfirmationClear', function (event, data) {
				//do nothing
			});

	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('order-upload', {
            parent: 'entity',
            params:{screen: 'OrderUpload'}, 
            url: '/order-upload',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.orderUpload.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order-upload/order-upload.html',
                    controller: 'OrderUploadController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('orderUpload');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('order-upload-confirmation', {
            parent: 'order-upload',
            url: '/order-upload-confirmation',
            params: {orderDTOList:[]},
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function($stateParams, $state, $uibModal,$rootScope) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-upload-confirmation-status/order-upload-confirmation-status.html',
                    controller: 'OrderUploadConfirmationStatusController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function(){
                        	
                        },
                        systemTime: ['Market',  function(Market ) {
         					return   Market.getCurrentDateTime().$promise;
                         }],
                         screenInfo : function(){
                            return "OrderConfirmation";
                        },
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('orderUploadConfirmationStatus');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('order-upload-status', {
            parent: 'order-upload',
            url: '/order-upload-status',
            params: {orderDTOList:[]},
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function($stateParams, $state, $uibModal,$rootScope) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-upload-confirmation-status/order-upload-confirmation-status.html',
                    controller: 'OrderUploadConfirmationStatusController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function(){
                        	
                        },
                        systemTime: ['Market',  function(Market ) {
         					return   Market.getCurrentDateTime().$promise;
                         }],
                         screenInfo : function(){
                            return "OrderSubmission";
                        },
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('orderUploadConfirmationStatus');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
         
        
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('OrderUpload', OrderUpload);

        OrderUpload.$inject = ['$resource'];

    function OrderUpload ($resource) {
        var resourceUrl =  '';
        
        return $resource(resourceUrl, {}, {
        	
              
                 'downloadOrderTemplate':{
     				method: 'GET',
     				url: 'api/order-upload-template-download',
     				 responseType: 'arraybuffer',
     				  transformResponse: function(data, headers) {
     	              	  return {
     	                        data: data,
     	                        headers: headers
     	                    };   
     	                } 
                 }
          
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {
        	this.viewFrom= 'OrderUpload'
        })

        .controller('OrderUploadController', OrderUploadController);

    OrderUploadController.$inject = ['$scope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
    				'MessageBox','$rootScope','OrderUpload','AlertService','$filter', '$window','FileUtil','OrderUtil','CustomerBankRelationshipReport','MarketWatch',
					'ExposureType','ExposureSubType','DefaultMarket','DateUtils','StaticLookUp','HolidayReport','IntradayMarket','Principal','SwapQuotesForTenorDates','$timeout',
					'TACViewForEntitiesService','UserProfile','Market','CurrencyPair'];

    function OrderUploadController($scope, $state , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
    				MessageBox,$rootScope,OrderUpload, AlertService, $filter, $window,FileUtil,OrderUtil,CustomerBankRelationshipReport,MarketWatch,
					ExposureType,ExposureSubType,DefaultMarket,DateUtils,StaticLookUp,HolidayReport,IntradayMarket,Principal,SwapQuotesForTenorDates,$timeout,
					TACViewForEntitiesService,UserProfile,Market,CurrencyPair) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.ORDER_UPLOAD;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.orgId = vm.globalValues.getOrgId();
        vm.clicked = false;
        vm.organisation = vm.globalValues.getOrganisation().organisationType.shortName;
        vm.uploadOrderFile = uploadOrderFile;
        vm.downloadOrderTemplate = downloadOrderTemplate;
        workflowSharedService.viewFrom = "OrderUpload";
		vm.invalidFileText = 'Invalid File.!';
		vm.invalidFile = false;
		vm.orderUploadList = [];
		$rootScope.maxForwardTenorDate = null;
		vm.exposureType = null;
		vm.exposureSubType = null;
		vm.configSettings = vm.globalValues.getConfigSettings();
		$rootScope.noOfDecimalsForRateForOrder = vm.globalValues.getNumberOfDecimalsForRate();
        $rootScope.noOfDecimalsForAmountForOrder = vm.globalValues.getNumberOfDecimalsForAmount();
        $rootScope.noOfDecimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
		$rootScope.tradeSettlementDateFrom = "";
		$rootScope.tradeSettlementDateFororder = "";
		//get source App
         $rootScope.sourceApp = StaticLookUp.getSourceAppList();
		var buySellMap = {
			'BUY': 'BUYY',
			'SELL': 'SELL'
		};
		var typeOfOrders = {
			"LIMIT":"LIMT",
			"MARKET":"MRKT"
		};
		var timeLimitIndicators = {
			"DAY" : "DAYY",
			"IOC" : "IOCC",
			"GTT" : "GTTM"
		};
		IntradayMarket.getCurrentBusinessDate(function(result){
			vm.currentDate = result.businessDate;
			vm.currentDate = DateUtils.convertLocalDateToServer(vm.currentDate);
			IntradayMarket.getMarketSessionSettings({"currentBusinessDate":vm.currentDate}, function(result){
				$rootScope.marketSessionSettings = result;

				setMarketSettings();
			});
		});

		setUsers();
        function setUsers() {
            if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
                vm.loggedInCustomer = vm.globalValues.getCustomer();

           }
           if(vm.entityOwnerType=='Bank' || vm.entityOwnerType=='Branch'){
               vm.bank = vm.globalValues.getBank();
           }
           if(vm.entityOwnerType=='Branch'){
               vm.branch = vm.globalValues.getBranch();
           }

        }
		vm.allTradingBanks=CustomerBankRelationshipReport.query();

		vm.bankCurrencyPairConfiguration=CustomerBankRelationshipReport.getBankCurrencyPairConfiguration();

		vm.applicableInstruments = CustomerBankRelationshipReport.getApplicableInstruments();

		vm.currencyPairList = CurrencyPair.query();

		DefaultMarket.marketInstruments(function(result) {
			vm.instrumentTypes = result;
		DefaultMarket.csInstruments({currencyPairId: vm.globalValues.getDefaultCurrencyPairId()},onGetInstrumentSuccess, onGetInstrumentFailure);
		});
                 

function onGetInstrumentSuccess(result) {
    vm.instrumentTypes = result;


angular.forEach(vm.instrumentTypes, function (value) {

    if (value.baseCurrency === 'USD') {

        // USD → single object
        switch (value.instrumentCode) {
            case 'SPOT':
                $rootScope.currencies.usd.spot = value.tickSize;
                break;
            case 'CASH':
                $rootScope.currencies.usd.cash = value.tickSize;
                break;
            case 'TOM':
                $rootScope.currencies.usd.tom = value.tickSize;
                break;
            case 'InterbankSPOT':
                $rootScope.currencies.usd.ibSpot = value.tickSize;
                break;
            case 'Forward':
                $rootScope.currencies.usd.forward = value.tickSize;
                break;
        }

    } else {
        // OTHER currencies → keyed by tokenSequenceNumber
        var token = value.tokenSequenceNumber;
        if (!token) return;

        if (!$rootScope.currencies.other[token]) {
            $rootScope.currencies.other[token] = {
                currency: value.baseCurrency,
                spot: 0,
                cash: 0,
                tom: 0
            };
        }

        switch (value.instrumentCode) {
            case 'SPOT':
                $rootScope.currencies.other[token].spot = value.tickSize;
                break;
            case 'CASH':
                $rootScope.currencies.other[token].cash = value.tickSize;
                break;
            case 'TOM':
                $rootScope.currencies.other[token].tom = value.tickSize;
                break;
        }
    }
});
            // get tick size for each instrument
}

		function onGetInstrumentFailure() {

        }




		ExposureType.getAllExposureTypes(function(result) {
			vm.exposureTypes = result;
		});
		ExposureSubType.getAllExposureSubTypes(function(result) {
			vm.exposureSubTypes = result;
		});
		StaticLookUp.getEventTypeList(function(result){
			$rootScope.eventTypes = result;
		});
		Principal.identity().then(function(account) {
			vm.account =  account;
		if(vm.account.organisation.organisationType.shortName=='BANK'){
			SwapQuotesForTenorDates.getSwapQuotesForGivenBank({bankId: vm.account.organisation.id}, onGetSwapQuotesSuccess, onGetSwapQuotesFailure);
		}else if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
			SwapQuotesForTenorDates.getSwapQuotesForGivenCustomer({customerId: vm.account.organisation.id}, onGetSwapQuotesSuccess, onGetSwapQuotesFailure);
			TACViewForEntitiesService.getCustomerAgreedTACList({customerId : account.organisation.id}, function(result){
				$rootScope.agreedTACList = result;
			});
		}
		UserProfile.get({userId: vm.account.id}, onGetUserSpecSettingSuccess, onGetUserSpecSettingFailure)
	});
		function onGetSwapQuotesSuccess(result){
			if(result!=null && result!=undefined && result.swapQuotesTenorDateDTOList!=null && result.swapQuotesTenorDateDTOList!=null
                && result.swapQuotesTenorDateDTOList.length>0){

        		$rootScope.bankComparativeDTO = result;
				prepareSwapQuotes();
				}

		}
		function onGetSwapQuotesFailure(){

		}
		function prepareSwapQuotes(){
            if($rootScope.bankComparativeDTO!=null && $rootScope.bankComparativeDTO!=undefined
                && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList!=null
                && $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList.length==1){
                $rootScope.defaultBankSpread = $rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList[0].swapQuotesForTenorDatesList;
            }

        }

		// set market settings
        function setMarketSettings(){
        	angular.forEach($rootScope.marketSessionSettings, function(value){

				if(value.baseCurrency=='USD'){

					if(value.instrumentCode == 'SPOT'){
        	 	$rootScope.retailSpotMarketSession = value;
        		 }else if(value.instrumentCode == 'TOM'){
        	 	$rootScope.tomMarketSession = value;
        		 }else if(value.instrumentCode == 'CASH'){
        		 	$rootScope.cashMarketSession = value;
        		 }else if(value.instrumentCode == 'Forward'){
                     $rootScope.forwardMarketSession = value;
                 }

				}
				else{
				 $rootScope.marketSessionMap.set(value.tokenSequenceNumber,value);
				}
        	})
        }

		StaticLookUp.getTenorsForLookup(onGetTenorLookupSuccess, onGetTenorLookupFailure);
		StaticLookUp.getTenorsWithBrokenDate(onGetTenorSuccess, onGetTenorFailure);
		Market.getMarketDepth(onGetMarketDepthSuccess, onGetMarketDepthFailure);
		Market.getDailyClosingPrice(onGetLtpForLimitSuccess, onGetLtpForLimitFailure);
		function onGetTenorLookupSuccess(result){
			vm.tenorsLookup = result;
            vm.tenor = result[0];
            $timeout(function() {
                vm.tradeSettlementDate = new Date(vm.tenor.settlementDate);
				$rootScope.tradeSettlementDateFororder = vm.tradeSettlementDate;
            }, 100);
            $rootScope.tenor = vm.tenor;
        }

        function onGetTenorLookupFailure(){

        }
		function onGetTenorSuccess(result){
            vm.tenors = result;
            $rootScope.tenors = result;
            if(vm.tenors!=null && vm.tenors!=undefined && vm.tenors.length>0){
                vm.maxTenorDate = new Date(vm.tenors[vm.tenors.length-1].settlementDate);
                $rootScope.maxTenorDate = vm.maxTenorDate;
            }
        }

        function onGetTenorFailure(){

        }
		function onGetUserSpecSettingSuccess(result){
        	vm.userPreference = result;
        	$rootScope.userPreference = result;
		}
		function onGetUserSpecSettingFailure(){

		}
		function onGetMarketDepthSuccess(result){
        	if($rootScope.marketDepth==null || $rootScope.marketDepth==undefined){
            	$rootScope.marketDepth = result;
        	}
        	// get market depth for IB SPOT
			$rootScope.ibSpotMarketDepth = MarketWatch.getIBSpotMarketDepth($rootScope.marketDepth);

        }
		function onGetMarketDepthFailure(){

        }
		function onGetLtpForLimitSuccess(result){
        	vm.ltpForLimitsForAllInstrument = result;
        	angular.forEach(vm.ltpForLimitsForAllInstrument, function(value){
        		if(value.instrument.instrumentCode=='SPOT'){
        			$rootScope.previousDayClosingPriceForSpot = value.lastTradeExchangeRate;
        		}else if(value.instrument.instrumentCode=='InterbankSPOT'){
        			$rootScope.previousDayClosingPriceForIbSpot = value.lastTradeExchangeRate;
        		}
        	})

        }

        function onGetLtpForLimitFailure(){

        }


        logScreenAccess();

        function getExpirtyTime(){
           Market.getCurrentDateTime(function (result){
			vm.currentDateTime = moment.parseZone(result.currentDateTime);
		});
	}

       function uploadOrderFile() {
		vm.clicked=true;
		Market.getCurrentDateTime(function (result){
			vm.currentDateTime = moment.parseZone(result.currentDateTime);
			//once get the real time then validate the order
			prepareAndValidateOrderUpload(vm.orderUploadList);
		});

       }


       function downloadOrderTemplate() {
    	   var mimeType= '';
    	   var baseString =   'Bulk_Order_'+  moment().format( 'DD_MMM_YYYY_HH_mm') + '.xlsx';
    	   OrderUpload.downloadOrderTemplate(function(result){

    		   if(result.data != null && result.data != undefined && result.data.byteLength != 0){

    			   vm.certificateFile = result.data;

    				      var IEFile = new Blob([result.data], {type: mimeType});

    				     if(window.navigator.msSaveOrOpenBlob) {
    		                   window.navigator.msSaveOrOpenBlob(IEFile, baseString );
    		               }

    				      else{

    				    	  var link = document.createElement("a");
    	    	   			  var bytes = new Uint8Array( vm.certificateFile );

    	    				      var blob = new Blob([bytes], {type: mimeType});
    	    				      link.href =  window.URL.createObjectURL(blob);

    	    				      link.download = baseString;
    	        	   		   	  document.body.appendChild(link);
    	        	   		   	  link.click();
    	        	   			  document.body.removeChild(link);

    				      }

    		   }
    		   else{
    			   AlertService.error($filter('translate')('gatewayApp.orderUpload.fileNotExists'));
    		   }



    	   })
       }

       $scope.$watch('vm.orderUpload', function(value){
    	   if(vm.orderUpload != null && vm.orderUpload != undefined){
			if(vm.orderUpload.name != null && vm.orderUpload.name != undefined && validatefileNameScriptContent(vm.orderUpload.name)){
    			   vm.inputFile = vm.orderUpload.name;
    	    		 vm.fileExtension =  vm.inputFile.substring(vm.orderUpload.name.lastIndexOf(".") + 1);
    	    		 if(vm.fileExtension  != 'xls' && vm.fileExtension  != 'xlsx'){
						MessageBox.openMessageBox('Alert', $filter('translate')('gatewayApp.orderUpload.invalidFile'), 'Ok', 'fileInvalid');
    	    		 }else{
						var reader = new FileReader();
						reader.readAsArrayBuffer(value);
						reader.onload = function(e) {
						 var data = new Uint8Array(e.target.result);
						 vm.orderUploadList  = FileUtil.parseExcelFile(data);
						 // check column count
						if(validateExistColumnCount(vm.orderUploadList[0]) < 21){
							MessageBox.openMessageBox('Alert', $filter('translate')('gatewayApp.orderUpload.invalidFile'), 'Ok', 'fileInvalid');

						}
						// check row count
						else if(vm.orderUploadList.length > 101){
							MessageBox.openMessageBox('Alert', $filter('translate')('gatewayApp.orderUpload.fileRowCountInvalid'), 'Ok', 'fileInvalid');
						}
						};
                }

    		   }else{
				        vm.orderUpload = null;
    	    			 vm.inputFile = null;
						 vm.invalidFile = false;
			   }
    	   }
		   else{
			vm.orderUpload = null;
			 vm.inputFile = null;
			 vm.invalidFile = false;
   }
       })
	   function validateExistColumnCount(columns){
		return columns.filter(Boolean).length;
	   }

	   $rootScope.$on('gatewayApp.messagebox.ok.fileInvalid', function (event) {
				angular.element("input[type='file']").val(null);
    	    	vm.orderUpload = null;
    	    	vm.inputFile = null;
	  });


       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }


	   function prepareAndValidateOrderUpload(orderDTOList){
		vm.orderDTOList = [];
    	for(var i=1;i<orderDTOList.length;i++){
			vm.orderRequestDTO = orderDTOList[i];
			vm.importErrorString = "";
			if(vm.orderRequestDTO!=null && vm.orderRequestDTO!='' && vm.orderRequestDTO!=""){
				vm.orderDTO={};
				vm.orderDTO.SystemUniqueSNo = i;
				if(validateExistColumnCount(vm.orderRequestDTO)>=2){
					/// validation 1
				validateDataFields();
				 if(vm.importErrorString==""){
					prepareOrderDTOAfterValidation();
					/// validation 2
					validateOrder();

					setSpreadValues();

				 }
				}else{
					vm.importErrorString += "Invalid column count";
				}

				vm.orderDTO.exceptionMessage = vm.importErrorString;

				vm.importErrorString=="" ? vm.orderDTO.uploadStatus = 'SUCCESS' : vm.orderDTO.uploadStatus = 'FAILED' ;
				prepareOrderDTOAfterValidation();
				// clear values after each order validation
				clearValues();
			}
			vm.orderDTOList.push(vm.orderDTO);
		}
		// dialog screen show after order validation
		if(vm.userPreference.showOrderConfirmationForBulkOrder=='no'){
			$state.go("order-upload-status",{orderDTOList:vm.orderDTOList});
			angular.element("input[type='file']").val(null);
			vm.orderUpload = null;
    	    vm.inputFile = null;
			vm.clicked=false;
		}else if(vm.userPreference.showOrderConfirmationForBulkOrder=='yes'){
			$state.go("order-upload-confirmation",{orderDTOList:vm.orderDTOList});
			angular.element("input[type='file']").val(null);
			vm.orderUpload = null;
    	    vm.inputFile = null;
			vm.clicked=false;
		}
	   }

		function clearValues() {
			$rootScope.defaultBankSpread = "";
			$rootScope.tradeSettlementDateFrom = "";
			$rootScope.tradeSettlementDateFororder = "";
			$rootScope.tenor = null;
			vm.exposureSubType = null;
			vm.exposureType = null;

		}

		function validateOrder() {

			 if (vm.orderDTO != null) {
    // for (var i = 0; i < $rootScope.currencyPairList.length; i++) {
    //     var cp = $rootScope.currencyPairList[i];
    //     if (cp.code == vm.orderDTO.currencyPair) {
    //         $rootScope.currencyPairForOrder = cp;
    //         vm.orderDTO.currencyPairId = cp.id;
    //         break; // ✅ stops loop immediately
    //     }
    // }

	for(var i=0;i<$rootScope.instrumentTypes.length;i++){
		var instrument = $rootScope.instrumentTypes[i];
		if(instrument.currencyPair.code == vm.orderDTO.currencyPair && instrument.instrumentCode == vm.orderDTO.instrumentCode){
			 $rootScope.currencyPairForOrder = instrument.currencyPair;
			vm.orderDTO.currencyPairId = instrument.currencyPair.id;
			vm.orderDTO.tokenSequenceNumber = instrument.tokenSequenceNumber;
			vm.orderDTO.instrumentId = instrument.id;
			vm.orderDTO.currencyPairCode = instrument.currencyPair.code;
			break;
		}
		
	}
}


        	vm.transactionParametersSettings = vm.globalValues.getTransactionParametersSettings();

			$rootScope.transactionParametersSettingsForOrder = vm.transactionParametersSettings;
			$rootScope.configurationSettingsForOrder = angular.copy(vm.configSettings);
			$rootScope.userPreferenceForOrder = angular.copy(vm.userPreference);
			validateMarketOrder(vm.orderDTO.typeOfOrder);
			var validateSettlementDate = OrderUtil.validateSettlementDate(vm.orderDTO.instrumentCode, vm.orderDTO.isOptionPeriod, vm.orderDTO.tradeSettlementDate, 'Settlement');
			var validateOptionStartSettlementDate = OrderUtil.validateOptionSettlementDate(vm.orderDTO.instrumentCode, vm.orderDTO.isOptionPeriod, vm.orderDTO.tradeSettlementDateFrom, 'Start');
			var validateOptionEndSettlementDate = OrderUtil.validateOptionSettlementDate(vm.orderDTO.instrumentCode, vm.orderDTO.isOptionPeriod, vm.orderDTO.tradeSettlementDateTo, 'End');
			var validateOptionPeriods = OrderUtil.validateOptionPeriods(vm.orderDTO.instrumentCode, vm.orderDTO.isOptionPeriod, vm.orderDTO.tradeSettlementDateFrom, vm.orderDTO.tradeSettlementDateTo);
			var vadliteSessionStatus = OrderUtil.validateSessionStatus(vm.orderDTO.instrumentCode);
			var validateAgreedTAC = OrderUtil.validateAgreedTAC(vm.bankForTrading);
			var validateOrderAmount = OrderUtil.validateOrderAmount(vm.orderDTO.orderAmount);
			var validateLimitExchangeRateHardCheck = OrderUtil.validateLimitExchangeRateHardCheck(vm.orderDTO.buySellIndicator, vm.orderDTO.typeOfOrder, null, vm.orderDTO.instrumentCode, vm.orderDTO.activityIndicator,
			vm.orderDTO.orderAmount, null, vm.orderDTO.limitExchangeRate, vm.orderDTO.limitExchangeRateInSpot, null, null, null, null,vm.orderDTO.currencyPair,vm.orderDTO.currencyPairId,vm.orderDTO.tokenSequenceNumber);
			var validateOrderDTOIsNull = OrderUtil.validateOrderDTOIsNull(vm.orderDTO);
			//validate spread uses if only settlement dates are valid
			if(validateSettlementDate.isValid && validateOptionStartSettlementDate.isValid && validateOptionEndSettlementDate.isValid){
				var validateSpreadUsed = OrderUtil.validateSpreadUsed($rootScope.defaultBankSpread, vm.orderDTO.instrumentCode, vm.orderDTO.buySellIndicator);
				if (!validateSpreadUsed.isValid) {
					vm.importErrorString += validateSpreadUsed.errorString + ";";
				}
			}
			if (!validateSettlementDate.isValid) {
				vm.importErrorString += validateSettlementDate.errorString + ";";
			}
			if (!validateOptionStartSettlementDate.isValid) {
				vm.importErrorString += validateOptionStartSettlementDate.errorString + ";";
			}
			if (!validateOptionEndSettlementDate.isValid) {
				vm.importErrorString += validateOptionEndSettlementDate.errorString + ";";
			}
			if (!validateOptionPeriods.isValid) {
				vm.importErrorString += validateOptionPeriods.errorShortString + ";";
			}
			if (!vadliteSessionStatus.isValid) {
				vm.importErrorString += vadliteSessionStatus.errorString + ";";
			}
			if (!validateAgreedTAC.isValid) {
				vm.importErrorString += validateAgreedTAC.errorString + ";";
			}
			if (!validateOrderAmount.isValid) {
				vm.importErrorString += validateOrderAmount.errorShortString + ";";
			}
			if (!validateLimitExchangeRateHardCheck.isValid) {
				vm.importErrorString += validateLimitExchangeRateHardCheck.errorShortString + ";";
			}
			if(!validateOrderDTOIsNull.isValid){
				vm.importErrorString += validateOrderDTOIsNull.errorShortString + ";";
			}

		}

		function validateDataFields() {
			validateSerialNumber(vm.orderRequestDTO[0]);
			validateCustomer(vm.orderRequestDTO[1]);
			validateRelationshipBank(vm.orderRequestDTO[2]);
			validateAndSetInstrument(vm.orderRequestDTO[3], vm.orderRequestDTO[5]);
			vm.orderDTO.activityIndicator = 'PLAC';
			validateBuySellIndicator(vm.orderRequestDTO[4]);
			vm.orderDTO.currencyPair = vm.orderRequestDTO[5];
			if (vm.orderDTO.currencyPair == "") {
				vm.importErrorString += "Currency Pair cannot be empty;";
			}
			validateOrderType(vm.orderRequestDTO[6], vm.orderRequestDTO[5]);
			validateOrderAmount(vm.orderRequestDTO[7]);
			validateLimitExchangeRate(vm.orderRequestDTO[8]);
			validateTimeLimitIndicator(vm.orderRequestDTO[9]);
			vm.orderDTO.tradeSettlementDate = vm.orderRequestDTO[11];
			vm.orderDTO.forwardType = vm.orderRequestDTO[14];
			vm.orderDTO.tradeSettlementDateFrom = vm.orderRequestDTO[15];
			vm.orderDTO.tradeSettlementDateTo = vm.orderRequestDTO[16];
			validateForwardInstrument(vm.orderDTO.forwardType);
			vm.orderDTO.userId = vm.globalValues.getUserId();
			vm.orderDTO.retailUserCode = vm.globalValues.getUser().login;
			vm.orderDTO.userEntityOwnerId = vm.globalValues.getEntityOwnerTypeId();
			vm.orderDTO.stopExchangeRate = 0;
			validateRemarks(vm.orderRequestDTO);
			 var sourceApp = getSourceApp('FXRETAIL');
            vm.orderDTO.sourceAppId = sourceApp.id;
            vm.orderDTO.sourceAppName = sourceApp.name;
			vm.orderDTO.deliveryMode = '';
            vm.orderDTO.settlementIFSCCode = '';
            vm.orderDTO.noOfTrades = 0;
            vm.orderDTO.tradeTotalPrice = 0;
			validateBasedOnCurrencyPair(vm.orderRequestDTO[5], vm.orderRequestDTO[2]);

		}

		function validateBasedOnCurrencyPair(currencyPair, ngCode) {
			if(currencyPair != ""){
				validateCurrencyPair(currencyPair);

				validateCurrencyPairByBank(currencyPair,ngCode);
			}
		}

		function validateCurrencyPairByBank(currencyPair,ngCode) {

			if(currencyPair != "" && ngCode !=""){

			var normalizedPair = currencyPair.replace("/", "").toUpperCase();
			var isConfigured = false;

			angular.forEach(vm.bankCurrencyPairConfiguration, function(value){
			   if(value.bank.ngCode == ngCode.toUpperCase()  && value.currencyPair.code==normalizedPair ){
				isConfigured =true;
			   }
		   });

		   if (!isConfigured) {
               vm.importErrorString += "Currency pair is not applicable for the bank;";
            }
		 }

		}

		function validateCurrencyPair(currencyPair) {

			var normalizedPair = currencyPair.replace("/", "").toUpperCase();
			var isConfigured = false;

			angular.forEach(vm.currencyPairList, function(value){
			   if(value.code == normalizedPair){
				   isConfigured =true;
				   vm.orderDTO.currencyPair = normalizedPair;
			   }
		   });

		   if (!isConfigured) {
               vm.importErrorString += "Currency pair is not configured;";
            }

		}

		function getSourceApp(sourceAppName){
            var sourceApp = {};
            angular.forEach($rootScope.sourceApp, function(value){
                if(value.shortName==sourceAppName){
                    sourceApp = value;
                }
            })
            return sourceApp;
        }

		function validateMarketOrder(typeOfOrder){
			if(typeOfOrders.MARKET.match(typeOfOrder)){
				if(vm.configSettings.isAllowMarketOrder!='Yes'){
					vm.importErrorString += "Market Order is not allowed;";
				}
			}
		}
		function setSpreadValues() {
			if (vm.orderDTO.instrumentCode != 'SPOT' && vm.orderDTO.currencyPair == 'USDINR') {
				var tickSize = OrderUtil.gettickSizeForGivenInstrument(vm.orderDTO.instrumentCode);

				vm.spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, vm.orderDTO.instrumentCode, vm.orderDTO.buySellIndicator,
					DateUtils.convertLocalDateToServer(getSettlementDate(vm.orderDTO.instrumentCode, vm.orderDTO.buySellIndicator, vm.orderDTO.tradeSettlementDateFrom, vm.orderDTO.tradeSettlementDateTo)), $rootScope.retailSpotMarketSession.settlementDate,
					tickSize);
				if (vm.orderDTO.instrumentCode != 'Forward') {
					vm.orderDTO.limitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.limitExchangeRate, vm.spreadUsed);
				} else {
					vm.orderDTO.limitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.limitExchangeRate, (vm.spreadUsed * -1));
				}
				vm.orderDTO.spreadUsed = vm.spreadUsed;
			} else {
				vm.orderDTO.limitExchangeRateInSpot = vm.orderDTO.limitExchangeRate;
			}
		}

		function validateForwardInstrument(forwardType) {
			if (vm.orderDTO.instrumentCode == 'Forward') {

				validateAndSetExposures();
				// check the forwardtype is empty (broken date)
				if (forwardType == "") {
					validateSettlementDate(vm.orderDTO.tradeSettlementDate, "Settlement Date");
					vm.orderDTO.isOptionPeriod = false;
					vm.orderDTO.tradeSettlementDateFrom = null;
				// check the forwardtype is option period
				} else if (forwardType.toUpperCase() == "OPTION PERIOD") {
					vm.orderDTO.isOptionPeriod = true;
					var filteredTenor = $filter('filter')(vm.tenorsLookup, { tenorName: 'Option Period' });
					if (filteredTenor != null && filteredTenor != undefined) {
						vm.tenor = filteredTenor[0];
						$rootScope.tenor = vm.tenor;
					}
					validateSettlementDate(vm.orderDTO.tradeSettlementDateFrom, "Start Date");
					validateSettlementDate(vm.orderDTO.tradeSettlementDateTo, "End Date");
				} else {
					vm.importErrorString += "Invalid Forward Type;";
				}
			} else {
				vm.orderDTO.isOptionPeriod = false;
				vm.orderDTO.tradeSettlementDateFrom = null;
			}
		}

		function validateAndSetExposures() {
			if (vm.orderRequestDTO[12] == "") {
				vm.orderDTO.exposureTypeName = "-";
			} else {
				vm.orderDTO.exposureTypeName = vm.orderRequestDTO[12];
			}
			if (vm.orderRequestDTO[13] == "") {
				vm.orderDTO.exposureSubTypeName = "-";
			} else {
				vm.orderDTO.exposureSubTypeName = vm.orderRequestDTO[13];
			}
			validateAndSetExposureType(vm.orderDTO.exposureTypeName);
			validateAndSetExposureSubType(vm.orderDTO.exposureSubTypeName);
		}

		function validateTimeLimitIndicator(timeLimitIndicator) {
			vm.orderDTO.timeLimitIndicator = timeLimitIndicator;
			timeLimitIndicator = timeLimitIndicator.toUpperCase();
			if (timeLimitIndicator == "") {
				vm.importErrorString += "Order Time Indicator  cannot be empty;";
			} else if (timeLimitIndicators.hasOwnProperty(timeLimitIndicator))  {
				vm.orderDTO.timeLimitIndicator = timeLimitIndicators[timeLimitIndicator];
			} else {
				vm.importErrorString += 'Invalid Order Time Indicator;';
			}
			// validate expiry time
			validateExpiryTime();
		}

		function validateExpiryTime() {
			if (vm.orderDTO.timeLimitIndicator == "GTTM") {
				vm.orderDTO.expiryTime = vm.orderRequestDTO[10];
				vm.orderDTO.expiryTimeString = vm.orderRequestDTO[10];
				if (vm.orderDTO.expiryTime == "") {
					vm.importErrorString += "GTT Time cannot be empty;";
				} else {
					vm.serverDateUTCOffset =  vm.currentDateTime.utcOffset();
         			vm.currentTime = moment.parseZone(vm.currentDateTime, 'HH:mm').utcOffset(vm.serverDateUTCOffset).format( 'HH:mm');
					  vm.closeTime = OrderUtil.getCloseTimeForInstrumentCode(vm.orderDTO.instrumentCode);
					 if(vm.serverDateUTCOffset == moment().utcOffset()){
						vm.expiryTime = moment(vm.orderDTO.expiryTime, 'HH:mm').format( 'HH:mm');
					}else{
						vm.expiryTime = moment(vm.orderDTO.expiryTime, 'HH:mm').utcOffset(vm.serverDateUTCOffset).format( 'HH:mm');
					}
					if (vm.expiryTime == "Invalid date") {
						vm.importErrorString += "Invalid Time format;";
					} else
					//validate close time
					if(vm.expiryTime.split(':')[0] > vm.closeTime.split(':')[0]){
						vm.importErrorString += 'Expiry time cannot be greater than ' + vm.orderDTO.instrumentCode +  ' session close time '+ vm.closeTime + ';';

					}else if((vm.expiryTime.split(':')[0] == vm.closeTime.split(':')[0]) && (vm.expiryTime.split(':')[1] >= vm.closeTime.split(':')[1])){
						vm.importErrorString += 'Expiry time cannot be greater than ' + vm.orderDTO.instrumentCode +  ' session close time '+ vm.closeTime + ';';

					} else
					// validate open time
					 if (vm.expiryTime.split(':')[0] < vm.currentTime.split(':')[0]) {
						vm.importErrorString += "GTT Time cannot be lesser than current time;";
					} else if ((vm.expiryTime.split(':')[0] == vm.currentTime.split(':')[0]) && (vm.expiryTime.split(':')[1] < vm.currentTime.split(':')[1])) {
						vm.importErrorString += "GTT Time cannot be lesser than current time;";
					}
					formatExpiryTime();

				}
			}
		}
		function formatExpiryTime(){
        	var expiryTime;

        	if(vm.serverDateUTCOffset == moment().utcOffset()){
        		expiryTime = moment(vm.expiryTime, 'HH:mm').format( 'HH:mm');
         	}else{
         		expiryTime = moment(vm.expiryTime, 'HH:mm').utcOffset(vm.serverDateUTCOffset).format( 'HH:mm');
         	}
        	var expiryTimeInString = "";
        	if(expiryTime.split(':').length>1){
            	expiryTimeInString = expiryTime.split(':')[0] + expiryTime.split(':')[1] + '00';
            	var todayDateString = moment(vm.currentDate).utcOffset(vm.serverDateUTCOffset).format( 'YYYYMMDD');
            	expiryTimeInString = todayDateString + expiryTimeInString;
        	}
			vm.orderDTO.expiryTime = expiryTimeInString;
			vm.orderDTO.expiryTimeString = expiryTime;
        }

		function validateLimitExchangeRate(limitExchangeRate) {
			vm.orderDTO.limitExchangeRate = limitExchangeRate;
			if (vm.orderDTO.typeOfOrder == "LIMT") {
				if (limitExchangeRate === "") {
					vm.importErrorString += "Limit price cannot be empty;";
				} else {
					var splitLimitRate = limitExchangeRate.toString().split(".");
					if (splitLimitRate.length > 1 && splitLimitRate[1].length > $rootScope.noOfDecimalsForRateForOrder) {
						vm.importErrorString += "Limit price should have " + $rootScope.noOfDecimalsForRateForOrder + " decimals digits;";
					}
				}
			}
		}

		function validateOrderType(typeOfOrder, currencyPair) {
			vm.orderDTO.typeOfOrder = typeOfOrder;
			typeOfOrder = typeOfOrder.toUpperCase();
			if (typeOfOrder == "") {
				vm.importErrorString += "Order type cannot be empty;";
			} else if (typeOfOrders.hasOwnProperty(typeOfOrder)) {
				vm.orderDTO.typeOfOrder = typeOfOrders[typeOfOrder];
			} else {
				vm.importErrorString += "Order type should be Limit or Market;";
			}

			validateOrderTypeBasedOnCurrencyPair(typeOfOrder,currencyPair);
		}

		function validateOrderTypeBasedOnCurrencyPair(typeOfOrder,currencyPair){

			if (typeOfOrder != "" && currencyPair !="") {
				if (currencyPair.replace("/", "").toUpperCase() != "USDINR" && typeOfOrder != "LIMIT"){
					vm.importErrorString += "Order type is not applicable for this currencyPair;";
				}
			}

		}

		function validateOrderAmount(orderAmount) {
			vm.orderDTO.orderAmount = orderAmount;
			if (vm.orderDTO.orderAmount === "") {
				vm.importErrorString += "Order Quantity cannot be empty;";
			} else {
				var splitOrderAmount = vm.orderDTO.orderAmount.toString().split(".");
				if (splitOrderAmount.length > 1 && splitOrderAmount[1].length > $rootScope.noOfDecimalsForAmountForOrder) {
					vm.importErrorString += "Order quantity should have " + $rootScope.noOfDecimalsForAmountForOrder + " decimals digits;";
				}
			}
		}

		function validateBuySellIndicator(buySellIndicator) {
			vm.orderDTO.buySellIndicator = buySellIndicator;
			buySellIndicator = buySellIndicator.toUpperCase();
			if (vm.orderDTO.buySellIndicator == "") {
				vm.importErrorString += "Buy/Sell cannot be empty;";
			} else if (buySellMap.hasOwnProperty(buySellIndicator)) {
				vm.orderDTO.buySellIndicator = buySellMap[buySellIndicator];
			} else {
					vm.importErrorString += "Invalid Buy/Sell;";
				}

		}

		function validateSerialNumber(serialNumber) {
			if (serialNumber == "") {
				vm.importErrorString += "Serial Number cannot be empty;";
			} else {
				//vm.orderDTO.SystemUniqueSNo = serialNumber;
				vm.orderDTO.serialNumber = serialNumber;
				//validateSerialNumber(serialNumber);
			}
		}

		function checkAndvalidateSerialNumber(serialNumber) {
			if (isNaN(vm.orderDTO.SystemUniqueSNo)) {
				vm.importErrorString += "Serial Number is Invalid;";
			} else {
				var duplicateOrders = vm.orderUploadList.filter(function (orderDTO) {
					return orderDTO[0] === serialNumber;
				});

				if (duplicateOrders.length > 1) {
					vm.importErrorString += "Serial Number cannot be duplicate;";
				}
			}
		}

	   function prepareOrderDTOAfterValidation() {
		setEventType();

		if(vm.orderDTO.instrumentCode!='Forward'){
			vm.orderDTO.tradeSettlementDate = null;
			vm.orderDTO.tradeSettlementDateFrom = null;
		}
		if(vm.orderDTO.tradeSettlementDateTo!=""){
			vm.orderDTO.tradeSettlementDate = vm.orderDTO.tradeSettlementDateTo;
		}

		if(vm.orderDTO.timeLimitIndicator!='GTTM'){
			vm.orderDTO.expiryTime = 0;
		}
		if(vm.orderDTO.typeOfOrder == "MRKT"){
            vm.orderDTO.limitExchangeRate=0;
        }

		//vm.orderDTO.limitExchangeRate = $filter('number')(vm.orderDTO.limitExchangeRate, $rootScope.noOfDecimalsForRateForOrder);

	   }

		function validateSettlementDate(settlementDate,fieldName) {
			if (settlementDate == "") {
				vm.importErrorString += fieldName+" cannot be empty;";
			} else {
				var settlemendDateServerFormat = DateUtils.convertLocalDateToServer(settlementDate);
				var holidayList = _.filter(vm.holidayListAfterBusinessDate, function(s){return s.indexOf(settlemendDateServerFormat)!==-1;});
           		if(holidayList!=null && holidayList!=undefined && holidayList.length>0){
					vm.importErrorString += fieldName+" cannot be a holiday;";
				}
				var dateRegex = /^\d{2}-\d{2}-\d{4}$/;
				var date =$filter('date')(settlementDate, 'dd-MM-yyyy');
				if (!dateRegex.test(date)) {

					vm.importErrorString += "Invalid "+fieldName+".Format should be in 'dd-mm-yyyy';";
				}
				else if (moment(vm.currentDate).isAfter(settlemendDateServerFormat)) {

					vm.importErrorString += fieldName+" cannot be past date;";
				}else{
					if(fieldName=='Settlement Date' || fieldName=='End Date'){
						$rootScope.tradeSettlementDateFororder = settlementDate;
					}else{
						$rootScope.tradeSettlementDateFrom = settlementDate;
					}

				}

			}
		}

	// validate customer
	   function validateCustomer(customerCode){
		if(customerCode==""){
			vm.importErrorString += "Customer ID cannot be empty;";
		}else{
			vm.orderDTO.customerCode=customerCode;
			var isInvalidCustomer = ((vm.entityOwnerType === 'MultiUserCustomer' || vm.entityOwnerType === 'SingleUserCustomer') && customerCode !== vm.loggedInCustomer.customerCode);
				if(isInvalidCustomer){
					vm.importErrorString += "Customer ID does not belong to the uploading user;";
				}
           }

	   }
	   // validate relationship bank
	   function validateRelationshipBank(ngCode){
		vm.orderDTO.bankNegotiationCode = ngCode;
		if(ngCode==""){
			vm.importErrorString += "Bank Negotiation Code cannot be empty;";
		}else{
			validateTradingBankRelationship(vm.orderRequestDTO[2],vm.orderDTO.customerCode);
		}
	   }

	   //need to common
	   function getSpotRateForGivenRateAndSpread(rate, spread){
		if(rate>0){
			var spotRate = Number(rate) + Number(spread)/100;
			return spotRate;
		}else{
			return null;
		}
	}

		function validateAndSetInstrument(instrumentCode, currencyPair) {
			vm.orderDTO.instrumentCode = instrumentCode;
			instrumentCode = instrumentCode.toUpperCase();
			vm.orderDTO.instrumentId = null;
			if(instrumentCode==""){
				vm.importErrorString += "Instrument Code cannot be empty;";
			}else{
				if(instrumentCode=="FORWARD"){
					instrumentCode = "Forward";
				}
				angular.forEach(vm.instrumentTypes, function (value) {
					if (value.instrumentCode == instrumentCode) {
						vm.orderDTO.instrumentId = value.id;
						vm.orderDTO.instrumentCode=value.instrumentCode;
					}
				});
				if(vm.orderDTO.instrumentId==null){
					vm.importErrorString += "Invalid Instrument Code;";
				}
			}

			if(instrumentCode != ""){
				validateInstrumentBasedOnCurrencyPair(instrumentCode,currencyPair);

				validateInstrumentIsApplicableForCurrencyPair(instrumentCode,currencyPair);
			}

		}

		function validateInstrumentIsApplicableForCurrencyPair(instrumentCode,currencyPair){

            if (instrumentCode != "" && currencyPair !="") {

			var normalizedPair = currencyPair.replace("/", "").toUpperCase();
			var isConfigured = false;

			angular.forEach(vm.applicableInstruments, function(value){
			   if(value.instrumentCode == instrumentCode  && value.currencyPair.code==normalizedPair ){
				isConfigured =true;
			   }
		   });

		   if (!isConfigured) {
               vm.importErrorString += "Currency pair is not applicable for the instrument;";
            }

			}
		}

		function validateInstrumentBasedOnCurrencyPair(instrumentCode,currencyPair){
			if (instrumentCode != "" && currencyPair !="") {
				if (currencyPair.replace("/", "").toUpperCase() != "USDINR" && instrumentCode == "FORWARD"){
					vm.importErrorString += "Instrument is not applicable for this currencyPair;";
				}
			}
		}
		function validateAndSetExposureType(exposureType){
            if(exposureType==null || exposureType==undefined || exposureType==''){
                exposureType = $rootScope.userPreference.userExposureType;
            }
            angular.forEach(vm.exposureTypes, function(value){
                if(value.name.toUpperCase()==exposureType.toUpperCase()){
                    vm.exposureType = value;
                }
            });
			if(vm.exposureType==null){
				vm.importErrorString += "Invalid exposure type;";
			}else{
				vm.orderDTO.exposureTypeId = vm.exposureType.id;
				vm.orderDTO.exposureTypeName = vm.exposureType.name;

			}
        }

        function validateAndSetExposureSubType(exposureSubType){
            if(exposureSubType==null || exposureSubType==undefined || exposureSubType==''){
                exposureSubType = $rootScope.userPreference.userExposureSubType;
            }
            angular.forEach(vm.exposureSubTypes, function(value){
                if(value.name.toUpperCase()==exposureSubType.toUpperCase()){
                    vm.exposureSubType = value;
                }
            });
			if(vm.exposureSubType==null){
				vm.importErrorString += "Invalid sub exposure type;";
			}else{
				vm.orderDTO.exposureSubTypeId = vm.exposureSubType.id;
				vm.orderDTO.exposureSubTypeName = vm.exposureSubType.name;
			}
        }

	   function validateRemarks(orderRequestDTO){
			var remarkRegex = /[^a-zA-Z0-9-\s.]/g;

			vm.orderDTO.remarks   = orderRequestDTO[17].toString();
			vm.orderDTO.remarks2  = orderRequestDTO[18].toString();
			vm.orderDTO.remarks3  = orderRequestDTO[19].toString();
			vm.orderDTO.remarks4  = orderRequestDTO[20].toString();
			if(vm.orderDTO.remarks.match(remarkRegex)){
				vm.importErrorString += "Remarks 1 Special characters other than - and . are not allowed;";
			}
			if(vm.orderDTO.remarks2.match(remarkRegex)){
				vm.importErrorString += "Remarks 2 Special characters other than - and . are not allowed;";
			}
			if(vm.orderDTO.remarks3.match(remarkRegex)){
				vm.importErrorString += "Remarks 3 Special characters other than - and . are not allowed;";
			}
			if(vm.orderDTO.remarks4.match(remarkRegex)){
				vm.importErrorString += "Remarks 4 Special characters other than - and . are not allowed;";
			}

	   }

	   function setEventType(){
		var eventType = OrderUtil.getEventTypeForShortName('Booking');
                vm.orderDTO.eventTypeId = eventType.id;
                vm.orderDTO.eventType = eventType.shortName;
                vm.orderDTO.settlementLegId = null;
	   }



	   function validateTradingBankRelationship(ngCode,customerCode){

		angular.forEach(vm.allTradingBanks, function(value){
			   if(value.bank.ngCode==ngCode.toUpperCase()  && value.customer.customerCode==customerCode ){
				   vm.orderDTO.branchId=value.tradingBranch.id;
				   vm.orderDTO.branchName=value.tradingBranch.branchName;
				   vm.orderDTO.branchCode=value.tradingBranch.branchId;
				   vm.orderDTO.customerId=value.customer.id;
				   vm.orderDTO.customerName=value.customer.customerFirstName;
				   vm.orderDTO.customerCode=value.customer.customerCode;
				   vm.orderDTO.bankName=value.bank.bankName;
				   vm.orderDTO.bankId=value.bank.id;
				   vm.orderDTO.bankMemberNumber = value.bank.bankMemberNo;
				   vm.bankForTrading=value.bank;
				   if($rootScope.bankComparativeDTO!=null){
					$rootScope.defaultBankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, value.bank.id);
				   }

			   }

		   });
		if(vm.orderDTO.bankId==null || vm.orderDTO.bankId==undefined || vm.orderDTO.bankId==""){
				   vm.importErrorString = vm.importErrorString + "There is no trading relationship for the customer with the bank or branch."
			   }
   }
   /* get settlemnt date based on the order type, instrument and tenor name*/
   function getSettlementDate( instrumentCode, orderType, tradeSettlementDateFrom,tradeSettlementDateTo){
	var settlementDate = angular.copy($rootScope.tradeSettlementDateFororder);
	if(instrumentCode == 'Forward' && $rootScope.tenor !=null && $rootScope.tenor != undefined && $rootScope.tenor.tenorName == 'Option Period'){
		if( orderType =="SELL" ){
			settlementDate = angular.copy(tradeSettlementDateFrom);
		}else
		{
			settlementDate = angular.copy(tradeSettlementDateTo);
		}
	}
	return settlementDate;
}

function validatefileNameScriptContent(fileName){
var regexPattern = /^[a-zA-Z0-9_ .-]+$/;

 if(!fileName.match(regexPattern)){
 AlertService.error($filter('translate')('gatewayApp.orderUpload.invalidFileName'));
 return false;
 }
 return true;
 }


    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('order-status-report', {
            parent: 'entity',
            url: '/order-status-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.orderStatusReport.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order-status-report/order-status-report.html',
                    controller: 'OrderStatusReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('orderStatusReport');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('orderActivity');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('order-activity', {
            parent: 'order-status-report',
            url: '/order-activity-status/{orderNumber}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-activity/order-activity.html',
                    controller: 'OrderActivityController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    	
                            	 entity: ['OrderActivity', 'GlobalValues', function(OrderActivity, GlobalValues) {
                                     return OrderActivity.get({orderNumber : $stateParams.orderNumber}).$promise;
                                 }],
                                 businessDate: null
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('order-activity-pending-orders', {
            parent: 'home',
            url: '/order-activity-pending-order/{orderNumber}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-activity/order-activity.html',
                    controller: 'OrderActivityController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    	
                            	 entity: ['OrderActivity', 'GlobalValues', function(OrderActivity, GlobalValues) {
                                     return OrderActivity.get({orderNumber : $stateParams.orderNumber}).$promise;
                                 }],
                                 businessDate: null
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         .state('order-activity-reports', {
            parent: 'home-page-reports',
            url: '/order-activity-reports',
            params: {ordNo : null},
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-activity/order-activity.html',
                    controller: 'OrderActivityController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        
                                 entity: ['OrderActivity', 'GlobalValues', function(OrderActivity, GlobalValues) {
                                     return OrderActivity.get({orderNumber : $stateParams.ordNo}).$promise;
                                 }],
                                 businessDate: null
                       
                    }
                }).result.then(function() {
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('order-activity-trade-history', {
            parent: 'trade-history',
            url: '/order-activity-trade-history/{orderNumber}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-activity/order-activity.html',
                    controller: 'OrderActivityController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    	
                            	 entity: ['OrderActivity', 'GlobalValues', function(OrderActivity, GlobalValues) {
                                     return OrderActivity.get({orderNumber : $stateParams.orderNumber}).$promise;
                                 }],
                                 businessDate: null
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('order-activity-order-history', {
            parent: 'order-history',
            url: '/order-activity-order-history/{orderNumber}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-activity/order-activity.html',
                    controller: 'OrderActivityController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        
                                 entity: ['OrderActivity', 'GlobalValues', function(OrderActivity, GlobalValues) {
                                     return OrderActivity.get({orderNumber : $stateParams.orderNumber}).$promise;
                                 }],
                                 businessDate: null
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         
         };
    })();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'orderStatusReport'
        })
        
        .controller('OrderStatusReportController', OrderStatusReportController);

    OrderStatusReportController.$inject = ['$scope','$rootScope', '$state', 'OrderStatusDetails', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout','IntradayMarket','DateUtils', 'DefaultMarket','StaticLookUp','ExportFile'];

    function OrderStatusReportController($scope,$rootScope,$state, OrderStatusDetails , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout,IntradayMarket,DateUtils, DefaultMarket,StaticLookUp,ExportFile) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.ORDERSTATUSREPORT;
		$rootScope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
		vm.reportFileTimestampFormat = '_DD_MMM_YYYY_HH_mm';
		vm.clicked=false; 
        // DefaultMarket.marketInstruments(function(result){
        //     vm.instrumentTypes = result;
        // });
		getInstrumentMatchedCurrencypair();

        StaticLookUp.getOrderStatus(function(result){
        	vm.orderStatusList = result;
        });
        vm.screenLog = ScreenLog;
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        
        vm.todayDate = new Date();
        vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.orgId = vm.globalValues.getOrgId();
        
        if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
        	 vm.loggedInCustomer = vm.globalValues.getCustomerId();
        }
        if(vm.entityOwnerType=='Bank' || vm.entityOwnerType=='Branch'){
        	vm.bank = vm.globalValues.getBank();
        }
        if(vm.entityOwnerType=='Branch'){
        	vm.branch = vm.globalValues.getBranch();
        }
        //testing
       
        vm.getOrderStatusDetails = getOrderStatusDetails;
        vm.ExpandOrCollapseOrderStatusReport=true;
        
        workflowSharedService.viewFrom = "orderStatusReport";
		vm.exportDataToExcelFile = exportDataToExcelFile;
	    vm.exportDataToCsvFile = exportDataToCsvFile;
	    vm.exportDataToPdfFile = exportDataToPdfFile;
		vm.tableName = 'orderStatusReport';
		vm.fileName = "Order_Status_Report";
        
        logScreenAccess();
       // loadCurrentBusinessDate();

       function getOrderStatusDetails() {
    	   
    	   vm.bankId = 0;
    	   vm.branchId = 0;
    	   vm.customerId= 0;
    	   vm.instrumentId = 0;
    	   vm.orderStatusId = 0;
		   vm.currencyPairId = 0;
    	   
    	   
    	   	
	    	   if (vm.entityOwnerType == 'Bank' || vm.entityOwnerType == 'Branch'){
	    		   vm.bankId = vm.globalValues.getOrganisation().id;
	    	   }else if(vm.bank!=null && vm.bank!=undefined){
	    		   if(vm.entityOwnerType == 'Clearcorp' || vm.entityOwnerType == 'MultiUserCustomer' || vm.entityOwnerType == 'SingleUserCustomer'){
		    			  vm.bankId = vm.bank.id;
		    		  }
	    	   }
	    	   
	    	   if(vm.entityOwnerType == 'Branch'){
	    		   vm.branchId = vm.globalValues.getBranch().id;
	    	   }else  if(vm.branch!=null && vm.branch!=undefined){
	    		   if(vm.entityOwnerType=='Clearcorp' || vm.entityOwnerType=='Bank'){
	    			   vm.branchId = vm.branch.id;
	    		   }
	    	   }
	    	   
	    	   if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
	    		   vm.customerId = vm.globalValues.getCustomerId();
	    	   } else  if(vm.customer!=null && vm.customer!=undefined){
	    		   if(vm.entityOwnerType!='MultiUserCustomer' && vm.entityOwnerType!='SingleUserCustomer'){
	    			   vm.customerId = vm.customer.id;
	    		   }
	    	   }
    	   
    	   
	    	   if(vm.instrument!=null && vm.instrument!=undefined){
	    		   vm.instrumentId = vm.instrument.id;
	    	   }
	    	   
	    	   if(vm.orderStatus!=null && vm.orderStatus!=undefined){
	    		   vm.orderStatusId= vm.orderStatus.id;
	    	   }

			   	if(vm.currencyPair!=null && vm.currencyPair!=undefined){
	    		   vm.currencyPairId= vm.currencyPair.id;
	    	   }
	    	   
	    	   
	    	   
    	   OrderStatusDetails.getOrderStatusDetails({"bankId": vm.bankId, "branchId":vm.branchId , "customerId" : vm.customerId ,
    		   "instrumentId" : vm.instrumentId , "orderStatusId" : vm.orderStatusId , "currencyPairId" : vm.currencyPairId},function(result) {
    	   
               
                
                angular.forEach(result, function(value){
                	value.revisionTimeStamp=moment(value.revisionTimeStamp,'YYYYMMDDHHmmss.SSSSSSSSS').format();
                	
                	if(value.expiryTime==0){
	              		var time = moment().toDate();
		              	time.setHours(0);
		              	time.setMinutes(0);
		              	time.setSeconds(0);
		              	time.setMilliseconds(0);
		              	value.expiryTime=time;
	              	}else{
	              		value.expiryTime=moment(value.expiryTime,'YYYYMMDDHHmmss').format();
	              	}
                	
                	if(value.buySellFlag.toUpperCase()=='BUYY'){
                		value.buySellFlag='Buy';
                	}else if(value.buySellFlag.toUpperCase()=='SELL'){
                		value.buySellFlag='Sell';
                	}
                	
                	
                	
                	if(value.timeCondition.toUpperCase()!='GTTM'){
                		value.expiryTime=null;
                	}
                	
                	if(value.timeCondition.toUpperCase()=='DAYY'){
                		value.timeCondition='DAY';
                	}else if(value.timeCondition.toUpperCase()=='GTTM'){
                		value.timeCondition='GTT';
                	}else if(value.timeCondition.toUpperCase()=='IOCC'){
                		value.timeCondition='IOC';
                	}
                	
                	if(value.priceCondition.shortName!='STLS' && value.priceCondition.shortName!='TKPR'){
                		value.stopExchangeRate=null;
                	}
                	
                	if(value.lastTradeSequenceNumber==0){
                		value.lastTradeSequenceNumber=0;
                	}
            	});
                
               
                vm.orderStatusDetails = result;
				vm.clicked=false; 
             });        	
        }      
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       function loadCurrentBusinessDate(){
    	   IntradayMarket.getCurrentBusinessDate(getBusinessDateSuccess, getBusinessDateFailed);
       }
       
       function getBusinessDateSuccess(result){
    	   vm.currentBusinessDate = DateUtils.convertLocalDateFromServer(result.businessDate);
    	   
    	   vm.convertedCurrentBusinessDate=DateUtils.convertLocalDateToServer(vm.currentBusinessDate);
    	   
       }
       
       function getBusinessDateFailed(){
    	   
       }

	   function exportDataToExcelFile(totalRecordCount,noOfRecordsPerPage,pageNo){
		//$scope.noOfRecordsPerPage=totalRecordCount;
		ExportFile.exportFile('excel',vm.tableName, totalRecordCount,noOfRecordsPerPage,undefined,pageNo,vm.fileName,undefined,undefined,undefined);
		
	}
   
	function exportDataToCsvFile(totalRecordCount,noOfRecordsPerPage,pageNo){
		//$scope.noOfRecordsPerPage=totalRecordCount;
		ExportFile.exportFile('csv',vm.tableName, totalRecordCount,noOfRecordsPerPage,undefined,pageNo,vm.fileName,undefined,undefined,undefined);
			
		  
	}
	function exportDataToPdfFile(){
			if( vm.orderStatusDetails !=null &&  vm.orderStatusDetails!=undefined && vm.orderStatusDetails.length>0){
			   
				vm.mimeType = 'application/pdf';
				vm.extension = ".pdf";
				OrderStatusDetails.exportOrderStatusPdfFile({
					"bankId": vm.bankId, "branchId": vm.branchId, "customerId": vm.customerId,
					"instrumentId": vm.instrumentId, "orderStatusId": vm.orderStatusId, "currencyPairId": vm.currencyPairId
				}, processResponse);

			}
	}
	function processResponse(result){        	  
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
			vm.baseString =   vm.fileName + moment().format( vm.reportFileTimestampFormat ) +  vm.extension; 
			
			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				  window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
	  }
	   
	   vm.getSwapPoints = function getSwapPoints(spotExchangeRate, tradeExchangeRate){
		var swapPts =0;
		   if(spotExchangeRate!=0){
			var swapPts = Math.abs(spotExchangeRate - tradeExchangeRate) * 100
			swapPts = (Math.round(parseFloat(swapPts)*100)/100);
			return swapPts;
		   }else{
			return swapPts;
		   }
		 
	   }

	 $scope.$watch('vm.currencyPair', function (value) {
         if (value != null && value != undefined) {
			getInstrumentMatchedCurrencypair();
    	}
		})

		function getInstrumentMatchedCurrencypair(){
            var currencyPairId = vm.globalValues.getDefaultCurrencyPairId();
            if (!vm.currencyPair != null && vm.currencyPair != undefined) {
                currencyPairId = vm.currencyPair.id;
            }
			DefaultMarket.csInstruments({currencyPairId:currencyPairId},onGetInstrumentSuccess, onGetInstrumentFailure);
            
        } 

		function onGetInstrumentSuccess(result) {
            vm.instrumentTypes = result;
            // get tick size for each instrument
		}

		function onGetInstrumentFailure() {

        }

      
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('OrderStatusDetails', OrderStatusDetails);

    OrderStatusDetails.$inject = ['$resource'];

    function OrderStatusDetails ($resource) {
        var resourceUrl =  'api/order-status-details/:id';
        
        return $resource(resourceUrl, {}, {
        	
        	'getTradesOutstandingList':{
        		isArray:true,
				method: 'GET',
				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId',fromSetDate :'@fromSetDate',toSetDate:'@toSetDate',currencyPairId:'@currencyPairId'},
				url: 'api/trades-outstanding/:bankId/:branchId/:customerId/:instrumentId/:fromSetDate/:toSetDate/:currencyPairId'
        	},
        	'getOrderStatusDetails':{
           	 
             	isArray:true,
  				method: 'GET',
  				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId', orderStatusId : '@orderStatusId', currencyPairId : '@currencyPairId'},
  				url: 'api/order-status-report/bank/:bankId/branch/:branchId/customer/:customerId/instrument/:instrumentId/orderStatus/:orderStatusId/currencyPair/:currencyPairId/order-status-details'
              },

         'getPendingOrders':{
         	isArray:true,
				method: 'GET',
				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId', currencyPairId : '@currencyPairId'},
				url: 'api/pending-order/bank/:bankId/branch/:branchId/customer/:customerId/instrument/:instrumentId/currencyPair/:currencyPairId/order-status-details'
          },
          'getOrderStatusList':{
           		isArray:true,
  				method: 'GET',
  				url: 'api/order-status-list'
            },
	     'getTradesForSelectedInstrument':{
	       	isArray:true,
				method: 'GET',
				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId', currencyPairId : '@currencyPairId'},
				url: 'api/trades/:bankId/bank/:branchId/branch/:customerId/customer/:instrumentId/instrument/:currencyPairId/currencyPair'
	      },
	      'getUserWiseTurnoverHeader':{
		       	isArray:true,
					method: 'GET',
					params: {bankId: '@bankId', branchId: '@branchId', login : '@login',customerId: '@customerId'},
					url: 'api/trades/get-userwise-turnover-report-header'
		      },
		      
		  'getUserWiseTurnoverDetails':{
			       	isArray:true,
						method: 'GET',
						params: {bankId :'@bankId',branchId:'@branchId',userId:'@userId',customerId: '@customerId'},
						url: 'api/trades/bank/:bankId/branch/:branchId/user/:userId/customer/:customerId/get-userwise-turnover-report-details'
	      },'getUserRoleListFromUser': {
                method: 'GET',
                url: 'api/get-user-role-for-user',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getPendingOrdersForUser':{
             	isArray:true,
    				method: 'GET',
    				url: 'api/pending-order-for-user'
              },
		'exportOrderStatusPdfFile':{
          	method: 'POST',
				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId', orderStatusId : '@orderStatusId', currencyPairId : '@currencyPairId'},
				url: 'api/export-order-status-report-pdf/bank/:bankId/branch/:branchId/customer/:customerId/instrument/:instrumentId/orderStatus/:orderStatusId/currencyPair/:currencyPairId/',
				responseType: 'arraybuffer',
				transformResponse: function(data, headers) {
				   return {
					   data: data,
					   headers: headers
				   };   
			   } 

			 }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('order-server-manual-login', {
            parent: 'entity',
            url: '/order-server-manual-login',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.orderServerManualLogin.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order-server-manual-login/order-server-manual-login.html',
                    controller: 'OrderServerManualLoginController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('OrderServerManualLogin', OrderServerManualLogin);

    OrderServerManualLogin.$inject = ['$resource'];

    function OrderServerManualLogin ($resource) {
        var resourceUrl =  'api/order-server-manual-login';
        
        return $resource(resourceUrl, {}, {
        	
              'manualLogin': {
                  method: 'POST',
                  url: 'order/manual-login'
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'orderServerManualLogin'
        })
        
        .controller('OrderServerManualLoginController', OrderServerManualLoginController);

    OrderServerManualLoginController.$inject = ['$scope', '$state',  'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout',
    		'OrderServerManualLogin','MessageBox','$rootScope','AlertService', '$filter'];

    function OrderServerManualLoginController($scope, $state,  GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout,
    		OrderServerManualLogin,MessageBox,$rootScope,AlertService,$filter) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.ORDER_SERVER_MANUAL_LOGIN;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        workflowSharedService.viewFrom = "orderServerManualLogin";
        vm.screenLog = ScreenLog;
        var yesMessageEvent = null;
        var startRecoveryEvent=null;
        logScreenAccess();
        
        vm.orderServerManualLogin = orderServerManualLogin;
        
        vm.todayDate = new Date();
      
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       
       function orderServerManualLogin(){
    	   
    	   MessageBox.openMessageBox("Alert", "Do you want to manually login to order server?", "YesNo", "orderServerManualLogin");
       }
       
       $scope.$on('$destroy', function() {
 		  if (yesMessageEvent!=null )
 			  	yesMessageEvent();
	        });
   
 		
    	 yesMessageEvent = $rootScope.$on('gatewayApp.messagebox.yes.orderServerManualLogin', function (event, data) {
    		 	vm.orderServerManualLoginStatus = "PROGRESS";
 				OrderServerManualLogin.manualLogin(orderServerManualLoginSuccess,orderServerManualLoginFailure);
 				
 			
 		});
 	
 
		$rootScope.$on('gatewayApp.messagebox.no.orderServerManualLogin', function (event, data) {
			//do nothing
		});
		
		function orderServerManualLoginSuccess(error){
			
		}
		
		function orderServerManualLoginFailure(error){
			//alert(error.message);
			vm.orderServerManualLoginStatus = "";
			if(error.status==503){
				
				AlertService.error($filter('translate')( "error.order.serviceUnavailable"));
			}else if(error.status==403){
				//since session expiry  popup is diplayed do not show any error for 403 status
				//AlertService.error($filter('translate')( "Service Unavailable"));
			}
			else{
				AlertService.error($filter('translate')( error.data));
			}
		}
		
		 startRecoveryEvent = $rootScope.$on('orderServerManualLogin', function (event, data) {
	 			if(data!=null){
	 				
	 				if(data.message=="success"){
	 					//vm.orderServerManualLoginStatus = "SUCCESS";
	 					vm.orderServerManualLoginStatus = "";
	 					console.log("Order server manual login successful " + data.message);
	 					AlertService.success($filter('translate')('global.menu.orderServerManualLogin.success'));
	 				}else{
	 					//vm.orderServerManualLoginStatus = "FAILURE";
	 					vm.orderServerManualLoginStatus = "";
	 					console.log("Order server manual login failed " + data.message);
	 					AlertService.error(data.message);
	 				}
	 			}
	 			
	 		});
	 	
		 $scope.$on('$destroy', function() {
	 		  if (startRecoveryEvent!=null )
	 			 startRecoveryEvent();
		        });
     
      
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('order-history', {
            parent: 'entity',
            url: '/order-history',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.orderHistory.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order-history/order-history.html',
                    controller: 'OrderHistoryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('orderHistory');
                    $translatePartialLoader.addPart('orderActivity');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        
        
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('OrderHistory', OrderHistory);

    OrderHistory.$inject = ['$resource'];

    function OrderHistory ($resource) {
        var resourceUrl =  'api/order-history/:id';
        
        return $resource(resourceUrl, {}, {
        	
        
        	'getOrderHistory':{
           	 
             	isArray:true,
  				method: 'GET',
  				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId',
  					buySell : '@buySell', orderStatus : '@orderStatus', fromDate : '@fromDate', toDate : '@toDate',currencyPairId : '@currencyPairId'},
  				
  				url: 'api/order-history/get-order-history-details'
              }
          
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'orderHistory'
        })
        
        .controller('OrderHistoryController', OrderHistoryController);

    OrderHistoryController.$inject = ['$scope', '$state', 'OrderHistory', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
    	'$timeout','DateUtils','AlertService','$filter'];

    function OrderHistoryController($scope, $state, OrderHistory , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout,DateUtils,
    		AlertService,$filter) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.ORDER_HISTORY;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        
        vm.todayDate = new Date();
        vm.yesterdayDate = new Date();
        vm.yesterdayDate.setDate(vm.yesterdayDate.getDate() - 1);
        vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.orgId = vm.globalValues.getOrgId();
        vm.fromDate = DateUtils.convertDateTimeFromServer(vm.yesterdayDate);
        vm.toDate = DateUtils.convertDateTimeFromServer(vm.yesterdayDate);
        vm.buySellIndicators=["BUY","SELL"];
        vm.valid=false;
		vm.clicked=false;
        
        vm.minDate = DateUtils.getSubtractMonth(new Date(),3);
        vm.noOfMonthsForHistoricalView = vm.globalValues.getConfigSettings().noOfMOnthsForHistoricalReportsView;
        
        if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
        	 vm.loggedInCustomer = vm.globalValues.getCustomerId();
        }
        if(vm.entityOwnerType=='Bank' || vm.entityOwnerType=='Branch'){
        	vm.bank = vm.globalValues.getBank();
        }
        if(vm.entityOwnerType=='Branch'){
        	vm.branch = vm.globalValues.getBranch();
        }
        
       
        vm.getOrderHistory = getOrderHistory;
        vm.ExpandOrCollapseOrderHistory=true;
        
        workflowSharedService.viewFrom = "orderHistory";
       
        
        logScreenAccess();
       // loadCurrentBusinessDate();

       function getOrderHistory() {
    	   
    	   vm.bankId = null;
    	   vm.branchId = null;
    	   vm.customerId= null;
    	   vm.instrumentId = null;
    	   vm.buySellFlag=null;
    	   vm.orderStatusName = null;
		   vm.currencyPairId = null;
    	   
    	   if(moment(vm.fromDate).isAfter(vm.yesterdayDate,'day')){
	   			AlertService.error($filter('translate')('gatewayApp.orderHistory.futureFromDate'));
	   			vm.valid=false;
	   		}
	   		else if(moment(vm.fromDate).isAfter(vm.toDate,'day')){
	   			AlertService.error($filter('translate')('gatewayApp.orderHistory.greaterFromDate'));
	   			vm.valid=false;
	   		}else if(moment(vm.toDate).isAfter(vm.yesterdayDate,'day')){
	   			AlertService.error($filter('translate')('gatewayApp.orderHistory.greaterToDate'));
	   			vm.valid=false;
	   		}
	   		else if(moment(vm.fromDate).isBefore(vm.minDate, 'day')){
	   			AlertService.error('Historical Reports are available only for a period of '  + vm.noOfMonthsForHistoricalView + ' months...!');
	   			vm.valid=false;
	   		}else if(!(moment(vm.fromDate).isSame(vm.toDate,'month'))){
				AlertService.error($filter('translate')('gatewayApp.orderHistory.helpText'));
				vm.valid=false;
			}
	   		else{
				vm.clicked=true;
	   			vm.valid=true;
	   		 if (vm.entityOwnerType == 'Bank' || vm.entityOwnerType == 'Branch'){
	    		   vm.bankId = vm.globalValues.getOrganisation().id;
	    	   }else if(vm.bank!=null && vm.bank!=undefined){
	    		   if(vm.entityOwnerType == 'Clearcorp' || vm.entityOwnerType == 'MultiUserCustomer' || vm.entityOwnerType == 'SingleUserCustomer'){
		    			  vm.bankId = vm.bank.id;
		    		  }
	    	   }
	    	   
	    	   if(vm.entityOwnerType == 'Branch'){
	    		   vm.branchId = vm.globalValues.getBranch().id;
	    	   }else  if(vm.branch!=null && vm.branch!=undefined){
	    		   if(vm.entityOwnerType=='Clearcorp' || vm.entityOwnerType=='Bank'){
	    			   vm.branchId = vm.branch.id;
	    		   }
	    	   }
	    	   
	    	   if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
	    		   vm.customerId = vm.globalValues.getCustomerId();
	    	   } else  if(vm.customer!=null && vm.customer!=undefined){
	    		   if(vm.entityOwnerType!='MultiUserCustomer' && vm.entityOwnerType!='SingleUserCustomer'){
	    			   vm.customerId = vm.customer.id;
	    		   }
	    	   }
  	   
  	   
	    	   if(vm.instrument!=null && vm.instrument!=undefined){
	    		   vm.instrumentId = vm.instrument.id;
	    	   }
	    	   
	    	   if(vm.orderStatus!=null && vm.orderStatus!=undefined && vm.orderStatus !=""){
	    		   vm.orderStatusName= vm.orderStatus.name;
	    		   if(vm.orderStatusName=='Filled'){
	    			   vm.orderStatusName='TRAD';
	    		   }else if(vm.orderStatusName=='Cancelled'){
	    			   vm.orderStatusName='CNCL';
	    		   }
	    	   }
	    	   if(vm.buySell!=null && vm.buySell!=undefined && vm.buySell!=""){
	    		   if(vm.buySell=='BUY'){
	    			   vm.buySellFlag = 'BUYY';
	    		   }else if(vm.buySell=='SELL'){
	    			   vm.buySellFlag='SELL';
	    		   }else{
	    			   vm.buySellFlag=null;
	    		   }
	    	   }

			   if(vm.currencyPair!=null && vm.currencyPair!=undefined){
	    		   vm.currencyPairId = vm.currencyPair.id;
	    	   }
	    	   
	    	   vm.convertedFromDate = DateUtils.convertLocalDateToServer(vm.fromDate);
	    	   vm.convertedToDate = DateUtils.convertLocalDateToServer(vm.toDate);
	    	   
  	   OrderHistory.getOrderHistory({bankId: vm.bankId, branchId:vm.branchId , customerId : vm.customerId ,
  		   instrumentId : vm.instrumentId , buySell:vm.buySellFlag,orderStatus : vm.orderStatusName,
  		   fromDate: vm.convertedFromDate, toDate : vm.convertedToDate,currencyPairId: vm.currencyPairId},function(result) {
  	   
              
              angular.forEach(result, function(value){
              	
              	if(value.buySellIndicator.toUpperCase()=='BUYY'){
              		value.buySellIndicator='Buy';
              	}else if(value.buySellIndicator.toUpperCase()=='SELL'){
              		value.buySellIndicator='Sell';
              	}
              	
              	if(value.orderStatus=='TRAD'){
              		value.orderStatus='Filled';
              	}else if(value.orderStatus=='CNCL'){
              		value.orderStatus='Cancelled';
              	}
              	//alert("SD" + value.settlementStartDate ); 	
          	});
             
             
              vm.orderHistory = result;
			  vm.clicked=false;
           });        
	   		}
    	   	
	    	  	
        }      
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
  	    vm.getSwapPoints = function getSwapPoints(spotExchangeRate, tradeExchangeRate){
			var swapPts = Math.abs(spotExchangeRate - tradeExchangeRate) * 100
			swapPts = (Math.round(parseFloat(swapPts)*100)/100);
			return swapPts;
		}
  
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('OrderConfigController', OrderConfigController);

    OrderConfigController.$inject = ['$scope', '$rootScope', '$state',  '$uibModalInstance', 'UserProfile', 'GlobalValues', '$filter', 'ExposureType', 'ExposureSubType'];

    function OrderConfigController($scope, $rootScope, $state, $uibModalInstance, UserProfile, GlobalValues, $filter, ExposureType, ExposureSubType) {
        var vm = this;
        vm.clear=clear;
        vm.globalValues = GlobalValues;
        vm.save=save;
        $scope.clicked=false;
        loadAll();
        vm.configSettings = vm.globalValues.getConfigSettings();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
		vm.noOfDecimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
		vm.noOfdecimalsForPaise = vm.globalValues.getNumberOfDecimalsForRateInReports();
        vm.getCurrencyWiseUserPreference = getCurrencyWiseUserPreference;
        vm.minimumOrderValue = vm.configSettings.minimumOrderValue;
        vm.isAllowStopLoss = vm.configSettings.isAllowStopLossOrder;
        vm.isAllowTakeProfit = vm.configSettings.isAllowTakeProfitOrder;
        vm.isAllowMarketOrder = vm.configSettings.isAllowMarketOrder;
        vm.maximumOrderValueHardCheck = vm.globalValues.getTransactionParameterValue(vm.globalValues.getDefaultCurrencyPairId(), "MaximumOrderValueHardCheck");
        vm.allowedOrderPriceDeviationFromMarketPriceInPercentage = vm.globalValues.getTransactionParameterValue(vm.globalValues.getDefaultCurrencyPairId(), "AllowedOrderPriceDeviationFromMarketPriceInPercentage");
        vm.allowedOrderPriceDeviationFromMarketPriceInPaise = vm.globalValues.getTransactionParameterValue(vm.globalValues.getDefaultCurrencyPairId(), "AllowedOrderPriceDeviationFromMarketPriceInPaise");
        vm.errorText1 = '';
        vm.errorText2 = '';
        vm.errorText3 = '';
        vm.errorText4 = '';
        vm.errorText5 = '';
        vm.exposureType = null;
        vm.exposureSubType = null;
        vm.ExpandOrCollapseUserProfile = false;
        vm.ExpandOrCollapseCurrencyPreferences = false;


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function loadAll(){
        	UserProfile.get({
				"userId" : vm.globalValues.getUserId()
			}, onGetUserProfileSuccess, onGetUserProfileError);
        }
        
        function onGetUserProfileSuccess(result){
        	vm.userprofile = result;

            
			updateCurrencyWiseUserPrefrencesForUser(vm.userprofile.currencyWiseUserPreferenceSettingsDTOList);

        	if(vm.userprofile.userPriceCondition=='STLS' && vm.isAllowStopLoss!='Yes'){
        		vm.userprofile.userPriceCondition = 'LIMT';
        	}
        	if(vm.userprofile.userPriceCondition=='TKPR' && vm.isAllowTakeProfit!='Yes'){
        		vm.userprofile.userPriceCondition = 'LIMT';
        	}
            //load lookup and values for exposure type and exposure sub type
            loadLookupAndValues(vm.userprofile.userExposureType, vm.userprofile.userExposureSubType);
        }


        function updateCurrencyWiseUserPrefrencesForUser(result) {

           $rootScope.currencyWiseUserPreferenceSettings = [];


            angular.forEach(result,function(value){


                
    var currencyId = value.currencyPair.id;
    var shortName = value.shortName;

    if (!currencyId || !shortName) return;

    // Get existing object from map
    var obj = $rootScope.currencyWiseUserPreferenceSettings[currencyId];

    if (!obj) {
        obj = {
            currencyPair: value.currencyPair.code,
            configs: [null, null, null,null] // SPOT, TOM, CASH
        };
    }

    switch (shortName) {
        case "AllowedOrderPriceDeviationFromMarketPriceInPaise":
            obj.configs[0] = value.configValue;
            break;
        case "MaximumOrderValueHardCheck":
            obj.configs[1] = value.configValue;
            break;
        case "MaximumOrderValueSoftCheck":
            obj.configs[2] = value.configValue;
            break;
        case "AllowedOrderPriceDeviationFromMarketPriceInPercentage":
            obj.configs[3] = value.configValue;
            break;    
        default:
            console.warn("Unknown instrumentCode:", shortName);
    }
    
             $rootScope.currencyWiseUserPreferenceSettings[currencyId] =  obj;

            });

        }

        
        //load lookup and values for exposure type and exposure sub type
        function loadLookupAndValues(userExposureType, userExposureSubType){
            loadExposureTypeLookup(userExposureType);
            loadExposureSubTypeLookup(userExposureSubType);
        }
        
        //load lookup and value for exposure type 
        function loadExposureTypeLookup(userExposureType){
            ExposureType.getEnabledExposureTypes(function(result){
                vm.exposureTypes = result;
                angular.forEach(vm.exposureTypes, function(value){
                    if(value.name==userExposureType){
                        vm.exposureType = value;
                    }
                })
                if(vm.exposureType.id==null || vm.exposureType.id==undefined){
                    vm.exposureType = null;
                }
            })
        }
            
        //load lookup and value for exposure sub  type 
        function loadExposureSubTypeLookup(userExposureSubType){
            ExposureSubType.getEnabledExposureSubTypes(function(result){
                vm.exposureSubTypes = result;
                angular.forEach(vm.exposureSubTypes, function(value){
                    if(value.name==userExposureSubType){
                        vm.exposureSubType = value;
                    }
                })
                if(vm.exposureSubType.id==null || vm.exposureSubType.id==undefined){
                    vm.exposureSubType = null;
                }
            })
        }
        vm.validateOrderValue = function validateOrderValue(value){
        	vm.errorText1 = '';
        	if(value!=null && value!=undefined && value!=''){
                var maxHardCheck = vm.maximumOrderValueHardCheck; // Default to min if nothing else
                if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck) {
                    maxHardCheck = vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck;
                }
        		if(Number(value) < Number(vm.minimumOrderValue) || Number(value) > Number(maxHardCheck)){
        			vm.errorText1 = 'Value should be in between ' + $filter('number')(vm.minimumOrderValue,vm.noOfDecimalsForAmount) + ' and ' + $filter('number')(maxHardCheck,vm.noOfDecimalsForAmount) + '.';
        		}
        	}
        }
        
        vm.validateAllowedOrderPriceDeviationFromMarketPriceInPercentage = function validateAllowedOrderPriceDeviationFromMarketPriceInPercentage(value){
        	vm.errorText2 = '';
            var clearcorpMax = vm.allowedOrderPriceDeviationFromMarketPriceInPercentage;
            if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.currencyPair) {
                var paramValue = GlobalValues.getTransactionParameterValue(vm.currencyWiseUserPreferenceSettings.currencyPair.id, "AllowedOrderPriceDeviationFromMarketPriceInPercentage");
                if (paramValue != null) clearcorpMax = paramValue;
            }
        	if(Number(value) > Number(clearcorpMax)){
        		vm.errorText2 = "Value should be less than or equal to Clearcorp's hard check value " + $filter('number')(clearcorpMax,vm.noOfDecimalsForPercent) + '.';
        	}else if(Number(value) <= 0){
        		vm.errorText2 = "Value should be greater than 0.";
        	}
        }
        
        vm.validateMaximumOrderValueHardCheck = function validateMaximumOrderValueHardCheck(value){
        	vm.errorText3 = '';
            var clearcorpMax = vm.maximumOrderValueHardCheck;
            if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.currencyPair) {
                var paramValue = GlobalValues.getTransactionParameterValue(vm.currencyWiseUserPreferenceSettings.currencyPair.id, "MaximumOrderValueHardCheck");
                if (paramValue != null) clearcorpMax = paramValue;
            }
        	if(value!=null && value!=undefined && value!=''){
        		if(Number(value) > Number(clearcorpMax)){
        			vm.errorText3 = "Value should be less than or equal to Clearcorp's maximum order value hard check " + $filter('number')(clearcorpMax,vm.noOfDecimalsForAmount) + '.';
        		}else if(Number(value) <= Number(vm.minimumOrderValue)){
        			vm.errorText3 = "Value should be greater than Clearcorp's minimum order value " + $filter('number')(vm.minimumOrderValue,vm.noOfDecimalsForAmount) + '.';
        		}else if(Number(value) <= 0){
        			vm.errorText3 = "Value should be greater than 0.";
        		}
        	}
        }
        
        vm.validateMaximumOrderValueSoftCheck = function validateMaximumOrderValueSoftCheck(value){
        	vm.errorText4 = '';
            var clearcorpMax = vm.maximumOrderValueHardCheck;
            var maxHardCheck = clearcorpMax;
            if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.currencyPair) {
                var paramValue = GlobalValues.getTransactionParameterValue(vm.currencyWiseUserPreferenceSettings.currencyPair.id, "MaximumOrderValueHardCheck");
                if (paramValue != null) {
                    clearcorpMax = paramValue;
                    maxHardCheck = paramValue;
                }
            }
            if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck) {
                maxHardCheck = vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck;
            }
        	if(value!=null && value!=undefined && value!=''){
		        if(Number(value) > Number(clearcorpMax)){
        			vm.errorText4 = "Value should be less than or equal to Clearcorp's maximum order value hard check " + $filter('number')(clearcorpMax,vm.noOfDecimalsForAmount) + '.';
        		}else if(Number(value) > Number(maxHardCheck)){
		        	vm.errorText4 = "Value should be less than or equal to user level maximum order value hard check " + $filter('number')(maxHardCheck,vm.noOfDecimalsForAmount) + '.';
		        }else if(Number(value) <= 0){
		        	vm.errorText4 = "Value should be greater than 0.";
		        }
        	}
        }
        
        vm.validateAllowedOrderPriceDeviationFromMarketPriceInPaise = function validateAllowedOrderPriceDeviationFromMarketPriceInPaise(value){
        	vm.errorText5 = '';
            var clearcorpMax = vm.allowedOrderPriceDeviationFromMarketPriceInPaise;
            if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.currencyPair) {
                var paramValue = GlobalValues.getTransactionParameterValue(vm.currencyWiseUserPreferenceSettings.currencyPair.id, "AllowedOrderPriceDeviationFromMarketPriceInPaise");
                if (paramValue != null) clearcorpMax = paramValue;
            }
        	if(Number(value) > Number(clearcorpMax)){
        		vm.errorText5 = "Value should be less than or equal to Clearcorp's default value " + $filter('number')(clearcorpMax,vm.noOfDecimalsForPaise) + '.';
        	}else if(Number(value) <= 0){
        		vm.errorText5 = "Value should be greater than 0.";
        	}
        }

        function onGetUserProfileError(){
        	
        }
        
        function save(){
            if(vm.exposureType!=null||vm.exposureType!=undefined ){
                vm.userprofile.userExposureType = vm.exposureType.name;
            }

            if(vm.exposureSubType!=null||vm.exposureSubType!=undefined ){
                vm.userprofile.userExposureSubType = vm.exposureSubType.name;
            }
            
            if(vm.currencyWiseUserPreferenceSettings != undefined && vm.currencyWiseUserPreferenceSettings != null){
			UserProfile.UpdateCurrencyWiseUserPreferenceSettings(vm.currencyWiseUserPreferenceSettings);
			}
			UserProfile.updatePreferences(vm.userprofile, onSaveSuccess, onSaveError);
        }
        
        function onSaveSuccess(result){
            loadAll();
        	$uibModalInstance.close(result);
        }
        
        function onSaveError(){
        	 $scope.clicked=true;
        }


		function getCurrencyWiseUserPreference(currencyPair){
						UserProfile.getCurrencyWiseUserPreference({"currencyPairId": currencyPair.id,"userId" : vm.globalValues.getUserId()
			},ongetgetCurrencyWiseUserPreferenceSuccess, ongetCurrencyWiseUserPreferenceError);
		}

		function ongetgetCurrencyWiseUserPreferenceSuccess(result){
			vm.currencyWiseUserPreferenceSettings = result;
			vm.clicked=false;
		}

		function ongetCurrencyWiseUserPreferenceError(){
		vm.clicked=false;
		}

    }   
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('OrderActivityLog', OrderActivityLog);

        OrderActivityLog.$inject = ['$resource'];

    function OrderActivityLog($resource) {
    	 var resourceUrl =  '';
         
         return $resource(resourceUrl, {}, {
           'exportOrderActivityLogCSV':{
				method: 'POST',
				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId',reportDate:'@reportDate',currencyPairId : '@currencyPairId'},
				url: 'api/export-order-activity-log-csv',
				responseType: 'arraybuffer',
				transformResponse: function(data, headers) {
				   return {
					   data: data,
					   headers: headers
				   };   
			   } 

			 },
			 'exportOrderActivityLogExcel':{
				method: 'POST',
				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId',reportDate:'@reportDate', currencyPairId : '@currencyPairId'},
				url: 'api/export-order-activity-log-excel',
				responseType: 'arraybuffer',
				transformResponse: function(data, headers) {
				   return {
					   data: data,
					   headers: headers
				   };   
			   } 

			 }
         });
        }
    })();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('order-activity-log', {
            parent: 'entity',
            params:{screen: 'OrderActivityLog'},
            url: '/order-activity-log',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.orderActivityLog.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order-activity-log/order-activity-log.html',
                    controller: 'OrderActivityLogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('orderActivityLog');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        
        
         
         };
    })();
(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {
            this.viewFrom = 'orderActivityLog'
        })

        .controller('OrderActivityLogController', OrderActivityLogController);

        OrderActivityLogController.$inject = ['$scope', '$state', 'OrderActivityLog', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog', 'entityConstants',
        '$timeout', 'DateUtils', 'AlertService', '$filter'];

    function OrderActivityLogController($scope, $state, OrderActivityLog, GlobalValues, workflowSharedService, EntityPermissions, ScreenLog, entityConstants, $timeout, DateUtils,
        AlertService, $filter) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.ORDER_ACTIVITY_LOG;
        vm.globalValues = GlobalValues;
        vm.screenLog = ScreenLog;

        vm.todayDate = new Date();
        vm.reportDate = angular.copy(vm.todayDate);
        vm.minDate = DateUtils.getSubtractMonth(vm.todayDate,1);
        vm.maxDate = angular.copy(vm.todayDate);

       
        vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.orgId = vm.globalValues.getOrgId();
        vm.downloadFileType ="CSV" ;
        vm.downloadFileTypeIndicators = ["CSV","XLS"];
        vm.exportOrderActivityLogToFiles = exportOrderActivityLogToFiles;
        vm.clicked=false;
        logScreenAccess();
        setUsers();
        function setUsers() {
            if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
                vm.loggedInCustomer = vm.globalValues.getCustomerId();
           }
           if(vm.entityOwnerType=='Bank' || vm.entityOwnerType=='Branch'){
               vm.bank = vm.globalValues.getBank();
           }
           if(vm.entityOwnerType=='Branch'){
               vm.branch = vm.globalValues.getBranch();
           }
            
        }
  

		function prepareDataForCustomer() {
			if(vm.entityOwnerType == 'SingleUserCustomer' || vm.entityOwnerType == 'MultiUserCustomer')
				vm.customerId = vm.globalValues.getOrgId();
		}
		function prepareDataForOthers() {
			// if  bank user
			if (vm.entityOwnerType == 'Bank') {
				vm.bankId =  vm.globalValues.getOrgId();
			}
			// if branch user
			if (vm.entityOwnerType == 'Branch') {
				vm.bankId =  vm.globalValues.getOrgId();
				vm.branchId = vm.globalValues.getBranchId();
			}
			//if user manualy select bank and branch
			if(vm.bank!=null && vm.bank!=undefined){
    		   vm.bankId = vm.bank.id;
    	   	  }
    	   if(vm.branch!=null && vm.branch!=undefined){
    		   vm.branchId = vm.branch.id;
    	     }
            if (vm.customer != null && vm.customer != undefined) {
                vm.customerId = vm.customer.id;
		}

    }

        // download order activity log report 
        function exportOrderActivityLogToFiles() {
            vm.bankId = 0;
            vm.branchId = 0;
            vm.customerId = 0;
            vm.instrumentId = 0;
            vm.currencyPairId = 0;
            if (moment(vm.reportDate).isBefore(vm.minDate, 'day')) {
				AlertService.error($filter('translate')('gatewayApp.orderActivityLog.isBeforDate'));
				vm.valid = false;
			}else {
                vm.clicked=true;
                //prepare data to server for customers
                prepareDataForCustomer();
                //prepare data to server for bank,branch and clearcorp
                prepareDataForOthers();
                } 
                if (vm.instrument != null && vm.instrument != undefined) {
                    vm.instrumentId = vm.instrument.id;
                }
                if (vm.currencyPair != null && vm.currencyPair != undefined) {
                    vm.currencyPairId = vm.currencyPair.id;
                }
                var reportDate = DateUtils.convertLocalDateToServer(vm.reportDate);
              
	    
                if (vm.downloadFileType != null && vm.downloadFileType != undefined && vm.downloadFileType != "") {

                    vm.baseString = 'OrderActivityLog_' +moment(vm.reportDate).format('DD_MMM_YYYY');


                    if (vm.downloadFileType == 'CSV') {
                        vm.mimeType = 'text/csv'
                        vm.baseString = vm.baseString + ".csv";
                        OrderActivityLog.exportOrderActivityLogCSV ({"bankId":vm.bankId, "branchId": vm.branchId, "customerId": vm.customerId,"instrumentId": vm.instrumentId,"reportDate":reportDate,"currencyPairId": vm.currencyPairId}, processResponse,processfailde );
                    } else if (vm.downloadFileType == 'XLS') {
                        vm.mimeType = 'application/vnd.ms-excel';
                        vm.baseString = vm.baseString + ".xls";
                        OrderActivityLog.exportOrderActivityLogExcel({ "bankId":vm.bankId, "branchId": vm.branchId, "customerId": vm.customerId,"instrumentId": vm.instrumentId,"reportDate":reportDate,"currencyPairId": vm.currencyPairId}, processResponse,processfailde);
                    }
                }
            }

        function processResponse(result) {
            vm.clicked=false;
            var fileData = null;
            fileData = result.data;
            var link = document.createElement("a");
            var bytes = new Uint8Array(fileData);   // convert uint8 to binary
            if(fileData  !=null && fileData !=undefined && fileData.byteLength > 0){
            var blob = new Blob([bytes], { type: vm.mimeType });
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, vm.baseString);
            } else {
                link.href = window.URL.createObjectURL(blob);
                link.download = vm.baseString;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }else{
            AlertService.error("No Records Found");
        }
    }
    function processfailde(){
        vm.clicked=false;
    }
    function logScreenAccess(){
        ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
    }

  
}
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('OrderActivity', OrderActivity);

    OrderActivity.$inject = ['$resource'];

    function OrderActivity ($resource) {
        var resourceUrl =  'api/order-activity/:orderNumber';
        
        return $resource(resourceUrl, {}, {
        	
        
        	'get': {
                method: 'GET',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'orderActivityReport'
        })
        
        .controller('OrderActivityController', OrderActivityController);

    OrderActivityController.$inject = ['$scope', '$state', 'OrderActivity', 'GlobalValues', 'workflowSharedService', '$uibModalInstance','EntityPermissions', 'ScreenLog','entityConstants','$timeout','entity','IntradayMarket','DateUtils', 'businessDate'];

    function OrderActivityController($scope, $state, OrderActivity , GlobalValues, workflowSharedService, $uibModalInstance, EntityPermissions, ScreenLog,entityConstants,$timeout,entity, IntradayMarket,DateUtils,businessDate) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.ORDERACTIVITYREPORT;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        vm.clear=clear;
        vm.todayDate = new Date();
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        
        loadCurrentBusinessDate();
        if(businessDate!=null && businessDate != undefined){
        	vm.todayDate = businessDate;
        }
        
        angular.forEach(entity, function(value){
        	
	              	value.revisionTimeStamp=moment(value.revisionTimeStamp,'YYYYMMDDHHmmss.SSSSSSSSS').format();
	              	
	              	if(value.expiryTime==0){
	              		var time = moment().toDate();
		              	time.setHours(0);
		              	time.setMinutes(0);
		              	time.setSeconds(0);
		              	time.setMilliseconds(0);
		              	value.expiryTime=time;
	              	}else{
	              		value.expiryTime=moment(value.expiryTime,'YYYYMMDDHHmmss').format();
	              	}
	              	
	              	
	             // 	value.activityTimeStamp=moment(value.activityTimeStamp,'YYYYMMDDHHmmss.SSSSSSSSS').format();
	              	if(value.activityIndicator=='PLAC'){
	              		value.activityIndicator='Add';
	              	}else if(value.activityIndicator=='MDFY'){
	              		value.activityIndicator='Modify';
	              	}else if(value.activityIndicator=='CNCL'){
	              		value.activityIndicator='Cancel';
	              	}else if(value.activityIndicator == 'TRAD'){
	              		value.activityIndicator='Trade';
	              	}
	              	
	              	if(value.buySellFlag.toUpperCase()=='BUYY'){
	              		value.buySellFlag='Buy';
	              	}
	              	else{
	              		value.buySellFlag='Sell';
	              	}
	              	
	              	
	              	if(value.timeLimitIndicator.toUpperCase()!='GTTM'){
	              		value.expiryTime=null;
	              	}
	              	
	              	if(value.priceConditionName!='Stop Loss' && value.priceConditionName!='Take Profit'){
	              		value.stopExchangeRate=null;
	              	}
	              	
	              	if(value.tradeSequenceNumber==0){
	              		value.tradeSequenceNumber=0;
	              	}
	              	
    	});
        
        vm.orderActivityDetails=entity;
        
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       function loadCurrentBusinessDate(){
    	   IntradayMarket.getCurrentBusinessDate(getBusinessDateSuccess, getBusinessDateFailed);
       }
       
       function getBusinessDateSuccess(result){
    	   vm.currentBusinessDate = DateUtils.convertLocalDateFromServer(result.businessDate);
    	   
    	   vm.convertedCurrentBusinessDate=DateUtils.convertLocalDateToServer(vm.currentBusinessDate);
    	  
       }
       
       function getBusinessDateFailed(){
    	   
       }
       
       function clear () {
           $uibModalInstance.dismiss('cancel');
       }

	   vm.getSwapPoints = function getSwapPoints(spotExchangeRate, tradeExchangeRate){
		var swapPts =0;
		if(spotExchangeRate!=0){
		 var swapPts = Math.abs(spotExchangeRate - tradeExchangeRate) * 100
		 swapPts = (Math.round(parseFloat(swapPts)*100)/100);
		 return swapPts;
		}else{
		 return swapPts;
		}
	   }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('notification-settings', {
            parent: 'entity',
            params:{screen: 'BankNotificationSettings'},
            url: '/notification-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.notificationSettings.settings" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notification-settings/notification-settings.html',
                    controller: 'NotificationSettingsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'smd',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:true});
                }, function() {
                    $state.go('home', null, {reload:true});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('notificationSettings');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
           .state('change-notification-settings', {
                    parent: 'notification-settings',
                    url: '/change-notification-settings/{headerLabel}/{labelName}/{settingsName}/{settingsValue}/{settingsType}/{screenName}',
                    data: {
                        authorities: ['ROLE_USER'],
                        pageTitle: 'global.title'
                    },
                    ncyBreadcrumb: {
                        label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                        parent: 'user-profile'
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/notification-settings/change-notification-setting.html',
                            controller: 'ChangeNotificationSettingsController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'sm',
                            resolve: {
                                entity: function(){
                                    
                                }
                            }
                        }).result.then(function() {
                            $state.go('^', {}, { reload: false });
                        }, function() {
                            $state.go('^');
                        });
                    }],
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('notificationSettings');
                            $translatePartialLoader.addPart('userProfile');
                            $translatePartialLoader.addPart('user-management');
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                       
                    }
                })
                
                 .state('notification-settings-auditlog', {
                    parent: 'audit-log',
                    url: '/notification-settings-auditlog',
                    data: {
                        authorities: ['ROLE_USER'],
                        pageTitle: 'global.title'
                    },
                    ncyBreadcrumb: {
                        label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                        parent: 'user-profile'
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/notification-settings/change-notification-setting.html',
                            controller: 'ChangeNotificationSettingsController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'sm',
                            resolve: {
                                entity: function(){
                                    
                                }
                            }
                        }).result.then(function() {
                            $state.go('^', {}, { reload: false });
                        }, function() {
                            $state.go('^');
                        });
                    }],
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('notificationSettings');
                            $translatePartialLoader.addPart('userProfile');
                            $translatePartialLoader.addPart('user-management');
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                       
                    }
                })
                .state('notification-settings-historyreport', {
                    parent: 'history-report',
                    url: '/notification-settings-historyreport',
                    data: {
                        authorities: ['ROLE_USER'],
                        pageTitle: 'global.title'
                    },
                    ncyBreadcrumb: {
                        label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                        parent: 'user-profile'
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/notification-settings/change-notification-setting.html',
                            controller: 'ChangeNotificationSettingsController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'sm',
                            resolve: {
                                entity: function(){
                                    
                                }
                            }
                        }).result.then(function() {
                            $state.go('^', {}, { reload: false });
                        }, function() {
                            $state.go('^');
                        });
                    }],
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('notificationSettings');
                            $translatePartialLoader.addPart('userProfile');
                            $translatePartialLoader.addPart('user-management');
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                       
                    }
                })
                
                .state('notification-settings-todolist', {
                    parent: 'dashboard',
                    url: '/notification-settings-view',
                    data: {
                        authorities: ['ROLE_USER'],
                        pageTitle: 'global.title'
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/notification-settings/change-notification-setting.html',
                            controller: 'ChangeNotificationSettingsController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'sm',
                            resolve: {
                                entity: function () {                        	
                                    return {
                                            
                                    };
                                }
                            }
                        }).result.then(function() {
                            $state.go('^', null, { reload: true });
                        }, function() {
                            $state.go('^');
                        });
                    }],
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('notificationSettings');
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                       
                    }
                })
                .state('notification-todoList-resubmit', {
                    parent: 'dashboard',
                    url: '/notification-resubmit',
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/notification-settings/change-notification-setting.html',
                            controller: 'ChangeNotificationSettingsController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'sm',
                            resolve: {
                              entity: function () {                        	
        
                                }
                            }
                        }).result.then(function() {
                            $state.go('^', null, { reload: true });
                        }, function() {
                            $state.go('^');
                        });
                    }],
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('notificationSettings');
                             $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                       
                    }
                })
         };
    })();

(function() {
	'use strict';
	angular.module('gatewayApp').factory('NotificationSettings', NotificationSettings);

	NotificationSettings.$inject = [ '$resource' ];

	function NotificationSettings($resource) {
		var resourceUrl = 'api/bankSpecificSettings/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				 params: {bankId: '@bankId'},
				url : 'api/get-bank-specific-settings',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'updateNotificationSettings' : {
				method : 'POST',
				params:{notificationSettings:'notificationSettings'},
				url : 'api/bank-notification-settings',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                }                
			},
			'approve' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/approve'
			},
			'reject' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/reject'
			},
			'discard' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/discard'
			},
			'resubmitForEdit' : {
				method : 'PUT',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/resubmit/notificationSettings',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function() {
		this.viewFrom = 'changeSettings'
	})

	.controller('NotificationSettingsController', NotificationSettingsController);

	NotificationSettingsController.$inject = [ '$scope', '$state',
			'workflowSharedService', 'NotificationSettings', 'GlobalValues',
			'EntityPermissions', 'ScreenLog', 'DateUtils','$uibModalInstance','$stateParams','$rootScope','entityConstants' ];

	function NotificationSettingsController($scope, $state, workflowSharedService,
        NotificationSettings, GlobalValues, EntityPermissions, ScreenLog, DateUtils,$uibModalInstance,$stateParams,$rootScope,entityConstants) {

		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenLog = ScreenLog;
		vm.notificationSettings = {};
		vm.save = save;
		vm.userId = $stateParams.userId;
		vm.restoreDefault = restoreDefault;
		vm.launch = launch;
		vm.clear = clear;
		workflowSharedService.viewFrom = 'changeSettings';
		vm.isShowRegistrationSettings = true;
		 vm.bankId = vm.globalValues.getBankId();
		 vm.isShowOrderSettings=true;
		function launch() {
			$state.go("notification-settings");
		}
		logScreenAccess();
		loadAll();

		function loadAll() {
			NotificationSettings.get({
				"bankId" : vm.bankId
			},onGetNotificationSettingsSuccess, onGetNotificationSettingsError);
		}

		function onGetNotificationSettingsSuccess(result) {
			vm.notificationSettings = result;
			if(vm.notificationSettings.IsTradeEmailToBeSent==null || vm.notificationSettings.IsTradeEmailToBeSent == undefined)
				{
				vm.notificationSettings.IsTradeEmailToBeSent='Yes';
				}
	
		}

		function onGetNotificationSettingsError() {

		}
		
		function restoreDefault() {
			loadAll();
		}
		
	
		function save() {
			var fd = new FormData();
			
			vm.user.dob = DateUtils.convertLocalDateToServer(vm.user.dob);
			fd.append('user', JSON.stringify(vm.user));
            
			console.log(fd);

			NotificationSettings.update( fd, onSaveSuccess, onSaveError);
			
		}
		
		$rootScope.$on('Refresh', function(event, result) {
			loadAll();
		});
		
		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
		}

		function onSaveError() {

			$scope.clicked = false;
		}
		function logScreenAccess(){
	       	ScreenLog.screenLog(entityConstants.ENTITY_SHORT_NAME.NOTIFICATION_SETTINGS ,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
	    }

	}
})();

(function() {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function() {
		this.viewFrom = 'changeNotificationSettingsController'
	})

	.controller('ChangeNotificationSettingsController', ChangeNotificationSettingsController);

	ChangeNotificationSettingsController.$inject = [ '$scope', '$state',
			'workflowSharedService', 'NotificationSettings', 'GlobalValues',
			'EntityPermissions', 'ScreenLog', '$stateParams',
			'$uibModalInstance', '$rootScope', 'MessageBox', 'Workflow','entity','DateUtils', '$filter'];

	function ChangeNotificationSettingsController($scope, $state, workflowSharedService,
		NotificationSettings, GlobalValues, EntityPermissions, ScreenLog,
			$stateParams, $uibModalInstance, $rootScope, MessageBox, Workflow,entity,DateUtils, $filter) {

		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenLog = ScreenLog;
		vm.saveNotificationSettings = saveNotificationSettings;
		vm.notificationSettings = {};
		vm.controlMin=null;
		vm.controlMax=null;
		vm.bankId = vm.globalValues.getBankId();
		vm.notificationSettings.bankId=vm.bankId ;
/*		$("#date_input").on("change", function () {
		     $(this).css("color", "rgba(0,0,0,0)").siblings(".datepicker_label").css({ "text-align":"center", position: "absolute",left: "10px", top:"14px",width:$(this).width()}).text($(this).val().length == 0 ? "" : ($.datepicker.formatDate($(this).attr("dateformat"), new Date($(this).val()))));
		        });*/
		
		vm.approveNotificationSettings = approveNotificationSettings;
		vm.rejectNotificationSettings = rejectNotificationSettings;
		vm.discardNotificationSettings = discardNotificationSettings;
		vm.resubmitNotificationSettings = resubmitNotificationSettings;
		vm.clear = clear;
		$scope.showButton = false;
		$scope.isShowSaveButton = false;
		$scope.showDiscardButton = false;
		$scope.isShowResubmit = false;
		$scope.isShowOkButton = false;
		vm.isPasswordPolicySelected = true;

		vm.clicked = false;
		vm.noOfDecimals=0;



		if (workflowSharedService.viewFrom == 'notificationSettingstodolist_checker') {
			vm.ViewDisable = true;

			vm.notificationSettings = angular.fromJson($rootScope.payload);
			console.log(vm.notificationSettings);
			vm.headerLabel = "Order Settings";
			vm.labelName = vm.notificationSettings.bankSpecificSettingsList.settingsDescription;
			vm.settingsName = vm.notificationSettings.bankSpecificSettingsList.settingsName;
			if(vm.notificationSettings.settingsType=='amcdate'){
				vm.settingsValue = DateUtils.convertLocalDateFromServer(vm.notificationSettings.value);
			}else{
				vm.settingsValue = vm.notificationSettings.value;
			}
			
			vm.settingsType = vm.notificationSettings.settingsType;
			vm.screenName = 'dealingAdmin';
			vm.isDisabled = true
			$scope.showButton = true;
			$scope.showDiscardButton = false;
			$scope.isShowResubmit = false;
			$scope.isShowSaveButton = false;

		} else if (workflowSharedService.viewFrom =='notificationSettingstodolist_maker') {
			vm.ViewDisable = true;
			vm.notificationSettings = angular.fromJson($rootScope.payload);
			vm.headerLabel =  "Order Settings";
			vm.labelName =  vm.notificationSettings.bankSpecificSettingsList.settingsDescription;
			vm.settingsName =  vm.notificationSettings.bankSpecificSettingsList.settingsName;
			if(vm.notificationSettings.settingsType=='amcdate'){
				vm.settingsValue = DateUtils.convertLocalDateFromServer(vm.notificationSettings.value);
			}else{
				vm.settingsValue = vm.notificationSettings.value;
			}
			vm.settingsType =  vm.notificationSettings.settingsType;
			vm.screenName = 'dealingAdmin';
			vm.isDisabled = true
			$scope.showButton = false;
			$scope.showDiscardButton = true;
			$scope.isShowSaveButton = false;
			$scope.isShowResubmit = false;
		}

		else if (workflowSharedService.viewFrom == 'notificationSettingstodolist_resubmit') {
			vm.notificationSettings = angular.fromJson($rootScope.payload);
			vm.headerLabel =  "Order Settings";
			vm.labelName =  vm.notificationSettings.bankSpecificSettingsList.settingsDescription;
			vm.settingsName = vm.notificationSettings.bankSpecificSettingsList.settingsName;
			if(vm.notificationSettings.settingsType=='amcdate'){
				vm.settingsValue = DateUtils.convertLocalDateFromServer(vm.notificationSettings.value);
			}else{
				vm.settingsValue = vm.notificationSettings.value;
			}
			
			vm.settingsType =  vm.notificationSettings.settingsType;
			vm.isDisabled = false;
			vm.screenName = 'dealingAdmin';
			$scope.isShowResubmit = true;
			$scope.isShowSaveButton = false;

		} 		else if (workflowSharedService.viewFrom == 'notificationSettingstodolist_auditlog') {
			
			vm.notificationSettings = angular.fromJson($rootScope.payload);;
			vm.headerLabel = "Order Settings";
			vm.labelName = vm.notificationSettings.bankSpecificSettingsList.settingsDescription;
			vm.settingsName = vm.notificationSettings.settingsName;
			if(vm.notificationSettings.settingsType=='amcdate'){
				vm.settingsValue = DateUtils.convertLocalDateFromServer(vm.notificationSettings.value);
			}else{
				vm.settingsValue = vm.notificationSettings.value;
			}
			vm.settingsType = vm.notificationSettings.settingsType;
			vm.isDisabled = true;
			$scope.isShowResubmit = false;
			$scope.isShowSaveButton = false;
			$scope.isShowOkButton = true;

		} 
		else {
			vm.notificationSettings.isDefault = false;
			vm.notificationSettings.settingsName =  $stateParams.settingsName;
			vm.notificationSettings.value = $stateParams.settingsValue;
			vm.notificationSettings.settingsType = $stateParams.settingsType;
			
			vm.headerLabel = $stateParams.headerLabel;
			vm.labelName = $stateParams.labelName;
			vm.settingsName = $stateParams.settingsName;
			if($stateParams.settingsType=='amcdate'){
			
				
				vm.settingsValue = moment($stateParams.settingsValue,'DD/MM').toDate();
			}else{
				vm.settingsValue = $stateParams.settingsValue;
			}
			
			vm.settingsType = $stateParams.settingsType;
			vm.screenName = $stateParams.screenName;
			$scope.isShowSaveButton = true;
			console.log(vm.notificationSettings.value);
		}
		function saveNotificationSettings() {

			if(vm.settingsType == 'yesorno' ){
				vm.notificationSettings.value = vm.settingsValue;
			}
			
			NotificationSettings.updateNotificationSettings(vm.notificationSettings, onSaveSuccess, onSaveError)	

			
		}

		function onSaveSuccess(result) {
			$scope.$emit('Refresh');
			$uibModalInstance.close();

		}

		function onSaveError() {

			vm.clicked = false;
		}

		function approveNotificationSettings() {
			NotificationSettings.approve({
				"taskId" : $rootScope.taskID
			}, onApproveSuccess, onApproveError);
			
		}

		function onApproveSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close();
		}
		function onApproveError(error) {
			vm.clicked=false;
		}

		function rejectNotificationSettings() {
			Workflow.rejectTask($rootScope.taskID);
		}

		function discardNotificationSettings() {
			NotificationSettings.discard({
				"taskId" : $rootScope.taskID
			}, onDiscardSuccess, onDiscardError);
			
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close();
		}
		function onDiscardError(error) {

		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close(result);
			$uibModalInstance.close();
		}

		function onResubmitError(error) {
			vm.clicked=false;
		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function resubmitNotificationSettings() {
			if(vm.settingsType == 'yesorno' ){
				vm.notificationSettings.value = vm.settingsValue;
			}
			
			NotificationSettings.resubmitForEdit({
					"taskId" : $rootScope.taskID
				}, vm.notificationSettings, onResubmitSuccess, onResubmitError);
		

			
		}
		
		


	}
})();

(function() {
	'use strict';
	angular
		.module('gatewayApp')
		.factory('ModifyCustomerDetailsService', ModifyCustomerDetailsService);

	ModifyCustomerDetailsService.$inject = [ '$resource' ];

	function ModifyCustomerDetailsService($resource) {
		var resourceUrl = 'api/trading-branch-edi';

		return $resource(resourceUrl, {}, {
			
			'resubmit' : {
				method : 'PUT',
				params : {
					taskId : '@taskId',
					oldBranchId : '@oldBranchId'
				},
				url : 'api/tasks/resubmit-modify-customer-details',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'discard' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/discard'
			},			
			'editTradingBranch':{
        		method: 'PUT',
  				params: {orgId:'@orgId', oldBranchId:'@oldBranchId'},
  				url: 'api/trading-branch-edit',
  				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}      					
			},
			'approve': {
               method: 'GET',
               params: {taskId:'@taskId'},
               url: 'api/tasks/:taskId/approve'
			}

		});
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('MarkupSettingsViewController', MarkupSettingsViewController);

    MarkupSettingsViewController.$inject = ['$scope', '$state','$rootScope','workflowSharedService','$uibModalInstance','Markup','entity', 'Workflow', 'GlobalValues', 'ScreenLog','StaticLookUp','markupTypes','DateUtils', 'roEdApplicabilityMethods' ];

    function MarkupSettingsViewController($scope, $state, $rootScope, workflowSharedService, $uibModalInstance,Markup,entity, Workflow, GlobalValues, ScreenLog, StaticLookUp,markupTypes,DateUtils, roEdApplicabilityMethods) {
        var vm = this;
        vm.clear=clear;
        vm.approveMarkup = approveMarkup;
        vm.rejectMarkup = rejectMarkup;
        vm.discardMarkup = discardMarkup;
        $scope.showButton = false;
        $scope.showDiscardButton = false;
        $scope.clicked=false;
        vm.globalValues = GlobalValues;
        vm.markupTypes = markupTypes;
        vm.orgId = vm.globalValues.getOrgId();
        vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.decimalForPaise = vm.globalValues.getNumberOfDecimalsForRateInReports();
        
        //get RO/ED applicability method list lookup
        // StaticLookUp.getRoEdApplicabilityMethodList(function(result){
        //     vm.roEdApplicabilityMethodList = result;
        // });
        vm.roEdApplicabilityMethodList = roEdApplicabilityMethods;
        vm.hideRoEdApplicability = false;

        $scope.$watch('vm.markupType', function(value){
        	if(value!=null && value!=undefined){
        		if(vm.markupType.shortName.toUpperCase()=='PERCENTAGE'){
        			vm.noOfDecimals=vm.decimalsForPercent;
        		}else{
        			vm.noOfDecimals=vm.decimalForPaise;
        		}
        	}
        });
        
        
        if(workflowSharedService.viewFrom == 'markup'){
        	vm.markup = entity;    
        	vm.effectiveFromDateTime = DateUtils.convertDateTimeFromServer(vm.markup.effectiveFromDateTime);
        	
        	vm.bank=vm.markup.bank;
        	vm.branch=vm.markup.branch;
        	angular.forEach(vm.markupTypes, function(value){
        		if(value.shortName.toUpperCase()==vm.markup.markupType.toUpperCase()){
            		vm.markupType = value; 
        		}
        	});
            if(vm.markup.roEdApplicabilityMethod!=null && vm.markup.roEdApplicabilityMethod!=undefined){
                vm.roEdApplicabilityMethod = vm.markup.roEdApplicabilityMethod;
            }else{
                var defaultROEDApplicabilityMethod = _.filter(angular.copy(vm.roEdApplicabilityMethodList), { 'shortName': 'BOTHLEGS' });
                vm.roEdApplicabilityMethod = defaultROEDApplicabilityMethod[0];
            }

       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'markuptodolist_checker') {
        	vm.markup =  angular.fromJson($rootScope.payload); 
        	vm.effectiveFromDateTime = DateUtils.convertDateTimeFromServer(vm.markup.effectiveFromDateTime);
        	vm.bank=vm.markup.bank;
        	vm.branch=vm.markup.branch;
        	angular.forEach(vm.markupTypes, function(value){
        		if(value.shortName.toUpperCase()==vm.markup.markupType.toUpperCase()){
            		vm.markupType = value; 
        		}
        	});
            if(vm.markup.roEdApplicabilityMethod!=null && vm.markup.roEdApplicabilityMethod!=undefined){
                vm.roEdApplicabilityMethod = vm.markup.roEdApplicabilityMethod;
            }else{
                var defaultROEDApplicabilityMethod = _.filter(angular.copy(vm.roEdApplicabilityMethodList), { 'shortName': 'BOTHLEGS' });
                vm.roEdApplicabilityMethod = defaultROEDApplicabilityMethod[0];
            }
        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
        }
        else if(workflowSharedService.viewFrom == 'markuptodolist_maker') {
        	vm.markup =  angular.fromJson($rootScope.payload); 
        	vm.effectiveFromDateTime = DateUtils.convertDateTimeFromServer(vm.markup.effectiveFromDateTime);
        	vm.bank=vm.markup.bank;
        	vm.branch=vm.markup.branch;
        	angular.forEach(vm.markupTypes, function(value){
        		if(value.shortName.toUpperCase()==vm.markup.markupType.toUpperCase()){
            		vm.markupType = value; 
        		}
        	});
            if(vm.markup.roEdApplicabilityMethod!=null && vm.markup.roEdApplicabilityMethod!=undefined){
                vm.roEdApplicabilityMethod = vm.markup.roEdApplicabilityMethod;
            }else{
                var defaultROEDApplicabilityMethod = _.filter(angular.copy(vm.roEdApplicabilityMethodList), { 'shortName': 'BOTHLEGS' });
                vm.roEdApplicabilityMethod = defaultROEDApplicabilityMethod[0];
            }
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        }
        else if(workflowSharedService.viewFrom=='markup_import_auditlog'){
        	
        	vm.markup =  angular.fromJson($rootScope.payload);   
        	console.log(vm.markup);
        	
        	vm.effectiveFromDateTime = DateUtils.convertDateTimeFromServer(vm.markup.effectiveFromDateTime);
        	vm.bank=vm.markup.markupSettings.bank;
        	vm.branch=vm.markup.markupSettings.branch;
        	vm.markup.customer = vm.markup.markupSettings.customer;
        	vm.markup.markupValue = vm.markup.markupSettings.markupValue;
        	angular.forEach(vm.markupTypes, function(value){
        		if(value.shortName.toUpperCase()==vm.markup.markupSettings.markupType.toUpperCase()){
            		vm.markupType = value; 
        		}
        	});
            if(vm.markup.roEdApplicabilityMethod!=null && vm.markup.roEdApplicabilityMethod!=undefined){
                vm.roEdApplicabilityMethod = vm.markup.roEdApplicabilityMethod;
            }else{
                vm.hideRoEdApplicability = true;
                //var defaultROEDApplicabilityMethod = _.filter(angular.copy(vm.roEdApplicabilityMethodList), { 'shortName': 'BOTHLEGS' });
                //vm.roEdApplicabilityMethod = defaultROEDApplicabilityMethod[0];
            }
        	$scope.showButton=false;

        }
        else if(workflowSharedService.viewFrom=='markup_auditLog'){
        	vm.markup =  angular.fromJson($rootScope.payload);   
        	vm.effectiveFromDateTime = DateUtils.convertDateTimeFromServer(vm.markup.effectiveFromDateTime);
            vm.bank=vm.markup.bank;
            vm.branch=vm.markup.branch;

        	angular.forEach(vm.markupTypes, function(value){
        		if(value.shortName.toUpperCase()==vm.markup.markupType.toUpperCase()){
            		vm.markupType = value; 
        		}
        	});
            if(vm.markup.roEdApplicabilityMethod!=null && vm.markup.roEdApplicabilityMethod!=undefined){
                vm.roEdApplicabilityMethod = vm.markup.roEdApplicabilityMethod;
            }else{
                vm.hideRoEdApplicability = true;
                //var defaultROEDApplicabilityMethod = _.filter(angular.copy(vm.roEdApplicabilityMethodList), { 'shortName': 'BOTHLEGS' });
                //vm.roEdApplicabilityMethod = defaultROEDApplicabilityMethod[0];
            }
        	$scope.showButton=false;
        }
        
        function approveMarkup() { 
        	Markup.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectMarkup() { Workflow.rejectTask($rootScope.taskID); }

        function discardMarkup() {
        	Markup.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }

       
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('MarkupSettingsEditController', MarkupSettingsEditController);

    MarkupSettingsEditController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','Markup','entity','StaticLookUp', 'markupTypes','DateUtils', 'roEdApplicabilityMethods'];

     function MarkupSettingsEditController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,Markup,entity,StaticLookUp, markupTypes, DateUtils, roEdApplicabilityMethods) {
        var vm = this;
        vm.markup=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        vm.resubmitMarkup = resubmitMarkup;
        vm.globalValues = GlobalValues;
        vm.markupTypes = markupTypes;
        vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
        $scope.showButton = false;
        vm.orgId = vm.globalValues.getOrgId();
        vm.currentBusinessDate = vm.globalValues.getSystemSettings().businessDate;
        
        vm.effectiveFromDateTime = DateUtils.convertLocalDateFromServer(vm.currentBusinessDate);
        vm.todayDate = new Date();
        
        //get RO/ED applicability method list lookup
        // StaticLookUp.getRoEdApplicabilityMethodList(function(result){
        //     vm.roEdApplicabilityMethodList = result;
        // });
		vm.roEdApplicabilityMethodList = roEdApplicabilityMethods;
        
        var now = moment();
   	 	vm.momentBusinessDate = moment(vm.currentBusinessDate, 'YYYY-MM-DD');        	
   	 	vm.momentBusinessDate.set(
   			 { 	'hour':now.get('hour'),
   				'minute':now.get('minute'),
   				'second':now.get('second')
   				
   			 });
   	 	vm.effectiveFromDateTime = vm.momentBusinessDate.toDate();
   	 
        vm.disableTax=false;
        vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.decimalForPaise = vm.globalValues.getNumberOfDecimalsForRateInReports();
       
       vm.todayDate = new Date();
       angular.forEach(vm.markupTypes, function(value){
   		if(value.shortName.toUpperCase()=='PAISE'){
       		vm.markupType = value; 
   		}
   	});
       
       $scope.$watch('vm.markupType', function(value){
       	if(value!=null && value!=undefined){
       		if(vm.markupType.shortName.toUpperCase()=='PERCENTAGE'){
       			vm.noOfDecimals=vm.decimalsForPercent;
    			document.getElementById("txtMarkupValue2").value = "";
    			vm.markup.markupValue = null;
       		}else{
       			vm.noOfDecimals=vm.decimalForPaise;
    			document.getElementById("txtMarkupValue1").value = "";
    			vm.markup.markupValue = null;
       		}
       	}
       });
       
       $scope.$watch('vm.markup.markupValue', function(value){
       	if(value==null || value==undefined || value==""){
       		
       		vm.disableTax=true;
       		document.getElementById("txtTaxOnMarkup").value = "";
       		vm.markup.taxOnMarkup=null;
       		
       	}else{
       		vm.disableTax=false;
       	}
       });
                
        if(workflowSharedService.viewFrom == 'markup'){
        	vm.markup=entity;
        	
        	if(vm.markup!=null && vm.markup!=undefined){
        		vm.branch=vm.markup.branch;
        		
        	}
        	vm.effectiveFromDateTime = DateUtils.convertLocalDateFromServer(vm.currentBusinessDate);
        	 if(vm.entityOwnerType=='Bank'){
          	   vm.bank=vm.globalValues.getBank();
             }else if(vm.entityOwnerType=='Branch'){
          	   vm.bank=vm.globalValues.getBranch().bank;
          	   vm.branch=vm.globalValues.getBranch();
             }
        	 if(vm.markup.markupType!=null && vm.markup.markupType!=undefined){
        		 angular.forEach(vm.markupTypes, function(value){
             		if(value.shortName.toUpperCase()==vm.markup.markupType.toUpperCase()){
                 		vm.markupType = value; 
             		}
             	});
        	 }
          if(vm.markup.roEdApplicabilityMethod!=null && vm.markup.roEdApplicabilityMethod!=undefined){
              vm.roEdApplicabilityMethod = vm.markup.roEdApplicabilityMethod;
          }else{
              var defaultROEDApplicabilityMethod = _.filter(angular.copy(vm.roEdApplicabilityMethodList), { 'shortName': 'BOTHLEGS' });
              vm.roEdApplicabilityMethod = defaultROEDApplicabilityMethod[0];
          }

       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'markuptodolist_resubmit') {
        	vm.markup =  angular.fromJson($rootScope.payload);
        	vm.bank=vm.markup.bank;
        	vm.branch=vm.markup.branch;
        	vm.effectiveFromDateTime = DateUtils.convertLocalDateFromServer(vm.currentBusinessDate);
        	angular.forEach(vm.markupTypes, function(value){
        		if(value.shortName.toUpperCase()==vm.markup.markupType.toUpperCase()){
            		vm.markupType = value; 
        		}
        	});
          if(vm.markup.roEdApplicabilityMethod!=null && vm.markup.roEdApplicabilityMethod!=undefined){
              vm.roEdApplicabilityMethod = vm.markup.roEdApplicabilityMethod;
          }else{
              var defaultROEDApplicabilityMethod = _.filter(angular.copy(vm.roEdApplicabilityMethodList), { 'shortName': 'BOTHLEGS' });
              vm.roEdApplicabilityMethod = defaultROEDApplicabilityMethod[0];
          }

        	vm.disableForm = false;
        	$scope.showButton=true;
        }
        else if(workflowSharedService.viewFrom == 'markup_resubmit_delete') {
        	
        	vm.markup = angular.fromJson($rootScope.payload); 
        	vm.bank=vm.markup.bank;
        	vm.branch=vm.markup.branch;
        	vm.effectiveFromDateTime = DateUtils.convertLocalDateFromServer(vm.currentBusinessDate);
        	angular.forEach(vm.markupTypes, function(value){
        		if(value.shortName.toUpperCase()==vm.markup.markupType.toUpperCase()){
            		vm.markupType = value; 
        		}
        	});
          if(vm.markup.roEdApplicabilityMethod!=null && vm.markup.roEdApplicabilityMethod!=undefined){
              vm.roEdApplicabilityMethod = vm.markup.roEdApplicabilityMethod;
          }else{
              var defaultROEDApplicabilityMethod = _.filter(angular.copy(vm.roEdApplicabilityMethodList), { 'shortName': 'BOTHLEGS' });
              vm.roEdApplicabilityMethod = defaultROEDApplicabilityMethod[0];
          }

        	vm.disableForm = true;
        	$scope.showButton=true;
        }
		
		

        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	vm.markup.markupType = vm.markupType.shortName;
        	vm.markup.roEdApplicabilityMethod = vm.roEdApplicabilityMethod;
        	vm.markup.bank=vm.bank;
        	vm.markup.branch=vm.branch;
        	vm.markup.effectiveFromDateTime = vm.momentBusinessDate.toDate();
        	
        	if (vm.markup.id != null) {
				Markup.update({
					"orgId" : GlobalValues.getOrgId()
				}, vm.markup, onSaveSuccess, onSaveError);
			} else {
				Markup.save({
					"orgId" : GlobalValues.getOrgId()
				}, vm.markup, onSaveSuccess, onSaveError);
			}
        	
         }
      
       
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	
        	vm.clicked = false;
        }
        function resubmitMarkup() {
        	vm.markup.markupType = vm.markupType.shortName;
        	vm.markup.roEdApplicabilityMethod = vm.roEdApplicabilityMethod;
        	vm.markup.bank=vm.bank;
        	vm.markup.branch=vm.branch;
        	vm.markup.effectiveFromDateTime = vm.momentBusinessDate.toDate();
        	
        	Markup.resubmit({"taskId" : $rootScope.taskID}, vm.markup, onResubmitSuccess, onResubmitError);
        	
       		
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {}

       
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('markup-settings', {
            parent: 'entity',
            url: '/markup-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.markupSettings.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/markup-settings/markup-settings.html',
                    controller: 'MarkupSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('markupSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('markup-view', {
            parent: 'markup-settings',
            url: '/markup-settings/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/markup-settings/markup-settings-view-dialog.html',
                    controller: 'MarkupSettingsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['Markup', 'GlobalValues', function(Markup, GlobalValues) {
                                     return Markup.get({id : $stateParams.id}).$promise;
                                 }], 
                                 markupTypes: ['StaticLookUp', function(StaticLookUp){
                                	 return StaticLookUp.getMarkupTypes().$promise;
                                 }],
                                 roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                                    return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                                }]
                               
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('markup-new', {
            parent: 'markup-settings',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/markup-settings/markup-settings-dialog.html',
                    controller: 'MarkupSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	                           	
                             
                            };
                        }, 
                        markupTypes: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('markup-edit', {
            parent: 'markup-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/markup-settings/markup-settings-dialog.html',
                    controller: 'MarkupSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['Markup', 'GlobalValues', function(Markup, GlobalValues) {
                                     return Markup.get({id : $stateParams.id}).$promise;
                                 }], 
                                 markupTypes: ['StaticLookUp', function(StaticLookUp){
                                	 return StaticLookUp.getMarkupTypes().$promise;
                                 }],
                                 roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                                    return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                                }]
                               
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('markup-todolist', {
            parent: 'dashboard',
            url: '/MarkupSettings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/markup-settings/markup-settings-view-dialog.html',
                    controller: 'MarkupSettingsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }, 
                        markupTypes: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('markup-settings', null, { reload: 'markup-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('markup-todolist.resubmit', {
            parent: 'dashboard',
            url: '/MarkupSettingsEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/markup-settings/markup-settings-dialog.html',
                    controller: 'MarkupSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }, 
                        markupTypes: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('markup-settings', null, { reload: 'markup-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('markup-auditLog', {
            parent: 'audit-log',
            url: '/MarkupSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/markup-settings/markup-settings-view-dialog.html',
                    controller: 'MarkupSettingsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }, 
                        markupTypes: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('markup-settings', null, { reload: 'markup-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('markup-historyReport', {
            parent: 'history-report',
            url: '/MarkupettingsHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/markup-settings/markup-settings-view-dialog.html',
                    controller: 'MarkupSettingsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }, 
                        markupTypes: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('markup-settings', null, { reload: 'markup-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('Markup', Markup);

    Markup.$inject = ['$resource'];

    function Markup ($resource) {
        var resourceUrl =  'api/markup-settings/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/markup-settings'
        	 },
         	
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
             'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/markup-settings/orgId/:orgId',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
        	
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/markup-settings/orgId/:orgId',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/markup-settings',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              },
              'getAllMarkupForBranch': {
                  method: 'GET',
                  isArray: true,
                  params: {branchId:'@branchId',bankId:'@bankId'},
                  url: 'api/markup-for-branch/branch/:branchId/bank/:bankId',
                  transformResponse: function (data) {
                      if (data) {
                          data = angular.fromJson(data);
                      }
                      return data;
                  }
              },
              'getAllMarkupForCustomer': {
                  method: 'GET',
                  isArray: true,
                  params: {branchId:'@branchId',bankId:'@bankId'},
                  url: 'api/markup-for-customer/customer/:customerId',
                  transformResponse: function (data) {
                      if (data) {
                          data = angular.fromJson(data);
                      }
                      return data;
                  }
              },
              
            'getAllMarkupForCustomerAndCurrencyPair': {
                  method: 'GET',
                  isArray: true,
                  params: {customerId:'@customerId',currencyPairCode:'@currencyPairCode'},
                  url: 'api/markup-for-customer/customer/:customerId/currencyPairCode/:currencyPairCode',
                  transformResponse: function (data) {
                      if (data) {
                          data = angular.fromJson(data);
                      }
                      return data;
                  }
              }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'markup'
        })
        
        .controller('MarkupSettingsController', MarkupSettingsController);

    MarkupSettingsController.$inject = ['$scope', '$state', 'Markup', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants'];

    function MarkupSettingsController($scope, $state, Markup , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants) {
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.MARKUP_SETTINGS;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "markup";
        vm.bank = GlobalValues.getBank();
        vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
        vm.launch=launch;
        vm.clicked=false;
        function launch() {
        	$state.go("markup-new");
        }
        vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.decimalForPaise = vm.globalValues.getNumberOfDecimalsForRateInReports();
        
        
        
        vm.permitMarkupSettingsEditEntityAction = EntityPermissions.hasPermission('MarkupSettings.EDIT');
        vm.permitMarkupSettingsViewEntityAction = EntityPermissions.hasPermission('MarkupSettings.VIEW');
        vm.permitMarkupSettingsAddEntityAction = EntityPermissions.hasPermission('MarkupSettings.CREATE');
        vm.permitMarkupSettingsImportEntityAction = EntityPermissions.hasPermission('MarkupSettings.IMPORT');
        
        logScreenAccess();
        
        if(vm.entityOwnerType=='Branch'){
            loadAll();

        }

       function loadAll() {
    	   
    	   vm.bankId = vm.globalValues.getBank().id;
    	   vm.branchLogin = vm.globalValues.getBranch().id;
    		   Markup.getAllMarkupForBranch({"branchId": vm.branchLogin,"bankId":vm.bankId},function(result) {
                   vm.markup = result;
                });  
    	 
    	        	
        }      
       
       vm.loadCustomers = function loadCustomers(branch) {
    	   vm.branchId = 0;
    	   vm.bankId = vm.globalValues.getBank().id;
   		if(branch!=null && branch!=undefined){
       		vm.branchId = branch.id;
   		}
   		Markup.getAllMarkupForBranch({"branchId": vm.branchId,"bankId": vm.bankId}, function(result) {
            vm.markup = result;
            vm.clicked=false;  
        });

       	
       	
           
       }
       
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	 $stateProvider.state('markup-report', {
           	 parent: 'entity',
             url: '/markup-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.markupReport.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/markup-report/markup-report.html',
                    controller: 'MarkupReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('markupReport');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
    };
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('MarkupReport', MarkupReport);

    MarkupReport.$inject = ['$resource','DateUtils'];

    function MarkupReport ($resource, DateUtils) {
        var resourceUrl = 'api/trades';
        return $resource(resourceUrl, {}, {
            
            'getMarkupReportHeaderList': {
                method: 'GET',  
                url: 'api/trades/getMarkupReportHeaderList',
                params : {
                	bankId : '@bankId',
					branchId : '@branchId',
					customerId:'@custId'
                },
                isArray: true
            },
            'getHistoricalMarkupReportHeaderList': {
                method: 'GET',  
                url: 'api/trades/getHistoricalMarkupReportHeaderList',
                params : {
                	bankId : '@bankId',
					branchId : '@branchId',
					customerId:'@custId',
					fromDate:'@fromDate',
					toDate :'@toDate'
                },
                isArray: true
            },
            
            'getMarkupReportDetailsList': {
                method: 'GET',  
                url: 'api/trades/getMarkupReportDetailsList',
                params : {
                	bankId : '@bankId',
					branchId : '@branchId',
					customerId:'@custId',
					buyOrSell:'@buyOrSell'
				},
				isArray: true
            },
            'getHistoricalMarkupReportDetailsList': {
                method: 'GET',  
                url: 'api/trades/getHistoricalMarkupReportDetailsList',
                params : {
                	bankId : '@bankId',
					branchId : '@branchId',
					customerId:'@custId',
					buyOrSell:'@buyOrSell',
					businessDate :'@businessDate'
				},
				isArray: true
            }
            ,'getCurrentBusinessDate': {
                method: 'GET',  
                url: 'api/eod-process',
                transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
            },
            'exportData':{
			    method: 'POST',
                url: 'api/markup-report/export',
                responseType: 'arraybuffer',
                params : {
					bankId : '@bankId',
					branchId : '@branchId',
					custId :'@custId',
					fromDate :'@fromDate',
					toDate:'@toDate'
				},
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                } 
			},
			 'exportHistoricalData':{
				    method: 'POST',
	                url: 'api/historical-markup-report/export',
	                responseType: 'arraybuffer',
	                params : {
						bankId : '@bankId',
						branchId : '@branchId',
						custId :'@custId',
						fromDate :'@fromDate',
						toDate:'@toDate'
					},
	                transformResponse: function(data, headers) {
	              	  return {
	                        data: data,
	                        headers: headers
	                    };   
	                } 
				},
				
				 'exportHistoricalCSVData': {
	                  method: 'POST',
	                  url: 'api/historical-markup-report/export-csv',
	                  responseType: 'arraybuffer',
	                  params : {
							bankId : '@bankId',
							branchId : '@branchId',
							custId :'@custId',
							fromDate :'@fromDate',
							toDate:'@toDate'
						},
	                  transformResponse: function(data, headers) {
	                	  return {
	                          data: data,
	                          headers: headers
	                      };   
	                  }         
	             },
	             
	             'exportCSVData': {
	                  method: 'POST',
	                  url: 'api/markup-report/export-csv',
	                  responseType: 'arraybuffer',
	                  params : {
							bankId : '@bankId',
							branchId : '@branchId',
							custId :'@custId',
							fromDate :'@fromDate',
							toDate:'@toDate'
						},
	                  transformResponse: function(data, headers) {
	                	  return {
	                          data: data,
	                          headers: headers
	                      };   
	                  }         
	             },
				'getBBPSMarkupDetails': {
                method: 'GET',
                url: 'api/public/bbps-markup-details',
                responseType: 'arraybuffer', // This is correct for binary data like PDF
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            }
        });
    }
})();
(function () {
	'use strict';

	angular
		.module('gatewayApp')
		.controller('MarkupReportController', MarkupReportController);

	MarkupReportController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues',  'AlertService','MarkupReport','$filter', 'ScreenLog','entityConstants','DateUtils','$window'];

	function MarkupReportController( $scope, $state, $rootScope, GlobalValues,AlertService , MarkupReport , $filter , ScreenLog, entityConstants,DateUtils, $window){
		var vm = this;
		vm.globalValues = GlobalValues;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.MARKUPREPORT;
        vm.entityConstants = entityConstants;
        vm.screenLog = ScreenLog;
        vm.bank= null;
        vm.branch = null;
        vm.customer = null;
        vm.selectedHeaderBankId = null;
        vm.selectedHeaderBranchId = null;
        vm.selectedHeaderCustomerID = null;
        vm.headerList =[];
        vm.detailsList=[];
		vm.clicked=false;
        vm.loadHeader = getMarkupReportHeader;
        vm.getDetails = getDetails;
        //vm.reportDate = new Date();
        vm.showDetails= false;
        vm.bankLookUpName = "bank";
 		vm.bankFilter = '';
        vm.loggedInUser = vm.globalValues.getUser();
        vm.loggedinEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.ExpandOrCollapse = true;
        vm.valid=false;
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.todayDate = new Date();
 		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
 	    $scope.page = 1; 
 	   vm.expandBuyTrades = true;
       vm.expandSellTrades = true;
       vm.exportToFile = exportToFile;
       vm.historicalTrade = false;
       vm.valid = false;
       var index = 0;
       vm.markupTypePaise = 'Paise';
       vm.markupTypePercentage = 'Percentage';
       
      
       vm.historicalOrCurrent = 'Current';
 	    
 	   MarkupReport.getCurrentBusinessDate(getBusinnessDateSuccess, getBusinessDateFailed);
 	   
 	   function getBusinnessDateSuccess(result) {
 		  if (result.date) {
 			 vm.reportDate  = DateUtils.convertLocalDateFromServer(result.date);
 			vm.yesterdayDate = angular.copy(vm.reportDate);
 	       vm.yesterdayDate.setDate(vm.yesterdayDate.getDate() - 1);
 			 vm.fromDate = angular.copy(vm.reportDate);
 			 vm.fromDate.setDate(vm.fromDate.getDate() -1);
 		       vm.toDate = angular.copy(vm.reportDate);
 		      vm.toDate.setDate(vm.toDate.getDate() -1);
          }
 		  else {vm.reportDate =  null;}
 		  //vm.reportDate  = DateUtils.convertLocalDateFromServer(result.date);		console.log(  vm.reportDate );	
			
		}

		function getBusinessDateFailed(error) {
			//Do Nothing
		}
 	    
		if (vm.loggedinEntityOwnerType == 'Clearcorp'){
			 vm.disableBank = false;
			 vm.disableBranch = false;
			 vm.disableCustomer = false;
			 vm.bankLookUpName = "nonTerminatedBanks";
	    }
 	    else if (vm.loggedinEntityOwnerType == 'Bank'){
	  		
	  		 vm.bank = vm.globalValues.getBank();
	  		 vm.disableBank = true;
	  		 vm.disableBranch = false;
	  		 vm.disableCustomer = false;
 	    }
 	    else if (vm.loggedinEntityOwnerType == 'Branch'){
 	    	
	  		 vm.bank = vm.globalValues.getBank();
	  		 vm.branch = vm.globalValues.getBranch();
	  		 vm.disableBank = true;
	  		 vm.disableBranch = true;
	  		 vm.disableCustomer = false;
	  		 vm.bankLookUpName = "bank";
	  		 vm.bankFilter = '';
 	    }
 	    else if (vm.loggedinEntityOwnerType == 'MultiUserCustomer' || vm.loggedinEntityOwnerType == 'SingleUserCustomer'){
	  		
	  		 vm.customer = vm.globalValues.getOrganisation();
	  		 vm.disableBank = false;
	  		 vm.disableBranch = true;
	  		 vm.disableCustomer = true;
	  		 vm.bankLookUpName = "tradingBank";
	  		 vm.bankFilter = vm.customer.id;
 	    }else{
 	    	
 	    }
 	    
 	   logScreenAccess();
 	   function getMarkupReportHeader(){
 		   vm.valid=true;
 		   var bankid = null;
 		   var branchId= null
 		   var customerid= null;
 		   if(vm.bank != undefined && vm.bank != null & vm.bank != ''){
 			  bankid = vm.bank.id;
 		   }
 		  if(vm.branch != undefined && vm.branch != null && vm.branch != ''){
 			 branchId = vm.branch.id;
 		   }
 		 if(vm.customer != undefined && vm.customer != null && vm.customer != ''){
 			customerid = vm.customer.id;
		   }
 		
 		 
 		if(vm.historicalOrCurrent == 'Historical' && moment(vm.fromDate).isAfter(vm.yesterdayDate,'day')){
   			AlertService.error($filter('translate')('gatewayApp.markupReport.futureFromDate'));
   			vm.valid=false;
   		}
   		else if(vm.historicalOrCurrent == 'Historical' && moment(vm.fromDate).isAfter(vm.toDate,'day')){
   			AlertService.error($filter('translate')('gatewayApp.markupReport.greaterFromDate'));
   			vm.valid=false;
   		}else if(vm.historicalOrCurrent == 'Historical' && moment(vm.toDate).isAfter(vm.yesterdayDate,'day')){
   			AlertService.error($filter('translate')('gatewayApp.markupReport.greaterToDate'));
   			vm.valid=false;
   		}
   		else{
			vm.clicked=true;
   			vm.valid = true;
   		 if(vm.historicalOrCurrent == 'Historical'){
  			vm.historicalTrade = true;
  			 vm.convertedFromDate = DateUtils.convertLocalDateToServer(vm.fromDate);
  			 vm.convertedToDate = DateUtils.convertLocalDateToServer(vm.toDate);
  			MarkupReport.getHistoricalMarkupReportHeaderList({bankId: bankid, branchId : branchId, custId: customerid, fromDate : vm.convertedFromDate,
  				toDate : vm.convertedToDate} , markupHeaderSuccess, markupHeaderFailure );
  			
  		 }else{
  			vm.historicalTrade = false;
  			MarkupReport.getMarkupReportHeaderList({bankId: bankid, branchId : branchId, custId: customerid} , markupHeaderSuccess, markupHeaderFailure );
  		 }
   		 
   		}
 		 
 		
 		 
 	   }
 	   function markupHeaderSuccess(result){
 		  vm.headerList = result;
 		  vm.showDetails= false;
		  vm.clicked=false;
 		  
 	   }
 	   function markupHeaderFailure(error){
		 vm.clicked=false;
 	   }
 	  
 	   function getMarkupReportDetailsListExport(){
 		  var bankid = null;
		  var branchId= null
		  var customerid= null;
		  if(vm.bank != undefined && vm.bank != null & vm.bank != ''){
			  bankid = vm.bank.id;
		  }
		  if(vm.branch != undefined && vm.branch != null && vm.branch != ''){
			 branchId = vm.branch.id;
		   }
		  if(vm.customer != undefined && vm.customer != null && vm.customer != ''){
			customerid = vm.customer.id;
		   }
		  MarkupReport.getMarkupReportDetailsList({bankId: bankid, branchId : branchId, custId: customerid} , markupDetailsListExportSuccess, markupDetailsListExportFailure );
 	   }
 	  function markupDetailsListExportSuccess(result){
 		 vm.detailsListForExport = result;
 		
 	   }
 	  function markupDetailsListExportFailure(error){
 		  
	   }
 	  
 	 function getMarkupReportDetailsList(){
		 
 		 if(!vm.historicalTrade){
 			 MarkupReport.getMarkupReportDetailsList({bankId: vm.selectedHeaderBankId, branchId : vm.selectedHeaderBranchId, custId: vm.selectedHeaderCustomerID, buyOrSell : 'BUYY'}
 			  , markupDetailsBuyListSuccess, markupDetailsBuyListFailure );
 		 }
 		 else if(vm.businessDate != null &&vm.businessDate != undefined){
 			 vm.convertedBusinessDate = DateUtils.convertLocalDateToServer(vm.businessDate);
 			 MarkupReport.getHistoricalMarkupReportDetailsList({bankId: vm.selectedHeaderBankId, branchId : vm.selectedHeaderBranchId, 
 				 custId: vm.selectedHeaderCustomerID, buyOrSell : 'BUYY', businessDate :  vm.convertedBusinessDate}
			  , markupDetailsBuyListSuccess, markupDetailsBuyListFailure );
 		 }
 		 
		 
	   }
	  function markupDetailsBuyListSuccess(result){
		   index = 1;
		 vm.buyDetailsList = result;
		 
		 angular.forEach(vm.buyDetailsList, function(val){
			 val.index = index++;
		 })
		 
		 if(!vm.historicalTrade){
			 MarkupReport.getMarkupReportDetailsList({bankId: vm.selectedHeaderBankId, branchId : vm.selectedHeaderBranchId, custId: vm.selectedHeaderCustomerID, buyOrSell : 'SELL'}
			  , markupDetailsSellListSuccess, markupDetailsSellListFailure );
		 }
		 else if(vm.businessDate !=null && vm.businessDate !=undefined){
			 vm.convertedBusinessDate = DateUtils.convertLocalDateToServer(vm.businessDate);
			 MarkupReport.getHistoricalMarkupReportDetailsList({bankId: vm.selectedHeaderBankId, branchId : vm.selectedHeaderBranchId, custId: vm.selectedHeaderCustomerID,
				 buyOrSell : 'SELL', businessDate : vm.convertedBusinessDate}
			  , markupDetailsSellListSuccess, markupDetailsSellListFailure );
		 }
		 
		 
		 
		
	   }
	  function markupDetailsBuyListFailure(error){
		  
	   }
	  function getDetails(header){
		  vm.selectedHeaderBankId = header.bankId;
		  vm.selectedHeaderBranchId = header.branchId;
		  vm.selectedHeaderCustomerID=header.customerId;
		  vm.selectedHeaderCustomerName = header.customerName;
		  vm.businessDate = header.businessDate;
		  vm.showDetails= true;
		  vm.valid=true;
		  getMarkupReportDetailsList();
	  }
	   function logScreenAccess(){
			  vm.screenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
	    }
	   
	   function markupDetailsSellListSuccess(result){
		   
		   
		   vm.sellDetailsList = result;
		   
		   angular.forEach(vm.sellDetailsList, function(val){
				 val.index = index++;
			 })
		   vm.totalBuyMarkupValue = 0;
		   vm.totalSellMarkupValue = 0;
		   vm.totalBuyTax = 0;
		   vm.totalSellTax =0;
		   vm.totalBuyMarkupPostTax = 0;
		   vm.totalSellMarkupPostTax = 0;
		   if(vm.buyDetailsList.length>0){
			   vm.totalBuyMarkupValue = vm.buyDetailsList.reduce(function (a,b) { return a + b.markupValue; }, 0);
			   vm.totalBuyTax = vm.buyDetailsList.reduce(function (a,b) { return a + b.taxOnMarkup; }, 0);
			   vm.totalBuyMarkupPostTax = vm.buyDetailsList.reduce(function (a,b) { return a + b.markupValuePostTax; }, 0);
		   }
		   if(vm.sellDetailsList.length>0){
			   vm.totalSellMarkupValue = vm.sellDetailsList.reduce(function (a,b) { return a + b.markupValue; }, 0);
			   vm.totalSellTax = vm.sellDetailsList.reduce(function (a,b) { return a + b.taxOnMarkup; }, 0);
			   vm.totalSellMarkupPostTax = vm.sellDetailsList.reduce(function (a,b) { return a + b.markupValuePostTax; }, 0);
		   }
		   vm.totalMarkupValue = vm.totalBuyMarkupValue + vm.totalSellMarkupValue;
		   vm.totalTax = vm.totalBuyTax + vm.totalSellTax;
		   vm.totalMarkupPostTax = vm.totalBuyMarkupPostTax + vm.totalSellMarkupPostTax;
		   
		  
	   }
	   
	   function markupDetailsSellListFailure(error){
		   
	   }
	   
	   
	   function exportToFile(fileType){
	      	  
	      	  
	      	 vm.valid=true;
	 		   var bankid = null;
	 		   var branchId= null
	 		   var customerid= null;
	 		   if(vm.bank != undefined && vm.bank != null & vm.bank != ''){
	 			  bankid = vm.bank.id;
	 		   }
	 		  if(vm.branch != undefined && vm.branch != null && vm.branch != ''){
	 			 branchId = vm.branch.id;
	 		   }
	 		 if(vm.customer != undefined && vm.customer != null && vm.customer != ''){
	 			customerid = vm.customer.id;
			   }
	 		 vm.fileType = fileType;
	      	  if( vm.headerList !=null &&  vm.headerList!=undefined){
	      		 
	      		  
	      		vm.convertedFromDate = DateUtils.convertLocalDateToServer(vm.fromDate);
	 			 vm.convertedToDate = DateUtils.convertLocalDateToServer(vm.toDate);
	 			 
		 			 if(!vm.historicalTrade){
		 				 
		 				 if(vm.fileType == 'excel')
		 					 MarkupReport.exportData({bankId: bankid, branchId : branchId, custId: customerid, fromDate : vm.convertedFromDate, toDate : vm.convertedToDate}, onExportSuccess);
		 				 else
		 					MarkupReport.exportCSVData({bankId: bankid, branchId : branchId, custId: customerid, fromDate : vm.convertedFromDate, toDate : vm.convertedToDate}, onExportSuccess);
		 			 }
		 			 else{
		 				 
		 				if(vm.fileType == 'excel')
		 					
		 					MarkupReport.exportHistoricalData({bankId: bankid, branchId : branchId, custId: customerid, fromDate : vm.convertedFromDate, toDate : vm.convertedToDate}, onExportSuccess);
		 				else
		 					MarkupReport.exportHistoricalCSVData({bankId: bankid, branchId : branchId, custId: customerid, fromDate : vm.convertedFromDate, toDate : vm.convertedToDate}, onExportSuccess);
		 			 }
	 			 
	 			 }
	      		
	      		  
	      		  
	      	  }
	        
	   function onExportSuccess(result){
		   var mimeType= '';
	      	
	      	  var baseString =   'Markup_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   
	      	  
		   if(vm.fileType == 'csv'){
   			  mimeType = 'text/csv'
   			  baseString = baseString+ ".csv";  
   		  }else if(vm.fileType == 'excel'){
   			  mimeType = 'application/vnd.ms-excel';
   			  baseString = baseString+ ".xls";  
   		  }
		   
		   var fileData = result.data;
			  
 			var IEFile = new Blob([result.data], {type: mimeType});
     		
             
             if(window.navigator.msSaveOrOpenBlob) {
                   window.navigator.msSaveOrOpenBlob(IEFile, baseString );
               }
             else{
           	  
           	  var link = document.createElement("a");   
     			  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
     			      			  
 			      var blob = new Blob([bytes], {type: mimeType});
 			      link.href =  window.URL.createObjectURL(blob);
 			      
     		   	  link.download = baseString;
     		   	  document.body.appendChild(link);
     		   	  link.click();
     			  document.body.removeChild(link);
             }
             
	   }
	
	}
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('MarketStatisticsController', MarketStatisticsController);

    MarketStatisticsController.$inject = ['$scope', '$rootScope', '$state',  '$uibModalInstance', '$stateParams','entity','prevClose','GlobalValues','$filter'];

    function MarketStatisticsController($scope, $rootScope, $state, $uibModalInstance, $stateParams,entity,prevClose,GlobalValues,$filter) {
        var vm = this;
        
        vm.clear=clear;
        vm.ltp=0;
        vm.ltpForIb=0;
        vm.instrument=$rootScope.instrumentForStats;
        vm.openPrice;
        vm.openPriceForIb;
        if(vm.instrument!='BOTH'){
            vm.marketStatistics=entity;
            vm.prevCloseObj = prevClose[0];
            vm.openPrice = getIntervalOpenExchangeRate(vm.marketStatistics);
        }else{
            vm.marketStatistics=$filter('filter')(entity, {tokenSequenceNumber: '10000002'});
            vm.prevCloseObj = prevClose[0];
            vm.marketStatisticsForIb=$filter('filter')(entity, {tokenSequenceNumber: '10000001'});;
            vm.prevCloseObjForIb = prevClose[1];
            vm.openPrice = getIntervalOpenExchangeRate(vm.marketStatistics);
            vm.openPriceForIb = getIntervalOpenExchangeRate(vm.marketStatisticsForIb);
        }
        vm.globalValues=GlobalValues;
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();

        vm.tbq = vm.marketStatistics.reduce(function (a,b) { return a + b.intervalBuyAmount; }, 0);
        vm.toq = vm.marketStatistics.reduce(function (a,b) { return a + b.intervalSellAmount; }, 0);
        vm.ttq = vm.marketStatistics.reduce(function (a,b) { return a + b.intervalTradeAmount; }, 0);
        vm.totalVal = vm.tbq + vm.toq;
        vm.prevClose=vm.prevCloseObj.lastTradeExchangeRate;
        
        vm.reverseMarketStatistics = angular.copy(vm.marketStatistics).reverse();
        
        angular.forEach(vm.reverseMarketStatistics, function(value){
          	if(value.intervalCloseExchangeRate!=0 && vm.ltp==0){
          		vm.ltp = value.intervalCloseExchangeRate;
          	}
        });
        
        if(vm.marketStatistics.length>0){
            //vm.ltp = vm.marketStatistics[vm.marketStatistics.length-1].intervalCloseExchangeRate;
            
            if(vm.ltp>0){
            	vm.changeInPrice = vm.ltp - vm.prevClose;
                vm.changeInPrice = Math.round(parseFloat(vm.changeInPrice)*100000) / 100000;
                vm.changeInPercent = (vm.changeInPrice/vm.ltp) * 100;
                vm.changeInPercent = Math.round(parseFloat(vm.changeInPercent)*100000) / 100000;
            }
            
            vm.high= Math.max.apply(Math,vm.marketStatistics.map(function(item){return item.intervalHighExchangeRate;}).filter(function(val){return val !== 0}));
            vm.low= Math.min.apply(Math,vm.marketStatistics.map(function(item){return item.intervalLowExchangeRate;}).filter(function(val){return val !== 0}));
        }
        
        if(vm.marketStatisticsForIb!=null && vm.marketStatisticsForIb!=undefined){
        	vm.tbqForIb = vm.marketStatisticsForIb.reduce(function (a,b) { return a + b.intervalBuyAmount; }, 0);
            vm.toqForIb = vm.marketStatisticsForIb.reduce(function (a,b) { return a + b.intervalSellAmount; }, 0);
            vm.ttqForIb = vm.marketStatisticsForIb.reduce(function (a,b) { return a + b.intervalTradeAmount; }, 0);
            vm.totalValForIb = vm.tbqForIb + vm.toqForIb;
            vm.prevCloseForIb=vm.prevCloseObjForIb.lastTradeExchangeRate;
            
            vm.reverseMarketStatisticsForIb = angular.copy(vm.marketStatisticsForIb).reverse();
            
            angular.forEach(vm.reverseMarketStatisticsForIb, function(value){
              	if(value.intervalCloseExchangeRate!=0 && vm.ltpForIb==0){
              		vm.ltpForIb = value.intervalCloseExchangeRate;
              	}
            });
            
            if(vm.marketStatisticsForIb.length>0){
                //vm.ltp = vm.marketStatistics[vm.marketStatistics.length-1].intervalCloseExchangeRate;
                
                if(vm.ltpForIb>0){
                	vm.changeInPriceForIb = vm.ltpForIb - vm.prevCloseForIb;
                    vm.changeInPriceForIb = Math.round(parseFloat(vm.changeInPriceForIb)*100000) / 100000;
                    vm.changeInPercentForIb = (vm.changeInPriceForIb/vm.ltpForIb) * 100;
                    vm.changeInPercentForIb = Math.round(parseFloat(vm.changeInPercentForIb)*100000) / 100000;
                }
                
                vm.highForIb= Math.max.apply(Math,vm.marketStatisticsForIb.map(function(item){return item.intervalHighExchangeRate;}).filter(function(val){return val !== 0}));
                vm.lowForIb= Math.min.apply(Math,vm.marketStatisticsForIb.map(function(item){return item.intervalLowExchangeRate;}).filter(function(val){return val !== 0}));
            }
        }
        

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function getIntervalOpenExchangeRate(marketStatisticsLlist){
        	 // Fix for issue -417 mantis , Market Open Price not getting updated
        	if ( marketStatisticsLlist!=null && marketStatisticsLlist!=undefined && marketStatisticsLlist.length>0 ){
        		var openRateFilteredMovementArray = marketStatisticsLlist.filter(function(val){return  val.intervalOpenExchangeRate !== 0.00});
            	if(openRateFilteredMovementArray!=null && openRateFilteredMovementArray!=undefined && openRateFilteredMovementArray.length>0)
            		return  openRateFilteredMovementArray[0].intervalOpenExchangeRate;
            	else return 0.00;
        	}
            // End Fix
        }
        
    }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('market-movement', {
            parent: 'entity',
            url: '/market-movement',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.marketMovement.title" | translate }}',
                parent: 'home'
              },
            views: {
                'content@': {
                    templateUrl: 'app/entities/market-movement/market-movement.html',
                    controller: 'MarketMovementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('marketMovement');
                    return $translate.refresh();
                }]
               
            }
            })
            }
        }) ();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('MarketMovement', MarketMovement);

    MarketMovement.$inject = ['$resource'];

    function MarketMovement ($resource) {
        var resourceUrl =  'api/market-movement-details';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {instrument:'@instrument', businessDate : '@businessDate',currencyPairCode:'@currencyPairCode'},
        	    url: 'api/get-market-movement-details/instrument/:instrument/businessDate/:businessDate/currencyPairCode/:currencyPairCode/market-movement'
        	 },
        
	        'getLTPForLimitsForInstrument': {
	            method: 'GET',  
	           
	            params : {
	            	instrument : '@instrument'
				},
				 url: 'api/instrument/:instrument/ltp-for-limits'
	        },
	        'getDailyClosingPrice': {
	            method: 'GET',  
	           
	            params : {
	            	instrument : '@instrument',currencyPairCode:'@currencyPairCode'
				},
				 url: 'api/instrument/:instrument/currencyPairCode/:currencyPairCode/daily-closing-price'
	        },
	        'getDailyClosingPriceList': {
	            method: 'GET',  
	           isArray: true,
	            params : {
	            	instrument : '@instrument'
				},
				 url: 'api/instrument/:instrument/daily-closing-price-list'
	        }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'marketMovement'
        })
        
        .controller('MarketMovementController', MarketMovementController);

    MarketMovementController.$inject = ['$scope', '$state', 'MarketMovement', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
    	'$timeout','IntradayMarket','DateUtils','$rootScope'];

    function MarketMovementController($scope, $state, MarketMovement , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
    		$timeout,IntradayMarket,DateUtils,$rootScope) {
    	
    	var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.MARKETMOVEMENT;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.instrument = 'SPOT';
        vm.currencyPairCode = 'USDINR';
        vm.tbq=0;
        vm.toq=0;
        vm.ttq=0;
        vm.ltp=0;
        vm.todayDate = new Date();
        $scope.refresh=refresh;
        vm.exportName = 'RetailSPOT';
        vm.openPrice = 0.00;
        $scope.loadAll=loadAll;
        vm.showData=false;
          	 
        workflowSharedService.viewFrom = "marketMovement";
        
    	loadCurrentBusinessDate();
    	 logScreenAccess();
    	 
    	 vm.getCurrentDateTime = getCurrentDateTime;
    	 function getCurrentDateTime(){
    		 vm.todayDate = new Date();
    	 }
    	 //loadAll();
    	 
    	/* var tickerPriceChange = $rootScope.$on("tickerPrice", function(event, object){
    		 vm.ltp=object;
    	 });
    	 
    	 $scope.$on('$destroy', function() {
    		 tickerPriceChange();
    	 
    	 });*/
    	 
        

         function loadAll() {
        	 vm.ltp=0;
        	 vm.high=null;
        	 vm.low=null;
        	 vm.changeInPrice=null;
        	 vm.changeInPercent=null;
             vm.changeInstrument =true;

             if(vm.currencyPair!=null && vm.currencyPair!=undefined){
	    		   vm.currencyPairCode= vm.currencyPair.code;
                   if(vm.currencyPairCode !='USDINR' && vm.instrument =='InterbankSPOT'){
                    vm.instrument='CASH';
                   } else if(vm.currencyPairCode =='USDINR' && (vm.instrument!='SPOT' && vm.instrument!='InterbankSPOT')){
                    vm.instrument='SPOT';
                   }
                   if(vm.currencyPairCode !='USDINR'){
                        vm.changeInstrument =false;
                   }

	    	   }

               console.log("currencyPairCode :" +vm.currencyPairCode);

        	// vm.currentDate=DateUtils.convertLocalDateToServer(vm.todayDate);
      	   	 MarketMovement.query({"instrument": vm.instrument, "businessDate" : vm.convertedCurrentBusinessDate, "currencyPairCode": vm.currencyPairCode},function(result) {
      		   
      		   
                  vm.marketMovement = result;
                  vm.tbq = vm.marketMovement.reduce(function (a,b) { return a + b.intervalBuyAmount; }, 0);
                  vm.toq = vm.marketMovement.reduce(function (a,b) { return a + b.intervalSellAmount; }, 0);
                  vm.ttq = vm.marketMovement.reduce(function (a,b) { return a + b.intervalTradeAmount; }, 0);
                 
                  angular.forEach(vm.marketMovement, function(value){
                  	value.intervalStartTime=moment(value.intervalStartTime,'YYYYMMDDHHmmss.SSSSSSSSS').format();
                  	value.intervalEndTime=moment(value.intervalEndTime,'YYYYMMDDHHmmss.SSSSSSSSS').format();
                  });
                  // Fix for issue -417 mantis , Market Open Price not getting updated
                  if( vm.marketMovement!=null &&  vm.marketMovement!=undefined &&  vm.marketMovement.length>0){
                	  	var openRateFilteredMovementArray = vm.marketMovement.filter(function(val){return  val.intervalOpenExchangeRate !== 0.00});
                  		if(openRateFilteredMovementArray!=null && openRateFilteredMovementArray!=undefined && openRateFilteredMovementArray.length>0)
                  			vm.openPrice = openRateFilteredMovementArray[0].intervalOpenExchangeRate;
      	   	 		}
                  // End Fix
                  vm.reverseMarketMovement = angular.copy(vm.marketMovement).reverse();
                  
                  angular.forEach(vm.reverseMarketMovement, function(value){
                    	if(value.intervalCloseExchangeRate!=0 && vm.ltp==0){
                    		vm.ltp = value.intervalCloseExchangeRate;
                    	}
                  });
                  
                  MarketMovement.getDailyClosingPrice({"instrument": vm.instrument,"currencyPairCode": vm.currencyPairCode},function(result){
            	   		vm.prevClose = result.lastTradeExchangeRate;
      	      	   	
            	   		if(vm.marketMovement.length>0){
            	   			//vm.ltp = vm.marketMovement[vm.marketMovement.length-1].intervalCloseExchangeRate;
             	      	    if(vm.ltp>0){
             	      	    	vm.changeInPrice = vm.ltp - vm.prevClose;
                  	            vm.changeInPrice = Math.round(parseFloat(vm.changeInPrice)*100000) / 100000;
                  	            vm.changeInPercent = (vm.changeInPrice/vm.ltp) * 100;
                  	            vm.changeInPercent = Math.round(parseFloat(vm.changeInPercent)*100000) / 100000;
             	      	    }
              	            
                            vm.high= Math.max.apply(Math,vm.marketMovement.map(function(item){return item.intervalHighExchangeRate;}).filter(function(val){return val !== 0}));
                            vm.low= Math.min.apply(Math,vm.marketMovement.map(function(item){return item.intervalLowExchangeRate;}).filter(function(val){return val !== 0}));
            	   		}
                });   
                  
               });    
      	   
      	      
         }
         
         $scope.$watch('vm.instrument', function(value){
        	 if(vm.instrument=='SPOT'){
        		 vm.exportName = 'RetailSPOT';
        	 }else if (vm.instrument=='InterbankSPOT'){
        		 vm.exportName='InterbankSPOT';
        	 }else if (vm.instrument=='CASH'){
        		 vm.exportName='CASH';
        	 }else if (vm.instrument=='TOM'){
        		 vm.exportName='TOM';
        	 }else if (vm.instrument=='FORWARD'){
        		 vm.exportName='FORWARD';
        	 }
            	// if(value!=null && value!=undefined){
            		
            	// 	if(vm.convertedCurrentBusinessDate!=null && vm.convertedCurrentBusinessDate!=undefined){
            	// 		loadAll();
            	// 	}
            		
            	// }
            });
         
         function logScreenAccess(){
         	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
         }
         
        
    	 
    	 function loadCurrentBusinessDate(){
      	   IntradayMarket.getCurrentBusinessDate(getBusinessDateSuccess, getBusinessDateFailed);
         }
         
         function getBusinessDateSuccess(result){
      	   vm.currentBusinessDate = DateUtils.convertLocalDateFromServer(result.businessDate);
      	   
      	   vm.convertedCurrentBusinessDate=DateUtils.convertLocalDateToServer(vm.currentBusinessDate);
      	   
      	   //loadAll();
      	   
         }
         
         function getBusinessDateFailed(){
      	   
         }
         
         $scope.toggle = true;
         function refresh() {
             $scope.toggle = false;
             $scope.refreshFlag = false;
             getCurrentDateTime();
             //loadAll();
             if ($scope.toggle == false) {
                 $timeout(function() {
                     $scope.toggle = true;
                 }, 2000);
                 $scope.refreshFlag = false;
             }
         };
         
    }    
})();
  
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('MarketDepthExpandController', MarketDepthExpandController);

    MarketDepthExpandController.$inject = ['$scope', '$rootScope', '$state',  '$uibModalInstance', '$stateParams', 'GlobalValues'];

    function MarketDepthExpandController($scope, $rootScope, $state, $uibModalInstance, $stateParams, GlobalValues) {
        var vm = this;
        
        vm.clear=clear;
        vm.globalValues = GlobalValues;

        vm.instrument=$stateParams.instrument;
        vm.marketDepth=$stateParams.marketDepth;
        vm.ibMarketDepth=$stateParams.ibMarketDepth;
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
    }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('manual-message-trigger', {
            parent: 'entity',
            url: '/manual-message-trigger',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "manualMessageTrigger.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manual-message-trigger/manual-message-trigger.html',
                    controller: 'ManualMessageTriggerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manualMessageTrigger'); 
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
    }
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ManualMessageTriggerService', ManualMessageTriggerService);

    ManualMessageTriggerService.$inject = ['$resource'];

    function ManualMessageTriggerService ($resource) {

        var resourceUrl = '';

        return $resource(resourceUrl, {}, {

            'sendManualTrigger': {
                method: 'POST',
                params: {
                    messageType: '@messageType'
                },
                url: 'order/public/manual-trigger'
                // transformRequest: function(data) {
                //     return angular.toJson(data);
                // },
                // transformResponse: function(data) {
                //     return data;
                // }
            }

        });

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'manualMessageTrigger'
        })
        
        .controller('ManualMessageTriggerController', ManualMessageTriggerController);

    ManualMessageTriggerController.$inject = ['ManualMessageTriggerService'];

    function ManualMessageTriggerController(ManualMessageTriggerService) {

       var vm = this;

       vm.messageTypeList = [
            "OrderResponse",
            "TradeResponse",
            "LimitUtilisationUpdate",
            "GetFillArrayIndexes",
            "GetInstrumentIndexes",
            "GetDailyClosingPriceDetails",
            "GetPendingOrderFromArray",
            "GetLTPPrices",
            "UpdateDailyClosingPrice",
            "UpdatePendingOrderArray",
            "UpdateSessionStatus",
            "UpdateSODStatus",
            "CancelPushMessage",
            "ClearMarketMovementRequests",
            "ClearOrderActivityRequests",
            "GetFileFormat",
            "OrderActivityResponse",
        ];

        vm.isJson = true; // Default to true

        function sendManualTrigger() {

            if (!vm.messageType) {
                vm.responseJson = 'Please select a message type.';
                return;
            }

            var requestData;

            if(vm.isJson)
            {
                try {
                    requestData = JSON.parse(vm.requestJson);
                } catch (error) {
                    vm.responseJson = 'Invalid JSON: ' + error.message;
                    return;
                }
            }
            else
            {
                requestData = {};
            }

            ManualMessageTriggerService.sendManualTrigger(
                {
                    messageType: vm.messageType
                },
                requestData,
                processSuccessResponse,
                processFailureResponse
            );

            // request.$promise.then(
            //     function(response) {
            //         console.log('Success response:', response);
            //     },
            //     function(error) {
            //         console.log('Error response:', error);
            //     }
            // );

            // request.$promise.catch(processFailureResponse);

        }

        // function processSuccessResponse(response) {

        //     console.log('FULL RESPONSE:', response);
        //     console.log('TYPE:', typeof response);
        //     console.log('ARRAY:', angular.isArray(response));

        //     if (angular.isArray(response)) {
        //         vm.responseJson = response.join('');
        //     } else {
        //         vm.responseJson = response;
        //     }

        //     // vm.responseJson = response || "Response Data";
        // }

        // function processFailureResponse(error) {
        //     console.log('Manual trigger error:', error);
        //     console.log('Error data:', error.data);

        //     vm.responseJson = error.data || 'Request failed';
        // }

        function processSuccessResponse(responseData) {
            vm.responseJson = responseData.response;
        }

        function processFailureResponse(error) {
            console.log('Manual trigger error:', error);

            if (error.data && error.data.response) {
                vm.responseJson = error.data.response;
            } else {
                vm.responseJson = 'Request failed';
            }
        }

        vm.sendManualTrigger = sendManualTrigger;

        // callAlert();

        // function callAlert()
        // {
        //     window.alert("Message");
        // }

    }
})();
    
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UsersRoleAssignController', UsersRoleAssignController);

    UsersRoleAssignController.$inject = ['Workflow', '$scope', '$state','$stateParams', '$rootScope','workflowSharedService', 'GlobalValues', '$uibModalInstance', 'User','Role','entity','ScreenLog'];

     function UsersRoleAssignController(Workflow, $scope, $state,$stateParams, $rootScope,workflowSharedService, GlobalValues, $uibModalInstance, User,Role,entity, ScreenLog) {
        var vm = this;
        vm.screenName = 'UserRole';
        vm.screenLog = ScreenLog;
        vm.save = save;
        vm.clear = clear;
        vm.discardUserRole=discardUserRole;
        vm.approveUserRole=approveUserRole;
        vm.rejectUserRole=rejectUserRole;
        vm.resubmit=resubmit;
        vm.roles=  Role.query({"orgId": GlobalValues.getCorpId()});
        vm.userRoleDTO = entity;
        vm.setDisabledValue=setDisabledValue();
        vm.disableSave=true;
        vm.ViewDisable = false;
        vm.selected = {
		    roles: []
		};
        vm.clicked=false;
        if(workflowSharedService.viewFrom == 'userRole') {
        	
         	$scope.showButton=false;
         	$scope.showDiscardButton=false;
        	$scope.showSave=true;
        	$scope.showResubmit=false;
         	$scope.disableElements=false;
         	vm.userId=vm.userRoleDTO.userId;
         	vm.shortName=vm.userRoleDTO.shortName;
        	 angular.forEach(vm.userRoleDTO.organisationRoleList,function(rolees,index){
 				vm.selected.roles.push(rolees);
 				vm.rolee={};
 				
 			});

        	vm.userRoleDTO.userId =$stateParams.id;
			//ScreenLog.screenLog({'entityName': 'UserRole', 'entityRecordId': vm.userRoleDTO.userId, 'action': 'MAP'});
        }
        
        else if(workflowSharedService.viewFrom == 'userroletodolist_checker'){
        	vm.ViewDisable = true;
          	$scope.showButton=true;
         	$scope.showDiscardButton=false;
        	$scope.showSave=false;
        	$scope.showResubmit=false;
        	$scope.disableElements=true;
        	vm.userRoles =  angular.fromJson($rootScope.payload); 
        	
        	vm.userId=vm.userRoles.userId;
        	vm.shortName=vm.userRoles.shortName;
        	angular.forEach(vm.userRoles.organisationRoleList,function(rolees,index){
 				vm.rolee=rolees;
 				vm.selected.roles.push(vm.rolee);
 				vm.rolee={};
 				
 			});
        	
        }
        else if(workflowSharedService.viewFrom == 'userroletodolist_maker'){
        	vm.ViewDisable = true;
         	$scope.showButton=false;
         	$scope.showResubmit=false;
         	$scope.showSave=false;
         	$scope.showDiscardButton=true;
         	$scope.disableElements=true;
        	vm.userRoles =  angular.fromJson($rootScope.payload);
        
        	vm.userId=vm.userRoles.userId;
        	vm.shortName=vm.userRoles.shortName;
        	angular.forEach(vm.userRoles.organisationRoleList,function(rolees,index){
 				vm.rolee=rolees;
 				vm.selected.roles.push(vm.rolee);
 				vm.rolee={};
 				
 			});

        }
        else if(workflowSharedService.viewFrom == 'userroletodolist_resubmit'){
        	$scope.showButton=false;
        	$scope.showResubmit=true;
         	$scope.showDiscardButton=false;
        	$scope.showSave=false;
        	$scope.disableElements=false;
        	vm.userRoleDTO =  angular.fromJson($rootScope.payload);
        	vm.screenLog.screenLog(vm.screenName, vm.userRoleDTO.userId, 'RESUBMIT');
        	vm.userId=vm.userRoleDTO.userId;
        	vm.shortName=vm.userRoleDTO.shortName;
        	angular.forEach(vm.userRoleDTO.organisationRoleList,function(rolees,index){
 				vm.rolee=rolees;
 				vm.selected.roles.push(vm.rolee);
 				vm.rolee1={};
 				
 			});
        }
        else if(workflowSharedService.viewFrom == 'userroletodolist_auditLog'){
        	vm.ViewDisable = true;
          	$scope.showButton=false;
         	$scope.showDiscardButton=false;
        	$scope.showSave=false;
        	$scope.showResubmit=false;
        	$scope.disableElements=true;
        	vm.userRoles =  angular.fromJson($rootScope.payload); 
        	
        	vm.userId=vm.userRoles.userId;
        	vm.shortName=vm.userRoles.shortName;
        	angular.forEach(vm.userRoles.organisationRoleList,function(rolees,index){
 				vm.rolee=rolees;
 				vm.selected.roles.push(vm.rolee);
 				vm.rolee={};
 				
 			});
        	
        }
        
        
		vm.userRoleDTO.organisationRoleList = [];
		
		function setRoleID(){
			vm.userRoleDTO.organisationRoleList = [];
			angular.forEach(vm.selected.roles,function(roles,index){
				vm.userRoleDTO.organisationRoleList.push(roles);
				vm.role={};
				
			});
		}
		function setDisabledValue(){
			vm.disableSave=false;
		}
	
		function clear () {
            $uibModalInstance.dismiss('cancel');
        }
		
		function save () {	
			setRoleID();
            User.mapRole(vm.userRoleDTO, onSaveSuccess, onSaveError);	
        }
		function resubmit () {	
		
			setRoleID();
        	
            User.resubmit({"taskId" : $rootScope.taskID},vm.userRoleDTO, onSaveSuccess, onSaveError);	
        }
     
        function onSaveSuccess (result) {
        	 
            $uibModalInstance.close(result);  
        }

        function onSaveError () {
        	vm.clicked=false;
        }
        function approveUserRole() { 
        	User.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);
        	
        }        
        function onApproveError(error) {
        	vm.clicked=false;
        }
        
        function rejectUserRole() { 
        	Workflow.rejectTask($rootScope.taskID);
        }

        function discardUserRole() {
        	User.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }
               
		
     } 
})();
(function() {
	'use strict';

	angular.module('gatewayApp').controller('UsersDialogController',
			UsersDialogController);

	UsersDialogController.$inject = [ '$scope', '$state', '$rootScope',
			'GlobalValues', 'workflowSharedService', '$uibModalInstance',
			'User', 'entity', 'DateUtils', 'ScreenLog', 'StaticLookUp' ,'AlertService','$filter'];

	function UsersDialogController($scope, $state, $rootScope, GlobalValues,
			workflowSharedService, $uibModalInstance, User, entity, DateUtils,
			ScreenLog, StaticLookUp,AlertService,$filter) {
		var vm = this;
		vm.screenName = 'UserManagement';
		vm.screenLog = ScreenLog;
		vm.users = entity;
		vm.clear = clear;
		vm.save = save;
		vm.clicked = false;
		$scope.showButton = false;
		vm.resubmitUsers = resubmitUsers;
		vm.globalValues = GlobalValues;
		vm.mobileCountryCode = 91;
		vm.gender = "M";
		$scope.showButton = false;
		vm.userType = vm.globalValues.getOrganisation().organisationType.shortName;
		vm.userEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
		vm.disablePID = false;
		vm.openForgotPID=openForgotPID;
		vm.country=vm.globalValues.getCountry();
		console.log(vm.country);
		vm.bank=vm.globalValues.getBank();
		vm.todayDate = new Date();
		$scope.formChangedForEmailOrMobile = false;
		vm.otpVerifiedId='';
		vm.userDetails=angular.copy(vm.users);
		// User.query(function(result) {
		// 	vm.allusers = result;
			
		// });
		

		if (workflowSharedService.viewFrom == 'userRole') {
			vm.users = entity;
			/*if(vm.users.id!==null){
			    ScreenLog.screenLog({'entityName': 'UserManagement', 'entityRecordId': vm.users.id, 'action': 'EDIT'});
			}else{
			    ScreenLog.screenLog({'entityName': 'UserManagement', 'entityRecordId': 0, 'action': 'ADD'});
			}*/
			if (vm.users.id != null) {
				vm.mobileCountryCode = vm.users.mobileCountryCode;
				vm.dob = DateUtils.convertLocalDateFromServer(vm.users.dob);
				vm.gender = vm.users.gender;
				vm.email = vm.users.email;
				vm.mobile = vm.users.mobile;
				vm.country=vm.users.country;
				if (vm.users.entityOwnerType.shortName == 'Branch') {
					vm.branch = vm.users.branch;
				}
			}
			$scope.showButton = false;
		} else if (workflowSharedService.viewFrom == 'usermanagementtodolist_resubmit') {
			vm.users = angular.fromJson($rootScope.payload);
			vm.mobileCountryCode = vm.users.mobileCountryCode;
			vm.dob = DateUtils.convertLocalDateFromServer(vm.users.dob);
			vm.gender = vm.users.gender;
			vm.email = vm.users.email;
			vm.mobile = vm.users.mobile;
			vm.country=vm.users.country;
			if (vm.users.entityOwnerTypeShortName == 'Branch') {
				vm.branch = vm.users.branch;
			}

			var entityRecordId = 0;
			if (vm.users.id != null) {
				entityRecordId = vm.users.id;
			}
			vm.screenLog.screenLog(vm.screenName, entityRecordId, 'RESUBMIT');
			vm.disableForm = false;
			$scope.showButton = true;
		} else if (workflowSharedService.viewFrom == 'usermanagementtodolist_resubmit_delink') {
			vm.users = angular.fromJson($rootScope.payload);
			vm.mobileCountryCode = vm.users.mobileCountryCode;
			vm.country=vm.users.country
			vm.dob = DateUtils.convertLocalDateFromServer(vm.users.dob);
			vm.gender = vm.users.gender;
			vm.users.mobileCountryCode = vm.mobileCountryCode;
			vm.users.country=vm.country;
			vm.email = vm.users.email;
			vm.mobile = vm.users.mobile;
			
			if (vm.users.entityOwnerType.shortName == 'Branch') {
				vm.branch = vm.users.branch;
			}
			vm.disableForm = true;
			$scope.showButton = true;
		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save() {
			
			if(moment(vm.dob).isAfter(vm.todayDate,'day')){
        		
        		 AlertService.error($filter('translate')('userManagement.futuredob'));
        		 vm.clicked=false;
        	 }else{
        		 vm.users.login = vm.users.login.toLowerCase();
     			vm.users.langKey = "en";
     			vm.users.organisation = null;
     			vm.users.mobileCountryCode = vm.mobileCountryCode;
     			vm.users.userType = vm.globalValues.getOrganisation().organisationType.shortName;
     			vm.users.gender = null;
     			vm.users.country=null;
				vm.users.address1='';
				vm.users.address2='';
				vm.users.city='';
				vm.users.state=null;
				vm.users.pincode='';
     			vm.users.dob = DateUtils.convertLocalDateToServer(vm.dob);
     			if (vm.users.userType == 'CLEARCORP') {
     				vm.users.entityOwnerTypeShortName = 'Clearcorp';
     			} else if (vm.users.userType == 'CUSTOMER') {
     				vm.users.entityOwnerTypeShortName = 'MultiUserCustomer';
     			} else if (vm.users.userType = 'BANK'
     					&& vm.userEntityOwnerType == 'Branch') {
     				vm.users.entityOwnerTypeShortName = 'Branch';
     				vm.users.entityOwnerType = vm.globalValues.getUser().entityOwnerType;
     				vm.users.branch = vm.globalValues.getBranch();
     				vm.users.branchId=vm.globalValues.getBranch().id;
     			} else {
     				vm.users.entityOwnerTypeShortName = vm.users.entityOwnerType.shortName;
     			}
     			if (vm.branch != null) {
     				vm.users.branchId = vm.branch.id;
     				vm.users.branch = vm.branch;
     			}
     			if (vm.users.id != null) {
     				User.update({
     					"orgId" : vm.globalValues.getOrgId()
     				}, vm.users, onSaveSuccess, onSaveError);
     			} else {
     				User.save({
     					"orgId" : vm.globalValues.getOrgId()
     				}, vm.users, onSaveSuccess, onSaveError);
     			}
        	 }
			

		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
		}

		function onSaveError() {
			vm.dob = DateUtils.convertLocalDateFromServer(vm.users.dob);
		//if(repo==false){
			// 	AlertService.error($filter('translate')('userManagement.isAuthorisedPerson'));
		//}
			vm.clicked = false;
		}

		$rootScope.$on('changeEmailRefresh', function(event, result) {
			vm.users.email = $rootScope.email;
			vm.otpVerifiedId=$rootScope.otpVerifiedId;
			vm.users.otpVerifiedId =vm.otpVerifiedId;
			$scope.formChangedForEmailOrMobile = true;
		});

		$rootScope.$on('changeMobileRefresh', function(event, result) {
			vm.users.mobile = $rootScope.mobile;
			vm.mobileCountryCode = $rootScope.mobileCountryCode;
			$scope.formChangedForEmailOrMobile = true;
		});

		function resubmitUsers() {
			if(moment(vm.dob).isAfter(vm.todayDate,'day')){
				vm.clicked=false;
        		 AlertService.error($filter('translate')('userManagement.futuredob'));
        		 
        	 }else{
        		 vm.users.login = vm.users.login.toLowerCase();
     			vm.users.langKey = "en";
     			vm.users.organisation = null;
     			vm.users.mobileCountryCode = vm.mobileCountryCode;
     			vm.users.userType = vm.globalValues.getOrganisation().organisationType.shortName;
     			vm.users.gender = null;
     			vm.users.country=null;
			    vm.users.address1='';
				vm.users.address2='';
				vm.users.city='';
				vm.users.state=null;
				vm.users.pincode='';

     			vm.users.dob = DateUtils.convertLocalDateToServer(vm.dob);
     			if (vm.users.userType == 'CLEARCORP') {
     				vm.users.entityOwnerTypeShortName = 'Clearcorp';
     			} else if (vm.users.userType == 'CUSTOMER') {
     				vm.users.entityOwnerTypeShortName = 'MultiUserCustomer';
     			} else if (vm.users.userType = 'BANK'
     					&& vm.userEntityOwnerType == 'Branch') {
     				vm.users.entityOwnerTypeShortName = 'Branch';
     				vm.users.entityOwnerType = vm.globalValues.getUser().entityOwnerType;
     				vm.users.branch = vm.globalValues.getBranch();
     				vm.users.branchId=vm.globalValues.getBranch().id;
     			} else {
     				vm.users.entityOwnerTypeShortName = vm.users.entityOwnerType.shortName;
     			}
     			if (vm.branch != null) {
     				vm.users.branchId = vm.branch.id;
     				vm.users.branch = vm.branch;
     			}
     			User.resubmitUserManagement({
     				"taskId" : $rootScope.taskID
     			}, vm.users, onResubmitSuccess, onResubmitError);
     			$uibModalInstance.dismiss('cancel');
        	 }
			
		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
		}
		function onResubmitError(error) {

			vm.dob = DateUtils.convertLocalDateFromServer(vm.users.dob);
			//if(repo==false){
			// 	AlertService.error($filter('translate')('userManagement.isAuthorisedPerson'));
		//}
		}

		vm.fetchUserByPersonalId = function fetchUserByPersonalId() {
			User
					.fetchUserByPersonalId(
							{
								'personalId' : vm.personalId
							},
							function(result) {
								if (result != null) {
									vm.users = result;
									vm.users.login = null;
									vm.users.mobile = null;
									vm.users.email = null;
									vm.users.id = null;
									vm.mobileCountryCode = vm.users.mobileCountryCode;
									vm.country=vm.users.country;
									vm.users.entityOwnerType = null;
									vm.dob = DateUtils
											.convertLocalDateFromServer(vm.users.dob);
									vm.gender = vm.users.gender;
									/*if (vm.users.entityOwnerType.shortName == 'Branch') {
										vm.branch = vm.users.branch;
									}*/
									vm.disablePID = true;
									vm.users.personId = vm.personalId;
								} else {
									MessageBox.openMessageBox("Alert", "Invalid personal ID", "Ok", "personid");
								}

							});
		}
		
		$rootScope.$on('gatewayApp.messagebox.ok.personid', function (event, data) {
			//do nothing
		});

		function openForgotPID(){
			if(vm.users==null || vm.users.id==null){
				$state.go('forgot-pid');
				$rootScope.$on('fetchPID', function(event, result) {
					vm.disablePID = false;
					vm.users = null;
					vm.dob = null;
					vm.gender = "M";
		        	vm.personalId= $rootScope.PID;
		        });
				
			}
			
			
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UsersViewController', UsersViewController);

    UsersViewController.$inject = ['$scope', '$state','$rootScope','workflowSharedService','$uibModalInstance','User', 'Branch' ,'entity', 'Workflow', 'GlobalValues', 'ScreenLog', 'DateUtils'];

    function UsersViewController($scope, $state, $rootScope, workflowSharedService, $uibModalInstance,User, Branch ,entity, Workflow, GlobalValues, ScreenLog, DateUtils) {
        var vm = this; 
        vm.clear=clear;
        vm.approveUsers = approveUsers;
        vm.rejectUsers = rejectUsers;
        vm.discardUsers = discardUsers;
        $scope.showButton = false;
        $scope.showDiscardButton = false;
        $scope.clicked=false;
        vm.theme = "dark";
        vm.globalValues = GlobalValues;
        vm.userType = vm.globalValues.getOrganisation().organisationType.shortName;
        vm.userEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.bank=vm.globalValues.getBank();
        $scope.clicked=false;
        
        
        if(workflowSharedService.viewFrom == 'userRole'  || workflowSharedService.viewFrom == 'bankregistration' || workflowSharedService.viewFrom == 'branch'){
        	vm.users = entity;        
        	vm.mobileCountryCode = vm.users.mobileCountryCode;
        	vm.country=vm.users.country;
        	vm.dob = DateUtils.convertLocalDateFromServer(vm.users.dob);
        	vm.gender = vm.users.gender; 
        	if(vm.users.entityOwnerType.shortName=='Branch'){
        		vm.branch = vm.users.branch;
        	}
            //ScreenLog.screenLog({'entityName': 'UserManagement', 'entityRecordId': vm.users.id, 'action': 'VIEW'});
       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'usermanagementtodolist_checker') {
        	vm.users =  angular.fromJson($rootScope.payload); 
        	vm.mobileCountryCode = vm.users.mobileCountryCode;
        	vm.country=vm.users.country;
        	vm.dob = DateUtils.convertLocalDateFromServer(vm.users.dob);
        	vm.gender = vm.users.gender; 
        	if(vm.userEntityOwnerType=='Branch' || vm.users.entityOwnerTypeShortName=='Branch'){
        		vm.branch = vm.users.branch;
        		
        	}
        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
        	
        	Branch.get({"id":vm.users.branchId},onGetBranchSuccess,onGetBranchError);
        	
        	
        }
        else if(workflowSharedService.viewFrom == 'usermanagementtodolist_maker') {
        	vm.users =  angular.fromJson($rootScope.payload); 
        	vm.mobileCountryCode = vm.users.mobileCountryCode;
        	vm.country=vm.users.country;
        	vm.dob = DateUtils.convertLocalDateFromServer(vm.users.dob);
        	vm.gender = vm.users.gender; 
        	console.log(vm.users);
        	if(vm.userEntityOwnerType=='Branch' || vm.users.entityOwnerTypeShortName=='Branch'){
        		vm.branch = vm.users.branch;
        	}
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        }
        if(workflowSharedService.viewFrom == 'userRole_auditLog'){
        	vm.users =  angular.fromJson($rootScope.payload); 
        	vm.mobileCountryCode = vm.users.mobileCountryCode;
        	vm.country=vm.users.country;
        	vm.dob = DateUtils.convertLocalDateFromServer(vm.users.dob);
        	vm.gender = vm.users.gender; 
        	if(vm.userEntityOwnerType=='Branch' || vm.users.entityOwnerTypeShortName=='Branch'){
        		vm.branch = vm.users.branch;
        	}
            //ScreenLog.screenLog({'entityName': 'UserManagement', 'entityRecordId': vm.users.id, 'action': 'VIEW'});
       	 	$scope.showButton=false;
       	 	
	       	 Branch.get({"id":vm.users.branchId},onGetBranchSuccess,onGetBranchError);
	     	
        }
        
        function approveUsers() { 
        	User.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	$scope.clicked=false;
        }
       
        function rejectUsers() { Workflow.rejectTask($rootScope.taskID); }

        function discardUsers() {
        	User.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }

    	var onGetBranchSuccess =  function onGetBranchSuccess(result){
    		vm.branch=result.branchName;
    	}
    	
    	var onGetBranchError = function onGetBranchError(){
    		
    	}
       
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UsersDelinkController',UsersDelinkController);

    UsersDelinkController.$inject = ['$uibModalInstance', 'entity', 'User', 'GlobalValues', 'ScreenLog','$scope'];

    function UsersDelinkController($uibModalInstance, entity, User, GlobalValues, ScreenLog,$scope) {
        var vm = this;

        vm.users = entity;
        console.log(vm.users);
        //ScreenLog.screenLog({'entityName': 'OrganisationUsers', 'entityRecordId': vm.users.id, 'action': 'DELETE'});
        vm.clear = clear;
        vm.confirmDelink = confirmDelink;
        $scope.clicked=false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelink (id) {
            User.delink({"id": id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'userRole'
        })
        .controller('ManageUserRoleController', ManageUserRoleController);

    ManageUserRoleController.$inject = ['$scope', '$state', 'workflowSharedService', 'User', 'GlobalValues', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout'];

    function ManageUserRoleController ($scope, $state,workflowSharedService, User, GlobalValues, EntityPermissions, ScreenLog,entityConstants,$timeout) {
        var vm = this;
        vm.screenLog = ScreenLog;
        vm.entityConstants = entityConstants;
        vm.globalValues = GlobalValues;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;

        vm.users = [];
        vm.permitAssignRole = EntityPermissions.hasPermission('UserRole.MAP');
        vm.permitAssignClearance = EntityPermissions.hasPermission('UserClearance.MAP');
        workflowSharedService.viewFrom = 'userRole';
        vm.userEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.EntityOwnerTypeId=vm.globalValues.getEntityOwnerType().id;
        vm.userBranch=vm.globalValues.getBranch();
        $scope.refresh=refresh;
        
        logScreenAccess();
        loadAll();
        
        function loadAll() {
        	if(vm.userEntityOwnerType=='Branch'){
        		User.getUsersByBranch({"branchId":vm.globalValues.getBranchId()},onGetUsersSuccess,onGetUsersError);
        		
        	}
        	else{
        		 User.query(function(result) {
                     vm.users = result;
                    
                     
                 });
        	}
           
        }
        function onGetUsersSuccess(result)
        {
        	vm.users=result;
        	
        }
        
        
        function onGetUsersError()
        {
        	
        }
        
        vm.launch=launch;
        function launch() {
        	$state.go("manage-users.new");
        }
        
        /*vm.screenLog = function screenLog(entity,entityRecordId,action){
        	ScreenLog.screenLog({'entityName': entity, 'entityRecordId': entityRecordId, 'action': action});
        }*/
        function logScreenAccess(){
        	ScreenLog.screenLog(entityConstants.ENTITY_SHORT_NAME.USER_MANAGEMENT,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }
        
        $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ManageUserClearanceController', ManageUserClearanceController);

    ManageUserClearanceController.$inject = ['Workflow', '$scope', '$state', '$stateParams', 'workflowSharedService', '$rootScope', '$uibModalInstance', 'entity', 'User', 'GlobalValues', 'ScreenLog'];

     function ManageUserClearanceController(Workflow, $scope, $state, $stateParams, workflowSharedService, $rootScope, $uibModalInstance, entity, User, GlobalValues, ScreenLog) {
        var vm = this;
        vm.screenName = 'UserClearance';
        vm.screenLog = ScreenLog;
        vm.ViewDisable = false;
        vm.selected = {
        		branch:[]
        		
        };
        vm.select = {
        		organisation:[]
        };

        vm.discardUserClearance=discardUserClearance;
        vm.approveUserClearance=approveUserClearance;
        vm.rejectUserClearance=rejectUserClearance;
        vm.resubmit = resubmit;
        $scope.clicked=false;
        if(workflowSharedService.viewFrom == 'userRole') {
        	
         	$scope.showButton=false;
         	$scope.showDiscardButton=false;
        	$scope.showSave=true;
        	$scope.showResubmit=false;
         	$scope.disableElements=false;
        vm.getUserClearanceDTO = entity;
        User.getClearance({"userId" :vm.getUserClearanceDTO.userID}, onGetSuccess, onGetError);
		//ScreenLog.screenLog({'entityName': 'UserClearance', 'entityRecordId': vm.getUserClearanceDTO.userID, 'action': 'MAP'});
        }
        else if(workflowSharedService.viewFrom == 'userclearancetodolist_checker'){
        	vm.ViewDisable = true;
          	$scope.showButton=true;
         	$scope.showDiscardButton=false;
        	$scope.showSave=false;
        	$scope.showResubmit=false;
        	$scope.disableElements=true;
        	vm.setClearanceDTO =  angular.fromJson($rootScope.payload); 
        	User.getUserClearance({"userId" : vm.setClearanceDTO.userID}, onGetSuccessChecker, onGetSuccessError);
        	
        	assignDataForChecklist();
        }
        else if(workflowSharedService.viewFrom == 'userclearancetodolist_maker'){
        	vm.ViewDisable = true;
         	$scope.showButton=false;
         	$scope.showResubmit=false;
         	$scope.showSave=false;
         	$scope.showDiscardButton=true;
         	$scope.disableElements=true;
        	vm.setClearanceDTO =  angular.fromJson($rootScope.payload);
        	User.getUserClearance({"userId" : vm.setClearanceDTO.userID}, onGetSuccessChecker, onGetSuccessError);
        	
        	assignDataForChecklist();
        }
        else if(workflowSharedService.viewFrom == 'userclearancetodolist_resubmit'){
        	$scope.showButton=false;
        	$scope.showResubmit=true;
         	$scope.showDiscardButton=false;
        	$scope.showSave=false;
        	$scope.disableElements=false;
        	vm.setClearanceDTO =  angular.fromJson($rootScope.payload);
        	vm.screenLog.screenLog(vm.screenName, vm.setClearanceDTO.userID, 'RESUBMIT');
        	User.getUserClearance({"userId" : vm.setClearanceDTO.userID}, onGetSuccessChecker, onGetSuccessError);
        	assignDataForChecklist();
        }
        function onGetSuccess(result){
        	vm.setClearanceDTO = result;
        	
        	vm.setClearanceDTO.userShortName = vm.getUserClearanceDTO.userShortName;
        	assignDataForChecklist();
        }
        function onGetError(error){
        	
        }
        function onGetSuccessChecker(result){
        	vm.getUserClearanceDTO =result;
        	vm.setClearanceDTO.userShortName = vm.getUserClearanceDTO.userShortName;
        	assignDataForChecklist();
        }
        function onGetSuccessError(error){
        	
        }
        
        vm.save = save;
        vm.clear = clear;
        $scope.corporate = {id:{}};
        
        
        
        function assignDataForChecklist(){
        	vm.selected.branch = vm.setClearanceDTO.buIDList;
        	vm.select.organisation =  vm.setClearanceDTO.organisationIDList;
        }
       
        
       
        function resubmit () {	
        	vm.setClearanceDTO.organisationIDList = vm.select.organisation;
        	vm.setClearanceDTO.buIDList = vm.selected.branch;
        	vm.setClearanceDTO.userID = vm.getUserClearanceDTO.userID;
        	
            User.resubmitClearance({"taskId" : $rootScope.taskID},vm.setClearanceDTO, onSaveSuccess, onSaveError);	
        }
     
        
        function save () {	
        	vm.setClearanceDTO.organisationIDList = vm.select.organisation;
        	vm.setClearanceDTO.buIDList = vm.selected.branch;
        	vm.setClearanceDTO.userID = vm.getUserClearanceDTO.userID;
		
            User.saveClearance({orgId:GlobalValues.getOrgId()}, vm.setClearanceDTO, onSaveSuccess, onSaveError);	
        }
        function onSaveSuccess (result) {
        	
            $uibModalInstance.close(result);  
        }

        function onSaveError (error) {
        	
        }
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        function approveUserClearance() { 
        	User.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);
        	
        }        
        function onApproveError(error) {
        	
        }
        
        function rejectUserClearance() { 
        	Workflow.rejectTask($rootScope.taskID);
        }

        
        function discardUserClearance() {
        	User.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }
     } 
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('manage-users', {
            parent: 'entity',
            url: '/manage-users',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.security.manageusers" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manage-users/manage-users-role.html',
                    controller: 'ManageUserRoleController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('ForgotPID');
                    return $translate.refresh();
                }]
               
            }
        })
         .state('manage-users-clearance', {
            parent: 'manage-users',
            url: '/manage-users-clearance/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/manage-users-clearance.html',
                    controller: 'ManageUserClearanceController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: ['User', function(User) {
                    		return User.getUserClearance({"userId" : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('manage-users', {}, { reload: 'manage-users' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('manage-users.assignrole', {
            parent: 'manage-users',
            url: '/assign-role/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-role-assign-dialog.html',
                    controller: 'UsersRoleAssignController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: ['User', function(User) {
                            return User.getRolesForUser({"userId" : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('manage-users', null, { reload: 'manage-users' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
             .state('manage-users-roletodolist-assignrole', {
            parent: 'dashboard',
            url: '/assign-role',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-role-assign-dialog.html',
                    controller: 'UsersRoleAssignController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	
                            	
                             
                            };
                    	}
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
                .state('manage-users-roletodolist-assignrole.resubmit', {
            parent: 'dashboard',
            url: '/assign-role-resubmit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-role-assign-dialog.html',
                    controller: 'UsersRoleAssignController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                    		
                    	}
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
          .state('manage-user-todolist', {
            parent: 'dashboard',
            url: '/role-clearance',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/manage-users-clearance.html',
                    controller: 'ManageUserClearanceController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                    		
                    	}
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('manage-user-todolist-resubmit', {
            parent: 'dashboard',
            url: '/role-clearance-resubmit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/manage-users-clearance.html',
                    controller: 'ManageUserClearanceController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	
                            	
                             
                            };
                    	}
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('manage-users.new', {
            parent: 'manage-users',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-dialog.html',
                    controller: 'UsersDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	 id:null,  
                            	name:null                            	
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('manage-users', null, { reload: 'manage-users' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('manage-users.view', {
            parent: 'manage-users',
            url: '/users/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-detail.html',
                    controller: 'UsersViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['User', 'GlobalValues', function(User, GlobalValues) {
                                     return User.get({userId : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('manage-users.edit', {
            parent: 'manage-users',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-dialog.html',
                    controller: 'UsersDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['User', 'GlobalValues', function(User, GlobalValues) {
                                     return User.get({userId : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('manage-users.delink', {
            parent: 'manage-users',
            url: '/{id}/delink',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-delink-dialog.html',
                    controller: 'UsersDelinkController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                    	entity: ['User', 'GlobalValues', function(User, GlobalValues) {
                            return User.get({userId : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('usermanagement-todolist', {
            parent: 'dashboard',
            url: '/usersview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-detail.html',
                    controller: 'UsersViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('manage-users', null, { reload: 'manage-users' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('usermanagement-todolist.resubmit', {
            parent: 'dashboard',
            url: '/usersedit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-dialog.html',
                    controller: 'UsersDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('manage-users', null, { reload: 'manage-users' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('usermanagement-auditLog', {
            parent: 'audit-log',
            url: '/usersview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-detail.html',
                    controller: 'UsersViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('manage-users', null, { reload: 'manage-users' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('manage-user-auditLog', {
            parent: 'audit-log',
            url: '/role-clearance',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/manage-users-clearance.html',
                    controller: 'ManageUserClearanceController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                    		
                    	}
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         .state('manage-users-role-auditLog', {
            parent: 'audit-log',
            url: '/assign-role',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-role-assign-dialog.html',
                    controller: 'UsersRoleAssignController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	
                            	
                             
                            };
                    	}
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         .state('manage-users-role-historyReport', {
            parent: 'history-report',
            url: '/assign-role',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-role-assign-dialog.html',
                    controller: 'UsersRoleAssignController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	
                            	
                             
                            };
                    	}
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('usermanagement-historyReport', {
            parent: 'history-report',
            url: '/usersview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-detail.html',
                    controller: 'UsersViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('manage-users', null, { reload: 'manage-users' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         .state('forgot-pid', {
            parent: 'manage-users.new',
            url: '/forgot-pid',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/forgot-pid/forgot-pid.html',
                    controller: 'ForgotPIDController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'smd',
                     resolve: {
                    	globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                    	entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                	$state.go('manage-users.new', null, { reload: 'manage-users.new' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
        .state('bank-registration-user-view', {
            parent: 'bank-registration',
            url: '/bank-users/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-detail.html',
                    controller: 'UsersViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['User', 'GlobalValues', function(User, GlobalValues) {
                                     return User.get({userId : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('branch-registration-user-view', {
            parent: 'branch',
            url: '/branch-users/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-users/users-detail.html',
                    controller: 'UsersViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['User', 'GlobalValues', function(User, GlobalValues) {
                                     return User.get({userId : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
   };
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var resourceUrl =  'api/users-for-organisation';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        	    url: 'api/users-for-organisation'
        	 },
        	 'get': {
                 method: 'GET',
                 params: {userId:'@userId',orgId:'@orgId'},
                 url: 'api/user/:userId/:orgId',
                 isArray:false,
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
        	 'getUsersByOrganisationAndEntityOwnerType': {
                 method: 'GET',
                 params: {orgId:'@orgId', entityOwnerType:'@entityOwnerType'},
                 url: 'api/users-by-organisation/:orgId/entity-owner-type/:entityOwnerType',
                 isArray:true,
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
        	 'getUsersByBranch': {
                 method: 'GET',
                 params: {branchId:'@branchId'},
                 url: 'api/users-by-branch/:branchId',
                 isArray:true,
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
             'saveClearance': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/orgId/:orgId/users-clearance',
                 transformRequest: function (data) {
                 	
                 	var copy =angular.toJson(data);
                 	
                     return copy;
                 }                
             },
             'updateSessionLog':{
                 method: 'POST',
                 url: 'api/update-session-log',
             },
             'insertSessionLog':{
                 method: 'POST',
                 url: 'api/insert-session-log',
             },
             'getClearance': {
  	            method: 'GET',
  	            params: {userId:'@userId'},
  	            url: 'api/user-clearance/:userId',
  	            transformResponse: function (data) {
  	                if (data) {
  	                    data = angular.fromJson(data);
  	                }
  	                return data;
  	            }
          	},
             'mapRole': {
                 method: 'POST',
                 url: 'api/users-role',
                 transformRequest: function (data) {
                 
                 	var copy =angular.toJson(data);
                 	
                     return copy;
                 }                
             },
             
         	'getRolesForUser': {
 	            method: 'GET',
 	            params: {userId:'@userId'},
 	            url: 'api/users-role/:userId',
 	            transformResponse: function (data) {
 	                if (data) {
 	                    data = angular.fromJson(data);
 	                }
 	                return data;
 	            }
         	},
         	
         	'getUserClearance': {
 	            method: 'GET',
 	            params: {userId:'@userId'},
 	            url: 'api/users-clearance/:userId',
 	            transformResponse: function (data) {
 	                if (data) {
 	                    data = angular.fromJson(data);
 	                   
 	                }
 	                return data;
 	            }
         	},
         	'fetchUserByPersonalId': {
 	            method: 'GET',
 	            params: {personalId:'@personalId'},
 	            url: 'api/fetch-user-for-personal-id/:personalId',
 	            transformResponse: function (data) {
 	                if (data) {
 	                    data = angular.fromJson(data);
 	                   
 	                }
 	                return data;
 	            }
         	},
         	'resubmitClearance': {
                method: 'PUT',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/resubmit/user-clearance',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                	return angular.toJson(copy);
                }
            },
         	 'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'resubmit': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/resubmit/user-roles',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             },

             'discard': {
            	 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/discard'
            },
            'mapOrganisation':{
            	method:'PUT',
            	url: 'api/users/map-organisation'
            },
            'getOrganisationByAlias': {
            	method: 'GET',
            	params: {aliasName:'@aliasName'},
            	url: 'api/get-org-by-alias/:aliasName'
            },
            'save': {
                method: 'POST',
                params: {orgId:'@orgId'},
                url: 'api/users/:orgId',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                }                
            },
            'update': {
            	method:'PUT',
            	params: {orgId:'@orgId'},
                url: 'api/users/:orgId',
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
            'delink': {
                method: 'PUT',
                params: {id:'@id'},
                url: 'api/delink-user/:id',              
                    transformRequest: function (data) {
                       	var copy = angular.copy(data);
                           return angular.toJson(copy);
                       }
            },
            'resubmitUserManagement': {
                method: 'PUT',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/resubmit/usermanagement',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                	return angular.toJson(copy);
                }
            },
            'getPID': {
            	method: 'GET',
                 params: {email:'@email',mobile :'@mobile',mobileCountryCode:'@mobileCountryCode',otp:'@otp'},
            	url: 'api/get-pid',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getUsersForOrganisation': {
                method: 'GET',
                params: {orgId:'@orgId'},
                url: 'api/users-by-organisation/:orgId',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getUsersExceptDelinkedForOrganisation': {
                method: 'GET',
                params: {orgId:'@orgId'},
                url: 'api/users-by-organisation-except-delinked/:orgId',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getUsersExceptDelinkedForBranch': {
                method: 'GET',
                params: {branchId:'@branchId'},
                url: 'api/all-users-except-delinked-for-branch/:branchId',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getNonDelinkedUsersForBranch':{
            	method: 'GET',
                params: {bankId:'@bankId',branchId:'@branchId'},
                url: 'api/all-non-delinked-users-for-branch/:bankId/:branchId',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getUsersForBranch': {
                method: 'GET',
                params: {branchId:'@branchId'},
                url: 'api/users-for-branch/:branchId',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getUsersByOrganisationAndEntityOwnerTypeForRestriciton': {
                method: 'GET',
                params: {orgId:'@orgId', entityOwnerType:'@entityOwnerType'},
                url: 'api/users-by-organisation-for-restriction/:orgId/entity-owner-type/:entityOwnerType',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getUsersForOrganisationForRestriction': {
                method: 'GET',
                params: {orgId:'@orgId'},
                url: 'api/users-by-organisation-for-restriction/:orgId',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },'getUsersForBranchRestriction': {
                method: 'GET',
                params: {branchId:'@branchId'},
                url: 'api/users-for-branch-restriciton/:branchId',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
			'checkPassword' : {
				method : 'POST',
				url : 'api/user-profile/check-password',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'getUsersByOrganisationAndEntityOwnerTypeTurnOverReport': {
                method: 'GET',
                params: {orgId:'@orgId', entityOwnerType:'@entityOwnerType'},
                url: 'api/users-by-org-entityowner-turnover-report/:orgId/entity-owner-type/:entityOwnerType',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getUsersForOrganisationTurnOverReport': {
                method: 'GET',
                params: {orgId:'@orgId'},
                url: 'api/users-by-organisation-turnover-report/:orgId',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },'getUsersForBranchTurnOverReport': {
                method: 'GET',
                params: {branchId:'@branchId',bankId:'@bankId'},
                url: 'api/users-for-branch-turnover-report/:bankId/:branchId',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAllUsersByOrganisationAndEntityOwnerType': {
                method: 'GET',
                params: {orgId:'@orgId', entityOwnerType:'@entityOwnerType'},
                url: 'api/all-users-by-org-entityowner/:orgId/entity-owner-type/:entityOwnerType',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAllUsersForOrganisation': {
                method: 'GET',
                params: {orgId:'@orgId'},
                url: 'api/all-users-by-organisation/:orgId',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },'getAllUsersForBranch': {
                method: 'GET',
                params: {branchId:'@branchId',bankId:'bankId'},
                url: 'api/all-users-for-branch/:bankId/:branchId',
                isArray:true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'SendOTPSMS' : {
				method : 'POST',
				url : 'api/forgot-pid/send-otp-mobile'
			},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('manage-user-restrictions', {          
            
        	parent: 'home',
            params:{screen: 'UserRestriction'},
        	url: 'manage-user-restrictions',
        	data: {
        		authorities: ['ROLE_USER'],
        		pageTitle: 'global.title'
        	},
        	ncyBreadcrumb: {
        		label: '{{ "global.menu.entityRestriction.manageUserRestriction" | translate }}',
        		parent: 'home'
        	},
        	onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        		$uibModal.open({
        			templateUrl: 'app/entities/manage-user-restrictions/manage-user-restrictions.html',
        			controller: 'ManageUserRestrictionController',
        			controllerAs: 'vm',
        			backdrop: 'static',
        			size: 'md',
        			resolve: {
        				entity: function(){
                    	
        				}
        			}
        		}).result.then(function() {
        			$state.go('home', null, {reload:true});
        		}, function() {
        			$state.go('home', null, {reload:false});
        		});
        	}],
        	resolve: {
        		translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
            	
        			$translatePartialLoader.addPart('userRestriction');
        			$translatePartialLoader.addPart('error');
        			$translatePartialLoader.addPart('global');
        			return $translate.refresh();
        			}]
        		}           
        	})
        	 .state('user-restrictions-todolist', {
            parent: 'dashboard',
            url: '/userRestrictionsView',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-user-restrictions/manage-user-restrictions.html',
                    controller: 'ManageUserRestrictionController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('home', null, { reload: 'home' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userRestriction');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
            
        })
        
         .state('user-restrictions-todolist.resubmit', {
            parent: 'dashboard',
            url: '/userRestrictionsResubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-user-restrictions/manage-user-restrictions.html',
                    controller: 'ManageUserRestrictionController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('home', null, { reload: 'home' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userRestriction');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('userRestriction-auditLog', {
            parent: 'audit-log',
            url: '/userRestrictionsauditLog',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-user-restrictions/manage-user-restrictions.html',
                    controller: 'ManageUserRestrictionController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('audit-log', null, { reload: 'audit-log' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userRestriction');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('userRestriction-historyReport', {
            parent: 'history-report',
            url: '/userRestrictionsHistoryReport',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-user-restrictions/manage-user-restrictions.html',
                    controller: 'ManageUserRestrictionController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('home', null, { reload: 'home' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userRestriction');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
       }    
 }) ();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('UserRestriciton', UserRestriciton);

    UserRestriciton.$inject = ['$resource'];

    function UserRestriciton ($resource) {
        var resourceUrl =  'api/user-status';
        
        return $resource(resourceUrl, {}, {
        	
        	 'get': {
                 method: 'GET',
                 params: {userId:'@userId'},
                 url: 'api/user-status',                 
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
        	 },
        	 'updateUserStatus' : {
        		 method: 'POST',
                 url: 'api/user-status-change/:orgId',
                 params: {orgId:'@orgId'},
                 isArray:false,
                 transformRequest: function (data) {
                  	
                  	var copy =angular.toJson(data);
                  	
                      return copy;
                  }
        	 },'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/user-restriction',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
             
        })
    }
}) ();
(function() {
    'use strict';

    angular
        .module('gatewayApp')      
        .controller('ManageUserRestrictionController', ManageUserRestrictionController);

    ManageUserRestrictionController.$inject = ['$scope', '$state', '$rootScope', 'workflowSharedService', 'GlobalValues', 'EntityPermissions', 'ScreenLog', 'entityConstants', 'AlertService', '$filter', 'UserRestriciton', '$uibModalInstance','Workflow'];

    function ManageUserRestrictionController($scope, $state,$rootScope ,workflowSharedService, GlobalValues,EntityPermissions, ScreenLog ,entityConstants ,AlertService,$filter, UserRestriciton, $uibModalInstance,Workflow) {
    	
    	 var vm = this;
         vm.userRestriction={};  
         vm.screenName = entityConstants.ENTITY_SHORT_NAME.USER_RESTRICTION;
         vm.entityConstants = entityConstants;
         vm.screenLog = ScreenLog;
         vm.globalValues = GlobalValues;
         
         $scope.showOkButton = false;
         $scope.showSaveButton = false;
         $scope.showResubmitButton = false;
         $scope.showApproveRejectButton = false;
         $scope.showDiscardButton = false;
         vm.showChangeStatus = true;
         vm.disableEdit = false;
         vm.disableForResubmit= false;         
         $scope.clicked=false;
         
         vm.approveUserRestriction = approveUserRestriction ;
         vm.resubmitUserRestriction =resubmitUserRestriction;
         vm.rejectUserRestriction = rejectUserRestriction;
         vm.discardUserRestriction = discardUserRestriction;
         vm.clear=clear;
         vm.saveUserRestriction = saveUserRestriction;
         
         vm.loggedInUser = vm.globalValues.getUser();
         vm.loggedinEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
         vm.mulitCustomerEntityOwnerTypeId = 4;
        
         //vm.possibleRestricitons=null;  
         vm.disableBank=false;
         vm.disableBranch=false;
         vm.disableCustomer=false;     
                 
         //vm.userFilterValue =[];
        // vm.userLookUpName = "";
         vm.userFilterValueCCIL =[];
         vm.userLookUpNameCCIL = "";
         vm.userFilterValueBank =[];
         vm.userLookUpNameBank = "";
         vm.userFilterValueBranch =[];
         vm.userLookUpNameBranch = "";
         vm.userFilterValueCustomer =[];
         vm.userLookUpNameCustomer = "";
         
         
         if($state.current.name=="manage-user-restrictions"){
        	 workflowSharedService.viewFrom="";
         }
         
         logScreenAccess();
         function logScreenAccess(){
            	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
         }         
         // method to enable Radio buttons                  
         function enableRadioButtons(showCCILRadio, showBankRadio, showBranchRadio, showCustomerRadio){
        	
        	vm.showCCILRadio= showCCILRadio;
            vm.showBankRadio = showBankRadio;
            vm.showBranchRadio = showBranchRadio;
            vm.showCustomerRadio  = showCustomerRadio;
        }     
         //method to enable controls
        function showControls(showBankControl, showBranchControl, showCustomerControl, showCcilUser, showBankUser,showBranchUser, showCustomerUser){       	
        	 
            vm.showBankControl = showBankControl;
            vm.showBranchControl = showBranchControl;
            vm.showCustomerControl  = showCustomerControl;
            vm.ccilUser = showCcilUser;
            vm.bankUser= showBankUser;
            vm.branchUser= showBranchUser;
            vm.customerUser = showCustomerUser;
         /*  
            if(vm.showBankControl){
           	 angular.element(document.querySelector("#txtbank")).attr('required','');
           	 angular.element(document.querySelector("#txtbank")).addClass('borderClass');
           	 //border: 1px solid #BB8557;
           }else{
           	 angular.element(document.querySelector("#txtbank")).removeAttr('required');
           }
           if(vm.showBranchControl){
          	 angular.element(document.querySelector("#txtBranch")).attr('required','');
          	 angular.element(document.querySelector("#txtBranch")).addClass('borderClass');
          	 //border: 1px solid #BB8557;
          }else{
          	 angular.element(document.querySelector("#txtBranch")).removeAttr('required');
          }
           if(vm.showCustomerControl){
          	 angular.element(document.querySelector("#txtCustomer")).attr('required','');
          	 angular.element(document.querySelector("#txtCustomer")).addClass('borderClass');
          	 //border: 1px solid #BB8557;
          }else{
          	 angular.element(document.querySelector("#txtCustomer")).removeAttr('required');
          }*/
        }       
        function disableControls(disableBank,disableBranch,disableCustomer){
        	 
        	vm.disableBank=disableBank;
            vm.disableBranch=disableBranch;
            vm.disableCustomer=disableCustomer;
         
        }   	 
        
        // Enable Radio buttons based on logged in user entity
        function activateAllowedEntities(){
        	 vm.possibleRestricitons=null;  
        	 var selectedEntity = "";
        	 if (vm.loggedinEntityOwnerType == 'Clearcorp'){
        		 enableRadioButtons(true,true,true,true);
        		 selectedEntity="Clearcorp";
        	 }
        	 else if (vm.loggedinEntityOwnerType == 'Bank'){
        		 enableRadioButtons(false,true,true,true);
        		 vm.userRestriction.selectedBank = vm.globalValues.getBank();
        		 //vm.disableBank = true;
        		 selectedEntity="Bank";
        	 }
        	 else if (vm.loggedinEntityOwnerType == 'Branch'){
        		 enableRadioButtons(false,false,true,true);
        		 vm.userRestriction.selectedBank = vm.globalValues.getBank();
        		 vm.userRestriction.selectedBranch = vm.globalValues.getBranch();
        		 //vm.disableBranch= true;
        		 selectedEntity="Branch";
        	 }
        	 else if (vm.loggedinEntityOwnerType == 'MultiUserCustomer'){
        		 enableRadioButtons(false,false,false,true);
        		 vm.userRestriction.selectedCustomer = vm.globalValues.getOrganisation();
        		// vm.disableCustomer = true;;
        		 selectedEntity="MultiUserCustomer";
        	 }
        	 if(vm.userRestriction.selectedEntity==null || vm.userRestriction.selectedEntity==undefined || vm.userRestriction.selectedEntity==""){
        		 vm.userRestriction.selectedEntity = selectedEntity;
        	 }
        	 onRadioValueChange(vm.userRestriction.selectedEntity);
        	 
         }
        //check workflow and set the flags accordingly
        if(workflowSharedService.viewFrom == 'userRestriction_checker') {
        	 
        	 	vm.userRestriction  =  angular.fromJson($rootScope.payload);         	 	
         		$scope.showSaveButton = false;
         		$scope.showResubmitButton = false;
         		$scope.showApproveRejectButton=true;
         		$scope.showDiscardButton = false;
         		vm.disableEdit=true;
         		//vm.userFilterValue ='';
               //vm.userLookUpName = '';
         		 vm.userFilterValueCCIL ='';
                 vm.userLookUpNameCCIL = '';
                 vm.userFilterValueBank ='';
                 vm.userLookUpNameBank = '';
                 vm.userFilterValueBranch ='';
                 vm.userLookUpNameBranch = '';
                 vm.userFilterValueCustomer ='';
                 vm.userLookUpNameCustomer = '';
               
         }
         else if(workflowSharedService.viewFrom == 'userRestriction_maker') {
        	 	vm.userRestriction=  angular.fromJson($rootScope.payload); 
        	 	
        	 	$scope.showSaveButton = false;
        	 	$scope.showResubmitButton = false;
         	 	$scope.showApproveRejectButton=false;
         	 	$scope.showDiscardButton = true;
         	 	vm.disableEdit=true;
         	 	 vm.userFilterValueCCIL ='';
                 vm.userLookUpNameCCIL = '';
                 vm.userFilterValueBank ='';
                 vm.userLookUpNameBank = '';
                 vm.userFilterValueBranch ='';
                 vm.userLookUpNameBranch = '';
                 vm.userFilterValueCustomer ='';
                 vm.userLookUpNameCustomer = '';
                
         }
         else if(workflowSharedService.viewFrom == 'userRestriction_resubmit') {
         	
        	 	vm.userRestriction= angular.fromJson($rootScope.payload); 
        	 	vm.screenLog.screenLog(vm.screenName, vm.userRestriction.user.id==null?0:vm.userRestriction.user.id, entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
        	 	$scope.showSaveButton=false;
        	 	$scope.showResubmitButton = true;
        	 	$scope.showApproveRejectButton=false;
        	 	$scope.showDiscardButton = false;
        	 	vm.disableEdit=false;
        	 	vm.disableForResubmit = true;
         }else if(workflowSharedService.viewFrom == 'userRestriction_auditLog'){
     	 	
        	 	vm.userRestriction=angular.fromJson($rootScope.payload);        		
        	 	$scope.showSaveButton = false;
        	 	$scope.showApproveRejectButton = false;
        	 	$scope.showDiscardButton = false;
        	 	vm.disableEdit=true;
        	 	$scope.showResubmitButton = false;
        	 	$scope.showOkButton = true;
         }else{
        	 	vm.userRestriction={};        		
        	 	$scope.showSaveButton = true;
        	 	$scope.showApproveRejectButton = false;
        	 	$scope.showDiscardButton = false;
        	 	vm.disableEdit=false;
        	 	$scope.showResubmitButton = false;
         } 
        // activate Allowed Entities on pageload
        activateAllowedEntities();
        function onRadioValueChange(selectedEntity){
        	
        	//on radio button change 
        	 if( !(workflowSharedService.viewFrom == 'userRestriction_resubmit' || workflowSharedService.viewFrom == 'userRestriction_maker' 
        		 || workflowSharedService.viewFrom == 'userRestriction_checker'|| workflowSharedService.viewFrom == 'userRestriction_auditLog')){
        		 clearInput();
        	 }else{
        		 UserRestriciton.get({userId : vm.userRestriction.user.id} ,onGetPossibleRestricitonSuccess, onGetPossibleRestricitonFailure );
        	 }
        	 if( vm.loggedinEntityOwnerType == 'Clearcorp' && selectedEntity == 'Clearcorp') {
        		
        		 showControls(false,false,false,true,false,false,false);
        		 disableControls(true,true,true);
        		 vm.userFilterValueCCIL ='';
                 vm.userLookUpNameCCIL = "usersByOrganisationForRestriction";
                 
        	 }else if(vm.loggedinEntityOwnerType == 'Clearcorp' && selectedEntity == 'Bank'){        		 
        		
        		 showControls(true,false,false,false,true,false,false); 
        		 disableControls(false,true,true);
        		 vm.userFilterValueBank=null;
                 vm.userLookUpNameBank = null;
        	 }else if( vm.loggedinEntityOwnerType == 'Clearcorp'  && selectedEntity == 'Branch'){        		 
        		 
        		 showControls(true,true,false,false,false,true,false);  
        		 disableControls(false,false,true);
        		 vm.userFilterValueBranch=null;
                 vm.userLookUpNameBranch = null;
        	 }else if( vm.loggedinEntityOwnerType == 'Clearcorp'  && selectedEntity == 'MultiUserCustomer'){
        		 
        		 showControls(true,true,true,false,false,false,true);
        		 disableControls(false,false,false);
        		 //vm.userFilterValue =['MultiUserCustomer', '', '' ,vm.userRestriction.selectedCustomer.id ];
        		 vm.userFilterValueCustomer=null;
                 vm.userLookUpNameCustomer = null;
        	 }
        	 else if(  vm.loggedinEntityOwnerType == 'Bank'  && selectedEntity == 'Branch'){ 
        	 
        		 showControls(true,true,false,false,false,true,false);  
        		 disableControls(true,false,true);
        		 vm.userFilterValueBranch=null;
                 vm.userLookUpNameBranch = null;
        	 }else if(  vm.loggedinEntityOwnerType == 'Bank' && selectedEntity == 'MultiUserCustomer'){
        		 
        		 showControls(true,true,true,false,false,false,true);
        		 disableControls(true,false,false);
        		 //vm.userFilterValue =['MultiUserCustomer', '', '' ,vm.userRestriction.selectedCustomer.id ];
        		 vm.userFilterValueCustomer=null;
                 vm.userLookUpNameCustomer = null;
        	 }
        	 else if(vm.loggedinEntityOwnerType == 'Bank' && selectedEntity == 'Bank'){
        		 
        		 showControls(true,false,false,false,true,false,false);
        		 disableControls(true,true,true);
        		 vm.userFilterValueBank ='';
                 vm.userLookUpNameBank = "usersByOrganisationForRestriction";
        	 }else if(vm.loggedinEntityOwnerType == 'Branch' && selectedEntity == 'Branch'){
        		 
        		 showControls(false,true,false,false,false,true,false);
        		 disableControls(true,true,true);
        		 vm.userFilterValueBranch ='';
                 vm.userLookUpNameBranch = "usersByOrganisationForRestriction";
        	 }else if(vm.loggedinEntityOwnerType == 'Branch' && selectedEntity == 'MultiUserCustomer'){
        		 
        		 showControls(false,true,true,false,false,false,true);
        		 disableControls(true,true,false);
        		 //vm.userFilterValue =['MultiUserCustomer', '', '' ,vm.userRestriction.selectedCustomer.id ];
        		 vm.userFilterValueCustomer=null;
                 vm.userLookUpNameCustomer = null;
        	 }else if(vm.loggedinEntityOwnerType == 'MultiUserCustomer' && selectedEntity == 'MultiUserCustomer'){
        		 
        		 showControls(false,false,true,false,false,false,true);
        		 disableControls(true,true,true);
        		 vm.userFilterValueCustomer ='';
                 vm.userLookUpNameCustomer = "usersByOrganisationForRestriction";
        	 }
        	
        	 //setUserFileterValue();
         }
         function onUserSelection(selectedUSer){
        	 
        	 if(selectedUSer!=null && selectedUSer !=undefined &&  selectedUSer!=""){
        		 if( !(workflowSharedService.viewFrom == 'userRestriction_resubmit' || workflowSharedService.viewFrom == 'userRestriction_maker' 
        			 || workflowSharedService.viewFrom == 'userRestriction_checker' || workflowSharedService.viewFrom =='userRestriction_auditLog')){
        		
        			 
        			 UserRestriciton.get({userId : selectedUSer.id} ,onGetPossibleRestricitonSuccess, onGetPossibleRestricitonFailure );
        		 }
        		 
        	 }
        	
         }
         function onGetPossibleRestricitonSuccess(result){
        	 vm.userRestriction.existingRestrictionStatus = result.currentStatus;
        	 vm.possibleRestricitons = result.availableStatus;
        	 if(vm.userRestriction.existingRestrictionStatus.shortName == 'TERMINATED'  || vm.userRestriction.existingRestrictionStatus.shortName == 'DELINKED'){
    			 vm.showChangeStatus = false;
    			 //vm.userRestriction.newRestrictionApplied = null;
    		 }else{
    			 vm.showChangeStatus = true;
    		 }
         }
         function onGetPossibleRestricitonFailure(error){
        	//errro handling
         }
         function saveUserRestriction(){
        	 var orgId = GlobalValues.getOrgId();
        	 vm.userRestriction.user.organisation=null;
        	 UserRestriciton.updateUserStatus( { "orgId": orgId },vm.userRestriction, onSaveSuccess, onSaveError ) ;
         }
         function onSaveSuccess (result) {
        	 //$uibModalInstance.close(result); 
        	 clearInput();
        	 vm.userRestriction.selectedEntity='';
        	 activateAllowedEntities();
        
        	
        	 
         }

         function onSaveError () {
        	 vm.userRestriction.selectedEntity='';
        	 activateAllowedEntities();
        	 clicked=false;
         }
         $scope.$watch('vm.userRestriction.selectedEntity', function(value){
        	 onRadioValueChange(value);
        	 
         });       
         $scope.$watch('vm.userRestriction.user', function(value){
        	 onUserSelection(value);
        	 
         });
         $scope.$watch('vm.userRestriction.selectedBank', function(value){
        	 
        	 setUserFileterValue();
         });
         $scope.$watch('vm.userRestriction.selectedBranch', function(value){
        	
        	 setUserFileterValue();
         });
         $scope.$watch('vm.userRestriction.selectedCustomer', function(value){
        	 
        	 setUserFileterValue();
         });
       
         function setUserFileterValue(){
        	 if( !(workflowSharedService.viewFrom == 'userRestriction_resubmit' || workflowSharedService.viewFrom == 'userRestriction_maker' 
        		 || workflowSharedService.viewFrom == 'userRestriction_checker' || workflowSharedService.viewFrom == 'userRestriction_auditLog')){
        		 vm.userRestriction.user = null;
        	 }
        	 if(vm.loggedinEntityOwnerType == 'Clearcorp' && vm.userRestriction.selectedEntity == 'Bank'
     		 	&& !(vm.userRestriction.selectedBank ==null || vm.userRestriction.selectedBank==undefined || vm.userRestriction.selectedBank=="" )){
        		 vm.userFilterValueBank ='Bank'+'~~'+ vm.userRestriction.selectedBank.id;
        		 vm.userLookUpNameBank = "userForRestriciton";
        	 }else if( ( vm.loggedinEntityOwnerType == 'Clearcorp' || vm.loggedinEntityOwnerType == 'Bank') && vm.userRestriction.selectedEntity == 'Branch'
     		 	&& !(vm.userRestriction.selectedBank ==null || vm.userRestriction.selectedBranch==undefined || vm.userRestriction.selectedBranch=="" )){
        		 
        		 vm.userFilterValueBranch ='Branch'+'~~'+ ''+ '~~'+ vm.userRestriction.selectedBranch.id;
        		 vm.userLookUpNameBranch = "userForRestriciton";
        	 }else if( (vm.loggedinEntityOwnerType == 'Clearcorp' || vm.loggedinEntityOwnerType == 'Bank' || vm.loggedinEntityOwnerType == 'Branch' ) && vm.userRestriction.selectedEntity == 'MultiUserCustomer' 
        		 &&  !(vm.userRestriction.selectedCustomer ==null || vm.userRestriction.selectedCustomer==undefined || vm.userRestriction.selectedCustomer=="" )){
         	 	//vm.userFilterValue ='MultiUserCustomer'+'~~'+ ''+ '~~'+ ''+ '~~'+vm.userRestriction.selectedCustomer.id ;
        		vm.userFilterValueCustomer =''+'~~'+ ''+ '~~'+ ''+ '~~'+vm.userRestriction.selectedCustomer.id ;
         	 	vm.userLookUpNameCustomer = "userForRestriciton";
          	}
         }
         function clearInput(){
        	 vm.userRestriction.existingRestrictionStatus = null;
        	 vm.userRestriction.newRestrictionApplied = null;
        	 vm.userRestriction.modifiedBy = null;
        	 vm.userRestriction.user = null;
        	 vm.userRestriction.id = null;
        	 vm.possibleRestricitons=null;
        	 if( vm.loggedinEntityOwnerType == 'Clearcorp' ) {
        		 vm.userRestriction.selectedBank = null;
        		 vm.userRestriction.selectedBranch = null;
        		 vm.userRestriction.selectedCustomer = null;
        	 }else if(vm.loggedinEntityOwnerType =='Bank'){
        		 
        		 vm.userRestriction.selectedBranch = null;
        		 vm.userRestriction.selectedCustomer = null;
        	 }else if(vm.loggedinEntityOwnerType =='Branch'){
        		
        		 vm.userRestriction.selectedCustomer = null;
        	 }
        	 //vm.userFilterValue =null;
             //vm.userLookUpName = "";            
        	 vm.userFilterValueCCIL = null;
             vm.userLookUpNameCCIL = '';
             vm.userFilterValueBank = null;
             vm.userLookUpNameBank = '';
             vm.userFilterValueBranch = null;
             vm.userLookUpNameBranch = '';
             vm.userFilterValueCustomer = null;
             vm.userLookUpNameCustomer = '';
         }
         
         function clear() {
        	 workflowSharedService.viewFrom="";
             $uibModalInstance.dismiss('cancel');
         }
         function resubmitUserRestriction() {
        	 vm.userRestriction.user.organisation=null;
        	UserRestriciton.resubmit({"taskId" : $rootScope.taskID}, vm.userRestriction, onResubmitSuccess, onResubmitError);
         	$uibModalInstance.dismiss('cancel');
         }
         
         function onResubmitSuccess(result) {
         	$rootScope.removeRow($rootScope.taskID);
         }        
         function onResubmitError(error) {
        	 clicked=false;
         }
         
         function rejectUserRestriction() { Workflow.rejectTask($rootScope.taskID); }
         
         function discardUserRestriction() {
        	UserRestriciton.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
         	$uibModalInstance.dismiss('cancel');	
         }
         
         function onDiscardSuccess(result) {
         	
         	$rootScope.removeRow($rootScope.taskID);        	
         }        
         function onDiscardError(error) {
         	
         }

         function approveUserRestriction() {  
        	UserRestriciton.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
         	$uibModalInstance.dismiss('cancel');     	
         }
         
         function onApproveSuccess(result) {
         	$rootScope.removeRow($rootScope.taskID);        	
         }        
         function onApproveError(error) {
         	
         }
         
         
    }
   
   
})();
  
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('OrganisationViewController', OrganisationViewController);

    OrganisationViewController.$inject = ['Workflow', '$scope', '$state','$rootScope', 'workflowSharedService','$uibModalInstance','Organisation','entity'];

    function OrganisationViewController(Workflow, $scope, $state,$rootScope, workflowSharedService, $uibModalInstance, Organisation,entity) {
        var vm = this;
        vm.clear=clear;
        $scope.showButton = false;
        $scope.showDiscardButton = false;
        
        vm.approveOrganisation = approveOrganisation;
        vm.rejectOrganisation = rejectOrganisation;
        vm.discardOrganisation = discardOrganisation;
        vm.ShowRequestedByLink = false;
        $scope.clicked=false;
        
        if(workflowSharedService.viewFrom == 'organisation'){
        	vm.organisation = entity;
       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'organisationtodolist_checker') {
        	vm.organisation =  angular.fromJson($rootScope.payload); 
        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
        	vm.taskId = $rootScope.taskID;
        	vm.ShowRequestedByLink = true;
        }
        else if(workflowSharedService.viewFrom == 'organisationtodolist_maker') {
        	vm.organisation =  angular.fromJson($rootScope.payload); 
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        }
        
        
        if(vm.organisation.orgType=="CORPORATE" || vm.organisation.fyEndMonth != null){
     	   vm.showCorporate=true;
     	   vm.organisation.fyStartMonth= vm.organisation.fyStartMonth.toString();
            
            vm.organisation.fyEndMonth= vm.organisation.fyEndMonth.toString();
        }
        
        function approveOrganisation() { 
        	Organisation.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectOrganisation() {
        	Workflow.rejectTask($rootScope.taskID);
        }

        function discardOrganisation() {
        	Organisation.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }
      
        function clear () {
        	
            $uibModalInstance.dismiss('cancel');
        }
       
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('OrganisationEditController', OrganisationEditController);

    OrganisationEditController.$inject = ['$scope', '$state','$rootScope', 'workflowSharedService','$uibModalInstance','Organisation','entity','GlobalValues'];

    function OrganisationEditController($scope, $state,$rootScope, workflowSharedService,$uibModalInstance, Organisation,entity,GlobalValues) {
        var vm = this;
        vm.clear=clear;
        vm.save=save;
        $scope.showButton=false;
        vm.resubmit=resubmit;
        $scope.clicked=false;
       vm.calculateFYEndMonth = calculateFYEndMonth;
       
       if(workflowSharedService.viewFrom == 'organisationtodolist_maker') {
    	   vm.organisation =  angular.fromJson($rootScope.payload); //load from pay-load when viewing from dash-board
         
        
          	$scope.showButton=true;
          }
       
       else{
    	   vm.organisation=entity;//load from the entity state during normal view
       	
       }
       
       if(vm.organisation.organisationType.shortName=="CORPORATE"){
    	   vm.showCorporate=true;
    	   vm.organisation.fyStartMonth= vm.organisation.fyStartMonth.toString();
           
           vm.organisation.fyEndMonth= vm.organisation.fyEndMonth.toString();
       }
       
      function save(){

          if(vm.organisation.organisationType.shortName=="CORPORATE"){
        	  Organisation.updateCorporate(vm.organisation);
        	  
          }
          else  if(vm.organisation.organisationType.shortName=="CONSULTANT"){
        	  Organisation.updateConsultant(vm.organisation);
          }
          $uibModalInstance.dismiss('cancel');
      }
      function resubmit(){
    	   if(vm.organisation.organisationType.shortName=="CORPORATE"){
         	  Organisation.resubmitCorporate({"taskId" : $rootScope.taskID},vm.organisation,onResubmitSuccess);
         	  
           }
           else  if(vm.organisation.organisationType.shortName=="CONSULTANT"){
         	  Organisation.resubmitConsultant({"taskId" : $rootScope.taskID},vm.organisation,onResubmitSuccess);
           }
    	  
      }
      function onResubmitSuccess(){
       		$rootScope.removeRow($rootScope.taskID);
    	  $uibModalInstance.dismiss('cancel');
      }
      
       function calculateFYEndMonth(){
       	
       		vm.organisation.fyEndMonth = (parseInt(vm.organisation.fyStartMonth) -1).toString();
       		if(vm.organisation.fyEndMonth == "0"){
       			vm.organisation.fyEndMonth = "12";
       		}
       	
       }
        function clear () {
        	
            $uibModalInstance.dismiss('cancel');
        }
       
        
    }
})();



(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('manage-organisation', {
            parent: 'entity',
            url: '/manage-organisation',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.organisation.manageorganisations" | translate }}',
                parent: 'home'
              },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manage-organisation/manage-organisation.html',
                    controller: 'ManageOrganisationController',
                    controllerAs: 'vm',
                    resolve: {
                         	entity:['Organisation', 'GlobalValues','$sessionStorage', function(Organisation, GlobalValues, $sessionStorage) {
                                 return $sessionStorage.userorganisation;
                             }]
                             }
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('organisation');
                    $translatePartialLoader.addPart('corporate');
                    $translatePartialLoader.addPart('consultant');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('manage-organisation.edit', {
            parent: 'manage-organisation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-organisation/organisation-edit-dialog.html',
                    controller: 'OrganisationEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity:['Organisation','$sessionStorage', function(Organisation,$sessionStorage) {
                            
                    		if($sessionStorage.userorganisation.organisationType.shortName=="CORPORATE"){
                    			return Organisation.getCorporate({id:$stateParams.id}).$promise;
                    		}
                    		else if($sessionStorage.userorganisation.organisationType.shortName=="CONSULTANT"){
                    			return Organisation.getConsultant({id:$stateParams.id}).$promise;
                    		}
                    		else 
                    			return null;
                    		
                        }]
                        }
                    
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('manage-organisation-todolist.resubmit', {
            parent: 'dashboard',
            url: '/organisationresubmit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-organisation/organisation-edit-dialog.html',
                    controller: 'OrganisationEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity:{
                        }
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
          .state('manage-organisation-todolist', {
            parent: 'dashboard',
            url: '/organisationview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-organisation/organisation-view-dialog.html',
                    controller: 'OrganisationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity:{
                        }
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('manage-organisation.view', {
            parent: 'manage-organisation',
            url: '/{id}/view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-organisation/organisation-view-dialog.html',
                    controller: 'OrganisationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                    	entity:['Organisation','$sessionStorage', function(Organisation,$sessionStorage) {
                            
                    		if($sessionStorage.userorganisation.organisationType.shortName=="CORPORATE"){
                    			return Organisation.getCorporate({id:$stateParams.id}).$promise;
                    		}
                    		else if($sessionStorage.userorganisation.organisationType.shortName=="CONSULTANT"){
                    			return Organisation.getConsultant({id:$stateParams.id}).$promise;
                    		}
                    		else 
                    			return null;
                    		
                        }]
                        }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]            
        })
       

        };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('Organisation', Organisation);

    Organisation.$inject = ['$resource'];

    function Organisation ($resource) {
    	   var resourceUrl =  'api/corporate/:id';

           return $resource(resourceUrl, {}, {
               'query': { method: 'GET', isArray: true},
               'getCorporate': {
                   method: 'GET',
                   isArray:false,
                   params: {id:'@id'},
                   url: 'api/corporate/:id',
                   transformResponse: function (data) {
                       if (data) {
                           data = angular.fromJson(data);
                       }
                       return data;
                   }
               },
            'getConsultant': {
                method: 'GET',
                params: {id:'@id'},
                url:'api/consultant/:id',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'updateCorporate': {
                method: 'PUT',
                url: 'api/corporates',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                }                
            },
            'updateConsultant': {
                method: 'PUT',
                url: 'api/consultants',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                }                
            },
    
            
            'resubmitCorporate': {
                method: 'PUT',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/resubmit/corporates',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                	return angular.toJson(copy);
                }
            },
      

            'approve': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
              	 method: 'GET',
                   params: {taskId:'@taskId'},
                   url: 'api/tasks/:taskId/discard'
             },
             'resubmitConsultant': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/resubmit/consultants',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             },
  
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'organisation'
         })
        .controller('ManageOrganisationController', ManageOrganisationController);

    ManageOrganisationController.$inject = ['$scope', '$state', 'workflowSharedService','Organisation', 'GlobalValues',  'entity', 'EntityPermissions'];

    function ManageOrganisationController($scope, $state, workflowSharedService,Organisation,GlobalValues, entity, EntityPermissions) {
        var vm = this;
        workflowSharedService.viewFrom = "organisation";

        vm.organisation=entity;
        
        vm.permitOrganisationEditEntityAction = EntityPermissions.hasPermission('Organisation.EDIT')
        vm.permitOrganisationViewEntityAction = EntityPermissions.hasPermission('Organisation.VIEW')

        
        	

 
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('manage-limits', {
            parent: 'entity',
            url: '/limits',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.riskManagement.limitSettings" | translate }}',
                parent: 'home'
              },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manage-limit/manage-limit.html',
                    controller: 'LimitsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('manage-limits.edit', {
            parent: 'manage-limits',
            url: '/limits/edit/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog-new.html',
                    controller: 'LimitsDialogNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                   	 entity: ['LimitSettings', 'GlobalValues', function(LimitSettings, GlobalValues) {
                   		 	
                            return LimitSettings.get({id : $stateParams.id}).$promise;
                        }]
              
           }
                }).result.then(function() {
                    $state.go('manage-limits', {}, { reload: 'manage-limits' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('manage-limits.reset', {
            parent: 'manage-limits',
            url: '/limits/reset/{id}',
            params: {resetInstrumentGroup: null},
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog-new.html',
                    controller: 'LimitsDialogNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        
                     entity: ['LimitSettings', 'GlobalValues', function(LimitSettings, GlobalValues) {
                            
                            return LimitSettings.get({id : $stateParams.id}).$promise;
                     }]
              
                    }
                }).result.then(function() {
                    $state.go('manage-limits', {}, { reload: 'manage-limits' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('manage-limits.new', {
            parent: 'manage-limits',
            url: '/limits/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog-new.html',
                    controller: 'LimitsDialogNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {                       	
                            
                          }
                      }
                }).result.then(function() {
                    $state.go('manage-limits', {}, { reload: 'manage-limits' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
            .state('manage-limits.view', {
            parent: 'manage-limits',
            url: '/limits/view/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog-new.html',
                    controller: 'LimitsDialogNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                     	
                      	 entity: ['LimitSettings', 'GlobalValues', function(LimitSettings, GlobalValues) {
                               return LimitSettings.get({id : $stateParams.id}).$promise;
                           }]
                      }
                }).result.then(function() {
                    $state.go('manage-limits', {}, { reload: 'manage-limits' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('limit-settings-todolist', {
            parent: 'dashboard',
            url: '/limit-settings-todolist',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog-new.html',
                    controller: 'LimitsDialogNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {                       	
                            
                          }
                      }
                }).result.then(function() {
                    $state.go('dashboard', {}, { reload: 'dashboard' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('limit-settings-todolist.resubmit', {
            parent: 'dashboard',
            url: '/limit-settings-todolist/resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog-new.html',
                    controller: 'LimitsDialogNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {                       	
                            
                          }
                      }
                }).result.then(function() {
                    $state.go('dashboard', {}, { reload: 'dashboard' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('customer_limit_Settings', {
            parent: 'home',
            url: '/customer-limit-change-request',
            params : {customerId: null, bankId: null, limitInstrumentGroup: null},
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog-new.html',
                    controller: 'LimitsDialogNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                   	 entity: ['LimitSettings', function(LimitSettings) {
                        return LimitSettings.getLimitForCustomer({customerId : $stateParams.customerId , bankId :$stateParams.bankId, limitInstrumentGroup: $stateParams.limitInstrumentGroup}).$promise;
                     }]
                    }
                }).result.then(function() {
                    $state.go('home', {}, { reload: 'home' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('customer-limit-settings-todolist', {
            parent: 'dashboard',
            url: '/customer-limits-todoList',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog-new.html',
                    controller: 'LimitsDialogNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                   	 entity: [function() {
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('dashboard', {}, { reload: 'dashboard' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('customer-limit-settings-todolist.resubmit', {
            parent: 'dashboard',
            url: '/customer-limit-settings-todolist/resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog-new.html',
                    controller: 'LimitsDialogNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {                       	
                            
                          }
                      }
                }).result.then(function() {
                    $state.go('dashboard', {}, { reload: 'dashboard' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
         .state('old-limit-settings-auditLog', {
            parent: 'audit-log',
            url: '/old-limit-settings-auditLog',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog.html',
                    controller: 'LimitsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                   	 entity: [function() {
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('manage-limits', {}, { reload: 'manage-limits' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
         .state('limit-settings-auditLog', {
            parent: 'audit-log',
            url: '/limit-settings-auditLog',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog-new.html',
                    controller: 'LimitsDialogNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        
                     entity: [function() {
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('manage-limits', {}, { reload: 'manage-limits' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('old-customer-limit-settings-auditLog', {
            parent: 'audit-log',
            url: '/old-customer-limit-settings-auditLog',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog.html',
                    controller: 'LimitsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        
                     entity: [function() {
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('home', {}, { reload: 'home' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('customer-limit-settings-auditLog', {
            parent: 'audit-log',
            url: '/customer-limit-settings-auditLog',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog-new.html',
                    controller: 'LimitsDialogNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                   	 entity: [function() {
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('home', {}, { reload: 'home' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('old-limit-settings-historyReport', {
            parent: 'history-report',
            url: '/old-limit-settings-historyReport',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog.html',
                    controller: 'LimitsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                   	 entity: [function() {
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('manage-limits', {}, { reload: 'manage-limits' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('limit-settings-historyReport', {
            parent: 'history-report',
            url: '/limit-settings-historyReport',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog-new.html',
                    controller: 'LimitsDialogNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        
                     entity: [function() {
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('manage-limits', {}, { reload: 'manage-limits' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('old-customer-limit-settings-historyReport', {
            parent: 'history-report',
            url: '/old-customer-limit-settings-historyReport',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog.html',
                    controller: 'LimitsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                   	 entity: [function() {
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('home', {}, { reload: 'home' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('customer-limit-settings-historyReport', {
            parent: 'history-report',
            url: '/customer-limit-settings-historyReport',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog-new.html',
                    controller: 'LimitsDialogNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        
                     entity: [function() {
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('home', {}, { reload: 'home' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('create-customer-limit-settings', {
            parent: 'home',
            params:{screen:'CustomerLimitChangeRequest'},
            url: 'create-customer-limits',
            data: {
                authorities: ['ROLE_USER']
            },
           
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/customer-new-limit.html',
                    controller: 'CustomerNewLimitController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                    	 entity: function() {
                         }
              
           }
                }).result.then(function() {
                    $state.go('home', null, { reload: true });
                }, function() {
                	$state.go('home', null, {reload:false});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
         .state('create-customer-limit-settings-todolist', {
            parent: 'dashboard',
            url: '/create-customer-limits-todoList',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/entities/manage-limit/customer-new-limit.html',
                    controller: 'CustomerNewLimitController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                   	 entity: function() {
                        }
              
                    }
                }).result.then(function() {
                    $state.go('dashboard', null, { reload: 'dashboard' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('create-customer-limit-settings-todolist.resubmit', {
            parent: 'dashboard',
            url: '/create-customer-limit-settings-todolist/resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/customer-new-limit.html',
                    controller: 'CustomerNewLimitController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {                       	
                            
                          }
                      }
                }).result.then(function() {
                    $state.go('dashboard', null, { reload: 'dashboard' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
         .state('create-customer-limit-settings-todolist-checker', {
            parent: 'dashboard',
            url: '/create-customer-limit-settings-checker',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/limit-dialog-new.html',
                    controller: 'LimitsDialogNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                   	 entity: [function() {
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('dashboard', {}, { reload: 'dashboard' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('create-customer-limit-settings-limit-report', {
            parent: 'home',
            url: '/create-customer-limits-new/bankId/{bankId}/instrument/{instrumentCode}',
            data: {
                authorities: ['ROLE_USER']
            },
           
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/customer-new-limit.html',
                    controller: 'CustomerNewLimitController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                    	 entity: function() {
                         }
              
           }
                }).result.then(function() {
                    $state.go('home', null, { reload: true });
                }, function() {
                	$state.go('home', null, {reload:false});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
         .state('old-create-customer-limit-settings-auditLog', {
            parent: 'audit-log',
            url: '/old-create-customer-limit-settings-auditLog',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/entities/manage-limit/customer-new-limit-dialog.html',
                	controller: 'CustomerCreateLimitController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                   	 entity: [function() {
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('audit-log', {}, { reload: 'audit-log' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
         .state('create-customer-limit-settings-auditLog', {
            parent: 'audit-log',
            url: '/create-customer-limit-settings-auditLog',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/customer-new-limit.html',
                    controller: 'CustomerNewLimitController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        
                     entity: [function() {
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('audit-log', {}, { reload: 'audit-log' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('old-create-customer-limit-settings-historyReport', {
            parent: 'history-report',
            url: '/old-create-limit-settings-historyReport',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/entities/manage-limit/customer-new-limit-dialog.html',
                    controller: 'CustomerCreateLimitController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                   	 entity: [function() {
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('history-report', {}, { reload: 'history-report' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('create-customer-limit-settings-historyReport', {
            parent: 'history-report',
            url: '/create-limit-settings-historyReport',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-limit/customer-new-limit.html',
                    controller: 'CustomerNewLimitController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        
                     entity: [function() {
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('history-report', {}, { reload: 'history-report' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
    }
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('LimitSettings', LimitSettings);

    LimitSettings.$inject = ['$resource'];

    function LimitSettings($resource) {
        var resourceUrl =  'api/limit-settings';
        
        return $resource(resourceUrl, {}, {
        	
        	 'fetchLimits': {
                 method: 'GET',
                 params: {bank:'@bank', branch:'@branch', limitsExpiringIn: '@limitsExpiringIn', showExpired:'@showExpired'},
                 url: 'api/limit-settings',
                 isArray:true
        	 },
        	 'save':{
        		 method:'POST',
        		 url:'order/limit-settings',
        		 transformRequest: function (data) {
                   	
                   	var copy =angular.toJson(data);
                   	
                       return copy;
                   }
        	 },
           'reset':{
             method:'POST',
             url:'order/reset-limit-settings',
             transformRequest: function (data) {
                    
                    var copy =angular.toJson(data);
                    
                       return copy;
                   }
           },
           'getOutstandingQuantityForPendingOrder': {
             method:'POST',
             url:'order/getOutstandingQuantityForContractPendingOrder',
             transformRequest: function (data) {
                    
                    var copy =angular.toJson(data);
                    
                       return copy;
                   },
            transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
           },
           'checkIsExistingTradeConsumesLimit': {
             method:'POST',
             url:'order/checkIsExistingTradeConsumesLimit',
             transformRequest: function (data) {
                    
                    var copy =angular.toJson(data);
                    
                       return copy;
                   },
            transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
           },
        	 'update':{
        		 method:'PUT',
        		 url:'order/limit-settings',
        		 transformRequest: function (data) {
                   	
                   	var copy =angular.toJson(data);
                   	
                       return copy;
                   }
        	 },
        	 'updateLimitSettingsByCustomer':{
        		 method:'PUT',
        		 url:'order/customer-limit-settings',
        		 transformRequest: function (data) {
                   	
                   	var copy =angular.toJson(data);
                   	
                       return copy;
                   }
        	 },        
        	 'get':{
        		 method: 'GET',
        		 param:{id : '@id'},
        		 url: 'api/limit-settings/:id',
        		 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
        	 },
        	 'approve': {
            	method: 'GET',
            	params: {taskId:'@taskId'},
            	url: 'order/tasks/:taskId/approve'
        	 },
        	 'reject': {
        		 method: 'GET',
        		 params: {taskId:'@taskId'},
        		 url: 'api/tasks/:taskId/reject'
        	 },
        	 'discard': {
        		 method: 'GET',
        		 params: {taskId:'@taskId'},
        		 url: 'api/tasks/:taskId/discard'
        	 },
        	 'resubmit': {
        		 method: 'PUT',
        		 params: {taskId:'@taskId'},
        		 url: 'order/tasks/:taskId/resubmit/limit-settings',
        		 transformRequest: function (data) {
        			 var copy = angular.copy(data);
        			 return angular.toJson(copy);
        		 }
        	 },
        	 'resubmitLimitChangeByCustomer': {
        		 method: 'PUT',
        		 params: {taskId:'@taskId'},
        		 url: 'order/tasks/:taskId/resubmit/customer-limit-settings',
        		 transformRequest: function (data) {
        			 var copy = angular.copy(data);
        			 return angular.toJson(copy);
        		 }
        	 },
        	 'getDefaultEffectiveToDateForForward':{
				method:'GET',
				url:'api/limit-settings/default-effective-to-date-for-forwards',
			   transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
            'getDefaultEffectiveToDate':{
            	  method:'GET',
            	  url:'api/limit-settings/default-effective-to-date',
            	 transformResponse: function (data) {
                      if (data) {
                          data = angular.fromJson(data);
                      }
                      return data;
                  }
              },'approveWihPayload': {
                  method: 'POST',
                  params: {taskId:'@taskId'},
                  url: 'order/tasks/:taskId/limit-settings/approveWithModification'
              },'getLimitForCustomer' :{
            	  method: 'GET',
         		 param:{customerId : '@customerId' , bankId : '@bankId', limitInstrumentGroup: '@limitInstrumentGroup'},
         		 url: 'api/customer-limit-settings',
         		 transformResponse: function (data) {
                      if (data) {
                          data = angular.fromJson(data);
                      }
                      return data;
                  }
              },
              'getLimitUtilsationDetailsForInstrument':{
     	       	isArray:true,
     				method: 'GET',
     				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId', currencyCode: '@currencyCode'},
     				url: 'api/limit-utilisation-details/:bankId/bank/:branchId/branch/:customerId/customer/:instrumentId/instrument/:currencyCode/currencyCode'
     	      },
     		  'getLimitsAvailableForAllInstruments':{
         	       	isArray:true,
         				method: 'GET',
         				params: {bankId : '@bankId', customerId : '@customerId'},
         				url: 'api/limit-utilisation-details-for-all-instrument/:bankId/bank/:customerId/customer'
         	  },
           'getLimitsAvailableForLimitInstrumentGroup':{
                isArray:true,
                method: 'GET',
                params: {bankId : '@bankId', customerId : '@customerId', limitInstrumentGroupId : '@limitInstrumentGroupId'},
                url: 'api/limit-utilisation-details-for-limit-instrument-group/:bankId/bank/:customerId/customer/:limitInstrumentGroupId/limitInstrumentGroup'
            },
     	     'createLimitSettingsByCustomer':{
        		 method:'POST',
        		 url:'order/create-customer-limit-settings',
        		 transformRequest: function (data) {
                   	
                   	var copy =angular.toJson(data);
                   	
                       return copy;
                   }
        	 },
			 'getLimitUtilisationDetailsForAllInstrumentForOrder':{
						isArray:true,
         				method: 'GET',
         				params: {bankId : '@bankId', customerId : '@customerId',currencyPairCode : '@currencyPairCode',baseCurrency : '@baseCurrency'},
         				url: 'api/limit-utilisation-details-for-all-instrument/:bankId/bank/:customerId/customer/:currencyPairCode/currencyPairCode'
         	  },
        	 
              
        	 
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'limitSettings'
        })
        
        .controller('LimitsController', LimitsController);

    LimitsController.$inject = ['$scope', '$rootScope', '$state', 'workflowSharedService', 'GlobalValues', 'EntityPermissions', 'ScreenLog', 'entityConstants' ,'StaticLookUp','LimitSettings','DateUtils','$filter','MessageBox'];

    function LimitsController($scope, $rootScope, $state, workflowSharedService, GlobalValues, EntityPermissions, ScreenLog , entityConstants, StaticLookUp,LimitSettings,DateUtils,$filter,MessageBox) {
    
    	 var vm = this;
         vm.globalValues = GlobalValues;
         vm.screenName = entityConstants.ENTITY_SHORT_NAME.LIMITSETTINGS;
         vm.entityConstants = entityConstants;
         vm.screenLog = ScreenLog;
		 vm.clicked=false;
         vm.loadAll = loadAll;
         vm.loadDefaultLimitPeriod = loadDefaultLimitPeriod;
         vm.loggedinEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
         
  		 $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
  	     $scope.page = 1;
         
         vm.selectedBranch=null;
         vm.selectedBank=null;
         vm.limitsExpiringIn="";
         vm.showExpired=false;
         vm.disableExpiringIn=false;
         vm.disableBranch=false;
         vm.limitRows=[];
         loadDefaultLimitPeriod();
         //defaultSetup(); -- load it after getting the config limitexpiryperiod irrespective of success or failre
         vm.edit = editLimit;
         vm.view = viewLimit;
         vm.reset = resetLimit;
         var loadDefaultLimitPeriod;
         //vm.currentDate = new Date();
         var systemSettings = vm.globalValues.getSystemSettings();
         if(systemSettings!=null && systemSettings!=undefined){
        	 
        	 var now = moment();
        	 vm.momentBusinessDate = moment(systemSettings.businessDate, 'YYYY-MM-DD');        	
        	 vm.momentBusinessDate.set(
        			 { 	'hour':now.get('hour'),
        				'minute':now.get('minute'),
        				'second':now.get('second')
        				
        			 });
        	 vm.currentDate = vm.momentBusinessDate.toDate();
         }
         //loadAll();
         
         function loadDefaultLimitPeriod(){
        	 StaticLookUp.getConfigSettings(getConfigSuccess, getConfgiFailure);
         }
         function getConfigSuccess(result){
        	 var configData = result;
        	 loadDefaultLimitPeriod = configData.defaultLimitPeriodForSpotWindow;
        	 vm.limitsExpiringIn =loadDefaultLimitPeriod;
        	 defaultSetup();
         }
         function getConfgiFailure(error){
        	 //TODO
        	 defaultSetup();
         }
         /*$scope.$watch('vm.limitsExpiringIn', function(value){
        	 if(value==undefined || value ==null || value ==""){
        		 vm.disableExpired=false;
        	 }else{
        		 vm.disableExpired=true;
        	 }
         });*/
         $scope.$watch('vm.showExpired', function(value){
        	 if(value){
        		vm.disableExpiringIn =true;
        		vm.limitsExpiringIn="";
        	 }else{
        		 vm.disableExpiringIn =false;
        		 vm.limitsExpiringIn= loadDefaultLimitPeriod;
        	 }
         })
         
         function defaultSetup(){
        	 if (vm.loggedinEntityOwnerType == "Bank"){
        		 vm.disableBranch=false;
        			 
				 vm.selectedBank = vm.globalValues.getBank();
        	 }else if(vm.loggedinEntityOwnerType == "Branch") {
        		 vm.disableBranch=true;
        		 vm.selectedBranch = vm.globalValues.getBranch();
        		 vm.selectedBank = vm.globalValues.getBank();
        		 loadAll();
        	 }
        	 
         }
       

 		workflowSharedService.viewFrom = "limitSettings";
 		
         vm.launch=launch;
         function launch() {
        	 workflowSharedService.viewFrom = "limitSettings_add";
         	$state.go("manage-limits.new");
         	//$state.go("special-holidays.view");
         }
         
        vm.permitLimitEditEntityAction = EntityPermissions.hasPermission( vm.screenName+'.' +vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
        vm.permitLimitResetEntityAction = EntityPermissions.hasPermission( vm.screenName+'.' +vm.entityConstants.ENTITY_ACTION_TYPE.RESET);
        vm.permitLimitCreateEntityAction = EntityPermissions.hasPermission( vm.screenName+'.' +vm.entityConstants.ENTITY_ACTION_TYPE.CREATE);
 		vm.permitLimitViewEntityAction = EntityPermissions.hasPermission( vm.screenName+'.' +vm.entityConstants.ENTITY_ACTION_TYPE.VIEW);
 		vm.permitLimitImportEntityAction = EntityPermissions.hasPermission( vm.screenName+'.' +vm.entityConstants.ENTITY_ACTION_TYPE.IMPORT);
 		
         function loadAll() {
        	 var selectedBranchId = null;
        	 if(vm.selectedBranch != null && vm.selectedBranch !=undefined){
        		 selectedBranchId = vm.selectedBranch.id
        	 }
        	return LimitSettings.fetchLimits({bank:vm.selectedBank.id , branch:selectedBranchId, limitsExpiringIn:vm.limitsExpiringIn, showExpired:vm.showExpired } , fetchSuccess,fetchFailure);
         }
         function fetchSuccess(result){
			 vm.clicked=false;
        	 var fetchedLimits = result;
             vm.limitRows = [];
             angular.forEach(fetchedLimits, function(row) {
            	 var orderedLimitDetails = [];
            	 orderedLimitDetails = $filter('orderBy')(row.limitSettingsDetailsList, 'instrumentType.id');
            	angular.forEach(orderedLimitDetails, function(details){
            		var newLimit = angular.copy(row);
            		newLimit.instrumentType =  details.instrumentType;
            		if(DateUtils.convertDateTimeFromServer(row.effectiveToDateTime) < vm.currentDate || row.active==false){
            			newLimit.showEdit=false;
                        newLimit.showResetToSpot = false;
                        newLimit.showResetToForward = false;
                        newLimit.showResetToAll = false;
            		}else{
            			newLimit.showEdit=true;
            		}
            		
                    if(DateUtils.convertDateTimeFromServer(row.effectiveToDateTime) < vm.currentDate || row.active==false){
                        //dont enable 
                    }
                    else{	
	                    //show reset to spot/forward/all depend on limit instrument group
	                    if(row.limitInstrumentGroup.shortName=='SPOTWINDOW'){
	                        newLimit.showResetToForward = false;
	                        newLimit.showResetToAll = true;
	                        newLimit.showResetToSpot = false;
	                    }else if(row.limitInstrumentGroup.shortName=='FORWARD'){
	                        newLimit.showResetToForward = false;
	                        newLimit.showResetToAll = true;
	                        newLimit.showResetToSpot = false;
	                    }else if(row.limitInstrumentGroup.shortName=='ALL'){
	                        newLimit.showResetToForward = true;
	                        newLimit.showResetToAll = false;
	                        newLimit.showResetToSpot = true;
	                    }
                    }
            		if(newLimit.instrumentType ==null || newLimit.instrumentType==undefined || newLimit.instrumentType ==""){
            			newLimit.instrumentType={};
            			newLimit.instrumentType.name="ALL";
            		}           		            		
            		if(newLimit.limitType=="GROSSBUY"){
            			newLimit.limitType="Gross Buy";
            		}else if(newLimit.limitType=="GROSSSELL"){
            			newLimit.limitType="Gross Sell";
            		}else if(newLimit.limitType=="GLOBALGROSS"){
            			newLimit.limitType="Global Gross";
            		}else if(newLimit.limitType=="NET"){
            			newLimit.limitType="Net";
            		}
            		if(newLimit.limitReinstateMethod=="SettledTrades"){
            			newLimit.limitReinstateMethod="Settled Trades";
            		}
            		newLimit.value = details.value;
            		if(row.userRemarks == null || row.userRemarks == undefined ){
            			newLimit.userRemarks = "";
            		}else{
            			newLimit.userRemarks = row.userRemarks ; 
            		}
                 	vm.limitRows.push(newLimit);
            	});
             	
             });
         }
         function fetchFailure(error){
			vm.clicked=false;
         }
         
         logScreenAccess();
         function logScreenAccess(){
            	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
         }
         function viewLimit(limit){
        	
        	workflowSharedService.viewFrom = "limitSettings_view";
     	 	ScreenLog.screenLog(vm.screenName,limit.id, vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS);
 			$state.params = {id:limit.id}
 			var state = '.view';
 			$state.go(state,{id:limit.id});
         }
         
         function editLimit(limit){
        	 workflowSharedService.viewFrom = "limitSettings_edit";
        	 	ScreenLog.screenLog(vm.screenName,limit.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
    			$state.params = {id:limit.id}
    			var state = '.edit';
    			$state.go(state,{id:limit.id});
         }

         function resetLimit(limit, resetInstrumentGroup){
            $rootScope.selectedLimit = angular.copy(limit);
            $rootScope.selectedResetInstrumentGroup = angular.copy(resetInstrumentGroup);
            MessageBox.openMessageBox("Alert", 'Already active limits exist. Do you want to proceed?', "YesNo", "resetlimits");
         }

         $rootScope.$on('gatewayApp.messagebox.yes.resetlimits', function (event, data) {
            workflowSharedService.viewFrom = "limitSettings_reset";
                ScreenLog.screenLog(vm.screenName,$rootScope.selectedLimit.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
                $state.params = {id:$rootScope.selectedLimit.id, resetInstrumentGroup: $rootScope.selectedResetInstrumentGroup};
                var state = '.reset';
                $state.go(state,{id:$rootScope.selectedLimit.id, resetInstrumentGroup: $rootScope.selectedResetInstrumentGroup});

         });

         $rootScope.$on('gatewayApp.messagebox.no.resetlimits', function (event, data) {
            //do nothing
         });

         $rootScope.$on('gatewayApp.messagebox.clear.resetlimits', function (event, data) {
            //do nothing
         });

         $scope.instrumentIdComparator = function(v1, v2) {
           // If we don't get strings, just compare by index
           if ( v1 != null && v1!=undefined 
        		   && v2!=null && v2!=undefined ) {
        	   return (v1.id < v2.id) ? 1 : -1;
           }

           return -1;
         };
         
    }
})();
  

(function() {
	'use strict';

	angular.module('gatewayApp')

	.controller('LimitsDialogNewController', LimitsDialogNewController);

	LimitsDialogNewController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','LimitSettings', 
		'DateUtils', 'ScreenLog','entityConstants', 'AlertService', '$filter', 'Workflow','entity','StaticLookUp','MessageBox', '$stateParams', 'Market',
		'DealingAdminApplicationWideSettings', 'DefaultMarket', '$timeout'];

	function LimitsDialogNewController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,LimitSettings,
			DateUtils,ScreenLog,entityConstants,AlertService,$filter, Workflow,entity,StaticLookUp,MessageBox,$stateParams,Market,
			DealingAdminApplicationWideSettings, DefaultMarket, $timeout) {
		var vm=this;
		var ALL_LIMIT_DETAIL_COUNT = 1;
		var INDIVIDUAL_LIMIT_DETAIL_COUNT = 3;
		var UPTOSPOTANDFORWARD_LIMIT_DETAIL_COUNT = 2;
		vm.actionType = "";
		 vm.globalValues = GlobalValues;
         vm.entityConstants = entityConstants;
         vm.screenLog = ScreenLog;
         vm.loggedinEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
         vm.screenName = entityConstants.ENTITY_SHORT_NAME.LIMITSETTINGS;
         $scope.showOkButton = false;
         vm.limitHeader={};
         vm.minValue = 0;
		 vm.showHighLight = false;
		 vm.showHighLightText = false;
		 vm.showLimitInfo = false;
        
         vm.SETTLED_TRADES = 'SETTLEDTRADES';
         vm.DAILY = 'DAILY';
         vm.YES = 'Yes';
         vm.NO = 'No';     
         vm.MAXIMUMTENOR = 'MAXIMUMTENOR';
         vm.MAXIMUMVALUEDATE = 'MAXIMUMVALUEDATE';

		 var systemSettings = vm.globalValues.getSystemSettings();
         if(systemSettings!=null && systemSettings!=undefined){
        	 var now = moment();
        	 vm.momentBusinessDate = moment(systemSettings.businessDate, 'YYYY-MM-DD');        	
        	 vm.momentBusinessDate.set(
        			 { 	'hour':now.get('hour'),
        				'minute':now.get('minute'),
        				'second':now.get('second')
        				
        			 });
        	 vm.currentDate = vm.momentBusinessDate.toDate();
        	
        	 vm.effectiveToMinimumDate = systemSettings.businessDate;
        	// vm.tillDate = new Date(vm.currentDate);
        	// vm.tillDate.setDate(vm.currentDate.getDate() + parseInt(vm.maxLimitPeriod));
         }
         // set maximum limit period 
		 DealingAdminApplicationWideSettings.getConfigValueForConfigName({configName: 'MaximumLimitPeriod'}, function(result){
			vm.maxLimitPeriod = result.value;
			vm.tillDate = new Date(vm.currentDate);
			vm.tillDate.setDate(vm.currentDate.getDate() + parseInt(vm.maxLimitPeriod));
		})
         vm.customerLimit = {};
       
         
         vm.clear = clear;
         vm.resubmitLimitSettings= resubmitLimitSettings;
         vm.approveLimitSettings = approveLimitSettings;
         vm.rejectLimitSettings = rejectLimitSettings;
         vm.discardLimitSettings = discardLimitSettings;
         vm.save=save;
         vm.clicked = false;
         vm.showLimitUtilised = false;
         vm.showLimitUtilisedWithINR = false;
         vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
         vm.ExpandOrCollapseLimitUtilised=false;
		 vm.validateModifiedFields = validateModifiedFields;
		 vm.checkforModificationField = checkforModificationField;
		 vm.checkModifiedOfValues = checkModifiedOfValues;

         loadInstrumentType();
         loadCurrency();
         loadLimitTypes();
		 loadLimitInstrumentGroup();
		 loadLimitReinstateType();
		 loadLimitTenorType();
		 loadMaximumTenorType();
		 loadMaximumValueDate();
		 loadDefaultEffectiveToDatesFromConfig();
		 loadConfigurationSettings();
                  
         function loadInstrumentType(){
        	 StaticLookUp.getInstrumentType(istrumentLookUpSuccess, instrumentLookupFailure);
			//DefaultMarket.csInstruments({currencyPairId:vm.globalValues.getDefaultCurrencyPairId()},istrumentLookUpSuccess, instrumentLookupFailure);
         }
         function istrumentLookUpSuccess(result){
        	 vm.instrumentTypes = result;
        	 angular.forEach( vm.instrumentTypes, function(item){
        		 if(item.shortName =='SPOT'){
        			 vm.spotType = item;
        		 }else if(item.shortName =='CASH'){
        			 vm.cashType = item;
        		 }else if (item.shortName =='TOM'){
        			 vm.tomType = item;
        		 }else if (item.shortName =='UptoSPOT'){
        			 vm.uptoSpotType = item;
        		 }else if (item.shortName =='Forward'){
        			 vm.frwdType = item;
        		 }
        	 });
        	
         }
         function instrumentLookupFailure(error){
        	 
         }        
         function loadCurrency(){
        	 StaticLookUp.getCurrencyLimit(currencySuccess,currencyFailure);
         }
         function currencySuccess(result){
        	 vm.currencies = result;
         }
         function currencyFailure(error){
        	 
         }
         function loadLimitTypes(){
        	 StaticLookUp.getLimitType(limitTypeSuccess, limitTypeFailure);
         }
         function limitTypeSuccess(result){
        	 vm.limitTypes = result;
        	 prepareLimitTypeToView();
         }
         function limitTypeFailure(error){
        	 
         }

		 function loadLimitInstrumentGroup(){
			 StaticLookUp.getLimitInstrumentGroupList(onGetLimitInstrumentGroupSuccess, onGetLimitInstrumentGroupFailure);
		 }

		 function onGetLimitInstrumentGroupSuccess(result){
			 vm.limitInstrumentGroupList = result;
			 if(vm.limitHeader.id==null || vm.limitHeader.id==undefined){
				 if(result!=null && result.length>0 && workflowSharedService.viewFrom=='limitSettings_add'){
					vm.limitInstrumentGroup = result[0];
                    vm.limitHeader.limitInstrumentGroup = result[0];
				 }
			 }
		 }

		 function onGetLimitInstrumentGroupFailure(){

		 }

		function loadLimitReinstateType(){
			StaticLookUp.getLimitReinstateTypeList(onGetLimitReinstateTypeSuccess, onGetLimitReinstateTypeFailure);
		}

		function onGetLimitReinstateTypeSuccess(result){
			vm.limitReinstateTypeList = result;
			if(vm.limitHeader.id==null || vm.limitHeader.id==undefined){
				if(result!=null && result.length>0){
				   if(workflowSharedService.viewFrom=='limitSettings_add'){
						vm.limitReinstateType = result[0];
                        vm.limitHeader.limitReinstateType = result[0];
				   }
				   vm.defaultLimitReinstateType = angular.copy(result[0]);
				}
			}
		}

		function onGetLimitReinstateTypeFailure(){

		}

		function loadLimitTenorType(){
			StaticLookUp.getLimitTenorTypeList(onGetLimitTenorTypeSuccess, onGetLimitTenorTypeFailure);
		}

		function onGetLimitTenorTypeSuccess(result){
			vm.limitTenorTypeList = result;
			if(vm.limitHeader.id==null || vm.limitHeader.id==undefined){
				if(result!=null && result.length>0){
					if(workflowSharedService.viewFrom=='limitSettings_add'){
						vm.limitTenorType = result[0];
                        vm.limitHeader.limitTenorType = result[0];
                        vm.limitHeader.maximumTenorValue = null;
                        vm.limitHeader.maximumTenorType = null;
                        vm.limitHeader.maximumValueDate = null;
					}
 				    vm.defaultLimitTenorType = angular.copy(result[0]);
				}
			}
		}

		function onGetLimitTenorTypeFailure(){

		}

		function loadMaximumTenorType(){
			vm.maximumTenorTypeList = ['Days', 'Months'];
			vm.maximumTenorType = 'Days';
		}

		function loadMaximumValueDate(){
			DefaultMarket.csInstruments({currencyPairId:vm.globalValues.getDefaultCurrencyPairId()},onGetInstrumentSuccess, onGetInstrumentFailure);
		}

		function onGetInstrumentSuccess(result){
        	vm.instrumentTypes = result;
        	angular.forEach(vm.instrumentTypes, function(value){
        		if(value.instrumentCode=='SPOT'){
                    var spotNextDate = new Date(value.settlementDate);
                    spotNextDate.setDate(spotNextDate.getDate()+1);
					if(workflowSharedService.viewFrom=='limitSettings_add'){
						$timeout(function() {
							vm.maximumValueDate = angular.copy(spotNextDate);
						}, 100);
					}
                    vm.spotNextDate = angular.copy(spotNextDate);
        		}
        	})
        }
        
        function onGetInstrumentFailure(){
        	
        }

        $scope.setForm = function (form) {
            $scope.limitForm = form;
        }
		function prepareLimitInfoConent(value) {
			if(value!=null){
				vm.showLimitInfo=true;
				if(value=='GROSSBUY'){
					vm.limitTypeInfo = "Limit available to Buy only";
				}else if(value=='GROSSSELL'){
					vm.limitTypeInfo = "Limit available to Sell only";
				}else if(value=='GLOBALGROSS'){
					vm.limitTypeInfo = "TOTAL  limit available to both  Buy and Sell";
				}else{
					vm.limitTypeInfo = "NET limit available to both Buy and Sell";
				}
			}
			
		}
         
         $scope.$watch('vm.selectedLimitType' , function(value){
        	 if(vm.limitHeader!=null && vm.limitHeader!==undefined){
        		 if(value !=null && value!=undefined){
					vm.limitHeader.limitType = value.shortName;
				 }
        	 }
			 if(value!=null){
				prepareLimitInfoConent(value.shortName);
			 }
         });
		 $scope.$watch('vm.limitHeader.limitCurrency' , function(value){
			if((workflowSharedService.viewFrom == 'customer_limitSettings' || workflowSharedService.viewFrom == 'customer_limitSettings_checker'
			|| workflowSharedService.viewFrom == 'customer_limitSettings_maker'|| workflowSharedService.viewFrom == 'customer_limitSettings_resubmit' 
			|| workflowSharedService.viewFrom == 'customer_limitSettings_auditLog') && vm.limitHeader!=null && vm.limitHeader!==undefined){
				if(value.code=='USD'){
					vm.showLimitUtilisedWithINR = false;
				}else{
					vm.showLimitUtilisedWithINR = true;
				}
			}
		});

         $scope.$watch('vm.limitReinstateType' , function(value){
             if(vm.limitHeader!=null && vm.limitHeader!==undefined){
                 if(value !=null && value!=undefined){
                    vm.limitHeader.limitReinstateType = value;
                 }
             }
         });

		 vm.onChangeLimitTenorType =  function onChangeLimitTenorType(value){
			if(vm.limitHeader!=null && vm.limitHeader!==undefined){
				if(value !=null && value!=undefined){
				   vm.limitHeader.limitTenorType = value;
					if(value.shortName=='NA'){ 
						//if limit tenor type is 'NA', then clear fields related with other limit on tenor types
						vm.maximumTenorType = null;
						vm.maximumValueDate = null;
						vm.limitHeader.maximumTenorValue = null;
                        vm.limitHeader.maximumTenorType = null;
						if($scope.limitForm!=null && $scope.limitForm!=undefined){
							$scope.limitForm.$setValidity("txtMaxTenorValue" + "txtrequired", true);
							$scope.limitForm.$setValidity("dtpMaxValueDate" + "dtprequired", true);
						}
					}else if(value.shortName=='MAXIMUMTENOR'){
						//if limit tenor type is 'MAXIMUMTENOR', then clear maximum value date control
						$scope.limitForm.$setValidity("dtpMaxValueDate" + "dtprequired", true);
						vm.maximumTenorType = 'Days';
						vm.limitHeader.maximumTenorValue = null;
					}else{
						//else if limit tenor type is 'MAXIMUMVALUEDATE', then clear maximum tenor value control
						vm.maximumTenorType = null;
						vm.limitHeader.maximumTenorValue = null;
						if($scope.limitForm!=null && $scope.limitForm!=undefined){
							$scope.limitForm.$setValidity("txtMaxTenorValue" + "txtrequired", true);
						}
						vm.maximumValueDate = angular.copy(vm.spotNextDate);
					}
				}
			}
		 }

         $scope.$watch('vm.maximumTenorType' , function(value){
             if(vm.limitHeader!=null && vm.limitHeader!==undefined){
                 if(value !=null && value!=undefined){
                    vm.limitHeader.maximumTenorType = value;
                 }else{
                    vm.limitHeader.maximumTenorType = null;
                 }
             }
         });

         $scope.$watch('vm.maximumValueDate' , function(value){
             if(vm.limitHeader!=null && vm.limitHeader!==undefined){
                 if(value !=null && value!=undefined){
                    vm.limitHeader.maximumValueDate = value;
                 }else{
                    vm.limitHeader.maximumValueDate = null;
                 }
             }
         });

         $scope.$watchGroup(['vm.selectedInstrument', 'vm.limitInstrumentGroup'], function(value){
             if(vm.limitInstrumentGroup!=null && vm.limitInstrumentGroup.shortName=='SPOTWINDOW'){
                 if( vm.limitHeader!=null && vm.limitHeader!=undefined && vm.selectedInstrument == 'individual'){
                     if( document.getElementById("txtall")!=undefined &&  document.getElementById("txtall")!=null){
                        document.getElementById("txtall").value = "";
                     }
                     if( document.getElementById("txtuptospot")!=undefined &&  document.getElementById("txtuptospot")!=null){
                         document.getElementById("txtuptospot").value = "";
                     }
                     if( document.getElementById("txtforward")!=undefined &&  document.getElementById("txtforward")!=null){
                         document.getElementById("txtforward").value = "";
                     }
                     vm.allValue=null;
                     vm.uptoSpotValue = null;
                     vm.forwardValue = null;
                 }
                 if( vm.limitHeader!=null && vm.limitHeader!=undefined && vm.selectedInstrument == 'uptoSpot'){
                     if( document.getElementById("txtall")!=undefined &&  document.getElementById("txtall")!=null){
                        document.getElementById("txtall").value = "";
                     }
                     if( document.getElementById("txtspot")!=undefined &&  document.getElementById("txtspot")!=null){
                         document.getElementById("txtspot").value = "";
                     }
                     if( document.getElementById("txttom")!=undefined &&  document.getElementById("txttom")!=null){
                         document.getElementById("txttom").value = "";
                     }
                     if( document.getElementById("txtcash")!=undefined &&  document.getElementById("txtcash")!=null){
                         document.getElementById("txtcash").value = "";
                     }
                     if( document.getElementById("txtforward")!=undefined &&  document.getElementById("txtforward")!=null){
                         document.getElementById("txtforward").value = "";
                     }
                     vm.allValue=null;
                     vm.spotValue=null;
                     vm.tomValue=null;
                     vm.cashValue=null;
                     vm.forwardValue = null;
                 }
             }else if(vm.limitInstrumentGroup!=null && vm.limitInstrumentGroup.shortName=='FORWARD'){
                 if( document.getElementById("txtall")!=undefined &&  document.getElementById("txtall")!=null){
                    document.getElementById("txtall").value = "";
                 }
                 if( document.getElementById("txtspot")!=undefined &&  document.getElementById("txtspot")!=null){
                     document.getElementById("txtspot").value = "";
                 }
                 if( document.getElementById("txttom")!=undefined &&  document.getElementById("txttom")!=null){
                     document.getElementById("txttom").value = "";
                 }
                 if( document.getElementById("txtcash")!=undefined &&  document.getElementById("txtcash")!=null){
                     document.getElementById("txtcash").value = "";
                 }
                 if( document.getElementById("txtuptospot")!=undefined &&  document.getElementById("txtuptospot")!=null){
                     document.getElementById("txtuptospot").value = "";
                 }
                 vm.allValue=null;
                 vm.spotValue=null;
                 vm.tomValue=null;
                 vm.cashValue=null;
                 vm.uptoSpotValue=null;
             }else{
                 if( document.getElementById("txtspot")!=undefined &&  document.getElementById("txtspot")!=null){
                     document.getElementById("txtspot").value = "";
                 }
                 if( document.getElementById("txttom")!=undefined &&  document.getElementById("txttom")!=null){
                     document.getElementById("txttom").value = "";
                 }
                 if( document.getElementById("txtcash")!=undefined &&  document.getElementById("txtcash")!=null){
                     document.getElementById("txtcash").value = "";
                 }
                 if( document.getElementById("txtuptospot")!=undefined &&  document.getElementById("txtuptospot")!=null){
                     document.getElementById("txtuptospot").value = "";
                 }
                 if( document.getElementById("txtforward")!=undefined &&  document.getElementById("txtforward")!=null){
                     document.getElementById("txtforward").value = "";
                 }
                 vm.spotValue=null;
                 vm.tomValue=null;
                 vm.cashValue=null;
                 vm.uptoSpotValue=null;
                 vm.forwardValue=null;
             }
			 if(vm.limitInstrumentGroup!=null && workflowSharedService.viewFrom=='limitSettings_add'){
			 	prepareLimitDetailsToSaveToDB(vm.selectedInstrument, vm.limitInstrumentGroup.shortName);
			 }
         });
         
         $scope.$watch('vm.allValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.allValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         
         $scope.$watch('vm.spotValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.spotValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         
         $scope.$watch('vm.tomValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.tomValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         
         $scope.$watch('vm.cashValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.cashValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         
         $scope.$watch('vm.forwardValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.forwardValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         
         $scope.$watch('vm.uptoSpotValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.uptoSpotValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         
         function prepareLimitTypeToView(){
        	
        	 if(vm.limitHeader!=null && vm.limitHeader!=undefined){
        		 angular.forEach(vm.limitTypes, function(item){
            		 if(item.shortName == vm.limitHeader.limitType ){
            			 vm.selectedLimitType = item;
            		 }
            	 })

				 //set limit instrument group
				 if(vm.limitHeader.limitInstrumentGroup!=null && vm.limitHeader.limitInstrumentGroup!=undefined){
					vm.limitInstrumentGroup = vm.limitHeader.limitInstrumentGroup;
                    var defaultReinstateId = "slt_inst_" + vm.limitHeader.limitInstrumentGroup.shortName;
                    if(document.getElementById(defaultReinstateId)!=null){
                        setTimeout(function(){document.getElementById(defaultReinstateId).click()});
                    }
                 }

				 //set limit reinstate type
				 if(vm.limitHeader.limitReinstateType!=null && vm.limitHeader.limitReinstateType!=undefined){
					vm.limitReinstateType = vm.limitHeader.limitReinstateType;
                    var defaultReinstateId = "slt_" + vm.limitHeader.limitReinstateType.shortName;
                    if(document.getElementById(defaultReinstateId)!=null){
                        setTimeout(function(){document.getElementById(defaultReinstateId).click()});
                    }
                 }

				 //set limit tenor type
                 if(vm.limitHeader.limitTenorType!=null && vm.limitHeader.limitTenorType!=undefined){
					vm.limitTenorType = vm.limitHeader.limitTenorType;
                    var defaultTenorTypeId = "slt_tenor_" + vm.limitHeader.limitTenorType.shortName;
                    if(document.getElementById(defaultTenorTypeId)!=null){
                        setTimeout(function(){document.getElementById(defaultTenorTypeId).click()});
                    }
                    if(vm.limitHeader.limitTenorType.shortName!='MAXIMUMTENOR'){
                        vm.maximumTenorType = null;
                    }else{
                        vm.maximumTenorType = vm.limitHeader.maximumTenorType;
                    }
                 }

        	 }
        	
         }
         function checkInstrumentValue(instrumentValue){
        	 
        	 if(instrumentValue == "" || instrumentValue == undefined || instrumentValue == null){
        		 return 0.00;
        	 }else{
        		 return instrumentValue;
        	 }
         }
         function prepareLimitDetailsToSaveToDB(selectedInstrument, limitInstrumentGroup){
             if(limitInstrumentGroup=='SPOTWINDOW'){
                 if( vm.limitHeader!=null && vm.limitHeader!=undefined && selectedInstrument == 'individual'){
                     vm.limitHeader.limitSettingsDetailsList=[];
                     vm.limitHeader.limitSettingsDetailsList[0]={};
                     vm.limitHeader.limitSettingsDetailsList[0].instrumentType=vm.cashType;
                     vm.limitHeader.limitSettingsDetailsList[0].value=checkInstrumentValue(vm.cashValue);
                     
                     vm.limitHeader.limitSettingsDetailsList[1]={};
                     vm.limitHeader.limitSettingsDetailsList[1].instrumentType=vm.tomType;
                     vm.limitHeader.limitSettingsDetailsList[1].value=checkInstrumentValue(vm.tomValue);
                     
                     vm.limitHeader.limitSettingsDetailsList[2]={};
                     vm.limitHeader.limitSettingsDetailsList[2].instrumentType=vm.spotType;
                     vm.limitHeader.limitSettingsDetailsList[2].value=checkInstrumentValue(vm.spotValue);
                 }else if( vm.limitHeader!=null && vm.limitHeader!=undefined && selectedInstrument == 'uptoSpot'){
                     vm.limitHeader.limitSettingsDetailsList=[];
                     vm.limitHeader.limitSettingsDetailsList[0]={};
                     vm.limitHeader.limitSettingsDetailsList[0].instrumentType=vm.uptoSpotType;
                     vm.limitHeader.limitSettingsDetailsList[0].value=checkInstrumentValue(vm.uptoSpotValue);
                 }
             }else if(limitInstrumentGroup=='FORWARD'){
                if(vm.limitHeader!=null && vm.limitHeader!=undefined){
                    vm.limitHeader.limitSettingsDetailsList=[];
                    vm.limitHeader.limitSettingsDetailsList[0]={};
                    vm.limitHeader.limitSettingsDetailsList[0].instrumentType=vm.frwdType;
                    vm.limitHeader.limitSettingsDetailsList[0].value=checkInstrumentValue( vm.forwardValue);
                }
             }else{
                if(vm.limitHeader!=null && vm.limitHeader!=undefined){
                    vm.limitHeader.limitSettingsDetailsList=[];
                    vm.limitHeader.limitSettingsDetailsList[0]={};
                    vm.limitHeader.limitSettingsDetailsList[0].instrumentType=null;
                    vm.limitHeader.limitSettingsDetailsList[0].value=checkInstrumentValue(vm.allValue);
                }
             }
         }
         function prepateLimitDetailsToView(){
        	 if( vm.limitHeader!=null && vm.limitHeader !=undefined && vm.limitHeader.limitSettingsDetailsList!=null 
                && vm.limitHeader.limitSettingsDetailsList!=undefined && vm.limitHeader.limitInstrumentGroup.shortName=='ALL'){
        		 vm.allValue = vm.limitHeader.limitSettingsDetailsList[0].value;
        		 if(vm.prevClose!=null && vm.prevClose!=undefined && vm.allValue !=null && vm.allValue !=undefined){
        			 vm.allValueInINR = (Math.round(parseFloat(vm.allValue)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
        	 else if(vm.limitHeader!=null && vm.limitHeader !=undefined && vm.limitHeader.limitSettingsDetailsList!=null
                && vm.limitHeader.limitSettingsDetailsList!=undefined && vm.limitHeader.limitInstrumentGroup.shortName=='SPOTWINDOW'){
                 if(vm.limitHeader.limitSettingsDetailsList.length == INDIVIDUAL_LIMIT_DETAIL_COUNT){
                     vm.selectedInstrument = "individual";
                     angular.forEach( vm.limitHeader.limitSettingsDetailsList, function(item){
                     if(item.instrumentType!=null && item.instrumentType!=undefined){
                         if(item.instrumentType.shortName =='CASH'){
                            vm.cashValue = item.value;
                             if(vm.prevClose!=null && vm.prevClose!=undefined && item.value!=null && item.value!=undefined){
                                 vm.cashValueInINR = (Math.round(parseFloat(vm.cashValue)*10000) / vm.prevClose) / 10000;
                             }
                        }else if(item.instrumentType.shortName =='TOM'){
                            vm.tomValue = item.value;
                            if(vm.prevClose!=null && vm.prevClose!=undefined && item.value!=null && item.value!=undefined){
                             vm.tomValueInINR = (Math.round(parseFloat(vm.tomValue)*10000) / vm.prevClose) / 10000;
                            }
                        }else if(item.instrumentType.shortName =='SPOT'){
                            vm.spotValue = item.value;
                            if(vm.prevClose!=null && vm.prevClose!=undefined && item.value!=null && item.value!=undefined){
                             vm.spotValueInINR = (Math.round(parseFloat(vm.spotValue)*10000) / vm.prevClose) / 10000;
                            }
                        }
                     }
                    });
                 }else{
                    vm.selectedInstrument = "uptoSpot";
                    angular.forEach( vm.limitHeader.limitSettingsDetailsList, function(item){
                         if(item.instrumentType!=null && item.instrumentType!=undefined){                       
                            if(item.instrumentType.shortName =='UptoSPOT'){
                                vm.uptoSpotValue = item.value;
                                if(vm.prevClose!=null && vm.prevClose!=undefined){
                                 vm.uptoSpotValueInINR = (Math.round(parseFloat(vm.uptoSpotValue)*10000) / vm.prevClose) / 10000;
                                }
                            }
                         }
                                         
                    });
                 }
        	 }else if(vm.limitHeader!=null && vm.limitHeader !=undefined && vm.limitHeader.limitSettingsDetailsList!=null 
                && vm.limitHeader.limitSettingsDetailsList!=undefined && vm.limitHeader.limitInstrumentGroup.shortName=='FORWARD'){
        		 angular.forEach( vm.limitHeader.limitSettingsDetailsList, function(item){
        			 if(item.instrumentType!=null && item.instrumentType!=undefined){        			 	
        			 	if(item.instrumentType.shortName =='Forward'){
        			 		vm.forwardValue = item.value;
        			 		if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 			vm.forwardValueInINR = (Math.round(parseFloat(vm.forwardValue)*10000) / vm.prevClose) / 10000;
        			 		}
        			 	}
        			 	
        			 }
        			 	  			 
        		 });
        	 }
         }
         function loadDefaultEffectiveToDatesFromConfig(){
        	 
			 //get default effective to date for spot window
			LimitSettings.getDefaultEffectiveToDate(function(result){
				vm.effecitveToDateForSpotWindow = DateUtils.convertDateTimeFromServer(result.effectiveToDate);
				if(workflowSharedService.viewFrom=='limitSettings_add' || 
                    (workflowSharedService.viewFrom=='create_customer_limitSettings_checker' 
                        && vm.customerLimit.limitSettingsHeader!=null && vm.customerLimit.limitSettingsHeader.limitInstrumentGroup.shortName=='SPOTWINDOW' 
                        	&& ( vm.customerLimit.limitSettingsHeader.effectiveToDateTime ==null || vm.customerLimit.limitSettingsHeader.effectiveToDateTime ==undefined ) )){
					vm.effectiveToDate = angular.copy(vm.effecitveToDateForSpotWindow);
				}
			})
	
			//get default effective to date for forward or all window
			LimitSettings.getDefaultEffectiveToDateForForward(function(result){
				vm.effecitveToDateForForwards = DateUtils.convertDateTimeFromServer(result.effectiveToDate);
                if(workflowSharedService.viewFrom=='create_customer_limitSettings_checker' 
                        && vm.customerLimit.limitSettingsHeader!=null && vm.customerLimit.limitSettingsHeader.limitInstrumentGroup.shortName!='SPOTWINDOW'
                        	&& ( vm.customerLimit.limitSettingsHeader.effectiveToDateTime ==null || vm.customerLimit.limitSettingsHeader.effectiveToDateTime ==undefined )){
                    vm.effectiveToDate = vm.effecitveToDateForForwards;
                }
			})
         }
		 
		 function loadDefaultEffectiveToDate(){
			 vm.effectiveToDate = angular.copy(vm.effecitveToDateForSpotWindow);
		 }

		 function loadConfigurationSettings(){
			 //load configuration settings to validate maximum tenor value 
			 //get confing settings - no. of active days for standard tenor
			DealingAdminApplicationWideSettings.getConfigValueForConfigName({configName: 'NoOfActiveDaysForStandardTenor'}, function(result){
				vm.noOfActiveDaysForStandardTenor = result.value;
			})

			//get confing settings - no. of active months for standard tenor
			DealingAdminApplicationWideSettings.getConfigValueForConfigName({configName: 'NoOfActiveMonthsForStandardTenor'}, function(result){
				vm.noOfActiveMonthsForStandardTenor = result.value;
			})
			
		 }

         //get max tenor date for validation
         StaticLookUp.getTenorsWithBrokenDate(onGetTenorSuccess, onGetTenorFailure);

         function onGetTenorSuccess(result){
            vm.tenors = result;
            if(vm.tenors!=null && vm.tenors!=undefined && vm.tenors.length>0){
                vm.maxTenorDate = new Date(vm.tenors[vm.tenors.length-1].settlementDate);
            }
         }

         function onGetTenorFailure(){

         }

		 function prepareDatesForView(){
        	 if(vm.limitHeader!=null && vm.limitHeader!=undefined){
        		vm.effectiveFromDate = DateUtils.convertDateTimeFromServer(vm.limitHeader.effectiveFromDateTime);
        	 	vm.effectiveToDate = DateUtils.convertDateTimeFromServer(vm.limitHeader.effectiveToDateTime);
                vm.maximumValueDate = DateUtils.convertLocalDateFromServer(vm.limitHeader.maximumValueDate);
        	 }
         }	
         function prepareDatesforServer(){
        	 vm.limitHeader.effectiveFromDateTime = vm.effectiveFromDate;        	
			 vm.limitHeader.effectiveToDateTime = new Date(vm.effectiveToDate);
        	 vm.limitHeader.effectiveToDateTime.setHours(23);
			 vm.limitHeader.effectiveToDateTime.setMinutes(59);
			 vm.limitHeader.effectiveToDateTime.setSeconds(59);
			 if(vm.limitHeader.limitTenorType!=null && vm.limitHeader.limitTenorType.shortName=='MAXIMUMVALUEDATE'){
				vm.limitHeader.maximumValueDate = DateUtils.convertLocalDateToServer(vm.limitHeader.maximumValueDate);
			 }else{
				vm.limitHeader.maximumValueDate = null;
			 }
         }

		 if (workflowSharedService.viewFrom == 'limitSettings_add') {

			vm.limitHeader = {};
			vm.selectedInstrument = 'individual';
			vm.effectiveFromDate = vm.currentDate;
			loadDefaultEffectiveToDate();
			
	        $scope.showButton = true;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;		
			$scope.showResubmitButton = false;
			vm.disableForm = false;
			vm.actionType="Add";
			var disableBranch=false;
			if (vm.loggedinEntityOwnerType == "Bank"){
	        	 disableBranch=false;
	        	 vm.limitHeader.bank = vm.globalValues.getBank();
	    			 
	    	 }else if(vm.loggedinEntityOwnerType == "Branch") {
	    		 disableBranch=true;
	    		
	    		 vm.limitHeader.branch = vm.globalValues.getBranch();
	    		 vm.limitHeader.bank = vm.limitHeader.branch.bank;
	    	 }
			enableControls(disableBranch,false,false,false,false);
			vm.disableReinstateField = false;
            vm.disableInstrumentGroupField = false;
            vm.disableUserRemarks = false;
            vm.showCustomerRemarks = false;
			
		} else if (workflowSharedService.viewFrom == 'limitSettings_edit') {
			
			vm.limitHeader = entity;
			
			prepateLimitDetailsToView();
			prepareDatesForView();
			vm.effectiveFromDate = vm.currentDate;
			prepareLimitTypeToView();
            LimitSettings.getLimitsAvailableForLimitInstrumentGroup({customerId : vm.limitHeader.customer.id , bankId : vm.limitHeader.bank.id, limitInstrumentGroupId : vm.limitHeader.limitInstrumentGroup.id }, function(result){
                vm.limitUtilisationDetails = result;
            })
            vm.showLimitUtilised = true;
            // if(vm.limitHeader.limitCurrency.code=='INR'){
            //      vm.showLimitUtilisedWithINR = true;
            // }
			vm.previousLimit = angular.copy(vm.limitHeader);
			$scope.showButton = true;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton = false;
			vm.disableForm = false;
			vm.actionType="Change";
			enableControls(true,true,false,false,false,false);
			vm.disableReinstateField = false;
            vm.disableInstrumentGroupField = true;
            vm.disableUserRemarks = false;
            vm.showCustomerRemarks = false;
		
        } else if (workflowSharedService.viewFrom == 'limitSettings_reset') {
            
            var limitHeader = angular.copy(entity);

            vm.limitHeader = {};
            vm.limitHeader.bank = limitHeader.bank;
            $timeout(function() {
                vm.limitHeader.branch = limitHeader.branch;
            }, 100);
            $timeout(function() {
                vm.limitHeader.customer = limitHeader.customer;
            }, 100);

            if($stateParams.resetInstrumentGroup=='SPOTWINDOW'){
                vm.selectedInstrument = 'individual';
            }
            vm.effectiveFromDate = vm.currentDate;
            loadDefaultEffectiveToDate();

            StaticLookUp.getLimitInstrumentGroupList(function(result){
                angular.forEach(result, function(value){
                    if(value.shortName==$stateParams.resetInstrumentGroup){
                        vm.limitHeader.limitInstrumentGroup = value;
                    }
                })
                //set limit instrument group
                $timeout(function() {
                    if(vm.limitHeader.limitInstrumentGroup!=null && vm.limitHeader.limitInstrumentGroup!=undefined){
                        vm.limitInstrumentGroup = vm.limitHeader.limitInstrumentGroup;
                        var defaultReinstateId = "slt_inst_" + vm.limitHeader.limitInstrumentGroup.shortName;
                        if(document.getElementById(defaultReinstateId)!=null){
                            setTimeout(function(){document.getElementById(defaultReinstateId).click()});
                        }
                    }
                }, 100);
            });

            
            $scope.showButton = true;
            $scope.showApproveRejectButton = false;
            $scope.showDiscardButton = false;       
            $scope.showResubmitButton = false;
            vm.disableForm = false;
            vm.actionType="Reset";
            var disableBranch=false;
            if (vm.loggedinEntityOwnerType == "Bank"){
                 disableBranch=true;
                 vm.limitHeader.bank = vm.globalValues.getBank();
                     
             }else if(vm.loggedinEntityOwnerType == "Branch") {
                 disableBranch=true;
                
                 vm.limitHeader.branch = vm.globalValues.getBranch();
                 vm.limitHeader.bank = vm.limitHeader.branch.bank;
             }
            enableControls(disableBranch,true,false,false,false);
            vm.disableReinstateField = false;
            vm.disableInstrumentGroupField = true;
            vm.disableUserRemarks = false;
            vm.showCustomerRemarks = false;
        
		} else if (workflowSharedService.viewFrom == 'limitSettings_view') {
			
			vm.limitHeader = entity;
			prepateLimitDetailsToView();
			prepareDatesForView();
			prepareLimitTypeToView();
			vm.previousLimit = angular.copy(vm.limitHeader);
			$scope.showOkButton = true;
			$scope.showButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton = false;
			vm.disableForm = true;
			vm.actionType="View";
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
            vm.disableInstrumentGroupField = true;
            vm.disableUserRemarks = true;
            vm.showCustomerRemarks = false;
		
		}
		else if (workflowSharedService.viewFrom == 'limitSettings_checker') {
			var copyOfPayload = angular.copy($rootScope.payload);
			vm.limitHeader = angular.fromJson(copyOfPayload);			
			prepateLimitDetailsToView();
			prepareDatesForView();
			prepareLimitTypeToView();
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = true;
			$scope.showDiscardButton = false;
			vm.disableForm = true;
			vm.actionType=getActionType($rootScope.action);
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
            vm.disableInstrumentGroupField = true;
            vm.disableUserRemarks = true;
            vm.showCustomerRemarks = false;
		} else if (workflowSharedService.viewFrom == 'limitSettings_maker') {
			var copyOfPayload = angular.copy($rootScope.payload);
			vm.limitHeader = angular.fromJson(copyOfPayload);
			prepateLimitDetailsToView();
			prepareDatesForView();
			prepareLimitTypeToView();
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = true;
			vm.disableForm = true;
			vm.actionType=getActionType($rootScope.action);
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
            vm.disableInstrumentGroupField = true;
            vm.disableUserRemarks = true;
            vm.showCustomerRemarks = false;
		} else if (workflowSharedService.viewFrom == 'limitSettings_resubmit') {
			var copyOfPayload = angular.copy($rootScope.payload);
			vm.limitHeader = angular.fromJson(copyOfPayload);
            //clear user remarks for resubmit
            vm.limitHeader.userRemarks = "";
			prepateLimitDetailsToView();
			prepareDatesForView();
			prepareLimitTypeToView();
			vm.screenLog.screenLog(vm.screenName, vm.limitHeader.id == null ? 0
					: vm.limitHeader.id,
					entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
			vm.disableForm = false;
			$scope.showButton = false;
			$scope.showResubmitButton = true;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			vm.actionType=getActionType($rootScope.action);
			enableControls(true,true,false,false,false,false);
			vm.disableReinstateField = false;
            vm.disableInstrumentGroupField = false;
            if(vm.actionType=='Reset'){
                vm.disableInstrumentGroupField = true;
            }
            vm.disableUserRemarks = false;
            vm.showCustomerRemarks = false;
		} else if (workflowSharedService.viewFrom == 'limitSettings_auditLog') {
			var copyOfPayload = angular.copy($rootScope.payload);
			vm.limitHeader = angular.fromJson(copyOfPayload);
			prepateLimitDetailsToView();
			prepareDatesForView();
			prepareLimitTypeToView();
			vm.disableForm = true;
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showOkButton = true;
			vm.actionType= getActionType($rootScope.actionName);
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
            vm.disableInstrumentGroupField = true;
            vm.disableUserRemarks = true;
            vm.showCustomerRemarks = false;
		}else if(workflowSharedService.viewFrom=='limit_import_auditlog'){
			var copyOfPayload = angular.copy($rootScope.payload); 
			var limitHeaderDTO = angular.fromJson(copyOfPayload);
			vm.limitHeader = limitHeaderDTO;
			prepateLimitDetailsToView();
			prepareDatesForView();
			prepareLimitTypeToView();
			vm.disableForm = true;
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showOkButton = true;
			vm.actionType= getActionType($rootScope.actionName);
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
            vm.disableInstrumentGroupField = true;
            vm.disableUserRemarks = true;
            vm.showCustomerRemarks = false;
        }
		else if (workflowSharedService.viewFrom == 'customer_limitSettings') {
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			vm.customerLimit  = entity;
			vm.showLimitUtilised = true;
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;		
            //clear existing customer remarks
            vm.limitHeader.customerRemarks = "";	
			//clear user remarks 
			vm.limitHeader.userRemarks = "";	
			LimitSettings.getLimitsAvailableForLimitInstrumentGroup({customerId : $stateParams.customerId , bankId :$stateParams.bankId, limitInstrumentGroupId: vm.limitHeader.limitInstrumentGroup.id }, function(result){
				vm.limitUtilisationDetails = result;
			})
			if(vm.limitHeader.limitCurrency.code=='INR'){
				vm.showLimitUtilisedWithINR = true;
			}
	         Market.getLTPForLimitsForInstrument({"instrument": 'InterbankSPOT'}, function(result){
	        	 if(result!=null && result.ltp!=null){
	            	 vm.prevClose = (Math.round(parseFloat(result.ltp)*10000)) / 10000;
	            	 prepateLimitDetailsToView();
	        	 }else{
	        		 prepateLimitDetailsToView();
	        	 }
	         })
			prepareDatesForView();
			vm.effectiveFromDate = vm.currentDate;
			prepareLimitTypeToView();
			ScreenLog.screenLog(vm.screenName,vm.limitHeader.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
			vm.limitHeader.effectiveFromDateTime = vm.currentDate;
			vm.previousLimit = angular.copy(vm.limitHeader);
			$scope.showButton = true;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton = false;
			vm.disableForm = false;
			vm.actionType="CustomerChange";
			enableControls(true,true,false,false,true,false);
			vm.disableReinstateField = true;
            vm.disableInstrumentGroupField = true;
            vm.disableUserRemarks = true;
            vm.showCustomerRemarks = true;
		} 
		else if (workflowSharedService.viewFrom == 'customer_limitSettings_checker') {
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;
			vm.previousLimit = angular.copy(vm.limitHeader);
			vm.showHighLight =true;
			vm.showHighLightText = true;	
			LimitSettings.getLimitsAvailableForAllInstruments({customerId : vm.limitHeader.customer.id , bankId :vm.limitHeader.bank.id }, function(result){
				vm.limitUtilisationDetails = result;
			})
			vm.showLimitUtilised = true;
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;
			if(vm.limitHeader.limitCurrency.code=='INR'){
				vm.showLimitUtilisedWithINR = true;
			}
	         Market.getLTPForLimitsForInstrument({"instrument": 'InterbankSPOT'}, function(result){
	        	 if(result!=null && result.ltp!=null){
	            	 vm.prevClose = (Math.round(parseFloat(result.ltp)*10000)) / 10000;
	            	 prepateLimitDetailsToView();
	        	 }else{
	        		 prepateLimitDetailsToView();
	        	 }
	         })
			prepareDatesForView();
			prepareLimitTypeToView();
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = true;
			$scope.showDiscardButton = false;
			//vm.disableForm = false;
			vm.disableForm = true;
			vm.actionType="CustomerChange";
			//enableControls(true,true,true,false,true,false);
			enableControls(true,true,false,false,false,false);
			vm.disableReinstateField = false;
            vm.disableInstrumentGroupField = true;
            vm.disableUserRemarks = false;
            vm.showCustomerRemarks = true;
		} else if (workflowSharedService.viewFrom == 'customer_limitSettings_maker') {
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;
			LimitSettings.getLimitsAvailableForAllInstruments({customerId : vm.limitHeader.customer.id , bankId :vm.limitHeader.bank.id }, function(result){
				vm.limitUtilisationDetails = result;
			})
			vm.showLimitUtilised = true;
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;			
			if(vm.limitHeader.limitCurrency.code=='INR'){
				vm.showLimitUtilisedWithINR = true;
			}
	         Market.getLTPForLimitsForInstrument({"instrument": 'InterbankSPOT'}, function(result){
	        	 if(result!=null && result.ltp!=null){
	            	 vm.prevClose = (Math.round(parseFloat(result.ltp)*10000)) / 10000;
	            	 prepateLimitDetailsToView();
	        	 }else{
	        		 prepateLimitDetailsToView();
	        	 }
	         })
			prepareDatesForView();
			prepareLimitTypeToView();
			
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = true;
			vm.disableForm = true;
			vm.actionType="CustomerChange";
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
            vm.disableInstrumentGroupField = true;
            vm.disableUserRemarks = true;
            vm.showCustomerRemarks = true;
			
		} else if (workflowSharedService.viewFrom == 'customer_limitSettings_resubmit') {
			
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;
			vm.previousLimit = angular.copy(vm.limitHeader);
			LimitSettings.getLimitsAvailableForAllInstruments({customerId : vm.limitHeader.customer.id , bankId :vm.limitHeader.bank.id }, function(result){
				vm.limitUtilisationDetails = result;
			})
			vm.showLimitUtilised = true;
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;			
			if(vm.limitHeader.limitCurrency.code=='INR'){
				vm.showLimitUtilisedWithINR = true;
			}
	         Market.getLTPForLimitsForInstrument({"instrument": 'InterbankSPOT'}, function(result){
	        	 if(result!=null && result.ltp!=null){
	            	 vm.prevClose = (Math.round(parseFloat(result.ltp)*10000)) / 10000;
	            	 prepateLimitDetailsToView();
	        	 }else{
	        		 prepateLimitDetailsToView();
	        	 }
	         })
			//clear user remarks 
			vm.limitHeader.userRemarks = "";
			prepareDatesForView();
			prepareLimitTypeToView();
			vm.screenLog.screenLog(vm.screenName, vm.limitHeader.id == null ? 0
					: vm.limitHeader.id,
					entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
			vm.disableForm = false;
			$scope.showButton = false;
			$scope.showResubmitButton = true;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			vm.actionType="CustomerChange";
			enableControls(true,true,false,false,true,false);
			vm.disableReinstateField = true;
            vm.disableInstrumentGroupField = true;
            vm.disableUserRemarks = true;
            vm.showCustomerRemarks = true;
		} else if (workflowSharedService.viewFrom == 'customer_limitSettings_auditLog') {
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;
			prepateLimitDetailsToView();
			prepareDatesForView();
			prepareLimitTypeToView();
			vm.disableForm = true;
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showOkButton = true;

			if(vm.limitHeader.id!=null && vm.limitHeader.id!=undefined && !vm.limitHeader.id==""){
				vm.actionType="CustomerChange";
			}else{
				vm.actionType="CustomerCreate";
			}
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
            vm.disableInstrumentGroupField = true;
            vm.disableUserRemarks = true;
            vm.showCustomerRemarks = true;
		}
		
		else if (workflowSharedService.viewFrom == 'create_customer_limitSettings_checker') {
			
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
						
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;			
			prepateLimitDetailsToView();
			prepareDatesForView();
			if(vm.limitHeader.effectiveFromDateTime == null || vm.limitHeader.effectiveFromDateTime == undefined
					|| vm.limitHeader.effectiveFromDateTime == ""){
				
				vm.effectiveFromDate = vm.currentDate;
				
			}
			if(vm.limitHeader.effectiveToDateTime == null || vm.limitHeader.effectiveToDateTime == undefined
					|| vm.limitHeader.effectiveToDateTime == ""){
				
				loadDefaultEffectiveToDate();
			}
			prepareLimitTypeToView();
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = true;
			$scope.showDiscardButton = false;
			vm.disableForm = false;
			vm.actionType="CustomerCreate";
			enableControls(true,true,false,false,false,false);
			vm.disableReinstateField = false;
            vm.disableInstrumentGroupField = false;
            vm.disableUserRemarks = false;
            vm.showCustomerRemarks = true;
			
		} 
		else if (workflowSharedService.viewFrom == 'create_customer_limitSettings_checker_view') {
			
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
						
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;			
			prepateLimitDetailsToView();
			prepareDatesForView();
			if(vm.limitHeader.effectiveFromDateTime == null || vm.limitHeader.effectiveFromDateTime == undefined
					|| vm.limitHeader.effectiveFromDateTime == ""){
				
				vm.effectiveFromDate = vm.currentDate;
				
			}
			if(vm.limitHeader.effectiveToDateTime == null || vm.limitHeader.effectiveToDateTime == undefined
					|| vm.limitHeader.effectiveToDateTime == ""){
				
				loadDefaultEffectiveToDate();
			}
			prepareLimitTypeToView();
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = true;
			vm.disableForm = true;
			vm.actionType="CustomerCreate";
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
            vm.disableInstrumentGroupField = true;
            vm.disableUserRemarks = true;
            vm.showCustomerRemarks = true;
			
		} 
		
		function enableControls(disableBranch , disableCusomer, disableOtherControls,disableEffectiveToControl, disableRadio, disableValues){
			
			vm.disableBranch = disableBranch;
			vm.disableCustomer = disableCusomer;
			vm.disableLimitType= disableOtherControls;
			vm.disableCurrency= disableOtherControls;
			vm.disableEffectiveToDate= disableEffectiveToControl;
			vm.disableRadio = disableRadio;
			vm.disableValues = disableValues;
		}
		  
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        function getActionType(action){
        	if(action!=null && action!=undefined){
	        	action = action.toLowerCase();
	        	if(action.indexOf("add") !== -1 || action.indexOf("create") !== -1){
	        		return "Add";
	        	}
	        	else if(action.indexOf("edit") !== -1 || action.indexOf("modify") !== -1 || action.indexOf("modified") !== -1 || action.indexOf("change") !== -1){
	        		return "Change";
	        	}
                else if(action.indexOf("reset") !== -1){
                    return "Reset";
                }
        	}
        }
        function isCustomerLimitRequest(){
        	if(vm.actionType == 'CustomerChange' || CustomerCreate){
        		return true;
        	}
        	return false;
        }
        
        function save() {        	    		
        	 prepareLimitDetailsToSaveToDB(vm.selectedInstrument, vm.limitInstrumentGroup.shortName);
        	 prepareDatesforServer();
        	 var comparision = moment(vm.currentDate).isAfter(vm.limitHeader.effectiveToDateTime, 'day');
       		if(comparision){
       			AlertService.error($filter('translate')('gatewayApp.limitSettings.invalidaDate'));
       			vm.clicked=false;
       		}else if(moment(vm.limitHeader.effectiveToDateTime).isAfter(vm.tillDate, 'day')){
    			AlertService.error($filter('translate')('gatewayApp.limitSettings.cannotMoreThanDate') + $filter('date')(vm.tillDate, "dd-MMM-yyyy") + '...!');
    			vm.clicked=false;
       		}else if(!isCustomerLimitRequest && (vm.limitHeader.limitTenorType!=null && vm.limitHeader.limitTenorType.shortName=='MAXIMUMVALUEDATE' 
               && moment(vm.limitHeader.maximumValueDate).isBefore(vm.spotNextDate, 'day') )){
                AlertService.error($filter('translate')('gatewayApp.limitSettings.maximumValueDateCannotLessThanDate') + $filter('date')(vm.spotNextDate, "dd-MMM-yyyy") + '...!');
                vm.clicked=false;
            }else if(!isCustomerLimitRequest && (vm.limitHeader.limitTenorType!=null && vm.limitHeader.limitTenorType.shortName=='MAXIMUMVALUEDATE' 
			   && moment(vm.limitHeader.maximumValueDate).isAfter(vm.maxTenorDate, 'day'))){
    			AlertService.error($filter('translate')('gatewayApp.limitSettings.maximumValueDateCannotMoreThanDate') + $filter('date')(vm.maxTenorDate, "dd-MMM-yyyy") + '...!');
    			vm.clicked=false;
       		}else if(!isCustomerLimitRequest && (vm.limitHeader.limitTenorType!=null && vm.limitHeader.limitTenorType.shortName=='MAXIMUMTENOR' 
                && vm.limitHeader.maximumTenorType=='Days'
                && parseInt(vm.limitHeader.maximumTenorValue)>parseInt(vm.noOfActiveDaysForStandardTenor))){
                AlertService.error($filter('translate')('gatewayApp.limitSettings.maximumTenorValueCannotMoreThan') + vm.noOfActiveDaysForStandardTenor.toString() + ' days...!');
                vm.clicked=false;
            }else if(!isCustomerLimitRequest && (vm.limitHeader.limitTenorType!=null && vm.limitHeader.limitTenorType.shortName=='MAXIMUMTENOR' 
               && vm.limitHeader.maximumTenorType=='Months'
               && parseInt(vm.limitHeader.maximumTenorValue)>parseInt(vm.noOfActiveMonthsForStandardTenor))){
                AlertService.error($filter('translate')('gatewayApp.limitSettings.maximumTenorValueCannotMoreThan') + vm.noOfActiveMonthsForStandardTenor.toString() + ' months...!');
                vm.clicked=false;
            }
       		else if (vm.limitHeader.id !== null && vm.limitHeader.id!==undefined) {
       			if(validateChange()){
       				if(workflowSharedService.viewFrom == 'customer_limitSettings'){
						// validate for modified fields and values
						validateModifiedFields();
       					LimitSettings.updateLimitSettingsByCustomer(vm.customerLimit, onCustomerSaveSuccess, onCustomerSaveError);
       				}else{
       					LimitSettings.update(vm.limitHeader, onSaveSuccess, onSaveError);
       				}
       			}else{
       				AlertService.error($filter('translate')('gatewayApp.limitSettings.noChangesMade'));
       				vm.clicked = false;
       			}
             }else {
                 if(vm.actionType=='Add'){
                    LimitSettings.save(vm.limitHeader, onSaveSuccess, onSaveError);           
                 }else{
                    LimitSettings.reset(vm.limitHeader, onSaveSuccess, onSaveError);           
                 }
             }       	
        	
         }
     
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }

        function onSaveError () {
        	vm.clicked = false;
        }
        
        function onCustomerSaveSuccess(result){
        	 $uibModalInstance.close(result); 
        	 MessageBox.openMessageBox('Alert', 'The request has been sent for bank approval. You will be notified by email on the request status...!', 'Ok', 'homepage');
        }
        function onCustomerSaveError(error){
        	vm.clicked = false;
        }
        function resubmitLimitSettings() {
        	 prepareLimitDetailsToSaveToDB(vm.selectedInstrument, vm.limitInstrumentGroup.shortName);
        	 prepareDatesforServer();
        	 var comparision = moment(vm.currentDate).isAfter(vm.limitHeader.effectiveToDateTime, 'day');
	       	 
        	if(comparision){
        			AlertService.error($filter('translate')('gatewayApp.limitSettings.invalidaDate'));
        			vm.clicked=false;
        	 }else if(moment(vm.limitHeader.effectiveToDateTime).isAfter(vm.tillDate, 'day')){
    			AlertService.error($filter('translate')('gatewayApp.limitSettings.cannotMoreThanDate') + $filter('date')(vm.tillDate, "dd-MMM-yyyy") + '...!');
    			vm.clicked=false;
       		 }else if(!isCustomerLimitRequest && (vm.limitHeader.limitTenorType.shortName=='MAXIMUMVALUEDATE' 
               && moment(vm.limitHeader.maximumValueDate).isBefore(vm.spotNextDate, 'day'))){
                AlertService.error($filter('translate')('gatewayApp.limitSettings.maximumValueDateCannotLessThanDate') + $filter('date')(vm.spotNextDate, "dd-MMM-yyyy") + '...!');
                vm.clicked=false;
            }else if(!isCustomerLimitRequest && (vm.limitHeader.limitTenorType.shortName=='MAXIMUMVALUEDATE' 
               && moment(vm.limitHeader.maximumValueDate).isAfter(vm.maxTenorDate, 'day'))){
                AlertService.error($filter('translate')('gatewayApp.limitSettings.maximumValueDateCannotMoreThanDate') + $filter('date')(vm.maxTenorDate, "dd-MMM-yyyy") + '...!');
                vm.clicked=false;
            }else if(!isCustomerLimitRequest && (vm.limitHeader.limitTenorType.shortName=='MAXIMUMTENOR' 
                && vm.limitHeader.maximumTenorType=='Days'
                && vm.limitHeader.maximumTenorValue>vm.noOfActiveDaysForStandardTenor)){
                AlertService.error($filter('translate')('gatewayApp.limitSettings.maximumTenorValueCannotMoreThan') + vm.noOfActiveDaysForStandardTenor.toString() + ' days...!');
                vm.clicked=false;
            }else if(!isCustomerLimitRequest && (vm.limitHeader.limitTenorType.shortName=='MAXIMUMTENOR' 
               && vm.limitHeader.maximumTenorType=='Months'
               && vm.limitHeader.maximumTenorValue>vm.noOfActiveMonthsForStandardTenor)){
                AlertService.error($filter('translate')('gatewayApp.limitSettings.maximumTenorValueCannotMoreThan') + vm.noOfActiveMonthsForStandardTenor.toString() + ' months...!');
                vm.clicked=false;
            }else if(workflowSharedService.viewFrom == 'customer_limitSettings_resubmit'){
				// validate for modified fields and values
				validateModifiedFields();
        		 LimitSettings.resubmitLimitChangeByCustomer({"taskId" : $rootScope.taskID}, vm.customerLimit, onResubmitSuccess, onResubmitError);
        	}else{
        		 LimitSettings.resubmit({"taskId" : $rootScope.taskID}, vm.limitHeader, onResubmitSuccess, onResubmitError);
        	}
        }
        
        function onResubmitSuccess(result) {
        	$uibModalInstance.close(result); 
        	$rootScope.removeRow($rootScope.taskID);
        }        

		function onResubmitError(error) {
        	vm.clicked = false;
        }
        
        function rejectLimitSettings() { 
        	$rootScope.action = vm.actionType;
        	Workflow.rejectTask($rootScope.taskID); 
        }

        function discardLimitSettings() {
        	LimitSettings.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        

		function onDiscardError(error) {
        	
        }

        function approveLimitSettings() {  
    		prepareLimitDetailsToSaveToDB(vm.selectedInstrument, vm.limitInstrumentGroup.shortName);
    		prepareDatesforServer();
        	var comparision = moment(vm.currentDate).isAfter(vm.limitHeader.effectiveToDateTime, 'day');
	       	 
        	if(comparision){
       			AlertService.error($filter('translate')('gatewayApp.limitSettings.invalidaDate'));
       			vm.clicked=false;
       		}else if(moment(vm.limitHeader.effectiveToDateTime).isAfter(vm.tillDate, 'day')){
    			AlertService.error($filter('translate')('gatewayApp.limitSettings.cannotMoreThanDate') + $filter('date')(vm.tillDate, "dd-MMM-yyyy") + '...!');
    			vm.clicked=false;
       		}       	
        	else if(workflowSharedService.viewFrom == 'create_customer_limitSettings_checker' || workflowSharedService.viewFrom == 'customer_limitSettings_checker'){
				//check modified fields and push to fieldcheckarray for 2nd approval
				if(workflowSharedService.viewFrom == 'customer_limitSettings_checker'){
					var previousFieldArray = [];
					previousFieldArray = angular.copy(vm.customerLimit.fieldCheckArray);
					validateModifiedFields();
					angular.forEach(previousFieldArray, function(field) {
						if(vm.customerLimit.fieldCheckArray.indexOf(field)==-1){
							vm.customerLimit.fieldCheckArray.push(field);
						}
					});
					vm.showHighLight = false;
				}		
        		LimitSettings.approveWihPayload({"taskId" : $rootScope.taskID},vm.customerLimit,onApproveSuccess,onApproveError);         	
        	}else{
        		LimitSettings.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError); 
        	}
        }
        
        function onApproveSuccess(result) {        	
        	$rootScope.removeRow($rootScope.taskID); 
        	$uibModalInstance.close(result);  
        }        

		function onApproveError(error) {
        	vm.clicked = false;
        }

		function validateChange(){
        	var changesMade = false;
        	var field1 = checkvalidityOfValues(vm.previousLimit.limitType , vm.limitHeader.limitType);
        	
        	var field2 = false;
        	if(vm.previousLimit.limitCurrency != null && vm.previousLimit.limitCurrency!=undefined && vm.limitHeader.limitCurrency!=null && vm.limitHeader.limitCurrency !=undefined){
        		field2 = checkvalidityOfValues(vm.previousLimit.limitCurrency.code , vm.limitHeader.limitCurrency.code);
        	}
        	var field3 = checkvalidityOfValues(DateUtils.convertLocalDateToServer(vm.previousLimit.effectiveToDateTime ),DateUtils.convertLocalDateToServer( vm.limitHeader.effectiveToDateTime));
        	var field4 =false;
        	var ChangesMAdeInDetail = false;
        	if(vm.previousLimit.limitSettingsDetailsList.length != vm.limitHeader.limitSettingsDetailsList.length){
        		field4 = true;
        	}else{
        		angular.forEach(vm.previousLimit.limitSettingsDetailsList, function(previousDetail){
        			angular.forEach(vm.limitHeader.limitSettingsDetailsList, function(currenDetail){
        				if(previousDetail.instrumentType == null && currenDetail.instrumentType == null){
        					if(checkvalidityOfValues(previousDetail.value,currenDetail.value)){
        						ChangesMAdeInDetail = true;
        					}
        				}
        				else if( ( previousDetail.instrumentType != null && currenDetail.instrumentType == null ) ||  (previousDetail.instrumentType == null && currenDetail.instrumentType != null)){
       						ChangesMAdeInDetail = true;
        				}
        				else if( previousDetail.instrumentType.id==currenDetail.instrumentType.id ){
        					if(checkvalidityOfValues(previousDetail.value,currenDetail.value)){
        						ChangesMAdeInDetail = true;
        					}
        				}
        			});
        		});
        	}
        	
        	//var field5 =false;
        	//field5 = checkvalidityOfValues(vm.previousLimit.isLimitToBeReinstated , vm.limitHeader.isLimitToBeReinstated);

            var field5 = false;
			if(vm.previousLimit.limitInstrumentGroup != null && vm.previousLimit.limitInstrumentGroup!=undefined && vm.limitHeader.limitInstrumentGroup!=null && vm.limitHeader.limitInstrumentGroup !=undefined){
        		field5 = checkvalidityOfValues(vm.previousLimit.limitInstrumentGroup.shortName , vm.limitHeader.limitInstrumentGroup.shortName);
        	}
        	
        	var field6 =false;
			if(vm.previousLimit.limitReinstateType != null && vm.previousLimit.limitReinstateType!=undefined && vm.limitHeader.limitReinstateType!=null && vm.limitHeader.limitReinstateType !=undefined){
        		field6 = checkvalidityOfValues(vm.previousLimit.limitReinstateType.shortName , vm.limitHeader.limitReinstateType.shortName);
        	}
        	
            var field7 =false;
			if(vm.previousLimit.limitTenorType != null && vm.previousLimit.limitTenorType!=undefined && vm.limitHeader.limitTenorType!=null && vm.limitHeader.limitTenorType !=undefined){
        		field7 = checkvalidityOfValues(vm.previousLimit.limitTenorType.shortName , vm.limitHeader.limitTenorType.shortName);
        	}
            
            var field8 =false;
            field8 = checkvalidityOfValues(vm.previousLimit.maximumTenorType, vm.limitHeader.maximumTenorType);
            
            var field9 =false;
            field9 = checkvalidityOfValues(vm.previousLimit.maximumTenorValue, vm.limitHeader.maximumTenorValue);
            
            var field10 =false;
            field10 = checkvalidityOfValues(vm.previousLimit.maximumValueDate, vm.limitHeader.maximumValueDate);
            
        	if(field1 || field2 || field3 || field4 || ChangesMAdeInDetail || field5 || field6 
                || field7 || field8 || field9 || field10){
        		changesMade = true;
        	}
        	return changesMade;
        }

		function checkvalidityOfValues(previousValue, currentValue){
        	var isValueChanged = (!(previousValue == null && (currentValue == "" || currentValue== null)) && previousValue!=currentValue);
        	return isValueChanged;
        }

		vm.onChangeLimitInstrumentGroup = function onChangeLimitInstrumentGroup(value){
			if(value!=null && value!=undefined){
                if(vm.limitHeader!=null && vm.limitHeader!=undefined){
                    vm.limitHeader.limitInstrumentGroup = value;
                }
				setFieldValues("txtspot", "");
				setFieldValues("txtcash", "");
				setFieldValues("txttom", "");
				setFieldValues("txtforward", "");
				setFieldValues("txtuptospot", "");
				setFieldValues("txtall", "");
				setFieldValues("txtMaxTenorValue", "");
				
                if(vm.defaultLimitReinstateType!=null && vm.defaultLimitReinstateType!=undefined){
                    var defaultReinstateId = "slt_" + vm.defaultLimitReinstateType.shortName;
                    if(document.getElementById(defaultReinstateId)!=null){
                        setTimeout(function(){document.getElementById(defaultReinstateId).click()});
                    }
                }
                if(vm.defaultLimitTenorType!=null && vm.defaultLimitTenorType!=undefined){
                    var defaultTenorTypeId = "slt_tenor_" + vm.defaultLimitTenorType.shortName;
                    if(document.getElementById(defaultTenorTypeId)!=null){
                        setTimeout(function(){document.getElementById(defaultTenorTypeId).click()});
                    }
                }
				if(vm.defaultLimitTenorType.shortName!='MAXIMUMTENOR'){
					vm.maximumTenorType = null;
				}else{
					vm.maximumTenorType = 'Days';
				}
				if(value.shortName=='SPOTWINDOW'){
					vm.selectedInstrument = 'individual';
					vm.effectiveToDate = angular.copy(vm.effecitveToDateForSpotWindow);
				}else{
					vm.effectiveToDate = angular.copy(vm.effecitveToDateForForwards);
				}

			}
		}

		function setFieldValues(fieldName, value){
        	if( document.getElementById(fieldName) !=null && document.getElementById(fieldName)!= undefined){
        		document.getElementById(fieldName).value = value;
        	}
        }
	//validate modified fields and push to field check araray
		function validateModifiedFields(){
			vm.customerLimit.fieldCheckArray=[];
			checkModifiedOfValues(vm.previousLimit.limitInstrumentGroup.shortName , vm.limitHeader.limitInstrumentGroup.shortName,"limitInstrumentGroup",vm.customerLimit);
			checkModifiedOfValues(vm.previousLimit.limitType , vm.limitHeader.limitType,"limitType",vm.customerLimit);
			checkModifiedOfValues(vm.previousLimit.limitReinstateType.shortName , vm.limitHeader.limitReinstateType.shortName,"limitReinstateType",vm.customerLimit);
			checkModifiedOfValues(vm.previousLimit.limitTenorType.shortName , vm.limitHeader.limitTenorType.shortName,"limitTenorType",vm.customerLimit);
			checkModifiedOfValues(vm.previousLimit.maximumTenorType , vm.limitHeader.maximumTenorType,"maximumTenorType",vm.customerLimit);
			checkModifiedOfValues(vm.previousLimit.maximumTenorValue , vm.limitHeader.maximumTenorValue,"maximumTenorValue",vm.customerLimit);
			checkModifiedOfValues(vm.previousLimit.maximumValueDate , vm.limitHeader.maximumValueDate,"maximumValueDate",vm.customerLimit);
			if(vm.previousLimit.limitCurrency != null && vm.previousLimit.limitCurrency!=undefined && vm.limitHeader.limitCurrency!=null && vm.limitHeader.limitCurrency !=undefined){
				checkModifiedOfValues(vm.previousLimit.limitCurrency.code , vm.limitHeader.limitCurrency.code,"limitCurrency",vm.customerLimit);
			}
			 checkModifiedOfValues(DateUtils.convertLocalDateToServer(vm.previousLimit.effectiveToDateTime ),DateUtils.convertLocalDateToServer( vm.limitHeader.effectiveToDateTime),"effectiveToDate",vm.customerLimit);
			if(vm.limitHeader.limitInstrumentGroup.shortName=='SPOTWINDOW'){
				if( vm.limitHeader!=null && vm.limitHeader!=undefined && vm.limitHeader.limitSettingsDetailsList.length == INDIVIDUAL_LIMIT_DETAIL_COUNT){
					angular.forEach(vm.previousLimit.limitSettingsDetailsList, function(previousDetail){
						angular.forEach(vm.limitHeader.limitSettingsDetailsList, function(currenDetail){
							 if( previousDetail.instrumentType.id==currenDetail.instrumentType.id ){
								if(currenDetail.instrumentType.shortName =='CASH'){
									 checkModifiedOfValues(previousDetail.value , currenDetail.value,"cashAmount",vm.customerLimit);			
								}else if(currenDetail.instrumentType.shortName =='TOM'){
									 checkModifiedOfValues(previousDetail.value , currenDetail.value,"tomAmount",vm.customerLimit);
								}else if(currenDetail.instrumentType.shortName =='SPOT'){
									 checkModifiedOfValues(previousDetail.value , currenDetail.value,"spotAmount",vm.customerLimit);  
								}
							}
						});
					});
				}else {
					 checkModifiedOfValues(vm.previousLimit.limitSettingsDetailsList[0].value , vm.limitHeader.limitSettingsDetailsList[0].value,"upToSpotAmount",vm.customerLimit);
				}
			}
		    else if(vm.limitHeader.limitInstrumentGroup.shortName=='FORWARD'){
				checkModifiedOfValues(vm.previousLimit.limitSettingsDetailsList[0].value , vm.limitHeader.limitSettingsDetailsList[0].value,"forwardAmount",vm.customerLimit);
		 }else{
			 checkModifiedOfValues(vm.previousLimit.limitSettingsDetailsList[0].value , vm.limitHeader.limitSettingsDetailsList[0].value,"allAmount",vm.customerLimit);
		 }
		}
		//check and push modified field names
		function checkModifiedOfValues(previousValue, currentValue,fieldName,customerLimit){
			
        	var isValueChanged = (!(previousValue == null && (currentValue == "" || currentValue== null)) && previousValue!=currentValue);
			 if(isValueChanged){
        	 	customerLimit.fieldCheckArray.push(fieldName);
        	 }
        	return isValueChanged;
        }
		//check modified fields in fieldCheckArray using control-modified in html
		function checkforModificationField(fieldName){
			if( workflowSharedService.viewFrom == 'customer_limitSettings_checker'  && vm.showHighLight && vm.customerLimit!=undefined && vm.customerLimit!=null) {
				var fieldCheckArray = angular.copy(vm.customerLimit.fieldCheckArray);
				if(fieldCheckArray!=undefined && fieldCheckArray!=null  && fieldCheckArray.indexOf(fieldName)>=0){
					return true;
				}else{
					return false;
				}
				 
			}
			else{
				return false;
			}
				 
			}
			
				
		}

	
})();

(function() {
	'use strict';

	angular.module('gatewayApp')

	.controller('LimitsDialogController', LimitsDialogController);

	LimitsDialogController.$inject = [ '$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','LimitSettings', 
		'DateUtils', 'ScreenLog','entityConstants', 'AlertService', '$filter', 'Workflow','entity','StaticLookUp','MessageBox', '$stateParams', 'Market' ];

	function LimitsDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,LimitSettings,
			DateUtils,ScreenLog,entityConstants,AlertService,$filter, Workflow,entity,StaticLookUp,MessageBox,$stateParams,Market) {
		var vm=this;
		var ALL_LIMIT_DETAIL_COUNT = 1;
		var INDIVIDUAL_LIMIT_DETAIL_COUNT = 4;
		var UPTOSPOTANDFORWARD_LIMIT_DETAIL_COUNT = 2;
		vm.actionType = "";
		 vm.globalValues = GlobalValues;
         vm.entityConstants = entityConstants;
         vm.screenLog = ScreenLog;
         vm.loggedinEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
         vm.screenName = entityConstants.ENTITY_SHORT_NAME.LIMITSETTINGS;
         $scope.showOkButton = false;
         vm.limitHeader={};
         vm.minValue = 0;
        
        
         //vm.disableReinstateField = false;         
         //vm.showLimiReinstateType = false;         
         vm.SETTLED_TRADES = 'SettledTrades';
         vm.DAILY = 'Daily';
         vm.YES = 'Yes';
         vm.NO = 'No';         
         //vm.isLimitToBeReinstated = NO;
         
         //vm.currentDate = new Date();
         //vm.effectiveToMinimumDate =  new Date();
         var systemSettings = vm.globalValues.getSystemSettings();
         if(systemSettings!=null && systemSettings!=undefined){
        	 var now = moment();
        	 vm.momentBusinessDate = moment(systemSettings.businessDate, 'YYYY-MM-DD');        	
        	 vm.momentBusinessDate.set(
        			 { 	'hour':now.get('hour'),
        				'minute':now.get('minute'),
        				'second':now.get('second')
        				
        			 });
        	 vm.currentDate = vm.momentBusinessDate.toDate();
        	
        	 vm.effectiveToMinimumDate = systemSettings.businessDate;
        	 vm.tillDate = new Date(vm.currentDate);
        	 vm.tillDate.setDate(vm.currentDate.getDate() + 364);
         }
         
         vm.customerLimit = {};
       
         
         vm.clear = clear;
         vm.resubmitLimitSettings= resubmitLimitSettings;
         vm.approveLimitSettings = approveLimitSettings;
         vm.rejectLimitSettings = rejectLimitSettings;
         vm.discardLimitSettings = discardLimitSettings;
         vm.save=save;
         vm.clicked = false;
         vm.showLimitUtilised = false;
         vm.showLimitUtilisedWithINR = false;
         vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();

         loadInstrumentType();
         loadCurrency();
         loadLimitTypes();
                  
         function loadInstrumentType(){
        	 StaticLookUp.getInstrumentType(istrumentLookUpSuccess, instrumentLookupFailure);
         }
         function istrumentLookUpSuccess(result){
        	 vm.instrumentTypes = result;
        	 angular.forEach( vm.instrumentTypes, function(item){
        		 if(item.shortName =='SPOT'){
        			 vm.spotType = item;
        		 }else if(item.shortName =='CASH'){
        			 vm.cashType = item;
        		 }else if (item.shortName =='TOM'){
        			 vm.tomType = item;
        		 }else if (item.shortName =='UptoSPOT'){
        			 vm.uptoSpotType = item;
        		 }else if (item.shortName =='Forward'){
        			 vm.frwdType = item;
        		 }
        	 });
        	
         }
         function instrumentLookupFailure(error){
        	 
         }        
         function loadCurrency(){
        	 StaticLookUp.getCurrencyLimit(currencySuccess,currencyFailure);
         }
         function currencySuccess(result){
        	 vm.currencies = result;
         }
         function currencyFailure(error){
        	 
         }
         function loadLimitTypes(){
        	 StaticLookUp.getLimitType(limitTypeSuccess, limitTypeFailure);
         }
         function limitTypeSuccess(result){
        	 vm.limitTypes = result;
        	 prepareLimitTypeToView();
         }
         function limitTypeFailure(error){
        	 
         }
         
         $scope.$watch('vm.selectedLimitType' , function(value){
        	 if(vm.limitHeader!=null && vm.limitHeader!==undefined){
        		 if(value !=null && value!=undefined)
        			 vm.limitHeader.limitType = value.shortName;
        		// else if(vm.limitHeader.limitType=null || vm.limitHeader.limitType == undefined )
        			// vm.limitHeader.limitType="";
        	 }
         });
         $scope.$watch('vm.isLimitToBeReinstated' , function(value){
        	 //if(vm.limitHeader!=null && vm.limitHeader!==undefined){
        		//alert(value + " " + typeof value);
        		 if(value !=null && value!=undefined && value== vm.NO){
        			 vm.showLimiReinstateType = false;
        			 vm.limitHeader.isLimitToBeReinstated =false;
        			 vm.limitHeader.limitReinstateMethod = null;
        		 }else if(value !=null && value!=undefined && value==vm.YES){
        			 vm.showLimiReinstateType = true;
        			 vm.limitHeader.isLimitToBeReinstated =true;
        			 document.getElementById("reinstateMethodRadio").focus();
        		 }
        	 //}
         });
         $scope.$watch('vm.selectedInstrument', function(value){
        	 if( vm.limitHeader!=null && vm.limitHeader!=undefined && value == 'all'){
        		 if( document.getElementById("txtspot")!=undefined &&  document.getElementById("txtspot")!=null){
        			 document.getElementById("txtspot").value = "";
        		 }
        		 if( document.getElementById("txttom")!=undefined &&  document.getElementById("txttom")!=null){
        			 document.getElementById("txttom").value = "";
        		 }
        		 if( document.getElementById("txtcash")!=undefined &&  document.getElementById("txtcash")!=null){
        			 document.getElementById("txtcash").value = "";
        		 }
        		 if( document.getElementById("txtforward")!=undefined &&  document.getElementById("txtforward")!=null){
        			 document.getElementById("txtforward").value = "";
        		 }
        		 if( document.getElementById("txtuptospot")!=undefined &&  document.getElementById("txtuptospot")!=null){
        			 document.getElementById("txtuptospot").value = "";
        		 }
        		 if( document.getElementById("txtuptospotforward")!=undefined &&  document.getElementById("txtuptospotforward")!=null){
        			 document.getElementById("txtuptospotforward").value = "";
        		 }
        		 vm.spotValue=null;
        		 vm.tomValue=null;
        		 vm.cashValue=null;
        		 vm.forwardValue = null;
        		 vm.uptoSpotValue = null;
        		 vm.forwardUptoSpotValue = null;
        	 }else if( vm.limitHeader!=null && vm.limitHeader!=undefined && value == 'individual'){
        		 if( document.getElementById("txtall")!=undefined &&  document.getElementById("txtall")!=null){
        		 	document.getElementById("txtall").value = "";
        	 	}
        		 if( document.getElementById("txtuptospot")!=undefined &&  document.getElementById("txtuptospot")!=null){
        			 document.getElementById("txtuptospot").value = "";
        		 }
        		 if( document.getElementById("txtuptospotforward")!=undefined &&  document.getElementById("txtuptospotforward")!=null){
        			 document.getElementById("txtuptospotforward").value = "";
        		 }
        		 vm.allValue=null;
        		 vm.uptoSpotValue = null;
        		 vm.forwardUptoSpotValue = null;
        	 }
        	 if( vm.limitHeader!=null && vm.limitHeader!=undefined && value == 'uptoSpot'){
        		 if( document.getElementById("txtall")!=undefined &&  document.getElementById("txtall")!=null){
         		 	document.getElementById("txtall").value = "";
         	 	 }
        		 if( document.getElementById("txtspot")!=undefined &&  document.getElementById("txtspot")!=null){
        			 document.getElementById("txtspot").value = "";
        		 }
        		 if( document.getElementById("txttom")!=undefined &&  document.getElementById("txttom")!=null){
        			 document.getElementById("txttom").value = "";
        		 }
        		 if( document.getElementById("txtcash")!=undefined &&  document.getElementById("txtcash")!=null){
        			 document.getElementById("txtcash").value = "";
        		 }
        		 if( document.getElementById("txtforward")!=undefined &&  document.getElementById("txtforward")!=null){
        			 document.getElementById("txtforward").value = "";
        		 }
        		 vm.allValue=null;
        		 vm.spotValue=null;
        		 vm.tomValue=null;
        		 vm.cashValue=null;
        		 vm.forwardValue = null;
        	 }
        	 prepareLimitDetailsToSaveToDB(value);
         });
         
         $scope.$watch('vm.allValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.allValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         
         $scope.$watch('vm.spotValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.spotValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         
         $scope.$watch('vm.tomValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.tomValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         
         $scope.$watch('vm.cashValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.cashValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         
         $scope.$watch('vm.forwardValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.forwardValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         
         $scope.$watch('vm.uptoSpotValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.uptoSpotValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         
         $scope.$watch('vm.forwardUptoSpotValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.forwardUptoSpotValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
    
         function prepareLimitTypeToView(){
        	
        	 if(vm.limitHeader!=null && vm.limitHeader!=undefined){
        		 angular.forEach(vm.limitTypes, function(item){
            		 if(item.shortName == vm.limitHeader.limitType ){
            			 vm.selectedLimitType = item;
            		 }
            	 })
        	 }
        	
         }
         function checkInstrumentValue(instrumentValue){
        	 
        	 if(instrumentValue == "" || instrumentValue == undefined || instrumentValue == null){
        		 return 0.00;
        	 }else{
        		 return instrumentValue;
        	 }
         }
         function prepareLimitDetailsToSaveToDB(value){
        	 if( vm.limitHeader!=null && vm.limitHeader!=undefined && value == 'all'){
        		 vm.limitHeader.limitSettingsDetailsList=[];
        		 vm.limitHeader.limitSettingsDetailsList[0]={};
        		 vm.limitHeader.limitSettingsDetailsList[0].instrumentType=null;
        		 vm.limitHeader.limitSettingsDetailsList[0].value=checkInstrumentValue(vm.allValue);
        		
        		 
        	 }else if( vm.limitHeader!=null && vm.limitHeader!=undefined && value == 'individual'){
        		 
        		
        		 vm.limitHeader.limitSettingsDetailsList=[];
        		 vm.limitHeader.limitSettingsDetailsList[0]={};
        		 vm.limitHeader.limitSettingsDetailsList[0].instrumentType=vm.cashType;
        		 vm.limitHeader.limitSettingsDetailsList[0].value=checkInstrumentValue(vm.cashValue);
        		 
        		 vm.limitHeader.limitSettingsDetailsList[1]={};
        		 vm.limitHeader.limitSettingsDetailsList[1].instrumentType=vm.tomType;
        		 vm.limitHeader.limitSettingsDetailsList[1].value=checkInstrumentValue(vm.tomValue);
        		 
        		 vm.limitHeader.limitSettingsDetailsList[2]={};
        		 vm.limitHeader.limitSettingsDetailsList[2].instrumentType=vm.spotType;
        		 vm.limitHeader.limitSettingsDetailsList[2].value=checkInstrumentValue(vm.spotValue);
        		 
        		 vm.limitHeader.limitSettingsDetailsList[3]={};
        		 vm.limitHeader.limitSettingsDetailsList[3].instrumentType=vm.frwdType;
        		 vm.limitHeader.limitSettingsDetailsList[3].value=checkInstrumentValue( vm.forwardValue);
        		 
        	 }else if( vm.limitHeader!=null && vm.limitHeader!=undefined && value == 'uptoSpot'){
        		 
        		 
        		 vm.limitHeader.limitSettingsDetailsList=[];
        		 vm.limitHeader.limitSettingsDetailsList[0]={};
        		 vm.limitHeader.limitSettingsDetailsList[0].instrumentType=vm.uptoSpotType;
        		 vm.limitHeader.limitSettingsDetailsList[0].value=checkInstrumentValue(vm.uptoSpotValue);
        		 
        		 vm.limitHeader.limitSettingsDetailsList[1]={};
        		 vm.limitHeader.limitSettingsDetailsList[1].instrumentType=vm.frwdType;
        		 vm.limitHeader.limitSettingsDetailsList[1].value=checkInstrumentValue(vm.forwardUptoSpotValue);
        		 
        		
        	 }
         }
         function prepateLimitDetailsToView(){
        	 
        	 if( vm.limitHeader!=null && vm.limitHeader !=undefined && vm.limitHeader.limitSettingsDetailsList!=null && vm.limitHeader.limitSettingsDetailsList!=undefined && vm.limitHeader.limitSettingsDetailsList.length==ALL_LIMIT_DETAIL_COUNT){
        		 vm.selectedInstrument = "all";
        		 vm.allValue = vm.limitHeader.limitSettingsDetailsList[0].value;
        		 if(vm.prevClose!=null && vm.prevClose!=undefined && vm.allValue !=null && vm.allValue !=undefined){
        			 vm.allValueInINR = (Math.round(parseFloat(vm.allValue)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
        	 else if(vm.limitHeader!=null && vm.limitHeader !=undefined && vm.limitHeader.limitSettingsDetailsList!=null && vm.limitHeader.limitSettingsDetailsList!=undefined && (vm.limitHeader.limitSettingsDetailsList.length==INDIVIDUAL_LIMIT_DETAIL_COUNT
        			 || vm.limitHeader.limitSettingsDetailsList.length==3 )){
        		 vm.selectedInstrument = "individual";
        		 angular.forEach( vm.limitHeader.limitSettingsDetailsList, function(item){
        			 if(item.instrumentType!=null && item.instrumentType!=undefined){
        			 	
        				 if(item.instrumentType.shortName =='CASH'){
         			 		vm.cashValue = item.value;
        	        		 if(vm.prevClose!=null && vm.prevClose!=undefined && item.value!=null && item.value!=undefined){
        	        			 vm.cashValueInINR = (Math.round(parseFloat(vm.cashValue)*10000) / vm.prevClose) / 10000;
        	        		 }
         			 	}else if(item.instrumentType.shortName =='TOM'){
        			 		vm.tomValue = item.value;
        			 		if(vm.prevClose!=null && vm.prevClose!=undefined && item.value!=null && item.value!=undefined){
    	        			 vm.tomValueInINR = (Math.round(parseFloat(vm.tomValue)*10000) / vm.prevClose) / 10000;
        			 		}
        			 	}else if(item.instrumentType.shortName =='SPOT'){
        			 		vm.spotValue = item.value;
        			 		if(vm.prevClose!=null && vm.prevClose!=undefined && item.value!=null && item.value!=undefined){
       	        			 vm.spotValueInINR = (Math.round(parseFloat(vm.spotValue)*10000) / vm.prevClose) / 10000;
        			 		}
        			 	}else if(item.instrumentType.shortName =='Forward'){
        			 		vm.forwardValue = item.value;
        			 		if(vm.prevClose!=null && vm.prevClose!=undefined && item.value!=null && item.value!=undefined){
       	        			 vm.forwardValueInINR = (Math.round(parseFloat(vm.forwardValue)*10000) / vm.prevClose) / 10000;
        			 		}
        			 	}
        			 	
        			 }
        			 	  			 
        		 });
        	 }
        	 else if(vm.limitHeader!=null && vm.limitHeader !=undefined && vm.limitHeader.limitSettingsDetailsList!=null && vm.limitHeader.limitSettingsDetailsList!=undefined && vm.limitHeader.limitSettingsDetailsList.length == UPTOSPOTANDFORWARD_LIMIT_DETAIL_COUNT){
        		 vm.selectedInstrument = "uptoSpot";
        		 angular.forEach( vm.limitHeader.limitSettingsDetailsList, function(item){
        			 if(item.instrumentType!=null && item.instrumentType!=undefined){        			 	
        				
        			 	if(item.instrumentType.shortName =='UptoSPOT'){
        			 		vm.uptoSpotValue = item.value;
        			 		if(vm.prevClose!=null && vm.prevClose!=undefined){
       	        			 vm.uptoSpotValueInINR = (Math.round(parseFloat(vm.uptoSpotValue)*10000) / vm.prevClose) / 10000;
        			 		}
        			 	}else if(item.instrumentType.shortName =='Forward'){
        			 		vm.forwardUptoSpotValue = item.value;
        			 		if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 			vm.forwardUptoSpotValueInINR = (Math.round(parseFloat(vm.forwardUptoSpotValue)*10000) / vm.prevClose) / 10000;
        			 		}
        			 	}
        			 	
        			 }
        			 	  			 
        		 });
        	 }
         }
         function loadDefaultEffectiveToDate(){
        	 //LimitSettings.getDefaultEffectiveToDate();
        	 LimitSettings.getDefaultEffectiveToDate(loadEffectiveDateSuccess, loadEffectiveDateFailure);
         }
         function loadEffectiveDateSuccess(result){
        	
        	 vm.efectiveToDate = DateUtils.convertDateTimeFromServer(result.effectiveToDate);
         }
         function loadEffectiveDateFailure(error){
        	 
         }
         function prepareDatesForView(){
        	 if(vm.limitHeader!=null && vm.limitHeader!=undefined){
        		 vm.efectiveFromDate = DateUtils.convertDateTimeFromServer(vm.limitHeader.effectiveFromDateTime);
        		 
        	 	vm.efectiveToDate = DateUtils.convertDateTimeFromServer(vm.limitHeader.effectiveToDateTime);
        	 }
         }	
         function prepareDatesforServer(){
        	// vm.limitHeader.effectiveFromDateTime = DateUtils.convertLocalDateToServer(vm.efectiveFromDate);
        	 //vm.limitHeader.effectiveToDateTime = DateUtils.convertLocalDateToServer(vm.efectiveToDate);
        	 vm.limitHeader.effectiveFromDateTime = vm.efectiveFromDate;        	
        	 vm.limitHeader.effectiveToDateTime = vm.efectiveToDate;
         }
		if (workflowSharedService.viewFrom == 'limitSettings_add') {

			vm.limitHeader = {};
			vm.selectedInstrument = 'individual';
			vm.efectiveFromDate = vm.currentDate;
			loadDefaultEffectiveToDate();
			
	        $scope.showButton = true;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;		
			$scope.showResubmitButton = false;
			vm.disableForm = false;
			vm.actionType="Add";
			var disableBranch=false;
			if (vm.loggedinEntityOwnerType == "Bank"){
	        	 disableBranch=false;
	        	 vm.limitHeader.bank = vm.globalValues.getBank();
	    			 
	    	 }else if(vm.loggedinEntityOwnerType == "Branch") {
	    		 disableBranch=true;
	    		
	    		 vm.limitHeader.branch = vm.globalValues.getBranch();
	    		 vm.limitHeader.bank = vm.limitHeader.branch.bank;
	    	 }
			enableControls(disableBranch,false,false,false,false);
			vm.disableReinstateField = false;
			
		} else if (workflowSharedService.viewFrom == 'limitSettings_edit') {
			
			vm.limitHeader = entity;
			
			prepateLimitDetailsToView();
			prepareDatesForView();
			vm.efectiveFromDate = vm.currentDate;
			prepareLimitTypeToView();
			/*if(vm.limitHeader !=null  && vm.limitHeader !=undefined){
				vm.limitHeader.effectiveFromDateTime = vm.currentDate;
			}*/
			vm.previousLimit = angular.copy(vm.limitHeader);
			$scope.showButton = true;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton = false;
			vm.disableForm = false;
			vm.actionType="Change";
			enableControls(true,true,false,false,false,false);
			vm.disableReinstateField = false;
		
		} else if (workflowSharedService.viewFrom == 'limitSettings_view') {
			
			vm.limitHeader = entity;
			prepateLimitDetailsToView();
			prepareDatesForView();
			prepareLimitTypeToView();
			/*if(vm.limitHeader !=null  && vm.limitHeader !=undefined){
				vm.limitHeader.effectiveFromDateTime = vm.currentDate;
			}*/
			vm.previousLimit = angular.copy(vm.limitHeader);
			$scope.showOkButton = true;
			$scope.showButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton = false;
			vm.disableForm = true;
			vm.actionType="View";
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
		
		}
		else if (workflowSharedService.viewFrom == 'limitSettings_checker') {
			
			var copyOfPayload = angular.copy($rootScope.payload);
			vm.limitHeader = angular.fromJson(copyOfPayload);			
			prepateLimitDetailsToView();
			prepareDatesForView();
			prepareLimitTypeToView();
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = true;
			$scope.showDiscardButton = false;
			vm.disableForm = true;
			vm.actionType=getActionType($rootScope.action);
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
		} else if (workflowSharedService.viewFrom == 'limitSettings_maker') {
			
			var copyOfPayload = angular.copy($rootScope.payload);
			vm.limitHeader = angular.fromJson(copyOfPayload);
			prepateLimitDetailsToView();
			prepareDatesForView();
			prepareLimitTypeToView();
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = true;
			vm.disableForm = true;
			vm.actionType=getActionType($rootScope.action);
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
			
		} else if (workflowSharedService.viewFrom == 'limitSettings_resubmit') {
			var copyOfPayload = angular.copy($rootScope.payload);
			vm.limitHeader = angular.fromJson(copyOfPayload);
			prepateLimitDetailsToView();
			prepareDatesForView();
			prepareLimitTypeToView();
			vm.screenLog.screenLog(vm.screenName, vm.limitHeader.id == null ? 0
					: vm.limitHeader.id,
					entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
			vm.disableForm = false;
			$scope.showButton = false;
			$scope.showResubmitButton = true;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			vm.actionType=getActionType($rootScope.action);
			enableControls(true,true,false,false,false,false);
			vm.disableReinstateField = false;
		} else if (workflowSharedService.viewFrom == 'limitSettings_auditLog') {
			
			var copyOfPayload = angular.copy($rootScope.payload);
			vm.limitHeader = angular.fromJson(copyOfPayload);
			prepateLimitDetailsToView();
			prepareDatesForView();
			prepareLimitTypeToView();
			vm.disableForm = true;
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showOkButton = true;
			vm.actionType= getActionType($rootScope.actionName);
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
		}else if(workflowSharedService.viewFrom=='limit_import_auditlog'){
        	
			var copyOfPayload = angular.copy($rootScope.payload); 
			var limitHeaderDTO = angular.fromJson(copyOfPayload);
			
			vm.limitHeader = limitHeaderDTO;
			prepateLimitDetailsToView();
			prepareDatesForView();
			prepareLimitTypeToView();
			vm.disableForm = true;
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showOkButton = true;
			vm.actionType= getActionType($rootScope.actionName);
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;

        }
		else if (workflowSharedService.viewFrom == 'customer_limitSettings') {
			
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			
			vm.customerLimit  = entity;
			LimitSettings.getLimitsAvailableForAllInstruments({customerId : $stateParams.customerId , bankId :$stateParams.bankId }, function(result){
				vm.limitUtilisationDetails = result;
			})
			vm.showLimitUtilised = true;
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;			
			if(vm.limitHeader.limitCurrency.code=='INR'){
				vm.showLimitUtilisedWithINR = true;
			}
	         Market.getLTPForLimitsForInstrument({"instrument": 'InterbankSPOT'}, function(result){
	        	 if(result!=null && result.ltp!=null){
	            	 vm.prevClose = (Math.round(parseFloat(result.ltp)*10000)) / 10000;
	            	 prepateLimitDetailsToView();
	        	 }else{
	        		 prepateLimitDetailsToView();
	        	 }
	         })
			prepareDatesForView();
			vm.efectiveFromDate = vm.currentDate;
			prepareLimitTypeToView();
			ScreenLog.screenLog(vm.screenName,vm.limitHeader.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
			vm.limitHeader.effectiveFromDateTime = vm.currentDate;
			vm.previousLimit = angular.copy(vm.limitHeader);
			
			$scope.showButton = true;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton = false;
			vm.disableForm = false;
			vm.actionType="CustomerChange";
			enableControls(true,true,true,false,true,false);
			vm.disableReinstateField = true;
		} 
		else if (workflowSharedService.viewFrom == 'customer_limitSettings_checker') {
			
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;
			LimitSettings.getLimitsAvailableForAllInstruments({customerId : vm.limitHeader.customer.id , bankId :vm.limitHeader.bank.id }, function(result){
				vm.limitUtilisationDetails = result;
			})
			vm.showLimitUtilised = true;
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;			
			if(vm.limitHeader.limitCurrency.code=='INR'){
				vm.showLimitUtilisedWithINR = true;
			}
	         Market.getLTPForLimitsForInstrument({"instrument": 'InterbankSPOT'}, function(result){
	        	 if(result!=null && result.ltp!=null){
	            	 vm.prevClose = (Math.round(parseFloat(result.ltp)*10000)) / 10000;
	            	 prepateLimitDetailsToView();
	        	 }else{
	        		 prepateLimitDetailsToView();
	        	 }
	         })
			prepareDatesForView();
			prepareLimitTypeToView();
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = true;
			$scope.showDiscardButton = false;
			//vm.disableForm = false;
			vm.disableForm = true;
			vm.actionType="CustomerChange";
			//enableControls(true,true,true,false,true,false);
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
			
		} else if (workflowSharedService.viewFrom == 'customer_limitSettings_maker') {
			
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;
			LimitSettings.getLimitsAvailableForAllInstruments({customerId : vm.limitHeader.customer.id , bankId :vm.limitHeader.bank.id }, function(result){
				vm.limitUtilisationDetails = result;
			})
			vm.showLimitUtilised = true;
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;			
			if(vm.limitHeader.limitCurrency.code=='INR'){
				vm.showLimitUtilisedWithINR = true;
			}
	         Market.getLTPForLimitsForInstrument({"instrument": 'InterbankSPOT'}, function(result){
	        	 if(result!=null && result.ltp!=null){
	            	 vm.prevClose = (Math.round(parseFloat(result.ltp)*10000)) / 10000;
	            	 prepateLimitDetailsToView();
	        	 }else{
	        		 prepateLimitDetailsToView();
	        	 }
	         })
			prepareDatesForView();
			prepareLimitTypeToView();
			
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = true;
			vm.disableForm = true;
			vm.actionType="CustomerChange";
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
			
		} else if (workflowSharedService.viewFrom == 'customer_limitSettings_resubmit') {
			
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;
			LimitSettings.getLimitsAvailableForAllInstruments({customerId : vm.limitHeader.customer.id , bankId :vm.limitHeader.bank.id }, function(result){
				vm.limitUtilisationDetails = result;
			})
			vm.showLimitUtilised = true;
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;			
			if(vm.limitHeader.limitCurrency.code=='INR'){
				vm.showLimitUtilisedWithINR = true;
			}
	         Market.getLTPForLimitsForInstrument({"instrument": 'InterbankSPOT'}, function(result){
	        	 if(result!=null && result.ltp!=null){
	            	 vm.prevClose = (Math.round(parseFloat(result.ltp)*10000)) / 10000;
	            	 prepateLimitDetailsToView();
	        	 }else{
	        		 prepateLimitDetailsToView();
	        	 }
	         })
			
			prepareDatesForView();
			prepareLimitTypeToView();
			vm.screenLog.screenLog(vm.screenName, vm.limitHeader.id == null ? 0
					: vm.limitHeader.id,
					entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
			vm.disableForm = false;
			$scope.showButton = false;
			$scope.showResubmitButton = true;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			vm.actionType="CustomerChange";
			enableControls(true,true,true,false,true,false);
			vm.disableReinstateField = true;
		} else if (workflowSharedService.viewFrom == 'customer_limitSettings_auditLog') {
			
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;
			prepateLimitDetailsToView();
			prepareDatesForView();
			prepareLimitTypeToView();
			vm.disableForm = true;
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showOkButton = true;
			//vm.actionType= getActionType($rootScope.actionName);
			if(vm.limitHeader.id!=null && vm.limitHeader.id!=undefined && !vm.limitHeader.id==""){
				vm.actionType="CustomerChange";
			}else{
				vm.actionType="CustomerCreate";
			}
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
		}
		
		else if (workflowSharedService.viewFrom == 'create_customer_limitSettings_checker') {
			
			//vm.minValue = 0.01;
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
						
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;			
			prepateLimitDetailsToView();
			prepareDatesForView();
			if(vm.limitHeader.effectiveFromDateTime == null || vm.limitHeader.effectiveFromDateTime == undefined
					|| vm.limitHeader.effectiveFromDateTime == ""){
				
				vm.efectiveFromDate = vm.currentDate;
				
			}
			if(vm.limitHeader.effectiveToDateTime == null || vm.limitHeader.effectiveToDateTime == undefined
					|| vm.limitHeader.effectiveToDateTime == ""){
				
				loadDefaultEffectiveToDate();
			}
			prepareLimitTypeToView();
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = true;
			$scope.showDiscardButton = false;
			//vm.disableForm = false;
			vm.disableForm = false;
			vm.actionType="CustomerCreate";
			//enableControls(true,true,true,false,true,false);
			enableControls(true,true,false,false,false,false);
			vm.disableReinstateField = false;
			
		} 
		else if (workflowSharedService.viewFrom == 'create_customer_limitSettings_checker_view') {
			
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
						
			vm.limitHeader = vm.customerLimit.limitSettingsHeader;			
			prepateLimitDetailsToView();
			prepareDatesForView();
			if(vm.limitHeader.effectiveFromDateTime == null || vm.limitHeader.effectiveFromDateTime == undefined
					|| vm.limitHeader.effectiveFromDateTime == ""){
				
				vm.efectiveFromDate = vm.currentDate;
				
			}
			if(vm.limitHeader.effectiveToDateTime == null || vm.limitHeader.effectiveToDateTime == undefined
					|| vm.limitHeader.effectiveToDateTime == ""){
				
				loadDefaultEffectiveToDate();
			}
			prepareLimitTypeToView();
			$scope.showButton = false;
			$scope.showResubmitButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = true;
			vm.disableForm = true;
			vm.actionType="CustomerCreate";
			enableControls(true,true,true,true,true,true);
			vm.disableReinstateField = true;
			
		} 
		setLimitReinstateOption();
		
		function setLimitReinstateOption(){
			if( vm.limitHeader!=null && vm.limitHeader!=undefined 
					&& vm.limitHeader.isLimitToBeReinstated!=null && vm.limitHeader.isLimitToBeReinstated!=undefined ){
				if(vm.limitHeader.isLimitToBeReinstated == true){
					vm.isLimitToBeReinstated = vm.YES;
					vm.showLimiReinstateType = true;
				}else{
					vm.isLimitToBeReinstated = vm.NO;
					vm.showLimiReinstateType = false;
				}
			}else{
				vm.isLimitToBeReinstated = vm.NO;
				vm.showLimiReinstateType = false;
			}
		}
		function enableControls(disableBranch , disableCusomer, disableOtherControls,disableEffectiveToControl, disableRadio, disableValues){
			
			vm.disableBranch = disableBranch;
			vm.disableCustomer = disableCusomer;
			vm.disableLimitType= disableOtherControls;
			vm.disableCurrency= disableOtherControls;
			vm.disableEffectiveToDate= disableEffectiveToControl;
			vm.disableRadio = disableRadio;
			vm.disableValues = disableValues;
		}
		  
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        function getActionType(action){
        	if(action!=null && action!=undefined){
	        	action = action.toLowerCase();
	        	if(action.indexOf("add") !== -1 || action.indexOf("create") !== -1){
	        		return "Add";
	        	}
	        	else if(action.indexOf("edit") !== -1 || action.indexOf("modify") !== -1 || action.indexOf("modified") !== -1 || action.indexOf("change") !== -1){
	        		return "Change";
	        	}
        	}
        }
        
        function save () {        	    		
        	 prepareLimitDetailsToSaveToDB(vm.selectedInstrument);
        	 prepareDatesforServer();
        	 var comparision = moment(vm.currentDate).isAfter(vm.limitHeader.effectiveToDateTime, 'day');
        	  console.log(vm.limitHeader.effectiveToDateTime);
        	  console.log(vm.currentDate);
       		if(comparision){
       			AlertService.error($filter('translate')('gatewayApp.limitSettings.invalidaDate'));
       			vm.clicked=false;
       		}else if(moment(vm.limitHeader.effectiveToDateTime).isAfter(vm.tillDate, 'day')){
    			AlertService.error($filter('translate')('gatewayApp.limitSettings.cannotMoreThanDate') + $filter('date')(vm.tillDate, "dd-MMM-yyyy") + '...!');
    			vm.clicked=false;
       		}
       		else if (vm.limitHeader.id !== null && vm.limitHeader.id!==undefined) {
       			if(validateChange()){
       				if(workflowSharedService.viewFrom == 'customer_limitSettings'){
       					LimitSettings.updateLimitSettingsByCustomer(vm.customerLimit, onCustomerSaveSuccess, onCustomerSaveError);
       				}else{
       					LimitSettings.update(vm.limitHeader, onSaveSuccess, onSaveError);
       				}
       				
       				
       			}else{
       				AlertService.error($filter('translate')('gatewayApp.limitSettings.noChangesMade'));
       				vm.clicked = false;
       			}
        		
             }else {
            	 
            	 LimitSettings.save(vm.limitHeader, onSaveSuccess, onSaveError);           
             }       	
        	
         }
     
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }

        function onSaveError () {
        	//vm. = DateUtils.convertDateTimeFromServer(vm.swapQuotes.holidayDate);

        	vm.clicked = false;
        }
        
        function onCustomerSaveSuccess(result){
        	//$scope.clicked = true;
        	 $uibModalInstance.close(result); 
        	 MessageBox.openMessageBox('Alert', 'The request has been sent for bank approval. You will be notified by email on the request status...!', 'Ok', 'homepage');
        }
        function onCustomerSaveError(error){
        	vm.clicked = false;
        }
        function resubmitLimitSettings() {
        	 prepareLimitDetailsToSaveToDB(vm.selectedInstrument);
        	 prepareDatesforServer();
        	 var comparision = moment(vm.currentDate).isAfter(vm.limitHeader.effectiveToDateTime, 'day');
	       	 
        	if(comparision){
        			AlertService.error($filter('translate')('gatewayApp.limitSettings.invalidaDate'));
        			vm.clicked=false;
        	 }else if(moment(vm.limitHeader.effectiveToDateTime).isAfter(vm.tillDate, 'day')){
    			AlertService.error($filter('translate')('gatewayApp.limitSettings.cannotMoreThanDate') + $filter('date')(vm.tillDate, "dd-MMM-yyyy") + '...!');
    			vm.clicked=false;
       		 }else if(workflowSharedService.viewFrom == 'customer_limitSettings_resubmit'){
        		 LimitSettings.resubmitLimitChangeByCustomer({"taskId" : $rootScope.taskID}, vm.customerLimit, onResubmitSuccess, onResubmitError);
        	 }else{
        		 LimitSettings.resubmit({"taskId" : $rootScope.taskID}, vm.limitHeader, onResubmitSuccess, onResubmitError);
        	 }
        	 
        	
        }
        
        function onResubmitSuccess(result) {
        	$uibModalInstance.close(result); 
        	$rootScope.removeRow($rootScope.taskID);
        	
        }        
        function onResubmitError(error) {
        	vm.clicked = false;
        }
        
        function rejectLimitSettings() { 
        	$rootScope.action = vm.actionType;
        	Workflow.rejectTask($rootScope.taskID); 
        }

        function discardLimitSettings() {
        	LimitSettings.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }

        function approveLimitSettings() {  
    		prepareLimitDetailsToSaveToDB(vm.selectedInstrument);
    		prepareDatesforServer();
        	var comparision = moment(vm.currentDate).isAfter(vm.limitHeader.effectiveToDateTime, 'day');
	       	 
        	if(comparision){
       			AlertService.error($filter('translate')('gatewayApp.limitSettings.invalidaDate'));
       			vm.clicked=false;
       		}else if(moment(vm.limitHeader.effectiveToDateTime).isAfter(vm.tillDate, 'day')){
    			AlertService.error($filter('translate')('gatewayApp.limitSettings.cannotMoreThanDate') + $filter('date')(vm.tillDate, "dd-MMM-yyyy") + '...!');
    			vm.clicked=false;
       		}       	
        	else if(workflowSharedService.viewFrom == 'create_customer_limitSettings_checker'){
        		LimitSettings.approveWihPayload({"taskId" : $rootScope.taskID},vm.customerLimit,onApproveSuccess,onApproveError);         	
        		 
        	}else{
        		LimitSettings.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError); 
        	}
        	 
        }
        
        function onApproveSuccess(result) {        	
        	
        	$rootScope.removeRow($rootScope.taskID); 
        	$uibModalInstance.close(result);  
        }        
        function onApproveError(error) {
        	vm.clicked = false;
        }
        function validateChange(){
        	var changesMade = false;
        	var field1 = checkvalidityOfValues(vm.previousLimit.limitType , vm.limitHeader.limitType);
        	
        	var field2 = false;
        	if(vm.previousLimit.limitCurrency != null && vm.previousLimit.limitCurrency!=undefined && vm.limitHeader.limitCurrency!=null && vm.limitHeader.limitCurrency !=undefined){
        		field2 = checkvalidityOfValues(vm.previousLimit.limitCurrency.code , vm.limitHeader.limitCurrency.code);
        	}
        	var field3 = checkvalidityOfValues(DateUtils.convertLocalDateToServer(vm.previousLimit.effectiveToDateTime ),DateUtils.convertLocalDateToServer( vm.limitHeader.effectiveToDateTime));
        	var field4 =false;
        	var ChangesMAdeInDetail = false;
        	if(vm.previousLimit.limitSettingsDetailsList.length != vm.limitHeader.limitSettingsDetailsList.length){
        		field4 = true;
        	}else{
        		angular.forEach(vm.previousLimit.limitSettingsDetailsList, function(previousDetail){
        			
        			angular.forEach(vm.limitHeader.limitSettingsDetailsList, function(currenDetail){
        				if(previousDetail.instrumentType == null && currenDetail.instrumentType == null){
        					if(checkvalidityOfValues(previousDetail.value,currenDetail.value)){
        						ChangesMAdeInDetail = true;
        					}
        				}
        				else if( ( previousDetail.instrumentType != null && currenDetail.instrumentType == null ) ||  (previousDetail.instrumentType == null && currenDetail.instrumentType != null)){
        					
        						ChangesMAdeInDetail = true;
        					
        				}
        				else if( previousDetail.instrumentType.id==currenDetail.instrumentType.id ){
        					if(checkvalidityOfValues(previousDetail.value,currenDetail.value)){
        						ChangesMAdeInDetail = true;
        					}
        				}
        			});
        			});
        	}
        	
        	var field5 =false;
        	field5 = checkvalidityOfValues(vm.previousLimit.isLimitToBeReinstated , vm.limitHeader.isLimitToBeReinstated);
        	
        	var field6 =false;
        	field6 = checkvalidityOfValues(vm.previousLimit.limitReinstateMethod , vm.limitHeader.limitReinstateMethod);
        	
        	
        	
        	if(field1 || field2 || field3 || field4 || ChangesMAdeInDetail || field5 || field6 ){
        		changesMade = true;
        	}
        	return changesMade;
        }
        function checkvalidityOfValues(previousValue, currentValue){
        	var isValueChanged = (!(previousValue == null && (currentValue == "" || currentValue== null)) && previousValue!=currentValue);
        	return isValueChanged;
        }
        
       
        
        
	}
})();

(function() {
	'use strict';

	angular.module('gatewayApp')

	.controller('CustomerCreateLimitController', CustomerCreateLimitController);

	CustomerCreateLimitController.$inject = [ '$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','LimitSettings', 
		 'ScreenLog','entityConstants', 'AlertService', '$filter', 'Workflow','entity','StaticLookUp','MessageBox', '$stateParams',  'CustomerTradingBankDetails' ];

	function CustomerCreateLimitController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,LimitSettings,
			ScreenLog,entityConstants,AlertService,$filter, Workflow,entity,StaticLookUp,MessageBox,$stateParams,CustomerTradingBankDetails) {
		
		 var vm=this;
		 vm.globalValues = GlobalValues;
         vm.entityConstants = entityConstants;
         vm.screenLog = ScreenLog;
         vm.loggedinEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
         vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
         $scope.showOkButton = false;
         
         if($state.current.name=="create-customer-limit-settings" || $state.current.name=="create-customer-limit-settings-limit-report"){
        	 workflowSharedService.viewFrom="";
         }
         
         
         vm.clear = clear;
         vm.resubmitLimitSettings= resubmitLimitSettings;
        
         vm.discardLimitSettings = discardLimitSettings;
         vm.save=save;
         vm.clicked = false;
        
         vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
         vm.defaultLimitType = 'GLOBALGROSS';
         vm.selectedInstrument = 'all';
         vm.defaultCurrencyCode = 'USD'
         vm.defaultLimitCurrency = null;
         vm.disableSave = false;

        // loadInstrumentType();
         loadCurrency();
         loadLimitTypes();
         loadTradingBankDetails();
         vm.tradingBankDetails = [];
         function loadTradingBankDetails(){
        	 //get trading bank details whos status is not in (suspended, terminated and pendingtradingactivation) 
        	CustomerTradingBankDetails.getValidTradingBankDetails( {'customerId': vm.globalValues.getOrganisation().id }, getTradingBankDetailsSuccess, getTradingBankDetailsFailure)
        	
         }    
         function getTradingBankDetailsSuccess(result){
        	
        	 vm.tradingBankDetails = result;
        	//load default trading bank and branch when new request from menu
 	        if($state.current.name=="create-customer-limit-settings" && $rootScope.defaultTradingBank!=null && $rootScope.defaultTradingBank!=undefined){
 	        	checkForBankAndBranch($rootScope.defaultTradingBank.id) ;
 			}else if($state.current.name=="create-customer-limit-settings-limit-report"){
 				checkForBankAndBranch($stateParams.bankId);
 	        }
         }
         function getTradingBankDetailsFailure(error){
        	 
         }
         function loadCurrency(){
        	 StaticLookUp.getCurrencyLimit(currencySuccess,currencyFailure);
         }
         function currencySuccess(result){
        	vm.currencies = result;
        	angular.forEach(vm.currencies, function(item){
        		if(item.code==vm.defaultCurrencyCode){
           		 	vm.defaultLimitCurrency =item;
           		 	if(	vm.customerLimit.customerLimitRequest.limitCurrency ==null 
           		 			|| 	vm.customerLimit.customerLimitRequest.limitCurrency == undefined
           		 			||  vm.customerLimit.customerLimitRequest.limitCurrency == ''){
           		 		vm.customerLimit.customerLimitRequest.limitCurrency = vm.defaultLimitCurrency;
           		 	}
           		}
           	});
        	
         }
         function currencyFailure(error){
        	 
         }
         function loadLimitTypes(){
        	 StaticLookUp.getLimitType(limitTypeSuccess, limitTypeFailure);
         }
         function limitTypeSuccess(result){
        	 vm.limitTypes = result;
        	 prepareLimitTypeToView();
         }
         function limitTypeFailure(error){
        	 
         }
         
         $scope.$watch('vm.customerLimit.limitSettingsHeader.bank' , function(value){
        	
        	 angular.forEach(vm.tradingBankDetails, function(item){
        		 if(value !=null && value!=undefined && value !=""){
	        		 if(item.bank.id == value.id ){
	        			 vm.customerLimit.limitSettingsHeader.branch = item.tradingBranch;
	        			 
	        		 }
        	 	}
        	 });
         });
         
       /*  $scope.$watch('vm.selectedLimitType' , function(value){
        	 if(vm.limitSettingsHeader!=null && vm.limitSettingsHeader!==undefined){
        		 if(value !=null && value!=undefined)
        			 vm.limitSettingsHeader.limitType = value.shortName;
        		// else if(vm.limitSettingsHeader.limitType=null || vm.limitSettingsHeader.limitType == undefined )
        			// vm.limitSettingsHeader.limitType="";
        	 }
         });
         $scope.$watch('vm.isLimitToBeReinstated' , function(value){
        	 //if(vm.limitSettingsHeader!=null && vm.limitSettingsHeader!==undefined){
        		//alert(value + " " + typeof value);
        		 if(value !=null && value!=undefined && value== vm.NO){
        			 vm.showLimiReinstateType = false;
        			 vm.limitSettingsHeader.isLimitToBeReinstated =false;
        			 vm.limitSettingsHeader.limitReinstateMethod = null;
        		 }else if(value !=null && value!=undefined && value==vm.YES){
        			 vm.showLimiReinstateType = true;
        			 vm.limitSettingsHeader.isLimitToBeReinstated =true;
        			 document.getElementById("reinstateMethodRadio").focus();
        		 }
        	 //}
         });
         $scope.$watch('vm.selectedInstrument', function(value){
        	 if( vm.limitSettingsHeader!=null && vm.limitSettingsHeader!=undefined && value == 'all'){
        		 if( document.getElementById("txtspot")!=undefined &&  document.getElementById("txtspot")!=null){
        			 document.getElementById("txtspot").value = "";
        		 }
        		 if( document.getElementById("txttom")!=undefined &&  document.getElementById("txttom")!=null){
        			 document.getElementById("txttom").value = "";
        		 }
        		 if( document.getElementById("txtcash")!=undefined &&  document.getElementById("txtcash")!=null){
        			 document.getElementById("txtcash").value = "";
        		 }
        		 vm.spotValue=null;
        		 vm.tomValue=null;
        		 vm.cashValue=null;
        	 }else if( vm.limitSettingsHeader!=null && vm.limitSettingsHeader!=undefined && value == 'individual'){
        		 if( document.getElementById("txtall")!=undefined &&  document.getElementById("txtall")!=null){
        		 	document.getElementById("txtall").value = "";
        	 	}
        		 vm.allValue=null;
        	 }
        	 prepareLimitDetailsToSaveToDB(value);
         });
         
         $scope.$watch('vm.allValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.allValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         
         $scope.$watch('vm.spotValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.spotValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         
         $scope.$watch('vm.tomValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.tomValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         
         $scope.$watch('vm.cashValue', function(value){
        	 if(value!=null && value!=undefined){
        		 if(vm.prevClose!=null && vm.prevClose!=undefined){
        			 vm.cashValueInINR = (Math.round(parseFloat(value)*10000) / vm.prevClose) / 10000;
        		 }
        	 }
         });
         */
         function prepareLimitTypeToView(){
        	
        	
        	angular.forEach(vm.limitTypes, function(item){
            		 if(item.shortName == vm.defaultLimitType ){
            			 vm.selectedLimitType = item;
            		 }
            })
        	
         }
         function checkInstrumentValue(instrumentValue){
        	 
        	 if(instrumentValue == "" || instrumentValue == undefined || instrumentValue == null){
        		 return 0.00;
        	 }else{
        		 return instrumentValue;
        	 }
         }
         
         function checkDefaultTradingBranch(giveBankId){
         	var matchFound = false;
        	 angular.forEach(vm.tradingBankDetails, function(item){
        		 if(item.bank.id == giveBankId ){
        			 vm.customerLimit.limitSettingsHeader.branch = item.tradingBranch;
        			 matchFound = true;
        			 
        		 }
        	 });
         }
         
         function checkForBankAndBranch(giveBankId){
          	var matchFound = false;
         	 angular.forEach(vm.tradingBankDetails, function(item){
         		 if(item.bank.id == giveBankId ){
         			 vm.customerLimit.limitSettingsHeader.bank = item.bank;
         			 vm.customerLimit.limitSettingsHeader.branch = item.tradingBranch;
         			 matchFound = true;
         		 }
         	 });
         	 if(!matchFound){ // if no match found from the given trading bank then disable the save button
         		 vm.disableSave = true;
         	 }
          }
      
         function prepareLimitDetailsToSaveToDB(){
        	 if( vm.customerLimit.limitSettingsHeader!=null && vm.customerLimit.limitSettingsHeader!=undefined ){
        		 
        		 vm.customerLimit.limitSettingsHeader.limitSettingsDetailsList=[];
        		 vm.customerLimit.limitSettingsHeader.limitSettingsDetailsList[0]={};
        		 vm.customerLimit.limitSettingsHeader.limitSettingsDetailsList[0].instrumentType=null;
        		 vm.customerLimit.limitSettingsHeader.limitSettingsDetailsList[0].value=checkInstrumentValue( vm.customerLimit.customerLimitRequest.limitAmount);
        		 vm.customerLimit.limitSettingsHeader.limitReinstateMethod = null;
        		 vm.customerLimit.limitSettingsHeader.isLimitToBeReinstated = false;
        		 vm.customerLimit.limitSettingsHeader.userRemarks= vm.customerLimit.customerLimitRequest.userRemarks;
        		 vm.customerLimit.limitSettingsHeader.limitCurrency= vm.customerLimit.customerLimitRequest.limitCurrency;
        		 vm.customerLimit.limitSettingsHeader.limitType = vm.selectedLimitType.shortName;
        		 vm.customerLimit.limitSettingsHeader.effectiveFromDateTime = null;
        		 vm.customerLimit.limitSettingsHeader.effectiveToDateTime = null;
        	 }
         }
         function prepateLimitDetailsToView(){
        	 
        	
        	
         }
         function loadBranch(){
        	 
         }
     
		
		if (workflowSharedService.viewFrom == 'create_customer_limitSettings_maker') {
			
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
			
	   
			prepareLimitTypeToView();
			
			$scope.showButton = false;
			$scope.showResubmitButton = false;		
			$scope.showDiscardButton = true;
			vm.disableForm = true;
			
			enableControls(true,true);
			
			
		} else if (workflowSharedService.viewFrom == 'create_customer_limitSettings_resubmit') {
			
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
			
			
			prepareLimitTypeToView();
			
			vm.screenLog.screenLog(vm.screenName, vm.customerLimit.limitSettingsHeader.id == null ? 0
					: vm.customerLimit.limitSettingsHeader.id,
					entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
			
			vm.disableForm = false;
			$scope.showButton = false;
			$scope.showResubmitButton = true;			
			$scope.showDiscardButton = false;			
			//disable bank
			enableControls(true,false);
			
		} else if (workflowSharedService.viewFrom == 'create_customer_limitSettings_auditLog') {
			
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
			
			   
			prepareLimitTypeToView();
			
			$scope.showButton = false;
			$scope.showResubmitButton = false;		
			$scope.showDiscardButton = false;
			$scope.showOkButton = true;
			vm.disableForm = true;			
			enableControls(true,true);
			
		}		
		else {
			
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			
			vm.customerLimit={}; 
	        vm.customerLimit.limitSettingsHeader = {};
	        vm.customerLimit.customerLimitRequest = {};;	
	        	        	
	        vm.customerLimit.limitSettingsHeader.customer = vm.globalValues.getCustomer();
			prepareLimitTypeToView();
			ScreenLog.screenLog(vm.screenName,0, vm.entityConstants.ENTITY_ACTION_TYPE.CREATE);
						
			$scope.showButton = true;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton = false;
			vm.disableForm = false;
			
			
			if($state.current.name=="create-customer-limit-settings"){
				enableControls(false,false);
			}else{
				//disable bank when request is from limit report
				enableControls(true,false);
			}
			
		} 
	
	
		function enableControls(disableBank , disableValues){
			vm.disableBank = disableBank
			vm.disableBranch = true;
			vm.disableCustomer = true;
			vm.disableLimitType= true;			
			vm.diableFields = disableValues;
		}
		  
		 function clear() {
        	 workflowSharedService.viewFrom="";
             $uibModalInstance.dismiss('cancel');
         }
       
        
        function save () {        	    		
        	
        	prepareLimitDetailsToSaveToDB();     
       		
       		LimitSettings.createLimitSettingsByCustomer(vm.customerLimit, onCustomerSaveSuccess, onCustomerSaveError);
       				
        	
         }
     
              
        function onCustomerSaveSuccess(result){
        	//$scope.clicked = true;
        	 $uibModalInstance.close(result); 
        	 MessageBox.openMessageBox('Alert', 'The request has been sent for bank approval. You will be notified by email on the request status...!', 'Ok', 'homepage');
        }
        function onCustomerSaveError(error){
        	vm.clicked = false;
        }
        function resubmitLimitSettings() {        	
        	prepareLimitDetailsToSaveToDB();     
        	 LimitSettings.resubmitLimitChangeByCustomer({"taskId" : $rootScope.taskID}, vm.customerLimit, onResubmitSuccess, onResubmitError);
        	
        }
        
        function onResubmitSuccess(result) {
        	$uibModalInstance.close(result); 
        	$rootScope.removeRow($rootScope.taskID);
        	
        }        
        function onResubmitError(error) {
        	vm.clicked = false;
        }
        
      

        function discardLimitSettings() {
        	LimitSettings.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }

        
       
       
        
        
	}
})();

(function() {
	'use strict';

	angular.module('gatewayApp')

	.controller('CustomerNewLimitController', CustomerNewLimitController);

	CustomerNewLimitController.$inject = [ '$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','LimitSettings', 
		 'ScreenLog','entityConstants', 'AlertService', '$filter', 'Workflow','entity','StaticLookUp','MessageBox', '$stateParams',  'CustomerTradingBankDetails','DateUtils','DealingAdminApplicationWideSettings'];

	function CustomerNewLimitController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,LimitSettings,
			ScreenLog,entityConstants,AlertService,$filter, Workflow,entity,StaticLookUp,MessageBox,$stateParams,CustomerTradingBankDetails,DateUtils,DealingAdminApplicationWideSettings) {
		
		 var vm=this;
		 vm.globalValues = GlobalValues;
         vm.entityConstants = entityConstants;
         vm.screenLog = ScreenLog;
         vm.loggedinEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
         vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
         $scope.showOkButton = false;
         if($state.current.name=="create-customer-limit-settings" || $state.current.name=="create-customer-limit-settings-limit-report"){
        	 workflowSharedService.viewFrom="";
         }
              var systemSettings = vm.globalValues.getSystemSettings();
         if(systemSettings!=null && systemSettings!=undefined){
        	 var now = moment();
        	 vm.momentBusinessDate = moment(systemSettings.businessDate, 'YYYY-MM-DD');        	
        	 vm.momentBusinessDate.set(
        			 { 	'hour':now.get('hour'),
        				'minute':now.get('minute'),
        				'second':now.get('second')
        				
        			 });
        	 vm.currentDate = vm.momentBusinessDate.toDate();
        	
        	 vm.effectiveToMinimumDate = systemSettings.businessDate;
        	 //vm.tillDate = new Date(vm.currentDate);
        	 //vm.tillDate.setDate(vm.currentDate.getDate() + parseInt(vm.maxLimitPeriod));
         }
         // set maximum limit period 
        DealingAdminApplicationWideSettings.getConfigValueForConfigName({configName: 'MaximumLimitPeriod'}, function(result){
            vm.maxLimitPeriod = result.value;
            vm.tillDate = new Date(vm.currentDate);
            vm.tillDate.setDate(vm.currentDate.getDate() + parseInt(vm.maxLimitPeriod));
            })
         
         vm.clear = clear;
         vm.resubmitLimitSettings= resubmitLimitSettings;
        
         vm.discardLimitSettings = discardLimitSettings;
         vm.save=save;
         vm.clicked = false;
        
         vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
         vm.defaultLimitType = 'GLOBALGROSS';
         vm.selectedInstrument = 'all';
         vm.defaultCurrencyCode = 'USD'
         vm.defaultLimitCurrency = null;
         vm.disableSave = false;
         vm.onChangeLimitInstrumentGroup =onChangeLimitInstrumentGroup;
         vm.showLimitInfo = false;
        // loadInstrumentType();
        
       
        
         loadCurrency();
         loadLimitTypes();
         loadTradingBankDetails();
         loadLimitInstrumentGroup();
         loadLimitReinstateType();
         loadLimitTenorType();
         loadInstrumentTypes();
         loadDefaultEffectiveToDatesFromConfig();
       
         vm.tradingBankDetails = [];
         function loadTradingBankDetails(){
        	 //get trading bank details whos status is not in (suspended, terminated and pendingtradingactivation) 
        	CustomerTradingBankDetails.getValidTradingBankDetails( {'customerId': vm.globalValues.getOrganisation().id }, getTradingBankDetailsSuccess, getTradingBankDetailsFailure)
        	
         }    
         function getTradingBankDetailsSuccess(result){
        	
        	 vm.tradingBankDetails = result;
        	//load default trading bank and branch when new request from menu
 	        if($state.current.name=="create-customer-limit-settings" && $rootScope.defaultTradingBank!=null && $rootScope.defaultTradingBank!=undefined){
 	        	checkForBankAndBranch($rootScope.defaultTradingBank.id) ;
 			}else if($state.current.name=="create-customer-limit-settings-limit-report"){
 				checkForBankAndBranch($stateParams.bankId);
 	        }
         }
         function getTradingBankDetailsFailure(error){
        	 
         }
         function loadCurrency(){
        	 StaticLookUp.getCurrencyLimit(currencySuccess,currencyFailure);
         }
         function currencySuccess(result){
        	vm.currencies = result;
        	angular.forEach(vm.currencies, function(item){
        		if(item.code==vm.defaultCurrencyCode){
           		 	vm.defaultLimitCurrency =item;
           		 	if(	vm.customerLimit.customerLimitRequest.limitCurrency ==null 
           		 			|| 	vm.customerLimit.customerLimitRequest.limitCurrency == undefined
           		 			||  vm.customerLimit.customerLimitRequest.limitCurrency == ''){
           		 		vm.customerLimit.customerLimitRequest.limitCurrency = vm.defaultLimitCurrency;
           		 	}
           		}
           	});
        	
         }
         function currencyFailure(error){
        	 
         }
         function loadLimitTypes(){
        	 StaticLookUp.getLimitType(limitTypeSuccess, limitTypeFailure);
         }
         function limitTypeSuccess(result){
        	 vm.limitTypes = result;
        	 prepareLimitTypeToView();
         }
         function limitTypeFailure(error){
        	 
         }

         
         function loadLimitInstrumentGroup(){
             StaticLookUp.getLimitInstrumentGroupList(onGetLimitInstrumentGroupSuccess, onGetLimitInstrumentGroupFailure);
         }

         function onGetLimitInstrumentGroupSuccess(result){
             vm.limitInstrumentGroupList = result;
            
             if(result!=null && result.length>0 && $state.current.name=="create-customer-limit-settings"){
            	 var defaultLimitForCreateCustomer = {};
            	 angular.forEach(result, function(item){
            		 if(item.shortName == 'ALL'){
            			 defaultLimitForCreateCustomer = item;
            		 }
            	 })
                vm.limitInstrumentGroup = defaultLimitForCreateCustomer;
                if(vm.customerLimit.limitSettingsHeader!=null && vm.customerLimit.limitSettingsHeader!=undefined){
                    vm.customerLimit.limitSettingsHeader.limitInstrumentGroup = vm.limitInstrumentGroup;
                }
             }else if(workflowSharedService.viewFrom == 'create_customer_limitSettings_maker'||workflowSharedService.viewFrom == 'create_customer_limitSettings_resubmit' || workflowSharedService.viewFrom == 'create_customer_limitSettings_auditLog'){
                if(vm.customerLimit.limitSettingsHeader.effectiveToDateTime!=null && vm.customerLimit.limitSettingsHeader.limitInstrumentGroup!=null){
                    vm.effectiveToDate =  DateUtils.convertDateTimeFromServer(vm.customerLimit.limitSettingsHeader.effectiveToDateTime);
                    vm.customerLimit.limitSettingsHeader.limitInstrumentGroup = angular.copy(vm.customerLimit.limitSettingsHeader.limitInstrumentGroup);
                }else{
                    setLimitInstrumentGroupForGivenInstrument(vm.customerLimit.limitSettingsHeader.limitInstrumentGroup.shortName);
                }

               
             }
             else{
                setLimitInstrumentGroupForGivenInstrument($stateParams.instrumentCode);
             }
                
             }
         

         function onGetLimitInstrumentGroupFailure(){

         }
         

         function setLimitInstrumentGroupForGivenInstrument(instrumentCode){
            var limitInstrumentGroup = ""
            if(instrumentCode=='ALL'){
                limitInstrumentGroup = 'ALL';

            }else if(instrumentCode=='Forward'){
                limitInstrumentGroup = 'FORWARD';
            }else /* if(instrumentCode=='CASh' || instrumentCode=='TOM'|| instrumentCode=='SPOT') */{
                limitInstrumentGroup = 'SPOTWINDOW';

            }
            angular.forEach(vm.limitInstrumentGroupList, function(value){
                if(value.shortName==limitInstrumentGroup){
                    vm.limitInstrumentGroup = value;
                }
            })

            if(vm.customerLimit.limitSettingsHeader!=null && vm.customerLimit.limitSettingsHeader!=undefined){
                vm.customerLimit.limitSettingsHeader.limitInstrumentGroup = vm.limitInstrumentGroup;
            }
         }

        

        // vm.onChangeLimitInstrumentGroup = function onChangeLimitInstrumentGroup(value){
        //     if(value!=null && value!=undefined){
        //         if(vm.customerLimit.limitSettingsHeader!=null && vm.customerLimit.limitSettingsHeader!=undefined){
        //             vm.customerLimit.limitSettingsHeader.limitInstrumentGroup = value;
        //         }
        //     }
        // }

        function loadLimitReinstateType(){
            StaticLookUp.getLimitReinstateTypeList(onGetLimitReinstateTypeSuccess, onGetLimitReinstateTypeFailure);
        }

        function onGetLimitReinstateTypeSuccess(result){
            vm.limitReinstateTypeList = result;
            if(result!=null && result.length>0){
               vm.limitReinstateType = result[0];
            }
            if(vm.customerLimit.limitSettingsHeader!=null && vm.customerLimit.limitSettingsHeader!=undefined){
                vm.customerLimit.limitSettingsHeader.limitReinstateType = vm.limitReinstateType;
            }
        }

        function onGetLimitReinstateTypeFailure(){

        }

        function loadLimitTenorType(){
            StaticLookUp.getLimitTenorTypeList(onGetLimitTenorTypeSuccess, onGetLimitTenorTypeFailure);
        }

        function onGetLimitTenorTypeSuccess(result){
            vm.limitTenorTypeList = result;
            if(result!=null && result.length>0){
               vm.limitTenorType = result[0];
            }
            if(vm.customerLimit.limitSettingsHeader!=null && vm.customerLimit.limitSettingsHeader!=undefined){
                vm.customerLimit.limitSettingsHeader.limitTenorType = vm.limitTenorType;
            }
        }

        function onGetLimitTenorTypeFailure(){

        }

        function loadInstrumentTypes(){
            StaticLookUp.getInstrumentType(onGetInstrumentSuccess, onGetInstrumentFailure);
        }

        function onGetInstrumentSuccess(result){
            vm.instrumentTypes = result;
        }

        function onGetInstrumentFailure(){

        }
     
       
        function loadDefaultEffectiveToDatesFromConfig(){
            //get default effective to date for forward or all window
          LimitSettings.getDefaultEffectiveToDateForForward(function(result){
           vm.effecitveToDateForForwards = DateUtils.convertDateTimeFromServer(result.effectiveToDate);
           //get default effective to date for spotwindo
           LimitSettings.getDefaultEffectiveToDate(function(result){
            vm.effecitveToDateForSpotWindow = DateUtils.convertDateTimeFromServer(result.effectiveToDate);
         setEffectiveToDateFromGivenInstrument(vm.customerLimit.limitSettingsHeader.limitInstrumentGroup.shortName);
        })
       })     
       }
       
       function loadDefaultEffectiveToDate(){
           vm.effectiveToDate = angular.copy(vm.effecitveToDateForForwards);
          
       }
       function loadSpotwindowSetEffectivetodate(){
        vm.effectiveToDate = angular.copy(vm.effecitveToDateForSpotWindow);
    }
       // set effective to date from given instrument group
       function setEffectiveToDateFromGivenInstrument(instrumentCode){
       if($state.current.name=="create-customer-limit-settings"){
        loadDefaultEffectiveToDate();
       }else if(workflowSharedService.viewFrom == 'create_customer_limitSettings_maker'||workflowSharedService.viewFrom == 'create_customer_limitSettings_resubmit' || workflowSharedService.viewFrom == 'create_customer_limitSettings_auditLog'){
        if(vm.customerLimit.limitSettingsHeader.effectiveToDateTime!=null){
            vm.effectiveToDate =  DateUtils.convertDateTimeFromServer(vm.customerLimit.limitSettingsHeader.effectiveToDateTime);
        }
       }
       else if(instrumentCode=='ALL'){
            loadDefaultEffectiveToDate();

        }else if(instrumentCode=='FORWARD'){
            loadDefaultEffectiveToDate();

        }else{
            loadSpotwindowSetEffectivetodate();

        }
     }

         $scope.$watch('vm.customerLimit.limitSettingsHeader.bank' , function(value){
        	 angular.forEach(vm.tradingBankDetails, function(item){
        		 if(value !=null && value!=undefined && value !=""){
	        		 if(item.bank.id == value.id ){
	        			 vm.customerLimit.limitSettingsHeader.branch = item.tradingBranch;
	        			 
	        		 }
        	 	}
        	 });
         });
         function prepareLimitInfoConent(value) {
			if(value!=null){
				vm.showLimitInfo=true;
				if(value=='GROSSBUY'){
					vm.limitTypeInfo = "Limit available to Buy only";
				}else if(value=='GROSSSELL'){
					vm.limitTypeInfo = "Limit available to Sell only";
				}else if(value=='GLOBALGROSS'){
					vm.limitTypeInfo = "TOTAL  limit available to both  Buy and Sell";
				}else{
					vm.limitTypeInfo = "NET limit available to both Buy and Sell";
				}
			}
			
		}
       
         function prepareLimitTypeToView(){
        	
        	
        	angular.forEach(vm.limitTypes, function(item){
            		 if(item.shortName == vm.defaultLimitType ){
            			 vm.selectedLimitType = item;
            		 }
                     prepareLimitInfoConent(value.shortName);
            })
        	
         }
         function checkInstrumentValue(instrumentValue){
        	 
        	 if(instrumentValue == "" || instrumentValue == undefined || instrumentValue == null){
        		 return 0.00;
        	 }else{
        		 return instrumentValue;
        	 }
         }
         
         function checkDefaultTradingBranch(giveBankId){
         	var matchFound = false;
        	 angular.forEach(vm.tradingBankDetails, function(item){
        		 if(item.bank.id == giveBankId ){
        			 vm.customerLimit.limitSettingsHeader.branch = item.tradingBranch;
        			 matchFound = true;
        			 
        		 }
        	 });
         }
         
         function checkForBankAndBranch(giveBankId){
          	var matchFound = false;
         	 angular.forEach(vm.tradingBankDetails, function(item){
         		 if(item.bank.id == giveBankId ){
         			 vm.customerLimit.limitSettingsHeader.bank = item.bank;
         			 vm.customerLimit.limitSettingsHeader.branch = item.tradingBranch;
         			 matchFound = true;
         		 }
         	 });
         	 if(!matchFound){ // if no match found from the given trading bank then disable the save button
         		 vm.disableSave = true;
         	 }
          }
      
         function prepareLimitDetailsToSaveToDB(){
        	 if( vm.customerLimit.limitSettingsHeader!=null && vm.customerLimit.limitSettingsHeader!=undefined ){
        		 
        		 vm.customerLimit.limitSettingsHeader.limitSettingsDetailsList=[];
        		 vm.customerLimit.limitSettingsHeader.limitSettingsDetailsList[0]={};
        		 vm.customerLimit.limitSettingsHeader.limitSettingsDetailsList[0].instrumentType=checkAndSetInstrumentType();
        		 vm.customerLimit.limitSettingsHeader.limitSettingsDetailsList[0].value=checkInstrumentValue( vm.customerLimit.customerLimitRequest.limitAmount);
        		 vm.customerLimit.limitSettingsHeader.limitReinstateMethod = null;
        		 vm.customerLimit.limitSettingsHeader.isLimitToBeReinstated = false;
        		 vm.customerLimit.limitSettingsHeader.userRemarks= vm.customerLimit.customerLimitRequest.userRemarks;
                 vm.customerLimit.limitSettingsHeader.customerRemarks= vm.customerLimit.customerLimitRequest.customerRemarks;
        		 vm.customerLimit.limitSettingsHeader.limitCurrency= vm.customerLimit.customerLimitRequest.limitCurrency;
        		 vm.customerLimit.limitSettingsHeader.limitType = vm.selectedLimitType.shortName;
        		 vm.customerLimit.limitSettingsHeader.effectiveFromDateTime = null;
        		 vm.customerLimit.limitSettingsHeader.effectiveToDateTime = vm.effectiveToDate;
        	 }
         }

         function checkAndSetInstrumentType(){
            var instrumentType = null;
            if(vm.limitInstrumentGroup.shortName=='SPOTWINDOW'){
                var uptoSpotInstrumentType = $filter('filter')(vm.instrumentTypes, {shortName: 'UptoSPOT'});
                instrumentType = uptoSpotInstrumentType[0];
            }else if(vm.limitInstrumentGroup.shortName=='FORWARD'){
                var forwardInstrumentType = $filter('filter')(vm.instrumentTypes, {shortName: 'Forward'});
                instrumentType= forwardInstrumentType[0];
            }
            return instrumentType;
         }

         function prepateLimitDetailsToView(){
        	 
        	
        	
         }
         function loadBranch(){
        	 
         }
     
		
		if (workflowSharedService.viewFrom == 'create_customer_limitSettings_maker') {
			
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
			vm.effectiveToDate = angular.copy(vm.customerLimit.limitSettingsHeader.effectiveToDateTime);
	   
			prepareLimitTypeToView();
			
			$scope.showButton = false;
			$scope.showResubmitButton = false;		
			$scope.showDiscardButton = true;
			vm.disableForm = false;
			
			enableControls(true,true,true,true,true);
			
			
		} else if (workflowSharedService.viewFrom == 'create_customer_limitSettings_resubmit') {
			
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));


			 vm.limitInstrumentGroup=vm.customerLimit.limitSettingsHeader.limitInstrumentGroup;
			prepareLimitTypeToView();
             
			vm.screenLog.screenLog(vm.screenName, vm.customerLimit.limitSettingsHeader.id == null ? 0
					: vm.customerLimit.limitSettingsHeader.id,
				     entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);

			vm.disableForm = false;
			$scope.showButton = false;
			$scope.showResubmitButton = true;			
			$scope.showDiscardButton = false;			
			//disable bank
			enableControls(true,false,false,false,false);
			
		} else if (workflowSharedService.viewFrom == 'create_customer_limitSettings_auditLog') {
			
			vm.customerLimit  = angular.fromJson(angular.copy($rootScope.payload));
			vm.limitInstrumentGroup=vm.customerLimit.limitSettingsHeader.limitInstrumentGroup;
			   
			prepareLimitTypeToView();
			
			$scope.showButton = false;
			$scope.showResubmitButton = false;		
			$scope.showDiscardButton = false;
			$scope.showOkButton = true;
			vm.disableForm = false;			
			enableControls(true,true,true,true,true);
			
		}		
		else {
			
			vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMERLIMITSETTINGS;
			
			vm.customerLimit={}; 
	        vm.customerLimit.limitSettingsHeader = {};
	        vm.customerLimit.customerLimitRequest = {};;	
	        	        	
	        vm.customerLimit.limitSettingsHeader.customer = vm.globalValues.getCustomer();
			prepareLimitTypeToView();
			ScreenLog.screenLog(vm.screenName,0, vm.entityConstants.ENTITY_ACTION_TYPE.CREATE);
						
			$scope.showButton = true;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton = false;
			vm.disableForm = false;
			
			
			if($state.current.name=="create-customer-limit-settings"){
				enableControls(false,false,false,false,false);
			}else{
				//disable bank when request is from limit report
				enableControls(true,false,false,false,false);
			}
			
		} 


		function enableControls(disableBank , disableValues,disableLimitType,disableEffectiveToDate,disableInstrumentGroupField){
			vm.disableBank = disableBank
			vm.disableBranch = true;
			vm.disableCustomer = true;
			vm.disableLimitType= disableLimitType;	
          	vm.diableFields = disableValues;
            vm.disableEffectiveToDate = disableEffectiveToDate;
            vm.disableInstrumentGroupField=disableInstrumentGroupField;
		}
		  
		 function clear() {
        	 workflowSharedService.viewFrom="";
             $uibModalInstance.dismiss('cancel');
         }
    
 	
        function prepareDatesforServer(){
           // vm.customerLimit.effectiveFromDateTime = vm.effectiveFromDate;
           vm.customerLimit.limitSettingsHeader.effectiveToDateTime = new Date(vm.effectiveToDate);
           vm.customerLimit.limitSettingsHeader.effectiveToDateTime.setHours(23);
           vm.customerLimit.limitSettingsHeader.effectiveToDateTime.setMinutes(59);
           vm.customerLimit.limitSettingsHeader.effectiveToDateTime.setSeconds(59);
        }	



        
        function save () {  
            prepareLimitDetailsToSaveToDB();   
            prepareDatesforServer();    	    		
       		
        	
            var comparision = moment(vm.currentDate).isAfter( vm.customerLimit.limitSettingsHeader.effectiveToDateTime, 'day');
            if(comparision){
                AlertService.error($filter('translate')('gatewayApp.limitSettings.invalidaDate'));
                vm.clicked=false;
            }else if(moment( vm.customerLimit.limitSettingsHeader.effectiveToDateTime).isAfter(vm.tillDate, 'day')){
             AlertService.error($filter('translate')('gatewayApp.limitSettings.cannotMoreThanDate') + $filter('date')(vm.tillDate, "dd-MMM-yyyy") + '...!');
             vm.clicked=false

             
            }else{ 
                LimitSettings.createLimitSettingsByCustomer(vm.customerLimit, onCustomerSaveSuccess, onCustomerSaveError);
            
            }		
        	
         }
     
              
        function onCustomerSaveSuccess(result){
        	//$scope.clicked = true;
        	 $uibModalInstance.close(result); 
        	 MessageBox.openMessageBox('Alert', 'The request has been sent for bank approval. You will be notified by email on the request status...!', 'Ok', 'homepage');
        }
        function onCustomerSaveError(error){
        	vm.clicked = false;
        }
        function resubmitLimitSettings() {  
            prepareLimitDetailsToSaveToDB();
            prepareDatesforServer();        	
         
            var comparision = moment(vm.currentDate).isAfter(vm.customerLimit.limitSettingsHeader.effectiveToDateTime, 'day');
            if(comparision){
                AlertService.error($filter('translate')('gatewayApp.limitSettings.invalidaDate'));
                vm.clicked=false;
            }else if(moment(vm.customerLimit.limitSettingsHeader.effectiveToDateTime).isAfter(vm.tillDate, 'day')){
             AlertService.error($filter('translate')('gatewayApp.limitSettings.cannotMoreThanDate') + $filter('date')(vm.tillDate, "dd-MMM-yyyy") + '...!');
             vm.clicked=false

             
            }else{  
        	 LimitSettings.resubmitLimitChangeByCustomer({"taskId" : $rootScope.taskID}, vm.customerLimit, onResubmitSuccess, onResubmitError);
            }
        }
        
        function onResubmitSuccess(result) {
        	$uibModalInstance.close(result); 
        	$rootScope.removeRow($rootScope.taskID);
        	
        }        
        function onResubmitError(error) {
        	vm.clicked = false;
        }
        
      

        function discardLimitSettings() {
        	LimitSettings.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }
 

        function onChangeLimitInstrumentGroup(value){
			if(value!=null && value!=undefined){
                
                if(vm.customerLimit.limitSettingsHeader!=null && vm.customerLimit.limitSettingsHeader!=undefined){
                                vm.customerLimit.limitSettingsHeader.limitInstrumentGroup = value;
                                vm.limitInstrumentGroup = value;
                
				setFieldValues("txtspot", "");
				setFieldValues("txtcash", "");
				setFieldValues("txttom", "");
				setFieldValues("txtforward", "");
				setFieldValues("txtuptospot", "");
				setFieldValues("txtall", "");
				setFieldValues("txtMaxTenorValue", "");

				if(value.shortName=='SPOTWINDOW'){
					vm.selectedInstrument = 'individual';
					vm.effectiveToDate = angular.copy(vm.effecitveToDateForSpotWindow);
				}else{
					vm.effectiveToDate = angular.copy(vm.effecitveToDateForForwards);
				}

			}
		}
    }
    function setFieldValues(fieldName, value){
        if( document.getElementById(fieldName) !=null && document.getElementById(fieldName)!= undefined){
            document.getElementById(fieldName).value = value;
        }
    }
      
        
        
	}
})();

(function () {
	'use strict';

	angular.module('gatewayApp').controller('HomeBranchDialogController',
		HomeBranchDialogController);

	HomeBranchDialogController.$inject = ['$scope', '$state', '$rootScope',
		'GlobalValues', 'workflowSharedService', '$uibModalInstance',
		'ManageHomeBranch', 'entity', 'DateUtils', 'AlertService', '$filter', 'StaticLookUp', 'BankRegistration'];

	function HomeBranchDialogController($scope, $state, $rootScope, GlobalValues,
		workflowSharedService, $uibModalInstance, ManageHomeBranch, entity, DateUtils, AlertService, $filter, StaticLookUp, BankRegistration) {
		var vm = this;
		vm.homeBranch = entity;
		vm.homeBranchDetailsDTO = {};
		//vm.ifscOrSwift = 'IFSC';
		vm.numberOfDigits = 11;
		//vm.openSearchHomeBranch = openSearchBranch;
		vm.ExpandOrCollapseBankDetails = true;
		vm.clear = clear;
		vm.save = save;
		vm.clicked = false;
		$scope.showButton = false;
		vm.resubmitHomeBranch = resubmitHomeBranch;
		vm.globalValues = GlobalValues;
		//vm.branch.country=vm.globalValues.getCountry();
		vm.todayDate = new Date();
		vm.valid = true;
		vm.bank = null;
		vm.stateName = null;
		vm.disablemode = false;
		vm.errorText = null;
		// vm.isEditMode = !!(vm.homeBranch && vm.homeBranch.id);
		vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;

		if (workflowSharedService.viewFrom == 'homeBranch') {
			vm.homeBranch = entity;
			if (vm.homeBranch != null && vm.homeBranch.id != null) {
				setBankValue();
				vm.homeBranchCounty = vm.globalValues.getCountry();
				// setStateValue();
				//do nothing
			} else {
				vm.homeBranchCounty = vm.globalValues.getCountry();
			}
			vm.homeBranch.bank = vm.globalValues.getBank();
			if(vm.homeBranch.bank != null && vm.homeBranch.bankName != null){
			preparDeliveryModeDTOList(vm.homeBranch);
			}
			$scope.showButton = false;
		} else if (workflowSharedService.viewFrom == 'homebranchtodolist_resubmit') {
			// 	vm.homeBranchDTO = angular.fromJson($rootScope.payload);
			vm.homeBranchDetailsDTO = angular.fromJson($rootScope.payload);
			if (vm.homeBranch == undefined) {
				vm.homeBranch = vm.homeBranchDetailsDTO
			}
			setBankValue();
			setStateValue();
			preparDeliveryModeDTOList(vm.homeBranch);
			vm.homeBranchCounty = vm.globalValues.getCountry();
			vm.disableForm = false;
			vm.disablemode = true;
			$scope.showButton = true;
		} else if (workflowSharedService.viewFrom == 'home_branch_resubmit_delete') {
			vm.homeBranch = angular.fromJson($rootScope.payload);
			setBankValue();
			setStateValue();
			preparDeliveryModeDTOList(vm.homeBranch);
			vm.disableForm = true;
			$scope.showButton = true;
		}

		function convertBooleanToYesNo(value) {
			if (value || value == false) return value;
			return value == 'yes' ? true : (value == 'no' ? false : null);
		}



		function validateEmail(email) {
			var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
			return re.test(email);
		}

		function testEmailValidation(email) {

			if (vm.homeBranch.homeBranchEmailId != null && vm.homeBranch.homeBranchEmailId != undefined && vm.homeBranch.homeBranchEmailId != '') {
				var emails = email.split(';');

				vm.invalidEmails = [];

				for (var i = 0; i < emails.length; i++) {
					if (!validateEmail(emails[i].trim())) {
						vm.invalidEmails.push(emails[i].trim())
					}
				}

				if (vm.invalidEmails.length > 0) {

					vm.valid = false;
				} else {
					vm.valid = true;
				}

			}
			else {
				vm.valid = true;
			}
		}
		function setBankValue() {
			if (vm.homeBranch.bankName != null) {
				BankRegistration.getBankForShortName({ bankName: vm.homeBranch.bankName }, function (result) {
					vm.bank = result;
					vm.homeBranch.bank = result;
				});
			}
		}
		function setStateValue() {

			if (vm.homeBranch.state != null) {
				StaticLookUp.getStateobject({ stateName: vm.homeBranch.state }, function (result) {
					vm.homeBranch.stateObject = result;
				})
			}
		}
		function clear() {
			$uibModalInstance.dismiss('cancel');
		}
		function save() {
			vm.homeBranch.aliasName = vm.homeBranch.bankName;
			vm.homeBranch.shortName = vm.homeBranch.bankName;
			vm.homeBranch.bankName = vm.homeBranch.bank.bankName;
			if (vm.bank != null) {
				vm.homeBranch.bankName = vm.bank.bankName;
			}
			if (vm.homeBranch.stateObject != null) {
				vm.homeBranch.state = vm.homeBranch.stateObject.shortName;
			}
			setDeliveryMode();
			vm.homeBranchDetailsDTO = vm.homeBranch;

			testEmailValidation(vm.homeBranch.homeBranchEmailId);
			if (vm.valid == true) {
				if (vm.homeBranch.id !== null) {
					ManageHomeBranch.update({
						"corpId": GlobalValues.getCorpId()
					}, vm.homeBranch, onSaveSuccess, onSaveError);
				} else if (vm.valid == true) {
					ManageHomeBranch.save({
						"corpId": GlobalValues.getCorpId()
					}, vm.homeBranchDetailsDTO, onSaveSuccess, onSaveError);
				}
			} else {
				var error = $filter('translate')('gatewayApp.homeBranch.invalidEmail');
				AlertService.error(error + vm.invalidEmails);
				vm.clicked = false;
				//AlertService.error($filter('translate')('gatewayApp.emailSettings.invalidEmail'),invalidEmails);
			}

		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
			vm.clicked = false;
		}

		function onSaveError() {
			vm.clicked = false;
		}



		function resubmitHomeBranch() {


			vm.homeBranch.aliasName = vm.homeBranch.bankName;
			vm.homeBranch.shortName = vm.homeBranch.bankName;
			vm.homeBranch.bankName = vm.homeBranch.bank.bankName;
			if (vm.bank != null) {
				vm.homeBranch.bankName = vm.bank.bankName;
			}
			if (vm.homeBranch.stateObject != null) {
				vm.homeBranch.state = vm.homeBranch.stateObject.shortName;
			}
			setDeliveryMode();
			vm.homeBranchDetailsDTO = vm.homeBranch;

			testEmailValidation(vm.homeBranch.homeBranchEmailId);
			if (vm.valid == true) {
				if (vm.homeBranch.id == null) {
					ManageHomeBranch.resubmitForCreate({
						"taskId": $rootScope.taskID
					}, vm.homeBranchDetailsDTO, onResubmitSuccess, onResubmitError);
				} else {
					ManageHomeBranch.resubmitForEdit({
						"taskId": $rootScope.taskID
					}, vm.homeBranch, onResubmitSuccess, onResubmitError);
				}
			} else {
				var error = $filter('translate')('gatewayApp.homeBranch.invalidEmail');
				AlertService.error(error + vm.invalidEmails);
				//AlertService.error($filter('translate')('gatewayApp.emailSettings.invalidEmail'),invalidEmails);
				vm.clicked = false;
			}

		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.dismiss('cancel');
		}
		function onResubmitError(error) {
			vm.clicked = false;
		}


		function preparDeliveryModeDTOList(homeBranch) {
			if(vm.homeBranch.bankName != null && vm.homeBranch.bankName !=undefined){
			getCurrencyPairList(vm.homeBranch.bankName);
			}else{
				getCurrencyPairList(vm.homeBranch.bank.bankName);
			}
			
			prepardeliveryModeIsEnable(homeBranch);
			vm.forexCardLoad = homeBranch.forexCardLoad ? homeBranch.forexCardLoad.split(",") : [];
			vm.currencyNotes = homeBranch.currencyNotes ? homeBranch.currencyNotes.split(",") : [];
			vm.remittance = homeBranch.remittance ? homeBranch.remittance.split(",") : [];
			vm.forexCardIssuance = homeBranch.forexCardIssuance ? homeBranch.forexCardIssuance.split(",") : [];
		}

		function preparDeliveryModeList(currencyPairList, deliveryMode) {

			var deliveryModeMap = {};

			angular.forEach(deliveryMode, function (code) {
				deliveryModeMap[code] = true;
			});

			return currencyPairList.map(function (item) {
				return {
					CurrencyCode: item.baseCurrency.code,
					isEnable: !!deliveryModeMap[item.baseCurrency.code]
				};
			});
		}



		function getCurrencyPairList(bankName) {

			StaticLookUp.getCurrencyPairBankName({ "bankName": bankName }, getCurrencyPairSuccess, getCurrencyPairError);
		}

		function getCurrencyPairSuccess(result) {
			vm.currencyPairList = result

			vm.forexCardLoadList = preparDeliveryModeList(vm.currencyPairList, vm.forexCardLoad);
			vm.currencyNoteList = preparDeliveryModeList(vm.currencyPairList, vm.currencyNotes);
			vm.remittanceList = preparDeliveryModeList(vm.currencyPairList, vm.remittance);
			vm.forexCardIssuanceList = preparDeliveryModeList(vm.currencyPairList, vm.forexCardIssuance);
		}
		function getCurrencyPairError() { }

		function setDeliveryMode() {
			vm.homeBranch.currencyNotes = convertDeliveryModeToString(vm.currencyNoteList,vm.homeBranch.currencyNotesIsEnable);
			vm.homeBranch.forexCardLoad = convertDeliveryModeToString(vm.forexCardLoadList,vm.homeBranch.forexCardLoadIsEnable);
			vm.homeBranch.remittance = convertDeliveryModeToString(vm.remittanceList,vm.homeBranch.remittanceIsEnable);
			vm.homeBranch.forexCardIssuance = convertDeliveryModeToString(vm.forexCardIssuanceList,vm.homeBranch.forexCardIssuanceIsEnable);
		}


		function convertDeliveryModeToString(deliveryModeList,deliveryModeIsEnable) {
			var currency = "";
			angular.forEach(deliveryModeList, function (item) {
				if(deliveryModeIsEnable){
				if (item.isEnable) {
					if (currency) {
						currency += ",";
					}
					currency += item.CurrencyCode;
				}
			}
			});
			return currency;
		}

		function prepardeliveryModeIsEnable(homeBranch) {
			vm.homeBranch.currencyNotesIsEnable = homeBranch.currencyNotes != null && homeBranch.currencyNotes !='';
			vm.homeBranch.forexCardLoadIsEnable = homeBranch.forexCardLoad != null && homeBranch.forexCardLoad !='';
			vm.homeBranch.remittanceIsEnable = homeBranch.remittance != null && homeBranch.remittance !='';
			vm.homeBranch.forexCardIssuanceIsEnable = homeBranch.forexCardIssuance != null && homeBranch.forexCardIssuance !='';
			
		}

		$scope.$watch('vm.homeBranch.bank', function(value){
        	if(value!=null && value!=undefined){
			vm.homeBranch.bankName = value.bankName;
			 vm.errorText = null;
 			preparDeliveryModeDTOList(vm.homeBranch)
        	}else{
				vm.homeBranch.bankName=null;
				vm.homeBranch.currencyNotesIsEnable=null;
				vm.homeBranch.forexCardLoadIsEnable=null;
				vm.homeBranch.remittanceIsEnable =null;
				vm.homeBranch.forexCardIssuanceIsEnable=null;
			}
        })	

		 $scope.$watchGroup(['vm.homeBranch.currencyNotesIsEnable', 'vm.homeBranch.forexCardLoadIsEnable', 'vm.homeBranch.remittanceIsEnable', 'vm.homeBranch.forexCardIssuanceIsEnable'], function (value) {
			if(vm.homeBranch.bankName == null || vm.homeBranch.bankName == undefined){	
				vm.errorText ='kindly select the bank';
			} else{
				vm.errorText = null;
			}


			})

	}
})();

(function() {
	'use strict';

	angular.module('gatewayApp').controller('HomeBranchViewController',
        HomeBranchViewController);

            HomeBranchViewController.$inject = [ '$scope', '$state', '$rootScope',
			'workflowSharedService', '$uibModalInstance', 'ManageHomeBranch', 'entity',
			'Workflow', 'GlobalValues','StaticLookUp','BankRegistration'];

	function HomeBranchViewController($scope, $state, $rootScope,
			workflowSharedService, $uibModalInstance, ManageHomeBranch, entity, Workflow,
			GlobalValues,StaticLookUp,BankRegistration) {
		var vm = this;
		vm.clear = clear;
		vm.approveHomeBranch = approveHomeBranch;
		vm.rejectHomeBranch = rejectHomeBranch;
		vm.discardHomeBranch = discardHomeBranch;
		$scope.showButton = false;
		$scope.showDiscardButton = false;
		vm.clicked = false;
		vm.ExpandOrCollapseUser1 = false;
		vm.ExpandOrCollapseUser2 = false;
		vm.ExpandOrCollapseBankDetails = true;
		vm.globalValues = GlobalValues;
		vm.homeBranchDetailsDTO = {};
		vm.isDefaultUsersRequired1 = false;
		vm.isDefaultUsersRequired2 = false;
        vm.bankValue=null;
        vm.bank=null;
        vm.homeBranchCountyValue=null;
        vm.state=null;

		if (workflowSharedService.viewFrom == 'homeBranch') {
			vm.homeBranch = entity;
            if(vm.homeBranch.bankName !=null && vm.homeBranch.bankName !=undefined){
                vm.homeBranch.bank = vm.globalValues.getBank();
                setBankValue();
                setStateValue();
				preparDeliveryModeDTOList(vm.homeBranch);

            }
			vm.homeBranch.currencyNotes = convertBooleanToYesNo(vm.homeBranch.currencyNotes)
			vm.homeBranch.forexCardLoad = convertBooleanToYesNo(vm.homeBranch.forexCardLoad)
			vm.homeBranch.remittance = convertBooleanToYesNo(vm.homeBranch.remittance)

			$scope.showButton = false;
		} else if (workflowSharedService.viewFrom == 'homebranchtodolist_checker') {
			vm.homeBranchDetailsDTO = angular.fromJson($rootScope.payload);

			if (vm.homeBranch  == undefined) {
				vm.homeBranch = vm.homeBranchDetailsDTO

				vm.homeBranch.currencyNotes = convertBooleanToYesNo(vm.homeBranch.currencyNotes)
			vm.homeBranch.forexCardLoad = convertBooleanToYesNo(vm.homeBranch.forexCardLoad)
			vm.homeBranch.remittance = convertBooleanToYesNo(vm.homeBranch.remittance)
			}
			setBankValue();
			setStateValue();
			preparDeliveryModeDTOList(vm.homeBranch);
			$scope.showButton = true;
			$scope.showDiscardButton = false;
		} else if (workflowSharedService.viewFrom == 'homebranchtodolist_maker') {
			vm.homeBranchDetailsDTO = angular.fromJson($rootScope.payload);
			if (vm.homeBranch == undefined || vm.homeBranch == null) {
				vm.homeBranch = vm.homeBranchDetailsDTO
				vm.homeBranch.currencyNotes = convertBooleanToYesNo(vm.homeBranch.currencyNotes)
			vm.homeBranch.forexCardLoad = convertBooleanToYesNo(vm.homeBranch.forexCardLoad)
			vm.homeBranch.remittance = convertBooleanToYesNo(vm.homeBranch.remittance)
			}
			setBankValue();
			setStateValue();
			preparDeliveryModeDTOList(vm.homeBranch);
			$scope.showButton = false;
			$scope.showDiscardButton = true;
		} else if (workflowSharedService.viewFrom == 'homebranch_auditLog') {
			vm.homeBranchDetailsDTO = angular.fromJson($rootScope.payload);
		

			if (vm.homeBranch == undefined) {
				vm.homeBranch=vm.homeBranchDetailsDTO
			}
			setBankValue();
			setStateValue();
			preparDeliveryModeDTOList(vm.homeBranch);
			$scope.showButton = false;
		}

		function convertBooleanToYesNo(value) {
			if(value || value == false) return value;
			return value == 'yes' ? true : ( value == 'no' ? false : null);
		}
		

        function setBankValue(){
        		if(vm.homeBranch.bankName !=null){

                    BankRegistration.getBankForShortName({bankName: vm.homeBranch.bankName},function(result){
                        vm.bank=result;
                    });
    		}
        }

        
        function setStateValue(){
           
        		if(vm.homeBranch.state!= null){
                    StaticLookUp.getStateobject({stateName:vm.homeBranch.state},function(result){
                        vm.stateName=result;
        })
    }
}

		function approveHomeBranch() {
			ManageHomeBranch.approve({
				"taskId" : $rootScope.taskID
			}, onApproveSuccess, onApproveError);
			$uibModalInstance.dismiss('cancel');
		}

		function onApproveSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
		}
		function onApproveError(error) {
			vm.clicked=false;
		}

		function rejectHomeBranch() {
			Workflow.rejectTask($rootScope.taskID);
		}

		function discardHomeBranch() {
			ManageHomeBranch.discard({
				"taskId" : $rootScope.taskID
			}, onDiscardSuccess, onDiscardError);
			$uibModalInstance.dismiss('cancel');
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);
		}
		function onDiscardError(error) {

		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function preparDeliveryModeDTOList(homeBranch) {
			getCurrencyPairList(homeBranch.bankName);
			prepardeliveryModeIsEnable(homeBranch);
			vm.forexCardLoad = homeBranch.forexCardLoad ? homeBranch.forexCardLoad.split(",") : [];
			vm.currencyNotes = homeBranch.currencyNotes ? homeBranch.currencyNotes.split(",") : [];
			vm.remittance = homeBranch.remittance ? homeBranch.remittance.split(",") : [];
			vm.forexCardIssuance = homeBranch.forexCardIssuance ? homeBranch.forexCardIssuance.split(",") : [];
		}

		function preparDeliveryModeList(currencyPairList, deliveryMode) {

			var deliveryModeMap = {};

			angular.forEach(deliveryMode, function (code) {
				deliveryModeMap[code] = true;
			});

			return currencyPairList.map(function (item) {
				return {
					CurrencyCode: item.baseCurrency.code,
					isEnable: !!deliveryModeMap[item.baseCurrency.code]
				};
			});
		}


		function getCurrencyPairList(bankName) {

			StaticLookUp.getCurrencyPairBankName({ "bankName": bankName }, getCurrencyPairSuccess, getCurrencyPairError);
		}

		function getCurrencyPairSuccess(result) {
			vm.currencyPairList = result

			vm.forexCardLoadList = preparDeliveryModeList(vm.currencyPairList, vm.forexCardLoad);
			vm.currencyNoteList = preparDeliveryModeList(vm.currencyPairList, vm.currencyNotes);
			vm.remittanceList = preparDeliveryModeList(vm.currencyPairList, vm.remittance);
			vm.forexCardIssuanceList = preparDeliveryModeList(vm.currencyPairList, vm.forexCardIssuance);
		}
		function getCurrencyPairError() { }

		function prepardeliveryModeIsEnable(homeBranch) {
			vm.homeBranch.currencyNotesIsEnable = homeBranch.currencyNotes != null && homeBranch.currencyNotes !='';
			vm.homeBranch.forexCardLoadIsEnable = homeBranch.forexCardLoad != null && homeBranch.forexCardLoad !='';
			vm.homeBranch.remittanceIsEnable = homeBranch.remittance != null && homeBranch.remittance !='';
			vm.homeBranch.forexCardIssuanceIsEnable = homeBranch.forexCardIssuance != null && homeBranch.forexCardIssuance !='';
			
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('HomeBranchDeleteController',HomeBranchDeleteController);

        HomeBranchDeleteController.$inject = ['$uibModalInstance', 'entity', 'ManageHomeBranch', 'GlobalValues','$scope'];

    function HomeBranchDeleteController($uibModalInstance, entity, ManageHomeBranch, GlobalValues,$scope) {
        var vm = this;

        vm.homeBranch = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        $scope.clicked=false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        
        function confirmDelete (id) {
        	ManageHomeBranch.delete({"corpId": GlobalValues.getCorpId(),"id":vm.homeBranch.id},
                    function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('manage-home-branch', {
            parent: 'entity',
            url: '/manage-home-branch',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.manageHomeBranch.manageHomeBranch" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manage-home-branch/manage-home-branch.html',
                    controller: 'ManageHomeBranchController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manageHomeBranch');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('home-branch', {
            parent: 'manage-home-branch',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-home-branch/manage-home-branch-dialog.html',
                    controller: 'HomeBranchDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	 id:null,  
                            	name:null                            	
                             
                            };
                        }
                    }
                }).result.then(function() {
                   $state.go('manage-home-branch', null, { reload: 'home-branch.new' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manageHomeBranch');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
        .state('home-branch.view', {
            parent: 'manage-home-branch',
            url: '/home-branch/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-home-branch/manage-home-branch-details.html',
                    controller: 'HomeBranchViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['ManageHomeBranch', 'GlobalValues', function(ManageHomeBranch, GlobalValues) {
                                     return ManageHomeBranch.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manageHomeBranch');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
         })
          .state('home-branch.edit', {
            parent: 'manage-home-branch',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl:  'app/entities/manage-home-branch/manage-home-branch-dialog.html',
                    controller: 'HomeBranchDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['ManageHomeBranch', 'GlobalValues', function(ManageHomeBranch, GlobalValues) {
                                     return ManageHomeBranch.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manageHomeBranch');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
         })
        .state('home-branch.delete', {
            parent: 'manage-home-branch',
            url: '/delete/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-home-branch/manage-home-branch-delete-dialog.html',
                    controller: 'HomeBranchDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ManageHomeBranch', 'GlobalValues', function(ManageHomeBranch, GlobalValues) {
                            return ManageHomeBranch.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    //$state.go('^', null, { reload: true });
                	$state.go('manage-home-branch', null, { reload: 'manage-home-branch' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('home-branch-todolist', {
            parent: 'dashboard',
            url: '/homeBranchview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-home-branch/manage-home-branch-details.html',
                    controller: 'HomeBranchViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('manage-home-branch', null, { reload: 'manage-home-branch' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manageHomeBranch');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
        
         .state('home-branch-todolist.resubmit', {
            parent: 'dashboard',
            url: '/homeBranchedit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl:  'app/entities/manage-home-branch/manage-home-branch-dialog.html',
                    controller: 'HomeBranchDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('manage-home-branch', null, { reload: 'manage-home-branch' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manageHomeBranch');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
        .state('home-branch-auditLog', {
            parent: 'audit-log',
            url: '/homeBranchview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-home-branch/manage-home-branch-details.html',
                    controller: 'HomeBranchViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('manage-home-branch', null, { reload: 'manage-home-branch' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manageHomeBranch');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
        .state('home-branch-historyReport', {
            parent: 'history-report',
            url: '/homeBranchview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-home-branch/manage-home-branch-details.html',
                    controller: 'HomeBranchViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('manage-home-branch', null, { reload: 'manage-home-branch' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manageHomeBranch');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
        
    }
    
    
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ManageHomeBranch', ManageHomeBranch);

        ManageHomeBranch.$inject = ['$resource'];

    function ManageHomeBranch ($resource) {
        var resourceUrl =  'api/home-branch/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }, 
            'getAllHomeBranchesForBank': {
                method: 'GET',
                isArray: true,
                params: {bankId:'@bankId'},
                url: 'api/home-branch-for-bank/:bankId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                params: {corpId:'@corpId'},
                url: 'api/home-branch/:corpId',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                }                
            },
            'update': {
            	method:'PUT',
            	params: {corpId:'@corpId'},
                url: 'api/home-branch/:corpId',
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
            'delete':{
                method: 'DELETE',
                params: {corpId:'@corpId', id:'@id'},
                url: 'api/home-branch/:corpId/:id'    
                },
         
            'approve': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
              	 method: 'GET',
                   params: {taskId:'@taskId'},
                   url: 'api/tasks/:taskId/discard'
             },
             'resubmitForCreate': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/resubmitForCreate/home-branch',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             },
             'resubmitForEdit': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/resubmitForEdit/home-branch',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             },
             'exportHomeBranchExcel':{
				method: 'POST',
                params: {bankId : '@bankId'},
				url: 'api/home-branch/export/excel',
				responseType: 'arraybuffer',
				transformRequest: function (data) {
	                   	var copy = angular.copy(data);
	                   	
	                       return angular.toJson(copy);
	            },
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			},
			'exportHomeBranchCsv':{
				method: 'POST',
                params: {bankId : '@bankId'},
				url: 'api/home-branch/export/csv',
				responseType: 'arraybuffer',
				transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
            },
			transformResponse: function(data, headers) {
				return {
					data: data,
					headers: headers
				};   
			}         
			},
            'exportHomeBranchDetails': {
                method: 'POST',
                url: 'api/home-branch/export/homeBranchExcel',
                 transformResponse: function (data) {
                 return data;
                }
            },
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'homeBranch'
        })
        
        .controller('ManageHomeBranchController', ManageHomeBranchController);

        ManageHomeBranchController.$inject = ['$scope', '$state', 'workflowSharedService', 'ManageHomeBranch', 'GlobalValues', 'EntityPermissions','ScreenLog','$rootScope','entityConstants','$timeout', 'AlertService', '$filter', ];

    function ManageHomeBranchController($scope, $state, workflowSharedService, ManageHomeBranch, GlobalValues, EntityPermissions,ScreenLog,$rootScope,entityConstants,$timeout,AlertService,$filter) {
        
        var vm = this;
        
        vm.globalValues = GlobalValues;
        vm.screenLog = ScreenLog;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.MANAGE_HOME_BRANCH;
        $scope.refresh=refresh;
        workflowSharedService.viewFrom = "homeBranch";
        vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
        vm.launch=launch;
        vm.clicked=false;
        vm.orgid=vm.globalValues.getOrganisation();
        vm.exportDataToFile = exportDataToFile;
        vm.manageHomeBranchfileName = "Manage_Home_Branch_Report_";
        vm.fileName = vm.manageHomeBranchfileName;
        vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
        vm.generateHomeBranchExcel = generateHomeBranchExcel;

        function launch() {
        	$state.go('home-branch');
        }
        
        vm.permitHomeBranchViewEntityAction = EntityPermissions.hasPermission('ManageHomeBranch.VIEW')
        vm.permitHomeBranchEditEntityAction = EntityPermissions.hasPermission('ManageHomeBranch.EDIT')
        vm.permitHomeBranchCreateEntityAction = EntityPermissions.hasPermission('ManageHomeBranch.CREATE')
		vm.permitHomeBranchDeleteEntityAction = EntityPermissions.hasPermission('ManageHomeBranch.DELETE')
 
		console.log(vm.permitHomeBranchViewEntityAction);
		if(vm.permitHomeBranchViewEntityAction){
			loadAll();	
		}
        
		function loadAll(){
            // if(vm.entityOwnerType=='Clearcorp'){
            //     vm.bankId=vm.bank.id;
            //     ManageHomeBranch.getAllHomeBranchesForBank({bankId: vm.globalValues.getOrganisation().id}, function(result) {
            //         vm.homeBranch = result;
            //         vm.clicked=false;                    
            //     });	
            // }else
			ManageHomeBranch.getAllHomeBranchesForBank({bankId: vm.globalValues.getOrganisation().id}, function(result) {
                vm.homeBranch = result;
                vm.clicked=false;                    
            });	
		}
		logScreenAccess();
        vm.loadAll = function loadAll(bank) {
        	vm.bankId = 0;
        		if(bank!=null && bank!=undefined){
            		vm.bankId = bank.id;
        		}
        		ManageHomeBranch.getAllHomeBranchesForBank({bankId: vm.bankId}, function(result) {
                    vm.homeBranch = result;
                    vm.clicked=false;            
                });

        	if(bank != undefined){vm.bankId = bank.id};
        	console.log(vm.bankId);   	
            
        }
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }
        
        $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
        function exportDataToFile(fileType){
            if(vm.bank == null  || vm.bank == undefined){
                vm.bankId=vm.globalValues.getOrganisation().id;
            }else{
                vm.bankId=vm.bank.id;
            }
			vm.fileName =  vm.manageHomeBranchfileName;
				if(fileType == 'csv'){
					vm.mimeType = 'text/csv';
					vm.extension =  ".csv";  
					ManageHomeBranch.exportHomeBranchCsv({bankId:vm.bankId}, processResponse );
				}
				else if(fileType == 'xls'){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.extension = ".xls";  
					ManageHomeBranch.exportHomeBranchExcel({bankId:vm.bankId},processResponse );
				}
		}

		function processResponse(result){        	  
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
			vm.baseString =   vm.fileName + moment().format( vm.reportFileTimestampFormat ) +  vm.extension; 

			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}

    function generateHomeBranchExcel() {
    ManageHomeBranch.exportHomeBranchDetails(function (response) {
        var message = $filter('translate')('gatewayApp.homeBranch.GeneratingExcel');
        AlertService.success(message);
    }, function (error) {
        var errorMessage = $filter('translate')('gatewayApp.homeBranch.errorGeneratingExcel');
        AlertService.error(errorMessage);
        console.error(error);
    });
}

      
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
         .state('manage-Entity-Restrictions', {
            parent: 'home',
            params:{screen: 'EntityRestriction'},
            url: 'Entity_Restrictions/Change_Restrictions',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                	 templateUrl: 'app/entities/manage-entity-restrictions/manage-entity-restrictions.html',
                     controller: 'manageEntityRestrictionsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        restrictionReasons: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getAllRestrictionReaons().$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('entityRestrictions');
                            return $translate.refresh();
                        }]
                       
                    }
                }).result.then(function() {
                    $state.go('home', {}, { reload: 'manage-Entity' });
                }, function() {
                    $state.go('home');
                });
            }]
        })
        
        .state('manage-Entity', {
            parent: 'entity',
            url: '/Entity_Restrictions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.security.manageglobalapprovalpolicy" | translate }}',
                parent: 'home'
              },
            views: {
                'content@': {
                	templateUrl: 'app/entities/manage-entity-restrictions/manage-entity-restrictions.html',
                    controller: 'manageEntityRestrictionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                restrictionReasons: ['StaticLookUp', function(StaticLookUp) {
                    return StaticLookUp.getAllRestrictionReaons().$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('entityRestrictions');
                    return $translate.refresh();
                }]
               
            }
        })
        
         .state('manage-Entity-Restrictions-todolist', {
            parent: 'dashboard',
            url: '/Entity_Restrictions/Change_Restrictions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/entities/manage-entity-restrictions/manage-entity-restrictions.html',
                    controller: 'manageEntityRestrictionsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        restrictionReasons: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getAllRestrictionReaons().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('manage-Entity-Restrictions', null, { reload: 'manage-Entity-Restrictions' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('manage-Entity-Restrictions-todolist.resubmit', {
            parent: 'dashboard',
            url: '/Entity_Restrictions',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/entities/manage-entity-restrictions/manage-entity-restrictions.html',
                    controller: 'manageEntityRestrictionsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        },
                        restrictionReasons: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getAllRestrictionReaons().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('manage-Entity-Restrictions', null, { reload: 'manage-Entity-Restrictions' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('manage-Entity-Restrictions-auditLog', {
            parent: 'audit-log',
            url: '/manage-Entity-Restrictions-auditLog',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-entity-restrictions/manage-entity-restrictions.html',
                    controller: 'manageEntityRestrictionsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                   	 entity: [function() {
                        }],
                        restrictionReasons: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getAllRestrictionReaons().$promise;
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('manage-Entity', {}, { reload: 'manage-Entity' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('manage-Entity-Restrictions-historyReport', {
            parent: 'history-report',
            url: '/manage-Entity-Restrictions-historyReport',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-entity-restrictions/manage-entity-restrictions.html',
                    controller: 'manageEntityRestrictionsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                   	 entity: [function() {
                        }],
                        restrictionReasons: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getAllRestrictionReaons().$promise;
                        }]
              
                    }
                }).result.then(function() {
                    $state.go('manage-Entity', {}, { reload: 'manage-Entity' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('limitSettings');
                    return $translate.refresh();
                }]
               
            }
        })
    }
    
    
})();
(function() {
	'use strict';
	angular.module('gatewayApp').factory('ManageEntityRestrictions',
			ManageEntityRestrictions);

	ManageEntityRestrictions.$inject = [ '$resource' ];

	function ManageEntityRestrictions($resource) {
		var resourceUrl = 'api/';

		return $resource(
				resourceUrl,
				{},
				{
					'fetchStatusDetailsForBank' : {
						method : 'GET',
						params : {
							bankId : '@bankId'
						},
						url : 'api/fetch-entity-restriction-bank/:bankId',
						transformResponse : function(data) {
							if (data) {
								data = angular.fromJson(data);
							}
							return data;
						}
					},
					'fetchStatusDetailsForBranch' : {
						method : 'GET',
						params : {
							bankId : '@bankId',
							branchId : '@branchId'
						},
						url : 'api/fetch-entity-restriction-branch/:bankId/:branchId',
						transformResponse : function(data) {
							if (data) {
								data = angular.fromJson(data);
							}
							return data;
						}
					},
					'fetchDetailsForCustomer' : {
						method : 'GET',
						params : {
							customerId : '@customerId'
						},
						url : 'api/fetch-entity-restriction-customer/:customerId',
						transformResponse : function(data) {
							if (data) {
								data = angular.fromJson(data);
							}
							return data;
						}
					},
					'fetchDetailsForCustomerRelationship' : {
						method : 'GET',
						params : {
							bankId : '@bankId',
							branchId : '@branchId',
							customerId : '@customerId'
						},
						url : 'api/fetch-entity-restriction-cust-rel/:bankId/:branchId/:customerId',
						transformResponse : function(data) {
							if (data) {
								data = angular.fromJson(data);
							}
							return data;
						}
					},

					'manageEntityRestrictionsForBank' : {
						method : 'POST',
						url : 'api/manage-entity-restriction-bank',
						/*params : {
							bankId : '@bankId',
							oldStatus : '@oldStatus',
							newStatus : '@newStatus'
						},*/
						transformRequest : function(data) {
							var copy = angular.copy(data);
							return angular.toJson(copy);
						}
					},

					'manageEntityRestrictionsForBranch' : {
						method : 'POST',
						url : 'api/manage-entity-restriction-branch',
						/*params : {
							bankId : '@bankId',
							branchId : '@branchId',
							oldStatus : '@oldStatus',
							newStatus : '@newStatus'
						},*/
						transformRequest : function(data) {
							var copy = angular.copy(data);
							return angular.toJson(copy);
						}
					},

					'manageEntityRestrictionsForCustomer' : {
						method : 'POST',
						url : 'api/manage-entity-restriction-customer',
						transformRequest : function(data) {
							var copy = angular.copy(data);
							return angular.toJson(copy);
						}
					},
					'approve' : {
						method : 'GET',
						params : {
							taskId : '@taskId'
						},
						url : 'api/tasks/:taskId/approve'
					},
					'reject' : {
						method : 'GET',
						params : {
							taskId : '@taskId'
						},
						url : 'api/tasks/:taskId/reject'
					},
					'discard' : {
						method : 'GET',
						params : {
							taskId : '@taskId'
						},
						url : 'api/tasks/:taskId/discard'
					},

					'ResubmitForEdit' : {
						method : 'PUT',
						params : {
							taskId : '@taskId'
						},
						url : 'api/tasks/:taskId/RestrictionResubmitForEdit',
						transformRequest : function(data) {
							var copy = angular.copy(data);
							return angular.toJson(copy);
						}
					},
					'manageEntityRestrictionsForCustomerRelationship' : {
						method : 'POST',
						url : 'api/manage-entity-restriction-customer-relationship',
						transformRequest : function(data) {
							var copy = angular.copy(data);
							return angular.toJson(copy);
						}
					},

				});
	}
})();

(function() {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function() {
		this.viewFrom = 'entityRestrictions'
	})

	.controller('manageEntityRestrictionsController',
			manageEntityRestrictionsController);

	manageEntityRestrictionsController.$inject = [ '$scope', '$state',
			'$rootScope', '$uibModalInstance', 'ManageEntityRestrictions',
			'GlobalValues', 'workflowSharedService', 'Workflow' ,'restrictionReasons','ScreenLog','entityConstants'];

	function manageEntityRestrictionsController($scope, $state, $rootScope,
			$uibModalInstance, ManageEntityRestrictions, GlobalValues,
			workflowSharedService, Workflow, restrictionReasons,ScreenLog,entityConstants) {
		var vm = this;

		vm.isShowBankEntity = true;
		vm.isShowBranchEntity = true;
		vm.FetchStatusDetailsForBank = FetchStatusDetailsForBank;
		vm.clear = clear;
		vm.isShowRestrictionDetails = false;
		vm.globalValues = GlobalValues;
		vm.save = save;
		vm.approve = approve;
		vm.reject = reject;
		vm.discard = discard;
		vm.resubmit = resubmit;
		vm.prepareEntityRestrictionDTO = prepareEntityRestrictionDTO;
		$scope.showButton = false;
		$scope.isShowSaveButton = false;
		$scope.showDiscardButton = false;
		$scope.isShowResubmit = false;
		vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
		vm.mulitCustomerEntityOwnerTypeId = 4;
		$scope.clicked=false;
		vm.restrictionReasonsList = restrictionReasons;
		vm.entityRestrictionsDTO = {};	
		vm.screenLog = ScreenLog;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.MANAGE_ENTITY_RESTRICTIONS;	
		entityRestrictionAccesScreen();

		function entityRestrictionAccesScreen(){
		vm.screenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}


		 if($state.current.name=="manage-Entity-Restrictions"){
        	 workflowSharedService.viewFrom="";
         }
		 
		if (workflowSharedService.viewFrom == 'entityRestrictionstodolist_checker') {
			vm.ViewDisable = true;

			vm.entityrestriction = angular.fromJson($rootScope.payload);
			setValuesFromTask(vm.entityrestriction);
			vm.isDisabled = true
			$scope.showButton = true;
			$scope.showDiscardButton = false;
			$scope.isShowResubmit = false;
			$scope.isShowSaveButton = false;

		} else if (workflowSharedService.viewFrom == 'entityRestrictionstodolist_maker') {
			vm.ViewDisable = true;
			vm.entityrestriction = angular.fromJson($rootScope.payload);
			setValuesFromTask(vm.entityrestriction);
			vm.isDisabled = true
			$scope.showButton = false;
			$scope.showDiscardButton = true;
			$scope.isShowSaveButton = false;
			$scope.isShowResubmit = false;
		}
		else if (workflowSharedService.viewFrom == 'entityRestriction_auditLog') {
			vm.ViewDisable = true;
			vm.entityrestriction = angular.fromJson($rootScope.payload);
			setValuesFromTask(vm.entityrestriction);
			vm.isDisabled = true
			$scope.showButton = false;
			$scope.showDiscardButton = false;
			$scope.isShowSaveButton = false;
			$scope.isShowResubmit = false;
		}
		

		else if (workflowSharedService.viewFrom == 'entityRestrictionstodolist_resubmit') {
			vm.entityrestriction = angular.fromJson($rootScope.payload);
			setValuesFromTask(vm.entityrestriction);
			vm.isDisabled = false;
			$scope.isShowResubmit = true;
			$scope.isShowSaveButton = false;
		} else {
			$scope.isShowSaveButton = true;
			defaultValuesBasedOnEntity();
			
		}

		
		function defaultValuesBasedOnEntity() {
			
			vm.isShowRestrictionDetails = false;
			if (vm.entityOwnerType == 'Clearcorp') {
				vm.isShowBankEntity = true;
				vm.isShowBranchEntity = true;
				vm.bank = null;
				vm.isShowCustomerEntity = true;
				vm.isShowCustomerRelationshipEntity = true;
				vm.entity = "BANK";
			}

			if (vm.entityOwnerType == 'Bank') {

				vm.isShowBankEntity = false;
				vm.isShowCustomerEntity = false;
				vm.isShowCustomerRelationshipEntity = true;
				vm.entity = "BRANCH";
				vm.bank = vm.globalValues.getBank();
				vm.branch = null;
				vm.isBankDisabled = true;
			}

			if (vm.entityOwnerType == 'Branch') {

				vm.isShowBankEntity = false;
				vm.isShowBranchEntity = false;
				vm.isShowCustomerEntity = false;
				vm.isShowCustomerRelationshipEntity = true;
				vm.entity = "CUSTREL";
				vm.bank = vm.globalValues.getBank();
				vm.branch = vm.globalValues.getBranch();
				vm.isBankDisabled = true;
				vm.isBranchDisabled = true;
			}

			if (vm.entityOwnerType == 'MultiUserCustomer') {

				vm.isShowBankEntity = false;
				vm.isShowBranchEntity = false;
				vm.isShowCustomerEntity = false;
				vm.isShowCustomerRelationshipEntity = true;
				vm.entity = "CUSTREL";
			}       
			
		}
		
		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		$scope.$watch('vm.bank', function(value) {
			if (value != null && value != undefined && vm.entity == "BANK") {
				FetchStatusDetailsForBank();
			}
		});

		$scope.$watch('vm.branch', function(value) {
			if (value != null && value != undefined && vm.entity == "BRANCH") {
				FetchStatusDetailsForBranch();
			}
		});

		function prepareEntityRestrictionDTO(bank,branch,customer,newStatus,oldStatus,entityType,reason,remarks) {
			vm.entityRestrictionsDTO.bank = bank;
			vm.entityRestrictionsDTO.branch = branch;
			vm.entityRestrictionsDTO.customer = customer;
			vm.entityRestrictionsDTO.entityType = entityType;
			vm.entityRestrictionsDTO.oldStatus = oldStatus;
			vm.entityRestrictionsDTO.newStatus = newStatus;
			vm.entityRestrictionsDTO.reason = reason;
			vm.entityRestrictionsDTO.remarks = remarks;
		}

		function save() {

			if (vm.entity == "BANK") {
				prepareEntityRestrictionDTO(vm.bank,null,null,vm.newStatus,vm.currentStatus,"BANK",vm.restrictionReason,vm.remarks);
				ManageEntityRestrictions.manageEntityRestrictionsForBank(vm.entityRestrictionsDTO, onSaveSuccess, onSaveError);
			} else if (vm.entity == "BRANCH") {
				prepareEntityRestrictionDTO(vm.bank,vm.branch,null,vm.newStatus,vm.currentStatus,"BRANCH",vm.restrictionReason,vm.remarks);
				ManageEntityRestrictions.manageEntityRestrictionsForBranch(vm.entityRestrictionsDTO, onSaveSuccess, onSaveError);
			} else if (vm.entity == "CUSTOMER") {
				prepareEntityRestrictionDTO(null,null,vm.customer,vm.newStatus,vm.currentStatus,"CUSTOMER",vm.restrictionReason,vm.remarks);
				ManageEntityRestrictions.manageEntityRestrictionsForCustomer(vm.entityRestrictionsDTO, onSaveSuccess, onSaveError);
			} else {
				prepareEntityRestrictionDTO(vm.bank,vm.branch,vm.customer,vm.newStatus,vm.currentStatus,"CUSTREL",vm.restrictionReason,vm.remarks);
				ManageEntityRestrictions.manageEntityRestrictionsForCustomerRelationship(vm.entityRestrictionsDTO, onSaveSuccess, onSaveError);
			}

		}

		function setValuesFromTask(task) {

			if (task.entityType == 'BANK') {
				vm.entity = "BANK";
				vm.isShowBankEntity = true;
				vm.isShowBranchEntity = false;
				vm.isShowCustomerEntity = false;
				vm.isShowCustomerRelationshipEntity = false
				vm.bank = task.bank;
				//FetchStatusDetailsForBank();
				vm.currentStatus = task.oldStatus;
				vm.newStatus = task.newStatus;
			}

			if (task.entityType == 'BRANCH') {
				vm.entity = "BRANCH";
				vm.isShowBankEntity = false;
				vm.isShowBranchEntity = true;
				vm.isShowCustomerEntity = false;
				vm.isShowCustomerRelationshipEntity = false

				vm.bank = task.bank;
				vm.branch = task.branch;
				//FetchStatusDetailsForBranch();
				vm.currentStatus = task.oldStatus;
				vm.newStatus = task.newStatus;
				
			}

			if (task.entityType == 'CUSTOMER') {
				vm.entity = "CUSTOMER";
				vm.isShowBankEntity = false;
				vm.isShowBranchEntity = false;
				vm.isShowCustomerEntity = true;
				vm.isShowCustomerRelationshipEntity = false

				vm.customer = task.customer;

				//fetchDetailsForCustomer();
				vm.currentStatus = task.oldStatus;
				vm.newStatus = task.newStatus;
			}

			if (task.entityType == 'CUSTREL') {
				vm.entity = "CUSTREL";
				vm.isShowBankEntity = false;
				vm.isShowBranchEntity = false;
				vm.isShowCustomerEntity = false;
				vm.isShowCustomerRelationshipEntity = true

				vm.bank = task.bank;
				vm.branch = task.branch;
				vm.customer = task.customer;
				//fetchDetailsForCustomerRelationship();
				vm.currentStatus = task.oldStatus;
				vm.newStatus = task.newStatus;
			
			}
			vm.restrictionReason = task.reason;
			vm.remarks = task.remarks;


		}

		$scope.$watch('vm.customer', function(value) {
			if (value != null && value != undefined
					&& (vm.entity == "CUSTOMER" || vm.entity == "CUSTREL")) {

				if (vm.entity == "CUSTOMER") {
					fetchDetailsForCustomer();
				} else if (vm.entity == "CUSTREL") {
					fetchDetailsForCustomerRelationship()
				}

			}
		});

		$scope.$watch('vm.entity', function(value) {
			if (value != null && value != undefined) {
				if( !(workflowSharedService.viewFrom == 'entityRestrictionstodolist_resubmit' 
					|| workflowSharedService.viewFrom == 'entityRestrictionstodolist_maker'
						|| workflowSharedService.viewFrom == 'entityRestrictionstodolist_checker'
							|| workflowSharedService.viewFrom =='entityRestriction_auditLog')){
		             
		             vm.newStatus = null;
		             vm.isShowRestrictionDetails = false;
					 vm.restrictionReason = null;
					 vm.remarks = null;
		             if (vm.entityOwnerType == 'Clearcorp') {
		 				
		 				vm.bank =  null;
		 				vm.branch = null;
		 				vm.customer = null;
		 		
		 			}

		 			if (vm.entityOwnerType == 'Bank') {
		 				vm.bank = vm.globalValues.getBank();
		 				vm.branch = null;
		 				vm.customer = null;
		 			}

		 			if (vm.entityOwnerType == 'Branch') {

		 				vm.bank = vm.globalValues.getBank();
		 				vm.branch = vm.globalValues.getBranch();
		 		
		 			}

		 			if (vm.entityOwnerType == 'MultiUserCustomer') {

		 				vm.bank = null;
		 				vm.branch = null;
		 				vm.customer = null;

		 			}    
	        	 }
				//clearValues();
				/*
				 * vm.bank = null; vm.branch = null; vm.customer = null;
				 */
			}
		});
		
				 
		
		function approve() {
			ManageEntityRestrictions.approve({
				"taskId" : $rootScope.taskID
			}, onApproveSuccess, onApproveError);

		}

		function onApproveSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.dismiss('cancel');
		}
		function onApproveError(error) {

		}

		function reject() {
			Workflow.rejectTask($rootScope.taskID);
		}

		function discard() {
			ManageEntityRestrictions.discard({
				"taskId" : $rootScope.taskID
			}, onDiscardSuccess, onDiscardError);

		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.dismiss('cancel');
		}
		function onDiscardError(error) {

		}

		function resubmit() {
			vm.entityrestriction.bank = vm.bank;
			vm.entityrestriction.branch = vm.branch;
			vm.entityrestriction.customer = vm.customer;
			vm.entityrestriction.oldStatus = vm.currentStatus;
			vm.entityrestriction.newStatus = vm.newStatus;
			vm.entityrestriction.reason = vm.restrictionReason;
			vm.entityrestriction.remarks = vm.remarks;
			ManageEntityRestrictions.ResubmitForEdit({
				"taskId" : $rootScope.taskID
			}, vm.entityrestriction, onResubmitSuccess, onResubmitError);
			
			
		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.dismiss('cancel');
		}

		function onResubmitError(error) {
			$scope.clicked=false;
		}

		function FetchStatusDetailsForBank() {			
				ManageEntityRestrictions.fetchStatusDetailsForBank({
					"bankId" : vm.bank.id
				}, onFetchSuccess, onFetchError);
			
		}

		function FetchStatusDetailsForBranch() {
				ManageEntityRestrictions.fetchStatusDetailsForBranch({
				"bankId" : vm.bank.id,
				"branchId" : vm.branch.id
				}, onFetchSuccess, onFetchError);
		
		}

		function fetchDetailsForCustomer() {
		
				ManageEntityRestrictions.fetchDetailsForCustomer({
				"customerId" : vm.customer.id
				}, onFetchSuccess, onFetchError);
			
		}

		function fetchDetailsForCustomerRelationship() {
			
				ManageEntityRestrictions.fetchDetailsForCustomerRelationship({
					"bankId" : vm.bank.id,
					"branchId" : vm.branch.id,
					"customerId" : vm.customer.id
				}, onFetchSuccess, onFetchError);
			
		}

        function onFetchSuccess(result) {
            if(isStatusCheckRequired()){
            	vm.currentStatus = result.CurrentStatus;
                vm.availableStatusList = result.AvailableStatus.split(";");
                vm.isShowRestrictionDetails = true;
                if( result.AvailableStatus==undefined || result.AvailableStatus==null || result.AvailableStatus.trim()=="" ){
                	vm.showChangeStatus = false;
                }else{
                	vm.showChangeStatus = true;
                }
            }     	
            
            else{
            	vm.showChangeStatus = true;
    			vm.isShowRestrictionDetails = true;
    			vm.availableStatusList = [];
    			vm.availableStatusList.push(vm.newStatus);
            }
			
        }


		function onFetchError(error) {

		}

		function onSaveSuccess(result) {
			defaultValuesBasedOnEntity();
		}

		function onSaveError(error) {

			$scope.clicked=false;
		}
		
		function isStatusCheckRequired(){
			
			if(!(
				 workflowSharedService.viewFrom == 'entityRestrictionstodolist_maker' 
					|| workflowSharedService.viewFrom == 'entityRestrictionstodolist_checker' || workflowSharedService.viewFrom =='entityRestriction_auditLog')){
				return true;
			}else{
				return false;
			}
		}

	}

})();

(function() {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function() {
		this.viewFrom = 'ManageCurrencyPairConfiguration'
	})

	.controller('ManageCurrencyPairConfigurationDialogController', ManageCurrencyPairConfigurationDialogController);

	ManageCurrencyPairConfigurationDialogController.$inject = [ '$scope', '$state',
			'workflowSharedService', 'ChangeConfig', 'GlobalValues',
			'EntityPermissions', 'ScreenLog', '$stateParams',
			'$uibModalInstance', '$rootScope', 'MessageBox', 'Workflow','entity','DateUtils', '$filter','AlertService','CurrencyPairConfiguration'];

	function ManageCurrencyPairConfigurationDialogController($scope, $state, workflowSharedService,
			ChangeConfig, GlobalValues, EntityPermissions, ScreenLog,
			$stateParams, $uibModalInstance, $rootScope, MessageBox, Workflow,entity,DateUtils, $filter,AlertService,CurrencyPairConfiguration) {

		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenLog = ScreenLog;
		vm.saveConfig = save;
		vm.confirmSave = confirmSave;
		vm.currecncyPairConfigSettings = {};
		vm.isShowDays = false;
		vm.isShowHours= false;
		vm.isShowSeconds= false;
		vm.isShowMins= false;
		vm.isShowUSD= false;
		vm.isShowPaise= false;
		vm.isShowPercentage=false;
		vm.errorText = "";
		vm.numericValueError = false;
		vm.isTransectionparamiter = false;
		vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
		// vm.bankId = vm.globalValues.getBank().id;
		
		vm.approveCurrecncyPairConfigSettings = approveCurrecncyPairConfigSettings;
		vm.rejectCurrecncyPairConfigSettings = rejectCurrecncyPairConfigSettings;
		vm.discardCurrecncyPairConfigSettings = discardCurrecncyPairConfigSettings;
		vm.resubmitCurrecncyPairConfigSettings = resubmitCurrecncyPairConfigSettings;
		vm.clear = clear;
		$scope.showButton = false;
		$scope.isShowSaveButton = false;
		$scope.showDiscardButton = false;
		$scope.isShowResubmit = false;
		vm.isPasswordPolicySelected = true;

		vm.clicked = false;
		vm.noOfDecimals=0;


		if (workflowSharedService.viewFrom == 'currency_pair_configurationtodolist_checker') {
			vm.ViewDisable = true;

			vm.currecncyPairConfigSettings = angular.fromJson($rootScope.payload);
			vm.labelName = vm.currecncyPairConfigSettings.currencyPair.code;
			vm.isDisabled = true
			vm.bankId = vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.bankName = vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			vm.currecncyPairConfigSettings.bank={};
			vm.currecncyPairConfigSettings.bank.id=vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.currecncyPairConfigSettings.bank.bankName=vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			$scope.showButton = true;
			$scope.showDiscardButton = false;
			$scope.isShowResubmit = false;
			$scope.isShowSaveButton = false;

		} else if (workflowSharedService.viewFrom == 'currency_pair_configurationtodolist_maker') {
			vm.ViewDisable = true;
			vm.currecncyPairConfigSettings = angular.fromJson($rootScope.payload);
			vm.labelName = vm.currecncyPairConfigSettings.currencyPair.code;
			vm.bankId = vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.bankName = vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			vm.currecncyPairConfigSettings.bank={};
			vm.currecncyPairConfigSettings.bank.id=vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.currecncyPairConfigSettings.bank.bankName=vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			vm.isDisabled = true
			$scope.showButton = false;
			$scope.showDiscardButton = true;
			$scope.isShowSaveButton = false;
			$scope.isShowResubmit = false;
		} else if (workflowSharedService.viewFrom == 'currency_pair_configuration_auditLog') {
			vm.ViewDisable = true;
			vm.currecncyPairConfigSettings = angular.fromJson($rootScope.payload);
			vm.labelName = vm.currecncyPairConfigSettings.currencyPair.code;
			vm.bankId = vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.bankName = vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			vm.currecncyPairConfigSettings.bank={};
			vm.currecncyPairConfigSettings.bank.id=vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.currecncyPairConfigSettings.bank.bankName=vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			vm.isDisabled = true
			$scope.showButton = false;
			$scope.showDiscardButton = true;
			$scope.isShowSaveButton = false;
			$scope.isShowResubmit = false;
		}
		else if (workflowSharedService.viewFrom == 'currency_pair_configuration_todolist_resubmit') {
			vm.currecncyPairConfigSettings = angular.fromJson($rootScope.payload);
			vm.labelName = vm.currecncyPairConfigSettings.currencyPair.code;
			vm.bankId = vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.bankName = vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			vm.currecncyPairConfigSettings.bank={};
			vm.currecncyPairConfigSettings.bank.id=vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.currecncyPairConfigSettings.bank.bankName=vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			vm.isDisabled = false;
			$scope.isShowResubmit = true;
			$scope.isShowSaveButton = false;
		}else {
			vm.currecncyPairConfigSettings =  $stateParams.currencyPairConfig;
			vm.labelName = $stateParams.labelName;
			if( vm.currecncyPairConfigSettings.bank != null &&  vm.currecncyPairConfigSettings.bank != undefined){
			vm.bankId = vm.currecncyPairConfigSettings.bank.id;
			vm.bankName = vm.currecncyPairConfigSettings.bank.bankName;
			vm.currecncyPairConfigSettings.bankId = vm.currecncyPairConfigSettings.bank.id;
			vm.currecncyPairConfigSettings.bankName = vm.currecncyPairConfigSettings.bank.bankName;
			}

			vm.corpId = $stateParams.corpId;
			$scope.isShowSaveButton = true;
		}


		function confirmSave() {
			var action = vm.currecncyPairConfigSettings.isEnabled ? 'enable' : 'disable';
			var message;
			if (vm.corpId) {
				message = 'Do you want to ' + action + ' currency pair?';
			} else {
				message = 'Do you want to ' + action + ' currency pair for ' + vm.bankName + '?';
			}
			MessageBox.openMessageBox("Alert", message, "YesNo", "continueSave");
		}

		var yesListener = $rootScope.$on('gatewayApp.messagebox.yes.continueSave', function(event, result) {
			save();
		});
		
		var noListener = $rootScope.$on('gatewayApp.messagebox.no.continueSave', function(event, result) {
			// vm.clicked = false;
		});

		$scope.$on('$destroy', function() {
			if (yesListener) { yesListener(); }
			if (noListener) { noListener(); }
		});

		function save() {
			vm.currencyPairConfigurationDTO = vm.currecncyPairConfigSettings;
            if(vm.corpId){
                // Clearcorp mode: call /manage-currency-pair-configuration/{corpId}
                CurrencyPairConfiguration.update({
                    "corpId": vm.corpId
                }, vm.currencyPairConfigurationDTO, onSaveSuccess, onSaveError);
            } else {
                // Bank mode: call bank endpoint
                CurrencyPairConfiguration.bankupdate({
                    "corpId": GlobalValues.getCorpId()
                }, vm.currencyPairConfigurationDTO, onSaveSuccess, onSaveError);
            }
		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
			vm.clicked = false;
		}

		function onSaveError() {
			vm.clicked = false;
		}

		function onSaveSuccess(result) {
			$scope.$emit('Refresh');
			$uibModalInstance.close();

		}

		function onSaveError() {

			vm.clicked = false;
		}

		function approveCurrecncyPairConfigSettings() {
			CurrencyPairConfiguration.approve({
				"taskId" : $rootScope.taskID
			}, onApproveSuccess, onApproveError);
			
		}

		function onApproveSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close();
        }
		function onApproveError(error) {
			vm.clicked=false;
		}

		function rejectCurrecncyPairConfigSettings() {
			Workflow.rejectTask($rootScope.taskID);
		}

		function discardCurrecncyPairConfigSettings() {
			CurrencyPairConfiguration.discard({
				"taskId" : $rootScope.taskID
			}, onDiscardSuccess, onDiscardError);
			
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close();
		}
		function onDiscardError(error) {

		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close(result);
			$uibModalInstance.close();
		}

		function onResubmitError(error) {
			vm.clicked=false;
		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function resubmitCurrecncyPairConfigSettings() {
			vm.currencyPairConfigurationDTO = vm.currecncyPairConfigSettings;
			CurrencyPairConfiguration.resubmitForCreate({
				"taskId": $rootScope.taskID
			}, vm.currencyPairConfigurationDTO, onResubmitSuccess, onResubmitError);
		}

	}
})();

(function() {
	'use strict';

	angular.module('gatewayApp').controller('ManageCurrencyPairConfigurationViewController',
        ManageCurrencyPairConfigurationViewController);

            ManageCurrencyPairConfigurationViewController.$inject = [ '$scope', '$state', '$rootScope',
			'workflowSharedService', '$uibModalInstance', 'CurrencyPairConfiguration', 'entity',
			'Workflow', 'GlobalValues','StaticLookUp'];

	function ManageCurrencyPairConfigurationViewController($scope, $state, $rootScope,
			workflowSharedService, $uibModalInstance, CurrencyPairConfiguration, entity, Workflow,
			GlobalValues,StaticLookUp) {
		var vm = this;
		vm.clear = clear;
		vm.approveCurrencyPairConfiguration = approveCurrencyPairConfiguration;
		vm.rejectCurrencyPairConfiguration = rejectCurrencyPairConfiguration;
		vm.discardCurrencyPairConfiguration = discardCurrencyPairConfiguration;
		$scope.showButton = false;
		$scope.showDiscardButton = false;
		vm.clicked = false;
		vm.ExpandOrCollapseRedirectionURLConfigurations = false;
		vm.ExpandOrCollapseFeeConfigurations = false;
		vm.globalValues = GlobalValues;
		vm.CurrencyPairConfigurationDTO = {};
        vm.bankValue=null;
        vm.bank=null;
        vm.state=null;

		if (workflowSharedService.viewFrom == 'currencyPairConfiguration') {
			vm.currencyPairConfiguration = entity; 
			console.log(vm.currencyPairConfiguration); 
			$scope.showButton = false;
		} else if (workflowSharedService.viewFrom == 'currency_pair_configurationtodolist_checker') {
			vm.currencyPairConfigurationDTO = angular.fromJson($rootScope.payload);

			if (vm.currencyPairConfiguration  == undefined) {
				vm.currencyPairConfiguration = vm.currencyPairConfigurationDTO
			}
			$scope.showButton = true;
			$scope.showDiscardButton = false;
		} else if (workflowSharedService.viewFrom == 'currency_pair_configurationtodolist_maker') {
			vm.currencyPairConfigurationDTO = angular.fromJson($rootScope.payload);
			if (vm.currencyPairConfiguration == undefined ||vm.currencyPairConfiguration == null) {
				vm.currencyPairConfiguration =  vm.currencyPairConfigurationDTO
			}
			$scope.showButton = false;
			$scope.showDiscardButton = true;
		} else if (workflowSharedService.viewFrom == 'currency_pair_configuration_auditLog') {
			vm.currencyPairConfigurationDTO = angular.fromJson($rootScope.payload);
		

			if (vm.currencyPairConfiguration == undefined) {
				vm.currencyPairConfiguration = vm.currencyPairConfigurationDTO
			}
			$scope.showButton = false;
		}
		
		function approveCurrencyPairConfiguration() {
			CurrencyPairConfiguration.approve({
				"taskId" : $rootScope.taskID
			}, onApproveSuccess, onApproveError);
			$uibModalInstance.dismiss('cancel');
		}

		function onApproveSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
		}
		function onApproveError(error) {
			vm.clicked=false;
		}

		function rejectCurrencyPairConfiguration() {
			Workflow.rejectTask($rootScope.taskID);
		}

		function discardCurrencyPairConfiguration() {
			CurrencyPairConfiguration.discard({
				"taskId" : $rootScope.taskID
			}, onDiscardSuccess, onDiscardError);
			$uibModalInstance.dismiss('cancel');
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);
		}
		function onDiscardError(error) {

		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('manage-currency-pair-configuration', {
            parent: 'entity',
            url: '/manage-currency-pair-configuration',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.currencyPairConfiguration.currencyPairConfiguration" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-currency-pair-configuration/manage-currency-pair-configuration.html',
                    controller: 'ManageCurrencyPairConfigurationController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:true});
                }, function() {
                    $state.go('home', null, {reload:true});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('currencyPairConfiguration');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('manage-currency-pair-configuration.edit', {
            parent: 'manage-currency-pair-configuration',
            url: '/Manage-currency-pair-configuration/{labelName}',
            params: {
                currencyPairConfig: null,
                bankId: null,
                bankName: null,
                corpId: null
            },
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-currency-pair-configuration/manage-currency-pair-configuration-dialog.html',
                    controller:  'ManageCurrencyPairConfigurationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('currencyPairConfiguration');
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('currency-pair-configuration-auditLog', {
            parent: 'audit-log',
            url: '/currency_pair_configuration_auditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-currency-pair-configuration/manage-currency-pair-configuration-dialog.html',
                    controller:  'ManageCurrencyPairConfigurationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('currencyPairConfiguration');
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('currency-pair-configuration-historyReport', {
            parent: 'history-report',
            url: '/currency-pair-configuration-historyReport',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-currency-pair-configuration/manage-currency-pair-configuration-dialog.html',
                    controller:  'ManageCurrencyPairConfigurationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('currencyPairConfiguration');
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
    .state('currency-pair-configurations-todolist', {
            parent: 'dashboard',
            url: '/currency-pair-configurations-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-currency-pair-configuration/manage-currency-pair-configuration-dialog.html',
                    controller:  'ManageCurrencyPairConfigurationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                	$state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('currencyPairConfiguration');
                	$translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
       .state('currency-pair-configuration-todolist-resubmit', {
            parent: 'dashboard',
            url: '/currency-pair-configurations-view',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manage-currency-pair-configuration/manage-currency-pair-configuration-dialog.html',
                    controller:  'ManageCurrencyPairConfigurationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('manage-currency-pair-configuration', null, { reload: 'manage-currency-pair-configuration' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('currencyPairConfiguration');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
    }
    
    
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('CurrencyPairConfiguration', CurrencyPairConfiguration);

        CurrencyPairConfiguration.$inject = ['$resource'];

    function CurrencyPairConfiguration ($resource) {
		var resourceUrl =  '/api';
		return $resource(resourceUrl, {}, {
		    'get' : {
			    method : 'GET',
			    params: {id : '@id'},
			    url:'api/manage-currency-pair-configuration/:id',
			    transformResponse : function(data) {
                 if (data) {
                    return angular.fromJson(data);
                    }
                    return data;
			    }
		    },
            'getBankCurrencyPairConfiguration': {
                method: 'GET',
                isArray: true,
                params: {bankId:'@bankId'},
                url: 'api/manage-bank-currency-pair-configuration/:bankId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAllCurrencyPairConfiguration': {
                method: 'GET',
                isArray: true,
                url: 'api/manage-currency-pair-configuration/',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	method:'POST',
            	params: {corpId:'@corpId'},
                url: 'api/manage-currency-pair-configuration/:corpId',
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
            'bankupdate': {
            	method:'POST',
            	params: {corpId:'@corpId'},
                url: 'api/manage-bank-currency-pair-configuration//:corpId',
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
            'approve': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
              	 method: 'GET',
                   params: {taskId:'@taskId'},
                   url: 'api/tasks/:taskId/discard'
             },
             'resubmitForCreate': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/resubmit/manage-currency-pair-configuration',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             },
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'currencyPairConfiguration'
        })
        
        .controller('ManageCurrencyPairConfigurationController', ManageCurrencyPairConfigurationController);

        ManageCurrencyPairConfigurationController.$inject = ['$scope', '$state', 'workflowSharedService', 'CurrencyPairConfiguration', 'GlobalValues', '$uibModalInstance','EntityPermissions','ScreenLog','$rootScope','entityConstants','$timeout', 'AlertService', '$filter','IntradayMarket','MessageBox' ];

    function ManageCurrencyPairConfigurationController($scope, $state, workflowSharedService, CurrencyPairConfiguration, GlobalValues, $uibModalInstance,EntityPermissions,ScreenLog,$rootScope,entityConstants,$timeout,AlertService,$filter,IntradayMarket,MessageBox) { 
        var vm = this;   
        vm.globalValues = GlobalValues;
        vm.screenLog = ScreenLog;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.MANAGE_CURRENCY_PAIR_CONFIGURATIONS;
        workflowSharedService.viewFrom = "currencyPairConfiguration";
        vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
        vm.clicked=false;
        vm.orgid=vm.globalValues.getOrganisation();
        vm.currencyPairConfigurationfileName = "Currency_Pair_Configuration";
        vm.fileName = vm.currencyPairConfigurationfileName;
        vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
        vm.noOfDecimalsForRate = 3;
        vm.getCurrencyConfig = getCurrencyConfig;
        vm.getClearcorpCurrencyConfig = getClearcorpCurrencyConfig;
        vm.onModeChange = onModeChange;
		vm.clear = clear;

        // Default mode for Clearcorp users: 'BANK' (matches original behaviour)
        vm.selectedMode = 'CLEARCORP';
        // MessageBox.openMessageBox("Alert", 'Are you sure to remove the selected instrument?', "YesNo", "continuedeletemktwatch");
        vm.permitCurrencyPairConfigurationViewEntityAction = EntityPermissions.hasPermission('ManageCurrencyPairConfiguration.VIEW')
        vm.permitCurrencyPairConfigurationEditEntityAction = EntityPermissions.hasPermission('ManageCurrencyPairConfiguration.EDIT')

        //get market session settings. to display status. market session settings will be available for SPOT, cash TOM
       	IntradayMarket.getIntradayMarketSessionSettingsForInstrument({"instrument":'InterbankSPOT'}, onGetMarketSessionSuccess, onGetMarketSessionFailure);
		
    	function onGetMarketSessionSuccess(result){
        	vm.marketSessionSettings = result;
        }
		
		function onGetMarketSessionFailure(){
			
		}

		if(vm.permitCurrencyPairConfigurationViewEntityAction && vm.entityOwnerType=='Bank'){
			loadAll();	
		}
        
		function loadAll(){
			CurrencyPairConfiguration.getBankCurrencyPairConfiguration({bankId: vm.globalValues.getOrganisation().id}, function(result) {
                vm.currencyPairConfiguration = result;
                vm.clicked=false;                    
            });	
		}

        function getCurrencyConfig(bank){
			CurrencyPairConfiguration.getBankCurrencyPairConfiguration({bankId: bank.id}, function(result) {
                vm.currencyPairConfiguration = result;
                vm.clicked=false;                    
            });	
        }

        function getClearcorpCurrencyConfig(){
            CurrencyPairConfiguration.getAllCurrencyPairConfiguration({}, function(result) {
                vm.currencyPairConfiguration = result;
                vm.clicked=false;
            });
        }

        vm.editConfiguration = function(mode, currencyPair) {
            if (vm.marketSessionSettings && vm.marketSessionSettings.sessionStatus == 'OPEN') {
                MessageBox.openMessageBox("Alert", "Modification is permitted only after the IB.SPOT market hours...!", "Ok", "");
                return;
            }

            if (mode == 'BANK') {
                $state.go('manage-currency-pair-configuration.edit', {
                    labelName: currencyPair.currencyPair.code, 
                    currencyPairConfig: currencyPair, 
                    bankId: currencyPair.bank.id, 
                    bankName: currencyPair.bank.bankName
                });
            } else if (mode == 'CLEARCORP') {
                $state.go('manage-currency-pair-configuration.edit', {
                    labelName: currencyPair.currencyPair.code, 
                    currencyPairConfig: currencyPair, 
                    corpId: vm.globalValues.getCorpId()
                });
            }
        };

        function onModeChange(mode){
            vm.selectedMode = mode;
            vm.currencyPairConfiguration = [];
            vm.bank = null;
            vm.clicked = false;
        }

        function clear() {
			$uibModalInstance.dismiss('cancel');
		}
		
				
		$rootScope.$on('Refresh', function(event, result) {
			loadAll();
		});
		
		logScreenAccess();
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }   
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('BBPSSettingsEditController', BBPSSettingsEditController);

    BBPSSettingsEditController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService', '$uibModalInstance', 'BBPSSettings', 'entity', 'StaticLookUp', 'DateUtils'];

    function BBPSSettingsEditController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance, BBPSSettings, entity, StaticLookUp, DateUtils) {
        var vm = this;
        vm.bbpsSetting = entity;

        vm.clear = clear;
        vm.save = save;
        vm.clicked = false;
        $scope.showButton = false;
        vm.resubmitBBPSSettings = resubmitBBPSSettings;
        vm.globalValues = GlobalValues;
        vm.markupType = { value: 'Paise' };
        vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
        $scope.showButton = false;
        vm.orgId = vm.globalValues.getOrgId();
        vm.currentBusinessDate = vm.globalValues.getSystemSettings().businessDate;
        vm.noOfDecimals = vm.globalValues.getNumberOfDecimalsForRateInReports();
        vm.effectiveFromDateTime = DateUtils.convertLocalDateFromServer(vm.currentBusinessDate);
        vm.todayDate = new Date();

        //get RO/ED applicability method list lookup
        // StaticLookUp.getRoEdApplicabilityMethodList(function(result){
        //     vm.roEdApplicabilityMethodList = result;
        // });
        var now = moment();
        vm.momentBusinessDate = moment(vm.currentBusinessDate, 'YYYY-MM-DD');
        vm.momentBusinessDate.set(
            {
                'hour': now.get('hour'),
                'minute': now.get('minute'),
                'second': now.get('second')

            });
        vm.effectiveFromDateTime = vm.momentBusinessDate.toDate();

        vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.decimalForPaise = vm.globalValues.getNumberOfDecimalsForRateInReports();

        vm.todayDate = new Date();
        $scope.$watch('vm.bbpsSetting.markupValue', function (value) {
            if (value == null || value == undefined || value == "") {

                document.getElementById("txtTaxOnMarkup").value = "";
                vm.bbpsSetting.taxOnMarkup = null;
            }
        });

        if (workflowSharedService.viewFrom == 'ManageBBPSSettings') {
            vm.bbpsSetting = entity;

            if (vm.bbpsSetting != null && vm.bbpsSetting != undefined) {
                vm.branch = vm.bbpsSetting.branch;
                vm.bank = vm.bbpsSetting.bank;
            }
            if (vm.entityOwnerType == 'Bank') {
                vm.bank = vm.globalValues.getBank();
            }

       	 	  $scope.showButton=false;
               vm.isModifyScreen = true;
        }
        else if (workflowSharedService.viewFrom == 'bbps_settingtodolist_resubmit') {
            vm.bbpsSetting = angular.fromJson($rootScope.payload);
            vm.bank = vm.bbpsSetting.bank;
            vm.branch = vm.bbpsSetting.branch;

        	vm.disableForm = false;
        	$scope.showButton=true;
            vm.isModifyScreen = true;
        }
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.bbpsSetting.bank = vm.bank;
            vm.bbpsSetting.branch = vm.branch;

            if (vm.bbpsSetting.id != null) {
                BBPSSettings.update({
                    "orgId": GlobalValues.getOrgId()
                }, vm.bbpsSetting, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
        }


        function onSaveError() {

            vm.clicked = false;
        }
        function resubmitBBPSSettings() {
            vm.bbpsSetting.bank = vm.bank;
            vm.bbpsSetting.branch = vm.branch;

            BBPSSettings.resubmit({ "taskId": $rootScope.taskID }, vm.bbpsSetting, onResubmitSuccess, onResubmitError);


            $uibModalInstance.dismiss('cancel');
        }

        function onResubmitSuccess(result) {
            $rootScope.removeRow($rootScope.taskID);
        }
        function onResubmitError(error) { }


    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('BBPSSettingsViewController', BBPSSettingsViewController);

    BBPSSettingsViewController.$inject = ['$scope', '$state', '$rootScope', 'workflowSharedService', '$uibModalInstance', 'BBPSSettings', 'entity', 'Workflow', 'GlobalValues', 'ScreenLog', 'StaticLookUp', 'DateUtils'];

    function BBPSSettingsViewController($scope, $state, $rootScope, workflowSharedService, $uibModalInstance, BBPSSettings, entity, Workflow, GlobalValues, ScreenLog, StaticLookUp, DateUtils) {
        var vm = this;
        vm.clear = clear;
        vm.approveBBPSSetting = approveBBPSSetting;
        vm.rejectBBPSSetting = rejectBBPSSetting;
        vm.discardBBPSSetting = discardBBPSSetting;
        $scope.showButton = false;
        $scope.showDiscardButton = false;
        $scope.clicked = false;
        vm.globalValues = GlobalValues;
        vm.markupType = { value: 'Paise' };
        vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
        vm.orgId = vm.globalValues.getOrgId();
        vm.noOfDecimals = vm.globalValues.getNumberOfDecimalsForRateInReports();

        //get RO/ED applicability method list lookup
        // StaticLookUp.getRoEdApplicabilityMethodList(function(result){
        //     vm.roEdApplicabilityMethodList = result;
        // });
        vm.hideRoEdApplicability = false;

        if(workflowSharedService.viewFrom == 'ManageBBPSSettings'){
        	vm.bbpsSetting = entity;    
        	vm.bank=vm.bbpsSetting.bank;
        	vm.branch=vm.bbpsSetting.branch;
       	 	$scope.showButton=false;
            vm.isModifyScreen = true;
        }
        else if(workflowSharedService.viewFrom == 'bbps_settingttodolist_checker') {
        	vm.bbpsSetting =  angular.fromJson($rootScope.payload); 
        	vm.bank=vm.bbpsSetting.bank;
        	vm.branch=vm.bbpsSetting.branch;
        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
            vm.isModifyScreen = true;
        }
        else if(workflowSharedService.viewFrom == 'bbps_settingttodolist_maker') {
        	vm.bbpsSetting =  angular.fromJson($rootScope.payload); 
        	vm.bank=vm.bbpsSetting.bank;
        	vm.branch=vm.bbpsSetting.branch;
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
            vm.isModifyScreen = true;
        }
        else if(workflowSharedService.viewFrom=='bbps_settings_auditLog'){
        	vm.bbpsSetting =  angular.fromJson($rootScope.payload);   
        	vm.effectiveFromDateTime = DateUtils.convertDateTimeFromServer(vm.markup.effectiveFromDateTime);
            vm.bank=vm.bbpsSetting.bank;
            vm.branch=vm.bbpsSetting.branch;
        	$scope.showButton=false;
            vm.isModifyScreen = true;
        }

        function approveBBPSSetting() {
            BBPSSettings.approve({ "taskId": $rootScope.taskID }, onApproveSuccess, onApproveError);
            $uibModalInstance.dismiss('cancel');
        }

        function onApproveSuccess(result) {
            $rootScope.removeRow($rootScope.taskID);
        }
        function onApproveError(error) {

        }

        function rejectBBPSSetting() {
            Workflow.rejectTask($rootScope.taskID);
        }

        function discardBBPSSetting() {
            BBPSSettings.discard({ "taskId": $rootScope.taskID }, onDiscardSuccess, onDiscardError);
            $uibModalInstance.dismiss('cancel');
        }

        function onDiscardSuccess(result) {

            $rootScope.removeRow($rootScope.taskID);
        }
        function onDiscardError(error) {

        }


        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('manage-bbps-settings', {
                parent: 'entity',
                url: '/manage-bbps-settings',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.title'
                },
                ncyBreadcrumb: {
                    label: '{{ "global.menu.manageBBPSSetting.main" | translate }}',
                    parent: 'home'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/manage-bbps-settings/manage-bbps-settings.html',
                        controller: 'ManageBBPSSettingsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('manageBBPSSettings');

                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]

                }
            })

            .state('bbps-settings-view', {
                parent: 'manage-bbps-settings',
                url: '/manage-bbps-settings/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.title'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/manage-bbps-settings/manage-bbps-settings-details.html',
                        controller: 'BBPSSettingsViewController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {

                            entity: ['BBPSSettings', 'GlobalValues', function (BBPSSettings, GlobalValues) {
                                return BBPSSettings.get({ id: $stateParams.id }).$promise;
                            }]

                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }],
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('manageBBPSSettings');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]

                }

            })
            .state('bbps-settings-edit', {
                parent: 'manage-bbps-settings',
                url: '/edit/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.title'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/manage-bbps-settings/manage-bbps-settings-dialog.html',
                        controller: 'BBPSSettingsEditController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {

                            entity: ['BBPSSettings', 'GlobalValues', function (BBPSSettings, GlobalValues) {
                                return BBPSSettings.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }],
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('manageBBPSSettings');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]

                }

            })
            .state('bbps-settings-todolist', {
                parent: 'dashboard',
                url: '/BBPSSettings',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.title'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/manage-bbps-settings/manage-bbps-settings-details.html',
                        controller: 'BBPSSettingsViewController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: function () {
                                return {
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('manage-bbps-settings', null, { reload: 'manage-bbps-settings' });
                    }, function () {
                        $state.go('^');
                    });
                }],
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('manageBBPSSettings');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]

                }

            })
            .state('bbps-settings-todolist.resubmit', {
                parent: 'dashboard',
                url: '/BBPSSettingsEdit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/manage-bbps-settings/manage-bbps-settings-dialog.html',
                        controller: 'BBPSSettingsEditController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: function () {

                            }
                        }
                    }).result.then(function () {
                        $state.go('manage-bbps-settings', null, { reload: 'manage-bbps-settings' });
                    }, function () {
                        $state.go('^');
                    });
                }],
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('manageBBPSSettings');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('bbps-settings-auditLog', {
                parent: 'audit-log',
                url: '/BBPSSettingsAuditLog',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.title'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/manage-bbps-settings/manage-bbps-settings-details.html',
                        controller: 'BBPSSettingsViewController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: function () {
                                return {
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('manage-bbps-settings', null, { reload: 'manage-bbps-settings' });
                    }, function () {
                        $state.go('^');
                    });
                }],
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('manageBBPSSettings');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]

                }

            })

            .state('bbps-settings-historyReport', {
                parent: 'history-report',
                url: '/BBPSSettingsHistoryReport',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.title'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/markup-settings/manage-bbps-settings-details.html',
                        controller: 'BBPSSettingsViewController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: function () {
                                return {
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('manage-bbps-settings', null, { reload: 'manage-bbps-settings' });
                    }, function () {
                        $state.go('^');
                    });
                }],
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('manageBBPSSettings');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    };
})();

(function () {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('BBPSSettings', BBPSSettings);

    BBPSSettings.$inject = ['$resource'];

    function BBPSSettings($resource) {
        var resourceUrl = 'api/bbps-settings/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                params: { id: '@id' },
                url: 'api/bbps-settings/:id',
                transformResponse: function (data) {
                    if (data) {
                        return angular.fromJson(data);
                    }
                    return data;
                }
            },

            'update': {
                method: 'POST',
                params: { orgId: '@orgId' },
                url: 'api/bbps-settings/orgId/:orgId',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'approve': {
                method: 'GET',
                params: { taskId: '@taskId' },
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: { taskId: '@taskId' },
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
                method: 'GET',
                params: { taskId: '@taskId' },
                url: 'api/tasks/:taskId/discard'
            },
            'resubmit': {
                method: 'PUT',
                params: { taskId: '@taskId' },
                url: 'api/tasks/:taskId/resubmit/bbps-settings',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'getBBPSSettings': {
                method: 'GET',
                isArray: true,
                params: { bankId: '@bankId',currentAndPreviousDaySettings :'@currentAndPreviousDaySettings'},
                url: 'api/bbps-settings/bank/:bankId/:currentAndPreviousDaySettings',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            //   'getBBPSSetting': {
            //       method: 'GET',
            //       isArray: true,
            //       params: {branchId:'@branchId',bankId:'@bankId'},
            //       url: 'api/markup-for-customer/customer/:customerId',
            //       transformResponse: function (data) {
            //           if (data) {
            //               data = angular.fromJson(data);
            //           }
            //           return data;
            //       }
            //   }

        });
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {
            this.viewFrom = 'ManageBBPSSettings'
        })

        .controller('ManageBBPSSettingsController', ManageBBPSSettingsController);

    ManageBBPSSettingsController.$inject = ['$scope', '$state', 'BBPSSettings', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog', 'entityConstants','$timeout'];

    function ManageBBPSSettingsController($scope, $state, BBPSSettings, GlobalValues, workflowSharedService, EntityPermissions, ScreenLog, entityConstants,$timeout) {
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.MANAGE_BBPS_SETTINGS;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "ManageBBPSSettings";
        vm.bank = GlobalValues.getBank();
        vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
        vm.clicked = false;
        vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.decimalForPaise = vm.globalValues.getNumberOfDecimalsForRateInReports();
        vm.currentAndPreviousDaySettings = true;
		$scope.refresh = refresh;
        vm.permitBBPSSettingsEditEntityAction = EntityPermissions.hasPermission('ManageBBPSSettings.EDIT');
        vm.permitBBPSSettingsViewEntityAction = EntityPermissions.hasPermission('ManageBBPSSettings.VIEW');

        logScreenAccess();

        loadAll();
        function loadAll() {

            if (vm.entityOwnerType == 'Bank') {
                
                vm.bankId = vm.globalValues.getBank().id; 
                if (vm.bankId == null) {
                    vm.bankId = 0;
                }
                BBPSSettings.getBBPSSettings({ "bankId": vm.bankId,"currentAndPreviousDaySettings":vm.currentAndPreviousDaySettings}, function (result) {
                    vm.bbpsSettings = result;
                });
            }
        }

        vm.loadBBPSSetting = function loadBBPSSetting(bank) {
            vm.bankId = 0;
            if(vm.entityOwnerType == 'Bank'){
                vm.bankId = vm.globalValues.getBank().id;
            }
            if (bank != null && bank != undefined) {
                vm.bankId = bank.id;
            }

            BBPSSettings.getBBPSSettings({ "bankId": vm.bankId,"currentAndPreviousDaySettings":vm.currentAndPreviousDaySettings }, function (result) {
                vm.bbpsSettings = result;
                vm.clicked = false;
            });




        }
        function logScreenAccess() {
            ScreenLog.screenLog(vm.screenName, 0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }

        $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	 $stateProvider.state('no-of-loggedin-users', {
           	 parent: 'entity',
             params:{screen: 'NoOfLoggedInUsers'},
             url: '/loggedin-users-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.networkmonitor.loggedinUsers" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/loggedin-users-report/cc-loggedin-users-report.html',
                    controller: 'CCLoggedInUsersReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('loggedInUsers');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
    };
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('LoggedInUsersReport', LoggedInUsersReport);

    LoggedInUsersReport.$inject = ['$resource','DateUtils'];

    function LoggedInUsersReport($resource, DateUtils) {
        var resourceUrl = 'api/loggedinusers';
        return $resource(resourceUrl, {}, {
            
            'getHeaderData': {
                method: 'GET',  
                url: 'api/loggedinusers/all-available-users-count',
               
                isArray: true
            },
            'getBankUsersDetails': {
                method: 'GET',  
                url: 'api/loggedinusers/bank-users',
                params : {
                	bankId : '@bankId'
					
				},
				isArray: true
            },
            'getBranchUsersCountForBank': {
                method: 'GET',  
                url: 'api/loggedinusers/branch-users-count-for-bank',
                params : {
                	bankId : '@bankId'
					
				},
                isArray: true
            },'getCustomerCountForBranch': {
                method: 'GET',  
                url: 'api/loggedinusers/customers-count-for-branch',
                params : {
                	bankId : '@bankId'
					
				},
                isArray: true
            },'getCustomersUsersCount': {
                method: 'GET',  
                url: 'api/loggedinusers/customer-users-count',
                params : {
                	bankId : '@bankId',
                	branchId: '@branchId'
					
				},
                isArray: true
            },'getCurrentBusinessDate': {
                method: 'GET',  
                url: 'api/eod-process',
                transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
            },
            'getExcelData': {
                method: 'POST',  
                url: 'api/loggedinusers/export/excel',
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 },
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                }         
            },
            'getCSVData': {
                method: 'POST',  
                url: 'api/loggedinusers/export/csv',
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 },
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                }         
            },
            'getOverAllSummaryData': {
                method: 'GET',  
                url: 'api/loggedinusers/overall-summary',
               
                isArray: true
            },
            'getBankwiseSummaryData': {
                method: 'GET',  
                url: 'api/loggedinusers/bank-summary',
               
                isArray: true
            },
            'getLoggedInUsersAsOFNow': {
                method: 'GET',  
                url: 'api/loggedinusers/get-users-loggedin-as-of-now',
                params : {
                	orgID : '@orgID',
                	entityOwnerType: '@entityOwnerType'
					
				},
                isArray: true
            },
            'getLoggedInUsersForTheDay': {
                method: 'GET',  
                url: 'api/loggedinusers/get-users-loggedin-for-the-day',
                params : {
                	orgID : '@orgID',
                	entityOwnerType: '@entityOwnerType'
					
				},
                isArray: true
            },
            'getFailedToLoginUsers': {
                method: 'GET',  
                url: 'api/loggedinusers/get-users-failed-to-login',
                params : {
                	orgID : '@orgID',
                	entityOwnerType: '@entityOwnerType'
					
				},
                isArray: true
            },
            'getNotLoggedInUsers': {
                method: 'GET',  
                url: 'api/loggedinusers/get-users-not-logged-in',
                params : {
                	orgID : '@orgID',
                	entityOwnerType: '@entityOwnerType'
					
				},
                isArray: true
            },
            'getUsersPlacedOrderForTheDay': {
                method: 'GET',  
                url: 'api/loggedinusers/get-users-placed-orders',
                params : {
                	orgID : '@orgID',
                	entityOwnerType: '@entityOwnerType'
					
				},
                isArray: true
            },
            'getUsersPlacedTradeForTheDay': {
                method: 'GET',  
                url: 'api/loggedinusers/get-users-traded',
                params : {
                	orgID : '@orgID',
                	entityOwnerType: '@entityOwnerType'
					
				},
                isArray: true
            },
            'getCustomerLoggedInUsersForTheDay': {
                method: 'GET',  
                url: 'api/loggedinusers/get-customer-users-loggedin-for-the-day',
                params : {
                	bankId : '@bankID'
					
				},
                isArray: true
            }
        });
    }
})();
(function () {
	'use strict';
	// This file not in use as of JULY 2021, new file cc-loggedin-users-report-controller.js is used instead 
	angular
		.module('gatewayApp')
		.controller('LoggedInUsersReportController', LoggedInUsersReportController);

	LoggedInUsersReportController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues',  'AlertService','LoggedInUsersReport','$filter', 'ScreenLog','entityConstants','DateUtils', '$timeout'];

	function LoggedInUsersReportController( $scope, $state, $rootScope, GlobalValues,AlertService , LoggedInUsersReport , $filter , ScreenLog, entityConstants,DateUtils,$timeout){
		var vm = this;
		vm.globalValues = GlobalValues;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.NO_OF_LOGGEDIN_USER_REPORT;
        vm.entityConstants = entityConstants;
        vm.screenLog = ScreenLog;
    	$scope.refresh = refresh;
        
        vm.headerList =[];
        vm.selectedEntityUserList=[];
        
        var recordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        //recordsPerPage=3;
        $scope.noOfRecordsPerPage = recordsPerPage;
        $scope.page = 1;
        $scope.noOfUserRecordsPerPage = recordsPerPage;
        $scope.userPage = 1;
        $scope.noOfBranchRecordsPerPage = recordsPerPage;
        $scope.branchPage = 1;
        $scope.noOfBranchCustomerRecordsPerPage = recordsPerPage;
        $scope.branchCustomerPage = 1;       
        $scope.noOfCustomerRecordsPerPage = recordsPerPage;
        $scope.customerPage = 1;
        
        vm.getBankUsersDetails = getBankUsersDetails;
        vm.getBranchWiseUsersCount = getBranchWiseUsersCount;
        vm.getBranchWiseCustomerCount = getBranchWiseCustomerCount;
        vm.getBranchUsersDetails = getBranchUsersDetails;
        vm.getBranchCustomerDetails = getBranchCustomerDetails;
        vm.getCustomerUserDetails = getCustomerUserDetails;
        
        vm.selectedBankName = '';
        vm.selectedBankId = '';	
        vm.selectedEntityName = '';
        vm.selectedEntityType = '';
        vm.selectedBranchName = '';
        vm.selectedBranchId = '';
        
		vm.showBranchDrillDown = false;
		vm.showCustomerCountForBranches=false; 
		vm.showSelectedBranchCustomerDetails = false;
		
		vm.showSelectedBankUsersDetails = false;
		vm.showSelectedBranchUsersDetails = false;
		vm.showSelectedCustomerUsersDetails = false;
		
		//initialise list		
		vm.branchWiseUserCountList= [];
		vm.branchWiseCustomerCountList =[];
		vm.customerDetailsList = [];
		vm.selectedEntityUserList = [];		
		
		vm.exportToFile = exportToFile;
		        	    
 	   /*LoggedInUsersReport.getCurrentBusinessDate(getBusinnessDateSuccess, getBusinessDateFailed);
 	   
 	   function getBusinnessDateSuccess(result) {
 		  if (result.date) {
 			 vm.reportDate  = DateUtils.convertLocalDateFromServer(result.date);
          }
 		  else {vm.reportDate =  null;}
 		 		
		}
		function getBusinessDateFailed(error) {
			//Do Nothing
		}*/
		vm.todayDate=new Date();
		vm.reportDate  = DateUtils.convertDateTimeFromServer(vm.todayDate);
 	    
 	   logScreenAccess();
 	   loadHeader();
 	   
 	   function loadHeader(){
 		   	vm.headerList =[];
 		   	vm.totalBankUsersCount = 0;
			vm.totalBranchUsersCount = 0;
			vm.totalCustomerUsersCount = 0;	
			vm.totalBranchUserCountForBank = 0;
			vm.totalBranchCustomerCountForBank = 0;
			vm.totalBranchCustomerUSerCount = 0;
			vm.filterText="";
 		  
 		  LoggedInUsersReport.getHeaderData(  reportHeaderSuccess, reportHeaderFailure );
 	   }
 	   function reportHeaderSuccess(result){
 		  
 		   vm.headerList = result;
 		  calculateHeaderTotal(vm.headerList);
 		  showGridsForHeaderSelection();
 	   }
 	   function reportHeaderFailure(error){
 		   
 	   }
 	  
 	  function getBankUsersDetails(selectedBankId, selectedBankName){
 		  
 		 vm.selectedBankName = selectedBankName;
         vm.selectedBankId = selectedBankId;
         vm.selectedEntityName = selectedBankName;
         vm.selectedEntityType = 'Bank';
         vm.userFilterText="";
         //reset the paggination
 		 $scope.noOfUserRecordsPerPage = recordsPerPage;
 		 $scope.userPage = 1; 	
         vm.showSelectedBankUsersDetails = true;
 		 vm.showSelectedBranchUsersDetails = false;
 		 vm.showSelectedCustomerUsersDetails = false;
 		 vm.showBranchDrillDown = false;
 		 vm.showCustomerCountForBranches=false; 
 		 vm.showSelectedBranchCustomerDetails = false;
         LoggedInUsersReport.getBankUsersDetails({bankId:selectedBankId},bankUserDetailsSuccess, bankUserDetailsFailure );
         
 	  }
 	  function bankUserDetailsSuccess(result){
 		 vm.selectedEntityUserList = result;
 			 
 		 
 	  }
 	  function bankUserDetailsFailure(error){
		   
 	  }
 	  
 	  
 	  function getBranchWiseUsersCount(selectedBankId, selectedBankName){
 		 vm.branchWiseUserCountList = [];
 		 vm.totalBranchUserCountForBank = 0; 			
 		 vm.totalBranchCustomerCountForBank = 0;  
 		 vm.totalBranchCustomerUSerCount = 0; 		  
 		 vm.selectedBankName = selectedBankName;
         vm.selectedBankId = selectedBankId;
         vm.branchWiseFilterText="";
         //reset the paggination
 		 /*$scope.noOfBranchRecordsPerPage = recordsPerPage;
 		 $scope.branchPage = 1;
         vm.showBranchDrillDown = true;
 		 vm.showSelectedBankUsersDetails = false;
 		 vm.showSelectedBranchUsersDetails = false;
 		 vm.showSelectedCustomerUsersDetails = false;
 		 vm.showCustomerCountForBranches=false; 
 		 vm.showSelectedBranchCustomerDetails = false;*/
         showGridsForBranchUserSelection();
         LoggedInUsersReport.getBranchUsersCountForBank({bankId:selectedBankId}, branchWiseUsersCountSuccess, branchWiseUsersCountFailure );
 	  }
 	  function branchWiseUsersCountSuccess(result){
 		
 		 vm.branchWiseUserCountList = result;
 		 calculateBranchUserTotal( vm.branchWiseUserCountList);
 		
 		 
 	  }
 	  function branchWiseUsersCountFailure(error){
		   
 		  
 	  }
 	  
 	  function getBranchWiseCustomerCount(selectedBankId, selectedBankName){
 		 vm.branchWiseCustomerCountList =[];
 		 vm.totalBranchCustomerCountForBank = 0;
 		 vm.totalBranchCustomerUSerCount = 0;
 		 vm.customerDetailsList =[];
 		 vm.branchWiseCustomerFilterText = "";
 		 vm.selectedBankName = selectedBankName;
         vm.selectedBankId = selectedBankId;
         showGridsForBranchCustomerCountSelection();
         //reset the paggination
 		 /*$scope.noOfBranchCustomerRecordsPerPage = recordsPerPage;
 		 $scope.branchCustomerPage = 1;
 		 vm.showSelectedBankUsersDetails = false;
		 vm.showSelectedBranchUsersDetails = false;
		 vm.showSelectedCustomerUsersDetails = false;
		 vm.showBranchDrillDown = false;
		 vm.showCustomerCountForBranches=true; 
		 vm.showSelectedBranchCustomerDetails = false;*/
         showGridsForBranchCustomerCountSelection();
         LoggedInUsersReport.getCustomerCountForBranch({bankId:selectedBankId}, branchWiseCustomerCountSuccess, branchWiseCustomerCountSuccess );
 	  }
 	  function branchWiseCustomerCountSuccess(result){
  		
 		 vm.branchWiseCustomerCountList = result;
 		 calculateBranchCustomerTotal(vm.branchWiseCustomerCountList);
 		 
 	  }
 	  function branchWiseCustomerCountFailure(error){
		   
 		  
 	  }
 	  
 	  function getBranchUsersDetails(branchName , branchId, userList){
 		 vm.selectedEntityName = branchName;
         vm.selectedEntityType = 'Branch';
         vm.userFilterText="";
    	 vm.selectedEntityUserList = userList;
 		 //reset the paggination
 		 $scope.noOfUserRecordsPerPage = recordsPerPage;
 		 $scope.userPage = 1; 
 		 vm.showSelectedBankUsersDetails = false;
		 vm.showSelectedBranchUsersDetails = true;
		 vm.showSelectedCustomerUsersDetails = false;
		 vm.showBranchDrillDown = true;
		 vm.showCustomerCountForBranches=false; 
		 vm.showSelectedBranchCustomerDetails = false;
 	  }
 	  
 	  function logScreenAccess(){
			  vm.screenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
	  }
	
 	  
 	  function getBranchCustomerDetails(bankId, branchId, branchName){
 		 vm.totalBranchCustomerUSerCount = 0;
 		 vm.customerDetailsList =[];
 		 vm.selectedBranchName = branchName;
         vm.selectedBranchId = branchId;     
 		 
 		 /*
 		 //reset the paggination
 		 $scope.noOfCustomerRecordsPerPage = recordsPerPage;
 		 $scope.customerPage = 1; 
 		 vm.showSelectedBankUsersDetails = false;
		 vm.showSelectedBranchUsersDetails = false;
		 vm.showSelectedCustomerUsersDetails = false;
		 vm.showBranchDrillDown = false;
		 vm.showCustomerCountForBranches=true; 
		 vm.showSelectedBranchCustomerDetails = true;*/
 		 showGridsForCustomerUserCountSelection();
 		 LoggedInUsersReport.getCustomersUsersCount({bankId:bankId, branchId:branchId },getBranchCustomerDetailsSuccess,getBranchCustomerDetailsFailure);
 		
 	  }
 	  function getBranchCustomerDetailsSuccess(result){
 		 
 		 vm.customerDetailsList = result;
 		 calculateCustomerUserTotal( vm.customerDetailsList);
 		
 	  }
 	  function getBranchCustomerDetailsFailure(error){
 		 
 	  }
 	  
 	  function getCustomerUserDetails(customerName, userList){
 		  
 		 vm.selectedEntityName = customerName;
         vm.selectedEntityType = 'Customer';
         vm.userFilterText="";
    	 vm.selectedEntityUserList = userList;
 		 //reset the paggination
 		 $scope.noOfUserRecordsPerPage = recordsPerPage;
 		 $scope.userPage = 1; 
 		 vm.showSelectedBankUsersDetails = false;
		 vm.showSelectedBranchUsersDetails = false;
		 vm.showSelectedCustomerUsersDetails = true;
		 vm.showBranchDrillDown = false;
		 vm.showCustomerCountForBranches=true; 
		 vm.showSelectedBranchCustomerDetails = true;
 	  }
 	  
 		/********** Refresh**********/
	  $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadHeader();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
	
	/***********END *************/
        function calculateHeaderTotal(list){
    		vm.totalBankUsersCount = 0;
    		vm.totalBranchUsersCount = 0;
    		vm.totalCustomerUsersCount= 0;
    		
    		angular.forEach(list, function(overallCountForbank) {
    			
    			vm.totalBankUsersCount = vm.totalBankUsersCount + overallCountForbank.bankUsersCount;  
    			vm.totalBranchUsersCount = vm.totalBranchUsersCount + overallCountForbank.branchUsersCount; 
    			vm.totalCustomerUsersCount = vm.totalCustomerUsersCount + overallCountForbank.customerUsersCount;
    		});
    		
    	}
    	function calculateBranchUserTotal(list){
    		vm.totalBranchUserCountForBank = 0;
    		angular.forEach(list , function(branch) {		

    			vm.totalBranchUserCountForBank = vm.totalBranchUserCountForBank + branch.branchUsersCount;

    		});
    		
    	}
    	function calculateBranchCustomerTotal(list){
    		vm.totalBranchCustomerCountForBank  = 0;
    		angular.forEach(list, function(branchCustomer) {
    			
    			vm.totalBranchCustomerCountForBank = vm.totalBranchCustomerCountForBank + branchCustomer.customerCount;
    		});
    		
    	}
    	function calculateCustomerUserTotal(list){
    		vm.totalBranchCustomerUSerCount = 0;
    		angular.forEach(list , function(customer) {
    			
    			vm.totalBranchCustomerUSerCount = vm.totalBranchCustomerUSerCount + customer.customerUsersCount;
    		});
    		
    	}
    	$scope.$watch('vm.filterText', function(value){
    		calculateHeaderTotal(vm.filterData);
    		showGridsForHeaderSelection();
        }); 
    	$scope.$watch('vm.branchWiseFilterText', function(value){
    		calculateBranchUserTotal(vm.branchWiseUserFilterData);
    		showGridsForBranchUserSelection();
        }); 
    	$scope.$watch('vm.branchWiseCustomerFilterText', function(value){
    		calculateBranchCustomerTotal(vm.branchWiseCustomerFilterData );
    		showGridsForBranchCustomerCountSelection();
        }); 
    	$scope.$watch('vm.customerFilterText', function(value){
    		calculateCustomerUserTotal(vm.customerFilterData);
    		showGridsForCustomerUserCountSelection();
        });
    	
    	function showGridsForCustomerUserCountSelection(){
    		 //reset the paggination
    		$scope.noOfCustomerRecordsPerPage = recordsPerPage;
    		$scope.customerPage = 1; 
    		vm.showSelectedBankUsersDetails = false;
   		 	vm.showSelectedBranchUsersDetails = false;
   		 	vm.showSelectedCustomerUsersDetails = false;
   		 	vm.showBranchDrillDown = false;
   		 	vm.showCustomerCountForBranches=true; 
   		 	vm.showSelectedBranchCustomerDetails = true;
   		 	vm.userFilterText="";
   		 	
    	}
    	function showGridsForBranchCustomerCountSelection(){
    		 //reset pagination
    		 $scope.noOfBranchCustomerRecordsPerPage = recordsPerPage;
    		 $scope.branchCustomerPage = 1;
    		 vm.showSelectedBankUsersDetails = false;
    		 vm.showSelectedBranchUsersDetails = false;
    		 vm.showSelectedCustomerUsersDetails = false;
    		 vm.showBranchDrillDown = false;
    		 vm.showCustomerCountForBranches=true; 
    		 vm.showSelectedBranchCustomerDetails = false;
    		 vm.userFilterText="";
    		 vm.customerFilterText ="";
    		 
    	}
    	function showGridsForBranchUserSelection(){
    		
    		 $scope.noOfBranchRecordsPerPage = recordsPerPage;
    		 $scope.branchPage = 1;
    		 vm.showBranchDrillDown = true;
     		 vm.showSelectedBankUsersDetails = false;
     		 vm.showSelectedBranchUsersDetails = false;
     		 vm.showSelectedCustomerUsersDetails = false;
     		 vm.showCustomerCountForBranches=false; 
     		 vm.showSelectedBranchCustomerDetails = false;
     		 vm.userFilterText="";
     		 //vm.branchWiseFilterText="";
    	}
    	function showGridsForHeaderSelection(){
    		
    		vm.showBranchDrillDown = false;
    		 vm.showSelectedBankUsersDetails = false;
    		 vm.showSelectedBranchUsersDetails = false;
    		 vm.showSelectedCustomerUsersDetails = false;
    		 vm.showCustomerCountForBranches=false; 
    		 vm.showSelectedBranchCustomerDetails = false;
    		 vm.userFilterText="";
    		 vm.customerFilterText ="";
    		 vm.branchWiseCustomerFilterText = "";
    		 vm.branchWiseFilterText="";
    	}
    	 function exportToFile(fileType){
          	  vm.baseString =   'No_Of_Logged_In_Users_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   	
          	  if( vm.headerList !=null &&  vm.headerList!=undefined){
          		  if(fileType == 'csv'){
          			 vm.mimeType = 'text/csv'
          			 vm.baseString = vm.baseString+ ".csv";  
          			LoggedInUsersReport.getCSVData(vm.headerList , processResponse )
          		  }else if(fileType == 'excel'){
          			  vm.mimeType = 'application/vnd.ms-excel';
          			  vm.baseString = vm.baseString+ ".xls";  
          			LoggedInUsersReport.getExcelData(vm.headerList , processResponse );
          		  }
          	  }
            }	
            function processResponse(result){
          	  var fileData = null;
      		  fileData = result.data;
      		  var link = document.createElement("a");   
      		  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
      		  
      		  
      	      var blob = new Blob([bytes], {type: vm.mimeType});
      	      if(window.navigator.msSaveOrOpenBlob) {
                      window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
      	      }else{
      	    	  link.href =  window.URL.createObjectURL(blob);      
      	    	  link.download = vm.baseString;
      	    	  document.body.appendChild(link);
      	    	  link.click();
      	    	  document.body.removeChild(link);
      	      }
      	  }
	}
})();
(function () {
	'use strict';

	angular
		.module('gatewayApp')
		.controller('CCLoggedInUsersReportController', CCLoggedInUsersReportController);

	CCLoggedInUsersReportController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues',  'AlertService','LoggedInUsersReport','$filter', 'ScreenLog','entityConstants','DateUtils', '$timeout'];

	function CCLoggedInUsersReportController( $scope, $state, $rootScope, GlobalValues,AlertService , LoggedInUsersReport , $filter , ScreenLog, entityConstants,DateUtils,$timeout){
		var vm = this;
		vm.globalValues = GlobalValues;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.NO_OF_LOGGEDIN_USER_REPORT;
        vm.entityConstants = entityConstants;
        vm.screenLog = ScreenLog;
    	$scope.refresh = refresh;
    	vm.currentDateTime =moment().format( 'DD_MMM_YYYY_HH_mm');
        
        vm.overallSummary =[];
        vm.bankwiseSummary =[];
        vm.userDetailsList =[];
        vm.BANK_TYPE= "Bank";
        vm.BRANCH_TYPE= "Branch";
        vm.CUSTOMER_TYPE= "Customer";
        vm.ORDER_TYPE= "Order";
        vm.TRADE_TYPE= "Trade";
        vm.CLEARCORP = "Clearcorp";
        
        var recordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        //recordsPerPage=3;
        $scope.noOfRecordsPerPage = recordsPerPage;
        $scope.page = 1;      
        $scope.overallPage = 1;
        $scope.userPage = 1;
        $scope.noOfRecordsPerUSerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        
        vm.getUsersLoggedInForTheMoment = getUsersLoggedInForTheMoment;
        vm.getUsersLoggedInForTheDay = getUsersLoggedInForTheDay;
        vm.getUsersNotLoggedInForTheDay = getUsersNotLoggedInForTheDay;
        vm.getUsersFailedToLoginForTheDay = getUsersFailedToLoginForTheDay;
        vm.getUsersOrderPlacedForTheDay = getUsersOrderPlacedForTheDay;
        vm.getUsersTradedForTheDay = getUsersTradedForTheDay;
        vm.getCustomerUsersLoggedInForTheDay = getCustomerUsersLoggedInForTheDay;
        
        vm.selectedBankName = '';
        vm.selectedBankId = 0;	
        vm.selectedEntityType = '';
        
        vm.showUserDetailsDrillDown = false;
		vm.showDetailsForOrderorTradedUsers = false;
		vm.showCustomerDetails=false; 
		vm.showBankDetails = false;
		vm.showBranchDetails = false;
		
		//vm.exportToFile = exportToFile;
		        	    
 	   /*LoggedInUsersReport.getCurrentBusinessDate(getBusinnessDateSuccess, getBusinessDateFailed);
 	   
 	   function getBusinnessDateSuccess(result) {
 		  if (result.date) {
 			 vm.reportDate  = DateUtils.convertLocalDateFromServer(result.date);
          }
 		  else {vm.reportDate =  null;}
 		 		
		}
		function getBusinessDateFailed(error) {
			//Do Nothing
		}*/
		vm.todayDate=new Date();
		vm.reportDate  = DateUtils.convertDateTimeFromServer(vm.todayDate);
 	    
 	   logScreenAccess();
 	   loadHeader();
 	   
 	   function loadHeader(){
 		   
 		   	vm.overallSummary =[];
 		   	vm.totalAsOfNowCount = 0;
			vm.totalForTheDayCount = 0;
			vm.totalOrderUsersCount = 0;	
			vm.totalTradedUsersCount = 0;
			vm.totalNotLoggedInUsersCount = 0;
			vm.totalFailedLoginUsersCount = 0;
			vm.filterText="";
			vm.bankwiseSummaryfilterText="";
			vm.userSummaryFilterText ="";
			vm.bankwiseSummary =[];
			vm.userDetailsList = [];
			resetGridsForHeaderSelection();
 		  
 		   LoggedInUsersReport.getOverAllSummaryData(  reportHeaderSuccess, reportHeaderFailure );
 		   LoggedInUsersReport.getBankwiseSummaryData(  bankwiseSummarySuccess, bankwiseSummaryFailure );
 	   }
 	   function reportHeaderSuccess(result){
 		  
 		  vm.overallSummary = result;
 		  calculateHeaderTotal(vm.overallSummary);
 		  
 	   }
 	   function reportHeaderFailure(error){
 		   
 	   }
 	  function bankwiseSummarySuccess(result){
 		  
		  vm.bankwiseSummary  = result;
 	  }
	  function bankwiseSummaryFailure(error){
		   
	  }
 	  
 	  function logScreenAccess(){
			  vm.screenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
	  }
	
 	 
 	  
 		/********** Refresh**********/
	  $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadHeader();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
	
	/***********END *************/
        function calculateHeaderTotal(list){
    		
        	vm.totalAsOfNowCount = 0;
    		vm.totalForTheDayCount = 0;
    		vm.totalOrderUsersCount = 0;
    		vm.totalTradedUsersCount = 0;
    		vm.totalNotLoggedInUsersCount = 0;
    		vm.totalFailedLoginUsersCount = 0;
    		
    		angular.forEach(list, function(overallCountForbank) {
    			
    			vm.totalAsOfNowCount = vm.totalAsOfNowCount + overallCountForbank.asOfNow;
        		vm.totalForTheDayCount = vm.totalForTheDayCount + overallCountForbank.forTheDay;
        		vm.totalOrderUsersCount = vm.totalOrderUsersCount + overallCountForbank.orderPlaced;
        		vm.totalTradedUsersCount = vm.totalTradedUsersCount + overallCountForbank.traded;
        		vm.totalNotLoggedInUsersCount = vm.totalNotLoggedInUsersCount + overallCountForbank.notLoggedIn;
        		vm.totalFailedLoginUsersCount = vm.totalFailedLoginUsersCount + overallCountForbank.failedLoginUsers;
    		});
    		
    	}
    	
    	$scope.$watch('vm.filterText', function(value){
    		calculateHeaderTotal(vm.filterData);
    		resetGridsForHeaderSelection();
        }); 
    	
    	$scope.$watch('vm.bankwiseSummaryfilterText', function(value){
    		
    		resetGridsForHeaderSelection();
        }); 
    	
    	function resetGridsForHeaderSelection(){
    		 vm.selectedBankName = '';
    	     vm.selectedBankId = 0;	
    	     vm.selectedEntityType = '';
    	     vm.userSummaryFilterText = '';
    	    // vm.userDetailsHeader = '';
    	        
    	     vm.showUserDetailsDrillDown = false;
    		 vm.showDetailsForOrderorTradedUsers = false;
    		 vm.showCustomerDetails=false; 
    		 vm.showBankDetails = false;
    		 vm.showBranchDetails = false;
    		
    	}
    	function userDetailsSuccess(result){
    		vm.userDetailsList = result;
    		angular.element("#userSearch").focus();
    	}
    	function userDetailsFailure(error){
    		
    	}
    	
    	function getUsersLoggedInForTheMoment(bankId, bankName, entityType, drillDownGridType){
    		
    		setSelectionDetails(bankId, bankName, entityType,drillDownGridType);
    		LoggedInUsersReport.getLoggedInUsersAsOFNow({'orgID' :bankId , 'entityOwnerType' : entityType } ,userDetailsSuccess, userDetailsFailure)
    		
    	}
    	function getUsersLoggedInForTheDay(bankId, bankName, entityType, drillDownGridType){
    		setSelectionDetails(bankId, bankName, entityType,drillDownGridType);
    		LoggedInUsersReport.getLoggedInUsersForTheDay({'orgID' :bankId , 'entityOwnerType' : entityType } ,userDetailsSuccess, userDetailsFailure)
    		
    	}
    	function getUsersNotLoggedInForTheDay(bankId, bankName, entityType, drillDownGridType){
    		setSelectionDetails(bankId, bankName, entityType,drillDownGridType);
    		LoggedInUsersReport.getNotLoggedInUsers({'orgID' :bankId , 'entityOwnerType' : entityType } ,userDetailsSuccess, userDetailsFailure)
    		
    	}
    	function getUsersFailedToLoginForTheDay(bankId, bankName, entityType, drillDownGridType){
    		setSelectionDetails(bankId, bankName, entityType,drillDownGridType);
    		LoggedInUsersReport.getFailedToLoginUsers({'orgID' :bankId , 'entityOwnerType' : entityType } ,userDetailsSuccess, userDetailsFailure)
    		
    	}
    	function getUsersOrderPlacedForTheDay(bankId, bankName, entityType, drillDownGridType){
    		setSelectionDetails(bankId, bankName, entityType,drillDownGridType);
    		LoggedInUsersReport.getUsersPlacedOrderForTheDay({'orgID' :bankId , 'entityOwnerType' : entityType } ,userDetailsSuccess, userDetailsFailure)
    		
    	}
    	function getUsersTradedForTheDay(bankId, bankName, entityType, drillDownGridType){
    		setSelectionDetails(bankId, bankName, entityType,drillDownGridType);
    		LoggedInUsersReport.getUsersPlacedTradeForTheDay({'orgID' :bankId , 'entityOwnerType' : entityType } ,userDetailsSuccess, userDetailsFailure)
    		
    	}
    	function getCustomerUsersLoggedInForTheDay(bankId, bankName, entityType, drillDownGridType){
    		setSelectionDetails(bankId, bankName, entityType,drillDownGridType);
    		LoggedInUsersReport.getCustomerLoggedInUsersForTheDay({'bankId' :bankId } ,userDetailsSuccess, userDetailsFailure)
    		
    	}
    	
    	function setSelectionDetails(bankId, bankName, entityType,drillDownGridType){
    		 
    		vm.selectedBankName = bankName;
    	    vm.selectedBankId = bankId;	
    	    vm.selectedEntityType = entityType;
    	    vm.userSummaryFilterText = '';
    	    setColumDisplayForUserDetails(bankId, bankName, drillDownGridType);
    	}
    	function setColumDisplayForUserDetails(bankId, bankName, drillDownGridType){
    		vm.showUserDetailsDrillDown = true;
    		vm.showDetailsForOrderorTradedUsers = false;
    		vm.showCustomerDetails=false; 
    		vm.showBankDetails = false;
    		vm.showBranchDetails = false;
    		
    		if(drillDownGridType ==  vm.BANK_TYPE ){    			
        		vm.showBankDetails = true;
        		vm.userDetailsHeader = "Bank Users"
        		
    		}else if(drillDownGridType == vm.BRANCH_TYPE ){
    			
    			vm.showBranchDetails = true;
    			vm.userDetailsHeader = "Branch Users"
    			
    		}else if(drillDownGridType == vm.CUSTOMER_TYPE ){
    			vm.showCustomerDetails=true; 
    			vm.showDetailsForOrderorTradedUsers  = true;
    			vm.userDetailsHeader = "Customer Users"
    		}else if(drillDownGridType == vm.CLEARCORP){
    			vm.userDetailsHeader = "Clearcorp Users"
    		}
    		else if(drillDownGridType == vm.ORDER_TYPE || drillDownGridType == vm.TRADE_TYPE) {
    			vm.showCustomerDetails=true; 
        		vm.showBankDetails = true;
        		vm.showBranchDetails = true;
        		if(drillDownGridType == vm.ORDER_TYPE)
        			vm.userDetailsHeader = "Order placed Users of the day";
        		else if(drillDownGridType == vm.TRADE_TYPE)
        			vm.userDetailsHeader = "Traded Users of the day";
    		}
    	}
    	 /*function exportToFile(fileType){
          	  vm.baseString =   'No_Of_Logged_In_Users_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   	
          	  if( vm.overallSummary !=null &&  vm.overallSummary!=undefined){
          		  if(fileType == 'csv'){
          			 vm.mimeType = 'text/csv'
          			 vm.baseString = vm.baseString+ ".csv";  
          			LoggedInUsersReport.getCSVData(vm.overallSummary , processResponse )
          		  }else if(fileType == 'excel'){
          			  vm.mimeType = 'application/vnd.ms-excel';
          			  vm.baseString = vm.baseString+ ".xls";  
          			LoggedInUsersReport.getExcelData(vm.overallSummary , processResponse );
          		  }
          	  }
            }	
            function processResponse(result){
          	  var fileData = null;
      		  fileData = result.data;
      		  var link = document.createElement("a");   
      		  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
      		  
      		  
      	      var blob = new Blob([bytes], {type: vm.mimeType});
      	      if(window.navigator.msSaveOrOpenBlob) {
                      window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
      	      }else{
      	    	  link.href =  window.URL.createObjectURL(blob);      
      	    	  link.download = vm.baseString;
      	    	  document.body.appendChild(link);
      	    	  link.click();
      	    	  document.body.removeChild(link);
      	      }
      	  }*/
	}
})();
(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('no-of-loggedin-users-for-bank', {
			parent: 'entity',
			params:{screen: 'NoOfLoggedInUsersForBank'},
			url: '/no-of-loggedin-users-for-bank',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'global.title'
			},
			ncyBreadcrumb: {
				label: '{{ "global.menu.security.noOfLoggedInUsers" | translate }}',
				parent: 'home'
			},
			views: {
				'content@': {
					templateUrl: 'app/entities/logged-in-users-for-bank/bank-loggedin-users.html',
					controller: 'BankLoggedInUsersController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('loggedInUsersForBank');                    
					$translatePartialLoader.addPart('error');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}]

			}
		})

	};
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('LoggedInUsersForBank', LoggedInUsersForBank);

    LoggedInUsersForBank.$inject = ['$resource','DateUtils'];

    function LoggedInUsersForBank($resource, DateUtils) {
        var resourceUrl = 'api/loggedinusersforbank';
        return $resource(resourceUrl, {}, {
            
            'getHeaderData': {
                method: 'GET',  
                url: 'api/loggedinusersforbank/all-available-users-count',
               
                isArray: true
            },
            'getBankUsersDetails': {
                method: 'GET',  
                url: 'api/loggedinusersforbank/bank-users',
                params : {
                	bankId : '@bankId'
					
				},
				isArray: true
            },
            'getBranchUsersCountForBank': {
                method: 'GET',  
                url: 'api/loggedinusersforbank/branch-users-count-for-bank',
                params : {
                	bankId : '@bankId'
					
				},
                isArray: true
            },'getCustomerCountForBranch': {
                method: 'GET',  
                url: 'api/loggedinusersforbank/customers-count-for-branch',
                params : {
                	bankId : '@bankId'
					
				},
                isArray: true
            },'getCustomersUsersCount': {
                method: 'GET',  
                url: 'api/loggedinusersforbank/customer-users-count',
                params : {
                	bankId : '@bankId',
                	branchId: '@branchId'
					
				},
                isArray: true
            },'getCurrentBusinessDate': {
                method: 'GET',  
                url: 'api/eod-process',
                transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
            },
            /*'getExcelData': {
                method: 'POST',  
                url: 'api/loggedinusersforbank/export/excel',
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 },
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                }         
            },
            'getCSVData': {
                method: 'POST',  
                url: 'api/loggedinusersforbank/export/csv',
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 },
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                }         
            },*/
            'getExcelData': {
                method: 'POST',  
                url: 'api/bankloggedinusers/export/excel',
                responseType: 'arraybuffer',   
                params : {                	
                	isAsOfNow: '@isAsOfNow'					
				},
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                }         
            },
            'getCSVData': {
                method: 'POST',  
                url: 'api/bankloggedinusers/export/csv',
                responseType: 'arraybuffer', 
                params : {                	
                	isAsOfNow: '@isAsOfNow'					
				},
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                }         
            },
            'getSummaryData': {
                method: 'GET',  
                url: 'api/bankloggedinusers/bank-summary',
                params : {
                	
                	isAsOfNow: '@isAsOfNow'
					
				},
            	transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
            	}
            },
            
            'getLoggedInUsersAsOFNow': {
                method: 'GET',  
                url: 'api/bankloggedinusers/get-users-loggedin-as-of-now',
                params : {
                	
                	entityOwnerType: '@entityOwnerType'
					
				},
                isArray: true
            },
            'getLoggedInUsersForTheDay': {
                method: 'GET',  
                url: 'api/bankloggedinusers/get-users-loggedin-for-the-day',
                params : {
                	
                	entityOwnerType: '@entityOwnerType'
					
				},
                isArray: true
            }
        });
    }
})();
(function () {
	'use strict';

	angular
	.module('gatewayApp')
	.controller('LoggedInUsersForBankController', LoggedInUsersForBankController);

	LoggedInUsersForBankController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues',  'AlertService','LoggedInUsersForBank','$filter', 'ScreenLog','entityConstants','DateUtils', '$timeout'];

	function LoggedInUsersForBankController( $scope, $state, $rootScope, GlobalValues,AlertService , LoggedInUsersForBank , $filter , ScreenLog, entityConstants,DateUtils,$timeout){
		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.NO_OF_LOGGEDIN_USER_REPORT_FOR_BANK;
		vm.entityConstants = entityConstants;
		vm.screenLog = ScreenLog;
		$scope.refresh = refresh;

		vm.headerList =[];
		vm.selectedEntityUserList=[];

		var recordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.noOfRecordsPerPage = recordsPerPage;
		$scope.page = 1;
		$scope.noOfUserRecordsPerPage = recordsPerPage;
		$scope.userPage = 1;
		$scope.noOfBranchRecordsPerPage = recordsPerPage;
		$scope.branchPage = 1;


		vm.getBankUsersDetails = getBankUsersDetails;
		vm.getBranchWiseUsersCount = getBranchWiseUsersCount;
		vm.getBranchUsersDetails = getBranchUsersDetails;


		vm.selectedBankName = '';
		vm.selectedBankId = '';	
		vm.selectedEntityName = '';
		vm.selectedEntityType = '';
		vm.selectedBranchName = '';
		vm.selectedBranchId = '';

		vm.showBranchDrillDown = false;		
		vm.showSelectedBankUsersDetails = false;
		vm.showSelectedBranchUsersDetails = false;


		//initialise list		
		vm.branchWiseUserCountList= [];
		vm.selectedEntityUserList = [];		

		vm.exportToFile = exportToFile;

		vm.todayDate = new Date();
		vm.reportDate = DateUtils.convertDateTimeFromServer(vm.todayDate);

		logScreenAccess();
		loadHeader();

		function loadHeader(){
			vm.headerList =[];
			vm.totalBankUsersCount = 0;
			vm.totalBranchUsersCount = 0;	
			vm.totalBranchUserCountForBank = 0;
			vm.filterText="";

			LoggedInUsersForBank.getHeaderData(reportHeaderSuccess, reportHeaderFailure );
		}
		function reportHeaderSuccess(result){
			vm.headerList = result;
			calculateHeaderTotal(vm.headerList);
			showGridsForHeaderSelection();
		}
		function reportHeaderFailure(error){

		}

		function getBankUsersDetails(selectedBankId, selectedBankName){

			vm.selectedBankName = selectedBankName;
			vm.selectedBankId = selectedBankId;
			vm.selectedEntityName = selectedBankName;
			vm.selectedEntityType = 'Bank';
			vm.userFilterText="";
			//reset the paggination
			$scope.noOfUserRecordsPerPage = recordsPerPage;
			$scope.userPage = 1; 	
			vm.showSelectedBankUsersDetails = true;
			vm.showSelectedBranchUsersDetails = false;
			vm.showBranchDrillDown = false;
			LoggedInUsersForBank.getBankUsersDetails({bankId:selectedBankId},bankUserDetailsSuccess, bankUserDetailsFailure );

		}
		function bankUserDetailsSuccess(result){
			vm.selectedEntityUserList = result;
		}
		function bankUserDetailsFailure(error){

		}


		function getBranchWiseUsersCount(selectedBankId, selectedBankName){
			vm.branchWiseUserCountList = [];
			vm.totalBranchUserCountForBank = 0; 					  
			vm.selectedBankName = selectedBankName;
			vm.selectedBankId = selectedBankId;
			vm.branchWiseFilterText="";
			//reset the paggination
			showGridsForBranchUserSelection();
			LoggedInUsersForBank.getBranchUsersCountForBank({bankId:selectedBankId}, branchWiseUsersCountSuccess, branchWiseUsersCountFailure );
		}
		function branchWiseUsersCountSuccess(result){

			vm.branchWiseUserCountList = result;
			calculateBranchUserTotal( vm.branchWiseUserCountList);
		}
		function branchWiseUsersCountFailure(error){
		}


		function getBranchUsersDetails(branchName , branchId, userList){
			vm.selectedEntityName = branchName;
			vm.selectedEntityType = 'Branch';
			vm.userFilterText="";
			vm.selectedEntityUserList = userList;
			//reset the paggination
			$scope.noOfUserRecordsPerPage = recordsPerPage;
			$scope.userPage = 1; 
			vm.showSelectedBankUsersDetails = false;
			vm.showSelectedBranchUsersDetails = true;
			vm.showBranchDrillDown = true;
		}

		function logScreenAccess(){
			vm.screenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}

	

		/********** Refresh**********/
		$scope.toggle = true;
		function refresh() {
			$scope.toggle = false;
			$scope.refreshFlag = false;
			loadHeader();
			if ($scope.toggle == false) {
				$timeout(function() {
					$scope.toggle = true;
				}, 2000);
				$scope.refreshFlag = false;
			}
		};

		/***********END *************/
		function calculateHeaderTotal(list){
			vm.totalBankUsersCount = 0;
			vm.totalBranchUsersCount = 0;

			angular.forEach(list, function(overallCountForbank) {

				vm.totalBankUsersCount = vm.totalBankUsersCount + overallCountForbank.bankUsersCount;  
				vm.totalBranchUsersCount = vm.totalBranchUsersCount + overallCountForbank.branchUsersCount; 

			});

		}
		function calculateBranchUserTotal(list){
			vm.totalBranchUserCountForBank = 0;
			angular.forEach(list , function(branch) {		
				vm.totalBranchUserCountForBank = vm.totalBranchUserCountForBank + branch.branchUsersCount;
			});

		}

		$scope.$watch('vm.filterText', function(value){
			calculateHeaderTotal(vm.filterData);
			showGridsForHeaderSelection();
		}); 
		$scope.$watch('vm.branchWiseFilterText', function(value){
			calculateBranchUserTotal(vm.branchWiseUserFilterData);
			showGridsForBranchUserSelection();
		}); 



		function showGridsForBranchUserSelection(){

			$scope.noOfBranchRecordsPerPage = recordsPerPage;
			$scope.branchPage = 1;
			vm.showBranchDrillDown = true;
			vm.showSelectedBankUsersDetails = false;
			vm.showSelectedBranchUsersDetails = false;
			vm.userFilterText="";
		}
		function showGridsForHeaderSelection(){

			vm.showBranchDrillDown = false;
			vm.showSelectedBankUsersDetails = false;
			vm.showSelectedBranchUsersDetails = false;
			vm.userFilterText="";
			vm.branchWiseFilterText="";
		}
		function exportToFile(fileType){
			vm.baseString =   'No_Of_Logged_In_Users_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   	
			if( vm.headerList !=null &&  vm.headerList!=undefined){
				if(fileType == 'csv'){
					vm.mimeType = 'text/csv'
						vm.baseString = vm.baseString+ ".csv";  
					LoggedInUsersForBank.getCSVData(vm.headerList , processResponse )
				}else if(fileType == 'excel'){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.baseString = vm.baseString+ ".xls";  
					LoggedInUsersForBank.getExcelData(vm.headerList , processResponse );
				}
			}
		}	
		function processResponse(result){
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer


			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	}
})();
(function () {
	'use strict';

	angular
	.module('gatewayApp')
	.controller('BankLoggedInUsersController', BankLoggedInUsersController);

	BankLoggedInUsersController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues',  'AlertService','LoggedInUsersForBank','$filter', 'ScreenLog','entityConstants','DateUtils', '$timeout'];

	function BankLoggedInUsersController( $scope, $state, $rootScope, GlobalValues,AlertService , LoggedInUsersForBank , $filter , ScreenLog, entityConstants,DateUtils,$timeout){
		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.NO_OF_LOGGEDIN_USER_REPORT_FOR_BANK;
		vm.entityConstants = entityConstants;
		vm.screenLog = ScreenLog;
		$scope.refresh = refresh;

		vm.currentDateTime =moment().format( 'DD_MMM_YYYY_HH_mm');
        
        vm.selectedEntityType = '';        
        vm.showUserDetailsDrillDown = false;
        vm.showBankDetails = false;
  		vm.showBranchDetails = false;
		//initiate list
        vm.bankSummary = {};
        vm.userDetailsList =[];

		var recordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.noOfRecordsPerPage = recordsPerPage;
		$scope.page = 1;
		$scope.noOfUserRecordsPerPage = recordsPerPage;
		$scope.userPage = 1;
		$scope.noOfBranchRecordsPerPage = recordsPerPage;
		$scope.branchPage = 1;

		vm.getUserDetails = getUserDetails;
		//vm.getUsersLoggedInForTheMoment = getUsersLoggedInForTheMoment;
	   // vm.getUsersLoggedInForTheDay = getUsersLoggedInForTheDay;
		vm.YES = true;
		vm.NO = false;
		vm.isAsOfNow = true;
		vm.BANK_TYPE= "Bank";
	    vm.BRANCH_TYPE= "Branch";
	
		vm.exportToFile = exportToFile;

		vm.todayDate = new Date();
		vm.reportDate = DateUtils.convertDateTimeFromServer(vm.todayDate);

		logScreenAccess();
		loadHeader();

		function loadHeader(){
			vm.bankSummary =[];
			vm.filterText="";
			resetGridsForHeaderSelection();

			LoggedInUsersForBank.getSummaryData({'isAsOfNow' : vm.isAsOfNow}, reportHeaderSuccess, reportHeaderFailure );
		}
		function reportHeaderSuccess(result){
			vm.bankSummary = result;
		}
		function reportHeaderFailure(error){

		}
		function resetGridsForHeaderSelection(){
   		
   	     vm.selectedEntityType = '';
   	     vm.userSummaryFilterText = '';  	
   	        
   	     vm.showUserDetailsDrillDown = false;
   		 vm.showBankDetails = false;
   		 vm.showBranchDetails = false;
   		
   	   }
		function userDetailsSuccess(result){
    		vm.userDetailsList = result;
    		angular.element("#userSearch").focus();
    	}
    	function userDetailsFailure(error){
    		
    	}
    	
    	function getUserDetails(bankId, bankName, entityType, drillDownGridType){
    		setSelectionDetails(bankId, bankName, entityType,drillDownGridType);
    		if(vm.isAsOfNow)
    			LoggedInUsersForBank.getLoggedInUsersAsOFNow({ 'entityOwnerType' : entityType } ,userDetailsSuccess, userDetailsFailure)
        		
    		else
    			LoggedInUsersForBank.getLoggedInUsersForTheDay({ 'entityOwnerType' : entityType } ,userDetailsSuccess, userDetailsFailure)
        		
    	}
    	
    	/*function getUsersLoggedInForTheMoment( entityType){
    		
    		
    		LoggedInUsersForBank.getLoggedInUsersAsOFNow({ 'entityOwnerType' : entityType } ,userDetailsSuccess, userDetailsFailure)
    		
    	}
    	function getUsersLoggedInForTheDay(bankId, bankName, entityType, drillDownGridType){
    		
    		LoggedInUsersForBank.getLoggedInUsersForTheDay({ 'entityOwnerType' : entityType } ,userDetailsSuccess, userDetailsFailure)
    		
    	}*/
    	
    	function setSelectionDetails(bankId, bankName, entityType,drillDownGridType){
   		 
    	    vm.selectedEntityType = entityType;
    	    vm.userSummaryFilterText = '';
    	    setColumDisplayForUserDetails(bankId, bankName, drillDownGridType);
    	}
    	function setColumDisplayForUserDetails(bankId, bankName, drillDownGridType){
    		vm.showUserDetailsDrillDown = true;
    		vm.showBankDetails = false;
    		vm.showBranchDetails = false;
    		
    		if(drillDownGridType ==  vm.BANK_TYPE ){    			
        		vm.showBankDetails = true;
        		vm.userDetailsHeader = "Bank Users"
        		
    		}else if(drillDownGridType == vm.BRANCH_TYPE ){
    			
    			vm.showBranchDetails = true;
    			vm.userDetailsHeader = "Branch Users"
    			
    		}
    	}



		function logScreenAccess(){
			vm.screenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}

	

		/********** Refresh**********/
		$scope.toggle = true;
		function refresh() {
			$scope.toggle = false;
			$scope.refreshFlag = false;
			loadHeader();
			if ($scope.toggle == false) {
				$timeout(function() {
					$scope.toggle = true;
				}, 2000);
				$scope.refreshFlag = false;
			}
		};

		/***********END *************/
	

		$scope.$watch('vm.filterText', function(value){
			resetGridsForHeaderSelection();
		}); 
		$scope.$watch('vm.isAsOfNow', function(newValue, oldValue){
			if(newValue!=null && newValue != undefined && newValue!=oldValue){
				loadHeader();
			}
		}); 



		function exportToFile(fileType){
			vm.baseString =   'No_Of_Logged_In_Users_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   	
			
				if(fileType == 'csv'){
					vm.mimeType = 'text/csv'
					vm.baseString = vm.baseString+ ".csv";  
					LoggedInUsersForBank.getCSVData({'isAsOfNow' : vm.isAsOfNow} , processResponse )
				}else if(fileType == 'excel'){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.baseString = vm.baseString+ ".xls";  
					LoggedInUsersForBank.getExcelData({'isAsOfNow' : vm.isAsOfNow} , processResponse );
				}
			
		}	
		function processResponse(result){
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer


			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	}
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('limit-utilisation-splitup', {
            parent: 'entity',
            url: '/limit-utilisation-splitup',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.limitUtilisationSplitup.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/limit-utilisation-splitup-report/limit-utilisation-splitup-report.html',
                    controller: 'LimitUtilisationSplitupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('limitUtilisationSplitup');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        
        
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('LimitUtilisationSplitup', LimitUtilisationSplitup);

        LimitUtilisationSplitup.$inject = ['$resource'];

    function LimitUtilisationSplitup ($resource) {
        var resourceUrl =  'api/limit-utilisation-splitup/:id';
        
        return $resource(resourceUrl, {}, {
        	
        
        	'getLimitUtilisationSplitupHeader':{
  				method: 'GET',
  				isArray:true,
  				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId',
  					 instrumentId : '@instrumentId'},  				
  				url: 'api/limit-utilisation-splitup-report',
  				 transformResponse: function(data, headers) {
  					if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                 }    
              },
             
              'exportLimitUtilisationSplitupExcel': {
                  method: 'POST',
                  url: 'api/limit-utilisation-splitup-report/excel-download',
                  responseType: 'arraybuffer',
                  params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'},
                  transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   },
                  transformResponse: function(data, headers) {
                	  return {
                          data: data,
                          headers: headers
                      };   
                  }         
             },
              'exportLimitUtilisationSplitupCsv': {
                  method: 'POST',
                  url: 'api/limit-utilisation-splitup-report/csv-download',
                  responseType: 'arraybuffer',
                  transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   },
                  transformResponse: function(data, headers) {
                	  return {
                          data: data,
                          headers: headers
                      };   
                  }         
             }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'limitUtilisationSplitup'
        })
        
        .controller('LimitUtilisationSplitupController', LimitUtilisationSplitupController);

    LimitUtilisationSplitupController.$inject = ['$scope', 'LimitUtilisationSplitup', 'GlobalValues', 'workflowSharedService', 'ScreenLog','entityConstants', 'DefaultMarket'];

    function LimitUtilisationSplitupController($scope, LimitUtilisationSplitup , GlobalValues, workflowSharedService, ScreenLog,entityConstants, DefaultMarket) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.LIMIT_UTILISATION_SPLITUP;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        $scope.noOfRecordsPerPageOrder = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.pageOrder = 1;
        $scope.noOfRecordsPerPageTrade = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.pageTrade = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.clicked=false;
        
        // DefaultMarket.marketInstruments(function(result){
        //     vm.instrumentTypes = result;
        // });
       DefaultMarket.csInstruments({currencyPairId:vm.globalValues.getDefaultCurrencyPairId()},onGetInstrumentSuccess, onGetInstrumentFailure);

       
        function onGetInstrumentSuccess(result) {
            vm.instrumentTypes = result;
            // get tick size for each instrument
		}

		function onGetInstrumentFailure() {

        }



        vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.orgId = vm.globalValues.getOrgId();
        vm.exportToFile = exportToFile;
        vm.filterData = {};
        vm.limitUtilisationSplitupHeaderList = [];
        vm.limitUtilSplitupTradeList=[];
        vm.limitUtilSplitupOrderList=[];
        vm.valid=false;
        
        vm.mimeType= '';  	  
  	  	vm.baseString =   'Limit_Utilisation_Splitup_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   	
        
        if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
            vm.customer = vm.globalValues.getCustomer();
        }
        if(vm.entityOwnerType=='Bank' || vm.entityOwnerType=='Branch'){
        	vm.bank = vm.globalValues.getBank();
        }
        if(vm.entityOwnerType=='Branch'){
        	vm.branch = vm.globalValues.getBranch();
        }
        
        vm.getLimitUtilisationSplitupHeaderList = getLimitUtilisationSplitupHeaderList;
        vm.getLimitUtilSplitupDetails = getLimitUtilSplitupDetails;
        vm.getBuyingPower = getBuyingPower;
        vm.getSellingPower = getSellingPower;
        vm.getExposure = getExposure;

        vm.ExpandOrCollapseLimitUtilisationSplitup=true;
        
        workflowSharedService.viewFrom = "transactionCharges";
       
        
        logScreenAccess();
        
        if (vm.entityOwnerType == 'Clearcorp'){
            vm.disableBank = false;
            vm.disableBranch = false;
            vm.disableCustomer = false;
        }
        else if (vm.entityOwnerType == 'Bank'){
              vm.disableBank = true;
              vm.disableBranch = false;
              vm.disableCustomer = false;
        }
        else if (vm.entityOwnerType == 'Branch'){
              vm.disableBank = true;
              vm.disableBranch = true;
              vm.disableCustomer = false;
        }
        else if (vm.entityOwnerType == 'MultiUserCustomer' || vm.entityOwnerType == 'SingleUserCustomer'){
              vm.disableBank = false;
              vm.disableBranch = true;
              vm.disableCustomer = true;
        }

       function getLimitUtilisationSplitupHeaderList() {
    	   
    	   vm.bankId = 0;
    	   vm.branchId = 0;
    	   vm.customerId= 0;
           vm.instrumentId = 0;
    	   vm.selectedLimitUtilisationSplitupHeader = {};
           vm.limitUtilisationSplitupHeaderList=[];
           vm.limitUtilSplitupTradeList=[];
           vm.limitUtilSplitupOrderList=[];
    	   vm.showTradeDetails = false;
           vm.showOrderDetails = false;
    	   
           if (vm.entityOwnerType == 'Bank' || vm.entityOwnerType == 'Branch'){
               vm.bankId = vm.globalValues.getOrganisation().id;
           }else if(vm.bank!=null && vm.bank!=undefined){
               if(vm.entityOwnerType == 'Clearcorp' || vm.entityOwnerType == 'MultiUserCustomer' || vm.entityOwnerType == 'SingleUserCustomer'){
                      vm.bankId = vm.bank.id;
               }
           }
           
           if(vm.entityOwnerType == 'Branch'){
               vm.branchId = vm.globalValues.getBranch().id;
           }else  if(vm.branch!=null && vm.branch!=undefined){
               if(vm.entityOwnerType=='Clearcorp' || vm.entityOwnerType=='Bank'){
                   vm.branchId = vm.branch.id;
               }
           }
           
           if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
               vm.customerId = vm.globalValues.getCustomerId();
           } else  if(vm.customer!=null && vm.customer!=undefined){
               if(vm.entityOwnerType!='MultiUserCustomer' && vm.entityOwnerType!='SingleUserCustomer'){
                   vm.customerId = vm.customer.id;
               }
           }

           if(vm.instrument!=null && vm.instrument!=undefined){
                vm.instrumentId = vm.instrument.id;
           }
           
           vm.valid = true;
           copyFilterData();
           LimitUtilisationSplitup.getLimitUtilisationSplitupHeader({"bankId": vm.bankId, "branchId":vm.branchId , "customerId" : vm.customerId ,
           "instrumentId": vm.instrumentId},function(result) {  
               vm.limitUtilisationSplitupHeaderList = result;
               vm.clicked=false;
            });        	
  
        }      
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       function getLimitUtilSplitupDetails(limitUtilisationSplitupHeader){
    	   vm.limitUtilSplitupTradeList=[];
           vm.limitUtilSplitupOrderList=[];
    	   vm.selectedLimitUtilisationSplitupHeader = limitUtilisationSplitupHeader; 
           //set limit splitup trade details
    	   vm.limitUtilSplitupTradeList=vm.selectedLimitUtilisationSplitupHeader.limitUtilSplitupTradeDetailsList;
           //if(vm.limitUtilSplitupTradeList!=null && vm.limitUtilSplitupTradeList!=undefined && vm.limitUtilSplitupTradeList.length>0){
                vm.showTradeDetails = true;
           //}

            //set limit splitup order details
            vm.limitUtilSplitupOrderList=vm.selectedLimitUtilisationSplitupHeader.limitUtilSplitupOrderDetailsList;
            //if(vm.limitUtilSplitupOrderList!=null && vm.limitUtilSplitupOrderList!=undefined && vm.limitUtilSplitupOrderList.length>0){
                 vm.showOrderDetails = true;
            //}
         }

      function exportToFile(fileType){
    	  vm.baseString =   'Limit_Utilisation_Splitup_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm_ss');   	
    	  if(vm.limitUtilisationSplitupHeaderList !=null &&  vm.limitUtilisationSplitupHeaderList!=undefined && vm.limitUtilisationSplitupHeaderList.length>0){
    		  if(fileType == 'csv'){
    			 vm.mimeType = 'text/csv'
    			 vm.baseString = vm.baseString+ ".csv";  
    			 LimitUtilisationSplitup.exportLimitUtilisationSplitupCsv({bankId:  vm.filterData.bankId, branchId:  vm.filterData.branchId, 
        			customerId:  vm.filterData.customerId,  instrumentId:  vm.filterData.instrumentId}, vm.limitUtilisationSplitupHeaderList, processResponse )
    		  }else if(fileType == 'excel'){
    			  vm.mimeType = 'application/vnd.ms-excel';
    			  vm.baseString = vm.baseString+ ".xls";  
    			  LimitUtilisationSplitup.exportLimitUtilisationSplitupExcel({bankId:  vm.filterData.bankId, branchId:  vm.filterData.branchId, 
        			customerId:  vm.filterData.customerId,  instrumentId:  vm.filterData.instrumentId}, vm.limitUtilisationSplitupHeaderList, processResponse );
    		  }
    	  }
      }

      function processResponse(result){
    	  var fileData = null;
		  fileData = result.data;
		  var link = document.createElement("a");   
		  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
		  
		  
	      var blob = new Blob([bytes], {type: vm.mimeType});
	      if(window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
	      }else{
	    	  link.href =  window.URL.createObjectURL(blob);      
	    	  link.download = vm.baseString;
	    	  document.body.appendChild(link);
	    	  link.click();
	    	  document.body.removeChild(link);
	      }
	  }

        function copyFilterData(){
        	if(vm.bank!=null && vm.bank !=undefined){
        		vm.filterData.bankId = angular.copy(vm.bank.id);
        	}else{
        		vm.filterData.bankId = 0;
        	}
        	if(vm.branch!=null && vm.branch!=undefined){
        		vm.filterData.branchId = angular.copy(vm.branch.id);
        	}else{
        		vm.filterData.branchId = 0;
        	}if(vm.customer!=null && vm.customer!=undefined){
        		vm.filterData.customerId = angular.copy(vm.customer.id);
        	}else{
        		vm.filterData.customerId = 0;
        	}
        	if(vm.instrument!=null && vm.instrument!=undefined){
        		vm.filterData.instrumentId = angular.copy(vm.instrument.id);
        	}else{
        		vm.filterData.instrumentId = 0;
        	}
        }

      function getBuyingPower(limit){
        var buyingPower = 0;
        var totalBuy = limit.pendingBuyOrder + limit.buyTrade + limit.previousDayBuyTrade;
        var totalSell = limit.pendingSellOrder + limit.sellTrade + limit.previousDaySellTrade;
        if(limit.limitType=='GROSSSELL'){
            buyingPower = 0;
        }else if(limit.limitType=='GROSSBUY'){
            buyingPower = limit.totalAllocatedInUSD - (totalBuy);
        }else if(limit.limitType=='GLOBALGROSS'){
            buyingPower = limit.totalAllocatedInUSD - (totalBuy + totalSell);
        }else if(limit.limitType=='NET'){
            totalBuy = limit.pendingBuyOrder+((limit.buyTrade + limit.previousDayBuyTrade) - (limit.sellTrade + limit.previousDaySellTrade));
            totalSell = limit.pendingSellOrder+((limit.sellTrade + limit.previousDaySellTrade) - (limit.buyTrade  + limit.previousDayBuyTrade));
            var xVals = [];
            xVals.push(totalBuy);
            xVals.push(totalSell);
            buyingPower = limit.totalAllocatedInUSD - totalBuy;
        }
        if (buyingPower < 0) {
            buyingPower = 0; // If negative, set it to 0
          }
        return buyingPower;
    }
    
    function getExposure(limit){
        var exposure = 0;
        var totalBuy = 0;
        var totalSell = 0;
        if(limit.limitType!='NET'){
            totalBuy = limit.pendingBuyOrder + limit.buyTrade + limit.previousDayBuyTrade;
            totalSell = limit.pendingSellOrder + limit.sellTrade + limit.previousDaySellTrade;
            exposure = (limit.pendingBuyOrder + limit.buyTrade + limit.previousDayBuyTrade + limit.pendingSellOrder + limit.sellTrade + limit.previousDaySellTrade) * 100/limit.totalAllocatedInUSD;
        }else{
            totalBuy = limit.pendingBuyOrder+((limit.buyTrade + limit.previousDayBuyTrade) - (limit.sellTrade + limit.previousDaySellTrade));
            totalSell = limit.pendingSellOrder+((limit.sellTrade + limit.previousDaySellTrade) - (limit.buyTrade + limit.previousDayBuyTrade));

            var xVals = [];
            xVals.push(totalBuy);
            xVals.push(totalSell);
            exposure =  Math.max.apply(Math, xVals) * 100/limit.totalAllocatedInUSD;
        }
        return exposure;
    }
    
    function getSellingPower(limit){
        var sellingPower = 0;
        var totalBuy = limit.pendingBuyOrder + (limit.buyTrade + limit.previousDayBuyTrade);
        var totalSell = limit.pendingSellOrder + (limit.sellTrade + limit.previousDaySellTrade);
        if(limit.limitType=='GROSSSELL'){
            sellingPower = limit.totalAllocatedInUSD - (totalSell);
        }else if(limit.limitType=='GROSSBUY'){
            sellingPower = 0;
        }else if(limit.limitType=='GLOBALGROSS'){
            sellingPower = limit.totalAllocatedInUSD - (totalBuy + totalSell);
        }else if(limit.limitType=='NET'){
            totalBuy = limit.pendingBuyOrder+((limit.buyTrade + limit.previousDayBuyTrade) - (limit.sellTrade + limit.previousDaySellTrade));
            totalSell = limit.pendingSellOrder+((limit.sellTrade + limit.previousDaySellTrade) - (limit.buyTrade + limit.previousDayBuyTrade));
            var xVals = [];
            xVals.push(totalBuy);
            xVals.push(totalSell);
            sellingPower = limit.totalAllocatedInUSD - totalSell;
        }
        if (sellingPower < 0) {
            sellingPower = 0; // If negative, set it to 0
          }
        return sellingPower;
    }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoice-view', {
            parent: 'entity',
            params:{screen: 'InvoiceView'},
            url: '/invoice-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.invoiceView.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice-view/invoice-view.html',
                    controller: 'InvoiceViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invoiceView');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                financialYears: ['StaticLookUp', function(StaticLookUp){
               	 return StaticLookUp.getPastAndPresentFinancialYears().$promise;
                }],
                chargeTypes: ['StaticLookUp', function(StaticLookUp){
                  	 return StaticLookUp.getChargesType().$promise;
                   }]
               
            }
        })
       
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('InvoiceView', InvoiceView);

    InvoiceView.$inject = ['$resource'];

    function InvoiceView ($resource) {
        var resourceUrl =  'api/invoice-view/:id';
        
        return $resource(resourceUrl, {}, {
        	
        
        	'getInvoiceDetailsByInvoiceNumber':{
           	 
        		isArray : true,
  				method: 'GET',
  				params: {invoiceNo : '@invoiceNo',orgId : '@orgId'},

  				url: 'api/invoice-view/get-invoice-detais-by-number',
  				transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
              },
              
              'getInvoiceDetails':{
                	 
               	isArray:true,
    				method: 'GET',
    				params: {bankId : '@bankId',chargesTypeId:'@chargesTypeId',financialYearId:'@financialYearId',
    							invoiceStartDate:'@invoiceStartDate',invoiceEndDate:'@invoiceEndDate'},
    				url: 'api/invoice-view/get-all-invoice-details'
                },
            'getReportPeriodList':{
            	isArray:true,
				method: 'GET',
				params:{financialYearFromDate:'@financialYearFromDate',financialYearToDate:'@financialYearToDate'},
				url: 'api/invoice-view/get-all-report-periods'
            },
            'getAnnexureDetails':{
            	isArray:false,
				method: 'GET',
				params: {
					invoiceId: '@invoiceId'
				},
				url: 'api/invoice-view/get-annexure-details'
            },
            'getInvoiceNumbers':{
            	isArray:true,
				method: 'GET',
				url: 'api/invoice-view/get-all-invoice-numbers'
            },
            'regenerateInvoice':{
              	 
        		isArray : true,
  				method: 'GET',
  				params: {invoiceNumber : '@invoiceNumber'},
  				url: 'api/invoice-view/regenerate-invoice-by-number',
  				transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
              }
          
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {
        	this.viewFrom= 'invoiceView'
        })

        .controller('InvoiceViewController', InvoiceViewController);

    InvoiceViewController.$inject = ['$scope', '$state', 'InvoiceView', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
    				'$timeout','DateUtils','StaticLookUp','financialYears','chargeTypes','MessageBox','$rootScope'];

    function InvoiceViewController($scope, $state, InvoiceView , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
    				$timeout,DateUtils,StaticLookUp,financialYears,chargeTypes,MessageBox,$rootScope) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.INVOICE_VIEW;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.financialYear = vm.globalValues.getFinancialYear();
        vm.chargeTypes = chargeTypes;
        vm.financialYears = financialYears;
        vm.financialYear = vm.financialYears[0];
        vm.selectedFilter='group';
        vm.generatePDF = generatePDF;
        vm.regenerateInvoice = regenerateInvoice;
        vm.checkForRegeneration = checkForRegeneration;
        vm.isRegenerated=false;
        vm.invoiceRegeneratedNumber ="";

        vm.todayDate = new Date();

        vm.orgId = vm.globalValues.getOrgId();

        var yesMessageEvent = null;
        vm.clicked=false;
        vm.currentBusinessDate = DateUtils.convertDateTimeFromServer(vm.globalValues.getSystemSettings().businessDate);
       // console.log(moment(vm.currentBusinessDate).subtract(1, 'months').calendar());
        vm.previousDate = moment(vm.currentBusinessDate).subtract(1, 'months').calendar();

     //   vm.currentMonth = moment().subtract(1,'months').month();




        vm.loadReportPeriods=loadReportPeriods;
        vm.getInvoiceView = getInvoiceView;
        vm.ExpandOrCollapseOrderStatusReport=true;

        workflowSharedService.viewFrom = "invoiceView";

        loadReportPeriods();
        logScreenAccess();
       // loadCurrentBusinessDate();


        function loadReportPeriods(){
        	InvoiceView.getReportPeriodList({financialYearFromDate : vm.financialYear.financialYearStart,financialYearToDate:vm.financialYear.financialYearEnd},function(result){
        		vm.reportPeriods = result;
        	});

        	InvoiceView.getInvoiceNumbers(function(result){
        		vm.invoiceNumbers = result;
        	})
        }

        $scope.$watch('vm.selectedFilter',function(value){
        	console.log(vm.selectedFilter);
        	if(value!=null && value!=undefined){
        		if(value=='individual'){
        			document.getElementById("txtbank").value = "";
        			vm.bank=null;
        			document.getElementById("chargesType").value = "";
        			document.getElementById("reportPeriod").value = "";
        		}
        		if(value=='group' && document.getElementById("invoiceNumber")!=null && document.getElementById("invoiceNumber")!=undefined){
        			document.getElementById("invoiceNumber").value = "";
        			//vm.invoiceNumber='';
        		}
        	}
        })

       function getInvoiceView() {

    	   vm.chargesTypeId = 0;
    	   vm.convertedStartDate = null;
    	   vm.convertedEndDate = null;

    	   if(vm.chargesType!=null && vm.chargesType!=undefined && vm.chargesType!=""){
    		   vm.chargesTypeId = vm.chargesType.id;
    	   }

    	   if(vm.reportPeriod!=null && vm.reportPeriod!=undefined && vm.reportPeriod!=""){
    		   var reportDates = vm.reportPeriod.split(" to ");
    		   vm.reportStartDate = parseDate(reportDates[0]);
    		   vm.reportEndDate = parseDate(reportDates[1]);
    		   vm.convertedStartDate = DateUtils.convertLocalDateToServer(vm.reportStartDate);
    		   vm.convertedEndDate = DateUtils.convertLocalDateToServer(vm.reportEndDate);
    	   }
    	  if(vm.invoiceNumber!=null && vm.invoiceNumber!=undefined && vm.selectedFilter=='individual'){
    		  InvoiceView.getInvoiceDetailsByInvoiceNumber({"invoiceNo":vm.invoiceNumber, "orgId":vm.orgId}, function(result){

    			  angular.forEach(result,function(value){
					  value.invoiceEndDate = DateUtils.convertDateTimeFromServer(value.invoiceEndDate);
					  vm.initialString = buildFileNames(value);
					  value.originalFileName = vm.initialString + '.pdf';
					  value.duplicateFileName = vm.initialString + '_dup.pdf';
					  value.annexureFileName = vm.initialString + '.xlsx';

				  })

    			  vm.invoiceView = result;
				  vm.clicked=false;

    		  })
    	  }else{
    		  InvoiceView.getInvoiceDetails({"bankId":vm.bank.id,"chargesTypeId":vm.chargesTypeId,"financialYearId":vm.financialYear.id,
    			  "invoiceStartDate":vm.convertedStartDate,"invoiceEndDate":vm.convertedEndDate},function(result){

    				  angular.forEach(result,function(value){
    					  value.invoiceEndDate = DateUtils.convertDateTimeFromServer(value.invoiceEndDate);
    					  vm.initialString = buildFileNames(value);
						  value.originalFileName = vm.initialString + '.pdf';
						  value.duplicateFileName = vm.initialString + '_dup.pdf';
						  value.annexureFileName = vm.initialString + '.xlsx';
    				  })




    			  vm.invoiceView = result;
				  vm.clicked=false;
    		  })
    	  }


       }

        function checkForRegeneration(invoice){

        	if(moment(invoice.invoiceEndDate).month()==moment(vm.previousDate).month() && moment(invoice.invoiceEndDate).year()==moment(vm.previousDate).year() && invoice.active){
        		return true;
        	}else{
        		return false;
        	}
        }

        function parseDate(s) {
        	  var months = {jan:0,feb:1,mar:2,apr:3,may:4,jun:5,
        	                jul:6,aug:7,sep:8,oct:9,nov:10,dec:11};
        	  var p = s.split('-');
        	  return new Date(p[2], months[p[1].toLowerCase()], p[0]);
        	}


       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }

       function generatePDF(invoice, fileType){

    	   InvoiceView.getAnnexureDetails({invoiceId: invoice.id}, function(result){
    		   var link = document.createElement("a");
    		   var fileData = null;
    		   vm.baseString = buildFileNames(invoice);
    		   if(fileType=='original'){
        		   fileData = result.originalInvoice;
        		   link.download = vm.baseString;
    		   }else if(fileType=='duplicate'){
        		   fileData = result.duplicateInvoice;
        		   link.download = vm.baseString + '_dup';
    		   }else if(fileType=='annexure'){
        		   fileData = result.annexures;
        		   link.download = vm.baseString;
    		   }
    		  
 			var fileTypeDetected = getFileTypeFromBase64(fileData);
			   if(fileTypeDetected === 'xls'){
				link.href = 'data:application/vnd.ms-excel;base64,' + fileData;
			   }else if(fileType=='annexure'){
        			link.href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + fileData;
    			}else{
        			link.href = 'data:application/pdf;base64,'+ encodeURI(fileData);
    	       		
     		   	}
	      		
    			  document.body.appendChild(link);
    			  link.title="title";
    			  link.setAttribute('title', 'signature');
    			  link.click();
    			  document.body.removeChild(link);
    	   })
    	   

       }

	   function getFileTypeFromBase64(base64Data) {
    if (!base64Data) return null;

    // Remove metadata if present (data:...;base64,)
    const cleanBase64 = base64Data.split(',').pop();

    // Get first few characters
    const prefix = cleanBase64.substring(0, 10);

    // PDF starts with JVBER
    if (prefix.startsWith("JVBER")) {
        return "pdf";
    }

    // XLSX (ZIP format) starts with UEsDB
    if (prefix.startsWith("UEsDB")) {
        return "xlsx";
    }

    // XLS (old format) usually starts with 0M8R (base64: 0M8R...)
    if (prefix.startsWith("0M8R")) {
        return "xls";
    }

    return "unknown";
}
       
       /*function regenerateInvoice(invoiceNumber){
    	   
    	if(invoiceNumber!=null && invoiceNumber!=undefined){
    		$scope.invoiceNumber = invoiceNumber;
    		MessageBox.openMessageBox("Alert", "Do you want to regenerate Invoice?", "YesNo", "regenerateInvoice");

    	}
    	}*/
    	function regenerateInvoice(invoiceId){

    		if(invoiceId!=null && invoiceId!=undefined){
    			$scope.invoiceNumber = invoiceId;
    			MessageBox.openMessageBox("Alert", "Do you want to regenerate the selected Invoice?", "YesNo", "regenerateInvoice");

    		}
    	}

    	  $scope.$on('$destroy', function() {
    		  if (yesMessageEvent!=null )
    			  	yesMessageEvent();
	        });


       	 yesMessageEvent = $rootScope.$on('gatewayApp.messagebox.yes.regenerateInvoice', function (event, data) {
    			if($scope.invoiceNumber!=null && $scope.invoiceNumber!=undefined){
    				InvoiceView.regenerateInvoice({invoiceNo : $scope.invoiceNumber}, regenerateInvoiceSuccess,regenerateInvoiceFailure);
    			}
    		});


		$rootScope.$on('gatewayApp.messagebox.no.regenerateInvoice', function (event, data) {
			//do nothing
		});

		function regenerateInvoiceSuccess(result){
			getInvoiceView();
			vm.isRegenerated = true;
			vm.invoiceRegeneratedNumber = vm.filterData[0].invoiceNumber;
			console.log(vm.isRegenerated);
		}

		function regenerateInvoiceFailure(){

		}

		function buildFileNames(invoice){
			var convertedCurrentBusinessDate = DateUtils.convertLocalDateToServer(invoice.invoiceEndDate);

			var generatedDate = DateUtils.convertDateTimeFromServer(invoice.invoiceGeneratedDate);
			var initialString = 'tmp_' + invoice.bank.ccpMembershipId + '_FX';
			if(invoice.chargesType.shortName=='AMC'){
				initialString = initialString + '0002_A';
			}else if(invoice.chargesType.shortName=='OneTimeRegistration'){
				initialString = initialString + '0003_M';
			}else if(invoice.chargesType.shortName=='Transaction'){
				initialString = initialString + '0001_M';
			}

			initialString = initialString + '_F_F_' + moment(invoice.invoiceEndDate).format("YYYYMMDD") + '_' +  moment(generatedDate).format("YYYYMMDD");
			return initialString;

		}
		$scope.$watch('vm.filterText', function(value){
			if( vm.isRegenerated==true && vm.filterData.length >0 &&  vm.invoiceRegeneratedNumber != vm.filterData[0].invoiceNumber){
				vm.isRegenerated=false;
			}
        });


    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('IntradayMarketSessionDialogController', IntradayMarketSessionDialogController);

    IntradayMarketSessionDialogController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','Workflow','$uibModalInstance',
    				'IntradayMarket','entity','StaticLookUp','DateUtils','AlertService','$filter'];

     function IntradayMarketSessionDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService,Workflow, $uibModalInstance,
    		 			IntradayMarket,entity,StaticLookUp,DateUtils,AlertService,$filter) {
        var vm = this;
        vm.intradayMarket=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        $scope.showApproveRejectButton=false;
        $scope.showDiscardButton = false;
    	$scope.showResubmitButton=false;
        vm.resubmitIntradayMarket = resubmitIntradayMarket;
        vm.globalValues = GlobalValues;
        vm.discardIntradayMarket = discardIntradayMarket;
        vm.rejectIntradayMarket= rejectIntradayMarket;
        vm.approveIntradayMarket= approveIntradayMarket;
       vm.viewMode=false;
      //vm.controlMinDate =new Date();
      vm.controlMinDate =vm.globalValues.getSystemSettings().businessDate;
      vm.validateSessionTime = validateSessionTime;
                
        if(workflowSharedService.viewFrom == 'intradayMarketSessionSettings'){
        	vm.intradayMarket=entity;
			vm.currencyPair = vm.intradayMarket.instrument.currencyPair;
        	vm.intradayMarket.businessDate = new Date(vm.intradayMarket.businessDate);
        	vm.openTime = moment(vm.intradayMarket.openTime, 'HH:mm');
        	vm.closeTime = moment(vm.intradayMarket.closeTime,'HH:mm');
        	 if(!vm.intradayMarket.instrument.instrumentApplicable){
            AlertService.error("Instrument is disabled. Editing is not allowed");
             $scope.showButton = false;
            }else if(vm.intradayMarket.instrument.isSettlementDateHoliday){
                AlertService.error("Holiday for the instrument. Editing is not allowed");
                 $scope.showButton = false;
            }else{
                $scope.showButton = true;
            }
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'intradayMarketSessionSettings_todolist_resubmit') {
        	vm.intradayMarket =  angular.fromJson($rootScope.payload);
			vm.currencyPair = vm.intradayMarket.instrument.currencyPair;
        	vm.intradayMarket.businessDate = new Date(vm.intradayMarket.businessDate);
        	vm.openTime = moment(vm.intradayMarket.openTime, 'HH:mm');
        	vm.closeTime = moment(vm.intradayMarket.closeTime,'HH:mm');
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=true;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'intradayMarketSessionSettings_todolist_checker') {
        	vm.intradayMarket =  angular.fromJson($rootScope.payload); 
			vm.currencyPair = vm.intradayMarket.instrument.currencyPair;
        	vm.intradayMarket.businessDate = new Date(vm.intradayMarket.businessDate);
        	vm.openTime = moment(vm.intradayMarket.openTime, 'HH:mm');
        	vm.closeTime = moment(vm.intradayMarket.closeTime,'HH:mm');
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = true;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom == 'intradayMarketSessionSettings_todolist_maker') {
        	vm.intradayMarket =  angular.fromJson($rootScope.payload); 
			vm.currencyPair = vm.intradayMarket.instrument.currencyPair; 
        	vm.intradayMarket.businessDate = new Date(vm.intradayMarket.businessDate);
        	vm.openTime = moment(vm.intradayMarket.openTime, 'HH:mm');
        	vm.closeTime = moment(vm.intradayMarket.closeTime,'HH:mm');
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = true;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom=='intradayMarketSessionSettings_auditlog'){
        	vm.intradayMarket =  angular.fromJson($rootScope.payload);   
			vm.currencyPair = vm.intradayMarket.instrument.currencyPair; 
        	vm.intradayMarket.businessDate = new Date(vm.intradayMarket.businessDate);
        	vm.openTime = moment(vm.intradayMarket.openTime, 'HH:mm');
        	vm.closeTime = moment(vm.intradayMarket.closeTime,'HH:mm');
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
        
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	
        	if(vm.intradayMarket.sessionStatus != 'OPEN' && !vm.validateSessionTime(vm.openTime)){
        		 AlertService.error($filter('translate')('gatewayApp.intradayMarket.pastOpenTime'));
        		 vm.clicked = false;
        	}
        		
        	else if(!vm.validateSessionTime(vm.closeTime)){
        		AlertService.error($filter('translate')('gatewayApp.intradayMarket.pastCloseTime'));
        		vm.clicked = false;
        	}
        		 
        	else{
        		
        		vm.intradayMarket.openTime = vm.openTime.format( 'HH:mm');
            	vm.intradayMarket.closeTime = vm.closeTime.format( 'HH:mm');
            	
            	
                    	IntradayMarket.update({
            					"orgId" : GlobalValues.getOrgId()
            				}, vm.intradayMarket, onSaveSuccess, onSaveError);
        	}
        	
        			
        	
         }
      
       
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	
        	vm.clicked = false;
        }
        function resubmitIntradayMarket() {
        	
        	if(vm.intradayMarket.sessionStatus != 'OPEN' && !vm.validateSessionTime(vm.openTime)){
        		 AlertService.error($filter('translate')('gatewayApp.intradayMarket.pastOpenTime'));
        		 vm.clicked = false;
        	}
        		
        	else if(!vm.validateSessionTime(vm.closeTime)){
        		AlertService.error($filter('translate')('gatewayApp.intradayMarket.pastCloseTime'));
        		vm.clicked = false;
        	}
        		 
        	else{
        		
        		vm.intradayMarket.openTime = vm.openTime.format( 'HH:mm');
            	vm.intradayMarket.closeTime = vm.closeTime.format( 'HH:mm');
        	
        			IntradayMarket.resubmit({"taskId" : $rootScope.taskID}, vm.intradayMarket, onResubmitSuccess, onResubmitError);
                	
               		
                	$uibModalInstance.dismiss('cancel');
       	}
        	
        	
        	
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {}

        function approveIntradayMarket() { 
        	IntradayMarket.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectIntradayMarket() { Workflow.rejectTask($rootScope.taskID); }

        function discardIntradayMarket() {
        	IntradayMarket.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }
        
        
        function validateSessionTime(inputTime){
        	
        	var isValidOpenTime = true;
        	 vm.currentTimeMoment = moment(new Date(), 'HH:mm A').format('HH:mm A');
      	   var currentTime = moment(vm.currentTimeMoment, 'HH:mm A');
      	   
      	  if(currentTime.isAfter(moment(inputTime, 'HH:mm A'))){
      		  	isValidOpenTime = false;
			}
      	  
      	  return isValidOpenTime;
        }
        	
        

     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('intraday-market-session-settings', {
            parent: 'entity',
            url: '/intraday-market-session-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.intradayMarketSessionSettings.manageIntradayMarketSessionSettings" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/intraday-market-session-settings/intraday-market-session-settings.html',
                    controller: 'intradayMarketSessionSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('intradayMarketSessionSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('intraday-market-edit', {
            parent: 'intraday-market-session-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intraday-market-session-settings/intraday-market-session-settings-dialog.html',
                    controller: 'IntradayMarketSessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['IntradayMarket', 'GlobalValues', function(IntradayMarket, GlobalValues) {
                                     return IntradayMarket.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }],            
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('intradayMarketSessionSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
        .state('intraday-market-session-settings-todolist', {
            parent: 'dashboard',
            url: '/intradaymarketSessionSEttings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intraday-market-session-settings/intraday-market-session-settings-dialog.html',
                    controller: 'IntradayMarketSessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('intraday-market-session-settings', null, { reload: 'intraday-market-session-settings' });
                }, function() {
                    $state.go('^');
                });
            }],
                 resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('intradayMarketSessionSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
        .state('intraday-market-todolist-resubmit', {
            parent: 'dashboard',
            url: '/intradaymarketSettingsEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intraday-market-session-settings/intraday-market-session-settings-dialog.html',
                    controller: 'IntradayMarketSessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('intraday-market-session-settings', null, { reload: 'intraday-market-session-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('intraday-market-settings-auditLog', {
            parent: 'audit-log',
            url: '/intradayMarketSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intraday-market-session-settings/intraday-market-session-settings-dialog.html',
                    controller: 'IntradayMarketSessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('intraday-market-session-settings', null, { reload: 'intraday-market-session-settings' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('intradayMarketSessionSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
        
         .state('intraday-market-settings-historyReport', {
            parent: 'history-report',
            url: '/intradayMarketSettingsHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intraday-market-session-settings/intraday-market-session-settings-dialog.html',
                    controller: 'IntradayMarketSessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('intraday-market-session-settings', null, { reload: 'intraday-market-session-settings' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('intradayMarketSessionSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('IntradayMarket', IntradayMarket);

    IntradayMarket.$inject = ['$resource'];

    function IntradayMarket ($resource) {
        var resourceUrl =  'api/intraday-market-session-settings/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId',currentBusinessDate :'@currentBusinessDate'},
        	    url: 'api/currentBusinessDate/:currentBusinessDate/intraday-market-session-settings'
        	 },
         	
         	'getMarketSessionSettings': { method: 'GET', isArray: true,
        		url: 'api/market-session-settings/:currentBusinessDate/currentBusinessDate',
         		params: {orgId:'@orgId',currentBusinessDate :'@currentBusinessDate'}
        	 },
         	
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
        	 'getIntradayMarketSessionSettingsForInstrument': {
                 method: 'GET',
                 url: 'api/market-session-settings/:instrument/instrument',
                 params: {instrument: '@instrument'},
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
             'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/intraday-market-session-settings/orgId/:orgId',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
        	
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/update-intraday-market-session-settings/orgId/:orgId',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/intraday-market-settings',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              },
              'getCurrentBusinessDate': {
                  method: 'GET',  
                  url: 'api/get-current-business-date',
                  transformResponse : function(data) {
  					if (data) {
  						data = angular.fromJson(data);
  					}
  					return data;
  				}
              },
              'getMessagesInBCMQ' : {
				method : 'GET',
        	    url: 'api/messages/getMessagesInBCMQ'
			}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'intradayMarketSessionSettings'
        })
        
        .controller('intradayMarketSessionSettingsController', intradayMarketSessionSettingsController);

    intradayMarketSessionSettingsController.$inject = ['$scope', '$state', 'IntradayMarket', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','DateUtils','$filter','$timeout','AlertService'];

    function intradayMarketSessionSettingsController($scope, $state, IntradayMarket , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,DateUtils,$filter,$timeout,AlertService) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.INTRADAY_MARKET_SESSION_SETTINGS;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "intradayMarketSessionSettings";
        vm.currentBusinessDate;
        vm.convertedCurrentBusinessDate;
        vm.permitIntradayMarketEditAction = EntityPermissions.hasPermission('IntradayMarketSessionSettings.EDIT');
        $scope.refresh=refresh;
        vm.editIntradayMarket = editIntradayMarket;
        vm.todayDate = new Date();
        
        logScreenAccess();
      loadCurrentBusinessDate();
    //    loadAll();
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       function loadCurrentBusinessDate(){
    	   IntradayMarket.getCurrentBusinessDate(getBusinessDateSuccess, getBusinessDateFailed);
       }
       
       function getBusinessDateSuccess(result){
    	   vm.currentBusinessDate = DateUtils.convertLocalDateFromServer(result.businessDate);
    	   vm.convertedCurrentBusinessDate=DateUtils.convertLocalDateToServer(vm.currentBusinessDate);
    	   IntradayMarket.query({"currentBusinessDate":vm.convertedCurrentBusinessDate},function(result) {
    		   	
    		   angular.forEach(result, function(value){
			   		
	    			  var closeTime = value.closeTime.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)?$/) || [value.closeTime];
	    			   
	    			  closeTime = closeTime.slice (1);  
	    			  closeTime[5] = ' ';
	    			  closeTime[6] = +closeTime[0] < 12 ? 'AM' : 'PM'; 
	    			  closeTime[0] = +closeTime[0] % 12 || 12;
	    			  if(closeTime[0]<=9){
	    				  closeTime[0]=0+""+closeTime[0];
	    			  }
				    value.closeTime = closeTime.join (''); 
				    
				    
				    var openTime = value.openTime.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)?$/) || [value.openTime];
	    			   
				    openTime = openTime.slice (1);  
				    openTime[5] = ' ';
				    openTime[6] = +openTime[0] < 12 ? 'AM' : 'PM'; 
				    openTime[0] = +openTime[0] % 12 || 12;
				    if(openTime[0]<=9){
				    	openTime[0]=0+""+openTime[0];
				    }
				    value.openTime = openTime.join (''); 
				  });
				  
				  
				  vm.intradayMarket = result;
				
		 
             });
       }
       function getBusinessDateFailed(){
    	   
       }
       
       function editIntradayMarket(intradayMarket,$event){
    	   vm.currentTimeMoment = moment(new Date(), 'HH:mm A').format('HH:mm A');
    	   var currentTime = moment(vm.currentTimeMoment, 'HH:mm A');
    	   console.log(intradayMarket.openTime);
    	   console.log(currentTime.isBefore(moment(intradayMarket.openTime, 'HH:mm A')));
    	   if(intradayMarket.sessionStatus == 'CLOSED' && currentTime.isAfter(moment(intradayMarket.openTime, 'HH:mm A'))){
    		   AlertService.error($filter('translate')('gatewayApp.intradayMarket.closedSession'));
    	   }else{
    		   $state.params = {id:intradayMarket.id};
      			var state = 'intraday-market-edit';
      			$state.go(state,{id:intradayMarket.id});
    	   }
       }
       
      /* function loadAll(){
    	   
    	   vm.currentDate=DateUtils.convertLocalDateToServer(vm.todayDate);
    	   IntradayMarket.query({"currentBusinessDate":vm.currentDate},function(result) {
    		   	
    		   angular.forEach(result, function(value){
			   		
	    			  var closeTime = value.closeTime.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)?$/) || [value.closeTime];
	    			   
	    			  closeTime = closeTime.slice (1);  
	    			  closeTime[5] = ' ';
	    			  closeTime[6] = +closeTime[0] < 12 ? 'AM' : 'PM'; 
	    			  closeTime[0] = +closeTime[0] % 12 || 12;
	    			  if(closeTime[0]<=9){
	    				  closeTime[0]=0+""+closeTime[0];
	    			  }
				    value.closeTime = closeTime.join (''); 
				    
				    
				    var openTime = value.openTime.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)?$/) || [value.openTime];
	    			   
				    openTime = openTime.slice (1);  
				    openTime[5] = ' ';
				    openTime[6] = +openTime[0] < 12 ? 'AM' : 'PM'; 
				    openTime[0] = +openTime[0] % 12 || 12;
				    if(openTime[0]<=9){
				    	openTime[0]=0+""+openTime[0];
				    }
				    value.openTime = openTime.join (''); 
				  });
				  
				  
				  vm.intradayMarket = result;
				
		 
             });
       }*/
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadCurrentBusinessDate();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };
      
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ManageInstrumentController', ManageInstrumentController);

    ManageInstrumentController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','InstrumentView','entity','DateUtils','Workflow','IntradayMarket','MessageBox'];

     function ManageInstrumentController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,InstrumentView,entity,DateUtils,Workflow,IntradayMarket,MessageBox) {
        var vm = this;
        vm.manageInstrument=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        $scope.showApproveRejectButton=false;
        $scope.showDiscardButton = false;
    	$scope.showResubmitButton=false;
        vm.resubmit = resubmit;
        vm.globalValues = GlobalValues;
        vm.discard = discard;
        vm.reject= reject;
        vm.approve= approve;
        vm.viewMode=false;
        vm.showEffectiveFrom=false;
        
        $scope.showButton = false;
        vm.orgId = vm.globalValues.getOrgId();

        IntradayMarket.getIntradayMarketSessionSettingsForInstrument({"instrument":'InterbankSPOT'}, onGetMarketSessionSuccess, onGetMarketSessionFailure);
		
    	function onGetMarketSessionSuccess(result){
        	vm.marketSessionSettings = result;
        }

        function onGetMarketSessionFailure(){
        }
           
        if(workflowSharedService.viewFrom == 'instrumentView'){
        	vm.manageInstrument=entity;
        	$scope.showButton = true;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	vm.viewMode=false;              
        }
        else if(workflowSharedService.viewFrom == 'manage_instrumenttodolist_resubmit') {
        	vm.manageInstrument =  angular.fromJson($rootScope.payload);
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=true;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'manage_instrumenttodolist_checker') {
        	vm.manageInstrument =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = true;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom == 'manage_instrumenttodolist_maker') {
        	vm.manageInstrument =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = true;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom=='manage_instrument_auditlog'){
        	vm.manageInstrument =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
		
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () { 
                if (vm.marketSessionSettings && vm.marketSessionSettings.sessionStatus == 'OPEN') {
                MessageBox.openMessageBox("Alert", "Modification is permitted only after the IB.SPOT market hours...!", "Ok", "");
                vm.viewMode=true;
                return;
                 }
            
                if(vm.manageInstrument.currencyPair != null && vm.manageInstrument.currencyPair != undefined){
                vm.manageInstrument.currencyPairId = vm.manageInstrument.currencyPair.id;
                }
				InstrumentView.update({
					"orgId" : GlobalValues.getOrgId()
				}, vm.manageInstrument, onSaveSuccess, onSaveError);	
         }
      
       
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	
        	vm.clicked = false;
        }
        function resubmit() {
        	
        	
        	InstrumentView.resubmit({"taskId" : $rootScope.taskID},  vm.manageInstrument, onResubmitSuccess, onResubmitError);
        	
       		
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {
        	vm.clicked = false;
        }
        
        function approve() { 
        	InstrumentView.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function reject() { Workflow.rejectTask($rootScope.taskID); }

        function discard() {
        	InstrumentView.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }
        
        

       
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('instrument-view', {
            parent: 'entity',
            params: {screen: 'InstrumentView'},
            url: '/instrument-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.instrumentView.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/instrument-view/instrument-view.html',
                    controller: 'InstrumentViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('instrumentView');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })

        .state('manage_instrument-edit', {
            parent: 'instrument-view',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instrument-view/manage-instrument-dialog.html',
                    controller: 'ManageInstrumentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	
                            	 entity: ['InstrumentView', 'GlobalValues', function(InstrumentView, GlobalValues) {
                                     return InstrumentView.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('instrumentView');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })

        .state('manage-instrument-todolist', {
            parent: 'dashboard',
            url: '/manageInstrument',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instrument-view/manage-instrument-dialog.html',
                    controller: 'ManageInstrumentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('instrument-view', null, { reload: 'instrument-view' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('instrumentView');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })

        .state('manage-instrument-resubmit', {
            parent: 'dashboard',
            url: '/manageInstrumentEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instrument-view/manage-instrument-dialog.html',
                    controller: 'ManageInstrumentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('instrument-view', null, { reload: 'instrument-view' });
                }, function() {
                    $state.go('^');
                });
            }]
        })

          .state('instrument-auditLog', {
            parent: 'audit-log',
            url: '/manageInstrumentAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instrument-view/manage-instrument-dialog.html',
                    controller: 'ManageInstrumentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('instrument-view', null, { reload: 'instrument-view' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('instrumentView');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
        
        .state('manage-instrument-historyReport', {
            parent: 'history-report',
            url: '/manageInstrumentHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instrument-view/manage-instrument-dialog.html',
                    controller: 'ManageInstrumentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('instrument-view', null, { reload: 'instrument-view' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('instrumentView');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('InstrumentView', InstrumentView);

    InstrumentView.$inject = ['$resource'];

    function InstrumentView ($resource) {
        var resourceUrl =  'api/instrument-view/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/orgId/:orgId/instrument-view'
        	 },
            'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           	
             'update': {
             	method:'POST',
             	params: {orgId:'@orgId'},
                url: 'api/manage-instrument/orgId/:orgId',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/manage-instrument',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'instrumentView'
        })
        
        .controller('InstrumentViewController', InstrumentViewController);

    InstrumentViewController.$inject = ['$scope', '$state', 'InstrumentView', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout'];

    function InstrumentViewController($scope, $state, InstrumentView , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.INSTRUMENT_VIEW;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        $scope.refresh=refresh;
        workflowSharedService.viewFrom = "instrumentView";
       
        
        logScreenAccess();
        loadAll();

        vm.permitInstrumentEditEntityAction = EntityPermissions.hasPermission('ManageInstrument.EDIT')

       function loadAll() {
    	   InstrumentView.query({"orgId": GlobalValues.getOrgId()},function(result) {
                vm.instruments = result;
             });        	
        }      
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('HomePageReportsController', HomePageReportsController);

    HomePageReportsController.$inject = ['$scope', '$rootScope', '$state',  '$uibModalInstance', '$stateParams', 
    'GlobalValues', 'OrderStatusDetails', 'MessageBox', '$filter', 'DateUtils', 'DefaultMarket', 'LimitSettings',
    'TradesDownload', 'GenerateDealTicket','CustomerBankRelationshipReport', 'EntityPermissions', '$controller',
    'MarketWatch'];

    function HomePageReportsController($scope, $rootScope, $state, $uibModalInstance, $stateParams, 
        GlobalValues, OrderStatusDetails, MessageBox, $filter, DateUtils, DefaultMarket, LimitSettings,
        TradesDownload, GenerateDealTicket,CustomerBankRelationshipReport, EntityPermissions, $controller,
        MarketWatch) {
        var vm = this;
        
        vm.clear=clear;
        vm.hasPermission = EntityPermissions.hasPermission;

        vm.globalValues = GlobalValues;
        vm.noOfRecordsPerPageOP = 10;
        vm.pageOP = 1;
        vm.noOfRecordsPerPageTrade = 10;
        vm.pageTrade = 1;
        vm.noOfRecordsPerPageOT = 10;
        vm.pageOT = 1;
        vm.noOfRecordsPerPageLimit = 10;
        vm.pageLimit = 1;

        //initialize variables
        vm.customerFilterForPO=$rootScope.customerFilterForPO;
        vm.customerFilterForLimit=$rootScope.customerFilterForLimit;
        vm.customerFilterForTrade=$rootScope.customerFilterForTrade;
        vm.customerFilterForOT=$rootScope.customerFilterForOT;

        vm.bankFilterForPO=$rootScope.bankFilterForPO;
        vm.bankFilterForLimit=$rootScope.bankFilterForLimit;
        vm.bankFilterForTrade=$rootScope.bankFilterForTrade;
        vm.bankFilterForOT=$rootScope.bankFilterForOT;

        vm.branchFilterForPO=$rootScope.branchFilterForPO;
        vm.branchFilterForLimit=$rootScope.branchFilterForLimit;
        vm.branchFilterForTrade=$rootScope.branchFilterForTrade;
        vm.branchFilterForOT=$rootScope.branchFilterForOT;

        vm.instrumentFilterForPO=$rootScope.instrumentFilterForPO;
        vm.instrumentFilterForLimit=$rootScope.instrumentFilterForLimit;
        vm.instrumentFilterForTrade=$rootScope.instrumentFilterForTrade;
        vm.instrumentFilterForOT=$rootScope.instrumentFilterForOT;

        vm.fromSettlementDate = $rootScope.fromSettlementDate;
        vm.toSettlementDate = $rootScope.toSettlementDate;
        vm.selectAll = $rootScope.selectAll;

        vm.currencyPairForPO = $rootScope.currencyPairForPO;
    	vm.currencyPairForOT = $rootScope.currencyPairForOT;
    	vm.currencyPairForTrade = $rootScope.currencyPairForTrade;
    	vm.currencyPairForLimit = $rootScope.currencyPairForLimit;
        vm.currencyPairForMarkup = $rootScope.currencyPairForMarkup;


        
        vm.orderStatusList = $rootScope.orderStatusList;

        // angular.extend(this, $controller('HomeController', {
        //     $scope : $scope, $uibModalInstance: $uibModalInstance, reload:false
        // }));

        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.poDetails = true;
        vm.tradeDetails = false;
        vm.otDetails = false;
        vm.limitDetails = false;
        vm.reportTab = $rootScope.reportTab;

        vm.permitModifyOrderEntry = vm.hasPermission('OrderEntry.EDIT');
        vm.permitCancelOrderEntry = vm.hasPermission('OrderEntry.DELETE');
        vm.permitCustomerLimitSettings = vm.hasPermission('CustomerLimitChangeRequest');

        //actions
        vm.modifyOrder = modifyOrder;
        vm.cancelOrder = cancelOrder;
        vm.cancelPendingOrdersSelected = cancelPendingOrdersSelected;
        vm.cancelAllOrders = cancelAllOrders;
        vm.cancelTrade = cancelTrade;
        vm.rolloverTrade = rolloverTrade;
        vm.earlyDeliveryTrade = earlyDeliveryTrade;
        vm.checkOrUncheckPendingOrderItem = checkOrUncheckPendingOrderItem;
        vm.checkOrUncheckPendingOrders = checkOrUncheckPendingOrders;
        vm.checkOrUncheckOutstandingTradesItem= checkOrUncheckOutstandingTradesItem;
        vm.changeRequest = changeRequest;
        vm.newLimitRequest = newLimitRequest;

        vm.getBuyingPower = getBuyingPower;
        vm.getSellingPower = getSellingPower;
        vm.getExposure = getExposure;
        vm.printDealTicket = printDealTicket;
        vm.printDealTicketOutstandingTrade = printDealTicketOutstandingTrade;

        if($rootScope.account.organisation.organisationType.shortName=='CUSTOMER'){
            vm.custCode= vm.globalValues.getCustomer().customerCode;
        }

        //DefaultMarket.marketInstruments(onGetInstrumentSuccess, onGetInstrumentFailure);
        getInstrumentMatchedCurrencypair();

        // function onGetInstrumentSuccess(result){
        //     vm.instrumentTypes = result;
        // }

        // function onGetInstrumentFailure(){
            
        // }

        //initialize methods
        vm.getPendingOrdersReport = getPendingOrdersReport;
        vm.getTradesReport = getTradesReport;
        vm.getOutstandingTradesReport = getOutstandingTradesReport; 
        vm.getLimitUtilisedReport = getLimitUtilisedReport;
        //implementation of methods
        //get pending orders report
        function getPendingOrdersReport(){
            vm.clickedReport=true;
            var instrumentTypeId = 0;
            if(vm.instrumentFilterForPO!=null && vm.instrumentFilterForPO!=undefined){
                instrumentTypeId = vm.instrumentFilterForPO.id;
            }

            getPendingOrderReportForInstrument(instrumentTypeId);
            syncInputsToHomePage();
        }
        
        function getCurrencyPairId(){
            var currencyPairId = 0;

            if(vm.currencyPair !=null){
                    currencyPairId = vm.currencyPair.id;
                }
            
            return currencyPairId;
        }

        // get pending orders reports for given instrument
        function getPendingOrderReportForInstrument(){
            var bankId = getBankIdForReportFilters('PO');
            var branchId = getBranchIdForReportFilters('PO');
            var customerId = getCustomerIdForReportFilters('PO');
            var instrumentId = getInstrumentIdForReportFilters('PO');
            var currencyPairId = getCurrencyPairId;

            if($rootScope.account.organisation.organisationType.shortName=='CLEARCORP'){
                getPendingOrders(bankId, branchId, customerId,instrumentId,currencyPairId);
            }else if($rootScope.account.organisation.organisationType.shortName=='BANK' && vm.globalValues.getEntityOwnerType().shortName!='Branch'){
                if(bankId!=0){
                    getPendingOrders(bankId, branchId, customerId,instrumentId,currencyPairId);
                }
            }else if($rootScope.account.organisation.organisationType.shortName=='BANK' && vm.globalValues.getEntityOwnerType().shortName=='Branch'){
                if(bankId!=0 && branchId!=0){
                    getPendingOrders(bankId, branchId, customerId,instrumentId,currencyPairId);
                }
            }else if($rootScope.account.organisation.organisationType.shortName=='CUSTOMER'){
                if(customerId!=0){
                    getPendingOrders(bankId, branchId, customerId,instrumentId,currencyPairId);
                }
            }
        }

        function getPendingOrders(bankId, branchId, customerId, instrumentId,currencyPairId){
            
            OrderStatusDetails.getPendingOrders({bankId: bankId, branchId: branchId, customerId: customerId,  instrumentId: instrumentId,  currencyPairId: currencyPairId}, onGetPendingOrdersSuccess, onGetPendingOrdersFailure);
            
        }
        
        function onGetPendingOrdersSuccess(result){
            $rootScope.pendingOrders = result;
            vm.clickedReport=false;
            angular.forEach($rootScope.pendingOrders, function(value, index){
                angular.forEach($rootScope.orderStatusList, function(orderStatus){
                    if(value.orderStatusId == orderStatus.id){
                        $rootScope.pendingOrders[index].orderStatus = orderStatus.name;
                    }
                    value.expiryTimeString=moment(value.expiryTime,'YYYYMMDDHHmmss').format();
                })
            })
        }
        
        function onGetPendingOrdersFailure(){
            vm.clickedReport=false;  
        }

        vm.getMomentFromOrderRevisionTimeStamp =  function(timestampString){
            return moment(timestampString,'YYYYMMDDHHmmss.SSSSSSSSS').format();
        }

        //get outstanding trades report
        function getOutstandingTradesReport(){
            vm.clickedReport=true;
            var instrumentTypeId = 0;
            if(vm.instrumentFilterForOT!=null && vm.instrumentFilterForOT!=undefined){
                instrumentTypeId = vm.instrumentFilterForOT.id;
            }

            if(validateTradesOutstandingDates(vm.fromSettlementDate, vm.toSettlementDate)){
                getOutstandingTradeReportForInstrument(instrumentTypeId);
            }else{
                MessageBox.openMessageBox("Alert","From date cannot be greater than the To date.", "Ok", "homepage");
            }
            syncInputsToHomePage();
        }

        function getOutstandingTradeReportForInstrument(){
            var bankId = getBankIdForReportFilters('OT');
            var branchId = getBranchIdForReportFilters('OT');
            var customerId = getCustomerIdForReportFilters('OT');
            var instrumentId = getInstrumentIdForReportFilters('OT');
            
            
            if($rootScope.account.organisation.organisationType.shortName=='CLEARCORP'){
                getOutstandingTrades(bankId, branchId, customerId,instrumentId,vm.fromSettlementDate,vm.toSettlementDate);
            }else if($rootScope.account.organisation.organisationType.shortName=='BANK' && vm.globalValues.getEntityOwnerType().shortName!='Branch'){
                if(bankId!=0){
                    getOutstandingTrades(bankId, branchId, customerId,instrumentId,vm.fromSettlementDate,vm.toSettlementDate);
                }
            }else if($rootScope.account.organisation.organisationType.shortName=='BANK' && vm.globalValues.getEntityOwnerType().shortName=='Branch'){
                if(bankId!=0 && branchId!=0){
                    getOutstandingTrades(bankId, branchId, customerId,instrumentId,vm.fromSettlementDate,vm.toSettlementDate);
                }
            }else if($rootScope.account.organisation.organisationType.shortName=='CUSTOMER'){
                if(customerId!=0){
                    getOutstandingTrades(bankId, branchId, customerId,instrumentId,vm.fromSettlementDate,vm.toSettlementDate);
                }
            }
        }

        function getOutstandingTrades(bankId, branchId, customerId, instrumentId, fromDate, toDate){

            var fromSettDate = null
            var toSettDate = null;
            
            //if the from date is null then provide the minimum possible date , else send the selected date 
            if(fromDate == null && fromDate == undefined){
                fromSettDate = new Date(1900,0,1);
            }else{
                fromSettDate = fromDate;
            }

            // if to date is null then provide the maximum possible date , else send the selected date 
            if(toDate == null && toDate == undefined){
                toSettDate = new Date(9999,11,31); 
            }else{
                toSettDate = toDate; 
            }

            OrderStatusDetails.getTradesOutstandingList({bankId: bankId, branchId: branchId, customerId: customerId,  instrumentId: instrumentId, fromSetDate : DateUtils.convertLocalDateToServer(fromSettDate),toSetDate :DateUtils.convertLocalDateToServer(toSettDate) }, onOutstandingTradesSuccess, onGetOutstandingTradesFailure);

            // if(moment(fromSettDate).isAfter(toSettDate,'day')){
            //  MessageBox.openMessageBox("Alert","From date cannot be greater than the To date.", "Ok", "homepage");
            // }

            // else{
            //  OrderStatusDetails.getTradesOutstandingList({bankId: bankId, branchId: branchId, customerId: customerId,  instrumentId: instrumentId, fromSetDate : DateUtils.convertLocalDateToServer(fromSettDate),toSetDate :DateUtils.convertLocalDateToServer(toSettDate) }, onOutstandingTradesSuccess, onGetOutstandingTradesFailure);
            // }
        }
               
        function validateTradesOutstandingDates(fromDate, toDate){
            var validFilterDates = true;
            var fromSettDate = null
            var toSettDate = null;
            
            //if the from date is null then provide the minimum possible date , else send the selected date 
            if(fromDate == null && fromDate == undefined){
                fromSettDate = new Date(1900,0,1);
            }else{
                fromSettDate = fromDate;
            }

            // if to date is null then provide the maximum possible date , else send the selected date 
            if(toDate == null && toDate == undefined){
                toSettDate = new Date(9999,11,31); 
            }else{
                toSettDate = toDate; 
            }

            if(moment(fromSettDate).isAfter(toSettDate,'day')){
                validFilterDates = false;
            }

            return validFilterDates;
        }
        
        function onOutstandingTradesSuccess(result){
            
            angular.forEach(result,function(value){
                value.tradeTime=moment(value.tradeTime,'YYYYMMDDHHmmss.SSSSSSSSS').format();
                value.select = false;
            });
            
            $rootScope.outstandingTrades = result;
            vm.clickedReport=false;
        }
        
        function onGetOutstandingTradesFailure(){
            vm.clickedReport=false;
        }

        function getTradesReport(){
            vm.clickedReport=true;
            var instrumentTypeId = 0;
            if(vm.instrumentFilterForTrade!=null && vm.instrumentFilterForTrade!=undefined){
                instrumentTypeId = vm.instrumentFilterForTrade.id;
            }
            
            getTradesReportForInstrument(instrumentTypeId);
            syncInputsToHomePage();
        }

        // get trades report for given instrument
        function getTradesReportForInstrument(){
            var bankId = getBankIdForReportFilters('Trade');
            var branchId = getBranchIdForReportFilters('Trade');
            var customerId = getCustomerIdForReportFilters('Trade');
            var instrumentId = getInstrumentIdForReportFilters('Trade');

            if($rootScope.account.organisation.organisationType.shortName=='CLEARCORP'){
                getTrades(bankId, branchId, customerId, instrumentId);
            }else if($rootScope.account.organisation.organisationType.shortName=='BANK' && vm.globalValues.getEntityOwnerType().shortName!='Branch'){
                if(bankId!=0){
                    getTrades(bankId, branchId, customerId, instrumentId);
                }
            }else if($rootScope.account.organisation.organisationType.shortName=='BANK' && vm.globalValues.getEntityOwnerType().shortName=='Branch'){
                if(bankId!=0 && branchId!=0){
                    getTrades(bankId, branchId, customerId, instrumentId);
                }
            }else if($rootScope.account.organisation.organisationType.shortName=='CUSTOMER'){
                if(customerId!=0){
                    getTrades(bankId, branchId, customerId, instrumentId);
                }
            }
        }
        
        function getTrades(bankId, branchId, customerId, instrumentId){
            
            OrderStatusDetails.getTradesForSelectedInstrument({bankId: bankId, branchId: branchId, customerId: customerId,  instrumentId: instrumentId}, onGetTradesSuccess, onGetTradesFailure);
            
        }
        
        function onGetTradesSuccess(result){
            vm.clickedReport=false;
            angular.forEach(result,function(value){
                value.tradeTime=moment(value.tradeTime,'YYYYMMDDHHmmss.SSSSSSSSS').format();
            });
            
             
            vm.summaryBuyTrades = result.filter(function(val){
                return val.buySellIndicator == "BUYY";
            })
            
            vm.summarySellTrades = result.filter(function(val){
                return val.buySellIndicator == "SELL";
            })
            
             vm.totalUSDBought = vm.summaryBuyTrades.reduce(function (a,b) { return a + b.tradedAmount; }, 0);
             vm.totalUSDSold = vm.summarySellTrades.reduce(function (a,b) { return a + b.tradedAmount; }, 0);
             vm.totalINRSold = vm.summaryBuyTrades.reduce(function (a,b) { return a + b.tradedValue; }, 0);
             vm.totalINRBought = vm.summarySellTrades.reduce(function (a,b) { return a + b.tradedValue; }, 0);
             
             
            $rootScope.trades = result;
            vm.expandTradePosition = false;
            if(vm.instrumentFilterForTrade!=null && vm.currencyPairForTrade!=null){
                $rootScope.totalUSDBought = vm.totalUSDBought;
                $rootScope.totalUSDSold = vm.totalUSDSold;
                $rootScope.totalINRSold = vm.totalINRSold;
                $rootScope.totalINRBought = vm.totalINRBought;
                $rootScope.weightedAverageBuy = Math.abs(vm.totalINRSold/vm.totalUSDBought);
                $rootScope.weightedAverageSell = Math.abs(vm.totalINRBought/vm.totalUSDSold);
                $rootScope.usdNet = vm.totalUSDBought - vm.totalUSDSold;
                $rootScope.inrNet = vm.totalINRBought - vm.totalINRSold;
                $rootScope.netWeightedAveragePrice = Math.abs((vm.totalINRBought - vm.totalINRSold) / (vm.totalUSDBought - vm.totalUSDSold));
                
                if(isNaN(Math.abs(vm.totalINRSold/vm.totalUSDBought)) || Math.abs(vm.totalINRSold/vm.totalUSDBought) == Infinity)
                    $rootScope.weightedAverageBuy = null;
                if(isNaN(Math.abs((vm.totalINRBought - vm.totalINRSold) / (vm.totalUSDBought - vm.totalUSDSold))) ||
                        (Math.abs((vm.totalINRBought - vm.totalINRSold) / (vm.totalUSDBought - vm.totalUSDSold))) == Infinity)
                    $rootScope.netWeightedAveragePrice = null;
                
                if(isNaN(Math.abs(vm.totalINRBought/vm.totalUSDSold)) || Math.abs(vm.totalINRBought/vm.totalUSDSold) == Infinity)
                     $rootScope.weightedAverageSell = null;
            }else{
                $rootScope.totalUSDBought = null;
                $rootScope.totalUSDSold = null;
                $rootScope.totalINRSold = null;
                $rootScope.totalINRBought = null;
                $rootScope.weightedAverageBuy = null;
                $rootScope.weightedAverageSell = null;
                $rootScope.usdNet = null;
                $rootScope.inrNet = null;
                $rootScope.netWeightedAveragePrice = null;
            }
            
        }
        
        function onGetTradesFailure(){
            vm.clickedReport=false; 
        }

        //get limits for instrument
        function getLimitUtilisedReport(){
            vm.clickedReport=true;
            var instrumentTypeId = 0;
            if(vm.instrumentFilterForLimit!=null && vm.instrumentFilterForLimit!=undefined){
                instrumentTypeId = vm.instrumentFilterForLimit.id;
                vm.limitInstrumentCode = 'ALL';
            }

            var currencyPairCode = vm.currencyPairForLimit.baseCurrency.code;

            getLimitUtilisedReportForInstrument(instrumentTypeId,currencyPairCode);
            syncInputsToHomePage();
            
        }


        vm.getMarkupReport = function getMarkupReport(currencyPairCode){
             vm.limitInstrumentCode = 'ALL';
        	if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
        		Markup.getAllMarkupForCustomerAndCurrencyPair({customerId: vm.account.organisation.id,currencyPairCode:currencyPairCode,}, onGetMarkupSuccess, onGetMarkupFailure);
        	}
        }
        
        function onGetMarkupSuccess(result){
        	if(result.length>0){
        		$rootScope.markupSettings = result;
        	}
        }
        function onGetMarkupFailure(){

        }

        // get limit utilisation reports for given instrument
        function getLimitUtilisedReportForInstrument(){
            var bankId = getBankIdForReportFilters('Limit');
            var branchId = getBranchIdForReportFilters('Limit');
            var customerId = getCustomerIdForReportFilters('Limit');
            var instrumentId = getInstrumentIdForReportFilters('Limit');
             var currencyCode = vm.currencyPairForLimit.baseCurrency.code;
            if($rootScope.account.organisation.organisationType.shortName=='CLEARCORP'){
                getLimitsAvailable(bankId, branchId, customerId,instrumentId,currencyCode);
            }else if($rootScope.account.organisation.organisationType.shortName=='BANK' && vm.globalValues.getEntityOwnerType().shortName!='Branch'){
                if(bankId!=0){
                    getLimitsAvailable(bankId, branchId, customerId,instrumentId,currencyCode);
                }
            }else if($rootScope.account.organisation.organisationType.shortName=='BANK' && vm.globalValues.getEntityOwnerType().shortName=='Branch'){
                if(bankId!=0 && branchId!=0){
                    getLimitsAvailable(bankId, branchId, customerId,instrumentId,currencyCode);
                }
            }else if($rootScope.account.organisation.organisationType.shortName=='CUSTOMER'){
                if(customerId!=0){
                    getLimitsAvailable(bankId, branchId, customerId,instrumentId,currencyCode);
                }
            }
        }
        
        function getLimitsAvailable(bankId, branchId, customerId, instrumentId,currencyCode){
            
            LimitSettings.getLimitUtilsationDetailsForInstrument({bankId: bankId, branchId: branchId, customerId: customerId,  instrumentId: instrumentId, currencyCode : currencyCode}, onGetLimitsSuccess, onGetLimitsFailure);

        }
        
        function onGetLimitsSuccess(result){
            $rootScope.limitsAvailableForSelectedInstrument = result;
            vm.clickedReport=false;
        }
        
        function onGetLimitsFailure(){
            vm.clickedReport=false;
        }
        
        function getBuyingPower(limit){
            var buyingPower = 0;
            var limitAllocated = 0;
            if(vm.currencyPairForLimit.code != 'USDINR'){
              limitAllocated = limit.limitAllocatedInFCY;
            }else{
              limitAllocated =  limit.limitAllocatedInUSD
            }
            var totalBuy = limit.totalPendingBuyOrderValue + limit.totalBuyTradeValue + limit.previousDayBuyTradeValue;
            var totalSell = limit.totalPendingSellOrderValue + limit.totalSellTradeValue + limit.previousDaySellTradeValue;
            if(limit.limitType=='GROSSSELL'){
                buyingPower = 0;
            }else if(limit.limitType=='GROSSBUY'){
                buyingPower = limitAllocated - (totalBuy);
            }else if(limit.limitType=='GLOBALGROSS'){
                buyingPower = limitAllocated - (totalBuy + totalSell);
            }else if(limit.limitType=='NET'){
                totalBuy = limit.totalPendingBuyOrderValue+((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue));
                totalSell = limit.totalPendingSellOrderValue+((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue  + limit.previousDayBuyTradeValue));
                var xVals = [];
                xVals.push(totalBuy);
                xVals.push(totalSell);
                buyingPower = limitAllocated - totalBuy;
            }
            if(buyingPower<0){
                buyingPower=0;
            }
            return buyingPower;
        }
        
        function getExposure(limit){
            var exposure = 0;
            var totalBuy = 0;
            var totalSell = 0;
            if(limit.limitType!='NET'){
                totalBuy = limit.totalPendingBuyOrderValue + limit.totalBuyTradeValue + limit.previousDayBuyTradeValue;
                totalSell = limit.totalPendingSellOrderValue + limit.totalSellTradeValue + limit.previousDaySellTradeValue;
                exposure = (limit.totalPendingBuyOrderValue + limit.totalBuyTradeValue + limit.previousDayBuyTradeValue + limit.totalPendingSellOrderValue + limit.totalSellTradeValue + limit.previousDaySellTradeValue) * 100/limit.limitAllocatedInUSD;
            }else{
                totalBuy = limit.totalPendingBuyOrderValue+((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue));
                totalSell = limit.totalPendingSellOrderValue+((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue));

                var xVals = [];
                xVals.push(totalBuy);
                xVals.push(totalSell);
                exposure =  Math.max.apply(Math, xVals) * 100/limit.limitAllocatedInUSD;
            }
            return exposure;
        }
        
        function getSellingPower(limit){
            var sellingPower = 0;
            var limitAllocated = 0;
            if(vm.currencyPairForLimit.code != 'USDINR'){
              limitAllocated = limit.limitAllocatedInFCY;
            }else{
              limitAllocated =  limit.limitAllocatedInUSD
            }
            var totalBuy = limit.totalPendingBuyOrderValue + (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue);
            var totalSell = limit.totalPendingSellOrderValue + (limit.totalSellTradeValue + limit.previousDaySellTradeValue);
            if(limit.limitType=='GROSSSELL'){
                sellingPower = limitAllocated - (totalSell);
            }else if(limit.limitType=='GROSSBUY'){
                sellingPower = 0;
            }else if(limit.limitType=='GLOBALGROSS'){
                sellingPower = limitAllocated - (totalBuy + totalSell);
            }else if(limit.limitType=='NET'){
                totalBuy = limit.totalPendingBuyOrderValue+((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue));
                totalSell = limit.totalPendingSellOrderValue+((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue));
                var xVals = [];
                xVals.push(totalBuy);
                xVals.push(totalSell);
                sellingPower = limitAllocated - totalSell;
            }
            if(sellingPower<0){
                sellingPower=0; 
            }
            return sellingPower;
        }
        
        function printDealTicket(trade){
            vm.tradeResponse = angular.copy(trade);
            console.log(typeof vm.tradeResponse.tradeTime);
            vm.tradeResponse.tradeTime = moment(vm.tradeResponse.tradeTime).format('YYYYMMDDHHmmss.SSSSSSSSS');
            GenerateDealTicket.generate(vm.tradeResponse,function(result){
                var file = new Blob([result.data], {type: 'application/pdf'});
                // var fileURL = URL.createObjectURL(file);
                // window.open(fileURL, "_blank", "fullscreen=yes");
                var fileURL = URL.createObjectURL(file);
                if(window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file, "DealTicket.pdf");
                }
                else {
                     window.open(fileURL, "_blank", "fullscreen=yes");    
                }
            });
        }
        
        function printDealTicketOutstandingTrade(outstandingTrade){
            vm.tradeResponse = angular.copy(outstandingTrade);
            console.log(typeof vm.tradeResponse.tradeTime);
            vm.tradeResponse.tradeTime = moment(vm.tradeResponse.tradeTime).format('YYYYMMDDHHmmss.SSSSSSSSS');
            GenerateDealTicket.generateOutstandingTrades(vm.tradeResponse,function(result){
                var file = new Blob([result.data], {type: 'application/pdf'});
                var fileURL = URL.createObjectURL(file);
                if(window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file, "DealTicket.pdf");
                }
                else {
                     window.open(fileURL, "_blank", "fullscreen=yes");    
                }
            });
        }

        // get bank, branch and customer id from report filters
        function getBankIdForReportFilters(reportType){
            var bankId = 0;
            if($rootScope.account.organisation.organisationType.shortName=='CLEARCORP' || $rootScope.account.organisation.organisationType.shortName=='CUSTOMER'){
                if(reportType=='PO'){
                    if(vm.bankFilterForPO!=null){
                        bankId = vm.bankFilterForPO.id;
                    }
                }else if(reportType=='Limit'){
                    if(vm.bankFilterForLimit!=null){
                        bankId = vm.bankFilterForLimit.id;
                    }
                }else if(reportType=='Trade'){
                    if(vm.bankFilterForTrade!=null){
                        bankId = vm.bankFilterForTrade.id;
                    }
                }
                else if(reportType=='OT'){
                    if(vm.bankFilterForOT!=null){
                        bankId = vm.bankFilterForOT.id;
                    }
                }
            }else if($rootScope.account.organisation.organisationType.shortName=='BANK'){
                bankId = $rootScope.account.organisation.id;
            }
            
            return bankId;
        }
        
        function getBranchIdForReportFilters(reportType){
            var branchId = 0;
            if(reportType=='PO'){
                if(vm.branchFilterForPO!=null){
                    branchId = vm.branchFilterForPO.id;
                }
            }else if(reportType=='Limit'){
                if(vm.branchFilterForLimit!=null){
                    branchId = vm.branchFilterForLimit.id;
                }
            }else if(reportType=='Trade'){
                if(vm.branchFilterForTrade!=null){
                    branchId = vm.branchFilterForTrade.id;
                }
            }
            else if(reportType=='OT'){
                if(vm.branchFilterForOT!=null){
                    branchId = vm.branchFilterForOT.id;
                }
            }
            return branchId;
        }
        
        function getInstrumentIdForReportFilters(reportType){
            var instrumentId = 0;
            if(reportType=='PO'){
                if(vm.instrumentFilterForPO!=null){
                    instrumentId = vm.instrumentFilterForPO.id;
                }
            }else if(reportType=='Limit'){
                if(vm.instrumentFilterForLimit!=null){
                    instrumentId = vm.instrumentFilterForLimit.id;
                }
            }else if(reportType=='Trade'){
                if(vm.instrumentFilterForTrade!=null){
                    instrumentId = vm.instrumentFilterForTrade.id;
                }
            }
            else if(reportType=='OT'){
                if(vm.instrumentFilterForOT!=null){
                    instrumentId = vm.instrumentFilterForOT.id;
                }
            }
            return instrumentId;
        }
        
        function getCustomerIdForReportFilters(reportType){
            var customerId = 0;
            if($rootScope.account.organisation.organisationType.shortName=='CLEARCORP' || $rootScope.account.organisation.organisationType.shortName=='BANK'){
                if(reportType=='PO'){
                    if(vm.customerFilterForPO!=null){
                        customerId = vm.customerFilterForPO.id;
                    }
                }else if(reportType=='Limit'){
                    if(vm.customerFilterForLimit!=null){
                        customerId = vm.customerFilterForLimit.id;
                    }
                }else if(reportType=='Trade'){
                    if(vm.customerFilterForTrade!=null){
                        customerId = vm.customerFilterForTrade.id;
                    }
                }
                else if(reportType=='OT'){
                    if(vm.customerFilterForOT!=null){
                        customerId = vm.customerFilterForOT.id;
                    }
                }
            }else if($rootScope.account.organisation.organisationType.shortName=='CUSTOMER'){
                customerId = vm.globalValues.getCustomerId();
            }
            return customerId;
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
            syncInputsToHomePage();
        }
        
        vm.exportOTToExcelFile = exportOTToExcelFile;
        vm.exportOTToCsvFile = exportOTToCsvFile;
        vm.exportTradesToCsvFile = exportTradesToCsvFile;
        vm.exportTradesToExcelFile = exportTradesToExcelFile;

        vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm_ss';
        function exportOTToCsvFile(){
        	
        	if($rootScope.outstandingTrades!=null && $rootScope.outstandingTrades.length >0){
        		vm.mimeType = 'text/csv';

        		var baseString = 'OUTSTANDING_TRADES_'+ moment().format(vm.reportFileTimestampFormat) ;  
        		vm.baseString = baseString+ ".csv";
        		var selectedTrades = angular.copy($rootScope.outstandingTrades);
        		angular.forEach(selectedTrades,function(value,index){        		
        			value.tradeTime = moment(value.tradeTime).format('YYYYMMDDHHmmss.SSSSSSSSS');    	        		 	        		
        		});

        		TradesDownload.getTradesOutstandingCSV(selectedTrades, processResponse);

        	}
        	          
        }
        
        function exportOTToExcelFile(){
        	if($rootScope.outstandingTrades!=null && $rootScope.outstandingTrades.length >0){           	
        		vm.mimeType = 'application/vnd.ms-excel';
        		var baseString = 'OUTSTANDING_TRADES_'+ moment().format(vm.reportFileTimestampFormat);  
        		vm.baseString = baseString+ ".xls";  
        		var selectedTrades = angular.copy($rootScope.outstandingTrades);
        		angular.forEach(selectedTrades,function(value,index){        		
        			value.tradeTime = moment(value.tradeTime).format('YYYYMMDDHHmmss.SSSSSSSSS');    	        		 	        		
        		});

        		TradesDownload.getTradesOutstandingCSV(selectedTrades, processResponse);


        	}
        }
        
        function exportTradesToCsvFile(){
            if($rootScope.trades!=null && $rootScope.trades.length >0){

                vm.mimeType = 'text/csv';
                 var baseString =    moment(vm.currentDate).format( 'YYYYMMDD')+'_FXRETAIL_TRADES';  
                 vm.baseString = baseString+ ".csv";  
                var selectedTrades = angular.copy($rootScope.trades);
                angular.forEach(selectedTrades,function(value,index){               
                    value.tradeTime = moment(value.tradeTime).format('YYYYMMDDHHmmss.SSSSSSSSS');
                    console.log("tradetime " +  value.tradeTime);
                    
                });
                TradesDownload.getCSVForTrades(selectedTrades , processResponse );
            }
        }
        
        function exportTradesToExcelFile(){
            if($rootScope.trades!=null && $rootScope.trades.length >0){

                  vm.mimeType = 'application/vnd.ms-excel';
                  var baseString =    moment(vm.currentDate).format( 'YYYYMMDD')+'_FXRETAIL_TRADES';  
                  vm.baseString = baseString+ ".xls";  
                  var selectedTrades = angular.copy($rootScope.trades);
                    angular.forEach(selectedTrades,function(value,index){               
                        value.tradeTime = moment(value.tradeTime).format('YYYYMMDDHHmmss.SSSSSSSSS');
                        console.log("tradetime " +  value.tradeTime);
                        
                    });
                  TradesDownload.getExcelForTrades(selectedTrades , processResponse );
            }
        }

        function processResponse(result){
          var fileData = null;
          fileData = result.data;
          var link = document.createElement("a");   
          var bytes = new Uint8Array( fileData );   // convert uint8 to binary
                                                    // array from arraybuffer
          var blob = new Blob([bytes], {type: vm.mimeType});
          if(window.navigator.msSaveOrOpenBlob) {
                  window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
          }else{
              link.href =  window.URL.createObjectURL(blob);      
              link.download = vm.baseString;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
          }
        }

        vm.openOrderActivity = function openOrderActivity(ordNo){
            $state.go('order-activity-reports', {ordNo: ordNo});
        }

        vm.changeTab = function changeTab(tabId){
            setTimeout(function(){document.getElementById(tabId).click();},100);
        }

        //events emitted to the homepage
        //modify order from pending orders
        function modifyOrder(pendingOrder){
            $rootScope.pendingOrderToModify = pendingOrder;
            $rootScope.modifyCount = 0;
            $scope.$emit('modifypendingorder');
            $uibModalInstance.close();
            syncInputsToHomePage();
        }

        //cancel order from pending orders
        function cancelOrder(pendingOrder){
            $rootScope.pendingOrderToCancel = pendingOrder;
            $rootScope.cancelCount = 0;
            $scope.$emit('cancelpendingorder');
            //$uibModalInstance.close();
            //syncInputsToHomePage();
        }

        //canel contraction from outstanding trades
        // function cancelTrade(){
        //     $rootScope.cancelTradeCount = 0;
        //     $scope.$emit('cancelpendingtrade');
        //     //$uibModalInstance.close();
        //     //syncInputsToHomePage();
        // }

        function cancelTrade(){
            //vm.remarks = "";
            var outstandingTrades = angular.copy($rootScope.outstandingTrades);
            var outstandingTrade = _.filter(outstandingTrades, {'select': true});
            if(validateOutstandingTrade(outstandingTrade)){
                $rootScope.outstandingTradeToCancel = outstandingTrade[0];
                $rootScope.cancelTradeCount = 0;
                $scope.$emit('cancelpendingtrade');
                $uibModalInstance.close();
                syncInputsToHomePage();
            }
        }

        function validateOutstandingTrade(outstandingTrade) {
            var isValid = true;
            if(outstandingTrade.length>0){
                //validate selected contract is forward contract. Need not validate based on event type
                if(outstandingTrade[0].instrumentCode!='Forward' ){	//&& outstandingTrade[0].eventTypeName!='Early Delivery'
                    isValid = false;
                    MessageBox.openMessageBox("Alert", "The SPOT/TOM/CASH contract cannot be cancelled.", "Ok", "selectedorders");
                }
                else{
                    //validate outstanding amount
                	var cancellationSettlementDate = $rootScope.getSettlementDateForContractCancellation(outstandingTrade[0]);                  	 							                 
                    var instrumentCode = MarketWatch.getInstrumentCodeForSettlement(cancellationSettlementDate, $rootScope.tenors, $rootScope.retailSpotMarketSession, $rootScope.cashMarketSession, $rootScope.tomMarketSession);
                    if((outstandingTrade[0].outStandingAmount - outstandingTrade[0].blockedAmount)<=0){
                        isValid = false;
                        MessageBox.openMessageBox("Alert", "Cancellation order(s) is already pending for execution, the operation is not permitted...!", "Ok", "selectedorders");   
                    }
                    //validate spread 
                    if(instrumentCode!='SPOT'){
                        var tickSize = MarketWatch.gettickSizeForGivenInstrument(instrumentCode, $rootScope.tickSize);
                        var buySellIndicator = 'BUYY';
                        if(outstandingTrade[0].buySellIndicator=='BUYY'){
                            buySellIndicator = 'SELL';  
                        }
                        var bankSpread = MarketWatch.getDefaultBankSwapQuotes($rootScope.bankComparativeDTO.swapQuotesTenorDateDTOList, outstandingTrade[0].bankId);
                        var spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate(bankSpread, instrumentCode, buySellIndicator, 
                            DateUtils.convertLocalDateToServer(angular.copy(cancellationSettlementDate)), $rootScope.retailSpotMarketSession.settlementDate, 
                            tickSize);
                        if(spreadUsed==null || spreadUsed==undefined){
                            isValid = false;
                            if(buySellIndicator == 'BUYY'){
                               if(instrumentCode=='Forward'){
                                  MessageBox.openMessageBox("Alert", "Order entry not possible as FORWARD offer spread for the selected settlement date is not provided by your Relationship bank.", "Ok", "selectedorders"); 
                               }else{
                                  MessageBox.openMessageBox("Alert", instrumentCode + "/SPOT bid spread is not given by the bank. Order entry not possible...!", "Ok", "selectedorders");   
                               }
                            }else{
                               if(instrumentCode=='Forward'){
                                  MessageBox.openMessageBox("Alert", "Order entry not possible as FORWARD bid spread for the selected settlement date is not provided by your Relationship bank.", "Ok", "selectedorders"); 
                               }else{
                                  MessageBox.openMessageBox("Alert", instrumentCode + "/SPOT offer spread is not given by the bank. Order entry not possible...!", "Ok", "selectedorders");   
                               }
                            }
                        }
                    }
                }
            }else{
                isValid = false;
                MessageBox.openMessageBox("Alert", "Please select a trade to proceed.", "Ok", "selectedorders");
            }
            return isValid;
        }

        var closereportexp = $rootScope.$on('closereportexp', function(event, result){
            $uibModalInstance.close();
            syncInputsToHomePage();
        })

        $scope.$on('$destroy', function() {
            closereportexp(); 
        });

        //cancel selected orders from pending orders
        function cancelPendingOrdersSelected(){
            $rootScope.cancelSelectedCount = 0;
            $scope.$emit('cancelselectedpendingorders');
            //$uibModalInstance.close();
            //syncInputsToHomePage();
        }
        //cancel selected orders from pending orders
        function cancelAllOrders(){
            vm.selectAll = true;
          //  pendingOrder.select =true;
            $rootScope.cancelSelectedCount = 0;
            $scope.$emit('cancelallpendingorders');
            //$uibModalInstance.close();
            //syncInputsToHomePage();
        }

        //limit change request from limits
        function changeRequest(){
            var limits = angular.copy($rootScope.limitsAvailableForSelectedInstrument);
            var selectedLimits = _.filter(limits, {'select': true});
            if(selectedLimits.length<=0){
                MessageBox.openMessageBox("Alert", "Please select a limit to proceed.", "Ok", "limitchangerequestexp");
            }else{
                $rootScope.selectedLimit = selectedLimits[0];
                $rootScope.limitChangeRequestCount = 0;
                $scope.$emit('limitchangerequestfromexp');
                //$uibModalInstance.close();
                syncInputsToHomePage();
            }
        }

        //new limit request from limits
        function newLimitRequest(){
            $rootScope.newLimitRequestCount = 0;
            $rootScope.bankFilterForLimit = vm.bankFilterForLimit;
            $scope.$emit('newlimitrequestfromexp');
            //$uibModalInstance.close();
            syncInputsToHomePage();
        }

        //sync local variables changes in home page
        $scope.$watch('vm.bankFilterForLimit', function(value){
            if($rootScope.account!=null && $rootScope.account!=undefined && value!=null && value!=undefined){
                $rootScope.bankFilterForLimit = value;
                if($rootScope.account.organisation.organisationType.shortName=='CUSTOMER'){
                    CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
                        vm.branchFilterForLimit = result;
                        $rootScope.branchFilterForLimit = result;
                    });
                    // get the limits when the bakFilterForLimit changes
                    LimitSettings.getLimitsAvailableForAllInstruments({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, checkLimitOnBankFilterChangeSuccess, onGetLimitsAvailableFailure);
                }
            }else{
                vm.branchFilterForLimit = null;
                $rootScope.bankFilterForLimit = null;
                $rootScope.branchFilterForLimit = null;
            }
        })
        function checkLimitOnBankFilterChangeSuccess(result){
            if(result!=null && result !=undefined && result.length > 0){
                $rootScope.limitAvailableForSlectBankFilterInReport = true;
            }else{
                $rootScope.limitAvailableForSlectBankFilterInReport = false;
            }
        }
        
        function onGetLimitsAvailableFailure(){
            
        }

        $scope.$watch('vm.bankFilterForOT', function(value){
            if($rootScope.account!=null && $rootScope.account!=undefined && value!=null && value!=undefined){
                $rootScope.bankFilterForOT = value;
                if($rootScope.account.organisation.organisationType.shortName=='CUSTOMER'){
                    CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
                        vm.branchFilterForOT = result;
                        $rootScope.branchFilterForOT = result;
                    })
                }
            }else{
                vm.branchFilterForOT = null;
                $rootScope.bankFilterForOT = null;
                $rootScope.branchFilterForOT = null;
            }
        })
        
        $scope.$watch('vm.bankFilterForPO', function(value){
            if($rootScope.account!=null && $rootScope.account!=undefined && value!=null && value!=undefined){
                $rootScope.bankFilterForPO = value;
                if($rootScope.account.organisation.organisationType.shortName=='CUSTOMER'){
                    CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
                        vm.branchFilterForPO = result;
                        $rootScope.branchFilterForPO = result;
                    })
                }
            }else{
                vm.branchFilterForPO = null;
                $rootScope.bankFilterForPO = null;
                $rootScope.branchFilterForPO = null;
            }
        })
        
         $scope.$watch('vm.bankFilterForTrade', function(value){
            if($rootScope.account!=null && $rootScope.account!=undefined && value!=null && value!=undefined){
                $rootScope.bankFilterForTrade = value;
                if($rootScope.account.organisation.organisationType.shortName=='CUSTOMER'){
                    CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
                        vm.branchFilterForTrade = result;
                        $rootScope.branchFilterForTrade = result;
                    })
                }
            }else{
                vm.branchFilterForTrade = null;
                $rootScope.bankFilterForTrade = null;
                $rootScope.branchFilterForTrade = null;
            }
        })

        $scope.$watch('vm.instrumentFilterForPO', function(value){
            $rootScope.instrumentFilterForPO = value;
        })

        $scope.$watch('vm.instrumentFilterForLimit', function(value){
            $rootScope.instrumentFilterForLimit = value;            
        })

        $scope.$watch('vm.instrumentFilterForTrade', function(value){
            $rootScope.instrumentFilterForTrade = value;
        })

        $scope.$watch('vm.instrumentFilterForOT', function(value){
            $rootScope.instrumentFilterForOT = value;
        })
        
        $scope.$watch('vm.branchFilterForOT', function(value){
            $rootScope.branchFilterForOT = value;
        })

        $scope.$watch('vm.branchFilterForPO', function(value){
            $rootScope.branchFilterForPO = value;
        })

        $scope.$watch('vm.branchFilterForLimit', function(value){
            $rootScope.branchFilterForLimit = value;
        })

        $scope.$watch('vm.branchFilterForTrade', function(value){
            $rootScope.branchFilterForTrade = value;
        })
        
        $scope.$watch('vm.customerFilterForPO', function(value){
            $rootScope.customerFilterForPO = value;
        })
        
        $scope.$watch('vm.customerFilterForOT', function(value){
            $rootScope.customerFilterForOT = value;
        })

        $scope.$watch('vm.customerFilterForLimit', function(value){
            $rootScope.customerFilterForLimit = value;
        })

        $scope.$watch('vm.customerFilterForTrade', function(value){
            $rootScope.customerFilterForTrade = value;
        })
        
        $scope.$watch('vm.fromSettlementDate', function(value){
            $rootScope.fromSettlementDate = value;
        })

        $scope.$watch('vm.toSettlementDate', function(value){
            $rootScope.toSettlementDate = value;
        })

        $scope.$watch('vm.selectAll', function(value){
            $rootScope.selectAll = value;
        })

        $scope.$watch('vm.reportTab', function(value){
            $rootScope.reportTab = vm.reportTab;
            syncInputsToHomePage();
        })

        $scope.$watch('vm.currencyPairForPO', function(value){
           $rootScope.currencyPairFilterForPO = value;
            getInstrumentMatchedCurrencypair();
        })
        $scope.$watch('vm.currencyPairForOT', function(value){
          $rootScope.currencyPairFilterForOT = value;
           getInstrumentMatchedCurrencypair();
        })
        $scope.$watch('vm.currencyPairForTrade', function(value){
           $rootScope.branchFilterForTrade = value;
            getInstrumentMatchedCurrencypair();
        })
       $scope.$watch('vm.currencyPairForLimit', function(value){
           $rootScope.currencyPairForLimit = value;
            getInstrumentMatchedCurrencypair();
        })
         $scope.$watch('vm.currencyPairForMarkup', function(value){
           $rootScope.currencyPairForMarkup = value;
            getInstrumentMatchedCurrencypair();
        })

        //actions from the report
        function checkOrUncheckPendingOrderItem(){
            var allSelected = true;
        
            angular.forEach($rootScope.pendingOrders, function(value, index){
                if (!$rootScope.pendingOrders[index].select){
                    allSelected = false
                }
            });
            
            if(allSelected){
                vm.selectAll= true;
                // if(document.getElementById("selectAll")!=null ||
                // document.getElementById("selectAll")!=undefined)
                document.getElementById("selectAll").checked = true;
            }else{
                vm.selectAll= false;
                // if(document.getElementById("selectAll")!=null ||
                // document.getElementById("selectAll")!=undefined)
                document.getElementById("selectAll").checked = false;
            }
        }

        function checkOrUncheckPendingOrders(event){
            
            changePendingOrderItemSelection(event.target.checked);
               
        }

        function changePendingOrderItemSelection(value){
            if(value){
                angular.forEach($rootScope.pendingOrders, function(value, index){
                    if(value.orderStatus!="Risk Validated"){
                        $rootScope.pendingOrders[index].select = true;
                    }
                });
            }else{
                angular.forEach($rootScope.pendingOrders, function(value, index){
                    $rootScope.pendingOrders[index].select = false;
                });
            }
        }

        function checkOrUncheckOutstandingTradesItem(outstandingValue, event){
            var selectedValue = event.target.checked;
            angular.forEach($rootScope.outstandingTrades, function(value, index){                
                    value.select = false;                
            })
            outstandingValue.select = selectedValue;
        }

        $rootScope.$on('$destroy', function () {
            if(emitSyncInputs!=null){
                emitSyncInputs();
            }
        });

        function syncInputsToHomePage(){
            $rootScope.customerFilterForPO=vm.customerFilterForPO;
            $rootScope.customerFilterForLimit=vm.customerFilterForLimit;
            $rootScope.customerFilterForTrade=vm.customerFilterForTrade;
            $rootScope.customerFilterForOT=vm.customerFilterForOT;

            $rootScope.bankFilterForPO=vm.bankFilterForPO;
            $rootScope.bankFilterForLimit=vm.bankFilterForLimit;
            $rootScope.bankFilterForTrade=vm.bankFilterForTrade;
            $rootScope.bankFilterForOT=vm.bankFilterForOT;

            $rootScope.branchFilterForPO=vm.branchFilterForPO;
            $rootScope.branchFilterForLimit=vm.branchFilterForLimit;
            $rootScope.branchFilterForTrade=vm.branchFilterForTrade;
            $rootScope.branchFilterForOT=vm.branchFilterForOT;

            $rootScope.instrumentFilterForPO=vm.instrumentFilterForPO;
            $rootScope.instrumentFilterForLimit=vm.instrumentFilterForLimit;
            $rootScope.instrumentFilterForTrade=vm.instrumentFilterForTrade;
            $rootScope.instrumentFilterForOT=vm.instrumentFilterForOT;

            $rootScope.fromSettlementDate = vm.fromSettlementDate;
            $rootScope.toSettlementDate = vm.toSettlementDate;
            $rootScope.selectAll = document.getElementById("selectAll").checked;
            $rootScope.reportTab = vm.reportTab;

            $rootScope.currencyPairForPO = vm.currencyPairForPO;
    		$rootScope.currencyPairForOT = vm.currencyPairForOT;
    		$rootScope.currencyPairForTrade = vm.currencyPairForTrade;
    		$rootScope.currencyPairForLimit = vm.currencyPairForLimit;
            $rootScope.currencyPairForMarkup = vm.currencyPairForMarkup;

            var emitSyncInputs = $scope.$emit('syncinputs');

        }

        vm.getSwapPointsForTradesReport = function getSwapPointsForTradesReport(spotExchangeRate, tradeExchangeRate){
            var swapPts = Math.abs(spotExchangeRate - tradeExchangeRate) * 100
            swapPts = (Math.round(parseFloat(swapPts)*100)/100);
            return swapPts;
        }

        function rolloverTrade(){
            var outstandingTrades = angular.copy($rootScope.outstandingTrades);
            var outstandingTrade = _.filter(outstandingTrades, {'select': true});
            //validate spread is available for cancellation leg
            if(validateOutstandingTradeForRollover(outstandingTrade)){ 
                $rootScope.outstandingTradeToRollover = outstandingTrade[0];
                $rootScope.rolloverTradeCount = 0;
                $scope.$emit('rolloverpendingtrade');
                $uibModalInstance.close();
                syncInputsToHomePage();
            }
        }

        function validateOutstandingTradeForRollover(outstandingTrade) {
            var isValid = true;
            if(outstandingTrade.length>0){
                //validate selected contract is forward contract
                if(outstandingTrade[0].instrumentCode!='Forward' ){ //&& outstandingTrade[0].eventTypeName=='Booking'
                    isValid = false;
                    MessageBox.openMessageBox("Alert", "The SPOT/TOM/CASH contract cannot be rolled over...!", "Ok", "traderollover");
                }
                else if(outstandingTrade[0].instrumentCode == 'Forward' && outstandingTrade[0].isOptionPeriod == true ){
                    isValid = false;
                    MessageBox.openMessageBox("Alert", "The option period forward contract cannot be rolled over...!", "Ok", "traderollover");
                }            	
                else{
                    //validate outstanding amount
                	//intruent code for cancellation leg to validate the session status of the cancellation leg
                    var instrumentCode = getInstrumentCodeForSettlement(outstandingTrade[0].tradeSettlementDate);     
                    var cancellationLegSpread = findCancellationLegSpread(instrumentCode, outstandingTrade[0].tradeSettlementDate, $rootScope.findBuyySellIndicatorForCancellationLeg(outstandingTrade[0].buySellIndicator) );
                    
                    /*if(outstandingTrade[0].instrumentCode!='Forward' && outstandingTrade[0].eventTypeName=='Early Delivery'){
                        isValid = false;
                        MessageBox.openMessageBox("Alert", "The Early Delivery SPOT/TOM/CASH contract cannot be rolled over...!", "Ok", "traderollover");
                    }else*/ 
                    if((outstandingTrade[0].outStandingAmount - outstandingTrade[0].blockedAmount)<=0){
                        isValid = false;
                        MessageBox.openMessageBox("Alert", "Order(s) is already pending for execution, the operation is not permitted...!", "Ok", "traderollover");   
                    }else if(!validateCancellationLegSessionStatus('ROLL', instrumentCode)){
                    	 isValid = false;
                        MessageBox.openMessageBox("Alert", "Session is closed for Cancellation Leg instrument " + instrumentCode + "...!", "Ok", "traderollover");  
                    }else if(cancellationLegSpread == null || cancellationLegSpread == undefined){
                    	isValid = false;
                   	 MessageBox.openMessageBox("Alert", "Contract cannot be rolled over. Cancellation Leg Swap Point for "+ $filter('date')(outstandingTrade[0].tradeSettlementDate,'dd-MMM-yyyy') +" is not provided by Relationship bank...!", "Ok", "traderollover");
                        
                   }
                }
            }else{
                isValid = false;
                MessageBox.openMessageBox("Alert", "Please select a trade to proceed.", "Ok", "traderollover");
            }
            return isValid;
        }

        function earlyDeliveryTrade(){
            var outstandingTrades = angular.copy($rootScope.outstandingTrades);
            var outstandingTrade = _.filter(outstandingTrades, {'select': true});
            if(validateOutstandingTradeForEarlyDelivery(outstandingTrade)){ 
                $rootScope.outstandingTradeToEarlyDelivery = outstandingTrade[0];
                $rootScope.earlyDeliveryTradeCount = 0;
                $scope.$emit('earlydeliverypendingtrade');
                $uibModalInstance.close();
                syncInputsToHomePage();
            }
        }

        function validateOutstandingTradeForEarlyDelivery(outstandingTrade) {
            var isValid = true;
            if(outstandingTrade.length>0){
                //validate selected contract is forward contract
                if(outstandingTrade[0].instrumentCode!='Forward' ){ //&& outstandingTrade[0].eventTypeName=='Booking'
                    isValid = false;
                    MessageBox.openMessageBox("Alert", "The SPOT/TOM/CASH contract cannot be early delivered...!", "Ok", "tradeearlydelivery");
                }
                else if(outstandingTrade[0].instrumentCode == 'Forward' && outstandingTrade[0].isOptionPeriod == true && !$rootScope.isEventAppliedBeforeOptionPeriod(outstandingTrade[0]) ){
               	 isValid = false;
               	 MessageBox.openMessageBox("Alert", "The option period forward contract cannot be early delivered during the option period...!", "Ok", "tradeearlydelivery");
                } 
                else{
                    //validate outstanding amount
                    //var instrumentCode = getInstrumentCodeForSettlement(outstandingTrade[0].tradeSettlementDate);
                    
                   /* if(outstandingTrade[0].instrumentCode!='Forward' && outstandingTrade[0].eventTypeName=='Early Delivery'){
                        isValid = false;
                        MessageBox.openMessageBox("Alert", "The Early Delivery SPOT/TOM/CASH contract cannot be early delivered...!", "Ok", "tradeearlydelivery");
                    }else*/ 
                	if((outstandingTrade[0].outStandingAmount - outstandingTrade[0].blockedAmount)<=0){
                        isValid = false;
                        MessageBox.openMessageBox("Alert", "Order(s) is already pending for execution, the operation is not permitted...!", "Ok", "tradeearlydelivery");   
                    }
                                     
                    var tradeSettlementDateForCancellation = $rootScope.getSettlementDateForContractCancellation(outstandingTrade[0]);
                    var cancellationLegInstrumentCode = getInstrumentCodeForSettlement(tradeSettlementDateForCancellation);
                    var cancellationLegSpread = findCancellationLegSpread(cancellationLegInstrumentCode, tradeSettlementDateForCancellation, $rootScope.findBuyySellIndicatorForCancellationLeg(outstandingTrade[0].buySellIndicator) );
                    
                    var instrumentCode = getInstrumentCodeForSettlement(outstandingTrade[0].tradeSettlementDate);
                    
                    if(instrumentCode=='CASH'){
                        isValid = false;
                        MessageBox.openMessageBox("Alert", "Contract cannot be early delivered as the contract entered into CASH instrument...!", "Ok", "tradeearlydelivery");
                    }else if(!validateCancellationLegSessionStatus('EARL', cancellationLegInstrumentCode)){
                    	 isValid = false;
                    	 MessageBox.openMessageBox("Alert", "Session is closed for Cancellation Leg instrument " + instrumentCode + "...!", "Ok", "tradeearlydelivery");  
                    }else if(cancellationLegSpread == null || cancellationLegSpread == undefined){
                    	isValid = false;
                   	 	MessageBox.openMessageBox("Alert", "Contract cannot be early delivered. Cancellation Leg Swap Point for "+ $filter('date')(outstandingTrade[0].tradeSettlementDate,'dd-MMM-yyyy') +" is not provided by Relationship bank...!", "Ok", "tradeearlydelivery");
                     }
                }
            }else{
                isValid = false;
                MessageBox.openMessageBox("Alert", "Please select a trade to proceed.", "Ok", "tradeearlydelivery");
            }
            return isValid;
        }

        
        function getInstrumentCodeForSettlement(tradeSettlementDate){
            var tenor = null;
            angular.forEach($rootScope.tenors, function(value){
                if(value.settlementDate==tradeSettlementDate){
                    tenor = value;
                }
            })
            if(tenor==null || tenor == undefined){
                if(tradeSettlementDate==$rootScope.retailSpotMarketSession.settlementDate){
                    return 'SPOT';
                }else if(tradeSettlementDate==$rootScope.cashMarketSession.settlementDate){
                    return 'CASH';
                }else if(tradeSettlementDate==$rootScope.tomMarketSession.settlementDate){
                    return 'TOM';
                }else {
                    tenor = $rootScope.tenors[0];
                    return 'Forward';
                }
            }else{
                return 'Forward';
            }
        }
        // validate session status
        function validateSessionStatus(instrumentCode){
        	var status = "";
        	
        	if(instrumentCode == 'SPOT'){
        		status = $rootScope.retailSpotMarketSession.sessionTimingsDTO.status;
        	}else if(instrumentCode == 'CASH'){
        		status = $rootScope.cashMarketSession.sessionTimingsDTO.status;
        	}else if(instrumentCode == 'TOM'){
        		status = $rootScope.tomMarketSession.sessionTimingsDTO.status;
        	}else if(instrumentCode == 'Forward'){
                status = $rootScope.forwardMarketSession.sessionTimingsDTO.status;
            }
        	
        	if(status!='OPEN'){        		
        		return false;
        	}
        	
        	return true;
        }
        /**
         * Valdate cancellation leg session status before placing ROLL or EARLY delivery
         */
        function validateCancellationLegSessionStatus(activityIndicator, cancellationLegInstrument){
        	if(activityIndicator=='ROLL' || activityIndicator=='EARL'){
        		var isValidSessionStatus = validateSessionStatus(cancellationLegInstrument);
        		
        		return isValidSessionStatus ;
        	}
        	return true;
        }
        
        // this functionality is invoked during validation and also during the trade date settlement change
        function findCancellationLegSpread(instCode, tradeCancellationSettlementDate, orderTypeOfCancellationLeg){
        	
        	 //get tick size for instcode and stored in variable
            var tickSize = $rootScope.gettickSizeForGivenInstrument(instCode);

        	 if(instCode=='SPOT'){ //if given instrument is SPOT, then set cancellation leg spread as 0
                 return  0;
             }else{
                 //get spread for given settlement date,  order type of cancellation leg
                 return MarketWatch.getSpreadForTenorAndSettlementDate($rootScope.defaultBankSpread, instCode, orderTypeOfCancellationLeg, 
                     DateUtils.convertLocalDateToServer(angular.copy(tradeCancellationSettlementDate)), $rootScope.retailSpotMarketSession.settlementDate, 
                     tickSize);
             }
        }

        function getInstrumentMatchedCurrencypair(){
            var currencyPairId = vm.globalValues.getDefaultCurrencyPairId();
            if (!vm.currencyPair != null && vm.currencyPair != undefined) {
                currencyPairId = vm.currencyPair.id;
            }
			DefaultMarket.csInstruments({currencyPairId:currencyPairId},onGetInstrumentSuccess, onGetInstrumentFailure);
            
        } 

		function onGetInstrumentSuccess(result) {
            vm.instrumentTypes = result;
            // get tick size for each instrument
		}

		function onGetInstrumentFailure() {

        }
    }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ifsc-upload-view', {
            parent: 'entity',
            params:{screen: 'HomeBranchIFSCUpload'},
            url: '/home-branch-ifsc-upload',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.homeBranchUpload.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/home-branch-ifsc-upload/home-branch-ifsc-upload.html',
                    controller: 'HomeBranchIfscUploadController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                   
                    $translatePartialLoader.addPart('homeBranchIfscUpload');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
      
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('HomeBranchIfscUpload', HomeBranchIfscUpload);

    HomeBranchIfscUpload.$inject = ['$resource'];

    function HomeBranchIfscUpload($resource) {
        var resourceUrl =  'api/home-branch-upload';

        return $resource(resourceUrl, {}, {
        	   'generateTemplateFile': {
                   method: 'POST',
                   url: 'api/home-branch-template-export',
                   responseType: 'arraybuffer',
                   transformResponse: function(data, headers) {
                 	  return {
                           data: data,
                           headers: headers
                       };   
                   }         
              }
            
            
              });
    }
})();

            

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'homeBranchIFSCUpload'
        })
        
        .controller('HomeBranchIfscUploadController', HomeBranchIfscUploadController);

    HomeBranchIfscUploadController.$inject = ['$scope', '$state', 'workflowSharedService', 'HomeBranchIfscUpload', 'EntityPermissions', 'ScreenLog', 'entityConstants','ImportFile', 'AlertService', '$filter','ImportFileService', 'MessageBox','FileUtil','$rootScope'];
    function HomeBranchIfscUploadController($scope, $state, workflowSharedService, HomeBranchIfscUpload, EntityPermissions, ScreenLog , entityConstants,ImportFile, AlertService,$filter ,ImportFileService, MessageBox,FileUtil,$rootScope) {
    	
    	var vm = this;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.HOME_BRANCH_IFSC_UPLOAD;
        vm.entityConstants = entityConstants;
        vm.screenLog = ScreenLog;
        vm.generateTemplate = generateTemplate;
        vm.uploadFile = uploadFile;
		
        vm.invalidFileSize = false;
		vm.invalidFileName = false;
		vm.invalidFileNameText = "Invalid File Name";	
		vm.invalidFileSizeText = "Uploaded File size should be minimum of 1 Byte and maximum of 3MB";
		vm.invalidFileText = "Invalid file format";
		
		vm.invalidFile = false;
		vm.uploadedIfscData=null;
		 var Extensions = ["xls","xlsx"];
		
		workflowSharedService.viewFrom = "homeBranchIFSCUpload";
		vm.mimeType = 'application/vnd.ms-excel';
		vm.baseString = "homebranchupload"+ ".xls";  
		$rootScope.homebranchUploadInProgress = false;
				
		/* vm.permitUpload = EntityPermissions.hasPermission( vm.screenName+'.' +vm.entityConstants.ENTITY_ACTION_TYPE.IMPORT);
		
		if(vm.permitUpload == false){
			  $state.go('home');
		} */
		 var minFileSizeinBytes = 1;
	     var maxFileSizeinBytes = 3*1024*1024;
	     vm.fileExtension = "";
	     vm.inputFileName = "";
	     vm.fileNameWithoutExtension = "";
       
        logScreenAccess();
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }
        function uploadFile(){        	
        	$rootScope.homebranchUploadInProgress = false;
        	if(vm.invalidFile == true){
        		vm.uploadedIfscData=null;
		        vm.inputFileName=null;
		        angular.element("input[type='file']").val(null);
				AlertService.error(vm.invalidFileText);
			}else if(vm.invalidFileSize == true){
				vm.uploadedIfscData=null;
		        vm.inputFileName=null;
		        angular.element("input[type='file']").val(null);
				AlertService.error(vm.invalidFileSizeText);
			}else if(vm.invalidFileName == true){
				vm.uploadedIfscData=null;
		        vm.inputFileName=null;
		        angular.element("input[type='file']").val(null);
				AlertService.error(vm.invalidFileNameText);
			}else {
				ImportFile.importFile('HomeBranchImport',vm.uploadedIfscData);
				 vm.inputFileName=null;
			       angular.element("input[type='file']").val(null);
		      	
			}
		}        
        function generateTemplate(){
        	//ImportFile.generateTemplate( 'HomeBranchIFSCUpload');
        	HomeBranchIfscUpload.generateTemplateFile(generateSuccess, generateFailure)
        	
        }
        function generateSuccess(result){
        	/*var base64data = "base64," + $.base64.encode(result.data);
            var blob = new Blob([csvstring], { type: "application/vnd.ms-excel" + ';' + base64data })
            window.saveAs(blob, "homebranchupload" + "."  + "xls");*/
        	
        	var fileData = null;
   		  	fileData = result.data;
   		  	var link = document.createElement("a");   
   		  	var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer   		  
   		  
   		  	var blob = new Blob([bytes], {type: vm.mimeType});
   		  	if(window.navigator.msSaveOrOpenBlob) {
                   window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
   		  	}else{
   	    	  link.href =  window.URL.createObjectURL(blob);      
   	    	  link.download = vm.baseString;
   	    	  document.body.appendChild(link);
   	    	  link.click();
   	    	  document.body.removeChild(link);
   		  	}
        }
        function generateFailure(error){
        	//AlertService.error($filter('translate')('gatewayApp.homeBranchIfscUpload.templateError'));
        }
       /* function onImportSuccess(result) {
			
			MessageBox.showMessageBox("Alert", " File has been uploaded successfully. ", "Ok");
			$state.go($state.current, {}, {});
		
		
        }
        function onImportFailure(result) {
			console.log(result);
			if(result.data!="") {
				ImportFileService.exportException(result.data, true, 'HomeBranchImport' + '_error');
	    	}else{
	            MessageBox.showMessageBox("Alert",'HomeBranchImport' + " - Invalid File", "Ok");    
	    	}
			$state.go($state.current, {}, {});
        }*/
        
       $scope.$watch('vm.uploadedIfscData', function(value){
        	if(value!=null && value!=undefined){
        		vm.inputFileName = value.name;
        		console.log(minFileSizeinBytes);
        		console.log(maxFileSizeinBytes)
        		console.log(value.size)
        		console.log(FileUtil.isFileSizeValid(value.size ,minFileSizeinBytes , maxFileSizeinBytes  ))
        		if(!FileUtil.isFileSizeValid(value.size ,minFileSizeinBytes , maxFileSizeinBytes  )){
        			vm.invalidFileSize = true;
        			vm.invalidFileName = false;
        			vm.invalidFile = false;
        			
        		}else{
        			vm.fileNameWithoutExtension ="";        	
        			vm.invalidFileSize = false;
        			vm.invalidFile = false;
        			if(value.name!=null && value.name!=undefined){
            			vm.fileExtension = vm.inputFileName.substring(value.name.lastIndexOf(".") + 1);
            			vm.fileNameWithoutExtension =  vm.inputFileName.substring(0,value.name.lastIndexOf("."));
        			}else{
        				
    			         vm.invalidFile = false;
    			         vm.invalidFileSize = false;
    			         vm.invalidFileName = true;
    			        
    			         //AlertService.error(vm.invalidFileNameText );
        			}    			
        			
        			if(vm.fileNameWithoutExtension != 'homebranchupload' && vm.fileNameWithoutExtension != 'homebranchupload' ){
        				
    			         vm.invalidFile = false;
    			         vm.invalidFileSize = false;
    			         vm.invalidFileName = true;
        			 }
        			 else if(Extensions.indexOf(vm.fileExtension.toLowerCase()) <= -1) {
    		        	
        				//check for extension
    		        	vm.invalidFile = true;
    		        	vm.invalidFileName = false;
    		        	vm.invalidFileSize = false;
        			 }
        			 else{
        				var reader = new FileReader();
        				 reader.readAsArrayBuffer(value);
        				
        				reader.onloadend = function(e) {
        					if (e.target.readyState === FileReader.DONE) {
        						var bytes = new Uint8Array( e.target.result ); 
        						var arr = bytes.subarray(0, 4);
            					if(!FileUtil.checkExcelFileExtension(arr)){          				        	
          				        	
            						vm.invalidFile = true;
          					        vm.invalidFileSize = false;
          					        vm.invalidFileName = false;          					             					      
          				      	}else{    				      		
          				      		
          				      		vm.invalidFile = false;
          				      		vm.invalidFileSize = false;
          				      		vm.invalidFileName = false;
          						 
          				      	}
        					}
        					
        				};
        				
        			 }  
        		}
        	}
        });
       var setFoucs = function(){
    	   
    	   angular.element("#downloadTemplate").focus();
    	}     
       angular.element(document).ready(setFoucs);
   	

    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('HomeBranchFilterController', HomeBranchFilterController);

    HomeBranchFilterController.$inject = ['$scope', '$state',  '$uibModalInstance', '$rootScope', '$stateParams'];

    function HomeBranchFilterController($scope, $state,$uibModalInstance, $rootScope, $stateParams) {    
        var vm = this;
        vm.filterText = $stateParams.filterText;
        vm.clear=clear;
     
        function clear() {
			$uibModalInstance.dismiss('cancel');
		}
        
        $scope.$watch('vm.branch', function(value){
        	if(value!=null && value!='' && value!= undefined){
        		$rootScope.branch=value;
        		$scope.$emit('searchBranch'); 
        		$uibModalInstance.dismiss('cancel');
        	}
        })
     }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('holiday-report', {
            parent: 'entity',
            url: '/holiday-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.holidayReport.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/holiday-report/holiday-report.html',
                    controller: 'HolidayReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('holidayReport');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
       
         
         };
    })();

(function() {
	'use strict';
	angular.module('gatewayApp').factory('HolidayReport',
			HolidayReport);

	HolidayReport.$inject = [ '$resource' ];

	function HolidayReport($resource) {
		var resourceUrl = 'api/holiday-report/:id';

		return $resource(resourceUrl, {}, {

			'getAllTheYears' : {
				method : 'GET',
				url : 'api/get-all-years',
				 isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
			},
			'getHolidayListAfterGivenDate' : {
				method : 'GET',
				url : 'api/holiday-list-after-given-date',
				 isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
			},
			'getSpecificYearData':{
				isArray: true,
			    method: 'GET',
                url: 'api/get-specific-year-data',
                params : {
                	givenYear : '@givenYear',
					currencyCode : '@currencyCode',
					holidayType :'holidayType'
				},
                transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
			},
			'getCurrentYearData':{
			    method: 'GET',
			    isArray: true,
                url: 'api/get-current-year-data',
                params : {
					currencyCode : '@currencyCode',
					holidayType :'@holidayType'
				},
                transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
			},
			 'excelHolidayReport':{
				    method: 'POST',
	                url: 'api/history-report/excel',
	                responseType: 'arraybuffer',
	                  transformRequest: function (data) {
	                     	var copy = angular.copy(data);
	                     	
	                         return angular.toJson(copy);
	                     },
	                    transformResponse: function(data, headers) {
	                  	  return {
	                            data: data,
	                            headers: headers
	                        };   
	                    }  
				},
				 'csvHolidayReport':{
					    method: 'POST',
		                url: 'api/history-report/csv',
		                responseType: 'arraybuffer',
		                  transformRequest: function (data) {
		                     	var copy = angular.copy(data);
		                     	
		                         return angular.toJson(copy);
		                     },
		                    transformResponse: function(data, headers) {
		                  	  return {
		                            data: data,
		                            headers: headers
		                        };   
		                    }  
					}

		});
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'holidayReport'
        })
        
        .controller('HolidayReportController', HolidayReportController);

    HolidayReportController.$inject = ['$scope', '$state', 'InvoiceView', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
    				'$timeout','DateUtils','StaticLookUp','MessageBox','$rootScope','HolidayReport'];

    function HolidayReportController($scope, $state, InvoiceView , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
    				$timeout,DateUtils,StaticLookUp,MessageBox,$rootScope,HolidayReport) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.HOLIDAY_REPORT;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        vm.isRegenerated=false;
        vm.selectedFilter='group'; 
        vm.loadHolidayYearsAndCurrency=loadHolidayYearsAndCurrency;
		vm.clicked=false;
        vm.getHolidayData=getHolidayData;
        vm.changedYear=changedYear;
        vm.onObtainHolidayReportSuccess=onObtainHolidayReportSuccess;
        vm.onObtainHolidayReportFailure=onObtainHolidayReportFailure;
        vm.exportToFile=exportToFile;
        vm.ExpandOrCollapseHolidayReport=true;
        vm.enableShowFuture=true;
        vm.holidayData=[];
        vm.allHolidayType = [];
        workflowSharedService.viewFrom = "holidayReport";
        vm.mimeType= '';  	  
 	  	vm.baseString =   'Holiday_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm'); 
 	  	vm.selectedCurrentYear=true;
 	  	// vm.selectedCurrency="ALL";
 	  	vm.logScreenAccess=logScreenAccess;
 	  	
        loadHolidayYearsAndCurrency();
        logScreenAccess();
        vm.selectedHolidayType = "All";
		loadCurrency();

       // loadCurrentBusinessDate();
        
        /*function getAllHolidayType(){
        	vm.allHolidayType = StaticLookUp.getAllHolidayType();
        	vm.allHolidayType.push("ALL");
        }
        */

		function loadCurrency(){
        	 StaticLookUp.getCurrency(currencySuccess,currencyFailure);
         }

		 function currencySuccess(result){
        	 vm.currencies = result;
         }
         function currencyFailure(error){
        	 
         }

        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }
        
        function changedYear()
        {
        	var currentYear=new Date().getFullYear();
        
        	if(vm.selectedYear==currentYear)
        		{
        			vm.enableShowFuture=true;
        			vm.selectedCurrentYear=true;
        		}
        	else
        		{
        		vm.enableShowFuture=false;
        		vm.selectedCurrentYear=false;
        		}
        }
        
        function loadHolidayYearsAndCurrency(){
        	HolidayReport.getAllTheYears(function(result){
        		vm.yearsList = result;
        	});
        	
        	vm.selectedYear=new Date().getFullYear();

        }
        
        
        function getHolidayData()
        {
        				var currency='';
        	
			        	// if(vm.selectedCurrency!="ALL")
			        	// {
			        	// 	currency=vm.selectedCurrency;
			        	// }
						if(vm.currencyCode!=null)
			        	{
			        		currency=vm.currencyCode.code;
			        	}
			        	if(vm.selectedCurrentYear==true)
			        	{
			        		HolidayReport.getCurrentYearData({currencyCode:currency,holidayType:vm.selectedHolidayType},onObtainHolidayReportSuccess,onObtainHolidayReportFailure)
			        	}
			        	else
			        	{
			        		HolidayReport.getSpecificYearData({givenYear : vm.selectedYear,currencyCode:currency,holidayType:vm.selectedHolidayType},onObtainHolidayReportSuccess,onObtainHolidayReportFailure)
			
			        	}
          }
        function onObtainHolidayReportSuccess(result){
    		vm.holidayData=result;
			vm.clicked=false;
    		console.log(result);
    	}
        
        function onObtainHolidayReportFailure()
        {
        	vm.clicked=false;
        }
      	
        
        
        function exportToFile(fileType){
        	vm.baseString =   'Holiday_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm'); 
        	
        	 vm.convertedTodayDate = DateUtils.convertLocalDateToServer(vm.todayDate);
    	
        	  if( vm.holidayData !=null &&  vm.holidayData!=undefined){
        		  if(fileType == 'csv'){
        			  vm.mimeType = 'text/csv'
        			  vm.baseString =vm.baseString+ ".csv";  
        			  HolidayReport.csvHolidayReport(vm.holidayData, onGenerateFileSuccess);
        		  }else if(fileType == 'excel'){
        			  vm.mimeType = 'application/vnd.ms-excel';
        			  vm.baseString = vm.baseString+ ".xls";
        			  HolidayReport.excelHolidayReport(vm.holidayData, onGenerateFileSuccess);
        		  }
        		 

        		  function onGenerateFileSuccess(result)
        		  {
        	    	  var fileData = null;
        			  fileData = result.data;
        			  var link = document.createElement("a");   
        			  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
        			  
        			  
        		      var blob = new Blob([bytes], {type: vm.mimeType});
        		      if(window.navigator.msSaveOrOpenBlob) {
        	                window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
        		      }else{
        		    	  link.href =  window.URL.createObjectURL(blob);      
        		    	  link.download = vm.baseString;
        		    	  document.body.appendChild(link);
        		    	  link.click();
        		    	  document.body.removeChild(link);
        		      }
        		  }
        		  
    
        		  
        	  }
          }	
		
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('history-report', {
            parent: 'entity',
            params:{screen: 'HistoryReport'},
            url: '/history-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.HistoryReport.manageHistoryReport" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/history-report/history-report.html',
                    controller: 'HistoryReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('historyReport');
                    $translatePartialLoader.addPart('smsSettings');
                    $translatePartialLoader.addPart('bankRegistration');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('role');
                    $translatePartialLoader.addPart('branch');
                    $translatePartialLoader.addPart('securityPolicy');
                    $translatePartialLoader.addPart('entityActionApprovalPolicy');
                    $translatePartialLoader.addPart('approvalPolicy');
                    $translatePartialLoader.addPart('alertconfiguration');
                    $translatePartialLoader.addPart('customer-registration');
                    $translatePartialLoader.addPart('markupSettings');
                    $translatePartialLoader.addPart('defaultMarkupSettings');
                    $translatePartialLoader.addPart('heConnectivitySettings');
                    $translatePartialLoader.addPart('intradayMarketSessionSettings');
                    $translatePartialLoader.addPart('defaultMarketSessionSettings');
                    $translatePartialLoader.addPart('emailSettings');
                    $translatePartialLoader.addPart('amcSettings');
                    $translatePartialLoader.addPart('customerCharges');
                    $translatePartialLoader.addPart('gstSettings');
                    $translatePartialLoader.addPart('transactionChargesSettings');
                    $translatePartialLoader.addPart('creditFactorSettings');
                    return $translate.refresh();
                }],
                entity: function(){
                	
                }
            }
        })
       
       };
    })();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('HistoryReport', HistoryReport);

    HistoryReport.$inject = ['$resource'];

    function HistoryReport ($resource) {
        var resourceUrl =  'api/get-history-report/:id';

        return $resource(resourceUrl, {}, {
            
        	 'getHistoryReportDetails':{
             	isArray:true,
  				method: 'GET',
  				params: {entityId:'@entityId',login:'@login',from:'@from',to:'@to',orgId:'@orgId'},
  				url: 'api/history-report/:entityId/:from/:to/get-history-report-details'
              },
             'getHistoryReportDetailsFromArchive':{
               	isArray:true,
    			method: 'GET',
    			params: {entityId:'@entityId',login:'@login',from:'@from',to:'@to',orgId:'@orgId'},
    			url: 'api/history-archive-report/:entityId/:from/:to/get-history-report-details'
              }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function() {
            this.viewFrom = ''
        })
        .controller('HistoryReportController', HistoryReportController);

    HistoryReportController.$inject = ['$scope', '$state', 'workflowSharedService','$rootScope','MessageBox','HistoryReport', 'GlobalValues','EntityPermissions','$filter', 'entity','DateUtils','ScreenLog','entityConstants','AlertService'];

    function HistoryReportController($scope, $state, workflowSharedService, $rootScope, MessageBox, HistoryReport, GlobalValues, EntityPermissions,$filter, entity,DateUtils,ScreenLog,entityConstants,AlertService) {    
        var vm = this;
        vm.globalValues = GlobalValues;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.getHistoryReport=getHistoryReport;
        vm.todayDate=new Date();
        vm.Values=Values;
        vm.userEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.userListValue={};
        vm.ExpandOrCollapseHistoryReport = true;
        vm.screenLog=ScreenLog;
        logScreenAccess();
        vm.valid=false;
		vm.clicked=false;
        vm.historicalOrCurrent = 'Current';

		vm.reportDate  = DateUtils.convertDateTimeFromServer(vm.todayDate);
		vm.yesterdayDate = angular.copy(vm.reportDate);
		vm.yesterdayDate.setDate(vm.yesterdayDate.getDate() - 1);
		vm.fromDate = angular.copy(vm.reportDate);
		vm.fromDate.setDate(vm.fromDate.getDate() -1);
	    vm.toDate = angular.copy(vm.reportDate);
	    vm.toDate.setDate(vm.toDate.getDate() -1);
	    vm.orgId = null;
  	    /*
         * Get details for history report given login name, screen, from and to date
         */
        function getHistoryReport()
        {   
        	vm.historyReportDetails = [];
        	setOrganisationIdForSlectedEntity();
        	if(vm.historicalOrCurrent != 'Current' && moment(vm.fromDate).isAfter(vm.yesterdayDate,'day')){
    			AlertService.error($filter('translate')('gatewayApp.HistoryReport.futureFromDate'));
    			vm.valid=false;
    		}
    		else if(vm.historicalOrCurrent != 'Current' && moment(vm.fromDate).isAfter(vm.toDate,'day')){
    			AlertService.error($filter('translate')('gatewayApp.HistoryReport.greaterFromDate'));
    			vm.valid=false;
    		}
    		else if (vm.historicalOrCurrent != 'Current' && moment(vm.toDate).isAfter(vm.yesterdayDate,'day')){
    			AlertService.error($filter('translate')('gatewayApp.HistoryReport.greaterToDate'));
    			vm.valid=false;
    		}
        	
    		else{
				vm.clicked=true;
    			vm.valid=true;
    			var from=$filter('date')(vm.fromDate, "yyyy-MM-dd");
        		var to=$filter('date')(vm.toDate, "yyyy-MM-dd");
        		var entityId = 0;
        		if(vm.screenName!=undefined && vm.screenName!=null && vm.screenName!=""){
        			entityId = vm.screenName.id; 
        		}
        		if(vm.historicalOrCurrent == 'Current'){
        			from=$filter('date')(vm.todayDate, "yyyy-MM-dd");
        			to=$filter('date')(vm.todayDate, "yyyy-MM-dd");
            		HistoryReport.getHistoryReportDetails({"entityId":entityId,"login":vm.userListValue,"from":from,"to":to,"orgId":vm.orgId},onGetHistoryReportDetailsSuccess,onGetHistoryReportDetailsError);
        		}else{
            		HistoryReport.getHistoryReportDetailsFromArchive({"entityId":entityId,"login":vm.userListValue,"from":from,"to":to,"orgId":vm.orgId},onGetHistoryReportDetailsSuccess,onGetHistoryReportDetailsError);
        		}
    		}
        		
            		

        }
        
        function setOrganisationIdForSlectedEntity(){
        	if(vm.userEntityOwnerType == vm.selectedEntityOwnerType){
        		vm.orgId = vm.globalValues.getOrgId(); 
        		console.log("logged in user org id "  + vm.orgId);
        	}else{
	        	if(vm.userEntityOwnerType == 'Clearcorp'){
	        	
		        	 if( vm.selectedEntityOwnerType =='Bank' || vm.selectedEntityOwnerType == 'Branch'){
		        		vm.orgId = vm.bankValue.id; 
		        		console.log("selected bank or branch org id "  + vm.orgId);
		        	}else if( vm.selectedEntityOwnerType =='SingleUserCustomer' || vm.selectedEntityOwnerType == 'MultiUserCustomer'){
		        		vm.orgId = vm.customerValue.id; 
		        		console.log("selected customer id "  + vm.orgId);
		        	}
	        	}else if(vm.userEntityOwnerType == 'Bank'){
	        		
	        		if(vm.selectedEntityOwnerType == 'Branch'){
		        		vm.orgId = vm.globalValues.getOrgId(); 
		        		console.log("logged in user org id "  + vm.orgId);
	        		}else if( vm.selectedEntityOwnerType =='SingleUserCustomer' || vm.selectedEntityOwnerType == 'MultiUserCustomer'){
		        		vm.orgId = vm.customerValue.id; 
		        		console.log("selected customer id "  + vm.orgId);
		        	}
	        	}else if(vm.userEntityOwnerType == 'Branch'){
	        		
	        		if( vm.selectedEntityOwnerType =='SingleUserCustomer' || vm.selectedEntityOwnerType == 'MultiUserCustomer'){
		        		vm.orgId = vm.customerValue.id; 
		        		console.log("selected customer id "  + vm.orgId);
		        	}
	        	}
	        	
        	}
        }
        //vm.fromDate = DateUtils.convertDateTimeFromServer(vm.todayDate);
        //vm.toDate = DateUtils.convertDateTimeFromServer(vm.todayDate);
        function onGetHistoryReportDetailsSuccess(result)
        {
        	
        	vm.historyReportDetails=result;
			vm.clicked=false;
        	
        }
        
        
        function onGetHistoryReportDetailsError()
        {
        	vm.clicked=false;
        }
        
        /*
         * Load the screen by passing entity and payload
         */
        
        function Values(entity,payload,actionName){
            $rootScope.payload = payload;
            $rootScope.actionName = actionName;
            workflowSharedService.viewFrom = getViewFrom(entity,actionName);
            var state = getState(entity,actionName);
            $state.go(state);
            
            
        	
        }
        
        
        
        function getViewFrom(entity,actionName){
        	if (entity == 'SecurityPolicy'){
        		return 'securityPolicy_auditLog';
        	}
        	else if (entity == 'GlobalSecurityPolicy'){
        		return 'globalSecurityPolicy_auditLog';
        	}        	
        	else if (entity == 'EntityStateApprovalProcess'){
        		return 'entityActionApprovalPolicy_auditLog';
        	}
        	
        	
        	else if (entity == 'ApprovalProcess'){
        		return 'approvalPolicy_auditLog';
        	}
        	
        	
        	else if (entity == 'OrganisationRole'){
        		return 'role_auditLog';
        	}
        	
        	
        	else if (entity == 'UserRole' ){
        		return 'userroletodolist_auditLog';
        	}
        	

        	else if (entity == 'UserManagement') {
        		return 'userRole_auditLog';
        	}
        	
          	else if (entity == 'BankRegistration'){
          		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'|| actionName=='REJECT - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}else{
        			return 'bankregistration_auditlog';
        		}
        	}
        	
        	else if (entity == 'BranchRegistration'){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'|| actionName=='REJECT - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}else{
        			return 'branch_auditLog';
        		}
        	}
			else if (entity == 'ManageHomeBranch'){
				return 'homebranch_auditLog';
		    }
        	else if (entity == 'AlertConfiguration'){
        		return 'alertConfiguration_auditLog';
        	}

        	
        	
        	else if (entity == 'SMSSettings'){
        		return 'smssettings_auditlog';
        	}
        	else if(entity=='CustomerRegistration'){
        		return 'customerregistrationtodolist_historyReport';
        	}
        	else if(entity=='Customer'){
        		return 'customerregistrationtodolist_historyReport'
        	}
        	else if (entity == 'UserAdminApplicationWideSettings'){
        		return 'userAdminApplicationWideSettings_auditlog';
        	}
        	
          	else if (entity == 'DealingAdminApplicationWideSettings'){
        		return 'dealingAdminApplicationWideSettings_auditlog';
        	}
			else if (entity == 'TransactionParametersSettings'){
        		return 'transaction-parameters-settings_auditlog';
        	}
          	else if (entity == 'DefaultMarkupSettings'){
        		return 'defaultMarkup_auditlog';
        	}
        	
          	else if (entity == 'MarkupSettings'){
          		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}else if(actionName=='ADD CONFIRM-IMPORT'){
        			return 'markup_import_auditlog';
        		}else{
        			return 'markup_auditLog';
        		}
          	}
          	else if (entity == 'HEConnectivitySettings'){
        		return 'heConnectivitySettings_auditlog';
        	}
          	else if (entity=='IntradayMarketSessionSettings'){
        		return 'intradayMarketSessionSettings_auditlog' ;
        	}
          	else if (entity=='DefaultMarketSessionSettings'){
          		return 'defaultMarketSessionSettings_auditlog';
          	}
          	else if (entity=='EmailSettings'){
          		return 'emailSettings_auditlog' ;
          	}
          	else if (entity=='UserRestriction'){
        		return 'userRestriction_auditLog';
        	}
          	else if (entity=='SwapQuotes'){
          		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT' || actionName=='REJECT - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}   
        		return 'swapQuotes_auditLog';
        	}
          	else if (entity=='SpecialHoliday'){
        		return 'specialHoliday_auditLog';
        	}
          	else if (entity=='RegularHolidays'){
        		return 'regularHoliday_auditLog';
        	}
          	else if (entity=='LimitSettings'){
          		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'  || actionName=='REJECT - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}else if(actionName=='ADD CONFIRM-IMPORT'){
        			return 'limit_import_auditlog';
        		}else{
        			return 'limitSettings_auditLog';
        		}
        		
        	}
          	else if (entity=='CustomerLimitChangeRequest'){
          		
          		if(actionName.indexOf('CREATE') >= 0 && (vm.userEntityOwnerType == 'SingleUserCustomer' || vm.userEntityOwnerType =='MultiUserCustomer') )
          			return 'create_customer_limitSettings_auditLog';
          		else
          			return 'customer_limitSettings_auditLog';
        	}
        	else if (entity=='EntityRestriction'){
        		return 'entityRestriction_auditLog';
        	}
        	else if (entity == 'AMCSettings'){
          		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}else if(actionName=='ADD CONFIRM-IMPORT'){
        			return 'amc_import_auditlog';
        		}else{
        			return 'amcSettings_auditlog';
        		}
          	}
        	else if (entity == 'CustomerCharges'){
          		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}else if(actionName=='ADD CONFIRM-IMPORT'){
        			return 'customer_charges_import_auditlog';
        		}else{
        			return 'customerCharges_auditlog';
        		}
          	}
        	else if (entity == 'GSTSettings'){
          		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}else if(actionName=='ADD CONFIRM-IMPORT'){
        			return 'gst_settings_import_auditlog';
        		}else{
        			return 'gstSettings_auditlog';
        		}
          	}
        	else if (entity=='TransactionChargesSettings'){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'|| actionName == 'REJECT - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}else{
        			return 'transactionChargesSettings_auditlog';
        		}
        		
        	}
            else if (entity=='CreditFactorSettings'){
                return 'creditFactorSettings_auditlog';
            }
        	else if (entity=='HomeBranchIFSCUpload'){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'|| actionName == 'REJECT - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}
        		
        	}
        	else if (entity=='ModifyCustomerDetails'){
        		//modifycustomerdetails_auditlog
        		return 'modifycustomerdetails_auditlog';
        	}
        	else if (entity=='TermsAndConditionsUpload'){

        		return 'termsConditionUpload_auditlog';
        	}
		else if (entity=='TermsAndConditionsView'){
        		
        		return 'entited_tac_view_auditLog';
        	}
		else if (entity=='CustomerTermsAndConditionsUpload'){
        		return 'customerTermsConditionUploadByBank_auditlog';
        	}

		else if (entity=='BankFeesChargesUpload'){
	    		return 'bankFeesAndChargesUpload_auditlog';
	    	}
			else if (entity == 'PendingOrderReport'){
        		return 'messageuploadtodolist_auditLog';
        	}
		else if (entity == 'ManageBBPSSettings'){
        	return 'bbps_settings_auditLog';
        }
        }
        
        function getState(entity,actionName){
        	if (entity == 'SecurityPolicy'){
        		return 'security-policy-historyReport';
        	}
        	else if (entity == 'GlobalSecurityPolicy'){
        		return 'global-security-policy-historyReport';
        	}
        	
        	
        	else if (entity == 'EntityStateApprovalProcess'){
        		return 'entity-action-approval-policy-historyReport';
        	}
        	
        	
        	else if (entity == 'ApprovalProcess' ){
        		return 'approval-policy-historyReport';
        	}
        	
        	
        	else if (entity == 'OrganisationRole'){
        		return 'manage-role-historyReport';
        	}
        	
        	
        	else if (entity == 'UserRole' ){
        		return 'manage-users-role-historyReport';
        	}
        	
        	
        	else if (entity == 'UserManagement'){
        		return 'usermanagement-historyReport';
        	}
        	
         	else if (entity == 'BankRegistration' ){
         		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'|| actionName=='REJECT - IMPORT'){
        			return 'upload-todolist-historyReport';
        		}else{
        			return 'bank-registration-historyReport';
        		}
        	}
        	
        	else if (entity == 'BranchRegistration' ){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'|| actionName=='REJECT - IMPORT'){
        			return 'upload-todolist-historyReport';
        		}else{
        			return 'branch-historyReport';
        		}
        	}
        	
        	else if (entity == 'AlertConfiguration'){
        		return 'alert-configuration-historyReport';
        	}
        	else if (entity == 'SMSSettings' ){
        		return 'sms-settings-historyReport';
        	}
        	else if(entity=='CustomerRegistration'){
				var customerRegistration =  angular.fromJson($rootScope.payload);
				if( customerRegistration.primaryContactName != ""){
					return 'old-customer-registration-historyReport';
                    }else{
						return 'customer-registration-historyReport';
					}
        	
        	}
        	else if(entity=='Customer'){
        		return 'customer-info-status-view-historyreport';
        	}
        	else if (entity == 'DealingAdminApplicationWideSettings' ){
        		return 'dealing-admin-change-config-historyreport';
        	}
        	
         	else if (entity == 'UserAdminApplicationWideSettings' ){
        		return 'change-config-historyreport';
        	}
         	else if(entity=='CustomerSpecificSettings')
         		{
         			return 'customer-specific-settings-historyreport'
         		}
        	
         	else if (entity == 'DefaultMarkupSettings'){
         		return 'default-markup-historyReport';
         	}
         	else if (entity=='MarkupSettings'){
         		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'upload-todolist-historyReport';
        		}else{
        			return 'markup-historyReport';
        		}
         		return 'markup-historyReport';
         	}
         	else if(entity=='HEConnectivitySettings'){
        		return 'he-connectiviy-settings-historyReport';
        	}
         	else if(entity=='IntradayMarketSessionSettings'){
         		return 'intraday-market-settings-historyReport';
         	}
         	else if (entity=='DefaultMarketSessionSettings'){
         		return 'default-market-settings-historyReport';
         	}
         	else if (entity=='EmailSettings'){
         		return 'email-historyReport';
         	}
         	else if (entity=='UserRestriction'){
        		return 'userRestriction-historyReport';
        	}
         	else if (entity=='SwapQuotes'){
         		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT' || actionName=='REJECT - IMPORT'){
        			return 'upload-todolist-historyReport';
        		}
         		var swapQuotesForTenorDatesDTO =  angular.fromJson($rootScope.payload);
        		if(swapQuotesForTenorDatesDTO.swapQuotesForTenorDatesList == undefined ){
        			return 'old-swapQuotes-historyReport';
        		}
        		return 'swapQuotes-historyReport';
        	}
          	else if (entity=='SpecialHoliday'){
        		return 'specialHoliday-historyReport';
        	}
          	else if (entity=='RegularHolidays'){
        		return 'regularHoliday-historyReport';
        	}
          	else if (entity=='LimitSettings'){
          		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT' || actionName=='REJECT - IMPORT'){
        			return 'upload-todolist-historyReport';
        		}else{
                    var limitSettingsHeaderDTO =  angular.fromJson($rootScope.payload);
                    if(limitSettingsHeaderDTO.limitInstrumentGroup == undefined ){
                        return 'old-limit-settings-auditLog';
                    }
        			return 'limit-settings-historyReport';
        		}
        		
        	}
          	else if (entity=='CustomerLimitChangeRequest'){         	
          			
          		if(actionName.indexOf('CREATE') >= 0 && (vm.userEntityOwnerType == 'SingleUserCustomer' || vm.userEntityOwnerType =='MultiUserCustomer') )
          			return 'create-customer-limit-settings-historyReport';
          		else
                    var customerLimitSettingsDTO =  angular.fromJson($rootScope.payload);
                    if(customerLimitSettingsDTO.limitSettingsHeader.limitInstrumentGroup == undefined ){
                        return 'old-customer-limit-settings-auditLog';
                    }
          			return 'customer-limit-settings-historyReport';
        	}
          	else if (entity=='EntityRestriction'){
        		return 'manage-Entity-Restrictions-historyReport';
        	}
          	else if (entity=='AMCSettings'){
         		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'upload-todolist-historyReport';
        		}else{
        			return 'amc-historyReport';
        		}
         		return 'amc-historyReport';
         	}
          	else if (entity=='CustomerCharges'){
         		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'upload-todolist-historyReport';
        		}else{
        			return 'customer-charges-historyReport';
        		}
         		return 'customer-charges-historyReport';
         	}
          	else if (entity=='GSTSettings'){
         		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'upload-todolist-historyReport';
        		}else{
        			return 'gst-settings-historyReport';
        		}
         		return 'gst-settings-historyReport';
         	}
          	else if (entity=='TransactionChargesSettings'){
          		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT' || actionName == 'REJECT - IMPORT'){
          			return 'upload-todolist-historyReport';
          		}else{
          			return 'transaction-charges-settings-historyReport';
          		}
    		
          	}
            else if (entity=='CreditFactorSettings'){
                return 'credit-factor-settings-historyReport';
            }
          	else if (entity=='HomeBranchIFSCUpload'){
          		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'|| actionName == 'REJECT - IMPORT'){
          			return 'upload-todolist-historyReport';
          		}
          	}
          	else if (entity=='ModifyCustomerDetails'){
        		//modifycustomerdetails_auditlog
        		return 'modify-customer-details-historyreport';
        	}
          	else if (entity=='TermsAndConditionsUpload'){

        		return 'terms-condition-upload-historyReport';
        	}
		else if (entity=='TermsAndConditionsView'){
        		
        		return 'entities-tac-view-historyReport';
        	}
		else if (entity=='CustomerTermsAndConditionsUpload'){

        		return 'customer-tac-upload-by-bank-historyReport';
        	}
		else if (entity=='BankFeesChargesUpload'){

		    		return 'bank-fees-charges-upload-historyReport';
		   	}
		else if (entity == 'PendingOrderReport'){
        		return 'upload-todolist-historyReport';
        	}
		else if(entity=='BankNotificationSettings'){
					return 'notification-settings-historyreport'
				}
		else if (entity == 'ManageHomeBranch'){
				return 'home-branch-historyReport';
		    }
		else if(entity =='ManageCurrencyPairConfiguration'){
				return 'currency-pair-configuration-historyReport';
		}
		else if (entity=='ManageInstrument'){
                return 'manage-instrument-historyReport';
        }
			   
        }
        function logScreenAccess(){
           	ScreenLog.screenLog( entityConstants.ENTITY_SHORT_NAME.HISTORY_REPORT,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }

     }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('he-status-update', {
            parent: 'entity',
            url: '/he-status-update',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.heStatusUpdate.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/he-status-update/he-status-update.html',
                    controller: 'HEStatusUpdateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('heStatusUpdate');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
         
         };
    })();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'heStatusUpdate'
        })
        
        .controller('HEStatusUpdateController', HEStatusUpdateController);

    HEStatusUpdateController.$inject = ['$scope', '$state',  'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout',
    		'HeConnectivity','MessageBox','$rootScope','AlertService','$filter'];

    function HEStatusUpdateController($scope, $state,  GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout,HeConnectivity,
    			MessageBox,$rootScope,AlertService,$filter) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.HE_STATUS_UPDATE;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        workflowSharedService.viewFrom = "heStatusUpdate";
        vm.screenLog = ScreenLog;
        var yesMessageEvent = null;
        var statusUpdateEvent=null;
        logScreenAccess();
        loadAll();
        vm.sendHEStatusUpdate = sendHEStatusUpdate;
        
        vm.todayDate = new Date();
      
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       function loadAll(){
    	   HeConnectivity.query({"orgId": GlobalValues.getOrgId()},function(result) {
               vm.currentStatus = result[0].interactiveStatus;
               
               if(vm.currentStatus=='Online'){
        		   vm.changedStatus='Offline';
        	   }else{
        		   vm.changedStatus='Online';
        	   }
               
            }); 
    	   
    	   
       }
       
       function sendHEStatusUpdate(){
    	   $scope.status = vm.changedStatus;
    	   MessageBox.openMessageBox("Alert", "Do you want to change the HE Interactive Status?", "YesNo", "changeHEStatus");
       }
       
       $scope.$on('$destroy', function() {
 		  if (yesMessageEvent!=null )
 			  	yesMessageEvent();
	        });
   
 		
    	 yesMessageEvent = $rootScope.$on('gatewayApp.messagebox.yes.changeHEStatus', function (event, data) {
 			if($scope.status!=null && $scope.status!=undefined){
 				vm.heStatusUpdate = "PROGRESS";
 				HeConnectivity.changeStatus({status : $scope.status},changeStatusSuccess,changeStatusFailure);
 				
 			}
 		});
 	
 
		$rootScope.$on('gatewayApp.messagebox.no.changeHEStatus', function (event, data) {
			//do nothing
		});
		
		function changeStatusSuccess(){
			
		}
		
		function changeStatusFailure(error){
			vm.heStatusUpdate = "";
			if(error.status==503){
				
				AlertService.error($filter('translate')( "error.order.serviceUnavailable"));
			}else if(error.status==403){
				//since session expiry  popup is diplayed do not show any error for 403 status
				//AlertService.error($filter('translate')( "Service Unavailable"));
			}
			else{
				AlertService.error($filter('translate')( error.data));
			}
		}
		
		 statusUpdateEvent = $rootScope.$on('heStatusUpdate', function (event, data) {
	 			if(data!=null){
	 				if(data.message=="success"){
	 					//vm.heStatusUpdate = "SUCCESS";
	 					vm.heStatusUpdate = "";
	 					console.log("He connection successful " + data.message);
	 					AlertService.success($filter('translate')('gatewayApp.heStatusUpdate.success'));
	 					 loadAll();
	 				}else{
	 					//vm.heStatusUpdate = "FAILURE";
	 					vm.heStatusUpdate = "";
	 					console.log("He connection failed " + data.message);
	 					AlertService.error(data.message);
	 					//AlertService.error($filter('translate')('gatewayApp.heStatusUpdate.error'));
	 				}
	 			}
	 			
	 		});
	 	
		 $scope.$on('$destroy', function() {
	 		  if (statusUpdateEvent!=null )
	 			 statusUpdateEvent();
		        });
     
      
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('HeConnectivitySettingsDialogController', HeConnectivitySettingsDialogController);

    HeConnectivitySettingsDialogController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','Workflow','$uibModalInstance','HeConnectivity','entity','StaticLookUp'];

     function HeConnectivitySettingsDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService,Workflow, $uibModalInstance,HeConnectivity,entity,StaticLookUp) {
        var vm = this;
        vm.connectivitySettings=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        $scope.showApproveRejectButton=false;
        $scope.showDiscardButton = false;
    	$scope.showResubmitButton=false;
        vm.resubmitConnectivity = resubmitConnectivity;
        vm.globalValues = GlobalValues;
        vm.discardConnectivity = discardConnectivity;
        vm.rejectConnectivity= rejectConnectivity;
        vm.approveConnectivity= approveConnectivity;
       vm.viewMode=false;
      
                
        if(workflowSharedService.viewFrom == 'heConnectivitySettings'){
        	vm.connectivitySettings=entity;
        	$scope.showButton = true;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'heConnectivitySettings_todolist_resubmit') {
        	vm.connectivitySettings =  angular.fromJson($rootScope.payload);
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=true;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'heConnectivitySettings_todolist_checker') {
        	vm.connectivitySettings =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = true;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom == 'heConnectivitySetting_todolist_maker') {
        	vm.connectivitySettings =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = true;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom=='heConnectivitySettings_auditlog'){
        	vm.connectivitySettings =  angular.fromJson($rootScope.payload);   
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
        
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	
			
        	HeConnectivity.update({
					"orgId" : GlobalValues.getOrgId()
				}, vm.connectivitySettings, onSaveSuccess, onSaveError);
			
        	
         }
      
       
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	
        	vm.clicked = false;
        }
        function resubmitConnectivity() {
        	
        	HeConnectivity.resubmit({"taskId" : $rootScope.taskID}, vm.connectivitySettings, onResubmitSuccess, onResubmitError);
        	
       		
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {}

        function approveConnectivity() { 
        	HeConnectivity.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectConnectivity() { Workflow.rejectTask($rootScope.taskID); }

        function discardConnectivity() {
        	HeConnectivity.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }

     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('he-connectivity-settings', {
            parent: 'entity',
            params:{screen: 'HEConnectivitySettings'},
            url: '/he-connectivity-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.heConnectivitySettings.manageHeConnectivitySettings" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/he-connectivity-settings/he-connectivity-settings.html',
                    controller: 'HeConnectivitySettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('heConnectivitySettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('he-connectivity-edit', {
            parent: 'he-connectivity-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/he-connectivity-settings/he-connectivity-settings-dialog.html',
                    controller: 'HeConnectivitySettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['HeConnectivity', 'GlobalValues', function(HeConnectivity, GlobalValues) {
                                     return HeConnectivity.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('he-connectivity-settings-todolist', {
            parent: 'dashboard',
            url: '/heConnectivitySettings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/he-connectivity-settings/he-connectivity-settings-dialog.html',
                    controller: 'HeConnectivitySettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('he-connectivity-settings', null, { reload: 'he-connectivity-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('he-connectivity-settings-todolist-resubmit', {
            parent: 'dashboard',
            url: '/heConnectivitySettingsEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/he-connectivity-settings/he-connectivity-settings-dialog.html',
                    controller: 'HeConnectivitySettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('he-connectivity-settings', null, { reload: 'he-connectivity-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('he-connectiviy-settings-auditLog', {
            parent: 'audit-log',
            url: '/heConnectivitySettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/he-connectivity-settings/he-connectivity-settings-dialog.html',
                    controller: 'HeConnectivitySettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('he-connectivity-settings', null, { reload: 'he-connectivity-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('he-connectiviy-settings-historyReport', {
            parent: 'history-report',
            url: '/heConnectivitySettingsHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/he-connectivity-settings/he-connectivity-settings-dialog.html',
                    controller: 'HeConnectivitySettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('he-connectivity-settings', null, { reload: 'he-connectivity-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'heConnectivitySettings'
        })
        
        .controller('HeConnectivitySettingsController', HeConnectivitySettingsController);

    HeConnectivitySettingsController.$inject = ['$scope', '$state','$rootScope','HeConnectivity', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout','MessageBox','Auth'];

    function HeConnectivitySettingsController($scope, $state,$rootScope, HeConnectivity , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout,MessageBox,Auth) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.HE_CONNECTIVITY_SETTINGS;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "heConnectivitySettings";
        vm.entityOwnerType=vm.globalValues.getEntityOwnerType().shortName;
        $scope.refresh=refresh;
        
        vm.permitHeConnectivitySettingsEditAction = EntityPermissions.hasPermission('HEConnectivitySettings.EDIT');
      /* if(vm.permitHeConnectivitySettingsEditAction ==false){
			//message box 
			MessageBox.openMessageBox('Alert', 'Session expired. You will be redirected to login page...!', 'Ok', 'permitHeConnectivitySettingsEditAction');
		}

		$rootScope.$on('gatewayApp.messagebox.ok.permitHeConnectivitySettingsEditAction', function (event) {
			Auth.sessionlogout();
		});
		
		$rootScope.$on('gatewayApp.messagebox.clear.permitHeConnectivitySettingsEditAction', function (result){
			Auth.sessionlogout();
		})*/
        
        logScreenAccess();
        loadAll();

       function loadAll() {
    	   HeConnectivity.query({"orgId": GlobalValues.getOrgId()},function(result) {
                vm.connectivitySettings = result;
             });        	
        }      
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('HeConnectivity', HeConnectivity);

    HeConnectivity.$inject = ['$resource'];

    function HeConnectivity ($resource) {
        var resourceUrl =  'api/he-connectivity-settings/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/orgId/:orgId/he-connectivity-settings'
        	 },
         	
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
             'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/he-connectivity-settings/orgId/:orgId',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
        	
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/update-he-connectivity-settings/orgId/:orgId',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/he-connectivity-settings',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              },
              'changeStatus': {
                  method: 'POST',
                  params: {status:'@status'},
                  url: 'order/he-interactive-status-update'
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('GSTSettingsEditController', GSTSettingsEditController);

    GSTSettingsEditController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','GSTSettings','entity','DateUtils','Workflow'];

     function GSTSettingsEditController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,GSTSettings,entity,DateUtils,Workflow) {
        var vm = this;
        vm.gstSetting=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        $scope.showApproveRejectButton=false;
        $scope.showDiscardButton = false;
    	$scope.showResubmitButton=false;
        vm.resubmitGSTSettings = resubmitGSTSettings;
        vm.globalValues = GlobalValues;
        vm.discardGSTSettings = discardGSTSettings;
        vm.rejectGSTSettings= rejectGSTSettings;
        vm.approveGSTSettings= approveGSTSettings;
        vm.viewMode=false;
        vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.country = vm.globalValues.getCountry();
        
        $scope.showButton = false;
        vm.orgId = vm.globalValues.getOrgId();
        var systemSettings = vm.globalValues.getSystemSettings();
        
        $scope.$watch('vm.gstSetting.state', function(value){
           	if(value!=null && value!=undefined){
           		vm.stateCode = vm.gstSetting.state.tinNumber;
           	}
           });
      
           
        if(workflowSharedService.viewFrom == 'gstSettings'){
        	vm.gstSetting=entity;
        	$scope.showButton = true;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'gstSettingstodolist_resubmit') {
        	vm.gstSetting =  angular.fromJson($rootScope.payload);
        	
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=true;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'gstSettings_todolist_checker') {
        	vm.gstSetting =  angular.fromJson($rootScope.payload); 
        
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = true;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom == 'gstSettings_todolist_maker') {
        	vm.gstSetting =  angular.fromJson($rootScope.payload); 
        	
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = true;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom=='gstSettings_auditlog'){
        	vm.gstSetting =  angular.fromJson($rootScope.payload); 
        
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
        else if(workflowSharedService.viewFrom=='gst_settings_import_auditlog'){
        	
        	vm.gstSetting =  angular.fromJson($rootScope.payload);   
        	vm.gstSetting = vm.gstSetting.gstSettings;
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
		

        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	
        	vm.gstSetting.effectiveFrom = DateUtils.convertLocalDateToServer(systemSettings.businessDate);
        	
        	if(vm.gstSetting.cgst==null || vm.gstSetting.cgst==undefined || vm.gstSetting.cgst==""){
        		vm.gstSetting.cgst=0;
        	}
        	if(vm.gstSetting.sgst==null || vm.gstSetting.sgst==undefined || vm.gstSetting.sgst==""){
        		vm.gstSetting.sgst=0;
        	}
        	if(vm.gstSetting.igst == null || vm.gstSetting.igst==undefined || vm.gstSetting.igst==""){
        		vm.gstSetting.igst=0;
        	}
        	if(vm.gstSetting.utgst==null || vm.gstSetting.utgst==undefined || vm.gstSetting.utgst==""){
        		vm.gstSetting.utgst=0;
        	}
        	
        	if (vm.gstSetting.id != null) {
				GSTSettings.update({
					"orgId" : GlobalValues.getOrgId()
				}, vm.gstSetting, onSaveSuccess, onSaveError);
			} else {
				GSTSettings.save({
					"orgId" : GlobalValues.getOrgId()
				}, vm.gstSetting, onSaveSuccess, onSaveError);
			}
        	
         }
      
       
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	
        	vm.clicked = false;
        }
        function resubmitGSTSettings() {
        	
        	vm.gstSetting.effectiveFrom = DateUtils.convertLocalDateToServer(systemSettings.businessDate);
        	
        	if(vm.gstSetting.cgst==null || vm.gstSetting.cgst==undefined || vm.gstSetting.cgst==""){
        		vm.gstSetting.cgst=0;
        	}
        	if(vm.gstSetting.sgst==null || vm.gstSetting.sgst==undefined || vm.gstSetting.sgst==""){
        		vm.gstSetting.sgst=0;
        	}
        	if(vm.gstSetting.igst == null || vm.gstSetting.igst==undefined || vm.gstSetting.igst==""){
        		vm.gstSetting.igst=0;
        	}
        	if(vm.gstSetting.utgst==null || vm.gstSetting.utgst==undefined || vm.gstSetting.utgst==""){
        		vm.gstSetting.utgst=0;
        	}
        	
        	
        	GSTSettings.resubmit({"taskId" : $rootScope.taskID}, vm.gstSetting, onResubmitSuccess, onResubmitError);
        	
       		
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {
        	vm.clicked = false;
        }
        
        function approveGSTSettings() { 
        	GSTSettings.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectGSTSettings() { Workflow.rejectTask($rootScope.taskID); }

        function discardGSTSettings() {
        	GSTSettings.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }
        
        

       
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('gst-settings', {
            parent: 'entity',
            url: '/gst-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.gstSettings.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gst-settings/gst-settings.html',
                    controller: 'GSTSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gstSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
       
        .state('gst-settings-new', {
            parent: 'gst-settings',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gst-settings/gst-settings-dialog.html',
                    controller: 'GSTSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	                           	
                             
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('gst-settings-edit', {
            parent: 'gst-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gst-settings/gst-settings-dialog.html',
                    controller: 'GSTSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['GSTSettings', 'GlobalValues', function(GSTSettings, GlobalValues) {
                                     return GSTSettings.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('gst-settings-todolist', {
            parent: 'dashboard',
            url: '/gstSettings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gst-settings/gst-settings-dialog.html',
                    controller: 'GSTSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('gst-settings', null, { reload: 'gst-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('gst-settings-todolist-resubmit', {
            parent: 'dashboard',
            url: '/gstSettingsEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gst-settings/gst-settings-dialog.html',
                    controller: 'GSTSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('gst-settings', null, { reload: 'gst-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('gst-settings-auditLog', {
            parent: 'audit-log',
            url: '/GSTSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gst-settings/gst-settings-dialog.html',
                    controller: 'GSTSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('gst-settings', null, { reload: 'gst-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('gst-settings-historyReport', {
            parent: 'history-report',
            url: '/gstSettingsHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gst-settings/gst-settings-dialog.html',
                    controller: 'GSTSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('gst-settings', null, { reload: 'gst-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('GSTSettings', GSTSettings);

    GSTSettings.$inject = ['$resource'];

    function GSTSettings ($resource) {
        var resourceUrl =  'api/gst-settings/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/gst-settings'
        	 },
         	
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
             'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/gst-settings/orgId/:orgId',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
        	
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/gst-settings/orgId/:orgId',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/gst-settings',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'gstSettings'
        })
        
        .controller('GSTSettingsController', GSTSettingsController);

    GSTSettingsController.$inject = ['$scope', '$state', 'GSTSettings', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout'];

    function GSTSettingsController($scope, $state, GSTSettings , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout) {
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.GST_SETTINGS;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "gstSettings";
        $scope.refresh=refresh;
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        
        vm.launch=launch;
        function launch() {
        	$state.go("gst-settings-new");
        }
        
        
        vm.permitGSTSettingsAddEntityAction = EntityPermissions.hasPermission('GSTSettings.CREATE');
        vm.permitGSTSettingsImportEntityAction = EntityPermissions.hasPermission('GSTSettings.IMPORT');
        vm.permitGSTSettingsEditEntityAction = EntityPermissions.hasPermission('GSTSettings.EDIT');
        
        logScreenAccess();
        loadAll();

       function loadAll() {
    	   
    	   GSTSettings.query(function(result) {
               vm.gstSettings = result;                
           });
    	 
        }      
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('GlobalSecurityPolicyDialogController', GlobalSecurityPolicyDialogController);

    GlobalSecurityPolicyDialogController.$inject = ['Workflow', '$scope', '$state', '$stateParams', '$rootScope','workflowSharedService', 'GlobalValues', '$uibModalInstance', 'GlobalOrganisationTypeRole', 'GlobalSecurityPolicy','entity','ScreenLog','entityConstants'];

     function GlobalSecurityPolicyDialogController(Workflow, $scope, $state, $stateParams, $rootScope, workflowSharedService, GlobalValues, $uibModalInstance, GlobalOrganisationTypeRole, GlobalSecurityPolicy, entity,ScreenLog,entityConstants) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.GLOBAL_SECURITY_POLICY;
        vm.screenLog = ScreenLog;
        vm.save = save;
        vm.clear = clear;
        vm.clicked = false;
        vm.securityPolicyDTO ={};
       
        vm.approveSecurityPolicy = approveSecurityPolicy;
        vm.rejectSecurityPolicy = rejectSecurityPolicy;
        vm.discardSecurityPolicy = discardSecurityPolicy;
        vm.resubmitSecurityPolicy = resubmitSecurityPolicy;
        
      //  vm.roles = GlobalOrganisationTypeRole.rolesAllForOrganisationType({orgTypeId:GlobalValues.getOrganisation().organisationType.id,custUserTypeId:0});
        console.log(vm.roles);
        vm.selected = {orgRoleID: []};
        
        if(workflowSharedService.viewFrom == 'globalSecurityPolicy'){
	        showButtonsViewScreen();
	        vm.securityPolicyDTO = entity;
	        console.log($stateParams.custUserTypeId);
	        vm.roles = GlobalOrganisationTypeRole.queryAll({orgTypeId:$stateParams.orgTypeId,customerUserTypeId:$stateParams.custUserTypeId});
	        vm.selected = {orgRoleID: []};
	        vm.orgTypeId = $stateParams.orgTypeId;
	        vm.custUserTypeId = $stateParams.custUserTypeId;
	        vm.screenLog.screenLog(vm.screenName, vm.securityPolicyDTO.themeID, entityConstants.ENTITY_ACTION_TYPE.MAP);
	    	vm.selected.orgRoleID = vm.securityPolicyDTO.organisationRoleIDs;
        }
        else if(workflowSharedService.viewFrom == 'globalSecurityPolicytodolist_checker') {
        	vm.ViewDisable = true;
        	
        	vm.securityPolicyDTO =  angular.fromJson($rootScope.payload); 
        	 vm.roles = GlobalOrganisationTypeRole.queryAll({orgTypeId:vm.securityPolicyDTO.orgTypeId,customerUserTypeId:vm.securityPolicyDTO.custUserTypeId});
  	        vm.selected = {orgRoleID: []};
        	vm.selected.orgRoleID = vm.securityPolicyDTO.organisationRoleIDs;
        	vm.orgTypeId = vm.securityPolicyDTO.orgTypeId;
	        vm.custUserTypeId = vm.securityPolicyDTO.custUserTypeId;
        	showButtonsViewCheckerScreen();
        }
        else if(workflowSharedService.viewFrom == 'globalSecurityPolicytodolist_maker') {
        	vm.ViewDisable = true;
        	
        	vm.securityPolicyDTO =  angular.fromJson($rootScope.payload); 
        	vm.roles = GlobalOrganisationTypeRole.queryAll({orgTypeId:vm.securityPolicyDTO.orgTypeId,customerUserTypeId:vm.securityPolicyDTO.custUserTypeId});
  	        vm.selected = {orgRoleID: []};
        	vm.selected.orgRoleID = vm.securityPolicyDTO.organisationRoleIDs;
        	vm.orgTypeId = vm.securityPolicyDTO.orgTypeId;
	        vm.custUserTypeId = vm.securityPolicyDTO.custUserTypeId;
        	showButtonsViewMakerScreen();
        }
        
        else if(workflowSharedService.viewFrom == 'globalSecurityPolicy_resubmit') {
        	vm.securityPolicyDTO = angular.fromJson($rootScope.payload); 
        	vm.roles = GlobalOrganisationTypeRole.queryAll({orgTypeId:vm.securityPolicyDTO.orgTypeId,customerUserTypeId:vm.securityPolicyDTO.custUserTypeId});
 	        vm.selected = {orgRoleID: []};
	        vm.screenLog.screenLog(vm.screenName, vm.securityPolicyDTO.themeID, entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
        	vm.selected.orgRoleID = vm.securityPolicyDTO.organisationRoleIDs;
        	vm.orgTypeId = vm.securityPolicyDTO.orgTypeId;
	        vm.custUserTypeId = vm.securityPolicyDTO.custUserTypeId;
        	showButtonsResubmitScreen();
        }
        else if(workflowSharedService.viewFrom == 'globalSecurityPolicy_auditLog') {
        	
        	vm.ViewDisable = true;        	
        	vm.securityPolicyDTO =  angular.fromJson($rootScope.payload); 
        	 vm.roles = GlobalOrganisationTypeRole.queryAll({orgTypeId:vm.securityPolicyDTO.orgTypeId,customerUserTypeId:vm.securityPolicyDTO.custUserTypeId});
   	        vm.selected = {orgRoleID: []};
         	vm.selected.orgRoleID = vm.securityPolicyDTO.organisationRoleIDs;
         	vm.orgTypeId = vm.securityPolicyDTO.orgTypeId;
 	        vm.custUserTypeId = vm.securityPolicyDTO.custUserTypeId;
        	vm.btnClose=true;
        	vm.btnApproveReject=false;
        	
        }
        function showButtonsViewScreen(){
        	vm.ViewDisable = false;
            vm.btnClose = false;
            vm.btnApproveReject = false;
            $scope.showDiscardButton = false;
            $scope.showSaveButton = true;
            $scope.showCancelButton = true;
            $scope.showResubmitButton = false;
        }
        function showButtonsViewCheckerScreen(){
        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
        	vm.btnClose = true;
        	$scope.showDiscardButton = false;
        	vm.btnApproveReject = true;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
        function showButtonsResubmitScreen(){
        	vm.btnClose = false;
        	$scope.showButton=true;
        	vm.btnApproveReject = false;
        	$scope.showDiscardButton = false;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = true;
            $scope.showResubmitButton = true;
        }
        function showButtonsViewMakerScreen(){
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        	vm.btnClose = true;
        	vm.btnApproveReject = false;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
		function clear () {
            $uibModalInstance.dismiss('cancel');
        }
		
		function save () {	
			
			vm.securityPolicyDTO.orgRoleIDs = vm.selected.orgRoleID;
			vm.securityPolicyDTO.orgTypeId = vm.orgTypeId;
			if(vm.custUserTypeId!=null && vm.custUserTypeId!=undefined){
				vm.securityPolicyDTO.custUserTypeId = vm.custUserTypeId;
			}else{
				vm.securityPolicyDTO.custUserTypeId=0;
			}
			
			
			
        	GlobalSecurityPolicy.save({"orgId":GlobalValues.getOrgId()},vm.securityPolicyDTO, onSaveSuccess, onSaveError);	
        }
     
        function onSaveSuccess (result) {
        	$scope.$emit('globalSecurityPolicyRefresh');        	
            $uibModalInstance.close(result);  
        }

        function onSaveError () {
        	vm.clicked = false;
        }
        function approveSecurityPolicy() { 
        	GlobalSecurityPolicy.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	vm.clicked = false;
        }
       
        function rejectSecurityPolicy() { Workflow.rejectTask($rootScope.taskID); }

        function onRejectSuccess(result) {
        
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onRejectError(error) {}
        
        function discardSecurityPolicy() {
        	GlobalSecurityPolicy.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {

        }
        function resubmitSecurityPolicy() {
        	vm.securityPolicyDTO.organisationRoleIDs = vm.selected.orgRoleID;
        	vm.securityPolicyDTO.orgTypeId = vm.orgTypeId;
			if(vm.custUserTypeId!=null && vm.custUserTypeId!=undefined){
				vm.securityPolicyDTO.custUserTypeId = vm.custUserTypeId;
			}else{
				vm.securityPolicyDTO.custUserTypeId=0;
			}
         	GlobalSecurityPolicy.resubmit({"taskId" : $rootScope.taskID}, vm.securityPolicyDTO, onResubmitSuccess, onResubmitError);
          	$uibModalInstance.dismiss('cancel');
          }
          
        function onResubmitSuccess(result) {
         
          $rootScope.removeRow($rootScope.taskID);
         }        
         function onResubmitError(error) {
        	 vm.clicked = false;
         }
         
         
     } 
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('global-security-policy', {
            parent: 'entity',
            url: '/global-security-policy',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.security.manageglobalsecuritypolicy" | translate }}',
                parent: 'home'
              },
            views: {
                'content@': {
                    templateUrl: 'app/entities/global-security-policy/global-security-policy.html',
                    controller: 'GlobalSecurityPolicyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('globalSecurityPolicy');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('global-security-policy.new', {
            parent: 'global-security-policy',
            url: '/global-security-policy/{id}/{orgTypeId}/{custUserTypeId}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$rootScope', '$uibModal', function($stateParams, $state, $rootScope, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-security-policy/global-security-policy-dialog.html',
                    controller: 'GlobalSecurityPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: ['GlobalSecurityPolicy', 'GlobalValues', function(GlobalSecurityPolicy, GlobalValues) {
                            return GlobalSecurityPolicy.get({orgId:GlobalValues.getOrgId(), themeID : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                	$rootScope.$emit('gatewayApp:globalSecurityPolicyRefresh');
                    $state.go('global-security-policy');
                }, function() {
                    $state.go('global-security-policy');
                });
            }]
        })
         .state('global-security-policy-todolist', {
            parent: 'dashboard',
            url: '/global-security-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-security-policy/global-security-policy-dialog.html',
                    controller: 'GlobalSecurityPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('global-security-policy', null, { reload: 'global-security-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
        .state('global-security-policy-todolist.resubmit', {
            parent: 'dashboard',
            url: '/global-security-policy-resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-security-policy/global-security-policy-dialog.html',
                    controller: 'GlobalSecurityPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                        	

                        }
                    }
                }).result.then(function() {
                    $state.go('global-security-policy', null, { reload: 'global-security-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
        })
        .state('global-security-policy-auditLog', {
            parent: 'audit-log',
            url: '/global-security-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-security-policy/global-security-policy-dialog.html',
                    controller: 'GlobalSecurityPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('global-security-policy', null, { reload: 'global-security-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
        .state('global-security-policy-historyReport', {
            parent: 'history-report',
            url: '/global-security-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-security-policy/global-security-policy-dialog.html',
                    controller: 'GlobalSecurityPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('global-security-policy', null, { reload: 'global-security-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
   };
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('GlobalSecurityPolicy', GlobalSecurityPolicy);

    GlobalSecurityPolicy.$inject = ['$resource'];

    function GlobalSecurityPolicy ($resource) {
        var resourceUrl =  'api/orgId/:orgId/global-security-policy/:themeID';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/orgId/:orgId/global-security-policy'
        	 },
        	 'getEntityPermissions':{
        		 params: {orgId:'@orgId'},
        		 isArray: true,
         	     url: 'api/orgId/:orgId/global-security-policy/entity-permissions'
        	 },
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
        	 'getGlobalSecurityPolicies': {
                 method: 'GET',
                 isArray: true,
                 url: 'api/global-security-policy/orgTypeId/:orgTypeId/customerUserTypeId/:customerUserTypeId',
                 params: {orgTypeId:'@orgTypeId',customerUserTypeId:'@customerUserTypeId'},
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
        	 'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/orgId/:orgId/global-security-policy',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 return angular.toJson(copy);
                 }                
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/global-security-policy',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'globalSecurityPolicy'
        })
        .controller('GlobalSecurityPolicyController', GlobalSecurityPolicyController);

    GlobalSecurityPolicyController.$inject = ['$scope', '$rootScope', '$state', 'workflowSharedService', 'GlobalSecurityPolicy', 'GlobalValues', 'EntityPermissions','ScreenLog','entityConstants'];

    function GlobalSecurityPolicyController ($scope, $rootScope, $state, workflowSharedService, GlobalSecurityPolicy, GlobalValues, EntityPermissions, ScreenLog,entityConstants) {
        var vm = this;
        vm.screenLog=ScreenLog;
        vm.securityPolicies = [];        
       
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.GLOBAL_SECURITY_POLICY;
        
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.clicked=false;
        //vm.permitSecurityPolicyMapEntityAction = EntityPermissions.hasPermission('GlobalSecurityPolicy.MAP');
        vm.permitSecurityPolicyMapEntityAction = true;
                
        workflowSharedService.viewFrom = 'globalSecurityPolicy';
        
        $rootScope.$on('gatewayApp:globalSecurityPolicyRefresh', function(event, result) {
        	//loadAll();
        });
        logScreenAccess();
        //loadAll();
        
        vm.loadAll = function loadAll(organisationType, customerUserType) {
        	vm.custUserTypeID = 0;
        	$rootScope.organisationType = organisationType;
        	
        	$rootScope.customerUserType = customerUserType;
        	if(customerUserType != undefined){vm.custUserTypeID = customerUserType.id};
        	GlobalSecurityPolicy.getGlobalSecurityPolicies({"orgTypeId":organisationType.id, "customerUserTypeId": vm.custUserTypeID},function(result) {
        		vm.securityPolicies = result;
                vm.clicked=false;
        		console.log(result);
        		
        	});
        }
        
        $rootScope.$on('globalSecurityPolicyRefresh', function(event, result) {
        	vm.organisationtype = $rootScope.organisationType;
        	vm.customerusertype = $rootScope.customerUserType;
        	if($rootScope.organisationType != null)
        		vm.loadAll(vm.organisationtype, vm.customerusertype); 
        });
        function logScreenAccess(){
            
       	 ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('GlobalOrganisationTypeRole', GlobalOrganisationTypeRole);

    GlobalOrganisationTypeRole.$inject = ['$resource'];

    function GlobalOrganisationTypeRole ($resource) {
        var resourceUrl =  'api/orgId/:orgId/global-organisation-type-role/:id';

        return $resource(resourceUrl, {}, {
        	'queryAll': { method: 'GET', isArray: true,
        		params: {orgTypeId:'@orgTypeId',customerUserTypeId:'@customerUserTypeId' },
        	    url: 'api/global-organisation-type-role/orgTypeId/:orgTypeId/customerUserTypeId/:customerUserTypeId'
        	 },
        	 'rolesAllForOrganisationType': { method: 'GET', isArray: true,
          		params: {orgTypeId:'@orgTypeId',custUserTypeID: '@custUserTypeId'},
          	    url: 'api/orgTypeId/:orgTypeId/custUserTypeId/:custUserTypeId/rolesAllForOrganisationType'
          	 }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('GlobalEntityActionApprovalPolicy', GlobalEntityActionApprovalPolicy);

    GlobalEntityActionApprovalPolicy.$inject = ['$resource'];

    function GlobalEntityActionApprovalPolicy ($resource) {
        var resourceUrl =  'api/orgId/:orgId/global-entity-action-approval-policy/:id';
        
        return $resource(resourceUrl, {}, {
        	'getEntityActions': {
        		method: 'GET', 
        		isArray: true,
        		url: 'api/orgId/:orgId/global-entity-actions/:id'
        	 },
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
        	 'map': {
                 method: 'PUT',
                 params: {orgId:'@orgId'},
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/global-entity-action-approval-policy',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('GlobalEntityActionApprovalPolicyDialogController', GlobalEntityActionApprovalPolicyDialogController);

    GlobalEntityActionApprovalPolicyDialogController.$inject = ['Workflow', '$scope', '$state', 'entity', '$rootScope', '$uibModalInstance', 'workflowSharedService', 'GlobalEntityActionApprovalPolicy', 'GlobalValues', 'CSPLPagination', 'ScreenLog','entityConstants'];

    function GlobalEntityActionApprovalPolicyDialogController(Workflow, $scope, $state, entity,  $rootScope,  $uibModalInstance, workflowSharedService, GlobalEntityActionApprovalPolicy, GlobalValues, CSPLPagination, ScreenLog,entityConstants) {
        var vm = this;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.MANAGE_GLOBAL_ENTITY_STATE_APPROVAL_PROCESS;
        vm.screenLog = ScreenLog;
        vm.save = save;
        vm.entityActionApprovalPolicyDTO = {};
        vm.selected = {entityActions: []};

        vm.clear = clear;
        vm.approveEntityActionApprovalPolicy = approveEntityActionApprovalPolicy;
        vm.rejectEntityActionApprovalPolicy = rejectEntityActionApprovalPolicy;
        vm.discardEntityActionApprovalPolicy = discardEntityActionApprovalPolicy;
        vm.resubmitEntityActionApprovalPolicy = resubmitEntityActionApprovalPolicy;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        $scope.clicked=false;
        vm.selectAll=false;
    	vm.checkOrUncheckHeaderAction = checkOrUncheckHeaderAction;
    	vm.checkOrUncheckAction = checkOrUncheckAction;
        
        if(workflowSharedService.viewFrom == 'globalApprovalPolicy'){
	        vm.entityActionApprovalPolicyDTO = entity;
	        console.log(vm.entityActionApprovalPolicyDTO);
			//ScreenLog.screenLog({'entityName': 'EntityStateApprovalProcess', 'entityRecordId': vm.entityActionApprovalPolicyDTO.id, 'action': 'MAP'});
	        vm.ShowApprovalPolicyLink = false;
	        showButtonsManipulateScreen();
        }
        else if(workflowSharedService.viewFrom == 'globalEntityActionApprovalPolicytodolist_checker') {
        	vm.ShowApprovalPolicyLink = true;
        	vm.entityActionApprovalPolicyDTO =  angular.fromJson($rootScope.payload); 
        	showButtonsViewCheckerScreen();
        }
        else if(workflowSharedService.viewFrom == 'globalEntityActionApprovalPolicytodolist_maker') {
        	vm.ShowApprovalPolicyLink = false;
        	vm.entityActionApprovalPolicyDTO =  angular.fromJson($rootScope.payload); 
        	showButtonsViewMakerScreen();
        }
        
        else if(workflowSharedService.viewFrom == 'globalEntityActionApprovalPolicy_resubmit') {
        	vm.ShowApprovalPolicyLink = false;
        	vm.entityActionApprovalPolicyDTO = angular.fromJson($rootScope.payload); 
			vm.screenLog.screenLog(vm.screenName, vm.entityActionApprovalPolicyDTO.id, entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
        	showButtonsResubmitScreen();
        }

        GlobalEntityActionApprovalPolicy.getEntityActions({orgId:GlobalValues.getOrgId(), id:vm.entityActionApprovalPolicyDTO.approvalPolicyId},function(result) {            
        					vm.entityActionApprovalPolicies = result;
        					console.log(vm.entityActionApprovalPolicies);
						    		
						     vm.selected.entityActions =angular.copy(vm.entityActionApprovalPolicyDTO.entityActions);
						     console.log( "approval policy length" + vm.entityActionApprovalPolicies.length);
						     console.log( "exiisting" + vm.selected.entityActions.length);
						     if( vm.entityActionApprovalPolicies.length == vm.selected.entityActions.length){
						    	 vm.selectAll = true;
						    	 document.getElementById("selectAll").checked = true;
						     }
						    });
        
        function showButtonsManipulateScreen(){
        	vm.ViewDisable = false;
            vm.btnClose = false;
            vm.btnApproveReject = false;
            $scope.showDiscardButton = false;
            $scope.showSaveButton = true;
            $scope.showCancelButton = true;
            $scope.showResubmitButton = false;
        }
        function showButtonsViewCheckerScreen(){
        	$scope.showButton=true;
        	vm.ViewDisable = true;
        	$scope.showDiscardButton = false;
        	vm.btnClose = true;
        	$scope.showDiscardButton = false;
        	vm.btnApproveReject = true;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
        function showButtonsResubmitScreen(){
        	vm.ViewDisable = false;
        	vm.btnClose = false;
        	$scope.showButton=true;
        	vm.btnApproveReject = false;
        	$scope.showDiscardButton = false;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = true;
            $scope.showResubmitButton = true;
        }
        function showButtonsViewMakerScreen(){
        	vm.ViewDisable = true;
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        	vm.btnClose = true;
        	vm.btnApproveReject = false;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
		function clear () {
            $uibModalInstance.dismiss('cancel');
        }
		
		function save () {
			vm.entityActionApprovalPolicyDTO.entityActions = vm.selected.entityActions;
			GlobalEntityActionApprovalPolicy.map({"orgId":GlobalValues.getOrgId()}, vm.entityActionApprovalPolicyDTO, onSaveSuccess, onSaveError);
        }
     
        function onSaveSuccess (result) {
            $uibModalInstance.close(result);  
        }

        function onSaveError () {
        	$scope.clicked=false;
        }
        function approveEntityActionApprovalPolicy() { 
        	GlobalEntityActionApprovalPolicy.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	$scope.clicked=false;
        }
       
        function rejectEntityActionApprovalPolicy() { Workflow.rejectTask($rootScope.taskID);}

        function discardEntityActionApprovalPolicy() {
        	GlobalEntityActionApprovalPolicy.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {

        }
        function resubmitEntityActionApprovalPolicy() {
        	vm.entityActionApprovalPolicyDTO.entityActions = vm.selected.entityActions;
        	GlobalEntityActionApprovalPolicy.resubmit({"taskId" : $rootScope.taskID}, vm.entityActionApprovalPolicyDTO, onResubmitSuccess, onResubmitError);
          	$uibModalInstance.dismiss('cancel');
          }
          
          function onResubmitSuccess(result) {
          	$rootScope.removeRow($rootScope.taskID);
          }        
          function onResubmitError(error) { 
        	  $scope.clicked=false;
          }
          function checkOrUncheckHeaderAction(event){
          	
        	  changeHeaderActionSelection(event.target.checked);
                 
          }
         function changeHeaderActionSelection(value){
      	 	if(value){
          		angular.forEach(vm.entityActionApprovalPolicies, function(item, index){
          		
          			//item.entityActions = true;
          			vm.selected.entityActions.push(item.entityActions);
          			
          		});
      		}else{
      			angular.forEach(vm.entityActionApprovalPolicies, function(item, index){
      				//item.entityActions = false;
      				vm.selected.entityActions = [];
      			});
      		}
          
          }
          function checkOrUncheckAction(){
          	          	
          	if(vm.selected.entityActions.length == vm.entityActionApprovalPolicies.length ){
          		vm.selectAll= true;
          		document.getElementById("selectAll").checked = true;
          	}else{
          		vm.selectAll= false;
          		document.getElementById("selectAll").checked = false;
          	}
          }
          
          /*function setupPagination(result){
      		vm.CSPLPagination = CSPLPagination;
      	    vm.CSPLPagination.initialisePagination('globalEntityActionApprovalPolicy', vm.entityActionApprovalPolicies);
      		vm.totalRecordLength = vm.CSPLPagination.getTotalRecordCount('globalEntityActionApprovalPolicy');
      		vm.itemsPerPage = vm.CSPLPagination.getItemsPerPage('globalEntityActionApprovalPolicy');
      		vm.pageCount = 1;
              $scope.$watch('vm.pageCount', function(){
              	vm.CSPLPagination.setPage('globalEntityActionApprovalPolicy', vm.pageCount);
              	vm.pagedValues = vm.CSPLPagination.getPagedValues('globalEntityActionApprovalPolicy');
              });
     }*/
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('GlobalApprovalPolicyDialogController', GlobalApprovalPolicyDialogController);

    GlobalApprovalPolicyDialogController.$inject = ['Workflow', '$scope', '$state', 'entity', 'mode', '$rootScope', '$uibModalInstance', 'workflowSharedService', 'GlobalApprovalPolicy', 'GlobalValues', 'OrganisationManipulation', 'ScreenLog','entityConstants','AlertService'];

    function GlobalApprovalPolicyDialogController(Workflow, $scope, $state, entity, mode, $rootScope,  $uibModalInstance, workflowSharedService, GlobalApprovalPolicy, GlobalValues, OrganisationManipulation, ScreenLog,entityConstants,AlertService) {
        var vm = this;
        vm.save = save;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.GLOBAL_APPROVAL_PROCESS;
        vm.screenLog = ScreenLog;
        vm.approvalPolicyDTO = {};
        vm.ownerOrganisation = {};
        vm.approvalPolicyRolesList = [];
        vm.approvalPolicyRoleIds = [];
        vm.selectedPolicyOrganisationType = null;
        vm.selectedPolicyOrganisationRole = null;
        vm.error = null;
        vm.clicked=false;
                       
        vm.clear = clear;
        vm.approveApprovalPolicy = approveApprovalPolicy;
        vm.rejectApprovalPolicy = rejectApprovalPolicy;
        vm.discardApprovalPolicy = discardApprovalPolicy;
        vm.resubmitApprovalPolicy = resubmitApprovalPolicy;
        vm.addProcessRole = addProcessRole;
        vm.removePolicy = removePolicy;
        vm.validateNoOfApprovals=validateNoOfApprovals;
        
        if(workflowSharedService.viewFrom == 'globalApprovalPolicy'){
	        vm.approvalPolicyDTO = entity;
	        console.log(vm.approvalPolicyDTO);
	        vm.organisationtype = vm.approvalPolicyDTO.organisationType;
	   		vm.customerUserType = vm.approvalPolicyDTO.customerUserType;
	        if (mode == "View"){
	        	//ScreenLog.screenLog({'entityName': 'ApprovalProcess', 'entityRecordId': vm.approvalPolicyDTO.id, 'action': 'VIEW'});
	        	showButtonsViewScreen();
	        	vm.ViewDisable = true;
	        }
	        else if (mode == "Edit"){
                //ScreenLog.screenLog({'entityName': 'ApprovalProcess', 'entityRecordId': vm.approvalPolicyDTO.id, 'action': 'EDIT'});
	        	showButtonsManipulateScreen();
	        	vm.EditDisable = true;
	        }
	        else{
				//ScreenLog.screenLog({'entityName': 'ApprovalProcess', 'entityRecordId': 0, 'action': 'ADD'});
		        showButtonsManipulateScreen();
	        }
	        
        }
        else if (workflowSharedService.viewFrom == "globalEntityActionApprovalPolicytodolist_checker"){
        	 vm.ViewDisable = true;
	   		 vm.approvalPolicyDTO = entity;
	   		vm.organisationtype = vm.approvalPolicyDTO.organisationType;
	   		vm.customerUserType = vm.approvalPolicyDTO.customerUserType;
			 showButtonsViewScreen();
        }
        else if(workflowSharedService.viewFrom == 'globalApprovalPolicytodolist_checker') {
        	vm.ViewDisable = true;

    		vm.approvalPolicyDTO =  angular.fromJson($rootScope.payload); 
    		vm.organisationtype = vm.approvalPolicyDTO.organisationType;
	   		vm.customerUserType = vm.approvalPolicyDTO.customerUserType;
    		showButtonsViewCheckerScreen();
        }
        else if(workflowSharedService.viewFrom == 'globalApprovalPolicytodolist_maker') {
        	vm.ViewDisable = true;
        	vm.approvalPolicyDTO =  angular.fromJson($rootScope.payload); 
        	vm.organisationtype = vm.approvalPolicyDTO.organisationType;
	   		vm.customerUserType = vm.approvalPolicyDTO.customerUserType;
        	showButtonsViewMakerScreen();
        }
        
        else if(workflowSharedService.viewFrom == 'globalApprovalPolicy_resubmit') {
        	vm.EditDisable = true;
        	vm.approvalPolicyDTO = angular.fromJson($rootScope.payload); 
        	vm.organisationtype = vm.approvalPolicyDTO.organisationType;
	   		vm.customerUserType = vm.approvalPolicyDTO.customerUserType;
            var entityRecordId = 0;
            if(vm.approvalPolicyDTO.id!=null){
  	      		entityRecordId = vm.approvalPolicyDTO.id;
  	      	}          
            vm.screenLog.screenLog(vm.screenName, entityRecordId, vm.entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
        	showButtonsResubmitScreen();
        }

        vm.ownerOrganisation = OrganisationManipulation.checkAndGetOrganisation(vm.approvalPolicyDTO.organisationType);
        
        if (vm.approvalPolicyDTO.globalApprovalPolicyRoles != null){
//            vm.approvalPolicyRolesList = OrganisationManipulation.checkAndGetGivenObjectListWithOrganisation(vm.approvalPolicyDTO.approvalPolicyRoles);
            vm.approvalPolicyRolesList = vm.approvalPolicyDTO.globalApprovalPolicyRoles;
        	fetchExistingRoleIDs();
        }
        
        function fetchExistingRoleIDs(){
        	vm.approvalPolicyDTO.globalApprovalPolicyRoles.forEach(function(item) {
        		  vm.approvalPolicyRoleIds.push(item.globalOrganisationTypeRole.id);
        	});
        }
        
        function addProcessRole(){
        	var approvalPolicyRoleDTO = {}
        	
        	if (vm.selectedPolicyOrganisationRole!=null && validateDuplicationOfRole() && vm.validateNoOfApprovals()){
	        	vm.approvalPolicyRoleIds.push(vm.selectedPolicyOrganisationRole.id);
	        	approvalPolicyRoleDTO.organisationType =  vm.selectedPolicyOrganisationType;
	        	approvalPolicyRoleDTO.globalOrganisationTypeRole = vm.selectedPolicyOrganisationRole;
	        	approvalPolicyRoleDTO.noOfApprovals=vm.noOfApprovals;
	        	vm.approvalPolicyRolesList.push(approvalPolicyRoleDTO);
	            vm.selectedPolicyOrganisationType = null;
	            vm.selectedPolicyOrganisationRole = null;
	            vm.noOfApprovals="";
        	}
        }
        
        function validateDuplicationOfRole(){
        	vm.error = "";
        	
        	if (vm.approvalPolicyRoleIds.indexOf(vm.selectedPolicyOrganisationRole.id) > -1){
        		AlertService.error( "Role already exists in the process.");
        		return false;
        	}
        	return true;
        }
        
        function validateExistanceOfLevels(){
        	vm.error = "";
        	
        	if (vm.approvalPolicyRoleIds.length == 0){
        		AlertService.error( "Workflow levels should not be empty.");
      
        		return false;
        	}
        	return true;
        }
        
        function removePolicy(rowId){
        	vm.approvalPolicyRoleIds.splice(rowId,1);
        	vm.approvalPolicyRolesList.splice(rowId,1);
        	$scope.approvalPolicyForm.$setDirty();
        }
        
        function showButtonsViewScreen(){
            vm.btnClose = true;
            vm.btnApproveReject = false;
            $scope.showDiscardButton = false;
            $scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
        
        function showButtonsManipulateScreen(){
        	vm.ViewDisable = false;
            vm.btnClose = false;
            vm.btnApproveReject = false;
            $scope.showDiscardButton = false;
            $scope.showSaveButton = true;
            $scope.showCancelButton = true;
            $scope.showResubmitButton = false;
        }
        function showButtonsViewCheckerScreen(){
        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
        	vm.btnClose = true;
        	$scope.showDiscardButton = false;
        	vm.btnApproveReject = true;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
        function showButtonsResubmitScreen(){
        	vm.btnClose = false;
        	$scope.showButton=true;
        	vm.btnApproveReject = false;
        	$scope.showDiscardButton = false;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = true;
            $scope.showResubmitButton = true;
        }
        function showButtonsViewMakerScreen(){
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        	vm.btnClose = true;
        	vm.btnApproveReject = false;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
		function clear () {
            $uibModalInstance.dismiss('cancel');
        }
		
		function save () {	
			if (validateExistanceOfLevels()){
				vm.approvalPolicyDTO.globalApprovalPolicyRoles = vm.approvalPolicyRolesList;
				vm.approvalPolicyDTO.organisationType = vm.organisationtype;
				vm.approvalPolicyDTO.customerUserType = vm.customerUserType;
				var customerUserTypeId = 0;
				if(vm.customerUserType!=null && vm.customerUserType!=undefined){
					customerUserTypeId = vm.customerUserType.id;
				}
				if (mode == "Edit"){
					GlobalApprovalPolicy.update({"orgTypeId":vm.organisationtype.id,"custUserTypeId":customerUserTypeId}, vm.approvalPolicyDTO, onSaveSuccess, onSaveError);
				}
				else {
					GlobalApprovalPolicy.save({"orgTypeId":vm.organisationtype.id,"custUserTypeId":customerUserTypeId},vm.approvalPolicyDTO, onSaveSuccess, onSaveError);
				}
			}
        }
     
        function onSaveSuccess (result) {
            $uibModalInstance.close(result);  
        }

        function onSaveError () {
        	vm.clicked=false;
        }
        function approveApprovalPolicy() { 
        	GlobalApprovalPolicy.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	vm.clicked=false;
        }
       
        function rejectApprovalPolicy() { Workflow.rejectTask($rootScope.taskID);}

        function discardApprovalPolicy() {
        	GlobalApprovalPolicy.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {

        }
        function resubmitApprovalPolicy() {
			if (validateExistanceOfLevels()){
				
				GlobalApprovalPolicy.resubmit({"taskId" : $rootScope.taskID}, getActualApprovalPolicyDTO(), onResubmitSuccess, onResubmitError);
	          	$uibModalInstance.dismiss('cancel');
			}
          }
          
          function onResubmitSuccess(result) {
          	$rootScope.removeRow($rootScope.taskID);
          }        
          function onResubmitError(error) { 
        	  vm.clicked=false;
          }
          
          function getActualApprovalPolicyDTO(){
        	  
			vm.approvalPolicyDTO.organisationType = vm.organisationtype;
			vm.approvalPolicyDTO.customerUserType = vm.customerUserType;
			vm.approvalPolicyDTO.globalApprovalPolicyRoles = vm.approvalPolicyRolesList;	
			/* Since no OrganisationDTO in the actual DTO class for GlobalApprovalPolicy.java ignoring hte two lines*/
        	//vm.approvalPolicyDTO.organisationType = OrganisationManipulation.checkAndGetOrganisationDTO(vm.ownerOrganisation);
        	//vm.approvalPolicyDTO.globalApprovalPolicyRoles = OrganisationManipulation.checkAndGetGivenObjectListWithOrganisationDTO(vm.approvalPolicyRolesList);
        	  
        	  return vm.approvalPolicyDTO;
          }
          function validateNoOfApprovals(){
          	vm.error = "";
          	
          	if (vm.noOfApprovals =="" || vm.noOfApprovals ==null|| vm.noOfApprovals >5 || vm.noOfApprovals < 1){
          		AlertService.error(  "No of Approvals should be 1 to 5.");
          		//vm.error = "No of Approvals should be 1 to 5."
          		return false;
          	}
          	return true;
          }
        
    }
    
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('GlobalApprovalPolicyDeleteController',GlobalApprovalPolicyDeleteController);

    GlobalApprovalPolicyDeleteController.$inject = ['$uibModalInstance', 'entity', 'GlobalApprovalPolicy', 'GlobalValues', 'ScreenLog','$scope'];

    function GlobalApprovalPolicyDeleteController($uibModalInstance, entity, GlobalApprovalPolicy, GlobalValues, ScreenLog,$scope) {
        var vm = this;

        vm.approvalPolicyDTO = entity;
    	//ScreenLog.screenLog({'entityName': 'ApprovalProcess', 'entityRecordId': vm.approvalPolicyDTO.id, 'action': 'DELETE'});
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        $scope.clicked=false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	GlobalApprovalPolicy.delete({"orgId":GlobalValues.getOrgId(),id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('global-approval-policy', {
            parent: 'entity',
            url: '/global-approval-policy',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.security.manageglobalapprovalpolicy" | translate }}',
                parent: 'home'
              },
            views: {
                'content@': {
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy.html',
                    controller: 'GlobalApprovalPolicyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('globalApprovalPolicy');
                    $translatePartialLoader.addPart('globalEntityActionApprovalPolicy');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('global-approval-policy.new', {
            parent: 'global-approval-policy',
            url: '/global-approval-policy/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy-dialog.html',
                    controller: 'GlobalApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: ['GlobalApprovalPolicy', 'GlobalValues', function(GlobalApprovalPolicy, GlobalValues) {
                            return { id:null };
                        }],
                        mode: function(){
                       	 return "New";
                        }
                    }
                }).result.then(function() {
                    $state.go('global-approval-policy', {}, { reload: 'global-approval-policy' });
                }, function() {
                    $state.go('global-approval-policy');
                });
            }]
        })
        .state('global-approval-policy.edit', {
            parent: 'global-approval-policy',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy-dialog.html',
                    controller: 'GlobalApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                            	 entity: ['GlobalApprovalPolicy', 'GlobalValues', function(GlobalApprovalPolicy, GlobalValues) {
                                     return GlobalApprovalPolicy.get({orgId:GlobalValues.getOrgId(), id:$stateParams.id}).$promise;
                                 }],
                                 mode: function(){
                                	 return "Edit";
                                 }
                    }
                }).result.then(function() {
                    $state.go('global-approval-policy', {}, { reload: true });
                }, function() {
                    $state.go('global-approval-policy');
                });
            }]
            
        })
        .state('global-approval-policy.view', {
            parent: 'global-approval-policy',
            url: '/{id}/view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy-dialog.html',
                    controller: 'GlobalApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                            	 entity: ['GlobalApprovalPolicy', 'GlobalValues', function(GlobalApprovalPolicy, GlobalValues) {
                                     return GlobalApprovalPolicy.get({orgId:GlobalValues.getOrgId(), id:$stateParams.id}).$promise;
                                 }],
                                 mode: function(){
                                	 return "View";
                                 }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('global-approval-policy.delete', {
            parent: 'global-approval-policy',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy-delete-dialog.html',
                    controller: 'GlobalApprovalPolicyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GlobalApprovalPolicy', 'GlobalValues', function(GlobalApprovalPolicy, GlobalValues) {
                            return GlobalApprovalPolicy.get({orgId:GlobalValues.getOrgId(), id:$stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('global-approval-policy-todolist', {
            parent: 'dashboard',
            url: '/global-approval-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy-dialog.html',
                    controller: 'GlobalApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        },
                        mode: function(){
                       	 return "";
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('globalApprovalPolicy');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                	$state.go('global-approval-policy', null, { reload: 'global-approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
        .state('global-approval-policy-todolist.resubmit', {
            parent: 'dashboard',
            url: '/global-approval-policy-resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy-dialog.html',
                    controller: 'GlobalApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                        	

                        },
                        mode: function(){
                          	 return "";
                           },
                       translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                           $translatePartialLoader.addPart('error');
                           $translatePartialLoader.addPart('global');
                           $translatePartialLoader.addPart('globalApprovalPolicy');
                           return $translate.refresh();
                       }]
                    }
                }).result.then(function() {
                    $state.go('global-approval-policy', null, { reload: 'global-approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
        })
        .state('global-approval-policy.map', {
            parent: 'global-approval-policy',
            url: '/global-entity-action-approval-policy/{id}/map',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-entity-action-approval-policy.html',
                    controller: 'GlobalEntityActionApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: ['GlobalEntityActionApprovalPolicy', 'GlobalValues', function(GlobalEntityActionApprovalPolicy, GlobalValues) {
                    		return GlobalEntityActionApprovalPolicy.get({orgId:GlobalValues.getOrgId(), id:$stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('global-approval-policy', {}, { reload: 'global-approval-policy' });
                }, function() {
                    $state.go('global-approval-policy');
                });
            }]
        })
        .state('global-entity-action-approval-policy-view', {
            parent: 'global-entity-action-approval-policy-todolist',
            url: '/{id}/view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy-dialog.html',
                    controller: 'GlobalApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                            	 entity: ['GlobalApprovalPolicy', 'GlobalValues', function(GlobalApprovalPolicy, GlobalValues) {
                                     return GlobalApprovalPolicy.get({orgId:GlobalValues.getOrgId(), id:$stateParams.id}).$promise;
                                 }],
                                 mode: function(){
                                	 return "View";
                                 }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         .state('global-entity-action-approval-policy-todolist', {
            parent: 'dashboard',
            url: '/global-entity-action-approval-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-entity-action-approval-policy.html',
                    controller: 'GlobalEntityActionApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('globalApprovalPolicy');
                            $translatePartialLoader.addPart('globalEntityActionApprovalPolicy');                       
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                	$state.go('global-approval-policy', null, { reload: 'global-approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
        .state('global-entity-action-approval-policy-todolist.resubmit', {
            parent: 'dashboard',
            url: '/global-entity-action-approval-policy-resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-entity-action-approval-policy.html',
                    controller: 'GlobalEntityActionApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                        	

                        },
                       translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                           $translatePartialLoader.addPart('error');
                           $translatePartialLoader.addPart('global');
                           $translatePartialLoader.addPart('globalApprovalPolicy');
                           $translatePartialLoader.addPart('globalEntityActionApprovalPolicy');
                           return $translate.refresh();
                       }]
                    }
                }).result.then(function() {
                    $state.go('global-approval-policy', null, { reload: 'global-approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
        })
   };
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('GlobalApprovalPolicy', GlobalApprovalPolicy);

    GlobalApprovalPolicy.$inject = ['$resource'];

    function GlobalApprovalPolicy ($resource) {
        var resourceUrl =  'api/orgId/:orgId/global-approval-policy/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'}
        	 },
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
             'getGlobalApprovalPolicies': {
                 method: 'GET',
                 isArray: true,
                 url: 'api/global-approval-policy/orgTypeId/:orgTypeId/customerUserTypeId/:customerUserTypeId',
                 params: {orgTypeId:'@orgTypeId',customerUserTypeId:'@customerUserTypeId'},
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
        	 'save': {
                 method: 'POST',
                 url: 'api/global-approval-policy/orgTypeId/:orgTypeId/custUserTypeId/:custUserTypeId',
                 params: {orgTypeId:'@orgTypeId',custUserTypeId:'@custUserTypeId'},
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                    return angular.toJson(copy);
                 }                
             },
        	 'update': {
                 method: 'PUT',
                 url: 'api/global-approval-policy/orgTypeId/:orgTypeId/custUserTypeId/:custUserTypeId',
                 params: {orgTypeId:'@orgTypeId',custUserTypeId:'@custUserTypeId'},
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/global-approval-policy',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'globalApprovalPolicy'
        })
        
        .controller('GlobalApprovalPolicyController', GlobalApprovalPolicyController);

    GlobalApprovalPolicyController.$inject = ['$scope', '$state','$rootScope', 'workflowSharedService', 'GlobalApprovalPolicy', 'GlobalValues', 'EntityPermissions', 'ScreenLog','entityConstants'];

    function GlobalApprovalPolicyController($scope, $state,$rootScope, workflowSharedService, GlobalApprovalPolicy, GlobalValues, EntityPermissions, ScreenLog,entityConstants) {
        var vm = this;
        workflowSharedService.viewFrom = "globalApprovalPolicy";
        /*vm.EntityStateApprovalProcessScreen = 'EntityStateApprovalProcess';
        vm.ApprovalProcessScreen = 'ApprovalProcess';*/
        vm.entityConstants = entityConstants;
        vm.EntityStateApprovalProcessScreen = entityConstants.ENTITY_SHORT_NAME.MANAGE_GLOBAL_ENTITY_STATE_APPROVAL_PROCESS;
        vm.ApprovalProcessScreen = entityConstants.ENTITY_SHORT_NAME.GLOBAL_APPROVAL_PROCESS;
        vm.screenLog = ScreenLog;
        vm.launch=launch;
        logScreenAccess();
        vm.clicked=false;
        /*
        vm.permitEntityStateApprovalProcessMapEntityAction = EntityPermissions.hasPermission('EntityStateApprovalProcess.MAP');
        vm.permitApprovalProcessViewEntityAction = EntityPermissions.hasPermission('ApprovalProcess.VIEW');
        vm.permitApprovalProcessCreateEntityAction = EntityPermissions.hasPermission('ApprovalProcess.CREATE');
        vm.permitApprovalProcessEditEntityAction = EntityPermissions.hasPermission('ApprovalProcess.EDIT');
        vm.permitApprovalProcessDeleteEntityAction = EntityPermissions.hasPermission('ApprovalProcess.DELETE');
         */      
        vm.permitEntityStateApprovalProcessMapEntityAction = true;
        vm.permitApprovalProcessViewEntityAction = true;
        vm.permitApprovalProcessCreateEntityAction = true;
        vm.permitApprovalProcessEditEntityAction = true;
        vm.permitApprovalProcessDeleteEntityAction = true;
       
        
        function launch() {
        	$state.go("global-approval-policy.new");
        }
        
        
        vm.loadAll = function loadAll(organisationType, customerUserType) {
        	
        	if(organisationType.shortName=="CUSTOMER"){
        		vm.custUserTypeID = customerUserType.id
        	}
        	else{
        		vm.custUserTypeID = 0;
        		customerUserType =null;
        		vm.customerusertype=null;
        	}
        	
        	$rootScope.organisationType = organisationType;        	
        	$rootScope.customerUserType = customerUserType;
        	
        	
        	//if(customerUserType != undefined){vm.custUserTypeID = customerUserType.id};
        	GlobalApprovalPolicy.getGlobalApprovalPolicies({"orgTypeId":organisationType.id, "customerUserTypeId": vm.custUserTypeID},function(result) {
        		vm.globalApprovalPolicies = result;
                vm.clicked=false;
        		console.log(result);
        		
        	});
        }
        function logScreenAccess(){
            
       	 ScreenLog.screenLog( vm.ApprovalProcessScreen,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('generic-users', {
            parent: 'entity',
            url: '/generic-users',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.genericUsers.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/generic-users/generic-users.html',
                    controller: 'GenericUsersController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
             
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
       
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('GenericUsers', GenericUsers);

    GenericUsers.$inject = ['$resource'];

    function GenericUsers ($resource) {
        var resourceUrl =  'api/generic-users';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', 
        	    url: 'api/user-import'
        	 },
         	
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        
        .controller('GenericUsersController', GenericUsersController);

    GenericUsersController.$inject = ['$scope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','GenericUsers','AlertService'];

    function GenericUsersController($scope, $state , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,GenericUsers, AlertService) {
        var vm = this;
        vm.importUsers = importUsers;
        
       function importUsers() {
        	GenericUsers.query(onGetSuccess, onGetFailure);
    	        	
        }      
        
        function onGetSuccess(){
        	AlertService.success("File uploaded successfully...!");
        }
        
        function onGetFailure(){
        	
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('generic-customers', {
            parent: 'entity',
            url: '/generic-customers',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.genericCustomers.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/Generic-Customers/generic-customers.html',
                    controller: 'GenericCustomersController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
             
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
       
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('GenericCustomers', GenericCustomers);

    GenericCustomers.$inject = ['$resource'];

    function GenericCustomers ($resource) {
        var resourceUrl =  'api/customer-onboarding-import';
        
        return $resource(resourceUrl, {}, {
        	'customerImport': { method: 'GET', 
        	    url: 'api/customer-onboarding-import'
        	 },
         	
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        
        .controller('GenericCustomersController', GenericCustomersController);

    GenericCustomersController.$inject = ['$scope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','GenericCustomers','AlertService'];

    function GenericCustomersController($scope, $state , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,GenericCustomers, AlertService) {
        var vm = this;
        vm.importCustomers = importCustomers
        
       function importCustomers() {
        	GenericCustomers.query(onGetSuccess, onGetFailure);
    	        	
        }      
        
        function onGetSuccess(){
        	AlertService.info("File uploaded successfully...!");
        }
        
        function onGetFailure(){
        	
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('GenerateDealTicket', GenerateDealTicket);

    GenerateDealTicket.$inject = ['$resource'];

    function GenerateDealTicket ($resource) {
        var resourceUrl =  'api/generate-deal-ticket';
        
        return $resource(resourceUrl, {}, {
        	          
            	
             'generate': {
                 method: 'POST',
                 url: 'api/generate-deal-ticket',
                 responseType: 'arraybuffer',
                 transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	
                      return angular.toJson(copy);
                  },
                 transformResponse: function(data, headers) {
                     return {
                         data: data,
                         headers: headers
                     };
                 }              
             },
             'generateOutstandingTrades': {
                 method: 'POST',
                 url: 'api/generate-deal-ticket-outstanding-trades',
                 responseType: 'arraybuffer',
                 transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	
                      return angular.toJson(copy);
                  },
                 transformResponse: function(data, headers) {
                     return {
                         data: data,
                         headers: headers
                     };
                 }              
             }
              
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("gatewayApp")

        .controller("ForgotPIDController", ForgotPIDController);

    ForgotPIDController.$inject = [
        "$scope",
        "$state",
        "$uibModalInstance",
        "workflowSharedService",
        "User",
        "GlobalValues",
        "EntityPermissions",
        "$filter",
        "entity",
        "ScreenLog",
        "$rootScope",
        "AlertService",
        "globalValue",
        "CryptoUtil"
    ];

    function ForgotPIDController(
        $scope,
        $state,
        $uibModalInstance,
        workflowSharedService,
        User,
        GlobalValues,
        EntityPermissions,
        $filter,
        entity,
        ScreenLog,
        $rootScope,
        AlertService,
        globalValue,
        CryptoUtil
    ) {
        var vm = this;

        vm.todayDate = new Date();
        vm.globalValues = GlobalValues;
        vm.getPID = getPID;
        vm.getPIDFromList = getPIDFromList;
        vm.NotFound = "No data found";
        vm.show = false;
        $scope.clicked = false;
        vm.clear = clear;
        vm.sendOTP = sendOTP;
        $scope.noOfRecordsPerPage =
            GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.mobileCountryCode = 91;
        vm.disableGenerateOTP = false;
        vm.resendPrimaryOTP = resendPrimaryOTP;
        vm.platformENCCode = "tV1f3EtXyUjBrf8JbbW7bSYf7JgyxZpVXYJvwAyM34Q=";
        vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;


        $scope.otpInput = {
            size: globalValue.defaultOTPLength,
            type: "password",
            onDone: function (value) {
                vm.otp = value;
            },
            onChange: function (value) {
                console.log(value);
            }
        };

        function getPID() {
            vm.PID = null;
            //var dob=$filter('date')(vm.dob, "yyyy-MM-dd");

            /*if(vm.aadharNumber==undefined || vm.aadharNumber==null){
                User.getPID({"firstName":vm.firstName,"dob":dob,"aadhar":'0'},onGetPIDSuccess,onGetPIDError);
            }
            else{
                User.getPID({"firstName":vm.firstName,"dob":dob,"aadhar":vm.aadharNumber},onGetPIDSuccess,onGetPIDError);
            }*/
            User.getPID(
                {
                    email: vm.email,
                    mobile: vm.mobile,
                    mobileCountryCode: vm.mobileCountryCode,
                    otp: vm.otp
                },
                onGetPIDSuccess,
                onGetPIDError
            );

            //User.getPID({"email":vm.email,"mobile":vm.mobile},onGetPIDSuccess,onGetPIDError);
        }

        $scope.selectedRow = null; // initialize our variable to null
        $scope.setClickedRow = function (index) {
            //function that sets the value of selectedRow to current index
            $scope.selectedRow = index;
        };

        function getPIDFromList(index) {
            vm.PID = vm.pidList[index].personDetails.personId;
            $rootScope.PID = vm.PID;
            $scope.$emit("fetchPID");
            $uibModalInstance.dismiss("cancel");
        }

        function onGetPIDSuccess(result) {
            vm.wrongOTPAttemptCount = 0;
            if (result.length == 1) {
                vm.PID = result[0].personDetails.personId;
                $rootScope.PID = vm.PID;
                $scope.$emit("fetchPID");
                $uibModalInstance.dismiss("cancel");
            } else if (result.length > 1) {
                vm.pidList = result;
            }
        }
        function onGetPIDError() {
            vm.wrongOTPAttemptCount = vm.wrongOTPAttemptCount + 1;
            if (
                vm.wrongOTPAttemptCount >=
                globalValue.maximumOTPWrongAttemptCount
            ) {
                //AlertService.error("Maximum wrong OTP attempt count is exceeded!<br>Please request for resend OTP.")
                MessageBox.openMessageBox(
                    "Alert",
                    "Maximum wrong OTP attempt count is exceeded! Session expired. You will be redirected to login page...!",
                    "Ok",
                    "invalidotpchangemobile"
                );
            }
            vm.otpClicked = false;
        }

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        // function sendOTP() {
        // 	vm.disableGenerateOTP= true;
        // 		User.SendOTPSMS({
        // 			"mobile" :vm.mobile,
        // 			"mobileCountryCode": vm.mobileCountryCode,
        // 		}, onOTPSendSuccess, onSendOTPError);
        // 	}

        function sendOTP() {
            vm.disableGenerateOTP = true;
            if (vm.entityOwnerType != 'Clearcorp') {
                // ✅ Step 1: Execute reCAPTCHA
                grecaptcha.ready(function () {
                    grecaptcha
                        .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
                            action: "otp_action"
                        })
                        .then(function (token) {
                            // ✅ Step 2: Call API with token
                            User.SendOTPSMS(
                                {
                                    mobile: vm.mobile,
                                    mobileCountryCode: vm.mobileCountryCode,
                                    recaptchaToken: token,
                                    orgType: vm.entityOwnerType,
                                    sourceType: "send-otp",
                                    source: "forget-pid"
                                },
                                onOTPSendSuccess,
                                onSendOTPError
                            );
                        })
                        .catch(function (error) {
                            console.error("reCAPTCHA error:", error);
                            vm.disableGenerateOTP = false; // re-enable button
                        });
                });
            } else {
                User.SendOTPSMS(
                    {
                        mobile: vm.mobile,
                        mobileCountryCode: vm.mobileCountryCode,
                        orgType: vm.entityOwnerType,
                        sourceType: "send-otp",
                        source: "forget-pid"
                    },
                    onOTPSendSuccess,
                    onSendOTPError
                );

            }
        }
        function onOTPSendSuccess(result) {
            vm.wrongOTPAttemptCount = 0;
            vm.resendOTPAttemptCount = 0;
            AlertService.info("OTP has been sent to your mobile");
            vm.isOTPSend = true;
        }

        function onSendOTPError() {
            vm.disableGenerateOTP = false;
            AlertService.error("Error occurred while generating OTP mobile");
        }
    }

    function resendPrimaryOTP() {
        if (vm.mobileCountryCode == null || vm.mobileCountryCode == undefined) {
            vm.mobileCountryCode = "";
        }
        var mobileNo = vm.mobile;
        var mobileCountryCode = vm.mobileCountryCode;
        if (
            vm.resendOTPAttemptCount >= globalValue.maximumOTPResendAttemptCount
        ) {
            //AlertService.error("Maximum request for resend OTP is exceeded!<br>Please try again later.")
            MessageBox.openMessageBox(
                "Alert",
                "Maximum request for resend OTP is exceeded! Please try again.",
                "Ok",
                "resendotpchangemobile"
            );
            // }else{
            // 	User.SendOTPSMS({mobile: mobileNo, mobileCountryCode : mobileCountryCode}, onResendPrimaryOTPSuccess, onResendPrimaryOTPError);
            // }
        } else {
            if (vm.entityOwnerType != 'Clearcorp') {
                // ✅ Step 1: Execute reCAPTCHA
                grecaptcha.ready(function () {
                    grecaptcha
                        .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
                            action: "otp_action"
                        })
                        .then(function (token) {
                            // ✅ Step 2: Call API with token
                            User.SendOTPSMS(
                                {
                                    mobile: mobileNo,
                                    mobileCountryCode: mobileCountryCode,
                                    orgType: vm.entityOwnerType,
                                    recaptchaToken: token,
                                    sourceType: "resend-otp",
                                    source: "forget-pid"
                                },
                                onResendPrimaryOTPSuccess,
                                onResendPrimaryOTPError
                            );
                        })
                        .catch(function (error) {
                            console.error("reCAPTCHA error:", error);
                            vm.disableGenerateOTP = false;
                        });
                });
            } else {
                User.SendOTPSMS(
                    {
                        mobile: mobileNo,
                        mobileCountryCode: mobileCountryCode,
                        orgType: vm.entityOwnerType,
                        sourceType: "resend-otp",
                        source: "forget-pid"
                    },
                    onResendPrimaryOTPSuccess,
                    onResendPrimaryOTPError
                );

            }
        }
        }

        function onResendPrimaryOTPSuccess() {
            vm.wrongOTPAttemptCount = 0;
            vm.resendOTPAttemptCount = vm.resendOTPAttemptCount + 1;
            AlertService.info("OTP has been resent to your mobile");
        }

        function onResendPrimaryOTPError() {
            //AlertService.error("Error occurred while generating OTP mobile");
        }
    }) ();

(function () {
	'use strict';

	angular.module('gatewayApp').controller('ForexConfigurationsDialogController',
		ForexConfigurationsDialogController);

	ForexConfigurationsDialogController.$inject = ['$scope', '$state', '$rootScope',
		'GlobalValues', 'workflowSharedService', '$uibModalInstance',
		'ForexConfigurations', 'entity', 'DateUtils', 'AlertService', '$filter', 'StaticLookUp'];

	function ForexConfigurationsDialogController($scope, $state, $rootScope, GlobalValues,
		workflowSharedService, $uibModalInstance, ForexConfigurations, entity, DateUtils, AlertService, $filter, StaticLookUp) {
		var vm = this;
		vm.homeBranch = entity;
		vm.forexConfigurationsDTO = {};
		vm.numberOfDigits = 11;
		vm.ExpandOrCollapseRedirectionURLConfigurations = false;
		vm.ExpandOrCollapseFeeConfigurations = false;
		vm.clear = clear;
		vm.save = save;
		vm.clicked = false;
		$scope.showButton = false;
		vm.resubmitForexConfigurations = resubmitForexConfigurations;
		vm.globalValues = GlobalValues;
		vm.todayDate = new Date();
		vm.disablemode = false;

		vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
		vm.unitTypes = [
				{ value: 'Fixed', displayName: 'Fixed ' },
				{ value: 'Percentage', displayName: 'Percentage' }
		];

		vm.currencyNotesDeliveryOptions = [
				{ name: 'AVAILABLE', value: 'AVAILABLE' },
				{ name: 'NOT_AVAILABLE', value: 'NOT_AVAILABLE' },
				{ name: 'INAPP', value: 'INAPP' },
				{ name: 'REDIRECTION', value: 'REDIRECTION' }
		];
		vm.deliveryConfigOptions = [
				{ name: 'AVAILABLE', value: 'AVAILABLE' },
				{ name: 'NOT_AVAILABLE', value: 'NOT_AVAILABLE' },
				{ name: 'INAPP', value: 'INAPP' },
				{ name: 'REDIRECTION', value: 'REDIRECTION' }
		];


		if (workflowSharedService.viewFrom == 'forexConfigurations') {
			vm.forexConfigurations = entity;
			if (!vm.forexConfigurations.bankForexFeeDetailsList) {
				vm.forexConfigurations.bankForexFeeDetailsList = [];
			}
			// Normalize values correctly
			vm.forexConfigurations.bankForexFeeDetailsList.forEach(function (fee) {
				if (fee.units) {
					if (fee.units == 'Fixed') {
						fee.units = vm.unitTypes[0];
					}
					else {
						fee.units = vm.unitTypes[1];
					}

				}
			});
			$scope.showButton = false;
		} else if (workflowSharedService.viewFrom == 'forex_configurationstodolist_resubmit') {
			vm.forexConfigurationsDTO = angular.fromJson($rootScope.payload);
			if (vm.forexConfigurations == undefined) {
				vm.forexConfigurations = vm.forexConfigurationsDTO
			}
			// Normalize values correctly
			vm.forexConfigurations.bankForexFeeDetailsList.forEach(function (fee) {
				if (fee.units) {
					if (fee.units == 'Fixed') {
						fee.units = vm.unitTypes[0];
					}
					else {
						fee.units = vm.unitTypes[1];
					}

				}
			});

			vm.disableForm = false;
			vm.disablemode = true;
			$scope.showButton = true;
		}


		function clear() {
			$uibModalInstance.dismiss('cancel');
		}
		function save() {
			vm.forexConfigurationsDTO = vm.forexConfigurations;
			vm.forexConfigurationsDTO.bankForexFeeDetailsList.forEach(function (fee) {
				if (fee.units && typeof fee.units === 'object') {
					fee.units = fee.units.value; // <-- convert object to string
				}
				fee.bank=vm.forexConfigurations.bank;
			});
			if(vm.forexConfigurationsDTO.bankForexUrlDetails != null && vm.forexConfigurationsDTO.bankForexUrlDetails != undefined){
			vm.forexConfigurationsDTO.bankForexUrlDetails.bank =vm.forexConfigurations.bank;
			}
			ForexConfigurations.update({
				"corpId": GlobalValues.getCorpId()
			}, vm.forexConfigurationsDTO, onSaveSuccess, onSaveError);
		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
			vm.clicked = false;
		}

		function onSaveError() {
			vm.clicked = false;
		}



		function resubmitForexConfigurations() {
			vm.forexConfigurationsDTO = vm.forexConfigurations;
			vm.forexConfigurationsDTO.bankForexFeeDetailsList.forEach(function (fee) {
				if (fee.units && typeof fee.units === 'object') {
					fee.units = fee.units.value; // <-- convert object to string
				}
			});
			ForexConfigurations.resubmitForCreate({
				"taskId": $rootScope.taskID
			}, vm.forexConfigurationsDTO, onResubmitSuccess, onResubmitError);
		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.dismiss('cancel');
		}
		function onResubmitError(error) {
			vm.clicked = false;
		}

	}
})();

(function() {
	'use strict';

	angular.module('gatewayApp').controller('ForexConfigurationsViewController',
        ForexConfigurationsViewController);

            ForexConfigurationsViewController.$inject = [ '$scope', '$state', '$rootScope',
			'workflowSharedService', '$uibModalInstance', 'ForexConfigurations', 'entity',
			'Workflow', 'GlobalValues','StaticLookUp'];

	function ForexConfigurationsViewController($scope, $state, $rootScope,
			workflowSharedService, $uibModalInstance, ForexConfigurations, entity, Workflow,
			GlobalValues,StaticLookUp) {
		var vm = this;
		vm.clear = clear;
		vm.approveForexConfigurations = approveForexConfigurations;
		vm.rejectForexConfigurations = rejectForexConfigurations;
		vm.discardForexConfigurations = discardForexConfigurations;
		$scope.showButton = false;
		$scope.showDiscardButton = false;
		vm.clicked = false;
		vm.ExpandOrCollapseRedirectionURLConfigurations = false;
		vm.ExpandOrCollapseFeeConfigurations = false;
		vm.globalValues = GlobalValues;
		vm.forexConfigurationsDTO = {};
        vm.bankValue=null;
        vm.bank=null;
        vm.state=null;

		if (workflowSharedService.viewFrom == 'forexConfigurations') {
			vm.forexConfigurations = entity; 
			console.log(vm.forexConfigurations); 
			$scope.showButton = false;
		} else if (workflowSharedService.viewFrom == 'forex_configurationstodolist_checker') {
			vm.forexConfigurationsDTO = angular.fromJson($rootScope.payload);

			if (vm.forexConfigurations  == undefined) {
				vm.forexConfigurations = vm.forexConfigurationsDTO
			}
			$scope.showButton = true;
			$scope.showDiscardButton = false;
		} else if (workflowSharedService.viewFrom == 'forex_configurationstodolist_maker') {
			vm.forexConfigurationsDTO = angular.fromJson($rootScope.payload);
			if (vm.forexConfigurations == undefined ||vm.forexConfigurations == null) {
				vm.forexConfigurations =  vm.forexConfigurationsDTO
			}
			$scope.showButton = false;
			$scope.showDiscardButton = true;
		} else if (workflowSharedService.viewFrom == 'forexConfigurations_auditLog') {
			vm.forexConfigurationsDTO = angular.fromJson($rootScope.payload);
		

			if (vm.forexConfigurations == undefined) {
				vm.forexConfigurations = vm.forexConfigurationsDTO
			}
			$scope.showButton = false;
		}
		
		function approveForexConfigurations() {
			ForexConfigurations.approve({
				"taskId" : $rootScope.taskID
			}, onApproveSuccess, onApproveError);
			$uibModalInstance.dismiss('cancel');
		}

		function onApproveSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
		}
		function onApproveError(error) {
			vm.clicked=false;
		}

		function rejectForexConfigurations() {
			Workflow.rejectTask($rootScope.taskID);
		}

		function discardForexConfigurations() {
			ForexConfigurations.discard({
				"taskId" : $rootScope.taskID
			}, onDiscardSuccess, onDiscardError);
			$uibModalInstance.dismiss('cancel');
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);
		}
		function onDiscardError(error) {

		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('forex-configurations', {
            parent: 'entity',
            url: '/forex-configurations',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{"global.menu.forexConfigurations.forexConfigurations" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/forex-configurations/forex-configurations.html',
                    controller: 'ForexConfigurationsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('forexConfigurations');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('forex-configurations.view', {
            parent: 'forex-configurations',
            url: '/view/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/forex-configurations/forex-configurations-details.html',
                    controller: 'ForexConfigurationsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['ForexConfigurations', 'GlobalValues', function(ForexConfigurations, GlobalValues) {
                                     return ForexConfigurations.get({id: $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('forexConfigurations');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
         })
          .state('forex-configurations.edit', {
            parent: 'forex-configurations',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl:  'app/entities/forex-configurations/forex-configurations-dialog.html',
                    controller: 'ForexConfigurationsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['ForexConfigurations', 'GlobalValues', function(ForexConfigurations, GlobalValues) {
                                     return ForexConfigurations.get({id: $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('forexConfigurations');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
         })
         .state('forex-configurations-todolist', {
            parent: 'dashboard',
            url: '/forexConfigurationsView',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/forex-configurations/forex-configurations-details.html',
                    controller: 'ForexConfigurationsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('forex-configurations', null, { reload: 'forex-configurations' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('forexConfigurations');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
        
         .state('forex-configurations-todolist.resubmit', {
            parent: 'dashboard',
            url: '/forexConfigurationsEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl:  'app/entities/forex-configurations/forex-configurations-dialog.html',
                    controller: 'ForexConfigurationsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('forex-configurations', null, { reload: 'forex-configurations' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('forexConfigurations');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
        .state('forex-configurations-auditLog', {
            parent: 'audit-log',
            url: '/forexConfigurationsView',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/forex-configurations/forex-configurations-details.html',
                    controller: 'ForexConfigurationsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('forex-configurations', null, { reload: 'forex-configurations' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('forexConfigurations');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
        .state('forex-configurations-historyReport', {
            parent: 'history-report',
            url: '/forexConfigurationsView',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/forex-configurations/forex-configurations-details.html',
                    controller: 'ForexConfigurationsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('forex-configurations', null, { reload: 'forex-configurations' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('forexConfigurations');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
            
        })
        
    }
    
    
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ForexConfigurations', ForexConfigurations);

        ForexConfigurations.$inject = ['$resource'];

    function ForexConfigurations ($resource) {
		var resourceUrl =  '/api';
		return $resource(resourceUrl, {}, {
		    'get' : {
			    method : 'GET',
			    params: {id : '@id'},
			    url:'api/manage-forex-configurations/:id',
			    transformResponse : function(data) {
                 if (data) {
                    return angular.fromJson(data);
                    }
                    return data;
			    }
		    },
            'getForexConfigurations': {
                method: 'GET',
                isArray: true,
                params: {bankId:'@bankId'},
                url: 'api/forex-configurations/:bankId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAllForexConfigurations': {
                method: 'GET',
                isArray: true,
                url: 'api/forex-configurations/',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	method:'POST',
            	params: {corpId:'@corpId'},
                url: 'api/manage-forex-configurations/:corpId',
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
            'approve': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
              	 method: 'GET',
                   params: {taskId:'@taskId'},
                   url: 'api/tasks/:taskId/discard'
             },
             'resubmitForCreate': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/resubmitForCreate/forex-configurations-details',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             },
             'exportForexConfigurationsExcel':{
				method: 'POST',
                params: {bankId : '@bankId'},
				url: 'api/forex-configurations/export/excel',
				responseType: 'arraybuffer',
				transformRequest: function (data) {
	                   	var copy = angular.copy(data);
	                   	
	                       return angular.toJson(copy);
	            },
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			},
			'exportForexConfigurationsCsv':{
				method: 'POST',
                params: {bankId : '@bankId'},
				url: 'api/forex-configurations/export/csv',
				responseType: 'arraybuffer',
				transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
            },
			transformResponse: function(data, headers) {
				return {
					data: data,
					headers: headers
				};   
			}         
			},
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'forexConfigurations'
        })
        
        .controller('ForexConfigurationsController', ForexConfigurationsController);

        ForexConfigurationsController.$inject = ['$scope', '$state', 'workflowSharedService', 'ForexConfigurations', 'GlobalValues', 'EntityPermissions','ScreenLog','$rootScope','entityConstants','$timeout', 'AlertService', '$filter', ];

    function ForexConfigurationsController($scope, $state, workflowSharedService, ForexConfigurations, GlobalValues, EntityPermissions,ScreenLog,$rootScope,entityConstants,$timeout,AlertService,$filter) {
        
        var vm = this;
        
        vm.globalValues = GlobalValues;
        vm.screenLog = ScreenLog;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.MANAGE_Forex_Configurations;
        $scope.refresh=refresh;
        workflowSharedService.viewFrom = "forexConfigurations";
        vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
        vm.clicked=false;
        vm.exportDataToFile = exportDataToFile;
        vm.orgid=vm.globalValues.getOrganisation();
        vm.forexConfigurationsfileName = "Forex_Configurations_";
        vm.fileName = vm.forexConfigurationsfileName;
        vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
        vm.noOfDecimalsForRate = 3;
        
        vm.permitForexConfigurationsViewEntityAction = EntityPermissions.hasPermission('ManageForexConfigurations.VIEW')
        vm.permitForexConfigurationsEditEntityAction = EntityPermissions.hasPermission('ManageForexConfigurations.EDIT')
 
		console.log(vm.permitForexConfigurationsViewEntityAction);
		if(vm.permitForexConfigurationsViewEntityAction){
			loadAll();	
		}
        
		function loadAll(){
            if(vm.entityOwnerType=='Clearcorp'){
                ForexConfigurations.getAllForexConfigurations(function(result) {
                    vm.forexConfigurations = result;
                    vm.clicked=false;                    
                });	
            }else
			ForexConfigurations.getForexConfigurations({bankId: vm.globalValues.getOrganisation().id}, function(result) {
                vm.forexConfigurations = result;
                vm.clicked=false;                    
            });	
		}
		logScreenAccess();
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }
        
        $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
        function exportDataToFile(fileType){
            if(vm.bank == null  || vm.bank == undefined){
                vm.bankId=vm.globalValues.getOrganisation().id;
            }else{
                vm.bankId=vm.bank.id;
            }
			vm.fileName =  vm.forexConfigurationsfileName ;
				if(fileType == 'csv'){
					vm.mimeType = 'text/csv';
					vm.extension =  ".csv";  
					ForexConfigurations.exportForexConfigurationsCsv({bankId:vm.bankId}, processResponse );
				}
				else if(fileType == 'xls'){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.extension = ".xls";  
					ForexConfigurations.exportForexConfigurationsExcel({bankId:vm.bankId},processResponse );
				}
		}

		function processResponse(result){        	  
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
			vm.baseString =   vm.fileName + moment().format( vm.reportFileTimestampFormat ) +  vm.extension; 

			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}   
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ExposureTypeEditController', ExposureTypeEditController);

    ExposureTypeEditController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService', '$uibModalInstance', 'ExposureType', 'entity', 'mode', 'Workflow'];

     function ExposureTypeEditController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance, ExposureType, entity, mode, Workflow) {
        var vm = this;
        vm.exposureType=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        $scope.showApproveRejectButton=false;
        $scope.showDiscardButton = false;
    	$scope.showResubmitButton=false;
        vm.resubmitExposureType = resubmitExposureType;
        vm.globalValues = GlobalValues;
        vm.discardExposureType = discardExposureType;
        vm.rejectExposureType = rejectExposureType;
        vm.approveExposureType = approveExposureType;
        vm.viewMode=false;
        vm.disabled=false;
        
        $scope.showButton = false;
        vm.orgId = vm.globalValues.getOrgId();
        vm.mode = mode;
        
        if(workflowSharedService.viewFrom == 'exposureType'){
        	vm.exposureType=entity;
        	$scope.showButton = true;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'exposureTypetodolist_resubmit') {
        	vm.exposureType =  angular.fromJson($rootScope.payload);
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=true;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'exposureType_todolist_checker') {
        	vm.exposureType =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = true;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom == 'exposureType_todolist_maker') {
        	vm.exposureType =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = true;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom=='exposureType_auditlog'){
        	vm.exposureType =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
        else if(workflowSharedService.viewFrom=='exposure_type_import_auditlog'){
        	
        	vm.exposureType =  angular.fromJson($rootScope.payload);   
        	
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
		
        if(vm.exposureType!=null && vm.exposureType.isEnabled!=null && vm.exposureType.isEnabled!=undefined){
        	vm.disabled = !vm.exposureType.isEnabled;
        }
        
        if(mode=='VIEW'){
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	
        	if(vm.disabled){
        		vm.exposureType.isEnabled = false;
        	}else{
        		vm.exposureType.isEnabled = true;
        	}
        	
        	if (vm.exposureType.id != null) {
				ExposureType.update({
					"orgId" : GlobalValues.getOrgId()
				}, vm.exposureType, onSaveSuccess, onSaveError);
			} else {
				ExposureType.save({
					"orgId" : GlobalValues.getOrgId()
				}, vm.exposureType, onSaveSuccess, onSaveError);
			}
        	
         }
      
       
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	
        	vm.clicked = false;
        }
        function resubmitExposureType() {
        	
        	if(vm.disabled){
        		vm.exposureType.isEnabled = false;
        	}else{
        		vm.exposureType.isEnabled = true;
        	}
        	
        	ExposureType.resubmit({"taskId" : $rootScope.taskID}, vm.exposureType, onResubmitSuccess, onResubmitError);
        	
       		
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {
        	vm.clicked = false;
        }
        
        function approveExposureType() { 
        	ExposureType.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectExposureType() { Workflow.rejectTask($rootScope.taskID); }

        function discardExposureType() {
        	ExposureType.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        

        function onDiscardError(error) {
        	
        }

        $scope.$watch('vm.exposureType.name', function(newVal, oldVal) {
            if(newVal!=null||newVal!=undefined)
            {
                newVal = newVal.replace(/(\r\n|\n|\r)/gm," ");
                newVal = newVal.replace(/(,)/gm,"");
                newVal = newVal.replace("=","");
                newVal = newVal.replace(/[^\x20-\x7E]/g, '');
                vm.exposureType.name = newVal;
                
            }
        });
        
        $scope.$watch('vm.exposureType.remarks', function(newVal, oldVal) {
            if(newVal!=null && newVal!=undefined && newVal!='')
            {
                newVal = newVal.replace(/[^\x20-\x7E]/g, '');
                vm.exposureType.remarks = newVal;
                
            }
        });

     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('exposure-type', {
            parent: 'entity',
            params:{screen:'ExposureType'},
            url: '/exposure-type',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.exposureType.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/exposure-type/exposure-type.html',
                    controller: 'ExposureTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
	           	validateSODAndSession: ['ExposureType', function(ExposureType, GlobalValues) {
	                return ExposureType.validateSODAndSession().$promise;
	            }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('exposureType');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
       
        .state('exposure-type-new', {
            parent: 'exposure-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-type/exposure-type-dialog.html',
                    controller: 'ExposureTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	                           	
                             
                            };
                        },
                        mode: function(){
                        	return ""
                        }
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('exposure-type-edit', {
            parent: 'exposure-type',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-type/exposure-type-dialog.html',
                    controller: 'ExposureTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	 entity: ['ExposureType', 'GlobalValues', function(ExposureType, GlobalValues) {
                             return ExposureType.get({id : $stateParams.id}).$promise;
                         }],
                         mode: function(){
                         	return ""
                         }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('exposure-type-view', {
            parent: 'exposure-type',
            url: '/view/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-type/exposure-type-dialog.html',
                    controller: 'ExposureTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	 entity: ['ExposureType', 'GlobalValues', function(ExposureType, GlobalValues) {
                             return ExposureType.get({id : $stateParams.id}).$promise;
                         }],
                         mode: function(){
                         	return "VIEW"
                         }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('exposure-type-todolist', {
            parent: 'dashboard',
            url: '/exposureType',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-type/exposure-type-dialog.html',
                    controller: 'ExposureTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        mode: function(){
                        	return ""
                        }
                    }
                }).result.then(function() {
                	$state.go('exposure-type', null, { reload: 'exposure-type' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('exposure-type-todolist-resubmit', {
            parent: 'dashboard',
            url: '/exposureTypeEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-type/exposure-type-dialog.html',
                    controller: 'ExposureTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
	                      entity: function () {                       	
	                          
	                      },
	                      mode: function(){
	                      	return ""
	                      }
                    }
                }).result.then(function() {
                	$state.go('exposure-type', null, { reload: 'exposure-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('exposure-type-auditLog', {
            parent: 'audit-log',
            url: '/exposureTypeAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-type/exposure-type-dialog.html',
                    controller: 'ExposureTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        mode: function(){
                        	return ""
                        }
                    }
                }).result.then(function() {
                	$state.go('exposure-type', null, { reload: 'exposure-type' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('exposure-type-historyReport', {
            parent: 'history-report',
            url: '/exposureTypeHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-type/exposure-type-dialog.html',
                    controller: 'ExposureTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        mode: function(){
                        	return ""
                        }
                    }
                }).result.then(function() {
                	$state.go('exposure-type', null, { reload: 'exposure-type' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ExposureType', ExposureType);

    ExposureType.$inject = ['$resource'];

    function ExposureType ($resource) {
        var resourceUrl =  'api/exposure-type/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/exposure-type'
        	 },
         	
             'getAllExposureTypes':{
                 isArray: true,
                 url: 'api/all-exposure-types',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },

             'getEnabledExposureTypes':{
                 isArray: true,
                 url: 'api/enabled-exposure-types',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },

             'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
             'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/exposure-type/orgId/:orgId',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
        	
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/exposure-type/orgId/:orgId',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
 			 'validateSODAndSession' : {
				method : 'GET',
				url : 'api/validate-sod-session-status',
			 },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/exposure-type',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'exposureType'
        })
        
        .controller('ExposureTypeController', ExposureTypeController);

    ExposureTypeController.$inject = ['$scope', '$state','$rootScope','ExposureType', 'GlobalValues', 'workflowSharedService', 
    'EntityPermissions', 'ScreenLog', 'entityConstants', '$timeout', 'IntradayMarket', 'MessageBox', 'validateSODAndSession','Auth'];

    function ExposureTypeController($scope, $state,$rootScope, ExposureType, GlobalValues, workflowSharedService, 
      EntityPermissions, ScreenLog, entityConstants, $timeout, IntradayMarket, MessageBox, validateSODAndSession,Auth) {
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.EXPOSURE_TYPE;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "exposureType";
        $scope.refresh=refresh;
        vm.validateSODAndSession = validateSODAndSession;
        
        vm.launch=launch;
        vm.editExposureType=editExposureType;
        function launch() {
          if(vm.marketSessionSettings.sessionStatus=='OPEN'){
            MessageBox.openMessageBox("Alert", "Addition/Modification is permitted only after the IB.SPOT market hours...!", "Ok", "exposuretype");
          }else if(!vm.validateSODAndSession.allowToAddOrEdit){
        	  MessageBox.openMessageBox("Alert", "SOD is completed for the business day, addition/modifications is not permitted.", "Ok", "exposuretype");
          }else{
            $state.go("exposure-type-new");
          }
        }

        function editExposureType(exposureTypeId){
          if(vm.marketSessionSettings.sessionStatus=='OPEN'){
            MessageBox.openMessageBox("Alert", "Addition/Modification is permitted only after the IB.SPOT market hours...!", "Ok", "exposuretype");
          }else if(!vm.validateSODAndSession.allowToAddOrEdit){
        	  MessageBox.openMessageBox("Alert", "SOD is completed for the business day, addition/modifications is not permitted.", "Ok", "exposuretype");
          }else{
            vm.screenLog.screenLog(vm.screenName, exposureTypeId, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
            $state.go("exposure-type-edit", {id:exposureTypeId});
          }
        }
        
        vm.permitExposureTypeAddEntityAction = EntityPermissions.hasPermission('ExposureType.CREATE');
        vm.permitExposureTypeEditEntityAction = EntityPermissions.hasPermission('ExposureType.EDIT');
        vm.permitExposureTypeViewEntityAction = EntityPermissions.hasPermission('ExposureType.VIEW');
       /* if(vm.permitExposureTypeViewEntityAction ==false){
          //message box 
          MessageBox.openMessageBox('Alert', 'Session expired. You will be redirected to login page...!', 'Ok', 'permitExposureTypeViewEntityAction');
        }
    
        $rootScope.$on('gatewayApp.messagebox.ok.permitExposureTypeViewEntityAction', function (event) {
          Auth.sessionlogout();
        });
        
        $rootScope.$on('gatewayApp.messagebox.clear.permitExposureTypeViewEntityAction', function (result){
          Auth.sessionlogout();
        })*/
        
        logScreenAccess();
        loadAll();

       function loadAll() {
    	   
    	   ExposureType.getAllExposureTypes(function(result) {
               vm.exposureTypes = result;                
           });
    	 
        }      
       
        //get market session settings.
        IntradayMarket.getIntradayMarketSessionSettingsForInstrument({"instrument":'InterbankSPOT'}, onGetMarketSessionSuccess, onGetMarketSessionFailure);

        function onGetMarketSessionSuccess(result){
          vm.marketSessionSettings = result;
        }

        function onGetMarketSessionFailure(){

        }

       function logScreenAccess(){
    	   ScreenLog.screenLog(vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ExposureSubTypeEditController', ExposureSubTypeEditController);

    ExposureSubTypeEditController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService', '$uibModalInstance', 'ExposureSubType', 'entity', 'mode', 'Workflow'];

     function ExposureSubTypeEditController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance, ExposureSubType, entity, mode, Workflow) {
        var vm = this;
        vm.exposureSubType=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        $scope.showApproveRejectButton=false;
        $scope.showDiscardButton = false;
    	$scope.showResubmitButton=false;
        vm.resubmitExposureSubType = resubmitExposureSubType;
        vm.globalValues = GlobalValues;
        vm.discardExposureSubType = discardExposureSubType;
        vm.rejectExposureSubType = rejectExposureSubType;
        vm.approveExposureSubType = approveExposureSubType;
        vm.viewMode=false;
        vm.disabled=false;
        
        $scope.showButton = false;
        vm.orgId = vm.globalValues.getOrgId();
        vm.mode = mode;
        
        if(workflowSharedService.viewFrom == 'exposureSubType'){
        	vm.exposureSubType=entity;
        	$scope.showButton = true;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'exposureSubTypetodolist_resubmit') {
        	vm.exposureSubType =  angular.fromJson($rootScope.payload);
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=true;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'exposureSubType_todolist_checker') {
        	vm.exposureSubType =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = true;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom == 'exposureSubType_todolist_maker') {
        	vm.exposureSubType =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = true;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom=='exposureSubType_auditlog'){
        	vm.exposureSubType =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
        else if(workflowSharedService.viewFrom=='exposure_sub_type_import_auditlog'){
        	
        	vm.exposureSubType =  angular.fromJson($rootScope.payload);   
        	
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
		
        if(vm.exposureSubType!=null && vm.exposureSubType.isEnabled!=null && vm.exposureSubType.isEnabled!=undefined){
        	vm.disabled = !vm.exposureSubType.isEnabled;
        }
        
        if(mode=='VIEW'){
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	
        	if(vm.disabled){
        		vm.exposureSubType.isEnabled = false;
        	}else{
        		vm.exposureSubType.isEnabled = true;
        	}
        	
        	if (vm.exposureSubType.id != null) {
				ExposureSubType.update({
					"orgId" : GlobalValues.getOrgId()
				}, vm.exposureSubType, onSaveSuccess, onSaveError);
			} else {
				ExposureSubType.save({
					"orgId" : GlobalValues.getOrgId()
				}, vm.exposureSubType, onSaveSuccess, onSaveError);
			}
        	
         }
      
       
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	
        	vm.clicked = false;
        }
        function resubmitExposureSubType() {
        	
        	if(vm.disabled){
        		vm.exposureSubType.isEnabled = false;
        	}else{
        		vm.exposureSubType.isEnabled = true;
        	}
        	
        	ExposureSubType.resubmit({"taskId" : $rootScope.taskID}, vm.exposureSubType, onResubmitSuccess, onResubmitError);
        	
       		
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {
        	vm.clicked = false;
        }
        
        function approveExposureSubType() { 
        	ExposureSubType.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectExposureSubType() { Workflow.rejectTask($rootScope.taskID); }

        function discardExposureSubType() {
        	ExposureSubType.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        

        function onDiscardError(error) {
        	
        }

        $scope.$watch('vm.exposureSubType.name', function(newVal, oldVal) {
            if(newVal!=null && newVal!=undefined && newVal!='')
            {
                newVal = newVal.replace(/(\r\n|\n|\r)/gm," ");
                newVal = newVal.replace(/(,)/gm,"");
                newVal = newVal.replace("=","");
                newVal = newVal.replace(/[^\x20-\x7E]/g, '');
                vm.exposureSubType.name = newVal;
                
            }
        });
        
        $scope.$watch('vm.exposureSubType.remarks', function(newVal, oldVal) {
            if(newVal!=null && newVal!=undefined && newVal!='')
            {
                newVal = newVal.replace(/[^\x20-\x7E]/g, '');
                vm.exposureSubType.remarks = newVal;
                
            }
        });

     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('exposure-sub-type', {
            parent: 'entity',
            params:{screen:'ExposureSubType'},
            url: '/exposure-sub-type',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.exposureSubType.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/exposure-sub-type/exposure-sub-type.html',
                    controller: 'ExposureSubTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                validateSODAndSession: ['ExposureType', function(ExposureType, GlobalValues) {
                    return ExposureType.validateSODAndSession().$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('exposureSubType');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
       
        .state('exposure-sub-type-new', {
            parent: 'exposure-sub-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-sub-type/exposure-sub-type-dialog.html',
                    controller: 'ExposureSubTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	                           	
                             
                            };
                        },
                        mode: function(){
                        	return ""
                        }
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('exposure-sub-type-edit', {
            parent: 'exposure-sub-type',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-sub-type/exposure-sub-type-dialog.html',
                    controller: 'ExposureSubTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	 entity: ['ExposureSubType', 'GlobalValues', function(ExposureSubType, GlobalValues) {
                             return ExposureSubType.get({id : $stateParams.id}).$promise;
                         }],
                         mode: function(){
                         	return ""
                         }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('exposure-sub-type-view', {
            parent: 'exposure-sub-type',
            url: '/view/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-sub-type/exposure-sub-type-dialog.html',
                    controller: 'ExposureSubTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	 entity: ['ExposureSubType', 'GlobalValues', function(ExposureSubType, GlobalValues) {
                             return ExposureSubType.get({id : $stateParams.id}).$promise;
                         }],
                         mode: function(){
                         	return "VIEW"
                         }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('exposure-sub-type-todolist', {
            parent: 'dashboard',
            url: '/exposureSubType',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-sub-type/exposure-sub-type-dialog.html',
                    controller: 'ExposureSubTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        mode: function(){
                        	return ""
                        }
                    }
                }).result.then(function() {
                	$state.go('exposure-sub-type', null, { reload: 'exposure-sub-type' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('exposure-sub-type-todolist-resubmit', {
            parent: 'dashboard',
            url: '/exposureSubTypeEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-sub-type/exposure-sub-type-dialog.html',
                    controller: 'ExposureSubTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
	                      entity: function () {                       	
	                          
	                      },
	                      mode: function(){
	                      	return ""
	                      }
                    }
                }).result.then(function() {
                	$state.go('exposure-sub-type', null, { reload: 'exposure-sub-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('exposure-sub-type-auditLog', {
            parent: 'audit-log',
            url: '/exposureSubTypeAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-sub-type/exposure-sub-type-dialog.html',
                    controller: 'ExposureSubTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        mode: function(){
                        	return ""
                        }
                    }
                }).result.then(function() {
                	$state.go('exposure-sub-type', null, { reload: 'exposure-sub-type' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('exposure-sub-type-historyReport', {
            parent: 'history-report',
            url: '/exposureSubTypeHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-sub-type/exposure-sub-type-dialog.html',
                    controller: 'ExposureSubTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        mode: function(){
                        	return ""
                        }
                    }
                }).result.then(function() {
                	$state.go('exposure-sub-type', null, { reload: 'exposure-sub-type' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ExposureSubType', ExposureSubType);

    ExposureSubType.$inject = ['$resource'];

    function ExposureSubType ($resource) {
        var resourceUrl =  'api/exposure-sub-type/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/exposure-sub-type'
        	 },
         	
             'getAllExposureSubTypes':{
                 isArray: true,
                 url: 'api/all-exposure-sub-types',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },

             'getEnabledExposureSubTypes':{
                 isArray: true,
                 url: 'api/enabled-exposure-sub-types',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },

             'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
             'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/exposure-sub-type/orgId/:orgId',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
        	
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/exposure-sub-type/orgId/:orgId',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/exposure-sub-type',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'exposureSubType'
        })
        
        .controller('ExposureSubTypeController', ExposureSubTypeController);

    ExposureSubTypeController.$inject = ['$scope', '$state', '$rootScope','ExposureSubType', 'GlobalValues', 'workflowSharedService', 
    'EntityPermissions', 'ScreenLog', 'entityConstants', '$timeout', 'IntradayMarket', 'MessageBox', 'validateSODAndSession','Auth'];

    function ExposureSubTypeController($scope, $state, $rootScope, ExposureSubType, GlobalValues, workflowSharedService, 
      EntityPermissions, ScreenLog, entityConstants, $timeout, IntradayMarket, MessageBox, validateSODAndSession,Auth) {
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.EXPOSURE_SUB_TYPE;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "exposureSubType";
        $scope.refresh=refresh;
        vm.validateSODAndSession = validateSODAndSession;
        
        vm.launch=launch;
        vm.editExposureSubType=editExposureSubType;
        function launch() {
          if(vm.marketSessionSettings.sessionStatus=='OPEN'){
            MessageBox.openMessageBox("Alert", "Addition/Modification is permitted only after the IB.SPOT market hours...!", "Ok", "exposuresubtype");
          }else if(!vm.validateSODAndSession.allowToAddOrEdit){
            MessageBox.openMessageBox("Alert", "SOD is completed for the business day, addition/modifications is not permitted.", "Ok", "exposuretype");
          }else{
            $state.go("exposure-sub-type-new");  
          }
        }

        function editExposureSubType(exposureSubTypeId){
          if(vm.marketSessionSettings.sessionStatus=='OPEN'){
            MessageBox.openMessageBox("Alert", "Addition/Modification is permitted only after the IB.SPOT market hours...!", "Ok", "exposuresubtype");
          }else if(!vm.validateSODAndSession.allowToAddOrEdit){
            MessageBox.openMessageBox("Alert", "SOD is completed for the business day, addition/modifications is not permitted.", "Ok", "exposuretype");
          }else{
            vm.screenLog.screenLog(vm.screenName, exposureSubTypeId, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
            $state.go("exposure-sub-type-edit", {id:exposureSubTypeId});
          }
        }
        
        vm.permitExposureSubTypeAddEntityAction = EntityPermissions.hasPermission('ExposureSubType.CREATE');
        vm.permitExposureSubTypeEditEntityAction = EntityPermissions.hasPermission('ExposureSubType.EDIT');
        vm.permitExposureSubTypeViewEntityAction = EntityPermissions.hasPermission('ExposureSubType.VIEW');
       /* if(vm.permitExposureSubTypeViewEntityAction ==false){
          //message box 
          MessageBox.openMessageBox('Alert', 'Session expired. You will be redirected to login page...!', 'Ok', 'permitExposureSubTypeViewEntityAction');
        }
    
        $rootScope.$on('gatewayApp.messagebox.ok.permitExposureSubTypeViewEntityAction', function (event) {
          Auth.sessionlogout();
        });
        
        $rootScope.$on('gatewayApp.messagebox.clear.permitExposureSubTypeViewEntityAction', function (result){
          Auth.sessionlogout();
        })*/
        
        logScreenAccess();
        loadAll();

       function loadAll() {
    	   
    	   ExposureSubType.getAllExposureSubTypes(function(result) {
               vm.exposureSubTypes = result;                
           });
    	 
        }      
       
        //get market session settings.
        IntradayMarket.getIntradayMarketSessionSettingsForInstrument({"instrument":'InterbankSPOT'}, onGetMarketSessionSuccess, onGetMarketSessionFailure);

        function onGetMarketSessionSuccess(result){
          vm.marketSessionSettings = result;
        }

        function onGetMarketSessionFailure(){

        }

       function logScreenAccess(){
    	   ScreenLog.screenLog(vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ExpiryTimeController', ExpiryTimeController);

    ExpiryTimeController.$inject = ['$scope', '$rootScope', '$state',  '$uibModalInstance', '$filter', '$stateParams'];

    function ExpiryTimeController($scope, $rootScope, $state, $uibModalInstance, $filter, $stateParams) {
        var vm = this;
        vm.clear=clear;
        vm.add=add;
        $scope.clicked=false;
        vm.closeTime = $stateParams.closeTime;
        fillDefaultTime();
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        
        function add(){
        	//validateExpiryTime();
        	if(!validateExpirtyTime()){
        		
        	}else{
            	formatExpiryTime();
            	$rootScope.expiryTime = vm.expiryTime;
            	$uibModalInstance.close();
            	$scope.$emit('addExpiryTime');
        	}
        }
        
        function fillDefaultTime(){
        	vm.currentDate = new Date();
        	vm.expiryDateTime = addMinutes(vm.currentDate, 1);
        }
        
        function addMinutes(date, minutes) {
            return new Date(date.getTime() + minutes*60000);
        }
        
        function validateExpirtyTime(){
        	vm.currentDate = new Date();
        	vm.currentTime = moment(vm.currentDate, 'HH:mm').format( 'HH:mm');
        	
        	vm.expiryTime = moment(vm.expiryDateTime, 'HH:mm').format( 'HH:mm');
        	
        	if(vm.expiryTime==null || vm.expiryTime==undefined || vm.expiryTime==''){
        		vm.errorSting = 'Invalid expiry time';
        		return false;
        	}
        	
        	if(vm.expiryTime.split(':')[0] < vm.currentTime.split(':')[0]){
        		vm.errorString = 'Expiry time should be greater than current time.';
        		return false;
        	}else if(vm.expiryTime.split(':')[1] < vm.currentTime.split(':')[1]){
        		vm.errorString = 'Expiry time should be greater than current time.';
        		return false;
        	}
        	
        	if(vm.expiryTime.split(':')[0] < vm.currentTime.split(':')[0]){
        		vm.errorString = 'Expiry time should be greater than current time.';
        		return false;
        	}else if(vm.expiryTime.split(':')[1] < vm.currentTime.split(':')[1]){
        		vm.errorString = 'Expiry time should be greater than current time.';
        		return false;
        	}
        	return true;
        }
        
        function formatExpiryTime(){
        	vm.expiryTime = moment(vm.expiryDateTime, 'HH:mm').format( 'HH:mm');
        	var expiryTimeInString = "";
        	if(vm.expiryTime.split(':').length>1){
            	expiryTimeInString = vm.expiryTime.split(':')[0] + vm.expiryTime.split(':')[1] + '00';
            	var todayDateString = $filter('date')(new Date(),'yyyy-mm-dd');
            	todayDateString = todayDateString.replace('-', '');
            	expiryTimeInString = todayDateString + expiryTimeInString;
        	}
        	vm.expiryTime = expiryTimeInString;
        }
    }   
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ErrorMessages', ErrorMessages);

    ErrorMessages.$inject = ['$resource'];

    function ErrorMessages ($resource) {
        var resourceUrl =  'api/error-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            
            'getErrorMessageForCode': {
                method: 'GET',
                params: {code:'@code'},
                url: 'api/error-message-for-code/:code',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
	'use strict';

	angular
		.module('gatewayApp')
		.controller('EodProcessNewController', EodProcessNewController);

	EodProcessNewController.$inject = ['$scope', '$state', '$stateParams', '$rootScope', 'GlobalValues', 'DateUtils', 'AlertService','EODProcess','MessageBox',
            '$filter','$timeout', 'ScreenLog','entityConstants','StaticLookUp','SODProcess', '$interval', '$fileLogger', 'FileUtil','EntityPermissions','Auth'];

	function EodProcessNewController($scope, $state, $stateParams, $rootScope, GlobalValues, DateUtils, AlertService,EODProcess,MessageBox,
            $filter,$timeout , ScreenLog,entityConstants,StaticLookUp, SODProcess, $interval, $fileLogger, FileUtil,EntityPermissions,Auth) {

		var vm = this;
		vm.todayDate;
		vm.nextDate;
		vm.currentBusinessDate;
		vm.nextBusinessDate;
		$fileLogger.setTimestampFormat('dd-MMM-yyyy HH:mm:ss:sss', '+0530');
		$fileLogger.info('eod screen accessed');
		vm.globalValues = GlobalValues;
		vm.beginEODProcess = beginEODProcess;		
		var convertedNextBusinessDate ;
		var convertedCurrentBusinessDate ;
		$scope.refresh = refresh;
		vm.today = new Date();
		vm.convertedTodayDate = DateUtils.convertLocalDateToServer(vm.today);
		vm.validateEod = validateEod;
		vm.validateInteractiveServerDbProcessing = validateInteractiveServerDbProcessing;
		vm.validateBroadcastServerDbProcessing = validateBroadcastServerDbProcessing;
		vm.isEODvalidated=false;
		vm.validation=vm.NOTSTARTED;
		vm.validateBroadcastDBProcessing=vm.NOTSTARTED;
		vm.validateInteractiveDBProcessing=vm.NOTSTARTED;
		vm.hideCheckList=false;
		vm.showEodProcess=false;
		vm.eodDone=false;
		vm.disbleEod = true;
		vm.eodStatus='';
		vm.isRefreshDisabled=false;
		vm.isEodProcessSuccessfull=null;
		vm.isEodCompletedForOrder=false;
		vm.isEodCompleted = false;
		vm.processStatusMap = {};
		vm.newProcessStatusMap = {};
		vm.today = new Date();
		vm.errorMessage = "";
		vm.logOffId = 0;
		vm.reconOrderReqId = 0;
		vm.reconOrderResponseId = 0;
		vm.reconTradeReqId = 0;
		vm.reconTradeResId = 0;
		vm.userLogoffReqId = 0;
		vm.userLogoffResponseId = 0;
		vm.luddlogOffReq = 0;
		vm.luddlogoffRespnse = 0;
		vm.disconnectinteractiveId = 0;
		vm.disconnectboradcastId = 0;
		vm.clearRvId = 0;
		vm.dormantId = 0;
		vm.autowithdrawalId = 0;
		vm.eodId = 0;
		vm.limitId = 0;
		vm.archiveId = 0;
		vm.shiftDateId = 0;
		vm.prepareNextdateDataId = 0;
		vm.logOffEndId = 0;
		vm.dailyTransactionId = 0;
		vm.monthEndBillingId = 0;
		vm.yearEndBillingId = 0;
		vm.holidayRequestId = 0;
		vm.holidayResponseId = 0;
		vm.updateTradingBranchId = 0;
		vm.sessionCloseMessage = "";
		vm.sessionCloseValidation = "";
		vm.responseReceivedValidation = "";
		vm.responseReceivedMessage="";
		vm.idArray = [];
		vm.autoRefreshToggle = null;
		
		vm.connectToMQID = 0;
		vm.executionCount = 0;
		vm.revokeProcessId;
		vm.eodProcessList = [];
		vm.eodProcessListFromDB = [];
		vm.newProcessResultMap = {};
		vm.processResultMap = {};
		vm.processErrorMap = {};
		vm.newProcessErrorMap = {};
		vm.errorList = {};
		var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
		vm.processId;
		vm.showResumeButton=false;
		var orderServiceEODProcessUpdateSubscription = null;
		var autoRefreshInterval = vm.globalValues.getConfigSettings().intervalBetweenFetchEODStatusLog;
		vm.orderProcessIds = [2,4,23,25,6,8,10,11,12];
		
		
		/* Constants to be used in HTML file for displaying progress icons */

		vm.INPROGRESS = "INPROGRESS";
		vm.COMPLETED = "COMPLETED";
		vm.FAILED = "FAILED";
		vm.NOTSTARTED = "NOTSTARTED";
		vm.OPEN = "TO_BE_INITIATED";
		vm.INCOMPLETE = "INCOMPLETE";
		vm.permitEODProcessAddEntityAction = EntityPermissions.hasPermission('EODProcess.CREATE');
		
		
		
		logScreenAccess();
		loadDates();
		loadErrorMEssages();
	
		/* set Intial State and initial status for each process and load the new businessDates */
		function loadDates() {
			SODProcess.getCurrentBusinessDate(loadSystemSettingsSuccess, loadSystemSettingsError);
		}
		
		function loadSystemSettingsSuccess(result){
			vm.lastSystemSetting = result;
			vm.eodStatus=vm.lastSystemSetting.eodStatus;
			vm.currentBusinessDate = DateUtils.convertLocalDateFromServer(vm.lastSystemSetting.businessDate);
			vm.todayDate = $filter('date')(vm.currentBusinessDate,"dd/MM/yyyy");
			vm.todayDate = vm.todayDate + " | " + days[vm.currentBusinessDate.getDay()];
			convertedCurrentBusinessDate = DateUtils.convertLocalDateToServer(vm.currentBusinessDate);
            $fileLogger.info('loadSystemSettingsSuccess - getNextValidBusinessDate');
			EODProcess.getNextValidBusinessDate( {
				"currentBusinessDate" : convertedCurrentBusinessDate
			} , getNextBusinessDateSuccess, getNextBusinessDateError);
			vm.disbleEod = disableEodProcess();
			// load all eod work flow items
			loadWorkFlowItems();
		}
		function loadSystemSettingsError(){
			
		}
		// Set Initial status as NOTSTARTED for each process on page laod /
		
		 function loadWorkFlowItems(){
       	 StaticLookUp.getEodWorkFlow(lookupWorkFlowSuccess, lookupWorkFlowFailure);
        }
        function lookupWorkFlowSuccess(result){
        	
        	vm.eodProcessListFromDB = result;
        	vm.eodProcessList = [];
        	console.log(vm.eodProcessListFromDB );
        	vm.idArray = [];
        	angular.forEach(vm.eodProcessListFromDB, function(item){               
                vm.idArray.push( item.id);               
            });
        	
   	    	vm.eodProcessList = angular.copy(vm.eodProcessListFromDB);   	    	
   	    	
   	   
          	if(vm.eodStatus == vm.OPEN || vm.eodStatus==vm.INCOMPLETE || vm.eodStatus==vm.INPROGRESS){
          		
          		 angular.forEach( vm.eodProcessList, function(item){
          		 
	          		 if(item.processName=='ForciblelogoffUsers'){
	          			 vm.logOffId = item.id;
	          		 }else if(item.processName=='ReconOrderDetailsRequest'){
	          			 vm.reconOrderReqId = item.id;
	          		 }       		 
	          		 else if(item.processName=='MakeUsersDormant'){
	        			 vm.dormantId=item.id;
	          		 }
	          		 else if(item.processName=='AutowithdrawalOfPendingApprovalCustomers'){
	        			 vm.autowithdrawalId=item.id;
	        		 }
	          		 else if(item.processName=='GenerateEODEmails'){
	        			 vm.eodId=item.id;
	        		 }
	          		 else if(item.processName=='ProcessLimitsAtEOD'){
	        			 vm.limitId=item.id;
	        		 }
	          		 else if(item.processName=='ArchiveTablesAtEOD'){
	          			 vm.archiveId=item.id;
	          		 }
	          		 else if(item.processName=='ComputeDailyTransactionCharges'){
	          			vm.dailyTransactionId=item.id;
	          		 }
	          		 else if(item.processName=='GenerateMonthEndBillingReport'){
	          			vm.monthEndBillingId=item.id;
	          		 }
	          		 else if(item.processName=='GenerateYearEndBillingReport'){
	          			vm.yearEndBillingId=item.id;
	          		 }	
	          		 else if(item.processName=='UpdateNewTradingBranchForCustomers'){
	          			vm.updateTradingBranchId=item.id;
	          		 }
	          		 else if(item.processName=='ShiftingTheSystemDate'){
	          			vm.shiftDateId=item.id;
	          		 }
	          		 else if(item.processName=='PrepareNextBusinessDateData'){
	          			vm.prepareNextdateDataId=item.id;
	          		 }	          		 
	          		 item.status = vm.NOTSTARTED;
	          		 item.remarks='';	       		
	          		 vm.newProcessResultMap[item.id] = null;
	          		 vm.processResultMap[item.id] = null;
	          		 vm.processErrorMap[item.id] = null;
	          		 vm.newProcessErrorMap[item.id] = null;
          		 });
          	}
          	if(vm.eodStatus==vm.INPROGRESS || vm.eodStatus==vm.INCOMPLETE){
                $fileLogger.info('lookupWorkFlowSuccess getEODProcessStatusLog');
          		 EODProcess.getEODProcessStatusLog({
    				"businessDate" : convertedCurrentBusinessDate
    			} ,getEODProcessStatusLogSuccess,getEODProcessStatusLogFailure);
          		vm.showResumeButton=true;
          		vm.showEodProcess=true;
          		vm.isEODvalidated=true;
          	 }
        
        }
        
	function getEODProcessStatusLogSuccess(result){
		
		var processIndex = vm.idArray.indexOf(result.processId);
   		angular.forEach(vm.eodProcessList,function(item,index){
   			if(index < processIndex)
   			item.status = vm.COMPLETED;
   		})
		
	}
	
	function getEODProcessStatusLogFailure(){}
	
        
        
        function lookupWorkFlowFailure(error){
       	 //do nothing
        }
        
        //END//
		// FETCH ERROR MESSAGE AND SET TO GLOBAL VARIABLE/
         function loadErrorMEssages(){
        	 StaticLookUp.getProcessErrorMessages(loadErrorMEssagesSuccess, loadErrorMEssagesFailure);
         }
         function loadErrorMEssagesSuccess(result){
        	        	
        	 vm.errorList  = result[0];
         }
         function loadErrorMEssagesFailure(error){
        	 //do nothing
         }

		 
         // get all eod process log
		function getAllEODProcessStatusLog(){
    				
					EODProcess.getAllEODProcessStatusLog({"businessDate" : convertedCurrentBusinessDate},getAllEODProcessStatusLogSuccess,getAllEODProcessStatusLogFailure);
		}
		//success - get all eod process log
		function getAllEODProcessStatusLogSuccess(result) {
			vm.eodStatusLogList = result;
			angular.forEach(vm.eodStatusLogList, function(value,index){
						 var indexOfRevokeProcess = vm.idArray.indexOf(value.process.id);
						var item = vm.eodProcessList[indexOfRevokeProcess];
						var nextItem = vm.eodProcessList[indexOfRevokeProcess+1];
						 if(item.status == vm.NOTSTARTED || item.status == vm.INPROGRESS){
							if(value.isCompleted==true){
								item.remarks = "";
								item.status = vm.COMPLETED;
								if(item.processName=='EODStatusUpdateProcess'){
									vm.eodDone=true;
									eodStatusLogDownload();
								 }
								 updateRemarksInProcessList(nextItem.id ,"",   vm.INPROGRESS);
							}else{
								item.remarks = value.errorMessage;
								item.status = vm.FAILED;
								stopAutoRefresh();
								eodErrorStatusLogDownload(item, value.errorMessage);
							}
						}
						
								
			});
			
		}

		function getAllEODProcessStatusLogFailure(result) {
			// nothing 
		}

      // function to start the EOD process on start/resume button click
 		function beginEODProcess(actionType) {
 			 $fileLogger.info(actionType + ' Clicked');
 			vm.isRefreshDisabled = false;
 			vm.showEodProcess=true;
 			vm.isEodProcessSuccessfull=null;
 			vm.isEodCompleted = false;
 			
 			if(vm.currentBusinessDate !=null && vm.currentBusinessDate !=undefined && vm.currentBusinessDate !=''){
 				if ( vm.currentBusinessDate > vm.today ) {
 					
 					AlertService.error($filter('translate')('gatewayApp.eodProcess.forwardDateError'));
 					
 				}else if(vm.eodStatus == vm.COMPLETED){
 					AlertService.error($filter('translate')('gatewayApp.eodProcess.alreadyCompleted'));
 				}
 				else {
 					//call the  process
					$rootScope.eodInProgress = true;
 					processeod();

 				}
 			}
 			

 		}
        
 		// Process methods before starting the eod process /
		var processeod = function processeod(){
				vm.executionCount = vm.executionCount+1;
				if(vm.eodStatus == vm.INCOMPLETE || vm.eodStatus == vm.INPROGRESS ){
					$fileLogger.info('updateEODPRocessLog');
					EODProcess.updateEODPRocessLog({"businessDate" : convertedCurrentBusinessDate},updateEODLogSuccess, updateEODLogFailure);
				}else{
                $fileLogger.info('processEOD');
				updateRemarksInProcessList(vm.logOffId ,"",   vm.INPROGRESS);
           		 $fileLogger.info('logOffUsersForcibly');
				EODProcess.initiateEODProcess( {				
				"businessDate" : convertedCurrentBusinessDate,
				"status" : vm.OPEN ,
				"nextBusinessDate": convertedNextBusinessDate,
				"processId" : vm.logOffId,
				"executionCount" : vm.executionCount
				}, initialEODProcessSucess, initialEODProcessError);
			}
			
		}
		
		function clearPreviousStatus(){
			
			var indexOfRevokeProcess = vm.idArray.indexOf(vm.revokeProcessId);
			 
			 angular.forEach(  vm.eodProcessList, function(item,index){
				 if(index >= indexOfRevokeProcess){
					 item.status = vm.NOTSTARTED;
					 item.remarks='';
					 vm.processResultMap[ item.id] = null;	
				 }else{
					item.status = vm.COMPLETED;
					item.remarks='';
				 }
			 });
		}
	
		function updateEODLogSuccess(result){
			vm.executionCount = parseInt(result.executionCount);
			vm.executionCount = vm.executionCount+1;
			vm.revokeProcessId = parseInt(result.revokeProcessId);
			$fileLogger.info('updateEODLogSuccess execution count -' + vm.executionCount + ' vm.revokeProcessId' + vm.revokeProcessId);
			clearPreviousStatus();
			if(vm.eodStatus == vm.INPROGRESS && vm.revokeProcessId != vm.dormantId && vm.revokeProcessId != vm.logOffId){
					
					AlertService.error($filter('translate')('gatewayApp.eodProcess.alreadyInProgress'));
			}else{
			
				vm.eodStatus = vm.INPROGRESS ;
				vm.disbleEod = true;	
				console.log('EOD procss resumed with process id '+ vm.revokeProcessId);
				$fileLogger.info('EOD procss resumed with process id' + vm.revokeProcessId);
				$fileLogger.info('current execution Count', vm.executionCount);
				if(vm.orderProcessIds.includes(vm.revokeProcessId)){
					successProcessor(startEODInOrderService);
				}else if(vm.revokeProcessId == vm.logOffId){
					updateRemarksInProcessList(vm.logOffId ,"",   vm.INPROGRESS);
					EODProcess.initiateEODProcess( {				
						"businessDate" : convertedCurrentBusinessDate,
						"status" : vm.INPROGRESS ,
						"nextBusinessDate": convertedNextBusinessDate,
						"processId" : vm.revokeProcessId,
						"executionCount" : vm.executionCount
						}, initialEODProcessSucess, initialEODProcessError);
				}
				else{
				updateRemarksInProcessList(vm.revokeProcessId ,"",   vm.INPROGRESS);
				EODProcess.initiateEODProcess( {				
					"businessDate" : convertedCurrentBusinessDate,
					"status" : vm.INPROGRESS ,
					"nextBusinessDate": convertedNextBusinessDate,
					"processId" : vm.revokeProcessId,
					"executionCount" : vm.executionCount
					}, processeodEndSucess, processeodEndError);
				}
			}
		}
		
		function updateEODLogFailure(){
			
		}
		

		function initialEODProcessSucess(result){
			
				updateRemarksInProcessList(vm.logOffId ,"",  vm.COMPLETED);
			  //clear revokeProcessId before starting the EOD process in OPS. 
			  vm.revokeProcessId = null;
				vm.eodStatus = vm.INPROGRESS ;
				vm.disbleEod = true;			
				successProcessor(startEODInOrderService);
			
		}
		
		
		function initialEODProcessError(error){
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.logOffId ,errorCode , vm.FAILED );
			AlertService.error( errorCode );
		}
		
		
		function updateRemarksInProcessList(processID, errorMessage, status){
			var indexOfRevokeProcess = vm.idArray.indexOf(processID);
			var item = vm.eodProcessList[indexOfRevokeProcess];
			item.remarks = errorMessage;
			item.status = status ;
			//download log file whenever any process is failed.
			if(status==vm.FAILED){
				eodErrorStatusLogDownload(item, errorMessage);
			}
		}
		
		
		
		function eodErrorStatusLogDownload(item, errorMessage) {
			$fileLogger.info('EOD stopped in ' + item.processName);
			vm.isEodProcessSuccessfull=false;
			vm.showResumeButton=true;
			$fileLogger.info(errorMessage);
			$timeout(function () {
				$rootScope.eodInProgress = false;
				FileUtil.downloadLogFile("FXRetail_EOD_Process");
			}, 1000);
		}

		 function disableEodProcess(){
		    	
		    	if(vm.currentBusinessDate ==undefined || vm.currentBusinessDate == null || vm.currentBusinessDate == ''){
		    		// no valid businessdate - disable start button
		    		return true;
		    	}else if(vm.eodStatus ==vm.OPEN || vm.eodStatus==null || vm.eodStatus==undefined ||vm.eodStatus==''){
		    		// eodStatus is open for the business date then enable start button
		    		vm.isRefreshDisabled=true;
		    		return false;
		    	}else if( vm.eodStatus ==vm.INCOMPLETE){
		    		
		    		vm.isRefreshDisabled=false;
		    		return false;
		    		
		    	}
		    	else if( (vm.eodStatus ==vm.INPROGRESS ) && !(vm.isEodProcessSuccessfull==null || vm.isEodProcessSuccessfull==false)){
		    		// enable start button when eodStatus is in in progress and eod process is not successful
		    		vm.isRefreshDisabled=false;
		    		return  false;
		    	}else if( vm.eodStatus ==vm.INPROGRESS  && (vm.isEodProcessSuccessfull==null || vm.isEodProcessSuccessfull==true)){
		    		// disable start button when sodStatus is in inprogress and sod process is  successfull
		    		vm.isRefreshDisabled=false;
		    		return true;
		    	}else if( vm.COMPLETED ==vm.eodStatus ){
		    		vm.isRefreshDisabled=true;
		    		return true;
		    	}
		    	
		    }
		 
		 
		
		
		function getNextBusinessDateSuccess(result) {
			vm.nextBusinessDate = DateUtils.convertLocalDateFromServer(result.date);
			vm.nextDate = $filter('date')(vm.nextBusinessDate,"dd/MM/yyyy");
			vm.nextDate = vm.nextDate + " | " + days[vm.nextBusinessDate.getDay()];
			convertedNextBusinessDate = DateUtils.convertLocalDateToServer(vm.nextBusinessDate);
		}
		function getNextBusinessDateError(error) {
		}
		
		

		
		
		
		
		
		/* begin EOD in order service */
		var startEODInOrderService = function startEODInOrderService(){
			var nextProcesss = vm.eodProcessList[1];
			if(vm.revokeProcessId==null){
	
				vm.processId = nextProcesss.id;
			}else{
				vm.processId = vm.revokeProcessId;
				
				nextProcesss = vm.eodProcessList[vm.idArray.indexOf(vm.revokeProcessId)];
			}
			console.log('next order server EOD process - ' + nextProcesss.id);
		
				updateRemarksInProcessList(vm.processId ,"",   vm.INPROGRESS);
				
				var eodRequest = {};
				eodRequest.executionCount = vm.executionCount;
				eodRequest.businessDate = convertedCurrentBusinessDate;
				eodRequest.startingProcessID =  vm.processId;

                $fileLogger.info('initiateEODInOrderService');
				EODProcess.initiateEODInOrderService(eodRequest,
					startEODInOrderServiceSuccess, startEODInOrderServiceFailure);
		}

		function startEODInOrderServiceSuccess(result){
			//do nothing as this is async call
            
			$fileLogger.info('initiateEODInOrderService success');
			
		}
		function startEODInOrderServiceFailure(error){
			
			// EOD Failure
			var errorCode = errorProcessor(error);
			$fileLogger.info('initiateEODInOrderService failed ' + errorCode);
			updateRemarksInProcessList(vm.processId ,"",  vm.FAILED);
            $fileLogger.info('processEOD called again in startEODInOrderServiceFailure');
			EODProcess.processEOD( {				
				"businessDate" : convertedCurrentBusinessDate,
				"status" : vm.INCOMPLETE,
				"nextBusinessDate" : convertedNextBusinessDate
			},  processENDEODSucess, processENDEODError);
			AlertService.error( errorCode );
		}
		/*  END */
		
		
		
		
		
		
		/*General method used in all process */
		function successProcessor(successProcessToInvoke){
			
			if(vm.isEodProcessSuccessfull == null || vm.isEodProcessSuccessfull == true){
				// next process is invoked only when previous one is is successful
				if(successProcessToInvoke!=null)
					successProcessToInvoke();
			}
		}
		

		function errorProcessor(error){		
			var errorcode = "";
			if( error.message !=undefined &&  error.message !=null &&  error.message!=""){
				errorcode  = $filter('translate')( error.message ) //+  error.businessDate;				
				//vm.errorMessage = error.exceptionMessage +  errorcode ;
			}else if( !(error.data==undefined || error.data==null || error.data=='')){
				errorcode  = $filter('translate')( error.data.message );
				//vm.errorMessage = error.data.exceptionMessage +" "+  errorcode;
			}else{
				errorcode = $filter('translate')( "Service unavailable");
			}
			 		
			//AlertService.error( errorcode );
			vm.isEodProcessSuccessfull=false;
			return errorcode;
		}
		
		

		// Watch for Process failure through the isEodProcessSuccessfull flag , if it is failed log the status, if it true do nothing
		 $scope.$watch('vm.isEodProcessSuccessfull', function(value){
				if(value!=null && value!=undefined && value == false){
	               
					//method to enable or disable start button if process is unsuccessfull
					vm.eodStatus = vm.INCOMPLETE;
					vm.disbleEod = disableEodProcess();
					
				}
			
				});
	
	
		 orderServiceEODProcessUpdateSubscription = $rootScope.$on("orderServiceEODProcessUpdate", function(event,result){
			 $fileLogger.info(" websocket message orderServiceEODProcessUpdate recevied for process id " + result.processID + "status " +result.success );
		    	if( result.success!=vm.processResultMap[result.processID]){
		    
		    		processStatusNotificationFromOrderService(result);
		    	}else if( result.success==false && result.exceptionNumber!=vm.processErrorMap[result.processID]){
		    		//update new error code
		    		processStatusNotificationFromOrderService(result);
		    	}
		    	
	         });
	  
      function unsubscribeToEODProcessUpdate(){
          if(orderServiceEODProcessUpdateSubscription!=null){
              // unscribe to order service update notification
              orderServiceEODProcessUpdateSubscription();
          }
      }
      var webscoketDisconnect = $rootScope.$on("websocketDisconnected", function(event,result){
	    	
	    	console.log("web socket disconnected with reason " + result);
	    	 $fileLogger.info("web socket disconnected with reason " + result);
	    	var logOffIndex = vm.idArray.indexOf(vm.logOffId);
	    	var dormantIndex = vm.idArray.indexOf(vm.dormantId);
	    	angular.forEach( vm.eodProcessList, function(item,index){
	    		// set the status as failed only for order service process when websocket disconnection occurs
	    		
	   		 	if(item.status == vm.INPROGRESS && index > logOffIndex && index < dormantIndex){
	   		 		item.status = vm.FAILED;
	   		 		item.remarks=vm.errorList["7001"].rejectionReason;
	   		 	}
	    		
	    	
	    	});
	    	
     });
	    $scope.$on('$destroy', function() {
	        	unsubscribeToEODProcessUpdate();	        	
	        	if(webscoketDisconnect!=null){
	  			  webscoketDisconnect();
	  		  }	
	    });
		
		function processENDEODSucess(result){			
		    	
				
		}
		function processENDEODError(error){
			//DO NOthing
		}
		   
		    
		function eodStatusLogDownload() {
			stopAutoRefresh();
			AlertService.success($filter('translate')('gatewayApp.eodProcess.eodProcesscompleted') + $filter('date')(vm.currentBusinessDate, "dd-MMM-yyyy"));
			$timeout(function () {
				$rootScope.eodInProgress = false;
				FileUtil.downloadLogFile("FXRetail_EOD_Process");
			}, 1000);
		}

		    
			
		
		
		function stopAutoRefresh() {
			if (angular.isDefined(vm.autoRefreshToggle)) {
				$interval.cancel(vm.autoRefreshToggle);
				vm.autoRefreshToggle = undefined;
			}
		}

			function processStatusNotificationFromOrderService(processStatus){
				

					var indexOfProcess =  vm.idArray.indexOf(processStatus.processID);
					var item = vm.eodProcessList[indexOfProcess];
					console.log("notification received from order service for process "+ processStatus.processID);
							if(item.id==processStatus.processID &&  processStatus.success==true ){
							item.status = vm.COMPLETED;
							item.remarks = "";
							var keyArray = vm.idArray
							var index = keyArray.indexOf(processStatus.processID);
							var nextIndex = index+1;
							if(nextIndex < keyArray.length){
								var nextProcess = vm.eodProcessList[nextIndex];
								if(nextProcess!=undefined && nextProcess!=null && nextProcess!='' && nextProcess.status!= vm.COMPLETED && nextProcess.status!= vm.FAILED){
									nextProcess.status = vm.INPROGRESS ;
									
								}
								if(item.processName == 'DisconnectBroadcastMQChannel' && !vm.isEodCompletedForOrder){
									console.log('received DisconnectBroadcastMQChannel completion message');
									vm.isEodCompletedForOrder  = true;
									
									 $fileLogger.info('calling to start from make user dormant method - from processStatusNotificationFromOrderService');
									// call rest of the eod process in QRS
									EODProcess.initiateEODProcess( {				
										"businessDate" : convertedCurrentBusinessDate,
										"status" : vm.INPROGRESS ,
										"nextBusinessDate": convertedNextBusinessDate,
										"processId" : vm.dormantId,
										"executionCount" : vm.executionCount
										}, processeodEndSucess, processeodEndError);
								}
								
							}
				
						vm.processResultMap[processStatus.processID] = processStatus.success;
						vm.processErrorMap[processStatus.processID] = null;
					   
				   
				   }else if(item.id==processStatus.processID &&  processStatus.success==false){
							
					   item.status = vm.FAILED;
					   item.remarks = "Process Failed";
					   vm.isEodProcessSuccessfull = false;			
					   var errorKey = processStatus.exceptionNumber+""+processStatus.messageNumber;
				   
					   if( vm.errorList[errorKey]!=null && vm.errorList[errorKey]!=undefined 
							   && vm.errorList[errorKey]!='' ){
						   item.remarks =  vm.errorList[errorKey].rejectionReason;
						   
					   }

						vm.processResultMap[processStatus.processID] = processStatus.success;
						vm.processErrorMap[processStatus.processID] = processStatus.exceptionNumber;
					   
				   }
				
					 
			}
			function processeodEndSucess(result){
				
				vm.autoRefreshToggle = $interval(function() {
					getAllEODProcessStatusLog();
						
					}, autoRefreshInterval);
			}
			function processeodEndError(result){

			}		
		
		/* Refresh*/
		  $scope.toggle = true;
	        function refresh() {
				$fileLogger.info('eod screen refreshed');
	            $scope.toggle = false;
	            $scope.refreshFlag = false;
	            loadDates();
	            if ($scope.toggle == false) {
	                $timeout(function() {
	                    $scope.toggle = true;
	                }, 2000);
	                $scope.refreshFlag = false;
	            }
	        };
		
		
	    function logScreenAccess(){
	           ScreenLog.screenLog( entityConstants.ENTITY_SHORT_NAME.EOD_PROCESS,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
	        }


	    /**Validate EOD process*/
	    function validateEod(){
	    	EODProcess.validateEOD(validateSuccess,validateFailure);
	    	vm.validation = vm.INPROGRESS;
	    }
	    
	    function validateSuccess(result){
	    	
	    	if(result.isValidated==true){
	    		vm.validation = vm.COMPLETED;
	    		vm.remarks="";
	    		validateSessionClose();
	    	}else{
	    		vm.validation = vm.FAILED;
	    		vm.remarks="Not processed";
	    	}
	    	
	    }
	    
	    function validateFailure(error){
	    	var errorCode = '';
	    	if(error.message!=null && error.message!=undefined && error.message!=''){
	    		errorCode = $filter('translate')(error.message);
	    	}
	    	vm.remarks=errorCode;
	    	vm.validation = vm.FAILED;
	    }
	    
	    function validateInteractiveServerDbProcessing(){
            $fileLogger.info('Validate Clicked');
	    	EODProcess.validateDBProcessing({"serverName" : "Interactive_Server"},validateInteractiveServerDbProcessingSuccess,validateInteractiveServerDbProcessingFailure);
	    	vm.validateInteractiveDBProcessing = vm.INPROGRESS;
	    }
	    
	    function validateInteractiveServerDbProcessingSuccess(result){
	    	vm.validateInteractiveDBProcessing = vm.COMPLETED;
    		vm.remarksForInteractiveServerDBProcessing="";
    		validateBroadcastServerDbProcessing();
	    	
	    }
	    
	    function validateInteractiveServerDbProcessingFailure(error){
	    	var errorCode = '';
	    	if(error.data.validationMsg!=null && error.data.validationMsg!=undefined && error.data.validationMsg!=''){
	    		errorCode = $filter('translate')(error.data.validationMsg);
	    	}
	    	vm.remarksForInteractiveServerDBProcessing=errorCode;
	    	vm.validateInteractiveDBProcessing = vm.FAILED;
	    }
	    
	    function validateBroadcastServerDbProcessing(){
	    	EODProcess.validateDBProcessing({"serverName" : "Broadcast_Server"},validateBroadcastServerDbProcessingSuccess,validateBroadcastServerDbProcessingFailure);
	    	vm.validateBroadcastDBProcessing = vm.INPROGRESS;
	    }
	    
	    function validateBroadcastServerDbProcessingSuccess(result){
	    	vm.validateBroadcastDBProcessing = vm.COMPLETED;
    		vm.remarksForBroadcastServerDBProcessing="";
    		validateResponseReceived();
	    }
	    
	    function validateBroadcastServerDbProcessingFailure(error){
	    	var errorCode = '';
	    	if(error.data.validationMsg!=null && error.data.validationMsg!=undefined && error.data.validationMsg!=''){
	    		errorCode = $filter('translate')(error.data.validationMsg);
	    	}
	    	vm.remarksForBroadcastServerDBProcessing=errorCode;
	    	vm.validateBroadcastDBProcessing = vm.FAILED;
	    }
	    
	    function validateResponseReceived(){
	    	vm.responseReceivedValidation = vm.INPROGRESS;
	    	vm.responseReceivedMessage="";
	    	EODProcess.validateResponseReceived(validateResponseReceivedSuccess,validateResponseReceivedFailure);
	    }
	    
	    function validateResponseReceivedSuccess(result){    	
	    	
	    	if( result.responseReceived==true){
	    		vm.responseReceivedValidation = vm.COMPLETED;
	    		vm.responseReceivedMessage="";
	    		validateEod();
	    		
	    	}else{
	    		vm.responseReceivedValidation = vm.FAILED;
	    		vm.responseReceivedMessage= "Not processed";
	    	}
	    	
    		
	    }
	    
	    function validateResponseReceivedFailure(error){
	    	var errorCode = '';
	    	if(error.data.validationMsg!=null && error.data.validationMsg!=undefined && error.data.validationMsg!=''){
	    		errorCode = $filter('translate')(error.data.validationMsg);
	    	}
	    	vm.responseReceivedMessage = errorCode;
	    	vm.responseReceivedValidation = vm.FAILED;
	    }
	    
	    
	    function validateSessionClose(){
	    	vm.sessionCloseValidation = vm.INPROGRESS;
	    	EODProcess.validateSessionClose({"currentBusinessDate" : convertedCurrentBusinessDate},validateSessionCloseSuccess,validateSessionCloseFailure);
	    	
	    }
	    
	    function validateSessionCloseSuccess(result){    	
	    	vm.isEODvalidated = result.isSessionClosed;
	    	if( result.isSessionClosed==true){
	    		vm.sessionCloseValidation = vm.COMPLETED;
	    		vm.sessionCloseMessage="";
	    		
	    	}else{
	    		vm.sessionCloseValidation = vm.FAILED;
	    		vm.sessionCloseMessage= $filter('translate')('gatewayApp.eodProcess.sessionCloseMessage');
	    	}
	    	
	    	
	    }
	    
	    function validateSessionCloseFailure(error){
	    	
	    	var errorCode = '';
	    	if(error.data.validationMsg!=null && error.data.validationMsg!=undefined && error.data.validationMsg!=''){
	    		errorCode = $filter('translate')(error.data.validationMsg);
	    	}
	    	vm.sessionCloseMessage=errorCode;
	    	vm.sessionCloseValidation = vm.FAILED;
	    }
	  
	    
		
	
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('start-eod-process', {
            parent: 'entity',
            params:{screen: 'EODProcess'},
            url: '/start-eod-process',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.EODProcess.eodProcess" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/eod-process/start-eod-process.html',
                    controller: 'EodProcessNewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
              
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('eodProcess');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

(function () {
	'use strict';

	angular
		.module('gatewayApp')
		.controller('EODProcessController', EodProcessController);

	EodProcessController.$inject = ['$scope', '$state', '$stateParams', '$rootScope', 'GlobalValues', 'DateUtils', 'AlertService','EODProcess','MessageBox',
            '$filter','$timeout', 'ScreenLog','entityConstants','StaticLookUp','SODProcess', '$interval', '$fileLogger', 'FileUtil','EntityPermissions','Auth'];

	function EodProcessController($scope, $state, $stateParams, $rootScope, GlobalValues, DateUtils, AlertService,EODProcess,MessageBox,
            $filter,$timeout , ScreenLog,entityConstants,StaticLookUp, SODProcess, $interval, $fileLogger, FileUtil,EntityPermissions,Auth) {

		var vm = this;
		vm.todayDate;
		vm.nextDate;
		vm.currentBusinessDate;
		vm.nextBusinessDate;
		$fileLogger.setTimestampFormat('dd-MMM-yyyy HH:mm:ss:sss', '+0530');
		$fileLogger.info('eod screen accessed');
		vm.globalValues = GlobalValues;
		vm.beginEODProcess = beginEODProcess;		
		var convertedNextBusinessDate ;
		var convertedCurrentBusinessDate ;
		$scope.refresh = refresh;
		vm.today = new Date();
		vm.convertedTodayDate = DateUtils.convertLocalDateToServer(vm.today);
		vm.validateEod = validateEod;
		vm.validateInteractiveServerDbProcessing = validateInteractiveServerDbProcessing;
		vm.validateBroadcastServerDbProcessing = validateBroadcastServerDbProcessing;
		vm.isEODvalidated=false;
		vm.validation=vm.NOTSTARTED;
		vm.validateBroadcastDBProcessing=vm.NOTSTARTED;
		vm.validateInteractiveDBProcessing=vm.NOTSTARTED;
		vm.hideCheckList=false;
		vm.showEodProcess=false;
		vm.eodDone=false;
		vm.disbleEod = true;
		vm.eodStatus='';
		vm.isRefreshDisabled=false;
		vm.isEodProcessSuccessfull=null;
		vm.isEodCompletedForOrder=false;
		vm.isEodCompleted = false;
		vm.processStatusMap = {};
		vm.newProcessStatusMap = {};
		vm.today = new Date();
		vm.errorMessage = "";
		vm.logOffId = 0;
		vm.reconOrderReqId = 0;
		vm.reconOrderResponseId = 0;
		vm.reconTradeReqId = 0;
		vm.reconTradeResId = 0;
		vm.userLogoffReqId = 0;
		vm.userLogoffResponseId = 0;
		vm.luddlogOffReq = 0;
		vm.luddlogoffRespnse = 0;
		vm.disconnectinteractiveId = 0;
		vm.disconnectboradcastId = 0;
		vm.clearRvId = 0;
		vm.dormantId = 0;
		vm.autowithdrawalId = 0;
		vm.eodId = 0;
		vm.limitId = 0;
		vm.archiveId = 0;
		vm.shiftDateId = 0;
		vm.prepareNextdateDataId = 0;
		vm.logOffEndId = 0;
		vm.dailyTransactionId = 0;
		vm.monthEndBillingId = 0;
		vm.yearEndBillingId = 0;
		vm.holidayRequestId = 0;
		vm.holidayResponseId = 0;
		vm.updateTradingBranchId = 0;
		vm.sessionCloseMessage = "";
		vm.sessionCloseValidation = "";
		vm.responseReceivedValidation = "";
		vm.responseReceivedMessage="";
		vm.idArray = [];

		
		vm.connectToMQID = 0;
		vm.executionCount = 0;
		vm.revokeProcessId;
		vm.eodProcessList = [];
		vm.eodProcessListFromDB = [];
		vm.newProcessResultMap = {};
		vm.processResultMap = {};
		vm.processErrorMap = {};
		vm.newProcessErrorMap = {};
		vm.errorList = {};
		var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
		vm.processId;
		vm.showResumeButton=false;
		var orderServiceEODProcessUpdateSubscription = null;
		
		
		/************* Constants to be used in HTML file for displaying progress icons ********************/

		vm.INPROGRESS = "INPROGRESS";
		vm.COMPLETED = "COMPLETED";
		vm.FAILED = "FAILED";
		vm.NOTSTARTED = "NOTSTARTED";
		vm.OPEN = "TO_BE_INITIATED";
		vm.INCOMPLETE = "INCOMPLETE";
		 vm.permitEODProcessAddEntityAction = EntityPermissions.hasPermission('EODProcess.CREATE');
		// if(vm.permitEODProcessAddEntityAction ==false){
		// 	//message box 
		// 	MessageBox.openMessageBox('Alert', 'Session expired. You will be redirected to login page...!', 'Ok', 'permitEODProcessAddEntityAction');
		// }

		// $rootScope.$on('gatewayApp.messagebox.ok.permitEODProcessAddEntityAction', function (event) {
		// 	Auth.sessionlogout();
		// });
		
		// $rootScope.$on('gatewayApp.messagebox.clear.permitEODProcessAddEntityAction', function (result){
		// 	Auth.sessionlogout();
		// })
		
		
		logScreenAccess();
		loadDates();
		loadErrorMEssages();
	
		/** set Intial State and initial status for each process and load the new businessDates *****/
		function loadDates() {
			SODProcess.getCurrentBusinessDate(loadSystemSettingsSuccess, loadSystemSettingsError);
		}
		
		function loadSystemSettingsSuccess(result){
			vm.lastSystemSetting = result;
			vm.eodStatus=vm.lastSystemSetting.eodStatus;
			vm.currentBusinessDate = DateUtils.convertLocalDateFromServer(vm.lastSystemSetting.businessDate);
			vm.todayDate = $filter('date')(vm.currentBusinessDate,"dd/MM/yyyy");
			vm.todayDate = vm.todayDate + " | " + days[vm.currentBusinessDate.getDay()];
			convertedCurrentBusinessDate = DateUtils.convertLocalDateToServer(vm.currentBusinessDate);
            $fileLogger.info('loadSystemSettingsSuccess - getNextValidBusinessDate');
			EODProcess.getNextValidBusinessDate( {
				"currentBusinessDate" : convertedCurrentBusinessDate
			} , getNextBusinessDateSuccess, getNextBusinessDateError);
			vm.disbleEod = disableEodProcess();
			
			/*if(vm.eodStatus == vm.COMPLETED){
					AlertService.error($filter('translate')('gatewayApp.eodProcess.alreadyCompleted'));
			}else if(vm.eodStatus == vm.INPROGRESS){
					
					AlertService.error($filter('translate')('gatewayApp.eodProcess.alreadyInProgress'));
			}*/
			loadWorkFlowItems();
		}
		function loadSystemSettingsError(){
			
		}
		/*********** Set Initial status as NOTSTARTED for each process on page laod *****************/
		
		 function loadWorkFlowItems(){
       	 StaticLookUp.getEodWorkFlow(lookupWorkFlowSuccess, lookupWorkFlowFailure);
        }
        function lookupWorkFlowSuccess(result){
        	
        	vm.eodProcessListFromDB = result;
        	vm.eodProcessList = [];
        	console.log(vm.eodProcessListFromDB );
        	vm.idArray = [];
        	angular.forEach(vm.eodProcessListFromDB, function(item){               
                vm.idArray.push( item.id);               
            });
        	
   	    	vm.eodProcessList = angular.copy(vm.eodProcessListFromDB);   	    	
   	    	
   	   
          	if(vm.eodStatus == vm.OPEN || vm.eodStatus==vm.INCOMPLETE || vm.eodStatus==vm.INPROGRESS){
          		
          		 angular.forEach( vm.eodProcessList, function(item){
          		 
	          		 if(item.processName=='ForciblelogoffUsers'){
	          			 vm.logOffId = item.id;
	          		 }else if(item.processName=='ReconOrderDetailsRequest'){
	          			 vm.reconOrderReqId = item.id;
	          		 }       		 
	          		 else if(item.processName=='MakeUsersDormant'){
	        			 vm.dormantId=item.id;
	          		 }
	          		 else if(item.processName=='AutowithdrawalOfPendingApprovalCustomers'){
	        			 vm.autowithdrawalId=item.id;
	        		 }
	          		 else if(item.processName=='GenerateEODEmails'){
	        			 vm.eodId=item.id;
	        		 }
	          		 else if(item.processName=='ProcessLimitsAtEOD'){
	        			 vm.limitId=item.id;
	        		 }
	          		 else if(item.processName=='ArchiveTablesAtEOD'){
	          			 vm.archiveId=item.id;
	          		 }
	          		 else if(item.processName=='ComputeDailyTransactionCharges'){
	          			vm.dailyTransactionId=item.id;
	          		 }
	          		 else if(item.processName=='GenerateMonthEndBillingReport'){
	          			vm.monthEndBillingId=item.id;
	          		 }
	          		 else if(item.processName=='GenerateYearEndBillingReport'){
	          			vm.yearEndBillingId=item.id;
	          		 }	
	          		 else if(item.processName=='UpdateNewTradingBranchForCustomers'){
	          			vm.updateTradingBranchId=item.id;
	          		 }
	          		 else if(item.processName=='ShiftingTheSystemDate'){
	          			vm.shiftDateId=item.id;
	          		 }
	          		 else if(item.processName=='PrepareNextBusinessDateData'){
	          			vm.prepareNextdateDataId=item.id;
	          		 }	          		 
	          		 item.status = vm.NOTSTARTED;
	          		 item.remarks='';	       		
	          		 vm.newProcessResultMap[item.id] = null;
	          		 vm.processResultMap[item.id] = null;
	          		 vm.processErrorMap[item.id] = null;
	          		 vm.newProcessErrorMap[item.id] = null;
          		 });
          	}
          	if(vm.eodStatus==vm.INPROGRESS || vm.eodStatus==vm.INCOMPLETE){
                $fileLogger.info('lookupWorkFlowSuccess getEODProcessStatusLog');
          		 EODProcess.getEODProcessStatusLog({
    				"businessDate" : convertedCurrentBusinessDate
    			} ,getEODProcessStatusLogSuccess,getEODProcessStatusLogFailure);
          		vm.showResumeButton=true;
          		vm.showEodProcess=true;
          		vm.isEODvalidated=true;
          	 }
        
        }
        
	function getEODProcessStatusLogSuccess(result){
		
		var processIndex = vm.idArray.indexOf(result.processId);
   		angular.forEach(vm.eodProcessList,function(item,index){
   			if(index < processIndex)
   			item.status = vm.COMPLETED;
   		})
		
	}
	
	function getEODProcessStatusLogFailure(){}
	
        function reloadListAndMap(){
        	
        	vm.eodProcessList = angular.copy(vm.eodProcessListFromDB);
        	vm.idArray = [];
        	angular.forEach(vm.eodProcessListFromDB, function(item){               
                vm.idArray.push( item.id);               
            });
        	
       	 	angular.forEach( vm.eodProcessList, function(item){
	       	 	 if(item.processName=='ForciblelogoffUsers'){      			
	       			 vm.logOffId = item.id;
	      		 }else if(item.processName=='ReconOrderDetailsRequest'){       			
	      			 vm.reconOrderReqId = item.id;;
	       		 }
	      		 else if(item.processName=='MakeUsersDormant'){
	    			 vm.dormantId=item.id;;
	    		 }
	      		 else if(item.processName=='AutowithdrawalOfPendingApprovalCustomers'){
	    			 vm.autowithdrawalId=item.id;;
	    		 }
	      		 else if(item.processName=='GenerateEODEmails'){
	    			 vm.eodId=item.id;;
	    		 }
	      		 else if(item.processName=='ProcessLimitsAtEOD'){
	    			 vm.limitId=item.id;
	    		 }
	      		 else if(item.processName=='ArchiveTablesAtEOD'){
	      			 vm.archiveId=item.id;
	      		
	      		 }else if(item.processName=='ComputeDailyTransactionCharges'){
	      			 vm.dailyTransactionId=item.id;
	      		 }
	      		 else if(item.processName=='GenerateMonthEndBillingReport'){
	      			 vm.monthEndBillingId=item.id;
	      		 }
	      		 else if(item.processName=='GenerateYearEndBillingReport'){
	      			 vm.yearEndBillingId=item.id;
	      		 }
	      		 else if(item.processName=='UpdateNewTradingBranchForCustomers'){
	      			 vm.updateTradingBranchId=item.id;
	      		 }
	      		 else if(item.processName=='ShiftingTheSystemDate'){
	      			 vm.shiftDateId=item.id;
	      		 }
	      		 else if(item.processName=='PrepareNextBusinessDateData'){
	      			 	vm.prepareNextdateDataId=item.id;
	      		 }
       	 	});
       	 	// vm.processStatusMap =  angular.copy(vm.newProcessStatusMap);
       	 	vm.processResultMap = angular.copy(vm.newProcessResultMap);
       	 	vm.processErrorMap = angular.copy(vm.newProcessErrorMap);
       	 
        }
        
        function lookupWorkFlowFailure(error){
       	 //do nothing
        }
        
        /**********************************END********************************************************/
		/******** FETCH ERROR MESSAGE AND SET TO GLOBAL VARIABLE *************************************/
         function loadErrorMEssages(){
        	 StaticLookUp.getProcessErrorMessages(loadErrorMEssagesSuccess, loadErrorMEssagesFailure);
         }
         function loadErrorMEssagesSuccess(result){
        	// vm.globalValues.checkAndSetSelectedErrorMessages(result);        	
        	 vm.errorList  = result[0];
         }
         function loadErrorMEssagesFailure(error){
        	 //do nothing
         }
         /****************load config for maximumWaitingtime to get response from orderservice , define timer to check whether response is received in time *******************/
 				
 		/*vm.enableTimer = false;
 		vm.maximumWaitTimeForOrderServiceResponse = 0 ; 
 		vm.latestOrderSeviceRequestTimestamp = 0 ; 
 		vm.latestProcess = 0;
 		vm.configSettings = vm.globalValues.getConfigSettings();
 		
 		var maximumWaitTimeForResponseString  = vm.configSettings.timerIntervalforSODEODResponseWait;
 		if(maximumWaitTimeForResponseString!=null && maximumWaitTimeForResponseString!=undefined && maximumWaitTimeForResponseString.trim()!=''){
 			
 			vm.maximumWaitTimeForOrderServiceResponse = parseInt(maximumWaitTimeForResponseString, 10) * 1000;
 			//vm.maximumWaitTimeForOrderServiceResponse = 60*1000;
 		}else{
 			
 			vm.maximumWaitTimeForOrderServiceResponse = 60000;//default 60 secs
 		}
 		
 		vm.responseTimeCheckInterval = vm.maximumWaitTimeForOrderServiceResponse/2;
 		
 		$scope.checkForResponseTimeout = function() {
 			
 	        console.log("$scope.callAtInterval - Interval occurred");
 	        var currentTimestamp = moment().valueOf();
 	        if( (vm.enableTimer == true) && ( (currentTimestamp - vm.latestOrderSeviceRequestTimestamp ) >  vm.maximumWaitTimeForOrderServiceResponse )){
 	        	
 	        	// update the eod Process status log = INCOMPLETE
 	        	if(vm.latestProcess!=null && vm.latestProcess!=undefined && vm.latestProcess.status == vm.INPROGRESS){
 	        		updateRemarksInProcessList(vm.latestProcess.id ,"Response timeout occurred",  vm.FAILED);
 	        		EODProcess.insertProcessLog({"currentBusinessDate" : convertedCurrentBusinessDate,
 	    				"processId" : vm.latestProcess.id,
 	    				"executionCount" : vm.executionCount,
 	    				"errorMessageCode" : "7001",
 	    				"isSuccess" : false});
 	        	}
 	        	vm.eodStatus = vm.INCOMPLETE;
 				vm.disbleEod = disableEodProcess();			
 				
 				EODProcess.processEOD( {				
 					"businessDate" : convertedCurrentBusinessDate,
 					"status" : vm.INCOMPLETE,
 					"nextBusinessDate" : convertedNextBusinessDate
 				}, endEODInUISuccess, endEODInUIError);
 	        	
 	        }
 	    }
 		

 	 	$interval( function(){ 
 	 		$scope.checkForResponseTimeout(); 
 	 		}, vm.responseTimeCheckInterval);
 	 	
 		function endEODInUISuccess(result){
 			
 			vm.enableTimer = false;
 			//destroy the event 
 			unsubscribeToEODProcessUpdate();	

 			// send kafka message to order service to stop the further process.
 			EODProcess.stopEODForcibly();
 			
 			
 			
         	
 		}
 	
 		function endEODInUIError(error){
 			//DO NOthing			
 			unsubscribeToEODProcessUpdate();		
 		}*/
 		/***************************************************************************/
      // function to start the EOD process on start button click
 		function beginEODProcess(actionType) {
 			 $fileLogger.info(actionType + ' Clicked');
 			vm.isRefreshDisabled = false;
 			vm.showEodProcess=true;
 			vm.isEodProcessSuccessfull=null;
 			vm.isEodCompleted = false;
 			//reloadListAndMap();
 			if(vm.currentBusinessDate !=null && vm.currentBusinessDate !=undefined && vm.currentBusinessDate !=''){
 				if ( vm.currentBusinessDate > vm.today ) {
 					
 					AlertService.error($filter('translate')('gatewayApp.eodProcess.forwardDateError'));
 					
 				}else if(vm.eodStatus == vm.COMPLETED){
 					AlertService.error($filter('translate')('gatewayApp.eodProcess.alreadyCompleted'));
 				}
 				else {
 					//call the first process
					$rootScope.eodInProgress = true;
 					processeod();
 					//logOffUsersForcibly();
 					
 				}
 			}
 			

 		}
        
 		/*********************** Process methods before starting the eod process ********************************************/
		var processeod = function processeod(){
					
                $fileLogger.info('processEOD');
				EODProcess.processEOD( {				
				"businessDate" : convertedCurrentBusinessDate,
				"status" : vm.INPROGRESS ,
				"nextBusinessDate": convertedNextBusinessDate
				}, processeodSucess, processeodError);
		
			
		}
		
		function clearPreviousStatus(){
			
			var indexOfRevokeProcess = vm.idArray.indexOf(vm.revokeProcessId);
			 
			 angular.forEach(  vm.eodProcessList, function(item,index){
				 if(index >= indexOfRevokeProcess){
					 item.status = vm.NOTSTARTED;
					 item.remarks='';
					 vm.processResultMap[ item.id] = null;	
				 }else{
					item.status = vm.COMPLETED;
					item.remarks='';
				 }
			 });
		}
	
		function updateEODLogSuccess(result){
			vm.executionCount = parseInt(result.executionCount);
			vm.executionCount = vm.executionCount+1;
			vm.revokeProcessId = parseInt(result.revokeProcessId);
			$fileLogger.info('updateEODLogSuccess execution count -' + vm.executionCount + ' vm.revokeProcessId' + vm.revokeProcessId);
			clearPreviousStatus();
			if(vm.eodStatus == vm.INPROGRESS && vm.revokeProcessId != vm.dormantId && vm.revokeProcessId != vm.logOffId){
					
					AlertService.error($filter('translate')('gatewayApp.eodProcess.alreadyInProgress'));
			}else{
			
				vm.eodStatus = vm.INPROGRESS ;
				vm.disbleEod = true;	
				console.log('EOD procss resumed with process id '+ vm.revokeProcessId);
				$fileLogger.info('EOD procss resumed with process id' + vm.revokeProcessId);
			if(vm.revokeProcessId == vm.logOffId || vm.revokeProcessId == 0){
				successProcessor(logOffUsersForcibly);
			}if(vm.revokeProcessId == vm.reconOrderResponseId ){
				successProcessor(startEODInOrderService);
			}else if(vm.revokeProcessId == vm.dormantId){
				console.log('calling make user dormant method - from Resume EOD');
				successProcessor(MakeUsersDormant);
			}else if(vm.revokeProcessId == vm.autowithdrawalId){
				successProcessor(autoWithrdrawPendingCutomerRegistration);
			}else if(vm.revokeProcessId == vm.eodId ){
				successProcessor(generateEODEmails);
			}else if(vm.revokeProcessId == vm.limitId ){
				successProcessor(processLimitsAtEOD);
			}else if(vm.revokeProcessId == vm.archiveId){
				successProcessor(archiveTables);
			}else if(vm.revokeProcessId == vm.dailyTransactionId){
				successProcessor(computeDailyTransactions);
			}else if(vm.revokeProcessId == vm.monthEndBillingId){
				successProcessor(monthEndBilling);
			}else if(vm.revokeProcessId == vm.yearEndBillingId){
				successProcessor(yearEndBilling);
			}else if(vm.revokeProcessId == vm.updateTradingBranchId){
				successProcessor(updateNewTradingBranchForCustomers);
			}
			else if(vm.revokeProcessId ==	vm.shiftDateId){
				successProcessor(shiftDate);
			}
			else if(vm.revokeProcessId == vm.prepareNextdateDataId ){
				successProcessor(prepareNextBusinessDatedata);
			}else{
				successProcessor(startEODInOrderService);
			}
			
			}
		}
		
		function updateEODLogFailure(){
			
		}
		

		function processeodSucess(result){
			
			if(vm.eodStatus == vm.INCOMPLETE || vm.eodStatus == vm.INPROGRESS ){
                $fileLogger.info('updateEODPRocessLog');
				EODProcess.updateEODPRocessLog({"businessDate" : convertedCurrentBusinessDate},updateEODLogSuccess, updateEODLogFailure);
			}else{			
				vm.executionCount = vm.executionCount+1;
				$fileLogger.info('current execution Count', vm.executionCount);
				//		vm.revokeProcessId = parseInt(result.revokeProcessId);
				vm.eodStatus = vm.INPROGRESS ;
				vm.disbleEod = true;			
				successProcessor(logOffUsersForcibly);
			}
		}
		
		
		function processeodError(error){
			var errorCode = errorProcessor(error);
			AlertService.error( errorCode );
		}
		
		
		function updateRemarksInProcessList(processID, errorMessage, status){
			var indexOfRevokeProcess = vm.idArray.indexOf(processID);
			var item = vm.eodProcessList[indexOfRevokeProcess];
			item.remarks = errorMessage;
			item.status = status ;
			//download log file whenever any process is failed.
			if(status==vm.FAILED){
				$fileLogger.info('EOD stopped in ' + item.processName);
				$fileLogger.info(errorMessage);
				$timeout(function(){
					$rootScope.eodInProgress = false;
					FileUtil.downloadLogFile("FXRetail_EOD_Process");
				}, 1000);
			}
		}
		
		
		
		 function disableEodProcess(){
		    	
		    	if(vm.currentBusinessDate ==undefined || vm.currentBusinessDate == null || vm.currentBusinessDate == ''){
		    		// no valid businessdate - disable start button
		    		return true;
		    	}else if(vm.eodStatus ==vm.OPEN || vm.eodStatus==null || vm.eodStatus==undefined ||vm.eodStatus==''){
		    		// eodStatus is open for the business date then enable start button
		    		vm.isRefreshDisabled=true;
		    		return false;
		    	}else if( vm.eodStatus ==vm.INCOMPLETE){
		    		
		    		vm.isRefreshDisabled=false;
		    		return false;
		    		
		    	}
		    	else if( (vm.eodStatus ==vm.INPROGRESS ) && !(vm.isEodProcessSuccessfull==null || vm.isEodProcessSuccessfull==false)){
		    		// enable start button when eodStatus is in in progress and eod process is not successful
		    		vm.isRefreshDisabled=false;
		    		return  false;
		    	}else if( vm.eodStatus ==vm.INPROGRESS  && (vm.isEodProcessSuccessfull==null || vm.isEodProcessSuccessfull==true)){
		    		// disable start button when sodStatus is in inprogress and sod process is  successfull
		    		vm.isRefreshDisabled=false;
		    		return true;
		    	}else if( vm.COMPLETED ==vm.eodStatus ){
		    		vm.isRefreshDisabled=true;
		    		return true;
		    	}
		    	
		    }
		 
		 
		/*function getBusinnessDateSuccess(result) {
					
			vm.currentBusinessDate = DateUtils.convertLocalDateFromServer(result.date);
			convertedCurrentBusinessDate = DateUtils.convertLocalDateToServer(vm.currentBusinessDate);
			EODProcess.getNextValidBusinessDate( {
					"currentBusinessDate" : convertedCurrentBusinessDate
				} , getNextBusinessDateSuccess, getNextBusinessDateError);
				

			//vm.nextBusinessDate =  DateUtils.convertLocalDateFromServer(result.date);
			//vm.nextBusinessDate.setDate(vm.nextBusinessDate.getDate() + 1);
			//convertedNextBusinessDate = DateUtils.convertLocalDateToServer(vm.nextBusinessDate);
			
		}

		function getBusinessDateFailed(error) {
			//Do Nothing
		}*/
		
		function getNextBusinessDateSuccess(result) {
			vm.nextBusinessDate = DateUtils.convertLocalDateFromServer(result.date);
			vm.nextDate = $filter('date')(vm.nextBusinessDate,"dd/MM/yyyy");
			vm.nextDate = vm.nextDate + " | " + days[vm.nextBusinessDate.getDay()];
			convertedNextBusinessDate = DateUtils.convertLocalDateToServer(vm.nextBusinessDate);
		}
		function getNextBusinessDateError(error) {
		}
		/*function getNextTomDateSuccess(result) {
			vm.tomDate = DateUtils.convertLocalDateFromServer(result.date);
		}
		function getNextTomDateError(error) {
		}*/
		

		
		/*********************** Process methods for forcible logoff users ********************************************/
		var logOffUsersForcibly = function logOffUsersForcibly(){
			
			updateRemarksInProcessList(vm.logOffId ,"",   vm.INPROGRESS);
            $fileLogger.info('logOffUsersForcibly');
			EODProcess.logOffUsersForcibly( {				
				"currentBusinessDate" : convertedCurrentBusinessDate,
				"processId" : vm.logOffId,
				"executionCount" : vm.executionCount
			}, logOffUsersForciblySucccess, logOffUsersForciblyError);
		}
		function logOffUsersForciblySucccess(result){
			updateRemarksInProcessList(vm.logOffId ,"",  vm.COMPLETED);
			//clear revokeProcessId before starting the EOD process in OPS. 
			//if it retained as 1. then it will make issue on OPS. issue fixed on 21-Jan-2021.
			vm.revokeProcessId = null;
			//invoke next process - auto withdrawal of pending customers
			successProcessor(startEODInOrderService);
		}
		function logOffUsersForciblyError(error){
			
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.logOffId ,errorCode , vm.FAILED );
		
		}
		
		/************************* END *****************************************************************************/
		
		/********** begin EOD in order service *************/
		var startEODInOrderService = function startEODInOrderService(){
			//var getKeysArray = Object.keys(vm.eodProcessList);
			var nextProcesss = vm.eodProcessList[1];
			if(vm.revokeProcessId==null){
				//vm.processId = vm.reconOrderReqId;
				vm.processId = nextProcesss.id;
			}else{
				vm.processId = vm.revokeProcessId;
				
				nextProcesss = vm.eodProcessList[vm.idArray.indexOf(vm.revokeProcessId)];
			}
			console.log('next order server EOD process - ' + nextProcesss.id);
			/*if(nextProcesss.processName=='ReconOrderDetailsRequest' || nextProcesss.processName=='ReconOrderDetailsResponse' || nextProcesss.processName=='ReconTradeDetailsRequest'
				|| nextProcesss.processName=='ReconTradeDetailsResponse' || nextProcesss.processName=='UserLogOffRequest' || nextProcesss.processName=='UserLogOffResponse'
				|| nextProcesss.processName=='LUDDLogOffRequest' || nextProcesss.processName=='LUDDLogOffResponse' || nextProcesss.processName=='DisconnectInteractiveMQChannel' || nextProcesss.processName=='DisconnectBroadcastMQChannel'){*/
				updateRemarksInProcessList(vm.processId ,"",   vm.INPROGRESS);
				
				var eodRequest = {};
				eodRequest.executionCount = vm.executionCount;
				eodRequest.businessDate = convertedCurrentBusinessDate;
				eodRequest.startingProcessID =  vm.processId;
				 
				/*EODProcess.initiateEODInOrderService({
					"executionCount" : vm.executionCount,
					"businessDate": convertedCurrentBusinessDate,
					"revokeProcessId": vm.processId},
						startEODInOrderServiceSuccess, startEODInOrderServiceFailure);*/
                $fileLogger.info('initiateEODInOrderService');
				EODProcess.initiateEODInOrderService(eodRequest,
						startEODInOrderServiceSuccess, startEODInOrderServiceFailure);
			/*}else{
				successProcessor(nextProcesss.processName);
			}*/
			
		}
		function startEODInOrderServiceSuccess(result){
			//do nothing as this is async call
            
			$fileLogger.info('initiateEODInOrderService success');
			
		}
		function startEODInOrderServiceFailure(error){
			
			// EOD Failure
			var errorCode = errorProcessor(error);
			$fileLogger.info('initiateEODInOrderService failed ' + errorCode);
			updateRemarksInProcessList(vm.processId ,"",  vm.FAILED);
            $fileLogger.info('processEOD called again in startEODInOrderServiceFailure');
			EODProcess.processEOD( {				
				"businessDate" : convertedCurrentBusinessDate,
				"status" : vm.INCOMPLETE,
				"nextBusinessDate" : convertedNextBusinessDate
			},  processENDEODSucess, processENDEODError);
			AlertService.error( errorCode );
		}
		/********  END *************/
		
		
		
		/*********************** Process methods for make users dormant ********************************************/
		var MakeUsersDormant = function MakeUsersDormant(){
			
			updateRemarksInProcessList(vm.dormantId ,"",   vm.INPROGRESS);		
            $fileLogger.info('makeUsersDormant');
			EODProcess.makeUsersDormant( {				
				"currentBusinessDate" : convertedCurrentBusinessDate,
				"processId" : vm.dormantId,
				"executionCount" : vm.executionCount
			}, makeUsersDormantSucccess, makeUsersDormantError);
		}
		function makeUsersDormantSucccess(result){
			updateRemarksInProcessList(vm.dormantId ,"",  vm.COMPLETED);
			//invoke next process - auto withdrawal of pending customers
			successProcessor(autoWithrdrawPendingCutomerRegistration);
		}
		function makeUsersDormantError(error){
			
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.dormantId ,errorCode , vm.FAILED );
		}
		
		
		/************************* END *****************************************************************************/

		/*********************** Process methods for auto withdrawal of pening customer registration ********************************************/
		
		var autoWithrdrawPendingCutomerRegistration = function autoWithrdrawPendingCutomerRegistration(){
			
			
			updateRemarksInProcessList(vm.autowithdrawalId ,"",   vm.INPROGRESS);			
            $fileLogger.info('autoWithdrwaPendingCustomers');            
			EODProcess.autoWithdrwaPendingCustomers( {				
				"currentBusinessDate" : convertedCurrentBusinessDate,
				"processId" : vm.autowithdrawalId,
				"executionCount" : vm.executionCount
			}, autoWithrdrawPendingCutomerRegistrationSucccess, autoWithrdrawPendingCutomerRegistrationError);
		}
		function autoWithrdrawPendingCutomerRegistrationSucccess(result){
			
			updateRemarksInProcessList(vm.autowithdrawalId ,"",  vm.COMPLETED);
			//invoke next process - generate EOD Emails
			successProcessor(generateEODEmails);
		}
		function autoWithrdrawPendingCutomerRegistrationError(error){
			
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.autowithdrawalId ,errorCode , vm.FAILED );
		}
		
		
		/************************* END *****************************************************************************/
		
		/*********************** Process methods for GEnerate EOD Emails ********************************************/
		var generateEODEmails = function generateEODEmails(){			
			
			updateRemarksInProcessList(vm.eodId ,"",   vm.INPROGRESS);			
            $fileLogger.info('generateEODEmails');            
			EODProcess.generateEODEmails( {				
				"currentBusinessDate" : convertedCurrentBusinessDate,
				"processId" : vm.eodId,
				"executionCount" : vm.executionCount
			}, generateEODEmailsSuccess, generateEODEmailsError);
		}
		function generateEODEmailsSuccess(result) {
			updateRemarksInProcessList(vm.eodId ,"",  vm.COMPLETED);
			//invoke next process - shift date 
			successProcessor(processLimitsAtEOD);
			
		}
		function generateEODEmailsError(error) {
			
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.eodId ,errorCode , vm.FAILED );
			
		}
		

		/*********************** Process Methods for limit expire emails ********************************************/
		

		var processLimitsAtEOD  = function processLimitsAtEOD(){
			
			updateRemarksInProcessList(vm.limitId ,"",   vm.INPROGRESS);
			
            $fileLogger.info('processLimits');        
			EODProcess.processLimits( {
				"currentBusinessDate" : convertedCurrentBusinessDate,
				"processId" : vm.limitId,
				"executionCount" : vm.executionCount
				
			}, processLimitsSuccess, processLimitsError);
		}
		function processLimitsSuccess(result) {
						
			
			updateRemarksInProcessList(vm.limitId ,"",  vm.COMPLETED);
		
			successProcessor(archiveTables);
			
			
		}
		function processLimitsError(error) {
			
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.limitId ,errorCode , vm.FAILED );
			
		}
		

		
		/*********************** Process Methods for archivivng tables********************************************/
		

		var archiveTables  = function archiveTables(){
			
			updateRemarksInProcessList(vm.archiveId ,"",   vm.INPROGRESS);
			
            $fileLogger.info('archiveTables');    
			EODProcess.archiveTables( {
				"currentBusinessDate" : convertedCurrentBusinessDate,
				"processId" : vm.archiveId,
				"executionCount" : vm.executionCount
				
			}, archiveTablesSuccess, archiveTablesFailure);
		}
		function archiveTablesSuccess(result) {
						
			
			updateRemarksInProcessList(vm.archiveId ,"",  vm.COMPLETED);
		
			successProcessor(computeDailyTransactions);
			
			
		}
		function archiveTablesFailure(error) {
			
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.archiveId ,errorCode , vm.FAILED );
			
		}
		
	/*********************** Process Methods for computeDailyTransaction tables********************************************/
		

		var computeDailyTransactions  = function computeDailyTransactions(){
			
			updateRemarksInProcessList(vm.dailyTransactionId ,"",   vm.INPROGRESS);
			
            $fileLogger.info('computeDailyTransactions');
			EODProcess.computeDailyTransactions( {
				"currentBusinessDate" : convertedCurrentBusinessDate,
				"processId" : vm.dailyTransactionId,
				"executionCount" : vm.executionCount
				
			}, computeDailyTransactionsSuccess, computeDailyTransactionssFailure);
		}
		function computeDailyTransactionsSuccess(result) {
						
			
			updateRemarksInProcessList(vm.dailyTransactionId ,"",  vm.COMPLETED);
		
			successProcessor(monthEndBilling);
			
			
		}
		function computeDailyTransactionssFailure(error) {
			
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.dailyTransactionId ,errorCode , vm.FAILED );
			
		}
		/*********************** Process Methods for monthEndBilling tables********************************************/
		

		var monthEndBilling  = function monthEndBilling(){
			
			updateRemarksInProcessList(vm.monthEndBillingId ,"",   vm.INPROGRESS);
			
            $fileLogger.info('generateMonthEndBillingReport');
			EODProcess.generateMonthEndBillingReport( {
				
				"processId" : vm.monthEndBillingId,
				"executionCount" : vm.executionCount
				
			}, monthEndBillingSuccess, monthEndBillingFailure);
		}
		function monthEndBillingSuccess(result) {
						
			
			updateRemarksInProcessList(vm.monthEndBillingId ,"",  vm.COMPLETED);
		
			successProcessor(yearEndBilling);
			
			
		}
		function monthEndBillingFailure(error) {
			
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.monthEndBillingId ,errorCode , vm.FAILED );
			
		}
		
/*********************** Process Methods for yearEndBilling tables********************************************/
		

		var yearEndBilling  = function yearEndBilling(){
			
			updateRemarksInProcessList(vm.yearEndBillingId ,"",   vm.INPROGRESS);
			
            $fileLogger.info('generateYearEndBillingReport');
			EODProcess.generateYearEndBillingReport( {
				"processId" : vm.yearEndBillingId,
				"executionCount" : vm.executionCount
				
			}, yearEndBillingSuccess, yearEndBillingFailure);
		}
		function yearEndBillingSuccess(result) {
						
			
			updateRemarksInProcessList(vm.yearEndBillingId ,"",  vm.COMPLETED);
		
			successProcessor(updateNewTradingBranchForCustomers);
			
			
		}
		function yearEndBillingFailure(error) {
			
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.yearEndBillingId ,errorCode , vm.FAILED );
			
		}
		/*********************** Process Methods for shifting Date ********************************************/
		

		var shiftDate  = function shiftDate(){
			
			updateRemarksInProcessList(vm.shiftDateId ,"",   vm.INPROGRESS);
            $fileLogger.info('shiftDateInSystem');
			EODProcess.shiftDateInSystem( {
				"currentBusinessDate" : convertedCurrentBusinessDate,		
				"processId" : vm.shiftDateId,
				"executionCount" : vm.executionCount
				
			}, shiftDateSuccess, shiftDateError);
		}
		function shiftDateSuccess(result) {
						
			updateRemarksInProcessList(vm.shiftDateId ,"",  vm.COMPLETED);
			
			successProcessor(prepareNextBusinessDatedata);
		}
		function shiftDateError(error) {
			
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.shiftDateId ,errorCode , vm.FAILED );
			
		}
		
		/*********************** Prepare ********************************************/
		

		var prepareNextBusinessDatedata  = function prepareNextBusinessDatedata(){
			
			updateRemarksInProcessList(vm.prepareNextdateDataId ,"",   vm.INPROGRESS);
            $fileLogger.info('prepareNextBusinessDateData');
			EODProcess.prepareNextBusinessDateData( { "currentBusinessDate" : convertedCurrentBusinessDate,
				"processId" : vm.prepareNextdateDataId,
				"executionCount" : vm.executionCount}, prepareSuccess, prepareError);
		}
		function prepareSuccess(result) {
						
			updateRemarksInProcessList(vm.prepareNextdateDataId ,"",  vm.COMPLETED);
            $fileLogger.info('processEOD - Complete');
			EODProcess.processEOD( {				
				"businessDate" : convertedCurrentBusinessDate,
				"status" : vm.COMPLETED,
				"nextBusinessDate" : convertedNextBusinessDate
			}, processEODcompleteSucess, processEODcompleteError);
			vm.eodDone=true;
		
			
		}
		function prepareError(error) {
			
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.prepareNextdateDataId ,errorCode , vm.FAILED );
			
		}
		
		/*********************** Process methods for forcible logoff users ********************************************//*
		var logOffUsersForciblyEnd = function logOffUsersForciblyEnd(){
			
			updateRemarksInProcessList(vm.logOffEndId ,"",   vm.INPROGRESS);
			EODProcess.logOffUsersForcibly( {				
				"currentBusinessDate" : convertedCurrentBusinessDate,
				"processId" : vm.logOffEndId,
				"executionCount" : vm.executionCount
			}, logOffUsersForciblyEndSucccess, logOffUsersForciblyEndError);
		}
		function logOffUsersForciblyEndSucccess(result){
			updateRemarksInProcessList(vm.logOffEndId ,"",  vm.COMPLETED);
			loadDates();
			//invoke next process - auto withdrawal of pending customers
		}
		function logOffUsersForciblyEndError(error){
			
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.logOffEndId ,errorCode , vm.FAILED );
		
		}*/
		
		/*********************General method used in all process ***********************/
		function successProcessor(successProcessToInvoke){
			
			if(vm.isEodProcessSuccessfull == null || vm.isEodProcessSuccessfull == true){
				// next process is invoked only when previous one is is successful
				if(successProcessToInvoke!=null)
					successProcessToInvoke();
			}
		}
		

		function errorProcessor(error){		
			var errorcode = "";
			if( error.message !=undefined &&  error.message !=null &&  error.message!=""){
				errorcode  = $filter('translate')( error.message ) //+  error.businessDate;				
				//vm.errorMessage = error.exceptionMessage +  errorcode ;
			}else if( !(error.data==undefined || error.data==null || error.data=='')){
				errorcode  = $filter('translate')( error.data.message );
				//vm.errorMessage = error.data.exceptionMessage +" "+  errorcode;
			}else{
				errorcode = $filter('translate')( "Service unavailable");
			}
			 		
			//AlertService.error( errorcode );
			vm.isEodProcessSuccessfull=false;
			return errorcode;
		}
		
		/********************************************/
		
		
		/*********************** END ********************************************/
		// Watch for Process failure through the isEodProcessSuccessfull flag , if it is failed log the status, if it true do nothing
		 $scope.$watch('vm.isEodProcessSuccessfull', function(value){
				if(value!=null && value!=undefined && value == false){
	               
					//method to enable or disable start button if process is unsuccessfull
					vm.eodStatus = vm.INCOMPLETE;
					vm.disbleEod = disableEodProcess();
					/*EODProcess.processEOD( {				
						"businessDate" : convertedCurrentBusinessDate,
						"status" : vm.INCOMPLETE,
						"nextBusinessDate" : convertedNextBusinessDate
					}, processENDEODSucess, processENDEODError);*/
				}
			
				});
		   /* $scope.$watch('vm.isEodCompleted', function(value){
				 if(value==true ){
					// update the status as completed when the isEODProcessSuccessful is true and inprogress
					EODProcess.processEOD( {				
						"businessDate" : convertedCurrentBusinessDate,
						"status" : 'COMPLETED'
					}, processENDEODSucess, processENDEODError);
				}
				});*/
	
		 orderServiceEODProcessUpdateSubscription = $rootScope.$on("orderServiceEODProcessUpdate", function(event,result){
			 $fileLogger.info(" websocket message orderServiceEODProcessUpdate recevied for process id " + result.processID + "status " +result.success );
		    	if( result.success!=vm.processResultMap[result.processID]){
		    
		    		processStatusNotificationFromOrderService(result);
		    	}else if( result.success==false && result.exceptionNumber!=vm.processErrorMap[result.processID]){
		    		//update new error code
		    		processStatusNotificationFromOrderService(result);
		    	}
		    	
	         });
	  
      function unsubscribeToEODProcessUpdate(){
          if(orderServiceEODProcessUpdateSubscription!=null){
              // unscribe to order service update notification
              orderServiceEODProcessUpdateSubscription();
          }
      }
      var webscoketDisconnect = $rootScope.$on("websocketDisconnected", function(event,result){
	    	
	    	console.log("web socket disconnected with reason " + result);
	    	 $fileLogger.info("web socket disconnected with reason " + result);
	    	var logOffIndex = vm.idArray.indexOf(vm.logOffId);
	    	var dormantIndex = vm.idArray.indexOf(vm.dormantId);
	    	angular.forEach( vm.eodProcessList, function(item,index){
	    		// set the status as failed only for order service process when websocket disconnection occurs
	    		
	   		 	if(item.status == vm.INPROGRESS && index > logOffIndex && index < dormantIndex){
	   		 		item.status = vm.FAILED;
	   		 		item.remarks=vm.errorList["7001"].rejectionReason;
	   		 	}
	    		
	    	
	    	});
	    	
     });
	    $scope.$on('$destroy', function() {
	        	unsubscribeToEODProcessUpdate();	        	
	        	if(webscoketDisconnect!=null){
	  			  webscoketDisconnect();
	  		  }	
	    });
		
		function processENDEODSucess(result){			
		    	
				
		}
		    
		    function processEODcompleteSucess(result){
		    	AlertService.success($filter('translate')('gatewayApp.eodProcess.eodProcesscompleted') + $filter('date')(vm.currentBusinessDate,"dd-MMM-yyyy"));
                $timeout(function(){
					$rootScope.eodInProgress = false;
                    FileUtil.downloadLogFile("FXRetail_EOD_Process");
                }, 1000);
				EODProcess.logOffUsersForcibly( {				
					"currentBusinessDate" : convertedCurrentBusinessDate,
					"processId" : 0,
					"executionCount" : vm.executionCount
				});
		    }
		    
		    function processEODcompleteError(error){}
		    
		    
			
			function processENDEODError(error){
				//DO NOthing
				

			}
		
		
			function processStatusNotificationFromOrderService(processStatus){
				
				//angular.forEach( vm.sodProcessList, function(item,index){
				var indexOfProcess =  vm.idArray.indexOf(processStatus.processID);
				var item = vm.eodProcessList[indexOfProcess];
					//console.log("process", index);
					console.log("notification received from order service for process "+ processStatus.processID);
				
					if(item.id==processStatus.processID &&  processStatus.success==true ){
						
						item.status = vm.COMPLETED;
						item.remarks = "";
						
						//var keyArray = Object.keys(vm.eodProcessList);
						var keyArray = vm.idArray
						var index = keyArray.indexOf(processStatus.processID);
						var nextIndex = index+1;
						if(nextIndex < keyArray.length){
							var nextProcess = vm.eodProcessList[nextIndex];
		    				if(nextProcess!=undefined && nextProcess!=null && nextProcess!='' && nextProcess.status!= vm.COMPLETED && nextProcess.status!= vm.FAILED){
		    					nextProcess.status = vm.INPROGRESS ;
		    					
		    				}
		    				// $fileLogger.info('success notification received from order server for process id- ' + processStatus.processID);
		    				if(item.processName == 'DisconnectBroadcastMQChannel' && !vm.isEodCompletedForOrder){
		    					console.log('received DisconnectBroadcastMQChannel completion message');
		    					vm.isEodCompletedForOrder  = true;
		    					
		    					 $fileLogger.info('calling make user dormant method - from processStatusNotificationFromOrderService');
		    					successProcessor(MakeUsersDormant);
		    				}
		    				
						}
							
							
						
						//vm.processStatusMap[processStatus.processID] =true;
						 vm.processResultMap[processStatus.processID] = processStatus.success;
						 vm.processErrorMap[processStatus.processID] = null;
						
					
					}else if(item.id==processStatus.processID &&  processStatus.success==false){
						
						//$fileLogger.info('failure notification received from order server for process id- ' + processStatus.processID)				
						item.status = vm.FAILED;
						item.remarks = "Process Failed";
						vm.isEodProcessSuccessfull = false;			
						var errorKey = processStatus.exceptionNumber+""+processStatus.messageNumber;
					
						if( vm.errorList[errorKey]!=null && vm.errorList[errorKey]!=undefined 
								&& vm.errorList[errorKey]!='' ){
							item.remarks =  vm.errorList[errorKey].rejectionReason;
							
						}
						
						//vm.processStatusMap[processStatus.processID] =true;
						 vm.processResultMap[processStatus.processID] = processStatus.success;
						 vm.processErrorMap[processStatus.processID] = processStatus.exceptionNumber;
						
					}
					 
			}
		
		
		/***********************  END *************************************************************************************/
		/********** Refresh**********/
		  $scope.toggle = true;
	        function refresh() {
				$fileLogger.info('eod screen refreshed');
	            $scope.toggle = false;
	            $scope.refreshFlag = false;
	            loadDates();
	            if ($scope.toggle == false) {
	                $timeout(function() {
	                    $scope.toggle = true;
	                }, 2000);
	                $scope.refreshFlag = false;
	            }
	        };
		
		/***********END *************/
	    function logScreenAccess(){
	           ScreenLog.screenLog( entityConstants.ENTITY_SHORT_NAME.EOD_PROCESS,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
	        }
	    
	    function validateEod(){
            //$fileLogger.info('validateEOD');
	    	EODProcess.validateEOD(validateSuccess,validateFailure);
	    	vm.validation = vm.INPROGRESS;
	    }
	    
	    function validateSuccess(result){
	    	
	    	if(result.isValidated==true){
	    		vm.validation = vm.COMPLETED;
	    		vm.remarks="";
	    		validateSessionClose();
	    	}else{
	    		vm.validation = vm.FAILED;
	    		vm.remarks="Not processed";
	    	}
	    	
	    }
	    
	    function validateFailure(error){
	    	var errorCode = '';
	    	if(error.message!=null && error.message!=undefined && error.message!=''){
	    		errorCode = $filter('translate')(error.message);
	    	}
	    	vm.remarks=errorCode;
	    	vm.validation = vm.FAILED;
	    }
	    
	    function validateInteractiveServerDbProcessing(){
            $fileLogger.info('Validate Clicked');
	    	EODProcess.validateDBProcessing({"serverName" : "Interactive_Server"},validateInteractiveServerDbProcessingSuccess,validateInteractiveServerDbProcessingFailure);
	    	vm.validateInteractiveDBProcessing = vm.INPROGRESS;
	    }
	    
	    function validateInteractiveServerDbProcessingSuccess(result){
	    	vm.validateInteractiveDBProcessing = vm.COMPLETED;
    		vm.remarksForInteractiveServerDBProcessing="";
    		validateBroadcastServerDbProcessing();
	    	
	    }
	    
	    function validateInteractiveServerDbProcessingFailure(error){
	    	var errorCode = '';
	    	if(error.data.validationMsg!=null && error.data.validationMsg!=undefined && error.data.validationMsg!=''){
	    		errorCode = $filter('translate')(error.data.validationMsg);
	    	}
	    	vm.remarksForInteractiveServerDBProcessing=errorCode;
	    	vm.validateInteractiveDBProcessing = vm.FAILED;
	    }
	    
	    function validateBroadcastServerDbProcessing(){
            //$fileLogger.info('validateBroadcastDBProcessing');
	    	EODProcess.validateDBProcessing({"serverName" : "Broadcast_Server"},validateBroadcastServerDbProcessingSuccess,validateBroadcastServerDbProcessingFailure);
	    	vm.validateBroadcastDBProcessing = vm.INPROGRESS;
	    }
	    
	    function validateBroadcastServerDbProcessingSuccess(result){
	    	vm.validateBroadcastDBProcessing = vm.COMPLETED;
    		vm.remarksForBroadcastServerDBProcessing="";
    		validateResponseReceived();
	    }
	    
	    function validateBroadcastServerDbProcessingFailure(error){
	    	var errorCode = '';
	    	if(error.data.validationMsg!=null && error.data.validationMsg!=undefined && error.data.validationMsg!=''){
	    		errorCode = $filter('translate')(error.data.validationMsg);
	    	}
	    	vm.remarksForBroadcastServerDBProcessing=errorCode;
	    	vm.validateBroadcastDBProcessing = vm.FAILED;
	    }
	    
	    function validateResponseReceived(){
	    	vm.responseReceivedValidation = vm.INPROGRESS;
	    	vm.responseReceivedMessage="";
            //$fileLogger.info('validateResponseReceived');
	    	EODProcess.validateResponseReceived(validateResponseReceivedSuccess,validateResponseReceivedFailure);
	    }
	    
	    function validateResponseReceivedSuccess(result){    	
	    	//vm.isEODvalidated = result.responseReceived;
	    	
	    	if( result.responseReceived==true){
	    		vm.responseReceivedValidation = vm.COMPLETED;
	    		vm.responseReceivedMessage="";
	    		validateEod();
	    		
	    	}else{
	    		vm.responseReceivedValidation = vm.FAILED;
	    		//vm.responseReceivedMessage= $filter('translate')('gatewayApp.eodProcess.responseReceivedMessage');
	    		vm.responseReceivedMessage= "Not processed";
	    	}
	    	
    		
	    }
	    
	    function validateResponseReceivedFailure(error){
	    	var errorCode = '';
	    	if(error.data.validationMsg!=null && error.data.validationMsg!=undefined && error.data.validationMsg!=''){
	    		errorCode = $filter('translate')(error.data.validationMsg);
	    	}
	    	vm.responseReceivedMessage = errorCode;
	    	vm.responseReceivedValidation = vm.FAILED;
	    }
	    
	    
	    function validateSessionClose(){
	    	vm.sessionCloseValidation = vm.INPROGRESS;
	    	//vm.currentBusinessDate = DateUtils.convertLocalDateFromServer(vm.lastSystemSetting.businessDate);
	    	//convertedCurrentBusinessDate = DateUtils.convertLocalDateToServer(vm.currentBusinessDate);
            //$fileLogger.info('validateSessionClose');
	    	EODProcess.validateSessionClose({"currentBusinessDate" : convertedCurrentBusinessDate},validateSessionCloseSuccess,validateSessionCloseFailure);
	    	
	    }
	    
	    function validateSessionCloseSuccess(result){    	
	    	vm.isEODvalidated = result.isSessionClosed;
	    	if( result.isSessionClosed==true){
	    		vm.sessionCloseValidation = vm.COMPLETED;
	    		vm.sessionCloseMessage="";
	    		
	    	}else{
	    		vm.sessionCloseValidation = vm.FAILED;
	    		vm.sessionCloseMessage= $filter('translate')('gatewayApp.eodProcess.sessionCloseMessage');
	    	}
	    	
	    	
	    }
	    
	    function validateSessionCloseFailure(error){
	    	
	    	var errorCode = '';
	    	if(error.data.validationMsg!=null && error.data.validationMsg!=undefined && error.data.validationMsg!=''){
	    		errorCode = $filter('translate')(error.data.validationMsg);
	    	}
	    	vm.sessionCloseMessage=errorCode;
	    	vm.sessionCloseValidation = vm.FAILED;
	    }
	    var replaceAt=function(index, replacement, stringtoBemodified) {
	        return  replacement + this.substr(index+1, stringtoBemodified.length-1) + replacement;
	    }
	    /*********************** Process Methods for UpdateNewTradingBranchForCustomers ********************************************/
		

		var updateNewTradingBranchForCustomers  = function updateNewTradingBranchForCustomers(){
			
			updateRemarksInProcessList(vm.updateTradingBranchId ,"",   vm.INPROGRESS);
            $fileLogger.info('updateNewTradingBranchForCustomers');
			EODProcess.updateNewTradingBranchForCustomers( {
				"currentBusinessDate" : convertedCurrentBusinessDate,		
				"processId" : vm.updateTradingBranchId,
				"executionCount" : vm.executionCount
				
			}, updateTradingBranchSuccess, updateTradingBranchError);
		}
		function updateTradingBranchSuccess(result) {
			console.log(result)	;		
			console.log(result.data)	;
			console.log(result.message)	;
			var message = "";
			if(result != null && result!=undefined && result.message!=null && result.message!="" && result.message!=undefined){
				message = result.message
			}
			updateRemarksInProcessList(vm.updateTradingBranchId ,message,  vm.COMPLETED);
			
			successProcessor(shiftDate);
		}
		function updateTradingBranchError(error) {
			
			var errorCode = errorProcessor(error);
			updateRemarksInProcessList(vm.updateTradingBranchId ,errorCode , vm.FAILED );
			
		}
		
		/*********************** Prepare ********************************************/
	
	}
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('EODProcess', EODProcess);

    EODProcess.$inject = ['$resource','DateUtils'];

    function EODProcess ($resource, DateUtils) {
        var resourceUrl = 'api/eod-process/';
        return $resource(resourceUrl, {}, {
            
            'getCurrentBusinessDate': {
                method: 'GET',  
                url: 'api/eod-process',
                transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
            },
            'shiftDateInSystem' : {
				method : 'PUT',
				params : {
					currentBusinessDate : '@currentBusinessDate',
					processId : '@processId',
					executionCount : '@executionCount'
				},
				url : 'api/eod-process/new-system-settings',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
            
            'putEODProcessStatusLog' : {
				method : 'PUT',
				params : {
					currentBusinessDate : '@currentBusinessDate',
					nextBusinessDate : '@nextBusinessDate',
					isEodDone:'@isEodDone',
					errorMessage :'@errorMessage'
				},
				url : 'api/eod-process/update-eodProcess-status-log',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'getNextValidBusinessDate' : {
				method : 'GET',
				params : {
					
					currentBusinessDate : '@currentBusinessDate'
					
				},
				url : 'api/eod-process/get-next-system-date',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'generateEODEmails' : {
				method : 'GET',
				params : {
					
					currentBusinessDate : '@currentBusinessDate',
					processId : '@processId',
					executionCount : '@executionCount'
					
				},
				url : 'api/eod-process/generateEODEmail',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'makeUsersDormant' : {
				method : 'POST',
				params : {
					
					currentBusinessDate : '@currentBusinessDate',
					processId : '@processId',
					executionCount : '@executionCount'
					
				},
				url : 'api/eod-process/makeUsersDormant',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'autoWithdrwaPendingCustomers' : {
				method : 'POST',
				params : {
					
					currentBusinessDate : '@currentBusinessDate',
					processId : '@processId',
					executionCount : '@executionCount'
					
				},
				url : 'api/eod-process/autoWithdrawalOfPendingCustomers',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'processEOD' : {
				method : 'POST',
				params : {
					
					businessDate : '@businessDate',
					status : '@status',
					nextBusinessDate : '@nextBusinessDate'
					
				},
				url : 'api/eod-process/updateProcessStatus',
			},
			'logOffUsersForcibly' : {
				method : 'POST',
				params : {
					currentBusinessDate : '@currentBusinessDate',
					processId : '@processId',
					executionCount : '@executionCount'
				},
				url : 'api/eod-process/forcibleLogOff',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'processLimits' : {
				method : 'POST',
				params : {
					
					currentBusinessDate : '@currentBusinessDate',
					processId : '@processId',
					executionCount : '@executionCount'
					
				},
				url : 'api/eod-process/process-limits',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'archiveTables' : {
				method : 'POST',
				params : {
					
					currentBusinessDate : '@currentBusinessDate',
					processId : '@processId',
					executionCount : '@executionCount'
					
				},
				url : 'api/eod-process/archive-tables',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'prepareNextBusinessDateData' : {
				method : 'POST',
				params : {
					currentBusinessDate : '@currentBusinessDate',
					processId : '@processId',
					executionCount : '@executionCount'
					
				},
				url : 'api/eod-process/prepare-next-business-date-data',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'updateEODPRocessLog' : {
				method : 'POST',
				params : {
					
					businessDate : '@businessDate',
				},
				url : 'api/eod-process/updateProcessStatusLog',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'validateEOD' : {
				method : 'POST',
				url : 'api/eod-process/validateEOD',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'validateDBProcessing' : {
				method : 'POST',
				url : 'api/eod-process/validate-db-processing',
				params : {
					serverName : '@serverName'
				},
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'initiateEODInOrderService' :{
				
				method : 'POST',				
				url : 'order/process/eod',
				/*params : {
					
					executionCount : '@executionCount',
					businessDate : '@businessDate',
					processId : '@revokeProcessId'
				},*/
				transformRequest: function (data) {
                   	
                   	var copy =angular.toJson(data);
                   	
                       return copy;
                },
				transformResponse : function(data) {
					if(data!=null && data!=undefined && data !=''){
						if(data.substring(0,1)=='<'){
				
						}else {
							data = angular.fromJson(data);
							return data;
						}
					
					}
				}
				
			},
			'getEODProcessStatusLog' : {
				method : 'GET',
				params : {
					
					businessDate : '@businessDate'
					
				},
				url : 'api/eod-process/getEODProcessStatusLog',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'computeDailyTransactions' : {
				method : 'POST',
				params : {
					
					currentBusinessDate : '@currentBusinessDate',					
					processId : '@processId',
					executionCount : '@executionCount'
					
				},
				url : 'api/eod-process/compute-daily-transaction-charges',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'generateMonthEndBillingReport' : {
				method : 'POST',
				params : {
					
									
					processId : '@processId',
					executionCount : '@executionCount'
					
				},
				url : 'api/eod-process/generate-month-end-billing-report',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'generateYearEndBillingReport' : {
				method : 'POST',
				params : {
					
									
					processId : '@processId',
					executionCount : '@executionCount'
					
				},
				url : 'api/eod-process/generate-year-end-billing-report',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			/*'stopEODForcibly' :{
				method : 'POST',
				url : 'api/eod-process/stop-eod-forcibly',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},*/
			'insertProcessLog' :{
				method: 'POST',
				params : {
					
					currentBusinessDate : '@currentBusinessDate',
					processId : '@processId',
					executionCount : '@executionCount',
					errorMessageCode : '@errorMessageCode',
					isSuccess : '@isSuccess'
				},
				url : 'api/eod-process/insert-process-log',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},'validateSessionClose' : {
				method : 'POST',
				url : 'api/eod-process/validate-session-close',
				params : {
					currentBusinessDate : '@currentBusinessDate'
				},
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			
			'validateResponseReceived' : {
				method : 'POST',
				url : 'api/eod-process/validate-recon-response',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			
			
			
			'generateInvoice' : {
				method : 'GET',
				url : 'api/eod-process/generateTransactionInvoice',
				params : {
					billingDate : '@billingDate',
					orgId:'@orgId'
				},
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'aysncgenerateInvoice' : {
				method : 'GET',
				url : 'api/eod-process/async-generateInvoice',
				params : {
					billingDate : '@billingDate',
					orgId:'@orgId'
				},
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'updateNewTradingBranchForCustomers' : {
				method : 'POST',
				params : {					
									
					processId : '@processId',
					executionCount : '@executionCount',
					currentBusinessDate : '@currentBusinessDate'
					
				},
				url : 'api/eod-process/updateNewTradingBranchForCustomers',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			
			/*,
			'eodStatusUpdateOnRefresh' : {
				method : 'POST',
				params : {
					
					businessDate : '@businessDate',
					status : '@status',
					nextBusinessDate : '@nextBusinessDate'
					
				},
				url : 'api/eod-process/check-update-eod-status-on-refresh',
			},*/
			'initiateEODProcess' : {
				method : 'POST',
				params : {
					
					businessDate : '@businessDate',
					status : '@status',
					nextBusinessDate : '@nextBusinessDate',
					processId : '@processId',
					executionCount : '@executionCount',
					
				},
				url : 'api/process-eod',
			},
			'getAllEODProcessStatusLog' : {
				method : 'GET',
				isArray: true,
				params : {
					businessDate : '@businessDate'
				},
				url : 'api/eod-process/getAllEODProcessStatusLog',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			}
			
            
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('EmailSettingsDialogController', EmailSettingsDialogController);

    EmailSettingsDialogController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','Workflow','$uibModalInstance',
		'EmailSettings','entity','EmailCategory','DateUtils','AlertService','$filter'];

     function EmailSettingsDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService,Workflow, $uibModalInstance,
	 			EmailSettings,entity,EmailCategory,DateUtils,AlertService,$filter) {
        var vm = this;
        vm.emailSettings=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        $scope.showApproveRejectButton=false;
        $scope.showDiscardButton = false;
    	$scope.showResubmitButton=false;
        vm.resubmitEmailSettings = resubmitEmailSettings;
        vm.globalValues = GlobalValues;
        vm.discardEmailSettings = discardEmailSettings;
        vm.rejectEmailSettings= rejectEmailSettings;
        vm.approveEmailSettings= approveEmailSettings;
       vm.viewMode=false;
       vm.emailCategory = getEmailCategories();
       vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
       vm.Valid=false;
       vm.invalidEmails = [];
      
       vm.entity=vm.entityOwnerType;
       
       
       function getEmailCategories(){
    	   vm.entityOwnerTypeId = vm.globalValues.getEntityOwnerType().id;
    	   EmailCategory.getEmailCategoryForEntity({entityOwnerTypeId: vm.entityOwnerTypeId},function(result) {
               vm.emailCategory = result;
            }); 
       }
     
       function validateEmail(email) {
    	    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    	    return re.test(email);
    	}

       function testEmailValidation(email){
    	

    	var emails = email.split(';');

    	vm.invalidEmails=[];

    	for (var i = 0; i < emails.length; i++) { 
    	    if(!validateEmail(emails[i].trim())) {
    	      vm.invalidEmails.push(emails[i].trim())
    	    }
    	}

    	if(vm.invalidEmails.length>0){
    		
    		vm.Valid=false;
    	}else{
    		vm.Valid=true;
    	}

       }
    	
       $scope.$watch('vm.emailSettings.emailIds', function(value){
            if(value!=null && value!=undefined && value != ''){
                vm.emailSettings.emailIds = vm.emailSettings.emailIds.toLowerCase();
            }
       });
                
        if(workflowSharedService.viewFrom == 'emailSettings'){
        	vm.emailSettings=entity;
        	$scope.showButton = true;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'emailSettings_todolist_resubmit') {
        	vm.emailSettings =  angular.fromJson($rootScope.payload);
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=true;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'emailSettings_todolist_checker') {
        	vm.emailSettings =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = true;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom == 'emailSettings_todolist_maker') {
        	vm.emailSettings =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = true;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom=='emailSettings_auditlog'){
        	vm.emailSettings =  angular.fromJson($rootScope.payload);   
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
		
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	
        	vm.emailSettings.organisation=null;
        	if(vm.entityOwnerType=='Branch'){
        		vm.emailSettings.branch = vm.globalValues.getBranch();
        	}
        	
        	if(vm.emailSettings.emailIds!=null && vm.emailSettings.emailIds!=""){
        	testEmailValidation(vm.emailSettings.emailIds);
        	if(vm.Valid==true){
        		if (vm.emailSettings.id != null) {
    				EmailSettings.update({
    					"orgId" : GlobalValues.getOrgId()
    				}, vm.emailSettings, onSaveSuccess, onSaveError);
    			} else {
    				EmailSettings.save({
    					"orgId" : GlobalValues.getOrgId()
    				}, vm.emailSettings, onSaveSuccess, onSaveError);
    				
    			}
        	}else{
        		var error = $filter('translate')('gatewayApp.emailSettings.invalidEmail');
        		AlertService.error(error + vm.invalidEmails);
        		//AlertService.error($filter('translate')('gatewayApp.emailSettings.invalidEmail'),invalidEmails);
        	}
        	}else{
        		if (vm.emailSettings.id != null) {
    				EmailSettings.update({
    					"orgId" : GlobalValues.getOrgId()
    				}, vm.emailSettings, onSaveSuccess, onSaveError);
    			} else {
    				EmailSettings.save({
    					"orgId" : GlobalValues.getOrgId()
    				}, vm.emailSettings, onSaveSuccess, onSaveError);
    				
    			}
        	}
        	
        	
        	
        	
         }
      
       
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	
        	vm.clicked = false;
        }
        function resubmitEmailSettings() {
        	
        	vm.emailSettings.organisation=null;
        	if(vm.entityOwnerType=='Branch'){
        		vm.emailSettings.branch = vm.globalValues.getBranch();
        	}
        	if(vm.emailSettings.emailIds!=null && vm.emailSettings.emailIds!=""){
        	testEmailValidation(vm.emailSettings.emailIds);
        	if(vm.Valid==true){
        		EmailSettings.resubmit({"taskId" : $rootScope.taskID}, vm.emailSettings, onResubmitSuccess, onResubmitError);
            	
           		
            	$uibModalInstance.dismiss('cancel');
        	}else{
        		var error = $filter('translate')('gatewayApp.emailSettings.invalidEmail');
        		AlertService.error(error + vm.invalidEmails);
        		//AlertService.error($filter('translate')('gatewayApp.emailSettings.invalidEmail'),invalidEmails);
        	}
        	}else{
        		EmailSettings.resubmit({"taskId" : $rootScope.taskID}, vm.emailSettings, onResubmitSuccess, onResubmitError);
            	
           		
            	$uibModalInstance.dismiss('cancel');
        	}
        	
        	
        			
        		
        	}
        	
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {
        	vm.clicked= false;
        }

        function approveEmailSettings() { 
        	EmailSettings.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectEmailSettings() { Workflow.rejectTask($rootScope.taskID); }

        function discardEmailSettings() {
        	EmailSettings.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }

     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('email-settings', {
            parent: 'entity',
            url: '/email-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.emailSettings.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/email-settings/email-settings.html',
                    controller: 'EmailSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('emailSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('email-view', {
            parent: 'email-settings',
            url: '/email-settings/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/email-settings/email-settings-view-dialog.html',
                    controller: 'EmailSettingsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['EmailSettings', 'GlobalValues', function(EmailSettings, GlobalValues) {
                                     return EmailSettings.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('email-new', {
            parent: 'email-settings',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/email-settings/email-settings-dialog.html',
                    controller: 'EmailSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	                           	
                             
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('email-edit', {
            parent: 'email-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/email-settings/email-settings-dialog.html',
                    controller: 'EmailSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['EmailSettings', 'GlobalValues', function(EmailSettings, GlobalValues) {
                                     return EmailSettings.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('email-todolist', {
            parent: 'dashboard',
            url: '/emailSettings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/email-settings/email-settings-dialog.html',
                    controller: 'EmailSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('email-settings', null, { reload: 'email-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('email-todolist.resubmit', {
            parent: 'dashboard',
            url: '/emailSettingsEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/email-settings/email-settings-dialog.html',
                    controller: 'EmailSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('email-settings', null, { reload: 'email-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('email-auditLog', {
            parent: 'audit-log',
            url: '/emailSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/email-settings/email-settings-dialog.html',
                    controller: 'EmailSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('email-settings', null, { reload: 'email-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('email-historyReport', {
            parent: 'history-report',
            url: '/emailettingsHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/email-settings/email-settings-dialog.html',
                    controller: 'EmailSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('email-settings', null, { reload: 'email-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('EmailSettings', EmailSettings);

    EmailSettings.$inject = ['$resource'];

    function EmailSettings ($resource) {
        var resourceUrl =  'api/email-settings/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/orgId/:orgId/email-settings'
        	 },
         	
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
             'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/email-settings/orgId/:orgId',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
        	
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/update-email-settings/orgId/:orgId',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/email-settings',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'emailSettings'
        })
        
        .controller('EmailSettingsController', EmailSettingsController);

    EmailSettingsController.$inject = ['$scope', '$state', 'EmailSettings', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout'];

    function EmailSettingsController($scope, $state, EmailSettings , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout) {
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.EMAIL_SETTINGS;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.screenLog = ScreenLog;
        $scope.refresh=refresh;
        workflowSharedService.viewFrom = "emailSettings";
        
        vm.launch=launch;
        function launch() {
        	$state.go("email-new");
        }
        
        
        
        vm.permitEmailSettingsEditEntityAction = EntityPermissions.hasPermission('EmailSettings.EDIT');
        vm.permitEmailSettingsAddEntityAction = EntityPermissions.hasPermission('EmailSettings.CREATE');
        
        logScreenAccess();
        loadAll();
       

       function loadAll() {
    	   
    	   EmailSettings.query({"orgId": GlobalValues.getOrgId()},function(result) {
               vm.emailSettings = result;
            });  
    	 
        }      
       
      
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('EmailCategory', EmailCategory);

    EmailCategory.$inject = ['$resource'];

    function EmailCategory ($resource) {
        var resourceUrl =  'api/email-category/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getEmailCategoryForEntity': {
                method: 'GET',
                params: {entityOwnerTypeId:'@entityOwnerTypeId'},
                isArray: true,
                url: 'api/email-category-for-entity/entityOwnerTypeId/:entityOwnerTypeId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('e-invoice-upload-view', {
            parent: 'entity',
            params:{screen: 'eInvoiceUpload'},
            url: '/e-invoice-upload',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.eInvoiceUpload.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/e-invoice-upload/e-invoice-upload.html',
                    controller: 'EInvoiceUploadController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                   
                    $translatePartialLoader.addPart('eInvoiceUpload');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                chargeTypes: ['StaticLookUp', function(StaticLookUp){
                    return StaticLookUp.getChargesType().$promise;
                }],
                systemSettings: ['IntradayMarket', function(IntradayMarket) {
                    return IntradayMarket.getCurrentBusinessDate().$promise;
                }],
                previousSystemSettings:['TransactionChargesSummaryView',function(TransactionChargesSummaryView){
                	return TransactionChargesSummaryView.getPreviousBusinessDate().$promise;
                }],
                configSetting :['GlobalValues', function(GlobalValues) {
                    return GlobalValues.getConfigSettings();
                }],
                financialYears: ['StaticLookUp', function(StaticLookUp){
					return StaticLookUp.getPastAndPresentFinancialYears().$promise;
				}]
               
            }
        })
      
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('EInvoiceUpload', EInvoiceUpload);

        EInvoiceUpload.$inject = ['$resource'];

    function EInvoiceUpload($resource) {
        var resourceUrl =  'api/e-invoice-upload';

        return $resource(resourceUrl, {}, {
        	   'uploadFiles': {
                   method: 'POST',
                   url: 'api/upload-eInvoice-jsonMappingfiles',
                //   params: {chargeTypeId : '@chargeTypeId', financialYearId : '@financialYearId'},
                   headers: {'Content-Type': undefined},
                   responseType: 'arraybuffer',
                   transformResponse: function(data, headers) {
                 	  return {
                           data: data,
                           headers: headers
                       };   
                   }         
              }
            
            
              });
    }
})();

            

(function () {
	'use strict';

	angular
		.module('gatewayApp')
		.service("workflowSharedService", function () {
			this.viewFrom = 'eInvoiceUpload'
		})

		.controller('EInvoiceUploadController', EInvoiceUploadController);

	EInvoiceUploadController.$inject = ['$scope', '$state', 'workflowSharedService', 'EInvoiceUpload', 'chargeTypes', 'configSetting', 'EntityPermissions', 'ScreenLog', 'entityConstants', 'ImportFile', 'AlertService', '$filter', 'ImportFileService', 'MessageBox', 'FileUtil', '$rootScope', 'DateUtils', 'systemSettings', 'previousSystemSettings','financialYears'];
	function EInvoiceUploadController($scope, $state, workflowSharedService, EInvoiceUpload, chargeTypes, configSetting, EntityPermissions, ScreenLog, entityConstants, ImportFile, AlertService, $filter, ImportFileService, MessageBox, FileUtil, $rootScope, DateUtils, systemSettings, previousSystemSettings,financialYears) {

		var vm = this;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.EINVOICE_UPLOAD;
		vm.entityConstants = entityConstants;
		vm.screenLog = ScreenLog;
		vm.uploadFiles = uploadFiles;
		vm.chargeTypes = chargeTypes;
		vm.chargesType = angular.copy(vm.chargeTypes[2]);
		vm.financialYears = financialYears;
		
		vm.checkZipFile = false;
		vm.checkMappingFile = false;
		vm.invalidJsonZipSize = false;
		vm.invalidJsonZipSizeText = "Maximum of 3MB file size is allowed";
		vm.invalidJsonZipText = "Accepted file format .zip";
		vm.invalidMappingFileSizeText = "Maximum of 3MB file size is allowed";
		vm.invalidMappingFileText = "Accepted file format .xls, .xlsx";
		vm.loadFinancialMonthOption = loadFinancialMonthOption;
		vm.loadFinancialYearDisplay = loadFinancialYearDisplay;
		
		vm.configSettings = configSetting;
		vm.noOFMonthsToDisplayForReports = vm.configSettings.noOfMOnthsForHistoricalReportsView;
		vm.previousFiancialMonthOptions = [];
		vm.invalidJsonZip = false;
		vm.invalidMappingFile = false;
		vm.invalidMappingFileSize = false;
		vm.uploadedIfscData = null;
		var MappingExtensions = ["xls", "xlsx"];
		var JsonExtension = ["zip"];
		workflowSharedService.viewFrom = "eInvoiceUpload";




		var minJsonFileSizeinBytes = 1;
		var maxJsonFileSizeinBytes = 3 * 1024 * 1024;
		var minMappingFileSizeinBytes = 1;
		var maxMappingFileSizeinBytes = 3 * 1024 * 1024;
		vm.fileExtension = "";
		vm.inputJsonZipFileName = "";
		vm.inputMappingFileName = "";
		vm.fileNameWithoutExtension = "";
		if (vm.configSettings != null && vm.configSettings != undefined && vm.configSettings.noOfMOnthsForHistoricalReportsView != null && vm.configSettings.noOfMOnthsForHistoricalReportsView != undefined && !isNaN(vm.configSettings.noOfMOnthsForHistoricalReportsView)) {
			vm.noOFMonthsToDisplayForReports = vm.configSettings.noOfMOnthsForHistoricalReportsView;
		}
		else {
			vm.noOFMonthsToDisplayForReports = 2;
		}
		if (systemSettings != null && systemSettings != undefined && previousSystemSettings != null && previousSystemSettings != undefined) {
			vm.currentBusinessDate = systemSettings.businessDate;
			vm.previousBusinessDate = previousSystemSettings.businessDate;
			vm.currentBusinessDateMoment = moment(DateUtils.convertLocalDateFromServer(angular.copy(vm.currentBusinessDate)));
			vm.previousBusinessDateMoment = moment(DateUtils.convertLocalDateFromServer(angular.copy(vm.previousBusinessDate)));
			loadFinancialMonthOption();
		}
		function loadFinancialMonthOption() {
			vm.previousFiancialMonthOptions = [];
			if(vm.configSettings.billingEndDate!=null && vm.configSettings.billingEndDate !=""){
				vm.previousFiancialMonthOptions.push(createMonthOptions(angular.copy(vm.currentBusinessDateMoment)));	//temporary
			}
			var monthCount = 1;
			for (monthCount = 1; monthCount <= vm.noOFMonthsToDisplayForReports; monthCount++) {
				vm.previousFiancialMonthOptions.push(createMonthOptions(angular.copy(vm.currentBusinessDateMoment).subtract(monthCount, 'month')))
			}
			vm.financialMonth = angular.copy(vm.previousFiancialMonthOptions[0]);
			

		}
		loadFinancialYearDisplay();
		function loadFinancialYearDisplay(){
			var yearCount = 0;
			if(vm.financialYears != null && vm.financialYears != undefined){
				for(yearCount = 0;yearCount < vm.financialYears.length; yearCount++){
					var fromYear = moment(DateUtils.convertLocalDateFromServer(angular.copy(vm.financialYears[yearCount].financialYearStart))).year();
					var toYear = moment(DateUtils.convertLocalDateFromServer(angular.copy(vm.financialYears[yearCount].financialYearEnd))).year();
					var displayYear = fromYear+"-"+ toYear;
					vm.financialYears[yearCount].displayYear = displayYear;
				}
			}
			vm.allFinancialYears = [];
			if(vm.configSettings.billingEndDate!=null && vm.configSettings.billingEndDate !=""){
				vm.allFinancialYears.push(angular.copy(vm.financialYears[0]));	//temporary
			}
			vm.allFinancialYears.push(angular.copy(vm.financialYears[1]));
			vm.financialYear =  angular.copy(vm.financialYears[1]);
			
		}
		vm.createMonthOptions = createMonthOptions;
		function createMonthOptions(dateMoment) {
			var currentMonthOption = {}
			currentMonthOption.date = angular.copy(dateMoment).startOf('month');
			currentMonthOption.monthDisplay = dateMoment.format('MMM - YYYY');
			return currentMonthOption;

		}




		logScreenAccess();
		function logScreenAccess() {
			ScreenLog.screenLog(vm.screenName, 0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}
		function uploadFiles() {
			if (vm.mappingFile != null && vm.jsonZipFile != null) {
				if(vm.chargesType.shortName!='AMC'){
					vm.fromDate = angular.copy( vm.financialMonth.date).toDate();
					vm.toDate =angular.copy( vm.financialMonth.date).endOf('month').toDate();
				}else{
				vm.fromDate = DateUtils.convertLocalDateFromServer(angular.copy(vm.financialYear.financialYearStart));
			    vm.toDate  = DateUtils.convertLocalDateFromServer(angular.copy(vm.financialYear.financialYearEnd));
				}
				
				var fd1 = new FormData();
				fd1.append('chargeTypeId', JSON.stringify(vm.chargesType.id));
				fd1.append('fromDate', DateUtils.convertLocalDateToServer(vm.fromDate));
				fd1.append('toDate', DateUtils.convertLocalDateToServer(vm.toDate));
				fd1.append('jsonFile', vm.jsonZipFile);
				fd1.append('mappingFile', vm.mappingFile);
				EInvoiceUpload.uploadFiles(fd1, onSaveSuccess, onSaveError);
				
				

			}

		}
		function onSaveSuccess(result) {
			resetMappingFileValue();
				resetJsonFileValue();
				vm.clicked = false;
		}


		function onSaveError() {
			resetMappingFileValue();
			resetJsonFileValue();
			vm.clicked = false;
		}
		function resetJsonFileValue() {
			vm.inputJsonZipFileName = null;
			vm.jsonZipFile = null;
			vm.checkZipFile = false;
		}
		function resetMappingFileValue() {
			vm.mappingFile = null;
			vm.inputMappingFileName = null;
			vm.checkMappingFile = false;
		}
		$scope.$watch('vm.jsonZipFile', function (value) {
			if (value != null && value != undefined) {
				vm.inputJsonZipFileName = value.name;

				if (!FileUtil.isFileSizeValid(value.size, minJsonFileSizeinBytes, maxJsonFileSizeinBytes)) {
					vm.invalidJsonZipSize = true;
					vm.invalidJsonZip = false;
					resetJsonFileValue();

				} else {
					vm.fileNameWithoutExtension = "";
					vm.invalidJsonZipSize = false;
					vm.invalidJsonZip = false;
					vm.fileExtension = vm.inputJsonZipFileName.substring(value.name.lastIndexOf(".") + 1);
					if (JsonExtension.indexOf(vm.fileExtension.toLowerCase()) <= -1) {
						resetJsonFileValue();
						//check for extension
						vm.invalidJsonZip = true;
						vm.invalidJsonZipSize = false;
					}
					else {
						var reader = new FileReader();
						reader.readAsArrayBuffer(value);

						reader.onloadend = function (e) {
							if (e.target.readyState === FileReader.DONE) {
								var bytes = new Uint8Array(e.target.result);
								var arr = bytes.subarray(0, 4);
								if (!FileUtil.checkZipFileExtension(arr)) {
									resetJsonFileValue();
									vm.invalidJsonZip = true;
									vm.invalidJsonZipSize = false;
								} else {

									vm.invalidJsonZip = false;
									vm.invalidJsonZipSize = false;

								}
								$scope.$digest();
							}

						};

					}
				}
			}
			else {
				document.getElementById("jsonFile").value = null;
				resetJsonFileValue();
			}
		});
		$scope.$watch('vm.mappingFile', function (value) {
			if (value != null && value != undefined) {
				vm.inputMappingFileName = value.name;

				if (!FileUtil.isFileSizeValid(value.size, minMappingFileSizeinBytes, maxMappingFileSizeinBytes)) {
					resetMappingFileValue();
					vm.invalidMappingFileSize = true;
					vm.invalidMappingFile = false;

				} else {
					vm.fileNameWithoutExtension = "";
					vm.invalidMappingFileSize = false;
					vm.invalidMappingFile = false;
					vm.fileExtension = vm.inputMappingFileName.substring(value.name.lastIndexOf(".") + 1);
					if (MappingExtensions.indexOf(vm.fileExtension.toLowerCase()) <= -1) {
						resetMappingFileValue();
						//check for extension
						vm.invalidMappingFile = true;
						vm.invalidMappingFileSize = false;
					}
					else {
						var reader = new FileReader();
						reader.readAsArrayBuffer(value);

						reader.onloadend = function (e) {
							if (e.target.readyState === FileReader.DONE) {
								var bytes = new Uint8Array(e.target.result);
								var arr = bytes.subarray(0, 4);
								if (!FileUtil.checkExcelFileExtension(arr)) {
									resetMappingFileValue();;
									vm.invalidMappingFile = true;
									vm.invalidMappingFileSize = false;
								} else {

									vm.invalidMappingFile = false;
									vm.invalidMappingFileSize = false;

								}
								$scope.$digest();
							}

						};

					}
				}
			}
			else {
				document.getElementById("mappingFile").value = null;
				resetMappingFileValue();
			}
		});



	}
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('DefaultMarkupSettingsViewController', DefaultMarkupSettingsViewController);

    DefaultMarkupSettingsViewController.$inject = ['$scope', '$state','$rootScope','workflowSharedService','$uibModalInstance','DefaultMarkup','entity', 'Workflow', 'GlobalValues', 'ScreenLog','StaticLookUp','markupTypes', 'roEdApplicabilityMethods' ];

    function DefaultMarkupSettingsViewController($scope, $state, $rootScope, workflowSharedService, $uibModalInstance,DefaultMarkup,entity, Workflow, GlobalValues, ScreenLog, StaticLookUp,markupTypes,roEdApplicabilityMethods) {
        var vm = this;
        vm.clear=clear;
        vm.approveDefaultMarkup = approveDefaultMarkup;
        vm.rejectDefaultMarkup = rejectDefaultMarkup;
        vm.discardDefaultMarkup = discardDefaultMarkup;
        $scope.showButton = false;
        $scope.showDiscardButton = false;
        $scope.clicked=false;
        vm.globalValues = GlobalValues;
        vm.markupTypes = markupTypes;
        
        //get RO/ED applicability method list lookup
        // StaticLookUp.getRoEdApplicabilityMethodList(function(result){
        //     vm.roEdApplicabilityMethodList = result;
        // });
        vm.roEdApplicabilityMethodList = roEdApplicabilityMethods;

        vm.hideRoEdApplicability = false;
        
        $scope.$watch('vm.markupType', function(value){
        	if(value!=null && value!=undefined){
        		if(vm.markupType.shortName=='Percentage'){
        			vm.noOfDecimals="3";
        		}else{
        			vm.noOfDecimals="2";
        		}
        	}
        });
        
        if(workflowSharedService.viewFrom == 'defaultMarkup'){
        	vm.defaultMarkup = entity;    
        	angular.forEach(vm.markupTypes, function(value){
        		if(value.shortName==vm.defaultMarkup.markupType){
            		vm.markupType = value; 
        		}
        	});
            if(vm.defaultMarkup.roEdApplicabilityMethod!=null && vm.defaultMarkup.roEdApplicabilityMethod!=undefined){
                vm.roEdApplicabilityMethod = vm.defaultMarkup.roEdApplicabilityMethod;
            }else{
                var defaultROEDApplicabilityMethod = _.filter(angular.copy(vm.roEdApplicabilityMethodList), { 'shortName': 'BOTHLEGS' });
                vm.roEdApplicabilityMethod = defaultROEDApplicabilityMethod[0];
            }

       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'defaultMarkuptodolist_checker') {
        	vm.defaultMarkup =  angular.fromJson($rootScope.payload); 
        	angular.forEach(vm.markupTypes, function(value){
        		if(value.shortName==vm.defaultMarkup.markupType){
            		vm.markupType = value; 
        		}
        	});
            if(vm.defaultMarkup.roEdApplicabilityMethod!=null && vm.defaultMarkup.roEdApplicabilityMethod!=undefined){
                vm.roEdApplicabilityMethod = vm.defaultMarkup.roEdApplicabilityMethod;
            }else{
                var defaultROEDApplicabilityMethod = _.filter(angular.copy(vm.roEdApplicabilityMethodList), { 'shortName': 'BOTHLEGS' });
                vm.roEdApplicabilityMethod = defaultROEDApplicabilityMethod[0];
            }

        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
        }
        else if(workflowSharedService.viewFrom == 'defaultMarkuptodolist_maker') {
        	vm.defaultMarkup =  angular.fromJson($rootScope.payload); 
        	angular.forEach(vm.markupTypes, function(value){
        		if(value.shortName==vm.defaultMarkup.markupType){
            		vm.markupType = value; 
        		}
        	});
            if(vm.defaultMarkup.roEdApplicabilityMethod!=null && vm.defaultMarkup.roEdApplicabilityMethod!=undefined){
                vm.roEdApplicabilityMethod = vm.defaultMarkup.roEdApplicabilityMethod;
            }else{
                var defaultROEDApplicabilityMethod = _.filter(angular.copy(vm.roEdApplicabilityMethodList), { 'shortName': 'BOTHLEGS' });
                vm.roEdApplicabilityMethod = defaultROEDApplicabilityMethod[0];
            }

        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        }
        else if(workflowSharedService.viewFrom=='defaultMarkup_auditlog'){
        	vm.defaultMarkup =  angular.fromJson($rootScope.payload);   
        	angular.forEach(vm.markupTypes, function(value){
        		if(value.shortName==vm.defaultMarkup.markupType){
            		vm.markupType = value; 
        		}
        	});
            if(vm.defaultMarkup.roEdApplicabilityMethod!=null && vm.defaultMarkup.roEdApplicabilityMethod!=undefined){
                vm.roEdApplicabilityMethod = vm.defaultMarkup.roEdApplicabilityMethod;
            }else{
                vm.hideRoEdApplicability = true;
                //var defaultROEDApplicabilityMethod = _.filter(angular.copy(vm.roEdApplicabilityMethodList), { 'shortName': 'BOTHLEGS' });
                //vm.roEdApplicabilityMethod = defaultROEDApplicabilityMethod[0];
            }

        	$scope.showButton=false;

        }
        
        function approveDefaultMarkup() { 
        	DefaultMarkup.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectDefaultMarkup() { Workflow.rejectTask($rootScope.taskID); }

        function discardDefaultMarkup() {
        	DefaultMarkup.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }

       
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('DefaultMarkupSettingsEditController', DefaultMarkupSettingsEditController);

    DefaultMarkupSettingsEditController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','DefaultMarkup','entity','StaticLookUp', 'markupTypes', 'roEdApplicabilityMethods'];

     function DefaultMarkupSettingsEditController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,DefaultMarkup,entity,StaticLookUp, markupTypes, roEdApplicabilityMethods) {
        var vm = this;
        vm.defaultMarkup=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        vm.resubmitDefaultMarkup = resubmitDefaultMarkup;
        vm.globalValues = GlobalValues;
        vm.markupTypes = markupTypes;
        
        $scope.showButton = false;
        vm.disableTax=false;

        //get RO/ED applicability method list lookup
        // StaticLookUp.getRoEdApplicabilityMethodList(function(result){
        //     vm.roEdApplicabilityMethodList = result;
        // });
        vm.roEdApplicabilityMethodList = roEdApplicabilityMethods;
        
        $scope.$watch('vm.markupType', function(value){
        	if(value!=null && value!=undefined){
        		if(vm.markupType.shortName=='Percentage'){
        			vm.noOfDecimals="3";
        			document.getElementById("txtMarkupValue2").value = "";
        			vm.defaultMarkup.markupValue = null;
        		}else{
        			vm.noOfDecimals="2";
        			document.getElementById("txtMarkupValue1").value = "";
        			vm.defaultMarkup.markupValue = null;
        		}
        	}
        });
        
        $scope.$watch('vm.defaultMarkup.markupValue', function(value){
        	if(value==null || value==undefined || value==""){
        		
        		vm.disableTax=true;
        		document.getElementById("txtTaxOnMarkup").value = "";
        		vm.defaultMarkup.taxOnMarkup=null;
        	}else{
        		vm.disableTax=false;
        	}
        });
       
                
        if(workflowSharedService.viewFrom == 'defaultMarkup'){
        	vm.defaultMarkup=entity;

        	angular.forEach(vm.markupTypes, function(value){
        		if(value.shortName==vm.defaultMarkup.markupType){
            		vm.markupType = value; 
        		}
        	});
        	
            if(vm.defaultMarkup.roEdApplicabilityMethod!=null && vm.defaultMarkup.roEdApplicabilityMethod!=undefined){
                vm.roEdApplicabilityMethod = vm.defaultMarkup.roEdApplicabilityMethod;
            }else{
                var defaultROEDApplicabilityMethod = _.filter(angular.copy(vm.roEdApplicabilityMethodList), { 'shortName': 'BOTHLEGS' });
                vm.roEdApplicabilityMethod = defaultROEDApplicabilityMethod[0];
            }

       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'defaultMarkuptodolist_resubmit') {
        	vm.defaultMarkup =  angular.fromJson($rootScope.payload);
        	angular.forEach(vm.markupTypes, function(value){
        		if(value.shortName==vm.defaultMarkup.markupType){
            		vm.markupType = value; 
        		}
        	});
            if(vm.defaultMarkup.roEdApplicabilityMethod!=null && vm.defaultMarkup.roEdApplicabilityMethod!=undefined){
                vm.roEdApplicabilityMethod = vm.defaultMarkup.roEdApplicabilityMethod;
            }else{
                var defaultROEDApplicabilityMethod = _.filter(angular.copy(vm.roEdApplicabilityMethodList), { 'shortName': 'BOTHLEGS' });
                vm.roEdApplicabilityMethod = defaultROEDApplicabilityMethod[0];
            }

        	vm.disableForm = false;
        	$scope.showButton=true;
        }
        else if(workflowSharedService.viewFrom == 'defaultMarkup_resubmit_delete') {
        	vm.defaultMarkup = angular.fromJson($rootScope.payload); 
        	angular.forEach(vm.markupTypes, function(value){
        		if(value.shortName==vm.defaultMarkup.markupType){
            		vm.markupType = value; 
        		}
        	});
            if(vm.defaultMarkup.roEdApplicabilityMethod!=null && vm.defaultMarkup.roEdApplicabilityMethod!=undefined){
                vm.roEdApplicabilityMethod = vm.defaultMarkup.roEdApplicabilityMethod;
            }else{
                var defaultROEDApplicabilityMethod = _.filter(angular.copy(vm.roEdApplicabilityMethodList), { 'shortName': 'BOTHLEGS' });
                vm.roEdApplicabilityMethod = defaultROEDApplicabilityMethod[0];
            }

        	vm.disableForm = true;
        	$scope.showButton=true;
        }
		
		

        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	vm.defaultMarkup.markupType = vm.markupType.shortName;
            vm.defaultMarkup.roEdApplicabilityMethod = vm.roEdApplicabilityMethod;
        	DefaultMarkup.update({ "orgId": vm.globalValues.getOrgId() },vm.defaultMarkup, onSaveSuccess, onSaveError);
         }
      
       
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	
        	vm.clicked = false;
        }
        function resubmitDefaultMarkup() {
        	vm.defaultMarkup.roEdApplicabilityMethod = vm.roEdApplicabilityMethod;
        	DefaultMarkup.resubmit({"taskId" : $rootScope.taskID}, vm.defaultMarkup, onResubmitSuccess, onResubmitError);
        	
       		
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {
        	vm.clicked = false;
        }

       
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('default-markup-settings', {
            parent: 'entity',
            url: '/default-markup-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.defaultMarkupSettings.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/default-markup-settings/default-markup-settings.html',
                    controller: 'DefaultMarkupSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('defaultMarkupSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('default-markup-view', {
            parent: 'default-markup-settings',
            url: '/default-markup-settings/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-markup-settings/default-markup-settings-view-dialog.html',
                    controller: 'DefaultMarkupSettingsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	
                            	 entity: ['DefaultMarkup', 'GlobalValues', function(DefaultMarkup, GlobalValues) {
                                     return DefaultMarkup.get({id : $stateParams.id}).$promise;
                                 }], 
                                 markupTypes: ['StaticLookUp', function(StaticLookUp){
                                	 return StaticLookUp.getMarkupTypes().$promise;
                                 }],
                                 roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                                    return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                                }]
                               
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('default-markup-edit', {
            parent: 'default-markup-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-markup-settings/default-markup-settings-edit-dialog.html',
                    controller: 'DefaultMarkupSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	
                            	 entity: ['DefaultMarkup', 'GlobalValues', function(DefaultMarkup, GlobalValues) {
                                     return DefaultMarkup.get({id : $stateParams.id}).$promise;
                                 }], 
                                 markupTypes: ['StaticLookUp', function(StaticLookUp){
                                	 return StaticLookUp.getMarkupTypes().$promise;
                                 }],
                                 roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                                    return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                                }]
                               
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('default-markup-todolist', {
            parent: 'dashboard',
            url: '/defaultMarkupSettings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-markup-settings/default-markup-settings-view-dialog.html',
                    controller: 'DefaultMarkupSettingsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }, 
                        markupTypes: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('default-markup-settings', null, { reload: 'default-markup-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('default-markup-todolist.resubmit', {
            parent: 'dashboard',
            url: '/defaultMarkupSettingsEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-markup-settings/default-markup-settings-edit-dialog.html',
                    controller: 'DefaultMarkupSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }, 
                        markupTypes: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('default-markup-settings', null, { reload: 'default-markup-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('default-markup-auditLog', {
            parent: 'audit-log',
            url: '/defaultMarkupSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-markup-settings/default-markup-settings-view-dialog.html',
                    controller: 'DefaultMarkupSettingsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }, 
                        markupTypes: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('default-markup-settings', null, { reload: 'default-markup-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('default-markup-historyReport', {
            parent: 'history-report',
            url: '/defaultMarkupettingsHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-markup-settings/default-markup-settings-view-dialog.html',
                    controller: 'DefaultMarkupSettingsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }, 
                        markupTypes: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('default-markup-settings', null, { reload: 'default-markup-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('DefaultMarkup', DefaultMarkup);

    DefaultMarkup.$inject = ['$resource'];

    function DefaultMarkup ($resource) {
        var resourceUrl =  'api/default-markup-settings/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/orgId/:orgId/view-default-markup-settings'
        	 },
         	
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
        	
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/orgId/:orgId/default-markup-settings',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/default-markup-settings',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              },
              'getByBank': {
                method: 'GET',
                url: 'api/default-markup-settings-by-bank/:bankId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'defaultMarkup'
        })
        
        .controller('DefaultMarkupSettingsController', DefaultMarkupSettingsController);

    DefaultMarkupSettingsController.$inject = ['$scope', '$state', 'DefaultMarkup', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout'];

    function DefaultMarkupSettingsController($scope, $state, DefaultMarkup , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.DEFAULT_MARKUP_SETTINGS;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "defaultMarkup";
        vm.entityOwnerType=vm.globalValues.getEntityOwnerType().shortName;
        $scope.refresh=refresh;
        
        vm.permitDefaultMarkupSettingsEditEntityAction = EntityPermissions.hasPermission('DefaultMarkupSettings.EDIT');
        vm.permitDefaultMarkupSettingsViewEntityAction = EntityPermissions.hasPermission('DefaultMarkupSettings.VIEW');
        
        logScreenAccess();
        loadAll();

       function loadAll() {
    	   DefaultMarkup.query({"orgId": GlobalValues.getOrgId()},function(result) {
                vm.defaultMarkup = result;
             });        	
        }      
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('DefaultMarketSessionDialogController', DefaultMarketSessionDialogController);

    DefaultMarketSessionDialogController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','Workflow','$uibModalInstance','DefaultMarket','entity','StaticLookUp','DateUtils','AlertService'];

     function DefaultMarketSessionDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService,Workflow, $uibModalInstance,DefaultMarket,entity,StaticLookUp,DateUtils,AlertService) {
        var vm = this;
        vm.defaultMarket=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        $scope.showApproveRejectButton=false;
        $scope.showDiscardButton = false;
    	$scope.showResubmitButton=false;
        vm.resubmitDefaultMarket = resubmitDefaultMarket;
        vm.globalValues = GlobalValues;
        vm.discardDefaultMarket = discardDefaultMarket;
        vm.rejectDefaultMarket= rejectDefaultMarket;
        vm.approveDefaultMarket= approveDefaultMarket;
       vm.viewMode=false;
      vm.controlMinDate =new Date();
                
        if(workflowSharedService.viewFrom == 'defaultMarketSessionSettings'){
        	vm.defaultMarket=entity;

            if(!vm.defaultMarket.instrumentApplicable){
            AlertService.error("Instrument is disabled. Editing is not allowed");
             $scope.showButton = false;
            }else{
                $scope.showButton = true;
            }
        	vm.inputCloseTime = moment(vm.defaultMarket.inputCloseTime, 'HH:mm');
        	vm.inputOpenTime = moment(vm.defaultMarket.inputOpenTime,'HH:mm');
        	
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'defaultMarketSessionSettings_todolist_resubmit') {
        	vm.defaultMarket =  angular.fromJson($rootScope.payload);
        	vm.inputCloseTime = moment(vm.defaultMarket.inputCloseTime, 'HH:mm');
        	vm.inputOpenTime = moment(vm.defaultMarket.inputOpenTime,'HH:mm');
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=true;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'defaultMarketSessionSettings_todolist_checker') {
        	vm.defaultMarket =  angular.fromJson($rootScope.payload); 
        	vm.inputCloseTime = moment(vm.defaultMarket.inputCloseTime, 'HH:mm');
        	vm.inputOpenTime = moment(vm.defaultMarket.inputOpenTime,'HH:mm');
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = true;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom == 'defaultMarketSessionSettings_todolist_maker') {
        	vm.defaultMarket =  angular.fromJson($rootScope.payload); 
        	vm.inputCloseTime = moment(vm.defaultMarket.inputCloseTime, 'HH:mm');
        	vm.inputOpenTime = moment(vm.defaultMarket.inputOpenTime,'HH:mm');
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = true;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom=='defaultMarketSessionSettings_auditlog'){
        	vm.defaultMarket =  angular.fromJson($rootScope.payload);   
        	vm.inputCloseTime = moment(vm.defaultMarket.inputCloseTime, 'HH:mm');
        	vm.inputOpenTime = moment(vm.defaultMarket.inputOpenTime,'HH:mm');
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
        
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	
        	vm.defaultMarket.inputOpenTime = vm.inputOpenTime.format( 'HH:mm');
        	vm.defaultMarket.inputCloseTime = vm.inputCloseTime.format( 'HH:mm');
        	
        	DefaultMarket.update({
					"orgId" : GlobalValues.getOrgId()
				}, vm.defaultMarket, onSaveSuccess, onSaveError);
			
        	
         }
      
       
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	
        	vm.clicked = false;
        }
        function resubmitDefaultMarket() {
        	vm.defaultMarket.inputOpenTime = vm.inputOpenTime.format( 'HH:mm');
        	vm.defaultMarket.inputCloseTime = vm.inputCloseTime.format( 'HH:mm');
        	DefaultMarket.resubmit({"taskId" : $rootScope.taskID}, vm.defaultMarket, onResubmitSuccess, onResubmitError);
        	
       		
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {
        	vm.clicked = false;
        }

        function approveDefaultMarket() { 
        	DefaultMarket.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectDefaultMarket() { Workflow.rejectTask($rootScope.taskID); }

        function discardDefaultMarket() {
        	DefaultMarket.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }

     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('default-market-session-settings', {
            parent: 'entity',
            url: '/default-market-session-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.defaultMarketSessionSettings.manageDefaultMarketSessionSettings" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/default-market-session-settings/default-market-session-settings.html',
                    controller: 'DefaultMarketSessionSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('defaultMarketSessionSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('default-market-edit', {
            parent: 'default-market-session-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-market-session-settings/default-market-session-settings-dialog.html',
                    controller: 'DefaultMarketSessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['DefaultMarket', 'GlobalValues', function(DefaultMarket, GlobalValues) {
                                     return DefaultMarket.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('default-market-session-settings-todolist', {
            parent: 'dashboard',
            url: '/defaultMarketSessionSEttings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-market-session-settings/default-market-session-settings-dialog.html',
                    controller: 'DefaultMarketSessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('default-market-session-settings', null, { reload: 'default-market-session-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('default-market-todolist-resubmit', {
            parent: 'dashboard',
            url: '/defaultMarketSettingsEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-market-session-settings/default-market-session-settings-dialog.html',
                    controller: 'DefaultMarketSessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('default-market-session-settings', null, { reload: 'default-market-session-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('default-market-settings-auditLog', {
            parent: 'audit-log',
            url: '/defaultMarketSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-market-session-settings/default-market-session-settings-dialog.html',
                    controller: 'DefaultMarketSessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('default-market-session-settings', null, { reload: 'default-market-session-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('default-market-settings-historyReport', {
            parent: 'history-report',
            url: '/defaultMarketSettingsHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-market-session-settings/default-market-session-settings-dialog.html',
                    controller: 'DefaultMarketSessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('default-market-session-settings', null, { reload: 'default-market-session-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('DefaultMarket', DefaultMarket);

    DefaultMarket.$inject = ['$resource'];

    function DefaultMarket ($resource) {
        var resourceUrl =  'api/default-market-session-settings/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/orgId/:orgId/default-market-session-settings'
        	 },
         	
         	'marketInstruments': { method: 'GET', isArray: true,
        	    url: 'api/market-instruments'
        	 },
         	
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
        	 'getInstrumentTypes': {
                 method: 'GET',
                 url: 'api/instruemnt-types',
                 isArray: true,
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
             'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/default-market-session-settings/orgId/:orgId',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
        	
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/update-default-market-session-settings/orgId/:orgId',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/default-market-settings',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              },
              'getCurrentBusinessDate': {
                  method: 'GET',  
                  url: 'api/get-current-business-date',
                  transformResponse : function(data) {
  					if (data) {
  						data = angular.fromJson(data);
  					}
  					return data;
  				}
              },
            'csInstruments': { 
                method: 'GET', 
                isArray: true,
                params: {currencyPairId:'@currencyPairId'},
        	    url: 'api/market-instruments/currencyPairId/:currencyPairId'
        	 },
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'defaultMarketSessionSettings'
        })
        
        .controller('DefaultMarketSessionSettingsController', DefaultMarketSessionSettingsController);

    DefaultMarketSessionSettingsController.$inject = ['$scope', '$state', 'DefaultMarket', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','DateUtils','$filter','$timeout'];

    function DefaultMarketSessionSettingsController($scope, $state, DefaultMarket , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,DateUtils,$filter,$timeout) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.DEFAULT_MARKET_SESSION_SETTINGS;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "defaultMarketSessionSettings";
        vm.currentBusinessDate;
        vm.convertedCurrentBusinessDate;
        vm.permitDefaultMarketEditAction = EntityPermissions.hasPermission('DefaultMarketSessionSettings.EDIT');
        $scope.refresh=refresh;
        
        logScreenAccess();
        loadAll();
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
    
       
      function loadAll(){
    	   DefaultMarket.query({"orgId": GlobalValues.getOrgId()},function(result) {
    		   
    		   angular.forEach(result, function(value){
    			   		
		    			  var closeTime = value.inputCloseTime.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)?$/) || [value.inputCloseTime];
		    			   
		    			  closeTime = closeTime.slice (1);  
		    			  closeTime[5] = ' ';
		    			  closeTime[6] = +closeTime[0] < 12 ? 'AM' : 'PM'; 
		    			  closeTime[0] = +closeTime[0] % 12 || 12;
		    			  if(closeTime[0]<=9){
		    				  closeTime[0]=0+""+closeTime[0];
		    			  }
    				    value.inputCloseTime = closeTime.join (''); 
    				    /*if(value.inputCloseTime='12 PM'){
    				    	value.inputCloseTime = '12:00 PM';
    				    }*/
    				    
    				    
    				    var openTime = value.inputOpenTime.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)?$/) || [value.inputOpenTime];
    	    			   
    				    openTime = openTime.slice (1);  
    				    openTime[5]= ' ';
    				    openTime[6] = +openTime[0] < 12 ? 'AM' : 'PM'; 
    				    openTime[0] = +openTime[0] % 12 || 12;
    				    if(openTime[0]<=9){
    				    	openTime[0]=0+""+openTime[0];
    				    }
    				    value.inputOpenTime = openTime.join (''); 
    				  });
    				  
    				  
    				  vm.defaultMarket = result;
    				
    		   });
              
         
    	   
      }
      
      $scope.toggle = true;
      function refresh() {
          $scope.toggle = false;
          $scope.refreshFlag = false;
          loadAll();
          if ($scope.toggle == false) {
              $timeout(function() {
                  $scope.toggle = true;
              }, 2000);
              $scope.refreshFlag = false;
          }
      };
       
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-view-report', {
            parent: 'entity',
            params:{screen: 'CustomerViewReport'}, 
            url: '/customer-view-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.customer.manageCustomerViewReport" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-view-report/customer-view-report.html',
                    controller: 'CustomerViewReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('customerViewReport');
                    $translatePartialLoader.addPart('customer-registration');
                    $translatePartialLoader.addPart('customerBankRelationshipReport');
                    return $translate.refresh();
                }],
                entity: function(){
                	
                }
            }
        })
        /*.state('customer-view-report.edit', {
            parent: 'customer-view-report',
            url: '/customer-view-report/edit/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/entities/customer-bank-relationship-report/customer-trading-bank-dialog.html',
                    controller: 'CustomerTradingBankDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                   	 entity: ['CustomerTradingBankDetails', 'GlobalValues', function(CustomerTradingBankDetails, GlobalValues) {
                   		 	
                            return CustomerTradingBankDetails.getCustomerDetailsForBankRelationship({customerTradinBankDetailsId : $stateParams.id}).$promise;
                        }]
              
           }
                }).result.then(function() {
                    $state.go('customer-view-report', {}, { reload: 'customer-view-report' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
       
       };
    })();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'customerregistration'
        })
        .controller('CustomerViewReportController', CustomerViewReportController);

    CustomerViewReportController.$inject = ['$scope', '$state', 'workflowSharedService','CustomerTradingBankDetails',  'GlobalValues','EntityPermissions','$filter', 'entity','ScreenLog','entityConstants'];

    function CustomerViewReportController($scope, $state, workflowSharedService, CustomerTradingBankDetails,  GlobalValues, EntityPermissions,$filter, entity,ScreenLog,entityConstants) {    
        var vm = this;
        vm.globalValues = GlobalValues;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.getCustomerDetails=getCustomerDetails;
        
        vm.userType = vm.globalValues.getOrganisation().organisationType.shortName;
        vm.userEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.userBranch=vm.globalValues.getBranch();
        vm.screenLog = ScreenLog;
        vm.exportAllCustomerDetails = exportAllCustomerDetails;
        workflowSharedService.viewFrom = "customerregistration";
        
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMER_VIEW_REPORT;
        vm.modifyCustomerDetailsScreenName = vm.entityConstants.ENTITY_SHORT_NAME.MODIFY_CUSTOMER_DETAILS;
        vm.permitTradingBranchModification = EntityPermissions.hasPermission( vm.modifyCustomerDetailsScreenName+'.' +vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
		vm.clicked=false;
        
		vm.exportButtonEnabled = true;

        vm.editTradingBankDetails = editTradingBankDetails;
        logScreenAccess();
		vm.exportToFile = exportToFile
		vm.mimeType= ''; 
		vm.dateFilter = 'Today';
        // if(vm.userEntityOwnerType=='Branch'){
        // 	loadAll();
        // }
        
        function getCustomerDetails()
        {   
        	// var filterObj = {}
            // filterObj.bankId=null;
            // filterObj.branchId=null;

        	var bankId=null;
            var branchId=null;

			var dateFilter = getDateFilter();
    		var fromDate = dateFilter.fromDate;
    		var toDate = dateFilter.toDate;

        	if(vm.userType=='CLEARCORP'){
        		if(vm.bank != null && vm.bank != undefined && vm.bank != '')
        			bankId=vm.bank.id;
        		if(vm.branch != null && vm.branch != undefined && vm.branch != '')
        			branchId=vm.branch.id;
        	}
        	if(vm.userType=='BANK' && vm.userEntityOwnerType!='Branch'){
        		bankId=vm.globalValues.getOrgId();
        		if(vm.branch != null && vm.branch != undefined && vm.branch != '')
        			branchId=vm.branch.id;
        	}
        	if(vm.userEntityOwnerType=='Branch'){
        		bankId=vm.globalValues.getOrgId();
        		branchId=vm.globalValues.getBranchId();
        	}
        	
        	CustomerTradingBankDetails.getCustomerDetailsForReport({"bankId":bankId,"branchId":branchId,"fromDate": fromDate,"toDate": toDate},onGetCustomerDetailsSuccess,onGetCustomerDetailsError);
			// return filterObj;
        }
        
        function exportAllCustomerDetails()
        {   
        	
        	var bankId=null;
            var branchId=null;
			vm.exportButtonEnabled = false;

      	  	var  mimeType = 'application/vnd.ms-excel';
      	  	var fileData = null;
      	  	var baseString = 'Customer_View_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm')+ ".xls";  
      	  CustomerTradingBankDetails.exportAllCustomerDetails(  function(result){
      			 
      			  fileData = result.data;
      			  if(fileData!=null && fileData!=undefined ){
	      			  var data = "";
	      			  console.log( "type" + typeof fileData); 
	      			  /*var link = document.createElement("a");  
	      			  var bytes = new Uint8Array( fileData );   // convert uint8rom arraybuffer
	      			  //data = btoa(String.fromCharCode.apply(null, bytes)); // get data string from binary array
	      			  //link.href = 'data:'+mimeType+';base64,'+ encodeURI(data);
	      			  var blob = new Blob([bytes], {type: mimeType});
				      link.href =  window.URL.createObjectURL(blob);
	      		   	  link.download = baseString;
	      		   	  document.body.appendChild(link);
	      		   	  link.click();
	      			  document.body.removeChild(link);*/
	      			  
	      			var downloadLink = document.createElement("a");
	      			var docExt = "xls";
	                var blob = new Blob([fileData], {type: 'application/vnd.ms-xls'});
	                downloadLink.href =  window.URL.createObjectURL(blob);
	                downloadLink.download = baseString;
	                var blob = new Blob([fileData], { type: "application/vnd.ms-excel;charset=utf-8" })
	                window.saveAs(blob, baseString);
      			  }
      		  });	
        }
        function onGetCustomerDetailsSuccess(result)
        {
        	vm.customerDetails=result;
        	vm.clicked=false;
        }
        
        
        function onGetCustomerDetailsError()
        {
        	vm.clicked=false;
        }
        // function loadAll(){
        // 	getCustomerDetails();
        	
        // }
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }
        function editTradingBankDetails(customerTradingBankDetails,$event){
        	 //workflowSharedService.viewFrom == 'customerViewReportEdit'
        	 ScreenLog.screenLog(vm.modifyCustomerDetailsScreenName,customerTradingBankDetails.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
        	 $state.params = {id:customerTradingBankDetails.id}
    		 var state = 'modify-customer-details';
    		 $state.go(state,{id:customerTradingBankDetails.id});
        	//
        }
        
        vm.getAddress = function getAddress(address1, address2){
        	var address = '-';
        	if(address1!=null && address1!=undefined && address1!=''){
        		address = address1;
        	}
        	if(address2!=null && address2!=undefined && address2!=''){
        		address = address + ', ' + address2;
        	}
        	return address;
        }
        
        vm.getMobile = function getMobile(mobile, mobileCountryCode){
        	var mobileNo = '-';
        	if(mobile!=null && mobile!=undefined && mobile!=''){
        		mobileNo = mobile;
        		if(mobileCountryCode!=null && mobileCountryCode!=undefined && mobileCountryCode!=''){
        			mobileNo = mobileCountryCode + '-' + mobile;
        		}
        	}
        	return mobileNo;
        }

		//export csv and excel file 
		function exportToFile(fileType){
	 	   var bankId=null;
			var branchId=null;
			vm.exportButtonEnabled = false;
			if(vm.userType=='CLEARCORP'){
        		if(vm.bank != null && vm.bank != undefined && vm.bank != '')
        			bankId=vm.bank.id;
        		if(vm.branch != null && vm.branch != undefined && vm.branch != '')
        			branchId=vm.branch.id;
        	}
        	if(vm.userType=='BANK' && vm.userEntityOwnerType!='Branch'){
        		bankId=vm.globalValues.getOrgId();
        		if(vm.branch != null && vm.branch != undefined && vm.branch != '')
        			branchId=vm.branch.id;
        	}
        	if(vm.userEntityOwnerType=='Branch'){
        		bankId=vm.globalValues.getOrgId();
        		branchId=vm.globalValues.getBranchId();
			}

			vm.baseString =  'Customer_View_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');

			    var dateFilter = getDateFilter();
    			var fromDate = dateFilter.fromDate;
    			var toDate = dateFilter.toDate;
			
			if( vm.customerDetails !=null &&  vm.customerDetails!=undefined){
				if(fileType == 'csv'){
					vm.mimeType = 'text/csv'
					vm.baseString = vm.baseString+ ".csv";
					
					CustomerTradingBankDetails.exportCSVData({"bankId":bankId,"branchId":branchId,"fromDate": fromDate,"toDate": toDate},onGenerateSuccess);
				}else if(fileType == 'excel'){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.baseString = vm.baseString+ ".xls"; 
					CustomerTradingBankDetails.exportExcelData({"bankId":bankId,"branchId":branchId,"fromDate": fromDate,"toDate": toDate},onGenerateSuccess);
				}
			}
		}
      
		/* generate  excel and csv file  */
		function onGenerateSuccess(result){
        	
			var fileData = result.data;
			vm.exportButtonEnabled = true;
			 
			 var IEfile= new Blob([result.data], {type: vm.mimeType});
				if(window.navigator.msSaveOrOpenBlob) {
				   window.navigator.msSaveOrOpenBlob(IEfile, vm.baseString );
				}
				else
					{
					 var link = document.createElement("a");   
					 var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
					 
					 
					 var blob = new Blob([bytes], {type: vm.mimeType});
					 link.href =  window.URL.createObjectURL(blob);
					 
				  
					 
						link.download = vm.baseString;
						document.body.appendChild(link);
						link.click();
					 document.body.removeChild(link);
					}
		}

		function getDateFilter() {

    var today = new Date();
    var fromDate;
    var toDate;

    if (vm.dateFilter === 'Today') {

        fromDate = new Date(today);
        fromDate.setHours(0, 0, 0, 0);

        toDate = new Date(fromDate);
        toDate.setDate(toDate.getDate() + 1);

    } else if (vm.dateFilter === 'Yesterday') {

        toDate = new Date(today);
        toDate.setHours(0, 0, 0, 0);

        fromDate = new Date(toDate);
        fromDate.setDate(fromDate.getDate() - 1);
    }

    return {
        fromDate: fromDate.toISOString(),
        toDate: toDate.toISOString()
    };
}


		
     }
	
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('CustomerUserType', CustomerUserType);

    CustomerUserType.$inject = ['$resource'];

    function CustomerUserType ($resource) {
        var resourceUrl =  'api/customer-user-type/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getWithoutSingleUser':{
            	method:'GET',
            	url:'api/customer-user-type-multi',
            	isArray : true
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('CustomerTradingBankDetails', CustomerTradingBankDetails);

    CustomerTradingBankDetails.$inject = ['$resource'];

    function CustomerTradingBankDetails ($resource) {
        var resourceUrl =  'api/customer-trading-bank-details/:id';

        return $resource(resourceUrl, {}, {
            
            
            'getCustomerDetailsForReport':{
            	 
            	isArray:true,
 				method: 'GET',
 				params: {bankId:'@bankId',branchId:'@branchId',fromDate: '@fromDate',toDate: '@toDate'},
 				url: 'api/customer-details/get-customer-details-for-report'
             },
             'exportAllCustomerDetails':{
            	 
  				method: 'GET',
  				responseType: 'arraybuffer',
  				url: 'api/customer-details/export-all-customer-details',
  				transformResponse: function(data,headers) {
  					return {
                        data: data,
                        headers: headers
                    };
  				 }     
              },
              'getCustomerDetailsForBankRelationship':{
   				method: 'GET',
   				params: {customerTradinBankDetailsId:'@customerTradinBankDetailsId'},
   				url: 'api/customer-details/get-customer-report/:customerTradinBankDetailsId'
               },
               'getBankAndDefaultUserDetailsForCustomer':{
      				method: 'GET',
      				params: {customerId:'@customerId', bankId:'@bankId'},
      				url: 'api/customer-details/get-bank-and-default-user/:customerId/:bankId'
               },
               'getCustomerRegistrationRequestFromPayload':{
     				method: 'POST',
     				url: 'api/customer-details/get-customer-registration-from-report',
     				transformResponse: function(data,headers) {
     	  					return {
     	                        data: data,
     	                        headers: headers
     	                    };
     	  			},
     	  			transformRequest : function(data) {
					var copy = angular.copy(data);

					return angular.toJson(copy);
				}
              } ,
              'getValidTradingBankDetails':{
	   				method: 'GET',
	   				url: 'api/valid-status-trading-bank-for-customer',
	   				isArray:true
   	  			},
   	  		       
            'getAnnexure2ForCustomerBankRelationship':{
                method:'GET',
                params: {customerTradinBankDetailsId:'@customerTradinBankDetailsId'},
                url: 'api/annexure-2-for-customer-relationship/:customerTradinBankDetailsId',
                responseType: 'arraybuffer',
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            },
            'exportExcelData':{
			    method: 'GET',
                url: 'api/customer-details/export-customer-details/excel',
                responseType: 'arraybuffer',
                params : {
                    bankId : '@bankId',
					branchId : '@branchId'
				},
                transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 },
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                } 
			},
			'exportCSVData':{
			    method: 'GET',
                url: 'api/customer-details/export-customer-details/csv',
                responseType: 'arraybuffer',
                params : {
					bankId : '@bankId',
					branchId : '@branchId'
				},
                transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 },
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                } 
			}

               
             });
    }
})();

(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.service("workflowSharedService", function () {        	
		this.viewFrom= 'customerTacUploadByBankView'
	})

	.controller('CustomerTACByBankViewController', CustomerTACByBankViewController);

	CustomerTACByBankViewController.$inject = ['$scope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
		'AlertService','$rootScope','CustomerTACUploadByBank','$timeout','TacViewForEntitiesUtility','entity'];

	function CustomerTACByBankViewController($scope, $state,  GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
			AlertService,$rootScope,CustomerTACUploadByBank,$timeout,TacViewForEntitiesUtility,entity) {

		var vm = this;
		vm.entityConstants = entityConstants;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMER_TERMS_AND_CONDITIONS_UPLOAD;
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;
		vm.globalValues=GlobalValues;
		vm.screenLog = ScreenLog;
		vm.filterData = {};	    
		vm.extension = "";
		workflowSharedService.viewFrom = "customerTacUploadByBankView";
		logScreenAccess();
		vm.loadAll = loadAll;
		loadAll();
		vm.valid = false;
		vm.openTACPreview = openTACPreview;
		vm.uploadTAC = uploadTAC;
		$scope.refresh=refresh;
		vm.bankTACDetails = entity;


		function base64ToArrayBuffer(base64) {
			var binary_string =  window.atob(base64);
			var len = binary_string.length;
			var bytes = new Uint8Array( len );
			for (var i = 0; i < len; i++)        {
				bytes[i] = binary_string.charCodeAt(i);
			}
			return bytes.buffer;
		}

		function openTACPreview(tacFile){
			TacViewForEntitiesUtility.previewTAC(tacFile.fileContent,tacFile.fileName);	
		}

		function uploadTAC(tacDetails){
			$state.go('customer-tac-upload-by-bank',{id:tacDetails.id});

		}

		function logScreenAccess(){
			ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}

		
		function loadAll() {
			vm.bankTACDetails = [];
			CustomerTACUploadByBank.getActiveCustomerTACUploadByBank({organisationId:GlobalValues.getOrgId()},function(result) {
				vm.bankTACDetails = result;

			});
		}

		$scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };

	}
})();
(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.controller('CustomerTACUploadByBankApprovalController', CustomerTACUploadByBankApprovalController);

	CustomerTACUploadByBankApprovalController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','CustomerTACUploadByBank','entity','DateUtils','Workflow','FileUtil','AlertService','$filter','$uibModalInstance','systemSettings','TacViewForEntitiesUtility','globalValue','TACViewForEntitiesService','configurationSetting'];

	function CustomerTACUploadByBankApprovalController($scope, $state, $rootScope, GlobalValues, workflowSharedService,CustomerTACUploadByBank,entity,DateUtils,Workflow,FileUtil,AlertService,$filter,$uibModalInstance,systemSettings,TacViewForEntitiesUtility,globalValue,TACViewForEntitiesService,configurationSetting) {
		var vm = this;
		vm.bankForCustomerTacDTO=entity;   

		vm.clear=clear;
		vm.clicked=false;
		$scope.showButton = false;
		$scope.showApproveRejectButton=false;
		$scope.showDiscardButton = false;
		$scope.showResubmitButton=false;
		vm.globalValues = GlobalValues;
		vm.discardTAC = discardTAC;
		vm.rejectTAC = rejectTAC;
		vm.approveTAC = approveTAC;
		vm.openClearcorpTac = TacViewForEntitiesUtility.onGetCcilTacForBank;
        vm.messageBoxName = "customerTACUploadApproval";
        vm.checkTACFile = false;
		vm.resubmitTAC = resubmitTAC;
		vm.viewMode=false;
		vm.configSettings = globalValue;
		vm.maxFileNameLength = (vm.configSettings.uploadedFileNameLength != null && vm.configSettings.uploadedFileNameLength != undefined && vm.configSettings.uploadedFileNameLength != '') ?vm.configSettings.uploadedFileNameLength : 150 ;
		var minFileSizeinBytes = 0;
		var maxFileSizeinBytes = 500;
		vm.maximumFileSizeinKB = (configurationSetting != null && configurationSetting != undefined && configurationSetting.maximumFileSizeTermsAndConditionsUpload != null && configurationSetting.maximumFileSizeTermsAndConditionsUpload != undefined && configurationSetting.maximumFileSizeTermsAndConditionsUpload != '') ? parseInt(configurationSetting.maximumFileSizeTermsAndConditionsUpload) : 500 ;
		vm.minimumFileSizeInKB = 0;
		if( vm.minimumFileSizeInKB != undefined &&  vm.minimumFileSizeInKB !=null &&  vm.minimumFileSizeInKB  !=''){
			minFileSizeinBytes = vm.minimumFileSizeInKB*1024;
		}
		if( vm.maximumFileSizeinKB != undefined &&  vm.maximumFileSizeinKB !=null &&  vm.maximumFileSizeinKB  !=''){

			maxFileSizeinBytes = vm.maximumFileSizeinKB*1024;
			if(vm.maximumFileSizeinKB == 1024){
				vm.showInKB = false;
				vm.tacFileUploadSize = 1;
			}else{
				vm.showInKB = true;
				vm.tacFileUploadSize = vm.maximumFileSizeinKB;
			}
		}
		
		var Extensions = "pdf";
		vm.minDate = new Date();
		vm.minDate.setDate(new Date().getDate() + 1);

		$scope.showButton = false;
		vm.orgId = vm.globalValues.getOrgId();
		
		if(systemSettings != null && systemSettings != undefined){
			vm.businessDate  = DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
			vm.businessDatePlusOne =  moment(vm.businessDate).add(1,'days').toDate();
			vm.minDate = angular.copy(vm.businessDatePlusOne);
		}

		if(workflowSharedService.viewFrom == 'customerTermsConditionUploadByBanktodolist_resubmit') {
			vm.bankForCustomerTacDTO =  angular.copy(angular.fromJson($rootScope.payload));
			vm.bankForCustomerTacDTO.enforcingDate = new Date(vm.bankForCustomerTacDTO.tacMaster.enforcingDate);

			$scope.showButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton=true;
			vm.viewMode=false;
		}

		else if(workflowSharedService.viewFrom == 'customerTermsConditionUploadByBank_todolist_checker') {
			vm.bankForCustomerTacDTO =  angular.fromJson($rootScope.payload); 
			vm.bankForCustomerTacDTO.enforcingDate =DateUtils.convertLocalDateFromServer( vm.bankForCustomerTacDTO.tacMaster.enforcingDate);
			vm.viewMode=true;
			$scope.showButton = false;
			$scope.showApproveRejectButton = true;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton=false;
		}
		else if(workflowSharedService.viewFrom == 'customerTermsConditionUploadByBank_todolist_maker') {
			vm.bankForCustomerTacDTO =  angular.fromJson($rootScope.payload); 
			vm.bankForCustomerTacDTO.enforcingDate =DateUtils.convertLocalDateFromServer( vm.bankForCustomerTacDTO.tacMaster.enforcingDate);
			vm.viewMode=true;
			$scope.showButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = true;
			$scope.showResubmitButton=false;
		}
		else if(workflowSharedService.viewFrom=='customerTermsConditionUploadByBank_auditlog'){
			vm.bankForCustomerTacDTO =  angular.fromJson($rootScope.payload); 
			vm.bankForCustomerTacDTO.enforcingDate =DateUtils.convertLocalDateFromServer( vm.bankForCustomerTacDTO.tacMaster.enforcingDate);			vm.viewMode=true;
			$scope.showButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton=false;

		}else{
			vm.bankForCustomerTacDTO=entity;
			vm.bankForCustomerTacDTO.enforcingDate = vm.minDate;
			$scope.showButton = true;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton=false;
			vm.viewMode=false;
		}
		function base64ToArrayBuffer(base64) {
			var binary_string =  window.atob(base64);
			var len = binary_string.length;
			var bytes = new Uint8Array( len );
			for (var i = 0; i < len; i++)        {
				bytes[i] = binary_string.charCodeAt(i);
			}
			return bytes.buffer;
		}

		vm.openTACPreview = openTACPreview;
		function openTACPreview(pdfContent){
			TacViewForEntitiesUtility.previewTAC(pdfContent.fileContent, pdfContent.fileName);
		}

		/*function openClearcorpTac(){
			CustomerTACUploadByBank.getAgreedTacForBank({orgId:vm.orgId},onGetTacSuccess,onGetTacFailure)
		}

		function onGetTacSuccess(result){

			if(result != null || result != undefined){
				TacViewForEntitiesUtility.previewTAC(result.tacMaster.tacFiles.fileContent, result.tacMaster.tacFiles.fileName);
			}else{
				AlertService.error($filter('translate')('gatewayApp.customerTacUploadByBank.bankNotAgreedTac'));
			}
		}*/

		function onGetTacFailure(error){

		}


		function clear() {
			$uibModalInstance.dismiss('cancel');
		}


		function approveTAC() { 
			CustomerTACUploadByBank.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
			     	
		}

		function onApproveSuccess(result) {
			$uibModalInstance.dismiss('cancel');
			$rootScope.removeRow($rootScope.taskID);        	
		}        
		function onApproveError(error) {
			vm.clicked = false;
		}

		function rejectTAC() { Workflow.rejectTask($rootScope.taskID); }

		function discardTAC() {
			CustomerTACUploadByBank.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
			$uibModalInstance.dismiss('cancel');	
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);        	
		}        
		function onDiscardError(error) {

		}
		
		function resubmitTAC() {
			if(vm.bankForCustomerTacDTO.enforcingDate == null || vm.bankForCustomerTacDTO.enforcingDate == undefined || moment(vm.minDate).isAfter(DateUtils.convertLocalDateToServer(vm.bankForCustomerTacDTO.enforcingDate))){
				vm.clicked = false;
				AlertService.error($filter('translate')('gatewayApp.customerTacUploadByBank.enforcingDateGreater'));
				
			}
			else{
				if(vm.termsCondition != null){
					var fd1 = new FormData();
					//vm.bankForCustomerTacDTO.tacMaster.tacFiles.fileName = vm.termsCondition.name;
					//vm.bankForCustomerTacDTO.tacMaster.enforcingDate = DateUtils.convertLocalDateToServer(vm.bankForCustomerTacDTO.enforcingDate);
					fd1.append('id', JSON.stringify($rootScope.taskID));
					var enforcingDate = DateUtils.convertLocalDateToServer(vm.bankForCustomerTacDTO.enforcingDate);
					fd1.append('enforcingDate', enforcingDate);
					fd1.append('file', vm.termsCondition);
					fd1.append('dto', JSON.stringify(vm.bankForCustomerTacDTO));
					CustomerTACUploadByBank.resubmit( fd1, onResubmitSuccess, onResubmitError);


				}
			}
			
		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.dismiss('cancel');
		}        
		function onResubmitError(error) {
			vm.clicked = false;
		}

		//validate terms and condition 
		$scope.$watch('vm.termsCondition', function(value){
		
			
			if(value!= undefined && value!=null){
				
				if(!FileUtil.isFileSizeValid(value.size ,minFileSizeinBytes , maxFileSizeinBytes  )){
					vm.invalidTermsConditionSize = true;
					if(vm.showInKB == true){
						vm.invalidTermsConditionSixeText = "Maximum of " + vm.tacFileUploadSize +" KB file size is allowed";
					}else{
						vm.invalidTermsConditionSixeText = "Maximum of " + vm.tacFileUploadSize +" MB file size is allowed";
					}
					vm.invalidTermsCondition = false;
					vm.invalidTermsConditionName = false;
					vm.termsCondition=null;
					angular.element("input[type='file']").val(null);

				}else{
					vm.inputTermsCondition=vm.termsCondition.name;
					vm.invalidTermsConditionSize = false;
					vm.invalidTermsCondition = false;
					vm.invalidTermsConditionName = false;
					vm.fileExtension = vm.inputTermsCondition.substring(vm.termsCondition.name.lastIndexOf(".") + 1);
					var fileNameWithoutExtension  =  vm.inputTermsCondition.substring(0,vm.termsCondition.name.lastIndexOf("."));
					//check for extension
					if(!(Extensions == (vm.fileExtension.toLowerCase()))) {
						angular.element("input[type='file']").val(null);
						vm.termsCondition=null;
						vm.inputTermsCondition=null;
						vm.invalidTermsCondition = true;
						vm.invalidTermsConditionSize = false;
						vm.invalidTermsConditionName = false;
						vm.invalidTermsConditionText = "Accepted file format .pdf";
					}
					else if(!FileUtil.isFileNameValid(fileNameWithoutExtension,vm.maxFileNameLength )){
	    				 angular.element("input[type='file']").val(null);
	    				 vm.termsCondition=null;
				         vm.inputTermsCondition=null;
				         vm.invalidTermsCondition = false;
				         vm.invalidTermsConditionSize = false;
				         vm.invalidTermsConditionName = true;
				         vm.invalidTermsConditionNameText = "Uploaded pdf file name should not exceed " + vm.maxFileNameLength+ " charaters.";
				         
	    			 }

					else{ // check for malicious file with correct extension
						var reader = new FileReader();
						reader.readAsArrayBuffer(value.slice(0,4));
						reader.onloadend = function(e){
							if (e.target.readyState === FileReader.DONE) {
								var arrayBuffer = e.target.result;
								var bytes = new Uint8Array( arrayBuffer );
								if(!FileUtil.checkTermsConditionExtension(bytes)){
									angular.element("input[type='file']").val(null);
									vm.termsCondition=null;
									vm.inputTermsCondition=null;
									vm.invalidTermsCondition = true;
									vm.invalidTermsConditionSize = false;
									vm.invalidTermsConditionName = false;
									vm.invalidTermsConditionText = "Accepted file format .pdf";
								}
								else{
									vm.invalidTermsConditionSize = false;
									vm.invalidTermsCondition =false;
									vm.invalidTermsConditionName = false;


								}
								$scope.$digest();
							}
						}; 
					}
				}
			}
			else{
				angular.element("input[type='file']").val(null);

				vm.inputTermsCondition=null;
			}
		});
		
	}   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CustomerTacUploadApprovalDisclaimerController', CustomerTacUploadApprovalDisclaimerController);

    CustomerTacUploadApprovalDisclaimerController.$inject = ['$uibModalInstance','$stateParams', 'GlobalValues', '$rootScope', '$scope', 'TacViewForEntitiesUtility','CustomerTACUploadByBank'];

    function CustomerTacUploadApprovalDisclaimerController($uibModalInstance,$stateParams,GlobalValues,   $rootScope, $scope, TacViewForEntitiesUtility,CustomerTACUploadByBank) {
    	
    	var vm = this;
    	
    	vm.clear = clear;
        vm.approve = approve;
        $scope.clicked = false;
        vm.entityId =  $stateParams.entityId;
        vm.onGetCcilTac = TacViewForEntitiesUtility.onGetCcilTacForBank;
        vm.organisation = GlobalValues.getOrganisation();
        vm.messageBoxName = "customertacuploadApprovalfromtodo";
    	
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function approve(){
        	$scope.rowID = vm.entityId;
        	CustomerTACUploadByBank.approve({"taskId" : $scope.rowID},onApproveSuccess,onApproveError);      	
			             	
     	            
        }
      
        function onApproveSuccess(result) {
           
            $rootScope.removeRow( $scope.rowID );
            $uibModalInstance.dismiss('cancel');
        }

        function onApproveError(error) {
        	//$scope.clicked=false;
        	 $uibModalInstance.dismiss('cancel');        	
        }
        
        
    }
})();
(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
		.state('customer-tac-upload-by-bank-view', {
			parent: 'entity',
			params:{screen:'CustomerTermsAndConditionsUpload'},
			url: '/customer-tac-upload-by-bank-view',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'global.title'
			},
			ncyBreadcrumb: {
				label: '{{ "global.menu.customerTacUploadByBank.main" | translate }}',
				parent: 'home'
			},
			views: {
				'content@': {
					templateUrl: 'app/entities/customer-tac-upload/customer-tac-upload-by-bank-view.html',
					controller: 'CustomerTACByBankViewController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customerTacUploadByBank');                    
					$translatePartialLoader.addPart('error');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}],
				entity: ['CustomerTACUploadByBank','GlobalValues', function(CustomerTACUploadByBank,GlobalValues) {
					return CustomerTACUploadByBank.getActiveCustomerTACUploadByBank({organisationId:GlobalValues.getOrgId()}).$promise;

				}]
			}
		})
		
		

		.state('customer-tac-upload-by-bank', {
			parent: 'customer-tac-upload-by-bank-view',
			url: '/customer-tac-upload-by-bank',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'global.title'
			},
			onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl: 'app/entities/customer-tac-upload/customer-tac-upload-by-bank.html',
					controller: 'CustomerTACUploadByBankController',
					controllerAs: 'vm',
					backdrop: 'static',
					size: 'md',
					resolve: {

						entity: function () {                        	
							return {                            		
							};
						},
						globalValue: ['StaticLookUp', function(StaticLookUp) {
							return StaticLookUp.getConfigSettings().$promise;
						}],
						systemSettings: ['IntradayMarket', function(IntradayMarket) {
							return IntradayMarket.getCurrentBusinessDate().$promise;
						}],
						configurationSetting :['GlobalValues', function(GlobalValues) {
							return GlobalValues.getConfigSettings();
						}]

					}
				}).result.then(function() {
					$state.go('^', {}, { reload: true });
				}, function() {
					$state.go('^');
				});
			}]

		})

		.state('customer-tac-upload-by-bank-todolist', {
			parent: 'dashboard',
			url: '/customer-tac-upload-by-bank-todo',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'global.title'
			},
			onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl: 'app/entities/customer-tac-upload/customer-tac-upload-by-bank-approval.html',
					controller: 'CustomerTACUploadByBankApprovalController',
					controllerAs: 'vm',
					backdrop: 'static',
					size: 'md',
					resolve: {
						entity: function () {                        	
							return {                            		
							};
						},
						systemSettings:function() {
							return {                            		
							};
						},
                        globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                        configurationSetting :['GlobalValues', function(GlobalValues) {
                            return GlobalValues.getConfigSettings();
                        }]
					}
				}).result.then(function() {
					$state.go('customer-tac-upload-by-bank-view', null, { reload: 'customer-tac-upload-by-bank-view' });
				}, function() {
					$state.go('^');
				});
			}],
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customerTacUploadByBank');
					$translatePartialLoader.addPart('error');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}]
			}

		})
		.state('customer-tac-upload-by-bank-todolist-resubmit', {
			parent: 'dashboard',
			url: '/customer-tac-upload-by-bank-todo-resubmit',
			data: {
				authorities: ['ROLE_USER']
			},
			onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl: 'app/entities/customer-tac-upload/customer-tac-upload-by-bank-approval.html',
					controller: 'CustomerTACUploadByBankApprovalController',
					controllerAs: 'vm',
					backdrop: 'static',
					size: 'md',
					resolve: {
						entity: function () {                       	

						},
						systemSettings: ['IntradayMarket', function(IntradayMarket) {
							return IntradayMarket.getCurrentBusinessDate().$promise;
						}],
                        globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                        configurationSetting :['GlobalValues', function(GlobalValues) {
                            return GlobalValues.getConfigSettings();
                        }]
					}
				}).result.then(function() {
					$state.go('customer-tac-upload-by-bank-view', null, { reload: 'customer-tac-upload-by-bank-view' });
				}, function() {
					$state.go('^');
				});
			}],
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customerTacUploadByBank');
					$translatePartialLoader.addPart('error');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}]
			}
		})
		.state('customer-tac-upload-by-bank-auditLog', {
			parent: 'audit-log',
			url: '/customer-tac-upload-by-bank-auditLog',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'global.title'
			},
			onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl: 'app/entities/customer-tac-upload/customer-tac-upload-by-bank-approval.html',
					controller: 'CustomerTACUploadByBankApprovalController',
					controllerAs: 'vm',
					backdrop: 'static',
					size: 'md',
					resolve: {
						entity: function () {                        	
							return {                            		
							};
						},
						systemSettings: function() {
							return null;
						},
                        globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                        configurationSetting :['GlobalValues', function(GlobalValues) {
                            return GlobalValues.getConfigSettings();
                        }]
					}
				}).result.then(function() {
					$state.go('customer-tac-upload-by-bank-view', null, { reload: 'customer-tac-upload-by-bank-view' });
				}, function() {
					$state.go('^');
				});
			}],
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customerTacUploadByBank');
					$translatePartialLoader.addPart('error');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}]
			}

		})


		.state('customer-tac-upload-by-bank-historyReport', {
			parent: 'history-report',
			url: '/customer-tac-upload-by-bank-history',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'global.title'
			},
			onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl: 'app/entities/customer-tac-upload/customer-tac-upload-by-bank-approval.html',
					controller: 'CustomerTACUploadByBankApprovalController',
					controllerAs: 'vm',
					backdrop: 'static',
					size: 'md',
					resolve: {
						entity: function () {                        	
							return {                            		
							};
						},
						systemSettings: function() {
							return null;
						},
                        globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                        configurationSetting :['GlobalValues', function(GlobalValues) {
                            return GlobalValues.getConfigSettings();
                        }]
					}
				}).result.then(function() {
					$state.go('customer-tac-upload-by-bank-view', null, { reload: 'customer-tac-upload-by-bank-view' });
				}, function() {
					$state.go('^');
				});
			}],
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customerTacUploadByBank');
					$translatePartialLoader.addPart('error');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}]
			}

		}).state('customer-tac-upload-apporval-disclaimer', {
            parent: 'dashboard',
            url: '/customer-tc-upload-approval-disclaimer',
            params : {entityId : null, customerId : null, tradingBank : null},
            data: {
            	authorities: ['ROLE_USER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-tac-upload/customer-tac-upload-approval-disclaimer-dialog.html',
                    controller: 'CustomerTacUploadApprovalDisclaimerController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerTacUploadByBank');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('task');
                    return $translate.refresh();
                }]
            }
        })

	};
})();

(function() {
	'use strict';
	angular
	.module('gatewayApp')
	.factory('CustomerTACUploadByBank', CustomerTACUploadByBank);

	CustomerTACUploadByBank.$inject = ['$resource'];

	function CustomerTACUploadByBank($resource) {
		var resourceUrl =  'api/customer-terms-condition-upload-by-bank/:id';

		return $resource(resourceUrl, {}, {
			'getActiveCustomerTACUploadByBank':{
				isArray:true,
				method: 'GET',
				params: {organisationId : '@organisationId'
				},
				url: 'api/customer-terms-condition-upload-by-bank/get-active-tac'

			},
			'getTermsConditionDetails':{
				method: 'GET',
				params: {id : '@id'},
				url: 'api/customer-terms-condition-upload/terms-conditions/:id',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'getAgreedTacForBank':{
				method: 'GET',
				params: {orgId : '@orgId'
				},
				url: 'api/customer-terms-condition-upload-by-bank/agreed-entity',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'getCustomerTacUploadByBankDTO':{
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'resubmit':{
				method: 'POST',
				url: 'api/tasks/resubmit/customer-terms-condition-upload-by-bank-resubmit',
				headers: {
					'Content-Type': undefined
				}


			},			
			'update':{
				method:'POST',
				url: 'api/customer-terms-condition-upload-by-bank',
				headers: {
					'Content-Type': undefined
				}

			},
			'approve' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/approve'
			},
			'reject' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/reject'
			},
			'discard' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/discard'
			},
			'getTermsConditionDetailsTACMaster':{
				isArray:true,
				method: 'GET',
				params: {organisationId : '@organisationId'
				},
				url: 'api/terms-conditions-upload-details/:organisationId'
			},

		});
	}
})();

(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.controller('CustomerTACUploadByBankController', CustomerTACUploadByBankController);

	CustomerTACUploadByBankController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','CustomerTACUploadByBank','entity','DateUtils','Workflow','FileUtil','AlertService','$filter','systemSettings','TacViewForEntitiesUtility','entityConstants','ScreenLog','globalValue','TACViewForEntitiesService','configurationSetting','$uibModalInstance'];

	function CustomerTACUploadByBankController($scope, $state, $rootScope, GlobalValues, workflowSharedService,CustomerTACUploadByBank,entity,DateUtils,Workflow,FileUtil,AlertService,$filter,systemSettings,TacViewForEntitiesUtility,entityConstants,ScreenLog,globalValue,TACViewForEntitiesService,configurationSetting,$uibModalInstance) {
		var vm = this;
		vm.bankForCustomerTacDTO=entity;   

		vm.clear=clear;
		vm.save=save;
		vm.clicked=false;
		$scope.showButton = false;
		$scope.showApproveRejectButton=false;
		$scope.showDiscardButton = false;
		$scope.showResubmitButton=false;
		vm.globalValues = GlobalValues;
		vm.openClearcorpTac = TacViewForEntitiesUtility.onGetCcilTacForBank;
        vm.messageBoxName = "customerTACUpload";
		vm.viewMode=false;
		var minFileSizeinBytes = 0;
		var maxFileSizeinBytes = 500;
		vm.maximumFileSizeinKB = (configurationSetting != null && configurationSetting != undefined && configurationSetting.maximumFileSizeTermsAndConditionsUpload != null && configurationSetting.maximumFileSizeTermsAndConditionsUpload != undefined && configurationSetting.maximumFileSizeTermsAndConditionsUpload != '') ? parseInt(configurationSetting.maximumFileSizeTermsAndConditionsUpload) : 500 ;
		vm.minimumFileSizeInKB = 0;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMER_TERMS_AND_CONDITIONS_UPLOAD;
		vm.configSettings = globalValue;
		vm.checkTACFile = false;

		vm.maxFileNameLength = (vm.configSettings.uploadedFileNameLength != null && vm.configSettings.uploadedFileNameLength != undefined && vm.configSettings.uploadedFileNameLength != '') ?vm.configSettings.uploadedFileNameLength : 150 ;
		
		if( vm.minimumFileSizeInKB != undefined &&  vm.minimumFileSizeInKB !=null &&  vm.minimumFileSizeInKB  !=''){
			minFileSizeinBytes = vm.minimumFileSizeInKB*1024;
		}
		if( vm.maximumFileSizeinKB != undefined &&  vm.maximumFileSizeinKB !=null &&  vm.maximumFileSizeinKB  !=''){
			
			maxFileSizeinBytes = vm.maximumFileSizeinKB*1024;
			if(vm.maximumFileSizeinKB == 1024){
				vm.showInKB = false;
				vm.tacFileUploadSize = 1;
			}else{
				vm.showInKB = true;
				vm.tacFileUploadSize = vm.maximumFileSizeinKB;
			}
		}
		
		var Extensions = "pdf";
		vm.minDate = new Date();
		vm.minDate.setDate(new Date().getDate() + 1);

		if(systemSettings != null && systemSettings != undefined){
			vm.businessDate  = DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
			vm.businessDatePlusOne =  moment(vm.businessDate).add(1,'days').toDate();
			vm.minDate = angular.copy(vm.businessDatePlusOne);
		}
		
		$scope.showButton = false;
		vm.orgId = vm.globalValues.getOrgId();



		vm.bankForCustomerTacDTO.enforcingDate = vm.minDate;
		$scope.showButton = true;
		$scope.showApproveRejectButton = false;
		$scope.showDiscardButton = false;
		$scope.showResubmitButton=false;
		vm.viewMode=false;
		
		vm.tacMasterId = 0;
		ScreenLog.screenLog(vm.screenName,vm.tacMasterId, entityConstants.ENTITY_ACTION_TYPE.EDIT);
		vm.bankForCustomerTacDTO.bank = vm.globalValues.getOrganisation();
		CustomerTACUploadByBank.getTermsConditionDetailsTACMaster({organisationId:GlobalValues.getOrgId()},function(result) {
			if(result!=null){
			vm.bankForCustomerTacDTO.tacMaster =result[0] ;
		}
		});

		function base64ToArrayBuffer(base64) {
			var binary_string =  window.atob(base64);
			var len = binary_string.length;
			var bytes = new Uint8Array( len );
			for (var i = 0; i < len; i++)        {
				bytes[i] = binary_string.charCodeAt(i);
			}
			return bytes.buffer;
		}

		vm.openTACPreview = openTACPreview;
		function openTACPreview(pdfContent){
			var y = window.outerHeight / 2 + window.screenY - ( 700 / 2);
			var x = window.outerWidth / 2 + window.screenX - ( 700 / 2);
			var contentByteArray = base64ToArrayBuffer(pdfContent);
			var file = new Blob([contentByteArray], {type: 'application/pdf'});
			$scope.fileURL = URL.createObjectURL(file);
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(file, "TermsAndConditions.pdf");
			}
			else {
				window.open($scope.fileURL, "_blank", "width=700,height=700,"+"top="+y+", left="+x);  

			}
		}



		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save () {   
			//check if the terms and condition is not null before saving

			if(moment(vm.minDate).isAfter(DateUtils.convertLocalDateToServer(vm.bankForCustomerTacDTO.enforcingDate))){
				vm.clicked = false;
				AlertService.error($filter('translate')('gatewayApp.customerTacUploadByBank.enforcingDateGreater'));
				
			}
			else{
				if(vm.termsCondition != null){
					var fd1 = new FormData();				
					var enforcingDate = DateUtils.convertLocalDateToServer(vm.bankForCustomerTacDTO.enforcingDate);
					fd1.append('enforcingDate', enforcingDate);
					fd1.append('dto', JSON.stringify(vm.bankForCustomerTacDTO));
					fd1.append('file', vm.termsCondition);
					CustomerTACUploadByBank.update(fd1, onSaveSuccess, onSaveError);
				}
			}
		}
		
		function resetValues(){
			vm.clicked = false;

				vm.bankForCustomerTacDTO.enforcingDate = vm.minDate;
				vm.inputTermsCondition=null;
				vm.termsCondition = null;

		}


		function onSaveSuccess (result) {
			$uibModalInstance.close(result);  
		}


		function onSaveError () {

			vm.clicked = false;
		}


		//validate terms and condition 
		$scope.$watch('vm.termsCondition', function(value){

			if(value!= undefined && value!=null){
				if(!FileUtil.isFileSizeValid(value.size ,minFileSizeinBytes , maxFileSizeinBytes  )){
					vm.invalidTermsConditionSize = true;
					if(vm.showInKB == true){
						vm.invalidTermsConditionSixeText = "Maximum of " + vm.tacFileUploadSize +" KB file size is allowed";
					}else{
						vm.invalidTermsConditionSixeText = "Maximum of " + vm.tacFileUploadSize +" MB file size is allowed";
					}
					vm.invalidTermsCondition = false;
					vm.invalidTermsConditionName = false;
					vm.termsCondition=null;
					angular.element("input[type='file']").val(null);

				}else{
					vm.inputTermsCondition=vm.termsCondition.name;
					vm.invalidTermsConditionSize = false;
					vm.invalidTermsCondition = false;
					vm.invalidTermsConditionName = false;
					vm.fileExtension = vm.inputTermsCondition.substring(vm.termsCondition.name.lastIndexOf(".") + 1);
					var fileNameWithoutExtension  =  vm.inputTermsCondition.substring(0,vm.termsCondition.name.lastIndexOf("."));
					//check for extension
					if(!(Extensions == (vm.fileExtension.toLowerCase()))) {
						angular.element("input[type='file']").val(null);
						vm.termsCondition=null;
						vm.inputTermsCondition=null;
						vm.invalidTermsCondition = true;
						vm.invalidTermsConditionSize = false;
						vm.invalidTermsConditionName = false;
						vm.invalidTermsConditionText = "Accepted file format .pdf";
					}
					else if(!FileUtil.isFileNameValid(fileNameWithoutExtension,vm.maxFileNameLength )){
	    				 angular.element("input[type='file']").val(null);
	    				 vm.termsCondition=null;
				         vm.inputTermsCondition=null;
				         vm.invalidTermsCondition = false;
				         vm.invalidTermsConditionSize = false;
				         vm.invalidTermsConditionName = true;
				         vm.invalidTermsConditionNameText = "Uploaded pdf file name should not exceed " + vm.maxFileNameLength+ " charaters.";
				         
	    			 }

					else{ // check for malicious file with correct extension
						var reader = new FileReader();
						reader.readAsArrayBuffer(value.slice(0,4));
						reader.onloadend = function(e){
							if (e.target.readyState === FileReader.DONE) {
								var arrayBuffer = e.target.result;
								var bytes = new Uint8Array( arrayBuffer );
								if(!FileUtil.checkTermsConditionExtension(bytes)){
									angular.element("input[type='file']").val(null);
									vm.termsCondition=null;
									vm.inputTermsCondition=null;
									vm.invalidTermsCondition = true;
									vm.invalidTermsConditionSize = false;
									vm.invalidTermsConditionName = false;
									vm.invalidTermsConditionText = "Accepted file format .pdf";
								}
								else{
									vm.invalidTermsConditionSize = false;
									vm.invalidTermsCondition =false;
									vm.invalidTermsConditionName = false;


								}
								$scope.$digest();
							}
						}; 
					}
				}
			}
			else{
				angular.element("input[type='file']").val(null);
				
				vm.inputTermsCondition=null;
				
			}
		});
		
	        

	}   
})();

 (function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-specific-settings', {
            parent: 'entity',
            params:{screen: 'CustomerSpecificSettings'},
            url: '/customer-specific-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.customerSettings.settings" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-specific-settings/customer-specific-settings.html',
                    controller: 'CustomerSpecificSettingsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'smd',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:true});
                }, function() {
                    $state.go('home', null, {reload:true});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('customerSpecificSettings');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
         };
    })();

(function() {
	'use strict';
	angular.module('gatewayApp').factory('CustomerSpecificSettings', CustomerSpecificSettings);

	CustomerSpecificSettings.$inject = [ '$resource' ];

	function CustomerSpecificSettings($resource) {
		var resourceUrl = 'api/customerSpecificSettings/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				 params: {customerId: '@customerId'},
				url : 'api/get-customer-specific-settings',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function() {
		this.viewFrom = 'changeSettings'
	})

	.controller('CustomerSpecificSettingsController', CustomerSpecificSettingsController);

	CustomerSpecificSettingsController.$inject = [ '$scope', '$state',
			'workflowSharedService', 'CustomerSpecificSettings', 'GlobalValues',
			'EntityPermissions', 'ScreenLog', 'DateUtils','$uibModalInstance','$stateParams','$rootScope','entityConstants' ];

	function CustomerSpecificSettingsController($scope, $state, workflowSharedService,
			CustomerSpecificSettings, GlobalValues, EntityPermissions, ScreenLog, DateUtils,$uibModalInstance,$stateParams,$rootScope,entityConstants) {

		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenLog = ScreenLog;
		vm.customerSpecificSettings = {};
		vm.save = save;
		vm.userId = $stateParams.userId;
		vm.restoreDefault = restoreDefault;
		vm.launch = launch;
		vm.clear = clear;
		workflowSharedService.viewFrom = 'changeSettings';
		vm.isShowRegistrationSettings = true;
		 vm.customerId = vm.globalValues.getCustomerId();
		 vm.isShowOrderSettings=true;
		function launch() {
			$state.go("customer-specific-settings");
		}
		logScreenAccess();
		loadAll();

		function loadAll() {
			CustomerSpecificSettings.get({
				"customerId" : vm.customerId
			},onGetCustomerSpecificSettingsSuccess, onGetCustomerSpecificSettingsError);
		}

		function onGetCustomerSpecificSettingsSuccess(result) {
			vm.customerSpecificSettings = result;
			if(vm.customerSpecificSettings.IsTradeSMSToBeSent==null || vm.customerSpecificSettings.IsTradeSMSToBeSent == undefined)
				{
				vm.customerSpecificSettings.IsTradeSMSToBeSent='Yes';
				}
			if(vm.customerSpecificSettings.IsTradeEmailToBeSent==null || vm.customerSpecificSettings.IsTradeEmailToBeSent == undefined){
				vm.customerSpecificSettings.IsTradeEmailToBeSent='Yes';
			}
	
		}

		function onGetCustomerSpecificSettingsError() {

		}
		
		function restoreDefault() {
			loadAll();
		}
		
	
		function save() {
			var fd = new FormData();
			
			vm.user.dob = DateUtils.convertLocalDateToServer(vm.user.dob);
			fd.append('user', JSON.stringify(vm.user));
            
			console.log(fd);

			CustomerSpecificSettings.update( fd, onSaveSuccess, onSaveError);
			
		}
		
		$rootScope.$on('Refresh', function(event, result) {
			loadAll();
		});
		
		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
		}

		function onSaveError() {

			$scope.clicked = false;
		}
		function logScreenAccess(){
	       	ScreenLog.screenLog(entityConstants.ENTITY_SHORT_NAME.CUSTOMER_SPECIFIC_SETTINGS ,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
	    }

	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	 $stateProvider.state('otp-confirmation-withdraw-request', {
             parent: 'customer-onboarding-status-view',
             url: '/otp-confirmation-withdraw-request/{mobile}/{mobileCountryCode}/{requestId}/{email}/{theme}',
             data: {
                 authorities: []
             },
             onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                 $uibModal.open({
                     templateUrl: 'app/entities/otp-confirm/otp-confirm.html',
                     controller: 'OtpConfirmController',
                     controllerAs: 'vm',
                     backdrop: 'static',
                     size: 'sm',
                     resolve: {
                    	 globalValue: ['StaticLookUp', function(StaticLookUp) {
                             return StaticLookUp.getConfigSettingsPreLogin().$promise;
                         }],
                    	 mode: function(){ return "customeronboardingwithdrawrequest"; }
                     }
                 }).result.then(function() {
                     $state.go('^', {}, { reload: true });
                 }, function() {
                     $state.go('^');
                 });
             }]

         })
         .state('otp-confirmation-withdraw-reg-request', {
             parent: 'registrationRequestStatus',
             url: '/otp-confirmation-withdraw-reg-regrequest/{mobile}/{mobileCountryCode}/{requestId}/{email}/{theme}',
             data: {
                 authorities: []
             },
             onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                 $uibModal.open({
                     templateUrl: 'app/entities/otp-confirm/otp-confirm.html',
                     controller: 'OtpConfirmController',
                     controllerAs: 'vm',
                     backdrop: 'static',
                     size: 'sm',
                     resolve: {
                    	 globalValue: ['StaticLookUp', function(StaticLookUp) {
                             return StaticLookUp.getConfigSettingsPreLogin().$promise;
                         }],
                    	 mode: function(){ return "customeronboardingwithdrawregrequest"; }
                     }
                 }).result.then(function() {
                     $state.go('^', {}, { reload: true });
                 }, function() {
                     $state.go('^');
                 });
             }]

         })
         $stateProvider.state('otp-confirmation-fetch-reg-request', {
             parent: 'registrationRequestStatus',
             url: '/otp-confirmation-fetch-reg-request/{theme}',
             params: {refNo: null},
             data: {
                 authorities: []
             },
             onEnter: ['$stateParams', '$state', '$uibModal', 'CryptoUtil','GlobalValues', function($stateParams, $state, $uibModal, CryptoUtil, GlobalValues) {
                 $uibModal.open({
                     templateUrl: 'app/entities/otp-confirm/otp-confirm.html',
                     controller: 'OtpConfirmController',
                     controllerAs: 'vm',
                     backdrop: 'static',
                     size: 'sm',
                     resolve: {
                         globalValue: ['StaticLookUp', function(StaticLookUp) {
                             return StaticLookUp.getConfigSettingsPreLogin().$promise;
                         }],
                         mode: function(){ return "customeronboardingfetchregrequest"; }
                     }
                 }).result.then(function(result) {
                     $state.go('customer-registration-status-view', {id: CryptoUtil.encrypt(result.activationKey, GlobalValues.getPlatformENCCode()), theme: 'light'});
                 }, function() {
                     $state.go('^');
                 });
             }]
         })
         $stateProvider.state('otp-confirmation-fetch-request', {
             parent: 'customerOnboardingStatus',
             url: '/otp-confirmation-fetch-request/{theme}',
             params: {refNo: null},
             data: {
                 authorities: []
             },
             onEnter: ['$stateParams', '$state', '$uibModal', 'CryptoUtil','GlobalValues', function($stateParams, $state, $uibModal, CryptoUtil, GlobalValues) {
                 $uibModal.open({
                     templateUrl: 'app/entities/otp-confirm/otp-confirm.html',
                     controller: 'OtpConfirmController',
                     controllerAs: 'vm',
                     backdrop: 'static',
                     size: 'sm',
                     resolve: {
                         globalValue: ['StaticLookUp', function(StaticLookUp) {
                             return StaticLookUp.getConfigSettingsPreLogin().$promise;
                         }],
                         mode: function(){ return "customeronboardingfetchrequest"; }
                     }
                 }).result.then(function(result) {
                     $state.go('customer-onboarding-status-view', {id: CryptoUtil.encrypt(result.activationKey, GlobalValues.getPlatformENCCode()), theme: 'light'});
                 }, function() {
                     $state.go('^');
                 });
             }]
         })
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CustomerViewPanImageController',CustomerViewPanImageController);

    CustomerViewPanImageController.$inject = ['$uibModalInstance','$stateParams', 'GlobalValues'];

    function CustomerViewPanImageController($uibModalInstance,$stateParams, GlobalValues) {
    	var vm = this;
        vm.clear = clear;
        vm.image = $stateParams.image;
        vm.theme = $stateParams.theme;
        
        

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        
        
    }
})();

(function () {
    "use strict";

    angular
        .module("gatewayApp")
        .controller(
            "CustomerRegistrationViewController",
            CustomerRegistrationViewController
        );

    CustomerRegistrationViewController.$inject = [
        "$scope",
        "$state",
        "$rootScope",
        "$window",
        "$stateParams",
        "workflowSharedService",
        "mode",
        "CustomerTradingBankDetails",
        "Branch",
        "$uibModalInstance",
        "StaticLookUp",
        "CustomerApproval",
        "entity",
        "Workflow",
        "GlobalValues",
        "ScreenLog",
        "CustomerRegistration",
        "MessageBox",
        "DateUtils",
        "CustomerInfoChange",
        "enableField",
        "CustomerInfoUtil",
        "entityConstants",
        "$filter",
        "ModifyCustomerDetailsService",
        "AlertService",
        "TACViewForEntitiesService",
        "TacViewForEntitiesUtility",
        "customerTypeWiseInputDetails",
        "ClearcorpTACUpload",
        "markupTypes",
        "roEdApplicabilityMethods",
        "CryptoUtil"
    ];

    function CustomerRegistrationViewController(
        $scope,
        $state,
        $rootScope,
        $window,
        $stateParams,
        workflowSharedService,
        mode,
        CustomerTradingBankDetails,
        Branch,
        $uibModalInstance,
        StaticLookUp,
        CustomerApproval,
        entity,
        Workflow,
        GlobalValues,
        ScreenLog,
        CustomerRegistration,
        MessageBox,
        DateUtils,
        CustomerInfoChange,
        enableField,
        CustomerInfoUtil,
        entityConstants,
        $filter,
        ModifyCustomerDetailsService,
        AlertService,
        TACViewForEntitiesService,
        TacViewForEntitiesUtility,
        customerTypeWiseInputDetails,
        ClearcorpTACUpload,
        markupTypes,
        roEdApplicabilityMethods,
        CryptoUtil
    ) {
        var vm = this;
        vm.screenLog = ScreenLog;
        vm.clear = clear;
        vm.customerTypes = StaticLookUp.getAllCustomerTypes();
        vm.approveCustomerRegistration = approveCustomerRegistration;
        vm.rejectCustomerRegistration = rejectCustomerRegistration;
        vm.sourceOfIntro = StaticLookUp.getsourceOfIntro();
        vm.mode = mode;
        vm.showButton = false;
        vm.disableMarkup = false;
        vm.showHighLight = false;
        vm.clicked = false;
        vm.globalValues = GlobalValues;
        if (
            vm.globalValues != null &&
            vm.globalValues != undefined &&
            vm.globalValues.getEntityOwnerType() != null &&
            vm.globalValues.getEntityOwnerType() != undefined
        ) {
            vm.userEntityOwnerType =
                vm.globalValues.getEntityOwnerType().shortName;
        }
        vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.decimalForPaise =
            vm.globalValues.getNumberOfDecimalsForRateInReports();
        vm.roEdApplicabilityMethodList = roEdApplicabilityMethods;
        vm.markupTypes = markupTypes;
        vm.disable = true;
        vm.ExpandOrCollapseCustomerInfo = true;
        vm.ExpandOrCollapseBankRelationship = false;
        vm.ExpandOrCollapseUserInfo = false;
        vm.theme = $stateParams.theme;
        vm.showDiscardButton = false;
        vm.bankInfo = true;
        vm.showMarkup = false;
        vm.defaultUserInfo = true;
        vm.showResubmitButton = false;
        vm.resubmitCustomerRegistration = resubmitCustomerRegistration;
        vm.discardCustomerUpdate = discardCustomerUpdate;
        /*Added to enable fields for resubmit from cstomer prfile amendment    */
        vm.checkforModification = checkforModification;
        vm.enableFieldsForResubmit = false;
        vm.invalidPanImageSize = false;
        var fd = null;
        var customerPreviousData = {};
        vm.oldTradingBranch = null;
        vm.oldHomeBranchDetails = null;
        vm.oldBankAccountNumber = null;
        vm.filterText = null;
        vm.isEdit = false;
        vm.noChange = false;
        vm.noHomeBranchChange = false;
        vm.noAccountChange = false;
        vm.isModifyScreen = false;
        vm.saveModificationOnCustomerDetails =
            saveModificationOnCustomerDetails;
        vm.cutomerInfo = true;
        vm.authPersonInfo = true;
        vm.showPrint = false;
        vm.discardModifyCustomerDetails = discardModifyCustomerDetails;
        vm.rejectCustomerModification = rejectCustomerModification;
        vm.approveModifyCustomerDetails = approveModifyCustomerDetails;
        vm.resubmitModifyCustomerDetails = resubmitModifyCustomerDetails;
        vm.viewAcceptedTermsAndConditions = viewAcceptedTermsAndConditions;
        vm.downloadAnnexure1 = downloadAnnexure1;
        vm.clicked = false;
        //intialize customer type wise input details
        vm.customerTypeWiseInputDetails = customerTypeWiseInputDetails;

        //Indices of input details in customer type wise input details array
        $scope.firstNameIndex = 0;
        $scope.middleNameIndex = 1;
        $scope.lastNameIndex = 2;
        $scope.entityNameIndex = 3;
        $scope.panNoIndex = 4;
        $scope.panImageIndex = 5;
        $scope.legalEntityIdentifierIndex = 6;
        $scope.leiExpiryDateIndex = 7;
        $scope.cinIndex = 8;
        $scope.gstinIndex = 9;
        $scope.stateCodeIndex = 10;
        $scope.dobDoiIndex = 11;
        vm.showSingleUser = false;
        vm.showMultiUser = false;
        vm.isSoleProp = false;
        var tacAnnexurefilename = "FX-Retail Registration with T&C_";

        $scope.customerTypeSolePropId = 27;

        vm.onGetCcilTac = TacViewForEntitiesUtility.onGetCcilTacForBank;
        vm.messageBoxName = "customerApproval";

        angular.forEach(vm.markupTypes, function (value) {
            if (value.shortName.toUpperCase() == "PAISE") {
                vm.markupType = value;
            } else {
                vm.markupType = value;
            }
        });

        //set no of decimals based on markup types
        $scope.$watch("vm.markupType", function (value) {
            if (value != null && value != undefined) {
                if (vm.markupType.shortName.toUpperCase() == "PERCENTAGE") {
                    vm.noOfDecimals = vm.decimalsForPercent;
                    document.getElementById("txtMarkupValue2").value = "";
                    vm.markup.markupValue = null;
                } else {
                    vm.noOfDecimals = vm.decimalForPaise;
                    document.getElementById("txtMarkupValue1").value = "";
                    vm.markup.markupValue = null;
                }
            }
        });

        $scope.$watch(
            "vm.customerRegistrationRequest.markupSettings.markupValue",
            function (value) {
                if (value === null || value === undefined || value === "") {
                    vm.disableTax = true;
                    document.getElementById("txtTaxOnMarkup").value = "";
                    vm.customerRegistrationRequest.markupSettings.taxOnMarkup =
                        null;
                } else {
                    if (value === 0) {
                        vm.customerRegistrationRequest.markupSettings.markupValue =
                            "0";
                    }
                    vm.disableTax = false;
                }
            }
        );

        function setMarkupTypeAndRoedMethod() {
            angular.forEach(vm.markupTypes, function (value) {
                if (
                    value.shortName.toUpperCase() ==
                    vm.customerRegistrationRequest.markupSettings.markupType.toUpperCase()
                ) {
                    vm.markupType = value;
                }
            });
            angular.forEach(vm.roEdApplicabilityMethodList, function (value) {
                if (
                    value.id ==
                    vm.customerRegistrationRequest.markupSettings
                        .roEdApplicabilityMethodId
                ) {
                    vm.roEdApplicabilityMethod = value;
                }
            });
        }
        function setUserNameAsCustomerName() {
            if (
                vm.customerRegistrationRequest.customerType.customerUserType
                    .shortName == "SingleUserCustomer"
            ) {
                vm.customerRegistrationRequest.userFirstName =
                    vm.customerDetails.customer.customerFirstName;
                vm.customerRegistrationRequest.userMiddleName =
                    vm.customerDetails.customer.customerMiddleName;
                vm.customerRegistrationRequest.userLastName =
                    vm.customerDetails.customer.customerLastName;
            }
        }
        function setCustomerNameAsUserName() {
            if (
                vm.customerRegistrationRequest.customerType.customerUserType
                    .shortName == "SingleUserCustomer"
            ) {
                vm.customerDetails.customer.customerFirstName =
                    vm.customerRegistrationRequest.userFirstName;
                vm.customerDetails.customer.customerMiddleName =
                    vm.customerRegistrationRequest.userMiddleName;
                vm.customerDetails.customer.customerLastName =
                    vm.customerRegistrationRequest.userLastName;
            }
        }
        function hideNameDisplayDetailsForSoleProp(
            customerRegistrationRequest
        ) {
            if (
                customerRegistrationRequest.customerType.id ==
                $scope.customerTypeSolePropId
            ) {
                vm.isSoleProp = true;
            }
        }
        if (mode == "customerViewReport") {
            vm.bankInfo = true;
            vm.defaultUserInfo = true;
        } else if (mode == "customerApprovalToDo") {
            vm.theme = "dark";
        } else if (mode == "auditlog" || mode == "HistoryReport") {
            vm.theme = "dark";
        }

        vm.customerRegistrationRequest = entity;
        if (
            vm.customerRegistrationRequest.customerCode != null &&
            vm.customerRegistrationRequest.customerCode != undefined
        ) {
            CustomerRegistration.getPANImage(
                { customerCode: vm.customerRegistrationRequest.customerCode },
                function (result) {
                    vm.customerRegistrationRequest.customerPanImage = result;
                }
            );
        }
        vm.customerRegistrationRequest.dobOrDoi = new Date(
            vm.customerRegistrationRequest.dobOrDoi
        );
        vm.customerRegistrationRequest.dob = new Date(
            vm.customerRegistrationRequest.dob
        );
        if (
            vm.customerRegistrationRequest.leiExpiryDate != null &&
            vm.customerRegistrationRequest.leiExpiryDate != undefined &&
            vm.customerRegistrationRequest.leiExpiryDate != ""
        ) {
            vm.customerRegistrationRequest.leiExpiryDate = new Date(
                vm.customerRegistrationRequest.leiExpiryDate
            );
        }

        if (
            (mode == "customeronboardingstatus" ||
                mode == "registrationrequeststatus") &&
            vm.customerRegistrationRequest.customerBankRelationshipStatus
                .shortName == "PENDINGAPPROVAL"
        ) {
            vm.withdraw = true;
        }
        if (workflowSharedService.viewFrom == "customerregistration") {
            vm.customerRegistrationRequest = entity;
            if (
                vm.customerRegistrationRequest.customerCode != null &&
                vm.customerRegistrationRequest.customerCode != undefined
            ) {
                CustomerRegistration.getPANImage(
                    {
                        customerCode:
                            vm.customerRegistrationRequest.customerCode
                    },
                    function (result) {
                        vm.customerRegistrationRequest.customerPanImage =
                            result;
                    }
                );
            }
            vm.customerRegistrationRequest.dobOrDoi = new Date(
                vm.customerRegistrationRequest.dobOrDoi
            );
            vm.customerRegistrationRequest.dob = new Date(
                vm.customerRegistrationRequest.dob
            );
            if (
                vm.customerRegistrationRequest.leiExpiryDate != null &&
                vm.customerRegistrationRequest.leiExpiryDate != undefined &&
                vm.customerRegistrationRequest.leiExpiryDate != ""
            ) {
                vm.customerRegistrationRequest.leiExpiryDate = new Date(
                    vm.customerRegistrationRequest.leiExpiryDate
                );
            }
            vm.showButton = false;
            if (
                mode == "customeronboardingstatus" ||
                mode == "registrationrequeststatus"
            ) {
                vm.withdraw = true;
            } else if (mode == "modifycustomerdetails") {
                vm.oldTradingBranch = entity.tradingBranch;
                //Added for Home branch and account number update CR 27-OCT-2021
                vm.oldHomeBranchDetails = angular.copy(entity.homeBranch);
                vm.oldBankAccountNumber = angular.copy(
                    entity.bankAccountNumber
                );
                vm.filterText = entity.bank.ccpMembershipId;
                //alert(vm.tradingBank.customer.id);
                vm.isEdit = true;
                vm.noChange = false;
                vm.noHomeBranchChange = false;
                vm.noAccountChange = false;
                vm.bankInfo = true;
                vm.defaultUserInfo = false;
                vm.theme = "dark";
                vm.termsAndConditionsApproval = true;
                vm.showPrint = false;
                vm.showButton = false;
                vm.showResubmitButton = false;
                vm.showDiscardButton = false;
                vm.isModifyScreen = true;
                vm.cutomerInfo = false;
                vm.authPersonInfo = false;
                vm.ExpandOrCollapseCustomerInfo = false;
                vm.ExpandOrCollapseBankRelationship = true;
                vm.ExpandOrCollapseUserInfo = false;
            }
        } else if (
            workflowSharedService.viewFrom ==
            "customerregistrationtodolist_checker"
        ) {
            if (mode == "customerInfoChangeStatus") {
                vm.bankInfo = true;
                vm.defaultUserInfo = true;
                vm.customerDetails = angular.copy(
                    angular.fromJson($rootScope.payload)
                );
                console.log(vm.customerDetails);
                vm.customerRegistrationRequest = vm.customerDetails.customer;
                CustomerTradingBankDetails.getBankAndDefaultUserDetailsForCustomer(
                    {
                        customerId: vm.customerDetails.customer.id,
                        bankId: vm.globalValues.getOrganisation().id
                    },
                    function (result) {
                        vm.bankAndDefaultUserDetails = result;
                        UpdateBankAndDefaultUserDetails();
                        setUserNameAsCustomerName();
                    }
                );
                hideNameDisplayDetailsForSoleProp(
                    vm.customerRegistrationRequest
                );
                vm.theme = "dark";
                vm.termsAndConditionsApproval = true;
                vm.showPrint = true;
            } else {
                vm.customerRegistrationRequest = angular.copy(
                    angular.fromJson($rootScope.payload)
                );
                vm.termsAndConditionsApproval = false;
                vm.showPrint = true;
                vm.organisation = vm.globalValues.getOrganisation();

                vm.showMarkup = true;
                vm.showHighLight = true;
                //fill markup setting
                if (
                    vm.customerRegistrationRequest.markupSettings == null ||
                    vm.customerRegistrationRequest.markupSettings == undefined
                ) {
                    CustomerRegistration.getMarkupDetails(
                        vm.customerRegistrationRequest,
                        function (result) {
                            vm.customerRegistrationRequest.markupSettings =
                                result.markupSettings;
                            setMarkupTypeAndRoedMethod();
                        }
                    );
                } else {
                    setMarkupTypeAndRoedMethod();
                }
                //loadTacAgreedDetailsForChecker(vm.organisation.id);
            }
            if (
                vm.customerRegistrationRequest.customerCode != null &&
                vm.customerRegistrationRequest.customerCode != undefined
            ) {
                CustomerRegistration.getPANImage(
                    {
                        customerCode:
                            vm.customerRegistrationRequest.customerCode
                    },
                    function (result) {
                        vm.customerRegistrationRequest.customerPanImage =
                            result;
                    }
                );
            }
            vm.customerRegistrationRequest.dobOrDoi = new Date(
                vm.customerRegistrationRequest.dobOrDoi
            );
            vm.customerRegistrationRequest.dob = new Date(
                vm.customerRegistrationRequest.dob
            );
            if (
                vm.customerRegistrationRequest.leiExpiryDate != null &&
                vm.customerRegistrationRequest.leiExpiryDate != undefined &&
                vm.customerRegistrationRequest.leiExpiryDate != ""
            ) {
                vm.customerRegistrationRequest.leiExpiryDate = new Date(
                    vm.customerRegistrationRequest.leiExpiryDate
                );
                //vm.printArray.push(vm.customerRegistrationRequest);
            }

            vm.showButton = true;
            vm.showResubmitButton = false;
            vm.showDiscardButton = false;
        } else if (
            workflowSharedService.viewFrom ==
            "customerregistrationtodolist_maker"
        ) {
            if (mode == "customerInfoChangeStatus") {
                vm.bankInfo = false;
                vm.defaultUserInfo = false;
                vm.authPersonInfo = false;
                vm.customerDetails = angular.copy(
                    angular.fromJson($rootScope.payload)
                );
                vm.customerRegistrationRequest = vm.customerDetails.customer;
                setUserNameAsCustomerName();
                hideNameDisplayDetailsForSoleProp(
                    vm.customerRegistrationRequest
                );
                vm.theme = "dark";
            } else {
                vm.customerRegistrationRequest = angular.copy(
                    angular.fromJson($rootScope.payload)
                );
            }
            if (
                vm.customerRegistrationRequest.customerCode != null &&
                vm.customerRegistrationRequest.customerCode != undefined
            ) {
                CustomerRegistration.getPANImage(
                    {
                        customerCode:
                            vm.customerRegistrationRequest.customerCode
                    },
                    function (result) {
                        vm.customerRegistrationRequest.customerPanImage =
                            result;
                    }
                );
            }
            vm.customerRegistrationRequest.dobOrDoi = new Date(
                vm.customerRegistrationRequest.dobOrDoi
            );
            vm.customerRegistrationRequest.dob = new Date(
                vm.customerRegistrationRequest.dob
            );
            if (
                vm.customerRegistrationRequest.leiExpiryDate != null &&
                vm.customerRegistrationRequest.leiExpiryDate != undefined &&
                vm.customerRegistrationRequest.leiExpiryDate != ""
            ) {
                vm.customerRegistrationRequest.leiExpiryDate = new Date(
                    vm.customerRegistrationRequest.leiExpiryDate
                );
            }
            vm.showButton = false;
            vm.showResubmitButton = false;
            vm.showDiscardButton = true;
        } else if (
            workflowSharedService.viewFrom ==
            "customerregistrationtodolist_resubmit"
        ) {
            if (mode == "customerInfoChangeStatus") {
                vm.bankInfo = false;
                vm.defaultUserInfo = false;
                vm.authPersonInfo = false;
                vm.customerDetails = angular.copy(
                    angular.fromJson($rootScope.payload)
                );
                vm.customerRegistrationRequest = vm.customerDetails.customer;
                setUserNameAsCustomerName();
                hideNameDisplayDetailsForSoleProp(
                    vm.customerRegistrationRequest
                );
                vm.theme = "dark";
                vm.enableFieldsForResubmit = enableField;
                if (vm.enableFieldsForResubmit) {
                    $("#panImageFile").val(null);
                    vm.image = null;
                    fd = new FormData();
                    customerPreviousData = angular.copy(
                        vm.customerDetails.customer
                    );
                }
            } else {
                vm.customerRegistrationRequest = angular.copy(
                    angular.fromJson($rootScope.payload)
                );
            }
            if (
                vm.customerRegistrationRequest.customerCode != null &&
                vm.customerRegistrationRequest.customerCode != undefined
            ) {
                CustomerRegistration.getPANImage(
                    {
                        customerCode:
                            vm.customerRegistrationRequest.customerCode
                    },
                    function (result) {
                        vm.customerRegistrationRequest.customerPanImage =
                            result;
                    }
                );
            }
            vm.customerRegistrationRequest.dobOrDoi = new Date(
                vm.customerRegistrationRequest.dobOrDoi
            );
            vm.customerRegistrationRequest.dob = new Date(
                vm.customerRegistrationRequest.dob
            );
            if (
                vm.customerRegistrationRequest.leiExpiryDate != null &&
                vm.customerRegistrationRequest.leiExpiryDate != undefined &&
                vm.customerRegistrationRequest.leiExpiryDate != ""
            ) {
                vm.customerRegistrationRequest.leiExpiryDate = new Date(
                    vm.customerRegistrationRequest.leiExpiryDate
                );
            }
            vm.showButton = false;
            vm.showResubmitButton = true;
            vm.showDiscardButton = false;
        }

        if (
            workflowSharedService.viewFrom ==
            "customerregistrationtodolist_auditlog"
        ) {
            if (mode == "customerInfoChangeStatus" || mode == "InfoAuditlog") {
                vm.bankInfo = false;
                vm.defaultUserInfo = false;
                vm.authPersonInfo = false;
                vm.customerDetails = angular.copy(
                    angular.fromJson($rootScope.payload)
                );
                vm.customerRegistrationRequest = vm.customerDetails.customer;
                setUserNameAsCustomerName();
                hideNameDisplayDetailsForSoleProp(
                    vm.customerRegistrationRequest
                );
                vm.theme = "dark";
            } else {
                vm.customerRegistrationRequest = angular.copy(
                    angular.fromJson($rootScope.payload)
                );

                vm.disableMarkup = true;
                if (vm.customerRegistrationRequest.markupSettings != null) {
                    vm.showMarkup = true;
                    setMarkupTypeAndRoedMethod();
                }
            }

            if (
                vm.customerRegistrationRequest.customerCode != null &&
                vm.customerRegistrationRequest.customerCode != undefined
            ) {
                CustomerRegistration.getPANImage(
                    {
                        customerCode:
                            vm.customerRegistrationRequest.customerCode
                    },
                    function (result) {
                        vm.customerRegistrationRequest.customerPanImage =
                            result;
                    }
                );
            }
            vm.customerRegistrationRequest.dobOrDoi = new Date(
                vm.customerRegistrationRequest.dobOrDoi
            );
            vm.customerRegistrationRequest.dob = new Date(
                vm.customerRegistrationRequest.dob
            );
            if (
                vm.customerRegistrationRequest.leiExpiryDate != null &&
                vm.customerRegistrationRequest.leiExpiryDate != undefined &&
                vm.customerRegistrationRequest.leiExpiryDate != ""
            ) {
                vm.customerRegistrationRequest.leiExpiryDate = new Date(
                    vm.customerRegistrationRequest.leiExpiryDate
                );
            }
            vm.showButton = false;
            vm.showResubmitButton = false;
        }
        if (
            workflowSharedService.viewFrom ==
            "customerregistrationtodolist_historyReport"
        ) {
            if (
                mode == "customerInfoChangeStatus" ||
                mode == "InfoHistoryReport"
            ) {
                vm.bankInfo = false;
                vm.defaultUserInfo = false;
                vm.authPersonInfo = false;
                vm.customerDetails = angular.copy(
                    angular.fromJson($rootScope.payload)
                );
                vm.customerRegistrationRequest = vm.customerDetails.customer;
                setUserNameAsCustomerName();
                hideNameDisplayDetailsForSoleProp(
                    vm.customerRegistrationRequest
                );
                vm.theme = "dark";
            } else {
                vm.customerRegistrationRequest = angular.copy(
                    angular.fromJson($rootScope.payload)
                );

                vm.disableMarkup = true;
                if (vm.customerRegistrationRequest.markupSettings != null) {
                    vm.showMarkup = true;
                    setMarkupTypeAndRoedMethod();
                }
            }

            if (
                vm.customerRegistrationRequest.customerCode != null &&
                vm.customerRegistrationRequest.customerCode != undefined
            ) {
                CustomerRegistration.getPANImage(
                    {
                        customerCode:
                            vm.customerRegistrationRequest.customerCode
                    },
                    function (result) {
                        vm.customerRegistrationRequest.customerPanImage =
                            result;
                    }
                );
            }
            vm.customerRegistrationRequest.dobOrDoi = new Date(
                vm.customerRegistrationRequest.dobOrDoi
            );
            vm.customerRegistrationRequest.dob = new Date(
                vm.customerRegistrationRequest.dob
            );
            if (
                vm.customerRegistrationRequest.leiExpiryDate != null &&
                vm.customerRegistrationRequest.leiExpiryDate != undefined &&
                vm.customerRegistrationRequest.leiExpiryDate != ""
            ) {
                vm.customerRegistrationRequest.leiExpiryDate = new Date(
                    vm.customerRegistrationRequest.leiExpiryDate
                );
            }
            vm.showButton = false;
            vm.showResubmitButton = false;
        } else if (
            workflowSharedService.viewFrom == "modifycustomerdetails_checker"
        ) {
            vm.bankInfo = true;
            vm.defaultUserInfo = true;
            vm.customerReport = angular.copy(
                angular.fromJson($rootScope.payload)
            );
            //Added for Home branch and account number update CR 27-OCT-2021
            vm.oldTradingBranch = angular.copy(
                vm.customerReport.oldTradingBranch
            );
            vm.oldHomeBranchDetails = angular.copy(
                vm.customerReport.oldHomeBranchDetails
            );
            vm.oldBankAccountNumber = angular.copy(
                vm.customerReport.oldBankAccountNumber
            );
            CustomerTradingBankDetails.getCustomerRegistrationRequestFromPayload(
                vm.customerReport,
                function (result) {
                    vm.customerRegistrationRequest = angular.fromJson(
                        result.data
                    );
                    if (
                        vm.customerReport.customer.customerCode != null &&
                        vm.customerReport.customer.customerCode != undefined
                    ) {
                        CustomerRegistration.getPANImage(
                            {
                                customerCode:
                                    vm.customerReport.customer.customerCode
                            },
                            function (result) {
                                vm.customerRegistrationRequest.customerPanImage =
                                    result;
                            }
                        );
                    }
                    vm.customerRegistrationRequest.dobOrDoi = new Date(
                        vm.customerRegistrationRequest.dobOrDoi
                    );
                    vm.customerRegistrationRequest.dob = new Date(
                        vm.customerRegistrationRequest.dob
                    );
                    if (
                        vm.customerRegistrationRequest.leiExpiryDate != null &&
                        vm.customerRegistrationRequest.leiExpiryDate !=
                            undefined &&
                        vm.customerRegistrationRequest.leiExpiryDate != ""
                    ) {
                        vm.customerRegistrationRequest.leiExpiryDate = new Date(
                            vm.customerRegistrationRequest.leiExpiryDate
                        );
                        //vm.printArray.push(vm.customerRegistrationRequest);
                    }
                }
            );
            vm.theme = "dark";
            vm.termsAndConditionsApproval = true;
            vm.showPrint = true;

            vm.showButton = true;
            vm.showResubmitButton = false;
            vm.showDiscardButton = false;
            vm.isModifyScreen = true;
            vm.ExpandOrCollapseCustomerInfo = false;
            vm.ExpandOrCollapseBankRelationship = true;
            vm.ExpandOrCollapseUserInfo = false;
        } else if (
            workflowSharedService.viewFrom == "modifycustomerdetails_maker"
        ) {
            vm.bankInfo = true;
            vm.defaultUserInfo = true;
            vm.theme = "dark";
            vm.customerReport = angular.copy(
                angular.fromJson($rootScope.payload)
            );
            //Added for Home branch and account number update CR 27-OCT-2021
            vm.oldTradingBranch = angular.copy(
                vm.customerReport.oldTradingBranch
            );
            vm.oldHomeBranchDetails = angular.copy(
                vm.customerReport.oldHomeBranchDetails
            );
            vm.oldBankAccountNumber = angular.copy(
                vm.customerReport.oldBankAccountNumber
            );
            CustomerTradingBankDetails.getCustomerRegistrationRequestFromPayload(
                vm.customerReport,
                function (result) {
                    vm.customerRegistrationRequest = angular.fromJson(
                        result.data
                    );
                    if (
                        vm.customerReport.customer.customerCode != null &&
                        vm.customerReport.customer.customerCode != undefined
                    ) {
                        CustomerRegistration.getPANImage(
                            {
                                customerCode:
                                    vm.customerReport.customer.customerCode
                            },
                            function (result) {
                                vm.customerRegistrationRequest.customerPanImage =
                                    result;
                            }
                        );
                    }
                    vm.customerRegistrationRequest.dobOrDoi = new Date(
                        vm.customerRegistrationRequest.dobOrDoi
                    );
                    vm.customerRegistrationRequest.dob = new Date(
                        vm.customerRegistrationRequest.dob
                    );
                    if (
                        vm.customerRegistrationRequest.leiExpiryDate != null &&
                        vm.customerRegistrationRequest.leiExpiryDate !=
                            undefined &&
                        vm.customerRegistrationRequest.leiExpiryDate != ""
                    ) {
                        vm.customerRegistrationRequest.leiExpiryDate = new Date(
                            vm.customerRegistrationRequest.leiExpiryDate
                        );
                        //vm.printArray.push(vm.customerRegistrationRequest);
                    }
                }
            );
            vm.showButton = false;
            vm.showResubmitButton = false;
            vm.showDiscardButton = true;
            vm.isModifyScreen = true;
            vm.ExpandOrCollapseCustomerInfo = false;
            vm.ExpandOrCollapseBankRelationship = true;
            vm.ExpandOrCollapseUserInfo = false;
        } else if (
            workflowSharedService.viewFrom == "modifycustomerdetails_resubmit"
        ) {
            vm.bankInfo = true;
            vm.defaultUserInfo = true;
            vm.isEdit = true;
            vm.theme = "dark";
            vm.enableFieldsForResubmit = false;
            vm.customerReport = angular.copy(
                angular.fromJson($rootScope.payload)
            );
            vm.oldTradingBranch = vm.customerReport.oldTradingBranch;
            //Added for Home branch and account number update CR 27-OCT-2021
            vm.oldHomeBranchDetails = angular.copy(
                vm.customerReport.oldHomeBranchDetails
            );
            vm.oldBankAccountNumber = angular.copy(
                vm.customerReport.oldBankAccountNumber
            );
            vm.filterText =
                vm.customerReport.customerTradingBankDetails.bank.ccpMembershipId;
            CustomerTradingBankDetails.getCustomerRegistrationRequestFromPayload(
                vm.customerReport,
                function (result) {
                    vm.customerRegistrationRequest = angular.fromJson(
                        result.data
                    );
                    if (
                        vm.customerReport.customer.customerCode != null &&
                        vm.customerReport.customer.customerCode != undefined
                    ) {
                        CustomerRegistration.getPANImage(
                            {
                                customerCode:
                                    vm.customerReport.customer.customerCode
                            },
                            function (result) {
                                vm.customerRegistrationRequest.customerPanImage =
                                    result;
                            }
                        );
                    }
                    vm.customerRegistrationRequest.dobOrDoi = new Date(
                        vm.customerRegistrationRequest.dobOrDoi
                    );
                    vm.customerRegistrationRequest.dob = new Date(
                        vm.customerRegistrationRequest.dob
                    );
                    if (
                        vm.customerRegistrationRequest.leiExpiryDate != null &&
                        vm.customerRegistrationRequest.leiExpiryDate !=
                            undefined &&
                        vm.customerRegistrationRequest.leiExpiryDate != ""
                    ) {
                        vm.customerRegistrationRequest.leiExpiryDate = new Date(
                            vm.customerRegistrationRequest.leiExpiryDate
                        );
                        //vm.printArray.push(vm.customerRegistrationRequest);
                    }
                }
            );
            if (vm.enableFieldsForResubmit) {
                $("#panImageFile").val(null);
                vm.image = null;
                fd = new FormData();
                //customerPreviousData = angular.copy(vm.customerDetails.customer);
            }

            vm.showButton = false;
            vm.showResubmitButton = true;
            vm.showDiscardButton = false;
            vm.isModifyScreen = true;
            vm.termsAndConditionsApproval = false;
            vm.ExpandOrCollapseCustomerInfo = false;
            vm.ExpandOrCollapseBankRelationship = true;
            vm.ExpandOrCollapseUserInfo = false;
        }

        if (
            workflowSharedService.viewFrom == "modifycustomerdetails_auditlog"
        ) {
            vm.bankInfo = true;
            vm.defaultUserInfo = true;
            vm.isModifyScreen = true;
            vm.theme = "dark";
            vm.customerReport = angular.copy(
                angular.fromJson($rootScope.payload)
            );
            //Added for Home branch and account number update CR 27-OCT-2021
            vm.oldTradingBranch = angular.copy(
                vm.customerReport.oldTradingBranch
            );
            vm.oldHomeBranchDetails = angular.copy(
                vm.customerReport.oldHomeBranchDetails
            );
            vm.oldBankAccountNumber = angular.copy(
                vm.customerReport.oldBankAccountNumber
            );
            CustomerTradingBankDetails.getCustomerRegistrationRequestFromPayload(
                vm.customerReport,
                function (result) {
                    vm.customerRegistrationRequest = angular.fromJson(
                        result.data
                    );
                    if (
                        vm.customerReport.customer.customerCode != null &&
                        vm.customerReport.customer.customerCode != undefined
                    ) {
                        CustomerRegistration.getPANImage(
                            {
                                customerCode:
                                    vm.customerReport.customer.customerCode
                            },
                            function (result) {
                                vm.customerRegistrationRequest.customerPanImage =
                                    result;
                            }
                        );
                    }
                    vm.customerRegistrationRequest.dobOrDoi = new Date(
                        vm.customerRegistrationRequest.dobOrDoi
                    );
                    vm.customerRegistrationRequest.dob = new Date(
                        vm.customerRegistrationRequest.dob
                    );
                    if (
                        vm.customerRegistrationRequest.leiExpiryDate != null &&
                        vm.customerRegistrationRequest.leiExpiryDate !=
                            undefined &&
                        vm.customerRegistrationRequest.leiExpiryDate != ""
                    ) {
                        vm.customerRegistrationRequest.leiExpiryDate = new Date(
                            vm.customerRegistrationRequest.leiExpiryDate
                        );
                        //vm.printArray.push(vm.customerRegistrationRequest);
                    }
                }
            );
            vm.showButton = false;
            vm.showResubmitButton = false;
        }
        /* if(workflowSharedService.viewFrom == 'modifycustomerdetails_historyReport') {
                 	
            	 vm.bankInfo=true;
            	 vm.defaultUserInfo=true;
            	 vm.isModifyScreen = true;
            	 vm.theme = 'dark';                 	
            	 vm.customerReport=angular.copy(angular.fromJson($rootScope.payload));
                   
                 CustomerTradingBankDetails.getCustomerRegistrationRequestFromPayload( vm.customerReport, function(result){
                   	vm.customerRegistrationRequest = angular.fromJson(result.data);
                   	if(vm.customerReport.customer.customerCode!=null && vm.customerReport.customer.customerCode!=undefined){
                   		CustomerRegistration.getPANImage({customerCode: vm.customerReport.customer.customerCode}, function(result){
                   			vm.customerRegistrationRequest.customerPanImage = result;
                   		})
                  }
                 vm.customerRegistrationRequest.dobOrDoi = new Date(vm.customerRegistrationRequest.dobOrDoi);
                       vm.customerRegistrationRequest.dob = new Date(vm.customerRegistrationRequest.dob);
                       if( vm.customerRegistrationRequest.leiExpiryDate !=null && vm.customerRegistrationRequest.leiExpiryDate!=undefined 
                     			 && vm.customerRegistrationRequest.leiExpiryDate!= ''){
               			vm.customerRegistrationRequest.leiExpiryDate = new Date(vm.customerRegistrationRequest.leiExpiryDate);
               			//vm.printArray.push(vm.customerRegistrationRequest);
                       }
                 });
             	vm.showButton=false;
             	vm.showResubmitButton=false;
             	
             } */
        if (
            workflowSharedService.viewFrom == "customerinfoupdateintimationview"
        ) {
            if (mode == "customerInfoUpdationIntimationView") {
                vm.bankInfo = false;
                vm.defaultUserInfo = false;
                vm.authPersonInfo = false;
                vm.customerDetails = angular.copy(
                    angular.fromJson($rootScope.payload)
                );
                vm.customerRegistrationRequest = vm.customerDetails.customer;
                setUserNameAsCustomerName();
                vm.theme = "dark";
            }
            if (
                vm.customerRegistrationRequest.customerCode != null &&
                vm.customerRegistrationRequest.customerCode != undefined
            ) {
                CustomerRegistration.getPANImage(
                    {
                        customerCode:
                            vm.customerRegistrationRequest.customerCode
                    },
                    function (result) {
                        vm.customerRegistrationRequest.customerPanImage =
                            result;
                    }
                );
            }
            vm.customerRegistrationRequest.dobOrDoi = new Date(
                vm.customerRegistrationRequest.dobOrDoi
            );
            vm.customerRegistrationRequest.dob = new Date(
                vm.customerRegistrationRequest.dob
            );
            if (
                vm.customerRegistrationRequest.leiExpiryDate != null &&
                vm.customerRegistrationRequest.leiExpiryDate != undefined &&
                vm.customerRegistrationRequest.leiExpiryDate != ""
            ) {
                vm.customerRegistrationRequest.leiExpiryDate = new Date(
                    vm.customerRegistrationRequest.leiExpiryDate
                );
                //vm.printArray.push(vm.customerRegistrationRequest);
            }
        }
        //markup hide when remove action-type
        if (vm.customerRegistrationRequest.actionType == "REMOVE") {
            vm.showMarkup = false;
        }

        function approveCustomerRegistration() {
            if (vm.mode == "customerInfoChangeStatus") {
                vm.screenLog.screenLog(
                    "Customer",
                    vm.customerDetails.customer.id,
                    entityConstants.ENTITY_ACTION_TYPE.APPROVE
                );
                CustomerApproval.approve(
                    { taskId: $rootScope.taskID },
                    onApproveSuccess,
                    onApproveError
                );
                $uibModalInstance.dismiss("cancel");
            } else if (vm.customerRegistrationRequest.tradingBranch != null) {
                if (
                    vm.roEdApplicabilityMethod == null ||
                    vm.roEdApplicabilityMethod == undefined
                ) {
                    AlertService.error(
                        "Please assign the RO/ED Applicability Method"
                    );
                }
                if (vm.markupType == null || vm.markupType == undefined) {
                    AlertService.error("Please assign the markup value");
                }
                vm.customerRegistrationRequest.markupSettings.markupType =
                    vm.markupType.shortName;
                vm.customerRegistrationRequest.markupSettings.roEdApplicabilityMethodId =
                    vm.roEdApplicabilityMethod.id;
                vm.customerRegistrationRequest.dobOrDoi = null;
                vm.screenLog.screenLog(
                    "CustomerRegistration",
                    vm.customerRegistrationRequest.id,
                    entityConstants.ENTITY_ACTION_TYPE.APPROVE
                );
                CustomerApproval.approveCustomerRegistration(
                    { taskId: $rootScope.taskID },
                    vm.customerRegistrationRequest,
                    onApproveSuccess,
                    onApproveError
                );

                /*CustomerApproval.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     */
            }
        }
        function onApproveSuccess(result) {
            if (
                result != null &&
                result != undefined &&
                result.errorMessage != null &&
                result.errorMessage != undefined &&
                result.errorMessage != ""
            ) {
                if (
                    result.errorMessage ==
                    "tacViewForEntities.bank.cannotApproveCustomer"
                ) {
                    vm.clicked = false;
                    MessageBox.openMessageBox(
                        "Alert",
                        $filter("translate")(
                            "error.tacViewForEntities.bank.cannotApproveCustomer"
                        ),
                        "Ok",
                        "bankApprovalMessage"
                    );
                }
            } else {
                $rootScope.removeRow($rootScope.taskID);
                $uibModalInstance.dismiss("cancel");
            }
        }
        function onApproveError(error) {
            vm.clicked = false;
        }

        function rejectCustomerRegistration() {
            Workflow.rejectCustomerApproval($rootScope.taskID);
        }

        vm.viewPanImage = function viewPanImage() {
            if (
                vm.customerRegistrationRequest.customerCode != null &&
                vm.customerRegistrationRequest.customerCode != undefined
            ) {
                CustomerRegistration.getPANImage(
                    {
                        customerCode:
                            vm.customerRegistrationRequest.customerCode
                    },
                    function (result) {
                        vm.customerRegistrationRequest.customerPanImage =
                            result;
                        openPanImage();
                    }
                );
            } else {
                openPanImage();
            }
        };

        function base64ToArrayBuffer(base64) {
            var binary_string = window.atob(base64);
            var len = binary_string.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }
            return bytes.buffer;
        }

        function openPanImage() {
            if (vm.customerRegistrationRequest.fileExtension == "pdf") {
                var contentByteArray = base64ToArrayBuffer(
                    vm.customerRegistrationRequest.panImage
                );

                var file = new Blob([contentByteArray], {
                    type: "application/pdf"
                });
                var fileURL = URL.createObjectURL(file);

                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file, "PAN.pdf");
                } else {
                    window.open(fileURL, "PAN.pdf");
                }
                //var pdfWindow = window.open("");
                //pdfWindow.document.write("<iframe width='100%' height='100%' title='PAN'  src='data:application/pdf;base64, " + encodeURI(vm.customerRegistrationRequest.panImage)+"' ></iframe>")
            } else if (
                (vm.customerRegistrationRequest.customerPanImage != null ||
                    vm.customerRegistrationRequest.customerPanImage !=
                        undefined) &&
                vm.customerRegistrationRequest.customerPanImage.fileExtension ==
                    "pdf"
            ) {
                var contentByteArray = base64ToArrayBuffer(
                    vm.customerRegistrationRequest.customerPanImage.image
                );

                var file = new Blob([contentByteArray], {
                    type: "application/pdf"
                });
                var fileURL = URL.createObjectURL(file);

                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file, "PAN.pdf");
                } else {
                    window.open(fileURL, "PAN.pdf");
                }
                //var pdfWindow = window.open("");
                //pdfWindow.document.write("<iframe width='100%' height='100%' title='PAN'  src='data:application/pdf;base64, " + encodeURI(vm.customerRegistrationRequest.customerPanImage.image)+"' ></iframe>")
            } else {
                if (mode == "trackstatus") {
                    $state.go("view-pan-image-track-status", {
                        image: vm.customerRegistrationRequest.panImage,
                        theme: vm.theme
                    });
                } else if (mode == "registrationrequeststatus") {
                    $state.go("view-pan-image-registration-status", {
                        image: vm.customerRegistrationRequest.panImage,
                        theme: vm.theme
                    });
                } else if (mode == "customeronboarding") {
                    $state.go("view-panImage-customer-onboarding", {
                        image: vm.customerRegistrationRequest.panImage,
                        theme: vm.theme
                    });
                } else if (mode == "customeronboardingstatus") {
                    $state.go("view-panImage-customer-onboarding-status", {
                        image: vm.customerRegistrationRequest.panImage,
                        theme: vm.theme
                    });
                } else if (mode == "customerApprovalToDo") {
                    $state.go("view-panImage-customer-approval", {
                        image: vm.customerRegistrationRequest.panImage,
                        theme: vm.theme
                    });
                } else if (mode == "customerViewReport") {
                    $state.go("view-panImage-customer-view-report", {
                        image: vm.customerRegistrationRequest.panImage,
                        theme: vm.theme
                    });
                } else if (
                    mode == "customerInfoChangeStatus" &&
                    (workflowSharedService.viewFrom ==
                        "customerregistrationtodolist_maker" ||
                        workflowSharedService.viewFrom ==
                            "customerregistrationtodolist_resubmit")
                ) {
                    $state.go("view-panImage-customer-info-status", {
                        image: vm.customerRegistrationRequest.customerPanImage
                            .image,
                        theme: vm.theme
                    });
                } else if (
                    mode == "customerInfoChangeStatus" &&
                    workflowSharedService.viewFrom ==
                        "customerregistrationtodolist_checker"
                ) {
                    $state.go("view-panImage-customer-update", {
                        image: vm.customerRegistrationRequest.customerPanImage
                            .image,
                        theme: vm.theme
                    });
                } else if (mode == "auditlog") {
                    $state.go("view-panImage-audit-log", {
                        image: vm.customerRegistrationRequest.panImage,
                        theme: vm.theme
                    });
                } else if (mode == "HistoryReport") {
                    $state.go("view-panImage-history-report", {
                        image: vm.customerRegistrationRequest.panImage,
                        theme: vm.theme
                    });
                } else if (mode == "InfoAuditlog") {
                    $state.go("view-panImage-customer-info-audit-log", {
                        image: vm.customerRegistrationRequest.customerPanImage
                            .image,
                        theme: vm.theme
                    });
                } else if (mode == "InfoHistoryReport") {
                    $state.go("view-panImage-customer-info-history-report", {
                        image: vm.customerRegistrationRequest.customerPanImage
                            .image,
                        theme: vm.theme
                    });
                } else if (mode == "customerInfoUpdationIntimationView") {
                    $state.go("view-panImage-customer-info-intimation-status", {
                        image: vm.customerRegistrationRequest.customerPanImage
                            .image,
                        theme: vm.theme
                    });
                } else if (mode == "modifycustomerdetails_todo") {
                    $state.go("view-panImage-modify-customer-todo", {
                        image: vm.customerRegistrationRequest.customerPanImage
                            .image,
                        theme: vm.theme
                    });
                } else if (mode == "modifycustomerDetails_history") {
                    $state.go(
                        "view-panImage-modify-customer-details-history-report",
                        {
                            image: vm.customerRegistrationRequest
                                .customerPanImage.image,
                            theme: vm.theme
                        }
                    );
                } else if (mode == "modifycustomerDetails_audit") {
                    $state.go(
                        "view-panImage-modify-customer-details-audit-log",
                        {
                            image: vm.customerRegistrationRequest
                                .customerPanImage.image,
                            theme: vm.theme
                        }
                    );
                }
            }
        }

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        vm.withdrawRequest = function withdraw() {
            vm.isSent = false;
            if (vm.mode == "customeronboardingstatus") {
                MessageBox.openMessageBox(
                    "Alert",
                    "Do you want to withdraw your bank relationship request?",
                    "YesNo",
                    "customeronboardingstatus"
                );
            } else if (vm.mode == "registrationrequeststatus") {
                MessageBox.openMessageBox(
                    "Alert",
                    "Do you want to withdraw your bank relationship request?",
                    "YesNo",
                    "registrationrequeststatus"
                );
            }
            //CustomerRegistration.discard({ "requestId": vm.customerRegistrationRequest.id }, onDiscardSuccess, onDiscardError);
        };

        $rootScope.$on(
            "gatewayApp.messagebox.yes.customeronboardingstatus",
            function (event, data) {
                if (!vm.isSent) {
                    vm.isSent = true;
                    vm.openVerifyDialogue = false;
                    if (
                        vm.customerRegistrationRequest.userMobileCountryCode ==
                            null ||
                        vm.customerRegistrationRequest.userMobileCountryCode ==
                            undefined
                    ) {
                        vm.customerRegistrationRequest.userMobileCountryCode =
                            "";
                    }
                    var mobileNo = vm.customerRegistrationRequest.userMobile;
                    var mobileCountryCode =
                        vm.customerRegistrationRequest.userMobileCountryCode.toString();
                    // CustomerRegistration.sendOTPToMobileAndEmail(
                    //     {
                    //         mobile: mobileNo,
                    //         mobileCountryCode: mobileCountryCode,
                    //         email: vm.customerRegistrationRequest.userEmail
                    //     },
                    //     onSendSuccess,
                    //     onSendFailure
                    // );

                    // Step 1: Execute reCAPTCHA
                    grecaptcha.ready(function () {
                        grecaptcha
                            .execute(
                                CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey,vm.globalValues.getPlatformENCCode()),
                                {
                                    action: "otp_action"
                                }
                            )
                            .then(function (token) {
                                // Step 2: Call API with token
                                CustomerRegistration.sendOTPToMobileAndEmail(
                                    {
                                        mobile: mobileNo,
                                        mobileCountryCode: mobileCountryCode,
                                        email: vm.customerRegistrationRequest
                                            .userEmail,
                                        recaptchaToken: token,
                                        sourceType: "send-otp",
                                        source: "view-customer-registration"
                                    },
                                    onSendSuccess,
                                    onSendFailure
                                );
                            })
                            .catch(function (error) {
                                console.error("reCAPTCHA error:", error);
                                vm.disableGenerateOTP = false;
                            });
                    });
                }
            }
        );

        function onSendSuccess() {
            if (!vm.openVerifyDialogue) {
                vm.openVerifyDialogue = true;
                if (
                    vm.customerRegistrationRequest.userMobileCountryCode ==
                        null ||
                    vm.customerRegistrationRequest.userMobileCountryCode ==
                        undefined
                ) {
                    vm.customerRegistrationRequest.userMobileCountryCode = "";
                }
                var mobileNo = vm.customerRegistrationRequest.userMobile;
                var mobileCountryCode =
                    vm.customerRegistrationRequest.userMobileCountryCode.toString();
                $state.go("otp-confirmation-withdraw-request", {
                    mobile: mobileNo,
                    mobileCountryCode: mobileCountryCode,
                    requestId:
                        vm.customerRegistrationRequest.requestReferenceNumber,
                    email: vm.customerRegistrationRequest.userEmail,
                    theme: "light"
                });
            }
        }

        function onSendFailure() {
            //do nothing
        }

        $rootScope.$on(
            "gatewayApp.messagebox.yes.registrationrequeststatus",
            function (event, data) {
                otp - confirm - controller;
                if (!vm.isSent) {
                    vm.isSent = true;
                    vm.openVerifyDialogue = false;
                    if (
                        vm.customerRegistrationRequest.userMobileCountryCode ==
                            null ||
                        vm.customerRegistrationRequest.userMobileCountryCode ==
                            undefined
                    ) {
                        vm.customerRegistrationRequest.userMobileCountryCode =
                            "";
                    }
                    var mobileNo = vm.customerRegistrationRequest.userMobile;
                    var mobileCountryCode =
                        vm.customerRegistrationRequest.userMobileCountryCode.toString();
                    // CustomerRegistration.sendOTPToMobileAndEmail({mobile: mobileNo, mobileCountryCode : mobileCountryCode, email: vm.customerRegistrationRequest.userEmail}, onSendOtpSuccess, onSendOtpFailure);

                    // Execute reCAPTCHA
                    grecaptcha.ready(function () {
                        grecaptcha
                            .execute(
                                CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey,vm.globalValues.getPlatformENCCode()),
                                {
                                    action: "otp_action"
                                }
                            )
                            .then(function (token) {
                                // Call API with token
                                CustomerRegistration.sendOTPToMobileAndEmail(
                                    {
                                        mobile: mobileNo,
                                        mobileCountryCode: mobileCountryCode,
                                        email: vm.customerRegistrationRequest
                                            .userEmail,
                                        recaptchaToken: token,
                                        sourceType: "send-otp",
                                        source: "view-customer-registration"
                                    },
                                    onSendOtpSuccess,
                                    onSendOtpFailure
                                );
                            })
                            .catch(function (error) {
                                console.error("reCAPTCHA error:", error);
                                vm.disableGenerateOTP = false;
                            });
                    });
                }
            }
        );

        function onSendOtpSuccess() {
            if (!vm.openVerifyDialogue) {
                vm.openVerifyDialogue = true;
                if (
                    vm.customerRegistrationRequest.userMobileCountryCode ==
                        null ||
                    vm.customerRegistrationRequest.userMobileCountryCode ==
                        undefined
                ) {
                    vm.customerRegistrationRequest.userMobileCountryCode = "";
                }
                var mobileNo = vm.customerRegistrationRequest.userMobile;
                var mobileCountryCode =
                    vm.customerRegistrationRequest.userMobileCountryCode.toString();
                $state.go("otp-confirmation-withdraw-reg-request", {
                    mobile: mobileNo,
                    mobileCountryCode: mobileCountryCode,
                    requestId:
                        vm.customerRegistrationRequest.requestReferenceNumber,
                    email: vm.customerRegistrationRequest.userEmail,
                    theme: "light"
                });
            }
        }

        function onSendOtpFailure() {
            //do nothing
        }

        $rootScope.$on(
            "gatewayApp.messagebox.no.customeronboardingstatus",
            function (event, data) {
                //do nothing
                vm.clicked = false;
            }
        );

        $rootScope.$on(
            "gatewayApp.messagebox.no.registrationrequeststatus",
            function (event, data) {
                //do nothing
                vm.clicked = false;
            }
        );

        $rootScope.$on(
            "gatewayApp.messagebox.clear.customeronboardingstatus",
            function (event, data) {
                //do nothing
                vm.clicked = false;
            }
        );

        $rootScope.$on(
            "gatewayApp.messagebox.clear.registrationrequeststatus",
            function (event, data) {
                //do nothing
                vm.clicked = false;
            }
        );

        function onDiscardSuccess() {
            $uibModalInstance.dismiss("cancel");
        }

        function onDiscardError() {
            $uibModalInstance.dismiss("cancel");
        }
        function perpareDataToBeSaved() {
            fd = new FormData();
            if (vm.customerDetails.isSuspendableAction) {
                //doNothing
            } else if (vm.customerDetails.isApprovalRequired) {
                CustomerInfoUtil.checkForNameChangeWrokFlow(
                    customerPreviousData,
                    vm.customerDetails
                );
                if (!vm.customerDetails.isSuspendableAction) {
                    vm.customerDetails.isApprovalRequired = true;
                }
            }

            if (vm.image === undefined || vm.image == "") {
                vm.image = null;
            }
            fd.append("pan", vm.image);
            fd.append("customer", JSON.stringify(vm.customerDetails));
            fd.append("taskId", $rootScope.taskID);
        }

        function resubmitCustomerRegistration() {
            //vm.isupdated = false;
            setCustomerNameAsUserName();
            ScreenLog.screenLog(
                entityConstants.ENTITY_SHORT_NAME.CUSTOMER,
                vm.customerDetails.customer.id == null
                    ? 0
                    : vm.customerDetails.customer.id,
                entityConstants.ENTITY_ACTION_TYPE.RESUBMIT
            );
            vm.customerDetails.customer.dobOrDoi =
                DateUtils.convertLocalDateToServer(
                    vm.customerDetails.customer.dobOrDoi
                );
            if (
                vm.customerDetails.customer.leiExpiryDate != null &&
                vm.customerDetails.customer.leiExpiryDate != undefined &&
                vm.customerDetails.customer.leiExpiryDate != ""
            ) {
                vm.customerDetails.customer.leiExpiryDate =
                    DateUtils.convertLocalDateToServer(
                        vm.customerDetails.customer.leiExpiryDate
                    );
            }
            if (vm.enableFieldsForResubmit) {
                var previousFieldArray = [];
                previousFieldArray = angular.copy(
                    vm.customerDetails.fieldCheckArray
                );
                CustomerInfoUtil.isCustomerProfileFormValuesChanged(
                    customerPreviousData,
                    vm.customerDetails,
                    vm.image
                );
                angular.forEach(previousFieldArray, function (field) {
                    if (
                        vm.customerDetails.fieldCheckArray.indexOf(field) == -1
                    ) {
                        vm.customerDetails.fieldCheckArray.push(field);
                    }
                });
                perpareDataToBeSaved();
                if (vm.customerDetails.isSuspendableAction == true) {
                    vm.isupdated = false;
                    confirmFromUserForAction();
                } else {
                    CustomerApproval.resubmitUpdatedCustomerInfo(
                        fd,
                        onResubmitSuccess,
                        onResubmitError
                    );
                    $uibModalInstance.dismiss("cancel");
                }
            } else {
                CustomerApproval.resubmitCustomerInfo(
                    { taskId: $rootScope.taskID },
                    vm.customerDetails,
                    onResubmitSuccess,
                    onResubmitError
                );
                $uibModalInstance.dismiss("cancel");
            }
        }

        function confirmFromUserForAction() {
            MessageBox.openMessageBox(
                "Alert",
                $filter("translate")("gatewayApp.customerInfo.suspendAlert"),
                "YesNo",
                "customerprofileresubmit"
            );
            $rootScope.$on(
                "gatewayApp.messagebox.yes.customerprofileresubmit",
                function (event, data) {
                    if (fd != null && !vm.isupdated) {
                        vm.isupdated = true;
                        CustomerApproval.resubmitUpdatedCustomerInfo(
                            fd,
                            onResubmitSuccess,
                            onResubmitError
                        );
                        $uibModalInstance.dismiss("cancel");
                    }
                }
            );

            $rootScope.$on(
                "gatewayApp.messagebox.no.customerprofileresubmit",
                function (event, data) {
                    vm.isupdated = true;
                }
            );
        }

        function onResubmitSuccess(result) {
            fd = null;
            $rootScope.removeRow($rootScope.taskID);
        }
        function onResubmitError(error) {
            vm.clicked = false;
        }

        function discardCustomerUpdate() {
            vm.discardProcessed = false;
            //vm.customerDetails.customer.dobOrDoi = DateUtils.convertLocalDateToServer(vm.customerDetails.customer.dobOrDoi);
            ScreenLog.screenLog(
                entityConstants.ENTITY_SHORT_NAME.CUSTOMER,
                vm.customerDetails.customer.id == null
                    ? 0
                    : vm.customerDetails.customer.id,
                entityConstants.ENTITY_ACTION_TYPE.DISCARD
            );
            MessageBox.openMessageBox(
                "Alert",
                "Do you want to withdraw your customer info change?",
                "ProceedCancel",
                "withdrawcustomerchange_regview"
            );
        }
        $rootScope.$on(
            "gatewayApp.messagebox.proceed.withdrawcustomerchange_regview",
            function (event, data) {
                if (!vm.discardProcessed) {
                    vm.discardProcessed = true;
                    CustomerInfoChange.discard(
                        { taskId: $rootScope.taskID },
                        onDiscardSuccess,
                        onDiscardError
                    );
                }
            }
        );

        $rootScope.$on(
            "gatewayApp.messagebox.cancel.withdrawcustomerchange_regview",
            function (event, data) {
                vm.discardProcessed = true;
            }
        );

        var subscribeWithdrawOTPConfirm = $rootScope.$on(
            "withdrawOTPConfirm",
            function (event, result) {
                vm.requestId = $rootScope.requestId;
                CustomerRegistration.discard(
                    { requestId: vm.customerRegistrationRequest.id },
                    onWithdrawnSuccess,
                    onWithdrawnError
                );
            }
        );

        $scope.$on("$destroy", function () {
            subscribeWithdrawOTPConfirm();
        });

        function onWithdrawnSuccess() {
            MessageBox.openMessageBox(
                "Alert",
                "The request ref #" + vm.requestId + " has been withdrawn",
                "Ok",
                "withdrawnrequest"
            );
        }

        function onWithdrawnError() {}

        $rootScope.$on(
            "gatewayApp.messagebox.ok.withdrawnrequest",
            function (event, data) {
                $uibModalInstance.dismiss("cancel");
            }
        );

        function checkforModification(fieldName) {
            if (
                (mode == "customerInfoChangeStatus" ||
                    mode == "customerInfoUpdationIntimationView") &&
                vm.customerDetails != undefined &&
                vm.customerDetails != null
            ) {
                var fieldCheckArray = vm.customerDetails.fieldCheckArray;

                if (
                    fieldCheckArray != undefined &&
                    fieldCheckArray != null &&
                    fieldCheckArray.indexOf(fieldName) >= 0
                ) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
        $scope.$watch("vm.image", function (value) {
            if (value != undefined && value != null) {
                if (value.size > 200000) {
                    vm.invalidPanImageSize = true;
                    angular.element("input[type='file']").val(null);
                    vm.image = null;
                } else {
                    vm.inputPanImage = vm.image.name;
                    vm.invalidPanImageSize = false;
                }
            }
        });

        // resubmit action customer email and primary mobile change
        vm.openChangeEmailForCustomer = function openChangeEmail() {
            console.log(vm.globalValues.getOrganisation().id);
            $state.go("change-email-customer-info-resubmit", {
                userId: vm.globalValues.getUserId(),
                email: vm.customerDetails.customer.primaryEmail,
                mode: "customerinfo",
                customerId: vm.globalValues.getOrganisation().id
            });
        };

        vm.openChangeMobileForCustomer = function openChangeMobile() {
            $state.go("change-mobile-customer-info-resubmit", {
                userId: vm.globalValues.getUserId(),
                mobile: vm.customerDetails.customer.primaryMobile,
                countryCode:
                    vm.customerDetails.customer.primaryMobileCountryCode,
                mode: "customerinfo",
                customerId: vm.globalValues.getOrganisation().id
            });
        };
        $rootScope.$on("changeEmailRefresh", function (event, result) {
            if (vm.enableFieldsForResubmit)
                vm.customerDetails.customer.primaryEmail = $rootScope.email;
        });

        $rootScope.$on("changeMobileRefresh", function (event, result) {
            if (vm.enableFieldsForResubmit)
                vm.customerDetails.customer.primaryMobile = $rootScope.mobile;
        });

        vm.print = print;
        /*function print(){
			 var printContents = document.getElementById("printPage").innerHTML;
			 var popupWin = window.open('', '_blank', 'fullscreen=yes');
       	  	popupWin.document.open();
       	  	var value = '<html><head><link rel="stylesheet" type="text/css" href="style.css" /><style type="text/css" media="print"> @page { size: landscape;}</style></head><body onload="window.print()"  >' + printContents + '</body></html>';
       	  	console.log(value);
       	  	popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /><style type="text/css" media="print"> @page { size: landscape;}</style></head><body onload="window.print()"  >' + printContents + '</body></html>');
       	  	popupWin.document.close();
		}*/
        function print() {
            var customerRegDetails = angular.copy(
                vm.customerRegistrationRequest
            );
            customerRegDetails.dob = DateUtils.convertLocalDateToServer(
                customerRegDetails.dob
            );
            customerRegDetails.dobOrDoi = DateUtils.convertLocalDateToServer(
                customerRegDetails.dobOrDoi
            );
            if (
                vm.inputDetailsForSelectedCustType != null &&
                vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex] !=
                    null &&
                vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex]
                    .display &&
                customerRegDetails.leiExpiryDate != null &&
                customerRegDetails.leiExpiryDate != undefined &&
                customerRegDetails.leiExpiryDate != ""
            ) {
                customerRegDetails.leiExpiryDate =
                    DateUtils.convertLocalDateToServer(
                        customerRegDetails.leiExpiryDate
                    );
            }

            if (
                vm.inputDetailsForSelectedCustType != null &&
                vm.inputDetailsForSelectedCustType[$scope.entityNameIndex] !=
                    null &&
                vm.inputDetailsForSelectedCustType[$scope.entityNameIndex]
                    .display &&
                customerRegDetails.companyName != null &&
                customerRegDetails.companyName != ""
            ) {
                customerRegDetails.customerFirstName =
                    customerRegDetails.companyName;
                customerRegDetails.customerLastName =
                    customerRegDetails.companyName;
            }

            CustomerRegistration.getCustomerRegistrationPrintForBankApproval(
                customerRegDetails,
                function (result) {
                    var file = new Blob([result.data], {
                        type: "application/pdf"
                    });
                    var fileURL = URL.createObjectURL(file);
                    //window.open(fileURL, "_blank", "fullscreen=yes");
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(
                            file,
                            "CustomerRegistrationPreview.pdf"
                        );
                    } else {
                        window.open(fileURL, "CustomerRegistrationPreview.pdf");
                    }
                }
            );
        }

        function UpdateBankAndDefaultUserDetails() {
            var bankAndDefaultUserDetailsObj = angular.copy(
                vm.bankAndDefaultUserDetails
            );
            vm.customerRegistrationRequest.bank =
                bankAndDefaultUserDetailsObj.bank;
            vm.customerRegistrationRequest.homeBranch =
                bankAndDefaultUserDetailsObj.homeBranch;
            vm.customerRegistrationRequest.tradingBranch =
                bankAndDefaultUserDetailsObj.tradingBranch;
            vm.customerRegistrationRequest.bankAccountNumber =
                bankAndDefaultUserDetailsObj.bankAccountNumber;
            vm.customerRegistrationRequest.branchAddress =
                bankAndDefaultUserDetailsObj.branchAddress;
            vm.customerRegistrationRequest.userFirstName =
                bankAndDefaultUserDetailsObj.userFirstName;
            vm.customerRegistrationRequest.userMiddleName =
                bankAndDefaultUserDetailsObj.userMiddleName;
            vm.customerRegistrationRequest.userLastName =
                bankAndDefaultUserDetailsObj.userLastName;
            vm.customerRegistrationRequest.aadharNumber =
                bankAndDefaultUserDetailsObj.aadharNumber;
            vm.customerRegistrationRequest.gender =
                bankAndDefaultUserDetailsObj.gender;
            vm.customerRegistrationRequest.dob = new Date(
                bankAndDefaultUserDetailsObj.dob
            );
            vm.customerRegistrationRequest.userAddress1 =
                bankAndDefaultUserDetailsObj.userAddress1;
            vm.customerRegistrationRequest.userAddress2 =
                bankAndDefaultUserDetailsObj.userAddress2;
            vm.customerRegistrationRequest.userCity =
                bankAndDefaultUserDetailsObj.userCity;
            vm.customerRegistrationRequest.userState =
                bankAndDefaultUserDetailsObj.userState;
            vm.customerRegistrationRequest.userCountry =
                bankAndDefaultUserDetailsObj.userCountry;
            vm.customerRegistrationRequest.userPincode =
                bankAndDefaultUserDetailsObj.userPincode;
            vm.customerRegistrationRequest.login =
                bankAndDefaultUserDetailsObj.login;
            vm.customerRegistrationRequest.userEmail =
                bankAndDefaultUserDetailsObj.userEmail;
            vm.customerRegistrationRequest.userMobileCountryCode =
                bankAndDefaultUserDetailsObj.userMobileCountryCode;
            vm.customerRegistrationRequest.userMobile =
                bankAndDefaultUserDetailsObj.userMobile;
            vm.customerRegistrationRequest.active =
                bankAndDefaultUserDetailsObj.active;
            vm.customerRegistrationRequest.panImage =
                bankAndDefaultUserDetailsObj.panImage;
        }
        $scope.$watch(
            "vm.customerRegistrationRequest.tradingBranch",
            function (value) {
                if (value != null && value != undefined && vm.isEdit == true) {
                    if (
                        vm.oldTradingBranch != undefined &&
                        vm.oldTradingBranch != null &&
                        vm.customerRegistrationRequest.tradingBranch != null &&
                        vm.customerRegistrationRequest.tradingBranch !=
                            undefined &&
                        vm.oldTradingBranch.id ==
                            vm.customerRegistrationRequest.tradingBranch.id
                    ) {
                        vm.noChange = true;
                    } else {
                        vm.noChange = false;
                    }
                }
            }
        );
        $scope.$watch(
            "vm.customerRegistrationRequest.homeBranch",
            function (value) {
                if (value != null && value != undefined && vm.isEdit == true) {
                    if (
                        vm.oldHomeBranchDetails != null &&
                        vm.oldHomeBranchDetails != undefined &&
                        vm.customerRegistrationRequest.homeBranch != null &&
                        vm.customerRegistrationRequest.homeBranch !=
                            undefined &&
                        vm.oldHomeBranchDetails.id ==
                            vm.customerRegistrationRequest.homeBranch.id
                    ) {
                        vm.noHomeBranchChange = true;
                    } else {
                        vm.noHomeBranchChange = false;
                    }
                }
            }
        );
        $scope.$watch(
            "vm.customerRegistrationRequest.bankAccountNumber",
            function (value) {
                if (value != null && value != undefined && vm.isEdit == true) {
                    if (
                        vm.oldBankAccountNumber != null &&
                        vm.oldBankAccountNumber != undefined &&
                        vm.oldBankAccountNumber ==
                            vm.customerRegistrationRequest.bankAccountNumber
                    ) {
                        vm.noAccountChange = true;
                    } else {
                        vm.noAccountChange = false;
                    }
                }
            }
        );

        function saveModificationOnCustomerDetails() {
            if (vm.noChange && vm.noHomeBranchChange && vm.noAccountChange) {
                //show error when trading branch selected is same as the current branch
                AlertService.error("No changes are made");
                vm.clicked = false;
            } else {
                ModifyCustomerDetailsService.editTradingBranch(
                    {
                        orgId: vm.globalValues.getOrganisation().id,
                        oldBranchId: vm.oldTradingBranch.id
                    },
                    vm.customerRegistrationRequest,
                    editTradingBranchSuccess,
                    editTradingBranchFailed
                );
            }
        }
        function editTradingBranchSuccess(result) {
            $uibModalInstance.close(result);
        }
        function editTradingBranchFailed() {
            vm.clicked = false;
        }
        function discardModifyCustomerDetails() {
            ModifyCustomerDetailsService.discard(
                { taskId: $rootScope.taskID },
                onDiscardSuccess,
                onDiscardError
            );
        }
        function rejectCustomerModification() {
            Workflow.rejectTask($rootScope.taskID);
        }
        function approveModifyCustomerDetails() {
            vm.screenLog.screenLog(
                "ModifyCustomerDetails",
                0,
                entityConstants.ENTITY_ACTION_TYPE.APPROVE
            );
            ModifyCustomerDetailsService.approve(
                { taskId: $rootScope.taskID },
                onApproveSuccess,
                onApproveError
            );
            $uibModalInstance.dismiss("cancel");
        }
        function resubmitModifyCustomerDetails() {
            if (vm.noChange && vm.noHomeBranchChange && vm.noAccountChange) {
                //show error when trading branch selected is same as the current branch
                AlertService.error("No changes are made");
                vm.clicked = false;
            } else {
                ModifyCustomerDetailsService.resubmit(
                    {
                        taskId: $rootScope.taskID,
                        oldBranchId: vm.oldTradingBranch.id
                    },
                    vm.customerRegistrationRequest,
                    onResubmitSuccess,
                    onResubmitError
                );
                $uibModalInstance.dismiss("cancel");
            }
        }

        $scope.$watch(
            "vm.customerRegistrationRequest.assignTradingBranch",
            function (value) {
                if (value != null && value != undefined) {
                    if (value) {
                        if (
                            vm.customerRegistrationRequest.tradingBranch !=
                                null &&
                            vm.mode != "customeronboarding"
                        ) {
                            vm.customerRegistrationRequest.tradingBranch = null;
                        }
                        vm.disableTradingBranch = true;
                    } else {
                        vm.disableTradingBranch = false;
                    }
                }
            }
        );

        function viewAcceptedTermsAndConditions() {
            TACViewForEntitiesService.getAnnexure2(
                vm.customerRegistrationRequest,
                onGetAnnexure2Success,
                onGetAnnexure2Failure
            );
        }

        function onGetAnnexure2Success(result) {
            TacViewForEntitiesUtility.downloadTACForArray(
                result.data,
                tacAnnexurefilename +
                    moment().format("DD_MMM_YYYY_HH_mm") +
                    ".pdf"
            );
            // var file = new Blob([result.data], {type: 'application/pdf'});
            // var fileURL = URL.createObjectURL(file);
            // //window.open(fileURL, "_blank", "fullscreen=yes");
            // if(window.navigator.msSaveOrOpenBlob) {
            //     window.navigator.msSaveOrOpenBlob(file, "Annexure2.pdf");
            // }
            // else{
            //     //window.open(fileURL, "Annexure2.pdf");
            //     var link = document.createElement("a");
            //     link.href =  fileURL;
            //     link.download ="Annexure2.pdf";
            //     document.body.appendChild(link);
            //     link.click();
            //     document.body.removeChild(link);
            // }
        }

        function onGetAnnexure2Failure() {
            //do nothing
        }

        function downloadAnnexure1() {
            TACViewForEntitiesService.getAnnexure1(
                vm.customerRegistrationRequest,
                onGetAnnexure1Success,
                onGetAnnexure1Failure
            );
        }

        function onGetAnnexure1Success(result) {
            TacViewForEntitiesUtility.downloadTACForArray(
                result.data,
                tacAnnexurefilename +
                    moment().format("DD_MMM_YYYY_HH_mm") +
                    ".pdf"
            );
            vm.clicked = false;
            // var file = new Blob([result.data], {type: 'application/pdf'});
            // var fileURL = URL.createObjectURL(file);
            // //window.open(fileURL, "_blank", "fullscreen=yes");
            // if(window.navigator.msSaveOrOpenBlob) {
            //     window.navigator.msSaveOrOpenBlob(file, "Annexure1.pdf");
            // }
            // else{
            //     //window.open(fileURL, "Annexure2.pdf");
            //     var link = document.createElement("a");
            //     link.href =  fileURL;
            //     link.download ="Annexure1.pdf";
            //     document.body.appendChild(link);
            //     link.click();
            //     document.body.removeChild(link);
            // }
        }

        function onGetAnnexure1Failure() {
            vm.clicked = false;
            //do nothing
        }

        $scope.$watch(
            "vm.customerRegistrationRequest.customerType",
            function (value) {
                if (value != null && value != undefined) {
                    vm.inputDetailsForSelectedCustType = _.filter(
                        vm.customerTypeWiseInputDetails,
                        function (item) {
                            return item.customerType.id == value.id;
                        }
                    );
                    if (
                        value.customerUserType.shortName == "SingleUserCustomer"
                    ) {
                        vm.showSingleUser = true;
                        vm.showMultiUser = false;
                    } else if (
                        value.customerUserType.shortName == "MultiUserCustomer"
                    ) {
                        vm.showMultiUser = true;
                        vm.showSingleUser = false;
                    }
                    if (
                        workflowSharedService.viewFrom ==
                            "customerregistrationtodolist_auditlog" ||
                        workflowSharedService.viewFrom ==
                            "customerregistrationtodolist_historyReport" ||
                        workflowSharedService.viewFrom ==
                            "modifycustomerdetails_auditlog"
                    ) {
                        if (
                            vm.customerRegistrationRequest.customerType.id ==
                                $scope.customerTypeSolePropId &&
                            vm.customerRegistrationRequest.customerLastName !=
                                null &&
                            vm.customerRegistrationRequest.customerLastName !=
                                ""
                        ) {
                            vm.inputDetailsForSelectedCustType[
                                $scope.entityNameIndex
                            ].display = false;
                            vm.inputDetailsForSelectedCustType[
                                $scope.entityNameIndex
                            ].isMandatory = false;
                            vm.inputDetailsForSelectedCustType[
                                $scope.firstNameIndex
                            ].display = true;
                            vm.inputDetailsForSelectedCustType[
                                $scope.firstNameIndex
                            ].isMandatory = true;
                            vm.inputDetailsForSelectedCustType[
                                $scope.lastNameIndex
                            ].display = true;
                            vm.inputDetailsForSelectedCustType[
                                $scope.lastNameIndex
                            ].isMandatory = true;
                            vm.inputDetailsForSelectedCustType[
                                $scope.middleNameIndex
                            ].display = true;
                        }
                    }
                } else {
                    vm.showSingleUser = true;
                    vm.showMultiUser = false;
                    vm.inputDetailsForSelectedCustType = [
                        {
                            customerType: null,
                            fieldName: "FirstName",
                            display: true,
                            isMandatory: true
                        },
                        {
                            customerType: null,
                            fieldName: "MiddleName",
                            display: true,
                            isMandatory: false
                        },
                        {
                            customerType: null,
                            fieldName: "LastName",
                            display: true,
                            isMandatory: true
                        },
                        {
                            customerType: null,
                            fieldName: "EntityName",
                            display: false,
                            isMandatory: false
                        },
                        {
                            customerType: null,
                            fieldName: "PANNo",
                            display: true,
                            isMandatory: true
                        },
                        {
                            customerType: null,
                            fieldName: "PANImage",
                            display: true,
                            isMandatory: true
                        },
                        {
                            customerType: null,
                            fieldName: "LegalEntityIdentifier",
                            display: true,
                            isMandatory: false
                        },
                        {
                            customerType: null,
                            fieldName: "LEIExpiryDate",
                            display: true,
                            isMandatory: false
                        },
                        {
                            customerType: null,
                            fieldName: "CIN",
                            display: false,
                            isMandatory: false
                        },
                        {
                            customerType: null,
                            fieldName: "GSTIN",
                            display: true,
                            isMandatory: false
                        },
                        {
                            customerType: null,
                            fieldName: "StateCode",
                            display: true,
                            isMandatory: false
                        },
                        {
                            customerType: null,
                            fieldName: "DOBDOI",
                            display: true,
                            isMandatory: true
                        }
                    ];
                }
            }
        );

        $scope.$watchGroup(
            [
                "vm.customerRegistrationRequest.customerFirstName",
                "vm.enableFieldsForResubmit"
            ],
            function (value) {
                if (vm.enableFieldsForResubmit) {
                    var newVal =
                        vm.customerRegistrationRequest.customerFirstName;
                    if (newVal != null && newVal != undefined) {
                        newVal = newVal.replace(/(\r\n|\n|\r)/gm, " ");
                        vm.customerRegistrationRequest.customerFirstName =
                            newVal.replace(/(,)/gm, "");
                    }
                }
            }
        );

        vm.checkforTradingBranchModification =
            function checkforTradingBranchModification() {
                if (
                    vm.mode == "customerApprovalToDo" &&
                    vm.userEntityOwnerType == "Bank"
                ) {
                    return true;
                } else if (
                    vm.mode == "modifycustomerdetails_todo" &&
                    vm.userEntityOwnerType == "Bank"
                ) {
                    //if old and new home branch id is different then show as modified
                    if (
                        vm.oldTradingBranch != null &&
                        vm.oldTradingBranch != undefined &&
                        vm.customerRegistrationRequest.tradingBranch !=
                            undefined &&
                        vm.customerRegistrationRequest.tradingBranch != null &&
                        vm.customerRegistrationRequest.tradingBranch.id !=
                            vm.oldTradingBranch.id
                    )
                        return true;
                }
                return false;
            };
        vm.checkforHomeBranchModification =
            function checkforHomeBranchModification() {
                if (
                    vm.mode == "modifycustomerdetails_todo" &&
                    vm.userEntityOwnerType == "Bank"
                ) {
                    //if old and new home branch id is different then show as modified
                    if (
                        vm.oldHomeBranchDetails != null &&
                        vm.oldHomeBranchDetails != undefined &&
                        vm.customerRegistrationRequest.homeBranch != null &&
                        vm.customerRegistrationRequest.homeBranch !=
                            undefined &&
                        vm.customerRegistrationRequest.homeBranch.id !=
                            vm.oldHomeBranchDetails.id
                    )
                        return true;
                }
                return false;
            };
        vm.checkforAccountModification =
            function checkforAccountModification() {
                if (
                    vm.mode == "modifycustomerdetails_todo" &&
                    vm.userEntityOwnerType == "Bank"
                ) {
                    //if old and new home branch id is different then show as modified
                    if (
                        vm.oldBankAccountNumber != null &&
                        vm.oldBankAccountNumber != undefined &&
                        vm.customerRegistrationRequest.bankAccountNumber !=
                            null &&
                        vm.customerRegistrationRequest.bankAccountNumber !=
                            undefined &&
                        vm.customerRegistrationRequest.bankAccountNumber !=
                            vm.oldBankAccountNumber
                    )
                        return true;
                }
                return false;
            };
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CustomerRegistrationPreviewController', CustomerRegistrationPreviewController);

    CustomerRegistrationPreviewController.$inject = ['$scope', '$rootScope', '$state','$timeout', 'Auth', '$window', 'StaticLookUp', 'MessageBox', 'CustomerRegistration', '$sessionStorage', 'DateUtils', 'Country', 'GlobalValues', 'AlertService', '$filter','$stateParams','$uibModalInstance','customerTypeWiseInputDetails'];

    function CustomerRegistrationPreviewController ($scope, $rootScope, $state, $timeout, Auth, $window, StaticLookUp, MessageBox, CustomerRegistration, $sessionStorage, DateUtils, Country, GlobalValues, AlertService,$filter, $stateParams, $uibModalInstance, customerTypeWiseInputDetails) {
        var vm = this;
       
        vm.globalValues = GlobalValues;
        vm.theme = $stateParams.theme;
        vm.customerRegistrationRequest = $stateParams.customerRegistrationRequest;
        vm.panImageFile  = $stateParams.image;
        vm.viewPanImage = viewPanImage;
        vm.submit = submit;
        vm.clear = clear;
        vm.clicked = false;
        vm.dob =  $filter('date')(vm.customerRegistrationRequest.dob, "dd-MMM-yyyy");
        
         vm.dobOrDoi =  $filter('date')(vm.customerRegistrationRequest.dobOrDoi, "dd-MMM-yyyy");
         
         if( vm.customerRegistrationRequest.leiExpiryDate !=null && vm.customerRegistrationRequest.leiExpiryDate!=undefined 
       			 && vm.customerRegistrationRequest.leiExpiryDate!= ''){
        	 vm.leiExpiryDate =  $filter('date')(vm.customerRegistrationRequest.leiExpiryDate, "dd-MMM-yyyy");
         }
         
          
        //intialize customer type wise input details
        vm.customerTypeWiseInputDetails = customerTypeWiseInputDetails;
        
        //Indices of input details in customer type wise input details array
        $scope.firstNameIndex = 0;
        $scope.middleNameIndex = 1;
        $scope.lastNameIndex = 2;
        $scope.entityNameIndex = 3;
        $scope.panNoIndex = 4;
        $scope.panImageIndex = 5;
        $scope.legalEntityIdentifierIndex = 6;
        $scope.leiExpiryDateIndex = 7;
        $scope.cinIndex = 8;
        $scope.gstinIndex = 9;
        $scope.stateCodeIndex = 10;
        $scope.dobDoiIndex = 11;
        vm.showSingleUser=false;
		vm.showMultiUser=false;
		$scope.customerTypeSolePropId=27;
		vm.clicked=false;

        $scope.$watch('vm.customerRegistrationRequest.customerType', function(value){
            if(value!=null && value!=undefined){
                vm.inputDetailsForSelectedCustType = _.filter(vm.customerTypeWiseInputDetails, function(item) {
                    return item.customerType.id == value.id;
                });
                if(value.customerUserType.shortName=='SingleUserCustomer'){
					vm.showSingleUser=true;
					vm.showMultiUser=false;
						}else if(value.customerUserType.shortName=='MultiUserCustomer'){
							vm.showMultiUser=true;
							vm.showSingleUser=false;
					
						}
            }else{
                vm.showSingleUser=true;
				vm.showMultiUser=false;
                vm.inputDetailsForSelectedCustType = [
                    {customerType: null, fieldName: 'FirstName', display: true, isMandatory: true},
                    {customerType: null, fieldName: 'MiddleName', display: true, isMandatory: false},
                    {customerType: null, fieldName: 'LastName', display: true, isMandatory: true},
                    {customerType: null, fieldName: 'EntityName', display: false, isMandatory: false},
                    {customerType: null, fieldName: 'PANNo', display: true, isMandatory: true},
                    {customerType: null, fieldName: 'PANImage', display: true, isMandatory: true},
                    {customerType: null, fieldName: 'LegalEntityIdentifier', display: true, isMandatory: false},
                    {customerType: null, fieldName: 'LEIExpiryDate', display: true, isMandatory: false},
                    {customerType: null, fieldName: 'CIN', display: false, isMandatory: false},
                    {customerType: null, fieldName: 'GSTIN', display: true, isMandatory: false},
                    {customerType: null, fieldName: 'StateCode', display: true, isMandatory: false},
                    {customerType: null, fieldName: 'DOBDOI', display: true, isMandatory: true}
                ]
            }
        });

        function submit(){
        	if(moment(vm.customerRegistrationRequest.dob).isAfter(vm.todayDate,'day')){
        		
       		 AlertService.error($filter('translate')('gatewayApp.customerRegistration.futuredateOfBirth'));
       		 
       	 }else if( vm.inputDetailsForSelectedCustType!=null 
                            && vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex]!= null 
                            && vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex].display && vm.customerRegistrationRequest.leiExpiryDate !=null && vm.customerRegistrationRequest.leiExpiryDate!=undefined 
       			 && vm.customerRegistrationRequest.leiExpiryDate!= '' && moment(vm.customerRegistrationRequest.leiExpiryDate).isBefore(vm.todayDate,'day')){
        		
       		 AlertService.error($filter('translate')('gatewayApp.customerRegistration.expiryDate'));
       		 
       	 }      	
        	else{
       		var fd = new FormData();
			vm.customerRegistrationRequest.dob = DateUtils.convertLocalDateToServer(vm.customerRegistrationRequest.dob);
			vm.customerRegistrationRequest.dobOrDoi = DateUtils.convertLocalDateToServer(vm.customerRegistrationRequest.dobOrDoi);
			if( vm.customerRegistrationRequest.leiExpiryDate !=null && vm.customerRegistrationRequest.leiExpiryDate!=undefined 
	       			 && vm.customerRegistrationRequest.leiExpiryDate!= ''){
				vm.customerRegistrationRequest.leiExpiryDate = DateUtils.convertLocalDateToServer(vm.customerRegistrationRequest.leiExpiryDate);
			}
			
			if(vm.inputDetailsForSelectedCustType!=null 
                            && vm.inputDetailsForSelectedCustType[$scope.entityNameIndex]!= null 
                            && vm.inputDetailsForSelectedCustType[$scope.entityNameIndex].display){
							vm.customerRegistrationRequest.customerFirstName=vm.customerRegistrationRequest.companyName;
							vm.customerRegistrationRequest.customerLastName=vm.customerRegistrationRequest.companyName;
								
				
			}
			if(vm.customerRegistrationRequest.customerType.customerUserType.shortName=='SingleUserCustomer'){
				if(vm.customerRegistrationRequest.customerType.id != $scope.customerTypeSolePropId){
					vm.customerRegistrationRequest.customerFirstName=vm.customerRegistrationRequest.userFirstName;
					vm.customerRegistrationRequest.customerMiddleName=vm.customerRegistrationRequest.userMiddleName;
					vm.customerRegistrationRequest.customerLastName=vm.customerRegistrationRequest.userLastName;
				}
				

			}
			vm.panFile = $rootScope.panFile;
			fd.append('customer', JSON.stringify(vm.customerRegistrationRequest));
			if($rootScope.panFile.name!=null && $rootScope.panFile.name!=undefined){
	            fd.append('pan', vm.panFile);
	            CustomerRegistration.submit(fd, onSubmitSuccess, onSubmitFailure);
			}else{
	            CustomerRegistration.reSubmit(fd, onSubmitSuccess, onSubmitFailure);
			}
        	
       	 }
        	
        }
        
        function onSubmitSuccess(result){
        	//$uibModalInstance.dismiss('cancel');
        	//$state.go('registrationRequestStatus', {requestId: result.id});
        	$uibModalInstance.close(result);
			vm.clicked = false;
        	 
        }
        
        function onSubmitFailure(){
        	vm.clicked = false;
        	vm.customerRegistrationRequest.dob  = DateUtils.convertLocalDateFromServer(vm.customerRegistrationRequest.dob);
        	vm.customerRegistrationRequest.dobOrDoi  = DateUtils.convertLocalDateFromServer(vm.customerRegistrationRequest.dobOrDoi);
        	
        	if(vm.inputDetailsForSelectedCustType!=null 
                            && vm.inputDetailsForSelectedCustType[$scope.entityNameIndex]!= null 
                            && vm.inputDetailsForSelectedCustType[$scope.entityNameIndex].display){
				vm.customerRegistrationRequest.customerFirstName=vm.customerRegistrationRequest.companyName;
				vm.customerRegistrationRequest.customerLastName=vm.customerRegistrationRequest.companyName;
				vm.required = false;
			}
            if(vm.inputDetailsForSelectedCustType!=null 
                            && vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex]!= null 
                            && vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex].display){
                if( vm.customerRegistrationRequest.leiExpiryDate !=null && vm.customerRegistrationRequest.leiExpiryDate!=undefined 
                         && vm.customerRegistrationRequest.leiExpiryDate!= ''){
                    vm.customerRegistrationRequest.leiExpiryDate = DateUtils.convertLocalDateFromServer(vm.customerRegistrationRequest.leiExpiryDate);
                }
            }
        }
        
        function base64ToArrayBuffer(base64) {
    	    var binary_string =  window.atob(base64);
    	    var len = binary_string.length;
    	    var bytes = new Uint8Array( len );
    	    for (var i = 0; i < len; i++)        {
    	        bytes[i] = binary_string.charCodeAt(i);
    	    }
    	    return bytes.buffer;
    	}

        function viewPanImage(){
        	if(vm.customerRegistrationRequest.fileExtension=='pdf'){
        		var contentByteArray = base64ToArrayBuffer(vm.panImageFile);
	    		  
	    		var file = new Blob([contentByteArray], { type: 'application/pdf' });
	            var fileURL = URL.createObjectURL(file);
	              
	            if(window.navigator.msSaveOrOpenBlob) {
	                  window.navigator.msSaveOrOpenBlob(file, "PAN.pdf");
	            }
	            else {
	                   window.open(fileURL, "PAN.pdf");    
	            }
    			//var pdfWindow = window.open("");
        		//pdfWindow.document.write("<iframe width='100%' height='100%'title='PAN'  src='data:application/pdf;base64, " + encodeURI(vm.panImageFile)+"' ></iframe>")
        	}
       
        	else{
        		console.log(vm.customerRegistrationRequest.panImage);
        		$state.go('view-panImage-customer-registration-preview', {image:vm.panImageFile ,theme:vm.theme});	
        	
        }
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
      
        vm.print = print;
        
		function print(){
			var customerRegDetails = angular.copy(vm.customerRegistrationRequest);
			customerRegDetails.dob = DateUtils.convertLocalDateToServer(customerRegDetails.dob);
			//customerRegDetails.dobOrDoi = DateUtils.convertLocalDateToServer(customerRegDetails.dobOrDoi);
			if( customerRegDetails.leiExpiryDate !=null && customerRegDetails.leiExpiryDate!=undefined 
	       			 && customerRegDetails.leiExpiryDate!= ''){
				customerRegDetails.leiExpiryDate = DateUtils.convertLocalDateToServer(customerRegDetails.leiExpiryDate);
			}
			
			if(vm.inputDetailsForSelectedCustType!=null 
                            && vm.inputDetailsForSelectedCustType[$scope.entityNameIndex]!= null 
                            && vm.inputDetailsForSelectedCustType[$scope.entityNameIndex].display){
				customerRegDetails.customerFirstName=customerRegDetails.companyName;
				customerRegDetails.customerLastName=customerRegDetails.companyName;
			}
       	  	
       	 	CustomerRegistration.getCustomerRegistrationPrintForNewCustomer(customerRegDetails,function(result){
	        	var file = new Blob([result.data], {type: 'application/pdf'});
	      		var fileURL =URL.createObjectURL(file);
	              vm.clicked=false;
	              if(window.navigator.msSaveOrOpenBlob) {
	                    window.navigator.msSaveOrOpenBlob(file, "CustomerRegistrationPreview.pdf");
	                }
	                else {
	                     window.open(fileURL, "CustomerRegistrationPreview.pdf");    
	                }

       	 	});
		}
    }
})();

(function () {
    "use strict";

    angular
        .module("gatewayApp")
        .controller(
            "CustomerRegistrationControllerNew",
            CustomerRegistrationControllerNew
        );

    CustomerRegistrationControllerNew.$inject = [
        "$scope",
        "$rootScope",
        "$state",
        "$timeout",
        "Auth",
        "$window",
        "StaticLookUp",
        "MessageBox",
        "CustomerRegistration",
        "$sessionStorage",
        "DateUtils",
        "Country",
        "GlobalValues",
        "globalValue",
        "AlertService",
        "$filter",
        "FileUtil",
        "Branch",
        "customerTypeWiseInputDetails",
        "TACViewForEntitiesService",
        "TacViewForEntitiesUtility",
        "CryptoUtil"
    ];

    function CustomerRegistrationControllerNew(
        $scope,
        $rootScope,
        $state,
        $timeout,
        Auth,
        $window,
        StaticLookUp,
        MessageBox,
        CustomerRegistration,
        $sessionStorage,
        DateUtils,
        Country,
        GlobalValues,
        globalValue,
        AlertService,
        $filter,
        FileUtil,
        Branch,
        customerTypeWiseInputDetails,
        TACViewForEntitiesService,
        TacViewForEntitiesUtility,
        CryptoUtil
    ) {
        var vm = this;
        vm.customerTypes = StaticLookUp.getCustomerTypes();
        vm.sourceOfIntro = StaticLookUp.getsourceOfIntro();
        vm.theme = "light";
        //initialize customer type wise input details
        vm.customerTypeWiseInputDetails = customerTypeWiseInputDetails;

        //Indices of input details in customer type wise input details array
        $scope.firstNameIndex = 0;
        $scope.middleNameIndex = 1;
        $scope.lastNameIndex = 2;
        $scope.entityNameIndex = 3;
        $scope.panNoIndex = 4;
        $scope.panImageIndex = 5;
        $scope.legalEntityIdentifierIndex = 6;
        $scope.leiExpiryDateIndex = 7;
        $scope.cinIndex = 8;
        $scope.gstinIndex = 9;
        $scope.stateCodeIndex = 10;
        $scope.dobDoiIndex = 11;
        vm.showSingleUser = false;
        vm.showMultiUser = false;
        vm.validPan = false;
        vm.touchedsourceOfIntro = true;

        vm.globalValues = GlobalValues;
        vm.configSettings = globalValue;
        $sessionStorage.isAuth = true;
        vm.checkPanImage = false;
        vm.customerRegistrationRequest = {};
        vm.customerRegistrationRequest.userMobileCountryCode = 91;
        vm.required = false;
        vm.otpLength = globalValue.defaultOTPLength;
        var Extensions = ["pdf", "png", "jpg"];
        vm.todayDate = new Date();
        vm.leiExpiryRequired = false;
        vm.disableLeiExpiry = true;
        vm.leiMinDate = vm.todayDate;
        vm.leiMinDate.setDate(new Date().getDate() + 1);
        //vm.leiMinDate =  vm.leiMinDate ;
        vm.skipOTPUserContact = true;
        vm.skipOTPUserEmailContact = true;
        vm.showSkipOTP = true;
        if (
            globalValue.skipOTPVerification == "No" ||
            globalValue.skipOTPVerification == "no" ||
            globalValue.skipOTPVerification == "NO"
        ) {
            vm.skipOTPUserContact = false;
            vm.skipOTPUserEmailContact = false;
            vm.showSkipOTP = false;
            vm.customerRegistrationRequest.isSkipOTPUserMobile = false;
            vm.customerRegistrationRequest.isSkipOTPUserEmailContact = false;
        } else {
            vm.skipOTPUserContact = true;
            vm.skipOTPUserEmailContact = true;
            vm.showSkipOTP = true;
            vm.customerRegistrationRequest.isSkipOTPUserMobile = true;
            vm.customerRegistrationRequest.isSkipOTPUserEmailContact = true;
        }
        //get rejected request by reference number
        vm.refNo = "";
        vm.clearcorpOrgId = 1;
        vm.clearcorpForCustomerTACTypeId = 1;
        vm.bankForCustomerTACTypeId = 3;
        vm.fetchRejectedRequest = fetchRejectedRequest;
        vm.openHelpWindow = openHelpWindow;
        vm.previewClearcorpTAC = previewClearcorpTAC;
        vm.previewBankTAC = previewBankTAC;
        vm.maximumFileSize = "200 kb";
        vm.customerRegistrationRequest.assignTradingBranch = true;
        vm.disableTradingBranch = true;
        vm.customerRegistrationRequest.otpVerifiedEmailId = "";
        vm.customerRegistrationRequest.otpVerifiedMobileId = "";
        vm.customerRegistrationRequest.isSkipOTPUserMobile = true;
        vm.customerRegistrationRequest.isSkipOTPUserEmailContact = true;

        setEnvironmentName();

        $window.onresize = function () {
            changeTemplate();
        };
        changeTemplate();

        function changeTemplate() {
            var screenWidth = $window.innerWidth;
            if (screenWidth < 768) {
                vm.mobileView = true;
            } else if (screenWidth >= 768) {
                vm.mobileView = false;
            }
        }

        $scope.$watch(
            "vm.customerRegistrationRequest.customerType",
            function (value) {
                if (value != null && value != undefined) {
                    vm.inputDetailsForSelectedCustType = _.filter(
                        vm.customerTypeWiseInputDetails,
                        function (item) {
                            return item.customerType.id == value.id;
                        }
                    );
                    if (
                        value.customerUserType.shortName == "SingleUserCustomer"
                    ) {
                        vm.showSingleUser = true;
                        vm.showMultiUser = false;
                    } else if (
                        value.customerUserType.shortName == "MultiUserCustomer"
                    ) {
                        vm.showMultiUser = true;
                        vm.showSingleUser = false;
                    }
                } else {
                    vm.showSingleUser = true;
                    vm.showMultiUser = false;
                    vm.inputDetailsForSelectedCustType = [
                        {
                            customerType: null,
                            fieldName: "FirstName",
                            display: true,
                            isMandatory: true
                        },
                        {
                            customerType: null,
                            fieldName: "MiddleName",
                            display: true,
                            isMandatory: false
                        },
                        {
                            customerType: null,
                            fieldName: "LastName",
                            display: true,
                            isMandatory: true
                        },
                        {
                            customerType: null,
                            fieldName: "EntityName",
                            display: false,
                            isMandatory: false
                        },
                        {
                            customerType: null,
                            fieldName: "PANNo",
                            display: true,
                            isMandatory: true
                        },
                        {
                            customerType: null,
                            fieldName: "PANImage",
                            display: true,
                            isMandatory: true
                        },
                        {
                            customerType: null,
                            fieldName: "LegalEntityIdentifier",
                            display: true,
                            isMandatory: false
                        },
                        {
                            customerType: null,
                            fieldName: "LEIExpiryDate",
                            display: true,
                            isMandatory: false
                        },
                        {
                            customerType: null,
                            fieldName: "GSTIN",
                            display: true,
                            isMandatory: false
                        },
                        {
                            customerType: null,
                            fieldName: "StateCode",
                            display: true,
                            isMandatory: false
                        }
                    ];
                }
                userInfoContentChange();
            }
        );

        getCountry();
        getClearcorpTACMaster();

        function getCountry() {
            Country.get({ id: 1 }, onGetSuccess, onGetFailure);
        }

        function onGetSuccess(result) {
            vm.customerRegistrationRequest.country = result;
        }

        function onGetFailure() {}

        function getClearcorpTACMaster() {
            TACViewForEntitiesService.getActiveTACForOrganisationAndTacType(
                {
                    orgId: vm.clearcorpOrgId,
                    tacTypeId: vm.clearcorpForCustomerTACTypeId
                },
                function (result) {
                    vm.clearcorpTAC = result;
                }
            );
        }

        vm.invalidPanImageSize = false;
        vm.invalidPanImage = false;
        vm.isUserMobileVerified = false;
        vm.isUserEmailVerified = false;
        vm.checkUserOTP = false;
        vm.checkUserEmailOTP = false;
        vm.invalidUserOtp = false;
        vm.invalidUserEmailOtp = false;
        vm.visibleUserOTP = false;
        vm.visibleUserOTPEmail = false;
        vm.submit = submit;
        vm.showGenerateOTPButton = false;
        vm.showGenerateOTPEmailButton = false;
        vm.disableGenerateOTP = true;
        vm.disableGenerateOTPEmail = true;
        vm.generateUserOTP = generateUserOTP;
        vm.generateUserOTPEmail = generateUserOTPEmail;
        vm.wrongUserOTPCount = 0;

        vm.minimumFileSizeInKB = globalValue.uploadedFileMinimumSize;
        vm.maximumFileSizeinKB = globalValue.uploadedFileMaximumSize;
        vm.invalidPanImageSixeText = "";
        vm.invalidPanImageFileNameText = "";
        vm.invalidPanImageText = "";
        vm.maxFileNameLength =
            globalValue.uploadedFileNameLength != null &&
            globalValue.uploadedFileNameLength != undefined &&
            globalValue.uploadedFileNameLength != ""
                ? globalValue.uploadedFileNameLength
                : 150;
        var minFileSizeinBytes = 0;
        var maxFileSizeinBytes = 100;
        if (
            vm.minimumFileSizeInKB != undefined &&
            vm.minimumFileSizeInKB != null &&
            vm.minimumFileSizeInKB != ""
        ) {
            minFileSizeinBytes = vm.minimumFileSizeInKB * 1024;
        }
        if (
            vm.maximumFileSizeinKB != undefined &&
            vm.maximumFileSizeinKB != null &&
            vm.maximumFileSizeinKB != ""
        ) {
            maxFileSizeinBytes = vm.maximumFileSizeinKB * 1024;
        }

        function userInfoContentChange() {
            if (vm.showMultiUser) {
                vm.firstNameInfo = "Enter Authorised Person's  First Name";
                vm.middleNameInfo = "Enter Authorised Person's Middle Name";
                vm.lastNameInfo = "Enter Authorised Person's Last Name";
                vm.emailInfo = "Enter Authorised Person's Email ID";
                vm.mobileInfo = "Enter Authorised Person's Mobile No.";
                vm.dobInfo = "Enter Authorised Person's Date of Birth";
                vm.address1Info = "Enter the Address First line of Entity";
                vm.address2Info = "Enter the Address Second line of Entity";
                vm.panImageInfo =
                    "Upload Image of Entity PAN card in JPG, PNG, PDF (max size 200 Kb)";
            } else {
                vm.firstNameInfo = "Enter your First Name";
                vm.middleNameInfo = "Enter your Middle Name";
                vm.lastNameInfo = "Enter your Last Name";
                vm.emailInfo = "Enter your Email ID";
                vm.mobileInfo = "Enter your Mobile No.";
                vm.dobInfo = "Enter your Date of Birth";
                vm.address1Info = "Enter your Address First line";
                vm.address2Info = "Enter your Address Second line";
                vm.panImageInfo =
                    "Upload Image of your PAN card in JPG, PNG, PDF (max size 200 Kb)";
            }
        }

        $scope.userotpInput = {
            size: globalValue.defaultOTPLength,
            type: "password",
            onDone: function (value) {
                vm.userMobileOtp = value;
            },
            onChange: function (value) {
                if (value != undefined && value != null) {
                    vm.checkUserOTP = false;
                    vm.isUserMobileVerified = false;
                    if (value.length == vm.otpLength) {
                        vm.checkUserOTP = true;
                        vm.invalidUserOtp = false;
                        if (
                            vm.customerRegistrationRequest
                                .userMobileCountryCode == null &&
                            vm.customerRegistrationRequest
                                .userMobileCountryCode == undefined
                        ) {
                            vm.customerRegistrationRequest.userMobileCountryCode =
                                "";
                        }

                        if (vm.isOtpBlocked) {
                            MessageBox.openMessageBox(
                                "Alert",
                                "Maximum wrong OTP attempt count is exceeded! Login blocked. Please try after " +
                                    vm.configSettings
                                        .timePeriodToBlockUserLoginInMinutes +
                                    " minutes.",
                                "Ok",
                                "invalidotp"
                            );
                            return;
                        }


						//var mobileNo = vm.customerRegistrationRequest.userMobileCountryCode.toString() + vm.userMobile;
						CustomerRegistration.verifyOTP({ mobile: vm.userMobile, otp: vm.userMobileOtp ,mobileCountryCode:vm.customerRegistrationRequest.userMobileCountryCode.toString()}, onMobileVerifySuccess, onMobileVerifyFailure);
						//vm.userOtpVerification = result.isVerified;
						/* if(vm.userOtpVerification){
							vm.isUserMobileVerified = true;
							vm.invalidUserOtp = false;
						}else{
							vm.invalidUserOtp = true;
							vm.isUserMobileVerified = false;
							vm.wrongUserOTPCount=vm.wrongUserOTPCount+1;
							if(vm.wrongUserOTPCount>=globalValue.maximumOTPWrongAttemptCount) // check if the wrong user otp was entered for 3 or more times 
							{
								AlertService.error("Maximum wrong OTP attempt count is exceeded!<br>Please request for resend OTP.");
							}		            			
						} 
					});*/
                    } else {
                        vm.checkUserOTP = false;
                    }
                }
            }
        };
        function onMobileVerifySuccess(result) {
            if (result.isVerified == "VERIFIED") {
                vm.isUserMobileVerified = true;
                vm.invalidUserOtp = false;
                vm.customerRegistrationRequest.otpVerifiedMobileId =
                    result.otpVerifiedId;
                //save the mobilOTPID
                vm.wrongOTPCount = 0;
            }
        }
        function onMobileVerifyFailure(result) {
            vm.invalidUserOtp = true;
            vm.isUserMobileVerified = false;
            vm.wrongOTPCount = (vm.wrongOTPCount || 0) + 1;
            if (vm.wrongOTPCount >= globalValue.maximumOTPWrongAttemptCount) {
                vm.isOtpBlocked = true;
                vm.remainingTime = 60; // 1 minute block

                MessageBox.openMessageBox(
                    "Alert",
                    "Maximum wrong OTP attempt count is exceeded! Login blocked. Please try after " +
                        vm.configSettings.timePeriodToBlockUserLoginInMinutes +
                        " minutes.",
                    "Ok",
                    "invalidotp"
                );
                // Start 1-minute countdown
                var countdown = function () {
                    if (vm.remainingTime > 0) {
                        vm.remainingTime--;
                        $timeout(countdown, 1000);
                    } else {
                        vm.isOtpBlocked = false;
                        vm.wrongOTPCount = 0;
                    }
                };
                countdown();
            }
        }
        $scope.userOtpEmailInput = {
            size: globalValue.defaultOTPLength,
            type: "password",
            onDone: function (value) {
                vm.userEmailOtp = value;
            },
            onChange: function (value) {
                if (value != undefined && value != null) {
                    vm.checkUserEmailOTP = false;
                    vm.isUserEmailVerified = false;
                    if (value.length == vm.otpLength) {
                        vm.checkUserEmailOTP = true;
                        vm.invalidUserEmailOtp = false;
                        /* CustomerRegistration.verifyOTPEmail({email: vm.userEmail, otp: vm.userEmailOtp}, function(result){
							vm.userOtpEmailVerification = result.isVerified;
							if(vm.userOtpEmailVerification){
								vm.isUserEmailVerified = true;
								vm.checkPanImage = true;
								vm.invalidUserEmailOtp = false;
							}else{
								vm.invalidUserEmailOtp = true;
								vm.isUserEmailVerified = false;
							}
						}); */
                        if (vm.isOtpBlocked) {
                            MessageBox.openMessageBox(
                                "Alert",
                                "Maximum wrong OTP attempt count is exceeded! Login blocked. Please try after " +
                                    vm.configSettings
                                        .timePeriodToBlockUserLoginInMinutes +
                                    " minutes.",
                                "Ok",
                                "invalidotp"
                            );
                            return;
                        }
                        CustomerRegistration.verifyOTPEmail(
                            { email: vm.userEmail, otp: vm.userEmailOtp },
                            onemailChangeSuccess,
                            onemailChangefailed
                        );
                    } else {
                        vm.checkUserEmailOTP = false;
                    }
                }
            }
        };

        function onemailChangeSuccess(result) {
            if (result.isVerified == "VERIFIED") {
                vm.isUserEmailVerified = true;
                vm.checkPanImage = true;
                vm.invalidUserEmailOtp = false;
                vm.customerRegistrationRequest.otpVerifiedEmailId =
                    result.otpVerifiedId;
                //save emailOTP ID
                // Reset attempts on success
                vm.wrongOTPCount = 0;
                vm.isOtpBlocked = false;
            }
        }

        function onemailChangefailed() {
            vm.invalidUserEmailOtp = true;
            vm.isUserEmailVerified = false;
            // Initialize and increase wrong attempt count
            vm.wrongOTPCount = (vm.wrongOTPCount || 0) + 1;
            if (vm.wrongOTPCount >= globalValue.maximumOTPWrongAttemptCount) {
                vm.isOtpBlocked = true;
                vm.remainingTime = 60; // 1 minute block

                MessageBox.openMessageBox(
                    "Alert",
                    "Maximum wrong OTP attempt count is exceeded! Login blocked. Please try after " +
                        vm.configSettings.timePeriodToBlockUserLoginInMinutes +
                        " minutes.",
                    "Ok",
                    "invalidotp"
                );
                // Start 1-minute countdown
                var countdown = function () {
                    if (vm.remainingTime > 0) {
                        vm.remainingTime--;
                        $timeout(countdown, 1000);
                    } else {
                        vm.isOtpBlocked = false;
                        vm.wrongOTPCount = 0;
                    }
                };
                countdown();
            }
        }

        //validate pan image size
        $scope.$watch("vm.panImage", function (value) {
            if (value != undefined && value != null) {
                if (value.name != null && value.name != undefined) {
                    vm.inputPanImage = value.name;
                    if (
                        vm.panImage.name != null &&
                        vm.panImage.name != undefined
                    ) {
                        vm.inputPanImage = vm.panImage.name;
                        vm.customerRegistrationRequest.fileExtension =
                            vm.inputPanImage.substring(
                                vm.panImage.name.lastIndexOf(".") + 1
                            );
                    } else {
                        vm.panImageBytes = vm.panImage;
                    }
                    var reader = new FileReader();
                    reader.readAsArrayBuffer(vm.panImage);
                    reader.onloadend = function (e) {
                        if (e.target.readyState === FileReader.DONE) {
                            var binary = "";
                            var bytes = new Uint8Array(e.target.result);
                            var len = bytes.byteLength;
                            for (var i = 0; i < len; i++) {
                                binary += String.fromCharCode(bytes[i]);
                            }
                            var data = window.btoa(binary);
                            //var data = btoa(String.fromCharCode.apply(null, bytes));
                            vm.panImageBytes = data;
                        }
                        $scope.$digest();

                        // Check the file signature against known types
                    };
                }
            } else {
                angular.element("input[type='file']").val(null);
                vm.panImage = null;
                vm.inputPanImage = null;
            }
        });
        $scope.$watch("vm.skipOTPUserContact", function (value) {
            if (value != null && value != undefined) {
                vm.customerRegistrationRequest.isSkipOTPUserMobile = value;
                vm.skipOTPUserMobile = value;
                if (value) {
                    vm.showGenerateUserOTPButton = false; // if skip otp then don't show the generate button
                    vm.disableGenerateUserOTP = true; //
                    vm.userMobileOtp = null;
                } else if (!value && !vm.isUserMobileVerified) {
                    //show generate button when skip is unchecked
                    vm.showGenerateUserOTPButton = false;
                    vm.disableGenerateUserOTP = true;
                    vm.visibleUserOTP = false;
                    vm.customerRegistrationRequest.isSkipOTPUserMobile = value;
                    if (
                        vm.customerRegistrationRequest.userMobile != null &&
                        vm.customerRegistrationRequest.userMobile !=
                            undefined &&
                        vm.customerRegistrationRequest.userMobile.length >= 1
                    ) {
                        vm.disableGenerateOTP = false;
                    }
                } else if (!value && vm.isUserMobileVerified) {
                    vm.showGenerateUserOTPButton = false; // if skip otp then don't show the generate button
                    vm.disableGenerateUserOTP = true; //
                    //vm.visibleUserOTP = true;
                }
                validateUserMobile(vm.customerRegistrationRequest.userMobile);
            }
        });

        function validateUserMobile(value) {
            if (value != undefined && value != null) {
                vm.visibleUserOTP = false;
                vm.userMobile = vm.customerRegistrationRequest.userMobile;
                vm.userMobileOtp = null;
                vm.isUserMobileVerified = false;

                if (value.length >= 1) {
                    var isSkipOTPForUserContact = vm.skipOTPUserContact;
                    vm.skipOTPUserMobile = isSkipOTPForUserContact;

                    if (
                        !vm.skipOTPUserMobile &&
                        (vm.customerRegistrationRequest.userMobileCountryCode !=
                            vm.verifiedUserMobileCountryCode ||
                            value != vm.verifiedUserMobile)
                    ) {
                        vm.showGenerateUserOTPButton = true;
                        vm.disableGenerateUserOTP = false;
                    } else {
                        vm.showGenerateUserOTPButton = false;
                        vm.disableGenerateUserOTP = true;
                        vm.isUserMobileVerified = true;
                    }
                } else {
                    vm.disableGenerateUserOTP = true;
                    vm.showGenerateUserOTPButton = false;
                }
            } else {
                vm.showGenerateUserOTPButton = false;
                vm.userMobileOtp = null;
            }
        }

        $scope.$watch("vm.skipOTPUserEmailContact", function (value) {
            if (value != null && value != undefined) {
                vm.customerRegistrationRequest.isSkipOTPUserEmailContact =
                    value;
                vm.skipOTPUserEmail = value;
                if (value) {
                    vm.showGenerateUserOTPEmailButton = false; // if skip otp then don't show the generate button
                    vm.disableGenerateUserOTPEmail = true; //
                    vm.userEmailOtp = null;
                } else if (!value && !vm.isUserEmailVerified) {
                    //show generate button when skip is unchecked
                    vm.showGenerateUserOTPEmailButton = false;
                    vm.disableGenerateUserOTPEmail = true;
                    vm.visibleUserOTPEmail = false;
                    if (
                        vm.customerRegistrationRequest.userEmail != null &&
                        vm.customerRegistrationRequest.userEmail != undefined &&
                        vm.customerRegistrationRequest.userEmail.length >= 1 &&
                        vm.customerRegistrationRequest.userEmail.indexOf("@") >
                            -1 &&
                        vm.customerRegistrationRequest.userEmail.indexOf(".") >
                            -1
                    ) {
                        vm.disableGenerateUserOTPEmail = false;
                    }
                } else if (!value && vm.isUserEmailVerified) {
                    vm.showGenerateUserOTPEmailButton = false; // if skip otp then don't show the generate button
                    vm.disableGenerateUserOTPEmail = true; //
                }

                validateUserEmail(vm.customerRegistrationRequest.userEmail);
            }
        });

        function validateUserEmail(value) {
            if (value != undefined && value != null) {
                vm.visibleUserOTPEmail = false;
                vm.userEmail = vm.customerRegistrationRequest.userEmail;
                vm.userEmailOtp = null;
                vm.isUserEmailVerified = false;
                var isSkipOTPForUserEmailContact = vm.skipOTPUserEmailContact;
                vm.skipOTPUserEmail = isSkipOTPForUserEmailContact;
                if (value.length >= 1 && !vm.skipOTPUserEmail) {
                    vm.disableGenerateUserOTPEmail = true;
                    vm.showGenerateUserOTPEmailButton = false;
                    if (value != vm.verifiedUserEmail) {
                        vm.showGenerateUserOTPEmailButton = true;
                    } else {
                        vm.isUserEmailVerified = true;
                        vm.showGenerateUserOTPEmailButton = false;
                    }
                    if (value.indexOf("@") > -1 && value.indexOf(".") > -1) {
                        vm.disableGenerateUserOTPEmail = false;
                    } else {
                        vm.disableGenerateUserOTPEmail = true;
                    }
                } else {
                    vm.disableGenerateUserOTPEmail = true;
                    vm.showGenerateUserOTPEmailButton = false;
                }
            } else {
                vm.showGenerateUserOTPEmailButton = false;
                vm.userEmailOtp = null;
            }
        }

        //send otp sms to the user contact mobile number
        $scope.$watch(
            "vm.customerRegistrationRequest.userMobile",
            function (value) {
                validateUserMobile(value);
            }
        );
        // Mobile Otp Recaptcha Implementation

        // function generateUserOTP() {
        //     vm.disableGenerateUserOTP = true;
        //     vm.showGenerateUserOTPButton = false;

        //     if (
        //         vm.customerRegistrationRequest.userMobileCountryCode == null &&
        //         vm.customerRegistrationRequest.userMobileCountryCode ==
        //             undefined
        //     ) {
        //         vm.customerRegistrationRequest.userMobileCountryCode = "";
        //     }
        //     var mobileNo = vm.customerRegistrationRequest.userMobile;
        //     var mobileCountryCode =
        //         vm.customerRegistrationRequest.userMobileCountryCode.toString();
        //     CustomerRegistration.sendOTP(
        //         { mobile: mobileNo, mobileCountryCode: mobileCountryCode },
        //         onUserOtpSendSuccess,
        //         onUserOtpSendError,
        //     );
        // }

        function generateUserOTP() {
            vm.disableGenerateUserOTP = true;
            vm.showGenerateUserOTPButton = false;
            var email = "0";
            if (
                vm.customerRegistrationRequest.userEmail != null &&
                vm.customerRegistrationRequest.userEmail != ""
            ) {
                email = vm.customerRegistrationRequest.userEmail;
            }
            if (
                vm.customerRegistrationRequest.userMobileCountryCode == null ||
                vm.customerRegistrationRequest.userMobileCountryCode ==
                    undefined
            ) {
                vm.customerRegistrationRequest.userMobileCountryCode = "";
            }

            var mobileNo = vm.customerRegistrationRequest.userMobile;
            var mobileCountryCode =
                vm.customerRegistrationRequest.userMobileCountryCode.toString();


            // ✅ Step 1: Execute reCAPTCHA
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey,vm.globalValues.getPlatformENCCode()), {
                        action: "otp_action"
                    })
                    .then(function (token) {


                        // ✅ Step 2: Call API with token
                        CustomerRegistration.sendOTP(
                            {
                                mobile: mobileNo,
                                mobileCountryCode: mobileCountryCode,
                                recaptchaToken: token, 
                                sourceType: "send-otp", // optional but good
                                source: "customer-registration",
								email:email // optional but good
                            },
                            onUserOtpSendSuccess,
                            onUserOtpSendError
                        );
                    })
                    .catch(function (error) {
                        console.error("reCAPTCHA error:", error);

                        vm.disableGenerateUserOTP = false;
                        vm.showGenerateUserOTPButton = true;
                    });
            });
        }

        function onUserOtpSendSuccess(result) {
            AlertService.info("OTP has been sent to your mobile");
            vm.wrongUserOTPCount = 0;
            vm.visibleUserOTP = true;
            vm.userMobileOtp = null;
            vm.userMobile = vm.customerRegistrationRequest.userMobile;
            vm.isUserMobileVerified = false;
            var email = 0;
        }

        function onUserOtpSendError() {
            AlertService.info("Error occurred while generating OTP");
            vm.disableGenerateUserOTP = false;
            vm.showGenerateUserOTPButton = true;
        }

        $scope.$watch(
            "vm.customerRegistrationRequest.userEmail",
            function (value) {
                validateUserEmail(value);
            }
        );

        function generateUserOTPEmail() {
            vm.disableGenerateUserOTPEmail = true;
            vm.showGenerateUserOTPEmailButton = false;
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
                        action: "otp_action"
                    })
                    .then(function (token) {
                        CustomerRegistration.sendOTPEmail({
                            email: vm.customerRegistrationRequest.userEmail,
                            recaptchaToken: token,
                            sourceType: "send-otp",
                            source: "customer-registration"
                        },
                            onUserEmailOtpSendSuccess,
                            onUserEmailOtpSendError
                        );
                    })
                    .catch(function (error) {
                        console.error("reCAPTCHA error:", error);
                        vm.disableGenerateOTP = false; // re-enable button
                    });
            });
        }

        // function generateUserOTPEmail() {
        //     vm.disableGenerateOTPEmail = true;
        //     vm.showGenerateOTPEmailButton = false;

        //     console.log("Testing Recaptcha data ",vm.globalValues.getRecaptchaToken(),vm.globalValues.getPlatformENCCode());

        //     // Step 1: Execute reCAPTCHA
        //     grecaptcha.ready(function () {
        //         grecaptcha
        //             .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey,vm.globalValues.getPlatformENCCode()), {
        //                 action: "otp_action"
        //             })
        //             .then(function (token) {
        //                 // Step 2: Call existing API with token
        //                 CustomerRegistration.sendOTPEmail(
        //                     {
        //                         email: vm.customerRegistrationRequest.userEmail,
        //                         recaptchaToken: token // ✅ added
        //                     },
        //                     onUserEmailOtpSendSuccess,
        //                     onUserEmailOtpSendError
        //                 );
        //             });
        //     });
        // }

        function onUserEmailOtpSendSuccess(result) {
            AlertService.info("OTP has been sent to your email");
            vm.visibleUserOTPEmail = true;
            vm.userEmailOtp = null;
            vm.userEmail = vm.customerRegistrationRequest.userEmail;
            vm.isUserEmailVerified = false;
            var email = 0;
        }

        function onUserEmailOtpSendError() {
            AlertService.info("Error occurred while generating OTP");
            vm.disableGenerateUserOTPEmail = false;
            vm.showGenerateUserOTPEmailButton = true;
        }

        $scope.$watch(
            "vm.customerRegistrationRequest.homeBranch",
            function (value) {
                if (value != null && value != undefined) {
                    vm.tradingBranchAddress = value.address;
                } else {
                    vm.tradingBranchAddress = null;
                }
            }
        );

        function submit() {
            if (
                vm.inputDetailsForSelectedCustType != null &&
                vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex] !=
                    null &&
                vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex]
                    .display &&
                vm.customerRegistrationRequest.leiExpiryDate != null &&
                vm.customerRegistrationRequest.leiExpiryDate != undefined &&
                vm.customerRegistrationRequest.leiExpiryDate != "" &&
                moment(vm.customerRegistrationRequest.leiExpiryDate).isBefore(
                    vm.todayDate,
                    "day"
                )
            ) {
                $scope.$emit(
                    "errorMessage",
                    $filter("translate")(
                        "gatewayApp.customerRegistration.expiryDate"
                    )
                );
            } else if (
                moment(vm.customerRegistrationRequest.dob).isAfter(
                    vm.todayDate,
                    "day"
                )
            ) {
                $scope.$emit(
                    "errorMessage",
                    $filter("translate")(
                        "gatewayApp.customerRegistration.futuredateOfBirth"
                    )
                );
            } else {
                vm.clicked = true;
                vm.customerRegistrationRequest.branchAddress =
                    vm.tradingBranchAddress;
                //update clearcorp TAC and bank TAC in cust reg.request in order to update tacForCustomerRequested
                if (vm.clearcorpTAC != null && vm.clearcorpTAC.id != null) {
                    vm.customerRegistrationRequest.clearcorpTAC =
                        vm.clearcorpTAC;
                }
                if (vm.bankTAC != null && vm.bankTAC.id != null) {
                    vm.customerRegistrationRequest.bankTAC = vm.bankTAC;
                }

                if (
                    vm.customerRegistrationRequest.isSkipOTPUserMobile ==
                        null ||
                    vm.customerRegistrationRequest.isSkipOTPUserMobile ==
                        undefined
                ) {
                    vm.customerRegistrationRequest.isSkipOTPUserMobile = true;
                }
                if (
                    vm.customerRegistrationRequest.isSkipOTPUserEmailContact ==
                        null ||
                    vm.customerRegistrationRequest.isSkipOTPUserEmailContact ==
                        undefined
                ) {
                    vm.customerRegistrationRequest.isSkipOTPUserEmailContact = true;
                }
                //vm.customerRegistrationRequest.panImage = vm.panImageBytes;

                $rootScope.panFile = vm.panImage;
                prepareDatesforServer();
                var fd = new FormData();
                fd.append("pan", vm.panImage);
                fd.append(
                    "customer",
                    JSON.stringify(vm.customerRegistrationRequest)
                );
                if (vm.panImage.name != null && vm.panImage.name != undefined) {
                    CustomerRegistration.validateCustomerOnboarding(
                        fd,
                        onSubmitSuccess,
                        onSubmitFailure
                    );
                } else {
                    onSubmitSuccess("success");
                }
            }
        }
        function prepareDatesforServer() {
            if (
                vm.inputDetailsForSelectedCustType != null &&
                vm.inputDetailsForSelectedCustType[$scope.entityNameIndex] !=
                    null &&
                vm.inputDetailsForSelectedCustType[$scope.entityNameIndex]
                    .display
            ) {
                vm.customerRegistrationRequest.customerFirstName =
                    vm.customerRegistrationRequest.companyName;
                vm.customerRegistrationRequest.customerLastName =
                    vm.customerRegistrationRequest.companyName;
            }
            //vm.customerRegistrationRequest.fileExtension = vm.panImage.name.substring(vm.panImage.name.lastIndexOf(".") + 1);
            // unnecessary columns set to empty or null
            vm.customerRegistrationRequest.dobOrDoi = null;
            vm.customerRegistrationRequest.primaryContactName = "";
            vm.customerRegistrationRequest.primaryMobileCountryCode = "";
            vm.customerRegistrationRequest.primaryMobile = "";
            vm.customerRegistrationRequest.primaryEmail = "";
            vm.customerRegistrationRequest.userAddress1 = "";
            vm.customerRegistrationRequest.userCity = "";
            vm.customerRegistrationRequest.userCountry = null;
            vm.customerRegistrationRequest.userState = null;
            vm.customerRegistrationRequest.userPincode = "";
            vm.customerRegistrationRequest.tradingBranch = null;
        }

        function onSubmitSuccess(result) {
            $state.go("customerRegistrationPreview", {
                customerRegistrationRequest: vm.customerRegistrationRequest,
                theme: "light",
                image: vm.panImageBytes
            });
            vm.clicked = false;
        }

        function onSubmitFailure() {
            vm.clicked = false;
            vm.customerRegistrationRequest.dob =
                DateUtils.convertLocalDateFromServer(
                    vm.customerRegistrationRequest.dob
                );

            if (
                vm.inputDetailsForSelectedCustType != null &&
                vm.inputDetailsForSelectedCustType[$scope.entityNameIndex] !=
                    null &&
                vm.inputDetailsForSelectedCustType[$scope.entityNameIndex]
                    .display
            ) {
                vm.customerRegistrationRequest.customerFirstName =
                    vm.customerRegistrationRequest.companyName;
                vm.customerRegistrationRequest.customerLastName =
                    vm.customerRegistrationRequest.companyName;
                vm.required = false;
            }
            if (
                vm.inputDetailsForSelectedCustType != null &&
                vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex] !=
                    null &&
                vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex]
                    .display
            ) {
                if (
                    vm.customerRegistrationRequest.leiExpiryDate != null &&
                    vm.customerRegistrationRequest.leiExpiryDate != undefined &&
                    vm.customerRegistrationRequest.leiExpiryDate != ""
                ) {
                    vm.customerRegistrationRequest.leiExpiryDate =
                        DateUtils.convertLocalDateFromServer(
                            vm.customerRegistrationRequest.leiExpiryDate
                        );
                }
            }
        }

        vm.resendUserOTP = function resendUserOTP() {
            var email = "0";
            if (
                vm.customerRegistrationRequest.userEmail != null &&
                vm.customerRegistrationRequest.userEmail != ""
            ) {
                email = vm.customerRegistrationRequest.userEmail;
            }
            if (
                vm.customerRegistrationRequest.userMobileCountryCode == null &&
                vm.customerRegistrationRequest.userMobileCountryCode ==
                    undefined
            ) {
                vm.customerRegistrationRequest.userMobileCountryCode = "";
            }
            var mobileNo = vm.customerRegistrationRequest.userMobile;
            var mobileCountryCode =
                vm.customerRegistrationRequest.userMobileCountryCode.toString();
            // CustomerRegistration.sendOTP(
            //     { mobile: mobileNo, mobileCountryCode: mobileCountryCode },
            //     onResendUserOtpSuccess,
            //     onResendUserOtpError
            // );
             // Step 1: Execute reCAPTCHA
                    grecaptcha.ready(function () {
                        grecaptcha
                            .execute(
                                CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey,vm.globalValues.getPlatformENCCode()),
                                {
                                    action: "otp_action"
                                }
                            )
                            .then(function (token) {
                                // Step 2: Call API with token
                                CustomerRegistration.sendOTP(
                                    {
                                        mobile: mobileNo,
                                        mobileCountryCode: mobileCountryCode,
                                        recaptchaToken: token,
                                        sourceType: "resend-otp",
                                        source: "customer-registration",
										email:email
                                    },
                                    onResendUserOtpSuccess,
                                    onResendUserOtpError
                                );
                            })
                            .catch(function (error) {
                                console.error("reCAPTCHA error:", error);
                                vm.disableGenerateOTP = false;
                            });
                    });
        };

        function onResendUserOtpSuccess(result) {
            AlertService.info("OTP has been resent to your mobile");
            vm.wrongUserOTPCount = 0;
        }

        function onResendUserOtpError() {}

        vm.resendUserOTPEmail = function resendUserOTPEmail() {
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
                        action: "otp_action"
                    })
                    .then(function (token) {
                        CustomerRegistration.sendOTPEmail({
                            email: vm.customerRegistrationRequest.userEmail,
                            recaptchaToken: token,
                            sourceType: "send-otp",
                            source: "customer-registration"
                        },
                            onUserEmailOtpSendSuccess,
                            onUserEmailOtpSendError
                        );
                    })
                    .catch(function (error) {
                        console.error("reCAPTCHA error:", error);
                        vm.disableGenerateOTP = false; // re-enable button
                    });
            });
        };

        function onResendUserOtpEmailSuccess(result) {
            AlertService.info("OTP has been resent to your email");
        }

        function onResendUserOtpEmailError() {}

        $scope.$watch("vm.customerRegistrationRequest.bank", function (value) {
            if (value != null && value != "" && value != undefined) {
                //var bankName = value.bankName;
                //bankName = bankName.substring(0, 5); // issue fix mantis id :20
                vm.filterText = value.ccpMembershipId;
            }
        });
        $scope.$watch(
            "vm.customerRegistrationRequest.legalEntityIdentifier",
            function (value) {
                if (value != undefined && value != null) {
                    if (value.length == 20) {
                        vm.leiExpiryRequired = true;
                        vm.disableLeiExpiry = false;
                        //vm.customerRegistrationRequest.leiExpiryDate = null;
                    } else {
                        vm.leiExpiryRequired = false;
                        vm.disableLeiExpiry = true;
                        vm.customerRegistrationRequest.leiExpiryDate = null;
                    }
                } else {
                    vm.leiExpiryRequired = false;
                    vm.disableLeiExpiry = true;
                    vm.customerRegistrationRequest.leiExpiryDate = null;
                }
            }
        );

        function fetchRejectedRequest() {
            $state.go("request-reference-number", { refNo: vm.refNo });
        }

        var subscribeFetchRequest = $rootScope.$on(
            "fetchRequest",
            function (event, result) {
                if ($rootScope.refNo == null || $rootScope.refNo == undefined) {
                    vm.refNo = "";
                } else {
                    vm.refNo = $rootScope.refNo;
                    vm.requestDetailsToResubmit =
                        $rootScope.requestDetailsToResubmit;
                    if (
                        vm.requestDetailsToResubmit.customerType
                            .isRequiredForDisplay == false
                    ) {
                        vm.requestDetailsToResubmit.customerType = null;
                        vm.touchedcustomertype = true;
                        vm.touchedsourceOfIntro = true;
                    }
                    getCustomerRegistrationRequestToResubmit(vm.refNo);
                }
            }
        );

        $scope.$on("$destroy", function () {
            subscribeFetchRequest();
        });

        //get request by reference number to resubmit
        function getCustomerRegistrationRequestToResubmit(refNo) {
            if (refNo != "") {
                vm.customerRegistrationRequest = {};
                vm.customerRegistrationRequest.userMobileCountryCode = 91;
                vm.panImage = null;
                vm.panImageBytes = null;
                vm.tradingBranch = null;
                vm.inputPanImage = null;
                //CustomerRegistration.getCustomerRegistrationRequestToResubmit({requestReferenceNo: refNo}, onFetchSuccess, onFetchFailure)
                onFetchSuccess(vm.requestDetailsToResubmit);
            }
        }

        function onFetchSuccess(result) {
            if (result.id != null && result.id != null) {
                vm.customerRegistrationRequest = angular.copy(result);
                $timeout(function () {
                    vm.customerRegistrationRequest.state = angular.copy(
                        result.state
                    );
                }, 1000);
                vm.panImage = vm.customerRegistrationRequest.panImage;
                vm.panImageBytes = vm.customerRegistrationRequest.panImage;
                vm.customerRegistrationRequest.dob =
                    DateUtils.convertLocalDateFromServer(
                        vm.customerRegistrationRequest.dob
                    );
                vm.inputDetailsForSelectedCustType = _.filter(
                    vm.customerTypeWiseInputDetails,
                    function (item) {
                        return (
                            item.customerType.id ==
                            vm.customerRegistrationRequest.customerType.id
                        );
                    }
                );
                if (
                    vm.inputDetailsForSelectedCustType != null &&
                    vm.inputDetailsForSelectedCustType[
                        $scope.entityNameIndex
                    ] != null &&
                    vm.inputDetailsForSelectedCustType[$scope.entityNameIndex]
                        .display
                ) {
                    vm.customerRegistrationRequest.companyName =
                        vm.customerRegistrationRequest.customerFirstName;
                    //vm.customerRegistrationRequest.customerLastName = " ";
                }
                if (
                    vm.inputDetailsForSelectedCustType != null &&
                    vm.inputDetailsForSelectedCustType[
                        $scope.leiExpiryDateIndex
                    ] != null &&
                    vm.inputDetailsForSelectedCustType[
                        $scope.leiExpiryDateIndex
                    ].display
                ) {
                    vm.customerRegistrationRequest.leiExpiryDate =
                        DateUtils.convertLocalDateFromServer(
                            vm.customerRegistrationRequest.leiExpiryDate
                        );
                }
                vm.tradingBranch = angular.copy(
                    vm.customerRegistrationRequest.tradingBranch
                );
                vm.inputPanImage = "PAN Image uploaded";
                vm.validPan = true;
                vm.verifiedUserMobileCountryCode = angular.copy(
                    vm.customerRegistrationRequest.userMobileCountryCode
                );
                vm.verifiedUserMobile = angular.copy(
                    vm.customerRegistrationRequest.userMobile
                );
                vm.verifiedUserEmail = angular.copy(
                    vm.customerRegistrationRequest.userEmail
                );
                vm.isUserMobileVerified = false;
                vm.skipOTPUserMobile = false;
            } else {
                //AlertService.error("Invalid request reference number.");
            }
        }

        function onFetchFailure() {}

        function base64ToArrayBuffer(base64) {
            var binary_string = window.atob(base64);
            var len = binary_string.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }
            return bytes.buffer;
        }

        vm.viewPanImage = function viewPanImage() {
            if (vm.customerRegistrationRequest.fileExtension == "pdf") {
                //var pdfWindow = window.open("");
                //pdfWindow.document.write("<iframe width='100%' height='100%'title='PAN'  src='data:application/pdf;base64, " + encodeURI(vm.customerRegistrationRequest.panImage)+"' ></iframe>")
                var contentByteArray = base64ToArrayBuffer(
                    vm.customerRegistrationRequest.panImage
                );

                var file = new Blob([contentByteArray], {
                    type: "application/pdf"
                });
                var fileURL = URL.createObjectURL(file);

                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file, "PAN.pdf");
                } else {
                    window.open(fileURL, "PAN.pdf");
                }
            } else {
                $state.go("view-panImage-resubmit-request", {
                    image: vm.customerRegistrationRequest.panImage,
                    theme: "light"
                });
            }
        };

        function openHelpWindow() {
            CustomerRegistration.getHelpContent(
                { type: "Customer_OnBoarding" },
                onGetHelpContentsSuccess,
                onGetHelpContentsFailure
            );
        }

        function onGetHelpContentsSuccess(result) {
            if (result.contents != null && result.contents != undefined) {
                var contentByteArray = base64ToArrayBuffer(result.contents);

                var file = new Blob([contentByteArray], {
                    type: "application/pdf"
                });
                var fileURL = URL.createObjectURL(file);

                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(
                        file,
                        "CustomerOnBoarding.pdf"
                    );
                } else {
                    window.open(fileURL, "CustomerOnBoarding.pdf");
                }
            }
        }

        function base64ToArrayBuffer(base64) {
            var binary_string = window.atob(base64);
            var len = binary_string.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }
            return bytes.buffer;
        }

        function onGetHelpContentsFailure() {}
        $scope.$watch("vm.customerRegistrationRequest.bank", function (value) {
            if (value != null && value != undefined) {
                TACViewForEntitiesService.getActiveTACForOrganisationAndTacType(
                    { orgId: value.id, tacTypeId: vm.bankForCustomerTACTypeId },
                    function (result) {
                        if (result != null && result.tacFiles != null) {
                            vm.bankTAC = result;
                        } else {
                            vm.bankTAC = null;
                        }
                    }
                );
            } else {
                vm.bankTAC = null;
            }
        });

        function previewClearcorpTAC() {
            if (vm.clearcorpTAC != null && vm.clearcorpTAC != undefined) {
                TacViewForEntitiesUtility.previewTAC(
                    vm.clearcorpTAC.tacFiles.fileContent,
                    vm.clearcorpTAC.tacFiles.fileName
                );
            }
        }

        function previewBankTAC() {
            if (vm.bankTAC != null && vm.bankTAC != undefined) {
                TacViewForEntitiesUtility.previewTAC(
                    vm.bankTAC.tacFiles.fileContent,
                    vm.bankTAC.tacFiles.fileName
                );
            }
        }

        $scope.$watch(
            "vm.customerRegistrationRequest.companyName",
            function (newVal, oldVal) {
                if (newVal != null && newVal != undefined) {
                    newVal = newVal.replace(/(\r\n|\n|\r)/gm, " ");
                    vm.customerRegistrationRequest.companyName = newVal.replace(
                        /(,)/gm,
                        ""
                    );
                }
            }
        );

        vm.openUserInfo = function openUserInfo() {
            $timeout(function () {
                //set focus to login control
                if (
                    vm.customerRegistrationRequest.customerType
                        .enableUserInfo == false &&
                    document.getElementById("txtLogin") != null &&
                    document.getElementById("txtLogin") != undefined
                ) {
                    document.getElementById("txtLogin").focus();
                }
            }, 100);
        };
        function setEnvironmentName() {
            if (
                vm.configSettings.environmentName != "" &&
                vm.configSettings.environmentName != undefined &&
                vm.configSettings.environmentName != null
            ) {
                vm.environmentName =
                    vm.configSettings.environmentName.toUpperCase();
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CustomerRegistrationApprovalDisclaimerController', CustomerRegistrationApprovalDisclaimerController);

    CustomerRegistrationApprovalDisclaimerController.$inject = ['$uibModalInstance','$stateParams', 'GlobalValues', '$rootScope', '$scope', 'TacViewForEntitiesUtility','CustomerApproval','CustomerRegistration','systemSettings','DateUtils','MessageBox','$filter'];

    function CustomerRegistrationApprovalDisclaimerController($uibModalInstance,$stateParams,GlobalValues,   $rootScope, $scope, TacViewForEntitiesUtility,CustomerApproval,CustomerRegistration,systemSettings,DateUtils,MessageBox,$filter) {
    	
    	var vm = this;
    	
    	vm.clear = clear;
        vm.approve = approve;
        $scope.clicked = false;
        vm.entityId =  $stateParams.entityId;
        vm.onGetCcilTac = TacViewForEntitiesUtility.onGetCcilTacForBank;
        vm.organisation = GlobalValues.getOrganisation();
        vm.messageBoxName = "customerApprovalfromtodo";
        vm.isBankAgreedTac = false;
        
        
        if(systemSettings != null && systemSettings != undefined){
			vm.businessDate  = DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
		}
    	
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function approve(){
        $scope.rowID = vm.entityId;
        CustomerApproval.approve({ "taskId": vm.entityId }, onApproveSuccess, onApproveError); 
      }
      
        function onApproveSuccess(result) {
        	if((result != null && result != undefined) && (result.errorMessage != null && result.errorMessage != undefined && result.errorMessage != "")){
				if(result.errorMessage  == 'tacViewForEntities.bank.cannotApproveCustomer'){
					$uibModalInstance.dismiss('cancel');
					MessageBox.openMessageBox("Alert", $filter('translate')('error.tacViewForEntities.bank.cannotApproveCustomer'), "Ok", "bankApprovalMessage");
				}
			}else{
            $rootScope.removeRow( $scope.rowID );
            $uibModalInstance.dismiss('cancel');
			}
        }

        function onApproveError(error) {
        	//$scope.clicked=false;
        	$uibModalInstance.dismiss('cancel');
        	if((error != null && error != undefined) && (result.errorMessage != null && result.errorMessage != undefined && result.errorMessage != "")){

        		if(result.errorMessage  == 'tacViewForEntities.bank.cannotApproveCustomer'){
        			MessageBox.openMessageBox("Alert", $filter('translate')('error.tacViewForEntities.bank.cannotApproveCustomer'), "Ok", "bankApprovalMessage");
        		}
        	}
        	        	
        }
        
        
    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('customerRegistration', {
            parent: 'account',
            url: '/customer-registration',
            data: {
                authorities: []
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/entities/customer-registration/customer-registration-new.html',
                    controller: 'CustomerRegistrationControllerNew',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	globalValue: ['StaticLookUp', function(StaticLookUp) {
                    return StaticLookUp.getConfigSettingsPreLogin().$promise;
                }],
            	
                customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                    return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                }],
                
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('customer-registration');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    return $translate.refresh();
                }]
            }
        })
        .state('request-reference-number', {
            parent: 'customerRegistration',
            url: '/request-reference-number',
            params: {refNo: null},
            data: {
                authorities: [],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.requestReferenceNumber.main" | translate }}',
                parent: 'customerRegistration'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/request-reference-number/request-reference-number.html',
                    controller: 'RequestReferenceNumberController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xs',
                    resolve: {
                        configSettings: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettingsPreLogin().$promise;
                        }],
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('customerRegistration', null, {reload:false});
                }, function() {
                	$state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('request-reference-number');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('customer-onboarding-view', {
            parent: 'customer-onboarding-exception-report',
            params: {id: null},
            url: '/customer-registration-view/{theme}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['CustomerRegistration', 'GlobalValues', function(CustomerRegistration, GlobalValues) {
                                     return CustomerRegistration.get($stateParams.id).$promise;
                                 }],
                                 customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                                     return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                                 }],
                                 markupTypes: ['StaticLookUp', function(StaticLookUp) {
                                    return StaticLookUp.getMarkupTypes().$promise;
                                }],
                                roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                                    return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                                }],
                                 mode: function(){
                 					return "customeronboarding";
                                 },
                                 enableField: function(){
                                	 return false;
                                 }
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('view-panImage-customer-onboarding', {
            parent: 'customer-onboarding-view',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                    //$state.go('^', null, { reload: true });
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('view-panImage-resubmit-request', {
            parent: 'customerRegistration',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                    //$state.go('^', null, { reload: true });
                	$state.go('^', null, { reload: 'false' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-registration-status-view', {
            parent: 'registrationRequestStatus',
            params: {id: null},
            url: '/customer-details/{theme}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['CustomerRegistration', 'GlobalValues', function(CustomerRegistration, GlobalValues) {
                                     return CustomerRegistration.get($stateParams.id).$promise;
                                 }],
                                 customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                                     return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                                 }],
                                 markupTypes: {},
                                 roEdApplicabilityMethods: {},
                					mode: function(){
                					return "registrationrequeststatus";
                					},
                					enableField: function(){
                                   	 return false;
                                    }
                       
                    }
                }).result.then(function() {
                	$state.go('registrationRequestStatus', null, { reload: true });
                }, function() {
                	$state.go('registrationRequestStatus', null, { reload: true });
                });
            }]
            
        })
        
        .state('customer-track-status-view', {
            parent: 'trackStatus',
            params: {id: null},
            url: '/customer-onboarding-details/{theme}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['CustomerRegistration', 'GlobalValues', function(CustomerRegistration, GlobalValues) {
                                     return CustomerRegistration.get($stateParams.id).$promise;
                                 }],
                                 customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                                     return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                                 }],
                                 markupTypes: {},
                                 roEdApplicabilityMethods: {},
                					mode: function(){
                					return "trackstatus";
                					},
                					enableField: function(){
                                   	 return false;
                                    }
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
        .state('customer-onboarding-status-view', {
            parent: 'customerOnboardingStatus',
            params: {id: null},
            url: '/customer-onboarding-status/{theme}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['CustomerRegistration', 'GlobalValues', function(CustomerRegistration, GlobalValues) {
                                     return CustomerRegistration.get($stateParams.id).$promise;
                                 }],
                                 customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                                     return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                                 }],
                                 markupTypes: {},
                                 roEdApplicabilityMethods: {},
                					mode: function(){
                					return "customeronboardingstatus";
                					},
                					enableField: function(){
                                   	 return false;
                                    }
                       
                    }
                }).result.then(function() {
                    $state.go('customerOnboardingStatus', null, { reload: true });
                }, function() {
                	$state.go('customerOnboardingStatus', null, { reload: true });
                });
            }]
            
        })
        .state('view-pan-image-track-status', {
            parent: 'customer-track-status-view',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('view-pan-image-registration-status', {
            parent: 'customer-registration-status-view',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('view-panImage-customer-onboarding-status', {
            parent: 'customer-onboarding-status-view',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-approval-todo-view', {
            parent: 'customer-todo',
            url: '/customer-registration-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {     
                    		
                            return {                            		
                            };
                        },
                        customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                        }],
                        markupTypes: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }],
                    	mode: function(){
                    		
         				return  'customerApprovalToDo';
                    	},
                    	enableField: function(){
                       	 return false;
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('customer-update-approval-todo-view', {
            parent: 'customer-todo',
            url: '/customer-update-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {     
                    		
                            return {                            		
                            };
                        },
                        customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                        }],
                        markupTypes: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }],
                    	mode: function(){
                    		
         				return 'customerInfoChangeStatus';
                    		},
                    		enableField: function(){
                           	 return false;
                            }
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('modify-customer-details-todoList', {
            parent: 'dashboard',
            url: '/modify-customer-details-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {     
                    		
                            return {                            		
                            };
                        },
                        customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                        }],
                        markupTypes: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }],
                    	mode: function(){
                    		
         				return  'modifycustomerdetails_todo';
                    	},
                    	enableField: function(){
                       	 return false;
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
       /* .state('customer-update-approval-todo-view', {
            parent: 'customer-todo',
            url: '/customer-update-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {     
                    		
                            return {                            		
                            };
                        },
                    	mode: function(){
                    		
         				return 'customerInfoChangeStatus';
                    		},
                    		enableField: function(){
                           	 return false;
                            }
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })*/
        .state('view-panImage-customer-approval', {
            parent: 'customer-approval-todo-view',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('view-panImage-customer-update', {
            parent: 'customer-update-approval-todo-view',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-view-report-view', {
            parent: 'customer-view-report',
            params: {id: null},
            url: '/customer-registration-view/{theme}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['CustomerTradingBankDetails', 'GlobalValues', function(CustomerTradingBankDetails, GlobalValues) {
                                     //return UserProfile.getCustomer({customerId : $stateParams.id}).$promise;
                            		 return CustomerTradingBankDetails.getCustomerDetailsForBankRelationship({customerTradinBankDetailsId: $stateParams.id}).$promise;
                                 }],
                                 customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                                     return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                                 }],
                                 markupTypes: ['StaticLookUp', function(StaticLookUp) {
                                    return StaticLookUp.getMarkupTypes().$promise;
                                }],
                                roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                                    return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                                }],
                                 mode: function(){
                 					return "customerViewReport";
                                 },
                                 enableField: function(){
                                	 return false;
                                 }
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('modify-customer-details', {
            parent: 'customer-view-report',
            params: {id: null},
            url: '/modify-customer-details/{theme}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['CustomerTradingBankDetails', 'GlobalValues', function(CustomerTradingBankDetails, GlobalValues) {
                                     //return UserProfile.getCustomer({customerId : $stateParams.id}).$promise;
                            		 return CustomerTradingBankDetails.getCustomerDetailsForBankRelationship({customerTradinBankDetailsId: $stateParams.id}).$promise;
                                 }],
                                 customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                                     return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                                 }],
                                 markupTypes: ['StaticLookUp', function(StaticLookUp) {
                                    return StaticLookUp.getMarkupTypes().$promise;
                                }],
                                roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                                    return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                                }],
                                 mode: function(){
                 					return "modifycustomerdetails";
                                 },
                                 enableField: function(){
                                	 return false;
                                 }
                       
                    }
                }).result.then(function() {
                    $state.go('customer-view-report', {}, { reload: 'customer-view-report' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('view-panImage-customer-view-report', {
            parent: 'customer-view-report-view',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('view-panImage-customer-info-update', {
            parent: 'user-profile',
            url: '/pan',
            params: {image: null},
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
	.state('customer-info-status-view', {
            parent: 'customer-info-change-status',
            url: '/customer-registration-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['CustomerRegistration', 'GlobalValues', function(CustomerRegistration, GlobalValues) {
                                     //return CustomerRegistration.get({requestId : $stateParams.id}).$promise;
                            		 return {};
                                 }],
                                 customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                                     return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                                 }],
                                 markupTypes: ['StaticLookUp', function(StaticLookUp) {
                                    return StaticLookUp.getMarkupTypes().$promise;
                                }],
                                roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                                    return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                                }],
                                 mode: function(){
                 					return "customerInfoChangeStatus";
                                 },
                                 enableField: function(){
                                	 return $state.params.enableFields;
                                 }
                				
                       
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('view-panImage-customer-info-status', {
            parent: 'customer-info-status-view',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-registration-auditLog', {
            parent: 'audit-log',
            url: '/customerRegistrationAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                        }],
                        markupTypes: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }],
                        mode: function(){
         					return "auditlog";
                        	},
                        	enableField: function(){
                           	 return false;
                            }
                    }
                }).result.then(function() {
                	$state.go('customerRegistration', null, { reload: 'customerRegistration' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('customer-registration-historyReport', {
            parent: 'history-report',
            url: '/customerRegistrationHistoryReport',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                        }],
                        markupTypes: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }],
                		mode: function(){
 					return "HistoryReport";
                		},
                		enableField: function(){
                       	 return false;
                        }
                
                    }
                }).result.then(function() {
                	$state.go('customerRegistration', null, { reload: 'customerRegistration' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('old-customer-registration-auditLog', {
            parent: 'audit-log',
            url: '/old-customerRegistrationAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                        }],
                        markupTypes: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }],
                        mode: function(){
         					return "auditlog";
                        	},
                        	enableField: function(){
                           	 return false;
                            }
                    }
                }).result.then(function() {
                	$state.go('customerRegistration', null, { reload: 'customerRegistration' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('old-customer-registration-historyReport', {
            parent: 'history-report',
            url: '/old-customerRegistrationHistoryReport',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                        }],
                        markupTypes: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }],
                		mode: function(){
 					return "HistoryReport";
                		},
                		enableField: function(){
                       	 return false;
                        }
                
                    }
                }).result.then(function() {
                	$state.go('customerRegistration', null, { reload: 'customerRegistration' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('view-panImage-audit-log', {
            parent: 'customer-registration-auditLog',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('view-panImage-history-report', {
            parent: 'customer-registration-historyReport',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-info-status-view-auditLog', {
            parent: 'audit-log',
            url: '/customer-info-audit-log',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                        }],
                        markupTypes: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }],
                        mode: function(){
         					return "InfoAuditlog";
                        	},
                        	enableField: function(){
                           	 return false;
                            }
                    }
                }).result.then(function() {
                	$state.go('customerRegistration', null, { reload: 'customerRegistration' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('view-panImage-customer-info-audit-log', {
            parent: 'customer-info-status-view-auditLog',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('customer-info-status-view-historyreport', {
            parent: 'history-report',
            url: '/customer-info-history-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                        }],
                        markupTypes: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }],
                        mode: function(){
         					return "InfoHistoryReport";
                        	},
                        	enableField: function(){
                           	 return false;
                            }
                    }
                }).result.then(function() {
                	$state.go('customerRegistration', null, { reload: 'customerRegistration' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('view-panImage-customer-info-history-report', {
            parent: 'customer-info-status-view-historyreport',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('terms-and-conditions', {
            parent: 'customerRegistration',
            url: '/termsAndConditions/{theme} ',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions/terms-and-conditions.html',
                    controller: 'TermsAndConditionsController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                    	mode: function(){
         					return "customerOnBoarding";
                        }
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-info-update-intimation-view', {
            parent: 'entity',
            url: '/customer-info-update-intimation-view',
            data: {
                authorities: ['ROLE_USER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                        }],
                        markupTypes: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }],
                    	mode: function(){
         					return "customerInfoUpdationIntimationView";
                        },
                        enableField: function(){
                       	 return false;
                        }
                    }
                }).result.then(function() {
                    $state.go('home', null, { reload: 'home' });
                }, function() {
                    $state.go('home', null, { reload: 'home' });
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customer-registration');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('view-panImage-customer-info-intimation-status', {
            parent: 'customer-info-update-intimation-view',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('terms-and-conditions-bank-registration', {
            parent: 'trading-bank-create',
            url: '/termsAndConditions /{theme}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions/terms-and-conditions.html',
                    controller: 'TermsAndConditionsController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                    	mode: function(){
         					return "tradingBankRelationship";
                        }
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('customerRegistrationPreview', {
            parent: 'customerRegistration',
            url: '/customer-registration-preview/{theme}',
            params: { customerRegistrationRequest: null, image: null},
            data: {
            	authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-preview.html',
                    controller: 'CustomerRegistrationPreviewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xlg',
                    resolve: {	
                                 mode: function(){
                 					return "customeronboarding";
                                 },
                                 customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                                     return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                                 }],
                                 enableField: function(){
                                	 return false;
                                 }
                       
                    }
                }).result.then(function(result) {
                   $state.go('customerOnboardingStatus', {key: result.activationKey}, { reload: true });
                }, function() {
                   $state.go('^');
                });
            }]
            
        })
        .state('view-panImage-customer-registration-preview', {
            parent: 'customerRegistrationPreview',
            url: '/pan',
            params: { image: null ,
            	theme : null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                    //$state.go('^', null, { reload: true });
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('termsAndConditionsApproval', {
            parent: 'customer-todo',
            url: '/termsAndConditionsApproval',
            params : {entityId : null, customerId : null, tradingBank : null},
            data: {
            	authorities: ['ROLE_USER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions-approval/terms-and-conditions-approval.html',
                    controller: 'TermsAndConditionsApprovalController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('terms-and-conditions-checker-approval', {
            parent: 'termsAndConditionsApproval',
            url: '/termsAndConditions /{theme}',
            data: {
            	authorities: ['ROLE_USER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions/terms-and-conditions-member.html',
                    controller: 'TermsAndConditionsController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                    	mode: function(){
         					return "customerToDo";
                        }
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('terms-and-conditions-view-approval', {
            parent: 'customer-approval-todo-view',
            url: '/termsAndConditions /{theme}',
            data: {
            	authorities: ['ROLE_USER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions/terms-and-conditions-member.html',
                    controller: 'TermsAndConditionsController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                    	mode: function(){
         					return "customerViewApproval";
                        }
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('password-policy-bank-registration', {
            parent: 'terms-and-conditions-bank-registration',
            url: '/passwordPolicy /{theme}',
            data: {
            	authorities: [],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions/password-policy.html',
                    controller: 'PasswordPolicyController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                    	mode: function(){
         					return "tradingBankRelationship";
                        }
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('password-policy-customer-approval', {
            parent: 'terms-and-conditions-checker-approval',
            url: '/passwordPolicy /{theme}',
            data: {
            	authorities: [],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions/password-policy.html',
                    controller: 'PasswordPolicyController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                    	mode: function(){
         					return "customerToDo";
                        }
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('password-policy-customer-view-approval', {
            parent: 'terms-and-conditions-view-approval',
            url: '/passwordPolicy /{theme}',
            data: {
            	authorities: [],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions/password-policy.html',
                    controller: 'PasswordPolicyController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                    	mode: function(){
         					return "customerViewApproval";
                        }
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('password-policy-customer-onBoarding', {
            parent: 'terms-and-conditions',
            url: '/passwordPolicy /{theme}',
            data: {
            	authorities: [],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions/password-policy.html',
                    controller: 'PasswordPolicyController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                    	mode: function(){
         					return "customerOnBoarding";
                        }
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('schedule-of-fees-bank-registration', {
            parent: 'terms-and-conditions-bank-registration',
            url: '/scheduleOfFees /{theme}',
            data: {
            	authorities: [],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions/schedule-of-fees.html',
                    controller: 'ScheduleOfFeesController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	mode: function(){
         					return "tradingBankRelationship";
                        }
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('schedule-of-fees-customer-approval', {
            parent: 'terms-and-conditions-checker-approval',
            url: '/scheduleOfFees /{theme}',
            data: {
            	authorities: [],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions/schedule-of-fees.html',
                    controller: 'ScheduleOfFeesController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	mode: function(){
         					return "customerToDo";
                        }
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('schedule-of-fees-customer-view-approval', {
            parent: 'terms-and-conditions-view-approval',
            url: '/scheduleOfFees /{theme}',
            data: {
            	authorities: [],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions/schedule-of-fees.html',
                    controller: 'ScheduleOfFeesController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	mode: function(){
         					return "customerViewApproval";
                        }
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('schedule-of-fees-customer-onBoarding', {
            parent: 'terms-and-conditions',
            url: '/scheduleOfFees/{theme}',
            data: {
            	authorities: [],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions/schedule-of-fees.html',
                    controller: 'ScheduleOfFeesController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	mode: function(){
         					return "customerOnBoarding";
                        }
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
         .state('schedule-of-fees-transaction-charges-report', {
            parent: 'transaction-charges',
            url: '/Schedule-of-fees-Transaction-charges/{theme}',
            data: {
            	authorities: [],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions/schedule-of-fees.html',
                    controller: 'ScheduleOfFeesController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	mode: function(){
         					return "transactionCharges";
                        }
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
          .state('schedule-of-fees', {
            parent: 'home',
            url: '/Schedule-of-fees/{theme}',
            data: {
            	authorities: [],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions/schedule-of-fees.html',
                    controller: 'ClearCorpScheduleOfFeesController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
      /*  .state('schedule-of-fees', {
            parent: 'entity',
            url: '/Schedule-of-fees/{theme}',
            data: {
            	authorities: [],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terms-and-conditions/schedule-of-fees.html',
                    controller: 'ScheduleOfFeesController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        .state('view-panImage-modify-customer-todo', {
            parent: 'modify-customer-details-todoList',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modify-customer-details-historyreport', {
            parent: 'history-report',
            url: '/modify-customer-details-history-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                        }],
                        markupTypes: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }],
                        mode: function(){
         					return "modifycustomerDetails_history";
                        	},
                        	enableField: function(){
                           	 return false;
                            }
                    }
                }).result.then(function() {
                	$state.go('history-report', null, { reload: 'history-report' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('view-panImage-modify-customer-details-history-report', {
            parent: 'modify-customer-details-historyreport',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modify-customer-details-auditLog', {
            parent: 'audit-log',
            url: '/modify-customer-details-audit-log',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-new-view-dialog.html',
                    controller: 'CustomerRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        customerTypeWiseInputDetails: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getCustomerTypeWiseInputDetails().$promise;
                        }],
                        markupTypes: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }],
                        mode: function(){
         					return "modifycustomerDetails_audit";
                        	},
                        	enableField: function(){
                           	 return false;
                            }
                    }
                }).result.then(function() {
                	$state.go('audit-log', null, { reload: 'audit-log' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('view-panImage-modify-customer-details-audit-log', {
            parent: 'modify-customer-details-auditLog',
            url: '/pan/{theme}',
            params: {image: null},
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-view-panImage.html',
                    controller: 'CustomerViewPanImageController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: 'true' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('customer-registration-apporval-disclaimer', {
            parent: 'customer-todo',
            url: '/customer-registration-approval-disclaimer',
            params : {entityId : null,customerId : null, tradingBank : null},
            data: {
            	authorities: ['ROLE_USER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-registration/customer-registration-approval-disclaimer-dialog.html',
                    controller: 'CustomerRegistrationApprovalDisclaimerController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                    	systemSettings: ['IntradayMarket', function(IntradayMarket) {
                            return IntradayMarket.getCurrentBusinessDate().$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('error');
                            return $translate.refresh();
                        }]
                       
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
       
        
    }
})();

(function () {
    "use strict";
    angular
        .module("gatewayApp")
        .factory("CustomerRegistration", CustomerRegistration);

    CustomerRegistration.$inject = ["$resource"];

    function CustomerRegistration($resource) {
        var resourceUrl = "api/public/customer-registration/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    url: "api/customers",
                    isArray: true
                },
                get: {
                    method: "POST",
                    url: "api/public/customer-onboarding-view",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                getCustomer: {
                    method: "GET",
                    url: "api/customer/:id",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                sendOTP: {
                    method: "POST",
                    url: "api/send-otp-mobile",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);

                        return angular.toJson(copy);
                    }
                },
                sendOTPEmail: {
                    method: "POST",
                    url: "api/send-otp-email",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        return angular.toJson(copy);
                    }
                },

                resendOTP: {
                    method: "POST",
                    params: { mobile: "@mobile" },
                    url: "api/resend-otp/mobile/:mobile",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);

                        return angular.toJson(copy);
                    }
                },
                verifyOTP: {
                    method: "POST",
                    url: "api/verify-otp-mobile"
                },
                verifyOTPEmail: {
                    method: "POST",
                    url: "api/verify-otp-email"
                },
                getCustomersForBank: {
                    method: "GET",
                    url: "api/customer-for-bank/:bankId/customer",
                    params: { bankId: "@bankId" },
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                getCustomersForBankNonProp: {
                    method: "GET",
                    url: "api/customer-for-bank-non-prop/:bankId/customer",
                    params: { bankId: "@bankId" },
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                getCustomersForBranch: {
                    method: "GET",
                    url: "api/customer-for-branch/bank/:bankId/branch/:branchId/customerType/:customerType/customer",
                    params: {
                        bankId: "@bankId",
                        branchId: "@branchId",
                        customerType: "@customerType"
                    },
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                getAllNonPropCustomersForBank: {
                    method: "GET",
                    url: "api/all-non-prop-customers-for-bank/:bankId/bank/:customerUserTypeId/customerUserType",
                    params: {
                        bankId: "@bankId",
                        customerUserTypeId: "@customerUserTypeId"
                    },
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                getSingleAndMultiCustomersForBranch: {
                    method: "GET",
                    url: "api/single-and-multi-customer-for-branch/bank/:bankId/branch/:branchId/customer",
                    params: { bankId: "@bankId", branchId: "@branchId" },
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                getCustomersForBranchForLimits: {
                    method: "GET",
                    url: "api/customer-for-branch-with-valid-status/bank/:bankId/branch/:branchId/customer/:customerId",
                    params: {
                        bankId: "@bankId",
                        branchId: "@branchId",
                        customerId: "@customerId"
                    },
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },

                submit: {
                    method: "POST",
                    url: "api/public/customer-onboarding",
                    headers: {
                        "Content-Type": undefined
                    }
                },
                reSubmit: {
                    method: "POST",
                    url: "api/public/resubmit-customer-onboarding",
                    headers: {
                        "Content-Type": undefined
                    }
                },
                discard: {
                    method: "GET",
                    params: {
                        requestId: "@requestId"
                    },
                    url: "api/public/customer-onboarding-withdraw/:requestId"
                },
                validatePan: {
                    method: "POST",
                    params: {
                        panNumber: "@panNumber"
                    },
                    url: "api/public/customer-onboarding/verifyPan/:panNumber"
                },
                getPANImage: {
                    method: "GET",
                    isArray: false,
                    params: { customerCode: "@customerCode" },
                    url: "api/customer-pan-image/customer/:customerCode"
                },
                getAllStatusSingleAndMultiCustomersForBranch: {
                    method: "GET",
                    url: "api/all-single-and-multi-customer-for-branch/bank/:bankId/branch/:branchId/customer",
                    params: { bankId: "@bankId", branchId: "@branchId" },
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                getAllCustomersForBranch: {
                    method: "GET",
                    url: "api/all-customers-for-branch/:branchId/branch",
                    params: { bankId: "@bankId", branchId: "@branchId" },
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                customerByEntityOwnerTypeShortName: {
                    method: "GET",
                    url: "api/customer-for-branch-by-entity-owner-type-shortname/bank/:bankId/branch/:branchId/customerType/:customerType/customer",
                    params: {
                        bankId: "@bankId",
                        branchId: "@branchId",
                        customerType: "@customerType"
                    },
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                getBankDetails: {
                    method: "GET",
                    url: "api/public/bank",
                    isArray: true
                },
                getTradingBranchDetails: {
                    method: "GET",
                    url: "api/public/trading-branch/{bankId}/bank",
                    isArray: true
                },
                validateRejectedRequestAndSendOTP: {
                    method: "POST",
                    url: "api/public/validate-rejected-request-and-send-otp",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                sendOTPForRequestRefNo: {
                    method: "POST",
                    url: "api/public/send-otp-for-request-ref-no"
                },
                getCustomerRegistrationRequestToResubmit: {
                    method: "GET",
                    url: "api/public/rejected-request",
                    params: { requestReferenceNo: "@requestReferenceNo" },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                verifyOTPAndGetCustomerRegistrationRequest: {
                    method: "POST",
                    url: "api/public/verify-otp-for-request-ref-no",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);

                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                sendOTPToMobileAndEmail: {
                    method: "POST",
                    url: "api/public/send-otp-mobile-email",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);

                        return angular.toJson(copy);
                    }
                },
                nonPropCustomersForBranch: {
                    method: "GET",
                    url: "api/non-prop-customers/bank/:bankId/branch/:branchId/customer",
                    params: { bankId: "@bankId", branchId: "@branchId" },
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                getCustomerRegistrationPrintForNewCustomer: {
                    method: "POST",
                    url: "api/public/generate-new-customer-registration-pdf",
                    responseType: "arraybuffer",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);

                        return angular.toJson(copy);
                    },
                    transformResponse: function (data, headers) {
                        return {
                            data: data,
                            headers: headers
                        };
                    }
                },
                getCustomerRegistrationPrintForBankApproval: {
                    method: "POST",
                    url: "api/generate-customer-registration-pdf-view-bank-approval",
                    responseType: "arraybuffer",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);

                        return angular.toJson(copy);
                    },
                    transformResponse: function (data, headers) {
                        return {
                            data: data,
                            headers: headers
                        };
                    }
                },
                validateCustomerOnboarding: {
                    method: "POST",
                    url: "api/public/validate-customer-onboarding",
                    headers: {
                        "Content-Type": undefined
                    }
                },
                getHelpContent: {
                    method: "GET",
                    isArray: false,
                    params: { type: "@type" },
                    url: "api/public/help-contents/:type"
                },
                getSingleAndMultiCustomersForBranchNonProp: {
                    method: "GET",
                    url: "api/all-single-and-multi-customer-for-branch-non-prop/bank/:bankId/branch/:branchId/customer",
                    params: { bankId: "@bankId", branchId: "@branchId" },
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                getAllNonPropAllCustomer: {
                    method: "GET",
                    url: "api/all-customers-non-prop",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                getAllNonPropCustomersForLookup: {
                    method: "GET",
                    params: { customerUserTypeId: "@customerUserTypeId" },
                    url: "api/all-non-prop-customers-lookup/:customerUserTypeId/customerUserType",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                editTradingBranch: {
                    method: "PUT",
                    params: { orgId: "@orgId", oldBranchId: "@oldBranchId" },
                    url: "api/trading-branch-edit",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        return angular.toJson(copy);
                    }
                },
                getMarkupDetails: {
                    method: "POST",
                    url: "api/customer-onboarding/fillMarkup",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            }
        );
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CustomerRegistrationController', CustomerRegistrationController);

    CustomerRegistrationController.$inject = ['$scope', '$rootScope', '$state','$timeout', 'Auth', '$window', 'StaticLookUp', 
    'MessageBox', 'CustomerRegistration', '$sessionStorage', 'DateUtils', 'Country', 'GlobalValues', 'globalValue', 'AlertService', 
    '$filter','FileUtil', 'Branch', 'customerTypeWiseInputDetails', 'TACViewForEntitiesService', 'TacViewForEntitiesUtility','CryptoUtil'];

    function CustomerRegistrationController ($scope, $rootScope, $state, $timeout, Auth, $window, StaticLookUp, 
        MessageBox, CustomerRegistration, $sessionStorage, DateUtils, Country, GlobalValues, globalValue, AlertService,
        $filter,FileUtil, Branch, customerTypeWiseInputDetails, TACViewForEntitiesService, TacViewForEntitiesUtility,CryptoUtil) {
        var vm = this;
        vm.customerTypes = StaticLookUp.getCustomerTypes();
        //initialize customer type wise input details
        vm.customerTypeWiseInputDetails = customerTypeWiseInputDetails;

        //Indices of input details in customer type wise input details array
        $scope.firstNameIndex = 0;
        $scope.middleNameIndex = 1;
        $scope.lastNameIndex = 2;
        $scope.entityNameIndex = 3;
        $scope.panNoIndex = 4;
        $scope.panImageIndex = 5;
        $scope.legalEntityIdentifierIndex = 6;
        $scope.leiExpiryDateIndex = 7;
        $scope.cinIndex = 8;
        $scope.gstinIndex = 9;
        $scope.stateCodeIndex = 10;
        $scope.dobDoiIndex = 11;

        //window.onpopstate = function (e) { history.pushState(null, null, window.location.href); }
        vm.globalValues = GlobalValues;
        vm.customerInfo = true;
        vm.bankInfo=false;
        $sessionStorage.isAuth = true;
        vm.checkPanImage = false;
        vm.customerRegistrationRequest = {};
        vm.customerRegistrationRequest.gender = 'M';
        vm.customerRegistrationRequest.primaryMobileCountryCode = 91;
        vm.customerRegistrationRequest.alternateMobileCountryCode1 = 91;
        vm.customerRegistrationRequest.alternateMobileCountryCode2 = 91;
        vm.customerRegistrationRequest.userMobileCountryCode = 91;
        vm.customerRegistrationRequest.assignTradingBranch = false;
        vm.required = false;
        vm.otpLength = globalValue.defaultOTPLength;
        var Extensions = ["pdf","png","jpg","jpeg"];
        vm.todayDate=new Date();
        vm.leiExpiryRequired = false;
    	vm.disableLeiExpiry = true;
    	vm.leiMinDate = vm.todayDate +1;
        vm.skipOTPPrimaryContact=true;
        vm.skipOTPPrimaryEmailContact=true;
        vm.skipOTPUserContact=true;
        vm.skipOTPUserEmailContact=true;
    	vm.showSkipOTP = true;
    	if(globalValue.skipOTPVerification == 'No' || globalValue.skipOTPVerification == 'no'|| globalValue.skipOTPVerification == 'NO'){
            vm.skipOTPPrimaryContact=false;
            vm.skipOTPPrimaryEmailContact=false;
            vm.skipOTPUserContact=false;
            vm.skipOTPUserEmailContact=false;
    		vm.showSkipOTP = false;
    	}else{
            vm.skipOTPPrimaryContact=true;
            vm.skipOTPPrimaryEmailContact=true;
            vm.skipOTPUserContact=true;
            vm.skipOTPUserEmailContact=true;
    		vm.showSkipOTP = true;
    	}
    	//get rejected request by reference number
    	vm.refNo = "";
        vm.clearcorpOrgId = 1;
        vm.clearcorpForCustomerTACTypeId = 1;
        vm.bankForCustomerTACTypeId = 3;
    	vm.fetchRejectedRequest = fetchRejectedRequest;
        vm.openHelpWindow = openHelpWindow;
        vm.previewClearcorpTAC = previewClearcorpTAC;
        vm.previewBankTAC = previewBankTAC;

        $window.onresize = function() {
            changeTemplate();
        };
        changeTemplate();

        function changeTemplate() {
            var screenWidth = $window.innerWidth;
            if (screenWidth < 768) {
                vm.mobileView = true;
            } else if (screenWidth >= 768) {
                vm.mobileView = false;
            }
        }
        
        $scope.$watch('vm.customerRegistrationRequest.customerType', function(value){
        	// if(value!=null && value!=undefined){
        	// 	if(value.customerUserType.shortName=='SingleUserCustomer'){
        	// 		vm.required = true;
        	// 		vm.leiExpiryRequired = false;
        	// 		vm.disableLeiExpiry = true;
        	// 	}else if(value.customerUserType.shortName=='MultiUserCustomer'){
        	// 		vm.required = false;
        	// 		if(vm.customerRegistrationRequest.legalEntityIdentifier!=null 
        	// 				&& vm.customerRegistrationRequest.legalEntityIdentifier!=undefined 
        	// 				&& vm.customerRegistrationRequest.legalEntityIdentifier.length==20){
        	// 			vm.leiExpiryRequired = true;
        	// 			vm.disableLeiExpiry = false;
        	// 		}else{
        	// 			vm.leiExpiryRequired = false;
        	// 			vm.disableLeiExpiry = true;
        	// 		}
         //        	//vm.disableLeiExpiry = true;
         //        	//vm.customerRegistrationRequest.leiExpiryDate = null;
        	// 	}
        	// }
            if(value!=null && value!=undefined){
                vm.inputDetailsForSelectedCustType = _.filter(vm.customerTypeWiseInputDetails, function(item) {
                    return item.customerType.id == value.id;
                });
            }else{
                vm.inputDetailsForSelectedCustType = [
                    {customerType: null, fieldName: 'FirstName', display: true, isMandatory: true},
                    {customerType: null, fieldName: 'MiddleName', display: true, isMandatory: false},
                    {customerType: null, fieldName: 'LastName', display: true, isMandatory: true},
                    {customerType: null, fieldName: 'EntityName', display: false, isMandatory: false},
                    {customerType: null, fieldName: 'PANNo', display: true, isMandatory: true},
                    {customerType: null, fieldName: 'PANImage', display: true, isMandatory: true},
                    {customerType: null, fieldName: 'LegalEntityIdentifier', display: true, isMandatory: false},
                    {customerType: null, fieldName: 'LEIExpiryDate', display: true, isMandatory: false},
                    {customerType: null, fieldName: 'CIN', display: false, isMandatory: false},
                    {customerType: null, fieldName: 'GSTIN', display: true, isMandatory: false},
                    {customerType: null, fieldName: 'StateCode', display: true, isMandatory: false},
                    {customerType: null, fieldName: 'DOBDOI', display: true, isMandatory: true}
                ]
            }

        });
       
        getCountry();
        getClearcorpTACMaster();
        
        function getCountry(){
        	Country.get({id: 1}, onGetSuccess, onGetFailure);
        }
        
        function onGetSuccess(result){
            vm.customerRegistrationRequest.country=result;
            vm.customerRegistrationRequest.userCountry=result;
        }

        function onGetFailure(){
        		
        }

        function getClearcorpTACMaster(){
            TACViewForEntitiesService.getActiveTACForOrganisationAndTacType({orgId: vm.clearcorpOrgId, tacTypeId: vm.clearcorpForCustomerTACTypeId}, function(result){
                vm.clearcorpTAC = result;
            })
        }

        vm.invalidPanImageSize = false;
        vm.invalidPanImage = false;
        vm.isPrimaryMobileVerified = false;
        vm.isPrimaryEmailVerified = false;
        vm.checkPrimaryOTP = false;
        vm.checkPrimaryEmailOTP = false;
        vm.invalidPrimaryOtp = false;
        vm.invalidPrimaryEmailOtp = false;
        vm.checkUserOTP = false;
        vm.checkUserEmailOTP = false;
        vm.invalidUserOtp = false;
        vm.invalidUserEmailOtp = false;
        vm.visibleOTP = false;
        vm.visibleOTPEmail = false;
        vm.visibleUserOTP = false;
        vm.visibleUserOTPEmail = false;
        vm.isUserMobileVerified = false;
        vm.isUserEmailVerified = false;
        vm.submit = submit;
        vm.showGenerateOTPButton = false;
        vm.showGenerateOTPEmailButton = false;
        vm.disableGenerateOTP = true;
        vm.disableGenerateOTPEmail = true;
        vm.generateOTP = generateOTP;
        vm.generateOTPEmail = generateOTPEmail;
        vm.showGenerateUserOTPButton = false;
        vm.showGenerateUserOTPEmailButton = false;
        vm.disableGenerateUserOTP = true;
        vm.disableGenerateUserOTPEmail = true;
        vm.generateUserOTP = generateUserOTP;
        vm.generateUserOTPEmail = generateUserOTPEmail;
        vm.wrongPrimaryOTPCount=0;
        vm.wrongUserOTPCount=0;
      
        vm.minimumFileSizeInKB = globalValue.uploadedFileMinimumSize;
        vm.maximumFileSizeinKB = globalValue.uploadedFileMaximumSize;
        vm.invalidPanImageSixeText = "";
        vm.invalidPanImageFileNameText = "";
        vm.invalidPanImageText = "";
        vm.maxFileNameLength = (globalValue.uploadedFileNameLength != null && globalValue.uploadedFileNameLength != undefined && globalValue.uploadedFileNameLength != '') ?globalValue.uploadedFileNameLength : 150 ;
        var minFileSizeinBytes = 0;
        var maxFileSizeinBytes = 100;
        if( vm.minimumFileSizeInKB != undefined &&  vm.minimumFileSizeInKB !=null &&  vm.minimumFileSizeInKB  !=''){
        	minFileSizeinBytes = vm.minimumFileSizeInKB*1024;
        }
        if( vm.maximumFileSizeinKB != undefined &&  vm.maximumFileSizeinKB !=null &&  vm.maximumFileSizeinKB  !=''){
        	maxFileSizeinBytes = vm.maximumFileSizeinKB*1024;
        }

		$scope.otpInput = {
				size : globalValue.defaultOTPLength,
				type : "password",
				onDone : function(value) {
					vm.primaryMobileOtp = value;
				},
				onChange : function(value) {
					if(value!= undefined && value!=null){
		        		vm.checkPrimaryOTP = false;
		        		vm.isPrimaryMobileVerified = false;
		        		if(value.length==vm.otpLength){
		        			vm.checkPrimaryOTP = true;
		        			vm.invalidPrimaryOtp = false;
		                	if(vm.customerRegistrationRequest.primaryMobileCountryCode==null && vm.customerRegistrationRequest.primaryMobileCountryCode==undefined){
		                		vm.customerRegistrationRequest.primaryMobileCountryCode = "";
		                	}
		                	//var mobileNo = vm.customerRegistrationRequest.primaryMobileCountryCode.toString() + vm.primaryMobile;
		            		CustomerRegistration.verifyOTP({mobile: vm.primaryMobile, otp: vm.primaryMobileOtp,mobileCountryCode:vm.customerRegistrationRequest.primaryMobileCountryCode.toString()}, function(result){
		            			vm.otpVerification = result.isVerified;
		            			if(vm.otpVerification){
		            				vm.isPrimaryMobileVerified = true;
		            				vm.checkPanImage = true;
		            				vm.invalidPrimaryOtp = false;
		            			}else{
		            				vm.invalidPrimaryOtp = true;
		            				vm.isPrimaryMobileVerified = false;
		            				vm.wrongPrimaryOTPCount=vm.wrongPrimaryOTPCount+1;
		            				if(vm.wrongPrimaryOTPCount>=globalValue.maximumOTPWrongAttemptCount) // check if the wrong primary otp was entered for 3 or more times 
		            				{
		            					AlertService.error("Maximum wrong OTP attempt count is exceeded!<br>Please request for resend OTP.");
		            				}
		            			}
		            		});
		        		}else{
		        			vm.checkPrimaryOTP = false;
		        		}
		        	}
				}
			};
		
		$scope.userotpInput = {
				size : globalValue.defaultOTPLength,
				type : "password",
				onDone : function(value) {
					vm.userMobileOtp = value;
				},
				onChange : function(value) {
					if(value!= undefined && value!=null){
		        		vm.checkUserOTP = false;
        				vm.isUserMobileVerified = false;
		        		if(value.length==vm.otpLength){
		        			vm.checkUserOTP = true;
		        			vm.invalidUserOtp = false;
		                	if(vm.customerRegistrationRequest.userMobileCountryCode==null && vm.customerRegistrationRequest.userMobileCountryCode==undefined){
		                		vm.customerRegistrationRequest.userMobileCountryCode = "";
		                	}
		                	//var mobileNo = vm.customerRegistrationRequest.userMobileCountryCode.toString() + vm.userMobile;
		            		CustomerRegistration.verifyOTP({mobile: vm.userMobile, otp: vm.userMobileOtp,mobileCountryCode:vm.customerRegistrationRequest.userMobileCountryCode.toString()}, function(result){
		            			vm.userOtpVerification = result.isVerified;
		            			if(vm.userOtpVerification){
		            				vm.isUserMobileVerified = true;
		            				vm.invalidUserOtp = false;
		            			}else{
		            				vm.invalidUserOtp = true;
		            				vm.isUserMobileVerified = false;
		            				vm.wrongUserOTPCount=vm.wrongUserOTPCount+1;
		            				if(vm.wrongUserOTPCount>=globalValue.maximumOTPWrongAttemptCount) // check if the wrong user otp was entered for 3 or more times 
		            				{
		            					AlertService.error("Maximum wrong OTP attempt count is exceeded!<br>Please request for resend OTP.");
		            				}		            			
		            			}
		            		});
		        		}else{
		        			vm.checkUserOTP = false;
		        		}
		        	}
				}
			};
        
		$scope.otpEmailInput = {
				size : globalValue.defaultOTPLength,
				type : "password",
				onDone : function(value) {
					vm.primaryEmailOtp = value;
				},
				onChange : function(value) {
					if(value!= undefined && value!=null){
		        		vm.checkPrimaryEmailOTP = false;
		        		vm.isPrimaryEmailVerified = false;
		        		if(value.length==vm.otpLength){
		        			vm.checkPrimaryEmailOTP = true;
		        			vm.invalidPrimaryEmailOtp = false;
		            		CustomerRegistration.verifyOTPEmail({email: vm.primaryEmail, otp: vm.primaryEmailOtp}, function(result){
		            			vm.otpEmailVerification = result.isVerified;
		            			if(vm.otpEmailVerification){
		            				vm.isPrimaryEmailVerified = true;
		            				vm.checkPanImage = true;
		            				vm.invalidPrimaryEmailOtp = false;
		            			}else{
		            				vm.invalidPrimaryEmailOtp = true;
		            				vm.isPrimaryEmailVerified = false;
		            			}
		            		});
		        		}else{
		        			vm.checkPrimaryEmailOTP = false;
		        		}
		        	}
				}
			};
		
		$scope.userOtpEmailInput = {
				size : globalValue.defaultOTPLength,
				type : "password",
				onDone : function(value) {
					vm.userEmailOtp = value;
				},
				onChange : function(value) {
					if(value!= undefined && value!=null){
		        		vm.checkUserEmailOTP = false;
		        		vm.isUserEmailVerified = false;
		        		if(value.length==vm.otpLength){
		        			vm.checkUserEmailOTP = true;
		        			vm.invalidUserEmailOtp = false;
		            		CustomerRegistration.verifyOTPEmail({email: vm.userEmail, otp: vm.userEmailOtp}, function(result){
		            			vm.userOtpEmailVerification = result.isVerified;
		            			if(vm.userOtpEmailVerification){
		            				vm.isUserEmailVerified = true;
		            				vm.checkPanImage = true;
		            				vm.invalidUserEmailOtp = false;
		            			}else{
		            				vm.invalidUserEmailOtp = true;
		            				vm.isUserEmailVerified = false;
		            			}
		            		});
		        		}else{
		        			vm.checkUserEmailOTP = false;
		        		}
		        	}
				}
			};
		
        //validate pan image size
        $scope.$watch('vm.panImage', function(value){
        	
        	if(value!= undefined && value!=null){
        		if(value.name!=null && value.name!=undefined){
            		if(!FileUtil.isFileSizeValid(value.size ,minFileSizeinBytes , maxFileSizeinBytes  )){
            			vm.invalidPanImageSize = true;
            			vm.invalidPanFileName = false;
            			vm.invalidPanImageSixeText = "PAN image size should be in between "+ vm.minimumFileSizeInKB +"KB and " + vm.maximumFileSizeinKB +" KB";
            			vm.invalidPanImage = false;
            			vm.panImage=null;
            			angular.element("input[type='file']").val(null);
            		}else{
            			vm.inputPanImage=value.name;
            			vm.invalidPanImageSize = false;
            			vm.invalidPanImage = false;
            			if(vm.panImage.name!=null && vm.panImage.name!=undefined){
                			vm.inputPanImage=vm.panImage.name;
                			vm.customerRegistrationRequest.fileExtension = vm.inputPanImage.substring(vm.panImage.name.lastIndexOf(".") + 1);
                			var fileNameWithoutExtension  =  vm.inputPanImage.substring(0,vm.panImage.name.lastIndexOf("."));
            			}else{
            				vm.panImageBytes = vm.panImage;
            			}
            			
            			//check for extension
            			 if(Extensions.indexOf(vm.customerRegistrationRequest.fileExtension.toLowerCase()) <= -1) {
    			        	angular.element("input[type='file']").val(null);
    			        	vm.panImage=null;
    			        	vm.inputPanImage=null;
    			        	vm.invalidPanImage = true;
    			        	 vm.invalidPanFileName = false;
    			        	 vm.invalidPanImageSize = false;
    			        	 vm.invalidPanImageText = "Invalid file format";
            			 }
            			 else if(!FileUtil.isFileNameValid(fileNameWithoutExtension,vm.maxFileNameLength )){
    	    				 angular.element("input[type='file']").val(null);
    	    				 vm.panImage=null;
    	    				 vm.inputPanImage=null;
    				         vm.invalidPanImage = false;
    				         vm.invalidPanImageSize = false;
    				         vm.invalidPanFileName = true;
    				         vm.invalidPanImageFileNameText = "Uploaded pan file name should not exceed " + vm.maxFileNameLength+ " charaters.";				         
    	    			 }else{
            				 var reader = new FileReader();
            				 reader.readAsArrayBuffer(vm.panImage);
            				 /*reader.onload = function(){
            					  var arrayBuffer = reader.result;
            				      var binary = '';
            				      var bytes = new Uint8Array( arrayBuffer ); 
            				      vm.invalidPanImage = false;
         					      vm.invalidPanImageSize = false;
         					      vm.invalidPanFileName = false;
                				      
         					      var data = btoa(String.fromCharCode.apply(null, bytes)); 
                				  vm.panImageBytes =  data;        					      
            				     
            				      
            				}*/
            				reader.onloadend = function(e) {
            					if (e.target.readyState === FileReader.DONE) {
            						var bytes = new Uint8Array( e.target.result ); 
            						var arr = bytes.subarray(0, 4);
    	        					if(!FileUtil.checkPanImageFileExtension(arr)){
    	      				    	  angular.element("input[type='file']").val(null);
    	      				        	vm.panImage=null;
    	      				        	vm.inputPanImage=null;
    	      				        	vm.invalidPanImage = true;
    	      					         vm.invalidPanImageSize = false;
    	      					         vm.invalidPanFileName = false;
    	      					         vm.invalidPanImageText = "Invalid file format";
    	      					         vm.panImageBytes =  null;
    	      					      
    	      				      	}else{      				      		
    	      				      		
    	      				      		vm.invalidPanImage = false;
    	      				      		vm.invalidPanImageSize = false;
    	      				      		vm.invalidPanFileName = false;
    	            				      /*for (var i = 0; i < len; i++) {
    	            				          binary += String.fromCharCode( bytes[ i ] );
    	            				      }
    	            				      var data = window.btoa( binary );*/
    	      				      		var data = btoa(String.fromCharCode.apply(null, bytes)); 
    	      				      		vm.panImageBytes =  data;  
    	      				      	}
    	        					 $scope.$digest();
            					}
            					  // Check the file signature against known types

            				};
            			 }
            			
            		}
        		}
        	}
        	else{
        		angular.element("input[type='file']").val(null);
        		
        		vm.inputPanImage=null;
        	}
        })
         $scope.$watch('vm.skipOTPPrimaryContact', function(value){
        	 if(value!=null && value!=undefined){
        		 vm.skipOTPPrimaryMobile = value;
        	 	if(value){
        		
        	 		vm.showGenerateOTPButton = false;// if skip otp then don't show the generate button
        	 		vm.disableGenerateOTP = true; // 
        	 		vm.primaryMobileOtp = null;
        	 	}else if(!value && !vm.isPrimaryMobileVerified ){
        	 		vm.showGenerateOTPButton = true; //show generate button when skip is unchecked
        	 		vm.disableGenerateOTP = true;
        	 		vm.visibleOTP = false;
        	 		if(vm.customerRegistrationRequest.primaryMobile!=null && vm.customerRegistrationRequest.primaryMobile!=undefined 
        				 && vm.customerRegistrationRequest.primaryMobile.length>=1){
        	 			vm.disableGenerateOTP = false;
        	 		}
        	 	}else if(!value && vm.isPrimaryMobileVerified){
        	 		vm.showGenerateOTPButton = false;// if skip otp then don't show the generate button
        	 		vm.disableGenerateOTP = true; // 
        	 	}
                validatePrimaryMobile(vm.customerRegistrationRequest.primaryMobile);
         	}
         });
        
        $scope.$watch('vm.skipOTPPrimaryEmailContact', function(value){
       	 if(value!=null && value!=undefined){
    		 vm.skipOTPPrimaryEmail = value;
    	 	if(value){
    		
    	 		vm.showGenerateOTPEmailButton = false;// if skip otp then don't show the generate button
    	 		vm.disableGenerateOTPEmail = true; // 
    	 		vm.primaryEmailOtp = null;
    	 	}else if(!value && !vm.isPrimaryEmailVerified ){
    	 		vm.showGenerateOTPEmailButton = true; //show generate button when skip is unchecked
    	 		vm.disableGenerateOTPEmail = true;
    	 		vm.visibleOTPEmail = false;
    	 		if(vm.customerRegistrationRequest.primaryEmail!=null && vm.customerRegistrationRequest.primaryEmail!=undefined 
    				 && vm.customerRegistrationRequest.primaryEmail.length>=1 && ((vm.customerRegistrationRequest.primaryEmail.indexOf('@')>-1) && (vm.customerRegistrationRequest.primaryEmail.indexOf('.')>-1))){
    	 			vm.disableGenerateOTPEmail = false;
    	 		}
    	 	}else if(!value && vm.isPrimaryEmailVerified){
    	 		vm.showGenerateOTPEmailButton = false;// if skip otp then don't show the generate button
    	 		vm.disableGenerateOTPEmail = true; // 
    	 	}
            validatePrimaryEmail(vm.customerRegistrationRequest.primaryEmail);
     	 }
        });

        function validatePrimaryEmail(value){
            if(value!= undefined && value!=null && value!=''){
                vm.visibleOTPEmail = false;
                vm.primaryEmail = vm.customerRegistrationRequest.primaryEmail;
                vm.primaryEmailOtp = null;
                vm.isPrimaryEmailVerified = false;
                if(value.length>=1){
                    var isSkipOTPForPrimaryEmailContact = vm.skipOTPPrimaryEmailContact;
                    vm.skipOTPPrimaryEmail = isSkipOTPForPrimaryEmailContact;
                    
                    if(!vm.skipOTPPrimaryEmail && value!=vm.verifiedPrimaryEmail){
                        vm.showGenerateOTPEmailButton = true;
                    }else{
                        vm.showGenerateOTPEmailButton = false;
                        vm.isPrimaryEmailVerified = true;
                    }
                    if((value.indexOf('@')>-1) && (value.indexOf('.')>-1)){
                        vm.disableGenerateOTPEmail = false;
                    }else{
                        vm.disableGenerateOTPEmail = true;
                    }
                    
                }else{
                    vm.disableGenerateOTPEmail = true;
                    vm.showGenerateOTPEmailButton = false;
                }
            }else{
                vm.showGenerateOTPEmailButton = false;
                vm.primaryEmailOtp = null;
            }
        }


        //send otp sms to the primary contact mobile number
        $scope.$watch('vm.customerRegistrationRequest.primaryMobile', function(value){
            validatePrimaryMobile(value);
        	// if(value!= undefined && value!=null){
        	// 	//if(vm.isPrimaryMobileVerified ){// when mobile number is changed after otp verification reset the otp fields
        	// 		vm.visibleOTP = false;
         //    		vm.primaryMobile = vm.customerRegistrationRequest.primaryMobile;
         //    		vm.primaryMobileOtp = null;
         //    		vm.isPrimaryMobileVerified = false;
        	// 	//}
        	// 	if(value.length>=1){
        	// 		var isSkipOTPForPrimaryContact = vm.skipOTPPrimaryContact;
        	// 		vm.skipOTPPrimaryMobile = isSkipOTPForPrimaryContact;
        			
         //        	if(!vm.skipOTPPrimaryMobile && (vm.customerRegistrationRequest.primaryMobileCountryCode!=vm.verifiedPrimaryMobileCountryCode || value!=vm.verifiedPrimaryMobile)){
                		
         //        		//CustomerRegistration.sendOTP({mobile: vm.customerRegistrationRequest.primaryMobile}, onPrimaryOtpSendSuccess, onPrimaryOtSendError);
         //        		vm.showGenerateOTPButton = true;
         //                vm.disableGenerateOTP = false;
         //        	}else{
         //                vm.showGenerateOTPButton = false;
         //                vm.isPrimaryMobileVerified = true;
         //            }
                	
        	// 	}else{
        	// 		vm.disableGenerateOTP = true;
         //        	vm.showGenerateOTPButton = false;
                	
        	// 	}
        		
            	
        	// }else{
        	// 	vm.showGenerateOTPButton = false;
        	// 	vm.primaryMobileOtp = null;
         // 	}
        })

        function validatePrimaryMobile(value){
            if(value!= undefined && value!=null){
                //if(vm.isPrimaryMobileVerified ){// when mobile number is changed after otp verification reset the otp fields
                    vm.visibleOTP = false;
                    vm.primaryMobile = vm.customerRegistrationRequest.primaryMobile;
                    vm.primaryMobileOtp = null;
                    vm.isPrimaryMobileVerified = false;
                //}
                if(value.length>=1){
                    var isSkipOTPForPrimaryContact = vm.skipOTPPrimaryContact;
                    vm.skipOTPPrimaryMobile = isSkipOTPForPrimaryContact;
                    
                    if(!vm.skipOTPPrimaryMobile && (vm.customerRegistrationRequest.primaryMobileCountryCode!=vm.verifiedPrimaryMobileCountryCode || value!=vm.verifiedPrimaryMobile)){
                        
                        //CustomerRegistration.sendOTP({mobile: vm.customerRegistrationRequest.primaryMobile}, onPrimaryOtpSendSuccess, onPrimaryOtSendError);
                        vm.showGenerateOTPButton = true;
                        vm.disableGenerateOTP = false;
                    }else{
                        vm.showGenerateOTPButton = false;
                        vm.isPrimaryMobileVerified = true;
                    }
                    
                }else{
                    vm.disableGenerateOTP = true;
                    vm.showGenerateOTPButton = false;
                    
                }
                
                
            }else{
                vm.showGenerateOTPButton = false;
                vm.primaryMobileOtp = null;
            }
        }
        
        function generateOTP(){
        	vm.disableGenerateOTP = true;
        	vm.showGenerateOTPButton = false;
    		/*if(vm.customerRegistrationRequest.primaryEmail!=null && vm.customerRegistrationRequest.primaryEmail!=''){
    			email = vm.customerRegistrationRequest.primaryEmail;
    		}*/
        	if(vm.customerRegistrationRequest.primaryMobileCountryCode==null && vm.customerRegistrationRequest.primaryMobileCountryCode==undefined){
        		vm.customerRegistrationRequest.primaryMobileCountryCode = "";
        	}
        	var mobileNo =  vm.customerRegistrationRequest.primaryMobile;
        	var mobileCountryCode = vm.customerRegistrationRequest.primaryMobileCountryCode.toString();
        	CustomerRegistration.sendOTP({mobile: mobileNo, mobileCountryCode : mobileCountryCode}, onPrimaryOtpSendSuccess, onPrimaryOtSendError);
        }
        function onPrimaryOtpSendSuccess(result){
        	
        	AlertService.info("OTP has been sent to your mobile");
        	vm.wrongPrimaryOTPCount=0;
        	vm.visibleOTP = true;
    		vm.primaryMobile = vm.customerRegistrationRequest.primaryMobile;
    		vm.primaryMobileOtp = null;
    		vm.isPrimaryMobileVerified = false;
    		var email = 0;
        }
        
        function onPrimaryOtSendError(){
        	
        	AlertService.error("Error occurred while generating OTP");
        	vm.disableGenerateOTP = false;
        	vm.showGenerateOTPButton = true;
        }
        
        $scope.$watch('vm.customerRegistrationRequest.primaryEmail', function(value){
            validatePrimaryEmail(value);
       //  	if(value!= undefined && value!=null && value!=''){
    			// vm.visibleOTPEmail = false;
       //  		vm.primaryEmail = vm.customerRegistrationRequest.primaryEmail;
       //  		vm.primaryEmailOtp = null;
       //  		vm.isPrimaryEmailVerified = false;
       //  		if(value.length>=1){
       //  			var isSkipOTPForPrimaryEmailContact = vm.skipOTPPrimaryEmailContact;
       //  			vm.skipOTPPrimaryEmail = isSkipOTPForPrimaryEmailContact;
        			
       //          	if(!vm.skipOTPPrimaryEmail && value!=vm.verifiedPrimaryEmail){
       //          		vm.showGenerateOTPEmailButton = true;
       //          	}else{
       //                  vm.showGenerateOTPEmailButton = false;
       //                  vm.isPrimaryEmailVerified = true;
       //              }
       //          	if((value.indexOf('@')>-1) && (value.indexOf('.')>-1)){
       //                  vm.disableGenerateOTPEmail = false;
       //          	}else{
       //          		vm.disableGenerateOTPEmail = true;
       //          	}
                	
       //  		}else{
       //  			vm.disableGenerateOTPEmail = true;
       //          	vm.showGenerateOTPEmailButton = false;
       //  		}
       //  	}else{
       //  		vm.showGenerateOTPEmailButton = false;
       //  		vm.primaryEmailOtp = null;
       //   	}
        })
        
        function generateOTPEmail(){
        	vm.disableGenerateOTPEmail = true;
        	vm.showGenerateOTPEmailButton = false;
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
                        action: "otp_action"
                    })
                    .then(function (token) {
                        CustomerRegistration.sendOTPEmail({
                            email: vm.customerRegistrationRequest.userEmail,
                            recaptchaToken: token,
                            sourceType: "send-otp",
                            source: "customer-registration"
                        },
                            onUserEmailOtpSendSuccess,
                            onUserEmailOtpSendError
                        );
                    })
                    .catch(function (error) {
                        console.error("reCAPTCHA error:", error);
                        vm.disableGenerateOTP = false; // re-enable button
                    });
            });        }
        function onPrimaryOtpEmailSendSuccess(result){
        	
        	AlertService.info("OTP email has been sent to your email");
        	
        	vm.visibleOTPEmail = true;
    		vm.primaryEmail = vm.customerRegistrationRequest.primaryEmail;
    		vm.primaryEmailOtp = null;
    		vm.isPrimaryEmailVerified = false;
        }
        
        function onPrimaryOtpEmailSendError(){
        	
        	AlertService.error("Error occurred while generating OTP email");
        	vm.disableGenerateOTPEmail = false;
        	vm.showGenerateOTPEmailButton = true;
        }

        $scope.$watch('vm.skipOTPUserContact', function(value){
       	 if(value!=null && value!=undefined){
       		vm.skipOTPUserMobile = value;
       	 	if(value){
       		
       	 		vm.showGenerateUserOTPButton = false;// if skip otp then don't show the generate button
       	 		vm.disableGenerateUserOTP = true; // 
       	 		vm.userMobileOtp = null;
       	 	}else if(!value && !vm.isUserMobileVerified ){
       	 		 //show generate button when skip is unchecked
       	 		vm.showGenerateUserOTPButton = false;
       	 		vm.disableGenerateUserOTP = true;
       	 		vm.visibleUserOTP = false;
       	 		if(vm.customerRegistrationRequest.userMobile!=null && vm.customerRegistrationRequest.userMobile!=undefined 
          				 && vm.customerRegistrationRequest.userMobile.length>=1 ){
       	 			if(  (vm.customerRegistrationRequest.userMobile != vm.customerRegistrationRequest.primaryMobile) || 
       	 				(vm.skipOTPPrimaryMobile && vm.customerRegistrationRequest.userMobile == vm.customerRegistrationRequest.primaryMobile)   ){
       	 				
       	 				vm.showGenerateUserOTPButton = true;
       	 				vm.disableGenerateUserOTP = false;
       	 				
       	 			}
       	 			
       	 		}
       	 	}else if(!value && vm.isUserMobileVerified){
       	 		vm.showGenerateUserOTPButton = false;// if skip otp then don't show the generate button
       	 		vm.disableGenerateUserOTP = true; // 
       	 		//vm.visibleUserOTP = true;
       	 	}
            validateUserMobile(vm.customerRegistrationRequest.userMobile);
        }
        });

        function validateUserMobile(value){
            if(value!= undefined && value!=null){
                //if(vm.isUserMobileVerified ){// when mobile number is changed after otp verification reset the otp fields
                    vm.visibleUserOTP = false;
                    vm.userMobile = vm.customerRegistrationRequest.userMobile;
                    vm.userMobileOtp = null;
                    vm.isUserMobileVerified = false;
                //}
                var isSkipOTPForUserContact = vm.skipOTPUserContact;
                vm.skipOTPUserMobile = isSkipOTPForUserContact;
                if(value.length>=1 && !vm.skipOTPUserMobile  ){
                        vm.disableGenerateUserOTP = true;
                        vm.showGenerateUserOTPButton = false;
                        if(((value != vm.customerRegistrationRequest.primaryMobile) || 
                                (vm.skipOTPPrimaryMobile && value == vm.customerRegistrationRequest.primaryMobile)) &&
                                (vm.customerRegistrationRequest.userMobileCountryCode!=vm.verifiedUserMobileCountryCode || value!=vm.verifiedUserMobile)){
                                
                                vm.showGenerateUserOTPButton = true;
                                vm.disableGenerateUserOTP = false;
                                
                        }else if(!vm.skipOTPPrimaryMobile && value == vm.customerRegistrationRequest.primaryMobile && vm.isPrimaryMobileVerified ){
                            vm.isUserMobileVerified = true;
                            vm.showGenerateUserOTPButton = false;
                        }else if(!vm.skipOTPPrimaryMobile && vm.isPrimaryMobileVerified && value==vm.verifiedUserMobile){
                            vm.isUserMobileVerified = true;
                            vm.showGenerateUserOTPButton = false;
                        } 
                }else{
                    vm.disableGenerateUserOTP = true;
                    vm.showGenerateUserOTPButton = false;
                }
                
            }else{
                vm.showGenerateUserOTPButton = false;
                vm.userMobileOtp = null;
            }
        }

        $scope.$watch('vm.skipOTPUserEmailContact', function(value){
          	 if(value!=null && value!=undefined){
        		vm.skipOTPUserEmail = value;
        	 	if(value){
        	 		vm.showGenerateUserOTPEmailButton = false;// if skip otp then don't show the generate button
        	 		vm.disableGenerateUserOTPEmail = true; // 
        	 		vm.userEmailOtp = null;
        	 	}else if(!value && !vm.isUserEmailVerified ){
        	 		 //show generate button when skip is unchecked
        	 		vm.showGenerateUserOTPEmailButton = false;
        	 		vm.disableGenerateUserOTPEmail = true;
        	 		vm.visibleUserOTPEmail = false;
        	 		if(vm.customerRegistrationRequest.userEmail!=null && vm.customerRegistrationRequest.userEmail!=undefined 
           				 && vm.customerRegistrationRequest.userEmail.length>=1 && ((vm.customerRegistrationRequest.userEmail.indexOf('@')>-1) && (vm.customerRegistrationRequest.userEmail.indexOf('.')>-1))){
        	 			if((vm.customerRegistrationRequest.userEmail != vm.customerRegistrationRequest.primaryEmail) || 
        	 				(vm.skipOTPPrimaryEmail && vm.customerRegistrationRequest.userEmail == vm.customerRegistrationRequest.primaryEmail)){
        	 				vm.showGenerateUserOTPEmailButton = true;
        	 				vm.disableGenerateUserOTPEmail = false;
        	 			}
        	 		}
        	 	}else if(!value && vm.isUserEmailVerified){
        	 		vm.showGenerateUserOTPEmailButton = false;// if skip otp then don't show the generate button
        	 		vm.disableGenerateUserOTPEmail = true; // 
        	 	}

                validateUserEmail(vm.customerRegistrationRequest.userEmail);
             }
         });

        function validateUserEmail(value){
            if(value!= undefined && value!=null){
                vm.visibleUserOTPEmail = false;
                vm.userEmail = vm.customerRegistrationRequest.userEmail;
                vm.userEmailOtp = null;
                vm.isUserEmailVerified = false;
                var isSkipOTPForUserEmailContact = vm.skipOTPUserEmailContact;
                vm.skipOTPUserEmail = isSkipOTPForUserEmailContact;
                if(value.length>=1 && !vm.skipOTPUserEmail){
                        vm.disableGenerateUserOTPEmail = true;
                        vm.showGenerateUserOTPEmailButton = false;
                        if(((value != vm.customerRegistrationRequest.primaryEmail) || 
                                (vm.skipOTPPrimaryEmail && value == vm.customerRegistrationRequest.primaryEmail)) &&
                                (value!=vm.verifiedUserEmail)){
                                vm.showGenerateUserOTPEmailButton = true;
                                if((value.indexOf('@')>-1) && (value.indexOf('.')>-1)){
                                    vm.disableGenerateUserOTPEmail = false;
                                }else{
                                    vm.disableGenerateUserOTPEmail = true;
                                }
                                //vm.disableGenerateUserOTPEmail = false;
                                
                        }else if(!vm.skipOTPPrimaryEmail && value == vm.customerRegistrationRequest.primaryEmail && vm.isPrimaryEmailVerified ){
                            vm.isUserEmailVerified = true;
                            vm.showGenerateUserOTPEmailButton = false;
                        }else if(!vm.skipOTPPrimaryEmail && vm.isPrimaryEmailVerified && value==vm.verifiedUserEmail){
                            vm.isUserEmailVerified = true;
                            vm.showGenerateUserOTPEmailButton = false;
                        }
                }else{
                    vm.disableGenerateUserOTPEmail = true;
                    vm.showGenerateUserOTPEmailButton = false;
                }
                
            }else{
                vm.showGenerateUserOTPEmailButton = false;
                vm.userEmailOtp = null;
            }
        }
        
        //send otp sms to the user contact mobile number
        $scope.$watch('vm.customerRegistrationRequest.userMobile', function(value){
            validateUserMobile(value);
       //  	if(value!= undefined && value!=null){
       //  		//if(vm.isUserMobileVerified ){// when mobile number is changed after otp verification reset the otp fields
       //  			vm.visibleUserOTP = false;
       //      		vm.userMobile = vm.customerRegistrationRequest.userMobile;
       //      		vm.userMobileOtp = null;
       //      		vm.isUserMobileVerified = false;
       //  		//}
       //  		var isSkipOTPForUserContact = vm.skipOTPUserContact;
    			// vm.skipOTPUserMobile = isSkipOTPForUserContact;
       //  		if(value.length>=1 && !vm.skipOTPUserMobile  ){
       //  				vm.disableGenerateUserOTP = true;
       //  				vm.showGenerateUserOTPButton = false;
       //      			if(((value != vm.customerRegistrationRequest.primaryMobile) || 
       //         	 				(vm.skipOTPPrimaryMobile && value == vm.customerRegistrationRequest.primaryMobile)) &&
       //                          (vm.customerRegistrationRequest.userMobileCountryCode!=vm.verifiedUserMobileCountryCode || value!=vm.verifiedUserMobile)){
               	 				
       //         	 				vm.showGenerateUserOTPButton = true;
       //         	 				vm.disableGenerateUserOTP = false;
               	 				
       //         	 		}else if(!vm.skipOTPPrimaryMobile && value == vm.customerRegistrationRequest.primaryMobile && vm.isPrimaryMobileVerified ){
       //         	 			vm.isUserMobileVerified = true;
       //                      vm.showGenerateUserOTPButton = false;
       //         	 		}else if(!vm.skipOTPPrimaryMobile && vm.isPrimaryMobileVerified && value==vm.verifiedUserMobile){
       //                      vm.isUserMobileVerified = true;
       //                      vm.showGenerateUserOTPButton = false;
       //                  } 
       //  		}else{
       //  			vm.disableGenerateUserOTP = true;
       //          	vm.showGenerateUserOTPButton = false;
       //  		}
            	
       //  	}else{
       //  		vm.showGenerateUserOTPButton = false;
       //  		vm.userMobileOtp = null;
       //  	}
        });
        function generateUserOTP(){
        	
        	vm.disableGenerateUserOTP = true;
        	vm.showGenerateUserOTPButton = false;
    		/*if(vm.customerRegistrationRequest.primaryEmail!=null && vm.customerRegistrationRequest.primaryEmail!=''){
    			email = vm.customerRegistrationRequest.primaryEmail;
    		}*/
        	if(vm.customerRegistrationRequest.userMobileCountryCode==null && vm.customerRegistrationRequest.userMobileCountryCode==undefined){
        		vm.customerRegistrationRequest.userMobileCountryCode = "";
        	}
        	var mobileNo = vm.customerRegistrationRequest.userMobile;
        	var mobileCountryCode = vm.customerRegistrationRequest.userMobileCountryCode.toString();
    		CustomerRegistration.sendOTP({mobile: mobileNo, mobileCountryCode : mobileCountryCode}, onUserOtpSendSuccess, onUserOtpSendError);
        }
        function onUserOtpSendSuccess(result){
        	AlertService.info("OTP has been sent to your mobile");
        	vm.wrongUserOTPCount=0;
        	vm.visibleUserOTP = true;
        	vm.userMobileOtp = null;
        	vm.userMobile = vm.customerRegistrationRequest.userMobile;
    		vm.isUserMobileVerified = false;
    		var email = 0;
        	
        }
        
        function onUserOtpSendError(){
        	AlertService.info("Error occurred while generating OTP");
        	vm.disableGenerateUserOTP = false;
        	vm.showGenerateUserOTPButton = true;
        }
        
        $scope.$watch('vm.customerRegistrationRequest.userEmail', function(value){
            validateUserEmail(value);
       //  	if(value!= undefined && value!=null){
    			// vm.visibleUserOTPEmail = false;
       //  		vm.userEmail = vm.customerRegistrationRequest.userEmail;
       //  		vm.userEmailOtp = null;
       //  		vm.isUserEmailVerified = false;
       //  		var isSkipOTPForUserEmailContact = vm.skipOTPUserEmailContact;
    			// vm.skipOTPUserEmail = isSkipOTPForUserEmailContact;
       //  		if(value.length>=1 && !vm.skipOTPUserEmail){
       //  				vm.disableGenerateUserOTPEmail = true;
       //  				vm.showGenerateUserOTPEmailButton = false;
       //      			if(((value != vm.customerRegistrationRequest.primaryEmail) || 
       //         	 				(vm.skipOTPPrimaryEmail && value == vm.customerRegistrationRequest.primaryEmail)) &&
       //                          (value!=vm.verifiedUserEmail)){
       //         	 				vm.showGenerateUserOTPEmailButton = true;
       //                          if((value.indexOf('@')>-1) && (value.indexOf('.')>-1)){
       //                              vm.disableGenerateUserOTPEmail = false;
       //                          }else{
       //                              vm.disableGenerateUserOTPEmail = true;
       //                          }
       //         	 				//vm.disableGenerateUserOTPEmail = false;
               	 				
       //         	 		}else if(!vm.skipOTPPrimaryEmail && value == vm.customerRegistrationRequest.primaryEmail && vm.isPrimaryEmailVerified ){
       //         	 			vm.isUserEmailVerified = true;
       //                      vm.showGenerateUserOTPEmailButton = false;
       //         	 		}else if(!vm.skipOTPPrimaryEmail && vm.isPrimaryEmailVerified && value==vm.verifiedUserEmail){
       //                      vm.isUserEmailVerified = true;
       //                      vm.showGenerateUserOTPEmailButton = false;
       //                  }
       //  		}else{
       //  			vm.disableGenerateUserOTPEmail = true;
       //          	vm.showGenerateUserOTPEmailButton = false;
       //  		}
            	
       //  	}else{
       //  		vm.showGenerateUserOTPEmailButton = false;
       //  		vm.userEmailOtp = null;
       //  	}
        });

        function generateUserOTPEmail(){
        	vm.disableGenerateUserOTPEmail = true;
        	vm.showGenerateUserOTPEmailButton = false;
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
                        action: "otp_action"
                    })
                    .then(function (token) {
                        CustomerRegistration.sendOTPEmail({
                            email: vm.customerRegistrationRequest.userEmail,
                            recaptchaToken: token,
                            sourceType: "send-otp",
                            source: "customer-registration"
                        },
                            onUserEmailOtpSendSuccess,
                            onUserEmailOtpSendError
                        );
                    })
                    .catch(function (error) {
                        console.error("reCAPTCHA error:", error);
                        vm.disableGenerateOTP = false; // re-enable button
                    });
            });
		    }
        
        function onUserEmailOtpSendSuccess(result){
        	AlertService.info("OTP has been sent to your email");
        	vm.visibleUserOTPEmail = true;
        	vm.userEmailOtp = null;
        	vm.userEmail = vm.customerRegistrationRequest.userEmail;
    		vm.isUserEmailVerified = false;
    		var email = 0;
        	
        }
        
        function onUserEmailOtpSendError(){
        	AlertService.info("Error occurred while generating OTP");
        	vm.disableGenerateUserOTPEmail = false;
        	vm.showGenerateUserOTPEmailButton = true;
        }

        //verify otp sms for primary mobile
        /*$scope.$watch('vm.primaryMobileOtp', function(value){
        	if(value!= undefined && value!=null){
        		vm.checkPrimaryOTP = false;
        		vm.isPrimaryMobileVerified = false;
        		if(value.length==vm.otpLength){
        			vm.checkPrimaryOTP = true;
            		CustomerRegistration.verifyOTP({mobile: vm.primaryMobile, otp: vm.primaryMobileOtp}, function(result){
            			vm.otpVerification = result.isVerified;
            			if(vm.otpVerification){
            				vm.isPrimaryMobileVerified = true;
            				vm.checkPanImage = true;
            				vm.invalidPrimaryOtp = false;
            			}else{
            				vm.invalidPrimaryOtp = true;
            				vm.isPrimaryMobileVerified = false;
            			}
            		});
        		}else{
        			vm.checkPrimaryOTP = false;
        		}
        	}
        })*/
        
        //verify otp sms for user mobile
        /*$scope.$watch('vm.userMobileOtp', function(value){
        	if(value!= undefined && value!=null){
        		vm.checkUserOTP = false;
        		if(value.length==vm.otpLength){
        			vm.checkUserOTP = true;
            		CustomerRegistration.verifyOTP({mobile: vm.userMobile, otp: vm.userMobileOtp}, function(result){
            			vm.userOtpVerification = result.isVerified;
            			if(vm.userOtpVerification){
            				vm.isUserMobileVerified = true;
            			}else{
            				vm.invalidUserOtp = true;
            				vm.isUserMobileVerified = false;
            			}
            		});
        		}else{
        			vm.checkUserOTP = false;
        		}
        	}
        })*/
        
         $scope.$watch('vm.customerRegistrationRequest.homeBranch', function(value){
        	if(value!=null&&value!=undefined){
        		vm.tradingBranchAddress = value.address;
        	}else{
        		vm.tradingBranchAddress = null;
        	}
        });
        
        function submit(){
        	if( vm.inputDetailsForSelectedCustType!=null 
                            && vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex]!= null 
                            && vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex].display && vm.customerRegistrationRequest.leiExpiryDate !=null && vm.customerRegistrationRequest.leiExpiryDate!=undefined 
          			 && vm.customerRegistrationRequest.leiExpiryDate!= '' && moment(vm.customerRegistrationRequest.leiExpiryDate).isBefore(vm.todayDate,'day')){
           		
           		//AlertService.error($filter('translate')('gatewayApp.customerRegistration.expiryDate'));
           		$scope.$emit('errorMessage', ($filter('translate')('gatewayApp.customerRegistration.expiryDate')));
          		 
           	}else if(moment(vm.customerRegistrationRequest.dob).isAfter(vm.todayDate,'day')){
        		
       		 //AlertService.error($filter('translate')('gatewayApp.customerRegistration.futuredateOfBirth'));
        		$scope.$emit('errorMessage', ($filter('translate')('gatewayApp.customerRegistration.futuredateOfBirth')));
       	 
        	}else{
        		vm.customerRegistrationRequest.branchAddress = vm.tradingBranchAddress;
                //update clearcorp TAC and bank TAC in cust reg.request in order to update tacForCustomerRequested
                if(vm.clearcorpTAC!=null && vm.clearcorpTAC.id!=null){
                    vm.customerRegistrationRequest.clearcorpTAC = vm.clearcorpTAC;
                }
                if(vm.bankTAC!=null && vm.bankTAC.id!=null){
                    vm.customerRegistrationRequest.bankTAC = vm.bankTAC;
                }
        		//vm.customerRegistrationRequest.panImage = vm.panImageBytes;
        		$rootScope.panFile = vm.panImage;
        		
        		var fd = new FormData();
        		fd.append('pan', vm.panImage);
        		fd.append('customer', JSON.stringify(vm.customerRegistrationRequest));
        		if(vm.panImage.name!=null && vm.panImage.name!=undefined){
            		CustomerRegistration.validateCustomerOnboarding(fd, onSubmitSuccess, onSubmitFailure);
        		}else{
        			onSubmitSuccess('success');
        		}
				
		
    			
       		/*var fd = new FormData();
			vm.customerRegistrationRequest.dob = DateUtils.convertLocalDateToServer(vm.customerRegistrationRequest.dob);
			vm.customerRegistrationRequest.dobOrDoi = DateUtils.convertLocalDateToServer(vm.customerRegistrationRequest.dobOrDoi);
			if( vm.customerRegistrationRequest.leiExpiryDate !=null && vm.customerRegistrationRequest.leiExpiryDate!=undefined 
	       			 && vm.customerRegistrationRequest.leiExpiryDate!= ''){
				vm.customerRegistrationRequest.leiExpiryDate = DateUtils.convertLocalDateToServer(vm.customerRegistrationRequest.leiExpiryDate);
			}
			vm.customerRegistrationRequest.branchAddress = vm.tradingBranchAddress;
			
			if(vm.customerRegistrationRequest.customerType.customerUserType.shortName=='MultiUserCustomer'){
				vm.customerRegistrationRequest.customerFirstName=vm.customerRegistrationRequest.companyName;
				vm.customerRegistrationRequest.customerLastName=vm.customerRegistrationRequest.companyName;
			}
			
            fd.append('pan', vm.panImage);
			fd.append('customer', JSON.stringify(vm.customerRegistrationRequest));
        	
            CustomerRegistration.submit(fd, onSubmitSuccess, onSubmitFailure);*/
       	 }
        	
        }
        
        function onSubmitSuccess(result){
        	//$state.go('registrationRequestStatus', {requestId: result.id});
        	$state.go('customerRegistrationPreview', {customerRegistrationRequest : vm.customerRegistrationRequest, theme : 'light', image :vm.panImageBytes });
        }
        
        function onSubmitFailure(){
        	vm.customerRegistrationRequest.dob  = DateUtils.convertLocalDateFromServer(vm.customerRegistrationRequest.dob);
        	vm.customerRegistrationRequest.dobOrDoi  = DateUtils.convertLocalDateFromServer(vm.customerRegistrationRequest.dobOrDoi);
        	
        	if(vm.inputDetailsForSelectedCustType!=null 
                            && vm.inputDetailsForSelectedCustType[$scope.entityNameIndex]!= null 
                            && vm.inputDetailsForSelectedCustType[$scope.entityNameIndex].display){
				vm.customerRegistrationRequest.customerFirstName=vm.customerRegistrationRequest.companyName;
				vm.customerRegistrationRequest.customerLastName=vm.customerRegistrationRequest.companyName;
				vm.required = false;
			}
            if(vm.inputDetailsForSelectedCustType!=null 
                            && vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex]!= null 
                            && vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex].display){
                if( vm.customerRegistrationRequest.leiExpiryDate !=null && vm.customerRegistrationRequest.leiExpiryDate!=undefined 
                         && vm.customerRegistrationRequest.leiExpiryDate!= ''){
                    vm.customerRegistrationRequest.leiExpiryDate = DateUtils.convertLocalDateFromServer(vm.customerRegistrationRequest.leiExpiryDate);
                }                
            }

        }
        
        vm.resendPrimaryOTP = function resendPrimaryOTP(){
        	var email = '0';
    		if(vm.customerRegistrationRequest.primaryEmail!=null && vm.customerRegistrationRequest.primaryEmail!=''){
    			email = vm.customerRegistrationRequest.primaryEmail;
    		}
        	if(vm.customerRegistrationRequest.primaryMobileCountryCode==null && vm.customerRegistrationRequest.primaryMobileCountryCode==undefined){
        		vm.customerRegistrationRequest.primaryMobileCountryCode = "";
        	}
        	var mobileNo =  vm.customerRegistrationRequest.primaryMobile;
        	var mobileCountryCode = vm.customerRegistrationRequest.primaryMobileCountryCode.toString();
        	CustomerRegistration.sendOTP({mobile: mobileNo, mobileCountryCode : mobileCountryCode}, onResendPrimaryOtpSuccess, onResendPrimaryOtpError);
        }

        function onResendPrimaryOtpSuccess(result){
        	AlertService.info("OTP has been resent to your mobile");
        	vm.wrongPrimaryOTPCount=0;
        }
        
        function onResendPrimaryOtpError(){
        	
        }
        
        vm.resendUserOTP = function resendUserOTP(){
        	var email = '0';
    		if(vm.customerRegistrationRequest.userEmail!=null && vm.customerRegistrationRequest.userEmail!=''){
    			email = vm.customerRegistrationRequest.userEmail;
    		}
        	if(vm.customerRegistrationRequest.userMobileCountryCode==null && vm.customerRegistrationRequest.userMobileCountryCode==undefined){
        		vm.customerRegistrationRequest.userMobileCountryCode = "";
        	}
        	var mobileNo = vm.customerRegistrationRequest.userMobile;
        	var mobileCountryCode = vm.customerRegistrationRequest.userMobileCountryCode.toString();
        	CustomerRegistration.sendOTP({mobile: mobileNo, mobileCountryCode : mobileCountryCode}, onResendUserOtpSuccess, onResendUserOtpError);
        }

        function onResendUserOtpSuccess(result){
        	AlertService.info("OTP has been resent to your mobile");
        	vm.wrongUserOTPCount=0;
        }
        
        function onResendUserOtpError(){
        	
        }
        
        vm.resendPrimaryOTPEmail = function resendPrimaryOTPEmail(){
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
                        action: "otp_action"
                    })
                    .then(function (token) {
                        CustomerRegistration.sendOTPEmail({
                            email: vm.customerRegistrationRequest.userEmail,
                            recaptchaToken: token,
                            sourceType: "send-otp",
                            source: "customer-registration"
                        },
                            onUserEmailOtpSendSuccess,
                            onUserEmailOtpSendError
                        );
                    })
                    .catch(function (error) {
                        console.error("reCAPTCHA error:", error);
                        vm.disableGenerateOTP = false; // re-enable button
                    });
            });
		}

        function onResendPrimaryOtpEmailSuccess(result){
        	AlertService.info("OTP has been resent to your email");
        }
        
        function onResendPrimaryOtpEmailError(){
        	
        }
        
        vm.resendUserOTPEmail = function resendUserOTPEmail(){
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
                        action: "otp_action"
                    })
                    .then(function (token) {
                        CustomerRegistration.sendOTPEmail({
                            email: vm.customerRegistrationRequest.userEmail,
                            recaptchaToken: token,
                            sourceType: "send-otp",
                            source: "customer-registration"
                        },
                            onUserEmailOtpSendSuccess,
                            onUserEmailOtpSendError
                        );
                    })
                    .catch(function (error) {
                        console.error("reCAPTCHA error:", error);
                        vm.disableGenerateOTP = false; // re-enable button
                    });
            });
		    }

        function onResendUserOtpEmailSuccess(result){
        	AlertService.info("OTP has been resent to your email");
        }
        
        function onResendUserOtpEmailError(){
        	
        }
        
        vm.copyUserInfo = function copyUserInfo() {
        	
        	if( vm.inputDetailsForSelectedCustType!=null 
                            && vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex]!= null 
                            && vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex].display && vm.customerRegistrationRequest.leiExpiryDate !=null && vm.customerRegistrationRequest.leiExpiryDate!=undefined 
           			 && vm.customerRegistrationRequest.leiExpiryDate!= '' && moment(vm.customerRegistrationRequest.leiExpiryDate).isBefore(vm.todayDate,'day')){
         		
           		 //AlertService.error($filter('translate')('gatewayApp.customerRegistration.expiryDate'));
        		 $scope.$emit('errorMessage', ($filter('translate')('gatewayApp.customerRegistration.expiryDate')));
           		 
           	}else if(moment(vm.customerRegistrationRequest.dobOrDoi).isAfter(vm.todayDate,'day')){
        		
           		//AlertService.error($filter('translate')('gatewayApp.customerRegistration.futuredob'));
           		$scope.$emit('errorMessage', ($filter('translate')('gatewayApp.customerRegistration.futuredob')));
       		
           	}else{
        		 CustomerRegistration.validatePan({panNumber : vm.customerRegistrationRequest.panNumber},onPanVerificationSuccess, onPanVerificationFailure);
        	}
        	
		}
        
        function onPanVerificationSuccess(result){
        	
        		vm.customerInfo=false;
            	vm.bankInfo=true;
            	if(vm.customerRegistrationRequest.customerType.customerUserType.shortName=='SingleUserCustomer'){
                    if(vm.inputDetailsForSelectedCustType!=null 
                            && vm.inputDetailsForSelectedCustType[$scope.entityNameIndex]!= null 
                            && vm.inputDetailsForSelectedCustType[$scope.entityNameIndex].display){
                        //do not copy first/middle/last name when entity name is captured in customer info
                        //vm.customerRegistrationRequest.userFirstName=vm.customerRegistrationRequest.companyName;
                    }else{
                        vm.customerRegistrationRequest.userFirstName=vm.customerRegistrationRequest.customerFirstName;
                        vm.customerRegistrationRequest.userMiddleName=vm.customerRegistrationRequest.customerMiddleName;
                        vm.customerRegistrationRequest.userLastName=vm.customerRegistrationRequest.customerLastName;
                    }
            		vm.customerRegistrationRequest.userMobileCountryCode=vm.customerRegistrationRequest.primaryMobileCountryCode;
            		vm.customerRegistrationRequest.userMobile=vm.customerRegistrationRequest.primaryMobile;
            		vm.customerRegistrationRequest.userEmail=vm.customerRegistrationRequest.primaryEmail;
            		vm.customerRegistrationRequest.dob=vm.customerRegistrationRequest.dobOrDoi;
            		vm.customerRegistrationRequest.userAddress1=vm.customerRegistrationRequest.address1;
            		vm.customerRegistrationRequest.userAddress2=vm.customerRegistrationRequest.address2;
            		vm.customerRegistrationRequest.userCity=vm.customerRegistrationRequest.city;
            		vm.customerRegistrationRequest.userCountry=vm.customerRegistrationRequest.country;
    				$timeout(function(){
    					vm.customerRegistrationRequest.userState=vm.customerRegistrationRequest.state;
					}, 100);
            		vm.customerRegistrationRequest.userPincode=vm.customerRegistrationRequest.pincode;
            		vm.isUserEmailVerified = true;
            		vm.isUserMobileVerified = true;
            	}
            	
				  $timeout(function(){
					  if(vm.tradingBranch!=null){
						  vm.customerRegistrationRequest.tradingBranch = vm.tradingBranch;
					  }
				  }, 100);
        }
        
        function onPanVerificationFailure(){
        	
        }
        
		$scope.$watch('vm.customerRegistrationRequest.bank', function(value){
			if(value!=null && value!='' && value!=undefined){
				//var bankName = value.bankName;
				//bankName = bankName.substring(0, 5); // issue fix mantis id :20
				vm.filterText = value.ccpMembershipId;
			}
		});
		  $scope.$watch('vm.customerRegistrationRequest.legalEntityIdentifier', function(value){
	        	if(value!= undefined && value!=null){
	        		
	        		if(value.length==20){
	        			vm.leiExpiryRequired = true;
	                	vm.disableLeiExpiry = false;
	                	//vm.customerRegistrationRequest.leiExpiryDate = null;
	                	
	        		}else{
	        			vm.leiExpiryRequired = false;
	                	vm.disableLeiExpiry = true;
	                	vm.customerRegistrationRequest.leiExpiryDate = null;
	        		}        		
	            	
	        	}
	        	else{
	        		vm.leiExpiryRequired = false;
                	vm.disableLeiExpiry = true;
                	vm.customerRegistrationRequest.leiExpiryDate = null;
	        	}
	        })
	        
	      function fetchRejectedRequest(){
			  $state.go('request-reference-number', {refNo: vm.refNo});
		  }

	      var subscribeFetchRequest = $rootScope.$on('fetchRequest', function(event, result) {
	        	if($rootScope.refNo==null || $rootScope.refNo==undefined){
	        		vm.refNo = "";
	        	}else{
	        		vm.refNo = $rootScope.refNo;
                    vm.requestDetailsToResubmit = $rootScope.requestDetailsToResubmit;
                    if(vm.requestDetailsToResubmit.customerType.isRequiredForDisplay==false){
                        vm.requestDetailsToResubmit.customerType = null;
                        vm.touchedcustomertype=true;
                    }
	        		getCustomerRegistrationRequestToResubmit(vm.refNo);
	        	}
	      });
	        
	      $scope.$on('$destroy', function() {
	        	subscribeFetchRequest();	        	
	      });
	      
	      //get request by reference number to resubmit  
	      function getCustomerRegistrationRequestToResubmit(refNo){
			  if(refNo!=""){
		    	  vm.customerRegistrationRequest = {};
		          vm.customerRegistrationRequest.gender = 'M';
		          vm.customerRegistrationRequest.primaryMobileCountryCode = 91;
		          vm.customerRegistrationRequest.alternateMobileCountryCode1 = 91;
		          vm.customerRegistrationRequest.alternateMobileCountryCode2 = 91;
		          vm.customerRegistrationRequest.userMobileCountryCode = 91;
		          vm.customerRegistrationRequest.assignTradingBranch = false;
		          //getCountry();
				  vm.panImage = null;
				  vm.panImageBytes = null;
				  vm.tradingBranch = null;
				  vm.inputPanImage = null;
				  //CustomerRegistration.getCustomerRegistrationRequestToResubmit({requestReferenceNo: refNo}, onFetchSuccess, onFetchFailure)
                  onFetchSuccess(vm.requestDetailsToResubmit);
			  }
		  }
	      
	      function onFetchSuccess(result){
			  if(result.id!=null && result.id!=null){
				  vm.customerRegistrationRequest = angular.copy(result);
				  $timeout(function(){
					  vm.customerRegistrationRequest.state = angular.copy(result.state);
					  vm.customerRegistrationRequest.userState = angular.copy(result.userState);
				  }, 1000);
				  vm.panImage = vm.customerRegistrationRequest.panImage;
				  vm.panImageBytes = vm.customerRegistrationRequest.panImage;
				  vm.customerRegistrationRequest.dobOrDoi = DateUtils.convertLocalDateFromServer(vm.customerRegistrationRequest.dobOrDoi);
				  vm.customerRegistrationRequest.dob = DateUtils.convertLocalDateFromServer(vm.customerRegistrationRequest.dob);
                  vm.inputDetailsForSelectedCustType = _.filter(vm.customerTypeWiseInputDetails, function(item) {
                    return item.customerType.id == vm.customerRegistrationRequest.customerType.id;
                });
				  if(vm.inputDetailsForSelectedCustType!=null 
                            && vm.inputDetailsForSelectedCustType[$scope.entityNameIndex]!= null 
                            && vm.inputDetailsForSelectedCustType[$scope.entityNameIndex].display){
					  vm.customerRegistrationRequest.companyName = vm.customerRegistrationRequest.customerFirstName;
                      //vm.customerRegistrationRequest.customerLastName = " ";
				  }
                  if(vm.inputDetailsForSelectedCustType!=null 
                            && vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex]!= null 
                            && vm.inputDetailsForSelectedCustType[$scope.leiExpiryDateIndex].display){
                      vm.customerRegistrationRequest.leiExpiryDate = DateUtils.convertLocalDateFromServer(vm.customerRegistrationRequest.leiExpiryDate);
                  }
				  vm.tradingBranch = angular.copy(vm.customerRegistrationRequest.tradingBranch);
				  vm.inputPanImage = "PAN Image uploaded";
                  vm.verifiedPrimaryMobileCountryCode = angular.copy(vm.customerRegistrationRequest.primaryMobileCountryCode);
                  vm.verifiedPrimaryMobile = angular.copy(vm.customerRegistrationRequest.primaryMobile);
                  vm.verifiedPrimaryEmail = angular.copy(vm.customerRegistrationRequest.primaryEmail);
                  vm.verifiedUserMobileCountryCode = angular.copy(vm.customerRegistrationRequest.userMobileCountryCode);
                  vm.verifiedUserMobile = angular.copy(vm.customerRegistrationRequest.userMobile);
                  vm.verifiedUserEmail = angular.copy(vm.customerRegistrationRequest.userEmail);
			  }else{
				  //AlertService.error("Invalid request reference number.");
			  }
	      }
	      
	      function onFetchFailure(){
	      }
	      
	      function base64ToArrayBuffer(base64) {
    	    var binary_string =  window.atob(base64);
    	    var len = binary_string.length;
    	    var bytes = new Uint8Array( len );
    	    for (var i = 0; i < len; i++)        {
    	        bytes[i] = binary_string.charCodeAt(i);
    	    }
    	    return bytes.buffer;
	      }
	      
	      vm.viewPanImage = function viewPanImage(){
	        	if(vm.customerRegistrationRequest.fileExtension=='pdf'){
	    			//var pdfWindow = window.open("");
	        		//pdfWindow.document.write("<iframe width='100%' height='100%'title='PAN'  src='data:application/pdf;base64, " + encodeURI(vm.customerRegistrationRequest.panImage)+"' ></iframe>")
	        		var contentByteArray = base64ToArrayBuffer(vm.customerRegistrationRequest.panImage);
		    		  
		    		var file = new Blob([contentByteArray], { type: 'application/pdf' });
		            var fileURL = URL.createObjectURL(file);
		              
		            if(window.navigator.msSaveOrOpenBlob) {
		                  window.navigator.msSaveOrOpenBlob(file, "PAN.pdf");
		            }
		            else {
		                   window.open(fileURL, "PAN.pdf");    
		            }
	        	}
	        	else{
	        		$state.go('view-panImage-resubmit-request', {image:vm.customerRegistrationRequest.panImage,theme:'light'});
	        	}
	        }
       
	      
	      function openHelpWindow(){
	    	  
	    	  CustomerRegistration.getHelpContent({type : 'Customer_OnBoarding'}, onGetHelpContentsSuccess, onGetHelpContentsFailure);
	    	  
	    	  
	      }
	      
	      function onGetHelpContentsSuccess(result){
	    	  if(result.contents != null && result.contents != undefined){
	    		  var contentByteArray = base64ToArrayBuffer(result.contents);
	    		  
	    		  var file = new Blob([contentByteArray], { type: 'application/pdf' });
	              var fileURL = URL.createObjectURL(file);
	              
	              if(window.navigator.msSaveOrOpenBlob) {
	                    window.navigator.msSaveOrOpenBlob(file, "CustomerOnBoarding.pdf");
	                }
	                else {
	                     window.open(fileURL, "CustomerOnBoarding.pdf");    
	                }
	              
	              
	    		  
//	    		  var pdfWindow = window.open("");
//	        		pdfWindow.document.write("<iframe width='100%' height='100%' title='PAN'  src='data:application/pdf;base64, " 
//	        				+ encodeURI(result.contents)+"' ></iframe>")
	    		  
	    	  }
	      }
	      
	      function base64ToArrayBuffer(base64) {
	    	    var binary_string =  window.atob(base64);
	    	    var len = binary_string.length;
	    	    var bytes = new Uint8Array( len );
	    	    for (var i = 0; i < len; i++)        {
	    	        bytes[i] = binary_string.charCodeAt(i);
	    	    }
	    	    return bytes.buffer;
	    	}
	      
	      function onGetHelpContentsFailure(){
	    	  
	      }
	      $scope.$watch('vm.customerRegistrationRequest.bank', function(value){
	    	  if(value!=null && value!=undefined){
	    		  Branch.getValidBranchDetailsForBank({bankId: value.id}, function(result){
	    			  if(result!=null && (result.length>1 || result.length==0)){
	    				  vm.customerRegistrationRequest.assignTradingBranch = true;
	    			  }else{
	    				  vm.customerRegistrationRequest.assignTradingBranch = false;
	    			  }
	    		  })

                  TACViewForEntitiesService.getActiveTACForOrganisationAndTacType({orgId: value.id, tacTypeId: vm.bankForCustomerTACTypeId}, function(result){
                    if(result!=null && result.tacFiles!=null){
                        vm.bankTAC = result;    
                    }else{
                        vm.bankTAC = null;
                    }
                  })
	    	  }else{
	    		  vm.customerRegistrationRequest.assignTradingBranch = false;
                  vm.bankTAC = null;
	    	  }
	      })
	      
	      $scope.$watchGroup(['vm.customerRegistrationRequest.assignTradingBranch', 'vm.customerRegistrationRequest.tradingBranch'], function(value){
	    	  if(vm.customerRegistrationRequest.assignTradingBranch!=null && vm.customerRegistrationRequest.assignTradingBranch!=undefined){
	    		  if(vm.customerRegistrationRequest.assignTradingBranch){
	    			  if(vm.customerRegistrationRequest!=null && vm.customerRegistrationRequest.tradingBranch!=null){
	    				  vm.customerRegistrationRequest.tradingBranch = null;
	    			  }
	    			  vm.disableTradingBranch = true;
	    		  }else{
	    			  vm.disableTradingBranch = false;
	    		  }
	    	  }
	      })

          function previewClearcorpTAC(){
            if(vm.clearcorpTAC!=null && vm.clearcorpTAC!=undefined){
                TacViewForEntitiesUtility.previewTAC(vm.clearcorpTAC.tacFiles.fileContent, vm.clearcorpTAC.tacFiles.fileName);    
            }
          }

          function previewBankTAC(){
            if(vm.bankTAC!=null && vm.bankTAC!=undefined){
                TacViewForEntitiesUtility.previewTAC(vm.bankTAC.tacFiles.fileContent, vm.bankTAC.tacFiles.fileName);    
            }
          }

          $scope.$watch('vm.customerRegistrationRequest.companyName', function(newVal, oldVal) {
            if(newVal!=null && newVal!=undefined)
            {
                newVal = newVal.replace(/(\r\n|\n|\r)/gm," ");
                vm.customerRegistrationRequest.companyName = newVal.replace(/(,)/gm,"");
                
            }
          });
          
          vm.openUserInfo = function openUserInfo(){
        	  $timeout(function(){
    			  //set focus to login control
    			  if(vm.customerRegistrationRequest.customerType.enableUserInfo==false 
    					  && document.getElementById("txtLogin") !=null && document.getElementById("txtLogin")!= undefined){
    	        		document.getElementById("txtLogin").focus();
    			  }
        	  }, 100)
          }
	      
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-onboarding-exception-report', {
            parent: 'entity',
            params:{screen: 'CustomerOnboardingExceptionReport'},
            url: '/customer-onboarding-exception-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.customer.customerOnBoardingExceptionReport" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-on-boarding-exception-report/customer-on-boarding-exception-report.html',
                    controller: 'CustomerOnBoardingExceptionReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('customerOnBoardingExceptionReport');
                    $translatePartialLoader.addPart('customer-registration');
                    $translatePartialLoader.addPart('auditLog');
                    return $translate.refresh();
                }],
                entity: function(){
                	
                }
            }
        })
        
        
       
       };
    })();
(function() {
	'use strict';
	angular.module('gatewayApp').factory('CustomerOnBoardingExceptionReport',
			CustomerOnBoardingExceptionReport);

	CustomerOnBoardingExceptionReport.$inject = [ '$resource' ];

	function CustomerOnBoardingExceptionReport($resource) {
		var resourceUrl = 'api/customer-on-boarding-report/:id';

		return $resource(resourceUrl, {}, {

			'getCustomerOnBoardingReportDetails' : {
				isArray : true,
				method : 'GET',
				params : {
					from : '@from',
					to : '@to'
				},
				url : 'api/customer-on-boarding-details/:from/from/:to/to'
			},
			'exportExcelData':{
			    method: 'POST',
                url: 'api/customer-on-boarding-exception-details/excel',
                responseType: 'arraybuffer',
                params : {
					from : '@from',
					to : '@to'
				},
                transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 },
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                } 
			},
			'exportCSVData':{
			    method: 'POST',
                url: 'api/customer-on-boarding-exception-details/csv',
                responseType: 'arraybuffer',
                params : {
					from : '@from',
					to : '@to'
				},
                transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 },
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                } 
			}

		});
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'customerregistration'
        })
        .controller('CustomerOnBoardingExceptionReportController', CustomerOnBoardingExceptionReportController);

    CustomerOnBoardingExceptionReportController.$inject = ['$scope', '$state', 'workflowSharedService','CustomerOnBoardingExceptionReport',  
    	'GlobalValues','EntityPermissions','$filter', 'entity','ScreenLog','entityConstants','$timeout', 'DateUtils', 'AlertService','$window','CryptoUtil'];

    function CustomerOnBoardingExceptionReportController($scope, $state,  workflowSharedService, CustomerOnBoardingExceptionReport,  
    		GlobalValues, EntityPermissions,$filter, entity,ScreenLog,entityConstants,$timeout, DateUtils, AlertService, $window, CryptoUtil) {    
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.userEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.showDetails=false;
        vm.todayDate=new Date();
        vm.customerOnBoarding=customerOnBoarding;
        vm.GetNumberOfDaysInPipeline=GetNumberOfDaysInPipeline;
        vm.screenLog=ScreenLog;
        $scope.refresh=refresh;
        vm.prepareTotalRow = prepareTotalRow;
        vm.prepareDetails=prepareDetails;
        vm.prepareElements=prepareElements;
        vm.todayDate=new Date();
        vm.fromDate = DateUtils.convertDateTimeFromServer(vm.todayDate);
        vm.toDate = DateUtils.convertDateTimeFromServer(vm.todayDate);
        vm.mimeType= '';  	  
  	  	vm.baseString =  'Customer_OnBoarding_Exception_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm'); 
        workflowSharedService.viewFrom = "customerregistration";
		vm.clicked=false; 
        
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMER_ONBOARDING_EXCEPTION_REPORT;
        logScreenAccess();
        
        //display all the records of customer onboarding
        
        vm.loadAll = loadAll;
        vm.exportToFile = exportToFile
        
        function loadAll() {
        	vm.totalPendingTasksCount = 0;
        	vm.totalRejectedTasksCount = 0;
        	vm.totalAutoWithdrawnTasksCount = 0;
        	vm.totalWithdrawnTasksCount = 0
        	vm.totalPendingTasks = [];
        	vm.totalRejectedTasks = [];
        	vm.totalAutoWithdrawnTasks = [];
        	vm.totalWithdrawnTasks = [];
        	vm.customerRegistrationDetails = [];
        	if(moment(vm.fromDate).isAfter(vm.todayDate,'day')){
    			AlertService.error($filter('translate')('gatewayApp.AuditLog.futureFromDate'));
    		}
    		else if(moment(vm.fromDate).isAfter(vm.toDate,'day')){
    			AlertService.error($filter('translate')('gatewayApp.AuditLog.greaterFromDate'));
    		}else if(moment(vm.toDate).isAfter(vm.todayDate,'day')){
    			AlertService.error($filter('translate')('gatewayApp.AuditLog.greaterToDate'));
    		}
    		else{
        		var from=DateUtils.convertLocalDateToServer(vm.fromDate);
        		var to=DateUtils.convertLocalDateToServer(vm.toDate);
        		
                CustomerOnBoardingExceptionReport.getCustomerOnBoardingReportDetails({"from":from,"to":to}, function(result) {
                    vm.customerOnBoardingDetails = result; 
					vm.clicked=false; 
                    /*if(vm.userEntityOwnerType=='Branch'){
                    	if(vm.customerOnBoardingDetails.length>0){
                    		vm.showDetails=true;
                        	vm.customerRegistrationDetails = vm.customerOnBoardingDetails[0].customerRegistrationRequestList;
                    	}else{
                    		vm.customerRegistrationDetails = [];
                    	}
                    }*/
                });
    		}
        }
        
        function customerOnBoarding(customerRegistrationList, status){
        	vm.customerRegistrationDetails = customerRegistrationList;
        	if(status=='pending'){
        		vm.showDateOfRejectionWithdrawn = false;
        	}else{
        		vm.showDateOfRejectionWithdrawn = true;
        	}
        	
        }
        
        //get the number of days in pipeline given created date
        function GetNumberOfDaysInPipeline(createdDate){
        		$scope.formattedCreatedDate =   $filter('date')(createdDate, "yyyy-MM-dd");
        		var startDate = Date.parse($scope.formattedCreatedDate);
        		$scope.formattedTodayDate =   $filter('date')(vm.todayDate, "yyyy-MM-dd");
        		var endDate = Date.parse($scope.formattedTodayDate);
        		var timeDiff = endDate - startDate;
        		$scope.daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        		return $scope.daysDiff;
        }
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }
        
        $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
        
        $scope.$watch('vm.filterText', function(value){
        	vm.totalPendingTasksCount = 0;
        	vm.totalRejectedTasksCount = 0;
        	vm.totalAutoWithdrawnTasksCount = 0;
        	vm.totalWithdrawnTasksCount = 0;
        	vm.totalPendingTasks = [];
        	vm.totalRejectedTasks = [];
        	vm.totalAutoWithdrawnTasks = [];
        	vm.totalWithdrawnTasks = [];
        	vm.customerRegistrationDetails = [];
        	angular.forEach(vm.filterData, function(value){
            	prepareTotalRow(value);
        	})
        	
        })
        
        function prepareElements()
        {
        	 //if(vm.userEntityOwnerType!='Branch'){
	        	vm.totalPendingTasksCount = 0;
	        	vm.totalRejectedTasksCount = 0;
	        	vm.totalAutoWithdrawnTasksCount = 0;
	        	vm.totalWithdrawnTasksCount = 0;
	        	vm.totalPendingTasks = [];
	        	vm.totalRejectedTasks = [];
	        	vm.totalAutoWithdrawnTasks = [];
	        	vm.totalWithdrawnTasks = [];
	        	vm.customerRegistrationDetails = [];
        	 //}
        }
        
      function prepareDetails(){
        	prepareElements();
        	angular.forEach(vm.filterData, function(value){
            	prepareTotalRow(value);
        	})
        }
        
        function prepareTotalRow(customerOnBoardingDetail){
        	vm.totalPendingTasksCount = vm.totalPendingTasksCount + customerOnBoardingDetail.numberOfPendingTasks; 
        	vm.totalRejectedTasksCount = vm.totalRejectedTasksCount + customerOnBoardingDetail.numberOfRejectedTasks; 
			vm.totalAutoWithdrawnTasksCount = vm.totalAutoWithdrawnTasksCount + customerOnBoardingDetail.numberOfAutoWithdrawnTasks; 
			vm.totalWithdrawnTasksCount = vm.totalWithdrawnTasksCount + customerOnBoardingDetail.numberOfWithdrawnTasks; 

			if(customerOnBoardingDetail.customerRegistrationRequestList!=null && customerOnBoardingDetail.customerRegistrationRequestList!=undefined){
				vm.totalPendingTasks = vm.totalPendingTasks.concat(customerOnBoardingDetail.customerRegistrationRequestList); 
			}
			if(customerOnBoardingDetail.rejectedRequestList!=null && customerOnBoardingDetail.rejectedRequestList!=undefined){
				vm.totalRejectedTasks = vm.totalRejectedTasks.concat(customerOnBoardingDetail.rejectedRequestList); 
			}
			if(customerOnBoardingDetail.autoWithdrawnRequestList!=null && customerOnBoardingDetail.autoWithdrawnRequestList!=undefined){
				vm.totalAutoWithdrawnTasks = vm.totalAutoWithdrawnTasks.concat(customerOnBoardingDetail.autoWithdrawnRequestList); 
			}
			if(customerOnBoardingDetail.withdrawnRequestList!=null && customerOnBoardingDetail.withdrawnRequestList!=undefined){
				vm.totalWithdrawnTasks = vm.totalWithdrawnTasks.concat(customerOnBoardingDetail.withdrawnRequestList);
			}
        }
        function exportToFile(fileType){

    		var from=DateUtils.convertLocalDateToServer(vm.fromDate);
    		var to=DateUtils.convertLocalDateToServer(vm.toDate);
    		vm.baseString =  'Customer_OnBoarding_Exception_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');
      	  if( vm.customerOnBoardingDetails !=null &&  vm.customerOnBoardingDetails!=undefined){
      		  if(fileType == 'csv'){
      			  vm.mimeType = 'text/csv'
      			  vm.baseString = vm.baseString+ ".csv";
           		CustomerOnBoardingExceptionReport.exportCSVData({"from":from,"to":to},vm.customerOnBoardingDetails ,onGenerateSuccess);
      		  }else if(fileType == 'excel'){
      			  vm.mimeType = 'application/vnd.ms-excel';
      			  vm.baseString = vm.baseString+ ".xls"; 
      			CustomerOnBoardingExceptionReport.exportExcelData({"from":from,"to":to},vm.customerOnBoardingDetails ,onGenerateSuccess);
      		  }
      	  }
        }
      	  
        function onGenerateSuccess(result){
        	
			  var fileData = result.data;
 			  
 			  var IEfile= new Blob([result.data], {type: vm.mimeType});
			      if(window.navigator.msSaveOrOpenBlob) {
			    	 window.navigator.msSaveOrOpenBlob(IEfile, vm.baseString );
			      }
			      else
			    	  {
	     			  var link = document.createElement("a");   
	     			  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
	     			  
	 			      //var data = btoa(String.fromCharCode.apply(null, bytes)); // get data string from binary array			     
	     		   	  //link.href = 'data:'+mimeType+';base64,'+ encodeURI(data);
	     			  
	 			      var blob = new Blob([bytes], {type: vm.mimeType});
	 			      link.href =  window.URL.createObjectURL(blob);
	 			      
	 			   
	 			      
	     		   	  link.download = vm.baseString;
	     		   	  document.body.appendChild(link);
	     		   	  link.click();
	     			  document.body.removeChild(link);
			    	  }
      	}
        
        vm.getAddress = function getAddress(address1, address2){
        	var address = '-';
        	if(address1!=null && address1!=undefined && address1!=''){
        		address = address1;
        	}
        	if(address2!=null && address2!=undefined && address2!=''){
        		address = address + ', ' + address2;
        	}
        	return address;
        }
        
        vm.getMobile = function getMobile(mobile, mobileCountryCode){
        	var mobileNo = '-';
        	if(mobile!=null && mobile!=undefined && mobile!=''){
        		mobileNo = mobile;
        		if(mobileCountryCode!=null && mobileCountryCode!=undefined && mobileCountryCode!=''){
        			mobileNo = mobileCountryCode + '-' + mobile;
        		}
        	}
        	return mobileNo;
        }

		vm.openCustomerView = function(customerOnBoardingDetail){

    		var encryptedKey = CryptoUtil.encrypt(customerOnBoardingDetail.activationKey,GlobalValues.getPlatformENCCode());

    		vm.screenLog.screenLog(
        	vm.screenName,
        	customerOnBoardingDetail.id,
        	vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS
    		);

    		$state.go('customer-onboarding-view', {
        		id: encryptedKey,
        		theme: 'dark'
    		});	
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-info-change-status', {
            parent: 'entity',
            url: '/customer-info-change-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.customer.customerInfoChangeStatus" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-info-change-status/customer-info-change-status.html',
                    controller: 'CustomerInfoChangeStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('error');
                	$translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('CustomerInfoChangeStatus');
                    $translatePartialLoader.addPart('customer-registration');
                    return $translate.refresh();
                }],
                entity: function(){
                	
                }
            }
        })
       
       };
    })();
(function() {
	'use strict';
	angular.module('gatewayApp').factory('CustomerInfoChange', CustomerInfoChange);

	CustomerInfoChange.$inject = [ '$resource' ];

	function CustomerInfoChange($resource) {
		var resourceUrl = 'api/customer-info/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'getCustomers' : {
				method : 'GET',
				isArray : true,
				params : {
					orgId : '@orgId'
				},
				url : 'api/customer-info-status/orgId/:orgId',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},

			
			'discard' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/multitask/discard'
			},
			 
			'resubmitCustomer' : {
				method : 'PUT',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/resubmitForCreate/bank',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'getAllTasksForCustomersBasedOnReference' : {
				method : 'GET',
				isArray : true,
				params : {
					orgId : '@orgId',
					reference: '@reference'
				},
				url : 'api/allTasks/customer-info-status/orgId/:orgId/reference/:reference',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},

			

		});
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function() {
            this.viewFrom = ''
        })
        .controller('CustomerInfoChangeStatusController', CustomerInfoChangeStatusController);

    CustomerInfoChangeStatusController.$inject = ['$scope', '$timeout', '$state', '$stateParams', 'workflowSharedService', 'CustomerInfoChange', '$rootScope', 'GlobalValues', 'Workflow', '$filter', 'ScreenLog','MessageBox','entityConstants'];

    function CustomerInfoChangeStatusController($scope, $timeout, $state, $stateParams, workflowSharedService, CustomerInfoChange, $rootScope, GlobalValues, Workflow, $filter, ScreenLog, MessageBox,entityConstants) {
        var vm = this;
        vm.screenLog = ScreenLog;
        vm.tasks = [];
        vm.getTasks = [];
        vm.resubmitEntity=resubmitEntity;
        vm.viewEntity = viewEntity;
        vm.discardEntity = discardEntity;
        
        vm.globalValues=GlobalValues;
        
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMER;
        
        logScreenAccess();
        loadAll();
       

        function loadAll() {
        	 //vm.rejectedCount = 0;
             //vm.enableFields = false;
            
        	CustomerInfoChange.getCustomers({ "orgId": GlobalValues.getOrgId() }, function(result) {
                vm.fetchedTasks = result;
                vm.tasks = [];
                angular.forEach(vm.fetchedTasks, function(task) {
                	task.changeType = getChangeType(task);
                    vm.tasks.push(task);
                });
               
                vm.discardProcessed = true;
            });
        }

       
        
        function discardEntity(entityList) {
            
        	$scope.rowID = entityList.id;
        	vm.discardProcessed = false;
        	vm.screenLog.screenLog(entityList.entity.shortName, entityList.entityRecordID==null?0:entityList.entityRecordID, entityConstants.ENTITY_ACTION_TYPE.DISCARD);
            MessageBox.openMessageBox("Alert", "Do you want to withdraw your customer info change?", "ProceedCancel", "withdrawcustomerchange");
            //ScreenLog.screenLog({'entityName': entityList.entity.shortName, 'entityRecordId': entityList.entityRecordID==null?0:entityList.entityRecordID, 'action': 'DISCARD'});
        }
        
        $rootScope.$on('gatewayApp.messagebox.proceed.withdrawcustomerchange', function (event, data) {
        	
        	if($state.current.name == 'customer-info-change-status' && $scope.rowID!=undefined && !vm.discardProcessed){
        		
        		vm.discardProcessed = true;
                CustomerInfoChange.discard({ "taskId": $scope.rowID }, onDiscardSuccess, onDiscardError).$promise.then(function (){ } );
               
        	}

        });
		
		$rootScope.$on('gatewayApp.messagebox.cancel.withdrawcustomerchange', function (event, data) {
			if($state.current.name == 'customer-info-change-status'){
				vm.discardProcessed = true;
			}
    	});
        
       

        function onDiscardSuccess(result) {
            $rootScope.removeRow($scope.rowID);
            $scope.rowID = undefined;
            vm.discardProcessed=true;
            $state.go('customer-info-change-status', null, { reload: 'customer-info-change-status' });
        }

        function onDiscardError(error) {
        	vm.discardProcessed = true;
        }
        
        function viewEntity(entity,id,payload,action,changeType, recordId){
            $rootScope.payload = payload;
            $rootScope.taskID = id;
            vm.screenLog.screenLog(entity, recordId==null?0:recordId, entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS);
            workflowSharedService.viewFrom ='customerregistrationtodolist_maker';
            var state = 'customer-info-status-view';
            $state.go(state);
        }
        
        function resubmitEntity(entity,id,payload,changeType ,reference, recordId){
            $rootScope.payload = payload;
            $rootScope.taskID = id;
            var rejectedCount = 0;
            var enableFields = false;
            //vm.screenLog.screenLog(entity, recordId==null?0:recordId, entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
            workflowSharedService.viewFrom = 'customerregistrationtodolist_resubmit' ;
            var state = 'customer-info-status-view';
            // Get active and inactive tasks with same payload
            angular.forEach(vm.tasks, function(task){
            	if(task.changeType == 'Rejected' ){
            		rejectedCount =  rejectedCount+1;
            	}
            });
            CustomerInfoChange.getAllTasksForCustomersBasedOnReference({"orgId": GlobalValues.getOrgId() ,"reference" : reference},function(result){
            	vm.allTasks = result;
            	if(vm.allTasks!=null && vm.allTasks!=undefined && vm.allTasks.length == rejectedCount){
                	enableFields = true;
            	}
            	$state.params = {enableFields:enableFields}
            	$state.go(state);
            }, function(error){
            	$state.params = {enableFields:enableFields}
            	$state.go(state);
            });
            
        }
       
        
    	function getChangeType(task){
    		if(task.changeType == 'CREATE' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Added';
    		}
    		
    		else if(task.taskHistory[task.taskHistory.length - 1].action == 'REJECTED'){
    			//vm.rejectedCount =  vm.rejectedCount+1;
    			return 'Rejected';
    		}
    		
    	}
    	
        $rootScope.removeRow = function(id) {
            var index = -1;
            var comArr = eval(vm.tasks);
            for (var i = 0; i < comArr.length; i++) {
                if (comArr[i].id === id) {
                    index = i;
                    break;
                }
            }
            if (index === -1) {
               // alert("Something gone wrong");
            }
            vm.tasks.splice(index, 1);
        };

        $scope.toggle = true;
        $scope.refresh = function() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };

        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CustomerChargesEditController', CustomerChargesEditController);

    CustomerChargesEditController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','CustomerCharges','entity','DateUtils','Workflow'];

     function CustomerChargesEditController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,CustomerCharges,entity,DateUtils,Workflow) {
        var vm = this;
        vm.customerCharge=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        $scope.showApproveRejectButton=false;
        $scope.showDiscardButton = false;
    	$scope.showResubmitButton=false;
        vm.resubmitCustomerCharges = resubmitCustomerCharges;
        vm.globalValues = GlobalValues;
        vm.discardCustomerCharges = discardCustomerCharges;
        vm.rejectCustomerCharges= rejectCustomerCharges;
        vm.approveCustomerCharges= approveCustomerCharges;
        vm.viewMode=false;
        //vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.decimalsForPercent = 4;
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        
        $scope.showButton = false;
        vm.orgId = vm.globalValues.getOrgId();
        var systemSettings = vm.globalValues.getSystemSettings();
      
           
        if(workflowSharedService.viewFrom == 'customerCharges'){
        	vm.customerCharge=entity;
        	$scope.showButton = true;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'customerChargestodolist_resubmit') {
        	vm.customerCharge =  angular.fromJson($rootScope.payload);
        	
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=true;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'customerCharges_todolist_checker') {
        	vm.customerCharge =  angular.fromJson($rootScope.payload); 
        
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = true;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom == 'customerCharges_todolist_maker') {
        	vm.customerCharge =  angular.fromJson($rootScope.payload); 
        	
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = true;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom=='customerCharges_auditlog'){
        	vm.customerCharge =  angular.fromJson($rootScope.payload); 
        
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
        else if(workflowSharedService.viewFrom=='customer_charges_import_auditlog'){
        	
        	vm.customerCharge =  angular.fromJson($rootScope.payload);   
        	vm.customerCharge = vm.customerCharge.customerCharges;
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
		

        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	
        	vm.customerCharge.effectiveFrom = DateUtils.convertLocalDateToServer(systemSettings.businessDate);
        	
        	
        	if (vm.customerCharge.id != null) {
				CustomerCharges.update({
					"orgId" : GlobalValues.getOrgId()
				}, vm.customerCharge, onSaveSuccess, onSaveError);
			} else {
				CustomerCharges.save({
					"orgId" : GlobalValues.getOrgId()
				}, vm.customerCharge, onSaveSuccess, onSaveError);
			}
        	
         }
      
       
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	
        	vm.clicked = false;
        }
        function resubmitCustomerCharges() {
        	
        	vm.customerCharge.effectiveFrom = DateUtils.convertLocalDateToServer(systemSettings.businessDate);
        	
        	
        	CustomerCharges.resubmit({"taskId" : $rootScope.taskID}, vm.customerCharge, onResubmitSuccess, onResubmitError);
        	
       		
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {
        	vm.clicked = false;
        }
        
        function approveCustomerCharges() { 
        	CustomerCharges.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectCustomerCharges() { Workflow.rejectTask($rootScope.taskID); }

        function discardCustomerCharges() {
        	CustomerCharges.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }
        
        

       
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-charges', {
            parent: 'entity',
            url: '/customer-charges',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.customerCharges.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-charges/customer-charges.html',
                    controller: 'CustomerChargesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerCharges');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
       
        .state('customer-charges-new', {
            parent: 'customer-charges',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-charges/customer-charges-dialog.html',
                    controller: 'CustomerChargesEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	                           	
                             
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('customer-charges-edit', {
            parent: 'customer-charges',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-charges/customer-charges-dialog.html',
                    controller: 'CustomerChargesEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['CustomerCharges', 'GlobalValues', function(CustomerCharges, GlobalValues) {
                                     return CustomerCharges.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('customer-charges-todolist', {
            parent: 'dashboard',
            url: '/customerCharges',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-charges/customer-charges-dialog.html',
                    controller: 'CustomerChargesEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('customer-charges', null, { reload: 'customer-charges' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('customer-charges-todolist-resubmit', {
            parent: 'dashboard',
            url: '/customerChargesEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-charges/customer-charges-dialog.html',
                    controller: 'CustomerChargesEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('customer-charges', null, { reload: 'customer-charges' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('customer-charges-auditLog', {
            parent: 'audit-log',
            url: '/CustomerChargesAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-charges/customer-charges-dialog.html',
                    controller: 'CustomerChargesEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('customer-charges', null, { reload: 'customer-charges' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('customer-charges-historyReport', {
            parent: 'history-report',
            url: '/customerChargesHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-charges/customer-charges-dialog.html',
                    controller: 'CustomerChargesEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('customer-charges', null, { reload: 'customer-charges' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('CustomerCharges', CustomerCharges);

    CustomerCharges.$inject = ['$resource'];

    function CustomerCharges ($resource) {
        var resourceUrl =  'api/customer-charges/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/customer-charges'
        	 },
         	
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
             'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/customer-charges/orgId/:orgId',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
        	
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/customer-charges/orgId/:orgId',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/customer-charges',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'customerCharges'
        })
        
        .controller('CustomerChargesController', CustomerChargesController);

    CustomerChargesController.$inject = ['$scope', '$state', 'CustomerCharges', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout'];

    function CustomerChargesController($scope, $state, CustomerCharges , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout) {
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMER_CHARGES;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "customerCharges";
        $scope.refresh=refresh;
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
     //   vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.decimalsForPercent = 4;
        
        vm.launch=launch;
        function launch() {
        	$state.go("customer-charges-new");
        }
        
        
        vm.permitCustomerChargesAddEntityAction = EntityPermissions.hasPermission('CustomerCharges.CREATE');
        vm.permitCustomerChargesImportEntityAction = EntityPermissions.hasPermission('CustomerCharges.IMPORT');
        vm.permitCustomerChargesEditEntityAction = EntityPermissions.hasPermission('CustomerCharges.EDIT');
        
        logScreenAccess();
        loadAll();

       function loadAll() {
    	   
    	   CustomerCharges.query(function(result) {
               vm.customerCharges = result;                
           });
    	 
        }      
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CustomerTradingBankDialogController', CustomerTradingBankDialogController);

    CustomerTradingBankDialogController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance',
    'CustomerBankRelationshipReport','entity','Branch', 'TACViewForEntitiesService', 'TacViewForEntitiesUtility'];

     function CustomerTradingBankDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,
     	CustomerBankRelationshipReport,entity,Branch, TACViewForEntitiesService, TacViewForEntitiesUtility) {
        var vm = this;
        vm.tradingBank=entity; 
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        vm.globalValues = GlobalValues;
        vm.clearcorpOrgId = 1;
        vm.clearcorpForCustomerTACTypeId = 1;
        vm.bankForCustomerTACTypeId = 3;
        vm.previewClearcorpTAC = previewClearcorpTAC;
        vm.previewBankTAC = previewBankTAC;
        getClearcorpTACMaster();
        vm.tradingBank.assignTradingBranch = true;
        $scope.showButton = false;
       
        $scope.$watch('vm.tradingBank.homeBranch', function(value){
        	if(value!=null&&value!=undefined){
        		vm.tradingBranchAddress = value.address;
        	}
        });
                
        if(workflowSharedService.viewFrom == 'tradingBank'){
        	vm.tradingBank=entity;
       	 	$scope.showButton=false;
        }
        
		
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	vm.tradingBank.branchAddress = vm.tradingBranchAddress;

            //update clearcorp TAC and bank TAC in cust reg.request in order to update tacForCustomerRequested
            if(vm.clearcorpTAC!=null && vm.clearcorpTAC.id!=null){
                vm.tradingBank.clearcorpTAC = vm.clearcorpTAC;
            }
            if(vm.bankTAC!=null && vm.bankTAC.id!=null){
                vm.tradingBank.bankTAC = vm.bankTAC;
            }
        	
        	CustomerBankRelationshipReport.save({ "customerId": GlobalValues.getOrgId() },vm.tradingBank, onSaveSuccess, onSaveError);           
         	
         }
      
       
     
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	vm.clicked = false;
        }
        
        function getClearcorpTACMaster(){
            TACViewForEntitiesService.getActiveTACForOrganisationAndTacType({orgId: vm.clearcorpOrgId, tacTypeId: vm.clearcorpForCustomerTACTypeId}, function(result){
                vm.clearcorpTAC = result;
            })
        }

		$scope.$watch('vm.tradingBank.bank', function(value){
			if(value!=null && value!='' && value!=undefined){
				//var bankName = value.bankName;
				//bankName = bankName.substring(0, 5); // mantis issue fix: 20
				vm.filterText = value.ccpMembershipId;
			}
		})
		
		$scope.$watch('vm.tradingBank.assignTradingBranch', function(value){
	    	  if(value!=null && value!=undefined){
	    		  if(value){
	    			  if(vm.tradingBank.tradingBranch!=null){
	    				  vm.tradingBank.tradingBranch = null;
	    			  }
	    			  vm.disableTradingBranch = true;
	    			  //vm.tradingBranchRequired = false;
	    		  }else{
	    			  vm.disableTradingBranch = false;
	    			 // vm.tradingBranchRequired = true;
	    		  }
	    	  }
	    })
	      
	    $scope.$watch('vm.tradingBank.bank', function(value){
	    	if(value!=null && value!=undefined){
	    		// Branch.getValidBranchDetailsForBank({bankId: value.id}, function(result){
	    		// 	if(result!=null && (result.length>1 || result.length==0)){
	    		// 		vm.tradingBank.assignTradingBranch = true;
	    		// 	}
				// 	// else{
	    		// 	// 	//vm.tradingBank.assignTradingBranch = false;
	    		// 	// 	//$scope.tradingBankForm.$setValidity('txttradingBranchachrequired', true);
	    		// 	// }
	    		// })

				TACViewForEntitiesService.getActiveTACForOrganisationAndTacType({orgId: value.id, tacTypeId: vm.bankForCustomerTACTypeId}, function(result){
					if(result!=null && result.tacFiles!=null){
						vm.bankTAC = result;    
					}else{
						vm.bankTAC = null;
					}
				})
	    	}else{
	    		 // vm.tradingBank.assignTradingBranch = false;
	    		  vm.bankTAC = null;
	    	}
	    })

		function previewClearcorpTAC(){
			if(vm.clearcorpTAC!=null && vm.clearcorpTAC!=undefined){
			    TacViewForEntitiesUtility.previewTAC(vm.clearcorpTAC.tacFiles.fileContent, vm.clearcorpTAC.tacFiles.fileName);    
			}
		}

		function previewBankTAC(){
			if(vm.bankTAC!=null && vm.bankTAC!=undefined){
			    TacViewForEntitiesUtility.previewTAC(vm.bankTAC.tacFiles.fileContent, vm.bankTAC.tacFiles.fileName);    
			}
		}
	  
       
     }   
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('CustomerBankRelationshipReport', CustomerBankRelationshipReport);

    CustomerBankRelationshipReport.$inject = ['$resource'];

    function CustomerBankRelationshipReport ($resource) {
        var resourceUrl =  'api/customer-bank-relationship-report/:id';

        return $resource(resourceUrl, {}, {
            
        	'query': { method: 'GET', isArray: true,
        	    url: 'api/all-trading-banks'
        	 },
            
            'getCustomerTradingBanks':{
            	 
            	isArray:true,
 				method: 'GET',
 				url: 'api/trading-bank-for-customer/:customerId/customer'
             },
             
             'getPendingAndRejected':{
            	 
             	isArray:true,
  				method: 'GET',
  				url: 'api/pending-rejected-request-for-customer/:customerId/customer'
              },
              'save' : {
  				method : 'POST',
  				params : {
  					customerId : '@customerId'
  				},
  				url : 'api/add-trading-bank/:customerId/customerId',
  				transformRequest : function(data) {
  					var copy = angular.copy(data);
  					return angular.toJson(copy);
  				}
  			},
			'delete' : {
				method : 'POST',
				params : {
					customerTradingBankDetailsId : '@customerTradingBankDetailsId',
					customerId:'@customerId'
				},
				url : 'api/delete-trading-bank/:customerTradingBankDetailsId/customer-trading-bank/:customerId/customerId'
			},
			'discard' : {
				method : 'GET',
				params : {
					requestId : '@requestId'
				},
				url : 'api/public/customer-onboarding-withdraw/:requestId'
			},
            'getTradingBanksForCustomer':{
           	 
            	isArray:true,
 				method: 'GET',
 				url: 'api/trading-bank-list-for-customer/:customerId/customer'
             },
             'getTradingBranchForCustomerAndBank':{
               	 
             	isArray:false,
  				method: 'GET',
  				url: 'api/trading-branch-for-customer-bank/:customerId/customer/:bankId/bank',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
              },
              'getValidTradingBranchForCustomerAndBank':{
                	 
               	isArray:false,
    				method: 'GET',
    				url: 'api/valid-trading-branch-for-customer-bank/:customerId/customer/:bankId/bank',
                  transformResponse: function (data) {
                      if (data) {
                          data = angular.fromJson(data);
                      }
                      return data;
                  }
                },
			'close' : {
				method : 'GET',
				params : {
					id : '@id'
				},
				url : 'api/customer-rejection-close/:id'
			},
			'getTradingBanksAllStatusForCustomer':{
	           	 
            	isArray:true,
 				method: 'GET',
 				url: 'api/trading-bank-list-all-status-for-customer/:customerId/customer'
             },
             
			 'excelCustomerBankRelationshipReport':{
				    method: 'POST',
	  				params : {
	  					customerId : '@customerId'
	  				},
	                url: 'api/customer-tradingbank-details/excel/:customerId/customer',
	                responseType: 'arraybuffer',
	                transformResponse: function(data, headers) {
	              	  return {
	                        data: data,
	                        headers: headers
	                    };   
	                } 
				},
				
				'csvCustomerBankRelationshipReport':{
					    method: 'POST',
		  				params : {
		  					customerId : '@customerId'
		  				},
		                url: 'api/customer-tradingbank-details/csv/:customerId/customer',
		                responseType: 'arraybuffer',
		                transformResponse: function(data, headers) {
		              	  return {
		                        data: data,
		                        headers: headers
		                    };   
		                } 
				},
				'getAllNonTerminatedCustomers':{
			           	 
			            	isArray:true,
			 				method: 'GET',
			 				params : {
			  					bankId : '@bankId',
			  					branchId : '@branchId'
			  				},
			 				url: 'api/all-customers-non-terminated'
			     },
			     'getAllNonPropNonTerminatedCustomers':{
			               	 
			             	isArray:true,
			  				method: 'GET',
			  				params : {
			  					bankId : '@bankId',
			  					branchId : '@branchId'
			  				},
			  				url: 'api/customers-non-prop-non-terminated'
			      },       
			      'getAllNonTerminatedNonSuspendedCustomers':{
              	 
			            	isArray:true,
			            	method: 'GET',
			            	params : {
				  					bankId : '@bankId',
				  					branchId : '@branchId'
			            	},
			            	url: 'api/all-customers-non-terminated-non-suspended'
			       },

				   'getBankCurrencyPairConfiguration': {
					         method: 'GET',
							 isArray: true,
        	                 url: 'api/get-bank-currency-pair-configuration'
        	       },

				   'getApplicableInstruments': {
					         method: 'GET',
							 isArray: true,
        	                 url: 'api/get-applicable-instruments'
        	       }
			
              
            
             });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CustomerBankRelationshipReportController', CustomerBankRelationshipReportController);

    CustomerBankRelationshipReportController.$inject = ['$scope', '$state', 'workflowSharedService','GlobalValues','CustomerBankRelationshipReport','UserProfile','EntityPermissions','$filter', 'entity','ScreenLog', '$rootScope', 'MessageBox', 'entityConstants','$timeout', 'CustomerTradingBankDetails', 'TacViewForEntitiesUtility', 'TACViewForEntitiesService', 'agreedTACList'];

    function CustomerBankRelationshipReportController($scope, $state,  workflowSharedService,  GlobalValues, CustomerBankRelationshipReport, UserProfile,EntityPermissions,$filter, entity,ScreenLog, $rootScope, MessageBox , entityConstants,$timeout, CustomerTradingBankDetails, TacViewForEntitiesUtility, TACViewForEntitiesService, agreedTACList) {
        var vm = this;
        vm.globalValues = GlobalValues;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        $scope.noOfRecordsPerPage1 = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page1 = 1;
        $scope.noOfRecordsPerPage2 = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page2 = 1;
        vm.screenLog=ScreenLog;
        vm.userBank=vm.globalValues.getCustomerId;
        vm.deleteRelationship=deleteRelationship;
        vm.withdrawRequest=withdrawRequest;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.TRADING_BANK_LIST
        vm.close=close;
        $scope.refresh=refresh;
        vm.exportToFile=exportToFile;
        vm.openAnnexure2=openAnnexure2;
        var yesMessageEvent = null;
        vm.mimeType= '';
  	  	vm.baseString = 'Trading_Bank_List_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');

  	    var tacAnnexurefilename = "FX-Retail Registration with T&C_";

        vm.organisation = vm.globalValues.getOrganisation();
        vm.clearcorpOrgId = 1;
        vm.agreedTacList = agreedTACList;
        // getClearcorpTACAgreed();

        vm.permitCustomerBankRelationshipAddEntityAction = EntityPermissions.hasPermission('TradingBankList.ADD')
        vm.permitCustomerBankRelationshipRemoveEntityAction = EntityPermissions.hasPermission('TradingBankList.REMOVE')
		vm.permitCustomerBankRelationshipWithdrawEntityAction = EntityPermissions.hasPermission('TradingBankList.WITHDRAW')


        loadAll();

        function getClearcorpTACAgreed(){
            if(vm.agreedTacList!=null && vm.agreedTacList!=undefined && vm.agreedTacList.length>0){
                vm.clearcorpTAC = _.filter(angular.copy(vm.agreedTacList), { 'tacProviderId': vm.clearcorpOrgId });
                if(vm.clearcorpTAC!=null && vm.clearcorpTAC!=undefined && vm.clearcorpTAC.length>0){
                    vm.isClearcorpTACAgreed = vm.clearcorpTAC[0].isAgreed;
                }
            }
        }

        vm.launch=launch;
        function launch() {
            // if(vm.isClearcorpTACAgreed!=null && vm.isClearcorpTACAgreed!=undefined && angular.lowercase(vm.isClearcorpTACAgreed)=='yes'){
            //     $state.go("trading-bank-create");
            // }else{
            //     MessageBox.openMessageBox("Alert", $filter('translate')('gatewayApp.BankRelationship.agreeClearcorpRevisedTAC'), "Ok", "customerbankrelationship");
            // }
            $state.go("trading-bank-create");
        }

        logScreenAccess();
        //Get customer trading bank details and customer registration request details for customer id

        function loadAll() {
        	CustomerBankRelationshipReport.getCustomerTradingBanks({"customerId":vm.globalValues.getOrgId()},onGetCustomerTradingBanksSuccess,onGetCustomerTradingBanksError);

        	CustomerBankRelationshipReport.getPendingAndRejected({"customerId":vm.globalValues.getOrgId()},onGetCustomerPendingSuccess,onGetCustomerPendingError);

        	UserProfile.get({"userId" : vm.globalValues.getUser().id}, onGetUserProfileSuccess, onGetUserProfileError);



        }

        function onGetCustomerTradingBanksSuccess(result)
        {
            vm.tradingBanks=result;
        }


        function onGetCustomerTradingBanksError()
        {

        }

        function onGetCustomerPendingSuccess(result)
        {
        	vm.pendingAndRejectedBanks=result;

        }


        function onGetCustomerPendingError()
        {

        }

        function onGetUserProfileSuccess(result){
			vm.userprofile = result;
			vm.customerBank=vm.userprofile.userTradingBank;


        }

        function onGetUserProfileError(){

        }

        //delete customer trading bank relationship

        function deleteRelationship(id){
            $scope.deleteRequestId = id;
            MessageBox.openMessageBox("Alert", "Are you sure to delete this bank relationship?", "YesNo", "deletebankrelationship");
            //CustomerBankRelationshipReport.delete({"customerTradingBankDetailsId":id,"customerId":vm.globalValues.getOrgId()},onDeleteCustomerTradingBankSuccess,onDeleteCustomerTradingBankError);
        }

        yesMessageEvent = $rootScope.$on('gatewayApp.messagebox.yes.deletebankrelationship', function (event, data) {
            if($scope.deleteRequestId!=undefined){
                CustomerBankRelationshipReport.delete({"customerTradingBankDetailsId":$scope.deleteRequestId,"customerId":vm.globalValues.getOrgId()},onDeleteCustomerTradingBankSuccess,onDeleteCustomerTradingBankError);


        	}
        });

        $scope.$on('$destroy', function() {
  		  if (yesMessageEvent!=null )
  			  	yesMessageEvent();
	        });


		$rootScope.$on('gatewayApp.messagebox.no.deletebankrelationship', function (event, data) {
			//do nothing
    	});


        function onDeleteCustomerTradingBankSuccess(){
            $scope.deleteRequestId = undefined;
            $state.go('customer-bank-relationship-report', null, { reload: 'customer-bank-relationship-report' });
        }

        function onDeleteCustomerTradingBankError(){
            $scope.deleteRequestId = undefined;
        }

        //withdraw registration request

        function withdrawRequest(id){
            $scope.requestId = id;
            MessageBox.openMessageBox("Alert", "Do you want to withdraw your bank relationship request?", "YesNo", "withdrawbankrelationrequest");
            //CustomerBankRelationshipReport.discard({"requestId": id},onWithdrawTradingBankSuccess,onWithdrawTradingBankError);
        }

        $rootScope.$on('gatewayApp.messagebox.yes.withdrawbankrelationrequest', function (event, data) {
            if($scope.requestId!=undefined){
                CustomerBankRelationshipReport.discard({"requestId": $scope.requestId},onWithdrawTradingBankSuccess,onWithdrawTradingBankError);
            }
        });

		$rootScope.$on('gatewayApp.messagebox.no.withdrawbankrelationrequest', function (event, data) {
			//do nothing
    	});

        function onWithdrawTradingBankSuccess(){
        	$scope.requestId = undefined;
        	$state.go('customer-bank-relationship-report', null, { reload: 'customer-bank-relationship-report' });

        }

        function onWithdrawTradingBankError(){
            $scope.requestId = undefined;
        }

        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }

        function close(id){
            CustomerBankRelationshipReport.close({"id": id},onCloseSuccess,onCloseError);
        }

        function onCloseSuccess(){
            $state.go('customer-bank-relationship-report', null, { reload: 'customer-bank-relationship-report' });
        }

        function onCloseError(){

        }

        function exportToFile(fileType){

        	vm.baseString = 'Trading_Bank_List_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');
       	  if(( vm.tradingBanks !=null &&  vm.tradingBanks!=undefined) || (vm.pendingAndRejectedBanks !=null &&  vm.pendingAndRejectedBanks!=undefined) ){
       		  if(fileType == 'csv'){
       			  vm.mimeType = 'text/csv'
       			  vm.baseString = vm.baseString+ ".csv";
       			CustomerBankRelationshipReport.csvCustomerBankRelationshipReport({"customerId":vm.globalValues.getOrgId()},onGenerateSuccess);
       		  }else if(fileType == 'excel'){
       			  vm.mimeType = 'application/vnd.ms-excel';
       			  vm.baseString = vm.baseString+ ".xls";

       			CustomerBankRelationshipReport.excelCustomerBankRelationshipReport({"customerId":vm.globalValues.getOrgId()},onGenerateSuccess);
       		  }
       	  }
        }
        function onGenerateSuccess(result){

 			  var fileData = result.data;

   			  var IEfile= new Blob([result.data], {type: vm.mimeType});
 			      if(window.navigator.msSaveOrOpenBlob) {
 			    	 window.navigator.msSaveOrOpenBlob(IEfile, vm.baseString );
 			      }
 			      else
 			    	  {
 	     			  var link = document.createElement("a");
 	     			  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer

 	 			      //var data = btoa(String.fromCharCode.apply(null, bytes)); // get data string from binary array
 	     		   	  //link.href = 'data:'+mimeType+';base64,'+ encodeURI(data);

 	 			      var blob = new Blob([bytes], {type: vm.mimeType});
 	 			      link.href =  window.URL.createObjectURL(blob);



 	     		   	  link.download = vm.baseString;
 	     		   	  document.body.appendChild(link);
 	     		   	  link.click();
 	     			  document.body.removeChild(link);
 			    	  }
        	}




        $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };

        $scope.customFilter = function customFilter(pendingAndRejectedBank){
            return (pendingAndRejectedBank.customerBankRelationshipStatus.shortName=='PENDINGAPPROVAL');
        }

        $scope.customFilter1 = function customFilter1(pendingAndRejectedBank){
            return (pendingAndRejectedBank.customerBankRelationshipStatus.shortName=='REJECTED');
        }

        function openAnnexure2(customerTradingBankDetailsId){
            CustomerTradingBankDetails.getAnnexure2ForCustomerBankRelationship({customerTradinBankDetailsId: customerTradingBankDetailsId}, onGetAnnexure2Success, onGetAnnexure2Failure);
        }

        function onGetAnnexure2Success(result){
            TacViewForEntitiesUtility.downloadTACForArray(result.data, tacAnnexurefilename + moment().format( 'DD_MMM_YYYY_HH_mm') + '.pdf' );
        }

        function onGetAnnexure2Failure(){
            //do nothing
        }

     }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-bank-relationship-report', {
            parent: 'entity',
            params:{screen:'TradingBankList'},
            url: '/customer-bank-relationship-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.customer.customerBankRelationshipReport" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-bank-relationship-report/customer-bank-relationship-report.html',
                    controller: 'CustomerBankRelationshipReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('customerBankRelationshipReport');
                    $translatePartialLoader.addPart('customer-registration');
                    return $translate.refresh();
                }],
                entity: function(){
                	
                },
                agreedTACList: ['TACViewForEntitiesService', 'GlobalValues', function(TACViewForEntitiesService, GlobalValues) {
                    return TACViewForEntitiesService.getTacAgreedDetailsForGivenCustomer({"customerId" : GlobalValues.getOrganisation().id}).$promise;
                }]
            }
        })
        .state('trading-bank-create', {
            parent: 'customer-bank-relationship-report',
            url: '/trading-bank',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-bank-relationship-report/customer-trading-bank-dialog.html',
                    controller: 'CustomerTradingBankDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	    
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer-bank-relationship-report', null, { reload: 'customer-bank-relationship-report' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
       
       };
    })();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('CurrencyPair', CurrencyPair);

    CurrencyPair.$inject = ['$resource'];

    function CurrencyPair ($resource) {
        var resourceUrl =  'api/currencyPair/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CreditFactorSettingsDialogController', CreditFactorSettingsDialogController);

    CreditFactorSettingsDialogController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues',
    	'workflowSharedService','$uibModalInstance','CreditFactorSettings','entity','DateUtils',
        'Workflow', 'AlertService', '$filter', 'DealingAdminApplicationWideSettings'];

     function CreditFactorSettingsDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService, 
    		 $uibModalInstance,CreditFactorSettings,entity,DateUtils,
             Workflow, AlertService, $filter, DealingAdminApplicationWideSettings) {
        var vm = this;
        vm.creditFactorSettingsHeader=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        $scope.showApproveRejectButton=false;
        $scope.showDiscardButton = false;
    	$scope.showResubmitButton=false;
        vm.resubmitCreditFactorSettings = resubmitCreditFactorSettings;
        vm.globalValues = GlobalValues;
        vm.discardCreditFactorSettings = discardCreditFactorSettings;
        vm.rejectCreditFactorSettings= rejectCreditFactorSettings;
        vm.approveCreditFactorSettings= approveCreditFactorSettings;
        vm.viewMode=false;
        vm.showEffectiveFrom=false;
        vm.addCreditFactorSettings = addCreditFactorSettings;
        vm.editCreditFactorSettings = editCreditFactorSettings;
        vm.removeCreditFactorSettings = removeCreditFactorSettings;
        vm.resetCreditFactorSettings = resetCreditFactorSettings;
        vm.noOfDecimals = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.noOfDecimalsForPercent = 2;
        
        $scope.showButton = false;
        vm.orgId = vm.globalValues.getOrgId();
        vm.creditFactorSettingsDetailsList = [];
        vm.noOfDecimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.newCreditFactor = { tenorFrom : 1, tenorTo : null, creditFactor : null, editable : true, valid: false}

        loadTenorType();
        loadConfigurationSettings();
        
        function loadTenorType(){
            vm.tenorTypeList = ['Days', 'Months'];
        }

        function loadConfigurationSettings(){
             //load configuration settings to validate maximum tenor value 
             //get confing settings - no. of active days for standard tenor
            DealingAdminApplicationWideSettings.getConfigValueForConfigName({configName: 'NoOfActiveDaysForStandardTenor'}, function(result){
                vm.noOfActiveDaysForStandardTenor = result.value;
            })

            //get confing settings - no. of active months for standard tenor
            DealingAdminApplicationWideSettings.getConfigValueForConfigName({configName: 'NoOfActiveMonthsForStandardTenor'}, function(result){
                vm.noOfActiveMonthsForStandardTenor = result.value;
            })
            
        }

        if(workflowSharedService.viewFrom == 'creditFactorSettings'){
    		vm.creditFactorSettingsDetailsList.push(angular.copy(vm.newCreditFactor));
			if (entity != null && entity != undefined && entity.creditFactorSettingsDetailsList != null && entity.creditFactorSettingsDetailsList != undefined
					&& entity.creditFactorSettingsDetailsList.length > 0) {
				vm.creditFactorSettingsHeader = entity;
				setValidForExistingCreditFactorSlabs();
				prepareNewCreditFactorSettings(vm.creditFactorSettingsHeader.creditFactorSettingsDetailsList);
				vm.creditFactorSettingsHeader.creditFactorSettingsDetailsList.push(angular.copy(vm.newCreditFactor));
				vm.creditFactorSettingsDetailsList = angular.copy(vm.creditFactorSettingsHeader.creditFactorSettingsDetailsList);
			}
        	$scope.showButton = true;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	vm.viewMode=false;
        	$scope.DisabledControl = false;
        }
        else if(workflowSharedService.viewFrom == 'creditFactorSettingstodolist_resubmit') {
        	vm.creditFactorSettingsHeader = angular.copy( angular.fromJson($rootScope.payload));
        	setValidForExistingCreditFactorSlabs();
        	prepareNewCreditFactorSettings(vm.creditFactorSettingsHeader.creditFactorSettingsDetailsList);
        	vm.creditFactorSettingsHeader.creditFactorSettingsDetailsList.push(angular.copy(vm.newCreditFactor));
        	vm.creditFactorSettingsDetailsList = angular.copy(vm.creditFactorSettingsHeader.creditFactorSettingsDetailsList);
        	
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=true;
        	vm.viewMode=false;
        	$scope.DisabledControl = false;
        }
        else if(workflowSharedService.viewFrom == 'creditFactorSettings_todolist_checker') {
        	vm.creditFactorSettingsHeader =  angular.fromJson($rootScope.payload); 
        	vm.creditFactorSettingsDetailsList = angular.copy(vm.creditFactorSettingsHeader.creditFactorSettingsDetailsList);
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = true;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	$scope.DisabledControl = true;
        }
        else if(workflowSharedService.viewFrom == 'creditFactorSettings_todolist_maker') {
        	vm.creditFactorSettingsHeader =  angular.fromJson($rootScope.payload); 
        	vm.creditFactorSettingsDetailsList = angular.copy(vm.creditFactorSettingsHeader.creditFactorSettingsDetailsList);
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = true;
        	$scope.showResubmitButton=false;
        	$scope.DisabledControl = true;
        }
        else if(workflowSharedService.viewFrom=='creditFactorSettings_auditlog'){
        	vm.creditFactorSettingsHeader =  angular.fromJson($rootScope.payload); 
        	vm.creditFactorSettingsDetailsList = angular.copy(vm.creditFactorSettingsHeader.creditFactorSettingsDetailsList);
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	$scope.DisabledControl = true;

        }
        
        //prepare new credit factor slab to enter. getting 'tenor to' from the last slab and assigned it to 'tenor from' of new slab
		function prepareNewCreditFactorSettings(creditFactorSettingsDetailsList){
			if(creditFactorSettingsDetailsList.length>0){
				var lastSlab = creditFactorSettingsDetailsList[creditFactorSettingsDetailsList.length-1];
				if(lastSlab!=null && lastSlab!=undefined){
					vm.newCreditFactor.tenorFrom = Number(lastSlab.tenorTo) + Number(1);
				}
			}
		}
		
		function setValidForExistingCreditFactorSlabs(){
			angular.forEach(vm.creditFactorSettingsHeader.creditFactorSettingsDetailsList, function(value,index){
				value.valid =true;
			})
		}
        
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	vm.creditFactorSettingsDetailsList = getValidObject(vm.creditFactorSettingsDetailsList);
            var errorMsgForMaxTenorValidation = validateMaximumTenorValue(vm.creditFactorSettingsDetailsList)
        	if($scope.errorMsg!=''){
   				AlertService.error($scope.errorMsg);
        	}else if(errorMsgForMaxTenorValidation!=''){
                AlertService.error(errorMsgForMaxTenorValidation);
            }else{
	        	vm.creditFactorSettingsHeader.creditFactorSettingsDetailsList = vm.creditFactorSettingsDetailsList;
	        	vm.creditFactorSettingsHeader.creditFactorSettingsDetailsList = $filter('orderBy')(vm.creditFactorSettingsHeader.creditFactorSettingsDetailsList, 'minimumTradedValue');
	        	if (vm.creditFactorSettingsHeader.id != null) {
	        		CreditFactorSettings.update({
						"orgId" : GlobalValues.getOrgId()
					}, vm.creditFactorSettingsHeader, onSaveSuccess, onSaveError);
				} else {
					CreditFactorSettings.save({
						"orgId" : GlobalValues.getOrgId()
					}, vm.creditFactorSettingsHeader, onSaveSuccess, onSaveError);
				}
        	}
         }
      
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
      
        function onSaveError () {
        	prepareNewCreditFactorSettings(vm.creditFactorSettingsDetailsList);
			vm.creditFactorSettingsDetailsList.push(angular.copy(vm.newCreditFactor));
        	vm.clicked = false;
        }

        function resubmitCreditFactorSettings() {
        	vm.creditFactorSettingsDetailsList = getValidObject(vm.creditFactorSettingsDetailsList);
        	vm.creditFactorSettingsHeader.creditFactorSettingsDetailsList = vm.creditFactorSettingsDetailsList;
            var errorMsgForMaxTenorValidation = validateMaximumTenorValue(vm.creditFactorSettingsDetailsList)
            if($scope.errorMsg!=''){
                AlertService.error($scope.errorMsg);
            }else if(errorMsgForMaxTenorValidation!=''){
                AlertService.error(errorMsgForMaxTenorValidation);
            }else{
                CreditFactorSettings.resubmit({"taskId" : $rootScope.taskID}, vm.creditFactorSettingsHeader, onResubmitSuccess, onResubmitError);
                $uibModalInstance.dismiss('cancel');
            }
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        

        function onResubmitError(error) {
        	prepareNewCreditFactorSettings(vm.creditFactorSettingsDetailsList);
			vm.creditFactorSettingsDetailsList.push(angular.copy(vm.newCreditFactor));
        	vm.clicked = false;
        }
        
        function approveCreditFactorSettings() { 
        	CreditFactorSettings.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        

        function onApproveError(error) {
        	
        }
       
        function rejectCreditFactorSettings() { Workflow.rejectTask($rootScope.taskID); }

        function discardCreditFactorSettings() {
        	CreditFactorSettings.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        

        function onDiscardError(error) {
        	
        }
        
        function addCreditFactorSettings(index){
        	$scope.errorMessage = '';
        	
        	$scope.errorMessage = validateList(index);
            if($scope.errorMessage == ''){
                vm.creditFactorSettingsDetailsList[index].editable = false;
                vm.creditFactorSettingsDetailsList[index].valid = true;
                vm.creditFactorSettingsDetailsList[index].tenorTo = (Math.round(parseFloat(vm.creditFactorSettingsDetailsList[index].tenorTo) * 10000)/10000)
                vm.creditFactorSettingsDetailsList[index].tenorFrom = (Math.round(parseFloat(vm.creditFactorSettingsDetailsList[index].tenorFrom) * 10000)/10000)
                if(vm.creditFactorSettingsDetailsList[index+ 1] != null && vm.creditFactorSettingsDetailsList[index+ 1] != undefined){
                    vm.creditFactorSettingsDetailsList[index+ 1].tenorFrom = Number(vm.creditFactorSettingsDetailsList[index].tenorTo) + Number(1);
                }
                prepareNewCreditFactorSettings(vm.creditFactorSettingsDetailsList);
                vm.creditFactorSettingsDetailsList.push(angular.copy(vm.newCreditFactor));
            }
            else{
                vm.creditFactorSettingsDetailsList[index].valid = false;
               // $scope.errorMessage = $filter('translate')($scope.errorMessage);
            }
        	
        }
        
        function editCreditFactorSettings(editIndex){

            //clear error message in current row before editing the selected row
            $scope.errorMessage = '';
        	
        	angular.forEach(vm.creditFactorSettingsDetailsList, function(value, index){
        		
        		if(angular.equals(value, vm.newCreditFactor) && vm.creditFactorSettingsDetailsList.length>1){
        			vm.creditFactorSettingsDetailsList.splice(index, 1);
        		}
        		
        		if(!value.valid && vm.creditFactorSettingsDetailsList.length>1){
        			vm.creditFactorSettingsDetailsList.splice(index, 1);
        		}
        		
        		value.editable = false;
        		
        		//if(index>0 && index == vm.creditFactorSettingsDetailsList.length -1){
        			
        			//vm.creditFactorSettingsDetailsList.splice(index,1);
        			
        		//}
        		
        	})
        	
        	if(vm.creditFactorSettingsDetailsList[editIndex] != null && vm.creditFactorSettingsDetailsList[editIndex] != undefined)
        		vm.creditFactorSettingsDetailsList[editIndex].editable = true;
        }
        
        function removeCreditFactorSettings(index){
        	if(vm.creditFactorSettingsDetailsList[index+ 1] != null && vm.creditFactorSettingsDetailsList[index+ 1] != undefined){
        		if(index==0){
        			vm.creditFactorSettingsDetailsList[index+ 1].tenorFrom = Number('1');
        		}else{
        			vm.creditFactorSettingsDetailsList[index+ 1].tenorFrom = Number(vm.creditFactorSettingsDetailsList[index-1].tenorTo) + Number(1);
        		}
			}
        	vm.creditFactorSettingsDetailsList.splice(index, 1);
        }
        
        function resetCreditFactorSettings(index){
        	var maxValueCtrl = "txtTenorTo_" + index;
        	var chargesCtrl = "txtCreditFactor_" + index;
        	document.getElementById(maxValueCtrl).value = "";
        	vm.creditFactorSettingsDetailsList[index].tenorTo = null;
        	document.getElementById(chargesCtrl).value = "";
        	vm.creditFactorSettingsDetailsList[index].creditFactor = null;
        	vm.creditFactorSettingsDetailsList[index].valid = false;

            //reset error message
            $scope.errorMessage = '';
        }
        
        
        function getValidObject(creditFactorSettingsDetailsList) {
        	$scope.errorMsg = '';
        	angular.forEach(creditFactorSettingsDetailsList, function(value,index) {
				if (angular.equals(value, vm.newCreditFactor)) {
					creditFactorSettingsDetailsList.splice(index, 1);

				} else if (value.editable == true) {
					if(vm.creditFactorSettingsDetailsList[index].tenorTo!=null && vm.creditFactorSettingsDetailsList[index].creditFactor!=null){
						$scope.errorMsg = $filter('translate')('gatewayApp.creditFactorSettings.incompleteSlab');
						vm.clicked = false;
					}else{
						if(vm.creditFactorSettingsDetailsList[index+ 1] != null && vm.creditFactorSettingsDetailsList[index+ 1] != undefined){
	                		if(index==0){
	                			vm.creditFactorSettingsDetailsList[index+ 1].tenorFrom = Number('1');
	                		}else{
	                			vm.creditFactorSettingsDetailsList[index+ 1].tenorFrom = Number(vm.creditFactorSettingsDetailsList[index-1].tenorTo) + Number(1);
	                		}
	        			}
						creditFactorSettingsDetailsList.splice(index, 1);
					}
				}

			});

			vm.creditFactorSettingsDetailsList = creditFactorSettingsDetailsList;

			return vm.creditFactorSettingsDetailsList;
		}

        function validateMaximumTenorValue(creditFactorSettingsDetailsList){
            var errorMessage = '';
            angular.forEach(creditFactorSettingsDetailsList, function(value, index){
                if(value!=null && value!=undefined && value.tenorTo!=null && value!=undefined){
                    if(vm.creditFactorSettingsHeader.tenorType=='Days'){
                        if(parseInt(value.tenorTo)>parseInt(vm.noOfActiveDaysForStandardTenor)){
                            errorMessage = 'Row no. ' + (index + 1) + ' - ' + $filter('translate')('gatewayApp.creditFactorSettings.tenorToGreaterThanMaxTenor') + vm.noOfActiveDaysForStandardTenor.toString() + ' days';
                            vm.clicked = false;
                        }
                    }else{
                        if(parseInt(value.tenorTo)>parseInt(vm.noOfActiveMonthsForStandardTenor)){
                            errorMessage = 'Row no. ' + (index + 1) + ' - ' + $filter('translate')('gatewayApp.creditFactorSettings.tenorToGreaterThanMaxTenor') + vm.noOfActiveMonthsForStandardTenor.toString() + ' months';
                            vm.clicked = false;
                        }
                    }
                    if(errorMessage==''){
                        if(parseInt(value.tenorFrom)==parseInt(value.tenorTo)){
                            errorMessage = 'Row no. ' + (index + 1) + ' - ' + $filter('translate')('gatewayApp.creditFactorSettings.maxLessThanMin');
                            vm.clicked = false;
                        }
                    }
                }
            })
            return errorMessage;
        }

        
        function validateList(index){
            
            if(Number(vm.creditFactorSettingsDetailsList[index].tenorFrom) >= Number(vm.creditFactorSettingsDetailsList[index].tenorTo) 
                    || vm.creditFactorSettingsDetailsList[index].tenorTo=='' || vm.creditFactorSettingsDetailsList[index].tenorTo==undefined){
                
                return $filter('translate')('gatewayApp.creditFactorSettings.maxLessThanMin');
            }
            
            else if(vm.creditFactorSettingsDetailsList[index-1] != null && vm.creditFactorSettingsDetailsList[index-1] != undefined
                    && Number(vm.creditFactorSettingsDetailsList[index].tenorFrom)
                    <= Number(vm.creditFactorSettingsDetailsList[index-1].tenorTo)){
                
                return $filter('translate')('gatewayApp.creditFactorSettings.greaterMin');
            }
            
            else if(vm.creditFactorSettingsDetailsList[index+ 1] != null && vm.creditFactorSettingsDetailsList[index+ 1] != undefined
                    && Number(vm.creditFactorSettingsDetailsList[index].tenorTo)
                    >= Number(vm.creditFactorSettingsDetailsList[index+ 1].tenorTo)){

                return $filter('translate')('gatewayApp.creditFactorSettings.greaterMax');
            }
            else if(vm.creditFactorSettingsDetailsList[index+ 1] != null && vm.creditFactorSettingsDetailsList[index+ 1] != undefined
                    && Number(vm.creditFactorSettingsDetailsList[index].tenorTo)
                    >= Number(vm.creditFactorSettingsDetailsList[index+ 1].tenorFrom)){

                vm.creditFactorSettingsDetailsList[index+ 1].tenorFrom = vm.creditFactorSettingsDetailsList[index].tenorTo;
            }
            else if(vm.creditFactorSettingsDetailsList[index+ 1] != null && vm.creditFactorSettingsDetailsList[index+ 1] != undefined){
                vm.creditFactorSettingsDetailsList[index+ 1].tenorFrom = vm.creditFactorSettingsDetailsList[index].tenorTo;
            }

            if(vm.creditFactorSettingsHeader.tenorType=='Days'){
                if(parseInt(vm.creditFactorSettingsDetailsList[index].tenorTo)>parseInt(vm.noOfActiveDaysForStandardTenor)){
                    return $filter('translate')('gatewayApp.creditFactorSettings.tenorToGreaterThanMaxTenor') + vm.noOfActiveDaysForStandardTenor.toString() + ' days';
                }
            }else{
                if(parseInt(vm.creditFactorSettingsDetailsList[index].tenorTo)>parseInt(vm.noOfActiveMonthsForStandardTenor)){
                    return $filter('translate')('gatewayApp.creditFactorSettings.tenorToGreaterThanMaxTenor') + vm.noOfActiveMonthsForStandardTenor.toString() + ' months';
                }
            }

            return '';
        }
       
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('credit-factor-settings', {
            parent: 'entity',
            url: '/credit-factor-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.creditFactorSettings.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/credit-factor-settings/credit-factor-settings.html',
                    controller: 'CreditFactorSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                validateSODAndSession: ['ExposureType', function(ExposureType, GlobalValues) {
                    return ExposureType.validateSODAndSession().$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('creditFactorSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('credit-factor-settings-edit', {
            parent: 'credit-factor-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/credit-factor-settings/credit-factor-settings-dialog.html',
                    controller: 'CreditFactorSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['CreditFactorSettings', 'GlobalValues', function(CreditFactorSettings, GlobalValues) {
                                     return CreditFactorSettings.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         .state('credit-factor-settings-todolist', {
            parent: 'dashboard',
            url: '/CreditFactorSettingsToDo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/credit-factor-settings/credit-factor-settings-dialog.html',
                    controller: 'CreditFactorSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('credit-factor-settings', null, { reload: 'credit-factor-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('credit-factor-settings-todolist-resubmit', {
            parent: 'dashboard',
            url: '/CreditFactorSettingsResubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/credit-factor-settings/credit-factor-settings-dialog.html',
                    controller: 'CreditFactorSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('credit-factor-settings', null, { reload: 'credit-factor-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        .state('credit-factor-settings-auditLog', {
            parent: 'audit-log',
            url: '/CreditFactorSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/credit-factor-settings/credit-factor-settings-dialog.html',
                    controller: 'CreditFactorSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('credit-factor-settings', null, { reload: 'credit-factor-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
          .state('credit-factor-settings-historyReport', {
            parent: 'history-report',
            url: '/CreditFactorSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/credit-factor-settings/credit-factor-settings-dialog.html',
                    controller: 'CreditFactorSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('credit-factor-settings', null, { reload: 'credit-factor-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('credit-factor-settings-report-view', {
            parent: 'entity',
            url: '/credit-factor-settings-report-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.creditFactorSettingsReportView.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/credit-factor-setings-report/credit-factor-settings-report-view.html',
                    controller: 'CreditFactorSettingsReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
               
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('creditFactorSettings');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        
         };
    })();

(function() {
	'use strict';
	angular.module('gatewayApp').factory('CreditFactorSettings', CreditFactorSettings);

	CreditFactorSettings.$inject = [ '$resource' ];

	function CreditFactorSettings($resource) {
		var resourceUrl = 'api/credit-factor-settings/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				params : {
					orgId : '@orgId'
				},
				url: 'api/credit-factor-settings-for-bank/:orgId/orgId',
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},

			'getCreditFactorsForCustomer' : {
				method : 'GET',
				params : {
					orgId : '@orgId'
				},
				url: 'api/credit-factor-settings-for-customer/:customerId/customer',
				isArray: true
			},
			'update' : {
				method : 'PUT',
				params : {
					orgId : '@orgId'
				},
				url : 'api/credit-factor-settings/orgId/:orgId',
				transformRequest : function(data) {
					var copy = angular.copy(data);

					return angular.toJson(copy);
				}
			},
            'getCreditFactorExcel':{
                method:'POST',
                url: 'api/credit-factor-settings/excel',
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            },
            'getCreditFactorCSV':{
                method:'POST',
                url: 'api/credit-factor-settings/csv',
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            },
			'approve' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/approve'
			},
			'reject' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/reject'
			},
			'discard' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/discard'
			},
			
			'resubmit' : {
				method : 'PUT',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/resubmit-credit-factor-settings',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'getActiveCreditSettings' : {
				method:'GET',
				isArray:true,
	            url: 'api/credit-factor-settings-view'    
			}
		

		});
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'creditFactorSettings'
        })
        
        .controller('CreditFactorSettingsController', CreditFactorSettingsController);

    CreditFactorSettingsController.$inject = ['$scope', '$state', 'CreditFactorSettings', 'GlobalValues', 'workflowSharedService', 
    'EntityPermissions', 'ScreenLog','entityConstants','$timeout', 'validateSODAndSession', 'IntradayMarket', 'MessageBox'];

    function CreditFactorSettingsController($scope, $state, CreditFactorSettings , GlobalValues, workflowSharedService, 
      EntityPermissions, ScreenLog,entityConstants,$timeout, validateSODAndSession, IntradayMarket, MessageBox) {
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.CREDIT_FACTOR_SETTINGS;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "creditFactorSettings";
        vm.bank = GlobalValues.getBank();
        $scope.refresh=refresh;
        vm.exportToFile = exportToFile;
        vm.editCreditFactor = editCreditFactor;
        vm.validateSODAndSession = validateSODAndSession;
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.noOfDecimalsForPercent = 4;
        
        vm.permitCreditFactorSettingsEditEntityAction = EntityPermissions.hasPermission('CreditFactorSettings.EDIT');
        
        //get market session settings.
        IntradayMarket.getIntradayMarketSessionSettingsForInstrument({"instrument":'InterbankSPOT'}, onGetMarketSessionSuccess, onGetMarketSessionFailure);

        function onGetMarketSessionSuccess(result){
          vm.marketSessionSettings = result;
        }

        function onGetMarketSessionFailure(){

        }

        logScreenAccess();
        loadAll();

        function loadAll() {
    	    CreditFactorSettings.query({orgId: vm.globalValues.getOrganisation().id}, getCreditFactorSettingsSuccess, getCreditFactorSettingsFailure);
        }      
       

        function editCreditFactor(creditFactorSettingsHeaderId){
          if(vm.marketSessionSettings.sessionStatus=='OPEN'){
            MessageBox.openMessageBox("Alert", "Modification is permitted only after the IB.SPOT market hours...!", "Ok", "creditfactorsettings");
          }else if(!vm.validateSODAndSession.allowToAddOrEdit){
            MessageBox.openMessageBox("Alert", "SOD is completed for the business day, modifications is not permitted.", "Ok", "creditfactorsettings");
          }else{
            vm.screenLog.screenLog(vm.screenName, creditFactorSettingsHeaderId, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
            $state.go("credit-factor-settings-edit", {id:creditFactorSettingsHeaderId});
          }
        }

       function getCreditFactorSettingsSuccess(result){
    	   vm.creditFactorSettingsHeader = result;
    	   vm.creditFactorSettingsDetailsList=[];
    	   
         if(vm.creditFactorSettingsHeader!=null && vm.creditFactorSettingsHeader!=undefined){
             angular.forEach(vm.creditFactorSettingsHeader.creditFactorSettingsDetailsList, function(detail){
               vm.details = angular.copy(detail);
               vm.details.creditFactorSettingsHeader = vm.creditFactorSettingsHeader;
               vm.creditFactorSettingsDetailsList.push(vm.details);
             })
         }
    		  
       }
       
       function getCreditFactorSettingsFailure(){}
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };

	   	function exportToFile(fileType){
			vm.baseString =   'Credit_Factor_Settings_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   	
			if(vm.creditFactorSettingsDetailsList !=null &&  vm.creditFactorSettingsDetailsList !=undefined){
				if(fileType == 'csv' ){
					vm.mimeType = 'text/csv'
					vm.baseString = vm.baseString+ ".csv";  
					CreditFactorSettings.getCreditFactorCSV(vm.creditFactorSettingsDetailsList, processResponse);
				}else if(fileType == 'excel' ){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.baseString = vm.baseString+ ".xls";  
					CreditFactorSettings.getCreditFactorExcel(vm.creditFactorSettingsDetailsList, processResponse);
				}
			}
		}
	   	
		function processResponse(result){
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
			
		}
       
       
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'creditFactorSettingsReport'
        })
        
        .controller('CreditFactorSettingsReportController', CreditFactorSettingsReportController);

    CreditFactorSettingsReportController.$inject = ['$scope', '$state', 'CreditFactorSettings', 'GlobalValues', 'workflowSharedService', 
    'EntityPermissions', 'ScreenLog','entityConstants','$timeout'];

    function CreditFactorSettingsReportController($scope, $state, CreditFactorSettings , GlobalValues, workflowSharedService, 
      EntityPermissions, ScreenLog,entityConstants,$timeout) {
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.CREDIT_FACTOR_SETTINGS_VIEW;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "creditFactorSettingsReport";
     
        $scope.refresh=refresh;
       
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.noOfDecimalsForPercent = 4;        
     
        logScreenAccess();
        loadAll();

        function loadAll() {
    	    CreditFactorSettings.getActiveCreditSettings( getCreditFactorSettingsSuccess, getCreditFactorSettingsFailure);
        }      
       
        function getCreditFactorSettingsSuccess(result){
    	  
    	   vm.creditFactorSettingsList = result; 	 
    	    		  
       }
       
       function getCreditFactorSettingsFailure(){}
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };

       
       
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('Country', Country);

    Country.$inject = ['$resource'];

    function Country ($resource) {
        var resourceUrl =  'api/public/country/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getCountryForUser': {
                method: 'GET',
                params: {shortName:'@shortName'},
                url: 'api/country-for-user/:shortName',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ContactUsController', ContactUsController);

    ContactUsController.$inject = ['$scope', '$state', '$rootScope','$uibModalInstance' ];

     function ContactUsController($scope, $state, $rootScope, $uibModalInstance ) {
        var vm = this;
        
        vm.ExpandOrCollapseAuditLog = false;
        vm.valid=true;
        vm.clear=clear;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);
/*  this screen view for all entity  */
    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trades-for-the-day-report', {
            parent: 'entity',
            params:{screen: 'TradesForTheDay'}, 
            url: '/trades-for-the-day-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.tradesForTheDayReport.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/clearcorp-trades-report/clearcorp-trades-report.html',
                    controller: 'ClearCorpTradesReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clearcorpTradesReport');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('orderActivity');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('order-activity-report-from-trades', {
            parent: 'trades-for-the-day-report',
            url: '/order-activity-report-for-trades/{orderNumber}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-activity/order-activity.html',
                    controller: 'OrderActivityController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    	
                            	 entity: ['OrderActivity', 'GlobalValues', function(OrderActivity, GlobalValues) {
                                     return OrderActivity.get({orderNumber : $stateParams.orderNumber}).$promise;
                                 }],
                                 businessDate: [ 'GlobalValues','DateUtils', function( GlobalValues,DateUtils) {
                                	 var systemSettings = GlobalValues.getSystemSettings();
                                     if(systemSettings!=null && systemSettings!=undefined){
                                     	return DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
                                     	 
                                     }else{
                                    	 return null;
                                     }
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
             
        
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ClearCorpTradesReportService', ClearCorpTradesReportService);

    ClearCorpTradesReportService.$inject = ['$resource'];

    function ClearCorpTradesReportService($resource) {
        var resourceUrl =  'api/trades/:id';
        
        return $resource(resourceUrl, {}, {
        	
        
        	'getTradesForReport':{
          		isArray:true,
 				method: 'GET',
 				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'
 						, fromTime: '@fromTime' , toTime : '@toTime', currencyPairId : '@currencyPairId'
 				},
 				url: 'api/clearcorp-trades-report'
           },
           'exportTradeExcel':{
           	 method: 'GET',
                url: 'api/clearcorp-trades-report/excel-download',
                responseType: 'arraybuffer',
                params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'
						, fromTime: '@fromTime' , toTime : '@toTime', currencyPairId : '@currencyPairId'
                },
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                }      
           },
           'exportTradesCsv':{
            	 method: 'GET',
                 url: 'api/clearcorp-trades-report/csv-download',
                 responseType: 'arraybuffer',
                 params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'
						, fromTime: '@fromTime' , toTime : '@toTime', currencyPairId : '@currencyPairId'
                 },
                 transformResponse: function(data, headers) {
               	  return {
                         data: data,
                         headers: headers
                     };   
                 }      
            },
            'exportTradesPdf':{
             	 method: 'GET',
                  url: 'api/clearcorp-trades-report/pdf-download',
                  responseType: 'arraybuffer',
                  params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'
						, fromTime: '@fromTime' , toTime : '@toTime', currencyPairId : '@currencyPairId'
                  },
                  transformResponse: function(data, headers) {
                	  return {
                          data: data,
                          headers: headers
                      };   
                  }      
             }
        });
    }
   })();

(function() {
    'use strict';
	/*  this screen view for all entity  */
    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'clearCorpTradesReport'
        })
        
        .controller('ClearCorpTradesReportController', ClearCorpTradesReportController);

    ClearCorpTradesReportController.$inject = ['$scope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
    	'DateUtils','AlertService','$filter',   'ClearCorpTradesReportService' , 'GenerateDealTicket','SODProcess', 'DealingAdminApplicationWideSettings'];

    function ClearCorpTradesReportController($scope, $state,  GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
    		DateUtils,AlertService,$filter,  ClearCorpTradesReportService, GenerateDealTicket,SODProcess, DealingAdminApplicationWideSettings) {
       
    	var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.TRADES_FOR_THE_DAY;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
       
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.configSettings = vm.globalValues.getConfigSettings();
		vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
		
        vm.toTime = moment();
       
        vm.defaultDuration = "01:00:00";
	    vm.maxDate = moment().subtract( vm.duration);
	    vm.todayDate = new Date();
		vm.clicked=false;
	    vm.getTrades = getTrades;
	    vm.exportDataToExcelFile = exportDataToExcelFile;
	    vm.exportDataToCsvFile = exportDataToCsvFile;
	    vm.exportDataToPdfFile = exportDataToPdfFile;
	    vm.filterData = {};
	    vm.printDealTicket = printDealTicket;
	    vm.fileName = "Trades_for_the_day_report_";
	    vm.extension = "";
	    vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
	    vm.printDealTicket = printDealTicket;

		setUsers();
        function setUsers() {
            if(vm.entityOwnerType=='MultiUserCustomer' || vm.entityOwnerType=='SingleUserCustomer'){
                vm.loggedInCustomer = vm.globalValues.getCustomerId();
           }
           if(vm.entityOwnerType=='Bank' || vm.entityOwnerType=='Branch'){
               vm.bank = vm.globalValues.getBank();
           }
           if(vm.entityOwnerType=='Branch'){
               vm.branch = vm.globalValues.getBranch();
           }
            
        }
	    
	    logScreenAccess();
	    vm.valid = false;
	   
	    function loadDates() {
        	
			SODProcess.getCurrentBusinessDate(loadSystemSettingsSuccess, loadSystemSettingsError);
		}
    	function loadSystemSettingsSuccess(result){
			vm.lastSystemSetting = result;
			vm.todayDate = DateUtils.convertLocalDateFromServer(vm.lastSystemSetting.businessDate);
    	}
    	
    	function loadSystemSettingsError(){
			
		}
        loadDates();
        var subtractDurationFromGivenValue = function(toValue) {
	       	 if(toValue !=null && toValue !=undefined && toValue != ""){
	       		 var duration = vm.duration;
	       		 var hours = duration.hours();
	       		 var minutes = duration.minutes();
	       		 if(duration==null || duration ==undefined ||  duration=="" || ( hours == 0 && minutes == 0)){
	       			 duration = moment.duration( vm.defaultDuration);
	       		 }
	       		 return angular.copy(toValue).subtract(duration);
	       	 }else{
	       		 
	       		 return null;
	       	 }
       }
      
        DealingAdminApplicationWideSettings.getConfigValueForConfigName(
        		{"configName": "TimeDifferenceForTimePickerControl"}, function(result){
        			if(result !=null && result !=undefined && result.value!=null && result.value !=undefined && result.value != ""){
        				vm.duration = moment.duration( parseInt( result.value), 'hours');
        			}else{
        				vm.duration = moment.duration( vm.defaultDuration);
        			}
        			 vm.fromTime = subtractDurationFromGivenValue( vm.toTime);
       });
        
        function setReportPeriod(){
        	vm.toDateTime = moment(angular.copy(vm.todayDate ) , 'YYYY-MM-DD');        	
        	vm.toDateTime.set(
       			 { 	'hour':vm.toTime.get('hour'),
       				'minute':vm.toTime.get('minute'),
       				'second':vm.toTime.get('second')
       				
       			 });
        	vm.fromDateTime = moment(angular.copy(vm.todayDate ) , 'YYYY-MM-DD');        	
        	vm.fromDateTime.set(
       			 { 	'hour':vm.fromTime.get('hour'),
       				'minute':vm.fromTime.get('minute'),
       				'second':vm.fromTime.get('second')
       				
       			 });
       	 
        	vm.fromTimeDateObject = new Date(vm.fromDateTime);
        	vm.toTimeDateObject = new Date(vm.toDateTime);
        }

		function prepareDataForCustomer() {
			if(vm.entityOwnerType == 'SingleUserCustomer' || vm.entityOwnerType == 'MultiUserCustomer')
			vm.filterData.customerId = vm.globalValues.getOrgId();
		}
        
        function copyFilterData(){
				// if  bank user
				if (vm.entityOwnerType == 'Bank') {
					vm.filterData.bankId =  vm.globalValues.getOrgId();
				}
				// if branch user
				if (vm.entityOwnerType == 'Branch') {
					vm.filterData.bankId =  vm.globalValues.getOrgId();
					vm.filterData.branchId = vm.globalValues.getBranchId();
				}
        	
        	 if(vm.bank!=null && vm.bank !=undefined){
        		 
        		 vm.filterData.bankId = angular.copy(vm.bank.id);
        	 }else{
        		
        		 vm.filterData.bankId = 0;
        	 }
        	 if(vm.branch!=null && vm.branch!=undefined){
        		
        		 vm.filterData.branchId = angular.copy(vm.branch.id);
        	}else{
        		 
        		vm.filterData.branchId = 0;
        	}if(vm.customer!=null && vm.customer!=undefined){
        		 
        		vm.filterData.customerId = angular.copy(vm.customer.id);
        	}else{
        		
        		vm.filterData.customerId = 0;
        	}
        	if(vm.instrument!=null && vm.instrument!=undefined){
        		 vm.filterData.instrumentId = angular.copy(vm.instrument.id);
        	}else{
        		vm.filterData.instrumentId = 0;
        	}
			if(vm.currencyPair!=null && vm.currencyPair!=undefined){
        		 vm.filterData.currencyPairId = angular.copy(vm.currencyPair.id);
        	}else{
        		vm.filterData.currencyPairId = 0;
        	}
        	 vm.filterData.fromTimeDateObject = angular.copy(vm.fromTimeDateObject );
        	 vm.filterData.toTimeDateObject = angular.copy(vm.toTimeDateObject);
        }
        
        function getTrades(){
        	vm.valid = true;
        	if(vm.toTime.isAfter(moment())){
        		
        		AlertService.error("To Time should be less than or equal to current time");
        	}else if(vm.fromTime.isAfter( vm.toTime)){
        		
        		AlertService.error("From Time should be less than or equal to To Time");
        	}else{
				vm.clicked=true;
        		setReportPeriod();
        		copyFilterData();
				prepareDataForCustomer();
        		ClearCorpTradesReportService.getTradesForReport({bankId: vm.filterData.bankId, branchId: vm.filterData.branchId, 
    			customerId:vm.filterData.customerId,  instrumentId: vm.filterData.instrumentId, fromTime:vm.fromTimeDateObject , toTime:vm.toTimeDateObject, currencyPairId: vm.filterData.currencyPairId}, 
    			onGetTradesSuccess, onGetTradesFailure);  		
        	}
        	
        }
        function onGetTradesSuccess(result){
        	 
        	angular.forEach(result,function(value){
        		value.tradeTime=moment(value.tradeTime,'YYYYMMDDHHmmss.SSSSSSSSS').format();
        	});
        	 vm.clearcorptradesReportDetails = result;
			 vm.clicked=false;
        }
        function onGetTradesFailure(error){
        	vm.clicked=false;
        }
        
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }
        function exportDataToExcelFile(){
      	 
      	  if(  vm.clearcorptradesReportDetails  !=null &&   vm.clearcorptradesReportDetails !=undefined &&  vm.clearcorptradesReportDetails .length>0){
		
      			vm.mimeType = 'application/vnd.ms-excel';
      			vm.extension = ".xls";  
      			ClearCorpTradesReportService.exportTradeExcel({bankId:  vm.filterData.bankId, branchId:  vm.filterData.branchId, 
        			customerId:  vm.filterData.customerId,  instrumentId:  vm.filterData.instrumentId, fromTime: vm.filterData.fromTimeDateObject , toTime: vm.filterData.toTimeDateObject, currencyPairId:  vm.filterData.currencyPairId  } 
      			, processResponse );
      		 
      	  }
        }       
        function exportDataToCsvFile(){        	
        		
        	  if( vm.clearcorptradesReportDetails !=null &&  vm.clearcorptradesReportDetails!=undefined && vm.clearcorptradesReportDetails.length>0){
			
        			vm.mimeType = 'text/csv';
        			vm.extension = ".csv";  
        			ClearCorpTradesReportService.exportTradesCsv({bankId:  vm.filterData.bankId, branchId:  vm.filterData.branchId, 
          			customerId:  vm.filterData.customerId,  instrumentId:  vm.filterData.instrumentId, fromTime: vm.filterData.fromTimeDateObject , toTime: vm.filterData.toTimeDateObject, currencyPairId:  vm.filterData.currencyPairId  } , processResponse );
        		 
        	  }
        }
	    function exportDataToPdfFile(){	    	
	    	
	      	  if( vm.clearcorptradesReportDetails !=null &&  vm.clearcorptradesReportDetails!=undefined && vm.clearcorptradesReportDetails.length>0){
				
	      			vm.mimeType = 'application/pdf';
	      			vm.extension =  ".pdf";  
	      			ClearCorpTradesReportService.exportTradesPdf({bankId:  vm.filterData.bankId, branchId:  vm.filterData.branchId, 
	        			customerId:  vm.filterData.customerId,  instrumentId:  vm.filterData.instrumentId, fromTime: vm.filterData.fromTimeDateObject , toTime: vm.filterData.toTimeDateObject, currencyPairId:  vm.filterData.currencyPairId  } , processResponse );
	      		 
	      	  }
	    }
	    function processResponse(result){
	      	  var fileData = null;
	  		  fileData = result.data;
	  		  var link = document.createElement("a");   
	  		  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
	  		  vm.baseString =     vm.fileName + moment().format(vm.reportFileTimestampFormat) +  vm.extension;   	
	  		  
	  	      var blob = new Blob([bytes], {type: vm.mimeType});
	  	      if(window.navigator.msSaveOrOpenBlob) {
	                  window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
	  	      }else{
	  	    	  link.href =  window.URL.createObjectURL(blob);      
	  	    	  link.download = vm.baseString;
	  	    	  document.body.appendChild(link);
	  	    	  link.click();
	  	    	  document.body.removeChild(link);
	  	      }
	  	}
	    function printDealTicket(trade){
        	vm.tradeResponse = angular.copy(trade);
        	console.log(typeof vm.tradeResponse.tradeTime);
        	vm.tradeResponse.tradeTime = moment(vm.tradeResponse.tradeTime).format('YYYYMMDDHHmmss.SSSSSSSSS');
        	GenerateDealTicket.generate(vm.tradeResponse,function(result){
	        	var file = new Blob([result.data], {type: 'application/pdf'});
	      		
                var fileURL = URL.createObjectURL(file);
                if(window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file, "DealTicket.pdf");
                }
                else {
                     window.open(fileURL, "_blank", "fullscreen=yes");    
                }
        	});
        }
		vm.getSwapPoints = function getSwapPoints(spotExchangeRate, tradeExchangeRate){
            var swapPts = Math.abs(spotExchangeRate - tradeExchangeRate) * 100
            swapPts = (Math.round(parseFloat(swapPts)*100)/100);
            return swapPts;
		}
    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('outstanding-trades-report', {
            parent: 'entity',
            params:{screen: 'OutstandingTradesReport'},
            url: '/outstanding-trades-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.tradesOutstandingReport.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/clearcorp-trades-outstanding-report/clearcorp-trades-outstanding-report.html',
                    controller: 'ClearcorpTradesOutstandingReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clearcorpTradesOutstandingReport');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('orderActivity');
                    return $translate.refresh();
                }],
                systemSetting: ['IntradayMarket', function(IntradayMarket) {
                    return IntradayMarket.getCurrentBusinessDate().$promise;
                }]

            }
        })
        .state('order-activity-report-from-trades-os', {
            parent: 'outstanding-trades-report',
            url: '/order-activity-report-for-trades-os/{orderNumber}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-activity/order-activity.html',
                    controller: 'OrderActivityController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    	
                            	 entity: ['OrderActivity', 'GlobalValues', function(OrderActivity, GlobalValues) {
                                     return OrderActivity.get({orderNumber : $stateParams.orderNumber}).$promise;
                                 }],
                                 businessDate: [ 'GlobalValues','DateUtils', function( GlobalValues,DateUtils) {
                                	 var systemSettings = GlobalValues.getSystemSettings();
                                     if(systemSettings!=null && systemSettings!=undefined){
                                     	return DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
                                     	 
                                     }else{
                                    	 return null;
                                     }
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
             
        
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ClearcorpTradesOutstandingReportService', ClearcorpTradesOutstandingReportService);

    ClearcorpTradesOutstandingReportService.$inject = ['$resource'];

    function ClearcorpTradesOutstandingReportService($resource) {
        var resourceUrl =  'api/trades-outstanding/:id';
        
        return $resource(resourceUrl, {}, {
        	
            'getTradesOutstandingExcel':{
                method: 'POST',
                url: 'api/trades-outstanding-report/export-excel',
                params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId',fromSetDate :'@fromSetDate',toSetDate:'@toSetDate', currencyPairId : '@currencyPairId'},
                responseType: 'arraybuffer',
                 transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            },
            'getTradesOutstandingCsv':{
                method: 'POST',
                url: 'api/trades-outstanding-report/export-csv',
                params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId',fromSetDate :'@fromSetDate',toSetDate:'@toSetDate', currencyPairId : '@currencyPairId'},
                responseType: 'arraybuffer',
                 transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            }
        });
    }
   })();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'clearcorpTradesOutstandingReport'
        })
        
        .controller('ClearcorpTradesOutstandingReportController', ClearcorpTradesOutstandingReportController);

    ClearcorpTradesOutstandingReportController.$inject = ['$scope', 'GlobalValues', 'ScreenLog','entityConstants', 
    	'DateUtils','AlertService', 'ClearcorpTradesOutstandingReportService', 'OrderStatusDetails', 'systemSetting', 'DefaultMarket'];

    function ClearcorpTradesOutstandingReportController($scope, GlobalValues, ScreenLog,entityConstants, 
    		DateUtils,AlertService, ClearcorpTradesOutstandingReportService, OrderStatusDetails, systemSetting, DefaultMarket) {
       
    	var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.OUTSTANDING_TRADES_REPORT;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
       
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
       
	    vm.getTradesOutstanding = getTradesOutstanding;
	    vm.exportDataToExcelFile = exportDataToExcelFile;
	    vm.exportDataToCsvFile = exportDataToCsvFile;
		vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
	    
	    vm.filterData = {};
	    vm.fileName = "Clearcorp_trades_outstanding_report_";
	    vm.extension = "";
	    vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
	    
		// DefaultMarket.marketInstruments(function(result){
        //     vm.instrumentTypes = result;
        // });
		getInstrumentMatchedCurrencypair();

	    logScreenAccess();
	    vm.valid = false;
		vm.clicked=false;
        vm.queryfromDate =  null;
        vm.querytoDate = null;

        if(systemSetting != null && systemSetting != undefined){
        	vm.currentDate = DateUtils.convertDateTimeFromServer(systemSetting.businessDate);
        	vm.fromSetDate = DateUtils.convertDateTimeFromServer(systemSetting.businessDate);
        	vm.toSetDate = DateUtils.convertDateTimeFromServer(systemSetting.businessDate);
        }
        
        function getTradesOutstanding(){
			var bankId = 0;
        	var branchId = 0;
        	var customerId = 0;
        	var instrumentId = 0;
			var currencyPairId = 0;

        	vm.clearcorpTradesOutstandingReportDetails = [];

        	if(moment(vm.fromSetDate).isAfter(vm.toSetDate,'day')){
        		AlertService.error($filter('translate')('gatewayApp.settlementReport.greaterFromDate'));
        		vm.valid=false;
        	}
        	else{
				vm.valid = true;
				vm.clicked=true;
        		if(vm.bank!=null){
        			bankId = vm.bank.id;
        		}
        		if(vm.branch!=null){
        			branchId = vm.branch.id;
        		}
        		if(vm.customer!=null){
        			customerId = vm.customer.id;
        		}
        		if(vm.instrument!=null){
        			instrumentId = vm.instrument.id;
        		}
				if(vm.currencyPair!=null){
        			currencyPairId = vm.currencyPair.id;
        		}

				copyFilterParams(bankId, branchId, customerId, instrumentId, angular.copy(vm.fromSetDate), angular.copy(vm.toSetDate),currencyPairId);

        		OrderStatusDetails.getTradesOutstandingList({bankId: bankId, branchId: branchId, customerId: customerId, instrumentId: instrumentId, 
        			fromSetDate: DateUtils.convertLocalDateToServer(vm.fromSetDate),toSetDate : DateUtils.convertLocalDateToServer(vm.toSetDate), currencyPairId: currencyPairId}, onGetTradeOSSuccess, onGetTradeOSFailure)

        	}
        }

        function onGetTradeOSSuccess(result){
        	angular.forEach(result,function(value){
        		value.tradeTime=moment(value.tradeTime,'YYYYMMDDHHmmss.SSSSSSSSS').format();
        	});
        	vm.clearcorpTradesOutstandingReportDetails = result;
			vm.clicked=false;
        }

		function onGetTradeOSFailure(error){
			vm.clicked=false;
        }

		function copyFilterParams(bankId, branchId, customerId, instrumentId, fromSetDate, toSetDate, currencyPairId){
			vm.filterData = {};
			
			vm.filterData.bankId = bankId;
			vm.filterData.branchId = branchId;
			vm.filterData.customerId = customerId;
			vm.filterData.instrumentId = instrumentId;
			vm.filterData.fromSetDate = fromSetDate;
			vm.filterData.toSetDate = toSetDate;
			vm.filterData.currencyPairId = currencyPairId;

		}
        
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }

		function exportDataToExcelFile(){
      	 
      	  if(vm.clearcorpTradesOutstandingReportDetails  !=null &&   vm.clearcorpTradesOutstandingReportDetails !=undefined &&  vm.clearcorpTradesOutstandingReportDetails .length>0){
      		 
      			vm.mimeType = 'application/vnd.ms-excel';
      			vm.extension = ".xls";  
				var selectedTrades = angular.copy(vm.clearcorpTradesOutstandingReportDetails);
				angular.forEach(selectedTrades,function(value,index){        		
					value.tradeTime = moment(value.tradeTime).format('YYYYMMDDHHmmss.SSSSSSSSS');    	        		 	        		
				});
				ClearcorpTradesOutstandingReportService.getTradesOutstandingExcel({bankId: vm.filterData.bankId, branchId: vm.filterData.branchId, customerId: vm.filterData.customerId, instrumentId: vm.filterData.instrumentId, 
        			fromSetDate: DateUtils.convertLocalDateToServer(vm.filterData.fromSetDate),toSetDate : DateUtils.convertLocalDateToServer(vm.filterData.toSetDate), currencyPairId: vm.filterData.currencyPairId},selectedTrades, processResponse);
      		 
      	  }
        }       
        function exportDataToCsvFile(){        	
        		
        	  if( vm.clearcorpTradesOutstandingReportDetails !=null &&  vm.clearcorpTradesOutstandingReportDetails!=undefined && vm.clearcorpTradesOutstandingReportDetails.length>0){
        		 
        			vm.mimeType = 'text/csv';
        			vm.extension = ".csv";  
					var selectedTrades = angular.copy(vm.clearcorpTradesOutstandingReportDetails);
					angular.forEach(selectedTrades,function(value,index){        		
						value.tradeTime = moment(value.tradeTime).format('YYYYMMDDHHmmss.SSSSSSSSS');    	        		 	        		
					});

					ClearcorpTradesOutstandingReportService.getTradesOutstandingCsv({bankId: vm.filterData.bankId, branchId: vm.filterData.branchId, customerId: vm.filterData.customerId, instrumentId: vm.filterData.instrumentId, 
						fromSetDate: DateUtils.convertLocalDateToServer(vm.filterData.fromSetDate),toSetDate : DateUtils.convertLocalDateToServer(vm.filterData.toSetDate), currencyPairId: vm.filterData.currencyPairId},selectedTrades, processResponse);
					 
        	  }
        }
	    
	    function processResponse(result){
	      	  var fileData = null;
	  		  fileData = result.data;
	  		  var link = document.createElement("a");   
	  		  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
	  		  vm.baseString =     vm.fileName + moment().format(vm.reportFileTimestampFormat) +  vm.extension;   	
	  		  
	  	      var blob = new Blob([bytes], {type: vm.mimeType});
	  	      if(window.navigator.msSaveOrOpenBlob) {
	                  window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
	  	      }else{
	  	    	  link.href =  window.URL.createObjectURL(blob);      
	  	    	  link.download = vm.baseString;
	  	    	  document.body.appendChild(link);
	  	    	  link.click();
	  	    	  document.body.removeChild(link);
	  	      }
	  	}

		
	 $scope.$watch('vm.currencyPair', function (value) {
         if (value != null && value != undefined) {
			getInstrumentMatchedCurrencypair();
    	}
		})

		function getInstrumentMatchedCurrencypair(){
            var currencyPairId = vm.globalValues.getDefaultCurrencyPairId();
            if (!vm.currencyPair != null && vm.currencyPair != undefined) {
                currencyPairId = vm.currencyPair.id;
            }
			DefaultMarket.csInstruments({currencyPairId:currencyPairId},onGetInstrumentSuccess, onGetInstrumentFailure);
            
        } 

		function onGetInstrumentSuccess(result) {
            vm.instrumentTypes = result;
            // get tick size for each instrument
		}

		function onGetInstrumentFailure() {

        }

    }
})();
(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.service("workflowSharedService", function () {        	
		this.viewFrom= 'tacUpload'
	})

	.controller('ClearcorpTACViewController', ClearcorpTACViewController);

	ClearcorpTACViewController.$inject = ['$scope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
		'AlertService','$rootScope','ClearcorpTACUpload','$timeout','TacViewForEntitiesUtility'];

	function ClearcorpTACViewController($scope, $state,  GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
			AlertService,$rootScope,ClearcorpTACUpload,$timeout,TacViewForEntitiesUtility) {

		var vm = this;
		vm.entityConstants = entityConstants;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.TERMS_AND_CONDITIONS_VIEW;
		vm.uploadScreenName = entityConstants.ENTITY_SHORT_NAME.CLEARCORP_TAC_UPLOAD;
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;
		vm.globalValues=GlobalValues;
		vm.screenLog = ScreenLog;
		vm.filterData = {};	    
		vm.extension = "";
		workflowSharedService.viewFrom = "tacUpload";
		logScreenAccess();
		loadAll();
		vm.valid = false;
		//vm.clearcorpTACDetails = entity
		vm.openTACPreview = openTACPreview;
		vm.uploadTAC = uploadTAC;
		$scope.refresh=refresh;
		 //removing the permission to avoid the conflict
		//vm.permitTACImportEntityAction = EntityPermissions.hasPermission('TermsAndConditionsUpload.IMPORT');
		//vm.permitTACViewEntityAction = EntityPermissions.hasPermission('TermsAndConditionsView.VIEW');


		function base64ToArrayBuffer(base64) {
			var binary_string =  window.atob(base64);
			var len = binary_string.length;
			var bytes = new Uint8Array( len );
			for (var i = 0; i < len; i++)        {
				bytes[i] = binary_string.charCodeAt(i);
			}
			return bytes.buffer;
		}

		function openTACPreview(tacFile){
			/*var y = window.outerHeight / 2 + window.screenY - ( 700 / 2);
			var x = window.outerWidth / 2 + window.screenX - ( 700 / 2);

			var contentByteArray = base64ToArrayBuffer(pdfContent);
			var file = new Blob([contentByteArray], {type: 'application/pdf'});
			$scope.fileURL = URL.createObjectURL(file);
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(file, "TermsAndConditions.pdf");
			}
			else {
				var win =  window.open($scope.fileURL, "_blank", "width=700,height=700,"+"top="+y+", left="+x);  

			}*/
			TacViewForEntitiesUtility.previewTAC(tacFile.fileContent,tacFile.fileName);	
		}

		function uploadTAC(tacDetails){
			ScreenLog.screenLog(vm.uploadScreenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
			$state.go('terms-condition-upload',{id:tacDetails.id});

		}

		function logScreenAccess(){
			ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}

		vm.loadAll = loadAll;
		function loadAll() {
			vm.clearcorpTACDetails = [];
			ClearcorpTACUpload.getTermsConditionDetails({organisationId:GlobalValues.getOrgId()},function(result) {
				vm.clearcorpTACDetails = result;

			});
		}


		$scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };

	}
})();
 (function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('clearcorp-tac-upload-view', {
            parent: 'entity',
            params:{screen:'TermsAndConditionsUpload'},
            url: '/clearcorp-tac-upload-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.clearCorpTACUpload.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/clearcorp-terms-condition-upload/clearcorp-tac-view.html',
                    controller: 'ClearcorpTACViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clearCorpTACUpload');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
                /*,entity: ['ClearcorpTACUpload','GlobalValues', function(ClearcorpTACUpload,GlobalValues) {
                    return ClearcorpTACUpload.getTermsConditionDetails({organisationId:GlobalValues.getOrgId()}).$promise;
                }],*/
               
            }
        })
        
         .state('agreed-bank-details', {
            parent: 'clearcorp-tac-upload-view',
            url: '/agreed-bank-details',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'clearcorp-tac-upload-view'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clearcorp-terms-condition-upload/clearcorp-tac-bank-agreed-view.html',
                    controller: 'AgreedBanksController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                        entity: ['ClearcorpTACUpload','GlobalValues', function(ClearcorpTACUpload,GlobalValues) {
                            return ClearcorpTACUpload.getAgreedBankDetails().$promise;
                        }],
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
            	
                
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('clearCorpTACUpload');
                    $translatePartialLoader.addPart('agreedBanks');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('clearcorp-bank-tac-view', {
            parent: 'clearcorp-tac-upload-view',
            url: '/banks-terms-and-condition',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'clearcorp-tac-upload-view'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clearcorp-terms-condition-upload/clearcorp-bank-tac-view.html',
                    controller: 'ClearcorpBankTACViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                        entity: ['ClearcorpTACUpload','GlobalValues', function(ClearcorpTACUpload,GlobalValues) {
                            return ClearcorpTACUpload.getBankTermsAndConditions().$promise;
                        }],
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {                
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('clearCorpTACUpload');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
       
        
        
        .state('terms-condition-upload', {
            parent: 'clearcorp-tac-upload-view',
            url: '/terms-condition-upload/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clearcorp-terms-condition-upload/clearcorp-tac-edit.html',
                    controller: 'ClearcorpTACEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity:['ClearcorpTACUpload', function(ClearcorpTACUpload) {
                            		 return ClearcorpTACUpload.getTermConditionDTO({id : $stateParams.id}).$promise;
                                 }],
                                 globalValue: ['StaticLookUp', function(StaticLookUp) {
                                     return StaticLookUp.getConfigSettings().$promise;
                                 }],
                                 systemSettings: ['IntradayMarket', function(IntradayMarket) {
                                     return IntradayMarket.getCurrentBusinessDate().$promise;
                                 }],
                                 configurationSetting :['GlobalValues', function(GlobalValues) {
                                     return GlobalValues.getConfigSettings();
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('terms-condition-upload-todolist', {
            parent: 'dashboard',
            url: '/terms-condition-upload-to-do',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clearcorp-terms-condition-upload/clearcorp-tac-approval.html',
                    controller: 'ClearcorpTACEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                        systemSettings: ['IntradayMarket', function(IntradayMarket) {
                            return IntradayMarket.getCurrentBusinessDate().$promise;
                        }],
                        configurationSetting :['GlobalValues', function(GlobalValues) {
                            return GlobalValues.getConfigSettings();
                        }]
                    }
                }).result.then(function() {
                	$state.go('clearcorp-tac-upload-view', null, { reload: 'clearcorp-tac-upload-view' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clearCorpTACUpload');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
            
        })
        .state('terms-condition-upload-todolist-resubmit', {
            parent: 'dashboard',
            url: '/clearcorp-tac-resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clearcorp-terms-condition-upload/clearcorp-tac-edit.html',
                    controller: 'ClearcorpTACEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        },
                        globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                        systemSettings: ['IntradayMarket', function(IntradayMarket) {
                            return IntradayMarket.getCurrentBusinessDate().$promise;
                        }],
                        configurationSetting :['GlobalValues', function(GlobalValues) {
                            return GlobalValues.getConfigSettings();
                        }]
                    }
                }).result.then(function() {
                	$state.go('clearcorp-tac-upload-view', null, { reload: 'clearcorp-tac-upload-view' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clearCorpTACUpload');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
          .state('terms-condition-upload-auditLog', {
            parent: 'audit-log',
            url: '/terms-condition-upload-audit-log',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clearcorp-terms-condition-upload/clearcorp-tac-approval.html',
                    controller: 'ClearcorpTACEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                        systemSettings: ['IntradayMarket', function(IntradayMarket) {
                            return IntradayMarket.getCurrentBusinessDate().$promise;
                        }],
                        configurationSetting :['GlobalValues', function(GlobalValues) {
                            return GlobalValues.getConfigSettings();
                        }]
                    }
                }).result.then(function() {
                	$state.go('clearcorp-tac-upload-view', null, { reload: 'clearcorp-tac-upload-view' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clearCorpTACUpload');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
            
        })
        
        
        .state('terms-condition-upload-historyReport', {
            parent: 'history-report',
            url: '/TACHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clearcorp-terms-condition-upload/clearcorp-tac-approval.html',
                    controller: 'ClearcorpTACEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                        systemSettings: ['IntradayMarket', function(IntradayMarket) {
                            return IntradayMarket.getCurrentBusinessDate().$promise;
                        }],
                        configurationSetting :['GlobalValues', function(GlobalValues) {
                            return GlobalValues.getConfigSettings();
                        }]
                    }
                }).result.then(function() {
                	$state.go('clearcorp-tac-upload-view', null, { reload: 'clearcorp-tac-upload-view' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         };
    })();

(function() {
	'use strict';
	angular
	.module('gatewayApp')
	.factory('ClearcorpTACUpload', ClearcorpTACUpload);

	ClearcorpTACUpload.$inject = ['$resource'];

	function ClearcorpTACUpload($resource) {
		var resourceUrl =  'api/terms-conditions-upload-details/terms-conditions/:id';

		return $resource(resourceUrl, {}, {


			'getTermsConditionDetails':{
				isArray:true,
				method: 'GET',
				params: {organisationId : '@organisationId'
				},
				url: 'api/terms-conditions-upload-details/:organisationId'
			},
			'getBankTermsAndConditions':{
				isArray:true,
				method: 'GET',
				url: 'api/terms-conditions-upload-details/get-all-bank-tac'
			},
			'getAgreedBankDetails':{
				isArray:true,
				method: 'GET',
				url: 'api/tac-agreed-view/get-all-bank-ccil-tac'
			},
			'getTermConditionDTO':{
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'resubmit':{
				 method: 'POST',
                 url: 'api/tasks/resubmit/tac-resubmit',
                 headers: {
 					'Content-Type': undefined
 				}

				
			},
			'resubmitWithoutMultipart':{
				 method: 'PUT',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/resubmit/tac-resubmit-without-multipart',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                	return angular.toJson(copy);
                }
				
			},
			'update':{
				method:'POST',
				url: 'api/terms-conditions-upload-details',

				headers: {
					'Content-Type': undefined
				}

			},
			'approve' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/approve'
			},
			'reject' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/reject'
			},
			'discard' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/discard'
			},
			'getCSVForAgreedBanks':{

				method: 'POST',
				url: 'api/terms-conditions-upload-details/agreed-banks/csv',
				responseType: 'arraybuffer',
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				} 
			},
			'getExcelForAgreedBanks':{

				method: 'POST',
				url: 'api/terms-conditions-upload-details/agreed-banks/excel',
				responseType: 'arraybuffer',
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				} 
			},
			'getTermsAndConditionsMerged':{
				method:'POST',
				url: 'api/terms-conditions-upload/export-merged-pdf',
				responseType: 'arraybuffer',
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				} 
			},
            'getTermsAndConditionsMergedCustomerView':{
				method:'POST',
				url: 'api/terms-conditions-upload/customer/export-merged-pdf',
				responseType: 'arraybuffer',
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				} 
			},
			'getCSVForBanksTermsAndConditionsView':{

				method: 'POST',
				url: 'api/terms-conditions-upload-details/banks-tac-view-clearcorp/csv',
				responseType: 'arraybuffer',
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				} 
			},
			'getExcelForBanksTermsAndConditions':{

				method: 'POST',
				url: 'api/terms-conditions-upload-details/banks-tac-view-clearcorp/excel',
				responseType: 'arraybuffer',
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				} 
			},

		});
	}
})();

(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.controller('ClearcorpTACEditController', ClearcorpTACEditController);

	ClearcorpTACEditController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','ClearcorpTACUpload','entity','DateUtils','Workflow','FileUtil','globalValue','TacViewForEntitiesUtility','systemSettings','AlertService','$filter','configurationSetting'];

	function ClearcorpTACEditController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,ClearcorpTACUpload,entity,DateUtils,Workflow,FileUtil,globalValue,TacViewForEntitiesUtility,systemSettings,AlertService,$filter,configurationSetting) {
		var vm = this;
		vm.clearCorpTermsAndCondtionsUploadDTO=entity;   

		vm.clear=clear;
		vm.save=save;
		vm.clicked=false;
		$scope.showButton = false;
		$scope.showApproveRejectButton=false;
		$scope.showDiscardButton = false;
		$scope.showResubmitButton=false;
		vm.resubmitTAC = resubmitTAC;
		vm.globalValues = GlobalValues;
		vm.discardTAC = discardTAC;
		vm.rejectTAC = rejectTAC;
		vm.approveTAC = approveTAC;
		vm.viewMode=false;
		vm.checkTACFile=false;
		vm.configSettings = globalValue;
		vm.maxFileNameLength = (vm.configSettings.uploadedFileNameLength != null && vm.configSettings.uploadedFileNameLength != undefined && vm.configSettings.uploadedFileNameLength != '') ?vm.configSettings.uploadedFileNameLength : 150 ;
		var minFileSizeinBytes = 0;
		var maxFileSizeinBytes = 500;
		vm.maximumFileSizeinKB = (configurationSetting != null && configurationSetting != undefined && configurationSetting.maximumFileSizeTermsAndConditionsUpload != null && configurationSetting.maximumFileSizeTermsAndConditionsUpload != undefined && configurationSetting.maximumFileSizeTermsAndConditionsUpload != '') ? parseInt(configurationSetting.maximumFileSizeTermsAndConditionsUpload) : 500 ;
		vm.minimumFileSizeInKB = 0;
		if( vm.minimumFileSizeInKB != undefined &&  vm.minimumFileSizeInKB !=null &&  vm.minimumFileSizeInKB  !=''){
			minFileSizeinBytes = vm.minimumFileSizeInKB*1024;
		}
		if( vm.maximumFileSizeinKB != undefined &&  vm.maximumFileSizeinKB !=null &&  vm.maximumFileSizeinKB  !=''){

			maxFileSizeinBytes = vm.maximumFileSizeinKB*1024;
			if(vm.maximumFileSizeinKB == 1024){
				vm.showInKB = false;
				vm.tacFileUploadSize = 1;
			}else{
				vm.showInKB = true;
				vm.tacFileUploadSize = vm.maximumFileSizeinKB;
			}
		}
		var Extensions = "pdf";
		vm.minDate = new Date();
		vm.minDate.setDate(new Date().getDate() + 1);

		$scope.showButton = false;
		vm.orgId = vm.globalValues.getOrgId();
		vm.configurationSettings = vm.globalValues.getConfigSettings();
		if(systemSettings != null && systemSettings != undefined){
			vm.businessDate  = DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
			//vm.minDate = vm.minDate.vm.businessDate + 1;
			var daysAdded = 1;
			if(vm.configurationSettings.intervalNoOfDaysToConfigureTACEnforcementDate != null && vm.configurationSettings.intervalNoOfDaysToConfigureTACEnforcementDate != undefined){
				daysAdded = parseInt(vm.configurationSettings.intervalNoOfDaysToConfigureTACEnforcementDate);
			}
			vm.businessDatePlusOne =  moment(vm.businessDate).add(daysAdded,'days').toDate();
			vm.minDate = angular.copy(vm.businessDatePlusOne);
		}


		if(workflowSharedService.viewFrom == 'tacUpload'){
			vm.clearCorpTermsAndCondtionsUploadDTO=entity;
			vm.clearCorpTermsAndCondtionsUploadDTO.enforcingDate = vm.minDate;
			$scope.showButton = true;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton=false;
			vm.viewMode=false;
		}
		else if(workflowSharedService.viewFrom == 'termsConditionUploadtodolist_resubmit') {
			vm.clearCorpTermsAndCondtionsUploadDTO =  angular.copy(angular.fromJson($rootScope.payload));
			vm.clearCorpTermsAndCondtionsUploadDTO.enforcingDate = DateUtils.convertLocalDateFromServer(vm.clearCorpTermsAndCondtionsUploadDTO.tacMaster.enforcingDate);

			$scope.showButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton=true;
			vm.viewMode=false;
		}
		else if(workflowSharedService.viewFrom == 'termsConditionUpload_todolist_checker') {
			vm.clearCorpTermsAndCondtionsUploadDTO =  angular.fromJson($rootScope.payload); 
			vm.clearCorpTermsAndCondtionsUploadDTO.enforcingDate =DateUtils.convertLocalDateFromServer( vm.clearCorpTermsAndCondtionsUploadDTO.tacMaster.enforcingDate);
			vm.viewMode=true;
			$scope.showButton = false;
			$scope.showApproveRejectButton = true;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton=false;
		}
		else if(workflowSharedService.viewFrom == 'termsConditionUpload_todolist_maker') {
			vm.clearCorpTermsAndCondtionsUploadDTO =  angular.fromJson($rootScope.payload); 
			vm.clearCorpTermsAndCondtionsUploadDTO.enforcingDate =DateUtils.convertLocalDateFromServer( vm.clearCorpTermsAndCondtionsUploadDTO.tacMaster.enforcingDate);
			vm.viewMode=true;
			$scope.showButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = true;
			$scope.showResubmitButton=false;
		}
		else if(workflowSharedService.viewFrom=='termsConditionUpload_auditlog'){
			vm.clearCorpTermsAndCondtionsUploadDTO =  angular.fromJson($rootScope.payload); 
			vm.clearCorpTermsAndCondtionsUploadDTO.enforcingDate =DateUtils.convertLocalDateFromServer( vm.clearCorpTermsAndCondtionsUploadDTO.tacMaster.enforcingDate);			vm.viewMode=true;
			$scope.showButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton=false;

		}
		function base64ToArrayBuffer(base64) {
			var binary_string =  window.atob(base64);
			var len = binary_string.length;
			var bytes = new Uint8Array( len );
			for (var i = 0; i < len; i++)        {
				bytes[i] = binary_string.charCodeAt(i);
			}
			return bytes.buffer;
		}

		vm.openTACPreview = openTACPreview;
		function openTACPreview(tacAgreedDetail){
			 /*var y = window.outerHeight / 2 + window.screenY - ( 700 / 2);
			  var x = window.outerWidth / 2 + window.screenX - ( 700 / 2);
			var contentByteArray = base64ToArrayBuffer(pdfContent);
			var file = new Blob([contentByteArray], {type: 'application/pdf'});
			$scope.fileURL = URL.createObjectURL(file);
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(file, "TermsAndConditions.pdf");
			}
			else {
				var win =  window.open($scope.fileURL, "_blank", "width=700,height=700,"+"top="+y+", left="+x);  
				
			}*/
			TacViewForEntitiesUtility.previewTAC(tacAgreedDetail.fileContent, tacAgreedDetail.fileName);
		}



		function clear () {
			$uibModalInstance.dismiss('cancel');
		}

		function save () {   
			//check if the terms and condition is not null before saving
			if(moment(vm.minDate).isAfter(DateUtils.convertLocalDateToServer(vm.clearCorpTermsAndCondtionsUploadDTO.enforcingDate))){
				vm.clicked = false;
				AlertService.error($filter('translate')('gatewayApp.clearCorpTACUpload.enforcingDateGreater'));
				
			}
			else{
				if(vm.termsCondition != null){
					var fd1 = new FormData();
					vm.clearCorpTermsAndCondtionsUploadDTO.tacMaster.tacFiles.fileName = vm.termsCondition.name;
					vm.clearCorpTermsAndCondtionsUploadDTO.tacMaster.enforcingDate = DateUtils.convertLocalDateToServer(vm.clearCorpTermsAndCondtionsUploadDTO.enforcingDate);
					fd1.append('dto', JSON.stringify(vm.clearCorpTermsAndCondtionsUploadDTO));
					fd1.append('file', vm.termsCondition);
					ClearcorpTACUpload.update(fd1, onSaveSuccess, onSaveError);
				}
			}
		}


		function onSaveSuccess (result) {
			$uibModalInstance.close(result);  
		}


		function onSaveError () {

			vm.clicked = false;
		}
		function resubmitTAC() {
			if(moment(vm.minDate).isAfter(DateUtils.convertLocalDateToServer(vm.clearCorpTermsAndCondtionsUploadDTO.enforcingDate))){
				vm.clicked = false;
				AlertService.error($filter('translate')('gatewayApp.clearCorpTACUpload.enforcingDateGreater'));
				
			}
			else{

				if(vm.termsCondition != null){
					var fd1 = new FormData();
					vm.clearCorpTermsAndCondtionsUploadDTO.tacMaster.tacFiles.fileName = vm.termsCondition.name;
					vm.clearCorpTermsAndCondtionsUploadDTO.tacMaster.enforcingDate = DateUtils.convertLocalDateToServer(vm.clearCorpTermsAndCondtionsUploadDTO.enforcingDate);
					fd1.append('id', JSON.stringify($rootScope.taskID));
					fd1.append('dto', JSON.stringify(vm.clearCorpTermsAndCondtionsUploadDTO));
					fd1.append('file', vm.termsCondition);
					ClearcorpTACUpload.resubmit( fd1, onResubmitSuccess, onResubmitError);


				}
			}

		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.dismiss('cancel');
		}        
		function onResubmitError(error) {
			vm.clicked = false;
		}

		function approveTAC() { 
			ClearcorpTACUpload.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
			   	
		}

		function onApproveSuccess(result) {
			$uibModalInstance.dismiss('cancel');  
			$rootScope.removeRow($rootScope.taskID);        	
		}        
		function onApproveError(error) {
			vm.clicked = false;
		}

		function rejectTAC() { Workflow.rejectTask($rootScope.taskID); }

		function discardTAC() {
			ClearcorpTACUpload.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
			$uibModalInstance.dismiss('cancel');	
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);        	
		}        
		function onDiscardError(error) {

		}



		//validate terms and condition 
		$scope.$watch('vm.termsCondition', function(value){
			if(value!= undefined && value!=null){
				if(!FileUtil.isFileSizeValid(value.size ,minFileSizeinBytes , maxFileSizeinBytes  )){
					vm.invalidTermsConditionSize = true;
					if(vm.showInKB == true){
						vm.invalidTermsConditionSixeText = "Maximum of " + vm.tacFileUploadSize +" KB file size is allowed";
					}else{
						vm.invalidTermsConditionSixeText = "Maximum of " + vm.tacFileUploadSize +" MB file size is allowed";
					}
					vm.invalidTermsCondition = false;
					vm.invalidTermsConditionName = false;
					vm.termsCondition=null;
					angular.element("input[type='file']").val(null);

				}else{
					vm.inputTermsCondition=vm.termsCondition.name;
					vm.invalidTermsConditionSize = false;
					vm.invalidTermsCondition = false;
					vm.invalidTermsConditionName = false;
					vm.fileExtension = vm.inputTermsCondition.substring(vm.termsCondition.name.lastIndexOf(".") + 1);
					var fileNameWithoutExtension  =  vm.inputTermsCondition.substring(0,vm.termsCondition.name.lastIndexOf("."));

					//check for extension
					if(!(Extensions == (vm.fileExtension.toLowerCase()))) {
						angular.element("input[type='file']").val(null);
						vm.termsCondition=null;
						vm.inputTermsCondition=null;
						vm.invalidTermsCondition = true;
						vm.invalidTermsConditionSize = false;
						vm.invalidTermsConditionName = false;
						vm.invalidTermsConditionText = "Accepted file format .pdf";
					}
					else if(!FileUtil.isFileNameValid(fileNameWithoutExtension,vm.maxFileNameLength )){
	    				 angular.element("input[type='file']").val(null);
	    				 vm.termsCondition=null;
				         vm.inputTermsCondition=null;
				         vm.invalidTermsCondition = false;
				         vm.invalidTermsConditionSize = false;
				         vm.invalidTermsConditionName = true;
				         vm.invalidTermsConditionNameText = "Uploaded pdf file name should not exceed " + vm.maxFileNameLength+ " charaters.";
				         
	    			 }

					else{ // check for malicious file with correct extension
						var reader = new FileReader();
						reader.readAsArrayBuffer(value.slice(0,4));
						reader.onloadend = function(e){
							if (e.target.readyState === FileReader.DONE) {
								var arrayBuffer = e.target.result;
								var bytes = new Uint8Array( arrayBuffer );
								if(!FileUtil.checkTermsConditionExtension(bytes)){
									angular.element("input[type='file']").val(null);
									vm.termsCondition=null;
									vm.inputTermsCondition=null;
									vm.invalidTermsCondition = true;
									vm.invalidTermsConditionSize = false;
									vm.invalidTermsConditionName = false;
									vm.invalidTermsConditionText = "Accepted file format .pdf";
								}
								else{
									vm.invalidTermsConditionSize = false;
									vm.invalidTermsCondition =false;
									vm.invalidTermsConditionName = false;


								}
								$scope.$digest();
							}
						}; 
					}
				}
			}
			else{
				angular.element("input[type='file']").val(null);

				vm.inputTermsCondition=null;
			}
		});


	}   
})();

(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.service("workflowSharedService", function () {        	
		this.viewFrom= 'agreedBankList'
	})

	.controller('AgreedBanksController', AgreedBanksController);

	AgreedBanksController.$inject = ['$scope','$rootScope','$state',  'GlobalValues', 'workflowSharedService', '$uibModalInstance','EntityPermissions', 'ScreenLog','entityConstants','$timeout','entity','DateUtils','ClearcorpTACUpload','TacViewForEntitiesUtility'];

	function AgreedBanksController($scope,$rootScope,$state, GlobalValues, workflowSharedService, $uibModalInstance, EntityPermissions, ScreenLog,entityConstants,$timeout,entity,DateUtils,ClearcorpTACUpload,TacViewForEntitiesUtility) {
		var vm = this;
		vm.entityConstants = entityConstants;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.TERMS_AND_CONDITIONS_VIEW;
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;
		vm.globalValues=GlobalValues;
		vm.screenLog = ScreenLog;
		vm.clear=clear;
		vm.agreedBankList=entity;
		vm.openTACPreview = openTACPreview;
		vm.exportToFile = exportToFile;
		 vm.permitTACViewEntityAction = EntityPermissions.hasPermission('TermsAndConditionsView.VIEW');

		function exportToFile(fileType){
			vm.baseString =   'Agreed_Banks_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   	
			if( vm.agreedBankList !=null &&  vm.agreedBankList !=undefined){
				if(fileType == 'csv'){
					vm.mimeType = 'text/csv'
						vm.baseString = vm.baseString+ ".csv";  
					ClearcorpTACUpload.getCSVForAgreedBanks(vm.agreedBankList , processResponse );
				}else if(fileType == 'excel'){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.baseString = vm.baseString+ ".xls";  
					ClearcorpTACUpload.getExcelForAgreedBanks(vm.agreedBankList , processResponse );
				}
			}
		}	
		function processResponse(result){
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
			//ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.EXPORT_AGREED_BANKS); - action not required for export
		}

		function openTACPreview(agreedBank){
			vm.seletedFileName = agreedBank.fileName;
			var fd1 = new FormData();			
			ClearcorpTACUpload.getTermsAndConditionsMerged(agreedBank, onMergeSuccess, onMergeError);
		}

		function onMergeSuccess (result) {
			/*var y = window.outerHeight / 2 + window.screenY - ( 700 / 2);
			  var x = window.outerWidth / 2 + window.screenX - ( 700 / 2);
			var file = new Blob([result.data], {type: 'application/pdf'});
			var fileURL = URL.createObjectURL(file);
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(file, "TermsAndCondition.pdf");
			}
			else {
				window.open(fileURL, "_blank",  "width=700,height=700,"+"top="+y+", left="+x);    
			}*/
			TacViewForEntitiesUtility.previewTACForArray(result.data, "Clearcorp's Terms and Conditions for Member.pdf");	

		}


		function onMergeError () {

		}
		logScreenAccess(); // screen log required for view agreed banks
		function logScreenAccess(){
			ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.VIEW_AGREED_BANKS);
		}


		function clear () {
			$uibModalInstance.dismiss('cancel');
		}
		

	
	}
})();

(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.service("workflowSharedService", function () {        	
		this.viewFrom= 'clearcorpBankTACView'
	})

	.controller('ClearcorpBankTACViewController', ClearcorpBankTACViewController);

	ClearcorpBankTACViewController.$inject = ['$scope','$rootScope','$state',  'GlobalValues', 'workflowSharedService', '$uibModalInstance','EntityPermissions', 'ScreenLog','entityConstants','$timeout','entity','DateUtils','ClearcorpTACUpload','TacViewForEntitiesUtility'];

	function ClearcorpBankTACViewController($scope,$rootScope,$state, GlobalValues, workflowSharedService, $uibModalInstance, EntityPermissions, ScreenLog,entityConstants,$timeout,entity,DateUtils,ClearcorpTACUpload,TacViewForEntitiesUtility) {
		var vm = this;
		vm.entityConstants = entityConstants;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.TERMS_AND_CONDITIONS_VIEW;
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;
		vm.globalValues=GlobalValues;
		vm.screenLog = ScreenLog;
		vm.clear=clear;
		vm.bankTermsAndConditionsList=entity;
		vm.openTACPreview = openTACPreview;
		vm.exportToFile = exportToFile;
		 vm.permitTACViewEntityAction = EntityPermissions.hasPermission('TermsAndConditionsView.VIEW');

		function exportToFile(fileType){
			vm.baseString =   'Bank\'s_Terms_And_Conditions_For_Customers_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   	
			if( vm.bankTermsAndConditionsList !=null &&  vm.bankTermsAndConditionsList !=undefined){
				if(fileType == 'csv'){
					vm.mimeType = 'text/csv'
						vm.baseString = vm.baseString+ ".csv";  
					ClearcorpTACUpload.getCSVForBanksTermsAndConditionsView(vm.bankTermsAndConditionsList , processResponse );
				}else if(fileType == 'excel'){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.baseString = vm.baseString+ ".xls";  
					ClearcorpTACUpload.getExcelForBanksTermsAndConditions(vm.bankTermsAndConditionsList , processResponse );
				}
			}
		}	
		function processResponse(result){
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}

		function openTACPreview(bankTACClearcorp){
			var fd1 = new FormData();
			var contentByteArray = base64ToArrayBuffer(bankTACClearcorp.tacMaster.tacFiles.fileContent);
			TacViewForEntitiesUtility.previewTACForArray(contentByteArray, "Banks's Terms and Conditions for Customer.pdf");	
		}
		
		function base64ToArrayBuffer(base64) {
    	    var binary_string =  window.atob(base64);
    	    var len = binary_string.length;
    	    var bytes = new Uint8Array( len );
    	    for (var i = 0; i < len; i++)        {
    	        bytes[i] = binary_string.charCodeAt(i);
    	    }
    	    return bytes.buffer;
    	}
        

		logScreenAccess(); // screen log required for view agreed banks
		function logScreenAccess(){
			ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.VIEW_BANKS_TAC_FOR_CUSTOMERS);
		}


		function clear () {
			$uibModalInstance.dismiss('cancel');
		}
		

	
	}
})();


(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.service("workflowSharedService", function () {        	
		this.viewFrom= ''
	})

	.controller('ClearcorpMemberBankHistoryController', ClearcorpMemberBankHistoryController);

	ClearcorpMemberBankHistoryController.$inject = ['$scope','$rootScope','$state',  'GlobalValues', 'workflowSharedService', '$uibModalInstance','EntityPermissions', 'ScreenLog','entityConstants','$timeout','DateUtils','MemberBanksFeeAndChargesViewService','BankFeeViewForEntitiesUtility','AlertService','$filter'];

	function ClearcorpMemberBankHistoryController($scope,$rootScope,$state, GlobalValues, workflowSharedService, $uibModalInstance, EntityPermissions, ScreenLog,entityConstants,$timeout,DateUtils,MemberBanksFeeAndChargesViewService,BankFeeViewForEntitiesUtility,AlertService,$filter) {
		var vm = this;
		vm.clear=clear;
		vm.go = go;
		vm.banksFeeChargeDTO = [];
		
		vm.globalValues = GlobalValues;
		vm.valid=false;
		
        vm.todayDate = new Date();
        vm.fromDate = DateUtils.convertDateTimeFromServer(vm.todayDate);
        vm.toDate = DateUtils.convertDateTimeFromServer(vm.todayDate);
        
      //  vm.minDate = DateUtils.getMinimumLocalDate(new Date());
        vm.noOfMonthsForHistoricalView = vm.globalValues.getConfigSettings().noOfMOnthsForHistoricalReportsView;
        
        vm.clicked=false;
		vm.goClick = false;
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;
		
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.BANK_FEES_CHARGES_VIEW;
		vm.globalValues=GlobalValues;
		vm.screenLog = ScreenLog;
	
		vm.permitBankViewEntityAction = true;
		vm.openBankFeesChargesPreview = openBankFeesChargesPreview;
		function openBankFeesChargesPreview(memberBankFeesChargesFile){
			BankFeeViewForEntitiesUtility.previewBankFee(memberBankFeesChargesFile,'Bank Fees And Charges.pdf');	
		}

		
		
		function go() {
			
			if(moment(vm.fromDate).isAfter(vm.todayDate,'day')){
	   			AlertService.error($filter('translate')('gatewayApp.memberBanksFeesAndChargesView.futureFromDate'));
	   			vm.valid=false;
	   		}
	   		else if(moment(vm.fromDate).isAfter(vm.toDate,'day')){
	   			AlertService.error($filter('translate')('gatewayApp.memberBanksFeesAndChargesView.greaterFromDate'));
	   			vm.valid=false;
	   		}else if(moment(vm.toDate).isAfter(vm.todayDate,'day')){
	   			AlertService.error($filter('translate')('gatewayApp.memberBanksFeesAndChargesView.greaterToDate'));
	   			vm.valid=false;
	   		}
	   	/*	else if(moment(vm.fromDate).isBefore(vm.minDate, 'day')){
	   			AlertService.error('Historical Reports are available only for a period of '  + vm.noOfMonthsForHistoricalView + ' months...!');
	   			vm.valid=false;
	   		}*/
	   		else{
	   			vm.valid=true;
				vm.clicked=true;
	   			vm.convertedFromDate = DateUtils.convertLocalDateToServer(vm.fromDate);
		    	vm.convertedToDate = DateUtils.convertLocalDateToServer(vm.toDate);
		    	
		    	/*var from=$filter('date')(vm.fromDate, "yyyy-MM-dd");
	        	var to=$filter('date')(vm.toDate, "yyyy-MM-dd");*/
			
			MemberBanksFeeAndChargesViewService.getMemberBankHistoryViewDto({'fromDate':vm.convertedFromDate,'toDate':vm.convertedToDate},onRetreiveSuccess,onRetreiveFailure);
			vm.goClick = false;
				function onRetreiveSuccess(result) {
					console.log(result);
					vm.clicked=false;
					vm.banksFeeChargeDTO = result;
					vm.goClick = true;
					console.log(vm.banksFeeChargeDTO);

				}
				function onRetreiveFailure(error){
					console.log(error);
					vm.clicked=false;
				}
	   		}
			
		}
		
		
		$scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
	



		function clear () {
			$uibModalInstance.dismiss('cancel');
		}
		

	
	}
})();
//view-relationship-bank-fees-charges
//relationshipBankFeesChargesView

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	 $stateProvider
         .state('view-member-fees-charges', {
             parent: 'entity',
             url: '/view-member-fees-charges',
             data: {
            	 authorities: ['ROLE_USER'],
                 pageTitle: 'global.title'
             },
             ncyBreadcrumb: {
                 label: '{{ "global.menu.memberFeesAndCharges.main" | translate }}',
                 parent: 'home'
             },
             views: {
                 'content@': {
                     templateUrl: 'app/entities/clearcorp-member-bank-fee-charges-view/clearcorp-member-bank-fee-charges-view.html',
                     controller: 'MemberBanksFeesChargesViewController',
                     controllerAs: 'vm'
                 }
             },
             resolve: {
                 translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                 	$translatePartialLoader.addPart('error');
                     $translatePartialLoader.addPart('global');       
                 	$translatePartialLoader.addPart('memberBanksFeesAndChargesView');
                
                     return $translate.refresh();
                 }]
             }
         })
         
         .state('clearcorp-member-bank-history-view', {
             parent: 'view-member-fees-charges',
             url: '/member-bank-history-view',
             data: {
                 authorities: ['ROLE_USER'],
                 pageTitle: 'global.title'
             },
             ncyBreadcrumb: {
                 label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                 parent: 'view-member-fees-charges'
             },
             onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                 $uibModal.open({
                     templateUrl: 'app/entities/clearcorp-member-bank-fee-charges-view/clearcorp-member-bank-history.html',
                     controller: 'ClearcorpMemberBankHistoryController',
                     controllerAs: 'vm',
                     backdrop: 'static',
                     size: 'md',
                     resolve: {
                     	globalValue: ['StaticLookUp', function(StaticLookUp) {
                             return StaticLookUp.getConfigSettings().$promise;
                         }]
                     }
                 }).result.then(function() {
                     $state.go('^', {}, { reload: false });
                 }, function() {
                     $state.go('^');
                 });
             }],
             resolve: {                
                 translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                 	$translatePartialLoader.addPart('clearCorpTACUpload');
                     $translatePartialLoader.addPart('error');
                     $translatePartialLoader.addPart('global');
                     return $translate.refresh();
                 }]
                
             }
         })
         
         
     
         
    };
    })();

(function() {
	'use strict';
	angular
	.module('gatewayApp')
	.factory('MemberBanksFeeAndChargesViewService', MemberBanksFeeAndChargesViewService);

	MemberBanksFeeAndChargesViewService.$inject = ['$resource'];

	function MemberBanksFeeAndChargesViewService($resource) {
		var resourceUrl =  '/api';

		return $resource(resourceUrl, {}, {
			'getMemberBankViewDto':{
				method: 'GET',
				isArray: true,
				url: '/api/active-bank-fees-charges/get-all-bank-ccil-view',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}

			},
			'getMemberBankHistoryViewDto':{
				method: 'GET',
				isArray: true,
				params:{fromDate:'@fromDate',toDate:'@toDate'},
				url: '/api/history-bank-fees-charges-for-Period/get-all-bank-ccil-view',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}

			}
		
		

		});
	}
})();


(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.controller('MemberBanksFeesChargesViewController', MemberBanksFeesChargesViewController)

	MemberBanksFeesChargesViewController.$inject = ['ScreenLog','$scope', '$state', '$rootScope', 'GlobalValues','MemberBanksFeeAndChargesViewService', 'workflowSharedService', 'entityConstants','BankFeeViewForEntitiesUtility','$timeout'];

	function MemberBanksFeesChargesViewController( ScreenLog,$scope, $state, $rootScope, GlobalValues,MemberBanksFeeAndChargesViewService,workflowSharedService,entityConstants,BankFeeViewForEntitiesUtility,$timeout) {
		var vm = this;
		vm.banksFeeChargeDTO = [];
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.BANK_FEES_CHARGES_VIEW;
		vm.globalValues=GlobalValues;
		$scope.refresh=refresh;
		workflowSharedService.viewFrom = "bankFeesAndChargesView";
		vm.screenLog = ScreenLog;
		logScreenAccess();
		
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;
		vm.openBankFeesChargesPreview = openBankFeesChargesPreview;
		function openBankFeesChargesPreview(memberBankFeesChargesFile){
			BankFeeViewForEntitiesUtility.previewBankFee(memberBankFeesChargesFile,'Bank Fees And Charges.pdf');	
		}
		
		$scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };


		loadAll();
	
		function logScreenAccess(){
			ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}
		
		function loadAll() {
			MemberBanksFeeAndChargesViewService.getMemberBankViewDto(function (result){
				vm.banksFeeChargeDTO = result;
			});
		};

	
	/*	function loadAll() {
			MemberBanksFeeAndChargesViewService.getMemberBankViewDto().$promise.then(function(result) {
				console.log(result);				
				vm.banksFeeChargeDTO = result;
				console.log(vm.banksFeeChargeDTO);
	  	        });	
		};*/
		/*function onRetreiveSuccess(result) {
			console.log(result);
			
			vm.banksFeeChargeDTO = result;
			console.log(vm.banksFeeChargeDTO);

		}
		function onRetreiveFailure(error){
			console.log(error);
		}*/
		
		
		
		

	}
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-markup-view-report', {
            parent: 'entity',
            params:{screen: 'CustomerMarkupView'}, 
            url: '/customer-markup-view-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.markupReportForClearCorp.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/clearcorp-markup-report/clearcorp-markup-report.html',
                    controller: 'ClearCorpMarkupReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clearcorpMarkupReport');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('orderActivity');
                    return $translate.refresh();
                }]
               
            }
        })
                 
        
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ClearCorpMarkupReportService', ClearCorpMarkupReportService);

    ClearCorpMarkupReportService.$inject = ['$resource'];

    function ClearCorpMarkupReportService($resource) {
        var resourceUrl =  'api/markup/:id';
        
        return $resource(resourceUrl, {}, {
        	
        
        	'getMarkupForReport':{
          		isArray:true,
 				method: 'GET',
 				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', currencyPairCode : '@currencyPairCode'
 				},
 				url: 'api/markupsettings-for-customer'
           },
           'exportMarkupExcel':{
           	 method: 'GET',
                url: 'api/clearcorp-markup-report/excel-download',
                responseType: 'arraybuffer',
                params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', currencyPairCode : '@currencyPairCode'
                },
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                }      
           },
           'exportMarkupCsv':{
            	 method: 'GET',
                 url: 'api/clearcorp-markup-report/csv-download',
                 responseType: 'arraybuffer',
                 params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', currencyPairCode : '@currencyPairCode'
                 },
                 transformResponse: function(data, headers) {
               	  return {
                         data: data,
                         headers: headers
                     };   
                 }      
            },
            'exportMarkupPdf':{
             	 method: 'GET',
                  url: 'api/clearcorp-markup-report/pdf-download',
                  responseType: 'arraybuffer',
                  params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', currencyPairCode : '@currencyPairCode'
                  },
                  transformResponse: function(data, headers) {
                	  return {
                          data: data,
                          headers: headers
                      };   
                  }      
             }
        });
    }
   })();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'clearCorpMarkupReport'
        })
        
        .controller('ClearCorpMarkupReportController', ClearCorpMarkupReportController);

    ClearCorpMarkupReportController.$inject = ['$scope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
    	'DateUtils','AlertService','$filter',   'ClearCorpMarkupReportService', 'SODProcess'];

    function ClearCorpMarkupReportController($scope, $state,  GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
    		DateUtils,AlertService,$filter,  ClearCorpMarkupReportService, SODProcess) {
       
    	var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMER_MARKUP_VIEW;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
       
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.configSettings = vm.globalValues.getConfigSettings();
		
        /*vm.toTime = moment();
        vm.duration = moment.duration(  parseInt(vm.configSettings.timeDifferenceForTimePickerControl), 'hours')
	    vm.maxDate = moment().subtract( vm.duration);*/
	    vm.todayDate = new Date();
	    vm.getMarkup = getMarkup;
	    vm.exportDataToExcelFile = exportDataToExcelFile;
	    vm.exportDataToCsvFile = exportDataToCsvFile;
	    vm.exportDataToPdfFile = exportDataToPdfFile;
	    vm.filterData = {};	    
	    vm.fileName = "Customer_markup_view_as_on";
	    vm.extension = "";
	    vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
	    vm.ExpandOrCollapseMarkup = true;
	    logScreenAccess();
	    vm.valid = false;
		vm.clicked=false;
	    function loadDates() {
        	
			SODProcess.getCurrentBusinessDate(loadSystemSettingsSuccess, loadSystemSettingsError);
		}
    	function loadSystemSettingsSuccess(result){
			vm.lastSystemSetting = result;
			vm.todayDate = DateUtils.convertLocalDateFromServer(vm.lastSystemSetting.businessDate);
    	}
    	
    	function loadSystemSettingsError(){
			
		}
        loadDates(); 
                   
        function copyFilterData(){
        	
        	 if(vm.bank!=null && vm.bank !=undefined){
        		 
        		 vm.filterData.bankId = angular.copy(vm.bank.id);
        	 }else{
        		
        		 vm.filterData.bankId = 0;
        	 }
        	 if(vm.branch!=null && vm.branch!=undefined){
        		
        		 vm.filterData.branchId = angular.copy(vm.branch.id);
        	}else{
        		 
        		vm.filterData.branchId = 0;
        	}if(vm.customer!=null && vm.customer!=undefined){
        		 
        		vm.filterData.customerId = angular.copy(vm.customer.id);
        	}else{
        		
        		vm.filterData.customerId = 0;
        	}

			if(vm.currencyPair!=null && vm.currencyPair!=undefined){
        		 
        		vm.filterData.currencyPairCode = angular.copy(vm.currencyPair.code);
        	}else{
        		
        		vm.filterData.currencyPairCode = null;
        	}
        	
        }
        
        function getMarkup(){
        	vm.valid = true;
        	vm.clearcorpmarkupReportDetails = [];
        	copyFilterData();
        	ClearCorpMarkupReportService.getMarkupForReport({bankId: vm.filterData.bankId, branchId: vm.filterData.branchId, 
    			customerId:vm.filterData.customerId, currencyPairCode:vm.filterData.currencyPairCode }, 
    			onGetMarkupSuccess, onGetMarkupFailure);  		
        	
        }
        function onGetMarkupSuccess(result){        	 
        
        	 vm.clearcorpmarkupReportDetails = result;
			 vm.clicked=false;
        }
        function onGetMarkupFailure(error){
        	vm.clicked=false;
        }
        
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }
        function exportDataToExcelFile(){
      	 
      	  if(  vm.clearcorpmarkupReportDetails  !=null &&   vm.clearcorpmarkupReportDetails !=undefined &&  vm.clearcorpmarkupReportDetails .length>0){
      		 
      			vm.mimeType = 'application/vnd.ms-excel';
      			vm.extension = ".xls";  
      			ClearCorpMarkupReportService.exportMarkupExcel({bankId:  vm.filterData.bankId, branchId:  vm.filterData.branchId, 
        			customerId:  vm.filterData.customerId, currencyPairCode:  vm.filterData.currencyPairCode } 
      			, processResponse );
      		 
      	  }
        }       
        function exportDataToCsvFile(){        	
        		
        	  if( vm.clearcorpmarkupReportDetails !=null &&  vm.clearcorpmarkupReportDetails!=undefined && vm.clearcorpmarkupReportDetails.length>0){
        		 
        			vm.mimeType = 'text/csv';
        			vm.extension = ".csv";  
        			ClearCorpMarkupReportService.exportMarkupCsv({bankId:  vm.filterData.bankId, branchId:  vm.filterData.branchId, 
          			customerId:  vm.filterData.customerId,currencyPairCode:  vm.filterData.currencyPairCode } , processResponse );
        		 
        	  }
        }
	    function exportDataToPdfFile(){	    	
	    	
	      	  if( vm.clearcorpmarkupReportDetails !=null &&  vm.clearcorpmarkupReportDetails!=undefined && vm.clearcorpmarkupReportDetails.length>0){
	      		 
	      			vm.mimeType = 'application/pdf';
	      			vm.extension =  ".pdf";  
	      			ClearCorpMarkupReportService.exportMarkupPdf({bankId:  vm.filterData.bankId, branchId:  vm.filterData.branchId, 
	        			customerId:  vm.filterData.customerId, currencyPairCode:  vm.filterData.currencyPairCode } , processResponse );
	      		 
	      	  }
	    }
	    function processResponse(result){
	      	  var fileData = null;
	  		  fileData = result.data;
	  		  var link = document.createElement("a");   
	  		  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
	  		  vm.baseString =     vm.fileName + moment().format(vm.reportFileTimestampFormat) +  vm.extension;   	
	  		  
	  	      var blob = new Blob([bytes], {type: vm.mimeType});
	  	      if(window.navigator.msSaveOrOpenBlob) {
	                  window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
	  	      }else{
	  	    	  link.href =  window.URL.createObjectURL(blob);      
	  	    	  link.download = vm.baseString;
	  	    	  document.body.appendChild(link);
	  	    	  link.click();
	  	    	  document.body.removeChild(link);
	  	      }
	  	}
	   
    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('limit-utilisation-report', {
            parent: 'entity',
            params:{screen: 'LimitUtilisationReport'}, 
            url: '/limit-utilisation-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.limitUtilisationReport.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/clearcorp-limit-utilisation-report/clearcorp-limit-utilisation-report.html',
                    controller: 'ClearCorpLimitUtilisationReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clearcorpLimitUtilisationReport');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
                
        
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ClearCorpLimitUtilisedReportService', ClearCorpLimitUtilisedReportService);

    ClearCorpLimitUtilisedReportService.$inject = ['$resource'];

    function ClearCorpLimitUtilisedReportService($resource) {
        var resourceUrl =  'api/clearcorp-limits-reports/:id';
        
        return $resource(resourceUrl, {}, {
        	
        
        	'getLimitsForReport':{
          		isArray:true,
 				method: 'GET',
 				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'
 				},
 				url: 'api/clearcorp-limit-utilisation-report-details'
           },
           'exportLimitsExcel':{
           	 method: 'POST',
                url: 'api/clearcorp-limit-utilisation-report-details/excel-download',
                responseType: 'arraybuffer',
                params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'					
                },
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                },
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                }      
           },
           'exportLimitsCsv':{
            	 method: 'POST',
                 url: 'api/clearcorp-limit-utilisation-report-details/csv-download',
                 responseType: 'arraybuffer',
                 params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'						
                 },
                 transformRequest: function (data) {
                    	var copy = angular.copy(data);
                    	
                        return angular.toJson(copy);
                 },
                 transformResponse: function(data, headers) {
               	  return {
                         data: data,
                         headers: headers
                     };   
                 }      
            },
            'exportLimitsPdf':{
             	 method: 'POST',
                  url: 'api/clearcorp-limit-utilisation-report-details/pdf-download',
                  responseType: 'arraybuffer',
                  params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'
				  },
				  transformRequest: function (data) {
	                   	var copy = angular.copy(data);
	                   	
	                       return angular.toJson(copy);
	              },
                  transformResponse: function(data, headers) {
                	  return {
                          data: data,
                          headers: headers
                      };   
                  }      
             }
        });
    }
   })();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'clearCorpLimitUtilisationReportController'
        })
        
        .controller('ClearCorpLimitUtilisationReportController', ClearCorpLimitUtilisationReportController);

    ClearCorpLimitUtilisationReportController.$inject = ['$scope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
    	'DateUtils','AlertService','$filter', 'ClearCorpLimitUtilisedReportService','SODProcess'];

    function ClearCorpLimitUtilisationReportController($scope, $state,  GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
    		DateUtils,AlertService,$filter, ClearCorpLimitUtilisedReportService, SODProcess) {
       
    	var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.LIMIT_UTILISATION_REPORT;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.globalValues=GlobalValues;
        vm.screenLog = ScreenLog;
       
        vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.configSettings = vm.globalValues.getConfigSettings();
	
	    vm.todayDate = new Date();
	    vm.getLimitUtilised = getLimitUtilised;
		vm.clicked=false;
	    vm.exportDataToExcelFile = exportDataToExcelFile;
	    vm.exportDataToCsvFile = exportDataToCsvFile;
	    vm.exportDataToPdfFile = exportDataToPdfFile;
	    vm.filterData = {};
	    vm.fileName = "Limit_utilisation_report_";
	    vm.extension = "";
	    vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
	    	    
	    logScreenAccess();
	    vm.valid = false;
	   
	    function loadDates() {
        	
			SODProcess.getCurrentBusinessDate(loadSystemSettingsSuccess, loadSystemSettingsError);
		}
    	function loadSystemSettingsSuccess(result){
			vm.lastSystemSetting = result;
			vm.todayDate = DateUtils.convertLocalDateFromServer(vm.lastSystemSetting.businessDate);
    	}
    	
    	function loadSystemSettingsError(){
			
		}
        loadDates();      
        function copyFilterData(){
        	
        	 if(vm.bank!=null && vm.bank !=undefined){
        		 
        		 vm.filterData.bankId = angular.copy(vm.bank.id);
        	 }else{
        		
        		 vm.filterData.bankId = 0;
        	 }
        	 if(vm.branch!=null && vm.branch!=undefined){
        		
        		 vm.filterData.branchId = angular.copy(vm.branch.id);
        	}else{
        		 
        		vm.filterData.branchId = 0;
        	}if(vm.customer!=null && vm.customer!=undefined){
        		 
        		vm.filterData.customerId = angular.copy(vm.customer.id);
        	}else{
        		
        		vm.filterData.customerId = 0;
        	}
        	if(vm.instrument!=null && vm.instrument!=undefined){
        		 vm.filterData.instrumentId = angular.copy(vm.instrument.id);
        	}else{
        		vm.filterData.instrumentId = 0;
        	}
       }
        
        function getLimitUtilised(){
        		vm.valid = true;
        		copyFilterData();
        		ClearCorpLimitUtilisedReportService.getLimitsForReport({bankId: vm.filterData.bankId, branchId: vm.filterData.branchId, 
    			customerId:vm.filterData.customerId,  instrumentId: vm.filterData.instrumentId }, 
    			onGetLimitSuccess, onGetLimitFailure);
    			 		
        	
        }
        function onGetLimitSuccess(result){
        	 
        	 vm.limitUtilisationDetailsList = result;
			 vm.clicked=false;
        }
        function onGetLimitFailure(error){
        	vm.clicked=false;
        }
        
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }
        function exportDataToExcelFile(){
      	 
      	  if(  vm.limitUtilisationDetailsList  !=null &&   vm.limitUtilisationDetailsList !=undefined &&  vm.limitUtilisationDetailsList .length>0){
      		 
      			vm.mimeType = 'application/vnd.ms-excel';
      			vm.extension = ".xls";  
      			ClearCorpLimitUtilisedReportService.exportLimitsExcel({bankId:  vm.filterData.bankId, branchId:  vm.filterData.branchId, 
        			customerId:  vm.filterData.customerId,  instrumentId:  vm.filterData.instrumentId } ,vm.limitUtilisationDetailsList	, processResponse );
      		 
      	  }
        }       
        function exportDataToCsvFile(){        	
        		
        	  if( vm.limitUtilisationDetailsList !=null &&  vm.limitUtilisationDetailsList!=undefined && vm.limitUtilisationDetailsList.length>0){
        		 
        			vm.mimeType = 'text/csv';
        			vm.extension = ".csv";  
        			ClearCorpLimitUtilisedReportService.exportLimitsCsv({bankId:  vm.filterData.bankId, branchId:  vm.filterData.branchId, 
          			customerId:  vm.filterData.customerId,  instrumentId:  vm.filterData.instrumentId },vm.limitUtilisationDetailsList , processResponse );
        		 
        	  }
        }
	    function exportDataToPdfFile(){	    	
	    	
	      	  if( vm.limitUtilisationDetailsList !=null &&  vm.limitUtilisationDetailsList!=undefined && vm.limitUtilisationDetailsList.length>0){
	      		 
	      			vm.mimeType = 'application/pdf';
	      			vm.extension =  ".pdf";  
	      			ClearCorpLimitUtilisedReportService.exportLimitsPdf({bankId:  vm.filterData.bankId, branchId:  vm.filterData.branchId, 
	        			customerId:  vm.filterData.customerId,  instrumentId:  vm.filterData.instrumentId} ,vm.limitUtilisationDetailsList, processResponse );
	      		 
	      	  }
	    }
	    function processResponse(result){
	      	  var fileData = null;
	  		  fileData = result.data;
	  		  var link = document.createElement("a");   
	  		  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
	  		  vm.baseString =     vm.fileName + moment().format(vm.reportFileTimestampFormat) +  vm.extension;   	
	  		  
	  	      var blob = new Blob([bytes], {type: vm.mimeType});
	  	      if(window.navigator.msSaveOrOpenBlob) {
	                  window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
	  	      }else{
	  	    	  link.href =  window.URL.createObjectURL(blob);      
	  	    	  link.download = vm.baseString;
	  	    	  document.body.appendChild(link);
	  	    	  link.click();
	  	    	  document.body.removeChild(link);
	  	      }
	  	}
	    
	    vm.getBuyingPower = function getBuyingPower(limit){
        	var buyingPower = 0;
        	var totalBuy = limit.totalPendingBuyOrderValue + limit.totalBuyTradeValue + limit.previousDayBuyTradeValue;
        	var totalSell = limit.totalPendingSellOrderValue + limit.totalSellTradeValue + limit.previousDaySellTradeValue;
        	if(limit.limitType=='GROSSSELL'){
        		buyingPower = 0;
        	}else if(limit.limitType=='GROSSBUY'){
        		buyingPower = limit.limitAllocatedInUSD - (totalBuy);
        	}else if(limit.limitType=='GLOBALGROSS'){
        		buyingPower = limit.limitAllocatedInUSD - (totalBuy + totalSell);
        	}else if(limit.limitType=='NET'){
        		totalBuy = limit.totalPendingBuyOrderValue+((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue));
        		totalSell = limit.totalPendingSellOrderValue+((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue  + limit.previousDayBuyTradeValue));
        		var xVals = [];
        		xVals.push(totalBuy);
        		xVals.push(totalSell);
        		buyingPower = limit.limitAllocatedInUSD - totalBuy;
        	}
        	if( buyingPower != undefined && buyingPower !=null && buyingPower != 0 && buyingPower>0)
				return $filter('number')(buyingPower, vm.noOfDecimalsForAmount);
			else{
        		return '-';
        	}
        		
		   
        	
        }
        
        vm.getExposure = function getExposure(limit){
        	var exposure = 0;
        	var totalBuy = 0;
        	var totalSell = 0;
        	if(limit.limitType!='NET'){
            	totalBuy = limit.totalPendingBuyOrderValue + limit.totalBuyTradeValue + limit.previousDayBuyTradeValue;
            	totalSell = limit.totalPendingSellOrderValue + limit.totalSellTradeValue + limit.previousDaySellTradeValue;
            	exposure = (limit.totalPendingBuyOrderValue + limit.totalBuyTradeValue + limit.previousDayBuyTradeValue + limit.totalPendingSellOrderValue + limit.totalSellTradeValue + limit.previousDaySellTradeValue) * 100/limit.limitAllocatedInUSD;
        	}else{
        		totalBuy = limit.totalPendingBuyOrderValue+((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue));
        		totalSell = limit.totalPendingSellOrderValue+((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue));

            	var xVals = [];
        		xVals.push(totalBuy);
        		xVals.push(totalSell);
        		exposure =  Math.max.apply(Math, xVals) * 100/limit.limitAllocatedInUSD;
        	}
        	
        	if( !isNaN(exposure) && exposure != undefined && exposure !=null && exposure != 0 ){
        		return $filter('number')(exposure, vm.noOfDecimalsForAmount) + '%';
        	}else{
        		return '0.00%';
        	}
        }
        
        vm.getSellingPower = function getSellingPower(limit){
        	var sellingPower = 0;
        	var totalBuy = limit.totalPendingBuyOrderValue + (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue);
        	var totalSell = limit.totalPendingSellOrderValue + (limit.totalSellTradeValue + limit.previousDaySellTradeValue);
        	if(limit.limitType=='GROSSSELL'){
        		sellingPower = limit.limitAllocatedInUSD - (totalSell);
        	}else if(limit.limitType=='GROSSBUY'){
        		sellingPower = 0;
        	}else if(limit.limitType=='GLOBALGROSS'){
        		sellingPower = limit.limitAllocatedInUSD - (totalBuy + totalSell);
        	}else if(limit.limitType=='NET'){
        		totalBuy = limit.totalPendingBuyOrderValue+((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue));
        		totalSell = limit.totalPendingSellOrderValue+((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue));
        		var xVals = [];
        		xVals.push(totalBuy);
        		xVals.push(totalSell);
        		sellingPower = limit.limitAllocatedInUSD - totalSell;
        	}
        	if( sellingPower != undefined && sellingPower !=null && sellingPower != 0 && sellingPower>0)
				return $filter('number')(sellingPower, vm.noOfDecimalsForAmount);
			else{
        		return '-'
        	}
        }
        
        vm.calculateGrossBuyTotal = function calculateGrossBuyTotal(limitUtilisationDetail){
        	return limitUtilisationDetail.totalBuyTradeValue + limitUtilisationDetail.previousDayBuyTradeValue + limitUtilisationDetail.totalPendingBuyOrderValue;
        }
        vm.calculateGrossSellTotal = function calculateGrossSellTotal(limitUtilisationDetail){
        	return limitUtilisationDetail.totalSellTradeValue + limitUtilisationDetail.previousDaySellTradeValue + limitUtilisationDetail.totalPendingSellOrderValue
        }
        
        vm.calculateNetBuyTotal = function calculateNetBuyTotal(limitUtilisationDetail){
        	return limitUtilisationDetail.totalPendingBuyOrderValue+((limitUtilisationDetail.totalBuyTradeValue + limitUtilisationDetail.previousDayBuyTradeValue) - (limitUtilisationDetail.totalSellTradeValue + limitUtilisationDetail.previousDaySellTradeValue));
        }
        
        vm.calculateNetSellTotal = function calculateNetSellTotal(limitUtilisationDetail){
     	   return limitUtilisationDetail.totalPendingSellOrderValue+((limitUtilisationDetail.totalSellTradeValue + limitUtilisationDetail.previousDaySellTradeValue) - (limitUtilisationDetail.totalBuyTradeValue + limitUtilisationDetail.previousDayBuyTradeValue));
        }
    }
})();
 (function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('change-settings', {
            parent: 'customer-specific-settings',
            url: '/change-settings/{headerLabel}/{labelName}/{settingsName}/{settingsValue}/{settingsType}/{screenName}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-settings/change-settings.html',
                    controller: 'ChangeSettingsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('customerSpecificSettings');
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
         .state('change-settings-auditlog', {
            parent: 'audit-log',
            url: '/change-settings-auditlog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-settings/change-settings.html',
                    controller: 'ChangeSettingsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('customerSpecificSettings');
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('change-settings-historyreport', {
            parent: 'history-report',
            url: '/change-settings-historyreport',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-settings/change-settings.html',
                    controller: 'ChangeSettingsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('customerSpecificSettings');
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('customer-specific-settings-todolist', {
            parent: 'dashboard',
            url: '/customer-specific-settings-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/entities/change-settings/change-settings.html',
                    controller: 'ChangeSettingsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                	$state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('customerSpecificSettings');
                	$translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('customer-specific-settings-todoList-resubmit', {
            parent: 'dashboard',
            url: '/customer-specific-settings-resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-settings/change-settings.html',
                    controller: 'ChangeSettingsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                        	

                        }
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                	$state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('customerSpecificSettings');
                	 $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })

        
         };
    })();

(function() {
	'use strict';
	angular.module('gatewayApp').factory('ChangeSettings', ChangeSettings);

	ChangeSettings.$inject = [ '$resource' ];

	function ChangeSettings($resource) {
		var resourceUrl = 'api/change-settings/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'updateCustomerSpecificSettings' : {
				method : 'POST',
				params:{customerSpecificSettings:'customerSpecificSettings'},
				url : 'api/customer-specific-settings',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                }                
			},
			'approve' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/approve'
			},
			'reject' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/reject'
			},
			'discard' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/discard'
			},
			'resubmitForEdit' : {
				method : 'PUT',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/resubmit/customerSpecificSettings',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function() {
		this.viewFrom = 'changeSettings'
	})

	.controller('ChangeSettingsController', ChangeSettingsController);

	ChangeSettingsController.$inject = [ '$scope', '$state',
			'workflowSharedService', 'ChangeSettings', 'GlobalValues',
			'EntityPermissions', 'ScreenLog', '$stateParams',
			'$uibModalInstance', '$rootScope', 'MessageBox', 'Workflow','entity','DateUtils', '$filter'];

	function ChangeSettingsController($scope, $state, workflowSharedService,
			ChangeSettings, GlobalValues, EntityPermissions, ScreenLog,
			$stateParams, $uibModalInstance, $rootScope, MessageBox, Workflow,entity,DateUtils, $filter) {

		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenLog = ScreenLog;
		vm.saveCustomerSpecificSettings = saveCustomerSpecificSettings;
		vm.customerSpecificSettings = {};
		vm.controlMin=null;
		vm.controlMax=null;
		vm.customerId = vm.globalValues.getCustomerId();
		vm.customerSpecificSettings.customerId=vm.customerId ;
/*		$("#date_input").on("change", function () {
		     $(this).css("color", "rgba(0,0,0,0)").siblings(".datepicker_label").css({ "text-align":"center", position: "absolute",left: "10px", top:"14px",width:$(this).width()}).text($(this).val().length == 0 ? "" : ($.datepicker.formatDate($(this).attr("dateformat"), new Date($(this).val()))));
		        });*/
		
		vm.approveCustomerSpecificSettings = approveCustomerSpecificSettings;
		vm.rejectCustomerSpecificSettings = rejectCustomerSpecificSettings;
		vm.discardCustomerSpecificSettings = discardCustomerSpecificSettings;
		vm.resubmitCustomerSpecificSettings = resubmitCustomerSpecificSettings;
		vm.clear = clear;
		$scope.showButton = false;
		$scope.isShowSaveButton = false;
		$scope.showDiscardButton = false;
		$scope.isShowResubmit = false;
		$scope.isShowOkButton = false;
		vm.isPasswordPolicySelected = true;

		vm.clicked = false;
		vm.noOfDecimals=0;



		if (workflowSharedService.viewFrom == 'customerSpecificSettingstodolist_checker') {
			vm.ViewDisable = true;

			vm.customerSpecificSettings = angular.fromJson($rootScope.payload);
			console.log(vm.customerSpecificSettings);
			vm.headerLabel = "Order Settings";
			vm.labelName = vm.customerSpecificSettings.customerSpecificSettingsList.settingsDescription;
			vm.settingsName = vm.customerSpecificSettings.customerSpecificSettingsList.settingsName;
			if(vm.customerSpecificSettings.settingsType=='amcdate'){
				vm.settingsValue = DateUtils.convertLocalDateFromServer(vm.customerSpecificSettings.value);
			}else{
				vm.settingsValue = vm.customerSpecificSettings.value;
			}
			
			vm.settingsType = vm.customerSpecificSettings.settingsType;
			vm.screenName = 'dealingAdmin';
			vm.isDisabled = true
			$scope.showButton = true;
			$scope.showDiscardButton = false;
			$scope.isShowResubmit = false;
			$scope.isShowSaveButton = false;

		} else if (workflowSharedService.viewFrom == 'customerSpecificSettingstodolist_maker') {
			vm.ViewDisable = true;
			vm.customerSpecificSettings = angular.fromJson($rootScope.payload);
			vm.headerLabel =  "Order Settings";
			vm.labelName = vm.customerSpecificSettings.customerSpecificSettingsList.settingsDescription;
			vm.settingsName = vm.customerSpecificSettings.customerSpecificSettingsList.settingsName;
			if(vm.customerSpecificSettings.settingsType=='amcdate'){
				vm.settingsValue = DateUtils.convertLocalDateFromServer(vm.customerSpecificSettings.value);
			}else{
				vm.settingsValue = vm.customerSpecificSettings.value;
			}
			vm.settingsType = vm.customerSpecificSettings.settingsType;
			vm.screenName = 'dealingAdmin';
			vm.isDisabled = true
			$scope.showButton = false;
			$scope.showDiscardButton = true;
			$scope.isShowSaveButton = false;
			$scope.isShowResubmit = false;
		}

		else if (workflowSharedService.viewFrom == 'customerSpecificSettings_resubmit') {
			vm.customerSpecificSettings = angular.fromJson($rootScope.payload);
			vm.headerLabel =  "Order Settings";
			vm.labelName = vm.customerSpecificSettings.customerSpecificSettingsList.settingsDescription;
			vm.settingsName = vm.customerSpecificSettings.customerSpecificSettingsList.settingsName;
			if(vm.customerSpecificSettings.settingsType=='amcdate'){
				vm.settingsValue = DateUtils.convertLocalDateFromServer(vm.customerSpecificSettings.value);
			}else{
				vm.settingsValue = vm.customerSpecificSettings.value;
			}
			
			vm.settingsType = vm.customerSpecificSettings.settingsType;
			vm.isDisabled = false;
			vm.screenName = 'dealingAdmin';
			$scope.isShowResubmit = true;
			$scope.isShowSaveButton = false;

		} 		else if (workflowSharedService.viewFrom == 'customerSpecificSettings_auditlog') {
			
			vm.customerSpecificSettings = angular.fromJson($rootScope.payload);;
			vm.headerLabel = "Order Settings";
			vm.labelName = vm.customerSpecificSettings.customerSpecificSettingsList.settingsDescription;
			vm.settingsName = vm.customerSpecificSettings.settingsName;
			if(vm.customerSpecificSettings.settingsType=='amcdate'){
				vm.settingsValue = DateUtils.convertLocalDateFromServer(vm.customerSpecificSettings.value);
			}else{
				vm.settingsValue = vm.customerSpecificSettings.value;
			}
			vm.settingsType = vm.customerSpecificSettings.settingsType;
			vm.isDisabled = true;
			$scope.isShowResubmit = false;
			$scope.isShowSaveButton = false;
			$scope.isShowOkButton = true;

		} 
		else {
			vm.customerSpecificSettings.isDefault = false;
			vm.customerSpecificSettings.settingsName =  $stateParams.settingsName;
			vm.customerSpecificSettings.value = $stateParams.settingsValue;
			vm.customerSpecificSettings.settingsType = $stateParams.settingsType;
			
			vm.headerLabel = $stateParams.headerLabel;
			vm.labelName = $stateParams.labelName;
			vm.settingsName = $stateParams.settingsName;
			if($stateParams.settingsType=='amcdate'){
			
				
				vm.settingsValue = moment($stateParams.settingsValue,'DD/MM').toDate();
			}else{
				vm.settingsValue = $stateParams.settingsValue;
			}
			
			vm.settingsType = $stateParams.settingsType;
			vm.screenName = $stateParams.screenName;
			$scope.isShowSaveButton = true;
			console.log(vm.customerSpecificSettings.value);
		}
		
		if(vm.settingsName == 'MaximumPasswordAgeInDays' || vm.settingsName == 'AutoWithdrawalOfCustomerRegistrationApplication' || vm.settingsName == 'UnUsedTimeFrame' 
			|| vm.settingsName == 'DefaultLimitPeriodForSpotWindow' || vm.settingsName == 'DefaultLimitPeriodForForwardWindow' || vm.settingsName == 'NoOfDaysToDisableTheAccount' || vm.settingsName == 'NoOfDaysBeforePasswordWarning' || vm.settingsName == 'NoOfDaysEmailTriggeredForPendingApprovalRecords'){
			vm.isShowDays = true;
		}else if(vm.settingsName == 'MinimumPasswordAgeInHours') {
			vm.isShowHours = true;
		}else if (vm.settingsName == 'LifeSpanOfTheOTP' || vm.settingsName == 'ThrottlingParameters'){
			vm.isShowSeconds = true;
		}else if (vm.settingsName == 'NearestRoundingOffValueForUSD') {
			vm.noOfDecimals= vm.decimalForPaise;
			vm.isShowPaise=true;
			vm.isShowUSD = true;
		}else if (vm.settingsName == 'MinimumOrderValue' || vm.settingsName == 'MaximumOrderValue') {
			vm.noOfDecimals= vm.decimalForPaise;
			vm.isShowPaise=false;
			vm.isShowUSD = true;
			vm.controlMin = 0;
			vm.controlMax = $filter('number')(999999999.99, vm.decimalsForAmount);
		}else if (vm.settingsName == 'NearestRoundingOffValueForINR' || vm.settingsName == 'AllowedOrderPriceDeviationFromMarketPriceInPaise') {
			vm.isShowPaise = true;
		}else if(vm.settingsName == 'MarketMovementInterval' || vm.settingsName == 'SessionTimeoutInterval' || vm.settingsName == 'MinimumIdleTimeToRestrictOrderActivity'
			  || vm.settingsName == 'PreCASHSessionCloseIntimation') {
			vm.isShowMins = true;
		}else if(vm.settingsName=='ExchangeRateChange'){
			vm.noOfDecimals=vm.decimalsForPercent;
		}else if(vm.settingsName=='MinimumTransactionChargePerTrade' || vm.settingsName=='OrderLotSize'){
			vm.noOfDecimals= vm.decimalForPaise;
			vm.isShowPaise=true;
		}
		

		function saveCustomerSpecificSettings() {

			if(vm.settingsType == 'yesorno' ){
				vm.customerSpecificSettings.value = vm.settingsValue;
			}
			
			ChangeSettings.updateCustomerSpecificSettings(vm.customerSpecificSettings, onSaveSuccess, onSaveError)	

			
		}

		function onSaveSuccess(result) {
			$scope.$emit('Refresh');
			$uibModalInstance.close();

		}

		function onSaveError() {

			vm.clicked = false;
		}

		function approveCustomerSpecificSettings() {
			ChangeSettings.approve({
				"taskId" : $rootScope.taskID
			}, onApproveSuccess, onApproveError);
			
		}

		function onApproveSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close();
		}
		function onApproveError(error) {
			vm.clicked=false;
		}

		function rejectCustomerSpecificSettings() {
			Workflow.rejectTask($rootScope.taskID);
		}

		function discardCustomerSpecificSettings() {
			ChangeSettings.discard({
				"taskId" : $rootScope.taskID
			}, onDiscardSuccess, onDiscardError);
			
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close();
		}
		function onDiscardError(error) {

		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close(result);
			$uibModalInstance.close();
		}

		function onResubmitError(error) {
			vm.clicked=false;
		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function resubmitCustomerSpecificSettings() {
			if(vm.settingsType == 'yesorno' ){
				vm.customerSpecificSettings.value = vm.settingsValue;
			}
			
				ChangeSettings.resubmitForEdit({
					"taskId" : $rootScope.taskID
				}, vm.customerSpecificSettings, onResubmitSuccess, onResubmitError);
		

			
		}
		
		


	}
})();

(function () {
    "use strict";

    angular
        .module("gatewayApp")
        .service("workflowSharedService", function () {
            this.viewFrom = "changemobile";
        })

        .controller("ChangeMobileController", ChangeMobileController);

    ChangeMobileController.$inject = [
        "$scope",
        "$state",
        "workflowSharedService",
        "ChangeMobile",
        "GlobalValues",
        "EntityPermissions",
        "ScreenLog",
        "$stateParams",
        "$uibModalInstance",
        "$rootScope",
        "MessageBox",
        "globalValue",
        "AlertService",
        "$filter",
        "CryptoUtil"
    ];

    function ChangeMobileController(
        $scope,
        $state,
        workflowSharedService,
        ChangeMobile,
        GlobalValues,
        EntityPermissions,
        ScreenLog,
        $stateParams,
        $uibModalInstance,
        $rootScope,
        MessageBox,
        globalValue,
        AlertService,
        $filter,
        CryptoUtil
    ) {
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.screenLog = ScreenLog;
        vm.userProfile = {};
        vm.user = {};
        vm.changeMobile = changeMobile;
        vm.sendOTP = sendOTP;
        vm.changeUserMobile = changeUserMobile;
        vm.showChangeMobile = false;
        vm.isOTPSend = false;
        vm.clear = clear;
        vm.checkPassword = checkPassword;
        vm.currentMobile = $stateParams.mobile;
        vm.currentMobileCountryCode = $stateParams.countryCode;
        vm.userId = $stateParams.userId;
        vm.customerId = $stateParams.customerId;
        vm.mode = $stateParams.mode;
        vm.userProfile.confirmMobileCountryCode = 91;
        vm.userProfile.newMobileCountryCode = 91;
        vm.disableGenerateOTP = false;
        $scope.clicked = false;
        vm.otpClicked = false;
        vm.password = null;
        vm.allowedPasswordCharacters = /^[!@#^&*()\-_.:;a-zA-Z0-9]/;
        vm.wrongOTPAttemptCount = 0;
        vm.resendOTPAttemptCount = 0;
        vm.stepUpToken = "";
        vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;        vm.email = $stateParams.email;
        console.log("send Otp mail :"+ vm.email);


        vm.platformENCCode = "tV1f3EtXyUjBrf8JbbW7bSYf7JgyxZpVXYJvwAyM34Q=";

        $scope.otpInput = {
            size: globalValue.defaultOTPLength,
            type: "password",
            onDone: function (value) {
                vm.otp = value;
            },
            onChange: function (value) {
                console.log(value);
            }
        };

        vm.launch = launch;
        function launch() {
            $state.go("user-profile");
        }

        function sendOTP() {
            vm.disableGenerateOTP = true;
            if (vm.mode == "customerinfo") {
                ChangeMobile.SendOTPSMSForCustomer(
                    {
                        mobile: vm.currentMobile,
                        newMobile: vm.userProfile.confirmMobile,
                        newMobileCountryCode:
                            vm.userProfile.confirmMobileCountryCode
                    },
                    onOTPSendSuccess,
                    onSendOTPError
                );
            } else {
                if (vm.entityOwnerType != 'Clearcorp') {
                    // Step 1: Execute reCAPTCHA
                    grecaptcha.ready(function () {
                        grecaptcha
                            .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
                                action: "otp_action"
                            })
                            .then(function (token) {
                                // ✅ Step 2: Call API with token
                                ChangeMobile.SendOTPSMS(
                                    {
                                        userId: vm.userId,
                                        mobile: vm.currentMobile,
                                        newMobile: vm.userProfile.confirmMobile,
                                        newMobileCountryCode:
                                            vm.userProfile.confirmMobileCountryCode,
                                        stepUpToken: vm.stepUpToken,
                                        recaptchaToken: token,
                                        orgType: vm.entityOwnerType,
                                        sourceType: "send-otp",
                                        source: "profile"
                                    },
                                    onOTPSendSuccess,
                                    onSendOTPError
                                );
                            })
                            .catch(function (error) {
                                console.error("reCAPTCHA error:", error);
                                vm.disableGenerateOTP = false;
                            });
                    });
                } else {
                    ChangeMobile.SendOTPSMS(
                        {
                            userId: vm.userId,
                            mobile: vm.currentMobile,
                            newMobile: vm.userProfile.confirmMobile,
                            newMobileCountryCode:
                                vm.userProfile.confirmMobileCountryCode,
                            stepUpToken: vm.stepUpToken,
                            orgType: vm.entityOwnerType,
                            sourceType: "send-otp",
                            source: "profile"
                        },
                        onOTPSendSuccess,
                        onSendOTPError
                    );
                }
            }
        }

        function changeMobile() {
            $rootScope.mobile = vm.userProfile.confirmMobile;
            $rootScope.mobileCountryCode =
                vm.userProfile.confirmMobileCountryCode;
            $scope.$emit("changeMobileRefresh");
            $uibModalInstance.close();
        }

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        vm.resendPrimaryOTP = function resendPrimaryOTP() {
            var email = "0";
            if (
                vm.userProfile.confirmMobileCountryCode == null ||
                vm.userProfile.confirmMobileCountryCode == undefined
            ) {
                vm.userProfile.confirmMobileCountryCode = "";
            }
            var mobileNo = vm.userProfile.confirmMobile;
            var mobileCountryCode = vm.userProfile.confirmMobileCountryCode;
            if (
                vm.resendOTPAttemptCount >=
                globalValue.maximumOTPResendAttemptCount
            ) {
                //AlertService.error("Maximum request for resend OTP is exceeded!<br>Please try again later.")
                MessageBox.openMessageBox(
                    "Alert",
                    "Maximum request for resend OTP is exceeded! Please try again.",
                    "Ok",
                    "resendotpchangemobile"
                );
            } else {
                // ChangeMobile.resendOTP(
                //     {
                //         mobile: mobileNo,
                //         mobileCountryCode: mobileCountryCode,
                //         email: email,
                //         stepUpToken: vm.stepUpToken
                //     },
                //     onResendPrimaryOTPSuccess,
                //     onResendPrimaryOTPError
                // );

                // ✅ Step 1: Execute reCAPTCHA
                if (vm.entityOwnerType != 'Clearcorp') {
                    grecaptcha.ready(function () {
                        grecaptcha
                            .execute(
                                CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.globalValues.getPlatformENCCode()),
                                {
                                    action: "otp_action"
                                }
                            )
                            .then(function (token) {
                                // ✅ Step 2: Call API with token
                                ChangeMobile.SendOTPSMS(
                                    {
                                    userId: vm.userId,
                                    mobile: vm.currentMobile,
                                    newMobile: vm.userProfile.confirmMobile,
                                    newMobileCountryCode:
                                    vm.userProfile.confirmMobileCountryCode,
                                    stepUpToken: vm.stepUpToken,
                                        recaptchaToken: token,
                                        orgType: vm.entityOwnerType,
                                        sourceType: "resend-otp",
                                        source: "profile"
                                    },
                                    onResendPrimaryOTPSuccess,
                                    onResendPrimaryOTPError
                                );
                            })
                            .catch(function (error) {
                                console.error("reCAPTCHA error:", error);
                                vm.disableGenerateOTP = false;
                            });
                    });
                } else {
                    ChangeMobile.resendOTP(
                        {
                            mobile: mobileNo,
                            mobileCountryCode: mobileCountryCode,
                            email: email,
                            stepUpToken: vm.stepUpToken,
                            orgType: vm.entityOwnerType,
                            sourceType: "resend-otp",
                            source: "profile"
                        },
                        onResendPrimaryOTPSuccess,
                        onResendPrimaryOTPError
                    );

                }
            }
        };

        function onResendPrimaryOTPSuccess() {
            vm.wrongOTPAttemptCount = 0;
            vm.resendOTPAttemptCount = vm.resendOTPAttemptCount + 1;
            AlertService.info("OTP has been resent to your mobile");
        }

        function onResendPrimaryOTPError() {
            //AlertService.error("Error occurred while generating OTP mobile");
        }

        function changeUserMobile() {
            vm.otpClicked = true;
            if (vm.otp == null || vm.otp == undefined || vm.otp == "") {
                vm.otpClicked = false;
                AlertService.error($filter("translate")("error.InvalidOTP"));
            } else if (vm.mode == "customerinfo") {
                $rootScope.mobile = vm.userProfile.confirmMobile;
                ChangeMobile.updateForCustomer(
                    {
                        customerId: vm.customerId,
                        newMobile: vm.userProfile.confirmMobile,
                        newMobileCountryCode:
                            vm.userProfile.confirmMobileCountryCode,
                        otp: vm.otp
                    },
                    onMobileChangeSuccess,
                    onMobileChangeError
                );
            } else {
                ChangeMobile.update(
                    {
                        userId: vm.userId,
                        newMobile: vm.userProfile.confirmMobile,
                        newMobileCountryCode:
                            vm.userProfile.confirmMobileCountryCode,
                        otp: vm.otp
                    },
                    onMobileChangeSuccess,
                    onMobileChangeError
                );
            }
        }

        $rootScope.$on(
            "gatewayApp.messagebox.ok.invalidotpchangemobile",
            function (event, data) {
                $scope.$emit("gatewayApp.messagebox.ok.sessionexpired");
            }
        );

        $rootScope.$on(
            "gatewayApp.messagebox.clear.invalidotpchangemobile",
            function (event, data) {
                $scope.$emit("gatewayApp.messagebox.ok.sessionexpired");
            }
        );

        $rootScope.$on(
            "gatewayApp.messagebox.ok.resendotpchangemobile",
            function (event, data) {
                clear();
            }
        );

        $rootScope.$on(
            "gatewayApp.messagebox.clear.resendotpchangemobile",
            function (event, data) {
                clear();
            }
        );

        function checkPassword() {
            if (vm.mode == "customerinfo") {
                var userCredentialsForCustomer = {};
                userCredentialsForCustomer.userId = vm.userId;
                userCredentialsForCustomer.password = vm.password;
                userCredentialsForCustomer.customerId = vm.customerId;
                ChangeMobile.checkPasswordForCustomer(
                    userCredentialsForCustomer,
                    onSaveSuccess,
                    onSaveError
                );
            } else {
                var userCredentials = {};
                userCredentials.userId = vm.userId;
                userCredentials.password = vm.password;
                userCredentials.mobileEmailFlag = "mobile";
                ChangeMobile.checkPassword(
                    userCredentials,
                    onSaveSuccess,
                    onSaveError
                );
            }
        }

        function onSaveSuccess(result) {
            if (
                result.hasOwnProperty("IsPendingEmailChange") &&
                result.IsPendingEmailChange != null &&
                result.IsPendingEmailChange == true
            ) {
                MessageBox.openMessageBox(
                    "Alert",
                    "Change of email request is already pending for verification. If you proceed with change of mobile number, then the pending email change request will be discarded automatically. Do you still want to proceed?",
                    "ProceedCancel",
                    "changemobilerequest"
                );
            } else {
                if (result.stepUpToken != null && result.stepUpToken != "") {
                    vm.stepUpToken = result.stepUpToken;
                    vm.showChangeMobile = true;
                }
            }
        }

        function onOTPSendSuccess(result) {
            vm.wrongOTPAttemptCount = 0;
            vm.resendOTPAttemptCount = 0;
            AlertService.info("OTP has been sent to your mobile");
            vm.isOTPSend = true;
        }

        function onSaveError() {
            $scope.clicked = false;
        }

        function onSendOTPError() {
            vm.disableGenerateOTP = false;
            AlertService.error("Error occurred while generating OTP mobile");
        }

        function onMobileChangeSuccess(result) {
            vm.wrongOTPAttemptCount = 0;
            $scope.$emit("changeMobileRefresh");
            $uibModalInstance.close(result);
        }
        /*
         * allow only 30 characters in password and only some special characters
         */
        $scope.$watch("vm.password", function (newVal, oldVal) {
            if (newVal != null || newVal != undefined) {
                if (newVal.length > 30) {
                    vm.password = oldVal;
                }
                if (
                    !newVal
                        .charAt(newVal.length - 1)
                        .match(vm.allowedPasswordCharacters)
                ) {
                    vm.password = oldVal;
                }
            }
        });

        $rootScope.$on(
            "gatewayApp.messagebox.proceed.changemobilerequest",
            function (event, data) {
                vm.showChangeMobile = true;
                ChangeMobile.activatePendingEmailChangeRequest(
                    { userId: vm.userId },
                    onCancelSuccess,
                    onCancelError
                );
            }
        );

        $rootScope.$on(
            "gatewayApp.messagebox.cancel.changemobilerequest",
            function (event, data) {
                vm.showChangeMobile = false;
                $uibModalInstance.close();
            }
        );

        function onMobileChangeError() {
            vm.wrongOTPAttemptCount = vm.wrongOTPAttemptCount + 1;
            if (
                vm.wrongOTPAttemptCount >=
                globalValue.maximumOTPWrongAttemptCount
            ) {
                //AlertService.error("Maximum wrong OTP attempt count is exceeded!<br>Please request for resend OTP.")
                MessageBox.openMessageBox(
                    "Alert",
                    "Maximum wrong OTP attempt count is exceeded! Session expired. You will be redirected to login page...!",
                    "Ok",
                    "invalidotpchangemobile"
                );
            }
            vm.otpClicked = false;
        }

        function onCancelSuccess() {
            //vm.clicked = false;
        }

        function onCancelError() {
            //vm.clicked = false;
        }
    }
})();

 (function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('change-mobile', {
            parent: 'user-profile',
            url: '/change-mobile/{userId}/{mobile}/{countryCode}/{mode}/{customerId}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-mobile/change-mobile.html',
                    controller: 'ChangeMobileController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                    	entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
            	
                
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
         .state('change-mobile-user', {
            parent: 'manage-users',
            url: '/change-mobile/{userId}/{mobile}/{countryCode}/{mode}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-mobile/change-mobile.html',
                    controller: 'ChangeMobileController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                        
                    	entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
            	
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('change-mobile-customer-info-resubmit', {
            parent: 'customer-info-status-view',
            url: '/change-mobile/{userId}/{mobile}/{countryCode}/{mode}/{customerId}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-mobile/change-mobile.html',
                    controller: 'ChangeMobileController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                    	entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
            	
                
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
         };
    })();

(function() {
	'use strict';
	angular.module('gatewayApp').factory('ChangeMobile', ChangeMobile);

	ChangeMobile.$inject = [ '$resource' ];

	function ChangeMobile($resource) {
		var resourceUrl = 'api/change-mobile/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'SendOTPSMS' : {
				method : 'POST',
				url : 'api/user-profile/send-otp-mobile'
			},
			'SendOTPSMSForCustomer' : {
				method : 'POST',
				url : 'api/user-profile/send-otp-for-customer'
			},
			'resendOTP' : {
				method : 'POST',
				url : 'api/resend-otp-mobile',
				transformRequest : function(data) {
					var copy = angular.copy(data);

					return angular.toJson(copy);
				}
			},
			'update' : {
				method : 'PUT',
				url : 'api/user-profile/update-new-mobile'
			},
			'updateForCustomer' : {
				method : 'PUT',
				url : 'api/user-profile/update-new-mobile-for-customer'
			},
			'activatePendingEmailChangeRequest' : {
				method : 'POST',
				params : {
					userId : '@userId'
				},
				url : 'api/user-profile/activate-email-change/userId/:userId'
			},
			'checkPassword' : {
				method : 'POST',
				/*params : {
					userId : '@userId',
					password : '@password'
				},*/
				url : 'api/user-profile/check-password'
			},
			'checkPasswordForCustomer' : {
				method : 'POST',
				/*params : {
					userId : '@userId',
					password : '@password',
					customerId : '@customerId'
				},*/
				url : 'api/user-profile/check-password-customer'
			}

		});
	}
})();

(function() {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function() {
		this.viewFrom = 'changeemail'
	})

	.controller('ChangeEmailController', ChangeEmailController);

	ChangeEmailController.$inject = [ '$scope', '$state',
			'workflowSharedService', 'ChangeEmail', 'GlobalValues',
			'EntityPermissions', 'ScreenLog', '$stateParams',
			'$uibModalInstance', '$rootScope', 'MessageBox', 'CustomerRegistration', 
			'globalValue', 'AlertService','CryptoUtil'];

	function ChangeEmailController($scope, $state, workflowSharedService,
			ChangeEmail, GlobalValues, EntityPermissions, ScreenLog,
			$stateParams, $uibModalInstance, $rootScope, MessageBox, CustomerRegistration, 
			globalValue, AlertService,CryptoUtil) {

		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenLog = ScreenLog;
		vm.userprofile = {};
		vm.user = {};
		vm.currentEmail = $stateParams.email;
		vm.userId = $stateParams.userId;
		vm.customerId = $stateParams.customerId;
		vm.mode = $stateParams.mode;
		vm.sendActivationMail = sendActivationMail;
		vm.updateNewEmail = updateNewEmail;
		vm.checkPassword = checkPassword;
		vm.updateEmail = updateEmail;
		vm.showChangeEmail = false;
		vm.clicked = false;
		vm.password=null;
		vm.allowedPasswordCharacters=/^[!@#^&*()\-_.:;a-zA-Z0-9]/;
		vm.clear = clear;

		vm.otpLength = globalValue.defaultOTPLength;
		vm.visibleOTPEmail = false;
		vm.isEmailVerified = false;
	    vm.skipOTPEmail = false;
   		vm.showGenerateOTPEmailButton = false;
        vm.disableGenerateOTPEmail = true;
        vm.checkEmailOTP = false;
        vm.invalidEmailOtp = false;
		vm.emailOtp = null;
		vm.generateOTPEmail = generateOTPEmail;
		vm.wrongOTPAttemptCount = 0;
		vm.resendOTPAttemptCount = 0;
		vm.otpVerifiedId='';
		vm.stepUpToken = '';
		vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
		if(vm.mode!='user' && (globalValue.skipOTPVerification == 'No' || globalValue.skipOTPVerification == 'no'|| globalValue.skipOTPVerification == 'NO')){
			vm.skipOTPEmail = false;
    	}else{
    		vm.skipOTPEmail = false;
    	}

		console.log(vm.mode);
		console.log(vm.customerId);
		function updateEmail() {
			
				$rootScope.email = vm.userProfile.confirmEmail;
				$rootScope.otpVerifiedId = vm.otpVerifiedId;
				$scope.$emit('changeEmailRefresh');
				$uibModalInstance.close();
			
		}

		function sendActivationMail() {
			
			if(vm.mode == 'customerinfo'){
				ChangeEmail.sendActivationMailForCustomer({
					"customerId" : vm.customerId,
					"newEmail" : vm.userProfile.confirmEmail,
					"email" : vm.currentEmail
				}, onEmailChangeSuccess, onEmailChangeError)
			}else{
				ChangeEmail.sendActivationMail({
					"userId" : vm.userId,
					"newEmail" : vm.userProfile.confirmEmail,
					"email" : vm.currentEmail
				}, onEmailChangeSuccess, onEmailChangeError)
			}
				
				
			
		}

		function checkPassword() {
			if(vm.mode == 'customerinfo'){
				var userCredentialsForCustomer = {};
				userCredentialsForCustomer.userId = vm.userId;
				userCredentialsForCustomer.password = vm.password;
				userCredentialsForCustomer.customerId = vm.customerId;
				ChangeEmail.checkPasswordForCustomer(userCredentialsForCustomer, onSaveSuccess, onSaveError);	


			}else {
				var userCredentials = {};
				userCredentials.userId = vm.userId;
				userCredentials.password = vm.password;
				userCredentials.mobileEmailFlag = "email"
				ChangeEmail.checkPassword(userCredentials, onSaveSuccess, onSaveError);
				}
			
		}

		function onSaveSuccess(result) {
			// $uibModalInstance.close(result);
			 if (result.hasOwnProperty('IsPendingEmailChange') && result.IsPendingEmailChange != null && result.IsPendingEmailChange == true) {
				 MessageBox.openMessageBox("Alert", "Change of email request is already pending for verification. If you proceed with change of email, then the pending email change request will be discarded automatically. Do you still want to proceed?", "ProceedCancel", "changeemailrequest");
			 }else{
				if(result.stepUpToken !=null && result.stepUpToken != ''){
				vm.stepUpToken = result.stepUpToken;
				 vm.showChangeEmail = true;
				}
			 }
			//vm.showChangeEmail = true;
			
		}

		 $scope.$watch('vm.userProfile.newEmail', function(value){
	        	if(value!= undefined && value!=null && value!=''){
	    			vm.visibleOTPEmail = false;
	        		vm.emailOtp = null;
	        		vm.isEmailVerified = false;
	        		if(value.length>=1){
	                	if(!vm.skipOTPEmail){
	                		vm.showGenerateOTPEmailButton = true;
	                	}
	                	if((value.indexOf('@')>-1) && (value.indexOf('.')>-1)){
	                        vm.disableGenerateOTPEmail = false;
	                	}else{
	                		vm.disableGenerateOTPEmail = true;
	                	}
	                	
	        		}else{
	        			vm.disableGenerateOTPEmail = true;
	                	vm.showGenerateOTPEmailButton = false;
	        		}
	        	}else{
	        		vm.showGenerateOTPEmailButton = false;
	        		vm.emailOtp = null;
	         	}
	      })
	      
	    $scope.otpEmailInput = {
				size : globalValue.defaultOTPLength,
				type : "password",
				onDone : function(value) {
					vm.emailOtp = value;
				},
				onChange : function(value) {
					if(value!= undefined && value!=null){
		        		vm.checkEmailOTP = false;
		        		vm.isEmailVerified = false;
		        		if(value.length==vm.otpLength){
		        			vm.checkEmailOTP = true;
		        			vm.invalidEmailOtp = false;
		            	/* 	CustomerRegistration.verifyOTPEmail({email: vm.userProfile.confirmEmail, otp: vm.emailOtp}, function(result){
		            			vm.otpVerification = result.isVerified;
		            			if(vm.otpVerification){
		            				vm.isEmailVerified = true;
		            				vm.invalidEmailOtp = false;
		            			}else{
		            				vm.wrongOTPAttemptCount = vm.wrongOTPAttemptCount + 1;
		            				if(vm.wrongOTPAttemptCount>=globalValue.maximumOTPWrongAttemptCount){
				        				MessageBox.openMessageBox('Alert', 'Maximum wrong OTP attempt count exceeds! Session expired. You will be redirected to login page...!', 'Ok', 'invalidotpchangeemail');
				        			}
		            				vm.invalidEmailOtp = true;
		            				vm.isEmailVerified = false;
		            			}
		            		}); */
							CustomerRegistration.verifyOTPEmail({email: vm.userProfile.confirmEmail, otp: vm.emailOtp},onemailChangeSuccess,onemailChangefailed);

		        		}else{
		        			vm.checkEmailOTP = false;
		        		}
		        	}
				}
		};
        function onemailChangeSuccess(result){
		if(result.isVerified=='VERIFIED'){
			vm.isEmailVerified = true;
		    vm.invalidEmailOtp = false;
			vm.otpVerifiedId=result.otpVerifiedId;
		}
	}
		function onemailChangefailed(){
			vm.wrongOTPAttemptCount = vm.wrongOTPAttemptCount + 1;
			if(vm.wrongOTPAttemptCount>=globalValue.maximumOTPWrongAttemptCount){
				MessageBox.openMessageBox('Alert', 'Maximum wrong OTP attempt count exceeds! Session expired. You will be redirected to login page...!', 'Ok', 'invalidotpchangeemail');
			}
			vm.invalidEmailOtp = true;
			vm.isEmailVerified = false;
		}
		 $rootScope.$on('gatewayApp.messagebox.ok.invalidotpchangeemail', function (event, data) {
			 $scope.$emit('gatewayApp.messagebox.ok.sessionexpired');        	      
		 });
	        
		 $rootScope.$on('gatewayApp.messagebox.clear.invalidotpchangeemail', function (event, data) {
			 $scope.$emit('gatewayApp.messagebox.ok.sessionexpired');      	      
		 });


		function generateOTPEmail() {
			vm.disableGenerateOTPEmail = true;
			vm.showGenerateOTPEmailButton = false;
			if(vm.entityOwnerType != 'Clearcorp'){
			grecaptcha.ready(function () {
				grecaptcha
					.execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
						action: "otp_action"
					})
					.then(function (token) {
						ChangeEmail.sendOTPVerificationEmail({ 
							email: vm.currentEmail,
							newEmail: vm.userProfile.confirmEmail,
							userId: vm.userId,
							stepUpToken: vm.stepUpToken,
							recaptchaToken: token,
							orgType: vm.entityOwnerType,
							sourceType: "send-otp",
                            source: "manage-user" 
						},
							onOtpEmailSendSuccess, onOtpEmailSendError
						);
					})
					.catch(function (error) {
						console.error("reCAPTCHA error:", error);
						vm.disableGenerateOTP = false; // re-enable button
					});
			});
			} else {
				ChangeEmail.sendOTPVerificationEmail({
					email: vm.currentEmail,
					newEmail: vm.userProfile.confirmEmail,
					userId: vm.userId,
					stepUpToken: vm.stepUpToken,
					orgType: vm.entityOwnerType,
					sourceType: "send-otp",
                    source: "manage-user" 
				},
					onOtpEmailSendSuccess, onOtpEmailSendError
				);

			}
		}

		 function onOtpEmailSendSuccess(result){
        	AlertService.info("OTP email has been sent to your email");
        	vm.visibleOTPEmail = true;
    		vm.emailOtp = null;
    		vm.isEmailVerified = false;
    		vm.wrongOTPAttemptCount = 0;
    		vm.resendOTPAttemptCount = 0;
        }
        
        function onOtpEmailSendError(){
        	AlertService.error("Error occurred while generating OTP email");
        	vm.disableGenerateOTPEmail = false;
        	vm.showGenerateOTPEmailButton = true;
        }
		
        vm.resendOTPEmail = function resendOTPEmail(){
        	if(vm.resendOTPAttemptCount>=globalValue.maximumOTPResendAttemptCount){
        		//AlertService.error("Maximum resend OTP count exceeds!<br>Please try again later.")
        		MessageBox.openMessageBox('Alert', 'Maximum resend OTP count exceeds! Please try again.', 'Ok', 'resendotpchangeemail');
        	}else{
			if(vm.entityOwnerType != 'Clearcorp'){
			grecaptcha.ready(function () {
				grecaptcha
					.execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
						action: "otp_action"
					})
					.then(function (token) {
						ChangeEmail.sendOTPVerificationEmail({ 
							email: vm.currentEmail,
							newEmail: vm.userProfile.confirmEmail,
							userId: vm.userId,
							stepUpToken: vm.stepUpToken,
							recaptchaToken: token,
							orgType: vm.entityOwnerType,
							sourceType: "send-otp",
                            source: "manage-user" 
						},
							onOtpEmailSendSuccess, onOtpEmailSendError
						);
					})
					.catch(function (error) {
						console.error("reCAPTCHA error:", error);
						vm.disableGenerateOTP = false; // re-enable button
					});
			});
			} else {
				ChangeEmail.sendOTPVerificationEmail({
					email: vm.currentEmail,
					newEmail: vm.userProfile.confirmEmail,
					userId: vm.userId,
					stepUpToken: vm.stepUpToken,
					orgType: vm.entityOwnerType,
					sourceType: "send-otp",
                    source: "manage-user" 
				},
					onOtpEmailSendSuccess, onOtpEmailSendError
				);

			}
		}
        }

        $rootScope.$on('gatewayApp.messagebox.ok.resendotpchangeemail', function (event, data) {
        	clear();      	      
		});
	        
		$rootScope.$on('gatewayApp.messagebox.clear.resendotpchangeemail', function (event, data) {
			clear();      	      
		});

        function onResendOtpEmailSuccess(result){
        	vm.wrongOTPAttemptCount = 0;
        	vm.resendOTPAttemptCount = vm.resendOTPAttemptCount + 1; 
        	AlertService.info("OTP has been resent to your email");
        }
        
        function onResendOtpEmailError(){
        	
        }
        
		$rootScope.$on('gatewayApp.messagebox.proceed.changeemailrequest', function (event, data) {
			vm.showChangeEmail = true;
			if(vm.mode == 'customerinfo'){
				ChangeEmail.activatePendingEmailChangeRequestForCustomer({"customerId" : vm.customerId}, onCancelSuccess, onCancelError);
			}else {
				ChangeEmail.activatePendingEmailChangeRequest({"userId" : vm.userId}, onCancelSuccess, onCancelError);	
			}
			
    	});
		
		$rootScope.$on('gatewayApp.messagebox.cancel.changeemailrequest', function (event, data) {
			vm.showChangeEmail = false;
			$uibModalInstance.close();
    	});
		
		function onSaveError() {

			vm.clicked = false;
		}
		
		function onCancelSuccess() {

			//vm.clicked = false;
		}
		
		function onCancelError() {

			//vm.clicked = false;
		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function onEmailChangeSuccess(result) {

			$uibModalInstance.close(result);

		}

		function onEmailChangeError() {

			vm.clicked = false;
		}
		
		function updateNewEmail(){
			if(vm.mode == 'customerinfo'){
				ChangeEmail.updateCustomerEmail({
					"customerId" : vm.customerId,
					"newEmail" : vm.userProfile.confirmEmail,
					"email" : vm.currentEmail,
					"otpVerifiedId":vm.otpVerifiedId

				}, onEmailChangeSuccess, onEmailChangeError)
			}else{
				ChangeEmail.updateUserEmail({
					"userId" : vm.userId,
					"newEmail" : vm.userProfile.confirmEmail,
					"email" : vm.currentEmail,
					"otpVerifiedId":vm.otpVerifiedId
				}, onEmailChangeSuccess, onEmailChangeError)
			}
		}
		
		 /*
         * allow only 30 characters in password and only some special characters
         */
		 $scope.$watch('vm.password', function(newVal, oldVal) {
			 if(newVal!=null||newVal!=undefined)
	        	{
			       	  if(newVal.length > 30) {       
			       		  vm.password = oldVal;
			       	  }
			       	  if(!newVal.charAt((newVal.length)-1).match(vm.allowedPasswordCharacters))
			   		  {
			       		  vm.password = oldVal;
			   		  }
	        	}
	       	});

	}
})();

 (function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('change-email', {
            parent: 'user-profile',
            url: '/change-email/{userId}/{email}/{mode}/{customerId}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-email/change-email.html',
                    controller: 'ChangeEmailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
         .state('change-email-user', {
            parent: 'manage-users',
            url: '/change-email/{userId}/{email}/{mode}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'manage-users'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-email/change-email.html',
                    controller: 'ChangeEmailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
         .state('change-email-customer-info-resubmit', {
            parent: 'customer-info-status-view',
            url: '/change-email-customer-info/{userId}/{email}/{mode}/{customerId}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-email/change-email.html',
                    controller: 'ChangeEmailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
         };
    })();

(function() {
	'use strict';
	angular.module('gatewayApp').factory('ChangeEmail', ChangeEmail);

	ChangeEmail.$inject = [ '$resource' ];

	function ChangeEmail($resource) {
		var resourceUrl = 'api/change-email/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'sendActivationMail' : {
				method : 'POST',
				url : 'api/user-profile/send-email-change'
			},
			'sendActivationMailForCustomer' : {
				method : 'POST',
				url : 'api/user-profile-customer'
			},
			'activatePendingEmailChangeRequest' : {
				method : 'POST',
				params : {
					userId : '@userId'
				},
				url : 'api/user-profile/activate-email-change/userId/:userId'
			},
			'activatePendingEmailChangeRequestForCustomer' : {
				method : 'POST',
				params : {
					customerId : '@customerId'
				},
				url : 'api/user-profile/activate-email-change-customer/customerId/:customerId'
			},
			'update' : {
				method : 'POST',
				params : {
					key : '@key'
				},
				url : 'api/user-profile/update-email/key/:key'
			},
			'updateForCustomer' : {
				method : 'POST',
				params : {
					key : '@key'
				},
				url : 'api/user-profile/update-email-customer/key/:key'
			},
			'checkPassword' : {
				method : 'POST',
				/*params : {
					userId : '@userId',
					password : '@password'
				},*/
				url : 'api/user-profile/check-password'
			},
			
			'sendOTPVerificationEmail' : {
				method : 'POST',
				url : 'api/send-otp-verification-email',
				transformRequest : function(data) {
					var copy = angular.copy(data);

					return angular.toJson(copy);
				}
			},
			'updateCustomerEmail' : {
				method : 'POST',
				url : 'api/update-customer-email'
			},
			'updateUserEmail' : {
				method : 'POST',
				url : 'api/update-user-email'
			},
			'checkPasswordForCustomer' : {
				method : 'POST',
				/*params : {
					userId : '@userId',
					password : '@password',
					customerId : '@customerId'
				},*/
				url : 'api/user-profile/check-password-customer'
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function () {
		this.viewFrom = 'changeConfig'
	})

		.controller('ChangeConfigController', ChangeConfigController);

	ChangeConfigController.$inject = ['$scope', '$state',
		'workflowSharedService', 'ChangeConfig', 'GlobalValues',
		'EntityPermissions', 'ScreenLog', '$stateParams',
		'$uibModalInstance', '$rootScope', 'MessageBox', 'Workflow', 'entity', 'DateUtils', '$filter', 'AlertService'];

	function ChangeConfigController($scope, $state, workflowSharedService,
		ChangeConfig, GlobalValues, EntityPermissions, ScreenLog,
		$stateParams, $uibModalInstance, $rootScope, MessageBox, Workflow, entity, DateUtils, $filter, AlertService) {

		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenLog = ScreenLog;
		vm.saveConfig = saveConfig;
		vm.configSettings = {};
		vm.isShowDays = false;
		vm.isShowHours = false;
		vm.isShowSeconds = false;
		vm.isShowMins = false;
		vm.isShowUSD = false;
		vm.isShowPaise = false;
		vm.isShowPercentage = false;
		vm.controlMin = null;
		vm.controlMax = $filter('number')(999999999, 0);
		vm.maximumOrderValueHardCheck = vm.globalValues.getConfigSettings().maximumOrderValueHardCheck;
		vm.maximumOrderValueSoftCheck = vm.globalValues.getConfigSettings().maximumOrderValueSoftCheck;
		vm.transactionParametersSettings = vm.globalValues.getTransactionParametersSettings();
		vm.minimumOrderValue = vm.globalValues.getConfigSettings().minimumOrderValue;
		vm.errorText = "";
		vm.numericValueError = false;
		vm.isTransectionparamiter = false;

		$("#date_input").on("change", function () {
			$(this).css("color", "rgba(0,0,0,0)").siblings(".datepicker_label").css({ "text-align": "center", position: "absolute", left: "10px", top: "14px", width: $(this).width() }).text($(this).val().length == 0 ? "" : ($.datepicker.formatDate($(this).attr("dateformat"), new Date($(this).val()))));
		});

		vm.approveConfigSettings = approveConfigSettings;
		vm.rejectConfigSettings = rejectConfigSettings;
		vm.discardConfigSettings = discardConfigSettings;
		vm.resubmitConfigSettings = resubmitConfigSettings;
		vm.clear = clear;
		$scope.showButton = false;
		$scope.isShowSaveButton = false;
		$scope.showDiscardButton = false;
		$scope.isShowResubmit = false;
		vm.isPasswordPolicySelected = true;

		vm.clicked = false;
		vm.noOfDecimals = 0;
		vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
		vm.decimalForPaise = vm.globalValues.getNumberOfDecimalsForRateInReports();
		vm.decimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();


		if (workflowSharedService.viewFrom == 'applicationWideSettingstodolist_checker') {
			vm.ViewDisable = true;

			vm.configSettings = angular.fromJson($rootScope.payload);
			console.log(vm.configSettings);
			vm.headerLabel = vm.configSettings.configurationCategory.name;
			vm.labelName = vm.configSettings.configDescription;
			vm.configName = vm.configSettings.configName;
			if (vm.configSettings.controlType == 'amcdate') {
				vm.configValue = DateUtils.convertLocalDateFromServer(vm.configSettings.value);
			} else {
				vm.configValue = vm.configSettings.value;
			}

			vm.controlType = vm.configSettings.controlType;
			vm.screenName = 'useradmin';
			vm.isDisabled = true
			$scope.showButton = true;
			$scope.showDiscardButton = false;
			$scope.isShowResubmit = false;
			$scope.isShowSaveButton = false;

		} else if (workflowSharedService.viewFrom == 'applicationWideSettingstodolist_maker') {
			vm.ViewDisable = true;
			vm.configSettings = angular.fromJson($rootScope.payload);
			vm.headerLabel = vm.configSettings.configurationCategory.name;
			vm.labelName = vm.configSettings.configDescription;
			vm.configName = vm.configSettings.configName;
			if (vm.configSettings.controlType == 'amcdate') {
				vm.configValue = DateUtils.convertLocalDateFromServer(vm.configSettings.value);
			} else {
				vm.configValue = vm.configSettings.value;
			}
			vm.controlType = vm.configSettings.controlType;
			vm.screenName = 'useradmin';
			vm.isDisabled = true
			$scope.showButton = false;
			$scope.showDiscardButton = true;
			$scope.isShowSaveButton = false;
			$scope.isShowResubmit = false;
		}

		else if (workflowSharedService.viewFrom == 'applicationWideSettings_resubmit') {
			vm.configSettings = angular.fromJson($rootScope.payload);
			vm.headerLabel = vm.configSettings.configurationCategory.name;
			vm.labelName = vm.configSettings.configDescription;
			vm.configName = vm.configSettings.configName;
			if (vm.configSettings.controlType == 'amcdate') {
				vm.configValue = DateUtils.convertLocalDateFromServer(vm.configSettings.value);
			} else {
				vm.configValue = vm.configSettings.value;
			}

			vm.controlType = vm.configSettings.controlType;
			vm.isDisabled = false;
			vm.screenName = 'useradmin';
			$scope.isShowResubmit = true;
			$scope.isShowSaveButton = false;

		} else if (workflowSharedService.viewFrom == 'dealingAdminApplicationWideSettingstodolist_checker') {
			vm.ViewDisable = true;

			vm.configSettings = angular.fromJson($rootScope.payload);
			console.log(vm.configSettings);
			vm.headerLabel = vm.configSettings.configurationCategory.name;
			vm.labelName = vm.configSettings.configDescription;
			vm.configName = vm.configSettings.configName;
			vm.controlType = vm.configSettings.controlType;
			if (vm.configSettings.controlType == 'amcdate') {
				vm.configValue = DateUtils.convertLocalDateFromServer(vm.configSettings.value);
			} else {
				vm.configValue = vm.configSettings.value;
			}
			vm.isDisabled = true
			$scope.showButton = true;
			$scope.showDiscardButton = false;
			$scope.isShowResubmit = false;
			$scope.isShowSaveButton = false;


		} else if (workflowSharedService.viewFrom == 'dealingAdminApplicationWideSettingstodolist_maker') {
			vm.ViewDisable = true;
			vm.configSettings = angular.fromJson($rootScope.payload);
			vm.headerLabel = vm.configSettings.configurationCategory.name;
			vm.labelName = vm.configSettings.configDescription;
			vm.configName = vm.configSettings.configName;
			vm.controlType = vm.configSettings.controlType;
			if (vm.configSettings.controlType == 'amcdate') {
				vm.configValue = DateUtils.convertLocalDateFromServer(vm.configSettings.value);
			} else {
				vm.configValue = vm.configSettings.value;
			}

			vm.isDisabled = true
			$scope.showButton = false;
			$scope.showDiscardButton = true;
			$scope.isShowSaveButton = false;
			$scope.isShowResubmit = false;
		}

		else if (workflowSharedService.viewFrom == 'dealingAdminApplicationWideSettingstodolist_resubmit') {
			vm.configSettings = angular.fromJson($rootScope.payload);
			if (vm.configSettings.configurationCategory != undefined) {
				vm.headerLabel = vm.configSettings.configurationCategory.name;
				vm.labelName = vm.configSettings.configDescription;
				vm.configName = vm.configSettings.configName;
				m.controlType = angular.copy(vm.configSettings.controlType);
				if (vm.configSettings.controlType == 'amcdate') {
					vm.configValue = DateUtils.convertLocalDateFromServer(angular.copy(vm.configSettings.value));
				} else {
					vm.configValue = angular.copy(vm.configSettings.value);
				}
			} else {
				vm.headerLabel = 'Order Settings';
				vm.labelName = vm.configSettings.name;
				vm.configName = vm.configSettings.shortName;
				vm.configValue = vm.configSettings.value;
				vm.controlType = 'numeric';
				vm.screenName = 'transactionParametersSettings';
			}

			vm.isDisabled = false;
			$scope.isShowResubmit = true;
			$scope.isShowSaveButton = false;
		}
		else if (workflowSharedService.viewFrom == 'userAdminApplicationWideSettings_auditlog') {

			vm.configSettings = angular.fromJson($rootScope.payload);;
			vm.headerLabel = vm.configSettings.configurationCategory.name;
			vm.labelName = vm.configSettings.configDescription;
			vm.configName = vm.configSettings.configName;
			if (vm.configSettings.controlType == 'amcdate') {
				vm.configValue = DateUtils.convertLocalDateFromServer(vm.configSettings.value);
			} else {
				vm.configValue = vm.configSettings.value;
			}
			vm.controlType = vm.configSettings.controlType;
			vm.isDisabled = true;
			$scope.isShowResubmit = false;
			$scope.isShowSaveButton = false;

		}
		else if (workflowSharedService.viewFrom == 'dealingAdminApplicationWideSettings_auditlog') {
			vm.configSettings = angular.fromJson($rootScope.payload);
			console.log(vm.configSettings);
			vm.headerLabel = vm.configSettings.configurationCategory.name;
			vm.labelName = vm.configSettings.configDescription;
			vm.configName = vm.configSettings.configName;
			vm.controlType = vm.configSettings.controlType;
			if (vm.configSettings.controlType == 'amcdate') {
				vm.configValue = DateUtils.convertLocalDateFromServer(vm.configSettings.value);
			} else {
				vm.configValue = vm.configSettings.value;
			}
			vm.isDisabled = true;
			$scope.isShowResubmit = false;
			$scope.isShowSaveButton = false;
		} else if (workflowSharedService.viewFrom == 'TransactionParametersSettingstodolist_maker') {
			vm.configSettings = angular.fromJson($rootScope.payload);
			vm.headerLabel = 'Order Settings';
			vm.labelName = vm.configSettings.name;
			vm.configName = vm.configSettings.shortName;
			vm.configValue = vm.configSettings.value;
			vm.controlType = 'numericwithdecimals';
			vm.screenName = 'transactionParametersSettings';
			vm.isDisabled = true
			$scope.showButton = false;
			$scope.showDiscardButton = true;
			$scope.isShowSaveButton = false;
			$scope.isShowResubmit = false;
		} else if (workflowSharedService.viewFrom == 'TransactionParametersSettingstodolist_checker') {
			vm.configSettings = angular.fromJson($rootScope.payload);
			vm.headerLabel = 'Order Settings';
			vm.labelName = vm.configSettings.name;
			vm.configName = vm.configSettings.shortName;
			vm.configValue = vm.configSettings.value;
			vm.controlType = 'numericwithdecimals';
			vm.screenName = 'transactionParametersSettings';
			vm.isDisabled = true
			$scope.showButton = true;
			$scope.showDiscardButton = false;
			$scope.isShowResubmit = false;
			$scope.isShowSaveButton = false;
		} else if (workflowSharedService.viewFrom == 'TransactionParametersSettingstodolist_resubmit') {
			vm.configSettings = angular.fromJson($rootScope.payload);
			vm.headerLabel = 'Order Settings';
			vm.labelName = vm.configSettings.name;
			vm.configName = vm.configSettings.shortName;
			vm.configValue = vm.configSettings.value;
			vm.controlType = 'numericwithdecimals';
			vm.screenName = 'transactionParametersSettings';
			vm.isDisabled = false;
			$scope.isShowResubmit = true;
			$scope.isShowSaveButton = false;
		} else if (workflowSharedService.viewFrom == 'TransactionParametersSettingstodolist_auditlog') {
			vm.configSettings = angular.fromJson($rootScope.payload);
			console.log(vm.configSettings);
			vm.headerLabel = vm.configSettings.configurationCategory.name;
			vm.labelName = vm.configSettings.configDescription;
			vm.configName = vm.configSettings.configName;
			vm.controlType = vm.configSettings.controlType;
			if (vm.configSettings.controlType == 'amcdate') {
				vm.configValue = DateUtils.convertLocalDateFromServer(vm.configSettings.value);
			} else {
				vm.configValue = vm.configSettings.value;
			}
			vm.isDisabled = true;
			$scope.isShowResubmit = false;
			$scope.isShowSaveButton = false;
		} else {
			vm.configSettings.isDefault = false;
			vm.configSettings.configName = $stateParams.configName;
			vm.configSettings.value = $stateParams.configValue;
			vm.configSettings.controlType = $stateParams.controlType;
			vm.configSettings.configDescription = $stateParams.labelName;
			vm.configSettings.currencyPairId = $stateParams.currencyPairId;
			vm.headerLabel = $stateParams.headerLabel;
			vm.labelName = $stateParams.labelName;
			vm.configName = $stateParams.configName;
			if ($stateParams.controlType == 'amcdate') {


				vm.configValue = moment($stateParams.configValue, 'DD/MM').toDate();
			} else {
				vm.configValue = $stateParams.configValue;
			}

			vm.controlType = $stateParams.controlType;
			vm.screenName = $stateParams.screenName;
			$scope.isShowSaveButton = true;
			console.log(vm.configSettings.value);
		}
		var transactionParamConfigs = buildTransactionParamConfigs();

		if (vm.configName == 'MaximumPasswordAgeInDays' || vm.configName == 'AutoWithdrawalOfCustomerRegistrationApplication'
			|| vm.configName == 'UnUsedTimeFrame' || vm.configName == 'DefaultLimitPeriodForSpotWindow'
			|| vm.configName == 'DefaultLimitPeriodForForwardAndAllWindow' || vm.configName == 'NoOfDaysToDisableTheAccount'
			|| vm.configName == 'NoOfDaysBeforePasswordWarning' || vm.configName == 'NoOfDaysEmailTriggeredForPendingApprovalRecords') {
			vm.isShowDays = true;
		} else if (vm.configName == 'MinimumPasswordAgeInHours') {
			vm.isShowHours = true;
		} else if (vm.configName == 'LifeSpanOfTheOTP' || vm.configName == 'ThrottlingParameters') {
			vm.isShowSeconds = true;
		} else if (vm.configName == 'NearestRoundingOffValueForUSD') {
			vm.noOfDecimals = vm.decimalForPaise;
			vm.isShowPaise = false;
			vm.isShowUSD = true;
		// } else if (vm.configName == 'MinimumOrderValue' || vm.configName == 'MaximumOrderValueHardCheck' || vm.configName == 'MaximumOrderValueSoftCheck') {
		// 	vm.noOfDecimals = vm.decimalForPaise;
		// 	vm.isShowPaise = false;
		// 	vm.isShowUSD = true;
		// 	vm.controlMin = 0;
		// 	vm.controlMax = $filter('number')(999999999.99, vm.decimalsForAmount);
		} else if (vm.configName == 'NearestRoundingOffValueForINR') {
			vm.controlMax = $filter('number')(99, 0);
			vm.isShowPaise = true;
		} else if (vm.configName == 'AllowedOrderPriceDeviationFromMarketPriceInPaise') {
			vm.controlMax = $filter('number')(999, 0);
			vm.isShowPaise = true;
			setCurrency();
		} else if (vm.configName == 'MarketMovementInterval' || vm.configName == 'SessionTimeoutInterval' || vm.configName == 'MinimumIdleTimeToRestrictOrderActivity'
			|| vm.configName == 'PreCASHSessionCloseIntimation') {
			vm.isShowMins = true;
		} else if (vm.configName == 'TimePeriodToBlockUserLoginInMinutes') {
			vm.isShowMins = true;
			vm.controlMin = 1;
			vm.controlMax = 100;
		} else if (vm.configName == 'SessionTimeoutInterval') {
			vm.isShowMins = true;
			vm.controlMin = 1;
		} else if (vm.configName == 'ExchangeRateChange') {
			vm.noOfDecimals = vm.decimalForPaise;
			setCurrency();
		}else if(vm.configName == 'AllowedOrderPriceDeviationFromMarketPriceInPercentage'){
			vm.noOfDecimals = vm.decimalForPaise;
			vm.isShowPercentage = true;
			setCurrency();
		} else if (vm.configName == 'MinimumTransactionChargePerTrade' || vm.configName == 'OrderLotSize') {
			vm.noOfDecimals = vm.decimalForPaise;
			vm.isShowPaise = true;
		} else if (vm.configName == 'DefaultLimitPeriodForFORWARDAndALLInDays' || vm.configName == 'DefaultLimitPeriodForSPOTWindowInDays') {
			vm.controlMin = 1;
			vm.controlMax = 3000;
		} else if (transactionParamConfigs[vm.configName]) {
			vm.noOfDecimals = vm.decimalForPaise;
			vm.isShowPaise = false;
			vm.isShowUSD = true;
			vm.controlMin = 0;
			vm.screenName = 'transactionParametersSettings';
			vm.controlMax = $filter('number')(999999999.99, vm.decimalsForAmount);
			setCurrency();
		}


		function buildTransactionParamConfigs() {
			return {
				'MinimumOrderValue': true,
				'MaximumOrderValueHardCheck': true,
				'MaximumOrderValueSoftCheck': true,
				'ExchangeRateChange': true
			};
		}





		vm.onValueChange = onValueChange;
		vm.monthsCountError = false;
		vm.minMaxAlertOnValueChange = minMaxAlertOnValueChange;
		function onValueChange(value) {
			if ((value != null || value != undefined) && value.toString().length != 0) {
				if (value > 20 || value <= 0) {
					vm.monthsCountError = true;
				}
				else {
					vm.monthsCountError = false;
				}
			} else {
				vm.monthsCountError = false;
			}


		}
		function setCurrency() {
			var cpId = $stateParams.currencyPairId;
			angular.forEach(vm.transactionParametersSettings, function (setting) {
				if (cpId && setting.currencyPair.id == cpId) {
					vm.currency = setting.currencyPair.baseCurrency.code;
					vm.currencyCode = ' For '+vm.currency 
				} else if (!cpId && vm.configName === setting.shortName) {
					vm.currency = setting.currencyPair.baseCurrency.code;
					vm.currencyCode =' For '+vm.currency 
				}
			});
		}

		function minMaxAlertOnValueChange(value, minValue, maxValue, errorText) {
			vm.errorText = "";
			if ((value != null || value != undefined) && value.toString().length != 0) {
				if (value > maxValue || value < minValue) {
					vm.numericValueError = true;
					vm.errorText = $filter('translate')(errorText)
				}
				else {
					vm.numericValueError = false;
				}
			} else {
				vm.numericValueError = false;
			}


		}

		function saveConfig() {
			if (vm.controlType == 'amcdate') {
				vm.configSettings.value = DateUtils.convertLocalDateToServer(angular.copy(vm.configValue));
			}
			if (vm.controlType == 'text' || vm.controlType == 'yesorno' || vm.controlType == 'email') {
				vm.configSettings.value = angular.copy(vm.configValue);
			}

			var currencySettingsMap = buildCurrencySettingsMap(vm.transactionParametersSettings);
			if (!validateOrderValueConfig(currencySettingsMap)) {
				return false;
			}

			if (vm.configName == 'OrderLotSize' || vm.configName == 'ExchangeRateChange'
				|| vm.configName == 'NearestRoundingOffValueForUSD' || vm.configName == 'AllowedOrderPriceDeviationFromMarketPriceInPercentage') {
				if (parseFloat(vm.configSettings.value) <= parseFloat("0")) {
					AlertService.error("Value should be greater than zero.");
					vm.clicked = false;
					return false;
				}
			}

			if (vm.screenName == 'useradmin') {
				ChangeConfig.updateConfigUserAdmin(vm.configSettings, onSaveSuccess, onSaveError)
			} else if (vm.screenName == 'transactionParametersSettings') {
				ChangeConfig.updateTransactionParametersSettings(vm.configSettings, onSaveSuccess, onSaveError)
			} else {
				ChangeConfig.updateConfigDealingAdmin(vm.configSettings, onSaveSuccess, onSaveError)
			}

		}

		function validateMinimumOrderValue(configSettingsValue, maximumOrderValueHardCheck) {
			vm.screenName = 'transactionParametersSettings';
			if (parseFloat(configSettingsValue) >= parseFloat(maximumOrderValueHardCheck)) {
				AlertService.error("Minimum order value should be less than maximum order value hard check.");
				vm.clicked = false;
				return false;
			}
			if (parseFloat(configSettingsValue) <= parseFloat("0")) {
				AlertService.error("Value should be greater than zero.");
				vm.clicked = false;
				return false;
			}
			return true;
		}

		function validateMaximumOrderValueHardCheck(configSettingsValue, minimumOrderValue, maximumOrderValueSoftCheck) {
			vm.screenName = 'transactionParametersSettings';
			if (parseFloat(configSettingsValue) <= parseFloat(minimumOrderValue)) {
				AlertService.error("Maximum order value hard check should be greater than minimum order value.");
				vm.clicked = false;
				return false;
			}

			if (parseFloat(configSettingsValue) < parseFloat(maximumOrderValueSoftCheck)) {
				AlertService.error("Maximum order value hard check should be greater than or equal to maximum order value soft check.");
				vm.clicked = false;
				return false;
			}
			return true;
		}
		function validateMaximumOrderValueSoftCheck(configSettingsValue, maximumOrderValueHardCheck) {
			vm.screenName = 'transactionParametersSettings';
			if (parseFloat(configSettingsValue) > parseFloat(maximumOrderValueHardCheck)) {
				AlertService.error("Maximum order value soft check should be less than or equal to maximum order value hard check.");
				vm.clicked = false;
				return false;
			}
			if (parseFloat(configSettingsValue) <= parseFloat("0")) {
				AlertService.error("Value should be greater than zero.");
				vm.clicked = false;
				return false;
			}
			return true;

		}


		function buildCurrencySettingsMap(settingsList) {
			var map = {};
			if (!settingsList) return map;

			settingsList.forEach(function (setting) {
				var currencyCode = setting.currencyPair.baseCurrency.code; // e.g. 'INR', 'USD'

				if (!currencyCode) return;

				if (!map[currencyCode]) {
					map[currencyCode] = {};
				}

				// Map shortName to the correct field in our map
				var shortName = setting.shortName; // e.g. 'MinimumOrderValueINR'

				if (shortName === 'MinimumOrderValue') {
					map[currencyCode].minimumOrderValue = setting.value;
				} else if (shortName === 'MaximumOrderValueHardCheck') {
					map[currencyCode].maximumOrderValueHardCheck = setting.value;
				} else if (shortName === 'MaximumOrderValueSoftCheck') {
					map[currencyCode].maximumOrderValueSoftCheck = setting.value;
				}
			});

			return map;
		}


		function validateOrderValueConfig(currencySettingsMap) {

			var configName = vm.configName ? vm.configName.trim() : '';
			var value = vm.configSettings.value;
			var currency = vm.currency;

			switch (configName) {

				case 'MinimumOrderValue':
					var hardCheckValue = currency
						? (currencySettingsMap[currency] && currencySettingsMap[currency].maximumOrderValueHardCheck)
						: vm.maximumOrderValueHardCheck;

					return validateMinimumOrderValue(value, hardCheckValue);


				case 'MaximumOrderValueHardCheck':
					var minValue = currency
						? (currencySettingsMap[currency] && currencySettingsMap[currency].minimumOrderValue)
						: vm.minimumOrderValue;

					var softCheckValue = currency
						? (currencySettingsMap[currency] && currencySettingsMap[currency].maximumOrderValueSoftCheck)
						: vm.maximumOrderValueSoftCheck;

					return validateMaximumOrderValueHardCheck(value, minValue, softCheckValue);


				case 'MaximumOrderValueSoftCheck':
					var hardCheckValue = currency
						? (currencySettingsMap[currency] && currencySettingsMap[currency].maximumOrderValueHardCheck)
						: vm.maximumOrderValueHardCheck;

					return validateMaximumOrderValueSoftCheck(value, hardCheckValue);


				case 'ExchangeRateChange':
					if (parseFloat(value) <= 0) {
						AlertService.error("Value should be greater than zero.");
						vm.clicked = false;
						return false;
					}
					return true;
			}

			// ✅ Other configs (non-currency based)
			var zeroCheckConfigs = [
				'OrderLotSize',
				'ExchangeRateChange',
				'NearestRoundingOffValueForUSD',
				'AllowedOrderPriceDeviationFromMarketPriceInPercentage'
			];

			if (zeroCheckConfigs.indexOf(configName) !== -1) {
				if (parseFloat(value) <= 0) {
					AlertService.error("Value should be greater than zero.");
					vm.clicked = false;
					return false;
				}
			}

			return true;
		}

		if (vm.controlType == 'numeric') {
			if (parseFloat(vm.configSettings.value) <= parseFloat("0")) {
				if (vm.configName == 'OTPEmailTemplateID') {
					AlertService.error("Invalid OTP email template ID.");
				} else {
					AlertService.error("Value should be greater than zero.");
				}
				vm.clicked = false;
				return false;
			}
		}

		function onSaveSuccess(result) {
			$scope.$emit('Refresh');
			$uibModalInstance.close();

		}

		function onSaveError() {

			vm.clicked = false;
		}

		function approveConfigSettings() {
			ChangeConfig.approve({
				"taskId": $rootScope.taskID
			}, onApproveSuccess, onApproveError);

		}

		function onApproveSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close();
		}
		function onApproveError(error) {
			vm.clicked = false;
		}

		function rejectConfigSettings() {
			Workflow.rejectTask($rootScope.taskID);
		}

		function discardConfigSettings() {
			ChangeConfig.discard({
				"taskId": $rootScope.taskID
			}, onDiscardSuccess, onDiscardError);

		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close();
		}
		function onDiscardError(error) {

		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close(result);
			$uibModalInstance.close();
		}

		function onResubmitError(error) {
			vm.clicked = false;
		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function resubmitConfigSettings() {
			if (vm.controlType == 'amcdate') {
				vm.configSettings.value = DateUtils.convertLocalDateToServer(angular.copy(vm.configValue));
			}
			if (vm.controlType == 'text' || vm.controlType == 'yesorno' || vm.controlType == 'email') {
				vm.configSettings.value = angular.copy(vm.configValue);
			}

			if (vm.screenName == 'useradmin') {
				ChangeConfig.resubmitForEdit({
					"taskId": $rootScope.taskID
				}, vm.configSettings, onResubmitSuccess, onResubmitError);
			} else if (vm.screenName == 'transactionParametersSettings') {
				ChangeConfig.resubmitTransactionParametersSettings({
					"taskId": $rootScope.taskID
				}, vm.configSettings, onResubmitSuccess, onResubmitError);

			} else {
				ChangeConfig.dealerAdminResubmitForEdit({
					"taskId": $rootScope.taskID
				}, vm.configSettings, onResubmitSuccess, onResubmitError);
			}



		}

	}
})();

 (function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('change-config', {
            parent: 'application-wide-settings',
            url: '/change-config/{headerLabel}/{labelName}/{configName}/{configValue}/{controlType}/{screenName}/{currencyPairId}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-config/change-config.html',
                    controller: 'ChangeConfigController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('applicationWideSettings');
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
         .state('change-config-auditlog', {
            parent: 'audit-log',
            url: '/change-config-auditlog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-config/change-config.html',
                    controller: 'ChangeConfigController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('applicationWideSettings');
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('change-config-historyreport', {
            parent: 'history-report',
            url: '/change-config-historyreport',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-config/change-config.html',
                    controller: 'ChangeConfigController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('applicationWideSettings');
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('dealing-admin-change-config', {
            parent: 'dealing-admin-application-wide-settings',
            url: '/change-config/{headerLabel}/{labelName}/{configName}/{configValue}/{controlType}/{screenName}/{currencyPairId}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-config/change-config.html',
                    controller: 'ChangeConfigController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('applicationWideSettings');
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('dealing-admin-change-config-auditlog', {
            parent: 'audit-log',
            url: '/change-dealing-admin-config-auditlog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-config/change-config.html',
                    controller: 'ChangeConfigController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('applicationWideSettings');
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('dealing-admin-change-config-historyreport', {
            parent: 'history-report',
            url: '/change-dealing-admin-config-historyreport',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'user-profile'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-config/change-config.html',
                    controller: 'ChangeConfigController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('applicationWideSettings');
                	$translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('application-wide-settings-todolist', {
            parent: 'dashboard',
            url: '/application-wide-settings-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/entities/change-config/change-config.html',
                    controller: 'ChangeConfigController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                	$state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('applicationWideSettings');
                	$translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('application-wide-settings-todolist.resubmit', {
            parent: 'dashboard',
            url: '/application-wide-settings-resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-config/change-config.html',
                    controller: 'ChangeConfigController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                        	

                        }
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                	$state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('applicationWideSettings');
                	 $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('dealing-admin-application-wide-settings-todolist', {
            parent: 'dashboard',
            url: '/dealing-admin-application-wide-settings-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/entities/change-config/change-config.html',
                    controller: 'ChangeConfigController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                	$state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('applicationWideSettings');
                	$translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('dealing-admin-application-wide-settings-todolist.resubmit', {
            parent: 'dashboard',
            url: '/dealing-admin-application-wide-settings-resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-config/change-config.html',
                    controller: 'ChangeConfigController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                        	

                        }
                    }
                }).result.then(function() {
                	$state.go('^', null, { reload: true });
                }, function() {
                	$state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('applicationWideSettings');
                	 $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
    };
    })();

(function() {
	'use strict';
	angular.module('gatewayApp').factory('ChangeConfig', ChangeConfig);

	ChangeConfig.$inject = [ '$resource' ];

	function ChangeConfig($resource) {
		var resourceUrl = 'api/change-email/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'updateConfigUserAdmin' : {
				method : 'POST',
				url : 'api/configuration-settings-useradmin',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                }                
			},
			'updateConfigDealingAdmin' : {
				method : 'POST',
				url : 'api/configuration-settings-dealingadmin',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'updateTransactionParametersSettings' : {
				method : 'POST',
				url : 'api/transaction-parameters-settings',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'resubmitTransactionParametersSettings' : {
				method : 'PUT',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/resubmit-transaction-parameters-settings/config',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'approve' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/approve'
			},
			'reject' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/reject'
			},
			'discard' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/discard'
			},
			'resubmitForEdit' : {
				method : 'PUT',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/resubmitForEdit/config',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'dealerAdminResubmitForEdit' : {
				method : 'PUT',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/dealerAdminResubmitForEdit/config',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			}
		});
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cancelled-orders-report', {
            parent: 'entity',
            params:{screen: 'CancelledOrdersReport'},
            url: '/cancelled-orders-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.cancelledordersreport.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cancelled-orders-report/cancelled-orders-report.html',
                    controller: 'CancelledOrdersReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cancelledordersreport');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('orderActivity');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('cancelled-order-activity', {
            parent: 'cancelled-orders-report',
            url: '/order-activity-status/{orderNumber}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-activity/order-activity.html',
                    controller: 'OrderActivityController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    	
                            	 entity: ['OrderActivity', 'GlobalValues', function(OrderActivity, GlobalValues) {
                                     return OrderActivity.get({orderNumber : $stateParams.orderNumber}).$promise;
                                 }],
                                 businessDate: null
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        

            
    };
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('CancelledOrdersReportService', CancelledOrdersReportService);

        CancelledOrdersReportService.$inject = ['$resource'];

    function CancelledOrdersReportService ($resource) {
        var resourceUrl =  '';
        
        return $resource(resourceUrl, {}, {
            'getCancelledOrdersReport':{
           	 
                isArray:true,
                 method: 'GET',
                 params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId', currencyPairId : '@currencyPairId'},
                 url: 'api/cancel-order-report/bank/:bankId/branch/:branchId/customer/:customerId/instrument/:instrumentId/currencyPair/:currencyPairId/'
                }

        	
            });
        }
    })();
    
(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'cancelledOrdersReport'
        })
        
        .controller('CancelledOrdersReportController', CancelledOrdersReportController);

        CancelledOrdersReportController.$inject = ['$scope', '$state', 'CancelledOrdersReportService', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout','IntradayMarket','DateUtils', 'DefaultMarket','StaticLookUp'];

    function CancelledOrdersReportController($scope, $state, CancelledOrdersReportService , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout,IntradayMarket,DateUtils, DefaultMarket,StaticLookUp) {

            var vm = this;
            vm.bankId = 0;
            vm.entityConstants = entityConstants;
            vm.screenName = entityConstants.ENTITY_SHORT_NAME.CANCELLEDORDERSREPORT;
            $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
            $scope.page = 1;
            vm.globalValues=GlobalValues;
            // DefaultMarket.marketInstruments(function(result){
            //     vm.instrumentTypes = result;
            // });
            getInstrumentMatchedCurrencypair();

           
            vm.screenLog = ScreenLog;
            vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
            vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();

            vm.todayDate = new Date();
            vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
            vm.orgId = vm.globalValues.getOrgId();

           
            vm.clicked=false;
            vm.getCancelledOrdersReport = getCancelledOrdersReport;
            vm.ExpandOrCollapsecanCelledOrdersReport=true;

            workflowSharedService.viewFrom = "cancelledOrdersReport";


            logScreenAccess();
            function getCancelledOrdersReport() {
               
            
   vm.bankId = 0;
   vm.branchId = 0;
   vm.customerId= 0;
   vm.instrumentId = 0;
      vm.currencyPairId = 0;
                        if(vm.bank!=null && vm.bank!=undefined){
                                vm.bankId = vm.bank.id;      
                        }


                        if(vm.branch!=null && vm.branch!=undefined){
                                vm.branchId = vm.branch.id;
                            }

                        if(vm.customer!=null && vm.customer!=undefined){
                                vm.customerId = vm.customer.id;
                            }


                        if(vm.instrument!=null && vm.instrument!=undefined){
                            vm.instrumentId = vm.instrument.id;
                        }

                        if(vm.orderStatus!=null && vm.orderStatus!=undefined){
                            vm.orderStatusId= vm.orderStatus.id;
                        }

                         if(vm.currencyPair!=null && vm.currencyPair!=undefined){
                            vm.currencyPairId = vm.currencyPair.id;
                        }

 CancelledOrdersReportService.getCancelledOrdersReport({"bankId": vm.bankId, "branchId":vm.branchId , "customerId" : vm.customerId ,
       "instrumentId" : vm.instrumentId,"currencyPairId" : vm.currencyPairId},function(result) {
   
       	   
   
     
        
        angular.forEach(result, function(value){
            value.revisionTimeStamp=moment(value.revisionTimeStamp,'YYYYMMDDHHmmss.SSSSSSSSS').format();
            
            if(value.expiryTime==0){
                  var time = moment().toDate();
                  time.setHours(0);
                  time.setMinutes(0);
                  time.setSeconds(0);
                  time.setMilliseconds(0);
                  value.expiryTime=time;
              }else{
                  value.expiryTime=moment(value.expiryTime,'YYYYMMDDHHmmss').format();
              }
            
            if(value.buySellFlag.toUpperCase()=='BUYY'){
                value.buySellFlag='Buy';
            }else if(value.buySellFlag.toUpperCase()=='SELL'){
                value.buySellFlag='Sell';
            }
            
            
            
            if(value.timeCondition.toUpperCase()!='GTTM'){
                value.expiryTime=null;
            }
            
            if(value.timeCondition.toUpperCase()=='DAYY'){
                value.timeCondition='DAY';
            }else if(value.timeCondition.toUpperCase()=='GTTM'){
                value.timeCondition='GTT';
            }else if(value.timeCondition.toUpperCase()=='IOCC'){
                value.timeCondition='IOC';
            }
            
            if(value.priceCondition.shortName!='STLS' && value.priceCondition.shortName!='TKPR'){
                value.stopExchangeRate=null;
            }
            
            if(value.lastTradeSequenceNumber==0){
                value.lastTradeSequenceNumber=0;
            }
         });
        
       
        vm.cancelledOrdersReport = result;
        vm.clicked=false;
     });        	
} 
function logScreenAccess(){
    ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
}

function loadCurrentBusinessDate(){
    IntradayMarket.getCurrentBusinessDate(getBusinessDateSuccess, getBusinessDateFailed);
}

function getBusinessDateSuccess(result){
    vm.currentBusinessDate = DateUtils.convertLocalDateFromServer(result.businessDate);
    
    vm.convertedCurrentBusinessDate=DateUtils.convertLocalDateToServer(vm.currentBusinessDate);
    
}

function getBusinessDateFailed(){
    
} 
vm.getSwapPoints = function getSwapPoints(spotExchangeRate, tradeExchangeRate){
    var swapPts =0;
		   if(spotExchangeRate!=0){
			var swapPts = Math.abs(spotExchangeRate - tradeExchangeRate) * 100
			swapPts = (Math.round(parseFloat(swapPts)*100)/100);
			return swapPts;
		   }else{
			return swapPts;
		   }
 }
    
	 $scope.$watch('vm.currencyPair', function (value) {
         if (value != null && value != undefined) {
			getInstrumentMatchedCurrencypair();
    	}
		})

		function getInstrumentMatchedCurrencypair(){
            var currencyPairId = vm.globalValues.getDefaultCurrencyPairId();
            if (!vm.currencyPair != null && vm.currencyPair != undefined) {
                currencyPairId = vm.currencyPair.id;
            }
			DefaultMarket.csInstruments({currencyPairId:currencyPairId},onGetInstrumentSuccess, onGetInstrumentFailure);
            
        } 

		function onGetInstrumentSuccess(result) {
            vm.instrumentTypes = result;
            // get tick size for each instrument
		}

		function onGetInstrumentFailure() {

        }




}
})();


(function() {
	'use strict';

	angular.module('gatewayApp').controller('BranchDialogController',
			BranchDialogController);

	BranchDialogController.$inject = [ '$scope', '$state', '$rootScope',
			'GlobalValues', 'workflowSharedService', '$uibModalInstance',
			'Branch', 'entity', 'DateUtils' ,'AlertService','$filter'];

	function BranchDialogController($scope, $state, $rootScope, GlobalValues,
			workflowSharedService, $uibModalInstance, Branch, entity, DateUtils,AlertService,$filter) {
		var vm = this;
		vm.branch = entity;
		vm.branchDTO = {};
		vm.user1 = {};
		vm.user2 = {};
		vm.ExpandOrCollapseUser1 = false;
		vm.ExpandOrCollapseUser2 = false;
		vm.ExpandOrCollapseBankDetails = true;
		vm.user1.mobileCountryCode = 91;
		vm.user2.mobileCountryCode = 91;
		vm.mobileCountryCode=91;
		vm.user1.gender = "M";
		vm.user2.gender = "M";
		vm.ifscOrSwift = 'IFSC';
		vm.numberOfDigits = 11;
		vm.isDefaultUsersRequired1 = false;
		vm.isDefaultUsersRequired2 = false;
		vm.openSearchBranch = openSearchBranch;
		vm.clear = clear;
		vm.save = save;
		vm.clicked = false;
		$scope.showButton = false;
		vm.resubmitBranch = resubmitBranch;
		vm.globalValues = GlobalValues;
		//vm.branch.country=vm.globalValues.getCountry();
		vm.user1.country=vm.globalValues.getCountry();
		vm.user2.country=vm.globalValues.getCountry();
		$scope.showButton = false;
        vm.todayDate=new Date();
        vm.valid=true;

		if (workflowSharedService.viewFrom == 'branch') {
			vm.branch = entity;
			if(vm.branch!=null && vm.branch.id!=null){
				//do nothing
			}else{
				vm.branch.country=vm.globalValues.getCountry();
			}
			vm.branch.bank = vm.globalValues.getBank();
			if(vm.branch.ifscOrSwift!=null && vm.branch.ifscOrSwift!=undefined){
				vm.ifscOrSwift = vm.branch.ifscOrSwift;	
			}
			if(vm.ifscOrSwift == 'SWIFT'){
				vm.swiftCode = vm.branch.ifscCode;
			}
			if(vm.branch.mobileCountryCode!=null && vm.branch.mobileCountryCode!=undefined){
				vm.mobileCountryCode=vm.branch.mobileCountryCode;
			}
			$scope.showButton = false;
		} else if (workflowSharedService.viewFrom == 'branchtodolist_resubmit') {
			vm.branchDTO = angular.fromJson($rootScope.payload);
			vm.branch = vm.branchDTO.branch;
			
		
			if (vm.branch == undefined) {
				vm.branch = vm.branchDTO
			} else {

				vm.user1 = vm.branchDTO.user1;
				vm.user2 = vm.branchDTO.user2;

				if (vm.user1 != null) {
					vm.isDefaultUsersRequired1 = true;
					vm.user1.dob = new Date(vm.branchDTO.user1.dob);
				}
				if (vm.user2 != null) {
					vm.isDefaultUsersRequired2 = true;
					vm.user2.dob = new Date(vm.branchDTO.user2.dob);
				}
				
				if(vm.user1==null){
					vm.user1={};
					vm.user1.mobileCountryCode=91;
					vm.user1.gender="M";
					vm.user1.country=vm.globalValues.getCountry();
				}
				if(vm.user2==null){
					vm.user2={};
					vm.user2.mobileCountryCode=91;
					vm.user2.gender="M";
					vm.user2.country=vm.globalValues.getCountry();
				}
			}
			
			
			vm.ifscOrSwift = vm.branch.ifscOrSwift;
			
			if(vm.ifscOrSwift == 'SWIFT'){
				vm.swiftCode = vm.branch.ifscCode;
			}
			vm.mobileCountryCode=vm.branch.mobileCountryCode;
			
			vm.disableForm = false;
			$scope.showButton = true;
		} else if (workflowSharedService.viewFrom == 'branch_resubmit_delete') {
			vm.branch = angular.fromJson($rootScope.payload);
			vm.disableForm = true;
			$scope.showButton = true;
		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		/* $scope.$watch('vm.ifscOrSwift', function(value){
	        	if(vm.ifscOrSwift == 'IFSC'){
	        		vm.numberOfDigits = 11;
	        	}else if(vm.ifscOrSwift == 'SWIFT'){
	        		vm.numberOfDigits = 8;
	        	}
	        });*/
		
		function save() {
			
			

			vm.branch.aliasName = vm.branch.branchName;
			vm.branch.shortName = vm.branch.branchName;
			vm.branch.name = vm.branch.branchName;
			vm.branch.mobileCountryCode=vm.mobileCountryCode;
			if(vm.ifscOrSwift == 'SWIFT'){
				vm.branch.ifscCode = vm.swiftCode;
				vm.branch.ifscOrSwift = 'SWIFT'
			}else {
				vm.branch.ifscOrSwift = 'IFSC'
			}
			if (vm.branch.id == null) {
				vm.branchDTO.branch = vm.branch;

				if (vm.isDefaultUsersRequired1 == true) {
					if(moment(vm.user1.dob).isAfter(vm.todayDate,'day')){
		    			AlertService.error($filter('translate')('gatewayApp.branch.futuredobUser1'));
		    			vm.clicked = false;
		    			vm.valid=false;
		    		}else{
		    			vm.valid=true;
		    			vm.branchDTO.user1 = vm.user1;
						vm.branchDTO.user1.entityOwnerTypeShortName = 'Branch'
						vm.branchDTO.user1.dob = DateUtils
								.convertLocalDateToServer(vm.user1.dob);
		    		}
					
				} else {
					vm.branchDTO.user1 = null;
				}
				
				if (vm.isDefaultUsersRequired2 == true) {
					if(moment(vm.user2.dob).isAfter(vm.todayDate,'day')){
		    			AlertService.error($filter('translate')('gatewayApp.branch.futuredobUser2'));
		    			vm.clicked = false;
		    			vm.valid=false;
		    		}else{
		    			vm.valid=true;
		    			vm.branchDTO.user2 = vm.user2;
						vm.branchDTO.user2.entityOwnerTypeShortName = 'Branch'
						vm.branchDTO.user2.dob = DateUtils
								.convertLocalDateToServer(vm.user2.dob);
		    		}
					
				} else {
					vm.branchDTO.user2 = null;
				}

			}

			if (vm.branch.id !== null) {
				Branch.update({
					"corpId" : GlobalValues.getCorpId()
				}, vm.branch, onSaveSuccess, onSaveError);
			} else if(vm.valid==true) {
				Branch.save({
					"corpId" : GlobalValues.getCorpId()
				}, vm.branchDTO, onSaveSuccess, onSaveError);
			}

		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
		}

		function onSaveError() {
			if (vm.isDefaultUsersRequired1 == true) {
				vm.user1.dob = DateUtils
						.convertDateTimeFromServer(vm.branchDTO.user1.dob);
				}
			if (vm.isDefaultUsersRequired2 == true) {
				vm.user2.dob = DateUtils
						.convertDateTimeFromServer(vm.branchDTO.user2.dob);
				}
			vm.clicked = false;
		}

		function resubmitBranch() {
			vm.branch.aliasName = vm.branch.branchName;
			vm.branch.shortName = vm.branch.branchName;
			vm.branch.name = vm.branch.branchName;
			vm.branch.mobileCountryCode=vm.mobileCountryCode;
			if(vm.ifscOrSwift == 'SWIFT'){
				vm.branch.ifscCode = vm.swiftCode;
				vm.branch.ifscOrSwift = 'SWIFT'
			}else {
				vm.branch.ifscOrSwift = 'IFSC'
			}
			if (vm.branch.id == null) {
				vm.branchDTO.branch = vm.branch;

				if (vm.isDefaultUsersRequired1 == true) {
					vm.branchDTO.user1 = vm.user1;
					vm.user1.dob = DateUtils
							.convertLocalDateToServer(vm.user1.dob);
					
					vm.branchDTO.user1.entityOwnerTypeShortName = 'Branch'
					
					vm.branchDTO.user1.dob = DateUtils
							.convertLocalDateToServer(vm.user1.dob);
					
				}else{
					vm.branchDTO.user1 = null;
				}
				
				if (vm.isDefaultUsersRequired2==true) {
					vm.branchDTO.user2 = vm.user2;
					vm.user2.dob = DateUtils
							.convertLocalDateToServer(vm.user2.dob);
					
					vm.branchDTO.user2.entityOwnerTypeShortName = 'Branch'
					
					vm.branchDTO.user2.dob = DateUtils
							.convertLocalDateToServer(vm.user2.dob);
					
				}else{
					vm.branchDTO.user2=null;
				}
			}

			if (vm.branch.id == null) {
				Branch.resubmitForCreate({
					"taskId" : $rootScope.taskID
				}, vm.branchDTO, onResubmitSuccess, onResubmitError);
			} else {
				Branch.resubmitForEdit({
					"taskId" : $rootScope.taskID
				}, vm.branch, onResubmitSuccess, onResubmitError);
			}

		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.dismiss('cancel');
		}
		function onResubmitError(error) {
			if(vm.branchDTO.user2!=null){
				vm.branchDTO.user2.dob = DateUtils.convertLocalDateFromServer(vm.branchDTO.user2.dob);
			}
			if(vm.branchDTO.user1!=null){
				vm.branchDTO.user1.dob = DateUtils.convertLocalDateFromServer(vm.branchDTO.user1.dob);
			}
        	vm.clicked = false;
		}
		
		$scope.$watch('vm.homeBranch', function(value){
			if(value!=null && value!='' && value!=undefined){
				vm.branch.branchName = value.branchName;
				vm.ifscOrSwift = "IFSC";
				vm.branch.ifscOrSwift = "IFSC";
				vm.branch.ifscCode = value.ifscCode;
			}
		})
		
		$scope.$watch('vm.branch.bank', function(value){
			if(value!=null && value!='' && value!=undefined){
				//var bankName = value.bankName;
				//bankName = bankName.substring(0, 5);		// mantis issue fix:20		
				vm.filterText = value.ccpMembershipId;
			}
		})
		
		function openSearchBranch(){
			if(workflowSharedService.viewFrom == 'branch'){
				$state.go('home-branch-filter', {filterText: vm.filterText});
			}else if(workflowSharedService.viewFrom == 'branchtodolist_resubmit'){
				$state.go('home-branch-filter-resubmit', {filterText: vm.filterText});
			}
			
			$rootScope.$on('searchBranch', function(event, result) {
	        	vm.homeBranch= $rootScope.branch;
	        });
		}

	}
})();

(function() {
	'use strict';

	angular.module('gatewayApp').controller('BranchViewController',
			BranchViewController);

	BranchViewController.$inject = [ '$scope', '$state', '$rootScope',
			'workflowSharedService', '$uibModalInstance', 'Branch', 'entity',
			'Workflow', 'GlobalValues' ];

	function BranchViewController($scope, $state, $rootScope,
			workflowSharedService, $uibModalInstance, Branch, entity, Workflow,
			GlobalValues) {
		var vm = this;
		vm.clear = clear;
		vm.approveBranch = approveBranch;
		vm.rejectBranch = rejectBranch;
		vm.discardBranch = discardBranch;
		$scope.showButton = false;
		$scope.showDiscardButton = false;
		vm.clicked = false;
		vm.ExpandOrCollapseUser1 = false;
		vm.ExpandOrCollapseUser2 = false;
		vm.ExpandOrCollapseBankDetails = true;
		vm.globalValues = GlobalValues;
		vm.branchDTO = {};
		vm.isDefaultUsersRequired1 = false;
		vm.isDefaultUsersRequired2 = false;

		if (workflowSharedService.viewFrom == 'branch') {
			vm.branch = entity;
			vm.mobileCountryCode=vm.branch.mobileCountryCode;
			$scope.showButton = false;
		} else if (workflowSharedService.viewFrom == 'branchtodolist_checker') {
			vm.branchDTO = angular.fromJson($rootScope.payload);
			vm.branch = vm.branchDTO.branch;

			if (vm.branch == undefined) {
				vm.branch = vm.branchDTO
			}
			vm.mobileCountryCode=vm.branch.mobileCountryCode;
			vm.user1 = vm.branchDTO.user1;
			vm.user2 = vm.branchDTO.user2;

			if (vm.user1 != undefined) {
				vm.user1.dob = new Date(vm.user1.dob);
				vm.isDefaultUsersRequired1 = true;
			}

			if (vm.user2 != undefined) {
				vm.user2.dob = new Date(vm.user2.dob);
				vm.isDefaultUsersRequired2 = true;
			}

			$scope.showButton = true;
			$scope.showDiscardButton = false;
		} else if (workflowSharedService.viewFrom == 'branchtodolist_maker') {
			vm.branchDTO = angular.fromJson($rootScope.payload);
			vm.branch = vm.branchDTO.branch;
			if (vm.branch == undefined || vm.branch == null) {
				vm.branch = vm.branchDTO
			}
			vm.mobileCountryCode=vm.branch.mobileCountryCode;
			vm.user1 = vm.branchDTO.user1;
			vm.user2 = vm.branchDTO.user2;

			if (vm.user1 != undefined) {
				vm.user1.dob = new Date(vm.user1.dob);
				vm.isDefaultUsersRequired1 = true;
			}

			if (vm.user2 != undefined) {
				vm.user2.dob = new Date(vm.user2.dob);
				vm.isDefaultUsersRequired2 = true;
			}

			$scope.showButton = false;
			$scope.showDiscardButton = true;
		} else if (workflowSharedService.viewFrom == 'branch_auditLog') {
			vm.branchDTO = angular.fromJson($rootScope.payload);
			vm.branch = vm.branchDTO.branch;

			if (vm.branch == undefined) {
				vm.branch = vm.branchDTO
			}
			vm.mobileCountryCode=vm.branch.mobileCountryCode;
			vm.user1 = vm.branchDTO.user1;
			vm.user2 = vm.branchDTO.user2;
			
			if (vm.user1 != undefined) {
				vm.user1.dob = new Date(vm.user1.dob);
				vm.isDefaultUsersRequired1 = true;
			}

			if (vm.user2 != undefined) {
				vm.user2.dob = new Date(vm.user2.dob);
				vm.isDefaultUsersRequired2 = true;
			}

			$scope.showButton = false;
		}

		function approveBranch() {
			Branch.approve({
				"taskId" : $rootScope.taskID
			}, onApproveSuccess, onApproveError);
			$uibModalInstance.dismiss('cancel');
		}

		function onApproveSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
		}
		function onApproveError(error) {
			vm.clicked=false;
		}

		function rejectBranch() {
			Workflow.rejectTask($rootScope.taskID);
		}

		function discardBranch() {
			Branch.discard({
				"taskId" : $rootScope.taskID
			}, onDiscardSuccess, onDiscardError);
			$uibModalInstance.dismiss('cancel');
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);
		}
		function onDiscardError(error) {

		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('BranchDeleteController',BranchDeleteController);

    BranchDeleteController.$inject = ['$uibModalInstance', 'entity', 'Branch', 'GlobalValues','$scope'];

    function BranchDeleteController($uibModalInstance, entity, Branch, GlobalValues,$scope) {
        var vm = this;

        vm.branch = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        $scope.clicked=false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        
        function confirmDelete (id) {
        	Branch.delete({"corpId": GlobalValues.getCorpId(),"id":id},
                    function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('branch', {
            parent: 'entity',
            params:{screen: 'BranchRegistration'},
            url: '/branch',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.branch.manageBranchRegistration" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/branch/branch.html',
                    controller: 'BranchController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('branch');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('branch.new', {
            parent: 'branch',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/branch/branch-dialog.html',
                    controller: 'BranchDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	 id:null,  
                            	name:null                            	
                             
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('branch', null, { reload: 'branch' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('branch.view', {
            parent: 'branch',
            url: '/branch/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/branch/branch-detail.html',
                    controller: 'BranchViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['Branch', 'GlobalValues', function(Branch, GlobalValues) {
                                     return Branch.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('branch.edit', {
            parent: 'branch',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/branch/branch-dialog.html',
                    controller: 'BranchDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['Branch', 'GlobalValues', function(Branch, GlobalValues) {
                                     return Branch.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('branch.delete', {
            parent: 'branch',
            url: '/delete/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/branch/branch-delete-dialog.html',
                    controller: 'BranchDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Branch', 'GlobalValues', function(Branch, GlobalValues) {
                            return Branch.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    //$state.go('^', null, { reload: true });
                	$state.go('branch', null, { reload: 'branch' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('branch-todolist', {
            parent: 'dashboard',
            url: '/branchview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/branch/branch-detail.html',
                    controller: 'BranchViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('branch', null, { reload: 'branch' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('branch-todolist.resubmit', {
            parent: 'dashboard',
            url: '/branchedit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/branch/branch-dialog.html',
                    controller: 'BranchDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('branch', null, { reload: 'branch' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('branch-auditLog', {
            parent: 'audit-log',
            url: '/branchview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/branch/branch-detail.html',
                    controller: 'BranchViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('branch', null, { reload: 'branch' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('branch-historyReport', {
            parent: 'history-report',
            url: '/branchview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/branch/branch-detail.html',
                    controller: 'BranchViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('branch', null, { reload: 'branch' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })

        .state('home-branch-filter', {
            parent: 'branch.new',
            url: '/fetch-branch/{filterText}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/home-branch-filter/home-branch-filter.html',
                    controller: 'HomeBranchFilterController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('branch.new', null, { reload: 'branch.new' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })

        .state('home-branch-filter-resubmit', {
            parent: 'branch-todolist.resubmit',
            url: '/fetch-branch-resubmit/{filterText}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/home-branch-filter/home-branch-filter.html',
                    controller: 'HomeBranchFilterController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('branch.new', null, { reload: 'branch.new' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('Branch', Branch);

    Branch.$inject = ['$resource'];

    function Branch ($resource) {
        var resourceUrl =  'api/branch/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },           
           	
			'getBranchLookup' : {
				method : 'GET',
				isArray: true,
				url : 'api/branch/lookup'
			},

			'save': {
                method: 'POST',
                params: {corpId:'@corpId'},
                url: 'api/branch/:corpId',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                }                
            },
            'update': {
            	method:'PUT',
            	params: {corpId:'@corpId'},
                url: 'api/branch/:corpId',
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
            'delete':{
                method: 'DELETE',
                params: {corpId:'@corpId', id:'@id'},
                url: 'api/branch/:corpId/:id'    
                },
         
            'approve': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
              	 method: 'GET',
                   params: {taskId:'@taskId'},
                   url: 'api/tasks/:taskId/discard'
             },
             'resubmitForCreate': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/resubmitForCreate/branch',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             },
             'resubmitForEdit': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/resubmitForEdit/branch',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             },
             'getAllClearanceBranches': {
                 method: 'GET',
                 isArray: true,
                 params: {bankId:'@bankId'},
                 url: 'api/bank/:bankId/cleared-branches',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
             'getAllBranchesForBank': {
                 method: 'GET',
                 isArray: true,
                 params: {bankId:'@bankId'},
                 url: 'api/branches-for-bank/:bankId',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
             'getAllBranchesLookupForBank': {
                 method: 'GET',
                 isArray: true,
                 params: {bankId:'@bankId'},
                 url: 'api/branch/lookup/:bankId/bank',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
             'getAllBranchesLookupWithStatusForBank': {
                 method: 'GET',
                 isArray: true,
                 params: {bankId:'@bankId'},
                 url: 'api/branch-with-status/lookup/:bankId/bank',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
             'getAllActiveBranchesLookupForBank': {
                 method: 'GET',
                 isArray: true,
                 params: {bankId:'@bankId'},
                 url: 'api/active-branch/lookup/:bankId/bank',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
             'getBranchForUser': {
                 method: 'GET',
                 params: {userId:'@userId'},
                 url: 'api/branch-for-user/:userId',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
             'getValidBranchesForBank': {
                 method: 'GET',
                 isArray: true,
                 params: {bankId:'@bankId',customerId:'@customerId'},
                 url: 'api/valid-status-branches-for-bank/:bankId/:customerId',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
             'getValidBranchDetailsForBank': {
                 method: 'GET',
                 isArray: true,
                 params: {bankId:'@bankId'},
                 url: 'api/public/trading-branch/:bankId/bank',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             }           
            
              });
    }
})();

            

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'branch'
        })
        
        .controller('BranchController', BranchController);

    BranchController.$inject = ['$scope', '$state', 'workflowSharedService', 'Branch', 'GlobalValues', 'EntityPermissions','ScreenLog','$rootScope','entityConstants','$timeout'];

    function BranchController($scope, $state, workflowSharedService, Branch, GlobalValues, EntityPermissions,ScreenLog,$rootScope,entityConstants,$timeout) {
        
        var vm = this;
        
        vm.globalValues = GlobalValues;
        vm.screenLog = ScreenLog;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.BRANCH_REGISTRATION;
        $scope.refresh=refresh;
        workflowSharedService.viewFrom = "branch";
        vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
        vm.orgId = vm.globalValues.getOrganisation().id;
        vm.launch=launch;
        vm.clicked=false;
        function launch() {
        	$state.go("branch.new");
        }
        
        vm.permitBranchEditEntityAction = EntityPermissions.hasPermission('BranchRegistration.EDIT')
        vm.permitBranchCreateEntityAction = EntityPermissions.hasPermission('BranchRegistration.CREATE')
		vm.permitBranchViewEntityAction = EntityPermissions.hasPermission('BranchRegistration.VIEW')
		vm.permitBranchDeleteEntityAction = EntityPermissions.hasPermission('BranchRegistration.DELETE')
		vm.permitBranchImportEntityAction = EntityPermissions.hasPermission('BranchRegistration.IMPORT')
 
		console.log(vm.permitBranchCreateEntityAction);
		if(vm.permitBranchCreateEntityAction){
			loadAll();	
		}
        
		function loadAll(){
			Branch.getAllBranchesForBank({bankId: vm.globalValues.getOrganisation().id}, function(result) {
                vm.branch = result;
                vm.clicked=false;                    
            });	
		}
		logScreenAccess();
        vm.loadAll = function loadAll(bank) {
        	vm.bankId = 0;
        		if(bank!=null && bank!=undefined){
            		vm.bankId = bank.id;
        		}
        		Branch.getAllBranchesForBank({bankId: vm.bankId}, function(result) {
                    vm.branch = result;
                    vm.clicked=false;            
                });

        	if(bank != undefined){vm.bankId = bank.id};
        	console.log(vm.bankId);
        	
        	
            
        }
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }
        
        $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
      
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('bbpsMarkupDetails', {
            parent: 'account',
            url: '/bbps-markup-details',
            data: {
                authorities: []
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/entities/bbps-markup-details/bbps-markup-details.html',
                    controller: 'bbpsMarkupDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    return $translate.refresh();
                }]
            }
        })

                
    }
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('bbpsMarkupDetailsController',bbpsMarkupDetailsController);

		bbpsMarkupDetailsController.$inject = ['$scope', 'MarkupReport'];

    function bbpsMarkupDetailsController ($scope,MarkupReport ) {
        var vm = this;

        bbpsMarkupDetailsFile();

   function bbpsMarkupDetailsFile(){
	   MarkupReport.getBBPSMarkupDetails(function(result){
                vm.bbpsMarkupDetails = result.data;
				previewTACForArray( vm.bbpsMarkupDetails, 'BBPS_Markup_Details.pdf');
				
	   })
	
    }
    function previewTACForArray(arrayBuffer, pdfFileName) {
    var file = new Blob([arrayBuffer], { type: 'application/pdf' });
    var fileURL = URL.createObjectURL(file);

    // instead of opening new window, show inside current page
    document.getElementById("pdfContainer").innerHTML =
        '<embed src="' + fileURL + '" type="application/pdf" width="100%" height="100%">';
}
}
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('BankRegistrationDialogController', BankRegistrationDialogController);

    BankRegistrationDialogController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','BankRegistration','entity', 'DateUtils','MessageBox','AlertService','$filter'];

     function BankRegistrationDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,BankRegistration,entity,DateUtils,MessageBox,AlertService,$filter) {
        var vm = this;
        vm.bankRegistration=entity;   
        vm.bankDTO = {};
        vm.user1={};
        vm.user2={};
        vm.ExpandOrCollapseUser1 = false;
        vm.ExpandOrCollapseUser2 = false;
        vm.ExpandOrCollapseBankDetails = true;
        vm.user1.mobileCountryCode = 91;
        vm.user2.mobileCountryCode = 91;
        vm.mobileCountryCode = 91;
        vm.user1.gender= "M";
        vm.user2.gender= "M";
                
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        vm.resubmitBankRegistration =resubmitBankRegistration;
        vm.globalValues = GlobalValues;
       // vm.bankRegistration.country=vm.globalValues.getCountry();
        vm.user1.country=vm.globalValues.getCountry();
        vm.user2.country=vm.globalValues.getCountry();
        vm.country = vm.globalValues.getCountry();
        $scope.showButton = false;
        vm.todayDate=new Date();
        
       /* $scope.$watch('vm.bankRegistration.dateOfJoining', function(value){
        	if(value!=null && value!=undefined){
        		
        			if(moment(value).isAfter(vm.todayDate,'day')){
                		$scope.clicked=false;
                		 AlertService.error($filter('translate')('gatewayApp.bankRegistration.futureDateOfJoining'));
                		 
                	 }
        		}
        	
        })*/
        
        /*$scope.$watch('vm.bankRegistration.dateOfJoining', function(newValue, oldValue){
        	if(newValue!=null && newValue!=undefined){
        		if(moment(newValue).isSame(oldValue,'day')){
            		if(moment(newValue).isAfter(vm.todayDate,'day')){
            			AlertService.error($filter('translate')('gatewayApp.AuditLog.futureFromDate'));
            			vm.valid=false;
            		}
        		}
        	}
        })*/
                
        if(workflowSharedService.viewFrom == 'bankregistration'){
        	vm.bankRegistration=entity;
        	 vm.bankRegistration.country=vm.globalValues.getCountry();
        	if(vm.bankRegistration.mobileCountryCode!=null || vm.bankRegistration.mobileCountryCode!=undefined){
        		vm.mobileCountryCode=vm.bankRegistration.mobileCountryCode;
        	}
        	        	
       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'bank-registrationtodolist_resubmit') {
        	vm.bankDTO =  angular.fromJson($rootScope.payload);
        	vm.bankRegistration = vm.bankDTO.bank;
        	//vm.bankRegistration.mobileCountryCode = 91;
        	
        	if(vm.bankRegistration == undefined){
        		vm.bankRegistration = vm.bankDTO;
        		
        	}else{
        		vm.user1 = vm.bankDTO.user1;
 		        vm.user2 = vm.bankDTO.user2;
 		        vm.user1.dob=new Date(vm.bankDTO.user1.dob);
 	  			vm.user2.dob=new Date(vm.bankDTO.user2.dob);
        	}
        	
        	
        	vm.mobileCountryCode=vm.bankRegistration.mobileCountryCode;
		    vm.disableForm = false;
        	$scope.showButton=true;
        }
        else if(workflowSharedService.viewFrom == 'bank-registration_resubmit_delete') {
        	vm.bankRegistration = angular.fromJson($rootScope.payload); 
        	vm.disableForm = true;
        	$scope.showButton=true;
        }
		vm.bankRegistration.dateOfJoining = new Date(vm.bankRegistration.dateOfJoining);
		
	
		

        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	
        	if(moment(vm.bankRegistration.dateOfJoining).isAfter(vm.todayDate,'day')){
        		
        		 AlertService.error($filter('translate')('gatewayApp.bankRegistration.futureDateOfJoining'));
        		 
        	 }else if(moment(vm.user1.dob).isAfter(vm.todayDate,'day')){
        		
        		 AlertService.error($filter('translate')('gatewayApp.bankRegistration.futuredobUser1'));
        	 }else if(moment(vm.user2.dob).isAfter(vm.todayDate,'day')){
        		 AlertService.error($filter('translate')('gatewayApp.bankRegistration.futuredobUser2'));
        	 }
        	else{
				vm.clicked=true
        		vm.bankRegistration.aliasName = vm.bankRegistration.bankName;
            	vm.bankRegistration.shortName = vm.bankRegistration.bankName;
            	vm.bankRegistration.name = vm.bankRegistration.bankName;
            	vm.bankRegistration.mobileCountryCode=vm.mobileCountryCode;
            	vm.bankRegistration.legalName = vm.legalName;
            	vm.bankRegistration.tradeName = vm.tradeName;
            	
            	vm.bankRegistration.dateOfJoining = DateUtils.convertLocalDateToServer(vm.bankRegistration.dateOfJoining);
            	 if (vm.bankRegistration.id == null) {
            		 vm.bankDTO.bank = vm.bankRegistration;
                 	vm.bankDTO.user1 = vm.user1;
                 	vm.bankDTO.user2 = vm.user2;
                    	 vm.bankDTO.user1.entityOwnerTypeShortName = 'Bank'
                 		 vm.bankDTO.user2.entityOwnerTypeShortName = 'Bank'
                 	vm.user1.dob = DateUtils.convertLocalDateToServer(vm.bankDTO.user1.dob);
                 	vm.user2.dob = DateUtils.convertLocalDateToServer(vm.bankDTO.user2.dob);
            	 }
            	    	
            	
            	//vm.bankRegistration.getEntityRestrictionStatus() = "Active";
            	 if (vm.bankRegistration.id !== null) {
                     BankRegistration.update({ "corpId": GlobalValues.getCorpId() },vm.bankRegistration, onSaveSuccess, onSaveError);
                 } else {
                	 BankRegistration.save({ "corpId": GlobalValues.getCorpId() },vm.bankDTO, onSaveSuccess, onSaveError);           
                 }    
        	}
        	   	
         }
      
        vm.memberNo = '';
        vm.getUserNo = function getUserNo(MemberNo){
        	 
        	 if (MemberNo!=vm.memberNo && MemberNo!=null && MemberNo!="" && (/^\d+$/.test(MemberNo))){
        		 vm.memberNo = MemberNo;
        		 vm.flag = 1;
        		//vm.bankRegistration.userNo = BankRegistration.getUserNo({"MemberNo":MemberNo});
        		BankRegistration.getUserNo({"MemberNo":MemberNo}, function(result) {
        			vm.bankRegistration.userNo = result.userNo;
					$scope.bankregistrationForm.$setValidity("txtuserNo" + "txtrequired", true);
        			//vm.bankRegistration.ngCode = result.ngCode;
        			if(result == null){
        				MessageBox.openMessageBox("Alert", "Invalid Member No", "Ok", "invalidmember");
						$scope.bankregistrationForm.$setValidity("txtuserNo" + "txtrequired", false);
        			}
                });
        		//vm.UserNo  = vm.bankRegistration.userNo;
        			
        	}
        }
        
       
        
        $scope.$watch('vm.bankRegistration.state', function(value){
           	if(value!=null && value!=undefined){
           		vm.stateCode = vm.bankRegistration.state.tinNumber;
           	}
           });
        
        $scope.$watch('vm.bankRegistration.bankName', function(value){
           	if(value!=null && value!=undefined){
           		vm.legalName=value;
           		vm.tradeName=value;
           	}
           });
        
        $rootScope.$on('gatewayApp.messagebox.ok.invalidmember', function (event, data) {
        	//do nothing
        });
     
        function onSaveSuccess (result) {
			vm.clicked=false;
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
			vm.clicked = false;
        	vm.bankRegistration.dateOfJoining = DateUtils.convertDateTimeFromServer(vm.bankRegistration.dateOfJoining);
        	    	vm.user1.dob = DateUtils.convertDateTimeFromServer(vm.bankDTO.user1.dob);
        	vm.user2.dob = DateUtils.convertDateTimeFromServer(vm.bankDTO.user2.dob);
        	
        }
        function resubmitBankRegistration() {
        	
        	if(moment(vm.bankRegistration.dateOfJoining).isAfter(vm.todayDate,'day')){
        		 AlertService.error($filter('translate')('gatewayApp.bankRegistration.futureDateOfJoining'));
				 
        	 }else if(moment(vm.user1.dob).isAfter(vm.todayDate,'day')){
        		 AlertService.error($filter('translate')('gatewayApp.bankRegistration.futuredobUser1'));	
        	 }else if(moment(vm.user2.dob).isAfter(vm.todayDate,'day')){
        		 AlertService.error($filter('translate')('gatewayApp.bankRegistration.futuredobUser2'));	
        	 }
        	else{
				vm.clicked = true;
        		vm.bankRegistration.aliasName = vm.bankRegistration.bankName;
            	vm.bankRegistration.shortName = vm.bankRegistration.bankName;
            	vm.bankRegistration.name = vm.bankRegistration.bankName;
            	vm.bankRegistration.mobileCountryCode=vm.mobileCountryCode;
            	vm.bankRegistration.legalName = vm.legalName;
            	vm.bankRegistration.tradeName = vm.tradeName;
            	
            	vm.bankRegistration.dateOfJoining = DateUtils.convertLocalDateToServer(vm.bankRegistration.dateOfJoining);
            	 if (vm.bankRegistration.id == null) {
            		 vm.bankDTO.bank = vm.bankRegistration;
                 	vm.bankDTO.user1 = vm.user1;
                 	vm.bankDTO.user2 = vm.user2;
                 
                 	 vm.bankDTO.user1.entityOwnerTypeShortName = 'Bank'
                 		 vm.bankDTO.user2.entityOwnerTypeShortName = 'Bank'
                 	vm.bankDTO.user1.dob = DateUtils.convertLocalDateToServer(vm.user1.dob);
                 	vm.bankDTO.user2.dob = DateUtils.convertLocalDateToServer(vm.user2.dob);
            	 }
            	 
            	 if (vm.bankRegistration.id == null) {
            		 BankRegistration.resubmitForCreate({"taskId" : $rootScope.taskID}, vm.bankDTO, onResubmitSuccess, onResubmitError);	 
            	 }else{
            		 BankRegistration.resubmitForEdit({"taskId" : $rootScope.taskID}, vm.bankRegistration, onResubmitSuccess, onResubmitError);
            	 }
        	}
        	
        }
        
        function onResubmitSuccess(result) {
			vm.clicked = false;
        	$rootScope.removeRow($rootScope.taskID);
        	$uibModalInstance.dismiss('cancel');
        }        
        function onResubmitError(error) {
			vm.bankDTO.user1.dob = DateUtils.convertLocalDateFromServer(vm.bankDTO.user1.dob);
			vm.bankDTO.user2.dob = DateUtils.convertLocalDateFromServer(vm.bankDTO.user2.dob);
			vm.bankDTO.bank.dateOfJoining = DateUtils.convertLocalDateFromServer(vm.bankDTO.bank.dateOfJoining);
        	vm.clicked = false;
        }

     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('BankRegistrationViewController', BankRegistrationViewController);

    BankRegistrationViewController.$inject = ['$scope', '$state','$rootScope','workflowSharedService','$uibModalInstance','BankRegistration','entity', 'Workflow', 'GlobalValues'];

    function BankRegistrationViewController($scope, $state, $rootScope, workflowSharedService, $uibModalInstance,BankRegistration,entity, Workflow, GlobalValues) {
        var vm = this;
        vm.clear=clear;
        vm.approveBankRegistration = approveBankRegistration;
        vm.rejectBankRegistration = rejectBankRegistration;
        vm.discardBankRegistration = discardBankRegistration;
        $scope.showButton = false;
        $scope.showDiscardButton = false;
        $scope.clicked=false;
        vm.globalValues = GlobalValues;
        vm.ExpandOrCollapseUser1 = false;
        vm.ExpandOrCollapseUser2 = false;
        vm.ExpandOrCollapseBankDetails = true;
        vm.hidePanForAudit = false;
        vm.bankDTO = {};
        
        
        
        if(workflowSharedService.viewFrom == 'bankregistration'){
        	vm.bankRegistration = entity; 
        	vm.mobileCountryCode=vm.bankRegistration.mobileCountryCode;
        	vm.tradeName = vm.bankRegistration.tradeName;
        	vm.legalName = vm.bankRegistration.legalName;
       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'bank-registrationtodolist_checker') {
        	vm.bankDTO =  angular.fromJson($rootScope.payload);
        	vm.bankRegistration = vm.bankDTO.bank;
        	
        	if(vm.bankRegistration == undefined){
        		vm.bankRegistration = vm.bankDTO;
        		
        	}
        	        	
        	vm.mobileCountryCode=vm.bankRegistration.mobileCountryCode;
        	vm.tradeName = vm.bankRegistration.tradeName;
        	vm.legalName = vm.bankRegistration.legalName;
        	vm.user1=  vm.bankDTO.user1;
        	vm.user2=  vm.bankDTO.user2;
        	
        	if(vm.user1 != undefined){
        		vm.user1.dob = new Date(vm.user1.dob);
            	vm.user2.dob = new Date(vm.user2.dob);
        	}
        	       	
        	
        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
        }
        else if(workflowSharedService.viewFrom == 'bank-registrationtodolist_maker') {
        	vm.bankDTO =  angular.fromJson($rootScope.payload); 
        	vm.bankRegistration = vm.bankDTO.bank;
        	
        	if(vm.bankRegistration == undefined){
        		vm.bankRegistration = vm.bankDTO;
        		
        	}
        	
        	vm.mobileCountryCode=vm.bankRegistration.mobileCountryCode;
        	vm.tradeName = vm.bankRegistration.tradeName;
        	vm.legalName = vm.bankRegistration.legalName;
        	vm.user1=  vm.bankDTO.user1;
        	vm.user2=  vm.bankDTO.user2;
        	
        	if(vm.user1 != undefined){
        		vm.user1.dob = new Date(vm.user1.dob);
            	vm.user2.dob = new Date(vm.user2.dob);
        	}
        	
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        }
        if(workflowSharedService.viewFrom == 'bankregistration_auditlog'){
        	vm.bankDTO =  angular.fromJson($rootScope.payload); 
        	vm.bankRegistration = vm.bankDTO.bank;
        
        	if(vm.bankRegistration == undefined){
        		vm.bankRegistration = vm.bankDTO;
        		
        	}
        	if(vm.bankRegistration.bankPan == undefined || vm.bankRegistration.bankPan == ''){
        	vm.hidePanForAudit = true;
        	}
        	vm.mobileCountryCode=vm.bankRegistration.mobileCountryCode;
        	vm.tradeName = vm.bankRegistration.tradeName;
        	vm.legalName = vm.bankRegistration.legalName;
        	vm.user1=  vm.bankDTO.user1;
        	vm.user2=  vm.bankDTO.user2;
        	if(vm.user1 != undefined){
        		vm.user1.dob = new Date(vm.user1.dob);
            	vm.user2.dob = new Date(vm.user2.dob);
        	}
       	 	$scope.showButton=false;
        }
        vm.bankRegistration.dateOfJoining = new Date(vm.bankRegistration.dateOfJoining);

        function approveBankRegistration() { 
        	BankRegistration.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectBankRegistration() { Workflow.rejectTask($rootScope.taskID); }

        function discardBankRegistration() {
        	BankRegistration.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }

       
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('BankRegistrationDeleteController',BankRegistrationDeleteController);

    BankRegistrationDeleteController.$inject = ['$uibModalInstance', 'entity', 'BankRegistration', 'GlobalValues','$scope'];

    function BankRegistrationDeleteController($uibModalInstance, entity, BankRegistration, GlobalValues,$scope) {
        var vm = this;

        vm.bankRegistration = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        $scope.clicked=false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        
        function confirmDelete (id) {
        	BankRegistration.delete({"corpId": GlobalValues.getCorpId(),"id":id},
                    function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('bank-registration', {
            parent: 'entity',
            url: '/bank-registration',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.bankRegistration.manageBankRegistration" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bank-registration/bank-registration.html',
                    controller: 'BankRegistrationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('bankRegistration');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('bank-registration.new', {
            parent: 'bank-registration',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-dialog.html',
                    controller: 'BankRegistrationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	 id:null,  
                            	name:null                            	
                             
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('bank-registration', null, { reload: 'bank-registration' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('bank-registration.view', {
            parent: 'bank-registration',
            url: '/bank-registration/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-detail.html',
                    controller: 'BankRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['BankRegistration', 'GlobalValues', function(BankRegistration, GlobalValues) {
                                     return BankRegistration.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('bank-registration.edit', {
            parent: 'bank-registration',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-dialog.html',
                    controller: 'BankRegistrationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['BankRegistration', 'GlobalValues', function(BankRegistration, GlobalValues) {
                                     return BankRegistration.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('bank-registration.delete', {
            parent: 'bank-registration',
            url: '/delete/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-delete-dialog.html',
                    controller: 'BankRegistrationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BankRegistration', 'GlobalValues', function(BankRegistration, GlobalValues) {
                            return BankRegistration.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    //$state.go('^', null, { reload: true });
                	$state.go('bank-registration', null, { reload: 'bank-registration' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('bank-registration-todolist', {
            parent: 'dashboard',
            url: '/bankview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-detail.html',
                    controller: 'BankRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('bank-registration', null, { reload: 'bank-registration' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('bank-registration-todolist.resubmit', {
            parent: 'dashboard',
            url: '/bankedit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-dialog.html',
                    controller: 'BankRegistrationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('bank-registration', null, { reload: 'bank-registration' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        .state('bank-registration-auditLog', {
            parent: 'audit-log',
            url: '/bankRegistrationAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-detail.html',
                    controller: 'BankRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('bank-registration', null, { reload: 'bank-registration' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
          .state('bank-registration-historyReport', {
            parent: 'history-report',
            url: '/bankRegistrationAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-registration/bank-registration-detail.html',
                    controller: 'BankRegistrationViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('bank-registration', null, { reload: 'bank-registration' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
        
        
         };
    })();

(function() {
	'use strict';
	angular.module('gatewayApp').factory('BankRegistration', BankRegistration);

	BankRegistration.$inject = [ '$resource' ];

	function BankRegistration($resource) {
		var resourceUrl = 'api/bank/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},

			'getBankLookup' : {
				method : 'GET',
				isArray: true,
				url : 'api/bank/lookup'
			},

			'getBankLookupWithStatus' : {
				method : 'GET',
				isArray: true,
				url : 'api/bank-with-status/lookup'
			},

			'save' : {
				method : 'POST',
				params : {
					corpId : '@corpId'
				},
				url : 'api/bank/:corpId',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'update' : {
				method : 'PUT',
				params : {
					corpId : '@corpId'
				},
				url : 'api/bank/:corpId',
				transformRequest : function(data) {
					var copy = angular.copy(data);

					return angular.toJson(copy);
				}
			},
			'delete' : {
				method : 'DELETE',
				params : {
					corpId : '@corpId',
					id : '@id'
				},
				url : 'api/bank/:corpId/:id'
			},

			'approve' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/approve'
			},
			'reject' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/reject'
			},
			'discard' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/discard'
			},
			 'getUserNo': {
           	  method: 'GET',
           	  params: {MemberNo:'@MemberNo'},
           	  url: 'api/MemberNo/:MemberNo/bank'
            },
			'resubmitForCreate' : {
				method : 'PUT',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/resubmitForCreate/bank',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'resubmitForEdit' : {
				method : 'PUT',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/resubmitForEdit/bank',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'getBankForShortName':{
				method : 'GET',
				params : {
					bankName : '@bankName'
				},
				url : 'api/trading-bank/bankName/:bankName',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'getValidBankWithValidStatus':{
				method : 'GET',
				url : 'api/valid-bank-for-registration',
				isArray : true
			},
			'getNonTerminatedBankList':{
				method : 'GET',
				url : 'api/non-terminated-bank',
				isArray : true
			}

		});
	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'bankregistration'
        })
        
        .controller('BankRegistrationController', BankRegistrationController);

    BankRegistrationController.$inject = ['$scope', '$state', 'workflowSharedService', 'BankRegistration', 'GlobalValues', 'EntityPermissions','ScreenLog','entityConstants','$timeout'];

    function BankRegistrationController($scope, $state, workflowSharedService, BankRegistration, GlobalValues, EntityPermissions,ScreenLog,entityConstants,$timeout) {
        
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.entityConstants = entityConstants;
        vm.screenLog = ScreenLog;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.BANK_REGISTRATION ; 
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        $scope.refresh=refresh;
        vm.orgId = vm.globalValues.getOrganisation().id;
        
        workflowSharedService.viewFrom = "bankregistration";
        
        vm.launch=launch;
        function launch() {
        	$state.go("bank-registration.new");
        }
        
        vm.permitBankRegistrationEditEntityAction = EntityPermissions.hasPermission('BankRegistration.EDIT')
        vm.permitBankRegistrationCreateEntityAction = EntityPermissions.hasPermission('BankRegistration.CREATE')
		vm.permitBankRegistrationViewEntityAction = EntityPermissions.hasPermission('BankRegistration.VIEW')
		vm.permitBankRegistrationDeleteEntityAction = EntityPermissions.hasPermission('BankRegistration.DELETE')
		vm.permitBankRegistrationImportEntityAction = EntityPermissions.hasPermission('BankRegistration.IMPORT')

		logScreenAccess();
        loadAll();
        
        function loadAll() {
            BankRegistration.query(function(result) {
                vm.bankRegistration = result;                
            });
        }
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }
        
        $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
      
    }
})();

(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.controller('FeeUploadApprovalController', FeeUploadApprovalController);

	FeeUploadApprovalController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','BankFeeAndChargesUploadService','entity','DateUtils','Workflow','FileUtil','AlertService','$filter','$uibModalInstance','systemSettings','BankFeeViewForEntitiesUtility','globalValue','configurationSetting'];

	function FeeUploadApprovalController($scope, $state, $rootScope, GlobalValues, workflowSharedService,BankFeeAndChargesUploadService,entity,DateUtils,Workflow,FileUtil,AlertService,$filter,$uibModalInstance,systemSettings,BankFeeViewForEntitiesUtility,globalValue,configurationSetting) {
		var vm = this;
		vm.bankFeeDTO=entity;   

		vm.clear=clear;
		vm.clicked=false;
		$scope.showButton = false;
		$scope.showApproveRejectButton=false;
		$scope.showDiscardButton = false;
		$scope.showResubmitButton=false;
		vm.globalValues = GlobalValues;
		vm.discardBankFee = discardBankFee;
		vm.rejectBankFee = rejectBankFee;
		vm.approveBankFee = approveBankFee;

        vm.checkbankFeeFile = false;
		vm.resubmitBankFee = resubmitBankFee;
		vm.viewMode=false;
		vm.configSettings = globalValue;
		vm.maxFileNameLength = (vm.configSettings.uploadedFileNameLength != null && vm.configSettings.uploadedFileNameLength != undefined && vm.configSettings.uploadedFileNameLength != '') ?vm.configSettings.uploadedFileNameLength : 150 ;
		var minFileSizeinBytes = 0;
		var maxFileSizeinBytes = 500000;
		vm.maximumFileSizeinKB = (configurationSetting != null && configurationSetting != undefined && configurationSetting.maximumFileSizeTermsAndConditionsUpload != null && configurationSetting.maximumFileSizeTermsAndConditionsUpload != undefined && configurationSetting.maximumFileSizeTermsAndConditionsUpload != '') ? parseInt(configurationSetting.maximumFileSizeTermsAndConditionsUpload) : 500000 ;
		vm.minimumFileSizeInKB = 0;
		if( vm.minimumFileSizeInKB != undefined &&  vm.minimumFileSizeInKB !=null &&  vm.minimumFileSizeInKB  !=''){
			minFileSizeinBytes = vm.minimumFileSizeInKB*1024;
		}
		if( vm.maximumFileSizeinKB != undefined &&  vm.maximumFileSizeinKB !=null &&  vm.maximumFileSizeinKB  !=''){

			maxFileSizeinBytes = vm.maximumFileSizeinKB*1024;
			if(vm.maximumFileSizeinKB == 1024){
				vm.showInKB = false;
				vm.bankFeeFileUploadSize = 1;
			}else{
				vm.showInKB = true;
				vm.bankFeeFileUploadSize = vm.maximumFileSizeinKB;
			}
		}
		
		var Extensions = "pdf";
	

		$scope.showButton = false;
		vm.orgId = vm.globalValues.getOrgId();
	
	

		if(workflowSharedService.viewFrom == 'bankFeesAndChargesUploadtodolist_resubmit') {
			vm.bankFeeDTO =  angular.copy(angular.fromJson($rootScope.payload));
			console.log(vm.bankFeeDTO)
			$scope.showButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton=true;
			vm.viewMode=false;
		}

		else if(workflowSharedService.viewFrom == 'bankFeesAndChargesUpload_todolist_checker') {
			vm.bankFeeDTO =  angular.fromJson($rootScope.payload); 
			console.log(vm.bankFeeDTO)
			vm.viewMode=true;
			$scope.showButton = false;
			$scope.showApproveRejectButton = true;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton=false;
		}
		else if(workflowSharedService.viewFrom == 'bankFeesAndChargesUpload_todolist_maker') {
			vm.bankFeeDTO =  angular.fromJson($rootScope.payload); 
			console.log(vm.bankFeeDTO)
			vm.viewMode=true;
			$scope.showButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = true;
			$scope.showResubmitButton=false;
		}
		else if(workflowSharedService.viewFrom=='bankFeesAndChargesUpload_auditlog'){
			vm.bankFeeDTO =  angular.fromJson($rootScope.payload); 
			vm.viewMode=true;
			$scope.showButton = false;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton=false;

		}else{
			vm.bankFeeDTO=entity;
			$scope.showButton = true;
			$scope.showApproveRejectButton = false;
			$scope.showDiscardButton = false;
			$scope.showResubmitButton=false;
			vm.viewMode=false;
		}
		

		vm.openBankFeePreview = openBankFeePreview;
		function openBankFeePreview(pdfContent){
			BankFeeViewForEntitiesUtility.previewBankFee(pdfContent.fileContent, pdfContent.fileName);
		}


		function clear() {
			$uibModalInstance.dismiss('cancel');
		}


		function approveBankFee() { 
			BankFeeAndChargesUploadService.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
			     	
		}

		function onApproveSuccess(result) {
			$uibModalInstance.dismiss('cancel');
			$rootScope.removeRow($rootScope.taskID);        	
		}        
		function onApproveError(error) {
			vm.clicked = false;
		}

		function rejectBankFee() { Workflow.rejectTask($rootScope.taskID); }

		function discardBankFee() {
			BankFeeAndChargesUploadService.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
			$uibModalInstance.dismiss('cancel');	
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);        	
		}        
		function onDiscardError(error) {

		}
		
		function resubmitBankFee() {
		
				if(vm.bankFee != null){
					var fd1 = new FormData();
									fd1.append('id', JSON.stringify($rootScope.taskID));
					fd1.append('file', vm.bankFee);
					BankFeeAndChargesUploadService.resubmit( fd1, onResubmitSuccess, onResubmitError);


				}
	
			
		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.dismiss('cancel');
		}        
		function onResubmitError(error) {
			vm.clicked = false;
		}

		//validate terms and condition 
		$scope.$watch('vm.bankFee', function(value){
		
			
			if(value!= undefined && value!=null){
				
				if(!FileUtil.isFileSizeValid(value.size ,minFileSizeinBytes , maxFileSizeinBytes  )){
					vm.invalidBankFeeSize = true;
					if(vm.showInKB == true){
						vm.invalidBankFeeSixeText = "Maximum of " + vm.bankFeeFileUploadSize +" KB file size is allowed";
					}else{
						vm.invalidBankFeeSixeText = "Maximum of " + vm.bankFeeFileUploadSize +" MB file size is allowed";
					}
					vm.invalidBankFee = false;
					vm.invalidBankFeeName = false;
					vm.bankFee=null;
					angular.element("input[type='file']").val(null);

				}else{
					vm.inputBankFee=vm.bankFee.name;
					vm.invalidBankFeeSize = false;
					vm.invalidBankFee = false;
					vm.invalidBankFeeName = false;
					vm.fileExtension = vm.inputBankFee.substring(vm.bankFee.name.lastIndexOf(".") + 1);
					var fileNameWithoutExtension  =  vm.inputBankFee.substring(0,vm.bankFee.name.lastIndexOf("."));
					//check for extension
					if(!(Extensions == (vm.fileExtension.toLowerCase()))) {
						angular.element("input[type='file']").val(null);
						vm.bankFee=null;
						vm.inputBankFee=null;
						vm.invalidBankFee = true;
						vm.invalidBankFeeSize = false;
						vm.invalidBankFeeName = false;
						vm.invalidBankFeeText = "Accepted file format .pdf";
					}
					else if(!FileUtil.isFileNameValid(fileNameWithoutExtension,vm.maxFileNameLength )){
	    				 angular.element("input[type='file']").val(null);
	    				 vm.bankFee=null;
				         vm.inputBankFee=null;
				         vm.invalidBankFee = false;
				         vm.invalidBankFeeSize = false;
				         vm.invalidBankFeeName = true;
				         vm.invalidBankFeeNameText = "Uploaded pdf file name should not exceed " + vm.maxFileNameLength+ " charaters.";
				         
	    			 }

					else{ // check for malicious file with correct extension
						var reader = new FileReader();
						reader.readAsArrayBuffer(value.slice(0,4));
						reader.onloadend = function(e){
							if (e.target.readyState === FileReader.DONE) {
								var arrayBuffer = e.target.result;
								var bytes = new Uint8Array( arrayBuffer );
								if(!FileUtil.checkTermsConditionExtension(bytes)){
									angular.element("input[type='file']").val(null);
									vm.bankFee=null;
									vm.inputBankFee=null;
									vm.invalidBankFee = true;
									vm.invalidBankFeeSize = false;
									vm.invalidBankFeeName = false;
									vm.invalidBankFeeText = "Accepted file format .pdf";
								}
								else{
									vm.invalidBankFeeSize = false;
									vm.invalidBankFee =false;
									vm.invalidBankFeeName = false;


								}
								$scope.$digest();
							}
						}; 
					}
				}
			}
			else{
				angular.element("input[type='file']").val(null);

				vm.inputBankFee=null;
			}
		});
		
	}   
})();

(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.controller('FeeUploadController', FeeUploadController);

	FeeUploadController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','BankFeeAndChargesUploadService','entity','DateUtils','Workflow','FileUtil','AlertService','$filter','systemSettings','entityConstants','ScreenLog','globalValue','configurationSetting','$uibModalInstance'];

	function FeeUploadController($scope, $state, $rootScope, GlobalValues, workflowSharedService,BankFeeAndChargesUploadService,entity,DateUtils,Workflow,FileUtil,AlertService,$filter,systemSettings,entityConstants,ScreenLog,globalValue,configurationSetting,$uibModalInstance) {
		var vm = this;
		console.log(vm.bankForCustomerTacDTO);
		vm.globalValues = GlobalValues;
		vm.orgId = vm.globalValues.getOrgId();
		vm.bank = vm.globalValues.getOrganisation();

		vm.clear=clear;
		vm.save=save;
		vm.clicked=false;
		$scope.showButton = false;
		$scope.showApproveRejectButton=false;
		$scope.showDiscardButton = false;
		$scope.showResubmitButton=false;
		
		vm.viewMode=false;
		var minFileSizeinBytes = 0;
		var maxFileSizeinBytes = 500000;
		vm.maximumFileSizeinKB = (configurationSetting != null && configurationSetting != undefined && configurationSetting.maximumFileSizeTermsAndConditionsUpload != null && configurationSetting.maximumFileSizeTermsAndConditionsUpload != undefined && configurationSetting.maximumFileSizeTermsAndConditionsUpload != '') ? parseInt(configurationSetting.maximumFileSizeTermsAndConditionsUpload) : 500000 ;
		vm.minimumFileSizeInKB = 0;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.BANK_FEES_CHARGES_UPLOAD;
		logScreenAccess();
		function logScreenAccess(){
			ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.EDIT);
		}
		vm.configSettings = globalValue;
		vm.checkBankFeeFile = false;

		vm.maxFileNameLength = (vm.configSettings.uploadedFileNameLength != null && vm.configSettings.uploadedFileNameLength != undefined && vm.configSettings.uploadedFileNameLength != '') ?vm.configSettings.uploadedFileNameLength : 150 ;
		
		if( vm.minimumFileSizeInKB != undefined &&  vm.minimumFileSizeInKB !=null &&  vm.minimumFileSizeInKB  !=''){
			minFileSizeinBytes = vm.minimumFileSizeInKB*1024;
		}
		if( vm.maximumFileSizeinKB != undefined &&  vm.maximumFileSizeinKB !=null &&  vm.maximumFileSizeinKB  !=''){
			
			maxFileSizeinBytes = vm.maximumFileSizeinKB*1024;
			if(vm.maximumFileSizeinKB == 1024){
				vm.showInKB = false;
				vm.bankFeeFileUploadSize = 1;
			}else{
				vm.showInKB = true;
				vm.bankFeeFileUploadSize = vm.maximumFileSizeinKB;
			}
		}
		
		var Extensions = "pdf";
		vm.minDate = new Date();
		vm.minDate.setDate(new Date().getDate() + 1);

		if(systemSettings != null && systemSettings != undefined){
			vm.businessDate  = DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
			vm.businessDatePlusOne =  moment(vm.businessDate).add(1,'days').toDate();
			vm.minDate = angular.copy(vm.businessDatePlusOne);
		}
		
		$scope.showButton = false;

		$scope.showButton = true;
		$scope.showApproveRejectButton = false;
		$scope.showDiscardButton = false;
		$scope.showResubmitButton=false;
		vm.viewMode=false;
		
		vm.tacMasterId = 0;



		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save () {   
			
				if(vm.bankFee != null){
					var fd1 = new FormData();				
					fd1.append('file', vm.bankFee);
					console.log(fd1);
					BankFeeAndChargesUploadService.update(fd1, onSaveSuccess, onSaveError);
				}
		}
		
		function resetValues(){
			vm.clicked = false;

				vm.bankForCustomerTacDTO.enforcingDate = vm.minDate;
				vm.inputBankFee=null;
				vm.bankFee = null;

		}


		function onSaveSuccess (result) {
			$uibModalInstance.close(result);  
		}


		function onSaveError () {

			vm.clicked = false;
		}


		//validate terms and condition 
		$scope.$watch('vm.bankFee', function(value){

			if(value!= undefined && value!=null){
				if(!FileUtil.isFileSizeValid(value.size ,minFileSizeinBytes , maxFileSizeinBytes  )){
					vm.invalidBankFeeSize = true;
					if(vm.showInKB == true){
						vm.invalidBankFeeSizeText = "Maximum of " + vm.bankFeeFileUploadSize +" KB file size is allowed";
					}else{
						vm.invalidBankFeeSizeText = "Maximum of " + vm.bankFeeFileUploadSize +" MB file size is allowed";
					}
					vm.invalidBankFee = false;
					vm.invalidBankFeeName = false;
					vm.bankFee=null;
					angular.element("input[type='file']").val(null);

				}else{
					vm.inputBankFee=vm.bankFee.name;
					vm.invalidBankFeeSize = false;
					vm.invalidBankFee = false;
					vm.invalidBankFeeName = false;
					vm.fileExtension = vm.inputBankFee.substring(vm.bankFee.name.lastIndexOf(".") + 1);
					var fileNameWithoutExtension  =  vm.inputBankFee.substring(0,vm.bankFee.name.lastIndexOf("."));
					//check for extension
					if(!(Extensions == (vm.fileExtension.toLowerCase()))) {
						angular.element("input[type='file']").val(null);
						vm.bankFee=null;
						vm.inputBankFee=null;
						vm.invalidBankFee = true;
						vm.invalidBankFeeSize = false;
						vm.invalidBankFeeName = false;
						vm.invalidBankFeeText = "Accepted file format .pdf";
					}
					else if(!FileUtil.isFileNameValid(fileNameWithoutExtension,vm.maxFileNameLength )){
	    				 angular.element("input[type='file']").val(null);
	    				 vm.bankFee=null;
				         vm.inputBankFee=null;
				         vm.invalidBankFee = false;
				         vm.invalidBankFeeSize = false;
				         vm.invalidBankFeeName = true;
				         vm.invalidBankFeeNameText = "Uploaded pdf file name should not exceed " + vm.maxFileNameLength+ " charaters.";
				         
	    			 }

					else{ // check for malicious file with correct extension
						var reader = new FileReader();
						reader.readAsArrayBuffer(value.slice(0,4));
						reader.onloadend = function(e){
							if (e.target.readyState === FileReader.DONE) {
								var arrayBuffer = e.target.result;
								var bytes = new Uint8Array( arrayBuffer );
								if(!FileUtil.checkTermsConditionExtension(bytes)){
									angular.element("input[type='file']").val(null);
									vm.bankFee=null;
									vm.inputBankFee=null;
									vm.invalidBankFee = true;
									vm.invalidBankFeeSize = false;
									vm.invalidBankFeeName = false;
									vm.invalidBankFeeText = "Accepted file format .pdf";
								}
								else{
									vm.invalidBankFeeSize = false;
									vm.invalidBankFee =false;
									vm.invalidBankFeeName = false;


								}
								$scope.$digest();
							}
						}; 
					}
				}
			}
			else{
				angular.element("input[type='file']").val(null);
				
				vm.inputBankFee=null;
				
			}
		});
		
	        

	}   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	 $stateProvider
         .state('view-bank-fees-upload', {
             parent: 'entity',
			 params:{screen: 'BankFeesChargesUpload'},
             url: '/bank-fees-upload',
             data: {
            	 authorities: ['ROLE_USER'],
                 pageTitle: 'global.title'
             },
             ncyBreadcrumb: {
                 label: '{{ "global.menu.bankFeesAndChargesUpload.main" | translate }}',
                 parent: 'home'
             },
             views: {
                 'content@': {
                     templateUrl: 'app/entities/bank-fees-and-charges-upload/bank-fees-and-charges.html',
                     controller: 'BankFeeAndChargesUploadController',
                     controllerAs: 'vm'
                 }
             },
             resolve: {
                 translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                 	$translatePartialLoader.addPart('error');
                     $translatePartialLoader.addPart('global');       
                 	$translatePartialLoader.addPart('bankFeesAndChargesUpload');
                
                     return $translate.refresh();
                 }],
                 entity: function(){
                 	
                 }
             }
         })
         
         .state('feeUpload', {
 			parent: 'view-bank-fees-upload',
 			url: '/feeUpload',
 			data: {
 				authorities: ['ROLE_USER'],
 				pageTitle: 'global.title'
 			},
 			onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
 				$uibModal.open({
 					templateUrl: 'app/entities/bank-fees-and-charges-upload/fee-charge-upload.html',
 					controller: 'FeeUploadController',
 					controllerAs: 'vm',
 					backdrop: 'static',
 					size: 'md',
 					resolve: {
 						
 		                 translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
 		                 	$translatePartialLoader.addPart('error');
 		                     $translatePartialLoader.addPart('global');       
 		                 	$translatePartialLoader.addPart('bankFeesAndChargesUpload');
 		                
 		                     return $translate.refresh();
 		                 }],


 						entity: function () {                        	
 							return {                            		
 							};
 						},
 						globalValue: ['StaticLookUp', function(StaticLookUp) {
 							return StaticLookUp.getConfigSettings().$promise;
 						}],
 						systemSettings: ['IntradayMarket', function(IntradayMarket) {
 							return IntradayMarket.getCurrentBusinessDate().$promise;
 						}],
 						configurationSetting :['GlobalValues', function(GlobalValues) {
 							return GlobalValues.getConfigSettings();
 						}]

 					}
 				}).result.then(function() {
 					$state.go('^', {}, { reload: true });
 				}, function() {
 					$state.go('^');
 				});
 			}]

 		})
 		
 		.state('bankFeesAndChargesUpload-todolist', {
			parent: 'dashboard',
			url: '/bankFeesAndChargesUpload-todo',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'global.title'
			},
			onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl: 'app/entities/bank-fees-and-charges-upload/fee-upload-approval.html',
					controller: 'FeeUploadApprovalController',
					controllerAs: 'vm',
					backdrop: 'static',
					size: 'md',
					resolve: {

						entity: function () {                        	
							return {                            		
							};
						},
						systemSettings:function() {
							return {                            		
							};
						},
                        globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                        configurationSetting :['GlobalValues', function(GlobalValues) {
                            return GlobalValues.getConfigSettings();
                        }]
					}
				}).result.then(function() {
					$state.go('view-bank-fees-upload', null, { reload: 'view-bank-fees-upload' });
				}, function() {
					$state.go('^');
				});
			}],
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('error');
					$translatePartialLoader.addPart('global');
					$translatePartialLoader.addPart('bankFeesAndChargesUpload');
					return $translate.refresh();
				}]
			}

		})
		.state('bankFeesAndChargesUpload-todolist-resubmit', {
			parent: 'dashboard',
			url: '/bankFeesAndChargesUpload-todo-resubmit',
			data: {
				authorities: ['ROLE_USER']
			},
			onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl: 'app/entities/bank-fees-and-charges-upload/fee-upload-approval.html',
					controller: 'FeeUploadApprovalController',
					controllerAs: 'vm',
					backdrop: 'static',
					size: 'md',
					resolve: {

						entity: function () {                       	

						},
						systemSettings: ['IntradayMarket', function(IntradayMarket) {
							return IntradayMarket.getCurrentBusinessDate().$promise;
						}],
                        globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                        configurationSetting :['GlobalValues', function(GlobalValues) {
                            return GlobalValues.getConfigSettings();
                        }]
					}
				}).result.then(function() {
					$state.go('view-bank-fees-upload', null, { reload: 'view-bank-fees-upload' });
				}, function() {
					$state.go('^');
				});
			}],
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('bankFeesAndChargesUpload');
					$translatePartialLoader.addPart('error');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}]
			}
		})  //
        
		.state('bank-fees-charges-upload-auditLog', {
			parent: 'audit-log',
			url: '/bank-fees-charges-upload-auditLog',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'global.title'
			},
			onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl: 'app/entities/bank-fees-and-charges-upload/fee-upload-approval.html',
					controller: 'FeeUploadApprovalController',
					controllerAs: 'vm',
					backdrop: 'static',
					size: 'md',
					resolve: {
						entity: function () {                        	
							return {                            		
							};
						},
						systemSettings: function() {
							return null;
						},
                        globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                        configurationSetting :['GlobalValues', function(GlobalValues) {
                            return GlobalValues.getConfigSettings();
                        }]
					}
				}).result.then(function() {
					$state.go('view-bank-fees-upload', null, { reload: 'view-bank-fees-upload' });
				}, function() {
					$state.go('^');
				});
			}],
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('bankFeesAndChargesUpload');
					$translatePartialLoader.addPart('error');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}]
			}

		})
		
		.state('bank-fees-charges-upload-historyReport', {
			parent: 'history-report',
			url: '/bank-fees-charges-upload-history',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'global.title'
			},
			onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl: 'app/entities/bank-fees-and-charges-upload/fee-upload-approval.html',
					controller: 'FeeUploadApprovalController',
					controllerAs: 'vm',
					backdrop: 'static',
					size: 'md',
					resolve: {
						entity: function () {                        	
							return {                            		
							};
						},
						systemSettings: function() {
							return null;
						},
                        globalValue: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettings().$promise;
                        }],
                        configurationSetting :['GlobalValues', function(GlobalValues) {
                            return GlobalValues.getConfigSettings();
                        }]
					}
				}).result.then(function() {
					$state.go('view-bank-fees-upload', null, { reload: 'view-bank-fees-upload' });
				}, function() {
					$state.go('^');
				});
			}],
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('bankFeesAndChargesUpload');
					$translatePartialLoader.addPart('error');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}]
			}

		})


         
    };
    })();

(function() {
	'use strict';
	angular
	.module('gatewayApp')
	.factory('BankFeeAndChargesUploadService', BankFeeAndChargesUploadService);

	BankFeeAndChargesUploadService.$inject = ['$resource'];

	function BankFeeAndChargesUploadService($resource) {
		var resourceUrl =  '/api';

		return $resource(resourceUrl, {}, {
		
		'get' : {
			method : 'GET',
			params: {bankId : '@bankId'},
			url:'api/bank/:id',
			isArray : true,
			transformResponse : function(data) {
				if (data) {
					data = angular.fromJson(data);
				}
				return data;
			}
		},
			
			'getActiveFeeChargesUploadByBank':{
				method: 'GET',
				params: {bankId : '@bankId'},
				url: 'api/active-bank-fees-charges/:bankId/bankId'

			},
			'resubmit':{
				method: 'POST',
				url: 'api/tasks/resubmit/bank-fees-charges-upload-by-bank-resubmit',
				headers: {
					'Content-Type': undefined
				}


			},			
			'update':{
				method:'POST',
				url: 'api/bank-fees-charges-upload-details',
				headers: {
					'Content-Type': undefined
				}

			},
			'approve' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/approve'
			},
			'reject' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/reject'
			},
			'discard' : {
				method : 'GET',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/discard'
			}

		});
	}
})();

(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.controller('BankFeeAndChargesUploadController', BankFeeAndChargesUploadController)

	BankFeeAndChargesUploadController.$inject = ['ScreenLog','$scope', '$state', '$rootScope', 'GlobalValues','BankFeeAndChargesUploadService', 'workflowSharedService', 'entityConstants','TacViewForEntitiesUtility','CustomerTACUploadByBank','$timeout'];

	function BankFeeAndChargesUploadController(ScreenLog,$scope, $state, $rootScope, GlobalValues,BankFeeAndChargesUploadService,workflowSharedService,entityConstants,TacViewForEntitiesUtility,CustomerTACUploadByBank,$timeout) {
		var vm = this;
		vm.bankFeeChargeDetails = {};
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.BANK_FEES_CHARGES_UPLOAD;
		vm.globalValues=GlobalValues;
		$scope.refresh=refresh;
		vm.orgId = vm.globalValues.getOrgId();
		console.log(vm.orgId);
		workflowSharedService.viewFrom = "BankFeesAndChargesUploadByBankView";
		vm.screenLog = ScreenLog;		
		vm.loadAll = loadAll;
		vm.bankRegistration ={};
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;
		vm.uploadBankFeesCharges = uploadBankFeesCharges;
		vm.openBankFeesChargesPreview = openBankFeesChargesPreview;
		function openBankFeesChargesPreview(bankFeesChargesFile){
			TacViewForEntitiesUtility.previewTAC(bankFeesChargesFile.fileContent,bankFeesChargesFile.fileName);	
		}

		vm.loadAll();
	
		logScreenAccess();
		function logScreenAccess(){
			ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}

	
		function loadAll() {
				BankFeeAndChargesUploadService.getActiveFeeChargesUploadByBank({bankId:vm.orgId},onRetreiveSuccess,onRetreiveFailure);
				
				function onRetreiveSuccess(result) {
					console.log(result);
					
					vm.bankFeeChargeDetails = result;
					console.log(vm.bankFeeChargeDetails);
					if (vm.bankFeeChargeDetails.lastModifiedDate == '' || vm.bankFeeChargeDetails.lastModifiedDate == null ){
						
						vm.bankFeeChargeDetails.lastModifiedDate = '-';
						console.log(vm.bankFeeChargeDetails);
					}

				}
				function onRetreiveFailure(error){
					console.log(error);
				}

			
		}
		function uploadBankFeesCharges(bankFeesCharges){
		
			$state.go('feeUpload');

		}
		
		$scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };

		

	}
})();


(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('BankFeeViewForEntitiesUtility', BankFeeViewForEntitiesUtility);

    BankFeeViewForEntitiesUtility.$inject = ['$rootScope','FileUtil','$filter','MessageBox'];

    function BankFeeViewForEntitiesUtility ($rootScope,FileUtil,$filter,MessageBox ) {
    	var seletedFileName ="";
    	var messageBoxName = "";
        var service = {
        		previewBankFee : previewBankFee,
        		previewBankFeeForArray : previewBankFeeForArray,
        		downloadBankFee : downloadBankFee,
        		downloadBankFeeForArray : downloadBankFeeForArray,
        };

        return service;
        
        function previewBankFeeForArray(arrayBuffer, pdfFileName){
        	//var y = window.outerHeight / 2 + window.screenY - ( 700 / 2);
			//var x = window.outerWidth / 2 + window.screenX - ( 700 / 2);
        	var file = new Blob([arrayBuffer], {type: 'application/pdf'});
      		var filename = pdfFileName;
            var fileURL = URL.createObjectURL(file);
            if(window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(file, filename);
            }
            else {
            	//window.open(fileURL, filename, "width=700,height=700,"+"top="+y+", left="+x);
               window.open(fileURL, filename, "fullscreen=yes");   
            	//window.open('assets/data/forex_trading_tutorial5.pdf', 'pdf_test.pdf');
            	/*var link = document.createElement("a");   
            	link.href =  fileURL;      
  	    	    link.download =filename;
  	    	    document.body.appendChild(link);
  	    	    link.click();
  	    	    document.body.removeChild(link);*/
            }
        }
        function downloadBankFeeForArray(arrayBuffer, pdfFileName){
        	//var y = window.outerHeight / 2 + window.screenY - ( 700 / 2);
			//var x = window.outerWidth / 2 + window.screenX - ( 700 / 2);
        	var file = new Blob([arrayBuffer], {type: 'application/pdf'});
      		var filename = pdfFileName;
            var fileURL = URL.createObjectURL(file);
            if(window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(file, filename);
            }
            else {            
            	var link = document.createElement("a");   
            	link.href =  fileURL;      
  	    	    link.download =filename;
  	    	    document.body.appendChild(link);
  	    	    link.click();
  	    	    document.body.removeChild(link);
            }
        }
        function previewBankFee(fileInbase64String, pdfFileName){
        	
        	var arrayBuffer =  FileUtil.base64ToArrayBuffer(fileInbase64String);
        	previewBankFeeForArray(arrayBuffer, pdfFileName);
        	
        }
        function downloadBankFee(fileInbase64String, pdfFileName){
        	
        	var arrayBuffer =  FileUtil.base64ToArrayBuffer(fileInbase64String);
        	downloadBankFeeForArray(arrayBuffer, pdfFileName);
        	
        }
        

        
               
    }
})();

(function () {
	'use strict';

	angular
	.module('gatewayApp')
	.controller('CCAvailableUsersReportController', CCAvailableUsersReportController);

	CCAvailableUsersReportController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues',  'AlertService','AvailableUsersReport','$filter', 'ScreenLog','entityConstants','DateUtils','$timeout'];

	function CCAvailableUsersReportController(  $scope, $state, $rootScope, GlobalValues,AlertService , AvailableUsersReport , $filter , ScreenLog, entityConstants,DateUtils,$timeout){
		
		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.NO_OF_AVAILABLE_USER_REPORT;
		vm.entityConstants = entityConstants;
		vm.screenLog = ScreenLog;
		$scope.refresh = refresh;

		vm.currentDateTime =moment().format( 'DD_MMM_YYYY_HH_mm');
        
        vm.selectedEntityType = '';        
        vm.showUserDetailsDrillDown = false;
        vm.showBankDetails = false;
  		vm.showBranchDetails = false;
  		vm.showBankSummary = false;
  		vm.showCustomerDetails = false;
  		vm.userSummaryFilterText = '';
  		vm.bankSummaryfilterText = '';
  		
		//initiate list
  		vm.overAllSummary = {};
        vm.userDetailsList =[];
        vm.bankSummaryList  =[];

		var recordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.noOfRecordsPerPage = recordsPerPage;
		$scope.page = 1;
		$scope.noOfRecordsPerUSerPage = recordsPerPage;
		$scope.userPage = 1;
		

		vm.getUserDetails = getUserDetails;
		vm.getBankSummary = getBankSummary;
		
		//vm.getUsersLoggedInForTheMoment = getUsersLoggedInForTheMoment;
	   // vm.getUsersLoggedInForTheDay = getUsersLoggedInForTheDay;
		vm.YES = true;
		vm.NO = false;
		vm.isAsOfNow = true;
		vm.BANK_TYPE= "Bank";
	    vm.BRANCH_TYPE= "Branch";
	    vm.CUSTOMER_TYPE= "Customer";
        vm.CLEARCORP = "Clearcorp";
	
		vm.exportToFile = exportToFile;

		vm.todayDate = new Date();
		vm.reportDate = DateUtils.convertDateTimeFromServer(vm.todayDate);

		logScreenAccess();
		loadHeader();

		function loadHeader(){
			
			resetGridsForHeaderSelection();

			AvailableUsersReport.getOverAllSummaryData( reportHeaderSuccess, reportHeaderFailure );
		}
		function reportHeaderSuccess(result){
			vm.overAllSummary = result;
		}
		function reportHeaderFailure(error){

		}
		function resetGridsForHeaderSelection(){   		
   	   
			vm.bankSummaryList  = [];
			vm.userDetailsList  = [];
			vm.showUserDetailsDrillDown = false;
		    vm.showBankDetails = false;
		    vm.showBranchDetails = false;
		    vm.showBankSummary = false;
		  	vm.showCustomerDetails = false;
		  	vm.userSummaryFilterText = '';
		  	vm.bankSummaryfilterText = '';   		
   	   }
		function resetGridsBankSelection(){  
			
			vm.userDetailsList  = [];
			vm.showUserDetailsDrillDown = false;
		    vm.showBankDetails = false;
		    vm.showBranchDetails = false;
		  	vm.showCustomerDetails = false;
		  	vm.userSummaryFilterText = '';
   		
   	   }
		function userDetailsSuccess(result){
    		vm.userDetailsList = result;
    		angular.element("#userSearch").focus();
    	}
    	function userDetailsFailure(error){
    		
    	}
    	
    	function getBankSummary(){
    		//resetGridsBankSelection();
    		AvailableUsersReport.getBankSummary( getBankSummarySuccess, getBankSummaryFailure );
    	}
    	function getBankSummarySuccess(result){

    		vm.filterData = result;
    		vm.bankSummaryList = result;
    		vm.bankSummaryfilterText = '';
    		vm.showBankSummary = true;
    		vm.showUserDetailsDrillDown = false;
    		calculateBankHeaderTotal(result);
    	}
    	function getBankSummaryFailure(){
    		
    	}
    	
    	function calculateBankHeaderTotal(list){
     		
    		vm.totalBankUsers = 0;     		
     		angular.forEach(list, function(overallCountForbank) {
     			
     			vm.totalBankUsers = vm.totalBankUsers + overallCountForbank.bankUsers;
         		
     		});
     		
     	}    	
    	function getUserDetails(bankId, bankName, entityType, drillDownGridType){
    		setSelectionDetails(bankId, bankName, entityType,drillDownGridType);    		
    		AvailableUsersReport.getUserDetails({ 'entityOwnerType' : entityType , 'orgID' : bankId} ,userDetailsSuccess, userDetailsFailure)
        	    		
    	}
    
    	function setSelectionDetails(bankId, bankName, entityType,drillDownGridType){
   		 
    	    vm.selectedEntityType = entityType;
    	    vm.userSummaryFilterText = '';
    	    setColumDisplayForUserDetails(bankId, bankName, drillDownGridType);
    	}
    	function setColumDisplayForUserDetails(bankId, bankName, drillDownGridType){
    		vm.showUserDetailsDrillDown = true;
    		vm.showBankDetails = false;
    		vm.showBranchDetails = false;
    		vm.showCustomerDetails = false;
    		
    		
    		if(drillDownGridType ==  vm.BANK_TYPE ){    	
    			
        		vm.showBankDetails = true;
        		vm.userDetailsHeader = "Bank Users"
        		
    		}else if(drillDownGridType == vm.BRANCH_TYPE ){
    			vm.showBankSummary = false;
    			vm.showBranchDetails = true;
    			vm.userDetailsHeader = "Branch Users"
    			
    		}else if(drillDownGridType == vm.CUSTOMER_TYPE ){
    			vm.showBankSummary = false;
    			vm.showCustomerDetails = true;
    			vm.userDetailsHeader = "Customer Users"
    			
    		}else if(drillDownGridType == vm.CLEARCORP ){
    			vm.showBankSummary = false;
    			vm.userDetailsHeader = "Clearcorp Users"
    			
    		}
    	}
		function logScreenAccess(){
			vm.screenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}

		/********** Refresh**********/
		$scope.toggle = true;
		function refresh() {
			$scope.toggle = false;
			$scope.refreshFlag = false;
			loadHeader();
			if ($scope.toggle == false) {
				$timeout(function() {
					$scope.toggle = true;
				}, 2000);
				$scope.refreshFlag = false;
			}
		};

		/***********END *************/
	
	 
    	$scope.$watch('vm.bankSummaryfilterText', function(value){
    		calculateBankHeaderTotal(vm.filterData);
    		resetGridsBankSelection();
        }); 

		function exportToFile(fileType){
			vm.baseString =   'No_Of_Available_Users_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   	
			
				if(fileType == 'csv'){
					vm.mimeType = 'text/csv'
					vm.baseString = vm.baseString+ ".csv";  
					AvailableUsersReport.getAvailalbeUsersCSVData( processResponse )
				}else if(fileType == 'excel'){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.baseString = vm.baseString+ ".xls";  
					AvailableUsersReport.getAvailalbeUsersExcelData(processResponse );
				}
			
		}	
		function processResponse(result){
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer


			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	}
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	 $stateProvider.state('no-of-available-users', {
           	 parent: 'entity',
             params:{screen: 'NoOfAvailableUsers'},
             url: '/available-users-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.networkmonitor.availableUsers" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    //templateUrl: 'app/entities/available-users-report/available-users-report.html',
                	templateUrl: 'app/entities/available-users-report/cc-available-users-report.html',
                    controller: 'CCAvailableUsersReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('availableUsersReport');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
    };
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('AvailableUsersReport', AvailableUsersReport);

    AvailableUsersReport.$inject = ['$resource','DateUtils'];

    function AvailableUsersReport ($resource, DateUtils) {
        var resourceUrl = 'api/availableusers';
        return $resource(resourceUrl, {}, {
            
            'getHeaderData': {
                method: 'GET',  
                url: 'api/availableusers/all-available-users-count',
               
                isArray: true
            },
            'getBankUsersDetails': {
                method: 'GET',  
                url: 'api/availableusers/bank-users',
                params : {
                	bankId : '@bankId'
					
				},
				isArray: true
            },
            'getBranchUsersCountForBank': {
                method: 'GET',  
                url: 'api/availableusers/branch-users-count-for-bank',
                params : {
                	bankId : '@bankId'
					
				},
                isArray: true
            },'getCustomerCountForBranch': {
                method: 'GET',  
                url: 'api/availableusers/customers-count-for-branch',
                params : {
                	bankId : '@bankId'
					
				},
                isArray: true
            },'getCustomersUsersCount': {
                method: 'GET',  
                url: 'api/availableusers/customer-users-count',
                params : {
                	bankId : '@bankId',
                	branchId: '@branchId'
					
				},
                isArray: true
            },'getCurrentBusinessDate': {
                method: 'GET',  
                url: 'api/eod-process',
                transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
            },
            'getExcelData': {
                method: 'POST',  
                url: 'api/availableusers/export/excel',
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 },
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                }         
            },
            'getCSVData': {
                method: 'POST',  
                url: 'api/availableusers/export/csv',
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 },
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                }         
            }
            ,'getOverAllSummaryData': {
                method: 'GET',  
                url: 'api/availableUsers/overall-summary',
              
                
            },'getBankSummary': {
                method: 'GET',  
                url: 'api/availableUsers/bank-summary',                
				isArray: true
                
            },'getUserDetails': {
                method: 'GET',  
                url: 'api/availableUsers/get-user-details',   
                params : {
                	orgID : '@orgID',
                	entityOwnerType : '@entityOwnerType'
					
				},
				isArray: true
                
            },'getAvailalbeUsersExcelData': {
                method: 'POST',  
                url: 'api/cc-availableusers/export/excel',
                responseType: 'arraybuffer',
               
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                }         
            },
            'getAvailalbeUsersCSVData': {
                method: 'POST',  
                url: 'api/cc-availableusers/export/csv',
                responseType: 'arraybuffer',
               
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                }         
            }
        });
    }
})();
(function () {
	'use strict';

	angular
		.module('gatewayApp')
		.controller('AvailableUsersReportController', AvailableUsersReportController);

	AvailableUsersReportController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues',  'AlertService','AvailableUsersReport','$filter', 'ScreenLog','entityConstants','DateUtils','$timeout'];

	function AvailableUsersReportController( $scope, $state, $rootScope, GlobalValues,AlertService , AvailableUsersReport , $filter , ScreenLog, entityConstants,DateUtils,$timeout){
		var vm = this;
		vm.globalValues = GlobalValues;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.NO_OF_AVAILABLE_USER_REPORT;
        vm.entityConstants = entityConstants;
        vm.screenLog = ScreenLog;
        $scope.refresh = refresh;
        
        vm.headerList =[];
        vm.selectedEntityUserList=[];
        var recordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.noOfRecordsPerPage = recordsPerPage;
        $scope.page = 1;
        $scope.noOfUserRecordsPerPage = recordsPerPage;
        $scope.userPage = 1;
        $scope.noOfBranchRecordsPerPage = recordsPerPage;
        $scope.branchPage = 1;
        $scope.noOfBranchCustomerRecordsPerPage = recordsPerPage;
        $scope.branchCustomerPage = 1;       
        $scope.noOfCustomerRecordsPerPage = recordsPerPage;
        $scope.customerPage = 1;
        
        vm.getBankUsersDetails = getBankUsersDetails;
        vm.getBranchWiseUsersCount = getBranchWiseUsersCount;
        vm.getBranchWiseCustomerCount = getBranchWiseCustomerCount;
        vm.getBranchUsersDetails = getBranchUsersDetails;
        vm.getBranchCustomerDetails = getBranchCustomerDetails;
        vm.getCustomerUserDetails = getCustomerUserDetails;
        
        vm.selectedBankName = '';
        vm.selectedBankId = '';	
        vm.selectedEntityName = '';
        vm.selectedEntityType = '';
        vm.selectedBranchName = '';
        vm.selectedBranchId = '';
        
		vm.showBranchDrillDown = false;
		vm.showCustomerCountForBranches=false; 
		vm.showSelectedBranchCustomerDetails = false;
		
		vm.showSelectedBankUsersDetails = false;
		vm.showSelectedBranchUsersDetails = false;
		vm.showSelectedCustomerUsersDetails = false;
		
		//initialise list		
		vm.branchWiseUserCountList= [];
		vm.branchWiseCustomerCountList =[];
		vm.customerDetailsList = [];
		vm.selectedEntityUserList = [];		
		
		vm.exportToFile = exportToFile;
	
        	    
		/*AvailableUsersReport.getCurrentBusinessDate(getBusinnessDateSuccess, getBusinessDateFailed);
 	   
 	   function getBusinnessDateSuccess(result) {
 		  if (result.date) {
 			 vm.reportDate  = DateUtils.convertLocalDateFromServer(result.date);
          }
 		  else {vm.reportDate =  null;}
 		 		
		}
		function getBusinessDateFailed(error) {
			//Do Nothing
		}*/
		vm.todayDate=new Date();
		vm.reportDate  = DateUtils.convertDateTimeFromServer(vm.todayDate);
 	    
 	   logScreenAccess();
 	   loadHeader();
 	   
 	   function loadHeader(){		  
 		   	vm.headerList =[];
 			vm.totalBankUsersCount = 0;
 			vm.totalBranchUsersCount = 0;
 			vm.totalCustomerUsersCount = 0;	
 			vm.totalBranchUserCountForBank = 0;
 			vm.totalBranchCustomerCountForBank = 0;
 			vm.totalBranchCustomerUSerCount = 0;
 			vm.filterText="";
 			
 		  AvailableUsersReport.getHeaderData(  reportHeaderSuccess, reportHeaderFailure );
 	   }
 	   function reportHeaderSuccess(result){
 		  
 		   vm.headerList = result;
 		   calculateHeaderTotal(vm.headerList);
 		  showGridsForHeaderSelection();
 	   }
 	   function reportHeaderFailure(error){
 		   
 	   }
 	  
 	  function getBankUsersDetails(selectedBankId, selectedBankName){
 		  
 		 vm.selectedBankName = selectedBankName;
         vm.selectedBankId = selectedBankId;
         vm.selectedEntityName = selectedBankName;
         vm.selectedEntityType = 'Bank';
         //reset the paggination
 		 $scope.noOfUserRecordsPerPage = recordsPerPage;
 		 $scope.userPage = 1;
 		 vm.showSelectedBankUsersDetails = true;
 		 vm.showSelectedBranchUsersDetails = false;
 		 vm.showSelectedCustomerUsersDetails = false;
 		 vm.showBranchDrillDown = false;
 		 vm.showCustomerCountForBranches=false; 
 		 vm.showSelectedBranchCustomerDetails = false;
 		 vm.userFilterText = "";
         AvailableUsersReport.getBankUsersDetails({bankId:selectedBankId},bankUserDetailsSuccess, bankUserDetailsFailure );
         
 	  }
 	  function bankUserDetailsSuccess(result){
 		 vm.selectedEntityUserList = result;
 		
 		 
 	  }
 	  function bankUserDetailsFailure(error){
		   
 	  }
 	  
 	  
 	  function getBranchWiseUsersCount(selectedBankId, selectedBankName){
 		 vm.branchWiseUserCountList = [];
 		 vm.totalBranchUserCountForBank = 0; 			
 		 vm.totalBranchCustomerCountForBank = 0;  
 		 vm.totalBranchCustomerUSerCount = 0;
 		 vm.selectedBankName = selectedBankName;
         vm.selectedBankId = selectedBankId;
         vm.branchWiseFilterText="";
       //reset the paggination 		
 		/*
 		 *$scope.noOfBranchRecordsPerPage = recordsPerPage;
 		 $scope.branchPage = 1;
 		 vm.showBranchDrillDown = true;
 		 vm.showSelectedBankUsersDetails = false;
 		 vm.showSelectedBranchUsersDetails = false;
 		 vm.showSelectedCustomerUsersDetails = false;
 		 vm.showCustomerCountForBranches=false; 
 		 vm.showSelectedBranchCustomerDetails = false;*/
 		 showGridsForBranchUserSelection();
         AvailableUsersReport.getBranchUsersCountForBank({bankId:selectedBankId}, branchWiseUsersCountSuccess, branchWiseUsersCountFailure );
 	  }
 	  function branchWiseUsersCountSuccess(result){
 		
 		 vm.branchWiseUserCountList = result;
 		calculateBranchUserTotal(vm.branchWiseUserCountList);
 		 
 	  }
 	  function branchWiseUsersCountFailure(error){
		   
 		  
 	  }
 	  
 	  function getBranchWiseCustomerCount(selectedBankId, selectedBankName){
 		 vm.branchWiseCustomerCountList =[];
 		 vm.totalBranchCustomerCountForBank = 0;
 		 vm.totalBranchCustomerUSerCount = 0;
 		 vm.customerDetailsList =[];
 		 vm.selectedBankName = selectedBankName;
         vm.selectedBankId = selectedBankId;
         vm.branchWiseCustomerFilterText = "";
       //reset the paggination
 		 /*$scope.noOfBranchCustomerRecordsPerPage = recordsPerPage;
 		 $scope.branchCustomerPage = 1 		 
 		 vm.showSelectedBankUsersDetails = false;
		 vm.showSelectedBranchUsersDetails = false;
		 vm.showSelectedCustomerUsersDetails = false;
		 vm.showBranchDrillDown = false;
		 vm.showCustomerCountForBranches=true; 
		 vm.showSelectedBranchCustomerDetails = false;*/ 		
 		 showGridsForBranchCustomerCountSelection();
         AvailableUsersReport.getCustomerCountForBranch({bankId:selectedBankId}, branchWiseCustomerCountSuccess, branchWiseCustomerCountSuccess );
 	  }
 	  function branchWiseCustomerCountSuccess(result){
  		
 		 vm.branchWiseCustomerCountList = result;
 		calculateBranchCustomerTotal(vm.branchWiseCustomerCountList);
 		 
 		 
 	  }
 	  function branchWiseCustomerCountFailure(error){
		   
 		  
 	  }
 	  
 	  function getBranchUsersDetails(branchName , branchId, userList){
 		 vm.selectedEntityName = branchName;
 		 vm.userFilterText = "";
         vm.selectedEntityType = 'Branch';
    	 vm.selectedEntityUserList = userList;
 		 //reset the paggination
 		 $scope.noOfUserRecordsPerPage = recordsPerPage;
 		 $scope.userPage = 1; 
 		 vm.showSelectedBankUsersDetails = false;
		 vm.showSelectedBranchUsersDetails = true;
		 vm.showSelectedCustomerUsersDetails = false;
		 vm.showBranchDrillDown = true;
		 vm.showCustomerCountForBranches=false; 
		 vm.showSelectedBranchCustomerDetails = false;
 	  }
 	  
 	  function logScreenAccess(){
			  vm.screenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
	  }
	
 	  
 	  function getBranchCustomerDetails(bankId, branchId, branchName){
 		 vm.totalBranchCustomerUSerCount = 0;
 		 vm.customerDetailsList =[];
 		 vm.selectedBranchName = branchName;
         vm.selectedBranchId = branchId;
         vm.customerFilterText="";
         //reset the paggination
 		 /*
 		 $scope.noOfCustomerRecordsPerPage = recordsPerPage;
 		 $scope.customerPage = 1; 
 		 vm.showSelectedBankUsersDetails = false;
		 vm.showSelectedBranchUsersDetails = false;
		 vm.showSelectedCustomerUsersDetails = false;
		 vm.showBranchDrillDown = false;
		 vm.showCustomerCountForBranches=true; 
		 vm.showSelectedBranchCustomerDetails = true;*/
 		showGridsForCustomerUserCountSelection();
 		 AvailableUsersReport.getCustomersUsersCount({bankId:bankId, branchId:branchId },getBranchCustomerDetailsSuccess,getBranchCustomerDetailsFailure);
 		
 	  }
 	  function getBranchCustomerDetailsSuccess(result){
 		 
 		 vm.customerDetailsList = result;
 		calculateCustomerUserTotal(vm.customerDetailsList);
 		
 	  }
 	  function getBranchCustomerDetailsFailure(error){
 		 
 	  }
 	  
 	  function getCustomerUserDetails(customerName, userList){
 		  
 		 vm.selectedEntityName = customerName;
         vm.selectedEntityType = 'Customer';
         vm.userFilterText = "";
    	 vm.selectedEntityUserList = userList;
 		 //reset the paggination
 		 $scope.noOfUserRecordsPerPage = recordsPerPage;
 		 $scope.userPage = 1; 
 		 vm.showSelectedBankUsersDetails = false;
		 vm.showSelectedBranchUsersDetails = false;
		 vm.showSelectedCustomerUsersDetails = true;
		 vm.showBranchDrillDown = false;
		 vm.showCustomerCountForBranches=true; 
		 vm.showSelectedBranchCustomerDetails = true;
 	  }
		/********** Refresh**********/
	  $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadHeader();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
	
	/***********END *************/
        function calculateHeaderTotal(list){
    		vm.totalBankUsersCount = 0;
    		vm.totalBranchUsersCount = 0;
    		vm.totalCustomerUsersCount= 0;
    		
    		angular.forEach(list, function(overallCountForbank) {
    			
    			vm.totalBankUsersCount = vm.totalBankUsersCount + overallCountForbank.bankUsersCount;  
    			vm.totalBranchUsersCount = vm.totalBranchUsersCount + overallCountForbank.branchUsersCount; 
    			vm.totalCustomerUsersCount = vm.totalCustomerUsersCount + overallCountForbank.customerUsersCount;
    		});
    		
    	}
    	function calculateBranchUserTotal(list){
    		vm.totalBranchUserCountForBank = 0;
    		angular.forEach(list , function(branch) {		

    			vm.totalBranchUserCountForBank = vm.totalBranchUserCountForBank + branch.branchUsersCount;

    		});
    		
    	}
    	function calculateBranchCustomerTotal(list){
    		vm.totalBranchCustomerCountForBank  = 0;
    		angular.forEach(list, function(branchCustomer) {
    			
    			vm.totalBranchCustomerCountForBank = vm.totalBranchCustomerCountForBank + branchCustomer.customerCount;
    		});
    		
    	}
    	function calculateCustomerUserTotal(list){
    		vm.totalBranchCustomerUSerCount = 0;
    		angular.forEach(list , function(customer) {
    			
    			vm.totalBranchCustomerUSerCount = vm.totalBranchCustomerUSerCount + customer.customerUsersCount;
    		});
    		
    	}
    	$scope.$watch('vm.filterText', function(value){
    		calculateHeaderTotal(vm.filterData);
    		showGridsForHeaderSelection();
        }); 
    	$scope.$watch('vm.branchWiseFilterText', function(value){
    		calculateBranchUserTotal(vm.branchWiseUserFilterData);
    		showGridsForBranchUserSelection();
        }); 
    	$scope.$watch('vm.branchWiseCustomerFilterText', function(value){
    		calculateBranchCustomerTotal(vm.branchWiseCustomerFilterData );
    		showGridsForBranchCustomerCountSelection();
        }); 
    	$scope.$watch('vm.customerFilterText', function(value){
    		calculateCustomerUserTotal(vm.customerFilterData);
    		showGridsForCustomerUserCountSelection();
        });
    	
    	function showGridsForCustomerUserCountSelection(){
    		//reset pagination
    		$scope.noOfCustomerRecordsPerPage = recordsPerPage;
    		$scope.customerPage = 1; 
    		vm.showSelectedBankUsersDetails = false;
   		 	vm.showSelectedBranchUsersDetails = false;
   		 	vm.showSelectedCustomerUsersDetails = false;
   		 	vm.showBranchDrillDown = false;
   		 	vm.showCustomerCountForBranches=true; 
   		 	vm.showSelectedBranchCustomerDetails = true;
   		 	vm.userFilterText="";
   		 	
    	}
    	function showGridsForBranchCustomerCountSelection(){
    		//reset pagination
    		 $scope.noOfBranchCustomerRecordsPerPage = recordsPerPage;
    		 $scope.branchCustomerPage = 1 
    		 vm.showSelectedBankUsersDetails = false;
    		 vm.showSelectedBranchUsersDetails = false;
    		 vm.showSelectedCustomerUsersDetails = false;
    		 vm.showBranchDrillDown = false;
    		 vm.showCustomerCountForBranches=true; 
    		 vm.showSelectedBranchCustomerDetails = false;
    		 vm.userFilterText="";
    		 vm.customerFilterText ="";    		
    	}
    	function showGridsForBranchUserSelection(){
    		//reset pagintion
    		 $scope.noOfBranchRecordsPerPage = recordsPerPage;
     		 $scope.branchPage = 1;
    		 vm.showBranchDrillDown = true;
     		 vm.showSelectedBankUsersDetails = false;
     		 vm.showSelectedBranchUsersDetails = false;
     		 vm.showSelectedCustomerUsersDetails = false;
     		 vm.showCustomerCountForBranches=false; 
     		 vm.showSelectedBranchCustomerDetails = false;
     		 vm.userFilterText="";
     		
    	}
    	function showGridsForHeaderSelection(){
    		 vm.showBranchDrillDown = false;
    		 vm.showSelectedBankUsersDetails = false;
    		 vm.showSelectedBranchUsersDetails = false;
    		 vm.showSelectedCustomerUsersDetails = false;
    		 vm.showCustomerCountForBranches=false; 
    		 vm.showSelectedBranchCustomerDetails = false;
    		 vm.userFilterText="";
    		 vm.customerFilterText ="";
    		 vm.branchWiseCustomerFilterText = "";
    		 vm.branchWiseFilterText="";
    	}
    	 function exportToFile(fileType){
       	  vm.baseString =   'No_Of_Available_Users_Report_'+ moment().format( 'DD_MMM_YYYY_HH_mm');   	
       	  if( vm.headerList !=null &&  vm.headerList!=undefined){
       		  if(fileType == 'csv'){
       			 vm.mimeType = 'text/csv'
       			 vm.baseString = vm.baseString+ ".csv";  
       			AvailableUsersReport.getCSVData(vm.headerList , processResponse )
       		  }else if(fileType == 'excel'){
       			  vm.mimeType = 'application/vnd.ms-excel';
       			  vm.baseString = vm.baseString+ ".xls";  
       			AvailableUsersReport.getExcelData(vm.headerList , processResponse );
       		  }
       	  }
         }	
         function processResponse(result){
       	  var fileData = null;
   		  fileData = result.data;
   		  var link = document.createElement("a");   
   		  var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
   		  
   		  
   	      var blob = new Blob([bytes], {type: vm.mimeType});
   	      if(window.navigator.msSaveOrOpenBlob) {
                   window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
   	      }else{
   	    	  link.href =  window.URL.createObjectURL(blob);      
   	    	  link.download = vm.baseString;
   	    	  document.body.appendChild(link);
   	    	  link.click();
   	    	  document.body.removeChild(link);
   	      }
   	  }
    	
	}
	 
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function() {
            this.viewFrom = ''
        })
        .controller('AuditLogDialogController', AuditLogDialogController);

    AuditLogDialogController.$inject = ['$scope', 'entity','$stateParams','$uibModalInstance'];

    function AuditLogDialogController($scope, entity, $stateParams, $uibModalInstance) {    
        var vm = this;
        vm.clear = clear;
        vm.paramMap = entity;
        //console.log("vm.paramMap " + vm.paramMap);   
        
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
       
    }   
          
        
       
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('audit-log', {
            parent: 'entity',
            params:{screen: 'AuditLogReport'},
            url: '/audit-log',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.AuditLog.manageAuditLog" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/audit-log/audit-log.html',
                    controller: 'AuditLogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('auditLog');
                    $translatePartialLoader.addPart('smsSettings');
                    $translatePartialLoader.addPart('bankRegistration');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('role');
                    $translatePartialLoader.addPart('branch');
                    $translatePartialLoader.addPart('securityPolicy');
                    $translatePartialLoader.addPart('entityActionApprovalPolicy');
                    $translatePartialLoader.addPart('approvalPolicy');
                    $translatePartialLoader.addPart('alertconfiguration');
                    $translatePartialLoader.addPart('customer-registration');
                    $translatePartialLoader.addPart('markupSettings');
                    $translatePartialLoader.addPart('defaultMarkupSettings');
                    $translatePartialLoader.addPart('heConnectivitySettings');
                    $translatePartialLoader.addPart('intradayMarketSessionSettings');
                    $translatePartialLoader.addPart('defaultMarketSessionSettings');
                    $translatePartialLoader.addPart('emailSettings');
                    $translatePartialLoader.addPart('amcSettings');
                    $translatePartialLoader.addPart('customerCharges');
                    $translatePartialLoader.addPart('gstSettings');
                    $translatePartialLoader.addPart('transactionChargesSettings');
                    $translatePartialLoader.addPart('creditFactorSettings');
                    return $translate.refresh();
                }],
                entity: function(){
                	
                }
            }
        })
        .state('audit-log-param-view', {
            parent: 'audit-log',
            url: '/audit-log/param-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/audit-log/audit-log-params-view-dialog.html',
                    controller: 'AuditLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: $state.params.paramMap
                       
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
       
       };
    })();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('AuditLog', AuditLog);

    AuditLog.$inject = ['$resource'];

    function AuditLog ($resource) {
        var resourceUrl =  'api/get-audit-log/:id';

        return $resource(resourceUrl, {}, {
            
        	 'getAuditLogDetails':{
             	isArray:true,
  				method: 'GET',
  				params: {entityId:'@entityId',login:'@login',from:'@from',to:'@to',orgId:'@orgId'},
  				url: 'api/audit-log-report/:entityId/:from/:to/get-audit-log-details'
              },
              'getAuditLogDetailsFromArchive':{
               	isArray:true,
    			method: 'GET',
    			params: {entityId:'@entityId',login:'@login',from:'@from',to:'@to',orgId:'@orgId'},
    			url: 'api/audit-log-archive-report/:entityId/:from/:to/get-audit-log-details'
               }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function() {
            this.viewFrom = ''
        })
        .controller('AuditLogController', AuditLogController);

    AuditLogController.$inject = ['$scope', '$state', 'workflowSharedService','$rootScope','MessageBox','AuditLog', 'GlobalValues','EntityPermissions','$filter', 'entity','DateUtils','ScreenLog','entityConstants','AlertService'];

    function AuditLogController($scope, $state, workflowSharedService, $rootScope, MessageBox, AuditLog, GlobalValues, EntityPermissions,$filter, entity,DateUtils,ScreenLog,entityConstants,AlertService) {    
        var vm = this;
        vm.globalValues = GlobalValues;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.getAuditLogDetails=getAuditLogDetails;
        vm.todayDate=new Date();
        vm.Values=Values;
        vm.userEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        vm.userListValue={};
        vm.ExpandOrCollapseAuditLog = true;
        vm.entityConstants = entityConstants;
        vm.screenLog=ScreenLog;
        vm.showReportParams = showReportParams;
        vm.valid=false;
		vm.clicked=false;
        vm.historicalOrCurrent = 'Current';
        
		vm.reportDate  = DateUtils.convertDateTimeFromServer(vm.todayDate);
		vm.yesterdayDate = angular.copy(vm.reportDate);
		vm.yesterdayDate.setDate(vm.yesterdayDate.getDate() - 1);
		vm.fromDate = angular.copy(vm.reportDate);
		vm.fromDate.setDate(vm.fromDate.getDate() -1);
	    vm.toDate = angular.copy(vm.reportDate);
	    vm.toDate.setDate(vm.toDate.getDate() -1);
	    vm.orgId = null;

        /* $scope.$watch('vm.fromDate', function(newValue, oldValue){
        	if(newValue!=null && newValue!=undefined){
        		if(!moment(newValue).isAfter(oldValue,'day') && !moment(newValue).isBefore(oldValue,'day')){
            		if(moment(newValue).isAfter(vm.todayDate,'day')){
            			AlertService.error($filter('translate')('gatewayApp.AuditLog.futureFromDate'));
            			vm.valid=false;
            		}
        		}
        	}
        })*/
        
        /*$scope.$watch('vm.fromDate',function(value){
        	if(value!=null && value!=undefined){
        		if(moment(value).isAfter(vm.todayDate,'day')){
        			AlertService.error($filter('translate')('gatewayApp.AuditLog.futureFromDate'));
        			vm.valid=false;
        		}
        }
        })*/
        
        /*
         * Get details for audit log given login name, screen, from and to date
         */
        logScreenAccess();
        function getAuditLogDetails()
        {   
        	
        	console.log(vm.selectedEntityOwnerType);
        	setOrganisationIdForSlectedEntity();
        	vm.auditLogDetails = [];
    		if(vm.historicalOrCurrent != 'Current' && moment(vm.fromDate).isAfter(vm.yesterdayDate,'day')){
    			AlertService.error($filter('translate')('gatewayApp.AuditLog.futureFromDate'));
    			vm.valid=false;
    		}
    		else if(vm.historicalOrCurrent != 'Current' && moment(vm.fromDate).isAfter(vm.toDate,'day')){
    			AlertService.error($filter('translate')('gatewayApp.AuditLog.greaterFromDate'));
    			vm.valid=false;
    		}else if(vm.historicalOrCurrent != 'Current' && moment(vm.toDate).isAfter(vm.yesterdayDate,'day')){
    			AlertService.error($filter('translate')('gatewayApp.AuditLog.greaterToDate'));
    			vm.valid=false;
    		}
    		else{
    			vm.valid=true;
				vm.clicked=true;
    			var from=$filter('date')(vm.fromDate, "yyyy-MM-dd");
	        	var to=$filter('date')(vm.toDate, "yyyy-MM-dd");
	        	var entityId = 0;

            	if(vm.screenName!=undefined && vm.screenName!=null && vm.screenName!=''){
            		entityId = vm.screenName.id;
            	}
            	
            	if(vm.historicalOrCurrent == 'Current'){
	    			from=$filter('date')(vm.todayDate, "yyyy-MM-dd");
	        		to=$filter('date')(vm.todayDate, "yyyy-MM-dd");
                	AuditLog.getAuditLogDetails({"entityId":entityId,"login":vm.userListValue,"from":from,"to":to,"orgId":vm.orgId},onGetAuditLogDetailsSuccess,onGetAuditLogDetailsError);
            	}else{
                	AuditLog.getAuditLogDetailsFromArchive({"entityId":entityId,"login":vm.userListValue,"from":from,"to":to,"orgId":vm.orgId},onGetAuditLogDetailsSuccess,onGetAuditLogDetailsError);
            	}
            	
    		}
        }
        
        function setOrganisationIdForSlectedEntity(){
        	if(vm.userEntityOwnerType == vm.selectedEntityOwnerType){
        		vm.orgId = vm.globalValues.getOrgId(); 
        		console.log("logged in user org id "  + vm.orgId);
        	}else{
	        	if(vm.userEntityOwnerType == 'Clearcorp'){
	        	
		        	 if( vm.selectedEntityOwnerType =='Bank' || vm.selectedEntityOwnerType == 'Branch'){
		        		vm.orgId = vm.bankValue.id; 
		        		console.log("selected bank or branch org id "  + vm.orgId);
		        	}else if( vm.selectedEntityOwnerType =='SingleUserCustomer' || vm.selectedEntityOwnerType == 'MultiUserCustomer'){
		        		vm.orgId = vm.customerValue.id; 
		        		console.log("selected customer id "  + vm.orgId);
		        	}
	        	}else if(vm.userEntityOwnerType == 'Bank'){
	        		
	        		if(vm.selectedEntityOwnerType == 'Branch'){
		        		vm.orgId = vm.globalValues.getOrgId(); 
		        		console.log("logged in user org id "  + vm.orgId);
	        		}else if( vm.selectedEntityOwnerType =='SingleUserCustomer' || vm.selectedEntityOwnerType == 'MultiUserCustomer'){
		        		vm.orgId = vm.customerValue.id; 
		        		console.log("selected customer id "  + vm.orgId);
		        	}
	        	}else if(vm.userEntityOwnerType == 'Branch'){
	        		
	        		if( vm.selectedEntityOwnerType =='SingleUserCustomer' || vm.selectedEntityOwnerType == 'MultiUserCustomer'){
		        		vm.orgId = vm.customerValue.id; 
		        		console.log("selected customer id "  + vm.orgId);
		        	}
	        	}
	        	
        	}
        }
        //vm.fromDate = DateUtils.convertDateTimeFromServer(vm.todayDate);
        //vm.toDate = DateUtils.convertDateTimeFromServer(vm.todayDate);
        
        function onGetAuditLogDetailsSuccess(result)
        {
        	
        	vm.auditLogDetails=result;
        	vm.clicked=false;
        }
        
        
        function onGetAuditLogDetailsError()
        {
        	vm.clicked=false;
        }
        
        /*
         * Load the screen by passing entity and payload
         */
        
        function Values(entity,payload,actionName){
            $rootScope.payload = payload;
            $rootScope.actionName = actionName;
            workflowSharedService.viewFrom = getViewFrom(entity,actionName);
            var state = getState(entity,actionName);
            $state.go(state);
            
            
        	
        }     
        
        function getViewFrom(entity,actionName){
        	if (entity == 'SecurityPolicy'){
        		return 'securityPolicy_auditLog';
        	}
        	
        	else if (entity == 'GlobalSecurityPolicy'){
        		return 'globalSecurityPolicy_auditLog';
        	}
        	
        	else if (entity == 'EntityStateApprovalProcess'){
        		return 'entityActionApprovalPolicy_auditLog';
        	}
        	
        	
        	else if (entity == 'ApprovalProcess'){
        		return 'approvalPolicy_auditLog';
        	}
        	
        	
        	else if (entity == 'OrganisationRole'){
        		return 'role_auditLog';
        	}
        	
        	
        	else if (entity == 'UserRole' ){
        		return 'userroletodolist_auditLog';
        	}
        	

        	else if (entity == 'UserManagement') {
        		return 'userRole_auditLog';
        	}
        	
          	else if (entity == 'BankRegistration'){
          		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT' || actionName=='REJECT - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}else{
        			return 'bankregistration_auditlog';
        		}
        	}
        	
          	else if (entity == 'UserAdminApplicationWideSettings'){
        		return 'userAdminApplicationWideSettings_auditlog';
        	}

			else if (entity == 'PendingOrderReport'){
        		return 'messageuploadtodolist_auditLog';
        	}
        	
          	else if (entity == 'DealingAdminApplicationWideSettings'){
        		return 'dealingAdminApplicationWideSettings_auditlog';
        	}
			else if (entity == 'TransactionParametersSettings'){
        		return 'transaction-parameters-settings_auditlog';
        	}
        	
        	else if (entity == 'BranchRegistration'){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT' || actionName=='REJECT - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}else{
        			return 'branch_auditLog';
        		}
        	}
			else if (entity == 'ManageHomeBranch'){
        			return 'homebranch_auditLog';
        	}
			else if(entity=='BankNotificationSettings')
        		{
        			return 'notification-settings-auditlog'
        		}
        	
        	else if (entity == 'AlertConfiguration'){
        		return 'alertConfiguration_auditLog';
        	}		
			else if (entity == 'ManageForexConfigurations'){
        			return 'forexConfigurations_auditLog';
        	}
		else if (entity == 'ManageCurrencyPairConfiguration'){
        			return 'currency-pair-configuration-auditLog';
        	}
		else if (entity == 'ManageBBPSSettings'){
        			return 'bbps_settings_auditLog';
        	}

        	else if (entity == 'SMSSettings'){
        		return 'smssettings_auditlog';
        	}
        	else if(entity=='CustomerRegistration'){
        		return 'customerregistrationtodolist_auditlog'
        	}
        	else if(entity=='Customer'){
        		return 'customerregistrationtodolist_auditlog'
        	}
        	else if (entity == 'DefaultMarkupSettings'){
        		return 'defaultMarkup_auditlog';
        	}
        	else if (entity == 'MarkupSettings'){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}else if(actionName=='ADD CONFIRM-IMPORT'){
        			return 'markup_import_auditlog';
        		}else{
        			return 'markup_auditLog';
        		}
        		
        	}
        	else if (entity == 'HEConnectivitySettings'){
        		return 'heConnectivitySettings_auditlog';
        	}
        	else if (entity=='IntradayMarketSessionSettings'){
        		return 'intradayMarketSessionSettings_auditlog' ;
        	}
        	else if (entity=='DefaultMarketSessionSettings'){
        		return 'defaultMarketSessionSettings_auditlog';
        	}
        	else if (entity=='EmailSettings'){
        		return 'emailSettings_auditlog';
        	}
        	else if (entity=='UserRestriction'){
        		return 'userRestriction_auditLog';
        	}
        	else if (entity=='SwapQuotes'){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT' || actionName=='REJECT - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}        		
        		return 'swapQuotes_auditLog';
        	}
          	else if (entity=='SpecialHoliday'){
        		return 'specialHoliday_auditLog';
        	}
          	else if (entity=='RegularHolidays'){
        		return 'regularHoliday_auditLog';
        	}
          	else if (entity=='LimitSettings'){
        		
          		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT' || actionName=='REJECT - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}else if(actionName=='ADD CONFIRM-IMPORT'){
        			return 'limit_import_auditlog';
        		}else{
        			return 'limitSettings_auditLog';
        		}
          		
        	}
          	else if (entity=='CustomerLimitChangeRequest'){
          	
          		if(actionName.indexOf('CREATE') >= 0 && (vm.userEntityOwnerType == 'SingleUserCustomer' || vm.userEntityOwnerType =='MultiUserCustomer') )
          			return 'create_customer_limitSettings_auditLog';
          		else
          			return 'customer_limitSettings_auditLog';
        	}
          	else if (entity=='EntityRestriction'){
        		return 'entityRestriction_auditLog';
        	}
          	else if (entity == 'AMCSettings'){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}else if(actionName=='ADD CONFIRM-IMPORT'){
        			return 'amc_import_auditlog';
        		}else{
        			return 'amcSettings_auditlog';
        		}
        		
        	}
          	else if (entity == 'CustomerCharges'){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}else if(actionName=='ADD CONFIRM-IMPORT'){
        			return 'customer_charges_import_auditlog';
        		}else{
        			return 'customerCharges_auditlog';
        		}
        		
        	}
          	else if (entity == 'GSTSettings'){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'messageuploadtodolist_auditLog';
        		}else if(actionName=='ADD CONFIRM-IMPORT'){
        			return 'gst_settings_import_auditlog';
        		}else{
        			return 'gstSettings_auditlog';
        		}
        		
        	}
          	else if(entity == 'CustomerSpecificSettings'){
          		return 'customerSpecificSettings_auditlog';
          	}

          	else if (entity=='TransactionChargesSettings'){
				if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'|| actionName == 'REJECT - IMPORT'){
					return 'messageuploadtodolist_auditLog';
				}else{
	        		return 'transactionChargesSettings_auditlog';
				}	
        	}

            else if (entity=='CreditFactorSettings'){
                return 'creditFactorSettings_auditlog';
            }

          	else if (entity=='HomeBranchIFSCUpload'){
          		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'|| actionName == 'REJECT - IMPORT'|| actionName == 'ADD CONFIRM - IMPORT'){
          			return 'messageuploadtodolist_auditLog';
          		}
          	}
          	else if (entity=='ModifyCustomerDetails'){
        		//modifycustomerdetails_auditlog
        		return 'modifycustomerdetails_auditlog';
        	}
          	else if (entity=='TermsAndConditionsUpload'){
        		return 'termsConditionUpload_auditlog';
        	}
          	else if (entity=='TermsAndConditionsView'){
        		
        		return 'entited_tac_view_auditLog';
        	}
          	else if (entity=='CustomerTermsAndConditionsUpload'){
        		return 'customerTermsConditionUploadByBank_auditlog';
        	}
          	else if (entity=='ExposureType'){
        		return 'exposureType_auditlog';
        	}
          	else if (entity=='ExposureSubType'){
        		return 'exposureSubType_auditlog';
        	}
          	else if (entity=='BankFeesChargesUpload'){
        		return 'bankFeesAndChargesUpload_auditlog';
        	}
			else if(entity == 'ManageInstrument'){
          		return 'manage_instrument_auditlog';
          	}
        }
        
        function getState(entity,actionName){
        	if (entity == 'SecurityPolicy'){
        		return 'security-policy-auditLog';
        	}
        	else if (entity == 'GlobalSecurityPolicy'){
        		return 'global-security-policy-auditLog';
        	}
        	
        	else if (entity == 'EntityStateApprovalProcess'){
        		return 'entity-action-approval-policy-auditLog';
        	}
        	
        	
        	else if (entity == 'ApprovalProcess' ){
        		return 'approval-policy-auditLog';
        	}
        	
        	
        	else if (entity == 'OrganisationRole'){
        		return 'manage-role-auditLog';
        	}
        	
        	
        	else if (entity == 'UserRole' ){
        		return 'manage-users-role-auditLog';
        	}
        	
        	else if(entity=='CustomerSpecificSettings')
        		{
        			return 'change-settings-auditlog'
        		}
        	
        	else if (entity == 'UserManagement'){
        		return 'usermanagement-auditLog';
        	}
        	
         	else if (entity == 'BankRegistration' ){
         		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'|| actionName=='REJECT - IMPORT'){
        			return 'upload-todolist-auditLog';
        		}else{
        			return 'bank-registration-auditLog';
        		}
        	}
        	
        	
         	else if (entity == 'DealingAdminApplicationWideSettings' ){
        		return 'dealing-admin-change-config-auditlog';
        	}
			else if (entity == 'TransactionParametersSettings'){
        		return 'dealing-admin-change-config-auditlog';
        	}
        	
         	else if (entity == 'UserAdminApplicationWideSettings' ){
        		return 'change-config-auditlog';
        	}
        	
        	else if (entity == 'BranchRegistration' ){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'|| actionName=='REJECT - IMPORT'){
        			return 'upload-todolist-auditLog';
        		}else{
        			return 'branch-auditLog';
        		}
        	}
        	
        	else if (entity == 'AlertConfiguration'){
        		return 'alert-configuration-auditLog';
        	}
        	else if (entity == 'SMSSettings' ){
        		return 'sms-settings-auditLog';
        	}
        	else if(entity=='CustomerRegistration'){
				var customerRegistration =  angular.fromJson($rootScope.payload);
                    if( customerRegistration.primaryContactName != "" ){
                        return 'old-customer-registration-auditLog';
                    }else{
						return 'customer-registration-auditLog';
					}
        		
        	}
        	else if(entity=='Customer'){
        		return 'customer-info-status-view-auditLog';
        	}
        	else if (entity=='DefaultMarkupSettings'){
        		return 'default-markup-auditLog';
        	}
        	else if (entity=='MarkupSettings'){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'upload-todolist-auditLog';
        		}else{
        			return 'markup-auditLog';
        		}
        		
        	}
        	else if(entity=='HEConnectivitySettings'){
        		return 'he-connectiviy-settings-auditLog';
        	}
        	else if(entity=='IntradayMarketSessionSettings'){
        		return 'intraday-market-settings-auditLog';
        	}
        	else if (entity=='DefaultMarketSessionSettings'){
        		return 'default-market-settings-auditLog';
        	}
        	else if (entity=='EmailSettings'){
        		return 'email-auditLog';
        	}
        	else if (entity=='UserRestriction'){
        		return 'userRestriction-auditLog';
        	}
        	else if (entity=='SwapQuotes'){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'|| actionName=='REJECT - IMPORT'){
        			return 'upload-todolist-auditLog';
        		}
        		var swapQuotesForTenorDatesDTO =  angular.fromJson($rootScope.payload);
        		if(swapQuotesForTenorDatesDTO.swapQuotesForTenorDatesList == undefined ){
        			return 'old-swapQuotes-auditLog';
        		}
        		return 'swapQuotes-auditLog';
        	}
          	else if (entity=='SpecialHoliday'){
        		return 'specialHoliday-auditLog';
        	}
          	else if (entity=='RegularHolidays'){
        		return 'regularHoliday-auditLog';
        	}
          	else if (entity=='LimitSettings'){
          		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT' || actionName=='REJECT - IMPORT'){
          			return 'upload-todolist-auditLog';
          		}else{
                    var limitSettingsHeaderDTO =  angular.fromJson($rootScope.payload);
                    if(limitSettingsHeaderDTO.limitInstrumentGroup == undefined ){
                        return 'old-limit-settings-auditLog';
                    }
          			return 'limit-settings-auditLog';
          		}
        		
        	}
          	else if (entity=='CustomerLimitChangeRequest'){
          		          			
          		if(actionName.indexOf('CREATE') >= 0 && (vm.userEntityOwnerType == 'SingleUserCustomer' || vm.userEntityOwnerType =='MultiUserCustomer') )
          			return 'create-customer-limit-settings-auditLog';
          		else
                    var customerLimitSettingsDTO =  angular.fromJson($rootScope.payload);
                    if(customerLimitSettingsDTO.limitSettingsHeader.limitInstrumentGroup == undefined ){
                        return 'old-customer-limit-settings-auditLog';
                    }
          			return 'customer-limit-settings-auditLog';
        	}
          	else if (entity=='EntityRestriction'){
        		return 'manage-Entity-Restrictions-auditLog';
        	}
          	else if (entity=='AMCSettings'){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'upload-todolist-auditLog';
        		}else{
        			return 'amc-auditLog';
        		}
        		
        	}
          	else if (entity=='CustomerCharges'){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'upload-todolist-auditLog';
        		}else{
        			return 'customer-charges-auditLog';
        		}
        		
        	}
        	else if (entity=='GSTSettings'){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'){
        			return 'upload-todolist-auditLog';
        		}else{
        			return 'gst-settings-auditLog';
        		}
        		
        	}
        	
        	else if (entity=='TransactionChargesSettings'){
        		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'|| actionName == 'REJECT - IMPORT'){
        			return 'upload-todolist-auditLog';
        		}
        		else{
        			return 'transaction-charges-settings-auditLog';
        		}
        	}

            else if (entity=='CreditFactorSettings'){
                return 'credit-factor-settings-auditLog';
            }

        	else if (entity=='HomeBranchIFSCUpload'){
          		if(actionName=='DISCARD - IMPORT' || actionName=='PENDING APPROVAL - IMPORT'|| actionName == 'REJECT - IMPORT' || actionName == 'ADD CONFIRM - IMPORT'){
          			return 'upload-todolist-auditLog';
          		}
          	}
        	else if (entity=='ModifyCustomerDetails'){
        		//modifycustomerdetails_auditlog
        		return 'modify-customer-details-auditLog';
        	}
        	else if (entity=='TermsAndConditionsUpload'){
        		return 'terms-condition-upload-auditLog';
        	}
        	else if (entity=='TermsAndConditionsView'){
        		
        		return 'entities-tac-view-auditLog';
        	}
        	else if (entity=='CustomerTermsAndConditionsUpload'){
        		return 'customer-tac-upload-by-bank-auditLog';
        	}
        	else if (entity=='ExposureType'){
        		return 'exposure-type-auditLog';
        	}
        	else if (entity=='ExposureSubType'){
        		return 'exposure-sub-type-auditLog';
        	}
        	else if (entity=='BankFeesChargesUpload'){
        		return 'bank-fees-charges-upload-auditLog';
        	}
			else if (entity == 'PendingOrderReport'){
        		return 'upload-todolist-auditLog';
        	}
			else if(entity=='BankNotificationSettings')
        	{
        		return 'notification-settings-auditlog'
        	}
			else if(entity=='ManageHomeBranch')
        	{
        			return 'home-branch-auditLog'
        	}
			else if (entity=='ManageInstrument'){
        		return 'instrument-auditLog';	
        	}
        	
        }
        function showReportParams(queryString){
        	
    		vm.paramList = {};   		
    	
    		queryString = queryString.replace("{" , "");
    		queryString = queryString.replace("}" , "");
    		queryString = queryString.replace(/'/g , "");
    		
    		var splittedArray = queryString.split(';');
    			
    		angular.forEach(splittedArray, function(item) {
    			var simpleArray = item.split(':');
    			if(simpleArray!=undefined && simpleArray!=null && simpleArray.length==2
    					&& simpleArray[0]!=undefined && simpleArray[0]!=null && simpleArray[1]!=undefined && simpleArray[1]!=null){
    				var key="";
    				var value="";
    				key = simpleArray[0].trim();
    				value= simpleArray[1].trim();
    				vm.paramList[key] = value;
    			}
    		});
    		$state.params = {paramMap:vm.paramList};
    		$state.go('audit-log-param-view');
        }
        function logScreenAccess(){
           	ScreenLog.screenLog( entityConstants.ENTITY_SHORT_NAME.AUDIT_LOG_REPORT,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }
     }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('EntityActionApprovalPolicy', EntityActionApprovalPolicy);

    EntityActionApprovalPolicy.$inject = ['$resource'];

    function EntityActionApprovalPolicy ($resource) {
        var resourceUrl =  'api/orgId/:orgId/entity-action-approval-policy/:id';
        
        return $resource(resourceUrl, {}, {
        	'getEntityActions': {
        		method: 'GET', 
        		isArray: true,
        		url: 'api/orgId/:orgId/entity-actions/:id'
        	 },
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
        	 'map': {
                 method: 'PUT',
                 params: {orgId:'@orgId'},
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/entity-action-approval-policy',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('EntityActionApprovalPolicyDialogController', EntityActionApprovalPolicyDialogController);

    EntityActionApprovalPolicyDialogController.$inject = ['Workflow', '$scope', '$state', 'entity', '$rootScope', '$uibModalInstance', 'workflowSharedService', 'EntityActionApprovalPolicy', 'GlobalValues', 'CSPLPagination', 'ScreenLog','entityConstants'];

    function EntityActionApprovalPolicyDialogController(Workflow, $scope, $state, entity,  $rootScope,  $uibModalInstance, workflowSharedService, EntityActionApprovalPolicy, GlobalValues, CSPLPagination, ScreenLog,entityConstants) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.ENTITY_STATE_APPROVAL_PROCESS;
        vm.screenLog = ScreenLog;
        vm.save = save;
        vm.entityActionApprovalPolicyDTO = {};
        vm.selected = {entityActions: []};
        
        vm.clear = clear;
        vm.approveEntityActionApprovalPolicy = approveEntityActionApprovalPolicy;
        vm.rejectEntityActionApprovalPolicy = rejectEntityActionApprovalPolicy;
        vm.discardEntityActionApprovalPolicy = discardEntityActionApprovalPolicy;
        vm.resubmitEntityActionApprovalPolicy = resubmitEntityActionApprovalPolicy;
    	$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.clicked=false;
        vm.selectAll=false;
    	vm.checkOrUncheckHeaderAction = checkOrUncheckHeaderAction;
    	vm.checkOrUncheckAction = checkOrUncheckAction;
        
        if(workflowSharedService.viewFrom == 'approvalPolicy'){
	        vm.entityActionApprovalPolicyDTO = entity;
			//ScreenLog.screenLog({'entityName': 'EntityStateApprovalProcess', 'entityRecordId': vm.entityActionApprovalPolicyDTO.id, 'action': 'MAP'});
	        vm.ShowApprovalPolicyLink = false;
	        showButtonsManipulateScreen();
        }
        else if(workflowSharedService.viewFrom == 'entityActionApprovalPolicytodolist_checker') {
        	vm.ShowApprovalPolicyLink = true;
        	vm.entityActionApprovalPolicyDTO =  angular.fromJson($rootScope.payload); 
        	showButtonsViewCheckerScreen();
        }
        else if(workflowSharedService.viewFrom == 'entityActionApprovalPolicytodolist_maker') {
        	vm.ShowApprovalPolicyLink = false;
        	vm.entityActionApprovalPolicyDTO =  angular.fromJson($rootScope.payload); 
        	console.log("maker screen");
        	showButtonsViewMakerScreen();
        }
        
        else if(workflowSharedService.viewFrom == 'entityActionApprovalPolicy_resubmit') {
        	console.log("resubmit screen");
        	vm.ShowApprovalPolicyLink = false;
        	vm.entityActionApprovalPolicyDTO = angular.fromJson($rootScope.payload); 
			vm.screenLog.screenLog(vm.screenName, vm.entityActionApprovalPolicyDTO.id, entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
        	showButtonsResubmitScreen();
        }
        else if(workflowSharedService.viewFrom == 'entityActionApprovalPolicy_auditLog') {
        	vm.ShowApprovalPolicyLink = false;
        	vm.entityActionApprovalPolicyDTO =  angular.fromJson($rootScope.payload); 
        	vm.btnClose=true;
        	vm.ViewDisable=true;
        }

        EntityActionApprovalPolicy.getEntityActions({orgId:GlobalValues.getOrgId(), id:vm.entityActionApprovalPolicyDTO.approvalPolicyId},function(result) {            
        	 vm.entityActionApprovalPolicies = result;
						    		//setupPagination(result);
						            vm.selected.entityActions = angular.copy(vm.entityActionApprovalPolicyDTO.entityActions);
						            if( vm.entityActionApprovalPolicies.length == vm.selected.entityActions.length){
								    	 vm.selectAll = true;
								    	 document.getElementById("selectAll").checked = true;
								     }
						            
						    });
        
        function showButtonsManipulateScreen(){
        	vm.ViewDisable = false;
            vm.btnClose = false;
            vm.btnApproveReject = false;
            $scope.showDiscardButton = false;
            $scope.showSaveButton = true;
            $scope.showCancelButton = true;
            $scope.showResubmitButton = false;
        }
        function showButtonsViewCheckerScreen(){
        	$scope.showButton=true;
        	vm.ViewDisable = true;
        	$scope.showDiscardButton = false;
        	vm.btnClose = true;
        	$scope.showDiscardButton = false;
        	vm.btnApproveReject = true;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
        function showButtonsResubmitScreen(){
        	vm.ViewDisable = false;
        	vm.btnClose = false;
        	$scope.showButton=true;
        	vm.btnApproveReject = false;
        	$scope.showDiscardButton = false;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = true;
            $scope.showResubmitButton = true;
        }
        function showButtonsViewMakerScreen(){
        	vm.ViewDisable = true;
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        	vm.btnClose = true;
        	vm.btnApproveReject = false;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
		function clear () {
            $uibModalInstance.dismiss('cancel');
        }
		
		function save () {
			
			vm.entityActionApprovalPolicyDTO.entityActions = vm.selected.entityActions;
			EntityActionApprovalPolicy.map({"orgId":GlobalValues.getOrgId()}, vm.entityActionApprovalPolicyDTO, onSaveSuccess, onSaveError);
        }
     
        function onSaveSuccess (result) {
            $uibModalInstance.close(result);  
        }

        function onSaveError () {
        	vm.clicked=false;
        }
        function approveEntityActionApprovalPolicy() { 
        	EntityActionApprovalPolicy.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	vm.clicked=false;
        }
       
        function rejectEntityActionApprovalPolicy() { Workflow.rejectTask($rootScope.taskID);}

        function discardEntityActionApprovalPolicy() {
        	EntityActionApprovalPolicy.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {

        }
        function resubmitEntityActionApprovalPolicy() {
        	vm.entityActionApprovalPolicyDTO.entityActions = vm.selected.entityActions;
        	EntityActionApprovalPolicy.resubmit({"taskId" : $rootScope.taskID}, vm.entityActionApprovalPolicyDTO, onResubmitSuccess, onResubmitError);
          	$uibModalInstance.dismiss('cancel');
          }
          
          function onResubmitSuccess(result) {
          	$rootScope.removeRow($rootScope.taskID);
          }        
          function onResubmitError(error) { 
        	  vm.clicked=false;
          }
          
          function checkOrUncheckHeaderAction(event){
            	
        	  changeHeaderActionSelection(event.target.checked);
                 
          }
         function changeHeaderActionSelection(value){
      	 	if(value){
          		angular.forEach(vm.entityActionApprovalPolicies, function(item, index){
          		
          			//item.entityActions = true;
          			vm.selected.entityActions.push(item.entityActions);
          			
          		});
      		}else{
      			angular.forEach(vm.entityActionApprovalPolicies, function(item, index){
      				//item.entityActions = false;
      				vm.selected.entityActions = [];
      			});
      		}
          
          }
          function checkOrUncheckAction(){
          	          	
          	if(vm.selected.entityActions.length == vm.entityActionApprovalPolicies.length ){
          		vm.selectAll= true;
          		document.getElementById("selectAll").checked = true;
          	}else{
          		vm.selectAll= false;
          		document.getElementById("selectAll").checked = false;
          	}
          }
         
          /*// change -- used cspl-pagination tag
          function setupPagination(result){
      		vm.CSPLPagination = CSPLPagination;
      	    vm.CSPLPagination.initialisePagination('entityActionApprovalPolicy', vm.entityActionApprovalPolicies);
      		vm.totalRecordLength = vm.CSPLPagination.getTotalRecordCount('entityActionApprovalPolicy');
      		vm.itemsPerPage = vm.CSPLPagination.getItemsPerPage('entityActionApprovalPolicy');
      		vm.pageCount = 1;
              $scope.$watch('vm.pageCount', function(){
              	vm.CSPLPagination.setPage('entityActionApprovalPolicy', vm.pageCount);
              	vm.pagedValues = vm.CSPLPagination.getPagedValues('entityActionApprovalPolicy');
              });
     }*/
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ApprovalPolicyDialogController', ApprovalPolicyDialogController);

    ApprovalPolicyDialogController.$inject = ['Workflow', '$scope', '$state', 'entity', 'mode', '$rootScope', '$uibModalInstance', 'workflowSharedService', 'ApprovalPolicy', 'GlobalValues', 'OrganisationManipulation', 'ScreenLog','entityConstants','AlertService'];

    function ApprovalPolicyDialogController(Workflow, $scope, $state, entity, mode, $rootScope,  $uibModalInstance, workflowSharedService, ApprovalPolicy, GlobalValues, OrganisationManipulation, ScreenLog,entityConstants,AlertService) {
        var vm = this;
        vm.save = save;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.APPROVAL_PROCESS;
        vm.screenLog = ScreenLog;
        vm.approvalPolicyDTO = {};
        vm.ownerOrganisation={};
        vm.approvalPolicyRolesList = [];
        vm.approvalPolicyRoleIds = [];
        
        vm.selectedPolicyOrganisationRole = null;
        vm.error = null;
        vm.validateNoOfApprovals = validateNoOfApprovals;
                
        vm.clear = clear;
        vm.approveApprovalPolicy = approveApprovalPolicy;
        vm.rejectApprovalPolicy = rejectApprovalPolicy;
        vm.discardApprovalPolicy = discardApprovalPolicy;
        vm.resubmitApprovalPolicy = resubmitApprovalPolicy;
        vm.addProcessRole = addProcessRole;
        vm.removePolicy = removePolicy;
        vm.globalValues = GlobalValues;
        vm.ownerOrganisation=vm.globalValues.getOrganisation();
        vm.ownerOrganisationId=vm.globalValues.getOrganisation().id;
        //vm.noOfApprovals=1;
        vm.clicked=false;
        
        if(workflowSharedService.viewFrom == 'approvalPolicy'){
	        vm.approvalPolicyDTO = entity;
	        
	        if(vm.approvalPolicyDTO.id==null || vm.approvalPolicyDTO.id==undefined){
		        vm.approvalPolicyDTO.isSendEmail = true;
	        }

	        if (mode == "View"){
	        	//ScreenLog.screenLog({'entityName': 'ApprovalProcess', 'entityRecordId': vm.approvalPolicyDTO.id, 'action': 'VIEW'});
	        	showButtonsViewScreen();
	        	vm.ViewDisable = true;
	        }
	        else if (mode == "Edit"){
                //ScreenLog.screenLog({'entityName': 'ApprovalProcess', 'entityRecordId': vm.approvalPolicyDTO.id, 'action': 'EDIT'});
	        	showButtonsManipulateScreen();
	        	vm.EditDisable = true;
	        }
	        else{
				//ScreenLog.screenLog({'entityName': 'ApprovalProcess', 'entityRecordId': 0, 'action': 'ADD'});
		        showButtonsManipulateScreen();
	        }
	        
        }
        else if (workflowSharedService.viewFrom == "entityActionApprovalPolicytodolist_checker"){
        	 vm.ViewDisable = true;
	   		 vm.approvalPolicyDTO = entity;
			 showButtonsViewScreen();
        }
        else if(workflowSharedService.viewFrom == 'approvalPolicytodolist_checker') {
        	vm.ViewDisable = true;

    		vm.approvalPolicyDTO =  angular.fromJson($rootScope.payload); 
    		showButtonsViewCheckerScreen();
        }
        else if(workflowSharedService.viewFrom == 'approvalPolicytodolist_maker') {
        	vm.ViewDisable = true;
        	vm.approvalPolicyDTO =  angular.fromJson($rootScope.payload); 
        	showButtonsViewMakerScreen();
        }
        
        else if(workflowSharedService.viewFrom == 'approvalPolicy_resubmit') {
        	vm.EditDisable = true;
        	vm.approvalPolicyDTO = angular.fromJson($rootScope.payload); 
            var entityRecordId = 0;
            if(vm.approvalPolicyDTO.id!=null){
  	      		entityRecordId = vm.approvalPolicyDTO.id;
  	      	}          
            vm.screenLog.screenLog(vm.screenName, entityRecordId, entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
        	showButtonsResubmitScreen();
        }
        else if(workflowSharedService.viewFrom == 'approvalPolicy_auditLog') {
        	vm.ViewDisable = true;

    		vm.approvalPolicyDTO =  angular.fromJson($rootScope.payload); 
    		showButtonsViewScreen();
        }
        if(vm.approvalPolicyDTO.organisationDTO!=null){
            vm.ownerOrganisation = OrganisationManipulation.checkAndGetOrganisation(vm.approvalPolicyDTO.organisationDTO);
            
        }
        
        if (vm.approvalPolicyDTO.approvalPolicyRoles != null){
            vm.approvalPolicyRolesList = OrganisationManipulation.checkAndGetGivenObjectListWithOrganisation(vm.approvalPolicyDTO.approvalPolicyRoles);
        	fetchExistingRoleIDs();
        }
        
        function fetchExistingRoleIDs(){
        	vm.approvalPolicyDTO.approvalPolicyRoles.forEach(function(item) {
        		  vm.approvalPolicyRoleIds.push(item.organisationRole.id);
        	});
        }
        
        function addProcessRole(){
        	var approvalPolicyRoleDTO = {}
        	
        	if (vm.selectedPolicyOrganisationRole!=null && validateDuplicationOfRole() && vm.validateNoOfApprovals()){
        		console.log(vm.selectedPolicyOrganisationRole);
	        	vm.approvalPolicyRoleIds.push(vm.selectedPolicyOrganisationRole.id);
	        	approvalPolicyRoleDTO.organisation =  vm.ownerOrganisation;
	        	approvalPolicyRoleDTO.organisationRole = vm.selectedPolicyOrganisationRole;
	        	approvalPolicyRoleDTO.noOfApprovals=vm.noOfApprovals;
	        	vm.approvalPolicyRolesList.push(approvalPolicyRoleDTO);
	            
	            vm.selectedPolicyOrganisationRole = null;
	            vm.noOfApprovals="";
        	}
        }
        
        function validateDuplicationOfRole(){
        	vm.error = "";
        	
        	if (vm.approvalPolicyRoleIds.indexOf(vm.selectedPolicyOrganisationRole.id) > -1){
        		AlertService.error("Role already exists in the process.");
        		//vm.error = "Role already exists in the process."
        		return false;
        	}
        	return true;
        }
        function validateNoOfApprovals(){
        	vm.error = "";
        	
        	if (vm.noOfApprovals =="" || vm.noOfApprovals ==null|| vm.noOfApprovals >5 || vm.noOfApprovals < 1){
        		//vm.error = "No of Approvals should be 1 to 5."
        		AlertService.error("No of Approvals should be 1 to 5.");
        		return false;
        	}
        	return true;
        }
        
        function validateExistanceOfLevels(){
        	vm.error = "";
        	
        	if (vm.approvalPolicyRoleIds.length == 0){
        		AlertService.error("Workflow levels should not be empty.");
        		//vm.error = "Workflow levels should not be empty."
        		return false;
        	}
        	return true;
        }
        
        function removePolicy(rowId){
        	vm.approvalPolicyRoleIds.splice(rowId,1);
        	vm.approvalPolicyRolesList.splice(rowId,1);
        	$scope.approvalPolicyForm.$setDirty();
        }
        
        function showButtonsViewScreen(){
            vm.btnClose = true;
            vm.btnApproveReject = false;
            $scope.showDiscardButton = false;
            $scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
        
        function showButtonsManipulateScreen(){
        	vm.ViewDisable = false;
            vm.btnClose = false;
            vm.btnApproveReject = false;
            $scope.showDiscardButton = false;
            $scope.showSaveButton = true;
            $scope.showCancelButton = true;
            $scope.showResubmitButton = false;
        }
        function showButtonsViewCheckerScreen(){
        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
        	vm.btnClose = true;
        	$scope.showDiscardButton = false;
        	vm.btnApproveReject = true;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
        function showButtonsResubmitScreen(){
        	vm.btnClose = false;
        	$scope.showButton=true;
        	vm.btnApproveReject = false;
        	$scope.showDiscardButton = false;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = true;
            $scope.showResubmitButton = true;
        }
        function showButtonsViewMakerScreen(){
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        	vm.btnClose = true;
        	vm.btnApproveReject = false;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
		function clear () {
            $uibModalInstance.dismiss('cancel');
        }
		
		function save () {	
			if (validateExistanceOfLevels()){
				vm.approvalPolicyDTO.approvalPolicyRoles = vm.approvalPolicyRolesList;
				if (mode == "Edit"){
					ApprovalPolicy.update({"orgId":GlobalValues.getOrgId()}, getActualApprovalPolicyDTO(), onSaveSuccess, onSaveError);
				}
				else {
					ApprovalPolicy.save({"orgId":GlobalValues.getOrgId()}, getActualApprovalPolicyDTO(), onSaveSuccess, onSaveError);
				}
			}else{
				vm.clicked=false;
			}
        }
     
        function onSaveSuccess (result) {
            $uibModalInstance.close(result);  
        }

        function onSaveError () {
        	vm.clicked=false;

        }
        function approveApprovalPolicy() { 
        	ApprovalPolicy.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	vm.clicked=false;
        }
       
        function rejectApprovalPolicy() { Workflow.rejectTask($rootScope.taskID);}

        function discardApprovalPolicy() {
        	ApprovalPolicy.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {

        }
        function resubmitApprovalPolicy() {
			if (validateExistanceOfLevels()){
	        	ApprovalPolicy.resubmit({"taskId" : $rootScope.taskID}, getActualApprovalPolicyDTO(), onResubmitSuccess, onResubmitError);
	          	$uibModalInstance.dismiss('cancel');
			}
          }
          
          function onResubmitSuccess(result) {
          	$rootScope.removeRow($rootScope.taskID);
          }        
          function onResubmitError(error) {
        	  vm.clicked=false;
          }
          
          function getActualApprovalPolicyDTO(){
        	  vm.approvalPolicyDTO.organisationDTO = OrganisationManipulation.checkAndGetOrganisationDTO(vm.ownerOrganisation);
        	  vm.approvalPolicyDTO.approvalPolicyRoles = OrganisationManipulation.checkAndGetGivenObjectListWithOrganisationDTO(vm.approvalPolicyRolesList);
        	  
        	  return vm.approvalPolicyDTO;
          }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ApprovalPolicyDeleteController',ApprovalPolicyDeleteController);

    ApprovalPolicyDeleteController.$inject = ['$uibModalInstance', 'entity', 'ApprovalPolicy', 'GlobalValues', 'ScreenLog','$scope'];

    function ApprovalPolicyDeleteController($uibModalInstance, entity, ApprovalPolicy, GlobalValues, ScreenLog,$scope) {
        var vm = this;

        vm.approvalPolicyDTO = entity;
    	//ScreenLog.screenLog({'entityName': 'ApprovalProcess', 'entityRecordId': vm.approvalPolicyDTO.id, 'action': 'DELETE'});
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        $scope.clicked=false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	ApprovalPolicy.delete({"orgId":GlobalValues.getOrgId(),id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('approval-policy', {
            parent: 'entity',
            url: '/approval-policy',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.security.manageapprovalpolicy" | translate }}',
                parent: 'home'
              },
            views: {
                'content@': {
                    templateUrl: 'app/entities/approval-policy/approval-policy.html',
                    controller: 'ApprovalPolicyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('approvalPolicy');
                    $translatePartialLoader.addPart('entityActionApprovalPolicy');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('approval-policy.new', {
            parent: 'approval-policy',
            url: '/approval-policy/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approval-policy/approval-policy-dialog.html',
                    controller: 'ApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: ['ApprovalPolicy', 'GlobalValues', function(ApprovalPolicy, GlobalValues) {
                            return { id:null };
                        }],
                        mode: function(){
                       	 return "New";
                        }
                    }
                }).result.then(function() {
                    $state.go('approval-policy', {}, { reload: 'approval-policy' });
                }, function() {
                    $state.go('approval-policy');
                });
            }]
        })
        .state('approval-policy.edit', {
            parent: 'approval-policy',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approval-policy/approval-policy-dialog.html',
                    controller: 'ApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                            	 entity: ['ApprovalPolicy', 'GlobalValues', function(ApprovalPolicy, GlobalValues) {
                                     return ApprovalPolicy.get({orgId:GlobalValues.getOrgId(), id:$stateParams.id}).$promise;
                                 }],
                                 mode: function(){
                                	 return "Edit";
                                 }
                    }
                }).result.then(function() {
                    $state.go('approval-policy', {}, { reload: true });
                }, function() {
                    $state.go('approval-policy');
                });
            }]
            
        })
        .state('approval-policy.view', {
            parent: 'approval-policy',
            url: '/{id}/view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approval-policy/approval-policy-dialog.html',
                    controller: 'ApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                            	 entity: ['ApprovalPolicy', 'GlobalValues', function(ApprovalPolicy, GlobalValues) {
                                     return ApprovalPolicy.get({orgId:GlobalValues.getOrgId(), id:$stateParams.id}).$promise;
                                 }],
                                 mode: function(){
                                	 return "View";
                                 }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('approval-policy.delete', {
            parent: 'approval-policy',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approval-policy/approval-policy-delete-dialog.html',
                    controller: 'ApprovalPolicyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ApprovalPolicy', 'GlobalValues', function(ApprovalPolicy, GlobalValues) {
                            return ApprovalPolicy.get({orgId:GlobalValues.getOrgId(), id:$stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('approval-policy-todolist', {
            parent: 'dashboard',
            url: '/approval-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approval-policy/approval-policy-dialog.html',
                    controller: 'ApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        },
                        mode: function(){
                       	 return "";
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('approvalPolicy');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                	$state.go('approval-policy', null, { reload: 'approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
        .state('approval-policy-todolist.resubmit', {
            parent: 'dashboard',
            url: '/approval-policy-resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approval-policy/approval-policy-dialog.html',
                    controller: 'ApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                        	

                        },
                        mode: function(){
                          	 return "";
                           },
                       translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                           $translatePartialLoader.addPart('error');
                           $translatePartialLoader.addPart('global');
                           $translatePartialLoader.addPart('approvalPolicy');
                           return $translate.refresh();
                       }]
                    }
                }).result.then(function() {
                    $state.go('approval-policy', null, { reload: 'approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
        })
        .state('approval-policy.map', {
            parent: 'approval-policy',
            url: '/entity-action-approval-policy/{id}/map',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approval-policy/entity-action-approval-policy.html',
                    controller: 'EntityActionApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: ['EntityActionApprovalPolicy', 'GlobalValues', function(EntityActionApprovalPolicy, GlobalValues) {
                    		return EntityActionApprovalPolicy.get({orgId:GlobalValues.getOrgId(), id:$stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('approval-policy', {}, { reload: 'approval-policy' });
                }, function() {
                    $state.go('approval-policy');
                });
            }]
        })
        .state('entity-action-approval-policy-view', {
            parent: 'entity-action-approval-policy-todolist',
            url: '/{id}/view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approval-policy/approval-policy-dialog.html',
                    controller: 'ApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                            	 entity: ['ApprovalPolicy', 'GlobalValues', function(ApprovalPolicy, GlobalValues) {
                                     return ApprovalPolicy.get({orgId:GlobalValues.getOrgId(), id:$stateParams.id}).$promise;
                                 }],
                                 mode: function(){
                                	 return "View";
                                 }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         .state('entity-action-approval-policy-todolist', {
            parent: 'dashboard',
            url: '/entity-action-approval-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approval-policy/entity-action-approval-policy.html',
                    controller: 'EntityActionApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('approvalPolicy');
                            $translatePartialLoader.addPart('entityActionApprovalPolicy');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                	$state.go('approval-policy', null, { reload: 'approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
        .state('entity-action-approval-policy-todolist.resubmit', {
            parent: 'dashboard',
            url: '/entity-action-approval-policy-resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approval-policy/entity-action-approval-policy.html',
                    controller: 'EntityActionApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                        	

                        },
                       translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                           $translatePartialLoader.addPart('error');
                           $translatePartialLoader.addPart('global');
                           $translatePartialLoader.addPart('approvalPolicy');
                           $translatePartialLoader.addPart('entityActionApprovalPolicy');
                           return $translate.refresh();
                       }]
                    }
                }).result.then(function() {
                    $state.go('approval-policy', null, { reload: 'approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
        })
           .state('entity-action-approval-policy-auditLog', {
            parent: 'audit-log',
            url: '/entity-action-approval-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approval-policy/entity-action-approval-policy.html',
                    controller: 'EntityActionApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('approvalPolicy');
                            $translatePartialLoader.addPart('entityActionApprovalPolicy');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                	$state.go('approval-policy', null, { reload: 'approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
        .state('approval-policy-auditLog', {
            parent: 'audit-log',
            url: '/approval-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approval-policy/approval-policy-dialog.html',
                    controller: 'ApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        },
                        mode: function(){
                       	 return "";
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('approvalPolicy');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                	$state.go('approval-policy', null, { reload: 'approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
         .state('entity-action-approval-policy-historyReport', {
            parent: 'history-report',
            url: '/entity-action-approval-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approval-policy/entity-action-approval-policy.html',
                    controller: 'EntityActionApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('approvalPolicy');
                            $translatePartialLoader.addPart('entityActionApprovalPolicy');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                	$state.go('approval-policy', null, { reload: 'approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
        .state('approval-policy-historyReport', {
            parent: 'history-report',
            url: '/approval-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approval-policy/approval-policy-dialog.html',
                    controller: 'ApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        },
                        mode: function(){
                       	 return "";
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('approvalPolicy');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                	$state.go('approval-policy', null, { reload: 'approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
   };
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ApprovalPolicy', ApprovalPolicy);

    ApprovalPolicy.$inject = ['$resource'];

    function ApprovalPolicy ($resource) {
        var resourceUrl =  'api/orgId/:orgId/approval-policy/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'}
        	 },
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
             'getAllApprovalPolicy': { method: 'GET', isArray: true,
                params: {orgId:'@orgId'},
                url: 'api/orgId/:orgId/all-approval-policy'
             },
             'actionsForOrgAndPolicy': { method: 'GET', isArray: true,
                params: {orgId:'@orgId', policyId: '@policyId'},
                url: 'api/orgId/:orgId/actions-for-policy/:policyId/policyId'
             },
        	 'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                    return angular.toJson(copy);
                 }                
             },
        	 'update': {
                 method: 'PUT',
                 params: {orgId:'@orgId'},
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/approval-policy',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'approvalPolicy'
        })
        
        .controller('ApprovalPolicyController', ApprovalPolicyController);

    ApprovalPolicyController.$inject = ['$scope', '$state', 'workflowSharedService', 'ApprovalPolicy', 'GlobalValues', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout'];

    function ApprovalPolicyController($scope, $state, workflowSharedService, ApprovalPolicy, GlobalValues, EntityPermissions, ScreenLog,entityConstants,$timeout) {
        var vm = this;
        vm.entityConstants = entityConstants;
        workflowSharedService.viewFrom = "approvalPolicy";
        vm.EntityStateApprovalProcessScreen = entityConstants.ENTITY_SHORT_NAME.ENTITY_STATE_APPROVAL_PROCESS;
        vm.ApprovalProcessScreen = entityConstants.ENTITY_SHORT_NAME.APPROVAL_PROCESS;
        vm.screenLog = ScreenLog;
        vm.launch=launch;
        $scope.refresh=refresh;
        

        vm.permitEntityStateApprovalProcessMapEntityAction = EntityPermissions.hasPermission('EntityStateApprovalProcess.MAP');
        vm.permitApprovalProcessViewEntityAction = EntityPermissions.hasPermission('ApprovalProcess.VIEW');
        vm.permitApprovalProcessCreateEntityAction = EntityPermissions.hasPermission('ApprovalProcess.CREATE');
        vm.permitApprovalProcessEditEntityAction = EntityPermissions.hasPermission('ApprovalProcess.EDIT');
        vm.permitApprovalProcessDeleteEntityAction = EntityPermissions.hasPermission('ApprovalProcess.DELETE');
        
        function launch() {
        	$state.go("approval-policy.new");
        }
        
        loadAll();

        function loadAll() {
        	ApprovalPolicy.query({"orgId":GlobalValues.getOrgId()},function(result) {
                vm.approvalPolicies = result;
            });        
        	vm.screenLog.screenLog(vm.ApprovalProcessScreen,0, vm.entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }        
        
        /*vm.screenLog = function screenLog(entityRecordId,action){
        	if(action=='MAP'){
            	ScreenLog.screenLog({'entityName': 'EntityStateApprovalProcess', 'entityRecordId': entityRecordId, 'action': action});
        	}else{
            	ScreenLog.screenLog({'entityName': 'ApprovalProcess', 'entityRecordId': entityRecordId, 'action': action});
        	}
        }*/
        
        $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };

    }
})();

(function() {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function() {
		this.viewFrom = 'changeConfig'
	})

	.controller('ApplicationWideSettingsController', ApplicationWideSettingsController);

	ApplicationWideSettingsController.$inject = [ '$scope', '$state',
			'workflowSharedService', 'ApplicationWideSettings', 'GlobalValues',
			'EntityPermissions', 'ScreenLog', 'DateUtils','$uibModalInstance','$stateParams', '$rootScope', 'entityConstants'];

	function ApplicationWideSettingsController($scope, $state, workflowSharedService,
			ApplicationWideSettings, GlobalValues, EntityPermissions, ScreenLog, DateUtils,$uibModalInstance,$stateParams,$rootScope,entityConstants) {

		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenLog = ScreenLog;
		vm.applicationWideSettings = {};
		vm.userId = $stateParams.userId;
		//vm.restoreDefault = restoreDefault;
		vm.launch = launch;
		vm.clear = clear;
		workflowSharedService.viewFrom = 'changeConfig';
		vm.isPasswordPolicySelected = true;
		function launch() {
			$state.go("application-wide-settings");
		}
		logScreenAccess();
		loadAll();

		function loadAll() {
			ApplicationWideSettings.get({
				"userId" : vm.userId
			},onGetConfigurationSettingsSuccess, onGetConfigurationSettingsError);
		}

		function onGetConfigurationSettingsSuccess(result) {
			vm.applicationWideSettings = result;
		}

		function onGetConfigurationSettingsError() {

		}
		
		function clear() {
			$uibModalInstance.dismiss('cancel');
		}
		
				
		$rootScope.$on('Refresh', function(event, result) {
			loadAll();
		});
		
		function logScreenAccess(){
	       	ScreenLog.screenLog(entityConstants.ENTITY_SHORT_NAME.USER_ADMIN_APPLICATION_WIDE_SETTINGS ,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
	    }

	}
})();

 (function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('application-wide-settings', {
            parent: 'entity',
            params:{screen: 'UserAdminApplicationWideSettings'},
            url: '/application-wide-settings/{userId}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.userProfile.userProfile" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-wide-settings-useradmin/application-wide-settings.html',
                    controller: 'ApplicationWideSettingsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:true});
                }, function() {
                    $state.go('home', null, {reload:true});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('applicationWideSettings');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
         };
    })();

(function() {
	'use strict';
	angular.module('gatewayApp').factory('ApplicationWideSettings', ApplicationWideSettings);

	ApplicationWideSettings.$inject = [ '$resource' ];

	function ApplicationWideSettings($resource) {
		var resourceUrl = 'api/applicationWideSettings/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				url : 'api/configuration-settings',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			}

		});
	}
})();

(function() {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function() {
		this.viewFrom = 'configurationsettings'
	})

	.controller('DealingAdminApplicationWideSettingsController', DealingAdminApplicationWideSettingsController);

	DealingAdminApplicationWideSettingsController.$inject = [ '$scope', '$state',
			'workflowSharedService', 'DealingAdminApplicationWideSettings', 'GlobalValues', 'MessageBox',
			'EntityPermissions', 'ScreenLog', 'DateUtils','$uibModalInstance','$stateParams','$rootScope','entityConstants', 'IntradayMarket' ];

	function DealingAdminApplicationWideSettingsController($scope, $state, workflowSharedService,
			DealingAdminApplicationWideSettings, GlobalValues, MessageBox, EntityPermissions, ScreenLog, DateUtils,$uibModalInstance,$stateParams,$rootScope,entityConstants,IntradayMarket) {

		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenLog = ScreenLog;
		vm.applicationWideSettings = {};
		vm.save = save;
		vm.userId = $stateParams.userId;
		vm.restoreDefault = restoreDefault;
		vm.launch = launch;
		vm.clear = clear;
		vm.clicked=false;
		workflowSharedService.viewFrom = 'changeConfig';
		vm.isShowRegistrationSettings = true;
		vm.getTransactionParametersSettings = getTransactionParametersSettings;
		function launch() {
			$state.go("dealing-admin-application-wide-settings");
		}
		logScreenAccess();
		loadAll();
		vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
		vm.decimalsForPaise = vm.globalValues.getNumberOfDecimalsForRateInReports();
		vm.decimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();

		function loadAll() {
			DealingAdminApplicationWideSettings.get({
				"userId" : vm.userId
			},onGetConfigurationSettingsSuccess, onGetConfigurationSettingsError);
		}

		function onGetConfigurationSettingsSuccess(result) {
			console.log(vm.applicationWideSettings);
			vm.applicationWideSettings = result;
		}

		function onGetConfigurationSettingsError() {

		}

		function getTransactionParametersSettings(currencyPair){
						DealingAdminApplicationWideSettings.transactionParametersSetting({"currencyPairId": currencyPair.id
			},ongetTransactionParametersSettingsSuccess, ongetTransactionParametersSettingsError);
		}

		function ongetTransactionParametersSettingsSuccess(result){
			vm.transactionParametersSettings = result;
			vm.clicked=false;
		}

		function ongetTransactionParametersSettingsError(){
		vm.clicked=false;
		}
		
		function restoreDefault() {
			loadAll();
		}
		
       	//get market session settings. to display status. market session settings will be available for SPOT, cash TOM
       	IntradayMarket.getIntradayMarketSessionSettingsForInstrument({"instrument":'InterbankSPOT'}, onGetMarketSessionSuccess, onGetMarketSessionFailure);
		
    	function onGetMarketSessionSuccess(result){
        	vm.marketSessionSettings = result;
        }
		
		function onGetMarketSessionFailure(){
			
		}
		
		vm.validateAndChangeConfig = function validateAndChangeConfig(headerName, labelName, configName, configValue, controlType, screenName){
			if(configName=='OrderLotSize' || configName=='MinimumOrderValue' || configName=='MaximumOrderValueHardCheck' || configName=='MaximumOrderValueSoftCheck' || configName=='AllowedOrderPriceDeviationFromMarketPriceInPercentage'||
			   configName=='ExchangeRateChange'
			){
				if(vm.marketSessionSettings.sessionStatus=='OPEN'){
					MessageBox.openMessageBox("Alert", "Modification is permitted only after the IB.SPOT market hours...!", "Ok", "applicationdealingadminsettings");
				}else{
					$state.go("dealing-admin-change-config", {headerLabel: headerName,labelName: labelName , configName: configName ,configValue: configValue, controlType : controlType, screenName : screenName});
			}
		}
	}



	vm.validateAndChangetransectionParameters = function validateAndChangeConfig(headerName, labelName, configName, configValue, controlType, screenName,currencyPairId){
	if(screenName == 'transactionParametersSettings'){
			if(vm.marketSessionSettings.sessionStatus=='OPEN'){
				MessageBox.openMessageBox("Alert", "Modification is permitted only after the IB.SPOT market hours...!", "Ok", "applicationdealingadminsettings");
			}else{
				$state.go("dealing-admin-change-config", {headerLabel: headerName,labelName: labelName , configName: configName ,configValue: configValue, controlType : controlType, screenName : screenName,currencyPairId : currencyPairId});
			}
	}

	}


	
		
		function save() {
			var fd = new FormData();
			
			vm.user.dob = DateUtils.convertLocalDateToServer(vm.user.dob);
			fd.append('user', JSON.stringify(vm.user));
            
			console.log(fd);
			if(vm.panCardUpload != undefined){
				fd.append('file', vm.panCardUpload);
				UserProfile.updateWithImage( fd, onSaveSuccess, onSaveError);	
			}else{
				
				UserProfile.update( fd, onSaveSuccess, onSaveError);
			}
				
			
		}
		
		$rootScope.$on('Refresh', function(event, result) {
			loadAll();
		});
		
		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
		}

		function onSaveError() {

			$scope.clicked = false;
		}
		function logScreenAccess(){
	       	ScreenLog.screenLog(entityConstants.ENTITY_SHORT_NAME.DELAING_ADMIN_APPLICATION_WIDE_SEETINGS ,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
	    }

	}
})();

 (function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dealing-admin-application-wide-settings', {
            parent: 'entity',
            params:{screen: 'DealingAdminApplicationWideSettings'},
            url: '/dealing-admin-application-wide-settings/{userId}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.userProfile.userProfile" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-wide-settings-dealingadmin/application-wide-settings.html',
                    controller: 'DealingAdminApplicationWideSettingsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:true});
                }, function() {
                    $state.go('home', null, {reload:true});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('applicationWideSettings');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
         };
    })();

(function() {
	'use strict';
	angular.module('gatewayApp').factory('DealingAdminApplicationWideSettings', DealingAdminApplicationWideSettings);

	DealingAdminApplicationWideSettings.$inject = [ '$resource' ];

	function DealingAdminApplicationWideSettings($resource) {
		var resourceUrl = 'api/applicationWideSettings/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				url : 'api/configuration-settings',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
            'getConfigValueForConfigName': {
                method: 'GET',                      
 				params : {
 					configName : '@configName'
 				},
                url: 'api/get-configuration-setting-value',
                transformResponse : function(data) {
 					if (data) {
 						data = angular.fromJson(data);
 					}
 					return data;
 				}
             },
			'transactionParametersSetting' : {
				method : 'GET',
				params : {
 					currencyPairId : '@currencyPairId'
 				},
				isArray: true,
				url : 'api/transaction-parameters-setting',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			
		});
	}
})();

(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
		.state('amc-summary', {
			parent: 'entity',
			params:{screen: 'AMCSummary'},
			url: '/amc-summary',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'global.title'
			},
			ncyBreadcrumb: {
				label: '{{ "global.menu.amcSummary.main" | translate }}',
				parent: 'home'
			},
			views: {
				'content@': {
					templateUrl: 'app/entities/amc-summary/amc-summary.html',
					controller: 'AMCSummaryViewController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('amcSummary');
					$translatePartialLoader.addPart('error');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}],
				configSetting :['GlobalValues', function(GlobalValues) {
                    return GlobalValues.getConfigSettings();
                }],
				systemSettings: ['IntradayMarket', function(IntradayMarket) {
					return IntradayMarket.getCurrentBusinessDate().$promise;
				}],
				financialYears: ['StaticLookUp', function(StaticLookUp){
					return StaticLookUp.getPastAndPresentFinancialYears().$promise;
				}]

			}
		})   

	};
})();

(function() {
	'use strict';
	angular
	.module('gatewayApp')
	.factory('AMCSummaryView', AMCSummaryView);

	AMCSummaryView.$inject = ['$resource'];

	function AMCSummaryView ($resource) {
		var resourceUrl =  'api/amc-summary/:id';

		return $resource(resourceUrl, {}, {

			'getAMCSummaryReport':{          	 
				method: 'GET',
				params: {bankId : '@bankId',from : '@from', to: '@to',printorGenerateAfreshOption : '@printorGenerateAfreshOption'},  				
				url: 'api/amc-summary/get-amc-summary-details'
			},
			'exportAMCSummaryExcel':{
				method: 'POST',
				url: 'api/amc-summary/excel-download',
				responseType: 'arraybuffer',
				params: {freshOrPrintOption : '@freshOrPrintOption', bank : '@bank'},
				transformRequest: function (data) {
	                   	var copy = angular.copy(data);
	                   	
	                       return angular.toJson(copy);
	            },
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			},
			'downloadEInvoiceExcel':{
				method: 'POST',
				url: 'api/amc-summary/eInvoice-download',
				responseType: 'arraybuffer',
				params: {from : '@from', to: '@to',financialYearId : '@financialYearId'},
				transformRequest: function (data) {
	                   	var copy = angular.copy(data);
	                   	
	                       return angular.toJson(copy);
	            },
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			},
			'exportAMCSummaryCsv':{
				method: 'POST',
				url: 'api/amc-summary/csv-download',
				responseType: 'arraybuffer',
				params: {freshOrPrintOption : '@freshOrPrintOption', bank : '@bank'},
				transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
            },
			transformResponse: function(data, headers) {
				return {
					data: data,
					headers: headers
				};   
			}         
			},
			'exportAMCSummaryPdf':{
				method: 'POST',
				url: 'api/amc-summary/pdf-download',
				responseType: 'arraybuffer',
				params: {freshOrPrintOption : '@freshOrPrintOption'},
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			}
		
		});
	}
})();

(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.service("workflowSharedService", function () {        	
		this.viewFrom= 'amcSummaryView'
	})

	.controller('AMCSummaryViewController', AMCSummaryViewController);

	AMCSummaryViewController.$inject = ['$scope', '$state', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants',
		'DateUtils','AlertService','$filter',   'AMCSummaryView','financialYears','configSetting'];

	function AMCSummaryViewController($scope, $state,  GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,
			DateUtils,AlertService,$filter,  AMCSummaryView,financialYears,configSetting) {
		var vm = this;
		vm.entityConstants = entityConstants;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.AMC_SUMMARY_VIEW;
		$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
		$scope.page = 1;
		vm.globalValues=GlobalValues;
		vm.screenLog = ScreenLog;
		vm.financialYears = financialYears;
		vm.loadFinancialYearDisplay = loadFinancialYearDisplay;
		loadFinancialYearDisplay();
		vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
		vm.downloadEInvoice = downloadEInvoice;
		vm.configSettings = configSetting;
		vm.freshOrPrintOption = 'PrintGeneratedInvoice';
		vm.getAmcSummary = getAmcSummary;
		vm.exportDataToFile = exportDataToFile;
		vm.setDefaultValue = setDefaultValue;
		vm.clearAllValues = clearAllValues;
		vm.filterData = {};
		vm.amcSummaryfileName = "AMC_Summary_Report_";
		vm.eInvoiceChargesfileName = "e-Invoice_";
		vm.fileName = vm.amcSummaryfileName;
		vm.extension = "";
		vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
		vm.amcSummaryDetails = null;
		vm.showDownloadEInvoice = false;
		vm.clicked=false;
		
		logScreenAccess();
		vm.valid = false;
		vm.issuePresent = false;

		function loadFinancialYearDisplay(){
			var yearCount = 0;
			if(vm.financialYears != null && vm.financialYears != undefined){
				for(yearCount = 0;yearCount < vm.financialYears.length; yearCount++){
					var fromYear = moment(DateUtils.convertLocalDateFromServer(angular.copy(vm.financialYears[yearCount].financialYearStart))).year();
					var toYear = moment(DateUtils.convertLocalDateFromServer(angular.copy(vm.financialYears[yearCount].financialYearEnd))).year();
					var displayYear = fromYear+"-"+ toYear;
					vm.financialYears[yearCount].displayYear = displayYear;
				}
			}
		}

		function getAmcSummary(){
			if(vm.freshOrPrintOption == 'PrintGeneratedInvoice'){
				vm.showDownloadEInvoice = true;
			}else{
				vm.showDownloadEInvoice = false;
			}
			vm.eInvoiceDisable = false;
			vm.amcSummaryDetails = [];
			
			if(moment(vm.fromDate).isAfter(vm.toDate,'day') ){
				AlertService.error($filter('translate')('gatewayApp.amcSummary.fromDateGreaterThanToDate'));
				vm.valid = false;
				vm.issuePresent = true;
			}
			
			else{
				vm.valid = true;
				vm.issuePresent = false;
				vm.clicked=true;
				vm.selectedPrintorRefresh = angular.copy(vm.freshOrPrintOption);
				clearAllValues();
				AMCSummaryView.getAMCSummaryReport({ from : DateUtils.convertLocalDateToServer(vm.fromDate), to: DateUtils.convertLocalDateToServer(vm.toDate),printorGenerateAfreshOption : vm.selectedPrintorRefresh}, 
						onGetAMCSummarySuccess, onGetAMCSummaryFailure);  		
			}

		}
		function onGetAMCSummarySuccess(result){
			vm.amcSummaryDetails = result;
			vm.clicked=false;
		}
		function onGetAMCSummaryFailure(error){
			vm.clicked=false;
		}

		function logScreenAccess(){
			ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
		}

		//this method is used to set default value to both the from and to date and financial year
		function setDefaultValue(value){

			if(value == 'PrintGeneratedInvoice'){
				vm.allFinancialYears = [];
				if(vm.configSettings.billingEndDate!=null && vm.configSettings.billingEndDate !=""){
					vm.allFinancialYears.push(angular.copy(vm.financialYears[0]));	//temporary
				}
				vm.allFinancialYears.push(angular.copy(vm.financialYears[1]));
				vm.financialYear =  angular.copy(vm.financialYears[1]);
	

			}else if(value == 'GenerateAfresh'){
				vm.allFinancialYears = angular.copy(vm.financialYears);	
				vm.financialYear = angular.copy(vm.allFinancialYears[0]);
				
			}
			vm.fromDate = DateUtils.convertLocalDateFromServer(angular.copy(vm.financialYear.financialYearStart));
			vm.toDate  = DateUtils.convertLocalDateFromServer(angular.copy(vm.financialYear.financialYearEnd));
			
		}


		vm.onFinacialYearSelection = onFinacialYearSelection;
		function onFinacialYearSelection(value){
			vm.fromDate = DateUtils.convertLocalDateFromServer(angular.copy(value.financialYearStart));
			vm.toDate  = DateUtils.convertLocalDateFromServer(angular.copy(value.financialYearEnd));

		}

		function downloadEInvoice(){
			vm.mimeType = 'application/vnd.ms-excel';
			vm.extension = ".xls"; 
			vm.fileName = vm.eInvoiceChargesfileName;
			AMCSummaryView.downloadEInvoiceExcel({ from : DateUtils.convertLocalDateToServer(vm.fromDate), to: DateUtils.convertLocalDateToServer(vm.toDate),financialYearId :vm.financialYear.id}, processResponse );


         }

		function exportDataToFile(fileType){

			vm.fileName = vm.amcSummaryfileName;
			if( vm.amcSummaryDetails !=null &&  vm.amcSummaryDetails != undefined && vm.amcSummaryDetails.headerList.length > 0){
				if(fileType == 'csv'){
					vm.mimeType = 'text/csv';
					vm.extension =  ".csv";  
					AMCSummaryView.exportAMCSummaryCsv({freshOrPrintOption:vm.selectedPrintorRefresh },vm.amcSummaryDetails, processResponse );
				}
				else if(fileType == 'xls'){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.extension = ".xls";  
					AMCSummaryView.exportAMCSummaryExcel({freshOrPrintOption:vm.selectedPrintorRefresh },vm.amcSummaryDetails, processResponse );
				}
				else if(fileType == 'pdf'){
					vm.mimeType = 'application/pdf';
					vm.extension = ".pdf";  
					AMCSummaryView.exportAMCSummaryPdf({freshOrPrintOption:vm.selectedPrintorRefresh },vm.amcSummaryDetails , processResponse );
				}

			}
		}

		function processResponse(result){        	  
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
			vm.baseString =   vm.fileName + moment().format( vm.reportFileTimestampFormat ) +  vm.extension; 

			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}


		$scope.$watch('vm.freshOrPrintOption',function(value){
			if(value!= undefined && value!=null ){
				setDefaultValue(value);
				
			}
		
		});
		
		$scope.$watch('vm.financialYear',function(value){
			if(value!= undefined && value!=null ){
				onFinacialYearSelection(value);
			}
			vm.eInvoiceDisable = true;
		
		});
		
		function clearAllValues(){
			vm.amcSummaryDetails = null;
			$scope.filterText = null;
			$scope.filterTextSummary = null;
		}
		

	}
})();
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('AMCSettingsEditController', AMCSettingsEditController);

    AMCSettingsEditController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','AMCSettings','entity','DateUtils','Workflow'];

     function AMCSettingsEditController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,AMCSettings,entity,DateUtils,Workflow) {
        var vm = this;
        vm.amcSetting=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        $scope.showApproveRejectButton=false;
        $scope.showDiscardButton = false;
    	$scope.showResubmitButton=false;
        vm.resubmitAMC = resubmitAMC;
        vm.globalValues = GlobalValues;
        vm.discardAMC = discardAMC;
        vm.rejectAMC= rejectAMC;
        vm.approveAMC= approveAMC;
        vm.viewMode=false;
        vm.showEffectiveFrom=false;
        vm.financialYear = vm.globalValues.getFinancialYear().description;
        vm.noOfDecimals = vm.globalValues.getNumberOfDecimalsForAmount();
        
        $scope.showButton = false;
        vm.orgId = vm.globalValues.getOrgId();
        
        $scope.$watch('vm.bank', function(value){
           	if(value!=null && value!=undefined){
           		vm.effectiveFrom = new Date(vm.bank.dateOfJoining);
           		vm.showEffectiveFrom = true;
           	}
           });
       
           
        if(workflowSharedService.viewFrom == 'amcSettings'){
        	vm.amcSetting=entity;
        	vm.bank = vm.amcSetting.bank;
        	$scope.showButton = true;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'amcSettingtodolist_resubmit') {
        	vm.amcSetting =  angular.fromJson($rootScope.payload);
        	vm.bank = vm.amcSetting.bank;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=true;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'amcSettings_todolist_checker') {
        	vm.amcSetting =  angular.fromJson($rootScope.payload); 
        	vm.bank = vm.amcSetting.bank;
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = true;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom == 'amcSettings_todolist_maker') {
        	vm.amcSetting =  angular.fromJson($rootScope.payload); 
        	vm.bank = vm.amcSetting.bank;
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = true;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom=='amcSettings_auditlog'){
        	vm.amcSetting =  angular.fromJson($rootScope.payload); 
        	vm.bank = vm.amcSetting.bank;
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
        else if(workflowSharedService.viewFrom=='amc_import_auditlog'){
        	
        	vm.amcSetting =  angular.fromJson($rootScope.payload);   
        	
        	vm.effectiveFrom = new Date(vm.amcSetting.amcSettings.bank.dateOfJoining);
        	vm.bank=vm.amcSetting.amcSettings.bank;
        	
        	vm.amcSetting.charges = vm.amcSetting.amcSettings.charges;
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
		

        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	
        	vm.amcSetting.effectiveFrom = DateUtils.convertLocalDateToServer(vm.effectiveFrom);
        	vm.amcSetting.financialYear = vm.globalValues.getFinancialYear();
        	vm.amcSetting.bank = vm.bank;
        	
        	if (vm.amcSetting.id != null) {
				AMCSettings.update({
					"orgId" : GlobalValues.getOrgId()
				}, vm.amcSetting, onSaveSuccess, onSaveError);
			} else {
				AMCSettings.save({
					"orgId" : GlobalValues.getOrgId()
				}, vm.amcSetting, onSaveSuccess, onSaveError);
			}
        	
         }
      
       
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	
        	vm.clicked = false;
        }
        function resubmitAMC() {
        	
        	vm.amcSetting.effectiveFrom = DateUtils.convertLocalDateToServer(vm.effectiveFrom);
        	vm.amcSetting.financialYear = vm.globalValues.getFinancialYear();
        	vm.amcSetting.bank = vm.bank;
        	
        	AMCSettings.resubmit({"taskId" : $rootScope.taskID}, vm.amcSetting, onResubmitSuccess, onResubmitError);
        	
       		
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {
        	vm.clicked = false;
        }
        
        function approveAMC() { 
        	AMCSettings.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectAMC() { Workflow.rejectTask($rootScope.taskID); }

        function discardAMC() {
        	AMCSettings.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }
        
        

       
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('amc-settings', {
            parent: 'entity',
            url: '/amc-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.amcSettings.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/amc-settings/amc-settings.html',
                    controller: 'AMCSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('amcSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
       
        .state('amc-settings-new', {
            parent: 'amc-settings',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/amc-settings/amc-settings-dialog.html',
                    controller: 'AMCSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	                           	
                             
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('amc-settings-edit', {
            parent: 'amc-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/amc-settings/amc-settings-dialog.html',
                    controller: 'AMCSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	
                            	 entity: ['AMCSettings', 'GlobalValues', function(AMCSettings, GlobalValues) {
                                     return AMCSettings.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('amc-settings-todolist', {
            parent: 'dashboard',
            url: '/amcSettings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/amc-settings/amc-settings-dialog.html',
                    controller: 'AMCSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('amc-settings', null, { reload: 'amc-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('amc-todolist-resubmit', {
            parent: 'dashboard',
            url: '/amcSettingsEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/amc-settings/amc-settings-dialog.html',
                    controller: 'AMCSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('amc-settings', null, { reload: 'amc-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('amc-auditLog', {
            parent: 'audit-log',
            url: '/amcSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/amc-settings/amc-settings-dialog.html',
                    controller: 'AMCSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('amc-settings', null, { reload: 'amc-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('amc-historyReport', {
            parent: 'history-report',
            url: '/amcettingsHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/amc-settings/amc-settings-dialog.html',
                    controller: 'AMCSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('amc-settings', null, { reload: 'amc-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('AMCSettings', AMCSettings);

    AMCSettings.$inject = ['$resource'];

    function AMCSettings ($resource) {
        var resourceUrl =  'api/amc-settings/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/amc-settings'
        	 },
         	
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
             'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/amc-settings/orgId/:orgId',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
        	
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/amc-settings/orgId/:orgId',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/amc-settings',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'amcSettings'
        })
        
        .controller('AMCSettingsController', AMCSettingsController);

    AMCSettingsController.$inject = ['$scope', '$state', 'AMCSettings', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout'];

    function AMCSettingsController($scope, $state, AMCSettings , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout) {
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.AMC_SETTINGS;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "amcSettings";
        vm.bank = GlobalValues.getBank();
        $scope.refresh=refresh;
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        
        vm.launch=launch;
        function launch() {
        	$state.go("amc-settings-new");
        }
        
        
        vm.permitAMCSettingsAddEntityAction = EntityPermissions.hasPermission('AMCSettings.CREATE');
        vm.permitAMCSettingsImportEntityAction = EntityPermissions.hasPermission('AMCSettings.IMPORT');
        vm.permitAMCSettingsEditEntityAction = EntityPermissions.hasPermission('AMCSettings.EDIT');
        
        logScreenAccess();
        loadAll();

       function loadAll() {
    	   
    	   AMCSettings.query(function(result) {
               vm.amcSettings = result;                
           });
    	 
        }      
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('AddRemarksController', AddRemarksController);

    AddRemarksController.$inject = ['$scope', '$rootScope', '$state',  '$uibModalInstance', '$stateParams'];

    function AddRemarksController($scope, $rootScope, $state, $uibModalInstance, $stateParams) {
        var vm = this;
        vm.clear=clear;
        vm.add=add;
        $scope.clicked=false;
        vm.remarkList = [''];
        vm.addAdditionalRemark=addAdditionalRemark;
        vm.nonAllowedCharacters=/^[\n,]/;
		vm.removeAdditionalRemark=removeAdditionalRemark;
        vm.remarksValidation=remarksValidation;
        vm.remarks = $stateParams.remarks;

        checkAndFillRemark()
        vm.remarkDTO={};
        defaultRemarkvalue();
        vm.maxRemark=4;
        function defaultRemarkvalue(){
            vm.remarkDTO.remarks1="";
            vm.remarkDTO.remarks2=null;
            vm.remarkDTO.remarks3=null;
            vm.remarkDTO.remarks4=null;
        }
        function checkAndFillRemark() {
            if (vm.remarks != undefined && vm.remarks != null && vm.remarks != '') {
                vm.remarkList = [];
                if (vm.remarks.remarks1 !== null) {
                    vm.remarkList.push(vm.remarks.remarks1);
                }else{
                    vm.remarkList = [''];
                }
                
                if (vm.remarks.remarks2 !== null) {
                   vm.remarkList.push(vm.remarks.remarks2);
                }
                
                if (vm.remarks.remarks3 !== null) {
                   vm.remarkList.push(vm.remarks.remarks3);
                }
                
                if (vm.remarks.remarks4 !== null) {
                   vm.remarkList.push(vm.remarks.remarks4);
                }
            } 
        }

        function addAdditionalRemark(){
        if (vm.remarkList.length <= vm.maxRemark-1) { 
           vm.remarkList.push('');
        }

        }

        function removeAdditionalRemark (index){
           vm.remarkList.splice(index, 1 );
        };

        function remarksValidation(value, index) {
            if (value != null && value != undefined && value !='') {
                value = value.replace(/[^a-zA-Z0-9-\s.]/g,"");
               vm.remarkList[index]= value;
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function add() {
            setRemarksvalues()
            $rootScope.remarks =  vm.remarkDTO;
            $scope.$emit('addRemarks');
            $uibModalInstance.close();
        }

        function setRemarksvalues(){
            angular.forEach( vm.remarkList, function(value, index){
                    if (index >= 0 && index <= 3) {
                       vm.remarkDTO['remarks' + (index + 1)] = value;
                    }
                });

        }
    }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trading-dashboard', {
            parent: 'entity',
            url: '/trading-dashboard',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.dashboard.trading" | translate }}',
                parent: 'entity'
            },
            views: {
                'content@': {
                    templateUrl: 'app/dashboard/3/dashboard.html',
                    controller: 'TradingPageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('error');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TradingPageController', TradingPageController);

    TradingPageController.$inject = ['$scope', '$rootScope', 'Principal', 'LoginService', '$sessionStorage', '$state', 'GlobalValues', 
    		'EntityPermissions', 'Notifications', '$sce', '$filter', 'Branch', 'StaticLookUp', 'BankRegistration','Country', 'workflowSharedService','$window',
    		'UserProfile', 'CurrencyPair', 'MarketWatch', 'Market', 'SwapQuotes', 'DefaultMarket', 'CustomerRegistration', 'CustomerBankRelationshipReport',
    		'$timeout', 'OrderStatusDetails', 'LimitSettings', 'IntradayMarket', 'DateUtils', 'MessageBox','User','ErrorMessages', 'WebSocket'];

    function TradingPageController ($scope, $rootScope, Principal, LoginService, $sessionStorage, $state, GlobalValues, 
    			EntityPermissions, Notifications, $sce, $filter, Branch, StaticLookUp, BankRegistration, Country, workflowSharedService,$window,
    			UserProfile, CurrencyPair, MarketWatch, Market, SwapQuotes, DefaultMarket, CustomerRegistration, CustomerBankRelationshipReport,
    			$timeout, OrderStatusDetails, LimitSettings, IntradayMarket, DateUtils, MessageBox,User,ErrorMessages, WebSocket) {
        var vm = this;
        
        
        vm.globalValues = GlobalValues;
        vm.account = vm.globalValues.getUser();
        subscribeWebSocket();
        //DefaultMarket.marketInstruments(onGetInstrumentSuccess, onGetInstrumentFailure);
		getInstrumentMatchedCurrencypair();
        bootUp();
        function subscribeWebSocket(){
        	WebSocket.subscribeWebSocket(vm.account.id);
        }
        
        var orderFeedEvent = $rootScope.$on("orderFeed", function(event, object){
        	//$state.reload();
        	
        	if(object.topic=='PendingOrderUpdate'){
 				var pendingOrder = object.object;
 				pendingOrdersFeed(pendingOrder);
 				//$timeout(function(){pendingOrdersFeed(pendingOrder);}, 100);
 				vm.pendingArr.push(pendingOrder);
 			}else if(object.topic=='LimitUpdate'){
 				var limit = object.object;
 				limitUpdateFeed(limit);
 				//$timeout(function(){limitUpdateFeed(limit);}, 100);
 				vm.limitArr.push(limit);
 			}else if(object.topic=='TradeNotification'){
 				var trade = object.object;
 				//$timeout(function(){tradeNotificationHandling(trade);}, 100);
 				//$timeout(function(){frameTradeNotification(trade);}, 100);
 				tradeNotificationHandling(trade);
 				frameTradeNotification(trade);
 				vm.tradeArr.push(trade);
 			}else if(object.topic=='OrderNotification'){
 				var order = object.object;
 				frameOrderNotification(order);
 				//$timeout(function(){frameOrderNotification(order);}, 100);
 				vm.orderArr.push(order);
 			}
        });
        
        var marketFeedEvent = $rootScope.$on("marketFeed", function(event, object){
        	//$state.reload();
        	if(object.topic=='MarketDepth'){
 				var marketDepthDTO = object.object;
 				//$timeout(function(){marketDepthChanges(marketDepthDTO);}, 100);
 				marketDepthChanges(marketDepthDTO);
 			}else if(object.topic=='SessionStatusChange'){
 				var marketSessionSettings = object.object;
 				//$timeout(function(){marketSettingsChanges(marketSessionSettings);}, 100);
 				marketSettingsChanges(marketSessionSettings);
 			}else if(object.topic=='SwapQuoteChange'){
 				var swapQuote = object.object;
 				//$timeout(function(){swapQuoteChanges(swapQuote);}, 100);
 				swapQuoteChanges(swapQuote);
 			}
        });
        
        
        $scope.$on('$destroy', function() {
        	orderFeedEvent();
        	marketFeedEvent();
        });
        

        vm.today = new Date();
        vm.formattedDate = $filter('date')(vm.today, 'ddMMyyyyHHmm');
        vm.downloadData = downloadData;
        
        
		 vm.allTradingBanks=CustomerBankRelationshipReport.query();
	        
	        function convertArrayOfObjectsToCSV(args) {  
	            var result, ctr, keys, columnDelimiter, lineDelimiter, data;

	            data = args.data || null;
	            if (data == null || !data.length) {
	                return null;
	            }

	            columnDelimiter = args.columnDelimiter || ',';
	            lineDelimiter = args.lineDelimiter || '\n';

	            keys = Object.keys(data[0]);

	            result = '';
	            result += keys.join(columnDelimiter);
	            result += lineDelimiter;

	            data.forEach(function(item) {
	                ctr = 0;
	                keys.forEach(function(key) {
	                    if (ctr > 0) result += columnDelimiter;

	                    result += item[key];
	                    ctr++;
	                });
	                result += lineDelimiter;
	            });

	            return result;
	        }
	        
	        $scope.$watch('vm.content', function(value){
	           	if(value!= undefined && value!=null){
	           		
	           		var array = vm.content.split(/\n/);
	           		var tempHeader = array[0].trim();
	           		var headerErr = "Error Message";
	           		var tempHeaderErr = headerErr.trim();
	           		vm.newArray = tempHeader + "," + tempHeaderErr;
	           		
	           		for(var i=1;i<array.length;i++){
	           			
	           			if(array[i]!=""){
	           			vm.orderRequestDTO = array[i].split(',');
	           			if(vm.orderRequestDTO!=null && vm.orderRequestDTO!='' && vm.orderRequestDTO!=""){
	           				vm.orderImport={};
	           				
	           				
	           				vm.importErrorString="";
	           				vm.bankForTrading="";
	           				
	           				validateTradingBankRelationship(vm.orderRequestDTO[13],vm.orderRequestDTO[14],vm.orderRequestDTO[15]);
	           				
	           				if(vm.importErrorString==""){
	           					
	           					vm.orderImport.buySellIndicator=vm.orderRequestDTO[2];
	               				vm.orderImport.activityIndicator=vm.orderRequestDTO[0];
	               				vm.orderImport.typeOfOrder=vm.orderRequestDTO[6];
	               				vm.orderImport.instrumentCode=vm.orderRequestDTO[12];
	               				vm.orderImport.orderAmount = vm.orderRequestDTO[3];
	               				if(vm.orderImport.typeOfOrder!="MRKT"){
	               					vm.orderImport.limitExchangeRate = vm.orderRequestDTO[7];
	               				}
	               				if(vm.orderImport.typeOfOrder=="STLS" || vm.orderImport.typeOfOrder=="TKPR"){
	               					vm.orderImport.stopExchangeRate = vm.orderRequestDTO[8];
	               				}
	               				
	               				if(vm.orderImport.activityIndicator!="PLAC"){
	               					vm.orderImport.orderSequenceNumber=vm.orderRequestDTO[1];
	               					vm.orderImport.oldOrderAmount=vm.orderRequestDTO[19];
	               				}
	               				
	               				
	               				angular.forEach(vm.instrumentTypes, function(value){
	               	        		if(value.instrumentCode==vm.orderImport.instrumentCode){
	               		               	vm.orderImport.instrumentId=value.id;
	               	        		}
	               	        	});
	               				fillUploadDTO(vm.orderImport.buySellIndicator,vm.orderImport.activityIndicator,vm.orderImport.typeOfOrder,vm.orderImport.instrumentCode,
	               							vm.orderImport.orderAmount,vm.orderImport.limitExchangeRate,vm.orderImport.stopExchangeRate, vm.orderImport.oldOrderAmount);
	               				
	           				}
	               				
	               				if(vm.importErrorString!=""){
	               					
	               					
	               					
	               					var tempArr = array[i].trim();
	               					var tempErr = vm.importErrorString.trim();
                                    vm.newArray+="\n" + tempArr + "," + tempErr;

	               					
	               				}
	           				
	           			}
	           		}
	           		}
	           		if(vm.importErrorString!=""){
	           			downloadCSV({ filename: "order-import.csv" , input : vm.newArray});
	           		}
	           		
	           		angular.element("input[type='file']").val(null);
	           		vm.content=null;
	           		
	           	}
	           	else{
	           		angular.element("input[type='file']").val(null);
	           		
	           	}
	           })
	           
	           
	           function downloadCSV(args) {  
	        	
			        var data, filename, link;
			        
			        if(args.input==vm.newArray){
			        	  var csv = args.input;
			        }else{
			        	
			        	 var csv = convertArrayOfObjectsToCSV({
					            data: args.input
					        });
			        }
			       
			      
			        if (csv == null)
			        	return;

			        	filename = args.filename || 'export.csv';

			        	var blob = new Blob([csv], {type: "text/csv;charset=utf-8;"});

			        	if (navigator.msSaveBlob)
			        	{ 
			        		navigator.msSaveBlob(blob, filename)
			        	}
			        	else
			        	{
				        	var link = document.createElement("a");
				        	if (link.download !== undefined)
				        	{
		
				        	
					        	var url = URL.createObjectURL(blob);
					        	link.setAttribute("href", url);
					        	link.setAttribute("download", filename);
					        	link.style = "visibility:hidden";
					        	document.body.appendChild(link);
					        	link.click();
					        	document.body.removeChild(link);
				        	}
			        	}
			        	
	        	}
	           
	           
		        function validateTradingBankRelationship(bankMemberNumber, branchCode, customerCode){
		        	
		        	 angular.forEach(vm.allTradingBanks, function(value){
		 		   		if(value.bank.bankMemberNo==bankMemberNumber && value.tradingBranch.branchId==branchCode && value.customer.customerCode==customerCode ){
		 		       		vm.orderImport.branchId=value.tradingBranch.id;
		 		       		vm.orderImport.branchName=value.tradingBranch.branchName;
		 		       		vm.orderImport.branchCode=value.tradingBranch.branchId;
		 		       		vm.orderImport.customerId=value.customer.id;
		 		       		vm.orderImport.customerName=value.customer.customerFirstName;
		 		       		vm.orderImport.customerCode=value.customer.customerCode;
		 		       		vm.orderImport.bankName=value.bank.bankName;
		 		       		vm.orderImport.bankId=value.bank.id;
		 		       		vm.orderImport.bankMemberNumber = value.bank.bankMemberNo;
		 		       		vm.bankForTrading=value.bank;
		 		   		}
		 		   		
		 		   	});
		        	 if(vm.bankForTrading==null || vm.bankForTrading==undefined || vm.bankForTrading==""){
		 		   			vm.importErrorString = vm.importErrorString = "There is no trading relationship for the customer with the bank or branch."
		 		   		}
		        }
	        
	           function fillUploadDTO(buySellFlag, activityIndicator,typeOfOrder,instrumentCode,orderAmount,limitExRate,stopExRate, oldOrderAmount){

		        	var selectedBankSpread = MarketWatch.getDefaultBankSwapQuotes(vm.bankComparativeQuotes, vm.bankForTrading );
		        	if(validateOrderUpload(buySellFlag, typeOfOrder, selectedBankSpread, instrumentCode,orderAmount,limitExRate,stopExRate, activityIndicator, oldOrderAmount)){
		        		
		        		
		    	       	
		    	       	
		    	       	vm.orderImport.dqAmount=vm.orderRequestDTO[4];
		    	       	vm.orderImport.mfAmount=vm.orderRequestDTO[5];
		    	       	
		    	       	vm.orderImport.timeLimitIndicator=vm.orderRequestDTO[9];
		    	       	if(vm.orderImport.timeLimitIndicator=="GTTM"){
		    	       		vm.orderImport.expiryTime=vm.orderRequestDTO[10];
		    	       	}
		    	       	
		    	       	if(vm.orderImport.activityIndicator!="PLAC"){
		    	       		vm.orderImport.revisionTimeStamp=vm.orderRequestDTO[11];
		    	       	}
		    	    	
		    	        vm.orderImport.userId=vm.orderRequestDTO[16];
		    	    	vm.orderImport.retailUserCode = vm.orderRequestDTO[17];
		    	    	vm.orderImport.userEntityOwnerId = vm.orderRequestDTO[18];
		    	    	
		            	vm.orderImport.remarks = vm.remarks;
		            	vm.orderImport.spreadUsed = getSpreadUsed(selectedBankSpread, buySellFlag, instrumentCode);
		            	if(vm.orderImport.typeOfOrder=="MRKT" && vm.orderImport.activityIndicator=="MDFY"){
		            		vm.orderImport.typeOfOrder="LIMT";
		            	}
		
		            	
		            		if(activityIndicator=='PLAC'){
		                		placeOrderRequest(vm.orderImport)
		            		}else if(activityIndicator=='MDFY'){
		            			Market.modifyOrder(vm.orderImport);
		            		}else if(activityIndicator=='CNCL'){
		            			Market.cancelOrder(vm.orderImport);
		            		}
		            	
		        	}else{
		        		vm.importErrorString = vm.importErrorString + vm.errorString;
		        	}       	
	        }
	           
	        
	           
	           function validateOrderUpload(buySellFlag, priceCondtion, selectedBankSpread, instrumentCode,orderAmount,limitExRate,stopExRate,activityIndicator, oldOrderAmount){

	           
        	   if(vm.defaultInstrumentCode=='CASH'){
            		if(buySellFlag=='SELL' || buySellFlag=='MODIFYSELL'){
                    	limitExRateInSpot = getSpotRateForGivenRateAndSpread(limitExRate, selectedBankSpread.cashSpotOfferSpread); 
                    		
            		}else if(buySellFlag=='BUYY' || buySellFlag=='MODIFYBUY'){
                    	limitExRateInSpot = getSpotRateForGivenRateAndSpread(limitExRate, selectedBankSpread.cashSpotBidSpread); 
            		}
            	}else if(vm.defaultInstrumentCode=='TOM'){
                		if(buySellFlag=='SELL' || buySellFlag=='MODIFYSELL'){
                        	limitExRateInSpot = getSpotRateForGivenRateAndSpread(limitExRate, selectedBankSpread.tomSpotOfferSpread);  
                		}else if(buySellFlag=='BUYY' || buySellFlag=='MODIFYBUY'){
                        	limitExRateInSpot = getSpotRateForGivenRateAndSpread(limitExRate, selectedBankSpread.tomSpotBidSpread); 
                		}
                }else{
                	limitExRateInSpot = limitExRate;
                }
        	   
	           	if(!validateOrderAmount(orderAmount)){
	           		return false;
	           	}
	           	
	           	if(!validateLimitCheck(oldOrderAmount, activityIndicator, orderAmount, instrumentCode, buySellFlag)){
	           		
	           		return false;
	           	}
	           	
	           	//orderticksize
	           	//ltp
	           	var orderTickSize = getTickSizeForGivenInstrument(instrumentCode);
	           	var ltp = 0
	           	
	           	if(buySellFlag!='SELLBUY'){
	               	ltp = getLtpForGivenInstrumentAndBuySellFlag(instrumentCode, buySellFlag, selectedBankSpread);
	               	if(!validateLimitExchangeRate(buySellFlag, activityIndicator,priceCondtion, limitExRate,limitExRateInSpot, orderTickSize, ltp, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage)){
	               		return false;
	               	}
	               	if(!validateStopExchangeRate(priceCondtion, buySellFlag, limitExRate, stopExRate, orderTickSize)){
	               		return false;
	               	}
	               	if(!validateSpreadUsed(selectedBankSpread, instrumentCode, buySellFlag)){
	               		return false;
	               	}
	           	}else if(buySellFlag=='SELLBUY'){
	               	var buyLtp = getLtpForGivenInstrumentAndBuySellFlag(instrumentCode, 'BUYY', selectedBankSpread);
	               	var sellLtp = getLtpForGivenInstrumentAndBuySellFlag(instrumentCode, 'SELL', selectedBankSpread);
	               	if(!validateLimitExchangeRate('BUYY', activityIndicator,priceCondtion, limitExRate, limitExRateInSpot, orderTickSize, buyLtp, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage)){
	               		return false;
	               	}
	               	if(!validateLimitExchangeRate('SELL', activityIndicator,priceCondtion, limitExRate, limitExRateInSpot, orderTickSize, sellLtp, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage)){
	               		return false;
	               	}
	               	if(!validateStopExchangeRate(priceCondtion, 'BUYY', limitExRate, stopExRate, orderTickSize)){
	               		return false;
	               	}
	               	if(!validateStopExchangeRate(priceCondtion, 'SELL', limitExRate, stopExRate, orderTickSize)){
	               		return false;
	               	}
	               	if(!validateSpreadUsed(selectedBankSpread, instrumentCode, 'BUYY')){
	               		return false;
	               	}
	               	if(!validateSpreadUsed(selectedBankSpread, instrumentCode, 'SELL')){
	               		return false;
	               	}
	           	}
	           	
	           	return true;
	           }
        
	     function downloadData(){
	    	 
	    	 if(vm.orderArr!=null || vm.orderArr!=undefined || vm.orderArr.length==0){
	    		 downloadCSV({filename : "order_activity" + vm.formattedDate +  ".csv", input : vm.orderArr});

	        		vm.orderArr=[];
	    	 }
	    	 	
	    	 if(vm.pendingArr!=null || vm.pendingArr!=undefined || vm.pendingArr.length==0){
        		downloadCSV({filename : "pending_orders" + vm.formattedDate +  ".csv", input : vm.pendingArr});
        		vm.pendingArr=[];
	    	 }
	    	 if(vm.tradeArr!=null || vm.tradeArr!=undefined || vm.tradeArr.length==0){
        		downloadCSV({filename : "trades" + vm.formattedDate +  ".csv", input : vm.tradeArr});
        		vm.tradeArr=[];
	    	 }
	    	 if(vm.limitArr!=null || vm.limitArr!=undefined || vm.limitArr.length==0){
        		downloadCSV({filename : "limits" + vm.formattedDate +  ".csv", input : vm.limitArr});
        		vm.limitArr=[];
	    	 }
        		
        		
        		
	     }
	           
	           
        /*trading home page*/
        //initializing
        vm.tickerPrice={};
        vm.showPendingOrders = true;
        vm.tickerPrice.retailSpot = 0;
        vm.tickerPrice.ibSpot = 0;
        vm.tickerPrice.retailSpotDifference = 0;
        vm.tickerPrice.ibSpotDifference = 0;
        vm.orderType='SELL';
        vm.selectedInstrument = 'SPOT';
        vm.retailSpotMarketWatch = {};
        vm.orderDTO = {};
        vm.getPendingOrdersReport = getPendingOrdersReport; 
        vm.getLimitUtilisedReport = getLimitUtilisedReport;
        vm.getTradesReport = getTradesReport;
        $rootScope.changeInstrument = changeInstrument;
        vm.changeDefaultPriceCondition = changeDefaultPriceCondition;
        vm.modifyOrder = modifyOrder;
        vm.placeOrder = placeOrder; 
        vm.placeMarketOrder = placeMarketOrder;
        vm.cancelOrder = cancelOrder;
        vm.cancelModifyOrderAction = cancelModifyOrderAction;
        vm.cancelAllOrders = cancelAllOrders;
        vm.marketDepthChanges = marketDepthChanges;
        vm.marketSettingsChanges = marketSettingsChanges;
        vm.addRemarks = addRemarks;
        vm.expandMarketDepth = expandMarketDepth;
        vm.openMarketStatistics = openMarketStatistics;
        vm.orderDTO.activityIndicator = 'PLAC';
        vm.openOrderPreference = openOrderPreference;
        vm.limitChangeRequest = limitChangeRequest;
        vm.getBuyingPower = getBuyingPower;
        vm.getSellingPower = getSellingPower;
        vm.onChangingBankInSwapQuotes = onChangingBankInSwapQuotes;
        vm.softCheckDeviationForLimitExchangeRate = softCheckDeviationForLimitExchangeRate;
        vm.softCheckDeviationForBuyLimitExchangeRate = softCheckDeviationForBuyLimitExchangeRate;
        vm.softCheckDeviationForSellLimitExchangeRate = softCheckDeviationForSellLimitExchangeRate;
        vm.pendingArr=[];
        vm.tradeArr=[];
        vm.limitArr=[];
        vm.orderArr=[];
        
        //initialiize limits
        vm.retailSpotBuyLimit = 0;
        vm.retailSpotSellLimit = 0;
        vm.cashBuyLimit = 0;
        vm.cashSellLimit = 0;
        vm.tomBuyLimit = 0;
        vm.tomSellLimit = 0;

        function onGetInstrumentSuccess(result){
        	vm.instrumentTypes = result;
        	//get tick size for each instrument
        	vm.tickSize = {};
        	angular.forEach(vm.instrumentTypes, function(value){
        		if(value.instrumentCode=='SPOT'){
        			vm.tickSize.spot = value.tickSize;
        		}else if(value.instrumentCode=='CASH'){
        			vm.tickSize.cash = value.tickSize;
        		}else if(value.instrumentCode=='TOM'){
        			vm.tickSize.tom = value.tickSize;
        		}else if(value.instrumentCode=='InterbankSPOT'){
        			vm.tickSize.ibSpot = value.tickSize;
        		}
        	})
        }
        
        function onGetInstrumentFailure(){
        	
        }
        
        //bootUp();
        
        function bootUp(){

        	if(vm.account!=null){
            	//get user specific settings for the logged in user
                //we can get default trading bank, branch and customer for the logged in user from the user preference data.
                //fill the filters of branch and customer with the default trading branch and customer we get it from user preference.
                vm.configSettings = vm.globalValues.getConfigSettings();

        		UserProfile.get({userId: vm.account.id}, onGetUserSpecSettingSuccess, onGetUserSpecSettingFailure)
                //get currency pair and make USDINR default.
                CurrencyPair.query(onGetCurrencyPairSuccess, onGetCurrencyPairFailure);
                
                Market.getLTPForLimits(onGetLtpForLimitSuccess, onGetLtpForLimitFailure);
                
                getStaticDataFromDb();
                
                $scope.noOfRecordsPerPage = 5;
                $scope.page = 1;

        	}
        }
        
        function getStaticDataFromDb(){
        	
            
            //get order status list from db and stored in array for displaying the order status in pending order.
            OrderStatusDetails.getOrderStatusList(onGetOrderStatusListSuccess, onGetOrderStatusListFailure);
            
           if( vm.account.organisation.organisationType.shortName=='CUSTOMER'){
        	   vm.custCode= vm.globalValues.getCustomer().customerCode;
           }
           
           vm.noOfDecimalsForRate = vm.globalValues.getNumberOfDecimalsForRate();
           vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
            
        	
        }
        
        function onGetOrderStatusListSuccess(result){
        	vm.orderStatusList = result;
        }
        
        function onGetOrderStatusListFailure(){
        	
        }
        
        function onGetLtpForLimitSuccess(result){
        	vm.ltpForLimitsForAllInstrument = result;
        	angular.forEach(vm.ltpForLimitsForAllInstrument, function(value){
        		if(value.instrument.instrumentCode=='SPOT'){
        			vm.previousDayClosingPriceForSpot = value.previousDayClosingPrice;
        		}else if(value.instrument.instrumentCode=='InterbankSPOT'){
        			vm.previousDayClosingPriceForIbSpot = value.previousDayClosingPrice;
        		}
        	})
        	
        }
        
        function onGetLtpForLimitFailure(){
        	
        }
        
        function onGetUserSpecSettingSuccess(result){
        	vm.userPreference = result;
        	vm.defaultTradingBank = vm.userPreference.tradingBank;
        	vm.defaultTradingBranch = vm.userPreference.tradingBranch;
        	vm.defaultTradingCustomer = vm.userPreference.tradingCustomer;
        	//fill default values to order value, price condition, instrument to the controls.
        	if(vm.userPreference.userPriceCondition=='STLS' && vm.configSettings.isAllowStopLossOrder!='Yes'){
        		vm.userPreference.userPriceCondition = 'LIMT';
        	}
        	if(vm.userPreference.userPriceCondition=='TKPR' && vm.configSettings.isAllowTakeProfitOrder!='Yes'){
        		vm.userPreference.userPriceCondition = 'LIMT';
        	}
        	fillDefaultValuesToControls();
        	
            vm.currentDate = new Date();
            vm.currentDate = DateUtils.convertLocalDateToServer(vm.currentDate);
        	//get market session settings. to display status. market session settings will be available for SPOT, cash TOM
        	IntradayMarket.getMarketSessionSettings({"currentBusinessDate":vm.currentDate}, onGetMarketSessionSuccess, onGetMarketSessionFailure);
        	
        	getReportsToDisplay();

        }
        
        function onChangingBankInSwapQuotes(bank){
        	vm.defaultTradingBank = bank;
        	if(vm.globalValues.getOrganisation().organisationType.shortName=='CUSTOMER'){
        		CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: bank.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
					vm.defaultTradingBranch = result;
					//fillDefaultValuesToControls();
					vm.tradingBank = vm.defaultTradingBank;
					
					vm.bankFilterForPO = bank;
					vm.bankFilterForLimit = bank;
					vm.bankFilterForTrade = bank;
					vm.branchFilterForPO = result;
					vm.branchFilterForLimit = result;
					vm.branchFilterForTrade = result;
					vm.customerFilterForPO = vm.globalValues.getOrganisation().id;
					vm.customerFilterForLimit = vm.globalValues.getOrganisation().id;
					vm.customerFilterForTrade = vm.globalValues.getOrganisation().id;
					getReportsToDisplay();
				});
        	}
        }

        function onGetUserSpecSettingFailure(){
        	
        }
        
        function onGetCurrencyPairSuccess(result){
        	$rootScope.currencyPairList = result;
        	//make USDINR as default. the first record is USDINR.
        	$rootScope.currencyPair = result[0];
        	/*$rootScope.emit("currencyPair", currencyPair);
        	$rootScope.emit("currencyPairList", currencyPairList);*/
        }
        
        function onGetCurrencyPairFailure(){
        	
        }
        
        function onGetMarketSessionSuccess(result){
        	vm.marketSessionSettings = result;
        	//store session settings in separate variables for each and every instrument
        	setMarketSettings();
        	
        	//get market depth
        	Market.getMarketDepth(onGetMarketDepthSuccess, onGetMarketDepthFailure);
        	
        	//onGetMarketDepthSuccess(vm.marketDepth);
        	//Market.getMarketDepth(onGetMarketDepthSuccess, onGetMarketDepthFailure);
        }
        
        function onGetMarketSessionFailure(){
        	
        }
        
        //set market settings
        function setMarketSettings(){
        	//loop market session settings and get vm.retailSpotMarketSession, vm.cashMarketSession, vm.tomMarketSession..
        	angular.forEach(vm.marketSessionSettings, function(value){
        		if(value.instrumentCode == 'SPOT'){
        			vm.retailSpotMarketSession = value;
        		}else if(value.instrumentCode == 'TOM'){
        			vm.tomMarketSession = value;	
        		}else if(value.instrumentCode == 'CASH'){
        			vm.cashMarketSession = value;
        		}
        	})
        }
        
        //fill default values to controls and variables
        function fillDefaultValuesToControls(){
        	vm.orderDTO = {};
        	//fill order value, price condition, instrument type, order type to controls
        	if(vm.userPreference!=null && vm.userPreference!=undefined){
				vm.orderVolumeSpotMkt = vm.userPreference.userOrderValue;
				vm.orderVolumeCashMkt = vm.userPreference.userOrderValue;
				vm.orderVolumeTomMkt = vm.userPreference.userOrderValue;
				vm.defaultTimeCondition = vm.userPreference.userTimeCondition;

				setDefaultPriceCondition(vm.userPreference.userPriceCondition);

				vm.defaultInstrumentCode = vm.userPreference.userInstrumentCode;
				fillDefaultInstIdForInstCode(vm.defaultInstrumentCode);
				vm.loadBoardInstrumentCode = vm.userPreference.userInstrumentCode;
				$rootScope.loadBoardInstrumentCode = vm.userPreference.userInstrumentCode;
				vm.tradingBank = vm.defaultTradingBank;
				vm.instrumentFilterForPO = vm.userPreference.instrument;
				vm.instrumentFilterForTrade = vm.userPreference.instrument;
				vm.instrumentFilterForLimit = vm.userPreference.instrument;
				vm.selectedInstrument = vm.userPreference.instrument;

				if(vm.account.organisation.organisationType.shortName=='BANK'){
					vm.bankFilterForPO = vm.globalValues.getBank();
					vm.branchFilterForPO = vm.userPreference.tradingBranch;
					vm.customerFilterForPO = vm.userPreference.tradingCustomer;
					vm.bankFilterForTrade = vm.globalValues.getBank();
					vm.branchFilterForTrade = vm.userPreference.tradingBranch;
					vm.customerFilterForTrade = vm.userPreference.tradingCustomer;
					vm.bankFilterForLimit = vm.globalValues.getBank();
					vm.branchFilterForLimit = vm.userPreference.tradingBranch;
					vm.customerFilterForLimit = vm.userPreference.tradingCustomer;
				}else if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
					vm.bankFilterForPO = vm.userPreference.tradingBank;
					vm.branchFilterForPO = vm.userPreference.tradingBranch;
					vm.customerFilterForPO = vm.globalValues.getCustomer();
					vm.bankFilterForTrade = vm.userPreference.tradingBank;
					vm.branchFilterForTrade = vm.userPreference.tradingBranch;
					vm.customerFilterForTrade = vm.globalValues.getCustomer();
					vm.bankFilterForLimit = vm.userPreference.tradingBank;
					vm.branchFilterForLimit = vm.userPreference.tradingBranch;
					vm.customerFilterForLimit = vm.globalValues.getCustomer();
				}

				vm.orderDTO.orderAmount = vm.userPreference.userOrderValue;
				vm.orderDTO.timeLimitIndicator = vm.userPreference.userTimeCondition;
				vm.orderDTO.typeOfOrder = vm.userPreference.userPriceCondition;
				vm.orderDTO.instrumentCode = vm.userPreference.userInstrumentCode;
				vm.showPreOrderConfirmation = vm.userPreference.showPreOrderConfirmation;
				vm.orderDTO.activityIndicator = 'PLAC';
				vm.orderType = 'SELL';
	        	changeOrderType(vm.orderType, vm.orderDTO.activityIndicator);
        	}
        }
        
        function fillDefaultInstIdForInstCode(instCode){
        	angular.forEach(vm.instrumentTypes, function(value){
        		if(value.instrumentCode==instCode){
	               	vm.defaultInstrumentId=value.id;
        		}
        	})
        }
        
        $scope.$watch('vm.defaultInstrumentCode', function(value1){
        	angular.forEach(vm.instrumentTypes, function(value){
        		if(value.instrumentCode==value1 && value.instrumentCode==$rootScope.loadBoardInstrumentCode){
	               	vm.instrumentFilterForPO = value;
	               	vm.instrumentFilterForTrade = value;
	               	vm.instrumentFilterForLimit = value;
	               	vm.selectedInstrument = value;
	               	vm.defaultInstrumentId=value.id;
	               	//change report details according to load board instrument
	               	getReportDetailsForSelectedInstrument(value.id);
        		}
        	})
        })
        
        function changeInstrument(instrumentCode){
        	$rootScope.loadBoardInstrumentCode = instrumentCode;
        	//vm.instrumentFilterForPO = instrumentCode;
        	selectInstrumentInOrderEntry(instrumentCode);
        }
        
        function selectInstrumentInOrderEntry(instrumentCode){
        	if(instrumentCode=='SPOT'){
            	setTimeout(function(){document.getElementById('spotInstrument').click()});
        	}else if(instrumentCode=='CASH'){
            	setTimeout(function(){document.getElementById('cashInstrument').click()});
            	//document.getElementById('cashInstrument').click();
        	}else if(instrumentCode=='TOM'){
            	setTimeout(function(){document.getElementById('tomInstrument').click()});
            	//document.getElementById('tomInstrument').click();
        	}
        }
        
        function setDefaultPriceCondition(priceCondition){
        	vm.defaultPriceCondition = priceCondition;
        	if(!$scope.$$phase){
            	if(priceCondition=='MRKT' || priceCondition=='LIMT'){
                	setTimeout(function(){document.getElementById('limitTab').click()});
                	//document.getElementById('limitTab').click();
            	}else if(priceCondition=='STLS'){
                	setTimeout(function(){document.getElementById('stoplossTab').click()});
                	//document.getElementById('stoplossTab').click();
            	}else if(priceCondition=='TKPR'){
                	setTimeout(function(){document.getElementById('takeprofitTab').click()});
                	//document.getElementById('takeprofitTab').click();
            	}
        	}
        }
        
        function changeDefaultPriceCondition(priceCondition){
        	vm.defaultPriceCondition = priceCondition;
        }
        
        function onGetMarketDepthSuccess(result){
        	vm.marketDepth = result;
        	
        	prepareMarketDepthDisplay();
        	

        }
        
        function getReportsToDisplay(){
        	//get limits available for customer and bank and branch
        	//we can derive limits available for each and every instruments here and stored in separate variables to display in market watch..
            var bankId = getBankIdForLoggedInUser();
            var customerId = getCustomerIdForLoggedInUser();
        	if(bankId!=0 && customerId!=0){
        		getLimitsAvailableForAllInstruments(bankId, customerId);
        	}
            	
        	//get report details for selected instrument(to display in report section)
	        //For customer user, get limits available of the customer and default/selected bank. we can get default bank/branch from user specific settings.
	        //For bank/branch user, get limits available of the default/selected  customer for the bank. we can get default customer for bnak/branch user from user specific settings
        	getReportDetailsForSelectedInstrument(vm.selectedInstrument.id);

        }
        
        function getBankIdForLoggedInUser(){
        	var bankId = 0;
        	if(vm.account.organisation.organisationType.shortName=='CLEARCORP'){
        		if(vm.defaultTradingBank!=null){
            		bankId = vm.defaultTradingBank.id;
        		}
        	}else if(vm.account.organisation.organisationType.shortName=='BANK'){
        		bankId = vm.globalValues.getOrganisation().id;
        	}else if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
        		if(vm.defaultTradingBank!=null){
            		bankId = vm.defaultTradingBank.id;
        		}
        	}
        	return bankId;
        }
        
        function getCustomerIdForLoggedInUser(){
        	var customerId = 0;
        	if(vm.account.organisation.organisationType.shortName=='CLEARCORP' || vm.account.organisation.organisationType.shortName=='BANK'){
        		if(vm.defaultTradingCustomer!=null){
            		customerId = vm.defaultTradingCustomer.id;
        		}
        	}else if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
           		customerId = vm.globalValues.getOrganisation().id;
        	}
        	return customerId;
        }
        
        function prepareMarketDepthDisplay(){
        	//get market depth for both retail spot and interbank spot
        	getMarketDepthDetailsForReport();
        	setTimeout(function(){getSwapQuotes();});
        	
        	//set previous ticker price
        	/*var previousTickerPrice = angular.copy(vm.tickerPrice);
        	vm.previousTickerPrice = previousTickerPrice;*/
        	//get ticker price
        	angular.forEach(vm.marketDepth, function(value){
        		var previousTickerPrice = angular.copy(vm.tickerPrice);
            	vm.previousTickerPrice = previousTickerPrice;
            	vm.tickerPrice = MarketWatch.getTickerPrice(value, previousTickerPrice, vm.previousDayClosingPriceForSpot, vm.previousDayClosingPriceForIbSpot);
            	$rootScope.tickerPrice = vm.tickerPrice;
        	//$rootScope.$emit('tickerPrice', vm.tickerPrice);

        	})
        }

        function onGetMarketDepthFailure(){
        	
        }
        
        function getMarketDepthDetailsForReport(){
        	
//        	setTimeout(function(){
//        		var existingSpotMarketDepth = angular.copy(vm.retailSpotMarketDepth);
//            	//get market depth for SPOT
//            	existingSpotMarketDepth = MarketWatch.getRetailSpotMarketDepth(vm.marketDepth);
            	
            	vm.retailSpotMarketDepth = MarketWatch.getRetailSpotMarketDepth(vm.marketDepth);
            	
            	if(vm.retailSpotMarketDepth!=null && vm.retailSpotMarketDepth!=undefined){
            		getRetailSpotMarketWatch();
            	}

            	var existingIbSpotMarketDepth = vm.ibSpotMarketDepth;
            	//get market depth for IB SPOT
            	existingIbSpotMarketDepth = MarketWatch.getIBSpotMarketDepth(vm.marketDepth);
            	vm.ibSpotMarketDepth = existingIbSpotMarketDepth;
            	
            	if(vm.ibSpotMarketDepth!=null && vm.ibSpotMarketDepth!=undefined){
                	//get ibSpotMarketWatch
            		var existingIbSpotMarketWatch = vm.ibSpotMarketWatch;
            		existingIbSpotMarketWatch = MarketWatch.getIBSpotMarketWatch(vm.ibSpotMarketDepth);
            		vm.ibSpotMarketWatch = existingIbSpotMarketWatch;
            	}
//            	$scope.$apply();
//        	}, 100)
        }

        function getRetailSpotMarketWatch(){
        	var existingSpotMarketWatch = vm.retailSpotMarketWatch;
        	//get retailSpot market watch
        	existingSpotMarketWatch = MarketWatch.getRetailSpotMarketWatch(vm.retailSpotMarketDepth);
        	vm.retailSpotMarketWatch = existingSpotMarketWatch;
        	if(vm.retailSpotMarketWatch!=null && vm.retailSpotMarketWatch!=undefined){
            	//get swap quotes
            	//getSwapQuotes()
        	}
        }
        
        function getSwapQuotes(){
        	
            //if the user is customer user, get spread for the banks in which the customer has relationship with.
            //if the user is bank/branch user, get spread for that particular bank.
        	if(vm.account.organisation.organisationType.shortName=='CLEARCORP'){
            	SwapQuotes.getSwapQuotesForAllBanks(onGetSwapQuotesSuccess, onGetSwapQuotesFailure);
        	}else if(vm.account.organisation.organisationType.shortName=='BANK'){
            	SwapQuotes.getSwapQuotesForGivenBank({bankId: vm.account.organisation.id}, onGetSwapQuotesSuccess, onGetSwapQuotesFailure);
        	}else if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
            	SwapQuotes.getSwapQuotesForGivenCustomer({customerId: vm.account.organisation.id}, onGetSwapQuotesSuccess, onGetSwapQuotesFailure);
        	}
        }
        
    	function onGetSwapQuotesSuccess(result){
        	//result will be list of swap quotes for the bank(s)
        	//if result length is 1, then that is default bank for that user(customer user) and for bank/branch user, the result length will be 1. 
        	if(result.length>0){
        		//get bank swap quotes array to display in the bank comparative quotes section
        		vm.bankComparativeQuotes = result;

    			//change swap quotes in home page
        		prepareSwapQuotes();

        	}
        }
    	
    	function onGetSwapQuotesFailure(){
    		
    	}
        
    	function prepareBankComparativeQuotesInPrice(bankQuotesInSpread, retailSpotMarketWatch){
    		vm.bankQuotesInPrice = [];
    		angular.forEach(bankQuotesInSpread, function(value){
    			var bankQuotesInPriceValue = {};
    			//prepare bank quotes in price
    			bankQuotesInPriceValue = MarketWatch.getBankSwapQuotesInPrice(value, retailSpotMarketWatch);
    			vm.bankQuotesInPrice.push(bankQuotesInPriceValue);
    		})
    		
    	}
    	
    	function getBestSpreadRates(bankComparativeQuotes){
    		
    		vm.bestCashSpotBidSpread = Math.min.apply(Math,bankComparativeQuotes.map(function(item){return item.cashSpotBidSpread;}).filter(function(val){return val !== null}));
    		vm.bestCashSpotOfferSpread = Math.min.apply(Math,bankComparativeQuotes.map(function(item){return item.cashSpotOfferSpread;}).filter(function(val){return val !== null}));
    		vm.bestTomSpotBidSpread = Math.min.apply(Math,bankComparativeQuotes.map(function(item){return item.tomSpotBidSpread;}).filter(function(val){return val !== null}));
    		vm.bestTomSpotOfferSpread = Math.min.apply(Math,bankComparativeQuotes.map(function(item){return item.tomSpotOfferSpread;}).filter(function(val){return val !== null}));
    	}
    	
    	function onGetDefaultTradingBankSpreadSuccess(){
			//vm.defaultBankSpread = result;
    		
        	//get cash and tom market watch
			//getCashAndTomMarketWatch(vm.retailSpotMarketDepth, vm.defaultBankSpread);
			getCashAndTomMarketWatch(vm.retailSpotMarketWatch, vm.defaultBankSpread);
        	
        	
    	}
    	
    	function getCashAndTomMarketWatch(spotMarketWatch, bankSpread){
    		vm.cashMarketWatch = MarketWatch.getMarketWatchForGivenInstrument(spotMarketWatch, bankSpread, 'CASH');
    		vm.tomMarketWatch = MarketWatch.getMarketWatchForGivenInstrument(spotMarketWatch, bankSpread, 'TOM');
    	}
    	
    	function onGetDefaultTradingBankSpreadFailure(){
    		
    	}
    	
    	function onCashMarketWatchSuccess(result){
    		vm.cashMarketWacth = result;
    	}
    	
    	function onTomMarketWatchSuccess(result){
    		vm.tomMarketWacth = result;
    	}
    	
    	function onTomMarketWatchFailure(){
    		
    	}
    	
        function getLimitsAvailableForAllInstruments(bankId, customerId){
            //For customer user, get limits available of the customer and default/selected bank.
            //For bank/branch user, get limits available of the default/selected  customer for the bank.
            LimitSettings.getLimitsAvailableForAllInstruments({bankId: bankId, customerId: customerId}, onGetLimitsAvailableSuccess, onGetLimitsAvailableFailure);
        }
        
        function onGetLimitsAvailableSuccess(result){
        	//this is for market watch section
        	vm.limitsAvailableForAllInstrument = result;
        	if(result!=null && result!=undefined){
        		if(result.length>0){
        			if(result[0].instrumentCode=='ALL'){
        				vm.limitInstrumentCode = 'ALL';
        			}else{
        				vm.limitInstrumentCode = 'INDIVIDUAL';
        			}
        		}else{
        			fillZeroIfLimitIsNotDefined();
        		}
        	}else{
        		fillZeroIfLimitIsNotDefined();
    		}
        	//we can get limits for the instrument(spot, cash, tom or all) and limit type(gross, gross buy, gross sell, net).
        	angular.forEach(vm.limitsAvailableForAllInstrument, function(value){
        		//get limits for each instrument and assign it to separate variables to display in market watch
        		getLimitsForEachInstrument(value);
        	})	
        }
        
        function onGetLimitsAvailableFailure(){
        	
        }
        
        function fillZeroIfLimitIsNotDefined(){
        	vm.retailSpotBuyLimit = 0;
			vm.retailSpotSellLimit = 0;
			vm.cashBuyLimit = 0;
			vm.cashSellLimit = 0;
			vm.tomBuyLimit = 0;
			vm.tomSellLimit = 0;
        }
        
        function fillZeroIfLimitIsNotDefinedForInstrumentCode(instrumentCode){
        	if(instrumentCode=='SPOT'){
            	vm.retailSpotBuyLimit = 0;
    			vm.retailSpotSellLimit = 0;
        	}else if(instrumentCode=='CASH'){
    			vm.cashBuyLimit = 0;
    			vm.cashSellLimit = 0;
        	}else if(instrumentCode=='TOM'){
    			vm.tomBuyLimit = 0;
    			vm.tomSellLimit = 0;
        	}else if(instrumentCode=='ALL'){
            	vm.retailSpotBuyLimit = 0;
    			vm.retailSpotSellLimit = 0;
    			vm.cashBuyLimit = 0;
    			vm.cashSellLimit = 0;
    			vm.tomBuyLimit = 0;
    			vm.tomSellLimit = 0;
        	}
        }
        
        function getLimitsForEachInstrument(limit){
        	vm.limitType = limit.limitType;
        	if(limit.instrumentCode=='SPOT'){
    			vm.retailSpotBuyLimit = getBuyingPower(limit);
    			vm.retailSpotSellLimit = getSellingPower(limit);
    		}else if(limit.instrumentCode=='CASH'){
    			vm.cashBuyLimit = getBuyingPower(limit);
    			vm.cashSellLimit = getSellingPower(limit);
    		}else if(limit.instrumentCode=='TOM'){
    			vm.tomBuyLimit = getBuyingPower(limit);
    			vm.tomSellLimit = getSellingPower(limit);
    		}
        	
        	if(limit.instrumentCode=='ALL' || vm.limitInstrumentCode=='ALL'){
        		var buyingPower = getBuyingPower(limit);
        		var sellingPower =  getSellingPower(limit);
    			vm.retailSpotBuyLimit = buyingPower;
    			vm.retailSpotSellLimit = sellingPower;
    			vm.tomBuyLimit = buyingPower;
    			vm.tomSellLimit = sellingPower;
    			vm.cashBuyLimit = buyingPower;
    			vm.cashSellLimit = sellingPower;
        	}
        }
        
        function getPendingOrdersReport(){
        	var instrumentTypeId = 0;
        	if(vm.instrumentFilterForPO!=null && vm.instrumentFilterForPO!=undefined){
        		instrumentTypeId = vm.instrumentFilterForPO.id;
        		vm.pendingOrderInstrumentCode = 'ALL';
        	}

        	getPendingOrderReportForInstrument(instrumentTypeId);
        }
        
        function getPendingOrderReportForInstrument(instrumentTypeId){
        	var bankId = getBankIdForReportFilters('PO');
        	var branchId = getBranchIdForReportFilters('PO');
        	var customerId = getCustomerIdForReportFilters('PO');
            var currencyPairId = getCurrencyPairIdForReportFilters('PO');

        	if(vm.account.organisation.organisationType.shortName=='CLEARCORP'){
        		getPendingOrders(bankId, branchId, customerId,instrumentTypeId,currencyPairId);
        	}else if(vm.account.organisation.organisationType.shortName=='BANK' && vm.globalValues.getEntityOwnerType().shortName!='Branch'){
            	if(bankId!=0){
            		getPendingOrders(bankId, branchId, customerId,instrumentTypeId,currencyPairId);
            	}
        	}else if(vm.account.organisation.organisationType.shortName=='BANK' && vm.globalValues.getEntityOwnerType().shortName=='Branch'){
            	if(bankId!=0 && branchId!=0){
            		getPendingOrders(bankId, branchId, customerId,instrumentTypeId,currencyPairId);
            	}
        	}else if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
            	if(bankId!=0 && branchId!=0 && customerId!=0){
            		getPendingOrders(bankId, branchId, customerId,instrumentTypeId,currencyPairId);
            	}
        	}
        }
        
        function getPendingOrders(bankId, branchId, customerId, instrumentId,currencyPairId){
        	
    		OrderStatusDetails.getPendingOrders({bankId: bankId, branchId: branchId, customerId: customerId,  instrumentId: instrumentId, currencyPairId: currencyPairId}, onGetPendingOrdersSuccess, onGetPendingOrdersFailure);
        	
        }

        function onGetPendingOrdersSuccess(result){
        	vm.pendingOrders = result;
        	angular.forEach(vm.pendingOrders, function(value, index){
        		angular.forEach(vm.orderStatusList, function(orderStatus){
        			if(value.orderStatusId == orderStatus.id){
        				vm.pendingOrders[index].orderStatus = orderStatus.name;
        			}
        			value.expiryTime=moment(value.expiryTime,'YYYYMMDDHHmmss').format();
        		})
        	})
        }
        
        function onGetPendingOrdersFailure(){
        	
        }
        
        function getTradesReport(){
        	var instrumentTypeId = 0;
        	if(vm.instrumentFilterForTrade!=null && vm.instrumentFilterForTrade!=undefined){
        		instrumentTypeId = vm.instrumentFilterForTrade.id;
        		vm.tradeInstrumentCode = 'ALL';
        	}
        	
        	getTradesReportForInstrument(instrumentTypeId);
        }
        
        function getTradesReportForInstrument(instrumentTypeId){
        	var bankId = getBankIdForReportFilters('Trade');
        	var branchId = getBranchIdForReportFilters('Trade');
        	var customerId = getCustomerIdForReportFilters('Trade');
			var currencyPairId = getCurrencyPairIdForReportFilters('PO');

        	if(vm.account.organisation.organisationType.shortName=='CLEARCORP'){
        		getTrades(bankId, branchId, customerId, instrumentTypeId);
        	}else if(vm.account.organisation.organisationType.shortName=='BANK' && vm.globalValues.getEntityOwnerType().shortName!='Branch'){
            	if(bankId!=0){
            		getTrades(bankId, branchId, customerId, instrumentTypeId,currencyPairId);
            	}
        	}else if(vm.account.organisation.organisationType.shortName=='BANK' && vm.globalValues.getEntityOwnerType().shortName=='Branch'){
            	if(bankId!=0 && branchId!=0){
            		getTrades(bankId, branchId, customerId, instrumentTypeId,currencyPairId);
            	}
        	}else if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
            	if(bankId!=0 && branchId!=0 && customerId!=0){
            		getTrades(bankId, branchId, customerId, instrumentTypeId,currencyPairId);
            	}
        	}
        }
        
        function getTrades(bankId, branchId, customerId, instrumentId,currencyPairId){
        	
        	OrderStatusDetails.getTradesForSelectedInstrument({bankId: bankId, branchId: branchId, customerId: customerId,  instrumentId: instrumentId, currencyPairId: currencyPairId}, onGetTradesSuccess, onGetTradesFailure);
        	
        }
        
        function onGetTradesSuccess(result){
        	
        	angular.forEach(result,function(value){
        		value.tradeTime=moment(value.tradeTime,'YYYYMMDDHHmmss.SSSSSSSSS').format();
        	});
        	vm.trades = result;
        	
        }
        
        function onGetTradesFailure(){
        	
        }
        
        function getLimitUtilisedReport(){
        	var instrumentTypeId = 0;
        	if(vm.instrumentFilterForLimit!=null && vm.instrumentFilterForLimit!=undefined){
        		instrumentTypeId = vm.instrumentFilterForLimit.id;
        		vm.limitInstrumentCode = 'ALL';
        	}

        	getLimitUtilisedReportForInstrument(instrumentTypeId);
        	
        }
        
        function getLimitUtilisedReportForInstrument(instrumentTypeId){
        	var bankId = getBankIdForReportFilters('Limit');
        	var branchId = getBranchIdForReportFilters('Limit');
        	var customerId = getCustomerIdForReportFilters('Limit');
        	if(vm.account.organisation.organisationType.shortName=='CLEARCORP'){
        		getLimitsAvailable(bankId, branchId, customerId,instrumentTypeId);
        	}else if(vm.account.organisation.organisationType.shortName=='BANK' && vm.globalValues.getEntityOwnerType().shortName!='Branch'){
            	if(bankId!=0){
            		getLimitsAvailable(bankId, branchId, customerId,instrumentTypeId);
            	}
        	}else if(vm.account.organisation.organisationType.shortName=='BANK' && vm.globalValues.getEntityOwnerType().shortName=='Branch'){
            	if(bankId!=0 && branchId!=0){
            		getLimitsAvailable(bankId, branchId, customerId,instrumentTypeId);
            	}
        	}else if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
            	if(bankId!=0 && branchId!=0 && customerId!=0){
            		getLimitsAvailable(bankId, branchId, customerId,instrumentTypeId);
            	}
        	}
        }
        
        function getLimitsAvailable(bankId, branchId, customerId, instrumentId){
        	
        	LimitSettings.getLimitUtilsationDetailsForInstrument({bankId: bankId, branchId: branchId, customerId: customerId,  instrumentId: instrumentId}, onGetLimitsSuccess, onGetLimitsFailure);

        }
        
        function onGetLimitsSuccess(result){
        	vm.limitsAvailableForSelectedInstrument = result;
        }
        
        function onGetLimitsFailure(){
        	
        }
        
        //place market order
        function placeMarketOrder(buySellFlag, orderVolume, instrumentType, instrumentId){
        	vm.orderDTO.typeOfOrder = 'MRKT';
        	vm.orderDTO.activityIndicator = 'PLAC';
        	vm.orderDTO.instrumentCode = instrumentType;
        	vm.orderDTO.buySellIndicator = buySellFlag;
        	vm.orderDTO.orderAmount = parseFloat(orderVolume.replace(/,/g, ''));
        	vm.orderDTO.instrumentId = instrumentId;
        	vm.orderDTO.timeLimitIndicator = 'DAYY';

        	//fill bank, branch, customer details into order request dto
        	fillBankBranchCustomerDetails()
        	
        	vm.orderDTO.customerName = vm.globalValues.getCustomer().customerFirstName;
        	vm.orderDTO.userId = vm.globalValues.getUserId();
        	vm.orderDTO.retailUserCode = vm.globalValues.getUser().login;
        	vm.orderDTO.userEntityOwnerId = vm.globalValues.getEntityOwnerTypeId();
        	vm.orderDTO.limitExchangeRate = 0;
        	vm.orderDTO.stopExchangeRate = 0;
        	var selectedBankSpread = MarketWatch.getDefaultBankSwapQuotes(vm.bankComparativeQuotes, vm.tradingBank);
        	vm.orderDTO.spreadUsed = getSpreadUsed(selectedBankSpread, buySellFlag, instrumentType);

        	if(validateOrder(buySellFlag,vm.orderDTO.typeOfOrder, selectedBankSpread, instrumentType, vm.orderDTO.activityIndicator)){
            	if(vm.userPreference.showPreOrderConfirmation=='yes'){
                	$rootScope.orderDTO = vm.orderDTO;
                	$state.go('pre-order-confirmation', {closeTime: '', showPreOrderConfirmation: vm.userPreference.showPreOrderConfirmation});
            	}else{
            		//send order request to server
            		Market.placeOrder(vm.orderDTO);
            	}
        	}else{
        		MessageBox.openMessageBox("Alert", vm.errorString, "Ok", "homepage");
        	}
        }
        
        //place/modify/cancel order 
        function placeOrder(buySellFlag, activityIndicator){
        	var selectedBankSpread = MarketWatch.getDefaultBankSwapQuotes(vm.bankComparativeQuotes, vm.tradingBank);
        	if(validateOrder(buySellFlag, vm.defaultPriceCondition, selectedBankSpread, vm.defaultInstrumentCode, activityIndicator)){
            	if(activityIndicator=='MDFY' && vm.defaultPriceCondition=='MRKT'){
            		vm.defaultPriceCondition = 'LIMT';
            	}
        		if(activityIndicator=='PLAC'){
        			vm.orderDTO.activityIndicator = activityIndicator;
                	vm.orderDTO.typeOfOrder = vm.defaultPriceCondition;
                	vm.orderDTO.instrumentCode = vm.defaultInstrumentCode;
                	vm.orderDTO.instrumentId = vm.defaultInstrumentId;
                	vm.orderDTO.buySellIndicator = buySellFlag;
                	vm.orderDTO.timeLimitIndicator = vm.userPreference.userTimeCondition;
        		}

            	//fill bank, branch, customer details into order request dto
            	fillBankBranchCustomerDetails()
            	
            	vm.orderDTO.userId = vm.globalValues.getUserId();
            	vm.orderDTO.retailUserCode = vm.globalValues.getUser().login;
            	vm.orderDTO.userEntityOwnerId = vm.globalValues.getEntityOwnerTypeId();
            	vm.orderDTO.remarks = angular.copy(vm.remarks);
            	vm.orderDTO.spreadUsed = getSpreadUsed(selectedBankSpread, buySellFlag, vm.defaultInstrumentCode);

            	if(vm.userPreference.showPreOrderConfirmation=='yes' || vm.userPreference.userTimeCondition=='GTTM'){
                	$rootScope.orderDTO = vm.orderDTO;
                	var closeTime = getCloseTimeForInstrumentCode(vm.orderDTO.instrumentCode);
                	$state.go('pre-order-confirmation', {closeTime: closeTime, showPreOrderConfirmation: vm.userPreference.showPreOrderConfirmation});
            	}else{
            		if(activityIndicator=='PLAC'){
                		placeOrderRequest(vm.orderDTO);
            		}else if(activityIndicator=='MDFY'){
            			Market.modifyOrder(vm.orderDTO);
            		}else if(activityIndicator=='CNCL'){
            			Market.cancelOrder(vm.orderDTO);
            		}
            	}
        	}else{
        		MessageBox.openMessageBox("Alert", vm.errorString, "Ok", "homepage");
        	}       	
        }
        
        function fillBankBranchCustomerDetails(){
        	if(vm.globalValues.getEntityOwnerType().shortName=='Bank'){
            	vm.orderDTO.branchCode = vm.tradingBranch.branchId;
            	vm.orderDTO.branchId = vm.tradingBranch.id;
            	vm.orderDTO.branchName = vm.tradingBranch.branchName;
            	vm.orderDTO.bankId = vm.globalValues.getBank().id;
            	vm.orderDTO.bankName = vm.globalValues.getBank().bankName;
            	vm.orderDTO.bankMemberNumber = vm.globalValues.getBank().bankMemberNo;
            	vm.orderDTO.customerId = vm.tradingCustomer.id;
            	vm.orderDTO.customerName = vm.tradingCustomer.customerFirstName;
            	vm.orderDTO.customerCode = vm.tradingCustomer.customerCode;
        	}else if(vm.globalValues.getEntityOwnerType().shortName=='Branch'){
            	vm.orderDTO.branchCode = vm.globalValues.getBranch().branchId;
            	vm.orderDTO.branchId = vm.globalValues.getBranch().id;
            	vm.orderDTO.branchName = vm.globalValues.getBranch().branchName;
            	vm.orderDTO.bankId = vm.globalValues.getBank().id;
            	vm.orderDTO.bankName = vm.globalValues.getBank().bankName;
            	vm.orderDTO.bankMemberNumber = vm.globalValues.getBank().bankMemberNo;
            	vm.orderDTO.customerId = vm.tradingCustomer.id;
            	vm.orderDTO.customerName = vm.tradingCustomer.customerFirstName;
            	vm.orderDTO.customerCode = vm.tradingCustomer.customerCode;
        	}else if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
            	vm.orderDTO.branchCode = vm.tradingBranch.branchId;
            	vm.orderDTO.branchId = vm.tradingBranch.id;
            	vm.orderDTO.branchName = vm.tradingBranch.branchName;
            	vm.orderDTO.bankId = vm.tradingBank.id;
            	vm.orderDTO.bankName = vm.tradingBank.bankName;
            	vm.orderDTO.bankMemberNumber = vm.tradingBank.bankMemberNo;
            	vm.orderDTO.customerId = vm.globalValues.getCustomer().id;
            	vm.orderDTO.customerName = vm.globalValues.getCustomer().customerFirstName;
            	vm.orderDTO.customerCode = vm.globalValues.getCustomer().customerCode;
        	}
        }
        
        function getCloseTimeForInstrumentCode(instrument){
        	if(instrument=='SPOT'){
        		return vm.retailSpotMarketSession.sessionTimingsDTO.closeTime;
        	}else if(instrument=='CASH'){
        		return vm.cashMarketSession.sessionTimingsDTO.closeTime;
        	}else if(instrument=='TOM'){
        		return vm.tomMarketSession.sessionTimingsDTO.closeTime;
        	}
        }
        
        function validateOrder(buySellFlag, priceCondtion, selectedBankSpread, instrumentCode, activityIndicator){

        	vm.errorString = "";
        	
        	if(priceCondtion=='STLS'){
            	if(!isAllowedStopLossOrders()){
            		return false;
            	}
        	}
        	
        	if(priceCondtion=='TKPR'){
            	if(!isAllowedTakeProfitOrders()){
            		return false;
            	}
        	}
        	
        	if(!validateOrderAmount(vm.orderDTO.orderAmount)){
        		return false;
        	}
        	
        	//no need to check limits while cancelling orders
        	if(activityIndicator!='CNCL'){
            	if(!validateLimitCheck(vm.orderDTO.oldOrderAmount, activityIndicator, vm.orderDTO.orderAmount, instrumentCode, buySellFlag)){
            		return false;
            	}
        	}
        	
        	//orderticksize
        	//ltp
        	var orderTickSize = getTickSizeForGivenInstrument(instrumentCode);
        	var ltp = 0
        	
        	if(buySellFlag!='SELLBUY'){
            	ltp = getLtpForGivenInstrumentAndBuySellFlag(instrumentCode, buySellFlag, selectedBankSpread);
            	if(!validateLimitExchangeRate(buySellFlag, activityIndicator, priceCondtion, vm.orderDTO.limitExchangeRate, vm.orderDTO.limitExchangeRateInSpot, orderTickSize, ltp, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise)){
            		return false;
            	}
            	if(!validateStopExchangeRate(priceCondtion, buySellFlag, vm.orderDTO.limitExchangeRate, vm.orderDTO.stopExchangeRate, orderTickSize)){
            		return false;
            	}
            	if(!validateSpreadUsed(selectedBankSpread, instrumentCode, buySellFlag)){
            		return false;
            	}
        	}else if(buySellFlag=='SELLBUY'){
            	var buyLtp = getLtpForGivenInstrumentAndBuySellFlag(instrumentCode, 'BUYY', selectedBankSpread);
            	var sellLtp = getLtpForGivenInstrumentAndBuySellFlag(instrumentCode, 'SELL', selectedBankSpread);
            	if(!validateLimitExchangeRate('BUYY', activityIndicator, priceCondtion, vm.orderDTO.buyLimitExchangeRate, vm.orderDTO.buyLimitExchangeRateInSpot, orderTickSize, buyLtp, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise)){
            		return false;
            	}
            	if(!validateLimitExchangeRate('SELL', activityIndicator, priceCondtion, vm.orderDTO.sellLimitExchangeRate, vm.orderDTO.sellLimitExchangeRateInSpot, orderTickSize, sellLtp, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage, vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise)){
            		return false;
            	}
            	if(!validateStopExchangeRate(priceCondtion, 'BUYY', vm.orderDTO.buyLimitExchangeRate, vm.orderDTO.buyStopExchangeRate, orderTickSize)){
            		return false;
            	}
            	if(!validateStopExchangeRate(priceCondtion, 'SELL', vm.orderDTO.sellLimitExchangeRate, vm.orderDTO.sellStopExchangeRate, orderTickSize)){
            		return false;
            	}
            	if(!validateSpreadUsed(selectedBankSpread, instrumentCode, 'BUYY')){
               		return false;
               	}
               	if(!validateSpreadUsed(selectedBankSpread, instrumentCode, 'SELL')){
               		return false;
               	}
        	}
        	
        	if(!validateSessionStatus(instrumentCode)){
        		return false;
        	}
        	
        	return true;
        }
        
        function isAllowedStopLossOrders(){
        	if(vm.configSettings.isAllowStopLossOrder=='Yes'){
        		return true;
        	}else{
        		vm.errorString = "Stop loss orders are not allowed.";
        		return false;
        	}
        }
        
        function isAllowedTakeProfitOrders(){
        	if(vm.configSettings.isAllowTakeProfitOrder=='Yes'){
        		return true;
        	}else{
        		vm.errorString = "Take profit orders are not allowed.";
        		return false;
        	}
        }
        
        function validateTradingBankStatus(){
        	CustomerBankRelationshipReport.getTradingBanksForCustomer({customerId : vm.globalValues.getCustomer().id}, function(result){
        		if(result.length>0){
        			angular.forEach(result, function(value){
        				if(value.shortName == vm.tradingBank.shortName){
        					return true;
        				}
        			})
        		}
            	return false;
        	})
        }
        
        //validate session status
        function validateSessionStatus(instrumentCode){
        	var status = "";
        	
        	if(instrumentCode == 'SPOT'){
        		status = vm.retailSpotMarketSession.sessionTimingsDTO.status;
        	}else if(instrumentCode == 'CASH'){
        		status = vm.cashMarketSession.sessionTimingsDTO.status;
        	}else if(instrumentCode == 'TOM'){
        		status = vm.tomMarketSession.sessionTimingsDTO.status;
        	}
        	
        	if(status!='OPEN'){
        		vm.errorString = "Session is closed for " + instrumentCode + " market...!"
        		return false;
        	}
        	
        	return true;
        }
        
        //get tick size
        function getTickSizeForGivenInstrument(instrumentCode){
        	if(instrumentCode=='SPOT'){
        		return vm.tickSize.spot;
        	}else if(instrumentCode=='CASH'){
        		return vm.tickSize.cash;
        	}else if(instrumentCode=='TOM'){
        		return vm.tickSize.tom;
        	}
        }
        
        //get ltp for given instrument and buy sell flag
        function getLtpForGivenInstrumentAndBuySellFlag(instrumentCode, buySellFlag, selectedBankSpread){

        	if(instrumentCode!='SPOT'){
        		var spreadUsed = getSpreadUsed(selectedBankSpread, buySellFlag, instrumentCode);
        		if(spreadUsed==null || spreadUsed==undefined || spreadUsed==''){
        			if(vm.retailSpotMarketDepth!=null && vm.retailSpotMarketDepth!=undefined){
        				if(vm.retailSpotMarketDepth.ltp!=null && vm.retailSpotMarketDepth.ltp!=undefined && vm.retailSpotMarketDepth.ltp>0){
                    		return getSpotRateForGivenRateAndSpread(vm.retailSpotMarketDepth.ltp, spreadUsed);
                		}
            		}else{
            			return getSpotRateForGivenRateAndSpread(vm.previousDayClosingPriceForSpot, spreadUsed);
            		}
        		}
        	}else{
        		if(vm.retailSpotMarketDepth!=null && vm.retailSpotMarketDepth!=undefined){
        			if(vm.retailSpotMarketDepth.ltp!=null && vm.retailSpotMarketDepth.ltp!=undefined && vm.retailSpotMarketDepth.ltp>0){
                		return vm.retailSpotMarketDepth.ltp;
            		}
        		}else{
            		return vm.previousDayClosingPriceForSpot;
        		}
        	}
        
        	/*if(instrumentCode=='SPOT'){
        		if(buySellFlag=='SELL'){
            		return vm.retailSpotMarketWatch.bidPrice;
        		}else if(buySellFlag=='BUYY'){
        			return vm.retailSpotMarketWatch.offerPrice;
        		}
        	}else if(instrumentCode=='CASH'){
        		if(buySellFlag=='SELL'){
            		return vm.cashMarketWatch.bidPrice;
        		}else if(buySellFlag=='BUYY'){
        			return vm.cashMarketWatch.offerPrice;
        		}
        	}else if(instrumentCode=='TOM'){
        		if(buySellFlag=='SELL'){
            		return vm.tomMarketWatch.bidPrice;
        		}else if(buySellFlag=='BUYY'){
        			return vm.tomMarketWatch.offerPrice;
        		}
        	}*/
        }
        
        function getLTPOrPreviousDayLTPForInstrumentAndBuySellFlag(instrumentCode, buySellFlag){
        	if(instrumentCode=='SPOT'){
        		if(vm.retailSpotMarketDepth.ltp>0){
            		return vm.retailSpotMarketDepth.ltp;
        		}
        	}else if(instrumentCode=='CASH'){
        		if(vm.cashMarketDepth.ltp>0){
            		return vm.cashMarketDepth.ltp;
        		}
        	}else if(instrumentCode=='TOM'){
        		if(vm.tomMarketDepth.ltp>0){
            		return vm.tomMarketDepth.ltp;
        		}
        	}
        	return vm.previousDayClosingPriceForSpot;
        }
        
        //validate order amount
        function validateOrderAmount(orderAmount){
        	//orderAmount = orderAmount.replace(/,/g, '');
        	if(Number(orderAmount)==0){
        		vm.errorString = 'Order value must be greater than zero...! ';
        		return false;
        	}else if(Number(orderAmount) < 0){
        		vm.errorString = 'Order value must be positive...!';
        		return false;
        	}
        	else if(Number(orderAmount) < Number(vm.configSettings.minimumOrderValue)){
        		vm.errorString = 'Order amount should not be less than minimum order value ' + $filter('number')(vm.configSettings.minimumOrderValue, 0) + '...!';
        		return false;
        	}else if(Number(orderAmount) > Number(vm.configSettings.maximumOrderValue)){
        		vm.errorString = 'Order amount should not be greater than maximum order value ' + $filter('number')(vm.configSettings.maximumOrderValue, 0) + '...!';
        		return false;
        	}
        	else if(((Math.round(parseFloat(orderAmount) * 10000)) % (Math.round(parseFloat(vm.configSettings.orderLotSize) * 10000)))!=0){
        		vm.errorString = "Order value should be in multiples of lot size " + vm.configSettings.orderLotSize + "...!";
        		return false;
        	}
        	return true;
        }
        
        function validateLimitCheck(oldOrderAmount, activityIndicator, orderAmount, instrumentCode, buySellFlag){
        	if(buySellFlag=='SELL'){
        		if(!validateSellLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount)){
        			vm.errorString = "Sell trading limit breached. Order entry not possible...!";
        			return false;
        		}
        	}else if(buySellFlag=='BUYY'){
        		if(!validateBuyLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount)){
        			vm.errorString = "Buy trading limit breached. Order entry not possible...!";
        			return false;
        		}
        	}else if(buySellFlag=='SELLBUY'){
        		if(instrumentCode=='SPOT'){
        			if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, vm.retailSpotBuyLimit, vm.retailSpotSellLimit)){
        				return false;
        			}
        		}else if(instrumentCode=='CASH'){
        			if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, vm.cashBuyLimit, vm.cashSellLimit)){
        				return false;
        			}
        		}else if(instrumentCode=='TOM'){
        			if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, vm.tomBuyLimit, vm.tomSellLimit)){
        				return false;
        			}
        		}
        	}
        	return true;
        }
        
        /*
         * validate limits for sell and buy order
         */
        function validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, buyLimit, sellLimit){
        	if(vm.limitType == 'GLOBALGROSS' && orderAmount > (buyLimit/2)){
				vm.errorString = "Global gross limit breached. Order entry is not possible...!";
				return false;
			}
    		if(orderAmount > buyLimit){
    			vm.errorString = "Buy trading limit breached. Order entry is not possible...!";
    			return false;
    		}else if(orderAmount > sellLimit){
    			vm.errorString = "Sell trading limit breached. Order entry is not possible...!";
    			return false;
    		}
    		return true;
        }
        
        /*
         * validate sell limit
         */
        function validateSellLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount){
        	if(activityIndicator=='PLAC'){
        		if(instrumentCode=='SPOT'){
            		if(orderAmount > vm.retailSpotSellLimit){
            			return false;
            		}
        		}else if(instrumentCode=='CASH'){
            		if(orderAmount > vm.cashSellLimit){
            			return false;
            		}
        		}else if(instrumentCode=='TOM'){
            		if(orderAmount > vm.tomSellLimit){
            			return false;
            		}
        		}
        	}else if(activityIndicator=='MDFY'){
        		if(instrumentCode=='SPOT'){
            		if(orderAmount > vm.retailSpotSellLimit + oldOrderAmount){
            			return false;
            		}
        		}else if(instrumentCode=='CASH'){
            		if(orderAmount > vm.cashSellLimit + oldOrderAmount){
            			return false;
            		}
        		}else if(instrumentCode=='TOM'){
            		if(orderAmount > vm.tomSellLimit + oldOrderAmount){
            			return false;
            		}
        		}
        	}
        	return true;
        }
        
        /*
         * validate buy limit 
         */
        function validateBuyLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount){
        	if(activityIndicator=='PLAC'){
        		if(instrumentCode=='SPOT'){
            		if(orderAmount > vm.retailSpotBuyLimit){
            			return false;
            		}
        		}else if(instrumentCode=='CASH'){
            		if(orderAmount > vm.cashBuyLimit){
            			return false;
            		}
        		}else if(instrumentCode=='TOM'){
            		if(orderAmount > vm.tomBuyLimit){
            			return false;
            		}
        		}
        	}else if(activityIndicator=='MDFY'){
        		if(instrumentCode=='SPOT'){
            		if(orderAmount > vm.retailSpotBuyLimit + oldOrderAmount){
            			return false;
            		}
        		}else if(instrumentCode=='CASH'){
            		if(orderAmount > vm.cashBuyLimit + oldOrderAmount){
            			return false;
            		}
        		}else if(instrumentCode=='TOM'){
            		if(orderAmount > vm.tomBuyLimit + oldOrderAmount){
            			return false;
            		}
        		}
        	}
    		
    		return true;
        }
        
        function validateLimitExchangeRate(buySellFlag, activityIndicator, priceCondition, limitExchangeRate,limitExchangeRateInSpot, orderTickSize, ltp, allowedOrderPriceDeviationInPercent, allowedOrderPriceDeviationFromMarketPriceInPaise){
        	ltp = Number(ltp);
        	if(priceCondition!='MRKT'){
            	if(Number(limitExchangeRate)<0){
            		if(buySellFlag=='BUYY'){
                		vm.errorString = 'Buy limit price must be positive...!';
            		}else{
                		vm.errorString = 'Sell limit price must be positive...!';
            		}
            		return false;
            	}
        	}
        	
        	if((priceCondition!='MRKT' && Number(limitExchangeRate)==0) || (priceCondition=='MRKT' && activityIndicator=='MDFY' && Number(limitExchangeRate)==0)){
        		if(buySellFlag=='BUYY'){
            		vm.errorString = 'Buy limit price must be greater than zero...!';
        		}else{
            		vm.errorString = 'Sell limit price must be greater than zero...!';
        		}
        		return false;
        	}
        	var tickSizeRemainder = (Math.round(parseFloat(limitExchangeRate)*10000)) % (Math.round(parseFloat(orderTickSize)*10000));
        	if(tickSizeRemainder!=0){
        		if(buySellFlag=='BUYY'){
            		vm.errorString = 'Buy limit price should be in multiples of tick size ' + Number(orderTickSize) + '...!';
        		}else{
            		vm.errorString = 'Sell limit price should be in multiples of tick size ' + Number(orderTickSize) + '...!';
        		}
        		return false;
        	}
        	var higherCutOffPrice = vm.previousDayClosingPriceForSpot + (vm.previousDayClosingPriceForSpot * (allowedOrderPriceDeviationInPercent/100));
        	var lowerCutOffPrice = vm.previousDayClosingPriceForSpot - (vm.previousDayClosingPriceForSpot * (allowedOrderPriceDeviationInPercent/100));
        	
        	if(ltp>0 && ltp!=undefined && ltp!=null){
            	higherCutOffPrice = ltp + (ltp * (allowedOrderPriceDeviationInPercent/100));
            	lowerCutOffPrice = ltp - (ltp * (allowedOrderPriceDeviationInPercent/100));
        	}
        	
        	 
        	if(priceCondition!='MRKT' && (Math.round(parseFloat(limitExchangeRateInSpot)*10000) < Math.round(parseFloat(lowerCutOffPrice)*10000) ||  Math.round(parseFloat(limitExchangeRateInSpot)*10000) > Math.round(parseFloat(higherCutOffPrice)*10000))){
        		if(buySellFlag=='BUYY'){
            		vm.errorString = 'Buy limit price deviated from allowed order price...!';
        		}else{
            		vm.errorString = 'Sell limit price deviated from allowed order price...!';
        		}
        		return false;
        	}
        	
        	return true;
        }
        
        function validateStopExchangeRate(priceCondition, buySellFlag, limitExchangeRate, stopExchangeRate, orderTickSize){
        	if(Number(stopExchangeRate)<0){
        		vm.errorString = 'Trigger price must be positive...!';
        		return false;
        	}
        	
        	if(priceCondition!='MRKT' && priceCondition!='LIMT' && Number(stopExchangeRate)==0){
        		vm.errorString = 'Trigger price cannot be zero...!';
        		return false;
        	}
        	
        	if(priceCondition=='STLS' || priceCondition=='TKPR'){
        		if(buySellFlag=='BUYY' && Number(stopExchangeRate) > Number(limitExchangeRate)){
        			vm.errorString = 'Trigger price should be less than or equal to the limit price...!';
        			return false;
        		}
        		if(buySellFlag=='SELL' && Number(stopExchangeRate) < Number(limitExchangeRate)){
        			vm.errorString = 'Trigger price should be greater than or equal to the limit price...!';
        			return false;
        		}
        		var tickSizeRemainder = (Math.round(parseFloat(stopExchangeRate)*10000)) % (Math.round(parseFloat(orderTickSize)*10000));
            	if(tickSizeRemainder!=0){
            		vm.errorString = 'Trigger price should be in multiples of tick size ' + Number(orderTickSize) + '...!';
            		return false;
            	}
        	}
        	return true;
        }
        
        function validateSpreadUsed(selectedBankSpread, instrumentCode, buySellFlag){
        	if(instrumentCode!='SPOT'){
        		var spreadUsed = getSpreadUsed(selectedBankSpread, buySellFlag, instrumentCode);
        		if(spreadUsed==null || spreadUsed==undefined || spreadUsed==''){
        			if(buySellFlag=='BUYY'){
        				if(instrumentCode=='CASH'){
                			vm.errorString = 'CASH/SPOT bid spread is not given by the bank. Order entry not possible...!';
        				}else if(instrumentCode=='TOM'){
                			vm.errorString = 'TOM/SPOT bid spread is not given by the bank. Order entry not possible...!';
        				}
        			}else if(buySellFlag=='SELL'){
        				if(instrumentCode=='CASH'){
                			vm.errorString = 'CASH/SPOT offer spread is not given by the bank. Order entry not possible...!';
        				}else if(instrumentCode=='TOM'){
                			vm.errorString = 'TOM/SPOT offer spread is not given by the bank. Order entry not possible...!';
        				}
        			}
        			return false;
        		}
        	}
    		return true;
        }
        
        function getSpreadUsed(selectedBankSwapQuote, buySellFlag, instrumentCode){
        	if(buySellFlag=='BUYY'){
        		if(instrumentCode=='CASH'){
        			return selectedBankSwapQuote.cashSpotBidSpread;
        		}else if(instrumentCode=='TOM'){
        			return selectedBankSwapQuote.tomSpotBidSpread;
        		}
        	}else if(buySellFlag=='SELL'){
        		if(instrumentCode=='CASH'){
        			return selectedBankSwapQuote.cashSpotOfferSpread;
        		}else if(instrumentCode=='TOM'){
        			return selectedBankSwapQuote.tomSpotOfferSpread;
        		}
        	}
        }
        
        function placeOrderRequest(orderDTO){
        	if(orderDTO.buySellIndicator!='SELLBUY'){
        		Market.placeOrder(orderDTO, onPlaceOrderSuccess, onPlaceOrderFailure);
        	}else if(orderDTO.buySellIndicator=='SELLBUY'){
        		var sellOrderDTO = getSellOrderDTO();
        		Market.placeOrder(sellOrderDTO);
        		var buyOrderDTO = getBuyOrderDTO();
        		Market.placeOrder(buyOrderDTO, onPlaceOrderSuccess, onPlaceOrderFailure);
        	}
        }
        
        function onPlaceOrderSuccess(result){
        	vm.remarks = "";
			fillDefaultValuesToControls();
        }
        
        function onPlaceOrderFailure(){
        	
        }
        
        function getBuyOrderDTO(orderDTO){
        	var buyOrderDTO = angular.copy(orderDTO);
        	buyOrderDTO.buySellIndicator = 'BUYY';
        	buyOrderDTO.limitExchangeRate = orderDTO.buyLimitExchangeRate;
        	buyOrderDTO.stopExchangeRate = orderDTO.buyStopExchangeRate;
        	return buyOrderDTO;
        }
        
        function getSellOrderDTO(orderDTO){
        	var sellOrderDTO = angular.copy(orderDTO);
        	sellOrderDTO.buySellIndicator = 'SELL';
        	sellOrderDTO.limitExchangeRate = orderDTO.sellLimitExchangeRate;
        	sellOrderDTO.stopExchangeRate = orderDTO.sellStopExchangeRate;
        	return sellOrderDTO;
        }
        
        function getReportDetailsForSelectedInstrument(instrumentTypeId){
        	
        	getPendingOrderReportForInstrument(instrumentTypeId);
        	getLimitUtilisedReportForInstrument(instrumentTypeId);
        	getTradesReportForInstrument(instrumentTypeId);
        	
    	}

		function getCurrencyPairIdForReportFilters(reportType){
        	var currencyPairId = 0;
        	if(vm.account.organisation.organisationType.shortName=='CLEARCORP' || vm.account.organisation.organisationType.shortName=='CUSTOMER'){
        		if(reportType=='PO'){
            		if(vm.currencyPair!=null){
            			currencyPairId = vm.currencyPair.id;
            		}
        		}
        	}
        	
        	return currencyPairId;
        }
        
        function getBankIdForReportFilters(reportType){
        	var bankId = 0;
        	if(vm.account.organisation.organisationType.shortName=='CLEARCORP' || vm.account.organisation.organisationType.shortName=='CUSTOMER'){
        		if(reportType=='PO'){
            		if(vm.bankFilterForPO!=null){
            			bankId = vm.bankFilterForPO.id;
            		}
        		}else if(reportType=='Limit'){
            		if(vm.bankFilterForLimit!=null){
            			bankId = vm.bankFilterForLimit.id;
            		}
        		}else if(reportType=='Trade'){
            		if(vm.bankFilterForTrade!=null){
            			bankId = vm.bankFilterForTrade.id;
            		}
        		}
        	}else if(vm.account.organisation.organisationType.shortName=='BANK'){
        		bankId = vm.account.organisation.id;
        	}
        	
        	return bankId;
        }
        
        function getBranchIdForReportFilters(reportType){
        	var branchId = 0;
        	if(reportType=='PO'){
        		if(vm.branchFilterForPO!=null){
        			branchId = vm.branchFilterForPO.id;
        		}
    		}else if(reportType=='Limit'){
        		if(vm.branchFilterForLimit!=null){
        			branchId = vm.branchFilterForLimit.id;
        		}
    		}else if(reportType=='Trade'){
        		if(vm.branchFilterForTrade!=null){
        			branchId = vm.branchFilterForTrade.id;
        		}
    		}
        	return branchId;
        }
        
        function getCustomerIdForReportFilters(reportType){
        	var customerId = 0;
        	if(vm.account.organisation.organisationType.shortName=='CLEARCORP' || vm.account.organisation.organisationType.shortName=='BANK'){
        		if(reportType=='PO'){
            		if(vm.customerFilterForPO!=null){
            			customerId = vm.customerFilterForPO.id;
            		}
        		}else if(reportType=='Limit'){
            		if(vm.customerFilterForLimit!=null){
            			customerId = vm.customerFilterForLimit.id;
            		}
        		}else if(reportType=='Trade'){
            		if(vm.customerFilterForTrade!=null){
            			customerId = vm.customerFilterForTrade.id;
            		}
        		}
        	}else if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
        		customerId = vm.globalValues.getCustomerId();
        	}
        	return customerId;
        }
        
        $scope.$watch('vm.tradingBank', function(value){
        	if(vm.account!=null && vm.account!=undefined && value!=null && value!=undefined){
            	if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
            		CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
    					vm.tradingBranch = result;
    				})
            	}
            	
            	vm.defaultBankSpread = MarketWatch.getDefaultBankSwapQuotes(vm.bankComparativeQuotes, vm.tradingBank);
            	
            	if(vm.account.organisation.organisationType.shortName=='CLEARCORP'){
            		if(vm.defaultTradingCustomer!=null && vm.defaultTradingCustomer!=undefined){
                    	getLimitsAvailableForAllInstruments(vm.tradingBank.id, vm.defaultTradingCustomer.id);
            		}
            	}else if(vm.account.organisation.organisationType.shortName=='BANK'){
            		if(vm.defaultTradingCustomer!=null && vm.defaultTradingCustomer!=undefined){
                    	getLimitsAvailableForAllInstruments(vm.globalValues.getOrganisation().id, vm.defaultTradingCustomer.id);
            		}
            	}else if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
                	getLimitsAvailableForAllInstruments(vm.tradingBank.id, vm.globalValues.getCustomer().id);
            	}
        	}
        })
        
        $scope.$watch('vm.bankFilterForLimit', function(value){
        	if(vm.account!=null && vm.account!=undefined && value!=null && value!=undefined){
            	if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
            		CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
    					vm.branchFilterForLimit = result;
    				})
            	}
        	}
        })
        
        $scope.$watch('vm.bankFilterForPO', function(value){
        	if(vm.account!=null && vm.account!=undefined && value!=null && value!=undefined){
            	if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
            		CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
    					vm.branchFilterForPO = result;
    				})
            	}
        	}
        })
        
         $scope.$watch('vm.bankFilterForTrade', function(value){
        	if(vm.account!=null && vm.account!=undefined && value!=null && value!=undefined){
            	if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
            		CustomerBankRelationshipReport.getTradingBranchForCustomerAndBank({bankId: value.id, customerId: vm.globalValues.getOrganisation().id}, function(result){
    					vm.branchFilterForTrade = result;
    				})
            	}
        	}
        })
        
        //modify selected order
        function modifyOrder(pendingOrder){
        	prepareOrderDTO(pendingOrder, 'MDFY');
        }
        
        //re-assing default values to controls
        function cancelModifyOrderAction(){
        	fillDefaultValuesToControls();
        }
        
        function getCustomerId(){
        	if(vm.account.organisation.organisationType.shortName=='CLEARCORP'){
            	return vm.defaultTradingCustomer.id;
        	}else if(vm.account.organisation.organisationType.shortName=='BANK'){
            	return vm.defaultTradingCustomer.id;
        	}else if(vm.account.organisation.organisationType.shortName=='CUSTOMER'){
        		vm.globalValues.getCustomer().id
        	}
        }
        
        //prepare orderDTO to modify/cancel order from pending order details
        function prepareOrderDTO(pendingOrder, activityIndicator){
        	vm.orderDTO.activityIndicator = activityIndicator;
        	vm.orderDTO.orderAmount = pendingOrder.pendingOrderAmount;
        	vm.orderDTO.typeOfOrder = pendingOrder.typeOfOrder;
        	vm.orderDTO.instrumentCode = pendingOrder.instrumentCode;
        	vm.orderDTO.buySellIndicator = pendingOrder.buySellInd;
        	vm.orderDTO.timeLimitIndicator = pendingOrder.timeLimitIndicator;
        	if(vm.orderDTO.timeLimitIndicator=='GTTM'){
            	vm.orderDTO.expiryTime = pendingOrder.expiryTime;
        	}
        	vm.orderDTO.instrumentId = pendingOrder.retailOrderInstID;
        	vm.orderDTO.branchCode = pendingOrder.branchCode;
        	vm.orderDTO.branchId = pendingOrder.branchId;
        	vm.orderDTO.bankId = pendingOrder.bankId;
        	vm.orderDTO.bankName = pendingOrder.bankName;
        	vm.orderDTO.customerId = pendingOrder.customerId;
        	vm.orderDTO.customerName = pendingOrder.customerName;
        	vm.orderDTO.limitExchangeRate = pendingOrder.limitExchangeRate;
        	vm.orderDTO.stopExchangeRate = pendingOrder.stopExchangeRate;
        	vm.orderDTO.orderSequenceNumber = pendingOrder.orderSequenceNumber;
        	vm.orderDTO.oldOrderAmount = pendingOrder.oldOrderAmount;
        	if(activityIndicator!='PLAC'){
        		vm.orderDTO.revisionTimeStamp = pendingOrder.revisiontTimestampString;
            	vm.orderDTO.orderStatusId = pendingOrder.orderStatusId;
        	}
        	if(pendingOrder.typeOfOrder=='MRKT'){
        		vm.orderDTO.typeOfOrder = 'LIMT';
        		vm.defaultPriceCondition = 'LIMT';
        		vm.orderDTO.limitExchangeRate = getDefaultLimitPriceForModifyingMarketOrder(pendingOrder.instrumentCode, pendingOrder.buySellInd);
        	}

        	setDefaultPriceCondition(pendingOrder.typeOfOrder);
        	changeInstrument(pendingOrder.instrumentCode);
        	changeOrderType(pendingOrder.buySellInd, vm.orderDTO.activityIndicator);
        	changeTradingBank(pendingOrder.bankId);
        }
        
        function getDefaultLimitPriceForModifyingMarketOrder(instrumentCode, buySellFlag){
    		if(buySellFlag=='BUYY'){
            	if(instrumentCode=='SPOT'){
            		return vm.retailSpotMarketWatch.bidPrice;
            	}else if(instrumentCode=='CASH'){
            		return vm.cashMarketWatch.bidPrice;
            	}else if(instrumentCode=='TOM'){
            		return vm.tomMarketWatch.bidPrice;
            	}
    			
    		}else if(buySellFlag=='SELL'){
    			if(instrumentCode=='SPOT'){
            		return vm.retailSpotMarketWatch.offerPrice;
            	}else if(instrumentCode=='CASH'){
            		return vm.cashMarketWatch.offerPrice;
            	}else if(instrumentCode=='TOM'){
            		return vm.tomMarketWatch.offerPrice;
            	}
    		}
        	
        }
        
        function prepareOrderDTOToCancel(pendingOrder){
        	var orderDTO = {};
        	orderDTO.activityIndicator = 'CNCL';
        	orderDTO.orderAmount = pendingOrder.pendingOrderAmount;
        	orderDTO.typeOfOrder = pendingOrder.typeOfOrder;
        	orderDTO.instrumentCode = pendingOrder.instrumentCode;
        	orderDTO.instrumentId = pendingOrder.retailOrderInstID;
        	orderDTO.buySellIndicator = pendingOrder.buySellInd;
        	orderDTO.timeLimitIndicator = pendingOrder.timeLimitIndicator;
        	if(vm.orderDTO.timeLimitIndicator=='GTTM'){
            	vm.orderDTO.expiryTime = pendingOrder.expiryTime;
        	}
        	orderDTO.branchCode = pendingOrder.branchCode;
        	orderDTO.branchId = pendingOrder.branchId;
        	orderDTO.bankId = pendingOrder.bankId;
        	orderDTO.bankMemberNumber = pendingOrder.bankMemberNumber;
        	orderDTO.bankName = pendingOrder.bankName;
        	orderDTO.customerId = pendingOrder.customerId;
        	orderDTO.customerName = pendingOrder.customerName;
        	orderDTO.customerCode = pendingOrder.customerCode;
        	orderDTO.limitExchangeRate = pendingOrder.limitExchangeRate;
        	orderDTO.stopExchangeRate = pendingOrder.stopExchangeRate;
        	orderDTO.orderSequenceNumber = pendingOrder.orderSequenceNumber;
        	orderDTO.userId = vm.globalValues.getUserId();
        	orderDTO.retailUserCode = vm.globalValues.getUser().login;
        	orderDTO.userEntityOwnerId = vm.globalValues.getEntityOwnerTypeId();

        	var selectedBankSpread = MarketWatch.getDefaultBankSwapQuotes(vm.bankComparativeQuotes, vm.tradingBank);
        	orderDTO.spreadUsed = getSpreadUsed(selectedBankSpread, pendingOrder.buySellInd, pendingOrder.instrumentCode);

        	orderDTO.revisionTimeStamp = pendingOrder.revisiontTimestampString;        	
        	return orderDTO;
        }
        
        function changeTradingBank(bankId){
        	BankRegistration.get({id: bankId}, function(result){
        		vm.tradingBank = result;
        	})
        }
        
        //to cancel order
        function cancelOrder(pendingOrder){
        	prepareOrderDTO(pendingOrder, 'CNCL');
        }
        
        $scope.$watch('vm.selectAll', function(value){
        	if(value==true){
            	angular.forEach(vm.pendingOrders, function(value, index){
            		if(value.orderStatus!="Risk Validated"){
                		vm.pendingOrders[index].select = true;
            		}
            	})
        	}else{
            	angular.forEach(vm.pendingOrders, function(value, index){
            		vm.pendingOrders[index].select = false;
            	})
        	}
        })
        
        function cancelAllOrders(){
        	var ordersSelected = false;
        	angular.forEach(vm.pendingOrders, function(value){
        		if(value.select==true){
        			ordersSelected = true;
        		}
        	});
        	if(ordersSelected==true){
            	$scope.pendingOrders = vm.pendingOrders;
            	MessageBox.openMessageBox("Alert", "Do you want to proceed to cancel selected order(s)?", "ProceedCancel", "cancelselectedorders");
        	}else{
            	MessageBox.openMessageBox("Alert", "Please select the order(s) to proceed.", "Ok", "selectedorders");
        	}
        }
        
		$rootScope.$on('gatewayApp.messagebox.proceed.cancelselectedorders', function (event, data) {
        	angular.forEach($scope.pendingOrders, function(value){
        		if(value.select){
        			var orderDTO = {};
        			orderDTO = prepareOrderDTOToCancel(value);
        			//place cancel order
        			Market.cancelOrder(orderDTO);
        		}
        	})
    	});
		
		$rootScope.$on('gatewayApp.messagebox.cancel.cancelselectedorders', function (event, data) {
			//do not proceed
		});
		

        
        function changeOrderType(buySellFlag, activityIndicator){
        	if(buySellFlag=='BUYY' && activityIndicator=='PLAC'){
            	vm.orderType = 'BUYY';
            	setTimeout(function(){document.getElementById('buyTab').click()});
        		//document.getElementById('buyTab').click();
        	}else if(buySellFlag=='SELL' && activityIndicator=='PLAC'){
        		vm.orderType = 'SELL';
            	setTimeout(function(){document.getElementById('sellTab').click()});
        		//document.getElementById('sellTab').click();
        	}else if(buySellFlag=='BUYY' && activityIndicator=='MDFY'){
            	vm.orderType = 'MODIFYBUY';
            	setTimeout(function(){document.getElementById('modifybuyTab').click()});
        		//document.getElementById('buyTab').click();
        	}else if(buySellFlag=='SELL' && activityIndicator=='MDFY'){
        		vm.orderType = 'MODIFYSELL';
            	setTimeout(function(){document.getElementById('modifysellTab').click()});
        		//document.getElementById('sellTab').click();
        	}else if(buySellFlag=='BUYY' && activityIndicator=='CNCL'){
            	vm.orderType = 'CANCELBUY';
            	setTimeout(function(){document.getElementById('modifybuyTab').click()});
        		//document.getElementById('buyTab').click();
        	}else if(buySellFlag=='SELL' && activityIndicator=='CNCL'){
        		vm.orderType = 'CANCELSELL';
            	setTimeout(function(){document.getElementById('modifysellTab').click()});
        		//document.getElementById('sellTab').click();
        	}
        }
        
        //get equivalent spot price for limit and trigger prices
        $scope.$watchGroup(['vm.orderDTO.limitExchangeRate', 'vm.defaultInstrumentCode', 'vm.orderType', 'vm.tradingBank'], function(value){
        	if(vm.defaultBankSpread!=null && vm.defaultBankSpread!=undefined){
            	if(vm.defaultInstrumentCode=='CASH'){
            		if(vm.orderType=='SELL' || vm.orderType=='MODIFYSELL'){
                    	vm.orderDTO.limitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.limitExchangeRate, vm.defaultBankSpread.cashSpotOfferSpread); 
                    		
            		}else if(vm.orderType=='BUYY' || vm.orderType=='MODIFYBUY'){
                    	vm.orderDTO.limitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.limitExchangeRate, vm.defaultBankSpread.cashSpotBidSpread); 
            		}
            	}else if(vm.defaultInstrumentCode=='TOM'){
                		if(vm.orderType=='SELL' || vm.orderType=='MODIFYSELL'){
                        	vm.orderDTO.limitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.limitExchangeRate, vm.defaultBankSpread.tomSpotOfferSpread);  
                		}else if(vm.orderType=='BUYY' || vm.orderType=='MODIFYBUY'){
                        	vm.orderDTO.limitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.limitExchangeRate, vm.defaultBankSpread.tomSpotBidSpread); 
                		}
                }else{
                	vm.orderDTO.limitExchangeRateInSpot = vm.orderDTO.limitExchangeRate;
                }
            	
            	
            	if(vm.defaultPriceCondition=='STLS' || vm.defaultPriceCondition=='TKPR'){
            		//limit, stop price default
            	}
        	}
        	
        })
        
        function softCheckDeviationForLimitExchangeRate(value){
        	vm.limitPriceDeviationWarning = '';
        	if(value!=null && value!=undefined && value!=''){
            	var higherCutOffPriceSoft = vm.previousDayClosingPriceForSpot + Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise/100);
            	var lowerCutOffPriceSoft = vm.previousDayClosingPriceForSpot - Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise/100);
            	var ltp = getLtpForGivenInstrumentAndBuySellFlag(vm.defaultInstrumentCode, vm.orderType, vm.defaultBankSpread);
            	if(ltp>0 && ltp!=undefined && ltp!=null){
                	higherCutOffPriceSoft = ltp + (Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise/100));
                	lowerCutOffPriceSoft = ltp - (Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise/100));
            	}
            	
            	if(vm.defaultPriceCondition!='MRKT' && (Math.round(parseFloat(vm.orderDTO.limitExchangeRateInSpot)*10000) < Math.round(parseFloat(lowerCutOffPriceSoft)*10000) 
            			|| Math.round(parseFloat(vm.orderDTO.limitExchangeRateInSpot)*10000) > Math.round(parseFloat(higherCutOffPriceSoft)*10000))){
            		vm.limitPriceDeviationWarning = 'Deviates by more than ' + vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise + ' paise from the LTP';
            	}
        	}
        }
        
        function softCheckDeviationForBuyLimitExchangeRate(value){
        	vm.buyLimitPriceDeviationWarning = '';
        	if(value!=null && value!=undefined && value!=''){
            	var higherCutOffPriceSoft = vm.previousDayClosingPriceForSpot + Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise/100);
            	var lowerCutOffPriceSoft = vm.previousDayClosingPriceForSpot - Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise/100);
            	var ltp = getLtpForGivenInstrumentAndBuySellFlag(vm.defaultInstrumentCode, vm.orderType, vm.defaultBankSpread);
            	if(ltp>0 && ltp!=undefined && ltp!=null){
                	higherCutOffPriceSoft = ltp + (Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise/100));
                	lowerCutOffPriceSoft = ltp - (Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise/100));
            	}
            	
            	if(vm.defaultPriceCondition!='MRKT' && (Math.round(parseFloat(vm.orderDTO.buyLimitExchangeRateInSpot)*10000) < Math.round(parseFloat(lowerCutOffPriceSoft)*10000) 
            			|| Math.round(parseFloat(vm.orderDTO.buyLimitExchangeRateInSpot)*10000) > Math.round(parseFloat(higherCutOffPriceSoft)*10000))){
            		vm.buyLimitPriceDeviationWarning = 'Deviates by more than ' + vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise + ' paise from the LTP';
            	}
        	}
        }
        
        function softCheckDeviationForSellLimitExchangeRate(value){
        	vm.sellLimitPriceDeviationWarning = '';
        	if(value!=null && value!=undefined && value!=''){
            	var higherCutOffPriceSoft = vm.previousDayClosingPriceForSpot + Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise/100);
            	var lowerCutOffPriceSoft = vm.previousDayClosingPriceForSpot - Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise/100);
            	var ltp = getLtpForGivenInstrumentAndBuySellFlag(vm.defaultInstrumentCode, vm.orderType, vm.defaultBankSpread);
            	if(ltp>0 && ltp!=undefined && ltp!=null){
                	higherCutOffPriceSoft = ltp + (Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise/100));
                	lowerCutOffPriceSoft = ltp - (Number(vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise/100));
            	}
            	
            	if(vm.defaultPriceCondition!='MRKT' && (Math.round(parseFloat(vm.orderDTO.sellLimitExchangeRateInSpot)*10000) < Math.round(parseFloat(lowerCutOffPriceSoft)*10000) 
            			|| Math.round(parseFloat(vm.orderDTO.sellLimitExchangeRateInSpot)*10000) > Math.round(parseFloat(higherCutOffPriceSoft)*10000))){
            		vm.sellLimitPriceDeviationWarning = 'Deviates by more than ' + vm.configSettings.allowedOrderPriceDeviationFromMarketPriceInPaise + ' paise from the LTP';
            	}
        	}
        }
        
        //stop exchange rate
        $scope.$watchGroup(['vm.orderDTO.stopExchangeRate', 'vm.defaultInstrumentCode', 'vm.orderType'], function(value){
        	if(vm.defaultBankSpread!=null && vm.defaultBankSpread!=undefined){
            	if(vm.defaultInstrumentCode=='CASH'){
            		if(vm.orderType=='SELL' || vm.orderType=='MODIFYSELL'){
                    	vm.orderDTO.stopExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.stopExchangeRate, vm.defaultBankSpread.cashSpotOfferSpread); 
            		}else if(vm.orderType=='BUYY' || vm.orderType=='MODIFYBUY'){
                    	vm.orderDTO.stopExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.stopExchangeRate, vm.defaultBankSpread.cashSpotBidSpread);
            		}
            	}else if(vm.defaultInstrumentCode=='TOM'){
                		if(vm.orderType=='SELL' || vm.orderType=='MODIFYSELL'){
                        	vm.orderDTO.stopExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.stopExchangeRate, vm.defaultBankSpread.tomSpotOfferSpread);
                		}else if(vm.orderType=='BUYY' || vm.orderType=='MODIFYBUY'){
                        	vm.orderDTO.stopExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.stopExchangeRate, vm.defaultBankSpread.tomSpotBidSpread);
                		}
                }else{
                	vm.orderDTO.stopExchangeRateInSpot = vm.orderDTO.stopExchangeRate;
                }
            	
        	}
        })
        
        //buy limit exchange rate
        $scope.$watchGroup(['vm.orderDTO.buyLimitExchangeRate', 'vm.defaultInstrumentCode', 'vm.orderType'], function(value){
        	if(vm.defaultBankSpread!=null && vm.defaultBankSpread!=undefined){
            	if(vm.defaultInstrumentCode=='CASH'){
            		vm.orderDTO.buyLimitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.buyLimitExchangeRate, vm.defaultBankSpread.cashSpotBidSpread);
            	}else if(vm.defaultInstrumentCode=='TOM'){
            		vm.orderDTO.buyLimitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.buyLimitExchangeRate, vm.defaultBankSpread.tomSpotBidSpread); 
                }else{
                	vm.orderDTO.buyLimitExchangeRateInSpot = vm.orderDTO.buyLimitExchangeRate;
                }
        	}
        	
        	if(vm.userPreference!=null && vm.userPreference!=undefined){
        		if(vm.userPreference.userBidSpread!=null && vm.userPreference.userBidSpread!=undefined){
            		vm.orderDTO.sellLimitExchangeRate = Number(value[0]) + Number(vm.userPreference.userBidSpread);
            	}
        	}
        })
        
        //buy stop exchange rate
        $scope.$watchGroup(['vm.orderDTO.buyStopExchangeRate', 'vm.defaultInstrumentCode', 'vm.orderType'], function(value){
        	if(vm.defaultBankSpread!=null && vm.defaultBankSpread!=undefined){
            	if(vm.defaultInstrumentCode=='CASH'){
            		vm.orderDTO.buyStopExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.buyStopExchangeRate, vm.defaultBankSpread.cashSpotBidSpread); 
            	}else if(vm.defaultInstrumentCode=='TOM'){
            			vm.orderDTO.buyStopExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.buyStopExchangeRate, vm.defaultBankSpread.tomSpotBidSpread);  
                }else{
                	vm.orderDTO.buyStopExchangeRateInSpot = vm.orderDTO.buyStopExchangeRate;
                }
        	}
        })
        
        //sell limit exchange rate
        $scope.$watchGroup(['vm.orderDTO.sellLimitExchangeRate', 'vm.defaultInstrumentCode', 'vm.orderType'], function(value){
        	if(vm.defaultBankSpread!=null && vm.defaultBankSpread!=undefined){
            	if(vm.defaultInstrumentCode=='CASH'){
            		vm.orderDTO.sellLimitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.sellLimitExchangeRate, vm.defaultBankSpread.cashSpotOfferSpread); 
            	}else if(vm.defaultInstrumentCode=='TOM'){
            		vm.orderDTO.sellLimitExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.sellLimitExchangeRate, vm.defaultBankSpread.tomSpotOfferSpread); 
                }else{
                	vm.orderDTO.sellLimitExchangeRateInSpot = vm.orderDTO.sellLimitExchangeRate;
                }
        	}
        })
        
        //sell stop exchange rate
        $scope.$watchGroup(['vm.orderDTO.sellStopExchangeRate', 'vm.defaultInstrumentCode', 'vm.orderType'], function(value){
        	if(vm.defaultBankSpread!=null && vm.defaultBankSpread!=undefined){
            	if(vm.defaultInstrumentCode=='CASH'){
            		vm.orderDTO.sellStopExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.sellStopExchangeRate, vm.defaultBankSpread.cashSpotOfferSpread);
            	}else if(vm.defaultInstrumentCode=='TOM'){
            			vm.orderDTO.sellStopExchangeRateInSpot = getSpotRateForGivenRateAndSpread(vm.orderDTO.sellStopExchangeRate, vm.defaultBankSpread.tomSpotOfferSpread); 
                }else{
                	vm.orderDTO.sellStopExchangeRateInSpot = vm.orderDTO.sellStopExchangeRate;
                }
        	}
        })
        
        function getSpotRateForGivenRateAndSpread(rate, spread){
        	var spotRate = Number(rate) + Number(spread)/100;
        	return spotRate;
        }
        
        function marketDepthChanges(marketDepthDTO){
        	setTimeout(function(){
        	$scope.$apply(function(){
        		var marketDepth = {};
            	var existingMarketDepth = vm.marketDepth;
            	angular.forEach(existingMarketDepth, function(value, index){
            		if(value.instrumentID==marketDepthDTO.instrumentID){
            			marketDepth = MarketWatch.getMarketDepth(marketDepthDTO);
            			existingMarketDepth[index] = marketDepth;
            		}
            	});
            	
            	vm.marketDepth = existingMarketDepth;
            	
            	getMarketDepthDetailsForReport();
            	//set previous ticker price
            	var previousTickerPrice = angular.copy(vm.tickerPrice);
            	vm.previousTickerPrice = previousTickerPrice;
            	//get ticker price
            	vm.tickerPrice = MarketWatch.getTickerPrice(marketDepth, previousTickerPrice, vm.previousDayClosingPriceForSpot, vm.previousDayClosingPriceForIbSpot);
            	$rootScope.tickerPrice = vm.tickerPrice;
        	})
        	})
        }
        
        function marketSettingsChanges(marketSessionSettings){
        	vm.marketSessionSettings = marketSessionSettings;
        	setMarketSettings();
        }
        
        //update pending order report in home page
        function pendingOrdersFeed(pendingOrder){
        	//get pending orders from feed
        	setTimeout(function(){
        	$scope.$apply(function(){
            	var existingPendingOrders = [];
            	if(vm.pendingOrders!=null && vm.pendingOrders!=undefined){
            		if(vm.pendingOrders.length>0){
            			existingPendingOrders = angular.copy(vm.pendingOrders);
            		}
            	}
            	var merged = false;
            	if(pendingOrder!=null && pendingOrder!=undefined){
            		if(existingPendingOrders!=null && existingPendingOrders!= undefined){
            			if(existingPendingOrders.length>0){
                        	angular.forEach(existingPendingOrders, function(value, index){
                        		//if new order placed, order seq no will be 0 initially before the order confirmed 
                        		if(value.clientOrderID==pendingOrder.clientOrderID){
                        			existingPendingOrders[index] = pendingOrder;
                        			merged = true;
                        		}else if(value.orderSequenceNumber==pendingOrder.clientOrderID){
                        			existingPendingOrders[index] = pendingOrder;
                        			merged = true;
                        		}else if(value.orderSequenceNumber==pendingOrder.orderSequenceNumber){
                        			existingPendingOrders[index] = pendingOrder;
                        			merged = true;
                        		}
                        	});
            			}
            		}else{
            			existingPendingOrders.push(pendingOrder);
            			merged = true;
            		}
            		
                	if(!merged && pendingOrder.orderSequenceNumber==pendingOrder.clientOrderID){
            			existingPendingOrders.push(pendingOrder);
                	}
            	}
            	angular.forEach(existingPendingOrders, function(value, index){
            		angular.forEach(vm.orderStatusList, function(orderStatus){
            			if(value.orderStatusId == orderStatus.id){
            				existingPendingOrders[index].orderStatus = orderStatus.name;
            			}
            		})
            	})
            	
            	//vm.pendingOrders = existingPendingOrders;
            	setTimeout(function(){$scope.$apply(function(){vm.pendingOrders = existingPendingOrders;})});
        	})
        	})
        	
        }
        
        //update limits from the feed 
        function limitUpdateFeed(limit){
        	setTimeout(function(){
        	$scope.$apply(function(){
            	var existinglimit = [];
            	if(vm.limitsAvailableForSelectedInstrument!=null && vm.limitsAvailableForSelectedInstrument!=undefined){
            		if(vm.limitsAvailableForSelectedInstrument.length>0){
            			existinglimit = vm.limitsAvailableForSelectedInstrument;
            		}
            	}
            	if(limit!=null && limit!=undefined){
            		if(existinglimit!=null && existinglimit!= undefined){
            			if(existinglimit.length>0){
                        	angular.forEach(existinglimit, function(value, index){
                        		//if new order placed, order seq no will be 0 initially before the order confirmed 
                        		if(value.bankId==limit.bankId && value.branchId==limit.branchId && value.customerId==limit.customerId && (value.instId==limit.instId || value.instId==null)){
                        			if(value.active==true){
                        				existinglimit[index] = limit;
                            			getLimitsForEachInstrument(limit);
                        			}else if(value.active==false){
                        				existinglimit.splice(index, 1);
                        				fillZeroIfLimitIsNotDefinedForInstrumentCode(limit.instrumentCode);
                        			}
                        		}
                        	});
            			}
            		}
            	}
            	setTimeout(function(){$scope.$apply(function(){vm.limitsAvailableForSelectedInstrument = existinglimit;})});
            	//vm.limitsAvailableForSelectedInstrument = existinglimit;
        	});
        	})
        }
        
        
        //trade notificatoins handling
        function tradeNotificationHandling(trade){
        	setTimeout(function(){
        	$scope.$apply(function(){
            	//get trades from feed
        		var existingTrades = [];
            	if(vm.trades!=null && vm.trades!=undefined){
            		if(vm.trades.length>0){
            			existingTrades = vm.trades;
            		}
            	}
            	var merged = false;
            	if(trade!=null && trade!=undefined){
            		trade.tradeTime=moment(trade.tradeTime,'YYYYMMDDHHmmss.SSSSSSSSS').format();
            		if(existingTrades!=null && existingTrades!=undefined){
            			if(existingTrades.length>0){
                        	angular.forEach(existingTrades, function(value, index){
                        		if(value.orderSequenceNumber==trade.orderSequenceNumber){
                        			existingTrades[index] = trade;
                        			merged = true;
                        		}
                        	});
            			}else{
            				existingTrades.push(trade);
                			merged = true;
                		}
            		}else{
            			existingTrades.push(trade);
            			merged = true;
            		}
            	}
            	
            	setTimeout(function(){$scope.$apply(function(){vm.trades = existingTrades;})});
        	});
        	})
        }
        
        
        vm.initialString="";
        vm.messageString="";
        vm.rejectionReason="";
        vm.rejectionString="";
        vm.acceptanceMessage="";
        vm.rejectionMessage="";
       vm.errorMessageList = ErrorMessages.query();
      /*  vm.orderRequestDTO = { "userId" : 29, "errorMessage" : "Not completed" , "exceptionNumber" : 2204, "buySellIndicator" : "BUYY", "customerCode" : "IN8993000001",
        			"instrumentCode" : "SPOT", "orderAmount" : 4545324.34, "typeOfOrder" : "LIMT", "limitExchangeRate": 65.0898, "timeLimitIndicator": "Day", 
        			"messageNumber" : "8021","activityIndicator": "PLAC", "retailUserCode" : "akshayaa"};*/
       
        
        //handle order notification
        
        function frameOrderNotification(order){
        	
        	if(order!=null && order!=undefined){
        		
        		if(order.exceptionNumber!=null && order.exceptionNumber!="" && order.exceptionNumber!=undefined){
        			
        			//get rejection reason for error message
        			 angular.forEach(vm.errorMessageList, function(value){
        			   		if((value.messageNumber == 8300 || value.messageNumber == 8021) && value.code==order.exceptionNumber){
        			       		vm.rejectionReason = value.rejectionReason; 
        			   		}
        			   	});
            			
        		}
        		
            	if(order.buySellIndicator.toUpperCase()=='BUYY'){
            		order.buySellIndicator = 'BUY'
            	}
            	
      
            	
            	var baseCurrency = order.instrumentCode.split('/')[0];
            	//build the initial notification string
            	vm.initialString = order.buySellIndicator + " order for client" + " " + order.customerCode + ", " + order.instrumentCode + " " + baseCurrency + " " + order.orderAmount + " at " 
            		+ order.typeOfOrder + " " + order.limitExchangeRate + " " + order.timeLimitIndicator + " by " + order.retailUserCode;
            	
            	
            	//notification string if message number is 2300
            	
            	buildNotificationString(order);
            	
            	
        		
        	}
        }
        
        
        
        //build notification based on message number
        
        function buildNotificationString(order){
        	
        
        	if(order.messageNumber=='2300' || order.messageNumber=='2021'){
        		
        		buildStringForOrderRequest(order);
        	}
        	
        	else if(order.messageNumber=='8300' || order.messageNumber=='8021'){
        		
        		buildStringForOrderResponse(order);
        	}
        	
    		
        }
        
        //notification string for message number 2021/2300
        
        function buildStringForOrderRequest(order){
        	
        	
    			if(order.errorMessage!=''){
    				vm.rejectionString = vm.initialString + " rejected due to " + "&quot;" + order.errorMessage + "&quot;";
    				if(order.activityIndicator=='PLAC'){
    					vm.messageString = "PLACE ORDER rejected by RMS. " + vm.rejectionString;
    				}else if(order.activityIndicator=='MDFY'){
    					vm.messageString = "MODIFY ORDER rejected by RMS. " + vm.rejectionString;
    				}else if(order.activityIndicator=='CNCL'){
    					vm.messageString = "CANCEL ORDER rejected by RMS. " + vm.rejectionString;
    				}
    				
    				$.growl.error({ title: "Order Rejection", message: vm.messageString });
    			}else{
    				if(order.exceptionNumber==0){
        				if(order.activityIndicator=='PLAC'){
        					
        					vm.messageString = "PLACE ORDER submitted to Host. " + vm.initialString;
        				}else if(order.activityIndicator=='MDFY'){
        					vm.messageString = "MODIFY ORDER submitted to Host. " + vm.initialString;
        				}else if(order.activityIndicator=='CNCL'){
        					vm.messageString = "CANCEL ORDER submitted to Host. " + vm.initialString;
        				}
        				
        				$.growl.notice({ title: "Order Acceptance", message: vm.messageString });
        			}
        			else{
        				vm.rejectionString = vm.initialString + " rejected due to " + "&quot;" + order.errorMessage + "&quot;";
        				if(order.activityIndicator=='PLAC'){
        					vm.messageString = "PLACE ORDER rejected by RMS. " + vm.rejectionString;
        				}else if(order.activityIndicator=='MDFY'){
        					vm.messageString = "MODIFY ORDER rejected by RMS. " + vm.rejectionString;
        				}else if(order.activityIndicator=='CNCL'){
        					vm.messageString = "CANCEL ORDER rejected by RMS. " + vm.rejectionString;
        				}
        				
        				$.growl.error({ title: "Order Rejection", message: vm.messageString });
        			}
    			}
    	
    		
        }
        
      //notification string if message number is 8021/8300
        
        function buildStringForOrderResponse(order){
        	
        	
    			if(order.exceptionNumber==0){
    				vm.acceptanceMessage = vm.initialString + " accepted by Host. Order Sequence Number - " + order.orderSequenceNumber;
    				if(order.activityIndicator=='PLAC'){
    					vm.messageString = "PLACE ORDER ACCEPTANCE. " + vm.acceptanceMessage;
    				}else if(order.activityIndicator=='MDFY'){
    					vm.messageString = "ORDER MODIFICATION ACCEPTANCE. " + vm.acceptanceMessage;
    				}else if(order.activityIndicator=='CNCL'){
    					vm.messageString = "ORDER CANCELLATION ACCEPTANCE. " + vm.acceptanceMessage;
    				}
    				
    				$.growl.notice({ title: "Order Confirmation", message: vm.messageString });
    			}
    			else{
    				vm.rejectionString = vm.initialString + " rejected due to " + "&quot;" + vm.rejectionReason + "&quot;";
    				if(order.activityIndicator=='PLAC'){
    					vm.messageString = "PLACE ORDER REJECTION. " + vm.rejectionString;
    				}else if(order.activityIndicator=='MDFY'){
    					vm.messageString = "ORDER MODIFICATION REJECTION. " + vm.rejectionString;
    				}else if(order.activityIndicator=='CNCL'){
    					vm.messageString = "ORDER CANCELLATION REJECTION. " + vm.rejectionString;
    				}
    				
    				$.growl.error({ title: "Order Rejection", message: vm.messageString });
    			}
    		
        }
        
        vm.initialTradeMessage="";
        
        
        //prepare trade notification
        function frameTradeNotification(trade){
        	
        	if(trade!=null && trade!=undefined){
        		
        		if(trade.buySellIndicator.toUpperCase()=='BUYY'){
        			trade.buySellIndicator='Buy';
        		}
        		
        		var baseCurrency = trade.instrumentCode.split('/')[0];
        		vm.initialTradeMessage = trade.buySellIndicator + " trade " + trade.tradeSequenceNumber + " for " + trade.customerCode + ", " + trade.instrumentCode + " " + baseCurrency + 
        		  " " + trade.tradedAmount + " at " + trade.tradedExchangeRate + " for order number " + trade.orderSequenceNumber;
        		
        		$.growl.notice({ title: "Trade Confirmation", message: vm.initialTradeMessage });
        	}
        }
        
        function swapQuoteChanges(swapQuote){
        	//var existingQuotes = vm.bankComparativeQuotes;
        	angular.forEach(vm.bankComparativeQuotes, function(value, index){
        		if(value.bank.bankName==swapQuote.bank.bankName){
        			vm.bankComparativeQuotes[index] = swapQuote;
        			
        			//change swap quotes in home page
        			prepareSwapQuotes();

        		}
        	})
        	//vm.bankComparativeQuotes = existingQuotes;
        }
        
        //add remarks for order request
        function addRemarks(){
        	$state.go('add-remarks', {remarks: vm.remarks});
        }
        
        /*$rootScope.$on('addExpiryTime', function(event, result){
        	vm.orderDTO.expiryTime = $rootScope.expiryTime;
        	if(vm.userPreference.showPreOrderConfirmation=='yes'){
            	$rootScope.orderDTO = vm.orderDTO;
            	$state.go('pre-order-confirmation');
        	}else{
        		if(activityIndicator=='PLAC'){
            		placeOrderRequest(vm.orderDTO);
        		}else if(activityIndicator=='MDFY'){
        			Market.modifyOrder(vm.orderDTO);
        		}else if(activityIndicator=='CNCL'){
        			Market.cancelOrder(vm.orderDTO);
        		}
        	}
        });*/
        
        $rootScope.$on('addRemarks', function(event, result) {
			vm.remarks = $rootScope.remarks;
		});
        
        var orderplacedsuccess = $rootScope.$on('orderplacedsuccess', function(event, result) {
			vm.remarks = "";
			fillDefaultValuesToControls();
		});
        
        //expand market depth tab
        function expandMarketDepth(instrumentCode, marketDepth){
        	$rootScope.marketDepth = marketDepth;
        	$rootScope.instrument = instrumentCode;
        	$state.go('market-depth-expand');
        }
        
      //open market statistics tab
        function openMarketStatistics(instrumentCode){
        	$rootScope.instrument = instrumentCode;
        	$state.go('market-statistics');
        }
        
        function openOrderPreference(){
        	$state.go('order-config');
        }
        
        
        function prepareSwapQuotes(){
    		//prepare bank comparativeQuotes in price
    		prepareBankComparativeQuotesInPrice(vm.bankComparativeQuotes, vm.retailSpotMarketWatch);
    		
    		//get best offer and bid spread for both Cash/spot and tom/spot.
    		getBestSpreadRates(vm.bankComparativeQuotes);
    		
        	if(vm.bankComparativeQuotes.length==1){
            	vm.defaultBankSpread = vm.bankComparativeQuotes[0];
        	}else{
        		//get default bank swap quotes for the customer user
        		vm.defaultBankSpread = MarketWatch.getDefaultBankSwapQuotes(vm.bankComparativeQuotes, vm.defaultTradingBank);
        	}
    		if(vm.defaultBankSpread!=null && vm.defaultBankSpread!=undefined){
    			onGetDefaultTradingBankSpreadSuccess();
    		}
        }
        
        function onGetswapQuotesFeedFailure(){
        	
        }
        
        function limitChangeRequest(){
         	if(vm.bankFilterForLimit!=null && vm.bankFilterForLimit!=undefined && vm.globalValues.getOrganisation().organisationType.shortName=='CUSTOMER'){
        		workflowSharedService.viewFrom = "customer_limitSettings";
        		var customerId =vm.globalValues.getOrganisation().id ;
        		var bankId =  vm.bankFilterForLimit.id;
     			var state = 'customer_limit_Settings';
     			$state.go(state,{customerId:customerId, bankId : bankId});
            	//$state.go('customer_limit_Settings',{customerId:vm.globalValues.getOrganisation().id, bankId : vm.bankFilterForLimit.id});
        	}
        }
        
        function getBuyingPower(limit){
        	var buyingPower = 0;
        	var totalBuy = limit.totalPendingBuyOrderValue + limit.totalBuyTradeValue + limit.previousDayBuyTradeValue;
        	var totalSell = limit.totalPendingSellOrderValue + limit.totalSellTradeValue + limit.previousDaySellTradeValue;
        	if(limit.limitType=='GROSSSELL'){
        		buyingPower = 0;
        	}else if(limit.limitType=='GROSSBUY'){
        		buyingPower = limit.limitAllocatedInUSD - (totalBuy);
        	}else if(limit.limitType=='GLOBALGROSS'){
        		buyingPower = limit.limitAllocatedInUSD - (totalBuy + totalSell);
        	}else if(limit.limitType=='NET'){
        		totalBuy = limit.totalPendingBuyOrderValue+((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue));
        		totalSell = limit.totalPendingSellOrderValue+((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue  + limit.previousDayBuyTradeValue));
        		var xVals = [];
        		xVals.push(totalBuy);
        		xVals.push(totalSell);
        		buyingPower = limit.limitAllocatedInUSD - totalBuy;
        	}
        	return buyingPower;
        }
        
        vm.getExposure = function getExposure(limit){
        	var exposure = 0;
        	var totalBuy = 0;
        	var totalSell = 0;
        	if(limit.limitType!='NET'){
            	totalBuy = limit.totalPendingBuyOrderValue + limit.totalBuyTradeValue + limit.previousDayBuyTradeValue;
            	totalSell = limit.totalPendingSellOrderValue + limit.totalSellTradeValue + limit.previousDaySellTradeValue;
            	exposure = (limit.totalPendingBuyOrderValue + limit.totalBuyTradeValue + limit.previousDayBuyTradeValue + limit.totalPendingSellOrderValue + limit.totalSellTradeValue + limit.previousDaySellTradeValue) * 100/limit.limitAllocatedInUSD;
        	}else{
        		totalBuy = limit.totalPendingBuyOrderValue+((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue));
        		totalSell = limit.totalPendingSellOrderValue+((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue));

            	var xVals = [];
        		xVals.push(totalBuy);
        		xVals.push(totalSell);
        		exposure =  Math.max.apply(Math, xVals) * 100/limit.limitAllocatedInUSD;
        	}
        	return exposure;
        }
        
        function getSellingPower(limit){
        	var sellingPower = 0;
        	var totalBuy = limit.totalPendingBuyOrderValue + (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue);
        	var totalSell = limit.totalPendingSellOrderValue + (limit.totalSellTradeValue + limit.previousDaySellTradeValue);
        	if(limit.limitType=='GROSSSELL'){
        		sellingPower = limit.limitAllocatedInUSD - (totalSell);
        	}else if(limit.limitType=='GROSSBUY'){
        		sellingPower = 0;
        	}else if(limit.limitType=='GLOBALGROSS'){
        		sellingPower = limit.limitAllocatedInUSD - (totalBuy + totalSell);
        	}else if(limit.limitType=='NET'){
        		totalBuy = limit.totalPendingBuyOrderValue+((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue));
        		totalSell = limit.totalPendingSellOrderValue+((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue));
        		var xVals = [];
        		xVals.push(totalBuy);
        		xVals.push(totalSell);
        		sellingPower = limit.limitAllocatedInUSD - totalSell;
        	}
        	return sellingPower;
        }

		 $scope.$watch('vm.currencyPair', function (value) {
         if (value != null && value != undefined) {
			getInstrumentMatchedCurrencypair();
    	}
		})

		function getInstrumentMatchedCurrencypair(){
            var currencyPairId = vm.globalValues.getDefaultCurrencyPairId();
            if (!vm.currencyPair != null && vm.currencyPair != undefined) {
                currencyPairId = vm.currencyPair.id;
            }
			DefaultMarket.csInstruments({currencyPairId:currencyPairId},onGetInstrumentSuccess, onGetInstrumentFailure);
            
        }   
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-todo', {
            parent: 'entity',
            url: '/customer-todo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.dashboard.customerToDo" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/dashboard/2/dashboard.html',
                    controller: 'CustomerApprovalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('customerToDo');
                    $translatePartialLoader.addPart('customer-registration');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('CustomerApproval', CustomerApproval);

    CustomerApproval.$inject = ['$resource','DateUtils'];

    function CustomerApproval ($resource, DateUtils) {
        var resourceUrl = 'api/tasks/';
        return $resource(resourceUrl, {}, {
            'query': { 
            	method: 'GET', 
            	isArray: true, 
            	url: 'api/customer-approval/orgId/:orgId',
            	transformResponse: function (data) {
	                if (data) {
	                    data = angular.fromJson(data);   
	                    angular.forEach(data,function(value,index){                	
	                    	value.payload = angular.fromJson(value.payload);
	                    	var getDate = value.createdDate;
	                        getDate = getDate.substring(0, getDate.indexOf('T'));
	                        value.createdDate = getDate;
	                    })
	                }
                return data;
            }},
            'get': {
                method: 'GET',               
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);                                              
                    }
                    return data;
                }
            },
            'approve': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'approveCustomerRegistration': {
                method: 'POST',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve-customer-registration',
    			transformRequest : function(data) {
    				var copy = angular.copy(data);
    				return angular.toJson(copy);
    			}
            },
            'reject': {
                method: 'POST',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'view':{
            	method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId',
                transformResponse: function (data) {                	
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'discard': {
            	 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/discard'
            },
            'resubmitCustomerInfo' : {
				method : 'PUT',
				params : {
					taskId : '@taskId'
				},
				url : 'api/tasks/:taskId/resubmitCustomer/customer',
				transformRequest : function(data) {
					var copy = angular.copy(data);
					return angular.toJson(copy);
				}
			},
			'resubmitUpdatedCustomerInfo' : {
				method : 'POST',
				url : 'api/tasks/resubmitUpdatedCustomer',
				headers: {
                    'Content-Type': undefined
                }
			},
			'getBankDetails' : {
				method : 'GET',
				params : {
					
					customerId : '@customerId',
					bankId : '@bankId'
				},
				url : 'api/trading-details-for-customer-bank/:customerId/customer/:bankId/bank',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			}
			
            
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function() {
            this.viewFrom = ''
        })
        .controller('CustomerApprovalController', CustomerApprovalController);

    CustomerApprovalController.$inject = ['$scope', '$timeout', '$state', '$stateParams', 'workflowSharedService', 'CustomerApproval', '$rootScope', 'GlobalValues', 'Workflow', '$filter', 'ScreenLog', 'entityConstants','DefaultMarkup','AlertService','MessageBox'];

    function CustomerApprovalController($scope, $timeout, $state, $stateParams, workflowSharedService, CustomerApproval, $rootScope, GlobalValues, Workflow, $filter, ScreenLog, entityConstants,DefaultMarkup,AlertService,MessageBox) {
        var vm = this;
        vm.screenLog = ScreenLog;
        vm.tasks = [];
        vm.getTasks = [];
        vm.approveEntity = approveEntity; 
        vm.rejectEntity = rejectEntity;
        vm.viewEntity = viewEntity;
        vm.discardEntity = discardEntity;
        
        vm.globalValues=GlobalValues;
        vm.userType = vm.globalValues.getOrganisation().organisationType.shortName;
        vm.userLogin=vm.globalValues.getUser().login;
        
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.CUSTOMER_APPROVAL;
        logScreenAccess();
        
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
 	    $scope.page = 1;
        
        loadAll();

        function loadAll() {
            CustomerApproval.query({ "orgId": GlobalValues.getOrgId() }, function(result) {
                vm.fetchedTasks = result;
                vm.tasks = [];
                
                angular.forEach(vm.fetchedTasks, function(task) {
                	task.changeType = getChangeType(task);
                	console.log(angular.toJson(task));
                	if(task.entity.shortName == 'Customer'){
                		
                		CustomerApproval.getBankDetails({ "customerId":  task.entityRecordID, "bankId" : GlobalValues.getOrgId() }, 
                			function(bankDetails){ 
                				task.bankAccNumber = bankDetails.bankAccountNumber;
                			}).$promise.then(function(){
                				
                            });
                	}                		
                    vm.tasks.push(task);
                });
            });
        }

        function approveEntity(entityList) {
        	vm.screenLog.screenLog(entityList.entity.shortName, entityList.entityRecordID==null?0:entityList.entityRecordID, entityConstants.ENTITY_ACTION_TYPE.APPROVE);
        	// Terms and conditions agree not requeired on approval  - 22 june 2020 (TAC CR)
        	//instead disclaimer required for customer approval,no check box , just information
        	if(entityList.changeType != 'DELETE' && entityList.entity.shortName != 'Customer' ){
                if(entityList.payload.markupSettings==null){
                    DefaultMarkup.getByBank({"bankId":entityList.payload.bank.id}, onSaveSuccess, onSaveError);
                    function onSaveSuccess (result) {
                        if(result!=null){
                            if(result.markupType==null||result.markupType==undefined||result.markupType==''){
                                AlertService.error('Please assign the markup type');
                            }else if(result.markupValue==null||result.markupValue==undefined||result.markupValue==''){
                                AlertService.error('Please assign the markup value');
                            }else if(result.roEdApplicabilityMethod==null||result.roEdApplicabilityMethod==undefined){
                                AlertService.error('Please assign the RO/ED applicability method');
                            }else{
                                MessageBox.openMessageBox("Alert", "Please note the system will assign the default markup set by the bank for this customer. Do you want to proceed?", "ProceedCancel", "setDefaultMarkup");
                            }  
                        }
                    } 
                }else{
                    $state.go('customer-registration-apporval-disclaimer', {entityId : entityList.id,customerId:null,tradingBank : null});
                }
                  
                $rootScope.$on('gatewayApp.messagebox.proceed.setDefaultMarkup', function (event, data) {
                    $state.go('customer-registration-apporval-disclaimer', {entityId : entityList.id,customerId:null,tradingBank : null});
                });
                
                $rootScope.$on('gatewayApp.messagebox.cancel.setDefaultMarkup', function (event, data) {
                    //do not proceed
                }); 
                function onSaveError () {
                    
                }
        		
        	}else{
        		 $scope.rowID = entityList.id;
        		 CustomerApproval.approve({ "taskId": entityList.id }, onApproveSuccess, onApproveError);
        	}
        	
           /* $scope.rowID = entityList.id;
            
            //ScreenLog.screenLog({'entityName': entityList.entity.shortName, 'entityRecordId': entityList.entityRecordID==null?0:entityList.entityRecordID, 'action': 'APPROVE'});
            CustomerApproval.approve({ "taskId": entityList.id }, onApproveSuccess, onApproveError);*/
        }

        function onApproveSuccess(result) {
            var flag = $filter('filter')(vm.tasks, { id: $scope.rowID });
            $rootScope.removeRow($scope.rowID);
        }
        
        

        function onApproveError(error) {}

        vm.checkTaskWithCurrentLogin = function checkTaskWithCurrentLogin(taskHistory){
        	var isValidTask = true;
        	var versionNo = getMaxVersionOfTask(taskHistory);
        	if(taskHistory!=null && taskHistory!=undefined){
        		angular.forEach(taskHistory, function(value){
        			if(value!=null && value!=undefined){
        				if(value.action=="APPROVED" && value.version == versionNo){
        					if(value.createdBy==vm.userLogin){
        						isValidTask = false;
        					}
        				}
        			}
        		});
        		return isValidTask;
        	}
        }
        
        function getMaxVersionOfTask(taskHistory){
        	var versionNo = 0;
        	if(taskHistory!=null && taskHistory!=undefined){
        		if(taskHistory.length>0){
        			versionNo = taskHistory[taskHistory.length-1].version;
        		}
        	}
        	return versionNo;
        }

        function rejectEntity(entityList) {
            $scope.rowID = entityList.id;
            vm.screenLog.screenLog(entityList.entity.shortName, entityList.entityRecordID==null?0:entityList.entityRecordID, entityConstants.ENTITY_ACTION_TYPE.REJECT);
            //ScreenLog.screenLog({'entityName': entityList.entity.shortName, 'entityRecordId': entityList.entityRecordID==null?0:entityList.entityRecordID, 'action': 'REJECT'});
            Workflow.rejectCustomerApproval(entityList.id);
        }
        
        function discardEntity(entityList) {
            $scope.rowID = entityList.id;
            vm.screenLog.screenLog(entityList.entity.shortName, entityList.entityRecordID==null?0:entityList.entityRecordID, entityConstants.ENTITY_ACTION_TYPE.DISCARD);
            //ScreenLog.screenLog({'entityName': entityList.entity.shortName, 'entityRecordId': entityList.entityRecordID==null?0:entityList.entityRecordID, 'action': 'DISCARD'});
            CustomerApproval.discard({ "taskId": entityList.id }, onDiscardSuccess, onDiscardError);
        }

        function onDiscardSuccess(result) {
            $rootScope.removeRow($scope.rowID);
        }

        function onDiscardError(error) {
        	
        }
        
        function viewEntity(entity,id,payload,action,changeType, recordId){
            $rootScope.payload = payload;
            $rootScope.taskID = id;
            var param;
            var state;
            vm.screenLog.screenLog(entity,recordId==null?0:recordId, entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS);
            workflowSharedService.viewFrom ='customerregistrationtodolist_checker';
            if(entity == 'Customer'){
            	state = 'customer-update-approval-todo-view';
            }else{
            	state = 'customer-approval-todo-view';
            }
           
            
            $state.go(state,{ 'mode' :param  });
        }
        
       
        
        
        
        
    	function getChangeType(task){
    		if(task.changeType == 'CREATE' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'ADDED';
    		}else
    			 return task.changeType;
    		
    	}
    	
        $rootScope.removeRow = function(id) {
            var index = -1;
            var comArr = eval(vm.tasks);
            for (var i = 0; i < comArr.length; i++) {
                if (comArr[i].id === id) {
                    index = i;
                    break;
                }
            }
            if (index === -1) {
                //alert("Something gone wrong");
            }
            vm.tasks.splice(index, 1);
        };

        $scope.toggle = true;
        $scope.refresh = function() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
        
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }

    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dashboard', {
            parent: 'entity',
            url: '/dashboard',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.dashboard.todo" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/dashboard/1/dashboard.html',
                    controller: 'DashBoardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('bankRegistration');
                    $translatePartialLoader.addPart('branch');
                    $translatePartialLoader.addPart('smsSettings');
                    $translatePartialLoader.addPart('defaultMarkupSettings');
                    $translatePartialLoader.addPart('markupSettings');
                    $translatePartialLoader.addPart('heConnectivitySettings');
                    $translatePartialLoader.addPart('intradayMarketSessionSettings');
                    $translatePartialLoader.addPart('defaultMarketSessionSettings');
                    $translatePartialLoader.addPart('emailSettings');
                    $translatePartialLoader.addPart('amcSettings');
                    $translatePartialLoader.addPart('customerCharges');
                    $translatePartialLoader.addPart('gstSettings');
                    $translatePartialLoader.addPart('transactionChargesSettings');
                    $translatePartialLoader.addPart('uploadDownloadCertificates');
                    $translatePartialLoader.addPart('clearCorpTACUpload');
                    $translatePartialLoader.addPart('exposureType');
                    $translatePartialLoader.addPart('exposureSubType');
                    $translatePartialLoader.addPart('creditFactorSettings');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('Tasks', Tasks);

    Tasks.$inject = ['$resource','DateUtils'];

    function Tasks ($resource, DateUtils) {
        var resourceUrl = 'api/tasks/';
        return $resource(resourceUrl, {}, {
            'query': { 
            	method: 'GET', 
            	isArray: true, 
            	url: 'api/tasks/orgId/:orgId',
            	transformResponse: function (data) {
	                if (data) {
	                    data = angular.fromJson(data);   
	                    angular.forEach(data,function(value,index){                	
	                    	value.payload = angular.fromJson(value.payload);
	                    	// var getDate = value.createdDate;
	                        // getDate = getDate.substring(0, getDate.indexOf('T'));
	                        // value.createdDate = getDate;
	                    })
	                }
                return data;
            }},
            'get': {
                method: 'GET',               
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);                                              
                    }
                    return data;
                }
            },
            'approve': {
                method: 'GET',
                isArray: true, 
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'POST',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'view':{
            	method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId',
                transformResponse: function (data) {                	
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'discard': {
            	 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/discard'
            },
            'orderApprove': {
                method: 'GET', 
                params: {taskId:'@taskId'},
                url: 'order/tasks/:taskId/approve'
            },
            'orderApproveImport': {
                method: 'GET', 
                isArray: 'true',
                params: {taskId:'@taskId'},
                url: 'order/tasks/:taskId/approve'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function() {
            this.viewFrom = ''
        })
        .controller('DashBoardController', DashBoardController);

    DashBoardController.$inject = ['$scope', '$timeout', '$state', '$stateParams', 'workflowSharedService', 'Tasks', '$rootScope', 'GlobalValues', 
    	'Workflow', '$filter', 'ScreenLog','entityConstants','MessageBox', 'AlertService'];

    function DashBoardController($scope, $timeout, $state, $stateParams, workflowSharedService, Tasks, $rootScope, GlobalValues, 
    		Workflow, $filter, ScreenLog,entityConstants,MessageBox , AlertService) {
        var vm = this;
        vm.screenLog = ScreenLog;
        vm.tasks = [];
        vm.getTasks = [];
        vm.approveEntity = approveEntity; 
        vm.rejectEntity = rejectEntity;
        vm.viewEntity = viewEntity;
        vm.discardEntity = discardEntity;
        vm.resubmitEntity = resubmitEntity;
        vm.globalValues=GlobalValues;
        vm.userLogin=vm.globalValues.getUser().login;
        $scope.refresh = refresh;
        vm.loggedinEntityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
        
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;;
        $scope.noOfRecordsPerPage1 = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page1 = 1;;
        
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.TODO;
        vm.entityConstants = entityConstants;
        
        loadAll();
        logScreenAccess();

        function loadAll() {
            Tasks.query({ "orgId": GlobalValues.getOrgId() }, function(result) {
                vm.fetchedTasks = result;
                vm.tasks = [];
                angular.forEach(vm.fetchedTasks, function(task) {
                	task.taskAction = task.changeType;
                	task.changeType = getChangeType(task);                	
                    vm.tasks.push(task);
                });
                
            });
        }
        
        vm.checkTaskWithCurrentLogin = checkTaskWithCurrentLogin;
        function checkTaskWithCurrentLogin(taskHistory){
        	var isValidTask = true;
        	var versionNo = getMaxVersionOfTask(taskHistory);
        	if(taskHistory!=null && taskHistory!=undefined){
        		angular.forEach(taskHistory, function(value){
        			if(value!=null && value!=undefined){
        				if((value.action=="APPROVED" || value.action=="CREATED" || value.action=="RESUBMITTED") && value.version == versionNo && taskHistory[taskHistory.length-1].action!="REJECTED"){
        					if(value.createdBy==vm.userLogin){
        						isValidTask = false;
        					}
        				}
        			}
        		});
        		return isValidTask;
        	}
        }
        
        $scope.customFilter1 = function customFilter1(taskList){
        	return (taskList.lastModifiedBy==vm.userLogin && taskList.changeType!='Rejected' ) || ((!checkTaskWithCurrentLogin(taskList.taskHistory) && taskList.changeType!='Rejected'));
        }
        
        $scope.customFilter = function customFilter(taskList){
        	return (taskList.lastModifiedBy!=vm.userLogin || taskList.changeType=='Rejected') && (checkTaskWithCurrentLogin(taskList.taskHistory) || taskList.changeType=='Rejected');
        }
        
        function getMaxVersionOfTask(taskHistory){
        	var versionNo = 0;
        	if(taskHistory!=null && taskHistory!=undefined){
        		if(taskHistory.length>0){
        			versionNo = taskHistory[taskHistory.length-1].version;
        		}
        	}
        	return versionNo;
        }

        function approveEntity(entityList) {
            $scope.rowID = entityList.id;
            vm.screenLog.screenLog(entityList.entity.shortName, entityList.entityRecordID==null?0:entityList.entityRecordID, entityConstants.ENTITY_ACTION_TYPE.APPROVE);
            vm.taskChangeType = entityList.changeType;
            vm.taskEntityType = entityList.entity.shortName;
            //ScreenLog.screenLog({'entityName': entityList.entity.shortName, 'entityRecordId': entityList.entityRecordID==null?0:entityList.entityRecordID, 'action': 'APPROVE'});
           if(entityList.entity.shortName == 'CustomerLimitChangeRequest'|| entityList.entity.shortName == 'PendingOrderReport' || ( entityList.entity.shortName =='LimitSettings'  && vm.taskChangeType!='Imported' )){
        	   
        	   Tasks.orderApprove({ "taskId": entityList.id }, onApproveSuccess, onApproveError);
           }else if( entityList.entity.shortName =='LimitSettings' && vm.taskChangeType =='Imported'  ){
        	   
        	   Tasks.orderApproveImport({ "taskId": entityList.id }, onApproveSuccess, onApproveError);
           }else if(entityList.entity.shortName == 'TermsAndConditionsView' && vm.taskChangeType =='Agreed' ){
        	 
               $rootScope.taskID =  entityList.id;  
               var tacAgreedDTOPayload  = angular.fromJson(angular.copy(  entityList.payload));        	    
        	   $state.go('tac-agree-confirmation-todo', {tacTypeId :tacAgreedDTOPayload.tacAgreedEntities.tacType.id} );
       	   }else if(entityList.entity.shortName == 'CustomerTermsAndConditionsUpload' && vm.taskChangeType =='Imported' ){
       		
       		   $state.go('customer-tac-upload-apporval-disclaimer', {entityId : entityList.id});
       	   }else{
       		   
        	   if( vm.taskEntityType== 'HomeBranchIFSCUpload'){
        		   MessageBox
					.showMessageBox(
							"Alert",
							"Home Branch Import approval is still in progress... Please wait",
							"autoclose");
        	   }
        	   
        	   Tasks.approve({ "taskId": entityList.id }, onApproveSuccess, onApproveError);
           }
           
        }

        function onApproveSuccess(result) {
        	console.log("import result type " + typeof result);
        	if(vm.taskChangeType=='Imported'){
        		if(  vm.taskEntityType == 'HomeBranchIFSCUpload'){        			
        			 MessageBox.closeMessageBox("autoclose");
        		}
	        	if(result.length!=undefined && result.length >0) {
	        		exportException(result, true, 'Import' + '_error');
	        	}else if(  vm.taskEntityType != 'CustomerTermsAndConditionsUpload' &&  vm.taskEntityType != 'TermsAndConditionsUpload' && vm.taskEntityType!='BankFeesChargesUpload'){
	        		//MessageBox.showMessageBox("Alert", " File has been uploaded successfully.  ", "Ok");
	        		AlertService.success($filter('translate')('error.upload.success'));
	        	}
        	}
            var flag = $filter('filter')(vm.tasks, { id: $scope.rowID });
            $rootScope.removeRow($scope.rowID);
            refresh();
        }

        function onApproveError(result) {
        	if(  vm.taskEntityType == 'HomeBranchIFSCUpload'){        		
        		 MessageBox.closeMessageBox("autoclose");
    		}
        }

    	function exportException(JSONData, showHeader, fileName) {

			if (JSONData != "") {
				var arrData = typeof (JSONData) != 'object' ? JSON
						.parse(JSONData) : JSONData;
						var out = arrData[arrData.length-1];
					if (out == "failure") {
							MessageBox.showMessageBox("Alert",
									"File upload failed! Please check the error log. ",
									"Ok");
							//generateFile(arrData,fileName);
					} 
					else if(out=="invalid"){
								MessageBox.showMessageBox("Alert",
										"Invalid file",
										"Ok");
					} else {
					MessageBox
							.showMessageBox(
									"Alert",
									"Partial success! Please check the error log for the failed records.  ",
									"Ok");
				}
						
				var csv = "";
				
				
				
				console.log(out);
				
				

				for (var i = 0; i <= arrData.length-2; i++) {

					var row = "";

					row += arrData[i];
					
					/*for ( var index in arrData[i]) {
						
					}
*/
					row = row.slice(0, row.length - 1);

					csv += row + '\r\n';

				}
				
				console.log(csv);

				if (csv != '') {
					//csv = 'test, test'
					/*var uri = 'data:text/csv;charset=UTF-8,' + escape(csv);

					var link = document.createElement("a");
					link.href = uri;

					link.style = 'hidden';
					link.download = fileName + '.csv';

					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);*/
					var blob = new Blob([csv], { type: "application/" + "csv" })
		            window.saveAs(blob, fileName + "."  + "csv");

				}
			}

		}

	

        function rejectEntity(entityList) {
            $scope.rowID = entityList.id;
            $rootScope.action = entityList.taskAction;
            vm.screenLog.screenLog(entityList.entity.shortName, entityList.entityRecordID==null?0:entityList.entityRecordID, entityConstants.ENTITY_ACTION_TYPE.REJECT);
            //ScreenLog.screenLog({'entityName': entityList.entity.shortName, 'entityRecordId': entityList.entityRecordID==null?0:entityList.entityRecordID, 'action': 'REJECT'});
            Workflow.rejectTask(entityList.id, onRejectSuccess, onRejectError);
        }
        
        function onRejectSuccess(){
        	refresh();
        }
        
        function onRejectError(){
        		
        }
        
        function discardEntity(entityList) {
            $scope.rowID = entityList.id;
            vm.screenLog.screenLog(entityList.entity.shortName, entityList.entityRecordID==null?0:entityList.entityRecordID, entityConstants.ENTITY_ACTION_TYPE.DISCARD);
            //ScreenLog.screenLog({'entityName': entityList.entity.shortName, 'entityRecordId': entityList.entityRecordID==null?0:entityList.entityRecordID, 'action': 'DISCARD'});
            Tasks.discard({ "taskId": entityList.id }, onDiscardSuccess, onDiscardError);
        }

        function onDiscardSuccess(result) {
            $rootScope.removeRow($scope.rowID);
            refresh();
        }

        function onDiscardError(error) {
        	
        }
        
        function viewEntity(entity,id,payload,action,changeType, recordId,entityShortName, taskAction){
        	$rootScope.payload = payload;
            $rootScope.taskID = id;          
            $rootScope.action = taskAction;          
            
            vm.screenLog.screenLog(entity, recordId==null?0:recordId, entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS);
            workflowSharedService.viewFrom = getViewFrom(entity,action,changeType,entityShortName);
            workflowSharedService.importType = entity;
            var state = getState(entity, action,changeType,entityShortName);
            $state.go(state);
        }
        
        function resubmitEntity(entity,id,payload,changeType,recordId,taskAction){
            $rootScope.payload = payload;
            $rootScope.taskID = id;
            $rootScope.action = taskAction;
                        
            //vm.screenLog.screenLog(entity, recordId==null?0:recordId, entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS);
            workflowSharedService.viewFrom = getViewFrom(entity,'resubmit',changeType,'', taskAction);
            var state = getState(entity, 'resubmit',changeType,'');
            $state.go(state);
        }
        
       
        function getViewFrom(entity,action,changeType,entityShortName, taskAction){
        	
        	
        	
        	if (entity == 'SecurityPolicy' && action == "checker"){
        		return 'securityPolicytodolist_checker';
        	}
        	else if (entity == 'SecurityPolicy' && action == "maker"){
        		return 'securityPolicytodolist_maker';
        	}
        	else if (entity == 'SecurityPolicy' && action == "resubmit"){
        		return 'securityPolicy_resubmit';
        	}
        	else if (entity == 'GlobalSecurityPolicy' && action == "checker"){
        		return 'globalSecurityPolicytodolist_checker';
        	}
        	else if (entity == 'GlobalSecurityPolicy' && action == "maker"){
        		return 'globalSecurityPolicytodolist_maker';
        	}
        	else if (entity == 'GlobalSecurityPolicy' && action == "resubmit"){
        		return 'globalSecurityPolicy_resubmit';
        	}
        	else if (entity == 'UserAdminApplicationWideSettings' && action == "checker"){
        		return 'applicationWideSettingstodolist_checker';
        	}
        	else if (entity == 'UserAdminApplicationWideSettings' && action == "maker"){
        		return 'applicationWideSettingstodolist_maker';
        	}
        	else if (entity == 'UserAdminApplicationWideSettings' && action == "resubmit"){
        		return 'applicationWideSettings_resubmit';
        	}
        	else if (entity == 'DealingAdminApplicationWideSettings' && action == "checker"){
        		return 'dealingAdminApplicationWideSettingstodolist_checker';
        	}
        	else if (entity == 'DealingAdminApplicationWideSettings' && action == "maker"){
        		return 'dealingAdminApplicationWideSettingstodolist_maker';
        	}
        	else if (entity == 'DealingAdminApplicationWideSettings' && action == "resubmit"){
        		return 'dealingAdminApplicationWideSettingstodolist_resubmit';
        	}
			else if (entity == 'TransactionParametersSettings' && action == "checker"){
        		return 'TransactionParametersSettingstodolist_checker';
        	}
        	else if (entity == 'TransactionParametersSettings' && action == "maker"){
        		return 'TransactionParametersSettingstodolist_maker';
        	}
        	else if (entity == 'TransactionParametersSettings' && action == "resubmit"){
        		return 'TransactionParametersSettingstodolist_resubmit';
        	}

        	else if (entity == 'EntityStateApprovalProcess' && action == "checker"){
        		return 'entityActionApprovalPolicytodolist_checker';
        	}
        	else if (entity == 'EntityStateApprovalProcess' && action == "maker"){
        		return 'entityActionApprovalPolicytodolist_maker';
        	}
        	else if (entity == 'EntityStateApprovalProcess' && action == "resubmit"){
        		return 'entityActionApprovalPolicy_resubmit';
        	}
        	
            else if (entity == 'EntityRestriction' && action == "checker"){
                return 'entityRestrictionstodolist_checker';
            }
            else if (entity == 'EntityRestriction' && action == "maker"){
                return 'entityRestrictionstodolist_maker';
            }
            else if (entity == 'EntityRestriction' && action == "resubmit"){
                return 'entityRestrictionstodolist_resubmit';
            }

        	
        	else if (entity == 'ManageGlobalEntityStateApprovalProcess' && action == "checker"){
        		return 'globalEntityActionApprovalPolicytodolist_checker';
        	}
        	else if (entity == 'ManageGlobalEntityStateApprovalProcess' && action == "maker"){
        		return 'globalEntityActionApprovalPolicytodolist_maker';
        	}
        	else if (entity == 'ManageGlobalEntityStateApprovalProcess' && action == "resubmit"){
        		return 'globalEntityActionApprovalPolicy_resubmit';
        	}
        	
        	else if (entity == 'ApprovalProcess' && action == "checker"){
        		return 'approvalPolicytodolist_checker';
        	}
        	else if (entity == 'ApprovalProcess' && action == "maker"){
        		return 'approvalPolicytodolist_maker';
        	}
        	else if (entity == 'ApprovalProcess' && action == "resubmit"){
        		return 'approvalPolicy_resubmit';
        	}
        	
        	else if (entity == 'GlobalApprovalProcess' && action == "checker"){
        		return 'globalApprovalPolicytodolist_checker';
        	}
        	else if (entity == 'GlobalApprovalProcess' && action == "maker"){
        		return 'globalApprovalPolicytodolist_maker';
        	}
        	else if (entity == 'GlobalApprovalProcess' && action == "resubmit"){
        		return 'globalApprovalPolicy_resubmit';
        	}
        	
        	else if (entity == 'UserClearance' && action == "checker"){
        		return 'userclearancetodolist_checker';
        	}
        	else if (entity == 'UserClearance' && action == "maker"){
        		return 'userclearancetodolist_maker';
        	}
        	else if (entity == 'UserClearance' && action == "resubmit"){
        		return 'userclearancetodolist_resubmit';
        	}
        	
        	else if (entity == 'OrganisationRole' && action == "checker"){
        		return 'roletodolist_checker';
        	}
        	else if (entity == 'OrganisationRole' && action == "maker"){
        		return 'roletodolist_maker';
        	}
        	else if (entity == 'OrganisationRole' && action == "resubmit"){
        		return 'role_resubmit';
        	}
        	
        	else if (entity == 'UserRole' && action == "checker"){
        		return 'userroletodolist_checker';
        	}
        	else if (entity == 'UserRole' && action == "maker"){
        		return 'userroletodolist_maker';
        	}
        	else if (entity == 'UserRole' && action == "resubmit"){
        		return 'userroletodolist_resubmit';
        	}

        	else if (entity == 'UserManagement' && action == "checker"){
        		return 'usermanagementtodolist_checker';
        	}
        	else if (entity == 'UserManagement' && action == "maker"){
        		return 'usermanagementtodolist_maker';
        	}
        	else if (entity == 'UserManagement' && action == "resubmit"){
        		return 'usermanagementtodolist_resubmit';
        	}
          	else if (entity == 'BankRegistration' && action == "checker"){
          		if(changeType == 'Imported'){
          			return 'messageuploadtodolist_checker';	
          		}else {
          			return 'bank-registrationtodolist_checker';
          		}
        		
        	}
        	else if (entity == 'BankRegistration' && action == "maker"){
        		if(entityShortName == 'BankImport'){
          			return 'messageuploadtodolist_maker';	
          		}else {
          			return 'bank-registrationtodolist_maker';
          		}
           	}
        	else if (entity == 'BankRegistration' && action == "resubmit"){
        		return 'bank-registrationtodolist_resubmit';
        	}
        	else if (entity == 'BranchRegistration' && action == "checker"){
        		if(changeType == 'Imported'){
          			return 'messageuploadtodolist_checker';	
          		}else {
          			return 'branchtodolist_checker';
          		}
           	}
        	else if (entity == 'BranchRegistration' && action == "maker"){
        		if(entityShortName == 'BranchImport'){
          			return 'messageuploadtodolist_maker';	
          		}else {
          			return 'branchtodolist_maker';
          		}
        	}
        	else if (entity == 'BranchRegistration' && action == "resubmit"){
        		return 'branchtodolist_resubmit';
        	}

        	else if (entity == 'AlertConfiguration' && action == "checker"){
        		return 'alertconfigurationtodolist_checker';
        	}
        	else if (entity == 'AlertConfiguration' && action == "maker"){
        		return 'alertconfigurationtodolist_maker';
        	}
        	else if (entity == 'AlertConfiguration' && action == "resubmit"){
        		return 'alert_configuration_resubmit';
        	}
        	else if (entity == 'SMSSettings' && action == "checker"){
        		return 'smssettingtodolist_checker';
        	}
        	else if (entity == 'SMSSettings' && action == "maker"){
        		return 'smssettingstodolist_maker';
        	}
        	else if (entity == 'SMSSettings' && action == "resubmit"){
        		return 'smssettingstodolist_resubmit';
        	}
        	else if (entity == 'SpecialHoliday' && action == "checker"){
        		return 'specialholidaystodolist_checker';
        	}
        	else if (entity == 'SpecialHoliday' && action == "maker"){
        		return 'specialholidaystodolist_maker';
        	}
        	else if (entity == 'SpecialHoliday' && action == "resubmit"){
        		return 'specialholidays_resubmit';
        	}

        	else if (entity == 'RegularHolidays' && action == "checker"){
        		return 'regularholidaystodolist_checker';
        	}
        	else if (entity == 'RegularHolidays' && action == "maker"){
        		return 'regularholidaystodolist_maker';
        	}
        	else if (entity == 'RegularHolidays' && action == "resubmit"){
        		return 'regularholidays_resubmit';
        	}
        	else if (entity == 'SwapQuotes' && action == "checker"){
        		if(changeType == 'Imported'){
          			return 'messageuploadtodolist_checker';	
          		}
        		return 'swapQuotes_checker';
        	}
        	else if (entity == 'SwapQuotes' && action == "maker"){
        		if(entityShortName == 'SwapQuotesImport'){
          			return 'messageuploadtodolist_maker';	
          		}
        		return 'swapQuotes_maker';
        	}
        	else if (entity == 'SwapQuotes' && action == "resubmit"){
        		return 'swapQuotes_resubmit';
        	}
		else if (entity=='DefaultMarkupSettings' && action == "checker"){
        		return 'defaultMarkuptodolist_checker';
        	}
        	else if (entity=='DefaultMarkupSettings' && action == "maker"){
        		return 'defaultMarkuptodolist_maker';
        	}
        	else if (entity=='DefaultMarkupSettings' && action == "resubmit"){
        		return 'defaultMarkuptodolist_resubmit';
        	}
        	else if (entity=='MarkupSettings' && action == "checker"){
        		if(changeType == 'Imported'){
          			return 'messageuploadtodolist_checker';	
          		}else {
          			return 'markuptodolist_checker';
          		}
        		
        	}
        	else if (entity=='MarkupSettings' && action == "maker"){
        		if(entityShortName == 'MarkupImport'){
          			return 'messageuploadtodolist_maker';	
          		}else {
          			return 'markuptodolist_maker';
          		}
        		
        	}
        	else if (entity=='MarkupSettings' && action == "resubmit"){
        		return 'markuptodolist_resubmit';
        	}
        	else if (entity=='HEConnectivitySettings' && action == "checker"){
        		return 'heConnectivitySettings_todolist_checker';
        	}
        	else if (entity=='HEConnectivitySettings' && action == "maker"){
        		return 'heConnectivitySetting_todolist_maker';
        	}
        	else if (entity=='HEConnectivitySettings' && action == "resubmit"){
        		return 'heConnectivitySettings_todolist_resubmit';
        	}
        	else if (entity=='IntradayMarketSessionSettings' && action == "checker"){
        		return 'intradayMarketSessionSettings_todolist_checker';
        	}
        	else if (entity=='IntradayMarketSessionSettings' && action == "maker"){
        		return 'intradayMarketSessionSettings_todolist_maker';
        	}
        	else if (entity=='IntradayMarketSessionSettings' && action == "resubmit"){
        		return 'intradayMarketSessionSettings_todolist_resubmit';
        	}
        	else if (entity=='DefaultMarketSessionSettings' && action == "checker"){
        		return 'defaultMarketSessionSettings_todolist_checker';
        	}
        	else if (entity=='DefaultMarketSessionSettings' && action == "maker"){
        		return 'defaultMarketSessionSettings_todolist_maker';
        	}
        	else if (entity=='DefaultMarketSessionSettings' && action == "resubmit"){
        		return 'defaultMarketSessionSettings_todolist_resubmit';
        	}
        	else if (entity=='EmailSettings' && action == "checker"){
        		return 'emailSettings_todolist_checker';
        	}
        	else if (entity=='EmailSettings' && action == "maker"){
        		return 'emailSettings_todolist_maker';
        	}
        	else if (entity=='EmailSettings' && action == "resubmit"){
        		return 'emailSettings_todolist_resubmit';
        	}else if (entity=='UserRestriction' && action == "checker"){
        		return 'userRestriction_checker';
        	}
        	else if (entity=='UserRestriction' && action == "maker"){
        		return 'userRestriction_maker';
        	}
        	else if (entity=='UserRestriction' && action == "resubmit"){
        		return 'userRestriction_resubmit';
        	}
        	else if (entity=='LimitSettings' && action == "checker"){
        		if(entityShortName == 'LimitSettingsImport' && ( changeType == 'Imported' || changeType == 'Rejected')){
          			return 'messageuploadtodolist_checker';	
          		}else {
          			return 'limitSettings_checker';
          		}
        		
        	}
        	else if (entity=='LimitSettings' && action == "maker"){
        		if(entityShortName == 'LimitSettingsImport' && ( changeType == 'Imported' || changeType == 'Rejected')){
          			return 'messageuploadtodolist_maker';	
          		}else {
          			return 'limitSettings_maker';
          		}
        		
        	}
        	else if (entity=='LimitSettings' && action == "resubmit"){
        		return 'limitSettings_resubmit';
        	}
        	else if (entity=='CustomerLimitChangeRequest' && action == "checker"){
        		
        		if( $rootScope.action=='CREATE'){
        			
        			return 'create_customer_limitSettings_checker'
        		}        	
        		return 'customer_limitSettings_checker';
        	}
        	else if (entity=='CustomerLimitChangeRequest' && action == "maker"){
        		
        		if(  $rootScope.action=='CREATE' && !(vm.loggedinEntityOwnerType == "Bank" || vm.loggedinEntityOwnerType == "Branch" ) ){
        			
        			return 'create_customer_limitSettings_maker'
        		} 
        		else if( $rootScope.action=='CREATE' && (vm.loggedinEntityOwnerType == "Bank" || vm.loggedinEntityOwnerType == "Branch" ) ){
        			
        			return 'create_customer_limitSettings_checker_view'
        		} 
        		return 'customer_limitSettings_maker';
        	}
        	else if (entity=='CustomerLimitChangeRequest' && action == "resubmit"){
        		if( $rootScope.action=='CREATE'){
        			
        			return 'create_customer_limitSettings_resubmit'
        		} 
        		
        		return 'customer_limitSettings_resubmit';
        	}
			else if (entity=='PendingOrderReport' && action == "checker"){
          			return 'messageuploadtodolist_checker';	   		      		
        	}
        	else if (entity=='PendingOrderReport' && action == "maker"){
          			return 'messageuploadtodolist_maker';	     	
        	}
        	else if (entity=='AMCSettings' && action == "checker"){
        		if(changeType == 'Imported'){
          			return 'messageuploadtodolist_checker';	
          		}else {
          			return 'amcSettings_todolist_checker';
          		}
        		
        	}
        	else if (entity=='AMCSettings' && action == "maker"){
        		if(entityShortName == 'AMCImport'){
          			return 'messageuploadtodolist_maker';	
          		}else {
          			return 'amcSettings_todolist_maker';
          		}
        		
        	}
        	else if (entity=='AMCSettings' && action == "resubmit"){
        		return 'amcSettingtodolist_resubmit';
        	}
        	
        	else if (entity=='CustomerCharges' && action == "checker"){
        		if(changeType == 'Imported'){
          			return 'messageuploadtodolist_checker';	
          		}else {
          			return 'customerCharges_todolist_checker';
          		}
        		
        	}
        	else if (entity=='CustomerCharges' && action == "maker"){
        		if(entityShortName == 'OneTimeRegistrationChargesImport'){
          			return 'messageuploadtodolist_maker';	
          		}else {
          			return 'customerCharges_todolist_maker';
          		}
        		
        	}
        	else if (entity=='CustomerCharges' && action == "resubmit"){
        		return 'customerChargestodolist_resubmit';
        	}
        	
        	else if (entity=='GSTSettings' && action == "checker"){
        		if(changeType == 'Imported'){
          			return 'messageuploadtodolist_checker';	
          		}else {
          			return 'gstSettings_todolist_checker';
          		}
        		
        	}
        	else if (entity=='GSTSettings' && action == "maker"){
        		if(entityShortName == 'GSTSettingsImport'){
          			return 'messageuploadtodolist_maker';	
          		}else {
          			return 'gstSettings_todolist_maker';
          		}
        		
        	}
        	else if (entity=='GSTSettings' && action == "resubmit"){
        		return 'gstSettingstodolist_resubmit';
        	}
        	else if (entity=='TermsAndConditionsUpload' && action == "resubmit"){
        		return 'termsConditionUploadtodolist_resubmit';
        	}
        	else if (entity=='TermsAndConditionsUpload' && action == "checker"){
        		
          			return 'termsConditionUpload_todolist_checker';

        	}
        	else if (entity=='TermsAndConditionsUpload' && action == "maker"){
        		
          			return 'termsConditionUpload_todolist_maker';
        		
        	}
        	else if (entity=='CustomerTermsAndConditionsUpload' && action == "resubmit"){
        		return 'customerTermsConditionUploadByBanktodolist_resubmit';
        	}
        	else if (entity=='CustomerTermsAndConditionsUpload' && action == "checker"){
        		
          			return 'customerTermsConditionUploadByBank_todolist_checker';

        	}
        	else if (entity=='CustomerTermsAndConditionsUpload' && action == "maker"){
        		
          			return 'customerTermsConditionUploadByBank_todolist_maker';
        		
        	}
        	else if(entity=='CustomerSpecificSettings' &&  action == "checker"){
        		return 'customerSpecificSettingstodolist_checker';
        	}
        	else if (entity=='CustomerSpecificSettings' && action == "maker"){    
          			return 'customerSpecificSettingstodolist_maker';       		
        	}
        	else if(entity=='CustomerSpecificSettings' && action == "resubmit"){
        			return 'customerSpecificSettings_resubmit';
        	}
        	
        	else if (entity=='TransactionChargesSettings' && action == "checker"){
        		if(entityShortName == 'TransactionChargesImport'){
        			return 'messageuploadtodolist_checker';	
        		}else{
        			return 'transactionChargesSettings_todolist_checker';
        		}
        		
        		
        	}
        	else if (entity=='TransactionChargesSettings' && action == "maker"){
        		if(entityShortName == 'TransactionChargesImport'){
        			return 'messageuploadtodolist_maker';
        		}else{
        			return 'transactionChargesSettings_todolist_maker';
        		}
        		
        	}
        	else if (entity=='TransactionChargesSettings' && action == "resubmit" && taskAction != "DELETE"){
        		return 'transactionChargesSettingstodolist_resubmit';
        	}
        	else if (entity=='TransactionChargesSettings' && action == "resubmit" && taskAction == "DELETE"){
        		return 'transactionChargesSettingstodolist_resubmit_delete';
        	}
        	
            else if (entity=='CreditFactorSettings' && action == "checker"){
                return 'creditFactorSettings_todolist_checker';
            }
            else if (entity=='CreditFactorSettings' && action == "maker"){
                return 'creditFactorSettings_todolist_maker';
            }
            else if (entity=='CreditFactorSettings' && action == "resubmit"){
                return 'creditFactorSettingstodolist_resubmit';
            }

        	else if (entity=='UploadDownloadParticipantCertificate' && action == "checker"){
        		return 'participantCertificate_todolist_checker';
        	}

        	else if (entity=='UploadDownloadParticipantCertificate' && action == "maker"){
        		return 'participantCertificate_todolist_maker';
        	}
        	else if (entity=='HomeBranchIFSCUpload' && action == "maker"){
        		return 'messageuploadtodolist_maker';
        	}
        	else if (entity=='HomeBranchIFSCUpload' && action == "checker"){
        		return 'messageuploadtodolist_checker';
        	}
        	else if(entity=='ModifyCustomerDetails' &&  action == "checker"){
        		return 'modifycustomerdetails_checker';
        	}
        	else if (entity=='ModifyCustomerDetails' && action == "maker"){    
          			return 'modifycustomerdetails_maker';       		
        	}
        	else if(entity=='ModifyCustomerDetails' && action == "resubmit"){
        			return 'modifycustomerdetails_resubmit';
        	}
        	else if(entity=='TermsAndConditionsView' &&  action == "checker"){
        		return 'entited_tac_view_checker';
        	}
        	else if (entity=='TermsAndConditionsView' && action == "maker"){    
          			return 'entited_tac_view_maker';       		
        	}
        	else if(entity=='TermsAndConditionsView' && action == "resubmit"){
        			return 'entited_tac_view_resubmit';
        	}
        	else if (entity=='ExposureType' && action == "checker"){
        		return 'exposureType_todolist_checker';
        		
        	}
        	else if (entity=='ExposureType' && action == "maker"){
        		return 'exposureType_todolist_maker';
        		
        	}
        	else if (entity=='ExposureType' && action == "resubmit"){
        		return 'exposureTypetodolist_resubmit';
        	}
        	else if (entity=='ExposureSubType' && action == "checker"){
        		return 'exposureSubType_todolist_checker';
        		
        	}
        	else if (entity=='ExposureSubType' && action == "maker"){
        		return 'exposureSubType_todolist_maker';
        		
        	}
        	else if (entity=='ExposureSubType' && action == "resubmit"){
        		return 'exposureSubTypetodolist_resubmit';
        	}
        	else if (entity=='BankFeesChargesUpload' && action == "checker"){
        		return 'bankFeesAndChargesUpload_todolist_checker';
        		
        	}
        	else if (entity=='BankFeesChargesUpload' && action == "maker"){
        		return 'bankFeesAndChargesUpload_todolist_maker';
        		
        	}
        	else if (entity=='BankFeesChargesUpload' && action == "resubmit"){
        		return 'bankFeesAndChargesUploadtodolist_resubmit';
        	}
			else if (entity == 'ManageHomeBranch' && action == "checker"){
				return 'homebranchtodolist_checker';	
		 	}
	  		else if (entity == 'ManageHomeBranch' && action == "maker"){
		  
				return 'homebranchtodolist_maker';
	  		}
	  		else if (entity == 'ManageHomeBranch' && action == "resubmit"){
		  		return 'homebranchtodolist_resubmit';
	  		}
			  else if(entity=='BankNotificationSettings' &&  action == "checker"){
        		return 'notificationSettingstodolist_checker';
        	}
        	else if (entity=='BankNotificationSettings' && action == "maker"){    
          			return 'notificationSettingstodolist_maker';       		
        	}
        	else if(entity=='BankNotificationSettings' && action == "resubmit"){
        			return 'notificationSettings_resubmit';
        	}
			else if (entity == 'ManageForexConfigurations' && action == "checker"){
				return 'forex_configurationstodolist_checker';	
		 	}
	  		else if (entity == 'ManageForexConfigurations' && action == "maker"){
		  
				return 'forex_configurationstodolist_maker';
	  		}
	  		else if (entity == 'ManageForexConfigurations' && action == "resubmit"){
		  		return 'forex_configurationstodolist_resubmit';
	  		}
			else if (entity=='ManageBBPSSettings' && action == "resubmit"){
        		return 'bbps_settingtodolist_resubmit';
        	}
			else if (entity == 'ManageBBPSSettings' && action == "checker"){
				return 'bbps_settingttodolist_checker';	
		 	}
	  		else if (entity == 'ManageBBPSSettings' && action == "maker"){
		  
				return 'bbps_settingttodolist_maker';
	  		}
			else if (entity == 'ManageCurrencyPairConfiguration' && action == "checker"){
				return 'currency_pair_configurationtodolist_checker';	
		 	}
	  		else if (entity == 'ManageCurrencyPairConfiguration' && action == "maker"){
		  
				return 'currency_pair_configurationtodolist_maker';
	  		}
	  		else if (entity == 'ManageCurrencyPairConfiguration' && action == "resubmit"){
		  		return 'currency_pair_configuration_todolist_resubmit';
	  		}
			else if (entity=='ManageInstrument' && action == "checker"){
        		return 'manage_instrumenttodolist_checker';
        	}
			else if (entity=='ManageInstrument' && action == "maker"){
        		return 'manage_instrumenttodolist_maker';
        	}
			else if (entity=='ManageInstrument' && action == "resubmit"){
        		return 'manage_instrumenttodolist_resubmit';
        	}
        }
        
        function getState(entity,action,changeType,entityShortName){
        	
        	if(entity == 'CustomerSpecificSettings' && action !='resubmit'){
        		return 'customer-specific-settings-todolist';
        		
        	}
        	else if(entity == 'CustomerSpecificSettings' && action =='resubmit' ){
        		return 'customer-specific-settings-todoList-resubmit'
        	}
        	else if (entity == 'SecurityPolicy' && action != 'resubmit'){
        		return 'security-policy-todolist';
        	}
        	else if (entity == 'SecurityPolicy' && action == 'resubmit'){
        		return 'security-policy-todolist.resubmit';
        	}
        	else if (entity == 'GlobalSecurityPolicy' && action != 'resubmit'){
        		return 'global-security-policy-todolist';
        	}
        	else if (entity == 'GlobalSecurityPolicy' && action == 'resubmit'){
        		return 'global-security-policy-todolist.resubmit';
        	}
        	else if (entity == 'UserAdminApplicationWideSettings' && action != 'resubmit'){
        		return 'application-wide-settings-todolist';
        	}
        	else if (entity == 'UserAdminApplicationWideSettings' && action == 'resubmit'){
        		return 'application-wide-settings-todolist.resubmit';
        	}
        	else if ((entity == 'DealingAdminApplicationWideSettings') && action != 'resubmit'){
        		return 'dealing-admin-application-wide-settings-todolist';
        	}
        	else if (entity == 'DealingAdminApplicationWideSettings' && action == 'resubmit'){
        		return 'dealing-admin-application-wide-settings-todolist.resubmit';
        	}
			else if (entity == 'TransactionParametersSettings' && action != 'resubmit'){
        		return 'dealing-admin-application-wide-settings-todolist'
        	}
        	else if (entity == 'TransactionParametersSettings' && action == 'resubmit'){
        		return 'dealing-admin-application-wide-settings-todolist.resubmit';
        	}
        	else if (entity == 'EntityStateApprovalProcess' && action != 'resubmit'){
        		return 'entity-action-approval-policy-todolist';
        	}
        	else if (entity == 'EntityStateApprovalProcess' && action == 'resubmit'){
        		return 'entity-action-approval-policy-todolist.resubmit';
        	}
        	
            else if (entity == 'EntityRestriction' && action != 'resubmit'){
                return 'manage-Entity-Restrictions-todolist';
            }
            else if (entity == 'EntityRestriction' && action == 'resubmit'){
                return 'manage-Entity-Restrictions-todolist.resubmit';
            }

        	
        	else if (entity == 'ManageGlobalEntityStateApprovalProcess' && action != 'resubmit'){
        		return 'global-entity-action-approval-policy-todolist';
        	}
        	else if (entity == 'ManageGlobalEntityStateApprovalProcess' && action == 'resubmit'){
        		return 'global-entity-action-approval-policy-todolist.resubmit';
        	}
        	
        	else if (entity == 'ApprovalProcess' && action != 'resubmit'){
        		return 'approval-policy-todolist';
        	}
        	else if (entity == 'ApprovalProcess' && action == 'resubmit'){
        		return 'approval-policy-todolist.resubmit';
        	}
        	
        	else if (entity == 'GlobalApprovalProcess' && action != 'resubmit'){
        		return 'global-approval-policy-todolist';
        	}
        	else if (entity == 'GlobalApprovalProcess' && action == 'resubmit'){
        		return 'global-approval-policy-todolist.resubmit';
        	}
        	
        	else if (entity == 'UserClearance' && action != 'resubmit'){
        		return 'manage-user-todolist';
        	}
        	else if (entity == 'UserClearance' && action == 'resubmit'){
        		return 'manage-user-todolist-resubmit';
        	}
        	
        	else if (entity == 'OrganisationRole' && action != 'resubmit'){
        		return 'manage-role-todolist';
        	}
        	else if (entity == 'OrganisationRole' && action == 'resubmit'){
        		return 'manage-role-todolist.resubmit';
        	}
        	
        	else if (entity == 'UserRole' && action != 'resubmit'){
        		return 'manage-users-roletodolist-assignrole';
        	}
        	else if (entity == 'UserRole' && action == 'resubmit'){
        		return 'manage-users-roletodolist-assignrole.resubmit';
        	}
        	
        	else if (entity == 'UserManagement' && action != 'resubmit'){
        		return 'usermanagement-todolist';
        	}
        	else if (entity == 'UserManagement' && action == 'resubmit'){
        		return 'usermanagement-todolist.resubmit';
        	}
         	else if (entity == 'BankRegistration' && action != 'resubmit'){
         		if(entityShortName == 'BankImport' || changeType == 'Imported'){
          			return 'upload-todolist';	
          		}else {
          			return 'bank-registration-todolist';
          		}
        		
        	}
        	else if (entity == 'BankRegistration' && action == 'resubmit'){
        		return 'bank-registration-todolist.resubmit';
        	}
        	else if (entity == 'BranchRegistration' && action != 'resubmit'){
        		if(entityShortName == 'BranchImport'  || changeType == 'Imported'){
          			return 'upload-todolist';	
          		}else {
          			return 'branch-todolist';
          		}
        		
        	}
        	else if (entity == 'BranchRegistration' && action == 'resubmit'){
        		return 'branch-todolist.resubmit';
        	}
        	else if (entity == 'AlertConfiguration' && action != 'resubmit'){
        		return 'alert-configuration-todolist';
        	}
        	else if (entity == 'AlertConfiguration' && action == 'resubmit'){
        		return 'alert-configuration-todolist.resubmit';
        	}
        	else if (entity == 'SMSSettings' && action != 'resubmit'){
        		return 'sms-settings-todolist';
        	}
        	else if (entity == 'SMSSettings' && action == 'resubmit'){
        		return 'sms-settings-todolist.resubmit';
        	}else if (entity == 'RegularHolidays' && action != 'resubmit'){
        		return 'regular-holidays-todolist';
        	}
        	else if (entity == 'RegularHolidays' && action == 'resubmit'){
        		return 'regular-holidays-todolist.resubmit';
        	}
        	else if (entity == 'SpecialHoliday' && action != 'resubmit'){
        		return 'special-holidays-todolist';
        	}
        	else if (entity == 'SpecialHoliday' && action == 'resubmit'){
        		return 'special-holidays-todolist.resubmit';
        	}
        	else if (entity == 'SwapQuotes' && action != 'resubmit'){
        		if(entityShortName == 'SwapQuotesImport' || changeType == 'Imported'){
          			return 'upload-todolist';	
          		}
        		return 'swap-quotes-todolist';
        	}
        	else if (entity == 'SwapQuotes' && action == 'resubmit'){
        		return 'swap-quotes-todolist.resubmit';
        	}
        	else if (entity == 'DefaultMarkupSettings' && action != 'resubmit'){
        		return 'default-markup-todolist';
        	}
        	else if (entity == 'DefaultMarkupSettings' && action == 'resubmit'){
        		return 'default-markup-todolist.resubmit';
        	}
        	else if (entity == 'MarkupSettings' && action != 'resubmit'){
        		if(entityShortName == 'MarkupImport' || changeType == 'Imported'){
          			return 'upload-todolist';	
          		}else {
          			return 'markup-todolist';
          		}
        	}
        	else if (entity == 'MarkupSettings' && action == 'resubmit'){
        		return 'markup-todolist.resubmit';
        	}
        	else if (entity == 'DefaultMarkupSettings' && action != 'resubmit'){
        		return 'default-markup-todolist';
        	}
        	else if (entity == 'DefaultMarkupSettings' && action == 'resubmit'){
        		return 'default-markup-todolist.resubmit';
        	}
        	else if (entity == 'MarkupSettings' && action != 'resubmit'){
        		return 'markup-todolist';
        	}
        	else if (entity == 'MarkupSettings' && action == 'resubmit'){
        		return 'markup-todolist.resubmit';
        	}
        	else if (entity == 'HEConnectivitySettings' && action != 'resubmit'){
        		return 'he-connectivity-settings-todolist';
        	}
        	else if (entity == 'HEConnectivitySettings' && action == 'resubmit'){
        		return 'he-connectivity-settings-todolist-resubmit';
        	}
        	else if (entity == 'IntradayMarketSessionSettings' && action != 'resubmit'){
        		return 'intraday-market-session-settings-todolist';
        	}
        	else if (entity == 'IntradayMarketSessionSettings' && action == 'resubmit'){
        		return 'intraday-market-todolist-resubmit';
        	}
        	else if (entity == 'DefaultMarketSessionSettings' && action != 'resubmit'){
        		return 'default-market-session-settings-todolist';
        	}
        	else if (entity == 'DefaultMarketSessionSettings' && action == 'resubmit'){
        		return 'default-market-todolist-resubmit';
        	}
        	else if (entity == 'EmailSettings' && action != 'resubmit'){
        		return 'email-todolist';
        	}
        	else if (entity == 'EmailSettings' && action == 'resubmit'){
        		return 'email-todolist.resubmit';
        	}else if (entity == 'UserRestriction' && action != 'resubmit'){
        		return 'user-restrictions-todolist';
        	}
        	else if (entity == 'UserRestriction' && action == 'resubmit'){
        		return 'user-restrictions-todolist.resubmit';
        	}else if (entity == 'LimitSettings' && action != 'resubmit'){
        		
        		if(entityShortName == 'LimitSettingsImport' && ( changeType == 'Imported' || changeType == 'Rejected')){
          			return 'upload-todolist';	
        		}else {
        			return 'limit-settings-todolist'; 
        			}
        	}
        	else if (entity == 'LimitSettings' && action == 'resubmit'){
        		return 'limit-settings-todolist.resubmit';
        	}else if (entity == 'CustomerLimitChangeRequest' && action != 'resubmit'){
        		
        		if($rootScope.action =='CREATE' && action=='maker'){
        			if( vm.loggedinEntityOwnerType == "Bank" || vm.loggedinEntityOwnerType == "Branch"  ){
            			
            			return 'create-customer-limit-settings-todolist-checker'
            		} 
        			return 'create-customer-limit-settings-todolist';
        		}
        		
        		if($rootScope.action =='CREATE' && action=='checker'){
        			return 'create-customer-limit-settings-todolist-checker';
        		}
        		return 'customer-limit-settings-todolist';
        	}
        	else if (entity == 'CustomerLimitChangeRequest' && action == 'resubmit'){
        		
        		if($rootScope.action =='CREATE'){
        			return 'create-customer-limit-settings-todolist.resubmit';
        		}
        		return 'customer-limit-settings-todolist.resubmit';
        	}else if (entity == 'PendingOrderReport' && action != 'resubmit'){
        		return 'upload-todolist';	
        
        	}
        	else if (entity == 'AMCSettings' && action != 'resubmit'){
        	
        		if(entityShortName == 'AMCImport' || changeType == 'Imported'){
          			return 'upload-todolist';	
          		}else {
          			return 'amc-settings-todolist';
          		}
        	}
        	else if (entity == 'AMCSettings' && action == 'resubmit'){
        		return 'amc-todolist-resubmit';
        	}
        	else if (entity == 'CustomerCharges' && action != 'resubmit'){
            	
        		if(entityShortName == 'OneTimeRegistrationChargesImport' || changeType == 'Imported'){
          			return 'upload-todolist';	
          		}else {
          			return 'customer-charges-todolist';
          		}
        	}
        	else if (entity == 'CustomerCharges' && action == 'resubmit'){
        		return 'customer-charges-todolist-resubmit';
        	}
        	else if (entity == 'TermsAndConditionsUpload' && action != 'resubmit'){

        		return 'terms-condition-upload-todolist';

        	}
        	else if (entity == 'TermsAndConditionsUpload' && action == 'resubmit'){
        		return 'terms-condition-upload-todolist-resubmit';
        	}
        	else if (entity == 'CustomerTermsAndConditionsUpload' && action != 'resubmit'){

        		return 'customer-tac-upload-by-bank-todolist';

        	}
        	else if (entity == 'CustomerTermsAndConditionsUpload' && action == 'resubmit'){
        		return 'customer-tac-upload-by-bank-todolist-resubmit';
        	}

        	else if (entity == 'GSTSettings' && action != 'resubmit'){
            	
        		if(entityShortName == 'GSTSettingsImport' || changeType == 'Imported'){
          			return 'upload-todolist';	
          		}else {
          			return 'gst-settings-todolist';
          		}
        	}
        	else if (entity == 'GSTSettings' && action == 'resubmit'){
        		return 'gst-settings-todolist-resubmit';
        	}
        	
        	if (entity == 'TransactionChargesSettings' && action != 'resubmit'){
        		if(entityShortName=='TransactionChargesImport' || changeType == 'Imported'){
        			return 'upload-todolist';
        		}else{
        			return 'transaction-charges-settings-todolist';
        		}
        		
        		
        	}
        	else if (entity == 'TransactionChargesSettings' && action == 'resubmit'){
        		return 'transaction-charges-settings-todolist-resubmit';
        	}

            if (entity == 'CreditFactorSettings' && action != 'resubmit'){
                return 'credit-factor-settings-todolist';
            }
            else if (entity == 'CreditFactorSettings' && action == 'resubmit'){
                return 'credit-factor-settings-todolist-resubmit';
            }
        	
        	else if (entity == 'UploadDownloadParticipantCertificate'){
        		return 'participant-certificate-todolist';
        	}
        	else if (entity == 'HomeBranchIFSCUpload' && action != 'resubmit'){
            	
        		if(entityShortName == 'HomeBranchImport' || changeType == 'Imported'){
          			return 'upload-todolist';	
          		}
        	}
        	else if (entity == 'ModifyCustomerDetails' && action == 'resubmit'){
        		return 'modify-customer-details-todoList';
        	}
        	else if (entity == 'ModifyCustomerDetails' && action != 'resubmit'){
        		return 'modify-customer-details-todoList';
        	}
        	else if (entity == 'TermsAndConditionsView' && action == 'resubmit'){
        		return 'entities-tac-todo-view.resubmit';
        	}
        	else if (entity == 'TermsAndConditionsView' && action != 'resubmit'){
        		return 'entities-tac-todo-view';
        	}
        	else if (entity == 'ExposureType' && action != 'resubmit'){
        		return 'exposure-type-todolist';
        	}
        	else if (entity == 'ExposureType' && action == 'resubmit'){
        		return 'exposure-type-todolist-resubmit';
        	}
        	else if (entity == 'ExposureSubType' && action != 'resubmit'){
        		return 'exposure-sub-type-todolist';
        	}
        	else if (entity == 'ExposureSubType' && action == 'resubmit'){
        		return 'exposure-sub-type-todolist-resubmit';
        	}
        	else if (entity == 'BankFeesChargesUpload' && action != 'resubmit'){
        		return 'bankFeesAndChargesUpload-todolist';
        	}
        	else if (entity == 'BankFeesChargesUpload' && action == 'resubmit'){
        		return 'bankFeesAndChargesUpload-todolist-resubmit';
        	}
			else if (entity == 'ManageHomeBranch' && action != 'resubmit'){
          			return 'home-branch-todolist';
        	}
        	else if (entity == 'ManageHomeBranch' && action == 'resubmit'){
        		return 'home-branch-todolist.resubmit';
        	}
			if(entity == 'BankNotificationSettings' && action !='resubmit'){
        		return 'notification-settings-todolist';
        		
        	}
        	else if(entity == 'BankNotificationSettings' && action =='resubmit' ){
        		return 'notification-todoList-resubmit'

        	}else if (entity == 'ManageForexConfigurations' && action != 'resubmit'){
          			return 'forex-configurations-todolist';
        	}
        	else if (entity == 'ManageForexConfigurations' && action == 'resubmit'){
        		return 'forex-configurations-todolist.resubmit';

        	}else if (entity == 'ManageBBPSSettings' && action != 'resubmit'){
          			return 'bbps-settings-todolist';
        	}
        	else if (entity == 'ManageBBPSSettings' && action == 'resubmit'){
        		return 'bbps-settings-todolist.resubmit';

        	}else if (entity == 'ManageCurrencyPairConfiguration' && action != 'resubmit'){
        		return 'currency-pair-configurations-todolist';
        	}
        	else if (entity == 'ManageCurrencyPairConfiguration' && action == 'resubmit'){
        		return 'currency-pair-configuration-todolist-resubmit';
        	}
			else if (entity == 'ManageInstrument' && action != 'resubmit'){
          		return 'manage-instrument-todolist';
          	}
			else if (entity == 'ManageInstrument' && action == 'resubmit'){
        		return 'manage-instrument-resubmit';
        	}
			

        }
        
    	function getChangeType(task){
    		console.log(task.changeType);
    		if(task.changeType == 'CREATE' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Added';
    		}
    		else if(task.changeType == 'EDIT' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Modified';
    		}
            else if(task.changeType == 'RESET' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
                return 'Reset';
            }
    		else if(task.changeType == 'DELETE' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Deleted';
    		}
    		else if(task.changeType == 'REMOVE' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Removed';
    		}
    		else if(task.changeType == 'CANCEL' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Cancelled';
    		}
    		else if(task.changeType == 'ROLLOVER' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Rolled over';
    		}
    		else if(task.changeType == 'MAP' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Assign';
    		}
    		else if(task.changeType == 'COMMITTED' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Commit';
    		}
    		else if(task.changeType == 'DELIVERY' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Delivered';
    		}
    		else if(task.changeType == 'UNDODELIVERY' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Undo Delivery';
    		}
    		else if(task.changeType == 'UNDOCANCEL' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Undo Cancellation';
    		}
    		else if(task.changeType == 'ADDPRICE' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Added Price';
    		}
    		else if(task.changeType == 'UNDOSETTLE' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Undo Settlement';
    		}
            else if(task.changeType == 'EDITPRICE' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Edited Price';
    		}
            else if(task.changeType == 'CLOSEOUTCASH' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
                return 'Close Out Cash';
            }
            else if(task.changeType == 'CLOSEOUTDELIVERY' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
                return 'Close Out Delivery';
            }
            else if(task.changeType == 'SQUAREOFF' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
                return 'Square Off';
            }
            else if(task.changeType == 'UNWIND' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Unwind';
    		}
            else if(task.changeType == 'UNDOFXO' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
                return 'Undo Fx Options';
            }
            else if(task.changeType == 'DELINK' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
                return 'Delinked';
            }
    		else if(task.taskHistory[task.taskHistory.length - 1].action == 'REJECTED'){
    			return 'Rejected';
    		}
            else if(task.changeType == 'IMPORT'  && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
                return 'Imported';
            }
    		if(task.changeType == 'AGREE' && task.taskHistory[task.taskHistory.length - 1].action != 'REJECTED'){
    			return 'Agreed';
    		}
    	}
    	
        $rootScope.removeRow = function(id) {
            var index = -1;
            var comArr = eval(vm.tasks);
            for (var i = 0; i < comArr.length; i++) {
                if (comArr[i].id === id) {
                    index = i;
                    break;
                }
            }
            if (index === -1) {
                //alert("Something gone wrong");
            }
            vm.tasks.splice(index, 1);
        };

        $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
        
        
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }
        
        $rootScope.$on('gatewayApp.messagebox.clear.autoclose',function (event, data){
            //do nothing
        });
        
    }

})();

(function () {
    'use strict';

    angular.module('gatewayApp').service('CryptoUtil', CryptoUtil);

    function CryptoUtil() {

        // Base64 encoded AES key
        var cryptoKey = CryptoJS.enc.Base64.parse("MTIzNDU2Nzg5MDEyMzQ1Ng==");

        // 16-byte IV
        var iv = CryptoJS.enc.Utf8.parse("1234567890123456");

        var service = {
            encrypt: encrypt,
            decrypt: decrypt
        };

        return service;

        function encrypt(message, key) {

            if (key !== undefined) {
                cryptoKey = CryptoJS.enc.Base64.parse(key);
            }

            var encrypted = CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(message),
                cryptoKey,
                {
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                }
            );

            return encrypted.toString();
        }

        function decrypt(cipherText, key) {

            if (key !== undefined) {
                cryptoKey = CryptoJS.enc.Base64.parse(key);
            }

            var decrypted = CryptoJS.AES.decrypt(
                cipherText,
                cryptoKey,
                {
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                }
            );

            return decrypted.toString(CryptoJS.enc.Utf8);
        }
    }
})();
(function() {
    'use strict';

    var app = angular.module('gatewayApp');
    app.service("MessageBox", MessageBox)
    app.controller('ModalInstanceCtrl',['MessageBox', '$uibModalInstance','$sce', function(MessageBox, $uibModalInstance,$sce) {

    	var vm = this;
    	vm.messageDetails = {};
    	vm.messageDetails.messageTitle = MessageBox.getMessageTitle();
    	vm.messageDetails.messageContent = MessageBox.getMessageContent();
		vm.messageDetails.msgType = MessageBox.getMsgType();
		vm.messageDetails.alertType = MessageBox.getAlertType();
		vm.message = $sce.trustAsHtml(vm.messageDetails.messageContent);
    	vm.mode = MessageBox.getMode();

    	vm.yesButton = false;
    	vm.noButton = false;
    	vm.okButton = false;
    	vm.proceedButton = false;
    	vm.cancelButton = false;
    	vm.proceedBroadcastButton = false;

    	if(vm.mode == "OkCancel") { vm.okButton = true; vm.cancelButton = true;}
    	else if(vm.mode == "YesNo") { vm.yesButton = true; vm.noButton = true;}
    	else if(vm.mode == "YesNoCancel") { vm.yesButton = true; vm.noButton = true; vm.cancelButton = true;}
    	else if(vm.mode == "Ok") { vm.okButton = true;}
    	else if(vm.mode == "ProceedCancel") { vm.proceedButton = true; vm.cancelButton = true;}
    	else if(vm.mode == "ProceedCancelBroadcast") { vm.proceedBroadcastButton = true; vm.cancelButton = true;}
    	vm.ok = function() {
    	    $uibModalInstance.close("ok");
    	};
    	vm.cancel = function() {
    	    $uibModalInstance.dismiss("cancel");
    	};
    	vm.yes = function() {
    	    $uibModalInstance.close("yes");
    	};
    	vm.no = function() {
    	    $uibModalInstance.dismiss("no");
    	};
    	vm.proceed = function() {
    	    $uibModalInstance.close("proceed");
    	};
    	vm.proceedBroadcast = function() {
    	    $uibModalInstance.close("proceedBroadcast");
    	};
    }]);

    MessageBox.$inject = ['$uibModal', '$rootScope'];

    function MessageBox($uibModal, $rootScope) {
    	var messageTitle = "";
    	var messageContent = "";
    	var mode = "";
    	var moduleInstance = null;
		var msgType="";
		var alertType="";
		

    	var service = {
    		showMessageBox: showMessageBox,
    		getMessageContent: getMessageContent,
			getMsgType:getMsgType,
			getAlertType:getAlertType,
    		getMessageTitle: getMessageTitle,
    		getMode: getMode,
            openMessageBox: openMessageBox,
			openAlertMessageBox:openAlertMessageBox,
            closeMessageBox: closeMessageBox
    	}
    	return service;

    	function getMessageTitle(){
    		return messageTitle;
    	}

    	function getMessageContent(){
    		return messageContent;
    	}
		function getMsgType(){
    		return msgType;
    	}
		function getAlertType(){
			return alertType;
		}

    	function getMode() {
    		return mode;
    	}

    	function showMessageBox(title, content, msgMode) {
    		messageTitle = title;
    		messageContent = content;
    		mode = msgMode;
            openUibModal(null);
    	}

        function openMessageBox(title, content, msgMode, screenName) {
            messageTitle = title;
            messageContent = content;
            mode = msgMode;
            openUibModal(screenName);
        }
		// open alert message box for Hard check and soft check order validation
		function openAlertMessageBox(title, content, msgMode, screenName,msgtype,alerttype) {
            messageTitle = title;
            messageContent = content;
            mode = msgMode;
			msgType= msgtype;
			alertType=alerttype;
            openAlertUibModal(screenName);
        }
        function openUibModal(screenName) {
            moduleInstance = $uibModal.open({
                templateUrl: 'app/controllers/messagebox/messagebox.html',
                controller: 'ModalInstanceCtrl',
                controllerAs: 'vm',
            });
            moduleInstance.result
                .then(function(successOption) {
                    if(successOption == 'ok') { 
                        if (true) {}
                        if(screenName != undefined && screenName != null && screenName != "" && screenName != " ") {
                        	$rootScope.$emit(getEmitMessage('gatewayApp.messagebox.ok', screenName)); 
                        }else{
                        	$rootScope.$emit('gatewayApp.messagebox.ok');
                        }
                    }
                    else if(successOption == 'yes') { $rootScope.$emit(getEmitMessage('gatewayApp.messagebox.yes', screenName)); }
                    else if(successOption == 'proceed') { $rootScope.$emit(getEmitMessage('gatewayApp.messagebox.proceed', screenName)); }
                    else if(successOption == 'proceedBroadcast') { $rootScope.$broadcast(getEmitMessage('gatewayApp.messagebox.proceed', screenName)); }
            }, function(failureOption) {
                if(failureOption == 'cancel') { $rootScope.$emit(getEmitMessage('gatewayApp.messagebox.cancel', screenName)); }
                else if(failureOption == 'no') { $rootScope.$emit(getEmitMessage('gatewayApp.messagebox.no', screenName)); }
                else { $rootScope.$emit(getEmitMessage('gatewayApp.messagebox.clear', screenName)); }
            });
        }
		//for soft check and hard check order alert
		function openAlertUibModal(screenName) {
            moduleInstance = $uibModal.open({
                templateUrl: 'app/controllers/messagebox/alertMessageBox.html',
                controller: 'ModalInstanceCtrl',
                controllerAs: 'vm',
            });
            moduleInstance.result
                .then(function(successOption) {
                    if(successOption == 'ok') { 
                        if (true) {}
                        if(screenName != undefined && screenName != null && screenName != "" && screenName != " ") {
                        	$rootScope.$emit(getEmitMessage('gatewayApp.messagebox.ok', screenName)); 
                        }else{
                        	$rootScope.$emit('gatewayApp.messagebox.ok');
                        }
                    }
                    else if(successOption == 'yes') { $rootScope.$emit(getEmitMessage('gatewayApp.messagebox.yes', screenName)); }
                    else if(successOption == 'proceed') { $rootScope.$emit(getEmitMessage('gatewayApp.messagebox.proceed', screenName)); }
                    else if(successOption == 'proceedBroadcast') { $rootScope.$broadcast(getEmitMessage('gatewayApp.messagebox.proceed', screenName)); }
            }, function(failureOption) {
                if(failureOption == 'cancel') { $rootScope.$emit(getEmitMessage('gatewayApp.messagebox.cancel', screenName)); }
                else if(failureOption == 'no') { $rootScope.$emit(getEmitMessage('gatewayApp.messagebox.no', screenName)); }
                else { $rootScope.$emit(getEmitMessage('gatewayApp.messagebox.clear', screenName)); }
            });
        }

        function getEmitMessage(message, screeenName) {
            if(screeenName != undefined && screeenName != null && screeenName != "" && screeenName != " ") {
                return message + "." + screeenName;
            } else {
                return message;
            }
        }
        function closeMessageBox(msgMode) {
            if ( msgMode == mode && moduleInstance!= null && moduleInstance !=undefined){
            	moduleInstance.close();
            }
            
        }

     }

})();
(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('CSPLControlService', CSPLControlService);

    CSPLControlService.$inject = ['$resource'];

    function CSPLControlService ($resource) {
        var service = $resource('api/verify-captcha', {}, {
            'verify': { method:'POST'}
        });

        return service;
    }
})();

'use strict';

angular.module('gatewayApp')
  .factory('CSPLDataModel',['WidgetDataModel', '$timeout', function (WidgetDataModel, $timeout) {
      function CSPLDataModel() {
      }
      var value = 'CSPL';
      var widgetScope = null;
      var refreshWidget = null;
      var count = 0;
      CSPLDataModel.prototype = Object.create(WidgetDataModel.prototype);
      CSPLDataModel.prototype.constructor = WidgetDataModel;

      angular.extend(CSPLDataModel.prototype, {
          init: function () {
        	  widgetScope = this.widgetScope;
        	  refreshWidget = this.refreshWidget;
              this.widgetScope.updateValue = this.updateValue;
              this.refreshWidget();
              this.updateScope(value);      
          },
          refreshWidget: function (){
        	  count += 1;
        	  widgetScope.cspmmodel = value + count;   
        	  //$timeout(refreshWidget, 2000);
          },
          updateScope: function(data){
        	  widgetScope.cspmmodel = data;
          },
          updateValue : function(data){
        	  widgetScope.value = 'Button Clicked';
          },
          updateLimit: function (limit) {
              this.dataModelOptions = this.dataModelOptions ? this.dataModelOptions : {};
              this.dataModelOptions.limit = limit;
              this.limit = limit;
          },

          destroy: function () {
              WidgetDataModel.prototype.destroy.call(this);
          }
      });

      return CSPLDataModel;
  }]);
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CSPLControlController', CSPLControlController);

    CSPLControlController.$inject = ['$rootScope', '$scope', 'CSPLControlService', '$timeout', 'User', '$window', 'CSPLDataModel'];

    function CSPLControlController($rootScope, $scope, CSPLControlService, $timeout, User, $window, CSPLDataModel) {
        var vm = this;
        vm.captcha = null;
        vm.captchaNotSet = false;
        vm.submited = false;
        vm.submit = submit;
        vm.hideWidget = hideWidget;
        vm.hideRow = hideRow; 
        vm.widget1 = true;
        vm.widget2 = true;
        vm.widget3 = true;
        vm.widget4 = true;
        vm.widget5 = true;
        vm.widget1Data = [];
        vm.widget3Data = [];
        vm.widget1DataCount = 0;
        vm.widget3DataCount = 0;
        vm.allItems = [{"news": "Sec 1", "src" : "downarrow.jpg"}, {"news": "Sec 2", "src" : "uparrow.jpg"}, {"news": "Sec 3", "src" : "downarrow.jpg"}, {"news": "Sec 4", "src" : "downarrow.jpg"}];
        
        
        $scope.dashboardOptions = { 
        		'widgetDefinitions' : [{
                	name : 'Widget1',
                	template : '<input type="text" class="form-control" ng-model="cspmmodel" /> <br /> {{value}} <br /> <button class="btn btn-primary" ng-click=updateValue("a")>Test</button>',
                	dataAttrName: 'value',  
                    dataModelType: CSPLDataModel
                },{
                	name : 'Widget2',
                	template : '<input type="text" class="form-control" ng-model="cspmmodel" /> <br /> {{value}} <br /> <button class="btn btn-close">Clear</button>'
                },{
                	name : 'Widget3',
                	template : '<input type="text" class="form-control" ng-model="cspmmodel" /> <br /> {{value}} <br /> <button class="btn btn-close">Clear</button>'
                },{
                	name : 'Widget4',
                	template : '<input type="text" class="form-control" ng-model="cspmmodel" /> <br /> {{value}} <br /> <button class="btn btn-close">Clear</button>'
                },{
                	name : 'Widget5',
                	template : '<input type="text" class="form-control" ng-model="cspmmodel" /> <br /> {{value}} <br /> <button class="btn btn-close">Clear</button>'
                }],
                hideWidgetSettings: true,
                hideWidgetName: true,
                hideToolbar: true,
                hideWidgetClose: true,
                'defaultWidgets' :  [{ name : 'Widget1'}, { name : 'Widget2'}, { name : 'Widget3'}, { name : 'Widget4'}, { name : 'Widget5'}],
                'settingsModalOptions' : {},
                'widgetButtons' : false
        };

        
//        refreshWidget1();
//        refreshWidget3();
//        refreshTicker();
        
        function refreshTicker(){
        	User.query(function(data) {
        		vm.widget1DataCount += 1;
        		vm.allItems[3].news = "CSPL " + vm.widget1DataCount;
        		
        		if (vm.allItems[3].src == 'downarrow.jpg'){
        			vm.allItems[3].src = 'uparrow.jpg';
        		}
        		else {
        			vm.allItems[3].src = 'downarrow.jpg';
        		}
        		
        		$timeout(refreshTicker, 2000);
        	});
        }
        
//        angular.element('#mqMain').mouseover(function() {
//        	angular.element('#mqMain').stop();
//        }).mouseout(function() {
//        	angular.element('#mqMain').start();
//        });
        
        function refreshWidget1(){
        	User.query(function(data) {
        		vm.widget1Data = data;
        		vm.widget1DataCount += 1;
        		vm.widget1Data[0].login = vm.widget1Data[0].login + vm.widget1DataCount; 
        		$timeout(refreshWidget1, 2000);
        	});
        }
        
        function refreshWidget3(){
        	User.query(function(data) {
        		vm.widget3Data = data;
        		vm.widget3DataCount += 1;
        		vm.widget3Data[0].login = vm.widget3Data[0].login + vm.widget3DataCount; 
        		$timeout(refreshWidget3, 3000);
        	});
        }
        
        function hideRow(){
        	vm.widget3 = !vm.widget3;
        }
        
        function hideWidget(){
        	vm.widget2 = !vm.widget2;
        	if (vm.widget2){
        		angular.element('#wg1').css('width', '50%');
        	}
        	else {
        		angular.element('#wg1').css('width', '100%');        		
        	}
//        	var myEl = angular.element( document.querySelector( '#wg1' ) );
//        	myEl.addClass('col-lg-6');
//        	myEl.addClass('col-lg-12');
        }
        
//        var recaptcha = recaptchaFactory.create('.csCaptcha', {
//            sitekey: '6LdPbU4UAAAAAJxfAdVJrDhjs4RevSqC59LSPCig'
//        });
//        var callbacks = {
//    	    created: function (widgetId) {
//
//    	    },
//    	    success: function (response) {
//    	    	vm.captcha = response;
//    	    },
//    	    expired: function (widgetId) {
//    	        recaptcha.reload();
//    	    }
//    	}
//        recaptcha.setConfig(callbacks);
//        recaptcha.render();
        
        function submit(){
        	vm.captchaNotSet = false;
        	if (vm.captcha == null){
        		vm.captchaNotSet = true;
        	}
        	else {
        		CSPLControlService.verify(vm.captcha, function(data){
        			vm.submited = true;
        			vm.message = data.result;
        		});
    		
        	}
        }
        

    }
})();

(function () {
    'use strict';
    angular
        .module('gatewayApp')
        .constant('OrganisationTypeEnum', {
        	CLEARCORP:'CLEARCORP',OTHERS:'OTHERS',ADMIN:'admin'

        })
        .run(['$rootScope', 'OrganisationTypeEnum', function($rootScope, OrganisationTypeEnum) {
            $rootScope.OrganisationTypeEnum = OrganisationTypeEnum;
        }]);
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('workflow-rejection', {
            parent: 'dashboard',
            url: '/workflow-rejection',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$rootScope', '$uibModal', function($stateParams, $state, $rootScope, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/components/workflow/rejection_reason.html',
                    controller: 'WorkflowRejectionReasonController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
 
                    }
                }).result.then(function() {
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('workflow-customer-rejection', {
            parent: 'customer-todo',
            url: '/workflow-rejection',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$rootScope', '$uibModal', function($stateParams, $state, $rootScope, $uibModal) {
                $uibModal.open({
                	templateUrl: 'app/components/workflow/rejection_reason.html',
                    controller: 'WorkflowRejectionReasonController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
 
                    }
                }).result.then(function() {
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("Workflow", Workflow);

    Workflow.$inject = ['$rootScope', '$state'];

    function Workflow($rootScope,$state) {

    	var service = {
    			approveTask: approveTask,
    			rejectTask: rejectTask,
    			discardTask: discardTask,
    			rejectCustomerApproval: rejectCustomerApproval
    	};
    	return service;
    	
    	function approveTask(taskId){
    		
    	}
    	
    	function discardTask(taskId){
    		
    	}
    	
    	function rejectTask(taskId){
    		$rootScope.taskIdForRejection = taskId;
    		$state.go('workflow-rejection');
    	}
    	function rejectCustomerApproval(taskId){
    		$rootScope.taskIdForRejection = taskId;
    		$state.go('workflow-customer-rejection');
    	}

       
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('WorkflowRejectionReasonController', WorkflowRejectionReasonController);

    WorkflowRejectionReasonController.$inject = ['$scope','$rootScope', '$state', '$window', '$uibModalInstance', 'Tasks', '$uibModalStack'];

    function WorkflowRejectionReasonController ($scope,$rootScope, $state, $window, $uibModalInstance, Tasks, $uibModalStack) {
        var vm = this;
        
        vm.taskId = $rootScope.taskIdForRejection;
        vm.clear=clear;
        vm.confirm=confirm;
        //vm.reasonValidation=reasonValidation;
        
        function clear(){
        	$uibModalInstance.dismiss('cancel');
        }
        
        function confirm(){
        	 Tasks.reject({"taskId": vm.taskId}, vm.reason, onSuccess, onError);
        	 $uibModalInstance.close('');
        	 $uibModalStack.dismissAll();
        }
        
        function onSuccess(){
        	$rootScope.removeRow(vm.taskId);
        }
        
        function onError(){
        	
        }
       // this validation comen for all input validation 
        $scope.$watch('vm.reason', function(value){
            if (value != null && value != undefined && value !='') {
             value = value.toString().replace(/^[^a-zA-Z0-9]|[{}<>]/g,'');
                value = value.toString().replace(/^[^a-zA-Z0-9]+|[{}<>]/g, '');
                vm.reason= value;
        }
        });
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('StringUtils', StringUtils);

    StringUtils.$inject = ['ArrayUtils'];

    function StringUtils(ArrayUtils) {

        return {
            isBlank: isBlank,
            truncate: truncate,
            getMaximumLength: getMaximumLength,
            getValid: getValid,
            trim: trim,
            includes : includes,
            toUpperCase: toUpperCase,
            toLowerCase: toLowerCase,
            isString: isString,
            parseBoolean: parseBoolean,
            isEqual: isEqual
        };

        /**
         * Check If String is Blank
         * <code>
         *     isBlank(undefined) // true
         *     isBlank(null) // true
         *     isBlank(1) // true
         *     isBlank("") // true
         *     isBlank(" ") // true
         *     isBlank("Test") // false
         *     isBlank(" Test ") // false
         * </code>
         * @param   string          Test String
         * @return  true or false   Boolean
         */
        function isBlank(string) {
            return (string == undefined || string == null || !angular.isString(string) || string.trim() == "");
        }

        function getValid(string, defaultString) {
            return !isBlank(string) ? string : defaultString;
        }

        /**
         * Truncate the input string upto given maximum length
         * <code>
         *     truncatedString = truncate("Test", 2); // "Te"
         * </code>
         * @param   string          Input String
         * @param   maxLength       Maximum length
         * @return  returnString    Truncated String
         */
        function truncate(string, maxLength) {
            var returnString = string;
            if (!isBlank(string)) {
                if (string.length > maxLength) {
                    returnString = string.substr(0, maxLength) + '...';
                }
            }
            return returnString;
        }

        /**
         * Get Maximum length of a string property in an array of objects
         * <code>
         *     maxLength = getMaximumLength([{ 'businessUnit': { 'shortName': 'PLANO' }}, 
                                             { 'businessUnit': { 'shortName': 'KOHINOOR' }}], 'businessUnit.shortName'); // 8
         * </code>
         * @param   objectArray     Array of objects
         * @param   property        Property - Object path
         * @return  maxLength       Maximum length of given property
         */
        function getMaximumLength(objectArray, property) {
            var maxLength = 0;
            if (!ArrayUtils.isEmpty(objectArray)) {
                angular.forEach(objectArray, function(object, index) {
                    var evaluatedString = isBlank(_.get(object.model, property)) ? "" : _.get(object.model, property);
                    if (index == 0) {
                        maxLength = evaluatedString.length;
                    } else {
                        if (evaluatedString.length > maxLength) {
                            maxLength = evaluatedString.length;
                        }
                    }
                });
            }
            return maxLength;
        }

        function trim(string) {
            var trimmedString = ""
            if(!isBlank(string)) {
                trimmedString = string.replace(/^\s+|\s+$/gm, '');
            }
            return trimmedString;
        }
        
        /**
         * Check whether given value present in String
         */
        function includes(collection, value) {        	
        	return _.includes(collection, value);
        }

        function toUpperCase(value) {
            if (isBlank(value)) return "";
            return value.toUpperCase();
        }
        
        function toLowerCase(value) {
            if (isBlank(value)) return "";
            return value.toLowerCase();
        }

        function isString(value) {
            return angular.isString(value);
        }

        function parseBoolean(booleanString) {
            return !isBlank(booleanString) && trim(toLowerCase(booleanString)) === "true";
        }
        
        function isEqual(string1, string2){
        	return (string1 == string2);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('gatewayApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('gatewayApp')
        .constant('OperationEnum', {
        	ADD: 'Add', EDIT: 'Edit', DELETE: 'Delete', NONE: 'None'
        })
        .run(['$rootScope', 'OperationEnum', function($rootScope, OperationEnum) {
            $rootScope.OperationEnum = OperationEnum;
        }]);
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('ObjectUtils', ObjectUtils);

    ObjectUtils.$inject = ['StringUtils', 'ArrayUtils'];

    function ObjectUtils(StringUtils, ArrayUtils) {

        return {
            isInvalid: isInvalid,
            isEqual: isEqual,
            removeProperty: removeProperty,
            getFieldDescription: getFieldDescription,
            getObjectFromDescription: getObjectFromDescription,
            isObject: isObject,
            valueOf: valueOf,
            isNotNull: isNotNull,
            isEmpty: isEmpty,
            getKeys: getKeys,
            getValue: getValue,
            hasKeys: hasKeys
        };

        /**
         * Check If object is Invalid
         * @param   object          Test object
         * @return  true or false   Boolean
         */
        function isInvalid(object) {
            return object == undefined || object == null || !angular.isObject(object);
        }

        function removeProperty(object, property) {
            if (!isInvalid(object) && !StringUtils.isBlank(property) && object.hasOwnProperty(property)) {
                delete object[property];
            }
        }

        /**
         * Check If Two objects are equal by value
         * @param  baseObject       Base Object to compare with
         * @param  destinyObject    Destiny Object for comparison
         * @return {Boolean}        Returns Equality
         */
        function isEqual(baseObject, destinyObject) {
            // Create arrays of property names     
            var baseObjectProperties = _.keys(baseObject);
            var destinyObjectProperties = _.keys(destinyObject);

            // If count of properties is different, objects are not equivalent     
            if (baseObjectProperties.length != destinyObjectProperties.length) {
                return false;
            }

            for (var index = 0; index < baseObjectProperties.length; index++) {
                var property = baseObjectProperties[index];
                // If values of same property are not equal, objects are not equivalent         
                if (!_.isEqual(baseObject[property], destinyObject[property])) {
                    return false;
                }
            }
            // If we made it this far, objects are considered equivalent     
            return true;
        }


        function getFieldDescription(object, rowSeparator, columnSeparator) {
            var description = "";
            var keyValuePairs = [];
            var keys = _.keys(object);
            for (var index = 0; index < keys.length; index++) {
                if (!StringUtils.isBlank(object[keys[index]])) {
                    keyValuePairs.push(keys[index] + columnSeparator + object[keys[index]]);
                }
            }
            if (!ArrayUtils.isEmpty(keyValuePairs)) {
                description = keyValuePairs.join(rowSeparator);
            }
            return description;
        }


        function getObjectFromDescription(description, rowSeparator, columnSeparator) {
            var object = {};

            if (!StringUtils.isBlank(description)) {
                var rows = description.split(rowSeparator);

                if (!ArrayUtils.isEmpty(rows)) {
                    for (var index = 0; index < rows.length; index++) {
                        var keyValuePair = rows[index].split(columnSeparator);
                        object[keyValuePair[0]] = keyValuePair[1];
                    }
                }
            }

            return object;
        }

        function isObject(object) {
            return angular.isObject(object);
        }

        function valueOf(object, objectPath) {
            var returnValue = '';
            if (isObject(object) && !isInvalid(object) && !StringUtils.isBlank(objectPath)) {
                returnValue = _.get(object, objectPath, '');
            } else if (StringUtils.isString(object)) {
                returnValue = object;
            }
            return returnValue;
        }

        function isNotNull(object) {
            return (object != undefined && object != null);
        }

        function isEmpty(object) {
            if (isNotNull(object)) {
                for (var key in object) {
                    if (object.hasOwnProperty(key)) {
                        return false;
                    }
                }
            }
            return true;
        }

        function getKeys(object) {
            return _.keys(object);
        }

        function getValue(object, path, defaultValue) {
            var returnValue = angular.copy(defaultValue);
            if(!isInvalid(object) && !StringUtils.isBlank(path)) {
                returnValue = _.get(object, path, defaultValue);
            }

            if(returnValue == undefined || returnValue == null) {
                returnValue = angular.copy(defaultValue);
            }
            return returnValue;
        }

        function hasKeys(object) {
            return !ArrayUtils.isEmpty(getKeys(object));
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) === 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('gatewayApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('FloatUtils', FloatUtils);

    FloatUtils.$inject = ['GlobalValues', 'StringUtils', '$filter'];

    function FloatUtils(GlobalValues, StringUtils, $filter) {

        var service = {
            getAbsFloat: getAbsFloat,
            getFloat: getFloat,
            getFixedFloat: getFixedFloat,
            getFixedAmount: getFixedAmount,
            getFixedRate: getFixedRate,
            isInvalid: isInvalid,
            getSignedFloat: getSignedFloat,
            multiply: multiply,
            divide: divide,
            add: add,
            subtract: subtract,
            difference: difference,
            getSign: getSign,
            getNegativeFloat: getNegativeFloat,
            isNumber: isNumber,
            parseNumber: parseNumber,
            valueOf: valueOf,
            isNegative: isNegative,
            format: format,
            getFormattedValue : getFormattedValue,
            convertAmountInCrores : convertAmountInCrores
        };

        return service;

        function isInvalid(number) {
            return number == undefined || number == null || isNaN(parseFloat(number)) || !angular.isNumber(parseFloat(number));
        }

        function getAbsFloat(number) {
            return Math.abs(getFloat(number));
        }

        function getFloat(number) {
            var floatNumber = 0;
            if (number != undefined && number != null) {
                if (angular.isString(number)) {
                    number = number.replace(/,/g, '');
                    number = number.replace("( ", "-");
                    number = number.replace(")", "");
                }
                floatNumber = parseFloat(number);
                if (isNaN(floatNumber)) {
                    floatNumber = 0;
                }
            }
            return floatNumber;
        }

        function getFixedFloat(number, numberOfDecimals) {
            var floatNumber = 0;
            floatNumber = getFloat(number);
            floatNumber = floatNumber.toFixed(numberOfDecimals);
            return parseFloat(floatNumber);
        }

        function getFixedAmount(amount) {
            return getFixedFloat(amount, GlobalValues.getNumberOfDecimalsForAmount());
        }

        function getFixedRate(rate) {
            return getFixedFloat(rate, GlobalValues.getNumberOfDecimalsForInputRate());
        }

        function getSignedFloat(referenceFloat, destinationFloat) {
            var returnFloat = getFloat(destinationFloat);
            referenceFloat = getFloat(referenceFloat);
            if(referenceFloat > 0) {
                returnFloat = getAbsFloat(destinationFloat);
            } else if(referenceFloat < 0) {
                returnFloat = getAbsFloat(destinationFloat) * -1;
            }
            return returnFloat;
        }

        function divide(numerator, denominator, numberOfDecimals) {
            var returnValue = 0;
            denominator = getFloat(denominator);
            if (denominator != 0) {
                returnValue = getFixedFloat(getFloat(numerator) / denominator, numberOfDecimals);
            }
            return returnValue;
        }

        function multiply(multiplier, multiplicand){
        	 var returnValue = 0;
        	 return getFloat(multiplier) * getFloat(multiplicand);
        }
        
        function add(augend, addend) {
            return getFloat(augend) + getFloat(addend);
        }

        function subtract(minuend, subtrahend) {
            return getFloat(minuend) - getFloat(subtrahend);
        }

        function difference(minuend, subtrahend) {
            return getAbsFloat(subtract(minuend, subtrahend));
        }

        function getSign(number) {
            var sign = 1;
            if(getFloat(number) < 0) {
                sign = -1;
            }
            return sign;
        }

        function getNegativeFloat(value) {
            return getAbsFloat(value) * -1;
        }

        function isNumber(value) {
            return angular.isNumber(value);
        }

        function parseNumber(floatString) {
            var returnValue = 0;
            if (!StringUtils.isBlank(floatString)) {
                if (floatString[0] == '(' && floatString[floatString.length - 1] == ')') {
                    returnValue = floatString.replace(/[(),]/g, '');
                    returnValue = '-' + returnValue;
                } else if (floatString[0] == '-') {
                    returnValue = floatString.replace(/[(),]/g, '');
                } else {
                    returnValue = floatString;
                }
                returnValue = getFloat(returnValue.replace(/[,]/g, ''));
            }
            return returnValue;
        }

        function valueOf(value) {
            var returnValue = 0;
            if(isNumber(value)) {
                returnValue = getFloat(value);
            } else if(StringUtils.isString(value)) {
                returnValue = parseNumber(value);
            }
            return returnValue;
        }
        
        function isNegative(value){
        	if(value < 0 ){
        		return true;
        	}
        	else{
        		return false;
        	}
        }

        function format(value, noOfDecimals) {
            return $filter('number')(value, noOfDecimals);
        }

        function getFormattedValue(value, numOfDecimals){
            return getFloat(value).toLocaleString
                (GlobalValues.getLocaleString(), 
                    { maximumFractionDigits: numOfDecimals, minimumFractionDigits : numOfDecimals});
            
        }

        function convertAmountInCrores(value, numOfDecimals){
            var convertedValue = divide(value, getFloat(10000000), numOfDecimals);
            return getFormattedValue(convertedValue, numOfDecimals);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('FileUtil', FileUtil);

    FileUtil.$inject = ['$window', '$fileLogger', '$timeout'];

    function FileUtil ($window, $fileLogger, $timeout) {

        var service = {
        		checkImageFileExtension: checkImageFileExtension,
        		checkPanImageFileExtension : checkPanImageFileExtension,
        		checkTermsConditionExtension:checkTermsConditionExtension,
        		checkExcelFileExtension : checkExcelFileExtension,
                checkZipFileExtension : checkZipFileExtension,
        		isFileSizeValid : isFileSizeValid,
        		isFileNameValid : isFileNameValid,
        		base64ToArrayBuffer : base64ToArrayBuffer,
                downloadLogFile : downloadLogFile,
                viewFile : viewFile,
                viewFileFromBase64  : viewFileFromBase64,
                downloadFileFromBase64 : downloadFileFromBase64,
                parseExcelFile : parseExcelFile

        };

        return service;

        function checkImageFileExtension(firstFourBytes) {        	
        	 
        	  var header = "";
        	  for(var i = 0; i < firstFourBytes.length; i++) {
        	     header += firstFourBytes[i].toString(16);
        	  }
        	  console.log(header);
        	  var type = 'unknown';
        	  // Check the file signature against known types
              switch (header) {
                  case '89504e47':
                      type = 'image/png';
                      break;
                  case 'ffd8ffe0':
                  case 'ffd8ffe1':
                  case 'ffd8ffe2':
                      type = 'image/jpeg';
                      break;
                  /*case '25504446':
                      type = 'application/pdf';
                      break;*/
              }
              if(type == 'unknown'){
            		  return false;
        		
              }
              else{ return true };

        }
        function checkExcelFileExtension(firstFourBytes) {        	
       	 
      	  var header = "";
      	  for(var i = 0; i < firstFourBytes.length; i++) {
      	     header += firstFourBytes[i].toString(16);
      	  }
      	  console.log(header);
      	  var type = 'unknown';
      	  // Check the file signature against known types
            switch (header) {
                case 'd0cf11e0':
                    type = 'application/vnd.ms-excel';
                    break;
                case '504b34':
                    type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    break;
                
            }
            if(type == 'unknown'){
          		  return false;
      		
            }
            else{ return true };

      }
      function checkZipFileExtension(firstFourBytes) {        	
       	 
        var header = "";
        for(var i = 0; i < firstFourBytes.length; i++) {
           header += firstFourBytes[i].toString(16);
        }
        console.log(header);
        var type = 'unknown';
        // Check the file signature against known types
        switch (header) {
            
            case '504b34':
                type = 'application/x-zip-compressed';
                break;
            
        }
        if(type == 'unknown'){
                return false;
          
        }
        else{ return true };

  }
        
        function checkPanImageFileExtension(firstFourBytes) {        	
       	 
      	  var header = "";
      	  for(var i = 0; i < firstFourBytes.length; i++) {
      	     header += firstFourBytes[i].toString(16);
      	  }
      	  console.log(header);
      	  var type = 'unknown';
      	  // Check the file signature against known types
            switch (header) {
                case '89504e47':
                    type = 'image/png';
                    break;
                
                case 'ffd8ffe0':
                case 'ffd8ffe1':
                case 'ffd8ffe2':
                    type = 'image/jpeg';
                    break;
                case '25504446':
                    type = 'application/pdf';
                    break;
            }
            if(type == 'unknown'){
          		  return false;
      		
            }
            else{ return true };

      }
      
        function checkTermsConditionExtension(firstFourBytes) {        	

        	var header = "";
        	for(var i = 0; i < firstFourBytes.length; i++) {
        		header += firstFourBytes[i].toString(16);
        	}
        	console.log(header);
        	var type = 'unknown';
        	// Check the file signature against known types
        	switch (header) {

        	case '25504446':
        		type = 'application/pdf';
        		break;
        	}
        	if(type == 'unknown'){
        		return false;

        	}
        	else{ return true };

        }

        
      function isFileSizeValid(size, minSize, maxSize) {   
    	  if(size < minSize || size  > maxSize  ){
    		  return false;
    	  }else{
    		  return true;
    	  }
       	 
      }
      function isFileNameValid(fileName, maxlength) {        	
        	 if(fileName.length > maxlength){
        		 return false;
        	 }
        	 return true;
      }
      function base64ToArrayBuffer(base64) {
  	    var binary_string =  window.atob(base64);
  	    var len = binary_string.length;
  	    var bytes = new Uint8Array( len );
  	    for (var i = 0; i < len; i++)        {
  	        bytes[i] = binary_string.charCodeAt(i);
  	    }
  	    return bytes.buffer;
  	}
        
    function downloadLogFile(fileName){
        $fileLogger.getLogfile().then(function(l) {
            downloadFile(l, fileName);

            $timeout(function(){
                $fileLogger.deleteLogfile().then(function() {
                  console.log('Logfile deleted');
                });
            }, 1000);
        });

        
    }
    
    function downloadFile(result, fileName){
        var baseString = fileName + "_" + moment().format( 'DD_MMM_YYYY_HH_mm_ss') + ".log";  
        var blob = new Blob([ result ], { type : 'text/plain' });
        window.saveAs(blob, baseString);
    }

    function viewFile(file, fileName){
        var fileURL = URL.createObjectURL(file);
        if(window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file, fileName);
        }
        else {
            window.open(fileURL, fileName);    
        }
      }



function viewFileFromBase64(base64string, fileName){
            var content = base64ToArrayBuffer(base64string);
            var bytes = new Uint8Array( content );
            var mimeType = getMimeTypeForFile(bytes.slice(0,4));
            var fileData = content;  
            var bytes = new Uint8Array( fileData );
            var file = new Blob([bytes], {type: mimeType});
      		
            viewFile(file, fileName);
        }



// function downloadFile(file){
//             var link = document.createElement("a");   
//             var objectURL = URL.createObjectURL(file);
//             link.download = file.name;
//             link.href = objectURL;
            
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//         }

        function downloadFileFromBase64(base64string, fileName){
            var content = base64ToArrayBuffer(base64string);
            var bytes = new Uint8Array( content );
            var mimeType = getMimeTypeForFile(bytes.slice(0,4));
            var fileData = content;
            var link = document.createElement("a");   
            var bytes = new Uint8Array( fileData );

            var blob = new Blob([bytes], {
                type: mimeType
            });
            
            saveAs(blob, fileName);
        }

        function parseExcelFile(data){
			  var workbook = XLSX.read(data, { type: 'array', cellDates: true ,date1904: true});
			  var worksheet = workbook.Sheets[workbook.SheetNames[0]];
			  var jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: ''});
        jsonData = convertNullToEmptyString(jsonData);
				var excelData = removeEmptyCells(jsonData);
        formatDates(excelData);
        return excelData;
			
        }
        
        function convertNullToEmptyString(data) {
            return data.map(function(row) {
              return row.map(function(cell) {
                return cell === null ? '' : cell;
              });
            });
          }
      
        function readFileAsArrayBuffer(file, callback) {
            var reader = new FileReader();
            reader.onload = function (e) {
              var data = new Uint8Array(e.target.result);
              callback(data);
            };
            reader.readAsArrayBuffer(file);
          }

        function removeEmptyCells(data) {
			    return data.filter(function(row) {
			  return row.some(function(cell) {
				return cell !== '';
			  });
			});
		  }
           function formatDates(excelData) {
            excelData.forEach(function(row) {
              for (var i = 0; i < row.length; i++) {
                if (row[i] instanceof Date) {
                  var formattedDate = new Date(moment(row[i]).add(1, 'days'));
                  row[i] = formattedDate;
                }
              }
            });
          }
    
}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .constant('errorConstants', (function() {
            var problemBaseUrl = 'http://www.jhipster.tech/problem';
            return {
                EMAIL_ALREADY_USED_TYPE: problemBaseUrl + '/email-already-used',
                LOGIN_ALREADY_USED_TYPE: problemBaseUrl + '/login-already-used',
                EMAIL_NOT_FOUND_TYPE: problemBaseUrl + '/email-not-found',
                MOBILE_ALREADY_USED_TYPE: problemBaseUrl + '/mobile-already-used',
                USER_NOT_LOCKED_TYPE: problemBaseUrl + '/user-not-locked',
                USER_LOCKED_TYPE: problemBaseUrl + '/user-locked',
                EMAIL_OR_MOBILE_NOT_FOUND_TYPE: problemBaseUrl + '/email-or-mobile-not-found',
                PREVIOUS_PASSWORD_CANNOT_BE_USED_TYPE: problemBaseUrl + '/previous-password-cannot-be-used',
                PASSWORD_CANNOT_BE_CHANGED_WITH_IN_HOURS_TYPE: problemBaseUrl + '/password-cannot-be-changed-with-in-hours',
                PASSWORD_EXPIRED_TYPE: problemBaseUrl + '/password-expired',
                USER_BLOCKED_TYPE: problemBaseUrl + '/user-blocked',
                PASSWORD_SYSTEM_GENERATED_TYPE: problemBaseUrl + '/password-system-generated',
                TRADING_NOT_ACTIVATED_TYPE: problemBaseUrl + '/trading-not-activated',
                INVALID_OTP_TYPE: problemBaseUrl + '/invalid-otp',
                USER_SUSPENDED_TYPE :  problemBaseUrl + '/user-suspended',
                USER_ENTITY_SUSPENDED_TYPE :  problemBaseUrl + '/user-entity-suspended',
                NO_ACTIVE_BANK_RELATIONSHIP :  problemBaseUrl + '/no-active-bank-relationship',
//                EXCEEDS_PERMISSIBLE_USERS_COUNT_TYPE: problemBaseUrl + '/exceeds-permissible-users-count',
                PASSWORD_CONTAIN_LOGIN_TYPE: problemBaseUrl + '/password-contain-login',
                INCORRECT_PASSWORD_TYPE: problemBaseUrl + '/incorrect-password',
                USER_DORMANT_TYPE: problemBaseUrl + '/user-dormant',
                USER_DELINKED_TYPE: problemBaseUrl + '/user-entity-delinked',
                EMAIL_SEND_ATTEMPTS_BREACHED: problemBaseUrl + "/email-send-attempts-breached",
                USERNAME_NOT_FOUND : problemBaseUrl + "/user-name-not-found",
                INVALID_CAPTCHA: problemBaseUrl +"/invalid-captcha-details",
                MAXIMUM_CAPTCHA_TIME_EXCEED_TYPE : problemBaseUrl +"/maximum-captcha-time-exceed"
            }
        })());
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .constant('entityConstants', (function() {           
            return {
            	ENTITY_SHORT_NAME:{
            		BANK_REGISTRATION : 'BankRegistration',
            		USER_MANAGEMENT : 'UserManagement',
            		ORGANISATION_ROLE : 'OrganisationRole',
            		BRANCH_REGISTRATION: 'BranchRegistration',
            		CUSTOMER_VIEW_REPORT:'CustomerViewReport',
            		TRADING_BANK_LIST : 'TradingBankList',
            		SECURITY_POLICY : 'SecurityPolicy',
            		APPROVAL_PROCESS : 'ApprovalProcess',
            		ENTITY_STATE_APPROVAL_PROCESS : 'EntityStateApprovalProcess',
            		TODO:'ToDo',
            		CUSTOMER_APPROVAL: 'CustomerApproval',
            		SESSION_LOG_REPORT : 'SessionLogReport',
            		AUDIT_LOG_REPORT : 'AuditLogReport',
            		CUSTOMER_ONBOARDING_EXCEPTION_REPORT : 'CustomerOnboardingExceptionReport',
            		NO_OF_AVAILABLE_USERS : 'NumberOfAvailableUsers',
            		NO_OF_LOGGED_IN_USERS : 'NumberOfLoggedinUsers',
            		EMAIL_SETTINGS : 'EmailSettings',
            		USER_ROLE : 'UserRole',
            		SMS_FAILURE_REPORT : 'SMSFailureReport',
            		SMS_SETTINGS : 'SMSSettings',
            		HISTORY_REPORT : 'HistoryReport',
            		GLOBAL_SECURITY_POLICY :'GlobalSecurityPolicy',
            		GLOBAL_APPROVAL_PROCESS : 'GlobalApprovalProcess',
            		MANAGE_GLOBAL_ENTITY_STATE_APPROVAL_PROCESS : 'ManageGlobalEntityStateApprovalProcess',
            		CUSTOMER_REGISTRATION : 'CustomerRegistration',
            		CUSTOMER : 'Customer',
            		USER_ADMIN_APPLICATION_WIDE_SETTINGS : 'UserAdminApplicationWideSettings',
            		DELAING_ADMIN_APPLICATION_WIDE_SEETINGS : 'DealingAdminApplicationWideSettings',
            		EOD_PROCESS : 'EODProcess',
            		USER_PROFILE : 'UserProfile',
            		DEFAULT_MARKUP_SETTINGS : 'DefaultMarkupSettings',
            		MARKUP_SETTINGS : 'MarkupSettings',
            		SPECIAL_HOLIDAY : 'SpecialHoliday',
            		REGULAR_HOLIDAY : 'RegularHolidays',
            		SWAP_QUOTES: 'SwapQuotes',
            		HE_CONNECTIVITY_SETTINGS: 'HEConnectivitySettings',
            		INSTRUMENT_VIEW : 'InstrumentView',
            		INTRADAY_MARKET_SESSION_SETTINGS: 'IntradayMarketSessionSettings',
            		DEFAULT_MARKET_SESSION_SETTINGS:'DefaultMarketSessionSettings',
            		USER_RESTRICTION : 'UserRestriction',
            		LIMITSETTINGS : 'LimitSettings',
            		CUSTOMERLIMITSETTINGS :'CustomerLimitChangeRequest',
            		MARKUPREPORT : 'MarkupReport',
            		ORDERSTATUSREPORT : 'OrderStatusReport',
            		ORDERACTIVITYREPORT: 'OrderActivityReport',
            		MARKETMOVEMENT: 'MarketMovement',
            		USERWISETURNOVERREPORT: 'UserwiseTurnoverReport',
            		TRADESTOBESETTLEDREPORT: 'TradesToBeSettledReport',
            		SOD_PROCESS: 'SODProcess',
            		ORDER_HISTORY : 'OrderHistory',
            		TRADE_HISTORY : 'TradeHistory',
            		NO_OF_AVAILABLE_USER_REPORT : 'NoOfAvailableUsers',
            		NO_OF_LOGGEDIN_USER_REPORT : 'NoOfLoggedInUsers',
            		AMC_SETTINGS : 'AMCSettings',
            		CUSTOMER_CHARGES : 'CustomerCharges',
            		GST_SETTINGS : 'GSTSettings',
            		INVOICE_VIEW:'InvoiceView',
            		TRANSACTION_CHARGES:'TransactionChargesReport', 
            		TRADEORDERMANAGEMENTDASHBOARD: 'TradeOrderManagementDashboard',
            		TRADES_DOWNLOAD: 'TradesDownload',
            		HE_STATUS_UPDATE:'HEStatusUpdate',
            		ORDER_SERVER_MANUAL_LOGIN : 'OrderServerManualLogin',
            		SERVER_COMPONENT_STATUS :'ServerComponentStatus',
            		UPLOAD_DOWNLOAD_PARTICIPANT_CERTIFICATE : 'UploadDownloadParticipantCertificate',
            		HOLIDAY_REPORT:'HolidayReport',
            		HOME_BRANCH_IFSC_UPLOAD:'HomeBranchIFSCUpload',
            		MODIFY_CUSTOMER_DETAILS:'ModifyCustomerDetails',
                    PENDING_ORDER_REPORT : 'PendingOrderReport',
                    TRADES_FOR_THE_DAY : 'TradesForTheDay',
                    SWAP_QUOTES_VIEW : 'SwapQuotesView',
                    CUSTOMER_MARKUP_VIEW : 'CustomerMarkupView',
                    LIMIT_UTILISATION_REPORT : 'LimitUtilisationReport',
                    STANDARD_TENOR_VIEW:'StandardTenorView',
                    SYSTEM_AMENDED_TRADES:'SystemAmendedTradesReport',
                    TERMS_AND_CONDITIONS_VIEW: 'TermsAndConditionsView',
                    CLEARCORP_TAC_UPLOAD:'TermsAndConditionsUpload',
                    CUSTOMER_TERMS_AND_CONDITIONS_UPLOAD:'CustomerTermsAndConditionsUpload',
                    OTR_SUMMARY_VIEW:'OTRSummary',
                    TRANSACTION_CHARGES_SUMMARY_VIEW:'TransactionChargesSummary',
                    AMC_SUMMARY_VIEW:"AMCSummary",
                    NO_OF_LOGGEDIN_USER_REPORT_FOR_BANK:"NoOfLoggedInUsersForBank",
                    USERACCESSVIEW:"UserAccessView",
                    EXPOSURE_TYPE:"ExposureType",
                    EXPOSURE_SUB_TYPE:"ExposureSubType",
                    CREDIT_FACTOR_SETTINGS:"CreditFactorSettings",
					LIMIT_UTILISATION_SPLITUP:"LimitUtilisationSplitupReport",
					OUTSTANDING_TRADES_REPORT:"OutstandingTradesReport",
					PENDING_LIMIT_REQUESTS_VIEW:"PendingLimitRequestsView",
					CREDIT_FACTOR_SETTINGS_VIEW: "CreditFactorSettingsView",
					BANK_FEES_CHARGES_UPLOAD: "BankFeesChargesUpload",
					BANK_FEES_CHARGES_VIEW: "BankFeesAndChargesView",
					CLEARCORP_FEES_AND_CHARGES_VIEW:"ClearcorpFeesAndChargesView",
					CANCELLEDORDERSREPORT:"CancelledOrdersReport",
					EINVOICE_UPLOAD:"eInvoiceUpload",
					OTR_SUMMARY_FOR_BANK:"OTRSummaryForBank",
					ORDER_ACTIVITY_LOG:"OrderActivityLog",
					ORDER_UPLOAD :"OrderUpload",
					ORDER_CONFIRMATION:"OrderConfirmation",
					MANAGE_ENTITY_RESTRICTIONS : "EntityRestriction",
 					MANAGE_HOME_BRANCH:"ManageHomeBranch",
 					NOTIFICATION_SETTINGS:"NotificationSettings",
					MANAGE_Forex_Configurations:"ManageForexConfigurations",
					MANAGE_CURRENCY_PAIR_CONFIGURATIONS:"ManageCurrencyPairConfiguration",
					MANAGE_BBPS_SETTINGS:"ManageBBPSSettings"

            	},
            	ENTITY_ACTION_TYPE:{
            		ACCESS : 'ACCESS',
            		VIEW_DETAILS : 'VIEW DETAILS',
            		APPROVE : 'APPROVE',
            		DISCARD : 'DISCARD',
            		REJECT : 'REJECT',
            		VIEW : 'VIEW',
            		EDIT :'EDIT',
                    RESET : 'RESET',
            		MAP :'MAP',
            		DELINK :'DELINK',
            		CREATE :'CREATE',
            		ADD :'ADD',
            		DELETE :'DELETE',
            		RESUBMIT:'RESUBMIT',
            		CLEARDATA:'CLEARDATA',
            		RESEND :'RESEND',
            		REMOVE:'REMOVE',
            		WITHDRAW:'WITHDRAW',
            		IMPORT:'IMPORT',
            		LOGIN : 'LOGIN',
            		UPLOAD : 'UPLOAD',
            		DOWNLOAD : 'DOWNLOAD',
            		AGREE : 'AGREE',
            		VIEW_AGREED_BANKS:'VIEW AGREED BANKS',
            		EXPORT_AGREED_BANKS:'EXPORT AGREED BANKS',
            		VIEW_BANKS_TAC_FOR_CUSTOMERS:'VIEW BANK\'S TERMS AND CONDITIONS FOR CUSTOMERS',
            		VIEW_HISTORY:'VIEW HISTORY'

            	}
            }
        })());
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter','GlobalValues'];

    function DateUtils($filter,GlobalValues) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            getMinimumLocalDate : getMinimumLocalDate,
            dateformat: dateformat,
            convertLocalDateFromServerTo12HrsString:convertLocalDateFromServerTo12HrsString,
            getSubtractMonth:getSubtractMonth,
            convertLocalDateTimeToServer:convertLocalDateTimeToServer
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }
        function convertLocalDateTimeToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-ddTHH:mm:ss');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
        function convertLocalDateFromServerUsingMoment(date){
        	if (date) {
                //var dateString = date.split('-');
                return  moment(date, 'YYYY-DD-MM');
            }
        	return null;
        }
        function convertLocalDateFromServerTo12HrsString(date){
        	if (date) {
                //var dateString = date.split('-');
                return  moment(date).format('DD-MMM-YYYY hh:mm:ss A');
            }
        	return null;
        }
        
        function getMinimumLocalDate(date){
        	
        	//get first day of previous month
        	return new Date(date.getFullYear(), date.getMonth() - 1, 1);
        }

        function getSubtractMonth(date,noOfMonths){
            return new Date(date.getFullYear(), date.getMonth() - noOfMonths, 1);
        }
        
        
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            var fileURL = 'data:' + type +';base64,' + data;
            var win = $window.open('', '_blank');
            win.document.write(
                '<iframe src="' +
                fileURL +
                '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" sandbox="allow-same-origin allow-scripts allow-presentation" allowfullscreen></iframe>'
            );
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .service('CollectionUtils', CollectionUtils);

    CollectionUtils.$inject = ['ArrayUtils', 'ObjectUtils', 'StringUtils'];

    function CollectionUtils(ArrayUtils, ObjectUtils, StringUtils) {

        this.filter = function (array, objectPath, filterValue) {
            var filteredValue = [];

            if (!ArrayUtils.isEmpty(array) && !StringUtils.isBlank(filterValue)) {
                filteredValue = _.filter(array, function (element) {
                    return ObjectUtils.valueOf(element, objectPath).toLowerCase() === filterValue.toLowerCase();
                });
            }
            return filteredValue;
        };

        this.firstFilterValue = function (array, objectPath, filterValue) {
            var filteredValueArray = this.filter(array, objectPath, filterValue);
            var filteredValue;

            if (filteredValueArray.length > 0) {
                filteredValue = filteredValueArray[0];
            }
            return filteredValue;
        }
        this.includes = function (collection, element) {
            return _.includes(collection, element);
        };

        /** sort the collection by give element list
         * ex :var users = [ { 'user': 'fred',   'age': 48 },  { 'user': 'barney', 'age': 36 },
                             { 'user': 'fred',   'age': 40 },  { 'user': 'barney', 'age': 34 }];
                            
                    sort(users, ['user', 'age']);
                     => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
         */
        this.sort = function (collection, elementList) {
            return _.sortBy(collection, elementList);
        }

        this.map = function(collection, iteratee) {
            return _.map(collection, iteratee);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('ArrayUtils', ArrayUtils);

    ArrayUtils.$inject = [];

    function ArrayUtils () {

        return {
            isEmpty: isEmpty,
            hasNull: hasNull,
            join:    join,
            hasEqualLength: hasEqualLength,
            concat: concat
        };

        /**
         * Check If Array is Blank
         * @param   array          Test array
         * @return  true or false   Boolean
         */
        function isEmpty(array) {
            return array == undefined || array == null || !angular.isArray(array) || array.length == 0;
        }

        /**
         * Check If Array has any null value
         * @param   array          Test array
         * @return  true or false   Boolean
         */
        function hasNull(array) {
            var hasNull = true;
            if(!isEmpty(array)) {
                hasNull = array.every(function(arrayElement) {
                    return (arrayElement != undefined && arrayElement != null);
                });
            }
            return !hasNull;
        }

        function join(array, objectPath, separator) {
            var elements = [];
            if(!isEmpty(array)) {
                for (var index = 0; index < array.length; index++) {
                    elements.push(_.get(array[index], objectPath, ""));
                }
            }
            return _.join(elements, separator);
        }

        function hasEqualLength(source, destination) {
            return !isEmpty(source) && !isEmpty(destination) && source.length === destination.length;
        }
        
        function concat(array, values) {
            return _.concat(array, values);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('search-faq', {
            parent: 'entity',
            url: '/gatewayDesk',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/search-faq/search-faq.html',
                    controller: 'SearchFaqController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('searchfaq');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })

/*     .state('search-faq.view', {
        parent: 'entity',
        url: '/search-faq/{videofilename}',
        ncyBreadcrumb: {
            label: '{{ "global.menu.faq.searchfaq" | translate }} ',
            parent: 'search-faq'
          },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'global.title'
        },
        views: {
            'content@': {
                templateUrl: 'app/components/search-faq/faq-video.html',
                controller: 'FaqVideoController',
                controllerAs: 'vm'
            }
        },
        resolve: {

            entity: ['$stateParams', function($stateParams){
            	return $stateParams.videofilename;
            }]
        }
        });*/

        .state('search-faq.view', {
            parent: 'search-faq',
            url: '/search-faq/{videofilename}',
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.searchfaq" | translate }} ',
                parent: 'search-faq'
              },
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/search-faq/faq-video.html',
                    controller: 'FaqVideoController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	return {videoName : $stateParams.videofilename};
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]

            });

}
})();        
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'searchfaq'
        })
        
        .controller('SearchFaqController', SearchFaqController);

    SearchFaqController.$inject = ['$rootScope', '$scope', '$state', '$filter', 'workflowSharedService', 'FAQService', 'GlobalValues', 'EntityPermissions', '$sce'];

    function SearchFaqController($rootScope, $scope, $state, $filter, workflowSharedService, FAQService, GlobalValues, EntityPermissions, $sce) {
        var vm = this;
        workflowSharedService.viewFrom = "searchfaq";
       
		vm.permitSearchFaqViewEntityAction = EntityPermissions.hasPermission('SearchFAQ.VIEW')

		vm.loadincomplete = true;
       
        vm.Myshow=false;
        
        vm.faqdetailsfiltered=[];
        
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        
        loadAll();

		function loadAll() {

			//load faq category list from json file
			loadfaqcategory();

			//load faq details from json
			loadfaqdetails();
			
		}
        
		function loadfaqdetails(){
			FAQService.downloadJSONFile({
				"type" : "faq",
				"fileName" : "faqdetailsjson.txt",
				"fileType" : "txt"
			}, function(result) {
				vm.faqdetailsfromJSONFile = result;
				vm.loadincomplete = false;
				vm.filterfaqcategory('Approval');
			});
		}
		
		function loadfaqcategory(){
			FAQService.downloadJSONFile({
				"type" : "faq",
				"fileName" : "faqcategorylist.txt",
				"fileType" : "txt"
			}, function(result) {
				vm.faqcategorylistfromJSONFile = result;
				vm.loadincomplete = false;
			});
		}
		
		  vm.downloadTemplate = function downloadTemplate(templatefilename){
	        	 //alert("downloadTemplate");
	        	 //alert(templatefilename);
	        	 
	             var downloadLink = document.createElement("a");
	             downloadLink.href = "api/file/faq/templates/downloadtemplate/" + templatefilename + "/xlsx";            
	             downloadLink.download = templatefilename;
	             //alert("downloadTemplate1");

	             document.body.appendChild(downloadLink);
	             downloadLink.click();
	             document.body.removeChild(downloadLink);
	               //FAQService.downloadTemplate({fileName:'Template',fileType:'xls'}, onSuccess, onFailure);
	         }
		vm.searchFaqByEnter = function($event) {
			if ($event.keyCode === 13){
				vm.searchFaq(vm.questionHint);
			}
		}
		
        vm.filterfaqcategory = filterfaqcategory; 
        	function filterfaqcategory(category){
        		vm.faqdetailsfiltered = null;
        		vm.faqcategory = ''
    			var as = $(vm.faqdetailsfromJSONFile)
    			        .filter(function (i,n){
    			            return (n.categorylist.indexOf(category) != -1);
    			        }).css( "background-color", "red" );
//    			   alert(as);
//    			   alert(Object.keys(as).length);
                   if (Object.keys(as).length > 3){
                  	vm.faqdetailsfiltered = as;
                  	vm.faqcategory = category;
                   }
                   else{
                     vm.faqcategory = category + ' - No FAQ found'
                   }
    			   
        }
        
            
         vm.searchFaq = function searchFaq(faqStr){

        	 if (faqStr != null && faqStr != ""){

        		 vm.faqdetailsfiltered = null;
            	
        		 faqStr = faqStr.toLowerCase();
        		 
        		 var as = $(vm.faqdetailsfromJSONFile)
        		 .filter(function (i,n){
        			 return ((n.question.toLowerCase().indexOf(faqStr) != -1) || (n.answer.toLowerCase().indexOf(faqStr) != -1));
        		 });
		   
//        		 alert(as);
//        		 alert(Object.keys(as).length);
        		 vm.faqdetailsfiltered = as;

                if (Object.keys(as).length > 3){
                	 vm.faqdetailsfiltered = as;
                     vm.faqcategory = 'Related questions'
                 }
                 else{
                     vm.faqcategory = 'No such FAQ available'
                 }
        	 }
        }
         
        vm.highlight = function highlight(text, search) {
        	 //alert(text);
        	    if (!search) {
        	        return $sce.trustAsHtml(text);
        	    }
        	    return $sce.trustAsHtml(text.replace(new RegExp(search, 'gi'), '<span class="highlighted">$&</span>'));
        }
        
        $scope.isExpanded = function(faqDTO){
            return (faqDTO.expanded == false);
        };
         
    }
})();
         
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'searchfaq'
        })
        
        .controller('FaqVideoController', FaqVideoController);

    FaqVideoController.$inject = ['$rootScope', '$scope', '$state', '$uibModalInstance', 'workflowSharedService', 'FAQService', 'entity', 'GlobalValues', '$timeout'];

    function FaqVideoController($rootScope,  $scope, $state, $uibModalInstance, workflowSharedService, FAQService, entity, GlobalValues,$timeout) {
        var vm = this;
        workflowSharedService.viewFrom = "searchfaq";
       
        vm.videofilename = entity.videoName;

        getsourefilepath();
        
        function getsourefilepath(){
        	
        	$timeout(function () {
    			vm.videolink="api/file/faq/videos/download/" + vm.videofilename  + "/mp4";
            	var video = document.querySelector('video');
            	var source = document.querySelector('source');
//            	alert(vm.videolink);
//            	alert(source.src);
            	source.src = vm.videolink;
            	var isPlaying = video.currentTime > 0 && !video.paused && !video.ended 
                && video.readyState > 2;
                console.log(isPlaying);
                if (!isPlaying) {
                	video.load();
                	video.play();
                }
//            	video.load();
//            	video.play();
//            	alert("changesource end");

            }, 1000);
        	

        	
        }
        
        angular.element(document).ready(function () {
			   $('.videoElement').bind('contextmenu',function() { return false; });
         });
        
        vm.clear=clear;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('FaqViewController', FaqViewController);

    FaqViewController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance', '$http'];

     function FaqViewController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance, $http) {
        var vm = this;
        
		
       vm.faq=$rootScope.faqfilteredbyclick;
       vm.faqcategory = $rootScope.faqcategory;
       vm.faqcategorylistfromJSONFile = $rootScope.faqcategorylistfromJSONFile;
       vm.faqdetailsfilteredforselectedcategory = $rootScope.faqdetailsfilteredforselectedcategory;
       
        
        vm.faqdetailsfromJSONFile = $rootScope.faqdetailsfromJSONFile;
        vm.clear=clear;
        $scope.clicked=false;
        $scope.showButton = false;
       
        
        if(workflowSharedService.viewFrom == 'faq'){
        	//vm.faq=entity;
       	 	$scope.showButton=false;
        }

        vm.downloadTemplate = function downloadTemplate(templatefilename){
          	 //alert("downloadTemplate");
          	 //alert(templatefilename);
          	// vm.videofilename = "sample.mp4"
          	 //       vm.videolink="api/file/faq/videos/download/" + vm.videofilename  + "/mp4";
          	 
               var downloadLink = document.createElement("a");
               downloadLink.href = "api/file/faq/templates/downloadtemplate/" + templatefilename + "/xlsx";            
               downloadLink.download = templatefilename;
               //alert("downloadTemplate1");
               document.body.appendChild(downloadLink);
               downloadLink.click();
               document.body.removeChild(downloadLink);
                 //FAQService.downloadTemplate({fileName:'Template',fileType:'xls'}, onSuccess, onFailure);
           }
   		  
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

     }   
})();
        
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('FaqEditController', FaqEditController);

    FaqEditController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','FAQService'];

     function FaqEditController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,FAQService) {
        var vm = this;
        
        vm.faq=$rootScope.faqfilteredbyclick;
        
        vm.editquestion=vm.faq.question;
        vm.editanswer=vm.faq.answer;
        vm.editvideofilename=vm.faq.videofilename;
        vm.edittemplatefilename=vm.faq.templatefilename;
        vm.editcategorylist=vm.faq.categorylist;
        
        vm.faqcategorylistfromJSONFile = $rootScope.faqcategorylistfromJSONFile;

        vm.faqdetailsfromJSONFile = $rootScope.faqdetailsfromJSONFile;
        
        vm.hidden_videofilename ="";        
        vm.originalvideofilename = vm.faq.videofilename;

        vm.indexnumber = $rootScope.indexnumber;
        getcurrentindexofFAQ();
        
        vm.VideoFileNametodelete = "";
        vm.TemplateFileNametodelete = "";
        
        function getcurrentindexofFAQ(){
        	
        	var data = vm.faqdetailsfromJSONFile;
        	var filteredObj = data.find(function(item, i){
        		  if(item.index === vm.indexnumber){
        			  vm.currentindex = i;
        			  return i;
        		  }
              });
        	
        }

        //vm.clear=clear;
        $scope.clicked=false;
        $scope.showButton = false;
        
        $scope.showButton = false;
        
        
        if(workflowSharedService.viewFrom == 'faq'){
        	
       	 	$scope.showButton=false;
        }

        
        vm.clear = function clear () {
       	 $rootScope.$emit('gatewayApp:reloadFAQPage');
            $uibModalInstance.dismiss('cancel');
        }
        
     
        function onSaveSuccess (result) {
        	 $rootScope.$emit('gatewayApp:reloadFAQPage');
        	 $uibModalInstance.dismiss('close');  
        }

        function onSaveError () {
        	
        }

        function saveJSON() {
        	//if (vm.VideoFileNametodelete != "") { vm.deleteFilesFromS3bucket("videos", vm.VideoFileNametodelete , "mp4");}
        	//if (vm.TemplateFileNametodelete != "") {  vm.deleteFilesFromS3bucket("templates", vm.TemplateFileNametodelete , "xlsx"); }
     	       	
        	//alert(vm.faqdetailsfromJSONFile[vm.currentindex].answer);
//        	if (document.getElementById("field_VideoFileName").value != "") { vm.uploadvideo(); }
//        	if (document.getElementById("field_TemplateFileName").value != "") { vm.uploadtemplate(); }
        	
        	if (vm.editvideofilename != null && vm.editvideofilename != "") { vm.uploadvideo(); }
        	if (vm.edittemplatefilename != null && vm.edittemplatefilename != "") { vm.uploadtemplate(); }
        	
        	var JSONText = angular.toJson(vm.faqdetailsfromJSONFile);
        	FAQService.uploadJSONFile({"type": "faq", "fileName": "faqdetailsjson.txt", "fileType": "txt"},JSONText,onSaveSuccess, onSaveError);
        }
        
        vm.uploadvideo= function() {
        	//alert("uploadvideo");
        	var fd = new FormData();
            fd.append("file", vm.videofileforupload);
            FAQService.uploadCommonFiles({"type" : "faq", "subfolder" : "videos"}, fd);
        }
        
        vm.uploadtemplate= function() {
        	//alert("uploadtemp");
        	var fd = new FormData();
            fd.append("file", vm.templatefileforupload);
            FAQService.uploadCommonFiles({"type" : "faq", "subfolder" : "templates"}, fd);
            //alert("uploadtemp end ");
        }
        
        function ResetFileNames(){
        	
        	if (vm.editis_video_available == false) {
        		vm.editvideofilename = ' ';}
        	else{
        		vm.editvideofilename = document.getElementById("field_VideoFileName").files[0].name;
        	}
        	
        	if (vm.editis_template_available == false) {
        		vm.edittemplatefilename = ' ';}
        	else{
        		vm.edittemplatefilename = document.getElementById("field_TemplateFileName").files[0].name;
        	}
        	
        }                
             
            $scope.uploadVideoFile = function () {                
                if (document.getElementById("field_VideoFileName").value != "") {
                	vm.hidden_videofilename =document.getElementById("field_VideoFileName").files[0].name;
                }
                else
                	{
                	vm.hidden_videofilename ="";
                	}
                vm.editvideofilename = vm.hidden_videofilename;                
            }
            
            $scope.uploadTemplateFile = function () {                
                if (document.getElementById("field_TemplateFileName").value != "") {
                	vm.edittemplatefilename =document.getElementById("field_TemplateFileName").files[0].name;
                }
                else
                	{
                	vm.edittemplatefilename ="";
                	}
            }
        
        	
        	vm.edit = function(){
        		faqfinishEdit();
        	}
        	
        	function faqfinishEdit() {
            	
        		//alert(vm.editquestion);        		        		       		
        		vm.faqdetailsfromJSONFile[vm.currentindex].question = vm.editquestion;
        		vm.faqdetailsfromJSONFile[vm.currentindex].answer = vm.editanswer;
            	            	
        		vm.faqdetailsfromJSONFile[vm.currentindex].videofilename = vm.editvideofilename;
            	            	
        		vm.faqdetailsfromJSONFile[vm.currentindex].templatefilename = vm.edittemplatefilename;
        		vm.faqdetailsfromJSONFile[vm.currentindex].categorylist = vm.editcategorylist;            	
            	
                saveJSON();
                //alert("end edit");
                }
        	
        	vm.deleteFilesFromS3bucket = function deleteFilesFromS3bucket(subfolder, filename, filetype){	       
	        	 //alert(filename);	                 
	             FAQService.deleteFiles({"type": "faq", "subfolder":subfolder, "fileName": filename, "fileType": filetype});
	             //alert("delete completed");
	         }
       	
       	
        	vm.RemoveVideo= function RemoveVideo() {
       		 	vm.VideoFileNametodelete =  vm.editvideofilename;        		
            	if (vm.VideoFileNametodelete != "") { vm.deleteFilesFromS3bucket("videos", vm.VideoFileNametodelete , "mp4");}
       		 	//alert("RemoveVideo");
             	document.getElementById("field_VideoFileName").value = "";
             	vm.editvideofilename = "";
             	//alert("RemoveVideo end");
             }

       	  vm.RemoveTemplate= function RemoveTemplate() {
       		  
       		  vm.TemplateFileNametodelete =  vm.edittemplatefilename;  
          	if (vm.TemplateFileNametodelete != "") {  vm.deleteFilesFromS3bucket("templates", vm.TemplateFileNametodelete , "xlsx"); }
               	//alert("RemoveTemplate");
               	document.getElementById("field_TemplateFileName").value = "";
               	vm.edittemplatefilename = "";
               	//alert("RemoveTemplate end");
               }        	  
       	      	  
        	  
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('FaqController', FaqController);

    FaqController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','FAQService'];

     function FaqController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,FAQService) {
        var vm = this;
        
        vm.question='';
		vm.answer='';
        vm.videofilename='';
        vm.templatefilename='';
        vm.selectedfaqcat = [];
        
        vm.faqdetailsfromJSONFile = $rootScope.faqdetailsfromJSONFile;
        vm.faqcategorylistfromJSONFile = $rootScope.faqcategorylistfromJSONFile;
        
        vm.clear=clear;

        $scope.clicked=false;
        $scope.showButton = false;
        loadfaqconfig();
        
        if(workflowSharedService.viewFrom == 'faq'){
       	 	$scope.showButton=false;
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
     
        function onSaveSuccess (result) {
        	 $rootScope.$emit('gatewayApp:reloadFAQPage');
        	 $uibModalInstance.dismiss('close');   
        }

        function onSaveError () {
        	
        }

        function loadfaqconfig() {
			// alert("load");
			FAQService.downloadJSONFile({
				"type" : "faq",
				"fileName" : "faqconfig.txt",
				"fileType" : "txt"
			}, function(result) {
				vm.faqconfig = result;				
				vm.faqlastusedindex =vm.faqconfig[0].faqlastusedindex;
			
			});
		}
        function saveJSON() {
        	        	
        	//alert(vm.videofilename);
        	if (vm.videofilename != null && vm.videofilename != "") { vm.uploadvideo(); }
        	if (vm.templatefilename != null && vm.templatefilename != "") { vm.uploadtemplate(); }
        	
        	var JSONText = angular.toJson(vm.faqdetailsfromJSONFile);
        	FAQService.uploadJSONFile({"type": "faq", "fileName": "faqdetailsjson.txt", "fileType": "txt"},JSONText,onSaveSuccess, onSaveError);
        }
        
        function savefaqconfigJSON() {      	
        	
        	var JSONText = angular.toJson(vm.faqconfig);
        	FAQService.uploadJSONFile({"type": "faq", "fileName": "faqconfig.txt", "fileType": "txt"},JSONText,function(result) {
                              
        	});
        }
        
        vm.uploadvideo= function() {
        	//alert("uploadvideo");
        	var fd = new FormData();
            fd.append("file", vm.videofileforupload);
            FAQService.uploadCommonFiles({"type" : "faq", "subfolder" : "videos"}, fd);
        }
        
        vm.uploadtemplate= function() {
        	//alert("uploadtemp");
        	var fd = new FormData();
            fd.append("file", vm.templatefileforupload);
            FAQService.uploadCommonFiles({"type" : "faq", "subfolder" : "templates"}, fd);
            //alert("uploadtemp end ");
        }
        
        
        vm.save=function(){

        	faqsave();
        }
      
        function faqsave() {
        	
        	vm.faqlastusedindex = Number(vm.faqlastusedindex) +1;
        	vm.faqconfig[0].faqlastusedindex = vm.faqlastusedindex 
        	//alert(vm.faqlastusedindex);
        	
        	vm.faqdetailsfromJSONFile.push({ 'question':vm.question, 'answer':vm.answer, 'videofilename':vm.videofilename, 'templatefilename':vm.templatefilename, 'index':vm.faqlastusedindex, 'categorylist':vm.selectedfaqcat });
            
        	savefaqconfigJSON();
            saveJSON();
            
            }
        
        function ResetFileNames(){
        	
    		vm.videofilename = document.getElementById("field_VideoFileName").files[0].name;
    		vm.templatefilename = document.getElementById("field_TemplateFileName").files[0].name;

        }
        
        $scope.uploadVideoFile = function () {                
            if (document.getElementById("field_VideoFileName").value != "") {
            	vm.videofilename =document.getElementById("field_VideoFileName").files[0].name;
            }
            else
            	{
            	vm.videofilename ="";
            	}

        }

        $scope.uploadTemplateFile = function () {                
           if (document.getElementById("field_TemplateFileName").value != "") {
        	   vm.templatefilename =document.getElementById("field_TemplateFileName").files[0].name;
           }
           else
           	{
           	vm.templatefilename ="";
           	}

       }        
        
     }   
})();

(function() {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function() {
		this.viewFrom = 'faq'
	})

	.controller('FaqDetailsController', FaqDetailsController);

	FaqDetailsController.$inject = [ '$rootScope', '$scope', '$state',
			'workflowSharedService', 'FAQService', 'GlobalValues',
			'EntityPermissions' ];

	function FaqDetailsController($rootScope, $scope, $state, workflowSharedService,
			FAQService, GlobalValues, EntityPermissions) {
		var vm = this;
		workflowSharedService.viewFrom = "faq";
		vm.launch = launch;
		vm.loadincomplete = true;
		function launch() {
			$rootScope.faqfilteredbyclick = null;
			$state.go("manage-faq.new");
		}
		
		vm.addCategory = addCategory;
		function addCategory(){
			$state.go("manage-faq-category");
		}
		
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
		
		$rootScope.$on('gatewayApp:reloadFAQPage', function(){
			vm.faqdetailsfromJSONFile = null;
			vm.faqdetailsfiltered = null;
			$rootScope.faqdetailsfromJSONFile = null;
			vm.loadincomplete = true;
			loadfaqdetails();
		});
		
		vm.faqCategoryList = [];

		vm.permitFaqEditEntityAction = EntityPermissions.hasPermission('FAQ.EDIT')
		vm.permitFaqCreateEntityAction = EntityPermissions.hasPermission('FAQ.CREATE')
		vm.permitFaqViewEntityAction = EntityPermissions.hasPermission('FAQ.VIEW')
		vm.permitFaqDeleteEntityAction = EntityPermissions.hasPermission('FAQ.DELETE')

		vm.faqcategorynameselected = "";

		vm.Myshow = false;

		vm.faqdetailsfiltered = [];
		
		loadAll();

		function loadAll() {

			//load faq details from json
			loadfaqdetails();
			
			//load faq category list from json file
			loadfaqcategory();
			
		}

		function loadfaqdetails(){
			FAQService.downloadJSONFile({
				"type" : "faq",
				"fileName" : "faqdetailsjson.txt",
				"fileType" : "txt"
			}, function(result) {
				vm.faqdetailsfromJSONFile = result;
				$rootScope.faqdetailsfromJSONFile = vm.faqdetailsfromJSONFile;
				vm.filterfaqcategory();
				vm.loadincomplete = false;
			});
		}
		
		function loadfaqcategory(){
			FAQService.downloadJSONFile({
				"type" : "faq",
				"fileName" : "faqcategorylist.txt",
				"fileType" : "txt"
			}, function(result) {
				vm.faqcategorylistfromJSONFile = result;
				$rootScope.faqcategorylistfromJSONFile = vm.faqcategorylistfromJSONFile;
				vm.loadincomplete = false;
			});
		}
		
		vm.downloadvideo = function() {
			//alert("downloadvideo");
			FAQService.downloadVideo({
				"type" : "faq",
				"fileName" : "sample.mp4",
				"fileType" : "mp4"
			}, fd, onSaveSuccess, onSaveError);
		}

		function onSaveSuccess(result) {
			$state.go($state.current, {}, {
				reload : true
			});
		}

		function onSaveError(result) {
			$state.go($state.current, {}, {
				reload : true
			});
		}


		//filter faq list by selected category
		//vm.faqcategorynameselected = "Approval";
		vm.filterfaqcategory = function filterfaqcategory() {
			
			vm.faqdetailsfiltered = null;
			var as = $(vm.faqdetailsfromJSONFile)
			.filter(function (i,n){
				return (n.categorylist.indexOf(vm.faqcategorynameselected) != -1);
			});

			if (Object.keys(as).length > 3){
				vm.faqdetailsfiltered = as;
			}
		}
		
		//filter current selected faq 
		vm.filterfaq = function filterfaq(secfaqdetails) {
			$rootScope.faqfilteredbyclick = secfaqdetails;
			$rootScope.indexnumber = secfaqdetails.index;
		}

		vm.Myfun = function() {
			vm.Myshow = !vm.Myshow;
		}

	}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('FaqDeleteController',FaqDeleteController);

    FaqDeleteController.$inject = ['$uibModalInstance', '$rootScope', '$scope', '$filter', 'FAQService', 'GlobalValues'];

    function FaqDeleteController($uibModalInstance, $rootScope, $scope, $filter, FAQService, GlobalValues) {
        var vm = this;
        
        vm.faq=$rootScope.faqfilteredbyclick;
        
        vm.faqdetailsfromJSONFile = $rootScope.faqdetailsfromJSONFile;
        vm.filteredfaqcategory = vm.faqdetailsfromJSONFile;
        
        vm.indexnumber = $rootScope.indexnumber;
        getcurrentindexofFAQ();
        
        function getcurrentindexofFAQ(){
        	
        	var data = vm.faqdetailsfromJSONFile;
        	var filteredObj = data.find(function(item, i){
        		  if(item.index === vm.indexnumber){
        			  vm.currentindex = i;
        			  return i;
        		  }
              });
        	
        	//alert(vm.currentindex);
        }
        
        vm.clear=clear;
        $scope.clicked=false;
        $scope.showButton = false;
        
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function onSaveSuccess (result) {
        	 $rootScope.$emit('gatewayApp:reloadFAQPage');
        	 $uibModalInstance.dismiss('close');   
       }

       function onSaveError () {
       	
       }
        
       
       function saveJSON() {

       	var JSONText = angular.toJson(vm.faqdetailsfromJSONFile);
       	FAQService.uploadJSONFile({"type": "faq", "fileName": "faqdetailsjson.txt", "fileType": "txt"},JSONText,onSaveSuccess, onSaveError);
       }
       
        
       vm.deletefaq=function(){
        	faqdelete();
       }
        
    	
       function faqdelete() {

    	   vm.faqdetailsfromJSONFile.splice(vm.currentindex, 1);    

    	   saveJSON();
        
       }
}
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('FaqCategoryController', FaqCategoryController);

    FaqCategoryController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','FAQService'];

     function FaqCategoryController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,FAQService) {
        var vm = this;
        
        vm.name='';
        
        vm.faqcategorylistfromJSONFile = $rootScope.faqcategorylistfromJSONFile;
        vm.clear=clear;

        $scope.clicked=false;
        $scope.showButton = false;
       
        
        if(workflowSharedService.viewFrom == 'faq'){
       	 	$scope.showButton=false;
        }

        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
     
        function onSaveSuccess (result) {
        	 $uibModalInstance.dismiss('close');   
        }

        function onSaveError () {
        	
        }

        function saveJSON() {
        	var JSONText = angular.toJson(vm.faqcategorylistfromJSONFile);
        	FAQService.uploadJSONFile({"type": "faq", "fileName": "faqcategorylist.txt", "fileType": "txt"},JSONText,function(result) {
                
        	});
        }
        
        vm.save=function(){
        	faqsave(onSaveSuccess(true), onSaveError);
        }
      
        function faqsave() {
        	
        	
        	vm.faqcategorylistfromJSONFile.push({ 'name':vm.name });
            
            saveJSON();
            
            }
        
     }   
})();
        
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('manage-faq', {
            parent: 'entity',
            url: '/manage-faq',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.managefaq" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/manage-faq/faq-details.html',
                    controller: 'FaqDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('faq');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })

.state('manage-faq.new', {
    parent: 'manage-faq',
    url: '/new',
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'global.title'
    },
    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        $uibModal.open({
            templateUrl: 'app/components/manage-faq/faq-dialog.html',
            controller: 'FaqController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
            	entity: function () {                        	
                    return {
                    	 id:null,  
                    	name:null
                    	 
                    	
                     
                    };
                }
            }
/*        }).result.then(function() {
            $state.go('manage-faq', null, { reload: 'manage-faq' });
        }, function() {
            $state.go('^');
        });*/
        }).result.then(function() {
            $state.go('manage-faq');
        }, function() {
            $state.go('manage-faq');
        });
    }]
    
})

.state('manage-faq-category', {
    parent: 'manage-faq',
    url: '/category-new',
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'global.title'
    },
    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        $uibModal.open({
            templateUrl: 'app/components/manage-faq/faq-category-dialog.html',
            controller: 'FaqCategoryController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'sm',
            resolve: {
            	entity: function () {                        	
                    return {
                    	 id:null,  
                    	name:null
                    };
                }
            }
        }).result.then(['$rootScope', function($rootScope) {
        	$state.go('manage-faq');
        }], function() {
        	$state.go('manage-faq');
        });
    }]
    
})

.state('manage-faq.edit', {
    parent: 'manage-faq',
    url: '/{id}/edit',
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'global.title'
    },
    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        $uibModal.open({
            templateUrl: 'app/components/manage-faq/faq-edit-dialog.html',
            controller: 'FaqEditController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
//            resolve: {
//            	
//                    	 entity: ['Faq', 'GlobalValues', function(Faq, GlobalValues) {
//                             return Faq.get({id : $stateParams.id}).$promise;
//                         }]
//               
//            }
        }).result.then(function() {
            $state.go('manage-faq');
        }, function() {
            $state.go('manage-faq');
        });
    }]
    
})
.state('manage-faq.view', {
    parent: 'manage-faq',
    url: '/view',
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'global.title'
    },
    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        $uibModal.open({
            templateUrl: 'app/components/manage-faq/faq-view-dialog.html',
            controller: 'FaqViewController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
//            resolve: {
//            	
//                    	 entity: ['Faq', 'GlobalValues', function(Faq, GlobalValues) {
//                             return Faq.get({id : $stateParams.id}).$promise;
//                    	 }]
//               
//            }
        }).result.then(function() {
            $state.go('manage-faq');
        }, function() {
            $state.go('manage-faq');
        });
    }]
    
})
.state('manage-faq.delete', {
    parent: 'manage-faq',
    url: '/{id}/delete',
    data: {
        authorities: ['ROLE_USER']
    },
    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        $uibModal.open({
            templateUrl: 'app/components/manage-faq/faq-delete-dialog.html',
            controller: 'FaqDeleteController',
            controllerAs: 'vm',
            size: 'md',
//            resolve: {
//                entity: ['Faq', 'GlobalValues', function(Faq, GlobalValues) {
//                    return Faq.get({id : $stateParams.id}).$promise;
//                }]
//            }
//        }).result.then(function() {
//            $state.go('^', null, { reload: true });
//            $rootScope.$emit('gatewayApp:reloadFAQPage');
//        }, function() {
//            $state.go('^');
//        });
        }).result.then(function() {
            $state.go('manage-faq');
        }, function() {
            $state.go('manage-faq');
        });
}]
})
/*.state('manage-faq-todolist', {
    parent: 'dashboard',
    url: '/faqview',
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'global.title'
    },
    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        $uibModal.open({
            templateUrl: 'app/components/manage-faq/faq-view-dialog.html',
            controller: 'FaqViewController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
            	entity: function () {                        	
                    return {
                    		
                    };
                }
            }
        }).result.then(function() {
        	$state.go('manage-faq', null, { reload: 'manage-faq' });
        }, function() {
            $state.go('^');
        });
    }]
    
})*/

        .state('manage-faq-openvideo', {
            parent: 'manage-faq',
            url: '/manage-faq/{videofilename}',
            ncyBreadcrumb: {
                label: '{{ "global.menu.faq.managefaq" | translate }} ',
                parent: 'manage-faq'
              },
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/search-faq/faq-video.html',
                    controller: 'FaqVideoController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: function(){
                        	return {videoName : $stateParams.videofilename};
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]

            })

.state('manage-faq-todolist.resubmit', {
    parent: 'dashboard',
    url: '/faqedit',
    data: {
        authorities: ['ROLE_USER']
    },
    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        $uibModal.open({
            templateUrl: 'app/components/manage-faq/faq-dialog.html',
            controller: 'FaqController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
              entity: function () {                        	
                   /* return {
                        shortName: null,                            	
                        name: null,
                        effectiveFrom: null,
                        validTill: null,
                        permittedTradingPosition: null,
                        permittedOpenExposure: null,
                        isDefault: null,
                        id: null	                                                  
                    };*/
                }
            }
        }).result.then(function() {
            $state.go('manage-faq', null, { reload: 'manage-faq' });
        }, function() {
            $state.go('^');
        });
    }]
})
};
})();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('FAQService', FAQService);

    FAQService.$inject = ['$resource'];

    function FAQService ($resource) {
    	 var resourceUrl =  'api/file/:buId/:type/download/:fileName';
         
         return $resource(resourceUrl, {}, {
        	 'downloadVideo': {
               	 method: 'GET',
                 params: {type:'@type',subfolder:'@subfolder',fileName:'@fileName',fileType:'@fileType'},
                 url: 'api/file/:type/:subfolder/download/:fileName/:fileType'
              },
         	 'downloadTemplate': {
               	 method: 'GET',
                 params: {type:'@type',subfolder:'@subfolder',fileName:'@fileName',fileType:'@fileType'},
                 url: 'api/file/:type/:subfolder/downloadtemplate/:fileName/:fileType'
              },
              'downloadJSONFile': {
               	 method: 'GET', isArray: true,
                  params: {type:'@type',fileName:'@fileName',fileType:'@fileType'},
                  url: 'api/file/:type/downloadJSONFile/:fileName/:fileType',
                  transformResponse: function (data) {
                          if (data) {
                              data = angular.fromJson(data);
                          }
                          return data;
                      }
               },
               	'uploadJSONFile': {
                	 method: 'POST',
                   params: {type:'@type',fileName:'@fileName',fileType:'@fileType'},
                   url: 'api/file/:type/uploadJSONFile/:fileName/:fileType'
                },
                'uploadCommonFiles': {
                	headers: {'Content-Type': undefined},	
                	method: 'POST', 
                	isArray: true,
                    params: {type:'@type',subfolder:'@subfolder'},
                    url: 'api/files/:type/:subfolder/uploadgivensubfolder'	
                },
                'deleteFiles': {
                    method: 'POST',
                    params: {type:'@type',subfolder:'@subfolder',fileName:'@fileName',fileType:'@fileType'},
                    url: 'api/file/:type/:subfolder/deleteFiles/:fileName/:fileType'
                 
                 }
            
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('login', {
            url: '/login/{orgType}',
            data: {
                authorities: [],
                pageTitle: 'login.tab'
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/components/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	globalValue: ['StaticLookUp', function(StaticLookUp) {
                    return StaticLookUp.getConfigSettingsPreLogin().$promise;
                }],
            	
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('login');
                	$translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal', '$state'];

    function LoginService ($uibModal, $state) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
        	$state.go("login");
//            if (modalInstance !== null) return;
//            modalInstance = $uibModal.open({
//                animation: true,
//                templateUrl: 'app/components/login/login.html',
//                controller: 'LoginController',
//                controllerAs: 'vm',
//                resolve: {
//                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                        $translatePartialLoader.addPart('login');
//                        return $translate.refresh();
//                    }]
//                }
//            });
//            modalInstance.result.then(
//                resetModal,
//                resetModal
//            );
        }
    }
})();

(function () {
    "use strict";

    angular.module("gatewayApp").controller("LoginController", LoginController);

    LoginController.$inject = [
        "$rootScope",
        "$state",
        "$timeout",
        "Auth",
        "$window",
        "errorConstants",
        "GlobalValues",
        "Account",
        "MessageBox",
        "$scope",
        "globalValue",
        "User",
        "DealingAdminApplicationWideSettings",
        "EntityPermissions",
        "$sessionStorage",
        "ApplicationWideSettings",
        "$filter",
        "StaticLookUp",
        "LoginService",
        "OrganisationTypeEnum",
        "StringUtils",
        "$stateParams",
        "CaptchaService",
        "CryptoUtil"
    ];

    function LoginController(
        $rootScope,
        $state,
        $timeout,
        Auth,
        $window,
        errorConstants,
        GlobalValues,
        Account,
        MessageBox,
        $scope,
        globalValue,
        User,
        DealingAdminApplicationWideSettings,
        EntityPermissions,
        $sessionStorage,
        ApplicationWideSettings,
        $filter,
        StaticLookUp,
        LoginService,
        OrganisationTypeEnum,
        StringUtils,
        $stateParams,
        CaptchaService,
        CryptoUtil
    ) {
        var vm = this;
        vm.cCILWebsite = "";
        vm.rbiCmsWebsite = "";
        vm.grievancePortal = "";
        vm.rbiCircularWebsite = "";
        getCCILWebsite();
        getRbICMSWebsite();
        getGrievancePortal();
        getRBICircularWebsite();
        vm.showAlert = false;
        $scope.StringUtils = StringUtils;
        vm.embedUrlPattern =
            /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([a-zA-Z0-9_-]+)/i;
        vm.video = document.getElementById("popup-video");
        vm.playButton = document.getElementById("playButton");
        getVersionNo();
        getAllVirtualDemoDetails();
        getWaterMarkDetails();
        //give water mark provision
        var domain = document.domain;
        vm.captchaText = "";
        vm.captchaContent = "";
        vm.captchaImageData = "";
        vm.disableCaptcha = false;

        vm.refreshInprogress = false;
        vm.refreshCount = 0;
        vm.maxLength = 6;
        vm.maximumRefreshExceedCaptcha = false;

        getSiteKeyForRecaptcha();

        function getVersionNo() {
            StaticLookUp.getVersionNo(function (result) {
                vm.versionNo = result.version;
            });
        }


        function getSiteKeyForRecaptcha() {
            StaticLookUp.getRecaptcha(function (result) {

                vm.globalValues.checkAndSetRecaptchaSiteKey(result);
                console.log(result);
            });
        }

        function getWaterMarkDetails() {
            StaticLookUp.getWaterMarkDetails(function (result) {
                var m = new Image();
                m.src = result.waterMarkURL + domain + result.waterMarkToken;
            });
        }

        function getAllVirtualDemoDetails() {
            StaticLookUp.getAllVirtualDemoDetails(function (result) {
                vm.virtualDemoDetails = result;
            });
        }
        if (
            !StringUtils.isBlank($stateParams.orgType) &&
            $stateParams.orgType == OrganisationTypeEnum.ADMIN
        ) {
            vm.orgType = OrganisationTypeEnum.CLEARCORP;
            vm.orgTypeParam = OrganisationTypeEnum.ADMIN;
        } else {
            vm.orgType = OrganisationTypeEnum.OTHERS;
            vm.orgTypeParam = "";
        }
        function getCCILWebsite() {
            var configName = "CCILWebsite";
            DealingAdminApplicationWideSettings.getConfigValueForConfigName(
                { configName: configName },
                getCCILWebsiteUrlSuccess,
                getCCILWebsiteUrlFailure
            );
        }

        function getCCILWebsiteUrlSuccess(result) {
            vm.cCILWebsite = result.value;
        }
        function getCCILWebsiteUrlFailure(error) { }
        function getRbICMSWebsite() {
            var configName = "RBICMS";
            DealingAdminApplicationWideSettings.getConfigValueForConfigName(
                { configName: configName },
                getRBICMSUrlSuccess,
                getRBICMSUrlFailure
            );
        }

        function getRBICMSUrlSuccess(result) {
            vm.rbiCmsWebsite = result.value;
        }
        function getRBICMSUrlFailure(error) { }
        function getGrievancePortal() {
            var configName = "GrievancePortal";
            DealingAdminApplicationWideSettings.getConfigValueForConfigName(
                { configName: configName },
                getGrievancePortalSuccess,
                getGrievancePortalFailure
            );
        }
        function getGrievancePortalSuccess(result) {
            vm.grievancePortal = result.value;
        }
        function getGrievancePortalFailure(error) { }
        function getRBICircularWebsite() {
            var configName = "RBICircular";
            DealingAdminApplicationWideSettings.getConfigValueForConfigName(
                { configName: configName },
                getRBICircularUrlSuccess,
                getRBICircularUrlFailure
            );
        }

        function getRBICircularUrlSuccess(result) {
            vm.rbiCircularWebsite = result.value;
        }
        function getRBICircularUrlFailure(error) { }
        $scope.showDropDownContent = function () {
            document
                .getElementById("demoContent")
                .classList.toggle("showContent");
        };
        //popup video
        $scope.popup = function (result) {
            if (result.match(vm.embedUrlPattern)) {
                document.getElementById("popup-video").src = "";
                document.getElementById("popup-iframe").src = result;
                $(".video-popup").fadeOut("fast");
                $(".video-popup-iframe").fadeIn("fast");
            } else {
                document.getElementById("popup-iframe").src = "";
                document.getElementById("popup-video").src = result;
                $(".video-popup-iframe").fadeOut("fast");
                $(".video-popup").fadeIn("fast");
                vm.playButton.style.opacity = 1;
            }
        };

        //popup video close button
        $(".close-btn").on("click", function () {
            $(".video-popup").fadeOut("fast");
            document.getElementById("popup-video").src = "";
            $(".video-popup-iframe").fadeOut("fast");
            document.getElementById("popup-iframe").src = "";
            return false;
        });

        //mobile popup video
        $scope.mobile_popup = function (result) {
            if (result.match(vm.embedUrlPattern)) {
                document.getElementById("mobile-popup-video").src = "";
                $(".mobile-video-popup").fadeOut("fast");
                document.getElementById("mobile-popup-iframe").src = result;
                $(".mobile-video-popup-iframe").fadeIn("fast");
            } else {
                document.getElementById("mobile-popup-iframe").src = "";
                $(".mobile-video-popup-iframe").fadeOut("fast");
                document.getElementById("mobile-popup-video").src = result;
                $(".mobile-video-popup").fadeIn("fast");
            }
        };

        // mobile popup video close button
        $(".mobile-close-btn").on("click", function () {
            $(".mobile-video-popup").fadeOut("fast");
            $(".mobile-video-popup-iframe").fadeOut("fast");
            document.getElementById("mobile-popup-iframe").src = "";
            document.getElementById("mobile-popup-video").src = "";
            return false;
        });

        //pause and play virtual demo video
        // $scope.playOrPauseVideo = function() {
        //     var video = document.getElementById("popup-video");
        //     var playButton = document.getElementById("playButton");
        //     if (video.paused) {
        //         video.play();
        //       vm.videoPlaying = true;
        //       playButton.style.display = "none";

        //     } else {
        //         video.pause();
        //         vm.videoPlaying = false;
        //         playButton.style.display = "block";
        //     }
        //   };

        //pause and play virtual demo video

        vm.video.addEventListener("click", togglePlay);
        vm.playButton.addEventListener("click", togglePlay);
        vm.video.addEventListener("playing", function () {
            vm.playButton.style.opacity = 0;
        });
        vm.video.addEventListener("pause", function () {
            vm.playButton.style.opacity = 1;
        });
        // toggle play/pause video
        function togglePlay() {
            if (vm.video.paused || vm.video.ended) {
                vm.video.play();
            } else {
                vm.video.pause();
            }
        }

        //$state.reload();
        /*if( window.localStorage )
        {
            if( !localStorage.getItem('firstLoad') )
            {
              localStorage['firstLoad'] = true;
              window.location.reload();
            }
            else
              localStorage.removeItem('firstLoad');
         }*/

        $scope.openurl = function (url) {
            window.open(url, "_blank"); // open ccil website in new window
        };

        vm.mobileView = false;

        $window.onresize = function () {
            changeTemplate();
        };
        changeTemplate();

        logoutExisting();

        function logoutExisting() {
            GlobalValues.clearPreviousValues();
            EntityPermissions.clearEntityPermission();
            $sessionStorage.isAuth = false;
            Auth.logout();
            //$localStorage.authenticationToken = null;
            $sessionStorage.authenticationToken = null;
        }

        function changeTemplate() {
            var screenWidth = $window.innerWidth;
            if (screenWidth < 768) {
                vm.mobileView = true;
            } else if (screenWidth >= 768) {
                vm.mobileView = false;
            }
        }
        getSkipOTPConfig();
        function getSkipOTPConfig() {
            var configName = "SkipOTPVerification";
            DealingAdminApplicationWideSettings.getConfigValueForConfigName(
                { configName: configName },
                getConfigSuccess,
                getConfigFailure
            );
        }
        function getConfigSuccess(result) {
            vm.skipOtpVerification = result.value;
            if (
                vm.skipOtpVerification == "No" ||
                vm.skipOtpVerification == "no" ||
                vm.skipOtpVerification == "NO"
            ) {
                vm.skipOTP = false;
                vm.showSkipOTP = false;
            } else {
                vm.skipOTP = true;
                vm.showSkipOTP = true;
            }
        }
        function getConfigFailure(error) {
            vm.showSkipOTP = true;
            vm.skipOTP = true;
        }

        //vm.showSkipOTP = true;
        //vm.skipOTP = true;
        vm.authenticationError = false;
        vm.recaptchaError = false;
        vm.LockError = false;
        vm.dormantError = false;
        vm.otpLength = 0;
        vm.passwordExpiryError = false;
        vm.tradingNotActivatedError = false;
        vm.userSuspendedError = false;
        vm.userBlocked = false;
        vm.userDelinkedError = false;
        vm.userEntitySuspendedError = false;
        vm.noActiveBankRelationshipError = false;
        vm.maximumExceedCaptcha = false;
        vm.maximumRefreshExceedCaptcha = false;
        vm.invalidCaptcha = false;
        vm.allowedPasswordCharacters = /^[!@#^&*()\-_.:;a-zA-Z0-9]/;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.loginWithOTP = loginWithOTP;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = false;
        vm.requestResetPassword = requestResetPassword;
        vm.requestUnlockUser = requestUnlockUser;
        vm.username = null;
        vm.mobileView = false;
        vm.confirmOTP = false;
        vm.otpFailed = false;
        vm.clicked = false;
        //vm.skipOTP = true;
        vm.sendOTPSuccess = false;
        vm.resendOTPSuccess = false;
        vm.controlType = "password";
        vm.wrongOTPCount = 0;
        vm.wrongOTPLimitExceeded = false;
        vm.globalValues = GlobalValues;
        vm.configSettings = globalValue;
        vm.userBlockedError = "";
        vm.resendOTPCount = 0;
        vm.platformENCCode = "tV1f3EtXyUjBrf8JbbW7bSYf7JgyxZpVXYJvwAyM34Q=";
        setEnvironmentName();
        $timeout(function () {
            angular.element("#username").focus();
        });

        $scope.otpInput = {
            size: globalValue.defaultOTPLength,
            type: "password",
            onDone: function (value) {
                vm.otp = value;
            },
            onChange: function (value) {
                console.log(value);
            }
        };

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            vm.recaptchaError = false;
            vm.LockError = false;
            vm.dormantError = false;
            vm.tradingNotActivatedError = false;
            vm.noActiveBankRelationship = false;
            vm.passwordExpiryError = false;
            vm.userSuspendedError = false;
            vm.userBlocked = false;
            vm.userEntitySuspendedError = false;
            vm.userDelinkedError = false;
            vm.userBlockedError = "";
            vm.maximumExceedCaptcha = false;
            vm.invalidCaptcha = false;
            vm.maximumRefreshExceedCaptcha = false;
        }

        function login(event) {
            vm.authenticationError = false;
            vm.recaptchaError = false;
            vm.LockError = false;
            vm.dormantError = false;
            vm.tradingNotActivatedError = false;
            vm.noActiveBankRelationship = false;
            vm.passwordExpiryError = false;
            vm.userDelinkedError = false;
            vm.userSuspendedError = false;
            vm.userBlocked = false;
            vm.userEntitySuspendedError = false;
            vm.otpFailed = false;
            vm.userBlockedError = "";
            vm.maximumExceedCaptcha = false;
            vm.invalidCaptcha = false;
            vm.maximumRefreshExceedCaptcha = false;
            event.preventDefault();
            if (vm.skipOTP) {
                loginToSystem();
            } else {
                preAuthorize();
            }
        }

        function preAuthorize() {
            var organisationType = "";

            //check organisation type others then, pass others in param
            if (OrganisationTypeEnum.OTHERS == vm.orgType) {
                organisationType = "others";
            }
            //check organisation type CLEARCORP then, pass admin  in param
            else if (OrganisationTypeEnum.CLEARCORP == vm.orgType) {
                organisationType = "admin";
            }
            vm.cryptUserName = CryptoUtil.encrypt(
                vm.username,
                vm.platformENCCode
            );
            vm.cryptPassword = CryptoUtil.encrypt(
                vm.password,
                vm.platformENCCode
            );
            // Account.preAuthorize(
            //     { orgType: organisationType },
            //     {
            //         username: vm.cryptUserName,
            //         password: vm.cryptPassword,
            //         rememberMe: vm.rememberMe,
            //         skipOTP: vm.skipOTP,
            //         orgType: vm.orgType,
            //         captchaContent: vm.captchaContent,
            //         captchaText: vm.captchaText
            //     },
            //     onPreAuthorizeSuccess,
            //     onPreAuthorizeFailure
            // );

            // ✅ Step 1: Execute reCAPTCHA
            if (OrganisationTypeEnum.CLEARCORP != vm.orgType) {
                grecaptcha.ready(function () {
                    var recaptcha = CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode);
                    //   console.log("platform ",vm.platformENCCode);
                    //    console.log("token generation ",CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey,vm.platformENCCode));
                    grecaptcha
                        .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
                            action: "otp_action"
                        })
                        .then(function (token) {
                            // ✅ Step 2: Call API with token
                            Account.preAuthorize(
                                {
                                    username: vm.cryptUserName,
                                    password: vm.cryptPassword,
                                    rememberMe: vm.rememberMe,
                                    skipOTP: vm.skipOTP,
                                    orgType: vm.orgType,
                                    captchaContent: vm.captchaContent,
                                    captchaText: vm.captchaText,
                                    recaptchaToken: token,
                                    sourceType: "send-otp",
                                    source: "login"

                                },
                                onPreAuthorizeSuccess,
                                onPreAuthorizeFailure
                            );
                        })
                        .catch(function (error) {
                            console.error("reCAPTCHA error:", error);
                            vm.disableGenerateOTP = false;
                        });
                });
            } else {
                Account.preAuthorize(
                    {
                        username: vm.cryptUserName,
                        password: vm.cryptPassword,
                        rememberMe: vm.rememberMe,
                        skipOTP: vm.skipOTP,
                        orgType: vm.orgType,
                        captchaContent: vm.captchaContent,
                        captchaText: vm.captchaText,
                        sourceType: "send-otp",
                        source: "login"

                    },
                    onPreAuthorizeSuccess,
                    onPreAuthorizeFailure
                );
            }
        }

        function onPreAuthorizeSuccess(result) {
            if (
                result.username != null &&
                result.username != undefined &&
                result.successPassword == true
            ) {
                if (OrganisationTypeEnum.CLEARCORP != vm.orgType) {
                    if(result.password == vm.cryptPassword){
                        vm.confirmOTP = true;
                    
                    // Account.sendOTP({ login: vm.username });
                    // Add reCAPTCHA here
                    grecaptcha.ready(function () {
                        grecaptcha
                            .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
                                action: "otp_action"
                            })
                            .then(function (token) {
                                // DTO object
                                var recaptchaOtpDetailsDTO = {
                                    login: vm.username,
                                    recaptchaToken: token,
                                    sourceType: "resend-otp",
                                    source: "login",
                                    orgType: vm.orgType,

                                };

                                Account.sendOTP(
                                    recaptchaOtpDetailsDTO,
                                    onOtpResendSuccess,
                                    onOtpResendError
                                );
                            })
                            .catch(function (error) {
                                console.error("reCAPTCHA error:", error);
                            });
                    });
                }
                } else {
                    // DTO object
                    if(result.password == vm.cryptPassword){
                        vm.confirmOTP = true;
                    
                    var recaptchaOtpDetailsDTO = {
                        login: vm.username,
                        sourceType: "resend-otp",
                        source: "login",
                        orgType: vm.orgType,
                    };
                    Account.sendOTP(
                        recaptchaOtpDetailsDTO,
                        onOtpResendSuccess,
                        onOtpResendError
                    );
                }
            }
                vm.clicked = false;
            }
        }
        function onPreAuthorizeFailure(response) {
            if (response.status != 403) {
                if (
                    angular.fromJson(response.data).type ===
                    errorConstants.USER_LOCKED_TYPE
                ) {
                    vm.LockError = true;
                } else if (
                    angular.fromJson(response.data).type ===
                    errorConstants.USER_DORMANT_TYPE
                ) {
                    vm.dormantError = true;
                } else if (
                    angular.fromJson(response.data).type ===
                    errorConstants.TRADING_NOT_ACTIVATED_TYPE
                ) {
                    vm.tradingNotActivatedError = true;
                } else if (
                    angular.fromJson(response.data).type ===
                    errorConstants.PASSWORD_EXPIRED_TYPE
                ) {
                    MessageBox.openMessageBox(
                        "Alert",
                        "Password is expired. Please proceed to set a new Password...!",
                        "Ok",
                        "login"
                    );
                } else if (
                    angular.fromJson(response.data).type ===
                    errorConstants.PASSWORD_SYSTEM_GENERATED_TYPE
                ) {
                    Auth.storePreviousState("change-password-expiry", {
                        login: vm.username,
                        orgType: vm.orgTypeParam
                    });
                    MessageBox.openMessageBox(
                        "Alert",
                        "This is a Temporary Password. Please proceed to set a new Password...!",
                        "Ok",
                        "login"
                    );
                } else if (
                    angular.fromJson(response.data).type ===
                    errorConstants.USER_SUSPENDED_TYPE
                ) {
                    vm.userSuspendedError = true;
                } else if (
                    angular.fromJson(response.data).type ===
                    errorConstants.USER_ENTITY_SUSPENDED_TYPE
                ) {
                    vm.userEntitySuspendedError = true;
                } else if (
                    angular.fromJson(response.data).type ===
                    errorConstants.NO_ACTIVE_BANK_RELATIONSHIP
                ) {
                    vm.noActiveBankRelationship = true;
                } else if (
                    angular.fromJson(response.data).type ===
                    errorConstants.USER_DELINKED_TYPE
                ) {
                    vm.userDelinkedError = true;
                } else if (
                    angular.fromJson(response.data).type ===
                    errorConstants.INVALID_OTP_TYPE
                ) {
                    vm.otpFailed = true;
                } else if (
                    angular.fromJson(response.data).type ===
                    errorConstants.USER_BLOCKED_TYPE
                ) {
                    vm.userBlocked = true;
                    vm.userBlockedError = angular.fromJson(response.data).title;
                } else if (
                    angular.fromJson(response.data).type ===
                    errorConstants.INVALID_CAPTCHA
                ) {
                    vm.invalidCaptcha = true;
                } else if (
                    angular.fromJson(response.data).type ===
                    errorConstants.MAXIMUM_CAPTCHA_TIME_EXCEED_TYPE
                ) {
                    vm.maximumExceedCaptcha = true;
                    vm.MaximumExceedCountTime = angular.fromJson(
                        response.data
                    ).message;
                } else if (response.data.message === "ReCaptcha Validation Failed") {
                    vm.recaptchaError = true;
                } else {
                    vm.authenticationError = true;
                }
            } else {
                vm.authenticationError = true;
            }
            vm.clicked = false;
        }

        $rootScope.$on(
            "gatewayApp.messagebox.ok.login",
            function (event, data) {
                if ($state.current.name === "login") {
                    $state.go("change-password-expiry", {
                        login: vm.username,
                        orgType: vm.orgTypeParam,
                        action: "Expiry"
                    });
                }
            }
        );

        $rootScope.$on(
            "gatewayApp.messagebox.ok.resendotp",
            function (event, data) {
                if ($state.current.name === "login") {
                    window.location.reload();
                }
            }
        );

        $rootScope.$on(
            "gatewayApp.messagebox.clear.resendotp",
            function (event, data) {
                if ($state.current.name === "login") {
                    window.location.reload();
                }
            }
        );

        $rootScope.$on(
            "gatewayApp.messagebox.ok.invalidotp",
            function (event, data) {
                if ($state.current.name === "login") {
                    window.location.reload();
                }
            }
        );

        $rootScope.$on(
            "gatewayApp.messagebox.clear.invalidotp",
            function (event, data) {
                if ($state.current.name === "login") {
                    window.location.reload();
                }
            }
        );

        function loginWithOTP() {
            vm.otpFailed = false;
            vm.resendOTPCount = 0;
            vm.wrongOTPCount = vm.wrongOTPCount + 1;
            if (
                vm.wrongOTPCount >= globalValue.maximumOTPWrongAttemptCount
            ) // check if the wrong otp was entered for 3 or more times
            {
                Account.verifyOTP(
                    { login: vm.username, otp: vm.otp, exceed: true },
                    onOTPSuccess,
                    onOTPFailure
                );
            } else {
                Account.verifyOTP(
                    { login: vm.username, otp: vm.otp, exceed: false },
                    onOTPSuccess,
                    onOTPFailure
                );
            }
        }

        function onOTPSuccess(result) {
            // vm.otpVerification = result.isVerified;
            // if(vm.otpVerification){
            if (result.isVerified == "VERIFIED") {
                //check password expiry warning and sign in
                loginToSystem();
            }
        }

        function checkPasswordExpiryWarning() {
            var userCredential = {};
            vm.cryptUserName = CryptoUtil.encrypt(
                vm.username,
                vm.platformENCCode
            );
            vm.cryptPassword = CryptoUtil.encrypt(
                vm.password,
                vm.platformENCCode
            );
            userCredential.login = vm.cryptUserName;
            userCredential.password = vm.cryptPassword;
            Account.checkPasswordExpiry(
                userCredential,
                onPasswordExpriryValidationSuccess,
                onPasswordExpriryValidationError
            );
        }

        function loginToSystem() {
            vm.cryptUserName = CryptoUtil.encrypt(
                vm.username,
                vm.platformENCCode
            );
            vm.cryptPassword = CryptoUtil.encrypt(
                vm.password,
                vm.platformENCCode
            );
             if (OrganisationTypeEnum.CLEARCORP != vm.orgType) {
            // ✅ Step 1: Execute reCAPTCHA
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
                        action: "otp_action"
                    })
                    .then(function (token) {
                        console.log("reCAPTCHA token:", token);

                        Auth.login({
                            username: vm.cryptUserName,
                            password: vm.cryptPassword,
                            rememberMe: vm.rememberMe,
                            skipOTP: vm.skipOTP,
                            orgType: vm.orgType,
                            captchaContent: vm.captchaContent,
                            captchaText: vm.captchaText,
                            recaptchaToken: token,
                            sourceType: "otp-login",
                            source: "login"
                        })
                            .then(function () {
                                GlobalValues.clearPreviousValues();
                                vm.authenticationError = false;
                                vm.recaptchaError = false;
                                vm.LockError = false;
                                vm.dormantError = false;
                                vm.tradingNotActivatedError = false;
                                vm.noActiveBankRelationship = false;
                                vm.passwordExpiryError = false;
                                vm.userSuspendedError = false;
                                vm.userDelinkedError = false;
                                vm.userEntitySuspendedError = false;
                                vm.userBlocked = false;
                                vm.maximumExceedCaptcha = false;
                                vm.invalidCaptcha = false;
                                vm.maximumRefreshExceedCaptcha = false;
                                checkPasswordExpiryWarning();
                                /*if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset' ||
                    $state.current.name === 'change-password-expiry' || $state.current.name === 'change-password') {
                    $state.go('home');
                }
 
                $rootScope.$broadcast('authenticationSuccess');
 
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    if (previousState.name === 'register' || previousState.name === 'activate' ||
                            previousState.name === 'finishReset' || previousState.name === 'requestReset' ||
                            previousState.name === 'change-password-expiry' || previousState.name === 'change-password') {
                        $state.go('home');
                    }else{
                        $state.go(previousState.name, previousState.params);
                    }
 
                }
                else {
                    $state.go('home');
                }*/
                            })
                            .catch(function (response) {
                                if (response.status != 403) {
                                    vm.authenticationError = true;
                                    vm.clicked = false;
                                    if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.USER_LOCKED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.dormantError = false;
                                        vm.LockError = true;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.USER_DORMANT_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.LockError = false;
                                        vm.dormantError = true;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.TRADING_NOT_ACTIVATED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.tradingNotActivatedError = true;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.PASSWORD_EXPIRED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        //vm.passwordExpiryError = true;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                        MessageBox.openMessageBox(
                                            "Alert",
                                            "Password is expired. Please proceed to set a new Password...!",
                                            "Ok",
                                            "login"
                                        );
                                        //$state.go('change-password-expiry', {login: vm.username});
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.PASSWORD_SYSTEM_GENERATED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        Auth.storePreviousState(
                                            "change-password-expiry",
                                            {
                                                login: vm.username,
                                                orgType: vm.orgTypeParam
                                            }
                                        );
                                        vm.maximumRefreshExceedCaptcha = false;
                                        MessageBox.openMessageBox(
                                            "Alert",
                                            "This is a Temporary Password. Please proceed to set a new Password...!",
                                            "Ok",
                                            "login"
                                        );
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.USER_SUSPENDED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = true;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.USER_ENTITY_SUSPENDED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = true;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.NO_ACTIVE_BANK_RELATIONSHIP
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = true;
                                        vm.userSuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.USER_DELINKED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = true;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.INVALID_OTP_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.otpFailed = true;
                                        vm.clicked = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.INVALID_CAPTCHA
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = true;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.MAXIMUM_CAPTCHA_TIME_EXCEED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = true;
                                        vm.invalidCaptcha = false;
                                        vm.MaximumExceedCountTime =
                                            angular.fromJson(
                                                response.data
                                            ).message;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.USER_BLOCKED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.userBlocked = true;
                                        vm.userBlockedError = angular.fromJson(
                                            response.data
                                        ).title;
                                    }
                                } else {
                                    vm.authenticationError = true;
                                    vm.clicked = false;
                                }
                            });
                    })
                    .catch(function (error) {
                        console.error("reCAPTCHA error:", error);
                    });
            });
               }else{
                        Auth.login({
                            username: vm.cryptUserName,
                            password: vm.cryptPassword,
                            rememberMe: vm.rememberMe,
                            skipOTP: vm.skipOTP,
                            orgType: vm.orgType,
                            captchaContent: vm.captchaContent,
                            captchaText: vm.captchaText,
                            sourceType: "otp-login",
                            source: "login"
                        })
                            .then(function () {
                                GlobalValues.clearPreviousValues();
                                vm.authenticationError = false;
                                vm.recaptchaError = false;
                                vm.LockError = false;
                                vm.dormantError = false;
                                vm.tradingNotActivatedError = false;
                                vm.noActiveBankRelationship = false;
                                vm.passwordExpiryError = false;
                                vm.userSuspendedError = false;
                                vm.userDelinkedError = false;
                                vm.userEntitySuspendedError = false;
                                vm.userBlocked = false;
                                vm.maximumExceedCaptcha = false;
                                vm.invalidCaptcha = false;
                                vm.maximumRefreshExceedCaptcha = false;
                                checkPasswordExpiryWarning();
                            })
                            .catch(function (response) {
                                if (response.status != 403) {
                                    vm.authenticationError = true;
                                    vm.clicked = false;
                                    if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.USER_LOCKED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.dormantError = false;
                                        vm.LockError = true;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.USER_DORMANT_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.LockError = false;
                                        vm.dormantError = true;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.TRADING_NOT_ACTIVATED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.tradingNotActivatedError = true;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.PASSWORD_EXPIRED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        //vm.passwordExpiryError = true;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                        MessageBox.openMessageBox(
                                            "Alert",
                                            "Password is expired. Please proceed to set a new Password...!",
                                            "Ok",
                                            "login"
                                        );
                                        //$state.go('change-password-expiry', {login: vm.username});
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.PASSWORD_SYSTEM_GENERATED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        Auth.storePreviousState(
                                            "change-password-expiry",
                                            {
                                                login: vm.username,
                                                orgType: vm.orgTypeParam
                                            }
                                        );
                                        vm.maximumRefreshExceedCaptcha = false;
                                        MessageBox.openMessageBox(
                                            "Alert",
                                            "This is a Temporary Password. Please proceed to set a new Password...!",
                                            "Ok",
                                            "login"
                                        );
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.USER_SUSPENDED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = true;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.USER_ENTITY_SUSPENDED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = true;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.NO_ACTIVE_BANK_RELATIONSHIP
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = true;
                                        vm.userSuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.USER_DELINKED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = true;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.INVALID_OTP_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = false;
                                        vm.otpFailed = true;
                                        vm.clicked = false;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.INVALID_CAPTCHA
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = false;
                                        vm.invalidCaptcha = true;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.MAXIMUM_CAPTCHA_TIME_EXCEED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.passwordExpiryError = false;
                                        vm.LockError = false;
                                        vm.dormantError = false;
                                        vm.tradingNotActivatedError = false;
                                        vm.noActiveBankRelationship = false;
                                        vm.userSuspendedError = false;
                                        vm.userEntitySuspendedError = false;
                                        vm.userDelinkedError = false;
                                        vm.maximumExceedCaptcha = true;
                                        vm.invalidCaptcha = false;
                                        vm.MaximumExceedCountTime =
                                            angular.fromJson(
                                                response.data
                                            ).message;
                                        vm.maximumRefreshExceedCaptcha = false;
                                    } else if (
                                        angular.fromJson(response.data).type ===
                                        errorConstants.USER_BLOCKED_TYPE
                                    ) {
                                        vm.authenticationError = false;
                                        vm.recaptchaError = false;
                                        vm.userBlocked = true;
                                        vm.userBlockedError = angular.fromJson(
                                            response.data
                                        ).title;
                                    }
                                } else {
                                    vm.authenticationError = true;
                                    vm.clicked = false;
                                }
                            });
                        }
 
            
        }

        function signIn() {
            //			if ($state.current.name === 'register' || $state.current.name === 'activate' ||
            //                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset' ||
            //                    $state.current.name === 'change-password-expiry' || $state.current.name === 'change-password') {
            //                    $state.go('home');
            //                }else{
            //                	$state.go('home');
            //                }
            $state.go("home");
            $rootScope.$broadcast("authenticationSuccess");
            $rootScope.sessionExpired = false;
            User.insertSessionLog();

            /*if (Auth.getPreviousState()) {
                var previousState = Auth.getPreviousState();
                Auth.resetPreviousState();
                if (previousState.name === 'register' || previousState.name === 'activate' ||
                        previousState.name === 'finishReset' || previousState.name === 'requestReset' ||
                        previousState.name === 'change-password-expiry' || previousState.name === 'change-password') {
                    $state.go('home');
                }else{
                    $state.go(previousState.name, previousState.params);
                }
 
            }
            else {
                $state.go('home');
            }*/
        }

        function onPasswordExpriryValidationSuccess(result) {
            if (result.passwordExpiryDays != -1) {
                MessageBox.openMessageBox(
                    "Alert",
                    "Your password will be expired in " +
                    result.passwordExpiryDays +
                    " day(s). Do you want to reset your password?",
                    "YesNo",
                    "passwordexpirywarning"
                );
            } else {
                signIn();
            }
        }

        $rootScope.$on(
            "gatewayApp.messagebox.yes.passwordexpirywarning",
            function (event, data) {
                if ($state.current.name === "login") {
                    vm.confirmOTP = false;
                    $state.go("change-password-expiry", {
                        login: vm.username,
                        orgType: vm.orgTypeParam,
                        action: "Expiry"
                    });
                }
            }
        );

        $rootScope.$on(
            "gatewayApp.messagebox.no.passwordexpirywarning",
            function (event, data) {
                if ($state.current.name === "login") {
                    signIn();
                }
            }
        );

        $rootScope.$on(
            "gatewayApp.messagebox.clear.passwordexpirywarning",
            function (event, data) {
                if ($state.current.name === "login") {
                    signIn();
                }
            }
        );

        /*
         * allow only 30 characters in password and only some special characters
         */
        $scope.$watch("vm.password", function (newVal, oldVal) {
            if (newVal != null || newVal != undefined) {
                if (newVal.length > 30) {
                    vm.password = oldVal;
                }
                if (
                    !newVal
                        .charAt(newVal.length - 1)
                        .match(vm.allowedPasswordCharacters)
                ) {
                    vm.password = oldVal;
                }
            }
        });

        function onPasswordExpriryValidationError() { }

        function onOTPFailure(result) {
            //vm.wrongOTPCount=vm.wrongOTPCount+1;
            if (
                vm.wrongOTPCount >= globalValue.maximumOTPWrongAttemptCount
            ) // check if the wrong otp was entered for 3 or more times
            {
                vm.otpFailed = false;
                vm.wrongOTPLimitExceeded = true; //display message
                MessageBox.openMessageBox(
                    "Alert",
                    "Maximum wrong OTP attempt count is exceeded! Login blocked. Please try after " +
                    vm.configSettings.timePeriodToBlockUserLoginInMinutes +
                    " minutes.",
                    "Ok",
                    "invalidotp"
                );
                //MessageBox.openMessageBox('Alert', $filter('translate')('gatewayApp.error.UserBlockedForMaximumWrongOTPCount'), 'Ok', 'invalidotp');
            } else {
                vm.otpFailed = true;
                vm.clicked = false;
            }

            console.log(result);
        }

        function register() {
            $state.go("register");
        }

        function requestResetPassword() {
            $state.go("requestReset", {
                action: "RESET",
                orgType: vm.orgTypeParam
            });
        }

        function requestUnlockUser() {
            $state.go("requestUnlock", {
                action: "UNLOCK",
                orgType: vm.orgTypeParam
            });
        }

        vm.showPwd = function showPwd(controlType) {
            //vm.showPassword=!vm.showPassword;
            if (controlType == "password") {
                vm.controlType = "text";
            }
            if (controlType == "text") {
                vm.controlType = "password";
            }
        };

        vm.resendOTP = function resendOTP() {
            if (vm.resendOTPCount >= globalValue.maximumOTPResendAttemptCount) {
                MessageBox.openMessageBox(
                    "Alert",
                    "Maximum request for resend OTP is exceeded! Please try again.",
                    "Ok",
                    "resendotp"
                );
            } else {
                // Account.sendOTP(
                //     { login: vm.username },
                //     onOtpResendSuccess,
                //     onOtpResendError
                // );

                // Add reCAPTCHA here
            if (OrganisationTypeEnum.CLEARCORP != vm.orgType) {
                grecaptcha.ready(function () {
                    grecaptcha
                        .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
                            action: "otp_action"
                        })
                        .then(function (token) {
                            // DTO object
                            var recaptchaOtpDetailsDTO = {
                                login: vm.username,
                                recaptchaToken: token,
                                 orgType: vm.orgType,
                                sourceType: "resend-otp",
                                source: "login"
                            };

                            Account.sendOTP(
                                recaptchaOtpDetailsDTO,
                                onOtpResendSuccess,
                                onOtpResendError
                            );
                        })
                        .catch(function (error) {
                            console.error("reCAPTCHA error:", error);
                        });
                });
                } else {
                    // DTO object
                    var recaptchaOtpDetailsDTO = {
                        login: vm.username,
                        orgType: vm.orgType,
                        sourceType: "resend-otp",
                        source: "login"
                    };

                    Account.sendOTP(
                        recaptchaOtpDetailsDTO,
                        onOtpResendSuccess,
                        onOtpResendError
                    );
                }
            }

        };

        function onOtpResendSuccess(result) {
            vm.resendOTPCount = vm.resendOTPCount + 1;
            vm.wrongOTPCount = 0;
            vm.wrongOTPLimitExceeded = false;
            vm.sendOTPSuccess = false;
           vm.resendOTPSuccess = true;
        }

        function onOtpResendError() {
            MessageBox.openMessageBox(
                "Alert",
                "Too many requests - try again later.",
                "Ok",
                "resendotp"
            );
        }

        vm.openCustomerOnboarding = function openCustomerOnboarding() {
            $state.go("customerRegistration");
        };

        vm.resubmitApplication = function resubmitApplication() {
            $state.go("request-reference-number", { refNo: vm.refNo });
        };

        function setEnvironmentName() {
            if (
                vm.configSettings.environmentName != "" &&
                vm.configSettings.environmentName != undefined &&
                vm.configSettings.environmentName != null
            ) {
                vm.environmentName =
                    vm.configSettings.environmentName.toUpperCase();
            }
        }

        // Get Config For RestrictedOTPandEmailIntervalInSeconds
        function getRestrictedOTPandEmailIntervalInSeconds() {
            var configName = "RestrictedOTPandEmailIntervalInSeconds";
            DealingAdminApplicationWideSettings.getConfigValueForConfigName(
                { configName: configName },
                getRestrictedOTPandEmailIntervalInSecondsIsSuccess,
                getRestrictedOTPandEmailIntervalInSecondsIsFailure
            );
        }

        function getRestrictedOTPandEmailIntervalInSecondsIsSuccess(result) {
            vm.restrictedOTPandEmailIntervalInSeconds = result.value;
        }

        function getRestrictedOTPandEmailIntervalInSecondsIsFailure() { }

        // Get Config For RestrictedOTPandEmailCapacity
        function getRestrictedOTPandEmailCapacity() {
            var configName = "RestrictedOTPandEmailCapacity";
            DealingAdminApplicationWideSettings.getConfigValueForConfigName(
                { configName: configName },
                getRestrictedOTPandEmailCapacityIsSuccess,
                getRestrictedOTPandEmailCapacityIsFailure
            );
        }

        function getRestrictedOTPandEmailCapacityIsSuccess(result) {
            vm.restrictedOTPandEmailCapacity = result.value;
        }

        function getRestrictedOTPandEmailCapacityIsFailure() { }

        // Get Config For SkipCaptchaVerification
        function getSkipCaptchaVerification() {
            var configName = "SkipCaptchaVerification";
            DealingAdminApplicationWideSettings.getConfigValueForConfigName(
                { configName: configName },
                getSkipCaptchaVerificationIsSuccess,
                getSkipCaptchaVerificationIsFailure
            );
        }

        function getSkipCaptchaVerificationIsSuccess(result) {
            vm.skipCaptchaVerification = result.value;
        }

        function getSkipCaptchaVerificationIsFailure() { }

        getSkipCaptchaVerification();
        getRestrictedOTPandEmailIntervalInSeconds();
        getRestrictedOTPandEmailCapacity();
        loadCaptcha();

        //    vm.loadCaptcha = loadCaptcha;
        function loadCaptcha() {
            vm.refreshInprogress = true;

            CaptchaService.getCaptchaDetail(function (result) {
                vm.captchaImageData = result.captchaImageData;
                vm.captchaContent = result.captchaContent;

                // keep spinner for 1 second (adjust if needed)
                $timeout(function () {
                    vm.refreshInprogress = false;
                }, 1000); // stop spinner
            }, function () {
                // even on error, keep spinner for 1 second
                $timeout(function () {
                    vm.refreshInprogress = false;
                }, 1000); // stop spinner on error
            });
        }
        vm.refreshCaptcha = function () {

            if (vm.refreshInprogress || vm.maximumRefreshExceedCaptcha) {
                return;
            }

            loadCaptcha();
            vm.refreshCount++;

            if (vm.refreshCount > vm.restrictedOTPandEmailCapacity) {

                vm.maximumRefreshExceedCaptcha = true;
                vm.remainingTime = vm.restrictedOTPandEmailIntervalInSeconds; // 1 minute block

                // Start countdown (SAME AS OTP)
                var countdown = function () {
                    if (vm.remainingTime > 0) {
                        vm.remainingTime--;
                        $timeout(countdown, 1000);
                    } else {
                        vm.maximumRefreshExceedCaptcha = false;
                        vm.refreshCount = 0;
                    }
                };

                countdown();
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('CaptchaService', CaptchaService);

        CaptchaService.$inject = ['$resource', 'GlobalValues'];

    function CaptchaService($resource, GlobalValues) {
        var resourceUrl = 'api/';
        return $resource(resourceUrl, {}, {    	 
            'getCaptchaDetail':{
                method: 'GET',
                url: 'api/public/getCaptchaImageAndTextDetails'
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .filter('findLanguageFromKey', findLanguageFromKey)
        .filter('findLanguageRtlFromKey', findLanguageRtlFromKey);

    var languages = {
        'en': { name: 'English' },
        'hi': { name: 'हिंदी' }
        // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
    };

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return languages[lang].name;
        }
    }

    function findLanguageRtlFromKey() {
        return findLanguageRtlFromKeyFilter;

        function findLanguageRtlFromKeyFilter(lang) {
            return languages[lang].rtl;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'hi'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('execute-alert-notifications', {
            parent: 'entity',
            url: '/execute-alert-notifications',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.executeAlertNotifications.executeAlertNotifications" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/execute-alert-notifications/execute-alert-notifications.html',
                    controller: 'ExecuteAlertNotificationsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('executeAlertNotifications');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })

        };
    })();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ExecuteAlertNotifications', ExecuteAlertNotifications);

    ExecuteAlertNotifications.$inject = ['$resource'];

    function ExecuteAlertNotifications ($resource) {
        var resourceUrl =  'api/executeAlertNotifications';

        return $resource(resourceUrl, {}, {
            'execute': {
                method: 'POST',
            	params: {executeDate:'@executeDate'},
                url: 'api/execute-alert-notifications/:executeDate',
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
            'executeAlertsForBUAndEvents': {
                method: 'POST',
            	params: {executeDate:'@executeDate', corpId: '@corpId', branchId: '@branchId', eventId: '@eventId'},
                url: 'api/execute-notifications/:executeDate/:corpId/:branchId/:eventId',
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
        	'getAllCorporates': {
	            method: 'GET',
	            isArray: true,
	            url: 'api/corporate-organisations',
	            transformResponse: function (data) {
	                if (data) {
	                    data = angular.fromJson(data);
	                }
	                return data;
	            }
        	},
        	'getAllBanks': {
	            method: 'GET',
	            isArray: true,
	            url: 'api/bank-organisations',
	            transformResponse: function (data) {
	                if (data) {
	                    data = angular.fromJson(data);
	                }
	                return data;
	            }
        	},
        	'getAllBranches': {
	            method: 'GET',
	            isArray: true,
	            params: {bankId:'@bankId'},
	            url: 'api/bank/:bankId/cleared-branches',
	            transformResponse: function (data) {
	                if (data) {
	                    data = angular.fromJson(data);
	                }
	                return data;
	            }
        	}
       });
    }
})();
            
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        })
        
        .controller('ExecuteAlertNotificationsController', ExecuteAlertNotificationsController);

    ExecuteAlertNotificationsController.$inject = ['$scope', '$state', '$filter', 'workflowSharedService', 'ExecuteAlertNotifications', 'GlobalValues', 'EntityPermissions', 'AlertConfiguration'];

    function ExecuteAlertNotificationsController($scope, $state, $filter, workflowSharedService, ExecuteAlertNotifications, GlobalValues, EntityPermissions, AlertConfiguration) {
        var vm = this;
        vm.todayDate=new Date();
        vm.executeDate = vm.todayDate;
        vm.executeAllOrSpecific = 'all';
        vm.eventTypes = AlertConfiguration.getEventTypes();
        
        vm.corporates = ExecuteAlertNotifications.getAllBanks();

        vm.getBranchForCorporate = function getBranchForCorporate(corporate){
        	vm.branches = ExecuteAlertNotifications.getAllBranches({'bankId':corporate.id})
        }
        
        loadAll();
        
        function loadAll() {
        	
        }
        
        vm.executeAlertNotifications = function executeAlertNotifications(){
            var executeDate=$filter('date')(new Date(vm.executeDate),'dd-MMM-yyyy');
        	if(vm.executeAllOrSpecific=='specific'){
        		ExecuteAlertNotifications.executeAlertsForBUAndEvents({'executeDate':executeDate, 'corpId': vm.corporate.id, 'branchId': vm.branch.id, 'eventId': vm.eventType.id});
        	} 
        	else{
        		ExecuteAlertNotifications.execute({'executeDate':executeDate});
        	}
        }
        
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('csplDocumentUpload', ['StringUtils', 'ArrayUtils', 'CollectionUtils',
            'FileUtil', 'GlobalValues', 'OperationEnum', 'FloatUtils' , '$timeout', 
            function(StringUtils, ArrayUtils, CollectionUtils,
                FileUtil, GlobalValues, OperationEnum, FloatUtils, $timeout) {

                function linkFunction(scope, iElement, iAttrs, controllers) {

                    scope.formController = controllers[0];
                    scope.disableControl=false;
                    scope.invalidPan=false;
                    scope.invalidPanText='';
                    scope.file=null;
                    // set the maximim allowed file size 
                    scope.showRemove=false;
                    

                    document.getElementById("uploadPath").addEventListener("change", uploadPathChangeEventListener);
                 

                    scope.viewFile = {};

                    if(scope.file!=null && scope.file!=undefined){
                        // var uploadFile ={};
                        // uploadFile.fileName = scope.viewFile.name;
                        // uploadFile.file = scope.viewFile;
                        scope.viewFile=scope.file;
                      // scope.showRemove=true;
                            
                       
                    }
                    
                    function uploadPathChangeEventListener(event) {

                        try{
                                if(event.target.files.length>0){
                                    uploadInputFiles(event.target.files[0]);
                                    event.target.value = '';
                                }
                            
                        }
                        catch(error) {
                            scope.invalidPan=true;
                            scope.invalidPanText=error;
                           
                            //ModalService.openCsplAlertModal(error);
                        }

                        $timeout(function (){
                            setFormDirty();
                        },200);
                       
                    }
                  
                    function setFormDirty(){
                        if(_.get(scope, 'formController', false)){
                            scope.formController.$setDirty();
                        }
                    }

                    function uploadInputFiles(file){
                        scope.invalidPan=false;
                    
                        //Get all uploaded file
                        var uploadedFile = file;

                        //Validate all uploaded files
                        validateUploadedFiles(scope.viewFile, uploadedFile);

                        //Prepare File object for each uploaded file and add to list
                        
                            scope.file = file;
                            var uploadFile ={};
                            uploadFile.fileName = uploadedFile.name;
                            uploadFile.file = uploadedFile;
                            
                            scope.viewFile=uploadFile;
                            
                            //scope.multipartFileList=uploadedFile;

                        
                        scope.disableControl=true;
                        scope.showRemove=true;
                        scope.$digest();
                    }

                    /**
                     * Validate list of uploaded files
                     * Validate file duplication, invalid extension, invalid file size
                     */
                    function validateUploadedFiles(filesList, uploadedFile){

                        //Validate file duplication
                        //validateFileDuplication(filesList, uploadedFile);
                        
                        //Validate file extension
                        validateFileExtension(uploadedFile);

                        //Validate size of uploaded files
                        validateUploadedFilesSize(uploadedFile);

                    }

                    /**
                     * Validate if uploaded file is already present
                     */
                    function validateFileDuplication(filesList, uploadedFile){

                        var filesWithError = [];

                        angular.forEach(uploadedFile, function(file){
                            //Validate if file already exists
                            var filteredList = CollectionUtils.filter(filesList, 'fileName', file.name);

                            //Add all invalid files
                            if(!ArrayUtils.isEmpty(filteredList)){
                                filesWithError.push(file.name);
                            }
                        })

                        if(!ArrayUtils.isEmpty(filesWithError)){
                            throw "File(s) " + filesWithError.join(", ") + " already exists.";
                        }
                    }

                    /**
                     * Validate if uploaded files have valid allowed extensions
                     */
                    function validateFileExtension(uploadedFile){
                        
                        var filesWithError = [];

                       
                            
                            //Validate extension
                            var fileExtension = uploadedFile.name.substr(uploadedFile.name.lastIndexOf('.'));
                            if (!CollectionUtils.includes(getFileExtensions(), StringUtils.toLowerCase(fileExtension))){
                                filesWithError.push(uploadedFile.name);
                            }
                            

            

                        if(!ArrayUtils.isEmpty(filesWithError)){
                            throw "" + filesWithError.join(", ") + " are not allowed. The accepted file formats are pdf, jpg, png.";
                        }
                    }

                    /**
                     * Validate minimum and maximum size of uploaded files
                     */
                    function validateUploadedFilesSize(uploadedFile){

                        //Get min and max file size allowed from config settings
                        var maxSizeConfig = 200;
                        //GlobalValues.getConfigSettings().documentMaximumSize;

                        //Get default 100kb size
                        var maxSizeAllowed = FloatUtils.getFloat(200);
                        
                        //Get maximum value from config
                        if(!StringUtils.isBlank(maxSizeConfig)){
                            //Convert MB into bytes
                            maxSizeAllowed = FloatUtils.getFloat(maxSizeConfig);
                        }
                        // min size 1kb
                        var minSizeAllowed = 1;
                        

                        //Validate file size
                        validateFileSize(uploadedFile, minSizeAllowed, maxSizeAllowed);
                    }

                    /**
                     * Validate size of uploaded files
                     */
                    function validateFileSize(uploadedFile, minSizeAllowed, maxSizeAllowed){

                        var filesWithError = [];

                        

                            //Convert Kb into bytes
                            var minSizeAllowedBytes = FloatUtils.multiply(FloatUtils.getFloat(minSizeAllowed), 
                                FloatUtils.getFloat(1024));
                            var maxSizeAllowedBytes = FloatUtils.multiply(FloatUtils.getFloat(maxSizeAllowed), 
                                    FloatUtils.getFloat(1024));
  
                            //Validate size
                            //Validate minimum and maximum file size using config settings
                            if(!FileUtil.isFileSizeValid(uploadedFile.size ,minSizeAllowedBytes, maxSizeAllowedBytes  )){
                                filesWithError.push(uploadedFile.name);
                            }
                        

                        if(!ArrayUtils.isEmpty(filesWithError)){
                            throw "" + filesWithError.join(", ") + " is of invalid size. Minimum size  is "+minSizeAllowed +" Kb and Maximum  size is " + maxSizeAllowed + " kb.";
                        }

                    }
                    
                    //Get allowed file extensions
                    function getFileExtensions(){
                        return ['.jpg', '.png','.pdf'];
                    }

                    //Remove selected file
                    scope.removeFile = function(){

                        setFormDirty();  
                        scope.viewFile=null;
                        scope.file = null;
                        scope.disableControl=false;
                        scope.showRemove=false;
                        scope.invalidPan=true;
                        scope.invalidPanText="PAN image should be uploaded.";
                    }

                    //View selected file
                    scope.fileView = function(){

                        //If byte array is empty, file is just uploaded, so read from multipart file
                        if(StringUtils.isBlank(scope.viewFile.fileContentByte)){

                            if(scope.viewFile.file != undefined && scope.viewFile.file != null){
                                //open uploaded file
                                FileUtil.viewFile(scope.viewFile.file, scope.viewFile.name);
                            }
                        }else{
                            FileUtil.viewFileFromBase64(scope.viewFile.fileContentByte, scope.viewFile.name);
                        }
                    }

                    //Download selected file either from byte array or uploaded file content
                    scope.downloadFile = function(fileToDownload){

                        //If byte array is empty, file is just uploaded, so download from multipart file
                        if(StringUtils.isBlank(fileToDownload.fileContentByte)){

                            if(fileToDownload.file != undefined && fileToDownload.file != null){
                                //download uploaded file
                                FileUtil.downloadFile(fileToDownload.file);
                            }
                        }else{
                            //Download file from Base64 string
                            FileUtil.downloadFileFromBase64(fileToDownload.fileContentByte, fileToDownload.name);
                        }
                    }
                    scope.$watch('controlRequired', function(value) {
                        if (value != null && value != "" && (value == "true" || value == true)) {
                                if (scope.form != null) {
                                    scope.form.$setValidity(iAttrs.controlId + "fileRequired", false);
                                }
                            }
                            });
                    scope.$watch('file', function(value) {
                         if (value != null && value != "") {
                            scope.form.$setValidity(iAttrs.controlId + "fileRequired", true);
                                      
                            }else{
                                scope.form.$setValidity(iAttrs.controlId + "fileRequired", false);
                            
                            }
                     });
                    



                     angular.element(document).ready(function() {
                        var dropbox = document.getElementById("dropContainer");

                        if(dropbox != undefined && dropbox != null){
                            
                            dropbox.addEventListener("dragenter", dragenter, false);
                            dropbox.addEventListener("dragover", dragover, false);
                            dropbox.addEventListener("drop", drop, false);
                            dropbox.addEventListener("dragleave", dragleave, false);
                        }

                        
                    });
                    
                    
                    
                    function dragenter(evt) {
                        $('#dropContainer').addClass("active"); 
                        evt.stopPropagation();
                        evt.preventDefault();
                      };

                    function dragover(evt) {
                        $('#dropContainer').addClass("active"); 
                        evt.stopPropagation();
                        evt.preventDefault();
                      };

                    function dragleave(evt){
                        $('#dropContainer').removeClass("active"); 
                    }
                      
                    function drop(evt) {
                        $('#dropContainer').removeClass("active"); 
                        evt.stopPropagation();
                        evt.preventDefault();
                        try{
                            if(!scope.disableControl){
                                uploadInputFiles(evt.dataTransfer.files[0]);
                            }
                           
                           
                        }
                        catch(error) {
                            scope.invalidPan=true;
                            scope.invalidPanText=error;
                          
                          //  ModalService.openCsplAlertModal(error);
                        }
                        $timeout(function (){
                            setFormDirty();
                        },200);
                            
                      };
                }

                return {
                    templateUrl: 'app/components/cspl-document-upload/cspl-document-upload.html',
                    restrict: 'E',
                    scope: {
                        file : '=',
                        controlRequired: '=',
                        form:'=',
                        controlId: '='
                    },
                    require: ['^form'],
                    link: linkFunction
                };
            }]);
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('csplInfoTooltip', ['$translate','StringUtils',
            function( $translate,  StringUtils) {

            function linkFunction(scope, element, attrs) {
                
				// scope.showTooltip = "No";

            	element.click(function(){

					
					
					if(!StringUtils.isBlank(attrs.csplInfoTooltip)){

						var title = attrs.csplInfoTooltip;
						$(element).tooltip({
							container: 'body',
							title : function(){
								return title; 
							} ,
							placement : attrs.tooltipPosition,
							template: '<div class="popover info-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner info-tooltip-inner"></div></div>'
						});
						$(element).tooltip('show');

					}
					/*else if(attrs.tooltipRequired != undefined && attrs.tooltipRequired != null &&
						attrs.tooltipRequired){
							var title = attrs.csplInfoTooltip;
						
							$(element).tooltip({
								container: 'body',
								title : function(){
									return title; 
								} ,
								placement : "right"
							});
							$(element).tooltip('show');
					}
					else{
						$(element).tooltip('destroy');
					}   */ 
               });

			   element.mouseleave(function(){
					$('body>.tooltip').remove();
					$(element).tooltip('destroy');
			});

            }

            return {
                restrict: 'A',
                link: linkFunction
            };
        }]);
})();


(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('csplCheckbox', [function() {

            function linkFunction(scope, iElement, iAttrs, ngModelController) {
                var input = iElement.find('input[ng-model]');
                scope.color = "#F2F2F2";
                if (!ngModelController) {
                    return; // do nothing if no ng-model
                }
                
                if(scope.themeType=='light'){
                	scope.color = "#0D0D0D";
                }

                scope.onChange = function() {
                    ngModelController.$setViewValue(scope.value);
                };

                ngModelController.$render = function() {
                    scope.value = ngModelController.$modelValue;
                };
            }

            return {
                templateUrl: 'app/components/cspl-controls/cspl-checkbox/cspl-checkbox.html',
                restrict: 'E',
                require: 'ngModel',
                scope: {
                    ngDisabled: '=',
                    id: '=',
                    themeType: '@',
                    labelValue: '@'
                },
                link: linkFunction
            };
        }]);
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('AlertConfigurationDetailsController', AlertConfigurationDetailsController);

    AlertConfigurationDetailsController.$inject = ['Workflow', '$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AlertConfiguration', '$uibModalInstance', 'GlobalValues', 'workflowSharedService', 'ScreenLog'];

    function AlertConfigurationDetailsController(Workflow, $scope, $rootScope, $stateParams, previousState, entity, AlertConfiguration, $uibModalInstance, GlobalValues, workflowSharedService, ScreenLog) {
        var vm = this;

        vm.eventType = AlertConfiguration.getEventTypes();
        vm.reminderType = AlertConfiguration.getReminderTypes();
        vm.notifyByTypes = AlertConfiguration.getNotifyByTypes();
        vm.notificationTypes = AlertConfiguration.getNotificationTypes();
        vm.natureReminderMapping = AlertConfiguration.getNatureReminderMapping();
        vm.discardAlertConfiguration=discardAlertConfiguration;
        vm.rejectAlertConfiguration=rejectAlertConfiguration;
        vm.approveAlertConfiguration=approveAlertConfiguration;
        $scope.showButton = false;
        $scope.showDiscardButton = false;
        $scope.clicked=false;
        
        vm.users = AlertConfiguration.getUsersForOrganisation();

        vm.roles = AlertConfiguration.getRolesForOrganisation({"orgId" : GlobalValues.getOrganisation().id});

        if (entity!=null){
            vm.alertConfigurationHeader = entity;
            var notifyByTypeDetailsArr=vm.alertConfigurationHeader.alertConfigurationNotifyByTypeDetails;
            vm.notifyByTypeList=[];
            angular.forEach(notifyByTypeDetailsArr, function(value, key) 
            {
            	if (value.active==true){
                	vm.notifyByTypeList.push(value.notifyByType.id);
            	}
             });
            
            var notifyUserDetailsArr=vm.alertConfigurationHeader.alertConfigurationNotifyUserDetails;
            vm.userList=[];
            vm.roleList=[];
            angular.forEach(notifyUserDetailsArr, function(value, key) 
            {
            	if(value.active==true){
            		if (vm.alertConfigurationHeader.configNotifyUsersBy == 'users'){
                    	vm.userList.push(value.user.id);
            		}else{
                    	vm.roleList.push(value.organisationRole.id);
            		}
            	}
            });
        }
        if(workflowSharedService.viewFrom == 'alertConfiguration'){
        	
        	vm.alertConfigurationHeader=entity;
            //ScreenLog.screenLog({'entityName': 'AlertConfiguration', 'entityRecordId': vm.alertConfigurationHeader.id, 'action': 'VIEW'});
       	 	$scope.showButton=false;
        }
        else if(workflowSharedService.viewFrom == 'alertconfigurationtodolist_checker') {
        	vm.alertConfigurationHeaderDTO =  angular.fromJson($rootScope.payload); 
        	vm.alertConfigurationHeader=vm.alertConfigurationHeaderDTO.alertConfigurationHeader;
            var notifyByTypeDetailsArr=vm.alertConfigurationHeaderDTO.alertConfigurationNotifyByTypeDetails;
            vm.notifyByTypeList=[];
            angular.forEach(notifyByTypeDetailsArr, function(value, key) 
            {
            	if (value.active==true){
                	vm.notifyByTypeList.push(value.notifyByType.id);
            	}
             });
            var notifyUserDetailsArr=vm.alertConfigurationHeaderDTO.alertConfigurationNotifyUserDetails;
            vm.userList=[];
            vm.roleList=[];
            angular.forEach(notifyUserDetailsArr, function(value, key) 
            {
            	if(value.active==true){
            		if (vm.alertConfigurationHeader.configNotifyUsersBy == 'users'){
                    	vm.userList.push(value.user.id);
            		}else{
                    	vm.roleList.push(value.organisationRole.id);
            		}
            	}
            });

        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
        }
        else if(workflowSharedService.viewFrom == 'alertconfigurationtodolist_maker') {
        	vm.alertConfigurationHeaderDTO =  angular.fromJson($rootScope.payload); 
        	vm.alertConfigurationHeader=vm.alertConfigurationHeaderDTO.alertConfigurationHeader;

            var notifyByTypeDetailsArr=vm.alertConfigurationHeaderDTO.alertConfigurationNotifyByTypeDetails;
            vm.notifyByTypeList=[];
            angular.forEach(notifyByTypeDetailsArr, function(value, key) 
            {
            	if (value.active==true){
                	vm.notifyByTypeList.push(value.notifyByType.id);
            	}
             });
            
            var notifyUserDetailsArr=vm.alertConfigurationHeaderDTO.alertConfigurationNotifyUserDetails;
            vm.userList=[];
            vm.roleList=[];
            angular.forEach(notifyUserDetailsArr, function(value, key) 
            {
            	if(value.active==true){
            		if (vm.alertConfigurationHeader.configNotifyUsersBy == 'users'){
                    	vm.userList.push(value.user.id);
            		}else{
                    	vm.roleList.push(value.organisationRole.id);
            		}
            	}
            });

            $scope.showButton=false;
        	$scope.showDiscardButton = true;
        }
        if(workflowSharedService.viewFrom == 'alertConfiguration_auditLog'){
        	
        	vm.alertConfigurationHeaderDTO =  angular.fromJson($rootScope.payload); 
        	vm.alertConfigurationHeader=vm.alertConfigurationHeaderDTO.alertConfigurationHeader;
            //ScreenLog.screenLog({'entityName': 'AlertConfiguration', 'entityRecordId': vm.alertConfigurationHeader.id, 'action': 'VIEW'});
       	 	$scope.showButton=false;
       	 	$scope.showDiscardButton = false;
        }
        
        
        vm.flag = 0;
        vm.branchId = 0;
        vm.getUsers = function getUsers(branch){
        	if ((branch!=null && vm.flag==0) || (vm.branchId != 0 && vm.branchId != branch.id)){

        		vm.users = AlertConfiguration.getUserBranchClearances({"branchId":branch.id});
            	vm.branchId = branch.id;
            	vm.flag=1;

        	}
        }

        vm.previousState = previousState.name;
        
        vm.clear=clear;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function approveAlertConfiguration() { 
        	AlertConfiguration.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectAlertConfiguration() { Workflow.rejectTask($rootScope.taskID); }

        function discardAlertConfiguration() {
        	AlertConfiguration.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {
        	
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('AlertConfigurationEditController', AlertConfigurationEditController);

    AlertConfigurationEditController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AlertConfiguration', '$uibModalInstance', 'GlobalValues', 'OrganisationManipulation', 'ScreenLog'];

    function AlertConfigurationEditController($scope, $rootScope, $stateParams, entity, AlertConfiguration, $uibModalInstance, GlobalValues, OrganisationManipulation, ScreenLog) {
        var vm = this;

        if(entity!=null){
        	vm.alertConfigurationHeader=entity;
        	
        	/*vm.alertConfigurationHeader.alertConfigurationNotifyUserDetails=vm.alertConfigurationHeader.alertConfigurationNotifyUserDetails;
        	vm.alertConfigurationHeader.alertConfigurationNotifyByTypeDetails=vm.alertConfigurationHeader.alertConfigurationNotifyByTypeDetails;*/
        }
        vm.clear=clear;
        vm.save=save;
        vm.alertConfigurationDTO={};
        vm.alertConfigurationNotifyUserDetails = [];
        vm.alertConfigurationNotifyByTypeDetails = [];

        vm.eventType = AlertConfiguration.getEventTypes();
        vm.eventTypes = AlertConfiguration.getEventTypes();
        vm.reminderType = AlertConfiguration.getReminderTypes();
        vm.reminderTypes = AlertConfiguration.getReminderTypes();
        vm.notifyByTypes = AlertConfiguration.getNotifyByTypes();
        vm.notifyByTypesForAllAlerts =vm.notifyByTypes;
        vm.notificationTypes = AlertConfiguration.getNotificationTypes();
        vm.natureReminderMapping = AlertConfiguration.getNatureReminderMapping();
        vm.ownerOrganisation = GlobalValues.getOrganisation();
        
        vm.users = AlertConfiguration.getUsersForOrganisation();

        vm.roles = AlertConfiguration.getRolesForOrganisation({"orgId" : GlobalValues.getOrganisation().id});

        vm.alertConfigurationHeader = entity;
        //ScreenLog.screenLog({'entityName': 'AlertConfiguration', 'entityRecordId': vm.alertConfigurationHeader.id, 'action': 'EDIT'});
        var notifyByTypeDetailsArr=vm.alertConfigurationHeader.alertConfigurationNotifyByTypeDetails;
        vm.notifyByTypeList=[];
        angular.forEach(notifyByTypeDetailsArr, function(value, key) 
        {
        	if (value.active==true){
            	vm.notifyByTypeList.push(value.notifyByType.id);
        	}
         });
        
        var notifyUserDetailsArr=vm.alertConfigurationHeader.alertConfigurationNotifyUserDetails;
        vm.userList=[];
        vm.roleList=[];
        angular.forEach(notifyUserDetailsArr, function(value, key) 
        {
        	if(value.active==true){
        		if (vm.alertConfigurationHeader.configNotifyUsersBy == 'users'){
                	vm.userList.push(value.user.id);
        		}else{
                	vm.roleList.push(value.organisationRole.id);
        		}
        	}
        });
        //vm.previousState = previousState.name;
        
        vm.getEventTypes = function getEventTypes(notificationType){
        	if(notificationType!=null){
            	vm.eventType = null;
            	var as = $(vm.eventTypes)
    	        .filter(function (i,n){
    	            return (n.notificationType.id == notificationType.id);
    	        })
    			if (Object.keys(as).length > 3){
    	        	vm.eventType = as;
    			}
        	}
        }

        vm.getReminderTypes = function getReminderTypes(eventType){
        	if(eventType!=null){
            	vm.reminderTypesForEvent = null;
            	var reminderType = [];
            	var as = $(vm.natureReminderMapping)
    	        .filter(function (i,n){
    	            return (n.nature == eventType.nature);
    	        })
            	vm.reminderTypesForEvent = as;
            	if(vm.reminderTypesForEvent.length>0){
                	angular.forEach(vm.reminderTypesForEvent, function(item){
                		reminderType.push(item.reminderType);
                	})
                	vm.reminderType = reminderType;
            	}
        	}
        }

        vm.getNotifyByTypesForAlert = function getNotifyByTypesForAlert(alertType){
        	if(alertType != null){
        		vm.notifyByTypesForAlert = null;
        		        		
        		if(alertType.shortName == 'Upload Error Alert'){
                	var as = $(vm.notifyByTypesForAllAlerts)
        	        .filter(function (i,n){
        	            return (n.shortName == 'Email');
        	        })
                	vm.notifyByTypesForAlert = as;
                	
                	vm.notifyByTypes = vm.notifyByTypesForAlert;
        		}else{
        	        vm.notifyByTypes = vm.notifyByTypesForAllAlerts;
        		}
        	}
        } 
        
        vm.getNotifyByTypes = function getNotifyByTypes(selectedNotifyByList, notifyByType){
        	if (selectedNotifyByList.length==1 && notifyByType.shortName=='Email'){
            	var notifyByList = [];
            	notifyByList = selectedNotifyByList;
            	var as = $(vm.notifyByTypes)
    	        .filter(function (i,n){
    	            return (n.shortName == 'On app');
    	        })
    	        vm.OnAppNotifyByType = as;
            	if (selectedNotifyByList[0] != vm.OnAppNotifyByType[0].id){
                	notifyByList.push(vm.OnAppNotifyByType[0].id);
                	vm.notifyByList = notifyByList;
            	}
        	}
        }

        vm.flag = 0;
        vm.branchId = 0;
        vm.getUsers = function getUsers(branch){
        	if ((branch!=null && vm.flag==0) || (vm.branchId != 0 && vm.branchId != branch.id)){

        		vm.users = AlertConfiguration.getUserBranchClearances({"branchId":branch.id});
            	vm.branchId = branch.id;
            	vm.flag=1;

        	}
        }
        
       
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save()
        {
        	addAlertConfigurationNotifyUserDetails();
        	
        	addAlertConfigurationNotifyByTypeDetails();
        	
        	prepareAlertConfigurationDTOToUpdate();
        	
        	AlertConfiguration.update({"orgId":GlobalValues.getUserOrganisation().id}, vm.alertConfigurationDTO, onSaveSuccess, onSaveError);   
        }
     
        function addAlertConfigurationNotifyUserDetails(){
        	if(vm.alertConfigurationHeader.configNotifyUsersBy=='users'){
            	for (var j=0; j<=vm.userList.length-1; j++){
            		if (vm.userList[j]!=null){
                		vm.filteredNotifyUser={};
                    	var as = $(vm.users)
            	        .filter(function (i,n){
            	            return (n.id == vm.userList[j]);
            	        })
            	        vm.filteredNotifyUser = as;
                		vm.alertConfigurationNotifyUserDetails.push({
                				"user":{"id":vm.filteredNotifyUser[0].id,"login":vm.filteredNotifyUser[0].login,"firstName":vm.filteredNotifyUser[0].firstName,"lastName":vm.filteredNotifyUser[0].lastName,"email":vm.filteredNotifyUser[0].email,"activated":vm.filteredNotifyUser[0].active,"langKey":vm.filteredNotifyUser[0].langKey,"resetKey":vm.filteredNotifyUser[0].resetKey,"mobileCountryCode":vm.filteredNotifyUser[0].mobileCountryCode,"mobile":vm.filteredNotifyUser[0].mobile,"userType":vm.filteredNotifyUser[0].userType,"resetDate":vm.filteredNotifyUser[0].resetDate,"active":vm.filteredNotifyUser[0].active},
                    			"organisationRole": null
                    	});
            		}
            	}
        	}
        	else{
            	for (var j=0; j<=vm.roleList.length-1; j++){
            		if (vm.roleList[j]!=null){
                		vm.filteredNotifyRole={};
                    	var as = $(vm.roles)
            	        .filter(function (i,n){
            	            return (n.id == vm.roleList[j]);
            	        })
            	        vm.filteredNotifyRole = as;
                		vm.alertConfigurationNotifyUserDetails.push({
            				"user":null,
                			"organisationRole": {"id":vm.filteredNotifyRole[0].id,"active":vm.filteredNotifyRole[0].active,"systemGenerated":vm.filteredNotifyRole[0].systemGenerated,"shortName":vm.filteredNotifyRole[0].shortName,"name":vm.filteredNotifyRole[0].name,"objectType":vm.filteredNotifyRole[0].objectType}
                		});
            		}
            	}
        	}
        }
        
        function addAlertConfigurationNotifyByTypeDetails(){
        	vm.notifyByType=[];
        	for (var j=0; j<=vm.notifyByTypeList.length-1; j++){
        		vm.filteredNotifyByType={};
            	var as = $(vm.notifyByTypes)
    	        .filter(function (i,n){
    	            return (n.id == vm.notifyByTypeList[j]);
    	        })
    	        vm.filteredNotifyByType = as;
            	vm.alertConfigurationNotifyByTypeDetails.push({
    			'notifyByType': vm.filteredNotifyByType[0]
    			});
        	}
        }
        
        function prepareAlertConfigurationDTOToUpdate(){
        	
        	if (vm.alertConfigurationHeader.numberOfDaysToNotify == null || vm.alertConfigurationHeader.numberOfDaysToNotify == ""){
        		vm.alertConfigurationHeader.numberOfDaysToNotify = 0;
        	}
        	
        	vm.alertConfigurationHeader.alertConfigurationNotifyUserDetails=[];
        	vm.alertConfigurationHeader.alertConfigurationNotifyByTypeDetails=[];

        	delete vm.alertConfigurationHeader.ownerOrganisation;
        	delete vm.alertConfigurationHeader.creatorOrganisation;
        	
        	vm.alertConfigurationDTO.alertConfigurationHeader=vm.alertConfigurationHeader;
        	var alertConfigurationNotifyUserDetails=[];
        	alertConfigurationNotifyUserDetails=Array.from(vm.alertConfigurationNotifyUserDetails);
        	var alertConfigurationNotifyByTypeDetails=[];
        	alertConfigurationNotifyByTypeDetails=Array.from(vm.alertConfigurationNotifyByTypeDetails);
       		
        	vm.alertConfigurationDTO.alertConfigurationNotifyUserDetails=alertConfigurationNotifyUserDetails;       		
        	vm.alertConfigurationDTO.alertConfigurationNotifyByTypeDetails=alertConfigurationNotifyByTypeDetails; 
        	vm.alertConfigurationDTO.organisationDTO = OrganisationManipulation.checkAndGetOrganisationDTO(vm.ownerOrganisation);
        	
        }
        
       function onSaveSuccess (result) {
    	  $scope.$emit('alertRefresh');
       	 $uibModalInstance.close(result);  
       }

       function onSaveError () {
       	
       }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('AlertConfigurationDialogController', AlertConfigurationDialogController);

    AlertConfigurationDialogController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','$uibModalInstance','AlertConfiguration','entity', 'OrganisationManipulation', 'ScreenLog'];

     function AlertConfigurationDialogController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance,AlertConfiguration,entity, OrganisationManipulation, ScreenLog) {
        var vm = this;
        //vm.alertConfigurationHeader=entity;
        vm.configNotifyUsersBy = 'users';
        vm.screenName = 'AlertConfiguration';
        vm.screenLog = ScreenLog;
        vm.resubmit=resubmit;
        //ScreenLog.screenLog({'entityName': 'AlertConfiguration', 'entityRecordId': 0, 'action': 'ADD'});

        vm.alertConfigurationDTO={};
        //vm.alertConfigurationHeader={};
        vm.alertConfigurationNotifyUserDetails = [];
        vm.alertConfigurationNotifyByTypeDetails = [];
        vm.eventTypes = AlertConfiguration.getEventTypes();
        vm.reminderTypes = AlertConfiguration.getReminderTypes();
        vm.notifyByTypes = AlertConfiguration.getNotifyByTypes();
        vm.notifyByTypesForAllAlerts =vm.notifyByTypes;
        vm.notificationTypes = AlertConfiguration.getNotificationTypes();
        vm.natureReminderMapping = AlertConfiguration.getNatureReminderMapping();
        vm.creatorOrganisation = GlobalValues.getUserOrganisation()
        vm.ownerOrganisation = GlobalValues.getOrganisation();
        
        vm.users = AlertConfiguration.getUsersForOrganisation();

        vm.roles = AlertConfiguration.getRolesForOrganisation({"orgId" : GlobalValues.getOrganisation().id});
        vm.clear=clear;
        vm.save=save;
        $scope.clicked=false;
        $scope.showButton = false;

        if(entity!=null){
        	vm.alertConfigurationHeader=entity;
        	vm.alertConfigurationHeader.alertConfigurationNotifyUserDetails=[];
        	vm.alertConfigurationHeader.alertConfigurationNotifyByTypeDetails=[];
        	
        	vm.alertConfigurationHeader.alertConfigurationNotifyUserDetails=vm.alertConfigurationHeader.alertConfigurationNotifyUserDetails;
        	vm.alertConfigurationHeader.alertConfigurationNotifyByTypeDetails=vm.alertConfigurationHeader.alertConfigurationNotifyByTypeDetails;

        }
        else {
        	vm.alertConfigurationHeaderDTO =  angular.fromJson($rootScope.payload); 
        	vm.alertConfigurationHeader=vm.alertConfigurationHeaderDTO.alertConfigurationHeader;
        	vm.configNotifyUsersBy=vm.alertConfigurationHeader.configNotifyUsersBy;
        	// console.log(vm.alertConfigurationHeaderDTO);
            var notifyByTypeDetailsArr=vm.alertConfigurationHeaderDTO.alertConfigurationNotifyByTypeDetails;
            vm.notifyByTypeList=[];
            angular.forEach(notifyByTypeDetailsArr, function(value, key) 
            {
            	if (value.active==true){
                	vm.notifyByTypeList.push(value.notifyByType.id);
            	}
             });
            
            var notifyUserDetailsArr=vm.alertConfigurationHeaderDTO.alertConfigurationNotifyUserDetails;
            vm.userList=[];
            vm.roleList=[];
            angular.forEach(notifyUserDetailsArr, function(value, key) 
            {
            	if(value.active==true){
            		if (vm.alertConfigurationHeader.configNotifyUsersBy == 'users'){
                    	vm.userList.push(value.user.id);
            		}else{
                    	vm.roleList.push(value.organisationRole.id);
            		}
            	}
            });
            $scope.showButton=false;
        }
        
        if(workflowSharedService.viewFrom == 'alert_configuration_resubmit') {
        	var entityRecordId = 0;
        	if(vm.alertConfigurationHeader.id!=null){
        		entityRecordId = vm.alertConfigurationHeader.id;
        	}
        	vm.screenLog.screenLog(vm.screenName, entityRecordId, 'RESUBMIT');

            $scope.disableControl = true;
            vm.disableForm = false;
        	$scope.showButton=true;
        }else if(workflowSharedService.viewFrom == 'alert_configuration_resubmit_delete'){
            vm.disableForm = true;
        	$scope.showButton=true;
        }
        
        if(vm.alertConfigurationHeaderDTO==null){
        	$scope.disableControl = false;
        }
        
        
        vm.getEventTypes = function getEventTypes(notificationType){
        	if(notificationType!=null){
            	vm.eventTypesForNotificationType = null;
            	var as = $(vm.eventTypes)
    	        .filter(function (i,n){
    	            return (n.notificationType.id == notificationType.id);
    	        })
    			if (Object.keys(as).length > 3){
    	        	vm.eventTypesForNotificationType = as;
    			}
        	}
        }

        vm.getReminderTypes = function getReminderTypes(eventType){
        	if(eventType!=null){
            	vm.reminderTypesForEvent = null;
            	var reminderTypesForEventType = [];
            	var as = $(vm.natureReminderMapping)
    	        .filter(function (i,n){
    	            return (n.nature == eventType.nature);
    	        })
            	vm.reminderTypeForEvent = as;
            	if(vm.reminderTypeForEvent.length>0){
                	angular.forEach(vm.reminderTypeForEvent, function(item){
                		reminderTypesForEventType.push(item.reminderType);
                	})
                	vm.reminderTypesForEventType = reminderTypesForEventType;
            	}
        	}
        }

        vm.getNotifyByTypesForAlert = function getNotifyByTypesForAlert(alertType){
        	if(alertType != null){
        		vm.notifyByTypesForAlert = null;
        		        		
        		if(alertType.shortName == 'Upload Error Alert'){
                	var as = $(vm.notifyByTypesForAllAlerts)
        	        .filter(function (i,n){
        	            return (n.shortName == 'Email');
        	        })
                	vm.notifyByTypesForAlert = as;
                	
                	vm.notifyByTypes = vm.notifyByTypesForAlert;
        		}else{
        	        vm.notifyByTypes = vm.notifyByTypesForAllAlerts;
        		}
        	}
        } 
        
        vm.getNotifyByTypes = function getNotifyByTypes(selectedNotifyByList, notifyByType){
        	if (selectedNotifyByList.length==1 && notifyByType.shortName=='Email'){
            	var notifyByList = [];
            	notifyByList = selectedNotifyByList;
            	var as = $(vm.notifyByTypes)
    	        .filter(function (i,n){
    	            return (n.shortName == 'On app');
    	        })
    	        vm.OnAppNotifyByType = as;
            	if (vm.OnAppNotifyByType!=null){
                	if (selectedNotifyByList[0] != vm.OnAppNotifyByType[0].id){
                    	notifyByList.push(vm.OnAppNotifyByType[0].id);
                    	vm.notifyByList = notifyByList;
                	}
            	}
        	}
        }
        
        vm.clearNotifyByTypes = function clearNotifyByTypes(){
        	vm.notifyByTypeList = '';
        } 
        
        vm.flag = 0;
        vm.branchId = 0;
        vm.getUsers = function getUsers(branch){
        	if ((branch!=null && vm.flag==0) || (vm.branchId != 0 && vm.branchId != branch.id)){

        		vm.users = AlertConfiguration.getUserBranchClearances({"branchId":branch.id});
            	vm.branchId = branch.id;
            	vm.flag=1;

        	}
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        

        function save()
        {
        	vm.alertConfigurationHeader.configNotifyUsersBy = vm.configNotifyUsersBy;
        	addAlertConfigurationNotifyUserDetails();
        	
        	addAlertConfigurationNotifyByTypeDetails();
        	
        	prepareAlertConfigurationDTOToSave();
        	// console.log(vm.alertConfigurationHeader.id);
        	if(vm.alertConfigurationHeader.id!=null)
        		AlertConfiguration.update({"orgId":GlobalValues.getUserOrganisation().id}, vm.alertConfigurationDTO, onSaveSuccess, onSaveError);   
        	else
        		AlertConfiguration.save({"orgId":GlobalValues.getUserOrganisation().id}, vm.alertConfigurationDTO, onSaveSuccess, onSaveError);      		
        }
     
        function addAlertConfigurationNotifyUserDetails(){
        	if(vm.alertConfigurationHeader.configNotifyUsersBy=='users'){
            	for (var j=0; j<=vm.userList.length-1; j++){
            		if (vm.userList[j]!=null){
                		vm.filteredNotifyUser={};
                    	var as = $(vm.users)
            	        .filter(function (i,n){
            	            return (n.id == vm.userList[j]);
            	        })
            	        vm.filteredNotifyUser = as;
                		vm.alertConfigurationNotifyUserDetails.push({
                				"user":{"id":vm.filteredNotifyUser[0].id,"login":vm.filteredNotifyUser[0].login,"firstName":vm.filteredNotifyUser[0].firstName,"lastName":vm.filteredNotifyUser[0].lastName,"email":vm.filteredNotifyUser[0].email,"activated":vm.filteredNotifyUser[0].active,"langKey":vm.filteredNotifyUser[0].langKey,"resetKey":vm.filteredNotifyUser[0].resetKey,"mobileCountryCode":vm.filteredNotifyUser[0].mobileCountryCode,"mobile":vm.filteredNotifyUser[0].mobile,"userType":vm.filteredNotifyUser[0].userType,"resetDate":vm.filteredNotifyUser[0].resetDate,"active":vm.filteredNotifyUser[0].active},
                    			"organisationRole": null
                    	});
            		}
            	}
        	}
        	else{
            	for (var j=0; j<=vm.roleList.length-1; j++){
            		if (vm.roleList[j]!=null){
                		vm.filteredNotifyRole={};
                    	var as = $(vm.roles)
            	        .filter(function (i,n){
            	            return (n.id == vm.roleList[j]);
            	        })
            	        vm.filteredNotifyRole = as;
                		vm.alertConfigurationNotifyUserDetails.push({
            				"user":null,
                			"organisationRole": {"id":vm.filteredNotifyRole[0].id,"active":vm.filteredNotifyRole[0].active,"systemGenerated":vm.filteredNotifyRole[0].systemGenerated,"shortName":vm.filteredNotifyRole[0].shortName,"name":vm.filteredNotifyRole[0].name,"objectType":vm.filteredNotifyRole[0].objectType}
                		});
            		}
            	}
        	}
        }
        
        function addAlertConfigurationNotifyByTypeDetails(){
        	vm.notifyByType=[];
        	for (var j=0; j<=vm.notifyByTypeList.length-1; j++){
        		vm.filteredNotifyByType={};
            	var as = $(vm.notifyByTypes)
    	        .filter(function (i,n){
    	            return (n.id == vm.notifyByTypeList[j]);
    	        })
    	        vm.filteredNotifyByType = as;
            	vm.alertConfigurationNotifyByTypeDetails.push({
    			'notifyByType': vm.filteredNotifyByType[0]
    			});
        	}
        }
        
        function prepareAlertConfigurationDTOToSave(){
        	if (vm.alertConfigurationHeader.numberOfDaysToNotify == null || vm.alertConfigurationHeader.numberOfDaysToNotify == ""){
        		vm.alertConfigurationHeader.numberOfDaysToNotify = 0;
        	}
        	
        	vm.alertConfigurationDTO.alertConfigurationHeader=vm.alertConfigurationHeader;
        	var alertConfigurationNotifyUserDetails=[];
        	alertConfigurationNotifyUserDetails=Array.from(vm.alertConfigurationNotifyUserDetails);
        	var alertConfigurationNotifyByTypeDetails=[];
        	alertConfigurationNotifyByTypeDetails=Array.from(vm.alertConfigurationNotifyByTypeDetails);
       		
        	vm.alertConfigurationDTO.alertConfigurationNotifyUserDetails=alertConfigurationNotifyUserDetails;       		
        	vm.alertConfigurationDTO.alertConfigurationNotifyByTypeDetails=alertConfigurationNotifyByTypeDetails; 
        	vm.alertConfigurationDTO.organisationDTO = OrganisationManipulation.checkAndGetOrganisationDTO(vm.ownerOrganisation);
        }
        
        function onSaveSuccess (result) {
        	 $scope.$emit('alertRefresh');
        	 $uibModalInstance.close(result);  
        }

        function onSaveError () {
        	
        }

        function resubmit() {
        	vm.alertConfigurationHeader.configNotifyUsersBy = vm.configNotifyUsersBy;
        	addAlertConfigurationNotifyUserDetails();
        	
        	addAlertConfigurationNotifyByTypeDetails();
        	
        	prepareAlertConfigurationDTOToSave();
        	AlertConfiguration.resubmit({"taskId" : $rootScope.taskID}, vm.alertConfigurationDTO, onResubmitSuccess, onResubmitError);
			$uibModalInstance.dismiss('cancel');
		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
		}
		function onResubmitError(error) {
		}
     }   
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('AlertConfigurationDeleteController',AlertConfigurationDeleteController);

    AlertConfigurationDeleteController.$inject = ['$uibModalInstance', 'entity', 'AlertConfiguration', 'GlobalValues', 'OrganisationManipulation', '$scope', 'ScreenLog'];

    function AlertConfigurationDeleteController($uibModalInstance, entity, AlertConfiguration, GlobalValues, OrganisationManipulation, $scope, ScreenLog) {
        var vm = this;

        vm.alertConfigurationHeader = entity;
        //ScreenLog.screenLog({'entityName': 'AlertConfiguration', 'entityRecordId': vm.alertConfigurationHeader.id, 'action': 'DELETE'});
        var notifyByTypeDetailsArr=vm.alertConfigurationHeader.alertConfigurationNotifyByTypeDetails;
        vm.notifyByTypeList=[];
        var alertConfigurationNotifyByTypeDetails = [];
        angular.forEach(notifyByTypeDetailsArr, function(value, key) 
        {
        	if (value.active==true){
            	//vm.notifyByTypeList.push(value.notifyByType.id);
            	alertConfigurationNotifyByTypeDetails.push({
        			'notifyByType': value.notifyByType
        			});
        	}
         });
        
        var notifyUserDetailsArr=vm.alertConfigurationHeader.alertConfigurationNotifyUserDetails;
        vm.userList=[];
        vm.roleList=[];
        var alertConfigurationNotifyUserDetails = []
        angular.forEach(notifyUserDetailsArr, function(value, key) 
        {
        	if(value.active==true){
        		if (vm.alertConfigurationHeader.configNotifyUsersBy == 'users'){
                	//vm.userList.push(value.user.id);
        			alertConfigurationNotifyUserDetails.push({
        				"user":{"id":value.user.id,"login":value.user.login,"firstName":value.user.firstName,"lastName":value.user.lastName,"email":value.user.email,"activated":value.user.active,"langKey":value.user.langKey,"resetKey":value.user.resetKey,"mobileCountryCode":value.user.mobileCountryCode,"mobile":value.user.mobile,"userType":value.user.userType,"resetDate":value.user.resetDate,"active":value.user.active},
            			"organisationRole": null
            	});
        		}else{
                	//vm.roleList.push(value.organisationRole.id);
        			alertConfigurationNotifyUserDetails.push({
        				"user":null,
            			"organisationRole": {"id":value.organisationRole.id,"active":value.organisationRole.active,"systemGenerated":value.organisationRole.systemGenerated,"shortName":value.organisationRole.shortName,"name":value.organisationRole.name,"objectType":value.organisationRole.objectType}
            		});
        		}
        	}
        });

        vm.clear = clear;
        vm.alertConfigurationDTO = {};
        vm.ownerOrganisation = GlobalValues.getOrganisation();
        //vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.confirmDelete = function confirmDelete() {
        	prepareAlertConfigurationDTOToUpdate();
        	//alert(vm.Member.id);
        	AlertConfiguration.delete({"orgId":GlobalValues.getUserOrganisation().id}, vm.alertConfigurationDTO,
                function () {
        		 	$scope.$emit('alertRefresh');
                    $uibModalInstance.close(true);
                });
        }
        
        function prepareAlertConfigurationDTOToUpdate(){
        	
        	vm.alertConfigurationHeader.alertConfigurationNotifyUserDetails=[];
        	vm.alertConfigurationHeader.alertConfigurationNotifyByTypeDetails=[];

        	delete vm.alertConfigurationHeader.ownerOrganisation;
        	delete vm.alertConfigurationHeader.creatorOrganisation;
        	vm.alertConfigurationDTO.alertConfigurationHeader=vm.alertConfigurationHeader;
        	vm.alertConfigurationDTO.alertConfigurationNotifyUserDetails=alertConfigurationNotifyUserDetails;       		
        	vm.alertConfigurationDTO.alertConfigurationNotifyByTypeDetails=alertConfigurationNotifyByTypeDetails; 
        	vm.alertConfigurationDTO.organisationDTO = OrganisationManipulation.checkAndGetOrganisationDTO(vm.ownerOrganisation);
        	
        }
        
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('alert-configuration', {
            parent: 'entity',
            url: '/alert-configuration',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.alertConfiguration.alertConfiguration" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/alert-configuration/alert-configuration.html',
                    controller: 'AlertConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('alertconfiguration');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('alert-configuration.new', {
            parent: 'alert-configuration',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/alert-configuration/alert-configuration-dialog.html',
                    controller: 'AlertConfigurationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	 id:null,  
                            	name:null
                            	 
                            	
                             
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('alert-configuration', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('alert-configuration.edit', {
            parent: 'alert-configuration',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/alert-configuration/alert-configuration-edit-dialog.html',
                    controller: 'AlertConfigurationEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['AlertConfiguration', 'GlobalValues', function(AlertConfiguration, GlobalValues) {
                                     return AlertConfiguration.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('alert-configuration.view', {
            parent: 'alert-configuration',
            url: '/alertconfiguration/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/alert-configuration/alert-configuration-view-dialog.html',
                    controller: 'AlertConfigurationDetailsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    		translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('alertconfiguration');
                            return $translate.refresh();
                    		}],
                    		entity: ['AlertConfiguration', function(AlertConfiguration) {
                            return AlertConfiguration.get({id : $stateParams.id}).$promise;
                    		}],
                    		previousState: ["$state", function ($state) {
                            var currentStateData = {
                                name: $state.current.name || 'AlertConfiguration',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                            return currentStateData;
                    		}]
                    	}
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('alert-configuration.delete', {
            parent: 'alert-configuration',
            url: '/delete/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/alert-configuration/alert-configuration-delete-dialog.html',
                    controller: 'AlertConfigurationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AlertConfiguration', 'GlobalValues', function(AlertConfiguration, GlobalValues) {
                            return AlertConfiguration.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('alert-configuration-todolist', {
            parent: 'dashboard',
            url: '/alertconfigurationview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['GlobalValues','$stateParams', '$state', '$uibModal', function(GlobalValues,$stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/alert-configuration/alert-configuration-view-dialog.html',
                    controller: 'AlertConfigurationDetailsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {

                      	 entity: ['AlertConfiguration', function(AlertConfiguration) {
                             //return AlertConfiguration.get({id : $stateParams.id}).$promise;
                 		}],
                		previousState: ["$state", function ($state) {
                			var currentStateData = {
                			name: $state.current.name || 'AlertConfiguration',
                			params: $state.params,
                			url: $state.href($state.current.name, $state.params)
                			};
                			return currentStateData;
                		}]
                               	 
                   
                       }
                   }).result.then(function() {
                       $state.go('^', {}, { reload: true });
                   }, function() {
                       $state.go('^');
                   });
               }]
               
           })
           .state('alert-configuration-todolist.resubmit', {
            parent: 'dashboard',
            url: '/alertconfigurationresubmit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['GlobalValues','$stateParams', '$state', '$uibModal', function(GlobalValues,$stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/alert-configuration/alert-configuration-dialog.html',
                    controller: 'AlertConfigurationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {

                      	 entity: function() {
                      		//return AutoUpload.get({corpID: GlobalValues.getCorpId(),id : $stateParams.id}).$promise;
                           }
                               	 
                   
                       }
                   }).result.then(function() {
                       $state.go('alert-configuration', null, { reload: 'alert-configuration' });
                   }, function() {
                       $state.go('^');
                   });
               }]
               
           })
           .state('alert-configuration-auditLog', {
            parent: 'audit-log',
            url: '/alertconfigurationview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['GlobalValues','$stateParams', '$state', '$uibModal', function(GlobalValues,$stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/alert-configuration/alert-configuration-view-dialog.html',
                    controller: 'AlertConfigurationDetailsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {

                      	 entity: ['AlertConfiguration', function(AlertConfiguration) {
                             //return AlertConfiguration.get({id : $stateParams.id}).$promise;
                 		}],
                		previousState: ["$state", function ($state) {
                			var currentStateData = {
                			name: $state.current.name || 'AlertConfiguration',
                			params: $state.params,
                			url: $state.href($state.current.name, $state.params)
                			};
                			return currentStateData;
                		}]
                               	 
                   
                       }
                   }).result.then(function() {
                       $state.go('^', {}, { reload: true });
                   }, function() {
                       $state.go('^');
                   });
               }]
               
           })
            .state('alert-configuration-historyReport', {
            parent: 'history-report',
            url: '/alertconfigurationview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['GlobalValues','$stateParams', '$state', '$uibModal', function(GlobalValues,$stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/alert-configuration/alert-configuration-view-dialog.html',
                    controller: 'AlertConfigurationDetailsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {

                      	 entity: ['AlertConfiguration', function(AlertConfiguration) {
                             //return AlertConfiguration.get({id : $stateParams.id}).$promise;
                 		}],
                		previousState: ["$state", function ($state) {
                			var currentStateData = {
                			name: $state.current.name || 'AlertConfiguration',
                			params: $state.params,
                			url: $state.href($state.current.name, $state.params)
                			};
                			return currentStateData;
                		}]
                               	 
                   
                       }
                   }).result.then(function() {
                       $state.go('^', {}, { reload: true });
                   }, function() {
                       $state.go('^');
                   });
               }]
               
           })
        };
    })();
(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('AlertConfiguration', AlertConfiguration);

    AlertConfiguration.$inject = ['$resource'];

    function AlertConfiguration ($resource) {
        var resourceUrl =  'api/alertConfiguration/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                params: {orgId:'@orgId'},
                url: 'api/alertConfiguration/:orgId',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                }                
            },
            
            'getEventTypes': {
          	  method: 'GET',
          	  isArray: true,
          	  url: 'api/event-type'
             },

            'getUsersForOrganisation': {
             	  method: 'GET',
             	  isArray: true,
             	  url: 'api/users-for-organisation'
             },

             'getUserBranchClearances': {
            	  method: 'GET',
            	  isArray: true,
            	  params: {branchId:'@branchId'},
            	  url: 'api/branchId/:branchId/user-branch-clearances'
             },
             
            'getRolesForOrganisation': {
            	  method: 'GET',
            	  isArray: true,
            	  params: {orgId:'@orgId'},
            	  url: 'api/orgId/:orgId/rolesAllForOrganisation'
            },
             

            'getReminderTypes': {
             	  method: 'GET',
             	  isArray: true,
             	  url: 'api/reminder-type'
                },

            'getNotifyByTypes': {
               	  method: 'GET',
               	  isArray: true,
               	  url: 'api/notify-by-type'
              },
                

             'getNotificationTypes': {
            	  method: 'GET',
               	  isArray: true,
               	  url: 'api/notification-type'
              },
                  
              'getNatureReminderMapping': {
            	  method: 'GET',
               	  isArray: true,
               	  url: 'api/nature-reminder-mapping'
              },
              
           	'getAlertConfiguration':{
          	  method: 'GET',
        	  url: 'api/alertConfigurations',
          	  isArray:true,
              transformResponse: function (data) {
               if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
           	},
              
           	'getAlertConfigurationsByBranch':{
            	  method: 'GET',
            	  params: {branchId:'@branchId', orgId:'@orgId'},
            	  url: 'api/alert-configurations/branch/:branchId/org/:orgId',
            	  isArray:true,
            	  transformResponse: function (data) {
                 if (data) {
                          data = angular.fromJson(data);
                      }
                      return data;
                  }
             	},
                
            'update': {
            	method:'PUT',
            	params: {orgId:'@orgId'},
                url: 'api/alert-configuration-edit/:orgId',
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
            'delete': {
                method: 'PUT',
                params: {orgId:'@orgId'},
                url: 'api/alert-configuration-delete/:orgId',              
                    transformRequest: function (data) {
                       	var copy = angular.copy(data);
                       	
                           return angular.toJson(copy);
                       }
            },
            'approve': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
              	 method: 'GET',
                   params: {taskId:'@taskId'},
                   url: 'api/tasks/:taskId/discard'
             },
             'resubmit': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/resubmit/alert-configuration',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             }
             
       });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'alertConfiguration'
        })
        
        .controller('AlertConfigurationController', AlertConfigurationController);

    AlertConfigurationController.$inject = ['$scope', '$state', 'workflowSharedService', 'AlertConfiguration', 'GlobalValues', 'EntityPermissions', '$rootScope', 'ScreenLog'];

    function AlertConfigurationController($scope, $state, workflowSharedService, AlertConfiguration, GlobalValues, EntityPermissions, $rootScope, ScreenLog) {
        var vm = this;
        vm.screenName = 'AlertConfiguration';
        vm.screenLog = ScreenLog;
        //workflowSharedService.viewFrom = "alertConfiguration";
        vm.launch=launch;
        function launch() {
        	$state.go("alert-configuration.new");
        }

        //ScreenLog.screenLog({'entityName': 'AlertConfiguration', 'entityRecordId': 0, 'action': 'ACCESS'});

        vm.permitAlertConfigurationEditEntityAction = EntityPermissions.hasPermission('AlertConfiguraion.EDIT')
        vm.permitAlertConfigurationCreateEntityAction = EntityPermissions.hasPermission('AlertConfiguraion.CREATE')
		vm.permitAlertConfigurationViewEntityAction = EntityPermissions.hasPermission('AlertConfiguraion.VIEW')
		vm.permitAlertConfigurationDeleteEntityAction = EntityPermissions.hasPermission('AlertConfiguraion.DELETE')


        loadAll();
        
        function loadAll() {
        	/*AlertConfiguration.query(function(result) {
                vm.alertConfigurationHeader = result;
               console.log(vm.alertConfigurationHeader);
            }); */   
        	
            /*AlertConfiguration.getAlertConfiguration(function(result){
                vm.alertConfigurationHeader = result;
            });*/
       }
        
        vm.getAlertConfigurationsByBranch = function getAlertConfigurations(branch){
        	if (branch!=null){
        		$rootScope.branch = branch;
                AlertConfiguration.getAlertConfigurationsByBranch({'branchId': branch.id, 'orgId':GlobalValues.getUserOrganisation().id}, function(result){
                    vm.alertConfigurationHeader = result;
                });
        	}
        }
        
        vm.getNotifyByTypes = function(alertDetails){
        	var notifyByTypeNames = '';
        	var alertNotifyByTypeDetailsArr = alertDetails.alertConfigurationNotifyByTypeDetails;
        	angular.forEach(alertNotifyByTypeDetailsArr, function(value,key)
        			{
        			if (notifyByTypeNames==''){
        				notifyByTypeNames = value.notifyByType.longName;
        			}
        			else
        			{
        				notifyByTypeNames = notifyByTypeNames + ", " + value.notifyByType.longName;
        			}
        		})
        	return (notifyByTypeNames);
        }
        
        $rootScope.$on('alertRefresh', function(event, result) {
        	vm.branch = $rootScope.branch;
        	
        	if($rootScope.branch != null)
        		vm.getAlertConfigurationsByBranch(vm.branch); 
        });
        
        /*vm.screenLog = function screenLog(entityRecordId,action){
        	ScreenLog.screenLog({'entityName': 'AlertConfiguration', 'entityRecordId': entityRecordId, 'action': action});
        }*/
    }
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" style="word-wrap:normal;" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" style="word-wrap:normal;" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert  class="alert-directive" ng-cloak="" type="{{alert.type}}" ><span style="word-wrap:normal;">{{ alert.msg }}</span></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('gatewayApp')
        .component('nmbAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('gatewayApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;
                
            case 503: 
            	 addErrorAlert('Service not available','error.http.503');
                 break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('gatewayApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;
            case 403: 
           	 	addErrorAlert('You are not authorised to access this page','error.http.403');
                break;    
            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;
            case 429:
                addErrorAlert('error.http.429','Too many requests - try again later.');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
        
        var errorMessageEvent = $rootScope.$on('errorMessage', function(event, result) {
        	addErrorAlert(result);
      });
        
      $scope.$on('$destroy', function() {
    	  errorMessageEvent();	        	
      });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" style="word-wrap:break-word;" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" style="word-wrap:break-word;" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" class="alert-directive"  ><span style="word-wrap:break-word" ng-bind-html="alert.msg"></span></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('gatewayApp')
        .component('nmbAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

angular.module('gatewayApp').filter('capitalizeFirst', function () {
    return function (input) {
        if (!input) return '';
        input = input.toLowerCase();
        return input.charAt(0).toUpperCase() + input.slice(1);
    };
});
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && response.status === 403 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('gatewayApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage', 'GlobalValues'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage, GlobalValues) {
        var service = {
            responseError: responseError
        };

        return service;

        $rootScope.sessionExpired = false;
        function responseError(response) {
            if (response.status === 401 || response.status === 403 || response.status === 503) {
            	var messageBox = $injector.get('MessageBox');
            	if(!$rootScope.sessionExpired){
                    delete $localStorage.authenticationToken;
                    delete $sessionStorage.authenticationToken;
                    var Principal = $injector.get('Principal');
                    if (Principal.isAuthenticated()) {
                    	$rootScope.sessionExpired = true;
                    	if(response.status === 503){
                        	messageBox.openMessageBox('Alert', 'Throttling limit is execeeded. Kindly re-login after some time...!', 'Ok', 'throttlinglimitbreached');
                    	}else{
                        	messageBox.openMessageBox('Alert', 'Session expired. You will be redirected to login page...!', 'Ok', 'sessionexpired');
                    	}
                        /*var Auth = $injector.get('Auth');
                        Auth.authorize(true);*/
                    }
            	}
            }
            $rootScope.$on('gatewayApp.messagebox.ok.sessionexpired', function (event) {
            	var Auth = $injector.get('Auth');
            	var Account = $injector.get('Account');
            	var WebSocket = $injector.get('WebSocket');
            	GlobalValues.clearPreviousValues();
            	WebSocket.disconnecteWebSocket(true);
            	Account.logout();
                Auth.authorize(true);
                $rootScope.sessionExpired = true;
                $injector.get('$uibModalStack').dismissAll();
                $injector.get('$state').go('login', null, {reload:'login'});
                window.location.reload();
            });
            
            $rootScope.$on('gatewayApp.messagebox.clear.sessionexpired', function (result){
            	var Auth = $injector.get('Auth');
            	var Account = $injector.get('Account');
            	var WebSocket = $injector.get('WebSocket');
            	GlobalValues.clearPreviousValues();
            	WebSocket.disconnecteWebSocket(true);
            	Account.logout();
                Auth.authorize(true);
                $rootScope.sessionExpired = true;
                $injector.get('$uibModalStack').dismissAll();
                $injector.get('$state').go('login', null, {reload:'login'});
                window.location.reload();
            })
            
            $rootScope.$on('gatewayApp.messagebox.ok.throttlinglimitbreached', function (event) {
            	var Auth = $injector.get('Auth');
            	var Account = $injector.get('Account');
            	var WebSocket = $injector.get('WebSocket');
            	GlobalValues.clearPreviousValues();
            	WebSocket.disconnecteWebSocket(true);
            	Account.logout();
                Auth.authorize(true);
                $rootScope.sessionExpired = true;
                $injector.get('$uibModalStack').dismissAll();
                $injector.get('$state').go('login', null, {reload:'login'});
                //setTimeout (window.close, 5000);
            });
            
            $rootScope.$on('gatewayApp.messagebox.clear.throttlinglimitbreached', function (result){
            	var Auth = $injector.get('Auth');
            	var Account = $injector.get('Account');
            	var WebSocket = $injector.get('WebSocket');
            	GlobalValues.clearPreviousValues();
            	WebSocket.disconnecteWebSocket(true);
            	Account.logout();
                Auth.authorize(true);
                $rootScope.sessionExpired = true;
                $injector.get('$uibModalStack').dismissAll();
                $injector.get('$state').go('login', null, {reload:'login'});
                //setTimeout (window.close, 5000);
            })
            
            return $q.reject(response);
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage', 'GlobalValues'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage, GlobalValues) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            if (!config || !config.url || /^http/.test(config.url)) return config;

            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            if(!isInvalid(GlobalValues.getUser())){
                config.headers.guid = constructGuid();
            }
            return config;
        }
            
        function isInvalid(object) {
        	return object == undefined || object == null || !angular.isObject(object);
        }

        //Generate GUID for each request and append with the user id
        function constructGuid(){
            return GlobalValues.getUser().id + '_' + generateGuid();
        }

        //Generate GUID
        function generateGuid(){
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {  
                var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);  
                return v.toString(16);  
             }); 
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }


        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION', 'EntityPermissions', 'ObjectUtils', 'StringUtils','MessageBox','Account'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION, EntityPermissions, ObjectUtils, StringUtils,MessageBox,Account) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // validate screen parameter if available
                if (toStateParams) { 
                    var hasAccess =  getStateHasAccess(toStateParams);
                    
                    // no access permissions for the screen then move to login screen
                    if(!hasAccess){
                        event.preventDefault(); 
                       // $state.go('accessdenied');
                        MessageBox.openMessageBox('Alert', 'Session expired. You will be redirected to login page...!', 'Ok', 'unAthuAccess');
                        return; 
                    }
                }
                $rootScope.$on('gatewayApp.messagebox.ok.unAthuAccess', function (event) {
                    Auth.sessionlogout();
                });

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }

        /**
         * get state has Access
         * @param {object} stateParams 
         * @returns 
         */
         function getStateHasAccess(stateParams) {
            var hasAccess= true;

            //get Screen name and action from the parameter
            var screen = getScreenParam(stateParams);
            var action = getActionParam(stateParams);

            //default screen access is true, if the screen required access then check the access and assign it
            if (!StringUtils.isBlank(action) && !StringUtils.isBlank(screen)) {
                
                var returnValue = EntityPermissions.hasScreenActionPermissionPromise(screen, action);
                if(!angular.isUndefined(returnValue) && !angular.isUndefined(returnValue.then)){
                    returnValue.then(function(result){
                        var access=EntityPermissions.hasScreenActionPermission(screen, action);
                        if(!access){
                            $state.go('accessdenied');
                        };
                    })
                }
                else{
                    hasAccess = returnValue;
                }
            } else if (!StringUtils.isBlank(screen)) {
    
                var returnValue = EntityPermissions.hasPermissionPromise(screen);
                if(!angular.isUndefined(returnValue) && !angular.isUndefined(returnValue.then)){
                    returnValue.then(function(result){
                        var access=EntityPermissions.hasPermission(screen);
                        if(!access){
                            $state.go('accessdenied');
                        };
                    })
                }
                else{
                    hasAccess = returnValue;
                }
            }
            return hasAccess;  
        }

        /**
         * Get screen name parameter
         */
        function getScreenParam(stateParams){
           var screenParam = screenParam = ObjectUtils.valueOf(stateParams, 'screen');
           return screenParam;
        }

        /**
         * Get action name parameter
         */
        function getActionParam(stateParams){
            var actionParam = ObjectUtils.valueOf(stateParams, 'action');
            return actionParam; 
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', 'BUILD_TIMESTAMP'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider, BUILD_TIMESTAMP) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json' + (BUILD_TIMESTAMP ? '?build=' + BUILD_TIMESTAMP : '')
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('customer-registration');
                }]
            }
        });
    }
})();

(function() {
	'use strict';
	angular
		.module('gatewayApp')
		.factory('AppLookup', AppLookup);

	AppLookup.$inject = [ 'GlobalValues', '$rootScope', '$sessionStorage', 'Role', 'Branch','OrganisationType',
	'CustomerUserType','GlobalOrganisationTypeRole','BankRegistration', 'Country', 'StaticLookUp', 
	'CustomerRegistration', 'User', 'CustomerBankRelationshipReport', 'SecurityPolicy', 'ApprovalPolicy','DefaultMarket'];

	function AppLookup(GlobalValues, $rootScope, $sessionStorage, Role, Branch,OrganisationType,
		CustomerUserType,GlobalOrganisationTypeRole,BankRegistration, Country, StaticLookUp, 
		CustomerRegistration, User, CustomerBankRelationshipReport, SecurityPolicy, ApprovalPolicy,DefaultMarket) {

		var  onSuccess = function onSuccess(data) {
			$rootScope.$emit('gatewayApp:loadLookupComplete', data);
		}

		var onFailure = function onFailure() {
		}
		
		return {
			getLookupValue : function(lookupName, filterValue) {
				if ($sessionStorage.isAuth == true) {
					var returnValue = null;
					var filters = filterValue.split("~~");

					if (lookupName == "currency") {
						//returnValue = Currency.query();
						returnValue = StaticLookUp.getCurrency();
					} else if(lookupName == "organisationType"){
						returnValue = OrganisationType.query();
					} else if(lookupName == "customerUserType"){
						returnValue = CustomerUserType.query();
					} else if (lookupName == "country") {
						returnValue = Country.query();
					} else if (lookupName == "bank") {
						returnValue = BankRegistration.getBankLookup();
					} else if (lookupName == "bankWithStatus") {
						returnValue = BankRegistration.getBankLookupWithStatus();
					} else if (lookupName == "bankDetails") {
						returnValue = CustomerRegistration.getBankDetails();
					} else if (lookupName == "homeBranch") {
						if(filters[0] != "" && filters[0] != undefined){
							returnValue = StaticLookUp.getHomeBranchDetails({filterText: filters[0]}, onGetSuccess, onGetFailure);
						}
					} 
					/*else if (lookupName == "branch") {
						returnValue = Branch.query();
					}*/ 
					else if (lookupName == "state") {
						if(filters[0] != "" && filters[0] != undefined){
							returnValue = StaticLookUp.getStatesForCountry({countryId: filters[0]});	
						}
					} else if (lookupName == "entityOwnerType") {
						returnValue = StaticLookUp.getEntityOwnerTypes();
					} else if (lookupName == "entityOwnerTypeByOrganisationType") {
						returnValue = StaticLookUp.getEntityOwnerTypesForOrganisationType({ "organisationTypeId": GlobalValues.getOrganisation().organisationType.id });
			        } else if (lookupName == "entityOwnerTypeByUserEntityOwnerType") {
						returnValue = StaticLookUp.getEntityOwnerTypesForUserEntityOwnerType({ "entityOwnerTypeId": GlobalValues.getEntityOwnerType().id });
			        } else if (lookupName == "clearanceOrganisation") {
						returnValue = Corporate.getAllClearanceOrganisations();
					} else if (lookupName == "organisation") {
						returnValue = [];
						returnValue.push(GlobalValues.getOrganisation());
					} else if (lookupName == "Role") {
						if (filters[0] != "") {
							returnValue = Role.rolesAllForOrganisation({
								orgId : filters[0]
							});
						}
					} else if (lookupName == "theme") {
						if (filters[0] != "") {
							returnValue = SecurityPolicy.themesForOrganisation({
								orgId : filters[0]
							});
						}
					} else if (lookupName == "policy") {
						if (filters[0] != "") {
							returnValue = ApprovalPolicy.getAllApprovalPolicy({
								orgId : filters[0]
							});
						}
					} else if (lookupName == "actionsForOrgAndPolicy") {
						if (filters[0] != "" && filters[1] != "") {
							returnValue = ApprovalPolicy.actionsForOrgAndPolicy({
								orgId : filters[0], policyId : filters[1]
							});
						}
					}  else if (lookupName == "actionsForOrgAndTheme") {
						if (filters[0] != "" && filters[1] != "") {
							returnValue = SecurityPolicy.actionsForOrgAndTheme({
								orgId : filters[0], themeId : filters[1]
							});
						}
					}  else if (lookupName == "GlobalRole") {
						if (filters[0] != "") {
							if(filters[1]==undefined || filters[1]==""){
								filters[1] = 0;
							}
							returnValue = GlobalOrganisationTypeRole.rolesAllForOrganisationType({
								orgTypeId : filters[0],
								custUserTypeId : filters[1]
							});
						}
					} else if (lookupName == "organisationForApprovalPolicy") {
						if (filters[0] != "") {
							filters[0] = angular.fromJson(filters[0]);
							returnValue = [];
							returnValue
									.push(GlobalValues.getUserOrganisation());
							if (GlobalValues.getUserOrganisation().id != filters[0].id) {
								returnValue.push(filters[0]);
							}
							
						}
					} else if (lookupName == "organisationTypesForApprovalPolicy") {
						if (filters[0] != "") {
							filters[0] = angular.fromJson(filters[0]);
							returnValue = [];
							returnValue.push(filters[0]);
						}
					}else if(lookupName == "branch"){
						if (filters[0] != "") {
							returnValue = Branch.getAllBranchesLookupForBank({
								bankId : filters[0]
							});
						}
					}else if(lookupName == "branchWithStatus"){
						if (filters[0] != "") {
							returnValue = Branch.getAllBranchesLookupWithStatusForBank({
								bankId : filters[0]
							});
						}
					}else if(lookupName == "activeBranch"){
						if (filters[0] != "") {
							returnValue = Branch.getAllActiveBranchesLookupForBank({
								bankId : filters[0]
							});
						}
					}
					else if (lookupName == "allBranches") {
						returnValue = Branch.getBranchLookup();
					}
					else if (lookupName == "customersForBranch") {
						if(filters[0]!=""){
							returnValue = CustomerRegistration.getAllCustomersForBranch({"branchId": filters[0]});
						}
					}
					else if(lookupName == "branchesForBank"){
						if (filters[0] != "") {
							returnValue = Branch.getAllBranchesLookupForBank({ "bankId": filters[0] }, onSuccess, onFailure);
						}else if(GlobalValues.getOrganisation().organisationType.shortName=="BANK"){
							returnValue = Branch.getAllBranchesLookupForBank({ "bankId": GlobalValues.getOrgId() }, onSuccess, onFailure);
						}
					}
					else if(lookupName == "activeBranchesForBank"){
						if (filters[0] != "") {
							returnValue = Branch.getAllActiveBranchesLookupForBank({ "bankId": filters[0] }, onSuccess, onFailure);
						}else if(GlobalValues.getOrganisation().organisationType.shortName=="BANK"){
							returnValue = Branch.getAllActiveBranchesLookupForBank({ "bankId": GlobalValues.getOrgId() }, onSuccess, onFailure);
						}
					}
					else if(lookupName == "customerType"){
						returnValue = StaticLookUp.getCustomerTypes();
					} else if(lookupName == "AllCustomerTypes"){
						returnValue = StaticLookUp.getAllCustomerTypes();
					} else if(lookupName == "customer"){
						if(filters[0]!="" && filters[1]!=""){
							returnValue = CustomerRegistration.getCustomersForBranch({"bankId": filters[0], "branchId":filters[1],"customerType":filters[2]});
						}
						else if(filters[0]=="" && filters[1]!=""){
							returnValue = CustomerRegistration.getCustomersForBranch({"bankId": GlobalValues.getOrgId(), "branchId":filters[1],"customerType":filters[2]});
						}
						else if(filters[0]=="" && filters[1]=="" && filters[2] != "" && GlobalValues.getBranch()!=null){
							returnValue = CustomerRegistration.getCustomersForBranch({"bankId": GlobalValues.getOrgId(), "branchId":GlobalValues.getBranch().id,"customerType":filters[2]});
						}
						else if(filters[0]!="" && filters[1]=="" && filters[2] != "" && GlobalValues.getBranch()==null){
							returnValue = CustomerRegistration.getCustomersForBranch({"bankId": filters[0], "branchId":0,"customerType":filters[2]});
						}
					}else if(lookupName == "customerByEntityOwnerTypeShortName"){
						if(filters[0]!="" && filters[1]!=""){
							returnValue = CustomerRegistration.customerByEntityOwnerTypeShortName({"bankId": filters[0], "branchId":filters[1],"customerType":filters[2]});
						}
						else if(filters[0]=="" && filters[1]!=""){
							returnValue = CustomerRegistration.customerByEntityOwnerTypeShortName({"bankId": GlobalValues.getOrgId(), "branchId":filters[1],"customerType":filters[2]});
						}
						else if(filters[0]=="" && filters[1]=="" && filters[2] != "" && GlobalValues.getBranch()!=null){
							returnValue = CustomerRegistration.customerByEntityOwnerTypeShortName({"bankId": GlobalValues.getOrgId(), "branchId":GlobalValues.getBranch().id,"customerType":filters[2]});
						}
					} else if(lookupName == "user"){
						var userEntityOwnerType = GlobalValues.getEntityOwnerType().shortName;
						if(filters[0]!=""){
							if (filters[0]==userEntityOwnerType && userEntityOwnerType!="Branch"){
								returnValue = User.getUsersByOrganisationAndEntityOwnerType({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType});
							}else if (filters[0]==userEntityOwnerType && userEntityOwnerType=="Branch"){
								returnValue = User.getUsersForBranch({"branchId": GlobalValues.getBranch().id});
							}else if(userEntityOwnerType=="Clearcorp" && filters[0]=="Bank" && filters[1]!=""){
								returnValue = User.getUsersByOrganisationAndEntityOwnerType({"orgId": filters[1], entityOwnerType: 'Bank'});
							}else if((userEntityOwnerType=="Clearcorp" || userEntityOwnerType=="Bank") && filters[0]=="Branch" && filters[2]!=""){
								returnValue = User.getUsersForBranch({"branchId": filters[2]});
							}else if((userEntityOwnerType=="Clearcorp" || userEntityOwnerType=="Bank" || userEntityOwnerType=="Branch") && (filters[0]=="MultiUserCustomer" || filters[0]=="SingleUserCustomer") && filters[3]!=""){
								returnValue = User.getUsersByOrganisationAndEntityOwnerType({"orgId": filters[3], entityOwnerType: filters[0]});
							}
						}else if(userEntityOwnerType=="MultiUserCustomer" || userEntityOwnerType=="SingleUserCustomer"){
							returnValue = User.getUsersByOrganisationAndEntityOwnerType({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType});
						}
					}else if(lookupName == "allUsers"){
						var userEntityOwnerType = GlobalValues.getEntityOwnerType().shortName;
						if(filters[0]!=""){
							if (filters[0]==userEntityOwnerType && userEntityOwnerType!="Branch"){
								returnValue = User.getAllUsersByOrganisationAndEntityOwnerType({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType});
							}else if (filters[0]==userEntityOwnerType && userEntityOwnerType=="Branch"){
								returnValue = User.getAllUsersForBranch({"bankId":GlobalValues.getBankId(),"branchId": GlobalValues.getBranch().id});
							}else if(userEntityOwnerType=="Clearcorp" && filters[0]=="Bank" && filters[1]!=""){
								returnValue = User.getAllUsersByOrganisationAndEntityOwnerType({"orgId": filters[1], entityOwnerType: 'Bank'});
							}else if((userEntityOwnerType=="Clearcorp" || userEntityOwnerType=="Bank") && filters[0]=="Branch" && filters[2]!=""){
								returnValue = User.getAllUsersForBranch({"bankId":GlobalValues.getOrgId(),"branchId": filters[2]});
							}else if((userEntityOwnerType=="Clearcorp" || userEntityOwnerType=="Bank" || userEntityOwnerType=="Branch") && (filters[0]=="MultiUserCustomer" || filters[0]=="SingleUserCustomer") && filters[3]!=""){
								returnValue = User.getAllUsersByOrganisationAndEntityOwnerType({"orgId": filters[3], entityOwnerType: filters[0]});
							}
						}else if(userEntityOwnerType=="MultiUserCustomer" || userEntityOwnerType=="SingleUserCustomer"){
							returnValue = User.getAllUsersByOrganisationAndEntityOwnerType({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType});
						}else{
							returnValue=User.getAllUsersForOrganisation({"orgId": filters[3]});
						}
					}
					else if(lookupName == "userForRestriciton"){
						var userEntityOwnerType = GlobalValues.getEntityOwnerType().shortName;
						if(filters[0]!=""){
							if (filters[0]==userEntityOwnerType && userEntityOwnerType!="Branch"){
								returnValue = User.getUsersByOrganisationAndEntityOwnerTypeForRestriciton({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType});
							}else if (filters[0]==userEntityOwnerType && userEntityOwnerType=="Branch"){
								returnValue = User.getUsersForBranchRestriction({"branchId": GlobalValues.getBranch().id});
							}else if(userEntityOwnerType=="Clearcorp" && filters[0]=="Bank" && filters[1]!=""){
								returnValue = User.getUsersByOrganisationAndEntityOwnerTypeForRestriciton({"orgId": filters[1], entityOwnerType: 'Bank'});
							}else if((userEntityOwnerType=="Clearcorp" || userEntityOwnerType=="Bank") && filters[0]=="Branch" && filters[2]!=""){
								returnValue = User.getUsersForBranchRestriction({"branchId": filters[2]});
							}else if((userEntityOwnerType=="Clearcorp" || userEntityOwnerType=="Bank" || userEntityOwnerType=="Branch") && (filters[0]=="MultiUserCustomer" || filters[0]=="SingleUserCustomer") && filters[3]!=""){
								returnValue = User.getUsersByOrganisationAndEntityOwnerTypeForRestriciton({"orgId": filters[3], entityOwnerType: filters[0]});
							}
						}else if(userEntityOwnerType=="MultiUserCustomer" || userEntityOwnerType=="SingleUserCustomer"){
							returnValue = User.getUsersByOrganisationAndEntityOwnerTypeForRestriciton({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType});
						}else{
							returnValue=User.getUsersForOrganisationForRestriction({"orgId": filters[3]});
						}
					}else if(lookupName == "userForTurnOverReport"){
						var userEntityOwnerType = GlobalValues.getEntityOwnerType().shortName;
						if(filters[0]!=""){
							if (filters[0]==userEntityOwnerType && userEntityOwnerType!="Branch"){
								returnValue = User.getUsersByOrganisationAndEntityOwnerTypeTurnOverReport({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType});
							}else if (filters[0]==userEntityOwnerType && userEntityOwnerType=="Branch"){
								returnValue = User.getUsersForBranchTurnOverReport({"bankId":GlobalValues.getBankId(),"branchId": GlobalValues.getBranch().id});
							}else if(userEntityOwnerType=="Clearcorp" && filters[0]=="Bank" && filters[1]!=""){
								returnValue = User.getUsersByOrganisationAndEntityOwnerTypeTurnOverReport({"orgId": filters[1], entityOwnerType: 'Bank'});
							}else if((userEntityOwnerType=="Clearcorp" || userEntityOwnerType=="Bank") && filters[0]=="Branch" && filters[2]!=""){
								returnValue = User.getUsersForBranchTurnOverReport({"bankId":GlobalValues.getOrgId(),"branchId": filters[2]});
							}else if((userEntityOwnerType=="Clearcorp" || userEntityOwnerType=="Bank" || userEntityOwnerType=="Branch") && (filters[0]=="MultiUserCustomer" || filters[0]=="SingleUserCustomer") && filters[3]!=""){
								returnValue = User.getUsersByOrganisationAndEntityOwnerTypeTurnOverReport({"orgId": filters[3], entityOwnerType: filters[0]});
							}
						}else if(userEntityOwnerType=="MultiUserCustomer" || userEntityOwnerType=="SingleUserCustomer"){
							returnValue = User.getUsersByOrganisationAndEntityOwnerTypeTurnOverReport({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType});
						}else{
							returnValue=User.getUsersForOrganisationTurnOverReport({"orgId": filters[3]});
						}
					}
					else if(lookupName == "entity"){
							if(filters[0]!="")
								returnValue =StaticLookUp.getEntity({"entityOwnerType":filters[0]});
					}
					else if(lookupName == "tradingBank"){
						if (filters[0] != "") {
							returnValue =CustomerBankRelationshipReport.getTradingBanksForCustomer({
								customerId : filters[0]
							});
						}
					}
					else if(lookupName == "organisationTypeForGlobalApprovalPolicy"){
						returnValue = OrganisationType.organisationTypesForGlobalApprovalPolicy({"orgId":GlobalValues.getOrgId()});
					}
					else if(lookupName == "AllCustomers"){
						returnValue = CustomerRegistration.query();
					}
					else if(lookupName == "usersForOrganisation"){
						var userEntityOwnerType = GlobalValues.getEntityOwnerType().shortName;
						if(userEntityOwnerType=="Branch"){
							returnValue = User.getUsersForBranch({"branchId": GlobalValues.getBranch().id});	
						}
						else if(userEntityOwnerType=="MultiUserCustomer" || userEntityOwnerType=="SingleUserCustomer"){
							returnValue = User.getUsersByOrganisationAndEntityOwnerType({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType});
						}
						else{
							returnValue=User.getUsersForOrganisation({"orgId":GlobalValues.getOrgId()});
						}
					
					}
					else if(lookupName == "usersForGivenOrganisation"){
						if (filters[0] != "") {
							returnValue=User.getUsersExceptDelinkedForOrganisation({"orgId":filters[0]});
						}
					}
					else if(lookupName == "usersForGivenBranch"){
						if (filters[0] != "") {
							returnValue = User.getUsersExceptDelinkedForBranch({"branchId": filters[0]});
						}
					}
					else if(lookupName == "nonDelinkedUsersForGivenBranch"){
						if (filters[0] != "") {
							returnValue = User.getNonDelinkedUsersForBranch({"bankId":GlobalValues.getOrgId(),"branchId": filters[0]});
						}
					}
					else if(lookupName == "allUsersForOrganisation"){
						var userEntityOwnerType = GlobalValues.getEntityOwnerType().shortName;
						if(userEntityOwnerType=="Branch"){
							returnValue = User.getAllUsersForBranch({"bankId":GlobalValues.getBankId(),"branchId": GlobalValues.getBranch().id});	
						}
						else if(userEntityOwnerType=="MultiUserCustomer" || userEntityOwnerType=="SingleUserCustomer"){
							returnValue = User.getAllUsersByOrganisationAndEntityOwnerType({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType});
						}
						else{
							returnValue=User.getAllUsersForOrganisation({"orgId":GlobalValues.getOrgId()});
						}
					
					}
					else if(lookupName == "usersByOrganisationForRestriction"){
						var userEntityOwnerType = GlobalValues.getEntityOwnerType().shortName;
						if(userEntityOwnerType=="Branch"){
							returnValue = User.getUsersForBranchRestriction({"branchId": GlobalValues.getBranch().id});	
						}
						else if(userEntityOwnerType=="MultiUserCustomer" || userEntityOwnerType=="SingleUserCustomer"){
							returnValue = User.getUsersByOrganisationAndEntityOwnerTypeForRestriciton({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType});
						}
						else if(userEntityOwnerType=="Bank"){
							returnValue = User.getUsersByOrganisationAndEntityOwnerTypeForRestriciton({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType});
						}
						else{
							returnValue=User.getUsersForOrganisationForRestriction({"orgId":GlobalValues.getOrgId()});
						}
					
					}
					else if (lookupName == "allTypeCustomers"){
						if(filters[0]!="" && filters[1]!=""){
							returnValue = CustomerRegistration.getSingleAndMultiCustomersForBranch({"bankId": filters[0], "branchId":filters[1]});
						}/*else if(filters[0]!="" && filters[1]==""){
							returnValue = CustomerRegistration.getCustomersForBank({"bankId": filters[0]});
						}*/
					}else if (lookupName == "nonPropCustomersForBranch"){
						if(filters[0]!="" && filters[1]!=""){
							returnValue = CustomerRegistration.nonPropCustomersForBranch({"bankId": filters[0], "branchId":filters[1]});
						}
					}
					else if (lookupName == "allNonPropCustomersForBank"){
						if(filters[0]!="" && filters[1]!=""){
							returnValue = CustomerRegistration.getAllNonPropCustomersForBank({"bankId": filters[0], "customerUserTypeId":filters[1]});
						}
					}
					else if (lookupName == "customersForBank"){
						if(filters[0]!=""){
							returnValue = CustomerRegistration.getCustomersForBank({"bankId": filters[0]});
						}
					}
					
					else if (lookupName == "allTypeAndStatusCustomers"){
						if(filters[0]!="" && filters[1]!=""){
							returnValue = CustomerRegistration.getAllStatusSingleAndMultiCustomersForBranch({"bankId": filters[0], "branchId":filters[1]});
						}/*else if(filters[0]!="" && filters[1]==""){
							returnValue = CustomerRegistration.getCustomersForBank({"bankId": filters[0]});
						}*/
					}
					else if(lookupName == "allTypeCustomersForLimits"){
						var userEntityOwnerType = GlobalValues.getEntityOwnerType().shortName;
						if(userEntityOwnerType=="MultiUserCustomer" || userEntityOwnerType=="SingleUserCustomer"){
							if(filters[0]!="" && filters[1]!=""){
								var customerId = GlobalValues.getOrgId();
								returnValue = CustomerRegistration.getCustomersForBranchForLimits({"bankId": filters[0], "branchId":filters[1],"customerId":customerId});
							}
						}else{
							if(filters[0]!="" && filters[1]!=""){
								var customerId = 0;
								returnValue = CustomerRegistration.getCustomersForBranchForLimits({"bankId": filters[0], "branchId":filters[1],"customerId":customerId});
							}
						}
						
					}
					else if(lookupName == "validStatusBranchesForBank"){
						if (filters[0] != "") {
							var customerId = GlobalValues.getOrgId();
							returnValue = Branch.getValidBranchesForBank({ "bankId": filters[0] ,"customerId":customerId}, onSuccess, onFailure);
						}else if(GlobalValues.getOrganisation().organisationType.shortName=="BANK"){
							var customerId = 0;
							returnValue = Branch.getValidBranchesForBank({ "bankId": GlobalValues.getOrgId(),"customerId":customerId }, onSuccess, onFailure);
						}
					}else if(lookupName == "validBranchDetailsForBank"){
						if (filters[0] != "") {
							returnValue = Branch.getValidBranchDetailsForBank({ "bankId": filters[0] }, onSuccess, onFailure);
						}else if(GlobalValues.getOrganisation()!=null && GlobalValues.getOrganisation()!= undefined && GlobalValues.getOrganisation().organisationType.shortName=="BANK"){
							returnValue = Branch.getValidBranchDetailsForBank({ "bankId": GlobalValues.getOrgId() }, onSuccess, onFailure);
						}
					}else if(lookupName == "validBranchesForBank"){
						if (filters[0] != "") {
							returnValue = Branch.getValidBranchDetailsForBank({ "bankId": filters[0] }, onSuccess, onFailure);
						}else if(GlobalValues.getOrganisation()!=null && GlobalValues.getOrganisation()!= undefined && GlobalValues.getOrganisation().organisationType.shortName=="BANK"){
							returnValue = Branch.getValidBranchDetailsForBank({ "bankId": GlobalValues.getOrgId() }, onSuccess, onFailure);
						}
					}else if(lookupName == "validStatusBank"){
						returnValue = BankRegistration.getValidBankWithValidStatus();
					}
				else if(lookupName == "dayNumber"){
	    				returnValue = StaticLookUp.getDayNumberList();
	    			}
	    			else if(lookupName == "weekNumber"){
	    				returnValue = StaticLookUp.getWeekNumberList();
	    			}
					
	    			else if(lookupName == "instrument"){
	    				returnValue = StaticLookUp.getInstrumentType();
	    			}
					
	    			else if (lookupName == "orderStatus"){
	    				returnValue = StaticLookUp.getOrderStatus();
	    			}
	    			else if (lookupName == "userStatusExceptDelinked"){
	    				returnValue = StaticLookUp.getUserStatusExceptDelinked();
	    			}
	    			else if(lookupName == "customerChargesType"){
	    				returnValue = StaticLookUp.getCustomerChargesType();
	    			}
	    			else if(lookupName == "multiUserCustomerUserType"){
	    				returnValue = CustomerUserType.getWithoutSingleUser();
	    			}
	    			else if (lookupName == "customersForBankNonProp"){
						if(filters[0]!=""){
							returnValue = CustomerRegistration.getCustomersForBankNonProp({"bankId": filters[0]});
						}
					}
	    			else if (lookupName == "allTypeCustomersNonProp"){
	    				if(filters[0]!="" && filters[1]!=""){
							returnValue = CustomerRegistration.getSingleAndMultiCustomersForBranchNonProp({"bankId": filters[0], "branchId":filters[1]});
						}
					}
	    			else if (lookupName == "AllCustomersNonProp"){
	    				
							returnValue = CustomerRegistration.getAllNonPropAllCustomer();
						
					}
	    			else if (lookupName == "allNonPropCustomers"){
	    				if(filters[0]!=""){
							returnValue = CustomerRegistration.getAllNonPropCustomersForLookup({"customerUserTypeId":filters[0]});
	    				}
					}
	    			else if(lookupName == "tradingBankAllStatus"){
						if (filters[0] != "") {
							returnValue =CustomerBankRelationshipReport.getTradingBanksAllStatusForCustomer({
								customerId : filters[0]
							});
						}
					}else if(lookupName == 'nonTerminatedBanks'){
						
						returnValue = BankRegistration.getNonTerminatedBankList();
					}
					else if(lookupName == "allNonTerminatedCustomers"){
						if(filters[0]!="" && filters[1]!=""){
							returnValue = CustomerBankRelationshipReport.getAllNonTerminatedCustomers({"bankId": filters[0], "branchId":filters[1],"customerType":filters[2]});
						}
						
					}
					else if(lookupName == "nonPropNonTerminatedCustomers"){
						if(filters[0]!="" && filters[1]!=""){
							returnValue = CustomerBankRelationshipReport.getAllNonPropNonTerminatedCustomers({"bankId": filters[0], "branchId":filters[1],"customerType":filters[2]});
						}
						
					}
					else if(lookupName == "allNonTerminatedNonSuspendedCustomers"){
						if(filters[0]!="" && filters[1]!=""){
							returnValue = CustomerBankRelationshipReport.getAllNonTerminatedNonSuspendedCustomers({"bankId": filters[0], "branchId":filters[1],"customerType":filters[2]});
						}
						
					}
					else if(lookupName == "marketInstruments"){
	    				returnValue = StaticLookUp.getMarketInstrumentTypes();
	    			}
	    			else if(lookupName == "tenorsWithBrokenDate"){
						returnValue = StaticLookUp.getTenorsWithBrokenDate();		    			}

					else if(lookupName == "bankCategory"){
							returnValue = StaticLookUp.getBankCategory();
					}
					else if(lookupName == "currencyPair"){
							returnValue = StaticLookUp.getCurrencyPair({"bankId": filters[0]});
							
					}
                    else if(lookupName == "orderCurrencyPair"){
							returnValue = StaticLookUp.getOrderCurrencyPair({"bankId": filters[0]});
							
					}
					else if(lookupName == "fcyCurrencyPair"){
							returnValue = StaticLookUp.getFCYCurrencyPair({"bankId": filters[0]});
							
					}else if(lookupName == "marketInstrumentsCurrency"){
	    				returnValue = DefaultMarket.csInstruments({"currencyPairId": filters[0]});
	    			}
				




					return returnValue;

				}
			

				function onGetSuccess(data){
					$rootScope.$emit('gatewayApp:loadLookupComplete', data);
					returnValue = data;
				}
				function onGetFailure(){
				}
			}
		};

	}

})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('gatewayApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1791792306912)
;
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.includes('web.rest') || key.includes('service')) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.includes('jcache.statistics')) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('gatewayApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	$stateProvider.state('trackStatus', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: []
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/account/track-status/track-status.html',
                    controller: 'TrackStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	mode: function(){ return "trackstatus";},
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trackStatus');
                    $translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('customer-registration');
                    $translatePartialLoader.addPart('error');
                    return $translate.refresh();
                }]
            }
        })
        .state('registrationRequestStatus', {
            parent: 'account',
            url: '/view-customer-onboarding-status?key',
            data: {
                authorities: []
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/account/track-status/track-status.html',
                    controller: 'TrackStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	mode: function(){ return "registrationstatus";},
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trackStatus');
                    $translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('customer-registration');
                    $translatePartialLoader.addPart('otp-confirm');
                    $translatePartialLoader.addPart('error');
                    return $translate.refresh();
                }]
            }
        })
        .state('customerOnboardingStatus', {
            parent: 'account',
            url: '/customer-onboarding-status/{key}/key',
            data: {
                authorities: []
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/account/track-status/track-status.html',
                    controller: 'TrackStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	mode: function(){ return "customeronboardingstatus";},
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trackStatus');
                    $translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('customer-registration');
                    $translatePartialLoader.addPart('otp-confirm');
                    $translatePartialLoader.addPart('error');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
	'use strict';
	angular
		.module('gatewayApp')
		.factory('TrackStatus', TrackStatus);

	TrackStatus.$inject = [ '$resource' ];

	function TrackStatus($resource) {
		var resourceUrl = 'api/public/customer-onboarding-update-activation-status/:key';

		return $resource(resourceUrl, {}, {
			'updateStatus' : {
				method : 'GET',
				params : {key : '@key'},
				url : 'api/public/customer-onboarding-update-activation-status/:key',
				transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
			},
			'viewStatus' : {
				method : "POST",
				url : 'api/public/customer-onboarding-status',
				transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
			}
		});
	}
})();

(function () {
    "use strict";

    angular
        .module("gatewayApp")
        .controller("TrackStatusController", TrackStatusController);

    TrackStatusController.$inject = [
        "$stateParams",
        "$timeout",
        "TrackStatus",
        "$state",
        "mode",
        "CustomerRegistration",
        "$scope",
        "$rootScope",
        "CryptoUtil",
        "AlertService",
        "GlobalValues"
    ];

    function TrackStatusController(
        $stateParams,
        $timeout,
        TrackStatus,
        $state,
        mode,
        CustomerRegistration,
        $scope,
        $rootScope,
        CryptoUtil,
        AlertService,
        GlobalValues
    ) {
        var vm = this;
        vm.keyMissing = false;
        vm.activationKey = $stateParams.key;
        vm.requestId = $stateParams.requestId;
        vm.emailVerified = false;
        vm.approved = false;
        vm.tradingActivated = false;
        vm.withdrawn = false;
        vm.rejected = false;
        vm.globalValues = GlobalValues;
        vm.openCustomerDetails = openCustomerDetails;
        vm.generateOTP = generateOTP;
        vm.clicked = false;

        vm.platformENCCode = "tV1f3EtXyUjBrf8JbbW7bSYf7JgyxZpVXYJvwAyM34Q=";

        //updateStatus();
        viewStatus();
        function updateStatus() {
            if (
                vm.activationKey != null &&
                vm.activationKey != "" &&
                mode == "trackstatus"
            ) {
                TrackStatus.updateStatus(
                    { key: vm.activationKey },
                    onUpdateSuccess,
                    onUpdateFailure
                );
            } else {
                vm.keyMissing = true;
            }
        }

        function viewStatus() {
            var encryptedKey = CryptoUtil.encrypt($stateParams.key,GlobalValues.getPlatformENCCode());
            if (
                vm.activationKey != null &&
                vm.activationKey != "" &&
                mode == "customeronboardingstatus"
            ) {
                //TrackStatus.viewStatus({key: vm.activationKey}, onUpdateSuccess, onUpdateFailure);
                TrackStatus.viewStatus(encryptedKey,onUpdateSuccess,onUpdateFailure);
            }else if (
                vm.activationKey != null &&
                vm.activationKey != "" &&
                mode == "registrationstatus"
            ) {
                //TrackStatus.viewStatus({key: vm.activationKey}, onUpdateSuccess, onUpdateFailure);
            TrackStatus.viewStatus(encryptedKey,onUpdateSuccess,onUpdateFailure);
            
            }else {
                vm.keyMissing = true;
            }
        }

        function onUpdateSuccess(result) {
            vm.customerRegistrationRequest = result;
            vm.requestId = vm.customerRegistrationRequest.id;
            vm.requestRefNo =
                vm.customerRegistrationRequest.requestReferenceNumber;
            setStatus();
        }

        function setStatus() {
            if (
                vm.customerRegistrationRequest.customerBankRelationshipStatus
                    .shortName == "PENDINGVERIFICATION"
            ) {
                vm.emailVerified = false;
                vm.approved = false;
                vm.tradingActivated = false;
                vm.withdrawn = false;
                vm.rejected = false;
            } else if (
                vm.customerRegistrationRequest.customerBankRelationshipStatus
                    .shortName == "PENDINGAPPROVAL"
            ) {
                vm.emailVerified = true;
            } else if (
                vm.customerRegistrationRequest.customerBankRelationshipStatus
                    .shortName == "PENDINGTRADINGACTIVATION"
            ) {
                vm.emailVerified = true;
                vm.approved = true;
            } else if (
                vm.customerRegistrationRequest.customerBankRelationshipStatus
                    .shortName == "APPROVED"
            ) {
                vm.emailVerified = true;
                vm.approved = true;
                vm.tradingActivated = true;
            } else if (
                vm.customerRegistrationRequest.customerBankRelationshipStatus
                    .shortName == "WITHDRAWN" ||
                vm.customerRegistrationRequest.customerBankRelationshipStatus
                    .shortName == "WITHDRAWNBYSYSTEM"
            ) {
                vm.emailVerified = true;
                vm.withdrawn = true;
            } else if (
                vm.customerRegistrationRequest.customerBankRelationshipStatus
                    .shortName == "REJECTED"
            ) {
                vm.emailVerified = true;
                vm.rejected = true;
            }
        }

        function onUpdateFailure() {}

        // function generateOTP(){
        //     CustomerRegistration.sendOTPForRequestRefNo({requestReferenceNo: vm.requestRefNo}, onValidateSuccess, onValidateFailure);
        // }

        function generateOTP() {
            // ✅ Step 1: Execute reCAPTCHA
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey,vm.globalValues.getPlatformENCCode()), {
                        action: "otp_action"
                    })
                    .then(function (token) {
                       // console.log("reCAPTCHA token:", token);

                        // ✅ Step 2: Call API with token
                        CustomerRegistration.sendOTPForRequestRefNo(
                            {
                                requestReferenceNo: vm.requestRefNo,
                                recaptchaToken: token,
                                sourceType: "send-otp",
                                source: "view-registartion-request"
                            },
                            onValidateSuccess,
                            onValidateFailure
                        );
                    })
                    .catch(function (error) {
                        console.error("reCAPTCHA error:", error);

                        vm.disableGenerateUserOTP = false;
                        vm.showGenerateUserOTPButton = true;
                    });
            });
        }

        function onValidateSuccess(result) {
            if (mode == "registrationstatus") {
                $state.go("otp-confirmation-fetch-reg-request", {
                    refNo: vm.requestRefNo,
                    theme: "light"
                });
                vm.clicked = false;
            } else if (mode == "customeronboardingstatus") {
                $state.go("otp-confirmation-fetch-request", {
                    refNo: vm.requestRefNo,
                    theme: "light"
                });
                vm.clicked = false;
            }
        }

        function onValidateFailure() {
            vm.clicked = false;
        }

        var subscribeFetchRegisteredRequest = $rootScope.$on(
            "fetchRegisteredRequest",
            function (event, result) {
                openCustomerDetails();
            }
        );

        $scope.$on("$destroy", function () {
            $timeout(function () {
                subscribeFetchRegisteredRequest();
            }, 500);
        });

        function openCustomerDetails() {
            vm.cryptActivityKey = CryptoUtil.encrypt(
                vm.activationKey,
                vm.platformENCCode
            );
            if (mode == "trackstatus") {
                $state.go("customer-track-status-view", {
                    id: vm.cryptActivityKey,
                    theme: "light"
                });
            } else if (mode == "registrationstatus") {
                $state.go("customer-registration-status-view", {
                    id: vm.cryptActivityKey,
                    theme: "light"
                });
            } else if (mode == "customeronboardingstatus") {
                $state.go("customer-onboarding-status-view", {
                    id: vm.cryptActivityKey,
                    theme: "light"
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request/{orgType}',
            params: {action: null},
            data: {
                authorities: []
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                globalValue: ['StaticLookUp', function(StaticLookUp) {
                    return StaticLookUp.getConfigSettingsPreLogin().$promise;
                }], 

                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
              
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        })
        .state('requestUnlock', {
            parent: 'account',
            url: '/reset/unlock/{orgType}',
            params: {action: null},
            data: {
                authorities: []
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                globalValue: ['StaticLookUp', function(StaticLookUp) {
                    return StaticLookUp.getConfigSettingsPreLogin().$promise;
                }], 
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'errorConstants', 'Account', '$stateParams','$scope','$state','StringUtils','OrganisationTypeEnum','globalValue'];

    function RequestResetController ($timeout, Auth, errorConstants, Account, $stateParams,$scope, $state,StringUtils,OrganisationTypeEnum,globalValue) {
        var vm = this;

        vm.error = null;
        vm.errorEmailOrMobileNotExists = null;
        vm.errorUserNotLocked = null;
        vm.requestReset = requestReset;
        vm.requestUnlock = requestUnlock;
        vm.resetAccount = {};
        vm.action = $stateParams.action;
        vm.success = null;
        vm.timeToLoadLoginOnSucess = 3000; // in seconds
        vm.clicked = false;
        vm.configSettings = globalValue;
        setEnvironmentName();

        $timeout(function (){angular.element('#email').focus();});
        
        	$scope.$watch('vm.resetAccount.mobile', function(value) {
                if(vm.resetAccount.mobile !=null && vm.resetAccount.mobile !=undefined &&  vm.resetAccount.mobile !=''){
        	
        	vm.resetAccount.mobile = vm.resetAccount.mobile.toString().replace(/[^0-9]/g, '');
        	vm.resetAccount.mobile = vm.resetAccount.mobile.toString().replace(/(?!-)[^0-9]/g,'');
                }
        	});

            if(!StringUtils.isBlank($stateParams.orgType) && $stateParams.orgType == OrganisationTypeEnum.ADMIN){
                vm.orgType = OrganisationTypeEnum.CLEARCORP;
            }else{
                vm.orgType = OrganisationTypeEnum.OTHERS;
            }

        function requestReset () {

            vm.error = null;
            vm.errorEmailOrMobileNotExists = null;
            vm.errorEmailSendAttemptsBreached = null;
            vm.errorUserNotLocked = null;
            Auth.resetPasswordInit(vm.resetAccount.email, vm.resetAccount.mobile,vm.orgType).then(function () {
                vm.success = 'OK';
                $timeout(reloadLoginAtTimeOut, vm.timeToLoadLoginOnSucess );
            }).catch(function (response) {
                vm.success = null;
                vm.clicked = false;
                if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_OR_MOBILE_NOT_FOUND_TYPE) {
                    vm.errorEmailOrMobileNotExists = 'ERROR';
                }else if(response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_SEND_ATTEMPTS_BREACHED) {
                    vm.errorEmailSendAttemptsBreached = 'ERROR';
                }
                else {
                    vm.error = 'ERROR';
                }
            });
        }
        
        function requestUnlock(){
            vm.error = null;
            vm.errorEmailOrMobileNotExists = null;
            vm.errorUserNotLocked = null;

            Account.unlockAccount({email: vm.resetAccount.email, mobile: vm.resetAccount.mobile ,orgType : vm.orgType}, onUnlockSuccess, onUnlockFailure);
        }
        
        function onUnlockSuccess(){
        	vm.success = 'OK';
        	$timeout(reloadLoginAtTimeOut, vm.timeToLoadLoginOnSucess);
        }
        
        function onUnlockFailure(response){
        	vm.success = null;
            vm.clicked = false;
            if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.USER_NOT_LOCKED_TYPE) {
                vm.errorUserNotLocked = 'ERROR';
            } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_OR_MOBILE_NOT_FOUND_TYPE) {
                vm.errorEmailOrMobileNotExists = 'ERROR';
            } else if(response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_SEND_ATTEMPTS_BREACHED) {
                vm.errorEmailSendAttemptsBreached = 'ERROR';
            } else {
                vm.error = 'ERROR';
            }
        }
        function reloadLoginAtTimeOut() {
            //console.log("Timeout occurred");
            $state.go('login', {"orgType" : $stateParams.orgType}, {reload:'login'});
        }
        function setEnvironmentName() {
			if( vm.configSettings.environmentName !='' &&  vm.configSettings.environmentName!=undefined && vm.configSettings.environmentName!=null){
				vm.environmentName = vm.configSettings.environmentName.toUpperCase();
			}
		}
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    $translatePartialLoader.addPart('userProfile');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService','ChangeEmail'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService,ChangeEmail) {
        var vm = this;

        vm.keyMissing = $stateParams.key;
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        changeEmail();
        
        function changeEmail() {
        	
        	console.log(vm.keyMissing);
        	ChangeEmail.update({"key" : vm.keyMissing}, onSaveSuccess, onSaveError);
        }
        
        function onSaveSuccess(result) {
        	 if (result.hasOwnProperty('IsPendingEmailChangeDiscarded') && result.IsPendingEmailChangeDiscarded != null && result.IsPendingEmailChangeDiscarded == true) {
        		 vm.IsPendingEmailChangeAlreadyDiscarded = true;
        	 }else{
        		 vm.IsPendingEmailChangeAlreadyDiscarded = false;
        	 }
        	 console.log(vm.IsPendingEmailChangeAlreadyDiscarded);
		}

		function onSaveError() {

			//$scope.clicked = false;
		}
		
        
        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset1', {
            parent: 'account',
            url: '/reset/customerEmailChange?key',
            data: {
                authorities: []
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/account/reset/customerEmailChange/reset.finish.html',
                    controller: 'ResetFinish1Controller',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    $translatePartialLoader.addPart('userProfile');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ResetFinish1Controller', ResetFinish1Controller);

    ResetFinish1Controller.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService','ChangeEmail'];

    function ResetFinish1Controller ($stateParams, $timeout, Auth, LoginService,ChangeEmail) {
        var vm = this;

        vm.keyMissing = $stateParams.key;
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        changeEmail();
        
        function changeEmail() {
        	
        	console.log(vm.keyMissing);
        	ChangeEmail.updateForCustomer({"key" : vm.keyMissing}, onSaveSuccess, onSaveError);
        }
        
        function onSaveSuccess(result) {
        	 if (result.hasOwnProperty('IsPendingEmailChangeDiscarded') && result.IsPendingEmailChangeDiscarded != null && result.IsPendingEmailChangeDiscarded == true) {
        		 vm.IsPendingEmailChangeAlreadyDiscarded = true;
        	 }else{
        		 vm.IsPendingEmailChangeAlreadyDiscarded = false;
        	 }
        	 console.log(vm.IsPendingEmailChangeAlreadyDiscarded);
		}

		function onSaveError() {

			//$scope.clicked = false;
		}
		
        
        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', 'errorConstants'];

    function RegisterController ($translate, $timeout, Auth, LoginService, errorConstants) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.LOGIN_ALREADY_USED_TYPE) {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
//                '<br><small data-translate="global.messages.validate.newpassword.validation">Password should contain atleast one capital, one numeric, one special character and minimum 8 character length.</small>' +
                '</div>',
            scope: {
            	form: '=',
            	controlID: '=',
                passwordToCheck: '=',
                minPasswordLength: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement, attributes) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]\#\@\\]/g;

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= parseInt(attributes.minPasswordLength)) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
            	var c = {idx:0};
                if (password) {
                	c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
                else {
                    iElement.find('ul').children('li')
                    	.css({ 'background-color': '#DDD' });
                }
                if (c.idx == 5){
                    scope.form.$setValidity(attributes.controlId + "passwordWeek", true);
                }
                else{
            	   scope.form.$setValidity(attributes.controlId + "passwordWeek", false);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }],
                configSettings: ['StaticLookUp', function(StaticLookUp) {
                    return StaticLookUp.getConfigSettingsPreLogin().$promise;
                }]
            }
        })
        .state('change-password', {
            parent: 'home',
            url: 'change-password/{orgType}',
            params: {login: null},
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.changepassword" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/account/changepassword/changepassword.html',
                    controller: 'ChangePasswordController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('password');
                            $translatePartialLoader.addPart('error');
                            return $translate.refresh();
                        }],
                        configSettings: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettingsPreLogin().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('home');
                }, function() {
                    $state.go('home');
                });
            }]
            
        })
        .state('change-password-expiry', {
            parent: 'login',
            url: 'change-password-expiry/{orgType}',
            params: {login: null},
            data: {
                authorities: [],
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.changepassword" | translate }}',
                parent: 'login'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/account/changepassword/changepassword.html',
                    controller: 'ChangePasswordController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('password');
                            $translatePartialLoader.addPart('error');
                            return $translate.refresh();
                        }],
                        configSettings: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettingsPreLogin().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('login', null, {reload:'login'});
                }, function() {
                	$state.go('login', null, {reload:'login'});
                });
            }]
            
        })  .state('change-password-user-profile', {
            parent: 'user-profile',
            url: 'change-password/user-profile',
            params: {login: null},
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.changepassword" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/account/changepassword/changepassword.html',
                    controller: 'ChangePasswordController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('password');
                            $translatePartialLoader.addPart('error');
                            return $translate.refresh();
                        }],
                        configSettings: ['StaticLookUp', function(StaticLookUp) {
                            return StaticLookUp.getConfigSettingsPreLogin().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        ;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal','configSettings'];

    function PasswordController (Auth, Principal,configSettings) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.configSetting=configSettings;
        
        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ChangePasswordController', ChangePasswordController);

    ChangePasswordController.$inject = ['$scope','Auth', 'Principal', '$sessionStorage', '$uibModalInstance', 'GlobalValues', 'errorConstants', '$stateParams', 'StaticLookUp', 'EntityPermissions', '$state', 'MessageBox', '$rootScope','configSettings','$injector','$timeout'];

    function ChangePasswordController ($scope, Auth, Principal, $sessionStorage, $uibModalInstance, GlobalValues, errorConstants, $stateParams, StaticLookUp, EntityPermissions, $state, MessageBox, $rootScope,configSettings,$injector,$timeout) {
        var vm = this;
        vm.login = $stateParams.login;
        vm.action = $stateParams.action;
        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.clear = clear;
        vm.error = null;
        vm.previousPasswordError = null;
        vm.minimumPasswordAgeError = null;
        vm.incorrectPasswordError = null;
        vm.passwordContainLogin = null;
        vm.userLockedError = null;
        vm.success = null;
        vm.currentPasswordDoNotMatch = null;
        vm.allowedPasswordCharacters=/^[!@#^&*()\-_.:;a-zA-Z0-9]/;
        vm.globalValues = GlobalValues;
       // StaticLookUp.getConfigSettings(onGetSuccess, onGetFailure);
        vm.showPassword=false;
        vm.showConfirmPassword=false;
        vm.showCurrentPassword=false;
        vm.showPwd=showPwd;
        vm.showCurrentPwd=showCurrentPwd;
        vm.showConfirmPwd=showConfirmPwd;
        vm.boColor=null;
        vm.onFocusCurrentPwd=onFocusCurrentPwd;
        vm.onBlurCurrentPwd=onBlurCurrentPwd;
        vm.onFocusPwd=onFocusPwd;
        vm.onBlurPwd=onBlurPwd;
        vm.onFocusConfirmPwd=onFocusConfirmPwd;
        vm.onBlurConfirmPwd=onBlurConfirmPwd;
       
        vm.controlType = "password";
        vm.controlType1 = "password";
        vm.controlType2 = "password";
        vm.configSetting=configSettings;
        vm.globalValues.checkAndSetSelectedConfigurationSettings(configSettings);
        vm.timeToLoadLoginOnUnlock = 3000; // in seconds
        vm.loginpassword=null;
        vm.password=null;
        vm.confirmPassword=null;
        vm.clicked = false;
        
      /*  
        function onGetSuccess(result){
            vm.minimumPasswordLength = result.minimumPasswordLength;
            vm.minimumNumberOfPreviousPasswordThatCannotBeRepeated = result.minimumNumberOfPreviousPasswordThatCannotBeRepeated;
            vm.minimumPasswordAgeInHours = result.minimumPasswordAgeInHours;
            vm.globalValues.checkAndSetSelectedConfigurationSettings(result);      	
        }
        
        function onGetFailure(){
        	
        }*/
        Principal.identity().then(function(account) {
            vm.account = account;
        });
        
		function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function changePassword () {
        	vm.doNotMatch = '';
        	vm.currentPasswordDoNotMatch = '';
        	vm.error = '';
        	vm.previousPasswordError = '';
        	vm.minimumPasswordAgeError = '';
        	vm.incorrectPasswordError = '';
        	vm.passwordContainLogin = '';
        	vm.userLockedError = '';
        	
        	if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.previousPasswordError = null;
                vm.minimumPasswordAgeError = null;
                vm.incorrectPasswordError = null;
                vm.passwordContainLogin = null;
                vm.success = null;
            	vm.userLockedError = null;
                vm.doNotMatch = 'ERROR';
                vm.clicked = false;
            }
//        	else if ($sessionStorage.pwd !== vm.currentPassword){
//                vm.error = null;
//                vm.success = null;
//                vm.currentPasswordDoNotMatch = 'ERROR';
//        	}
        	else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.login,vm.loginpassword,vm.password).then(function () {
                    vm.error = null;
                    vm.previousPasswordError = null;
                    vm.minimumPasswordAgeError = null;
                    vm.incorrectPasswordError = null;
                    vm.passwordContainLogin = null;
                	vm.userLockedError = null;
                    vm.success = 'OK';
                    if(vm.action!='Expiry'){
                    	MessageBox.openMessageBox('Alert', 'Password has been successfully changed, Please re-login with new credentials...!', 'Ok', 'changepassword');
                    	//signOut();
                    }else{
                        $uibModalInstance.dismiss('cancel');  
                    }
                }).catch(function (response) {
                	vm.clicked = false;
                	if(angular.fromJson(response.data).type === errorConstants.PREVIOUS_PASSWORD_CANNOT_BE_USED_TYPE){
                		vm.previousPasswordError = 'ERROR'
                		vm.incorrectPasswordError = null;
                		vm.minimumPasswordAgeError = null;
                		vm.passwordContainLogin = null;
                        vm.error = null;
                       	vm.success = null;
                       	vm.userLockedError = null;
                	}else if(angular.fromJson(response.data).type === errorConstants.PASSWORD_CANNOT_BE_CHANGED_WITH_IN_HOURS_TYPE){
                		vm.minimumPasswordAgeError = "ERROR";
                		vm.incorrectPasswordError = null;
                		vm.previousPasswordError = null;
                		vm.passwordContainLogin = null;
                        vm.error = null;
                       	vm.success = null;
                       	vm.userLockedError = null;
                	}else if(angular.fromJson(response.data).type === errorConstants.PASSWORD_CONTAIN_LOGIN_TYPE){
                		vm.passwordContainLogin = "ERROR";
                		vm.incorrectPasswordError = null;
                		vm.minimumPasswordAgeError = null;
                		vm.previousPasswordError = null;
                        vm.error = null;
                       	vm.success = null;
                       	vm.userLockedError = null;
                	}else if(angular.fromJson(response.data).type === errorConstants.INCORRECT_PASSWORD_TYPE){
                		vm.passwordContainLogin = null;
                		vm.minimumPasswordAgeError = null;
                		vm.previousPasswordError = null;
                		vm.userLockedError = null;
                		vm.incorrectPasswordError = "ERROR";
                        vm.error = null;
                       	vm.success = null;   
                       	vm.userLockedError = null;
                    }else if(angular.fromJson(response.data).type === errorConstants.USER_LOCKED_TYPE){
                    	 vm.userLockedError = "ERROR";
                    	 vm.passwordContainLogin = null;
                 		 vm.minimumPasswordAgeError = null;
                 		 vm.previousPasswordError = null;                 		
                 		 vm.incorrectPasswordError = null;
                         vm.error = null;
                         vm.success = null;  
                     	$timeout(signOut, vm.timeToLoadLoginOnUnlock);
                    
                	}else{
                    	vm.success = null;
                        vm.error = 'ERROR';
                	}
                });
            }
        }
        
        function showPwd(controlType){
        	//vm.showPassword=!vm.showPassword;
        	if(controlType=="password"){
        		vm.controlType1 = "text";		
        	}
        	if(controlType=="text"){
        		vm.controlType1 = "password";		
        	}
        	

        }
        
        function showCurrentPwd(controlType){
        	//vm.showCurrentPassword=!vm.showCurrentPassword;
        	if(controlType=="password"){
        		vm.controlType = "text";		
        	}
        	if(controlType=="text"){
        		vm.controlType = "password";		
        	}
        }
        
        function showConfirmPwd(controlType){
        	//vm.showConfirmPassword=!vm.showConfirmPassword;
        	if(controlType=="password"){
        		vm.controlType2 = "text";		
        	}
        	if(controlType=="text"){
        		vm.controlType2 = "password";		
        	}
        }
        
        function onFocusCurrentPwd(){
        	vm.boColor = "#FFC000";
        }
        function onBlurCurrentPwd(){
        	vm.boColor = "#DADAE7";
        }
        
        function onFocusPwd(){
        	vm.boColor1 = "#FFC000";
        	
        }
        function onBlurPwd(){
        	vm.boColor1 = "#DADAE7";
        	
        }
        
        function onFocusConfirmPwd(){
        	vm.boColor2 = "#FFC000";
        }
        function onBlurConfirmPwd(){
        	vm.boColor2 = "#DADAE7";
        }
        
        $rootScope.$on('gatewayApp.messagebox.ok.changepassword', function (event, data) {
        	//console.log($state.current.name);
        	if($state.current.name == 'change-password' || $state.current.name == 'change-password-expiry'||$state.current.name == 'change-password-user-profile'){
            	signOut();
                //$uibModalInstance.dismiss('cancel');  
            	
        	}else{
                $uibModalInstance.dismiss('cancel');  
        	}
        });

        /*
         * allow only 30 characters in password and only some special characters
         */
        $scope.$watch('vm.loginpassword', function(newVal, oldVal) {
        	if(newVal!=null||newVal!=undefined)
        		{
	        		if(newVal.length > 30) {       
	        			vm.loginpassword = oldVal;
	        		}
	        		if(!newVal.charAt((newVal.length)-1).match(vm.allowedPasswordCharacters))
	        		{
	        			vm.loginpassword = oldVal;
	        		}
	        		if(vm.password==null||vm.confirmPassword==null||vm.loginpassword==null||vm.password==undefined||vm.confirmPassword==undefined||vm.loginpassword==undefined||vm.loginpassword.length<4||vm.confirmPassword.length<vm.configSetting.minimumPasswordLength||vm.password.length<vm.configSetting.minimumPasswordLength)
	        			$scope.form.$setValidity("valid", false);
	        		else
	        			$scope.form.$setValidity("valid", true);

        		}
      	        	});
        
        $scope.$watch('vm.confirmPassword', function(newVal, oldVal) {
        	if(newVal!=null||newVal!=undefined)
    		{
	        	  if(newVal.length > 30) {       
	        		  vm.confirmPassword = oldVal;
	        	  }
	        	  if(!newVal.charAt((newVal.length)-1).match(vm.allowedPasswordCharacters))
	    		  {
	        		  vm.confirmPassword = oldVal;
	    		  }
	        	  if(vm.password==null||vm.confirmPassword==null||vm.loginpassword==null||vm.password==undefined||vm.confirmPassword==undefined||vm.loginpassword==undefined||vm.loginpassword.length<4||vm.confirmPassword.length<vm.configSetting.minimumPasswordLength||vm.password.length<vm.configSetting.minimumPasswordLength)
	        		  $scope.form.$setValidity("valid", false);
	        	  else
	        		  $scope.form.$setValidity("valid", true);
    		}
        	});
        
        
        $scope.$watch('vm.password', function(newVal, oldVal) {
        	if(newVal!=null||newVal!=undefined)
    		{
        	  if(newVal.length > 30) {       
        		  vm.password = oldVal;
        	  }
        	  if(!newVal.charAt((newVal.length)-1).match(vm.allowedPasswordCharacters))
    		  {
        		  vm.password = oldVal;
    		  }
        	  if(vm.password==null||vm.confirmPassword==null||vm.loginpassword==null||vm.password==undefined||vm.confirmPassword==undefined||vm.loginpassword==undefined||vm.loginpassword.length<4||vm.confirmPassword.length<vm.configSetting.minimumPasswordLength||vm.password.length<vm.configSetting.minimumPasswordLength)
        		  $scope.form.$setValidity("valid", false);
        	  else
        		  $scope.form.$setValidity("valid", true);
    		}
        	});
      

        var signOut = function(){
        	GlobalValues.clearPreviousValues();
            EntityPermissions.clearEntityPermission();
            $sessionStorage.isAuth = false;
            Auth.logout();
            $injector.get('$uibModalStack').dismissAll();
            $state.go('login', {orgType : $stateParams.orgType}, {reload:'login'});
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('gatewayApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/cspl-ach-dropdown-template.html','<div class="{{$parent.themeType}}"><div class="custom-popup-wrapper" ng-style="{top: position().top+\'px\',\r\n          left: position().left+\'px\'}" style="display: block" ng-show="isOpen() && !moveInProgress" aria-hidden="{{!isOpen()}}"><div class="customDropdown table-responsive" style="max-height:45vh; overflow-y:auto; overflow-x:hidden"><table style="width:100%" class="table table-hover table-striped"><thead ng-show="$parent.numberOfColumns > 1"><tr><th ng-repeat="item in $parent.displayColumnArr"><span ng-if="item==\'shortName\'" title="Short Name">Short Name</span> <span ng-if="item==\'name\'" title="Name">Name</span> <span ng-if="item==\'ifscCode\'" title="IFSC Code">IFSC Code</span> <span ng-if="item==\'bankName\'" title="Bank Name">Bank Name</span> <span ng-if="item==\'branchName\'" title="Branch Name">Branch Name</span> <span ng-if="item==\'aliasName\'" title="Alias Name">Alias Name</span> <span ng-if="item==\'code\'" title="Code">Code</span> <span ng-if="item==\'customerCode\'" title="Cust ID">Cust ID</span> <span ng-if="item==\'customerFirstName\'" title="Customer First Name">Customer First Name</span> <span ng-if="item==\'customerMiddleName\'" title="Customer Middle Name">Customer Middle Name</span> <span ng-if="item==\'customerLastName\'" title="Customer Last Name">Customer Last Name</span> <span ng-if="item==\'customerName\'" title="Customer Name">Customer Name</span> <span ng-if="item==\'branchId\'" title="Branch ID">Branch ID</span></th></tr></thead><tbody><tr ng-repeat="match in matches" ng-mouseenter="selectActive($index)" ng-class="{active: isActive($index)}" ng-click="selectMatch($index)"><td ng-repeat="prop in $parent.$parent.displayColumnArr" title="{{match.model[prop]}}">{{match.model[prop]}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/csplEntityLookup.html','<div class="row"><label class="{{controlClass}} control-label" cspl-mandatory><span>Entity Owner Type</span></label></div><div class="row"><div class="col-md-8 col-md-offset-3"><!-- <cspl-ach control-model="selectedEntityOwnerType" control-id="txtEntityOwnerType" lookup-name="entityOwnerTypeByUserEntityOwnerType"\r\n\t\t\t display-column="shortName" form="controlForm" required></cspl-ach> --><div id="btnGroup"><div class="btn-group noPaddingMargin" style="width: auto;margin-bottom:8px" ng-init="(userEntityOwnerType==\'Clearcorp\' && showClearCorp==false)?selectedEntityOwnerType=\'Bank\':selectedEntityOwnerType=userEntityOwnerType"><label class="btn btn-primary" ng-model="$parent.selectedEntityOwnerType" ng-if="userEntityOwnerType==\'Clearcorp\' && showClearCorp!=false" uib-btn-radio="\'Clearcorp\'">Clearcorp</label><label class="btn btn-primary" ng-model="$parent.selectedEntityOwnerType" ng-if="userEntityOwnerType==\'Clearcorp\' || userEntityOwnerType==\'Bank\'" uib-btn-radio="\'Bank\'">Bank</label><label class="btn btn-primary" ng-model="$parent.selectedEntityOwnerType" ng-if="userEntityOwnerType==\'Clearcorp\' || userEntityOwnerType==\'Bank\' || userEntityOwnerType==\'Branch\'" uib-btn-radio="\'Branch\'">Branch</label><label class="btn btn-primary" ng-model="$parent.selectedEntityOwnerType" ng-if="userEntityOwnerType!=\'MultiUserCustomer\'" uib-btn-radio="\'SingleUserCustomer\'">SingleUserCustomer</label><label class="btn btn-primary" ng-model="$parent.selectedEntityOwnerType" ng-if="userEntityOwnerType!=\'SingleUserCustomer\'" uib-btn-radio="\'MultiUserCustomer\'">MultiUserCustomer</label></div></div></div></div><div class="row" ng-show="userEntityOwnerType==\'Clearcorp\' && (selectedEntityOwnerType==\'Bank\' || selectedEntityOwnerType==\'Branch\' || selectedEntityOwnerType==\'MultiUserCustomer\' || selectedEntityOwnerType==\'SingleUserCustomer\')"><label class="{{controlClass}} control-label" cspl-mandatory><span>Bank</span></label></div><div class="row" ng-show="userEntityOwnerType==\'Clearcorp\' && (selectedEntityOwnerType==\'Bank\' || selectedEntityOwnerType==\'Branch\' || selectedEntityOwnerType==\'MultiUserCustomer\' || selectedEntityOwnerType==\'SingleUserCustomer\')"><div class="{{controlClass}}"><cspl-ach control-model="bankValue" control-id="txtbank" lookup-name="bank" display-column="shortName" form="controlForm" control-required="userEntityOwnerType==\'Clearcorp\' && (selectedEntityOwnerType==\'Bank\' || selectedEntityOwnerType==\'Branch\' || selectedEntityOwnerType==\'MultiUserCustomer\' || selectedEntityOwnerType==\'SingleUserCustomer\')"></cspl-ach></div></div><div class="row" ng-show="(userEntityOwnerType==\'Clearcorp\' || userEntityOwnerType==\'Bank\') && (selectedEntityOwnerType==\'Branch\' || selectedEntityOwnerType==\'MultiUserCustomer\' || selectedEntityOwnerType==\'SingleUserCustomer\')"><label class="{{controlClass}} control-label" cspl-mandatory><span>Branch</span></label></div><div class="row"><div class="{{controlClass}}" ng-show="(userEntityOwnerType==\'Clearcorp\' || userEntityOwnerType==\'Bank\') && (selectedEntityOwnerType==\'Branch\' || selectedEntityOwnerType==\'MultiUserCustomer\' || selectedEntityOwnerType==\'SingleUserCustomer\') && (showTerminatedBranch!=false)"><cspl-ach control-model="branchValue" control-id="txtBranch" lookup-name="branchesForBank" filter-value="{{bankValue.id}}" display-column="shortName" form="controlForm" filter-value="{{bankValue.id}}" control-required="(userEntityOwnerType==\'Clearcorp\' || userEntityOwnerType==\'Bank\') && (selectedEntityOwnerType==\'Branch\' || selectedEntityOwnerType==\'MultiUserCustomer\' || selectedEntityOwnerType==\'SingleUserCustomer\')"></cspl-ach></div><div class="{{controlClass}}" ng-show="(userEntityOwnerType==\'Clearcorp\' || userEntityOwnerType==\'Bank\') && (selectedEntityOwnerType==\'Branch\' || selectedEntityOwnerType==\'MultiUserCustomer\' || selectedEntityOwnerType==\'SingleUserCustomer\') && (showTerminatedBranch==false)"><cspl-ach control-model="branchValue" control-id="txtBranch" lookup-name="activeBranchesForBank" filter-value="{{bankValue.id}}" display-column="shortName" form="controlForm" filter-value="{{bankValue.id}}" control-required="(userEntityOwnerType==\'Clearcorp\' || userEntityOwnerType==\'Bank\') && (selectedEntityOwnerType==\'Branch\' || selectedEntityOwnerType==\'MultiUserCustomer\' || selectedEntityOwnerType==\'SingleUserCustomer\')"></cspl-ach></div></div><div class="row" ng-show="(userEntityOwnerType==\'Clearcorp\' || userEntityOwnerType==\'Bank\' || userEntityOwnerType==\'Branch\') && (selectedEntityOwnerType==\'MultiUserCustomer\' || selectedEntityOwnerType==\'SingleUserCustomer\')"><label class="{{controlClass}} control-label"><span cspl-mandatory>Customer</span></label></div><div class="row"><div class="{{controlClass}}" ng-show="(userEntityOwnerType==\'Clearcorp\' || userEntityOwnerType==\'Bank\' || userEntityOwnerType==\'Branch\') && (selectedEntityOwnerType==\'MultiUserCustomer\' || selectedEntityOwnerType==\'SingleUserCustomer\')"><cspl-ach control-model="customerValue" control-id="txtCustomer" lookup-name="customerByEntityOwnerTypeShortName" filter-value="{{bankValue.id}}~~{{branchValue.id}}~~{{selectedEntityOwnerType}}" display-column="customerCode,customerFirstName" form="controlForm" control-required="(userEntityOwnerType==\'Clearcorp\' || userEntityOwnerType==\'Bank\' || userEntityOwnerType==\'Branch\') && (selectedEntityOwnerType==\'MultiUserCustomer\' || selectedEntityOwnerType==\'SingleUserCustomer\')"></cspl-ach></div></div><div ng-hide="userEntityOwnerType==\'MultiUserCustomer\' && showUser"><div class="row"><label class="{{controlClass}} control-label"><span>User</span></label></div><div class="row"><div class="{{controlClass}}" ng-init="(userLookup==null || userLookup ==undefined || userLookup ==\'\')?userLookup1=\'allUsers\':userLookup1=userLookup"><cspl-ach control-model="userValue" control-id="txtUser" lookup-name="{{userLookup1}}" display-column="login" filter-value="{{selectedEntityOwnerType}}~~{{bankValue.id}}~~{{branchValue.id}}~~{{customerValue.id}}" form="controlForm"></cspl-ach></div></div></div><div class="row" ng-hide="true"><input ng-model="userListValue" control-id="txtUserList" form="controlForm"></div>');
$templateCache.put('app/csplSelect.html','<style>/*the container must be positioned relative:*/\r\n.custom-select {\r\n  position: relative;\r\n  font-family: Arial;\r\n}\r\n\r\n.custom-select select {\r\n  display: none; /*hide original SELECT element:*/\r\n}\r\n\r\n.select-selected {\r\n  background-color: DodgerBlue;\r\n}\r\n\r\n/*style the arrow inside the select element:*/\r\n.select-selected:after {\r\n  position: absolute;\r\n  content: "";\r\n  top: 14px;\r\n  right: 10px;\r\n  width: 0;\r\n  height: 0;\r\n  border: 6px solid transparent;\r\n  border-color: #fff transparent transparent transparent;\r\n}\r\n\r\n/*point the arrow upwards when the select box is open (active):*/\r\n.select-selected.select-arrow-active:after {\r\n  border-color: transparent transparent #fff transparent;\r\n  top: 7px;\r\n}\r\n\r\n/*style the items (options), including the selected item:*/\r\n.select-items div,.select-selected {\r\n  color: #ffffff;\r\n  padding: 8px 16px;\r\n  border: 1px solid transparent;\r\n  border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n/*style items (options):*/\r\n.select-items {\r\n  position: absolute;\r\n  background-color: DodgerBlue;\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 99;\r\n}\r\n\r\n/*hide the items when the select box is closed:*/\r\n.select-hide {\r\n  display: none;\r\n}\r\n\r\n.select-items div:hover, .same-as-selected {\r\n  background-color: rgba(0, 0, 0, 0.1);\r\n}</style><script>var x, i, j, selElmnt, a, b, c;\r\n/*look for any elements with the class "custom-select":*/\r\nx = document.getElementsByClassName("custom-select");\r\nfor (i = 0; i < x.length; i++) {\r\n  selElmnt = x[i].getElementsByTagName("select")[0];\r\n  /*for each element, create a new DIV that will act as the selected item:*/\r\n  a = document.createElement("DIV");\r\n  a.setAttribute("class", "select-selected");\r\n  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;\r\n  x[i].appendChild(a);\r\n  /*for each element, create a new DIV that will contain the option list:*/\r\n  b = document.createElement("DIV");\r\n  b.setAttribute("class", "select-items select-hide");\r\n  for (j = 1; j < selElmnt.length; j++) {\r\n    /*for each option in the original select element,\r\n    create a new DIV that will act as an option item:*/\r\n    c = document.createElement("DIV");\r\n    c.innerHTML = selElmnt.options[j].innerHTML;\r\n    c.addEventListener("click", function(e) {\r\n        /*when an item is clicked, update the original select box,\r\n        and the selected item:*/\r\n        var y, i, k, s, h;\r\n        s = this.parentNode.parentNode.getElementsByTagName("select")[0];\r\n        h = this.parentNode.previousSibling;\r\n        for (i = 0; i < s.length; i++) {\r\n          if (s.options[i].innerHTML == this.innerHTML) {\r\n            s.selectedIndex = i;\r\n            h.innerHTML = this.innerHTML;\r\n            y = this.parentNode.getElementsByClassName("same-as-selected");\r\n            for (k = 0; k < y.length; k++) {\r\n              y[k].removeAttribute("class");\r\n            }\r\n            this.setAttribute("class", "same-as-selected");\r\n            break;\r\n          }\r\n        }\r\n        h.click();\r\n    });\r\n    b.appendChild(c);\r\n  }\r\n  x[i].appendChild(b);\r\n  a.addEventListener("click", function(e) {\r\n      /*when the select box is clicked, close any other select boxes,\r\n      and open/close the current select box:*/\r\n      e.stopPropagation();\r\n      closeAllSelect(this);\r\n      this.nextSibling.classList.toggle("select-hide");\r\n      this.classList.toggle("select-arrow-active");\r\n    });\r\n}\r\nfunction closeAllSelect(elmnt) {\r\n  /*a function that will close all select boxes in the document,\r\n  except the current select box:*/\r\n  var x, y, i, arrNo = [];\r\n  x = document.getElementsByClassName("select-items");\r\n  y = document.getElementsByClassName("select-selected");\r\n  for (i = 0; i < y.length; i++) {\r\n    if (elmnt == y[i]) {\r\n      arrNo.push(i)\r\n    } else {\r\n      y[i].classList.remove("select-arrow-active");\r\n    }\r\n  }\r\n  for (i = 0; i < x.length; i++) {\r\n    if (arrNo.indexOf(i)) {\r\n      x[i].classList.add("select-hide");\r\n    }\r\n  }\r\n}\r\n/*if the user clicks anywhere outside the select box,\r\nthen close all select boxes:*/\r\ndocument.addEventListener("click", closeAllSelect);</script><div class="custom-select"><select ng-model="controlModel" ng-change="csplSelectCtrl.changeEvent()"><option ng-value="model" ng-repeat="model in $parent.items">{{model.name}}</option></select></div>');
$templateCache.put('app/csplTableExport.html','<div class="dropdown" style="width:10%" ng-show="permissionToExport"><div class="dropdown-toggle" id="dropdownMenu-export-{{$id}}" data-toggle="dropdown" aria-expanded="true" role="button" aria-label="Export Menu"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border:none" aria-label="Export Table" tabindex="-1"><img src="assets/images/Export_01.png" alt="Export Icon"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-export-{{$id}}"><!-- <li><a onClick="document.getElementById(tableName).tableExport({ type: \'json\', escape: \'false\' });">JSON</a></li> --><!-- <li><a onClick="document.getElementById(tableName).tableExport({ type: \'xml\', escape: \'false\' });">XML</a></li> --><!-- <li><a onClick="document.getElementById(tableName).tableExport({ type: \'sql\' });">SQL</a></li>  --><!-- <li><a ng-click="csplTableExportCtrl.exportToFile(\'png\');">PNG</a></li> --><li><a ng-click="csplTableExportCtrl.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="csplTableExportCtrl.exportToFile(\'excel\');">XLS</a></li><!-- <li><a ng-click="csplTableExportCtrl.exportToFile(\'txt\');">TXT</a></li> --><!-- <li><a ng-click="csplTableExportCtrl.exportToFile(\'doc\');">Word</a></li> --><!-- <li><a ng-click="csplTableExportCtrl.exportToFile(\'powerpoint\');">PowerPoint</a></li> --><!-- <li><a ng-click="csplTableExportCtrl.exportToFile(\'pdf\');">PDF</a></li> --></ul></div>');
$templateCache.put('app/csplTableImport.html','<div class="dropdown" style="width:10%" ng-show="permissionToImport"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border:none"><img src="assets/images/Import_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><input type="file" id="uploadFile" name="fileUpload" fileread="fileContent" accept=".csv" ng-hide="true"> <a ng-click="csplTableImportCtrl.importFile();">Import File</a></li><li><a ng-click="csplTableImportCtrl.generateTemplate();">Generate Template</a></li></ul></div>');
$templateCache.put('app/home/fcy-market-depth.html','<div class="content-bot-left-wrapper" ng-show="enableOtherCurrencyTab"><div class="col-md-12 market-watch-row-fcy-header"><div class="col-md-6" style="margin-top: 5px"><div class="row" style="background-color: black;padding: 5px;border-radius: 5px"><div class="col-md-3"></div><div class="col-md-3 text-center"><div>SPOT <span style="margin-left: 3px" class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Settlement Date T+2 " tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span></div></div><div class="col-md-3 text-center"><div>TOM <span style="margin-left: 3px" class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Settlement Date T+1 " tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span></div></div><div class="col-md-3 text-center"><div>CASH <span style="margin-left: 3px" class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Settlement Date Today" tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span></div></div></div></div><div class="col-md-6" style="margin-top: 5px"><div class="row" style="background-color: black;padding: 5px;border-radius: 5px"><div class="col-md-3"></div><div class="col-md-3 text-center"><div>SPOT <span style="margin-left: 3px" class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Settlement Date T+2 " tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span></div></div><div class="col-md-3 text-center"><div>TOM <span style="margin-left: 3px" class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Settlement Date T+1 " tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span></div></div><div class="col-md-3 text-center"><div>CASH <span class="icon" style="margin-left: 3px" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Settlement Date Today" tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span></div></div></div></div></div><div style="height: 367px; overflow: auto; position: relative;padding-right: 2px"><div class="row market-watch-row-fcy no-curve-border" ng-repeat-start="row in marketArray track by row[0]" ng-if="$even"><!-- LEFT currency --><div class="col-md-6" style="margin-top: 5px;margin-bottom: 5px"><div class="row" style="background-color: black;padding: 5px;text-align: center;border-radius:5px"><div class="col-md-3" style="text-align: center;display: flex;align-items: center;padding: 3%">{{ row[1].baseCurrency }}/INR</div><!-- SPOT --><div class="col-md-3 less-padding" ng-class="{\r\n            \'status-disabled\': vm.getInstrumentStatus(row[1].instruments[0].tokenSequenceNo) === \'CLOSED\' || vm.getInstrumentStatus(row[1].instruments[0].tokenSequenceNo) === \'HOLIDAY\' || vm.getInstrumentStatus(row[1].instruments[0].tokenSequenceNo) === \'UNAVAILABLE\'\r\n          }"><span style="display:none">{{ date = vm.getInstrumentStatus(row[1].instruments[0].tokenSequenceNo) }} </span><!-- Header row --><div class="tile-header"><span ng-if="date && date === \'UNAVAILABLE\'">- </span><span ng-if="!date || date !== \'UNAVAILABLE\'" class="tile-date">{{ vm.getMarkData(row[1].instruments[0].tokenSequenceNo).settlementDate | date:\'dd-MMM-yyyy\' }}</span><div><span class="tile-status" ng-if="status = vm.getInstrumentStatus(row[1].instruments[0].tokenSequenceNo)" ng-class="{\r\n            \'status-closed\': status === \'CLOSED\',\r\n            \'status-holiday\': status === \'HOLIDAY\',\r\n            \'status-unavailable\': status === \'UNAVAILABLE\'\r\n          }">{{ status | capitalizeFirst }}</span></div><span class="tile-ltp"><span>LTP</span> <span ng-if="status === \'UNAVAILABLE\'">- </span><span ng-if="status !== \'UNAVAILABLE\'" class="color-white">{{ vm.getTickerPrice(row[1].instruments[0].tokenSequenceNo).ltp ? vm.getTickerPrice(row[1].instruments[0].tokenSequenceNo).ltp : vm.getTickerPrice(row[1].instruments[0].tokenSequenceNo).previouseDayClosingPrice | number:4 }}</span></span></div><div class=""><div class="col-md-6">YOU SELL</div><div class="col-md-6">YOU BUY</div></div><div class="" ng-class="{\'disabled-box\': (vm.getMarkData(row[1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status==\'CLOSED\') && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="col-md-6 box-sell box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'SELL\', \'SPOT\', row[1].instruments[0].bidPrice,vm.getMarkData(row[1].instruments[0].tokenSequenceNo).settlementDate, vm.getMarkData(row[1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status,row[0]);"><div class="text-align-right price">{{ row[1].instruments[0].bidPrice | split:\'.\':\'0\'}}<span ng-show="row[1].instruments[0].bidPrice>0">.</span><span class="la-value-fcy">{{ row[1].instruments[0].bidPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-left volume" ng-show="row[1].instruments[0].bidVolume>0">{{ row[1].instruments[0].bidVolume | number:2}}</div></div><div class="col-md-6 box-buy box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'BUYY\', \'SPOT\', row[1].instruments[0].offerPrice,vm.getMarkData(row[1].instruments[0].tokenSequenceNo).settlementDate, vm.getMarkData(row[1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status,row[0]);"><div class="text-align-left price">{{ row[1].instruments[0].offerPrice | split:\'.\':\'0\'}}<span ng-show="row[1].instruments[0].offerPrice>0">.</span><span class="la-value-fcy">{{ row[1].instruments[0].offerPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-right volume" ng-show="row[1].instruments[0].offerVolume>0">{{ row[1].instruments[0].offerVolume | number:2}}</div></div></div></div><!-- TOM --><div class="col-md-3 less-padding" ng-class="{\r\n            \'status-disabled\': vm.getInstrumentStatus(row[1].instruments[1].tokenSequenceNo) === \'CLOSED\' || vm.getInstrumentStatus(row[1].instruments[1].tokenSequenceNo) === \'HOLIDAY\' || vm.getInstrumentStatus(row[1].instruments[1].tokenSequenceNo) === \'UNAVAILABLE\'\r\n          }"><!-- Header row --><div class="tile-header"><span style="display:none">{{ date = vm.getInstrumentStatus(row[1].instruments[1].tokenSequenceNo) }} </span><span ng-if="date && date === \'UNAVAILABLE\'">- </span><span ng-if="!date || date !== \'UNAVAILABLE\'" class="tile-date">{{ vm.getMarkData(row[1].instruments[1].tokenSequenceNo).settlementDate | date:\'dd-MMM-yyyy\' }}</span><div><span class="tile-status" ng-if="statusTom = vm.getInstrumentStatus(row[1].instruments[1].tokenSequenceNo)" ng-class="{\r\n            \'status-closed\': statusTom === \'CLOSED\',\r\n            \'status-holiday\': statusTom === \'HOLIDAY\',\r\n            \'status-unavailable\': statusTom === \'UNAVAILABLE\'\r\n          }">{{ statusTom | capitalizeFirst }}</span></div><span class="tile-ltp"><span>LTP</span> <span ng-if="statusTom === \'UNAVAILABLE\'">- </span><span ng-if="statusTom !== \'UNAVAILABLE\'" class="color-white">{{ vm.getTickerPrice(row[1].instruments[1].tokenSequenceNo).ltp ? vm.getTickerPrice(row[1].instruments[1].tokenSequenceNo).ltp : vm.getTickerPrice(row[1].instruments[1].tokenSequenceNo).previouseDayClosingPrice | number:4 }}</span></span></div><div class=""><div class="col-md-6">YOU SELL</div><div class="col-md-6">YOU BUY</div></div><div class="" ng-class="{\'disabled-box\': (vm.getMarkData(row[1].instruments[1].tokenSequenceNo).sessionTimingsDTO.status==\'CLOSED\') && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="col-md-6 box-sell box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'SELL\', \'TOM\', row[1].instruments[1].bidPrice,vm.getMarkData(row[1].instruments[1].tokenSequenceNo).settlementDate, vm.getMarkData(row[1].instruments[1].tokenSequenceNo).sessionTimingsDTO.status,row[0]);"><div class="text-align-right price">{{ row[1].instruments[1].bidPrice | split:\'.\':\'0\'}}<span ng-show="row[1].instruments[1].bidPrice>0">.</span><span class="la-value-fcy">{{ row[1].instruments[1].bidPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-left volume" ng-show="row[1].instruments[1].bidVolume>0">{{ row[1].instruments[1].bidVolume | number:2}}</div></div><div class="col-md-6 box-buy box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'BUYY\', \'TOM\', row[1].instruments[1].offerPrice, vm.getMarkData(row[1].instruments[1].tokenSequenceNo).settlementDate, vm.getMarkData(row[1].instruments[1].tokenSequenceNo).sessionTimingsDTO.status,row[0]);"><div class="text-align-left price">{{ row[1].instruments[1].offerPrice | split:\'.\':\'0\'}}<span ng-show="row[1].instruments[1].offerPrice>0">.</span><span class="la-value-fcy">{{ row[1].instruments[1].offerPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-right volume" ng-show="row[1].instruments[1].offerVolume>0">{{ row[1].instruments[1].offerVolume | number:2}}</div></div></div></div><!-- CASH --><div class="col-md-3 less-padding" ng-class="{\r\n            \'status-disabled\': vm.getInstrumentStatus(row[1].instruments[2].tokenSequenceNo) === \'CLOSED\' || vm.getInstrumentStatus(row[1].instruments[2].tokenSequenceNo) === \'HOLIDAY\' || vm.getInstrumentStatus(row[1].instruments[2].tokenSequenceNo) === \'UNAVAILABLE\'\r\n          }"><!-- Header row --><div class="tile-header"><span style="display:none">{{ date = vm.getInstrumentStatus(row[1].instruments[2].tokenSequenceNo) }} </span><span ng-if="date && date === \'UNAVAILABLE\'">- </span><span ng-if="!date || date !== \'UNAVAILABLE\'" class="tile-date">{{ vm.getMarkData(row[1].instruments[2].tokenSequenceNo).settlementDate | date:\'dd-MMM-yyyy\' }}</span><div><span class="tile-status" ng-if="statusCash = vm.getInstrumentStatus(row[1].instruments[2].tokenSequenceNo)" ng-class="{\r\n            \'status-closed\': statusCash === \'CLOSED\',\r\n            \'status-holiday\': statusCash === \'HOLIDAY\',\r\n            \'status-unavailable\': statusCash === \'UNAVAILABLE\'\r\n          }">{{ statusCash | capitalizeFirst }}</span></div><span class="tile-ltp"><span>LTP</span> <span ng-if="statusCash === \'UNAVAILABLE\'">- </span><span ng-if="statusCash !== \'UNAVAILABLE\'" class="color-white">{{ vm.getTickerPrice(row[1].instruments[2].tokenSequenceNo).ltp ? vm.getTickerPrice(row[1].instruments[2].tokenSequenceNo).ltp : vm.getTickerPrice(row[1].instruments[2].tokenSequenceNo).previouseDayClosingPrice | number:4 }}</span></span></div><div class=""><div class="col-md-6">YOU SELL</div><div class="col-md-6">YOU BUY</div></div><div class="" ng-class="{\'disabled-box\': (vm.getMarkData(row[1].instruments[2].tokenSequenceNo).sessionTimingsDTO.status==\'CLOSED\') && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="col-md-6 box-sell box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'SELL\', \'CASH\', row[1].instruments[2].bidPrice,vm.getMarkData(row[1].instruments[2].tokenSequenceNo).settlementDate, vm.getMarkData(row[1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status,row[0]);"><div class="text-align-right price">{{ row[1].instruments[2].bidPrice | split:\'.\':\'0\'}}<span ng-show="row[1].instruments[2].bidPrice>0">.</span><span class="la-value-fcy">{{ row[1].instruments[2].bidPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-left volume" ng-show="row[1].instruments[2].bidVolume>0">{{ row[1].instruments[2].bidVolume | number:2}}</div></div><div class="col-md-6 box-buy box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'BUYY\', \'CASH\', row[1].instruments[2].offerPrice,vm.getMarkData(row[1].instruments[2].tokenSequenceNo).settlementDate, vm.getMarkData(row[1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status,row[0]);"><div class="text-align-left price">{{ row[1].instruments[2].offerPrice | split:\'.\':\'0\'}}<span ng-show="row[1].instruments[2].offerPrice>0">.</span><span class="la-value-fcy">{{ row[1].instruments[2].offerPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-right volume" ng-show="row[1].instruments[2].offerVolume>0">{{ row[1].instruments[2].offerVolume | number:2}}</div></div></div></div></div></div><!-- RIGHT currency --><div class="col-md-6" style="margin-top: 5px;margin-bottom: 5px" ng-if="marketArray[$index + 1]"><div class="row" style="background-color: black;padding: 5px;text-align: center;border-radius:5px"><div class="col-md-3" style="text-align: center;display: flex;align-items: center;padding: 3%">{{ marketArray[$index + 1][1].baseCurrency }}/INR</div><div class="col-md-3 less-padding" ng-class="{\r\n            \'status-disabled\': vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[0].tokenSequenceNo) === \'CLOSED\' || vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[0].tokenSequenceNo) === \'HOLIDAY\' || vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[0].tokenSequenceNo) === \'UNAVAILABLE\'\r\n          }"><!-- Header row --><div class="tile-header"><span style="display:none">{{ date = vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[0].tokenSequenceNo) }} </span><!-- Show \'-\' --> <span ng-if="date && date === \'UNAVAILABLE\'">- </span><span ng-if="!date || date !== \'UNAVAILABLE\'" class="tile-date">{{ vm.getMarkData(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).settlementDate | date:\'dd-MMM-yyyy\' }}</span><div><span class="tile-status" ng-if="statusCash = vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[0].tokenSequenceNo)" ng-class="{\r\n            \'status-closed\': statusCash === \'CLOSED\',\r\n            \'status-holiday\': statusCash === \'HOLIDAY\',\r\n            \'status-unavailable\': statusCash === \'UNAVAILABLE\'\r\n          }">{{ statusCash | capitalizeFirst }}</span></div><span class="tile-ltp"><span>LTP</span> <span ng-if="statusCash === \'UNAVAILABLE\'">- </span><span ng-if="statusCash !== \'UNAVAILABLE\'" class="color-white"><span style="color: white">{{ (vm.getTickerPrice(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).ltp != null ? vm.getTickerPrice(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).ltp : vm.getTickerPrice(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).previouseDayClosingPrice) | number:4 }}</span></span></span></div><div><div class="col-md-6">YOU SELL</div><div class="col-md-6">YOU BUY</div></div><div class="" ng-class="{\'disabled-box\': (vm.getMarkData(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status==\'CLOSED\') && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="col-md-6 box-sell box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'SELL\', \'SPOT\', marketArray[$index + 1][1].instruments[0].bidPrice,vm.getMarkData(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).settlementDate, vm.getMarkData(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status,marketArray[$index + 1][0]);"><div class="text-align-right price">{{ marketArray[$index + 1][1].instruments[0].bidPrice | split:\'.\':\'0\'}}<span ng-show=" marketArray[$index + 1][1].instruments[0].bidPrice>0">.</span><span class="la-value-fcy">{{ marketArray[$index + 1][1].instruments[0].bidPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-left volume" ng-show=" marketArray[$index + 1][1].instruments[0].bidVolume>0">{{ marketArray[$index + 1][1].instruments[0].bidVolume | number:2}}</div></div><div class="col-md-6 box-buy box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'BUYY\', \'SPOT\', marketArray[$index + 1][1].instruments[0].offerPrice,vm.getMarkData(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).settlementDate, vm.getMarkData(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status,marketArray[$index + 1][0]);"><div class="text-align-left price">{{ marketArray[$index + 1][1].instruments[0].offerPrice | split:\'.\':\'0\'}}<span ng-show=" marketArray[$index + 1][1].instruments[0].offerPrice>0">.</span><span class="la-value-fcy">{{ marketArray[$index + 1][1].instruments[0].offerPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-right volume" ng-show=" marketArray[$index + 1][1].instruments[0].offerVolume>0">{{ marketArray[$index + 1][1].instruments[0].offerVolume | number:2}}</div></div></div></div><!-- TOM --><div class="col-md-3 less-padding" ng-class="{\r\n            \'status-disabled\': vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[1].tokenSequenceNo) === \'CLOSED\' || vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[1].tokenSequenceNo) === \'HOLIDAY\' || vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[1].tokenSequenceNo) === \'UNAVAILABLE\'\r\n          }"><!-- Header row --><div class="tile-header"><span style="display:none">{{ date = vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[1].tokenSequenceNo) }} </span><!-- Show \'-\' --> <span ng-if="date && date === \'UNAVAILABLE\'">- </span><span ng-if="!date || date !== \'UNAVAILABLE\'" class="tile-date">{{ vm.getMarkData(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).settlementDate | date:\'dd-MMM-yyyy\' }} </span><span class="tile-status" ng-if="statusCash = vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[1].tokenSequenceNo)" ng-class="{\r\n            \'status-closed\': statusCash === \'CLOSED\',\r\n            \'status-holiday\': statusCash === \'HOLIDAY\',\r\n            \'status-unavailable\': statusCash === \'UNAVAILABLE\'\r\n          }">{{ statusCash | capitalizeFirst }} </span><span class="tile-ltp"><span>LTP</span> <span ng-if="statusCash === \'UNAVAILABLE\'">- </span><span ng-if="statusCash !== \'UNAVAILABLE\'" class="color-white">{{ (vm.getTickerPrice(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).ltp != null ? vm.getTickerPrice(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).ltp : vm.getTickerPrice(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).previouseDayClosingPrice) | number:4 }}</span></span></div><div class=""><div class="col-md-6">YOU SELL</div><div class="col-md-6">YOU BUY</div></div><div class="" ng-class="{\'disabled-box\': (vm.getMarkData(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).sessionTimingsDTO.status==\'CLOSED\') && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="col-md-6 box-sell box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'SELL\', \'SPOT\', marketArray[$index + 1][1].instruments[1].bidPrice,vm.getMarkData(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).settlementDate, vm.getMarkData(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).sessionTimingsDTO.status,marketArray[$index + 1][0]);"><div class="text-align-right price">{{ marketArray[$index + 1][1].instruments[1].bidPrice | split:\'.\':\'0\'}}<span ng-show=" marketArray[$index + 1][1].instruments[1].bidPrice>0">.</span><span class="la-value-fcy">{{ marketArray[$index + 1][1].instruments[1].bidPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-left volume" ng-show=" marketArray[$index + 1][1].instruments[1].bidVolume>0">{{ marketArray[$index + 1][1].instruments[1].bidVolume | number:2}}</div></div><div class="col-md-6 box-buy box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'BUYY\', \'SPOT\', marketArray[$index + 1][1].instruments[1].offerPrice,vm.getMarkData(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).settlementDate, vm.getMarkData(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).sessionTimingsDTO.status,marketArray[$index + 1][0]);"><div class="text-align-left price">{{ marketArray[$index + 1][1].instruments[1].offerPrice | split:\'.\':\'0\'}}<span ng-show=" marketArray[$index + 1][1].instruments[1].offerPrice>0">.</span><span class="la-value-fcy">{{ marketArray[$index + 1][1].instruments[1].offerPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-right volume" ng-show=" marketArray[$index + 1][1].instruments[1].offerVolume>0">{{ marketArray[$index + 1][1].instruments[1].offerVolume | number:2}}</div></div></div></div><!-- CASH --><div class="col-md-3 less-padding" ng-class="{\r\n            \'status-disabled\': vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[2].tokenSequenceNo) === \'CLOSED\' || vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[2].tokenSequenceNo) === \'HOLIDAY\' || vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[2].tokenSequenceNo) === \'UNAVAILABLE\'\r\n          }"><!-- Header row --><div class="tile-header"><span style="display:none">{{ date = vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[2].tokenSequenceNo) }} </span><!-- Show \'-\' --> <span ng-if="date && date === \'UNAVAILABLE\'">- </span><span ng-if="!date || date !== \'UNAVAILABLE\'" class="tile-date">{{ vm.getMarkData(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).settlementDate | date:\'dd-MMM-yyyy\' }}</span><div><span class="tile-status" ng-if="statusCash = vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[2].tokenSequenceNo)" ng-class="{\r\n            \'status-closed\': statusCash === \'CLOSED\',\r\n            \'status-holiday\': statusCash === \'HOLIDAY\',\r\n            \'status-unavailable\': statusCash === \'UNAVAILABLE\'\r\n          }">{{ statusCash | capitalizeFirst }}</span></div><span class="tile-ltp"><span>LTP</span> <span ng-if="statusCash === \'UNAVAILABLE\'">- </span><span ng-if="statusCash !== \'UNAVAILABLE\'" class="color-white"><span style="color: white">{{ (vm.getTickerPrice(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).ltp != null ? vm.getTickerPrice(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).ltp : vm.getTickerPrice(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).previouseDayClosingPrice) | number:4 }}</span></span></span></div><div class=""><div class="col-md-6">YOU SELL</div><div class="col-md-6">YOU BUY</div></div><div class="" ng-class="{\'disabled-box\': (vm.getMarkData(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).sessionTimingsDTO.status==\'CLOSED\') && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="col-md-6 box-sell box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'SELL\', \'SPOT\', marketArray[$index + 1][1].instruments[2].bidPrice,vm.getMarkData(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).settlementDate, vm.getMarkData(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).sessionTimingsDTO.status,marketArray[$index + 1][0]);"><div class="text-align-right price">{{ marketArray[$index + 1][1].instruments[2].bidPrice | split:\'.\':\'0\'}}<span ng-show=" marketArray[$index + 1][1].instruments[2].bidPrice>0">.</span><span class="la-value-fcy">{{ marketArray[$index + 1][1].instruments[2].bidPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-left volume" ng-show=" marketArray[$index + 1][1].instruments[2].bidVolume>0">{{ marketArray[$index + 1][1].instruments[2].bidVolume | number:2}}</div></div><div class="col-md-6 box-buy box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'BUYY\', \'SPOT\', marketArray[$index + 1][1].instruments[2].offerPrice,vm.getMarkData(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).settlementDate, vm.getMarkData(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).sessionTimingsDTO.status,marketArray[$index + 1][0]);"><div class="text-align-left price">{{ marketArray[$index + 1][1].instruments[2].offerPrice | split:\'.\':\'0\'}}<span ng-show=" marketArray[$index + 1][1].instruments[2].offerPrice>0">.</span><span class="la-value-fcy">{{ marketArray[$index + 1][1].instruments[2].offerPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-right volume" ng-show=" marketArray[$index + 1][1].instruments[2].offerVolume>0">{{ marketArray[$index + 1][1].instruments[2].offerVolume | number:2}}</div></div></div></div></div></div></div><div ng-repeat-end></div></div></div>');
$templateCache.put('app/home/home-market-depth.html','<form name="homePageReportsForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span>Currency Pair</span></h4></div><div class="modal-body"><div class="content dashboard home-page-reports"><div ng-include="\'app/home/fcy-market-depth.html\'"></div></div></div></form>');
$templateCache.put('app/home/home.html','<style>.order-price-contents .red select{\r\n\tborder: 1px solid #FF3737 !important;\r\n}</style><!-- main content starts --><!-- <form name="frmtradinghomepage" role="form" novalidate > vm.globalValues.getOrganisation().organisationType.shortName!=\'CUSTOMER\' --><div class="container-fluid dashboard" ng-show="vm.permitTradingDashboard"><!-- <div class="row" class="pinboard"\r\n      ng-show="vm.account.organisation.organisationType.shortName==\'BANK\'">\r\n      <div>\r\n         <div class="row">\r\n            <div class="col-sm-10 pinboard-border"\r\n               ng-if="vm.account.entityOwnerType.shortName==\'Bank\'">\r\n               <div class="col-xs-6 search-box">\r\n                  <cspl-ach control-model="vm.defaultTradingBranch"\r\n                     control-id="txtDefaultTradingBranch"\r\n                     lookup-name="branchesForBank"\r\n                     display-column="branchId,branchName" form="frmtradinghomepage"\r\n                     control-place-holder="Enter Branch ID or Name"></cspl-ach>\r\n               </div>\r\n               <div class="col-xs-6 search-box">\r\n                  <cspl-ach control-model="vm.defaultTradingCustomerControl"\r\n                     control-id="txtOrganisation" lookup-name="customer"\r\n                     control-place-holder="Enter Customer ID or Name"\r\n                     filter-value="{{vm.globalValues.getOrganisation().id}}~~{{vm.defaultTradingBranch.id}}~~{{0}}"\r\n                     display-column="customerCode,customerName"\r\n                     form="frmtradinghomepage"></cspl-ach>\r\n               </div>\r\n            </div>\r\n            <div class="col-sm-5 pinboard-border"\r\n               ng-if="vm.account.entityOwnerType.shortName==\'Branch\'">\r\n               <div class="search-box default-customer">\r\n                  <cspl-ach control-model="vm.defaultTradingCustomerControl"\r\n                     control-id="txtOrganisation" lookup-name="customer"\r\n                     control-place-holder="Enter Customer ID or Name"\r\n                     filter-value="{{vm.globalValues.getOrganisation().id}}~~{{vm.defaultTradingBranch.id}}~~{{0}}"\r\n                     display-column="customerCode,customerName"\r\n                     form="frmtradinghomepage"></cspl-ach>\r\n               </div>\r\n            </div>\r\n         </div>\r\n      </div>\r\n   </div> --><!-- ================= MARKET WATCH ================= --><div class="content-bot-left-wrapper" ng-show="enableOtherCurrencyTab"><div class="col-md-12 market-watch-row-fcy-header"><h3>Currency Pair</h3><div class="bcq-head pull-right text-right" ng-show="vm.showExpandIcon"><div class="bcq-head-icons" style="margin-top: -23px"><ul class="nav nav-tabs"><li><a data-toggle="tab" class="bcq-icon4" title="Expand view" ng-click="vm.expandFCYMarketDepth()"></a></li></ul></div></div><!--    \r\n            <ul style="text-align: right;" src="assets/images/expand_widget_light.png" class="nav nav-tabs">\r\n            <li><a data-toggle="tab" class="bcq-icon3"\r\n               title="ExpandData" ng-click="vm.expandFCYMarketDepth()"></a></li>\r\n            </ul> --><div class="col-md-6" style="margin-top: 5px"><div class="row" style="background-color: black;padding: 5px;border-radius: 5px;margin-right: 10px"><div class="col-md-3"></div><div class="col-md-3 text-center"><div>SPOT <span style="margin-left: 3px" class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Settlement Date T+2 " tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span></div></div><div class="col-md-3 text-center"><div>TOM <span style="margin-left: 3px" class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Settlement Date T+1 " tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span></div></div><div class="col-md-3 text-center"><div>CASH <span style="margin-left: 3px" class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Settlement Date Today" tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span></div></div></div></div><div class="col-md-6" style="margin-top: 5px"><div class="row" style="background-color: black;padding: 5px;border-radius: 5px;margin-left:-4px;margin-right: 14px"><div class="col-md-3"></div><div class="col-md-3 text-center"><div>SPOT <span style="margin-left: 3px" class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Settlement Date T+2 " tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span></div></div><div class="col-md-3 text-center"><div>TOM <span style="margin-left: 3px" class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Settlement Date T+1 " tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span></div></div><div class="col-md-3 text-center"><div>CASH <span class="icon" style="margin-left: 3px" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Settlement Date Today" tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span></div></div></div></div></div><div style="height: 367px; overflow: auto; position: relative;padding-right: 2px"><div class="row market-watch-row-fcy no-curve-border" ng-repeat-start="row in marketArray track by row[0]" ng-if="$even"><!-- LEFT currency --><div class="col-md-6" style="margin-top: 5px;margin-bottom: 5px"><div class="row" style="background-color: black;padding: 5px;text-align: center;border-radius:5px"><div class="col-md-3" style="text-align: center;display: flex;align-items: center;padding: 3%">{{ row[1].baseCurrency }}/INR</div><!-- SPOT --><div class="col-md-3 less-padding" ng-class="{\r\n            \'status-disabled\': vm.getInstrumentStatus(row[1].instruments[0].tokenSequenceNo) === \'CLOSED\' || vm.getInstrumentStatus(row[1].instruments[0].tokenSequenceNo) === \'HOLIDAY\' || vm.getInstrumentStatus(row[1].instruments[0].tokenSequenceNo) === \'UNAVAILABLE\'\r\n          }"><!-- Header row --><div class="tile-header"><span class="tile-date"><!-- Assign status once --> <span style="display:none">{{ date = vm.getInstrumentStatus(row[1].instruments[0].tokenSequenceNo) }} </span><!-- Show \'-\' --> <span ng-if="date && date === \'UNAVAILABLE\'">- </span><!-- Show date --> <span ng-if="!date || date !== \'UNAVAILABLE\'" class="color-white">{{ vm.getMarkData(row[1].instruments[0].tokenSequenceNo).settlementDate | date:\'dd-MMM-yyyy\' }}</span></span><div><span class="tile-status" ng-if="status = vm.getInstrumentStatus(row[1].instruments[0].tokenSequenceNo)" ng-class="{\r\n            \'status-closed\': status === \'CLOSED\',\r\n            \'status-holiday\': status === \'HOLIDAY\',\r\n            \'status-unavailable\': status === \'UNAVAILABLE\'\r\n          }">{{ status | capitalizeFirst }}</span></div><span class="tile-ltp"><span>LTP</span> <span ng-if="status === \'UNAVAILABLE\'">- </span><!-- Show LTP for other statuses --> <span ng-if="status !== \'UNAVAILABLE\'" class="color-white">{{ vm.getTickerPrice(row[1].instruments[0].tokenSequenceNo).ltp ? vm.getTickerPrice(row[1].instruments[0].tokenSequenceNo).ltp : vm.getTickerPrice(row[1].instruments[0].tokenSequenceNo).previouseDayClosingPrice | number:4 }}</span></span></div><div class=""><div class="col-md-6">YOU SELL</div><div class="col-md-6">YOU BUY</div></div><div class="" ng-class="{\'disabled-box\': (vm.getMarkData(row[1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status==\'CLOSED\') && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="col-md-6 box-sell box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'SELL\', \'SPOT\', row[1].instruments[0].bidPrice,vm.getMarkData(row[1].instruments[0].tokenSequenceNo).settlementDate, vm.getMarkData(row[1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status,row[0]);"><div class="text-align-right price">{{ row[1].instruments[0].bidPrice | split:\'.\':\'0\'}}<span ng-show="row[1].instruments[0].bidPrice>0">.</span><span class="la-value-fcy">{{ row[1].instruments[0].bidPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-left volume" ng-show="row[1].instruments[0].bidVolume>0">{{ row[1].instruments[0].bidVolume | number:2}}</div></div><div class="col-md-6 box-buy box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'BUYY\', \'SPOT\', row[1].instruments[0].offerPrice,vm.getMarkData(row[1].instruments[0].tokenSequenceNo).settlementDate, vm.getMarkData(row[1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status,row[0]);"><div class="text-align-left price">{{ row[1].instruments[0].offerPrice | split:\'.\':\'0\'}}<span ng-show="row[1].instruments[0].offerPrice>0">.</span><span class="la-value-fcy">{{ row[1].instruments[0].offerPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-right volume" ng-show="row[1].instruments[0].offerVolume>0">{{ row[1].instruments[0].offerVolume | number:2}}</div></div></div></div><!-- TOM --><div class="col-md-3 less-padding" ng-class="{\r\n            \'status-disabled\': vm.getInstrumentStatus(row[1].instruments[1].tokenSequenceNo) === \'CLOSED\' || vm.getInstrumentStatus(row[1].instruments[1].tokenSequenceNo) === \'HOLIDAY\' || vm.getInstrumentStatus(row[1].instruments[1].tokenSequenceNo) === \'UNAVAILABLE\'\r\n          }"><!-- Header row --><div class="tile-header"><span class="tile-date"><span style="display:none">{{ date = vm.getInstrumentStatus(row[1].instruments[1].tokenSequenceNo) }} </span><!-- Show \'-\' --> <span ng-if="date && date === \'UNAVAILABLE\'">- </span><!-- Show date --> <span ng-if="!date || date !== \'UNAVAILABLE\'" class="color-white">{{ vm.getMarkData(row[1].instruments[1].tokenSequenceNo).settlementDate | date:\'dd-MMM-yyyy\' }}</span></span><div><span class="tile-status" ng-if="statusTom = vm.getInstrumentStatus(row[1].instruments[1].tokenSequenceNo)" ng-class="{\r\n            \'status-closed\': statusTom === \'CLOSED\',\r\n            \'status-holiday\': statusTom === \'HOLIDAY\',\r\n            \'status-unavailable\': statusTom === \'UNAVAILABLE\'\r\n          }">{{ statusTom | capitalizeFirst }}</span></div><span class="tile-ltp"><span>LTP</span> <span ng-if="statusTom === \'UNAVAILABLE\'">- </span><!-- Show LTP for other statuses --> <span ng-if="statusTom !== \'UNAVAILABLE\'" class="color-white">{{ vm.getTickerPrice(row[1].instruments[1].tokenSequenceNo).ltp ? vm.getTickerPrice(row[1].instruments[1].tokenSequenceNo).ltp : vm.getTickerPrice(row[1].instruments[1].tokenSequenceNo).previouseDayClosingPrice | number:4 }}</span></span></div><div class=""><div class="col-md-6">YOU SELL</div><div class="col-md-6">YOU BUY</div></div><div class="" ng-class="{\'disabled-box\': (vm.getMarkData(row[1].instruments[1].tokenSequenceNo).sessionTimingsDTO.status==\'CLOSED\') && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="col-md-6 box-sell box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'SELL\', \'TOM\', row[1].instruments[1].bidPrice,vm.getMarkData(row[1].instruments[1].tokenSequenceNo).settlementDate, vm.getMarkData(row[1].instruments[1].tokenSequenceNo).sessionTimingsDTO.status,row[0]);"><div class="text-align-right price">{{ row[1].instruments[1].bidPrice | split:\'.\':\'0\'}}<span ng-show="row[1].instruments[1].bidPrice>0">.</span><span class="la-value-fcy">{{ row[1].instruments[1].bidPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-left volume" ng-show="row[1].instruments[1].bidVolume>0">{{ row[1].instruments[1].bidVolume | number:2}}</div></div><div class="col-md-6 box-buy box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'BUYY\', \'TOM\', row[1].instruments[1].offerPrice, vm.getMarkData(row[1].instruments[1].tokenSequenceNo).settlementDate, vm.getMarkData(row[1].instruments[1].tokenSequenceNo).sessionTimingsDTO.status,row[0]);"><div class="text-align-left price">{{ row[1].instruments[1].offerPrice | split:\'.\':\'0\'}}<span ng-show="row[1].instruments[1].offerPrice>0">.</span><span class="la-value-fcy">{{ row[1].instruments[1].offerPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-right volume" ng-show="row[1].instruments[1].offerVolume>0">{{ row[1].instruments[1].offerVolume | number:2}}</div></div></div></div><!-- CASH --><div class="col-md-3 less-padding" ng-class="{\r\n            \'status-disabled\': vm.getInstrumentStatus(row[1].instruments[2].tokenSequenceNo) === \'CLOSED\' || vm.getInstrumentStatus(row[1].instruments[2].tokenSequenceNo) === \'HOLIDAY\' || vm.getInstrumentStatus(row[1].instruments[2].tokenSequenceNo) === \'UNAVAILABLE\'\r\n          }"><div class="tile-header"><span class="tile-date"><span style="display:none">{{ date = vm.getInstrumentStatus(row[1].instruments[2].tokenSequenceNo) }} </span><!-- Show \'-\' --> <span ng-if="date && date === \'UNAVAILABLE\'">- </span><!-- Show date --> <span ng-if="!date || date !== \'UNAVAILABLE\'" class="color-white">{{ vm.getMarkData(row[1].instruments[2].tokenSequenceNo).settlementDate | date:\'dd-MMM-yyyy\' }}</span></span><div><span class="tile-status" ng-if="statusCash = vm.getInstrumentStatus(row[1].instruments[2].tokenSequenceNo)" ng-class="{\r\n            \'status-closed\': statusCash === \'CLOSED\',\r\n            \'status-holiday\': statusCash === \'HOLIDAY\',\r\n            \'status-unavailable\': statusCash === \'UNAVAILABLE\'\r\n          }">{{ statusCash | capitalizeFirst }}</span></div><span class="tile-ltp"><span>LTP</span> <span ng-if="statusCash === \'UNAVAILABLE\'">- </span><!-- Show LTP for other statuses --> <span ng-if="statusCash !== \'UNAVAILABLE\'" class="color-white">{{ vm.getTickerPrice(row[1].instruments[2].tokenSequenceNo).ltp ? vm.getTickerPrice(row[1].instruments[2].tokenSequenceNo).ltp : vm.getTickerPrice(row[1].instruments[2].tokenSequenceNo).previouseDayClosingPrice | number:4 }}</span></span></div><div class=""><div class="col-md-6">YOU SELL</div><div class="col-md-6">YOU BUY</div></div><div class="" ng-class="{\'disabled-box\': (vm.getMarkData(row[1].instruments[2].tokenSequenceNo).sessionTimingsDTO.status==\'CLOSED\') && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="col-md-6 box-sell box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'SELL\', \'CASH\', row[1].instruments[2].bidPrice,vm.getMarkData(row[1].instruments[2].tokenSequenceNo).settlementDate, vm.getMarkData(row[1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status,row[0]);"><div class="text-align-right price">{{ row[1].instruments[2].bidPrice | split:\'.\':\'0\'}}<span ng-show="row[1].instruments[2].bidPrice>0">.</span><span class="la-value-fcy">{{ row[1].instruments[2].bidPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-left volume" ng-show="row[1].instruments[2].bidVolume>0">{{ row[1].instruments[2].bidVolume | number:2}}</div></div><div class="col-md-6 box-buy box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'BUYY\', \'CASH\', row[1].instruments[2].offerPrice,vm.getMarkData(row[1].instruments[2].tokenSequenceNo).settlementDate, vm.getMarkData(row[1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status,row[0]);"><div class="text-align-left price">{{ row[1].instruments[2].offerPrice | split:\'.\':\'0\'}}<span ng-show="row[1].instruments[2].offerPrice>0">.</span><span class="la-value-fcy">{{ row[1].instruments[2].offerPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-right volume" ng-show="row[1].instruments[2].offerVolume>0">{{ row[1].instruments[2].offerVolume | number:2}}</div></div></div></div></div></div><!-- RIGHT currency --><div class="col-md-6" style="margin-top: 5px;margin-bottom: 5px" ng-if="marketArray[$index + 1]"><div class="row" style="background-color: black;padding: 5px;text-align: center;border-radius:5px"><div class="col-md-3" style="text-align: center;display: flex;align-items: center;padding: 3%">{{ marketArray[$index + 1][1].baseCurrency }}/INR</div><div class="col-md-3 less-padding" ng-class="{\r\n            \'status-disabled\': vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[0].tokenSequenceNo) === \'CLOSED\' || vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[0].tokenSequenceNo) === \'HOLIDAY\' || vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[0].tokenSequenceNo) === \'UNAVAILABLE\'\r\n          }"><!-- Header row --><div class="tile-header"><span class="tile-date"><!-- Assign status once --> <span style="display:none">{{ date = vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[0].tokenSequenceNo) }} </span><!-- Show \'-\' --> <span ng-if="date && date === \'UNAVAILABLE\'">- </span><!-- Show date --> <span ng-if="!date || date !== \'UNAVAILABLE\'" class="color-white">{{ vm.getMarkData(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).settlementDate | date:\'dd-MMM-yyyy\' }}</span></span><div><span class="tile-status" ng-if="statusSpotRight = vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[0].tokenSequenceNo)" ng-class="{\r\n            \'status-closed\': statusSpotRight === \'CLOSED\',\r\n            \'status-holiday\': statusSpotRight === \'HOLIDAY\',\r\n            \'status-unavailable\': statusSpotRight === \'UNAVAILABLE\'\r\n          }">{{ statusSpotRight | capitalizeFirst }}</span></div><span class="tile-ltp"><span>LTP</span> <span ng-if=" statusSpotRight === \'UNAVAILABLE\'">- </span><!-- Show LTP for other statuses --> <span ng-if="statusSpotRight !== \'UNAVAILABLE\'" class="color-white">{{ (vm.getTickerPrice(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).ltp != null ? vm.getTickerPrice(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).ltp : vm.getTickerPrice(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).previouseDayClosingPrice) | number:4 }}</span></span></div><div><div class="col-md-6">YOU SELL</div><div class="col-md-6">YOU BUY</div></div><div class="" ng-class="{\'disabled-box\': (vm.getMarkData(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status==\'CLOSED\') && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="col-md-6 box-sell box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'SELL\', \'SPOT\', marketArray[$index + 1][1].instruments[0].bidPrice,vm.getMarkData(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).settlementDate, vm.getMarkData(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status,marketArray[$index + 1][0]);"><div class="text-align-right price">{{ marketArray[$index + 1][1].instruments[0].bidPrice | split:\'.\':\'0\'}}<span ng-show=" marketArray[$index + 1][1].instruments[0].bidPrice>0">.</span><span class="la-value-fcy">{{ marketArray[$index + 1][1].instruments[0].bidPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-left volume" ng-show=" marketArray[$index + 1][1].instruments[0].bidVolume>0">{{ marketArray[$index + 1][1].instruments[0].bidVolume | number:2}}</div></div><div class="col-md-6 box-buy box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'BUYY\', \'SPOT\', marketArray[$index + 1][1].instruments[0].offerPrice,vm.getMarkData(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).settlementDate, vm.getMarkData(marketArray[$index + 1][1].instruments[0].tokenSequenceNo).sessionTimingsDTO.status,marketArray[$index + 1][0]);"><div class="text-align-left price">{{ marketArray[$index + 1][1].instruments[0].offerPrice | split:\'.\':\'0\'}}<span ng-show=" marketArray[$index + 1][1].instruments[0].offerPrice>0">.</span><span class="la-value-fcy">{{ marketArray[$index + 1][1].instruments[0].offerPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-right volume" ng-show=" marketArray[$index + 1][1].instruments[0].offerVolume>0">{{ marketArray[$index + 1][1].instruments[0].offerVolume | number:2}}</div></div></div></div><!-- TOM --><div class="col-md-3 less-padding" ng-class="{\r\n            \'status-disabled\': vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[1].tokenSequenceNo) === \'CLOSED\' || vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[1].tokenSequenceNo) === \'HOLIDAY\' || vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[1].tokenSequenceNo) === \'UNAVAILABLE\'\r\n          }"><!-- Header row --><div class="tile-header"><span class="tile-date"><!-- Assign status once --> <span style="display:none">{{ date = vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[1].tokenSequenceNo) }} </span><!-- Show \'-\' --> <span ng-if="date && date === \'UNAVAILABLE\'">- </span><!-- Show date --> <span ng-if="!date || date !== \'UNAVAILABLE\'" class="color-white">{{ vm.getMarkData(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).settlementDate | date:\'dd-MMM-yyyy\' }}</span></span><div><span class="tile-status" ng-if="statusTOMRight = vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[1].tokenSequenceNo)" ng-class="{\r\n            \'status-closed\': statusTOMRight === \'CLOSED\',\r\n            \'status-holiday\': statusTOMRight === \'HOLIDAY\',\r\n            \'status-unavailable\': statusTOMRight === \'UNAVAILABLE\'\r\n          }">{{ statusTOMRight | capitalizeFirst }}</span></div><span class="tile-ltp"><span>LTP</span> <span ng-if="statusTOMRight === \'UNAVAILABLE\'">- </span><!-- Show LTP for other statuses --> <span ng-if="statusTOMRight !== \'UNAVAILABLE\'" class="color-white">{{ (vm.getTickerPrice(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).ltp != null ? vm.getTickerPrice(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).ltp : vm.getTickerPrice(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).previouseDayClosingPrice) | number:4 }}</span></span></div><div class=""><div class="col-md-6">YOU SELL</div><div class="col-md-6">YOU BUY</div></div><div class="" ng-class="{\'disabled-box\': (vm.getMarkData(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).sessionTimingsDTO.status==\'CLOSED\') && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="col-md-6 box-sell box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'SELL\', \'TOM\', marketArray[$index + 1][1].instruments[1].bidPrice,vm.getMarkData(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).settlementDate, vm.getMarkData(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).sessionTimingsDTO.status,marketArray[$index + 1][0]);"><div class="text-align-right price">{{ marketArray[$index + 1][1].instruments[1].bidPrice | split:\'.\':\'0\'}}<span ng-show=" marketArray[$index + 1][1].instruments[1].bidPrice>0">.</span><span class="la-value-fcy">{{ marketArray[$index + 1][1].instruments[1].bidPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-left volume" ng-show=" marketArray[$index + 1][1].instruments[1].bidVolume>0">{{ marketArray[$index + 1][1].instruments[1].bidVolume | number:2}}</div></div><div class="col-md-6 box-buy box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'BUYY\', \'TOM\', marketArray[$index + 1][1].instruments[1].offerPrice,vm.getMarkData(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).settlementDate, vm.getMarkData(marketArray[$index + 1][1].instruments[1].tokenSequenceNo).sessionTimingsDTO.status,marketArray[$index + 1][0]);"><div class="text-align-left price">{{ marketArray[$index + 1][1].instruments[1].offerPrice | split:\'.\':\'0\'}}<span ng-show=" marketArray[$index + 1][1].instruments[1].offerPrice>0">.</span><span class="la-value-fcy">{{ marketArray[$index + 1][1].instruments[1].offerPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-right volume" ng-show=" marketArray[$index + 1][1].instruments[1].offerVolume>0">{{ marketArray[$index + 1][1].instruments[1].offerVolume | number:2}}</div></div></div></div><!-- CASH --><div class="col-md-3 less-padding" ng-class="{\r\n            \'status-disabled\': vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[2].tokenSequenceNo) === \'CLOSED\' || vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[2].tokenSequenceNo) === \'HOLIDAY\' || vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[2].tokenSequenceNo) === \'UNAVAILABLE\'\r\n          }"><!-- Header row --><div class="tile-header"><span class="tile-date"><!-- Assign status once --> <span style="display:none">{{ date = vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[2].tokenSequenceNo) }} </span><!-- Show \'-\' --> <span ng-if="date && date === \'UNAVAILABLE\'">- </span><!-- Show date --> <span ng-if="!date || date !== \'UNAVAILABLE\'" class="color-white">{{ vm.getMarkData(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).settlementDate | date:\'dd-MMM-yyyy\' }}</span></span><div><span class="tile-status" ng-if="statusCASHRight = vm.getInstrumentStatus(marketArray[$index + 1][1].instruments[2].tokenSequenceNo)" ng-class="{\r\n            \'status-closed\': statusCASHRight === \'CLOSED\',\r\n            \'status-holiday\': statusCASHRight === \'HOLIDAY\',\r\n            \'status-unavailable\': statusCASHRight === \'UNAVAILABLE\'\r\n          }">{{statusCASHRight | capitalizeFirst}}</span></div><span class="tile-ltp"><span>LTP</span> <span ng-if=" statusCASHRight === \'UNAVAILABLE\'">- </span><!-- Show LTP for other statuses --> <span ng-if="statusCASHRight !== \'UNAVAILABLE\'" class="color-white">{{ (vm.getTickerPrice(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).ltp != null ? vm.getTickerPrice(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).ltp : vm.getTickerPrice(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).previouseDayClosingPrice) | number:4 }}</span></span></div><div class=""><div class="col-md-6">YOU SELL</div><div class="col-md-6">YOU BUY</div></div><div class="" ng-class="{\'disabled-box\': (vm.getMarkData(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).sessionTimingsDTO.status==\'CLOSED\') && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="col-md-6 box-sell box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'SELL\', \'CASH\', marketArray[$index + 1][1].instruments[2].bidPrice,vm.getMarkData(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).settlementDate, vm.getMarkData(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).sessionTimingsDTO.status,marketArray[$index + 1][0]);"><div class="text-align-right price">{{ marketArray[$index + 1][1].instruments[2].bidPrice | split:\'.\':\'0\'}}<span ng-show=" marketArray[$index + 1][1].instruments[2].bidPrice>0">.</span><span class="la-value-fcy">{{ marketArray[$index + 1][1].instruments[2].bidPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-left volume" ng-show=" marketArray[$index + 1][1].instruments[2].bidVolume>0">{{ marketArray[$index + 1][1].instruments[2].bidVolume | number:2}}</div></div><div class="col-md-6 box-buy box-container" style="border-radius: 0px !important;margin:0px !important;min-height: 6vh !important" ng-click="vm.prepareOrderDTOFromMarketWatch(\'BUYY\', \'CASH\', marketArray[$index + 1][1].instruments[2].offerPrice,vm.getMarkData(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).settlementDate, vm.getMarkData(marketArray[$index + 1][1].instruments[2].tokenSequenceNo).sessionTimingsDTO.status,marketArray[$index + 1][0]);"><div class="text-align-left price">{{ marketArray[$index + 1][1].instruments[2].offerPrice | split:\'.\':\'0\'}}<span ng-show=" marketArray[$index + 1][1].instruments[2].offerPrice>0">.</span><span class="la-value-fcy">{{ marketArray[$index + 1][1].instruments[2].offerPrice | number:4 | split:\'.\':\'1\'}}</span></div><div class="text-align-right volume" ng-show=" marketArray[$index + 1][1].instruments[2].offerVolume>0">{{ marketArray[$index + 1][1].instruments[2].offerVolume | number:2}}</div></div></div></div></div></div></div><div ng-repeat-end></div></div></div><div class="row" id="marketwatchdiv" ng-show="!enableOtherCurrencyTab" ng-click="vm.removeOrderEntryFocus()"><div class="col-md-5-5 col-md-left"><div class="market-depth market-watch no-curve-border"><div class=""><div class="row market-watch-row no-curve-border"><div style="height: 160px"><div class="col-md-6 less-padding"><div class="small-box spot-box" ng-class="{\'disabled-box\': (retailSpotMarketSession.sessionTimingsDTO.status==\'CLOSED\' || retailSpotMarketSession.isSettlementDateHoliday==true) && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="box-top"><div class="pull-left"><div><h4 class="box-heading">SPOT</h4></div><div><span class="value-highlighted-txt market-watch-sett-date">{{retailSpotMarketSession.settlementDate | date: \'dd-MMM-yyyy\'}}</span></div></div><div class="pull-right text-right"><div class="textAlignCenter"><h4 class="box-heading" style="margin-right:0px; margin-left:10px; width: 100%">LTP</h4></div><div><span><span class="value-highlighted-txt">{{tickerPrice.retailSpot | split:\'.\':\'0\'}}.</span> <span class="value-highlighted-txt" ng-class="{\'value-highlighted-txt-decimal-up-trend\': tickerPrice.retailSpotDifference>0, \'value-highlighted-txt-decimal-down-trend\':tickerPrice.retailSpotDifference<0, \'value-highlighted-txt-decimal-equal-trend\':tickerPrice.retailSpotDifference==0}">{{tickerPrice.retailSpot | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span> <span ng-class="{\'market-watch-up-trend\': tickerPrice.retailSpotDifference>0, \'market-watch-down-trend\':tickerPrice.retailSpotDifference<0, \'market-watch-equal-trend\':tickerPrice.retailSpotDifference==0}"></span></span></div></div><div class="clearfix"></div></div><!--box-top ends--><!-- box-content --><div class="box-content"><div class="box-buy-sell" ng-class="{\'disabled-box\': ((retailSpotMarketWatch.bidPrice<=0 || retailSpotMarketWatch.bidPrice==null || retailSpotMarketWatch.bidPrice==undefined) || vm.defaultTradingCustomer==null) && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="box-sell" ng-class="{\'disabled-btn\': vm.permitNewOrderEntry==false && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="la-wrapper"><button class="btn-sell-buy" id="spotMktSell" ng-disabled="vm.orderVolumeSpotMkt==undefined || vm.orderVolumeSpotMkt==\'\' || retailSpotMarketSession.sessionTimingsDTO.status==\'CLOSED\' || retailSpotMarketSession.isSettlementDateHoliday==true || \r\n\t\t\t\t\t\t\t\t\t\t\t\t vm.defaultTradingCustomer==null || (vm.permitTradingDashboard==true && vm.permitNewOrderEntry==false) || \r\n\t\t\t\t\t\t\t\t\t\t\t\t retailSpotMarketWatch.bidPrice<=0 || retailSpotMarketWatch.bidPrice==null || retailSpotMarketWatch.bidPrice==undefined" ng-click="vm.prepareOrderDTOFromMarketWatch(\'SELL\', \'SPOT\', retailSpotMarketWatch.bidPrice, retailSpotMarketSession.settlementDate, retailSpotMarketSession.sessionTimingsDTO.status);" ng-show="vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'"><span ng-show="vm.permitNewOrderEntry">You Sell</span><span ng-show="vm.permitNewOrderEntry==false">Sell</span></button> <button ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'" class="btn-sell-buy btn-sell-border cursor-default">SELL</button></div><div class="la-wrapper text-right" ng-class="{\'ib-mkt-price\': vm.account.organisation.organisationType.shortName==\'CLEARCORP\'}"><p class="la-count" ng-show="retailSpotMarketSession.sessionTimingsDTO.status==\'OPEN\' && retailSpotMarketWatch.bidPrice!=null && retailSpotMarketWatch.bidPrice!=undefined && retailSpotMarketWatch.bidPrice>0">{{retailSpotMarketWatch.bidPrice | split:\'.\':\'0\'}}<span ng-show="retailSpotMarketWatch.bidPrice>0">.</span><span class="la-value">{{retailSpotMarketWatch.bidPrice | number:4 | split:\'.\':\'1\'}}</span></p></div><div class="la-wrapper"><div class="la-class" ng-show="retailSpotMarketSession.sessionTimingsDTO.status==\'OPEN\' && retailSpotMarketWatch.bidVolume>0">{{retailSpotMarketWatch.bidVolume | number : 2}}</div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="box-buy-sell" ng-class="{\'disabled-box\': ((retailSpotMarketWatch.offerPrice==null || retailSpotMarketWatch.offerPrice==undefined || retailSpotMarketWatch.offerPrice<=0) || vm.defaultTradingCustomer==null) && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="box-buy" ng-class="{\'disabled-btn\': vm.permitNewOrderEntry==false && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div class="la-wrapper text-right"><button class="btn-sell-buy" id="spotMktBuy" ng-disabled="vm.orderVolumeSpotMkt==undefined || vm.orderVolumeSpotMkt==\'\' || retailSpotMarketSession.sessionTimingsDTO.status==\'CLOSED\' || retailSpotMarketSession.isSettlementDateHoliday==true || \r\n\t\t\t\t\t\t\t\t\t\t\tvm.defaultTradingCustomer==null || (vm.permitTradingDashboard==true && vm.permitNewOrderEntry==false) ||  \r\n\t\t\t\t\t\t\t\t\t\t\t retailSpotMarketWatch.offerPrice==null || retailSpotMarketWatch.offerPrice==undefined || retailSpotMarketWatch.offerPrice<=0" ng-click="vm.prepareOrderDTOFromMarketWatch(\'BUYY\', \'SPOT\', retailSpotMarketWatch.offerPrice, retailSpotMarketSession.settlementDate, retailSpotMarketSession.sessionTimingsDTO.status);" ng-show="vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'"><span ng-show="vm.permitNewOrderEntry">You Buy</span><span ng-show="vm.permitNewOrderEntry==false">Buy</span></button> <button ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'" class="btn-sell-buy btn-buy-border cursor-default">BUY</button></div><div class="la-wrapper" ng-class="{\'ib-mkt-price\': vm.account.organisation.organisationType.shortName==\'CLEARCORP\'}"><p class="la-count" ng-show="retailSpotMarketSession.sessionTimingsDTO.status==\'OPEN\' && retailSpotMarketWatch.offerPrice!=null && retailSpotMarketWatch.offerPrice!=undefined && retailSpotMarketWatch.offerPrice>0">{{retailSpotMarketWatch.offerPrice | split:\'.\':\'0\'}}<span ng-show="retailSpotMarketWatch.offerPrice>0">.</span><span class="la-value">{{retailSpotMarketWatch.offerPrice | number:4 | split:\'.\':\'1\'}}</span></p></div><div class="la-wrapper text-right"><div class="la-class" ng-show="retailSpotMarketSession.sessionTimingsDTO.status==\'OPEN\' && retailSpotMarketWatch.offerVolume>0"><span class="text">{{retailSpotMarketWatch.offerVolume | number : 2}}</span></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --></div><!-- box-content ends --></div></div><div class="col-md-6 less-padding"><div class="small-box ib-spot-box"><div class="box-top"><div class="pull-left"><div><h4 class="row box-heading">Interbank SPOT</h4></div><div><span class="value-highlighted-txt market-watch-sett-date">{{retailSpotMarketSession.settlementDate | date: \'dd-MMM-yyyy\'}}</span></div></div><div class="pull-right text-right"><div class="textAlignCenter"><h4 class="row box-heading" style="margin-right:0px; margin-left:10px; width: 100%">LTP</h4></div><div><span><span class="value-highlighted-txt">{{tickerPrice.ibSpot | split:\'.\':\'0\'}}.</span> <span class="value-highlighted-txt" ng-class="{\'value-highlighted-txt-decimal-up-trend\': tickerPrice.ibSpotDifference>0, \'value-highlighted-txt-decimal-down-trend\':tickerPrice.ibSpotDifference<0, \'value-highlighted-txt-decimal-equal-trend\':tickerPrice.ibSpotDifference==0}">{{tickerPrice.ibSpot | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span> <span ng-class="{\'market-watch-up-trend\': tickerPrice.ibSpotDifference>0, \'market-watch-down-trend\':tickerPrice.ibSpotDifference<0, \'market-watch-equal-trend\':tickerPrice.ibSpotDifference==0}"></span></span></div></div><div class="clearfix"></div></div><!--box-top ends--><!-- box-content --><div class="box-content"><div class="box-buy-sell"><div class="box-sell"><div class="la-wrapper"><button class="btn-sell-buy btn-sell-border" id="ibspotMktSell">SELL</button></div><div class="la-wrapper text-right" ng-class="{\'ib-mkt-price\': vm.account.organisation.organisationType.shortName==\'CLEARCORP\'}"><p class="la-count" ng-show="ibSpotMarketWatch.bidPrice!=null && ibSpotMarketWatch.bidPrice!=undefined && ibSpotMarketWatch.bidPrice>0">{{ibSpotMarketWatch.bidPrice | split:\'.\':\'0\'}}<span ng-show="ibSpotMarketWatch.bidPrice>0">.</span><span class="la-value">{{ibSpotMarketWatch.bidPrice | number:4 | split:\'.\':\'1\'}}</span></p></div><div class="la-wrapper"><div class="la-class" ng-show="ibSpotMarketWatch.bidVolume>0">{{ibSpotMarketWatch.bidVolume | number:0}}</div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="box-buy-sell"><div class="box-buy"><div class="la-wrapper text-right"><button class="btn-sell-buy btn-buy-border" id="ibspotMktBuy">BUY</button></div><div class="la-wrapper" ng-class="{\'ib-mkt-price\': vm.account.organisation.organisationType.shortName==\'CLEARCORP\'}"><p class="la-count" ng-show="ibSpotMarketWatch.offerPrice!=null && ibSpotMarketWatch.offerPrice!=undefined && ibSpotMarketWatch.offerPrice>0">{{ibSpotMarketWatch.offerPrice | split:\'.\':\'0\'}}<span ng-show="ibSpotMarketWatch.offerPrice>0">.</span><span class="la-value">{{ibSpotMarketWatch.offerPrice | number:4 | split:\'.\':\'1\'}}</span></p></div><div class="la-wrapper text-right"><div class="la-class" ng-show="ibSpotMarketWatch.offerVolume>0">{{ibSpotMarketWatch.offerVolume| number:0}}</div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --></div><!-- box-content ends --></div></div></div></div><div class="market-depth-contents-bottom pin-board"><div class="row market-depth-contents no-curve-border"><div><table class="table"><thead><tr><th class="col-xs-4" ng-class="{\'bank-view\': vm.account.organisation.organisationType.shortName==\'BANK\', \r\n\t\t\t                        \'selected\' : vm.account.organisation.organisationType.shortName==\'CLEARCORP\'}"><!-- <span class="box-icon showing-for col-sm"\r\n\t\t\t\t                           ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" style="vertical-align: center;">\r\n\t\t\t\t                        \t<span title="{{vm.tradingBank.shortName}}" class="comp-name">{{vm.tradingBank.shortName}}</span>\r\n\t\t\t\t                        </span> --><div class="search-box width-90" ng-if="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.defaultTradingBankControl" control-id="txttradingBankPinboard" lookup-name="tradingBank" show-error-text="true" filter-value="{{vm.account.organisation.id}}" display-column="bankName" control-place-holder="Enter bank name" control-required="false" title="{{vm.defaultTradingBank.bankName}}"></cspl-ach></div><div class="search-box width-90" ng-if=" vm.account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.defaultTradingBankControl" control-id="txttradingBankPinboard" lookup-name="bank" show-error-text="true" display-column="bankName" control-place-holder="Enter bank name" control-required="false" title="{{vm.defaultTradingBank.bankName}}"></cspl-ach></div><div class="search-box width-90" ng-if="vm.account.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.defaultTradingCustomerControl" control-id="txtDefaultTradingCustomer" lookup-name="customer" filter-value="{{vm.tradingBank.id}}~~{{0}}~~{{0}}" display-column="customerCode,customerName" show-error-text="true" control-place-holder="Enter Customer ID or Name" control-required="false" title="{{vm.defaultTradingCustomerControl.customerName}}"></cspl-ach></div><div class="search-box width-90" ng-if="vm.account.entityOwnerType.shortName==\'Branch\'"><cspl-ach control-model="vm.defaultTradingCustomerControl" control-id="txtDefaultTradingCustomer" lookup-name="customer" filter-value="{{vm.tradingBank.id}}~~{{vm.tradingBranch.id}}~~{{0}}" display-column="customerCode,customerName" show-error-text="true" control-place-holder="Enter Customer ID or Name" control-required="false" title="{{vm.defaultTradingCustomerControl.customerName}}"></cspl-ach></div></th><th class="col-xs-2" style="vertical-align: center">&nbsp;&nbsp;YOU SELL</th><th class="col-xs-2">&nbsp;&nbsp;YOU BUY</th><th class="col-xs-2-5" style="vertical-align: center">Settlement Date</th><th class="col-xs-1-5" style="vertical-align: center"><img class="reset-mkt-watch" src="assets/images/reset_icon.png" alt="Reset" title="Restore Market Watch" role="button" tabindex="0" ng-keydown="($event.keyCode === 13 || $event.keyCode === 32) ? vm.resetUserMarketWatch() : null" ng-click="vm.resetUserMarketWatch();"></th></tr></thead></table></div></div><div class="row market-depth-contents no-curve-border" style="padding-right: 2px"><div style="height: 205px; overflow: auto; position: relative;padding-right: 2px" id="userMarketWatch"><table class="table market-watch-table"><tbody ng-model="userMarketWatchList" as-sortable="sortableOptions"><tr ng-repeat="swapQuotes in userMarketWatchList" ng-mouseover="row = $index" ng-mouseleave="row = -1" as-sortable-item style="cursor: move" ng-class="{ \'market-watch-table-row-background-color\' : row != $index, \'market-watch-table-row-hover-background-color\' : row == $index}"><td class="col-xs-4 market-watch-text-column" ng-class="{\'market-watch-instrument-select\': swapQuotes.editable}"><a as-sortable-item-handle ng-hide="swapQuotes.editable" class="market-watch-reorder-icon" title="Reorder"></a><span ng-hide="swapQuotes.editable" title="{{swapQuotes.instrument}}">{{swapQuotes.tenorName}}</span><span ng-hide="swapQuotes.editable" ng-click=""><a ng-if="vm.account.organisation.organisationType.shortName == \'CUSTOMER\' && swapQuotes.sessionStatus == \'OPEN\'" class="market-watch-compare-icon" title="Compare" role="button" tabindex="0" ng-keydown="($event.keyCode === 13 || $event.keyCode === 32) ? vm.prepareOutrightComparision(swapQuotes.settlementDate, swapQuotes.instrument) : null" ng-click="vm.prepareOutrightComparision(swapQuotes.settlementDate, swapQuotes.instrument);"></a></span><div class="col-xs-12" ng-show="swapQuotes.editable"><span class="col-xs-10" style="padding-right:0px"><cspl-dtp-without-error-and-info control-model="vm.selectedInstrumentDate" control-enter-key="vm.updateRow($index)" append-to-body="true" control-id="dtpMW{{$index}}"></cspl-dtp-without-error-and-info></span><!-- <span ng-click="vm.updateRow($index)"><a\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass="market-watch-add-icon" title="Add"></a></span> --></div><!-- add the add button here --></td><td role="button" tabindex="0" aria-label="Sell {{swapQuotes.instrument}} at {{swapQuotes.bidPrice}}" ng-keydown="($event.keyCode === 13 || $event.keyCode === 32) ? vm.prepareOrderDTOFromMarketWatch(\'SELL\',swapQuotes.instrument,swapQuotes.bidPrice, swapQuotes.settlementDate, swapQuotes.sessionStatus) : null" ng-click="vm.prepareOrderDTOFromMarketWatch(\'SELL\',swapQuotes.instrument,swapQuotes.bidPrice, swapQuotes.settlementDate, swapQuotes.sessionStatus);" class="col-xs-2" ng-class="{\'market-watch-sell\': (!swapQuotes.editable && swapQuotes.bidPrice != 0), \'market-watch-instrument-select-add-button\': swapQuotes.editable,\r\n\t                                 \'market-watch-sell-disabled\': (!swapQuotes.editable && (swapQuotes.bidPrice <= 0 || swapQuotes.bidPrice == null || swapQuotes.bidPrice == undefined || swapQuotes.sessionStatus != \'OPEN\' || vm.defaultTradingCustomer==null) && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\') }"><span ng-show="swapQuotes.isBestOffer && !swapQuotes.editable && swapQuotes.bidPrice!=null && swapQuotes.bidPrice!=undefined && swapQuotes.bidPrice>0 && vm.account.organisation.organisationType.shortName == \'CUSTOMER\' && swapQuotes.sessionStatus == \'OPEN\'" class="market-watch-best-sell-container"><span class="market-watch-best-sell"></span></span> <span ng-hide="swapQuotes.editable || swapQuotes.bidPrice <= 0 || swapQuotes.bidPrice == undefined || swapQuotes.bidPrice == null || swapQuotes.sessionStatus != \'OPEN\'"><span class="value-highlighted-txt">{{swapQuotes.bidPrice | split:\'.\':\'0\'}}.&nbsp;&nbsp;</span><span class="market-watch-value-highlighted-txt-decimal value-highlighted-txt-decimal">{{swapQuotes.bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span> <span class="col-xs-2" ng-show="swapQuotes.editable" style="padding-top: 3px"><button type="submit" style="height:30px;width:60px;line-height:1" class="btn btn-info active" ng-disabled="vm.clickUpdateRow == true" ng-click="vm.updateRow($index)"><span>ADD</span></button></span></td><td role="button" tabindex="0" aria-label="Buy {{swapQuotes.instrument}} at {{swapQuotes.offerPrice}}" ng-keydown="($event.keyCode === 13 || $event.keyCode === 32) ? vm.prepareOrderDTOFromMarketWatch(\'BUYY\',swapQuotes.instrument,swapQuotes.offerPrice, swapQuotes.settlementDate, swapQuotes.sessionStatus) : null" ng-click="vm.prepareOrderDTOFromMarketWatch(\'BUYY\',swapQuotes.instrument,swapQuotes.offerPrice, swapQuotes.settlementDate, swapQuotes.sessionStatus);" class="col-xs-2" ng-class="{\'market-watch-buy\': (!swapQuotes.editable && swapQuotes.offerPrice != 0), \'market-watch-instrument-select\': swapQuotes.editable,\r\n\t                                 \'market-watch-buy-disabled\': (!swapQuotes.editable && (swapQuotes.offerPrice <= 0 || swapQuotes.offerPrice == null || swapQuotes.offerPrice == undefined || swapQuotes.sessionStatus != \'OPEN\' || vm.defaultTradingCustomer==null) && vm.account.organisation.organisationType.shortName!=\'CLEARCORP\') }"><span ng-hide="swapQuotes.editable || swapQuotes.offerPrice <= 0 || swapQuotes.offerPrice == undefined || swapQuotes.offerPrice == null || swapQuotes.sessionStatus != \'OPEN\'"><span class="market-watch-value-highlighted-txt-decimal">{{swapQuotes.offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span><span class="value-highlighted-txt">&nbsp;&nbsp;{{swapQuotes.offerPrice | split:\'.\':\'0\'}}.</span> </span><span ng-show="swapQuotes.isBestBid && !swapQuotes.editable && swapQuotes.offerPrice!=null && swapQuotes.offerPrice!= undefined && swapQuotes.offerPrice>0 && vm.account.organisation.organisationType.shortName == \'CUSTOMER\' && swapQuotes.sessionStatus == \'OPEN\'" class="market-watch-best-buy-container"><span class="market-watch-best-buy"></span></span></td><td class="col-xs-2-5 market-watch-date-column" ng-class="{\'market-watch-instrument-select\': swapQuotes.editable}"><span ng-hide="swapQuotes.isSettlementHoliday ||swapQuotes.editable || vm.globalValues.getSystemSettings().sodStatus==\'TO_BE_INITIATED\'">{{swapQuotes.settlementDate | date: \'dd-MMM-yyyy\'}}</span><span ng-show="vm.globalValues.getSystemSettings().sodStatus==\'TO_BE_INITIATED\' || swapQuotes.isSettlementHoliday">-</span></td><td class="col-xs-1-5 market-watch-icon-column" ng-class="{\'market-watch-instrument-select\': swapQuotes.editable}"><span ng-show="row == $index"><span ng-hide="swapQuotes.editable" ng-click="vm.addRow($index + 1)"><a class="market-watch-add-icon" title="Add"></a></span>&nbsp;<span ng-click="vm.deleteRow($index)"><a class="market-watch-remove-icon" title="Remove"></a></span></span></td></tr></tbody></table></div></div></div></div></div></div><div class="col-md-6-5 col-md-right less-padding"><div class="row"><div class="market-depth"><div ng-class="{\'bank-branch-view\': vm.account.organisation.organisationType.shortName==\'BANK\'}"><h3>Market Depth</h3><span class="server-down-text" ng-show="broadcastServerDown"><img class="server-down-error" src="assets/images/Server Down-20.png" alt="server-down" title="Broadcast is not available">Broadcast not available</span><ul class="market-depth-tab nav nav-tabs" role="tablist"><li role="presentation" class="statistics-tab active"><a href="#spotStatistics" aria-controls="home" role="tab" data-toggle="tab"><span class="icon-tab-head">SPOT</span> <span class="tab-icon statistics-modal" data-toggle="modal" title="Market Statistics" data-target="#modal-table" ng-click="vm.openMarketStatistics(\'SPOT\')"></span> <span class="tab-icon maximise-icon popUPIcon" aria-label="Maximize SPOT" ng-click="vm.expandMarketDepth(\'Retail Spot\', retailSpotMarketDepth)"></span></a></li><li role="presentation" class="statistics-tab"><a href="#intSpotStatistics" aria-controls="home" role="tab" data-toggle="tab"><span class="icon-tab-head" title="INTERBANK SPOT">IB. SPOT</span> <span class="tab-icon statistics-modal" title="Market Statistics" data-toggle="modal" data-target="#modal-table" ng-click="vm.openMarketStatistics(\'InterbankSPOT\')"></span> <span class="tab-icon maximise-icon popUPIcon" aria-label="Maximize Interbank SPOT" ng-click="vm.expandMarketDepth(\'Interbank Spot\', ibSpotMarketDepth)"></span></a></li><li role="presentation" class="statistics-tab"><a href="#bothStatistics" aria-controls="home" role="tab" data-toggle="tab"><span class="icon-tab-head">BOTH</span> <span class="tab-icon statistics-modal" title="Both" data-toggle="modal" data-target="#modal-table" ng-click="vm.openMarketStatistics(\'BOTH\')"></span> <span class="tab-icon maximise-icon popUPIcon" aria-label="Maximize Both" ng-click="vm.expandMarketDepthForBothInstrument(\'BOTH\', retailSpotMarketDepth, ibSpotMarketDepth)"></span></a></li><li role="presentation" class="close-maximize-tab"><a href="javascript:void(0);" role="tab">Back to Normal View</a></li></ul><div ng-class="{\'server-down\': broadcastServerDown}"><div class="tab-content market-depth-contents"><div role="tabpanel" class="tab-pane active" id="spotStatistics"><div class="table-responsive" tabindex="0"><table class="table table-striped bothStats"><thead><tr><th class="text-right width-33">Bid Quantity</th><th class="text-left" style="padding-left: 40px !important">Bid Price</th><th class="text-right" style="padding-right: 40px !important">Offer Price</th><th class="text-left width-35">Offer Quantity</th></tr></thead><tbody><tr ng-repeat="marketDepth in retailSpotMarketDepth.marketDepthDetails"><td class="text-right"><span ng-hide="marketDepth.bidPrice==0">{{marketDepth.bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-left" style="padding-left: 40px !important"><span ng-hide="marketDepth.bidPrice==0" class="mdc-highlighted-txt">{{marketDepth.bidPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right" style="padding-right: 40px !important"><span ng-hide="marketDepth.offerPrice==0" class="mdc-highlighted-txt">{{marketDepth.offerPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span> </span><span ng-show="marketDepth.offerPrice==0"></span></td><td class="text-left" style="padding-left: 8px !important"><span ng-hide="marketDepth.offerPrice==0">{{marketDepth.offerVolume | number:vm.noOfDecimalsForAmount}}</span></td></tr><tr ng-show="retailSpotMarketDepth==null || retailSpotMarketDepth.marketDepthDetails==null || retailSpotMarketDepth.marketDepthDetails.length<=0"><td></td><td></td><td></td><td></td></tr><tr ng-show="retailSpotMarketDepth==null || retailSpotMarketDepth.marketDepthDetails==null || retailSpotMarketDepth.marketDepthDetails.length<=1"><td></td><td></td><td></td><td></td></tr><tr ng-show="retailSpotMarketDepth==null || retailSpotMarketDepth.marketDepthDetails==null || retailSpotMarketDepth.marketDepthDetails.length<=2"><td></td><td></td><td></td><td></td></tr><tr ng-show="retailSpotMarketDepth==null || retailSpotMarketDepth.marketDepthDetails==null || retailSpotMarketDepth.marketDepthDetails.length<=3"><td></td><td></td><td></td><td></td></tr><tr ng-show="retailSpotMarketDepth==null || retailSpotMarketDepth.marketDepthDetails==null || retailSpotMarketDepth.marketDepthDetails.length<=4"><td></td><td></td><td></td><td></td></tr></tbody></table></div></div><!-- spotStatistics ends --><div role="tabpanel" class="tab-pane" id="intSpotStatistics"><div class="table-responsive" tabindex="0"><table class="table table-striped bothStats"><thead><tr><th class="text-right width-33">Bid Quantity</th><th class="text-left" style="padding-left: 40px !important">Bid Price</th><th class="text-right" style="padding-right: 40px !important">Offer Price</th><th class="text-left width-35">Offer Quantity</th></tr></thead><tbody><tr ng-repeat="marketDepth in ibSpotMarketDepth.marketDepthDetails"><td class="text-right"><span ng-hide="marketDepth.bidPrice==0">{{marketDepth.bidVolume|number: 0}}</span></td><td class="text-left" style="padding-left: 40px !important"><span ng-hide="marketDepth.bidPrice==0" class="mdc-highlighted-txt">{{marketDepth.bidPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right" style="padding-right: 40px !important"><span ng-hide="marketDepth.offerPrice==0" class="mdc-highlighted-txt">{{marketDepth.offerPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-left" style="padding-left: 8px !important"><span ng-hide="marketDepth.offerPrice==0">{{marketDepth.offerVolume|number: 0}}</span></td></tr><tr ng-show="ibSpotMarketDepth==null || ibSpotMarketDepth.marketDepthDetails==null || ibSpotMarketDepth.marketDepthDetails.length<=0"><td></td><td></td><td></td><td></td></tr><tr ng-show="ibSpotMarketDepth==null || ibSpotMarketDepth.marketDepthDetails==null || ibSpotMarketDepth.marketDepthDetails.length<=1"><td></td><td></td><td></td><td></td></tr><tr ng-show="ibSpotMarketDepth==null || ibSpotMarketDepth.marketDepthDetails==null || ibSpotMarketDepth.marketDepthDetails.length<=2"><td></td><td></td><td></td><td></td></tr><tr ng-show="ibSpotMarketDepth==null || ibSpotMarketDepth.marketDepthDetails==null || ibSpotMarketDepth.marketDepthDetails.length<=3"><td></td><td></td><td></td><td></td></tr><tr ng-show="ibSpotMarketDepth==null || ibSpotMarketDepth.marketDepthDetails==null || ibSpotMarketDepth.marketDepthDetails.length<=4"><td></td><td></td><td></td><td></td></tr></tbody></table></div></div><!-- intSpotStatistics ends --><div role="tabpanel" class="tab-pane" id="bothStatistics"><div class="table-responsive"><table class="table table-striped bothStats"><thead><tr><th class="text-center right-border" colspan="4">Retail Spot</th><th class="text-center" colspan="4">Interbank Spot</th></tr><tr><th class="text-right">Bid Quantity</th><th class="text-right">Bid Price</th><th class="text-right">Offer Price</th><th class="text-right right-border">Offer Quantity</th><th class="text-right">Bid Quantity</th><th class="text-right">Bid Price</th><th class="text-right">Offer Price</th><th class="text-right">Offer Quantity</th></tr></thead><tbody><tr><td class="text-right content-spacing-4-8"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[0].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[0].bidPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[0].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border content-spacing-4-8"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[0].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[0].bidPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[0].bidPrice | split:\'.\':\'0\'}}.<span>{{retailSpotMarketDepth.marketDepthDetails[0].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right content-spacing-4-8" style="padding-left: 4px !important"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[0].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[0].offerPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[0].offerPrice | split:\'.\':\'0\'}}. <span>{{retailSpotMarketDepth.marketDepthDetails[0].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right right-border content-spacing-4-8"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[0].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[0].offerPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[0].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right content-spacing-4-8"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[0].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[0].bidPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[0].bidVolume |number: 0}}</span></td><td class="text-right right-border content-spacing-4-8"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[0].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[0].bidPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[0].bidPrice | split:\'.\':\'0\'}}.<span>{{ibSpotMarketDepth.marketDepthDetails[0].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right content-spacing-4-8" style="padding-left: 4px !important"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[0].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[0].offerPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[0].offerPrice | split:\'.\':\'0\'}}. <span>{{ibSpotMarketDepth.marketDepthDetails[0].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right content-spacing-4-8"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[0].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[0].offerPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[0].offerVolume |number: 0}}</span></td></tr><tr><td class="text-right content-spacing-4-8"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[1].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[1].bidPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[1].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border content-spacing-4-8"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[1].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[1].bidPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[1].bidPrice | split:\'.\':\'0\'}}.<span>{{retailSpotMarketDepth.marketDepthDetails[1].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right content-spacing-4-8" style="padding-left: 4px !important"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[1].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[1].offerPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[1].offerPrice | split:\'.\':\'0\'}}. <span>{{retailSpotMarketDepth.marketDepthDetails[1].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right right-border content-spacing-4-8"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[1].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[1].offerPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[1].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right content-spacing-4-8"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[1].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[1].bidPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[1].bidVolume |number: 0}}</span></td><td class="text-right right-border content-spacing-4-8"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[1].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[1].bidPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[1].bidPrice | split:\'.\':\'0\'}}.<span>{{ibSpotMarketDepth.marketDepthDetails[1].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right content-spacing-4-8" style="padding-left: 4px !important"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[1].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[1].offerPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[1].offerPrice | split:\'.\':\'0\'}}. <span>{{ibSpotMarketDepth.marketDepthDetails[1].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right content-spacing-4-8"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[1].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[1].offerPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[1].offerVolume |number: 0}}</span></td></tr><tr><td class="text-right content-spacing-4-8"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[2].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[2].bidPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[2].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border content-spacing-4-8"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[2].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[2].bidPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[2].bidPrice | split:\'.\':\'0\'}}.<span>{{retailSpotMarketDepth.marketDepthDetails[2].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right content-spacing-4-8" style="padding-left: 4px !important"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[2].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[2].offerPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[2].offerPrice | split:\'.\':\'0\'}}. <span>{{retailSpotMarketDepth.marketDepthDetails[2].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right right-border content-spacing-4-8"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[2].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[2].offerPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[2].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right content-spacing-4-8"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[2].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[2].bidPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[2].bidVolume |number: 0}}</span></td><td class="text-right right-border content-spacing-4-8"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[2].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[2].bidPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[2].bidPrice | split:\'.\':\'0\'}}.<span>{{ibSpotMarketDepth.marketDepthDetails[2].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right content-spacing-4-8" style="padding-left: 4px !important"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[2].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[2].offerPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[2].offerPrice | split:\'.\':\'0\'}}. <span>{{ibSpotMarketDepth.marketDepthDetails[2].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right content-spacing-4-8"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[2].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[2].offerPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[2].offerVolume |number: 0}}</span></td></tr><tr><td class="text-right content-spacing-4-8"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[3].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[3].bidPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[3].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border content-spacing-4-8"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[3].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[3].bidPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[3].bidPrice | split:\'.\':\'0\'}}.<span>{{retailSpotMarketDepth.marketDepthDetails[3].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right content-spacing-4-8" style="padding-left: 4px !important"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[3].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[3].offerPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[3].offerPrice | split:\'.\':\'0\'}}. <span>{{retailSpotMarketDepth.marketDepthDetails[3].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right right-border content-spacing-4-8"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[3].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[3].offerPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[3].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right content-spacing-4-8"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[3].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[3].bidPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[3].bidVolume |number: 0}}</span></td><td class="text-right right-border content-spacing-4-8"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[3].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[3].bidPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[3].bidPrice | split:\'.\':\'0\'}}.<span>{{ibSpotMarketDepth.marketDepthDetails[3].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right content-spacing-4-8" style="padding-left: 4px !important"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[3].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[3].offerPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[3].offerPrice | split:\'.\':\'0\'}}. <span>{{ibSpotMarketDepth.marketDepthDetails[3].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right content-spacing-4-8"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[3].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[3].offerPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[3].offerVolume |number: 0}}</span></td></tr><tr><td class="text-right content-spacing-4-8"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[4].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[4].bidPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[4].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border content-spacing-4-8"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[4].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[4].bidPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[4].bidPrice | split:\'.\':\'0\'}}.<span>{{retailSpotMarketDepth.marketDepthDetails[4].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right content-spacing-4-8" style="padding-left: 4px !important"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[4].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[4].offerPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[4].offerPrice | split:\'.\':\'0\'}}. <span>{{retailSpotMarketDepth.marketDepthDetails[4].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right right-border content-spacing-4-8"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[4].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[4].offerPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[4].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right content-spacing-4-8"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[4].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[4].bidPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[4].bidVolume |number: 0}}</span></td><td class="text-right right-border content-spacing-4-8"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[4].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[4].bidPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[4].bidPrice | split:\'.\':\'0\'}}.<span>{{ibSpotMarketDepth.marketDepthDetails[4].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right content-spacing-4-8" style="padding-left: 4px !important"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[4].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[4].offerPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[4].offerPrice | split:\'.\':\'0\'}}. <span>{{ibSpotMarketDepth.marketDepthDetails[4].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right content-spacing-4-8"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[4].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[4].offerPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[4].offerVolume |number: 0}}</span></td></tr></tbody></table></div></div><!-- bothStatistics ends --></div></div></div><!-- market-depth ends--></div></div><div class="row"><div ng-if="vm.account.organisation.organisationType.shortName == \'CUSTOMER\'" class="col-md-4-5 col-md-outright-comparition"><div class="market-depth"><div ng-class="{\'bank-branch-view\': vm.account.organisation.organisationType.shortName==\'BANK\'}"><h3>Outright Comparison</h3></div><div class="bcq-head"><div class="bcq-head-icons"><ul class="nav nav-tabs"><li><a data-toggle="tab" ng-click="vm.outrightView=\'Paise\'" class="bcq-icon1 outright-icon" title="Quotes In Paise"></a></li><li class="active"><a data-toggle="tab" ng-click="vm.outrightView=\'Price\'" class="bcq-icon2 outright-icon" title="Quotes In Price"></a></li></ul></div></div><div class="market-depth-contents"><div class="row" style="margin-top: 3px"><label class="col-md-6 control-label outright-sett-label-value">Settlement Date</label><span class="col-md-4 outright-sett-date-value" ng-if="outrightRatesList!=null && outrightRatesList!=undefined && outrightRatesList.length>0 && outrightRatesList[0].settlementDate!=null && outrightRatesList[0].settlementDate!=undefined"><span title="Settlement Date">{{outrightRatesList[0].settlementDate | date:\'dd-MMM-yyyy\'}}</span></span></div><div class="row" style="margin-top: 15px"><table class="table table-striped table-responsive outright-table"><tbody><tr ng-repeat="swapQuotes in outrightRatesList"><td style="min-width: 70px" ng-click="vm.onChangingBankInSwapQuotes(swapQuotes.bank);" ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'"><span class="outright-comp-name" ng-class="{\'outright-comp-name-selected\': swapQuotes.bank.bankName==vm.defaultTradingBank.bankName && vm.account.organisation.organisationType.shortName!=\'BANK\'}" style="padding-top: 7px !important" title="{{swapQuotes.bank.bankName}}">{{swapQuotes.bank.bankName}}</span></td><td class="text-right" style="min-width: 90px"><span ng-if="swapQuotes.bidPrice!=null && swapQuotes.bidPrice!=undefined && vm.outrightView==\'Price\'" ng-class="{\'overright-highlight-best-sell\': swapQuotes.isBestOffer, \'overright-highlight\': swapQuotes.isBestOffer==false}" ng-click="vm.prepareOrderDTOFromOutrights(swapQuotes.bank,\'SELL\',swapQuotes.instrument,swapQuotes.bidPrice, swapQuotes.settlementDate, swapQuotes.sessionStatus);"><span class="value-highlighted-txt">{{swapQuotes.bidPrice | split:\'.\':\'0\'}}.&nbsp;</span><span class="value-highlighted-txt value-highlighted-txt-decimal">{{swapQuotes.bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span> <span ng-if="swapQuotes.offerSpread!=null && swapQuotes.offerSpread!=undefined && vm.outrightView==\'Paise\'" ng-class="{\'overright-highlight-best-sell\': swapQuotes.isBestOffer, \'overright-highlight\': swapQuotes.isBestOffer==false}" style="padding-top: 4px !important"><span class="value-highlighted-txt">{{swapQuotes.offerSpread | number: vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right" style="min-width: 90px"><span ng-if="swapQuotes.offerPrice!=null && swapQuotes.offerPrice!=undefined && vm.outrightView==\'Price\'" ng-class="{\'overright-highlight-best-buy\': swapQuotes.isBestBid, \'overright-highlight\': swapQuotes.isBestBid==false}" ng-click="vm.prepareOrderDTOFromOutrights(swapQuotes.bank,\'BUYY\',swapQuotes.instrument,swapQuotes.offerPrice, swapQuotes.settlementDate, swapQuotes.sessionStatus);"><span class="value-highlighted-txt value-highlighted-txt-decimal">{{swapQuotes.offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span><span class="value-highlighted-txt">&nbsp;{{swapQuotes.offerPrice | split:\'.\':\'0\'}}.</span></span> <span ng-if="swapQuotes.bidSpread!=null && swapQuotes.bidSpread!=undefined && vm.outrightView==\'Paise\'" ng-class="{\'overright-highlight-best-buy\': swapQuotes.isBestBid, \'overright-highlight\': swapQuotes.isBestBid==false}" style="padding-top: 4px !important"><span class="value-highlighted-txt">{{swapQuotes.bidSpread | number: vm.noOfDecimalsForAmount}}</span></span></td></tr><!-- <tr ng-repeat="swapQuotes in outrightRatesList" ng-if="vm.outrightView==\'Paise\'">\r\n                                 <td\r\n                                    ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'"><span\r\n                                    class="outright-comp-name"\r\n                                    title="{{swapQuotes.bank.bankName}}">{{swapQuotes.bank}}</span>\r\n                                 </td>\r\n                                 <td class="text-right"><span ng-if="swapQuotes.offerSpread!=null && swapQuotes.offerSpread!=undefined" ng-class="{\'overright-highlight-best-sell\': swapQuotes.isBestOffer}" style="padding-top: 4px !important;"><span\r\n                                    class="value-highlighted-txt">{{swapQuotes.offerSpread | number: vm.noOfDecimalsForAmount}}</span></span>\r\n                                 </td>\r\n                                 <td class="text-right"><span ng-if="swapQuotes.bidSpread!=null && swapQuotes.bidSpread!=undefined" ng-class="{\'overright-highlight-best-buy\': swapQuotes.isBestBid}" style="padding-top: 4px !important;"><span class="value-highlighted-txt">{{swapQuotes.bidSpread | number: vm.noOfDecimalsForAmount}}</span></span>\r\n                                 </td>\r\n                              </tr> --></tbody></table></div></div></div></div><div ng-class="{\'col-md-7-5\': vm.account.organisation.organisationType.shortName == \'CUSTOMER\', \'col-md-12\': vm.account.organisation.organisationType.shortName != \'CUSTOMER\'}"><div ng-include="\'app/entities/swap-quotes-view/swap-quotes-report-view.html\'"></div></div></div></div><!-- Content right wrapper ends --></div><!-- top left right ends --><div class="row"><div class="col-md-5 less-padding" ng-show="vm.permitNewOrderEntry" ng-click="vm.setOrderEntryFocus()"><div class="content-bot-left-wrapper"><div class="content-bot-left" ng-class="{\'buy-mkt-border\': vm.orderType==\'BUYY\' && vm.orderFromMarketWatch==true, \'sell-mkt-border\': vm.orderType==\'SELL\' && vm.orderFromMarketWatch==true}"><div class="order-price" ng-if="vm.orderDTO.activityIndicator==\'PLAC\'"><form name="frmOrderEntry" role="form" ng-submit="vm.placeOrder()"><div ng-init="setForm(frmOrderEntry)"><h3>Order Entry</h3><div class="order-price-tab pull-right text-right"><ul class="nav nav-tabs" id="orderPriceTabs" role="tablist"><li role="presentation" class="active tab-buy"><a ng-click="vm.orderType=\'BUYY\'; vm.getLimitExchangeRateForInstrument(vm.defaultInstrumentCode);" aria-controls="buy" role="tab" id="buyTab" data-toggle="tab">BUY</a></li><li role="presentation" class="tab-sell"><a ng-click="vm.orderType=\'SELL\'; vm.getLimitExchangeRateForInstrument(vm.defaultInstrumentCode);" aria-controls="sell" role="tab" id="sellTab" data-toggle="tab">SELL</a></li><li role="presentation" class="tab-sell-buy"><a ng-click="vm.orderType=\'SELLBUY\'; vm.getLimitExchangeRateForInstrument(vm.defaultInstrumentCode);" aria-controls="sellBuy" role="tab" id="sellbuyTab" data-toggle="tab">BUY &amp; SELL</a></li></ul></div><div class="clearfix"></div></div><div ng-class="{\'buy-border\': vm.orderType==\'BUYY\', \'sell-border\': vm.orderType==\'SELL\', \'sellbuy-border\': vm.orderType==\'SELLBUY\'}"><div class="order-price-contents tab-content"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-inner col-md-12 padding-left-0"><div class="padding-left-0 width-100" ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'SPOT\'}"><a id="spotInstrument" aria-controls="spot" role="tab" ng-click="vm.updateDefaultInstrumentDetails(\'SPOT\')">SPOT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'TOM\'}"><a id="tomInstrument" aria-controls="tom" role="tab" ng-click="vm.updateDefaultInstrumentDetails(\'TOM\')">TOM</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'CASH\'}"><a id="cashInstrument" aria-controls="cash" role="tab" ng-click="vm.updateDefaultInstrumentDetails(\'CASH\')">CASH</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'Forward\'}"><a id="forwardInstrument" aria-controls="forward" role="tab" ng-show="!enableOtherCurrencyTab" ng-click="vm.updateDefaultInstrumentDetails(\'Forward\')">FORWARD</a></li></ul><div class="search-box col-md-6 width-63" ng-if="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"><span ng-if="!enableOtherCurrencyTab" class="col-md-3"><cspl-ach control-model="vm.currencyPairUSD" control-id="txtCurrencyPair" lookup-name="orderCurrencyPair" filter-value="{{vm.tradingBank.id}}" display-column="code" control-disabled="!enableOtherCurrencyTab" form="frmOrderEntry" show-error-text="true" control-required="vm.account.organisation.organisationType.shortName ==\'CUSTOMER\'"></cspl-ach></span><span ng-if="enableOtherCurrencyTab" class="col-md-3"><cspl-ach control-model="vm.currencyPairFCY" control-id="txtCurrencyPair" lookup-name="fcyCurrencyPair" filter-value="{{vm.tradingBank.id}}" display-column="code" control-disabled="!vm.isOtherCurrencyEnable" form="frmOrderEntry" show-error-text="true" control-required="vm.account.organisation.organisationType.shortName ==\'CUSTOMER\'" default-value="vm.defaultCurrencyPairData"></cspl-ach></span><span class="col-md-5"><cspl-ach control-model="vm.tradingBank" control-id="txttradingBankOrderEntry" lookup-name="tradingBank" show-error-text="true" filter-value="{{vm.account.organisation.id}}" display-column="bankName" form="frmOrderEntry" control-place-holder="Enter bank name" control-required="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"></cspl-ach></span></div><!-- <div class="order-price-tab-inner dropdown" style="width: 15%;">\r\n                    <div class="select-box">\r\n                    <select name="select" class="select-opt currency-select-opt"\r\n                        ng-model="currencyPair" ng-disabled="false" ng-options="currencyPair.code for currencyPair in currencyPairList track by currencyPair.id"  ng-change="vm.onCurrencyChange(currencyPair)">\r\n                        </select>\r\n                    </div>\r\n                </div> --> <!-- <div class="search-box order-entry-branch"\r\n                                       ng-if="vm.account.entityOwnerType.shortName==\'Bank\'">\r\n                                       <cspl-ach control-model="vm.tradingBranch"\r\n                                          control-id="txttradingBankOrderEntryForBank"\r\n                                          lookup-name="branchesForBank"\r\n                                          filter-value="{{vm.tradingBank.id}}"\r\n                                          display-column="branchId,branchName" form="frmOrderEntry"\r\n                                          control-place-holder="Enter Branch ID or Name"\r\n                                          control-required="vm.account.entityOwnerType.shortName==\'Bank\'"></cspl-ach>\r\n                                       <span class="help-block"\r\n                                          ng-show="vm.tradingBranch!=null && vm.tradingBranch!=undefined"\r\n                                          title="{{vm.tradingBranch.branchName}}">{{vm.tradingBranch.branchName}}</span>\r\n                                    </div> --><div class="search-box col-md-6 width-63" ng-if="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\' && vm.account.entityOwnerType.shortName!=\'Bank\' "><span ng-if="!enableOtherCurrencyTab" class="col-md-3"><cspl-ach control-model="vm.currencyPairUSD" control-id="txtCurrencyPair" lookup-name="orderCurrencyPair" filter-value="{{vm.tradingBank.id}}" display-column="code" control-disabled="!enableOtherCurrencyTab" form="frmOrderEntry" show-error-text="true" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"></cspl-ach></span><span ng-if="enableOtherCurrencyTab" class="col-md-3"><cspl-ach control-model="vm.currencyPairFCY" control-id="txtCurrencyPair" lookup-name="fcyCurrencyPair" filter-value="{{vm.tradingBank.id}}" display-column="code" control-disabled="!vm.isOtherCurrencyEnable" form="frmOrderEntry" show-error-text="true" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'" default-value="vm.defaultCurrencyPairData"></cspl-ach></span><span class="col-md-5"><cspl-ach control-model="vm.tradingCustomer" control-id="txtTradingCustomer" lookup-name="customer" filter-value="{{vm.tradingBank.id}}~~{{vm.tradingBranch.id}}~~{{0}}" display-column="customerCode,customerName" form="frmOrderEntry" show-error-text="true" control-place-holder="Enter Customer ID or Name" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"></cspl-ach></span><span class="help-block col-md-3 text-align-left padding-left-5" style="right:0px" ng-show="vm.tradingCustomer!=null && vm.tradingCustomer!=undefined" title="{{vm.tradingCustomer.customerName}}">{{vm.tradingCustomer.customerName}}</span></div><div class="search-box col-md-6 width-63" ng-if="vm.account.entityOwnerType.shortName==\'Bank\'"><span ng-if="!enableOtherCurrencyTab" class="col-md-3"><cspl-ach control-model="vm.currencyPairUSD" control-id="txtCurrencyPair" lookup-name="orderCurrencyPair" filter-value="{{vm.tradingBank.id}}" display-column="code" control-disabled="!enableOtherCurrencyTab" form="frmOrderEntry" show-error-text="true" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"></cspl-ach></span><span ng-if="enableOtherCurrencyTab" class="col-md-3"><cspl-ach control-model="vm.currencyPairFCY" control-id="txtCurrencyPair" lookup-name="fcyCurrencyPair" filter-value="{{vm.tradingBank.id}}" display-column="code" control-disabled="!vm.isOtherCurrencyEnable" form="frmOrderEntry" show-error-text="true" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'" default-value="vm.defaultCurrencyPairData"></cspl-ach></span><span class="col-md-5"><cspl-ach control-model="vm.tradingCustomer" control-id="txtTradingCustomer" lookup-name="customer" filter-value="{{vm.tradingBank.id}}~~{{0}}~~{{0}}" display-column="customerCode,customerName" form="frmOrderEntry" show-error-text="true" control-place-holder="Enter Customer ID or Name" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"></cspl-ach></span><span class="help-block col-md-3 text-align-left padding-left-5" style="right:0px" ng-show="vm.tradingCustomer!=null && vm.tradingCustomer!=undefined" title="{{vm.tradingCustomer.customerName}}">{{vm.tradingCustomer.customerName}}</span></div></div></div><div class="order-price-tab-inner" style="margin-bottom: 0px"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'DAYY\'}"><a id="dayTimeCondition" aria-controls="day" role="tab" data-toggle="tab" ng-click="vm.defaultTimeCondition=\'DAYY\';">DAY</a></li><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'IOCC\'}"><a id="iocTimeCondition" aria-controls="ioc" role="tab" data-toggle="tab" ng-click="vm.defaultTimeCondition=\'IOCC\';">IOC</a></li><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'GTTM\'}"><a id="gttTimeCondition" aria-controls="gtt" role="tab" data-toggle="tab" ng-click="vm.defaultTimeCondition=\'GTTM\';">GTT</a></li></ul><div class="select-box search-box order-forward-options" ng-show="vm.defaultInstrumentCode==\'Forward\'"><select name="select" class="select-opt" ng-model="vm.tenor" ng-options="tenor.tenorName for tenor in vm.tenorsLookup track by tenor.id" ng-change="vm.onChangeTenor(vm.tenor)" ng-required="vm.defaultInstrumentCode==\'Forward\'"></select></div><div class="row"><div class="search-box" ng-if="vm.defaultInstrumentCode==\'Forward\' && vm.tenor.tenorName == \'Option Period\'" style="width: 3%;margin-top: 2px"><script>$(\'[data-toggle="popover"]\').popover({\r\n                                              container: \'body\',\r\n                                             html: true\r\n                                              })</script><span class="icon" ng-show="vm.tenor.tenorName == \'Option Period\' && userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Forward Option Period Start and End is mandatory" tooltip-position="top"><img style="margin: 0 !important" class="width-height-20 info-tooltip-icon"></span><!-- <a ng-show="vm.tenor.tenorName == \'Option Period\' && userPreference.showInfoIcon==\'yes\'" id="optionInfo" tabindex="0" data-toggle="popover" role="button" \r\n\t\t\t\t\t\t\t\t\t\t\tdata-trigger="focus" data-placement="top" data-content="Forward Option Period Start and End is mandatory" \r\n\t\t\t\t\t\t\t\t\t\t\tdata-template="<div class=\'mainViewPopover popover\'  role=\'tooltip\'><div class=\'arrow\'></div><div class=\'popover-content\' ></div></div>" >\r\n                                      \t\t<span class="icon"  ng-if="vm.tenor.tenorName == \'Option Period\'"><img class="home-page-help-icon width-height-20" src="assets/images/Info-24.png" /></span>\r\n                                      \t</a> --></div><div class="search-box order-forward-options-date" ng-show="vm.defaultInstrumentCode==\'Forward\'" style="margin-left:5px"><cspl-dtp class="order-date-ctrl" control-model="vm.tradeSettlementDateFrom" control-id="dtpTradeSettlementDateFrom1" control-place-holder="Start Date" control-leave-key="vm.onChangeTradeSettlementDateFrom(vm.tradeSettlementDateFrom)" form="frmOrderEntry" control-min-date="vm.spotNextDate" ng-if="vm.tenor.tenorName == \'Option Period\'" control-max-date="vm.maxTenorDate" data-toggle="tooltip" title="Select Option Start Date" holiday-list="vm.holidayListAfterBusinessDate" show-error-text="true" order-entry-control="true" control-required="vm.defaultInstrumentCode==\'Forward\' && vm.tenor.tenorName == \'Option Period\'"></cspl-dtp></div><div class="search-box order-forward-options-date" ng-show="vm.defaultInstrumentCode==\'Forward\'" style="margin-left:5px"><cspl-dtp class="order-date-ctrl" control-model="vm.tradeSettlementDate" control-id="dtpTradeSettlementDate1" form="frmOrderEntry" control-min-date="vm.spotNextDate" control-max-date="vm.maxTenorDate" data-toggle="tooltip" title="{{vm.tenor.tenorName != \'Option Period\'?\'Select Date\':\'Select Option End Date\'}}" control-disabled="vm.tenor.tenorName != \'Broken Date\' && vm.tenor.tenorName != \'Option Period\'" control-leave-key="vm.onChangeTradeSettlementDate(vm.tradeSettlementDate); vm.getLimitExchangeRateForInstrument(\'Forward\');" holiday-list="vm.holidayListAfterBusinessDate" show-error-text="true" order-entry-control="true" control-required="vm.defaultInstrumentCode==\'Forward\'" control-place-holder="End Date"></cspl-dtp></div><div class="search-box order-forward-options-date" ng-show="enableOtherCurrencyTab" style="margin-left:5px"><cspl-dtp class="order-date-ctrl" control-model="vm.tradeFCYSettlementDate" control-id="dtpTradeSettlementDate2" form="frmOrderEntry" data-toggle="tooltip" title="{{vm.tenor.tenorName != \'Option Period\'?\'Select Date\':\'Select Option End Date\'}}" control-disabled="true" order-entry-control="true" control-place-holder="End Date"></cspl-dtp></div></div></div></div><div class="order-price-contents tab-content" ng-class="{\'mkt-order-view\': vm.defaultPriceCondition==\'MRKT\'}"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-last"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><!-- Nav tabs --><ul class="nav nav-tabs" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\'}"><a id="limitTab" role="tab" ng-click="vm.defaultPriceCondition=\'LIMT\'">LIMIT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'MRKT\' , \'disabled\':vm.configSettings.isAllowMarketOrder!=\'Yes\'}"><a id="marketTab" role="tab" ng-click="vm.defaultPriceCondition=\'MRKT\'" ng-class="{\'disabledTabLink\': vm.configSettings.isAllowMarketOrder!=\'Yes\'}">MKT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'STLS\', \'disabled\':vm.configSettings.isAllowStopLossOrder!=\'Yes\'}"><a id="stoplossTab" role="tab" ng-click="vm.defaultPriceCondition=\'STLS\'" ng-class="{\'disabledTabLink\': vm.configSettings.isAllowStopLossOrder!=\'Yes\'}">SL</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'TKPR\', \'disabled\':vm.configSettings.isAllowTakeProfitOrder!=\'Yes\'}"><a id="takeprofitTab" role="tab" ng-click="vm.defaultPriceCondition=\'TKPR\'" ng-class="{\'disabledTabLink\': vm.configSettings.isAllowTakeProfitOrder!=\'Yes\'}">TP</a></li></ul><div style="background:#292929;color:#7f7f7f ;border:1px solid #595959; padding-top:8px" ng-show="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\' "><span style="margin-left: 4px"><input type="radio" name="optradio" id="Regular" ng-model="vm.regularAndSplitOrder" style="margin-right: 5px" value="Regular" form="frmOrderEntry"><label style="color: #FFFFFF" for="Regular">Regular</label></span><span style="margin-left: 4px"><input type="radio" name="optradio" id="Split" ng-model="vm.regularAndSplitOrder" style="margin-right: 5px" value="Split" form="frmOrderEntry"><label style="color: #FFFFFF" for="Split">Split Order</label></span></div><!-- Tab panes --><div class="tab-content"><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\'}" ng-show="vm.defaultPriceCondition==\'LIMT\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th><th class="text-right">Limit Price</th><th ng-if="vm.regularAndSplitOrder==\'Split\'" class="text-right">No. Of Splits</th></thead><tbody><td class="text-right"><label for="txtlimitordervalue" class="sr-only">Order Quantity</label><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" control-id="txtlimitordervalue" form="frmOrderEntry" show-error-text="true" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric><span ng-show="errorTextOrderAmount != null && errorTextOrderAmount !=\'\'" style="position:relative"><span class="help-block-warning-error arrow-up split_order_error_text">{{errorTextOrderAmount}}</span></span></td><td class="text-right"><label for="txtlimitorderprice" class="sr-only">Limit Price</label><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" control-id="txtlimitorderprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'" show-error-text="true"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</p> --></td><td class="text-right" ng-if="vm.regularAndSplitOrder==\'Split\'"><label for="txtNoOfSplitValue" class="sr-only">No. Of Splits</label><cspl-numeric control-model="vm.noOfSplits" control-max="10" no-of-decimals="0" control-min="0" control-id="txtNoOfSplitValue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\' && vm.regularAndSplitOrder!=\'Regular\'" show-error-text="true"></cspl-numeric><span ng-show="errorTextNoOfSplits != null && errorTextNoOfSplits !=\'\'" style="position:relative"><span class="help-block-warning-error arrow-up split_order_error_text">{{errorTextNoOfSplits}}</span></span></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">Limit Available</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardSellLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardBuyLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\' ||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.limitExchangeRate!=null && vm.orderDTO.limitExchangeRate!=undefined && vm.orderDTO.limitExchangeRate>0">{{vm.orderDTO.limitExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span></span><br></td><td class="text-right" ng-if="vm.regularAndSplitOrder==\'Split\' && vm.showSplitedOrderAmount != \'\' && vm.showSplitedOrderAmount != undefined && vm.showSplitedOrderAmount  != null && vm.noOfSplits !=\'\'"><span>{{vm.noOfSplits}}</span>&nbsp;<span class="color-theme-txt">Orders of</span>&nbsp;<span>{{vm.showSplitedOrderAmount}}</span>&nbsp;<span class="color-theme-txt">qty</span><br></td></tr><tr><td></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.spreadUsed!=null && vm.spreadUsed!=undefined">&nbsp;&nbsp;{{vm.spreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">)</span></span></td></tr></tfoot></table><table class="table" ng-show="vm.orderType==\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th><th class="text-right">Buy Limit Price</th><th class="text-right">Sell Limit Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtsellbuylimitordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType==\'SELLBUY\'"></cspl-numeric><span ng-show="errorTextOrderAmount != null && errorTextOrderAmount !=\'\'" style="position:relative"><span class="help-block-warning-error arrow-up split_order_error_text">{{errorTextOrderAmount}}</span></span></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'buylimit\')" control-model="vm.orderDTO.buyLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuylimitbuyorderprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType==\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.buyLimitPriceDeviationWarning!=null && vm.buyLimitPriceDeviationWarning!=undefined && vm.buyLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.buyLimitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'selllimit\')" control-model="vm.orderDTO.sellLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuylimitsellorderprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType==\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.sellLimitPriceDeviationWarning!=null && vm.sellLimitPriceDeviationWarning!=undefined && vm.sellLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.sellLimitPriceDeviationWarning}}</p> --></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">Limit Available</span> <span ng-show="vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{tomSellLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'Forward\'">{{forwardBuyLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{forwardSellLimitWithCF |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.buyLimitExchangeRate!=null && vm.orderDTO.buyLimitExchangeRate!=undefined && vm.orderDTO.buyLimitExchangeRate>0">{{vm.orderDTO.buyLimitExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span></span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.sellLimitExchangeRate!=null && vm.orderDTO.sellLimitExchangeRate!=undefined && vm.orderDTO.sellLimitExchangeRate>0">{{vm.orderDTO.sellLimitExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span></span><br></td></tr><tr><td></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.buySpreadUsed!=null && vm.buySpreadUsed!=undefined), \'error-text\': (vm.buySpreadUsed==null || vm.buySpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.buySpreadUsed!=null && vm.buySpreadUsed!=undefined">&nbsp;&nbsp;{{vm.buySpreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.buySpreadUsed!=null && vm.buySpreadUsed!=undefined), \'error-text\': (vm.buySpreadUsed==null || vm.buySpreadUsed==undefined)}">)</span></span></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.sellSpreadUsed!=null && vm.sellSpreadUsed!=undefined), \'error-text\': (vm.sellSpreadUsed==null || vm.sellSpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.sellSpreadUsed!=null && vm.sellSpreadUsed!=undefined">&nbsp;&nbsp;{{vm.sellSpreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.sellSpreadUsed!=null && vm.sellSpreadUsed!=undefined), \'error-text\': (vm.sellSpreadUsed==null || vm.sellSpreadUsed==undefined)}">)</span></span></td></tr></tfoot></table></div></div><!-- limit tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'MRKT\'}" ng-show="vm.defaultPriceCondition==\'MRKT\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtmktordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'MRKT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">Limit Available</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardSellLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardBuyLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td></tr><tr><td></td></tr></tfoot></table><table class="table" ng-show="vm.orderType==\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtsellbuymktordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'MRKT\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">Limit Available</span> <span ng-show="vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'Forward\'">{{forwardBuyLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{forwardSellLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td></tr><tr><td></td></tr></tfoot></table></div></div><!-- mkt tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'STLS\'}" ng-show="vm.defaultPriceCondition==\'STLS\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th><th class="text-right">Limit Price</th><th class="text-right">Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtslordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsllimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.stopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsltriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">Limit Available</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardSellLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardBuyLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.limitExchangeRate!=null && vm.orderDTO.limitExchangeRate!=undefined && vm.orderDTO.limitExchangeRate>0">{{vm.orderDTO.limitExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span></span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.stopExchangeRate!=null && vm.orderDTO.stopExchangeRate!=undefined && vm.orderDTO.stopExchangeRate>0">{{vm.orderDTO.stopExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span></span><br></td></tr><tr><td></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.spreadUsed!=null && vm.spreadUsed!=undefined">&nbsp;&nbsp;{{vm.spreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">)</span></span></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined), \'error-text\': (vm.stopSpreadUsed==null || vm.stopSpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined">&nbsp;&nbsp;{{vm.stopSpreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined), \'error-text\': (vm.stopSpreadUsed==null || vm.stopSpreadUsed==undefined)}">)</span></span></td></tr></tfoot></table><table class="table" ng-show="vm.orderType==\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th><th class="text-right">Buy Limit Price</th><th class="text-right">Buy Trigger Price</th><th class="text-right">Sell Limit Price</th><th class="text-right">Sell Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtsellbuyslordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'buylimit\')" control-model="vm.orderDTO.buyLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuyslbuylimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.buyLimitPriceDeviationWarning!=null && vm.buyLimitPriceDeviationWarning!=undefined && vm.buyLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.buyLimitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.buyStopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuyslbuytriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'selllimit\')" control-model="vm.orderDTO.sellLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuyslselllimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.sellLimitPriceDeviationWarning!=null && vm.sellLimitPriceDeviationWarning!=undefined && vm.sellLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.sellLimitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.sellStopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuyslselltriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">Limit Available</span> <span ng-show="vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'Forward\'">{{forwardBuyLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{forwardSellLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.buyLimitExchangeRate!=null && vm.orderDTO.buyLimitExchangeRate!=undefined && vm.orderDTO.buyLimitExchangeRate>0">{{vm.orderDTO.buyLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.buyStopExchangeRate!=null && vm.orderDTO.buyStopExchangeRate!=undefined && vm.orderDTO.buyStopExchangeRate>0">{{vm.orderDTO.buyStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.sellLimitExchangeRate!=null && vm.orderDTO.sellLimitExchangeRate!=undefined && vm.orderDTO.sellLimitExchangeRate>0">{{vm.orderDTO.sellLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.sellStopExchangeRate!=null && vm.orderDTO.sellStopExchangeRate!=undefined && vm.orderDTO.sellStopExchangeRate>0">{{vm.orderDTO.sellStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td></tr><tr><td></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.buySpreadUsed!=null && vm.buySpreadUsed!=undefined), \'error-text\': (vm.buySpreadUsed==null || vm.buySpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.buySpreadUsed!=null && vm.buySpreadUsed!=undefined">&nbsp;&nbsp;{{vm.buySpreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.buySpreadUsed!=null && vm.buySpreadUsed!=undefined), \'error-text\': (vm.buySpreadUsed==null || vm.buySpreadUsed==undefined)}">)</span></span></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.buyStopSpreadUsed!=null && vm.buyStopSpreadUsed!=undefined), \'error-text\': (vm.buyStopSpreadUsed==null || vm.buyStopSpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.buyStopSpreadUsed!=null && vm.buyStopSpreadUsed!=undefined">&nbsp;&nbsp;{{vm.buyStopSpreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.buyStopSpreadUsed!=null && vm.buyStopSpreadUsed!=undefined), \'error-text\': (vm.buyStopSpreadUsed==null || vm.buyStopSpreadUsed==undefined)}">)</span></span></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.sellSpreadUsed!=null && vm.sellSpreadUsed!=undefined), \'error-text\': (vm.sellSpreadUsed==null || vm.sellSpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.sellSpreadUsed!=null && vm.sellSpreadUsed!=undefined">&nbsp;&nbsp;{{vm.sellSpreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.sellSpreadUsed!=null && vm.sellSpreadUsed!=undefined), \'error-text\': (vm.sellSpreadUsed==null || vm.sellSpreadUsed==undefined)}">)</span></span></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.sellStopSpreadUsed!=null && vm.sellStopSpreadUsed!=undefined), \'error-text\': (vm.sellStopSpreadUsed==null || vm.sellStopSpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.sellStopSpreadUsed!=null && vm.sellStopSpreadUsed!=undefined">&nbsp;&nbsp;{{vm.sellStopSpreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.sellStopSpreadUsed!=null && vm.sellStopSpreadUsed!=undefined), \'error-text\': (vm.sellStopSpreadUsed==null || vm.sellStopSpreadUsed==undefined)}">)</span></span></td></tr></tfoot></table></div></div><!-- sl tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'TKPR\'}" ng-show="vm.defaultPriceCondition==\'TKPR\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th><th class="text-right">Limit Price</th><th class="text-right">Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txttpordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txttplimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.stopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txttptriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">Limit Available</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardSellLimitWithCF |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardBuyLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.limitExchangeRate!=null && vm.orderDTO.limitExchangeRate!=undefined && vm.orderDTO.limitExchangeRate>0">{{vm.orderDTO.limitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.stopExchangeRate!=null && vm.orderDTO.stopExchangeRate!=undefined && vm.orderDTO.stopExchangeRate>0">{{vm.orderDTO.stopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td></tr><tr><td></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.spreadUsed!=null && vm.spreadUsed!=undefined">&nbsp;&nbsp;{{vm.spreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">)</span></span></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined), \'error-text\': (vm.stopSpreadUsed==null || vm.stopSpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined">&nbsp;&nbsp;{{vm.stopSpreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined), \'error-text\': (vm.stopSpreadUsed==null || vm.stopSpreadUsed==undefined)}">)</span></span></td></tr></tfoot></table><table class="table" ng-show="vm.orderType==\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th><th class="text-right">Buy Limit Price</th><th class="text-right">Buy Trigger Price</th><th class="text-right">Sell Limit Price</th><th class="text-right">Sell Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtsellbuytpordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'buylimit\')" control-model="vm.orderDTO.buyLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuytpbuylimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.buyLimitPriceDeviationWarning!=null && vm.buyLimitPriceDeviationWarning!=undefined && vm.buyLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.buyLimitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.buyStopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuytpbuytriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'selllimit\')" control-model="vm.orderDTO.sellLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuytpselllimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.sellLimitPriceDeviationWarning!=null && vm.sellLimitPriceDeviationWarning!=undefined && vm.sellLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.sellLimitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.sellStopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuytpselltriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">Limit Available</span> <span ng-show="vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{cashBuyLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'Forward\'">{{forwardSellLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{forwardBuyLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.buyLimitExchangeRate!=null && vm.orderDTO.buyLimitExchangeRate!=undefined && vm.orderDTO.buyLimitExchangeRate>0">{{vm.orderDTO.buyLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.buyStopExchangeRate!=null && vm.orderDTO.buyStopExchangeRate!=undefined && vm.orderDTO.buyStopExchangeRate>0">{{vm.orderDTO.buyStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.sellLimitExchangeRate!=null && vm.orderDTO.sellLimitExchangeRate!=undefined && vm.orderDTO.sellLimitExchangeRate>0">{{vm.orderDTO.sellLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.sellStopExchangeRate!=null && vm.orderDTO.sellStopExchangeRate!=undefined && vm.orderDTO.sellStopExchangeRate>0">{{vm.orderDTO.sellStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td></tr><tr><td></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.buySpreadUsed!=null && vm.buySpreadUsed!=undefined), \'error-text\': (vm.buySpreadUsed==null || vm.buySpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.buySpreadUsed!=null && vm.buySpreadUsed!=undefined">&nbsp;&nbsp;{{vm.buySpreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.buySpreadUsed!=null && vm.buySpreadUsed!=undefined), \'error-text\': (vm.buySpreadUsed==null || vm.buySpreadUsed==undefined)}">)</span></span></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.buyStopSpreadUsed!=null && vm.buyStopSpreadUsed!=undefined), \'error-text\': (vm.buyStopSpreadUsed==null || vm.buyStopSpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.buyStopSpreadUsed!=null && vm.buyStopSpreadUsed!=undefined">&nbsp;&nbsp;{{vm.buyStopSpreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.buyStopSpreadUsed!=null && vm.buyStopSpreadUsed!=undefined), \'error-text\': (vm.buyStopSpreadUsed==null || vm.buyStopSpreadUsed==undefined)}">)</span></span></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.sellSpreadUsed!=null && vm.sellSpreadUsed!=undefined), \'error-text\': (vm.sellSpreadUsed==null || vm.sellSpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.sellSpreadUsed!=null && vm.sellSpreadUsed!=undefined">&nbsp;&nbsp;{{vm.sellSpreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.sellSpreadUsed!=null && vm.sellSpreadUsed!=undefined), \'error-text\': (vm.sellSpreadUsed==null || vm.sellSpreadUsed==undefined)}">)</span></span></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.sellStopSpreadUsed!=null && vm.sellStopSpreadUsed!=undefined), \'error-text\': (vm.sellStopSpreadUsed==null || vm.sellStopSpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.sellStopSpreadUsed!=null && vm.sellStopSpreadUsed!=undefined">&nbsp;&nbsp;{{vm.sellStopSpreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.sellStopSpreadUsed!=null && vm.sellStopSpreadUsed!=undefined), \'error-text\': (vm.sellStopSpreadUsed==null || vm.sellStopSpreadUsed==undefined)}">)</span></span></td></tr></tfoot></table></div></div><!-- tp tab ends --></div></div></div><!-- sell-spot ends --></div></div><div class="order-price-tab-inner" style="margin-bottom:0px" ng-show="vm.defaultInstrumentCode==\'Forward\'"><div class="row margin-right-0"><div class="col-md-6"><label class="control-label left-floating width-20-percent">Exposure</label><div class="select-box search-box width-73-percent" style="margin-left:10px !important" ng-class="{red: frmOrderEntry.exposureType.$invalid}"><select name="exposureType" class="select-opt" ng-model="vm.exposureType" ng-options="exposureType.name for exposureType in vm.enabledExposureLookup track by exposureType.id" ng-required="vm.defaultInstrumentCode==\'Forward\'" form="frmOrderEntry"></select><span ng-show="frmOrderEntry.exposureType.$invalid" style="position:relative" class=""><span class="help-block-warning-error arrow-up" style="float: right;margin: 0px 2px 2px 0px; right: 0px; background: #ffffff; padding: 6px 1px; border-radius: 4px; border-right: 5px solid transparent; border-top: 5px solid black">This field cannot be left blank</span></span></div></div><div class="col-md-6"><div class="select-box search-box width-64-percent right-float" ng-class="{red: frmOrderEntry.exposureSubType.$invalid}"><select name="exposureSubType" class="select-opt" ng-model="vm.exposureSubType" ng-options="exposureSubType.name for exposureSubType in vm.enabledSubExposureLookup track by exposureSubType.id" ng-required="vm.defaultInstrumentCode==\'Forward\'" form="frmOrderEntry"></select><span ng-show="frmOrderEntry.exposureSubType.$invalid" style="position:relative" class=""><span class="help-block-warning-error arrow-up" style="float: right;margin: 0px 2px 2px 0px; right: 0px; background: #ffffff; padding: 6px 1px; border-radius: 4px; border-right: 5px solid transparent; border-top: 5px solid black">This field cannot be left blank</span></span></div><label class="control-label right-floating width-32-percent">Sub Exposure</label></div></div></div><div class="sell-btn-wrap"><div class="sell-btn-inner textAlignCenter"><p class="order-price-help-text-p"><span class="order-price-help-text">Prices shown are not inclusive of bank mark-up</span></p><p style="float: right"><!-- <span ng-show="vm.configSettings.allowOrderImport==\'Yes\'">\r\n                                       <label for="orderUpload" class="btn btn-primary">\r\n                                       <img src="assets/images/search-up-icon.png"\r\n                                          alt="download-icon">\r\n                                       </label>\r\n                                       </span> <input type="file" file-reader="vm.content"\r\n                                          file-model="vm.fileContent" id="orderUpload"\r\n                                          ng-hide="true" /> --><!-- <button type="button" ng-click="vm.downloadData()" class="btn btn-last-tab-buy">DOWNLOAD</button> --> <button type="submit" ng-show="vm.orderType==\'SELL\'" ng-disabled="frmOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-sell">SELL</button> <button type="submit" ng-show="vm.orderType==\'BUYY\'" ng-disabled="frmOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-buy">BUY</button> <button type="submit" ng-show="vm.orderType==\'MODIFYSELL\'" ng-disabled="frmOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-sell">MODIFY SELL</button> <button type="submit" ng-show="vm.orderType==\'MODIFYBUY\'" ng-disabled="frmOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-buy">MODIFY BUY</button> <button type="submit" ng-show="vm.orderType==\'CANCELSELL\'" ng-disabled="frmOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-sell">CANCEL SELL</button> <button type="submit" ng-show="vm.orderType==\'CANCELBUY\'" ng-disabled="frmOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-buy">CANCEL BUY</button> <button type="submit" ng-show="vm.orderType==\'SELLBUY\'" ng-disabled="frmOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-sell-buy">BUY & SELL</button></p><p class="add-remarks-p"><a href="javascript:void(0)" class="add-remarks-setting" data-toggle="modal" data-target="#modal-settings" ng-click="vm.openOrderPreference()" ng-show="vm.permitModifyOrderEntry || vm.permitNewOrderEntry"><img class="logo-icon" src="assets/images/box-right-icon.png" title="Order Preference" alt="icon"> </a><a href="javascript:void(0)" class="add-remarks" data-toggle="tooltip" title="Free text field, can be used to indicate the underlying details of an order" ng-click="vm.addRemarks()"><i class="fa fa-plus" aria-hidden="true"></i> Remarks</a></p></div></div></div><!--SELL Tab Closed--></div></div></form></div><div class="order-price" ng-if="vm.orderDTO.activityIndicator==\'MDFY\'"><form name="frmMdfyOrderEntry" role="form" ng-submit="vm.placeOrder()"><div ng-init="setMdfyForm(frmMdfyOrderEntry)"><h3 ng-if="vm.orderDTO.eventType!=\'Contract Cancellation\' && vm.orderDTO.eventType!=\'ContractCancellation\'">Order Entry</h3><h3 ng-if="vm.orderDTO.eventType==\'Contract Cancellation\' || vm.orderDTO.eventType==\'ContractCancellation\'">Contract Cancellation</h3><div class="order-price-tab pull-right text-right"><ul class="nav nav-tabs" id="orderPriceTabs" role="tablist"><li role="presentation" class="active tab-buy" ng-show="vm.orderDTO.buySellIndicator==\'BUYY\'"><a ng-click="vm.orderType=\'BUYY\'" aria-controls="buy" role="tab" id="modifybuyTab" data-toggle="tab">BUY</a></li><li role="presentation" class="tab-sell" ng-show="vm.orderDTO.buySellIndicator==\'SELL\'"><a ng-click="vm.orderType=\'SELL\'" aria-controls="sell" role="tab" id="modifysellTab" data-toggle="tab">SELL</a></li><li role="presentation" class="tab-sell-buy" ng-hide="true"><a ng-click="vm.orderType=\'SELLBUY\'" aria-controls="sellBuy" role="tab" data-toggle="tab">BUY &amp; SELL</a></li></ul></div><div class="clearfix"></div></div><div ng-class="{\'buy-border\': vm.orderType==\'BUYY\', \'sell-border\': vm.orderType==\'SELL\', \'sellbuy-border\': vm.orderType==\'SELLBUY\'}"><div class="order-price-contents tab-content"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-inner col-md-12 padding-left-0"><div class="padding-left-0 width-100" ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}" ng-init="statusCash = vm.getInstrumentStatus(vm.defaultTokenSequenceNo)"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'SPOT\'}" ng-show="vm.orderDTO.instrumentCode==\'SPOT\'"><a id="spotInstrument" aria-controls="spot" role="tab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'SPOT\')">SPOT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'TOM\'}" ng-show="vm.orderDTO.instrumentCode==\'TOM\'"><a id="tomInstrument" aria-controls="tom" role="tab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'TOM\')">TOM</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'CASH\'}" ng-show="vm.orderDTO.instrumentCode==\'CASH\'"><a id="cashInstrument" aria-controls="cash" role="tab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'CASH\')">CASH</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'Forward\'}" ng-show="vm.orderDTO.instrumentCode==\'Forward\'"><a id="forwardInstrument" aria-controls="forward" role="tab" ng-show="!enableOtherCurrencyTab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'Forward\')">FORWARD</a></li></ul><div class="search-box col-md-6 width-63" ng-if="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"><span ng-if="vm.orderDTO.activityIndicator==\'MDFY\'" class="col-md-4"><cspl-ach control-model="vm.currencyPairUSD" control-id="txtCurrencyPair" lookup-name="orderCurrencyPair" filter-value="{{vm.tradingBank.id}}" display-column="code" control-disabled="vm.orderDTO.activityIndicator==\'MDFY\'" form="frmOrderEntry" show-error-text="true" control-required="vm.account.organisation.organisationType.shortName ==\'CUSTOMER\'"></cspl-ach></span><span class="col-md-7"><cspl-ach control-model="vm.tradingBank" control-id="txtbankFilterForPO1" lookup-name="tradingBank" control-disabled="vm.orderDTO.activityIndicator==\'MDFY\'" filter-value="{{vm.account.organisation.id}}" display-column="bankName" form="frmMdfyOrderEntry" control-place-holder="Enter bank name" control-required="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"></cspl-ach></span></div><!-- <div class="search-box order-entry-branch"\r\n                                       ng-if="vm.account.entityOwnerType.shortName==\'Bank\'">\r\n                                       <cspl-ach control-model="vm.tradingBranch"\r\n                                          control-id="txtbankFilterForPO1"\r\n                                          lookup-name="branchesForBank"\r\n                                          control-disabled="vm.orderDTO.activityIndicator==\'MDFY\'"\r\n                                          filter-value="{{vm.tradingBank.id}}"\r\n                                          display-column="branchId,branchName" form="frmOrderEntry"\r\n                                          control-place-holder="Enter Branch ID or Name"\r\n                                          control-required="vm.account.entityOwnerType.shortName==\'Bank\'"></cspl-ach>\r\n                                       <span class="help-block"\r\n                                          ng-show="vm.tradingBranch!=null && vm.tradingBranch!=undefined"\r\n                                          title="{{vm.tradingBranch.branchName}}">{{vm.tradingBranch.branchName}}</span>\r\n                                    </div> --><div class="search-box col-md-6 width-63" ng-if="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\' && vm.account.entityOwnerType.shortName!=\'Bank\' "><span ng-if="!enableOtherCurrencyTab" class="col-md-3"><cspl-ach control-model="vm.currencyPairUSD" control-id="txtCurrencyPair" lookup-name="orderCurrencyPair" filter-value="{{vm.tradingBank.id}}" display-column="code" control-disabled="!enableOtherCurrencyTab" form="frmOrderEntry" show-error-text="true" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"></cspl-ach></span><span ng-if="enableOtherCurrencyTab" class="col-md-3"><cspl-ach control-model="vm.currencyPairFCY" control-id="txtCurrencyPair" lookup-name="fcyCurrencyPair" filter-value="{{vm.tradingBank.id}}" display-column="code" control-disabled="!vm.isOtherCurrencyEnable" form="frmOrderEntry" show-error-text="true" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'" default-value="vm.defaultCurrencyPairData"></cspl-ach></span><span class="col-md-4"><cspl-ach control-model="vm.tradingCustomer" control-id="txtTradingCustomer1" lookup-name="customer" filter-value="{{vm.tradingBank.id}}~~{{vm.tradingBranch.id}}~~{{0}}" control-disabled="vm.orderDTO.activityIndicator==\'MDFY\'" display-column="customerCode,customerName" form="frmMdfyOrderEntry" control-place-holder="Enter Customer ID or Name" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"></cspl-ach></span><span class="help-block col-md-3 text-align-left padding-left-5" style="right:0px" ng-show="vm.tradingCustomer!=null && vm.tradingCustomer!=undefined" title="{{vm.tradingCustomer.customerName}}">{{vm.tradingCustomer.customerName}}</span></div><div class="search-box col-md-6 width-63" ng-if="vm.account.entityOwnerType.shortName==\'Bank\'"><span ng-if="vm.orderDTO.activityIndicator==\'MDFY\'" class="col-md-3"><cspl-ach control-model="vm.currencyPairUSD" control-id="txtCurrencyPair" lookup-name="currencyPair" filter-value="{{vm.tradingBank.id}}" display-column="code" control-disabled="vm.orderDTO.activityIndicator==\'MDFY\'" form="frmOrderEntry" show-error-text="true" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'" default-value="vm.defaultCurrencyPairData"></cspl-ach></span><span class="col-md-5"><cspl-ach control-model="vm.tradingCustomer" control-id="txtTradingCustomer1" lookup-name="customer" filter-value="{{vm.tradingBank.id}}~~{{vm.tradingBranch.id}}~~{{0}}" control-disabled="vm.orderDTO.activityIndicator==\'MDFY\'" display-column="customerCode,customerName" form="frmMdfyOrderEntry" control-place-holder="Enter Customer ID or Name" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"></cspl-ach></span><span class="help-block col-md-3 text-align-left padding-left-5" style="right:0px" ng-show="vm.tradingCustomer!=null && vm.tradingCustomer!=undefined" title="{{vm.tradingCustomer.customerName}}">{{vm.tradingCustomer.customerName}}</span></div><!-- <div class="order-price-tab-inner dropdown" style="width: 15%;">\r\n                    <div class="select-box">\r\n                    <select name="select" class="select-opt currency-select-opt"\r\n                        ng-model="currencyPair" ng-disabled="vm.orderDTO.activityIndicator==\'MDFY\'" ng-options="currencyPair.code for currencyPair in currencyPairList track by currencyPair.id"  ng-change="vm.onCurrencyChange(currencyPair)">\r\n                        </select>\r\n                    </div>\r\n                </div> --></div></div><div class="order-price-tab-inner" style="margin-bottom: 0px"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'DAYY\'}" ng-show="vm.orderDTO.timeLimitIndicator==\'DAYY\'"><a id="dayTimeCondition" aria-controls="day" role="tab" data-toggle="tab" ng-click="vm.defaultTimeCondition=\'DAYY\';">DAY</a></li><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'IOCC\'}" ng-show="vm.orderDTO.timeLimitIndicator==\'IOCC\'"><a id="iocTimeCondition" aria-controls="ioc" role="tab" data-toggle="tab" ng-click="vm.defaultTimeCondition=\'IOCC\';">IOC</a></li><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'GTTM\'}" ng-show="vm.orderDTO.timeLimitIndicator==\'GTTM\'"><a id="gttTimeCondition" aria-controls="gtt" role="tab" data-toggle="tab" ng-click="vm.defaultTimeCondition=\'GTTM\';">GTT</a></li></ul><div class="select-box search-box" ng-show="vm.defaultInstrumentCode==\'Forward\'"><select name="select" class="select-opt" ng-model="vm.tenor" form="frmMdfyOrderEntry" ng-disabled="true" ng-options="tenor.tenorName for tenor in vm.tenorsLookup track by tenor.id" ng-required="vm.defaultInstrumentCode==\'Forward\'"></select></div><div class="row"><!--<div class="search-box " ng-show="vm.defaultInstrumentCode==\'Forward\'" style=" width: 3%;margin-top: 2px; ">\r\n                                      \t <a ng-show="vm.tenor.tenorName == \'Option Period\'" id="optionInfo" tabindex="0" data-toggle="popover" role="button" \r\n\t\t\t\t\t\t\t\t\t\t\tdata-trigger="focus" data-placement="right" data-content="Forward Option Delivery From and To is mandatory" \r\n\t\t\t\t\t\t\t\t\t\t\tdata-template="<div class=\'mainViewPopover popover\'  role=\'tooltip\'><div class=\'arrow\'></div><div class=\'popover-content\' ></div></div>" >\r\n                                      \t\t<span class="icon"  ng-if="vm.tenor.tenorName == \'Option Period\'"><img class="home-page-help-icon width-height-20" src="assets/images/Info-24.png" /></span>\r\n                                      \t</a> \r\n                                      \t</div>--><div class="search-box order-forward-options-date" ng-show="vm.defaultInstrumentCode==\'Forward\'" style="margin-left:5px"><cspl-dtp class="order-date-ctrl" control-model="vm.tradeSettlementDateFrom" control-id="dtpTradeSettlementDateFrom1" control-leave-key="vm.onChangeTradeSettlementDateFrom(vm.tradeSettlementDateFrom)" form="frmMdfyOrderEntry" control-min-date="vm.spotNextDate" ng-if="vm.tenor.tenorName == \'Option Period\'" control-max-date="vm.maxTenorDate" order-entry-control="true" control-disabled="true" holiday-list="vm.holidayListAfterBusinessDate" show-error-text="true" control-required="vm.defaultInstrumentCode==\'Forward\' && vm.tenor.tenorName == \'Option Period\'" control-place-holder="From"></div><div class="search-box order-forward-options-date" ng-show="vm.defaultInstrumentCode==\'Forward\'" style="margin-left:5px"><cspl-dtp class="order-date-ctrl" control-model="vm.tradeSettlementDate" control-id="dtpTradeSettlementDate2" form="frmMdfyOrderEntry" control-min-date="vm.spotNextDate" control-leave-key="vm.onChangeTradeSettlementDate(vm.tradeSettlementDate);" control-disabled="true" order-entry-control="true" holiday-list="vm.holidayListAfterBusinessDate" show-error-text="true" control-required="vm.defaultInstrumentCode==\'Forward\'" control-place-holder="To"></div><div class="search-box order-forward-options-date" ng-show="vm.currencyPairUSD.code != \'USDINR\'" style="margin-left:5px"><cspl-dtp class="order-date-ctrl" control-model="vm.tradeFCYSettlementDate" control-id="dtpTradeSettlementDate1" form="frmOrderEntry" data-toggle="tooltip" title="{{vm.tenor.tenorName != \'Option Period\'?\'Select Date\':\'Select Option End Date\'}}" control-disabled="true" order-entry-control="true" control-place-holder="End Date"></cspl-dtp></div></div></div></div><div class="order-price-contents tab-content" ng-class="{\'mkt-order-view\': vm.defaultPriceCondition==\'MRKT\'}"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-last"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><!-- Nav tabs --><ul class="nav nav-tabs" style="border: none" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\'}" ng-show="vm.orderDTO.typeOfOrder==\'LIMT\'"><a id="limitTab" ng-click="vm.defaultPriceCondition=\'LIMT\'">LIMIT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'MRKT\'}" ng-show="vm.orderDTO.typeOfOrder==\'MRKT\'"><a id="marketTab" ng-click="vm.defaultPriceCondition=\'MRKT\'">MKT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'STLS\'}" ng-show="vm.orderDTO.typeOfOrder==\'STLS\'"><a id="stoplossTab" ng-click="vm.defaultPriceCondition=\'STLS\'">SL</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'TKPR\'}" ng-show="vm.orderDTO.typeOfOrder==\'TKPR\'"><a id="takeprofitTab" ng-click="vm.defaultPriceCondition=\'TKPR\'">TP</a></li></ul><!-- Tab panes --><div class="tab-content"><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\'}" ng-show="vm.defaultPriceCondition==\'LIMT\'"><div class="table-responsive"><table class="table"><thead><th class="text-right">Order Quantity</th><th class="text-right">Limit Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" control-id="txtlimitordervalue1" form="frmMdfyOrderEntry" show-error-text="true" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" control-id="txtlimitorderprice1" form="frmMdfyOrderEntry" show-error-text="true" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</p> --></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true && vm.orderDTO.eventType!=\'Contract Cancellation\' && vm.orderDTO.eventType!=\'ContractCancellation\'"><span class="color-theme-txt" title="Limit Available">Limit Available</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardSellLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardBuyLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> </span><span ng-show="vm.tradingCustomer!=null && (vm.orderDTO.eventType==\'Contract Cancellation\' || vm.orderDTO.eventType==\'ContractCancellation\')"><span class="color-theme-txt" title="Outstanding Quantity">Outstanding Quantity</span> <span>{{outstandingQuantity | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.limitExchangeRate!=null && vm.orderDTO.limitExchangeRate!=undefined && vm.orderDTO.limitExchangeRate>0">{{vm.orderDTO.limitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td></tr><tr><td></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.spreadUsed!=null && vm.spreadUsed!=undefined">&nbsp;&nbsp;{{vm.spreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">)</span></span></td></tr></tfoot></table></div></div><!-- limit tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'MRKT\'}" ng-show="vm.defaultPriceCondition==\'MRKT\'"><div class="table-responsive"><table class="table"><thead><th class="text-right">Order Quantity</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtmktordervalue1" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'MRKT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true && vm.orderDTO.eventType!=\'Contract Cancellation\' && vm.orderDTO.eventType!=\'ContractCancellation\'"><span class="color-theme-txt" title="Limit Available">Limit Available</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardSellLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardBuyLimitWithCF |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> </span><span ng-show="vm.tradingCustomer!=null && (vm.orderDTO.eventType==\'Contract Cancellation\' || vm.orderDTO.eventType==\'ContractCancellation\')"><span class="color-theme-txt" title="Outstanding Quantity">Outstanding Quantity</span> <span>{{outstandingQuantity | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td></tr><tr><td></td></tr></tfoot></table></div></div><!-- mkt tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'STLS\'}" ng-show="vm.defaultPriceCondition==\'STLS\'"><div class="table-responsive"><table class="table"><thead><th class="text-right">Order Quantity</th><th class="text-right">Limit Price</th><th class="text-right">Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtslordervalue1" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsllimitprice1" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.stopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsltriggerprice1" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true && vm.orderDTO.eventType!=\'Contract Cancellation\' && vm.orderDTO.eventType!=\'ContractCancellation\'"><span class="color-theme-txt" title="Limit Available">Limit Available</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardSellLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardBuyLimitWithCF |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> </span><span ng-show="vm.tradingCustomer!=null && (vm.orderDTO.eventType==\'Contract Cancellation\' || vm.orderDTO.eventType==\'ContractCancellation\')"><span class="color-theme-txt" title="Outstanding Quantity">Outstanding Quantity</span> <span>{{outstandingQuantity | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.limitExchangeRate!=null && vm.orderDTO.limitExchangeRate!=undefined && vm.orderDTO.limitExchangeRate>0">{{vm.orderDTO.limitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.stopExchangeRate!=null && vm.orderDTO.stopExchangeRate!=undefined && vm.orderDTO.stopExchangeRate>0">{{vm.orderDTO.stopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td></tr><tr><td></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.spreadUsed!=null && vm.spreadUsed!=undefined">&nbsp;&nbsp;{{vm.spreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">)</span></span></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined), \'error-text\': (vm.stopSpreadUsed==null || vm.stopSpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined">&nbsp;&nbsp;{{vm.stopSpreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined), \'error-text\': (vm.stopSpreadUsed==null || vm.stopSpreadUsed==undefined)}">)</span></span></td></tr></tfoot></table></div></div><!-- sl tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'TKPR\'}" ng-show="vm.defaultPriceCondition==\'TKPR\'"><div class="table-responsive"><table class="table"><thead><th class="text-right">Order Quantity</th><th class="text-right">Limit Price</th><th class="text-right">Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txttpordervalue1" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txttplimitprice1" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.stopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txttptriggerprice1" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true && vm.orderDTO.eventType!=\'Contract Cancellation\' && vm.orderDTO.eventType!=\'ContractCancellation\'"><span class="color-theme-txt" title="Limit Available">Limit Available</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardSellLimitWithCF |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardBuyLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> </span><span ng-show="vm.tradingCustomer!=null && (vm.orderDTO.eventType==\'Contract Cancellation\' || vm.orderDTO.eventType==\'ContractCancellation\')"><span class="color-theme-txt" title="Outstanding Quantity">Outstanding Quantity</span> <span>{{outstandingQuantity | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.limitExchangeRate!=null && vm.orderDTO.limitExchangeRate!=undefined && vm.orderDTO.limitExchangeRate>0">{{vm.orderDTO.limitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.stopExchangeRate!=null && vm.orderDTO.stopExchangeRate!=undefined && vm.orderDTO.stopExchangeRate>0">{{vm.orderDTO.stopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td></tr><tr><td></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.spreadUsed!=null && vm.spreadUsed!=undefined">&nbsp;&nbsp;{{vm.spreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">)</span></span></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined), \'error-text\': (vm.stopSpreadUsed==null || vm.stopSpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined">&nbsp;&nbsp;{{vm.spreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined), \'error-text\': (vm.stopSpreadUsed==null || vm.stopSpreadUsed==undefined)}">)</span></span></td></tr></tfoot></table></div></div><!-- tp tab ends --></div></div></div><!-- sell-spot ends --></div></div><div class="order-price-tab-inner" style="margin-bottom:0px" ng-show="vm.defaultInstrumentCode==\'Forward\'"><div class="row margin-right-0"><div class="col-md-6"><label class="control-label left-floating width-20-percent">Exposure</label><div class="select-box search-box width-73-percent" style="margin-left:10px !important"><select name="select" class="select-opt" ng-model="vm.exposureType" ng-options="exposureType.name for exposureType in vm.allExposureLookup track by exposureType.id" ng-disabled="true" ng-required="vm.defaultInstrumentCode==\'Forward\'"></select></div></div><div class="col-md-6"><div class="select-box search-box width-64-percent right-float"><select name="select" class="select-opt" ng-model="vm.exposureSubType" ng-options="exposureSubType.name for exposureSubType in vm.allSubExposureLookup track by exposureSubType.id" ng-disabled="true" ng-required="vm.defaultInstrumentCode==\'Forward\'"></select></div><label class="control-label right-floating width-32-percent">Sub Exposure</label></div></div></div><div class="sell-btn-wrap"><div class="sell-btn-inner textAlignCenter"><p class="order-price-help-text-p"><span class="order-price-help-text">Prices shown are not inclusive of bank mark-up</span></p><p style="float: right"><button type="submit" id="mdfySellBtn" ng-show="vm.orderType==\'SELL\' && vm.orderDTO.activityIndicator==\'MDFY\'" ng-disabled="frmMdfyOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-sell">MODIFY SELL</button> <button type="submit" ng-show="vm.orderType==\'BUYY\' && vm.orderDTO.activityIndicator==\'MDFY\'" ng-disabled="frmMdfyOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-buy">MODIFY BUY</button> <button type="submit" ng-show="vm.orderType==\'SELL\' && vm.orderDTO.activityIndicator==\'CNCL\'" ng-disabled="frmMdfyOrderEntry.$invalid" class="btn btn-last-tab-sell">CANCEL SELL</button> <button type="submit" ng-show="vm.orderType==\'BUYY\' && vm.orderDTO.activityIndicator==\'CNCL\'" ng-disabled="frmMdfyOrderEntry.$invalid" class="btn btn-last-tab-buy">CANCEL BUY</button></p><p style="float: right; margin-top: 7px"><a class="back-to-order-entry" ng-click="vm.cancelModifyOrderAction()"><span class="icon arrow_triangle-left"></span>Back</a></p><p class="add-remarks-p"><a href="javascript:void(0)" class="add-remarks-setting" data-toggle="modal" data-target="#modal-settings" ng-click="vm.openOrderPreference()" ng-show="vm.permitModifyOrderEntry || vm.permitNewOrderEntry"><img class="logo-icon" src="assets/images/box-right-icon.png" title="Order Preference" alt="icon"> </a><a href="javascript:void(0)" class="add-remarks" ng-click="vm.addRemarks()"><i class="fa fa-plus" aria-hidden="true"></i> Remarks</a></p></div></div></div><!--SELL Tab Closed--></div></div></form></div><div class="order-price" ng-if="vm.orderDTO.activityIndicator==\'TRAD\'"><form name="frmTradeOrderEntry" role="form" ng-submit="vm.placeOrder()"><div ng-init="setTradeForm(frmTradeOrderEntry)"><h3 ng-if="vm.outstandtradedatefrom==null">Contract Cancellation</h3><h3 ng-if="vm.outstandtradedatefrom!=null">Contract Cancellation (Forward Option Period)</h3><div class="order-price-tab pull-right text-right" style="width: 35%"><ul class="nav nav-tabs" id="orderPriceTabs" role="tablist"><li role="presentation" class="active tab-buy" ng-show="vm.orderDTO.buySellIndicator==\'BUYY\'"><a ng-click="vm.orderType=\'BUYY\'" aria-controls="buy" role="tab" id="tradebuyTab" data-toggle="tab">BUY</a></li><li role="presentation" class="tab-sell" ng-show="vm.orderDTO.buySellIndicator==\'SELL\'"><a ng-click="vm.orderType=\'SELL\'" aria-controls="sell" role="tab" id="tradesellTab" data-toggle="tab">SELL</a></li></ul></div><div class="clearfix"></div></div><div ng-class="{\'buy-border\': vm.orderType==\'BUYY\', \'sell-border\': vm.orderType==\'SELL\', \'sellbuy-border\': vm.orderType==\'SELLBUY\'}"><div class="order-price-contents tab-content"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-inner"><div class="padding-left-0 width-100" ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'SPOT\'}" ng-show="vm.orderDTO.instrumentCode==\'SPOT\'"><a id="spotInstrument" aria-controls="spot" role="tab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'SPOT\')">SPOT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'TOM\'}" ng-show="vm.orderDTO.instrumentCode==\'TOM\'"><a id="tomInstrument" aria-controls="tom" role="tab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'TOM\')">TOM</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'CASH\'}" ng-show="vm.orderDTO.instrumentCode==\'CASH\'"><a id="cashInstrument" aria-controls="cash" role="tab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'CASH\')">CASH</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'Forward\'}" ng-show="vm.orderDTO.instrumentCode==\'Forward\'"><a id="forwardInstrument" aria-controls="forward" role="tab" ng-show="!enableOtherCurrencyTab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'Forward\')">FORWARD</a></li></ul><div class="search-box order-entry-branch" ng-if="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"><span ng-if="!enableOtherCurrencyTab" class="col-md-3"><cspl-ach control-model="vm.currencyPairUSD" control-id="txtCurrencyPair" lookup-name="orderCurrencyPair" filter-value="{{vm.tradingBank.id}}" display-column="code" control-disabled="!enableOtherCurrencyTab" form="frmOrderEntry" show-error-text="true" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"></cspl-ach></span><span ng-if="enableOtherCurrencyTab" class="col-md-3"><cspl-ach control-model="vm.currencyPairFCY" control-id="txtCurrencyPair" lookup-name="fcyCurrencyPair" filter-value="{{vm.tradingBank.id}}" display-column="code" control-disabled="!vm.isOtherCurrencyEnable" form="frmOrderEntry" show-error-text="true" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'" default-value="vm.defaultCurrencyPairData"></cspl-ach></span><span class="col-md-5"></span><cspl-ach control-model="vm.tradingBank" control-id="txtbankFilterForPO1" lookup-name="tradingBank" control-disabled="vm.orderDTO.activityIndicator==\'TRAD\'" filter-value="{{vm.account.organisation.id}}" display-column="bankName" form="frmTradeOrderEntry" control-place-holder="Enter bank name" control-required="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"></cspl-ach></div><div class="search-box col-md-6 width-63" ng-if="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"><span ng-if="!enableOtherCurrencyTab" class="col-md-3"><cspl-ach control-model="vm.currencyPairUSD" control-id="txtCurrencyPair" lookup-name="currencyPair" filter-value="{{vm.tradingBank.id}}" display-column="code" control-disabled="!enableOtherCurrencyTab" form="frmOrderEntry" show-error-text="true" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"></cspl-ach></span><span ng-if="enableOtherCurrencyTab" class="col-md-3"><cspl-ach control-model="vm.currencyPairFCY" control-id="txtCurrencyPair" lookup-name="fcyCurrencyPair" filter-value="{{vm.tradingBank.id}}" display-column="code" control-disabled="!vm.isOtherCurrencyEnable" form="frmOrderEntry" show-error-text="true" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'" default-value="vm.defaultCurrencyPairData"></cspl-ach></span><span class="col-md-5"><cspl-ach control-model="vm.tradingCustomer" control-id="txtTradingCustomer1" lookup-name="customer" filter-value="{{vm.tradingBank.id}}~~{{vm.tradingBranch.id}}~~{{0}}" control-disabled="vm.orderDTO.activityIndicator==\'TRAD\'" display-column="customerCode,customerName" form="frmTradeOrderEntry" control-place-holder="Enter Customer ID or Name" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"></cspl-ach></span><span class="help-block col-md-3 text-align-left padding-left-5" style="right:0px" ng-show="vm.tradingCustomer!=null && vm.tradingCustomer!=undefined" title="{{vm.tradingCustomer.customerName}}">{{vm.tradingCustomer.customerName}}</span></div></div></div><div class="order-price-tab-inner" style="margin-bottom: 0px"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'DAYY\'}"><a id="dayTimeCondition" aria-controls="day" role="tab" data-toggle="tab" ng-click="vm.defaultTimeCondition=\'DAYY\';">DAY</a></li><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'IOCC\'}"><a id="iocTimeCondition" aria-controls="ioc" role="tab" data-toggle="tab" ng-click="vm.defaultTimeCondition=\'IOCC\';">IOC</a></li><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'GTTM\'}"><a id="gttTimeCondition" aria-controls="gtt" role="tab" data-toggle="tab" ng-click="vm.defaultTimeCondition=\'GTTM\';">GTT</a></li></ul><div class="select-box search-box" ng-show="vm.defaultInstrumentCode==\'Forward\'"><select name="select" class="select-opt" ng-model="vm.tenor" form="frmTradeOrderEntry" ng-disabled="true" ng-options="tenor.tenorName for tenor in vm.tenorsLookupWithoutOption track by tenor.id" ng-required="vm.defaultInstrumentCode==\'Forward\'"></select></div><div class="search-box" ng-show="vm.defaultInstrumentCode==\'Forward\'"><cspl-dtp class="order-date-ctrl" control-model="vm.tradeSettlementDate" control-id="dtpTradeSettlementDate3" form="frmTradeOrderEntry" control-min-date="vm.spotNextDate" control-leave-key="vm.onChangeTradeSettlementDate(vm.tradeSettlementDate);" control-disabled="true" order-entry-control="true" holiday-list="vm.holidayListAfterBusinessDate" show-error-text="true" control-required="vm.defaultInstrumentCode==\'Forward\'"></div><div class="search-box order-forward-options-date" ng-show="enableOtherCurrencyTab" style="margin-left:5px"><cspl-dtp class="order-date-ctrl" control-model="vm.tradeFCYSettlementDate" control-id="dtpTradeSettlementDate1" form="frmOrderEntry" data-toggle="tooltip" title="{{vm.tenor.tenorName != \'Option Period\'?\'Select Date\':\'Select Option End Date\'}}" control-disabled="true" order-entry-control="true" control-place-holder="End Date"></cspl-dtp></div></div></div><div class="order-price-contents tab-content" ng-class="{\'mkt-order-view\': vm.defaultPriceCondition==\'MRKT\'}"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-last"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><!-- Nav tabs --><ul class="nav nav-tabs" style="border: none" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\'}"><a id="limitTab" ng-click="vm.defaultPriceCondition=\'LIMT\'">LIMIT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'MRKT\'}"><a id="marketTab" ng-click="vm.defaultPriceCondition=\'MRKT\'">MKT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'STLS\'}"><a id="stoplossTab" ng-click="vm.defaultPriceCondition=\'STLS\'">SL</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'TKPR\'}"><a id="takeprofitTab" ng-click="vm.defaultPriceCondition=\'TKPR\'">TP</a></li></ul><!-- Tab panes --><div class="tab-content"><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\'}" ng-show="vm.defaultPriceCondition==\'LIMT\'"><div class="table-responsive"><table class="table"><thead><th class="text-right">Order Quantity</th><th class="text-right">Limit Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" control-id="txtlimitordervalue2" form="frmTradeOrderEntry" show-error-text="true" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" control-id="txtlimitorderprice2" form="frmTradeOrderEntry" show-error-text="true" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null"><span class="color-theme-txt" title="Outstanding Quantity">Outstanding Quantity</span> <span>{{vm.orderDTO.outStandingAmount | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.limitExchangeRate!=null && vm.orderDTO.limitExchangeRate!=undefined && vm.orderDTO.limitExchangeRate>0">{{vm.orderDTO.limitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td></tr><tr><td></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.spreadUsed!=null && vm.spreadUsed!=undefined">&nbsp;&nbsp;{{vm.spreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">)</span></span></td></tr></tfoot></table></div></div><!-- limit tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'MRKT\'}" ng-show="vm.defaultPriceCondition==\'MRKT\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtmktordervalue2" form="frmTradeOrderEntry" control-required="vm.defaultPriceCondition==\'MRKT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">Limit Available</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardSellLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardBuyLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td></tr><tr><td></td></tr></tfoot></table></div></div><!-- mkt tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'STLS\'}" ng-show="vm.defaultPriceCondition==\'STLS\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th><th class="text-right">Limit Price</th><th class="text-right">Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtslordervalue2" form="frmTradeOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsllimitprice2" form="frmTradeOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.stopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsltriggerprice2" form="frmTradeOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">Limit Available</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardSellLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardBuyLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.limitExchangeRate!=null && vm.orderDTO.limitExchangeRate!=undefined && vm.orderDTO.limitExchangeRate>0">{{vm.orderDTO.limitExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span></span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.stopExchangeRate!=null && vm.orderDTO.stopExchangeRate!=undefined && vm.orderDTO.stopExchangeRate>0">{{vm.orderDTO.stopExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span></span><br></td></tr><tr><td></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.spreadUsed!=null && vm.spreadUsed!=undefined">&nbsp;&nbsp;{{vm.spreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">)</span></span></td><td class="text-right applied-swap-point" ng-if="!enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined), \'error-text\': (vm.stopSpreadUsed==null || vm.stopSpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined">&nbsp;&nbsp;{{vm.stopSpreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined), \'error-text\': (vm.stopSpreadUsed==null || vm.stopSpreadUsed==undefined)}">)</span></span></td></tr></tfoot></table></div></div><!-- sl tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'TKPR\'}" ng-show="vm.defaultPriceCondition==\'TKPR\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th><th class="text-right">Limit Price</th><th class="text-right">Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txttpordervalue2" form="frmTradeOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txttplimitprice2" form="frmTradeOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.stopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txttptriggerprice2" form="frmTradeOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">Limit Available</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardSellLimitWithCF |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'Forward\'">{{forwardBuyLimitWithCF | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.limitExchangeRate!=null && vm.orderDTO.limitExchangeRate!=undefined && vm.orderDTO.limitExchangeRate>0">{{vm.orderDTO.limitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'||enableOtherCurrencyTab"><span class="color-theme-txt">Eqv. Spot Price</span>&nbsp;&nbsp;<span ng-if="vm.orderDTO.stopExchangeRate!=null && vm.orderDTO.stopExchangeRate!=undefined && vm.orderDTO.stopExchangeRate>0">{{vm.orderDTO.stopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span></span><br></td></tr><tr><td></td><td class="text-right applied-swap-point" ng-if="enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.spreadUsed!=null && vm.spreadUsed!=undefined">&nbsp;&nbsp;{{vm.spreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.spreadUsed!=null && vm.spreadUsed!=undefined), \'error-text\': (vm.spreadUsed==null || vm.spreadUsed==undefined)}">)</span></span></td><td class="text-right applied-swap-point" ng-if="enableOtherCurrencyTab"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'"><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined), \'error-text\': (vm.stopSpreadUsed==null || vm.stopSpreadUsed==undefined)}">(Applied Swap Points</span><span ng-if="vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined">&nbsp;&nbsp;{{vm.stopSpreadUsed | number: vm.noOfDecimalsForAmount}}</span><span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.stopSpreadUsed!=null && vm.stopSpreadUsed!=undefined), \'error-text\': (vm.stopSpreadUsed==null || vm.stopSpreadUsed==undefined)}">)</span></span></td></tr></tfoot></table></div></div><!-- tp tab ends --></div></div></div><!-- sell-spot ends --></div></div><div class="order-price-tab-inner" style="margin-bottom:0px" ng-show="vm.defaultInstrumentCode==\'Forward\'"><div class="row margin-right-0"><div class="col-md-6"><label class="control-label left-floating width-20-percent">Exposure</label><div class="select-box search-box width-73-percent" style="margin-left:10px !important"><select name="select" class="select-opt" ng-model="vm.exposureType" ng-options="exposureType.name for exposureType in vm.allExposureLookup track by exposureType.id" ng-disabled="true" ng-required="vm.defaultInstrumentCode==\'Forward\'"></select></div></div><div class="col-md-6"><div class="select-box search-box width-64-percent right-float"><select name="select" class="select-opt" ng-model="vm.exposureSubType" ng-options="exposureSubType.name for exposureSubType in vm.allSubExposureLookup track by exposureSubType.id" ng-disabled="true" ng-required="vm.defaultInstrumentCode==\'Forward\'"></select></div><label class="control-label right-floating width-32-percent">Sub Exposure</label></div></div></div><div class="sell-btn-wrap"><div class="sell-btn-inner textAlignCenter"><p class="order-price-help-text-p"><span class="order-price-help-text">Prices shown are not inclusive of bank mark-up</span></p><p style="float: right"><button type="submit" ng-show="vm.orderType==\'SELL\' && vm.orderDTO.activityIndicator==\'TRAD\'" ng-disabled="frmTradeOrderEntry.$invalid" class="btn btn-last-tab-sell">SELL</button> <button type="submit" ng-show="vm.orderType==\'BUYY\' && vm.orderDTO.activityIndicator==\'TRAD\'" ng-disabled="frmTradeOrderEntry.$invalid" class="btn btn-last-tab-buy">BUY</button></p><p style="float: right; margin-top: 7px"><a class="back-to-order-entry" ng-click="vm.cancelModifyOrderAction()"><span class="icon arrow_triangle-left"></span>Back</a></p><p class="add-remarks-p"><a href="javascript:void(0)" class="add-remarks-setting" data-toggle="modal" data-target="#modal-settings" ng-click="vm.openOrderPreference()" ng-show="vm.permitModifyOrderEntry || vm.permitNewOrderEntry"><img class="logo-icon" src="assets/images/box-right-icon.png" title="Order Preference" alt="icon"> </a><a href="javascript:void(0)" class="add-remarks" ng-click="vm.addRemarks()"><i class="fa fa-plus" aria-hidden="true"></i> Remarks</a></p></div></div></div><!--SELL Tab Closed--></div></div></form></div><div class="order-price" ng-if="vm.orderDTO.activityIndicator==\'ROLL\'"><form name="frmRolloverTradeOrderEntry" role="form" ng-submit="vm.placeOrderForRollover()"><script>$(document).ready(function() {\r\n                           $(\'#rolloverRebookingPop\').popover({\r\n                              container: \'body\',\r\n                              html: true\r\n                            })\r\n                        });\r\n                        $(document).ready(function() {\r\n                           $(\'#rolloverCancellationPop\').popover({\r\n                              container: \'body\',\r\n                              html: true\r\n                            })\r\n                        });\r\n                        $(document).ready(function() {\r\n                           $(\'#rolloverSpotPop\').popover({\r\n                              container: \'body\',\r\n                              html: true\r\n                            })\r\n                        });\r\n                        $(document).ready(function() {\r\n                           $(\'#rolloverSpreadPop\').popover({\r\n                              container: \'body\',\r\n                              html: true\r\n                            })\r\n                        });</script><div ng-init="setTradeForm(frmRolloverTradeOrderEntry)"><h3>Contract Rollover</h3><div class="order-price-tab pull-right text-right"><ul class="nav nav-tabs" id="orderPriceTabs" role="tablist"><li role="presentation" class="active tab-buy" ng-show="vm.orderDTO.buySellIndicator==\'BUYY\'"><a ng-click="vm.orderType=\'BUYY\'" aria-controls="buy" role="tab" id="rolloverbuyTab" data-toggle="tab">BUY</a></li><li role="presentation" class="tab-sell" ng-show="vm.orderDTO.buySellIndicator==\'SELL\'"><a ng-click="vm.orderType=\'SELL\'" aria-controls="sell" role="tab" id="rolloversellTab" data-toggle="tab">SELL</a></li></ul></div><div class="clearfix"></div></div><div ng-class="{\'buy-border\': vm.orderType==\'BUYY\', \'sell-border\': vm.orderType==\'SELL\', \'sellbuy-border\': vm.orderType==\'SELLBUY\'}"><div class="order-price-contents tab-content"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-inner"><div class="padding-left-0 width-100" ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'SPOT\'}" ng-show="vm.orderDTO.instrumentCode==\'SPOT\'"><a id="spotInstrument" aria-controls="spot" role="tab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'SPOT\')">SPOT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'TOM\'}" ng-show="vm.orderDTO.instrumentCode==\'TOM\'"><a id="tomInstrument" aria-controls="tom" role="tab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'TOM\')">TOM</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'CASH\'}" ng-show="vm.orderDTO.instrumentCode==\'CASH\'"><a id="cashInstrument" aria-controls="cash" role="tab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'CASH\')">CASH</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'Forward\'}" ng-show="vm.orderDTO.instrumentCode==\'Forward\'"><a id="forwardInstrument" aria-controls="forward" role="tab" ng-show="!enableOtherCurrencyTab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'Forward\')">FORWARD</a></li></ul><ul class="nav nav-tabs orderPriceTabsInner margin-left-5" role="tablist"><li role="presentation" class="active"><a role="tab" data-toggle="tab">ROLLOVER</a></li></ul><div class="search-box order-entry-branch" ng-if="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.tradingBank" control-id="txtbankFilterForRollover" lookup-name="tradingBank" control-disabled="vm.orderDTO.activityIndicator==\'ROLL\'" filter-value="{{vm.account.organisation.id}}" display-column="bankName" form="frmRolloverTradeOrderEntry" control-place-holder="Enter bank name" control-required="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"></cspl-ach></div><div class="search-box col-md-6 width-53" ng-if="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"><span class="col-md-8"><cspl-ach control-model="vm.tradingCustomer" control-id="txtTradingCustomerForRollover" lookup-name="customer" filter-value="{{vm.tradingBank.id}}~~{{vm.tradingBranch.id}}~~{{0}}" control-disabled="vm.orderDTO.activityIndicator==\'ROLL\'" display-column="customerCode,customerName" form="frmRolloverTradeOrderEntry" control-place-holder="Enter Customer ID or Name" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"></cspl-ach></span><span class="help-block col-md-4 text-align-left padding-left-5" style="right:0px" ng-show="vm.tradingCustomer!=null && vm.tradingCustomer!=undefined" title="{{vm.tradingCustomer.customerName}}">{{vm.tradingCustomer.customerName}}</span></div></div></div><div class="order-price-tab-inner" style="margin-bottom: 0px"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" class="disabled"><a id="dayTimeCondition" aria-controls="day" role="tab" data-toggle="tab" class="disabledTabLink" ng-click="vm.defaultTimeCondition=\'DAYY\';">DAY</a></li><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'IOCC\'}"><a id="iocTimeCondition" aria-controls="ioc" role="tab" data-toggle="tab" class="disabledTabLink" ng-click="vm.defaultTimeCondition=\'IOCC\';">IOC</a></li><li role="presentation" class="disabled"><a id="gttTimeCondition" aria-controls="gtt" role="tab" data-toggle="tab" class="disabledTabLink" ng-click="vm.defaultTimeCondition=\'GTTM\';">GTT</a></li></ul><div class="select-box search-box"><select name="select" class="select-opt" ng-model="vm.tenor" form="frmRolloverTradeOrderEntry" ng-options="tenor.tenorName for tenor in vm.tenorsLookupWithoutOption track by tenor.id" ng-change="vm.onChangeTenor(vm.tenor)" ng-required="vm.defaultInstrumentCode==\'Forward\'"></select></div><div class="search-box"><cspl-dtp class="order-date-ctrl" control-model="vm.tradeSettlementDate" control-id="dtpTradeSettlementDate4" form="frmRolloverTradeOrderEntry" control-min-date="vm.minimumTradeSettlementDate" control-leave-key="vm.onChangeTradeSettlementDate(vm.tradeSettlementDate);" control-disabled="vm.tenor.tenorName != \'Broken Date\'" holiday-list="vm.holidayListAfterBusinessDate" show-error-text="true" control-required="true"></div><div class="search-box order-forward-options-date" ng-show="enableOtherCurrencyTab" style="margin-left:5px"><cspl-dtp class="order-date-ctrl" control-model="vm.tradeFCYSettlementDate" control-id="dtpTradeSettlementDate1" form="frmOrderEntry" data-toggle="tooltip" title="{{vm.tenor.tenorName != \'Option Period\'?\'Select Date\':\'Select Option End Date\'}}" control-disabled="true" order-entry-control="true" control-place-holder="End Date"></cspl-dtp></div></div></div><div class="order-price-contents tab-content" ng-class="{\'mkt-order-view\': vm.defaultPriceCondition==\'MRKT\'}"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-last"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><!-- Nav tabs --><ul class="nav nav-tabs" style="border: none" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\'}"><a id="limitTab" class="disabledTabLink" ng-click="vm.defaultPriceCondition=\'LIMT\'">LIMIT</a></li><li role="presentation" class="disabled"><a id="marketTab" class="disabledTabLink" ng-click="vm.defaultPriceCondition=\'MRKT\'">MKT</a></li><li role="presentation" class="disabled"><a id="stoplossTab" class="disabledTabLink" ng-click="vm.defaultPriceCondition=\'STLS\'">SL</a></li><li role="presentation" class="disabled"><a id="takeprofitTab" class="disabledTabLink" ng-click="vm.defaultPriceCondition=\'TKPR\'">TP</a></li></ul><!-- Tab panes --><div class="tab-content"><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\'}" ng-show="vm.defaultPriceCondition==\'LIMT\'"><div class="table-responsive"><table class="table"><thead><th class="text-right">Rollover Quantity</th><th class="text-right"><span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Interbank Spot Last Traded Price (LTP) + Swap points applicable for the rebooking date. This rate is subject to change at the time of order execution." tooltip-position="left"><img class="info-tooltip-icon home-page-help-icon"></span><!-- <a ng-show="userPreference.showInfoIcon==\'yes\'" id="rolloverRebookingPop" tabindex="0" data-toggle="popover" role="button" \r\n                                             data-trigger="focus" data-placement="left" data-content="Interbank Spot Last Traded Price (LTP) + Swap points applicable for the rebooking date. This rate is subject to change at the time of order execution." \r\n                                             data-template="<div class=\'mainViewPopover popover\' role=\'tooltip\'><div class=\'arrow\'></div><div class=\'popover-content\'></div></div>" >\r\n                                                <span class="icon"><img class="home-page-help-icon" src="assets/images/Info-24.png" /></span>\r\n                                             </a> --> <span ng-class="{\'error-text\': (vm.orderDTO.limitExchangeRate==null || vm.orderDTO.limitExchangeRate==undefined)}">Indicative Re-Booking Rate</span></th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" control-id="txtlimitordervalue3" form="frmRolloverTradeOrderEntry" show-error-text="true" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" control-id="txtlimitorderprice3" form="frmRolloverTradeOrderEntry" show-error-text="true" control-disabled="true" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null"><span class="color-theme-txt" title="Outstanding Quantity">Outstanding Quantity</span> <span>{{vm.orderDTO.outStandingAmount | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Interbank Spot Last Traded Price (LTP) + Swap points applicable for the original contract settlement date. This rate is subject to change at the time of order execution." tooltip-position="left"><img class="info-tooltip-icon home-page-help-icon"></span><!-- <a ng-show="userPreference.showInfoIcon==\'yes\'" id="rolloverCancellationPop" tabindex="0" data-toggle="popover" role="button" \r\n                                                               data-trigger="focus" data-placement="left" data-content="Interbank Spot Last Traded Price (LTP) + Swap points applicable for the original contract settlement date. This rate is subject to change at the time of order execution." \r\n                                                               data-template="<div class=\'mainViewPopover popover\' role=\'tooltip\'><div class=\'arrow\'></div><div class=\'popover-content\'></div></div>" >\r\n                                                                  <span class="icon"><img class="home-page-help-icon" src="assets/images/Info-24.png" /></span>\r\n                                                               </a> --> <span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.orderDTO.indicativeCancellationRate!=null && vm.orderDTO.indicativeCancellationRate!=undefined), \'error-text\': (vm.orderDTO.indicativeCancellationRate==null || vm.orderDTO.indicativeCancellationRate==undefined)}">Indicative Cancellation Rate</span>&nbsp;&nbsp;<span>{{vm.orderDTO.indicativeCancellationRate | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td class="padding-top-0"></td><td class="text-right padding-top-0"><span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Interbank Spot Last Traded Price (LTP). This rate is subject to change at the time of order execution." tooltip-position="left"><img class="info-tooltip-icon home-page-help-icon"></span><!-- <a ng-show="userPreference.showInfoIcon==\'yes\'" id="rolloverSpotPop" tabindex="0" data-toggle="popover" role="button" \r\n                                                               data-trigger="focus" data-placement="left" data-content="Interbank Spot Last Traded Price (LTP). This rate is subject to change at the time of order execution." \r\n                                                               data-template="<div class=\'mainViewPopover popover\' role=\'tooltip\'><div class=\'arrow\'></div><div class=\'popover-content\'></div></div>" >\r\n                                                                  <span class="icon"><img class="home-page-help-icon" src="assets/images/Info-24.png" /></span>\r\n                                                               </a> --> <span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.orderDTO.indicativeSpotRate!=null && vm.orderDTO.indicativeSpotRate!=undefined), \'error-text\': (vm.orderDTO.indicativeSpotRate==null || vm.orderDTO.indicativeSpotRate==undefined)}">Indicative Spot Rate</span>&nbsp;&nbsp;<span>{{vm.orderDTO.indicativeSpotRate | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td class="text-right applied-swap-point padding-top-0" colspan="2"><span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Difference between Swap points applicable for Original settlement date and Re-booking date." tooltip-position="top"><img class="info-tooltip-icon home-page-help-icon"></span><!-- <a ng-show="userPreference.showInfoIcon==\'yes\'" id="rolloverSpreadPop" tabindex="0" data-toggle="popover" role="button" \r\n                                                               data-trigger="focus" data-placement="top" data-content="Difference between Swap points applicable for Original settlement date and Re-booking date." \r\n                                                               data-template="<div class=\'mainViewPopover popover\' role=\'tooltip\'><div class=\'arrow\'></div><div class=\'popover-content\'></div></div>" >\r\n                                                                  <span class="icon"><img class="home-page-help-icon" src="assets/images/Info-24.png" /></span>\r\n                                                               </a> --> <span class="color-theme-txt" ng-if="(vm.orderDTO.forwardSwapPoints!=null && vm.orderDTO.forwardSwapPoints!=undefined)">Applied Swap Points&nbsp;&nbsp;{{vm.orderDTO.forwardSwapPoints | number: vm.noOfDecimalsForAmount}}</span> <span class="error-text" style="font-size:12px;color: #FF1D1D" ng-if="vm.orderDTO.forwardSwapPoints==null || vm.orderDTO.forwardSwapPoints==undefined">{{\'Order not allowed. Bank swap point not available for \'}}{{vm.tradeSettlementDate | date: \'dd-MMM-yyyy\'}}{{\'.\'}}</span></td></tr></tfoot></table></div></div><!-- limit tab ends --></div></div></div></div></div><div class="order-price-tab-inner" style="margin-bottom:0px;margin-top:5px" ng-show="vm.defaultInstrumentCode==\'Forward\'"><div class="row margin-right-0"><div class="col-md-6"><label class="control-label left-floating width-20-percent">Exposure</label><div class="select-box search-box width-73-percent" style="margin-left:10px !important"><select name="select" class="select-opt" ng-model="vm.exposureType" ng-options="exposureType.name for exposureType in vm.allExposureLookup track by exposureType.id" ng-disabled="true" ng-required="vm.defaultInstrumentCode==\'Forward\'"></select></div></div><div class="col-md-6"><div class="select-box search-box width-64-percent right-float"><select name="select" class="select-opt" ng-model="vm.exposureSubType" ng-options="exposureSubType.name for exposureSubType in vm.allSubExposureLookup track by exposureSubType.id" ng-disabled="true" ng-required="vm.defaultInstrumentCode==\'Forward\'"></select></div><label class="control-label right-floating width-32-percent">Sub Exposure</label></div></div></div><div class="sell-btn-wrap"><div class="sell-btn-inner textAlignCenter"><p class="order-price-help-text-p"><span class="order-price-help-text">Prices shown are not inclusive of bank mark-up</span></p><p style="float: right"><button type="submit" ng-show="vm.orderType==\'SELL\' && vm.orderDTO.activityIndicator==\'ROLL\'" ng-disabled="frmRolloverTradeOrderEntry.$invalid || (vm.orderDTO.indicativeCancellationRate==null || vm.orderDTO.indicativeCancellationRate==undefined)" class="btn btn-last-tab-sell">SELL</button> <button type="submit" ng-show="vm.orderType==\'BUYY\' && vm.orderDTO.activityIndicator==\'ROLL\'" ng-disabled="frmRolloverTradeOrderEntry.$invalid || (vm.orderDTO.indicativeCancellationRate==null || vm.orderDTO.indicativeCancellationRate==undefined)" class="btn btn-last-tab-buy">BUY</button></p><p style="float: right; margin-top: 7px"><a class="back-to-order-entry" ng-click="vm.cancelModifyOrderAction()"><span class="icon arrow_triangle-left"></span>Back</a></p><p class="add-remarks-p"><a href="javascript:void(0)" class="add-remarks-setting" data-toggle="modal" data-target="#modal-settings" ng-click="vm.openOrderPreference()" ng-show="vm.permitModifyOrderEntry || vm.permitNewOrderEntry"><img class="logo-icon" src="assets/images/box-right-icon.png" title="Order Preference" alt="icon"> </a><a href="javascript:void(0)" class="add-remarks" ng-click="vm.addRemarks()"><i class="fa fa-plus" aria-hidden="true"></i> Remarks</a></p></div></div></div><!--SELL Tab Closed--></div></div></form></div><div class="order-price" ng-if="vm.orderDTO.activityIndicator==\'EARL\'"><form name="frmEarlyDeliveryOrderEntry" role="form" ng-submit="vm.placeOrder()"><script>$(document).ready(function() {\r\n                           $(\'#edRebookingPop\').popover({\r\n                              container: \'body\',\r\n                              html: true\r\n                            })\r\n                        });\r\n                        $(document).ready(function() {\r\n                           $(\'#edCancellationPop\').popover({\r\n                              container: \'body\',\r\n                              html: true\r\n                            })\r\n                        });\r\n                        $(document).ready(function() {\r\n                           $(\'#edSpotPop\').popover({\r\n                              container: \'body\',\r\n                              html: true\r\n                            })\r\n                        });\r\n                        $(document).ready(function() {\r\n                           $(\'#edSpreadPop\').popover({\r\n                              container: \'body\',\r\n                              html: true\r\n                            })\r\n                        });</script><div ng-init="setTradeForm(frmEarlyDeliveryOrderEntry)"><h3 ng-if="vm.outstandtradedatefrom==null">Contract Early Delivery</h3><h3 ng-if="vm.outstandtradedatefrom!=null">Contract Early Delivery (Forward Option Period)</h3><div class="order-price-tab pull-right text-right" style="width: 35%"><ul class="nav nav-tabs" id="orderPriceTabs" role="tablist"><li role="presentation" class="active tab-buy" ng-show="vm.orderDTO.buySellIndicator==\'BUYY\'"><a ng-click="vm.orderType=\'BUYY\'" aria-controls="buy" role="tab" id="earlydeliverybuyTab" data-toggle="tab">BUY</a></li><li role="presentation" class="tab-sell" ng-show="vm.orderDTO.buySellIndicator==\'SELL\'"><a ng-click="vm.orderType=\'SELL\'" aria-controls="sell" role="tab" id="earlydeliverysellTab" data-toggle="tab">SELL</a></li></ul></div><div class="clearfix"></div></div><div ng-class="{\'buy-border\': vm.orderType==\'BUYY\', \'sell-border\': vm.orderType==\'SELL\', \'sellbuy-border\': vm.orderType==\'SELLBUY\'}"><div class="order-price-contents tab-content"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-inner"><div class="padding-left-0 width-100" ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'SPOT\'}" ng-show="vm.orderDTO.instrumentCode==\'SPOT\'"><a id="spotInstrument" aria-controls="spot" role="tab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'SPOT\')">SPOT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'TOM\'}" ng-show="vm.orderDTO.instrumentCode==\'TOM\'"><a id="tomInstrument" aria-controls="tom" role="tab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'TOM\')">TOM</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'CASH\'}" ng-show="vm.orderDTO.instrumentCode==\'CASH\'"><a id="cashInstrument" aria-controls="cash" role="tab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'CASH\')">CASH</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode===\'Forward\'}" ng-show="vm.orderDTO.instrumentCode==\'Forward\'"><a id="forwardInstrument" aria-controls="forward" role="tab" ng-show="!enableOtherCurrencyTab" data-toggle="tab" ng-click="vm.updateDefaultInstrumentDetails(\'Forward\')">FORWARD</a></li></ul><ul class="nav nav-tabs orderPriceTabsInner margin-left-5" role="tablist"><li role="presentation" class="active"><a role="tab" data-toggle="tab">EARLY DELIVERY</a></li></ul><div class="search-box order-entry-branch" ng-if="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.tradingBank" control-id="txtbankFilterForEarlyDelivery" lookup-name="tradingBank" control-disabled="vm.orderDTO.activityIndicator==\'EARL\'" filter-value="{{vm.account.organisation.id}}" display-column="bankName" form="frmEarlyDeliveryOrderEntry" control-place-holder="Enter bank name" control-required="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"></cspl-ach></div><div class="search-box col-md-6 width-53" ng-if="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"><span class="col-md-8"><cspl-ach control-model="vm.tradingCustomer" control-id="txtTradingCustomerForEarlyDelivery" lookup-name="customer" filter-value="{{vm.tradingBank.id}}~~{{vm.tradingBranch.id}}~~{{0}}" control-disabled="vm.orderDTO.activityIndicator==\'EARL\'" display-column="customerCode,customerName" form="frmEarlyDeliveryOrderEntry" control-place-holder="Enter Customer ID or Name" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"></cspl-ach></span><span class="help-block col-md-4 text-align-left padding-left-5" style="right:0px" ng-show="vm.tradingCustomer!=null && vm.tradingCustomer!=undefined" title="{{vm.tradingCustomer.customerName}}">{{vm.tradingCustomer.customerName}}</span></div></div></div><div class="order-price-tab-inner" style="margin-bottom: 0px"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" class="disabled"><a id="dayTimeCondition" aria-controls="day" role="tab" data-toggle="tab" class="disabledTabLink" ng-click="vm.defaultTimeCondition=\'DAYY\';">DAY</a></li><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'IOCC\'}"><a id="iocTimeCondition" aria-controls="ioc" role="tab" data-toggle="tab" class="disabledTabLink" ng-click="vm.defaultTimeCondition=\'IOCC\';">IOC</a></li><li role="presentation" class="disabled"><a id="gttTimeCondition" aria-controls="gtt" role="tab" data-toggle="tab" class="disabledTabLink" ng-click="vm.defaultTimeCondition=\'GTTM\';">GTT</a></li></ul><div class="select-box search-box"><select name="select" class="select-opt" ng-model="vm.tenor" form="frmEarlyDeliveryOrderEntry" ng-options="tenor.tenorName for tenor in vm.tenorsLookupWithoutOption track by tenor.id" ng-change="vm.onChangeTenor(vm.tenor)" ng-required="vm.defaultInstrumentCode==\'Forward\'"></select></div><div class="search-box"><cspl-dtp class="order-date-ctrl" control-model="vm.tradeSettlementDate" control-id="dtpTradeSettlementDate5" control-disabled="vm.tenor.tenorName != \'Broken Date\'" form="frmEarlyDeliveryOrderEntry" control-min-date="vm.minimumTradeSettlementDate" control-max-date="vm.maximumTradeSettlementDate" control-leave-key="vm.onChangeTradeSettlementDate(vm.tradeSettlementDate);" holiday-list="vm.holidayListAfterBusinessDate" show-error-text="true" control-required="true"></div><div class="search-box order-forward-options-date" ng-show="enableOtherCurrencyTab" style="margin-left:5px"><cspl-dtp class="order-date-ctrl" control-model="vm.tradeFCYSettlementDate" control-id="dtpTradeSettlementDate1" form="frmOrderEntry" data-toggle="tooltip" title="{{vm.tenor.tenorName != \'Option Period\'?\'Select Date\':\'Select Option End Date\'}}" control-disabled="true" order-entry-control="true" control-place-holder="End Date"></cspl-dtp></div></div></div><div class="order-price-contents tab-content" ng-class="{\'mkt-order-view\': vm.defaultPriceCondition==\'MRKT\'}"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-last"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><!-- Nav tabs --><ul class="nav nav-tabs" style="border: none" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\'}"><a id="limitTab" class="disabledTabLink" ng-click="vm.defaultPriceCondition=\'LIMT\'">LIMIT</a></li><li role="presentation" class="disabled"><a id="marketTab" class="disabledTabLink" ng-click="vm.defaultPriceCondition=\'MRKT\'">MKT</a></li><li role="presentation" class="disabled"><a id="stoplossTab" class="disabledTabLink" ng-click="vm.defaultPriceCondition=\'STLS\'">SL</a></li><li role="presentation" class="disabled"><a id="takeprofitTab" class="disabledTabLink" ng-click="vm.defaultPriceCondition=\'TKPR\'">TP</a></li></ul><!-- Tab panes --><div class="tab-content"><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\'}" ng-show="vm.defaultPriceCondition==\'LIMT\'"><div class="table-responsive"><table class="table"><thead><th class="text-right">Early Delivery Quantity</th><th class="text-right"><span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Interbank Spot Last Traded Price (LTP) + Swap points applicable for the rebooking date. This rate is subject to change at the time of order execution." tooltip-position="left"><img class="info-tooltip-icon home-page-help-icon"></span><!-- <a ng-show="userPreference.showInfoIcon==\'yes\'" id="edRebookingPop" tabindex="0" data-toggle="popover" role="button" \r\n                                                               data-trigger="focus" data-placement="left" data-content="Interbank Spot Last Traded Price (LTP) + Swap points applicable for the rebooking date. This rate is subject to change at the time of order execution." \r\n                                                               data-template="<div class=\'mainViewPopover popover\' role=\'tooltip\'><div class=\'arrow\'></div><div class=\'popover-content\'></div></div>" >\r\n                                                               <span class="icon"><img class="home-page-help-icon" src="assets/images/Info-24.png" /></span>\r\n                                                               </a> --> <span ng-class="{\'error-text\': (vm.orderDTO.limitExchangeRate==null || vm.orderDTO.limitExchangeRate==undefined)}">Indicative Re-Booking Rate</span></th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" control-id="txtlimitordervalue4" form="frmEarlyDeliveryOrderEntry" show-error-text="true" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" control-id="txtlimitorderprice4" form="frmEarlyDeliveryOrderEntry" show-error-text="true" control-disabled="true" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null"><span class="color-theme-txt" title="Outstanding Quantity">Outstanding Quantity</span> <span>{{vm.orderDTO.outStandingAmount | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Interbank Spot Last Traded Price (LTP) + Swap points applicable for the original contract settlement date. This rate is subject to change at the time of order execution." tooltip-position="left"><img class="info-tooltip-icon home-page-help-icon"></span><!-- <a ng-show="userPreference.showInfoIcon==\'yes\'" id="edCancellationPop" tabindex="0" data-toggle="popover" role="button" \r\n                                                               data-trigger="focus" data-placement="left" data-content="Interbank Spot Last Traded Price (LTP) + Swap points applicable for the original contract settlement date. This rate is subject to change at the time of order execution." \r\n                                                               data-template="<div class=\'mainViewPopover popover\' role=\'tooltip\'><div class=\'arrow\'></div><div class=\'popover-content\'></div></div>" >\r\n                                                                  <span class="icon"><img class="home-page-help-icon" src="assets/images/Info-24.png" /></span>\r\n                                                               </a> --> <span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.orderDTO.indicativeCancellationRate!=null && vm.orderDTO.indicativeCancellationRate!=undefined), \'error-text\': (vm.orderDTO.indicativeCancellationRate==null || vm.orderDTO.indicativeCancellationRate==undefined)}">Indicative Cancellation Rate</span>&nbsp;&nbsp;<span>{{vm.orderDTO.indicativeCancellationRate | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td class="padding-top-0"></td><td class="text-right padding-top-0"><span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Interbank Spot Last Traded Price (LTP). This rate is subject to change at the time of order execution." tooltip-position="left"><img class="info-tooltip-icon home-page-help-icon"></span><!-- <a ng-show="userPreference.showInfoIcon==\'yes\'" id="edSpotPop" tabindex="0" data-toggle="popover" role="button" \r\n                                                               data-trigger="focus" data-placement="left" data-content="Interbank Spot Last Traded Price (LTP). This rate is subject to change at the time of order execution." \r\n                                                               data-template="<div class=\'mainViewPopover popover\' role=\'tooltip\'><div class=\'arrow\'></div><div class=\'popover-content\'></div></div>" >\r\n                                                                  <span class="icon"><img class="home-page-help-icon" src="assets/images/Info-24.png" /></span>\r\n                                                               </a> --> <span class="color-theme-txt" ng-class="{\'color-theme-text\': (vm.orderDTO.indicativeSpotRate!=null && vm.orderDTO.indicativeSpotRate!=undefined), \'error-text\': (vm.orderDTO.indicativeSpotRate==null || vm.orderDTO.indicativeSpotRate==undefined)}">Indicative Spot Rate</span>&nbsp;&nbsp;<span>{{vm.orderDTO.indicativeSpotRate | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><!-- <td class="padding-top-0"></td> --><td class="text-right applied-swap-point padding-top-0" colspan="2"><span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Difference between Swap points applicable for Original settlement date and Re-booking date." tooltip-position="top"><img class="info-tooltip-icon home-page-help-icon"></span><!-- <a ng-show="userPreference.showInfoIcon==\'yes\'" id="edSpreadPop" tabindex="0" data-toggle="popover" role="button" \r\n                                                               data-trigger="focus" data-placement="top" data-content="Difference between Swap points applicable for Original settlement date and Re-booking date." \r\n                                                               data-template="<div class=\'mainViewPopover popover\' role=\'tooltip\'><div class=\'arrow\'></div><div class=\'popover-content\'></div></div>" >\r\n                                                                  <span class="icon"><img class="home-page-help-icon" src="assets/images/Info-24.png" /></span>\r\n                                                               </a> --> <span class="color-theme-txt" ng-if="(vm.orderDTO.forwardSwapPoints!=null && vm.orderDTO.forwardSwapPoints!=undefined)">Applied Swap Points&nbsp;&nbsp;{{vm.orderDTO.forwardSwapPoints | number: vm.noOfDecimalsForAmount}}</span> <span class="error-text" style="font-size:12px;color: #FF1D1D" ng-if="vm.orderDTO.forwardSwapPoints==null || vm.orderDTO.forwardSwapPoints==undefined">{{\'Order not allowed. Bank swap point not available for \'}}{{vm.tradeSettlementDate | date: \'dd-MMM-yyyy\'}}{{\'.\'}}</span></td></tr></tfoot></table></div></div><!-- limit tab ends --></div></div></div></div></div><div class="order-price-tab-inner" style="margin-bottom:0px;margin-top:5px" ng-show="vm.defaultInstrumentCode==\'Forward\'"><div class="row margin-right-0"><div class="col-md-6"><label class="control-label left-floating width-20-percent">Exposure</label><div class="select-box search-box width-73-percent" style="margin-left:10px !important"><select name="select" class="select-opt" ng-model="vm.exposureType" ng-options="exposureType.name for exposureType in vm.allExposureLookup track by exposureType.id" ng-disabled="true" ng-required="vm.defaultInstrumentCode==\'Forward\'"></select></div></div><div class="col-md-6"><div class="select-box search-box width-64-percent right-float"><select name="select" class="select-opt" ng-model="vm.exposureSubType" ng-options="exposureSubType.name for exposureSubType in vm.allSubExposureLookup track by exposureSubType.id" ng-disabled="true" ng-required="vm.defaultInstrumentCode==\'Forward\'"></select></div><label class="control-label right-floating width-32-percent">Sub Exposure</label></div></div></div><div class="sell-btn-wrap"><div class="sell-btn-inner textAlignCenter"><p class="order-price-help-text-p"><span class="order-price-help-text">Prices shown are not inclusive of bank mark-up</span></p><p style="float: right"><button type="submit" ng-show="vm.orderType==\'SELL\' && vm.orderDTO.activityIndicator==\'EARL\'" ng-disabled="frmEarlyDeliveryOrderEntry.$invalid || (vm.orderDTO.indicativeCancellationRate==null || vm.orderDTO.indicativeCancellationRate==undefined)" class="btn btn-last-tab-sell">SELL</button> <button type="submit" ng-show="vm.orderType==\'BUYY\' && vm.orderDTO.activityIndicator==\'EARL\'" ng-disabled="frmEarlyDeliveryOrderEntry.$invalid || (vm.orderDTO.indicativeCancellationRate==null || vm.orderDTO.indicativeCancellationRate==undefined)" class="btn btn-last-tab-buy">BUY</button></p><p style="float: right; margin-top: 7px"><a class="back-to-order-entry" ng-click="vm.cancelModifyOrderAction()"><span class="icon arrow_triangle-left"></span>Back</a></p><p class="add-remarks-p"><a href="javascript:void(0)" class="add-remarks-setting" data-toggle="modal" data-target="#modal-settings" ng-click="vm.openOrderPreference()" ng-show="vm.permitModifyOrderEntry || vm.permitNewOrderEntry"><img class="logo-icon" src="assets/images/box-right-icon.png" title="Order Preference" alt="icon"> </a><a href="javascript:void(0)" class="add-remarks" ng-click="vm.addRemarks()"><i class="fa fa-plus" aria-hidden="true"></i> Remarks</a></p></div></div></div><!--SELL Tab Closed--></div></div></form></div></div></div></div><!-- content-bot-left-wrapper ends --><div ng-class="{\'col-md-7 less-padding\': vm.permitNewOrderEntry==true, \'col-md-12 less-padding\': vm.permitTradingDashboard==true && vm.permitNewOrderEntry==false}" ng-click="vm.removeOrderEntryFocus()"><div ng-include="\'app/entities/home-page-reports/home-page-reports-view.html\'"></div></div></div><!-- main content ends --><!-- </form> --></div>');
$templateCache.put('app/home/home_old.html','<!-- main content starts --><!-- <form name="frmtradinghomepage" role="form" novalidate > vm.globalValues.getOrganisation().organisationType.shortName!=\'CUSTOMER\' --><div class="container-fluid dashboard" ng-show="vm.permitTradingDashboard"><div class="main-content"><div class="row" id="marketwatchdiv" ng-click="vm.removeOrderEntryFocus()"><div class="col-md-6 less-padding"><div class="pinboard" ng-show="vm.account.organisation.organisationType.shortName==\'BANK\'"><div class="row"><div class="col-sm-10 pinboard-border" ng-if="vm.account.entityOwnerType.shortName==\'Bank\'"><div class="col-xs-6 search-box"><cspl-ach control-model="vm.defaultTradingBranch" control-id="txtDefaultTradingBranch" lookup-name="branchesForBank" display-column="branchId,branchName" form="frmtradinghomepage" control-place-holder="Enter Branch ID or Name"></cspl-ach><span class="help-block" ng-show="vm.defaultTradingBranch!=null && vm.defaultTradingBranch!=undefined" title="{{vm.defaultTradingBranch.branchName}}">{{vm.defaultTradingBranch.branchName}}</span></div><div class="col-xs-6 search-box"><cspl-ach control-model="vm.defaultTradingCustomerControl" control-id="txtOrganisation" lookup-name="customer" control-place-holder="Enter Customer ID or Name" filter-value="{{vm.globalValues.getOrganisation().id}}~~{{vm.defaultTradingBranch.id}}~~{{0}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.defaultTradingCustomerControl!=null && vm.defaultTradingCustomerControl!=undefined" title="{{vm.defaultTradingCustomerControl.customerName}}">{{vm.defaultTradingCustomerControl.customerName}}</span></div></div><div class="col-sm-5 pinboard-border" ng-if="vm.account.entityOwnerType.shortName==\'Branch\'"><div class="search-box default-customer"><cspl-ach control-model="vm.defaultTradingCustomerControl" control-id="txtOrganisation" lookup-name="customer" control-place-holder="Enter Customer ID or Name" filter-value="{{vm.globalValues.getOrganisation().id}}~~{{vm.defaultTradingBranch.id}}~~{{0}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.defaultTradingCustomerControl!=null && vm.defaultTradingCustomerControl!=undefined" title="{{vm.defaultTradingCustomerControl.customerName}}">{{vm.defaultTradingCustomerControl.customerName}}</span></div></div><div class="bot-right-header-wrapper go-btn"><!-- <button type="button" class="btn btn-go" ng-click="vm.pinBoard()">\r\n\t\t\t\t\t\t<img class="logo-icon" src="assets/images/Pinboard-22.png" title="Pinboard" alt="icon" /></button>\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t<button type="button" ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && (vm.permitModifyOrderEntry || vm.permitNewOrderEntry)" \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass="btn btn-go" ng-click="vm.openOrderPreference()">\r\n\t\t\t\t\t\t<img class="logo-icon" src="assets/images/My Preference-22.png" title="Order Preference" alt="icon" /></button> --> <span class="box-icon" data-toggle="modal" data-target="#modal-settings" style="padding-left:3px"><a href="javascript:void(0)" class="order-preference" ng-click="vm.pinBoard()"><img class="logo-icon" src="assets/images/Pinboard-22.png" title="Pinboard" alt="icon"> </a></span><span class="box-icon" ng-show="vm.account.organisation.organisationType.shortName==\'BANK\'" data-toggle="modal" data-target="#modal-settings"><a href="javascript:void(0)" class="order-preference" ng-click="vm.openOrderPreference()" ng-show="vm.permitModifyOrderEntry || vm.permitNewOrderEntry"><img class="logo-icon" src="assets/images/My Preference-22.png" title="Order Preference" alt="icon"></a></span></div></div></div><div class="half-part" ng-class="{\'bank-view\': vm.account.organisation.organisationType.shortName==\'BANK\', \r\n\t\t\t\t\t\t\t\t\t\t\t\'selected\' : vm.account.organisation.organisationType.shortName==\'CLEARCORP\'}"><span class="box-icon preference" data-toggle="modal" data-target="#modal-settings"><a href="javascript:void(0)" class="order-preference" ng-click="vm.openOrderPreference()" ng-show="vm.account.organisation.organisationType.shortName==\'CUSTOMER\' && (vm.permitModifyOrderEntry || vm.permitNewOrderEntry)"><img class="logo-icon" src="assets/images/My Preference-22.png" title="Order Preference" alt="icon"></a></span><p class="showing-for" ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'">&nbsp;&nbsp;<span title="{{vm.tradingBank.shortName}}" class="comp-name">{{vm.tradingBank.shortName}}</span></p><div class="box-wrapper"><div class="box-row"><div class="small-box spot-box" ng-class="{\'disabled-box\': retailSpotMarketSession.sessionTimingsDTO.status==\'CLOSED\' || retailSpotMarketSession.isSettlementDateHoliday==true}"><div class="box-top"><div class="pull-left"><h4 class="box-heading">SPOT</h4><p class="box-date">{{retailSpotMarketSession.settlementDate | date: \'dd-MMM-yyyy\'}}</p></div><div class="pull-right text-right"><span ng-class="{\'box-open-icon\': retailSpotMarketSession.sessionTimingsDTO.status==\'OPEN\', \'box-close-icon\': retailSpotMarketSession.sessionTimingsDTO.status==\'CLOSED\' || retailSpotMarketSession.isSettlementDateHoliday==true}">{{retailSpotMarketSession.sessionTimingsDTO.status}}</span><!-- <span class="box-icon"\r\n\t\t\t\t\t\t\t\t\t\t\tdata-toggle="modal" data-target="#modal-settings">\r\n\t\t\t\t\t\t\t\t\t\t\t<a ng-click="vm.openOrderPreference()" ng-show="vm.permitModifyOrderEntry || vm.permitNewOrderEntry">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<img class="logo-icon" src="assets/images/box-right-icon.png" title="Order Preference" alt="icon" />\r\n\t\t\t\t\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t\t\t\t</span> --></div><div class="clearfix"></div></div><!--box-top ends--><!-- box-content --><div class="box-content"><div class="box-buy-sell" ng-class="{\'disabled-box\': ((retailSpotSellLimitForMkt==0 || retailSpotSellLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || (retailSpotMarketWatch.bidPrice<=0 || retailSpotMarketWatch.bidPrice==null || retailSpotMarketWatch.bidPrice==undefined) || vm.defaultTradingCustomer==null}"><div class="box-sell" ng-class="{\'disabled-btn\': vm.permitNewOrderEntry==false}"><div class="pull-left"><div class="la-wrapper"><button class="btn-sell-buy" id="spotMktSell" ng-disabled="vm.orderVolumeSpotMkt==undefined || vm.orderVolumeSpotMkt==\'\' || retailSpotMarketSession.sessionTimingsDTO.status==\'CLOSED\' || retailSpotMarketSession.isSettlementDateHoliday==true || \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t((retailSpotSellLimitForMkt==0 || retailSpotSellLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || vm.defaultTradingCustomer==null || (vm.permitTradingDashboard==true && vm.permitNewOrderEntry==false) || \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t retailSpotMarketWatch.bidPrice<=0 || retailSpotMarketWatch.bidPrice==null || retailSpotMarketWatch.bidPrice==undefined" ng-click="vm.placeMarketOrder(\'SELL\', vm.orderVolumeSpotMkt, \'SPOT\', 3, retailSpotMarketWatch.bidPrice)"><span ng-show="vm.permitNewOrderEntry">You Sell</span><span ng-show="vm.permitNewOrderEntry==false">Sell</span></button><div class="la-class" ng-show="retailSpotMarketSession.sessionTimingsDTO.status==\'OPEN\'">{{retailSpotMarketWatch.bidVolume | number}}</div></div></div><div class="pull-right text-right"><div class="la-wrapper" ng-class="{\'ib-mkt-price\': vm.account.organisation.organisationType.shortName==\'CLEARCORP\'}"><p class="la-count" ng-show="retailSpotMarketSession.sessionTimingsDTO.status==\'OPEN\'">{{retailSpotMarketWatch.bidPrice | split:\'.\':\'0\'}}<span ng-show="retailSpotMarketWatch.bidPrice>0">.</span><span class="la-value">{{retailSpotMarketWatch.bidPrice | number:4 | split:\'.\':\'1\'}}</span></p><div class="la-amount" ng-class="{\'laAmount\': (retailSpotMarketSession.sessionTimingsDTO.status!=\'OPEN\') || (retailSpotMarketSession.sessionTimingsDTO.status==\'OPEN\' && (retailSpotMarketWatch.bidPrice==undefined || retailSpotMarketWatch.bidPrice==null || retailSpotMarketWatch.bidPrice==undefined<=0))}" ng-show="vm.defaultTradingCustomer!=null && vm.defaultTradingCustomer!=undefined && vm.defaultTradingCustomer.isProp==false && vm.account.organisation.organisationType.shortName!=\'BANK\' && retailSpotMarketSession.sessionTimingsDTO.status==\'OPEN\'"><span title="Limit Available">LA</span> {{retailSpotSellLimitForMkt / 1000000 | number:vm.noOfDecimalsForAmount}} M</div></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="box-buy-sell" ng-class="{\'disabled-box\': ((retailSpotBuyLimitForMkt==0 || retailSpotBuyLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || (retailSpotMarketWatch.offerPrice==null || retailSpotMarketWatch.offerPrice==undefined || retailSpotMarketWatch.offerPrice<=0) || vm.defaultTradingCustomer==null}"><div class="box-buy" ng-class="{\'disabled-btn\': vm.permitNewOrderEntry==false}"><div class="pull-right"><div class="la-wrapper"><button class="btn-sell-buy" id="spotMktBuy" ng-disabled="vm.orderVolumeSpotMkt==undefined || vm.orderVolumeSpotMkt==\'\' || retailSpotMarketSession.sessionTimingsDTO.status==\'CLOSED\' || retailSpotMarketSession.isSettlementDateHoliday==true || \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t((retailSpotBuyLimitForMkt==0 || retailSpotBuyLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || vm.defaultTradingCustomer==null || (vm.permitTradingDashboard==true && vm.permitNewOrderEntry==false) ||  \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t retailSpotMarketWatch.offerPrice==null || retailSpotMarketWatch.offerPrice==undefined || retailSpotMarketWatch.offerPrice<=0" ng-click="vm.placeMarketOrder(\'BUYY\', vm.orderVolumeSpotMkt, \'SPOT\', 3, retailSpotMarketWatch.offerPrice)"><span ng-show="vm.permitNewOrderEntry">You Buy</span><span ng-show="vm.permitNewOrderEntry==false">Buy</span></button><div class="la-class" ng-show="retailSpotMarketSession.sessionTimingsDTO.status==\'OPEN\'"><span class="text">{{retailSpotMarketWatch.offerVolume | number}}</span></div></div></div><div class="pull-left"><div class="la-wrapper" ng-class="{\'ib-mkt-price\': vm.account.organisation.organisationType.shortName==\'CLEARCORP\'}"><p class="la-count" ng-show="retailSpotMarketSession.sessionTimingsDTO.status==\'OPEN\'">{{retailSpotMarketWatch.offerPrice | split:\'.\':\'0\'}}<span ng-show="retailSpotMarketWatch.offerPrice>0">.</span><span class="la-value">{{retailSpotMarketWatch.offerPrice | number:4 | split:\'.\':\'1\'}}</span></p><div class="la-amount" ng-show="vm.defaultTradingCustomer!=null && vm.defaultTradingCustomer!=undefined && vm.defaultTradingCustomer.isProp==false && vm.account.organisation.organisationType.shortName!=\'BANK\' && retailSpotMarketSession.sessionTimingsDTO.status==\'OPEN\'"><span title="Limit Available">LA</span> {{retailSpotBuyLimitForMkt / 1000000 | number:vm.noOfDecimalsForAmount}} M</div></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="mkt-value" ng-hide="(vm.permitTradingDashboard==true && vm.permitNewOrderEntry==false) || vm.defaultTradingCustomer==null"><span class="mkt-price"><cspl-number-text control-model="vm.orderVolumeSpotMkt" cspl-shortcuts="vm.executeplaceOrderShortcut(value, vm.orderVolumeSpotMkt, \'SPOT\', 3, retailSpotMarketWatch.bidPrice, retailSpotMarketWatch.offerPrice)" show-error-text="false" no-of-decimals="{{vm.noOfDecimalsForAmount}}" control-id="txtorderVolumeSpotMkt" control-disabled="(((retailSpotSellLimitForMkt==0 || retailSpotSellLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) ||  \r\n\t\t\t\t\t\t\t\t\t\t(retailSpotMarketWatch.bidPrice<=0 || retailSpotMarketWatch.bidPrice==null || retailSpotMarketWatch.bidPrice==undefined) || vm.defaultTradingCustomer==null) && \r\n\t\t\t\t\t\t\t\t\t\t(((retailSpotBuyLimitForMkt==0 || retailSpotBuyLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || (retailSpotMarketWatch.offerPrice==null || retailSpotMarketWatch.offerPrice==undefined || retailSpotMarketWatch.offerPrice<=0) ||  \r\n\t\t\t\t\t\t\t\t\t\tvm.defaultTradingCustomer==null) || retailSpotMarketSession.sessionTimingsDTO.status==\'CLOSED\' || retailSpotMarketSession.isSettlementDateHoliday==true" control-max="999999999.99" required></span></div></div><!-- box-content ends --></div></div><div class="box-row"><div class="small-box ib-spot-box"><div class="box-top"><div class="pull-left"><h4 class="box-heading">IB. SPOT</h4></div><div class="pull-right text-right"><span class="box-icon" data-toggle="modal" data-target="#modal-settings"><!-- <a ng-click="vm.openOrderPreference()">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<img class="logo-icon" src="assets/images/box-right-icon.png" alt="icon" />\r\n\t\t\t\t\t\t\t\t\t\t\t</a> --></span></div><div class="clearfix"></div></div><!--box-top ends--><!-- box-content --><div class="box-content"><div class="box-buy-sell"><div class="box-sell"><div class="pull-left"><div class="la-wrapper"><button class="btn-sell-buy" ng-disabled="false">SELL</button><div class="la-class">{{ibSpotMarketWatch.bidVolume | number}}</div></div></div><div class="pull-right text-right"><div class="la-wrapper ib-mkt-price"><p class="la-count">{{ibSpotMarketWatch.bidPrice | split:\'.\':\'0\' }}<span ng-show="ibSpotMarketWatch.bidPrice>0">.</span><span class="la-value">{{ibSpotMarketWatch.bidPrice | number:4 | split:\'.\':\'1\'}}</span></p></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="box-buy-sell"><div class="box-buy"><div class="pull-right"><div class="la-wrapper"><button class="btn-sell-buy" ng-disabled="false">BUY</button><div class="la-class"><span class="text">{{ibSpotMarketWatch.offerVolume | number}}</span></div></div></div><div class="pull-left"><div class="la-wrapper ib-mkt-price"><p class="la-count">{{ibSpotMarketWatch.offerPrice | split:\'.\':\'0\' }}<span ng-show="ibSpotMarketWatch.offerPrice>0">.</span><span class="la-value">{{ibSpotMarketWatch.offerPrice | number:4 | split:\'.\':\'1\'}}</span></p></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><!-- <div class="mkt-value">Mkt <span class="mkt-price"><input type="text" name="ibspot-mkt-price" value="800,000"/></span></div> --></div><!-- box-content ends --></div></div></div><!-- box-wrapper ends --></div><div class="half-part" ng-class="{\'not-selected bank-view\': vm.account.organisation.organisationType.shortName==\'BANK\', \'selected\': vm.account.organisation.organisationType.shortName!=\'BANK\'}"><p class="showing-for" style="visibility:hidden" ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'">Showing for : <span class="comp-name">{{vm.tradingBank.shortName}}</span></p><div class="box-wrapper"><div class="box-row"><div class="small-box cash-box" ng-class="{\'disabled-box\': cashMarketSession.sessionTimingsDTO.status==\'CLOSED\' || cashMarketSession.isSettlementDateHoliday==true}"><div class="box-top"><div class="pull-left"><h4 class="box-heading">CASH</h4><p class="box-date" ng-hide="cashMarketSession.isSettlementDateHoliday==true">{{cashMarketSession.settlementDate | date: \'dd-MMM-yyyy\'}}</p></div><div class="pull-right text-right"><span ng-class="{\'box-open-icon\': cashMarketSession.sessionTimingsDTO.status==\'OPEN\', \'box-close-icon\': cashMarketSession.sessionTimingsDTO.status==\'CLOSED\' || cashMarketSession.isSettlementDateHoliday==true}">{{cashMarketSession.sessionTimingsDTO.status}}</span><!-- <span class="box-icon"\r\n\t\t\t\t\t\t\t\t\t\t\tdata-toggle="modal" data-target="#modal-settings">\r\n\t\t\t\t\t\t\t\t\t\t\t<a ng-click="vm.openOrderPreference()" ng-show="vm.permitModifyOrderEntry || vm.permitNewOrderEntry">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<img class="logo-icon" src="assets/images/box-right-icon.png" title="Order Preference" alt="icon" />\r\n\t\t\t\t\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t\t\t\t</span> --></div><div class="clearfix"></div></div><!--box-top ends--><!-- box-content --><div class="box-content"><div class="box-buy-sell" ng-class="{\'disabled-box\': ((cashSellLimitForMkt==0 || cashSellLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || (cashMarketWatch.bidPrice<=0 || cashMarketWatch.bidPrice==null || cashMarketWatch.bidPrice==undefined) || vm.defaultTradingCustomer==null}"><div class="box-sell" ng-class="{\'disabled-btn\': vm.permitNewOrderEntry==false}"><div class="pull-left"><div class="la-wrapper"><button class="btn-sell-buy" id="cashMktSell" ng-disabled="vm.orderVolumeCashMkt==undefined || vm.orderVolumeCashMkt==\'\' || cashMarketSession.sessionTimingsDTO.status==\'CLOSED\' || cashMarketSession.isSettlementDateHoliday==true || \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t((cashSellLimitForMkt==0 || cashSellLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || vm.defaultTradingCustomer==null || (vm.permitTradingDashboard==true && vm.permitNewOrderEntry==false) || \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t cashMarketWatch.bidPrice<=0 || cashMarketWatch.bidPrice==null || cashMarketWatch.bidPrice==undefined" ng-click="vm.placeMarketOrder(\'SELL\', vm.orderVolumeCashMkt, \'CASH\', 1, cashMarketWatch.bidPrice)"><span ng-show="vm.permitNewOrderEntry">You Sell</span><span ng-show="vm.permitNewOrderEntry==false">Sell</span></button><div class="la-class" ng-show="cashMarketSession.sessionTimingsDTO.status==\'OPEN\'">{{cashMarketWatch.bidVolume | number}}</div></div></div><div class="pull-right text-right"><div class="la-wrapper" ng-class="{\'ib-mkt-price\': vm.account.organisation.organisationType.shortName==\'CLEARCORP\'}"><p class="la-count" ng-show="cashMarketSession.sessionTimingsDTO.status==\'OPEN\'">{{cashMarketWatch.bidPrice | split:\'.\':\'0\' }}<span ng-show="cashMarketWatch.bidPrice>0">.</span><span class="la-value">{{cashMarketWatch.bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></p><p class="spread" ng-show="cashMarketSession.sessionTimingsDTO.status==\'OPEN\' && cashMarketWatch.bidPrice>0 && defaultBankSpread.cashSpotOfferSpread!=null && defaultBankSpread.cashSpotOfferSpread!=undefined">({{defaultBankSpread.cashSpotOfferSpread}})</p><div class="la-amount" ng-class="{\'laAmount\': (cashMarketSession.sessionTimingsDTO.status!=\'OPEN\') || (cashMarketSession.sessionTimingsDTO.status==\'OPEN\' && (cashMarketWatch.bidPrice<=0 || cashMarketWatch.bidPrice==undefined || cashMarketWatch.bidPrice==null))}" ng-show="vm.defaultTradingCustomer!=null && vm.defaultTradingCustomer!=undefined && vm.defaultTradingCustomer.isProp==false && vm.account.organisation.organisationType.shortName!=\'BANK\' && cashMarketSession.sessionTimingsDTO.status==\'OPEN\'"><span title="Limit Available">LA</span> {{cashSellLimitForMkt / 1000000 | number: vm.noOfDecimalsForAmount}} M</div></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="box-buy-sell" ng-class="{\'disabled-box\': ((cashBuyLimitForMkt==0 || cashBuyLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || (cashMarketWatch.offerPrice<=0 || cashMarketWatch.offerPrice==null || cashMarketWatch.offerPrice==undefined) || vm.defaultTradingCustomer==null}"><div class="box-buy" ng-class="{\'disabled-btn\': vm.permitNewOrderEntry==false}"><div class="pull-right"><div class="la-wrapper"><button class="btn-sell-buy" id="cashMktBuy" ng-disabled="vm.orderVolumeCashMkt==undefined || vm.orderVolumeCashMkt==\'\' || cashMarketSession.sessionTimingsDTO.status==\'CLOSED\' || cashMarketSession.isSettlementDateHoliday==true || \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t((cashBuyLimitForMkt==0 || cashBuyLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || vm.defaultTradingCustomer==null || (vm.permitTradingDashboard==true && vm.permitNewOrderEntry==false) || \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t cashMarketWatch.offerPrice<=0 || cashMarketWatch.offerPrice==null || cashMarketWatch.offerPrice==undefined" ng-click="vm.placeMarketOrder(\'BUYY\', vm.orderVolumeCashMkt, \'CASH\', 1, cashMarketWatch.offerPrice)"><span ng-show="vm.permitNewOrderEntry">You Buy</span><span ng-show="vm.permitNewOrderEntry==false">Buy</span></button><div class="la-class" ng-show="cashMarketSession.sessionTimingsDTO.status==\'OPEN\'"><span class="text">{{cashMarketWatch.offerVolume | number}}</span></div></div></div><div class="pull-left"><div class="la-wrapper" ng-class="{\'ib-mkt-price\': vm.account.organisation.organisationType.shortName==\'CLEARCORP\'}"><p class="la-count" ng-show="cashMarketSession.sessionTimingsDTO.status==\'OPEN\'">{{cashMarketWatch.offerPrice | split:\'.\':\'0\' }}<span ng-show="cashMarketWatch.offerPrice>0">.</span><span class="la-value">{{cashMarketWatch.offerPrice | number:vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></p><p class="spread" ng-show="cashMarketSession.sessionTimingsDTO.status==\'OPEN\' && cashMarketWatch.offerPrice>0 && defaultBankSpread.cashSpotBidSpread!=null && defaultBankSpread.cashSpotBidSpread!=undefined">({{defaultBankSpread.cashSpotBidSpread}})</p><div class="la-amount" ng-show="vm.defaultTradingCustomer!=null && vm.defaultTradingCustomer!=undefined && vm.defaultTradingCustomer.isProp==false && vm.account.organisation.organisationType.shortName!=\'BANK\' && cashMarketSession.sessionTimingsDTO.status==\'OPEN\'"><span title="Limit Available">LA</span> {{cashBuyLimitForMkt / 1000000 | number: vm.noOfDecimalsForAmount}} M</div></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="mkt-value" ng-hide="(vm.permitTradingDashboard==true && vm.permitNewOrderEntry==false) || vm.defaultTradingCustomer==null"><span class="mkt-price"><cspl-number-text control-model="vm.orderVolumeCashMkt" control-id="txtorderVolumeCashMkt" cspl-shortcuts="vm.executeplaceOrderShortcut(value, vm.orderVolumeCashMkt, \'CASH\', 1, cashMarketWatch.bidPrice, cashMarketWatch.offerPrice)" control-disabled="(((cashSellLimitForMkt==0 || cashSellLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || (cashMarketWatch.bidPrice<=0 || cashMarketWatch.bidPrice==null || cashMarketWatch.bidPrice==undefined) || vm.defaultTradingCustomer==null) && \r\n\t\t\t\t\t\t\t\t\t\t(((cashBuyLimitForMkt==0 || cashBuyLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || (cashMarketWatch.offerPrice<=0 || cashMarketWatch.offerPrice==null || cashMarketWatch.offerPrice==undefined) || vm.defaultTradingCustomer==null) || \r\n\t\t\t\t\t\t\t\t\t\tcashMarketSession.sessionTimingsDTO.status==\'CLOSED\' || cashMarketSession.isSettlementDateHoliday==true" show-error-text="false" no-of-decimals="{{vm.noOfDecimalsForAmount}}" control-min="0" control-max="999999999.99" required></span></div></div><!-- box-content ends --></div></div><div class="box-row"><div class="small-box tom-box" ng-class="{\'disabled-box\': tomMarketSession.sessionTimingsDTO.status==\'CLOSED\' || tomMarketSession.isSettlementDateHoliday==true}"><div class="box-top"><div class="pull-left"><h4 class="box-heading">TOM</h4><p class="box-date" ng-hide="tomMarketSession.isSettlementDateHoliday==true">{{tomMarketSession.settlementDate | date: \'dd-MMM-yyyy\'}}</p></div><div class="pull-right text-right"><span ng-class="{\'box-open-icon\': tomMarketSession.sessionTimingsDTO.status==\'OPEN\', \'box-close-icon\': tomMarketSession.sessionTimingsDTO.status==\'CLOSED\' || tomMarketSession.isSettlementDateHoliday==true}">{{tomMarketSession.sessionTimingsDTO.status}}</span></div><div class="clearfix"></div></div><!--box-top ends--><!-- box-content --><div class="box-content"><div class="box-buy-sell" ng-class="{\'disabled-box\': ((tomSellLimitForMkt==0 || tomSellLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || (tomMarketWatch.bidPrice<=0 || tomMarketWatch.bidPrice==null || tomMarketWatch.bidPrice==undefined) || vm.defaultTradingCustomer==null}"><div class="box-sell" ng-class="{\'disabled-btn\': vm.permitNewOrderEntry==false}"><div class="pull-left"><div class="la-wrapper"><button class="btn-sell-buy" id="tomMktSell" ng-disabled="vm.orderVolumeTomMkt==undefined || vm.orderVolumeTomMkt==\'\' || tomMarketSession.sessionTimingsDTO.status==\'CLOSED\' || tomMarketSession.isSettlementDateHoliday==true || \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t((tomSellLimitForMkt==0 || tomSellLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || vm.defaultTradingCustomer==null || (vm.permitTradingDashboard==true && vm.permitNewOrderEntry==false) || \r\n\t\t\t\t\t\t\t\t\t\t\t\t\ttomMarketWatch.bidPrice<=0 || tomMarketWatch.bidPrice==null || tomMarketWatch.bidPrice==undefined" ng-click="vm.placeMarketOrder(\'SELL\', vm.orderVolumeTomMkt, \'TOM\', 2, tomMarketWatch.bidPrice)"><span ng-show="vm.permitNewOrderEntry">You Sell</span><span ng-show="vm.permitNewOrderEntry==false">Sell</span></button><div class="la-class" ng-if="tomMarketSession.sessionTimingsDTO.status==\'OPEN\'">{{tomMarketWatch.bidVolume | number}}</div></div></div><div class="pull-right text-right"><div class="la-wrapper" ng-class="{\'ib-mkt-price\': vm.account.organisation.organisationType.shortName==\'CLEARCORP\'}"><p class="la-count" ng-if="tomMarketSession.sessionTimingsDTO.status==\'OPEN\'">{{tomMarketWatch.bidPrice | split:\'.\':\'0\' }}<span ng-show="tomMarketWatch.bidPrice>0">.</span><span class="la-value">{{tomMarketWatch.bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></p><p class="spread" ng-if="tomMarketSession.sessionTimingsDTO.status==\'OPEN\' && tomMarketWatch.bidPrice>0 && defaultBankSpread.tomSpotOfferSpread!=null && defaultBankSpread.tomSpotOfferSpread!=undefined">({{defaultBankSpread.tomSpotOfferSpread}})</p><div class="la-amount" ng-class="{\'laAmount\': (tomMarketSession.sessionTimingsDTO.status!=\'OPEN\') || (tomMarketSession.sessionTimingsDTO.status==\'OPEN\' && (tomMarketWatch.bidPrice<=0 || tomMarketWatch.bidPrice==undefined || tomMarketWatch.bidPrice==null))}" ng-show="vm.defaultTradingCustomer!=null && vm.defaultTradingCustomer!=undefined && vm.defaultTradingCustomer.isProp==false && vm.account.organisation.organisationType.shortName!=\'BANK\' && tomMarketSession.sessionTimingsDTO.status==\'OPEN\'"><span title="Limit Available">LA</span> {{tomSellLimitForMkt / 1000000 | number: vm.noOfDecimalsForAmount}} M</div></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="box-buy-sell" ng-class="{\'disabled-box\': ((tomBuyLimitForMkt==0 || tomBuyLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || (tomMarketWatch.offerPrice<=0 || tomMarketWatch.offerPrice==null || tomMarketWatch.offerPrice==undefined) || vm.defaultTradingCustomer==null}"><div class="box-buy" ng-class="{\'disabled-btn\': vm.permitNewOrderEntry==false}"><div class="pull-right"><div class="la-wrapper"><button class="btn-sell-buy" id="tomMktBuy" ng-disabled="vm.orderVolumeTomMkt==undefined || vm.orderVolumeTomMkt==\'\' || tomMarketSession.sessionTimingsDTO.status==\'CLOSED\' || tomMarketSession.isSettlementDateHoliday==true || \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t((tomBuyLimitForMkt==0 || tomBuyLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || vm.defaultTradingCustomer==null || (vm.permitTradingDashboard==true && vm.permitNewOrderEntry==false) || \r\n\t\t\t\t\t\t\t\t\t\t\t\t\ttomMarketWatch.offerPrice<=0 || tomMarketWatch.offerPrice==null || tomMarketWatch.offerPrice==undefined" ng-click="vm.placeMarketOrder(\'BUYY\', vm.orderVolumeTomMkt, \'TOM\', 2, tomMarketWatch.offerPrice)"><span ng-show="vm.permitNewOrderEntry">You Buy</span><span ng-show="vm.permitNewOrderEntry==false">Buy</span></button><div class="la-class" ng-if="tomMarketSession.sessionTimingsDTO.status==\'OPEN\'"><span class="text">{{tomMarketWatch.offerVolume | number}}</span></div></div></div><div class="pull-left"><div class="la-wrapper" ng-class="{\'ib-mkt-price\': vm.account.organisation.organisationType.shortName==\'CLEARCORP\'}"><p class="la-count" ng-show="tomMarketSession.sessionTimingsDTO.status==\'OPEN\'">{{tomMarketWatch.offerPrice | split:\'.\':\'0\' }}<span ng-show="tomMarketWatch.offerPrice>0">.</span><span class="la-value">{{tomMarketWatch.offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></p><p class="spread" ng-show="tomMarketSession.sessionTimingsDTO.status==\'OPEN\' && tomMarketWatch.offerPrice>0  && defaultBankSpread.tomSpotBidSpread!=null && defaultBankSpread.tomSpotBidSpread!=undefined">({{defaultBankSpread.tomSpotBidSpread}})</p><div class="la-amount" ng-show="vm.defaultTradingCustomer!=null && vm.defaultTradingCustomer!=undefined && vm.defaultTradingCustomer.isProp==false && vm.account.organisation.organisationType.shortName!=\'BANK\' && tomMarketSession.sessionTimingsDTO.status==\'OPEN\'"><span title="Limit Available">LA</span> {{tomBuyLimitForMkt / 1000000 | number: vm.noOfDecimalsForAmount}} M</div></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="mkt-value" ng-hide="(vm.permitTradingDashboard==true && vm.permitNewOrderEntry==false) || vm.defaultTradingCustomer==null"><span class="mkt-price"><cspl-number-text control-model="vm.orderVolumeTomMkt" control-id="txtorderVolumeTomMkt" cspl-shortcuts="vm.executeplaceOrderShortcut(value, vm.orderVolumeTomMkt, \'TOM\', 2, tomMarketWatch.bidPrice, tomMarketWatch.offerPrice)" control-disabled="(((tomSellLimitForMkt==0 || tomSellLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || (tomMarketWatch.bidPrice<=0 || tomMarketWatch.bidPrice==null || tomMarketWatch.bidPrice==undefined) || vm.defaultTradingCustomer==null) && \r\n\t\t\t\t\t\t\t\t\t\t(((tomBuyLimitForMkt==0 || tomBuyLimitForMkt==null) && vm.defaultTradingCustomer.isProp==false) || (tomMarketWatch.offerPrice<=0 || tomMarketWatch.offerPrice==null || tomMarketWatch.offerPrice==undefined) || vm.defaultTradingCustomer==null) || \r\n\t\t\t\t\t\t\t\t\t\ttomMarketSession.sessionTimingsDTO.status==\'CLOSED\' || tomMarketSession.isSettlementDateHoliday==true" show-error-text="false" no-of-decimals="{{vm.noOfDecimalsForAmount}}" control-min="0" control-max="999999999.99" required></span></div></div><!-- box-content ends --></div></div></div><!-- box-wrapper ends --></div></div><div class="col-md-6 less-padding"><!-- Content right wrapper starts --><div class="market-depth markup"><div ng-class="{\'bank-branch-view\': vm.account.organisation.organisationType.shortName==\'BANK\'}"><h3></h3><ul class="market-depth-tab nav nav-tabs" role="tablist" style="float:left; margin-top: -10px"><li role="presentation" class="statistics-tab active"><a href="#comparitive_tab1" aria-controls="home" role="tab" ng-click="vm.showPriceIcon=true;" data-toggle="tab"><span class="icon-tab-head" ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'">Bank Comparative Quotes</span> <span class="icon-tab-head" ng-show="vm.account.organisation.organisationType.shortName==\'BANK\'">Swap Quote</span></a></li><li role="presentation" class="statistics-tab" ng-show="vm.account.organisation.organisationType.shortName == \'CUSTOMER\'"><a href="#markup_tab" aria-controls="home" role="tab" ng-click="vm.showPriceIcon=false;" data-toggle="tab"><span class="icon-tab-head">Markup</span></a></li></ul><div class="bcq-head" ng-if="vm.showPriceIcon"><div class="bcq-head-icons"><ul class="nav nav-tabs"><li class="active"><a data-toggle="tab" href="#comparitive_tab1" class="bcq-icon1" title="Quotes In Paise"></a></li><li><a data-toggle="tab" href="#comparitive_tab2" class="bcq-icon2" title="Quotes In Price"></a></li></ul></div></div><div class="tab-content market-depth-contents"><div role="tabpanel" class="tab-pane active" id="comparitive_tab1"><div class="bank-comparitive-contents"><div class="table-responsive table-fixed"><table class="table table-striped"><thead><tr class="inst"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'"></td><td align="center" class="headerRow" colspan="2">CASH/SPOT</td><td align="center" colspan="2"><span class="price-unit-val" ng-show="!vm.permitSwapQuotesEditEntityAction">(Val in Paise)</span><span ng-class="{\'headerRow\': vm.permitSwapQuotesEditEntityAction, \'headerRightRow\': !vm.permitSwapQuotesEditEntityAction}">TOM/SPOT</span></td><td ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction"><span class="price-unit-val" ng-show="vm.account.organisation.organisationType.shortName==\'BANK\'">(Val in Paise)</span></td></tr><tr class="thead"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'">Bank</td><td class="text-right">Bid Spread</td><td class="text-right right-border">Offer Spread</td><td class="text-right">Bid Spread</td><td class="text-right">Offer Spread</td><td class="text-right" ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction"></td></tr></thead><tbody><tr ng-repeat="swapQuotes in bankComparativeQuotes"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'"><span class="comp-name" ng-class="{\'selected\': swapQuotes.bank.bankName==vm.defaultTradingBank.bankName && vm.account.organisation.organisationType.shortName!=\'BANK\'}" ng-click="vm.onChangingBankInSwapQuotes(swapQuotes.bank)" title="{{swapQuotes.bank.bankName}}">{{swapQuotes.bank.bankName}}</span></td><td class="text-right"><span class="bid-spread" ng-class="{\'selected\': swapQuotes.cashSpotBidSpread==bestCashSpotBidSpread && vm.account.organisation.organisationType.shortName!=\'BANK\'}">{{swapQuotes.cashSpotBidSpread}}</span></td><td class="text-right right-border"><span class="offer-spread" ng-class="{\'selected\': swapQuotes.cashSpotOfferSpread==bestCashSpotOfferSpread && vm.account.organisation.organisationType.shortName!=\'BANK\'}">{{swapQuotes.cashSpotOfferSpread}}</span></td><td class="text-right"><span class="bid-spread" ng-class="{\'selected\': swapQuotes.tomSpotBidSpread==bestTomSpotBidSpread && vm.account.organisation.organisationType.shortName!=\'BANK\'}">{{swapQuotes.tomSpotBidSpread}}</span></td><td class="text-right"><span class="offer-spread" ng-class="{\'selected\': swapQuotes.tomSpotOfferSpread==bestTomSpotOfferSpread && vm.account.organisation.organisationType.shortName!=\'BANK\'}">{{swapQuotes.tomSpotOfferSpread}}</span></td><td align="center" ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction"><span class="edit-row"><img src="assets/images/edit-icon.png" ng-click="vm.editSwapQuotes(swapQuotes.id)"></span></td></tr><tr ng-show="bankComparativeQuotes.length<2 && vm.account.organisation.organisationType.shortName!=\'BANK\'"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'"></td><td></td><td class="right-border"></td><td></td><td></td><td ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction"></td></tr><tr ng-show="bankComparativeQuotes.length<3 && vm.account.organisation.organisationType.shortName!=\'BANK\'"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'"></td><td></td><td class="right-border"></td><td></td><td></td><td ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction"></td></tr></tbody><tfoot><tr><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'">&nbsp;</td><td class="text-right">Bid Quantity</td><td class="text-right">{{retailSpotMarketWatch.bidVolume | number}}</td><td class="text-right">Offer Quantity</td><td class="text-right">{{retailSpotMarketWatch.offerVolume | number}}</td><td ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction"></td></tr></tfoot></table></div><div class="clearfix"></div></div></div><!--Bank Comparitive Tab 1 CLOSED--><div role="tabpanel" class="tab-pane" id="comparitive_tab2"><div class="bank-comparitive-contents"><div class="table-responsive table-fixed" ng-class="{\'table-container\': vm.account.organisation.organisationType.shortName!=\'BANK\'}"><table class="table table-striped"><tbody><tr class="inst"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'"></td><td align="center" class="headerRow" colspan="2">CASH</td><td align="center" class="headerRow" colspan="2">TOM</td></tr><tr class="thead"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'">Bank</td><td class="text-right">Bid Price</td><td class="text-right right-border">Offer Price</td><td class="text-right">Bid Price</td><td class="text-right">Offer Price</td></tr></tbody><tbody><tr ng-repeat="swapQuotesInPrice in bankQuotesInPrice"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'"><span class="comp-name" ng-class="{\'selected\': swapQuotesInPrice.bank.bankName==vm.defaultTradingBank.bankName}" ng-click="vm.onChangingBankInSwapQuotes(swapQuotesInPrice.bank)" tilte="{{swapQuotesInPrice.bank.bankName}}">{{swapQuotesInPrice.bank.bankName}}</span></td><td class="text-right"><span class="bcq-highlighted-txt" ng-class="{\'selected\': swapQuotesInPrice.cashSpotBidSpread==bestCashSpotBidSpread}">{{swapQuotesInPrice.cashSpotBidSpread | split:\'.\':\'0\'}}<span ng-show="swapQuotesInPrice.cashSpotBidSpread>=0 && swapQuotesInPrice.cashSpotBidSpread!=null && swapQuotesInPrice.cashSpotBidSpread!=undefined">.{{swapQuotesInPrice.cashSpotBidSpread | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right right-border"><span class="bcq-highlighted-txt" ng-class="{\'selected\': swapQuotesInPrice.cashSpotOfferSpread==bestCashSpotOfferSpread}">{{swapQuotesInPrice.cashSpotOfferSpread | split:\'.\':\'0\'}}<span ng-show="swapQuotesInPrice.cashSpotOfferSpread>=0 && swapQuotesInPrice.cashSpotOfferSpread!=null && swapQuotesInPrice.cashSpotOfferSpread!=undefined">.{{swapQuotesInPrice.cashSpotOfferSpread | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span class="bcq-highlighted-txt" ng-class="{\'selected\': swapQuotesInPrice.tomSpotBidSpread==bestTomSpotBidSpread}">{{swapQuotesInPrice.tomSpotBidSpread | split:\'.\':\'0\'}}<span ng-show="swapQuotesInPrice.tomSpotBidSpread>=0 && swapQuotesInPrice.tomSpotBidSpread!=null && swapQuotesInPrice.tomSpotBidSpread!=undefined">.{{swapQuotesInPrice.tomSpotBidSpread | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span class="bcq-highlighted-txt" ng-class="{\'selected\': swapQuotesInPrice.tomSpotOfferSpread==bestTomSpotOfferSpread}">{{swapQuotesInPrice.tomSpotOfferSpread | split:\'.\':\'0\'}}<span ng-show="swapQuotesInPrice.tomSpotOfferSpread>=0 && swapQuotesInPrice.tomSpotOfferSpread!=null && swapQuotesInPrice.tomSpotOfferSpread!=undefined">.{{swapQuotesInPrice.tomSpotOfferSpread | number:4 | split:\'.\':\'1\'}}</span></span></td></tr><tr ng-show="bankQuotesInPrice.length<2 && vm.account.organisation.organisationType.shortName!=\'BANK\'"><td></td><td></td><td class="right-border"></td><td></td><td></td></tr><tr ng-show="bankQuotesInPrice.length<3 && vm.account.organisation.organisationType.shortName!=\'BANK\'"><td></td><td></td><td class="right-border"></td><td></td><td></td></tr></tbody><tfoot><tr><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'">&nbsp;</td><td class="text-right">Bid Quantity</td><td class="text-right">{{retailSpotMarketWatch.bidVolume | number}}</td><td class="text-right">Offer Quantity</td><td class="text-right">{{retailSpotMarketWatch.offerVolume | number}}</td></tr></tfoot></table></div><div class="clearfix"></div></div></div><div role="tabpanel" class="tab-pane" id="markup_tab"><div class="bank-comparitive-contents"><div class="table-responsive table-fixed" ng-class="{\'table-container\': vm.account.organisation.organisationType.shortName!=\'BANK\'}"><table class="table table-striped"><thead><tr><td></td><td></td><td></td></tr><tr><th>Bank&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</th><th>Markup Type</th><th class="text-right">Markup Value</th></tr></thead><tbody><tr ng-repeat="markup in markupSettings"><td><span class="comp-name" ng-class="{\'selected\': markup.bankName==vm.defaultTradingBank.bankName && vm.account.organisation.organisationType.shortName!=\'BANK\'}" ng-click="vm.onChangingBankInMarkup(markup.bankName)" title="{{markup.bank.bankName}}">{{markup.bankName}}</span></td><td><span class="mdc-highlighted-txt">{{markup.markupType}}</span></td><td class="text-right"><span ng-show="markup.markupType==\'Paise\'">{{markup.markupValue | number:vm.noOfDecimalsForAmount}}</span> <span ng-show="markup.markupType==\'Percentage\'">{{markup.markupValue| number:vm.noOfDecimalsForPercent}}</span></td></tr><tr ng-show="markupSettings.length<2 && vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"><td></td><td></td><td></td></tr><tr ng-show="markupSettings.length<3 && vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"><td></td><td></td><td></td></tr></tbody></table></div><div class="clearfix"></div></div></div><!--Bank Comparitive Tab 2 CLOSED--></div></div></div><!-- bank-comparitive-quotes ends--><div class="market-depth"><div ng-class="{\'bank-branch-view\': vm.account.organisation.organisationType.shortName==\'BANK\'}"><h3>Market Depth</h3>&nbsp;&nbsp;<span class="server-down-text" ng-show="broadcastServerDown"><img class="server-down-error" src="assets/images/Server Down-20.png" alt="server-down" title="Broadcast is not available">&nbsp;Broadcast is not available</span><ul class="market-depth-tab nav nav-tabs" role="tablist"><li role="presentation" class="statistics-tab active"><a href="#spotStatistics" aria-controls="home" role="tab" data-toggle="tab"><span class="icon-tab-head">SPOT</span> <span class="tab-icon statistics-modal" data-toggle="modal" title="Market Statistics" data-target="#modal-table" ng-click="vm.openMarketStatistics(\'SPOT\')"></span> <span class="tab-icon maximise-icon popUPIcon" ng-click="vm.expandMarketDepth(\'Retail Spot\', retailSpotMarketDepth)"></span></a></li><li role="presentation" class="statistics-tab"><a href="#intSpotStatistics" aria-controls="home" role="tab" data-toggle="tab"><span class="icon-tab-head" title="INTERBANK SPOT">IB. SPOT</span> <span class="tab-icon statistics-modal" title="Market Statistics" data-toggle="modal" data-target="#modal-table" ng-click="vm.openMarketStatistics(\'InterbankSPOT\')"></span> <span class="tab-icon maximise-icon popUPIcon" ng-click="vm.expandMarketDepth(\'Interbank Spot\', ibSpotMarketDepth)"></span></a></li><li role="presentation" class="statistics-tab"><a href="#bothStatistics" aria-controls="home" role="tab" data-toggle="tab"><span class="icon-tab-head">BOTH</span> <span class="tab-icon statistics-modal" title="Both" data-toggle="modal" data-target="#modal-table" ng-click="vm.openMarketStatistics(\'BOTH\')"></span> <span class="tab-icon maximise-icon popUPIcon" ng-click="vm.expandMarketDepthForBothInstrument(\'BOTH\', retailSpotMarketDepth, ibSpotMarketDepth)"></span></a></li><li role="presentation" class="close-maximize-tab"><a href="javascript:void(0);">Back to Normal View</a></li></ul><div ng-class="{\'server-down\': broadcastServerDown}"><div class="tab-content market-depth-contents"><div role="tabpanel" class="tab-pane active" id="spotStatistics"><div class="table-responsive"><table class="table table-striped"><thead><tr><th class="text-right">Bid Quantity</th><th class="text-right">Bid Price</th><th class="text-right">Offer Price</th><th class="text-right">Offer Quantity</th></tr></thead><tbody><tr ng-repeat="marketDepth in retailSpotMarketDepth.marketDepthDetails"><td class="text-right"><span ng-hide="marketDepth.bidPrice==0">{{marketDepth.bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span ng-hide="marketDepth.bidPrice==0" class="mdc-highlighted-txt">{{marketDepth.bidPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="marketDepth.offerPrice==0" class="mdc-highlighted-txt">{{marketDepth.offerPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span> <span ng-show="marketDepth.offerPrice==0"></span></td><td class="text-right"><span ng-hide="marketDepth.offerPrice==0">{{marketDepth.offerVolume | number:vm.noOfDecimalsForAmount}}</span></td></tr><tr ng-show="retailSpotMarketDepth==null || retailSpotMarketDepth.marketDepthDetails==null || retailSpotMarketDepth.marketDepthDetails.length<=0"><td></td><td></td><td></td><td></td></tr><tr ng-show="retailSpotMarketDepth==null || retailSpotMarketDepth.marketDepthDetails==null || retailSpotMarketDepth.marketDepthDetails.length<=1"><td></td><td></td><td></td><td></td></tr><tr ng-show="retailSpotMarketDepth==null || retailSpotMarketDepth.marketDepthDetails==null || retailSpotMarketDepth.marketDepthDetails.length<=2"><td></td><td></td><td></td><td></td></tr><tr ng-show="retailSpotMarketDepth==null || retailSpotMarketDepth.marketDepthDetails==null || retailSpotMarketDepth.marketDepthDetails.length<=3"><td></td><td></td><td></td><td></td></tr><tr ng-show="retailSpotMarketDepth==null || retailSpotMarketDepth.marketDepthDetails==null || retailSpotMarketDepth.marketDepthDetails.length<=4"><td></td><td></td><td></td><td></td></tr></tbody></table></div></div><!-- spotStatistics ends --><div role="tabpanel" class="tab-pane" id="intSpotStatistics"><div class="table-responsive"><table class="table table-striped"><thead><tr><th class="text-right">Bid Quantity</th><th class="text-right">Bid Price</th><th class="text-right">Offer Price</th><th class="text-right">Offer Quantity</th></tr></thead><tbody><tr ng-repeat="marketDepth in ibSpotMarketDepth.marketDepthDetails"><td class="text-right"><span ng-hide="marketDepth.bidPrice==0">{{marketDepth.bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span ng-hide="marketDepth.bidPrice==0" class="mdc-highlighted-txt">{{marketDepth.bidPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="marketDepth.offerPrice==0" class="mdc-highlighted-txt">{{marketDepth.offerPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="marketDepth.offerPrice==0">{{marketDepth.offerVolume | number:vm.noOfDecimalsForAmount}}</span></td></tr><tr ng-show="ibSpotMarketDepth==null || ibSpotMarketDepth.marketDepthDetails==null || ibSpotMarketDepth.marketDepthDetails.length<=0"><td></td><td></td><td></td><td></td></tr><tr ng-show="ibSpotMarketDepth==null || ibSpotMarketDepth.marketDepthDetails==null || ibSpotMarketDepth.marketDepthDetails.length<=1"><td></td><td></td><td></td><td></td></tr><tr ng-show="ibSpotMarketDepth==null || ibSpotMarketDepth.marketDepthDetails==null || ibSpotMarketDepth.marketDepthDetails.length<=2"><td></td><td></td><td></td><td></td></tr><tr ng-show="ibSpotMarketDepth==null || ibSpotMarketDepth.marketDepthDetails==null || ibSpotMarketDepth.marketDepthDetails.length<=3"><td></td><td></td><td></td><td></td></tr><tr ng-show="ibSpotMarketDepth==null || ibSpotMarketDepth.marketDepthDetails==null || ibSpotMarketDepth.marketDepthDetails.length<=4"><td></td><td></td><td></td><td></td></tr></tbody></table></div></div><!-- intSpotStatistics ends --><div role="tabpanel" class="tab-pane" id="bothStatistics"><div class="table-responsive"><table class="table table-striped bothStats"><thead><tr><th class="text-center right-border" colspan="4">Retail Spot</th><th class="text-center" colspan="4">Interbank Spot</th></tr><tr><th class="text-right">Bid Quantity</th><th class="text-right">Bid Price</th><th class="text-right">Offer Price</th><th class="text-right right-border">Offer Quantity</th><th class="text-right">Bid Quantity</th><th class="text-right">Bid Price</th><th class="text-right">Offer Price</th><th class="text-right">Offer Quantity</th></tr></thead><tbody><tr><td class="text-right"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[0].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[0].bidPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[0].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[0].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[0].bidPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[0].bidPrice | split:\'.\':\'0\'}}.<span>{{retailSpotMarketDepth.marketDepthDetails[0].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[0].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[0].offerPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[0].offerPrice | split:\'.\':\'0\'}}.<span>{{retailSpotMarketDepth.marketDepthDetails[0].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right right-border"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[0].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[0].offerPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[0].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[0].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[0].bidPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[0].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[0].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[0].bidPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[0].bidPrice | split:\'.\':\'0\'}}.<span>{{ibSpotMarketDepth.marketDepthDetails[0].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[0].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[0].offerPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[0].offerPrice | split:\'.\':\'0\'}}.<span>{{ibSpotMarketDepth.marketDepthDetails[0].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[0].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[0].offerPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[0].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td></tr><tr><td class="text-right"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[1].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[1].bidPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[1].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[1].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[1].bidPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[1].bidPrice | split:\'.\':\'0\'}}.<span>{{retailSpotMarketDepth.marketDepthDetails[1].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[1].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[1].offerPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[1].offerPrice | split:\'.\':\'0\'}}.<span>{{retailSpotMarketDepth.marketDepthDetails[1].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right right-border"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[1].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[1].offerPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[1].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[1].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[1].bidPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[1].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[1].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[1].bidPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[1].bidPrice | split:\'.\':\'0\'}}.<span>{{ibSpotMarketDepth.marketDepthDetails[1].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[1].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[1].offerPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[1].offerPrice | split:\'.\':\'0\'}}.<span>{{ibSpotMarketDepth.marketDepthDetails[1].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[1].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[1].offerPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[1].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td></tr><tr><td class="text-right"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[2].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[2].bidPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[2].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[2].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[2].bidPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[2].bidPrice | split:\'.\':\'0\'}}.<span>{{retailSpotMarketDepth.marketDepthDetails[2].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[2].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[2].offerPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[2].offerPrice | split:\'.\':\'0\'}}.<span>{{retailSpotMarketDepth.marketDepthDetails[2].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right right-border"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[2].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[2].offerPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[2].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[2].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[2].bidPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[2].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[2].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[2].bidPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[2].bidPrice | split:\'.\':\'0\'}}.<span>{{ibSpotMarketDepth.marketDepthDetails[2].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[2].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[2].offerPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[2].offerPrice | split:\'.\':\'0\'}}.<span>{{ibSpotMarketDepth.marketDepthDetails[2].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[2].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[2].offerPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[2].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td></tr><tr><td class="text-right"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[3].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[3].bidPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[3].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[3].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[3].bidPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[3].bidPrice | split:\'.\':\'0\'}}.<span>{{retailSpotMarketDepth.marketDepthDetails[3].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[3].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[3].offerPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[3].offerPrice | split:\'.\':\'0\'}}.<span>{{retailSpotMarketDepth.marketDepthDetails[3].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right right-border"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[3].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[3].offerPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[3].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[3].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[3].bidPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[3].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[3].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[3].bidPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[3].bidPrice | split:\'.\':\'0\'}}.<span>{{ibSpotMarketDepth.marketDepthDetails[3].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[3].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[3].offerPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[3].offerPrice | split:\'.\':\'0\'}}.<span>{{ibSpotMarketDepth.marketDepthDetails[3].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[3].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[3].offerPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[3].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td></tr><tr><td class="text-right"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[4].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[4].bidPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[4].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[4].bidPrice==0 || retailSpotMarketDepth.marketDepthDetails[4].bidPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[4].bidPrice | split:\'.\':\'0\'}}.<span>{{retailSpotMarketDepth.marketDepthDetails[4].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[4].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[4].offerPrice==undefined" class="mdc-highlighted-txt">{{retailSpotMarketDepth.marketDepthDetails[4].offerPrice | split:\'.\':\'0\'}}.<span>{{retailSpotMarketDepth.marketDepthDetails[4].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right right-border"><span ng-hide="retailSpotMarketDepth.marketDepthDetails[4].offerPrice==0 || retailSpotMarketDepth.marketDepthDetails[4].offerPrice==undefined">{{retailSpotMarketDepth.marketDepthDetails[4].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[4].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[4].bidPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[4].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[4].bidPrice==0 || ibSpotMarketDepth.marketDepthDetails[4].bidPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[4].bidPrice | split:\'.\':\'0\'}}.<span>{{ibSpotMarketDepth.marketDepthDetails[4].bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[4].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[4].offerPrice==undefined" class="mdc-highlighted-txt">{{ibSpotMarketDepth.marketDepthDetails[4].offerPrice | split:\'.\':\'0\'}}.<span>{{ibSpotMarketDepth.marketDepthDetails[4].offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="ibSpotMarketDepth.marketDepthDetails[4].offerPrice==0 || ibSpotMarketDepth.marketDepthDetails[4].offerPrice==undefined">{{ibSpotMarketDepth.marketDepthDetails[4].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td></tr></tbody></table></div></div><!-- bothStatistics ends --></div></div></div><!-- market-depth ends--></div></div><!-- Content right wrapper ends --></div></div><!-- top left right ends --><div class="row"><div class="col-md-5 less-padding" ng-show="vm.permitNewOrderEntry" ng-click="vm.setOrderEntryFocus()"><div class="content-bot-left-wrapper"><div class="content-bot-left"><div class="order-price" ng-if="vm.orderDTO.activityIndicator==\'PLAC\'"><form name="frmOrderEntry" role="form" ng-submit="vm.placeOrder()"><div ng-init="setForm(frmOrderEntry)"><h3>Order at the Price</h3><div class="order-price-tab pull-right text-right"><ul class="nav nav-tabs" id="orderPriceTabs" role="tablist"><li role="presentation" class="active tab-buy"><a ng-click="vm.orderType=\'BUYY\'" aria-controls="buy" role="tab" id="buyTab" data-toggle="tab">BUY</a></li><li role="presentation" class="tab-sell"><a ng-click="vm.orderType=\'SELL\'" aria-controls="sell" role="tab" id="sellTab" data-toggle="tab">SELL</a></li><li role="presentation" class="tab-sell-buy"><a ng-click="vm.orderType=\'SELLBUY\'" aria-controls="sellBuy" role="tab" id="sellbuyTab" data-toggle="tab">BUY &amp; SELL</a></li></ul></div><div class="clearfix"></div></div><div ng-class="{\'buy-border\': vm.orderType==\'BUYY\', \'sell-border\': vm.orderType==\'SELL\', \'sellbuy-border\': vm.orderType==\'SELLBUY\'}"><div class="order-price-contents tab-content"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-inner"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode==\'SPOT\'}"><a id="spotInstrument" aria-controls="spot" role="tab" data-toggle="tab" ng-click="vm.defaultInstrumentCode=\'SPOT\'; vm.defaultInstrumentId=3;">SPOT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode==\'TOM\'}"><a id="tomInstrument" aria-controls="tom" role="tab" data-toggle="tab" ng-click="vm.defaultInstrumentCode=\'TOM\'; vm.defaultInstrumentId=2;">TOM</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode==\'CASH\'}"><a id="cashInstrument" aria-controls="cash" role="tab" data-toggle="tab" ng-click="vm.defaultInstrumentCode=\'CASH\'; vm.defaultInstrumentId=1;">CASH</a></li></ul><div class="search-box order-entry-branch" ng-if="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.tradingBank" control-id="txttradingBankOrderEntry" lookup-name="tradingBank" filter-value="{{vm.account.organisation.id}}" display-column="bankName" form="frmOrderEntry" control-place-holder="Enter bank name" control-required="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"></cspl-ach></div><div class="search-box order-entry-branch" ng-if="vm.account.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.tradingBranch" control-id="txttradingBankOrderEntryForBank" lookup-name="branchesForBank" filter-value="{{vm.tradingBank.id}}" display-column="branchId,branchName" form="frmOrderEntry" control-place-holder="Enter Branch ID or Name" control-required="vm.account.entityOwnerType.shortName==\'Bank\'"></cspl-ach><span class="help-block" ng-show="vm.tradingBranch!=null && vm.tradingBranch!=undefined" title="{{vm.tradingBranch.branchName}}">{{vm.tradingBranch.branchName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"><cspl-ach control-model="vm.tradingCustomer" control-id="txtTradingCustomer" lookup-name="customer" filter-value="{{vm.tradingBank.id}}~~{{vm.tradingBranch.id}}~~{{0}}" display-column="customerCode,customerName" form="frmOrderEntry" control-place-holder="Enter Customer ID or Name" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"></cspl-ach><span class="help-block" ng-show="vm.tradingCustomer!=null && vm.tradingCustomer!=undefined" title="{{vm.tradingCustomer.customerName}}">{{vm.tradingCustomer.customerName}}</span></div></div></div><div class="order-price-tab-inner"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'DAYY\'}"><a id="dayTimeCondition" aria-controls="day" role="tab" data-toggle="tab" ng-click="vm.defaultTimeCondition=\'DAYY\';">DAY</a></li><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'IOCC\'}"><a id="iocTimeCondition" aria-controls="ioc" role="tab" data-toggle="tab" ng-click="vm.defaultTimeCondition=\'IOCC\';">IOC</a></li><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'GTTM\'}"><a id="gttTimeCondition" aria-controls="gtt" role="tab" data-toggle="tab" ng-click="vm.defaultTimeCondition=\'GTTM\';">GTT</a></li></ul></div></div><div class="order-price-contents tab-content" ng-class="{\'mkt-order-view\': vm.defaultPriceCondition==\'MRKT\'}"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-last"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><!-- Nav tabs --><ul class="nav nav-tabs" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\'}"><a id="limitTab" ng-click="vm.defaultPriceCondition=\'LIMT\'">LIMIT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'MRKT\'}"><a id="marketTab" ng-click="vm.defaultPriceCondition=\'MRKT\'">MKT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'STLS\', \'disabled\':vm.configSettings.isAllowStopLossOrder!=\'Yes\'}"><a id="stoplossTab" ng-click="vm.defaultPriceCondition=\'STLS\'" ng-class="{\'disabledTabLink\': vm.configSettings.isAllowStopLossOrder!=\'Yes\'}">SL</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'TKPR\', \'disabled\':vm.configSettings.isAllowTakeProfitOrder!=\'Yes\'}"><a id="takeprofitTab" ng-click="vm.defaultPriceCondition=\'TKPR\'" ng-class="{\'disabledTabLink\': vm.configSettings.isAllowTakeProfitOrder!=\'Yes\'}">TP</a></li></ul><!-- Tab panes --><div class="tab-content"><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\'}" ng-show="vm.defaultPriceCondition==\'LIMT\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th><th class="text-right">Limit Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" control-id="txtlimitordervalue" form="frmOrderEntry" show-error-text="true" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" control-id="txtlimitorderprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'" show-error-text="true"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</p> --></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">LA</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.limitExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table><table class="table" ng-show="vm.orderType==\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th><th class="text-right">Buy Limit Price</th><th class="text-right">Sell Limit Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtsellbuylimitordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'buylimit\')" control-model="vm.orderDTO.buyLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuylimitbuyorderprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType==\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.buyLimitPriceDeviationWarning!=null && vm.buyLimitPriceDeviationWarning!=undefined && vm.buyLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.buyLimitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'selllimit\')" control-model="vm.orderDTO.sellLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuylimitsellorderprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType==\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.sellLimitPriceDeviationWarning!=null && vm.sellLimitPriceDeviationWarning!=undefined && vm.sellLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.sellLimitPriceDeviationWarning}}</p> --></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">LA</span> <span ng-show="vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{tomSellLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.buyLimitExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.sellLimitExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table></div></div><!-- limit tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'MRKT\'}" ng-show="vm.defaultPriceCondition==\'MRKT\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtmktordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'MRKT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">LA</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td></tr><tr><td></td></tr></tfoot></table><table class="table" ng-show="vm.orderType==\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtsellbuymktordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'MRKT\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">LA</span> <span ng-show="vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td></tr><tr><td></td></tr></tfoot></table></div></div><!-- mkt tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'STLS\'}" ng-show="vm.defaultPriceCondition==\'STLS\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th><th class="text-right">Limit Price</th><th class="text-right">Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtslordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsllimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.stopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsltriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">LA</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.limitExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.stopExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table><table class="table" ng-show="vm.orderType==\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th><th class="text-right">Buy Limit Price</th><th class="text-right">Buy Trigger Price</th><th class="text-right">Sell Limit Price</th><th class="text-right">Sell Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtsellbuyslordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'buylimit\')" control-model="vm.orderDTO.buyLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuyslbuylimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.buyLimitPriceDeviationWarning!=null && vm.buyLimitPriceDeviationWarning!=undefined && vm.buyLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.buyLimitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.buyStopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuyslbuytriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'selllimit\')" control-model="vm.orderDTO.sellLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuyslselllimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.sellLimitPriceDeviationWarning!=null && vm.sellLimitPriceDeviationWarning!=undefined && vm.sellLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.sellLimitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.sellStopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuyslselltriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">LA</span> <span ng-show="vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.buyLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.buyStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.sellLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.sellStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table></div></div><!-- sl tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'TKPR\'}" ng-show="vm.defaultPriceCondition==\'TKPR\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th><th class="text-right">Limit Price</th><th class="text-right">Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txttpordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txttplimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.stopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txttptriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">LA</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.limitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.stopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table><table class="table" ng-show="vm.orderType==\'SELLBUY\'"><thead><th class="text-right">Order Quantity</th><th class="text-right">Buy Limit Price</th><th class="text-right">Buy Trigger Price</th><th class="text-right">Sell Limit Price</th><th class="text-right">Sell Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtsellbuytpordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'buylimit\')" control-model="vm.orderDTO.buyLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuytpbuylimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.buyLimitPriceDeviationWarning!=null && vm.buyLimitPriceDeviationWarning!=undefined && vm.buyLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.buyLimitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.buyStopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuytpbuytriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'selllimit\')" control-model="vm.orderDTO.sellLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuytpselllimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.sellLimitPriceDeviationWarning!=null && vm.sellLimitPriceDeviationWarning!=undefined && vm.sellLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.sellLimitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.sellStopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsellbuytpselltriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">LA</span> <span ng-show="vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{cashBuyLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}} | {{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.buyLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.buyStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.sellLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.sellStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table></div></div><!-- tp tab ends --></div></div></div><!-- sell-spot ends --></div></div><div class="sell-btn-wrap"><div class="sell-btn-inner"><p><span ng-show="vm.configSettings.allowOrderImport==\'Yes\'"><label for="orderUpload" class="btn btn-primary"><img src="assets/images/search-up-icon.png" alt="download-icon"></label></span><input type="file" file-reader="vm.content" file-model="vm.fileContent" id="orderUpload" ng-hide="true"><!-- <button type="button" ng-click="vm.downloadData()" class="btn btn-last-tab-buy">DOWNLOAD</button> --> <button type="submit" ng-show="vm.orderType==\'SELL\'" ng-disabled="frmOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-sell">SELL</button> <button type="submit" ng-show="vm.orderType==\'BUYY\'" ng-disabled="frmOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-buy">BUY</button> <button type="submit" ng-show="vm.orderType==\'MODIFYSELL\'" ng-disabled="frmOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-sell">MODIFY SELL</button> <button type="submit" ng-show="vm.orderType==\'MODIFYBUY\'" ng-disabled="frmOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-buy">MODIFY BUY</button> <button type="submit" ng-show="vm.orderType==\'CANCELSELL\'" ng-disabled="frmOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-sell">CANCEL SELL</button> <button type="submit" ng-show="vm.orderType==\'CANCELBUY\'" ng-disabled="frmOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-buy">CANCEL BUY</button> <button type="submit" ng-show="vm.orderType==\'SELLBUY\'" ng-disabled="frmOrderEntry.$invalid || vm.clicked" class="btn btn-last-tab-sell-buy">BUY & SELL</button></p><p style="float:left"><a href="javascript:void(0)" class="add-remarks-setting" data-toggle="modal" data-target="#modal-settings" ng-click="vm.openOrderPreference()" ng-show="vm.permitModifyOrderEntry || vm.permitNewOrderEntry"><img class="logo-icon" src="assets/images/box-right-icon.png" title="Order Preference" alt="icon"> </a><a href="javascript:void(0)" class="add-remarks" ng-click="vm.addRemarks()"><i class="fa fa-plus" aria-hidden="true"></i> Add Remarks</a></p></div></div></div><!--SELL Tab Closed--></div></div></form></div><div class="order-price" ng-if="vm.orderDTO.activityIndicator!=\'PLAC\'"><form name="frmMdfyOrderEntry" role="form" ng-submit="vm.placeOrder()"><div ng-init="setMdfyForm(frmMdfyOrderEntry)"><h3>Order at the Price</h3><div class="order-price-tab pull-right text-right"><ul class="nav nav-tabs" id="orderPriceTabs" role="tablist"><li role="presentation" class="active tab-buy" ng-show="vm.orderDTO.buySellIndicator==\'BUYY\'"><a ng-click="vm.orderType=\'BUYY\'" aria-controls="buy" role="tab" id="modifybuyTab" data-toggle="tab">BUY</a></li><li role="presentation" class="tab-sell" ng-show="vm.orderDTO.buySellIndicator==\'SELL\'"><a ng-click="vm.orderType=\'SELL\'" aria-controls="sell" role="tab" id="modifysellTab" data-toggle="tab">SELL</a></li><li role="presentation" class="tab-sell-buy" ng-hide="true"><a ng-click="vm.orderType=\'SELLBUY\'" aria-controls="sellBuy" role="tab" data-toggle="tab">BUY &amp; SELL</a></li></ul></div><div class="clearfix"></div></div><div ng-class="{\'buy-border\': vm.orderType==\'BUYY\', \'sell-border\': vm.orderType==\'SELL\', \'sellbuy-border\': vm.orderType==\'SELLBUY\'}"><div class="order-price-contents tab-content"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-inner"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode==\'SPOT\'}" ng-show="vm.orderDTO.instrumentCode==\'SPOT\'"><a id="spotInstrument" aria-controls="spot" role="tab" data-toggle="tab" ng-click="vm.defaultInstrumentCode=\'SPOT\'; vm.defaultInstrumentId=3;">SPOT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode==\'TOM\'}" ng-show="vm.orderDTO.instrumentCode==\'TOM\'"><a id="tomInstrument" aria-controls="tom" role="tab" data-toggle="tab" ng-click="vm.defaultInstrumentCode=\'TOM\'; vm.defaultInstrumentId=2;">TOM</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode==\'CASH\'}" ng-show="vm.orderDTO.instrumentCode==\'CASH\'"><a id="cashInstrument" aria-controls="cash" role="tab" data-toggle="tab" ng-click="vm.defaultInstrumentCode=\'CASH\'; vm.defaultInstrumentId=1;">CASH</a></li></ul><div class="search-box order-entry-branch" ng-if="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.tradingBank" control-id="txtbankFilterForPO1" lookup-name="tradingBank" control-disabled="vm.orderDTO.activityIndicator==\'MDFY\'" filter-value="{{vm.account.organisation.id}}" display-column="bankName" form="frmOrderEntry" control-place-holder="Enter bank name" control-required="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"></cspl-ach></div><div class="search-box order-entry-branch" ng-if="vm.account.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.tradingBranch" control-id="txtbankFilterForPO1" lookup-name="branchesForBank" control-disabled="vm.orderDTO.activityIndicator==\'MDFY\'" filter-value="{{vm.tradingBank.id}}" display-column="branchId,branchName" form="frmOrderEntry" control-place-holder="Enter Branch ID or Name" control-required="vm.account.entityOwnerType.shortName==\'Bank\'"></cspl-ach><span class="help-block" ng-show="vm.tradingBranch!=null && vm.tradingBranch!=undefined" title="{{vm.tradingBranch.branchName}}">{{vm.tradingBranch.branchName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"><cspl-ach control-model="vm.tradingCustomer" control-id="txtTradingCustomer1" lookup-name="customer" filter-value="{{vm.tradingBank.id}}~~{{vm.tradingBranch.id}}~~{{0}}" control-disabled="vm.orderDTO.activityIndicator==\'MDFY\'" display-column="customerCode,customerName" form="frmOrderEntry" control-place-holder="Enter Customer ID or Name" control-required="vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"></cspl-ach><span class="help-block" ng-show="vm.tradingCustomer!=null && vm.tradingCustomer!=undefined" title="{{vm.tradingCustomer.customerName}}">{{vm.tradingCustomer.customerName}}</span></div></div></div><div class="order-price-tab-inner"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'DAYY\'}" ng-show="vm.orderDTO.timeLimitIndicator==\'DAYY\'"><a id="dayTimeCondition" aria-controls="day" role="tab" data-toggle="tab" ng-click="vm.defaultTimeCondition=\'DAYY\';">DAY</a></li><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'IOCC\'}" ng-show="vm.orderDTO.timeLimitIndicator==\'IOCC\'"><a id="iocTimeCondition" aria-controls="ioc" role="tab" data-toggle="tab" ng-click="vm.defaultTimeCondition=\'IOCC\';">IOC</a></li><li role="presentation" ng-class="{\'active\': vm.defaultTimeCondition==\'GTTM\'}" ng-show="vm.orderDTO.timeLimitIndicator==\'GTTM\'"><a id="gttTimeCondition" aria-controls="gtt" role="tab" data-toggle="tab" ng-click="vm.defaultTimeCondition=\'GTTM\';">GTT</a></li></ul></div></div><div class="order-price-contents tab-content" ng-class="{\'mkt-order-view\': vm.defaultPriceCondition==\'MRKT\'}"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-last"><div ng-class="{\'buy\': vm.orderType==\'BUYY\', \'sell\': vm.orderType==\'SELL\', \'sellbuy\': vm.orderType==\'SELLBUY\'}"><!-- Nav tabs --><ul class="nav nav-tabs" style="border:none" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\'}" ng-show="vm.orderDTO.typeOfOrder==\'LIMT\'"><a id="limitTab" ng-click="vm.defaultPriceCondition=\'LIMT\'">LIMIT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'MRKT\'}" ng-show="vm.orderDTO.typeOfOrder==\'MRKT\'"><a id="marketTab" ng-click="vm.defaultPriceCondition=\'MRKT\'">MKT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'STLS\'}" ng-show="vm.orderDTO.typeOfOrder==\'STLS\'"><a id="stoplossTab" ng-click="vm.defaultPriceCondition=\'STLS\'">SL</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'TKPR\'}" ng-show="vm.orderDTO.typeOfOrder==\'TKPR\'"><a id="takeprofitTab" ng-click="vm.defaultPriceCondition=\'TKPR\'">TP</a></li></ul><!-- Tab panes --><div class="tab-content"><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\'}" ng-show="vm.defaultPriceCondition==\'LIMT\'"><div class="table-responsive"><table class="table"><thead><th class="text-right">Order Quantity</th><th class="text-right">Limit Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" control-id="txtlimitordervalue1" form="frmMdfyOrderEntry" show-error-text="true" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" control-id="txtlimitorderprice1" form="frmMdfyOrderEntry" show-error-text="true" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</p> --></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">LA</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.limitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table></div></div><!-- limit tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'MRKT\'}" ng-show="vm.defaultPriceCondition==\'MRKT\'"><div class="table-responsive"><table class="table"><thead><th class="text-right">Order Quantity</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtmktordervalue1" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'MRKT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">LA</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td></tr><tr><td></td></tr></tfoot></table></div></div><!-- mkt tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'STLS\'}" ng-show="vm.defaultPriceCondition==\'STLS\'"><div class="table-responsive"><table class="table"><thead><th class="text-right">Order Quantity</th><th class="text-right">Limit Price</th><th class="text-right">Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txtslordervalue1" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsllimitprice1" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.stopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txtsltriggerprice1" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">LA</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.limitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.stopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table></div></div><!-- sl tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'TKPR\'}" ng-show="vm.defaultPriceCondition==\'TKPR\'"><div class="table-responsive"><table class="table"><thead><th class="text-right">Order Quantity</th><th class="text-right">Limit Price</th><th class="text-right">Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" control-max="999999999.99" no-of-decimals="2" control-min="0" show-error-text="true" control-id="txttpordervalue1" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric cspl-shortcuts="vm.executeValueHistoryShortcut(value, \'limit\')" control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txttplimitprice1" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric><!-- \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p ng-class="help-block-warning" style="margin:0 0 3px 0;" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</p> --></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.stopExchangeRate" no-of-decimals="4" control-min="0" control-max="999.9999" show-error-text="true" control-id="txttptriggerprice1" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span ng-show="vm.tradingCustomer!=null && vm.tradingCustomer.isProp!=true && vm.showLA==true"><span class="color-theme-txt" title="Limit Available">LA</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{retailSpotBuyLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{cashSellLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{cashBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{tomSellLimit |round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{tomBuyLimit | round:\'\':\'down\':vm.noOfDecimalsForAmount}}</span></span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.limitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.stopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table></div></div><!-- tp tab ends --></div></div></div><!-- sell-spot ends --></div></div><div class="sell-btn-wrap"><div class="sell-btn-inner"><p><a class="back-to-order-entry" ng-click="vm.cancelModifyOrderAction()"><span class="icon arrow_triangle-left"></span>Back</a></p><p><button type="submit" ng-show="vm.orderType==\'SELL\' && vm.orderDTO.activityIndicator==\'MDFY\'" ng-disabled="frmMdfyOrderEntry.$invalid" class="btn btn-last-tab-sell">MODIFY SELL</button> <button type="submit" ng-show="vm.orderType==\'BUYY\' && vm.orderDTO.activityIndicator==\'MDFY\'" ng-disabled="frmMdfyOrderEntry.$invalid" class="btn btn-last-tab-buy">MODIFY BUY</button> <button type="submit" ng-show="vm.orderType==\'SELL\' && vm.orderDTO.activityIndicator==\'CNCL\'" ng-disabled="frmMdfyOrderEntry.$invalid" class="btn btn-last-tab-sell">CANCEL SELL</button> <button type="submit" ng-show="vm.orderType==\'BUYY\' && vm.orderDTO.activityIndicator==\'CNCL\'" ng-disabled="frmMdfyOrderEntry.$invalid" class="btn btn-last-tab-buy">CANCEL BUY</button></p><p style="float:left"><a href="javascript:void(0)" class="add-remarks-setting" data-toggle="modal" data-target="#modal-settings" ng-click="vm.openOrderPreference()" ng-show="vm.permitModifyOrderEntry || vm.permitNewOrderEntry"><img class="logo-icon" src="assets/images/box-right-icon.png" title="Order Preference" alt="icon"> </a><a href="javascript:void(0)" class="add-remarks" ng-click="vm.addRemarks()"><i class="fa fa-plus" aria-hidden="true"></i> Add Remarks</a></p></div></div></div><!--SELL Tab Closed--></div></div></form></div></div></div></div><!-- content-bot-left-wrapper ends --><div ng-class="{\'col-md-7 less-padding\': vm.permitNewOrderEntry==true, \'col-md-12 less-padding\': vm.permitTradingDashboard==true && vm.permitNewOrderEntry==false}" ng-click="vm.removeOrderEntryFocus()"><div class="nav-tab-bot-right"><!-- Nav tabs --><ul class="nav nav-tabs" role="tablist"><li role="presentation" class="active"><a href="#PendingOrders" aria-controls="PendingOrders" role="tab" data-toggle="tab">Pending Orders</a></li><li role="presentation"><a href="#Trades" aria-controls="Trades" role="tab" data-toggle="tab">Trades</a></li><li role="presentation"><a href="#Limits" aria-controls="Limits" role="tab" data-toggle="tab">Limits</a></li></ul><!-- Tab panes --><div class="tab-content"><div role="tabpanel" class="tab-pane active" id="PendingOrders"><div class="bot-right-header-wrapper"><div class="row"><div class="col-sm-9"><div class="nav-tab-bot-header-left"><div ng-class="{clearcorp: vm.account.entityOwnerType.shortName==\'Clearcorp\'}"><div class="up-btn"><!-- <a href="#"><img src="assets/images/search-up-icon.png"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\talt="download-icon"></a> --><cspl-table-export table-name="tblPendingOrders" total-record-count="pendingOrders.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Pending_Orders_{{vm.custCode}}_{{vm.bankFilterForPO.bankName}}" ignore-column="[0]"></cspl-table-export></div><div class="search-box order-entry-branch" ng-if="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.bankFilterForPO" control-id="txtbankFilterForPO" lookup-name="tradingBank" filter-value="{{vm.account.organisation.id}}" display-column="bankName" form="frmtradinghomepage" control-place-holder="Enter bank name"></cspl-ach></div><div class="search-box order-entry-branch" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.bankFilterForPO" control-id="txtbankFilterForPO" lookup-name="bank" control-place-holder="Enter bank name" display-column="bankName" form="frmtradinghomepage" control-required="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'"></cspl-ach></div><div class="search-box order-entry-branch" ng-if="vm.account.entityOwnerType.shortName==\'Clearcorp\' && vm.bankFilterForPO!=null"><cspl-ach control-model="vm.branchFilterForPO" control-id="txtbranchFilterForPO" lookup-name="validStatusBranchesForBank" filter-value="{{vm.bankFilterForPO.id}}" control-place-holder="Enter Branch ID or Name" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForPO!=null && vm.branchFilterForPO!=undefined" title="{{vm.branchFilterForPO.branchName}}">{{vm.branchFilterForPO.branchName}}</span></div><div class="search-box order-entry-branch" ng-if="vm.account.entityOwnerType.shortName==\'Clearcorp\' && vm.bankFilterForPO==null"><cspl-ach control-model="vm.branchFilterForPO" control-id="txtbranchFilterForPO" lookup-name="allBranches" control-place-holder="Enter Branch ID or Name" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForPO!=null && vm.branchFilterForPO!=undefined" title="{{vm.branchFilterForPO.branchName}}">{{vm.branchFilterForPO.branchName}}</span></div><div class="search-box order-entry-branch" ng-if="vm.account.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.branchFilterForPO" control-place-holder="Enter Branch ID or Name" control-id="txtbranchFilterForPO" lookup-name="validStatusBranchesForBank" filter-value="{{vm.account.organisation.id}}" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForPO!=null && vm.branchFilterForPO!=undefined" title="{{vm.branchFilterForPO.branchName}}">{{vm.branchFilterForPO.branchName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName==\'BANK\'"><cspl-ach control-model="vm.customerFilterForPO" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForPO" lookup-name="customer" filter-value="{{vm.bankFilterForPO.id}}~~{{vm.branchFilterForPO.id}}~~{{0}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForPO!=null && vm.customerFilterForPO!=undefined" title="{{vm.customerFilterForPO.customerName}}">{{vm.customerFilterForPO.customerName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForPO!=null && vm.bankFilterForPO!=null"><cspl-ach control-model="vm.customerFilterForPO" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForPO" lookup-name="customer" filter-value="{{vm.bankFilterForPO.id}}~~{{vm.branchFilterForPO.id}}~~{{0}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForPO!=null && vm.customerFilterForPO!=undefined" title="{{vm.customerFilterForPO.customerName}}">{{vm.customerFilterForPO.customerName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForPO==null && vm.bankFilterForPO!=null"><cspl-ach control-model="vm.customerFilterForPO" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForPO" lookup-name="customersForBank" filter-value="{{vm.bankFilterForPO.id}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForPO!=null && vm.customerFilterForPO!=undefined" title="{{vm.customerFilterForPO.customerName}}">{{vm.customerFilterForPO.customerName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForPO==null && vm.bankFilterForPO==null"><cspl-ach control-model="vm.customerFilterForPO" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForPO" lookup-name="AllCustomers" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForPO!=null && vm.customerFilterForPO!=undefined" title="{{vm.customerFilterForPO.customerName}}">{{vm.customerFilterForPO.customerName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForPO!=null && vm.bankFilterForPO==null"><cspl-ach control-model="vm.customerFilterForPO" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForPO" lookup-name="customersForBranch" filter-value="{{vm.branchFilterForPO.id}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForPO!=null && vm.customerFilterForPO!=undefined" title="{{vm.customerFilterForPO.customerName}}">{{vm.customerFilterForPO.customerName}}</span></div><div class="select-box"><select name="select" class="select-opt" ng-model="vm.instrumentFilterForPO" ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id"><option value="">--All--</option></select></div><div class="go-btn"><span ng-if="vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'"><button type="button" class="btn btn-go" ng-click="vm.getPendingOrdersReport()">GO</button></span> <span ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'"><button type="button" ng-disabled="vm.bankFilterForPO==null" class="btn btn-go" ng-click="vm.getPendingOrdersReport()">GO</button></span></div></div></div></div><div class="col-sm-3"><div class="nav-tab-bot-header-right text-right"><div class="search-field"><cspl-table-search control-model="filterTextForPO"></cspl-table-search></div></div></div></div><!-- row ends --></div><div class="bot-right-table"><div class="table-responsive"><table id="tblPendingOrders" class="table table-striped"><thead><tr><th ng-show="vm.permitCancelOrderEntry"><label class="check-control"><input id="selectAll" class="checkbox" name="" ng-model="$rootScope.selectAll" type="checkbox" ng-click="vm.checkOrUncheckPendingOrders($event)"> <span class="checkbox-overlay-header"></span></label></th><th ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.organisation.organisationType.shortName==\'CUSTOMER\'">Bank</th><th ng-show="vm.account.entityOwnerType.shortName==\'Clearcorp\' || vm.account.entityOwnerType.shortName==\'Bank\'">Branch</th><th ng-show="vm.account.entityOwnerType.shortName==\'Clearcorp\'">Branch ID</th><th ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.organisation.organisationType.shortName==\'BANK\'">Cust ID</th><th ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'">Customer</th><th>Instrument</th><th>B/S</th><th class="text-right">Order Quantity</th><th class="text-right">Traded Quantity</th><th class="text-right">Pending Order Quantity</th><th>Price Condition</th><th class="text-right">Order Price</th><th class="text-right">Eqv. Spot Order Price</th><th class="text-right">Trigger Price</th><th>Time Condition</th><th>GTT</th><th>Order Status</th><th>Order No.</th><th>Last Actioned By</th><th>Order Date Time</th><th class="text-right">&nbsp;&nbsp;</th></tr></thead><tbody><tr ng-repeat="pendingOrder in filterDataPendingOrders = (pendingOrders | filter : filterTextForPO | orderBy : \'lastModifiedDateTime\' : true ) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)" ng-hide="pendingOrder.pendingOrderAmount==0 || (pendingOrder.orderStatusId!=2 && pendingOrder.orderStatusId!=3 && pendingOrder.orderStatusId!=1)"><td ng-show="vm.permitCancelOrderEntry"><label class="check-control"><input class="checkbox" name="" ng-model="pendingOrder.select" type="checkbox" ng-disabled="pendingOrder.orderStatus==\'Risk Validated\'" ng-click="vm.checkOrUncheckPendingOrderItem()"> <span class="checkbox-overlay"></span></label></td><td ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.organisation.organisationType.shortName==\'CUSTOMER\'" class="minimize-field" title="{{pendingOrder.bankName}}"><span>{{pendingOrder.bankName}}</span></td><td ng-show="vm.account.entityOwnerType.shortName==\'Clearcorp\' || vm.account.entityOwnerType.shortName==\'Bank\'" class="minimize-field" title="{{pendingOrder.branchName}}"><span>{{pendingOrder.branchName}}</span></td><td ng-show="vm.account.entityOwnerType.shortName==\'Clearcorp\'"><span>{{pendingOrder.branchCode}}</span></td><td ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.organisation.organisationType.shortName==\'BANK\'"><span>{{pendingOrder.customerCode}}</span></td><td ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'" class="minimize-field" title="{{pendingOrder.customerName}}"><span>{{pendingOrder.customerName}}</span></td><td><span>{{pendingOrder.instrumentCode}}</span></td><td><span ng-show="pendingOrder.buySellInd==\'BUYY\'">Buy</span> <span ng-show="pendingOrder.buySellInd==\'SELL\'">Sell</span></td><td class="text-right"><span>{{pendingOrder.orderAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{pendingOrder.tradedAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{pendingOrder.pendingOrderAmount | number:vm.noOfDecimalsForAmount}}</span></td><td><span ng-show="pendingOrder.typeOfOrder==\'LIMT\'">Limit</span> <span ng-show="pendingOrder.typeOfOrder==\'MRKT\'">Market</span> <span ng-show="pendingOrder.typeOfOrder==\'STLS\'">Stop Loss</span> <span ng-show="pendingOrder.typeOfOrder==\'TKPR\'">Take Profit</span></td><td class="text-right"><span ng-show="pendingOrder.typeOfOrder!=\'MRKT\'">{{pendingOrder.limitExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right"><span ng-show="pendingOrder.typeOfOrder!=\'MRKT\'">{{pendingOrder.spotlimitExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right"><span ng-show="pendingOrder.typeOfOrder==\'STLS\' || pendingOrder.typeOfOrder==\'TKPR\'">{{pendingOrder.stopExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td><span ng-show="pendingOrder.timeLimitIndicator==\'DAYY\'">Day</span> <span ng-show="pendingOrder.timeLimitIndicator==\'IOCC\'">IOC</span> <span ng-show="pendingOrder.timeLimitIndicator==\'GTTM\'">GTT</span></td><td><span ng-show="pendingOrder.timeLimitIndicator==\'GTTM\'">{{pendingOrder.expiryTimeString | date:\'HH:mm\'}}</span></td><td><span>{{pendingOrder.orderStatus}}</span></td><td><span><a ui-sref="order-activity-pending-orders({orderNumber:pendingOrder.orderSequenceNumber})" style="text-decoration:underline">{{pendingOrder.orderSequenceNumber}}</a></span></td><td><span>{{pendingOrder.retailUserName}}</span></td><td ng-if="pendingOrder.orderStatus != \'Risk Validated\'"><span>{{vm.getMomentFromOrderRevisionTimeStamp(pendingOrder.revisiontTimestampString) | date:\'dd-MMM-yyyy HH:mm:ss\'}}</span></td><td ng-if="pendingOrder.orderStatus == \'Risk Validated\'"><span>{{pendingOrder.lastModifiedDateTime | date:\'dd-MMM-yyyy HH:mm:ss\'}}</span></td><td class="text-right freeze-column" style="padding-left: 7px; padding-right: 7px"><span class="edit-row" ng-show="vm.permitModifyOrderEntry"><img src="assets/images/edit-icon.png" ng-click="vm.modifyOrder(pendingOrder);" ng-hide="pendingOrder.orderStatus==\'Risk Validated\'"></span><span class="delete-row" ng-show="vm.permitModifyOrderEntry"><img src="assets/images/delete-icon.png" ng-click="vm.cancelOrder(pendingOrder);" ng-hide="pendingOrder.orderStatus==\'Risk Validated\'"></span></td></tr></tbody></table></div></div><div class="nav-tab-bot-right-footer"><div class="row"><div class="col-xs-8"><div ng-show="filterDataPendingOrders.length > 0"><cspl-pagination record-count="filterDataPendingOrders.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="col-xs-4 text-right" ng-show="vm.permitCancelOrderEntry"><button type="button" class="btn btn-info active" ng-click="vm.cancelAllOrders()">CANCEL SELECTED</button></div></div></div></div><!--PendingOrders Closed--><div role="tabpanel" class="tab-pane" id="Trades"><div class="bot-right-header-wrapper"><div class="row"><div class="col-sm-9"><div class="nav-tab-bot-header-left"><div ng-class="{clearcorp: vm.account.entityOwnerType.shortName==\'Clearcorp\'}"><div class="up-btn" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' "><!-- <a href="#"><img src="assets/images/search-up-icon.png"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\talt="download-icon"></a> --><cspl-table-export table-name="tblTrades" total-record-count="trades.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Trades_{{vm.custCode}}_{{vm.bankFilterForTrade.bankName}}" footer="ShowHiddenFooter"></cspl-table-export></div><div class="up-btn" ng-if="vm.account.organisation.organisationType.shortName != \'CLEARCORP\' "><div class="dropdown" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportTradesToCsvFile();">CSV</a></li><li><a ng-click="vm.exportTradesToExcelFile();">XLS</a></li></ul></div></div><div class="search-box order-entry-branch" ng-if="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.bankFilterForTrade" control-id="txtbankFilterForTrade" lookup-name="tradingBank" filter-value="{{vm.account.organisation.id}}" display-column="bankName" form="frmtradinghomepage" control-place-holder="Enter bank name"></cspl-ach></div><div class="search-box order-entry-branch" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.bankFilterForTrade" control-id="txtbankFilterForTrade" lookup-name="bank" control-place-holder="Enter bank name" display-column="bankName" form="frmtradinghomepage" control-required="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'"></cspl-ach></div><div class="search-box order-entry-branch" ng-if="vm.account.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.branchFilterForTrade" control-id="txtbranchFilterForTrade" lookup-name="validStatusBranchesForBank" filter-value="{{vm.account.organisation.id}}" control-place-holder="Enter Branch ID or Name" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForTrade!=null && vm.branchFilterForTrade!=undefined" title="{{vm.branchFilterForTrade.branchName}}">{{vm.branchFilterForTrade.branchName}}</span></div><div class="search-box order-entry-branch" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.bankFilterForTrade!=null"><cspl-ach control-model="vm.branchFilterForTrade" control-id="txtbranchFilterForTrade" lookup-name="validStatusBranchesForBank" filter-value="{{vm.bankFilterForTrade.id}}" control-place-holder="Enter Branch ID or Name" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForTrade!=null && vm.branchFilterForTrade!=undefined" title="{{vm.branchFilterForTrade.branchName}}">{{vm.branchFilterForTrade.branchName}}</span></div><div class="search-box order-entry-branch" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.bankFilterForTrade==null"><cspl-ach control-model="vm.branchFilterForTrade" control-id="txtbranchFilterForTrade" lookup-name="allBranches" control-place-holder="Enter Branch ID or Name" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForTrade!=null && vm.branchFilterForTrade!=undefined" title="{{vm.branchFilterForTrade.branchName}}">{{vm.branchFilterForTrade.branchName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName==\'BANK\'"><cspl-ach control-model="vm.customerFilterForTrade" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForTrade" lookup-name="customer" filter-value="{{vm.bankFilterForTrade.id}}~~{{vm.branchFilterForTrade.id}}~~{{0}}" display-column="customerCode,customerName" form="approvalPolicyForm" control-place-holder="Enter Customer ID or Name"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForTrade!=null && vm.customerFilterForTrade!=undefined" title="{{vm.customerFilterForTrade.customerName}}">{{vm.customerFilterForTrade.customerName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForTrade!=null && vm.bankFilterForTrade!=null"><cspl-ach control-model="vm.customerFilterForTrade" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForTrade" lookup-name="customer" filter-value="{{vm.bankFilterForTrade.id}}~~{{vm.branchFilterForTrade.id}}~~{{0}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForTrade!=null && vm.customerFilterForTrade!=undefined" title="{{vm.customerFilterForTrade.customerName}}">{{vm.customerFilterForTrade.customerName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForTrade==null && vm.bankFilterForTrade!=null"><cspl-ach control-model="vm.customerFilterForTrade" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForTrade" lookup-name="customersForBank" filter-value="{{vm.bankFilterForTrade.id}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForTrade!=null && vm.customerFilterForTrade!=undefined" title="{{vm.customerFilterForTrade.customerName}}">{{vm.customerFilterForTrade.customerName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForTrade!=null && vm.bankFilterForTrade==null"><cspl-ach control-model="vm.customerFilterForTrade" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForTrade" lookup-name="customersForBranch" filter-value="{{vm.branchFilterForTrade.id}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForTrade!=null && vm.customerFilterForTrade!=undefined" title="{{vm.customerFilterForTrade.customerName}}">{{vm.customerFilterForTrade.customerName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForTrade==null && vm.bankFilterForTrade==null"><cspl-ach control-model="vm.customerFilterForTrade" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForTrade" lookup-name="AllCustomers" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForTrade!=null && vm.customerFilterForTrade!=undefined" title="{{vm.customerFilterForTrade.customerName}}">{{vm.customerFilterForTrade.customerName}}</span></div><div class="select-box"><select name="select" class="select-opt" ng-model="vm.instrumentFilterForTrade" ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id"><option value="">--All--</option></select></div><div class="go-btn"><span ng-if="vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'"><button type="button" class="btn btn-go" ng-click="vm.getTradesReport()">GO</button></span> <span ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'"><button type="button" ng-disabled="vm.bankFilterForTrade==null" class="btn btn-go" ng-click="vm.getTradesReport()">GO</button></span></div></div></div></div><div class="col-sm-3"><div class="nav-tab-bot-header-right text-right"><div class="search-field"><cspl-table-search control-model="filterTextForTrade"></cspl-table-search></div></div></div></div><!-- row ends --></div><div class="bot-right-table"><div class="table-responsive"><table id="tblTrades" class="table table-striped"><thead><tr><th ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.organisation.organisationType.shortName==\'CUSTOMER\'">Bank</th><th ng-show="vm.account.entityOwnerType.shortName==\'Clearcorp\' || vm.account.entityOwnerType.shortName==\'Bank\'">Branch</th><th ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.organisation.organisationType.shortName==\'BANK\'">Customer</th><th>Instrument</th><th>B/S</th><th class="text-right">Trade Quantity</th><th class="text-right">Trade Price</th><th class="text-right">Eqv. Spot Trade Price</th><th class="text-right" style="min-width:130px">Trade Quantity (INR)</th><th style="min-width:130px">Trade Date Time</th><th class="text-right">Trade No.</th><th class="text-right">Order No.</th><th>Last Actioned By</th><th>&nbsp;</th></tr></thead><tbody><tr ng-repeat="trade in vm.tradeFilterData = (trades | filter : filterTextForTrade | orderBy : \'lastModifiedDateTime\' : true ) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.organisation.organisationType.shortName==\'CUSTOMER\'" class="minimize-field" title="{{trade.bankName}}"><span>{{trade.bankName}}</span></td><td ng-show="vm.account.entityOwnerType.shortName==\'Clearcorp\' || vm.account.entityOwnerType.shortName==\'Bank\'" class="minimize-field" title="{{trade.branchName}}"><span>{{trade.branchName}}</span></td><td ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.organisation.organisationType.shortName==\'BANK\'" class="minimize-field" title="{{trade.customerCode}}"><span>{{trade.customerCode}}</span></td><td><span>{{trade.instrumentCode}}</span></td><td><span ng-show="trade.buySellIndicator==\'BUYY\'">Buy</span> <span ng-show="trade.buySellIndicator==\'SELL\'">Sell</span></td><td class="text-right"><span>{{trade.tradedAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{trade.tradedExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right"><span>{{trade.spottradedExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right"><span>{{trade.tradedValue | number:vm.noOfDecimalsForAmount}}</span></td><td style="min-width:130px"><span>{{trade.tradeTime| date:\'dd-MMM-yyyy HH:mm:ss\'}}</span></td><td class="text-right"><span>{{trade.tradeSequenceNumber}}</span></td><td class="text-right"><span><a ui-sref="order-activity-pending-orders({orderNumber:trade.orderSequenceNumber})" style="text-decoration:underline">{{trade.orderSequenceNumber}}</a></span></td><td>{{trade.retailUserCode}}</td><td class="text-right freeze-column"><span class="edit-row"><img title="Deal Ticket" class="dealTicket" src="assets/images/Deal ticket-20.png" ng-click="vm.printDealTicket(trade);"></span></td></tr></tbody><tfoot ng-hide="true"><tr class="trade-summary-div" ng-if="trades.length>0 && vm.instrumentFilterForTrade != null && vm.instrumentFilterForTrade != undefined"><td colspan="6">(Trade Position)</td></tr><tr class="trade-summary-div" ng-if="trades.length>0 && vm.instrumentFilterForTrade != null && vm.instrumentFilterForTrade != undefined"><td class="col-md-2 summaryLabelTrades">USD Bought (B)</td><td class="col-md-2 panel-lbl-trades">{{(totalUSDBought | number : vm.noOfDecimalsForAmount)|| \'-\'}}</td><td class="col-md-2 summaryLabelTrades">INR Sold (S)</td><td class="col-md-2 panel-lbl-trades">{{(totalINRSold | number : vm.noOfDecimalsForAmount)|| \'-\'}}</td><td class="col-md-3 summaryLabelTrades">Weighted Average Price (B)</td><td class="col-md-1 panel-lbl-trades">{{(weightedAverageBuy| number : vm.noOfDecimalsForRate)|| \'-\'}}</td></tr><tr class="row" ng-if="trades.length>0 && vm.instrumentFilterForTrade != null && vm.instrumentFilterForTrade != undefined"><td class="col-md-2 summaryLabelTrades">USD Sold (S)</td><td class="col-md-2 panel-lbl-trades-secondary">{{(totalUSDSold | number : vm.noOfDecimalsForAmount)|| \'-\'}}</td><td class="col-md-2 summaryLabelTrades">INR Bought (B)</td><td class="col-md-2 panel-lbl-trades-secondary">{{(totalINRBought | number : vm.noOfDecimalsForAmount)|| \'-\'}}</td><td class="col-md-3 summaryLabelTrades">Weighted Average Price (S)</td><td class="col-md-1 panel-lbl-trades-secondary">{{(weightedAverageSell| number : vm.noOfDecimalsForRate)|| \'-\'}}</td></tr><tr class="row" ng-if="trades.length>0 && vm.instrumentFilterForTrade != null && vm.instrumentFilterForTrade != undefined"><td class="col-md-2 summaryLabelTrades">USD Net (B-S)</td><td class="col-md-2 panel-lbl-trades-tertiary" ng-if="usdNet >= 0">{{(usdNet | number : vm.noOfDecimalsForAmount)|| \'-\'}}</td><td class="col-md-2 panel-lbl-trades-tertiary" ng-if="usdNet < 0">({{(usdNet * -1 | number : vm.noOfDecimalsForAmount)|| \'-\'}} )</td><td class="col-md-2 summaryLabelTrades">INR Net (B-S)</td><td class="col-md-2 panel-lbl-trades-tertiary" ng-if="inrNet >= 0">{{(inrNet| number : vm.noOfDecimalsForAmount)|| \'-\'}}</td><td class="col-md-2 panel-lbl-trades-tertiary" ng-if="inrNet < 0">({{(inrNet * -1| number : vm.noOfDecimalsForAmount)|| \'-\'}} )</td><td class="col-md-3 summaryLabelTrades">Net Weighted Average Price</td><td class="col-md-1 panel-lbl-trades-tertiary">{{(netWeightedAveragePrice | number : vm.noOfDecimalsForRate) || \'-\'}}</td></tr></tfoot></table></div></div><div class="nav-tab-bot-right-footer tradeSummaryFooter"><div class="row" style="margin-bottom:-2px;margin-right:0px"><div class="col-xs-8"><div ng-show="trades.length > 0"><cspl-pagination record-count="trades.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="col-xs-4" style="padding-right:0px" ng-if="trades.length>0"><div class="tradePositionKey" ng-click="vm.expandTradePosition = !vm.expandTradePosition"><span style="padding-right:5px">Trade Position</span> <span style="float:right" aria-hidden="true" ng-show="!vm.expandTradePosition"><img style="height: 17px" src="assets/images/Accordion_expand.png"></span><span style="float:right" aria-hidden="true" ng-show="vm.expandTradePosition"><img style="height: 17px" src="assets/images/Accordion_collapse.png"></span></div></div></div><div ng-show="vm.expandTradePosition" class="trade-summary-div" ng-if="trades.length>0"><div class="row"><div class="col-md-2 summaryLabelTrades">USD Bought (B)</div><div class="col-md-2 panel-lbl-trades">{{(totalUSDBought | number : vm.noOfDecimalsForAmount)|| \'-\'}}</div><div class="col-md-2 summaryLabelTrades">INR Sold (S)</div><div class="col-md-2 panel-lbl-trades">{{(totalINRSold | number : vm.noOfDecimalsForAmount)|| \'-\'}}</div><div class="col-md-3 summaryLabelTrades">Weighted Average Price (B)</div><div class="col-md-1 panel-lbl-trades">{{(weightedAverageBuy| number : vm.noOfDecimalsForRate)|| \'-\'}}</div></div><div class="row"><div class="col-md-2 summaryLabelTrades">USD Sold (S)</div><div class="col-md-2 panel-lbl-trades-secondary">{{(totalUSDSold | number : vm.noOfDecimalsForAmount)|| \'-\'}}</div><div class="col-md-2 summaryLabelTrades">INR Bought (B)</div><div class="col-md-2 panel-lbl-trades-secondary">{{(totalINRBought | number : vm.noOfDecimalsForAmount)|| \'-\'}}</div><div class="col-md-3 summaryLabelTrades">Weighted Average Price (S)</div><div class="col-md-1 panel-lbl-trades-secondary">{{(weightedAverageSell| number : vm.noOfDecimalsForRate)|| \'-\'}}</div></div><div class="row"><div class="col-md-2 summaryLabelTrades">USD Net (B-S)</div><div class="col-md-2 panel-lbl-trades-tertiary" ng-if="usdNet >= 0">{{(usdNet | number : vm.noOfDecimalsForAmount)|| \'-\'}}</div><div class="col-md-2 panel-lbl-trades-tertiary" ng-if="usdNet < 0">({{(usdNet * -1 | number : vm.noOfDecimalsForAmount)|| \'-\'}})</div><div class="col-md-2 summaryLabelTrades">INR Net (B-S)</div><div class="col-md-2 panel-lbl-trades-tertiary" ng-if="inrNet >= 0">{{(inrNet| number : vm.noOfDecimalsForAmount)|| \'-\'}}</div><div class="col-md-2 panel-lbl-trades-tertiary" ng-if="inrNet < 0">({{(inrNet * -1| number : vm.noOfDecimalsForAmount)|| \'-\'}})</div><div class="col-md-3 summaryLabelTrades">Net Weighted Average Price</div><div class="col-md-1 panel-lbl-trades-tertiary">{{(netWeightedAveragePrice | number : vm.noOfDecimalsForRate) || \'-\'}}</div></div><!-- \t<table>\r\n\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t<td class="summaryLabel">USD Brought(B)</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{totalUSDBought}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td class="summaryLabel">USD Brought(B)</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{totalUSDBought}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td class="summaryLabel">USD Brought(B)</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{totalUSDBought}}</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t</table> --></div><!-- <div ng-show="vm.expandTradePosition" class="trade-summary-div" ng-if="trades.length>0 && (vm.instrumentFilterForTrade == null \r\n\t\t\t\t\t\t\t\t|| vm.instrumentFilterForTrade == undefined )">\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-2 summaryLabelTrades">USD Bought (B)</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-2 panel-lbl-trades">-</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-2 summaryLabelTrades">INR Sold (S)</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-2 panel-lbl-trades">-</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-3 summaryLabelTrades">Weighted Average Price (B)</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-1 panel-lbl-trades">-</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-2 summaryLabelTrades">USD Sold (S)</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-2 panel-lbl-trades-secondary">-</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-2 summaryLabelTrades">INR Bought (B)</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-2 panel-lbl-trades-secondary">-</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-3 summaryLabelTrades">Weighted Average Price (S)</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-1 panel-lbl-trades-secondary">-</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-2 summaryLabelTrades">USD Net (B-S)</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-2 panel-lbl-trades-tertiary" ng-if="usdNet >= 0">-</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-2 panel-lbl-trades-tertiary" ng-if="usdNet < 0">-</div>\r\n\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-2 summaryLabelTrades">INR Net (B-S)</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-2 panel-lbl-trades-tertiary" ng-if="inrNet >= 0">-</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-2 panel-lbl-trades-tertiary" ng-if="inrNet < 0">-</div>\r\n\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-3 summaryLabelTrades">Net Weighted Average Price</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-1 panel-lbl-trades-tertiary">-</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<table>\r\n\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t<td class="summaryLabel">USD Brought(B)</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{totalUSDBought}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td class="summaryLabel">USD Brought(B)</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{totalUSDBought}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td class="summaryLabel">USD Brought(B)</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{totalUSDBought}}</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t</table>\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t</div> --></div></div><!--Trades Closed--><div role="tabpanel" class="tab-pane" id="Limits"><div class="bot-right-header-wrapper"><div class="row"><div class="col-sm-9"><div class="nav-tab-bot-header-left"><div ng-class="{clearcorp: vm.account.entityOwnerType.shortName==\'Clearcorp\'}"><div class="up-btn"><!-- <a href="#"><img src="assets/images/search-up-icon.png"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\talt="download-icon"></a> --><cspl-table-export table-name="tblLimits" total-record-count="limitsAvailableForSelectedInstrument.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="LimitUtilisation_{{vm.custCode}}_{{vm.bankFilterForLimit.bankName}}"></cspl-table-export></div><div class="search-box order-entry-branch" ng-if="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.bankFilterForLimit" control-id="txtbankFilterForLimit" lookup-name="tradingBank" control-place-holder="Enter bank name" filter-value="{{vm.account.organisation.id}}" display-column="bankName" form="frmtradinghomepage"></cspl-ach></div><div class="search-box order-entry-branch" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.bankFilterForLimit" control-id="txtbankFilterForLimit" lookup-name="bank" control-place-holder="Enter bank name" display-column="bankName" form="frmtradinghomepage" control-required="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'"></cspl-ach></div><div class="search-box order-entry-branch" ng-if="vm.account.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.branchFilterForLimit" control-id="txtbranchFilterForLimit" lookup-name="validStatusBranchesForBank" filter-value="{{vm.account.organisation.id}}" control-place-holder="Enter Branch ID or Name" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForLimit!=null && vm.branchFilterForLimit!=undefined">{{vm.branchFilterForLimit.branchName}}</span></div><div class="search-box order-entry-branch" ng-if="vm.account.entityOwnerType.shortName==\'Clearcorp\' && vm.bankFilterForLimit!=null"><cspl-ach control-model="vm.branchFilterForLimit" control-id="txtbranchFilterForLimit" lookup-name="validStatusBranchesForBank" filter-value="{{vm.bankFilterForLimit.id}}" control-place-holder="Enter Branch ID or Name" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForLimit!=null && vm.branchFilterForLimit!=undefined">{{vm.branchFilterForLimit.branchName}}</span></div><div class="search-box order-entry-branch" ng-if="vm.account.entityOwnerType.shortName==\'Clearcorp\' && vm.bankFilterForLimit==null"><cspl-ach control-model="vm.branchFilterForLimit" control-id="txtbranchFilterForLimit" lookup-name="allBranches" control-place-holder="Enter Branch ID or Name" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForLimit!=null && vm.branchFilterForLimit!=undefined">{{vm.branchFilterForLimit.branchName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName==\'BANK\'"><cspl-ach control-model="vm.customerFilterForLimit" control-id="txtcustomerFilterForLimit" lookup-name="customer" filter-value="{{vm.bankFilterForLimit.id}}~~{{vm.branchFilterForLimit.id}}~~{{0}}" display-column="customerCode,customerName" form="approvalPolicyForm" control-place-holder="Enter Customer ID or Name"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForLimit!=null && vm.customerFilterForLimit!=undefined" title="{{vm.customerFilterForLimit.customerName}}">{{vm.customerFilterForLimit.customerName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForLimit!=null && vm.bankFilterForLimit!=null"><cspl-ach control-model="vm.customerFilterForLimit" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForLimit" lookup-name="customer" filter-value="{{vm.bankFilterForLimit.id}}~~{{vm.branchFilterForLimit.id}}~~{{0}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForLimit!=null && vm.customerFilterForLimit!=undefined" title="{{vm.customerFilterForLimit.customerName}}">{{vm.customerFilterForLimit.customerName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForLimit==null && vm.bankFilterForLimit!=null"><cspl-ach control-model="vm.customerFilterForLimit" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForLimit" lookup-name="customersForBank" filter-value="{{vm.bankFilterForLimit.id}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForLimit!=null && vm.customerFilterForLimit!=undefined" title="{{vm.customerFilterForLimit.customerName}}">{{vm.customerFilterForLimit.customerName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForLimit!=null && vm.bankFilterForLimit==null"><cspl-ach control-model="vm.customerFilterForLimit" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForLimit" lookup-name="customersForBranch" filter-value="{{vm.branchFilterForLimit.id}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForLimit!=null && vm.customerFilterForLimit!=undefined" title="{{vm.customerFilterForLimit.customerName}}">{{vm.customerFilterForLimit.customerName}}</span></div><div class="search-box" ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForLimit==null && vm.bankFilterForLimit==null"><cspl-ach control-model="vm.customerFilterForLimit" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForLimit" lookup-name="AllCustomers" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForLimit!=null && vm.customerFilterForLimit!=undefined" title="{{vm.customerFilterForLimit.customerName}}">{{vm.customerFilterForLimit.customerName}}</span></div><div class="select-box"><select name="select" class="select-opt" ng-model="vm.instrumentFilterForLimit" ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id"><option value="">--All--</option></select></div><div class="go-btn"><span ng-if="vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'"><button type="button" class="btn btn-go" ng-click="vm.getLimitUtilisedReport()">GO</button></span> <span ng-if="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'"><button type="button" ng-disabled="vm.bankFilterForLimit==null" class="btn btn-go" ng-click="vm.getLimitUtilisedReport()">GO</button></span></div></div></div></div><div class="col-sm-3"><div class="nav-tab-bot-header-right text-right"><div class="search-field"><cspl-table-search control-model="filterTextForLimit"></cspl-table-search><span class="help-block-values">(Values in USD)</span></div></div></div></div><!-- row ends --></div><div class="bot-right-table"><div class="table-responsive"><table id="tblLimits" class="table table-striped"><thead><tr><th rowspan="2" ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.organisation.organisationType.shortName==\'CUSTOMER\'">Bank</th><th rowspan="2" ng-show="vm.account.entityOwnerType.shortName==\'Clearcorp\' || vm.account.entityOwnerType.shortName==\'Bank\'">Branch</th><th rowspan="2" ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.organisation.organisationType.shortName==\'BANK\'">Customer</th><th rowspan="2">Instrument</th><th rowspan="2">Limit Type</th><th rowspan="2" class="text-right border-right-column">Allocated</th><!-- <th></th> --><th colspan="8" class="text-center border-right-column">Utilised</th><th colspan="2" class="text-center border-right-column">Un-utilised</th><th rowspan="2" class="text-right">Exposure %</th></tr><tr><!-- \t\t\t\t\t\t\t\t\t\t\t\t<th>Limit CCY</th> --><th class="text-right">Pending Buy</th><th class="text-right">Pending Sell</th><th class="text-right">Buy Trade</th><th class="text-right">Sell Trade</th><th class="text-right">Prev. Buy Trade</th><th class="text-right">Prev. Sell Trade</th><th class="text-right">Total Buy</th><th class="text-right border-right-column">Total Sell</th><th class="text-right">Buying Power</th><th class="text-right border-right-column">Selling Power</th><!-- <th class="text-right">Exposure %</th> --></tr></thead><tbody><tr ng-repeat="limit in filterData = (limitsAvailableForSelectedInstrument | filter : filterTextForLimit | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.organisation.organisationType.shortName==\'CUSTOMER\'" class="minimize-field" title="{{limit.bankName}}"><span>{{limit.bankName}}</span></td><td ng-show="vm.account.entityOwnerType.shortName==\'Clearcorp\' || vm.account.entityOwnerType.shortName==\'Bank\'" class="minimize-field" title="{{limit.branchName}}"><span>{{limit.branchName}}</span></td><td ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.organisation.organisationType.shortName==\'BANK\'" class="minimize-field" title="{{limit.customerCode}}"><span>{{limit.customerCode}}</span></td><td><span>{{limit.instrumentCode}}</span></td><td><span ng-show="limit.limitType==\'GROSSBUY\'">Gross Buy</span> <span ng-show="limit.limitType==\'GROSSSELL\'">Gross Sell</span> <span ng-show="limit.limitType==\'GLOBALGROSS\'">Global Gross</span> <span ng-show="limit.limitType==\'NET\'">Net</span></td><!-- \t\t\t\t\t\t\t\t\t\t\t\t<td><span>{{limit.currencyCode}}</span></td> --><td class="text-right"><span>{{limit.limitAllocatedInUSD | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{limit.totalPendingBuyOrderValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{limit.totalPendingSellOrderValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{limit.totalBuyTradeValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{limit.totalSellTradeValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{limit.previousDayBuyTradeValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{limit.previousDaySellTradeValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-show="limit.limitType!=\'NET\'"><span>{{limit.totalBuyTradeValue + limit.previousDayBuyTradeValue + limit.totalPendingBuyOrderValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-show="limit.limitType!=\'NET\'"><span>{{limit.totalSellTradeValue + limit.previousDaySellTradeValue + limit.totalPendingSellOrderValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-show="limit.limitType==\'NET\'"><span>{{limit.totalPendingBuyOrderValue+((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue)) | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-show="limit.limitType==\'NET\'"><span>{{limit.totalPendingSellOrderValue+((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue)) | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{vm.getBuyingPower(limit) | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{vm.getSellingPower(limit) | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{vm.getExposure(limit) | number:vm.noOfDecimalsForAmount}}</span></td></tr></tbody></table></div></div><div class="nav-tab-bot-right-footer"><div class="row"><div class="col-xs-8"><div ng-show="limitsAvailableForSelectedInstrument.length > 0"><cspl-pagination record-count="limitsAvailableForSelectedInstrument.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="col-xs-4 text-right"><button type="button" class="btn btn-info active" ng-show="vm.permitCustomerLimitSettings && limitAvailableForSlectBankFilterInReport" ng-disabled="vm.bankFilterForLimit==null || vm.bankFilterForLimit==undefined || filterData<=0" ng-click="vm.limitChangeRequest()">CHANGE REQUEST</button> <button type="button" class="btn btn-info active" ng-show="vm.permitCustomerLimitSettings && !limitAvailableForSlectBankFilterInReport" ng-disabled="vm.bankFilterForLimit==null || vm.bankFilterForLimit==undefined" ng-click="vm.newLimitRequest()">NEW LIMIT REQUEST</button></div></div></div></div><!--Limits Closed--></div></div></div></div></div><!-- main content ends --><!-- </form> -->');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><h3 ng-hide="filteredConfig.length === 0">Spring configuration</h3><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-success break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><h4 ng-hide="filtered.length === 0"><span>{{key}}</span></h4><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-success break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.user.id"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/changepassword/changepassword.html','<div class="modal-header"><h4 class="modal-title" data-translate="password.changepasswordtitle">Change Password</h4></div><div class="modal-body"><div class="content"><div class="row"><div class="col-md-8 col-md-offset-2"><!-- <div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success">\r\n\t\t                <strong>Password changed!</strong>\r\n\t\t            </div> --><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error">The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.userLockedError" data-translate="password.messages.locked">Maximum Incorrect current password attempt. User is locked.</div><div class="alert alert-danger" ng-show="vm.previousPasswordError">The last {{vm.configSetting.minimumNumberOfPreviousPasswordThatCannotBeRepeated}} passwords could not be re-used.</div><div class="alert alert-danger" ng-show="vm.incorrectPasswordError" data-translate="global.messages.error.incorrectPasswordError"></div><div class="alert alert-danger" ng-show="vm.minimumPasswordAgeError">The password cannot be changed with in {{vm.configSetting.minimumPasswordAgeInHours}} hours.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div class="alert alert-danger" ng-show="vm.currentPasswordDoNotMatch" data-translate="global.messages.error.currentPassworddontmatch">The current password do not match!</div><div class="alert alert-danger" ng-show="vm.passwordContainLogin" data-translate="global.messages.error.passowrdContainLogin">The current password do not match!</div><form name="form" role="form" novalidate show-validation ng-submit="vm.clicked = true; vm.changePassword();"><!-- \t\t                <div class="form-group">\r\n\t\t                    <label class="control-label" for="currentpassword" data-translate="global.form.currentpassword">Current password</label>\r\n\t\t                    <input type="password" class="form-control" id="currentpassword" name="currentpassword" placeholder="{{\'global.form.currentpassword.placeholder\' | translate}}"\r\n\t\t                           ng-model="vm.currentPassword" ng-minlength=4 ng-maxlength=50 required>\r\n\t\t                </div> --><div class="input-group"><label class="control-label change-pwd-label" for="login-password">Current Password</label><input id="login-password" name="login-password" type="{{vm.controlType}}" ng-model="vm.loginpassword" placeholder="{{\'global.form.currentpassword.placeholder\' | translate}}" class="form-control pwd" ng-focus="vm.onFocusCurrentPwd()" ng-blur="vm.onBlurCurrentPwd()" autocomplete="off" required> <span class="input-group-btn" style="display: block"><button type="button" tabindex="-1" ng-disabled="controlDisabled" class="btn btn-primary showButton" style="border-color:{{vm.boColor}}" ng-click="vm.showCurrentPwd(vm.controlType)"><img ng-src="assets/images/Password Visibility-18.png"></button></span></div><div class="input-group"><label class="control-label change-pwd-label" for="password" data-translate="global.form.newpassword">New password</label><input type="{{vm.controlType1}}" class="form-control pwd" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" autocomplete="off" ng-model="vm.password" ng-focus="vm.displayHelpText=true;vm.onFocusPwd()" ng-blur="displayHelpText=false;vm.onBlurPwd()" required> <span class="input-group-btn" style="display: block"><button type="button" tabindex="-1" ng-disabled="controlDisabled" class="btn btn-primary showButton" style="border-color:{{vm.boColor1}}" ng-click="vm.showPwd(vm.controlType1)"><img ng-src="assets/images/Password Visibility-18.png"></button></span></div><div><password-strength-bar control-id="password1" form="form" password-to-check="vm.password" min-password-length="vm.configSetting.minimumPasswordLength"></password-strength-bar><span class="help-block" style="text-align:left" data-translate="global.messages.validate.newpassword.validation" data-translate-values="{minValue: vm.configSetting.minimumPasswordLength, maxValue : 30}" ng-show="vm.displayHelpText"></span></div><div class="input-group"><label class="control-label change-pwd-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="{{vm.controlType2}}" class="form-control pwd" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" autocomplete="off" ng-model="vm.confirmPassword" ng-focus="vm.onFocusConfirmPwd()" ng-blur="vm.onBlurConfirmPwd()" required><!-- \t\t                    <password-strength-bar control-id="confirmPassword" form="form" password-to-check="vm.confirmPassword"></password-strength-bar> --> <span class="input-group-btn" style="display: block"><button type="button" tabindex="-1" ng-disabled="controlDisabled" class="btn btn-primary showButton" style="border-color:{{vm.boColor2}}" ng-click="vm.showConfirmPwd(vm.controlType2)"><img ng-src="assets/images/Password Visibility-18.png"></button></span></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="form.$invalid || vm.userLockedError==\'ERROR\' || vm.clicked" class="btn btn-primary"><span data-translate="password.form.button">Save</span></button></div></form></div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" autocomplete="off" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password" min-password-length="vm.configSetting.minimumPasswordLength"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" autocomplete="off" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/track-status/track-status.html','<div id="track-status"><div class="track-status-header text-center"><img class="customer-page-logo" src="assets/images/ClearCorp.png"> <img class="customer-page-header" src="assets/images/FX_CR.png"></div><div class="track-status-content"><div class="sub-header text-center"><span ng-show="!vm.withdrawn && !vm.rejected">Thank you for registering with us!!</span></div><div class="content text-center" ng-show="!vm.withdrawn && !vm.rejected"><span>Your application request <span class="reqNo">{{vm.requestRefNo}}</span> has been submitted to your relationship bank and it is now being reviewed.</span></div><div class="content text-center" ng-show="vm.withdrawn"><span>Your application request <span class="reqNo">{{vm.requestRefNo}}</span> has been <span class="withdrawn">Withdrawn</span>.</span></div><div class="content text-center" ng-show="vm.rejected"><span>Your application request <span class="reqNo">{{vm.requestRefNo}}</span> has been <span class="rejected">Rejected</span>.</span></div><div class="track-status-btn col-md-12"><button type="submit" ng-disabled="vm.clicked" class="btn btn-block btn-primary" ng-click="vm.generateOTP();vm.clicked = true;" ng-show="vm.activationKey!=\'0000\'">VIEW REGISTRATION DETAILS</button></div></div><div class="track-status-footer"><div class="track-status-icon"><!-- <img style="margin-right:15vh;margin-left: 15vh;" src="assets/images/Track_Status_Completed.png" /> --> <img style="margin-right:15vh;margin-left: 15vh" ng-show="vm.emailVerified" src="assets/images/Track_Status_Completed.png"><!-- <img style="margin-right:10vh;margin-left:10vh;" ng-show="!vm.emailVerified" src="assets/images/Track_Status_Incomplete.png" /> --> <img style="margin-left: 25vh" ng-show="!vm.approved" src="assets/images/Track_Status_Incomplete.png"> <img style="margin-left: 25vh" ng-show="vm.approved" src="assets/images/Track_Status_Completed.png"></div><div class="track-status-icon" style="margin-bottom: -8.2vh"><!-- <img style="width:30vh;" src="assets/images/Steppers_line_small_175.png" /> --> <img style="width: 43vh;margin-right: 7vh;margin-left: 30vh" src="assets/images/Steppers_line_small_175.png"> <img style="width: 43vh;margin-right: 13vh" src="assets/images/Steppers_line_small_175.png"></div><div class="status-text-header"><div class="col-md-3 col-md-offset-2">&nbsp;&nbsp;&nbsp;<img src="assets/images/Track_Status_Step1.png"></div><!-- <div class="col-md-2" >\r\n     \t\t\t\t&nbsp;&nbsp;<img ng-show="vm.emailVerified" src="assets/images/Track_Status_Step2.png" />\r\n     \t\t\t\t&nbsp;&nbsp;<img ng-show="!vm.emailVerified" src="assets/images/Track_Status_Step2_Current.png" />\r\n\t\t\t\t</div> --><div class="col-md-3"><img ng-show="vm.emailVerified && !vm.approved && !vm.rejected && !vm.withdrawn" src="assets/images/Track_Status_Step2_Current.png"> <img ng-show="!vm.emailVerified" src="assets/images/Track_Status_Step2_Upcoming.png"> <img ng-show="vm.approved && !vm.rejected && !vm.withdrawn" src="assets/images/Track_Status_Step2.png"> <img ng-show="vm.rejected" src="assets/images/Track_Status_Step2_Rejected.png"> <img ng-show="vm.withdrawn" src="assets/images/Track_Status_Step2_Withdrawn.png"></div><div class="col-md-3"><img ng-show="!vm.approved" src="assets/images/Track_Status_Step3_Upcoming.png"> <img ng-show="vm.approved && !vm.tradingActivated" src="assets/images/Track_Status_Step3_Current.png"> <img ng-show="vm.tradingActivated" src="assets/images/Track_Status_Step3.png"></div></div><div class="status-text-header"><label class="col-md-3 col-md-offset-2">&nbsp;&nbsp;&nbsp;Registration</label><!-- <label class="col-md-2 " >&nbsp;&nbsp;Email Verification</label> --><label class="col-md-3">&nbsp;Approval</label><label class="col-md-3">Trading Activation</label></div><div class="status-text"><span class="col-md-3 col-md-offset-2">Your request has been successfully submitted and pending for bank approval</span><!-- <span class="col-md-2">Your primary contact email/user email has been successfully verified and the request is now waiting for bank approval</span> --> <span class="col-md-3">You will receive an email confirmation along with the login credentials, once your request is verified and approved</span> <span class="col-md-3">You will be able to login to the platform once trading rights are activated</span></div></div></div>');
$templateCache.put('app/components/alert-configuration/alert-configuration-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.alertConfigurationHeader.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><nmb-alert-error></nmb-alert-error><p translate-values="{id: \'{{vm.alertConfigurationHeader.id}}\'}">Are you sure you want to delete this alert configuration?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-disabled="deleteForm.$invalid" class="btn btn-danger" ng-click="vm.confirmDelete()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/components/alert-configuration/alert-configuration-dialog.html','<form name="alertConfigurationForm" role="form" novalidate><div class="modal-header" style="height:80px"><!-- \t \t<h1 class="modal-title" >AlertConfiguraion</h1> --> <img src="assets/images/manage_alert.png" alt="" style="display:block; margin:auto; vertical-align:middle"><h6 style="color:white; text-align:center">Add Alert</h6></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><fieldset ng-disabled="vm.disableForm"><div class="row"><label class="col-md-3 control-label" cspl-mandatory>Notification type</label><div class="col-md-5-5"><select class="form-control" ng-model="vm.alertConfigurationHeader.eventType.notificationType" ng-options="notificationType as notificationType.shortName for notificationType in vm.notificationTypes track by notificationType.id" ng-hide="vm.getEventTypes(vm.alertConfigurationHeader.eventType.notificationType); vm.getNotifyByTypesForAlert(vm.alertConfigurationHeader.eventType.notificationType);" ng-change="vm.clearNotifyByTypes()" ng-disabled="disableControl" required></select></div></div><br><div class="row"><label class="col-md-3 control-label" cspl-mandatory>Event</label><div class="col-md-5-5"><select class="form-control" ng-model="vm.alertConfigurationHeader.eventType" ng-options="eventType as eventType.shortName for eventType in  vm.eventTypesForNotificationType track by eventType.id " ng-hide="vm.getReminderTypes(vm.alertConfigurationHeader.eventType)" ng-disabled="disableControl" required></select></div><label class="col-md-3 control-label" style="text-align:left" ng-hide="(vm.alertConfigurationHeader.eventType.nature==null)">({{vm.alertConfigurationHeader.eventType.nature}})</label></div><br><div class="row"><label class="col-md-3 control-label" cspl-mandatory>Branch</label><div class="col-md-5-5"><cspl-ach control-model="vm.alertConfigurationHeader.branch" control-id="txtBranch" lookup-name="branch" display-column="shortName" control-value-change="vm.getUsers(vm.alertConfigurationHeader.branch)" required form="alertConfigurationForm" control-disabled="disableControl"></cspl-ach></div></div><br><div class="row"><label class="col-md-3 control-label" cspl-mandatory>When to notify</label><div class="col-md-5-5"><select class="form-control" name="reminder" ng-model="vm.alertConfigurationHeader.reminderType" ng-options="reminderType as reminderType.shortName for reminderType in vm.reminderTypesForEventType track by reminderType.id " required></select></div><div class="col-md-1" style="width:12%"><cspl-numeric control-model="vm.alertConfigurationHeader.numberOfDaysToNotify" control-type="Number" no-of-decimals="0" control-max="99" control-id="txtNoOfDaysToNotify" form="alertConfigurationForm" ng-hide="vm.alertConfigurationHeader.eventType.nature!=\'Upcoming\'"></div><label class="col-md-2 control-label" style="text-align:left" ng-hide="vm.alertConfigurationHeader.eventType.nature!=\'Upcoming\'">days earlier</label></div><br><div class="row"><label class="col-md-3 control-label" cspl-mandatory>Notify whom</label><div class="col-md-5-5"><label class="control-label" for="radioRole" style="display: inline-block"><input type="radio" id="radioRole" ng-model="vm.configNotifyUsersBy" name="Role" value="roles" ng-click="vm.userList=null">&nbsp; Role</label>&emsp;<label class="control-label" for="radioUser" style="display: inline-block"><input type="radio" id="radioUser" ng-model="vm.configNotifyUsersBy" name="User" value="users" ng-click="vm.roleList=null">&nbsp; User</label></div></div><!-- \t\t\t\t\t<br> --><div class="row"><label class="col-md-2 control-label" style="width:24%"></label><div class="col-md-7" style="background-color:#EDEDEE; border-radius:6px"><ul style="list-style-type: none; margin: 0; padding: 0; overflow:auto" ng-hide="vm.configNotifyUsersBy==\'roles\'"><li ng-repeat="user in vm.users | orderBy: \'shortName\'" style="margin-top:5px"><label><input type="checkbox" checklist-model="vm.userList" checklist-value="user.id">&nbsp;{{user.login}} ({{user.email}})</label></li></ul><ul style="list-style-type: none; margin: 0; padding: 0" ng-hide="vm.configNotifyUsersBy==\'users\'"><li ng-repeat="role in vm.roles | orderBy: \'shortName\'" style="margin-top:5px"><label><input type="checkbox" checklist-model="vm.roleList" checklist-value="role.id">&nbsp;{{role.name}}</label></li></ul><!-- <select class="form-control" ng-model="vm.userList" ng-hide="vm.alertConfigurationHeader.configNotifyUsersBy==\'roles\'" \r\n\t\t\t\t\t\t\t\t\tng-options="user as (user.login + \' (\' + user.email + \')\') for user in vm.users track by user.id" multiple>\r\n\t\t\t\t\t\t</select> --><!-- <select class="form-control" ng-model="vm.roleList"  ng-hide="vm.alertConfigurationHeader.configNotifyUsersBy==\'users\'"\r\n\t\t\t\t\t\t\t\t\tng-options="role as role.name for role in vm.roles track by role.id" multiple>\r\n\t\t\t\t\t\t</select> --></div></div><br><div class="row"><label class="col-md-3 control-label" cspl-mandatory>Notify by</label><div class="col-md-6"><label style="margin-top: 10px" ng-repeat="NotifyType in vm.notifyByTypes | orderBy: \'shortName\'"><input type="checkbox" checklist-model="vm.notifyByTypeList" checklist-value="NotifyType.id" checklist-change="vm.getNotifyByTypes(vm.notifyByTypeList, NotifyType)">&nbsp;<span style="margin-bottom:5px">{{NotifyType.shortName}}</span>&nbsp;&nbsp;&nbsp;&nbsp;</label></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-show="!(showButton)" ng-disabled="alertConfigurationForm.$invalid || ((vm.userList==\'\' || vm.userList==null) && (vm.roleList==null || vm.roleList==\'\')) || (vm.notifyByTypeList==null || vm.notifyByTypeList==\'\') || clicked" class="btn btn-info active" ng-click="vm.save();clicked = true;"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-show="showButton" ng-disabled="alertConfigurationForm.$invalid || ((vm.userList==\'\' || vm.userList==null) && (vm.roleList==null || vm.roleList==\'\')) || (vm.notifyByTypeList==null || vm.notifyByTypeList==\'\') || clicked" class="btn btn-info active" ng-click="vm.resubmit();clicked = true;"><span data-translate="entity.action.resubmit">Resubmit</span></button></div></div></div></form>');
$templateCache.put('app/components/alert-configuration/alert-configuration-edit-dialog.html','<form name="alertConfigurationForm" role="form" novalidate><div class="modal-header" style="height:80px"><!-- \t \t<h1 class="modal-title" >AlertConfiguraion</h1> --> <img src="assets/images/manage_alert.png" alt="" style="display:block; margin:auto; vertical-align:middle"><h6 style="color:white; text-align:center">Edit Alert</h6></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><fieldset ng-disabled="vm.disableForm"><div class="row"><label class="col-md-3 control-label" cspl-mandatory>Notification type</label><div class="col-md-5-5"><select class="form-control" ng-model="vm.alertConfigurationHeader.eventType.notificationType" ng-options="notificationType as notificationType.shortName for notificationType in vm.notificationTypes track by notificationType.id" ng-hide="vm.getEventTypes(vm.alertConfigurationHeader.eventType.notificationType); vm.getNotifyByTypesForAlert(vm.alertConfigurationHeader.eventType.notificationType);" ng-disabled="true" required></select></div></div><br><div class="row"><label class="col-md-3 control-label" cspl-mandatory>Event</label><div class="col-md-5-5"><select class="form-control" ng-model="vm.alertConfigurationHeader.eventType" ng-options="eventType as eventType.shortName for eventType in  vm.eventType track by eventType.id " ng-hide="vm.getReminderTypes(vm.alertConfigurationHeader.eventType)" ng-disabled="true" required></select></div><label class="col-md-3 control-label" style="text-align:left" ng-hide="(vm.alertConfigurationHeader.eventType.nature==null)">({{vm.alertConfigurationHeader.eventType.nature}})</label></div><br><div class="row"><label class="col-md-3 control-label" cspl-mandatory>Branch</label><div class="col-md-5-5"><!-- <select class="form-control" ng-model="vm.alertConfigurationHeader.branch"\r\n\t\t\t\t\t\t\t\tng-options="branch as branch.shortName for branch in  vm.branch track by branch.id "\r\n\t\t\t\t\t\t\t\tng-change="vm.getUsers(vm.alertConfigurationHeader.branch)"></select> --><cspl-ach control-model="vm.alertConfigurationHeader.branch" control-id="txtBranch" lookup-name="branch" display-column="shortName" control-value-change="vm.getUsers(vm.alertConfigurationHeader.branch)" control-disabled="true" required form="alertConfigurationForm"></cspl-ach></div></div><br><div class="row"><label class="col-md-3 control-label" cspl-mandatory>When to notify</label><div class="col-md-5-5"><select class="form-control" name="reminder" ng-model="vm.alertConfigurationHeader.reminderType" ng-options="reminderType as reminderType.shortName for reminderType in vm.reminderType track by reminderType.id " required></select></div><div class="col-md-1" style="width:12%"><cspl-numeric control-model="vm.alertConfigurationHeader.numberOfDaysToNotify" control-type="Number" no-of-decimals="0" control-max="99" control-id="txtNoOfDaysToNotify" form="alertConfigurationForm" ng-hide="vm.alertConfigurationHeader.eventType.nature!=\'Upcoming\'"></div><label class="col-md-2 control-label" style="text-align:left" ng-hide="vm.alertConfigurationHeader.eventType.nature!=\'Upcoming\'">days earlier</label></div><br><div class="row"><label class="col-md-3 control-label" cspl-mandatory>Notify whom</label><div class="col-md-5-5"><label class="control-label" for="radioRole" style="display: inline-block"><input type="radio" id="radioRole" ng-model="vm.alertConfigurationHeader.configNotifyUsersBy" name="Role" value="roles" ng-click="vm.userList=null">&nbsp; Role</label>&emsp;<label class="control-label" for="radioUser" style="display: inline-block"><input type="radio" id="radioUser" ng-model="vm.alertConfigurationHeader.configNotifyUsersBy" name="User" value="users" ng-click="vm.roleList=null">&nbsp; User</label></div></div><br><div class="row"><label class="col-md-2 control-label" style="width:24%"></label><div class="col-md-7" style="background-color:#EDEDEE; border-radius:6px"><ul style="list-style-type: none; margin: 0; padding: 0; overflow:auto" ng-hide="vm.alertConfigurationHeader.configNotifyUsersBy==\'roles\'"><li ng-repeat="user in vm.users | orderBy: \'login\'" style="margin-top:5px"><label><input type="checkbox" checklist-model="vm.userList" checklist-value="user.id">&nbsp;{{user.login}} ({{user.email}})</label></li></ul><ul style="list-style-type: none; margin: 0; padding: 0" ng-hide="vm.alertConfigurationHeader.configNotifyUsersBy==\'users\'"><li ng-repeat="role in vm.roles" style="margin-top:5px"><label><input type="checkbox" checklist-model="vm.roleList" checklist-value="role.id">&nbsp;{{role.name}}</label></li></ul><!-- <label ng-repeat="user in vm.users | orderBy: \'login\'">\r\n  \t\t\t\t\t\t\t<input type="checkbox" checklist-model="vm.userList" checklist-value="user">&nbsp;{{user.login}} ({{user.email}})&nbsp;&nbsp;&nbsp;&nbsp;\r\n\t\t\t\t\t\t</label> --><!-- <select class="form-control" ng-model="vm.userList" ng-hide="vm.alertConfigurationHeader.configNotifyUsersBy==\'roles\'" \r\n\t\t\t\t\t\t\t\t\tng-options="user as (user.login + \' (\' + user.email + \')\') for user in vm.users track by user.id" multiple>\r\n\t\t\t\t\t\t</select> --><!-- <select class="form-control" ng-model="vm.roleList"  ng-hide="vm.alertConfigurationHeader.configNotifyUsersBy==\'users\'"\r\n\t\t\t\t\t\t\t\t\tng-options="role as role.name for role in vm.roles track by role.id" multiple>\r\n\t\t\t\t\t\t</select> --></div></div><br><div class="row"><label class="col-md-3 control-label" cspl-mandatory>Notify by</label><div class="col-md-6"><label style="margin-top: 10px" ng-repeat="NotifyType in vm.notifyByTypes | orderBy: \'shortName\'"><input type="checkbox" checklist-model="vm.notifyByTypeList" checklist-value="NotifyType.id" checklist-change="vm.getNotifyByTypes(vm.notifyByTypeList, NotifyType)">&nbsp;<span style="margin-bottom:5px">{{NotifyType.shortName}}</span>&nbsp;&nbsp;&nbsp;&nbsp;</label></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-hide="showButton" ng-disabled="alertConfigurationForm.$invalid || (vm.userList==null && vm.roleList==null) || (vm.notifyByTypeList==null || vm.notifyByTypeList==\'\') || clicked" class="btn btn-info active" ng-click="vm.save();clicked = true;"><span data-translate="entity.action.save">Save</span></button></div></div></div></form>');
$templateCache.put('app/components/alert-configuration/alert-configuration-view-dialog.html','<form name="alertConfigurationViewForm" role="form" novalidate><div class="modal-header"><h1 class="modal-title">Alert Configuration</h1></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><fieldset ng-disabled="vm.disableForm"><div class="row"><label class="col-md-3 control-label" cspl-mandatory>Notification type</label><div class="col-md-5-5"><select class="form-control" ng-model="vm.alertConfigurationHeader.eventType.notificationType" ng-options="notificationType as notificationType.shortName for notificationType in vm.notificationTypes track by notificationType.id" ng-disabled="true" required></select></div></div><br><div class="row"><label class="col-md-3 control-label" cspl-mandatory>Event</label><div class="col-md-5-5"><select class="form-control" ng-model="vm.alertConfigurationHeader.eventType" ng-options="eventType as eventType.shortName for eventType in  vm.eventType track by eventType.id " ng-disabled="true" required></select></div><label class="col-md-3 control-label" style="text-align:left" ng-hide="(vm.alertConfigurationHeader.eventType.nature==null)">({{vm.alertConfigurationHeader.eventType.nature}})</label></div><br><div class="row"><label class="col-md-3 control-label" cspl-mandatory>Branch</label><div class="col-md-5-5"><cspl-ach control-model="vm.alertConfigurationHeader.branch" control-id="txtBranch" lookup-name="branch" display-column="shortName" control-disabled="true" required form="alertConfigurationViewForm" control-value-change="vm.getUsers(vm.alertConfigurationHeader.branch)"></cspl-ach></div></div><br><div class="row"><label class="col-md-3 control-label" cspl-mandatory>When to notify</label><div class="col-md-5-5"><select class="form-control" name="reminder" ng-model="vm.alertConfigurationHeader.reminderType" ng-options="reminderType as reminderType.shortName for reminderType in vm.reminderType track by reminderType.id " ng-disabled="true" required></select></div><div class="col-md-1" style="width:12%"><cspl-numeric control-model="vm.alertConfigurationHeader.numberOfDaysToNotify" control-type="Number" no-of-decimals="0" control-max="99" control-id="txtNoOfDaysToNotify" form="alertConfigurationViewForm" ng-hide="vm.alertConfigurationHeader.eventType.nature!=\'Upcoming\'" control-disabled="true"></div><label class="col-md-2 control-label" style="text-align:left" ng-hide="vm.alertConfigurationHeader.eventType.nature!=\'Upcoming\'">days earlier</label></div><br><div class="row"><label class="col-md-3 control-label" cspl-mandatory>Notify whom</label><div class="col-md-5-5"><label class="control-label" for="radioRole" style="display: inline-block"><input type="radio" id="radioRole" ng-model="vm.alertConfigurationHeader.configNotifyUsersBy" name="Role" value="roles" ng-click="vm.userList=null" ng-disabled="true">&nbsp; Role</label>&emsp;<label class="control-label" for="radioUser" style="display: inline-block"><input type="radio" id="radioUser" ng-model="vm.alertConfigurationHeader.configNotifyUsersBy" name="User" value="users" ng-click="vm.roleList=null" ng-disabled="true">&nbsp; User</label></div></div><br><div class="row"><label class="col-md-2 control-label" style="width:24%"></label><div class="col-md-7" style="background-color:#EDEDEE; border-radius:6px"><ul style="list-style-type: none; margin: 0; padding: 0; overflow:auto" ng-hide="vm.alertConfigurationHeader.configNotifyUsersBy==\'roles\'"><li ng-repeat="user in vm.users | orderBy: \'shortName\'" style="margin-top:5px"><label><input type="checkbox" checklist-model="vm.userList" checklist-value="user.id" ng-disabled="true">&nbsp;{{user.login}} ({{user.email}})</label></li></ul><ul style="list-style-type: none; margin: 0; padding: 0" ng-hide="vm.alertConfigurationHeader.configNotifyUsersBy==\'users\'"><li ng-repeat="role in vm.roles | orderBy: \'shortName\'" style="margin-top:5px"><label><input type="checkbox" checklist-model="vm.roleList" checklist-value="role.id" ng-disabled="true">&nbsp;{{role.name}}</label></li></ul></div></div><br><div class="row"><label class="col-md-3 control-label" cspl-mandatory>Notify by</label><div class="col-md-6"><label style="margin-top: 10px" ng-repeat="NotifyType in vm.notifyByTypes | orderBy: \'shortName\'"><input type="checkbox" checklist-model="vm.notifyByTypeList" checklist-value="NotifyType.id" ng-disabled="true">&nbsp;<span style="margin-bottom:5px">{{NotifyType.shortName}}</span>&nbsp;&nbsp;&nbsp;&nbsp;</label></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.close">Close</span></button> <button type="button" ng-show="showDiscardButton" class="btn btn-reject" ng-click="vm.discardAlertConfiguration()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-show="showButton" class="btn btn-reject" ng-click="vm.rejectAlertConfiguration()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-show="showButton" class="btn btn-approve" ng-disabled="clicked" ng-click="vm.approveAlertConfiguration();clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div></div></div></form>');
$templateCache.put('app/components/alert-configuration/alert-configuration.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title">Alert Configuration</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="pull-right"><button type="button" class="btn btn-info active" ng-click="vm.screenLog.screenLog(vm.screenName, 0, \'ADD\'); vm.launch();"><span class="glyphicon glyphicon-plus"></span> <span>Alert Configuration</span></button></div></div><div class="row col-md-12"><fieldset class="well"><legend class="well-legend"><a class="collapse-module" data-toggle="collapse" href="#content-fx" aria-expanded="false" aria-controls="content-fx"><i aria-hidden="true" style="color:grey" class="toggling fa fa-chevron-circle-up"></i></a></legend><form class="-form" name="filterform"><div class="row"><label class="col-md-2 control-label">Branch</label><div class="col-md-4"><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="branch" display-column="shortName" required></cspl-ach></div><button type="button" class="btn btn-info active" ng-click="vm.getAlertConfigurationsByBranch(vm.branch)">Go</button></div></form></fieldset></div><div class="table-responsive"><table class="datatables-nosort table table-striped table-hover"><thead><tr><th>Event</th><th>Branch</th><th>Reminder</th><th>Notify By</th><th></th></tr></thead><tbody><tr ng-repeat="alertdetails in filterData = (vm.alertConfigurationHeader | filter : filterText | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{alertdetails.eventType.longName}}</td><td>{{alertdetails.branch.shortName}}</td><td>{{alertdetails.reminderType.longName}}</td><td>{{vm.getNotifyByTypes(alertdetails)}}</td><td style="text-align:center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ui-sref="alert-configuration.view({id: alertdetails.id})" ng-click="vm.screenLog.screenLog(vm.screenName, alertdetails.id, \'VIEW\')"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li><a ui-sref="alert-configuration.edit({id: alertdetails.id})" ng-click="vm.screenLog.screenLog(vm.screenName, alertdetails.id, \'EDIT\')"><span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></a></li><li><a ui-sref="alert-configuration.delete({id: alertdetails.id})" ng-click="vm.screenLog.screenLog(vm.screenName, alertdetails.id, \'DELETE\')"><span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="filterData.length > noOfRecordsPerPage"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/components/cspl-document-upload/cspl-document-upload.html','<style>#uploadFilesContainer::-webkit-scrollbar{\r\n\t    width: 4px;\r\n\t\theight: 6px;\r\n    }\r\n\r\n    #uploadFilesContainer::-webkit-scrollbar-corner{\r\n        background : #ffffff;\r\n    }</style><div class="row uploadDropContainer" id="dropContainer" ng-disabled="disableControl"><div class="dropContainerContent" id="dropContainerContent"><span data-translate="global.label.dragDrop"></span>&nbsp;<label class="browse-link" for="uploadPath" data-translate="global.label.browse"></label>&nbsp; <span data-translate="global.label.yourFiles"></span></div></div><div class="row"><span class="help-block-error" style="white-space: nowrap; text-align: left" ng-show="invalidPan">{{ invalidPanText}}</span></div><input type="file" id="uploadPath" name="uploadPath" ng-disabled="disableControl" class="form-control" ng-hide="true" accept="application/pdf,image/png,image/jpg,image/jpeg"><div id="uploadFilesContainer" style="width: 400px"><!-- <div class="col-md-12 col-xs-12  no-padding-left margin-bottom-xs"> --><div class="col-md-12 col-xs-12 no-padding-left margin-bottom-xs file-upload-name"><a ng-click="fileView()">{{viewFile.fileName}}</a><!-- <label class="no-padding-right" style="margin-left: 10px;" ng-show="showRemove" ng-click="removeFile();disableControl=false" --> <span ng-show="showRemove" class="icon file-sucsess"><a class="cspl-icon success-selection-icon"></a></span><label class="no-padding-right file-remove" style="margin-left: 10px" ng-show="showRemove" ng-click="removeFile();disableControl=false" uib-tooltip="Remove File" tooltip-placement="bottom" tooltip-append-to-body="true"><a class="cspl-icon remove-selection-icon"></a>&nbsp;Remove</label></div></div>');
$templateCache.put('app/components/execute-alert-notifications/execute-alert-notifications.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="gatewayApp.executeAlertNotifications.home.title"></span></h2><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="module-wrapper"><section class="module"><div class="row col-md-12"><fieldset class="well"><legend class="well-legend"><a class="collapse-module" data-toggle="collapse" href="#content-fx" aria-expanded="false" aria-controls="content-fx"><i aria-hidden="true" style="color: grey" class="toggling fa fa-chevron-circle-up"></i></a></legend><form class="form" name="executeform"><div class="row"><label class="col-md-2 control-label"><span data-translate="gatewayApp.executeAlertNotifications.date"></span></label><div class="col-md-3"><cspl-dtp control-model="vm.executeDate" control-id="dtpExecuteDate" control-max-date="vm.todayDate" form="executeform" required></cspl-dtp></div></div><br><div class="row"><label class="col-md-2 control-label"></label><div class="col-md-4"><input type="radio" id="radioAll" ng-model="vm.executeAllOrSpecific" name="All" value="all">&nbsp;<label class="control-label" for="radioAll"><span data-translate="gatewayApp.executeAlertNotifications.runAllAlerts"></span></label></div></div><div class="row"><label class="col-md-2 control-label"></label><div class="col-md-4"><input type="radio" id="radioSpecific" ng-model="vm.executeAllOrSpecific" name="Specific" value="specific">&nbsp;<label class="control-label" for="radioSpecific"><span data-translate="gatewayApp.executeAlertNotifications.specificAlerts"></span></label></div></div><br><div class="row"><label class="col-md-3 control-label"><span data-translate="gatewayApp.executeAlertNotifications.bank"></span></label><div class="col-md-4"><select class="form-control" ng-model="vm.corporate" ng-options="corporate as corporate.shortName for corporate in  vm.corporates track by corporate.id" ng-disabled="vm.executeAllOrSpecific==\'all\'" ng-change="vm.getBranchForCorporate(vm.corporate)" ng-required="vm.executeAllOrSpecific==\'specific\'"></select></div></div><br><div class="row"><label class="col-md-3 control-label"><span data-translate="gatewayApp.executeAlertNotifications.branch"></span></label><div class="col-md-4"><select class="form-control" ng-model="vm.branch" ng-options="branch as branch.shortName for branch in  vm.branches track by branch.id" ng-disabled="vm.executeAllOrSpecific==\'all\'" ng-required="vm.executeAllOrSpecific==\'specific\'"></select><!-- <cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="branch"\r\n\t\t\t\t\t\t\t\t\tdisplay-column="shortName" control-disabled="vm.executeAllOrSpecific==\'all\'" control-form="executeform" control-required="vm.executeAllOrSpecific==\'specific\'"></cspl-ach> --></div></div><br><div class="row"><label class="col-md-3 control-label"><span data-translate="gatewayApp.executeAlertNotifications.event"></span></label><div class="col-md-6"><select class="form-control" ng-model="vm.eventType" ng-options="eventType as eventType.shortName for eventType in  vm.eventTypes track by eventType.id" ng-disabled="vm.executeAllOrSpecific==\'all\'" ng-required="vm.executeAllOrSpecific==\'specific\'"></select></div></div><br><div class="row"><label class="col-md-2-5 control-label"></label><label class="col-md-3 control-label"></label><div class="col-md-4"><button type="button" class="btn btn-info active" ng-click="vm.executeAlertNotifications()" ng-disabled="executeform.$invalid"><span data-translate="gatewayApp.executeAlertNotifications.execute"></span></button></div></div></form></fieldset></div></section></div></div>');
$templateCache.put('app/components/login/login.html','<div class="Login-layout-no-leftnav"><section class="login-section auth-section"><div class="container"><div class="login-left"><div class="login-right-header dropdown-align"><div class="virtual-demo-dropdown"><div class="dropdown-content"><a ng-click="popup(demo.videoLink);" ng-repeat="demo in vm.virtualDemoDetails">{{demo.demoDisplayName}}</a></div></div></div></div><div class="login-right"><div class="login-right-header"><p class="margin-bottom-0"><span aria-hidden="true" class="icon"><img src="assets/images/Mail-20.png" style="height:20px; width:20px"></span>&nbsp; <span class="login-contact-font-size" data-translate="login.supportMail"></span></p><!-- commented below one to change the font separately for each number excluding OR matching to the login left image --><!-- <p class="margin-bottom-0"><span class="icon icon_headphones"></span>&nbsp;&nbsp;<span data-translate="login.supportContactNo"></span></p>--><p class="margin-bottom-0"><span aria-hidden="true" class="icon"><img src="assets/images/Support-20.png" style="height:20px; width:20px"></span>&nbsp; <span class="login-contact-font-size" data-translate="login.supportContactNo1"></span>&nbsp; <span data-translate="login.supportContactOR" style="font-size: 20px"></span>&nbsp; <span class="login-contact-font-size" data-translate="login.supportContactNo2"></span></p><p class="margin-bottom-0">&nbsp;&nbsp;<span class="login-timing-font-size" data-translate="login.businessTiming"></span></p><p></p></div><div class="mobile-virtual-demo-dropdown" ng-click="showDropDownContent();"><div id="demoContent" class="dropdown-content"><a ng-click="mobile_popup(demo.videoLink);" ng-repeat="demo in vm.virtualDemoDetails">{{demo.demoDisplayName}}</a></div></div><div class="administrator-logo" ng-if="!StringUtils.isBlank(vm.orgTypeParam)"></div><div class="form-box-inner" style="position: relative"><span class="" style="position: absolute;top: 0;right: 0;padding: 10px" ng-if=" vm.environmentName !=\'\' &&   vm.environmentName!=undefined &&   vm.environmentName!=null"><p class="btn-reg environment-name">{{vm.environmentName}}</p></span><h2 style="margin-bottom:10%; color:#114272" class="title text-center" data-translate="login.title"></h2><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to login!</strong><br>Please check your credentials and try again.</div><div class="alert alert-danger" ng-show="vm.recaptchaError"><strong>Failed to login!</strong><br>ReCaptcha Validation Failed.</div><div class="alert alert-danger" ng-show="vm.LockError" data-translate="login.messages.error.locked"><strong>Failed to login!</strong><br>User is locked.</div><div class="alert alert-danger" ng-show="vm.dormantError" data-translate="login.messages.error.dormant"><strong>Failed to login!</strong> Dormant User and account is locked. Please proceed to unlock your account.</div><div class="alert alert-danger" ng-show="vm.tradingNotActivatedError" data-translate="login.messages.error.tradingNotActivated"><strong>Failed to login!</strong><br>Trading would be activated from next working day.</div><div class="alert alert-danger" ng-show="vm.userSuspendedError" data-translate="login.messages.error.userSuspended"><strong>Failed to login!</strong><br>User is suspended.</div><div class="alert alert-danger" ng-show="vm.userEntitySuspendedError" data-translate="login.messages.error.userEntitySuspended"><strong>Failed to login!</strong><br>User Entity is suspended.</div><div class="alert alert-danger" ng-show="vm.noActiveBankRelationship" data-translate="login.messages.error.noActiveBankRelationship"><strong>Failed to login!</strong><br>User Entity is suspended.</div><div class="alert alert-danger" ng-show="vm.passwordExpiryError"><strong>Failed to login!</strong><br>Password is expired. <a ui-sref="change-password-expiry({login: vm.username, orgType : vm.orgTypeParam})">Change password</a></div><div class="alert alert-danger" ng-show="vm.activationError"><span data-translate="login.messages.error.userNotActivated"></span>&nbsp;<a ng-click="vm.resendActivationKey()"><span data-translate="login.form.clickHere"></span></a>&nbsp;<span data-translate="login.messages.info.resendActivation"></span></div><div class="alert alert-success" ng-show="vm.activationResendSuccess" data-translate="login.messages.info.activateResendSuccess">Please check you email for activation</div><div class="alert alert-info" ng-show="vm.sendOTPSuccess && !vm.authenticationError" data-translate="login.messages.info.sendOtpSuccess"></div><div class="alert alert-info" ng-show="vm.resendOTPSuccess" data-translate="login.messages.info.resendOtpSuccess"></div><div class="alert alert-danger" ng-show="vm.maximumExceedCaptcha"><strong>Failed to login!</strong><br>{{vm.MaximumExceedCountTime}}</div><div class="alert alert-danger" ng-show="vm.invalidCaptcha" data-translate="login.messages.error.invalidCaptcha"></div><div class="alert alert-danger" ng-show="vm.maximumRefreshExceedCaptcha">Too Many Captcha Request.<br>Please Try After {{ vm.restrictedOTPandEmailIntervalInSeconds }} Seconds.</div><div class="alert alert-danger" ng-show="vm.otpFailed"><strong>Failed to login!</strong><br>Incorrect OTP.</div><div class="alert alert-danger" ng-show="vm.userBlocked"><strong>Failed to login!</strong><br>{{vm.userBlockedError}}</div><div class="alert alert-danger" ng-show="vm.userDelinkedError" data-translate="login.messages.error.userDelinkedError"><strong>Failed to login!</strong><br>Account is not linked with any entity.</div><div class="row" ng-show="!vm.confirmOTP" style="margin-top: -1vh"><div class="auth-section-form-container"><form class="login-form" name="loginform" ng-submit="vm.clicked = true; vm.login($event);"><div class="form-group" style="margin-bottom: 2%"><label style="color:#414040" class="control-label" data-translate="login.form.user.placeholder">Email or Mobile or Login Name</label><div class="row" style="border-bottom: 1px solid #fdfcfc; padding-bottom: 2px"><div class="col-xs-11" style="padding-left:0 !important"><input id="login-email" name="username" type="text" autocomplete="off" ng-model="vm.username" class="form-control" ng-blur="vm.showAlert = false" ng-focus="vm.showAlert = true" style="width: 112%; height: 35px; border-radius: 7px; border: 1px solid #414040; margin-top: 5px; font-size: 13px" required></div></div><div class="login-mobile-info" ng-show="vm.showAlert"><span>If mobile no. exclude country code</span></div></div><!-- <div class="form-group">\r\n                                        <span  style= "color:#414040;" class="icon_key icon"></span>\r\n                                        <label style= "color:#414040;" class="control-label" data-translate="login.form.password.placeholder">Password</label>\r\n                                    \t<div class="row" style="border-bottom: 1px solid #ffffff; padding-bottom: 2px;">\r\n                                        <div class="col-xs-10">\r\n                                        <input id="login-password" name="password" type="{{vm.controlType}}" autocomplete="off" ng-model="vm.password" class="form-control login-password" style="width: 105%; height: 42px; padding: 10px; border-radius: 8px; border: 1px solid #414040; margin-top: 5px; font-size: 14px;" required />\r\n                                        </div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-xs-1">\r\n\t\t\t\t\t\t\t\t\t\t\t<button type="button" tabindex="-1" class="btn btn-primary"\r\n\t\t\t\t\t\t\t\t\t\t\tstyle="border:0px; color: #262626; background: #F7F7F7; outline:none;"\r\n\t\t\t\t\t\t\t\t\t\t\tng-click="vm.showPwd(vm.controlType)" ><img ng-src=\'assets/images/Password Visibility-18.png\' alt="Show Password"/></button>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n                                      </div> --><div class="form-group" style="margin-bottom: 2%"><label style="color:#414040" class="control-label margin-bottom-xs" data-translate="login.form.password.placeholder">Password</label><div class="row" style="border: 1px solid #dadae7; border-radius: 8px ;border-color:#414040"><div class="col-xs-9 col-md-10"><input id="login-password" name="password" type="{{vm.controlType}}" autocomplete="off" ng-model="vm.password" class="form-control login-password" style="border:0px; color:#414040 !important" required></div><div class="col-xs-1 col-md-1"><button type="button" tabindex="-1" class="btn btn-primary show-password-button" style="border:0px; background: #ffffff; outline:none" ng-click="vm.showPwd(vm.controlType)"><img ng-src="assets/images/Eye.png"></button></div></div></div><!-- Captcha Label --><div ng-if="vm.skipCaptchaVerification == \'No\'"><label class="control-label margin-bottom-xs" data-translate="login.form.captcha" style="color:#414040">Captcha</label><div class="row"><div class="col-md-6 col-sm-12 captcha-image-container"><input type="text" autocomplete="off" ng-model="vm.captchaText" class="form-control" style="border:0px; background:#ffffff" ng-disabled="vm.disableCaptcha" ng-keydown="vm.onCaptchaKeydown($event)" required></div><div class="col-md-6 col-sm-11 custom-captcha-margin"><div><img class="captcha-image" ng-src="{{vm.captchaImageData}}" alt="Captcha"> <span class="refreshButton"><i class="fa" ng-class="{\r\n\t\t\t\t\t\t\t\t\t\t\t\t\'fa-refresh\': !vm.refreshInprogress,\r\n\t\t\t\t\t\t\t\t\t\t\t\t\'fa-refresh fa-spin\': vm.refreshInprogress\r\n\t\t\t\t\t\t\t\t\t\t\t}" ng-click="vm.refreshCaptcha()" style="font-size:20px" uib-tooltip="Refresh" tooltip-placement="bottom"></i></span></div></div></div></div><!-- <div class="form-group">\r\n\r\n\t \t\t\t\t\t\t\t\t\t<p class="forgot-password" style="margin-top: 0px;"><a  href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot" tabindex="-1">Forgot password?</a></p>\r\n\t\t\t\t\t\t\t\t\t\t <p class="unlock-account" ><a ng-click="vm.requestUnlockUser()" data-translate="login.password.lock">Forgot password?</a></p>\r\n\t\t\t\t\t\t\t\t\t\t <label ng-if="vm.showSkipOTP" class="col-xs-3 control-label" for="isSkiptOTP" style="color:#C4C4C4; text-align:center; padding: 3.5vh 0 0.0vh 0;">Skip OTP</label>\r\n\t\t\t\t\t\t\t\t\t\t <div class="col-xs-1" ng-if="vm.showSkipOTP">\r\n\t\t\t\t\t\t\t\t\t\t\t <input type="checkbox" style="margin-top:1vh;" ng-model="vm.skipOTP" id="isSkiptOTP" />\r\n\t\t\t\t\t\t\t\t\t\t </div>\r\n\t\t\t\t\t\t\t\t\t\t</div> --><div class="form-group row"><!-- Forgot password always right --><div class="col-xs-12"><p class="forgot-password" style="margin: 0"><a href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot" tabindex="-1">Forgot password?</a></p><p class="unlock-account"><a ng-click="vm.requestUnlockUser()" data-translate="login.password.lock">Forgot password?</a></p><p></p></div><!-- Skip OTP (only when true, centered) --><div class="col-xs-12 text-center" ng-if="vm.showSkipOTP"><label for="isSkiptOTP" style="color:#C4C4C4; margin-right: 5px">Skip OTP</label><input type="checkbox" ng-model="vm.skipOTP" id="isSkiptOTP"></div></div><div class="col-xs-12" style="display:flex;justify-content:center"><button type="submit" class="btn btn-block btn-primary text-center" style="width: 60%; border-radius:18px" data-translate="login.form.button" ng-disabled="loginform.$invalid || vm.clicked">Sign in</button></div><!-- <div class="row">\r\n \t\t\t\t\t\t\t\t\t\t<div class="col-xs-5">\r\n \t\t\t\t\t\t\t\t\t\t<span style="color: #000;" data-translate="login.form.newCustomer"></span><br/><a ui-sref="customerRegistration" data-translate="login.form.registerHere">Register Customer</a>\r\n \t\t\t\t\t\t\t\t\t\t</div>\r\n\r\n \t\t\t\t\t\t\t\t\t\t<div class="col-xs-offset-3 col-xs-4">\r\n \t\t\t\t\t\t\t\t\t\t<span style="visibility: hidden;"><a ng-click="vm.openHelp()" data-translate="login.form.needHelp">Need Help</a></span>\r\n \t\t\t\t\t\t\t\t\t\t</div>\r\n \t\t\t\t\t\t\t\t</div> --></form></div></div><div class="row" ng-show="vm.confirmOTP"><div class="auth-section-form-container"><form class="login-otp" name="otpform"><div class="form-group email"><label class="sr-only" for="login-otp">OTP</label><span class="control-label">Enter your OTP here</span><br><div class="col-md-6" id="otp" control-model="vm.otp" otp-input-directive options="otpInput"></div></div><br><div class="row" ng-hide="vm.userBlocked"><label class="help-block col-md-6 col-md-offset-1"><a style="margin-right:2%" href="" ng-click="vm.resendOTP()">Resend</a></label></div><div class="row"><label class="col-md-12"><span class="help-block text-left" data-translate="login.messages.info.helpText"></span></label></div><button class="btn btn-block btn-primary" data-translate="login.form.verify" ng-disabled="vm.otp==null || vm.otp==\'\' || vm.clicked" ng-click="vm.clicked=true; vm.loginWithOTP();">Confirm</button></form></div></div></div><div ng-if="StringUtils.isBlank(vm.orgTypeParam)"><div style="margin-bottom: 3%"><p class="new-cutomer" style="color: #000" data-translate="login.form.newCustomer" ng-show="!vm.confirmOTP"></p><p class="col-xs-4 col-centered" style="display:flex;justify-content:center" ng-show="!vm.confirmOTP"><button class="btn btn-block btn-primary btn-reg" style="width: 90%; border-radius:18px" data-translate="login.form.registerHere" ng-click="vm.openCustomerOnboarding();">Register Customer</button></p><p class="resubmit-application" ng-show="!vm.confirmOTP"><a ng-click="vm.resubmitApplication()" data-translate="login.form.resubmitApplication">Resubmit Application?</a></p></div><div class="col-xs-12 version-no" style="background-color: #ffffff;margin-top:-1px"><span class="version-no" style="padding-right:0px">Version {{vm.versionNo}}</span></div><div style="margin-top: 1%;margin-bottom: 2%; background-color: #DAE3F3; padding-bottom:5px"><p style="text-align:center;margin:0%; background-color: #DAE3F3" ng-show="!vm.confirmOTP"><span><img ng-src="assets/images/Globe.png"></span><!-- <span class="more-info-link" style="color: #000; margin-right: 20px;" data-translate="login.form.forMoreInfo" ng-click="openurl(vm.cCILWebsite)"></span> --> <span class="more-info-link" style="margin-right: 6px"><a ng-click="openurl(vm.cCILWebsite)" data-translate="login.form.websiteLink"></a></span> <span><img ng-src="assets/images/Chat.png"></span><!-- <span class="more-info-link" style="color: #000;" data-translate="login.form.rbiCircular" ng-click="openurl(vm.rbiCircularWebsite)"></span> --> <span class="more-info-link"><a ng-click="openurl(vm.rbiCircularWebsite)" data-translate="login.form.rbiCircularLink"></a></span></p><p style="text-align:center;margin: 0%" ng-show="!vm.confirmOTP"><span><img ng-src="assets/images/Link.png"></span><span class="more-info" style="color: #000" data-translate="login.form.forGrievence"></span> <span class="more-info-link"><a ng-click="openurl(vm.rbiCmsWebsite)" data-translate="login.form.cmsLink"></a> </span><span style="color: #000">| </span><span class="more-info-link"><a ng-click="openurl(vm.grievancePortal)" data-translate="login.form.grievanceLink"></a></span></p></div></div><div ng-if="!StringUtils.isBlank(vm.orgTypeParam)" class="col-xs-12 version-no" style="background-color: #ffffff;margin-top:-1px"><span class="version-no" style="padding-right:0px">Version {{vm.versionNo}}</span></div><div class="video-popup"><div class="popup-content"><button class="close-btn"><i class="fa fa-close" style="font-size:15px"></i></button><video id="popup-video" src="" class="video popup-video" preload="auto" controlslist="nodownload" controls></video><div id="playButton" class="play-button"></div></div></div><div class="video-popup-iframe"><div class="popup-content-iframe"><button class="close-btn"><i class="fa fa-close" style="font-size:15px"></i></button><iframe id="popup-iframe" src="" class="video" sandbox="allow-same-origin allow-scripts allow-presentation" allowfullscreen></iframe></div></div><div class="mobile-video-popup-iframe"><div class="mobile-popup-content"><button class="mobile-close-btn"><i class="fa fa-close" style="font-size:15px"></i></button><iframe id="mobile-popup-iframe" src="" class="mobile-video" sandbox="allow-same-origin allow-scripts allow-presentation" allowfullscreen></iframe></div></div><div class="mobile-video-popup"><div class="mobile-popup-content"><button class="mobile-close-btn"><i class="fa fa-close" style="font-size:15px"></i></button><video id="mobile-popup-video" src="" class="mobile-video popup-video" preload="auto" controlslist="nodownload" controls></video></div></div></div></div></section></div><!-- commented due to redirect page happens from fxretail to netcoreads 29-03-2022\r\n <iframe src="https://netcoreads.com/dmp/jsv2/ifrm.html?pixelName=FX_Homepage&event=Visit%20(Landing%20Page)&eventName=FX_Homepage" WIDTH=0 HEIGHT=0></iframe> -->');
$templateCache.put('app/components/manage-faq/faq-category-dialog.html','<form name="faqForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><span data-translate="gatewayApp.faq.home.addCategory"></span></h4></div><div class="modal-body"><div class="content"><fieldset ng-disabled="vm.disableForm"><div class="row"><label class="col-md-2 control-label" cspl-mandatory>Category</label><div class="col-md-10"><cspl-text control-model="vm.name" control-maxlength="100" control-id="txtCategory" form="faqForm" required></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-hide="showButton" ng-disabled="faqForm.$invalid || clicked" class="btn btn-info active" ng-click="vm.save();clicked = true;"><span data-translate="entity.action.save">Save</span></button></div></div></div></form>');
$templateCache.put('app/components/manage-faq/faq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.faq.id)"><div class="modal-header-red"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" style="text-align:left;padding-left:3%"><span data-translate="gatewayApp.faq.home.delete"></span></h4></div><nmb-alert-error></nmb-alert-error><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel"></span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger" ng-click="vm.deletefaq()"><span data-translate="entity.action.delete"></span></button></div></div></form>');
$templateCache.put('app/components/manage-faq/faq-details.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="gatewayApp.faq.home.title"></span></h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="pull-right"><button type="button" class="btn btn-info active" ng-click="vm.addCategory()"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gatewayApp.faq.category"></span></button> <button type="button" class="btn btn-info active" ng-click="vm.launch()"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gatewayApp.faq.detail.title"></span></button></div></div><div class="row col-md-12"><fieldset class="module"><form class="-form" name="filterform"><div class="row"><label class="col-md-1 control-label"><span data-translate="gatewayApp.faq.category"></span></label><div class="col-md-4"><select class="form-control" id="field_faqdetails" name="faqdetails" ng-model="vm.faqcategorynameselected" ng-change="vm.filterfaqcategory()" ng-disabled="vm.loadincomplete"><option ng-repeat="CategoryList in vm.faqcategorylistfromJSONFile | orderBy: \'name\'" ng-value="CategoryList.name">{{CategoryList.name}}</option></select></div></div></form></fieldset></div><div class="table-responsive"><label style="margin-left:10px; font-size:120%; font-weight: bold; float:left; width:80%">{{vm.faqcategorynameselected}}</label><table class="datatables-nosort table table-striped table-hover"><thead ng-hide="true"><tr><th></th><th></th></tr></thead><tbody><tr ng-repeat="secfaqdetails in filterData = (vm.faqdetailsfiltered | filter : filterText | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td ng-hide="vm.edited === $index">{{secfaqdetails.question}}</td><td style="text-align:center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitFaqViewEntityAction" ng-hide="vm.edited === $index" ng-click="vm.filterfaq(secfaqdetails)"><a ui-sref="manage-faq.view()"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitFaqEditEntityAction" ng-hide="vm.edited === $index" ng-click="vm.filterfaq(secfaqdetails)"><a ui-sref="manage-faq.edit()"><span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></a></li><li ng-show="vm.permitFaqDeleteEntityAction" ng-hide="vm.edited === $index" ng-click="vm.filterfaq(secfaqdetails)"><a ui-sref="manage-faq.delete()"><span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="filterData.length > noOfRecordsPerPage"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/components/manage-faq/faq-dialog.html','<form name="faqForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><span data-translate="gatewayApp.faq.home.add"></span></h4></div><div class="modal-body"><div class="content"><fieldset ng-disabled="vm.disableForm"><div class="row"><div class="row"><label class="col-md-2 control-label" cspl-mandatory><span data-translate="gatewayApp.faq.question"></span></label><div class="col-md-10"><cspl-multiline-text control-model="vm.question" control-placeholder="Enter a question" control-maxlength="1000" control-id="txtQuestion" form="faqForm" required></div></div><div class="row"><label class="col-md-2 control-label" cspl-mandatory><span data-translate="gatewayApp.faq.answer"></span></label><div class="col-md-10"><cspl-multiline-text control-model="vm.answer" placeholder="Enter the appropriate answer" control-id="txtAnswer" control-maxlength="7000" form="faqForm" required></div></div><div class="row"><lable class="col-md-2 control-label" for="field_chkVideoAvailable"><span data-translate="gatewayApp.faq.video"></span>&nbsp;&nbsp;&nbsp;</lable><div class="col-md-10"><input type="file" id="field_VideoFileName" file-model="vm.videofileforupload" accept=".mp4" style="margin-top: 5px" onchange="angular.element(this).scope().uploadVideoFile()"></div></div><div class="row"><lable class="col-md-2 control-label" for="field_chkTemplateAvailable"><span data-translate="gatewayApp.faq.template"></span>&nbsp;&nbsp;&nbsp;</lable><div class="col-md-10"><input type="file" id="field_TemplateFileName" file-model="vm.templatefileforupload" accept=".xlsx" style="margin-top: 5px" onchange="angular.element(this).scope().uploadTemplateFile()"></div></div><div class="row" style="margin: 5px 0px 5px 0px"><label class="col-md-2 control-label" cspl-mandatory><span data-translate="gatewayApp.faq.category"></span></label><div class="col-md-10" style="background-color:#EDEDEE; border-radius: 6px; width:80%; margin-left:10px"><label style="margin-top: 3px" ng-repeat="CategoryList in vm.faqcategorylistfromJSONFile | orderBy: \'name\'"><input type="checkbox" checklist-model="vm.selectedfaqcat" checklist-value="CategoryList.name"><span style="margin-bottom:2px">{{CategoryList.name}}</span>&nbsp;&nbsp;&nbsp;&nbsp;</label></div></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel"></span></button> <button type="submit" ng-hide="showButton" ng-disabled="faqForm.$invalid || (vm.selectedfaqcat==null || vm.selectedfaqcat==\'\') || clicked" class="btn btn-info active" ng-click="vm.save();clicked = true;"><span data-translate="entity.action.save"></span></button></div></div></div></form>');
$templateCache.put('app/components/manage-faq/faq-edit-dialog.html','<form name="faqForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><span data-translate="gatewayApp.faq.home.edit"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><fieldset ng-disabled="vm.disableForm"><div class="row"><div class="row"><label class="col-md-2 control-label" cspl-mandatory><span data-translate="gatewayApp.faq.question"></span></label><div class="col-md-10"><cspl-multiline-text control-model="vm.editquestion" control-maxlength="500" control-id="txtQuestion" control-form="faqForm" required></div></div><div class="row"><label class="col-md-2 control-label" cspl-mandatory><span data-translate="gatewayApp.faq.answer"></span></label><div class="col-md-10"><cspl-multiline-text control-model="vm.editanswer" control-id="txtAnswer" control-maxlength="7000" control-form="faqForm" required></div></div><div class="row"><label class="col-md-2 control-label" for="field_chkVideoAvailable"><span data-translate="gatewayApp.faq.video"></span>&nbsp;&nbsp;&nbsp;</label><div class="col-md-10"><input type="file" id="field_VideoFileName" file-model="vm.videofileforupload" accept=".mp4" onchange="angular.element(this).scope().uploadVideoFile()" style="margin-top: 5px" form="faqForm"></div></div><div class="row" ng-show="(vm.editvideofilename !=\'\')"><lable class="col-md-2 control-label"></lable><div class="col-md-10"><label ng-bind="\'Current Video : \' + vm.editvideofilename"></label>&nbsp; <a style="text-decoration: none" ng-click="vm.RemoveVideo()"><span class="icon icon_close_alt"></span></a></div></div><div class="row"><label class="col-md-2 control-label" for="field_chkTemplateAvailable"><span data-translate="gatewayApp.faq.template"></span>&nbsp;&nbsp;&nbsp;</label><div class="col-md-10"><input type="file" id="field_TemplateFileName" file-model="vm.templatefileforupload" accept=".xlsx" onchange="angular.element(this).scope().uploadTemplateFile()" style="margin-top: 5px"></div></div><div class="row" ng-show="(vm.edittemplatefilename !=\'\')"><lable class="col-md-2 control-label"></lable><div class="col-md-10"><label ng-bind="\'Current Template : \' + vm.edittemplatefilename"></label>&nbsp; <a style="text-decoration: none" ng-click="vm.RemoveTemplate()"><span class="icon icon_close_alt"></span></a></div></div><div class="row" style="margin: 5px 0px 5px 0px"><label class="col-md-2 control-label" cspl-mandatory><span data-translate="gatewayApp.faq.category"></span></label><div class="col-md-10" style="background-color:#EDEDEE; border-radius: 6px; width:80%; margin-left:10px"><label style="margin-top:3px" ng-repeat="CategoryList in vm.faqcategorylistfromJSONFile | orderBy: \'name\'"><input type="checkbox" checklist-model="vm.editcategorylist" checklist-value="CategoryList.name"><span style="margin-bottom:2px">{{CategoryList.name}}</span>&nbsp;&nbsp;&nbsp;&nbsp;</label></div></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel"></span></button> <button type="submit" ng-hide="showButton" ng-disabled="faqForm.$invalid || (vm.editquestion==null || vm.editquestion==\'\') || (vm.editanswer==null || vm.editanswer==\'\') || (vm.editcategorylist==null || vm.editcategorylist==\'\') || clicked" class="btn btn-info active" ng-click="vm.edit();clicked = true;"><span data-translate="entity.action.save"></span></button></div></div></div></form>');
$templateCache.put('app/components/manage-faq/faq-view-dialog.html','<form name="faqForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><span data-translate="gatewayApp.faq.home.view"></span></h4></div><div class="modal-body"><div class="content"><fieldset ng-disabled="vm.disableForm"><div class="row"><div class="row"><label class="col-md-2 control-label" cspl-mandatory><span data-translate="gatewayApp.faq.question"></span></label><div class="col-md-10"><cspl-multiline-text control-model="vm.faq.question" control-type="Text" control-maxlength="500" control-id="txtQuestion" form="faqForm" control-disabled="true"></div></div><div class="row"><label class="col-md-2 control-label" cspl-mandatory><span data-translate="gatewayApp.faq.answer"></span></label><div class="col-md-10"><cspl-multiline-text control-model="vm.faq.answer" control-id="txtAnswer" control-maxlength="7000" form="faqForm" control-disabled="true"></div></div><div class="row" ng-hide="(vm.faq.videofilename==null || vm.faq.videofilename==\'\')"><lable class="col-md-2 control-label" for="field_chkVideoAvailable"><span data-translate="gatewayApp.faq.video"></span>&nbsp;&nbsp;&nbsp;</lable><div class="col-md-10"><lable class="control-label" for="field_chkVideoAvailable" id="field_videoFileName">{{vm.faq.videofilename}}</lable>&nbsp;&nbsp;&nbsp;&nbsp; <a ui-sref="manage-faq-openvideo({videofilename: vm.faq.videofilename})"><span data-translate="gatewayApp.faq.openVideo"></span></a></div></div><div class="row" ng-hide="(vm.faq.templatefilename==null || vm.faq.templatefilename==\'\')"><lable class="col-md-2 control-label" for="field_chkTemplateAvailable"><span data-translate="gatewayApp.faq.template"></span>&nbsp;&nbsp;&nbsp;</lable><div class="col-md-10"><lable ng-disabled="vm.faq.templatefilename==\'\'" class="control-label" for="field_chkTemplateAvailable" id="field_TemplateFileName" style="margin-top: 5px">{{vm.faq.templatefilename}}</lable>&nbsp;&nbsp;&nbsp;&nbsp; <a ng-click="vm.downloadTemplate(vm.faq.templatefilename)"><span data-translate="gatewayApp.faq.downloadTemplate"></span></a></div></div><div class="row" style="margin: 5px 0px 5px 0px"><label class="col-md-2 control-label" cspl-mandatory><span data-translate="gatewayApp.faq.category"></span></label><div class="col-md-10" style="background-color:#EDEDEE; border-radius: 6px; width:80%; margin-left:10px"><label style="margin-top:3px" ng-repeat="CategoryList in vm.faqcategorylistfromJSONFile | orderBy: \'name\'"><input type="checkbox" checklist-model="vm.faq.categorylist" checklist-value="CategoryList.name" ng-disabled="true"><span style="margin-bottom:2px">{{CategoryList.name}}</span>&nbsp;&nbsp;&nbsp;&nbsp;</label></div></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.close"></span></button></div></div></div></form>');
$templateCache.put('app/components/search-faq/faq-video.html','<form name="searchFaq" role="form" novalidate><div class="modal-header"><h4 class="modal-title">Gateway Desk</h4></div><div class="modal-body"><div class="content"><video id="vdMain" class="videoElement" width="100%" height="240" controls><source id="srcMain" src="" type="video/mp4">Your browser does not support the video tag.</video><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.close">Close</span></button></div></div></div></form>');
$templateCache.put('app/components/search-faq/search-faq.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title">Gateway Desk</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row" style="margin-top:20px"><div class="col-md-8" style="width:70%"><input class="form-control" width="600" type="search" placeholder="Search gateway desk" class="form-control" name="question_hint" id="question_hint" ng-disabled="vm.loadincomplete" ng-model="vm.questionHint" ng-keydown="vm.searchFaqByEnter($event)"></div><button style="width:9%" class="btn btn-info active" type="button" ng-click="vm.searchFaq(vm.questionHint); ">Search</button></div><br><div class="row"><section style="width:80%; float:left"><div class="col-md-8" style="width:70%"><label style="font-size:120%; font-weight: bold; float:left">{{vm.faqcategory}}</label></div><div class="table-responsive"><table class="datatables-nosort table table-striped table-hover" style="width:100%" cursor: pointer; ng-if="vm.faqdetailsfiltered.length > 0"><thead ng-hide="true"><th></th><th></th><th></th></thead><tbody ng-init="faqDTO.expanded = false" ng-repeat="faqDTO in vm.filterData = (vm.faqdetailsfiltered | filter : vm.isExpanded | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><!-- \t\t\t\t\t\t<span ng-bind-html="vm.highlight(faqDTO.question, vm.questionHint)"></span> --><tr><!-- \t\t\t\t\t\t\t\t<td width="10"><button ng-show="faqDTO.expanded" --><!-- \t\t\t\t\t\t\t\t\t\tng-click="faqDTO.expanded = false">-</button> --><!-- \t\t\t\t\t\t\t\t\t<button ng-show="!faqDTO.expanded" --><!-- \t\t\t\t\t\t\t\t\t\tng-click="faqDTO.expanded = true">+</button>  --><!-- \t\t\t\t\t\t\t\t</td> --><td width="10"><a style="text-decoration:none" ng-show="faqDTO.expanded" ng-click="faqDTO.expanded = false"><span style="color:#858585" class="icon icon_minus_alt"></span></a> <a style="text-decoration:none" ng-show="!faqDTO.expanded" ng-click="faqDTO.expanded = true"><span style="color:#858585" class="icon icon_plus_alt"></span></a></td><td ng-click="faqDTO.expanded = !faqDTO.expanded" style="font-weight: bold" ng-bind-html="vm.highlight(faqDTO.question, vm.questionHint)">{{faqDTO.question}}</td><td style="text-align:right"><div class="btn-group utility" ng-show="(faqDTO.expanded == 1 && faqDTO.videofilename != null && faqDTO.videofilename != \'\') || (faqDTO.expanded == 1 && faqDTO.templatefilename != null && faqDTO.templatefilename != \'\')" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsLgMenualignment" uib-dropdown-menu><li ng-show="(faqDTO.expanded == 1 && faqDTO.videofilename != null && faqDTO.videofilename != \'\') "><a style="text-align:right" ui-sref="search-faq.view({videofilename:faqDTO.videofilename})"><span class="hidden-xs hidden-sm" data-translate="entity.action.openvideo"></span></a></li><li ng-show="(faqDTO.expanded == 1 && faqDTO.templatefilename != null && faqDTO.templatefilename != \'\')" ng-click="vm.downloadTemplate(faqDTO.templatefilename)"><a style="text-align:right"><span class="hidden-xs hidden-sm" data-translate="entity.action.downloadtemplate"></span></a></li></ul></div></td></tr><tr ng-show="faqDTO.expanded"><td width="10"></td><td><span style="line-height:2" ng-bind-html="vm.highlight(faqDTO.answer, vm.questionHint)">{{faqDTO.answer}}</span></td><td style="text-align:center"></td></tr></tbody></table><div ng-show="vm.faqdetailsfiltered.length > noOfRecordsPerPage"><cspl-pagination record-count="vm.filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></section><aside style="width:20%; float: right"><div class="row search-faq-category" ng-hide="vm.loadincomplete"><ul style="list-style: none; margin-left:-25px"><li><span style="font-size:120%; font-weight: bold; line-height:1.5">Category</span></li></ul><ul ng-repeat="categoerylist in vm.faqcategorylistfromJSONFile | orderBy: \'name\'" style="list-style: none; margin-left:-25px"><li style="line-height:1"><a ng-click="vm.filterfaqcategory(categoerylist.name);"><b><u>{{categoerylist.name}}</u></b></a></li></ul></div></aside></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/components/workflow/rejection_reason.html','<form name="deleteForm" ng-submit="vm.confirm()"><div class="modal-header-red"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" style="text-align:left;padding-left:3%" data-translate="global.form.rejectionReason">Rejection Reason</h4></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><!-- <p>\r\n    \t<cspl-multiline-text control-model = "vm.reason" control-placeholder="Please provide a reason" control-rows="6" \r\n    \t\tcontrol-maxlength="1000" control-id="txtRejectionReason" form="deleteForm" required autofocus></cspl-multiline-text>\r\n    </p> --><p><textarea name="txtReason" class="form-control modal-header-red" placeholder="Please provide a reason" ng-model="vm.reason" rows="6" required></textarea></p><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" tabindex="-1" ng-click="vm.clear()"><span data-translate="global.form.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><span data-translate="global.form.reject">Reject</span></button></div></div></div></form>');
$templateCache.put('app/dashboard/1/dashboard.html','<div ncy-breadcrumb class="row" style="margin-left: 10px"></div><nmb-alert></nmb-alert><div class="row" style="margin-left: 10px"><div class="col-lg-12"><section class="item" style="padding:5px"><div class="panel panel-primary"><div class="panel-heading text-center"><span data-translate="global.menu.dashboard.todo"></span> <a href="" style="position: relative;float:right;  color: #fff"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><div class="panel-body"><div class="module-content-inner"><nmb-alert-error></nmb-alert-error><div class="table-responsive" ng-show="vm.tasks.length==0 "><span style="color: #7f7f7f" data-translate="gatewayApp.dashboard.home.nopendingactions ">No Pending Actions</span></div><div class="table-responsive" ng-show="vm.tasks.length> 0"><h3 class="view-heading">For My Action</h3><table class="dataTable table table-striped table-hover"><thead><tr><th>Action</th><th>Taken on</th><th>For</th><th>On</th><th>By</th><th nowrap="nowrap">Reason For Rejection</th><th>-</th></tr></thead><tbody><tr ng-repeat="taskList in filterData = (vm.tasks| orderBy:\'-lastModifiedDate\' | filter:customFilter) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td nowrap="nowrap">{{taskList.changeType}}</td><td style="word-break:break-word" width="30%">{{taskList.entity.name}} | {{taskList.entityShortName}}</td><td nowrap="nowrap" width="10%">{{taskList.owner}}</td><td nowrap="nowrap" width="15%">{{taskList.createdDate | date:\'dd-MM-yyyy HH:mm:ss\'}}</td><td nowrap="nowrap" width="20%">{{taskList.createdBy}}</td><td style="min-width:20%;word-wrap:break-word">{{taskList.reason}}</td><td><div class="btn-group utility" uib-dropdown dropdown-append-to-body="true" ng-show="(taskList.lastModifiedBy!=vm.userLogin)&&(taskList.changeType!=\'Rejected\' )"><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ng-click="vm.viewEntity(taskList.entity.shortName,taskList.id,taskList.payload,\'checker\', taskList.changeType,taskList.entityRecordID,taskList.entityShortName, taskList.taskAction)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li><a ng-click="vm.rejectEntity(taskList)"><span class="hidden-xs hidden-sm" data-translate="entity.action.reject"></span></a></li><li><a ng-click="vm.approveEntity(taskList)"><span class="hidden-xs hidden-sm" data-translate="entity.action.approve"></span></a></li></ul></div><div class="btn-group utility" uib-dropdown dropdown-append-to-body="true" ng-show="(taskList.changeType == \'Rejected\')"><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ng-click="vm.viewEntity(taskList.entity.shortName,taskList.id,taskList.payload,\'maker\', taskList.changeType,taskList.entityRecordID,taskList.entityShortName,  taskList.taskAction)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li><a ng-click="vm.discardEntity(taskList)"><span class="hidden-xs hidden-sm" data-translate="entity.action.discard"></span></a></li><li ng-hide="taskList.entityShortName == \'BankImport\' || taskList.entityShortName == \'BranchImport\' || taskList.entityShortName==\'MarkupImport\' || taskList.entityShortName==\'LimitSettingsImport\'\r\n                                          \t           \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t || taskList.entityShortName==\'AMCImport\' || taskList.entityShortName==\'CustomerChargesImport\'\r\n                                          \t           \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t || taskList.entityShortName==\'GSTSettingsImport\' || taskList.entityShortName==\'TransactionChargesImport\' || taskList.entity.shortName == \'UploadDownloadParticipantCertificate\'\r\n                                          \t           \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t || taskList.entity.shortName == \'HomeBranchIFSCUpload\' \r\n                                          \t           \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t || taskList.entityShortName == \'SwapQuotesImport\'"><a ng-click="vm.resubmitEntity(taskList.entity.shortName,taskList.id,taskList.payload, taskList.changeType,taskList.entityRecordID, taskList.taskAction )"><span class="hidden-xs hidden-sm" data-translate="entity.action.resubmit"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="filterData.length > noOfRecordsPerPage"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><br><div class="table-responsive" ng-show="vm.tasks.length> 0"><h3 class="view-heading">For Other Action</h3><table class="dataTable table table-striped table-hover"><thead><tr><th>Action</th><th>Taken on</th><th>For</th><th>On</th><th>By</th><th nowrap="nowrap">Reason For Rejection</th><th>-</th></tr></thead><tbody><tr ng-repeat="taskList in filterData1 = (vm.tasks| orderBy:\'-lastModifiedDate\' | filter: customFilter1) | limitTo:noOfRecordsPerPage1:noOfRecordsPerPage1*(page1-1)"><td nowrap="nowrap">{{taskList.changeType}}</td><td style="word-break:break-word" width="30%">{{taskList.entity.name}} | {{taskList.entityShortName}}</td><td nowrap="nowrap" width="10%">{{taskList.owner}}</td><td nowrap="nowrap" width="15%">{{taskList.createdDate | date:\'dd-MM-yyyy HH:mm:ss\'}}</td><td nowrap="nowrap" width="20%">{{taskList.createdBy}}</td><td style="min-width:20%;word-wrap:break-word">{{taskList.reason}}</td><td><div class="btn-group utility" uib-dropdown dropdown-append-to-body="true"><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ng-click="vm.viewEntity(taskList.entity.shortName,taskList.id,taskList.payload,\'maker\', taskList.changeType, taskList.entityRecordID,taskList.entityShortName,  taskList.taskAction)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="filterData1.length > noOfRecordsPerPage1"><cspl-pagination record-count="filterData1.length" control-model="page1" items-per-page="noOfRecordsPerPage1"></cspl-pagination></div></div></div></div></div></section></div></div><script src="assets/js/tables.js"></script>');
$templateCache.put('app/dashboard/2/dashboard.html','<div ncy-breadcrumb class="row" style="margin-left: 10px"></div><nmb-alert></nmb-alert><div class="row" style="margin-left: 10px"><div class="col-lg-12"><section class="item" style="padding:5px"><div class="panel panel-primary"><div class="panel-heading text-center"><span data-translate="gatewayApp.customerToDo.home.customerToDo"></span> <a href="" style="position: relative;float:right; color: #fff"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><div class="panel-body"><div class="module-content-inner"><nmb-alert-error></nmb-alert-error><div class="table-responsive" ng-show="vm.tasks.length==0 "><span style="color: #7f7f7f" data-translate="gatewayApp.customerToDo.home.nopendingactions ">No Pending Actions</span></div><div class="table-responsive" ng-show="vm.tasks.length> 0"><div class="row"><div class="pull-right" ng-show="vm.tasks.length>0 "><div class="col-md-6 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><cspl-table-export table-name="customertodo" total-record-count="vm.tasks.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="to-do"></cspl-table-export></div></div><table id="customertodo" class="datatables-nosort table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.customerToDo.customerName"></th><th style="min-width: 260px" nowrap="nowrap" data-translate="gatewayApp.customerToDo.customer"></th><th data-translate="gatewayApp.customerToDo.pan"></th><th nowrap="nowrap" data-translate="gatewayApp.customerToDo.accountNumber"></th><!-- <th data-translate="gatewayApp.customerToDo.emailid"></th>\r\n                                          <th data-translate="gatewayApp.customerToDo.mobile"></th> --><th nowrap="nowrap" data-translate="gatewayApp.customerToDo.actionType"></th><th nowrap="nowrap" align="right" data-translate="gatewayApp.customerToDo.requestRefNo"></th><th style="text-align:center">-</th></tr></thead><tbody><tr ng-repeat="taskList in filterData = (vm.tasks | filter : filterText | orderBy:\'-lastModifiedDate\' ) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)" ng-show="vm.checkTaskWithCurrentLogin(taskList.taskHistory)"><td width="15%" ng-if="taskList.entity.shortName==\'CustomerRegistration\' &&  taskList.payload.customerMiddleName!=null ">{{taskList.payload.customerFirstName+\' \'+taskList.payload.customerMiddleName+\' \'+taskList.payload.customerLastName}}</td><td width="15%" ng-if="taskList.entity.shortName==\'CustomerRegistration\' &&  taskList.payload.customerMiddleName==null">{{taskList.payload.customerFirstName+\' \'+taskList.payload.customerLastName}}</td><td width="15%" ng-if="taskList.entity.shortName==\'Customer\'  &&  taskList.payload.customer.customerMiddleName!=null ">{{taskList.payload.customer.customerFirstName+\' \'+taskList.payload.customer.customerMiddleName+\' \'+taskList.payload.customer.customerLastName}}</td><td width="15%" ng-if="taskList.entity.shortName==\'Customer\' &&  taskList.payload.customer.customerMiddleName==null">{{ taskList.payload.customer.customerFirstName+\' \'+\' \'+taskList.payload.customer.customerLastName}}</td><td width="15%"><span ng-if="taskList.payload.customerType.shortName!=\'RESIDENTINDIVIDUAL\' && taskList.payload.customerType.shortName!=\'NONRESIDENTINDIVIDUAL\' && taskList.payload.customerType.shortName!=\'HINDUUNDIVIDEDFAMILY\' && taskList.payload.customerType.shortName!=\'LIMITEDLIABILITYPARTNERSHIPFIRM\' && taskList.payload.customer.customerType.shortName!=\'RESIDENTINDIVIDUAL\' && taskList.payload.customer.customerType.shortName!=\'NONRESIDENTINDIVIDUAL\' && taskList.payload.customer.customerType.shortName!=\'HINDUUNDIVIDEDFAMILY\' && taskList.payload.customer.customerType.shortName!=\'LIMITEDLIABILITYPARTNERSHIPFIRM\'">{{taskList.payload.customerType.name || taskList.payload.customer.customerType.name }}</span> <span ng-if="taskList.payload.customerType.shortName==\'RESIDENTINDIVIDUAL\' || taskList.payload.customer.customerType.shortName==\'RESIDENTINDIVIDUAL\'">INDIVIDUAL (RESIDENT)</span> <span ng-if="taskList.payload.customerType.shortName==\'NONRESIDENTINDIVIDUAL\' || taskList.payload.customer.customerType.shortName==\'NONRESIDENTINDIVIDUAL\'">NON RESIDENT INDIVIDUAL - NRI</span> <span ng-if="taskList.payload.customerType.shortName==\'HINDUUNDIVIDEDFAMILY\' || taskList.payload.customer.customerType.shortName==\'HINDUUNDIVIDEDFAMILY\'">HINDU UNDIVIDED FAMILY \u2013 HUF</span> <span ng-if="taskList.payload.customerType.shortName==\'LIMITEDLIABILITYPARTNERSHIPFIRM\' || taskList.payload.customer.customerType.shortName==\'LIMITEDLIABILITYPARTNERSHIPFIRM\'">LIMITED LIABILITY PARTNERSHIP FIRM - LLP</span></td><td>{{taskList.payload.panNumber || taskList.payload.customer.panNumber}}</td><td>{{taskList.payload.bankAccountNumber ||taskList.bankAccNumber}}</td><!-- <td>{{taskList.payload.userEmail|| taskList.payload.customer.primaryEmail}}</td>\r\n\t\t\t\t\t\t\t\t\t<td  >{{taskList.payload.userMobile ||taskList.payload.customer.primaryMobile }}</td> --><td>{{taskList.payload.actionType || taskList.changeType}}</td><!-- <td  width="10%" ng-if="taskList.entity.shortName==\'Customer\'">{{taskList.payload.actionType ||taskList.changeType }}</td> --><td width="1%" align="right" ng-if="taskList.entity.shortName==\'CustomerRegistration\'">{{taskList.payload.requestReferenceNumber }}</td><td width="1%" align="right" ng-if="taskList.entity.shortName==\'Customer\'">{{\'-\'}}</td><td width="5%" align="center"><div class="btn-group utility" uib-dropdown dropdown-append-to-body="true"><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ng-click="vm.viewEntity(taskList.entity.shortName,taskList.id,taskList.payload,\'checker\', taskList.changeType , taskList.entityRecordID)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li><a ng-click="vm.rejectEntity(taskList)"><span class="hidden-xs hidden-sm" data-translate="entity.action.reject"></span></a></li><li><a ng-click="vm.approveEntity(taskList)"><span class="hidden-xs hidden-sm" data-translate="entity.action.approve"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="vm.tasks.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></div></div></section></div></div><script src="assets/js/tables.js"></script>');
$templateCache.put('app/dashboard/3/dashboard.html','<div class="container-fluid dashboard" ng-hide=" vm.globalValues.getOrganisation().organisationType.shortName!=\'CUSTOMER\'"><div class="main-content"><div class="row"><div class="col-md-6 less-padding"><div class="pinboard col-md-11" ng-show="vm.account.organisation.organisationType.shortName==\'BANK\'"><div class="col-sm-5" ng-show="vm.account.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.ownerOrganisation" control-disabled="vm.EditDisable || vm.ViewDisable" control-id="txtOrganisation" lookup-name="organisation" display-column="shortName" form="frmtradinghomepage"></cspl-ach></div><div class="col-sm-5"><cspl-ach control-model="vm.ownerOrganisation" control-disabled="vm.EditDisable || vm.ViewDisable" control-id="txtOrganisation" lookup-name="organisation" display-column="shortName" form="frmtradinghomepage"></cspl-ach></div><div class="col-sm-2"><button type="button" class="btn btn-info active">PIN BOARD</button></div></div><div class="half-part not-selected" ng-class="{\'bank-view\': vm.account.organisation.organisationType.shortName==\'BANK\'}"><div class="box-wrapper"><div class="box-row"><div class="small-box spot-box" ng-class="{\'disabled-box\': vm.retailSpotMarketSession.sessionTimingsDTO.status==\'CLOSED\'}"><div class="box-top"><div class="pull-left"><h4 class="box-heading">SPOT</h4><p class="box-date">{{vm.retailSpotMarketSession.settlementDate | date: \'dd-MMM-yyyy\'}}</p></div><div class="pull-right text-right"><span ng-class="{\'box-open-icon\': vm.retailSpotMarketSession.sessionTimingsDTO.status==\'OPEN\', \'box-close-icon\': vm.retailSpotMarketSession.sessionTimingsDTO.status==\'CLOSED\'}">{{vm.retailSpotMarketSession.sessionTimingsDTO.status}}</span> <span class="box-icon" data-toggle="modal" data-target="#modal-settings"><a ng-click="vm.openOrderPreference()"><img class="logo-icon" src="assets/images/box-right-icon.png" title="Order Preference" alt="icon"></a></span></div><div class="clearfix"></div></div><!--box-top ends--><!-- box-content --><div class="box-content"><div class="box-buy-sell" ng-class="{\'disabled-box\': vm.retailSpotSellLimit==0 || vm.retailSpotSellLimit==null || vm.retailSpotSellLimit==0}"><div class="box-sell"><div class="pull-left"><div class="la-wrapper"><button class="btn-sell-buy" ng-disabled="vm.retailSpotMarketSession.sessionTimingsDTO.status==\'CLOSED\' || vm.retailSpotSellLimit==0 || vm.retailSpotSellLimit==null || vm.retailSpotSellLimit==0" ng-click="vm.placeMarketOrder(\'SELL\', vm.orderVolumeSpotMkt, \'SPOT\', 3)">You Sell</button><div class="la-class"><span>LA</span> - {{vm.retailSpotSellLimit / 1000000 | number:vm.noOfDecimalsForAmount}} M</div><div class="la-amount">{{vm.retailSpotMarketWatch.bidVolume | number}}</div></div></div><div class="pull-right text-right"><div class="la-wrapper"><p class="la-count">{{vm.retailSpotMarketWatch.bidPrice | split:\'.\':\'0\'}}.<span class="la-value">{{vm.retailSpotMarketWatch.bidPrice | number:4 | split:\'.\':\'1\'}}</span></p></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="box-buy-sell" ng-class="{\'disabled-box\': vm.retailSpotBuyLimit==0 || vm.retailSpotBuyLimit==null || vm.retailSpotBuyLimit==0}"><div class="box-buy"><div class="pull-left"><div class="la-wrapper"><button class="btn-sell-buy" ng-disabled="vm.retailSpotMarketSession.sessionTimingsDTO.status==\'CLOSED\' || vm.retailSpotBuyLimit==0 || vm.retailSpotBuyLimit==null || vm.retailSpotBuyLimit==0" ng-click="vm.placeMarketOrder(\'BUYY\', vm.orderVolumeSpotMkt, \'SPOT\', 3)">You Buy</button><div class="la-class"><span>LA</span> - {{vm.retailSpotBuyLimit / 1000000 | number:vm.noOfDecimalsForAmount}} M</div><div class="la-amount">{{vm.retailSpotMarketWatch.offerVolume | number}}</div></div></div><div class="pull-right text-right"><div class="la-wrapper"><p class="la-count">{{vm.retailSpotMarketWatch.offerPrice | split:\'.\':\'0\'}}.<span class="la-value">{{vm.retailSpotMarketWatch.offerPrice | number:4 | split:\'.\':\'1\'}}</span></p></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="mkt-value">Mkt <span class="mkt-price"><cspl-number-text control-model="vm.orderVolumeSpotMkt" control-type="number" control-id="txtorderVolumeSpotMkt" control-disabled="vm.retailSpotMarketSession.sessionTimingsDTO.status==\'CLOSED\'" control-maxlength="19" required></span></div></div><!-- box-content ends --></div></div><div class="box-row"><div class="small-box ib-spot-box"><div class="box-top"><div class="pull-left"><h4 class="box-heading">IB. SPOT</h4></div><div class="pull-right text-right"><span class="box-icon" data-toggle="modal" data-target="#modal-settings"><!-- <a ng-click="vm.openOrderPreference()">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<img class="logo-icon" src="assets/images/box-right-icon.png" alt="icon" />\r\n\t\t\t\t\t\t\t\t\t\t\t</a> --></span></div><div class="clearfix"></div></div><!--box-top ends--><!-- box-content --><div class="box-content"><div class="box-buy-sell disabled-box"><div class="box-sell"><div class="pull-left"><div class="la-wrapper"><button class="btn-sell-buy">BUY</button><div class="la-amount">{{vm.ibSpotMarketWatch.bidVolume | number}}</div></div></div><div class="pull-right text-right"><div class="la-wrapper ib-mkt-price"><p class="la-count">{{vm.ibSpotMarketWatch.bidPrice | split:\'.\':\'0\' }}.<span class="la-value">{{vm.ibSpotMarketWatch.bidPrice | number:4 | split:\'.\':\'1\'}}</span></p></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="box-buy-sell disabled-box"><div class="box-buy"><div class="pull-left"><div class="la-wrapper"><button class="btn-sell-buy">SELL</button><div class="la-amount">{{vm.ibSpotMarketWatch.offerVolume | number}}</div></div></div><div class="pull-right text-right"><div class="la-wrapper ib-mkt-price"><p class="la-count">{{vm.ibSpotMarketWatch.offerPrice | split:\'.\':\'0\' }}.<span class="la-value">{{vm.ibSpotMarketWatch.offerPrice | number:4 | split:\'.\':\'1\'}}</span></p></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><!-- <div class="mkt-value">Mkt <span class="mkt-price"><input type="text" name="ibspot-mkt-price" value="800,000"/></span></div> --></div><!-- box-content ends --></div></div></div><!-- box-wrapper ends --></div><div class="half-part" ng-class="{\'not-selected bank-view\': vm.account.organisation.organisationType.shortName==\'BANK\', \'selected\': vm.account.organisation.organisationType.shortName!=\'BANK\'}"><p class="showing-for" ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'">Showing for : <span class="comp-name">{{vm.tradingBank.shortName}}</span></p><div class="box-wrapper"><div class="box-row"><div class="small-box cash-box" ng-class="{\'disabled-box\': vm.cashMarketSession.sessionTimingsDTO.status==\'CLOSED\'}"><div class="box-top"><div class="pull-left"><h4 class="box-heading">CASH</h4><p class="box-date">{{vm.cashMarketSession.settlementDate | date: \'dd-MMM-yyyy\'}}</p></div><div class="pull-right text-right"><span ng-class="{\'box-open-icon\': vm.cashMarketSession.sessionTimingsDTO.status==\'OPEN\', \'box-close-icon\': vm.cashMarketSession.sessionTimingsDTO.status==\'CLOSED\'}">{{vm.cashMarketSession.sessionTimingsDTO.status}}</span> <span class="box-icon" data-toggle="modal" data-target="#modal-settings"><a ng-click="vm.openOrderPreference()"><img class="logo-icon" src="assets/images/box-right-icon.png" title="Order Preference" alt="icon"></a></span></div><div class="clearfix"></div></div><!--box-top ends--><!-- box-content --><div class="box-content"><div class="box-buy-sell" ng-class="{\'disabled-box\': vm.cashSellLimit==0 || vm.cashSellLimit==null || vm.cashSellLimit==0}"><div class="box-sell"><div class="pull-left"><div class="la-wrapper"><button class="btn-sell-buy" ng-disabled="vm.cashMarketSession.sessionTimingsDTO.status==\'CLOSED\' || vm.cashSellLimit==0 || vm.cashSellLimit==null || vm.cashSellLimit==0" ng-click="vm.placeMarketOrder(\'SELL\', vm.orderVolumeCashMkt, \'CASH\', 1)">You Sell</button><div class="la-class"><span>LA</span> - {{vm.cashSellLimit / 1000000 | number: vm.noOfDecimalsForAmount}} M</div><div class="la-amount">{{vm.cashMarketWatch.bidVolume | number}}</div></div></div><div class="pull-right text-right"><div class="la-wrapper"><p class="la-count">{{vm.cashMarketWatch.bidPrice | split:\'.\':\'0\' }}.<span class="la-value">{{vm.cashMarketWatch.bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></p><p class="spread">({{vm.defaultBankSpread.cashSpotOfferSpread}})</p></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="box-buy-sell" ng-class="{\'disabled-box\': vm.cashBuyLimit==0 || vm.cashBuyLimit==null || vm.cashBuyLimit==0}"><div class="box-buy"><div class="pull-left"><div class="la-wrapper"><button class="btn-sell-buy" ng-disabled="vm.cashMarketSession.sessionTimingsDTO.status==\'CLOSED\' || vm.cashBuyLimit==0 || vm.cashBuyLimit==null || vm.cashBuyLimit==0" ng-click="vm.placeMarketOrder(\'BUYY\', vm.orderVolumeCashMkt, \'CASH\', 1)">You Buy</button><div class="la-class"><span>LA</span> - {{vm.cashBuyLimit / 1000000 | number: vm.noOfDecimalsForAmount}} M</div><div class="la-amount">{{vm.cashMarketWatch.offerVolume | number}}</div></div></div><div class="pull-right text-right"><div class="la-wrapper"><p class="la-count">{{vm.cashMarketWatch.offerPrice | split:\'.\':\'0\' }}.<span class="la-value">{{vm.cashMarketWatch.offerPrice | number:vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></p><p>({{vm.defaultBankSpread.cashSpotBidSpread}})</p></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="mkt-value">Mkt <span class="mkt-price"><cspl-number-text control-model="vm.orderVolumeCashMkt" control-id="txtorderVolumeCashMkt" control-disabled="vm.cashMarketSession.sessionTimingsDTO.status==\'CLOSED\'" control-maxlength="19" required></span></div></div><!-- box-content ends --></div></div><div class="box-row"><div class="small-box tom-box" ng-class="{\'disabled-box\': vm.tomMarketSession.sessionTimingsDTO.status==\'CLOSED\'}"><div class="box-top"><div class="pull-left"><h4 class="box-heading">TOM</h4><p class="box-date">{{vm.tomMarketSession.settlementDate | date: \'dd-MMM-yyyy\'}}</p></div><div class="pull-right text-right"><span ng-class="{\'box-open-icon\': vm.tomMarketSession.sessionTimingsDTO.status==\'OPEN\', \'box-close-icon\': vm.tomMarketSession.sessionTimingsDTO.status==\'CLOSED\'}">{{vm.tomMarketSession.sessionTimingsDTO.status}}</span></div><div class="clearfix"></div></div><!--box-top ends--><!-- box-content --><div class="box-content"><div class="box-buy-sell" ng-class="{\'disabled-box\': vm.tomSellLimit==0 || vm.tomSellLimit==null || vm.tomSellLimit==0}"><div class="box-sell"><div class="pull-left"><div class="la-wrapper"><button class="btn-sell-buy" ng-disabled="vm.tomMarketSession.sessionTimingsDTO.status==\'CLOSED\' || vm.tomSellLimit==0 || vm.tomSellLimit==null || vm.tomSellLimit==0" ng-click="vm.placeMarketOrder(\'SELL\', vm.orderVolumeTomMkt, \'TOM\', 2)">You Sell</button><div class="la-class"><span>LA</span> - {{vm.tomSellLimit / 1000000 | number: vm.noOfDecimalsForAmount}} M</div><div class="la-amount">{{vm.tomMarketWatch.bidVolume | number}}</div></div></div><div class="pull-right text-right"><div class="la-wrapper"><p class="la-count">{{vm.tomMarketWatch.bidPrice | split:\'.\':\'0\' }}.<span class="la-value">{{vm.tomMarketWatch.bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></p><p class="spread">({{vm.defaultBankSpread.tomSpotOfferSpread}})</p></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="box-buy-sell" ng-class="{\'disabled-box\': vm.tomBuyLimit==0 || vm.tomBuyLimit==null || vm.tomBuyLimit==0}"><div class="box-buy"><div class="pull-left"><div class="la-wrapper"><button class="btn-sell-buy" ng-disabled="vm.tomMarketSession.sessionTimingsDTO.status==\'CLOSED\' || vm.tomBuyLimit==0 || vm.tomBuyLimit==null || vm.tomBuyLimit==0" ng-click="vm.placeMarketOrder(\'BUYY\', vm.orderVolumeTomMkt, \'TOM\', 2)">You Buy</button><div class="la-class"><span>LA</span> - {{vm.tomBuyLimit / 1000000 | number: vm.noOfDecimalsForAmount}} M</div><div class="la-amount">{{vm.tomMarketWatch.offerVolume | number}}</div></div></div><div class="pull-right text-right"><div class="la-wrapper"><p class="la-count">{{vm.tomMarketWatch.offerPrice | split:\'.\':\'0\' }}.<span class="la-value">{{vm.tomMarketWatch.offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></p><p class="spread">({{vm.defaultBankSpread.tomSpotBidSpread}})</p></div></div><div class="clearfix"></div></div></div><!-- box-buy-sell ends --><div class="mkt-value">Mkt <span class="mkt-price"><cspl-number-text control-model="vm.orderVolumeTomMkt" control-id="txtorderVolumeTomMkt" control-disabled="vm.tomMarketSession.sessionTimingsDTO.status==\'CLOSED\'" control-maxlength="19" required></span></div></div><!-- box-content ends --></div></div></div><!-- box-wrapper ends --></div></div><div class="col-md-6 less-padding"><!-- Content right wrapper starts --><div class="content-right-wrapper"><div class="bank-comparitive-quotes"><div class="bcq-head"><h3>Bank Comparative Quotes</h3><div class="bcq-head-icons"><ul class="nav nav-tabs"><li class="active"><a data-toggle="tab" href="#comparitive_tab1" class="bcq-icon1" title="Quotes In Paise"></a></li><li><a data-toggle="tab" href="#comparitive_tab2" class="bcq-icon2" title="Quotes In Price"></a></li></ul></div></div><div class="tab-content"><div class="tab-pane in active" id="comparitive_tab1"><div class="bank-comparitive-contents"><div class="bank-comparitive-left"><h6 class="text-center" style="margin-left:35%">CASH/SPOT</h6><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Bank</th><th class="text-right">Bid Spread</th><th class="text-right">Offer Spread</th></tr></thead><tbody><tr ng-repeat="swapQuotes in vm.bankComparativeQuotes"><td><span class="comp-name" ng-class="{\'selected\': swapQuotes.bank.bankName==vm.defaultTradingBank.bankName}" ng-click="vm.onChangingBankInSwapQuotes(swapQuotes.bank)" title="{{swapQuotes.bank.bankName}}">{{swapQuotes.bank.bankName}}</span></td><td class="text-right"><span class="bid-spread" ng-class="{\'selected\': swapQuotes.cashSpotBidSpread==vm.bestCashSpotBidSpread}">{{swapQuotes.cashSpotBidSpread}}</span></td><td class="text-right"><span class="offer-spread" ng-class="{\'selected\': swapQuotes.cashSpotOfferSpread==vm.bestCashSpotOfferSpread}">{{swapQuotes.cashSpotOfferSpread}}</span></td></tr><tr ng-show="vm.bankQuotesInPrice.length<2"><td></td><td></td><td></td></tr><tr ng-show="vm.bankQuotesInPrice.length<3"><td></td><td></td><td></td></tr></tbody><tfoot><tr><td>&nbsp;</td><td class="text-right">Bid Value</td><td class="text-right">{{vm.retailSpotMarketWatch.bidVolume | number}}</td></tr></tfoot></table></div></div><div class="bank-comparitive-right"><h6 class="text-center">TOM/SPOT <span class="price-unit">(Val in Paise)</span></h6><div class="table-responsive"><table class="table table-striped"><thead><tr><th class="text-right">Bid Spread</th><th class="text-right">Offer Spread</th></tr></thead><tbody><tr ng-repeat="swapQuotes in vm.bankComparativeQuotes"><td class="text-right"><span class="bid-spread" ng-class="{\'selected\': swapQuotes.tomSpotBidSpread==vm.bestTomSpotBidSpread}">{{swapQuotes.tomSpotBidSpread}}</span></td><td class="text-right"><span class="offer-spread" ng-class="{\'selected\': swapQuotes.tomSpotOfferSpread==vm.bestTomSpotOfferSpread}">{{swapQuotes.tomSpotOfferSpread}}</span></td></tr><tr ng-show="vm.bankQuotesInPrice.length<2"><td></td><td></td></tr><tr ng-show="vm.bankQuotesInPrice.length<3"><td></td><td></td></tr></tbody><tfoot><tr><td class="text-right">Offer Value</td><td class="text-right">{{vm.retailSpotMarketWatch.offerVolume | number}}</td></tr></tfoot></table></div></div><div class="clearfix"></div></div></div><!--Bank Comparitive Tab 1 CLOSED--><div class="tab-pane" id="comparitive_tab2"><div class="bank-comparitive-contents"><div class="bank-comparitive-left"><h6 class="text-center" style="margin-left:35%">CASH</h6><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Bank</th><th class="text-right">Bid Price</th><th class="text-right">Offer Price</th></tr></thead><tbody><tr ng-repeat="swapQuotesInPrice in vm.bankQuotesInPrice"><td><span class="comp-name" ng-class="{\'selected\': swapQuotesInPrice.bank.bankName==vm.defaultTradingBank.bankName}" ng-click="vm.onChangingBankInSwapQuotes(swapQuotesInPrice.bank)" tilte="{{swapQuotesInPrice.bank.bankName}}">{{swapQuotesInPrice.bank.bankName}}</span></td><td class="text-right"><span class="bid-spread bcq-highlighted-txt" ng-class="{\'selected\': swapQuotesInPrice.cashSpotBidSpread==vm.bestCashSpotBidSpread}">{{swapQuotesInPrice.cashSpotBidSpread | split:\'.\':\'0\'}}.<span>{{swapQuotesInPrice.cashSpotBidSpread | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span class="offer-spread bcq-highlighted-txt" ng-class="{\'selected\': swapQuotesInPrice.cashSpotOfferSpread==vm.bestCashSpotOfferSpread}">{{swapQuotesInPrice.cashSpotOfferSpread | split:\'.\':\'0\'}}.<span>{{swapQuotesInPrice.cashSpotOfferSpread | number:4 | split:\'.\':\'1\'}}</span></span></td></tr><tr ng-show="vm.bankQuotesInPrice.length<2"><td></td><td></td><td></td></tr><tr ng-show="vm.bankQuotesInPrice.length<3"><td></td><td></td><td></td></tr></tbody><tfoot><tr><td>&nbsp;</td><td class="text-right">Bid Value</td><td class="text-right">{{vm.retailSpotMarketWatch.bidVolume | number}}</td></tr></tfoot></table></div></div><div class="bank-comparitive-right"><h6 class="text-center">TOM <span class="price-unit" ng-hide="true">(Val in Paise)</span></h6><div class="table-responsive"><table class="table table-striped"><thead><tr><th class="text-right">Bid Price</th><th class="text-right">Offer Price</th></tr></thead><tbody><tr ng-repeat="swapQuotesInPrice in vm.bankQuotesInPrice"><td class="text-right"><span class="bid-spread bcq-highlighted-txt" ng-class="{\'selected\': swapQuotesInPrice.tomSpotBidSpread==vm.bestTomSpotBidSpread}">{{swapQuotesInPrice.tomSpotBidSpread | split:\'.\':\'0\'}}.<span>{{swapQuotesInPrice.tomSpotBidSpread | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span class="offer-spread bcq-highlighted-txt" ng-class="{\'selected\': swapQuotesInPrice.tomSpotOfferSpread==vm.bestTomSpotOfferSpread}">{{swapQuotesInPrice.tomSpotOfferSpread | split:\'.\':\'0\'}}.<span>{{swapQuotesInPrice.tomSpotOfferSpread | number:4 | split:\'.\':\'1\'}}</span></span></td></tr><tr ng-show="vm.bankQuotesInPrice.length<2"><td></td><td></td></tr><tr ng-show="vm.bankQuotesInPrice.length<3"><td></td><td></td></tr></tbody><tfoot><tr><td class="text-right">Offer Value</td><td class="text-right">{{vm.retailSpotMarketWatch.offerVolume | number}}</td></tr></tfoot></table></div></div><div class="clearfix"></div></div></div><!--Bank Comparitive Tab 2 CLOSED--></div></div><!-- bank-comparitive-quotes ends--><div class="market-depth"><h3>Market Depth</h3><ul class="market-depth-tab nav nav-tabs" role="tablist"><li role="presentation" class="statistics-tab active"><a href="#spotStatistics" aria-controls="spotmarketdepth" role="tab" data-toggle="tab"><span class="icon-tab-head">SPOT</span> <span class="tab-icon statistics-modal" data-toggle="modal" title="Market Statistics" data-target="#modal-table" ng-click="vm.openMarketStatistics(\'Retail Spot\')"></span> <span class="tab-icon maximise-icon popUPIcon" ng-click="vm.expandMarketDepth(\'Retail Spot\', vm.retailSpotMarketDepth)"></span></a></li><li role="presentation" class="statistics-tab"><a href="#intSpotStatistics" aria-controls="interbankspotmarketdepth" role="tab" data-toggle="tab"><span class="icon-tab-head">INTERBANK SPOT</span> <span class="tab-icon statistics-modal" title="Market Statistics" data-toggle="modal" data-target="#modal-table" ng-click="vm.openMarketStatistics(\'Interbank Spot\')"></span> <span class="tab-icon maximise-icon popUPIcon" ng-click="vm.expandMarketDepth(\'Interbank Spot\', vm.ibSpotMarketDepth)"></span></a></li><li role="presentation" class="close-maximize-tab"><a href="javascript:void(0);">Back to Normal View</a></li></ul><div class="tab-content market-depth-contents"><div role="tabpanel" class="tab-pane active" id="spotStatistics"><div class="table-responsive"><table class="table table-striped"><thead><tr><th class="text-right">Bid Value</th><th class="text-right">Bid Price</th><th class="text-right">Offer Price</th><th class="text-right">Offer Value</th></tr></thead><tbody><tr ng-repeat="marketDepth in vm.retailSpotMarketDepth.marketDepthDetails" ng-hide="marketDepth.bidPrice==0 && marketDepth.offerPrice==0"><td class="text-right"><span>{{marketDepth.bidVolume | number}}</span></td><td class="text-right"><span class="mdc-highlighted-txt">{{marketDepth.bidPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span class="mdc-highlighted-txt">{{marketDepth.offerPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span>{{marketDepth.offerVolume | number}}</span></td></tr></tbody></table></div></div><!-- spotStatistics ends --><div role="tabpanel" class="tab-pane" id="intSpotStatistics"><div class="table-responsive"><table class="table table-striped"><thead><tr><th class="text-right">Bid Value</th><th class="text-right">Bid Price</th><th class="text-right">Offer Price</th><th class="text-right">Offer Value</th></tr></thead><tbody><tr ng-repeat="marketDepth in vm.ibSpotMarketDepth.marketDepthDetails" ng-hide="marketDepth.bidPrice==0 && marketDepth.offerPrice==0"><td class="text-right"><span>{{marketDepth.bidVolume | number}}</span></td><td class="text-right"><span class="mdc-highlighted-txt">{{marketDepth.bidPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.bidPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span class="mdc-highlighted-txt">{{marketDepth.offerPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.offerPrice | number: vm.noOfDecimalsForRate | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span>{{marketDepth.offerVolume | number}}</span></td></tr></tbody></table></div></div><!-- intSpotStatistics ends --></div></div><!-- market-depth ends--></div><!-- Content right wrapper ends --></div></div><!-- top left right ends --><div class="row"><div class="col-md-5 less-padding"><div class="content-bot-left-wrapper"><div class="content-bot-left"><div class="order-price" ng-show="vm.orderDTO.activityIndicator==\'PLAC\'"><form name="frmOrderEntry" role="form" novalidate><div><h3>Order at the Price</h3><div class="order-price-tab pull-right text-right"><ul class="nav nav-tabs" id="orderPriceTabs" role="tablist"><li role="presentation" class="active tab-sell"><a ng-click="vm.orderType=\'SELL\'" aria-controls="sell" role="tab" id="sellTab" data-toggle="tab">SELL</a></li><li role="presentation" class="tab-buy"><a ng-click="vm.orderType=\'BUYY\'" aria-controls="buy" role="tab" id="buyTab" data-toggle="tab">BUY</a></li><li role="presentation" class="tab-sell-buy"><a ng-click="vm.orderType=\'SELLBUY\'" aria-controls="sellBuy" role="tab" data-toggle="tab">SELL &amp; BUY</a></li></ul></div><div class="clearfix"></div></div><div class="order-price-contents tab-content"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-inner"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode==\'SPOT\'}"><a id="spotInstrument" aria-controls="spot" role="tab" data-toggle="tab" ng-click="vm.defaultInstrumentCode=\'SPOT\'; vm.defaultInstrumentId=3;">SPOT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode==\'CASH\'}"><a id="cashInstrument" aria-controls="cash" role="tab" data-toggle="tab" ng-click="vm.defaultInstrumentCode=\'CASH\'; vm.defaultInstrumentId=1;">CASH</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode==\'TOM\'}"><a id="tomInstrument" aria-controls="tom" role="tab" data-toggle="tab" ng-click="vm.defaultInstrumentCode=\'TOM\'; vm.defaultInstrumentId=2;">TOM</a></li></ul><div class="search-box"><cspl-ach control-model="vm.tradingBank" control-id="txtbankFilterForPO" lookup-name="tradingBank" filter-value="{{vm.account.organisation.id}}" display-column="bankName" form="frmOrderEntry" required></cspl-ach></div></div><div class="order-price-contents tab-content"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-last"><!-- Nav tabs --><ul class="nav nav-tabs" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\' || vm.defaultPriceCondition==\'MRKT\'}"><a id="limitTab" ng-click="vm.defaultPriceCondition=\'LIMT\'">LIMIT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'STLS\', \'disabled\':vm.configSettings.isAllowStopLossOrder!=\'Yes\'}"><a id="stoplossTab" ng-click="vm.defaultPriceCondition=\'STLS\'" ng-class="{\'disabledTabLink\': vm.configSettings.isAllowStopLossOrder!=\'Yes\'}">SL</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'TKPR\', \'disabled\':vm.configSettings.isAllowTakeProfitOrder!=\'Yes\'}"><a id="takeprofitTab" ng-click="vm.defaultPriceCondition=\'TKPR\'" ng-class="{\'disabledTabLink\': vm.configSettings.isAllowTakeProfitOrder!=\'Yes\'}">TP</a></li></ul><!-- Tab panes --><div class="tab-content"><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\' || vm.defaultPriceCondition==\'MRKT\'}" ng-show="vm.defaultPriceCondition==\'LIMT\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Value</th><th class="text-right">Limit Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" no-of-decimals="0" control-min="0" control-id="txtlimitOrderValue" form="frmOrderEntry" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtlimitOrderPrice" form="frmOrderEntry" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'" control-value-change="vm.softCheckDeviationForLimitExchangeRate(vm.orderDTO.limitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</span></td></tbody><tfoot><tr><td class="text-right"><span class="color-theme-txt">LA</span> - <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotBuyLimit | number}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{vm.cashSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{vm.cashBuyLimit | number}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{vm.tomSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{vm.tomBuyLimit | number}}</span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.limitExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table><table class="table" ng-show="vm.orderType==\'SELLBUY\'"><thead><th class="text-right">Order Value</th><th class="text-right">Buy Limit Price</th><th class="text-right">Sell Limit Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" no-of-decimals="0" control-min="0" control-id="txtsellbuylimitOrderValue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.buyLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuylimitBuyOrderPrice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType==\'SELLBUY\'" control-value-change="vm.softCheckDeviationForBuyLimitExchangeRate(vm.orderDTO.buyLimitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.buyLimitPriceDeviationWarning!=null && vm.buyLimitPriceDeviationWarning!=undefined && vm.buyLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.buyLimitPriceDeviationWarning}}</span></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.sellLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuylimitSellOrderPrice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType==\'SELLBUY\'" control-value-change="vm.softCheckDeviationForSellLimitExchangeRate(vm.orderDTO.sellLimitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.sellLimitPriceDeviationWarning!=null && vm.sellLimitPriceDeviationWarning!=undefined && vm.sellLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.sellLimitPriceDeviationWarning}}</span></td></tbody><tfoot><tr><td class="text-right"><span class="color-theme-txt">LA</span> - <span ng-show="vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotSellLimit | number}}, {{vm.retailSpotBuyLimit | number}}</span> <span ng-show="vm.defaultInstrumentCode==\'CASH\'">{{vm.cashSellLimit | number}}, {{vm.cashBuyLimit | number}}</span> <span ng-show="vm.defaultInstrumentCode==\'TOM\'">{{vm.tomSellLimit | number}}, {{vm.tomBuyLimit | number}}</span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.buyLimitExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.sellLimitExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table></div></div><!-- limit tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'STLS\'}" ng-show="vm.defaultPriceCondition==\'STLS\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Value</th><th class="text-right">Limit Price</th><th class="text-right">Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" no-of-decimals="0" control-min="0" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-id="txtslordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-id="txtsllimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'" control-value-change="vm.softCheckDeviationForLimitExchangeRate(vm.orderDTO.limitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</span></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.stopExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-id="txtsltriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span class="color-theme-txt">LA</span> - <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotBuyLimit | number}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{vm.cashSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{vm.cashBuyLimit | number}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{vm.tomSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{vm.tomBuyLimit | number}}</span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.limitExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.stopExchangeRateInSpot | number: vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table><table class="table" ng-show="vm.orderType==\'SELLBUY\'"><thead><th class="text-right">Order Value</th><th class="text-right">Buy Limit Price</th><th class="text-right">Buy Trigger Price</th><th class="text-right">Sell Limit Price</th><th class="text-right">Sell Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" no-of-decimals="0" control-min="0" control-id="txtsellbuyslordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.buyLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuyslbuylimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'" control-value-change="vm.softCheckDeviationForBuyLimitExchangeRate(vm.orderDTO.buyLimitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.buyLimitPriceDeviationWarning!=null && vm.buyLimitPriceDeviationWarning!=undefined && vm.buyLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.buyLimitPriceDeviationWarning}}</span></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.buyStopExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuyslbuytriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.sellLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuyslselllimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'" control-value-change="vm.softCheckDeviationForSellLimitExchangeRate(vm.orderDTO.sellLimitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.sellLimitPriceDeviationWarning!=null && vm.sellLimitPriceDeviationWarning!=undefined && vm.sellLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.sellLimitPriceDeviationWarning}}</span></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.sellStopExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuyslselltriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span class="color-theme-txt">LA</span> - <span ng-show="vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotSellLimit | number}}, {{vm.retailSpotBuyLimit | number}}</span> <span ng-show="vm.defaultInstrumentCode==\'CASH\'">{{vm.cashSellLimit | number}}, {{vm.cashBuyLimit | number}}</span> <span ng-show="vm.defaultInstrumentCode==\'TOM\'">{{vm.tomSellLimit | number}}, {{vm.tomBuyLimit | number}}</span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.buyLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.buyStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.sellLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.sellStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table></div></div><!-- sl tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'TKPR\'}" ng-show="vm.defaultPriceCondition==\'TKPR\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Value</th><th class="text-right">Limit Price</th><th class="text-right">Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" no-of-decimals="0" control-min="0" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-id="txttpordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-id="txttplimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'" control-value-change="vm.softCheckDeviationForLimitExchangeRate(vm.orderDTO.limitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</span></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.stopExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-id="txttptriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span class="color-theme-txt">LA</span> - <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotBuyLimit | number}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{vm.cashSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{vm.cashBuyLimit | number}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{vm.tomSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{vm.tomBuyLimit | number}}</span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.limitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.stopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table><table class="table" ng-show="vm.orderType==\'SELLBUY\'"><thead><th class="text-right">Order Value</th><th class="text-right">Buy Limit Price</th><th class="text-right">Buy Trigger Price</th><th class="text-right">Sell Limit Price</th><th class="text-right">Sell Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" no-of-decimals="0" control-min="0" control-id="txtsellbuytpordervalue" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.buyLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuyslbuylimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'" control-value-change="vm.softCheckDeviationForBuyLimitExchangeRate(vm.orderDTO.buyLimitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.buyLimitPriceDeviationWarning!=null && vm.buyLimitPriceDeviationWarning!=undefined && vm.buyLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.buyLimitPriceDeviationWarning}}</span></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.buyStopExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuytpbuytriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.sellLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuytpselllimitprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'" control-value-change="vm.softCheckDeviationForSellLimitExchangeRate(vm.orderDTO.sellLimitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.sellLimitPriceDeviationWarning!=null && vm.sellLimitPriceDeviationWarning!=undefined && vm.sellLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.sellLimitPriceDeviationWarning}}</span></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.sellStopExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuytpselltriggerprice" form="frmOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span class="color-theme-txt">LA</span> - <span ng-show="vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotSellLimit | number}}, {{vm.retailSpotBuyLimit | number}}</span> <span ng-show="vm.defaultInstrumentCode==\'CASH\'">{{vm.cashSellLimit | number}}, {{vm.cashBuyLimit | number}}</span> <span ng-show="vm.defaultInstrumentCode==\'TOM\'">{{vm.tomSellLimit | number}}, {{vm.tomBuyLimit | number}}</span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.buyLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.buyStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.sellLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.sellStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table></div></div><!-- tp tab ends --></div></div><!-- sell-spot ends --></div></div><div class="sell-btn-wrap"><div class="sell-btn-inner"><p><label for="orderUpload" class="btn btn-primary"><img src="assets/images/search-up-icon.png" alt="download-icon"></label><input type="file" file-reader="vm.content" file-model="vm.fileContent" id="orderUpload" ng-hide="true"><!-- <button type="button" ng-click="vm.downloadData()" class="btn btn-last-tab-buy">DOWNLOAD</button> --> <button type="button" ng-show="vm.orderType==\'SELL\'" ng-disabled="frmOrderEntry.$invalid" class="btn btn-last-tab-sell" ng-click="vm.placeOrder(\'SELL\', \'PLAC\')">SELL</button> <button type="button" ng-show="vm.orderType==\'BUYY\'" ng-disabled="frmOrderEntry.$invalid" class="btn btn-last-tab-buy" ng-click="vm.placeOrder(\'BUYY\', \'PLAC\')">BUY</button> <button type="button" ng-show="vm.orderType==\'MODIFYSELL\'" ng-disabled="frmOrderEntry.$invalid" class="btn btn-last-tab-sell" ng-click="vm.placeOrder(\'SELL\', \'MDFY\')">MODIFY SELL</button> <button type="button" ng-show="vm.orderType==\'MODIFYBUY\'" ng-disabled="frmOrderEntry.$invalid" class="btn btn-last-tab-buy" ng-click="vm.placeOrder(\'BUYY\', \'MDFY\')">MODIFY BUY</button> <button type="button" ng-show="vm.orderType==\'CANCELSELL\'" ng-disabled="frmOrderEntry.$invalid" class="btn btn-last-tab-sell" ng-click="vm.placeOrder(\'SELL\', \'CNCL\')">CANCEL SELL</button> <button type="button" ng-show="vm.orderType==\'CANCELBUY\'" ng-disabled="frmOrderEntry.$invalid" class="btn btn-last-tab-buy" ng-click="vm.placeOrder(\'BUYY\', \'CNCL\')">CANCEL BUY</button> <button type="button" ng-show="vm.orderType==\'SELLBUY\'" ng-disabled="frmOrderEntry.$invalid" class="btn btn-last-tab-sell-buy" ng-click="vm.placeOrder(\'SELLBUY\', \'PLAC\')">SELL & BUY</button></p><p><a href="javascript:void(0)" class="add-remarks" ng-click="vm.addRemarks()"><i class="fa fa-plus" aria-hidden="true"></i> Add Remarks</a> <a href="javascript:void(0)" class="add-remarks-setting" data-toggle="modal" data-target="#modal-settings" ng-click="vm.openOrderPreference()"><img class="logo-icon" src="assets/images/box-right-icon.png" title="Order Preference" alt="icon"></a></p></div></div></div><!--SELL Tab Closed--></div></form></div><div class="order-price" ng-show="vm.orderDTO.activityIndicator!=\'PLAC\'"><form name="frmMdfyOrderEntry"><div><h3>Order at the Price</h3><div class="order-price-tab pull-right text-right"><ul class="nav nav-tabs" id="orderPriceTabs" role="tablist"><li role="presentation" class="active tab-sell" ng-show="vm.orderDTO.buySellIndicator==\'SELL\'"><a ng-click="vm.orderType=\'SELL\'" aria-controls="sell" role="tab" id="modifysellTab" data-toggle="tab">SELL</a></li><li role="presentation" class="tab-buy" ng-show="vm.orderDTO.buySellIndicator==\'BUYY\'"><a ng-click="vm.orderType=\'BUYY\'" aria-controls="buy" role="tab" id="modifybuyTab" data-toggle="tab">BUY</a></li><li role="presentation" class="tab-sell-buy" ng-hide="true"><a ng-click="vm.orderType=\'SELLBUY\'" aria-controls="sellBuy" role="tab" data-toggle="tab">SELL &amp; BUY</a></li></ul></div><div class="clearfix"></div></div><div class="order-price-contents tab-content"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-inner"><ul class="nav nav-tabs orderPriceTabsInner" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode==\'SPOT\'}" ng-show="vm.orderDTO.instrumentCode==\'SPOT\'"><a id="spotInstrument" aria-controls="spot" role="tab" data-toggle="tab" ng-click="vm.defaultInstrumentCode=\'SPOT\'; vm.defaultInstrumentId=3;">SPOT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode==\'CASH\'}" ng-show="vm.orderDTO.instrumentCode==\'CASH\'"><a id="cashInstrument" aria-controls="cash" role="tab" data-toggle="tab" ng-click="vm.defaultInstrumentCode=\'CASH\'; vm.defaultInstrumentId=1;">CASH</a></li><li role="presentation" ng-class="{\'active\': vm.defaultInstrumentCode==\'TOM\'}" ng-show="vm.orderDTO.instrumentCode==\'TOM\'"><a id="tomInstrument" aria-controls="tom" role="tab" data-toggle="tab" ng-click="vm.defaultInstrumentCode=\'TOM\'; vm.defaultInstrumentId=2;">TOM</a></li></ul><div class="search-box"><cspl-ach control-model="vm.tradingBank" control-id="txtbankFilterForPO" lookup-name="tradingBank" filter-value="{{vm.account.organisation.id}}" control-disabled="true" display-column="bankName" form="frmMdfyOrderEntry" required></cspl-ach></div></div><div class="order-price-contents tab-content"><div role="tabpanel" class="tab-pane active"><div class="order-price-tab-last"><!-- Nav tabs --><ul class="nav nav-tabs" style="border:none" role="tablist"><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\' || vm.defaultPriceCondition==\'MRKT\'}" ng-show="vm.orderDTO.typeOfOrder==\'LIMT\' || vm.orderDTO.typeOfOrder==\'MRKT\'"><a id="limitTab" ng-click="vm.defaultPriceCondition=\'LIMT\'">LIMIT</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'STLS\'}" ng-show="vm.orderDTO.typeOfOrder==\'STLS\'"><a id="stoplossTab" ng-click="vm.defaultPriceCondition=\'STLS\'">SL</a></li><li role="presentation" ng-class="{\'active\': vm.defaultPriceCondition==\'TKPR\'}" ng-show="vm.orderDTO.typeOfOrder==\'TKPR\'"><a id="takeprofitTab" ng-click="vm.defaultPriceCondition=\'TKPR\'">TP</a></li></ul><!-- Tab panes --><div class="tab-content"><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'LIMT\' || vm.defaultPriceCondition==\'MRKT\'}" ng-show="vm.defaultPriceCondition==\'LIMT\' || vm.defaultPriceCondition==\'MRKT\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Value</th><th class="text-right">Limit Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" no-of-decimals="0" control-min="0" control-id="txtlimitOrderValue" form="frmMdfyOrderEntry" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtlimitOrderPrice" form="frmMdfyOrderEntry" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType!=\'SELLBUY\'" control-value-change="vm.softCheckDeviationForLimitExchangeRate(vm.orderDTO.limitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</span></td></tbody><tfoot><tr><td class="text-right"><span class="color-theme-txt">LA</span> - <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotBuyLimit | number}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{vm.cashSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{vm.cashBuyLimit | number}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{vm.tomSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{vm.tomBuyLimit | number}}</span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.limitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table><table class="table" ng-show="vm.orderType==\'SELLBUY\'"><thead><th class="text-right">Order Value</th><th class="text-right">Buy Limit Price</th><th class="text-right">Sell Limit Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" no-of-decimals="0" control-min="0" control-id="txtsellbuylimitOrderValue" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.buyLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuylimitBuyOrderPrice" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType==\'SELLBUY\'" control-value-change="vm.softCheckDeviationForBuyLimitExchangeRate(vm.orderDTO.buyLimitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.buyLimitPriceDeviationWarning!=null && vm.buyLimitPriceDeviationWarning!=undefined && vm.buyLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.buyLimitPriceDeviationWarning}}</span></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.sellLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuylimitSellOrderPrice" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'LIMT\' && vm.orderType==\'SELLBUY\'" control-value-change="vm.softCheckDeviationForSellLimitExchangeRate(vm.orderDTO.sellLimitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.sellLimitPriceDeviationWarning!=null && vm.sellLimitPriceDeviationWarning!=undefined && vm.sellLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.sellLimitPriceDeviationWarning}}</span></td></tbody><tfoot><tr><td class="text-right"><span class="color-theme-txt">LA</span> - <span ng-show="vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotSellLimit | number}}, {{vm.retailSpotBuyLimit | number}}</span> <span ng-show="vm.defaultInstrumentCode==\'CASH\'">{{vm.cashSellLimit | number}}, {{vm.cashBuyLimit | number}}</span> <span ng-show="vm.defaultInstrumentCode==\'TOM\'">{{vm.tomSellLimit | number}}, {{vm.tomBuyLimit | number}}</span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.buyLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.sellLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table></div></div><!-- limit tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'STLS\'}" ng-show="vm.defaultPriceCondition==\'STLS\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Value</th><th class="text-right">Limit Price</th><th class="text-right">Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" no-of-decimals="0" control-min="0" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-id="txtslordervalue" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-id="txtsllimitprice" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'" control-value-change="vm.softCheckDeviationForLimitExchangeRate(vm.orderDTO.limitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</span></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.stopExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-id="txtsltriggerprice" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span class="color-theme-txt">LA</span> - <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotBuyLimit | number}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{vm.cashSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{vm.cashBuyLimit | number}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{vm.tomSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{vm.tomBuyLimit | number}}</span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.limitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.stopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table><table class="table" ng-show="vm.orderType==\'SELLBUY\'"><thead><th class="text-right">Order Value</th><th class="text-right">Buy Limit Price</th><th class="text-right">Buy Trigger Price</th><th class="text-right">Sell Limit Price</th><th class="text-right">Sell Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" no-of-decimals="0" control-min="0" control-id="txtsellbuyslordervalue" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.buyLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuyslbuylimitprice" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'" control-value-change="vm.softCheckDeviationForBuyLimitExchangeRate(vm.orderDTO.buyLimitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.buyLimitPriceDeviationWarning!=null && vm.buyLimitPriceDeviationWarning!=undefined && vm.buyLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.buyLimitPriceDeviationWarning}}</span></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.buyStopExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuyslbuytriggerprice" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.sellLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuyslselllimitprice" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'" control-value-change="vm.softCheckDeviationForSellLimitExchangeRate(vm.orderDTO.sellLimitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.sellLimitPriceDeviationWarning!=null && vm.sellLimitPriceDeviationWarning!=undefined && vm.sellLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.sellLimitPriceDeviationWarning}}</span></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.sellStopExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuyslselltriggerprice" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'STLS\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span class="color-theme-txt">LA</span> - <span ng-show="vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotSellLimit | number}}, {{vm.retailSpotBuyLimit | number}}</span> <span ng-show="vm.defaultInstrumentCode==\'CASH\'">{{vm.cashSellLimit | number}}, {{vm.cashBuyLimit | number}}</span> <span ng-show="vm.defaultInstrumentCode==\'TOM\'">{{vm.tomSellLimit | number}}, {{vm.tomBuyLimit | number}}</span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.buyLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.buyStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.sellLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.sellStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table></div></div><!-- sl tab ends --><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultPriceCondition==\'TKPR\'}" ng-show="vm.defaultPriceCondition==\'TKPR\'"><div class="table-responsive"><table class="table" ng-show="vm.orderType!=\'SELLBUY\'"><thead><th class="text-right">Order Value</th><th class="text-right">Limit Price</th><th class="text-right">Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" no-of-decimals="0" control-min="0" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-id="txttpordervalue" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.limitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-id="txttplimitprice" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'" control-value-change="vm.softCheckDeviationForLimitExchangeRate(vm.orderDTO.limitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.limitPriceDeviationWarning!=null && vm.limitPriceDeviationWarning!=undefined && vm.limitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.limitPriceDeviationWarning}}</span></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.stopExchangeRate" no-of-decimals="4" control-min="0" control-disabled="vm.orderDTO.activityIndicator==\'CNCL\'" control-id="txttptriggerprice" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType!=\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span class="color-theme-txt">LA</span> - <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotBuyLimit | number}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'CASH\'">{{vm.cashSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'CASH\'">{{vm.cashBuyLimit | number}}</span> <span ng-show="vm.orderType==\'SELL\' && vm.defaultInstrumentCode==\'TOM\'">{{vm.tomSellLimit | number}}</span> <span ng-show="vm.orderType==\'BUYY\' && vm.defaultInstrumentCode==\'TOM\'">{{vm.tomBuyLimit | number}}</span></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.limitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.stopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.limitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.stopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table><table class="table" ng-show="vm.orderType==\'SELLBUY\'"><thead><th class="text-right">Order Value</th><th class="text-right">Buy Limit Price</th><th class="text-right">Buy Trigger Price</th><th class="text-right">Sell Limit Price</th><th class="text-right">Sell Trigger Price</th></thead><tbody><td class="text-right"><cspl-numeric control-model="vm.orderDTO.orderAmount" no-of-decimals="0" control-min="0" control-id="txtsellbuytpordervalue" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.buyLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuyslbuylimitprice" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'" control-value-change="vm.softCheckDeviationForBuyLimitExchangeRate(vm.orderDTO.buyLimitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.buyLimitPriceDeviationWarning!=null && vm.buyLimitPriceDeviationWarning!=undefined && vm.buyLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.buyLimitPriceDeviationWarning}}</span></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.buyStopExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuytpbuytriggerprice" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.sellLimitExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuytpselllimitprice" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'" control-value-change="vm.softCheckDeviationForSellLimitExchangeRate(vm.orderDTO.sellLimitExchangeRate)"></cspl-numeric><span ng-class="help-block-warning" style="color:#DC3C00" ng-show="vm.sellLimitPriceDeviationWarning!=null && vm.sellLimitPriceDeviationWarning!=undefined && vm.sellLimitPriceDeviationWarning!=\'\'"><i class="icon icon_error-triangle"></i>{{vm.sellLimitPriceDeviationWarning}}</span></td><td class="text-right"><cspl-numeric control-model="vm.orderDTO.sellStopExchangeRate" no-of-decimals="4" control-min="0" control-max="9999999.9999" control-id="txtsellbuytpselltriggerprice" form="frmMdfyOrderEntry" control-required="vm.defaultPriceCondition==\'TKPR\' && vm.orderType==\'SELLBUY\'"></cspl-numeric></td></tbody><tfoot><tr><td class="text-right"><span class="color-theme-txt">LA</span> - <span ng-show="vm.defaultInstrumentCode==\'SPOT\'">{{vm.retailSpotSellLimit | number}}, {{vm.retailSpotBuyLimit | number}}</span> <span ng-show="vm.defaultInstrumentCode==\'CASH\'">{{vm.cashSellLimit | number}}, {{vm.cashBuyLimit | number}}</span> <span ng-show="vm.defaultInstrumentCode==\'TOM\'">{{vm.tomSellLimit | number}}, {{vm.tomBuyLimit | number}}</span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.buyLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.buyStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.sellLimitExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td><td class="text-right"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'">{{vm.orderDTO.sellStopExchangeRateInSpot | number:vm.noOfDecimalsForRate}}</span><br></td></tr><tr><td></td><td class="text-right"><span ng-hide="vm.orderDTO.buyLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.buyStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.sellLimitExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td><td class="text-right"><span ng-hide="vm.orderDTO.sellStopExchangeRateInSpot<0 || vm.defaultInstrumentCode==\'SPOT\'" class="color-theme-txt">(Eqv Spot Price)</span></td></tr></tfoot></table></div></div><!-- tp tab ends --></div></div><!-- sell-spot ends --></div></div><div class="sell-btn-wrap"><div class="sell-btn-inner"><p><a class="back-to-order-entry" ng-click="vm.cancelModifyOrderAction()"><span class="icon arrow_triangle-left"></span>Back</a></p><p><button type="button" ng-show="vm.orderType==\'SELL\' && vm.orderDTO.activityIndicator==\'MDFY\'" ng-disabled="frmMdfyOrderEntry.$invalid" class="btn btn-last-tab-sell" ng-click="vm.placeOrder(\'SELL\', \'MDFY\')">MODIFY SELL</button> <button type="button" ng-show="vm.orderType==\'BUYY\' && vm.orderDTO.activityIndicator==\'MDFY\'" ng-disabled="frmMdfyOrderEntry.$invalid" class="btn btn-last-tab-buy" ng-click="vm.placeOrder(\'BUYY\', \'MDFY\')">MODIFY BUY</button> <button type="button" ng-show="vm.orderType==\'SELL\' && vm.orderDTO.activityIndicator==\'CNCL\'" ng-disabled="frmMdfyOrderEntry.$invalid" class="btn btn-last-tab-sell" ng-click="vm.placeOrder(\'SELL\', \'CNCL\')">CANCEL SELL</button> <button type="button" ng-show="vm.orderType==\'BUYY\' && vm.orderDTO.activityIndicator==\'CNCL\'" ng-disabled="frmMdfyOrderEntry.$invalid" class="btn btn-last-tab-buy" ng-click="vm.placeOrder(\'BUYY\', \'CNCL\')">CANCEL BUY</button></p><p><a href="javascript:void(0)" class="add-remarks" ng-click="vm.addRemarks()"><i class="fa fa-plus" aria-hidden="true"></i> Add Remarks</a> <a href="javascript:void(0)" class="add-remarks-setting" data-toggle="modal" data-target="#modal-settings"><img class="logo-icon" src="assets/images/box-right-icon.png" alt="icon"></a></p></div></div></div><!--SELL Tab Closed--></div></form></div></div></div></div><!-- content-bot-left-wrapper ends --><div class="col-md-7 less-padding"><div class="nav-tab-bot-right"><!-- Nav tabs --><ul class="nav nav-tabs" role="tablist"><li role="presentation" class="active"><a href="#PendingOrders" aria-controls="PendingOrders" role="tab" data-toggle="tab">Pending Orders</a></li><li role="presentation"><a href="#Trades" aria-controls="Trades" role="tab" data-toggle="tab">Trades</a></li><li role="presentation"><a href="#Limits" aria-controls="Limits" role="tab" data-toggle="tab">Limits</a></li></ul><!-- Tab panes --><div class="tab-content"><div role="tabpanel" class="tab-pane active" id="PendingOrders"><div class="bot-right-header-wrapper"><div class="row"><div class="col-sm-9"><div class="nav-tab-bot-header-left"><div class="up-btn"><!-- <a href="#"><img src="assets/images/search-up-icon.png"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\talt="download-icon"></a> --><cspl-table-export table-name="tblPendingOrders" total-record-count="vm.pendingOrders.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="PendingOrders_{{vm.custCode}}_{{vm.bankFilterForPO.bankName}}"></cspl-table-export></div><div class="search-box" ng-show="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.bankFilterForPO" control-id="txtbankFilterForPO" lookup-name="tradingBank" filter-value="{{vm.account.organisation.id}}" display-column="bankName" form="frmtradinghomepage" control-place-holder="Enter bank name" required></cspl-ach></div><div class="search-box" ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.bankFilterForPO" control-id="txtbankFilterForPO" lookup-name="bank" control-place-holder="Enter bank name" display-column="bankName" form="frmtradinghomepage" required></cspl-ach></div><div class="search-box" ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.branchFilterForPO" control-id="txtbranchFilterForPO" lookup-name="validStatusBranchesForBank" filter-value="{{vm.account.organisation.id}}" display-column="branchName" form="frmtradinghomepage" required></cspl-ach></div><div class="search-box" ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.organisation.organisationType.shortName==\'BANK\'"><cspl-ach control-model="vm.customerFilterForPO" control-id="txtcustomerFilterForPO" lookup-name="customer" filter-value="{{vm.bankFilterForPO.id}}~~{{vm.branchFilterForPO.id}}~~{{0}}" display-column="shortName" form="frmtradinghomepage" required></cspl-ach></div><div class="select-box"><select name="select" class="select-opt" ng-model="vm.instrumentFilterForPO" ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id"><option value=""></option></select></div><div class="go-btn"><button type="button" class="btn btn-go" ng-click="vm.getPendingOrdersReport()">GO</button></div></div></div><div class="col-sm-3"><div class="nav-tab-bot-header-right text-right"><div class="search-field"><cspl-table-search control-model="filterTextForPO"></cspl-table-search></div></div></div></div><!-- row ends --></div><div class="bot-right-table"><div class="table-responsive"><table id="tblPendingOrders" class="table table-striped"><thead><tr><th><label class="check-control"><input class="checkbox" name="" value="" ng-model="vm.selectAll" type="checkbox"> <span class="checkbox-overlay-header"></span></label></th><!-- <th>Bank</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Branch</th> --><!-- <th>Customer</th> --><th>Instrument</th><th>B/S</th><th class="text-right">Order Quantity</th><th>Price Condition</th><th class="text-right">Order Price</th><th class="text-right">Eqv. Spot Order Price</th><th class="text-right">Trigger Price</th><th>Time Condition</th><th>GTT</th><th class="text-right">Pending Order Quantity</th><th class="text-right">Traded Quantity</th><th>Order Status</th><th>Order No.</th><th>Last Actioned By</th><th class="text-right">&nbsp;</th></tr></thead><tbody><tr ng-repeat="pendingOrder in filterData = (vm.pendingOrders | filter : filterTextForPO | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)" ng-hide="pendingOrder.pendingOrderAmount==0 || (pendingOrder.orderStatusId!=2 && pendingOrder.orderStatusId!=3 && pendingOrder.orderStatusId!=1)"><td><label class="check-control"><input class="checkbox" name="" ng-model="pendingOrder.select" value="" type="checkbox" ng-disabled="pendingOrder.orderStatus==\'Risk Validated\'"> <span class="checkbox-overlay"></span></label></td><!-- <td class="minimize-field" title="{{pendingOrder.bankName}}"><span>{{pendingOrder.bankName}}</span></td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="minimize-field" title="{{pendingOrder.branchName}}"><span>{{pendingOrder.branchName}}</span></td> --><!-- <td><span>{{pendingOrder.customerCode}}</span></td> --><td><span>{{pendingOrder.instrumentCode}}</span></td><td><span ng-show="pendingOrder.buySellInd==\'BUYY\'">Buy</span> <span ng-show="pendingOrder.buySellInd==\'SELL\'">Sell</span></td><td class="text-right"><span>{{pendingOrder.orderAmount | number}}</span></td><td><span ng-show="pendingOrder.typeOfOrder==\'LIMT\'">Limit</span> <span ng-show="pendingOrder.typeOfOrder==\'MRKT\'">Market</span> <span ng-show="pendingOrder.typeOfOrder==\'STLS\'">Stop Loss</span> <span ng-show="pendingOrder.typeOfOrder==\'TKPR\'">Take Profit</span></td><td class="text-right"><span ng-show="pendingOrder.typeOfOrder!=\'MRKT\'">{{pendingOrder.limitExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right"><span ng-show="pendingOrder.typeOfOrder!=\'MRKT\'">{{pendingOrder.spotlimitExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right"><span ng-show="pendingOrder.typeOfOrder==\'STLS\' || pendingOrder.typeOfOrder==\'TKPR\'">{{pendingOrder.stopExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td><span ng-show="pendingOrder.timeLimitIndicator==\'DAYY\'">Day</span> <span ng-show="pendingOrder.timeLimitIndicator==\'IOCC\'">IOC</span> <span ng-show="pendingOrder.timeLimitIndicator==\'GTTC\'">GTT</span></td><td><span ng-show="pendingOrder.timeLimitIndicator==\'GTTC\'">{{pendingOrder.expiryTime | date:\'HH:mm\'}}</span></td><td class="text-right"><span>{{pendingOrder.pendingOrderAmount | number}}</span></td><td class="text-right"><span>{{pendingOrder.tradedAmount | number}}</span></td><td><span>{{pendingOrder.orderStatus}}</span></td><td><span><a ui-sref="order-activity-pending-orders({orderNumber:pendingOrder.orderSequenceNumber})" style="text-decoration:underline">{{pendingOrder.orderSequenceNumber}}</a></span></td><td><span>{{pendingOrder.retailUserName}}</span></td><td class="text-right"><span class="edit-row"><img src="assets/images/edit-icon.png" ng-click="vm.modifyOrder(pendingOrder);" ng-hide="pendingOrder.orderStatus==\'Risk Validated\'"></span><span class="delete-row"><img src="assets/images/delete-icon.png" ng-click="vm.cancelOrder(pendingOrder);" ng-hide="pendingOrder.orderStatus==\'Risk Validated\'"></span></td></tr></tbody></table></div></div><div class="nav-tab-bot-right-footer"><div class="row"><div class="col-xs-8"><div ng-show="vm.pendingOrders.length > 0"><cspl-pagination record-count="vm.pendingOrders.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="col-xs-4 text-right"><button type="button" class="btn btn-info active" ng-click="vm.cancelAllOrders()">CANCEL SELECTED</button></div></div></div></div><!--PendingOrders Closed--><div role="tabpanel" class="tab-pane" id="Trades"><div class="bot-right-header-wrapper"><div class="row"><div class="col-sm-9"><div class="nav-tab-bot-header-left"><div class="up-btn"><!-- <a href="#"><img src="assets/images/search-up-icon.png"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\talt="download-icon"></a> --><cspl-table-export table-name="tblTrades" total-record-count="vm.trades.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Trades_{{vm.custCode}}_{{vm.bankFilterForTrade.bankName}}"></cspl-table-export></div><div class="search-box" ng-show="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.bankFilterForTrade" control-id="txtbankFilterForTrade" lookup-name="tradingBank" filter-value="{{vm.account.organisation.id}}" display-column="bankName" form="frmtradinghomepage" control-place-holder="Enter bank name" required></cspl-ach></div><div class="search-box" ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.bankFilterForTrade" control-id="txtbankFilterForTrade" lookup-name="bank" control-place-holder="Enter bank name" display-column="bankName" form="frmtradinghomepage" required></cspl-ach></div><div class="search-box" ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.branchFilterForTrade" control-id="txtbranchFilterForTrade" lookup-name="validStatusBranchesForBank" filter-value="{{vm.account.organisation.id}}" display-column="branchName" form="frmtradinghomepage" required></cspl-ach></div><div class="search-box" ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.organisation.organisationType.shortName==\'BANK\'"><cspl-ach control-model="vm.customerFilterForTrade" control-id="txtcustomerFilterForTrade" lookup-name="customer" filter-value="{{vm.bankFilterForTrade.id}}~~{{vm.branchFilterForTrade.id}}~~{{0}}" display-column="shortName" form="approvalPolicyForm" required></cspl-ach></div><div class="select-box"><select name="select" class="select-opt" ng-model="vm.instrumentFilterForTrade" ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id"><option value=""></option></select></div><div class="go-btn"><button type="button" class="btn btn-go" ng-click="vm.getTradesReport()">GO</button></div></div></div><div class="col-sm-3"><div class="nav-tab-bot-header-right text-right"><div class="search-field"><cspl-table-search control-model="filterTextForTrade"></cspl-table-search></div></div></div></div><!-- row ends --></div><div class="bot-right-table"><div class="table-responsive"><table id="tblTrades" class="table table-striped"><thead><tr><!-- <th>Bank</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Branch</th> --><!-- <th>Customer</th> --><th>Instrument</th><th>B/S</th><th class="text-right">Trade Quantity</th><th class="text-right">Trade Price</th><th class="text-right">Eqv. Spot Trade Price</th><th>Trade Date Time</th><th class="text-right">Trade No.</th><th class="text-right">Order No.</th><th>Last Actioned By</th></tr></thead><tbody><tr ng-repeat="trade in filterData = (vm.trades | filter : filterTextForTrade | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><!-- <td><span>{{trade.bankName}}</span></td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td><span>{{trade.branchName}}</span></td> --><!-- <td><span>{{trade.customerName}}</span></td> --><td><span>{{trade.instrumentCode}}</span></td><td><span ng-show="trade.buySellIndicator==\'BUYY\'">Buy</span> <span ng-show="trade.buySellIndicator==\'SELL\'">Sell</span></td><td class="text-right"><span>{{trade.tradedAmount | number}}</span></td><td class="text-right"><span>{{trade.tradedExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right"><span>{{trade.spottradedExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td><span>{{trade.tradeTime| date:\'dd-MMM-yyyy HH:mm:ss\'}}</span></td><td class="text-right"><span>{{trade.tradeSequenceNumber}}</span></td><td class="text-right"><span><a ui-sref="order-activity-pending-orders({orderNumber:trade.orderSequenceNumber})" style="text-decoration:underline">{{trade.orderSequenceNumber}}</a></span></td><td>{{trade.retailUserCode}}</td></tr></tbody></table></div></div><div class="nav-tab-bot-right-footer"><div class="row"><div class="col-xs-8"><div ng-show="vm.trades.length > 0"><cspl-pagination record-count="vm.trades.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></div></div><!--Trades Closed--><div role="tabpanel" class="tab-pane" id="Limits"><div class="bot-right-header-wrapper"><div class="row"><div class="col-sm-9"><div class="nav-tab-bot-header-left"><div class="up-btn"><!-- <a href="#"><img src="assets/images/search-up-icon.png"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\talt="download-icon"></a> --><cspl-table-export table-name="tblLimits" total-record-count="vm.limitsAvailableForSelectedInstrument.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="LimitUtilisation_{{vm.custCode}}_{{vm.bankFilterForLimit.bankName}}"></cspl-table-export></div><div class="search-box" ng-show="vm.account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.bankFilterForLimit" control-id="txtbankFilterForLimit" lookup-name="tradingBank" control-place-holder="Enter bank name" filter-value="{{vm.account.organisation.id}}" display-column="bankName" form="frmtradinghomepage" required></cspl-ach></div><div class="search-box" ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.bankFilterForLimit" control-id="txtbankFilterForLimit" lookup-name="bank" control-place-holder="Enter bank name" display-column="bankName" form="frmtradinghomepage" required></cspl-ach></div><div class="search-box" ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.branchFilterForLimit" control-id="txtbranchFilterForLimit" lookup-name="validStatusBranchesForBank" filter-value="{{vm.account.organisation.id}}" display-column="branchName" form="frmtradinghomepage" required></cspl-ach></div><div class="search-box" ng-show="vm.account.organisation.organisationType.shortName==\'CLEARCORP\' || vm.account.organisation.organisationType.shortName==\'BANK\'"><cspl-ach control-model="vm.customerFilterForLimit" control-id="txtcustomerFilterForLimit" lookup-name="customer" filter-value="{{vm.bankFilterForLimit.id}}~~{{vm.branchFilterForLimit.id}}~~{{0}}" display-column="shortName" form="approvalPolicyForm" required></cspl-ach></div><div class="select-box"><select name="select" class="select-opt" ng-model="vm.instrumentFilterForLimit" ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id"><option value=""></option></select></div><div class="go-btn"><button type="button" class="btn btn-go" ng-click="vm.getLimitUtilisedReport()">GO</button></div></div></div><div class="col-sm-3"><div class="nav-tab-bot-header-right text-right"><div class="search-field"><cspl-table-search control-model="filterTextForLimit"></cspl-table-search></div></div></div></div><!-- row ends --></div><div class="bot-right-table"><div class="table-responsive"><table id="tblLimits" class="table table-striped"><thead><tr><!-- <th rowspan="2" style="">Bank</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th rowspan="2">Branch</th> --><!-- <th rowspan="2">Customer</th> --><th rowspan="2">Instrument</th><th rowspan="2">Limit Type</th><th rowspan="2" class="text-right">Allocated</th><!-- <th></th> --><th colspan="8" class="text-center">Utilised</th><th colspan="2" class="text-center">Un-utilised</th><th rowspan="2" class="text-right">Exposure %</th></tr><tr><!-- \t\t\t\t\t\t\t\t\t\t\t\t<th>Limit CCY</th> --><th class="text-right">Pending Buy Order Value</th><th class="text-right">Pending Sell Order Value</th><th class="text-right">Buy Trade Value</th><th class="text-right">Sell Trade Value</th><th class="text-right">Previous Day Buy Trade</th><th class="text-right">Previous Day Sell Trade</th><th class="text-right">Total Buy</th><th class="text-right">Total Sell</th><th class="text-right">Buying Power</th><th class="text-right">Selling Power</th><!-- <th class="text-right">Exposure %</th> --></tr></thead><tbody><tr ng-repeat="limit in filterData = (vm.limitsAvailableForSelectedInstrument | filter : filterTextForLimit | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><!-- <td><span>{{limit.bankName}}</span></td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td><span>{{limit.branchName}}</span></td> --><!-- <td><span>{{limit.customerCode}}</span></td> --><td><span>{{limit.instrumentCode}}</span></td><td><span ng-show="limit.limitType==\'GROSSBUY\'">Gross Buy</span> <span ng-show="limit.limitType==\'GROSSSELL\'">Gross Sell</span> <span ng-show="limit.limitType==\'GLOBALGROSS\'">Global Gross</span> <span ng-show="limit.limitType==\'NET\'">Net</span></td><!-- \t\t\t\t\t\t\t\t\t\t\t\t<td><span>{{limit.currencyCode}}</span></td> --><td class="text-right"><span>{{limit.limitAllocatedInUSD | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{limit.totalPendingBuyOrderValue | number}}</span></td><td class="text-right"><span>{{limit.totalPendingSellOrderValue | number}}</span></td><td class="text-right"><span>{{limit.totalBuyTradeValue | number}}</span></td><td class="text-right"><span>{{limit.totalSellTradeValue | number}}</span></td><td class="text-right"><span>{{limit.previousDayBuyTradeValue | number}}</span></td><td class="text-right"><span>{{limit.previousDaySellTradeValue | number}}</span></td><td class="text-right" ng-show="limit.limitType!=\'NET\'"><span>{{limit.totalBuyTradeValue + limit.previousDayBuyTradeValue + limit.totalPendingBuyOrderValue | number}}</span></td><td class="text-right" ng-show="limit.limitType!=\'NET\'"><span>{{limit.totalSellTradeValue + limit.previousDaySellTradeValue + limit.totalPendingSellOrderValue | number}}</span></td><td class="text-right" ng-show="limit.limitType==\'NET\'"><span>{{limit.totalPendingBuyOrderValue+((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue)) | number}}</span></td><td class="text-right" ng-show="limit.limitType==\'NET\'"><span>{{limit.totalPendingSellOrderValue+((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue)) | number}}</span></td><td class="text-right"><span>{{vm.getBuyingPower(limit) | number}}</span></td><td class="text-right"><span>{{vm.getSellingPower(limit) | number}}</span></td><td class="text-right"><span>{{vm.getExposure(limit) | number:vm.noOfDecimalsForAmount}}</span></td></tr></tbody></table></div></div><div class="nav-tab-bot-right-footer"><div class="row"><div class="col-xs-8"><div ng-show="vm.limitsAvailableForSelectedInstrument.length > 0"><cspl-pagination record-count="vm.limitsAvailableForSelectedInstrument.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="col-xs-4 text-right"><button type="button" class="btn btn-info active" ng-show="vm.permitCustomerLimitSettings" ng-disabled="vm.bankFilterForLimit==null || vm.bankFilterForLimit==undefined || filterData<=0" ng-click="vm.limitChangeRequest()">CHANGE REQUEST</button></div></div></div></div><!--Limits Closed--></div></div></div></div></div></div>');
$templateCache.put('app/controllers/csplcontrol/csplcontrol.html','<div class="row" style="margin-left: 10px"><div ncy-breadcrumb></div></div><!-- <div class="row" style="margin-left: 10px;">\r\n  <div class="col-lg-12">\r\n      <div class="">\r\n         <section class="module">\r\n             <div class="module-inner">\r\n                 <div class="module-content">\r\n                     <div class="module-content-inner">\r\n                     \t<div class="alert alert-danger" ng-show="vm.captchaNotSet">Captcha not verified</div>\r\n                     \t<div class="alert alert-success" ng-show="vm.submited">{{vm.message}}</div>\r\n                      \t<div ng-form="form1">\r\n\t\t\t\t\t\t\t<div class="csCaptcha"></div>\r\n\t\t\t\t\t\t\t<button ng-click="vm.submit()" class=\'btn btn-primary\'>Submit</button>\r\n\t\t\t\t\t\t</div>\r\n                    </div>\r\n                 </div>\r\n             </div>\r\n         </section>\r\n     </div>\r\n  </div>\r\n</div> --><!-- <div class="row col-lg-12" style="margin-left: 10px;">\r\n\t<marquee scrollamount="3" id="mqMain" style="background-color:white; height:30px; line-height:30px;" onMouseOver=\'this.stop();\' OnMouseOut=\'this.start();\'>\r\n\t      |&nbsp;&nbsp;<span ng-repeat="item in vm.allItems">\r\n\t          <img ng-src="/assets/images/downarrow.jpg" style="padding-top:3px;">&nbsp;&nbsp;{{item.news}}&nbsp;&nbsp;|&nbsp;&nbsp;\r\n\t      </span> \r\n\t</marquee> \r\n</div>\r\n<br />\r\n<div class="row" style="margin-left: 10px;">\r\n\t<button ng-click="vm.hideWidget()" class=\'btn btn-primary\'>Toggle Widget 2</button>\r\n\t<button ng-click="vm.hideRow()" class=\'btn btn-primary\'>Toggle Second Row</button>\r\n</div>\r\n<br />\r\n<div class="row" style="margin-left: 10px;">\r\n    <div class="col-lg-6" id="wg1" ng-show="vm.widget1">\r\n          <section class="item" style="padding:5px;">\r\n              <div class="panel panel-primary">\r\n                  <div class="panel-heading text-center">\r\n                      Widget 1 \r\n                  </div>\r\n                  <div class="panel-body">\r\n                      <div class="module-content-inner ">\r\n                      \t\t<div class="table-responsive" ng-show="vm.widget1Data.length!=0 ">\r\n                              <table class="datatables-nosort table table-striped table-hover">\r\n                                  <thead>\r\n                                      <tr>\r\n                                          <th>Login</th>\r\n                                          <th>First Name</th>\r\n                                          <th>Last Name</th>\r\n                                      </tr>\r\n                                  </thead>\r\n                                  <tbody>\r\n\t                                  <tr ng-repeat="data in vm.widget1Data">\r\n\t                                  \t   <td>{{data.login}}</td>\r\n\t                                  \t   <td>{{data.firstName}}</td>\r\n\t                                  \t   <td>{{data.lastName}}</td>\r\n\t                                  </tr>\r\n                                  </tbody>\r\n                              </table>\r\n                            </div>\r\n                      </div>\r\n                  </div>\r\n              </div>\r\n          </section>\r\n      </div>\r\n    <div class="col-lg-6" id="wg2" ng-show="vm.widget2">\r\n          <section class="item" style="padding:5px;">\r\n              <div class="panel panel-primary">\r\n                  <div class="panel-heading text-center">\r\n                      Widget 2\r\n                  </div>\r\n                  <div class="panel-body">\r\n                      <div class="module-content-inner ">\r\n                      </div>\r\n                  </div>\r\n              </div>\r\n          </section>\r\n      </div>\r\n </div>\r\n \r\n <div class="row" style="margin-left: 10px;">\r\n    <div class="col-lg-12" id="wg3" ng-show="vm.widget3">\r\n          <section class="item" style="padding:5px;">\r\n              <div class="panel panel-primary">\r\n                  <div class="panel-heading text-center">\r\n                      Widget 3 \r\n                  </div>\r\n                  <div class="panel-body">\r\n                      <div class="module-content-inner ">\r\n                      \t\t<div class="table-responsive" ng-show="vm.widget3Data.length!=0 ">\r\n                              <table class="datatables-nosort table table-striped table-hover">\r\n                                  <thead>\r\n                                      <tr>\r\n                                          <th>Login</th>\r\n                                          <th>First Name</th>\r\n                                          <th>Last Name</th>\r\n                                      </tr>\r\n                                  </thead>\r\n                                  <tbody>\r\n\t                                  <tr ng-repeat="data in vm.widget3Data">\r\n\t                                  \t   <td>{{data.login}}</td>\r\n\t                                  \t   <td>{{data.firstName}}</td>\r\n\t                                  \t   <td>{{data.lastName}}</td>\r\n\t                                  </tr>\r\n                                  </tbody>\r\n                              </table>\r\n                            </div>\r\n                      </div>\r\n                  </div>\r\n              </div>\r\n          </section>\r\n      </div>\r\n </div>\r\n \r\n  <div class="row" style="margin-left: 10px;">\r\n    <div class="col-lg-6" id="wg4" ng-show="vm.widget4">\r\n          <section class="item" style="padding:5px;">\r\n              <div class="panel panel-primary">\r\n                  <div class="panel-heading text-center">\r\n                      Widget 4\r\n                  </div>\r\n                  <div class="panel-body">\r\n                      <div class="module-content-inner ">\r\n                      </div>\r\n                  </div>\r\n              </div>\r\n          </section>\r\n      </div>\r\n    <div class="col-lg-6" id="wg5" ng-show="vm.widget5">\r\n          <section class="item" style="padding:5px;">\r\n              <div class="panel panel-primary">\r\n                  <div class="panel-heading text-center">\r\n                      Widget 5\r\n                  </div>\r\n                  <div class="panel-body">\r\n                      <div class="module-content-inner ">\r\n                      </div>\r\n                  </div>\r\n              </div>\r\n          </section>\r\n      </div>\r\n </div> --><div style="margin-left: 10px" data-dashboard="dashboardOptions"></div>');
$templateCache.put('app/controllers/messagebox/alertMessageBox.html','<div><div class="modal-header" ng-class="{ \'alert-softcheck\': vm.messageDetails.alertType==\'warning\' , \'alert-hardcheck\': vm.messageDetails.alertType==\'danger\'}"><h3 class="alert-title">&nbsp;{{vm.messageDetails.msgType}}</h3></div><div class="alert-body"><p ng-bind-html="vm.message" style="font-size:20px; text-align:center"></p><div class="modal-footer" style="text-align:center"><button class="btn btn-primary alert-button" type="button" ng-if="vm.okButton" ng-click="vm.ok()" autofocus>OK</button> <button class="btn btn-info alert-button" type="button" ng-if="vm.noButton" ng-click="vm.no()">No</button> <button class="btn btn-primary alert-button" type="button" ng-if="vm.yesButton" ng-click="vm.yes()" autofocus>Yes</button></div></div></div>');
$templateCache.put('app/controllers/messagebox/messagebox.html','<div><div class="modal-header-red"><div class="modal-header"><h3 class="modal-title">{{vm.messageDetails.messageTitle}}</h3></div><div class="modal-body" style="font-size:14px"><span>{{vm.messageDetails.messageContent}}</span><div class="modal-footer"><button class="btn btn-info" type="button" ng-if="vm.cancelButton" ng-click="vm.cancel()">Cancel</button> <button class="btn btn-primary" type="button" ng-if="vm.okButton" ng-click="vm.ok()" autofocus>OK</button> <button class="btn btn-info" type="button" ng-if="vm.noButton" ng-click="vm.no()">No</button> <button class="btn btn-primary" type="button" ng-if="vm.yesButton" ng-click="vm.yes()" autofocus>Yes</button> <button class="btn btn-primary" type="button" ng-if="vm.proceedButton" ng-click="vm.proceed()" autofocus>Proceed</button></div></div></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-12"><h2 style="text-align: center" data-translate="error.title">Error Page!</h2><div class="alert alert-danger" style="width: 30%" data-translate="error.http.403">You are not authorized to access this page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/favicon.png" alt="logo"> <span data-translate="global.title">Gateway</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><li ng-hide="vm.inProduction"><a href="/h2-console" target="_tab" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-hdd"></span>&nbsp; <span data-translate="global.menu.admin.database">Database</span></a></li></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/entities/amc-settings/amc-settings-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="amcSettingsEditForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span ng-show="vm.amcSetting.id==null" data-translate="global.menu.amcSettings.addNewAMC"></span> <span ng-show="vm.amcSetting.id!=null" data-translate="global.menu.amcSettings.editAMC"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset><br><div class="col-sm-7 col-centered"><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.amcSetting.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bank" control-disabled="vm.viewMode || (vm.amcSetting.id!=null || showResubmitButton)" display-column="bankName" placeholder="" form="amcSettingsEditForm" control-required="true"></div><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered" cspl-mandatory><span data-translate="gatewayApp.amcSetting.amc"></span></label><div class="col-xs-9 col-md-9 multi-col"><cspl-numeric control-model="vm.amcSetting.charges" control-id="txtCharges" no-of-decimals="{{vm.noOfDecimals}}" control-min="0" control-max="999999999999.99" form="amcSettingsEditForm" control-disabled="vm.viewMode" control-required="true"></cspl-numeric></div><div class="col-xs-1 col-md-1" style="line-height:30px"><span data-translate="gatewayApp.amcSetting.inr"></span></div></div></div><div class="col-xs-7 col-centered"><div class="form-group" ng-show="vm.showEffectiveFrom"><label class="col-md-12 col-xs-12 col-centered control-label" cspl-mandatory><span data-translate="gatewayApp.amcSetting.effectiveFrom"></span></label><div class="col-md-9 col-xs-9 multi-col"><cspl-dtp control-model="vm.effectiveFrom" control-id="dtpEffectiveFrom" form="amcSettingsEditForm" control-disabled="true" required></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered" cspl-mandatory><span data-translate="gatewayApp.amcSetting.financialYear"></span></label><div class="col-xs-12 col-md-12 multi-col"><cspl-text control-model="vm.financialYear" control-id="txtfinancialyear" control-disabled="true" form="amcSettingsEditForm" required></div></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="amcSettingsEditForm.$invalid || vm.clicked" ng-click="vm.clicked = true;vm.resubmitAMC();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="amcSettingsEditForm.$invalid  || vm.clicked" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardAMC()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectAMC()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveAMC();vm.clicked=true;" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/amc-settings/amc-settings.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.amcSettings.title">AMC Settings</h2><nmb-alert></nmb-alert><div><!-- <nmb-alert-error></nmb-alert-error>  --></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="float-right"><button type="button" class="btn btn-info active" ng-click="vm.screenLog.screenLog(vm.screenName,0,vm.entityConstants.ENTITY_ACTION_TYPE.ADD);vm.launch()" ng-show="vm.permitAMCSettingsAddEntityAction"><img ng-src="assets/images/Add.png"> <span data-translate="global.menu.amcSettings.newAMC"></span></button></div><div class="float-right col-xs-10 col-sm-3 col-md-2"><cspl-table-search control-model="filterText"></cspl-table-search></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="amcSettings" total-record-count="vm.amcSettings.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="AMC_Settings"></cspl-table-export></div><div class="pull-left" style="margin-left: 0px" ng-show="vm.permitAMCSettingsImportEntityAction"><cspl-table-import upload-type="AMCImport" file-content=""></cspl-table-import></div></div><div class="bootstrap-tableresponsive"><table id="amcSettings" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.amcSetting.bank">Bank</th><th data-translate="gatewayApp.amcSetting.effectiveFrom">Effective From</th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.amcSetting.amc">AMC</th><th></th></tr></thead><tbody><tr ng-repeat="amcSettings in filterData = (vm.amcSettings | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{amcSettings.bank.bankName}}</td><td>{{amcSettings.bank.dateOfJoining | date : \'dd-MMM-yyyy\'}}</td><td class="td-text-align-right noPaddingLeftRight">{{amcSettings.charges | number : vm.noOfDecimalsForAmount}}</td><td width="10%" style="text-align:right"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitAMCSettingsEditEntityAction"><a ui-sref="amc-settings-edit({id:amcSettings.id})" ng-click="vm.screenLog.screenLog(vm.screenName, amcSettings.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table><div style="padding:5px" ng-show="vm.amcSettings.length==0"><span>No record found</span></div><div ng-show="vm.amcSettings.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/add-remarks/add-remarks.html','<form name="addRemarksForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title">Add Remarks</h4></div><div class="modal-body"><div class="content"><!-- Remove the remark --><div ng-repeat="remarks in vm.remarkList track by $index" ng-if="remarks !== null"><div class="row"><label class="col-md-6 col-md-offset-3 control-label">Remarks<span ng-if="$index != 0">&nbsp;{{$index+1}}</span></label></div><!-- data-translate="gatewayApp.addRemarks.remarks" --><div class="row"><div class="col-md-7 col-md-offset-3"><!-- <cspl-text control-model="vm.remarks" control-type="Alphanumeric" control-id="txtremarks" control-maxlength="100" form="addRemarksForm" /> --><cspl-multiline-text control-model="vm.remarkList[$index]" control-maxlength="100" control-id="txtremarks" form="addRemarksForm" allow-enter="false" control-value-change="vm.remarksValidation(vm.remarkList[$index],$index)" ng-paste="$event.preventDefault()" autofocus></div><!-- remove Additional Remarks --> <img ng-if="$index != 0" src="assets/images/icons8-cancel-24.png" alt="Avatar" style="width: 25px; height: 25px; border:0px" title="Remove" ng-click="vm.removeAdditionalRemark($index)"></div></div><!-- add Additional Remarks --><div class="col-md-7 col-md-offset-3"><p ng-hide="vm.remarkList.length==vm.maxRemark" href="javascript:void(0)" class="add-remarks" data-toggle="tooltip" ng-click="vm.addAdditionalRemark()"><i class="fa fa-plus"></i>&nbsp;Additional Remarks</p></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-info active" ng-disabled="clicked" ng-click="vm.add();"><span data-translate="entity.action.ok">Ok</span></button></div></form>');
$templateCache.put('app/entities/amc-summary/amc-summary.html','<div class="container-fluid" ng-cloak><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.amcSummary.title"></h2><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseAMCSummary = !vm.ExpandOrCollapseAMCSummary" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#AMCSummary"><img ng-src="{{vm.ExpandOrCollapseAMCSummary == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.amcSummary.criteria">Criteria</span></a></h4></div><div id="AMCSummary" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="amcSummaryForm"><div class="col-md-offset-2 col-lg-offset-3 col-sm-offset-1 col-md-5 col-sm-6 col-xs-10 col-lg-5"><div class="form-group col-md-12" style="margin-bottom: 23px"><div id="btnGroup"><div class="btn-group"><label class="btn btn-primary" style="font-size: 12px" ng-model="vm.freshOrPrintOption" uib-btn-radio="\'PrintGeneratedInvoice\'">Print Generated Invoice</label><label class="btn btn-primary" style="font-size: 12px" ng-model="vm.freshOrPrintOption" uib-btn-radio="\'GenerateAfresh\'">Generate Afresh</label></div></div></div><div class="col-md-10"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.amcSummary.financialYear"></span></label></div><div class="form-group col-sm-7 col-md-9 col-lg-7 col-xs-7" style="margin-bottom: 23px"><select class="form-control select-style" name="financialYear" ng-model="vm.financialYear" ng-options="financialYear.displayYear for financialYear in vm.allFinancialYears track by financialYear.displayYear" form="amcSummaryForm" required></select></div><div class="col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-left"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.amcSummary.from"></span></label></span></div><div class="form-group col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-right no-padding-left"><cspl-dtp control-model="vm.fromDate" control-id="dtpFromDate" control-min-date="vm.minDate" control-max-date="vm.maxDate" control-disabled="true" form="amcSummaryForm" required></cspl-dtp></span></div><div class="col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-left"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.amcSummary.to"></span></label></span></div><div class="form-group col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-right no-padding-left"><cspl-dtp control-model="vm.toDate" control-id="dtpToDate" control-min-date="vm.minToDate" control-max-date="vm.maxToDate" control-disabled="true" form="amcSummaryForm" required></cspl-dtp></span><span class="col-md-2 col-sm-2 col-xs-2" style="text-align: right"><button class="btn btn-info active" ng-disabled="vm.clicked" ng-click="vm.getAmcSummary();" data-toggle="collapse" data-target="#AMCSummary" data-translate="gatewayApp.amcSummary.go"></button></span></div></div></form></div></div></div><div ng-show="vm.amcSummaryDetails.headerList.length > 0"><div class="row"><div class="dropdown col-md-3" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportDataToFile(\'csv\')">CSV</a></li><li><a ng-click="vm.exportDataToFile(\'xls\');">XLS</a></li><li><a ng-click="vm.exportDataToFile(\'pdf\')">PDF</a></li></ul></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search><div class="col-xs-4 text-right pull-right" ng-show="vm.showDownloadEInvoice"><button type="button" class="btn btn-info active" id="btnDownloadEInvoice" style="margin: 0px;text-transform: none !important" ng-click="vm.downloadEInvoice()" ng-disabled="vm.eInvoiceDisable"><span data-translate="entity.action.downloadEInvoice"></span></button></div></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="amcSummaryHeader" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.amcSummary.memberName"></th><th data-translate="gatewayApp.amcSummary.membershipId"></th><th data-translate="gatewayApp.amcSummary.invoiceNumber"></th><th style="min-width: 65px" data-translate="gatewayApp.amcSummary.segment"></th><th style="min-width: 80px" data-translate="gatewayApp.amcSummary.dateOfJoining"></th><th data-translate="gatewayApp.amcSummary.bankStateName"></th><th data-translate="gatewayApp.amcSummary.bankGSTIN"></th><th class="td-text-align-right" data-translate="gatewayApp.amcSummary.stateCode"></th><th class="td-text-align-right" data-translate="gatewayApp.amcSummary.amc"></th><th class="td-text-align-right" data-translate="gatewayApp.amcSummary.cgst"></th><th class="td-text-align-right" data-translate="gatewayApp.amcSummary.sgst"></th><th class="td-text-align-right" data-translate="gatewayApp.amcSummary.igst"></th><th class="td-text-align-right" data-translate="gatewayApp.amcSummary.utgst"></th><th class="td-text-align-right" data-translate="gatewayApp.amcSummary.totalTax"></th><th class="td-text-align-right" data-translate="gatewayApp.amcSummary.totalCharges"></th></tr></thead><tbody><tr ng-repeat="amcSummary in filterData = (vm.amcSummaryDetails.headerList| filter : filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break: break-word">{{amcSummary.bankChargesDTO.bankName}}</td><td>{{amcSummary.bankChargesDTO.membershipID}}</td><td><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\'">{{amcSummary.invoiceNumber}}</span><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\'">-</span></td><td>{{vm.amcSummaryDetails.platformName}}</td><td>{{amcSummary.bankChargesDTO.dateOfJoining | date : \'dd-MMM-yyyy\'}}</td><td><span ng-show="amcSummary.bankChargesDTO.state != null && amcSummary.bankChargesDTO.state.length > 0">{{amcSummary.bankChargesDTO.state}}</span><span ng-show="amcSummary.bankChargesDTO.state == null || amcSummary.bankChargesDTO.state.length == 0">-</span></td><td><span ng-show="amcSummary.bankChargesDTO.gstin != null && amcSummary.bankChargesDTO.gstin.length > 0">{{amcSummary.bankChargesDTO.gstin}}</span><span ng-show="amcSummary.bankChargesDTO.gstin == null || amcSummary.bankChargesDTO.gstin.length == 0">-</span></td><td class="td-text-align-right"><span ng-show="amcSummary.bankChargesDTO.tinNumber != null && amcSummary.bankChargesDTO.tinNumber != 0">{{amcSummary.bankChargesDTO.tinNumber}}</span><span ng-show="amcSummary.bankChargesDTO.tinNumber == null || amcSummary.bankChargesDTO.tinNumber == 0">-</span></td><td class="td-text-align-right"><span ng-show="amcSummary.chargeDetails.grossCharges == null">-</span><span ng-show="amcSummary.chargeDetails.grossCharges != null">{{amcSummary.chargeDetails.grossCharges | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || amcSummary.bankChargesDTO.cgstPercent == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && amcSummary.bankChargesDTO.cgstPercent != null">{{amcSummary.chargeDetails.cgstAmount | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || amcSummary.bankChargesDTO.sgstPercent == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && amcSummary.bankChargesDTO.sgstPercent != null">{{amcSummary.chargeDetails.sgstAmount | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || amcSummary.bankChargesDTO.integratedTax == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && amcSummary.bankChargesDTO.integratedTax != null">{{amcSummary.chargeDetails.igstAmount | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || amcSummary.bankChargesDTO.utTaxPercent == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && amcSummary.bankChargesDTO.utTaxPercent != null">{{amcSummary.chargeDetails.utgstAmount | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' ||  ( amcSummary.bankChargesDTO.cgstPercent == null && amcSummary.bankChargesDTO.sgstPercent == null \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& amcSummary.bankChargesDTO.integratedTax == null && amcSummary.bankChargesDTO.utTaxPercent == null )">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && !( amcSummary.bankChargesDTO.cgstPercent == null && amcSummary.bankChargesDTO.sgstPercent == null \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& amcSummary.bankChargesDTO.integratedTax == null && amcSummary.bankChargesDTO.utTaxPercent == null )">{{amcSummary.chargeDetails.totalTaxAmount | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="amcSummary.chargeDetails.netCharges == null">-</span><span ng-show="amcSummary.chargeDetails.netCharges != null">{{amcSummary.chargeDetails.netCharges | currency:"" : vm.noOfDecimalsForAmount}}</span></td></tr></tbody><tfoot class="rounded-off-bar" ng-show="filterText == null || filterText.length == 0"><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td data-translate="gatewayApp.amcSummary.grandTotal"></td><td class="td-text-align-right"><span ng-show=" vm.amcSummaryDetails.headerListGrandTotalCharges.grossCharges == null">-</span><span ng-show=" vm.amcSummaryDetails.headerListGrandTotalCharges.grossCharges != null">{{vm.amcSummaryDetails.headerListGrandTotalCharges.grossCharges | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || vm.amcSummaryDetails.headerListGrandTotalCharges.cgstAmount == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && vm.amcSummaryDetails.headerListGrandTotalCharges.cgstAmount != null">{{vm.amcSummaryDetails.headerListGrandTotalCharges.cgstAmount| currency:"" : vm.noOfDecimalsForAmount }}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || vm.amcSummaryDetails.headerListGrandTotalCharges.sgstAmount == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && vm.amcSummaryDetails.headerListGrandTotalCharges.sgstAmount != null">{{vm.amcSummaryDetails.headerListGrandTotalCharges.sgstAmount| currency:"" : vm.noOfDecimalsForAmount }}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || vm.amcSummaryDetails.headerListGrandTotalCharges.igstAmount == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && vm.amcSummaryDetails.headerListGrandTotalCharges.igstAmount != null">{{vm.amcSummaryDetails.headerListGrandTotalCharges.igstAmount| currency:"" : vm.noOfDecimalsForAmount }}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || vm.amcSummaryDetails.headerListGrandTotalCharges.utgstAmount == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && vm.amcSummaryDetails.headerListGrandTotalCharges.utgstAmount != null">{{vm.amcSummaryDetails.headerListGrandTotalCharges.utgstAmount| currency:"" : vm.noOfDecimalsForAmount }}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || vm.amcSummaryDetails.headerListGrandTotalCharges.totalTaxAmount == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && vm.amcSummaryDetails.headerListGrandTotalCharges.totalTaxAmount != null">{{vm.amcSummaryDetails.headerListGrandTotalCharges.totalTaxAmount| currency:"" : vm.noOfDecimalsForAmount }}</span></td><td class="td-text-align-right"><span ng-show=" vm.amcSummaryDetails.headerListGrandTotalCharges.netCharges == null">-</span><span ng-show=" vm.amcSummaryDetails.headerListGrandTotalCharges.netCharges != null">{{vm.amcSummaryDetails.headerListGrandTotalCharges.netCharges| currency:"" : vm.noOfDecimalsForAmount }}</span></td></tr></tfoot></table></div><div ng-show="filterData.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="table-responsive" ng-show="vm.issuePresent == true || vm.amcSummaryDetails.headerList.length == 0"><span>No record found</span></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/application-wide-settings-dealingadmin/application-wide-settings.html','<form name="configurationSettingsForm" role="form" novalidate><script src="app/app.module.js"></script><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="global.menu.applicationWideSettings.settings"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><div class="column"><div class="tab"><div class="img-with-text"><img src="assets/images/RegistrationAdminSettingsCurrent.png" style="width: 40px; height: 40px" ng-show="vm.isShowRegistrationSettings"> <img src="assets/images/RegistrationAdminSettings.png" style="width: 40px; height: 40px" ng-show="!vm.isShowRegistrationSettings" ng-click="vm.isShowRegistrationSettings=true;vm.isShowOrderSettings=false;vm.isShowLimitSettings=false;vm.isShowGSTSettings=false;vm.isShowOther=false;vm.isShowOrderAmountSettings=false;"><p style="text-align: center">Registration Settings</p></div><div class="img-with-text"><img src="assets/images/OrderSettingsCurrent.png" ng-show="vm.isShowOrderSettings" style="width: 40px; height: 40px"> <img src="assets/images/OrderSettings.png" ng-show="!vm.isShowOrderSettings" style="width: 40px; height: 40px" ng-click="vm.isShowRegistrationSettings=false;vm.isShowOrderSettings=true;vm.isShowLimitSettings=false;vm.isShowGSTSettings=false;vm.isShowOther=false;vm.isShowOrderAmountSettings=false;"><p style="text-align: center">Order Settings</p></div><div class="img-with-text"><img src="assets/images/LimitSettingsCurrent.png" ng-show="vm.isShowLimitSettings" style="width: 40px; height: 40px"> <img src="assets/images/LimitSettings.png" ng-show="!vm.isShowLimitSettings" style="width: 40px; height: 40px" ng-click="vm.isShowRegistrationSettings=false;vm.isShowOrderSettings=false;vm.isShowLimitSettings=true;vm.isShowGSTSettings=false;vm.isShowOther=false;vm.isShowOrderAmountSettings=false;"><p style="text-align: center">Limit Settings</p></div><div class="img-with-text" ng-hide="true"><img src="assets/images/GSTSettingsCurrent.png" ng-show="vm.isShowGSTSettings" style="width: 40px; height: 40px"> <img src="assets/images/GSTSettings.png" ng-show="!vm.isShowGSTSettings" style="width: 40px; height: 40px" ng-click="vm.isShowRegistrationSettings=false;vm.isShowOrderSettings=false;vm.isShowLimitSettings=false;vm.isShowGSTSettings=true;vm.isShowOther=false;vm.isShowOrderAmountSettings=false;"><p style="text-align: center">GST Settings</p></div><div class="img-with-text"><img src="assets/images/OthersCurrent.png" ng-show="vm.isShowOther" style="width: 40px; height: 40px"> <img src="assets/images/Others.png" ng-show="!vm.isShowOther" style="width: 40px; height: 40px" ng-click="vm.isShowRegistrationSettings=false;vm.isShowOrderSettings=false;vm.isShowLimitSettings=false;vm.isShowGSTSettings=false;vm.isShowOther=true;vm.isShowOrderAmountSettings=false;"><p style="text-align: center">Others</p></div><div class="img-with-text"><img src="assets/images/OrderSettingsCurrent.png" ng-show="vm.isShowOrderAmountSettings" style="width: 40px; height: 40px"> <img src="assets/images/OrderSettings.png" ng-show="!vm.isShowOrderAmountSettings" style="width: 40px; height: 40px" ng-click="vm.isShowRegistrationSettings=false;vm.isShowOrderSettings=false;vm.isShowLimitSettings=false;vm.isShowGSTSettings=false;vm.isShowOther=false;vm.isShowOrderAmountSettings=true;"><p style="text-align: center">Currency Wise Order Settings</p></div></div></div><div class="column" style="background-color: #000000; width: 80%"><div id="RegistrationAdminSettings" ng-show="vm.isShowRegistrationSettings"><div class="row"><label class="col-md-7 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.autoWithdrawalOfCustomerRegistrationApplication"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.autoWithdrawalOfCustomerRegistrationApplication" control-id="txtautoWithdrawalOfCustomerRegistrationApplication" control-disabled="true" no-of-decimals="{{}}" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Registration Admin Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.autoWithdrawalOfCustomerRegistrationApplication\' | translate}}\' ,configName: \'AutoWithdrawalOfCustomerRegistrationApplication\' , configValue: vm.applicationWideSettings.autoWithdrawalOfCustomerRegistrationApplication, controlType : \'numeric\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div></div><div id="OrderSettings" ng-show="vm.isShowOrderSettings"><!-- <div class="row">\r\n\t\t\t\t\t\t<label class="col-md-8 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage"></span></label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t<div class="col-md-2 col-md-offset-1">\r\n\t\t\t\t\t\t\t<cspl-numeric\r\n\t\t\t\t\t\t\t\tcontrol-model="vm.applicationWideSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage"\r\n\t\t\t\t\t\t\t\tcontrol-id="txtallowedOrderPriceDeviationFromMarketPriceInPercentage"\r\n\t\t\t\t\t\t\t\tno-of-decimals="{{vm.decimalsForPercent}}" control-disabled="true"\r\n\t\t\t\t\t\t\t\tform="configurationSettingsForm" currency-code="" required />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<a style="text-decoration: none;" title="Change Config"\r\n\t\t\t\t\t\t\tng-click="vm.validateAndChangeConfig(\'Order Settings\', \'Allowed order price deviation from the market price in % (Hard Check)\', \'AllowedOrderPriceDeviationFromMarketPriceInPercentage\', vm.applicationWideSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage, \'percentage\', \'dealingadmin\');">\r\n\t\t\t\t\t\t\t<img src="assets/images/EditProfile.png" alt="Avatar"\r\n\t\t\t\t\t\t\t\tstyle="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div> --><!-- <div class="row">\r\n\t\t\t\t\t\t<label class="col-md-8 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.allowedOrderPriceDeviationFromMarketPriceInPaise"></span></label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t<div class="col-md-3 col-md-offset-1">\r\n\t\t\t\t\t\t\t<cspl-numeric\r\n\t\t\t\t\t\t\t\tcontrol-model="vm.applicationWideSettings.allowedOrderPriceDeviationFromMarketPriceInPaise"\r\n\t\t\t\t\t\t\t\tcontrol-id="txtallowedOrderPriceDeviationFromMarketPriceInPaise" no-of-decimals="{{}}"\r\n\t\t\t\t\t\t\t\tcontrol-disabled="true" form="configurationSettingsForm" currency-code="" required />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<a style="text-decoration: none;" title="Change Config"\r\n\t\t\t\t\t\t\tui-sref="dealing-admin-change-config({headerLabel: \'Order Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.allowedOrderPriceDeviationFromMarketPriceInPaise\' | translate}}\' ,configName: \'AllowedOrderPriceDeviationFromMarketPriceInPaise\' , configValue: vm.applicationWideSettings.allowedOrderPriceDeviationFromMarketPriceInPaise, controlType : \'numeric\', screenName : \'dealingadmin\'})">\r\n\t\t\t\t\t\t\t<img src="assets/images/EditProfile.png" alt="Avatar"\r\n\t\t\t\t\t\t\t\tstyle="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div> --><!-- <div class="row">\r\n\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.minimumOrderValue"></span></label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t<div class="col-md-3 col-md-offset-1">\r\n\t\t\t\t\t\t\t<cspl-numeric control-model="vm.applicationWideSettings.minimumOrderValue"\r\n\t\t\t\t\t\t\t\tcontrol-id="txtminimumOrderValue" no-of-decimals="{{vm.decimalsForPaise}}"\r\n\t\t\t\t\t\t\t\tcontrol-disabled="true" form="configurationSettingsForm" currency-code="" required />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<a style="text-decoration: none;" title="Change Config"\r\n\t\t\t\t\t\t\tng-click="vm.validateAndChangeConfig(\'Order Settings\', \'Minimum Order Value (in USD)\', \'MinimumOrderValue\', vm.applicationWideSettings.minimumOrderValue, \'numericwithdecimals\', \'dealingadmin\');">\r\n\t\t\t\t\t\t\t<img src="assets/images/EditProfile.png" alt="Avatar"\r\n\t\t\t\t\t\t\t\tstyle="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div> --><!-- <div class="row">\r\n\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.maximumOrderValueHardCheck"></span></label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t<div class="col-md-3 col-md-offset-1">\r\n\t\t\t\t\t\t\t<cspl-numeric control-model="vm.applicationWideSettings.maximumOrderValueHardCheck"\r\n\t\t\t\t\t\t\t\tcontrol-id="txtmaximumOrderValueHardCheck" no-of-decimals="{{vm.decimalsForAmount}}"\r\n\t\t\t\t\t\t\t\tcontrol-disabled="true" form="configurationSettingsForm" currency-code="" required />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<a style="text-decoration: none;" title="Change Config"\r\n\t\t\t\t\t\t\tng-click="vm.validateAndChangeConfig(\'Order Settings\', \'Maximum Order Value Hard Check (in USD)\', \'MaximumOrderValueHardCheck\', vm.applicationWideSettings.maximumOrderValueHardCheck, \'numericwithdecimals\', \'dealingadmin\');">\r\n\t\t\t\t\t\t\t<img src="assets/images/EditProfile.png" alt="Avatar"\r\n\t\t\t\t\t\t\t\tstyle="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div> --><!-- <div class="row">\r\n\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.maximumOrderValueSoftCheck"></span></label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t<div class="col-md-3 col-md-offset-1">\r\n\t\t\t\t\t\t\t<cspl-numeric control-model="vm.applicationWideSettings.maximumOrderValueSoftCheck"\r\n\t\t\t\t\t\t\t\tcontrol-id="txtmaximumOrderValueSoftCheck" no-of-decimals="{{vm.decimalsForAmount}}"\r\n\t\t\t\t\t\t\t\tcontrol-disabled="true" form="configurationSettingsForm" currency-code="" required />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<a style="text-decoration: none;" title="Change Config"\r\n\t\t\t\t\t\t\tng-click="vm.validateAndChangeConfig(\'Order Settings\', \'Maximum Order Value Soft Check (in USD)\', \'MaximumOrderValueSoftCheck\', vm.applicationWideSettings.maximumOrderValueSoftCheck, \'numericwithdecimals\', \'dealingadmin\');">\r\n\t\t\t\t\t\t\t<img src="assets/images/EditProfile.png" alt="Avatar"\r\n\t\t\t\t\t\t\t\tstyle="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div> --><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.marketMovementInterval"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.marketMovementInterval" control-id="txtmarketMovementInterval" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Order Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.marketMovementInterval\' | translate}}\' , configName: \'MarketMovementInterval\' ,configValue: vm.applicationWideSettings.marketMovementInterval, controlType : \'numeric\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.orderLotSize"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.orderLotSize" control-id="txtOrderLotSize" no-of-decimals="{{vm.decimalsForPaise}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ng-click="vm.validateAndChangeConfig(\'Order Settings\', \'Order Lot Size (in USD)\', \'OrderLotSize\', vm.applicationWideSettings.orderLotSize, \'numericwithdecimals\', \'dealingadmin\');"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.isAllowStopLossOrder"></span></label></div><div class="row"><div id="btnGroup" class="col-md-2 col-md-offset-1" style="padding-bottom:7px"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.applicationWideSettings.isAllowStopLossOrder" ng-disabled="true" uib-btn-radio="\'Yes\'">Yes</label><label class="btn btn-primary" ng-model="vm.applicationWideSettings.isAllowStopLossOrder" ng-disabled="true" uib-btn-radio="\'No\'">No&nbsp;</label></div></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Order Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.isAllowStopLossOrder\' | translate}}\' ,configName: \'IsAllowStopLossOrder\' , configValue: vm.applicationWideSettings.isAllowStopLossOrder, controlType : \'yesorno\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px;margin-top:6px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.isAllowTakeProfitOrder"></span></label></div><div class="row"><div id="btnGroup" class="col-md-2 col-md-offset-1" style="padding-bottom:7px"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.applicationWideSettings.isAllowTakeProfitOrder" ng-disabled="true" uib-btn-radio="\'Yes\'">Yes</label><label class="btn btn-primary" ng-model="vm.applicationWideSettings.isAllowTakeProfitOrder" ng-disabled="true" uib-btn-radio="\'No\'">No&nbsp;</label></div></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Order Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.isAllowTakeProfitOrder\' | translate}}\' ,configName: \'IsAllowTakeProfitOrder\' , configValue: vm.applicationWideSettings.isAllowTakeProfitOrder, controlType : \'yesorno\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px;margin-top:6px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.isAllowMarketOrder"></span></label></div><div class="row"><div id="btnGroup" class="col-md-2 col-md-offset-1" style="padding-bottom: 7px"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.applicationWideSettings.isAllowMarketOrder" ng-disabled="true" uib-btn-radio="\'Yes\'">Yes</label><label class="btn btn-primary" ng-model="vm.applicationWideSettings.isAllowMarketOrder" ng-disabled="true" uib-btn-radio="\'No\'">No&nbsp;</label></div></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Order Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.isAllowMarketOrder\' | translate}}\' ,configName: \'IsAllowMarketOrder\' , configValue: vm.applicationWideSettings.isAllowMarketOrder, controlType : \'yesorno\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px; margin-top: 6px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><!-- <div class="row">\r\n\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.isAllowDisclosedValue"></span></label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t<div id="btnGroup" class="col-md-2 col-md-offset-1">\r\n\t\t\t\t\t\t\t<div class="btn-group">\r\n\t\t\t\t\t\t\t\t<label class="btn btn-primary"\r\n\t\t\t\t\t\t\t\t\tng-model="vm.applicationWideSettings.isAllowDisclosedValue" ng-disabled=true\r\n\t\t\t\t\t\t\t\t\tuib-btn-radio="\'Yes\'">Yes</label> <label class="btn btn-primary"\r\n\t\t\t\t\t\t\t\t\tng-model="vm.applicationWideSettings.isAllowDisclosedValue" ng-disabled=true\r\n\t\t\t\t\t\t\t\t\tuib-btn-radio="\'No\'">No&nbsp;</label>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<a style="text-decoration: none;" title="Change Config"\r\n\t\t\t\t\t\t\tui-sref="dealing-admin-change-config({headerLabel: \'Order Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.isAllowDisclosedValue\' | translate}}\' ,configName: \'IsAllowDisclosedValue\' , configValue: vm.applicationWideSettings.isAllowDisclosedValue, controlType : \'yesorno\', screenName : \'dealingadmin\'})">\r\n\t\t\t\t\t\t\t<img src="assets/images/EditProfile.png" alt="Avatar"\r\n\t\t\t\t\t\t\tstyle="width: 25px; height: 25px;margin-top:6px;">&nbsp;<span aria-hidden="true" class="icon"></span>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div> --><!-- <div class="row">\r\n\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.isAllowMinimumFillValue"></span></label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t<div id="btnGroup" class="col-md-2 col-md-offset-1">\r\n\t\t\t\t\t\t\t<div class="btn-group">\r\n\t\t\t\t\t\t\t\t<label class="btn btn-primary"\r\n\t\t\t\t\t\t\t\t\tng-model="vm.applicationWideSettings.isAllowMinimumFillValue" ng-disabled=true\r\n\t\t\t\t\t\t\t\t\tuib-btn-radio="\'Yes\'">Yes</label> <label class="btn btn-primary"\r\n\t\t\t\t\t\t\t\t\tng-model="vm.applicationWideSettings.isAllowMinimumFillValue" ng-disabled=true\r\n\t\t\t\t\t\t\t\t\tuib-btn-radio="\'No\'">No&nbsp;</label>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<a style="text-decoration: none;" title="Change Config"\r\n\t\t\t\t\t\t\tui-sref="dealing-admin-change-config({headerLabel: \'Order Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.isAllowMinimumFillValue\' | translate}}\' ,configName: \'IsAllowMinimumFillValue\' , configValue: vm.applicationWideSettings.isAllowMinimumFillValue, controlType : \'yesorno\', screenName : \'dealingadmin\'})">\r\n\t\t\t\t\t\t\t<img src="assets/images/EditProfile.png" alt="Avatar"\r\n\t\t\t\t\t\t\tstyle="width: 25px; height: 25px;margin-top:6px;">&nbsp;<span aria-hidden="true" class="icon"></span>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div> --><!-- <div class="row">\r\n\t\t\t\t\t\t<label class="col-md-8 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.ltpThreshold"></span></label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t<div class="col-md-2 col-md-offset-1">\r\n\t\t\t\t\t\t\t<cspl-numeric control-model="vm.applicationWideSettings.ltpThreshold"\r\n\t\t\t\t\t\t\t\tcontrol-id="txtLtpThreshold" no-of-decimals="{{vm.decimalsForPercent}}" control-disabled="true"\r\n\t\t\t\t\t\t\t\tform="configurationSettingsForm" currency-code="" required />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<a style="text-decoration: none;" title="Change Config"\r\n\t\t\t\t\t\t\tui-sref="dealing-admin-change-config({headerLabel: \'Order Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.ltpThreshold\' | translate}}\' ,configName: \'LTPThreshold\' , configValue: vm.applicationWideSettings.ltpThreshold, controlType : \'percentage\', screenName : \'dealingadmin\'})">\r\n\t\t\t\t\t\t\t<img src="assets/images/EditProfile.png" alt="Avatar"\r\n\t\t\t\t\t\t\tstyle="width: 25px; height: 25px;">&nbsp;<span aria-hidden="true" class="icon"></span>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div> --><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.sessionCloseIntimation"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.preCASHSessionCloseIntimation" control-id="txtSessionCloseIntimation" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Order Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.sessionCloseIntimation\' | translate}}\' ,configName: \'PreCASHSessionCloseIntimation\' , configValue: vm.applicationWideSettings.preCASHSessionCloseIntimation, controlType : \'numeric\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.minimumTransactionChargePerTrade"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.minimumTransactionChargePerTrade" control-id="txtMinimumTransactionCharge" no-of-decimals="{{vm.decimalsForPaise}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Order Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.minimumTransactionChargePerTrade\' | translate}}\' ,configName: \'MinimumTransactionChargePerTrade\' , configValue: vm.applicationWideSettings.minimumTransactionChargePerTrade, controlType : \'numericwithdecimals\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div></div><div id="LimitSettings" ng-show="vm.isShowLimitSettings"><div class="row"><label class="col-md-8 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.exchangeRateChange"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.exchangeRateChange" control-id="txtexchangeRateChange" no-of-decimals="{{vm.decimalsForPercent}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Limit Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.exchangeRateChange\' | translate}}\' ,configName: \'ExchangeRateChange\' , configValue: vm.applicationWideSettings.exchangeRateChange, controlType : \'percentage\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-8 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.unUsedTimeFrame"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.unUsedTimeFrame" control-id="txtunUsedTimeFrame" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Limit Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.unUsedTimeFrame\' | translate}}\' , configName: \'UnUsedTimeFrame\' ,configValue: vm.applicationWideSettings.unUsedTimeFrame, controlType : \'numeric\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.defaultLimitPeriod"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.defaultLimitPeriodForSpotWindow" control-id="txtdefaultLimitPeriod" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Limit Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.defaultLimitPeriod\' | translate}}\' ,configName: \'DefaultLimitPeriodForSPOTWindowInDays\' , configValue: vm.applicationWideSettings.defaultLimitPeriodForSpotWindow, controlType : \'numeric\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.defaultLimitPeriodForForwardAll"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.defaultLimitPeriodForForwardAndAllWindow" control-id="txtdefaultLimitPeriod" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Limit Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.defaultLimitPeriodForForwardAll\' | translate}}\' ,configName: \'DefaultLimitPeriodForFORWARDAndALLInDays\' , configValue: vm.applicationWideSettings.defaultLimitPeriodForForwardAndAllWindow, controlType : \'numeric\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.limitExpiryForBank"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.limitExpiry" control-id="txtdefaultlimitExpiry" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Limit Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.limitExpiryForBank\' | translate}}\' ,configName: \'LimitExpiry\' , configValue: vm.applicationWideSettings.limitExpiry, controlType : \'numeric\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.limitExpiryForCustomer"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.limitExpiryForCustomer" control-id="txtdefaultlimitExpiryForCustomer" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Limit Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.limitExpiryForCustomer\' | translate}}\' ,configName: \'LimitExpiryForCustomer\' , configValue: vm.applicationWideSettings.limitExpiryForCustomer, controlType : \'numeric\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div></div><div id="GSTSettings" ng-show="vm.isShowGSTSettings"><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.applicableGSTForBankAMC"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.applicableGSTForBankAMC" control-id="txtapplicableGSTForBankAMC" control-disabled="true" no-of-decimals="{{}}" form="configurationSettingsForm" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'GST Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.applicableGSTForBankAMC\' | translate}}\' ,configName: \'ApplicableGSTForBankAMC\' , configValue: vm.applicationWideSettings.applicableGSTForBankAMC, controlType : \'percentage\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.applicableGSTForCustomerOneTimeRegistrationCharges"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.applicableGSTForCustomerOneTimeRegistrationCharges" control-id="txtapplicableGSTForCustomerOneTimeRegistrationCharges" control-disabled="true" no-of-decimals="{{}}" form="configurationSettingsForm" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'GST Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.applicableGSTForCustomerOneTimeRegistrationCharges\' | translate}}\' ,configName: \'ApplicableGSTForCustomerOneTimeRegistrationCharges\' , configValue: vm.applicationWideSettings.applicableGSTForCustomerOneTimeRegistrationCharges, controlType : \'percentage\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.applicableGSTForTransactionCharges"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.applicableGSTForTransactionCharges" control-id="txtapplicableGSTForTransactionCharges" control-disabled="true" no-of-decimals="{{}}" form="configurationSettingsForm" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'GST Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.applicableGSTForTransactionCharges\' | translate}}\' ,configName: \'ApplicableGSTForTransactionCharges\' , configValue: vm.applicationWideSettings.applicableGSTForTransactionCharges, controlType : \'percentage\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div></div><div id="Others" ng-show="vm.isShowOther"><!-- <div class="row">\r\n\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.dateAndMonthForBankAMCPosting"></span></label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t<div class="col-md-2 col-md-offset-1">\r\n\t\t\t\t\t\t\t<cspl-text control-model="vm.applicationWideSettings.dateAndMonthForBankAMCPosting"\r\n\t\t\t\t\t\t\t\tcontrol-id="txtdateAndMonthForBankAMCPosting" control-disabled="true"\r\n\t\t\t\t\t\t\t\tform="configurationSettingsForm" required />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<a style="text-decoration: none;" title="Change Config"\r\n\t\t\t\t\t\t\tui-sref="dealing-admin-change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.dateAndMonthForBankAMCPosting\' | translate}}\' ,configName: \'DateAndMonthForBankAMCPosting\' , configValue: vm.applicationWideSettings.dateAndMonthForBankAMCPosting, controlType : \'amcdate\', screenName : \'dealingadmin\'})">\r\n\t\t\t\t\t\t\t<img src="assets/images/EditProfile.png" alt="Avatar"\r\n\t\t\t\t\t\t\tstyle="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div> --><div class="row"><label class="col-md-7 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.maxNumberOfPermissibleBankRelationship"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.maxNumberOfPermissibleBankRelationship" control-id="txtmaxNumberOfPermissibleBankRelationship" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.maxNumberOfPermissibleBankRelationship\' | translate}}\' ,configName: \'MaxNumberOfPermissibleBankRelationship\' , configValue: vm.applicationWideSettings.maxNumberOfPermissibleBankRelationship, controlType : \'numeric\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.nearestRoundingOffValueForINR"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.nearestRoundingOffValueForINR" control-id="txtnearestRoundingOffValueForINR" control-disabled="true" no-of-decimals="{{}}" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.nearestRoundingOffValueForINR\' | translate}}\' ,configName: \'NearestRoundingOffValueForINR\' , configValue: vm.applicationWideSettings.nearestRoundingOffValueForINR, controlType : \'numeric\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.nearestRoundingOffValueForUSD"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.nearestRoundingOffValueForUSD" control-id="txtnearestRoundingOffValueForUSD" no-of-decimals="{{2}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.nearestRoundingOffValueForUSD\' | translate}}\' ,configName: \'NearestRoundingOffValueForUSD\' , configValue: vm.applicationWideSettings.nearestRoundingOffValueForUSD, controlType : \'numericwithdecimals\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><!-- No of active tenor months --><div class="row"><label class="col-md-8 col-lg-9 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.NoOfActiveMonthsForStandardTenor"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.noOfActiveMonthsForStandardTenor" control-id="txtnoOfActiveMonthsForStandardTenor" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.NoOfActiveMonthsForStandardTenor\' | translate}}\' ,configName: \'NoOfActiveMonthsForStandardTenor\' , configValue: vm.applicationWideSettings.noOfActiveMonthsForStandardTenor, controlType : \'numeric\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><!-- No of active tenor days --><div class="row"><label class="col-md-8 col-lg-9 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.NoOfActiveDaysForStandardTenor"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.noOfActiveDaysForStandardTenor" control-id="txtnoOfActiveDaysForStandardTenor" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.NoOfActiveDaysForStandardTenor\' | translate}}\' ,configName: \'NoOfActiveDaysForStandardTenor\' , configValue: vm.applicationWideSettings.noOfActiveDaysForStandardTenor, controlType : \'numeric\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><!-- Transaction charges exemption period (in days) --><div class="row"><label class="col-md-8 col-lg-9 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.TransactionChargesExemptionPeriod"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.transactionChargesExemptionPeriod" control-id="txttransactionChargesExemptionPeriod" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.TransactionChargesExemptionPeriod\' | translate}}\' ,configName: \'TransactionChargesExemptionPeriod\' , configValue: vm.applicationWideSettings.transactionChargesExemptionPeriod, controlType : \'numeric\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><!-- ransaction charges exemption limit for a day (in USD) --><div class="row"><label class="col-md-8 col-lg-9 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.TransactionChargesExemptionLimitForADay"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.transactionChargesExemptionLimitForADay" control-id="txttransactionChargesExemptionLimitForADay" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="dealing-admin-change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.TransactionChargesExemptionLimitForADay\' | translate}}\' ,configName: \'TransactionChargesExemptionLimitForADay\' , configValue: vm.applicationWideSettings.transactionChargesExemptionLimitForADay, controlType : \'numeric\', screenName : \'dealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div></div><div id="OrderSettings" ng-show="vm.isShowOrderAmountSettings"><div class="form-group"><div class="row"><div class="col-xs-2 col-md-2" style="text-align:center"><label class="control-label" style="margin-top: 3px" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.currencyPair"></span></label></div><div class="col-md-5 col-sm-6 col-xs-10 col-lg-3"><cspl-ach control-model="vm.currencyPair" control-id="txtCurrencyPair" lookup-name="currencyPair" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}" control-place-holder="Enter Currency Pair" display-column="code" placeholder="" form="configurationSettingsForm" required></div><div class="col-md-1 col-sm-1"><button class="btn btn-info active" ng-disabled="configurationSettingsForm.$invalid ||vm.clicked" ng-click="vm.getTransactionParametersSettings(vm.currencyPair);vm.clicked=true;" data-toggle="collapse" data-target="#MarketMovement" data-translate="gatewayApp.applicationWideSettings.go"></button></div></div></div><div class="accordion-content1" style="border:1px #3f3e3e"><div class="row" ng-repeat="transactionParametersSetting in vm.transactionParametersSettings"><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span></span>{{transactionParametersSetting.name}}</label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="transactionParametersSetting.value" control-id="txtminimumOrderValue" no-of-decimals="{{vm.decimalsForPaise}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ng-click="vm.validateAndChangetransectionParameters(\'Order Settings\', transactionParametersSetting.name,transactionParametersSetting.shortName, transactionParametersSetting.value, \'numericwithdecimals\', \'transactionParametersSettings\',vm.currencyPair.id);"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div></div></div></div></div></div><script>openTab(event, \'RegistrationAdminSettings\');\r\n\r\n\t\t\t\tfunction openTab(evt, tabName) {\r\n\t\t\t\t\tvar i, tabcontent, tablinks;\r\n\t\t\t\t\ttabcontent = document.getElementsByClassName("tabcontent");\r\n\t\t\t\t\tfor (i = 0; i < tabcontent.length; i++) {\r\n\t\t\t\t\t\ttabcontent[i].style.display = "none";\r\n\t\t\t\t\t}\r\n\t\t\t\t\ttablinks = document.getElementsByClassName("tablinks");\r\n\t\t\t\t\tfor (i = 0; i < tablinks.length; i++) {\r\n\t\t\t\t\t\ttablinks[i].className = tablinks[i].className.replace(\r\n\t\t\t\t\t\t\t" active", "");\r\n\t\t\t\t\t}\r\n\t\t\t\t\tdocument.getElementById(tabName).style.display = "block";\r\n\t\t\t\t\t//evt.currentTarget.className += " active";\r\n\t\t\t\t}</script></div></form>');
$templateCache.put('app/entities/application-wide-settings-useradmin/application-wide-settings.html','<form name="configurationSettingsForm" role="form" novalidate><script src="app/app.module.js"></script><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="global.menu.applicationWideSettings.settings"></span></h4></div><div class="modal-body"><div class="content" style="min-height:470px"><nmb-alert></nmb-alert><div class="column"><div class="tab"><br><div class="img-with-text"><img src="assets/images/PasswordPolicyCurrent.png" style="width: 40px; height: 40px" ng-show="vm.isPasswordPolicySelected"> <img src="assets/images/PasswordPolicy.png" ng-show="!vm.isPasswordPolicySelected" style="width: 40px; height: 40px" ng-click="vm.isPasswordPolicySelected = true;vm.isOTPSettingsSelected=false;vm.isInterfaceSettingsSelected=false;vm.isOthersSelected=false;"><p style="text-align:center">Password Policy</p></div><br><div class="img-with-text"><img src="assets/images/OTPSettingsCurrent.png" style="width: 40px; height: 40px" ng-show="vm.isOTPSettingsSelected"> <img src="assets/images/OTPSettings.png" ng-show="!vm.isOTPSettingsSelected" style="width: 40px; height: 40px" ng-click="vm.isPasswordPolicySelected = false;vm.isOTPSettingsSelected=true;vm.isInterfaceSettingsSelected=false;vm.isOthersSelected=false;"><p style="text-align:center">OTP Specific Settings</p></div><br><!-- <div class="img-with-text">\r\n\t\t\t\t\t\t<img src="assets/images/InterfaceSettingsCurrent.png"\r\n\t\t\t\t\t\t\tng-show="vm.isInterfaceSettingsSelected" /> <img\r\n\t\t\t\t\t\t\tsrc="assets/images/InterfaceSettings.png" ng-show="!vm.isInterfaceSettingsSelected"\r\n\t\t\t\t\t\t\tng-click="vm.isPasswordPolicySelected = false;vm.isOTPSettingsSelected=false;vm.isInterfaceSettingsSelected=true;vm.isOthersSelected=false;" />\r\n\t\t\t\t\t\t<p style="text-align:center;">Interface Settings</p>\r\n\t\t\t\t\t</div> --><div class="img-with-text"><img src="assets/images/OthersCurrent.png" style="width: 40px; height: 40px" ng-show="vm.isOthersSelected"> <img src="assets/images/Others.png" ng-show="!vm.isOthersSelected" style="width: 40px; height: 40px" ng-click="vm.isPasswordPolicySelected = false;vm.isOTPSettingsSelected=false;vm.isInterfaceSettingsSelected=false;vm.isOthersSelected=true;"><p style="text-align:center">Others</p></div></div></div><div class="column" style="background-color: #000000; width: 80%"><div id="PasswordPolicy" ng-show="vm.isPasswordPolicySelected"><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.minCharacterLengthForPassword"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.minimumPasswordLength" control-id="txtminCharacterLengthForPassword" control-disabled="true" no-of-decimals="{{}}" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'Password Policy\',labelName: \'{{\'gatewayApp.applicationWideSettings.minCharacterLengthForPassword\' | translate}}\' ,configName: \'MinimumPasswordLength\' , configValue: vm.applicationWideSettings.minimumPasswordLength, controlType : \'numeric\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.maxPasswordAge"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.maximumPasswordAgeInDays" control-id="txtmaxPasswordAge" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'Password Policy\',labelName: \'{{\'gatewayApp.applicationWideSettings.maxPasswordAge\' | translate}}\' ,configName: \'MaximumPasswordAgeInDays\' , configValue: vm.applicationWideSettings.maximumPasswordAgeInDays, controlType : \'numeric\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row" ng-hide="true"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.minPasswordAge"></span></label></div><div class="row" ng-hide="true"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.minimumPasswordAgeInHours" control-id="txtminPasswordAge" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a ng-hide="true" style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'Password Policy\',labelName: \'{{\'gatewayApp.applicationWideSettings.minPasswordAge\' | translate}}\' ,configName: \'MinimumPasswordAgeInHours\' , configValue: vm.applicationWideSettings.minimumPasswordAgeInHours, controlType : \'numeric\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.passwordWrongAttemptCount"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.maximumPasswordWrongAttemptCount" control-id="txtpasswordWrongAttemptCount" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'Password Policy\',labelName: \'{{\'gatewayApp.applicationWideSettings.passwordWrongAttemptCount\' | translate}}\' ,configName: \'MaximumPasswordWrongAttemptCount\' , configValue: vm.applicationWideSettings.maximumPasswordWrongAttemptCount, controlType : \'numeric\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.minNoOfPreviousPasswords"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.minimumNumberOfPreviousPasswordThatCannotBeRepeated" control-id="txtminNoOfPreviousPasswords" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'Password Policy\',labelName: \'{{\'gatewayApp.applicationWideSettings.minNoOfPreviousPasswords\' | translate}}\' ,configName: \'MinimumNumberOfPreviousPasswordThatCannotBeRepeated\' , configValue: vm.applicationWideSettings.minimumNumberOfPreviousPasswordThatCannotBeRepeated, controlType : \'numeric\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.noOfDaysToDisableTheAccount"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.noOfDaysToDisableTheAccount" control-id="txtNoOfDaysToDisableTheAccount" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'Password Policy\',labelName: \'{{\'gatewayApp.applicationWideSettings.noOfDaysToDisableTheAccount\' | translate}}\' ,configName: \'NoOfDaysToDisableTheAccount\' , configValue: vm.applicationWideSettings.noOfDaysToDisableTheAccount, controlType : \'numeric\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.noOfDaysBeforePasswordWarning"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.noOfDaysBeforePasswordWarning" control-id="txtNoOfDaysBeforePasswordWarning" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'Password Policy\',labelName: \'{{\'gatewayApp.applicationWideSettings.noOfDaysBeforePasswordWarning\' | translate}}\' ,configName: \'NoOfDaysBeforePasswordWarning\' , configValue: vm.applicationWideSettings.noOfDaysBeforePasswordWarning, controlType : \'numeric\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><!-- <div class="row">\r\n\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label"\r\n\t\t\t\t\t\t\tcspl-mandatory><span\r\n\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.noOfDaysBeforeExpiryWarning"></span></label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t<div class="col-md-4 col-md-offset-1">\r\n\t\t\t\t\t\t\t<cspl-numeric\r\n\t\t\t\t\t\t\t\tcontrol-model="vm.applicationWideSettings.noOfDaysBeforeExpiryWarning"\r\n\t\t\t\t\t\t\t\tcontrol-id="txtnoOfDaysBeforeExpiryWarning" control-disabled = "true"\r\n\t\t\t\t\t\t\t\tno-of-decimals="{{}}" form="configurationSettingsForm"\r\n\t\t\t\t\t\t\t\tcurrency-code="" required />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div> --></div><div id="OTPSpecificSettings" ng-show="vm.isOTPSettingsSelected"><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.defaultOTPLength"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.defaultOTPLength" control-id="txtdefaultOTPLength" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'OTP Specific Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.defaultOTPLength\' | translate}}\' ,configName: \'DefaultOTPLength\' , configValue: vm.applicationWideSettings.defaultOTPLength, controlType : \'numeric\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.lifespanOfOTP"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.lifeSpanOfTheOTP" control-id="txtlifespanOfOTP" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'OTP Specific Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.lifespanOfOTP\' | translate}}\' ,configName: \'LifeSpanOfTheOTP\' , configValue: vm.applicationWideSettings.lifeSpanOfTheOTP, controlType : \'numeric\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.additionallyDeliverEmail"></span></label></div><div class="row"><div id="btnGroup" class="col-md-2 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.applicationWideSettings.deliverOTPInUserEmail" ng-disabled="true" uib-btn-radio="\'Yes\'">Yes</label><label class="btn btn-primary" ng-model="vm.applicationWideSettings.deliverOTPInUserEmail" ng-disabled="true" uib-btn-radio="\'No\'">No&nbsp;</label></div></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'OTP Specific Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.additionallyDeliverEmail\' | translate}}\' ,configName: \'DeliverOTPInUserEmail\' , configValue: vm.applicationWideSettings.deliverOTPInUserEmail, controlType : \'yesorno\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px;margin-top:6px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row" style="margin-top:10px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.smsAuthKey"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-1"><cspl-text control-model="vm.applicationWideSettings.smsLoginAuthKey" control-id="txtsmsAuthKey" control-disabled="true" form="configurationSettingsForm" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'OTP Specific Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.smsAuthKey\' | translate}}\' , configName: \'SMSLoginAuthKey\' ,configValue: vm.applicationWideSettings.smsLoginAuthKey, controlType : \'text\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.smsSenderCode"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-text control-model="vm.applicationWideSettings.smsSenderCode" control-id="txtSenderCode" control-disabled="true" form="configurationSettingsForm" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'OTP Specific Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.smsSenderCode\' | translate}}\' ,configName: \'SMSSenderCode\' , configValue: vm.applicationWideSettings.smsSenderCode, controlType : \'text\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.emailTemplateId"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.oTPEmailTemplateID" control-id="txtEmailTemplateID" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'OTP Specific Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.emailTemplateId\' | translate}}\' ,configName: \'OTPEmailTemplateID\' , configValue: vm.applicationWideSettings.oTPEmailTemplateID, controlType : \'numeric\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><div class="col-md-11 col-md-offset-1"><label class="control-label" style="margin-bottom:0px" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.timePeriodToBlockUser"></span></label><span class="help-block help-block-left" data-translate="gatewayApp.applicationWideSettings.timePeriodToBlockUserHelpText"></span></div></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.timePeriodToBlockUserLoginInMinutes" control-id="txttimePeriodToBlockUserLoginInMinutes" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></cspl-numeric></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'OTP Specific Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.timePeriodToBlockUser\' | translate}}\' ,configName: \'TimePeriodToBlockUserLoginInMinutes\' , configValue: vm.applicationWideSettings.timePeriodToBlockUserLoginInMinutes, controlType : \'numeric\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div></div><div id="InterfaceSettings" ng-show="vm.isInterfaceSettingsSelected"></div><div id="Others" ng-show="vm.isOthersSelected"><!-- <div class="row">\r\n\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.emailAddressToIntimate"></span></label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t<div class="col-md-4 col-md-offset-1">\r\n\t\t\t\t\t\t\t<cspl-text control-model="vm.applicationWideSettings.emailAddressToIntimate"\r\n\t\t\t\t\t\t\t\tcontrol-id="txtemailAddressToIntimate" control-disabled="true"\r\n\t\t\t\t\t\t\t\tform="configurationSettingsForm" required />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<a style="text-decoration: none;" title="Change Config"\r\n\t\t\t\t\t\t\tui-sref="change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.emailAddressToIntimate\' | translate}}\' ,configName: \'EmailAddressToIntimate\' , configValue: vm.applicationWideSettings.emailAddressToIntimate, controlType : \'email\', screenName : \'useradmin\'})">\r\n\t\t\t\t\t\t\t<img src="assets/images/EditProfile.png" alt="Avatar"\r\n\t\t\t\t\t\t\tstyle="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div> --><!-- <div class="row">\r\n\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.throttlingParameters"></span></label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t<div class="col-md-2 col-md-offset-1">\r\n\t\t\t\t\t\t\t<cspl-numeric control-model="vm.applicationWideSettings.throttlingParameters"\r\n\t\t\t\t\t\t\t\tcontrol-id="txtthrottlingParameters" no-of-decimals="{{}}" control-disabled="true"\r\n\t\t\t\t\t\t\t\tform="configurationSettingsForm" currency-code="" required />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<a style="text-decoration: none;" title="Change Config"\r\n\t\t\t\t\t\t\tui-sref="change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.throttlingParameters\' | translate}}\' ,configName: \'ThrottlingParameters\' , configValue: vm.applicationWideSettings.throttlingParameters, controlType : \'numeric\', screenName : \'useradmin\'})">\r\n\t\t\t\t\t\t\t<img src="assets/images/EditProfile.png" alt="Avatar"\r\n\t\t\t\t\t\t\tstyle="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div> --><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.minIdleTimeToRestrictOrders"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.minimumIdleTimeToRestrictOrderActivity" control-id="txtminIdleTimeToRestrictOrders" control-disabled="true" no-of-decimals="{{}}" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.minIdleTimeToRestrictOrders\' | translate}}\' ,configName: \'MinimumIdleTimeToRestrictOrderActivity\' , configValue: vm.applicationWideSettings.minimumIdleTimeToRestrictOrderActivity, controlType : \'numeric\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.sessionTimeOutInterval"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.sessionTimeoutInterval" control-id="txtsessionTimeOutInterval" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'Password Policy\',labelName: \'{{\'gatewayApp.applicationWideSettings.sessionTimeOutInterval\' | translate}}\' ,configName: \'SessionTimeoutInterval\' , configValue: vm.applicationWideSettings.sessionTimeoutInterval, controlType : \'numeric\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.emailTriggeredDays"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.applicationWideSettings.noOfDaysEmailTriggeredForPendingApprovalRecords" control-id="txtemailTriggeredDays" no-of-decimals="{{}}" control-disabled="true" form="configurationSettingsForm" currency-code="" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.emailTriggeredDays\' | translate}}\' ,configName: \'NoOfDaysEmailTriggeredForPendingApprovalRecords\' , configValue: vm.applicationWideSettings.noOfDaysEmailTriggeredForPendingApprovalRecords, controlType : \'numeric\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><!-- <div class="row">\r\n\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.tradeSMSToBeSent"></span></label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t<div id="btnGroup" class="col-md-2 col-md-offset-1" style="padding-bottom:7px">\r\n\t\t\t\t\t\t\t<div class="btn-group" >\r\n\t\t\t\t\t\t\t\t<label class="btn btn-primary"\r\n\t\t\t\t\t\t\t\t\tng-model="vm.applicationWideSettings.isTradeSMSToBeSent" ng-disabled=true\r\n\t\t\t\t\t\t\t\t\tuib-btn-radio="\'Yes\'">Yes</label> <label class="btn btn-primary"\r\n\t\t\t\t\t\t\t\t\tng-model="vm.applicationWideSettings.isTradeSMSToBeSent" ng-disabled=true\r\n\t\t\t\t\t\t\t\t\tuib-btn-radio="\'No\'">No&nbsp;</label>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<a style="text-decoration: none;" title="Change Config"\r\n\t\t\t\t\t\t\tui-sref="change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.tradeSMSToBeSent\' | translate}}\' ,configName: \'IsTradeSMSToBeSent\' , configValue: vm.applicationWideSettings.isTradeSMSToBeSent, controlType : \'yesorno\', screenName : \'useradmin\'})">\r\n\t\t\t\t\t\t\t<img src="assets/images/EditProfile.png" alt="Avatar"\r\n\t\t\t\t\t\t\tstyle="width: 25px; height: 25px;margin-top:6px;">&nbsp;<span aria-hidden="true" class="icon"></span>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div> --><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.serverPath"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-1"><cspl-text control-model="vm.applicationWideSettings.serverPath" control-id="txtserverpath" control-disabled="true" form="configurationSettingsForm" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.serverPath\' | translate}}\' ,configName: \'ServerPath\' , configValue: vm.applicationWideSettings.serverPath, controlType : \'text\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px;margin-top:6px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.cCILWebsite"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text control-model="vm.applicationWideSettings.cCILWebsite" control-id="txtserverpath" control-disabled="true" form="configurationSettingsForm" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.cCILWebsite\' | translate}}\' ,configName: \'CCILWebsite\' , configValue: vm.applicationWideSettings.cCILWebsite, controlType : \'text\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px;margin-top:6px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.rbiCms"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text control-model="vm.applicationWideSettings.rbiCms" control-id="txtrbiCms" control-disabled="true" form="configurationSettingsForm" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.rbiCms\' | translate}}\' ,configName: \'RBICMS\' , configValue: vm.applicationWideSettings.rbiCms, controlType : \'text\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px;margin-top:6px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.rbiCircular"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text control-model="vm.applicationWideSettings.rbiCircular" control-id="txtrbiCircular" control-disabled="true" form="configurationSettingsForm" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.rbiCircular\' | translate}}\' ,configName: \'RBICircular\' , configValue: vm.applicationWideSettings.rbiCircular, controlType : \'text\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px;margin-top:6px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.applicationWideSettings.grievancePortal"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text control-model="vm.applicationWideSettings.grievancePortal" control-id="txtgrievancePortal" control-disabled="true" form="configurationSettingsForm" required></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'Others\',labelName: \'{{\'gatewayApp.applicationWideSettings.grievancePortal\' | translate}}\' ,configName: \'GrievancePortal\' , configValue: vm.applicationWideSettings.grievancePortal, controlType : \'text\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px;margin-top:6px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div></div></div></div></div><script>//$("#btntab1").focus();\r\n\t\topenTab(event, \'PasswordPolicy\');\r\n\r\n\t\tfunction openTab(evt, tabName) {\r\n\t\t\tvar i, tabcontent, tablinks;\r\n\t\t\ttabcontent = document.getElementsByClassName("tabcontent");\r\n\t\t\tfor (i = 0; i < tabcontent.length; i++) {\r\n\t\t\t\ttabcontent[i].style.display = "none";\r\n\t\t\t}\r\n\t\t\ttablinks = document.getElementsByClassName("tablinks");\r\n\t\t\tfor (i = 0; i < tablinks.length; i++) {\r\n\t\t\t\ttablinks[i].className = tablinks[i].className.replace(\r\n\t\t\t\t\t\t" active", "");\r\n\t\t\t}\r\n\t\t\tdocument.getElementById(tabName).style.display = "block";\r\n\t\t\t//evt.currentTarget.className += " active";\r\n\t\t}</script></form>');
$templateCache.put('app/entities/audit-log/audit-log-params-view-dialog.html','<form name="auditForm" role="form" autocomplete="off" novalidate><div class="modal-header"><div class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="gatewayApp.AuditLog.reportParams"></span></div></div><div class="modal-body"><div class="content"><div ng-repeat="(key, value) in vm.paramMap" class="row"><div class="col-md-2"></div><span class="form-group col-md-8"><label class="control-label left-align-label">{{key}}</label><cspl-text control-model="value" control-id="{{key + \'value\'+ $index}}" control-disabled="true"></span></div></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" autofocus><span data-translate="gatewayApp.AuditLog.ok"></span></button></div></div></form>');
$templateCache.put('app/entities/audit-log/audit-log.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.AuditLog.manageAuditLog"></span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><form name="auditLogForm" role="form" novalidate><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px;  margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseAuditLog = !vm.ExpandOrCollapseAuditLog" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#AuditLogReport"><img ng-src="{{vm.ExpandOrCollapseAuditLog == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.AuditLog.Criteria">Criteria</span></a></h4></div><div id="AuditLogReport" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><div class="row"><cspl-entity-lookup user-entity-owner-type="vm.userEntityOwnerType" selected-entity-owner-type="vm.selectedEntityOwnerType" bank-value="vm.bankValue" branch-value="vm.branchValue" customer-value="vm.customerValue" user-value="vm.userValue" user-list-value="vm.userListValue" control-class="col-md-3 col-md-offset-3" control-form="auditLogForm"></cspl-entity-lookup></div><div class="row"><label class="col-md-offset-3 col-md-3 control-label"><span data-translate="gatewayApp.AuditLog.screenName"></span></label></div><div class="row"><div class="col-md-offset-3 col-md-3"><cspl-ach control-model="vm.screenName" control-id="txtScreenName" lookup-name="entity" filter-value="{{vm.selectedEntityOwnerType}}" display-column="name" form="auditLogForm"></cspl-ach></div></div><!-- <div class="row">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<label class="col-md-offset-3 col-md-3 control-label"  cspl-mandatory>\r\n\t\t\t\t\t\t\t\t\t\t<span data-translate="gatewayApp.AuditLog.fromDate"></span>\r\n\t\t\t\t\t\t\t\t\t</label> \r\n\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<label class="col-md-3 control-label"  cspl-mandatory>\r\n\t\t\t\t\t\t\t\t\t\t<span data-translate="gatewayApp.AuditLog.toDate"></span>\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t</div> --><!-- <div class="row">\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-3 col-md-offset-3">\r\n\t\t\t\t\t\t\t\t\t\t<cspl-dtp control-model = "vm.fromDate"  control-id="dtpFromDate"  form="auditLogForm" required/>\r\n\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-3  ">\r\n\t\t\t\t\t\t\t\t\t\t<cspl-dtp control-model = "vm.toDate"  control-id="dtpToDate" form="auditLogForm" required/>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="btn btn-info active" \r\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="auditLogForm.$invalid" \r\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.getAuditLogDetails()" data-toggle="collapse" data-target="#AuditLogReport"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t data-translate="gatewayApp.AuditLog.go">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\t --><div class="col-sm-6 col-centered" style="margin-top: 10px"><div class="col-md-12" style="padding-left: 0"><div class="col-md-2" style="padding-left: 0; margin-top: 10px"><input type="radio" name="optradio" id="radio1" ng-model="vm.historicalOrCurrent" style="margin-right: 5px" value="Historical" form="auditLogForm"><label style="color: #FFFFFF" for="radio1" data-translate="gatewayApp.AuditLog.historical"></label></div><div class="col-md-5"><cspl-dtp control-model="vm.fromDate" control-id="dtpFromDate" form="auditLogForm" control-required="vm.historicalOrCurrent != \'Current\'" control-disabled="vm.historicalOrCurrent == \'Current\'" control-max-date="vm.yesterdayDate"></div><div class="col-md-5"><cspl-dtp control-model="vm.toDate" control-id="dtpToDate" form="auditLogForm" control-required="vm.historicalOrCurrent != \'Current\'" control-disabled="vm.historicalOrCurrent == \'Current\'" control-max-date="vm.yesterdayDate"></div></div><div class="col-md-12" style="padding-left: 0"><div class="col-md-2" style="padding-left: 0; margin-top: 10px; padding-right: 0"><input type="radio" name="optradio" id="radio2" ng-model="vm.historicalOrCurrent" style="margin-right: 5px" value="Current" form="auditLogForm"><label style="color: #FFFFFF" for="radio2" data-translate="gatewayApp.AuditLog.forToday"></label></div><div class="col-md-5" style="margin-top: 10px"><label class="control-label"><span>{{vm.reportDate\t| date : \'dd-MMM-yyyy\'}}</span></label></div></div><div class="col-md-12" style="padding-left: 0"><div class="col-md-2" style="padding-left: 0"></div><div class="col-md-5"></div><div class="col-md-5"><button class="btn btn-info active" ng-click="vm.getAuditLogDetails();" ng-disabled="auditLogForm.$invalid||vm.clicked" style="float: right; margin-top:0px" data-translate="entity.action.go" data-toggle="collapse" data-target="#AuditLogReport"></button></div></div></div></div></div></div></form><div ng-show="vm.auditLogDetails.length > 0"><div class="row"><div class="pull-right"><div class="col-md-6 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><cspl-table-export table-name="AuditLogDetails" total-record-count="filterData.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="Audit_Log"></cspl-table-export><br></div></div><div class="table-responsive"><table id="AuditLogDetails" class="datatables-nosort table table-striped table-hover"><thead><tr><th style="padding-left:20px"><cspl-table-sort sort-type-model="sortType" default-sort="asc" sort-type-name="actionDateTime" sort-reverse-model="sortReverse" header-text="\'gatewayApp.AuditLog.dateTime\'|translate"></th><th data-translate="gatewayApp.AuditLog.loginName"></th><th data-translate="gatewayApp.AuditLog.screen"></th><th data-translate="gatewayApp.AuditLog.action"></th><th data-translate="gatewayApp.AuditLog.previousValue"></th><th data-translate="gatewayApp.AuditLog.currentValue"></th><th data-translate="gatewayApp.AuditLog.reportParams"></th></tr></thead><tbody><tr ng-repeat="auditLogDetail in filterData = (vm.auditLogDetails | filter : filterText | orderBy  : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="padding-left:20px">{{auditLogDetail.actionDateTime|date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td>{{auditLogDetail.login}}</td><td>{{auditLogDetail.entityName}}</td><td>{{auditLogDetail.actionName}}</td><td><a ng-if="auditLogDetail.previousValue!=\'\'" ng-click="vm.Values(auditLogDetail.entityShortName,auditLogDetail.previousValue,auditLogDetail.actionName)"><span data-translate="gatewayApp.AuditLog.previousValue"></span></a></td><td><a ng-if="auditLogDetail.currentValue!=\'\'" ng-click="vm.Values(auditLogDetail.entityShortName,auditLogDetail.currentValue,auditLogDetail.actionName)"><span data-translate="gatewayApp.AuditLog.currentValue"></span></a></td><td><a ng-if="auditLogDetail.queryParams!=\'\'" ng-click="vm.showReportParams(auditLogDetail.queryParams)"><span data-translate="gatewayApp.AuditLog.reportParams"></span></a></td></tr></tbody></table></div></div><div class="table-responsive" ng-show="vm.auditLogDetails.length==0"><span>No record found</span></div><div ng-show="vm.auditLogDetails.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></section></div></div>');
$templateCache.put('app/entities/available-users-report/available-users-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><!-- <h2 class="view-title" ><span data-translate="gatewayApp.availableUsers.headerTitle"></span><span>{{vm.reportDate|date :\'dd-MMM-yyyy\'}}</span></h2> --><nmb-alert></nmb-alert><div class="col-lg-12"><section class="item" style="padding:5px"><div class="panel panel-primary"><div class="panel-heading text-left"><span data-translate="gatewayApp.availableUsers.headerTitle"></span><span>{{vm.reportDate|date :\'dd-MMM-yyyy\'}}</span> <a href="" style="position: relative;float:right;  color: #fff" ng-class="{\'linkDisabled\' : vm.isRefreshDisabled}"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="!vm.isRefreshDisabled?refresh():\'\';" style="font-size:20px"></i></a></div><div class="panel-body"><div class="module-content-inner"><div ng-if="vm.headerList.length>0"><div class="row"><div class="dropdown col-md-3" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div><cspl-table-search control-model="vm.filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="headerList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.availableUsers.bank"></th><th class="td-text-align-right" data-translate="gatewayApp.availableUsers.noOfBankUsers"></th><th class="td-text-align-right" data-translate="gatewayApp.availableUsers.noOfBranchUsers"></th><th class="td-text-align-right" data-translate="gatewayApp.availableUsers.noOfCustomerUSers"></th></tr></thead><tbody><tr ng-repeat="overallCountForbank in vm.filterData = (vm.headerList | filter : vm.filterText) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break:break-word">{{overallCountForbank.bankName}}</td><td class="td-text-align-right"><b><span class="numericHyperlinkFont" ng-if="overallCountForbank.bankUsersCount==0">{{overallCountForbank.bankUsersCount}}</span> <span ng-if="overallCountForbank.bankUsersCount>0" class="numericHyperlinkFont"><a href="" ng-click="vm.getBankUsersDetails(overallCountForbank.bankId, overallCountForbank.bankName);">{{overallCountForbank.bankUsersCount}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="overallCountForbank.branchUsersCount==0" class="numericHyperlinkFont">{{overallCountForbank.branchUsersCount}}</span> <span ng-if="overallCountForbank.branchUsersCount>0" class="numericHyperlinkFont"><a href="" ng-click="vm.getBranchWiseUsersCount(overallCountForbank.bankId, overallCountForbank.bankName);">{{overallCountForbank.branchUsersCount}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="overallCountForbank.customerUsersCount==0" class="numericHyperlinkFont">{{overallCountForbank.customerUsersCount}}</span> <span ng-if="overallCountForbank.customerUsersCount>0" class="numericHyperlinkFont"><a href="" ng-click="vm.getBranchWiseCustomerCount(overallCountForbank.bankId, overallCountForbank.bankName);">{{overallCountForbank.customerUsersCount}}</a></span></b></td></tr></tbody><tfoot class="table-footer" ng-if="vm.filterData.length>0"><tr><td class="td-text-align-left" data-translate="gatewayApp.availableUsers.total"></td><td class="td-text-align-right">{{vm.totalBankUsersCount}}</td><td class="td-text-align-right">{{vm.totalBranchUsersCount}}</td><td class="td-text-align-right">{{vm.totalCustomerUsersCount }}</td></tr></tfoot></table></div><div ng-show="vm.filterData.length > 0"><cspl-pagination record-count="vm.filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><div ng-show="vm.filterData.length == 0"><span>No record found</span></div></div><div ng-if="vm.headerList.length==0"><span>No record found</span></div><div ng-if="vm.showBranchDrillDown"><div class="row"><label class="control-label col-md-1 col-sm-2 col-xs-2"><span data-translate="gatewayApp.availableUsers.bank"></span></label><label class="control-label"><span>{{vm.selectedBankName}}</span></label></div><div ng-if="vm.branchWiseUserCountList.length >0"><div class="row"><!-- <cspl-table-export class="col-md-1 col-sm-1 col-xs-1" table-name="BranchWiseUserCountList" total-record-count="vm.branchWiseUserFilterData.length" \r\n                    \tno-of-records-per-page="noOfBranchRecordsPerPage"  page-no="branchPage"  file-name="Available_Branch_Users"></cspl-table-export>\r\n                    \t --><cspl-table-search control-model="vm.branchWiseFilterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="BranchWiseUserCountList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.availableUsers.branch"></th><th class="td-text-align-right" data-translate="gatewayApp.availableUsers.usersCount"></th></tr></thead><tbody><tr ng-repeat="branch in vm.branchWiseUserFilterData = (vm.branchWiseUserCountList | filter : vm.branchWiseFilterText) | limitTo:noOfBranchRecordsPerPage:noOfBranchRecordsPerPage*(branchPage-1)"><td style="word-break:break-word">{{branch.branchName}}</td><td class="td-text-align-right"><b><span ng-if="branch.branchUsersCount==0" class="numericHyperlinkFont">{{branch.branchUsersCount}}</span> <span ng-if="branch.branchUsersCount>0" class="numericHyperlinkFont"><a href="" ng-click="vm.getBranchUsersDetails(branch.branchName , branch.branchId , branch.entityUserList);">{{branch.branchUsersCount}}</a></span></b></td></tr></tbody><tfoot class="table-footer" ng-if="vm.branchWiseUserFilterData.length>0"><tr><td class="td-text-align-left" data-translate="gatewayApp.availableUsers.total"></td><td class="td-text-align-right">{{vm.totalBranchUserCountForBank }}</td></tr></tfoot></table></div><div ng-show="vm.branchWiseUserFilterData.length > 0"><cspl-pagination record-count="vm.branchWiseUserFilterData.length" control-model="branchPage" items-per-page="noOfBranchRecordsPerPage"></cspl-pagination></div><div ng-show="vm.branchWiseUserFilterData.length == 0"><span>No record found</span></div></div><div ng-show="vm.branchWiseUserCountList.length  == 0"><span>No record found</span></div></div><div ng-if="vm.showCustomerCountForBranches"><div class="row"><label class="control-label col-md-1 col-sm-2 col-xs-2"><span data-translate="gatewayApp.availableUsers.bank"></span></label><label class="control-label"><span>{{vm.selectedBankName}}</span></label></div><div ng-if="vm.branchWiseCustomerCountList.length >0"><div class="row"><!-- <cspl-table-export class="col-md-1 col-sm-1 col-xs-1" table-name="BranchWiseCustomerCountList" \r\n                    \ttotal-record-count="vm.branchWiseCustomerFilterData.length" no-of-records-per-page="noOfBranchCustomerRecordsPerPage" \r\n                    \t page-no="branchCustomerPage"  file-name="Available_Branch_Customers"></cspl-table-export>\r\n                    \t --><cspl-table-search control-model="vm.branchWiseCustomerFilterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="BranchWiseCustomerCountList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.availableUsers.branch"></th><th class="td-text-align-right" data-translate="gatewayApp.availableUsers.customersCount"></th></tr></thead><tbody><tr ng-repeat="branchCustomer in vm.branchWiseCustomerFilterData = (vm.branchWiseCustomerCountList | filter : vm.branchWiseCustomerFilterText) | limitTo:noOfBranchCustomerRecordsPerPage:noOfBranchCustomerRecordsPerPage*(branchCustomerPage-1)"><td style="word-break:break-word">{{branchCustomer.branchName}}</td><td class="td-text-align-right"><b><span ng-if="branchCustomer.customerCount>0" class="numericHyperlinkFont"><a href="" ng-click="vm.totalBranchCustomerUSerCount=0;vm.getBranchCustomerDetails(vm.selectedBankId, branchCustomer.branchId, branchCustomer.branchName);">{{branchCustomer.customerCount}}</a></span> <span ng-if="branchCustomer.customerCount==0" class="numericHyperlinkFont">{{branchCustomer.customerCount}}</span></b></td></tr></tbody><tfoot class="table-footer" ng-if="vm.branchWiseCustomerFilterData.length>0"><tr><td class="td-text-align-left" data-translate="gatewayApp.availableUsers.total"></td><td class="td-text-align-right">{{vm.totalBranchCustomerCountForBank }}</td></tr></tfoot></table></div><div ng-show="vm.branchWiseCustomerFilterData.length > 0"><cspl-pagination record-count="vm.branchWiseCustomerFilterData.length" control-model="branchCustomerPage" items-per-page="noOfBranchCustomerRecordsPerPage"></cspl-pagination></div><div ng-show="vm.branchWiseCustomerFilterData.length== 0"><span>No record found</span></div></div><div ng-if="vm.branchWiseCustomerCountList.length ==0"><span>No record found</span></div></div><div ng-if="vm.showSelectedBranchCustomerDetails"><div class="row"><label class="control-label col-md-1 col-sm-1 col-xs-1"><span data-translate="gatewayApp.availableUsers.branch"></span></label><label class="control-label"><span>{{vm.selectedBranchName }}</span></label></div><div ng-if="vm.customerDetailsList.length >0"><div class="row"><!--<cspl-table-export class="col-md-1 col-sm-1 col-xs-1" table-name="CustomerDetailsList" total-record-count="vm.customerFilterData.length" \r\n                    \tno-of-records-per-page="noOfCustomerRecordsPerPage"  page-no="customerPage"  file-name="Available_Customers"></cspl-table-export>\r\n                    \t--><cspl-table-search control-model="vm.customerFilterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="CustomerDetailsList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.availableUsers.customerId"></th><th data-translate="gatewayApp.availableUsers.customer"></th><th class="td-text-align-right" data-translate="gatewayApp.availableUsers.usersCount"></th></tr></thead><tbody><tr ng-repeat="customer in vm.customerFilterData = (vm.customerDetailsList | filter : vm.customerFilterText) | limitTo:noOfCustomerRecordsPerPage:noOfCustomerRecordsPerPage*(customerPage-1)"><td style="word-break:break-word">{{customer.customerCode}}</td><td style="word-break:break-word">{{customer.customerName}}</td><td class="td-text-align-right"><b><span ng-if="customer.customerUsersCount>0" class="numericHyperlinkFont"><a href="" class="numericHyperlinkFont" ng-click="vm.getCustomerUserDetails(customer.customerName, customer.entityUserList);" class="numericHyperlinkFont">{{customer.customerUsersCount}}</a></span> <span ng-if="customer.customerUsersCount==0" class="numericHyperlinkFont">{{customer.customerUsersCount}}</span></b></td></tr></tbody><tfoot class="table-footer" ng-if="vm.customerFilterData.length>0"><tr><td class="td-text-align-left" data-translate="gatewayApp.availableUsers.total"></td><td></td><td class="td-text-align-right">{{vm.totalBranchCustomerUSerCount}}</td></tr></tfoot></table></div><div ng-show="vm.customerFilterData.length > 0"><cspl-pagination record-count="vm.customerFilterData.length" control-model="customerPage" items-per-page="noOfCustomerRecordsPerPage"></cspl-pagination></div><div ng-show="vm.customerFilterData.length == 0"><span>No record found</span></div></div><div ng-show="vm.customerDetailsList.length  == 0"><span>No record found</span></div></div><div ng-if="vm.showSelectedBankUsersDetails || vm.showSelectedBranchUsersDetails || vm.showSelectedCustomerUsersDetails"><div class="row"><label class="control-label col-md-1"><span>{{vm.selectedEntityType}}</span></label><label class="control-label col-md-5"><span>{{vm.selectedEntityName}}</span></label></div><div ng-if="vm.selectedEntityUserList.length >0"><div class="row"><cspl-table-search control-model="vm.userFilterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="UserDetailsList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.availableUsers.userName"></th><th data-translate="gatewayApp.availableUsers.mobile"></th><th data-translate="gatewayApp.availableUsers.emailID"></th></tr></thead><tbody><tr ng-repeat="user in userFilterData = (vm.selectedEntityUserList | filter : vm.userFilterText) | limitTo:noOfUserRecordsPerPage:noOfUserRecordsPerPage*(userPage-1)"><td style="word-break:break-word" ng-if="user.middleName!=null">{{user.firstName+\' \'+user.middleName+\' \'+user.lastName}}</td><td style="word-break:break-word" ng-if="user.middleName==null">{{user.firstName+\' \'+user.lastName}}</td><td>{{user.mobile}}</td><td>{{user.email}}</td></tr></tbody></table></div><div ng-show="userFilterData.length > 0"><cspl-pagination record-count="userFilterData.length" control-model="userPage" items-per-page="noOfUserRecordsPerPage"></cspl-pagination></div><div ng-show="userFilterData.length == 0"><span>No record found</span></div></div><div ng-show="vm.selectedEntityUserList.length == 0"><span>No record found</span></div></div></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/available-users-report/cc-available-users-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><!-- <h2 class="view-title" ><span data-translate="gatewayApp.availableUsers.headerTitle"></span><span>{{vm.reportDate|date :\'dd-MMM-yyyy\'}}</span></h2> --><nmb-alert></nmb-alert><div class="col-lg-12"><section class="item" style="padding:5px"><div class="panel panel-primary"><div class="panel-heading text-left"><h2 class="view-title"><span data-translate="gatewayApp.availableUsers.headerTitle"></span><span>{{vm.reportDate|date :\'dd-MMM-yyyy\'}}</span> <a href="" style="position: relative;float:right;  color: #fff" ng-class="{\'linkDisabled\' : vm.isRefreshDisabled}"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="!vm.isRefreshDisabled?refresh():\'\';" style="font-size:20px"></i></a></h2></div><div class="panel-body"><div class="module-content-inner"><div class="row"><label class="control-label font-16-px"><span data-translate="gatewayApp.availableUsers.summary"></span></label></div><div><div class="row"><div class="dropdown col-md-3 col-xs-1" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div></div><div style="width: 60%"><table id="overAllSummary" name="overAllSummary" class="dataTable table table-striped table-hover"><thead><tr><th class="td-text-align-right" data-translate="gatewayApp.availableUsers.noOfClearcorpUsers"></th><th class="td-text-align-right" data-translate="gatewayApp.availableUsers.noOfBankUsers"></th><th class="td-text-align-right" data-translate="gatewayApp.availableUsers.noOfBranchUsers"></th><th class="td-text-align-right" data-translate="gatewayApp.availableUsers.noOfCustomerUsers"></th></tr></thead><tbody><tr><td class="td-text-align-right"><b><span ng-if="vm.overAllSummary.clearcorpUsersCount == 0" class="numericHyperlinkFont">{{vm.overAllSummary.clearcorpUsersCount}}</span> <span ng-if="vm.overAllSummary.clearcorpUsersCount > 0"><a href="" class="numericHyperlinkFont" ng-click="vm.getUserDetails(0, \'\', vm.CLEARCORP, vm.CLEARCORP);">{{vm.overAllSummary.clearcorpUsersCount}}</a></span></b></td><td class="td-text-align-right"><b><span class="numericHyperlinkFont" ng-if="vm.overAllSummary.bankUsersCount == 0">{{vm.overAllSummary.bankUsersCount}}</span> <span ng-if="vm.overAllSummary.bankUsersCount > 0"><a href="" class="numericHyperlinkFont" ng-click="vm.getBankSummary();">{{vm.overAllSummary.bankUsersCount}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="vm.overAllSummary.branchUsersCount == 0" class="numericHyperlinkFont">{{vm.overAllSummary.branchUsersCount}}</span> <span ng-if="vm.overAllSummary.branchUsersCount > 0"><a href="" class="numericHyperlinkFont" ng-click="vm.getUserDetails(0, \'\', vm.BRANCH_TYPE,vm.BRANCH_TYPE);">{{vm.overAllSummary.branchUsersCount}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="vm.overAllSummary.customerUsersCount == 0" class="numericHyperlinkFont">{{vm.overAllSummary.customerUsersCount}}</span> <span ng-if="vm.overAllSummary.customerUsersCount > 0"><a href="" class="numericHyperlinkFont" ng-click="vm.getUserDetails(0,\'\', vm.CUSTOMER_TYPE,vm.CUSTOMER_TYPE);">{{vm.overAllSummary.customerUsersCount}}</a></span></b></td></tr></tbody></table></div></div><!-- <div ng-if = "vm.showBankSummary" class="row">\r\n\t\t\t\t\t\r\n\t\t\t  </div> --><div ng-if="vm.showBankSummary"><div class="row" style="width: 60%"><label class="control-label font-16-px" style="margin-top: 15px"><span data-translate="gatewayApp.availableUsers.bankSummary"></span></label><cspl-table-search ng-if="vm.bankSummaryList.length>0" control-model="vm.bankSummaryfilterText" class="col-md-3 col-sm-4 col-xs-5 float-right"></cspl-table-search></div><div style="width: 60%" ng-if="vm.bankSummaryList.length>0"><table id="bankSummary" name="bankSummary" class="dataTable table table-striped table-hover"><thead><tr><th class="td-text-align-left" data-translate="gatewayApp.availableUsers.bank"></th><th class="td-text-align-right" data-translate="gatewayApp.availableUsers.noOfUsers"></th></tr></thead><tbody><tr ng-repeat="overallCountForbank in vm.filterData = (vm.bankSummaryList | filter : vm.bankSummaryfilterText ) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break:break-word">{{overallCountForbank.bankName}}</td><td class="td-text-align-right"><b><span class="numericHyperlinkFont" ng-if="overallCountForbank.bankUsers == 0">{{overallCountForbank.bankUsers}}</span> <span ng-if="overallCountForbank.bankUsers > 0"><a href="" class="numericHyperlinkFont" ng-click="vm.getUserDetails(overallCountForbank.bankId,overallCountForbank.bankName, vm.BANK_TYPE,vm.BANK_TYPE);">{{overallCountForbank.bankUsers}}</a></span></b></td></tr></tbody><tfoot class="table-footer" ng-if="vm.filterData.length>0"><tr><td class="td-text-align-left" data-translate="gatewayApp.availableUsers.total"></td><td class="td-text-align-right"><span ng-if="vm.totalBankUsers == 0" class="numericHyperlinkFont">{{vm.totalBankUsers}}</span> <span ng-if="vm.totalBankUsers > 0"><a href="" class="numericHyperlinkFont" ng-click="vm.getUserDetails(0,\'\', vm.BANK_TYPE,vm.BANK_TYPE);">{{vm.totalBankUsers}}</a></span></td></tr></tfoot></table></div><div ng-show="vm.filterData.length > 0"><cspl-pagination record-count="vm.filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><div ng-show="vm.filterData.length == 0"><span>No record found</span></div></div><div ng-if="vm.bankSummaryList.length==0 &&  vm.showBankSummary"><span>No record found</span></div><div ng-if="vm.showUserDetailsDrillDown"><!-- <div class="row">\r\n\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t</div>  --><div ng-if="vm.userDetailsList.length>0"><div class="row"><label class="control-label font-16-px" style="margin-top: 15px">{{vm.userDetailsHeader}}</label><!-- <div class="pull-left">\r\n\t\t\t\t\t\t\t\t<cspl-table-export table-name="userDetails" total-record-count="vm.userDetailsList.length" no-of-records-per-page="noOfRecordsPerUSerPage" \r\n\t\t\t\t\t\t\t\tfilter-text="vm.userSummaryFilterText" page-no="userPage" file-name="No_of_logged_in_User_Details"></cspl-table-export>\t\r\n\t\t\t\t\t\t\t</div> --><cspl-table-search control-model="vm.userSummaryFilterText" control-id="userSearch" class="col-md-2 col-sm-3 col-xs-4 float-right"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="userDetails" name="userDetails" class="dataTable table table-striped table-hover"><thead><tr><th ng-if="(vm.showBankDetails || vm.showBranchDetails)" class="td-text-align-left" data-translate="gatewayApp.availableUsers.bankName"></th><th ng-if="vm.showBranchDetails" class="td-text-align-left" data-translate="gatewayApp.availableUsers.branchName"></th><th ng-if="vm.showCustomerDetails" class="td-text-align-left" data-translate="gatewayApp.availableUsers.customerName"></th><th ng-if="vm.showCustomerDetails" class="td-text-align-left" data-translate="gatewayApp.availableUsers.customerCategory"></th><th ng-if="vm.showCustomerDetails" class="td-text-align-left" data-translate="gatewayApp.availableUsers.customerID"></th><th class="td-text-align-left" data-translate="gatewayApp.availableUsers.userName"></th><th class="td-text-align-left" data-translate="gatewayApp.availableUsers.mobile" style="min-width: 70px"></th><th class="td-text-align-left" data-translate="gatewayApp.availableUsers.email"></th><th class="td-text-align-left" data-translate="gatewayApp.availableUsers.status"></th><th class="td-text-align-left" data-translate="gatewayApp.availableUsers.createdDateTime" style="max-width: 70px;    white-space: normal"></th><th class="td-text-align-left" data-translate="gatewayApp.availableUsers.lastSuccessfulLogin" style="max-width: 70px;    white-space: normal"></th><th class="td-text-align-left" data-translate="gatewayApp.availableUsers.lastUnSuccessfulLogin" style="max-width: 70px;    white-space: normal"></th></tr></thead><tbody><tr ng-repeat="userDetailsRow in vm.userDetailsFilterData = (vm.userDetailsList | filter : vm.userSummaryFilterText) | limitTo:noOfRecordsPerUSerPage:noOfRecordsPerUSerPage*(userPage-1)"><td ng-if="(vm.showBankDetails || vm.showBranchDetails)" style="word-break:break-word">{{userDetailsRow.bankName || \'-\'}}</td><td ng-if="vm.showBranchDetails" style="word-break:break-word">{{userDetailsRow.branchName || \'-\'}}</td><td ng-if="vm.showCustomerDetails" style="word-break:break-word">{{userDetailsRow.customerName || \'-\'}}</td><td ng-if="vm.showCustomerDetails" style="word-break:break-word">{{userDetailsRow.customerCategory || \'-\' }}</td><td ng-if="vm.showCustomerDetails" style="word-break:break-word">{{userDetailsRow.customerCode || \'-\' }}</td><td style="word-break:break-word">{{userDetailsRow.name}}</td><td style="word-break:break-word">{{userDetailsRow.mobileNumber}}</td><td style="word-break:break-word">{{userDetailsRow.email}}</td><td style="word-break:break-word">{{userDetailsRow.status}}</td><td style="word-break:break-word">{{ (userDetailsRow.createdDateTime | date:\'dd-MMM-yyyy HH:mm:ss\') || \'-\' }}</td><td style="word-break:break-word">{{ (userDetailsRow.lastSuccessfulLogin | date:\'dd-MMM-yyyy HH:mm:ss\') || \'-\' }}</td><td style="word-break:break-word">{{ (userDetailsRow.lastUnsuccessfulLogin | date:\'dd-MMM-yyyy HH:mm:ss\') || \'-\'}}</td></tr></tbody></table></div><div ng-show="vm.userDetailsFilterData.length > 0"><cspl-pagination record-count="vm.userDetailsFilterData.length" control-model="userPage" items-per-page="noOfRecordsPerUSerPage"></cspl-pagination></div><div ng-show="vm.userDetailsFilterData.length == 0"><span>No record found</span></div></div><div ng-if="vm.userDetailsList.length==0 && vm.showUserDetailsDrillDown"><span>No record found</span></div></div></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/approval-policy/approval-policy-delete-dialog.html','<form name="deleteForm" ng-submit="clicked=true;vm.confirmDelete(vm.approvalPolicyDTO.id)"><div class="modal-header-red"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" style="text-align:left;padding-left:3%">Are you sure?</h4></div><div class="modal-body"><nmb-alert-error></nmb-alert-error><p><textarea class="form-control modal-header-red" rows="6" ng-model="vm.reason" placeholder="Please provide a reason" required></textarea></p><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid||clicked" class="btn btn-danger"><span data-translate="entity.action.delete">Delete</span></button></div></div></div></form>');
$templateCache.put('app/entities/approval-policy/approval-policy-dialog.html','<form name="approvalPolicyForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title" ng-hide="vm.ViewDisable"><span data-translate="gatewayApp.title.addApprovalPolicy"></span></h4><h4 class="modal-title" ng-show="vm.ViewDisable"><span data-translate="gatewayApp.title.viewApprovalPolicy"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="row"><fieldset><div class="row" style="display: flex" ng-disabled="vm.ViewDisable"><label class="col-sm-10 col-sm-offset-2 control-label" data-translate="gatewayApp.approvalPolicy.name"></label></div><div class="row" style="display: flex"><!-- <div ng-disabled="vm.ViewDisable">  --><cspl-text class="col-sm-8 col-sm-offset-2" control-model="vm.approvalPolicyDTO.shortName" control-disabled="vm.ViewDisable" form="approvalPolicyForm" control-id="txtApprovalProcessName" required><div class="col-sm-1 col-sm-offset-2 pull-right"><cspl-table-search ng-show="vm.ViewDisable" control-model="filterText"></cspl-table-search></div><!-- </div>  --></div><div class="row" style="display: flex" ng-disabled="vm.ViewDisable" ng-hide="vm.ViewDisable"><!-- <div class="col-sm-10 col-sm-offset-2" ng-hide="vm.ViewDisable">  --><label class="col-sm-5 col-sm-offset-2 control-label" data-translate="gatewayApp.approvalPolicy.role"></label><label class="col-sm-3 control-label" data-translate="gatewayApp.approvalPolicy.noOfApprovals"></label><!-- </div>  --></div><div class="row" style="display: flex" ng-disabled="vm.ViewDisable" ng-hide="vm.ViewDisable"><!-- <div class="col-sm-10 col-sm-offset-2"  ng-hide="vm.ViewDisable"> --><cspl-ach class="col-sm-5 col-sm-offset-2" control-model="vm.selectedPolicyOrganisationRole" control-id="txtPolicyOrganisationRole" lookup-name="Role" display-column="name" filter-value="{{vm.ownerOrganisationId}}"></cspl-ach><div class="col-sm-3"><cspl-text control-model="vm.noOfApprovals" control-type="Number" control-id="txtNoOfApprovals" control-maxlength="1" control-minvalue="1" control-maxvalue="5" form="approvalPolicyForm"></div><div class="col-sm-2"><button type="button" class="btn btn-info active" ng-disabled="approvalPolicyForm.$invalid" ng-click="vm.addProcessRole()"><span class="glyphicon glyphicon-plus"></span><span data-translate="entity.action.add"></span></button></div><!-- </div> --></div><div class="row" style="display: flex" ng-disabled="vm.ViewDisable"><div class="col-sm-offset-2" style="padding-left: 8px"><input type="checkbox" style="margin-top:5px" ng-model="vm.approvalPolicyDTO.isSendEmail" ng-disabled="vm.ViewDisable" form="approvalPolicyForm" id="chkIsSendEmail"></div><label class="col-sm-3 control-label" for="chkIsSendEmail" data-translate="gatewayApp.approvalPolicy.isSendEmail">Is send email</label></div><br><div class="table-responsive col-sm-12"><table class="dataTable table table-striped table-hover"><thead><tr class="pl-2"><!-- <th class="col-sm-1 "></th>--><th class="col-sm-2" data-translate="gatewayApp.approvalPolicy.levels"></th><th class="col-sm-5" nowrap="nowrap" data-translate="gatewayApp.approvalPolicy.role"></th><th class="col-sm-3" data-translate="gatewayApp.approvalPolicy.noOfApprovals"></th><th></th></tr></thead><tbody><tr ng-repeat="approvalPolicyRole in vm.approvalPolicyRolesList| filter : filterText"><td>{{ ("gatewayApp.approvalPolicy.level" | translate) + " " + ($index + 1)}}</td><td>{{approvalPolicyRole.organisationRole.name}}</td><td>{{approvalPolicyRole.noOfApprovals}}</td><td class="text-right"><i ng-if="!vm.ViewDisable" ng-disabled="vm.ViewDisable" ng-click="!vm.ViewDisable ? vm.removePolicy($index):\'\'" class="glyphicon glyphicon-remove"></i></td></tr></tbody></table></div><br><br></fieldset></div><div class="modal-footer"><button type="button" ng-if="showCancelButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-if="vm.btnClose" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="gatewayApp.approvalPolicy.close">OK</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-click="vm.clicked=true;vm.resubmitApprovalPolicy()" ng-disabled="vm.clicked"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardApprovalPolicy()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="vm.btnApproveReject" class="btn btn-reject" ng-click="vm.rejectApprovalPolicy()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="vm.btnApproveReject" class="btn btn-approve" ng-click="vm.clicked=true;vm.approveApprovalPolicy()" ng-disabled="vm.clicked" autofocus><span data-translate="entity.action.approve">Approve</span></button> <button type="submit" ng-if="showSaveButton" ng-disabled="approvalPolicyForm.$invalid || (vm.approvalPolicyDTO.id!=null && approvalPolicyForm.$pristine) || vm.clicked" class="btn btn-info active" ng-click="vm.clicked=true;!vm.ViewDisable?vm.save():\'\'"><span data-translate="gatewayApp.approvalPolicy.submit">Save</span></button></div></div></div></form>');
$templateCache.put('app/entities/approval-policy/approval-policy.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="gatewayApp.title.manageApprovalPolicy"></span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="pull-right"><button type="button" class="btn btn-info active" ng-click="vm.screenLog.screenLog(vm.ApprovalProcessScreen, 0, vm.entityConstants.ENTITY_ACTION_TYPE.ADD); vm.launch()" ng-show="vm.permitApprovalProcessCreateEntityAction"><img ng-src="assets/images/Add.png"> <span data-translate="gatewayApp.approvalPolicy.approvePolicy"></span></button><div class="col-md-6 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="tblApprovalPolicy" total-record-count="vm.approvalPolicies.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Approval_Policy"></cspl-table-export></div></div><div class="bootstrap-tableresponsive"><table id="tblApprovalPolicy" class="dataTable table table-striped table-hover"><thead><tr><th class="col-md-5" data-translate="gatewayApp.approvalPolicy.approvalPolicyName"></th><th class="col-md-3" data-translate="gatewayApp.approvalPolicy.assignedRoles"></th><th class="col-md-2" data-translate="gatewayApp.approvalPolicy.actionsAssigned"></th><th class="col-md-2"></th></tr></thead><tbody><tr ng-repeat="approvalPolicy in  filteredPolicies= ( vm.approvalPolicies |filter : filterText)"><td>{{approvalPolicy.shortName}}</td><td><span ng-repeat="role in approvalPolicy.approvalPolicyRoles" ng-init="role.appender = $index < approvalPolicy.approvalPolicyRoles.length-1?\',\' :\'\'">{{ role.organisationRole.name + role.appender }}</span></td><td>{{ (approvalPolicy.assignedEntityActionCount > 0) ?("gatewayApp.approvalPolicy.yes"|translate) : ("gatewayApp.approvalPolicy.no"|translate)}}</td><td><div class="btn-group utility col-md-2" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ui-sref="approval-policy.view({id:approvalPolicy.id})" ng-click="vm.screenLog.screenLog(vm.ApprovalProcessScreen, approvalPolicy.id, vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitApprovalProcessEditEntityAction"><a ui-sref="approval-policy.edit({id:approvalPolicy.id})" ng-click="vm.screenLog.screenLog(vm.ApprovalProcessScreen, approvalPolicy.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></a></li><li ng-show="vm.permitApprovalProcessDeleteEntityAction"><a ui-sref="approval-policy.delete({id:approvalPolicy.id})" ng-click="vm.screenLog.screenLog(vm.ApprovalProcessScreen, approvalPolicy.id, vm.entityConstants.ENTITY_ACTION_TYPE.DELETE)"><span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></a></li><li ng-show="vm.permitEntityStateApprovalProcessMapEntityAction"><a ui-sref="approval-policy.map({id:approvalPolicy.id})" ng-click="vm.screenLog.screenLog(vm.EntityStateApprovalProcessScreen, approvalPolicy.id, vm.entityConstants.ENTITY_ACTION_TYPE.MAP)"><span class="hidden-xs hidden-sm" data-translate="gatewayApp.approvalPolicy.assignUnassignAction"></span></a></li></ul></div></td></tr></tbody></table></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/approval-policy/entity-action-approval-policy.html','<form name="entityActionApprovalPolicyForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="gatewayApp.title.assingOrUnAssignActions"></span></h4></div><div class="modal-body"><nmb-alert-error></nmb-alert-error><div class="content"><div class="row"><fieldset><div class="row"><b class="col-md-6">{{vm.entityActionApprovalPolicyDTO.shortName}}</b></div><div class="row"><div class="col-md-6 pull-right"><div class="col-md-12 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><cspl-table-export table-name="tblEntityActionsApprovalPolicy" ignore-column="0" total-record-count="vm.entityActionApprovalPolicies.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="Entity_Action_Approval_Policy"></cspl-table-export></div></div><div class="table-responsive col-md-12"><table id="tblEntityActionsApprovalPolicy" class="dataTable table table-striped table-hover"><thead><tr><th><label class="check-control"><input id="selectAll" ng-disabled="vm.ViewDisable" class="checkbox" name="" ng-model="vm.selectAll" type="checkbox" ng-click="vm.checkOrUncheckHeaderAction($event)"> <span class="checkbox-overlay-header"></span></label></th><th data-translate="gatewayApp.approvalPolicy.actions"></th><th data-translate="gatewayApp.approvalPolicy.assignedApprovalPolicy"></th></tr></thead><tbody><tr ng-repeat="entityActionApprovalPolicy in policies = ( vm.entityActionApprovalPolicies| filter: filterText) |limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)" ng-hide="(entityActionApprovalPolicy.entityActions.entity.shortName == \'UserMembership\') ? true : false"><td><input style="margin-right:0px" class="checklist" ng-disabled="vm.ViewDisable" type="checkbox" checklist-model="vm.selected.entityActions" checklist-value="entityActionApprovalPolicy.entityActions" ng-model="justAnotherCheckedVar" ng-click="vm.checkOrUncheckAction()"></td><td>{{entityActionApprovalPolicy.entityActions.shortName}}</td><td>{{entityActionApprovalPolicy.approvalPolicy.policyName}}</td></tr></tbody></table><div stlye=""><cspl-pagination record-count="policies.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination><!--  <uib-pagination ng-model="vm.pageCount"  total-items="vm.totalRecordLength" items-per-page="vm.itemsPerPage"></uib-pagination> --></div></div></fieldset></div></div><div class="modal-footer"><a ng-show="vm.ShowApprovalPolicyLink" class="pull-left" ui-sref="entity-action-approval-policy-view({id:vm.entityActionApprovalPolicyDTO.approvalPolicyId})">{{\'gatewayApp.approvalPolicy.viewMappedApprovalPolicy\'| translate}}</a> <button type="button" ng-show="showCancelButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-show="vm.btnClose" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="gatewayApp.approvalPolicy.close"></span></button> <button type="button" ng-show="showResubmitButton" class="btn btn-primary" ng-click="vm.clicked=true;vm.resubmitEntityActionApprovalPolicy()" ng-disabled="vm.clicked"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="button" ng-show="showDiscardButton" class="btn btn-reject" ng-click="vm.discardEntityActionApprovalPolicy()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-show="vm.btnApproveReject" class="btn btn-reject" ng-click="vm.rejectEntityActionApprovalPolicy()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-show="vm.btnApproveReject" class="btn btn-approve" ng-click="vm.clicked=true;vm.approveEntityActionApprovalPolicy()" ng-disabled="vm.clicked"><span data-translate="entity.action.approve">Approve</span></button> <button type="submit" ng-show="showSaveButton" class="btn btn-info active" ng-click="vm.clicked=true;showSaveButton?vm.save():\'\'" ng-disabled="entityActionApprovalPolicyForm.$pristine || vm.clicked"><span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/bank-fees-and-charges-upload/bank-fees-and-charges.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.bankFeesAndChargesUpload.title"></h2><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="module-wrapper"><section class="module"><div class="module-inner"><div><div class="row"><div class="pull-left"><a href="" style="color: #fff; vertical-align: -19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size: 20px"></i></a></div></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="clearcorpTermsCondition" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.bankFeesAndChargesUpload.lastmodifiedDateTime">Last Modified Date</th><th></th><th></th></tr></thead><tbody><tr class="clearcorp-terms-conditions"><td width="25%"><span>{{vm.bankFeeChargeDetails.lastModifiedDate | date:\'dd-MMM-yyyy hh:mm:ss a\'}}</span></td><!-- ng-show="tac.lastModifiedDate != null && tac.tacFiles != null" --><td width="10%" ng-show="vm.bankFeeChargeDetails.lastModifiedDate != \'-\'"><span style="color: #FFAA1D" ng-show="vm.bankFeeChargeDetails.feeFiles.fileContent != null" class="glyphicon glyphicon-file" ng-click="vm.openBankFeesChargesPreview(vm.bankFeeChargeDetails.feeFiles)" title="View Bank Fee and Charges"></span></td><td><span><img src="assets/images/EditProfile.png" class="EditProfile-noHover" ng-click="vm.uploadBankFeesCharges(vm.bankFeeChargeDetails)"> <img src="assets/images/EditProfile_Black.png" class="EditProfile-Hover" ng-click="vm.uploadBankFeesCharges(vm.bankFeeChargeDetails)" title="Revise Bank Fee and Charges"></span></td><td ng-show="vm.bankFeeChargeDetails.feeFiles.fileContent == null"></td></tr></tbody></table></div></div></div></section></div></div>');
$templateCache.put('app/entities/bank-fees-and-charges-upload/fee-charge-upload.html','<div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="global.menu.bankFeesAndChargesUpload.title"></span></h4></div><div class="modal-body"><div class="content"><p><nmb-alert></nmb-alert></p><p><nmb-alert-error></nmb-alert-error></p><form name="bankFeeUploadForm" role="form" novalidate><div class="col-md-offset-1 col-sm-offset-1 col-xs-offset-1 col-lg-offset-1 col-md-8 col-sm-8 col-xs-11 col-lg-8"><div class="row"><label class="control-label margin-top-7" cspl-mandatory><span data-translate="gatewayApp.bankFeesAndChargesUpload.bankName"></span></label></div><div class="row"><span class="col-md-8 col-lg-7 col-sm-8 col-xs-8" style="margin-left: -8px"><cspl-text control-model="vm.bank.bankName" control-id="txtbankName" control-disabled="true" placeholder="" form="termsConditionUploadForm" required></span></div><div class="row"><label class="control-label margin-top-7" cspl-mandatory><span data-translate="gatewayApp.bankFeesAndChargesUpload.filePath">filePath</span></label></div><div class="row"><div class="col-md-8 col-lg-7 col-sm-8 col-xs-8" style="margin-left: -8px"><div class="input-group col-md-12"><input type="text" class="form-control fileOpen" ng-class="{ \'red\': vm.checkBankFeeFile && (vm.inputBankFee==null || vm.inputBankFee==undefined)}" style="width: 75%" ng-model="vm.inputBankFee" ng-blur="vm.checkBankFeeFile=true;" readonly="readonly"><label style="width: 25%" for="bankFeeFile" ng-class="{ \'notentered\': vm.checkBankFeeFile && (vm.inputBankFee==null || vm.inputBankFee==undefined)}" class="btn btn-primary fileUploadDark"><img src="assets/images/Open Path-26.png" style="pointer-events: none"></label><input type="file" id="bankFeeFile" name="bankFeeUpload" fileread="vm.bankFee" accept="application/pdf" form="bankFeeUploadForm" ng-hide="true"> <span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.invalidBankFeeSize"><!-- Uploaded content should not be greater than 500 kb. --> {{vm.invalidBankFeeSizeText}} </span><span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.invalidBankFee">{{vm.invalidBankFeeText}}</span> <span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.invalidBankFeeName">{{vm.invalidBankFeeNameText}}</span> <span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.checkBankFeeFile && ( vm.inputBankFee==null || vm.inputBankFee==undefined)">Pdf file should be uploaded.</span></div></div><div class=""><button type="submit" class="btn btn-primary" ng-disabled="bankFeeUploadForm.$invalid || (vm.bankFee == null) || vm.clicked" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.upload">UPLOAD</span></button></div></div><div class="row"><div class="orderStatusInfo col-md-12 no-padding-top no-padding-left" style="float: left"><div class="no-padding-left no-padding-right"><div><span data-translate="gatewayApp.bankFeesAndChargesUpload.acceptedFileTypeLegend">Accepted file format .pdf</span></div><span ng-show="vm.showInKB" data-translate="gatewayApp.bankFeesAndChargesUpload.maximumFileSizeLegend" data-translate-values="{value: {{vm.bankFeeFileUploadSize}}}"></span> <span ng-show="vm.showInKB == false" data-translate="gatewayApp.bankFeesAndChargesUpload.maximumFileSizeLegendMB" data-translate-values="{value: {{vm.bankFeeFileUploadSize}}}"></span></div></div></div><div class="row"></div><br></div><br><br><div class="row col-md-offset-1 col-sm-offset-1 col-xs-offset-1 col-lg-offset-1 col-md-9 col-sm-10 col-xs-11 col-lg-10">&nbsp;</div></form></div></div>');
$templateCache.put('app/entities/bank-fees-and-charges-upload/fee-upload-approval.html','<div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="global.menu.bankFeesAndChargesUpload.title"></span></h4></div><div class="modal-body"><div class="content"><p><nmb-alert></nmb-alert></p><p><nmb-alert-error></nmb-alert-error></p><form name="bankFeeUploadForm" role="form" novalidate><div class="col-md-offset-1 col-sm-offset-1 col-xs-offset-1 col-lg-offset-1 col-md-8 col-sm-8 col-xs-11 col-lg-8"><div class="row"><label class="control-label margin-top-7" cspl-mandatory><span data-translate="gatewayApp.bankFeesAndChargesUpload.bankName"></span></label></div><div class="row"><span class="col-md-8 col-lg-7 col-sm-8 col-xs-8" style="margin-left: -8px"><cspl-text control-model="vm.bankFeeDTO.bank.bankName" control-id="txtbankName" control-disabled="true" placeholder="" form="bankFeeUploadForm" required></span><div class="col-md-4 col-lg-5 col-sm-4 col-xs-4" ng-if="showResubmitButton == false"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.openBankFeePreview(vm.bankFeeDTO.bankFeesCharges.feeFiles)"><span data-translate="gatewayApp.bankFeesAndChargesUpload.Preview"></span></button></div></div><div class="row" ng-if="showResubmitButton == true"><div class="col-md-4 col-lg-5 col-sm-4 col-xs-4" ng-if="showResubmitButton == false"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.openBankFeePreview(vm.bankFeeDTO.bankFeesCharges.feeFiles)"><span data-translate="gatewayApp.bankFeesAndChargesUpload.Preview"></span></button></div></div><div class="row" ng-show="showResubmitButton"><label class="control-label margin-top-7" cspl-mandatory><span data-translate="gatewayApp.bankFeesAndChargesUpload.filePath"></span></label></div><div class="row" ng-show="showResubmitButton"><div class="col-md-8 col-lg-7 col-sm-8 col-xs-8" style="margin-left: -8px"><div class="input-group col-md-12"><input type="text" class="form-control fileOpen" ng-class="{ \'red\': vm.checkBankFeeFile && (vm.inputbankFee==null || vm.inputbankFee==undefined)}" style="width: 75%" ng-model="vm.inputBankFee" ng-blur="vm.checkBankFeeFile=true;" readonly="readonly"><label style="width: 25%" for="bankFeeFile" ng-class="{ \'notentered\': vm.checkBankFeeFile && (vm.inputBankFee==null || vm.inputBankFee==undefined)}" class="btn btn-primary fileUploadDark"><img src="assets/images/Open Path-26.png" style="pointer-events: none"></label><input type="file" id="bankFeeFile" name="bankFeeUpload" fileread="vm.bankFee" accept="application/pdf" form="bankFeeUploadForm" ng-hide="true"> <span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.invalidBankFeeSize"><!-- Uploaded content should not be greater than 500 kb. -->{{ vm.invalidBankFeeSixeText}} </span><span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.invalidBankFee">{{vm.invalidBankFeeText}}</span> <span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.invalidBankFeeName">{{vm.invalidBankFeeNameText}}</span> <span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.checkBankFeeFile && ( vm.inputBankFee==null || vm.inputBankFee==undefined)">Pdf file should be uploaded.</span></div></div><div class=""><button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="bankFeeUploadForm.$invalid || (vm.bankFee == null) || vm.clicked" ng-click="vm.clicked = true;vm.resubmitBankFee();"><span data-translate="entity.action.resubmit">UPLOAD</span></button></div></div><div class="row" ng-if="showResubmitButton"><div class="orderStatusInfo col-md-12 no-padding-top no-padding-left" style="float: left"><div class="no-padding-left no-padding-right"><div><span data-translate="gatewayApp.bankFeesAndChargesUpload.acceptedFileTypeLegend"></span></div><span ng-show="vm.showInKB" data-translate="gatewayApp.bankFeesAndChargesUpload.maximumFileSizeLegend" data-translate-values="{value: {{vm.bankFeeFileUploadSize}}}"></span> <span ng-show="vm.showInKB == false" data-translate="gatewayApp.bankFeesAndChargesUpload.maximumFileSizeLegendMB" data-translate-values="{value: {{vm.bankFeeFileUploadSize}}}"></span></div></div></div><div class="row"></div><br></div><div class="col-md-offset-2 col-sm-offset-2 col-xs-offset-1 col-lg-offset-2 col-md-10 col-sm-10 col-xs-11"><div class="row"><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()" ng-if="!showResubmitButton">&nbsp;<span>OK</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardBankFee()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectBankFee()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" autofocus class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveBankFee();vm.clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div></div></div></form></div></div>');
$templateCache.put('app/entities/bank-registration/bank-registration-delete-dialog.html','<style>.modal-header-red {background-color:#f77b6b; padding:0px; height:50px; border-top-left-radius:3px; border-top-right-radius:3px;}\r\n .modal-title {color:#FFF; vertical-align:middle; line-height:50px;}\r\n .modal-header button.close {color:#FFF; vertical-align:middle;}\r\n .modal-body {padding:20px;}</style><form name="deleteForm" ng-submit="clicked=true;vm.confirmDelete(vm.bankRegistration.id)"><div class="modal-header modal-header-red"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" style="text-align:left;padding-left:3%">Are you sure?</h4></div><div class="modal-body"><nmb-alert-error></nmb-alert-error><p><textarea class="form-control" rows="6" ng-model="vm.reason" placeholder="Please provide a reason" required></textarea></p><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid||clicked" class="btn btn-danger"><span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/bank-registration/bank-registration-detail.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="bankRegistrationViewForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><span data-translate="global.menu.bankRegistration.main"></span></h4></div><div class="modal-body"><div class="content"><fieldset><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseBankDetails = !vm.ExpandOrCollapseBankDetails" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseThree"><img ng-src="{{vm.ExpandOrCollapseBankDetails == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="nav-label">Bank Details</span></a></h4></div><div id="collapseThree" class="panel-collapse collapse in" style="background-color: black"><div class="accordion-content1"><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.bankName"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.bankName" control-id="txtbankName" control-disabled="true" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.bankShortName"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.bankShortName" control-id="txtBankShortName" control-disabled="true" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.ccpMembershipId"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.ccpMembershipId" control-id="txtccpMembershipId" control-type="Alphanumeric" control-minlength="3" control-maxlength="12" control-disabled="true" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.bankMemberNo"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.bankMemberNo" control-id="txtbankMemberNo" control-disabled="true" control-type="Number" control-minlength="3" control-maxlength="12" control-value-change="vm.getUserNo(vm.bankRegistration.bankMemberNo)" placeholder="" form="bankregistrationForm" required></cspl-text><span class="help-block-error" ng-show="vm.bankRegistration.bankMemberNo!=null && vm.bankRegistration.userNo==null">Invalid bank member number</span></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.userNo"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.userNo" control-id="txtuserNo" control-disabled="true" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.NGCode"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.ngCode" control-id="txtNGCode" control-type="ShortName" control-minlength="4" control-maxlength="4" control-disabled="true" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.dateOfJoining"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-3"><cspl-dtp control-model="vm.bankRegistration.dateOfJoining" control-id="dtpdateOfJoining" form="bankregistrationForm" control-disabled="true" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.noOfPermissibleUsers"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-3"><cspl-numeric control-model="vm.bankRegistration.noOfPermissibleUsers" control-disabled="true" control-id="txtnoOfPermissibleUsers" no-of-decimals="{{}}" currency-code="" form="bankregistrationForm" required><span class="help-block" data-translate="gatewayApp.bankRegistration.noOfPermissibleUsersDetail"></span></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.legalName"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.legalName" control-id="txtlegalName" control-maxlength="100" control-disabled="true" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.tradeName"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.tradeName" control-id="txttradeName" control-maxlength="100" control-disabled="true" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.primaryContactName"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.primaryContactName" control-disabled="true" control-id="txtprimaryContactName" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.primaryEmailId"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.primaryEmailId" control-disabled="true" control-id="txtprimaryEmailId" control-type="Email" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.primaryMobileNo"></span></label></div><div class="row"><div class="col-lg-1 col-md-offset-3"><cspl-numeric control-model="vm.mobileCountryCode" control-id="txtMobileCountryCode" no-of-decimals="0" control-disabled="true" form="bankregistrationForm" required></div><div class="col-md-3"><cspl-text control-model="vm.bankRegistration.primaryMobileNo" control-type="Number" control-disabled="true" control-maxlength="15" control-id="txtprimaryMobileNo" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.address1"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.address1" control-id="txtbankAddress1" control-maxlength="255" control-disabled="true" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.address2"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.address2" control-id="txtbankAddress2" control-maxlength="255" control-disabled="true" placeholder="" form="bankregistrationForm"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.city"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.city" control-id="txtbankCity" control-maxlength="255" control-disabled="true" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.country"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-ach control-model="vm.bankRegistration.country" control-id="txtCountry" lookup-name="country" control-disabled="true" display-column="shortName" control-required="true" form="bankregistrationForm"></cspl-ach></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.state"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-3"><cspl-ach control-model="vm.bankRegistration.state" control-id="txtstateForCode" lookup-name="state" display-column="shortName" control-disabled="true" filter-value="{{vm.country.id}}~~" form="bankregistrationForm" control-required="true"></div><div class="col-lg-1"><cspl-numeric control-model="vm.bankRegistration.state.tinNumber" control-id="txtStateCode" no-of-decimals="0" control-max="99" form="bankregistrationForm" required control-disabled="true"></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.pincode"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.pincode" control-id="txtpincode" control-type="Alphanumeric" control-maxlength="7" placeholder="" form="bankregistrationForm" required control-disabled="true"></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.gst_In"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.gst_In" control-minlength="15" control-maxlength="15" help-text="{{\'userManagement.helpText.gstin\' | translate}}" control-type="Alphanumeric" control-id="txtgst_In" placeholder="" required control-disabled="true" form="bankregistrationForm"></div></div><div class="row" ng-hide="vm.hidePanForAudit"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.bankPan"></span></label></div><div class="row" ng-hide="vm.hidePanForAudit"><div class="col-md-4 col-md-offset-3"><!-- <div class="col-md-3 col-md-offset-3"> --><cspl-text control-model="vm.bankRegistration.bankPan" control-minlength="10" control-maxlength="10" help-text="{{\'gatewayApp.bankRegistration.helpText.bankPan\' | translate}}" control-type="AlphanumericWithCaps" control-id="txtbankPan" placeholder="" required control-disabled="true" form="bankregistrationForm"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.bankCategory"></span></label><div class="col-md-6 col-md-offset-3"><cspl-ach control-model="vm.bankRegistration.bankCategory" control-id="txtBankCategory" control-disabled="true" lookup-name="bankCategory" display-column="displayName" placeholder="" form="bankregistrationForm" control-disabled="true" required></div></div></div></div></div><div class="default-users" ng-show="vm.user1.login !=null" control-required="vm.bankRegistration.id ==null" style="display: block; align: center; margin-top: 20px; margin-bottom: 10px"><label class="section-header" style="background: #000000"><span>Default Users</span></label><br><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseUser1 = !vm.ExpandOrCollapseUser1" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseOne"><img ng-src="{{vm.ExpandOrCollapseUser1 == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="nav-label">User 1</span></a></h4></div><div id="collapseOne" class="panel-collapse collapse" style="background-color: black; height: 240px"><div class="accordion-content"><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.firstName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.firstName" control-id="txtfirstName" control-maxlength="100" placeholder="" form="bankregistrationForm" control-disabled="true" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.middleName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.middleName" control-disabled="true" control-id="txtmiddleName" control-maxlength="100" placeholder=""></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.lastName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.lastName" control-id="txtlastName" control-maxlength="100" control-disabled="true" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><!-- <div class="row">\r\n\t\t\t\t\t\t\t\t\t<label class="col-md-4 control-label col-md-offset-1"><span\r\n\t\t\t\t\t\t\t\t\t\tdata-translate="userManagement.aadharNumber"></span></label>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-11 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t\t\t<cspl-text control-model="vm.user1.aadharNumber"\r\n\t\t\t\t\t\t\t\t\t\t\tcontrol-id="txtaadharNumber" control-disabled="true"\r\n\t\t\t\t\t\t\t\t\t\t\tform="bankregistrationForm" />\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> --><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.gender"></span></label></div><div class="row"><div id="btnGroup" class="col-md-7 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.user1.gender" ng-disabled="true" uib-btn-radio="\'M\'">M</label><label class="btn btn-primary" ng-model="vm.user1.gender" ng-disabled="true" uib-btn-radio="\'F\'">F&nbsp;</label><label class="btn btn-primary" ng-model="vm.user1.gender" ng-disabled="true" uib-btn-radio="\'O\'">O&nbsp;</label></div></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.dob"></span></label></div><div class="row"><div class="col-md-5 col-md-offset-1"><cspl-dtp control-model="vm.user1.dob" control-id="dtpDOB" control-required="vm.bankRegistration.id ==null" control-disabled="true" form="bankregistrationForm"></cspl-dtp></div></div><div class="row" style="margin-top: 8px"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.login"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.login" control-disabled="true" control-id="txtLogin" control-maxlength="100" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.email"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.email" control-type="Email" control-disabled="true" control-id="txtemail" control-maxlength=" 100" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.mobile"></span></label></div><div class="row"><div class="col-lg-2 col-md-offset-1"><cspl-numeric control-model="vm.user1.mobileCountryCode" control-id="txtMobileCountryCode" no-of-decimals="0" control-disabled="true" control-required="vm.bankRegistration.id ==null" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div><div class="col-md-5"><cspl-text control-model="vm.user1.mobile" control-type="Number" control-id="txtMobile" control-maxlength="15" control-disabled="true" control-required="vm.bankRegistration.id ==null" form="bankregistrationForm"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.address1"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.address1" control-id="txtaddress1" control-maxlength="255" control-disabled="true" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.address2"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.address2" control-id="txtaddress2" control-maxlength="255" control-disabled="true" placeholder="" form="bankregistrationForm"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.city"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.city" control-id="txtcity" control-maxlength="255" placeholder="" control-disabled="true" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.country"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user1.country" control-id="txtCountry" lookup-name="country" control-disabled="true" display-column="shortName" control-required="vm.bankRegistration.id ==null" form="bankregistrationForm"></cspl-ach></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.state"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user1.state" control-id="txtstate" lookup-name="state" display-column="shortName" control-disabled="true" filter-value="{{vm.user1.country.id}}~~" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.pincode"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text control-model="vm.user1.pincode" control-id="txtpincode" control-type="Alphanumeric" control-disabled="true" control-maxlength="7" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div></div></div></div><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseUser2 = !vm.ExpandOrCollapseUser2" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseTwo"><img ng-src="{{vm.ExpandOrCollapseUser2 == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="nav-label">User 2</span></a></h4></div><div id="collapseTwo" class="panel-collapse collapse" style="background-color: black; height: 240px"><div class="accordion-content"><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.firstName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.firstName" control-disabled="true" control-id="txtfirstName" control-maxlength="100" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.middleName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.middleName" control-disabled="true" control-id="txtmiddleName" control-maxlength="100" placeholder=""></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.lastName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.lastName" control-disabled="true" control-id="txtlastName" control-maxlength="100" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><!-- <div class="row">\r\n\t\t\t\t\t\t\t\t\t<label class="col-md-4 control-label col-md-offset-1"><span\r\n\t\t\t\t\t\t\t\t\t\tdata-translate="userManagement.aadharNumber"></span></label>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-11 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t\t\t<cspl-text control-model="vm.user2.aadharNumber" control-disabled="true"\r\n\t\t\t\t\t\t\t\t\t\t\tcontrol-id="txtaadharNumber2"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tform="bankregistrationForm" />\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> --><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.gender"></span></label></div><div class="row"><div id="btnGroup" class="col-md-7 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.user2.gender" ng-disabled="true" uib-btn-radio="\'M\'">M</label><label class="btn btn-primary" ng-model="vm.user2.gender" ng-disabled="true" uib-btn-radio="\'F\'">F&nbsp;</label><label class="btn btn-primary" ng-model="vm.user2.gender" ng-disabled="true" uib-btn-radio="\'O\'">O&nbsp;</label></div></div></div><div class="row" style="margin-top: 8px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.dob"></span></label></div><div class="row"><div class="col-md-5 col-md-offset-1"><cspl-dtp control-model="vm.user2.dob" control-id="dtpDOB" control-required="vm.bankRegistration.id ==null" control-disabled="true" form="bankregistrationForm"></cspl-dtp></div></div><div class="row" style="margin-top: 8px"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.login"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.login" control-disabled="true" control-id="txtLogin" control-maxlength="100" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.email"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.email" control-type="Email" control-disabled="true" control-id="txtemail" control-maxlength=" 100" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.mobile"></span></label></div><div class="row"><div class="col-lg-2 col-md-offset-1"><cspl-numeric control-model="vm.user2.mobileCountryCode" control-disabled="true" control-id="txtMobileCountryCode" no-of-decimals="0" control-required="vm.bankRegistration.id ==null" form="bankregistrationForm"></div><div class="col-md-5"><cspl-text control-model="vm.user2.mobile" control-type="Number" control-id="txtMobile" control-maxlength="15" control-required="vm.bankRegistration.id ==null" control-disabled="true" form="bankregistrationForm"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.address1"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.address1" control-disabled="true" control-id="txtaddress1" control-maxlength="255" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.address2"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.address2" control-disabled="true" control-id="txtaddress2" control-maxlength="255" placeholder="" form="bankregistrationForm"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.city"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.city" control-id="txtcity" control-maxlength="255" placeholder="" control-disabled="true" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.country"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user2.country" control-id="txtCountry" lookup-name="country" control-disabled="true" display-column="shortName" control-required="vm.bankRegistration.id ==null" form="bankregistrationForm"></cspl-ach></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.state"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user2.state" control-id="txtstate" lookup-name="state" display-column="shortName" control-disabled="true" filter-value="{{vm.user2.country.id}}~~" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row" style="margin-top: 8px"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.pincode"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text control-model="vm.user2.pincode" control-id="txtpincode" control-type="Alphanumeric" control-disabled="true" control-maxlength="7" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div></div></div></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>OK</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardBankRegistration()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showButton" class="btn btn-reject" ng-click="vm.rejectBankRegistration()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" class="btn btn-approve" ng-disabled="clicked" ng-click="vm.approveBankRegistration();clicked=true;" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/bank-registration/bank-registration-dialog.html','<form name="bankregistrationForm" role="form" novalidate><div class="modal-header"><div class="modal-title"><span data-translate="gatewayApp.bankRegistration.addBank" ng-show="vm.bankRegistration.id==null"></span><span data-translate="gatewayApp.bankRegistration.editBank" ng-show="vm.bankRegistration.id!=null"></span></div></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset ng-disabled="vm.disableForm"><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseBankDetails = !vm.ExpandOrCollapseBankDetails" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseThree"><img ng-src="{{vm.ExpandOrCollapseBankDetails == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="nav-label">Bank Details</span></a></h4></div><div id="collapseThree" class="panel-collapse collapse in" style="background-color: black"><div class="accordion-content1"><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.bankName"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.bankName" control-type="StringWithoutCommaWithScriptValidation" control-id="txtbankName" control-maxlength="100" control-disabled="vm.bankRegistration.id !=null" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.bankShortName"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.bankShortName" control-id="txtBankShortName" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.ccpMembershipId"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.ccpMembershipId" control-id="txtccpMembershipId" control-type="AlphanumericWithCaps" control-minlength="3" control-maxlength="12" control-disabled="vm.bankRegistration.id !=null" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.bankMemberNo"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.bankMemberNo" control-id="txtbankMemberNo" control-disabled="vm.bankRegistration.id !=null" control-type="Number" control-minlength="3" control-maxlength="9" control-value-change="vm.getUserNo(vm.bankRegistration.bankMemberNo)" placeholder="" form="bankregistrationForm" required></cspl-text><span class="help-block-error" ng-show="vm.bankRegistration.bankMemberNo!=null && vm.bankRegistration.userNo==null && vm.bankRegistration.bankMemberNo.toString().length>=3">Invalid bank member number</span></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.userNo"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.userNo" control-id="txtuserNo" control-disabled="true" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.NGCode"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.ngCode" control-id="txtNGCode" control-type="ShortName" control-minlength="4" control-maxlength="4" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.dateOfJoining"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-3"><cspl-dtp control-model="vm.bankRegistration.dateOfJoining" control-id="dtpdateOfJoining" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.noOfPermissibleUsers"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-3"><cspl-text control-type="Number" control-model="vm.bankRegistration.noOfPermissibleUsers" control-minvalue="4" control-maxlength="4" control-id="txtnoOfPermissibleUsers" form="bankregistrationForm" required><span class="help-block" data-translate="gatewayApp.bankRegistration.noOfPermissibleUsersDetail"></span></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.legalName"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.legalName" control-id="txtlegalName" control-maxlength="100" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.tradeName"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.tradeName" control-id="txttradeName" control-maxlength="100" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.primaryContactName"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.primaryContactName" control-type="AlphaWithSpace" control-id="txtprimaryContactName" placeholder="" control-maxlength="100" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.primaryEmailId"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.primaryEmailId" control-id="txtprimaryEmailId" control-type="Email" control-maxlength="100" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.primaryMobileNo"></span></label></div><div class="row"><div class="col-lg-1 col-md-offset-3"><cspl-numeric control-model="vm.mobileCountryCode" control-id="txtMobileCountryCode" no-of-decimals="0" control-tab-index="-1" control-max="999" control-min="1" form="bankregistrationForm" required></div><div class="col-md-3"><cspl-text control-model="vm.bankRegistration.primaryMobileNo" control-type="Number" control-maxlength="15" control-id="txtprimaryMobileNo" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.address1"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.address1" control-id="txtbankAddress1" control-maxlength="255" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.bankRegistration.address2"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.address2" control-id="txtbankAddress2" control-maxlength="255" placeholder="" form="bankregistrationForm"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.city"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.city" control-id="txtbankCity" control-maxlength="255" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.country"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-ach control-model="vm.bankRegistration.country" control-id="txtbankCountry" lookup-name="country" display-column="shortName" form="bankregistrationForm" control-required="true"></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.state"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-3"><cspl-ach control-model="vm.bankRegistration.state" control-id="txtstateForCode" lookup-name="state" display-column="shortName" filter-value="{{vm.bankRegistration.country.id}}~~" form="bankregistrationForm" control-required="true"></div><div class="col-lg-1"><cspl-numeric control-model="vm.stateCode" control-id="txtStateCode" no-of-decimals="0" control-max="99" form="bankregistrationForm" required control-disabled="true"></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.pincode"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.pincode" control-id="txtpincode" control-type="Alphanumeric" control-maxlength="7" placeholder="" form="bankregistrationForm" required></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.gst_In"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.gst_In" control-minlength="15" control-maxlength="15" help-text="{{\'userManagement.helpText.gstin\' | translate}}" control-type="Alphanumeric" required control-id="txtgst_In" placeholder="" form="bankregistrationForm"></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.bankPan"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-3"><cspl-text control-model="vm.bankRegistration.bankPan" control-minlength="10" control-maxlength="10" help-text="{{\'gatewayApp.bankRegistration.helpText.bankPan\' | translate}}" control-type="AlphanumericWithCaps" control-id="txtbankPan" placeholder="" required form="bankregistrationForm"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.bankRegistration.bankCategory"></span></label><div class="col-md-6 col-md-offset-3"><cspl-ach control-model="vm.bankRegistration.bankCategory" control-id="txtBankCategory" lookup-name="bankCategory" display-column="displayName" placeholder="" form="bankregistrationForm" required></div></div></div></div></div><div class="default-users" ng-show="vm.bankRegistration.id ==null" control-required="vm.bankRegistration.id ==null" style="display: block; align: center; margin-top: 20px; margin-bottom: 10px"><label class="section-header" style="background: #000000"><span>Default Users</span></label><br><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseUser1 = !vm.ExpandOrCollapseUser1" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseOne"><img ng-src="{{vm.ExpandOrCollapseUser1 == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="nav-label">User 1</span></a></h4></div><div id="collapseOne" class="panel-collapse collapse" style="background-color: black; height: 240px"><div class="accordion-content"><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.firstName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.firstName" control-id="txtfirstName" control-maxlength="100" control-type="AlphaWithSpace" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.middleName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.middleName" control-type="AlphaWithSpace" control-id="txtmiddleName" control-maxlength="100" placeholder=""></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.lastName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.lastName" control-id="txtlastName" control-maxlength="100" control-type="AlphaWithSpace" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><!-- <div class="row">\r\n\t\t\t\t\t\t\t\t\t<label class="col-md-4 control-label col-md-offset-1"><span\r\n\t\t\t\t\t\t\t\t\t\tdata-translate="userManagement.aadharNumber"></span></label>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-11 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t\t\t<cspl-text control-model="vm.user1.aadharNumber"\r\n\t\t\t\t\t\t\t\t\t\t\tcontrol-id="txtaadharNumber"\r\n\t\t\t\t\t\t\t\t\t\t\thelp-text="{{\'userManagement.helpText.aadharNumber\' | translate}}"\r\n\t\t\t\t\t\t\t\t\t\t\tcontrol-type="Number" control-minlength="12"\r\n\t\t\t\t\t\t\t\t\t\t\tcontrol-maxlength="12" placeholder=""\r\n\t\t\t\t\t\t\t\t\t\t\tform="bankregistrationForm" />\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> --><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.gender"></span></label></div><div class="row"><div id="btnGroup" class="col-md-7 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.user1.gender" uib-btn-radio="\'M\'">M</label><label class="btn btn-primary" ng-model="vm.user1.gender" uib-btn-radio="\'F\'">F&nbsp;</label><label class="btn btn-primary" ng-model="vm.user1.gender" uib-btn-radio="\'O\'">O&nbsp;</label></div></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.dob"></span></label></div><div class="row"><div class="col-md-5 col-md-offset-1"><cspl-dtp control-model="vm.user1.dob" control-id="dtpDOB" control-required="vm.bankRegistration.id ==null" form="bankregistrationForm"></cspl-dtp></div></div><div class="row" style="margin-top: 8px"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.login"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.login" control-id="txtLogin" control-maxlength="100" placeholder="" control-type="Small" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.email"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.email" control-type="Email" control-id="txtemail" control-maxlength=" 100" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.mobile"></span></label></div><div class="row"><div class="col-lg-2 col-md-offset-1"><cspl-numeric control-model="vm.user1.mobileCountryCode" control-id="txtMobileCountryCode" no-of-decimals="0" control-tab-index="-1" control-max="999" control-min="1" control-required="vm.bankRegistration.id ==null" form="bankregistrationForm"></div><div class="col-md-5"><cspl-text control-model="vm.user1.mobile" control-type="Number" control-id="txtMobile" control-maxlength="15" control-required="vm.bankRegistration.id ==null" form="bankregistrationForm"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.address1"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.address1" control-id="txtaddress1" control-maxlength="255" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.address2"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.address2" control-id="txtaddress2" control-maxlength="255" placeholder="" form="bankregistrationForm"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.city"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.city" control-id="txtcity" control-maxlength="255" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.country"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user1.country" control-id="txtCountry" lookup-name="country" display-column="shortName" control-required="vm.bankRegistration.id ==null" form="bankregistrationForm"></cspl-ach></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.state"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user1.state" control-id="txtstate" lookup-name="state" display-column="shortName" filter-value="{{vm.user1.country.id}}~~" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.pincode"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text control-model="vm.user1.pincode" control-id="txtpincode1" control-type="Alphanumeric" control-maxlength="7" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div></div></div></div><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseUser2 = !vm.ExpandOrCollapseUser2" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseTwo"><img ng-src="{{vm.ExpandOrCollapseUser2 == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="nav-label">User 2</span></a></h4></div><div id="collapseTwo" class="panel-collapse collapse" style="background-color: black; height: 240px"><div class="accordion-content"><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.firstName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.firstName" control-id="txtfirstName2" control-maxlength="100" control-type="AlphaWithSpace" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.middleName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.middleName" control-id="txtmiddleName2" control-maxlength="100" control-type="AlphaWithSpace" placeholder=""></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.lastName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.lastName" control-id="txtlastName2" control-maxlength="100" control-type="AlphaWithSpace" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><!-- <div class="row">\r\n\t\t\t\t\t\t\t\t\t<label class="col-md-4 control-label col-md-offset-1"><span\r\n\t\t\t\t\t\t\t\t\t\tdata-translate="userManagement.aadharNumber"></span></label>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-11 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t\t\t<cspl-text control-model="vm.user2.aadharNumber"\r\n\t\t\t\t\t\t\t\t\t\t\tcontrol-id="txtaadharNumber2"\r\n\t\t\t\t\t\t\t\t\t\t\thelp-text="{{\'userManagement.helpText.aadharNumber\' | translate}}"\r\n\t\t\t\t\t\t\t\t\t\t\tcontrol-type="Number" control-minlength="12"\r\n\t\t\t\t\t\t\t\t\t\t\tcontrol-maxlength="12" placeholder=""\r\n\t\t\t\t\t\t\t\t\t\t\tform="bankregistrationForm" />\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> --><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.gender"></span></label></div><div class="row"><div id="btnGroup" class="col-md-7 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.user2.gender" uib-btn-radio="\'M\'">M</label><label class="btn btn-primary" ng-model="vm.user2.gender" uib-btn-radio="\'F\'">F&nbsp;</label><label class="btn btn-primary" ng-model="vm.user2.gender" uib-btn-radio="\'O\'">O&nbsp;</label></div></div></div><div class="row" style="margin-top: 8px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.dob"></span></label></div><div class="row"><div class="col-md-5 col-md-offset-1"><cspl-dtp control-model="vm.user2.dob" control-id="dtpDOB2" control-required="vm.bankRegistration.id ==null" form="bankregistrationForm"></cspl-dtp></div></div><div class="row" style="margin-top: 8px"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.login"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.login" control-id="txtLogin2" control-maxlength="100" placeholder="" control-type="Small" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.email"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.email" control-type="Email" control-id="txtemail2" control-maxlength=" 100" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.mobile"></span></label></div><div class="row"><div class="col-lg-2 col-md-offset-1"><cspl-numeric control-model="vm.user2.mobileCountryCode" control-id="txtMobileCountryCode2" no-of-decimals="0" control-tab-index="-1" control-max="999" control-min="1" control-required="vm.bankRegistration.id ==null" form="bankregistrationForm"></div><div class="col-md-5"><cspl-text control-model="vm.user2.mobile" control-type="Number" control-id="txtMobile2" control-maxlength="15" control-required="vm.bankRegistration.id ==null" form="bankregistrationForm"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.address1"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.address1" control-id="txtaddress12" control-maxlength="255" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.address2"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.address2" control-id="txtaddress22" control-maxlength="255" placeholder="" form="bankregistrationForm"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.city"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.city" control-id="txtcity2" control-maxlength="255" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.country"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user2.country" control-id="txtCountry2" lookup-name="country" display-column="shortName" control-required="vm.bankRegistration.id ==null" form="bankregistrationForm"></cspl-ach></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.state"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user2.state" control-id="txtstate2" lookup-name="state" display-column="shortName" filter-value="{{vm.user2.country.id}}~~" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div><div class="row" style="margin-top: 8px"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.pincode"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text control-model="vm.user2.pincode" control-id="txtpincode2" control-type="Alphanumeric" control-maxlength="7" placeholder="" form="bankregistrationForm" control-required="vm.bankRegistration.id ==null"></div></div></div></div></div></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showButton" class="btn btn-primary" ng-disabled="bankregistrationForm.$invalid || vm.clicked" ng-click="vm.resubmitBankRegistration()"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="!showButton" class="btn btn-info active" ng-disabled="bankregistrationForm.$invalid || vm.clicked || bankregistrationForm.$pristine" ng-click="vm.save()"><span data-translate="entity.action.save">Save</span></button></div></div></div></form>');
$templateCache.put('app/entities/bank-registration/bank-registration.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" ng-show="vm.permitBankRegistrationCreateEntityAction">Manage Banks</h2><h2 class="view-title" ng-show="!vm.permitBankRegistrationCreateEntityAction">View Banks</h2><nmb-alert></nmb-alert><div><!-- <nmb-alert-error></nmb-alert-error> --></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="pull-right"><button type="button" class="btn btn-info active" ng-click="vm.screenLog.screenLog(vm.screenName,0,vm.entityConstants.ENTITY_ACTION_TYPE.ADD);vm.launch()" ng-show="vm.permitBankRegistrationCreateEntityAction"><img ng-src="assets/images/Add.png"> <span data-translate="global.menu.bankRegistration.mainBank"></span></button><div class="col-md-6 pull-right" ng-show="vm.bankRegistration.length > 0"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><a href="" style="color: #fff; vertical-align: -19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size: 20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="tblbankregistration" total-record-count="vm.bankRegistration.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Manage_Banks"></cspl-table-export></div><div class="pull-left" ng-show="vm.permitBankRegistrationImportEntityAction" style="margin-left: 0px"><cspl-table-import upload-type="BankImport" file-content=""></cspl-table-import></div></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden" ng-show="vm.bankRegistration.length > 0"><table id="tblbankregistration" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.bankRegistration.entityRestrictionStatus"></th><th style="min-width: 60px" data-translate="gatewayApp.bankRegistration.bankName"></th><th style="word-break: break-word" width="50px" data-translate="gatewayApp.bankRegistration.bankShortName"></th><th style="min-width: 120px" data-translate="gatewayApp.bankRegistration.ccpMembershipId"></th><th style="min-width: 85px" data-translate="gatewayApp.bankRegistration.bankMemberNo"></th><th style="min-width: 55px" data-translate="gatewayApp.bankRegistration.userNo"></th><th style="min-width: 120px" data-translate="gatewayApp.bankRegistration.NGCode"></th><th style="min-width: 70px" data-translate="gatewayApp.bankRegistration.dateOfJoining"></th><th style="min-width: 95px" data-translate="gatewayApp.bankRegistration.primaryContactName"></th><th style="min-width: 175px" data-translate="gatewayApp.bankRegistration.primaryEmailId"></th><th style="min-width: 80px" data-translate="gatewayApp.bankRegistration.primaryMobileNo"></th><th style="min-width: 70px" data-translate="gatewayApp.bankRegistration.bankPan"></th><th style="word-break: break-word" width="50px" data-translate="gatewayApp.bankRegistration.bankCategory"></th><th style="word-break: break-word" width="50px" data-translate="gatewayApp.bankRegistration.isBreached"></th><th style="word-break: break-word" width="50px" data-translate="gatewayApp.bankRegistration.defaultUser1"></th><th style="word-break: break-word" width="50px" data-translate="gatewayApp.bankRegistration.defaultUser2"></th><th></th></tr></thead><tbody><tr ng-repeat="bankregistration in filterData = (vm.bankRegistration | filter : filterText | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><!-- Column values --><td>{{bankregistration.entityRestrictionStatus.shortName}}</td><td>{{bankregistration.bankName}}</td><td>{{bankregistration.bankShortName||\'-\'}}</td><td>{{bankregistration.ccpMembershipId}}</td><td>{{bankregistration.bankMemberNo}}</td><td>{{bankregistration.userNo}}</td><td>{{bankregistration.ngCode}}</td><td>{{bankregistration.dateOfJoining | date:\'dd-MMM-yyyy\'}}</td><td style="word-break: break-word">{{bankregistration.primaryContactName}}</td><td style="word-break: break-word">{{bankregistration.primaryEmailId}}</td><td>{{bankregistration.primaryMobileNo}}</td><td>{{bankregistration.bankPan}}</td><td>{{bankregistration.bankCategory.displayName||\'-\'}}</td><td><span ng-if="bankregistration.isBankBreached==true">Yes</span> <span ng-if="bankregistration.isBankBreached==false">No</span></td><td><span ng-if="bankregistration.defaultUserList!=null && bankregistration.defaultUserList.length>0"><a ui-sref="bank-registration-user-view({id: bankregistration.defaultUserList[0].id})" ng-click="vm.screenLog.screenLog(vm.entityConstants.ENTITY_SHORT_NAME.USER_MANAGEMENT,bankregistration.defaultUserList[0].id,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span>{{bankregistration.defaultUserList[0].login}}</span> </a></span><span ng-if="bankregistration.defaultUserList ==null">-</span></td><td><span ng-if="bankregistration.defaultUserList!=null && bankregistration.defaultUserList.length>1"><a ui-sref="bank-registration-user-view({id: bankregistration.defaultUserList[1].id})" ng-click="vm.screenLog.screenLog(vm.entityConstants.ENTITY_SHORT_NAME.USER_MANAGEMENT,bankregistration.defaultUserList[1].id,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span>{{bankregistration.defaultUserList[1].login}}</span> </a></span><span ng-if="bankregistration.defaultUserList ==null">-</span></td><td class="sticky-col" style="text-align: center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitBankRegistrationViewEntityAction"><a ui-sref="bank-registration.view({id: bankregistration.id})" ng-click="vm.screenLog.screenLog(vm.screenName,bankregistration.id,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitBankRegistrationEditEntityAction"><a ui-sref="bank-registration.edit({id: bankregistration.id})" ng-click="vm.screenLog.screenLog(vm.screenName,bankregistration.id,vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="vm.bankRegistration.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="table-responsive" ng-show="vm.bankRegistration.length ==0"><span>No record found</span></div></div></section></div></div><script src="assets/js/tables.js"></script>');
$templateCache.put('app/entities/bbps-markup-details/bbps-markup-details.html','<style>body {\r\n      margin: 0;\r\n      padding: 0;\r\n      height: 100vh;\r\n      background: white;\r\n      background-size: cover;\r\n      font-family: sans-serif;\r\n    }\r\n\r\n    .pdf-container {\r\n      position: absolute;\r\n      top: 10%;\r\n      left: 10%;\r\n      width: 80%;\r\n      height: 80%;\r\n      background: white;\r\n      box-shadow: 0 0 20px rgba(0,0,0,0.4);\r\n    }</style><div class="bbps-markup-details"><section class="customer-registration-section customer-onboarding"><div class="row"><!-- <div class="form-box col-md-6 col-md-offset-3">\r\n                         <div class="form-box-heading">\r\n                            <img class="customer-page-logo" src="assets/images/CC_Logo.png" />\r\n                            <img class="customer-page-header" src="assets/images/Forex_Trading_Screen_Customer_Registration.png" />\r\n                               <span ng-if="vm.environmentName!=\'\' &&  vm.environmentName!=undefined &&  vm.environmentName!=null" style="margin-bottom: 30px;" class="btn-reg fw-bolder environment-name">{{vm.environmentName}}</span> \r\n                    </div> \r\n                </div> --><!-- <div ng-repeat="page in vm.pages">\r\n    <img ng-src="{{page}}" style="width: 100%; display: block; margin-bottom: 20px;" />\r\n</div> --><div id="pdfContainer" style="width:100%; height:90vh; border:1px solid #ccc"></div></div></section></div>');
$templateCache.put('app/entities/branch/branch-delete-dialog.html','<style>.modal-header-red {background-color:#f77b6b; padding:0px; height:50px; border-top-left-radius:3px; border-top-right-radius:3px;}\r\n .modal-title {color:#FFF; vertical-align:middle; line-height:50px;}\r\n .modal-header button.close {color:#FFF; vertical-align:middle;}\r\n .modal-body {padding:20px;}</style><form name="deleteForm" ng-submit="clicked=true;vm.confirmDelete(vm.branch.id)"><div class="modal-header modal-header-red"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" style="text-align:left;padding-left:3%">Are you sure?</h4></div><div class="modal-body"><nmb-alert-error></nmb-alert-error><p><textarea class="form-control" rows="6" ng-model="vm.reason" placeholder="Please provide a reason" required></textarea></p><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid||clicked" class="btn btn-danger"><span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/branch/branch-detail.html','<style>.btn-reject {\r\n\tbackground-color: #f34743;\r\n\tborder: 1px solid #f34743;\r\n\tcolor: white;\r\n}\r\n\r\n.btn-approve {\r\n\tbackground-color: #37a36a;\r\n\tborder: 1px solid #37a36a;\r\n\tcolor: white;\r\n}</style><form name="branchViewForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><span data-translate="global.menu.branch.main"></span></h4></div><div class="modal-body"><div class="content"><fieldset><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseBankDetails = !vm.ExpandOrCollapseBankDetails" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseThree"><img ng-src="{{vm.ExpandOrCollapseBankDetails == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="nav-label">Branch Details</span></a></h4></div><div id="collapseThree" class="panel-collapse collapse in" style="background-color: black"><div class="accordion-content1"><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.bank"></span></label><div class="col-md-6 col-md-offset-3"><cspl-ach control-model="vm.branch.bank" control-id="txtbank" control-disabled="true" lookup-name="bank" display-column="bankName" placeholder="" form="branchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.branchName"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.branchName" control-id="txtbranchName" placeholder="" control-disabled="true" form="branchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.ifscCode"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.ifscCode" control-id="txtifscCode" control-disabled="true" placeholder="" form="branchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.primaryContactName"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.primaryContactName" control-id="txtprimaryContactName" placeholder="" control-disabled="true" form="branchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.primaryEmailId"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.primaryEmailId" control-disabled="true" control-id="txtprimaryEmailId" placeholder="" form="branchForm" required></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.branch.primaryMobileNo"></span></label></div><div class="row"><div class="col-lg-1 col-md-offset-3"><cspl-numeric control-model="vm.mobileCountryCode" control-disabled="true" control-id="txtMobileCountryCode" no-of-decimals="0" form="branchForm" required></div><div class="col-md-3"><cspl-text control-model="vm.branch.primaryMobileNo" control-type="Number" control-maxlength="15" control-disabled="true" control-id="txtprimaryMobileNo" placeholder="" form="branchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3"><span data-translate="gatewayApp.branch.BranchCustomerCareNo"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.branchCustomerCareNo" control-id="txtbranchCustomerCareNo" control-disabled="true" placeholder="" form="branchForm"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.address1"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.address1" control-disabled="true" control-id="txtaddress1" placeholder="" form="branchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3"><span data-translate="gatewayApp.branch.address2"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.address2" control-disabled="true" control-id="txtaddress2" placeholder="" form="branchForm"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.city"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.city" control-id="txtcity" control-disabled="true" placeholder="" form="branchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.country"></span></label><div class="col-md-4 col-md-offset-3"><cspl-ach control-model="vm.branch.country" control-disabled="true" control-id="txtCountry" lookup-name="country" display-column="shortName" form="branchForm" required></cspl-ach></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.state"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-3"><cspl-ach control-model="vm.branch.state" control-id="txtstate" lookup-name="state" display-column="shortName" control-disabled="true" filter-value="{{vm.branch.country.id}}~~" form="branchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.postalCode"></span></label><div class="col-md-4 col-md-offset-3"><cspl-text control-model="vm.branch.postalCode" control-disabled="true" control-id="txtpostalCode" control-type="Alphanumeric" control-maxlength="7" placeholder="" form="branchForm" required></div></div></div></div></div><div class="default-users" ng-show="vm.branch.id ==null || (vm.isDefaultUsersRequired1 == true || vm.isDefaultUsersRequired2 == true)" control-required="vm.branch.id ==null" style="display: block; align: center; margin-top: 20px; margin-bottom: 10px"><label class="section-header" style="background: #000000"><span>Default Users</span></label><br><div id="accordion" ng-show="vm.branch.id ==null"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px"><img ng-src="{{vm.ExpandOrCollapseUser1 == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> <input type="checkbox" style="margin-bottom: 5px;margin-left:10px;vertical-align:bottom" id="defaultUser1" ng-hide="vm.branch.id !=null" ng-disabled="true" ng-model="vm.isDefaultUsersRequired1" form="branchForm"> &nbsp;<label style="color:#FFFFFF">User 1</label></h4></div><div id="collapseOne" class="panel-collapse" ng-class="{\'collapse in\': vm.isDefaultUsersRequired1, \'collapse\': !vm.isDefaultUsersRequired1}" style="background-color: black"><div class="accordion-content"><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.firstName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.firstName" control-disabled="true" control-id="txtfirstName" control-maxlength="100" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.middleName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.middleName" control-disabled="true" control-id="txtmiddleName" control-maxlength="100" placeholder="" form="branchForm"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.lastName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.lastName" control-disabled="true" control-id="txtlastName" control-maxlength="100" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div><!-- <div class="row">\r\n\t\t\t\t\t\t\t\t<label class="col-md-4 control-label col-md-offset-1"><span\r\n\t\t\t\t\t\t\t\t\tdata-translate="userManagement.aadharNumber"></span></label>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t<div class="col-md-11 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t\t<cspl-text control-model="vm.user1.aadharNumber"\r\n\t\t\t\t\t\t\t\t\t\tcontrol-id="txtaadharNumber" control-disabled="true"\r\n\t\t\t\t\t\t\t\t\t\tcontrol-minlength="12" control-maxlength="12" placeholder=""\r\n\t\t\t\t\t\t\t\t\t\tform="branchForm" />\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div> --><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><spa n data-translate="userManagement.gender"></spa></label></div><div class="row"><div id="btnGroup" class="col-md-7 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.user1.gender" ng-disabled="true" uib-btn-radio="\'M\'">M</label><label class="btn btn-primary" ng-model="vm.user1.gender" ng-disabled="true" uib-btn-radio="\'F\'">F&nbsp;</label><label class="btn btn-primary" ng-model="vm.user1.gender" ng-disabled="true" uib-btn-radio="\'O\'">O&nbsp;</label></div></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.dob"></span></label></div><div class="row"><div class="col-md-5 col-md-offset-1"><cspl-dtp control-model="vm.user1.dob" control-id="dtpDOB" control-disabled="true" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true" form="branchForm"></cspl-dtp></div></div><div class="row" style="margin-top: 8px"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.login"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.login" control-disabled="true" control-id="txtLogin" control-maxlength="100" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1== true"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.email"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.email" control-type="Email" control-disabled="true" control-id="txtemail" control-maxlength=" 100" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.branch.primaryMobileNo"></span></label></div><div class="row"><div class="col-lg-2 col-md-offset-1"><cspl-numeric control-model="vm.user1.mobileCountryCode" control-disabled="true" control-id="txtMobileCountryCode" no-of-decimals="0" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div><div class="col-md-5"><cspl-text control-model="vm.user1.mobile" control-type="Number" control-id="txtMobile" control-disabled="true" control-maxlength="15" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.address1"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.address1" control-id="txtaddress1" control-maxlength="255" control-disabled="true" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.address2"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.address2" control-disabled="true" control-id="txtaddress2" control-maxlength="255" placeholder="" form="branchForm"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.city"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.city" control-id="txtcity" control-disabled="true" control-maxlength="255" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.country"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user1.country" control-id="txtCountry" lookup-name="country" display-column="shortName" control-disabled="true" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true" form="branchForm"></cspl-ach></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.state"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user1.state" control-id="txtstate" lookup-name="state" display-column="shortName" control-disabled="true" filter-value="{{vm.user1.country.id}}~~" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.pincode"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text control-model="vm.user1.pincode" control-disabled="true" control-id="txtpincode" control-type="Alphanumeric" control-maxlength="7" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div></div></div></div><div id="accordion" ng-show="vm.branch.id ==null"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px"><img ng-src="{{vm.ExpandOrCollapseUser2 == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> <input type="checkbox" style="margin-bottom: 5px;margin-left:10px;vertical-align:bottom" id="defaultUser2" ng-hide="vm.branch.id !=null" ng-disabled="true" ng-model="vm.isDefaultUsersRequired2" form="branchForm"> &nbsp;<label style="color:#FFFFFF">User 2</label></h4></div><div id="collapseTwo" class="panel-collapse" ng-class="{\'collapse in\': vm.isDefaultUsersRequired2, \'collapse\': !vm.isDefaultUsersRequired2}" style="background-color: black"><div class="accordion-content"><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.firstName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.firstName" control-id="txtfirstName2" control-maxlength="100" control-disabled="true" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.middleName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.middleName" control-disabled="true" control-id="txtmiddleName2" control-maxlength="100" placeholder="" form="branchForm"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.lastName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.lastName" control-disabled="true" control-id="txtlastName2" control-maxlength="100" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><!-- <div class="row">\r\n\t\t\t\t\t\t\t\t<label class="col-md-4 control-label col-md-offset-1"><span\r\n\t\t\t\t\t\t\t\t\tdata-translate="userManagement.aadharNumber"></span></label>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t<div class="col-md-11 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t\t<cspl-text control-model="vm.user2.aadharNumber"\r\n\t\t\t\t\t\t\t\t\t\tcontrol-disabled="true" control-id="txtaadharNumber2"\r\n\t\t\t\t\t\t\t\t\t\tcontrol-minlength="12" control-maxlength="12" placeholder=""\r\n\t\t\t\t\t\t\t\t\t\tform="branchForm" />\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div> --><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.gender"></span></label></div><div class="row"><div id="btnGroup" class="col-md-7 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.user2.gender" ng-disabled="true" uib-btn-radio="\'M\'">M</label><label class="btn btn-primary" ng-model="vm.user2.gender" ng-disabled="true" uib-btn-radio="\'F\'">F&nbsp;</label><label class="btn btn-primary" ng-model="vm.user2.gender" ng-disabled="true" uib-btn-radio="\'O\'">O&nbsp;</label></div></div></div><div class="row" style="margin-top: 8px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.dob"></span></label></div><div class="row"><div class="col-md-5 col-md-offset-1"><cspl-dtp control-model="vm.user2.dob" control-id="dtpDOB2" control-disabled="true" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true" form="branchForm"></cspl-dtp></div></div><div class="row" style="margin-top: 8px"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.login"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.login" control-disabled="true" control-id="txtLogin2" control-maxlength="100" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.email"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.email" control-type="Email" control-disabled="true" control-id="txtemail2" control-maxlength=" 100" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.mobile"></span></label></div><div class="row"><div class="col-lg-2 col-md-offset-1"><cspl-numeric control-model="vm.user2.mobileCountryCode" control-disabled="true" control-id="txtMobileCountryCode2" no-of-decimals="0" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div><div class="col-md-5"><cspl-text control-model="vm.user2.mobile" control-disabled="true" control-type="Number" control-id="txtMobile2" control-maxlength="15" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.address1"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.address1" control-disabled="true" control-id="txtaddress12" control-maxlength="255" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.address2"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.address2" control-disabled="true" control-id="txtaddress22" control-maxlength="255" placeholder="" form="branchForm"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.city"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.city" control-id="txtcity2" control-disabled="true" control-maxlength="255" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.country"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user2.country" control-disabled="true" control-id="txtCountry2" lookup-name="country" display-column="shortName" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true" form="branchForm"></cspl-ach></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.state"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user2.state" control-id="txtstate2" lookup-name="state" display-column="shortName" filter-value="{{vm.user2.country.id}}~~" control-disabled="true" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><div class="row" style="margin-top: 8px"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.pincode"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text control-model="vm.user2.pincode" control-disabled="true" control-id="txtpincode2" control-type="Alphanumeric" control-maxlength="7" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div></div></div></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>OK</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardBranch()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showButton" class="btn btn-reject" ng-click="vm.rejectBranch()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.clicked=true;vm.approveBranch();" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/branch/branch-dialog.html','<form name="branchForm" role="form" novalidate><div class="modal-header"><div class="modal-title"><span data-translate="gatewayApp.branch.addbranch" ng-show="vm.branch.id==null"></span><span data-translate="gatewayApp.branch.editbranch" ng-show="vm.branch.id!=null"></span></div></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset ng-disabled="vm.disableForm"><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseBankDetails = !vm.ExpandOrCollapseBankDetails" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseThree"><img ng-src="{{vm.ExpandOrCollapseBankDetails == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="nav-label">Branch Details</span></a></h4></div><div id="collapseThree" class="panel-collapse collapse in" style="background-color: black"><div class="accordion-content1"><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.bank"></span></label><div class="col-md-6 col-md-offset-3"><cspl-ach control-model="vm.branch.bank" control-id="txtbank" control-disabled="true" lookup-name="bank" display-column="bankName" placeholder="" form="branchForm" required></div></div><!-- <div class="row" ng-hide="vm.branch.id!=null">\r\n\t\t\t\t\t\t\t\t<label class="col-md-4 control-label col-md-offset-3"\r\n\t\t\t\t\t\t\t\t\tcspl-mandatory><span\r\n\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.branch.selectBranch"></span></label>\r\n\t\t\t\t\t\t\t\t<div class="col-md-6 col-md-offset-3">\r\n\t\t\t\t\t\t\t\t\t<cspl-ach control-model="vm.homeBranch" load-dynamic-data="true" control-id="txthomeBranch" lookup-name="homeBranch" display-column="ifscCode,branchName,bankName"\r\n\t\t\t\t\t\t\t\t\t\tfilter-value="{{vm.filterText}}" form="branchForm"></cspl-ach>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div> --><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.branchName"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.branchName" control-maxlength="100" control-type="StringWithoutCommaWithScriptValidation" control-id="txtbranchName" placeholder="" form="branchForm" required></div><div class="col-md-1" style="margin-top:5px" ng-show="vm.branch.id==null"><span><img class="icon" ng-src="assets/images/FetchValues.png" ng-click="vm.openSearchBranch()" title="Search Branch"></span></div></div><div class="row"><div id="btnGroup" class="col-md-7 col-md-offset-3"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.ifscOrSwift" ng-disabled="vm.branch.id!=null" uib-btn-radio="\'IFSC\'">IFSC</label><label class="btn btn-primary" ng-model="vm.ifscOrSwift" ng-disabled="vm.branch.id!=null" uib-btn-radio="\'SWIFT\'">SWIFT&nbsp;</label></div></div></div><div class="row" ng-show="vm.ifscOrSwift == \'IFSC\'"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.ifscCode"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.ifscCode" control-disabled="vm.branch.id!=null" control-id="txtifscCode1" control-minlength="11" control-required="vm.ifscOrSwift == \'IFSC\'" control-maxlength="11" placeholder="" control-type="AlphanumericWithCaps" placeholder="" form="branchForm"></div></div><div class="row" ng-show="vm.ifscOrSwift == \'SWIFT\'"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.ifscCode"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.swiftCode" control-id="txtifscCode2" control-type="AlphanumericWithCaps" control-disabled="vm.branch.id!=null" control-maxlength="11" placeholder="" control-required="vm.ifscOrSwift == \'SWIFT\'" form="branchForm"></cspl-text><span class="help-block-error" ng-show="(vm.swiftCode!=null && (vm.swiftCode.length != 11 && vm.swiftCode.length != 8))">Swift Code should be of 8 or 11 characters</span></div></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.primaryContactName"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.primaryContactName" control-maxlength="100" control-type="AlphaWithSpace" control-id="txtprimaryContactName" placeholder="" form="branchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.primaryEmailId"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.primaryEmailId" control-type="Email" control-maxlength=" 100" control-id="txtprimaryEmailId" placeholder="" form="branchForm" required></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.branch.primaryMobileNo"></span></label></div><div class="row"><div class="col-lg-1 col-md-offset-3"><cspl-numeric control-model="vm.mobileCountryCode" control-id="txtMobileCountryCode" no-of-decimals="0" control-tab-index="-1" control-max="999" control-min="1" form="branchForm" required></div><div class="col-md-3"><cspl-text control-model="vm.branch.primaryMobileNo" control-type="Number" control-maxlength="15" control-id="txtprimaryMobileNo" placeholder="" form="branchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3"><span data-translate="gatewayApp.branch.BranchCustomerCareNo"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.branchCustomerCareNo" control-type="Number" control-minlength="2" control-maxlength="20" control-id="txtbranchCustomerCareNo" placeholder="" form="branchForm"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.address1"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.address1" control-maxlength="255" control-id="txtaddress11" placeholder="" form="branchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3"><span data-translate="gatewayApp.branch.address2"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.address2" control-maxlength="255" control-id="txtaddress2" placeholder="" form="branchForm"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.city"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.branch.city" control-id="txtcity" control-maxlength="255" placeholder="" form="branchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.country"></span></label><div class="col-md-4 col-md-offset-3"><cspl-ach control-model="vm.branch.country" control-id="txtCountry" lookup-name="country" display-column="shortName" form="branchForm" required></cspl-ach></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.state"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-3"><cspl-ach control-model="vm.branch.state" control-id="txtstate" lookup-name="state" display-column="shortName" filter-value="{{vm.branch.country.id}}~~" form="branchForm" required></cspl-ach></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.branch.postalCode"></span></label><div class="col-md-4 col-md-offset-3"><cspl-text control-model="vm.branch.postalCode" control-id="txtpostalCode" control-type="Alphanumeric" control-maxlength="7" placeholder="" form="branchForm" required></div></div></div></div><div class="default-users" ng-show="vm.branch.id ==null || (vm.isDefaultUsersRequired1 == true || vm.isDefaultUsersRequired2 == true)" control-required="vm.branch.id ==null" style="display: block; align: center; margin-top: 20px; margin-bottom: 10px"><label class="section-header" style="background: #000000"><span>Default Users</span></label><br><div id="accordion" ng-show="vm.branch.id ==null"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px"><img ng-src="{{vm.ExpandOrCollapseUser1 == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> <input type="checkbox" style="margin-bottom: 5px;margin-left:10px;vertical-align:bottom" id="defaultUser1" ng-hide="vm.branch.id !=null" ng-model="vm.isDefaultUsersRequired1" form="branchForm"> &nbsp;<label style="color:#FFFFFF">User 1</label></h4></div><div id="collapseOne" class="panel-collapse" ng-class="{\'collapse in\': vm.isDefaultUsersRequired1, \'collapse\': !vm.isDefaultUsersRequired1}" style="background-color: black"><div class="accordion-content"><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.firstName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.firstName" control-id="txtfirstName" control-maxlength="100" control-type="AlphaWithSpace" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.middleName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.middleName" control-id="txtmiddleName" control-maxlength="100" control-type="AlphaWithSpace" placeholder="" form="branchForm"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.lastName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.lastName" control-id="txtlastName" control-maxlength="100" placeholder="" form="branchForm" control-type="AlphaWithSpace" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div><!-- <div class="row">\r\n\t\t\t\t\t\t\t<label class="col-md-4 control-label col-md-offset-1"><span\r\n\t\t\t\t\t\t\t\tdata-translate="userManagement.aadharNumber"></span></label>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t<div class="col-md-11 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t<cspl-text control-model="vm.user1.aadharNumber"\r\n\t\t\t\t\t\t\t\t\tcontrol-id="txtaadharNumber" control-minlength="12"\r\n\t\t\t\t\t\t\t\t\tcontrol-type="Number"\r\n\t\t\t\t\t\t\t\t\thelp-text="{{\'userManagement.helpText.aadharNumber\' | translate}}"\r\n\t\t\t\t\t\t\t\t\tcontrol-maxlength="12" placeholder="" form="branchForm" />\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.gender"></span></label></div><div class="row"><div id="btnGroup" class="col-md-7 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.user1.gender" uib-btn-radio="\'M\'">M</label><label class="btn btn-primary" ng-model="vm.user1.gender" uib-btn-radio="\'F\'">F&nbsp;</label><label class="btn btn-primary" ng-model="vm.user1.gender" uib-btn-radio="\'O\'">O&nbsp;</label></div></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.dob"></span></label></div><div class="row"><div class="col-md-5 col-md-offset-1"><cspl-dtp control-model="vm.user1.dob" control-id="dtpDOB" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true" form="branchForm"></cspl-dtp></div></div><div class="row" style="margin-top: 8px"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.login"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.login" control-id="txtLogin" control-maxlength="100" placeholder="" control-type="Small" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.email"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.email" control-type="Email" control-id="txtemail" control-maxlength=" 100" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.mobile"></span></label></div><div class="row"><div class="col-lg-2 col-md-offset-1"><cspl-numeric control-model="vm.user1.mobileCountryCode" control-id="txtMobileCountryCode" no-of-decimals="0" control-tab-index="-1" control-max="999" control-min="1" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div><div class="col-md-5"><cspl-text control-model="vm.user1.mobile" control-type="Number" control-id="txtMobile" control-maxlength="15" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.address1"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.address1" control-id="txtaddress1" control-maxlength="255" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.address2"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.address2" control-id="txtaddress2" control-maxlength="255" placeholder="" form="branchForm"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.city"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user1.city" control-id="txtcity1" control-maxlength="255" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.country"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user1.country" control-id="txtCountry1" lookup-name="country" display-column="shortName" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true" form="branchForm"></cspl-ach></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.state"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user1.state" control-id="txtstate1" lookup-name="state" display-column="shortName" filter-value="{{vm.user1.country.id}}~~" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.pincode"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text control-model="vm.user1.pincode" control-id="txtpincode" control-type="Alphanumeric" control-maxlength="7" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired1 == true"></div></div></div></div></div><div id="accordion" ng-show="vm.branch.id ==null"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px"><img ng-src="{{vm.ExpandOrCollapseUser2 == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> <input type="checkbox" style="margin-bottom: 5px;margin-left:10px;vertical-align:bottom" id="defaultUser2" ng-hide="vm.branch.id !=null" ng-model="vm.isDefaultUsersRequired2" form="branchForm"> &nbsp;<label style="color:#FFFFFF">User 2</label></h4></div><div id="collapseTwo" class="panel-collapse" ng-class="{\'collapse in\': vm.isDefaultUsersRequired2, \'collapse\': !vm.isDefaultUsersRequired2}" style="background-color: black"><div class="accordion-content"><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.firstName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.firstName" control-id="txtfirstName2" control-maxlength="100" control-type="AlphaWithSpace" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.middleName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.middleName" control-id="txtmiddleName2" control-maxlength="100" control-type="AlphaWithSpace" placeholder="" form="branchForm"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.lastName"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.lastName" control-id="txtlastName2" control-maxlength="100" control-type="AlphaWithSpace" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><!-- <div class="row">\r\n\t\t\t\t\t\t\t<label class="col-md-4 control-label col-md-offset-1"><span\r\n\t\t\t\t\t\t\t\tdata-translate="userManagement.aadharNumber"></span></label>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t<div class="col-md-11 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t<cspl-text control-model="vm.user2.aadharNumber"\r\n\t\t\t\t\t\t\t\t\tcontrol-id="txtaadharNumber2" control-minlength="12"\r\n\t\t\t\t\t\t\t\t\tcontrol-type="Number"\r\n\t\t\t\t\t\t\t\t\thelp-text="{{\'userManagement.helpText.aadharNumber\' | translate}}"\r\n\t\t\t\t\t\t\t\t\tcontrol-maxlength="12" placeholder="" form="branchForm" />\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.gender"></span></label></div><div class="row"><div id="btnGroup" class="col-md-7 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.user2.gender" uib-btn-radio="\'M\'">M</label><label class="btn btn-primary" ng-model="vm.user2.gender" uib-btn-radio="\'F\'">F&nbsp;</label><label class="btn btn-primary" ng-model="vm.user2.gender" uib-btn-radio="\'O\'">O&nbsp;</label></div></div></div><div class="row" style="margin-top: 8px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.dob"></span></label></div><div class="row"><div class="col-md-5 col-md-offset-1"><cspl-dtp control-model="vm.user2.dob" control-id="dtpDOB2" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true" form="branchForm"></cspl-dtp></div></div><div class="row" style="margin-top: 8px"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.login"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.login" control-id="txtLogin2" control-maxlength="100" placeholder="" control-type="Small" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.email"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.email" control-type="Email" control-id="txtemail2" control-maxlength=" 100" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.mobile"></span></label></div><div class="row"><div class="col-lg-2 col-md-offset-1"><cspl-numeric control-model="vm.user2.mobileCountryCode" control-id="txtMobileCountryCode2" no-of-decimals="0" control-max="999" control-min="1" form="branchForm" control-tab-index="-1" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div><div class="col-md-5"><cspl-text control-model="vm.user2.mobile" control-type="Number" control-id="txtMobile2" control-maxlength="15" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.address1"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.address1" control-id="txtaddress12" control-maxlength="255" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-1"><span data-translate="userManagement.address2"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.address2" control-id="txtaddress22" control-maxlength="255" placeholder="" form="branchForm"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.city"></span></label></div><div class="row"><div class="col-md-11 col-md-offset-1"><cspl-text control-model="vm.user2.city" control-id="txtcity2" control-maxlength="255" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.country"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user2.country" control-id="txtCountry2" lookup-name="country" display-column="shortName" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true" form="branchForm"></cspl-ach></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.state"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.user2.state" control-id="txtstate2" lookup-name="state" display-column="shortName" filter-value="{{vm.user2.country.id}}~~" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div><div class="row" style="margin-top: 8px"><label class="col-md-3 control-label col-md-offset-1" cspl-mandatory><span data-translate="userManagement.pincode"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text control-model="vm.user2.pincode" control-id="txtpincode2" control-type="Alphanumeric" control-maxlength="7" placeholder="" form="branchForm" control-required="vm.branch.id ==null && vm.isDefaultUsersRequired2 == true"></div></div></div></div></div></div></fieldset></div><div class="modal-footer"><label class="justified-tac-label" style="margin-top: 20px;   margin-left: 8%;  margin-right: 8%;  padding-bottom: 10px"><span data-translate="gatewayApp.branch.branchNote"></span></label><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showButton" class="btn btn-primary" ng-disabled="branchForm.$invalid || vm.clicked" ng-click="vm.clicked = true;vm.resubmitBranch();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="!showButton" class="btn btn-info active" ng-disabled="branchForm.$invalid || vm.clicked || (vm.ifscOrSwift == \'SWIFT\' && (vm.swiftCode.length != 11 && vm.swiftCode.length != 8)) || branchForm.$pristine" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/branch/branch.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" ng-show="vm.permitBranchCreateEntityAction">Manage Branches</h2><h2 class="view-title" ng-show="!vm.permitBranchCreateEntityAction">View Branches</h2><nmb-alert></nmb-alert><div><!-- <nmb-alert-error></nmb-alert-error> --></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row col-md-12" ng-show="vm.entityOwnerType==\'Clearcorp\'"><fieldset><form class="form" name="filterform"><div class="row"><label class="col-md-1 control-label" style="margin-top: 7px" cspl-mandatory><span data-translate="gatewayApp.branch.bankFilter"></span></label><div class="col-md-3"><cspl-ach control-model="vm.bank" control-id="txtBank" lookup-name="bank" display-column="shortName" form="filterform" control-required="vm.entityOwnerType==\'Clearcorp\'"></div><button type="button" class="btn btn-info active" ng-disabled="filterform.$invalid||vm.clicked" ng-click="vm.loadAll(vm.bank);vm.clicked=true;">Go</button></div></form></fieldset></div><div class="row"><div><div class="pull-right"><button type="button" class="btn btn-info active" ng-click="vm.screenLog.screenLog(vm.screenName,0,vm.entityConstants.ENTITY_ACTION_TYPE.ADD);vm.launch()" ng-show="vm.permitBranchCreateEntityAction"><img ng-src="assets/images/Add.png"> <span data-translate="global.menu.branch.mainBranch"></span></button><div class="col-md-6 pull-right" ng-show="vm.branch.length > 0"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="tblbranch" total-record-count="vm.branch.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Manage_Branches"></cspl-table-export></div><div class="pull-left" ng-show="vm.permitBranchImportEntityAction" style="margin-left: 0px"><cspl-table-import upload-type="BranchImport" file-content=""></cspl-table-import></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden" ng-show="vm.branch.length > 0"><table id="tblbranch" class="datatables-nosort table table-striped table-hover"><thead><tr><th style="min-width: 30px" data-translate="gatewayApp.branch.entityRestrictionStatus"></th><th data-translate="gatewayApp.branch.branchId"></th><th data-translate="gatewayApp.branch.bank"></th><th data-translate="gatewayApp.branch.branchName"></th><th style="min-width: 100px" data-translate="gatewayApp.branch.ifscCode"></th><th style="min-width: 100px" data-translate="gatewayApp.branch.primaryContactName"></th><th style="min-width:100px" data-translate="gatewayApp.branch.primaryEmailId"></th><th style="min-width: 100px" data-translate="gatewayApp.branch.primaryMobileNo"></th><th style="min-width: 100px" data-translate="gatewayApp.branch.BranchCustomerCareNo"></th><th style="word-break:break-word" width="50px" data-translate="gatewayApp.branch.defaultUser1"></th><th style="word-break:break-word" width="50px" data-translate="gatewayApp.branch.defaultUser2"></th><th></th></tr></thead><tbody><tr ng-repeat="branch in filterData = (vm.branch | filter : filterText | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><!-- Column values --><td>{{branch.entityRestrictionStatus.shortName}}</td><td>{{branch.branchId}}</td><td style="word-break:break-word">{{branch.bank.bankName}}</td><td style="word-break:break-word">{{branch.branchName}}</td><td>{{branch.ifscCode}}</td><td style="word-break:break-word">{{branch.primaryContactName}}</td><td style="word-break:break-word">{{branch.primaryEmailId}}</td><td>{{branch.primaryMobileNo}}</td><td style="min-width: 80px">{{branch.branchCustomerCareNo||\'-\'}}</td><td><span ng-if="branch.defaultUserList!=null && branch.defaultUserList.length>0"><a ui-sref="branch-registration-user-view({id: branch.defaultUserList[0].id})" ng-click="vm.screenLog.screenLog(vm.entityConstants.ENTITY_SHORT_NAME.USER_MANAGEMENT,branch.defaultUserList[0].id,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span>{{branch.defaultUserList[0].login}}</span> </a></span><span ng-if="branch.defaultUserList ==null">-</span></td><td><span ng-if="branch.defaultUserList!=null && branch.defaultUserList.length>1"><a ui-sref="branch-registration-user-view({id: branch.defaultUserList[1].id})" ng-click="vm.screenLog.screenLog(vm.entityConstants.ENTITY_SHORT_NAME.USER_MANAGEMENT,branch.defaultUserList[1].id,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span>{{branch.defaultUserList[1].login}}</span> </a></span><span ng-if="branch.defaultUserList ==null">-</span></td><td style="text-align: center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitBranchViewEntityAction"><a ui-sref="branch.view({id: branch.id})" ng-click="vm.screenLog.screenLog(vm.screenName,branch.id,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitBranchEditEntityAction"><a ui-sref="branch.edit({id: branch.id})" ng-click="vm.screenLog.screenLog(vm.screenName,branch.id,vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="vm.branch.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div><div class="table-responsive" ng-show="vm.branch.length==0"><span>No record found</span></div></div></div></section></div></div><script src="assets/js/tables.js"></script>');
$templateCache.put('app/entities/cancelled-orders-report/cancelled-orders-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.cancelledordersreport.title" data-translate-values="{value: {{vm.todayDate}}}">Cancelled Orders Report</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px;  margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapsecanCelledOrdersReport = !vm.ExpandOrCollapsecanCelledOrdersReport" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#CancelledOrdersReport"><img ng-src="{{vm.ExpandOrCollapsecanCelledOrdersReport == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.cancelledordersreport.criteria">Criteria</span></a></h4></div><div id="CancelledOrdersReport" class="collapse in" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="cancelledOrdersReportform"><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><div class="form-group"><label class="control-label" class="form-group"><span data-translate="gatewayApp.cancelledordersreport.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bank" display-column="bankName" placeholder="" form="cancelledOrdersReportform"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.cancelledordersreport.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="activeBranchesForBank" display-column="branchName" placeholder="" form="cancelledOrdersReportform" filter-value="{{vm.bank.id}}"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.cancelledordersreport.customer"></span></label><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="allTypeCustomers" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" control-place-holder="Enter Customer ID or Name" display-column="customerCode,customerName" placeholder="" form="cancelledOrdersReportform"></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\'"><label class="control-label"><span data-translate="gatewayApp.cancelledordersreport.currencyPair"></span></label><cspl-ach control-model="vm.currencyPair" control-id="txtCurrencyPair" lookup-name="currencyPair" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}" control-place-holder="Enter Currency Pair" display-column="code" placeholder="" form="cancelledOrdersReportform"></div></div><div class="form-group"><div class="row"><label class="col-md-offset-3 control-label col-xs-6 col-md-6"><span data-translate="gatewayApp.cancelledordersreport.instrument"></span></label><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><select name="select" class="form-control select-style non-mandatory" ng-model="vm.instrument" style="border-color:#595959" ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id"><option value="">--All--</option></select></div><div class="col-md-1 col-sm-1"><button class="btn btn-info active" ng-disabled="cancelledOrdersReportform.$invalid||vm.clicked" ng-click="vm.getCancelledOrdersReport();vm.clicked=true;" data-toggle="collapse" data-target="#CancelledOrdersReport" data-translate="gatewayApp.cancelledordersreport.go"></button></div></div></div></form></div></div></div><div ng-show="vm.cancelledOrdersReport.length > 0"><div class="row"><cspl-table-export class="col-md-1 col-sm-1 col-xs-1" table-name="cancelledOrdersReport" total-record-count="filterData.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="Cancelled_Orders_Report"></cspl-table-export><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="cancelledOrdersReport" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.cancelledordersreport.bank"></th><th data-translate="gatewayApp.cancelledordersreport.branch"></th><th data-translate="gatewayApp.cancelledordersreport.branchId"></th><th data-translate="gatewayApp.cancelledordersreport.custId"></th><th data-translate="gatewayApp.cancelledordersreport.customer"></th><th data-translate="gatewayApp.cancelledordersreport.currencyPair"></th><th data-translate="gatewayApp.cancelledordersreport.instrument"></th><th data-translate="gatewayApp.cancelledordersreport.orderType"></th><th data-translate="gatewayApp.cancelledordersreport.buySell"></th><th data-translate="gatewayApp.cancelledordersreport.settlementStartDate"></th><th data-translate="gatewayApp.cancelledordersreport.settlementDate"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.cancelledordersreport.orderQuantity"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.cancelledordersreport.tradedQuantity"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.cancelledordersreport.pendingOrderQuantity"></th><th data-translate="gatewayApp.cancelledordersreport.priceCondition"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.cancelledordersreport.orderPrice"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.cancelledordersreport.equivalentSpotPrice"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.cancelledordersreport.swapPtsInPaise"></th><th data-translate="gatewayApp.cancelledordersreport.timeCondition"></th><th data-translate="gatewayApp.cancelledordersreport.orderDateTime"></th><th data-translate="gatewayApp.cancelledordersreport.orderNumber"></th><th data-translate="gatewayApp.cancelledordersreport.tradeNumber"></th><th data-translate="gatewayApp.cancelledordersreport.sourceTradeNo"></th><th data-translate="gatewayApp.cancelledordersreport.exposureType"></th><th data-translate="gatewayApp.cancelledordersreport.exposureSubType"></th><th style="min-width:360px" data-translate="gatewayApp.cancelledordersreport.userRemarks1"></th><th style="min-width:360px" data-translate="gatewayApp.cancelledordersreport.userRemarks2"></th><th style="min-width:360px" data-translate="gatewayApp.cancelledordersreport.userRemarks3"></th><th style="min-width:360px" data-translate="gatewayApp.cancelledordersreport.userRemarks4"></th><th data-translate="gatewayApp.cancelledordersreport.orderStatus"></th><th data-translate="gatewayApp.cancelledordersreport.gttTime"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.cancelledordersreport.triggerPrice"></th><th data-translate="gatewayApp.cancelledordersreport.lastActionedBy"></th><th data-translate="gatewayApp.cancelledordersreport.placedAsSplitOrder"></th><th data-translate="gatewayApp.cancelledordersreport.deliveryMode"></th><th data-translate="gatewayApp.cancelledordersreport.source"></th></tr></thead><tbody><tr ng-repeat="cancelledOrder in filterData = (vm.cancelledOrdersReport | filter : filterText | orderBy: \'-orderSequenceNumber\')| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{cancelledOrder.bank.bankName}}</td><td>{{cancelledOrder.branch.branchName}}</td><td>{{cancelledOrder.branch.branchId}}</td><td>{{cancelledOrder.customer.customerCode}}</td><td ng-if="cancelledOrder.customer.customerMiddleName!=null && cancelledOrder.customer.customerMiddleName!=\'\' && cancelledOrder.customer.customerMiddleName!=undefined">{{cancelledOrder.customer.customerFirstName + \' \' + cancelledOrder.customer.customerMiddleName + \' \' + cancelledOrder.customer.customerLastName}}</td><td ng-if="cancelledOrder.customer.customerMiddleName==null || cancelledOrder.customer.customerMiddleName==\'\' || cancelledOrder.customer.customerMiddleName==undefined">{{cancelledOrder.customer.customerFirstName + \' \' + cancelledOrder.customer.customerLastName}}</td><td>{{cancelledOrder.currencyPair.code}}</td><td>{{cancelledOrder.instrument.instrumentCode}}</td><td>{{cancelledOrder.eventType.name}}</td><td>{{cancelledOrder.buySellFlag}}</td><td><span ng-if="cancelledOrder.tradeSettlementDateFrom !=null">{{cancelledOrder.tradeSettlementDateFrom| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="cancelledOrder.tradeSettlementDateFrom ==null">{{\'\'}}</span></td><td><span ng-if="cancelledOrder.tradeSettlementDate!=null && cancelledOrder.tradeSettlementDate!=undefined">{{cancelledOrder.tradeSettlementDate | date:\'dd-MMM-yyyy\'}}</span><span ng-if="cancelledOrder.tradeSettlementDate==null || cancelledOrder.tradeSettlementDate==undefined">-</span></td><td class="td-text-align-right noPaddingLeftRight">{{(cancelledOrder.pendingOrderAmount + cancelledOrder.tradeAmount) | currency:"" : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right" style="padding-right:10px">{{cancelledOrder.tradeAmount| currency:"" : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right" style="padding-right:10px">{{cancelledOrder.pendingOrderAmount| currency:"" : vm.noOfDecimalsForAmount}}</td><td>{{cancelledOrder.priceCondition.name}}</td><td class="td-text-align-right" style="padding-right:10px">{{cancelledOrder.limitExchangeRate| currency:"" : vm.noOfDecimalsForRate}}</td><td class="td-text-align-right noPaddingLeftRight">{{cancelledOrder.retailEquivalentSpotLimitExchangeRate| currency:"" : vm.noOfDecimalsForRate}}</td><td class="td-text-align-right" style="padding-right:10px">{{vm.getSwapPoints(cancelledOrder.retailEquivalentSpotLimitExchangeRate, cancelledOrder.limitExchangeRate) | currency:"" : vm.noOfDecimalsForAmount}}</td><td align="center">{{cancelledOrder.timeCondition}}</td><td nowrap="nowrap" ng-show="cancelledOrder.cancelledOrder.name==\'Risk Validated\'">{{cancelledOrder.lastModifiedDate | date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td nowrap="nowrap" ng-show="cancelledOrder.cancelledOrder.name!=\'Risk Validated\'">{{cancelledOrder.revisionTimeStamp | date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td><a ui-sref="cancelled-order-activity({orderNumber:cancelledOrder.orderSequenceNumber})" style="text-decoration:underline">{{cancelledOrder.orderSequenceNumber}}</a></td><td>{{cancelledOrder.lastTradeSequenceNumber||\'-\'}}</td><td ng-if="cancelledOrder.sourceTradeNumber != null && cancelledOrder.sourceTradeNumber != 0"><a ui-sref="cancelled-order-activity({orderNumber:cancelledOrder.sourceorderNumber})" style="text-decoration:underline">{{cancelledOrder.sourceTradeNumber}}</a></td><td ng-if="!(cancelledOrder.sourceTradeNumber != null && cancelledOrder.sourceTradeNumber != 0)">{{\' \'}}</td><td>{{cancelledOrder.exposureType.name || \'-\'}}</td><td>{{cancelledOrder.exposureSubType.name || \'-\'}}</td><td style="min-width:360px">{{cancelledOrder.userRemarks || \'-\'}}</td><td style="min-width:360px">{{cancelledOrder.remarks2 || \'-\'}}</td><td style="min-width:360px">{{cancelledOrder.remarks3 || \'-\'}}</td><td style="min-width:360px">{{cancelledOrder.remarks4 || \'-\'}}</td><td align="center">{{cancelledOrder.orderStatus.name}}</td><td ng-class="{ \'td-text-align-center\': cancelledOrder.expiryTime==null}">{{(cancelledOrder.expiryTime | date:\'HH:mm\')||\'-\'}}</td><td ng-class="{ \'td-text-align-center\': cancelledOrder.stopExchangeRate==null,\'td-text-align-right noPaddingLeftRight\' : cancelledOrder.stopExchangeRate!=null}">{{(cancelledOrder.stopExchangeRate| currency:"" : vm.noOfDecimalsForRate)||\'-\'}}</td><td>{{cancelledOrder.user.login}}</td><td nowrap="nowrap" ng-show="cancelledOrder.isSplitOrder==true">Yes</td><td nowrap="nowrap" ng-show="cancelledOrder.isSplitOrder==false">No</td><td style="min-width:360px">{{cancelledOrder.deliveryMode || \'-\'}}</td><td style="min-width:360px">{{cancelledOrder.sourceApp.name || \'-\'}}</td></tr></tbody></table></div><div class="row"><span class="cancelledOrderReport" data-translate="gatewayApp.cancelledordersreport.legend"></span></div><div class="row"><span class="cancelledOrderReport" data-translate="gatewayApp.cancelledordersreport.originalTradeLegend"></span></div><div ng-show="vm.cancelledOrdersReport.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div><div class="table-responsive" ng-show="vm.cancelledOrdersReport.length==0"><span>No record found</span></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/change-config/change-config.html','<form name="changeconfigForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="{{vm.headerLabel}}"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="row"><div class="col-md-8 col-md-offset-3" ng-show="vm.configName!=\'CCILWebsite\' && vm.configName!=\'RBICMS\'&& vm.configName!=\'RBICircular\' && vm.configName!=\'TimePeriodToBlockUserLoginInMinutes\' && vm.configName!=\'GrievancePortal\'"><label class="control-label" cspl-mandatory><span data-translate="{{vm.labelName}}"></span>&nbsp;<span ng-show="vm.currencyCode != null & vm.currencyCode != undefined" data-translate="{{vm.currencyCode}}"></span></label></div><div class="col-md-6 col-md-offset-1" ng-show="vm.configName==\'CCILWebsite\' || vm.configName==\'RBICMS\'|| vm.configName==\'RBICircular\' || vm.configName==\'GrievancePortal\'"><label class="control-label" cspl-mandatory><span data-translate="{{vm.labelName}}"></span></label></div><div class="col-md-8 col-md-offset-3" ng-show="vm.configName==\'TimePeriodToBlockUserLoginInMinutes\'"><label class="control-label" style="margin-bottom:0px" cspl-mandatory><span data-translate="{{vm.labelName}}"></span></label><span class="help-block help-block-left" data-translate="gatewayApp.applicationWideSettings.timePeriodToBlockUserHelpText"></span></div></div><div class="row"><div class="row" ng-if="vm.controlType == \'numeric\' && vm.configName==\'NoOfActiveMonthsForStandardTenor\'"><div class="col-md-4 col-md-offset-3"><cspl-numeric control-model="vm.configSettings.value" control-id="txtControl" no-of-decimals="{{}}" form="changeconfigForm" control-disabled="vm.isDisabled" currency-code="" control-invalid="vm.monthsCountError == true" control-value-change="vm.onValueChange(vm.configSettings.value)" required></div></div><span ng-show="vm.monthsCountError == true" class="help-block-error col-md-4 col-md-offset-3" style="text-align: left" data-translate="gatewayApp.applicationWideSettings.InvalidMonthCount"></span><div class="row" ng-if="vm.controlType == \'numeric\' && vm.configName==\'PreCASHSessionCloseIntimation\'"><div class="col-md-4 col-md-offset-3"><cspl-numeric control-model="vm.configSettings.value" control-id="txtControl" control-max="60" control-min="1" no-of-decimals="{{}}" form="changeconfigForm" control-disabled="vm.isDisabled" currency-code="" required></div><span class="label-profile col-md-1" ng-show="vm.isShowMins" style="display: block; margin-top: 6px">mins</span></div><div class="row" ng-if="vm.controlType == \'numeric\' && (vm.configName==\'DefaultLimitPeriodForFORWARDAndALLInDays\' || vm.configName==\'DefaultLimitPeriodForSPOTWindowInDays\')"><div class="col-md-4 col-md-offset-3"><cspl-numeric control-model="vm.configSettings.value" control-id="txtControl" control-invalid="vm.numericValueError == true" control-value-change="vm.minMaxAlertOnValueChange(vm.configSettings.value,1,3000,\'gatewayApp.applicationWideSettings.invalidNumericErrorForStandardTenor\')" no-of-decimals="{{}}" form="changeconfigForm" control-disabled="vm.isDisabled" currency-code="" required></div></div><span ng-show="vm.numericValueError == true" class="help-block-error col-md-4 col-md-offset-3" style="text-align: left">{{vm.errorText}}</span><div class="row" ng-if="vm.controlType == \'numeric\' && vm.configName!=\'PreCASHSessionCloseIntimation\' && vm.configName!=\'NoOfActiveMonthsForStandardTenor\' && vm.configName!=\'DefaultLimitPeriodForFORWARDAndALLInDays\' \r\n\t\t\t\t&& vm.configName!=\'DefaultLimitPeriodForSPOTWindowInDays\'"><div class="col-md-4 col-md-offset-3"><cspl-numeric control-model="vm.configSettings.value" control-id="txtControl" control-max="999999999" control-min="0" no-of-decimals="{{}}" form="changeconfigForm" control-disabled="vm.isDisabled" currency-code="" required></div><span class="label-profile col-md-1" ng-show="vm.isShowDays" style="display: block; margin-top: 6px">days </span><span class="label-profile col-md-1" ng-show="vm.isShowHours" style="display: block; margin-top: 6px">hours</span> <span class="label-profile col-md-1" ng-show="vm.isShowSeconds" style="display: block; margin-top: 6px">secs.</span> <span class="label-profile col-md-1" ng-show="vm.isShowMins" style="display: block; margin-top: 6px">mins.</span> <span class="label-profile col-md-1" ng-show="vm.isShowUSD" style="display: block; margin-top: 6px"></span> <span class="label-profile col-md-1" ng-show="vm.isShowPaise" style="display: block; margin-top: 6px">paise</span></div><div class="row" ng-if="vm.controlType == \'numericwithdecimals\'"><div class="col-md-5 col-md-offset-3" ng-show="vm.configName != \'MinimumOrderValue\' && vm.configName != \'MaximumOrderValueHardCheck\' && vm.configName != \'MaximumOrderValueSoftCheck\'"><cspl-numeric control-model="vm.configSettings.value" control-id="txtControl" control-min="0" control-max="999999999.99" no-of-decimals="{{vm.noOfDecimals}}" form="changeconfigForm" control-disabled="vm.isDisabled" currency-code="" required></div><div class="col-md-4 col-md-offset-3" ng-show="vm.configName == \'MinimumOrderValue\' || vm.configName == \'MaximumOrderValueHardCheck\' || vm.configName == \'MaximumOrderValueSoftCheck\'"><cspl-numeric control-model="vm.configSettings.value" control-id="txtControl" control-min="0" control-max="999999999.99" no-of-decimals="{{vm.noOfDecimals}}" form="changeconfigForm" control-disabled="vm.isDisabled" currency-code="" required></div><span class="label-profile col-md-1" ng-show="vm.isShowDays" style="display: block; margin-top: 6px">days </span><span class="label-profile col-md-1" ng-show="vm.isShowHours" style="display: block; margin-top: 6px">hours</span> <span class="label-profile col-md-1" ng-show="vm.isShowSeconds" style="display: block; margin-top: 6px">secs </span><span class="label-profile col-md-1" ng-show="vm.isShowMins" style="display: block; margin-top: 6px">mins </span><span class="label-profile col-md-1" ng-show="vm.isShowUSD" style="display: block; margin-top: 6px"></span> <span class="label-profile col-md-1" ng-show="vm.isShowPaise" style="display: block; margin-top: 6px">paise </span><span class="label-profile col-md-1" ng-show="vm.isShowPercentage" style="display: block; margin-top: 6px">%</span></div><div class="row" ng-if="vm.controlType == \'percentage\'"><div class="col-md-3 col-md-offset-3"><cspl-numeric control-model="vm.configSettings.value" control-id="txtControl" no-of-decimals="{{vm.noOfDecimals}}" form="changeconfigForm" control-min="0" control-max="100" control-disabled="vm.isDisabled" currency-code="" required></div><span class="label-profile col-md-1" style="display: block; margin-top: 6px">%</span></div><div class="row" ng-if="vm.controlType == \'text\' && (vm.configName != \'CCILWebsite\' && vm.configName != \'RBICMS\' && vm.configName != \'RBICircular\' && vm.configName!=\'GrievancePortal\')"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.configValue" control-disabled="vm.isDisabled" control-id="txtControl" form="changeconfigForm" required></div></div><div class="row" ng-if="vm.controlType == \'text\' && (vm.configName == \'CCILWebsite\' || vm.configName == \'RBICMS\' || vm.configName == \'RBICircular\' || vm.configName==\'GrievancePortal\')"><div class="col-md-11-5 col-md-offset-1"><cspl-text control-model="vm.configValue" control-disabled="vm.isDisabled" control-id="txtControl" form="changeconfigForm" required></div></div><!-- \t<div class="row" ng-show="vm.controlType == \'amcdate\'">\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3">\r\n\r\n\t\t\t\t\t\t<input type="text" ng-model="vm.configValue" class="form-control" ng-required="vm.controlType == \'amcdate\'"\r\n\t\t\t\t\t\t\tng-disabled="vm.isDisabled" name="test" control-id="txtControl" />\r\n\r\n\t\t\t\t\t\t<p class="help-block" ng-show="vm.configValue==null || vm.configValue==undefined"\r\n\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.invalidDatePattern"></p>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div> --><div class="row" ng-if="vm.controlType == \'amcdate\'"><div class="col-md-6 col-md-offset-3"><cspl-day-month control-model="vm.configValue" control-id="txtControl" control-disabled="vm.isDisabled" control-max-mode="\'day\'" form="changeconfigForm" control-required="vm.controlType==\'amcdate\'"><p class="help-block" ng-show="vm.configValue==null || vm.configValue==undefined" data-translate="gatewayApp.applicationWideSettings.invalidDatePattern"></p></div></div><div class="row" ng-if="vm.controlType == \'email\'"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.configValue" control-disabled="vm.isDisabled" control-id="txtControl" control-type="Email" placeholder="" form="changeconfigForm" required></div><span class="label-profile col-md-1" ng-show="vm.isShowDays" style="display: block; margin-top: 5px">days</span></div><div class="row" ng-if="vm.controlType == \'yesorno\'"><div id="btnGroup" class="col-md-4 col-md-offset-3"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.configValue" ng-disabled="vm.isDisabled" uib-btn-radio="\'Yes\'">Yes</label><label class="btn btn-primary" ng-model="vm.configValue" ng-disabled="vm.isDisabled" uib-btn-radio="\'No\'">No&nbsp;</label></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="isShowResubmit" class="btn btn-primary" ng-disabled="changeconfigForm.$invalid || vm.clicked || vm.monthsCountError == true || vm.numericValueError == true" ng-click="vm.clicked=true;vm.resubmitConfigSettings();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" class="btn btn-info active" ng-if="isShowSaveButton" ng-disabled="changeconfigForm.$invalid || changeconfigForm.$pristine||vm.clicked || vm.monthsCountError == true || vm.numericValueError == true" ng-click="vm.clicked=true;vm.saveConfig();"><span data-translate="gatewayApp.applicationWideSettings.submit"></span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardConfigSettings()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-show="showButton" class="btn btn-reject" ng-click="vm.rejectConfigSettings()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.clicked=true;vm.approveConfigSettings();" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></div><script type="text/javascript">$(\'.clockpicker\').clockpicker({\r\n\t\t\tafterDone : function() {\r\n\t\t\t\tclockpicker.val(round());\r\n\t\t\t}\r\n\t\t}).find(\'input\');</script></form>');
$templateCache.put('app/entities/change-mobile/change-mobile.html','<div><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="gatewayApp.userProfile.changeMobile"></span></h4></div><div class="modal-body"><div class="content" ng-if="!vm.showChangeMobile"><form name="loginPasswordForm" role="form" novalidate><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="row"><!-- <span><input type="text"   style = "width:20px;"maxlength="1" />\r\n\t\t\t\t<input type="text"   style = "width:20px;backcolor:black;textcolor:black;"maxlength="1" />\r\n\t\t\t\t<input type="text"  style = "width:20px;"maxlength="1" />\r\n\t\t\t\t<input type="text" style = "width:20px;"maxlength="1" />\r\n\t\t\t\t<input type="text"  style = "width:20px;"maxlength="1" />\r\n\t\t\t\t<input type="text"  style = "width:20px;"maxlength="1" /></span> --><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.loginPassword"></span></label></div><div class="row"><div class="form-group password"><label class="sr-only" for="login-password">Password</label><div class="col-md-6 col-md-offset-3"><input id="login-password" name="password" type="password" ng-model="vm.password" class="form-control login-password" autocomplete="off" required autofocus> <span class="help-block" data-translate="gatewayApp.userProfile.loginPasswordHelpText"></span></div></div></div><!-- <div class="row">\r\n\t\t\t\t<label class="col-sm-12 help-block" style="text-align: center;"><span\r\n\t\t\t\t\tdata-translate="gatewayApp.userProfile.loginPasswordHelpText"></span></label>\r\n\t\t\t</div> --><div class="modal-footer"><!-- <button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()">\r\n\t\t\t\t\t<span data-translate="entity.action.cancel">Cancel</span>\r\n\t\t\t\t</button> --> <button type="submit" ng-hide="showButton" class="btn btn-info active" ng-disabled="vm.password == null  || clicked" ng-click="vm.checkPassword();"><span data-translate="gatewayApp.userProfile.verify"></span></button></div></form></div><div class="content1" ng-if="vm.showChangeMobile"><form name="changemobileForm" role="form" novalidate><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.currentMobile"></span></label></div><div class="row"><div class="col-lg-2 col-md-offset-3"><cspl-numeric control-model="vm.currentMobileCountryCode" control-disabled="true" control-id="txtCurrentMobileCountryCode" no-of-decimals="0" control-required="vm.showChangeMobile" form="changemobileForm"></div><div class="col-md-6"><cspl-text control-model="vm.currentMobile" control-type="Number" control-maxlength="15" control-id="txtcurrentMobileNo" placeholder="" control-required="vm.showChangeMobile" control-disabled="true" form="changemobileForm"></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.newMobile"></span></label></div><div class="row"><div class="col-lg-2 col-md-offset-3"><cspl-numeric control-model="vm.userProfile.newMobileCountryCode" control-max="999" control-min="1" control-disabled="false" control-tab-index="-1" control-id="txtnewMobileCountryCode" no-of-decimals="0" control-required="vm.showChangeMobile" form="changemobileForm"></div><div class="col-md-6"><cspl-text control-model="vm.userProfile.newMobile" control-type="Number" control-maxlength="15" control-input-type="password" control-required="vm.showChangeMobile" control-id="txtnewMobileNo" placeholder="" form="changemobileForm" autofocus></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.confirmMobile"></span></label></div><div class="row"><div class="col-lg-2 col-md-offset-3"><cspl-numeric control-model="vm.userProfile.confirmMobileCountryCode" control-max="999" control-min="1" control-disabled="false" control-tab-index="-1" control-id="txtConfirmMobileCountryCode" no-of-decimals="0" control-required="vm.showChangeMobile" form="changemobileForm"></div><div class="col-md-6"><cspl-text control-model="vm.userProfile.confirmMobile" control-type="Number" control-maxlength="15" control-id="txtconfirmMobileNo" placeholder="" control-required="vm.showChangeMobile" form="changemobileForm"></cspl-text><span class="help-block-error" ng-show="vm.userProfile.confirmMobile!=null && vm.userProfile.confirmMobile!=vm.userProfile.newMobile">The Mobile and its confirmation should be the same.</span></div><div class="modal-footer"><button type="submit" ng-if="vm.mode == \'user\'" class="btn btn-info active" ng-disabled="changemobileForm.$invalid || (vm.userProfile.confirmMobile!=vm.userProfile.newMobile)" ng-click="vm.changeMobile()"><span data-translate="gatewayApp.userProfile.update"></span></button> <button type="submit" ng-if="vm.mode != \'user\' && !vm.isOTPSend " class="btn btn-info active" ng-disabled="changemobileForm.$invalid || (vm.userProfile.confirmMobile!=vm.userProfile.newMobile) || vm.disableGenerateOTP" ng-click="vm.sendOTP()"><span data-translate="entity.action.gnerateOTP"></span></button></div></div><div class="row" ng-if="vm.isOTPSend"><div class="col-md-6 col-md-offset-3" id="otp" control-model="vm.otp" otp-input-directive options="otpInput"></div><div class="row" ng-show="vm.isOTPSend"><label class="help-block col-md-10 col-md-offset-2"><a style="margin-right:12%" href="" ng-click="vm.resendPrimaryOTP()">Resend</a></label></div><!-- <div class="col-md-1" style="margin-top:5px; " ng-show="vm.isOTPSend"><span class="icon icon_refresh" title="Resend OTP" ng-click="vm.resendPrimaryOTP()"></span></div> --></div><div class="row"><div class="col-md-9 col-md-offset-3"><label class="help-text" ng-if="vm.isOTPSend" data-translate="gatewayApp.userProfile.otpHelpText"></label></div></div><div class="modal-footer" ng-if="vm.isOTPSend"><!-- <button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()">\r\n\t\t\t\t\t<span data-translate="entity.action.cancel">Cancel</span>\r\n\t\t\t\t</button> --> <button type="submit" class="btn btn-info active" ng-disabled="vm.otpClicked" ng-click="vm.changeUserMobile();"><span data-translate="gatewayApp.userProfile.verify"></span></button></div></form></div></div></div>');
$templateCache.put('app/entities/change-email/change-email.html','<div><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="gatewayApp.userProfile.changeEmail"></span></h4></div><div class="modal-body"><div class="content" ng-show="!vm.showChangeEmail"><form name="loginPasswordForm" role="form" novalidate><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.loginPassword"></span></label></div><div class="row"><div class="form-group password"><label class="sr-only" for="login-password">Password</label><div class="col-md-6 col-md-offset-3"><input id="login-password" name="password" type="password" ng-model="vm.password" class="form-control login-password" autocomplete="off" required> <span class="help-block" data-translate="gatewayApp.userProfile.loginPasswordHelpText"></span></div></div></div><!-- <div class="row">\r\n\t\t\t\t<label class="col-sm-6 col-md-offset-3 help-block" cspl-mandatory><span\r\n\t\t\t\t\tdata-translate="gatewayApp.userProfile.loginPasswordHelpText"></span></label>\r\n\t\t\t</div> --><div class="modal-footer"><!-- <button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()">\r\n\t\t\t\t\t<span data-translate="entity.action.cancel">Cancel</span>\r\n\t\t\t\t</button> --> <button type="submit" ng-hide="showButton" class="btn btn-info active" ng-disabled="vm.password == null " ng-click="vm.checkPassword();clicked = true;"><span data-translate="gatewayApp.userProfile.verify"></span></button></div></form></div><div class="content1" ng-show="vm.showChangeEmail"><form name="changeemailForm" role="form" novalidate><div><nmb-alert-error></nmb-alert-error></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.userProfile.currentEmail"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.currentEmail" control-id="txtCurrentEmail" control-type="Email" placeholder="" control-disabled="true" form="changeemailForm"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.userProfile.newEmail"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.userProfile.newEmail" control-id="txtNewEmail" control-input-type="password" control-type="Email" placeholder="" form="changeemailForm" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.userProfile.confirmEmail"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.userProfile.confirmEmail" control-id="txtConfirmEmail" control-type="Email" placeholder="" form="changeemailForm" required></cspl-text><span class="help-block-error" ng-show="vm.userProfile.confirmEmail!=null && vm.userProfile.confirmEmail!=vm.userProfile.newEmail">The Email and its confirmation should be the same.</span></div></div><div class="row" ng-if="vm.showGenerateOTPEmailButton"><div class="col-md-7 col-md-offset-3"><button type="button" ng-if="vm.showGenerateOTPEmailButton" class="btn btn-info lighttheme" ng-disabled="vm.disableGenerateOTPEmail || (vm.userProfile.newEmail!=vm.userProfile.confirmEmail)" ng-click="vm.generateOTPEmail()"><span data-translate="entity.action.gnerateOTP"></span></button><br></div></div><div class="row" ng-if="vm.showGenerateOTPEmailButton && !vm.disableGenerateOTPEmail"><span class="col-md-7 col-md-offset-3 help-block-error" data-translate="gatewayApp.userProfile.verifyEmailText" style="text-align: left"></span></div><div class="row" style="margin-top:10px" ng-show="vm.visibleOTPEmail"><div class="col-md-5 col-md-offset-3" id="txtotpemail" control-model="vm.emailOtp" otp-input-directive options="otpEmailInput" size="{{vm.otpLength}}" control-disabled="(vm.isEmailVerified && vm.checkEmailOTP)"></div><div class="col-md-1" ng-show="vm.isEmailVerified && vm.checkEmailOTP"><span class="icon"><img src="assets/images/checkmark_dark.gif"></span></div><div class="col-md-1" ng-show="vm.invalidEmailOtp && vm.checkEmailOTP" style="padding-top: 8px"><span class="icon icon_close" style="color:red;font-size:large"></span></div></div><div class="row" ng-show="vm.visibleOTPEmail && !(vm.isEmailVerified && vm.checkEmailOTP)"><label class="col-md-5 col-md-offset-3" style="font-size:12px; text-align:right; margin-top:5px"><a href="" ng-click="vm.resendOTPEmail()">Resend</a></label></div><div class="row" ng-show="vm.visibleOTPEmail"><div class="col-md-7 col-md-offset-3"><label class="help-text" ng-show="vm.emailOtp==null" ng-hide="vm.invalidEmailOtp && vm.checkEmailOTP" data-translate="gatewayApp.userProfile.otpEmailHelpText"></label><label class="help-text" ng-show="vm.invalidEmailOtp && vm.checkEmailOTP" data-translate="gatewayApp.userProfile.wrongotpHelpText"></label></div></div><nmb-alert></nmb-alert><div class="modal-footer"><!-- <button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()">\r\n\t\t\t\t\t<span data-translate="entity.action.cancel">Cancel</span>\r\n\t\t\t\t</button>\r\n \t\t\t\t--> <button type="submit" ng-hide="showButton" class="btn btn-info active" ng-disabled="changeemailForm.$invalid || vm.clicked || (vm.userProfile.confirmEmail!=vm.userProfile.newEmail) || (!vm.skipOTPEmail && !vm.isEmailVerified)" ng-click="vm.clicked=true;vm.mode == \'user\' ? vm.updateEmail() : vm.updateNewEmail()"><span data-translate="gatewayApp.userProfile.update"></span></button></div></form></div></div></div>');
$templateCache.put('app/entities/change-settings/change-settings.html','<form name="changesettingsForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="{{vm.headerLabel}}"></span></h4></div><div class="modal-body"><div class="content" style="min-height:15vh"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="col-md-4 col-centered" style="margin-top:10px"><div class="row"><label class="control-label" cspl-mandatory><span data-translate="{{vm.labelName}}"></span></label></div><div class="row"><div class="row" ng-show="vm.settingsType.localeCompare(\'yesorno\')==0"><div id="btnGroup" class=""><div class="btn-group"><label class="btn btn-primary" ng-model="vm.settingsValue" ng-disabled="vm.isDisabled" uib-btn-radio="\'Yes\'">Yes</label><label class="btn btn-primary" ng-model="vm.settingsValue" ng-disabled="vm.isDisabled" uib-btn-radio="\'No\'">No&nbsp;</label></div></div></div></div></div><!-- <div class="row">\r\n\t\t\t\t<label class="col-xs-7 col-xs-offset-3 control-label" cspl-mandatory><span\r\n\t\t\t\t\tdata-translate={{vm.labelName}}></span></label>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class="row">\r\n\t\t\t\t<div class="row" ng-show="vm.settingsType.localeCompare(\'yesorno\')==0">\r\n\t\t\t\t\t<div id="btnGroup" class="col-xs-5 col-md-offset-3">\r\n\t\t\t\t\t\t<div class="btn-group">\r\n\t\t\t\t\t\t\t<label class="btn btn-primary" ng-model="vm.settingsValue"\r\n\t\t\t\t\t\t\t\tng-disabled="vm.isDisabled" uib-btn-radio="\'Yes\'">Yes</label> <label\r\n\t\t\t\t\t\t\t\tclass="btn btn-primary" ng-model="vm.settingsValue" ng-disabled="vm.isDisabled"\r\n\t\t\t\t\t\t\t\tuib-btn-radio="\'No\'">No&nbsp;</label>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t</div> --><!-- <div style="margin-right:15px">\r\n\t\t\t\t  <span class="orderStatusInfo" data-translate="gatewayApp.customerSpecificSettings.legend"></span>\r\n\t\t\t\t</div>\t --></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-hide="isShowOkButton" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-info" ng-show="isShowOkButton" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.ok">Ok</span></button> <button type="submit" ng-if="isShowResubmit" class="btn btn-primary" ng-disabled="changesettingsForm.$invalid || vm.clicked" ng-click="vm.clicked=true;vm.resubmitCustomerSpecificSettings();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" class="btn btn-info active" ng-if="isShowSaveButton" ng-disabled="changesettingsForm.$invalid || changesettingsForm.$pristine || vm.clicked" ng-click="vm.clicked=true;vm.saveCustomerSpecificSettings();"><span data-translate="entity.action.save"></span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardCustomerSpecificSettings()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-show="showButton" class="btn btn-reject" ng-click="vm.rejectCustomerSpecificSettings()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.clicked=true;vm.approveCustomerSpecificSettings();" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div><script type="text/javascript">$(\'.clockpicker\').clockpicker({\r\n\t\t\tafterDone : function() {\r\n\t\t\t\tclockpicker.val(round());\r\n\t\t\t}\r\n\t\t}).find(\'input\');</script></form>');
$templateCache.put('app/entities/clearcorp-limit-utilisation-report/clearcorp-limit-utilisation-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.limitUtilisationReport.title" data-translate-values="{value: {{vm.todayDate}}}"></h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapsePendingOrder = !vm.ExpandOrCollapsePendingOrder" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#LimitUtilisationReport"><img ng-src="{{vm.ExpandOrCollapsePendingOrder == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.clearcorpLimitUtilisationReport.criteria">Criteria</span></a></h4></div><div id="LimitUtilisationReport" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="clearcorpLimitUtilisationReportForm"><div class="col-md-7 col-centered"><div class="row"><label class="control-label col-md-3"><span data-translate="gatewayApp.clearcorpLimitUtilisationReport.bank"></span></label></div><div class="row"><div class="col-md-5"><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="nonTerminatedBanks" display-column="bankName" placeholder="" form="clearcorpLimitUtilisationReportForm"></div></div><div class="row"><label class="control-label col-md-3"><span data-translate="gatewayApp.clearcorpLimitUtilisationReport.branch"></span></label></div><div class="row"><div class="col-md-5"><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="activeBranchesForBank" display-column="branchName" placeholder="" form="clearcorpLimitUtilisationReportForm" filter-value="{{vm.bank.id}}"></div></div><div class="row"><label class="control-label col-md-3"><span data-translate="gatewayApp.clearcorpLimitUtilisationReport.customer"></span></label></div><div class="row"><div class="col-md-5"><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="nonPropNonTerminatedCustomers" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" control-place-holder="Enter Customer ID or Name" display-column="customerCode,customerName" placeholder="" form="clearcorpLimitUtilisationReportForm"><span class="cutomer-highlight" ng-if="vm.customer.customerMiddleName==null">{{vm.customer.customerFirstName+\' \'+vm.customer.customerLastName}}</span> <span class="cutomer-highlight" ng-if="vm.customer.customerMiddleName!=null">{{vm.customer.customerFirstName+\' \'+ vm.customer.customerMiddleName+\' \'+vm.customer.customerLastName}}</span></div></div><div class="row"><label class="control-label col-md-3"><span data-translate="gatewayApp.clearcorpLimitUtilisationReport.instrument"></span></label></div><div class="row"><div class="col-md-5"><cspl-ach control-model="vm.instrument" control-id="txtInstrument" lookup-name="instrument" display-column="name" placeholder="" form="clearcorpLimitUtilisationReportForm"></div><div class="col-md-2"><button class="btn btn-info active" ng-disabled="clearcorpLimitUtilisationReportForm.$invalid||vm.clicked" ng-click="vm.getLimitUtilised();vm.clicked=true;" data-toggle="collapse" data-target="#LimitUtilisationReport" data-translate="gatewayApp.clearcorpLimitUtilisationReport.go"></button></div></div></div></form></div></div></div><div ng-show="vm.limitUtilisationDetailsList.length > 0"><div class="row"><div class="up-btn"><div class="dropdown" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportDataToCsvFile()">CSV</a></li><li><a ng-click="vm.exportDataToExcelFile();">XLS</a></li><li><a ng-click="vm.exportDataToPdfFile()">PDF</a></li></ul></div></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="clearcorpLimitUtilisationReport" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.clearcorpLimitUtilisationReport.bank" style="min-width:90px"></th><th data-translate="gatewayApp.clearcorpLimitUtilisationReport.branch" style="min-width:90px"></th><th data-translate="gatewayApp.clearcorpLimitUtilisationReport.custId"></th><th data-translate="gatewayApp.clearcorpLimitUtilisationReport.custName" style="min-width:90px"></th><th data-translate="gatewayApp.clearcorpLimitUtilisationReport.inst"></th><th data-translate="gatewayApp.clearcorpLimitUtilisationReport.limitType"></th><th data-translate="gatewayApp.clearcorpLimitUtilisationReport.limitccy"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpLimitUtilisationReport.limitccyAmount"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpLimitUtilisationReport.allocated"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpLimitUtilisationReport.pendingBuy"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpLimitUtilisationReport.pendingSell"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpLimitUtilisationReport.buyTrade"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpLimitUtilisationReport.sellTrade"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpLimitUtilisationReport.prevBuyTrade"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpLimitUtilisationReport.prevSellTrade"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpLimitUtilisationReport.totalBuy"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpLimitUtilisationReport.totalSell"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpLimitUtilisationReport.buyingPower"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpLimitUtilisationReport.sellingPower"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpLimitUtilisationReport.exposure"></th><th data-translate="gatewayApp.clearcorpLimitUtilisationReport.effectiveFrom"></th><th data-translate="gatewayApp.clearcorpLimitUtilisationReport.limitExpiryDate"></th><th data-translate="gatewayApp.clearcorpLimitUtilisationReport.limitReinstateMethod"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpLimitUtilisationReport.maxTenor"></th><th data-translate="gatewayApp.clearcorpLimitUtilisationReport.maxValueDate"></th></tr></thead><tbody><tr ng-repeat="limitUtilisationDetail in filterData = (vm.limitUtilisationDetailsList | filter : filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break:break-word">{{limitUtilisationDetail.bankName}}</td><td style="word-break:break-word">{{limitUtilisationDetail.branchName}}</td><td style="word-break:break-word">{{limitUtilisationDetail.customerCode}}</td><td style="word-break:break-word">{{limitUtilisationDetail.customerName}}</td><td>{{limitUtilisationDetail.instrumentCode}}</td><td><span ng-if="limitUtilisationDetail.limitType==\'GROSSBUY\'">Gross Buy</span> <span ng-if="limitUtilisationDetail.limitType==\'GROSSSELL\'">Gross Sell</span> <span ng-if="limitUtilisationDetail.limitType==\'GLOBALGROSS\'">Global Gross</span> <span ng-if="limitUtilisationDetail.limitType==\'NET\'">Net</span></td><td>{{limitUtilisationDetail.currencyCode}}</td><td ng-if="limitUtilisationDetail.currencyCode==\'USD\'">{{limitUtilisationDetail.limitAllocatedInUSD | number:vm.noOfDecimalsForAmount}}</td><td ng-if="limitUtilisationDetail.currencyCode==\'INR\'">{{limitUtilisationDetail.limitAllocatedInINR | number:vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right"><span>{{limitUtilisationDetail.limitAllocatedInUSD | number:vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-if="limitUtilisationDetail.totalPendingBuyOrderValue != 0">{{limitUtilisationDetail.totalPendingBuyOrderValue | number:vm.noOfDecimalsForAmount}}</span> <span ng-if="limitUtilisationDetail.totalPendingBuyOrderValue == 0 || limitUtilisationDetail.totalPendingBuyOrderValue == null || limitUtilisationDetail.totalPendingBuyOrderValue == undefined">-</span></td><td class="td-text-align-right"><span ng-if="limitUtilisationDetail.totalPendingSellOrderValue != 0">{{limitUtilisationDetail.totalPendingSellOrderValue | number:vm.noOfDecimalsForAmount}}</span> <span ng-if="limitUtilisationDetail.totalPendingSellOrderValue == 0 || limitUtilisationDetail.totalPendingSellOrderValue == null || limitUtilisationDetail.totalPendingSellOrderValue == undefined">-</span></td><td class="td-text-align-right"><span ng-if="limitUtilisationDetail.totalBuyTradeValue != 0">{{limitUtilisationDetail.totalBuyTradeValue | number:vm.noOfDecimalsForAmount}}</span> <span ng-if="limitUtilisationDetail.totalBuyTradeValue == 0 || limitUtilisationDetail.totalBuyTradeValue == null || limitUtilisationDetail.totalBuyTradeValue == undefined">-</span></td><td class="td-text-align-right"><span ng-if="limitUtilisationDetail.totalSellTradeValue != 0">{{limitUtilisationDetail.totalSellTradeValue | number:vm.noOfDecimalsForAmount}}</span> <span ng-if="limitUtilisationDetail.totalSellTradeValue == 0 || limitUtilisationDetail.totalSellTradeValue == null || limitUtilisationDetail.totalSellTradeValue == undefined">-</span></td><td class="td-text-align-right"><span ng-if="limitUtilisationDetail.previousDayBuyTradeValue != 0">{{limitUtilisationDetail.previousDayBuyTradeValue | number:vm.noOfDecimalsForAmount}}</span> <span ng-if="limitUtilisationDetail.previousDayBuyTradeValue == 0 || limitUtilisationDetail.previousDayBuyTradeValue == null || limitUtilisationDetail.previousDayBuyTradeValue == undefined">-</span></td><td class="td-text-align-right"><span ng-if="limitUtilisationDetail.previousDaySellTradeValue != 0">{{limitUtilisationDetail.previousDaySellTradeValue | number:vm.noOfDecimalsForAmount}}</span> <span ng-if="limitUtilisationDetail.previousDaySellTradeValue == 0 || limitUtilisationDetail.previousDaySellTradeValue == null || limitUtilisationDetail.previousDaySellTradeValue == undefined">-</span></td><td class="td-text-align-right" ng-if="limitUtilisationDetail.limitType!=\'NET\'"><span ng-if=" vm.calculateGrossBuyTotal(limitUtilisationDetail) != 0">{{ vm.calculateGrossBuyTotal(limitUtilisationDetail) | number:vm.noOfDecimalsForAmount}}</span> <span ng-if="vm.calculateGrossBuyTotal(limitUtilisationDetail) == undefined || vm.calculateGrossBuyTotal(limitUtilisationDetail) == null || vm.calculateGrossBuyTotal(limitUtilisationDetail) == 0">-</span></td><td class="td-text-align-right" ng-if="limitUtilisationDetail.limitType!=\'NET\'"><span ng-if=" vm.calculateGrossSellTotal(limitUtilisationDetail) != 0">{{vm.calculateGrossSellTotal(limitUtilisationDetail) | number:vm.noOfDecimalsForAmount}}</span> <span ng-if=" vm.calculateGrossSellTotal(limitUtilisationDetail) == undefined || vm.calculateGrossSellTotal(limitUtilisationDetail) == null || vm.calculateGrossSellTotal(limitUtilisationDetail) == 0">-</span></td><td class="td-text-align-right" ng-if="limitUtilisationDetail.limitType==\'NET\'"><span ng-if=" vm.calculateNetBuyTotal(limitUtilisationDetail) != 0">{{ vm.calculateNetBuyTotal(limitUtilisationDetail) | number:vm.noOfDecimalsForAmount}}</span> <span ng-if=" vm.calculateNetBuyTotal(limitUtilisationDetail) == undefined || vm.calculateNetBuyTotal(limitUtilisationDetail) == null || vm.calculateNetBuyTotal(limitUtilisationDetail) == 0">-</span></td><td class="td-text-align-right" ng-if="limitUtilisationDetail.limitType==\'NET\'"><span ng-if=" vm.calculateNetSellTotal(limitUtilisationDetail)!= 0 ">{{vm.calculateNetSellTotal(limitUtilisationDetail) | number:vm.noOfDecimalsForAmount}}</span> <span ng-if=" vm.calculateNetSellTotal(limitUtilisationDetail) == null || vm.calculateNetSellTotal(limitUtilisationDetail) == undefined || vm.calculateNetSellTotal(limitUtilisationDetail) == 0"></span></td><td class="td-text-align-right"><span>{{vm.getBuyingPower(limitUtilisationDetail)}}</span></td><td class="td-text-align-right"><span>{{vm.getSellingPower(limitUtilisationDetail)}}</span></td><td class="td-text-align-right"><span>{{vm.getExposure(limitUtilisationDetail) }}</span></td><td class=""><span>{{limitUtilisationDetail.effectiveFrom | date:\'dd-MMM-yyyy\'}}</span></td><td class=""><span>{{limitUtilisationDetail.effectiveTo | date:\'dd-MMM-yyyy\'}}</span></td><td class=""><span>{{limitUtilisationDetail.limitReinstateTypeName}}</span></td><td ng-if="limitUtilisationDetail.maximumTenorValue==null"></td><td ng-if="limitUtilisationDetail.maximumTenorValue!=null && limitUtilisationDetail.maximumTenorType==\'Days\'">{{limitUtilisationDetail.maximumTenorValue | number:0}} Day(s)</td><td ng-if="limitUtilisationDetail.maximumTenorValue!=null && limitUtilisationDetail.maximumTenorType==\'Months\'">{{limitUtilisationDetail.maximumTenorValue | number:0}} Month(s)</td><td class=""><span>{{limitUtilisationDetail.maximumValueDate | date:\'dd-MMM-yyyy\'}}</span></td></tr></tbody></table></div><div ng-show="vm.limitUtilisationDetailsList.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="table-responsive" ng-show="vm.limitUtilisationDetailsList.length==0"><span>No record found</span></div></div></section></div><script src="assets/js/tables.js"></script><style>.total-bar {\r\n\t\t\t\tbackground-color: #1a260e !important;\r\n\t\t\t}\r\n\r\n\t\t\t.total-bar:hover {\r\n\t\t\t\tbackground: #1a260e !important;\r\n\t\t\t\tcolor: #F2F2F2 !important;\r\n\t\t\t}</style></div>');
$templateCache.put('app/entities/clearcorp-member-bank-fee-charges-view/clearcorp-member-bank-fee-charges-view.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.memberFeesAndCharges.title"></h2><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="module-wrapper"><section class="module"><div class="module-inner"><div><div class="row"><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="memberBankFeeTable" total-record-count="vm.banksFeeChargeDTO.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="vm.filterText" page-no="page" file-name="Member_Bank_Fee"></cspl-table-export></div><div class="float-right col-md-2 col-sm-3 col-xs-4"><cspl-table-search control-model="vm.filterText"></cspl-table-search></div></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="memberBankFeeTable" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.memberBanksFeesAndChargesView.hash">#</th><th data-translate="gatewayApp.memberBanksFeesAndChargesView.bankName">Bank Name</th><th data-translate="gatewayApp.memberBanksFeesAndChargesView.ccilMembershipId">CCIL Membership Id</th><th data-translate="gatewayApp.memberBanksFeesAndChargesView.uploaded">Uploaded</th><th data-translate="gatewayApp.memberBanksFeesAndChargesView.lastUploadedDateTime">Last Uploaded Date Time</th><th></th><th></th></tr></thead><tbody><tr class="relationship-bank-fee-table-body" ng-repeat="memberBanks in filterData = ( vm.banksFeeChargeDTO | filter : vm.filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td width="5%">{{filterData.indexOf(memberBanks) +1}}</td><td width="25%"><span>{{memberBanks.bankName}}</span></td><td width="15%"><span>{{memberBanks.ccpMembershipId}}</span></td><td width="10%"><span ng-show="memberBanks.createdDateTime != null">Yes</span> <span ng-show="memberBanks.createdDateTime == null">No</span></td><td width="20%"><span ng-show="memberBanks.createdDateTime != null && memberBanks.fileContent != null">{{memberBanks.createdDateTime | date:\'dd-MMM-yyyy hh:mm:ss a\'}}</span><span ng-show="memberBanks.createdDateTime == null || memberBanks.fileContent == null">-</span></td><td width="25%" ng-show="memberBanks.fileContent != null"><span style="color: #FFAA1D" ng-show="memberBanks.fileContent != null" class="glyphicon glyphicon-file" ng-click="vm.openBankFeesChargesPreview(memberBanks.fileContent)" title="Member Bank Fee & Charges"></span></td><td></td></tr></tbody></table></div><div class="row"><div class="col-md-5" ng-show="vm.banksFeeChargeDTO.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><div class="col-md-7" style="font-size: 15px !important;width:52%;float: right;margin-top:23px"><a ui-sref="clearcorp-member-bank-history-view"><span data-translate="gatewayApp.memberBanksFeesAndChargesView.clickHereToViewTheNextScreen"></span></a></div></div></div></div></section></div></div>');
$templateCache.put('app/entities/clearcorp-member-bank-fee-charges-view/clearcorp-member-bank-history.html','<form name="memberBankHistory" role="form"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="global.menu.memberFeesAndChargesHistory.title"></span></h4></div><div class="modal-body"><div class="content" ng-class="{\'collapse in\':vm.valid}"><br><div class="row"><div class="col-md-1 text-right" style="margin-top:7px">From</div><div class="col-md-3"><cspl-dtp control-model="vm.fromDate" control-id="dtpFromDate" form="memberBankHistory" control-disabled="false" control-max-date="vm.todayDate" required></div><div class="col-md-1 text-right" style="margin-top:7px">To</div><div class="col-md-3"><cspl-dtp control-model="vm.toDate" control-id="dtpToDate" form="memberBankHistory" control-disabled="false" control-min-date="vm.fromDate" control-max-date="vm.todayDate" required></div><div class="col-md-2"><button type="button" class="btn btn-info" style="float:right;margin-right: 30%" data-dismiss="modal" ng-disabled="memberBankHistory.$invalid||vm.clicked" ng-click="vm.go()"><span>Go</span></button></div></div><div class="row"><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="memberBankFeeTable" total-record-count="vm.banksFeeChargeDTO.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="vm.filterText" page-no="page" file-name="Member_Bank_Fee_History"></cspl-table-export></div><div class="float-right col-md-3 col-sm-4 col-xs-6"><cspl-table-search control-model="vm.filterText"></cspl-table-search></div></div><fieldset><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="memberBankFeeTable" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.memberBanksFeesAndChargesView.hash">#</th><th data-translate="gatewayApp.memberBanksFeesAndChargesView.bankName">Bank Name</th><th data-translate="gatewayApp.memberBanksFeesAndChargesView.ccilMembershipId">CCIL Membership Id</th><th data-translate="gatewayApp.memberBanksFeesAndChargesView.uploaded">Uploaded</th><th data-translate="gatewayApp.memberBanksFeesAndChargesView.lastUploadedDateTime">Last Uploaded Date Time</th><th></th></tr></thead><tbody><tr class="relationship-bank-fee-table-body" ng-repeat="memberBanks in filterData = ( vm.banksFeeChargeDTO | filter : vm.filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td width="10%">{{filterData.indexOf(memberBanks) +1}}</td><td width="25%"><span>{{memberBanks.bankName}}</span></td><td width="15%"><span>{{memberBanks.ccpMembershipId}}</span></td><td width="15%"><span ng-show="memberBanks.createdDateTime != null">Yes</span> <span ng-show="memberBanks.createdDateTime == null">No</span></td><td width="25%"><span ng-show="memberBanks.createdDateTime != null && memberBanks.fileContent != null">{{memberBanks.createdDateTime | date:\'dd-MMM-yyyy hh:mm:ss a\'}}</span><span ng-show="memberBanks.createdDateTime == null || memberBanks.fileContent == null">-</span></td><td width="10%" ng-show="memberBanks.fileContent != null"><span style="color: #FFAA1D" ng-show="memberBanks.fileContent != null && vm.permitBankViewEntityAction == true" class="glyphicon glyphicon-file" ng-click="vm.openBankFeesChargesPreview(memberBanks.fileContent)" title="Member Bank Fee & Charges"></span></td></tr></tbody></table><span ng-show="vm.banksFeeChargeDTO.length == 0 && vm.goClick == true" class="text-left">No record found</span></div><div ng-show="vm.banksFeeChargeDTO.length == 0"><br><br><br><br><br><br><br><br><br><br></div><div ng-show="vm.banksFeeChargeDTO.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button></div></div></form>');
$templateCache.put('app/entities/clearcorp-markup-report/clearcorp-markup-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.markupReportForClearCorp.title" data-translate-values="{value: {{vm.todayDate}}}"></h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseMarkup = !vm.ExpandOrCollapseMarkup" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#MarkupReport"><img ng-src="{{vm.ExpandOrCollapseMarkup == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.clearcorpmarkupReport.criteria">Criteria</span></a></h4></div><div id="MarkupReport" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="clearcorpmarkupReportForm"><div class="col-md-6 col-centered"><div class="row"><label class="control-label col-md-3"><span data-translate="gatewayApp.clearcorpmarkupReport.bank"></span></label></div><div class="row"><div class="col-md-5"><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="nonTerminatedBanks" display-column="bankName" placeholder="" form="clearcorpmarkupReportForm"></div></div><div class="row"><label class="control-label col-md-3"><span data-translate="gatewayApp.clearcorpmarkupReport.branch"></span></label></div><div class="row"><div class="col-md-5"><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="activeBranchesForBank" display-column="branchName" placeholder="" form="clearcorpmarkupReportForm" filter-value="{{vm.bank.id}}"></div></div><div class="row"><label class="control-label col-md-3"><span data-translate="gatewayApp.clearcorpmarkupReport.currencyPair"></span></label></div><div class="row"><div class="col-md-5"><cspl-ach control-model="vm.currencyPair" control-id="txtCurrencyPair" lookup-name="currencyPair" display-column="code" placeholder="" form="clearcorpmarkupReportForm" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}"></div></div><div class="row"><label class="control-label col-md-3"><span data-translate="gatewayApp.clearcorpmarkupReport.customer"></span></label></div><div class="row"><div class="col-md-5"><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="nonPropNonTerminatedCustomers" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" control-place-holder="Enter Customer ID or Name" display-column="customerCode,customerName" placeholder="" form="clearcorpmarkupReportForm"><span class="cutomer-highlight" ng-if="vm.customer.customerMiddleName==null">{{vm.customer.customerFirstName+\' \'+vm.customer.customerLastName}}</span> <span class="cutomer-highlight" ng-if="vm.customer.customerMiddleName!=null">{{vm.customer.customerFirstName+\' \'+ vm.customer.customerMiddleName+\' \'+vm.customer.customerLastName}}</span></div><div class="col-md-2"><button class="btn btn-info active" ng-disabled="clearcorpmarkupReportForm.$invalid||vm.clicked" ng-click="vm.getMarkup();vm.clicked=true;" data-toggle="collapse" data-target="#MarkupReport" data-translate="gatewayApp.clearcorpmarkupReport.go"></button></div></div></div></form></div></div></div><div ng-show="vm.clearcorpmarkupReportDetails.length > 0"><div class="row"><!-- <cspl-table-export class="col-md-1 col-sm-1 col-xs-1" table-name="clearcorpmarkupReport" total-record-count="filterData.length" \r\n\t                    \tno-of-records-per-page="noOfRecordsPerPage"  page-no="page"  file-name="Order_Status_Report"></cspl-table-export> --><div class="up-btn" ng-if="vm.account.organisation.organisationType.shortName != \'CLEARCORP\' "><div class="dropdown" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportDataToCsvFile()">CSV</a></li><li><a ng-click="vm.exportDataToExcelFile();">XLS</a></li><li><a ng-click="vm.exportDataToPdfFile()">PDF</a></li></ul></div></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="clearcorpmarkupReport" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.clearcorpmarkupReport.bank" style="min-width:80px"></th><th data-translate="gatewayApp.clearcorpmarkupReport.branch" style="min-width:90px"></th><th data-translate="gatewayApp.clearcorpmarkupReport.custId" style="min-width:90px"></th><th data-translate="gatewayApp.clearcorpmarkupReport.customer" style="min-width:80px"></th><th data-translate="gatewayApp.clearcorpmarkupReport.markupType"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpmarkupReport.markupValue"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.clearcorpmarkupReport.taxOnMarkup"></th><th data-translate="gatewayApp.clearcorpmarkupReport.effectiveFrom"></th><th data-translate="gatewayApp.clearcorpmarkupReport.relationshipStatus"></th><th data-translate="gatewayApp.clearcorpmarkupReport.roEdApplicability"></th><th data-translate="gatewayApp.clearcorpmarkupReport.source"></th><th></th></tr></thead><tbody><tr ng-repeat="markup in filterData = (vm.clearcorpmarkupReportDetails | filter : filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break:break-word">{{markup.bankName}}</td><td style="word-break:break-word">{{markup.branchName}}</td><td style="word-break:break-word">{{markup.customerCode}}</td><td style="word-break:break-word">{{markup.customerName}}</td><td>{{markup.markupType}}</td><td class="td-text-align-right" style="padding-right:10px"><span ng-if="markup.markupType.toLowerCase()==\'paise\' && markup.markupValue!=null && markup.markupValue!=undefined">{{markup.markupValue | number:vm.noOfDecimalsForAmount}}</span> <span ng-if="markup.markupType.toLowerCase()==\'percentage\' && markup.markupValue!=null && markup.markupValue!=undefined">{{markup.markupValue | number:vm.noOfDecimalsForPercent}}</span> <span ng-if="markup.markupValue==null || markup.markupValue==undefined">-</span></td><td class="td-text-align-right" style="padding-right:10px"><span ng-if="markup.taxOnMarkup!=null && markup.taxOnMarkup!=undefined">{{markup.taxOnMarkup | number:vm.noOfDecimalsForPercent}}</span> <span ng-if="markup.taxOnMarkup==null || markup.taxOnMarkup==undefined">-</span></td><td><span>{{markup.effectiveFrom| date:\'dd-MMM-yyyy\'}}</span></td><td>{{markup.relationshipStatus}}</td><td><span ng-if="markup.roEdApplicabilityMethodName!=null && markup.roEdApplicabilityMethodName!=undefined">{{markup.roEdApplicabilityMethodName}}</span> <span ng-if="markup.roEdApplicabilityMethodName==null || markup.roEdApplicabilityMethodName==undefined">-</span></td><td>{{markup.sourceAppName}}</td></tr></tbody></table></div><div ng-show="vm.clearcorpmarkupReportDetails.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="table-responsive" ng-show="vm.clearcorpmarkupReportDetails.length==0"><span>No record found</span></div></div></section></div><script src="assets/js/tables.js"></script><style>.total-bar {\r\n\t\t\t\tbackground-color: #1a260e !important;\r\n\t\t\t}\r\n\r\n\t\t\t.total-bar:hover {\r\n\t\t\t\tbackground: #1a260e !important;\r\n\t\t\t\tcolor: #F2F2F2 !important;\r\n\t\t\t}</style></div>');
$templateCache.put('app/entities/clearcorp-terms-condition-upload/clearcorp-bank-tac-view.html','<form name="bankTermsAndConditions" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="global.menu.clearCorpTACUpload.banksTermsAndConditions.title"></span></h4></div><div class="modal-body"><div class="content"><div class="row"><div class="dropdown col-md-3 col-sm-3 col-xs-3" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div><cspl-table-search control-model="filterText" class="col-md-3 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><fieldset><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="`BankTermsAndConditions" class="dataTable table table-striped table-hover"><thead><tr><th style="width: 37%" data-translate="gatewayApp.clearCorpTACUpload.bankName"></th><th style="width: 37%" data-translate="gatewayApp.clearCorpTACUpload.latestRevisionDateTime"></th><th style="width: 23%" data-translate="gatewayApp.clearCorpTACUpload.bankEnforcingDate"></th><th></th></tr></thead><tbody><tr ng-repeat="bankTermsAndConditions in filterData = (vm.bankTermsAndConditionsList | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break:break-word">{{bankTermsAndConditions.bankName}}</td><td><span ng-if="bankTermsAndConditions.tacMaster.id != null">{{bankTermsAndConditions.tacMaster.createdDate | date:\'dd-MMM-yyyy hh:mm:ss a\'}}</span> <span ng-if="bankTermsAndConditions.tacMaster.id == null">-</span></td><td><span ng-if="bankTermsAndConditions.tacMaster.id != null">{{bankTermsAndConditions.tacMaster.enforcingDate | date:\'dd-MMM-yyyy\'}}</span> <span ng-if="bankTermsAndConditions.tacMaster.id == null">-</span></td><td><span ng-if="bankTermsAndConditions.tacMaster.id != null && vm.permitTACViewEntityAction == true"><span style="color: #FFAA1D" class="glyphicon glyphicon-file" ng-click="vm.openTACPreview(bankTermsAndConditions)" title="View Bank\'s Terms and Conditions"></span></span></td></tr></tbody></table></div><div ng-show="vm.bankTermsAndConditionsList.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button></div></div></form>');
$templateCache.put('app/entities/clearcorp-terms-condition-upload/clearcorp-tac-approval.html','<style>.btn-reject {\r\n\tbackground-color: #f34743;\r\n\tborder: 1px solid #f34743;\r\n\tcolor: white;\r\n}\r\n\r\n.btn-approve {\r\n\tbackground-color: #37a36a;\r\n\tborder: 1px solid #37a36a;\r\n\tcolor: white;\r\n}</style><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="gatewayApp.clearCorpTACUpload.termsConditionUpload"></span></h4></div><div class="modal-body"><div class="content"><p><nmb-alert></nmb-alert></p><p><nmb-alert-error></nmb-alert-error></p><form name="termsConditionUploadForm" role="form" novalidate><div class="col-md-offset-2 col-sm-offset-2 col-xs-offset-1 col-lg-offset-2 col-md-8 col-sm-8 col-xs-11 col-lg-8"><div class="form-group"><label class="control-label" style="width: 100%;  text-align: left;   margin-top: 10px" cspl-mandatory><span data-translate="gatewayApp.clearCorpTACUpload.entity"></span></label><div id="btnGroup" style="margin-left:-8px"><div class="btn-group" style="margin-left: 8px"><label class="btn btn-primary tab-padding active" ng-model="vm.clearCorpTermsAndCondtionsUploadDTO.entityType" uib-btn-radio="\'Bank\'" ng-disabled="true">Bank</label><label class="btn btn-primary tab-padding" ng-model="vm.clearCorpTermsAndCondtionsUploadDTO.entityType" uib-btn-radio="\'Customer\'" ng-disabled="true">Customer</label></div></div></div><div class="form-group"><label class="control-label left-align-label" style="width: 100%;  text-align: left;   margin-top: 10px" cspl-mandatory><span data-translate="gatewayApp.clearCorpTACUpload.enforcingDate"></span></label><div class="col-md-8 col-lg-6 col-sm-6 col-xs-8" style="margin-left:-8px"><cspl-dtp control-model="vm.clearCorpTermsAndCondtionsUploadDTO.enforcingDate" control-id="enforcingDate" control-required="true" control-disabled="true" form="termsConditionUploadForm"></cspl-dtp><div class="justified-help-block" style="padding-top:10px"><span data-translate="gatewayApp.clearCorpTACUpload.enfocingDateHelpText1"></span> <span class="text-decoration-underline" data-translate="gatewayApp.clearCorpTACUpload.enfocingDateHelpText2"></span> <span data-translate="gatewayApp.clearCorpTACUpload.enfocingDateHelpText3"></span></div></div><div class="col-md-2 col-sm-2 col-lg-2 col-xs-2"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.openTACPreview(vm.clearCorpTermsAndCondtionsUploadDTO.tacMaster.tacFiles)"><span data-translate="gatewayApp.clearCorpTACUpload.Preview"></span></button></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>OK</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardTAC()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectTAC()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" autofocus class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveTAC();vm.clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div></div>');
$templateCache.put('app/entities/clearcorp-terms-condition-upload/clearcorp-tac-bank-agreed-view.html','<form name="orderActivityForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="global.menu.clearCorpTACUpload.agreedBanks.title"></span></h4></div><div class="modal-body"><div class="content"><div class="row"><div class="dropdown col-md-3 col-sm-3 col-xs-3" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div><cspl-table-search control-model="filterText" class="col-md-3 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><fieldset><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="agreedBanks" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.agreedBanks.bank"></th><th data-translate="gatewayApp.agreedBanks.ccilMembershipId"></th><th data-translate="gatewayApp.agreedBanks.Agreed"></th><th data-translate="gatewayApp.agreedBanks.agreedDateAndTime"></th><th data-translate="gatewayApp.agreedBanks.agreedBy"></th><th></th></tr></thead><tbody><tr ng-repeat="agreedBank in filterData = (vm.agreedBankList | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{agreedBank.orgName}}</td><td>{{agreedBank.bankMembershipId}}</td><td>{{agreedBank.isAgreed}}</td><td><span ng-if="agreedBank.isAgreed == \'Yes\'">{{agreedBank.agreedDateTime | date:\'dd-MMM-yyyy hh:mm:ss a\'}}</span> <span ng-if="agreedBank.isAgreed == \'No\'">-</span></td><td><span ng-if="agreedBank.isAgreed== \'Yes\'">{{agreedBank.userFullName}}</span> <span ng-if="agreedBank.isAgreed== \'No\'">-</span></td><td><span ng-if="agreedBank.isAgreed == \'Yes\' && vm.permitTACViewEntityAction == true"><span style="color:#FFAA1D" class="glyphicon glyphicon-file" ng-click="vm.openTACPreview(agreedBank)" title="View Terms and Conditions"></span></span></td></tr></tbody></table></div><div ng-show="vm.agreedBankList.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button></div></div></form>');
$templateCache.put('app/entities/clearcorp-terms-condition-upload/clearcorp-tac-edit.html','<style>.reducedMargin {\r\n    margin-left: 20px;\r\n  }\r\n@media (max-width: 421px) {\r\n  .reducedMargin {\r\n    margin-left: 2px;\r\n  }\r\n}</style><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="gatewayApp.clearCorpTACUpload.termsConditionUpload"></span></h4></div><div class="modal-body"><div class="content"><form name="termsConditionUploadForm" class="form-horizontal" role="form" novalidate><fieldset><p><nmb-alert></nmb-alert></p><p><nmb-alert-error></nmb-alert-error></p><div class="row"><div class="col-md-6 col-md-offset-2"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.clearCorpTACUpload.entity"></span></label></div></div><div class="row" style="margin-top:5px"><div class="col-md-6 col-md-offset-2"><div id="btnGroup"><div class="btn-group"><label class="btn btn-primary tab-padding active" ng-model="vm.clearCorpTermsAndCondtionsUploadDTO.entityType" uib-btn-radio="\'Bank\'" ng-disabled="true">Bank</label><label class="btn btn-primary tab-padding" ng-model="vm.clearCorpTermsAndCondtionsUploadDTO.entityType" uib-btn-radio="\'Customer\'" ng-disabled="true">Customer</label></div></div></div></div><div class="row" style="margin-top:5px"><div class="col-md-6 col-md-offset-2"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.clearCorpTACUpload.enforcingDate"></span></label></div></div><div class="row" style="margin-top:5px"><div class="col-md-5 col-sm-5 col-xs-10 col-lg-4 col-md-offset-2"><div class=""><cspl-dtp style="width: 50%" control-model="vm.clearCorpTermsAndCondtionsUploadDTO.enforcingDate" control-id="enforcingDate" control-required="true" control-min-date="vm.minDate" form="termsConditionUploadForm"></cspl-dtp><div class="justified-help-block" style="padding-top:0px"><span data-translate="gatewayApp.clearCorpTACUpload.enfocingDateHelpText1"></span> <span class="text-decoration-underline" data-translate="gatewayApp.clearCorpTACUpload.enfocingDateHelpText2"></span> <span data-translate="gatewayApp.clearCorpTACUpload.enfocingDateHelpText3"></span></div></div></div></div><div class="row" style="margin-top:5px"><div class="col-md-6 col-md-offset-2"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.clearCorpTACUpload.filePath"></span></label></div></div><div class="row" style="margin-top:5px"><div class="col-md-10 col-sm-10 col-md-offset-2"><div class="input-group" style="float:left"><input type="text" class="form-control fileOpen" ng-class="{ \'red\': vm.checkTACFile && (vm.inputTermsCondition==null || vm.inputTermsCondition==undefined)}" ng-model="vm.inputTermsCondition" ng-blur="vm.checkTACFile=true;" readonly="readonly"><label style="width:46px" ng-class="{ \'notentered\': vm.checkTACFile && (vm.inputTermsCondition==null || vm.inputTermsCondition==undefined)}" for="termsConditionFile" class="btn btn-primary fileUploadDark"><img src="assets/images/Open Path-26.png" style="pointer-events: none"></label><input type="file" id="termsConditionFile" name="termsConditionUpload" fileread="vm.termsCondition" accept="application/pdf" form="termsConditionUploadForm" ng-hide="true"> <span class="help-block-error" style="margin-bottom: 5px;width:246px" ng-show="vm.invalidTermsConditionSize"><!-- Uploaded content should not be greater than 500 kb. --> {{vm.invalidTermsConditionSixeText}} </span><span class="help-block-error" style="margin-bottom: 5px;width:246px" ng-show="vm.invalidTermsCondition">{{vm.invalidTermsConditionText}}</span> <span class="help-block-error" style="margin-bottom: 5px;width:246px" ng-show="vm.invalidTermsConditionName">{{vm.invalidTermsConditionNameText}}</span> <span class="help-block-error" style="margin-bottom: 5px;width:246px" ng-show="vm.checkTACFile && ( vm.inputTermsCondition==null || vm.inputTermsCondition==undefined)">Pdf file should be uploaded.</span></div><div class="col-md-2"><button type="submit" ng-if="showButton" ng-disabled="termsConditionUploadForm.$invalid || vm.termsCondition == null  || vm.clicked" class="btn btn-info active reducedMargin" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.upload">UPLOAD</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary reducedMargin" ng-disabled="termsConditionUploadForm.$invalid || (vm.termsCondition == null) || vm.clicked" ng-click="vm.clicked = true;vm.resubmitTAC();"><span data-translate="entity.action.resubmit">UPLOAD</span></button></div></div></div><div class="row" style="margin-top:0px"><div class="col-md-6 col-md-offset-2 justified-help-block"><span data-translate="gatewayApp.clearCorpTACUpload.acceptedFormat"></span></div><div class="col-md-6 col-md-offset-2 justified-help-block" style="padding-top:5px"><span ng-show="vm.showInKB" data-translate="gatewayApp.clearCorpTACUpload.maxFileSize" data-translate-values="{value: {{vm.tacFileUploadSize}}}"></span> <span ng-show="vm.showInKB == false" data-translate="gatewayApp.clearCorpTACUpload.maximumFileSizeLegendMB" data-translate-values="{value: {{vm.tacFileUploadSize}}}"></span></div></div><br></fieldset></form></div></div>');
$templateCache.put('app/entities/clearcorp-terms-condition-upload/clearcorp-tac-view.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.clearCorpTACUpload.title"></h2><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="module-wrapper"><section class="module"><div class="module-inner"><div ng-show="vm.clearcorpTACDetails.length > 0"><div class="row"><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 float-right"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="clearcorpTermsCondition" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.clearCorpTACUpload.entity"></th><th data-translate="gatewayApp.clearCorpTACUpload.lastmodifiedDateTime"></th><th></th><th></th></tr></thead><tbody><tr class="clearcorp-terms-conditions" ng-repeat="tac in filterData = (vm.clearcorpTACDetails | filter : filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td width="20%"><span ng-if="tac.tacType.type == \'Clearcorp For Customer\'">Customer</span><span ng-if="tac.tacType.type == \'Clearcorp For Member\'">Bank</span></td><td width="25%">{{tac.lastModifiedDate | date:\'dd-MMM-yyyy hh:mm:ss a\'}}</td><td width="10%"><span style="color: #FFAA1D" class="glyphicon glyphicon-file" ng-click="vm.openTACPreview(tac.tacFiles)" title="View Terms and Conditions"></span></td><td><span><img src="assets/images/EditProfile.png" class="EditProfile-noHover" ng-click="vm.uploadTAC(tac)"> <img src="assets/images/EditProfile_Black.png" class="EditProfile-Hover" ng-click="vm.uploadTAC(tac)" title="Revise Terms and Conditions"></span></td></tr></tbody></table><div style="margin-top: 10px; ;font-size: 15px !important;width:60%"><a ui-sref="agreed-bank-details"><span style="float: left" data-translate="gatewayApp.clearCorpTACUpload.clickHere"></span></a><!-- <a ui-sref="clearcorp-bank-tac-view"><span style="float: right;"\r\n\t\t\t\t\t\t\t\tdata-translate="gatewayApp.clearCorpTACUpload.clickHereBankForCustomers"></span></a> --></div></div></div></div></section></div></div>');
$templateCache.put('app/entities/clearcorp-trades-outstanding-report/clearcorp-trades-outstanding-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.tradesOutstandingReport.title"></h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapsePendingOrder = !vm.ExpandOrCollapsePendingOrder" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#TradesOutstandingReport"><img ng-src="{{vm.ExpandOrCollapsePendingOrder == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.clearcorpTradesOutstandingReport.criteria">Criteria</span></a></h4></div><div id="TradesOutstandingReport" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="clearcorpTradesOutstandingReportForm"><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.clearcorpTradesOutstandingReport.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="nonTerminatedBanks" display-column="bankName" placeholder="" form="clearcorpTradesOutstandingReportForm"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.clearcorpTradesOutstandingReport.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="activeBranchesForBank" display-column="branchName" placeholder="" form="clearcorpTradesOutstandingReportForm" filter-value="{{vm.bank.id}}"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.clearcorpTradesOutstandingReport.customer"></span></label><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="allNonTerminatedCustomers" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" control-place-holder="Enter Customer ID or Name" display-column="customerCode,customerName" placeholder="" form="clearcorpTradesOutstandingReportForm"><span class="cutomer-highlight" ng-if="vm.customer.customerMiddleName==null">{{vm.customer.customerFirstName+\' \'+vm.customer.customerLastName}}</span> <span class="cutomer-highlight" ng-if="vm.customer.customerMiddleName!=null">{{vm.customer.customerFirstName+\' \'+ vm.customer.customerMiddleName+\' \'+vm.customer.customerLastName}}</span></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\'"><label class="control-label"><span data-translate="gatewayApp.clearcorpTradesOutstandingReport.currencyPair"></span></label><cspl-ach control-model="vm.currencyPair" control-id="txtCurrencyPair" lookup-name="currencyPair" display-column="code" placeholder="" form="clearcorpTradesOutstandingReportForm" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.clearcorpTradesOutstandingReport.instrument"></span></label><select name="select" class="form-control select-style non-mandatory" ng-model="vm.instrument" style="border-color:#595959" ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id"><option value="">--All--</option></select></div></div><div class="form-group"><div class="row"><label class="col-md-offset-3 control-label col-xs-8 col-sm-7 col-md-6" cspl-mandatory><span data-translate="gatewayApp.clearcorpTradesOutstandingReport.reportPeriod"></span></label><div class="col-md-offset-3 col-xs-10 col-sm-9 col-md-5"><div style="width: 100%"><div style="width: 50%; display: table-cell; padding-right: 8px"><cspl-dtp control-model="vm.fromSetDate" control-id="dtpFromDate" form="clearcorpTradesOutstandingReportForm" control-min-date="vm.currentDate" required></div><div style="width: 50%; display: table-cell; padding-left: 8px"><cspl-dtp control-model="vm.toSetDate" control-id="dtpToDate" form="clearcorpTradesOutstandingReportForm" control-min-date="vm.currentDate" required></div></div></div><div class="col-md-1 col-sm-1 col-xs-2"><button class="btn btn-info active" ng-disabled="clearcorpTradesOutstandingReportForm.$invalid||vm.clicked" ng-click="vm.getTradesOutstanding()" data-toggle="collapse" data-target="#TradesOutstandingReport" data-translate="gatewayApp.clearcorpTradesOutstandingReport.go"></button></div></div></div></form></div></div></div><div ng-show="vm.clearcorpTradesOutstandingReportDetails.length > 0"><div class="row"><div class="up-btn"><div class="dropdown" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportDataToCsvFile()">CSV</a></li><li><a ng-click="vm.exportDataToExcelFile();">XLS</a></li></ul></div></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="clearcorpTradesOutstandingReport" class="dataTable table table-striped table-hover"><thead><tr><th class="td-text-align-right padding-right-10">S.No.</th><th class="min-width-100" data-translate="gatewayApp.clearcorpTradesOutstandingReport.bank"></th><th class="min-width-100" data-translate="gatewayApp.clearcorpTradesOutstandingReport.branch"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.branchId"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.custId"></th><th class="min-width-100" data-translate="gatewayApp.clearcorpTradesOutstandingReport.customer"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.currencyPair"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.instrument"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.tradeType"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.buySell"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.tradeSettlementDateFrom"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.settlementDate"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.clearcorpTradesOutstandingReport.tradedQuantityUSD"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.clearcorpTradesOutstandingReport.tradePrice"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.clearcorpTradesOutstandingReport.netTradePrice"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.clearcorpTradesOutstandingReport.tradeValueINR"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.clearcorpTradesOutstandingReport.cancelledQuantityUSD"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.clearcorpTradesOutstandingReport.rolledOverQualityUSD"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.clearcorpTradesOutstandingReport.earlySettledQuantityUSD"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.clearcorpTradesOutstandingReport.outstandingQuantityUSD"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.clearcorpTradesOutstandingReport.blockedQuantityUSD"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.tradeStatus"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.tradeDateTime"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.tradeNo"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.orderNo"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.originalTradeNo"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.userRemarks1"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.userRemarks2"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.userRemarks3"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.userRemarks4"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.exposureType"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.exposureSubType"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.lastActionedBy"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.deliveryMode"></th><th data-translate="gatewayApp.clearcorpTradesOutstandingReport.source"></th></tr></thead><tbody><tr ng-repeat="outstandingTrade in filterData = (vm.clearcorpTradesOutstandingReportDetails | filter : filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td class="td-text-align-right">{{filterData.indexOf(outstandingTrade) + 1}}</td><td><span>{{outstandingTrade.bankName}}</span></td><td><span>{{outstandingTrade.branchName}}</span></td><td><span>{{outstandingTrade.branchCode}}</span></td><td><span>{{outstandingTrade.customerCode}}</span></td><td><span>{{outstandingTrade.customerName}}</span></td><td><span>{{outstandingTrade.currencyPair}}</span></td><td><span>{{outstandingTrade.instrumentCode}}</span></td><td><span>{{outstandingTrade.eventTypeName}}</span></td><td><span ng-show="outstandingTrade.buySellIndicator==\'BUYY\'">Buy</span> <span ng-show="outstandingTrade.buySellIndicator==\'SELL\'">Sell</span></td><td><span ng-if="outstandingTrade.tradeSettlementDateFrom !=null">{{outstandingTrade.tradeSettlementDateFrom| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="outstandingTrade.tradeSettlementDateFrom ==null">{{\'\'}}</span></td><td><span>{{outstandingTrade.tradeSettlementDate | date:\'dd-MMM-yyyy\'}}</span></td><td class="td-text-align-right"><span>{{outstandingTrade.tradeAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span>{{outstandingTrade.tradedExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td class="td-text-align-right"><span ng-if="outstandingTrade.buySellIndicator==\'BUYY\'">{{outstandingTrade.tradedExchangeRate + outstandingTrade.markupRate | number:vm.noOfDecimalsForRate}}</span> <span ng-if="outstandingTrade.buySellIndicator==\'SELL\'">{{outstandingTrade.tradedExchangeRate - outstandingTrade.markupRate | number:vm.noOfDecimalsForRate}}</span></td><td class="td-text-align-right"><span>{{outstandingTrade.tradedValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span>{{outstandingTrade.cancelledAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span>{{outstandingTrade.rolledoverAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span>{{outstandingTrade.earlysettledAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span>{{outstandingTrade.outStandingAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span>{{outstandingTrade.blockedAmount | number:vm.noOfDecimalsForAmount}}</span></td><td><span>{{outstandingTrade.tradeStatusName}}</span></td><td style="min-width: 130px"><span>{{outstandingTrade.tradeTime | date:\'dd-MMM-yyyy HH:mm:ss\'}}</span></td><td class="td-text-align-right"><span>{{outstandingTrade.tradeSequenceNumber}}</span></td><td class="td-text-align-right"><span><a ui-sref="order-activity-report-from-trades-os({orderNumber:outstandingTrade.orderSequenceNumber})" style="text-decoration: underline">{{outstandingTrade.orderSequenceNumber}}</a></span></td><td class="td-text-align-right"><span ng-if="outstandingTrade.sourceTradeNumber!=0">{{outstandingTrade.sourceTradeNumber}}</span></td><td style="min-width:360px"><span>{{outstandingTrade.userRemarks || \'-\'}}</span></td><td style="min-width:360px"><span>{{outstandingTrade.remarks2 || \'-\'}}</span></td><td style="min-width:360px"><span>{{outstandingTrade.remarks3 || \'-\'}}</span></td><td style="min-width:360px"><span>{{outstandingTrade.remarks4 || \'-\'}}</span></td><td><span>{{outstandingTrade.exposureTypeName || \'-\'}}</span></td><td><span>{{outstandingTrade.exposureSubTypeName || \'-\'}}</span></td><td><span>{{outstandingTrade.lastActionedBy}}</span></td><td><span>{{outstandingTrade.deliveryMode}}</span></td><td><span>{{outstandingTrade.sourceAppName}}</span></td></tr></tbody></table></div><div class="row padding-top-10"><span class="help-block right-floating" data-translate="gatewayApp.clearcorpTradesOutstandingReport.originalTradeLegend"></span></div><div ng-show="vm.clearcorpTradesOutstandingReportDetails.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="table-responsive" ng-show="vm.clearcorpTradesOutstandingReportDetails.length==0"><span>No record found</span></div></div></section></div><script src="assets/js/tables.js"></script><style>.total-bar {\r\n\tbackground-color: #1a260e !important;\r\n}\r\n\r\n.total-bar:hover {\r\n\tbackground: #1a260e !important;\r\n\tcolor: #F2F2F2 !important;\r\n}</style></div>');
$templateCache.put('app/entities/clearcorp-trades-report/clearcorp-trades-report.html','<!-- this screen view for all entity --><div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.tradesForTheDayReport.title" data-translate-values="{value: {{vm.todayDate}}}"></h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapsePendingOrder = !vm.ExpandOrCollapsePendingOrder" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#TradesReport"><img ng-src="{{vm.ExpandOrCollapsePendingOrder == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.clearcorptradesReport.criteria">Criteria</span></a></h4></div><div id="TradesReport" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="clearcorptradesReportForm"><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\'"><label class="control-label"><span data-translate="gatewayApp.clearcorptradesReport.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="nonTerminatedBanks" display-column="bankName" placeholder="" form="clearcorptradesReportForm"></div><div class="form-group" ng-if="vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'"><label class="control-label"><span data-translate="gatewayApp.clearcorptradesReport.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtTradingbank" lookup-name="tradingBank" display-column="shortName" placeholder="" form="clearcorptradesReportForm" filter-value="{{vm.loggedInCustomer}}"></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\'"><label class="control-label"><span data-translate="gatewayApp.clearcorptradesReport.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="activeBranchesForBank" display-column="branchName" placeholder="" form="clearcorptradesReportForm" filter-value="{{vm.bank.id}}"></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\'"><label class="control-label"><span data-translate="gatewayApp.clearcorptradesReport.customer"></span></label><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="allNonTerminatedCustomers" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" control-place-holder="Enter Customer ID or Name" display-column="customerCode,customerName" placeholder="" form="clearcorptradesReportForm"><span class="cutomer-highlight" ng-if="vm.customer.customerMiddleName==null">{{vm.customer.customerFirstName+\' \'+vm.customer.customerLastName}}</span> <span class="cutomer-highlight" ng-if="vm.customer.customerMiddleName!=null">{{vm.customer.customerFirstName+\' \'+ vm.customer.customerMiddleName+\' \'+vm.customer.customerLastName}}</span></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.clearcorptradesReport.currencyPair"></span></label><cspl-ach control-model="vm.currencyPair" control-id="txtCurrencyPair" lookup-name="currencyPair" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}" display-column="code" placeholder="" form="clearcorptradesReportForm"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.clearcorptradesReport.instrument"></span></label><cspl-ach control-model="vm.instrument" control-id="txtInstrument" lookup-name="marketInstrumentsCurrency" filter-value="{{ vm.currencyPair.id ? vm.currencyPair.id : 0 }}" display-column="instrumentCode" placeholder="" form="clearcorptradesReportForm"></div></div><div class="form-group"><div class="row"><label class="col-md-offset-3 control-label col-xs-8 col-sm-7 col-md-6" cspl-mandatory><span data-translate="gatewayApp.clearcorptradesReport.reportPeriod"></span></label><div class="col-md-offset-3 col-xs-10 col-sm-9 col-md-5"><!--  <cspl-from-to-time-picker from-model = "vm.fromTime" to-model="vm.toTime"   time-difference="vm.duration"  control-id = "timerTxt" control-required="true" max-value-for-from="vm.maxDate" \r\n \t\t\t\t\t\t\t\t\t\t\t\tcontrol-from-disabled= "false" control-to-disabled= "true" control24HrFormat = "false" form="clearcorptradesReportForm" set-default-values="true">\r\n\t\t\t\t\t\t\t\t\t\t\t</cspl-from-to-time-picker>\t--><div style="width: 100%"><div style="width: 50%; display: table-cell; padding-right: 8px"><cspl-time-picker control-model="vm.fromTime" control-id="fromTimer" time-zone="timeZone" control-required="true" control-disabled="false" control24hrformat="false" form="clearcorptradesReportForm" vertical-position="top"></cspl-time-picker></div><div style="width: 50%; display: table-cell; padding-left: 8px"><cspl-time-picker control-model="vm.toTime" control-id="toTimer" time-zone="timeZone" control-required="true" control-disabled="false" control24hrformat="false" form="clearcorptradesReportForm" vertical-position="top"></cspl-time-picker></div></div></div><div class="col-md-1 col-sm-1 col-xs-2"><button class="btn btn-info active" ng-disabled="clearcorptradesReportForm.$invalid||vm.clicked" ng-click="vm.getTrades();" data-toggle="collapse" data-target="#TradesReport" data-translate="gatewayApp.clearcorptradesReport.go"></button></div></div></div></form></div></div></div><div ng-show="vm.clearcorptradesReportDetails.length > 0"><div class="row"><div class="up-btn"><div class="dropdown" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportDataToCsvFile()">CSV</a></li><li><a ng-click="vm.exportDataToExcelFile();">XLS</a></li><li><a ng-click="vm.exportDataToPdfFile()">PDF</a></li></ul></div></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="clearcorptradesReport" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.clearcorptradesReport.bank" style="min-width: 90px"></th><th data-translate="gatewayApp.clearcorptradesReport.branch" style="min-width: 90px"></th><th data-translate="gatewayApp.clearcorptradesReport.custId"></th><th data-translate="gatewayApp.clearcorptradesReport.customer" style="min-width: 90px"></th><th data-translate="gatewayApp.clearcorptradesReport.currencyPair"></th><th data-translate="gatewayApp.clearcorptradesReport.inst"></th><th data-translate="gatewayApp.clearcorptradesReport.tradeType"></th><th data-translate="gatewayApp.clearcorptradesReport.settlementLeg"></th><th data-translate="gatewayApp.clearcorptradesReport.sourceTradeNo"></th><th data-translate="gatewayApp.clearcorptradesReport.buySell"></th><th data-translate="gatewayApp.clearcorptradesReport.tradeSettlementDateFrom"></th><th data-translate="gatewayApp.clearcorptradesReport.settDate"></th><th data-translate="gatewayApp.clearcorptradesReport.tradeNo"></th><th data-translate="gatewayApp.clearcorptradesReport.orderNumber"></th><th class="td-text-align-right" style="padding-right: 10px" data-translate="gatewayApp.clearcorptradesReport.tradedQuantity"></th><th class="td-text-align-right" style="padding-right: 10px" data-translate="gatewayApp.clearcorptradesReport.grossRate"></th><th class="td-text-align-right" style="padding-right: 10px" data-translate="gatewayApp.clearcorptradesReport.swapPtsInPaise"></th><th class="td-text-align-right" style="padding-right: 10px" data-translate="gatewayApp.clearcorptradesReport.equivalentSpotTradePrice"></th><th class="td-text-align-right" style="padding-right: 10px" data-translate="gatewayApp.clearcorptradesReport.netTradePrice"></th><th class="td-text-align-right" style="padding-right: 10px" data-translate="gatewayApp.clearcorptradesReport.tradedQuantityINR"></th><th data-translate="gatewayApp.clearcorptradesReport.tradeDateTime"></th><th ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.clearcorptradesReport.counterPartyBank" style="min-width: 90px"></th><th data-translate="gatewayApp.clearcorptradesReport.exposureType"></th><th data-translate="gatewayApp.clearcorptradesReport.exposureSubType"></th><th style="min-width:360px" data-translate="gatewayApp.clearcorptradesReport.userRemarks1"></th><th style="min-width:360px" data-translate="gatewayApp.clearcorptradesReport.userRemarks2"></th><th style="min-width:360px" data-translate="gatewayApp.clearcorptradesReport.userRemarks3"></th><th style="min-width:360px" data-translate="gatewayApp.clearcorptradesReport.userRemarks4"></th><th data-translate="gatewayApp.clearcorptradesReport.lastActionedBy"></th><th data-translate="gatewayApp.clearcorptradesReport.userMobileNo"></th><th data-translate="gatewayApp.clearcorptradesReport.deliveryMode"></th><th data-translate="gatewayApp.clearcorptradesReport.source"></th><th ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.clearcorptradesReport.fcyInrPrice"></th><th ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.clearcorptradesReport.fcyUsdPrice"></th><th ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.clearcorptradesReport.adjustedUsdInr"></th><th ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.clearcorptradesReport.fcyUsdSwapPoints"></th><th ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.clearcorptradesReport.usdInrSwapPoints"></th><th ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.clearcorptradesReport.uniqueRequestId"></th><th>&nbsp;</th></tr></thead><tbody><tr ng-repeat="trade in filterData = (vm.clearcorptradesReportDetails | filter : filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break: break-word">{{trade.bankName}}</td><td style="word-break: break-word">{{trade.branchName}}</td><td style="word-break: break-word">{{trade.customerCode}}</td><td style="word-break: break-word">{{trade.customerName}}</td><td style="min-width:100px">{{trade.currencyPair}}</td><td>{{trade.instrumentCode}}</td><td>{{trade.eventTypeName}}</td><td>{{trade.settlementLegName}}</td><td ng-if="trade.sourceTradeNumber != null && trade.sourceTradeNumber != 0"><a ui-sref="order-activity-report-from-trades({orderNumber:trade.sourceOrderNumber})" style="text-decoration: underline">{{trade.sourceTradeNumber}}</a></td><td ng-if="!(trade.sourceTradeNumber != null && trade.sourceTradeNumber != 0)">{{\' \'}}</td><td><span ng-show="trade.buySellIndicator==\'BUYY\'">Buy</span> <span ng-show="trade.buySellIndicator==\'SELL\'">Sell</span></td><td><span ng-if="trade.tradeSettlementDateFrom !=null">{{trade.tradeSettlementDateFrom| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="trade.tradeSettlementDateFrom ==null">{{\'\'}}</span></td><td><span>{{trade.tradeSettlementDate|\tdate:\'dd-MMM-yyyy\'}}</span></td><td>{{trade.tradeSequenceNumber}}</td><td><span><a ui-sref="order-activity-report-from-trades({orderNumber:trade.orderSequenceNumber})" style="text-decoration: underline">{{trade.orderSequenceNumber}}</a></span></td><td class="td-text-align-right" style="padding-right: 10px">{{trade.tradedAmount | number:vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right" style="padding-right: 10px"><span>{{trade.tradedExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td class="td-text-align-right" style="padding-right: 10px"><span>{{vm.getSwapPoints(trade.spottradedExchangeRate, trade.tradedExchangeRate) | number:vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right" style="padding-right: 10px"><span>{{trade.spottradedExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td class="td-text-align-right" style="padding-right: 10px"><span ng-if="trade.buySellIndicator==\'BUYY\'">{{trade.tradedExchangeRate + trade.markupValue | number:vm.noOfDecimalsForRate}}</span> <span ng-if="trade.buySellIndicator==\'SELL\'">{{trade.tradedExchangeRate - trade.markupValue | number:vm.noOfDecimalsForRate}}</span></td><td class="td-text-align-right" style="padding-right: 10px"><span>{{trade.tradedValue | number:vm.noOfDecimalsForAmount}}</span></td><td nowrap="nowrap" style="padding-right: 10px"><span>{{trade.tradeTime| date:\'dd-MM-yyyy HH:mm:ss\'}}</span></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" style="word-break: break-word">{{trade.counterBranchIdentity}}</td><td>{{trade.exposureTypeName || \'-\'}}</td><td>{{trade.exposureSubTypeName || \'-\'}}</td><td style="min-width:360px">{{trade.userRemarks || \'-\'}}</td><td style="min-width:360px">{{trade.remarks2 || \'-\'}}</td><td style="min-width:360px">{{trade.remarks3 || \'-\'}}</td><td style="min-width:360px">{{trade.remarks4 || \'-\'}}</td><td>{{trade.retailUserCode}}</td><td>{{trade.userMobileCountryCode}}-{{trade.userMobile}}</td><!-- <td><div class="align-deal-icon-up"><span class="deal-ticket-freeze icon_ribbon"\r\n\t\t\t\t\t\t\t\t\t\tng-click="vm.printDealTicket(trade);"></span></div></td> --><td style="min-width:100px">{{trade. deliveryMode}}</td><td style="min-width:100px">{{trade. sourceAppName}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" style="min-width:100px">{{trade.fcyInrPrice}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" style="min-width:100px">{{trade.fcyUsdPrice}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" style="min-width:100px">{{trade.adjustedUsdInr}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" style="min-width:100px">{{trade.fcyUsdSwapPoints}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" style="min-width:100px">{{trade.usdInrSwapPoints}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" style="min-width:100px">{{trade.uniqueRequestId}}</td><td class="sticky-col" style="text-align:right"><span class=""><img title="Deal Ticket" class="dealTicket dealTicket-noHover" src="assets/images/Deal ticket-20.png" ng-click="vm.printDealTicket(trade);"> <img title="Deal Ticket" class="dealTicket dealTicket-Hover" src="assets/images/Deal ticket_Black-20.png" ng-click="vm.printDealTicket(trade);"></span></td></tr></tbody></table></div><div class="padding-top-10"><div class="row"><span class="help-block right-floating" data-translate="gatewayApp.clearcorptradesReport.finalPrice"></span></div><div class="row"><span class="help-block right-floating" data-translate="gatewayApp.clearcorptradesReport.originalTradeLegend"></span></div></div><div ng-show="vm.clearcorptradesReportDetails.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="table-responsive" ng-show="vm.clearcorptradesReportDetails.length==0"><span>No record found</span></div></div></section></div><script src="assets/js/tables.js"></script><style>.total-bar {\r\n\tbackground-color: #1a260e !important;\r\n}\r\n\r\n.total-bar:hover {\r\n\tbackground: #1a260e !important;\r\n\tcolor: #F2F2F2 !important;\r\n}</style></div>');
$templateCache.put('app/entities/contact-us/contact-us.html','<div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="global.menu.contactUs.title"></span></h4></div><div class="modal-body" style="height: 250px"><div class="content"><div id="accordian"><div class="criteria"><h4 class="panel-title" style="width: 400px;  margin-bottom: 24px; font-size: 18px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseAuditLog = !vm.ExpandOrCollapseAuditLog" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#contactDetails"><img ng-src="{{vm.ExpandOrCollapseAuditLog == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="login.contactDetails"></span></a></h4></div><div id="contactDetails" ng-class="{\'collapse in\':vm.valid}" style="background-color: black; font-size: 18px"><div class="row"><p class="col-xs-offset-1 margin-bottom-0"><span class=""><img class="" src="assets/images/Support_Call-24_02.png" alt="Support" title="FX-Retail Support Contact No"> </span>&nbsp;&nbsp; <span class="" data-translate="login.supportContactNo1"></span> &nbsp;<span class="" data-translate="login.tollFree"></span> &nbsp;<span class="" data-translate="login.supportContactOR"></span> &nbsp;<span class="" data-translate="login.supportContactNo2"></span></p></div><br><div class="row"><p class="col-xs-offset-1 margin-bottom-0"><span class=""><img class="" src="assets/images/Mail-24_01.png" alt="Support" title="FX-Retail Email"> </span>&nbsp;&nbsp; <span class="" data-translate="login.supportMail"></span></p></div><br></div></div></div></div>');
$templateCache.put('app/entities/credit-factor-setings-report/credit-factor-settings-report-view.html','<div class="container-fluid"><div ncy-breadcrumb></div><!-- <h2 class="view-title" ><span data-translate="gatewayApp.creditFactorSettings.headerTitle"></span><span>{{vm.reportDate|date :\'dd-MMM-yyyy\'}}</span></h2> --><nmb-alert></nmb-alert><div class="col-lg-12"><section class="item" style="padding:5px"><div class="panel panel-primary"><div class="panel-heading text-left"><h2 class="view-title"><span data-translate="gatewayApp.creditFactorSettings.headerTitle"></span> <a href="" style="position: relative;float:right;  color: #fff" ng-class="{\'linkDisabled\' : vm.isRefreshDisabled}"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="!vm.isRefreshDisabled?refresh():\'\';" style="font-size:20px"></i></a></h2></div><div class="panel-body"><div class="module-content-inner"><!-- <div class="row">\r\n\t\t\t\t\t<label class="control-label font-16-px" ><span  data-translate="gatewayApp.creditFactorSettings.overAllSummary"></span></label>\r\n\t\t\t\t</div> --><div ng-if="vm.creditFactorSettingsList.length>0"><div class="row"><div class="pull-left"><cspl-table-export table-name="cfSettings" total-record-count="vm.creditFactorSettingsList.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="vm.filterText" page-no="page" file-name="CF_Settings_View"></cspl-table-export></div><cspl-table-search control-model="vm.filterText" class="col-md-2 col-sm-3 col-xs-4 float-right"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="cfSettings" name="cfSettings" class="dataTable table table-striped table-hover"><thead><tr><th class="td-text-align-left" data-translate="gatewayApp.creditFactorSettings.bank"></th><th class="td-text-align-left" data-translate="gatewayApp.creditFactorSettings.tenorType"></th><th class="td-text-align-right" data-translate="gatewayApp.creditFactorSettings.from"></th><th class="td-text-align-right" data-translate="gatewayApp.creditFactorSettings.to"></th><th class="td-text-align-right" data-translate="gatewayApp.creditFactorSettings.creditFactor"></th><th class="td-text-align-left" data-translate="gatewayApp.creditFactorSettings.lastModifiedDate"></th><th class="td-text-align-left" data-translate="gatewayApp.creditFactorSettings.modifiedBy"></th></tr></thead><tbody><tr ng-repeat="creditSettings in vm.filterData = (vm.creditFactorSettingsList | filter : vm.filterText) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break:break-word">{{creditSettings.customBank.bankName}}</td><td style="word-break:break-word">{{creditSettings.tenorType}}</td><td class="td-text-align-right">{{creditSettings.tenorFrom | number : 0}}</td><td class="td-text-align-right">{{creditSettings.tenorTo | number : 0 }}</td><td class="td-text-align-right">{{creditSettings.creditFactor | number : 2}}</td><td class="">{{ (creditSettings.lastModifiedDate | date:\'dd-MMM-yyyy\') || \'-\' }}</td><td style="word-break:break-word">{{creditSettings.lastModifiedBy || \'-\' }}</td></tr></tbody></table></div><div ng-show="vm.filterData.length > 0"><cspl-pagination record-count="vm.filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><div ng-show="vm.filterData.length == 0"><span>No record found</span></div></div><div ng-if="vm.creditFactorSettingsList.length==0"><span>No record found</span></div></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/credit-factor-settings/credit-factor-settings-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="creditFactorSettingsForm" role="form" novalidate><div class="modal-header"><!-- <button ng-show="userPreference.showInfoIcon==\'yes\'" type="button" class="close" style="margin-right: 25px;" data-toggle="popover" data-trigger="focus"  data-placement="left" data-content="This CF setting screen will help to set Credit Factor in Days or Months">\r\n\t\t<span class="icon" ><img class="width-height-20" src="assets/images/Info-24.png" /></span>\r\n\t</button> --> <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="This CF setting screen will help to set Credit Factor in Days or Months" tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="global.menu.creditFactorSettings.editCreditFactorSettings"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><br><div class="row"><div class="col-sm-2 right-label-div"><label class="control-label"><span data-translate="gatewayApp.creditFactorSettings.tenorsIn"></span></label></div><div class="col-sm-2"><select class="form-control select-style" control-id="seltype" ng-model="vm.creditFactorSettingsHeader.tenorType" ng-options="x for x in vm.tenorTypeList track by x" form="limitchangerequestform" ng-disabled="DisabledControl"><option selected="selected" disabled="disabled" hidden style="display: none" value=""></option></select></div></div><br><div><div class="row"><table class="dataTable table table-striped table-hover"><thead><tr><th class="td-text-align-right"><span data-translate="gatewayApp.creditFactorSettings.from"></span>&nbsp;<span>({{vm.creditFactorSettingsHeader.tenorType}})</span></th><th class="td-text-align-right"><span data-translate="gatewayApp.creditFactorSettings.to"></span>&nbsp;<span>({{vm.creditFactorSettingsHeader.tenorType}})</span></th><th class="td-text-align-right" data-translate="gatewayApp.creditFactorSettings.creditFactor"></th><th></th></tr></thead><tbody><tr ng-repeat="creditFactor in vm.creditFactorSettingsDetailsList"><td class="td-text-align-right" style="padding-bottom:0px !important"><span ng-hide="creditFactor.editable">{{creditFactor.tenorFrom | number: 0}}</span><div ng-show="creditFactor.editable"><cspl-numeric control-model="creditFactor.tenorFrom" control-id="txtTenorFrom" no-of-decimals="0" form="creditFactorSettingsForm" control-required="true" control-disabled="true"></cspl-numeric></div></td><td class="td-text-align-right" style="padding-bottom:0px !important"><span ng-hide="creditFactor.editable">{{creditFactor.tenorTo | number: 0}}</span><div ng-show="creditFactor.editable"><cspl-numeric control-model="creditFactor.tenorTo" control-id="txtTenorTo_{{$index}}" control-min="1" no-of-decimals="0" control-max="999999999999.99" form="creditFactorSettingsForm" control-required="true"></cspl-numeric><span class="help-block-warning-error" ng-show="errorMessage!=\'\' && errorMessage!=undefined && errorMessage!=null">{{errorMessage}}</span></div></td><td class="td-text-align-right" style="padding-bottom:0px !important"><span ng-hide="creditFactor.editable">{{creditFactor.creditFactor | number : 2}}</span><div ng-show="creditFactor.editable"><cspl-numeric control-model="creditFactor.creditFactor" control-id="txtCreditFactor_{{$index}}" control-min="1" control-max="100" no-of-decimals="2" form="creditFactorSettingsForm" control-required="true"></cspl-numeric></div></td><td style="padding-bottom:5px !important; padding-top:5px" nowrap="nowrap"><div><button class="btn btn-xs btn-primary btn-no-border" ng-show="!creditFactor.editable" ng-click="vm.editCreditFactorSettings($index)" ng-disabled="DisabledControl"><span class="glyphicon glyphicon-pencil" title="Edit"></span></button> <button class="btn btn-xs btn-primary btn-no-border" ng-show="!creditFactor.editable" ng-click="vm.removeCreditFactorSettings($index)" ng-disabled="DisabledControl"><span class="glyphicon glyphicon-trash" title="Delete"></span></button> <button style="margin-top:9px" class="btn btn-xs btn-primary btn-no-border" ng-show="creditFactor.editable" ng-click="vm.addCreditFactorSettings($index)" ng-disabled="creditFactor.tenorFrom == null|| creditFactor.tenorTo == null || creditFactor.creditFactor == null"><span class="glyphicon glyphicon-ok" ng-class="{\'glyphicon-ok-colored\': creditFactor.tenorFrom != null && creditFactor.tenorTo != null && creditFactor.creditFactor != null}" title="Add"></span></button> <button style="margin-top:9px" class="btn btn-xs btn-primary btn-no-border" ng-show="creditFactor.editable" ng-click="vm.resetCreditFactorSettings($index)" ng-disabled="creditFactor.tenorFrom == null|| creditFactor.tenorTo == null || creditFactor.creditFactor == null"><span class="glyphicon glyphicon-remove" ng-class="{\'glyphicon-remove-colored\': creditFactor.tenorFrom != null && creditFactor.tenorTo != null && creditFactor.creditFactor != null}" title="Remove"></span></button></div></td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="vm.creditFactorSettingsHeader.tenorType == null || vm.clicked || vm.creditFactorSettingsDetailsList.length <2" ng-click="vm.clicked = true;vm.resubmitCreditFactorSettings();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="vm.creditFactorSettingsHeader.tenorType == null  || vm.clicked || vm.creditFactorSettingsDetailsList.length <2" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardCreditFactorSettings()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectCreditFactorSettings()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveCreditFactorSettings();vm.clicked=true;" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/credit-factor-settings/credit-factor-settings.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.creditFactorSettings.title"></span> <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="This screen will help to set Credit (Risk) Factor in Days and Months, which will be applicable to Forward Contracts. For Upto Spot instrument, it sill remain 100% as existing. If limit is set as 10,000 and CF is 10% then if user placed order of 5,000 then only 500 limit will be utilised for subjected trade." tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></h2><nmb-alert></nmb-alert><div><!-- <nmb-alert-error></nmb-alert-error>  --></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><div class="dropdown" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\')">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div></div><div class="float-right col-md-2 col-sm-3 col-xs-4"><cspl-table-search control-model="vm.filterText"></cspl-table-search></div></div><div class="bootstrap-tableresponsive"><table id="creditFactorSettings" class="dataTable table table-striped table-hover"><thead><tr><th class="tableNumericColumn"><span>From ({{vm.creditFactorSettingsHeader.tenorType}})</span></th><th class="tableNumericColumn"><span>To ({{vm.creditFactorSettingsHeader.tenorType}})</span></th><th class="tableNumericColumn" data-translate="gatewayApp.creditFactorSettings.creditFactor"></th><th></th></tr></thead><tbody><tr ng-repeat="creditFactorSettings in filterData = (vm.creditFactorSettingsDetailsList| filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td class="tableNumericColumn">{{creditFactorSettings.tenorFrom | number : 0}}</td><td class="tableNumericColumn">{{creditFactorSettings.tenorTo | number : 0}}</td><td class="tableNumericColumn">{{creditFactorSettings.creditFactor | number : 2}}</td><td width="10%" style="text-align:right"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitCreditFactorSettingsEditEntityAction"><a ng-click="vm.editCreditFactor(creditFactorSettings.creditFactorSettingsHeader.id);"><span data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table><div style="padding:5px" ng-show="vm.creditFactorSettingsDetailsList.length==0"><span>No record found</span></div><div ng-show="vm.creditFactorSettingsDetailsList.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/customer-bank-relationship-report/customer-bank-relationship-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.customer.customerBankRelationshipReport"></span></h2><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="module-wrapper"><section class="module"><div class="module-inner"><h3 class="col-md-6 control-label title-label"><span data-translate="gatewayApp.BankRelationship.tradingBanks"></span></h3><div class="table-responsive"><div class="row"><div class="pull-right"><button type="button" class="btn btn-info active" ng-click="vm.screenLog.screenLog(vm.screenName,0, vm.entityConstants.ENTITY_ACTION_TYPE.ADD);vm.launch()" ng-show="vm.permitCustomerBankRelationshipAddEntityAction"><img ng-src="assets/images/Add.png"> <span data-translate="gatewayApp.BankRelationship.bank"></span></button><div class="col-md-6 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left" ng-show="vm.tradingBanks.length > 0"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition" ng-show="vm.tradingBanks.length > 0">|</span><div class="pull-left" ng-show="vm.tradingBanks.length > 0"><div class="dropdown col-md-3" style="width: 10%;padding-left: 0px"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div><!-- <cspl-table-export table-name="tradingBanks" total-record-count="vm.tradingBanks.length"\r\n\t\t\t\t\t\t\t\t no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Trading_Banks"></cspl-table-export> --></div></div><div class="table-responsive" ng-show="vm.tradingBanks.length > 0"><div style="margin-left:5px"></div><table id="tradingBanks" class="dataTable table table-striped table-hover"><thead><tr><th><span data-translate="gatewayApp.BankRelationship.bankName"></span></th><th><span data-translate="gatewayApp.BankRelationship.homeBranchIfsc"></span></th><th><span data-translate="gatewayApp.BankRelationship.tradingBranchIfsc"></span></th><th><span data-translate="gatewayApp.BankRelationship.status"></span></th><th></th><th></th></tr></thead><tbody><tr style="background-color:#38772D" ng-repeat="tradingBank in filterData = (vm.tradingBanks | filter : filterText)  | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td width="15%"><span>{{tradingBank.bank.bankName}}</span> &nbsp;\t<span class="fa fa-star" aria-hidden="true" style="font-size:13px" ng-show="tradingBank.bank.bankName==vm.customerBank"></span></td><td width="15%">{{tradingBank.homeBranch.ifscCode}}</td><td width="15%">{{tradingBank.tradingBranch.ifscCode}}</td><td width="15%">{{tradingBank.entityRestrictionStatus.displayName}}</td><td width="5%" align="center"><span style="color: #FFAA1D" class="glyphicon glyphicon-file" ng-click="vm.openAnnexure2(tradingBank.id)" title="View Terms and Conditions"></span></td><td width="5%" align="center"><span ng-show="vm.permitCustomerBankRelationshipRemoveEntityAction" ng-click="vm.deleteRelationship(tradingBank.id);vm.screenLog.screenLog(vm.screenName,tradingBank.id,vm.entityConstants.ENTITY_ACTION_TYPE.REMOVE)" class="icon icon_trash" title="Delete Relationship"></span></td></tr></tbody></table></div></div><div class="table-responsive" ng-show="vm.tradingBanks.length==0"><span>No record found</span></div><div ng-show="filterData.length > noOfRecordsPerPage"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><div class="row"><h3 class="col-md-10 control-label title-label"><span data-translate="gatewayApp.BankRelationship.pendingApprovalBanks"></span></h3><div class="table-responsive" ng-show="vm.pendingAndRejectedBanks.length > 0"><div style="margin-left:5px"></div><table id="pendingApprovalBanks" class="dataTable table table-striped table-hover"><thead><tr><th><span data-translate="gatewayApp.BankRelationship.bankName"></span></th><th><span data-translate="gatewayApp.BankRelationship.homeBranchIfsc"></span></th><th><span data-translate="gatewayApp.BankRelationship.tradingBranchIfsc"></span></th><th><span data-translate="gatewayApp.BankRelationship.actionType"></span></th><th nowrap="nowrap"><span data-translate="gatewayApp.BankRelationship.regReqNo"></span></th><th></th></tr></thead><tbody><tr style="background-color:#A95807" ng-repeat="pendingAndRejectedBank in filterData1 = (vm.pendingAndRejectedBanks | filter : customFilter | filter: filterText)  | limitTo:noOfRecordsPerPage1:noOfRecordsPerPage1*(page1-1)"><td width="15%">{{pendingAndRejectedBank.bank.bankName}}</td><td width="15%">{{pendingAndRejectedBank.homeBranch.ifscCode}}</td><td width="15%">{{pendingAndRejectedBank.tradingBranch.ifscCode}}</td><td width="10%">{{pendingAndRejectedBank.actionType}}</td><td width="10%">{{pendingAndRejectedBank.requestReferenceNumber}}</td><td width="5%" align="center"><span ng-show="vm.permitCustomerBankRelationshipWithdrawEntityAction" ng-click=" vm.withdrawRequest(pendingAndRejectedBank.id);vm.screenLog.screenLog(vm.screenName,pendingAndRejectedBank.id,vm.entityConstants.ENTITY_ACTION_TYPE.WITHDRAW)" class="icon icon_trash" title="Withdraw Request"></span></td></tr></tbody></table></div></div><div ng-show="filterData1.length > noOfRecordsPerPage1"><cspl-pagination record-count="filterData1.length" control-model="page1" items-per-page="noOfRecordsPerPage1"></cspl-pagination></div><div class="row"><h3 class="col-md-10 control-label title-label"><span data-translate="gatewayApp.BankRelationship.rejectedByBanks"></span></h3><div class="table-responsive" ng-show="vm.pendingAndRejectedBanks.length > 0"><div style="margin-left:5px"></div><table id="rejectedByBanks" class="dataTable table table-striped table-hover"><thead><tr><th><span data-translate="gatewayApp.BankRelationship.bankName"></span></th><th><span data-translate="gatewayApp.BankRelationship.homeBranchIfsc"></span></th><th><span data-translate="gatewayApp.BankRelationship.tradingBranchIfsc"></span></th><th><span data-translate="gatewayApp.BankRelationship.actionType"></span></th><th><span data-translate="gatewayApp.BankRelationship.remarks"></span></th><th></th></tr></thead><tbody><tr style="background-color:#A80000" ng-repeat="pendingAndRejectedBank in filterData2 = (vm.pendingAndRejectedBanks | filter : customFilter1 | filter: filterText) | limitTo:noOfRecordsPerPage2:noOfRecordsPerPage2*(page2-1)"><td width="15%">{{pendingAndRejectedBank.bank.bankName}}</td><td width="15%">{{pendingAndRejectedBank.homeBranch.ifscCode}}</td><td width="15%">{{pendingAndRejectedBank.tradingBranch.ifscCode}}</td><td width="10%">{{pendingAndRejectedBank.actionType}}</td><td width="10%">{{pendingAndRejectedBank.rejectionReason}}</td><td width="5%" align="center" ng-click=" vm.close(pendingAndRejectedBank.id)"><span class="icon icon_trash" title="Discard"></span></td></tr></tbody></table></div></div><div ng-show="filterData2.length > noOfRecordsPerPage2"><cspl-pagination record-count="filterData2.length" control-model="page2" items-per-page="noOfRecordsPerPage2"></cspl-pagination></div></div></section></div></div>');
$templateCache.put('app/entities/customer-bank-relationship-report/customer-trading-bank-dialog.html','<form name="tradingBankForm" role="form" autocomplete="off" novalidate><div class="modal-header"><div class="modal-title"><span data-translate="gatewayApp.BankRelationship.addBank"></span></div></div><div class="modal-body"><div><nmb-alert-error></nmb-alert-error></div><nmb-alert></nmb-alert><div class="content"><fieldset><div class="row"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="gatewayApp.tradingBank.bankName"></span>&nbsp;* <span ng-show="userPreference.showInfoIcon==\'yes\'" class="icon" cspl-info-tooltip="Enter name of Relationship Bank" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-ach control-model="vm.tradingBank.bank" control-id="txtBank" lookup-name="validStatusBank" display-column="shortName" form="tradingBankForm" required></cspl-ach></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="gatewayApp.tradingBank.bankAccountNo"></span>&nbsp;* <span ng-show="userPreference.showInfoIcon==\'yes\'" class="icon" cspl-info-tooltip="Enter the account number held with Relationship bank" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.tradingBank.bankAccountNumber" control-id="txtbankAccountNumber" control-type="Number" control-maxlength="20" form="tradingBankForm" required></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="gatewayApp.tradingBank.homeBranch"></span>&nbsp;* <span ng-show="userPreference.showInfoIcon==\'yes\'" class="icon" cspl-info-tooltip="Enter the Branch name where account is maintained with Bank" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-ach control-model="vm.tradingBank.homeBranch" control-id="txthomeBranch" lookup-name="homeBranch" display-column="ifscCode,branchName" filter-value="{{vm.filterText}}" form="tradingBankForm" required></cspl-ach><span class="help-block" ng-show="vm.tradingBank.homeBranch!=null">({{vm.tradingBank.homeBranch.branchName}})</span> <span class="help-block" ng-show="vm.tradingBank.homeBranch==null || vm.tradingBank.homeBranch==undefined"><span data-translate="gatewayApp.customerRegistration.helpText.branch"></span></span></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="gatewayApp.tradingBank.branchAddress"></span> <span ng-show="userPreference.showInfoIcon==\'yes\'" class="icon" cspl-info-tooltip="Home Branch Address details" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-multiline-text control-model="vm.tradingBranchAddress" control-id="txtbranchAddress" form="tradingBankForm"></div></div><span class="help-block" style="margin-right: 26%;   text-align: right;  padding-bottom: 10px"><span data-translate="gatewayApp.tradingBank.payable"></span></span><div class="row"><label class="col-md-4 col-md-offset-3 control-label"><span data-translate="gatewayApp.tradingBank.tradingBranch"></span> <span ng-show="userPreference.showInfoIcon==\'yes\'" class="icon" cspl-info-tooltip="The trading branch would be assigned by your Relationship bank" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><!-- remove filter value due to allahabad bank alone shows trading branch --><div class="col-md-6 col-md-offset-3"><cspl-ach control-model="vm.tradingBank.tradingBranch" name="txttradingBranch" control-id="txttradingBranch" lookup-name="validStatusBranchesForBank" display-column="ifscCode,branchName" form="tradingBankForm" control-disabled="vm.disableTradingBranch" control-required="!vm.disableTradingBranch"></cspl-ach><span class="help-block" ng-show="vm.tradingBank.tradingBranch!=null" style="word-break: break-word">({{vm.tradingBank.tradingBranch.branchName}})</span> <span class="help-block" ng-show="(vm.tradingBank.tradingBranch==null || vm.tradingBank.tradingBranch==undefined) && !vm.tradingBank.assignTradingBranch"><span data-translate="gatewayApp.customerRegistration.helpText.branch"></span></span> <span class="help-block" ng-show="(vm.tradingBank.tradingBranch==null || vm.tradingBank.tradingBranch==undefined) && vm.tradingBank.assignTradingBranch"><span data-translate="gatewayApp.customerRegistration.helpText.idontknow"></span></span></div></div><div class="row"><div class="col-md-9 col-md-offset-3"><input type="checkbox" style="margin-right:1%;vertical-align:middle;margin-bottom:3px" checklist-model="vm.termsAndCondition" checklist-value="termsAndConditions" ng-model="termsAndConditions" required> <a ng-click="vm.previewClearcorpTAC()"><span data-translate="gatewayApp.customerRegistration.termsAndConditionsOfClearcorp"></span></a></div></div><div class="row" style="margin-top: 5px" ng-if="vm.bankTAC!=null"><div class="col-md-9 col-md-offset-3"><input type="checkbox" style="margin-right:1%;vertical-align:middle;margin-bottom:3px" checklist-model="vm.termsAndConditionForBank" checklist-value="termsAndConditionsForBank" ng-model="termsAndConditionsForBank" ng-required="vm.bankTAC!=null"> <a ng-click="vm.previewBankTAC()"><span data-translate="gatewayApp.customerRegistration.termsAndConditionsOfBank"></span></a></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-hide="showButton" class="btn btn-info active" ng-disabled="tradingBankForm.$invalid || vm.clicked" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/customer-charges/customer-charges-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="customerChargesEditForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span ng-show="vm.customerCharge.id==null" data-translate="gatewayApp.customerCharges.addCustomerCharges"></span> <span ng-show="vm.customerCharge.id!=null" data-translate="gatewayApp.customerCharges.editCustomerCharges"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset><br><div class="col-sm-6 col-centered"><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerCharges.customerType"></span></label><cspl-ach control-model="vm.customerCharge.customerType" control-id="txtCustomerType" lookup-name="AllCustomerTypes" control-disabled="vm.viewMode || (vm.customerCharge.id!=null || showResubmitButton)" display-column="name" placeholder="" form="customerChargesEditForm" control-required="true"></div><!-- <div class="form-group">\r\n\t\t\t\t\t\t<label class="control-label"  cspl-mandatory><span data-translate="gatewayApp.customerCharges.chargeType" ></span></label>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<cspl-ach control-model="vm.customerCharge.chargesType" control-id="txtChargesType"\t lookup-name="customerChargesType" control-disabled="vm.viewMode || (vm.customerCharge.id!=null || showResubmitButton)"\r\n\t\t\t\t\t\t\t\t\t\tdisplay-column="description" placeholder="" form="customerChargesEditForm" control-required="true"/>\r\n\t\t\t\t\t\r\n\t\t\t\t</div> --><!-- \t\t\t\t<div class="form-group" ng-show="vm.customerCharge.chargesType.shortName==\'OneTimeRegistration\'">  --><label class="control-label col-xs-12 col-md-12 col-centered" cspl-mandatory><span data-translate="gatewayApp.customerCharges.chargeAmount"></span></label><div class="col-xs-9 col-md-7 multi-col"><cspl-numeric control-model="vm.customerCharge.charges" control-id="txtCharges" no-of-decimals="{{vm.noOfDecimalsForAmount}}" control-min="0" control-max="999999999999.99" form="customerChargesEditForm" control-disabled="vm.viewMode" control-required="true"></cspl-numeric></div><div class="col-xs-1 col-md-1" style="line-height:30px"><span data-translate="gatewayApp.customerCharges.inr"></span></div><!-- \t\t\t\t\t</div> --><!-- \t\t\t\t\t<div class="form-group" ng-show="vm.customerCharge.chargesType.shortName==\'Transaction\'">  \r\n\t\t\t\t\t<label class="control-label  col-xs-12 col-md-12  col-centered"  cspl-mandatory>\r\n\t\t\t\t\t<span  data-translate="gatewayApp.customerCharges.chargePercentage" ></span></label>\r\n\t\t\t\t\t\t<div class="col-xs-9 col-md-7  multi-col">\r\n\t\t\t\t\t\t<cspl-numeric control-model="vm.customerCharge.charges"  control-id="txtCharges1"  no-of-decimals="{{vm.decimalsForPercent}}" control-min="0" control-max="100"\r\n\t\t\t\t\t\t\tform="customerChargesEditForm"  control-disabled="vm.viewMode" control-required="vm.customerCharge.chargesType.shortName==\'Transaction\'"></cspl-numeric>\r\n\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t<div class="col-xs-1 col-md-1" style="line-height:30px">\r\n\t\t\t\t\t\t\t<span>%</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div> --></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="customerChargesEditForm.$invalid || vm.clicked" ng-click="vm.resubmitCustomerCharges();vm.clicked = true;"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="customerChargesEditForm.$invalid  || vm.clicked" class="btn btn-info active" ng-click="vm.save();vm.clicked = true;"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardCustomerCharges()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectCustomerCharges()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" autofocus class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveCustomerCharges();vm.clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/customer-charges/customer-charges.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.customerCharges.title">Manage Customer Charges</h2><nmb-alert></nmb-alert><div><!-- <nmb-alert-error></nmb-alert-error> --></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="float-right"><button type="button" class="btn btn-info active" ng-click="vm.screenLog.screenLog(vm.screenName,0,vm.entityConstants.ENTITY_ACTION_TYPE.ADD);vm.launch()" ng-show="vm.permitCustomerChargesAddEntityAction"><img ng-src="assets/images/Add.png"> <span data-translate="gatewayApp.customerCharges.charges"></span></button></div><div class="float-right col-xs-10 col-sm-3 col-md-2"><cspl-table-search control-model="filterText"></cspl-table-search></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="customerCharges" total-record-count="vm.customerCharges.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="One_Time_Registration_Charges"></cspl-table-export></div><div class="pull-left" style="margin-left: 0px" ng-show="vm.permitCustomerChargesImportEntityAction"><cspl-table-import upload-type="OneTimeRegistrationChargesImport" file-content=""></cspl-table-import></div></div><div class="bootstrap-tableresponsive"><table id="customerCharges" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.customerCharges.customerType">Customer Type</th><!-- \t\t\t\t\t<th data-translate="gatewayApp.customerCharges.chargeType">Charge Type</th> --><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.customerCharges.chargeValue">Charge Value</th><!-- \t\t\t\t\t<th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.customerCharges.charge%">Charge %</th> --><th></th></tr></thead><tbody><tr ng-repeat="customerCharges in filterData = (vm.customerCharges | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{customerCharges.customerType.name}}</td><!-- \t\t\t\t<td>{{customerCharges.chargesType.description}}</td> --><td class="td-text-align-right noPaddingLeftRight"><span ng-show="customerCharges.chargesType.shortName==\'OneTimeRegistration\'">{{customerCharges.charges | number : vm.noOfDecimalsForAmount}}</span></td><!-- \t\t\t\t<td class="td-text-align-right noPaddingLeftRight"><span ng-show="customerCharges.chargesType.shortName==\'Transaction\'">{{customerCharges.charges | number : vm.decimalsForPercent}}</span></td> --><td width="10%" style="text-align:right"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitCustomerChargesEditEntityAction"><a ui-sref="customer-charges-edit({id:customerCharges.id})" ng-click="vm.screenLog.screenLog(vm.screenName, customerCharges.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table><div style="padding:5px" ng-show="vm.customerCharges.length==0"><span>No record found</span></div><div ng-show="vm.customerCharges.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/customer-info-change-status/customer-info-change-status.html','<div ncy-breadcrumb class="row" style="margin-left: 10px"></div><nmb-alert></nmb-alert><div class="row" style="margin-left: 10px"><div class="col-lg-12"><section class="item" style="padding:5px"><div class="panel panel-primary"><div class="panel-heading text-center"><span data-translate="gatewayApp.customerInfo.title"></span> <a href="" style="position: relative;float:right; color: #fff"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><div class="panel-body"><div class="module-content-inner"><nmb-alert-error></nmb-alert-error><div class="table-responsive" ng-show="vm.tasks.length==0 "><span style="color: #7f7f7f" data-translate="gatewayApp.customerInfo.nopendingactions ">No Pending Actions</span></div><div class="table-responsive" ng-show="vm.tasks.length> 0"><div class="row"><div class="pull-right" ng-show="vm.tasks.length>0 "><div class="col-md-6 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><cspl-table-export table-name="customerInfo" total-record-count="vm.tasks.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Customer_Info_Change_Status"></cspl-table-export></div></div><table id="customerInfo" class="datatables-nosort table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.customerInfo.bankName">bank name</th><th data-translate="gatewayApp.customerInfo.branchName">branch name</th><th nowrap="nowrap" data-translate="gatewayApp.customerInfo.submittedOn">submitted on</th><th data-translate="gatewayApp.customerInfo.submittedBy">submitted by</th><th data-translate="gatewayApp.customerInfo.status">Status</th><th data-translate="gatewayApp.customerInfo.rejectedBy">Rejected by</th><th style="min-width:30px" data-translate="gatewayApp.customerInfo.rejectionReason">Rejected reason</th><th style="text-align:center">-</th></tr></thead><tbody><tr ng-repeat="task in filterData = (vm.tasks| filter : filterText | orderBy:\'-lastModifiedDate\') | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td width="15%">{{task.branch.bank.shortName}}</td><td width="15%">{{task.branch.branchName}}</td><td width="10%">{{task.createdDate|date:\'dd-MMM-yyyy\'}}</td><td width="15%">{{task.createdBy}}</td><td width="15%" ng-show="task.taskStatus.shortName==\'Created\'">Pending Approval</td><td width="15%" ng-show="task.taskStatus.shortName!=\'Created\'">{{task.taskStatus.shortName}}</td><td width="15%" ng-show="task.taskStatus.shortName==\'Rejected\'">{{task.lastModifiedBy}}</td><td width="15%" ng-show="task.taskStatus.shortName!=\'Rejected\'">{{\'-\'}}</td><td width="20%">{{task.reason}}</td><td width="10%" align="center"><div class="btn-group utility" uib-dropdown dropdown-append-to-body="true"><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ng-click="vm.viewEntity(task.entity.shortName,task.id,task.payload,\'maker\', task.changeType, task.entityRecordID)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li><a ng-click="vm.discardEntity(task)"><span class="hidden-xs hidden-sm" data-translate="entity.action.discard"></span></a></li><li ng-show="task.taskStatus.shortName==\'Rejected\'  "><a ng-click="vm.resubmitEntity(task.entity.shortName,task.id,task.payload, task.changeType, task.taskGroupReference, task.entityRecordID)"><span class="hidden-xs hidden-sm" data-translate="entity.action.resubmit"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="vm.tasks.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></div></div></section></div></div><script src="assets/js/tables.js"></script>');
$templateCache.put('app/entities/customer-on-boarding-exception-report/customer-on-boarding-exception-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.customer.customerOnBoardingExceptionReport"></span></h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><br><fieldset class="row"><form name="customerOnBoardingExceptionReportForm" role="form" novalidate><div class="row"><div><label class="col-md-1 control-label" style="text-align: right; padding-top: 5px" cspl-mandatory><span data-translate="gatewayApp.CustomerOnBoarding.from"></span></label><div class="col-md-2"><cspl-dtp control-id="dtpFromDate" control-model="vm.fromDate" form="customerOnBoardingExceptionReportForm" required></cspl-dtp></div></div><div><label class="col-md-1 control-label" style="text-align: right; padding-top: 5px" cspl-mandatory><span data-translate="gatewayApp.CustomerOnBoarding.to"></span></label><div class="col-md-2"><cspl-dtp control-id="dtpToDate" control-model="vm.toDate" form="customerOnBoardingExceptionReportForm" required></cspl-dtp></div></div><div class="col-md-3"><button class="btn btn-info active" ng-disabled="customerOnBoardingExceptionReportForm.$invalid||vm.clicked" ng-click="vm.loadAll();vm.clicked=true;" data-translate="gatewayApp.CustomerOnBoarding.go"></button></div></div></form></fieldset></div><div class="row"><div class="bootstrap-tableresponsive scrollableTable" style="overflow-x: auto; overflow-y: hidden"><div ng-show="vm.customerOnBoardingDetails.length > 0"><div class="row"><div class="pull-right"><div class="col-md-6 pull-right"><cspl-table-search control-model="vm.filterText"></cspl-table-search></div></div><div class="pull-left"><a href="" style="color: #fff; vertical-align: -19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size: 20px"></i></a></div><span class="partition">|</span><div class="pull-left"><div class="dropdown col-md-3" style="width:10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border:none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div></div></div><table id="customerOnBoardingDetails" class="dataTable table table-striped table-hover"><thead><tr><th ng-show="vm.userEntityOwnerType==\'Clearcorp\'"><cspl-table-sort sort-type-model="sortType" default-sort="asc" sort-type-name="bank.shortName" sort-reverse-model="sortReverse" header-text="\'gatewayApp.CustomerOnBoarding.bank\'|translate"></th><th ng-show="vm.userEntityOwnerType!=\'Clearcorp\'"><cspl-table-sort sort-type-model="sortType" sort-type-name="branch.branchName" sort-reverse-model="sortReverse" header-text="\'gatewayApp.CustomerOnBoarding.branch\'|translate"></th><th><cspl-table-sort sort-type-model="sortType" sort-type-name="numberOfPendingTasks" sort-reverse-model="sortReverse" header-text="\'gatewayApp.CustomerOnBoarding.numberOfPendingTasks\'|translate"></th><th><cspl-table-sort sort-type-model="sortType" sort-type-name="numberOfRejectedTasks" sort-reverse-model="sortReverse" header-text="\'gatewayApp.CustomerOnBoarding.numberOfRejectedTasks\'|translate"></th><th><cspl-table-sort sort-type-model="sortType" sort-type-name="numberOfWithdrawnTasks" sort-reverse-model="sortReverse" header-text="\'gatewayApp.CustomerOnBoarding.numberOfWithdrawnTasks\'|translate"></th><th><cspl-table-sort sort-type-model="sortType" sort-type-name="numberOfAutoWithdrawnTasks" sort-reverse-model="sortReverse" header-text="\'gatewayApp.CustomerOnBoarding.numberOfAutoWithdrawnTasks\'|translate"></th></tr></thead><tbody><tr ng-repeat="customerOnBoardingDetail in vm.filterData = (vm.customerOnBoardingDetails | filter : vm.filterText | orderBy  : sortType : sortReverse)" ng-init="vm.prepareDetails()"><td ng-show="vm.userEntityOwnerType==\'Clearcorp\'">{{customerOnBoardingDetail.bank.shortName}}</td><td ng-show="vm.userEntityOwnerType!=\'Clearcorp\'">{{customerOnBoardingDetail.branch.branchName}}</td><td><a href="" ng-show="customerOnBoardingDetail.numberOfPendingTasks>0" ng-click="vm.customerOnBoarding(customerOnBoardingDetail.customerRegistrationRequestList, \'pending\');vm.showDetails=\'true\'">{{customerOnBoardingDetail.numberOfPendingTasks}}</a> <span ng-show="customerOnBoardingDetail.numberOfPendingTasks<=0 || customerOnBoardingDetail.numberOfPendingTasks==null">0</span></td><td><a href="" ng-show="customerOnBoardingDetail.numberOfRejectedTasks>0" ng-click="vm.customerOnBoarding(customerOnBoardingDetail.rejectedRequestList, \'rejected\');vm.showDetails=\'true\'">{{customerOnBoardingDetail.numberOfRejectedTasks}}</a> <span ng-show="customerOnBoardingDetail.numberOfRejectedTasks<=0 || customerOnBoardingDetail.numberOfRejectedTasks==null">0</span></td><td><a href="" ng-show="customerOnBoardingDetail.numberOfAutoWithdrawnTasks>0" ng-click="vm.customerOnBoarding(customerOnBoardingDetail.autoWithdrawnRequestList, \'autowithdrawn\');vm.showDetails=\'true\'">{{customerOnBoardingDetail.numberOfAutoWithdrawnTasks}}</a> <span ng-show="customerOnBoardingDetail.numberOfAutoWithdrawnTasks<=0 || customerOnBoardingDetail.numberOfAutoWithdrawnTasks==null">0</span></td><td><a href="" ng-show="customerOnBoardingDetail.numberOfWithdrawnTasks>0" ng-click="vm.customerOnBoarding(customerOnBoardingDetail.withdrawnRequestList, \'withdrawn\');vm.showDetails=\'true\'">{{customerOnBoardingDetail.numberOfWithdrawnTasks}}</a> <span ng-show="customerOnBoardingDetail.numberOfWithdrawnTasks<=0 || customerOnBoardingDetail.numberOfWithdrawnTasks==null">0</span></td></tr></tbody><tfoot class="table-footer"><tr><td class="td-text-align-left" ng-show="vm.userEntityOwnerType!=\'Clearcorp\'" data-translate="gatewayApp.CustomerOnBoarding.total"></td><td ng-show="vm.userEntityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.CustomerOnBoarding.total"></td><td><a href="" ng-show="vm.totalPendingTasksCount>0" ng-click="vm.customerOnBoarding(vm.totalPendingTasks, \'pending\');vm.showDetails=\'true\'">{{vm.totalPendingTasksCount}}</a><span ng-show="vm.totalPendingTasksCount<=0 || vm.totalPendingTasksCount==null">0</span></td><td><a href="" ng-show="vm.totalRejectedTasksCount>0" ng-click="vm.customerOnBoarding(vm.totalRejectedTasks, \'rejected\');vm.showDetails=\'true\'">{{vm.totalRejectedTasksCount}}</a><span ng-show="vm.totalRejectedTasksCount<=0 || vm.totalRejectedTasksCount==null">0</span></td><td><a href="" ng-show="vm.totalAutoWithdrawnTasksCount>0" ng-click="vm.customerOnBoarding(vm.totalAutoWithdrawnTasks, \'autowithdrawn\');vm.showDetails=\'true\'">{{vm.totalAutoWithdrawnTasksCount}}</a><span ng-show="vm.totalAutoWithdrawnTasksCount<=0 || vm.totalAutoWithdrawnTasksCount==null">0</span></td><td><a href="" ng-show="vm.totalWithdrawnTasksCount>0" ng-click="vm.customerOnBoarding(vm.totalWithdrawnTasks, \'withdrawn\');vm.showDetails=\'true\'">{{vm.totalWithdrawnTasksCount}}</a><span ng-show="vm.totalWithdrawnTasksCount<=0 || vm.totalWithdrawnTasksCount==null">0</span></td></tr></tfoot></table></div></div></div><div class="row"><div ng-show="vm.showDetails && vm.customerRegistrationDetails.length > 0"><div class="row"><div class="pull-right"><div class="col-md-6 pull-right"><cspl-table-search control-model="filterText1"></cspl-table-search></div></div><!-- <div class="pull-left" ng-show="vm.userEntityOwnerType==\'Branch\'">\r\n\t\t\t\t\t\t\t\t\t<cspl-table-export table-name="OnBoardingDetails"\r\n\t\t\t\t\t\t\t\t\t\ttotal-record-count="vm.customerRegistrationDetails.length"\r\n\t\t\t\t\t\t\t\t\t\tno-of-records-per-page="noOfRecordsPerPage"\r\n\t\t\t\t\t\t\t\t\t\tfilter-text="filterText1" page-no="page"\r\n\t\t\t\t\t\t\t\t\t\tfile-name="customer-onboarding-details"></cspl-table-export>\r\n\r\n\t\t\t\t\t\t\t\t</div> --></div><div class="table-responsive" style="overflow-x:auto;overflow-y:hidden"><table id="OnBoardingDetails" class="dataTable table table-striped table-hover"><thead><tr><th><span data-translate="gatewayApp.CustomerOnBoarding.customerReferenceNo"></span></th><th nowrap="nowrap"><span data-translate="gatewayApp.CustomerOnBoarding.onBoardingDateTime"></span></th><th><span data-translate="gatewayApp.CustomerOnBoarding.bank"></span></th><th><span data-translate="gatewayApp.CustomerOnBoarding.customerName"></span></th><th><span data-translate="gatewayApp.CustomerOnBoarding.customerType"></span></th><th><span data-translate="gatewayApp.CustomerOnBoarding.homeBranchIFSC"></span></th><th data-translate="gatewayApp.CustomerOnBoarding.homeBranchAddress"></th><th><span data-translate="gatewayApp.CustomerOnBoarding.tradingBranchName"></span></th><th><span data-translate="gatewayApp.CustomerOnBoarding.tradingBranchIFSC"></span></th><th ng-if="vm.userEntityOwnerType!=\'Clearcorp\'"><span data-translate="gatewayApp.CustomerOnBoarding.accountNumber"></span></th><th ng-if="vm.userEntityOwnerType!=\'Clearcorp\'"><span data-translate="gatewayApp.CustomerOnBoarding.pan"></span></th><th data-translate="gatewayApp.CustomerOnBoarding.LEI"></th><!-- <th data-translate="gatewayApp.CustomerOnBoarding.CIN"></th> --><th data-translate="gatewayApp.CustomerOnBoarding.gstin"></th><th data-translate="gatewayApp.CustomerOnBoarding.stateCode"></th><!-- <th style="min-width:70px;" data-translate="gatewayApp.CustomerOnBoarding.dateOfJoining"></th>\r\n\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerOnBoarding.primaryContactName"></th>\r\n\t\t\t\t\t\t\t\t\t\t<th><span\r\n\t\t\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.CustomerOnBoarding.contactNumber"></span>\r\n\t\t\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t\t<th><span\r\n\t\t\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.CustomerOnBoarding.emailId"></span>\r\n\t\t\t\t\t\t\t\t\t\t</th> --><th ng-if="vm.userEntityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.CustomerOnBoarding.customerAddress"></th><th ng-if="vm.userEntityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.CustomerOnBoarding.customerCity"></th><th ng-if="vm.userEntityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.CustomerOnBoarding.customerState"></th><th ng-if="vm.userEntityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.CustomerOnBoarding.customerCountry"></th><th ng-if="vm.userEntityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.CustomerOnBoarding.customerPincode"></th><!-- <th data-translate="gatewayApp.CustomerOnBoarding.alternateContactName1"></th> \r\n\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerOnBoarding.alternateContactEmail1"></th>\r\n\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerOnBoarding.alternateContactMobile1"></th>\r\n\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerOnBoarding.alternateContactName2"></th>\r\n\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerOnBoarding.alternateContactEmail2"></th>\r\n\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerOnBoarding.alternateContactMobile2"></th>--><th data-translate="gatewayApp.CustomerOnBoarding.authorisedPersonFirstName"></th><th data-translate="gatewayApp.CustomerOnBoarding.authorisedPersonMiddleName"></th><th data-translate="gatewayApp.CustomerOnBoarding.authorisedPersonLastName"></th><!--<th data-translate="gatewayApp.CustomerOnBoarding.gender"></th>--><!--<th data-translate="gatewayApp.CustomerOnBoarding.userAddress"></th>\r\n\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerOnBoarding.userCity"></th>\r\n\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerOnBoarding.userState"></th>\r\n\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerOnBoarding.userCountry"></th>\r\n\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerOnBoarding.userPincode"></th>\r\n\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerOnBoarding.login"></th>--><th ng-if="vm.userEntityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.CustomerOnBoarding.authorisedPersonEmail"></th><th ng-if="vm.userEntityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.CustomerOnBoarding.authorisedPersonMobile"></th><th ng-if="vm.userEntityOwnerType==\'Clearcorp\'" style="min-width:70px" data-translate="gatewayApp.CustomerOnBoarding.dob"></th><th><span data-translate="gatewayApp.CustomerOnBoarding.noOfDaysInPipeline"></span></th><th><span data-translate="gatewayApp.CustomerOnBoarding.status"></span></th><th ng-show="vm.showDateOfRejectionWithdrawn"><span data-translate="gatewayApp.CustomerOnBoarding.dateOfRejectionOrAutoWithdrawn"></span></th><th style="min-width: 200px"><span data-translate="gatewayApp.CustomerOnBoarding.rejectedReason"></span></th><th ng-if="vm.userEntityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.CustomerOnBoarding.sourceOfIntro"></th><th></th></tr></thead><tbody><tr ng-repeat="customerOnBoardingDetail in filterData = (vm.customerRegistrationDetails | filter : filterText1 | orderBy  : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{customerOnBoardingDetail.requestReferenceNumber}}</td><td nowrap="nowrap">{{customerOnBoardingDetail.createdDate|date:\'dd-MMM-yyyy hh:mm:ss a\'}}</td><td>{{customerOnBoardingDetail.bank.shortName}}</td><td ng-show="customerOnBoardingDetail.customerMiddleName!=null">{{customerOnBoardingDetail.customerFirstName+\' \' +customerOnBoardingDetail.customerMiddleName+\' \' +customerOnBoardingDetail.customerLastName}}</td><td ng-show="customerOnBoardingDetail.customerMiddleName==null">{{customerOnBoardingDetail.customerFirstName+\' \' +customerOnBoardingDetail.customerLastName}}</td><td>{{customerOnBoardingDetail.customerType.name}}</td><td>{{customerOnBoardingDetail.homeBranch.ifscCode}}</td><td style="word-break:break-word">{{customerOnBoardingDetail.homeBranch.address}}</td><td>{{customerOnBoardingDetail.tradingBranch.branchName || \'-\'}}</td><td>{{customerOnBoardingDetail.tradingBranch.ifscCode || \'-\'}}</td><td ng-show="vm.userEntityOwnerType!=\'Clearcorp\'">{{customerOnBoardingDetail.bankAccountNumber}}</td><td ng-if="vm.userEntityOwnerType!=\'Clearcorp\'">{{customerOnBoardingDetail.panNumber}}</td><td>{{customerOnBoardingDetail.legalEntityIdentifier || \'-\'}}</td><!-- <td>{{customerOnBoardingDetail.corporateIdentificationNumber || \'-\'}}</td> --><td>{{customerOnBoardingDetail.gstin || \'-\'}}</td><td>{{customerOnBoardingDetail.stateCode || \'-\'}}</td><!-- <td>{{customerOnBoardingDetail.dobOrDoi|date:\'dd-MMM-yyyy\'}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{customerOnBoardingDetail.primaryContactName}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{customerOnBoardingDetail.primaryMobileCountryCode}}-{{customerOnBoardingDetail.primaryMobile}}</td>\r\n\t\t\t\t\t\t\t\t\t    <td>{{customerOnBoardingDetail.primaryEmail}}</td> --><td style="word-break:break-word" ng-if="vm.userEntityOwnerType==\'Clearcorp\'">{{vm.getAddress(customerOnBoardingDetail.address1,customerOnBoardingDetail.address2)}}</td><td ng-if="vm.userEntityOwnerType==\'Clearcorp\'">{{customerOnBoardingDetail.city || \'-\'}}</td><td ng-if="vm.userEntityOwnerType==\'Clearcorp\'">{{customerOnBoardingDetail.state.shortName || \'-\'}}</td><td ng-if="vm.userEntityOwnerType==\'Clearcorp\'">{{customerOnBoardingDetail.country.shortName || \'-\'}}</td><td ng-if="vm.userEntityOwnerType==\'Clearcorp\'">{{customerOnBoardingDetail.pincode || \'-\'}}</td><!-- <td>{{customerOnBoardingDetail.alternateContactName1 || \'-\'}}</td> \r\n\t\t\t\t\t\t\t\t\t\t<td>{{customerOnBoardingDetail.alternateEmail1 || \'-\'}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{vm.getMobile(customerOnBoardingDetail.alternateMobile1, customerOnBoardingDetail.alternateMobileCountryCode1)}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{customerOnBoardingDetail.alternateContactName2 || \'-\'}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{customerOnBoardingDetail.alternateEmail2 || \'-\'}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{vm.getMobile(customerOnBoardingDetail.alternateMobile2, customerOnBoardingDetail.alternateMobileCountryCode2)}}</td>--><td style="word-break:break-word">{{customerOnBoardingDetail.userFirstName}}</td><td style="word-break:break-word">{{customerOnBoardingDetail.userMiddleName || \'-\'}}</td><td style="word-break:break-word">{{customerOnBoardingDetail.userLastName}}</td><!--<td>{{customerOnBoardingDetail.gender}}</td>--><!--<td style="word-break:break-word">{{vm.getAddress(customerOnBoardingDetail.userAddress1,customerOnBoardingDetail.userAddress2)}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{customerOnBoardingDetail.userCity || \'-\'}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{customerOnBoardingDetail.userState.shortName}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{customerOnBoardingDetail.userCountry.shortName}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{customerOnBoardingDetail.userPincode}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>{{customerOnBoardingDetail.login}}</td>--><td ng-if="vm.userEntityOwnerType==\'Clearcorp\'">{{customerOnBoardingDetail.userEmail}}</td><td ng-if="vm.userEntityOwnerType==\'Clearcorp\'">{{customerOnBoardingDetail.userMobileCountryCode+\'-\'+customerOnBoardingDetail.userMobile}}</td><td ng-if="vm.userEntityOwnerType==\'Clearcorp\'">{{customerOnBoardingDetail.dob|date:\'dd-MMM-yyyy\'}}</td><td align="right">{{vm.GetNumberOfDaysInPipeline(customerOnBoardingDetail.createdDate)}}</td><td>{{customerOnBoardingDetail.customerBankRelationshipStatus.name}}</td><td ng-show="vm.showDateOfRejectionWithdrawn" nowrap="nowrap">{{customerOnBoardingDetail.lastModifiedDate|date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td style="word-break:break-word">{{customerOnBoardingDetail.rejectionReason}}</td><td ng-if="vm.userEntityOwnerType==\'Clearcorp\'">{{customerOnBoardingDetail.sourceOfIntro.displayName|| \'-\'}}</td><td class="sticky-col" style="text-align:center; right: 15px"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ng-click="vm.openCustomerView(customerOnBoardingDetail)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li></ul></div></td></tr></tbody></table></div></div><div class="table-responsive" ng-show="vm.customerOnBoardingDetails.length == 0"><span>No record found</span></div><div ng-show="vm.customerRegistrationDetails.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div></div>');
$templateCache.put('app/entities/customer-registration/bank-info-preview.html','<div class="headerForm"><h5 class="formHeading" data-translate="gatewayApp.customerRegistration.bankRelationship"></h5></div><form name="bankInfo"><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.bankName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.bank.bankName" control-id="txtbank" form="bankInfo" control-disabled="true" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.bankAccountNumber"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.bankAccountNumber" control-id="txtbankAccountNumber" form="bankInfo" control-disabled="true" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.homeBranch"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.homeBranch.ifscCode" control-id="txtHomeBranch" form="bankInfo" control-disabled="true" required></cspl-text><span style="margin-bottom: 5px" class="help-block" ng-show="vm.customerRegistrationRequest.homeBranch!=null">({{vm.customerRegistrationRequest.homeBranch.branchName}})</span></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.branchAddress"></span></label></div><div class="col-md-8"><cspl-multiline-text control-model="vm.customerRegistrationRequest.branchAddress" control-id="txtbankAddress" theme-type="{{vm.theme}}" form="bankInfo" control-disabled="true"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.tradingBranch"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.tradingBranch.ifscCode" control-id="txtTradingBranch" form="bankInfo" control-disabled="vm.customerRegistrationRequest.assignTradingBranch" control-required="false"></cspl-text><span style="margin-bottom: 5px" class="help-block" ng-show="vm.customerRegistrationRequest.tradingBranch!=null">({{vm.customerRegistrationRequest.tradingBranch.branchName}})</span> <span style="margin-bottom: 5px" class="help-block" ng-show="vm.customerRegistrationRequest.tradingBranch==null" data-translate="gatewayApp.customerRegistration.helpText.idontknow"></span></div></div></form>');
$templateCache.put('app/entities/customer-registration/bank-info-view-dialog.html','<ng-form name="bankInfo" ng-if="vm.bankInfo && !vm.customerRegistrationRequest.isProp"><div><h4 ng-show="vm.theme==\'dark\'" class="panel-title col-md-offset-2" style="width: 400px">&nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.bankRelationship"></span></h4><h4 ng-show="vm.theme==\'light\'" class="panel-title col-md-offset-2" style="width: 400px">&nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.bankRelationship"></span></h4></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.bankName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-ach control-model="vm.customerRegistrationRequest.bank" control-id="txtbank" lookup-name="bankDetails" theme-type="{{vm.theme}}" display-column="shortName" form="bankInfo" control-disabled="true" control-required="true"></cspl-ach></div></div><div class="row" ng-if="vm.userEntityOwnerType!=\'Clearcorp\'"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.bankAccountNumber"></span></label></div><div class="row" ng-if="vm.userEntityOwnerType!=\'Clearcorp\'"><div class="col-md-6 col-md-offset-3"><cspl-text ng-if="!vm.isEdit" theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.bankAccountNumber" control-id="txtbankAccountNumber" form="bankInfo" control-disabled="true" control-modified="vm.checkforAccountModification()" control-required="true"></cspl-text><cspl-text ng-if="vm.isEdit" theme-type="{{vm.theme}}" control-type="Number" control-maxlength="20" control-model="vm.customerRegistrationRequest.bankAccountNumber" control-id="txtbankAccountNumber1" form="bankInfo" control-disabled="false" required></cspl-text></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.homeBranch"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-ach ng-if="!vm.isEdit" control-model="vm.customerRegistrationRequest.homeBranch" control-id="txthomeBranch" theme-type="{{vm.theme}}" lookup-name="homeBranch" display-column="ifscCode,branchName" filter-value="" form="bankInfo" control-disabled="true" control-required="true" control-modified="vm.checkforHomeBranchModification()"></cspl-ach><cspl-ach ng-if="vm.isEdit" control-model="vm.customerRegistrationRequest.homeBranch" control-id="txthomeBranch2" theme-type="{{vm.theme}}" lookup-name="homeBranch" display-column="ifscCode,branchName" filter-value="{{vm.filterText}}" form="bankInfo" control-disabled="false" required></cspl-ach><span class="help-block" ng-show="vm.customerRegistrationRequest.homeBranch!=null">({{vm.customerRegistrationRequest.homeBranch.branchName}})</span> <span class="help-block" ng-show="vm.customerRegistrationRequest.homeBranch==null || vm.customerRegistrationRequest.homeBranch==undefined"><span data-translate="gatewayApp.customerRegistration.helpText.branch"></span></span></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.customerRegistration.branchAddress"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-multiline-text control-model="vm.customerRegistrationRequest.branchAddress" control-id="txtbankAddress" theme-type="{{vm.theme}}" form="bankInfo" control-disabled="true"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.tradingBranch"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-ach ng-if="!vm.isEdit" control-model="vm.customerRegistrationRequest.tradingBranch" control-id="txttradingBranch" theme-type="{{vm.theme}}" lookup-name="validBranchesForBank" filter-value="{{vm.customerRegistrationRequest.bank.id}}" display-column="ifscCode,branchName" form="bankInfo" control-disabled="vm.userEntityOwnerType!=\'Bank\' || !(vm.userEntityOwnerType==\'Bank\' && vm.mode==\'customerApprovalToDo\' && vm.customerRegistrationRequest.actionType==\'ADD\')" control-modified="vm.checkforTradingBranchModification()" control-required="!vm.disableTradingBranch || (vm.mode==\'customerApprovalToDo\')"></cspl-ach><cspl-ach ng-if="vm.isEdit" control-model="vm.customerRegistrationRequest.tradingBranch" control-id="txttradingBranch2" theme-type="{{vm.theme}}" lookup-name="validStatusBranchesForBank" display-column="ifscCode,branchName" filter-value="{{vm.customerRegistrationRequest.bank.id}}" form="bankInfo" required></cspl-ach><span class="help-block" ng-show="vm.customerRegistrationRequest.tradingBranch!=null" style="word-break: break-word">({{vm.customerRegistrationRequest.tradingBranch.branchName}})</span> <span class="help-block" ng-show="(vm.customerRegistrationRequest.tradingBranch==null || vm.customerRegistrationRequest.tradingBranch==undefined) && (vm.mode==\'customerApprovalToDo\' || vm.mode==\'modifycustomerdetails\')"><span data-translate="gatewayApp.customerRegistration.helpText.branch"></span></span><!-- <span class="help-block" ng-show="vm.isEdit && vm.noChange"><span data-translate="gatewayApp.customerRegistration.helpText.oldTradingBranch"></span>{{ \' \' +vm.oldTradingBranch.ifscCode }}</span> --></div></div></ng-form>');
$templateCache.put('app/entities/customer-registration/bank-info.html','<br><div class="row"><span class="group-heading">Bank Relationship</span></div><br><div class="row"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.bankName"></span>&nbsp;* <span class="icon" cspl-info-tooltip="Enter name of Relationship Bank" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.customerRegistrationRequest.bank" control-id="txtBank" lookup-name="bankDetails" theme-type="light" display-column="shortName" form="customerRegistration" required></cspl-ach></div></div><div class="row"><label class="col-md-9 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.bankAccountNumber"></span>&nbsp;* <span class="icon" cspl-info-tooltip="Enter the account number held with Relationship bank" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.bankAccountNumber" control-id="txtbankAccountNumber" control-type="Number" control-maxlength="20" form="customerRegistration" required></div></div><div class="row"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.homeBranch"></span>&nbsp;* <span class="icon" cspl-info-tooltip="Enter the Branch name where account is maintained with Bank" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.customerRegistrationRequest.homeBranch" control-id="txthomeBranch" theme-type="light" lookup-name="homeBranch" display-column="ifscCode,branchName" filter-value="{{vm.filterText}}" form="customerRegistration" required></cspl-ach><span class="help-block" ng-show="vm.customerRegistrationRequest.homeBranch!=null">({{vm.customerRegistrationRequest.homeBranch.branchName}})</span> <span class="help-block" ng-show="vm.customerRegistrationRequest.homeBranch==null || vm.customerRegistrationRequest.homeBranch==undefined"><span data-translate="gatewayApp.customerRegistration.helpText.branch"></span></span></div></div><div class="row"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.branchAddress"></span> <span class="icon" cspl-info-tooltip="Home Branch Address details" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-multiline-text control-model="vm.tradingBranchAddress" control-id="txtbranchAddress" theme-type="light" form="customerRegistration"></div></div><span class="help-block" style="margin-right: 35%;   text-align: right;  padding-bottom: 10px"><span data-translate="gatewayApp.customerRegistration.payable"></span></span><div class="row"><label class="col-md-5 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.tradingBranch"></span> <span class="icon" cspl-info-tooltip="The trading branch would be assigned by your Relationship bank" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach control-model="vm.customerRegistrationRequest.tradingBranch" control-id="txttradingBranch" theme-type="light" lookup-name="validBranchDetailsForBank" display-column="ifscCode,branchName" filter-value="{{vm.customerRegistrationRequest.bank.id}}~~" form="customerRegistration" control-disabled="vm.disableTradingBranch" control-required="!vm.disableTradingBranch"></cspl-ach><span class="help-block" data-translate="gatewayApp.customerRegistration.helpText.idontknow"></span></div></div><br>');
$templateCache.put('app/entities/customer-registration/customer-info-preview.html','<div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.address1"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.address1" control-id="txtcustomeraddress1" control-disabled="true" form="usersInfo" control-modified="vm.checkforModification(\'address1\')" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.address2"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.address2" control-id="txtcustomeraddress2" control-disabled="true" form="usersInfo" control-modified="vm.checkforModification(\'address2\')"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.city"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.city" control-id="txtcustomercity" control-disabled="true" form="usersInfo" required control-modified="vm.checkforModification(\'city\')"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.country"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.country.shortName" control-id="txtCountry" control-disabled="true" form="usersInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.state"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.state.shortName" control-id="txtState" control-disabled="true" form="usersInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.pincode"></span></label></div><div class="col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.pincode" control-id="txtcustomerpincode" control-type="Alphanumeric" control-disabled="true" form="usersInfo" control-maxlength="7" required></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex].display"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.gstinAndStateCode"></span></label></div><div class="col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.gstin" control-id="txtgstin" control-disabled="true" form="customerInfo" control-modified="vm.checkforModification(\'gstin\')"></div><div class="col-md-2"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.stateCode" control-id="txtstateCode" form="customerInfo" control-disabled="true" control-modified="vm.checkforModification(\'stateCode\')"></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex].display"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.legalEntityIdentifier"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.legalEntityIdentifier" control-id="txtlegalEntityIdentifier" control-disabled="true" form="customerInfo"></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex].display"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.validUpto"></span></label></div><div class="col-md-6"><cspl-text theme-type="{{vm.theme}}" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex].display" control-model="vm.leiExpiryDate" control-id="txtLeiExpriy" control-disabled="true" form="customerInfo"></div></div>');
$templateCache.put('app/entities/customer-registration/customer-info-view-dialog.html','<ng-form name="customerInfo" ng-if="vm.cutomerInfo"><div ng-if="vm.mode==\'customerApprovalToDo\' && vm.userEntityOwnerType==\'Bank\'" class="col-md-5" style="margin-top: 20px; margin-bottom: 10px;float:right"><span data-translate="gatewayApp.customerInfo.highlightedFiledLegend" class="field-highlighted-legend legend-white-color"></span> <span data-translate="gatewayApp.customerInfo.mandatory" class="field-highlighted-legend legend-blue-color"></span></div><div ng-if="vm.mode==\'customerInfoChangeStatus\' || (vm.mode==\'modifycustomerdetails_todo\' && !vm.isEdit)" class="col-md-5" style="margin-top: 20px; margin-bottom: 10px;float:right"><span data-translate="gatewayApp.customerInfo.highlightedFiledLegend" class="field-highlighted-legend legend-white-color"></span> <span data-translate="gatewayApp.customerInfo.modified" class="field-highlighted-legend legend-blue-color"></span></div><div class="row"><h4 ng-show="vm.theme==\'dark\'" class="panel-title col-md-offset-2" style="margin-top: 20px; margin-bottom: 10px">&nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.CustomerProfile"></span></h4><h4 ng-show="vm.theme==\'light\'" class="panel-title col-md-offset-2" style="width: 400px; margin-top: 20px; margin-bottom: 10px">&nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.CustomerProfile"></span></h4></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.customerType"></span></label></div><div class="row" style="margin-bottom:8px"><div class="col-md-6 col-md-offset-3"><select class="form-control select" name="customerType" ng-model="vm.customerRegistrationRequest.customerType" ng-options="customerType as customerType.name for customerType in vm.customerTypes track by customerType.id" ng-disabled="true" ng-class="{red: customerInfo.customerType.$invalid && vm.touchedcustomertype}" form="customerInfo" required></select><span class="help-block-error" ng-show="customerInfo.customerType.$invalid && vm.touchedcustomertype">This field cannot be left blank</span></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n    && vm.inputDetailsForSelectedCustType[entityNameIndex]!= null \r\n    && vm.inputDetailsForSelectedCustType[entityNameIndex].display"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.companyName"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n    && vm.inputDetailsForSelectedCustType[entityNameIndex]!= null \r\n    && vm.inputDetailsForSelectedCustType[entityNameIndex].display"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.customerFirstName" control-id="txtfirstName" form="customerInfo" control-disabled="!vm.enableFieldsForResubmit" control-modified="vm.checkforModification(\'entityName\')" control-required="vm.inputDetailsForSelectedCustType[entityNameIndex].display && vm.inputDetailsForSelectedCustType[entityNameIndex].isMandatory"></div></div><div ng-if="vm.showSingleUser && !vm.isSoleProp" ng-include="\'app/entities/customer-registration/name-info-view-dialog.html\'"></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n    && vm.inputDetailsForSelectedCustType[panNoIndex]!= null \r\n    && vm.inputDetailsForSelectedCustType[panNoIndex].display && vm.userEntityOwnerType!=\'Clearcorp\'"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.panNo"></span></label></div><div class="row" style="margin-bottom:10px" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n    && vm.inputDetailsForSelectedCustType[panNoIndex]!= null \r\n    && vm.inputDetailsForSelectedCustType[panNoIndex].display && vm.userEntityOwnerType!=\'Clearcorp\'"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.panNumber" control-id="txtPanNo" form="customerInfo" control-disabled="true" control-required="!vm.customerRegistrationRequest.isProp"></div><div class="col-md-2" style="margin-top:5px" ng-show="vm.customerRegistrationRequest.panImage ||vm.customerRegistrationRequest.customerPanImage"><a ng-click="vm.viewPanImage()"><img ng-show="vm.theme==\'dark\'" ng-src="assets/images/panImage.png" ng-class="{\'higlightChange\' : vm.checkforModification(\'customerPanImage\')}"><img ng-show="vm.theme==\'light\'" ng-src="assets/images/PAN Image-24.png"></a></div></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n    && vm.inputDetailsForSelectedCustType[panImageIndex]!= null \r\n    && vm.inputDetailsForSelectedCustType[panImageIndex].display && vm.enableFieldsForResubmit"><div class="row"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="gatewayApp.customerRegistration.panImageUpload"></span></label></div><div class="row" style="margin-bottom:10px"><div class="row col-md-10 col-md-offset-3 input-group"><input type="text" class="customer-regview-pan-upload form-control fileOpen" ng-model="vm.inputPanImage" ng-blur="vm.checkPanImage=true;" readonly="readonly"><label for="panImageFile" class="btn btn-primary fileUploadDark"><img src="assets/images/Open path-24.png"></label><input type="file" id="panImageFile" name="panImageUpload" file-model="vm.image" accept="image/x-png,image/jpg,image/jpeg,application/pdf" form="customerInfo" ng-hide="true"> <span class="help-block-error-pan" ng-show="vm.invalidPanImageSize">PAN image size should not be greater than 100 kb.</span></div></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[stateCodeIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[stateCodeIndex].display"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.customerRegistration.gstinAndStateCode"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[stateCodeIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[stateCodeIndex].display"><div class="col-md-3 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.gstin" control-id="txtgstin" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-modified="vm.checkforModification(\'gstin\')"></div><div class="col-lg-1"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.stateCode" control-id="txtstateCode" form="customerInfo" control-disabled="!vm.enableFieldsForResubmit" control-modified="vm.checkforModification(\'stateCode\')"></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex].display"><label class="col-md-4 control-label col-md-offset-3"><span data-translate="gatewayApp.customerRegistration.legalEntityIdentifier"></span></label><label class="col-md-3 control-label"><span data-translate="gatewayApp.customerRegistration.validUpto"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex].display"><div class="col-md-4 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.legalEntityIdentifier" control-id="txtlegalEntityIdentifier" control-disabled="true" form="customerInfo"></div><div class="col-md-3" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex].display"><cspl-dtp theme-type="{{vm.theme}}" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex].display" control-disabled="true" control-model="vm.customerRegistrationRequest.leiExpiryDate" control-id="leiValidUpto" form="customerInfo"></cspl-dtp></div></div></ng-form>');
$templateCache.put('app/entities/customer-registration/customer-info.html','<div class="row"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.address1"></span>&nbsp;* <span class="icon" cspl-info-tooltip="{{vm.address1Info}}" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.address1" control-id="txtcustomeraddress1" control-maxlength="255" form="customerRegistration" required></div></div><div class="row"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.address2"></span> <span class="icon" cspl-info-tooltip="{{vm.address2Info}}" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.address2" control-id="txtcustomeraddress2" control-maxlength="255" form="customerRegistration"></div></div><div class="row"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.city"></span>&nbsp;* <span class="icon" cspl-info-tooltip="Enter name of City" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.city" control-id="txtcustomercity" control-maxlength="255" form="customerRegistration" required></div></div><div class="row"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.country"></span>&nbsp;* <span class="icon" cspl-info-tooltip="Enter Country" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-5 col-md-offset-1"><cspl-ach theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.country" control-id="txtcustomerCountry" lookup-name="country" display-column="shortName" form="customerRegistration" required></cspl-ach></div></div><div class="row"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.state"></span>&nbsp;* <span class="icon" cspl-info-tooltip="Enter State" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-ach theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.state" control-id="txtcustomerstate" lookup-name="state" display-column="shortName" filter-value="{{vm.customerRegistrationRequest.country.id}}~~" form="customerRegistration" required></cspl-ach></div></div><div class="row"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.pincode"></span>&nbsp;* <span class="icon" cspl-info-tooltip="Enter Pin Code" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.pincode" control-id="txtcustomerpincode" control-type="Alphanumeric" control-maxlength="7" form="customerRegistration" required></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex].display"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.gstinAndStateCode"></span> <span class="icon" cspl-info-tooltip="Enter GSTIN & State Code" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex].display"><div class="col-xs-5 col-md-offset-1"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.gstin" control-id="txtgstin" control-type="Alphanumeric" control-minlength="15" control-maxlength="15" form="customerRegistration"></div><div class="col-xs-2"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.stateCode" control-minlength="2" control-maxlength="2" control-id="txtstateCode" form="customerRegistration"></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex].display"><label class="col-xs-6 col-md-4 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.legalEntityIdentifier"></span> <span class="icon" cspl-info-tooltip="Enter the Legal Entity Identifier (LEI) number" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex].display"><div class="col-xs-6 col-md-4 col-md-offset-1"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.legalEntityIdentifier" control-type="Alphanumeric" control-id="txtlegalEntityIdentifier" control-minlength="20" control-maxlength="20" form="customerRegistration"></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex].display"><label class="col-xs-6 col-md-4 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.validUpto"></span> <span class="icon" cspl-info-tooltip="Enter the LEI Expiry date" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n                            && vm.inputDetailsForSelectedCustType[leiExpiryDateIndex]!= null \r\n                            && vm.inputDetailsForSelectedCustType[leiExpiryDateIndex].display"><div class="col-xs-6 col-md-4 col-md-offset-1"><cspl-dtp theme-type="{{vm.theme}}" control-disabled="vm.disableLeiExpiry" control-required="vm.leiExpiryRequired" control-model="vm.customerRegistrationRequest.leiExpiryDate" control-min-date="vm.leiMinDate" control-id="leiValidUpto" form="customerRegistration"></cspl-dtp></div></div>');
$templateCache.put('app/entities/customer-registration/customer-registration-approval-disclaimer-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()" style="color:#F2F2F2">&times;</button><h4 class="modal-title">Disclaimer</h4></div><div class="modal-body"><div class="content"><div class="row"><label class="justified-tac-label" style="margin-top: 20px;   margin-left: 8%;  margin-right: 8%;  padding-bottom: 10px"><span data-translate="gatewayApp.customerRegistration.bankApproverTACText.text1"></span> <a ng-click="vm.onGetCcilTac(vm.organisation.id,vm.messageBoxName)"><span data-translate="gatewayApp.customerRegistration.bankApproverTACText.text2"></span></a> <span data-translate="gatewayApp.customerRegistration.bankApproverTACText.text3"></span></label></div></div><div class="modal-footer"><button type="button" class="btn btn-approve" ng-disabled="clicked" ng-click="clicked = true;vm.approve();"><span data-translate="entity.action.approve">Approve</span></button> <button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button></div></div>');
$templateCache.put('app/entities/customer-registration/customer-registration-new-preview.html','<div class="{{vm.theme}}"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-title"><span data-translate="gatewayApp.customerRegistration.previewCustomerRegistration"></span></div></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content" class="col-md-12"><!-- inner html start--><div ng-show="vm.showSingleUser" ng-include="\'app/entities/customer-registration/single-user-customer-preview.html\'"></div><div ng-show="vm.showMultiUser" ng-include="\'app/entities/customer-registration/multi-user-customer-preview.html\'"></div><div class="col-md-4"><div ng-include="\'app/entities/customer-registration/bank-info-preview.html\'"></div><!-- end --><div class="col-md-12" style="padding: 8px; padding-top: 0px"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.sourceOfIntro"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.sourceOfIntro.displayName" control-id="txtsourceOfIntro" control-disabled="true" required></cspl-text></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary secondaryAction" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1" style="width:100px"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-disabled="vm.clicked" class="btn btn-info" ng-click="vm.print();vm.clicked=true;" style="width:100px">&nbsp;<span style="text-align: center">Print</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.clicked=true;vm.submit()" ng-disabled="vm.clicked" style="width:100px"><span data-translate="entity.action.submit">Submit</span></button></div></div></div>');
$templateCache.put('app/entities/customer-registration/customer-registration-new-view-dialog.html','<div class="{{vm.theme}}"><form name="customerRegistrationView" role="form" novalidate><div class="modal-header"><div class="modal-title" ng-if="vm.isModifyScreen == false"><span data-translate="gatewayApp.customerRegistration.ViewCustomerRegistration"></span></div><div class="modal-title" ng-if="vm.isModifyScreen==true"><span data-translate="gatewayApp.tradingBranchModifyDetails.modifyDetails"></span></div></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content" style="max-height: 65vh"><div ng-include="\'app/entities/customer-registration/customer-info-view-dialog.html\'"></div><div ng-if="vm.showMultiUser && vm.authPersonInfo && !vm.customerRegistrationRequest.isProp" ng-include="\'app/entities/customer-registration/name-info-view-dialog.html\'"></div><div ng-include="\'app/entities/customer-registration/bank-info-view-dialog.html\'"></div><div ng-if="vm.userEntityOwnerType==\'Clearcorp\'||vm.mode == \'customeronboardingstatus\'"><div class="row"><label class="col-md-6 control-label col-md-offset-3" ng-if="vm.userEntityOwnerType==\'Clearcorp\'" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.sourceOfIntroByClearCorp"></span></label><label class="col-md-6 control-label col-md-offset-3" ng-if="vm.userEntityOwnerType!=\'Clearcorp\'" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.sourceOfIntro"></span></label></div><div class="row" style="margin-bottom:8px"><div class="col-md-6 col-md-offset-3"><select class="form-control select" name="sourceOfIntro" ng-model="vm.customerRegistrationRequest.sourceOfIntro" ng-options="sourceOfIntro as sourceOfIntro.displayName for sourceOfIntro in vm.sourceOfIntro track by sourceOfIntro.id" ng-disabled="true" ng-class="{red: customerRegistration.sourceOfIntro.$invalid && vm.touchedsourceOfIntro}" form="customerRegistrationView" required></select><span class="help-block-error" ng-show="customerRegistration.sourceOfIntro.$invalid && vm.touchedsourceOfIntro">This field cannot be left blank</span></div></div></div><div ng-include="\'app/entities/customer-registration/markup-info-view-dialog.html\'"></div></div></div><div class="modal-footer"><div ng-show="vm.showButton && vm.customerRegistrationRequest.actionType != \'REMOVE\' && vm.mode != \'customerInfoChangeStatus\' && vm.mode != \'modifycustomerdetails_todo\' " style="margin-bottom: 10px"><label class="justified-tac-label" style="margin-top: 20px;   margin-left: 8%;  margin-right: 8%;  padding-bottom: 10px"><span data-translate="gatewayApp.customerRegistration.bankApproverTACText.text1"></span> <a ng-click="vm.onGetCcilTac(vm.organisation.id,vm.messageBoxName)"><span data-translate="gatewayApp.customerRegistration.bankApproverTACText.text2"></span></a> <span data-translate="gatewayApp.customerRegistration.bankApproverTACText.text3"></span></label></div><div ng-show="vm.mode == \'customerViewReport\' && !vm.customerRegistrationRequest.isProp" style="margin-bottom: 10px; text-align: left"><label style="margin-left: 11%"><a style="text-decoration: underline; font-size: 14px" ng-click="vm.viewAcceptedTermsAndConditions()"><span data-translate="gatewayApp.customerRegistration.viewTermsAndConditions"></span></a></label></div><button type="button" class="btn btn-info" ng-show="vm.showPrint" data-dismiss="modal" ng-click="vm.print()">&nbsp;<span style="text-align: center">PRINT</span></button> <button type="button" class="btn btn-info" ng-show="!vm.withdraw  && !vm.isEdit" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span style="text-align: center">OK</span></button> <button type="button" class="btn btn-info secondaryAction" ng-show="vm.withdraw" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span style="text-align: center">OK</span></button> <button type="button" ng-if="vm.showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.isModifyScreen? vm.discardModifyCustomerDetails() :vm.discardCustomerUpdate()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="vm.showButton" class="btn btn-reject" ng-click="vm.isModifyScreen? vm.rejectCustomerModification() : vm.rejectCustomerRegistration()"><span data-translate="entity.action.reject">Reject</span></button> <!-- <button type="button" ng-if="vm.showButton && vm.mode ==\'customerApprovalToDo\'" autofocus class="btn  btn-approve" ng-disabled="(vm.customerRegistrationRequest.tradingBranch==null || vm.customerRegistrationRequest.tradingBranch==undefined || vm.customerRegistrationRequest.markupSettings.markupValue==null || vm.customerRegistrationRequest.markupSettings.markupValue==undefined || vm.customerRegistrationRequest.markupSettings.markupValue==\'\' || vm.clicked)" \r\n         ng-click="vm.clicked = true;vm.isModifyScreen?vm.approveModifyCustomerDetails():vm.approveCustomerRegistration();">\r\n            <span data-translate="entity.action.approve" >Approve</span>\r\n         </button> --> <button type="button" ng-if="vm.showButton" class="btn btn-approve" ng-disabled="(vm.customerRegistrationRequest.tradingBranch==null || vm.customerRegistrationRequest.tradingBranch==undefined || vm.clicked || customerRegistrationView.markup.$invalid)" ng-click="vm.clicked = true;vm.isModifyScreen?vm.approveModifyCustomerDetails():vm.approveCustomerRegistration();"><span data-translate="entity.action.approve">Approve</span></button> <button type="button" class="btn btn-info secondaryAction" style="width: 100px" ng-disabled="vm.clicked" ng-if="vm.mode == \'customeronboardingstatus\' || vm.mode == \'registrationrequeststatus\'" data-dismiss="modal" ng-click="vm.downloadAnnexure1();vm.clicked=true;">&nbsp;<span style="text-align: center">Download</span></button> <button type="submit" style="width:100px" ng-if="vm.withdraw" class="btn btn-reject" ng-disabled="vm.clicked" ng-click="vm.clicked=true;vm.withdrawRequest()"><span data-translate="gatewayApp.customerRegistration.withdraw">Withdraw</span></button> <button type="button" class="btn btn-info" data-dismiss="modal" ng-if="vm.isEdit" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="vm.showResubmitButton" class="btn btn-primary" ng-click="clicked = true;vm.isModifyScreen? vm.resubmitModifyCustomerDetails() : vm.resubmitCustomerRegistration();" ng-disabled="vm.isModifyScreen?(bankInfo.$invalid || vm.clicked ): vm.clicked "><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="vm.isEdit && vm.mode == \'modifycustomerdetails\' " autofocus class="btn btn-info active" ng-disabled="bankInfo.$invalid || vm.clicked" ng-click="vm.clicked = true;vm.saveModificationOnCustomerDetails();"><span data-translate="entity.action.save">Save</span></button></div></form></div>');
$templateCache.put('app/entities/customer-registration/customer-registration-new.html','<style>.auth-section .form-control {\r\n      padding-left: 30px;\r\n    }\r\n    .red{\r\n        border: 1px solid #FF3737;\r\n    }</style><div class="customer-registration-layout-no-leftnav"><section class="customer-registration-section customer-onboarding"><div class="row"><div class="form-box col-md-6 col-md-offset-3"><div class="form-box-heading"><img class="customer-page-logo" src="assets/images/ClearCorp.png"> <span class="customer-registration-logo" data-translate="gatewayApp.customerRegistration.customerRegistrationLogo"></span> <span ng-if="vm.environmentName!=\'\' &&  vm.environmentName!=undefined &&  vm.environmentName!=null" style="margin-bottom: 30px" class="btn-reg fw-bolder environment-name">{{vm.environmentName}}</span> <img class="customer-page-header" src="assets/images/FX_CR.png"></div><div class="form-box-inner"><div><nmb-alert-error></nmb-alert-error></div><div class="row" style="text-align:right"><label class="form-label" ng-click="vm.openHelpWindow()"><a class="resubmit-link" data-translate="gatewayApp.customerRegistration.needHelp"></a></label><span style="font-size:16px">&nbsp;|&nbsp;</span><label class="form-label" ng-click="vm.fetchRejectedRequest()"><a class="resubmit-link" data-translate="gatewayApp.customerRegistration.resubmitRejectedRequest"></a></label><br><span style="float: right; margin-top:0px !important" class="onboarding-help-text">Note: All (*) fields are mandatory</span></div><form name="customerRegistration"><div class="new-content" style="padding-left:3%;padding-right: 10%"><!-- inner html start--><div ng-include="\'app/entities/customer-registration/general-customer-info.html\'"></div><div ng-show="vm.showSingleUser" ng-include="\'app/entities/customer-registration/single-user-customer.html\'"></div><div ng-show="vm.showMultiUser" ng-include="\'app/entities/customer-registration/multi-user-customer.html\'"></div><!-- end --><div class="row"><label class="col-md-6 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.sourceOfIntro"></span>&nbsp;* <span class="icon" cspl-info-tooltip="Source of information about FX-Retail Platform" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row" style="margin-bottom:8px"><div class="col-md-7 col-md-offset-1"><select class="form-control select-style light-select" name="sourceOfIntro" ng-model="vm.customerRegistrationRequest.sourceOfIntro" ng-options="sourceOfIntro as sourceOfIntro.displayName for sourceOfIntro in vm.sourceOfIntro track by sourceOfIntro.id" ng-init="vm.touchedsourceOfIntro=false" ng-focus="vm.touchedsourceOfIntro=true" ng-class="{red: customerRegistration.sourceOfIntro.$invalid && vm.touchedsourceOfIntro}" form="customerRegistration" required><option value="" selected="selected" hidden></option></select><span class="help-block-error" ng-show="customerRegistration.sourceOfIntro.$invalid && vm.touchedsourceOfIntro">This field cannot be left blank</span></div></div><div class="row"><div class="col-md-10 col-md-offset-1"><input type="checkbox" style="margin-right:1%;vertical-align:middle;margin-bottom:3px" checklist-model="vm.termsAndCondition" checklist-value="termsAndConditions" ng-model="termsAndConditions" required> <a ng-click="vm.previewClearcorpTAC()"><span data-translate="gatewayApp.customerRegistration.termsAndConditions"></span></a></div></div><div class="row" style="margin-top: 5px" ng-if="false"><div class="col-md-10 col-md-offset-1"><input type="checkbox" style="margin-right:1%;vertical-align:middle;margin-bottom:3px" checklist-model="vm.termsAndConditionForBank" checklist-value="termsAndConditionsForBank" ng-model="termsAndConditionsForBank" ng-required="vm.bankTAC!=null"> <a ng-click="vm.previewBankTAC()"><span data-translate="gatewayApp.customerRegistration.termsAndConditionsOfBank"></span></a></div></div></div><div class="form-box-inner modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" ng-hide="true"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-info" ng-disabled="customerRegistration.$invalid||(!vm.isUserMobileVerified && !vm.skipOTPUserMobile)||vm.clicked" ng-click="vm.submit()"><span data-translate="gatewayApp.customerRegistration.previewSubmit"></span></button><div class="col-xs-7" style="padding-top:5px"><!-- <div class="onboarding-help-text" >\r\n                                     <span   data-translate="gatewayApp.customerRegistration.registrationCharge"></span>\r\n         \r\n                                 </div> --></div></div></form></div></div></div></section></div>');
$templateCache.put('app/entities/customer-registration/customer-registration-preview.html','<div class="{{vm.theme}}"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-title"><span data-translate="gatewayApp.customerRegistration.previewCustomerRegistration"></span></div></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content" class="col-md-12"><div class="col-md-4"><div class="headerForm"><h5 class="formHeading" data-translate="gatewayApp.customerRegistration.CustomerProfile"></h5></div><form name="customerInfo"><div style="display:table" class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.customerType" style="display:cell"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.customerType.name" control-id="txtCustomerType" form="customerInfo" control-disabled="true" required></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex].display"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.companyName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.companyName" control-id="txtfirstName" form="customerInfo" control-disabled="true" control-required="vm.inputDetailsForSelectedCustType[entityNameIndex].isMandatory"></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex].display"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.firstName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.customerFirstName" control-id="txtfirstName" form="customerInfo" control-disabled="true" control-required="vm.inputDetailsForSelectedCustType[firstNameIndex].isMandatory"></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex].display"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.middleName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.customerMiddleName" control-id="txtmiddleName" control-maxlength="100" form="customerInfo" control-disabled="true" control-modified="vm.checkforModification(\'customerMiddleName\')"></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex].display"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.lastName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.customerLastName" control-id="txtLastName" control-disabled="true" form="customerInfo" control-required="vm.inputDetailsForSelectedCustType[lastNameIndex].isMandatory" control-modified="vm.checkforModification(\'customerLastName\')"></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex].display"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.panNo"></span></label></div><div class="col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.panNumber" control-id="txtPanNo" form="customerInfo" control-disabled="true" control-required="vm.inputDetailsForSelectedCustType[panNoIndex].isMandatory"></div><div class="col-md-2" style="margin-top:5px"><a ng-click="vm.viewPanImage()"><img ng-show="vm.theme==\'dark\'" ng-src="assets/images/panImage.png" ng-class="{\'higlightChange\' : vm.checkforModification(\'customerPanImage\')}"><img ng-show="vm.theme==\'light\'" ng-src="assets/images/PAN Image-24.png"></a></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex].display"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.legalEntityIdentifier"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.legalEntityIdentifier" control-id="txtlegalEntityIdentifier" control-disabled="true" form="customerInfo"></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex].display"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.validUpto"></span></label></div><div class="col-md-6"><cspl-text theme-type="{{vm.theme}}" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex].display" control-model="vm.leiExpiryDate" control-id="txtLeiExpriy" control-disabled="true" form="customerInfo"></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[cinIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[cinIndex].display"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.corporateIdentificationNumber"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.corporateIdentificationNumber" control-id="txtcorporateIdentificationNumber" control-disabled="true" form="customerInfo"></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex].display"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.gstinAndStateCode"></span></label></div><div class="col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.gstin" control-id="txtgstin" control-disabled="true" form="customerInfo" control-modified="vm.checkforModification(\'gstin\')"></div><div class="col-md-2"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.stateCode" control-id="txtstateCode" form="customerInfo" control-disabled="true" control-modified="vm.checkforModification(\'stateCode\')"></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex].display"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.dobOrDoi"></span></label></div><div class="col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.dobOrDoi" control-id="txtDoborDoi" control-disabled="true" form="usersInfo" control-modified="vm.checkforModification(\'address1\')" control-required="vm.inputDetailsForSelectedCustType[dobDoiIndex].isMandatory"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.address1"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.address1" control-id="txtcustomeraddress1" control-disabled="true" form="usersInfo" control-modified="vm.checkforModification(\'address1\')" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.address2"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.address2" control-id="txtcustomeraddress2" control-disabled="true" form="usersInfo" control-modified="vm.checkforModification(\'address2\')"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.city"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.city" control-id="txtcustomercity" control-disabled="true" form="usersInfo" required control-modified="vm.checkforModification(\'city\')"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.country"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.country.shortName" control-id="txtCountry" control-disabled="true" form="usersInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.state"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.state.shortName" control-id="txtState" control-disabled="true" form="usersInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.pincode"></span></label></div><div class="col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.pincode" control-id="txtcustomerpincode" control-type="Alphanumeric" control-disabled="true" form="usersInfo" control-maxlength="7" required></div></div><label class="previewHeading"><span data-translate="gatewayApp.customerRegistration.primaryContact"></span></label><br><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.name"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.primaryContactName" control-id="txtprimaryContractName" control-disabled="true" form="customerInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.email"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.primaryEmail" control-type="Email" control-id="txtemail" control-disabled="true" form="customerInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.mobile"></span></label></div><div class="col-xs-2 col-md-2"><cspl-numeric theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.primaryMobileCountryCode" control-id="txtprimaryMobileCountryCode" no-of-decimals="0" control-disabled="true" form="customerInfo" required></div><div class="col-xs-7 col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.primaryMobile" control-type="Number" control-id="txtprimaryMobile" control-disabled="true" form="customerInfo" control-maxlength="15" required></div></div><label class="previewHeading"><span data-translate="gatewayApp.customerRegistration.alternateContact1"></span></label><br><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.name"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateContactName1" control-id="txtalternateName1" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-modified="vm.checkforModification(\'alternateContactName1\')"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.email"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateEmail1" control-type="Email" control-id="txtemail11" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-modified="vm.checkforModification(\'alternateEmail1\')"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.mobile"></span></label></div><div class="col-xs-2 col-md-2"><cspl-numeric theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateMobileCountryCode1" control-id="txtalternateMobileCountryCode1" control-disabled="!vm.enableFieldsForResubmit" no-of-decimals="0" form="customerInfo" control-modified="vm.checkforModification(\'alternateMobileCountryCode1\')"></div><div class="col-xs-7 col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateMobile1" control-type="Number" control-id="txtalternateMobile1" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-maxlength="15" control-modified="vm.checkforModification(\'alternateMobile1\')"></div></div><label class="previewHeading"><span data-translate="gatewayApp.customerRegistration.alternateContact2"></span></label><br><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.name"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateContactName2" control-id="txtalternateName2" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-modified="vm.checkforModification(\'alternateContactName2\')"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.email"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateEmail2" control-type="Email" control-id="txtemail12" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-modified="vm.checkforModification(\'alternateEmail2\')"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.mobile"></span></label></div><div class="col-xs-2 col-md-2"><cspl-numeric theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateMobileCountryCode2" control-id="txtalternateMobileCountryCode2" control-disabled="!vm.enableFieldsForResubmit" no-of-decimals="0" form="customerInfo" control-modified="vm.checkforModification(\'alternateMobileCountryCode2\')"></div><div class="col-xs-7 col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateMobile2" control-type="Number" control-maxlength="15" control-id="txtalternateMobile2" control-disabled="!vm.enableFieldsForResubmit" control-modified="vm.checkforModification(\'alternateMobile2\')" form="customerInfo"></div></div></form></div><div class="col-md-4"><div class="headerForm"><h5 class="formHeading" data-translate="gatewayApp.customerRegistration.bankRelationship"></h5></div><form name="bankInfo"><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.bankName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.bank.bankName" control-id="txtbank" form="bankInfo" control-disabled="true" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.homeBranch"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.homeBranch.ifscCode" control-id="txtHomeBranch" form="bankInfo" control-disabled="true" required></cspl-text><span style="margin-bottom: 5px" class="help-block" ng-show="vm.customerRegistrationRequest.homeBranch!=null">({{vm.customerRegistrationRequest.homeBranch.branchName}})</span></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.bankAccountNumber"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.bankAccountNumber" control-id="txtbankAccountNumber" form="bankInfo" control-disabled="true" required></div></div><div class="col-md-12"><div class="col-md-4"></div><div class="col-md-8"><cspl-checkbox class="control-label" id="chkAssignBranch" theme-type="{{vm.theme}}" ng-model="vm.customerRegistrationRequest.assignTradingBranch" label-value="{{\'gatewayApp.customerRegistration.idontknow\' | translate}}" ng-disabled="true"></cspl-checkbox></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.tradingBranch"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.tradingBranch.ifscCode" control-id="txtTradingBranch" form="bankInfo" control-disabled="vm.customerRegistrationRequest.assignTradingBranch || !vm.customerRegistrationRequest.assignTradingBranch" control-required="!vm.customerRegistrationRequest.assignTradingBranch"></cspl-text><span style="margin-bottom: 5px" class="help-block" ng-show="vm.customerRegistrationRequest.tradingBranch!=null">({{vm.customerRegistrationRequest.tradingBranch.branchName}})</span></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.branchAddress"></span></label></div><div class="col-md-8"><cspl-multiline-text control-model="vm.customerRegistrationRequest.branchAddress" control-id="txtbankAddress" theme-type="{{vm.theme}}" form="bankInfo" control-disabled="true"></div></div></form></div><div class="col-md-4"><div class="headerForm"><h5 class="formHeading" data-translate="gatewayApp.customerRegistration.defaultUserInfo"></h5></div><form name="userInfo"><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.firstName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userFirstName" control-id="txtfirstName" control-disabled="true" form="usersInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.middleName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userMiddleName" control-id="txtmiddleName" control-disabled="true" form="usersInfo"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.lastName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userLastName" control-id="txtlastName" control-disabled="true" form="usersInfo" required></div></div><!-- <div class="col-md-12"  > \r\n\t\t\t\t\t\t<div   class="col-md-4">\r\n\t\t\t\t\t\t\t<label class="control-label"  ><span data-translate="gatewayApp.customerRegistration.aadharNumber" ></span></label>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div   class="col-md-8">\r\n\t\t\t\t\t\t\t<cspl-text theme-type="{{vm.theme}}" control-model = "vm.customerRegistrationRequest.aadharNumber" control-type="Number" control-id="txtaadharNumber" control-disabled="true"\r\n\t\t\t\t\t\t\t\t help-text="{{\'gatewayApp.customerRegistration.helpText.aadharNumber\' | translate}}"   form="usersInfo" />\r\n\t\t\t\t\t\t\t\t </div>\r\n\t\t\t\t\t\t</div> --><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.gender"></span></label></div><div class="col-md-8" style="padding-bottom:7px"><div id="btnGroup"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.customerRegistrationRequest.gender" ng-disabled="true" uib-btn-radio="\'M\'">M</label><label class="btn btn-primary" ng-model="vm.customerRegistrationRequest.gender" ng-disabled="true" uib-btn-radio="\'F\'">F&nbsp;</label><label class="btn btn-primary" ng-model="vm.customerRegistrationRequest.gender" ng-disabled="true" uib-btn-radio="\'O\'">O&nbsp;</label></div></div></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.dob"></span></label></div><div class="col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.dob" control-id="txtDob" control-disabled="true" form="usersInfo"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.login"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.login" control-id="txtLogin" control-disabled="true" form="usersInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.email"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userEmail" control-type="Email" control-id="txtemail" control-disabled="true" form="usersInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.mobile"></span></label></div><div><div class="col-xs-2 col-md-2"><cspl-numeric theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userMobileCountryCode" control-id="txtMobileCountryCode" no-of-decimals="0" form="usersInfo" control-disabled="true" required></div><div class="col-xs-7 col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userMobile" control-type="Number" control-id="txtMobile" control-disabled="true" form="usersInfo" required></div></div></div><div class="col-md-12"><div class="col-md-4"></div><span style="margin-bottom: 5px" class="help-block" data-translate="gatewayApp.customerRegistration.mobileEmailText">All info related to user will be sent to this Email ID and Mobile No.</span></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.address1"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userAddress1" control-id="txtaddress1" control-disabled="true" form="usersInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.address2"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userAddress2" control-id="txtaddress2" control-disabled="true" form="usersInfo"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.city"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userCity" control-id="txtcity" control-disabled="true" form="usersInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.country"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userCountry.shortName" control-id="txtCountry" control-disabled="true" form="usersInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.state"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userState.shortName" control-id="txtState" control-disabled="true" form="usersInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.pincode"></span></label></div><div class="col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userPincode" control-id="txtpincode" control-type="Alphanumeric" control-disabled="true" form="usersInfo" required></div></div></form></div></div><!-- <div  ng-hide="true"  ng-include="\'app/entities/customer-registration/customer-registration-print-view.html\'"  ></div>  --><div class="modal-footer"><button type="button" class="btn btn-primary secondaryAction" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1" style="width:100px"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-info" ng-click="vm.print()" style="width:100px">&nbsp;<span style="text-align: center">Print</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.clicked=true;vm.submit()" ng-disabled="vm.clicked" style="width:100px"><span data-translate="entity.action.submit">Submit</span></button></div></div></div>');
$templateCache.put('app/entities/customer-registration/customer-registration-print-view.html','<div id="printPage" style="font-size: 14px"><h3 style="padding: 2px 0px;  margin: 2%;   font-weight: bold;    color: black;  text-align:center;text-decoration: underline;  text-decoration-style: double">Customer Registration Details</h3><div style="width:100%;display:table;font-size: 14px"><div style="width:33%;display:table-cell;padding-right:1.5%;border-right:1px solid black"><div style="display:table;width:100%; margin-bottom: 3%"><span style="font-size:15px;  font-weight: bold;  color: black;text-decoration: underline;  text-decoration-style: double" data-translate="gatewayApp.customerRegistration.CustomerProfile"></span></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.customerType" style="display:cell"></span></div><div style="width:60%; display:table-cell;    word-break: break-all"><span>{{vm.customerRegistrationRequest.customerType.name}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%" ng-if="vm.customerRegistrationRequest.customerType.customerUserType.shortName==\'MultiUserCustomer\'"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.companyName" style="display:cell"></span></div><div style="width:60%; display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.customerFirstName || vm.customerRegistrationRequest.companyName}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%" ng-if="vm.customerRegistrationRequest.customerType.customerUserType.shortName!=\'MultiUserCustomer\'"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.firstName"></span></div><div style="width:60%; display:table-cell;    word-break: break-all"><span>{{vm.customerRegistrationRequest.customerFirstName}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%" ng-if="vm.customerRegistrationRequest.customerType.customerUserType.shortName!=\'MultiUserCustomer\'"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.middleName"></span></div><div style="width:60%;display:table-cell"><span>{{vm.customerRegistrationRequest.customerMiddleName}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%" ng-if="vm.customerRegistrationRequest.customerType.customerUserType.shortName!=\'MultiUserCustomer\'"><div style="width:40%;display:table-cell; font-weight: bold"><span data-translate="gatewayApp.customerRegistration.lastName"></span></div><div style="width:60%;display:table-cell;     word-break: break-all"><span>{{vm.customerRegistrationRequest.customerLastName}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell; font-weight: bold"><span data-translate="gatewayApp.customerRegistration.panNo"></span></div><div style="width:60%;display:table-cell"><span>{{vm.customerRegistrationRequest.panNumber}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%" ng-if="vm.customerRegistrationRequest.customerType.customerUserType.shortName==\'MultiUserCustomer\'"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.lei"></span></div><div style="width:60%; display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.legalEntityIdentifier }}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%" ng-if="vm.customerRegistrationRequest.customerType.customerUserType.shortName==\'MultiUserCustomer\'"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.validUpto"></span></div><div style="width:60%; display:table-cell"><span>{{vm.customerRegistrationRequest.leiExpiryDate | date : \'dd-MMM-yyyy\'}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%" ng-if="vm.customerRegistrationRequest.customerType.customerUserType.shortName==\'MultiUserCustomer\'"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.cin"></span></div><div style="width:60%; display:table-cell;    word-break: break-all"><span>{{vm.customerRegistrationRequest.corporateIdentificationNumber}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%" ng-if="vm.customerRegistrationRequest.customerType.customerUserType.shortName==\'MultiUserCustomer\'"><div style="width:40%;display:table-cell; font-weight: bold"><span data-translate="gatewayApp.customerRegistration.gstin"></span></div><div style="width:60%;  display:table-cell;  word-break: break-all"><span>{{ vm.customerRegistrationRequest.gstin }}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%" ng-if="vm.customerRegistrationRequest.customerType.customerUserType.shortName==\'MultiUserCustomer\'"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.stateCode"></span></div><div style="width:60%;  display:table-cell;  word-break: break-all"><span>{{ vm.customerRegistrationRequest.stateCode }}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell; font-weight: bold"><span data-translate="gatewayApp.customerRegistration.dobOrDoi"></span></div><div style="width:60%; display:table-cell"><span>{{vm.customerRegistrationRequest.dobOrDoi | date : \'dd-MMM-yyyy\'}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.address1"></span></div><div style="width:60%;display:table-cell;     word-break: break-all"><span>{{vm.customerRegistrationRequest.address1}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.address2"></span></div><div style="width:60%;display:table-cell;     word-break: break-all"><span>{{vm.customerRegistrationRequest.address2}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.city"></span></div><div style="width:60%;display:table-cell;     word-break: break-all"><span>{{vm.customerRegistrationRequest.city}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell; font-weight: bold"><span data-translate="gatewayApp.customerRegistration.country"></span></div><div style="width:60%;display:table-cell"><span>{{vm.customerRegistrationRequest.country.shortName}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell; font-weight: bold"><span data-translate="gatewayApp.customerRegistration.state"></span></div><div style="width:60%;display:table-cell;    word-break: break-all"><span>{{vm.customerRegistrationRequest.state.shortName}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.pincode"></span></div><div style="display:table-cell"><span>{{vm.customerRegistrationRequest.pincode}}</span></div></div></div><div style="width:33%;display:table-cell;padding-left:1.5%;border-right:1px solid black;padding-right:1.5%"><div style="font-weight: bold; color: black;padding-bottom: 3%"><span style="text-decoration: underline" data-translate="gatewayApp.customerRegistration.primaryContact"></span></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell; font-weight: bold"><span data-translate="gatewayApp.customerRegistration.name"></span></div><div style="display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.primaryContactName}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell; font-weight: bold"><span data-translate="gatewayApp.customerRegistration.email"></span></div><div style="width:60%;display:table-cell;      word-break: break-all"><span>{{vm.customerRegistrationRequest.primaryEmail}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.mobile"></span></div><div style="width:10%;display:table-cell"><span>{{vm.customerRegistrationRequest.primaryMobileCountryCode+ \' \'}}</span></div><div style="width:50%;display:table-cell;     word-break: break-all"><span>{{vm.customerRegistrationRequest.primaryMobile}}</span></div></div><div style="font-weight: bold;  ; color: black; padding-bottom: 3%"><span style="text-decoration: underline" data-translate="gatewayApp.customerRegistration.alternateContact1"></span></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.name"></span></div><div style="display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.alternateContactName1}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell; font-weight: bold"><span data-translate="gatewayApp.customerRegistration.email"></span></div><div style="width:60%;display:table-cell;       word-break: break-all"><span>{{vm.customerRegistrationRequest.alternateEmail1}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.mobile"></span></div><div style="width:10%;display:table-cell"><span ng-if="vm.customerRegistrationRequest.alternateMobile1!=null \r\n\t\t\t\t\t\t\t&& vm.customerRegistrationRequest.alternateMobile1!=undefined \r\n\t\t\t\t\t\t\t&& vm.customerRegistrationRequest.alternateMobile1!=\'\'">{{vm.customerRegistrationRequest.alternateMobileCountryCode1 + \' \'}}</span></div><div style="width:50%;display:table-cell;    word-break: break-all"><span>{{vm.customerRegistrationRequest.alternateMobile1}}</span></div></div><div style="font-weight: bold;  color: black; padding-bottom: 3%"><span style="text-decoration: underline" data-translate="gatewayApp.customerRegistration.alternateContact2"></span></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.name"></span></div><div style="display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.alternateContactName2}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.email"></span></div><div style="display:table-cell;  word-break: break-all"><span>{{vm.customerRegistrationRequest.alternateEmail2}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.mobile"></span></div><div style="width:10%;display:table-cell"><span ng-if="vm.customerRegistrationRequest.alternateMobile2!=null \r\n\t\t\t\t\t\t\t&& vm.customerRegistrationRequest.alternateMobile2!=undefined \r\n\t\t\t\t\t\t\t&& vm.customerRegistrationRequest.alternateMobile2!=\'\'">{{vm.customerRegistrationRequest.alternateMobileCountryCode2 + \' \'}}</span></div><div style="width:50%;display:table-cell;    word-break: break-all"><span>{{vm.customerRegistrationRequest.alternateMobile2}}</span></div></div><div style="display:table;width:100%;margin-bottom:3%"><span style="font-weight: bold; font-size:15px; color: black;text-decoration: underline;  text-decoration-style: double" data-translate="gatewayApp.customerRegistration.bankRelationship"></span></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.bankName"></span></div><div style="width:60%; display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.bank.bankName}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.homeBranch"></span></div><div style="width:60%; display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.homeBranch.ifscCode}}</span> <span style="margin-bottom: 5px; font-style:italic;  font-size: 10px;  text-align: right" ng-show="vm.customerRegistrationRequest.homeBranch!=null">({{vm.customerRegistrationRequest.homeBranch.branchName}})</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.bankAccountNumber"></span></div><div style="width:60%; display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.bankAccountNumber}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.tradingBranch"></span></div><div style="width:60%; display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.tradingBranch.ifscCode}}</span> <span style="margin-bottom: 5px; font-style:italic; font-size: 10px;  text-align: right" ng-show="vm.customerRegistrationRequest.tradingBranch!=null">({{vm.customerRegistrationRequest.tradingBranch.branchName}})</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell; font-weight: bold"><span data-translate="gatewayApp.customerRegistration.branchAddress"></span></div><div style="width:60%;  display:table-cell;  word-break: break-all"><span>{{vm.customerRegistrationRequest.branchAddress}}</span></div></div></div><div style="width:33%;display:table-cell;padding-left:1.5%"><div style="display:table;width:100%;margin-bottom:3%"><span style="text-decoration: underline;  text-decoration-style: double; font-size:15px; font-weight: bold;  color: black" data-translate="gatewayApp.customerRegistration.defaultUserInfo"></span></div><div style="display:table;width:100%"><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.firstName"></span></div><div style="width:60%; display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.userFirstName}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.middleName"></span></div><div style="width:60%; display:table-cell"><span>{{vm.customerRegistrationRequest.userMiddleName}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell; font-weight: bold"><span data-translate="gatewayApp.customerRegistration.lastName"></span></div><div style="width:60%; display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.userLastName}}</span></div></div><!-- <div style="display:table;width:100%;padding-bottom: 3%;"  > \r\n\t\t\t\t\t\t<div    style="width:40%;display:table-cell;font-weight: bold; " >\r\n\t\t\t\t\t\t\t<span data-translate="gatewayApp.customerRegistration.aadharNumber" ></span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div     style="width:60%;display:table-cell;     word-break: break-all;">\r\n\t\t\t\t\t\t\t<span>{{vm.customerRegistrationRequest.aadharNumber}}</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div> --><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.gender"></span></div><div style="width:60%;display:table-cell"><div id="btnGroup"><div class="btn-group"><span>{{vm.customerRegistrationRequest.gender}}</span></div></div></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.dob"></span></div><div style="width:60%;display:table-cell"><span>{{vm.customerRegistrationRequest.dob | date : \'dd-MMM-yyyy\'}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.login"></span></div><div style="width:60%;  display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.login}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.email"></span></div><div style="width:60%; display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.userEmail}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.mobile"></span></div><div><div style="width:10%;display:table-cell"><span>{{vm.customerRegistrationRequest.userMobileCountryCode + \' \'}}</span></div><div style="width:50%;  display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.userMobile}}</span></div></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell; font-weight: bold"><span data-translate="gatewayApp.customerRegistration.address1"></span></div><div style="width:60%; display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.address1}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.address2"></span></div><div style="width:60%;  display:table-cell;   word-break: break-all"><span>{{vm.customerRegistrationRequest.address2}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.city"></span></div><div style="width:60%;  display:table-cell;  word-break: break-all"><span>{{vm.customerRegistrationRequest.city}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.country"></span></div><div style="width:60%; display:table-cell"><span>{{vm.customerRegistrationRequest.country.shortName}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.state"></span></div><div style="width:60%; display:table-cell"><span>{{vm.customerRegistrationRequest.state.shortName}}</span></div></div><div style="display:table;width:100%;padding-bottom: 3%"><div style="width:40%;display:table-cell;font-weight: bold"><span data-translate="gatewayApp.customerRegistration.pincode"></span></div><div style="width:60%; display:table-cell"><span>{{vm.customerRegistrationRequest.pincode}}</span></div></div></div></div></div></div>');
$templateCache.put('app/entities/customer-registration/customer-registration-view-dialog.html','<!-- <form name="CustomerRegistrationViewForm" role="form" novalidate> --><div class="{{vm.theme}}"><div class="modal-header"><div class="modal-title" ng-if="vm.isModifyScreen == false"><span data-translate="gatewayApp.customerRegistration.ViewCustomerRegistration"></span></div><div class="modal-title" ng-if="vm.isModifyScreen==true"><span data-translate="gatewayApp.tradingBranchModifyDetails.modifyDetails"></span></div></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><form name="customerInfo" ng-show="vm.cutomerInfo==true"><div id="accordion"><div ng-if="vm.mode==\'customerApprovalToDo\' && vm.userEntityOwnerType==\'Bank\'" class="col-md-5" style="margin-top: 20px; margin-bottom: 10px;float:right"><span data-translate="gatewayApp.customerInfo.highlightedFiledLegend" class="field-highlighted-legend legend-white-color"></span> <span data-translate="gatewayApp.customerInfo.mandatory" class="field-highlighted-legend legend-blue-color"></span></div><div ng-if="vm.mode==\'customerInfoChangeStatus\' || (vm.mode==\'modifycustomerdetails_todo\' && !vm.isEdit)" class="col-md-5" style="margin-top: 20px; margin-bottom: 10px;float:right"><span data-translate="gatewayApp.customerInfo.highlightedFiledLegend" class="field-highlighted-legend legend-white-color"></span> <span data-translate="gatewayApp.customerInfo.modified" class="field-highlighted-legend legend-blue-color"></span></div><div class="row"><h4 ng-show="vm.theme==\'dark\'" class="panel-title col-md-offset-1" style="margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseCustomerInfo = !vm.ExpandOrCollapseCustomerInfo" style="text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseThree"><img ng-src="{{vm.ExpandOrCollapseCustomerInfo == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.CustomerProfile"></span></a></h4><h4 ng-show="vm.theme==\'light\'" class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseCustomerInfo = !vm.ExpandOrCollapseCustomerInfo" style="text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseThree"><img ng-src="{{vm.ExpandOrCollapseCustomerInfo == false && \'assets/images/Accordion_expand_light.png\' || \'assets/images/Accordion_collapse_light.png\'}}"> &nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.CustomerProfile"></span></a></h4></div><div id="collapseThree" ng-class=" {\'panel-collapse collapse in\': !vm.isModifyScreen,\'panel-collapse collapse\': vm.isModifyScreen } "><div class="accordion-content1"><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.customerType"></span></label></div><div class="row" style="margin-bottom:8px"><div class="col-md-6 col-md-offset-3"><select class="form-control select" name="customerType" ng-model="vm.customerRegistrationRequest.customerType" ng-options="customerType as customerType.name for customerType in vm.customerTypes track by customerType.id" ng-disabled="true" ng-class="{red: customerInfo.customerType.$invalid && vm.touchedcustomertype}" form="customerInfo" required></select><span class="help-block-error" ng-show="customerInfo.customerType.$invalid && vm.touchedcustomertype">This field cannot be left blank</span></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex].display"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.companyName"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex].display"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.customerFirstName" control-id="txtfirstName" form="customerInfo" control-disabled="!vm.enableFieldsForResubmit" control-modified="vm.checkforModification(\'customerFirstName\')" control-required="vm.inputDetailsForSelectedCustType[entityNameIndex].display && vm.inputDetailsForSelectedCustType[entityNameIndex].isMandatory"></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex].display"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.firstName"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex].display"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.customerFirstName" control-id="txtfirstName" form="customerInfo" control-disabled="!vm.enableFieldsForResubmit" control-modified="vm.checkforModification(\'customerFirstName\')" control-required="vm.inputDetailsForSelectedCustType[firstNameIndex].display && vm.inputDetailsForSelectedCustType[firstNameIndex].isMandatory"></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex].display"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.customerRegistration.middleName"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex].display"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.customerMiddleName" control-id="txtmiddleName" control-maxlength="100" form="customerInfo" control-disabled="!vm.enableFieldsForResubmit" control-modified="vm.checkforModification(\'customerMiddleName\')"></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex].display"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.lastName"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex].display"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.customerLastName" control-id="txtLastName" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-required="vm.inputDetailsForSelectedCustType[lastNameIndex].display && vm.inputDetailsForSelectedCustType[lastNameIndex].isMandatory" control-modified="vm.checkforModification(\'customerLastName\')"></div></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex].display && vm.userEntityOwnerType!=\'Clearcorp\'"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.panNo"></span></label></div><div class="row" style="margin-bottom:10px" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex].display && vm.userEntityOwnerType!=\'Clearcorp\'"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.panNumber" control-id="txtPanNo" form="customerInfo" control-disabled="true" control-required="!vm.customerRegistrationRequest.isProp"></div><div class="col-md-2" style="margin-top:5px" ng-show="vm.customerRegistrationRequest.panImage ||vm.customerRegistrationRequest.customerPanImage"><a ng-click="vm.viewPanImage()"><img ng-show="vm.theme==\'dark\'" ng-src="assets/images/panImage.png" ng-class="{\'higlightChange\' : vm.checkforModification(\'customerPanImage\')}"><img ng-show="vm.theme==\'light\'" ng-src="assets/images/PAN Image-24.png"></a></div></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panImageIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panImageIndex].display && vm.enableFieldsForResubmit"><div class="row"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="gatewayApp.customerRegistration.panImageUpload"></span></label></div><div class="row" style="margin-bottom:10px"><div class="row col-md-10 col-md-offset-3 input-group"><input type="text" class="customer-regview-pan-upload form-control fileOpen" ng-model="vm.inputPanImage" ng-blur="vm.checkPanImage=true;" readonly="readonly"><label for="panImageFile" class="btn btn-primary fileUploadDark"><img src="assets/images/Open path-24.png"></label><input type="file" id="panImageFile" name="panImageUpload" file-model="vm.image" accept="image/x-png,image/jpg,image/jpeg,application/pdf" form="customerInfo" ng-hide="true"> <span class="help-block-error-pan" ng-show="vm.invalidPanImageSize">PAN image size should not be greater than 100 kb.</span></div></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex].display"><label class="col-md-4 control-label col-md-offset-3"><span data-translate="gatewayApp.customerRegistration.legalEntityIdentifier"></span></label><label class="col-md-3 control-label"><span data-translate="gatewayApp.customerRegistration.validUpto"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex].display"><div class="col-md-4 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.legalEntityIdentifier" control-id="txtlegalEntityIdentifier" control-disabled="true" form="customerInfo"></div><div class="col-md-3" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex].display"><cspl-dtp theme-type="{{vm.theme}}" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex].display" control-disabled="true" control-model="vm.customerRegistrationRequest.leiExpiryDate" control-id="leiValidUpto" form="customerInfo"></cspl-dtp></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[cinIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[cinIndex].display"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.customerRegistration.corporateIdentificationNumber"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[cinIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[cinIndex].display"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.corporateIdentificationNumber" control-id="txtcorporateIdentificationNumber" control-disabled="true" form="customerInfo"></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[stateCodeIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[stateCodeIndex].display"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.customerRegistration.gstinAndStateCode"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[stateCodeIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[stateCodeIndex].display"><div class="col-md-3 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.gstin" control-id="txtgstin" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-modified="vm.checkforModification(\'gstin\')"></div><div class="col-lg-1"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.stateCode" control-id="txtstateCode" form="customerInfo" control-disabled="!vm.enableFieldsForResubmit" control-modified="vm.checkforModification(\'stateCode\')"></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex].display"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.dobOrDoi"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex].display"><div class="col-md-3 col-md-offset-3"><cspl-dtp theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.dobOrDoi" control-id="dtpDOBorDOI" form="customerInfo" control-disabled="true" control-required="vm.inputDetailsForSelectedCustType[dobDoiIndex].display && vm.inputDetailsForSelectedCustType[dobDoiIndex].isMandatory"></cspl-dtp></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.address1"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.address1" control-id="txtcustomeraddress1" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-modified="vm.checkforModification(\'address1\')" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.customerRegistration.address2"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.address2" control-id="txtcustomeraddress2" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-modified="vm.checkforModification(\'address2\')"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.city"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.city" control-id="txtcustomercity" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" required control-modified="vm.checkforModification(\'city\')"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.country"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-3"><cspl-ach theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.country" control-id="txtcustomerCountry" lookup-name="country" display-column="shortName" form="customerInfo" required control-disabled="true"></cspl-ach></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.state"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-3"><cspl-ach theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.state" control-id="txtcustomerstate" lookup-name="state" display-column="shortName" filter-value="{{vm.customerRegistrationRequest.country.id}}" form="customerInfo" control-disabled="!vm.enableFieldsForResubmit" required control-modified="vm.checkforModification(\'state\')"></cspl-ach></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.pincode"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.pincode" control-id="txtcustomerpincode" control-type="Alphanumeric" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-maxlength="7" control-modified="vm.checkforModification(\'pincode\')" required></div></div><div class="user-section" style="display: block; align: center; margin-top: 20px; margin-bottom: 10px"><label class="section-header"><span data-translate="gatewayApp.customerRegistration.primaryContact"></span></label><br><div class="row"><label class="col-md-3 control-label col-md-offset-2" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.name"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-2"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.primaryContactName" control-id="txtprimaryContractName" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-modified="vm.checkforModification(\'primaryContactName\')" required></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-2" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.email"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-2"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.primaryEmail" control-type="Email" control-id="txtemail" control-disabled="true" form="customerInfo" control-modified="vm.checkforModification(\'primaryEmail\')" required></div><img ng-if="vm.enableFieldsForResubmit" src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px; border:0px" title="Change Email" ng-click="vm.openChangeEmailForCustomer()"></div><div class="row"><label class="col-md-3 control-label col-md-offset-2" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.mobile"></span></label></div><div class="row"><div class="col-lg-2 col-md-offset-2"><cspl-numeric theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.primaryMobileCountryCode" control-id="txtprimaryMobileCountryCode" no-of-decimals="0" control-disabled="true" form="customerInfo" control-modified="vm.checkforModification(\'primaryMobileCountryCode\')" required></div><div class="col-md-4"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.primaryMobile" control-type="Number" control-id="txtprimaryMobile" control-disabled="true" form="customerInfo" control-modified="vm.checkforModification(\'primaryMobile\')" control-maxlength="15" required></div><img ng-if="vm.enableFieldsForResubmit" src="assets/images/EditProfile.png" alt="Avatar" title="Change Mobile" style="width: 25px; height: 25px" ng-click="vm.openChangeMobileForCustomer()"></div></div><div class="user-section" style="display: block; align: center; margin-top: 20px; margin-bottom: 10px"><label class="section-header"><span data-translate="gatewayApp.customerRegistration.alternateContact"></span></label><br><div class="row"><span class="icon"><img ng-show="vm.theme==\'light\'" style="float:left;margin-left:7.7vh" src="assets/images/Cust_Onboarding_Accordion_1_22.png"></span><span class="icon"><img ng-show="vm.theme==\'dark\'" style="float:left;margin-left:7.7vh" src="assets/images/Cust_Onboarding_Accordion_1_22_Dark theme.png"></span><label style="margin-left:3vh" class="col-md-7 control-label"><span data-translate="gatewayApp.customerRegistration.name"></span></label></div><div class="row"><div class="col-md-1"><span class="icon"><img ng-show="vm.theme==\'light\'" class="accordionExpandIcon" src="assets/images/Accordion_Expand_Line_Light theme.png"></span><span class="icon"><img ng-show="vm.theme==\'dark\'" class="accordionExpandIcon" src="assets/images/Accordion_Expand_Line_Dark theme_Lighter shade.png"></span></div><div class="col-md-10"><div class="row"><div class="col-md-8 col-md-offset-2" style="margin-left:5.5vh"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateContactName1" control-id="txtalternateName1" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-modified="vm.checkforModification(\'alternateContactName1\')"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-2" style="margin-left:5.5vh"><span data-translate="gatewayApp.customerRegistration.email"></span></label></div><div class="row"><div class="col-md-8 col-md-offset-2" style="margin-left:5.5vh"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateEmail1" control-type="Email" control-id="txtemail11" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-modified="vm.checkforModification(\'alternateEmail1\')"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-2" style="margin-left:5.5vh"><span data-translate="gatewayApp.customerRegistration.mobile"></span></label></div><div class="row"><div class="col-lg-2 col-md-offset-2" style="margin-left:5.5vh"><cspl-numeric theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateMobileCountryCode1" control-id="txtalternateMobileCountryCode1" control-disabled="!vm.enableFieldsForResubmit" no-of-decimals="0" form="customerInfo" control-modified="vm.checkforModification(\'alternateMobileCountryCode1\')"></div><div class="col-md-5"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateMobile1" control-type="Number" control-id="txtalternateMobile1" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-maxlength="15" control-modified="vm.checkforModification(\'alternateMobile1\')"></div></div></div></div><div class="row"><span class="icon"><img ng-show="vm.theme==\'light\'" style="float:left;margin-left:7.7vh" src="assets/images/Cust_Onboarding_Accordion_2_22.png"></span><span class="icon"><img ng-show="vm.theme==\'dark\'" style="float:left;margin-left:7.7vh" src="assets/images/Cust_Onboarding_Accordion_2_22_Dark theme.png"></span><label style="margin-left:3vh" class="col-md-7 control-label"><span data-translate="gatewayApp.customerRegistration.name"></span></label></div><div class="row"><div class="col-md-1"><span class="icon"><img ng-show="vm.theme==\'light\'" class="accordionExpand2" src="assets/images/Accordion_Expand_Line_Light theme.png"></span><span class="icon"><img ng-show="vm.theme==\'dark\'" class="accordionExpand2" src="assets/images/Accordion_Expand_Line_Dark theme_Lighter shade.png"></span></div><div class="col-md-10"><div class="row"><div class="col-md-8 col-md-offset-2" style="margin-left:5.5vh"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateContactName2" control-id="txtalternateName2" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-modified="vm.checkforModification(\'alternateContactName2\')"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-2" style="margin-left:5.5vh"><span data-translate="gatewayApp.customerRegistration.email"></span></label></div><div class="row"><div class="col-md-8 col-md-offset-2" style="margin-left:5.5vh"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateEmail2" control-type="Email" control-id="txtemail12" control-disabled="!vm.enableFieldsForResubmit" form="customerInfo" control-modified="vm.checkforModification(\'alternateEmail2\')"></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-2" style="margin-left:5.5vh"><span data-translate="gatewayApp.customerRegistration.mobile"></span></label></div><div class="row"><div class="col-lg-2 col-md-offset-2" style="margin-left:5.5vh"><cspl-numeric theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateMobileCountryCode2" control-id="txtalternateMobileCountryCode2" control-disabled="!vm.enableFieldsForResubmit" no-of-decimals="0" form="customerInfo" control-modified="vm.checkforModification(\'alternateMobileCountryCode2\')"></div><div class="col-md-5"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.alternateMobile2" control-type="Number" control-maxlength="15" control-id="txtalternateMobile2" control-disabled="!vm.enableFieldsForResubmit" control-modified="vm.checkforModification(\'alternateMobile2\')" form="customerInfo"></div></div></div></div></div></div></div></div></form><form name="bankInfo" ng-show="vm.bankInfo && !vm.customerRegistrationRequest.isProp"><div id="accordion"><div><h4 ng-show="vm.theme==\'dark\'" class="panel-title col-md-offset-1" style="width: 400px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseBankRelationship = !vm.ExpandOrCollapseBankRelationship" style="text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseOne" ng-disabled="vm.mode == \'modifycustomerdetails\'"><img ng-src="{{vm.ExpandOrCollapseBankRelationship == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.bankRelationship"></span></a></h4><h4 ng-show="vm.theme==\'light\'" class="panel-title col-md-offset-1" style="width: 400px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseBankRelationship = !vm.ExpandOrCollapseBankRelationship" style="text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseOne"><img ng-src="{{vm.ExpandOrCollapseBankRelationship == false && \'assets/images/Accordion_expand_light.png\' || \'assets/images/Accordion_collapse_light.png\'}}"> &nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.bankRelationship"></span></a></h4></div><div id="collapseOne" ng-class="{ \'panel-collapse collapse in\': vm.isModifyScreen,\'panel-collapse collapse\': !vm.isModifyScreen }"><div class="accordion-content1"><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.bankName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-ach control-model="vm.customerRegistrationRequest.bank" control-id="txtbank" lookup-name="bankDetails" theme-type="{{vm.theme}}" display-column="shortName" form="bankInfo" control-disabled="true" required></cspl-ach></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.homeBranch"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-ach ng-if="!vm.isEdit" control-model="vm.customerRegistrationRequest.homeBranch" control-id="txthomeBranch" theme-type="{{vm.theme}}" lookup-name="homeBranch" display-column="ifscCode,branchName" filter-value="" form="bankInfo" control-disabled="true" control-required="true" control-modified="vm.checkforHomeBranchModification()"></cspl-ach><cspl-ach ng-if="vm.isEdit" control-model="vm.customerRegistrationRequest.homeBranch" control-id="txthomeBranch2" theme-type="{{vm.theme}}" lookup-name="homeBranch" display-column="ifscCode,branchName" filter-value="{{vm.filterText}}" form="bankInfo" control-disabled="false" required></cspl-ach><span class="help-block" ng-show="vm.customerRegistrationRequest.homeBranch!=null">({{vm.customerRegistrationRequest.homeBranch.branchName}})</span> <span class="help-block" ng-show="vm.customerRegistrationRequest.homeBranch==null || vm.customerRegistrationRequest.homeBranch==undefined"><span data-translate="gatewayApp.customerRegistration.helpText.branch"></span></span></div></div><div class="row" ng-if="vm.userEntityOwnerType!=\'Clearcorp\'"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.bankAccountNumber"></span></label></div><div class="row" ng-if="vm.userEntityOwnerType!=\'Clearcorp\'"><div class="col-md-6 col-md-offset-3"><cspl-text ng-if="!vm.isEdit" theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.bankAccountNumber" control-id="txtbankAccountNumber" form="bankInfo" control-disabled="true" control-modified="vm.checkforAccountModification()" control-required="true"></cspl-text><cspl-text ng-if="vm.isEdit" theme-type="{{vm.theme}}" control-type="Number" control-maxlength="20" control-model="vm.customerRegistrationRequest.bankAccountNumber" control-id="txtbankAccountNumber1" form="bankInfo" control-disabled="false" required></cspl-text></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.tradingBranch"></span></label><div class="col-md-3" ng-if="vm.mode==\'customeronboardingstatus\' || vm.mode==\'registrationrequeststatus\' || vm.mode==\'customeronboarding\'"><cspl-checkbox class="control-label" id="chkAssignBranch" theme-type="{{vm.theme}}" ng-model="vm.customerRegistrationRequest.assignTradingBranch" label-value="{{\'gatewayApp.customerRegistration.idontknow\' | translate}}" ng-disabled="true"></cspl-checkbox></div></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-ach ng-if="!vm.isEdit" control-model="vm.customerRegistrationRequest.tradingBranch" control-id="txttradingBranch" theme-type="{{vm.theme}}" lookup-name="validBranchesForBank" filter-value="{{vm.customerRegistrationRequest.bank.id}}" display-column="ifscCode,branchName" form="bankInfo" control-disabled="vm.userEntityOwnerType!=\'Bank\' || !(vm.userEntityOwnerType==\'Bank\' && vm.mode==\'customerApprovalToDo\' && vm.customerRegistrationRequest.actionType==\'ADD\')" control-modified="vm.checkforTradingBranchModification()" control-required="!vm.disableTradingBranch || (vm.mode==\'customerApprovalToDo\')"></cspl-ach><cspl-ach ng-if="vm.isEdit" control-model="vm.customerRegistrationRequest.tradingBranch" control-id="txttradingBranch2" theme-type="{{vm.theme}}" lookup-name="validStatusBranchesForBank" display-column="ifscCode,branchName" filter-value="{{vm.customerRegistrationRequest.bank.id}}" form="bankInfo" required></cspl-ach><span class="help-block" ng-show="vm.customerRegistrationRequest.tradingBranch!=null" style="word-break: break-word">({{vm.customerRegistrationRequest.tradingBranch.branchName}})</span> <span class="help-block" ng-show="vm.customerRegistrationRequest.tradingBranch==null || vm.customerRegistrationRequest.tradingBranch==undefined"><span data-translate="gatewayApp.customerRegistration.helpText.branch"></span></span><!-- <span class="help-block" ng-show="vm.isEdit && vm.noChange"><span data-translate="gatewayApp.customerRegistration.helpText.oldTradingBranch"></span>{{ \' \' +vm.oldTradingBranch.ifscCode }}</span> --></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.customerRegistration.branchAddress"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-multiline-text control-model="vm.customerRegistrationRequest.branchAddress" control-id="txtbankAddress" theme-type="{{vm.theme}}" form="bankInfo" control-disabled="true"></div></div></div></div></div></form><form name="userInfo" ng-show="vm.defaultUserInfo && vm.customerRegistrationRequest.login!=undefined && vm.customerRegistrationRequest.login!=null"><div id="accordion"><div><h4 ng-show="vm.theme==\'dark\'" class="panel-title col-md-offset-1" style="width: 400px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseUserInfo = !vm.ExpandOrCollapseUserInfo" style="text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseTwo"><img ng-src="{{vm.ExpandOrCollapseUserInfo == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.defaultUserInfo"></span></a></h4><h4 ng-show="vm.theme==\'light\'" class="panel-title col-md-offset-1" style="width: 400px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseUserInfo = !vm.ExpandOrCollapseUserInfo" style="text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseTwo"><img ng-src="{{vm.ExpandOrCollapseUserInfo == false && \'assets/images/Accordion_expand_light.png\' || \'assets/images/Accordion_collapse_light.png\'}}"> &nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.defaultUserInfo"></span></a></h4></div><div id="collapseTwo" class="panel-collapse collapse" style="height: 240px"><div class="accordion-content1"><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.firstName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userFirstName" control-id="txtfirstName" control-disabled="true" form="usersInfo" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.customerRegistration.middleName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userMiddleName" control-id="txtmiddleName" control-disabled="true" form="usersInfo"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.lastName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userLastName" control-id="txtlastName" control-disabled="true" form="usersInfo" required></div></div><!-- <div class="row"> \r\n\t\t\t\t\t\t\t<label class="col-md-6 control-label col-md-offset-3"  ><span data-translate="gatewayApp.customerRegistration.aadharNumber" ></span></label>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t<div class="col-md-6 col-md-offset-3">\r\n\t\t\t\t\t\t\t<cspl-text theme-type="{{vm.theme}}" control-model = "vm.customerRegistrationRequest.aadharNumber" control-type="Number" control-id="txtaadharNumber" control-disabled="true"\r\n\t\t\t\t\t\t\t\t help-text="{{\'gatewayApp.customerRegistration.helpText.aadharNumber\' | translate}}"   form="usersInfo" />\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.gender"></span></label></div><div class="row"><div id="btnGroup" class="col-md-6 col-md-offset-3"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.customerRegistrationRequest.gender" ng-disabled="true" uib-btn-radio="\'M\'">M</label><label class="btn btn-primary" ng-model="vm.customerRegistrationRequest.gender" ng-disabled="true" uib-btn-radio="\'F\'">F&nbsp;</label><label class="btn btn-primary" ng-model="vm.customerRegistrationRequest.gender" ng-disabled="true" uib-btn-radio="\'O\'">O&nbsp;</label></div></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.dob"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-3"><cspl-dtp theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.dob" control-id="dtpDOB" form="usersInfo" control-disabled="true" required></cspl-dtp></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.login"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.login" control-id="txtLogin" control-disabled="true" form="usersInfo" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.email"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userEmail" control-type="Email" control-id="txtemail" control-disabled="true" form="usersInfo" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.mobile"></span></label></div><div class="row"><div class="col-lg-1 col-md-offset-3"><cspl-numeric theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userMobileCountryCode" control-id="txtMobileCountryCode" no-of-decimals="0" form="usersInfo" control-disabled="true" required></div><div class="col-md-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userMobile" control-type="Number" control-id="txtMobile" control-disabled="true" form="usersInfo" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.address1"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userAddress1" control-id="txtaddress1" control-disabled="true" form="usersInfo" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.customerRegistration.address2"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userAddress2" control-id="txtaddress2" control-disabled="true" form="usersInfo"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.city"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userCity" control-id="txtcity" control-disabled="true" form="usersInfo" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.country"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-3"><cspl-ach theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userCountry" control-id="txtCountry" lookup-name="country" display-column="shortName" control-disabled="true" form="usersInfo" required></cspl-ach></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.state"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-3"><cspl-ach theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userState" control-id="txtstate" lookup-name="state" display-column="shortName" filter-value="{{vm.customerRegistrationRequest.country.id}}" form="usersInfo" control-disabled="true" required></cspl-ach></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.pincode"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userPincode" control-id="txtpincode" control-type="Alphanumeric" control-maxlength="7" control-disabled="true" form="usersInfo" required></div></div></div></div></div></form><form name="markup" ng-show="vm.showMarkup && !vm.customerRegistrationRequest.isProp"><div id="accordion"><div><h4 ng-show="vm.theme==\'dark\'" class="panel-title col-md-offset-1" style="width: 400px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseBankRelationship = !vm.ExpandOrCollapseBankRelationship" style="text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseFour" ng-disabled="vm.mode == \'modifycustomerdetails\'"><img ng-src="{{vm.ExpandOrCollapseBankRelationship == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.markup.markUp"></span></a></h4><h4 ng-show="vm.theme==\'light\'" class="panel-title col-md-offset-1" style="width: 400px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseBankRelationship = !vm.ExpandOrCollapseBankRelationship" style="text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseFour"><img ng-src="{{vm.ExpandOrCollapseBankRelationship == false && \'assets/images/Accordion_expand_light.png\' || \'assets/images/Accordion_collapse_light.png\'}}"> &nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.markup.markUp"></span></a></h4></div><div id="collapseFour" ng-class="{ \'panel-collapse collapse in\': vm.isModifyScreen,\'panel-collapse collapse\': !vm.isModifyScreen }"><div class="accordion-content1"><div class="row"><label class="col-md-3 control-label col-md-offset-2" style="padding-left: 0px"><span data-translate="gatewayApp.customerRegistration.markup.markupType"></span></label><label class="col-md-2 control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.markup.markupValue"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-2 multi-col"><select class="form-control select-style" name="markupType" ng-model="vm.markupType" ng-options="markupType.shortName for markupType in vm.markupTypes track by markupType.shortName" form="markup" ng-disabled="vm.disableMarkup" required></select></div><div class="col-md-2 multi-col" ng-show="vm.markupType.shortName!=\'Percentage\' " style="padding-left: 8px"><cspl-numeric control-model="vm.customerRegistrationRequest.markupSettings.markupValue" control-id="txtMarkupValue1" no-of-decimals="{{vm.noOfDecimals}}" form="markup" control-min="0" control-max="999" control-disabled="vm.disableMarkup" ng-class="{\'markupHighLight\' : vm.showHighLight }" control-required="vm.customerRegistrationRequest.actionType != \'REMOVE\'"></cspl-numeric></div><div class="col-md-2 multi-col" ng-show="vm.markupType.shortName==\'Percentage\' " style="padding-left: 8px"><cspl-numeric control-model="vm.customerRegistrationRequest.markupSettings.markupValue" control-id="txtMarkupValue2" no-of-decimals="{{vm.noOfDecimals}}" form="markup" control-min="0" control-max="100" control-disabled="vm.disableMarkup" ng-class="{\'markupHighLight\' : vm.showHighLight }" control-required="vm.customerRegistrationRequest.actionType != \'REMOVE\'"></cspl-numeric></div><div class="col-xs-1 col-md-1" style="line-height:30px"><span ng-show="vm.markupType.shortName==\'Percentage\' ">%</span></div></div><div class="row"><div class="col-md-3 multi-col col-md-offset-2"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.markup.taxOnMarkup"></span></label><div class="multi-col"><cspl-numeric control-model="vm.customerRegistrationRequest.markupSettings.taxOnMarkup" control-id="txtTaxOnMarkup" no-of-decimals="{{vm.decimalsForPercent}}" form="markup" control-min="0" control-max="100" control-disabled="vm.disableMarkup || vm.disableTax"></cspl-numeric></div></div><div class="col-md-1" style="line-height:78px"><span>%</span></div><div class="col-md-4 col-md-offset-1 help-block-text" style="padding-right: 0px"><span class="help-block" style="text-align: left" data-translate="gatewayApp.customerRegistration.markup.blank"></span></div></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-2" style="padding-left: 0px" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.markup.roEdApplicability"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-2 multi-col"><select class="form-control select-style" name="roEdApplicability" ng-model="vm.roEdApplicabilityMethod" ng-options="roEdApplicability.name for roEdApplicability in vm.roEdApplicabilityMethodList track by roEdApplicability.shortName" form="markup" ng-disabled="vm.disableMarkup" required></select></div></div></div></div></form></div></div><!-- <div  ng-hide="true"  ng-include="\'app/entities/customer-registration/customer-registration-print-view.html\'"  ></div> --><div class="modal-footer"><!-- vm.showButton== true for checker alone.  show the terms and condition for Add bank aproval and customer registration approval, For customer profile update and Modfiy customer details approval it is not required --><div ng-show="vm.showButton && vm.customerRegistrationRequest.actionType != \'REMOVE\' && vm.mode != \'customerInfoChangeStatus\' && vm.mode != \'modifycustomerdetails_todo\' " style="margin-bottom: 10px"><!-- \r\n                    \t<input type="checkbox" style="vertical-align: middle;margin-bottom: 3px;margin-right: 1%;" id="termsAndConditionsApproval" ng-model="vm.termsAndConditionsApproval">\r\n\t\t\t\t\t\t<label for="termsAndConditionsApproval" style="margin-right: 8%;">\r\n\t\t\t\t\t\t<a ui-sref="terms-and-conditions-view-approval({theme: vm.theme})"><span data-translate="gatewayApp.customerRegistration.termsAndConditions"></span></a></label>\r\n\t\t\t\t\t\t--><label class="justified-tac-label" style="margin-top: 20px;   margin-left: 8%;  margin-right: 8%;  padding-bottom: 10px"><span data-translate="gatewayApp.customerRegistration.bankApproverTACText.text1"></span> <a ng-click="vm.onGetCcilTac(vm.organisation.id,vm.messageBoxName)"><span data-translate="gatewayApp.customerRegistration.bankApproverTACText.text2"></span></a> <span data-translate="gatewayApp.customerRegistration.bankApproverTACText.text3"></span></label></div><div ng-show="vm.mode == \'customerViewReport\' && !vm.customerRegistrationRequest.isProp" style="margin-bottom: 10px; text-align: left"><label style="margin-left: 11%"><a style="text-decoration: underline; font-size: 14px" ng-click="vm.viewAcceptedTermsAndConditions()"><span data-translate="gatewayApp.customerRegistration.viewTermsAndConditions"></span></a></label></div><button type="button" class="btn btn-info" ng-show="vm.showPrint" data-dismiss="modal" ng-click="vm.print()">&nbsp;<span style="text-align: center">PRINT</span></button> <button type="button" class="btn btn-info" ng-show="!vm.withdraw  && !vm.isEdit" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span style="text-align: center">OK</span></button> <button type="button" class="btn btn-info secondaryAction" ng-show="vm.withdraw" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span style="text-align: center">OK</span></button> <button type="button" ng-if="vm.showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.isModifyScreen? vm.discardModifyCustomerDetails() :vm.discardCustomerUpdate()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="vm.showButton" class="btn btn-reject" ng-click="vm.isModifyScreen? vm.rejectCustomerModification() : vm.rejectCustomerRegistration()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="vm.showButton && vm.customerRegistrationRequest.actionType != \'REMOVE\' && vm.mode !=\'customerInfoChangeStatus\'" autofocus class="btn btn-approve" ng-disabled="(vm.customerRegistrationRequest.tradingBranch==null || vm.customerRegistrationRequest.tradingBranch==undefined || vm.customerRegistrationRequest.markupSettings.markupValue==null || vm.customerRegistrationRequest.markupSettings.markupValue==undefined || vm.customerRegistrationRequest.markupSettings.markupValue==\'\' || vm.clicked)" ng-click="vm.clicked = true;vm.isModifyScreen?vm.approveModifyCustomerDetails():vm.approveCustomerRegistration();"><span data-translate="entity.action.approve">Approve</span></button> <button type="button" ng-if="(vm.showButton && vm.customerRegistrationRequest.actionType == \'REMOVE\')|| vm.mode ==\'customerInfoChangeStatus\'" autofocus class="btn btn-approve" ng-disabled="(vm.customerRegistrationRequest.tradingBranch==null || vm.customerRegistrationRequest.tradingBranch==undefined || vm.clicked)" ng-click="vm.clicked = true;vm.isModifyScreen?vm.approveModifyCustomerDetails():vm.approveCustomerRegistration();"><span data-translate="entity.action.approve">Approve</span></button> <button type="button" class="btn btn-info secondaryAction" style="width: 100px" ng-if="vm.mode == \'customeronboardingstatus\' || vm.mode == \'registrationrequeststatus\'" data-dismiss="modal" ng-click="vm.downloadAnnexure1()">&nbsp;<span style="text-align: center">Download</span></button> <button type="submit" style="width:100px" ng-if="vm.withdraw" class="btn btn-reject" ng-disabled="vm.clicked" ng-click="vm.clicked=true;vm.withdrawRequest()"><span data-translate="gatewayApp.customerRegistration.withdraw">Withdraw</span></button> <button type="button" class="btn btn-info" data-dismiss="modal" ng-if="vm.isEdit" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="vm.showResubmitButton" class="btn btn-primary" ng-click="clicked = true;vm.isModifyScreen? vm.resubmitModifyCustomerDetails() : vm.resubmitCustomerRegistration();" ng-disabled="vm.isModifyScreen?(bankInfo.$invalid || vm.clicked ): vm.clicked "><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="vm.isEdit && vm.mode == \'modifycustomerdetails\' " autofocus class="btn btn-info active" ng-disabled="bankInfo.$invalid || vm.clicked" ng-click="vm.clicked = true;vm.saveModificationOnCustomerDetails();"><span data-translate="entity.action.save">Save</span></button></div></div><!-- </form> -->');
$templateCache.put('app/entities/customer-registration/customer-registration.html','<style>.auth-section .form-control {\r\n  padding-left: 30px;\r\n}\r\n.red{\r\n\tborder: 1px solid #FF3737;\r\n}</style><div class="customer-registration-layout-no-leftnav"><section class="customer-registration-section customer-onboarding"><div class="row"><div class="form-box col-md-6 col-md-offset-3"><div class="form-box-heading"><img class="customer-page-logo" src="assets/images/CC_Logo.png"> <img class="customer-page-header" src="assets/images/Customer_Registration_Header.png"></div><div style="float:right;padding-top:5px;padding-right:5px"><!-- \t\t            \t\t<span class="icon"></span><img src="assets/images/Help.png" ng-click="vm.openHelpWindow()" title="Help" /> --><label style="text-align: right" class="col-xs-12 form-label" ng-click="vm.openHelpWindow()"><a class="resubmit-link" data-translate="gatewayApp.customerRegistration.needHelp"></a></label><span style="float:right" class="mandatory-note btn btn-info">Note: All (*) fields are mandatory</span></div><div class="form-box-inner" ng-show="vm.customerInfo"><div><nmb-alert-error></nmb-alert-error></div><div class="row"><div class="col-md-12"><div class="glyph"><span class="icon"></span><img src="assets/images/Steppers_Current_24.png"> <span class="icon"></span><img class="line-width" src="assets/images/Steppers_line_small_100_weight_2.png"> <span class="icon"></span><img src="assets/images/Steppers_Need_to_be_filled_24.png"> <span class="icon"></span><img class="line-width" src="assets/images/Steppers_line_small_100_weight_2.png"> <span class="icon"></span><img src="assets/images/Steppers_Need_to_be_filled_24.png"></div></div></div><div class="row"><div class="col-xs-12"><div class="glyph-text"><label class="form-label">Customer Profile</label><label class="form-label disabled bank-rel" style="color:#BFBFBF">Bank Relationship</label><label class="form-label disabled user-info" style="color:#BFBFBF">User Info</label></div></div></div><form name="customerInfo" style="/*margin: 0 auto;width: 450px;*/"><div class="content" style="padding-left:5%"><div class="row" style="float:right"><label class="col-md-12 form-label" ng-click="vm.fetchRejectedRequest()"><a class="resubmit-link" data-translate="gatewayApp.customerRegistration.resubmitRejectedRequest"></a></label></div><div class="row"><label class="col-md-6 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.customerType"></span></label></div><div class="row" style="margin-bottom:8px"><div class="col-md-7 col-md-offset-2"><select class="form-control select-style light-select" name="customerType" ng-model="vm.customerRegistrationRequest.customerType" ng-options="customerType as customerType.name for customerType in vm.customerTypes track by customerType.id" ng-init="vm.touchedcustomertype=false" ng-focus="vm.touchedcustomertype=true" ng-class="{red: customerInfo.customerType.$invalid && vm.touchedcustomertype}" form="customerInfo" required><option value="" selected="selected" hidden></select><span class="help-block-error" ng-show="customerInfo.customerType.$invalid && vm.touchedcustomertype">This field cannot be left blank</span></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex].display"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.companyName"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex].display"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.companyName" control-id="txtcompanyName" control-maxlength="100" form="customerInfo" control-required="vm.inputDetailsForSelectedCustType[entityNameIndex].display && vm.inputDetailsForSelectedCustType[entityNameIndex].isMandatory"></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex].display"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.firstName"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex].display"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.customerFirstName" control-id="txtcustomerfirstName" control-type="AlphaWithSpace" control-maxlength="100" form="customerInfo" control-required="vm.inputDetailsForSelectedCustType[firstNameIndex].display && vm.inputDetailsForSelectedCustType[firstNameIndex].isMandatory"></div></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex].display"><div class="col-md-7 col-md-offset-2"><span class="help-block" data-translate="gatewayApp.customerRegistration.helpText.firstName" style="text-align: right"></span></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex].display"><label class="col-md-7 col-md-offset-2 form-label"><span data-translate="gatewayApp.customerRegistration.middleName"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex].display"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.customerMiddleName" control-id="txtcustomermiddleName" control-type="AlphaWithSpace" control-maxlength="100" form="customerInfo"></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex].display"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.lastName"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex].display"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.customerLastName" control-id="txtcustomerlastName" control-type="AlphaWithSpace" control-maxlength="100" form="customerInfo" control-required="vm.inputDetailsForSelectedCustType[lastNameIndex].display && vm.inputDetailsForSelectedCustType[lastNameIndex].isMandatory"></div></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex].display"><div class="col-md-7 col-md-offset-2"><span class="help-block" data-translate="gatewayApp.customerRegistration.helpText.lastName" style="text-align: right"></span></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex].display"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.panNo"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex].display"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.panNumber" control-type="Alphanumeric" control-minlength="10" control-maxlength="10" control-id="txtPanNo" help-text="{{\'gatewayApp.customerRegistration.helpText.panNumber\' | translate}}" form="customerInfo" control-required="vm.inputDetailsForSelectedCustType[panNoIndex].display && vm.inputDetailsForSelectedCustType[panNoIndex].isMandatory"></div><div class="col-md-2" style="margin-top:5px" ng-show="vm.customerRegistrationRequest.panImage ||vm.customerRegistrationRequest.customerPanImage"><a ng-click="vm.viewPanImage()"><img ng-src="assets/images/PAN Image-24.png"></a></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panImageIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panImageIndex].display"><div class="col-md-7 col-md-offset-2"><label class="form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.panImageUpload"></span></label></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panImageIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panImageIndex].display"><div class="col-xs-6 col-md-offset-2" style="padding-right: 0px"><div class="input-group"><span class="input-group-btn"><input type="text" class="form-control inputType" ng-model="vm.inputPanImage" ng-class="{ \'red\': vm.checkPanImage && (vm.inputPanImage==null || vm.inputPanImage==undefined)}" ng-blur="vm.checkPanImage=true;" readonly="readonly"><label for="panImageFile" class="btn btn-primary fileUploadButton" ng-class="{ \'notentered\': vm.checkPanImage && (vm.inputPanImage==null || vm.inputPanImage==undefined)}"><img src="assets/images/Open path-24.png" style="pointer-events:none"></label></span><input type="file" id="panImageFile" name="panImageUpload" fileread="vm.panImage" accept="image/x-png,image/jpg,image/jpeg,application/pdf" ng-class="{ \'red\': vm.checkPanImage && (vm.inputPanImage==null || vm.inputPanImage==undefined)}" ng-hide="true" form="customerInfo" ng-blur="vm.checkPanImage=true;" ng-required="vm.inputDetailsForSelectedCustType[panImageIndex].display && vm.inputDetailsForSelectedCustType[panImageIndex].isMandatory"></div><span class="help-block-error" ng-show="vm.invalidPanImageSize"><!-- PAN image size should not be greater than 100 kb. -->{{ vm.invalidPanImageSixeText}}</span> <span class="help-block-error" ng-show="vm.invalidPanImage">Invalid file format.</span> <span class="help-block-error" ng-show="vm.invalidPanFileName">{{vm.invalidPanImageFileNameText}}</span> <span class="help-block-error" ng-show="vm.checkPanImage && (vm.inputPanImage==null || vm.inputPanImage==undefined)">PAN image should be uploaded.</span></div><div class="col-xs-3" style="padding-left: 0px"><span class="icon"><img style="margin-top:5px" data-toggle="tooltip" title="Maximum file size should not be greater than 100kb.&#13;Allowed file types - png, jpg, jpeg, pdf" src="assets/images/Info-24.png"></span></div></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex].display"><label class="col-xs-6 col-md-4 col-md-offset-2 form-label"><span data-translate="gatewayApp.customerRegistration.legalEntityIdentifier"></span></label><label class="col-xs-5 col-md-4 col-lg-4 form-label"><span data-translate="gatewayApp.customerRegistration.validUpto"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex].display"><div class="col-xs-6 col-md-4 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.legalEntityIdentifier" control-type="Alphanumeric" control-id="txtlegalEntityIdentifier" control-minlength="20" control-maxlength="20" form="customerInfo"></div><div class="col-xs-5 col-md-4 col-lg-4" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex].display"><cspl-dtp theme-type="light" control-disabled="vm.disableLeiExpiry" control-required="vm.leiExpiryRequired" control-model="vm.customerRegistrationRequest.leiExpiryDate" control-min-date="vm.leiMinDate" control-id="leiValidUpto" form="customerInfo"></cspl-dtp></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[cinIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[cinIndex].display"><label class="col-md-9 col-md-offset-2 form-label"><span data-translate="gatewayApp.customerRegistration.corporateIdentificationNumber"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[cinIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[cinIndex].display"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.corporateIdentificationNumber" control-type="Alphanumeric" control-minlength="21" control-maxlength="21" control-id="txtcorporateIdentificationNumber" form="customerInfo"></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex].display"><label class="col-md-7 col-md-offset-2 form-label"><span data-translate="gatewayApp.customerRegistration.gstinAndStateCode"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex].display"><div class="col-xs-5 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.gstin" control-id="txtgstin" control-type="Alphanumeric" control-minlength="15" control-maxlength="15" form="customerInfo"></div><div class="col-xs-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.stateCode" control-minlength="2" control-maxlength="2" control-id="txtstateCode" form="customerInfo"></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex].display"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.dobOrDoi"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex].display"><div class="col-md-5 col-md-offset-2"><cspl-dtp theme-type="light" control-model="vm.customerRegistrationRequest.dobOrDoi" control-id="dtpDOBOrDoi" form="customerInfo" control-required="vm.inputDetailsForSelectedCustType[dobDoiIndex].display && vm.inputDetailsForSelectedCustType[dobDoiIndex].isMandatory"></cspl-dtp></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.address1"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.address1" control-id="txtcustomeraddress1" control-maxlength="255" form="customerInfo" required></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label"><span data-translate="gatewayApp.customerRegistration.address2"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.address2" control-id="txtcustomeraddress2" control-maxlength="255" form="customerInfo"></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.city"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.city" control-id="txtcustomercity" control-maxlength="255" form="customerInfo" required></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.country"></span></label></div><div class="row"><div class="col-md-5 col-md-offset-2"><cspl-ach theme-type="light" control-model="vm.customerRegistrationRequest.country" control-id="txtcustomerCountry" lookup-name="country" display-column="shortName" form="customerInfo" required></cspl-ach></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.state"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-ach theme-type="light" control-model="vm.customerRegistrationRequest.state" control-id="txtcustomerstate" lookup-name="state" display-column="shortName" filter-value="{{vm.customerRegistrationRequest.country.id}}~~" form="customerInfo" required></cspl-ach></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.pincode"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.pincode" control-id="txtcustomerpincode" control-type="Alphanumeric" control-maxlength="7" form="customerInfo" required></div></div><div class="user-section" style="display: block; align: center; margin-top: 20px; margin-bottom: 10px"><label class="section-header"><span data-translate="gatewayApp.customerRegistration.primaryContact"></span></label><div class="row"></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.name"></span></label></div><div class="row"><div class="col-md-9 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.primaryContactName" control-id="txtprimaryContactName" control-type="AlphaWithSpace" control-maxlength="100" form="customerInfo" required></div></div><div class="row"><label class="col-md-3 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.email"></span></label><input ng-if="vm.showSkipOTP" type="checkbox" style="vertical-align: middle;margin-bottom: 3px" id="skipOTPPrimaryEmail" ng-model="vm.skipOTPPrimaryEmailContact"><label ng-if="vm.showSkipOTP" for="skipOTPPrimaryEmail">Skip OTP</label></div><div class="row"><div class="col-md-9 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.primaryEmail" control-type="Email" control-id="txtprimaryContactemail" control-maxlength=" 100" form="customerInfo" required></div></div><div class="row generalAction" ng-if="vm.showGenerateOTPEmailButton"><div class="col-md-5 col-md-offset-2"><button type="button" ng-if="vm.showGenerateOTPEmailButton" class="btn btn-info lighttheme" ng-disabled="vm.disableGenerateOTPEmail" ng-click="vm.generateOTPEmail()"><span data-translate="entity.action.gnerateOTP"></span></button><br></div></div><div class="row generalAction" ng-if="vm.showGenerateOTPEmailButton && !vm.disableGenerateOTPEmail"><span class="col-md-5 col-md-offset-2 help-block-error" data-translate="gatewayApp.customerRegistration.verifyEmailText" style="text-align: left"></span></div><div class="row" style="margin-top:10px" ng-show="vm.visibleOTPEmail"><div class="col-lg-3 col-md-offset-2"><label class="col-md-7 form-label" style="margin-top:10px"><span data-translate="gatewayApp.customerRegistration.otp"></span></label></div><div class="col-md-5" id="txtotpemail" control-model="vm.primaryEmailOtp" otp-input-directive options="otpEmailInput" size="{{vm.otpLength}}" control-disabled="(vm.isPrimaryEmailVerified && vm.checkPrimaryEmailOTP)"></div><div class="col-md-1" ng-show="vm.isPrimaryEmailVerified && vm.checkPrimaryEmailOTP"><span class="icon"><img src="assets/images/checkmark.gif"></span></div><div class="col-md-1" ng-show="vm.invalidPrimaryEmailOtp && vm.checkPrimaryEmailOTP" style="padding-top: 8px"><span class="icon icon_close" style="color:red;font-size:large"></span></div></div><div class="row" ng-show="vm.visibleOTPEmail && !(vm.isPrimaryEmailVerified && vm.checkPrimaryEmailOTP)"><label class="col-md-7 col-md-offset-3" style="font-size:12px; text-align:right"><a href="" ng-click="vm.resendPrimaryOTPEmail()">Resend</a></label></div><div class="row" ng-show="vm.visibleOTPEmail"><div class="col-md-6 col-md-offset-4"><label class="help-block" ng-show="vm.primaryEmailOtp==null" ng-hide="vm.invalidPrimaryEmailOtp && vm.checkPrimaryEmailOTP" data-translate="gatewayApp.customerRegistration.helpText.otpEmail"></label><label class="help-block" ng-show="vm.invalidPrimaryEmailOtp && vm.checkPrimaryEmailOTP" data-translate="gatewayApp.customerRegistration.helpText.wrongotp"></label></div></div><nmb-alert></nmb-alert><div class="row"><label class="col-md-3 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.mobile"></span></label><input ng-if="vm.showSkipOTP" type="checkbox" style="vertical-align: middle;margin-bottom: 3px" id="skipOTPPrimaryMobile" ng-model="vm.skipOTPPrimaryContact"><label ng-if="vm.showSkipOTP" for="skipOTPPrimaryMobile">Skip OTP</label></div><div class="row"><div class="col-xs-3 col-md-offset-2"><cspl-numeric theme-type="light" control-model="vm.customerRegistrationRequest.primaryMobileCountryCode" control-id="txtprimaryMobileCountryCode" no-of-decimals="0" form="customerInfo" control-max="999" control-min="1" control-tab-index="-1" control-required="true" control-disabled="!vm.skipOTPPrimaryEmail && !vm.isPrimaryEmailVerified"></div><div class="col-xs-6"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.primaryMobile" control-type="Number" control-id="txtprimaryMobile" control-maxlength="15" form="customerInfo" control-disabled="!vm.skipOTPPrimaryEmail && !vm.isPrimaryEmailVerified" required></div></div><div class="row generalAction" ng-if="vm.showGenerateOTPButton"><div class="col-lg-3 col-md-offset-2"></div><div class="col-md-5"><button type="button" ng-if="vm.showGenerateOTPButton" class="btn btn-info lighttheme" ng-disabled="vm.disableGenerateOTP || (!vm.skipOTPPrimaryEmail && !vm.isPrimaryEmailVerified)" ng-click="vm.generateOTP()"><span data-translate="entity.action.gnerateOTP"></span></button><br></div></div><div class="row generalAction" ng-if="vm.showGenerateOTPButton && !vm.disableGenerateOTP"><span class="col-md-offset-5 help-block-error" data-translate="gatewayApp.customerRegistration.verifyMobileText" style="text-align: left"></span></div><div class="row" style="margin-top:10px" ng-show="vm.visibleOTP && !vm.skipOTPPrimaryMobile"><div class="col-lg-3 col-md-offset-2"><label class="col-md-7 form-label" style="margin-top:10px"><span data-translate="gatewayApp.customerRegistration.otp"></span></label></div><div class="col-md-5" id="txtotp" control-model="vm.primaryMobileOtp" otp-input-directive options="otpInput" size="{{vm.otpLength}}" control-disabled="(vm.isPrimaryMobileVerified && vm.checkPrimaryOTP)"></div><div class="col-md-1" ng-show="vm.isPrimaryMobileVerified && vm.checkPrimaryOTP"><span class="icon"><img src="assets/images/checkmark.gif"></span></div><div class="col-md-1" ng-show="vm.invalidPrimaryOtp && vm.checkPrimaryOTP" style="padding-top: 8px"><span class="icon icon_close" style="color:red;font-size:large"></span></div></div><div class="row" ng-show="vm.visibleOTP && !(vm.isPrimaryMobileVerified && vm.checkPrimaryOTP) && !vm.skipOTPPrimaryMobile"><label class="col-md-7 col-md-offset-3" style="font-size:12px; text-align:right"><a href="" ng-click="vm.resendPrimaryOTP()">Resend</a></label></div><div class="row" ng-show="vm.visibleOTP  && !vm.skipOTPPrimaryMobile"><div class="col-md-6 col-md-offset-4"><label class="help-block" ng-show="vm.primaryMobileOtp==null" ng-hide="vm.invalidPrimaryOtp && vm.checkPrimaryOTP" data-translate="gatewayApp.customerRegistration.helpText.otp"></label><label class="help-block" ng-show="vm.invalidPrimaryOtp && vm.checkPrimaryOTP" data-translate="gatewayApp.customerRegistration.helpText.wrongotp"></label></div></div></div><div class="user-section"><label class="section-header"><span data-translate="gatewayApp.customerRegistration.alternateContact"></span></label><div class="row"></div><div class="row"><span class="icon"><img style="float:left;margin-left:4.5vh" src="assets/images/Cust_Onboarding_Accordion_1_22.png"></span><label style="margin-left:2vh" class="col-md-7 form-label"><span data-translate="gatewayApp.customerRegistration.name"></span></label></div><div class="row"><div class="col-xs-1"><span class="icon"><img style="float:left;margin-left:4.5vh;height:28vh;width:0.5vh" src="assets/images/Accordion_Expand_Line_Light theme.png"></span></div><div class="col-xs-11"><div class="col-md-10 col-md-offset-2" style="margin-left:4vh"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.alternateContactName1" control-id="txtalternateName1" control-type="AlphaWithSpace" control-maxlength="100" form="customerInfo"></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" style="margin-left:4vh"><span data-translate="gatewayApp.customerRegistration.email"></span></label></div><div class="row"><div class="col-md-10 col-md-offset-2" style="margin-left:4vh"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.alternateEmail1" control-type="Email" control-id="txtemail11" control-maxlength=" 100" form="customerInfo"></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" style="margin-left:4vh"><span data-translate="gatewayApp.customerRegistration.mobile"></span></label></div><div class="row"><div class="col-xs-3 col-md-offset-2" style="margin-left:4vh"><cspl-numeric theme-type="light" control-model="vm.customerRegistrationRequest.alternateMobileCountryCode1" control-id="txtalternateMobileCountryCode1" no-of-decimals="0" control-max="999" control-min="1" control-tab-index="-1" form="customerInfo"></div><div class="col-md-7"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.alternateMobile1" control-type="Number" control-id="txtalternateMobile1" control-maxlength="15" form="customerInfo"></div></div></div></div><div class="row"><span class="icon"><img style="float:left;margin-left:4.5vh" src="assets/images/Cust_Onboarding_Accordion_2_22.png"></span><label style="margin-left:2vh" class="col-md-7 form-label"><span data-translate="gatewayApp.customerRegistration.name"></span></label></div><div class="row"><div class="col-xs-1"><span class="icon"><img style="float:left;margin-left:4.5vh;height:28vh;width:0.5vh" src="assets/images/Accordion_Expand_Line_Light theme.png"></span></div><div class="col-xs-11"><div class="row"><div class="col-md-10 col-md-offset-2" style="margin-left:4vh"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.alternateContactName2" control-id="txtalternateName2" control-type="AlphaWithSpace" control-maxlength="100" form="customerInfo"></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" style="margin-left:4vh"><span data-translate="gatewayApp.customerRegistration.email"></span></label></div><div class="row"><div class="col-md-10 col-md-offset-2" style="margin-left:4vh"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.alternateEmail2" control-type="Email" control-id="txtemail12" control-maxlength=" 100" form="customerInfo"></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" style="margin-left:4vh"><span data-translate="gatewayApp.customerRegistration.mobile"></span></label></div><div class="row"><div class="col-xs-3 col-md-offset-2" style="margin-left:4vh"><cspl-numeric theme-type="light" control-model="vm.customerRegistrationRequest.alternateMobileCountryCode2" control-id="txtalternateMobileCountryCode2" no-of-decimals="0" control-max="999" control-min="1" control-tab-index="-1" form="customerInfo"></div><div class="col-xs-7"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.alternateMobile2" control-type="Number" control-id="txtalternateMobile2" control-maxlength="15" form="customerInfo"></div></div></div></div></div></div><div class="form-box-inner modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1" ng-hide="true"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-info lighttheme" ng-disabled="customerInfo.$invalid || (!vm.skipOTPPrimaryMobile && !vm.isPrimaryMobileVerified) || (vm.panImage==null || vm.panImage==\'\') || (!vm.skipOTPPrimaryEmail && !vm.isPrimaryEmailVerified) || vm.customerRegistrationRequest.primaryMobile==null || vm.customerRegistrationRequest.primaryMobile==\'\' || vm.customerRegistrationRequest.primaryMobile==undefined" ng-click="vm.copyUserInfo()"><span data-translate="entity.action.next"></span></button><div class="col-xs-8" style="padding-top:10px"><div class="mandatory-note-bold btn btn-info"><span data-translate="gatewayApp.customerRegistration.chargesDetails1"></span></div><div class="mandatory-note btn btn-info"><span data-translate="gatewayApp.customerRegistration.chargesDetails2"></span></div></div></div></form></div><div class="form-box-inner" ng-show="vm.bankInfo"><div><nmb-alert-error></nmb-alert-error></div><div class="row"><div class="col-md-12"><div class="glyph"><span class="icon"></span><img src="assets/images/Steppers_Completed_24.png"> <span class="icon"></span><img src="assets/images/Steppers_line_small_100_weight_2.png"> <span class="icon"></span><img src="assets/images/Steppers_Current_24.png"> <span class="icon"></span><img src="assets/images/Steppers_line_small_100_weight_2.png"> <span class="icon"></span><img src="assets/images/Steppers_Need_to_be_filled_24.png"></div></div></div><div class="row"><div class="col-md-12"><div class="glyph-text"><label class="form-label disabled">Customer Profile</label><label class="form-label bank-rel">Bank Relationship</label><label class="form-label disabled user-info" style="color:#BFBFBF">User Info</label></div></div></div><form name="bankInfo"><div class="content" style="padding-left:5%"><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.bankName"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-ach control-model="vm.customerRegistrationRequest.bank" control-id="txtBank" lookup-name="bankDetails" theme-type="light" display-column="shortName" form="bankInfo" required></cspl-ach></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.homeBranch"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-ach control-model="vm.customerRegistrationRequest.homeBranch" control-id="txthomeBranch" theme-type="light" lookup-name="homeBranch" display-column="ifscCode,branchName" filter-value="{{vm.filterText}}" form="bankInfo" required></cspl-ach><span class="help-block" ng-show="vm.customerRegistrationRequest.homeBranch!=null">({{vm.customerRegistrationRequest.homeBranch.branchName}})</span> <span class="help-block" ng-show="vm.customerRegistrationRequest.homeBranch==null || vm.customerRegistrationRequest.homeBranch==undefined"><span data-translate="gatewayApp.customerRegistration.helpText.branch"></span></span></div></div><div class="row"><label class="col-md-9 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.bankAccountNumber"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.bankAccountNumber" control-id="txtbankAccountNumber" control-type="Number" control-maxlength="20" form="bankInfo" required></div></div><div class="row"><label class="col-md-5 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.tradingBranch"></span></label><div class="col-md-3"><cspl-checkbox class="form-label" id="chkAssignBranch" theme-type="light" ng-model="vm.customerRegistrationRequest.assignTradingBranch" label-value="{{\'gatewayApp.customerRegistration.idontknow\' | translate}}"></cspl-checkbox></div></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-ach control-model="vm.customerRegistrationRequest.tradingBranch" control-id="txttradingBranch" theme-type="light" lookup-name="validBranchDetailsForBank" display-column="ifscCode,branchName" filter-value="{{vm.customerRegistrationRequest.bank.id}}~~" form="bankInfo" control-disabled="vm.disableTradingBranch" control-required="!vm.disableTradingBranch"></cspl-ach><span class="help-block" ng-show="vm.customerRegistrationRequest.tradingBranch!=null">({{vm.customerRegistrationRequest.tradingBranch.branchName}})</span> <span class="help-block" ng-show="(vm.customerRegistrationRequest.tradingBranch==null || vm.customerRegistrationRequest.tradingBranch==undefined) && !vm.customerRegistrationRequest.assignTradingBranch"><span data-translate="gatewayApp.customerRegistration.helpText.branch"></span></span> <span class="help-block" ng-show="(vm.customerRegistrationRequest.tradingBranch==null || vm.customerRegistrationRequest.tradingBranch==undefined) && vm.customerRegistrationRequest.assignTradingBranch"><span data-translate="gatewayApp.customerRegistration.helpText.idontknow"></span></span></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label"><span data-translate="gatewayApp.customerRegistration.branchAddress"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-multiline-text control-model="vm.tradingBranchAddress" control-id="txtbranchAddress" theme-type="light" form="bankInfo"></div></div><span class="help-block" style="margin-right: 26%;   text-align: right;  padding-bottom: 10px"><span data-translate="gatewayApp.customerRegistration.payable"></span></span><div class="row"><div class="col-md-10 col-md-offset-2"><input type="checkbox" style="margin-right:1%;vertical-align:middle;margin-bottom:3px" checklist-model="vm.termsAndCondition" checklist-value="termsAndConditions" ng-model="termsAndConditions" required> <a ng-click="vm.previewClearcorpTAC()"><span data-translate="gatewayApp.customerRegistration.termsAndConditionsOfClearcorp"></span></a></div></div><div class="row" style="margin-top: 5px" ng-if="vm.bankTAC!=null"><div class="col-md-10 col-md-offset-2"><input type="checkbox" style="margin-right:1%;vertical-align:middle;margin-bottom:3px" checklist-model="vm.termsAndConditionForBank" checklist-value="termsAndConditionsForBank" ng-model="termsAndConditionsForBank" ng-required="vm.bankTAC!=null"> <a ng-click="vm.previewBankTAC()"><span data-translate="gatewayApp.customerRegistration.termsAndConditionsOfBank"></span></a></div></div></div><div class="form-box-inner modal-footer"><button type="button" class="btn btn-info secondaryAction" data-dismiss="modal" tabindex="-1" ng-click="vm.bankInfo=false;vm.customerInfo=true;"><span data-translate="entity.action.previous"></span></button> <button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" ng-hide="true"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-info" ng-disabled="bankInfo.$invalid" ng-click="vm.bankInfo=false;vm.userInfo=true;vm.openUserInfo();"><span data-translate="entity.action.next"></span></button><div class="col-xs-8" style="padding-top:10px"><div class="mandatory-note-bold btn btn-info"><span data-translate="gatewayApp.customerRegistration.chargesDetails1"></span></div><div class="mandatory-note btn btn-info"><span data-translate="gatewayApp.customerRegistration.chargesDetails2"></span></div></div></div></form></div><div class="form-box-inner" ng-show="vm.userInfo"><div><nmb-alert-error></nmb-alert-error></div><div class="row"><div class="col-md-12"><div class="glyph"><span class="icon"></span><img src="assets/images/Steppers_Completed_24.png"> <span class="icon"></span><img src="assets/images/Steppers_line_small_100_weight_2.png"> <span class="icon"></span><img src="assets/images/Steppers_Completed_24.png"> <span class="icon"></span><img src="assets/images/Steppers_line_small_100_weight_2.png"> <span class="icon"></span><img src="assets/images/Steppers_Current_24.png"></div></div></div><div class="row"><div class="col-md-12"><div class="glyph-text"><label class="form-label disabled">Customer Profile</label><label class="form-label disabled bank-rel">Bank Relationship</label><label class="form-label user-info">User Info</label></div></div></div><form name="usersInfo"><div class="content" style="padding-left:5%"><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.firstName"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.userFirstName" control-id="txtfirstName" control-type="AlphaWithSpace" control-maxlength="100" form="usersInfo" control-disabled="vm.customerRegistrationRequest.customerType.enableUserInfo==false" required></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label"><span data-translate="gatewayApp.customerRegistration.middleName"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.userMiddleName" control-id="txtmiddleName" control-type="AlphaWithSpace" control-maxlength="100" control-disabled="vm.customerRegistrationRequest.customerType.enableUserInfo==false" form="usersInfo"></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.lastName"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.userLastName" control-id="txtlastName" control-type="AlphaWithSpace" control-maxlength="100" form="usersInfo" control-disabled="vm.customerRegistrationRequest.customerType.enableUserInfo==false" required></div></div><!-- <div class="row"> \r\n\t\t\t\t\t\t\t<label class="col-md-7 col-md-offset-2 form-label" ><span data-translate="gatewayApp.customerRegistration.aadharNumber" ></span></label>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t<div class="col-md-7 col-md-offset-2">\r\n\t\t\t\t\t\t\t<cspl-text theme-type="light" control-model = "vm.customerRegistrationRequest.aadharNumber" control-type="Number" control-id="txtaadharNumber" control-minlength="12" control-maxlength="12"\r\n\t\t\t\t\t\t\t\t help-text="{{\'gatewayApp.customerRegistration.helpText.aadharNumber\' | translate}}"   form="usersInfo" />\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.gender"></span></label></div><div class="row"><div id="btnGroup" class="col-md-7 col-md-offset-2"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.customerRegistrationRequest.gender" uib-btn-radio="\'M\'">M</label><label class="btn btn-primary" ng-model="vm.customerRegistrationRequest.gender" uib-btn-radio="\'F\'">F&nbsp;</label><label class="btn btn-primary" ng-model="vm.customerRegistrationRequest.gender" uib-btn-radio="\'O\'">O&nbsp;</label></div></div></div><div class="row" style="margin-top:8px"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.dob"></span></label></div><div class="row"><div class="col-md-5 col-md-offset-2"><cspl-dtp theme-type="light" control-model="vm.customerRegistrationRequest.dob" control-id="dtpDOB" form="usersInfo" control-disabled="vm.customerRegistrationRequest.customerType.enableUserInfo==false" required></cspl-dtp></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.login"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.login" control-id="txtLogin" control-type="Small" control-maxlength="100" form="usersInfo" required></div></div><div class="row"><label class="col-md-2 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.email"></span></label><input ng-if="vm.showSkipOTP" type="checkbox" style="vertical-align: middle;margin-bottom: 3px" id="skipOTPUserEmail" ng-model="vm.skipOTPUserEmailContact" ng-disabled="vm.customerRegistrationRequest.customerType.enableUserInfo==false"><label ng-if="vm.showSkipOTP" for="skipOTPUserEmail" ng-disabled="vm.customerRegistrationRequest.customerType.enableUserInfo==false">Skip OTP</label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.userEmail" control-type="Email" control-id="txtuseremail" control-disabled="vm.customerRegistrationRequest.customerType.enableUserInfo==false" control-maxlength="100" form="usersInfo" required></div></div><div class="row generalAction" ng-if="vm.showGenerateUserOTPEmailButton"><div class="col-md-5 col-md-offset-2"><button type="button" ng-if="vm.showGenerateUserOTPEmailButton" class="btn btn-info lighttheme" ng-disabled="vm.disableGenerateUserOTPEmail" ng-click="vm.generateUserOTPEmail()"><span data-translate="entity.action.gnerateOTP"></span></button><br></div></div><div class="row generalAction" ng-if="vm.showGenerateUserOTPEmailButton && !vm.disableGenerateUserOTPEmail"><span class="col-md-5 col-md-offset-2 help-block-error" data-translate="gatewayApp.customerRegistration.verifyEmailText" style="text-align:left"></span></div><div class="row" ng-show="vm.visibleUserOTPEmail && !vm.skipOTPUserEmail"><div class="col-lg-2 col-md-offset-2"><label class="col-md-7 form-label" style="margin-top:10px"><span data-translate="gatewayApp.customerRegistration.otp"></span></label></div><div class="col-md-5" id="txtuseremailotp" control-model="vm.userEmailOtp" otp-input-directive options="userOtpEmailInput" size="{{vm.otpLength}}" control-disabled="(vm.isUserEmailVerified && vm.checkUserEmailOTP)"></div><div class="col-md-1" ng-show="vm.isUserEmailVerified && vm.checkUserEmailOTP"><span class="icon"><img src="assets/images/checkmark.gif"></span></div><div class="col-md-1" ng-show="vm.invalidUserEmailOtp && vm.checkUserEmailOTP" style="padding-top: 8px"><span class="icon icon_close" style="color:red;font-size: large"></span></div></div><div class="row" ng-show="vm.visibleUserOTPEmail && !(vm.isUserEmailVerified && vm.checkUserEmailOTP && !vm.skipOTPUserEmail)"><label class="col-md-7 col-md-offset-2" style="font-size:12px; text-align:right"><a href="" ng-click="vm.resendUserOTPEmail()">Resend</a></label></div><nmb-alert></nmb-alert><div class="row"><label class="col-md-2 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.mobile"></span></label><input ng-if="vm.showSkipOTP" type="checkbox" style="vertical-align: middle;margin-bottom: 3px" id="skipOTPUserMobile" ng-model="vm.skipOTPUserContact" ng-disabled="vm.customerRegistrationRequest.customerType.enableUserInfo==false"><label ng-if="vm.showSkipOTP" for="skipOTPUserMobile" ng-disabled="vm.customerRegistrationRequest.customerType.enableUserInfo==false">Skip OTP</label></div><div class="row"><div class="col-xs-2 col-md-offset-2"><cspl-numeric theme-type="light" control-model="vm.customerRegistrationRequest.userMobileCountryCode" control-id="txtUserMobileCountryCode" no-of-decimals="0" control-max="999" control-min="1" form="usersInfo" control-tab-index="-1" required control-disabled="(!vm.skipOTPUserEmail && !vm.isUserEmailVerified) || (vm.customerRegistrationRequest.customerType.enableUserInfo==false)"></div><div class="col-xs-7 col-md-5"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.userMobile" control-type="Number" control-id="txtUserMobile" control-maxlength="15" form="usersInfo" required control-disabled="(!vm.skipOTPUserEmail && !vm.isUserEmailVerified) || (vm.customerRegistrationRequest.customerType.enableUserInfo==false)"></div></div><div class="row help-block"><span class="col-md-7 col-md-offset-2" data-translate="gatewayApp.customerRegistration.userContactInfoNote" style="text-align: left;padding-bottom: 10px"></span></div><div class="row generalAction" ng-if="vm.showGenerateUserOTPButton"><div class="col-lg-2 col-md-offset-2"></div><div class="col-md-5"><button type="button" ng-if="vm.showGenerateUserOTPButton" class="btn btn-info lighttheme" ng-disabled="vm.disableGenerateUserOTP || (!vm.skipOTPUserEmail && !vm.isUserEmailVerified)" ng-click="vm.generateUserOTP()"><span data-translate="entity.action.gnerateOTP"></span></button><br></div></div><div class="row generalAction" ng-if="vm.showGenerateUserOTPButton && !vm.disableGenerateUserOTP"><span class="col-md-offset-4 help-block-error" data-translate="gatewayApp.customerRegistration.verifyMobileText" style="text-align:left"></span></div><!-- \t\t\t\t\t\t<nmb-alert></nmb-alert> --><div class="row" ng-show="vm.visibleUserOTP && !vm.skipOTPUserMobile"><div class="col-lg-2 col-md-offset-2"><label class="col-md-7 form-label" style="margin-top:10px"><span data-translate="gatewayApp.customerRegistration.otp"></span></label></div><div class="col-md-5" id="txtusermobileotp" control-model="vm.userMobileOtp" otp-input-directive options="userotpInput" size="{{vm.otpLength}}" control-disabled="(vm.isUserMobileVerified && vm.checkUserOTP)"></div><div class="col-md-1" ng-show="vm.isUserMobileVerified && vm.checkUserOTP"><span class="icon"><img src="assets/images/checkmark.gif"></span></div><div class="col-md-1" ng-show="vm.invalidUserOtp && vm.checkUserOTP" style="padding-top: 8px"><span class="icon icon_close" style="color:red;font-size: large"></span></div></div><div class="row" ng-show="vm.visibleUserOTP && !(vm.isUserMobileVerified && vm.checkUserOTP) && !vm.skipOTPUserMobile"><label class="col-md-7 col-md-offset-2" style="font-size:12px; text-align:right"><a href="" ng-click="vm.resendUserOTP()">Resend</a></label></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.address1"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.userAddress1" control-id="txtuseraddress1" control-maxlength="255" control-disabled="vm.customerRegistrationRequest.customerType.enableUserInfo==false" form="usersInfo" required></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label"><span data-translate="gatewayApp.customerRegistration.address2"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.userAddress2" control-id="txtuseraddress2" control-maxlength="255" control-disabled="vm.customerRegistrationRequest.customerType.enableUserInfo==false" form="usersInfo"></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.city"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.userCity" control-id="txtusercity" control-maxlength="255" control-disabled="vm.customerRegistrationRequest.customerType.enableUserInfo==false" form="usersInfo" required></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.country"></span></label></div><div class="row"><div class="col-md-5 col-md-offset-2"><cspl-ach theme-type="light" control-model="vm.customerRegistrationRequest.userCountry" control-id="txtuserCountry" lookup-name="country" display-column="shortName" control-disabled="vm.customerRegistrationRequest.customerType.enableUserInfo==false" form="usersInfo" required></cspl-ach></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.state"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-ach theme-type="light" control-model="vm.customerRegistrationRequest.userState" control-id="txtuserstate" lookup-name="state" display-column="shortName" filter-value="{{vm.customerRegistrationRequest.userCountry.id}}~~" form="usersInfo" control-disabled="vm.customerRegistrationRequest.customerType.enableUserInfo==false" required></cspl-ach></div></div><div class="row"><label class="col-md-7 col-md-offset-2 form-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.pincode"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-2"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.userPincode" control-id="txtuserpincode" control-type="Alphanumeric" control-maxlength="7" control-disabled="vm.customerRegistrationRequest.customerType.enableUserInfo==false" form="usersInfo" required></div></div></div><div class="form-box-inner modal-footer"><button type="button" class="btn btn-info secondaryAction" data-dismiss="modal" tabindex="-1" ng-click="vm.userInfo=false;vm.bankInfo=true;"><span data-translate="entity.action.previous"></span></button> <button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" ng-hide="true"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-info" ng-disabled="(!vm.skipOTPUserMobile && !vm.isUserMobileVerified) || usersInfo.$invalid || bankInfo.$invalid || customerInfo.$invalid || (!vm.skipOTPUserEmail && !vm.isUserEmailVerified) || vm.customerRegistrationRequest.userMobile==null || vm.customerRegistrationRequest.userMobile==\'\' || vm.customerRegistrationRequest.userMobile==undefined" ng-click="vm.submit()"><span data-translate="gatewayApp.customerRegistration.previewSubmit"></span></button><div class="col-xs-7" style="padding-top:10px;padding-left: 0px;padding-right: 0px"><div class="mandatory-note-bold btn btn-info"><span data-translate="gatewayApp.customerRegistration.chargesDetails1"></span></div><div class="mandatory-note btn btn-info"><span data-translate="gatewayApp.customerRegistration.chargesDetails2"></span></div></div></div></form></div></div><div class="copyright text-center"><!-- &copy; 2016 - Chella Software --></div></div></section></div><!-- commented due to redirect page happens from fxretail to netcoreads 29-03-2022\r\n<iframe src="https://netcoreads.com/dmp/jsv2/ifrm.html?pixelName=FX_Homepage&event=OTP%20Verification%20/%20Install%20/%20Register&eventName=FX_Register" WIDTH=0 HEIGHT=0></iframe> -->');
$templateCache.put('app/entities/customer-registration/customer-view-panImage.html','<style>.modal-header-red {background-color:#292929; padding:0px; height:50px; border: 1px solid #292929; border-top-left-radius:3px; border-top-right-radius:3px;}\r\n .modal-title {color:#FFF; vertical-align:middle; line-height:50px;}\r\n .modal-header button.close {color:#FFF; vertical-align:middle;}\r\n .modal-body {padding:20px;}</style><form name="panimage"><div class="{{vm.theme}}"><div class="modal-header modal-header-red"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()" style="color:#F2F2F2">&times;</button><h4 class="modal-title" style="text-align:left;padding-left:3%">Pan Image</h4></div><div class="modal-body"><img ng-src="data:image/JPEG;base64,{{vm.image}}" class="panImage"></div><nmb-alert-error></nmb-alert-error></div></form>');
$templateCache.put('app/entities/customer-registration/general-customer-info.html','<div class="row"><span class="group-heading">Customer Profile</span></div><br><div class="row"><label class="col-md-6 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.customerType"></span>&nbsp;* <span class="icon" cspl-info-tooltip="Select appropriate customer type" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row" style="margin-bottom:8px"><div class="col-md-7 col-md-offset-1"><select class="form-control select-style light-select" name="customerType" ng-model="vm.customerRegistrationRequest.customerType" ng-options="customerType as customerType.name for customerType in vm.customerTypes track by customerType.id" ng-init="vm.touchedcustomertype=false" ng-focus="vm.touchedcustomertype=true" ng-class="{red: customerInfo.customerType.$invalid && vm.touchedcustomertype}" form="customerRegistration" required><option value="" selected="selected" hidden></option></select><span class="help-block-error" ng-show="customerInfo.customerType.$invalid && vm.touchedcustomertype">This field cannot be left blank</span><div style="padding-top:10px"><div class="onboarding-help-text"><span data-translate="gatewayApp.customerRegistration.singleUserchargesDetails"></span></div><!-- <div ng-show="vm.showMultiUser" class="onboarding-help-text">\r\n                <span data-translate="gatewayApp.customerRegistration.multiUserchargesDetails"></span>\r\n            </div> --></div></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n&& vm.inputDetailsForSelectedCustType[entityNameIndex]!= null \r\n&& vm.inputDetailsForSelectedCustType[entityNameIndex].display"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.companyName"></span>&nbsp;* <span class="icon" cspl-info-tooltip="Enter the name of Entity" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n&& vm.inputDetailsForSelectedCustType[entityNameIndex]!= null \r\n&& vm.inputDetailsForSelectedCustType[entityNameIndex].display"><div class="col-md-7 col-md-offset-1"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.companyName" control-id="txtcompanyName" control-maxlength="100" form="customerRegistration" control-required="vm.inputDetailsForSelectedCustType[entityNameIndex].display && vm.inputDetailsForSelectedCustType[entityNameIndex].isMandatory"></div></div><!-- name info html  --><div ng-show="vm.showSingleUser" ng-include="\'app/entities/customer-registration/name-info.html\'"></div><!-- pan info  --><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex].display"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.panNo"></span>&nbsp;* <span class="icon" cspl-info-tooltip="Enter the correct PAN Number" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex].display"><div class="col-md-7 col-md-offset-1"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.panNumber" control-type="Alphanumeric" control-minlength="10" control-maxlength="10" control-id="txtPanNo" help-text="{{\'gatewayApp.customerRegistration.helpText.panNumber\' | translate}}" form="customerRegistration" control-required="vm.inputDetailsForSelectedCustType[panNoIndex].display && vm.inputDetailsForSelectedCustType[panNoIndex].isMandatory"></div><div class="col-md-2" style="margin-top:5px" ng-show="vm.customerRegistrationRequest.panImage ||vm.customerRegistrationRequest.customerPanImage"><a ng-click="vm.viewPanImage()"><img ng-src="assets/images/PAN Image-24.png"></a></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panImageIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panImageIndex].display"><div class="col-md-4 col-md-offset-1"><label class="form-label"><span data-translate="gatewayApp.customerRegistration.panImageUpload"></span>&nbsp;* <span class="icon" cspl-info-tooltip="{{vm.panImageInfo}}" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="col-md-6 col-xs-5 justified-help-block" style="padding-top: 5px"><div data-translate="global.label.acceptedFileFormatAndSize" data-translate-values="{value: \'{{vm.maximumFileSize}}\'}"></div></div></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panImageIndex]!= null \r\n\t\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panImageIndex].display"><div class="col-xs-6 col-md-offset-1" style="padding-right: 0px"><cspl-document-upload file="vm.panImage" control-id="uploadPath" form="customerRegistration" name="panImageUpload" control-required="true"></cspl-document-upload></div></div>');
$templateCache.put('app/entities/customer-registration/markup-info-view-dialog.html','<ng-form name="markup" ng-if="vm.showMarkup && !vm.customerRegistrationRequest.isProp"><div><h4 ng-show="vm.theme==\'dark\'" class="panel-title col-md-offset-2" style="width: 400px">&nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.markup.markUp"></span></h4><h4 ng-show="vm.theme==\'light\'" class="panel-title col-md-offset-2" style="width: 400px">&nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.markup.markUp"></span></h4></div><div class="row"><label class="col-md-3 control-label col-md-offset-3" style="padding-left: 0px"><span data-translate="gatewayApp.customerRegistration.markup.markupType"></span></label><label class="col-md-2 control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.markup.markupValue"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-3 multi-col"><select class="form-control select-style" name="markupType" ng-model="vm.markupType" ng-options="markupType.shortName for markupType in vm.markupTypes track by markupType.shortName" form="markup" ng-disabled="vm.disableMarkup" required></select></div><div class="col-md-2 multi-col" ng-show="vm.markupType.shortName!=\'Percentage\' " style="padding-left: 8px"><cspl-numeric control-model="vm.customerRegistrationRequest.markupSettings.markupValue" control-id="txtMarkupValue1" no-of-decimals="{{vm.noOfDecimals}}" form="markup" control-min="0" control-max="999" control-disabled="vm.disableMarkup" ng-class="{\'markupHighLight\' : vm.showHighLight }" control-required="vm.customerRegistrationRequest.actionType != \'REMOVE\'"></cspl-numeric></div><div class="col-md-2 multi-col" ng-show="vm.markupType.shortName==\'Percentage\' " style="padding-left: 8px"><cspl-numeric control-model="vm.customerRegistrationRequest.markupSettings.markupValue" control-id="txtMarkupValue2" no-of-decimals="{{vm.noOfDecimals}}" form="markup" control-min="0" control-max="100" control-disabled="vm.disableMarkup" ng-class="{\'markupHighLight\' : vm.showHighLight }" control-required="vm.customerRegistrationRequest.actionType != \'REMOVE\'"></cspl-numeric></div><div class="col-xs-1 col-md-1" style="line-height:30px"><span ng-show="vm.markupType.shortName==\'Percentage\' ">%</span></div></div><div class="row"><div class="col-md-3 multi-col col-md-offset-3"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.markup.taxOnMarkup"></span></label><div class="multi-col"><cspl-numeric control-model="vm.customerRegistrationRequest.markupSettings.taxOnMarkup" control-id="txtTaxOnMarkup" no-of-decimals="{{vm.decimalsForPercent}}" form="markup" control-min="0" control-max="100" control-disabled="vm.disableMarkup || vm.disableTax"></cspl-numeric></div></div><div class="col-md-1" style="line-height:78px"><span>%</span></div><div class="col-md-4 help-block-text" style="padding-right: 0px"><span class="help-block" style="text-align: left" data-translate="gatewayApp.customerRegistration.markup.blank"></span></div></div><div class="row"><label class="col-md-3 control-label col-md-offset-3" style="padding-left: 0px" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.markup.roEdApplicability"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-3 multi-col"><select class="form-control select-style" name="roEdApplicability" ng-model="vm.roEdApplicabilityMethod" ng-options="roEdApplicability.name for roEdApplicability in vm.roEdApplicabilityMethodList track by roEdApplicability.shortName" form="markup" ng-disabled="vm.disableMarkup" required></select></div></div></ng-form>');
$templateCache.put('app/entities/customer-registration/multi-user-customer-preview.html','<div class="col-md-4"><div class="headerForm"><h5 class="formHeading" data-translate="gatewayApp.customerRegistration.CustomerProfile"></h5></div><form name="customerInfo"><div style="display:table" class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.customerType" style="display:cell"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.customerType.name" control-id="txtCustomerType" form="customerInfo" control-disabled="true" required></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex].display"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.companyName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.companyName" control-id="txtfirstName" form="customerInfo" control-disabled="true" control-required="vm.inputDetailsForSelectedCustType[entityNameIndex].isMandatory"></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex].display"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.panNo"></span></label></div><div class="col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.panNumber" control-id="txtPanNo" form="customerInfo" control-disabled="true" control-required="vm.inputDetailsForSelectedCustType[panNoIndex].isMandatory"></div><div class="col-md-2" style="margin-top:5px"><a ng-click="vm.viewPanImage()"><img ng-show="vm.theme==\'dark\'" ng-src="assets/images/panImage.png" ng-class="{\'higlightChange\' : vm.checkforModification(\'customerPanImage\')}"><img ng-show="vm.theme==\'light\'" ng-src="assets/images/PAN Image-24.png"></a></div></div><!--customer info html  --><div ng-include="\'app/entities/customer-registration/customer-info-preview.html\'"></div></form></div><div class="col-md-4"><div class="headerForm"><h5 class="formHeading" data-translate="gatewayApp.customerRegistration.authorizedPerson"></h5></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.firstName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userFirstName" control-id="txtfirstName" form="customerInfo" control-disabled="true" control-required="vm.inputDetailsForSelectedCustType[firstNameIndex].isMandatory"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.middleName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userMiddleName" control-id="txtmiddleName" control-maxlength="100" form="customerInfo" control-disabled="true" control-modified="vm.checkforModification(\'customerMiddleName\')"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.lastName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userLastName" control-id="txtLastName" control-disabled="true" form="customerInfo" control-required="vm.inputDetailsForSelectedCustType[lastNameIndex].isMandatory" control-modified="vm.checkforModification(\'customerLastName\')"></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.email"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userEmail" control-type="Email" control-id="txtemail" control-disabled="true" form="customerInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.mobile"></span></label></div><div class="col-xs-2 col-md-2"><cspl-numeric theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userMobileCountryCode" control-id="txtprimaryMobileCountryCode" no-of-decimals="0" control-disabled="true" form="customerInfo" required></div><div class="col-xs-7 col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userMobile" control-type="Number" control-id="txtprimaryMobile" control-disabled="true" form="customerInfo" control-maxlength="15" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.dob"></span></label></div><div class="col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.dob" control-id="txtDob" control-disabled="true" form="usersInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.login"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.login" control-id="txtLogin" control-disabled="true" form="usersInfo" required></div></div></div>');
$templateCache.put('app/entities/customer-registration/multi-user-customer.html','<div ng-include="\'app/entities/customer-registration/customer-info.html\'"></div><div ng-include="\'app/entities/customer-registration/name-info.html\'"></div><div ng-include="\'app/entities/customer-registration/user-info.html\'"></div><div ng-include="\'app/entities/customer-registration/bank-info.html\'"></div>');
$templateCache.put('app/entities/customer-registration/name-info-view-dialog.html','<ng-form name="nameInfo"><!-- whereever customer info group show then auth person info also shown --><div class="row"><h4 ng-show="vm.theme==\'dark\'" class="panel-title col-md-offset-2" style="width: 400px">&nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.authorisedPerson"></span></h4><h4 ng-show="vm.theme==\'light\'" class="panel-title col-md-offset-2" style="width: 400px">&nbsp; <span class="nav-label" data-translate="gatewayApp.customerRegistration.authorisedPerson"></span></h4></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.firstName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userFirstName" control-id="txtfirstName" form="nameInfo" control-disabled="!vm.enableFieldsForResubmit" control-modified="vm.checkforModification(\'customerFirstName\')" control-required="vm.inputDetailsForSelectedCustType[firstNameIndex].display && vm.inputDetailsForSelectedCustType[firstNameIndex].isMandatory"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.customerRegistration.middleName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userMiddleName" control-id="txtmiddleName" control-maxlength="100" form="nameInfo" control-disabled="!vm.enableFieldsForResubmit" control-modified="vm.checkforModification(\'customerMiddleName\')"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.lastName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userLastName" control-id="txtLastName" control-disabled="!vm.enableFieldsForResubmit" form="nameInfo" control-required="vm.inputDetailsForSelectedCustType[lastNameIndex].display && vm.inputDetailsForSelectedCustType[lastNameIndex].isMandatory" control-modified="vm.checkforModification(\'customerLastName\')"></div></div></ng-form>');
$templateCache.put('app/entities/customer-registration/name-info.html','<div class="row" style="margin-top: 15px"><span class="group-heading">Authorised Person</span></div><div class="col-md-7 col-md-offset-1"><span class="help-block authorised-help-text" data-translate="gatewayApp.customerRegistration.helpText.authorisedPersonDetails"></span></div><div class="row"><label class="col-md-7 col-md-offset-1 form-label" style="position:relative"><span data-translate="gatewayApp.customerRegistration.firstName"></span>&nbsp;* <span class="icon" cspl-info-tooltip="{{vm.firstNameInfo}}" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userFirstName" control-id="txtfirstName" control-type="AlphaWithSpace" control-maxlength="100" form="customerRegistration" control-required="true"></div></div><div class="row"><div class="col-md-7 col-md-offset-1"><span class="help-block" data-translate="gatewayApp.customerRegistration.helpText.firstName" style="text-align: right"></span></div></div><div class="row"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.middleName"></span> <span class="icon" cspl-info-tooltip="{{vm.middleNameInfo}}" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userMiddleName" control-id="txtmiddleName" control-type="AlphaWithSpace" control-maxlength="100" form="customerRegistration"></div></div><div class="row"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.lastName"></span>&nbsp;* <span class="icon" cspl-info-tooltip="{{vm.lastNameInfo}}" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userLastName" control-id="txtlastName" control-type="AlphaWithSpace" control-maxlength="100" form="customerRegistration" control-required="true"></div></div><div class="row"><div class="col-md-7 col-md-offset-1"><span class="help-block" data-translate="gatewayApp.customerRegistration.helpText.lastName" style="text-align: right"></span></div></div>');
$templateCache.put('app/entities/customer-registration/single-user-customer-preview.html','<div class="col-md-4"><div class="headerForm"><h5 class="formHeading" data-translate="gatewayApp.customerRegistration.CustomerProfile"></h5></div><form name="customerInfo"><div style="display:table" class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.customerType" style="display:cell"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.customerType.name" control-id="txtCustomerType" form="customerInfo" control-disabled="true" required></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex].display"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.companyName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.companyName" control-id="txtfirstName" form="customerInfo" control-disabled="true" control-required="vm.inputDetailsForSelectedCustType[entityNameIndex].isMandatory"></div></div><div class="col-md-12" style="padding-right:0;padding-left:0"><div class="headerForm"><h5 class="formHeadingnew" data-translate="gatewayApp.customerRegistration.authorizedPerson"></h5></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex].display"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.firstName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userFirstName" control-id="txtfirstName" form="customerInfo" control-disabled="true" control-required="vm.inputDetailsForSelectedCustType[firstNameIndex].isMandatory"></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex].display"><div class="col-md-4"><label class="control-label"><span data-translate="gatewayApp.customerRegistration.middleName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userMiddleName" control-id="txtmiddleName" control-maxlength="100" form="customerInfo" control-disabled="true" control-modified="vm.checkforModification(\'customerMiddleName\')"></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex].display"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.lastName"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userLastName" control-id="txtLastName" control-disabled="true" form="customerInfo" control-required="vm.inputDetailsForSelectedCustType[lastNameIndex].isMandatory" control-modified="vm.checkforModification(\'customerLastName\')"></div></div><div class="col-md-12" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex].display"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.panNo"></span></label></div><div class="col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.panNumber" control-id="txtPanNo" form="customerInfo" control-disabled="true" control-required="vm.inputDetailsForSelectedCustType[panNoIndex].isMandatory"></div><div class="col-md-2" style="margin-top:5px"><a ng-click="vm.viewPanImage()"><img ng-show="vm.theme==\'dark\'" ng-src="assets/images/panImage.png" ng-class="{\'higlightChange\' : vm.checkforModification(\'customerPanImage\')}"><img ng-show="vm.theme==\'light\'" ng-src="assets/images/PAN Image-24.png"></a></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.email"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userEmail" control-type="Email" control-id="txtemail" control-disabled="true" form="customerInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.mobile"></span></label></div><div class="col-xs-2 col-md-2"><cspl-numeric theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userMobileCountryCode" control-id="txtprimaryMobileCountryCode" no-of-decimals="0" control-disabled="true" form="customerInfo" required></div><div class="col-xs-7 col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.userMobile" control-type="Number" control-id="txtprimaryMobile" control-disabled="true" form="customerInfo" control-maxlength="15" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.dob"></span></label></div><div class="col-md-6"><cspl-text theme-type="{{vm.theme}}" control-model="vm.dob" control-id="txtDob" control-disabled="true" form="usersInfo" required></div></div><div class="col-md-12"><div class="col-md-4"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.login"></span></label></div><div class="col-md-8"><cspl-text theme-type="{{vm.theme}}" control-model="vm.customerRegistrationRequest.login" control-id="txtLogin" control-disabled="true" form="usersInfo" required></div></div></div></form></div><!-- customer info html --><div class="col-md-4"><br><br><br><div ng-include="\'app/entities/customer-registration/customer-info-preview.html\'"></div></div>');
$templateCache.put('app/entities/customer-registration/single-user-customer.html','<div ng-include="\'app/entities/customer-registration/user-info.html\'"></div><div ng-include="\'app/entities/customer-registration/customer-info.html\'"></div><div ng-include="\'app/entities/customer-registration/bank-info.html\'"></div>');
$templateCache.put('app/entities/customer-registration/user-info.html','<div class="row"><label class="col-md-3 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.email"></span>&nbsp;* <span class="icon" cspl-info-tooltip="{{vm.emailInfo}}" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label><input ng-if="vm.showSkipOTP" type="checkbox" style="vertical-align: middle;margin-bottom: 3px" id="skipOTPUserEmail" ng-model="vm.skipOTPUserEmailContact"><label ng-if="vm.showSkipOTP" for="skipOTPUserEmail">Skip OTP</label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.userEmail" control-type="Email" control-id="txtuseremail" control-maxlength="100" form="customerRegistration" required></div></div><div class="row generalAction" ng-if="vm.showGenerateUserOTPEmailButton"><div class="col-md-5 col-md-offset-1"><button type="button" ng-if="vm.showGenerateUserOTPEmailButton" class="btn btn-info lighttheme" ng-disabled="vm.disableGenerateUserOTPEmail" ng-click="vm.generateUserOTPEmail()"><span data-translate="entity.action.gnerateOTP"></span></button><br></div></div><div class="row generalAction" ng-if="vm.showGenerateUserOTPEmailButton && !vm.disableGenerateUserOTPEmail"><span class="col-md-5 col-md-offset-1 help-block-error" data-translate="gatewayApp.customerRegistration.verifyEmailText" style="text-align:left"></span></div><div class="row" ng-show="vm.visibleUserOTPEmail && !vm.skipOTPUserEmail"><div class="col-lg-2 col-md-offset-1"><label class="col-md-7 form-label" style="margin-top:10px"><span data-translate="gatewayApp.customerRegistration.otp"></span></label></div><div class="col-md-5" id="txtuseremailotp" control-model="vm.userEmailOtp" otp-input-directive options="userOtpEmailInput" size="{{vm.otpLength}}" control-disabled="(vm.isUserEmailVerified && vm.checkUserEmailOTP)"></div><div class="col-md-1" ng-show="vm.isUserEmailVerified && vm.checkUserEmailOTP"><span class="icon"><img src="assets/images/checkmark.gif"></span></div><div class="col-md-1" ng-show="vm.invalidUserEmailOtp && vm.checkUserEmailOTP" style="padding-top: 8px"><span class="icon icon_close" style="color:red;font-size: large"></span></div></div><div class="row" ng-show="vm.visibleUserOTPEmail && !(vm.isUserEmailVerified && vm.checkUserEmailOTP && !vm.skipOTPUserEmail)"><label class="col-md-7 col-md-offset-1" style="font-size:12px; text-align:right"><a href="" ng-click="vm.resendUserOTPEmail()">Resend</a></label></div><div class="row" ng-show="vm.visibleUserOTPEmail"><div class="col-md-6 col-md-offset-2"><label class="help-block" ng-show="vm.userEmailOtp==null" ng-hide="vm.invalidUserEmailOtp && vm.checkUserEmailOTP" data-translate="gatewayApp.customerRegistration.helpText.otpEmail"></label><label class="help-block" ng-show="vm.invalidUserEmailOtp && vm.checkUserEmailOTP" data-translate="gatewayApp.customerRegistration.helpText.wrongotp"></label></div></div><nmb-alert></nmb-alert><div class="row"><label class="col-md-3 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.mobile"></span>&nbsp;* <span class="icon" cspl-info-tooltip="{{vm.mobileInfo}}" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label><input ng-if="vm.showSkipOTP" type="checkbox" style="vertical-align: middle;margin-bottom: 3px" id="skipOTPUserMobile" ng-model="vm.skipOTPUserContact"><label ng-if="vm.showSkipOTP" for="skipOTPUserMobile">Skip OTP</label></div><div class="row"><div class="col-xs-2 col-md-offset-1"><cspl-numeric theme-type="light" control-model="vm.customerRegistrationRequest.userMobileCountryCode" control-id="txtUserMobileCountryCode" no-of-decimals="0" control-max="999" control-min="1" form="customerRegistration" control-tab-index="-1" required control-disabled="(!vm.skipOTPUserEmail && !vm.isUserEmailVerified)"></div><div class="col-xs-7 col-md-5"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.userMobile" control-type="Number" control-id="txtUserMobile" control-maxlength="15" form="customerRegistration" required control-disabled="(!vm.skipOTPUserEmail && !vm.isUserEmailVerified)"></div></div><div class="row generalAction" ng-if="vm.showGenerateUserOTPButton"><div class="col-lg-2 col-md-offset-1"></div><div class="col-md-5"><button type="button" ng-if="vm.showGenerateUserOTPButton" class="btn btn-info lighttheme" ng-disabled="vm.disableGenerateUserOTP || (!vm.skipOTPUserEmail && !vm.isUserEmailVerified)" ng-click="vm.generateUserOTP()"><span data-translate="entity.action.gnerateOTP"></span></button><br></div></div><div class="row generalAction" ng-if="vm.showGenerateUserOTPButton && !vm.disableGenerateUserOTP"><span class="col-md-offset-3 help-block-error" data-translate="gatewayApp.customerRegistration.verifyMobileText" style="text-align:left"></span></div><!-- \t\t\t\t\t\t<nmb-alert></nmb-alert> --><div class="row" ng-show="vm.visibleUserOTP && !vm.skipOTPUserMobile"><div class="col-lg-2 col-md-offset-1"><label class="col-md-7 form-label" style="margin-top:10px"><span data-translate="gatewayApp.customerRegistration.otp"></span></label></div><div class="col-md-5" id="txtusermobileotp" control-model="vm.userMobileOtp" otp-input-directive options="userotpInput" size="{{vm.otpLength}}" control-disabled="(vm.isUserMobileVerified && vm.checkUserOTP)"></div><div class="col-md-1" ng-show="vm.isUserMobileVerified && vm.checkUserOTP"><span class="icon"><img src="assets/images/checkmark.gif"></span></div><div class="col-md-1" ng-show="vm.invalidUserOtp && vm.checkUserOTP" style="padding-top: 8px"><span class="icon icon_close" style="color:red;font-size: large"></span></div></div><div class="row" ng-show="vm.visibleUserOTP && !(vm.isUserMobileVerified && vm.checkUserOTP) && !vm.skipOTPUserMobile"><label class="col-md-7 col-md-offset-1" style="font-size:12px; text-align:right"><a href="" ng-click="vm.resendUserOTP()">Resend</a></label></div><div class="row" ng-show="vm.visibleUserOTP  && !vm.skipOTPUserMobile"><div class="col-md-6 col-md-offset-2"><label class="help-block" ng-show="vm.userMobileOtp==null" ng-hide="vm.invalidUserOtp && vm.checkUserOTP" data-translate="gatewayApp.customerRegistration.helpText.otp"></label><label class="help-block" ng-show="vm.invalidUserOtp && vm.checkUserOTP" data-translate="gatewayApp.customerRegistration.helpText.wrongotp"></label></div></div><div class="row" style="margin-top:8px"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.dob"></span>&nbsp;* <span class="icon" cspl-info-tooltip="{{vm.dobInfo}}" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-5 col-md-offset-1"><cspl-dtp theme-type="light" control-model="vm.customerRegistrationRequest.dob" control-id="dtpDOB" form="customerRegistration" control-disabled="false" required></cspl-dtp></div></div><div class="row"><label class="col-md-7 col-md-offset-1 form-label"><span data-translate="gatewayApp.customerRegistration.login"></span>&nbsp;* <span class="icon" cspl-info-tooltip="Enter the login in Alphabet and/or number. This can be used to login into FX -Retail platform" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-1"><cspl-text theme-type="light" control-model="vm.customerRegistrationRequest.login" control-id="txtLogin" control-type="Small" control-maxlength="100" form="customerRegistration" required></div></div>');
$templateCache.put('app/entities/customer-tac-upload/customer-tac-upload-approval-disclaimer-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()" style="color:#F2F2F2">&times;</button><h4 class="modal-title">Disclaimer</h4></div><div class="modal-body"><div class="content"><div class="row"><div class="justified-tac-label text-decoration-underline" style="text-align: center"><span data-translate="gatewayApp.customerTacUploadByBank.disclaimerHeading"></span></div><label class="justified-tac-label" style="margin-left: 8%;  margin-right: 8%;  padding-bottom: 10px"><span data-translate="gatewayApp.customerTacUploadByBank.disclaimerContent1"></span> <a ng-click="vm.onGetCcilTac(vm.organisation.id,vm.messageBoxName)"><span data-translate="gatewayApp.customerTacUploadByBank.disclaimerContent2"></span></a> <span data-translate="gatewayApp.customerTacUploadByBank.disclaimerContent3"></span></label></div></div><div class="modal-footer"><button type="button" class="btn btn-approve" ng-disabled="clicked" ng-click="clicked = true;vm.approve();"><span data-translate="entity.action.approve">Approve</span></button> <button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button></div></div>');
$templateCache.put('app/entities/customer-tac-upload/customer-tac-upload-by-bank-approval.html','<div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="global.menu.customerTacUploadByBank.title"></span></h4></div><div class="modal-body"><div class="content"><p><nmb-alert></nmb-alert></p><p><nmb-alert-error></nmb-alert-error></p><form name="termsConditionUploadForm" role="form" novalidate><div class="col-md-offset-1 col-sm-offset-1 col-xs-offset-1 col-lg-offset-1 col-md-8 col-sm-8 col-xs-11 col-lg-8"><div class="row"><label class="control-label margin-top-7" cspl-mandatory><span data-translate="gatewayApp.customerTacUploadByBank.bankName"></span></label></div><div class="row"><span class="col-md-8 col-lg-7 col-sm-8 col-xs-8" style="margin-left: -8px"><cspl-text control-model="vm.bankForCustomerTacDTO.bank.bankName" control-id="txtbankName" control-disabled="true" placeholder="" form="termsConditionUploadForm" required></span></div><div class="row"><label class="control-label margin-top-7" cspl-mandatory><span data-translate="gatewayApp.customerTacUploadByBank.enforcingDate"></span></label></div><div class="row" ng-if="showResubmitButton == false"><div class="col-md-8 col-lg-7 col-sm-8 col-xs-8" style="margin-left: -8px"><cspl-dtp control-model="vm.bankForCustomerTacDTO.enforcingDate" control-id="enforcingDate" control-required="true" control-disabled="showResubmitButton == false" form="termsConditionUploadForm"></cspl-dtp><div class="justified-help-block" style="padding-top: 0px; /*width: 130%*/"><span data-translate="gatewayApp.customerTacUploadByBank.enforcingHelpText1"></span> <span class="text-decoration-underline" data-translate="gatewayApp.customerTacUploadByBank.enforcingHelpText2"></span> <span data-translate="gatewayApp.customerTacUploadByBank.enforcingHelpText3"></span></div></div><div class="col-md-4 col-lg-5 col-sm-4 col-xs-4" ng-if="showResubmitButton == false"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.openTACPreview(vm.bankForCustomerTacDTO.tacMaster.tacFiles)"><span data-translate="gatewayApp.customerTacUploadByBank.Preview"></span></button></div></div><div class="row" ng-if="showResubmitButton == true"><div class="col-md-8 col-lg-7 col-sm-8 col-xs-8" style="margin-left: -8px"><cspl-dtp control-model="vm.bankForCustomerTacDTO.enforcingDate" control-id="enforcingDate" control-required="true" control-min-date="vm.minDate" control-disabled="showResubmitButton == false" form="termsConditionUploadForm"></cspl-dtp><div class="justified-help-block" style="padding-top: 0px; /*width: 130%*/"><span data-translate="gatewayApp.customerTacUploadByBank.enforcingHelpText1"></span> <span class="text-decoration-underline" data-translate="gatewayApp.customerTacUploadByBank.enforcingHelpText2"></span> <span data-translate="gatewayApp.customerTacUploadByBank.enforcingHelpText3"></span></div></div><div class="col-md-4 col-lg-5 col-sm-4 col-xs-4" ng-if="showResubmitButton == false"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.openTACPreview(vm.bankForCustomerTacDTO.tacMaster.tacFiles)"><span data-translate="gatewayApp.customerTacUploadByBank.Preview"></span></button></div></div><div class="row" ng-show="showResubmitButton"><label class="control-label margin-top-7" cspl-mandatory><span data-translate="gatewayApp.customerTacUploadByBank.filePath"></span></label></div><div class="row" ng-show="showResubmitButton"><div class="col-md-8 col-lg-7 col-sm-8 col-xs-8" style="margin-left: -8px"><div class="input-group col-md-12"><input type="text" class="form-control fileOpen" ng-class="{ \'red\': vm.checkTACFile && (vm.inputTermsCondition==null || vm.inputTermsCondition==undefined)}" style="width: 75%" ng-model="vm.inputTermsCondition" ng-blur="vm.checkTACFile=true;" readonly="readonly"><label style="width: 25%" for="termsConditionFile" ng-class="{ \'notentered\': vm.checkTACFile && (vm.inputTermsCondition==null || vm.inputTermsCondition==undefined)}" class="btn btn-primary fileUploadDark"><img src="assets/images/Open Path-26.png" style="pointer-events: none"></label><input type="file" id="termsConditionFile" name="termsConditionUpload" fileread="vm.termsCondition" accept="application/pdf" form="termsConditionUploadForm" ng-hide="true"> <span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.invalidTermsConditionSize"><!-- Uploaded content should not be greater than 500 kb. -->{{ vm.invalidTermsConditionSixeText}} </span><span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.invalidTermsCondition">{{vm.invalidTermsConditionText}}</span> <span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.invalidTermsConditionName">{{vm.invalidTermsConditionNameText}}</span> <span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.checkTACFile && ( vm.inputTermsCondition==null || vm.inputTermsCondition==undefined)">Pdf file should be uploaded.</span></div></div><div class=""><button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="termsConditionUploadForm.$invalid || (vm.termsCondition == null) || vm.clicked" ng-click="vm.clicked = true;vm.resubmitTAC();"><span data-translate="entity.action.resubmit">UPLOAD</span></button></div></div><div class="row" ng-if="showResubmitButton"><div class="orderStatusInfo col-md-12 no-padding-top no-padding-left" style="float: left"><div class="no-padding-left no-padding-right"><div><span data-translate="gatewayApp.customerTacUploadByBank.acceptedFileTypeLegend"></span></div><span ng-show="vm.showInKB" data-translate="gatewayApp.customerTacUploadByBank.maximumFileSizeLegend" data-translate-values="{value: {{vm.tacFileUploadSize}}}"></span> <span ng-show="vm.showInKB == false" data-translate="gatewayApp.customerTacUploadByBank.maximumFileSizeLegendMB" data-translate-values="{value: {{vm.tacFileUploadSize}}}"></span></div></div></div><div class="row"></div><br></div><div class="row col-md-offset-1 col-sm-offset-1 col-xs-offset-1 col-lg-offset-1 col-md-9 col-sm-10 col-xs-11 col-lg-10"><div class="row text-decoration-underline justified-tac-label" style="text-align: center"><span data-translate="gatewayApp.customerTacUploadByBank.disclaimerHeading"></span></div><div class="row justified-tac-label text-align-justify"><span data-translate="gatewayApp.customerTacUploadByBank.disclaimerContent1"></span> <a ng-click="vm.openClearcorpTac(vm.orgId,vm.messageBoxName)"><span data-translate="gatewayApp.customerTacUploadByBank.disclaimerContent2"></span></a> <span data-translate="gatewayApp.customerTacUploadByBank.disclaimerContent3"></span></div></div><br><div class="col-md-offset-2 col-sm-offset-2 col-xs-offset-1 col-lg-offset-2 col-md-10 col-sm-10 col-xs-11"><div class="row"><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()" ng-if="!showResubmitButton">&nbsp;<span>OK</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardTAC()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectTAC()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" autofocus class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveTAC();vm.clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div></div></div></form></div></div>');
$templateCache.put('app/entities/customer-tac-upload/customer-tac-upload-by-bank-view.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.customerTacUploadByBank.title"></h2><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="module-wrapper"><section class="module"><div class="module-inner"><div ng-show="vm.bankTACDetails.length > 0"><div class="row"><div class="pull-left"><a href="" style="color: #fff; vertical-align: -19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size: 20px"></i></a></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 float-right"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="clearcorpTermsCondition" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.customerTacUploadByBank.entity"></th><th data-translate="gatewayApp.customerTacUploadByBank.lastmodifiedDateTime"></th><th></th><th></th></tr></thead><tbody><tr class="clearcorp-terms-conditions" ng-repeat="tac in filterData = ( vm.bankTACDetails | filter : filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td width="20%"><span ng-if="tac.tacType.type == \'Bank for Customer\'">Customer</span></td><td width="25%"><span ng-show="tac.lastModifiedDate != null && tac.tacFiles != null">{{tac.lastModifiedDate | date:\'dd-MMM-yyyy hh:mm:ss a\'}}</span><span ng-show="tac.lastModifiedDate == null || tac.tacFiles == null">-</span></td><td width="10%" ng-show="tac.tacFiles != null"><span style="color: #FFAA1D" ng-show="tac.tacFiles != null" class="glyphicon glyphicon-file" ng-click="vm.openTACPreview(tac.tacFiles)" title="View Customer Terms and Conditions"></span></td><td><span><img src="assets/images/EditProfile.png" class="EditProfile-noHover" ng-click="vm.uploadTAC(tac)"> <img src="assets/images/EditProfile_Black.png" class="EditProfile-Hover" ng-click="vm.uploadTAC(tac)" title="Revise Customer Terms and Conditions"></span></td><td ng-show="tac.tacFiles == null"></td></tr></tbody></table></div></div></div></section></div></div>');
$templateCache.put('app/entities/customer-tac-upload/customer-tac-upload-by-bank.html','<div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="global.menu.customerTacUploadByBank.title"></span></h4></div><div class="modal-body"><div class="content"><p><nmb-alert></nmb-alert></p><p><nmb-alert-error></nmb-alert-error></p><form name="termsConditionUploadForm" role="form" novalidate><div class="col-md-offset-1 col-sm-offset-1 col-xs-offset-1 col-lg-offset-1 col-md-8 col-sm-8 col-xs-11 col-lg-8"><div class="row"><label class="control-label margin-top-7" cspl-mandatory><span data-translate="gatewayApp.customerTacUploadByBank.bankName"></span></label></div><div class="row"><span class="col-md-8 col-lg-7 col-sm-8 col-xs-8" style="margin-left: -8px"><cspl-text control-model="vm.bankForCustomerTacDTO.bank.bankName" control-id="txtbankName" control-disabled="true" placeholder="" form="termsConditionUploadForm" required></span></div><div class="row"><label class="control-label margin-top-7" cspl-mandatory><span data-translate="gatewayApp.customerTacUploadByBank.enforcingDate"></span></label></div><div class="row"><div class="col-md-8 col-lg-7 col-sm-8 col-xs-8" style="margin-left: -8px"><cspl-dtp control-model="vm.bankForCustomerTacDTO.enforcingDate" control-id="enforcingDate" control-required="true" control-min-date="vm.minDate" form="termsConditionUploadForm"></cspl-dtp><div class="justified-help-block" style="padding-top: 0px; /*width: 130%*/"><span data-translate="gatewayApp.customerTacUploadByBank.enforcingHelpText1"></span> <span class="text-decoration-underline" data-translate="gatewayApp.customerTacUploadByBank.enforcingHelpText2"></span> <span data-translate="gatewayApp.customerTacUploadByBank.enforcingHelpText3"></span></div></div></div><div class="row"><label class="control-label margin-top-7" cspl-mandatory><span data-translate="gatewayApp.customerTacUploadByBank.filePath"></span></label></div><div class="row"><div class="col-md-8 col-lg-7 col-sm-8 col-xs-8" style="margin-left: -8px"><div class="input-group col-md-12"><input type="text" class="form-control fileOpen" ng-class="{ \'red\': vm.checkTACFile && (vm.inputTermsCondition==null || vm.inputTermsCondition==undefined)}" style="width: 75%" ng-model="vm.inputTermsCondition" ng-blur="vm.checkTACFile=true;" readonly="readonly"><label style="width: 25%" for="termsConditionFile" ng-class="{ \'notentered\': vm.checkTACFile && (vm.inputTermsCondition==null || vm.inputTermsCondition==undefined)}" class="btn btn-primary fileUploadDark"><img src="assets/images/Open Path-26.png" style="pointer-events: none"></label><input type="file" id="termsConditionFile" name="termsConditionUpload" fileread="vm.termsCondition" accept="application/pdf" form="termsConditionUploadForm" ng-hide="true"> <span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.invalidTermsConditionSize"><!-- Uploaded content should not be greater than 500 kb. -->{{ vm.invalidTermsConditionSixeText}} </span><span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.invalidTermsCondition">{{vm.invalidTermsConditionText}}</span> <span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.invalidTermsConditionName">{{vm.invalidTermsConditionNameText}}</span> <span class="help-block-error" style="margin-top: -10px; margin-bottom: 12px" ng-show="vm.checkTACFile && ( vm.inputTermsCondition==null || vm.inputTermsCondition==undefined)">Pdf file should be uploaded.</span></div></div><div class=""><button type="submit" class="btn btn-primary" ng-disabled="termsConditionUploadForm.$invalid || (vm.termsCondition == null) || vm.clicked" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.upload">UPLOAD</span></button></div></div><div class="row"><div class="orderStatusInfo col-md-12 no-padding-top no-padding-left" style="float: left"><div class="no-padding-left no-padding-right"><div><span data-translate="gatewayApp.customerTacUploadByBank.acceptedFileTypeLegend"></span></div><span ng-show="vm.showInKB" data-translate="gatewayApp.customerTacUploadByBank.maximumFileSizeLegend" data-translate-values="{value: {{vm.tacFileUploadSize}}}"></span> <span ng-show="vm.showInKB == false" data-translate="gatewayApp.customerTacUploadByBank.maximumFileSizeLegendMB" data-translate-values="{value: {{vm.tacFileUploadSize}}}"></span></div></div></div><div class="row"></div><br></div><div class="row col-md-offset-1 col-sm-offset-1 col-xs-offset-1 col-lg-offset-1 col-md-9 col-sm-10 col-xs-11 col-lg-10"><div class="row text-decoration-underline justified-tac-label" style="text-align: center"><span data-translate="gatewayApp.customerTacUploadByBank.disclaimerHeading"></span></div><div class="row justified-tac-label text-align-justify"><span data-translate="gatewayApp.customerTacUploadByBank.disclaimerContent1"></span> <a ng-click="vm.openClearcorpTac(vm.orgId,vm.messageBoxName)"><span data-translate="gatewayApp.customerTacUploadByBank.disclaimerContent2"></span></a> <span data-translate="gatewayApp.customerTacUploadByBank.disclaimerContent3"></span></div></div><br><br><div class="row col-md-offset-1 col-sm-offset-1 col-xs-offset-1 col-lg-offset-1 col-md-9 col-sm-10 col-xs-11 col-lg-10">&nbsp;</div></form></div></div>');
$templateCache.put('app/entities/customer-specific-settings/customer-specific-settings.html','<form name="customerSpecificSettingsForm" role="form" novalidate><script src="app/app.module.js"></script><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="global.menu.customerSpecificSettings.settings"></span></h4></div><div class="modal-body"><div class="content" style="min-height:35vh"><nmb-alert></nmb-alert><div class="column" style="background-color: #000000; width: 30%;margin-top:20px"><div class="tab"><br><div class="img-with-text"><img src="assets/images/OrderSettingsCurrent.png" ng-show="vm.isShowOrderSettings" style="width: 40px; height: 40px"> <img src="assets/images/OrderSettings.png" ng-show="!vm.isShowOrderSettings" style="width: 40px; height: 40px" ng-click="vm.isShowOrderSettings=true;"><p style="text-align: center">Order Settings</p></div><br></div></div><div class="column" style="background-color: #000000; width: 70%;margin-top:40px"><div id="OrderSettings" ng-show="vm.isShowOrderSettings"><div class="row"><label class="col-xs-7 col-xs-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.customerSpecificSettings.tradeSMSToBeSent"></span></label></div><div class="row"><div id="btnGroup" class="col-xs-4 col-xs-offset-1" style="padding-bottom:7px"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.customerSpecificSettings.IsTradeSMSToBeSent" ng-disabled="true" uib-btn-radio="\'Yes\'">Yes</label><label class="btn btn-primary" ng-model="vm.customerSpecificSettings.IsTradeSMSToBeSent" ng-disabled="true" uib-btn-radio="\'No\'">No&nbsp;</label></div></div><a style="text-decoration: none" title="Change Settings" ui-sref="change-settings({headerLabel: \'Order Settings\',labelName: \'{{\'gatewayApp.customerSpecificSettings.tradeSMSToBeSent\' | translate}}\' ,settingsName: \'IsTradeSMSToBeSent\' , settingsValue: vm.customerSpecificSettings.IsTradeSMSToBeSent, settingsType : \'yesorno\', screenName : \'customerdealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px;margin-top:6px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-xs-7 col-xs-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.customerSpecificSettings.tradeEmailToBeSent"></span></label></div><div class="row"><div id="btnGroup" class="col-xs-4 col-xs-offset-1" style="padding-bottom:7px"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.customerSpecificSettings.IsTradeEmailToBeSent" ng-disabled="true" uib-btn-radio="\'Yes\'">Yes</label><label class="btn btn-primary" ng-model="vm.customerSpecificSettings.IsTradeEmailToBeSent" ng-disabled="true" uib-btn-radio="\'No\'">No&nbsp;</label></div></div><a style="text-decoration: none" title="Change Settings" ui-sref="change-settings({headerLabel: \'Order Settings\',labelName: \'{{\'gatewayApp.customerSpecificSettings.tradeEmailToBeSent\' | translate}}\' ,settingsName: \'IsTradeEmailToBeSent\' , settingsValue: vm.customerSpecificSettings.IsTradeEmailToBeSent, settingsType : \'yesorno\', screenName : \'customerdealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px;margin-top:6px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div></div></div></div></div><script>//$("#btntab1").focus();\r\n\t\topenTab(event, \'OrderSettings\');\r\n\r\n\t\tfunction openTab(evt, tabName) {\r\n\t\t\tvar i, tabcontent, tablinks;\r\n\t\t\ttabcontent = document.getElementsByClassName("tabcontent");\r\n\t\t\tfor (i = 0; i < tabcontent.length; i++) {\r\n\t\t\t\ttabcontent[i].style.display = "none";\r\n\t\t\t}\r\n\t\t\ttablinks = document.getElementsByClassName("tablinks");\r\n\t\t\tfor (i = 0; i < tablinks.length; i++) {\r\n\t\t\t\ttablinks[i].className = tablinks[i].className.replace(\r\n\t\t\t\t\t\t" active", "");\r\n\t\t\t}\r\n\t\t\tdocument.getElementById(tabName).style.display = "block";\r\n\t\t\t//evt.currentTarget.className += " active";\r\n\t\t}</script></form>');
$templateCache.put('app/entities/customer-view-report/customer-view-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.customer.manageCustomerViewReport"></span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner" style="padding-bottom:10px"><br><div class="row"><fieldset class="row"><form name="customerForm" role="form" novalidate><div class="row"><div ng-show="vm.userType==\'CLEARCORP\'"><label class="col-md-1 control-label" style="text-align:right;padding-top:5px;width: auto" cspl-mandatory><span data-translate="gatewayApp.CustomerViewReport.Bank"></span></label><div class="col-md-2"><cspl-ach control-model="vm.bank" control-id="txtBank" lookup-name="bank" display-column="bankName" form="customerForm" control-required="vm.userType==\'CLEARCORP\'"></cspl-ach></div></div><div ng-show="vm.userType==\'BANK\' && vm.userEntityOwnerType!=\'Branch\'"><label class="col-md-1 control-label" style="text-align:right;padding-top:5px;width: auto"><span data-translate="gatewayApp.CustomerViewReport.branch"></span></label><div class="col-md-3"><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="activeBranchesForBank" display-column="shortName" form="customerForm"></cspl-ach></div></div><div ng-show="vm.userType==\'CLEARCORP\'"><label class="col-md-1 control-label" style="text-align:right;padding-top:5px;width: auto"><span data-translate="gatewayApp.CustomerViewReport.branch"></span></label><div class="col-md-2"><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="activeBranch" display-column="shortName" filter-value="{{vm.bank.id}}" form="customerForm"></cspl-ach></div></div><div class="col-md-2 btn-group"><div class="col-md-12"><label class="btn btn-primary tab-padding active" ng-model="vm.dateFilter" uib-btn-radio="\'Today\'">TODAY</label><label class="btn btn-primary tab-padding" ng-model="vm.dateFilter" uib-btn-radio="\'Yesterday\'">YESTERDAY</label></div></div><div class="col-md-3"><!-- <div class="col-md-2" style="padding-left: 1%;">   --> <button class="btn btn-info active" ng-disabled="customerForm.$invalid ||vm.clicked" ng-click="vm.getCustomerDetails();vm.clicked=true;" data-translate="gatewayApp.CustomerViewReport.go" style="margin-right: 2%"></button><!-- </div>\r\n\t\t\t\t\t\t\t\t\t\t\t<div> \r\n\t\t\t\t\t\t\t\t\t\t\t<span class="button-separator" ng-show="vm.userType==\'CLEARCORP\'">|</span>\r\n\t\t\t\t\t\t\t\t\t\t\t </div>\r\n\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-md-3" style="padding-left: 2%;"> \r\n\t\t\t\t\t\t\t\t\t\t\t<button class=" btn btn-info active" ng-show="vm.userType==\'CLEARCORP\'"\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.exportAllCustomerDetails();" style="margin-left: 2%;">\r\n\t\t\t\t\t\t\t\t\t\t\t\tExport All\r\n\t\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t\t\t</div> --></div></div></form></fieldset></div><div class="row"><div ng-show="vm.customerDetails.length > 0"><div class="row"><div class="pull-right"><div class="col-md-6 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><!-- <div class="pull-left">\r\n\t\t\t\t\t\t\t<cspl-table-export table-name="customerDetails" total-record-count="filterData.length" no-of-records-per-page="noOfRecordsPerPage"  \r\n\t\t\t\t\t\t\tpage-no="page" file-name="Customer_View_Report"></cspl-table-export>\r\n\t\t\t\t\t\t\t\t\t</div>\t --><div class="pull-left"><div class="dropdown col-md-3" style="width:10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border:none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user" ng-if="vm.exportButtonEnabled"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div></div><!-- <div class="pull-left">\r\n\t\t\t\t\t\t\t\t\t<div class="dropdown col-md-3" style="width:10%;"  >\r\n\t\t\t\t\t\t\t\t\t\t<div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button">\r\n\t\t\t\t\t\t\t\t\t\t\t<button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border:none;"><img src="assets/images/Export_01.png" /></button>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user">\r\n\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t<li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li>\r\n\t\t\t\t\t\t\t\t\t\t\t<li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li>\r\n\t\t\t\t \t \r\n\t\t\t\t\t\t\t\t\t\t</ul>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\t --></div><div class="table-responsive" style="overflow-x:auto;overflow-y:hidden"><table id="customerDetails" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.CustomerViewReport.CustomerReferenceNo"></th><th data-translate="gatewayApp.CustomerViewReport.ApplicableForOTR"></th><th data-translate="gatewayApp.CustomerViewReport.Bank"></th><th data-translate="gatewayApp.CustomerViewReport.customerName"></th><th data-translate="gatewayApp.CustomerViewReport.customerID"></th><th data-translate="gatewayApp.CustomerViewReport.customerType"></th><th data-translate="gatewayApp.CustomerViewReport.homeBranchIfsc"></th><th data-translate="gatewayApp.CustomerViewReport.homeBranchAddress"></th><th data-translate="gatewayApp.CustomerViewReport.tradingBranchName"></th><th data-translate="gatewayApp.CustomerViewReport.tradingBranchIfsc"></th><th ng-if="vm.userEntityOwnerType!=\'Clearcorp\'" data-translate="gatewayApp.CustomerViewReport.accountNumber"></th><th ng-if="vm.userEntityOwnerType!=\'Clearcorp\'" data-translate="gatewayApp.CustomerViewReport.pan"></th><th data-translate="gatewayApp.CustomerViewReport.LEI"></th><!-- <th data-translate="gatewayApp.CustomerViewReport.CIN"></th> --><th data-translate="gatewayApp.CustomerViewReport.gstin"></th><th data-translate="gatewayApp.CustomerViewReport.stateCode"></th><!-- <th style="min-width:70px" data-translate="gatewayApp.CustomerViewReport.dobOrDoi"></th>--><th data-translate="gatewayApp.CustomerViewReport.dateOfJoining"></th><th data-translate="gatewayApp.CustomerViewReport.registrationSubmissionDate"></th><!-- <th data-translate="gatewayApp.CustomerViewReport.primaryContactName"></th>\r\n\t\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerViewReport.mobileNo"></th>\r\n\t\t\t\t\t\t\t\t\t\t\t <th data-translate="gatewayApp.CustomerViewReport.emailId"></th> --><th data-translate="gatewayApp.CustomerViewReport.registeredAddress"></th><th data-translate="gatewayApp.CustomerViewReport.customerCity"></th><th data-translate="gatewayApp.CustomerViewReport.customerState"></th><th data-translate="gatewayApp.CustomerViewReport.customerCountry"></th><th data-translate="gatewayApp.CustomerViewReport.customerPincode"></th><!-- <th data-translate="gatewayApp.CustomerViewReport.alternateContactName1"></th>\r\n\t\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerViewReport.alternateContactEmail1"></th>\r\n\t\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerViewReport.alternateContactMobile1"></th>\r\n\t\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerViewReport.alternateContactName2"></th>\r\n\t\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerViewReport.alternateContactEmail2"></th>\r\n\t\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerViewReport.alternateContactMobile2"></th>--><th data-translate="gatewayApp.CustomerViewReport.authorisedPersonFirstName"></th><th data-translate="gatewayApp.CustomerViewReport.authorisedPersonMiddleName"></th><th data-translate="gatewayApp.CustomerViewReport.authorisedPersonLastName"></th><!--<th data-translate="gatewayApp.CustomerViewReport.gender"></th> --><!-- <th data-translate="gatewayApp.CustomerViewReport.userAddress"></th>\r\n\t\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerViewReport.userCity"></th>\r\n\t\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerViewReport.userState"></th>\r\n\t\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerViewReport.userCountry"></th>\r\n\t\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerViewReport.userPincode"></th>\r\n\t\t\t\t\t\t\t\t\t\t\t<th data-translate="gatewayApp.CustomerViewReport.login"></th> --><th data-translate="gatewayApp.CustomerViewReport.authorisedPersonEmail"></th><th data-translate="gatewayApp.CustomerViewReport.authorisedPersonMobile"></th><th ng-if="vm.userEntityOwnerType==\'Clearcorp\'" style="min-width:70px" data-translate="gatewayApp.CustomerViewReport.dob"></th><th data-translate="gatewayApp.CustomerViewReport.isMarkupAvailable"></th><th data-translate="gatewayApp.CustomerViewReport.isLimitsAvailable"></th><th data-translate="gatewayApp.CustomerViewReport.status"></th><th ng-if="vm.userEntityOwnerType!=\'Branch\'" data-translate="gatewayApp.CustomerViewReport.migratedToNewBranch"></th><th data-translate="gatewayApp.CustomerViewReport.clearcorpTACAgreedDate"></th><!-- <th data-translate="gatewayApp.CustomerViewReport.bankTACAgreedDate"></th> --><th ng-if="vm.userEntityOwnerType==\'Clearcorp\'" style="min-width:70px" data-translate="gatewayApp.CustomerViewReport.sourceOfIntro"></th><th data-translate="gatewayApp.CustomerViewReport.source"></th><th></th></tr></thead><tbody><tr ng-repeat="customerDetail in filterData = (vm.customerDetails | filter : filterText | orderBy  : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{customerDetail.customerTradingBankDetails.requestReferenceNumber || \'-\'}}</td><td style="text-align:center;min-width:135px"><span ng-if="customerDetail.applicableToOTR==true" class="otr-status-yes">Yes</span> <span ng-if="customerDetail.applicableToOTR==false" class="otr-status-no">No</span></td><td style="min-width: 150px">{{customerDetail.customerTradingBankDetails.bank.shortName}}</td><td style="word-break:break-word" ng-show="customerDetail.customer.customerMiddleName!=null">{{customerDetail.customer.customerFirstName+\' \'+customerDetail.customer.customerMiddleName+\' \'+customerDetail.customer.customerLastName}}</td><td style="word-break:break-word" ng-show="customerDetail.customer.customerMiddleName==null">{{customerDetail.customer.customerFirstName+\' \'+customerDetail.customer.customerLastName}}</td><td>{{customerDetail.customer.customerCode}}</td><td>{{customerDetail.customer.customerType.name}}</td><td>{{customerDetail.customerTradingBankDetails.homeBranch.ifscCode || \'-\'}}</td><td>{{customerDetail.customerTradingBankDetails.homeBranch.address || \'-\'}}</td><td>{{customerDetail.customerTradingBankDetails.tradingBranch.branchName}}</td><td>{{customerDetail.customerTradingBankDetails.tradingBranch.ifscCode}}</td><td ng-if="vm.userEntityOwnerType!=\'Clearcorp\'"><span ng-if="!customerDetail.customer.isProp">{{customerDetail.customerTradingBankDetails.bankAccountNumber}}</span> <span ng-if="customerDetail.customer.isProp">-</span></td><td ng-if="vm.userEntityOwnerType!=\'Clearcorp\'">{{customerDetail.customer.panNumber || \'-\'}}</td><td>{{customerDetail.customer.legalEntityIdentifier || \'-\'}}</td><!-- <td >{{customerDetail.customer.corporateIdentificationNumber || \'-\'}}</td> --><td>{{customerDetail.customer.gstin || \'-\'}}</td><td>{{customerDetail.customer.stateCode || \'-\'}}</td><!-- <td>{{customerDetail.customer.dobOrDoi|date:"dd-MMM-yyyy"}}</td>--><td>{{customerDetail.dateOfJoining|date:"dd-MMM-yyyy"}}</td><td><span ng-if="customerDetail.customer.isProp">-</span> <span ng-if="!customerDetail.customer.isProp">{{customerDetail.registrationSubmissionDateTime | date:"dd-MMM-yyyy hh:mm:ss a"}}</span></td><!-- <td>{{customerDetail.customer.primaryContactName}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td>{{customerDetail.customer.primaryMobileCountryCode+\'-\'+customerDetail.customer.primaryMobile}}</td>\r\n\t\t\t\t\t\t\t\t\t\t    <td>{{customerDetail.customer.primaryEmail}}</td> --><td>{{vm.getAddress(customerDetail.customer.address1,customerDetail.customer.address2)}}</td><td>{{customerDetail.customer.city || \'-\'}}</td><td>{{customerDetail.customer.state.shortName || \'-\'}}</td><td>{{customerDetail.customer.country.shortName || \'-\'}}</td><td>{{customerDetail.customer.pincode || \'-\'}}</td><!-- <td>{{customerDetail.customer.alternateContactName1 || \'-\'}}</td> \r\n\t\t\t\t\t\t\t\t\t\t\t<td>{{customerDetail.customer.alternateEmail1 || \'-\'}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td>{{vm.getMobile(customerDetail.customer.alternateMobile1, customerDetail.customer.alternateMobileCountryCode1)}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td>{{customerDetail.customer.alternateContactName2 || \'-\'}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td>{{customerDetail.customer.alternateEmail2 || \'-\'}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td>{{vm.getMobile(customerDetail.customer.alternateMobile2, customerDetail.customer.alternateMobileCountryCode2)}}</td>--><td style="word-break:break-word">{{customerDetail.userDTO.firstName || \'-\'}}</td><td style="word-break:break-word">{{customerDetail.userDTO.middleName || \'-\'}}</td><td style="word-break:break-word">{{customerDetail.userDTO.lastName || \'-\'}}</td><!--<td>{{customerDetail.userDTO.gender || \'-\'}}</td>--><!--<td style="word-break:break-word">{{vm.getAddress(customerDetail.userDTO.address1,customerDetail.userDTO.address2)}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td>{{customerDetail.userDTO.city || \'-\'}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td>{{customerDetail.userDTO.state.shortName || \'-\'}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td>{{customerDetail.userDTO.country.shortName || \'-\'}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td>{{customerDetail.userDTO.pincode || \'-\'}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td>{{customerDetail.userDTO.login || \'-\'}}</td>--><td>{{customerDetail.userDTO.email || \'-\'}}</td><td>{{customerDetail.userDTO.mobileCountryCode+\'-\'+customerDetail.userDTO.mobile}}</td><td ng-if="vm.userEntityOwnerType==\'Clearcorp\'"><span ng-if="customerDetail.customer.isProp">-</span><span ng-if="!customerDetail.customer.isProp">{{customerDetail.userDTO.dob | date:"dd-MMM-yyyy"}}</span></td><td><span ng-if="customerDetail.customer.isProp">-</span> <span ng-if="!customerDetail.customer.isProp"><span ng-if="customerDetail.isMarkupAvailable==true" class="otr-status-yes">Yes</span><span ng-if="customerDetail.isMarkupAvailable==false" class="otr-status-no">No</span></span></td><td><span ng-if="customerDetail.customer.isProp">-</span> <span ng-if="!customerDetail.customer.isProp"><span ng-if="customerDetail.isLimitsAvailable==true" class="otr-status-yes">Yes</span><span ng-if="customerDetail.isLimitsAvailable==false" class="otr-status-no">No</span></span></td><td>{{customerDetail.customerTradingBankDetails.entityRestrictionStatus.displayName}}</td><td ng-if="vm.userEntityOwnerType!=\'Branch\'" style="text-align:center;min-width:135px"><span ng-if="!customerDetail.customer.isProp && customerDetail.customerTradingBankDetails.isMigratedToNewBranch==true" class="otr-status-yes">Yes</span> <span ng-if="customerDetail.customer.isProp">-</span> <span ng-if="!customerDetail.customer.isProp && customerDetail.customerTradingBankDetails.isMigratedToNewBranch==false" class="otr-status-no">No</span></td><td><span ng-if="customerDetail.clearcorpTACAgreedDateTime == null || customerDetail.clearcorpTACAgreedDateTime == \'\'">-</span> <span ng-if="customerDetail.clearcorpTACAgreedDateTime != null && customerDetail.clearcorpTACAgreedDateTime != \'\'">{{customerDetail.clearcorpTACAgreedDateTime | date:"dd-MMM-yyyy hh:mm:ss a"}}</span></td><!-- <td><span ng-if="customerDetail.bankTACAgreedDateTime == null || customerDetail.bankTACAgreedDateTime == \'\'">-</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="customerDetail.bankTACAgreedDateTime != null && customerDetail.bankTACAgreedDateTime != \'\'">{{customerDetail.bankTACAgreedDateTime | date:"dd-MMM-yyyy hh:mm:ss a"}}</span></td> --><td ng-if="vm.userEntityOwnerType==\'Clearcorp\'">{{customerDetail.sourceOfIntro.displayName||\'-\'}}</td><td>{{customerDetail.sourceAppName|| \'-\'}}</td><td class="sticky-col" style="text-align:center; right: 15px"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ui-sref="customer-view-report-view({id: customerDetail.customerTradingBankDetails.id,theme:\'dark\'})" ng-click="vm.screenLog.screenLog(vm.screenName,customerDetail.customer.id,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitTradingBranchModification && !customerDetail.customer.isProp && customerDetail.customer.entityRestrictionStatus.shortName!=\'Terminated\'"><a ng-click="vm.editTradingBankDetails(customerDetail.customerTradingBankDetails,$event)"><span class="" data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table></div><div ng-show="vm.customerDetails.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="table-responsive" ng-show="vm.customerDetails.length==0"><span>No record found</span></div></div></div></section></div></div>');
$templateCache.put('app/entities/default-market-session-settings/default-market-session-settings-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="defaultMarketEdit" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span ng-show="vm.viewMode==false" data-translate="global.menu.defaultMarketSessionSettings.editDefaultMarketSessionSettings"></span> <span ng-show="vm.viewMode==true" data-translate="global.menu.defaultMarketSessionSettings.viewDefaultMarketSessionSettings"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="content" style="overflow:unset"><fieldset style="height:300px"><br><div class="col-md-6 col-centered"><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered" cspl-mandatory><span data-translate="gatewayApp.defaultMarket.instrument"></span></label><div id="btnGroup" class="col-xs-12 col-md-8 col-space" style="padding-bottom:8px"><div class="btn-group" style="height:30px;border:none"><label class="btn btn-primary" style="font-size:12px" ng-show="vm.defaultMarket.instrumentName==\'CASH\' " ng-model="vm.defaultMarket.instrumentName" uib-btn-radio="\'CASH\'" ng-disabled="true">CASH</label><label class="btn btn-primary" style="font-size:12px" ng-show="vm.defaultMarket.instrumentName==\'TOM\' " ng-model="vm.defaultMarket.instrumentName" uib-btn-radio="\'TOM\'" ng-disabled="true">TOM</label></div></div></div><div class="form-group"><label class="col-md-12 col-xs-12 col-centered control-label" style="padding-top:5px" cspl-mandatory><span data-translate="gatewayApp.defaultMarket.sessionOpen"></span></label><div class="col-md-7 col-xs-9 col-space"><cspl-time-picker control-model="vm.inputOpenTime" control-id="dtpSessionOpen" control24hrformat="false" form="defaultMarketEdit" control-disabled="vm.viewMode" required></div></div><div class="form-group"><label class="col-md-12 col-xs-12 col-centered control-label" style="padding-top:5px" cspl-mandatory><span data-translate="gatewayApp.defaultMarket.sessionClose"></span></label><div class="col-md-7 col-xs-9 col-space"><cspl-time-picker control-model="vm.inputCloseTime" control-id="dtpSessionClose" control24hrformat="false" form="defaultMarketEdit" control-disabled="vm.viewMode" required></div></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="defaultMarketEdit.$invalid || vm.clicked" ng-click="vm.resubmitDefaultMarket();vm.clicked = true;"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="defaultMarketEdit.$invalid  || vm.clicked" class="btn btn-info active" ng-click="vm.save();vm.clicked = true;"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardDefaultMarket()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-show="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectDefaultMarket()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" autofocus class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveDefaultMarket();vm.clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/default-market-session-settings/default-market-session-settings.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.defaultMarketSessionSettings.manageDefaultMarketSessionSettings">Manage Default Market Session Settings</h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="float-right col-xs-10 col-sm-3 col-md-2"><cspl-table-search control-model="filterText"></cspl-table-search></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="tblDefaultMarketSessionSettings" total-record-count="vm.defaultMarket.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Default_Market_Session_Settings"></cspl-table-export></div></div><div class="bootstrap-tableresponsive"><table id="tblDefaultMarketSessionSettings" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.defaultMarket.currenyPair">Currency Pair</th><th data-translate="gatewayApp.defaultMarket.instrument">Instrument</th><th data-translate="gatewayApp.defaultMarket.sessionOpen">Session Open</th><th data-translate="gatewayApp.defaultMarket.sessionClose">Session Close</th><th data-translate="gatewayApp.defaultMarket.settlementDate">Settlement Date</th><th></th></tr></thead><tbody><tr ng-repeat="default in filterData = (vm.defaultMarket | filter : filterText | orderBy : \'id\')| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><!-- Column values --><td>{{default.currencyPair.code}}</td><td>{{default.instrumentName}}</td><td>{{default.inputOpenTime|uppercase}}</td><td>{{default.inputCloseTime|uppercase}}</td><td ng-show="!default.isSettlementDateHoliday">{{default.settlementDate| date:\'dd-MMM-yy\'}}</td><td ng-show="default.isSettlementDateHoliday">-</td><td style="text-align:center"><div class="btn-group utility" ng-show="vm.permitDefaultMarketEditAction && default.isConfigurableInFxRetail==true" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ui-sref="default-market-edit({id:default.id})"><span data-translate="entity.action.edit">Edit</span></a></li></ul></div></td></tr></tbody></table><div ng-show="vm.defaultMarket.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="table-responsive" ng-show="vm.defaultMarket.length ==0"><span>No record found</span></div></div></section></div></div><script src="assets/js/tables.js"></script>');
$templateCache.put('app/entities/e-invoice-upload/e-invoice-upload.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="gatewayApp.eInvoiceUpload.home.title"></span></h2><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><form class="form" name="uploadForm" role="form"><div class="form-group col-md-offset-3 col-md-8 col-sm-6 col-xs-12 col-lg-6" style="margin-top:2%"><div class="row"><div class="col-md-10"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.eInvoiceUpload.chargesType"></span></label></div><div class="form-group col-sm-6 col-md-8 col-lg-6 col-xs-6" style="margin-bottom:15px"><select class="form-control select-style" name="chargesType" ng-model="vm.chargesType" id="chargesType" ng-options="chargesType.description for chargesType in vm.chargeTypes track by chargesType.shortName" form="uploadForm" required></select></div></div><div class="row" ng-show="vm.chargesType.shortName!=\'AMC\'"><div class="col-md-10"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.eInvoiceUpload.financialMonth"></span></label></div><div class="form-group col-sm-6 col-md-8 col-lg-6 col-xs-6" style="margin-bottom: 15px"><select class="form-control select-style" name="financialMonth" ng-model="vm.financialMonth" ng-options="financialMonth.monthDisplay for financialMonth in vm.previousFiancialMonthOptions track by financialMonth.date" form="uploadForm" required></select></div></div><div class="row" ng-show="vm.chargesType.shortName==\'AMC\'"><div class="col-md-10"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.eInvoiceUpload.financialYear"></span></label></div><div class="form-group col-sm-6 col-md-8 col-lg-6 col-xs-6" style="margin-bottom: 15px"><select class="form-control select-style" name="financialYear" ng-model="vm.financialYear" ng-options="financialYear.displayYear for financialYear in vm.allFinancialYears track by financialYear.displayYear" form="uploadForm" required></select></div></div><div class="row"><div class="col-md-10"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.eInvoiceUpload.jsonZipFile"></span></label></div><div class="col-sm-10 col-md-10 col-lg-6 col-xs-12" style="margin-bottom: 5px"><div class="input-group"><input type="text" class="form-control fileOpen" ng-class="{ \'red\': vm.checkZipFile && (vm.inputJsonZipFileName==null || vm.inputJsonZipFileName==undefined)}" ng-model="vm.inputJsonZipFileName" ng-blur="vm.checkZipFile=true;" readonly="readonly" required><label style="width:46px" ng-class="{ \'notentered\': vm.checkZipFile && (vm.inputJsonZipFileName==null || vm.inputJsonZipFileName==undefined)}" for="jsonFile" class="btn btn-primary fileUploadDark"><img src="assets/images/Open Path-26.png" style="pointer-events: none"></label><input type="file" id="jsonFile" name="jsonZipUpload" fileread="vm.jsonZipFile" accept="application/zip,application/x-zip-compressed" form="uploadForm" ng-hide="true"> <span class="help-block-error" style="margin-bottom: 5px;width:246px; margin-top: -15px" ng-show="vm.invalidJsonZipSize"><!-- Uploaded content should not be smaller than 3 mb. --> {{vm.invalidJsonZipSizeText}} </span><span class="help-block-error" style="margin-bottom: 5px;width:246px; margin-top: -15px" ng-show="vm.invalidJsonZip">{{vm.invalidJsonZipText}}</span> <span class="help-block-error" style="margin-bottom: 5px;width:246px; margin-top: -6px" ng-show="vm.checkZipFile && ( vm.inputJsonZipFileName==null || vm.inputJsonZipFileName==undefined)">Zip file should be uploaded.</span><div class="col-md-10 justified-help-block" style="padding-left:0px"><span data-translate="gatewayApp.eInvoiceUpload.zipfileFormatText"></span></div><div class="col-md-12 justified-help-block" style="padding-top:5px;padding-left:0px"><!-- <span ng-show="vm.showInKB" data-translate="gatewayApp.clearCorpTACUpload.maxFileSize"\r\n\t\t\t\t\t\t\t\t\t\t\tdata-translate-values="{value: {{vm.tacFileUploadSize}}}"></span> --> <span data-translate="gatewayApp.eInvoiceUpload.zifileSizeText"></span></div></div></div></div><div class="row"><div class="col-md-10"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.eInvoiceUpload.mappingFile"></span></label></div><div class="col-sm-10 col-md-10 col-lg-6 col-xs-12" style="margin-bottom: 5px"><div class="input-group"><input type="text" class="form-control fileOpen" ng-class="{ \'red\': vm.checkMappingFile && (vm.inputMappingFileName==null || vm.inputMappingFileName==undefined)}" ng-model="vm.inputMappingFileName" ng-blur="vm.checkMappingFile=true;" readonly="readonly" required><label style="width:46px" ng-class="{ \'notentered\': vm.checkMappingFile && (vm.inputMappingFileName==null || vm.inputMappingFileName==undefined)}" for="mappingFile" class="btn btn-primary fileUploadDark"><img src="assets/images/Open Path-26.png" style="pointer-events: none"></label><input type="file" id="mappingFile" name="termsConditionUpload" fileread="vm.mappingFile" accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" form="uploadForm" ng-hide="true"> <span class="help-block-error" style="margin-bottom: 5px;width:246px; margin-top: -15px" ng-show="vm.invalidMappingFileSize"><!-- Uploaded content should not be smaller than 3 mb. --> {{vm.invalidMappingFileSizeText}} </span><span class="help-block-error" style="margin-bottom: 5px;width:246px; margin-top: -15px" ng-show="vm.invalidMappingFile">{{vm.invalidMappingFileText}}</span> <span class="help-block-error" style="margin-bottom: 5px;width:246px; margin-top: -6px" ng-show="vm.checkMappingFile && ( vm.inputMappingFileName==null || vm.inputMappingFileName==undefined)">XLS file should be uploaded.</span><div class="col-md-10 justified-help-block" style="padding-left:0px"><span data-translate="gatewayApp.eInvoiceUpload.xlfileFormatText"></span></div><div class="col-md-12 justified-help-block" style="padding-top:5px;padding-left:0px"><!-- <span ng-show="vm.showInKB" data-translate="gatewayApp.clearCorpTACUpload.maxFileSize"\r\n\t\t\t\t\t\t\t\t\t\t\tdata-translate-values="{value: {{vm.tacFileUploadSize}}}"></span> --> <span data-translate="gatewayApp.eInvoiceUpload.xlfileSizeText"></span></div></div></div></div><div class="col-md-offset-3 col-md-2 col-sm-2 col-xs-1"><button type="submit" class="btn btn-primary" form="uploadForm" ng-disabled="uploadForm.$invalid || vm.mappingFile==null || vm.jsonZipFile==null ||vm.clicked" ng-click="vm.clicked = true;vm.uploadFiles();" data-translate="gatewayApp.eInvoiceUpload.upload"></button></div></div></form></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/default-markup-settings/default-markup-settings-edit-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="defaultMarkupEditForm" role="form" novalidate><div class="modal-header"><span class="icon" style="float: right;margin-top :7px;margin-right:30px" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Default Mark-up" tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="global.menu.defaultMarkupSettings.defaultMarkup"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset><br><div class="col-xs-6 col-centered"><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.markup.bank"></span></label><cspl-text control-model="vm.defaultMarkup.bank.bankName" control-disabled="true" control-id="txtMarkupBank" form="defaultMarkupEditForm" required></div><div class="form-group"><label class="control-label col-xs-12 col-centered" cspl-mandatory><span data-translate="gatewayApp.markup.markupType"></span></label><div class="col-xs-10 multi-col"><select class="form-control select-style" name="markupType" ng-model="vm.markupType" ng-options="markupType.shortName for markupType in vm.markupTypes track by markupType.shortName" form="defaultMarkupEditForm" required></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-centered"><span data-translate="gatewayApp.markup.markupValue"></span> <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Mark-up Value" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label><div class="col-xs-10 multi-col" ng-show="vm.markupType.shortName!=\'Percentage\'"><cspl-numeric control-model="vm.defaultMarkup.markupValue" control-id="txtMarkupValue1" no-of-decimals="{{vm.noOfDecimals}}" form="defaultMarkupEditForm" control-min="0" control-max="999"></cspl-numeric></div><div class="col-xs-10 multi-col" ng-show="vm.markupType.shortName==\'Percentage\'"><cspl-numeric control-model="vm.defaultMarkup.markupValue" control-id="txtMarkupValue2" no-of-decimals="{{vm.noOfDecimals}}" form="defaultMarkupEditForm" control-min="0" control-max="100"></cspl-numeric></div><div class="col-xs-1" style="line-height:30px"><span ng-show="vm.markupType.shortName==\'Percentage\' ">%</span></div></div></div><br><div class="help-block-text"><span class="help-block" data-translate="gatewayApp.markup.blank"></span> <span style="padding-top:5px" class="help-block" data-translate="gatewayApp.markup.zero"></span></div><div class="col-xs-6 col-centered"><div class="form-group"><label class="control-label col-xs-12 col-centered" style="padding-top:5px"><span data-translate="gatewayApp.markup.taxOnMarkup"></span></label><div class="col-xs-10 multi-col"><cspl-numeric control-model="vm.defaultMarkup.taxOnMarkup" control-id="txtTaxOnMarkup" no-of-decimals="3" control-disabled="vm.disableTax" form="defaultMarkupEditForm" control-min="0" control-max="100"></cspl-numeric></div><div class="col-xs-1" style="line-height:30px"><span>%</span></div></div></div><div class="col-xs-6 col-centered"><div class="form-group"><label class="control-label col-xs-12 col-centered"><span data-translate="gatewayApp.markup.roEdApplicability"></span>&nbsp;* <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Mark-up applicability for rollover (RO) & early delivery (ED). If selected Both legs means Mark-up will be charged on both legs and Rebooking leg only means Mark-up will be charged only on Rebooking leg." tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label><div class="col-xs-10 multi-col"><select class="form-control select-style" name="roEdApplicability" ng-model="vm.roEdApplicabilityMethod" ng-options="roEdApplicability.name for roEdApplicability in vm.roEdApplicabilityMethodList track by roEdApplicability.shortName" form="defaultMarkupEditForm" required></select></div></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showButton" class="btn btn-primary" ng-disabled="defaultMarkupEditForm.$invalid || vm.clicked" ng-click="vm.resubmitDefaultMarkup();vm.clicked = true;"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="!showButton" ng-disabled="defaultMarkupEditForm.$invalid  || vm.clicked" class="btn btn-info active" ng-click="vm.save();vm.clicked = true;"><span data-translate="entity.action.save">Save</span></button></div><div class="row"><span class="orderStatusInfo right-floating padding-top-0 italic-font" data-translate="gatewayApp.markup.roEdHelpText"></span></div></div></form>');
$templateCache.put('app/entities/default-markup-settings/default-markup-settings-view-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="defaultMarkupViewForm" role="form" novalidate><div class="modal-header"><!-- <button ng-show="userPreference.showInfoIcon==\'yes\'" type="button" class="close" style="margin-right: 25px;" data-toggle="popover" data-trigger="focus"  data-placement="left" data-content="Default Mark-up">\r\n\t\t\t<span class="icon" ><img class="width-height-20" src="assets/images/Info-24.png" /></span>\r\n\t\t</button> --> <span class="icon" style="float: right;margin-top :7px;margin-right:30px" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Default Mark-up" tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="global.menu.defaultMarkupSettings.defaultMarkup"></span></h4></div><div class="modal-body"><div class="content"><fieldset><br><div class="col-xs-6 col-centered"><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.markup.bank"></span></label><cspl-text control-model="vm.defaultMarkup.bank.bankName" control-disabled="true" control-id="txtMarkupBank" form="defaultMarkupViewForm" required></div><div class="form-group"><label class="control-label col-xs-12 col-centered" cspl-mandatory><span data-translate="gatewayApp.markup.markupType"></span></label><div class="col-xs-10 multi-col"><select class="form-control select-style" style="border-color:#BB8557" name="markupType" ng-model="vm.markupType" ng-options="markupType.shortName for markupType in vm.markupTypes track by markupType.shortName" ng-disabled="true" form="defaultMarkupViewForm" required></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-centered"><span data-translate="gatewayApp.markup.markupValue"></span> <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Mark-up Value" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label><div class="col-xs-10 multi-col"><cspl-numeric control-model="vm.defaultMarkup.markupValue" control-id="txtMarkupValue" no-of-decimals="{{vm.noOfDecimals}}" form="defaultMarkupViewForm" control-min="0" control-max="100" control-disabled="true"></cspl-numeric></div><div class="col-xs-1" style="line-height:30px"><span ng-show="vm.markupType.shortName==\'Percentage\' ">%</span></div></div></div><br><div class="help-block-text"><span class="help-block" data-translate="gatewayApp.markup.blank"></span> <span style="padding-top:5px" class="help-block" data-translate="gatewayApp.markup.zero"></span></div><div class="col-xs-6 col-centered"><div class="form-group"><label class="control-label col-xs-12 col-centered" style="padding-top:5px"><span data-translate="gatewayApp.markup.taxOnMarkup"></span></label><div class="col-xs-10 multi-col"><cspl-numeric control-model="vm.defaultMarkup.taxOnMarkup" control-id="txtTaxOnMarkup" no-of-decimals="3" form="defaultMarkupViewForm" control-min="0" control-max="100" control-disabled="true"></cspl-numeric></div><div class="col-xs-1" style="line-height:30px"><span>%</span></div></div></div><div class="col-xs-6 col-centered" ng-hide="vm.roEdApplicabilityMethod==null && vm.hideRoEdApplicability"><div class="form-group"><label class="control-label col-xs-12 col-centered"><span data-translate="gatewayApp.markup.roEdApplicability"></span>&nbsp;* <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Mark-up applicability for rollover (RO) & early delivery (ED). If selected Both legs means Mark-up will be charged on both legs and Rebooking leg only means Mark-up will be charged only on Rebooking leg." tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label><div class="col-xs-10 multi-col"><select class="form-control select-style" name="roEdApplicability" ng-model="vm.roEdApplicabilityMethod" ng-options="roEdApplicability.name for roEdApplicability in vm.roEdApplicabilityMethodList track by roEdApplicability.shortName" ng-disabled="true" form="defaultMarkupViewForm" required></select></div></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>OK</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardDefaultMarkup()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showButton" class="btn btn-reject" ng-click="vm.rejectDefaultMarkup()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" autofocus class="btn btn-approve" ng-disabled="clicked" ng-click="vm.approveDefaultMarkup();clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div><div class="row"><span class="orderStatusInfo right-floating padding-top-0 italic-font" data-translate="gatewayApp.markup.roEdHelpText"></span></div></div></form>');
$templateCache.put('app/entities/default-markup-settings/default-markup-settings.html','<script>$(\'[data-toggle="popover"]\').popover({\r\n    container: \'body\',\r\n\thtml: true\r\n \t})</script><div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.defaultMarkupSettings.main">Default Markup Settings</h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="float-right"><cspl-table-search control-model="filterText"></cspl-table-search></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="defaultMarkupSettings" total-record-count="vm.defaultMarkup.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Default_Markup_Settings"></cspl-table-export></div></div><div class="bootstrap-tableresponsive"><table id="defaultMarkupSettings" class="dataTable table table-striped table-hover"><thead><tr><th ng-show="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.markup.bank">Bank</th><th data-translate="gatewayApp.markup.markupType">Markup Type</th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.markup.markupValue">Markup Value</th><th class="td-text-align-right" data-translate="gatewayApp.markup.taxOnMarkup">Tax on Markup</th><th data-translate="gatewayApp.markup.roEdApplicability"></th><th class="td-text-align-center" style="padding: 8px 10px"><span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Mark-up applicability for rollover (RO) & early delivery (ED). If selected Both legs means Mark-up will be charged on both legs and Rebooking leg only means Mark-up will be charged only on Rebooking leg." tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span><!-- <a ng-show="userPreference.showInfoIcon==\'yes\'" id="roEdApplicabilityPop" tabindex="0" data-toggle="popover" role="button" \r\n\t\t\t\t\t\tdata-trigger="focus" data-placement="left" data-content="Mark-up applicability for rollover (RO) & early delivery (ED). If selected Both legs means Mark-up will be charged on both legs and Rebooking leg only means Mark-up will be charged only on Rebooking leg."\r\n\t\t\t\t\t\tdata-template="<div class=\'mainViewPopover popover\' role=\'tooltip\'><div class=\'arrow\'></div><div class=\'popover-content\'></div></div>">\r\n\t\t\t\t\t\t   <span class="icon"><img class="home-page-help-icon width-height-20" src="assets/images/Info-24.png" /></span>\r\n\t\t\t\t\t\t</a> --></th></tr></thead><tbody><tr ng-repeat="markup in filterData = (vm.defaultMarkup | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td ng-show="vm.entityOwnerType==\'Clearcorp\'">{{markup.bank.bankName}}</td><td>{{markup.markupType}}</td><td ng-show="markup.markupType==\'Paise\'" class="td-text-align-right noPaddingLeftRight">{{(markup.markupValue|number:2)||\'-\'}}</td><td ng-show="markup.markupType==\'Percentage\'" class="td-text-align-right noPaddingLeftRight">{{(markup.markupValue|number:3)||\'-\'}}</td><td class="td-text-align-right">{{(markup.taxOnMarkup|number:3)||\'-\'}}</td><td>{{markup.roEdApplicabilityMethod.name}}</td><td style="text-align:center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitDefaultMarkupSettingsViewEntityAction"><a ui-sref="default-markup-view({id:markup.id})" ng-click="vm.screenLog.screenLog(vm.screenName, markup.id, vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitDefaultMarkupSettingsEditEntityAction"><a ui-sref="default-markup-edit({id:markup.id})" ng-click="vm.screenLog.screenLog(vm.screenName, markup.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="vm.defaultMarkup.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="row"><span class="orderStatusInfo right-floating italic-font" data-translate="gatewayApp.markup.roEdHelpText"></span></div><div class="row"><span class="orderStatusInfo right-floating italic-font" data-translate="gatewayApp.markup.fcyBankFeeNote"></span></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/email-settings/email-settings-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="emailSettingsEditForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span ng-show="vm.emailSettings.id==null" data-translate="global.menu.emailSettings.addEmailList"></span> <span ng-show="vm.emailSettings.id!=null" data-translate="global.menu.emailSettings.editEmailList"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset><br><div class="col-sm-6 col-centered"><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.emailSettings.entity"></span></label><div id="btnGroup"><div class="btn-group col-sm-9 col-xs-12 col-md-8 col-lg-10 noPaddingMargin" style="width:auto;margin-bottom:10px"><label ng-show="vm.entityOwnerType==\'Clearcorp\'" class="btn btn-primary tab-padding" ng-model="vm.entity" ng-disabled="vm.viewMode || vm.emailSettings.id!=null" uib-btn-radio="\'Clearcorp\'">ClearCorp</label><label ng-show="vm.entityOwnerType==\'Bank\'" class="btn btn-primary tab-padding" ng-model="vm.entity" ng-disabled="vm.viewMode || vm.emailSettings.id!=null" uib-btn-radio="\'BANK\'">Bank</label><label ng-show="vm.entityOwnerType==\'Branch\'" class="btn btn-primary tab-padding" ng-model="vm.entity" ng-disabled="vm.viewMode || vm.emailSettings.id!=null" uib-btn-radio="\'BRANCH\'">Branch</label><label ng-show="vm.entityOwnerType==\'MultiUserCustomer\'" class="btn btn-primary" ng-model="vm.entity" ng-disabled="vm.viewMode || vm.emailSettings.id!=null" uib-btn-radio="\'MultiUserCustomer\'">MultiUserCustomer</label><label ng-show="vm.entityOwnerType==\'SingleUserCustomer\'" class="btn btn-primary" ng-model="vm.entity" ng-disabled="vm.viewMode || vm.emailSettings.id!=null" uib-btn-radio="\'SingleUserCustomer\'">SingleUserCustomer</label></div></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered" cspl-mandatory><span data-translate="gatewayApp.emailSettings.emailCategory"></span></label><select class="dark form-control select-style" name="emailCategory" ng-model="vm.emailSettings.emailCategory" ng-options="emailCategory.longName for emailCategory in vm.emailCategory track by emailCategory.id" form="emailSettingsEditForm" required ng-disabled="vm.viewMode || vm.emailSettings.id!=null"></select></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.emailSettings.notifyWhom"></span></label><cspl-multiline-text control-model="vm.emailSettings.emailIds" control-id="txtNotifyWhom" form="emailSettingsEditForm" control-disabled="vm.viewMode"></div><div class="form-group"><span class="help-block" data-translate="gatewayApp.emailSettings.showText"></span></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-show="showResubmitButton" class="btn btn-primary" ng-disabled="emailSettingsEditForm.$invalid" ng-click="vm.resubmitEmailSettings();vm.clicked = true;"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-show="showButton" ng-disabled="emailSettingsEditForm.$invalid" class="btn btn-info active" ng-click="vm.save();vm.clicked = true;"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardEmailSettings()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectEmailSettings()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" autofocus class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveEmailSettings();vm.clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/email-settings/email-settings.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.emailSettings.main">Email Settings</h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="float-right"><button type="button" class="btn btn-info active" ng-click="vm.screenLog.screenLog(vm.screenName,0,vm.entityConstants.ENTITY_ACTION_TYPE.ADD);vm.launch()" ng-show="vm.permitEmailSettingsAddEntityAction"><img ng-src="assets/images/Add.png"> <span data-translate="global.menu.emailSettings.newEmail"></span></button></div><div class="float-right col-xs-10 col-sm-3 col-md-2"><cspl-table-search control-model="filterText"></cspl-table-search></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="emailSettings" total-record-count="vm.emailSettings.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Email_Settings"></cspl-table-export></div></div><div class="bootstrap-tableresponsive"><table id="emailSettings" class="dataTable table table-striped table-hover" style="table-layout: fixed; width: 100%"><thead><tr><th data-translate="gatewayApp.emailSettings.emailCategory">Email Category</th><th data-translate="gatewayApp.emailSettings.notifyWhom">Notify Whom</th><th></th></tr></thead><tbody><tr ng-repeat="email in filterData = (vm.emailSettings | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{email.emailCategory.longName}}</td><td style="word-wrap: break-word">{{email.emailIds||\'-\'}}</td><td style="text-align:right;padding-right:50px"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitEmailSettingsEditEntityAction"><a ui-sref="email-edit({id:email.id})" ng-click="vm.screenLog.screenLog(vm.screenName, email.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="vm.emailSettings.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/eod-process/start-eod-process.html','<div ncy-breadcrumb class="row" style="margin-left: 10px"></div><nmb-alert></nmb-alert><div class="row" style="padding:5px"></div><div class="row" style="margin-left: 10px"><nmb-aler-error><div class="col-lg-12"><section class="item" style="padding:5px"><div class="panel panel-primary"><div class="panel-heading text-left"><span data-translate="gatewayApp.eodProcess.title"></span> <a href="" style="position: relative;float:right;  color: #fff" ng-class="{\'linkDisabled\' : vm.isRefreshDisabled}"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="!vm.isRefreshDisabled?refresh():\'\';" style="font-size:20px" ng-show="vm.permitEODProcessAddEntityAction"></i></a></div><div class="panel-body"><div class="module-content-inner"><br><div class="row"><label class="col-md-2 control-label left-align-label"><span data-translate="gatewayApp.eodProcess.currentSystemDate"></span></label><div class="col-md-3"><!-- <cspl-dtp control-model="vm.currentBusinessDate" control-id="selectedDate"   control-disabled="true"  />  --><cspl-text control-model="vm.todayDate" control-id="txtCurrentBusinessDate" control-disabled="true"></div><label class="col-md-2 control-label left-align-label"><span data-translate="gatewayApp.eodProcess.nextSystemDate"></span></label><div class="col-md-3"><!-- <cspl-dtp  control-model="vm.nextBusinessDate" control-id="selectedDate"  control-disabled="true"  /> --><cspl-text control-model="vm.nextDate" control-id="txtNextBusinessDate" control-disabled="true"></div><div class="col-md-1"><button class="btn btn-info active" ng-click="vm.validateInteractiveServerDbProcessing()" ng-disabled="vm.showResumeButton" data-translate="gatewayApp.eodProcess.validate"></button></div><div class="col-md-1"><button class="btn btn-info active" ng-click="vm.beginEODProcess(\'Start EOD\')" ng-disabled="vm.eodDone || !vm.isEODvalidated" data-translate="gatewayApp.eodProcess.start" ng-hide="vm.showResumeButton"></button></div><div class="col-md-1"><button class="btn btn-info active" ng-click="vm.beginEODProcess(\'Resume EOD\')" ng-disabled="vm.eodDone || !vm.isEODvalidated" data-translate="gatewayApp.eodProcess.resume" ng-show="vm.showResumeButton"></button></div></div><div class="row bootstrap-tableresponsive" ng-hide="vm.showEodProcess"><table id="eodValidation" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.eodProcess.checklist"></th><th data-translate="gatewayApp.eodProcess.status"></th><th data-translate="gatewayApp.eodProcess.remarks" word-break: break-word; width: 50%;></th></tr></thead><tbody><tr><td data-translate="gatewayApp.eodProcess.checkInteractiveServerDBProcessing"></td><td><span ng-if="vm.validateInteractiveDBProcessing==vm.NOTSTARTED" aria-hidden="true" class="icon"></span> <span ng-if="vm.validateInteractiveDBProcessing==vm.INPROGRESS" aria-hidden="true" class="icon"><img src="assets/images/Progress_bar.GIF"> </span><span ng-if="vm.validateInteractiveDBProcessing==vm.COMPLETED" aria-hidden="true" class="icon"><img src="assets/images/EOD_Process_Success.png"> </span><span ng-if="vm.validateInteractiveDBProcessing==vm.FAILED" aria-hidden="true" class="icon"><img src="assets/images/EOD_Process_Error.png"></span></td><td>{{vm.remarksForInteractiveServerDBProcessing}}</td></tr><tr><td data-translate="gatewayApp.eodProcess.checkBroadcastServerDBProcessing"></td><td><span ng-if="vm.validateBroadcastDBProcessing==vm.NOTSTARTED" aria-hidden="true" class="icon"></span> <span ng-if="vm.validateBroadcastDBProcessing==vm.INPROGRESS" aria-hidden="true" class="icon"><img src="assets/images/Progress_bar.GIF"> </span><span ng-if="vm.validateBroadcastDBProcessing==vm.COMPLETED" aria-hidden="true" class="icon"><img src="assets/images/EOD_Process_Success.png"> </span><span ng-if="vm.validateBroadcastDBProcessing==vm.FAILED" aria-hidden="true" class="icon"><img src="assets/images/EOD_Process_Error.png"></span></td><td>{{vm.remarksForBroadcastServerDBProcessing}}</td></tr><tr><td data-translate="gatewayApp.eodProcess.validateResponseReceived"></td><td><span ng-if="vm.responseReceivedValidation==vm.NOTSTARTED" aria-hidden="true" class="icon"></span> <span ng-if="vm.responseReceivedValidation==vm.INPROGRESS" aria-hidden="true" class="icon"><img src="assets/images/Progress_bar.GIF"> </span><span ng-if="vm.responseReceivedValidation==vm.COMPLETED" aria-hidden="true" class="icon"><img src="assets/images/EOD_Process_Success.png"> </span><span ng-if="vm.responseReceivedValidation==vm.FAILED" aria-hidden="true" class="icon"><img src="assets/images/EOD_Process_Error.png"></span></td><td>{{vm.responseReceivedMessage}}</td></tr><tr><td data-translate="gatewayApp.eodProcess.checkListTask"></td><td><span ng-if="vm.validation==vm.NOTSTARTED" aria-hidden="true" class="icon"></span> <span ng-if="vm.validation==vm.INPROGRESS" aria-hidden="true" class="icon"><img src="assets/images/Progress_bar.GIF"> </span><span ng-if="vm.validation==vm.COMPLETED" aria-hidden="true" class="icon"><img src="assets/images/EOD_Process_Success.png"> </span><span ng-if="vm.validation==vm.FAILED" aria-hidden="true" class="icon"><img src="assets/images/EOD_Process_Error.png"></span></td><td>{{vm.remarks}}</td></tr><tr><td data-translate="gatewayApp.eodProcess.validateSessionClose"></td><td><span ng-if="vm.sessionCloseValidation==vm.NOTSTARTED" aria-hidden="true" class="icon"></span> <span ng-if="vm.sessionCloseValidation==vm.INPROGRESS" aria-hidden="true" class="icon"><img src="assets/images/Progress_bar.GIF"> </span><span ng-if="vm.sessionCloseValidation==vm.COMPLETED" aria-hidden="true" class="icon"><img src="assets/images/EOD_Process_Success.png"> </span><span ng-if="vm.sessionCloseValidation==vm.FAILED" aria-hidden="true" class="icon"><img src="assets/images/EOD_Process_Error.png"></span></td><td>{{vm.sessionCloseMessage}}</td></tr></tbody></table></div><div class="row bootstrap-tableresponsive" ng-show="vm.showEodProcess"><table id="eodProcess" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.eodProcess.process"></th><th data-translate="gatewayApp.eodProcess.status"></th><th data-translate="gatewayApp.eodProcess.remarks"></th></tr></thead><tbody><tr ng-repeat="process in vm.eodProcessList "><td>{{process.description}}</td><td><span ng-if="process.status==vm.NOTSTARTED" aria-hidden="true" class="icon"></span> <span ng-if="process.status==vm.INPROGRESS" aria-hidden="true" class="icon"><img src="assets/images/Progress_bar.GIF"> </span><span ng-if="process.status==vm.COMPLETED" aria-hidden="true" class="icon"><img src="assets/images/EOD_Process_Success.png"> </span><span ng-if="process.status==vm.FAILED" aria-hidden="true" class="icon"><img src="assets/images/EOD_Process_Error.png"></span></td><td>{{process.remarks}}</td></tr></tbody></table></div></div></div></div></section></div></nmb-aler-error></div><script src="assets/js/tables.js"></script>');
$templateCache.put('app/entities/expiry-time/expiry-time.html','<form name="expiryTimeForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><span data-translate="gatewayApp.expiryTime.title"></span></h4></div><div class="modal-body"><div class="content"><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.expiryTime.gtt"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-time-picker control-model="vm.expiryDateTime" control-id="dtpExpiryTime" control24hrformat="true" form="intradayMarketEdit" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="expiryTimeForm.$invalid" class="btn btn-info active" ng-disabled="clicked" ng-click="vm.add();" autofocus><span>Ok</span></button></div></div></form>');
$templateCache.put('app/entities/exposure-sub-type/exposure-sub-type-dialog.html','<style>.btn-reject {\r\n\tbackground-color: #f34743;\r\n\tborder: 1px solid #f34743;\r\n\tcolor: white;\r\n}\r\n\r\n.btn-approve {\r\n\tbackground-color: #37a36a;\r\n\tborder: 1px solid #37a36a;\r\n\tcolor: white;\r\n}</style><form name="exposureSubTypeEditForm" role="form" autocomplete="off" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span ng-show="vm.exposureSubType.id==null" data-translate="global.menu.exposureSubType.addNewExposureSubType"></span> <span ng-show="vm.exposureSubType.id!=null && vm.mode!=\'VIEW\'" data-translate="global.menu.exposureSubType.editExposureSubType"></span> <span ng-show="vm.exposureSubType.id!=null && vm.mode==\'VIEW\'" data-translate="global.menu.exposureSubType.viewExposureSubType"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset><br><div class="col-sm-10 col-centered"><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered" cspl-mandatory><span data-translate="gatewayApp.exposureSubType.exposureSubType"></span></label><div class="col-xs-12 col-md-12 multi-col" ng-show="!(vm.exposureSubType.id!=null)"><cspl-text control-model="vm.exposureSubType.name" control-id="txtExposureSubTypeName" control-maxlength="100" control-disabled="vm.viewMode || (vm.exposureSubType.id!=null || showResubmitButton)" form="exposureSubTypeEditForm" control-required="true"></div><div class="col-xs-9 col-md-9 multi-col" ng-show="vm.exposureSubType.id!=null"><cspl-text control-model="vm.exposureSubType.name" control-id="txtExposureSubTypeName" control-maxlength="100" control-disabled="vm.viewMode || (vm.exposureSubType.id!=null || showResubmitButton)" form="exposureSubTypeEditForm" control-required="true"></div><div class="col-xs-3 col-md-3" style="line-height:30px" ng-show="vm.exposureSubType.id!=null"><!-- <input type="checkbox" style="vertical-align: middle;margin-bottom: 3px;" id="chkIsEnabled" ng-model="vm.disabled" ng-disabled="vm.viewMode">\r\n\t\t\t\t\t\t\t<label class="control-label" for="chkIsEnabled" data-translate="gatewayApp.exposureSubType.disable">Disable?</label> --><label class="check-control" ng-hide="vm.viewMode"><input class="checkbox" ng-model="vm.disabled" type="checkbox" id="chkIsEnabled" ng-disabled="vm.viewMode"> <span class="checkbox-overlay" style="top:5px"></span></label><label class="check-control" ng-show="vm.viewMode"><input class="checkbox" ng-model="vm.disabled" type="checkbox" id="chkIsEnabled" ng-disabled="vm.viewMode"> <span class="checkbox-overlay-disabled" style="top:5px"></span></label><label class="control-label" for="chkIsEnabled" data-translate="gatewayApp.exposureSubType.disable" style="margin-left: 3px"></label></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered"><span data-translate="gatewayApp.exposureSubType.remarks"></span></label><cspl-multiline-text control-model="vm.exposureSubType.remarks" control-maxlength="7000" control-id="txtremarks" control-disabled="vm.viewMode" form="exposureSubTypeEditForm" allow-enter="false"></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span ng-if="vm.mode!=\'VIEW\'" data-translate="entity.action.cancel">Cancel</span> <span ng-if="vm.mode==\'VIEW\'" data-translate="entity.action.close">Close</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="exposureSubTypeEditForm.$invalid || vm.clicked" ng-click="vm.clicked = true;vm.resubmitExposureSubType();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="exposureSubTypeEditForm.$invalid  || vm.clicked" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardExposureSubType()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectExposureSubType()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveExposureSubType();vm.clicked=true;" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/exposure-sub-type/exposure-sub-type.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.exposureSubType.title">Exposure Sub-Type</h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="float-right"><button type="button" class="btn btn-info active" ng-click="vm.screenLog.screenLog(vm.screenName,0,vm.entityConstants.ENTITY_ACTION_TYPE.ADD);vm.launch()" ng-show="vm.permitExposureSubTypeAddEntityAction"><img ng-src="assets/images/Add.png"> <span data-translate="global.menu.exposureSubType.newExposureSubType"></span></button></div><div class="float-right col-xs-10 col-sm-3 col-md-2"><cspl-table-search control-model="filterText"></cspl-table-search></div><div class="pull-left"><a href="" style="color: #fff; vertical-align: -19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size: 20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="exposureSubType" total-record-count="vm.exposureSubTypes.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Exposure_Sub_Type"></cspl-table-export></div></div><div class="table-responsive" style="overflow: auto !important"><table id="exposureSubType" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.exposureSubType.status">Status</th><th data-translate="gatewayApp.exposureSubType.exposureSubType">Exposure Sub-Type</th><th data-translate="gatewayApp.exposureSubType.remarks">Remarks</th><th data-translate="gatewayApp.exposureSubType.lastModifiedDate">Last Modified Date</th><th></th></tr></thead><tbody><tr ng-repeat="exposureSubType in filterData = (vm.exposureSubTypes | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td><span ng-if="exposureSubType.isEnabled==true">Active</span><span ng-if="exposureSubType.isEnabled==false">Disabled</span></td><td>{{exposureSubType.name}}</td><td>{{exposureSubType.remarks}}</td><td>{{exposureSubType.lastModifiedDate | date : \'dd-MMM-yyyy HH:mm:ss\'}}</td><td width="10%" style="text-align: right"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitExposureSubTypeEditEntityAction"><a ng-click="vm.editExposureSubType(exposureSubType.id)"><span data-translate="entity.action.edit"></span></a></li><li ng-show="vm.permitExposureSubTypeViewEntityAction"><a ui-sref="exposure-sub-type-view({id:exposureSubType.id})" ng-click="vm.screenLog.screenLog(vm.screenName, exposureSubType.id, vm.entityConstants.ENTITY_ACTION_TYPE.VIEW)"><span data-translate="entity.action.view"></span></a></li></ul></div></td></tr></tbody></table><div style="padding: 5px" ng-show="vm.exposureSubTypes.length==0"><span>No record found</span></div><div ng-show="vm.exposureSubTypes.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/exposure-type/exposure-type-dialog.html','<style>.btn-reject {\r\n\tbackground-color: #f34743;\r\n\tborder: 1px solid #f34743;\r\n\tcolor: white;\r\n}\r\n\r\n.btn-approve {\r\n\tbackground-color: #37a36a;\r\n\tborder: 1px solid #37a36a;\r\n\tcolor: white;\r\n}</style><form name="exposureTypeEditForm" role="form" autocomplete="off" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span ng-show="vm.exposureType.id==null" data-translate="global.menu.exposureType.addNewExposureType"></span> <span ng-show="vm.exposureType.id!=null && vm.mode!=\'VIEW\'" data-translate="global.menu.exposureType.editExposureType"></span> <span ng-show="vm.exposureType.id!=null && vm.mode==\'VIEW\'" data-translate="global.menu.exposureType.viewExposureType"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset><br><div class="col-sm-10 col-centered"><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered" cspl-mandatory><span data-translate="gatewayApp.exposureType.exposureType"></span></label><div class="col-xs-12 col-md-12 multi-col" ng-show="!(vm.exposureType.id!=null)"><cspl-text control-model="vm.exposureType.name" control-id="txtExposureTypeName" control-maxlength="100" control-disabled="vm.viewMode || (vm.exposureType.id!=null || showResubmitButton)" form="exposureTypeEditForm" control-required="true"></div><div class="col-xs-9 col-md-9 multi-col" ng-show="vm.exposureType.id!=null"><cspl-text control-model="vm.exposureType.name" control-id="txtExposureTypeName" control-maxlength="100" control-disabled="vm.viewMode || (vm.exposureType.id!=null || showResubmitButton)" form="exposureTypeEditForm" control-required="true"></div><div class="col-xs-3 col-md-3" style="line-height:30px" ng-show="vm.exposureType.id!=null"><!-- <input type="checkbox" style="vertical-align: middle;margin-bottom: 3px;" id="chkIsEnabled" ng-model="vm.disabled" ng-disabled="vm.viewMode">\r\n\t\t\t\t\t\t\t<label class="control-label" for="chkIsEnabled" data-translate="gatewayApp.exposureType.disable">Disable?</label> --><label class="check-control" ng-hide="vm.viewMode"><input class="checkbox" ng-model="vm.disabled" type="checkbox" id="chkIsEnabled" ng-disabled="vm.viewMode"> <span class="checkbox-overlay" style="top:5px"></span></label><label class="check-control" ng-show="vm.viewMode"><input class="checkbox" ng-model="vm.disabled" type="checkbox" id="chkIsEnabled" ng-disabled="vm.viewMode"> <span class="checkbox-overlay-disabled" style="top:5px"></span></label><label class="control-label" for="chkIsEnabled" data-translate="gatewayApp.exposureType.disable" style="margin-left: 3px"></label></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered"><span data-translate="gatewayApp.exposureType.remarks"></span></label><cspl-multiline-text control-model="vm.exposureType.remarks" control-maxlength="7000" control-id="txtremarks" control-disabled="vm.viewMode" form="exposureTypeEditForm" allow-enter="false"></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span ng-if="vm.mode!=\'VIEW\'" data-translate="entity.action.cancel">Cancel</span> <span ng-if="vm.mode==\'VIEW\'" data-translate="entity.action.close">Close</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="exposureTypeEditForm.$invalid || vm.clicked" ng-click="vm.clicked = true;vm.resubmitExposureType();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="exposureTypeEditForm.$invalid  || vm.clicked" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardExposureType()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectExposureType()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveExposureType();vm.clicked=true;" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/exposure-type/exposure-type.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.exposureType.title">Exposure Type</h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="float-right"><button type="button" class="btn btn-info active" ng-click="vm.screenLog.screenLog(vm.screenName,0,vm.entityConstants.ENTITY_ACTION_TYPE.ADD);vm.launch()" ng-show="vm.permitExposureTypeAddEntityAction"><img ng-src="assets/images/Add.png"> <span data-translate="global.menu.exposureType.newExposureType"></span></button></div><div class="float-right col-xs-10 col-sm-3 col-md-2"><cspl-table-search control-model="filterText"></cspl-table-search></div><div class="pull-left"><a href="" style="color: #fff; vertical-align: -19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size: 20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="exposureType" total-record-count="vm.exposureTypes.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Exposure_Type"></cspl-table-export></div></div><div class="table-responsive" style="overflow: auto !important"><table id="exposureType" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.exposureType.status">Status</th><th data-translate="gatewayApp.exposureType.exposureType">Exposure Type</th><th data-translate="gatewayApp.exposureType.remarks">Remarks</th><th data-translate="gatewayApp.exposureType.lastModifiedDate">Last Modified Date</th><th></th></tr></thead><tbody><tr ng-repeat="exposureType in filterData = (vm.exposureTypes | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td><span ng-if="exposureType.isEnabled==true">Active</span><span ng-if="exposureType.isEnabled==false">Disabled</span></td><td>{{exposureType.name}}</td><td>{{exposureType.remarks}}</td><td>{{exposureType.lastModifiedDate | date : \'dd-MMM-yyyy HH:mm:ss\'}}</td><td width="10%" style="text-align: right"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitExposureTypeEditEntityAction"><a ng-click="vm.editExposureType(exposureType.id)"><span data-translate="entity.action.edit"></span></a></li><li ng-show="vm.permitExposureTypeViewEntityAction"><a ui-sref="exposure-type-view({id:exposureType.id})" ng-click="vm.screenLog.screenLog(vm.screenName, exposureType.id, vm.entityConstants.ENTITY_ACTION_TYPE.VIEW)"><span data-translate="entity.action.view"></span></a></li></ul></div></td></tr></tbody></table><div style="padding: 5px" ng-show="vm.exposureTypes.length==0"><span>No record found</span></div><div ng-show="vm.exposureTypes.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/forex-configurations/forex-configurations-details.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="forexConfigurationsViewForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><span data-translate="global.menu.forexConfigurations.forexConfigurations"></span></h4></div><div class="modal-body"><div class="content"><fieldset><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.forexConfigurations.bank"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.forexConfigurations.bank.bankName" control-id="txtbankName" control-disabled="true" placeholder="" form="bankregistrationForm"></div></div><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseRedirectionURLConfigurations = !vm.ExpandOrCollapseRedirectionURLConfigurations" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseone"><img ng-src="{{vm.ExpandOrCollapseRedirectionURLConfigurations == false && \'assets/images/Accordion_collapse.png\' || \'assets/images/Accordion_expand.png\'}}"> &nbsp; <span class="nav-label">Bank Redirection URL Configurations</span></a></h4></div><div id="collapseone" class="panel-collapse collapse in" style="background-color: black"><div class="accordion-content1"><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.forexConfigurations.forexCardIssuanceURL"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.forexConfigurations.bankForexUrlDetails.forexCardIssuanceUrl" control-id="txtforexCardIssuanceUrl" control-minlength="1" control-disabled="true" placeholder="" form="forexConfigurationsForm"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.forexConfigurations.forexCardReloadURL"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.forexConfigurations.bankForexUrlDetails.forexCardReloadUrl" control-id="txtforexCardReloadURL" control-disabled="true" control-minlength="1" placeholder="" form="forexConfigurationsForm"></cspl-text></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.forexConfigurations.forexRemittanceURL"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.forexConfigurations.bankForexUrlDetails.forexCardRemittanceUrl" control-minlength="1" control-id="txtforexRemittanceURL" control-disabled="true" placeholder="" form="forexConfigurationsForm"></div></div></div></div></div><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseDeliveryConfigurations = !vm.ExpandOrCollapseDeliveryConfigurations" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapsethree"><img ng-src="{{vm.ExpandOrCollapseDeliveryConfigurations == false && \'assets/images/Accordion_collapse.png\' || \'assets/images/Accordion_expand.png\'}}"> &nbsp; <span class="nav-label">Forex Delivery Configurations</span></a></h4></div><div id="collapsethree" class="panel-collapse collapse in" style="background-color: black"><div class="accordion-content1"><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span>Currency Notes</span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.forexConfigurations.bankForexUrlDetails.currencyNotes" control-id="txtcurrencyNotes" control-disabled="true" placeholder="" form="forexConfigurationsForm"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span>Card Issuance</span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.forexConfigurations.bankForexUrlDetails.cardIssuance" control-id="txtcardIssuance" control-disabled="true" placeholder="" form="forexConfigurationsForm"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span>Card Load</span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.forexConfigurations.bankForexUrlDetails.cardLoad" control-id="txtcardLoad" control-disabled="true" placeholder="" form="forexConfigurationsForm"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span>Remittance</span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.forexConfigurations.bankForexUrlDetails.remittance" control-id="txtremittance" control-disabled="true" placeholder="" form="forexConfigurationsForm"></div></div></div></div></div><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseFeeConfigurations = !vm.ExpandOrCollapseFeeConfigurations" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapsetwo"><img ng-src="{{vm.ExpandOrCollapseFeeConfigurations == false && \'assets/images/Accordion_collapse.png\' || \'assets/images/Accordion_expand.png\' }}"> &nbsp; <span class="nav-label">Fee Configurations</span></a></h4></div><div id="collapsetwo" class="panel-collapse collapse in" style="background-color: black"><div class="accordion-content1"><div class="row" ng-repeat="fee in vm.forexConfigurations.bankForexFeeDetailsList"><div class="col-md-9 col-md-offset-2"><label class="col-md-3 control-label"><span></span>{{fee.feeType.name}}</label><!-- <label\r\n\t\t\t\t\t\t\t\t\tcspl-mandatory><span>{{fee.feeType.name}}</span></label> --><!-- <cspl-text control-model="fee.feeType.name"\r\n                                    control-id="txtFeeType{{$index}}"\r\n                                    control-disabled="true"\r\n                                    form="forexConfigurationsForm" /> --><div class="col-md-3"><label class="control-label"><span data-translate="gatewayApp.forexConfigurations.rate"></span></label><cspl-numeric control-model="fee.fee" control-id="txtFee{{$index}}" control-disabled="true" no-of-decimals="{{3}}" form="forexConfigurationsForm"></div><!-- Units --><div class="col-md-3"><label class="control-label"><span data-translate="gatewayApp.forexConfigurations.units"></span></label><cspl-text control-model="fee.units" control-id="txtUnits{{$index}}" form="forexConfigurationsForm" control-disabled="true"></div></div></div></div></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>OK</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardForexConfigurations()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showButton" class="btn btn-reject" ng-click="vm.rejectForexConfigurations()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" class="btn btn-approve" ng-disabled="clicked" ng-click="vm.approveForexConfigurations();clicked=true;" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/forex-configurations/forex-configurations-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="forexConfigurationsForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><span data-translate="global.menu.forexConfigurations.forexConfigurations"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.forexConfigurations.bank"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.forexConfigurations.bank.bankName" control-id="txtbankName" control-disabled="true" placeholder="" form="forexConfigurationsForm"></div></div><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseRedirectionURLConfigurations = !vm.ExpandOrCollapseRedirectionURLConfigurations" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseone"><img ng-src="{{vm.ExpandOrCollapseRedirectionURLConfigurations == false && \'assets/images/Accordion_collapse.png\' ||\'assets/images/Accordion_expand.png\'}}"> &nbsp; <span class="nav-label">Bank Redirection URL Configurations</span></a></h4></div><div id="collapseone" class="panel-collapse collapse in" style="background-color: black"><div class="accordion-content1"><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.forexConfigurations.forexCardIssuanceURL"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.forexConfigurations.bankForexUrlDetails.forexCardIssuanceUrl" control-id="txtforexCardIssuanceUrl" control-minlength="1" placeholder="" form="forexConfigurationsForm"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.forexConfigurations.forexCardReloadURL"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.forexConfigurations.bankForexUrlDetails.forexCardReloadUrl" control-id="txtforexCardReloadURL" control-minlength="1" placeholder="" form="forexConfigurationsForm"></cspl-text></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.forexConfigurations.forexRemittanceURL"></span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><cspl-text control-model="vm.forexConfigurations.bankForexUrlDetails.forexCardRemittanceUrl" control-minlength="1" control-id="txtforexRemittanceURL" placeholder="" form="forexConfigurationsForm"></div></div></div></div></div><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseDeliveryConfigurations = !vm.ExpandOrCollapseDeliveryConfigurations" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapsethree"><img ng-src="{{vm.ExpandOrCollapseDeliveryConfigurations == false && \'assets/images/Accordion_collapse.png\' || \'assets/images/Accordion_expand.png\'}}"> &nbsp; <span class="nav-label">Forex Delivery Configurations</span></a></h4></div><div id="collapsethree" class="panel-collapse collapse in" style="background-color: black"><div class="accordion-content1"><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span>Currency Notes</span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><select class="form-control" style="border-color: #484850" required ng-model="vm.forexConfigurations.bankForexUrlDetails.currencyNotes" ng-options="opt.value as opt.name for opt in vm.currencyNotesDeliveryOptions"></select></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span>Card Issuance</span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><select class="form-control" style="border-color: #484850" required ng-model="vm.forexConfigurations.bankForexUrlDetails.cardIssuance" ng-options="opt.value as opt.name for opt in vm.deliveryConfigOptions"></select></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span>Card Load</span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><select class="form-control" style="border-color: #484850" required ng-model="vm.forexConfigurations.bankForexUrlDetails.cardLoad" ng-options="opt.value as opt.name for opt in vm.deliveryConfigOptions"></select></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-3" cspl-mandatory><span>Remittance</span></label></div><div class="row"><div class="col-md-7 col-md-offset-3"><select class="form-control" style="border-color: #484850" required ng-model="vm.forexConfigurations.bankForexUrlDetails.remittance" ng-options="opt.value as opt.name for opt in vm.deliveryConfigOptions"></select></div></div></div></div></div><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseFeeConfigurations = !vm.ExpandOrCollapseFeeConfigurations" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapsetwo"><img ng-src="{{vm.ExpandOrCollapseFeeConfigurations == false && \'assets/images/Accordion_collapse.png\' || \'assets/images/Accordion_expand.png\' }}"> &nbsp; <span class="nav-label">Fee Configurations</span></a></h4></div><div id="collapsetwo" class="panel-collapse collapse in" style="background-color: black"><div class="accordion-content1"><div class="row" ng-repeat="fee in vm.forexConfigurations.bankForexFeeDetailsList"><div class="col-md-9 col-md-offset-2"><label class="col-md-3 control-label"><span></span>{{fee.feeType.name}}</label><!-- <label\r\n\t\t\t\t\t\t\t\t\tcspl-mandatory><span>{{fee.feeType.name}}</span></label> --><!-- <cspl-text control-model="fee.feeType.name"\r\n                                    control-id="txtFeeType{{$index}}"\r\n                                    control-disabled="true"\r\n                                    form="forexConfigurationsForm" /> --><div class="col-md-3"><label class="control-label"><span data-translate="gatewayApp.forexConfigurations.rate"></span></label><cspl-numeric control-model="fee.fee" control-id="txtFee{{$index}}" form="forexConfigurationsForm" no-of-decimals="{{3}}"></div><!-- Units --><div class="col-md-3"><label class="control-label"><span data-translate="gatewayApp.forexConfigurations.units"></span></label><select class="form-control" style="border-color: #484850" control-id="txtUnits{{$index}}" ng-model="fee.units" ng-options="u.value for u in vm.unitTypes track by u.value" form="forexConfigurationsForm"><option selected="selected" disabled="disabled" hidden style="display:none" value=""></option></select></div></div></div></div></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showButton" class="btn btn-primary" ng-disabled="forexConfigurationsForm.$invalid || vm.clicked" ng-click="vm.clicked = true;vm.resubmitForexConfigurations();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="!showButton" class="btn btn-info active" ng-disabled="forexConfigurationsForm.$invalid || vm.clicked || forexConfigurationsForm.$pristine" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/forex-configurations/forex-configurations.html','<div class="container-fluid" ng-cloak><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.forexConfigurations.forexConfigurations"></h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div id="forexConfigurations" class="forex-configurations collapse in" style="background-color: black"><div class="accordion-content1"></div></div></div><br><div><div class="row"><div class="pull-right"><div class="col-md-6 pull-right"><cspl-table-search control-model="filterData1"></cspl-table-search></div></div><div class="pull-left"><a href="" style="color: #fff; vertical-align: -19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size: 20px"></i></a></div><span class="partition">|</span><div class="pull-left"><div class="dropdown col-md-3" style="width:10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border:none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportDataToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportDataToFile(\'xls\');">XLS</a></li></ul></div></div></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="forexConfigurations" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.forexConfigurations.bank"></th><th data-translate="gatewayApp.forexConfigurations.forexCardIssuanceURL"></th><th data-translate="gatewayApp.forexConfigurations.forexCardReloadURL"></th><th data-translate="gatewayApp.forexConfigurations.forexRemittanceURL"></th><th><span>Currency Notes</span></th><th><span>Card Issuance</span></th><th><span>Card Load</span></th><th><span>Remittance</span></th><th data-translate="gatewayApp.forexConfigurations.feeType"></th><th data-translate="gatewayApp.forexConfigurations.rate"></th><th data-translate="gatewayApp.forexConfigurations.units"></th><th></th></tr></thead><tbody class="forexConfigurations" ng-repeat="forexConfigurations in vm.forexConfigurations | filter: filterData1 | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><tr><td style="border-top: 1px solid #333333" rowspan="{{5}}">{{forexConfigurations.bank.bankName}}</td><td style="border-top: 1px solid #333333" rowspan="{{5}}">{{forexConfigurations.bankForexUrlDetails.forexCardIssuanceUrl || \'-\'}}</td><td style="border-top: 1px solid #333333" rowspan="{{5}}">{{forexConfigurations.bankForexUrlDetails.forexCardReloadUrl || \'-\'}}</td><td style="border-top: 1px solid #333333" rowspan="{{5}}">{{forexConfigurations.bankForexUrlDetails.forexCardRemittanceUrl || \'-\'}}</td><td style="border-top: 1px solid #333333" rowspan="{{5}}">{{forexConfigurations.bankForexUrlDetails.currencyNotes || \'-\'}}</td><td style="border-top: 1px solid #333333" rowspan="{{5}}">{{forexConfigurations.bankForexUrlDetails.cardIssuance || \'-\'}}</td><td style="border-top: 1px solid #333333" rowspan="{{5}}">{{forexConfigurations.bankForexUrlDetails.cardLoad || \'-\'}}</td><td style="border-top: 1px solid #333333" rowspan="{{5}}">{{forexConfigurations.bankForexUrlDetails.remittance || \'-\'}}</td><td style="border-top: 1px solid #333333">{{forexConfigurations.bankForexFeeDetailsList[0].feeType.name || \'-\'}}</td><td style="border-top: 1px solid #333333">{{forexConfigurations.bankForexFeeDetailsList[0].fee| currency:"" : vm.noOfDecimalsForRate || \'-\'}}</td><td style="border-top: 1px solid #333333">{{forexConfigurations.bankForexFeeDetailsList[0].units || \'-\'}}</td><td style="border-top: 1px solid #333333" style="text-align:center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitForexConfigurationsViewEntityAction"><a ui-sref="forex-configurations.view({id: forexConfigurations.id})" ng-click="vm.screenLog.screenLog(vm.screenName,forexConfigurations.id,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitForexConfigurationsEditEntityAction"><a ui-sref="forex-configurations.edit({id: forexConfigurations.id})" ng-click="vm.screenLog.screenLog(vm.screenName,forexConfigurations.id,vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></a></li></ul></div></td></tr><tr ng-repeat="feeDetails in forexConfigurations.bankForexFeeDetailsList.slice(1)"><td>{{feeDetails.feeType.name || \'-\'}}</td><td>{{feeDetails.fee| currency:"" : vm.noOfDecimalsForRate || \'-\'}}</td><td>{{feeDetails.units || \'-\'}}</td></tr></tbody></table></div><div ng-show="vm.forexConfigurations.length > 0"><cspl-pagination record-count="vm.forexConfigurations.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div></div><script src="assets/js/tables.js"></script><style>tbody.forexConfigurations:hover tr{\r\nbackground-color: #F0CBA6 !important;\r\ncolor:#0D0D0D !important;\r\n}\r\n\r\n tbody.forexConfigurations:hover tr td{\r\n\r\n} \r\n.table-responsive {\r\n  overflow: visible !important;\r\n}</style>');
$templateCache.put('app/entities/forgot-pid/forgot-pid.html','<style>.selectedRow {\r\n    background-color:#F0CBA6 !important;\r\n    color:#0D0D0D;\r\n}</style><form name="forgotpidform" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="gatewayApp.ForgotPID.main"></span></h4></div><div class="modal-body"><div class="content"><!-- <div class="row">\r\n\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"><span\r\n\t\t\t\t\tdata-translate="gatewayApp.ForgotPID.firstName"></span></label>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class="row">\r\n\t\t\t\t\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3">\r\n\t\t\t\t\t\t<cspl-text control-model="vm.firstName" control-type="AlphaWithSpace" control-id="txtfirstName" control-maxlength="100" form="forgotpidform"/>\r\n\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class="row">\r\n\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"><span\r\n\t\t\t\t\tdata-translate="gatewayApp.ForgotPID.lastName"></span></label>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class="row">\r\n\t\t\t\t\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3">\r\n\t\t\t\t\t\t<cspl-text control-model="vm.lastName" control-type="AlphaWithSpace" control-id="txtlastName" control-maxlength="100" form="forgotpidform"/>\r\n\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\r\n\t\t\t</div> --><!-- <div class="row">\r\n\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span\r\n\t\t\t\t\tdata-translate="gatewayApp.ForgotPID.dob"></span></label>\r\n\t\t\t</div>\r\n\t\t\t\r\n\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3">\r\n\t\t\t\t\t\t\t<cspl-dtp control-model = "vm.dob" control-id="dtpdob"  form="forgotpidform" required/>\r\n\t\t\t\t\t</div>\r\n\t\t\t</div> --><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.ForgotPID.email"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.email" control-type="Email" control-id="txtemail" control-maxlength=" 100" form="usersForm" form="forgotpidform" required></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.ForgotPID.mobile"></span></label></div><div class="row"><div class="col-lg-1 col-md-offset-3"><cspl-numeric control-model="vm.mobileCountryCode" control-id="txtMobileCountryCode" no-of-decimals="0" control-tab-index="-1" control-max="999" control-min="1" form="forgotpidform" required></div><div class="col-md-5"><cspl-text control-model="vm.mobile" control-type="Number" control-id="txtMobile" control-maxlength="15" form="forgotpidform" required></div><!-- <div class="row">\r\n\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"\r\n\t\t\t\t\tcspl-mandatory><span\r\n\t\t\t\t\tdata-translate="gatewayApp.ForgotPID.pincode"></span></label>\r\n\t\t\t</div>\r\n\t\t\t<div class="row">\r\n\t\t\t\t<div class="col-md-6 col-md-offset-3">\r\n\t\t\t\t\t<cspl-text control-model="vm.pincode"\r\n\t\t\t\t\t\tcontrol-id="txtpincode" control-type="Alphanumeric"\r\n\t\t\t\t\t\t control-maxlength="7" form="forgotpidform" required />\r\n\t\t\t\t</div>--></div><div class="row col-md-offset-3" ng-if="!vm.isOTPSend"><button type="submit" class="btn btn-info active" ng-disabled="forgotpidform.$invalid" ng-click="vm.sendOTP()"><span data-translate="entity.action.gnerateOTP"></span></button></div><div class="row" ng-if="vm.isOTPSend"><div class="col-md-6 col-md-offset-3" id="otp" control-model="vm.otp" otp-input-directive options="otpInput"></div><div class="row" ng-show="vm.isOTPSend"><label class="help-block col-md-10 col-md-offset-2"><a style="margin-right:12%" href="" ng-click="vm.sendOTP()">Resend</a></label></div><!-- <div class="col-md-1" style="margin-top:5px; " ng-show="vm.isOTPSend"><span class="icon icon_refresh" title="Resend OTP" ng-click="vm.resendPrimaryOTP()"></span></div> --></div><div class="row"><div class="col-md-9 col-md-offset-3"><label class="help-text" ng-if="vm.isOTPSend" data-translate="gatewayApp.ForgotPID.otpHelpText"></label></div></div><div class="row col-md-3 col-md-offset-10" ng-if="vm.isOTPSend"><button type="submit" class="btn btn-info active" ng-disabled="forgotpidform.$invalid" ng-click="selectedRow=null;vm.pidList=null;vm.getPID();vm.show=true;"><span data-translate="gatewayApp.ForgotPID.fetch"></span></button></div><!-- <div class="row">\r\n\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label" ><span\r\n\t\t\t\t\tdata-translate="gatewayApp.ForgotPID.aadharNo"></span></label>\r\n\t\t\t</div>\r\n\t\t\t\r\n\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3">\r\n\t\t\t\t\t\t\t<cspl-text control-model="vm.aadharNumber"  control-id="txtaadharNumber"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcontrol-minlength="12" control-maxlength="12"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\thelp-text="{{\'userManagement.helpText.aadharNumber\' | translate}}"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tform="forgotpidform" />\r\n\t\t\t\t\t</div>\r\n\t\t\t</div> --><div class="row" ng-show="vm.pidList!=null && vm.pidList.length>0"><span class="help-block-error left-floating ng-scope" data-translate="gatewayApp.ForgotPID.legend"></span></div><div class="table-responsive" style="overflow:auto" ng-show="vm.pidList!=null && vm.pidList.length>0"><table id="tblusermanagement" class="dataTable table table-striped table-hover"><thead><tr><th>Personal ID</th><th data-translate="gatewayApp.ForgotPID.firstName">First Name</th><th data-translate="gatewayApp.ForgotPID.lastName">Last Name</th><th style="min-width:85px" data-translate="gatewayApp.ForgotPID.dob">DOB</th><th data-translate="gatewayApp.ForgotPID.pincode">Postal Code</th></tr></thead><tbody><tr ng-repeat="user in filterData = (vm.pidList | filter : filterText | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)" ng-class="{\'selectedRow\':$index == selectedRow}" ng-click="setClickedRow($index)"><td>{{user.personDetails.personId}}</td><td style="word-break:break-word">{{user.personDetails.firstName}}</td><td style="word-break:break-word">{{user.personDetails.lastName}}</td><td>{{user.personDetails.dob|date:\'dd-MMM-yyyy\'}}</td><td style="word-break:break-word">{{user.personDetails.pincode}}</td></tr></tbody></table><div ng-show="vm.pidList.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="modal-footer"><button type="submit" class="btn btn-info active" ng-show="vm.pidList!=null && vm.pidList.length>0" ng-disabled="selectedRow==null || selectedRow==undefined" ng-click="vm.getPIDFromList(selectedRow);vm.show=true;"><span data-translate="gatewayApp.ForgotPID.go"></span></button></div><!-- <div class="row" ng-show="vm.PID!=null">\r\n\t\t\t\t<label class="col-md-6 col-md-offset-3  control-label"> <span data-translate="gatewayApp.ForgotPID.PID"></span></label>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class="row" ng-show="vm.PID!=null">\r\n\t\t\t\t<div class="col-md-6 col-md-offset-3 ">\r\n\t\t\t\t\t<cspl-text control-model="vm.PID" control-type="Alphanumeric" control-disabled="true" control-id="txtPID" />\r\n\t\t\t\t</div>\r\n\r\n\t\t\t</div> --><div class="alert alert-success alert-message" ng-show="vm.PID!=null">PID is {{vm.PID}}</div><div><nmb-alert-error></nmb-alert-error></div></div></div></div></form>');
$templateCache.put('app/entities/generic-users/generic-users.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title">Generic Users</h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="col-md-1"><button type="button" class="btn btn-info active" ng-click="vm.importUsers()">IMPORT</button></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/Generic-Customers/generic-customers.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title">Generic Customers</h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="col-md-1"><button type="button" class="btn btn-info active" ng-click="vm.importCustomers()">IMPORT</button></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/global-approval-policy/global-approval-policy-delete-dialog.html','<form name="deleteForm" ng-submit="clicked=true;vm.confirmDelete(vm.approvalPolicyDTO.id)"><div class="modal-header-red"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" style="text-align:left;padding-left:3%">Are you sure?</h4></div><div class="modal-body"><nmb-alert-error></nmb-alert-error><p><textarea class="form-control modal-header-red" rows="6" ng-model="vm.reason" placeholder="Please provide a reason" required></textarea></p><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid||clicked" class="btn btn-danger"><span data-translate="entity.action.delete">Delete</span></button></div></div></div></form>');
$templateCache.put('app/entities/global-approval-policy/global-approval-policy-dialog.html','<form name="approvalPolicyForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title" ng-if="(!vm.ViewDisable && !vm.EditDisable) "><span data-translate="gatewayApp.title.addGlobalApprovalPolicy"></span></h4><h4 class="modal-title" ng-if="vm.ViewDisable"><span data-translate="gatewayApp.title.viewGlobalApprovalPolicy"></span></h4><h4 class="modal-title" ng-if="vm.EditDisable"><span data-translate="gatewayApp.title.editGlobalApprovalPolicy"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="row"><fieldset><div class="row" style="display: flex" ng-disabled="vm.ViewDisable"><label class="col-sm-10 col-sm-offset-2 control-label" data-translate="gatewayApp.globalApprovalPolicy.globalApprovalProcessFor"></label></div><div class="row"><cspl-ach class="col-sm-5 col-sm-offset-2" control-model="vm.organisationtype" control-disabled="vm.EditDisable || vm.ViewDisable" control-id="txtOrganisationType" lookup-name="organisationTypeForGlobalApprovalPolicy" display-column="shortName" form="approvalPolicyForm" required></cspl-ach></div><div class="row" style="display: flex" ng-show="vm.organisationtype.shortName==\'CUSTOMER\'" ng-disabled="vm.ViewDisable"><label class="col-sm-10 col-sm-offset-2 control-label" data-translate="gatewayApp.globalApprovalPolicy.customerUserType"></label></div><div class="row" style="display: flex" ng-show="vm.organisationtype.shortName==\'CUSTOMER\'" ng-disabled="vm.ViewDisable"><cspl-ach class="col-sm-5 col-sm-offset-2" control-model="vm.customerUserType" control-disabled="vm.EditDisable || vm.ViewDisable" control-id="txtcustomerUserType" lookup-name="multiUserCustomerUserType" display-column="shortName" form="approvalPolicyForm" control-required="vm.organisationtype.shortName==\'CUSTOMER\'"></cspl-ach></div><div class="row" style="display: flex"><label class="col-sm-10 col-sm-offset-2 control-label" data-translate="gatewayApp.globalApprovalPolicy.approvalProcessName"></label></div><div class="row" style="display: flex"><cspl-text class="col-sm-8 col-sm-offset-2" control-model="vm.approvalPolicyDTO.shortName" control-disabled="vm.ViewDisable" form="approvalPolicyForm" control-id="txtApprovalProcessName" required><div class="col-sm-1 col-sm-offset-2 pull-right"><cspl-table-search ng-show="vm.ViewDisable" control-model="filterText"></cspl-table-search></div></div><div class="row" style="display: flex" ng-disabled="vm.ViewDisable" ng-hide="vm.ViewDisable"><!-- <div class="col-sm-10 col-sm-offset-2" ng-hide="vm.ViewDisable">  --><label class="col-sm-5 col-sm-offset-2 control-label" data-translate="gatewayApp.globalApprovalPolicy.role"></label><label class="col-sm-3 control-label" data-translate="gatewayApp.globalApprovalPolicy.noOfApprovals"></label><!-- </div>  --></div><div class="row" style="display: flex" ng-disabled="vm.ViewDisable" ng-hide="vm.ViewDisable"><!-- <div class="col-sm-10 col-sm-offset-2"  ng-hide="vm.ViewDisable"> --><cspl-ach class="col-sm-5 col-sm-offset-2" control-model="vm.selectedPolicyOrganisationRole" control-id="txtPolicyOrganisationRole" lookup-name="GlobalRole" display-column="name" form="approvalPolicyForm" filter-value="{{vm.organisationtype.id}}~~{{vm.customerUserType.id}}"></cspl-ach><div class="col-sm-3"><cspl-text control-model="vm.noOfApprovals" control-type="Number" control-id="txtNoOfApprovals" control-maxlength="1" control-minvalue="1" control-maxvalue="5" form="approvalPolicyForm"></div><div class="col-sm-2"><button type="button" class="btn btn-info active" ng-click="vm.addProcessRole()"><span class="glyphicon glyphicon-plus"></span><span data-translate="entity.action.add"></span></button></div><!-- </div> --></div><br><table class="datatables-nosort table table-striped table-hover"><thead><tr class="pl-2"><!-- <th class="col-sm-1 "></th>--><th class="col-sm-2" data-translate="gatewayApp.globalApprovalPolicy.levels"></th><th class="col-sm-5" nowrap="nowrap" data-translate="gatewayApp.globalApprovalPolicy.role"></th><th class="col-sm-3" data-translate="gatewayApp.globalApprovalPolicy.noOfApprovals"></th><th></th></tr></thead><tbody><!-- <tr  ng-hide="vm.ViewDisable">\r\n\t\t\t\t\t\t\t\t<td></td>\r\n\t\t\t\t\t\t\t\t<td></td>\r\n\t\t\t\t\t\t\t\t<td></td>\r\n\t\t\t\t\t\t\t\t<td><cspl-numeric control-model="vm.noOfApprovals" control-max="5" control-min="1" \r\n\t\t\t\t\t\t\t\t\t\t\tcontrol-id="txtNoOfApprovals" no-of-decimals="0"  /></td>\r\n\t\t\t\t\t\t\t\t<td class="tableNumericColumn">\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t</tr> --><tr ng-repeat="globalApprovalPolicyRole in vm.approvalPolicyRolesList | filter : filterText"><td>{{ ("gatewayApp.globalApprovalPolicy.level" | translate) + " " + ($index + 1)}}</td><td>{{globalApprovalPolicyRole.globalOrganisationTypeRole.name}}</td><td>{{globalApprovalPolicyRole.noOfApprovals}}</td><td class="text-right"><i ng-if="!vm.ViewDisable" ng-click="vm.removePolicy($index)" class="glyphicon glyphicon-remove"></i></td></tr></tbody></table></fieldset></div><br><br></div><div class="modal-footer"><button type="button" ng-show="showCancelButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-show="vm.btnClose" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span>Close</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-click="vm.clicked=true;vm.resubmitApprovalPolicy()" ng-disabled="vm.clicked"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardApprovalPolicy()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="vm.btnApproveReject" class="btn btn-reject" ng-click="vm.rejectApprovalPolicy()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="vm.btnApproveReject" autofocus class="btn btn-approve" ng-click="vm.clicked=true;vm.approveApprovalPolicy()" ng-disabled="vm.clicked"><span data-translate="entity.action.approve">Approve</span></button> <button type="submit" ng-if="showSaveButton" ng-disabled="approvalPolicyForm.$invalid|| approvalPolicyForm.$pristine|| vm.clicked" class="btn btn-info active" ng-click="vm.clicked=true;vm.save()"><span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/global-approval-policy/global-approval-policy.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="gatewayApp.title.manageGlobalApprovalPolicy"></span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row col-md-12"><fieldset class="row col-md-12"><form class="-form" name="filterform"><div class="row" style="padding-top:20px"><label class="col-md-2 control-label left-align-label"><span data-translate="gatewayApp.globalApprovalPolicy.organisationType"></span></label><div class="col-md-2"><cspl-ach control-model="vm.organisationtype" control-id="txtOrganisationType" lookup-name="organisationTypeForGlobalApprovalPolicy" display-column="shortName" required></cspl-ach></div><button type="button" class="btn btn-info active" ng-disabled="vm.organisationtype==null||vm.clicked" ng-show="vm.organisationtype.shortName!=\'CUSTOMER\'" ng-click="vm.loadAll(vm.organisationtype,vm.customerusertype);vm.screenLog.screenLog(vm.ApprovalProcessScreen,0,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW);vm.clicked=true;"><span data-translate="entity.action.go"></span></button><label class="col-md-2 control-label left-align-label" ng-show="vm.organisationtype.shortName==\'CUSTOMER\'"><span data-translate="gatewayApp.globalApprovalPolicy.customerUserType"></span></label><div class="col-md-2" ng-show="vm.organisationtype.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.customerusertype" control-id="txtCustomerUserType" lookup-name="multiUserCustomerUserType" display-column="shortName" required></cspl-ach></div><button type="button" class="btn btn-info active" ng-show="vm.organisationtype.shortName==\'CUSTOMER\'" ng-disabled="vm.customerusertype==null||vm.clicked" ng-click="vm.loadAll(vm.organisationtype,vm.customerusertype);vm.screenLog.screenLog(vm.ApprovalProcessScreen,0,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW);vm.clicked=true;"><span data-translate="entity.action.go"></span></button></div></form></fieldset></div><div class="row"><div class="pull-right"><button type="button" class="btn btn-info active col-md-6" ng-click="vm.screenLog.screenLog(vm.ApprovalProcessScreen, 0, vm.entityConstants.ENTITY_ACTION_TYPE.ADD); vm.launch()"><img ng-src="assets/images/Add.png"> <span data-translate="gatewayApp.globalApprovalPolicy.globalApprovePolicy"></span></button><div class="col-md-6 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><cspl-table-export table-name="tblGlobalApprovalPolicy" total-record-count="vm.globalApprovalPolicies.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="Global_Approval_Policy"></cspl-table-export></div></div></div><div class="bootstrap-tableresponsive"><table id="tblGlobalApprovalPolicy" class="dataTable table table-striped table-hover"><thead><tr><th class="col-md-5" data-translate="gatewayApp.globalApprovalPolicy.approvalPolicyName"></th><th class="col-md-3" data-translate="gatewayApp.globalApprovalPolicy.assignedRoles"></th><th class="col-md-2" data-translate="gatewayApp.globalApprovalPolicy.actionsAssigned"></th><th class="col-md-2"></th></tr></thead><tbody><tr ng-repeat="approvalPolicy in filteredPolicies=  (vm.globalApprovalPolicies| filter: filterText)"><td>{{approvalPolicy.shortName}}</td><td><span ng-repeat="role in approvalPolicy.globalApprovalPolicyRoles" ng-init="role.appender = $index < approvalPolicy.globalApprovalPolicyRoles.length-1?\',\' :\'\'">{{ role.globalOrganisationTypeRole.name + role.appender }}</span></td><td>{{ (approvalPolicy.assignedEntityActionCount > 0) ? ("gatewayApp.globalApprovalPolicy.yes"|translate) : ("gatewayApp.globalApprovalPolicy.no"|translate) }}</td><td style="text-align:center"><div class="btn-group utility col-md-2" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ui-sref="global-approval-policy.view({id:approvalPolicy.id})" ng-click="vm.screenLog.screenLog(vm.ApprovalProcessScreen, approvalPolicy.id, vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitApprovalProcessEditEntityAction"><a ui-sref="global-approval-policy.edit({id:approvalPolicy.id})" ng-click="vm.screenLog.screenLog(vm.ApprovalProcessScreen, approvalPolicy.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></a></li><li ng-show="vm.permitApprovalProcessDeleteEntityAction"><a ui-sref="global-approval-policy.delete({id:approvalPolicy.id})" ng-click="vm.screenLog.screenLog(vm.ApprovalProcessScreen, approvalPolicy.id, vm.entityConstants.ENTITY_ACTION_TYPE.DELETE)"><span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></a></li><li ng-show="vm.permitEntityStateApprovalProcessMapEntityAction"><a ui-sref="global-approval-policy.map({id:approvalPolicy.id})" ng-click="vm.screenLog.screenLog(vm.EntityStateApprovalProcessScreen, approvalPolicy.id, vm.entityConstants.ENTITY_ACTION_TYPE.MAP)"><span class="hidden-xs hidden-sm" data-translate="gatewayApp.globalApprovalPolicy.assignUnassignAction"></span></a></li></ul></div></td></tr></tbody></table></div></section></div></div><script src="assets/js/tables.js"></script>');
$templateCache.put('app/entities/global-approval-policy/global-entity-action-approval-policy.html','<form name="entityActionApprovalPolicyForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="gatewayApp.title.assingOrUnAssignActions"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert-error></nmb-alert-error><div class="row"><fieldset><div class="row"><b>{{vm.entityActionApprovalPolicyDTO.shortName}}</b></div><div class="row"><div class="col-md-6 pull-right"><div class="col-md-12 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><cspl-table-export table-name="tblglobalEntityActionsApprovalPolicy" total-record-count="vm.entityActionApprovalPolicies.length" ignore-column="0" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="Global_Entity_Action_Approval_Policy"></cspl-table-export></div></div><div class="table-responsive col-md-12"><table id="tblglobalEntityActionsApprovalPolicy" class="dataTable table table-striped table-hover"><thead><tr><th><label class="check-control"><input id="selectAll" ng-disabled="vm.ViewDisable" class="checkbox" name="" ng-model="vm.selectAll" type="checkbox" ng-click="vm.checkOrUncheckHeaderAction($event)"> <span class="checkbox-overlay-header"></span></label></th><th data-translate="gatewayApp.globalApprovalPolicy.actions"></th><th data-translate="gatewayApp.globalApprovalPolicy.assignedApprovalPolicy"></th></tr></thead><tbody><tr ng-repeat="globalEntityActionApprovalPolicy in policies =( vm.entityActionApprovalPolicies| filter: filterText) |limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)" ng-hide="(globalEntityActionApprovalPolicy.entityActions.entity.shortName == \'UserMembership\') ? true : false"><td><input type="checkbox" class="checklist" ng-disabled="vm.ViewDisable" checklist-model="vm.selected.entityActions" checklist-value="globalEntityActionApprovalPolicy.entityActions" ng-model="justAnotherCheckedVar" ng-click="vm.checkOrUncheckAction()"></td><td>{{globalEntityActionApprovalPolicy.entityActions.shortName}}</td><td>{{globalEntityActionApprovalPolicy.globalApprovalPolicy.policyName}}</td></tr></tbody></table><div stlye=""><cspl-pagination record-count="policies.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></fieldset></div></div><div class="modal-footer"><a ng-show="vm.ShowApprovalPolicyLink" class="pull-left" ui-sref="global-entity-action-approval-policy-view({id:vm.entityActionApprovalPolicyDTO.approvalPolicyId})">{{\'gatewayApp.globalApprovalPolicy.viewMappedApprovalPolicy\'| translate}}</a> <button type="button" ng-show="showCancelButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-show="vm.btnClose" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="gatewayApp.globalApprovalPolicy.close"></span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-click="vm.clicked=true;vm.resubmitEntityActionApprovalPolicy()" ng-disabled="vm.clicked"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardEntityActionApprovalPolicy()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="vm.btnApproveReject" class="btn btn-reject" ng-click="vm.rejectEntityActionApprovalPolicy()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="vm.btnApproveReject" autofocus class="btn btn-approve" ng-click="vm.clicked=true;vm.approveEntityActionApprovalPolicy()" ng-disabled="vm.clicked"><span data-translate="entity.action.approve">Approve</span></button> <button type="submit" ng-if="showSaveButton" class="btn btn-info active" ng-click="vm.clicked=true;vm.save()" ng-disabled="entityActionApprovalPolicyForm.$pristine || vm.clicked"><span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/global-security-policy/global-security-policy-dialog.html','<form name="securityPolicyForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title">Assign Roles</h4></div><div class="modal-body"><div class="content"><nmb-alert-error></nmb-alert-error><div class="row"><fieldset ng-disabled="vm.ViewDisable"><div class="row"><b>{{vm.securityPolicyDTO.themeShortName}}</b></div><br><div class="col-md-8 col-md-offset-2"><table class="datatables-nosort table table-striped table-hover"><thead><tr><th></th><th>Role</th></tr></thead><tbody><tr ng-repeat="role in vm.roles" ng-hide="role.systemGenerated"><td>&nbsp; <input type="checkbox" checklist-model="vm.selected.orgRoleID" checklist-value="role.id" ng-model="justAnotherCheckedVar"></td><td>{{role.name}}</td></tr></tbody></table></div><br><br></fieldset></div><div class="modal-footer"><button type="button" ng-show="showCancelButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-show="vm.btnClose" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span>Close</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-click="vm.clicked=true;vm.resubmitSecurityPolicy()" ng-disabled="vm.clicked"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardSecurityPolicy()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="vm.btnApproveReject" class="btn btn-reject" ng-click="vm.rejectSecurityPolicy()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="vm.btnApproveReject" autofocus class="btn btn-approve" ng-click="vm.clicked=true;vm.approveSecurityPolicy()" ng-disabled="vm.clicked"><span data-translate="entity.action.approve">Approve</span></button> <button type="submit" ng-if="showSaveButton" class="btn btn-info active" ng-click="vm.clicked=true;vm.save()" ng-disabled="securityPolicyForm.$pristine || vm.clicked"><span data-translate="entity.action.save">Save</span></button></div></div></div></form>');
$templateCache.put('app/entities/global-security-policy/global-security-policy.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.globalSecurityPolicy.home.setupLabel">Global Security Policy</h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row col-md-12"><fieldset class="row col-md-12"><form class="-form" name="filterform"><div class="row" style="padding-top:20px"><label class="col-md-2 control-label left-align-label"><span data-translate="gatewayApp.globalSecurityPolicy.organisationType"></span></label><div class="col-md-2"><cspl-ach control-model="vm.organisationtype" control-id="txtOrganisationType" lookup-name="organisationTypeForGlobalApprovalPolicy" display-column="shortName" required></cspl-ach></div><button type="button" class="btn btn-info active" ng-disabled="vm.organisationtype==null||vm.clicked" ng-show="vm.organisationtype.shortName!=\'CUSTOMER\'" ng-click="vm.loadAll(vm.organisationtype,vm.customerusertype);vm.screenLog.screenLog(vm.screenName,0,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW);vm.clicked=true;">Go</button><label class="col-md-2 control-label left-align-label" ng-show="vm.organisationtype.shortName==\'CUSTOMER\'"><span data-translate="gatewayApp.globalSecurityPolicy.customerUserType"></span></label><div class="col-md-2" ng-show="vm.organisationtype.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.customerusertype" control-id="txtCustomerUserType" lookup-name="customerUserType" display-column="shortName" required></cspl-ach></div><button type="button" class="btn btn-info active" ng-show="vm.organisationtype.shortName==\'CUSTOMER\'" ng-disabled="vm.customerusertype==null||vm.clicked" ng-click="vm.loadAll(vm.organisationtype,vm.customerusertype);vm.screenLog.screenLog(vm.screenName,0,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW);vm.clicked=true;">Go</button></div></form></fieldset></div><div class="row"><div class="pull-right"><div class="col-md-6 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><cspl-table-export table-name="tblSecurityPolicy" total-record-count="vm.securityPolicies.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="Global_Security_Policy"></cspl-table-export></div></div><div class="table-responsive"><table id="tblSecurityPolicy" class="datatables-nosort table table-striped table-hover"><thead><tr><th><cspl-table-sort sort-type-model="sortType" default-sort="asc" sort-type-name="themeShortName" sort-reverse-model="sortReverse" header-text="\'global.globalSecurityPolicy.ThemeActions\' | translate"></th><th ng-hide="true"><cspl-table-sort sort-type-model="sortType" sort-type-name="entityOwnerTypes" sort-reverse-model="sortReverse" header-text="\'global.globalSecurityPolicy.OwnerType\' | translate"></th><th data-translate="global.securityPolicy.Roles">Can be performed by</th><th></th></tr></thead><tbody><tr ng-repeat="globalSecurityPolicy in filterData = (vm.securityPolicies | filter : filterText | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{globalSecurityPolicy.themeShortName}}</td><td ng-hide="true">{{globalSecurityPolicy.entityOwnerTypes.join(\', \')}}</td><td>{{globalSecurityPolicy.orgRoleNames.join(\', \')}}</td><td><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitSecurityPolicyMapEntityAction"><a ui-sref="global-security-policy.new({id:globalSecurityPolicy.themeID, orgTypeId: globalSecurityPolicy.orgTypeId, custUserTypeId: globalSecurityPolicy.custUserTypeId})"><span class="hidden-xs hidden-sm" data-translate="entity.action.assignRoles"></span></a></li></ul></div></td></tr></tbody></table><div stlye=""><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/gst-settings/gst-settings-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span ng-show="vm.gstSetting.id==null" data-translate="gatewayApp.gstSettings.addGSTSettings"></span> <span ng-show="vm.gstSetting.id!=null" data-translate="gatewayApp.gstSettings.editGSTSettings"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><form name="gstSettingsForm" role="form" novalidate><div class="form-group col-xs-5"><label class="control-label left-align-label" cspl-mandatory><span data-translate="gatewayApp.gstSettings.state"></span></label><cspl-ach control-model="vm.gstSetting.state" control-id="txtState" lookup-name="state" filter-value="{{vm.country.id}}" control-disabled="vm.viewMode || (vm.gstSetting.id!=null || showResubmitButton)" display-column="name" form="gstSettingsForm" control-required="true"></cspl-ach></div><div class="form-group col-xs-2"><label class="control-label left-align-label" cspl-mandatory><span data-translate="gatewayApp.gstSettings.stateCode"></span></label><cspl-numeric control-model="vm.stateCode" no-of-decimals="0" control-id="txtStateCode" form="gstSettingsForm" control-required="true" control-disabled="true"></div><table id="gstSettings" class="dataTable table table-striped"><thead><tr><th class="td-text-align-right" data-translate="gatewayApp.gstSettings.cgst"></th><th class="td-text-align-right" data-translate="gatewayApp.gstSettings.sgst"></th><th class="td-text-align-right" data-translate="gatewayApp.gstSettings.igst"></th><th class="td-text-align-right" data-translate="gatewayApp.gstSettings.utgst"></th></tr></thead><tr><td><cspl-numeric control-model="vm.gstSetting.cgst" control-id="cgst" control-type="Number" no-of-decimals="{{vm.decimalsForPercent}}" control-max="100" autocomplete="" control-min="0" form="gstSettingsForm" control-disabled="vm.viewMode" class="td-text-align-right"></cspl-numeric></td><td><cspl-numeric control-model="vm.gstSetting.sgst" control-id="sgst" control-type="Number" no-of-decimals="{{vm.decimalsForPercent}}" control-max="100" autocomplete="" control-min="0" form="gstSettingsForm" control-disabled="vm.viewMode" class="td-text-align-right"></cspl-numeric></td><td><cspl-numeric control-model="vm.gstSetting.igst" control-id="igst" control-type="Number" no-of-decimals="{{vm.decimalsForPercent}}" control-max="100" autocomplete="" control-min="0" form="gstSettingsForm" control-disabled="vm.viewMode" class="td-text-align-right"></cspl-numeric></td><td><cspl-numeric control-model="vm.gstSetting.utgst" control-id="utgst" control-type="Number" no-of-decimals="{{vm.decimalsForPercent}}" control-max="100" autocomplete="" control-min="0" form="gstSettingsForm" control-disabled="vm.viewMode" class="td-text-align-right"></cspl-numeric></td></tr></table><div class="row"><span class="help-block right-floating" data-translate="gatewayApp.gstSettings.legend"></span></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="gstSettingsForm.$invalid || vm.clicked" ng-click="vm.resubmitGSTSettings();vm.clicked = true;"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="gstSettingsForm.$invalid  || vm.clicked" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardGSTSettings()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectGSTSettings()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" autofocus class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveGSTSettings();vm.clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div></form></div></div>');
$templateCache.put('app/entities/gst-settings/gst-settings.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.gstSettings.title"></span></h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="float-right"><button type="button" class="btn btn-info active" ng-click="vm.screenLog.screenLog(vm.screenName,0,vm.entityConstants.ENTITY_ACTION_TYPE.ADD);vm.launch()" ng-show="vm.permitGSTSettingsAddEntityAction"><img ng-src="assets/images/Add.png"> <span data-translate="gatewayApp.gstSettings.gst"></span></button></div><div class="float-right col-xs-10 col-sm-3 col-md-2"><cspl-table-search control-model="filterText"></cspl-table-search></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="gstSettings" total-record-count="vm.gstSettings.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="GST_Settings"></cspl-table-export></div><div class="pull-left" style="margin-left: 0px" ng-show="vm.permitGSTSettingsImportEntityAction"><cspl-table-import upload-type="GSTSettingsImport" file-content=""></cspl-table-import></div></div><div class="bootstrap-tableresponsive"><table id="gstSettings" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.gstSettings.state">State</th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.gstSettings.cgst">CGST</th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.gstSettings.sgst">SGST</th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.gstSettings.igst">IGST</th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.gstSettings.utgst">UTGST</th><th></th></tr></thead><tbody><tr ng-repeat="gstSettings in filterData = (vm.gstSettings | filter : filterText | orderBy: \'state.name\')| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{gstSettings.state.name}}</td><td class="td-text-align-right noPaddingLeftRight">{{gstSettings.cgst | number : vm.decimalsForPercent}}</td><td class="td-text-align-right noPaddingLeftRight">{{gstSettings.sgst | number : vm.decimalsForPercent}}</td><td class="td-text-align-right noPaddingLeftRight">{{gstSettings.igst | number : vm.decimalsForPercent}}</td><td class="td-text-align-right noPaddingLeftRight">{{gstSettings.utgst | number : vm.decimalsForPercent}}</td><td width="10%" style="text-align:right"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitGSTSettingsEditEntityAction"><a ui-sref="gst-settings-edit({id:gstSettings.id})" ng-click="vm.screenLog.screenLog(vm.screenName, gstSettings.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table><div style="padding:5px" ng-show="vm.gstSettings.length==0"><span>No record found</span></div><div ng-show="vm.gstSettings.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/he-connectivity-settings/he-connectivity-settings-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="heConnectivityEditForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span ng-show="vm.viewMode==false" data-translate="global.menu.heConnectivitySettings.editHeConnectivitySettings"></span> <span ng-show="vm.viewMode==true" data-translate="global.menu.heConnectivitySettings.viewHeConnectivitySettings"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset><br><div class="col-sm-6 col-centered"><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.heConnectivity.luddNumber"></span></label><cspl-text control-model="vm.connectivitySettings.luddNumber" control-id="txtLuddNumber" control-type="Number" control-disabled="vm.viewMode" control-minlength="5" control-maxlength="5" placeholder="" form="heConnectivityEditForm" required></div><!-- <div class="form-group">\r\n\t\t\t\t\t\t<label class="control-label"  cspl-mandatory><span data-translate="gatewayApp.heConnectivity.luddPassword" ></span></label>\r\n\t\t\t\t\t<cspl-text control-model="vm.connectivitySettings.luddPassword"\r\n\t\t\t\t\t\t\t\t\tcontrol-id="txtLuddPassword"  control-disabled="vm.viewMode"\r\n\t\t\t\t\t\t\t\t\tcontrol-minlength="4" control-maxlength="50" placeholder=""\r\n\t\t\t\t\t\t\t\t\tform="heConnectivityEditForm"\r\n\t\t\t\t\t\t\t\t\trequired />\r\n\t\t\t\t\t\r\n\t\t\t\t</div>\t --><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.heConnectivity.retailMemberNumber"></span></label><cspl-text control-model="vm.connectivitySettings.retailMemberNumber" control-id="txtRetailMemberNumber" control-type="Number" control-disabled="vm.viewMode" control-minlength="5" control-maxlength="5" placeholder="" form="heConnectivityEditForm" required></div><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.heConnectivity.retailUserNumber"></span></label><cspl-text control-model="vm.connectivitySettings.retailUserNumber" control-id="txtLuddNumber" control-type="Number" control-disabled="vm.viewMode" control-minlength="5" control-maxlength="5" placeholder="" form="heConnectivityEditForm" required></div><!-- <div class="form-group">\r\n\t\t\t\t\t\t<label class="control-label"  cspl-mandatory><span data-translate="gatewayApp.heConnectivity.retailUserPassword" ></span></label>\r\n\t\t\t\t\t <cspl-text control-model="vm.connectivitySettings.retailUserPassword"\r\n\t\t\t\t\t\t\t\t\tcontrol-id="txtRetailUserPassword"  control-disabled="vm.viewMode"\r\n\t\t\t\t\t\t\t\t\tcontrol-minlength="4" control-maxlength="50" placeholder=""\r\n\t\t\t\t\t\t\t\t\tform="heConnectivityEditForm"\r\n\t\t\t\t\t\t\t\t\trequired />\r\n\t\t\t\t\t\r\n\t\t\t\t</div>\t --><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.heConnectivity.tcpipAddress"></span></label><cspl-text control-model="vm.connectivitySettings.tcpIpAddress" control-id="txttcpipAddres" control-disabled="vm.viewMode" control-maxlength="15" placeholder="" control-type="IPAddress" form="heConnectivityEditForm" required></div><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.heConnectivity.applicationVersionNumber"></span></label><cspl-text control-model="vm.connectivitySettings.applicationVersionNumber" control-id="txtApplicationVersionNumber" control-disabled="vm.viewMode" placeholder="" control-type="IPAddress" control-maxlength="100" form="heConnectivityEditForm" required></div><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.heConnectivity.userApplicationVersionNumber"></span></label><cspl-text control-model="vm.connectivitySettings.userApplicationVersionNumber" control-id="txtUserApplicationVersionNumber" control-disabled="vm.viewMode" placeholder="" control-type="IPAddress" control-maxlength="100" form="heConnectivityEditForm" required></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="heConnectivityEditForm.$invalid || vm.clicked" ng-click="vm.resubmitConnectivity();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="heConnectivityEditForm.$invalid|| ( vm.connectivitySettings.id!=null && !heConnectivityEditForm.$dirty)   || vm.clicked" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardConnectivity()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectConnectivity()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" autofocus class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveConnectivity();vm.clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/he-connectivity-settings/he-connectivity-settings.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.heConnectivitySettings.manageHeConnectivitySettings">Manage HE Connectivity Settings</h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="float-right col-xs-10 col-sm-3 col-md-2"><cspl-table-search control-model="filterText"></cspl-table-search></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="heConnectivitySettings" total-record-count="vm.connectivitySettings.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="HE_Connectivity_Settings"></cspl-table-export></div></div><div class="bootstrap-tableresponsive"><table id="heConnectivitySettings" class="dataTable table table-striped table-hover"><thead><tr><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.heConnectivity.luddNumber"></th><!-- <th data-translate="gatewayApp.heConnectivity.luddPassword"></th> --><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.heConnectivity.retailMemberNumber"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.heConnectivity.retailUserNumber"></th><!-- <th data-translate="gatewayApp.heConnectivity.retailUserPassword"></th> --><th data-translate="gatewayApp.heConnectivity.tcpipAddress"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.heConnectivity.applicationVersionNumber"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.heConnectivity.userApplicationVersionNumber"></th><th></th></tr></thead><tbody><tr ng-repeat="connectivity in filterData = (vm.connectivitySettings | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td class="td-text-align-right noPaddingLeftRight">{{connectivity.luddNumber}}</td><!-- <td >{{connectivity.luddPassword}}</td> --><td class="td-text-align-right noPaddingLeftRight">{{connectivity.retailMemberNumber}}</td><td class="td-text-align-right noPaddingLeftRight">{{connectivity.retailUserNumber}}</td><!-- <td >{{connectivity.retailUserPassword}}</td> --><td>{{connectivity.tcpIpAddress}}</td><td style="word-wrap:break-word" class="td-text-align-right noPaddingLeftRight">{{connectivity.applicationVersionNumber}}</td><td style="word-wrap:break-word" class="td-text-align-right noPaddingLeftRight">{{connectivity.userApplicationVersionNumber}}</td><td style="text-align:center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ui-sref="he-connectivity-edit({id:connectivity.id})" ng-click="vm.screenLog.screenLog(vm.screenName, connectivity.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/he-status-update/he-status-update.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.heStatusUpdate.title">HE Status Update</h2><nmb-alert></nmb-alert><div></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="HEStatusUpdate"><form class="" role="form" name="HEStatusUpdateForm"><br><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.heStatusUpdate.heInteractiveStatusChange"></span></label><cspl-text control-model="vm.changedStatus" control-id="txtChangedStatus" control-disabled="true" form="HEStatusUpdateForm" required></div></div><div class="form-group"><div class="row"><label class="col-md-offset-3 control-label col-xs-6 col-md-6" cspl-mandatory><span data-translate="gatewayApp.heStatusUpdate.currentStatus"></span></label><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><cspl-text control-model="vm.currentStatus" control-id="txtCurrentStatus" control-disabled="true" form="HEStatusUpdateForm" required></div><div class="col-md-1 col-sm-1"><button class="btn btn-info active" ng-disabled="HEStatusUpdateForm.$invalid" ng-click="vm.sendHEStatusUpdate();vm.screenLog.screenLog(vm.screenName, 1, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)" data-translate="gatewayApp.heStatusUpdate.go"></button></div></div></div></form></div><div style="text-align:center" ng-show="vm.heStatusUpdate==\'PROGRESS\'"><img class="ProgressStatusImage" src="assets/images/Progress_bar.GIF"></div><div style="text-align:center" ng-show="vm.heStatusUpdate==\'SUCCESS\'"><img class="statusImage" src="assets/images/EOD_Process_Success.png"></div><div style="text-align:center" ng-show="vm.heStatusUpdate==\'FAILURE\'"><img class="statusImage" src="assets/images/EOD_Process_Error.png"></div></div></section></div></div>');
$templateCache.put('app/entities/history-report/history-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.HistoryReport.manageHistoryReport"></span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><form name="historyReportForm" role="form" novalidate><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px;  margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseHistoryReport = !vm.ExpandOrCollapseHistoryReport" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#HistoryReport"><img ng-src="{{vm.ExpandOrCollapseHistoryReport == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.HistoryReport.criteria">Criteria</span></a></h4></div><div id="HistoryReport" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><div class="row"><cspl-entity-lookup user-entity-owner-type="vm.userEntityOwnerType" selected-entity-owner-type="vm.selectedEntityOwnerType" bank-value="vm.bankValue" branch-value="vm.branchValue" customer-value="vm.customerValue" user-value="vm.userValue" user-list-value="vm.userListValue" control-class="col-md-3 col-md-offset-3" control-form="historyReportForm"></cspl-entity-lookup></div><div class="row"><label class="col-md-offset-3 col-md-3 control-label"><span data-translate="gatewayApp.HistoryReport.screenName"></span></label></div><div class="row"><div class="col-md-offset-3 col-md-3"><cspl-ach control-model="vm.screenName" control-id="txtScreenName" lookup-name="entity" filter-value="{{vm.selectedEntityOwnerType}}" display-column="name" form="historyReportForm"></cspl-ach></div></div><!-- <div class="row">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<label class="col-md-offset-3 col-md-3 control-label"  cspl-mandatory>\r\n\t\t\t\t\t\t\t\t\t\t<span data-translate="gatewayApp.HistoryReport.fromDate"></span>\r\n\t\t\t\t\t\t\t\t\t</label> \r\n\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<label class="col-md-3 control-label"  cspl-mandatory>\r\n\t\t\t\t\t\t\t\t\t\t<span data-translate="gatewayApp.HistoryReport.toDate"></span>\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t</div>\t\t\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-3 col-md-offset-3">\r\n\t\t\t\t\t\t\t\t\t\t<cspl-dtp control-model = "vm.fromDate" control-id="dtpFromDate"  form="historyReportForm" required/>\r\n\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-3  ">\r\n\t\t\t\t\t\t\t\t\t\t<cspl-dtp control-model = "vm.toDate" control-id="dtpToDate" form="historyReportForm" required/>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<button class=" btn btn-info active"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="historyReportForm.$invalid" data-toggle="collapse" data-target="#HistoryReport"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.getHistoryReport();" \r\n\t\t\t\t\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.HistoryReport.go">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> --><div class="col-sm-6 col-centered" style="margin-top: 10px"><div class="col-md-12" style="padding-left: 0"><div class="col-md-2" style="padding-left: 0; margin-top: 10px"><input type="radio" name="optradio" id="radio1" ng-model="vm.historicalOrCurrent" style="margin-right: 5px" value="Historical" form="historyReportForm"><label style="color: #FFFFFF" for="radio1" data-translate="gatewayApp.HistoryReport.historical"></label></div><div class="col-md-5"><cspl-dtp control-model="vm.fromDate" control-id="dtpFromDate" form="historyReportForm" control-required="vm.historicalOrCurrent != \'Current\'" control-disabled="vm.historicalOrCurrent == \'Current\'" control-max-date="vm.yesterdayDate"></div><div class="col-md-5"><cspl-dtp control-model="vm.toDate" control-id="dtpToDate" form="historyReportForm" control-required="vm.historicalOrCurrent != \'Current\'" control-disabled="vm.historicalOrCurrent == \'Current\'" control-max-date="vm.yesterdayDate"></div></div><div class="col-md-12" style="padding-left: 0"><div class="col-md-2" style="padding-left: 0; margin-top: 10px; padding-right: 0"><input type="radio" name="optradio" id="radio2" ng-model="vm.historicalOrCurrent" style="margin-right: 5px" value="Current" form="historyReportForm"><label style="color: #FFFFFF" for="radio2" data-translate="gatewayApp.HistoryReport.forToday"></label></div><div class="col-md-5" style="margin-top: 10px"><label class="control-label"><span>{{vm.reportDate\t| date : \'dd-MMM-yyyy\'}}</span></label></div></div><div class="col-md-12" style="padding-left: 0"><div class="col-md-2" style="padding-left: 0"></div><div class="col-md-5"></div><div class="col-md-5"><button class="btn btn-info active" ng-disabled="historyReportForm.$invalid||vm.clicked" ng-click="vm.getHistoryReport();" style="float: right; margin-top:0px" data-translate="entity.action.go" data-toggle="collapse" data-target="#HistoryReport"></button></div></div></div></div></div></div></form><div ng-show="vm.historyReportDetails.length > 0"><div class="row"><div class="pull-right"><div class="col-md-6 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><cspl-table-export table-name="HistoryReportDetails" total-record-count="vm.historyReportDetails.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="History_Report"></cspl-table-export></div></div><div class="table-responsive"><table id="HistoryReportDetails" class="datatables-nosort table table-striped table-hover"><thead><tr><th style="padding-left:20px"><cspl-table-sort sort-type-model="sortType" default-sort="asc" sort-type-name="actionDateTime" sort-reverse-model="sortReverse" header-text="\'gatewayApp.HistoryReport.dateTime\'|translate"></th><th data-translate="gatewayApp.HistoryReport.loginName"></th><th data-translate="gatewayApp.HistoryReport.screen"></th><th data-translate="gatewayApp.HistoryReport.action"></th><th data-translate="gatewayApp.HistoryReport.previousValue"></th><th data-translate="gatewayApp.HistoryReport.currentValue"></th></tr></thead><tbody><tr ng-repeat="historyReportDetail in filterData = (vm.historyReportDetails | filter : filterText | orderBy  : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="padding-left:20px">{{historyReportDetail.actionDateTime|date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td>{{historyReportDetail.login}}</td><td>{{historyReportDetail.entityName}}</td><td>{{historyReportDetail.actionName}}</td><td><a ng-if="historyReportDetail.previousValue!=\'\'" ng-click="vm.Values(historyReportDetail.entityShortName,historyReportDetail.previousValue,historyReportDetail.actionName)"><span data-translate="gatewayApp.HistoryReport.previousValue"></span></a></td><td><a ng-if="historyReportDetail.currentValue!=\'\'" ng-click="vm.Values(historyReportDetail.entityShortName,historyReportDetail.currentValue,historyReportDetail.actionName)"><span data-translate="gatewayApp.HistoryReport.currentValue"></span></a></td></tr></tbody></table></div></div><div class="table-responsive" ng-show="vm.historyReportDetails.length==0"><span>No record found</span></div><div ng-show="vm.historyReportDetails.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></section></div></div>');
$templateCache.put('app/entities/holiday-report/holiday-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.holidayReport.title">Holiday View</h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px;  margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseHolidayReport = !vm.ExpandOrCollapseHolidayReport" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#HolidayReport"><img ng-src="{{vm.ExpandOrCollapseHolidayReport == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.holidayReport.criteria">Criteria</span></a></h4></div><div id="HolidayReport" class="collapse in" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="holidayReportForm"><div class="col-md-offset-3 col-md-6 col-sm-6 col-xs-10 col-lg-4"><div class="col-md-12"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.holidayReport.year"></span></label></div><div class="col-md-3" style="margin-bottom:4px;padding-bottom:6px"><select class="form-control select-style select-notRequired" name="holidayReport" ng-model="vm.selectedYear" id="HolidayReportYear" ng-options="holidayDate for holidayDate in vm.yearsList track by holidayDate" ng-change="vm.changedYear()" form="holidayReportForm" required></select></div><div class="col-md-1"><input type="checkbox" name="checkbox" id="checkbox1" class="checkbox" ng-disabled="!vm.enableShowFuture" ng-model="vm.selectedCurrentYear" value="group" form="holidayReportForm" style="margin-top: 13px"></div><div class="col-md-5-5" style="padding-bottom: 0px;margin-bottom: 0px;padding-left: 0px;padding-top: 8px;vertical-align: baseline"><label class="control-label" for="checkbox1"><span data-translate="gatewayApp.holidayReport.showFutureDates"></span></label></div><div class="col-md-12"><label class="control-label"><span data-translate="gatewayApp.holidayReport.holidayType"></span></label></div><div class="col-md-5" style="margin-bottom:10px"><select class="form-control select-style select-notRequired" name="holidayReport" ng-model="vm.selectedHolidayType" id="HolidayReportHolidayType" form="holidayReportForm" required><!-- ng-options="holidayType for holidayDate in vm.allHolidayType" form="holidayReportForm"  required> --><option>All</option><option>Trading</option><option>Settlement</option></select></div><div class="col-md-12"><label class="control-label"><span data-translate="gatewayApp.holidayReport.currency"></span></label></div><!-- <div class="col-md-12" >\r\n\t\t\t\t\t        \t <div id="btnGroup" class="col-md-8" style="border-radius:5px;padding-left:0 !important">\r\n\t\t\t\t\t\t\t\t<div class="btn-group noPaddingMargin">\r\n\t\t\t\t\t\t\t\t\t<label class="btn btn-primary holidayBtn active" ng-model="vm.selectedCurrency"  style="border-radius:4px"\r\n\t\t\t\t\t\t\t\t\t\t uib-btn-radio="\'ALL\'">ALL</label>\r\n\t\t\t\t\t\t\t\t\t<label class="btn btn-primary holidayBtn active" ng-model="vm.selectedCurrency"  style="border-radius:4px"\r\n\t\t\t\t\t\t\t\t\t\t uib-btn-radio="\'INR\'">INR\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t<label class="btn btn-primary holidayBtn active" ng-model="vm.selectedCurrency"  style="border-radius:4px"\r\n\t\t\t\t\t\t\t\t\t\t uib-btn-radio="\'USD\'">USD\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div> --><div class="col-md-3" style="margin-bottom:4px;padding-bottom:6px"><select class="form-control select-style select-notRequired" control-id="selccy" id="HolidayReportCurrency" ng-model="vm.currencyCode" ng-options="x.code for x in vm.currencies track by x.code" form="holidayReportForm"></select></div><div class="col-md-1"></div><div class="col-md-2"><button style="float:right" class="btn btn-info active" ng-disabled="holidayReportForm.$invalid||vm.clicked" ng-click="vm.getHolidayData();vm.clicked=true;" data-toggle="collapse" data-translate="gatewayApp.holidayReport.Go"></button></div></div></form></div></div></div></div><div ng-show="vm.holidayData.length > 0"><div class="row"><div class="dropdown col-md-3" style="width:10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border:none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div><cspl-table-search control-model="vm.filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="holidayData" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.holidayReport.currency"></th><th data-translate="gatewayApp.holidayReport.holidayDate"></th><th data-translate="gatewayApp.holidayReport.description"></th><th data-translate="gatewayApp.holidayReport.holidayType"></th></tr></thead><tbody><tr ng-repeat="individualHolidayData in vm.filterData = (vm.holidayData | filter : vm.filterText | orderBy : \'-createdDateTime\')| \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tlimitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)" ng-class="{\'coloredRow\':\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t (page-1)*noOfRecordsPerPage +$index ==0 && vm.isRegenerated}"><td>{{individualHolidayData.currency.code}}</td><td>{{individualHolidayData.holidayDate|date:\'dd-MMM-yyyy\'}}</td><td>{{individualHolidayData.description}}</td><td>{{individualHolidayData.holidayType.shortName}}</td></tr></tbody></table></div><div ng-show="vm.holidayData.length > 0"><cspl-pagination record-count="vm.filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></section></div><div class="table-responsive" ng-show="vm.holidayData.length==0"><span>No record found</span></div></div><script src="assets/js/tables.js"></script>');
$templateCache.put('app/entities/home-branch-filter/home-branch-filter.html','<form name="homeBranchFilter" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="global.menu.homeBranchFilter.title"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset><div class="col-sm-8 col-sm-offset-2"><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="global.menu.homeBranchFilter.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="homeBranch" filter-value="{{vm.filterText}}" display-column="ifscCode,branchName,bankName" form="homeBranchFilter" required></cspl-ach></div></div></fieldset></div></div></form>');
$templateCache.put('app/entities/home-branch-ifsc-upload/home-branch-ifsc-upload.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="gatewayApp.homeBranchIfscUpload.home.title"></span></h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><form class="form" name="uploadForm" role="form"><div class="form-group col-md-12 col-sm-12 col-xs-12" style="margin-top:2%"><label class="control-label left-align-label col-md-2 col-sm-2 col-xs-3" cspl-mandatory><span data-translate="gatewayApp.homeBranchIfscUpload.filePath"></span></label><div class="col-md-3 col-sm-5 col-xs-7"><div class="input-group"><input type="text" form="uploadForm" class="form-control fileOpen" ng-model="vm.inputFileName" ng-blur="vm.checkInputData=true;" readonly="readonly" required><label for="uploadFile" class="btn btn-primary fileUploadDark" class="block-upload"><img src="assets/images/Open Path-26.png" style="height:20px;padding-bottom:2px;pointer-events:none" form="uploadForm"></label><input type="file" id="uploadFile" name="uploadFile" fileread="vm.uploadedIfscData" accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" form="uploadForm" ng-hide="true" ng-blur="vm.checkInputData=true;"></div><!--<div    style = "display:table;padding-top: 5px;width:100%" >\r\n\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t<input form="uploadForm"  style = "display:table-cell" type="text" class="fileUploadFormControl" ng-model="vm.inputFileName" ng-class="{ \'#FF3737\': vm.checkInputData && (vm.inputFileName==null || vm.inputFileName==undefined)}"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-blur="vm.checkInputData=true;" readonly required>\r\n\t\t\t\t\t\t\t\t\t\t<label  style = "display:table-cell" for="uploadFile" class="  fileUploadBlack">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="assets/images/Open path-24.png" style="pointer-events:none" form="uploadForm" >\r\n\t\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t    \t\t\t\t\t\t<input  type="file" id="uploadFile" name="uploadFile" fileread="vm.uploadedIfscData" accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" \r\n\t\t\t    \t\t\t\t\t\t\tng-class="{ \'#FF3737\': vm.checkInputData && (vm.inputFileName==null || vm.inputFileName==undefined)}" ng-hide="true" form="uploadForm" ng-blur="vm.checkInputData=true;"  required/>\r\n\t\t\t\t\t\t\t\t\t \r\n\t\t\t\t\t\t\t\t\t</div>--><div style="width:100%;padding-right: 8px"><span class="help-block left-floating ng-scope" data-translate="gatewayApp.homeBranchIfscUpload.fileFormatText"></span><br><span class="help-block left-floating ng-scope" data-translate="gatewayApp.homeBranchIfscUpload.fileSizeText"></span></div><br><!-- <div style="width:100%;padding-top:10px;text-align: center;" ng-show="homebranchUploadInProgress == true">\r\n\t\t\t\t\t\t\t\t\t<span\t\tdata-translate="gatewayApp.homeBranchIfscUpload.inProgress">\t</span>\r\n\t\t\t\t\t\t\t\t\t <br /> <img class="ProgressStatusImage"src="assets/images/Progress_bar.GIF" />\r\n\t\t\t\t\t\t\t\t\t</div> --></div><div class="col-md-3 col-sm-1 col-xs-1"><!-- || vm.clicked  --> <button type="submit" class="btn btn-primary" form="uploadForm" ng-disabled="uploadForm.$invalid || homebranchUploadInProgress == true" ng-click="vm.clicked = true;vm.uploadFile();" data-translate="gatewayApp.homeBranchIfscUpload.upload"></button></div></div><div class="form-group col-md-12 col-sm-12 col-xs-12" style="margin-top:2%"><div style="width:100%;padding-left: 9.7%"><span class="component-label left-align-label" data-translate="gatewayApp.homeBranchIfscUpload.generateFileFormat"></span> <a ng-click="vm.generateTemplate()" href="" id="downloadTemplate" form="uploadForm" autofocus><span class="" data-translate="gatewayApp.homeBranchIfscUpload.clickHere"></span></a></div></div></form></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/home-page-reports/home-page-reports-view.html','<div class="market-depth report"><!-- Nav tabs --><h3></h3><ul class="market-depth-tab nav nav-tabs" role="tablist" style="float: left; margin-top: -6px"><li role="presentation" class="statistics-tab" ng-class="{\'active\': vm.reportTab==\'PendingOrders\'}"><a ng-click="vm.reportTab=\'PendingOrders\'" href="#PendingOrders" aria-controls="PendingOrders" role="tab" data-toggle="tab">Pending Orders<span>({{ (pendingOrders || []).length }})</span></a></li><li role="presentation" ng-class="{\'active\': vm.reportTab==\'Trades\'}"><a ng-click="vm.reportTab=\'Trades\'" href="#Trades" aria-controls="Trades" role="tab" data-toggle="tab">Trades <span>({{ (trades || []).length }})</span></a></li><li role="presentation" ng-class="{\'active\': vm.reportTab==\'OutstandingTrades\'}"><a href="#OutstandingTrades" ng-click="vm.reportTab=\'OutstandingTrades\'" aria-controls="OutstandingTrades" role="tab" data-toggle="tab">Outstanding Trades<span>({{ ((outstandingTrades|| []) | filter:{currencyPair:vm.currencyPairForTrade.code}).length }})</span></a></li><li style="margin-right:5px" role="presentation" ng-class="{\'active\': vm.reportTab==\'Limits\'}"><a href="#Limits" ng-click="vm.reportTab=\'Limits\'" aria-controls="Limits" role="tab" data-toggle="tab">Limits</a></li><!-- <li  ng-if="account.organisation.organisationType.shortName==\'CUSTOMER\'" role="presentation" ng-class="{\'active\': vm.reportTab==\'markup\'}">\r\n         <a href="#markup" ng-click="vm.reportTab=\'markup\'"\r\n         aria-controls="markup" role="tab" data-toggle="tab">markup</a></li> --><li role="presentation" class="statistics-tab" ng-class="{\'active\': vm.reportTab==\'markup_tab\'}" ng-show="vm.account.organisation.organisationType.shortName == \'CUSTOMER\'"><a href="#markup_tab" aria-controls="markup_tab" role="tab" ng-click="vm.reportTab=\'markup_tab\'" data-toggle="tab"><span class="icon-tab-head">Markup</span></a></li></ul><div class="bcq-head" ng-show="vm.showExpandIcon"><div class="bcq-head-icons"><ul class="nav nav-tabs"><li><a data-toggle="tab" class="bcq-icon3" title="Expand view" ng-click="vm.expandReports()"></a></li></ul></div></div><!-- Tab panes --><div class="market-depth-contents tab-content"><div role="tabpanel" class="tab-pane" ng-class="{active: vm.reportTab==\'PendingOrders\'}" id="PendingOrders"><div class="bot-right-header-wrapper"><div class="row"><div class="col-sm-9"><div class="nav-tab-bot-header-left"><div ng-class="{clearcorp: account.entityOwnerType.shortName==\'Clearcorp\'}"><div class="up-btn"><cspl-table-export table-name="tblPendingOrders" total-record-count="pendingOrders.length" no-of-records-per-page="vm.noOfRecordsPerPageOP" filter-text="filterText" page-no="vm.pageOP" file-name="Pending_Orders_{{vm.custCode}}_{{vm.bankFilterForPO.bankName}}" ignore-column="[0]"></cspl-table-export></div><div class="search-box order-entry-branch" ng-if="account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.bankFilterForPO" control-id="txtbankFilterForPO" lookup-name="tradingBank" filter-value="{{account.organisation.id}}" display-column="bankName" form="frmtradinghomepage" control-place-holder="Enter bank name"></cspl-ach></div><div class="search-box order-entry-branch" ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.bankFilterForPO" control-id="txtbankFilterForPO" lookup-name="bank" control-place-holder="Enter bank name" display-column="bankName" form="frmtradinghomepage" control-required="account.organisation.organisationType.shortName==\'CLEARCORP\'"></cspl-ach></div><div class="search-box order-entry-branch" ng-if="account.entityOwnerType.shortName==\'Clearcorp\'"><cspl-ach control-model="vm.branchFilterForPO" control-id="txtbranchFilterForPO" lookup-name="validStatusBranchesForBank" filter-value="{{vm.bankFilterForPO.id}}" control-place-holder="Enter Branch ID or Name" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForPO!=null && vm.branchFilterForPO!=undefined" title="{{vm.branchFilterForPO.branchName}}">{{vm.branchFilterForPO.branchName}}</span></div><!-- <div class="search-box order-entry-branch"\r\n                           ng-if="account.entityOwnerType.shortName==\'Clearcorp\' && vm.bankFilterForPO==null">\r\n                           <cspl-ach control-model="vm.branchFilterForPO"\r\n                              control-id="txtbranchFilterForPO" lookup-name="allBranches"\r\n                              control-place-holder="Enter Branch ID or Name"\r\n                              display-column="branchId,branchName"\r\n                              form="frmtradinghomepage"></cspl-ach>\r\n                           <span class="help-block"\r\n                              ng-show="vm.branchFilterForPO!=null && vm.branchFilterForPO!=undefined"\r\n                              title="{{vm.branchFilterForPO.branchName}}">{{vm.branchFilterForPO.branchName}}</span>\r\n                        </div> --><div class="search-box order-entry-branch" ng-if="account.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.branchFilterForPO" control-place-holder="Enter Branch ID or Name" control-id="txtbranchFilterForPO" lookup-name="validStatusBranchesForBank" filter-value="{{account.organisation.id}}" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForPO!=null && vm.branchFilterForPO!=undefined" title="{{vm.branchFilterForPO.branchName}}">{{vm.branchFilterForPO.branchName}}</span></div><div class="search-box" ng-if="account.organisation.organisationType.shortName==\'BANK\'"><cspl-ach control-model="vm.customerFilterForPO" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForPO" lookup-name="customer" filter-value="{{vm.bankFilterForPO.id}}~~{{vm.branchFilterForPO.id}}~~{{0}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForPO!=null && vm.customerFilterForPO!=undefined" title="{{vm.customerFilterForPO.customerName}}">{{vm.customerFilterForPO.customerName}}</span></div><div class="search-box" ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.customerFilterForPO" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForPO" lookup-name="customer" filter-value="{{vm.bankFilterForPO.id}}~~{{vm.branchFilterForPO.id}}~~{{0}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForPO!=null && vm.customerFilterForPO!=undefined" title="{{vm.customerFilterForPO.customerName}}">{{vm.customerFilterForPO.customerName}}</span></div><div class="search-box" style="width: 110px"><cspl-ach control-model="vm.currencyPairForPO" control-place-holder="Enter Currency Pair" control-id="txtcurrencyPairForPO" lookup-name="currencyPair" filter-value="{{ vm.bankFilterForPO.id ? vm.bankFilterForPO.id : 0 }}" display-column="code" form="frmtradinghomepage"></cspl-ach><!-- <span class="help-block"\r\n                              ng-show="vm.customerFilterForPO!=null && vm.customerFilterForPO!=undefined"\r\n                              title="{{vm.customerFilterForPO.customerName}}">{{vm.customerFilterForPO.customerName}}</span> --></div><!-- <div class="search-box"\r\n                           ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForPO==null && vm.bankFilterForPO!=null">\r\n                           <cspl-ach control-model="vm.customerFilterForPO"\r\n                              control-place-holder="Enter Customer ID or Name"\r\n                              control-id="txtcustomerFilterForPO"\r\n                              lookup-name="customersForBank"\r\n                              filter-value="{{vm.bankFilterForPO.id}}"\r\n                              display-column="customerCode,customerName"\r\n                              form="frmtradinghomepage"></cspl-ach>\r\n                           <span class="help-block"\r\n                              ng-show="vm.customerFilterForPO!=null && vm.customerFilterForPO!=undefined"\r\n                              title="{{vm.customerFilterForPO.customerName}}">{{vm.customerFilterForPO.customerName}}</span>\r\n                        </div> --> <!-- <div class="search-box"\r\n                           ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForPO==null && vm.bankFilterForPO==null">\r\n                           <cspl-ach control-model="vm.customerFilterForPO"\r\n                              control-place-holder="Enter Customer ID or Name"\r\n                              control-id="txtcustomerFilterForPO"\r\n                              lookup-name="AllCustomers"\r\n                              display-column="customerCode,customerName"\r\n                              form="frmtradinghomepage"></cspl-ach>\r\n                           <span class="help-block"\r\n                              ng-show="vm.customerFilterForPO!=null && vm.customerFilterForPO!=undefined"\r\n                              title="{{vm.customerFilterForPO.customerName}}">{{vm.customerFilterForPO.customerName}}</span>\r\n                        </div> --> <!-- <div class="search-box"\r\n                           ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForPO!=null && vm.bankFilterForPO==null">\r\n                           <cspl-ach control-model="vm.customerFilterForPO"\r\n                              control-place-holder="Enter Customer ID or Name"\r\n                              control-id="txtcustomerFilterForPO"\r\n                              lookup-name="customersForBranch"\r\n                              filter-value="{{vm.branchFilterForPO.id}}"\r\n                              display-column="customerCode,customerName"\r\n                              form="frmtradinghomepage"></cspl-ach>\r\n                           <span class="help-block"\r\n                              ng-show="vm.customerFilterForPO!=null && vm.customerFilterForPO!=undefined"\r\n                              title="{{vm.customerFilterForPO.customerName}}">{{vm.customerFilterForPO.customerName}}</span>\r\n                        </div> --><div class="select-box"><select name="select" class="select-opt" aria-label="Filter by Instrument" ng-model="vm.instrumentFilterForPO" ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id"><option value="">--All--</option></select></div><div class="go-btn"><span ng-if="account.organisation.organisationType.shortName!=\'CLEARCORP\'"><button type="button" ng-disabled="vm.clickedReport" class="btn btn-go" ng-click="vm.getPendingOrdersReport();">GO</button></span> <span ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\'"><button type="button" ng-disabled="vm.bankFilterForPO==null||vm.clickedReport" class="btn btn-go" ng-click="vm.getPendingOrdersReport();">GO</button></span></div></div></div></div><div class="col-sm-3"><div class="nav-tab-bot-header-right text-right"><div class="search-field"><cspl-table-search control-model="filterTextForPO"></cspl-table-search></div></div></div></div><!-- row ends --></div><div class="bot-right-table"><div class="table-responsive"><table id="tblPendingOrders" class="table table-striped"><thead class="freeze-thead"><tr><th style="margin-top: 3px" class="freeze-column-pending-order-home" ng-class="{\'freeze-col-min-width-60\' : vm.permitModifyOrderEntry == true, \'freeze-col-min-width-30\' : vm.permitModifyOrderEntry == false}"><label class="check-control" ng-show="vm.permitCancelOrderEntry"><input aria-label="Select All Orders" id="selectAll" class="checkbox" name="" ng-model="vm.selectAll" type="checkbox" ng-click="vm.checkOrUncheckPendingOrders($event)"> <span class="checkbox-overlay-header"></span></label></th><th ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'CUSTOMER\'">Bank</th><th ng-show="account.entityOwnerType.shortName==\'Clearcorp\' || account.entityOwnerType.shortName==\'Bank\'">Branch</th><th ng-show="account.entityOwnerType.shortName==\'Clearcorp\'">Branch ID</th><th ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'BANK\'">Cust ID</th><th ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\'">Customer</th><th>Currency Pair</th><th ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}">Inst</th><th ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}">Order Type</th><th ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}">B/S</th><th class="text-right" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div>Settlement</div><div>Start Date</div></th><th class="text-right" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div>Settlement</div><div>End Date</div></th><th class="text-right" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}">Order Price</th><th class="text-right" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}">Order Qty</th><th class="text-right" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}">Pending Qty</th><th class="text-right" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}">Traded Qty</th><th ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div>Price</div><div>Condition</div></th><th class="text-right" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div>Eqv. Spot</div><div>Order Price</div></th><th class="text-right" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div>Trigger</div><div>Price</div></th><th ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div>Time</div><div>Condition</div></th><th ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}">GTT</th><th ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><div>Order</div><div>Status</div></th><th ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}">Order No.</th><th ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}">Last Actioned By</th><th ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}">Order Date Time</th><th ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}">Placed as Split order</th><!-- <th ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}">Currency Pair</th> --></tr></thead><tbody><tr ng-repeat="pendingOrder in filterDataPendingOrders = (pendingOrders | filter : filterTextForPO | orderBy : \'lastModifiedDateTime\' : true ) | limitTo:vm.noOfRecordsPerPageOP:vm.noOfRecordsPerPageOP*(vm.pageOP-1)" ng-hide="pendingOrder.pendingOrderAmount==0 || (pendingOrder.orderStatusId!=2 && pendingOrder.orderStatusId!=3 && pendingOrder.orderStatusId!=1)"><td class="freeze-column-pending-order-home" ng-class="{\'freeze-col-min-width-60\' : vm.permitModifyOrderEntry == true, \'freeze-col-min-width-30\' : vm.permitModifyOrderEntry == false}"><label class="check-control" ng-show="vm.permitCancelOrderEntry"><input class="checkbox" aria-label="Select Order {{pendingOrder.retailOrderRefNo}}" name="" ng-model="pendingOrder.select" type="checkbox" ng-disabled="pendingOrder.orderStatus==\'Risk Validated\'" ng-click="vm.checkOrUncheckPendingOrderItem()"> <span class="checkbox-overlay"></span></label><span class="edit-row" ng-show="vm.permitModifyOrderEntry"><img src="assets/images/edit-icon.png" class="padding-bottom-10" ng-click="vm.modifyOrder(pendingOrder);" ng-hide="pendingOrder.orderStatus==\'Risk Validated\'"></span><span class="delete-row" ng-show="vm.permitModifyOrderEntry"><img src="assets/images/delete-icon.png" class="padding-bottom-10" ng-click="vm.cancelOrder(pendingOrder);" ng-hide="pendingOrder.orderStatus==\'Risk Validated\'"></span></td><td ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'CUSTOMER\'" class="minimize-field" title="{{pendingOrder.bankName}}"><span>{{pendingOrder.bankName}}</span></td><td ng-show="account.entityOwnerType.shortName==\'Clearcorp\' || account.entityOwnerType.shortName==\'Bank\'" class="minimize-field" title="{{pendingOrder.branchName}}"><span>{{pendingOrder.branchName}}</span></td><td ng-show="account.entityOwnerType.shortName==\'Clearcorp\'"><span>{{pendingOrder.branchCode}}</span></td><td ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'BANK\'"><span>{{pendingOrder.customerCode}}</span></td><td ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\'" class="minimize-field" title="{{pendingOrder.customerName}}"><span>{{pendingOrder.customerName}}</span></td><td><span>{{pendingOrder.currencyPairCode}}</span></td><td ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span>{{pendingOrder.instrumentCode}}</span></td><td ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span>{{pendingOrder.eventTypeName}}</span></td><td ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span ng-show="pendingOrder.buySellInd==\'BUYY\'">Buy</span> <span ng-show="pendingOrder.buySellInd==\'SELL\'">Sell</span></td><td ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span ng-if="pendingOrder.tradeSettlementDateFrom !=null">{{pendingOrder.tradeSettlementDateFrom | date:\'dd-MMM-yyyy\'}}</span> <span ng-if="pendingOrder.tradeSettlementDateFrom ==null">{{\'\'}}</span></td><td ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span>{{pendingOrder.tradeSettlementDate | date:\'dd-MMM-yyyy\'}}</span></td><td class="text-right" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span ng-show="pendingOrder.typeOfOrder!=\'MRKT\'">{{pendingOrder.limitExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span>{{pendingOrder.orderAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span>{{pendingOrder.pendingOrderAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span>{{pendingOrder.tradedAmount | number:vm.noOfDecimalsForAmount}}</span></td><td ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span ng-show="pendingOrder.typeOfOrder==\'LIMT\'">Limit</span> <span ng-show="pendingOrder.typeOfOrder==\'MRKT\'">Market</span> <span ng-show="pendingOrder.typeOfOrder==\'STLS\'">Stop Loss</span> <span ng-show="pendingOrder.typeOfOrder==\'TKPR\'">Take Profit</span></td><td class="text-right" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span ng-show="pendingOrder.typeOfOrder!=\'MRKT\'">{{pendingOrder.spotlimitExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span ng-show="pendingOrder.typeOfOrder==\'STLS\' || pendingOrder.typeOfOrder==\'TKPR\'">{{pendingOrder.stopExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span ng-show="pendingOrder.timeLimitIndicator==\'DAYY\'">Day</span> <span ng-show="pendingOrder.timeLimitIndicator==\'IOCC\'">IOC</span> <span ng-show="pendingOrder.timeLimitIndicator==\'GTTM\'">GTT</span></td><td ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span ng-show="pendingOrder.timeLimitIndicator==\'GTTM\'">{{pendingOrder.expiryTimeString | date:\'HH:mm\'}}</span></td><td ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span>{{pendingOrder.orderStatus}}</span></td><td ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span><a ui-sref="order-activity-pending-orders({orderNumber:pendingOrder.orderSequenceNumber})" style="text-decoration: underline">{{pendingOrder.orderSequenceNumber}}</a></span></td><td ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span>{{pendingOrder.retailUserName}}</span></td><td ng-if="pendingOrder.orderStatus != \'Risk Validated\'" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span>{{vm.getMomentFromOrderRevisionTimeStamp(pendingOrder.revisiontTimestampString) | date:\'dd-MMM-yyyy HH:mm:ss\'}}</span></td><td ng-if="pendingOrder.orderStatus == \'Risk Validated\'" ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span>{{pendingOrder.lastModifiedDateTime | date:\'dd-MMM-yyyy HH:mm:ss\'}}</span></td><td nowrap="nowrap" ng-show="pendingOrder.isSplitOrder==true">Yes</td><td nowrap="nowrap" ng-show="pendingOrder.isSplitOrder==false">No</td><!-- <td ng-class="{\'padding-left-0\':account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span>{{pendingOrder.currencyPairCode}}</span></td> --></tr></tbody></table></div></div><div class="nav-tab-bot-right-footer"><div class="row"><div class="col-xs-8"><div ng-show="filterDataPendingOrders.length > 0"><cspl-pagination record-count="filterDataPendingOrders.length" control-model="vm.pageOP" items-per-page="vm.noOfRecordsPerPageOP"></cspl-pagination></div></div><div class="col-xs-4 text-right"><button type="button" class="btn btn-info active" id="btnCancelAll" ng-show="vm.permitCancelOrderEntry && account.organisation.organisationType.shortName==\'CLEARCORP\'" ng-click="vm.cancelAllOrders()">CANCEL ALL</button> <button type="button" class="btn btn-info active" id="btnCancelSelected" ng-show="vm.permitCancelOrderEntry" ng-click="vm.cancelPendingOrdersSelected()">CANCEL SELECTED</button></div></div></div></div><!--PendingOrders Closed--><div role="tabpanel" class="tab-pane" id="OutstandingTrades" ng-class="{active: vm.reportTab==\'OutstandingTrades\'}"><div class="bot-right-header-wrapper"><div class="row"><div class="col-sm-12"><div class="nav-tab-bot-header-left"><div ng-class="{clearcorps: account.entityOwnerType.shortName==\'Clearcorp\'}"><div class="row" ng-hide="account.entityOwnerType.shortName==\'Clearcorp\' || account.organisation.organisationType.shortName==\'CUSTOMER\'"><label class="control-label outright-sett-label-value">Settlement Date</label><div class="search-box" style="width: 20%" ng-hide="account.entityOwnerType.shortName==\'Clearcorp\'"><cspl-dtp class="outstanding-trade-date" control-model="vm.fromSettlementDate" control-id="selectedFromDate" show-error-text="true"></div><div class="search-box" style="width: 20%" ng-hide="account.entityOwnerType.shortName==\'Clearcorp\'"><cspl-dtp class="outstanding-trade-date" control-model="vm.toSettlementDate" control-id="selectedToDate" show-error-text="true"></div></div><div class="row"><div class="col-sm-10"><div class="up-btn"><div class="dropdown" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportOTToCsvFile();">CSV</a></li><li><a ng-click="vm.exportOTToExcelFile();">XLS</a></li></ul></div></div><span ng-show="account.organisation.organisationType.shortName==\'CUSTOMER\' || account.entityOwnerType.shortName==\'Clearcorp\'"><label class="control-label outright-sett-label-value">Settlement Date</label><span class="search-box" ng-class="{\'width-13\':account.entityOwnerType.shortName==\'Clearcorp\',\'width-15\':account.organisation.organisationType.shortName==\'CUSTOMER\'}"><cspl-dtp class="outstanding-trade-date" control-model="vm.fromSettlementDate" control-id="selectedFromDate"></span><span class="search-box" ng-class="{\'width-13\':account.entityOwnerType.shortName==\'Clearcorp\',\'width-15\':account.organisation.organisationType.shortName==\'CUSTOMER\'}"><cspl-dtp class="outstanding-trade-date" control-model="vm.toSettlementDate" control-id="selectedToDate"></span></span><div class="search-box order-entry-branch" style="width:23%" ng-if="account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.bankFilterForOT" control-id="txtbankFilterForOT" lookup-name="tradingBank" filter-value="{{account.organisation.id}}" display-column="bankName" form="frmtradinghomepage" control-place-holder="Enter bank name"></cspl-ach></div><div class="search-box order-entry-branch" style="width:14%" ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.bankFilterForOT" control-id="txtbankFilterForOT" lookup-name="bank" control-place-holder="Enter bank name" display-column="bankName" form="frmtradinghomepage" control-required="account.organisation.organisationType.shortName==\'CLEARCORP\'"></cspl-ach></div><div class="search-box order-entry-branch" style="width:14%" ng-if="account.entityOwnerType.shortName==\'Clearcorp\'"><cspl-ach control-model="vm.branchFilterForOT" control-id="txtbranchFilterForOT" lookup-name="validStatusBranchesForBank" filter-value="{{vm.bankFilterForOT.id}}" control-place-holder="Enter Branch ID or Name" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForOT!=null && vm.branchFilterForOT!=undefined" title="{{vm.branchFilterForOT.branchName}}">{{vm.branchFilterForOT.branchName}}</span></div><!-- <div class="search-box order-entry-branch" style="width:14%;"\r\n                              ng-if="account.entityOwnerType.shortName==\'Clearcorp\' && vm.bankFilterForOT==null">\r\n                              <cspl-ach control-model="vm.branchFilterForOT"\r\n                                 control-id="txtbranchFilterForOT" lookup-name="allBranches"\r\n                                 control-place-holder="Enter Branch ID or Name"\r\n                                 display-column="branchId,branchName"\r\n                                 form="frmtradinghomepage"></cspl-ach>\r\n                              <span class="help-block"\r\n                                 ng-show="vm.branchFilterForOT!=null && vm.branchFilterForOT!=undefined"\r\n                                 title="{{vm.branchFilterForOT.branchName}}">{{vm.branchFilterForOT.branchName}}</span>\r\n                           </div> --><div class="search-box order-entry-branch" ng-if="account.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.branchFilterForOT" control-place-holder="Enter Branch ID or Name" control-id="txtbranchFilterForOT" lookup-name="validStatusBranchesForBank" filter-value="{{account.organisation.id}}" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForOT!=null && vm.branchFilterForOT!=undefined" title="{{vm.branchFilterForOT.branchName}}">{{vm.branchFilterForOT.branchName}}</span></div><div class="search-box" ng-if="account.organisation.organisationType.shortName==\'BANK\'"><cspl-ach control-model="vm.customerFilterForOT" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForOT" lookup-name="customer" filter-value="{{vm.bankFilterForOT.id}}~~{{vm.branchFilterForOT.id}}~~{{0}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForOT!=null && vm.customerFilterForOT!=undefined" title="{{vm.customerFilterForOT.customerName}}">{{vm.customerFilterForOT.customerName}}</span></div><div class="search-box" style="width:14%" ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.customerFilterForOT" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForOT" lookup-name="customer" filter-value="{{vm.bankFilterForOT.id}}~~{{vm.branchFilterForOT.id}}~~{{0}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForOT!=null && vm.customerFilterForOT!=undefined" title="{{vm.customerFilterForOT.customerName}}">{{vm.customerFilterForOT.customerName}}</span></div><div class="search-box" style="width: 110px"><cspl-ach control-model="vm.currencyPairForOT" control-place-holder="Enter Currency Pair" control-id="txtcurrencyPairForOT" lookup-name="currencyPair" filter-value="{{ vm.bankFilterForOT.id ? vm.bankFilterForOT.id : 0 }}" display-column="code" form="frmtradinghomepage"></cspl-ach><!-- <span class="help-block"\r\n                              ng-show="vm.customerFilterForPO!=null && vm.customerFilterForPO!=undefined"\r\n                              title="{{vm.customerFilterForPO.customerName}}">{{vm.customerFilterForPO.customerName}}</span> --></div><!-- <div class="search-box " style="width:14%;"\r\n                              ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForOT==null && vm.bankFilterForOT!=null">\r\n                              <cspl-ach control-model="vm.customerFilterForOT"\r\n                                 control-place-holder="Enter Customer ID or Name"\r\n                                 control-id="txtcustomerFilterForOT"\r\n                                 lookup-name="customersForBank"\r\n                                 filter-value="{{vm.bankFilterForOT.id}}"\r\n                                 display-column="customerCode,customerName"\r\n                                 form="frmtradinghomepage"></cspl-ach>\r\n                              <span class="help-block"\r\n                                 ng-show="vm.customerFilterForOT!=null && vm.customerFilterForOT!=undefined"\r\n                                 title="{{vm.customerFilterForOT.customerName}}">{{vm.customerFilterForOT.customerName}}</span>\r\n                           </div> --> <!-- <div class="search-box " style="width:14%;"\r\n                              ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForOT==null && vm.bankFilterForOT==null">\r\n                              <cspl-ach control-model="vm.customerFilterForOT"\r\n                                 control-place-holder="Enter Customer ID or Name"\r\n                                 control-id="txtcustomerFilterForOT"\r\n                                 lookup-name="AllCustomers"\r\n                                 display-column="customerCode,customerName"\r\n                                 form="frmtradinghomepage"></cspl-ach>\r\n                              <span class="help-block"\r\n                                 ng-show="vm.customerFilterForOT!=null && vm.customerFilterForOT!=undefined"\r\n                                 title="{{vm.customerFilterForOT.customerName}}">{{vm.customerFilterForOT.customerName}}</span>\r\n                           </div> --> <!-- <div class="search-box " style="width:14%;"\r\n                              ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForOT!=null && vm.bankFilterForOT==null">\r\n                              <cspl-ach control-model="vm.customerFilterForOT"\r\n                                 control-place-holder="Enter Customer ID or Name"\r\n                                 control-id="txtcustomerFilterForOT"\r\n                                 lookup-name="customersForBranch"\r\n                                 filter-value="{{vm.branchFilterForOT.id}}"\r\n                                 display-column="customerCode,customerName"\r\n                                 form="frmtradinghomepage"></cspl-ach>\r\n                              <span class="help-block"\r\n                                 ng-show="vm.customerFilterForOT!=null && vm.customerFilterForOT!=undefined"\r\n                                 title="{{vm.customerFilterForOT.customerName}}">{{vm.customerFilterForOT.customerName}}</span>\r\n                           </div> --><div class="select-box"><select name="select" class="select-opt" ng-model="vm.instrumentFilterForOT" ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id"><option value="">--All--</option></select></div><div class="go-btn"><span ng-if="account.organisation.organisationType.shortName!=\'CLEARCORP\'"><button type="button" ng-disabled="vm.clickedReport" class="btn btn-go" ng-click="vm.getOutstandingTradesReport();">GO</button></span> <span ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\'"><button type="button" class="btn btn-go" ng-disabled="vm.bankFilterForOT==null||vm.clickedReport" ng-click="vm.getOutstandingTradesReport();">GO</button></span></div></div><div class="col-sm-2"><div class="nav-tab-bot-header-right text-right"><div class="search-field"><cspl-table-search control-model="filterTextForOT"></cspl-table-search></div></div></div></div></div></div></div></div></div><div class="bot-right-table"><div class="table-responsive" ng-class="{\'margin-top-1\': account.organisation.organisationType.shortName!=\'BANK\',\'margin-top-2\': account.organisation.organisationType.shortName==\'BANK\'}" style="margin-top: 1%"><table id="tblOutstandingTrades" class="table table-striped"><thead class="freeze-thead"><tr><th ng-show="account.entityOwnerType.shortName!=\'Clearcorp\'" style="min-width: 50px"></th><th ng-show="account.entityOwnerType.shortName==\'Clearcorp\'">&nbsp;&nbsp;</th><th ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'CUSTOMER\'">Bank</th><th ng-show="account.entityOwnerType.shortName==\'Clearcorp\' || account.entityOwnerType.shortName==\'Bank\'">Branch</th><th ng-show="account.entityOwnerType.shortName==\'Clearcorp\'">Branch ID</th><th ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'BANK\'">Cust ID</th><th ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\'">Customer</th><th>Currency Pair</th><th>Instrument</th><th>Trade Type</th><th>B/S</th><th class="text-right">Settlement Start Date</th><th class="text-right">Settlement End Date</th><th class="text-right">Traded Quantity</th><th class="text-right">Trade Price</th><th class="text-right">Net Trade Price</th><th class="text-right">Trade Value (INR)</th><th class="text-right">Cancelled Quantity</th><th class="text-right">Rolled Over Quantity</th><th class="text-right">Early Settled Quantity</th><th class="text-right">Outstanding Quantity</th><th class="text-right">Blocked Quantity</th><th>Trade Status</th><th>Trade Date Time</th><th>Trade No.</th><th>Order No.</th><th>Original Trade No.</th><th>UserRemarks1</th><th>UserRemarks2</th><th>UserRemarks3</th><th>UserRemarks4</th><th>Exposure Type</th><th>Exposure Sub-Type</th><th>Last Actioned By</th><th>Delivery Mode</th><th>Source</th></tr></thead><tbody><tr ng-repeat="outstandingTrade in filterDataOutstandingTrades = (outstandingTrades | filter : filterTextForOT ) | limitTo:vm.noOfRecordsPerPageOT:vm.noOfRecordsPerPageOT*(vm.pageOT-1)"><td class="freeze-column-left-OT"><label ng-show="account.entityOwnerType.shortName!=\'Clearcorp\'" class="check-control"><input class="checkbox" name="OutstandingTrade_{{$index}}" ng-model="outstandingTrade.select" type="checkbox" ng-click="vm.checkOrUncheckOutstandingTradesItem(outstandingTrade, $event)"> <span class="checkbox-overlay"></span></label><span class="edit-row"><img title="Deal Ticket" class="dealTicket" ng-class="{\'margin-bottom-8\': account.organisation.organisationType.shortName != \'CLEARCORP\'}" src="assets/images/Deal ticket-20.png" ng-click="vm.printDealTicketOutstandingTrade(outstandingTrade);"></span></td><td ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'CUSTOMER\'" class="minimize-field" title="{{outstandingTrade.bankName}}"><span>{{outstandingTrade.bankName}}</span></td><td ng-show="account.entityOwnerType.shortName==\'Clearcorp\' || account.entityOwnerType.shortName==\'Bank\'" class="minimize-field" title="{{outstandingTrade.branchName}}"><span>{{outstandingTrade.branchName}}</span></td><td ng-show="account.entityOwnerType.shortName==\'Clearcorp\'"><span>{{outstandingTrade.branchCode}}</span></td><td ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'BANK\'"><span>{{outstandingTrade.customerCode}}</span></td><td ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\'" class="minimize-field" title="{{outstandingTrade.customerName}}"><span>{{outstandingTrade.customerName}}</span></td><td><span>{{outstandingTrade.currencyPair}}</span></td><td><span>{{outstandingTrade.instrumentCode}}</span></td><td><span>{{outstandingTrade.eventTypeName}}</span></td><td><span ng-show="outstandingTrade.buySellIndicator==\'BUYY\'">Buy</span> <span ng-show="outstandingTrade.buySellIndicator==\'SELL\'">Sell</span></td><td><span ng-if="outstandingTrade.tradeSettlementDateFrom !=null">{{outstandingTrade.tradeSettlementDateFrom | date:\'dd-MMM-yyyy\'}}</span> <span ng-if="outstandingTrade.tradeSettlementDateFrom ==null">{{\'\'}}</span></td><td><span>{{outstandingTrade.tradeSettlementDate | date:\'dd-MMM-yyyy\'}}</span></td><td class="text-right"><span>{{outstandingTrade.tradeAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{outstandingTrade.tradedExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right"><span ng-if="outstandingTrade.buySellIndicator==\'BUYY\'">{{outstandingTrade.tradedExchangeRate + outstandingTrade.markupRate | number:vm.noOfDecimalsForRate}}</span> <span ng-if="outstandingTrade.buySellIndicator==\'SELL\'">{{outstandingTrade.tradedExchangeRate - outstandingTrade.markupRate | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right"><span>{{outstandingTrade.tradedValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{outstandingTrade.cancelledAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{outstandingTrade.rolledoverAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{outstandingTrade.earlysettledAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{outstandingTrade.outStandingAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{outstandingTrade.blockedAmount | number:vm.noOfDecimalsForAmount}}</span></td><td><span>{{outstandingTrade.tradeStatusName}}</span></td><td style="min-width: 130px"><span>{{outstandingTrade.tradeTime | date:\'dd-MMM-yyyy HH:mm:ss\'}}</span></td><td class="text-right"><span>{{outstandingTrade.tradeSequenceNumber}}</span></td><td class="text-right"><span><a ui-sref="order-activity-pending-orders({orderNumber:outstandingTrade.orderSequenceNumber})" style="text-decoration: underline">{{outstandingTrade.orderSequenceNumber}}</a></span></td><td class="text-right"><span ng-if="outstandingTrade.sourceTradeNumber!=0">{{outstandingTrade.sourceTradeNumber}}</span></td><td style="min-width:270px"><span>{{outstandingTrade.userRemarks || \'-\'}}</span></td><td style="min-width:180px"><span>{{outstandingTrade.remarks2 || \'-\'}}</span></td><td style="min-width:180px"><span>{{outstandingTrade.remarks3 || \'-\'}}</span></td><td style="min-width:180px"><span>{{outstandingTrade.remarks4 || \'-\'}}</span></td><td><span>{{outstandingTrade.exposureTypeName || \'-\'}}</span></td><td><span>{{outstandingTrade.exposureSubTypeName || \'-\'}}</span></td><td><span>{{outstandingTrade.lastActionedBy}}</span></td><td><span>{{outstandingTrade.deliveryMode}}</span></td><td><span>{{outstandingTrade.sourceAppName}}</span></td></tr></tbody></table></div></div><div class="nav-tab-bot-right-footer"><div class="row"><div class="col-xs-4"><div ng-show="filterDataOutstandingTrades.length > 0"><cspl-pagination record-count="filterDataOutstandingTrades.length" control-model="vm.pageOT" items-per-page="vm.noOfRecordsPerPageOT"></cspl-pagination></div></div><div class="col-xs-8 text-right" ng-show="vm.permitCancelOrderEntry && account.entityOwnerType.shortName!=\'Clearcorp\'"><button type="button" class="btn btn-info active" ng-click="vm.rolloverTrade();"><span>ROLLOVER</span> <span ng-show="userPreference.showInfoIcon==\'yes\'" class="icon"><img class="home-page-help-icon width-height-18" data-toggle="tooltip" title="This option will open Rollover order form to Rebook contract for future date after existing settlement date and cancel selected source contract." src="assets/images/Info-24.png"></span></button> <button type="button" class="btn btn-info active" ng-click="vm.earlyDeliveryTrade();"><span>EARLY DELIVERY</span> <span ng-show="userPreference.showInfoIcon==\'yes\'" class="icon"><img class="home-page-help-icon width-height-18" data-toggle="tooltip" title="This option will open Early Delivery order form to Rebook contract for before any of existing settlement date and cancel selected source contract." src="assets/images/Info-24.png"></span></button> <button type="button" class="btn btn-info active" ng-click="vm.cancelTrade();"><span>CANCEL CONTRACT</span> <span ng-show="userPreference.showInfoIcon==\'yes\'" class="icon"><img class="home-page-help-icon width-height-18" data-toggle="tooltip" title="This option will open cancellation order form for selected source contract before original settlement date." src="assets/images/Info-24.png"></span></button></div></div></div></div><!--Outstanding Trades Closed--><div role="tabpanel" class="tab-pane" id="Trades" ng-class="{active: vm.reportTab==\'Trades\'}"><div class="bot-right-header-wrapper"><div class="row"><div class="col-sm-9"><div class="nav-tab-bot-header-left"><div ng-class="{clearcorp: account.entityOwnerType.shortName==\'Clearcorp\'}"><div class="up-btn" ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' "><cspl-table-export table-name="tblTrades" total-record-count="trades.length" no-of-records-per-page="vm.noOfRecordsPerPageTrade" filter-text="filterText" page-no="vm.pageTrade" file-name="Trades_{{vm.custCode}}_{{vm.bankFilterForTrade.bankName}}" footer="ShowHiddenFooter" ignore-column="[0]"></cspl-table-export></div><div class="up-btn" ng-if="account.organisation.organisationType.shortName != \'CLEARCORP\' "><div class="dropdown" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportTradesToCsvFile();">CSV</a></li><li><a ng-click="vm.exportTradesToExcelFile();">XLS</a></li></ul></div></div><div class="search-box order-entry-branch" ng-if="account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.bankFilterForTrade" control-id="txtbankFilterForTrade" lookup-name="tradingBank" filter-value="{{account.organisation.id}}" display-column="bankName" form="frmtradinghomepage" control-place-holder="Enter bank name"></cspl-ach></div><div class="search-box order-entry-branch" ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.bankFilterForTrade" control-id="txtbankFilterForTrade" lookup-name="bank" control-place-holder="Enter bank name" display-column="bankName" form="frmtradinghomepage" control-required="account.organisation.organisationType.shortName==\'CLEARCORP\'"></cspl-ach></div><div class="search-box order-entry-branch" ng-if="account.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.branchFilterForTrade" control-id="txtbranchFilterForTrade" lookup-name="validStatusBranchesForBank" filter-value="{{account.organisation.id}}" control-place-holder="Enter Branch ID or Name" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForTrade!=null && vm.branchFilterForTrade!=undefined" title="{{vm.branchFilterForTrade.branchName}}">{{vm.branchFilterForTrade.branchName}}</span></div><div class="search-box order-entry-branch" ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.branchFilterForTrade" control-id="txtbranchFilterForTrade" lookup-name="validStatusBranchesForBank" filter-value="{{vm.bankFilterForTrade.id}}" control-place-holder="Enter Branch ID or Name" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForTrade!=null && vm.branchFilterForTrade!=undefined" title="{{vm.branchFilterForTrade.branchName}}">{{vm.branchFilterForTrade.branchName}}</span></div><!-- <div class="search-box order-entry-branch"\r\n                           ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.bankFilterForTrade==null">\r\n                           <cspl-ach control-model="vm.branchFilterForTrade"\r\n                              control-id="txtbranchFilterForTrade"\r\n                              lookup-name="allBranches"\r\n                              control-place-holder="Enter Branch ID or Name"\r\n                              display-column="branchId,branchName"\r\n                              form="frmtradinghomepage"></cspl-ach>\r\n                           <span class="help-block"\r\n                              ng-show="vm.branchFilterForTrade!=null && vm.branchFilterForTrade!=undefined"\r\n                              title="{{vm.branchFilterForTrade.branchName}}">{{vm.branchFilterForTrade.branchName}}</span>\r\n                        </div> --><div class="search-box" ng-if="account.organisation.organisationType.shortName==\'BANK\'"><cspl-ach control-model="vm.customerFilterForTrade" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForTrade" lookup-name="customer" filter-value="{{vm.bankFilterForTrade.id}}~~{{vm.branchFilterForTrade.id}}~~{{0}}" display-column="customerCode,customerName" form="approvalPolicyForm" control-place-holder="Enter Customer ID or Name"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForTrade!=null && vm.customerFilterForTrade!=undefined" title="{{vm.customerFilterForTrade.customerName}}">{{vm.customerFilterForTrade.customerName}}</span></div><div class="search-box" ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.customerFilterForTrade" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForTrade" lookup-name="customer" filter-value="{{vm.bankFilterForTrade.id}}~~{{vm.branchFilterForTrade.id}}~~{{0}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForTrade!=null && vm.customerFilterForTrade!=undefined" title="{{vm.customerFilterForTrade.customerName}}">{{vm.customerFilterForTrade.customerName}}</span></div><!-- <div class="search-box"\r\n                           ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForTrade==null && vm.bankFilterForTrade!=null">\r\n                           <cspl-ach control-model="vm.customerFilterForTrade"\r\n                              control-place-holder="Enter Customer ID or Name"\r\n                              control-id="txtcustomerFilterForTrade"\r\n                              lookup-name="customersForBank"\r\n                              filter-value="{{vm.bankFilterForTrade.id}}"\r\n                              display-column="customerCode,customerName"\r\n                              form="frmtradinghomepage"></cspl-ach>\r\n                           <span class="help-block"\r\n                              ng-show="vm.customerFilterForTrade!=null && vm.customerFilterForTrade!=undefined"\r\n                              title="{{vm.customerFilterForTrade.customerName}}">{{vm.customerFilterForTrade.customerName}}</span>\r\n                        </div> --> <!-- <div class="search-box"\r\n                           ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForTrade!=null && vm.bankFilterForTrade==null">\r\n                           <cspl-ach control-model="vm.customerFilterForTrade"\r\n                              control-place-holder="Enter Customer ID or Name"\r\n                              control-id="txtcustomerFilterForTrade"\r\n                              lookup-name="customersForBranch"\r\n                              filter-value="{{vm.branchFilterForTrade.id}}"\r\n                              display-column="customerCode,customerName"\r\n                              form="frmtradinghomepage"></cspl-ach>\r\n                           <span class="help-block"\r\n                              ng-show="vm.customerFilterForTrade!=null && vm.customerFilterForTrade!=undefined"\r\n                              title="{{vm.customerFilterForTrade.customerName}}">{{vm.customerFilterForTrade.customerName}}</span>\r\n                        </div> --> <!-- <div class="search-box"\r\n                           ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForTrade==null && vm.bankFilterForTrade==null">\r\n                           <cspl-ach control-model="vm.customerFilterForTrade"\r\n                              control-place-holder="Enter Customer ID or Name"\r\n                              control-id="txtcustomerFilterForTrade"\r\n                              lookup-name="AllCustomers"\r\n                              display-column="customerCode,customerName"\r\n                              form="frmtradinghomepage"></cspl-ach>\r\n                           <span class="help-block"\r\n                              ng-show="vm.customerFilterForTrade!=null && vm.customerFilterForTrade!=undefined"\r\n                              title="{{vm.customerFilterForTrade.customerName}}">{{vm.customerFilterForTrade.customerName}}</span>\r\n                        </div> --><div class="search-box" style="width: 110px"><cspl-ach control-model="vm.currencyPairForTrade" control-place-holder="Enter Currency Pair" control-id="txtcurrencyPairForTrade" lookup-name="currencyPair" filter-value="{{ vm.bankFilterForTrade.id ? vm.bankFilterForTrade.id : 0 }}" display-column="code" form="frmtradinghomepage"></cspl-ach></div><div class="select-box"><select name="select" class="select-opt" ng-model="vm.instrumentFilterForTrade" ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id"><option value="">--All--</option></select></div><div class="go-btn"><span ng-if="account.organisation.organisationType.shortName!=\'CLEARCORP\'"><button type="button" ng-disabled="vm.clickedReport" class="btn btn-go" ng-click="vm.getTradesReport();">GO</button></span> <span ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\'"><button type="button" ng-disabled="vm.bankFilterForTrade==null||vm.clickedReport" class="btn btn-go" ng-click="vm.getTradesReport();">GO</button></span></div></div></div></div><div class="col-sm-3"><div class="nav-tab-bot-header-right text-right"><div class="search-field"><cspl-table-search control-model="filterTextForTrade"></cspl-table-search></div></div></div></div><!-- row ends --></div><div class="bot-right-table"><div class="table-responsive"><table id="tblTrades" class="table table-striped"><thead class="freeze-thead"><tr><th>&nbsp;</th><th ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'CUSTOMER\'">Bank</th><th ng-show="account.entityOwnerType.shortName==\'Clearcorp\' || account.entityOwnerType.shortName==\'Bank\'">Branch</th><th ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'BANK\'">Cust ID</th><th>Currency Pair</th><th>Inst</th><th>Trade Type</th><th>Settlement Leg</th><th>B/S</th><th class="text-right">Settlement Start Date</th><th class="text-right">Settlement End Date</th><th class="text-right">Traded Quantity</th><th class="text-right">Trade Price</th><th class="text-right">Net Trade Price</th><th class="text-right">Swap Pts. (Paise)</th><th class="text-right">Eqv. Spot Trade Price</th><th class="text-right" style="min-width: 130px">Trade Value (INR)</th><th style="min-width: 130px">Trade Date Time</th><th class="text-right">Trade No.</th><th>Original Trade No.</th><th class="text-right">Order No.</th><th>Exposure Type</th><th>Exposure Sub-Type</th><th>UserRemarks1</th><th>UserRemarks2</th><th>UserRemarks3</th><th>UserRemarks4</th><th>Last Actioned By</th><th>Delivery Mode</th><th>Source</th></tr></thead><tbody><tr ng-repeat="trade in vm.tradeFilterData = (trades | filter : filterTextForTrade | orderBy : \'lastModifiedDateTime\' : true ) | limitTo:vm.noOfRecordsPerPageTrade:vm.noOfRecordsPerPageTrade*(vm.pageTrade-1)"><td class="text-right freeze-column-left"><span class="edit-row"><img title="Deal Ticket" class="dealTicket" src="assets/images/Deal ticket-20.png" ng-click="vm.printDealTicket(trade);"></span></td><td ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'CUSTOMER\'" class="minimize-field" title="{{trade.bankName}}"><span>{{trade.bankName}}</span></td><td ng-show="account.entityOwnerType.shortName==\'Clearcorp\' || account.entityOwnerType.shortName==\'Bank\'" class="minimize-field" title="{{trade.branchName}}"><span>{{trade.branchName}}</span></td><td ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'BANK\'" class="minimize-field" title="{{trade.customerCode}}"><span>{{trade.customerCode}}</span></td><td>{{trade.currencyPair}}</td><td><span>{{trade.instrumentCode}}</span></td><td><span>{{trade.eventTypeName}}</span></td><td><span>{{trade.settlementLegName}}</span></td><td><span ng-show="trade.buySellIndicator==\'BUYY\'">Buy</span> <span ng-show="trade.buySellIndicator==\'SELL\'">Sell</span></td><td><span ng-if="trade.tradeSettlementDateFrom !=null">{{trade.tradeSettlementDateFrom| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="trade.tradeSettlementDateFrom ==null">{{\'\'}}</span></td><td><span>{{trade.tradeSettlementDate| date:\'dd-MMM-yyyy\'}}</span></td><td class="text-right"><span>{{trade.tradedAmount | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{trade.tradedExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right"><span>{{trade.netTradePrice | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right"><span>{{vm.getSwapPointsForTradesReport(trade.spottradedExchangeRate, trade.tradedExchangeRate) | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{trade.spottradedExchangeRate | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right"><span>{{trade.tradedValue | number:vm.noOfDecimalsForAmount}}</span></td><td style="min-width: 130px"><span>{{trade.tradeTime| date:\'dd-MMM-yyyy HH:mm:ss\'}}</span></td><td class="text-right"><span>{{trade.tradeSequenceNumber}}</span></td><td><span ng-if="trade.sourceTradeNumber!=0"><a ui-sref="order-activity-pending-orders({orderNumber:trade.sourceOrderNumber})" style="text-decoration: underline">{{trade.sourceTradeNumber}}</a></span></td><td class="text-right"><span><a ui-sref="order-activity-pending-orders({orderNumber:trade.orderSequenceNumber})" style="text-decoration: underline">{{trade.orderSequenceNumber}}</a></span></td><td><span>{{trade.exposureTypeName || \'-\'}}</span></td><td><span>{{trade.exposureSubTypeName || \'-\'}}</span></td><td style="min-width:270px">{{trade.userRemarks || \'-\'}}</td><td style="min-width:180px">{{trade.remarks2 || \'-\'}}</td><td style="min-width:180px">{{trade.remarks3 || \'-\'}}</td><td style="min-width:180px">{{trade.remarks4 || \'-\'}}</td><td>{{trade.retailUserCode}}</td><td style="min-width:180px">{{trade.deliveryMode || \'-\'}}</td><td>{{trade.sourceAppName}}</td></tr></tbody><tfoot ng-hide="true"><tr class="trade-summary-div" ng-if="trades.length>0 && vm.instrumentFilterForTrade != null && vm.instrumentFilterForTrade != undefined"><td></td><td colspan="6">(Trade Position)</td></tr><tr class="trade-summary-div" ng-if="trades.length>0 && vm.instrumentFilterForTrade != null && vm.instrumentFilterForTrade != undefined"><td></td><td class="col-md-2 summaryLabelTrades">USD Bought (B)</td><td class="col-md-2 panel-lbl-trades">{{(totalUSDBought | number : vm.noOfDecimalsForAmount)|| \'-\'}}</td><td class="col-md-2 summaryLabelTrades">INR Sold (S)</td><td class="col-md-2 panel-lbl-trades">{{(totalINRSold | number : vm.noOfDecimalsForAmount)|| \'-\'}}</td><td class="col-md-3 summaryLabelTrades">Weighted Average Price (B)</td><td class="col-md-1 panel-lbl-trades">{{(weightedAverageBuy| number : vm.noOfDecimalsForRate)|| \'-\'}}</td></tr><tr class="row" ng-if="trades.length>0 && vm.instrumentFilterForTrade != null && vm.instrumentFilterForTrade != undefined"><td></td><td class="col-md-2 summaryLabelTrades">USD Sold (S)</td><td class="col-md-2 panel-lbl-trades-secondary">{{(totalUSDSold | number : vm.noOfDecimalsForAmount)|| \'-\'}}</td><td class="col-md-2 summaryLabelTrades">INR Bought (B)</td><td class="col-md-2 panel-lbl-trades-secondary">{{(totalINRBought | number : vm.noOfDecimalsForAmount)|| \'-\'}}</td><td class="col-md-3 summaryLabelTrades">Weighted Average Price (S)</td><td class="col-md-1 panel-lbl-trades-secondary">{{(weightedAverageSell| number : vm.noOfDecimalsForRate)|| \'-\'}}</td></tr><tr class="row" ng-if="trades.length>0 && vm.instrumentFilterForTrade != null && vm.instrumentFilterForTrade != undefined"><td></td><td class="col-md-2 summaryLabelTrades">USD Net (B-S)</td><td class="col-md-2 panel-lbl-trades-tertiary" ng-if="usdNet >= 0">{{(usdNet | number : vm.noOfDecimalsForAmount)|| \'-\'}}</td><td class="col-md-2 panel-lbl-trades-tertiary" ng-if="usdNet < 0">({{(usdNet * -1 | number : vm.noOfDecimalsForAmount)|| \'-\'}} )</td><td class="col-md-2 summaryLabelTrades">INR Net (B-S)</td><td class="col-md-2 panel-lbl-trades-tertiary" ng-if="inrNet >= 0">{{(inrNet| number : vm.noOfDecimalsForAmount)|| \'-\'}}</td><td class="col-md-2 panel-lbl-trades-tertiary" ng-if="inrNet < 0">({{(inrNet * -1| number : vm.noOfDecimalsForAmount)|| \'-\'}} )</td><td class="col-md-3 summaryLabelTrades">Net Weighted Average Price</td><td class="col-md-1 panel-lbl-trades-tertiary">{{(netWeightedAveragePrice | number : vm.noOfDecimalsForRate) || \'-\'}}</td></tr></tfoot></table></div></div><div class="nav-tab-bot-right-footer tradeSummaryFooter"><div class="row" style="margin-bottom: -2px; margin-right: 0px"><div class="col-xs-8"><div ng-show="trades.length > 0"><cspl-pagination record-count="trades.length" control-model="vm.pageTrade" items-per-page="vm.noOfRecordsPerPageTrade"></cspl-pagination></div></div><div class="col-xs-4" style="padding-right: 0px" ng-if="trades.length>0"><div class="tradePositionKey" ng-click="vm.expandTradePosition = !vm.expandTradePosition"><span style="padding-right: 5px">Trade Position</span> <span style="float: right" aria-hidden="true" ng-show="!vm.expandTradePosition"><img style="height: 17px" src="assets/images/Accordion_expand.png"></span><span style="float: right" aria-hidden="true" ng-show="vm.expandTradePosition"><img style="height: 17px" src="assets/images/Accordion_collapse.png"></span></div></div></div><div ng-show="vm.expandTradePosition" class="trade-summary-div" ng-if="trades.length>0"><div class="row"><div class="col-md-2 summaryLabelTrades">{{vm.currencyPairForTrade.baseCurrency.code}} Bought (B)</div><div class="col-md-2 panel-lbl-trades">{{(totalUSDBought | number : vm.noOfDecimalsForAmount)|| \'-\'}}</div><div class="col-md-2 summaryLabelTrades">INR Sold (S)</div><div class="col-md-2 panel-lbl-trades">{{(totalINRSold | number : vm.noOfDecimalsForAmount)|| \'-\'}}</div><div class="col-md-3 summaryLabelTrades">Weighted Average Price (B)</div><div class="col-md-1 panel-lbl-trades">{{(weightedAverageBuy| number : vm.noOfDecimalsForRate)|| \'-\'}}</div></div><div class="row"><div class="col-md-2 summaryLabelTrades">{{vm.currencyPairForTrade.baseCurrency.code}} Sold (S)</div><div class="col-md-2 panel-lbl-trades-secondary">{{(totalUSDSold | number : vm.noOfDecimalsForAmount)|| \'-\'}}</div><div class="col-md-2 summaryLabelTrades">INR Bought (B)</div><div class="col-md-2 panel-lbl-trades-secondary">{{(totalINRBought | number : vm.noOfDecimalsForAmount)|| \'-\'}}</div><div class="col-md-3 summaryLabelTrades">Weighted Average Price (S)</div><div class="col-md-1 panel-lbl-trades-secondary">{{(weightedAverageSell| number : vm.noOfDecimalsForRate)|| \'-\'}}</div></div><div class="row"><div class="col-md-2 summaryLabelTrades">{{vm.currencyPairForTrade.baseCurrency.code}} Net (B-S)</div><div class="col-md-2 panel-lbl-trades-tertiary" ng-if="usdNet >= 0">{{(usdNet | number : vm.noOfDecimalsForAmount)|| \'-\'}}</div><div class="col-md-2 panel-lbl-trades-tertiary" ng-if="usdNet < 0">({{(usdNet * -1 | number : vm.noOfDecimalsForAmount)|| \'-\'}})</div><div class="col-md-2 summaryLabelTrades">INR Net (B-S)</div><div class="col-md-2 panel-lbl-trades-tertiary" ng-if="inrNet >= 0">{{(inrNet| number : vm.noOfDecimalsForAmount)|| \'-\'}}</div><div class="col-md-2 panel-lbl-trades-tertiary" ng-if="inrNet < 0">({{(inrNet * -1| number : vm.noOfDecimalsForAmount)|| \'-\'}})</div><div class="col-md-3 summaryLabelTrades">Net Weighted Average Price</div><div class="col-md-1 panel-lbl-trades-tertiary">{{(netWeightedAveragePrice | number : vm.noOfDecimalsForRate) || \'-\'}}</div></div><!-- \t<table>\r\n                  <tr>\r\n                  \t<td class="summaryLabel">USD Brought(B)</td>\r\n                  \t<td>{{totalUSDBought}}</td>\r\n                  \t<td class="summaryLabel">USD Brought(B)</td>\r\n                  \t<td>{{totalUSDBought}}</td>\r\n                  \t<td class="summaryLabel">USD Brought(B)</td>\r\n                  \t<td>{{totalUSDBought}}</td>\r\n                  </tr>\r\n                  \r\n                  </table> --></div><!-- <div class="row">\r\n             <span class="orderStatusInfo right-floating">Original Trade No. indicates the booking trade number of the original Contract</span>\r\n             </div>\r\n             <div class="row">\r\n             <br>\r\n             </div> --> <!-- <div ng-show="vm.expandTradePosition" class="trade-summary-div" ng-if="trades.length>0 && (vm.instrumentFilterForTrade == null \r\n               || vm.instrumentFilterForTrade == undefined )">\r\n               \r\n               \t<div class="row">\r\n               \t\t<div class="col-md-2 summaryLabelTrades">USD Bought (B)</div>\r\n               \t\t<div class="col-md-2 panel-lbl-trades">-</div>\r\n               \t\t<div class="col-md-2 summaryLabelTrades">INR Sold (S)</div>\r\n               \t\t<div class="col-md-2 panel-lbl-trades">-</div>\r\n               \t\t<div class="col-md-3 summaryLabelTrades">Weighted Average Price (B)</div>\r\n               \t\t<div class="col-md-1 panel-lbl-trades">-</div>\r\n               \t</div>\r\n               \t\r\n               \t<div class="row">\r\n               \t\t<div class="col-md-2 summaryLabelTrades">USD Sold (S)</div>\r\n               \t\t<div class="col-md-2 panel-lbl-trades-secondary">-</div>\r\n               \t\t<div class="col-md-2 summaryLabelTrades">INR Bought (B)</div>\r\n               \t\t<div class="col-md-2 panel-lbl-trades-secondary">-</div>\r\n               \t\t<div class="col-md-3 summaryLabelTrades">Weighted Average Price (S)</div>\r\n               \t\t<div class="col-md-1 panel-lbl-trades-secondary">-</div>\r\n               \t</div>\r\n               \t\r\n               \t<div class="row">\r\n               \t\t<div class="col-md-2 summaryLabelTrades">USD Net (B-S)</div>\r\n               \t\t<div class="col-md-2 panel-lbl-trades-tertiary" ng-if="usdNet >= 0">-</div>\r\n               \t\t<div class="col-md-2 panel-lbl-trades-tertiary" ng-if="usdNet < 0">-</div>\r\n               \t\t\r\n               \t\t<div class="col-md-2 summaryLabelTrades">INR Net (B-S)</div>\r\n               \t\t<div class="col-md-2 panel-lbl-trades-tertiary" ng-if="inrNet >= 0">-</div>\r\n               \t\t<div class="col-md-2 panel-lbl-trades-tertiary" ng-if="inrNet < 0">-</div>\r\n               \t\t\t\r\n               \t\t<div class="col-md-3 summaryLabelTrades">Net Weighted Average Price</div>\r\n               \t\t<div class="col-md-1 panel-lbl-trades-tertiary">-</div>\r\n               \t</div>\r\n               \t\r\n               \t<table>\r\n               \t<tr>\r\n               \t\t<td class="summaryLabel">USD Brought(B)</td>\r\n               \t\t<td>{{totalUSDBought}}</td>\r\n               \t\t<td class="summaryLabel">USD Brought(B)</td>\r\n               \t\t<td>{{totalUSDBought}}</td>\r\n               \t\t<td class="summaryLabel">USD Brought(B)</td>\r\n               \t\t<td>{{totalUSDBought}}</td>\r\n               \t</tr>\r\n               \t\r\n               \t</table>\r\n               \r\n               </div> --></div></div><!--Trades Closed--><div role="tabpanel" class="tab-pane" id="Limits" ng-class="{active: vm.reportTab==\'Limits\'}"><form class="" role="form" name="frmtradinghomepage"><div class="bot-right-header-wrapper"><div class="row"><div class="col-sm-9"><div class="nav-tab-bot-header-left"><div ng-class="{clearcorp: account.entityOwnerType.shortName==\'Clearcorp\'}"><div class="up-btn"><cspl-table-export table-name="tblLimits" total-record-count="limitsAvailableForSelectedInstrument.length" no-of-records-per-page="vm.noOfRecordsPerPageLimit" filter-text="filterText" page-no="vm.pageLimit" file-name="LimitUtilisation_{{vm.custCode}}_{{vm.bankFilterForLimit.bankName}}"></cspl-table-export></div><div class="search-box order-entry-branch" ng-if="account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.bankFilterForLimit" control-id="txtbankFilterForLimit" lookup-name="tradingBank" control-place-holder="Enter bank name" filter-value="{{account.organisation.id}}" display-column="bankName" form="frmtradinghomepage"></cspl-ach></div><div class="search-box order-entry-branch" ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.bankFilterForLimit" control-id="txtbankFilterForLimit" lookup-name="bank" control-place-holder="Enter bank name" display-column="bankName" form="frmtradinghomepage" control-required="account.organisation.organisationType.shortName==\'CLEARCORP\'"></cspl-ach></div><div class="search-box order-entry-branch" ng-if="account.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.branchFilterForLimit" control-id="txtbranchFilterForLimit" lookup-name="validStatusBranchesForBank" filter-value="{{account.organisation.id}}" control-place-holder="Enter Branch ID or Name" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForLimit!=null && vm.branchFilterForLimit!=undefined">{{vm.branchFilterForLimit.branchName}}</span></div><div class="search-box order-entry-branch" ng-if="account.entityOwnerType.shortName==\'Clearcorp\'"><cspl-ach control-model="vm.branchFilterForLimit" control-id="txtbranchFilterForLimit" lookup-name="validStatusBranchesForBank" filter-value="{{vm.bankFilterForLimit.id}}" control-place-holder="Enter Branch ID or Name" display-column="branchId,branchName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.branchFilterForLimit!=null && vm.branchFilterForLimit!=undefined">{{vm.branchFilterForLimit.branchName}}</span></div><!-- <div class="search-box order-entry-branch"\r\n                           ng-if="account.entityOwnerType.shortName==\'Clearcorp\' && vm.bankFilterForLimit==null">\r\n                           <cspl-ach control-model="vm.branchFilterForLimit"\r\n                              control-id="txtbranchFilterForLimit"\r\n                              lookup-name="allBranches"\r\n                              control-place-holder="Enter Branch ID or Name"\r\n                              display-column="branchId,branchName"\r\n                              form="frmtradinghomepage"></cspl-ach>\r\n                           <span class="help-block"\r\n                              ng-show="vm.branchFilterForLimit!=null && vm.branchFilterForLimit!=undefined">{{vm.branchFilterForLimit.branchName}}</span>\r\n                        </div> --><div class="search-box" ng-if="account.organisation.organisationType.shortName==\'BANK\'"><cspl-ach control-model="vm.customerFilterForLimit" control-id="txtcustomerFilterForLimit" lookup-name="customer" filter-value="{{vm.bankFilterForLimit.id}}~~{{vm.branchFilterForLimit.id}}~~{{0}}" display-column="customerCode,customerName" form="approvalPolicyForm" control-place-holder="Enter Customer ID or Name"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForLimit!=null && vm.customerFilterForLimit!=undefined" title="{{vm.customerFilterForLimit.customerName}}">{{vm.customerFilterForLimit.customerName}}</span></div><div class="search-box" ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\'"><cspl-ach control-model="vm.customerFilterForLimit" control-place-holder="Enter Customer ID or Name" control-id="txtcustomerFilterForLimit" lookup-name="customer" filter-value="{{vm.bankFilterForLimit.id}}~~{{vm.branchFilterForLimit.id}}~~{{0}}" display-column="customerCode,customerName" form="frmtradinghomepage"></cspl-ach><span class="help-block" ng-show="vm.customerFilterForLimit!=null && vm.customerFilterForLimit!=undefined" title="{{vm.customerFilterForLimit.customerName}}">{{vm.customerFilterForLimit.customerName}}</span></div><div class="search-box" style="width: 110px"><cspl-ach control-model="vm.currencyPairForLimit" control-place-holder="Enter Currency Pair" control-id="txtcurrencyPairForLimit" lookup-name="currencyPair" filter-value="{{ vm.bankFilterForLimit.id ? vm.bankFilterForLimit.id : 0 }}" display-column="code" form="frmtradinghomepage" control-required="true"></cspl-ach></div><!-- <div class="search-box"\r\n                           ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForLimit==null && vm.bankFilterForLimit!=null">\r\n                           <cspl-ach control-model="vm.customerFilterForLimit"\r\n                              control-place-holder="Enter Customer ID or Name"\r\n                              control-id="txtcustomerFilterForLimit"\r\n                              lookup-name="customersForBank"\r\n                              filter-value="{{vm.bankFilterForLimit.id}}"\r\n                              display-column="customerCode,customerName"\r\n                              form="frmtradinghomepage"></cspl-ach>\r\n                           <span class="help-block"\r\n                              ng-show="vm.customerFilterForLimit!=null && vm.customerFilterForLimit!=undefined"\r\n                              title="{{vm.customerFilterForLimit.customerName}}">{{vm.customerFilterForLimit.customerName}}</span>\r\n                        </div> --> <!-- <div class="search-box"\r\n                           ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForLimit!=null && vm.bankFilterForLimit==null">\r\n                           <cspl-ach control-model="vm.customerFilterForLimit"\r\n                              control-place-holder="Enter Customer ID or Name"\r\n                              control-id="txtcustomerFilterForLimit"\r\n                              lookup-name="customersForBranch"\r\n                              filter-value="{{vm.branchFilterForLimit.id}}"\r\n                              display-column="customerCode,customerName"\r\n                              form="frmtradinghomepage"></cspl-ach>\r\n                           <span class="help-block"\r\n                              ng-show="vm.customerFilterForLimit!=null && vm.customerFilterForLimit!=undefined"\r\n                              title="{{vm.customerFilterForLimit.customerName}}">{{vm.customerFilterForLimit.customerName}}</span>\r\n                        </div> --> <!-- <div class="search-box"\r\n                           ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\' && vm.branchFilterForLimit==null && vm.bankFilterForLimit==null">\r\n                           <cspl-ach control-model="vm.customerFilterForLimit"\r\n                              control-place-holder="Enter Customer ID or Name"\r\n                              control-id="txtcustomerFilterForLimit"\r\n                              lookup-name="AllCustomers"\r\n                              display-column="customerCode,customerName"\r\n                              form="frmtradinghomepage"></cspl-ach>\r\n                           <span class="help-block"\r\n                              ng-show="vm.customerFilterForLimit!=null && vm.customerFilterForLimit!=undefined"\r\n                              title="{{vm.customerFilterForLimit.customerName}}">{{vm.customerFilterForLimit.customerName}}</span>\r\n                        </div> --><div class="select-box"><select name="select" class="select-opt" ng-model="vm.instrumentFilterForLimit" ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id"><option value="">--All--</option></select></div><div class="go-btn"><span ng-if="account.organisation.organisationType.shortName!=\'CLEARCORP\'"><button type="button" ng-disabled="vm.clickedReport || vm.currencyPairForLimit == null" class="btn btn-go" ng-click="vm.getLimitUtilisedReport();">GO</button></span> <span ng-if="account.organisation.organisationType.shortName==\'CLEARCORP\'"><button type="button" ng-disabled="vm.bankFilterForLimit==null||vm.clickedReport||vm.currencyPairForLimit == null" class="btn btn-go" ng-click="vm.getLimitUtilisedReport();">GO</button></span></div></div></div></div><div class="col-sm-3"><div class="nav-tab-bot-header-right text-right"><div class="search-field"><cspl-table-search control-model="filterTextForLimit"></cspl-table-search><span class="help-block-values"></span></div></div></div></div><!-- row ends --></div></form><div class="bot-right-table"><div class="table-responsive"><table id="tblLimits" class="table table-striped"><thead class="freeze-thead"><tr><th ng-show="account.organisation.organisationType.shortName==\'CUSTOMER\'" style="min-width: 40px"></th><th rowspan="2" ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'CUSTOMER\'">Bank</th><th rowspan="2" ng-show="account.entityOwnerType.shortName==\'Clearcorp\' || account.entityOwnerType.shortName==\'Bank\'">Branch</th><th rowspan="2" ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'BANK\'">Cust ID</th><th rowspan="2">Instrument</th><th rowspan="2">Limit Type</th><th rowspan="2" class="text-right">Allocated (USD)</th><th rowspan="2" class="text-right" ng-show="vm.currencyPairForLimit.code!=\'USDINR\'">Allocated (FCY)</th><th rowspan="2" class="border-right-column">Expiry Date</th><!-- <th></th> --><th colspan="8" class="text-center border-right-column" ng-show="vm.currencyPairForLimit.code==\'USDINR\'">Utilised</th><th colspan="2" class="text-center border-right-column">Un-utilised</th><th rowspan="2">Effective From</th><th rowspan="2">Effective To</th><th rowspan="2">Re-Instatement Method</th><th rowspan="2">Max. Tenor</th><th rowspan="2">Max. Value Date</th><th rowspan="2" class="text-right">Exposure %</th></tr><tr><!-- \t\t\t\t\t\t\t\t\t\t\t\t<th>Limit CCY</th> --><th ng-show="account.organisation.organisationType.shortName==\'CUSTOMER\'" style="min-width: 40px"></th><th class="text-right" ng-show="vm.currencyPairForLimit.code==\'USDINR\'">Pending Buy</th><th class="text-right" ng-show="vm.currencyPairForLimit.code==\'USDINR\'">Pending Sell</th><th class="text-right" ng-show="vm.currencyPairForLimit.code==\'USDINR\'">Buy Trade</th><th class="text-right" ng-show="vm.currencyPairForLimit.code==\'USDINR\'">Sell Trade</th><th class="text-right" ng-show="vm.currencyPairForLimit.code==\'USDINR\'">Prev. Buy Trade</th><th class="text-right" ng-show="vm.currencyPairForLimit.code==\'USDINR\'">Prev. Sell Trade</th><th class="text-right" ng-show="vm.currencyPairForLimit.code==\'USDINR\'">Total Buy</th><th class="text-right border-right-column" ng-show="vm.currencyPairForLimit.code==\'USDINR\'">Total Sell</th><th class="text-right">Buying Power</th><th class="text-right border-right-column">Selling Power</th><!-- <th class="text-right">Exposure %</th> --></tr></thead><tbody><tr ng-repeat="limit in filterData = (limitsAvailableForSelectedInstrument | filter : filterTextForLimit | orderBy : \'instId\' ) | limitTo:vm.noOfRecordsPerPageLimit:vm.noOfRecordsPerPageLimit*(vm.pageLimit-1)"><td ng-show="account.organisation.organisationType.shortName==\'CUSTOMER\'" class="freeze-column-left-OT"><label ng-show="account.organisation.organisationType.shortName==\'CUSTOMER\'" class="check-control"><input class="checkbox" name="Limits_{{$index}}" ng-model="limit.select" type="checkbox" ng-click="vm.checkOrUncheckLimitItem(limit, $event)"> <span class="checkbox-overlay"></span></label></td><td ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'CUSTOMER\'" class="minimize-field" title="{{limit.bankName}}"><span>{{limit.bankName}}</span></td><td ng-show="account.entityOwnerType.shortName==\'Clearcorp\' || account.entityOwnerType.shortName==\'Bank\'" class="minimize-field" title="{{limit.branchName}}"><span>{{limit.branchName}}</span></td><td ng-show="account.organisation.organisationType.shortName==\'CLEARCORP\' || account.organisation.organisationType.shortName==\'BANK\'" class="minimize-field" title="{{limit.customerCode}}"><span>{{limit.customerCode}}</span></td><td><span>{{limit.instrumentName}}</span></td><td><span ng-show="limit.limitType==\'GROSSBUY\'">Gross Buy</span> <span ng-show="limit.limitType==\'GROSSSELL\'">Gross Sell</span> <span ng-show="limit.limitType==\'GLOBALGROSS\'">Global Gross</span> <span ng-show="limit.limitType==\'NET\'">Net</span></td><!-- \t\t\t\t\t\t\t\t\t\t\t\t<td><span>{{limit.currencyCode}}</span></td> --><td class="text-right"><span>{{limit.limitAllocatedInUSD | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-show="vm.currencyPairForLimit.code!=\'USDINR\'"><span>{{limit.limitAllocatedInFCY | number:vm.noOfDecimalsForAmount}}</span></td><td><span>{{limit.effectiveTo | date:\'dd-MMM-yyyy\'}}</span></td><td class="text-right" ng-show="vm.currencyPairForLimit.code==\'USDINR\'"><span>{{limit.totalPendingBuyOrderValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-show="vm.currencyPairForLimit.code==\'USDINR\'"><span>{{limit.totalPendingSellOrderValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-show="vm.currencyPairForLimit.code==\'USDINR\'"><span>{{limit.totalBuyTradeValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-show="vm.currencyPairForLimit.code==\'USDINR\'"><span>{{limit.totalSellTradeValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-show="vm.currencyPairForLimit.code==\'USDINR\'"><span>{{limit.previousDayBuyTradeValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-show="vm.currencyPairForLimit.code==\'USDINR\'"><span>{{limit.previousDaySellTradeValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-show="limit.limitType!=\'NET\' && vm.currencyPairForLimit.code==\'USDINR\'"><span>{{limit.totalBuyTradeValue + limit.previousDayBuyTradeValue + limit.totalPendingBuyOrderValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-show="limit.limitType!=\'NET\' && vm.currencyPairForLimit.code==\'USDINR\'"><span>{{limit.totalSellTradeValue + limit.previousDaySellTradeValue + limit.totalPendingSellOrderValue | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-show="limit.limitType==\'NET\' && vm.currencyPairForLimit.code==\'USDINR\'"><span>{{limit.totalPendingBuyOrderValue+((limit.totalBuyTradeValue + limit.previousDayBuyTradeValue) - (limit.totalSellTradeValue + limit.previousDaySellTradeValue)) | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right" ng-show="limit.limitType==\'NET\' && vm.currencyPairForLimit.code==\'USDINR\'"><span>{{limit.totalPendingSellOrderValue+((limit.totalSellTradeValue + limit.previousDaySellTradeValue) - (limit.totalBuyTradeValue + limit.previousDayBuyTradeValue)) | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{vm.getBuyingPower(limit) | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span>{{vm.getSellingPower(limit) | number:vm.noOfDecimalsForAmount}}</span></td><td><span>{{limit.effectiveFrom | date:\'dd-MMM-yyyy\'}}</span></td><td><span>{{limit.effectiveTo | date:\'dd-MMM-yyyy\'}}</span></td><td><span>{{limit.limitReinstateTypeName}}</span></td><td ng-if="limit.maximumTenorValue==null"></td><td ng-if="limit.maximumTenorValue!=null && limit.maximumTenorType==\'Days\'">{{limit.maximumTenorValue | number:0}} Day(s)</td><td ng-if="limit.maximumTenorValue!=null && limit.maximumTenorType==\'Months\'">{{limit.maximumTenorValue | number:0}} Month(s)</td><td>{{limit.maximumValueDate | date:\'dd-MMM-yyyy\'}}</td><td class="text-right"><span>{{vm.getExposure(limit) | number:vm.noOfDecimalsForAmount}}</span></td></tr></tbody></table></div></div><div class="nav-tab-bot-right-footer"><div class="row"><div class="col-xs-8"><div ng-show="limitsAvailableForSelectedInstrument.length > 0"><cspl-pagination record-count="limitsAvailableForSelectedInstrument.length" control-model="vm.pageLimit" items-per-page="vm.noOfRecordsPerPageLimit"></cspl-pagination></div></div><div class="col-xs-4 text-right"><button type="button" class="btn btn-info active" ng-show="vm.permitCustomerLimitSettings && limitsAvailableForSelectedInstrument.length>0" ng-disabled="filterData<=0" ng-click="vm.changeRequest()">CHANGE REQUEST</button> <button type="button" class="btn btn-info active" ng-show="vm.permitCustomerLimitSettings && limitsAvailableForSelectedInstrument.length<=0" ng-disabled="vm.bankFilterForLimit==null || vm.bankFilterForLimit==undefined" ng-click="vm.newLimitRequest()">NEW LIMIT REQUEST</button></div></div></div></div><div role="tabpanel" class="tab-pane" id="markup_tab" ng-class="{active: vm.reportTab==\'markup_tab\'}"><div class="bot-right-header-wrapper"><div class="row"><div class="col-sm-9"><div class="nav-tab-bot-header-left"><div><div class="up-btn"><cspl-table-export table-name="tblMarkup" total-record-count="markupSettings.length" no-of-records-per-page="vm.noOfRecordsPerPageLimit" filter-text="filterText" page-no="vm.pageLimit" file-name="Markup_Details"></cspl-table-export></div><div class="search-box order-entry-branch" style="width: 110px" ng-if="account.organisation.organisationType.shortName==\'CUSTOMER\'"><cspl-ach control-model="vm.currencyPairForMarkup" control-id="txtCurrencyPairForMarkup" lookup-name="currencyPair" control-place-holder="Enter currency Pair" filter-value="{{vm.tradingBank.id ? vm.tradingBank.id : 0 }}" display-column="code" form="frmtradinghomepage"></cspl-ach></div><div class="go-btn" style="padding-left: 5px"><span ng-if="account.organisation.organisationType.shortName==\'CUSTOMER\'"><button type="button" ng-disabled="vm.currencyPairForMarkup==null||vm.clickedReport" class="btn btn-go" ng-click="vm.getMarkupReport(vm.currencyPairForMarkup.code);">GO</button></span></div></div></div></div><div class="col-sm-3"><div class="nav-tab-bot-header-right text-right"><div class="search-field"><cspl-table-search control-model="filterTextForLimit"></cspl-table-search><span class="help-block-values"></span></div></div></div></div><!-- row ends --></div><div class="bank-comparitive-contents mark-up"><div class="table-responsive table-fixed" ng-class="{\'table-container\': vm.account.organisation.organisationType.shortName!=\'BANK\'}"><table id="tblMarkup" class="table table-striped"><thead class="width-100"><tr><th style="width: 25%">Bank</th><th style="width: 16%">Markup Type</th><th class="text-center">Markup Value</th><th><span>RO/ED Applicability</span> <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Both legs means Mark-up will be charged on the Rebooking as well as on Cancellation Leg. Rebooking leg only means Mark-up will be charged on the Rebooking leg only" tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span><!-- <a ng-show="userPreference.showInfoIcon==\'yes\'" id="roEdApplicabilityPop" tabindex="0" data-toggle="popover" role="button" \r\n                              data-trigger="focus" data-placement="left" data-content="Both legs means Mark-up will be charged on the Rebooking as well as on Cancellation Leg. Rebooking leg only means Mark-up will be charged on the Rebooking leg only" \r\n                              data-template="<div class=\'mainViewPopover popover\' role=\'tooltip\'><div class=\'arrow\'></div><div class=\'popover-content\'></div></div>" >\r\n                              <span class="icon"><img class="home-page-help-icon" src="assets/images/Info-24.png" /></span>                          \r\n                              </a> --></th></tr></thead><tbody class="tbody-mark-up"><tr class="width-100" ng-repeat="markup in markupSettings"><td style="width: 25%"><span class="comp-name" style="width:130px" ng-class="{\'selected\': markup.bankName==vm.defaultTradingBank.bankName && vm.account.organisation.organisationType.shortName!=\'BANK\'}" ng-click="vm.onChangingBankInMarkup(markup.bankName)" title="{{markup.bankName}}">{{markup.bankName}}</span></td><td style="width: 16%"><span class="mdc-highlighted-txt">{{markup.markupType}}</span></td><td class="text-center"><span ng-show="markup.markupType.toLowerCase()==\'Paise\'.toLowerCase()">{{markup.markupValue | number:vm.noOfDecimalsForAmount}}</span> <span ng-show="markup.markupType.toLowerCase()==\'Percentage\'.toLowerCase()">{{markup.markupValue| number:vm.noOfDecimalsForPercent}}</span></td><td>{{markup.roEdApplicabilityMethodName}}</td></tr><tr class="width-100" ng-show="markupSettings.length<2 && vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"><td></td><td></td><td></td><td></td></tr><tr class="width-100" ng-show="markupSettings.length<3 && vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'"><td></td><td></td><td></td><td></td></tr></tbody></table></div><div class="clearfix"></div></div></div><!--Limits Closed--></div></div>');
$templateCache.put('app/entities/home-page-reports/home-page-reports.html','<form name="homePageReportsForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span>Home Page Reports</span></h4></div><div class="modal-body"><div class="content dashboard home-page-reports"><div ng-include="\'app/entities/home-page-reports/home-page-reports-view.html\'"></div></div></div></form>');
$templateCache.put('app/entities/instrument-view/instrument-view.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 ng-if="!vm.permitInstrumentEditEntityAction" class="view-title" data-translate="global.menu.instrumentView.main">Instrument View</h2><h2 ng-if="vm.permitInstrumentEditEntityAction" class="view-title" data-translate=" global.menu.ManageInstrument.main">Manage Instrument</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="float-right col-xs-10 col-sm-3 col-md-2"><cspl-table-search control-model="filterText"></cspl-table-search></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="instrumentView" total-record-count="vm.instruments.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Instruments"></cspl-table-export></div></div><div class="bootstrap-tableresponsive"><table id="instrumentView" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.instrumentView.currencyPair"></th><th data-translate="gatewayApp.instrumentView.instrument"></th><th style="padding-right:10px" class="paddingRight" data-translate="gatewayApp.instrumentView.tickSize"></th><th data-translate="gatewayApp.instrumentView.settlementDate"></th><th data-translate="gatewayApp.instrumentView.baseCurrency"></th><th data-translate="gatewayApp.instrumentView.counterCurrency"></th><th data-translate="gatewayApp.instrumentView.tokenseqNo"></th><th data-translate="gatewayApp.instrumentView.broadcastTokenseqNo"></th><th data-translate="gatewayApp.instrumentView.isInstrumentApplicable"></th><th ng-if="vm.permitInstrumentEditEntityAction"></th></tr></thead><tbody><tr ng-repeat="instrument in filterData = (vm.instruments | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{instrument.currencyPair.code}}</td><td>{{instrument.instrumentName}}</td><td class="paddingRight">{{instrument.tickSize}}</td><td ng-show="!instrument.isSettlementDateHoliday">{{instrument.settlementDate| date:\'dd-MMM-yy\'}}</td><td ng-show="instrument.isSettlementDateHoliday">-</td><td>{{instrument.baseCurrency}}</td><td>{{instrument.counterCurrency}}</td><td>{{instrument.tokenSequenceNumber}}</td><td>{{instrument.broadcastTokenSequenceNumber}}</td><td style="text-align:center" ng-if="instrument.instrumentApplicable">Yes</td><td style="text-align:center" ng-if="!instrument.instrumentApplicable">No</td><td ng-if="vm.permitInstrumentEditEntityAction" style="text-align:center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitInstrumentEditEntityAction"><a ui-sref="manage_instrument-edit({id: instrument.id})" ng-click="vm.screenLog.screenLog(vm.screenName,instrument.id,vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="vm.instruments.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/instrument-view/manage-instrument-dialog.html','<style>.btn-reject {\r\n        background-color: #f34743;\r\n        border: 1px solid #f34743;\r\n        color: white;\r\n    }\r\n\r\n    .btn-approve {\r\n        background-color: #37a36a;\r\n        border: 1px solid #37a36a;\r\n        color: white;\r\n    }</style><form name="manageInstrumentEditForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span ng-show="vm.manageInstrument.id!=null" data-translate="global.menu.ManageInstrument.main"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset><br><div class="col-sm-7 col-centered"><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.instrumentView.currencyPair"></span></label><cspl-ach control-model="vm.manageInstrument.currencyPair" control-id="txtcurrencyPair" lookup-name="currencyPair" control-disabled="true" display-column="code" placeholder="" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}" placeholder="" form="manageInstrumentEditForm" control-required="true"></div><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered" cspl-mandatory><span data-translate="gatewayApp.instrumentView.instrument"></span></label><div class="col-xs-12 col-md-12 multi-col"><cspl-text control-model="vm.manageInstrument.instrumentCode" control-id="txtfinancialyear" control-disabled="true" form="manageInstrumentEditForm" required></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered" class="control-label" cspl-mandatory><span data-translate="gatewayApp.instrumentView.isInstrumentApplicable"></span></label><div id="btnGroup" class="col-xs-12 col-md-12 multi-col"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.manageInstrument.instrumentApplicable" control-disabled="vm.viewMode || (vm.manageInstrument.id!=null || showResubmitButton)" uib-btn-radio="true">Yes</label><label class="btn btn-primary" ng-model="vm.manageInstrument.instrumentApplicable" control-disabled="vm.viewMode || (vm.manageInstrument.id!=null || showResubmitButton)" uib-btn-radio="false">No&nbsp;</label></div></div></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="manageInstrumentEditForm.$invalid || vm.clicked" ng-click="vm.clicked = true;vm.resubmit();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="manageInstrumentEditForm.$invalid || vm.clicked" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discard()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.reject()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approve();vm.clicked=true;" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/intraday-market-session-settings/intraday-market-session-settings-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="intradayMarketEdit" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span ng-show="vm.viewMode==false" data-translate="global.menu.intradayMarketSessionSettings.editIntradayMarketSessionSettings"></span> <span ng-show="vm.viewMode==true" data-translate="global.menu.intradayMarketSessionSettings.viewIntradayMarketSessionSettings"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="content" style="overflow:unset"><fieldset><br><div class="col-md-6 col-centered"><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered"><span data-translate="gatewayApp.intradayMarket.currenyPair"></span></label><cspl-ach class="col-xs-12 col-md-8 col-space" control-model="vm.currencyPair" control-id="txtCurrencyPair" lookup-name="currencyPair" display-column="code" placeholder="" form="intradayMarketEdit" control-disabled="true" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}"></div><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered" cspl-mandatory><span data-translate="gatewayApp.intradayMarket.instrument"></span></label><div id="btnGroup" class="col-xs-12 col-md-8 col-space" style="padding-bottom:8px"><div class="btn-group" style="height:30px;border:none"><label class="btn btn-primary" style="font-size:12px" ng-show="vm.intradayMarket.instrument.instrumentName==\'CASH\' " ng-model="vm.intradayMarket.instrument.instrumentName" uib-btn-radio="\'CASH\'" ng-disabled="true">CASH</label><label class="btn btn-primary" style="font-size:12px" ng-show="vm.intradayMarket.instrument.instrumentName==\'TOM\' " ng-model="vm.intradayMarket.instrument.instrumentName" uib-btn-radio="\'TOM\'" ng-disabled="true">TOM</label></div></div></div><div class="form-group"><label class="col-md-12 col-xs-12 col-centered control-label" cspl-mandatory><span data-translate="gatewayApp.intradayMarket.sessionOpen"></span></label><div class="col-md-7 col-xs-9 col-space"><cspl-time-picker control-model="vm.openTime" control-id="dtpSessionOpen" control24hrformat="false" form="intradayMarketEdit" control-disabled="vm.viewMode\r\n   \t\t\t\t\t \t\t   || vm.intradayMarket.sessionStatus==\'OPEN\'" required></div><span class="help-block" ng-show="vm.intradayMarket.sessionStatus==\'OPEN\'" data-translate="gatewayApp.intradayMarket.openSession"></span></div><div class="form-group"><label class="col-md-12 col-xs-12 col-centered control-label" cspl-mandatory><span data-translate="gatewayApp.intradayMarket.sessionClose"></span></label><div class="col-md-7 col-xs-9 col-space"><cspl-time-picker control-model="vm.closeTime" control-id="dtpSessionClose" control24hrformat="false" form="intradayMarketEdit" control-disabled="vm.viewMode" required></div><span class="help-block" ng-show="vm.intradayMarket.sessionStatus==\'CLOSED\' && !vm.validateSessionTime(vm.openTime)" data-translate="gatewayApp.intradayMarket.closeSession"></span></div><div class="form-group"><label class="col-md-12 col-xs-12 col-centered control-label" cspl-mandatory><span data-translate="gatewayApp.intradayMarket.businessDate"></span></label><div class="col-md-7 col-xs-9 col-space"><cspl-dtp control-model="vm.intradayMarket.businessDate" control-id="dtpBusinessDate" control-disabled="true" required></cspl-dtp></div></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="intradayMarketEdit.$invalid || vm.clicked" ng-click="vm.clicked = true;vm.resubmitIntradayMarket();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="intradayMarketEdit.$invalid||vm.clicked" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardIntradayMarket()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectIntradayMarket()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" autofocus class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveIntradayMarket();vm.clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/intraday-market-session-settings/intraday-market-session-settings.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.intradayMarketSessionSettings.manageIntradayMarketSessionSettings">Manage Intraday Market Session Settings</h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><br><div class="row col-md-12"><div class="row"><label class="col-md-2 col-xs-6 col-sm-2 control-label margin-top-7 no-padding-right" cspl-mandatory><span data-translate="gatewayApp.intradayMarket.businessDate"></span></label><div class="col-md-2 col-xs-10 no-padding-left"><cspl-dtp control-model="vm.currentBusinessDate" control-id="dtpBusinessDate" control-disabled="true" required></cspl-dtp></div></div></div><div class="row"><div class="float-right col-xs-10 col-sm-3 col-md-2"><cspl-table-search control-model="filterText"></cspl-table-search></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="tblIntradayMarketSessionSettings" total-record-count="vm.intradayMarket.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Intraday_Market_Session_Settings"></cspl-table-export></div></div><div class="bootstrap-tableresponsive"><table id="tblIntradayMarketSessionSettings" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.intradayMarket.currenyPair">Currency Pair</th><th data-translate="gatewayApp.intradayMarket.instrument">Instrument</th><th data-translate="gatewayApp.intradayMarket.sessionOpen">Session Open</th><th data-translate="gatewayApp.intradayMarket.sessionClose">Session Close</th><th data-translate="gatewayApp.intradayMarket.settlementDate">Settlement Date</th><th></th></tr></thead><tbody><tr ng-repeat="intraday in filterData = (vm.intradayMarket | filter : filterText | orderBy : \'instrument.id\')| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><!-- Column values --><td>{{intraday.instrument.currencyPair.code}}</td><td>{{intraday.instrument.instrumentName}}</td><td>{{intraday.openTime|uppercase}}</td><td>{{intraday.closeTime|uppercase}}</td><td ng-show="!intraday.instrument.isSettlementDateHoliday">{{intraday.instrument.settlementDate|date:\'dd-MMM-yyyy\'}}</td><td ng-show="intraday.instrument.isSettlementDateHoliday">-</td><td style="text-align:center"><div class="btn-group utility" ng-show="vm.permitIntradayMarketEditAction && intraday.instrument.isConfigurableInFxRetail==true" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ng-click="vm.editIntradayMarket(intraday,$event)"><span data-translate="entity.action.edit">Edit</span></a></li></ul></div></td></tr></tbody></table><div ng-show="vm.intradayMarket.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/invoice-view/invoice-view.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.invoiceView.title">Invoice View</h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px;  margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseInvoiceView = !vm.ExpandOrCollapseInvoiceView" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#InvoiceView"><img ng-src="{{vm.ExpandOrCollapseInvoiceView == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.invoiceView.criteria">Criteria</span></a></h4></div><div id="InvoiceView" class="collapse in" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="invoiceViewForm"><div class="col-md-offset-3 col-md-6 col-sm-6 col-xs-10 col-lg-4"><div class="row"><div class="col-md-1"><input type="radio" name="optradio" id="radio1" class="radio" ng-model="vm.selectedFilter" value="group" form="invoiceViewForm" style="margin-top: 5px"></div><div class="col-md-10"><label class="control-label" for="radio1" cspl-mandatory><span data-translate="gatewayApp.invoiceView.bank"></span></label></div><div class="col-md-1"></div></div><div class="row"><div class="col-md-1"><!--<span style="visibility: hidden;" class="icon" ><img  class="filter-seperation"  src="assets/images/Accordion_Expand_Line_Dark theme_Lighter shade.png" /></span> --></div><div class="col-md-11" style="margin-bottom:8px;padding-bottom:6px"><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bank" control-disabled="vm.selectedFilter==\'individual\'" display-column="bankName" placeholder="" form="invoiceViewForm" control-required="vm.selectedFilter==\'group\'"></div></div><div class="row"><div class="col-md-1"></div><div class="col-md-11"><label class="control-label"><span data-translate="gatewayApp.invoiceView.reportType"></span></label></div></div><div class="row"><div class="col-md-1"></div><div class="col-md-11" style="margin-bottom:8px;padding-bottom:6px"><select class="form-control select-style select-notRequired" name="reportType" ng-model="vm.chargesType" id="chargesType" ng-options="chargesType.description for chargesType in vm.chargeTypes track by chargesType.shortName" form="invoiceViewForm" ng-disabled="vm.selectedFilter==\'individual\'"><option value="">--ALL--</option></select></div></div><div class="row"><div class="col-md-1"></div><div class="col-md-11"><label class="control-label"><span data-translate="gatewayApp.invoiceView.financialYear"></span></label></div></div><div class="row"><div class="col-md-1"></div><div class="col-md-11" style="margin-bottom:8px;padding-bottom:6px"><select class="form-control select-style select-notRequired" name="financialYear" ng-model="vm.financialYear" id="financialYear" ng-options="financialYear.description for financialYear in vm.financialYears track by financialYear.description" form="invoiceViewForm" ng-disabled="vm.selectedFilter==\'individual\'" ng-change="vm.loadReportPeriods()"></select></div></div><div class="row"><div class="col-md-1"></div><div class="col-md-11"><label class="control-label"><span data-translate="gatewayApp.invoiceView.reportPeriod"></span></label></div></div><div class="row"><div class="col-md-1"></div><div class="col-md-11" style="margin-bottom:8px;padding-bottom:6px"><select class="form-control select-style select-notRequired" name="reportPeriod" ng-model="vm.reportPeriod" id="reportPeriod" ng-options="reportPeriod for reportPeriod in vm.reportPeriods track by reportPeriod" form="invoiceViewForm" ng-disabled="vm.selectedFilter==\'individual\'"><option value="">--ALL--</option></select></div></div><div class="row" style="padding-top:25px"><div class="col-md-1"><input type="radio" name="optradio" id="radio2" class="radio" ng-model="vm.selectedFilter" value="individual" form="invoiceViewForm" style="margin-top: 5px"></div><div class="col-md-10"><label class="control-label" for="radio2" cspl-mandatory><span data-translate="gatewayApp.invoiceView.invoiceNumber"></span></label></div></div><div class="row"><div class="col-md-1"><span style="visibility: hidden" class="icon"><img class="single-filter-seperation" src="assets/images/Accordion_Expand_Line_Dark theme_Lighter shade.png"></span></div><div class="col-md-10"><cspl-text control-model="vm.invoiceNumber" control-id="invoiceNumber" control-disabled="vm.selectedFilter==\'group\'" form="invoiceViewForm" control-required="vm.selectedFilter==\'individual\'"></div><div class="col-md-1"><button class="btn btn-info active" ng-disabled="invoiceViewForm.$invalid||vm.clicked" ng-click="vm.invoiceRegeneratedNumber=\'\';vm.isRegenerated=false;vm.getInvoiceView();vm.clicked=true;" data-toggle="collapse" data-target="#InvoiceView" data-translate="gatewayApp.invoiceView.show"></button></div></div><div class="row"><div class="col-md-1"></div><div class="col-md-11"><ul style="list-style-type:none;padding-left:0px;padding-top:5px"><li><span class="help-block" style="text-align:unset" ng-show="vm.selectedFilter==\'individual\'">Format&nbsp;&nbsp; : CC/&lt;TC/RC/AMC&gt;/&lt;Financialyear&gt;/&lt;Counter&gt;</span></li><li><span class="help-block" style="text-align:unset" ng-show="vm.selectedFilter==\'individual\'">Example&nbsp;: CC/TC/1819/001</span></li></ul></div></div></div></form></div></div></div><div ng-show="vm.invoiceView.length > 0"><div class="row"><cspl-table-export class="col-md-1 col-sm-1 col-xs-1" table-name="invoiceView" total-record-count="vm.filterData.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="Invoice"></cspl-table-export><cspl-table-search control-model="vm.filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="invoiceView" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.invoiceView.membershipId"></th><th data-translate="gatewayApp.invoiceView.bankName"></th><th data-translate="gatewayApp.invoiceView.chargeType"></th><th data-translate="gatewayApp.invoiceView.invoiceNumber"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.invoiceView.grossCharges"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.invoiceView.cgst"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.invoiceView.sgst"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.invoiceView.igst"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.invoiceView.utgst"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.invoiceView.netInvoice"></th><th data-translate="gatewayApp.invoiceView.memberNo"></th><th data-translate="gatewayApp.invoiceView.gstIn"></th><th data-translate="gatewayApp.invoiceView.legalName"></th><th data-translate="gatewayApp.invoiceView.tradeName"></th><th data-translate="gatewayApp.invoiceView.address"></th><th data-translate="gatewayApp.invoiceView.state"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.invoiceView.stateCode"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.invoiceView.appliedCgst"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.invoiceView.appliedSgst"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.invoiceView.appliedIgst"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.invoiceView.appliedUtgst"></th><th data-translate="gatewayApp.invoiceView.invoiceCopyOriginal"></th><th data-translate="gatewayApp.invoiceView.invoiceCopyDuplicate"></th><th data-translate="gatewayApp.invoiceView.annexureCopy"></th><th></th></tr></thead><tbody><tr ng-repeat="invoice in vm.filterData = (vm.invoiceView | filter : vm.filterText | orderBy : \'-createdDateTime\')| \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tlimitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)" ng-class="{\'coloredRow\':\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t (page-1)*noOfRecordsPerPage +$index ==0 && vm.isRegenerated}"><td>{{invoice.bank.ccpMembershipId}}</td><td>{{invoice.bank.bankName}}</td><td>{{invoice.chargesType.description}}</td><td>{{invoice.invoiceNumber}}</td><td class="td-text-align-right noPaddingLeftRight">{{invoice.grossCharges | amount}}</td><td class="td-text-align-right" style="padding-right:10px">{{(invoice.cgst | amount) || \'-\'}}</td><td class="td-text-align-right noPaddingLeftRight">{{(invoice.sgst | amount) || \'-\'}}</td><td class="td-text-align-right" style="padding-right:10px">{{(invoice.igst | amount) || \'-\'}}</td><td class="td-text-align-right noPaddingLeftRight">{{(invoice.utgst | amount) || \'-\'}}</td><td class="td-text-align-right" style="padding-right:10px">{{invoice.netInvoice | amount}}</td><td>{{invoice.bank.bankMemberNo}}</td><td>{{(invoice.gstIn) || \'-\'}}</td><td>{{invoice.legalName}}</td><td>{{invoice.tradeName}}</td><td>{{invoice.address}}</td><td>{{invoice.state}}</td><td class="td-text-align-right" style="padding-right:10px">{{invoice.stateCode}}</td><td class="td-text-align-right noPaddingLeftRight">{{invoice.appliedGst.cgst| number: vm.decimalsForPercent | percentage}}</td><td class="td-text-align-right" style="padding-right:10px">{{invoice.appliedGst.sgst | number: vm.decimalsForPercent| percentage}}</td><td class="td-text-align-right noPaddingLeftRight">{{invoice.appliedGst.igst | number: vm.decimalsForPercent| percentage}}</td><td class="td-text-align-right" style="padding-right:10px">{{invoice.appliedGst.utgst | number: vm.decimalsForPercent| percentage}}</td><td align="center"><a ng-click="vm.generatePDF(invoice,\'original\')" style="text-decoration:underline;text-align:center">{{invoice.originalFileName}}</a></td><td align="center"><a ng-click="vm.generatePDF(invoice,\'duplicate\')" style="text-decoration:underline">{{invoice.duplicateFileName}}</a></td><td align="center"><a ng-click="vm.generatePDF(invoice,\'annexure\')" style="text-decoration:underline">{{invoice.annexureFileName}}</a></td><td class="sticky-col" style="text-align:right"><div class="btn-group utility" uib-dropdown ng-show="vm.checkForRegeneration(invoice)"><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ng-click="vm.regenerateInvoice(invoice.id)"><!-- vm.regenerateInvoice(invoice.invoiceNumber) --> <span data-translate="gatewayApp.invoiceView.regenerate"></span></a></li></ul></div></td></tr></tbody></table></div><div ng-show="vm.invoiceView.length > 0"><cspl-pagination record-count="vm.filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="table-responsive" ng-show="vm.invoiceView.length==0"><span>No record found</span></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/limit-utilisation-splitup-report/limit-utilisation-splitup-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.limitUtilisationSplitup.title">Trade History</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseLimitUtilisationSplitup = !vm.ExpandOrCollapseLimitUtilisationSplitup" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#LimitUtilisationSplitup"><img ng-src="{{vm.ExpandOrCollapseLimitUtilisationSplitup == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.limitUtilisationSplitup.criteria">Criteria</span></a></h4></div><div id="LimitUtilisationSplitup" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="limitUtilisationSplitupForm"><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\'"><label class="control-label"><span data-translate="gatewayApp.limitUtilisationSplitup.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bank" display-column="bankName" placeholder="" form="limitUtilisationSplitupForm"></div><div class="form-group" ng-if="vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'"><label class="control-label"><span data-translate="gatewayApp.limitUtilisationSplitup.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtTradingbank" lookup-name="tradingBank" display-column="shortName" placeholder="" form="limitUtilisationSplitupForm" filter-value="{{vm.customer.id}}"></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\'"><label class="control-label"><span data-translate="gatewayApp.limitUtilisationSplitup.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="branchesForBank" display-column="branchName" placeholder="" form="limitUtilisationSplitupForm" filter-value="{{vm.bank.id}}"></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\'"><label class="control-label"><span data-translate="gatewayApp.limitUtilisationSplitup.customer"></span></label><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="allTypeCustomers" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" control-place-holder="Enter Customer ID or Name" display-column="customerCode,customerName" placeholder="" form="limitUtilisationSplitupForm"></div></div><div class="form-group"><div class="row"><label class="col-md-offset-3 control-label col-xs-6 col-md-6"><span data-translate="gatewayApp.limitUtilisationSplitup.instrument"></span></label><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><select name="select" class="form-control select-style non-mandatory" ng-model="vm.instrument" style="border-color:#595959" ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id"><option value="">--All--</option></select></div><div class="col-md-1 col-sm-1"><button class="btn btn-info active" ng-disabled="limitUtilisationSplitupForm.$invalid||vm.clicked" ng-click="vm.getLimitUtilisationSplitupHeaderList();vm.clicked=true;" data-toggle="collapse" data-target="#LimitUtilisationSplitup" data-translate="gatewayApp.limitUtilisationSplitup.go"></button></div></div></div></form></div></div></div><div ng-show="vm.limitUtilisationSplitupHeaderList.length > 0"><div class="row"><div class="dropdown col-md-3" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="limitUtilisationSplitup" class="dataTable table table-striped table-hover"><thead><tr><th ng-if="!vm.disableBank" class="min-width-100" data-translate="gatewayApp.limitUtilisationSplitup.bank"></th><th ng-if="!vm.disableBranch" class="min-width-100" data-translate="gatewayApp.limitUtilisationSplitup.branch"></th><th ng-if="!vm.disableCustomer" data-translate="gatewayApp.limitUtilisationSplitup.custId"></th><th ng-if="!vm.disableCustomer" class="min-width-100" data-translate="gatewayApp.limitUtilisationSplitup.customer"></th><th data-translate="gatewayApp.limitUtilisationSplitup.instrument"></th><th data-translate="gatewayApp.limitUtilisationSplitup.limitType"></th><th data-translate="gatewayApp.limitUtilisationSplitup.limitCCY"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.allocatedInUSD"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.pendingBuy"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.pendingSell"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.buyTrade"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.sellTrade"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.prevBuyTrade"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.prevSellTrade"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.totalBuy"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.totalSell"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.buyingPower"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.sellingPower"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.exposure"></th><th data-translate="gatewayApp.limitUtilisationSplitup.limitExpiryDate"></th><th data-translate="gatewayApp.limitUtilisationSplitup.limitReinstateMethod"></th><th data-translate="gatewayApp.limitUtilisationSplitup.maxTenor"></th><th data-translate="gatewayApp.limitUtilisationSplitup.maxValueDate"></th></tr></thead><tbody><tr ng-repeat="limitUtilisationSplitup in filterData = (vm.limitUtilisationSplitupHeaderList | filter : filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)" ng-click="vm.getLimitUtilSplitupDetails(limitUtilisationSplitup);"><td ng-if="!vm.disableBank">{{limitUtilisationSplitup.bankName}}</td><td ng-if="!vm.disableBranch">{{limitUtilisationSplitup.branchName}}</td><td ng-if="!vm.disableCustomer">{{limitUtilisationSplitup.customerCode}}</td><td ng-if="!vm.disableCustomer">{{limitUtilisationSplitup.customerName}}</td><td>{{limitUtilisationSplitup.instrumentName || \'ALL\'}}</td><td><span ng-show="limitUtilisationSplitup.limitType==\'GROSSBUY\'">Gross Buy</span> <span ng-show="limitUtilisationSplitup.limitType==\'GROSSSELL\'">Gross Sell</span> <span ng-show="limitUtilisationSplitup.limitType==\'GLOBALGROSS\'">Global Gross</span> <span ng-show="limitUtilisationSplitup.limitType==\'NET\'">Net</span></td><td>{{limitUtilisationSplitup.limitCCY}}</td><td class="td-text-align-right">{{limitUtilisationSplitup.totalAllocatedInUSD | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{limitUtilisationSplitup.pendingBuyOrder | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{limitUtilisationSplitup.pendingSellOrder | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{limitUtilisationSplitup.buyTrade | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{limitUtilisationSplitup.sellTrade | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{limitUtilisationSplitup.previousDayBuyTrade | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{limitUtilisationSplitup.previousDaySellTrade | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{limitUtilisationSplitup.totalBuy | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{limitUtilisationSplitup.totalSell | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{vm.getBuyingPower(limitUtilisationSplitup) | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{vm.getSellingPower(limitUtilisationSplitup) | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{vm.getExposure(limitUtilisationSplitup) | number : vm.noOfDecimalsForAmount}}</td><td><span>{{limitUtilisationSplitup.limitExpiryDate | date:\'dd-MMM-yyyy\'}}</span></td><td><span>{{limitUtilisationSplitup.limitReinstateTypeName}}</span></td><td ng-if="limitUtilisationSplitup.maximumTenorValue==null"></td><td ng-if="limitUtilisationSplitup.maximumTenorValue!=null && limitUtilisationSplitup.maximumTenorType==\'Days\'">{{limitUtilisationSplitup.maximumTenorValue | number:0}} Day(s)</td><td ng-if="limitUtilisationSplitup.maximumTenorValue!=null && limitUtilisationSplitup.maximumTenorType==\'Months\'">{{limitUtilisationSplitup.maximumTenorValue | number:0}} Month(s)</td><td>{{limitUtilisationSplitup.maximumValueDate | date:\'dd-MMM-yyyy\'}}</td></tr></tbody></table></div><div ng-show="filterData.length>0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><br><div ng-show="vm.showTradeDetails || vm.showOrderDetails"><div class="row"><label class="control-label font-16-px col-md-1" ng-if="vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'Clearcorp\'"><span data-translate="gatewayApp.limitUtilisationSplitup.bank"></span></label><label class="control-label font-16-px col-md-11" ng-if="vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'Clearcorp\'"><span>{{vm.selectedLimitUtilisationSplitupHeader.bankName}}</span></label><label class="control-label font-16-px col-md-1" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\'"><span data-translate="gatewayApp.limitUtilisationSplitup.customer"></span></label><label class="control-label font-16-px col-md-11" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\'"><span>{{vm.selectedLimitUtilisationSplitupHeader.customerName + \' (\' + vm.selectedLimitUtilisationSplitupHeader.customerCode+ \')\'}}</span></label><label class="control-label font-16-px col-md-1"><span data-translate="gatewayApp.limitUtilisationSplitup.instrument"></span></label><label class="control-label font-16-px col-md-11"><span>{{vm.selectedLimitUtilisationSplitupHeader.instrumentName || \'All\'}}</span></label></div></div><div ng-show="vm.showTradeDetails"><div class="row"><h3 class="col-md-7 margin-top-10"><span data-translate="gatewayApp.limitUtilisationSplitup.trades" class="details-table-header"></span></h3><div ng-show="vm.limitUtilSplitupTradeList.length>0" class="col-md-2 col-sm-3 col-xs-4 right-floating"><cspl-table-search control-model="filterTextTrade"></cspl-table-search></div></div><div class="table-responsive" ng-show="vm.limitUtilSplitupTradeList.length>0" style="overflow-x: auto; overflow-y: auto; max-height: 500px !important"><div class="row"></div><table id="limitUtilSplitupTradeDetails" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.limitUtilisationSplitup.tradeDate"></th><th data-translate="gatewayApp.limitUtilisationSplitup.tradeNo"></th><th data-translate="gatewayApp.limitUtilisationSplitup.settlementDate"></th><th data-translate="gatewayApp.limitUtilisationSplitup.currencyPair"></th><th data-translate="gatewayApp.limitUtilisationSplitup.instrument"></th><th data-translate="gatewayApp.limitUtilisationSplitup.limitInstrument"></th><th data-translate="gatewayApp.limitUtilisationSplitup.tradeType"></th><th data-translate="gatewayApp.limitUtilisationSplitup.settlementLeg"></th><th data-translate="gatewayApp.limitUtilisationSplitup.buySellFlag"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.tradedQuantityInUSD"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.appliedCF"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.activeUtilisation"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.bookingUtilisation"></th></tr></thead><tbody><tr ng-repeat="limitUtilSplitupTrade in filteredSplitupTradeDetails = (vm.limitUtilSplitupTradeList | filter : filterTextTrade) | limitTo:noOfRecordsPerPageTrade:noOfRecordsPerPageTrade*(pageTrade-1)"><td class="txt-no-wrap">{{limitUtilSplitupTrade.createdDateTime | date:\'dd-MMM-yyyy\'}}</td><td>{{limitUtilSplitupTrade.tradeSequenceNo}}</td><td>{{limitUtilSplitupTrade.settlementDate | date:\'dd-MMM-yyyy\'}}</td><td>{{limitUtilSplitupTrade.currencyPairCode}}</td><td>{{limitUtilSplitupTrade.instrumentCode}}</td><td>{{limitUtilSplitupTrade.limitInstrumentCode}}</td><td>{{limitUtilSplitupTrade.eventTypeName}}</td><td>{{limitUtilSplitupTrade.settlementLegName}}</td><td><span ng-show="limitUtilSplitupTrade.buySellFlag==\'BUYY\'">Buy</span> <span ng-show="limitUtilSplitupTrade.buySellFlag==\'SELL\'">Sell</span></td><td class="td-text-align-right">{{limitUtilSplitupTrade.tradedQuantity | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{limitUtilSplitupTrade.appliedCF | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{limitUtilSplitupTrade.activeUtilisation | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{limitUtilSplitupTrade.bookingUtilisation | number : vm.noOfDecimalsForAmount}}</td></tr></tbody></table></div><div ng-show="filteredSplitupTradeDetails.length>0"><cspl-pagination record-count="filteredSplitupTradeDetails.length" control-model="pageTrade" items-per-page="noOfRecordsPerPageTrade"></cspl-pagination></div><div class="table-responsive padding-left-10 padding-bottom-10" ng-show="vm.limitUtilSplitupTradeList==null || vm.limitUtilSplitupTradeList==undefined || vm.limitUtilSplitupTradeList.length==0"><span>No record found</span></div><br></div><div ng-show="vm.showOrderDetails"><div class="row"><h3 class="col-md-4 margin-top-10"><span data-translate="gatewayApp.limitUtilisationSplitup.pendingOrders" class="details-table-header"></span></h3><div ng-show="vm.limitUtilSplitupOrderList.length>0" class="col-md-2 col-sm-3 col-xs-4 right-floating"><cspl-table-search control-model="filterTextOrder"></cspl-table-search></div></div><div class="table-responsive" ng-show="vm.limitUtilSplitupOrderList.length>0" style="overflow-x: auto; overflow-y: auto; max-height: 500px !important"><div class="row"></div><table id="limitUtilSplitupOrderDetails" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.limitUtilisationSplitup.orderNo"></th><th data-translate="gatewayApp.limitUtilisationSplitup.settlementDate"></th><th data-translate="gatewayApp.limitUtilisationSplitup.currencyPair"></th><th data-translate="gatewayApp.limitUtilisationSplitup.instrument"></th><th data-translate="gatewayApp.limitUtilisationSplitup.limitInstrument"></th><th data-translate="gatewayApp.limitUtilisationSplitup.orderType"></th><th data-translate="gatewayApp.limitUtilisationSplitup.buySellFlag"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.orderQuantityInUSD"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.appliedCF"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.limitUtilisationSplitup.utilisation"></th></tr></thead><tbody><tr ng-repeat="limitUtilSplitupOrder in filteredSplitupOrderDetails = (vm.limitUtilSplitupOrderList | filter : filterTextOrder) | limitTo:noOfRecordsPerPageOrder:noOfRecordsPerPageOrder*(pageOrder-1)"><td>{{limitUtilSplitupOrder.orderSequenceNo}}</td><td>{{limitUtilSplitupOrder.tradeSettlementDate | date:\'dd-MMM-yyyy\'}}</td><td>{{limitUtilSplitupOrder.currencyPairCode}}</td><td>{{limitUtilSplitupOrder.instrumentCode}}</td><td>{{limitUtilSplitupOrder.limitInstrumentCode}}</td><td>{{limitUtilSplitupOrder.eventTypeName}}</td><td><span ng-show="limitUtilSplitupOrder.buySellFlag==\'BUYY\'">Buy</span> <span ng-show="limitUtilSplitupOrder.buySellFlag==\'SELL\'">Sell</span></td><td class="td-text-align-right">{{limitUtilSplitupOrder.orderQuantity | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{limitUtilSplitupOrder.appliedCF | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{limitUtilSplitupOrder.utilisation | number : vm.noOfDecimalsForAmount}}</td></tr></tbody></table></div><div ng-show="filteredSplitupOrderDetails.length>0"><cspl-pagination record-count="filteredSplitupOrderDetails.length" control-model="pageOrder" items-per-page="noOfRecordsPerPageOrder"></cspl-pagination></div><div class="table-responsive padding-left-10 padding-bottom-10" ng-show="vm.limitUtilSplitupOrderList==null || vm.limitUtilSplitupOrderList==undefined || vm.limitUtilSplitupOrderList.length==0"><span>No record found</span></div><br></div></div><div class="table-responsive" ng-show="vm.limitUtilisationSplitupHeaderList.length==0"><span>No record found</span></div></div></section></div><script src="assets/js/tables.js"></script><style>.total-bar {\r\n\tbackground-color: #1a260e !important;\r\n}\r\n\r\n.total-bar:hover {\r\n\tbackground: #1a260e !important;\r\n\tcolor: #F2F2F2 !important;\r\n}</style></div>');
$templateCache.put('app/entities/logged-in-users-for-bank/bank-loggedin-users.html','<div class="container-fluid"><div ncy-breadcrumb></div><!-- <h2 class="view-title" ><span data-translate="gatewayApp.loggedInUsersForBank.headerTitle"></span><span>{{vm.reportDate|date :\'dd-MMM-yyyy\'}}</span></h2> --><nmb-alert></nmb-alert><div class="col-lg-12"><section class="item" style="padding:5px"><div class="panel panel-primary"><div class="panel-heading text-left"><h2 class="view-title"><span data-translate="gatewayApp.loggedInUsersForBank.headerTitle"></span><span>{{vm.reportDate|date :\'dd-MMM-yyyy\'}}</span> <a href="" style="position: relative;float:right;  color: #fff" ng-class="{\'linkDisabled\' : vm.isRefreshDisabled}"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="!vm.isRefreshDisabled?refresh():\'\';" style="font-size:20px"></i></a></h2></div><div class="panel-body"><div class="module-content-inner"><div class="form-group row"><!-- <label class="col-sm-12 control-label" for="isLimitToBeReinstated" cspl-mandatory><span  data-translate="gatewayApp.limitSettings.isLimitTobeReInstated"></label>\r\n\t\t\t\t\t\t\t --><div id="btnGroup" class="col-sm-8" style="padding-bottom:7px"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.isAsOfNow" uib-btn-radio="vm.YES">As Of Now</label><label class="btn btn-primary" ng-model="vm.isAsOfNow" uib-btn-radio="vm.NO">For Today</label></div></div></div><div class="row"><label class="control-label font-16-px"><span data-translate="gatewayApp.loggedInUsersForBank.summary"></span></label></div><div><div class="row"><div class="dropdown col-md-3 col-xs-1" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div><!-- <cspl-table-search control-model="vm.filterText"\r\n\t\t\t\t\t\t\t\t\tclass=" col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search> --></div><div style="width: 40%"><table id="overAllSummary" name="overAllSummary" class="dataTable table table-striped table-hover"><thead><tr><th class="td-text-align-right" data-translate="gatewayApp.loggedInUsersForBank.noOfBankUsers"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedInUsersForBank.noOfBranchUsers"></th></tr></thead><tbody><tr><td class="td-text-align-right"><b><span class="numericHyperlinkFont" ng-if="vm.bankSummary.bankUsers == 0">{{vm.bankSummary.bankUsers}}</span> <span ng-if="vm.bankSummary.bankUsers > 0"><a href="" class="numericHyperlinkFont" ng-click="vm.getUserDetails(vm.bankSummary.bankId,vm.bankSummary.bankName, vm.BANK_TYPE,vm.BANK_TYPE);">{{vm.bankSummary.bankUsers}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="vm.bankSummary.noOfBranchUsers == 0" class="numericHyperlinkFont">{{vm.bankSummary.noOfBranchUsers}}</span> <span ng-if="vm.bankSummary.noOfBranchUsers > 0"><a href="" class="numericHyperlinkFont" ng-click="vm.getUserDetails(vm.bankSummary.bankId, vm.bankSummary.bankName, vm.BRANCH_TYPE,vm.BRANCH_TYPE);">{{vm.bankSummary.noOfBranchUsers}}</a></span></b></td></tr></tbody></table></div></div><br><div ng-if="vm.showUserDetailsDrillDown"><div class="row"><label class="control-label font-16-px">{{vm.userDetailsHeader}}</label></div><div ng-if="vm.userDetailsList.length>0"><div class="row"><div class="pull-left"><!-- <cspl-table-export table-name="userDetails" total-record-count="vm.userDetailsList.length" no-of-records-per-page="noOfRecordsPerUSerPage" \r\n\t\t\t\t\t\t\t\tfilter-text="vm.userSummaryFilterText" page-no="userPage" file-name="No_of_logged_in_User_Details"></cspl-table-export>\t --></div><cspl-table-search control-model="vm.userSummaryFilterText" control-id="userSearch" class="col-md-2 col-sm-3 col-xs-4 float-right"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="userDetails" name="userDetails" class="dataTable table table-striped table-hover"><thead><tr><!-- <th  ng-if = "(vm.showBankDetails || vm.showBranchDetails)" class="td-text-align-left" data-translate="gatewayApp.loggedInUsersForBank.bankName"></th> --><th ng-if="vm.showBranchDetails" class="td-text-align-left" data-translate="gatewayApp.loggedInUsersForBank.branchName"></th><th class="td-text-align-left" data-translate="gatewayApp.loggedInUsersForBank.userName"></th><th class="td-text-align-left" data-translate="gatewayApp.loggedInUsersForBank.mobile" style="min-width: 70px"></th><th class="td-text-align-left" data-translate="gatewayApp.loggedInUsersForBank.email"></th><!--<th  class="td-text-align-left" data-translate="gatewayApp.loggedInUsersForBank.status"></th>\r\n\t\t\t\t\t\t\t\t\t\t<th  class="td-text-align-left" data-translate="gatewayApp.loggedInUsersForBank.createdDateTime" style="max-width: 70px;    white-space: normal;"></th> --><th class="td-text-align-left" data-translate="gatewayApp.loggedInUsersForBank.lastSuccessfulLogin" style="max-width: 70px;    white-space: normal"></th><th class="td-text-align-left" data-translate="gatewayApp.loggedInUsersForBank.lastUnSuccessfulLogin" style="max-width: 70px;    white-space: normal"></th></tr></thead><tbody><tr ng-repeat="userDetailsRow in vm.userDetailsFilterData = (vm.userDetailsList | filter : vm.userSummaryFilterText) | limitTo:noOfRecordsPerUSerPage:noOfRecordsPerUSerPage*(userPage-1)"><!--<td ng-if = "(vm.showBankDetails || vm.showBranchDetails)" style="word-break:break-word;"> {{userDetailsRow.bankName || \'-\'}}</td> --><td ng-if="vm.showBranchDetails" style="word-break:break-word">{{userDetailsRow.branchName || \'-\'}}</td><td style="word-break:break-word">{{userDetailsRow.name}}</td><td style="word-break:break-word">{{userDetailsRow.mobileNumber}}</td><td style="word-break:break-word">{{userDetailsRow.email}}</td><!-- <td style="word-break:break-word;"> {{userDetailsRow.status}}</td>\r\n\t\t\t\t\t\t\t\t\t\t<td style="word-break:break-word;"> {{ (userDetailsRow.createdDateTime | date:\'dd-MMM-yyyy HH:mm:ss\') || \'-\' }}</td> --><td style="word-break:break-word">{{ (userDetailsRow.lastSuccessfulLogin | date:\'dd-MMM-yyyy HH:mm:ss\') || \'-\' }}</td><td style="word-break:break-word">{{ (userDetailsRow.lastUnsuccessfulLogin | date:\'dd-MMM-yyyy HH:mm:ss\') || \'-\'}}</td></tr></tbody></table></div><div ng-show="vm.userDetailsFilterData.length > 0"><cspl-pagination record-count="vm.userDetailsFilterData.length" control-model="userPage" items-per-page="noOfRecordsPerUSerPage"></cspl-pagination></div><div ng-show="vm.userDetailsFilterData.length == 0"><span>No record found</span></div></div><div ng-if="vm.userDetailsList.length==0 && vm.showUserDetailsDrillDown"><span>No record found</span></div></div></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/logged-in-users-for-bank/logged-in-users-for-bank.html','<div class="container-fluid" ng-cloak><div ncy-breadcrumb></div><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="col-lg-12"><section class="item" style="padding: 5px"><div class="panel panel-primary"><div class="panel-heading text-left"><span data-translate="gatewayApp.loggedInUsersForBank.headerTitle"></span><span>{{vm.reportDate|date :\'dd-MMM-yyyy\'}}</span> <a href="" style="position: relative; float: right; color: #fff" ng-class="{\'linkDisabled\' : vm.isRefreshDisabled}"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="!vm.isRefreshDisabled?refresh():\'\';" style="font-size: 20px"></i></a></div><div class="panel-body"><div class="module-content-inner"><div ng-if="vm.headerList.length>0"><div class="row"><div class="dropdown col-md-3 col-xs-1" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div><cspl-table-search control-model="vm.filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="headerList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.loggedInUsersForBank.bank" width="30%"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedInUsersForBank.noOfBankUsers" width="20%"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedInUsersForBank.noOfBranchUsers" width="20%"></th><th></th></tr></thead><tbody><tr ng-repeat="overallCountForbank in vm.filterData = (vm.headerList | filter : vm.filterText) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break: break-word">{{overallCountForbank.bankName}}</td><td class="td-text-align-right"><b><span class="numericHyperlinkFont" ng-if="overallCountForbank.bankUsersCount==0">{{overallCountForbank.bankUsersCount}}</span> <span ng-if="overallCountForbank.bankUsersCount>0"><a href="" class="numericHyperlinkFont" ng-click="vm.getBankUsersDetails(overallCountForbank.bankId, overallCountForbank.bankName);">{{overallCountForbank.bankUsersCount}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="overallCountForbank.branchUsersCount==0" class="numericHyperlinkFont">{{overallCountForbank.branchUsersCount}}</span> <span ng-if="overallCountForbank.branchUsersCount>0"><a href="" class="numericHyperlinkFont" ng-click="vm.getBranchWiseUsersCount(overallCountForbank.bankId, overallCountForbank.bankName);">{{overallCountForbank.branchUsersCount}}</a></span></b></td><td></td></tr></tbody><tfoot class="table-footer" ng-if="vm.filterData.length>0"><tr><td class="td-text-align-left" data-translate="gatewayApp.loggedInUsersForBank.total"></td><td class="td-text-align-right">{{vm.totalBankUsersCount}}</td><td class="td-text-align-right">{{vm.totalBranchUsersCount}}</td><td></td></tr></tfoot></table></div><div ng-show="vm.filterData.length > 0"><cspl-pagination record-count="vm.filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><div ng-show="vm.filterData.length == 0"><span>No record found</span></div></div><div ng-if="vm.headerList.length==0"><span>No record found</span></div><div ng-if="vm.showBranchDrillDown"><div class="row"><label class="control-label col-md-1 col-sm-2 col-xs-2"><span data-translate="gatewayApp.loggedInUsersForBank.bank"></span></label><label class="control-label"><span>{{vm.selectedBankName}}</span></label></div><div ng-if="vm.branchWiseUserCountList.length >0"><div class="row"><cspl-table-search control-model="vm.branchWiseFilterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="BranchWiseUserCountList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.loggedInUsersForBank.branch"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedInUsersForBank.usersCount"></th></tr></thead><tbody><tr ng-repeat="branch in vm.branchWiseUserFilterData = (vm.branchWiseUserCountList | filter : vm.branchWiseFilterText) | limitTo:noOfBranchRecordsPerPage:noOfBranchRecordsPerPage*(branchPage-1)"><td style="word-break: break-word">{{branch.branchName}}</td><td class="td-text-align-right"><b><span ng-if="branch.branchUsersCount==0" class="numericHyperlinkFont">{{branch.branchUsersCount}}</span> <span ng-if="branch.branchUsersCount>0" class="numericHyperlinkFont"><a href="" ng-click="vm.getBranchUsersDetails(branch.branchName , branch.branchId , branch.entityUserList);">{{branch.branchUsersCount}}</a></span></b></td></tr></tbody><tfoot class="table-footer" ng-if="vm.branchWiseUserFilterData.length>0"><tr><td class="td-text-align-left" data-translate="gatewayApp.loggedInUsersForBank.total"></td><td class="td-text-align-right">{{vm.totalBranchUserCountForBank }}</td></tr></tfoot></table></div><div ng-show="vm.branchWiseUserFilterData.length > 0"><cspl-pagination record-count="vm.branchWiseUserFilterData.length" control-model="branchPage" items-per-page="noOfBranchRecordsPerPage"></cspl-pagination></div><div ng-show="vm.branchWiseUserFilterData.length == 0"><span>No record found</span></div></div><div ng-show="vm.branchWiseUserCountList.length  == 0"><span>No record found</span></div></div><div ng-if="vm.showSelectedBankUsersDetails || vm.showSelectedBranchUsersDetails"><div class="row"><label class="control-label col-md-1"><span>{{vm.selectedEntityType}}</span></label><label class="control-label col-md-5"><span>{{vm.selectedEntityName}}</span></label></div><div ng-if="vm.selectedEntityUserList.length >0"><div class="row"><cspl-table-search control-model="vm.userFilterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="UserDetailsList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.loggedInUsersForBank.userName"></th><th data-translate="gatewayApp.loggedInUsersForBank.mobile"></th><th data-translate="gatewayApp.loggedInUsersForBank.emailID"></th></tr></thead><tbody><tr ng-repeat="user in userFilterData = (vm.selectedEntityUserList | filter : vm.userFilterText) | limitTo:noOfUserRecordsPerPage:noOfUserRecordsPerPage*(userPage-1)"><td style="word-break: break-word" ng-if="user.middleName!=null">{{user.firstName+\' \'+user.middleName+\' \'+user.lastName}}</td><td style="word-break: break-word" ng-if="user.middleName==null">{{user.firstName+\' \'+user.lastName}}</td><td>{{user.mobile}}</td><td>{{user.email}}</td></tr></tbody></table></div><div ng-show="userFilterData.length > 0"><cspl-pagination record-count="userFilterData.length" control-model="userPage" items-per-page="noOfUserRecordsPerPage"></cspl-pagination></div><div ng-show="userFilterData.length == 0"><span>No record found</span></div></div><div ng-show="vm.selectedEntityUserList.length == 0"><span>No record found</span></div></div></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/loggedin-users-report/cc-loggedin-users-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><!-- <h2 class="view-title" ><span data-translate="gatewayApp.loggedinUsers.headerTitle"></span><span>{{vm.reportDate|date :\'dd-MMM-yyyy\'}}</span></h2> --><nmb-alert></nmb-alert><div class="col-lg-12"><section class="item" style="padding:5px"><div class="panel panel-primary"><div class="panel-heading text-left"><h2 class="view-title"><span data-translate="gatewayApp.loggedinUsers.headerTitle"></span><span>{{vm.reportDate|date :\'dd-MMM-yyyy\'}}</span> <a href="" style="position: relative;float:right;  color: #fff" ng-class="{\'linkDisabled\' : vm.isRefreshDisabled}"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="!vm.isRefreshDisabled?refresh():\'\';" style="font-size:20px"></i></a></h2></div><div class="panel-body"><div class="module-content-inner"><div class="row"><label class="control-label font-16-px"><span data-translate="gatewayApp.loggedinUsers.overAllSummary"></span></label></div><div ng-if="vm.overallSummary.length>0"><div class="row"><div class="pull-left"><cspl-table-export table-name="overAllSummary" total-record-count="vm.overallSummary.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="vm.filterText" page-no="overallPage" file-name="No_of_logged_in_Users_Overall_Summary"></cspl-table-export></div><cspl-table-search control-model="vm.filterText" class="col-md-2 col-sm-3 col-xs-4 float-right"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="overAllSummary" name="overAllSummary" class="dataTable table table-striped table-hover"><thead><tr><th></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.asOfNow"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.forTheDay"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.ordersPlaced"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.traded"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.notLoggedIn"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.failedLoginAttempts"></th></tr></thead><tbody><tr ng-repeat="overalSummaryRow in vm.filterData = (vm.overallSummary | filter : vm.filterText) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break:break-word">{{overalSummaryRow.entityOwnerDisplayType}} {{\'Users\'}}</td><td class="td-text-align-right"><b><span class="numericHyperlinkFont" ng-if="overalSummaryRow.asOfNow == 0">{{overalSummaryRow.asOfNow}}</span> <span ng-if="overalSummaryRow.asOfNow > 0"><a href="" class="numericHyperlinkFont" ng-click="vm.getUsersLoggedInForTheMoment(0,\'\', overalSummaryRow.entityOwnerDisplayType,overalSummaryRow.entityOwnerDisplayType);">{{overalSummaryRow.asOfNow}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="overalSummaryRow.forTheDay == 0" class="numericHyperlinkFont">{{overalSummaryRow.forTheDay}}</span> <span ng-if="overalSummaryRow.forTheDay > 0"><a href="" class="numericHyperlinkFont" ng-click="vm.getUsersLoggedInForTheDay(0,\'\', overalSummaryRow.entityOwnerDisplayType,overalSummaryRow.entityOwnerDisplayType);">{{overalSummaryRow.forTheDay}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="overalSummaryRow.orderPlaced == 0" class="numericHyperlinkFont">{{overalSummaryRow.orderPlaced}}</span> <span ng-if="overalSummaryRow.orderPlaced > 0" class="numericHyperlinkFont"><a href="" ng-click="vm.getUsersOrderPlacedForTheDay(0,\'\', overalSummaryRow.entityOwnerDisplayType,vm.ORDER_TYPE);">{{overalSummaryRow.orderPlaced}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="overalSummaryRow.traded == 0" class="numericHyperlinkFont">{{overalSummaryRow.traded}}</span> <span ng-if="overalSummaryRow.traded > 0" class="numericHyperlinkFont"><a href="" ng-click="vm.getUsersTradedForTheDay(0,\'\', overalSummaryRow.entityOwnerDisplayType,vm.TRADE_TYPE);">{{overalSummaryRow.traded}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="overalSummaryRow.notLoggedIn == 0" class="numericHyperlinkFont">{{overalSummaryRow.notLoggedIn}}</span> <span ng-if="overalSummaryRow.notLoggedIn > 0" class="numericHyperlinkFont"><a href="" ng-click="vm.getUsersNotLoggedInForTheDay(0,\'\', overalSummaryRow.entityOwnerDisplayType,overalSummaryRow.entityOwnerDisplayType);">{{overalSummaryRow.notLoggedIn}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="overalSummaryRow.failedLoginUsers == 0" class="numericHyperlinkFont">{{overalSummaryRow.failedLoginUsers}}</span> <span ng-if="overalSummaryRow.failedLoginUsers > 0" class="numericHyperlinkFont"><a href="" ng-click="vm.getUsersFailedToLoginForTheDay (0,\'\', overalSummaryRow.entityOwnerDisplayType,overalSummaryRow.entityOwnerDisplayType);">{{overalSummaryRow.failedLoginUsers}}</a></span></b></td></tr><tr ng-if="vm.filterData.length>0" style="background-color: #2a2a2a;\tfont-size: 16px !important;color: #F2F2F2 !important"><td class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.totalUsers" style="font-size: 16px !important"></td><td class="td-text-align-right" style="font-size: 16px !important">{{vm.totalAsOfNowCount}}</td><td class="td-text-align-right" style="font-size: 16px !important">{{vm.totalForTheDayCount}}</td><td class="td-text-align-right" style="font-size: 16px !important">{{vm.totalOrderUsersCount }}</td><td class="td-text-align-right" style="font-size: 16px !important">{{vm.totalTradedUsersCount }}</td><td class="td-text-align-right" style="font-size: 16px !important">{{vm.totalNotLoggedInUsersCount }}</td><td class="td-text-align-right" style="font-size: 16px !important">{{vm.totalFailedLoginUsersCount }}</td></tr></tbody><!--  <tfoot class="table-footer" ng-if="vm.filterData.length>0">\r\n\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t<td  class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.totalUsers"></td>\t\r\n\t\t\t\t\t\t\t\t\t<td class="td-text-align-right" >{{vm.totalAsOfNowCount}}</td>\r\n\t\t\t\t\t\t\t\t\t<td class="td-text-align-right" >{{vm.totalForTheDayCount}}</td>\r\n\t\t\t\t\t\t\t\t\t<td class="td-text-align-right" >{{vm.totalOrderUsersCount }}</td>\r\n\t\t\t\t\t\t\t\t\t<td class="td-text-align-right" >{{vm.totalTradedUsersCount }}</td>\r\n\t\t\t\t\t\t\t\t\t<td class="td-text-align-right" >{{vm.totalNotLoggedInUsersCount }}</td>\r\n\t\t\t\t\t\t\t\t\t<td class="td-text-align-right" >{{vm.totalFailedLoginUsersCount }}</td>\r\n\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t</tfoot> --></table></div><div ng-show="vm.filterData.length == 0"><span>No record found</span></div></div><div ng-if="vm.overallSummary.length==0"><span>No record found</span></div><br><div class="row"><label class="control-label font-16-px"><span data-translate="gatewayApp.loggedinUsers.bankwiseSummary"></span></label></div><div ng-if="vm.bankwiseSummary.length>0"><div class="row"><div class="pull-left"><cspl-table-export table-name="bankwiseSummary" total-record-count="vm.bankwiseSummary.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="vm.bankwiseSummaryfilterText" page-no="page" file-name="No_of_logged_in_Users_Bankwise_Summary"></cspl-table-export></div><cspl-table-search control-model="vm.bankwiseSummaryfilterText" class="col-md-2 col-sm-3 col-xs-4 float-right"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="bankwiseSummary" name="bankwiseSummary" class="dataTable table table-striped table-hover"><thead><tr><th class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.bank"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.bankUsers"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.branchUsers"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.customerUsers"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.ordersPlaced"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.traded"></th></tr></thead><tbody><tr ng-repeat="bankwiseSummaryRow in vm.bankSummaryFilterData = (vm.bankwiseSummary | filter : vm.bankwiseSummaryfilterText) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break:break-word">{{bankwiseSummaryRow.bankName}}</td><td class="td-text-align-right"><b><span class="numericHyperlinkFont" ng-if="bankwiseSummaryRow.bankUsers == 0">{{bankwiseSummaryRow.bankUsers}}</span> <span ng-if="bankwiseSummaryRow.bankUsers > 0"><a href="" class="numericHyperlinkFont" ng-click="vm.getUsersLoggedInForTheDay(bankwiseSummaryRow.bankId,bankwiseSummaryRow.bankName, vm.BANK_TYPE,vm.BANK_TYPE);">{{bankwiseSummaryRow.bankUsers}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="bankwiseSummaryRow.noOfBranchUsers == 0" class="numericHyperlinkFont">{{bankwiseSummaryRow.noOfBranchUsers}}</span> <span ng-if="bankwiseSummaryRow.noOfBranchUsers > 0"><a href="" class="numericHyperlinkFont" ng-click="vm.getUsersLoggedInForTheDay(bankwiseSummaryRow.bankId, bankwiseSummaryRow.bankName, vm.BRANCH_TYPE,vm.BRANCH_TYPE);">{{bankwiseSummaryRow.noOfBranchUsers}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="bankwiseSummaryRow.noOfCustomerUsers == 0" class="numericHyperlinkFont">{{bankwiseSummaryRow.noOfCustomerUsers}}</span> <span ng-if="bankwiseSummaryRow.noOfCustomerUsers > 0" class="numericHyperlinkFont"><a href="" ng-click="vm.getCustomerUsersLoggedInForTheDay(bankwiseSummaryRow.bankId, bankwiseSummaryRow.bankName,vm.CUSTOMER_TYPE,vm.CUSTOMER_TYPE);">{{bankwiseSummaryRow.noOfCustomerUsers}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="bankwiseSummaryRow.noOfOrdersPlacedUsers == 0" class="numericHyperlinkFont">{{bankwiseSummaryRow.noOfOrdersPlacedUsers}}</span> <span ng-if="bankwiseSummaryRow.noOfOrdersPlacedUsers > 0" class="numericHyperlinkFont"><a href="" ng-click="vm.getUsersOrderPlacedForTheDay(bankwiseSummaryRow.bankId, bankwiseSummaryRow.bankName,\'\',vm.ORDER_TYPE);">{{bankwiseSummaryRow.noOfOrdersPlacedUsers}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="bankwiseSummaryRow.noOfradedUsers == 0" class="numericHyperlinkFont">{{bankwiseSummaryRow.noOfradedUsers}}</span> <span ng-if="bankwiseSummaryRow.noOfradedUsers > 0" class="numericHyperlinkFont"><a href="" ng-click="vm.getUsersTradedForTheDay(bankwiseSummaryRow.bankId, bankwiseSummaryRow.bankName,\'\',vm.TRADE_TYPE);">{{bankwiseSummaryRow.noOfradedUsers}}</a></span></b></td></tr></tbody></table></div><div ng-show="vm.bankSummaryFilterData.length > 0"><cspl-pagination record-count="vm.bankSummaryFilterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><div ng-show="vm.bankSummaryFilterData.length == 0"><span>No record found</span></div></div><div ng-if="vm.bankwiseSummary.length==0"><span>No record found</span></div><div ng-if="vm.showUserDetailsDrillDown"><div class="row"><label class="control-label font-16-px">{{vm.userDetailsHeader}}</label></div><div class="row" ng-if="vm.selectedBankId != 0 "><label class="control-label col-md-1 col-sm-2 col-xs-2"><span data-translate="gatewayApp.loggedinUsers.bank"></span></label><label class="control-label"><span>{{vm.selectedBankName}}</span></label></div><div ng-if="vm.userDetailsList.length>0"><div class="row"><div class="pull-left"><cspl-table-export table-name="userDetails" total-record-count="vm.userDetailsList.length" no-of-records-per-page="noOfRecordsPerUSerPage" filter-text="vm.userSummaryFilterText" page-no="userPage" file-name="No_of_logged_in_User_Details"></cspl-table-export></div><cspl-table-search control-model="vm.userSummaryFilterText" control-id="userSearch" class="col-md-2 col-sm-3 col-xs-4 float-right"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="userDetails" name="userDetails" class="dataTable table table-striped table-hover"><thead><tr><th ng-if="(vm.showBankDetails || vm.showBranchDetails)" class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.bankName"></th><th ng-if="vm.showBranchDetails" class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.branchName"></th><th ng-if="vm.showCustomerDetails" class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.customerName"></th><th ng-if="vm.showCustomerDetails" class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.customerCategory"></th><th ng-if="vm.showCustomerDetails" class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.customerID"></th><th class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.userName"></th><th class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.mobile" style="min-width: 70px"></th><th class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.email"></th><th class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.status"></th><th ng-if="vm.showDetailsForOrderorTradedUsers" class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.isOrdersPlaced" style="max-width: 25px;    white-space: normal"></th><th ng-if="vm.showDetailsForOrderorTradedUsers" class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.isTraded" style="max-width: 25px;    white-space: normal"></th><th class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.createdDateTime" style="max-width: 70px;    white-space: normal"></th><th class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.lastSuccessfulLogin" style="max-width: 70px;    white-space: normal"></th><th class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.lastUnSuccessfulLogin" style="max-width: 70px;    white-space: normal"></th></tr></thead><tbody><tr ng-repeat="userDetailsRow in vm.userDetailsFilterData = (vm.userDetailsList | filter : vm.userSummaryFilterText) | limitTo:noOfRecordsPerUSerPage:noOfRecordsPerUSerPage*(userPage-1)"><td ng-if="(vm.showBankDetails || vm.showBranchDetails)" style="word-break:break-word">{{userDetailsRow.bankName || \'-\'}}</td><td ng-if="vm.showBranchDetails" style="word-break:break-word">{{userDetailsRow.branchName || \'-\'}}</td><td ng-if="vm.showCustomerDetails" style="word-break:break-word">{{userDetailsRow.customerName || \'-\'}}</td><td ng-if="vm.showCustomerDetails" style="word-break:break-word">{{userDetailsRow.customerCategory || \'-\' }}</td><td ng-if="vm.showCustomerDetails" style="word-break:break-word">{{userDetailsRow.customerCode || \'-\' }}</td><td style="word-break:break-word">{{userDetailsRow.name}}</td><td style="word-break:break-word">{{userDetailsRow.mobileNumber}}</td><td style="word-break:break-word">{{userDetailsRow.email}}</td><td style="word-break:break-word">{{userDetailsRow.status}}</td><td ng-if="vm.showDetailsForOrderorTradedUsers" style="word-break:break-word"><span ng-if="userDetailsRow.ordersPlaced">{{\'Yes\'}} </span><span ng-if="!userDetailsRow.ordersPlaced">{{\'No\'}}</span></td><td ng-if="vm.showDetailsForOrderorTradedUsers" style="word-break:break-word"><span ng-if="userDetailsRow.tradesPlaced">{{\'Yes\'}} </span><span ng-if="!userDetailsRow.tradesPlaced">{{\'No\'}}</span></td><td style="word-break:break-word">{{ (userDetailsRow.createdDateTime | date:\'dd-MMM-yyyy HH:mm:ss\') || \'-\' }}</td><td style="word-break:break-word">{{ (userDetailsRow.lastSuccessfulLogin | date:\'dd-MMM-yyyy HH:mm:ss\') || \'-\' }}</td><td style="word-break:break-word">{{ (userDetailsRow.lastUnsuccessfulLogin | date:\'dd-MMM-yyyy HH:mm:ss\') || \'-\'}}</td></tr></tbody></table></div><div ng-show="vm.userDetailsFilterData.length > 0"><cspl-pagination record-count="vm.userDetailsFilterData.length" control-model="userPage" items-per-page="noOfRecordsPerUSerPage"></cspl-pagination></div><div ng-show="vm.userDetailsFilterData.length == 0"><span>No record found</span></div></div><div ng-if="vm.userDetailsList.length==0 && vm.showUserDetailsDrillDown"><span>No record found</span></div></div></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/loggedin-users-report/loggedin-users-report.html','<!--  This file not in use as of JULY 2021, new file cc-loggedin-users-report.html is used instead --><div class="container-fluid"><div ncy-breadcrumb></div><!-- <h2 class="view-title" ><span data-translate="gatewayApp.loggedinUsers.headerTitle"></span><span>{{vm.reportDate|date :\'dd-MMM-yyyy\'}}</span></h2> --><nmb-alert></nmb-alert><div class="col-lg-12"><section class="item" style="padding:5px"><div class="panel panel-primary"><div class="panel-heading text-left"><span data-translate="gatewayApp.loggedinUsers.headerTitle"></span><span>{{vm.reportDate|date :\'dd-MMM-yyyy\'}}</span> <a href="" style="position: relative;float:right;  color: #fff" ng-class="{\'linkDisabled\' : vm.isRefreshDisabled}"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="!vm.isRefreshDisabled?refresh():\'\';" style="font-size:20px"></i></a></div><div class="panel-body"><div class="module-content-inner"><div ng-if="vm.headerList.length>0"><div class="row"><div class="dropdown col-md-3" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div><cspl-table-search control-model="vm.filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="headerList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.loggedinUsers.bank"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.noOfBankUsers"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.noOfBranchUsers"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.noOfCustomerUSers"></th></tr></thead><tbody><tr ng-repeat="overallCountForbank in vm.filterData = (vm.headerList | filter : vm.filterText) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break:break-word">{{overallCountForbank.bankName}}</td><td class="td-text-align-right"><b><span class="numericHyperlinkFont" ng-if="overallCountForbank.bankUsersCount==0">{{overallCountForbank.bankUsersCount}}</span> <span ng-if="overallCountForbank.bankUsersCount>0"><a href="" class="numericHyperlinkFont" ng-click="vm.getBankUsersDetails(overallCountForbank.bankId, overallCountForbank.bankName);">{{overallCountForbank.bankUsersCount}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="overallCountForbank.branchUsersCount==0" class="numericHyperlinkFont">{{overallCountForbank.branchUsersCount}}</span> <span ng-if="overallCountForbank.branchUsersCount>0"><a href="" class="numericHyperlinkFont" ng-click="vm.getBranchWiseUsersCount(overallCountForbank.bankId, overallCountForbank.bankName);">{{overallCountForbank.branchUsersCount}}</a></span></b></td><td class="td-text-align-right"><b><span ng-if="overallCountForbank.customerUsersCount==0" class="numericHyperlinkFont">{{overallCountForbank.customerUsersCount}}</span> <span ng-if="overallCountForbank.customerUsersCount>0" class="numericHyperlinkFont"><a href="" ng-click="vm.getBranchWiseCustomerCount(overallCountForbank.bankId, overallCountForbank.bankName);">{{overallCountForbank.customerUsersCount}}</a></span></b></td></tr></tbody><tfoot class="table-footer" ng-if="vm.filterData.length>0"><tr><td class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.total"></td><td class="td-text-align-right">{{vm.totalBankUsersCount}}</td><td class="td-text-align-right">{{vm.totalBranchUsersCount}}</td><td class="td-text-align-right">{{vm.totalCustomerUsersCount }}</td></tr></tfoot></table></div><div ng-show="vm.filterData.length > 0"><cspl-pagination record-count="vm.filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><div ng-show="vm.filterData.length == 0"><span>No record found</span></div></div><div ng-if="vm.headerList.length==0"><span>No record found</span></div><div ng-if="vm.showBranchDrillDown"><div class="row"><label class="control-label col-md-1 col-sm-2 col-xs-2"><span data-translate="gatewayApp.loggedinUsers.bank"></span></label><label class="control-label"><span>{{vm.selectedBankName}}</span></label></div><div ng-if="vm.branchWiseUserCountList.length >0"><div class="row"><cspl-table-search control-model="vm.branchWiseFilterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="BranchWiseUserCountList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.loggedinUsers.branch"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.usersCount"></th></tr></thead><tbody><tr ng-repeat="branch in vm.branchWiseUserFilterData = (vm.branchWiseUserCountList | filter : vm.branchWiseFilterText) | limitTo:noOfBranchRecordsPerPage:noOfBranchRecordsPerPage*(branchPage-1)"><td style="word-break:break-word">{{branch.branchName}}</td><td class="td-text-align-right"><b><span ng-if="branch.branchUsersCount==0" class="numericHyperlinkFont">{{branch.branchUsersCount}}</span> <span ng-if="branch.branchUsersCount>0" class="numericHyperlinkFont"><a href="" ng-click="vm.getBranchUsersDetails(branch.branchName , branch.branchId , branch.entityUserList);">{{branch.branchUsersCount}}</a></span></b></td></tr></tbody><tfoot class="table-footer" ng-if="vm.branchWiseUserFilterData.length>0"><tr><td class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.total"></td><td class="td-text-align-right">{{vm.totalBranchUserCountForBank }}</td></tr></tfoot></table></div><div ng-show="vm.branchWiseUserFilterData.length > 0"><cspl-pagination record-count="vm.branchWiseUserFilterData.length" control-model="branchPage" items-per-page="noOfBranchRecordsPerPage"></cspl-pagination></div><div ng-show="vm.branchWiseUserFilterData.length == 0"><span>No record found</span></div></div><div ng-show="vm.branchWiseUserCountList.length  == 0"><span>No record found</span></div></div><div ng-if="vm.showCustomerCountForBranches"><div class="row"><label class="control-label col-md-1 col-sm-2 col-xs-2"><span data-translate="gatewayApp.loggedinUsers.bank"></span></label><label class="control-label"><span>{{vm.selectedBankName}}</span></label></div><div ng-if="vm.branchWiseCustomerCountList.length >0"><div class="row"><cspl-table-search control-model="vm.branchWiseCustomerFilterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="BranchWiseCustomerCountList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.loggedinUsers.branch"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.customersCount"></th></tr></thead><tbody><tr ng-repeat="branchCustomer in vm.branchWiseCustomerFilterData = (vm.branchWiseCustomerCountList | filter : vm.branchWiseCustomerFilterText) | limitTo:noOfBranchCustomerRecordsPerPage:noOfBranchCustomerRecordsPerPage*(branchCustomerPage-1)"><td style="word-break:break-word">{{branchCustomer.branchName}}</td><td class="td-text-align-right"><b><span ng-if="branchCustomer.customerCount>0" class="numericHyperlinkFont"><a href="" ng-click="vm.getBranchCustomerDetails(vm.selectedBankId, branchCustomer.branchId, branchCustomer.branchName);">{{branchCustomer.customerCount}}</a></span> <span ng-if="branchCustomer.customerCount==0" class="numericHyperlinkFont">{{branchCustomer.customerCount}}</span></b></td></tr></tbody><tfoot class="table-footer" ng-if="vm.branchWiseCustomerFilterData.length>0"><tr><td class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.total"></td><td class="td-text-align-right">{{vm.totalBranchCustomerCountForBank }}</td></tr></tfoot></table></div><div ng-show="vm.branchWiseCustomerFilterData.length > 0"><cspl-pagination record-count="vm.branchWiseCustomerFilterData.length" control-model="branchCustomerPage" items-per-page="noOfBranchCustomerRecordsPerPage"></cspl-pagination></div><div ng-show="vm.branchWiseCustomerFilterData.length== 0"><span>No record found</span></div></div><div ng-if="vm.branchWiseCustomerCountList.length ==0"><span>No record found</span></div></div><div ng-if="vm.showSelectedBranchCustomerDetails"><div class="row"><label class="control-label col-md-1 col-sm-1 col-xs-1"><span data-translate="gatewayApp.loggedinUsers.branch"></span></label><label class="control-label"><span>{{vm.selectedBranchName }}</span></label></div><div ng-if="vm.customerDetailsList.length >0"><div class="row"><cspl-table-search control-model="vm.customerFilterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="CustomerDetailsList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.loggedinUsers.customerId"></th><th data-translate="gatewayApp.loggedinUsers.customer"></th><th class="td-text-align-right" data-translate="gatewayApp.loggedinUsers.usersCount"></th></tr></thead><tbody><tr ng-repeat="customer in vm.customerFilterData = (vm.customerDetailsList | filter : vm.customerFilterText) | limitTo:noOfCustomerRecordsPerPage:noOfCustomerRecordsPerPage*(customerPage-1)"><td style="word-break:break-word">{{customer.customerCode}}</td><td style="word-break:break-word">{{customer.customerName}}</td><td class="td-text-align-right"><b><span ng-if="customer.customerUsersCount>0"><a href="" class="numericHyperlinkFont" ng-click="vm.getCustomerUserDetails(customer.customerName, customer.entityUserList);" class="numericHyperlinkFont">{{customer.customerUsersCount}}</a></span> <span ng-if="customer.customerUsersCount==0" class="numericHyperlinkFont">{{customer.customerUsersCount}}</span></b></td></tr></tbody><tfoot class="table-footer" ng-if="vm.customerFilterData.length>0"><tr><td class="td-text-align-left" data-translate="gatewayApp.loggedinUsers.total"></td><td></td><td class="td-text-align-right">{{vm.totalBranchCustomerUSerCount}}</td></tr></tfoot></table></div><div ng-show="vm.customerFilterData.length > 0"><cspl-pagination record-count="vm.customerFilterData.length" control-model="customerPage" items-per-page="noOfCustomerRecordsPerPage"></cspl-pagination></div><div ng-show="vm.customerFilterData.length == 0"><span>No record found</span></div></div><div ng-show="vm.customerDetailsList.length  == 0"><span>No record found</span></div></div><div ng-if="vm.showSelectedBankUsersDetails || vm.showSelectedBranchUsersDetails || vm.showSelectedCustomerUsersDetails"><div class="row"><label class="control-label col-md-1"><span>{{vm.selectedEntityType}}</span></label><label class="control-label col-md-5"><span>{{vm.selectedEntityName}}</span></label></div><div ng-if="vm.selectedEntityUserList.length >0"><div class="row"><cspl-table-search control-model="vm.userFilterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="bootstrap-tableresponsive"><table id="UserDetailsList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.loggedinUsers.userName"></th><th data-translate="gatewayApp.loggedinUsers.mobile"></th><th data-translate="gatewayApp.loggedinUsers.emailID"></th></tr></thead><tbody><tr ng-repeat="user in userFilterData = (vm.selectedEntityUserList | filter : vm.userFilterText) | limitTo:noOfUserRecordsPerPage:noOfUserRecordsPerPage*(userPage-1)"><td style="word-break:break-word" ng-if="user.middleName!=null">{{user.firstName+\' \'+user.middleName+\' \'+user.lastName}}</td><td style="word-break:break-word" ng-if="user.middleName==null">{{user.firstName+\' \'+user.lastName}}</td><td>{{user.mobile}}</td><td>{{user.email}}</td></tr></tbody></table></div><div ng-show="userFilterData.length > 0"><cspl-pagination record-count="userFilterData.length" control-model="userPage" items-per-page="noOfUserRecordsPerPage"></cspl-pagination></div><div ng-show="userFilterData.length == 0"><span>No record found</span></div></div><div ng-show="vm.selectedEntityUserList.length == 0"><span>No record found</span></div></div></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/manage-bbps-settings/manage-bbps-settings-details.html','<style>.btn-reject {\r\n\t\tbackground-color: #f34743;\r\n\t\tborder: 1px solid #f34743;\r\n\t\tcolor: white;\r\n\t}\r\n\r\n\t.btn-approve {\r\n\t\tbackground-color: #37a36a;\r\n\t\tborder: 1px solid #37a36a;\r\n\t\tcolor: white;\r\n\t}</style><form name="bbpsSettingViewForm" role="form" novalidate><div class="modal-header"><!-- <button ng-show="userPreference.showInfoIcon==\'yes\'" type="button" class="close" style="margin-right: 25px;" data-toggle="popover" data-trigger="focus"  data-placement="left" data-content="Mark-up Settings">\r\n\t\t<span class="icon" ><img class="width-height-20" src="assets/images/Info-24.png" /></span>\r\n\t</button> --> <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="global.menu.manageBBPSSetting.viewBBPSSetting"></span></h4><div class="modal-title" ng-if="vm.isModifyScreen==true"><span data-translate="gatewayApp.bbpsSetting.approved"></span></div></div><div class="modal-body"><div class="content"><fieldset><br><div class="col-xs-6 col-centered"><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.bbpsSetting.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="branch" filter-value="{{vm.orgId}}" display-column="bankName" control-disabled="true" form="bbpsSettingViewForm" required></cspl-ach></div><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.bbpsSetting.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="branch" filter-value="{{vm.orgId}}" display-column="branchName" control-disabled="true" form="bbpsSettingViewForm" required></cspl-ach></div><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered"><span data-translate="gatewayApp.bbpsSetting.markupValue"></span>&nbsp;* <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Mark-up Value" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span><!-- <button ng-show="userPreference.showInfoIcon==\'yes\'" type="button" class="transparentbg transparent-border margin-right-25" data-toggle="popover" data-trigger="focus"  data-placement="right" data-content="Mark-up Value">\r\n\t\t\t\t\t\t\t<span class="icon" ><img class="width-height-20" src="assets/images/Info-24.png" /></span>\r\n\t\t\t\t\t\t</button> --></label><div class="col-xs-12 col-md-6 multi-col"><cspl-text control-model="vm.markupType.value" control-disabled="true" form="bbpsSettingViewForm"></cspl-text></div><div class="col-xs-10 col-md-5 multi-col"><cspl-numeric control-model="vm.bbpsSetting.defaultMarkUpValue" control-id="txtMarkupValue" no-of-decimals="{{vm.noOfDecimals}}" form="bbpsSettingViewForm" control-disabled="true" required></cspl-numeric></div></div></div><div class="col-xs-6 col-centered" ng-show="vm.entityOwnerType==\'Clearcorp\'"><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered"><span data-translate="gatewayApp.bbpsSetting.taxOnMarkup"></span></label><div class="col-xs-12 col-md-6 multi-col"><cspl-numeric control-model="vm.bbpsSetting.taxOnMarkup" control-id="txtTaxOnMarkup" no-of-decimals="{{vm.decimalsForPercent}}" form="bbpsSettingViewForm" control-min="0" control-max="100" control-disabled="true"></cspl-numeric></div><div class="col-xs-1" style="line-height:30px"><span>%</span></div></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>OK</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardBBPSSetting()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showButton" class="btn btn-reject" ng-click="vm.rejectBBPSSetting()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" autofocus class="btn btn-approve" ng-disabled="clicked" ng-click="vm.approveBBPSSetting();clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/manage-bbps-settings/manage-bbps-settings-dialog.html','<style>.btn-reject {\r\n\t\tbackground-color: #f34743;\r\n\t\tborder: 1px solid #f34743;\r\n\t\tcolor: white;\r\n\t}\r\n\r\n\t.btn-approve {\r\n\t\tbackground-color: #37a36a;\r\n\t\tborder: 1px solid #37a36a;\r\n\t\tcolor: white;\r\n\t}</style><form name="bbpsSettingEditForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="global.menu.manageBBPSSetting.manageBBPSSetting"></span></h4><div class="modal-title" ng-if="vm.isModifyScreen==true"><span data-translate="gatewayApp.bbpsSetting.approved"></span></div></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset><br><div class="col-sm-6 col-centered"><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.bbpsSetting.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bank" filter-value="{{vm.orgId}}" display-column="bankName" control-disabled="true" form="bbpsSettingEditForm" required></cspl-ach></div><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.bbpsSetting.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="branch" filter-value="{{vm.bank.id}}" display-column="branchName" form="bbpsSettingEditForm" required></cspl-ach></div><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered"><span data-translate="gatewayApp.bbpsSetting.markupValue"></span>&nbsp;* <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Mark-up Value" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span><!-- <button ng-show="userPreference.showInfoIcon==\'yes\'" type="button" class="transparentbg transparent-border margin-right-25" data-toggle="popover" data-trigger="focus"  data-placement="right" data-content="Mark-up Value">\r\n\t\t\t\t\t\t\t<span class="icon" ><img class="width-height-20" src="assets/images/Info-24.png" /></span>\r\n\t\t\t\t\t\t</button> --></label><div class="col-xs-12 col-md-6 multi-col"><cspl-text control-model="vm.markupType.value" control-disabled="true" form="bbpsSettingEditForm"></cspl-text></div><div class="col-xs-10 col-md-5 multi-col"><cspl-numeric control-model="vm.bbpsSetting.defaultMarkUpValue" control-id="txtMarkupValue" no-of-decimals="{{vm.noOfDecimals}}" form="bbpsSettingEditForm" required></cspl-numeric></div></div></div><div class="col-xs-6 col-centered" ng-show="vm.entityOwnerType==\'Clearcorp\'"><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered"><span data-translate="gatewayApp.bbpsSetting.taxOnMarkup"></span></label><div class="col-xs-12 col-md-6 multi-col"><cspl-numeric control-model="vm.bbpsSetting.taxOnMarkup" control-id="txtTaxOnMarkup" no-of-decimals="{{vm.decimalsForPercent}}" form="bbpsSettingEditForm" control-min="0" control-max="100"></cspl-numeric></div><div class="col-xs-1" style="line-height:30px"><span>%</span></div></div></div></fieldset></div><div class="modal-footer"><div class="row"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showButton" class="btn btn-primary" ng-disabled="bbpsSettingEditForm.$invalid || vm.clicked" ng-click="vm.resubmitBBPSSettings();vm.clicked = true;"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="!showButton" ng-disabled="bbpsSettingEditForm.$invalid || (vm.bbpsSetting.id!=null && bbpsSettingEditForm.$pristine) || vm.clicked" class="btn btn-info active" ng-click="vm.save();vm.clicked = true;"><span data-translate="entity.action.save">Save</span></button></div><div class="justified-help-block float-right"><span data-translate="gatewayApp.bbpsSetting.helpText"></span></div></div></div></form>');
$templateCache.put('app/entities/manage-bbps-settings/manage-bbps-settings.html','<script>$(\'[data-toggle="popover"]\').popover({\r\n\t\tcontainer: \'body\',\r\n\t\thtml: true\r\n\t})</script><div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.manageBBPSSetting.main">BBPS Setting</h2><nmb-alert></nmb-alert><div><!-- <nmb-alert-error></nmb-alert-error> --></div><div class="module-wrapper"><section class="module"><div class="module-inner"><form name="BBPSSettingForm" role="form" novalidate><div ng-show="vm.entityOwnerType==\'Clearcorp\'"><div class="row"><label class="col-md-1 col-xs-4 control-label" style="margin-top: 7px"><span data-translate="gatewayApp.bbpsSetting.bank"></span></label><div class="col-md-3"><cspl-ach control-model="vm.bank" control-id="txtBranch" lookup-name="bank" display-column="bankName" form="BBPSSettingForm"></cspl-ach></div><div class="col-xs-1"><button type="button" class="btn btn-info active" ng-disabled="BBPSSettingForm.$invalid||vm.clicked" ng-click="vm.loadBBPSSetting(vm.bank);vm.clicked=true;">Go</button></div></div></div></form><div class="row"><div class="pull-left"><cspl-table-export table-name="bbpsSettings" total-record-count="vm.bbpsSettings.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Markup_Settings"></cspl-table-export></div><span class="partition">|</span><div class="pull-left"><a href="" style="color: #fff; vertical-align: -19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size: 20px"></i></a></div></div><div class="bootstrap-tableresponsive"><table id="bbpsSettings" class="dataTable table table-striped table-hover"><thead><tr><th ng-show="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.bbpsSetting.bank">bank</th><th data-translate="gatewayApp.bbpsSetting.branch">Branch</th><th class="" data-translate="gatewayApp.bbpsSetting.markupValue">Markup Value</th><th ng-show="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.bbpsSetting.taxOnMarkup">Tax on Markup</th><th class="" data-translate="gatewayApp.bbpsSetting.lastModifiedDateTime">last Modified Date Time</th><th></th></tr></thead><tbody><tr ng-repeat="bbpsSetting in filterData = (vm.bbpsSettings | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td ng-show="vm.entityOwnerType==\'Clearcorp\'" style="word-break:break-word">{{bbpsSetting.bank.bankName}}</td><td style="word-break:break-word">{{bbpsSetting.branch.branchName||\'-\'}}</td><td>{{(bbpsSetting.defaultMarkUpValue|number:vm.decimalsForPercent)||\'-\'}}</td><td ng-show="vm.entityOwnerType==\'Clearcorp\'">{{(bbpsSetting.taxOnMarkup|number:vm.decimalsForPercent)||\'-\'}}</td><td ng-show="bbpsSetting.defaultMarkUpValue != null && bbpsSetting.defaultMarkUpValue != null ">{{bbpsSetting.effectiveFromDate|date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td ng-show="bbpsSetting.defaultMarkUpValue == null && bbpsSetting.defaultMarkUpValue == null ">-</td><td style="border-top: 1px solid #333333" style="text-align:center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitBBPSSettingsViewEntityAction"><a ui-sref="bbps-settings-view({id: bbpsSetting.id})" ng-click="vm.screenLog.screenLog(vm.screenName,bbpsSetting.id,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitBBPSSettingsEditEntityAction"><a ui-sref="bbps-settings-edit({id: bbpsSetting.id})" ng-click="vm.screenLog.screenLog(vm.screenName,bbpsSetting.id,vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table><div style="padding:5px" ng-show="vm.bbpsSetting.length==0"><span>No record found</span></div><div ng-show="vm.bbpsSettings.length > 0"><cspl-pagination record-count="vm.bbpsSettings.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="row"><span class="orderStatusInfo right-floating italic-font" data-translate="gatewayApp.bbpsSetting.helpText"></span></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/manage-currency-pair-configuration/manage-currency-pair-configuration-details.html','<style>.btn-reject {\r\n\t\tbackground-color: #f34743;\r\n\t\tborder: 1px solid #f34743;\r\n\t\tcolor: white;\r\n\t}\r\n\r\n\t.btn-approve {\r\n\t\tbackground-color: #37a36a;\r\n\t\tborder: 1px solid #37a36a;\r\n\t\tcolor: white;\r\n\t}</style><form name="currencyPairConfigurationForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><span data-translate="global.menu.currencyPairConfiguration.currencyPairConfiguration"></span></h4></div><div class="modal-body" style="padding:30px"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset><div id="accordion"><div style="display: flex; flex-wrap: wrap; gap: 15px"><div ng-repeat="currencyPair in vm.currencyPairConfiguration" style="width: 23%"><label class="control-label" cspl-mandatory>{{currencyPair.currencyPair.code}}</label><div id="btnGroup" style="padding-bottom: 7px"><div class="btn-group"><label class="btn btn-primary" ng-model="currencyPair.isEnabled" ontrol-disabled="true" uib-btn-radio="true">Yes</label><label class="btn btn-primary" ng-model="currencyPair.isEnabled" ontrol-disabled="true" uib-btn-radio="false">No&nbsp;</label></div></div><a style="text-decoration: none" title="Change Config" ui-sref="change-config({headerLabel: \'OTP Specific Settings\',labelName: \'{{\'gatewayApp.applicationWideSettings.additionallyDeliverEmail\' | translate}}\' ,configName: \'DeliverOTPInUserEmail\' , configValue: vm.applicationWideSettings.deliverOTPInUserEmail, controlType : \'yesorno\', screenName : \'useradmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px;margin-top:6px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showButton" class="btn btn-primary" ng-disabled="currencyPairConfigurationForm.$invalid || vm.clicked" ng-click="vm.clicked = true;vm.resubmitForexConfigurations();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="!showButton" class="btn btn-info active" ng-disabled="currencyPairConfigurationForm.$invalid || vm.clicked || currencyPairConfigurationForm.$pristine" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/manage-currency-pair-configuration/manage-currency-pair-configuration-dialog.html','<form name="currecncyPairconfigForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span ng-if="!vm.bankId" data-translate="global.menu.currencyPairConfiguration.currencyPairConfiguration"></span><span ng-if="vm.bankId" data-translate="global.menu.currencyPairConfiguration.bankCurrencyPairConfiguration"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="row" ng-if="vm.bankId"><div class="col-md-8 col-md-offset-3"><label class="control-label" for="txtbank" cspl-mandatory><span data-translate="gatewayApp.currencyPairConfiguration.bankname"></span></label><cspl-ach control-id="txtbank" control-model="vm.currecncyPairConfigSettings.bank" lookup-name="bank" display-column="bankName" form="currencyPairConfigurationForm" control-required="true" control-disabled="true"></cspl-ach></div></div><br ng-if="vm.bankId"><div class="row"><div class="col-md-8 col-md-offset-3"><label class="control-label" cspl-mandatory><span data-translate="{{vm.labelName}}"></span></label></div></div><div class="row"><div id="btnGroup" class="col-md-4 col-md-offset-3"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.currecncyPairConfigSettings.isEnabled" ng-disabled="vm.isDisabled" uib-btn-radio="true">Yes</label><label class="btn btn-primary" ng-model="vm.currecncyPairConfigSettings.isEnabled" ng-disabled="vm.isDisabled" uib-btn-radio="false">No&nbsp;</label></div></div></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="isShowResubmit" class="btn btn-primary" ng-disabled="currecncyPairconfigForm.$invalid || vm.clicked" ng-click="vm.clicked=true;vm.resubmitCurrecncyPairConfigSettings();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" class="btn btn-info active" ng-if="isShowSaveButton" ng-disabled="currecncyPairconfigForm.$invalid || currecncyPairconfigForm.$pristine " ng-click="vm.clicked=true;vm.confirmSave();"><span data-translate="gatewayApp.currencyPairConfiguration.submit"></span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardCurrecncyPairConfigSettings()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-show="showButton" class="btn btn-reject" ng-click="vm.rejectCurrecncyPairConfigSettings()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.clicked=true;vm.approveCurrecncyPairConfigSettings();" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></div><script type="text/javascript">$(\'.clockpicker\').clockpicker({\r\n\t\t\tafterDone : function() {\r\n\t\t\t\tclockpicker.val(round());\r\n\t\t\t}\r\n\t\t}).find(\'input\');</script></form>');
$templateCache.put('app/entities/manage-currency-pair-configuration/manage-currency-pair-configuration.html','<style>.btn-reject {\r\n\t\tbackground-color: #f34743;\r\n\t\tborder: 1px solid #f34743;\r\n\t\tcolor: white;\r\n\t}\r\n\r\n\t.btn-approve {\r\n\t\tbackground-color: #37a36a;\r\n\t\tborder: 1px solid #37a36a;\r\n\t\tcolor: white;\r\n\t}</style><form name="currencyPairConfigurationForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="global.menu.currencyPairConfiguration.currencyPairConfiguration"></span></h4></div><div class="modal-body" style="padding:30px"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div ng-if="vm.entityOwnerType==\'Clearcorp\'"><!-- Row: col-md-3 toggles | col-md-6 label+filter | col-md-3 GO --><div class="row" style="margin-bottom:15px"><!-- col 1: Mode toggle --><div class="col-md-3 col-sm-3" style="padding-top:22px"><div id="btnGroup"><div class="btnGroup"><div class="btn-group noPaddingMargin" style="width: auto; margin-bottom: 8px"><label class="btn btn-primary" ng-model="vm.selectedMode" ng-click="vm.onModeChange(\'CLEARCORP\')" uib-btn-radio="\'CLEARCORP\'"><span data-translate="gatewayApp.currencyPairConfiguration.clearcorp"></span></label><label class="btn btn-primary" ng-model="vm.selectedMode" ng-click="vm.onModeChange(\'BANK\')" uib-btn-radio="\'BANK\'"><span data-translate="gatewayApp.currencyPairConfiguration.bank"></span></label></div></div></div></div><!-- col 2: Bank Name label + filter (BANK mode only) --><div class="col-md-6 col-sm-6" ng-if="vm.selectedMode == \'BANK\'"><label class="control-label" for="txtbank" cspl-mandatory><span data-translate="gatewayApp.currencyPairConfiguration.bankname"></span></label><cspl-ach control-id="txtbank" control-model="vm.bank" lookup-name="bank" display-column="bankName" form="currencyPairConfigurationForm" control-required="true"></cspl-ach></div><!-- col 3: GO button --><div class="col-md-3 col-sm-3" style="padding-top:22px"><button type="button" class="btn btn-info active" ng-if="vm.selectedMode == \'BANK\'" ng-disabled="!vm.bank || vm.clicked" ng-click="vm.getCurrencyConfig(vm.bank); vm.clicked=true;">Go</button> <button type="button" class="btn btn-info active" ng-if="vm.selectedMode == \'CLEARCORP\'" ng-disabled="vm.clicked" ng-click="vm.getClearcorpCurrencyConfig(); vm.clicked=true;">Go</button></div></div></div><div class="content"><fieldset><div id="accordion"><div style="display: flex; flex-wrap: wrap; gap: 15px; margin-top: 35px"><div ng-repeat="currencyPair in vm.currencyPairConfiguration" style="width: 23%"><label class="control-label" cspl-mandatory>{{currencyPair.currencyPair.code}}</label><div id="btnGroup" style="padding-bottom: 7px"><div class="btn-group"><label class="btn btn-primary" ng-model="currencyPair.isEnabled" ng-disabled="true" uib-btn-radio="true">Yes</label><label class="btn btn-primary" ng-model="currencyPair.isEnabled" ng-disabled="true" uib-btn-radio="false">No&nbsp;</label></div><!-- BANK mode edit link --> <a style="text-decoration: none; cursor: pointer" title="Change Config" ng-if="vm.permitCurrencyPairConfigurationEditEntityAction && vm.selectedMode == \'BANK\'" ng-click="vm.editConfiguration(\'BANK\', currencyPair)"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px; margin-top:6px">&nbsp;<span aria-hidden="true" class="icon"></span> </a><!-- CLEARCORP mode edit link --> <a style="text-decoration: none; cursor: pointer" title="Change Config" ng-if="vm.permitCurrencyPairConfigurationEditEntityAction && vm.selectedMode == \'CLEARCORP\'" ng-click="vm.editConfiguration(\'CLEARCORP\', currencyPair)"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px; margin-top:6px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div></div></div></div></fieldset></div><div class="modal-footer"><button ng-if="vm.currencyPairConfiguration.length>0" type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showButton" class="btn btn-primary" ng-disabled="currencyPairConfigurationForm.$invalid || vm.clicked" ng-click="vm.clicked = true;vm.resubmitForexConfigurations();"><span data-translate="entity.action.resubmit">Resubmit</span></button></div></div></form>');
$templateCache.put('app/entities/manage-entity-restrictions/manage-entity-restrictions.html','<style>.tab {\r\n\tmargin-left: 16%;\r\n}\r\n\r\n@media screen and (max-width: 324px) {\r\n\t#btnGroup .btn {\r\n\t\tfont-size: 10px;\r\n\t}\r\n\t.tab-padding {\r\n\t\tpadding-right: 5px;\r\n\t\tpadding-left: 5px;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 992px) {\r\n\t.tab {\r\n\t\tmargin-left: 8%;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 580px) {\r\n\t.tab {\r\n\t\tmargin-left: 0px;\r\n\t}\r\n}</style><form name="mangeuserrestrictionsform" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="">Manage Entity Restrictions</span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="content"><fieldset><div class="col-sm-10 col-xs-12 col-lg-8 col-md-8 col-centered" style="padding-left:6px"><label class="control-label">Entity</label><div id="btnGroup"><div class="btn-group noPaddingMargin" style="width: auto;margin-bottom:8px"><label class="btn btn-primary" ng-model="vm.entity" ng-show="vm.isShowBankEntity" uib-btn-radio="\'BANK\'">Bank</label><label class="btn btn-primary" ng-model="vm.entity" ng-show="vm.isShowBranchEntity" uib-btn-radio="\'BRANCH\'">Branch</label><label class="btn btn-primary" ng-model="vm.entity" ng-show="vm.isShowCustomerEntity" uib-btn-radio="\'CUSTOMER\'">Customer</label><label class="btn btn-primary" ng-model="vm.entity" ng-show="vm.isShowCustomerRelationshipEntity" uib-btn-radio="\'CUSTREL\'">Customer Relationship</label></div></div></div><div class="col-sm-10 col-xs-12 col-lg-8 col-md-8 col-centered"><div id="ccil"><div class="form-group col-sm-9 col-md-11 col-lg-10 col-xs-9" ng-show="vm.entity == \'BANK\' || vm.entity == \'CUSTREL\' || vm.entity == \'BRANCH\'"><label class="control-label" for="txtbank" cspl-mandatory>Bank</label><cspl-ach theme-type="{{vm.theme}}" control-id="txtbank" control-model="vm.bank" control-disabled="vm.isBankDisabled || vm.isDisabled" lookup-name="bank" display-column="bankName" control-required="vm.entity == \'BANK\' || vm.entity == \'CUSTREL\'" form="mangeuserrestrictionsform"></div><div class="form-group col-sm-9 col-md-11 col-lg-10 col-xs-9" ng-show="vm.entity == \'CUSTREL\' || vm.entity == \'BRANCH\'"><label class="control-label" for="txtbranch" cspl-mandatory>Branch</label><cspl-ach theme-type="{{vm.theme}}" control-id="txtbranch" control-model="vm.branch" lookup-name="activeBranch" control-disabled="vm.isBranchDisabled || vm.isDisabled" control-required="vm.entity == \'CUSTREL\' || vm.entity == \'BRANCH\'" display-column="shortName" filter-value="{{vm.bank.id}}" form="mangeuserrestrictionsform"></div><div class="form-group col-sm-9 col-md-11 col-lg-10 col-xs-9" ng-show="vm.entity == \'CUSTREL\'"><label class="control-label" for="txtCustomer" cspl-mandatory>Customer</label><cspl-ach theme-type="{{vm.theme}}" lookup-name="allTypeAndStatusCustomers" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" display-column="customerCode,customerName" control-place-holder="Enter Customer ID or Name" control-id="txtCustomer" control-disabled="vm.isDisabled" control-required="vm.entity == \'CUSTREL\' || vm.entity == \'CUSTOMER\'" control-model="vm.customer" form="mangeuserrestrictionsform"></cspl-ach><span class="cutomer-highlight margin-bottom-0" ng-if="vm.customer.customerMiddleName==null">{{vm.customer.customerFirstName+\' \'+vm.customer.customerLastName}}</span> <span class="cutomer-highlight margin-bottom-0" ng-if="vm.customer.customerMiddleName!=null">{{vm.customer.customerFirstName+\' \'+ vm.customer.customerMiddleName+\' \'+vm.customer.customerLastName}}</span></div><div class="form-group col-sm-9 col-md-11 col-lg-10 col-xs-9" ng-show="vm.entity == \'CUSTOMER\'"><label class="control-label" for="txtCustomer" cspl-mandatory>Customer</label><cspl-ach theme-type="{{vm.theme}}" lookup-name="AllCustomers" display-column="customerCode,customerName" control-place-holder="Enter Customer ID or Name" display-column="shortName" control-id="txtCustomer" control-disabled="vm.isDisabled" control-required="vm.entity == \'CUSTREL\' || vm.entity == \'CUSTOMER\'" control-model="vm.customer" form="mangeuserrestrictionsform"></cspl-ach><span class="cutomer-highlight margin-bottom-0" ng-if="vm.customer.customerMiddleName==null">{{vm.customer.customerFirstName+\' \'+vm.customer.customerLastName}}</span> <span class="cutomer-highlight margin-bottom-0" ng-if="vm.customer.customerMiddleName!=null">{{vm.customer.customerFirstName+\' \'+ vm.customer.customerMiddleName+\' \'+vm.customer.customerLastName}}</span></div><div id="restrictioncontainer" ng-show="vm.isShowRestrictionDetails"><div class="form-group col-sm-12 col-xs-12 col-md-10 col-lg-8"><div><label class="control-label">Current Status</label></div><div><label class="control-label restrictions-lbl" control-id="statuslbl"><span class="restriction-span">{{vm.currentStatus}}</span></label></div></div><div class="form-group col-xs-10 col-md-10 col-lg-9 col-sm-10" ng-show="vm.showChangeStatus"><div><label class="control-label" for="txtbank" cspl-mandatory ng-show="vm.showChangeStatus"><span>Change Status</span></label></div><div><select class="form-control select-style" ng-disabled="vm.isDisabled" ng-required="true" control-id="selRestriction" ng-model="vm.newStatus" ng-selected="vm.newStatus" ng-options="availableStatus as availableStatus for availableStatus in vm.availableStatusList" ng-show="vm.showChangeStatus"></select></div></div><div class="form-group col-xs-10 col-md-10 col-lg-9 col-sm-10"><div><label class="control-label" for="txtbank" cspl-mandatory><span>Reason</span></label></div><div><select class="form-control select-style" ng-disabled="vm.isDisabled" ng-required="true" control-id="selRestrictionReason" ng-model="vm.restrictionReason" name="restrictionReason" id="restrictionReason" ng-options="restrictionReason.name for restrictionReason in vm.restrictionReasonsList track by restrictionReason.shortName"></select></div></div><div class="form-group col-xs-10 col-md-10 col-lg-9 col-sm-10"><label class="control-label" for="txtRemarks" cspl-mandatory><span>Remarks</span></label><cspl-multiline-text control-model="vm.remarks" control-rows="5" control-disabled="vm.isDisabled" control-maxlength="1000" control-id="txtRemarks" form="mangeuserrestrictionsform" ng-required="true"></cspl-multiline-text></div></div></div></div></fieldset></div><div class="modal-footer col-centered"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="isShowResubmit" class="btn btn-primary" ng-disabled="mangeuserrestrictionsform.$invalid || clicked" ng-click="vm.resubmit();clicked = true;"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" class="btn btn-info active" ng-if="isShowSaveButton" ng-disabled="mangeuserrestrictionsform.$invalid || clicked" ng-click="clicked = true;vm.save();"><span>Save</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discard()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showButton" class="btn btn-reject" ng-click="vm.reject()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" class="btn btn-approve" ng-disabled="clicked" ng-click="clicked=true;vm.approve(); autofocus"><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/manage-home-branch/manage-home-branch-delete-dialog.html','s<form name="deleteForm" ng-submit="clicked=true;vm.confirmDelete(vm.homebranch.id)"><div class="modal-header-red"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" style="text-align:left;padding-left:3%">Are you sure want to delete?</h4></div><div class="modal-body"><nmb-alert-error></nmb-alert-error><p><textarea class="form-control modal-header-red" ng-model="vm.reason" rows="6" placeholder="Please provide a reason" required></textarea></p><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid||clicked" class="btn btn-danger"><span data-translate="entity.action.delete">Delete</span></button></div></div></div></form>');
$templateCache.put('app/entities/manage-home-branch/manage-home-branch-details.html','<style>.btn-reject {\r\n        background-color: #f34743;\r\n        border: 1px solid #f34743;\r\n        color: white;\r\n    }\r\n    \r\n    .btn-approve {\r\n        background-color: #37a36a;\r\n        border: 1px solid #37a36a;\r\n        color: white;\r\n    }</style><form name="manageHomeBranchViewForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><span data-translate="global.menu.manageHomeBranch.main"></span></h4></div><div class="modal-body"><div class="content"><fieldset><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseBankDetails = !vm.ExpandOrCollapseBankDetails" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseThree"><img ng-src="{{vm.ExpandOrCollapseBankDetails == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="nav-label">Home Branch Details</span></a></h4></div><div id="collapseThree" class="panel-collapse collapse in" style="background-color: black"><div class="accordion-content1"><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.bank"></span></label><div class="col-md-6 col-md-offset-3"><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bank" display-column="shortName" control-disabled="true" placeholder="" form="manageHomeBranchViewForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.ifscCode"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.ifscCode" control-id="txtifscCode" placeholder="" control-disabled="true" form="manageHomeBranchViewForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3"><span data-translate="gatewayApp.homeBranch.micr"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.micrCode" control-type="Number" placeholder="" control-maxlength="9" control-minlength="9" control-id="txtmicrCode" placeholder="" control-disabled="true" form="manageHomeBranchForm"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.branchName"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.branchName" control-disabled="true" control-id="AllowedCharsRegex" control-type="AllowedCharsRegex" placeholder="" form="manageHomeBranchViewForm"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.address"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.address" control-id="txtaddress" placeholder="" control-disabled="true" form="manageHomeBranchViewForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.pincode"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.pincode" control-type="Alphanumeric" control-maxlength="7" control-minlength="1" control-id="txtpincode" control-disabled="true" placeholder="" form="manageHomeBranchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.contact"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.contact" control-type="Number" control-disabled="true" control-maxlength="15" control-id="txtcontact" placeholder="" form="manageHomeBranchViewForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.city"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.city" control-id="txtcity" control-disabled="true" placeholder="" form="manageHomeBranchViewForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.district"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.district" control-id="txtdistrict" control-disabled="true" placeholder="" form="manageHomeBranchViewForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.state"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-3"><cspl-ach control-model="vm.stateName" control-id="txtstate" lookup-name="state" display-column="shortName" control-disabled="true" filter-value="{{vm.homeBranch.country.id}}~~" form="manageHomeBranchViewForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.membershipid"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.membershipId" control-id="txtmembershipid" control-disabled="true" placeholder="" form="manageHomeBranchViewForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3"><span data-translate="gatewayApp.homeBranch.homeBranchEmail"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.homeBranchEmailId" control-id="txthomeBranchEmail" control-disabled="true" placeholder="" form="manageHomeBranchViewForm"></div></div><div class="row" style="margin-top: 8px !important"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.homeBranch.currencyNotes"></span></label><div class="col-md-8 col-md-offset-3"><div class="col-md-3" id="btnGroup"><div class="btn-group" uib-btn-radio-group><label class="btn btn-primary" ng-model="vm.homeBranch.currencyNotesIsEnable" uib-btn-radio="true" ng-disabled="true">Yes</label><label class="btn btn-primary" ng-model="vm.homeBranch.currencyNotesIsEnable" uib-btn-radio="false" ng-disabled="true">No&nbsp;</label></div></div><div ng-show="vm.homeBranch.currencyNotesIsEnable" class="col-md-9" style="padding: 2px; border: 1px solid #999;border-radius:8px"><div class="content"><fieldset style="background-color: #070707"><div id="accordion"><div style="display: flex; flex-wrap: wrap; gap: 15px; margin-top: 8px"><div ng-repeat="currencyNote in vm.currencyNoteList" style="width: 13%"><input type="checkbox" style="margin-bottom: 8px;margin-left:10px;vertical-align:bottom" id="currencyNote" ng-model="currencyNote.isEnable" form="manageHomeBranchViewForm" ng-disabled="true"><label class="control-label" style="margin-left:4px">{{currencyNote.CurrencyCode}}</label></div></div></div></fieldset></div></div></div></div><div class="row" style="margin-top: 8px !important"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.homeBranch.forexCardLoad"></span></label><div class="col-md-8 col-md-offset-3"><div class="col-md-3" id="btnGroup"><div class="btn-group" uib-btn-radio-group><label class="btn btn-primary" ng-model="vm.homeBranch.forexCardLoadIsEnable" uib-btn-radio="true" ng-disabled="true">Yes</label><label class="btn btn-primary" ng-model="vm.homeBranch.forexCardLoadIsEnable" uib-btn-radio="false" ng-disabled="true">No&nbsp;</label></div></div><div ng-show="vm.homeBranch.forexCardLoadIsEnable" class="col-md-9" style="padding: 2px; border: 1px solid #999;border-radius:8px"><div class="content"><fieldset style="background-color: #070707"><div id="accordion"><div style="display: flex; flex-wrap: wrap; gap: 15px; margin-top: 8px"><div ng-repeat="forexCardLoad in vm.forexCardLoadList" style="width: 13%"><input type="checkbox" style="margin-bottom: 8px;margin-left:10px;vertical-align:bottom" id="forexCardLoad" ng-model="forexCardLoad.isEnable" form="manageHomeBranchViewForm" ng-disabled="true"><label class="control-label" style="margin-left:4px">{{forexCardLoad.CurrencyCode}}</label></div></div></div></fieldset></div></div></div></div><div class="row" style="margin-top: 8px !important"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.homeBranch.remittance"></span></label><div class="col-md-8 col-md-offset-3"><div class="col-md-3" id="btnGroup"><div class="btn-group" uib-btn-radio-group><label class="btn btn-primary" ng-model="vm.homeBranch.remittanceIsEnable" uib-btn-radio="true" ng-disabled="true">Yes</label><label class="btn btn-primary" ng-model="vm.homeBranch.remittanceIsEnable" uib-btn-radio="false" ng-disabled="true">No&nbsp;</label></div></div><div ng-show="vm.homeBranch.remittanceIsEnable" class="col-md-9" style="padding: 2px; border: 1px solid #999;border-radius:8px"><div class="content"><fieldset style="background-color: #070707"><div id="accordion"><div style="display: flex; flex-wrap: wrap; gap: 15px; margin-top: 8px"><div ng-repeat="remittance in vm.remittanceList" style="width: 13%"><input type="checkbox" style="margin-bottom: 8px;margin-left:10px;vertical-align:bottom" id="remittance" ng-model="remittance.isEnable" form="manageHomeBranchViewForm" ng-disabled="true"><label class="control-label" style="margin-left:4px">{{remittance.CurrencyCode}}</label></div></div></div></fieldset></div></div></div></div><div class="row" style="margin-top: 8px !important"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.homeBranch.forexCardIssuance"></span></label><div class="col-md-8 col-md-offset-3"><div class="col-md-3" id="btnGroup"><div class="btn-group" uib-btn-radio-group><label class="btn btn-primary" ng-model="vm.homeBranch.forexCardIssuanceIsEnable" uib-btn-radio="true" ng-disabled="true">Yes</label><label class="btn btn-primary" ng-model="vm.homeBranch.forexCardIssuanceIsEnable" uib-btn-radio="false" ng-disabled="true">No&nbsp;</label></div></div><div ng-show="vm.homeBranch.forexCardIssuanceIsEnable" class="col-md-9" style="padding: 2px; border: 1px solid #999;border-radius:8px"><div class="content"><fieldset style="background-color: #070707"><div id="accordion"><div style="display: flex; flex-wrap: wrap; gap: 15px; margin-top: 8px"><div ng-repeat="forexCardIssuance in vm.forexCardIssuanceList" style="width: 13%"><input type="checkbox" style="margin-bottom: 8px;margin-left:10px;vertical-align:bottom" id="forexCardIssuance" ng-model="forexCardIssuance.isEnable" form="manageHomeBranchViewForm" ng-disabled="true"><label class="control-label" style="margin-left:4px">{{forexCardIssuance.CurrencyCode}}</label></div></div></div></fieldset></div></div></div></div><!-- \r\n                            <div class="row" style="margin-top: 6px !important;">\r\n                                <label class="col-md-4 control-label col-md-offset-3"><span\r\n                                    data-translate="gatewayApp.homeBranch.currencyNotes"></span>\r\n                                </label>\r\n                                    \r\n                                <div id="btnGroup" class="col-md-6  col-md-offset-3" >\r\n                                    <div class="btn-group" uib-btn-radio-group >\r\n                                        <label class="btn btn-primary"\r\n                                            ng-model="vm.homeBranch.currencyNotes" \r\n                                            uib-btn-radio="true" \r\n                                            ng-disabled="true">Yes</label>\r\n\r\n                                        <label class="btn btn-primary"\r\n                                            ng-model="vm.homeBranch.currencyNotes" \r\n                                            uib-btn-radio="false" \r\n                                            ng-disabled="true">No&nbsp;</label>\r\n                                    </div>\r\n                                </div>\r\n                            </div> \r\n\r\n\r\n\r\n                            <div class="row" style="margin-top: 6px !important;">\r\n                                <label class="col-md-4 control-label col-md-offset-3"><span\r\n                                    data-translate="gatewayApp.homeBranch.forexCardLoad"></span>\r\n                                </label>\r\n                                    \r\n                                <div id="btnGroup" class="col-md-6  col-md-offset-3" >\r\n                                    <div class="btn-group" uib-btn-radio-group >\r\n                                        <label class="btn btn-primary"\r\n                                            ng-model="vm.homeBranch.forexCardLoad" \r\n                                            uib-btn-radio="true" \r\n                                            ng-disabled="true">Yes</label>\r\n\r\n                                        <label class="btn btn-primary"\r\n                                            ng-model="vm.homeBranch.forexCardLoad" \r\n                                            uib-btn-radio="false" \r\n                                            ng-disabled="true">No&nbsp;</label>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div class="row" style="margin-top: 6px !important;">\r\n                                <label class="col-md-4 control-label col-md-offset-3"><span\r\n                                    data-translate="gatewayApp.homeBranch.remittance"></span>\r\n                                </label>\r\n                                    \r\n                                <div id="btnGroup" class="col-md-6  col-md-offset-3" >\r\n                                    <div class="btn-group" uib-btn-radio-group >\r\n                                        <label class="btn btn-primary"\r\n                                            ng-model="vm.homeBranch.remittance" \r\n                                            uib-btn-radio="true" \r\n                                            ng-disabled="true">Yes</label>\r\n\r\n                                        <label class="btn btn-primary"\r\n                                            ng-model="vm.homeBranch.remittance" \r\n                                            uib-btn-radio="false" \r\n                                            ng-disabled="true">No&nbsp;</label>\r\n                                    </div>\r\n                                </div>\r\n                            </div> --></div></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>OK</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardHomeBranch()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showButton" class="btn btn-reject" ng-click="vm.rejectHomeBranch()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.clicked=true;vm.approveHomeBranch();" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/manage-home-branch/manage-home-branch-dialog.html','<form name="manageHomeBranchForm" role="form" novalidate><div class="modal-header"><div class="modal-title"><span data-translate="gatewayApp.homeBranch.addHomeBranch" ng-show="vm.homeBranch.id==null"></span><span data-translate="gatewayApp.homeBranch.editHomeBranch" ng-show="vm.homeBranch.id!=null"></span></div></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset ng-disabled="vm.disableForm"><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseBankDetails = !vm.ExpandOrCollapseBankDetails" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseThree"><img ng-src="{{vm.ExpandOrCollapseBankDetails == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="nav-label">Home Branch Details</span></a></h4></div><div id="collapseThree" class="panel-collapse collapse in" style="background-color: black"><div class="accordion-content1"><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.bank"></span></label><div class="col-md-6 col-md-offset-3"><cspl-ach control-model="vm.homeBranch.bank" control-id="txtbank" lookup-name="bank" display-column="bankName" placeholder="" form="manageHomeBranchForm" control-disabled="vm.homeBranch.id!=null || (vm.entityOwnerType==\'Bank\'&& vm.homeBranch.id==null) || vm.disablemode" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.ifscCode"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.ifscCode" control-id="txtifscCode" placeholder="" control-maxlength="11" control-minlength="11" control-type="AlphanumericWithCaps" placeholder="" control-disabled="vm.homeBranch.id!=null" form="manageHomeBranchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3"><span data-translate="gatewayApp.homeBranch.micr"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.micrCode" control-type="Number" placeholder="" control-maxlength="9" control-minlength="9" control-id="txtmicrCode" placeholder="" form="manageHomeBranchForm"></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.branchName"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.branchName" control-type="AllowedCharsRegex" control-id="txtbranchName" placeholder="" form="manageHomeBranchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.address"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.address" control-id="txtaddress" placeholder="" form="manageHomeBranchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.pincode"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.pincode" control-type="Alphanumeric" control-maxlength="7" control-minlength="1" control-id="txtpincode" placeholder="" form="manageHomeBranchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.contact"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.contact" control-type="Number" control-maxlength="15" control-id="txtcontact" placeholder="" form="manageHomeBranchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.city"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.city" control-id="txtcity" placeholder="" form="manageHomeBranchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.district"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.district" control-id="txtdistrict" placeholder="" form="manageHomeBranchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.state"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-3"><cspl-ach control-model="vm.homeBranch.stateObject" control-id="txtstate" lookup-name="state" display-column="shortName" filter-value="{{vm.homeBranchCounty.id}}~~" form="manageHomeBranchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3" cspl-mandatory><span data-translate="gatewayApp.homeBranch.membershipid"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.membershipId" control-id="txtmembershipid" control-maxlength="12" control-minlength="12" control-type="AlphanumericWithCaps" placeholder="" form="manageHomeBranchForm" required></div></div><div class="row"><label class="col-md-4 control-label col-md-offset-3"><span data-translate="gatewayApp.homeBranch.homeBranchEmail"></span></label><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.homeBranch.homeBranchEmailId" control-id="txthomeBranchEmail" placeholder="" form="manageHomeBranchForm"></div></div><div class="form-group" style="margin-right: 198px !important"><span class="help-block" data-translate="gatewayApp.homeBranch.showText"></span></div><div class="row" style="margin-top: 8px !important"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.homeBranch.currencyNotes"></span></label><div class="col-md-8 col-md-offset-3"><div class="col-md-3" id="btnGroup"><div class="btn-group" uib-btn-radio-group><label class="btn btn-primary" ng-model="vm.homeBranch.currencyNotesIsEnable" uib-btn-radio="true">Yes</label><label class="btn btn-primary" ng-model="vm.homeBranch.currencyNotesIsEnable" uib-btn-radio="false">No&nbsp;</label></div><div ng-show="vm.errorText != null" style="color: #E86A6A">{{vm.errorText}}</div></div><div ng-show="vm.homeBranch.currencyNotesIsEnable" class="col-md-9" style="padding: 2px; border: 1px solid #999;border-radius:8px"><div class="content"><fieldset style="background-color: #070707"><div id="accordion"><div style="display: flex; flex-wrap: wrap; gap: 15px; margin-top: 8px"><div ng-repeat="currencyNote in vm.currencyNoteList" style="width: 13%"><input type="checkbox" style="margin-bottom: 8px;margin-left:10px;vertical-align:bottom" id="currencyNote" ng-model="currencyNote.isEnable" form="branchForm"><label class="control-label" style="margin-left:4px">{{currencyNote.CurrencyCode}}</label></div></div></div></fieldset></div></div></div></div><div class="row" style="margin-top: 8px !important"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.homeBranch.forexCardLoad"></span></label><div class="col-md-8 col-md-offset-3"><div class="col-md-3" id="btnGroup"><div class="btn-group" uib-btn-radio-group><label class="btn btn-primary" ng-model="vm.homeBranch.forexCardLoadIsEnable" uib-btn-radio="true">Yes</label><label class="btn btn-primary" ng-model="vm.homeBranch.forexCardLoadIsEnable" uib-btn-radio="false">No&nbsp;</label></div><div ng-show="vm.errorText != null" style="color: #E86A6A">{{vm.errorText}}</div></div><div ng-show="vm.homeBranch.forexCardLoadIsEnable" class="col-md-9" style="padding: 2px; border: 1px solid #999;border-radius:8px"><div class="content"><fieldset style="background-color: #070707"><div id="accordion"><div style="display: flex; flex-wrap: wrap; gap: 15px; margin-top: 8px"><div ng-repeat="forexCardLoad in vm.forexCardLoadList" style="width: 13%"><input type="checkbox" style="margin-bottom: 8px;margin-left:10px;vertical-align:bottom" id="forexCardLoad" ng-model="forexCardLoad.isEnable" form="branchForm"><label class="control-label" style="margin-left:4px">{{forexCardLoad.CurrencyCode}}</label></div></div></div></fieldset></div></div></div></div><div class="row" style="margin-top: 8px !important"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.homeBranch.remittance"></span></label><div class="col-md-8 col-md-offset-3"><div class="col-md-3" id="btnGroup"><div class="btn-group" uib-btn-radio-group><label class="btn btn-primary" ng-model="vm.homeBranch.remittanceIsEnable" uib-btn-radio="true">Yes</label><label class="btn btn-primary" ng-model="vm.homeBranch.remittanceIsEnable" uib-btn-radio="false">No&nbsp;</label></div><div ng-show="vm.errorText != null" style="color: #E86A6A">{{vm.errorText}}</div></div><div ng-show="vm.homeBranch.remittanceIsEnable" class="col-md-9" style="padding: 2px; border: 1px solid #999;border-radius:8px"><div class="content"><fieldset style="background-color: #070707"><div id="accordion"><div style="display: flex; flex-wrap: wrap; gap: 15px; margin-top: 8px"><div ng-repeat="remittance in vm.remittanceList" style="width: 13%"><input type="checkbox" style="margin-bottom: 8px;margin-left:10px;vertical-align:bottom" id="remittance" ng-model="remittance.isEnable" form="branchForm"><label class="control-label" style="margin-left:4px">{{remittance.CurrencyCode}}</label></div></div></div></fieldset></div></div></div></div><div class="row" style="margin-top: 8px !important"><label class="col-md-6 control-label col-md-offset-3"><span data-translate="gatewayApp.homeBranch.forexCardIssuance"></span></label><div class="col-md-8 col-md-offset-3"><div class="col-md-3" id="btnGroup"><div class="btn-group" uib-btn-radio-group><label class="btn btn-primary" ng-model="vm.homeBranch.forexCardIssuanceIsEnable" uib-btn-radio="true">Yes</label><label class="btn btn-primary" ng-model="vm.homeBranch.forexCardIssuanceIsEnable" uib-btn-radio="false">No&nbsp;</label></div><div ng-show="vm.errorText != null" style="color: #E86A6A">{{vm.errorText}}</div></div><div ng-show="vm.homeBranch.forexCardIssuanceIsEnable" class="col-md-9" style="padding: 2px; border: 1px solid #999;border-radius:8px"><div class="content"><fieldset style="background-color: #070707"><div id="accordion"><div style="display: flex; flex-wrap: wrap; gap: 15px; margin-top: 8px"><div ng-repeat="forexCardIssuance in vm.forexCardIssuanceList" style="width: 13%"><input type="checkbox" style="margin-bottom: 8px;margin-left:10px;vertical-align:bottom" id="forexCardIssuance" ng-model="forexCardIssuance.isEnable" form="branchForm"><label class="control-label" style="margin-left:4px">{{forexCardIssuance.CurrencyCode}}</label></div></div></div></fieldset></div></div></div></div></div></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showButton" class="btn btn-primary" ng-disabled="manageHomeBranchForm.$invalid || vm.clicked" ng-click="vm.clicked = true;vm.resubmitHomeBranch();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="!showButton" class="btn btn-info active" ng-disabled="manageHomeBranchForm.$invalid || vm.clicked || manageHomeBranchForm.$pristine" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button></div></div></div></form>');
$templateCache.put('app/entities/manage-home-branch/manage-home-branch.html','<div class="container-fluid"><!-- <div ncy-breadcrumb></div>\r\n\t<h2 class="view-title">Manage Home Branches</h2>\r\n\t<nmb-alert></nmb-alert>\r\n\t<div>\r\n\t\t\t\t<nmb-alert-error></nmb-alert-error>\r\n\t\t\t</div> --><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.manageHomeBranch.manageHomeBranch"></span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row col-md-12" ng-show="vm.entityOwnerType==\'Clearcorp\'"><fieldset><form class="form" name="filterform"><div class="row"><label class="col-md-1 control-label" style="margin-top: 7px" cspl-mandatory><span data-translate="gatewayApp.homeBranch.bankFilter"></span></label><div class="col-md-3"><cspl-ach control-model="vm.bank" control-id="txtBank" lookup-name="bank" display-column="shortName" form="filterform" control-required="vm.entityOwnerType==\'Clearcorp\'"></div><button type="button" class="btn btn-info active" ng-disabled="filterform.$invalid||vm.clicked" ng-click="vm.loadAll(vm.bank);vm.clicked=true;">Go</button> <button type="button" class="btn btn-info active" style="margin-left: 10px" ng-click="vm.generateHomeBranchExcel()">Export All</button></div></form></fieldset></div><div class="row"><div class="pull-right"><button type="button" class="btn btn-info active" ng-click="vm.screenLog.screenLog(vm.screenName,0,vm.entityConstants.ENTITY_ACTION_TYPE.ADD);vm.launch()" ng-show="vm.permitHomeBranchCreateEntityAction"><img ng-src="assets/images/Add.png"> <span data-translate="global.menu.manageHomeBranch.homeBranch"></span></button><div class="col-md-6 pull-right" ng-show="vm.homeBranch.length > 0"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><a href="" style="color: #fff; vertical-align: -19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size: 20px"></i></a></div><span class="partition">|</span><div class="pull-left"><div class="dropdown col-md-3" style="width:10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border:none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportDataToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportDataToFile(\'xls\');">XLS</a></li></ul></div></div></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden" ng-show="vm.homeBranch.length > 0"><table id="tblhomeBranch" class="datatables-nosort table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.homeBranch.bank"></th><th data-translate="gatewayApp.homeBranch.bankMemberNo"></th><th style="min-width: 100px" data-translate="gatewayApp.homeBranch.ifscCode"></th><th data-translate="gatewayApp.homeBranch.branchName"></th><th style="min-width: 80px" data-translate="gatewayApp.homeBranch.micr"></th><th style="min-width: 140px" data-translate="gatewayApp.homeBranch.address"></th><th data-translate="gatewayApp.homeBranch.pincode"></th><th style="min-width: 80px" data-translate="gatewayApp.homeBranch.contact"></th><th style="min-width: 80px" data-translate="gatewayApp.homeBranch.city"></th><th style="min-width: 100px" data-translate="gatewayApp.homeBranch.district"></th><th style="min-width: 80px" data-translate="gatewayApp.homeBranch.state"></th><th style="min-width:80px" data-translate="gatewayApp.homeBranch.membershipid"></th><th style="min-width: 140px" data-translate="gatewayApp.homeBranch.homeBranchEmail"></th><th data-translate="gatewayApp.homeBranch.currencyNotes"></th><th data-translate="gatewayApp.homeBranch.forexCardLoad"></th><th data-translate="gatewayApp.homeBranch.remittance"></th><th data-translate="gatewayApp.homeBranch.forexCardIssuance"></th><th></th></tr></thead><tbody><tr ng-repeat="homeBranch in filterData = (vm.homeBranch | filter : filterText | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><!-- Column values --><td style="word-break:break-word">{{homeBranch.bankName}}</td><td>{{homeBranch.bankMemberNo}}</td><td>{{homeBranch.ifscCode}}</td><td style="word-break:break-word">{{homeBranch.branchName}}</td><td>{{homeBranch.micrCode||\'-\'}}</td><td style="word-break:break-word">{{homeBranch.address}}</td><td>{{homeBranch.pincode}}</td><td style="word-break:break-word">{{homeBranch.contact}}</td><td style="word-break:break-word">{{homeBranch.city}}</td><td style="word-break:break-word">{{homeBranch.district}}</td><td style="word-break:break-word">{{homeBranch.state}}</td><td>{{homeBranch.membershipId}}</td><td style="word-break:break-word">{{homeBranch.homeBranchEmailId||\'-\'}}</td><td>{{homeBranch.currencyNotes}}</td><td>{{homeBranch.forexCardLoad}}</td><td>{{homeBranch.remittance}}</td><td>{{homeBranch.forexCardIssuance}}</td><td style="text-align: center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitHomeBranchViewEntityAction"><a ui-sref="home-branch.view({id: homeBranch.id})" ng-click="vm.screenLog.screenLog(vm.screenName,homeBranch.id,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitHomeBranchEditEntityAction"><a ui-sref="home-branch.edit({id: homeBranch.id})" ng-click="vm.screenLog.screenLog(vm.screenName,homeBranch.id,vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></a></li><li ng-show="vm.permitHomeBranchDeleteEntityAction"><a ui-sref="home-branch.delete({id: homeBranch.id})" ng-click="vm.screenLog.screenLog(vm.screenName,homeBranch.id,vm.entityConstants.ENTITY_ACTION_TYPE.DELETE)"><span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="vm.homeBranch.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div><div class="table-responsive" ng-show="vm.homeBranch.length==0"><span>No record found</span></div></section></div></div><script src="assets/js/tables.js"></script>');
$templateCache.put('app/entities/manage-limit/customer-new-limit-dialog.html','<form name="limitchangerequestform" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="gatewayApp.limitSettings.customerNewLimit"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="content"><fieldset ng-disabled="vm.disableForm"><br><div class="col-sm-6 col-centered"><div class="form-group"><label class="control-label" for="txtbank" cspl-mandatory><span data-translate="gatewayApp.limitSettings.bank"></span></label><cspl-ach control-id="txtbank" control-model="vm.customerLimit.limitSettingsHeader.bank" lookup-name="tradingBank" filter-value="{{vm.customerLimit.limitSettingsHeader.customer.id}}" display-column="shortName" form="limitchangerequestform" control-disabled="vm.disableBank" control-required="!vm.disableBank"></cspl-ach></div><div class="form-group"><label class="control-label" for="txtbranch" cspl-mandatory><span data-translate="gatewayApp.limitSettings.branch"></span></label><cspl-text control-id="txtbranch" control-model="vm.customerLimit.limitSettingsHeader.branch.branchName" form="limitchangerequestform" control-disabled="vm.disableBranch" control-required="!vm.disableBranch"></cspl-text></div><div class="form-group"><label class="control-label" for="txtcustomer" cspl-mandatory><span data-translate="gatewayApp.limitSettings.customer"></span></label><cspl-text control-id="txtcustomer" form="limitchangerequestform" control-model="vm.customerLimit.limitSettingsHeader.customer.customerCode" control-disabled="vm.disableCustomer" control-required="!vm.disableCustomer"></cspl-text><span class="cutomer-highlight" ng-if="vm.customerLimit.limitSettingsHeader.customer.customerMiddleName==null">{{vm.customerLimit.limitSettingsHeader.customer.customerFirstName+\' \'+ vm.customerLimit.limitSettingsHeader.customer.customerLastName}}</span> <span class="cutomer-highlight" ng-if="vm.customerLimit.limitSettingsHeader.customer.customerMiddleName!=null">{{vm.customerLimit.limitSettingsHeader.customer.customerFirstName+\' \'+ vm.customerLimit.limitSettingsHeader.customer.customerMiddleName+\' \'+vm.customerLimit.limitSettingsHeader.customer.customerLastName}}</span></div><div class="form-group col-sm-10" style="padding-left: 0"><label class="control-label" for="seltype" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitType"></span></label><select class="form-control select-style" control-id="seltype" ng-model="vm.selectedLimitType" style="width: 90%" ng-options="x.displayName for x in vm.limitTypes track by x.displayName" form="limitchangerequestform" ng-disabled="vm.disableLimitType" ng-required="!vm.disableLimitType"><option selected="selected" disabled="disabled" hidden style="display: none" value=""></option></select><!--  ng-class="{\'form-control select-light\' : !vm.disableLimitType, \'form-control disable-select-light\' : vm.disableLimitType }"  --></div><div class="form-group col-sm-10" style="padding-left: 0"><label class="control-label" for="selccy" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitCurrency"></span></label><select class="form-control select-style" control-id="selccy" ng-model="vm.customerLimit.customerLimitRequest.limitCurrency" style="width: 90%" ng-options="x.code for x in vm.currencies track by x.code" form="limitchangerequestform" ng-disabled="vm.diableFields" ng-required="!vm.disableCurrency"><option selected="selected" disabled="disabled" hidden style="display: none" value=""></option></select><!-- ng-class="{\'form-control select-light\' : !vm.disableLimitType, \'form-control disable-select-light\' : vm.disableLimitType }" --></div><div class="form-group col-sm-9" style="padding-left: 0"><label class="control-label" for="txtLimitAmount" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitAmount"></span></label><cspl-numeric control-id="txtLimitAmount" control-model="vm.customerLimit.customerLimitRequest.limitAmount" form="limitchangerequestform" control-disabled="vm.diableFields" no-of-decimals="{{2}}" control-min="0.00" control-max="999999999999.99" control-required="!vm.diableFields"></cspl-numeric><span class="help-block-error" ng-show="vm.customerLimit.customerLimitRequest.limitAmount!=undefined && vm.customerLimit.customerLimitRequest.limitAmount!=null && vm.customerLimit.customerLimitRequest.limitAmount!=\'\' && vm.customerLimit.customerLimitRequest.limitAmount==0"><span data-translate="gatewayApp.limitSettings.limitGreaterThanZero"></span></span> <span style="color: #858585; font-size: 12px;text-align:left" ng-show="vm.customerLimit.customerLimitRequest.limitCurrency.code == \'INR\'"><span data-translate="gatewayApp.limitSettings.inrHelpText"></span></span></div><div class="form-group col-sm-12" style="padding-left: 0"><label class="control-label" for="txtRemarks"><span data-translate="gatewayApp.limitSettings.remarks"></span></label><cspl-multiline-text control-model="vm.customerLimit.customerLimitRequest.userRemarks" control-rows="5" control-maxlength="1000" control-id="txtRemarks" form="limitchangerequestform" control-disabled="vm.diableFields" autofocus></cspl-multiline-text></div></div></fieldset></div><div class="modal-footer"><button type="button" ng-show="showDiscardButton ||  showOkButton " class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button> <button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" ng-show="showResubmitButton || showButton"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="limitchangerequestform.$invalid || vm.clicked || vm.customerLimit.customerLimitRequest.limitAmount==0" ng-click="vm.clicked = true;vm.resubmitLimitSettings();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="limitchangerequestform.$invalid ||  vm.clicked || vm.disableSave || vm.customerLimit.customerLimitRequest.limitAmount==0" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardLimitSettings()" autofocus><span data-translate="entity.action.discard">Discard</span></button></div></div></form>');
$templateCache.put('app/entities/manage-limit/customer-new-limit.html','<form name="limitchangerequestform" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="gatewayApp.limitSettings.customerNewLimit"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="content"><fieldset ng-disabled="vm.disableForm"><br><div class="col-sm-6 col-centered"><div class="form-group"><label class="control-label" for="txtbank" cspl-mandatory><span data-translate="gatewayApp.limitSettings.bank"></span></label><cspl-ach control-id="txtbank" control-model="vm.customerLimit.limitSettingsHeader.bank" lookup-name="tradingBank" filter-value="{{vm.customerLimit.limitSettingsHeader.customer.id}}" display-column="shortName" form="limitchangerequestform" control-disabled="vm.disableBank" control-required="!vm.disableBank"></cspl-ach></div><div class="form-group"><label class="control-label" for="txtbranch" cspl-mandatory><span data-translate="gatewayApp.limitSettings.branch"></span></label><cspl-text control-id="txtbranch" control-model="vm.customerLimit.limitSettingsHeader.branch.branchName" form="limitchangerequestform" control-disabled="vm.disableBranch" control-required="!vm.disableBranch"></cspl-text></div><div class="form-group"><label class="control-label" for="txtcustomer" cspl-mandatory><span data-translate="gatewayApp.limitSettings.customer"></span></label><cspl-text control-id="txtcustomer" form="limitchangerequestform" control-model="vm.customerLimit.limitSettingsHeader.customer.customerCode" control-disabled="vm.disableCustomer" control-required="!vm.disableCustomer"></cspl-text><span class="cutomer-highlight" ng-if="vm.customerLimit.limitSettingsHeader.customer.customerMiddleName==null">{{vm.customerLimit.limitSettingsHeader.customer.customerFirstName+\' \'+ vm.customerLimit.limitSettingsHeader.customer.customerLastName}}</span> <span class="cutomer-highlight" ng-if="vm.customerLimit.limitSettingsHeader.customer.customerMiddleName!=null">{{vm.customerLimit.limitSettingsHeader.customer.customerFirstName+\' \'+ vm.customerLimit.limitSettingsHeader.customer.customerMiddleName+\' \'+vm.customerLimit.limitSettingsHeader.customer.customerLastName}}</span></div><div class="form-group col-sm-10 padding-left-0"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitToBeSetFor"></span></label><div id="btnGroup"><div class="btn-group"><label class="btn btn-primary" ng-repeat="limitInstrumentGroup in vm.limitInstrumentGroupList" ng-model="vm.customerLimit.limitSettingsHeader.limitInstrumentGroup" id="slt_inst_{{limitInstrumentGroup.shortName}}" ng-disabled="vm.disableInstrumentGroupField" ng-click="vm.onChangeLimitInstrumentGroup(limitInstrumentGroup);" uib-btn-radio="{{limitInstrumentGroup}}">{{limitInstrumentGroup.name}}</label></div></div></div><div class="form-group col-sm-12" style="padding-left: 0;margin-bottom: 0px"><div class="col-sm-12" style="padding: 0px"><label class="control-label" for="seltype" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitType"></span></label></div><div class="col-sm-7" style="padding: 0px"><select class="form-control select-style" control-id="seltype" ng-model="vm.selectedLimitType" ng-options="x.displayName for x in vm.limitTypes track by x.displayName" form="limitchangerequestform" ng-disabled="vm.disableLimitType" ng-required="!vm.disableLimitType"></select><option selected="selected" disabled="disabled" hidden style="display: none" value=""></option></div><div class="col-sm-2" style="margin-top: 6px;padding: 0px"><span class="icon" ng-show="vm.showLimitInfo && userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="{{vm.limitTypeInfo}}" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></div></div><!--  ng-class="{\'form-control select-light\' : !vm.disableLimitType, \'form-control disable-select-light\' : vm.disableLimitType }"  --><div class="form-group col-sm-10" style="padding-left: 0; margin-top: 15px"><label class="control-label" for="selccy" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitCurrency"></span></label><select class="form-control select-style" control-id="selccy" ng-model="vm.customerLimit.customerLimitRequest.limitCurrency" style="width: 70%" ng-options="x.code for x in vm.currencies track by x.code" form="limitchangerequestform" ng-disabled="vm.diableFields" ng-required="!vm.disableCurrency"><option selected="selected" disabled="disabled" hidden style="display: none" value=""></option></select><!-- ng-class="{\'form-control select-light\' : !vm.disableLimitType, \'form-control disable-select-light\' : vm.disableLimitType }" --></div><div class="padding-left-0 form-group col-sm-7" style="padding-left: 0"><label class="control-label" for="txtLimitAmount" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitAmount"></span></label><cspl-numeric control-id="txtLimitAmount" control-model="vm.customerLimit.customerLimitRequest.limitAmount" form="limitchangerequestform" control-disabled="vm.diableFields" no-of-decimals="{{2}}" control-min="0.00" control-max="999999999999.99" control-required="!vm.diableFields"></cspl-numeric><span class="help-block-error" ng-show="vm.customerLimit.customerLimitRequest.limitAmount!=undefined && vm.customerLimit.customerLimitRequest.limitAmount!=null && vm.customerLimit.customerLimitRequest.limitAmount!=\'\' && vm.customerLimit.customerLimitRequest.limitAmount==0"><span data-translate="gatewayApp.limitSettings.limitGreaterThanZero"></span></span> <span style="color: #858585; font-size: 12px;text-align:left;width: 65%" ng-show="vm.customerLimit.customerLimitRequest.limitCurrency.code == \'INR\'"><span data-translate="gatewayApp.limitSettings.inrHelpText"></span></span></div><div class="form-group col-sm-9" style="padding:0px"><div class="col-sm-12 padding-left-7" style="padding:0px"><label class="padding-left-0 control-label" ng-class="col-sm-7" for="dtpEfctTo" cspl-mandatory><span data-translate="gatewayApp.limitSettings.effectiveTo"></span></label></div><div class="padding-left-0 col-sm-7"><cspl-dtp control-id="dtpEfctTo" control-model="vm.effectiveToDate" form="limitchangerequestform" control-disabled="vm.disableEffectiveToDate" control-required="!vm.disableEffectiveToDate"></cspl-dtp></div></div><div class="form-group col-sm-12" style="padding-left: 0"><label class="control-label" for="txtCustomerRemarks"><span data-translate="gatewayApp.limitSettings.customerRemarks"></span></label><cspl-multiline-text control-model="vm.customerLimit.customerLimitRequest.customerRemarks" control-rows="5" control-maxlength="1000" control-id="txtCustomerRemarks" form="limitchangerequestform" control-disabled="vm.diableFields" autofocus></cspl-multiline-text></div></div></fieldset></div><div class="modal-footer"><button type="button" ng-show="showDiscardButton ||  showOkButton " class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button> <button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" ng-show="showResubmitButton || showButton"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="limitchangerequestform.$invalid || vm.clicked || vm.customerLimit.customerLimitRequest.limitAmount==0" ng-click="vm.clicked = true;vm.resubmitLimitSettings();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="limitchangerequestform.$invalid ||  vm.clicked || vm.disableSave || vm.customerLimit.customerLimitRequest.limitAmount==0" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardLimitSettings()" autofocus><span data-translate="entity.action.discard">Discard</span></button></div></div></form>');
$templateCache.put('app/entities/manage-limit/limit-dialog-new.html','<form name="limitchangerequestform" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span ng-show="vm.actionType==\'Add\'" data-translate="gatewayApp.limitSettings.addLimit"></span> <span ng-show="vm.actionType==\'Change\'" data-translate="gatewayApp.limitSettings.editLimit"></span> <span ng-show="vm.actionType==\'Reset\'" data-translate="gatewayApp.limitSettings.resetLimit"></span> <span ng-show="vm.actionType==\'CustomerChange\'" data-translate="gatewayApp.limitSettings.changeLimit"></span> <span ng-show="vm.actionType==\'CustomerCreate\'" data-translate="gatewayApp.limitSettings.customerNewLimit"></span> <span ng-show="vm.actionType==\'View\'" data-translate="gatewayApp.limitSettings.viewLimit"></span></h4></div><div class="modal-body" ng-init="setForm(limitchangerequestform)"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="content"><fieldset><div ng-if="vm.showHighLightText" class="col-md-4" style="margin-top: 20px; margin-bottom: 10px;float:right"><span data-translate="gatewayApp.customerInfo.highlightedFiledLegend" class="field-highlighted-legend legend-white-color"></span> <span data-translate="gatewayApp.customerInfo.modified" class="field-highlighted-legend legend-blue-color"></span></div><br><div ng-class="{\'col-sm-10 col-centered\': vm.showLimitUtilised, \'col-sm-8 col-centered\': (!vm.showLimitUtilised && !vm.showLimitUtilisedWithINR)}"><div class="form-group"><div class="col-sm-12 padding-left-0"><label class="control-label padding-left-0" ng-class="{\'col-sm-7\': vm.showLimitUtilised, \'col-sm-9\': !vm.showLimitUtilised}" for="txtbank" cspl-mandatory><span data-translate="gatewayApp.limitSettings.bank"></span></label></div><div class="col-sm-12 padding-left-0 margin-bottom-7"><div class="padding-left-0" ng-class="{\'col-sm-7\': vm.showLimitUtilised, \'col-sm-9\': !vm.showLimitUtilised}"><cspl-text control-id="txtbank" control-model="vm.limitHeader.bank.bankName" form="limitchangerequestform" control-disabled="true"></div></div></div><div class="form-group"><div class="col-sm-12 padding-left-0"><label class="control-label padding-left-0" ng-class="{\'col-sm-7\': vm.showLimitUtilised, \'col-sm-9\': !vm.showLimitUtilised}" for="txtbranch" cspl-mandatory><span data-translate="gatewayApp.limitSettings.branch"></span></label></div><div class="col-sm-12 padding-left-0 margin-bottom-7"><div class="padding-left-0" ng-class="{\'col-sm-7\': vm.showLimitUtilised, \'col-sm-9\': !vm.showLimitUtilised}"><cspl-ach control-id="txtbranch" control-model="vm.limitHeader.branch" lookup-name="validStatusBranchesForBank" display-column="shortName" form="limitchangerequestform" control-disabled="vm.disableBranch" control-required="!vm.disableBranch"></cspl-ach></div></div></div><div class="form-group"><div class="col-sm-12 padding-left-0"><label class="control-label padding-left-0" ng-class="{\'col-sm-7\': vm.showLimitUtilised, \'col-sm-9\': !vm.showLimitUtilised}" for="txtcustomer" cspl-mandatory><span data-translate="gatewayApp.limitSettings.customer"></span></label></div><div class="col-sm-12 padding-left-0 margin-bottom-7"><div class="padding-left-0" ng-class="{\'col-sm-7\': vm.showLimitUtilised, \'col-sm-9\': !vm.showLimitUtilised}"><cspl-ach control-id="txtcustomer" control-place-holder="Enter Customer ID or Name" form="limitchangerequestform" control-model="vm.limitHeader.customer" lookup-name="allTypeCustomersForLimits" filter-value="{{vm.limitHeader.bank.id}}~~{{vm.limitHeader.branch.id}}" display-column="customerCode,customerName" control-disabled="vm.disableCustomer" control-required="!vm.disableCustomer"></cspl-ach><span class="cutomer-highlight" ng-if="vm.limitHeader.customer.customerMiddleName==null">{{vm.limitHeader.customer.customerFirstName+\' \'+vm.limitHeader.customer.customerLastName}}</span> <span class="cutomer-highlight" ng-if="vm.limitHeader.customer.customerMiddleName!=null">{{vm.limitHeader.customer.customerFirstName+\' \'+ vm.limitHeader.customer.customerMiddleName+\' \'+vm.limitHeader.customer.customerLastName}}</span></div></div></div><div class="form-group col-sm-12 padding-left-0"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitToBeSetFor"></span></label><div id="btnGroup"><div class="btn-group" ng-class="{\'highlight-blue-border\' : vm.checkforModificationField(\'limitInstrumentGroup\')}"><label class="btn btn-primary" ng-repeat="limitInstrumentGroup in vm.limitInstrumentGroupList" ng-model="vm.limitInstrumentGroup" id="slt_inst_{{limitInstrumentGroup.shortName}}" ng-disabled="vm.disableInstrumentGroupField" ng-click="vm.onChangeLimitInstrumentGroup(limitInstrumentGroup);" uib-btn-radio="{{limitInstrumentGroup}}">{{limitInstrumentGroup.name}}</label></div></div></div><div class="form-group"><div class="col-sm-12 padding-left-0"><div class="padding-left-0" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}"><label class="control-label" for="seltype" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitType"></span></label></div></div><div class="padding-left-0 margin-bottom-10" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}"><select class="form-control select-style" ng-class="{\'highlight-blue-border\' : vm.checkforModificationField(\'limitType\')}" control-id="seltype" ng-model="vm.selectedLimitType" ng-options="x.displayName for x in vm.limitTypes track by x.displayName" form="limitchangerequestform" ng-disabled="vm.disableLimitType" ng-required="!vm.disableLimitType"><option selected="selected" disabled="disabled" hidden style="display: none" value=""></option></select></div><div class="col-sm-2" style="margin-top: 6px;padding: 0px"><span class="icon" ng-show="vm.showLimitInfo && userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="{{vm.limitTypeInfo}}" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></div></div><div class="form-group"><div class="col-sm-12 padding-left-0"><div class="padding-left-0" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}"><label class="control-label" for="selccy" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitCurrency"></span></label></div></div><div class="col-sm-12 padding-left-0 margin-bottom-10"><div class="padding-left-0" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}"><select class="form-control select-style" control-id="selccy" ng-class="{\'highlight-blue-border\' : vm.checkforModificationField(\'limitCurrency\')}" ng-model="vm.limitHeader.limitCurrency" ng-options="x.code for x in vm.currencies track by x.code" form="limitchangerequestform" ng-disabled="vm.disableCurrency" ng-required="!vm.disableCurrency"><option selected="selected" disabled="disabled" hidden style="display: none" value=""></option></select></div></div></div><div class="form-group"><div class="col-sm-12 padding-left-0"><div class="col-sm-5 padding-left-0 width-45-per"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitValue"></span></label></div><div class="col-sm-3 padding-left-0" ng-show="vm.showLimitUtilisedWithINR"><label class="control-label"><span data-translate="gatewayApp.limitSettings.usdEqv"></span></label></div></div><div class="col-sm-12 padding-left-0" ng-show="vm.limitInstrumentGroup.shortName==\'SPOTWINDOW\'"><div class="col-sm-1" ng-class="{\'width-5-per\': vm.showLimitUtilised, \'width-7-per\': !vm.showLimitUtilised}"><input type="radio" name="optradio" id="radio1" class="radio" ng-model="vm.selectedInstrument" value="individual" form="limitchangerequestform" ng-disabled="vm.disableRadio" style="margin-top: 8px"></div><div class="col-sm-3 multi-col" ng-class="{\'width-15-per\': vm.showLimitUtilised, \'width-19-per\': !vm.showLimitUtilised}"><label ng-class="{\'control-label limit-change-lbl\' : vm.selectedInstrument ==\'individual\' ,\'control-label limit-change-all-lbl\'  : vm.selectedInstrument !=\'individual\'} " for="txtspot"><span data-translate="gatewayApp.limitSettings.spot"></span></label></div><div class="multi-col txt" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}"><cspl-numeric control-id="txtspot" control-model="vm.spotValue" form="limitchangerequestform" control-disabled="(!vm.disableValues && vm.selectedInstrument ==\'individual\') ?false:true" no-of-decimals="{{2}}" control-min="{{vm.minValue}}" control-max="999999999999.99" control-required="false" control-modified="vm.checkforModificationField(\'spotAmount\')"></div><div class="multi-col txt" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}" ng-show="vm.showLimitUtilisedWithINR"><cspl-numeric control-id="txtspotValueInINR" control-model="vm.spotValueInINR" form="limitchangerequestform" control-disabled="true" no-of-decimals="{{vm.noOfDecimalsForAmount}}" control-modified="vm.checkforModificationField(\'spotAmount\')"></div></div></div><div class="form-group" ng-show="vm.limitInstrumentGroup.shortName==\'SPOTWINDOW\'"><div class="col-sm-12 padding-left-0"><div class="col-sm-1" ng-class="{\'width-5-per\': vm.showLimitUtilised, \'width-7-per\': !vm.showLimitUtilised}"></div><div class="col-sm-3 multi-col" ng-class="{\'width-15-per\': vm.showLimitUtilised, \'width-19-per\': !vm.showLimitUtilised}"><label ng-class="{\'control-label limit-change-lbl\' : vm.selectedInstrument ==\'individual\' ,\'control-label limit-change-all-lbl\'  : vm.selectedInstrument !=\'individual\'} " for="txttom"><span data-translate="gatewayApp.limitSettings.tom"></span></label></div><div class="multi-col txt" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}"><cspl-numeric control-id="txttom" control-model="vm.tomValue" form="limitchangerequestform" control-disabled="(!vm.disableValues && vm.selectedInstrument ==\'individual\') ?false:true" no-of-decimals="{{2}}" control-min="{{vm.minValue}}" control-max="999999999999.99" control-required="false" control-modified="vm.checkforModificationField(\'tomAmount\')"></div><div class="multi-col txt" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}" ng-show="vm.showLimitUtilisedWithINR"><cspl-numeric control-id="txttomValueInINR" control-model="vm.tomValueInINR" form="limitchangerequestform" control-disabled="true" no-of-decimals="{{vm.noOfDecimalsForAmount}}" control-modified="vm.checkforModificationField(\'tomAmount\')"></div></div></div><div class="form-group" ng-show="vm.limitInstrumentGroup.shortName==\'SPOTWINDOW\'"><div class="col-sm-12 padding-left-0"><div class="col-sm-1 multi-col" ng-class="{\'width-5-per\': vm.showLimitUtilised, \'width-7-per\': !vm.showLimitUtilised}"></div><div class="col-sm-3 multi-col" ng-class="{\'width-15-per\': vm.showLimitUtilised, \'width-19-per\': !vm.showLimitUtilised}"><label ng-class="{\'control-label limit-change-lbl\' : vm.selectedInstrument ==\'individual\' ,\'control-label limit-change-all-lbl\'  : vm.selectedInstrument !=\'individual\'} " for="txtcash"><span data-translate="gatewayApp.limitSettings.cash"></span></label></div><div class="multi-col txt" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}"><cspl-numeric control-id="txtcash" control-model="vm.cashValue" form="limitchangerequestform" control-disabled="(!vm.disableValues &&vm.selectedInstrument ==\'individual\') ?false:true" no-of-decimals="{{2}}" control-min="{{vm.minValue}}" control-max="999999999999.99" control-required="false" control-modified="vm.checkforModificationField(\'cashAmount\')"></div><div class="multi-col txt" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}" ng-show="vm.showLimitUtilisedWithINR"><cspl-numeric control-id="txtcashValueInINR" control-model="vm.cashValueInINR" form="limitchangerequestform" control-disabled="true" no-of-decimals="{{vm.noOfDecimalsForAmount}}" control-modified="vm.checkforModificationField(\'cashAmount\')"></div><div class="col-sm-2 width-27-per margin-top-xs" ng-show="vm.showLimitUtilised \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& vm.limitHeader.limitInstrumentGroup.shortName==\'SPOTWINDOW\' \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& vm.selectedInstrument==\'individual\'"><span ng-click="vm.ExpandOrCollapseLimitUtilised = !vm.ExpandOrCollapseLimitUtilised"><span ng-if="vm.ExpandOrCollapseLimitUtilised" class="icon arrow_carrot-up check-limit-icon"></span><span ng-if="!vm.ExpandOrCollapseLimitUtilised" class="icon arrow_carrot-down check-limit-icon"></span>&nbsp;<span class="check-limit" data-translate="gatewayApp.limitSettings.checkLimitUtilised"></span></span></div></div></div><div class="form-group slide-down-animation" ng-show="vm.showLimitUtilised \r\n\t\t\t\t\t&& vm.limitHeader.limitInstrumentGroup.shortName==\'SPOTWINDOW\' \r\n\t\t\t\t\t&& vm.selectedInstrument==\'individual\'" ng-style="{ display: vm.ExpandOrCollapseLimitUtilised  ? \'block\' : \'none\' }"><div class="col-sm-1 multi-col width-5-per"></div><div class="col-sm-11 padding-left-0"><div ng-include="\'app/entities/manage-limit/limit-utilisation-details.html\'"></div></div></div><div class="form-group" ng-show="vm.limitInstrumentGroup.shortName==\'FORWARD\'"><div class="col-sm-12 padding-left-0"><div class="multi-col txt" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}"><cspl-numeric control-id="txtforward" control-model="vm.forwardValue" form="limitchangerequestform" control-disabled="vm.disableValues" no-of-decimals="{{2}}" control-min="{{vm.minValue}}" control-max="999999999999.99" control-modified="vm.checkforModificationField(\'forwardAmount\')" control-required="false"></div><div class="multi-col txt" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}" ng-show="vm.showLimitUtilisedWithINR"><cspl-numeric control-id="txtforwardValueInINR" control-model="vm.forwardValueInINR" form="limitchangerequestform" control-disabled="true" no-of-decimals="{{vm.noOfDecimalsForAmount}}" control-modified="vm.checkforModificationField(\'forwardAmount\')"></div><div class="col-sm-2 width-27-per margin-top-xs" ng-show="vm.showLimitUtilised \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& vm.limitHeader.limitInstrumentGroup.shortName==\'FORWARD\'"><span ng-click="vm.ExpandOrCollapseLimitUtilised = !vm.ExpandOrCollapseLimitUtilised"><span ng-if="vm.ExpandOrCollapseLimitUtilised" class="icon arrow_carrot-up check-limit-icon"></span><span ng-if="!vm.ExpandOrCollapseLimitUtilised" class="icon arrow_carrot-down check-limit-icon"></span>&nbsp;<span class="check-limit" data-translate="gatewayApp.limitSettings.checkLimitUtilised"></span></span></div></div></div><div class="form-group" ng-show="vm.limitInstrumentGroup.shortName==\'SPOTWINDOW\'"><div class="col-sm-12 padding-left-0"><div class="col-sm-1" ng-class="{\'width-5-per\': vm.showLimitUtilised, \'width-7-per\': !vm.showLimitUtilised}"><input type="radio" name="optradio" id="radio3" class="radio" ng-model="vm.selectedInstrument" value="uptoSpot" form="limitchangerequestform" ng-disabled="vm.disableRadio" style="margin-top: 8px"></div><div class="col-sm-3 multi-col" ng-class="{\'width-15-per\': vm.showLimitUtilised, \'width-19-per\': !vm.showLimitUtilised}"><label ng-class="{\'control-label limit-change-lbl-width\' : vm.selectedInstrument ==\'uptoSpot\' ,\'control-label limit-change-all-lbl-width\'  : vm.selectedInstrument !=\'uptoSpot\'} " for="txtuptospot"><span data-translate="gatewayApp.limitSettings.uptoSpot"></span></label></div><div class="multi-col txt" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}"><cspl-numeric control-id="txtuptospot" control-model="vm.uptoSpotValue" form="limitchangerequestform" control-disabled="( !vm.disableValues && vm.selectedInstrument ==\'uptoSpot\') ?false:true" no-of-decimals="{{2}}" control-min="{{vm.minValue}}" control-max="999999999999.99" control-required="false" control-modified="vm.checkforModificationField(\'upToSpotAmount\')"></div><div class="multi-col txt" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}" ng-show="vm.showLimitUtilisedWithINR"><cspl-numeric control-id="txtuptoSpotValueInINR" control-model="vm.uptoSpotValueInINR" form="limitchangerequestform" control-disabled="true" no-of-decimals="{{vm.noOfDecimalsForAmount}}" control-modified="vm.checkforModificationField(\'upToSpotAmount\')"></div><div class="col-sm-2 width-27-per margin-top-xs" ng-show="vm.showLimitUtilised \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& vm.limitHeader.limitInstrumentGroup.shortName==\'SPOTWINDOW\' \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& vm.selectedInstrument!=\'individual\'"><span ng-click="vm.ExpandOrCollapseLimitUtilised = !vm.ExpandOrCollapseLimitUtilised"><span ng-if="vm.ExpandOrCollapseLimitUtilised" class="icon arrow_carrot-up check-limit-icon"></span><span ng-if="!vm.ExpandOrCollapseLimitUtilised" class="icon arrow_carrot-down check-limit-icon"></span>&nbsp;<span class="check-limit" data-translate="gatewayApp.limitSettings.checkLimitUtilised"></span></span></div></div></div><div class="form-group slide-down-animation" ng-show="vm.showLimitUtilised \r\n\t\t\t\t\t&& vm.limitHeader.limitInstrumentGroup.shortName==\'SPOTWINDOW\' \r\n\t\t\t\t\t&& vm.selectedInstrument!=\'individual\'" ng-style="{ display: vm.ExpandOrCollapseLimitUtilised  ? \'block\' : \'none\' }"><div class="col-sm-1 multi-col width-5-per"></div><div class="col-sm-11 padding-left-0"><div ng-include="\'app/entities/manage-limit/limit-utilisation-details.html\'"></div></div></div><div class="form-group" ng-show="vm.limitInstrumentGroup.shortName==\'ALL\'"><div class="col-sm-12 padding-left-0"><div class="multi-col txt" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}"><cspl-numeric control-id="txtall" control-model="vm.allValue" form="limitchangerequestform" control-disabled="vm.disableValues" no-of-decimals="{{2}}" control-min="{{vm.minValue}}" control-max="999999999999.99" control-required="false" control-modified="vm.checkforModificationField(\'allAmount\')"></div><div class="multi-col txt" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}" ng-show="vm.showLimitUtilisedWithINR"><cspl-numeric control-id="txtallValueInINR" control-model="vm.allValueInINR" form="limitchangerequestform" control-disabled="true" no-of-decimals="{{vm.noOfDecimalsForAmount}}" control-modified="vm.checkforModificationField(\'allAmount\')"></div><div class="col-sm-2 width-27-per margin-top-xs" ng-show="vm.showLimitUtilised \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& vm.limitHeader.limitInstrumentGroup.shortName==\'ALL\'"><span ng-click="vm.ExpandOrCollapseLimitUtilised = !vm.ExpandOrCollapseLimitUtilised"><span ng-if="vm.ExpandOrCollapseLimitUtilised" class="icon arrow_carrot-up check-limit-icon"></span><span ng-if="!vm.ExpandOrCollapseLimitUtilised" class="icon arrow_carrot-down check-limit-icon"></span>&nbsp;<span class="check-limit" data-translate="gatewayApp.limitSettings.checkLimitUtilised"></span></span></div></div></div><div class="form-group slide-down-animation" ng-show="vm.showLimitUtilised \r\n\t\t\t\t\t&& (vm.limitHeader.limitInstrumentGroup.shortName==\'FORWARD\' || vm.limitHeader.limitInstrumentGroup.shortName==\'ALL\')" ng-style="{ display: vm.ExpandOrCollapseLimitUtilised  ? \'block\' : \'none\' }"><div class="col-sm-12 padding-left-0"><div ng-include="\'app/entities/manage-limit/limit-utilisation-details.html\'"></div></div></div><div class="form-group"><label class="control-label col-sm-12 padding-left-0" for="limitReinstateType" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitReinstateType"></span></label><div id="btnGroup" class="col-sm-12 padding-left-0" style="padding-bottom:5px"><div class="btn-group" ng-class="{\'highlight-blue-border\' : vm.checkforModificationField(\'limitReinstateType\')}"><label class="btn btn-primary" ng-repeat="limitReinstateType in vm.limitReinstateTypeList" ng-model="vm.limitReinstateType" id="slt_{{limitReinstateType.shortName}}" ng-disabled="vm.disableReinstateField" uib-btn-radio="{{limitReinstateType}}" ng-click="">{{limitReinstateType.name}}</label></div></div><div class="col-sm-12 padding-left-0" ng-if="vm.limitReinstateType !=null"><span class="help-block" style="text-align:left" ng-if="vm.limitReinstateType.shortName == vm.DAILY" data-translate="gatewayApp.limitSettings.dailyDefinition"></span> <span class="help-block" style="text-align:left" ng-if="vm.limitReinstateType.shortName == vm.SETTLED_TRADES" data-translate="gatewayApp.limitSettings.settledTradesDefinition"></span></div></div><div class="form-group col-sm-12 padding-left-0" style="padding-top: 7px; margin-bottom: 5px" ng-show="vm.limitInstrumentGroup.shortName!=\'SPOTWINDOW\'"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitOnTenors"></span></label><div id="btnGroup" style="padding-bottom:7px"><div class="btn-group" ng-class="{\'highlight-blue-border\' : vm.checkforModificationField(\'limitTenorType\')}"><label class="btn btn-primary" ng-repeat="limitTenorType in vm.limitTenorTypeList" id="slt_tenor_{{limitTenorType.shortName}}" ng-model="vm.limitTenorType" ng-disabled="vm.disableReinstateField" ng-click="vm.onChangeLimitTenorType(limitTenorType);" uib-btn-radio="{{limitTenorType}}">{{limitTenorType.name}}</label></div></div><div class="col-sm-12 padding-left-0" ng-if="vm.limitHeader.limitTenorType !=null"><span class="help-block" style="text-align:left" ng-if="vm.limitHeader.limitTenorType.shortName == vm.MAXIMUMTENOR" data-translate="gatewayApp.limitSettings.maximumTenorDefinition"></span> <span class="help-block" style="text-align:left" ng-if="vm.limitHeader.limitTenorType.shortName == vm.MAXIMUMVALUEDATE" data-translate="gatewayApp.limitSettings.maximumValueDateDefinition"></span></div></div><div class="form-group col-sm-12 padding-left-0" ng-if="vm.limitInstrumentGroup.shortName!=\'SPOTWINDOW\' && vm.limitTenorType.shortName!=\'NA\'"><div class="col-sm-12 padding-left-0" ng-if="vm.limitTenorType.shortName==\'MAXIMUMTENOR\'"><div class="padding-left-0" ng-class="{\'col-sm-2\': vm.showLimitUtilised, \'col-sm-3\': !vm.showLimitUtilised}"><select class="form-control select-style" name="maximumTenorType" ng-model="vm.maximumTenorType" ng-class="{\'highlight-blue-border\' : vm.checkforModificationField(\'maximumTenorType\')}" form="limitchangerequestform" required ng-disabled="vm.disableReinstateField"><option ng-repeat="maximumTenorType in vm.maximumTenorTypeList" value="{{maximumTenorType}}">{{maximumTenorType}}</option></select></div><div ng-class="{\'col-sm-2\': vm.showLimitUtilised, \'col-sm-3\': !vm.showLimitUtilised}"><!-- <cspl-numeric control-id="txtMaxTenorValue" control-model="vm.limitHeader.maximumTenorValue"\r\n\t\t\t\t\t\t\t\t\tform="limitchangerequestform"\r\n\t\t\t\t\t\t\t\t\tno-of-decimals="{{0}}" control-min="0" control-disabled="vm.disableReinstateField"\r\n\t\t\t\t\t\t\t\t\tcontrol-required="vm.limitInstrumentGroup.shortName!=\'SPOTWINDOW\' && vm.limitTenorType.shortName==\'MAXIMUMTENOR\'"></cspl-numeric> --><!-- <input class="form-control maximum-tenor-control" ng-class="{\'error-border\': limitchangerequestform.txtMaxTenorValue.$invalid && vm.touchedMaxTenorValue}" \r\n\t\t\t\t\t\t\t\t\tname="txtMaxTenorValue" type="text" ng-model="vm.limitHeader.maximumTenorValue"  angular-currency="{mDec: 0, vMin: 0}"  \r\n\t\t\t\t\t\t\t\t\tng-required="vm.limitInstrumentGroup.shortName!=\'SPOTWINDOW\' && vm.limitTenorType.shortName==\'MAXIMUMTENOR\'"\r\n\t\t\t\t\t\t\t\t\tng-disabled="vm.disableReinstateField" form="limitchangerequestform" ng-init="vm.touchedMaxTenorValue=false" \r\n\t\t\t\t\t\t\t\t\tng-blur="vm.touchedMaxTenorValue=true"></input>\r\n\t\t\t\t\t\t\t\t\t<span class="help-block-error" ng-show="limitchangerequestform.txtMaxTenorValue.$invalid && vm.touchedMaxTenorValue">This field cannot be left blank</span>  --><cspl-custom-numeric control-id="txtMaxTenorValue" control-model="vm.limitHeader.maximumTenorValue" form="limitchangerequestform" no-of-decimals="{{0}}" control-min="0" control-disabled="vm.disableReinstateField" control-required="vm.limitInstrumentGroup.shortName!=\'SPOTWINDOW\' && vm.limitTenorType.shortName==\'MAXIMUMTENOR\'" control-modified="vm.checkforModificationField(\'maximumTenorValue\')"></cspl-custom-numeric></div></div><div class="padding-left-0" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}" ng-if="vm.limitTenorType.shortName==\'MAXIMUMVALUEDATE\'"><cspl-dtp control-id="dtpMaxValueDate" control-model="vm.maximumValueDate" control-required="vm.limitInstrumentGroup.shortName!=\'SPOTWINDOW\' && vm.limitTenorType.shortName==\'MAXIMUMVALUEDATE\'" control-disabled="vm.disableReinstateField" form="limitchangerequestform" control-modified="vm.checkforModificationField(\'maximumValueDate\')"></cspl-dtp></div></div><div class="form-group"><div class="col-sm-12 padding-left-0"><label class="padding-left-0 control-label" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}" for="dtpEfctFrom" cspl-mandatory><span data-translate="gatewayApp.limitSettings.effectiveFrom"></span></label><label class="padding-left-0 control-label" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}" for="dtpEfctTo" cspl-mandatory><span data-translate="gatewayApp.limitSettings.effectiveTo"></span></label></div><div class="col-sm-12 padding-left-0" style="padding-bottom: 7px"><div class="padding-left-0" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}"><cspl-dtp control-id="dtpEfctFrom" control-model="vm.effectiveFromDate" form="limitchangerequestform" control-disabled="true"></cspl-dtp></div><div class="padding-left-0" ng-class="{\'col-sm-3\': vm.showLimitUtilised, \'col-sm-4\': !vm.showLimitUtilised}"><cspl-dtp control-id="dtpEfctTo" control-model="vm.effectiveToDate" form="limitchangerequestform" control-disabled="vm.disableEffectiveToDate" control-required="!vm.disableEffectiveToDate" control-modified="vm.checkforModificationField(\'effectiveToDate\')"></cspl-dtp></div></div></div><div class="form-group" style="padding-top: 8px" ng-show="vm.showCustomerRemarks"><label class="col-sm-12 padding-left-0 control-label" for="txtCustomerRemarks"><span data-translate="gatewayApp.limitSettings.customerRemarks"></span></label><div class="col-sm-12 padding-left-0"><cspl-multiline-text control-model="vm.limitHeader.customerRemarks" control-rows="5" control-maxlength="1000" control-id="txtCustomerRemarks" form="limitchangerequestform" control-disabled="vm.disableValues || vm.globalValues.getOrganisation().organisationType.shortName!=\'CUSTOMER\'" autofocus></cspl-multiline-text></div></div><div class="form-group" style="padding-top: 8px" ng-show="vm.globalValues.getOrganisation().organisationType.shortName!=\'CUSTOMER\'"><label class="col-sm-12 padding-left-0 control-label" for="txtRemarks"><span data-translate="gatewayApp.limitSettings.remarks"></span></label><div class="col-sm-12 padding-left-0"><cspl-multiline-text control-model="vm.limitHeader.userRemarks" control-rows="5" control-maxlength="1000" control-id="txtRemarks" form="limitchangerequestform" control-disabled="vm.disableUserRemarks" autofocus></cspl-multiline-text></div></div></div></fieldset></div><div class="modal-footer"><div class="row"><span class="orderStatusInfo left-floating italic-font" data-translate="gatewayApp.limitSettings.fcyLimitNote"></span></div><div class="row" style="margin-top: 10px"><button type="button" ng-show="showDiscardButton || showApproveRejectButton || showOkButton " class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button> <button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" ng-show="showResubmitButton || showButton"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="limitchangerequestform.$invalid || vm.clicked " ng-click="vm.clicked = true;vm.resubmitLimitSettings();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="limitchangerequestform.$invalid || (vm.limitHeader.id == null && limitchangerequestform.$invalid) || (vm.limitHeader.id != null && limitchangerequestform.$pristine) || vm.clicked" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardLimitSettings()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectLimitSettings()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-approve" ng-disabled="limitchangerequestform.$invalid    || vm.clicked" ng-click="vm.clicked = true;vm.approveLimitSettings();" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></div></form><!-- <style>\r\n\t.error-border{\r\n\t\tborder: 1px solid #FF3737 !important;\r\n\t}\r\n</style> -->');
$templateCache.put('app/entities/manage-limit/limit-dialog.html','<form name="limitchangerequestform" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span ng-show="vm.actionType==\'Add\'" data-translate="gatewayApp.limitSettings.addLimit"></span> <span ng-show="vm.actionType==\'Change\'" data-translate="gatewayApp.limitSettings.editLimit"></span> <span ng-show="vm.actionType==\'CustomerChange\'" data-translate="gatewayApp.limitSettings.changeLimit"></span> <span ng-show="vm.actionType==\'CustomerCreate\'" data-translate="gatewayApp.limitSettings.customerNewLimit"></span> <span ng-show="vm.actionType==\'View\'" data-translate="gatewayApp.limitSettings.viewLimit"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="content"><fieldset ng-disabled="vm.disableForm"><br><div ng-class="{\'col-sm-4\': vm.showLimitUtilised, \'col-sm-6 col-centered\': (!vm.showLimitUtilised && !vm.showLimitUtilisedWithINR)}"><div class="form-group"><label class="control-label" for="txtbank" cspl-mandatory><span data-translate="gatewayApp.limitSettings.bank"></span></label><cspl-text control-id="txtbank" control-model="vm.limitHeader.bank.bankName" form="limitchangerequestform" control-disabled="true"></div><div class="form-group"><label class="control-label" for="txtbranch" cspl-mandatory><span data-translate="gatewayApp.limitSettings.branch"></span></label><cspl-ach control-id="txtbranch" control-model="vm.limitHeader.branch" lookup-name="validStatusBranchesForBank" display-column="shortName" form="limitchangerequestform" control-disabled="vm.disableBranch" control-required="!vm.disableBranch"></cspl-ach></div><div class="form-group"><label class="control-label" for="txtcustomer" cspl-mandatory><span data-translate="gatewayApp.limitSettings.customer"></span></label><cspl-ach control-id="txtcustomer" control-place-holder="Enter Customer ID or Name" form="limitchangerequestform" control-model="vm.limitHeader.customer" lookup-name="allTypeCustomersForLimits" filter-value="{{vm.limitHeader.bank.id}}~~{{vm.limitHeader.branch.id}}~~{{vm.limitHeader.customer.id}}" display-column="customerCode,customerName" control-disabled="vm.disableCustomer" control-required="!vm.disableCustomer"></cspl-ach><span class="cutomer-highlight" ng-if="vm.limitHeader.customer.customerMiddleName==null">{{vm.limitHeader.customer.customerFirstName+\' \'+vm.limitHeader.customer.customerLastName}}</span> <span class="cutomer-highlight" ng-if="vm.limitHeader.customer.customerMiddleName!=null">{{vm.limitHeader.customer.customerFirstName+\' \'+ vm.limitHeader.customer.customerMiddleName+\' \'+vm.limitHeader.customer.customerLastName}}</span></div><div class="form-group col-sm-10" style="padding-left: 0"><label class="control-label" for="seltype" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitType"></span></label><select class="form-control select-style" control-id="seltype" ng-model="vm.selectedLimitType" style="width: 75%" ng-options="x.displayName for x in vm.limitTypes track by x.displayName" form="limitchangerequestform" ng-disabled="vm.disableLimitType" ng-required="!vm.disableLimitType"><option selected="selected" disabled="disabled" hidden style="display: none" value=""></option></select><!--  ng-class="{\'form-control select-light\' : !vm.disableLimitType, \'form-control disable-select-light\' : vm.disableLimitType }"  --></div><div class="form-group col-sm-10" style="padding-left: 0"><label class="control-label" for="selccy" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitCurrency"></span></label><select class="form-control select-style" control-id="selccy" ng-model="vm.limitHeader.limitCurrency" style="width: 75%" ng-options="x.code for x in vm.currencies track by x.code" form="limitchangerequestform" ng-disabled="vm.disableCurrency" ng-required="!vm.disableCurrency"><option selected="selected" disabled="disabled" hidden style="display: none" value=""></option></select><!-- ng-class="{\'form-control select-light\' : !vm.disableLimitType, \'form-control disable-select-light\' : vm.disableLimitType }" --></div><div class="form-group"><div class="col-sm-12"><div class="col-sm-5" style="padding-left: 0"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.limitSettings.instrument"></span></label></div><div class="col-sm-7" style="padding-left: 2px"><label class="control-label"><span data-translate="gatewayApp.limitSettings.requestingFor"></span></label></div></div><div class="col-sm-12"><div class="col-sm-1"><input type="radio" name="optradio" id="radio1" class="radio" ng-model="vm.selectedInstrument" value="individual" form="limitchangerequestform" ng-disabled="vm.disableRadio" style="margin-top: 8px"></div><div class="col-sm-4 multi-col"><label ng-class="{\'control-label limit-change-lbl\' : vm.selectedInstrument ==\'individual\' ,\'control-label limit-change-all-lbl\'  : vm.selectedInstrument !=\'individual\'} " for="txtspot"><span data-translate="gatewayApp.limitSettings.spot"></span></label></div><div class="col-sm-7 multi-col txt"><cspl-numeric control-id="txtspot" control-model="vm.spotValue" form="limitchangerequestform" control-disabled="(!vm.disableValues && vm.selectedInstrument ==\'individual\') ?false:true" no-of-decimals="{{2}}" control-min="{{vm.minValue}}" control-max="999999999999.99" control-required="false"></div></div></div><div class="form-group"><div class="col-sm-12"><div class="col-sm-1"></div><div class="col-sm-4 multi-col"><label ng-class="{\'control-label limit-change-lbl\' : vm.selectedInstrument ==\'individual\' ,\'control-label limit-change-all-lbl\'  : vm.selectedInstrument !=\'individual\'} " for="txttom"><span data-translate="gatewayApp.limitSettings.tom"></span></label></div><div class="col-sm-7 multi-col txt"><cspl-numeric control-id="txttom" control-model="vm.tomValue" form="limitchangerequestform" control-disabled="(!vm.disableValues && vm.selectedInstrument ==\'individual\') ?false:true" no-of-decimals="{{2}}" control-min="{{vm.minValue}}" control-max="999999999999.99" control-required="false"></div></div></div><div class="form-group"><div class="col-sm-12"><div class="col-sm-1 multi-col"></div><div class="col-sm-4 multi-col"><label ng-class="{\'control-label limit-change-lbl\' : vm.selectedInstrument ==\'individual\' ,\'control-label limit-change-all-lbl\'  : vm.selectedInstrument !=\'individual\'} " for="txtcash"><span data-translate="gatewayApp.limitSettings.cash"></span></label></div><div class="col-sm-7 multi-col txt"><cspl-numeric control-id="txtcash" control-model="vm.cashValue" form="limitchangerequestform" control-disabled="(!vm.disableValues &&vm.selectedInstrument ==\'individual\') ?false:true" no-of-decimals="{{2}}" control-min="{{vm.minValue}}" control-max="999999999999.99" control-required="false"></div></div></div><div class="form-group"><div class="col-sm-12"><div class="col-sm-1 multi-col"></div><div class="col-sm-4 multi-col"><label ng-class="{\'control-label limit-change-lbl-width\' : vm.selectedInstrument ==\'individual\' ,\'control-label limit-change-all-lbl-width\'  : vm.selectedInstrument !=\'individual\'} " for="txtforward"><span data-translate="gatewayApp.limitSettings.forward"></span></label></div><div class="col-sm-7 multi-col txt"><cspl-numeric control-id="txtforward" control-model="vm.forwardValue" form="limitchangerequestform" control-disabled="(!vm.disableValues &&vm.selectedInstrument ==\'individual\') ?false:true" no-of-decimals="{{2}}" control-min="{{vm.minValue}}" control-max="999999999999.99" control-required="false"></div></div></div><div class="form-group"><div class="col-sm-12"><div class="col-sm-1"><input type="radio" name="optradio" id="radio3" class="radio" ng-model="vm.selectedInstrument" value="uptoSpot" form="limitchangerequestform" ng-disabled="vm.disableRadio" style="margin-top: 8px"></div><div class="col-sm-4 multi-col"><label ng-class="{\'control-label limit-change-lbl-width\' : vm.selectedInstrument ==\'uptoSpot\' ,\'control-label limit-change-all-lbl-width\'  : vm.selectedInstrument !=\'uptoSpot\'} " for="txtuptospot"><span data-translate="gatewayApp.limitSettings.uptoSpot"></span></label></div><div class="col-sm-7 multi-col txt"><cspl-numeric control-id="txtuptospot" control-model="vm.uptoSpotValue" form="limitchangerequestform" control-disabled="( !vm.disableValues && vm.selectedInstrument ==\'uptoSpot\') ?false:true" no-of-decimals="{{2}}" control-min="{{vm.minValue}}" control-max="999999999999.99" control-required="false"></div></div></div><div class="form-group"><div class="col-sm-12"><div class="col-sm-1 multi-col"></div><div class="col-sm-4 multi-col"><label ng-class="{\'control-label limit-change-lbl-width\' : vm.selectedInstrument ==\'uptoSpot\' ,\'control-label limit-change-all-lbl-width\'  : vm.selectedInstrument !=\'uptoSpot\'} " for="txtuptospotforward"><span data-translate="gatewayApp.limitSettings.forward"></span></label></div><div class="col-sm-7 multi-col txt"><cspl-numeric control-id="txtuptospotforward" control-model="vm.forwardUptoSpotValue" form="limitchangerequestform" control-disabled="(!vm.disableValues &&vm.selectedInstrument ==\'uptoSpot\') ?false:true" no-of-decimals="{{2}}" control-min="{{vm.minValue}}" control-max="999999999999.99" control-required="false"></div></div></div><div class="form-group"><div class="col-sm-12"><div class="col-sm-1"><input type="radio" name="optradio" id="radio2" class="radio" ng-model="vm.selectedInstrument" value="all" form="limitchangerequestform" ng-disabled="vm.disableRadio" style="margin-top: 8px"></div><div class="col-sm-4 multi-col"><label ng-class="{\'control-label limit-change-lbl\' : vm.selectedInstrument ==\'all\' ,\'control-label limit-change-all-lbl\'  : vm.selectedInstrument !=\'all\'} " for="txtxall"><span data-translate="gatewayApp.limitSettings.all"></span></label></div><div class="col-sm-7 multi-col txt"><cspl-numeric control-id="txtall" control-model="vm.allValue" form="limitchangerequestform" control-disabled="( !vm.disableValues && vm.selectedInstrument ==\'all\') ?false:true" no-of-decimals="{{2}}" control-min="{{vm.minValue}}" control-max="999999999999.99" control-required="false"></div></div></div><div class="form-group"><label class="col-sm-12 control-label" for="dtpEfctFrom" cspl-mandatory><span data-translate="gatewayApp.limitSettings.effectiveFrom"></span></label><div class="col-sm-8"><cspl-dtp control-id="dtpEfctFrom" control-model="vm.efectiveFromDate" form="limitchangerequestform" control-disabled="true"></cspl-dtp></div></div><div class="form-group"><label class="col-sm-12 control-label" for="dtpEfctTo" cspl-mandatory><span data-translate="gatewayApp.limitSettings.effectiveTo"></span></label><div class="col-sm-8"><cspl-dtp control-id="dtpEfctTo" control-model="vm.efectiveToDate" form="limitchangerequestform" control-disabled="vm.disableEffectiveToDate" control-required="!vm.disableEffectiveToDate"></cspl-dtp></div></div><div class="form-group"><label class="col-sm-12 control-label" for="isLimitToBeReinstated" cspl-mandatory><span data-translate="gatewayApp.limitSettings.isLimitTobeReInstated"></span></label><div id="btnGroup" class="col-sm-8" style="padding-bottom:7px"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.isLimitToBeReinstated" ng-disabled="vm.disableReinstateField" uib-btn-radio="vm.YES">Yes</label><label class="btn btn-primary" ng-model="vm.isLimitToBeReinstated" ng-disabled="vm.disableReinstateField" uib-btn-radio="vm.NO">No&nbsp;</label></div></div></div><div class="form-group" ng-if="vm.showLimiReinstateType"><label class="control-label col-sm-12" ng-if="vm.showLimiReinstateType" for="limitReinstateType" cspl-mandatory><span data-translate="gatewayApp.limitSettings.limitReinstateType"></span></label><div id="btnGroup" class="col-sm-12" style="padding-bottom:7px" ng-if="vm.showLimiReinstateType"><div class="btn-group"><label class="btn btn-primary" id="reinstateMethodRadio" ng-model="vm.limitHeader.limitReinstateMethod" ng-disabled="vm.disableReinstateField" uib-btn-radio="vm.DAILY" ng-required="vm.showLimiReinstateType">Daily</label><label class="btn btn-primary" ng-model="vm.limitHeader.limitReinstateMethod" ng-disabled="vm.disableReinstateField" uib-btn-radio="vm.SETTLED_TRADES">Settled Trades&nbsp;</label></div></div><div class="col-sm-12" ng-if="vm.limitHeader.limitReinstateMethod !=null"><span class="help-block" style="text-align:left" ng-if="vm.limitHeader.limitReinstateMethod == vm.DAILY" data-translate="gatewayApp.limitSettings.dailyDefinition"></span> <span class="help-block" style="text-align:left" ng-if="vm.limitHeader.limitReinstateMethod == vm.SETTLED_TRADES" data-translate="gatewayApp.limitSettings.settledTradesDefinition"></span></div></div><div class="form-group"><label class="col-sm-12 control-label" for="txtRemarks"><span data-translate="gatewayApp.limitSettings.remarks"></span></label><div class="col-sm-12"><cspl-multiline-text control-model="vm.limitHeader.userRemarks" control-rows="5" control-maxlength="1000" control-id="txtRemarks" form="limitchangerequestform" control-disabled="vm.disableValues" autofocus></cspl-multiline-text></div></div></div><div class="col-sm-2" ng-show="vm.showLimitUtilisedWithINR"><div class="form-group all-instrument-limit-usd-eqv" ng-show="vm.selectedInstrument ==\'all\'"><div class="col-sm-12 multi-col txt"><label class="control-label"><span data-translate="gatewayApp.limitSettings.usdEqv"></span></label><cspl-numeric control-id="txtall" control-model="vm.allValueInINR" form="limitchangerequestform" control-disabled="true" no-of-decimals="{{vm.noOfDecimalsForAmount}}"></div></div><div class="form-group individual-instrument-limit-usd-eqv" ng-show="vm.selectedInstrument ==\'individual\'"><div class="col-sm-12 multi-col txt"><label class="control-label"><span data-translate="gatewayApp.limitSettings.usdEqv"></span></label><cspl-numeric control-id="txtall" control-model="vm.spotValueInINR" form="limitchangerequestform" control-disabled="true" no-of-decimals="{{vm.noOfDecimalsForAmount}}"></div></div><div class="form-group" ng-show="vm.selectedInstrument ==\'individual\'"><div class="col-sm-12 multi-col txt"><cspl-numeric control-id="txtall" control-model="vm.tomValueInINR" form="limitchangerequestform" control-disabled="true" no-of-decimals="{{vm.noOfDecimalsForAmount}}"></div></div><div class="form-group" ng-show="vm.selectedInstrument ==\'individual\'"><div class="col-sm-12 multi-col txt"><cspl-numeric control-id="txtall" control-model="vm.cashValueInINR" form="limitchangerequestform" control-disabled="true" no-of-decimals="{{vm.noOfDecimalsForAmount}}"></div></div><div class="form-group" ng-show="vm.selectedInstrument ==\'individual\'"><div class="col-sm-12 multi-col txt"><cspl-numeric control-id="txtall" control-model="vm.forwardValueInINR" form="limitchangerequestform" control-disabled="true" no-of-decimals="{{vm.noOfDecimalsForAmount}}"></div></div><div class="form-group uptospot-instrument-limit-usd-eqv" ng-show="vm.selectedInstrument ==\'uptoSpot\'"><div class="col-sm-12 multi-col txt"><label class="control-label"><span data-translate="gatewayApp.limitSettings.usdEqv"></span></label><cspl-numeric control-id="txtall" control-model="vm.uptoSpotValueInINR" form="limitchangerequestform" control-disabled="true" no-of-decimals="{{vm.noOfDecimalsForAmount}}"></div></div><div class="form-group" ng-show="vm.selectedInstrument ==\'uptoSpot\'"><div class="col-sm-12 multi-col txt"><cspl-numeric control-id="txtall" control-model="vm.forwardUptoSpotValueInINR" form="limitchangerequestform" control-disabled="true" no-of-decimals="{{vm.noOfDecimalsForAmount}}"></div></div></div><div ng-class="{\'col-sm-8\': vm.showLimitUtilised, \'col-sm-6\': vm.showLimitUtilisedWithINR}" ng-show="vm.showLimitUtilised"><div class="form-group"><div class="table-responsive customer-limit" style="overflow-x:auto;overflow-y:hidden" ng-class="{\'all-instrument-limit\': vm.selectedInstrument ==\'all\', \'individual-instrument-limit\': vm.selectedInstrument ==\'individual\', \'uptospot-instrument-limit\': vm.selectedInstrument ==\'uptoSpot\'}"><span class="help-block" data-translate="gatewayApp.limitSettings.allInUSD"></span><table id="tblLimitUtilised" class="dataTable table table-striped table-hover"><thead><tr><th class="text-right" data-translate="gatewayApp.limitSettings.currentlyAllocated"></th><th class="text-right" data-translate="gatewayApp.limitSettings.utilised"></th><th class="text-right" data-translate="gatewayApp.limitSettings.remaining"></th><th class="text-right" data-translate="gatewayApp.limitSettings.pov"></th></tr></thead><tbody><tr ng-repeat="limitUtilisationDetail in filterData = (vm.limitUtilisationDetails)"><!-- Column values --><td class="text-right" style="background: #8C6900">{{limitUtilisationDetail.limitAllocatedInUSD | number:vm.noOfDecimalsForAmount}}</td><td class="text-right" style="background: #8C2B2B">{{limitUtilisationDetail.limitUsed | number:vm.noOfDecimalsForAmount}}</td><td class="text-right" style="background: #177317">{{limitUtilisationDetail.limitAllocatedInUSD - limitUtilisationDetail.limitUsed | number:vm.noOfDecimalsForAmount}}</td><td class="text-right" style="background: #4A4A4A">{{limitUtilisationDetail.totalPendingBuyOrderValue + limitUtilisationDetail.totalPendingSellOrderValue | number:vm.noOfDecimalsForAmount}}</td></tr></tbody></table><span class="help-block" data-translate="gatewayApp.limitSettings.povDetails"></span></div></div></div></fieldset></div><div class="modal-footer"><button type="button" ng-show="showDiscardButton || showApproveRejectButton || showOkButton " class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button> <button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" ng-show="showResubmitButton || showButton"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="limitchangerequestform.$invalid || vm.clicked " ng-click="vm.clicked = true;vm.resubmitLimitSettings();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="limitchangerequestform.$invalid || (vm.limitHeader.id == null && limitchangerequestform.$invalid) || (vm.limitHeader.id != null && limitchangerequestform.$pristine) || vm.clicked" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardLimitSettings()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectLimitSettings()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-approve" ng-disabled="limitchangerequestform.$invalid    || vm.clicked" ng-click="vm.clicked = true;vm.approveLimitSettings();" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/manage-limit/limit-utilisation-details.html','<div class="table-responsive" style="overflow-x:auto;overflow-y:hidden"><span class="help-block" data-translate="gatewayApp.limitSettings.allInUSD"></span><table id="tblLimitUtilised" class="dataTable table table-striped"><thead><tr><th></th><th class="text-right" data-translate="gatewayApp.limitSettings.currentlyAllocated"></th><th class="text-right" data-translate="gatewayApp.limitSettings.utilised"></th><th class="text-right" data-translate="gatewayApp.limitSettings.remaining"></th><th class="text-right" data-translate="gatewayApp.limitSettings.pov"></th></tr></thead><tbody><tr ng-repeat="limitUtilisationDetail in filterData = (vm.limitUtilisationDetails)"><!-- Column values --><td class="text-center" style="background: #262626">{{limitUtilisationDetail.instrumentCode}}</td><td class="text-right" style="background: #004660">{{limitUtilisationDetail.limitAllocatedInUSD | number:vm.noOfDecimalsForAmount}}</td><td class="text-right" style="background: #4D0000">{{limitUtilisationDetail.limitUsed | number:vm.noOfDecimalsForAmount}}</td><td class="text-right" style="background: #223415">{{limitUtilisationDetail.limitAllocatedInUSD - limitUtilisationDetail.limitUsed | number:vm.noOfDecimalsForAmount}}</td><td class="text-right" style="background: #664D00">{{limitUtilisationDetail.totalPendingBuyOrderValue + limitUtilisationDetail.totalPendingSellOrderValue | number:vm.noOfDecimalsForAmount}}</td></tr></tbody></table><span class="help-block" data-translate="gatewayApp.limitSettings.povDetails"></span></div>');
$templateCache.put('app/entities/manage-limit/manage-limit.html','<style>.limit_lbl{\r\npadding-top:5px;\r\npadding-right:10px;\r\npadding-left:5px;\r\n}\r\ntable.table .dropdownOptionsMenualignment{\r\n\tleft: -90px;\r\n\tmin-width: 105px;\r\n}</style><div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="gatewayApp.limitSettings.title"></span></h2><nmb-alert></nmb-alert><!-- <nmb-alert-error></nmb-alert-error>  --><div class="module-wrapper"><section class="module"><div class="module-inner"><br><div class="row"><form name="manageLimitForm"><script>$(document).ready(function() {\r\n\t\t\t\t\t\t\t   $(\'#limitInfo\').popover({\r\n\t\t\t\t\t\t\t\t  container: \'body\',\r\n\t\t\t\t\t\t\t\t  html: true\r\n\t\t\t\t\t\t\t   })\r\n\t\t\t\t\t\t\t});</script><div class="col-sm-1"><label class="control-label limit_lbl"><span data-translate="gatewayApp.limitSettings.branch"></span></label></div><div class="col-sm-3"><cspl-ach control-model="vm.selectedBranch" lookup-name="validStatusBranchesForBank" display-column="shortName" filter-value="{{ vm.selectedBank.id}}" form="manageLimitForm" control-id="txtBranch" control-disabled="vm.disableBranch"></cspl-ach></div><div class="col-sm-2 col-xs-7 noPaddingMargin"><label class="control-label limit_lbl"><span data-translate="gatewayApp.limitSettings.showLimitsExpiringInNext"></span></label></div><div class="col-sm-1 col-xs-3 noPaddingMargin"><cspl-text control-type="Number" control-model="vm.limitsExpiringIn" control-maxlength="3" control-id="txtexpiry_day" form="manageLimitForm" control-disabled="vm.disableExpiringIn"></div><div class="col-sm-1 col-xs-1"><label class="control-label limit_lbl"><span data-translate="gatewayApp.limitSettings.days"></span></label></div><div class="col-sm-2 col-xs-7"><label class="control-label limit_lbl checkbox-inline"><input type="checkbox" form="manageLimitForm" ng-model="vm.showExpired" id="expitytxt"><span data-translate="gatewayApp.limitSettings.showExpiredLimits"></span></label></div><div class="col-sm-1 col-xs-3"><button type="button" class="btn btn-info active" ng-disabled="vm.clicked" ng-click="vm.loadAll();vm.clicked=true;"><span data-translate="entity.action.go"></span></button></div></form></div><br><div class="row"><div class="pull-left"><cspl-table-export table-name="tblLimitSettings" total-record-count="filterData.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Manage_Limits"></cspl-table-export></div><div class="pull-left" style="margin-left: 0px" ng-show="vm.permitLimitImportEntityAction"><cspl-table-import upload-type="LimitSettingsImport" file-content=""></cspl-table-import></div><div class="pull-left" style="margin-top: 25px;margin-left: 0px"><a ng-show="userPreference.showInfoIcon==\'yes\'" id="limitInfo" tabindex="0" data-toggle="popover" role="button" data-trigger="focus" data-placement="right" data-content="Operation Type - Add/Edit/Reset To All/Reset To Spot/Reset To Forward<br>\r\n\t\t\t\t\t\t\t\t\tLimit to be set for- SpotWindow/Forward/All<br>\r\n\t\t\t\t\t\t\t\t\tLimit Type - Global Gross/Gross Buy/Gross Sell/Net<br>\r\n\t\t\t\t\t\t\t\t\tLimit Currency Code - USD/INR<br>\r\n\t\t\t\t\t\t\t\t\tLimit on Tenors Type - Not Applicable/Maximum Tenor/Maximum Value Date<br>\r\n\t\t\t\t\t\t\t\t\tMaximum Tenor Type - Days/Months in case Maximum Tenor selected as Limit on Tenors Type<br> \r\n\t\t\t\t\t\t\t\t\tMaximum Tenor - No of days/months<br> \r\n\t\t\t\t\t\t\t\t\tMaximum Value Date - dd-MMM-yyyy in case Maximum value date selected as Limit on Tenors Type<br>\r\n\t\t\t\t\t\t\t\t\tEffective To date - dd-MMM-yyyy<br>\r\n\t\t\t\t\t\t\t\t\tLimit Reinstatement Method - Not Applicable/Daily/Settled Trades" data-template="<div class=\'mainViewPopover popover\'  role=\'tooltip\'><div class=\'arrow\'></div><div class=\'popover-content\' ></div></div>"><span class="icon"><img class="home-page-help-icon width-height-20" src="assets/images/Info-24.png"></span></a></div><div class="float-right"><button type="button" class="btn btn-info active" ng-show="vm.permitLimitCreateEntityAction" ng-click="vm.screenLog.screenLog(vm.screenName, 0,vm.entityConstants.ENTITY_ACTION_TYPE.ADD); vm.launch()"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span data-translate="gatewayApp.limitSettings.limit">Limit</span></button></div><div class="float-right col-xs-10 col-sm-3 col-md-2"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="table-responsive" style="overflow-x: auto; overflow-y: auto"><table id="tblLimitSettings" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.limitSettings.branch">Branch</th><th data-translate="gatewayApp.limitSettings.customerId">Cust. ID</th><th data-translate="gatewayApp.limitSettings.customerName">Customer Name</th><th data-translate="gatewayApp.limitSettings.instrument">Instrument</th><th data-translate="gatewayApp.limitSettings.limitType">Limit Type</th><th data-translate="gatewayApp.limitSettings.limitCurrency" style="width:30px">Limit CCY</th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.limitSettings.limitAmount">Limit Amount</th><th style="width:5%" data-translate="gatewayApp.limitSettings.limitReinstateType">Limit Reinstate Method</th><th data-translate="gatewayApp.limitSettings.maximumTenor">Maximum Tenor</th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.limitSettings.maximumValueDate">Maximum Value Date</th><th data-translate="gatewayApp.limitSettings.from" style="padding-left:25px">From</th><th data-translate="gatewayApp.limitSettings.to">To</th><!-- <th style="width:5%;word-wrap: break-word; " data-translate="gatewayApp.limitSettings.isLimitTobeReInstated">Is Limit To be reinstated</th> --><th style="width:8%;word-wrap: break-word" data-translate="gatewayApp.limitSettings.remarks">Remarks</th><th style="width:8%;word-wrap: break-word" data-translate="gatewayApp.limitSettings.customerRemarks">Remarks</th><th></th></tr></thead><tbody><tr ng-repeat="limit in filterData = (vm.limitRows | filter : filterText) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break:break-word; min-width: 120px">{{limit.branch.branchName}}</td><td style="white-space: nowrap">{{limit.customer.customerCode }}</td><td style="word-break:break-word; min-width: 120px" ng-if="limit.customer.customerMiddleName!=null ">{{limit.customer.customerFirstName+\' \'+limit.customer.customerMiddleName+\' \'+limit.customer.customerLastName}}</td><td style="word-break:break-word; min-width: 120px" ng-if="limit.customer.customerMiddleName==null">{{limit.customer.customerFirstName+\' \'+limit.customer.customerLastName}}</td><td>{{limit.instrumentType.name}}</td><td>{{limit.limitType}}</td><td>{{limit.limitCurrency.code}}</td><td class="td-text-align-right noPaddingLeftRight">{{limit.value| currency :\'\'}}</td><td style="width:5%">{{limit.limitReinstateType.name}}</td><td ng-if="limit.maximumTenorValue==null"></td><td ng-if="limit.maximumTenorValue!=null && limit.maximumTenorType==\'Days\'">{{limit.maximumTenorValue | number:0}} Day(s)</td><td ng-if="limit.maximumTenorValue!=null && limit.maximumTenorType==\'Months\'">{{limit.maximumTenorValue | number:0}} Month(s)</td><td style="padding-left:25px;white-space: nowrap">{{limit.maximumValueDate | date:\'dd-MMM-yyyy\'}}</td><td style="padding-left:25px;white-space: nowrap">{{limit.effectiveFromDateTime | date:\'dd-MMM-yyyy\'}}</td><td style="white-space: nowrap">{{limit.effectiveToDateTime | date:\'dd-MMM-yyyy\'}}</td><!-- <td style="width:5%"><span    ng-if ="limit.isLimitToBeReinstated == true" data-translate="gatewayApp.limitSettings.yes"></span>\r\n\t\t\t\t\t\t \t\t\t<span   ng-if ="limit.isLimitToBeReinstated == false"  data-translate="gatewayApp.limitSettings.no"></span></td> --><td style="width:8%;word-wrap: break-word; max-width: 200px">{{limit.userRemarks}}</td><td style="width:8%;word-wrap: break-word; max-width: 200px">{{limit.customerRemarks}}</td><td class="sticky-col" style="text-align:center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitLimitViewEntityAction"><a ng-click="vm.view(limit)"><span class="" data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitLimitEditEntityAction && limit.showEdit"><a ng-click="vm.edit(limit)"><span class="" data-translate="entity.action.edit"></span></a></li><li ng-show="vm.permitLimitResetEntityAction && limit.showResetToSpot"><a ng-click="vm.reset(limit, \'SPOTWINDOW\')"><span class="" data-translate="entity.action.resetToSpot"></span></a></li><li ng-show="vm.permitLimitResetEntityAction && limit.showResetToForward"><a ng-click="vm.reset(limit, \'FORWARD\')"><span class="" data-translate="entity.action.resetToForward"></span></a></li><li ng-show="vm.permitLimitResetEntityAction && limit.showResetToAll"><a ng-click="vm.reset(limit, \'ALL\')"><span class="" data-translate="entity.action.resetToAll"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="vm.limitRows.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><div ng-show="filterData.length == 0"><span>No records found</span></div></div><div class="row"><span class="orderStatusInfo right-floating italic-font" data-translate="gatewayApp.limitSettings.fcyLimitNote"></span></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/manage-organisation/manage-organisation.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title">Manage Organisation</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="table-responsive"><table class="datatables-nosort table table-striped table-hover"><thead><tr><th>Short Name</th><th>Full Name</th><th>Address</th><th></th></tr></thead><tbody><tr><td>{{vm.organisation.shortName}}</td><td>{{vm.organisation.name}}</td><td>{{vm.organisation.address}}</td><td style="text-align:center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitOrganisationViewEntityAction"><a ui-sref="manage-organisation.view({id:vm.organisation.id})"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitOrganisationEditEntityAction"><a ui-sref="manage-organisation.edit({id:vm.organisation.id})"><span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/manage-organisation/organisation-edit-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="organisationeditform"><div class="modal-header"><h4 class="modal-title" id="shortTermLoanLabel">Manage Organisation</h4></div><div class="modal-body"><div class="content"><div ng-show="vm.showCorporate"><form name="corpeditform" role="form" novalidate><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Short Name</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.shortName" control-type="ShortName" form="corpeditform" control-id="txtCorporateShortName" control-disabled="true" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Full name</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.name" form="corpeditform" control-id="txtCorporateName" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Security code</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.aliasName" control-type="ShortName" form="corpeditform" control-id="txtCorporateAlias" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Address</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.address" form="corpeditform" control-id="txtAddress" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">City</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.city" form="corpeditform" control-id="txtcity" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Pincode</label><div class="col-sm-3"><cspl-text control-model="vm.organisation.pincode" form="corpeditform" control-id="txtpincode" required></div><label class="col-sm-2 control-label">Country</label><div class="col-sm-3"><cspl-ach control-model="vm.organisation.country" form="corpeditform" lookup-name="country" display-column="shortName" control-id="txtCorporate" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Functional CCY.</label><div class="col-sm-3"><cspl-ach control-model="vm.organisation.functionalCurrency" form="corpeditform" lookup-name="currency" display-column="code" control-id="txtfunctionalCCY" required></div><label class="col-sm-2 control-label" style="padding-bottom:8px">Cross CCY.</label><div class="col-sm-3"><cspl-ach control-model="vm.organisation.crossCurrency" form="corpeditform" lookup-name="currency" display-column="code" control-id="txtcrossCCY" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">FY start month</label><div class="col-sm-3"><select class="form-control" name="txtfyStartMonth" form="corpregform" ng-model="vm.organisation.fyStartMonth" ng-change="vm.calculateFYEndMonth()"><option value="1">Jan</option><option value="2">Feb</option><option value="3">Mar</option><option value="4">Apr</option><option value="5">May</option><option value="6">Jun</option><option value="7">Jul</option><option value="8">Aug</option><option value="9">Sep</option><option value="10">Oct</option><option value="11">Nov</option><option value="12">Dec</option></select></div><label class="col-sm-2 control-label" style="padding-bottom:8px">FY end month</label><div class="col-sm-3"><select class="form-control" name="txtfyEndMonth" form="corpregform" ng-model="vm.organisation.fyEndMonth" ng-disabled="true"><option value="1">Jan</option><option value="2">Feb</option><option value="3">Mar</option><option value="4">Apr</option><option value="5">May</option><option value="6">Jun</option><option value="7">Jul</option><option value="8">Aug</option><option value="9">Sep</option><option value="10">Oct</option><option value="11">Nov</option><option value="12">Dec</option></select></div></div><br><br><div class="modal-footer"><input type="button" class="btn btn-info" value="Cancel" ng-click="vm.clear()"> <input type="button" class="btn btn-info active" value="Resubmit" ng-show="showButton" ng-disabled="corpeditform.$invalid || clicked" ng-click="vm.resubmit();clicked=true;"> <input type="button" class="btn btn-info active" value="Save" ng-show="! showButton" ng-disabled="corpeditform.$invalid || clicked" ng-click="vm.save();clicked=true;"></div></form></div><div ng-hide="vm.showCorporate"><form name="consultanteditForm" role="form"><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Short Name</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.shortName" control-type="ShortName" form="consultanteditForm" control-id="txtCorporateShortName" control-disabled="true" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Full name</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.name" form="consultanteditForm" control-id="txtCorporateName" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Security code</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.aliasName" control-type="ShortName" form="consultanteditForm" control-id="txtCorporateAlias" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Address</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.address" form="consultanteditForm" control-id="txtAddress" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">City</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.city" form="consultanteditForm" control-id="txtcity" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Pincode</label><div class="col-sm-3"><cspl-text control-model="vm.organisation.pincode" form="consultanteditForm" control-id="txtpincode" required></div><label class="col-sm-2 control-label">Country</label><div class="col-sm-3"><cspl-ach control-model="vm.organisation.country" form="consultanteditForm" lookup-name="country" display-column="shortName" control-id="txtCorporate" required></div></div><br><br><div class="modal-footer"><input type="button" class="btn btn-info" value="Cancel" ng-click="vm.clear()"> <input type="button" class="btn btn-info active" value="Resubmit" ng-show="showButton" ng-disabled="consultanteditForm.$invalid || clicked" ng-click="vm.resubmit();clicked=true;"> <input type="button" class="btn btn-info active" value="Save" ng-show="! showButton" ng-disabled="consultanteditForm.$invalid || clicked" ng-click="vm.save();clicked=true;"></div></form></div></div></div></form>');
$templateCache.put('app/entities/manage-organisation/organisation-view-dialog.html','<form name="orgviewform" role="form" novalidate><div class="modal-header"><h4 class="modal-title" id="shortTermLoanLabel">Manage Organisation</h4></div><div class="modal-body"><div class="content"><div ng-show="vm.showCorporate"><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Short Name</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.shortName" control-type="ShortName" form="corpeditform" control-id="txtCorporateShortName" control-disabled="true" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Full name</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.name" form="corpeditform" control-id="txtCorporateName" control-disabled="true" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Security code</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.aliasName" control-type="ShortName" form="corpeditform" control-disabled="true" control-id="txtCorporateAlias" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Address</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.address" form="corpeditform" control-id="txtAddress" control-disabled="true" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">City</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.city" form="corpeditform" control-id="txtcity" control-disabled="true" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Pincode</label><div class="col-sm-3"><cspl-text control-model="vm.organisation.pincode" form="corpeditform" control-id="txtpincode" control-disabled="true" required></div><label class="col-sm-2 control-label">Country</label><div class="col-sm-3"><cspl-text control-model="vm.organisation.country.shortName" form="corpeditform" control-id="txtCorporate" control-disabled="true" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Functional CCY.</label><div class="col-sm-3"><cspl-text control-model="vm.organisation.functionalCurrency.code" form="corpeditform" control-id="txtfunctionalCCY" control-disabled="true" required></div><label class="col-sm-2 control-label" style="padding-bottom:8px">Cross CCY.</label><div class="col-sm-3"><cspl-text control-model="vm.organisation.crossCurrency.code" form="corpeditform" control-id="txtcrossCCY" control-disabled="true" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">FY start month</label><div class="col-sm-3"><select class="form-control" name="txtfyStartMonth" form="corpregform" ng-model="vm.organisation.fyStartMonth" ng-disabled="true"><option value="1">Jan</option><option value="2">Feb</option><option value="3">Mar</option><option value="4">Apr</option><option value="5">May</option><option value="6">Jun</option><option value="7">Jul</option><option value="8">Aug</option><option value="9">Sep</option><option value="10">Oct</option><option value="11">Nov</option><option value="12">Dec</option></select></div><label class="col-sm-2 control-label" style="padding-bottom:8px">FY end month</label><div class="col-sm-3"><select class="form-control" name="txtfyEndMonth" form="corpregform" ng-model="vm.organisation.fyEndMonth" ng-disabled="true"><option value="1">Jan</option><option value="2">Feb</option><option value="3">Mar</option><option value="4">Apr</option><option value="5">May</option><option value="6">Jun</option><option value="7">Jul</option><option value="8">Aug</option><option value="9">Sep</option><option value="10">Oct</option><option value="11">Nov</option><option value="12">Dec</option></select></div></div></div><div ng-hide="vm.showCorporate"><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Short Name</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.shortName" control-type="ShortName" form="corpeditform" control-id="txtCorporateShortName" control-disabled="true" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Full name</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.name" form="corpeditform" control-id="txtCorporateName" control-disabled="true" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Security code</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.aliasName" control-type="ShortName" form="corpeditform" control-disabled="true" control-id="txtCorporateAlias" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Address</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.address" form="corpeditform" control-id="txtAddress" control-disabled="true" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">City</label><div class="col-sm-8"><cspl-text control-model="vm.organisation.city" form="corpeditform" control-id="txtcity" control-disabled="true" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-sm-3 control-label">Pincode</label><div class="col-sm-3"><cspl-text control-model="vm.organisation.pincode" form="corpeditform" control-id="txtpincode" control-disabled="true" required></div><label class="col-sm-2 control-label">Country</label><div class="col-sm-3"><cspl-text control-model="vm.organisation.country.shortName" form="corpeditform" control-id="txtCorporate" control-disabled="true" required></div></div></div><br><br><a ng-show="vm.ShowRequestedByLink" ui-sref="task-user({id:vm.taskId})">Requested By</a><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>OK</span></button> <button type="button" ng-show="showDiscardButton" class="btn btn-reject" ng-click="vm.discardOrganisation()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-show="showButton" class="btn btn-reject" ng-click="vm.rejectOrganisation()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-show="showButton" class="btn btn-approve" ng-disabled="clicked" ng-click="vm.approveOrganisation();clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div></div></div></form>');
$templateCache.put('app/entities/manage-user-restrictions/manage-user-restrictions.html','<style>.tab-padding {\r\n\tpadding-right: 10px;\r\n\tpadding-left: 18px;\r\n}\r\n\r\n@media screen and (max-width: 324px) {\r\n\t#btnGroup .btn {\r\n\t\tfont-size: 10px;\r\n\t}\r\n\t.col-centered {\r\n\t\twidth: 100%;\r\n\t\tmargin: 0 auto;\r\n\t\tfloat: none;\r\n\t\tpadding: 0;\r\n\t\theight:0 auto;\r\n\t}\r\n}\r\n\r\n.tab-padding {\r\n\tpadding-right: 5px;\r\n\tpadding-left: 5px;\r\n}\r\n}</style><form name="mangeuserrestrictionsform" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="gatewayApp.userRestriction.title"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="content"><fieldset ng-disabled="vm.disableEdit"><br><div class="col-sm-9 col-xs-12 col-lg-9 col-md-9 col-centered"><div class="form-group col-sm-12" ng-show="vm.loggedinEntityOwnerType!=\'MultiUserCustomer\'"><label class="control-label" data-translate="gatewayApp.userRestriction.entity"></label><div id="btnGroup"><div class="btn-group col-sm-10 col-xs-12 col-md-9 col-lg-10 noPaddingMargin" style="width: auto;margin-bottom:8px"><label class="btn btn-primary" ng-if="vm.showCCILRadio" ng-model="vm.userRestriction.selectedEntity" ng-disabled="{{vm.disableEdit || vm.disableForResubmit}}" uib-btn-radio="\'Clearcorp\'" data-translate="gatewayApp.userRestriction.clearCorp"></label><label class="btn btn-primary" ng-if="vm.showBankRadio" ng-model="vm.userRestriction.selectedEntity" ng-disabled="{{vm.disableEdit || vm.disableForResubmit}}" uib-btn-radio="\'Bank\'" data-translate="gatewayApp.userRestriction.bank"></label><label class="btn btn-primary" ng-if="vm.showBranchRadio" ng-model="vm.userRestriction.selectedEntity" ng-disabled="{{vm.disableEdit || vm.disableForResubmit}}" uib-btn-radio="\'Branch\'" data-translate="gatewayApp.userRestriction.branch"></label><label class="btn btn-primary" ng-if="vm.showCustomerRadio" ng-model="vm.userRestriction.selectedEntity" ng-disabled="{{vm.disableEdit || vm.disableForResubmit}}" uib-btn-radio="\'MultiUserCustomer\'" data-translate="gatewayApp.userRestriction.customer"></label></div></div></div></div><div class="col-sm-9 col-xs-12 col-lg-9 col-md-9 col-centered"><div id="ccil" class=""><div class="form-group col-sm-8 col-md-9 col-lg-7 col-xs-10" ng-show="vm.showBankControl" ng-disabled="vm.disableBank || vm.disableEdit || vm.disableForResubmit"><label class="control-label" for="txtbank" cspl-mandatory><span data-translate="gatewayApp.userRestriction.bank"></span></label><cspl-ach ng-show="vm.showBankControl" control-id="txtbank" lookup-name="bank" ng-class="borderClass" display-column="shortName" form="mangeuserrestrictionsform" control-required="vm.showBankControl" control-disabled="vm.disableBank || vm.disableEdit || vm.disableForResubmit" control-model="vm.userRestriction.selectedBank"></cspl-ach></div><div class="form-group col-sm-8 col-md-9 col-lg-7 col-xs-10" ng-show="vm.showBranchControl" ng-disabled="vm.disableBranch || vm.disableEdit || vm.disableForResubmit"><label class="control-label" for="txtbranch" cspl-mandatory><span data-translate="gatewayApp.userRestriction.branch"></span></label><cspl-ach ng-show="vm.showBranchControl" control-id="txtBranch" lookup-name="activeBranchesForBank" display-column="shortName" control-required="vm.showBranchControl" filter-value="{{vm.userRestriction.selectedBank.id}}" form="mangeuserrestrictionsform" control-disabled="vm.disableBranch || vm.disableEdit || vm.disableForResubmit" control-model="vm.userRestriction.selectedBranch"></cspl-ach></div><div class="form-group col-sm-8 col-md-9 col-lg-7 col-xs-10" ng-show="vm.showCustomerControl" ng-disabled="vm.disableCustomer || vm.disableEdit || vm.disableForResubmit"><label class="control-label" for="txtCustomer" cspl-mandatory><span data-translate="gatewayApp.userRestriction.customer"></span></label><cspl-ach ng-show="vm.showCustomerControl" control-id="txtCustomer" control-place-holder="Enter Customer ID or Name" lookup-name="nonPropCustomersForBranch" control-required="vm.showCustomerControl" filter-value="{{vm.userRestriction.selectedBank.id}}~~{{vm.userRestriction.selectedBranch.id}}" display-column="customerCode,customerName" form="mangeuserrestrictionsform" control-disabled="vm.disableCustomer || vm.disableEdit || vm.disableForResubmit" control-model="vm.userRestriction.selectedCustomer"></cspl-ach><span class="cutomer-highlight" ng-if="vm.userRestriction.selectedCustomer.customerMiddleName==null">{{vm.userRestriction.selectedCustomer.customerFirstName+\' \'+vm.userRestriction.selectedCustomer.customerLastName}}</span> <span class="cutomer-highlight" ng-if="vm.userRestriction.selectedCustomer.customerMiddleName!=null">{{vm.userRestriction.selectedCustomer.customerFirstName+\' \'+ vm.userRestriction.selectedCustomer.customerMiddleName+\' \'+vm.userRestriction.selectedCustomer.customerLastName}}</span></div><div class="form-group col-sm-8 col-md-9 col-lg-7 col-xs-10"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.userRestriction.user"></span></label><div ng-show="vm.ccilUser"><cspl-ach control-id="txtCcilUser" ng-show="vm.ccilUser" lookup-name="{{vm.userLookUpNameCCIL}}" display-column="login" filter-value="{{vm.userFilterValueCCIL}}" form="mangeuserrestrictionsform" control-required="vm.ccilUser" control-disabled="vm.disableEdit || vm.disableForResubmit || !vm.ccilUser" control-model="vm.userRestriction.user"></div><div ng-show="vm.bankUser"><cspl-ach control-id="txtBankUser" lookup-name="{{vm.userLookUpNameBank}}" display-column="login" filter-value="{{vm.userFilterValueBank}}" form="mangeuserrestrictionsform" control-required="vm.bankUser" control-disabled="vm.disableEdit || vm.disableForResubmit || !vm.bankUser" control-model="vm.userRestriction.user"></div><div ng-show="vm.branchUser"><cspl-ach control-model="vm.userRestriction.user" control-id="txtBranchUser" lookup-name="{{vm.userLookUpNameBranch}}" display-column="login" filter-value="{{vm.userFilterValueBranch}}" form="mangeuserrestrictionsform" control-required="vm.branchUser" control-disabled="vm.disableEdit || vm.disableForResubmit || !vm.branchUser" control-model="vm.userRestriction.user"></div><div ng-show="vm.customerUser"><cspl-ach control-id="txtCustomerUser" lookup-name="{{vm.userLookUpNameCustomer}}" display-column="login" filter-value="{{vm.userFilterValueCustomer}}" form="mangeuserrestrictionsform" control-required="vm.customerUser" control-disabled="vm.disableEdit || vm.disableForResubmit || !vm.customerUser" control-model="vm.userRestriction.user"></div></div><div class="form-group col-sm-6 col-md-7 col-lg-8" ng-show="vm.userRestriction.user!=null"><div><label class="control-label" data-translate="gatewayApp.userRestriction.restrictionApplied"></label></div><div><label class="control-label restrictions-lbl" control-id="statuslbl"><span class="restriction-span">{{vm.userRestriction.existingRestrictionStatus.shortName}}</span></label></div><!--  --></div><div class="row form-group col-xs-10 col-md-8 col-lg-6 col-sm-10" ng-show="vm.showChangeStatus"><div><label class="control-label" for="txtbank" cspl-mandatory ng-show="vm.showChangeStatus"><span data-translate="gatewayApp.userRestriction.changeRestriction"></span></label></div><div><select class="form-control select-style" ng-disabled="vm.disableEdit" name="selRestriction" ng-model="vm.userRestriction.newRestrictionApplied" ng-options="x.restricitonName for x in vm.possibleRestricitons track by x.restricitonName" ng-change="" form="mangeuserrestrictionsform" required ng-show="vm.showChangeStatus"><option selected="selected" disabled="disabled" hidden style="display: none" value=""></option></select></div></div></div></div></fieldset></div><div class="modal-footer"><button type="button" ng-show="showDiscardButton || showApproveRejectButton || showOkButton " class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button> <button type="button" ng-show="showSaveButton || showResubmitButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="mangeuserrestrictionsform.$invalid || clicked" ng-click="vm.resubmitUserRestriction();clicked = true;"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showSaveButton" ng-disabled="(mangeuserrestrictionsform.$invalid || mangeuserrestrictionsform.$pristine || clicked)" class="btn btn-info active" ng-click="vm.saveUserRestriction();clicked = true;"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardUserRestriction()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectUserRestriction()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-approve" ng-disabled="" ng-click="vm.approveUserRestriction()" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/manage-users/manage-users-clearance.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="branchForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title">Set Clearance</h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><fieldset ng-disabled="vm.ViewDisable"><div class="row"><label class="col-md-5 control-label">User ID</label><div class="col-md-4"><cspl-text control-model="vm.getUserClearanceDTO.userShortName" control-id="txtBranch" control-disabled="true"></div></div><br><div class="table-responsive col-md-8 col-md-offset-2" ng-if="vm.getUserClearanceDTO.organisationShortName != null"><table class="datatables-nosort table table-striped table-hover"><thead><tr><th>{{vm.getUserClearanceDTO.organisationShortName}}</th><th><input type="checkbox" checklist-model="vm.select.organisation" checklist-value="vm.getUserClearanceDTO.organisationID" ng-model="justAnotherCheckedVar"></th></tr></thead><tbody><tr ng-repeat="branch in vm.getUserClearanceDTO.buList"><td>&emsp;{{branch.shortName}}</td><td><input type="checkbox" checklist-model="vm.selected.branch" checklist-value="branch.id" ng-model="justAnotherCheckedVar"></td></tr></tbody></table></div><div class="table-responsive col-md-8 col-md-offset-2" ng-if="vm.getUserClearanceDTO.consultantShortName != null"><table class="datatables-nosort table table-striped table-hover"><thead><tr><th>{{vm.getUserClearanceDTO.consultantShortName}}</th><th><input type="checkbox" checklist-model="vm.select.organisation" checklist-value="vm.getUserClearanceDTO.consultantID" ng-model="justAnotherCheckedVar"></th></tr></thead><tbody ng-repeat="(key, value) in vm.getUserClearanceDTO.buList | groupBy: \'corporate.shortName\'"><tr><td>{{key}}</td><td><input type="checkbox" checklist-model="vm.select.organisation" checklist-value="value[0].corporate.id" ng-model="justAnotherCheckedVar"></td></tr><tr ng-repeat="branch in value"><td>&emsp;{{branch.shortName}}</td><td><input type="checkbox" checklist-model="vm.selected.branch" checklist-value="branch.id" ng-model="justAnotherCheckedVar"></td></tr></tbody></table></div><br><br></fieldset><div class="modal-footer"><button type="button" ng-hide="showButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmit" class="btn btn-info active" ng-disabled="clicked" ng-click="vm.resubmit();clicked=true;"><span>Resubmit</span></button> <button type="submit" ng-if="showSave" class="btn btn-info active" ng-disabled="clicked" ng-click="vm.save();clicked=true;"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-show="showButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>Close</span></button> <button type="button" ng-show="showDiscardButton" class="btn btn-reject" ng-click="vm.discardUserClearance()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-show="showButton" class="btn btn-reject" ng-click="vm.rejectUserClearance()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-show="showButton" class="btn btn-approve" ng-disabled="clicked" ng-click="vm.approveUserClearance();clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div></div></div></form>');
$templateCache.put('app/entities/manage-users/manage-users-role.html','<div class="container-fluid" ng-cloak><div ncy-breadcrumb></div><h2 class="view-title">Manage Users</h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="pull-right"><button type="button" class="btn btn-info active" ng-click="vm.screenLog.screenLog(vm.entityConstants.ENTITY_SHORT_NAME.USER_MANAGEMENT,0,vm.entityConstants.ENTITY_ACTION_TYPE.ADD); vm.launch()"><img ng-src="assets/images/Add.png"> <span data-translate="userManagement.detail.title"></span></button><div class="col-md-6 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="tblusermanagement" total-record-count="vm.users.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="User_Management"></cspl-table-export></div></div><div class="table-responsive" style="overflow:auto"><table id="tblusermanagement" class="dataTable table table-striped table-hover"><thead><tr><th>Personal ID</th><th style="min-width:95px" data-translate="userManagement.firstName">First Name</th><th style="min-width:55px" data-translate="userManagement.middleName">Middle Name</th><th style="min-width:95px" data-translate="userManagement.lastName">Last Name</th><!-- <th style="max-width:50px" data-translate="userManagement.gender">Gender</th> --><th style="min-width:85px" data-translate="userManagement.dob">DOB</th><th style="min-width:85px" data-translate="userManagement.login">Login Name</th><th style="min-width:85px" data-translate="userManagement.branch" ng-show="vm.userEntityOwnerType==\'Bank\'">Branch</th><th style="min-width:85px" data-translate="userManagement.email">Email</th><th style="min-width:75px" data-translate="userManagement.mobile">Mobile</th><th style="min-width:50px" data-translate="userManagement.userStatus">Status</th><th style="min-width:130px" data-translate="userManagement.lastSuccessFulLogin"></th><th style="min-width:130px" data-translate="userManagement.lastUnSuccessFulLogin"></th><th style="min-width:130px" data-translate="userManagement.createdDateTime">Created Date Time</th><th style="min-width:45px;word-wrap: break-word" data-translate="userManagement.authorizedperson" ng-show=" vm.userEntityOwnerType ==\'MultiUserCustomer\'">Authorized Person</th><th style="min-width:60px;text-align:left"></th></tr></thead><tbody><tr ng-repeat="user in filterData = (vm.users | filter : filterText | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{user.personId}}</td><td style="word-break:break-word">{{user.firstName}}</td><td style="word-break:break-word">{{user.middleName||\'-\'}}</td><td style="word-break:break-word">{{user.lastName}}</td><!-- <td>{{user.gender}}</td> --><td>{{user.dob|date:\'dd-MMM-yyyy\'}}</td><td style="word-break:break-word">{{user.login}}</td><td style="word-break:break-word" ng-show="vm.userEntityOwnerType==\'Bank\'">{{user.branch.branchName||\'-\'}}</td><td style="word-break:break-word">{{user.email}}</td><td>{{user.mobile}}</td><td>{{user.userStatus}}</td><td><span ng-show="user.lastSuccessfulLogin != null">{{user.lastSuccessfulLogin | date:\'dd-MMM-yyyy HH:mm:ss\'}}</span><span ng-show="user.lastSuccessfulLogin == null">-</span></td><td><span ng-show="user.lastUnsuccessfulLogin != null">{{user.lastUnsuccessfulLogin | date:\'dd-MMM-yyyy HH:mm:ss\'}}</span><span ng-show="user.lastUnsuccessfulLogin == null">-</span></td><td><span ng-show="user.createdDate != null">{{user.createdDate | date:\'dd-MMM-yyyy HH:mm:ss\'}}</span><span ng-show="user.createdDate == null">-</span></td><td style="word-break:break-word" ng-show=" vm.userEntityOwnerType ==\'MultiUserCustomer\'">{{user.isAuthorisedPerson ? "Yes":"No"}}</td><td style="text-align:center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu menualign" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ui-sref="manage-users.view({id: user.id})" ng-click="vm.screenLog.screenLog(vm.entityConstants.ENTITY_SHORT_NAME.USER_MANAGEMENT,user.id,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li><a ui-sref="manage-users.edit({id: user.id})" ng-click="vm.screenLog.screenLog(vm.entityConstants.ENTITY_SHORT_NAME.USER_MANAGEMENT,user.id,vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></a></li><li ng-show="vm.permitAssignRole"><a ui-sref="manage-users.assignrole({id:user.id})" ng-click="vm.screenLog.screenLog(vm.entityConstants.ENTITY_SHORT_NAME.USER_ROLE,user.id,vm.entityConstants.ENTITY_ACTION_TYPE.MAP)"><span class="hidden-xs hidden-sm">Assign roles</span></a></li><li><a ui-sref="manage-users.delink({id: user.id})" ng-click="vm.screenLog.screenLog(vm.entityConstants.ENTITY_SHORT_NAME.USER_MANAGEMENT,user.id,vm.entityConstants.ENTITY_ACTION_TYPE.DELINK)"><span class="hidden-xs hidden-sm" data-translate="entity.action.delink"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="vm.users.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/manage-users/users-delink-dialog.html','<form name="delinkForm" ng-submit="clicked=true;vm.confirmDelink(vm.users.id)"><div class="modal-header-red"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" style="text-align:left;padding-left:3%">Are you sure want to de-link?</h4></div><div class="modal-body"><nmb-alert-error></nmb-alert-error><p><textarea class="form-control modal-header-red" ng-model="vm.reason" rows="6" placeholder="Please provide a reason" required></textarea></p><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="delinkForm.$invalid||clicked" class="btn btn-danger"><span data-translate="entity.action.delink"></span></button></div></div></div></form>');
$templateCache.put('app/entities/manage-users/users-detail.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="usersViewForm" role="form" novalidate><div class="{{vm.theme}}"><div class="modal-header"><h4 class="modal-title"><span data-translate="global.menu.admin.userManagement"></span></h4></div><div class="modal-body"><div class="content"><fieldset><div class="row" ng-show="vm.users.id!=null"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.personalId"></span></label></div><div class="row" ng-show="vm.users.id!=null"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.users.personId" control-disabled="true" control-id="txtpersonalId" control-type="Alphanumeric" form="usersForm"></div><div class="col-md-2" style="margin-top:2px"><button type="button" class="btn btn-info" data-dismiss="modal" ng-disabled="vm.personalId==null || vm.personalId==\'\' || vm.disablePID" ng-click="vm.fetchUserByPersonalId()"><span data-translate="entity.action.fetch"></span></button></div></div><div class="row" ng-show="vm.userType==\'BANK\' && vm.userEntityOwnerType!=\'Branch\'"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.userBelongsTo"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3" ng-show="vm.userType==\'BANK\' && vm.userEntityOwnerType!=\'Branch\'"><!-- <select class="form-control" ng-model="vm.corporate" ng-options="corporate as corporate.shortName for corporate in  vm.corporates track by corporate.id" \r\n\t\t\t\t\t\t\t\t\tng-disabled="vm.users.id!=null"  ng-required="vm.userType==\'BANK\'"></select> --><cspl-ach theme-type="{{vm.theme}}" control-model="vm.users.entityOwnerType" control-id="txtEntityOwnerType" lookup-name="entityOwnerTypeByOrganisationType" control-disabled="true" display-column="shortName" form="usersForm"></cspl-ach></div></div><div class="row" style="margin-top:8px" ng-show="(vm.userType==\'BANK\' && vm.users.entityOwnerTypeShortName==\'Branch\' && vm.userEntityOwnerType!=\'Branch\') "><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.branch"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3" ng-show="(vm.userType==\'BANK\' && vm.users.entityOwnerTypeShortName==\'Branch\' && vm.userEntityOwnerType!=\'Branch\')"><cspl-ach theme-type="{{vm.theme}}" control-model="vm.branch" control-id="txtBranch" lookup-name="branchesForBank" display-column="shortName" control-disabled="true" form="usersForm"></cspl-ach></div></div><div class="row" style="margin-top: 8px" ng-show="vm.userType==\'BANK\' && vm.users.entityOwnerType.shortName==\'Bank\'"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.bank"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3" ng-show="vm.userType==\'BANK\' && vm.users.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.bank" control-id="txtbank" control-disabled="true" lookup-name="bank" display-column="bankName" placeholder="" form="usersForm"></div></div><div class="row" style="margin-top:8px"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.firstName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.users.firstName" control-id="txtfirstName" form="usersForm" control-disabled="true"></div><div class="col-sm-3" ng-show=" vm.userEntityOwnerType ==\'MultiUserCustomer\'"><input type="checkbox" style="margin-top:5px" ng-model="vm.users.isAuthorisedPerson" form="usersForm" ng-disabled="true"><label class="control-label" data-translate="userManagement.authorizedperson"></label></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="userManagement.middleName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.users.middleName" control-id="txtmiddleName" control-disabled="true" form="usersForm"></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.lastName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.users.lastName" control-id="txtlastName" control-disabled="true" form="usersForm"></div></div><!-- <div class="row"> \r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"  ><span data-translate="userManagement.aadharNumber" ></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3">\r\n\t\t\t\t\t<cspl-text theme-type="{{vm.theme}}" control-model = "vm.users.aadharNumber" control-id="txtaadharNumber" help-text="{{\'userManagement.helpText.aadharNumber\' | translate}}"  \r\n\t\t\t\t\t\t control-disabled="true" form="usersForm" /> \r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div> --><!-- <div class="row"> \r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"  cspl-mandatory><span data-translate="userManagement.gender" ></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div id="btnGroup" class="col-md-6 col-md-offset-3">\r\n\t                    <div class="btn-group">\r\n\t                        <label class="btn btn-primary" ng-model="vm.gender" ng-disabled="true" uib-btn-radio="\'M\'">M</label>\r\n\t                        <label class="btn btn-primary" ng-model="vm.gender" ng-disabled="true" uib-btn-radio="\'F\'">F&nbsp;</label>\r\n\t                        <label class="btn btn-primary" ng-model="vm.gender" ng-disabled="true" uib-btn-radio="\'O\'">O&nbsp;</label>\r\n\t                    </div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div> --><div class="row" style="margin-top:8px"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.dob"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-3"><cspl-dtp theme-type="{{vm.theme}}" control-model="vm.dob" control-id="dtpDOB" control-disabled="true" form="usersForm"></cspl-dtp></div></div><div class="row" style="margin-top:8px"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.login"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.users.login" control-id="txtLogin" form="usersForm" control-disabled="true"></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.email"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.users.email" control-id="txtemail" form="usersForm" control-disabled="true"></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.mobile"></span></label></div><div class="row"><div class="col-lg-1 col-md-offset-3"><cspl-numeric theme-type="{{vm.theme}}" control-model="vm.mobileCountryCode" control-id="txtMobileCountryCode" no-of-decimals="0" form="usersForm" control-disabled="true"></div><div class="col-md-3"><cspl-text theme-type="{{vm.theme}}" control-model="vm.users.mobile" control-type="Number" control-id="txtMobile" form="usersForm" control-disabled="true"></div></div><!-- <div class="row"> \r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"  cspl-mandatory><span data-translate="userManagement.address1" ></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3">\r\n\t\t\t\t\t<cspl-text theme-type="{{vm.theme}}" control-model = "vm.users.address1" control-id="txtaddress1" control-disabled="true" form="usersForm"/> \r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row"> \r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label" ><span data-translate="userManagement.address2" ></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3">\r\n\t\t\t\t\t<cspl-text theme-type="{{vm.theme}}" control-model = "vm.users.address2" control-id="txtaddress2"  control-disabled="true" form="usersForm"/> \r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row"> \r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"  cspl-mandatory><span data-translate="userManagement.city" ></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3 ">\r\n\t\t\t\t\t<cspl-text theme-type="{{vm.theme}}" control-model = "vm.users.city" control-id="txtcity"  control-disabled="true" form="usersForm" /> \r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row"> \r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"  cspl-mandatory><span data-translate="userManagement.country" ></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-4 col-md-offset-3 ">\r\n\t\t\t\t\t\t<cspl-ach theme-type="{{vm.theme}}" control-model="vm.country"  control-id="txtCountry" lookup-name="country" display-column="shortName" control-disabled="true" form="usersForm" ></cspl-ach>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row"> \r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"  cspl-mandatory><span data-translate="userManagement.state" ></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3 ">\r\n\t\t\t\t\t<cspl-ach theme-type="{{vm.theme}}" control-model="vm.users.state"  control-id="txtstate" lookup-name="state" display-column="shortName" filter-value="{{vm.users.country.id}}~~" control-disabled="true" form="usersForm"></cspl-ach> \r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row" style="margin-top:8px"> \r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"  cspl-mandatory><span data-translate="userManagement.pincode" ></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3 ">\r\n\t\t\t\t\t<cspl-text theme-type="{{vm.theme}}" control-model = "vm.users.pincode" control-id="txtpincode"  form="usersForm" control-disabled="true"/> \r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div> --></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>OK</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardUsers()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showButton" class="btn btn-reject" ng-click="vm.rejectUsers()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" class="btn btn-approve" autofocus ng-disabled="clicked" ng-click="clicked=true;vm.approveUsers();"><span data-translate="entity.action.approve">Approve</span></button></div></div></div></form>');
$templateCache.put('app/entities/manage-users/users-dialog.html','<form name="usersForm" role="form" autocomplete="off" novalidate><div class="modal-header"><div class="modal-title"><span data-translate="userManagement.home.createLabel" ng-show="vm.users.id==null"></span><span data-translate="userManagement.home.editLabel" ng-show="vm.users.id!=null"></span></div></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset ng-disabled="vm.disableForm"><div class="row" ng-hide="vm.users.id!=null"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="userManagement.personalId"></span></label></div><div class="row" ng-hide="vm.users.id!=null"><div class="col-md-5 col-md-offset-3"><cspl-text control-model="vm.personalId" control-type="Alphanumeric" control-disabled="vm.disablePID" control-id="txtpersonalId" help-text="{{\'userManagement.helpText.pid\' | translate}}" control-maxlength="7" form="usersForm"></div><div class="col-md-1" style="margin-top:5px"><span><img class="icon" ng-src="assets/images/Forgot_PID.png" ng-click="vm.openForgotPID()" title="Forgot PID"></span></div><div class="col-md-2" style="margin-top: 2px"><button type="button" class="btn btn-info" data-dismiss="modal" ng-disabled="vm.personalId==null || vm.personalId==\'\' || vm.disablePID" ng-click="vm.fetchUserByPersonalId()"><span data-translate="entity.action.fetch"></span></button></div></div><div class="row" ng-show="vm.userType==\'BANK\' && vm.userEntityOwnerType!=\'Branch\'"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.userBelongsTo"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3" ng-show="vm.userType==\'BANK\' && vm.userEntityOwnerType!=\'Branch\'"><!-- <select class="form-control" ng-model="vm.corporate" ng-options="corporate as corporate.shortName for corporate in  vm.corporates track by corporate.id" \r\n\t\t\t\t\t\t\t\t\tng-disabled="vm.users.id!=null"  ng-required="vm.userType==\'BANK\'"></select> --><cspl-ach control-model="vm.users.entityOwnerType" control-id="txtEntityOwnerType" lookup-name="entityOwnerTypeByOrganisationType" control-disabled="vm.users.id!=null" display-column="shortName" form="usersForm" control-required="vm.userType==\'BANK\' && vm.userEntityOwnerType!=\'Branch\'"></cspl-ach></div></div><div class="row" style="margin-top: 8px" ng-show="vm.userType==\'BANK\' && vm.users.entityOwnerType.shortName==\'Branch\'"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.branch"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3" ng-show="vm.userType==\'BANK\' && vm.users.entityOwnerType.shortName==\'Branch\'"><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="validStatusBranchesForBank" display-column="shortName" control-disabled="vm.users.id!=null" form="usersForm" control-required="vm.userType==\'BANK\' && vm.users.entityOwnerType.shortName==\'Branch\'"></cspl-ach></div></div><div class="row" style="margin-top: 8px" ng-show="vm.userType==\'BANK\' && vm.users.entityOwnerType.shortName==\'Bank\'"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.bank"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3" ng-show="vm.userType==\'BANK\' && vm.users.entityOwnerType.shortName==\'Bank\'"><cspl-ach control-model="vm.bank" control-id="txtbank" control-disabled="true" lookup-name="validStatusBank" display-column="bankName" placeholder="" form="usersForm" control-required="vm.userType==\'BANK\' && vm.users.entityOwnerType.shortName==\'Bank\'"></div></div><div class="row" style="margin-top: 8px"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.firstName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.users.firstName" control-type="AlphaWithSpace" control-id="txtfirstName" control-maxlength="100" form="usersForm" control-disabled="vm.users.id!=null||vm.disablePID" required></div><div control-disabled="vm.disablePID"><div class="col-sm-3" ng-show=" vm.userEntityOwnerType ==\'MultiUserCustomer\'"><input type="checkbox" style="margin-top:5px" ng-model="vm.users.isAuthorisedPerson" control-disabled="vm.disablePID"><label class="control-label" data-translate="userManagement.authorizedperson"></label></div></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="userManagement.middleName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.users.middleName" control-id="txtmiddleName" control-maxlength="100" control-type="AlphaWithSpace" control-disabled="vm.disablePID" form="usersForm"></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.lastName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.users.lastName" control-id="txtlastName" control-maxlength="100" control-type="AlphaWithSpace" control-disabled="vm.disablePID" form="usersForm" required></div></div><!-- <div class="row">\r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"><span\r\n\t\t\t\t\t\tdata-translate="userManagement.aadharNumber"></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3">\r\n\t\t\t\t\t\t<cspl-text control-model="vm.users.aadharNumber"\r\n\t\t\t\t\t\t\tcontrol-type="Number" control-id="txtaadharNumber"\r\n\t\t\t\t\t\t\tcontrol-minlength="12" control-maxlength="12"\r\n\t\t\t\t\t\t\thelp-text="{{\'userManagement.helpText.aadharNumber\' | translate}}"\r\n\t\t\t\t\t\t\tcontrol-disabled="vm.disablePID" form="usersForm" />\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div> --><!-- <div class="row">\r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"\r\n\t\t\t\t\t\tcspl-mandatory><span\r\n\t\t\t\t\t\tdata-translate="userManagement.gender"></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div id="btnGroup" class="col-md-6 col-md-offset-3">\r\n\t\t\t\t\t\t<div class="btn-group">\r\n\t\t\t\t\t\t\t<label class="btn btn-primary" ng-model="vm.gender"\r\n\t\t\t\t\t\t\t\tng-disabled="vm.disablePID" uib-btn-radio="\'M\'">M</label> <label\r\n\t\t\t\t\t\t\t\tclass="btn btn-primary" ng-model="vm.gender"\r\n\t\t\t\t\t\t\t\tng-disabled="vm.disablePID" uib-btn-radio="\'F\'">F&nbsp;</label>\r\n\t\t\t\t\t\t\t\t<label\r\n\t\t\t\t\t\t\t\tclass="btn btn-primary" ng-model="vm.gender"\r\n\t\t\t\t\t\t\t\tng-disabled="vm.disablePID" uib-btn-radio="\'O\'">O&nbsp;</label>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div> --><div class="row" style="margin-top: 8px"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.dob"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-3"><cspl-dtp control-model="vm.dob" control-id="dtpDOB" control-disabled="vm.disablePID" form="usersForm" required></cspl-dtp></div></div><div class="row" style="margin-top: 8px"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.login"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.users.login" control-id="txtLogin" control-type="Small" control-maxlength="100" form="usersForm" control-disabled="vm.users.id!=null" required></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.email"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.users.email" control-type="Email" control-disabled="vm.users.id != null" control-id="txtemail" control-maxlength=" 100" form="usersForm" required></div><a ng-show="vm.users.id != null" style="text-decoration: none" title="Change Email" ui-sref="change-email-user({userId: vm.users.id,email: vm.email,mode: \'user\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="userManagement.mobile"></span></label></div><div class="row"><div class="col-lg-1 col-md-offset-3"><cspl-numeric control-model="vm.mobileCountryCode" control-disabled="vm.users.id != null" control-id="txtMobileCountryCode" no-of-decimals="0" control-tab-index="-1" control-max="999" control-min="1" form="usersForm" required></div><div class="col-md-3"><cspl-text control-model="vm.users.mobile" control-type="Number" control-id="txtMobile" control-maxlength="15" control-disabled="vm.users.id != null" form="usersForm" required></div><a ng-show="vm.users.id != null" style="text-decoration: none" title="Change Mobile" ui-sref="change-mobile-user({userId: vm.globalValues.getUserId(),mobile: vm.mobile,mode: \'user\',countryCode: vm.mobileCountryCode})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div><!-- <div class="row">\r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"\r\n\t\t\t\t\t\tcspl-mandatory><span\r\n\t\t\t\t\t\tdata-translate="userManagement.address1"></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3">\r\n\t\t\t\t\t\t<cspl-text control-model="vm.users.address1"\r\n\t\t\t\t\t\t\tcontrol-id="txtaddress1" control-maxlength="255"\r\n\t\t\t\t\t\t\tcontrol-disabled="vm.disablePID" form="usersForm" required />\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"><span\r\n\t\t\t\t\t\tdata-translate="userManagement.address2"></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3">\r\n\t\t\t\t\t\t<cspl-text control-model="vm.users.address2"\r\n\t\t\t\t\t\t\tcontrol-id="txtaddress2" control-maxlength="255"\r\n\t\t\t\t\t\t\tcontrol-disabled="vm.disablePID" form="usersForm" />\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"\r\n\t\t\t\t\t\tcspl-mandatory><span data-translate="userManagement.city"></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3 ">\r\n\t\t\t\t\t\t<cspl-text control-model="vm.users.city" control-id="txtcity"\r\n\t\t\t\t\t\t\tcontrol-maxlength="255" control-disabled="vm.disablePID"\r\n\t\t\t\t\t\t\tform="usersForm" required />\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"\r\n\t\t\t\t\t\tcspl-mandatory><span\r\n\t\t\t\t\t\tdata-translate="userManagement.country"></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-4 col-md-offset-3 ">\r\n\t\t\t\t\t\t<cspl-ach control-model="vm.country" control-id="txtCountry"\r\n\t\t\t\t\t\t\tlookup-name="country" display-column="shortName"\r\n\t\t\t\t\t\t\tcontrol-disabled="vm.disablePID" form="usersForm" required></cspl-ach>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"\r\n\t\t\t\t\t\tcspl-mandatory><span data-translate="userManagement.state"></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3 ">\r\n\t\t\t\t\t\t<cspl-ach control-model="vm.users.state" control-id="txtstate"\r\n\t\t\t\t\t\t\tlookup-name="state" display-column="shortName"\r\n\t\t\t\t\t\t\tfilter-value="{{vm.country.id}}"\r\n\t\t\t\t\t\t\tcontrol-disabled="vm.disablePID" form="usersForm" required></cspl-ach>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row" style="margin-top: 8px">\r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"\r\n\t\t\t\t\t\tcspl-mandatory><span\r\n\t\t\t\t\t\tdata-translate="userManagement.pincode"></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-6 col-md-offset-3 ">\r\n\t\t\t\t\t\t<cspl-text control-model="vm.users.pincode"\r\n\t\t\t\t\t\t\tcontrol-id="txtpincode" control-type="Alphanumeric"\r\n\t\t\t\t\t\t\t control-maxlength="7" form="usersForm"\r\n\t\t\t\t\t\t\tcontrol-disabled="vm.disablePID" required />\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div> --></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showButton" class="btn btn-primary" ng-disabled="usersForm.$invalid || vm.clicked" ng-click="vm.clicked = true;vm.resubmitUsers();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="!showButton" ng-disabled=" usersForm.$invalid || (vm.users.entityOwnerType.shortName==\'Branch\' && vm.branch==null) || (vm.users.id == null && usersForm.$invalid) || (vm.users.id != null &&  (usersForm.$pristine && !formChangedForEmailOrMobile)  ) || vm.clicked" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/manage-users/users-role-assign-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n .btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="UserRoleform" role="form" novalidate><div class="modal-header"><h4 class="modal-title">Assign User Roles</h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><fieldset ng-disabled="disableElements"><div class="row"><label class="col-md-6 col-md-offset-2 control-label">{{vm.shortName}}</label></div><!-- <div class="row">\r\n\t\t\t \t\t<label class="col-md-offset-3 col-md-1-5 control-label" >Username</label>\r\n\t\t\t\t\t<div class="col-md-4 ">\r\n\t\t\t\t\t\t<cspl-text control-model = "vm.shortName" control-id="txtFirstName"  control-disabled = "true"/>\r\n\t\t\t\t\t</div>\r\n\t\t\t \t</div> \r\n\t\t\t \t<br/> --><div class="col-md-8 col-md-offset-2"><table class="datatables-nosort table table-striped table-hover"><thead><tr><th>Roles</th><th></th></tr></thead><tbody><tr ng-repeat="role in vm.roles"><td>{{role.name}}</td><td><input type="checkbox" checklist-model="vm.selected.roles" checklist-value="role.id" ng-change="vm.setDisabledValue()" ng-model="justAnotherCheckedVar"></td></tr></tbody></table></div><br><br></fieldset><div class="modal-footer"><button type="button" ng-hide="showButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmit" class="btn btn-info active" ng-disabled="vm.clicked" ng-click="vm.clicked = true;vm.resubmit();"><span>Resubmit</span></button> <button type="submit" ng-if="showSave" class="btn btn-info active" ng-disabled="vm.clicked || UserRoleform.$pristine" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-show="showButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>Close</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardUserRole()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showButton" class="btn btn-reject" ng-click="vm.rejectUserRole()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" autofocus class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.clicked=true;vm.approveUserRole();"><span data-translate="entity.action.approve">Approve</span></button></div></div></div></form>');
$templateCache.put('app/entities/market-depth/market-depth-expand.html','<form name="marketDepthExpandForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span ng-if="vm.instrument!=\'BOTH\'">{{vm.instrument}} - Market Depth</span><span ng-if="vm.instrument==\'BOTH\'">Market Depth</span></h4></div><div class="modal-body"><div class="content"><div class="table-responsive market-depth-expand"><table class="table table-striped" ng-if="vm.instrument == \'Retail Spot\'"><thead><tr><th class="text-right width-25">Bid Quantity</th><th class="text-left width-25" style="padding-left: 16px !important">Bid Price</th><th class="text-right width-25" style="padding-right: 16px !important">Offer Price</th><th class="text-left width-25">Offer Quantity</th></tr></thead><tbody><tr ng-repeat="marketDepth in vm.marketDepth.marketDepthDetails"><td class="text-right width-25"><span ng-hide="marketDepth.bidPrice==0">{{marketDepth.bidVolume | number:vm.noOfDecimalsForAmount:vm.noOfDecimalsForAmount}}</span></td><td class="text-left width-25" style="padding-left: 16px !important"><span ng-hide="marketDepth.bidPrice==0" class="mdc-highlighted-txt">{{marketDepth.bidPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.bidPrice | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right width-25" style="padding-right: 16px !important"><span ng-hide="marketDepth.offerPrice==0" class="mdc-highlighted-txt">{{marketDepth.offerPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.offerPrice | number:4 | split:\'.\':\'1\'}}</span></span> <span ng-show="marketDepth.offerPrice==0"></span></td><td class="text-left width-25"><span ng-hide="marketDepth.offerPrice==0">{{marketDepth.offerVolume | number:vm.noOfDecimalsForAmount:vm.noOfDecimalsForAmount}}</span> <span ng-show="marketDepth.offerPrice==0"></span></td></tr></tbody></table><table class="table table-striped" ng-if="vm.instrument == \'Interbank Spot\'"><thead><tr><th class="text-right width-25">Bid Quantity</th><th class="text-left width-25" style="padding-left: 16px !important">Bid Price</th><th class="text-right width-25" style="padding-right: 16px !important">Offer Price</th><th class="text-left width-25">Offer Quantity</th></tr></thead><tbody><tr ng-repeat="marketDepth in vm.marketDepth.marketDepthDetails"><td class="text-right width-25"><span ng-hide="marketDepth.bidPrice==0">{{marketDepth.bidVolume | number:0}}</span></td><td class="text-left width-25" style="padding-left: 16px !important"><span ng-hide="marketDepth.bidPrice==0" class="mdc-highlighted-txt">{{marketDepth.bidPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.bidPrice | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right width-25" style="padding-right: 16px !important"><span ng-hide="marketDepth.offerPrice==0" class="mdc-highlighted-txt">{{marketDepth.offerPrice | split:\'.\':\'0\'}}.<span>{{marketDepth.offerPrice | number:4 | split:\'.\':\'1\'}}</span></span> <span ng-show="marketDepth.offerPrice==0"></span></td><td class="text-left width-25"><span ng-hide="marketDepth.offerPrice==0">{{marketDepth.offerVolume | number:0}}</span> <span ng-show="marketDepth.offerPrice==0"></span></td></tr></tbody></table><table class="table table-striped bothStats" ng-if="vm.instrument==\'BOTH\'"><thead><tr><td align="center" colspan="4" class="right-border">Retail Spot</td><td align="center" colspan="4">Interbank Spot</td></tr><tr><th class="text-right">Bid Qty</th><th class="text-right">Bid Price</th><th class="text-right">Offer Price</th><th class="text-right right-border">Offer Qty</th><th class="text-right">Bid Qty</th><th class="text-right">Bid Price</th><th class="text-right">Offer Price</th><th class="text-right">Offer Qty</th></tr></thead><tbody><tr><td class="text-right"><span ng-hide="vm.marketDepth.marketDepthDetails[0].bidPrice==0">{{vm.marketDepth.marketDepthDetails[0].bidVolume | number:vm.noOfDecimalsForAmount:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="vm.marketDepth.marketDepthDetails[0].bidPrice==0" class="mdc-highlighted-txt">{{vm.marketDepth.marketDepthDetails[0].bidPrice | split:\'.\':\'0\'}}.<span>{{vm.marketDepth.marketDepthDetails[0].bidPrice | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="vm.marketDepth.marketDepthDetails[0].offerPrice==0" class="mdc-highlighted-txt">{{vm.marketDepth.marketDepthDetails[0].offerPrice | split:\'.\':\'0\'}}.<span>{{vm.marketDepth.marketDepthDetails[0].offerPrice | number:4 | split:\'.\':\'1\'}}</span></span> <span ng-show="vm.marketDepth.marketDepthDetails[0].offerPrice==0"></span></td><td class="text-right right-border"><span ng-hide="vm.marketDepth.marketDepthDetails[0].offerPrice==0">{{vm.marketDepth.marketDepthDetails[0].offerVolume | number:vm.noOfDecimalsForAmount:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[0].bidPrice==0">{{vm.ibMarketDepth.marketDepthDetails[0].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[0].bidPrice==0" class="mdc-highlighted-txt">{{vm.ibMarketDepth.marketDepthDetails[0].bidPrice | split:\'.\':\'0\'}}.<span>{{vm.ibMarketDepth.marketDepthDetails[0].bidPrice | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[0].offerPrice==0" class="mdc-highlighted-txt">{{vm.ibMarketDepth.marketDepthDetails[0].offerPrice | split:\'.\':\'0\'}}.<span>{{vm.ibMarketDepth.marketDepthDetails[0].offerPrice | number:4 | split:\'.\':\'1\'}}</span></span> <span ng-show="vm.ibMarketDepth.marketDepthDetails[0].offerPrice==0"></span></td><td class="text-right"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[0].offerPrice==0">{{vm.ibMarketDepth.marketDepthDetails[0].offerVolume | number:0}}</span></td></tr><tr><td class="text-right"><span ng-hide="vm.marketDepth.marketDepthDetails[1].bidPrice==0">{{vm.marketDepth.marketDepthDetails[1].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="vm.marketDepth.marketDepthDetails[1].bidPrice==0" class="mdc-highlighted-txt">{{vm.marketDepth.marketDepthDetails[1].bidPrice | split:\'.\':\'0\'}}.<span>{{vm.marketDepth.marketDepthDetails[1].bidPrice | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="vm.marketDepth.marketDepthDetails[1].offerPrice==0" class="mdc-highlighted-txt">{{vm.marketDepth.marketDepthDetails[1].offerPrice | split:\'.\':\'0\'}}.<span>{{vm.marketDepth.marketDepthDetails[1].offerPrice | number:4 | split:\'.\':\'1\'}}</span></span> <span ng-show="vm.marketDepth.marketDepthDetails[1].offerPrice==0"></span></td><td class="text-right right-border"><span ng-hide="vm.marketDepth.marketDepthDetails[1].offerPrice==0">{{vm.marketDepth.marketDepthDetails[1].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[1].bidPrice==0">{{vm.ibMarketDepth.marketDepthDetails[1].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[1].bidPrice==0" class="mdc-highlighted-txt">{{vm.ibMarketDepth.marketDepthDetails[1].bidPrice | split:\'.\':\'0\'}}.<span>{{vm.ibMarketDepth.marketDepthDetails[1].bidPrice | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[1].offerPrice==0" class="mdc-highlighted-txt">{{vm.ibMarketDepth.marketDepthDetails[1].offerPrice | split:\'.\':\'0\'}}.<span>{{vm.ibMarketDepth.marketDepthDetails[1].offerPrice | number:4 | split:\'.\':\'1\'}}</span></span> <span ng-show="vm.ibMarketDepth.marketDepthDetails[1].offerPrice==0"></span></td><td class="text-right"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[1].offerPrice==0">{{vm.ibMarketDepth.marketDepthDetails[1].offerVolume | number:0}}</span></td></tr><tr><td class="text-right"><span ng-hide="vm.marketDepth.marketDepthDetails[2].bidPrice==0">{{vm.marketDepth.marketDepthDetails[2].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="vm.marketDepth.marketDepthDetails[2].bidPrice==0" class="mdc-highlighted-txt">{{vm.marketDepth.marketDepthDetails[2].bidPrice | split:\'.\':\'0\'}}.<span>{{vm.marketDepth.marketDepthDetails[2].bidPrice | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="vm.marketDepth.marketDepthDetails[2].offerPrice==0" class="mdc-highlighted-txt">{{vm.marketDepth.marketDepthDetails[2].offerPrice | split:\'.\':\'0\'}}.<span>{{vm.marketDepth.marketDepthDetails[2].offerPrice | number:4 | split:\'.\':\'1\'}}</span></span> <span ng-show="vm.marketDepth.marketDepthDetails[2].offerPrice==0"></span></td><td class="text-right right-border"><span ng-hide="vm.marketDepth.marketDepthDetails[2].offerPrice==0">{{vm.marketDepth.marketDepthDetails[2].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[2].bidPrice==0">{{vm.ibMarketDepth.marketDepthDetails[2].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[2].bidPrice==0" class="mdc-highlighted-txt">{{vm.ibMarketDepth.marketDepthDetails[2].bidPrice | split:\'.\':\'0\'}}.<span>{{vm.ibMarketDepth.marketDepthDetails[2].bidPrice | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[2].offerPrice==0" class="mdc-highlighted-txt">{{vm.ibMarketDepth.marketDepthDetails[2].offerPrice | split:\'.\':\'0\'}}.<span>{{vm.ibMarketDepth.marketDepthDetails[2].offerPrice | number:4 | split:\'.\':\'1\'}}</span></span> <span ng-show="vm.ibMarketDepth.marketDepthDetails[2].offerPrice==0"></span></td><td class="text-right"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[2].offerPrice==0">{{vm.ibMarketDepth.marketDepthDetails[2].offerVolume | number:0}}</span></td></tr><tr><td class="text-right"><span ng-hide="vm.marketDepth.marketDepthDetails[3].bidPrice==0">{{vm.marketDepth.marketDepthDetails[3].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="vm.marketDepth.marketDepthDetails[3].bidPrice==0" class="mdc-highlighted-txt">{{vm.marketDepth.marketDepthDetails[3].bidPrice | split:\'.\':\'0\'}}.<span>{{vm.marketDepth.marketDepthDetails[3].bidPrice | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="vm.marketDepth.marketDepthDetails[3].offerPrice==0" class="mdc-highlighted-txt">{{vm.marketDepth.marketDepthDetails[3].offerPrice | split:\'.\':\'0\'}}.<span>{{vm.marketDepth.marketDepthDetails[3].offerPrice | number:4 | split:\'.\':\'1\'}}</span></span> <span ng-show="vm.marketDepth.marketDepthDetails[3].offerPrice==0"></span></td><td class="text-right right-border"><span ng-hide="vm.marketDepth.marketDepthDetails[3].offerPrice==0">{{vm.marketDepth.marketDepthDetails[3].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[3].bidPrice==0">{{vm.ibMarketDepth.marketDepthDetails[3].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[3].bidPrice==0" class="mdc-highlighted-txt">{{vm.ibMarketDepth.marketDepthDetails[3].bidPrice | split:\'.\':\'0\'}}.<span>{{vm.ibMarketDepth.marketDepthDetails[3].bidPrice | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[3].offerPrice==0" class="mdc-highlighted-txt">{{vm.ibMarketDepth.marketDepthDetails[3].offerPrice | split:\'.\':\'0\'}}.<span>{{vm.ibMarketDepth.marketDepthDetails[3].offerPrice | number:4 | split:\'.\':\'1\'}}</span></span> <span ng-show="vm.ibMarketDepth.marketDepthDetails[3].offerPrice==0"></span></td><td class="text-right"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[3].offerPrice==0">{{vm.ibMarketDepth.marketDepthDetails[3].offerVolume | number:0}}</span></td></tr><tr><td class="text-right"><span ng-hide="vm.marketDepth.marketDepthDetails[4].bidPrice==0">{{vm.marketDepth.marketDepthDetails[4].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="vm.marketDepth.marketDepthDetails[4].bidPrice==0" class="mdc-highlighted-txt">{{vm.marketDepth.marketDepthDetails[4].bidPrice | split:\'.\':\'0\'}}.<span>{{vm.marketDepth.marketDepthDetails[4].bidPrice | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="vm.marketDepth.marketDepthDetails[4].offerPrice==0" class="mdc-highlighted-txt">{{vm.marketDepth.marketDepthDetails[4].offerPrice | split:\'.\':\'0\'}}.<span>{{vm.marketDepth.marketDepthDetails[4].offerPrice | number:4 | split:\'.\':\'1\'}}</span></span> <span ng-show="vm.marketDepth.marketDepthDetails[4].offerPrice==0"></span></td><td class="text-right right-border"><span ng-hide="vm.marketDepth.marketDepthDetails[4].offerPrice==0">{{vm.marketDepth.marketDepthDetails[4].offerVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[4].bidPrice==0">{{vm.ibMarketDepth.marketDepthDetails[4].bidVolume | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right right-border"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[4].bidPrice==0" class="mdc-highlighted-txt">{{vm.ibMarketDepth.marketDepthDetails[4].bidPrice | split:\'.\':\'0\'}}.<span>{{vm.ibMarketDepth.marketDepthDetails[4].bidPrice | number:4 | split:\'.\':\'1\'}}</span></span></td><td class="text-right"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[4].offerPrice==0" class="mdc-highlighted-txt">{{vm.ibMarketDepth.marketDepthDetails[4].offerPrice | split:\'.\':\'0\'}}.<span>{{vm.ibMarketDepth.marketDepthDetails[4].offerPrice | number:4 | split:\'.\':\'1\'}}</span></span> <span ng-show="vm.ibMarketDepth.marketDepthDetails[4].offerPrice==0"></span></td><td class="text-right"><span ng-hide="vm.ibMarketDepth.marketDepthDetails[4].offerPrice==0">{{vm.ibMarketDepth.marketDepthDetails[4].offerVolume | number:0}}</span></td></tr></tbody></table></div></div></div></form>');
$templateCache.put('app/entities/manual-message-trigger/manual-message-trigger.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="manualMessageTrigger.title">Manual Message Trigger</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><!-- Message Type --><div class="row manual-message-type-row"><label class="col-md-offset-3 control-label col-xs-6 col-md-6 mb-5"><span>Message Type</span></label><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><select name="messageType" class="form-control select-style non-mandatory" ng-model="vm.messageType" ng-options="messageType for messageType in vm.messageTypeList"><option value="">-- Select Message Type --</option></select></div></div><!-- Request / Send / Response --><div class="manual-message-container"><!-- Request --><div class="json-panel"><div class="json-panel-header"><span>Request</span><label class="json-checkbox-label"><input type="checkbox" ng-model="vm.isJson"> <span>Is JSON</span></label></div><textarea class="json-textarea" ng-model="vm.requestJson" placeholder="Enter request here..." spellcheck="false">\r\n                        </textarea></div><!-- Send Button --><div class="send-button-container"><button type="button" class="btn btn-info" ng-click="vm.sendManualTrigger()" ng-disabled="vm.clicked">Send</button></div><!-- Response --><div class="json-panel"><div class="json-panel-header"><span>Response</span></div><textarea class="json-textarea" ng-model="vm.responseJson" placeholder="Response will be displayed here..." readonly="readonly" spellcheck="false">\r\n                        </textarea></div></div></div></section></div></div>');
$templateCache.put('app/entities/market-movement/market-movement.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.marketMovement.title">Market Movement</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseMarketMovement = !vm.ExpandOrCollapseMarketMovement" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#MarketMovement"><img ng-src="{{vm.ExpandOrCollapseMarketMovement == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.marketMovement.criteria">Criteria</span></a></h4></div><div id="MarketMovement" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="marketMovementForm"><div class="form-group"><div class="row"><label class="col-md-offset-3 control-label col-xs-6 col-md-6" cspl-mandatory><span data-translate="gatewayApp.marketMovement.currencyPair"></span></label><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><!-- <select name="select" class="form-control select-style non-mandatory" ng-model="vm.instrument" style="border-color:#595959;" \r\n                                                    ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id">\r\n                                                    <option value="">--All--</option>\r\n                                            </select> --><cspl-ach control-model="vm.currencyPair" control-id="txtCurrencyPair" lookup-name="currencyPair" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}" control-place-holder="Enter Currency Pair" display-column="code" placeholder="" form="marketMovementForm" control-required="true"></div><div class="col-md-1 col-sm-1"><button class="btn btn-info active" ng-disabled="marketMovementForm.$invalid" ng-click="loadAll();vm.clicked=true;  vm.showData = true;" data-target="#MarketMovement" data-translate="gatewayApp.marketMovement.go"></button></div></div></div></form></div></div></div><div ng-if="vm.showData"><!-- <div class="row" ng-show="vm.marketMovement.length > 0"> --><div class="row"><div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="tblmarketmovement" total-record-count="vm.marketMovement.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Market_Movement_{{vm.exportName}}"></cspl-table-export></div></div><div class="pull-left"><label class="headerlbl control-label">{{ vm.currencyPair && vm.currencyPair.code ? vm.currencyPair.code : \'USDINR\' }}</label></div><div class="col-md-4 pull-left"><label class="datelbl control-label">{{vm.todayDate | date:\'dd-MMM-yy\'}} | {{vm.todayDate|date:\'hh:mm a\'}}</label></div><div style="margin-top:10px;float:right" ng-if="vm.changeInstrument"><div><div id="btnGroup"><div class="btn-group noPaddingMargin"><label class="btn btn-primary tab-padding active" ng-model="vm.instrument" uib-btn-radio="\'SPOT\'">RETAIL SPOT</label><label class="btn btn-primary tab-padding" ng-model="vm.instrument" uib-btn-radio="\'InterbankSPOT\'">INTERBANK SPOT</label></div></div></div></div><div style="margin-top:10px;float:right" ng-if="!vm.changeInstrument"><div><div id="btnGroup"><div class="btn-group noPaddingMargin"><label class="btn btn-primary tab-padding active" ng-model="vm.instrument" uib-btn-radio="\'CASH\'">CASH</label><label class="btn btn-primary tab-padding" ng-model="vm.instrument" uib-btn-radio="\'TOM\'">TOM</label><label class="btn btn-primary tab-padding" ng-model="vm.instrument" uib-btn-radio="\'SPOT\'">SPOT</label></div></div></div></div></div><!-- <div class="table-responsive" style="overflow:auto;" ng-show="vm.marketMovement.length > 0"> --><div class="table-responsive" style="overflow:auto"><table id="tblmarketmovement" class="dataTable table table-striped table-hover secondaryTable"><thead><tr><th data-translate="gatewayApp.marketMovement.timeInterval">Time Interval</th><th class="text-right noPaddingLeftRight" data-translate="gatewayApp.marketMovement.bidValue">Bid Value</th><th class="text-right noPaddingLeftRight" data-translate="gatewayApp.marketMovement.offerValue">Offer Value</th><th class="text-right noPaddingLeftRight" data-translate="gatewayApp.marketMovement.tradedValue">Traded Value</th><th class="text-right noPaddingLeftRight" data-translate="gatewayApp.marketMovement.open">Open</th><th class="text-right noPaddingLeftRight" data-translate="gatewayApp.marketMovement.high">High</th><th class="text-right noPaddingLeftRight" data-translate="gatewayApp.marketMovement.low">Low</th><th class="text-right noPaddingLeftRight" data-translate="gatewayApp.marketMovement.ltp">Low</th><th class="text-right" style="padding-right:15px;padding-left:0px" data-translate="gatewayApp.marketMovement.currencyPair">LTP</th></tr></thead><tbody><tr ng-repeat="market in filterData = (vm.marketMovement | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="width:100px"><span class="lbl-padding control-label">{{market.intervalStartTime | date:\'HH:mm\'}} - {{market.intervalEndTime | date:\'HH:mm\'}}</span></td><td class="text-right noPaddingLeftRight">{{market.intervalBuyAmount | number : vm.noOfDecimalsForAmount}}</td><td class="text-right noPaddingLeftRight">{{market.intervalSellAmount | number : vm.noOfDecimalsForAmount}}</td><td class="text-right noPaddingLeftRight">{{market.intervalTradeAmount | number : vm.noOfDecimalsForAmount}}</td><td class="text-right noPaddingLeftRight">{{market.intervalOpenExchangeRate | number : vm.noOfDecimalsForRate}}</td><td class="text-right noPaddingLeftRight">{{market.intervalHighExchangeRate | number : vm.noOfDecimalsForRate}}</td><td class="text-right noPaddingLeftRight">{{market.intervalLowExchangeRate | number : vm.noOfDecimalsForRate}}</td><td class="text-right noPaddingLeftRight">{{market.intervalCloseExchangeRate | number : vm.noOfDecimalsForRate}}</td><td class="text-right" style="padding-right:15px;padding-left:0px">{{ vm.currencyPair && vm.currencyPair.code ? vm.currencyPair.code : \'USDINR\' }}</td></tr></tbody><tfoot><tr class="primaryRow"><td class="summaryLabel" style="border-left:1px solid white;;border-top-left-radius:5px" data-translate="gatewayApp.marketMovement.prevClose"></td><td class="panel-lbl">{{(vm.prevClose | number : vm.noOfDecimalsForRate) || \'-\'}}</td><td class="summaryLabel" data-translate="gatewayApp.marketMovement.open"></td><td class="panel-lbl">{{vm.openPrice | number : vm.noOfDecimalsForRate }}</td><td class="summaryLabel" data-translate="gatewayApp.marketMovement.high"></td><td class="panel-lbl">{{vm.high | number : vm.noOfDecimalsForRate }}</td><td class="summaryLabel" data-translate="gatewayApp.marketMovement.low"></td><td class="panel-lbl">{{vm.low | number : vm.noOfDecimalsForRate }}</td><td class="panel-lbl" style="border-right:1px solid white;border-top-right-radius:5px"></td></tr><tr><td class="summaryLabel" style="border-left:1px solid white" data-translate="gatewayApp.marketMovement.ltp"></td><td class="panel-lbl">{{vm.ltp | number : vm.noOfDecimalsForRate }}</td><td class="summaryLabel" data-translate="gatewayApp.marketMovement.change"></td><td class="panel-lbl" style="mso-number-format:General"><span ng-show="vm.changeInPrice>0">+{{vm.changeInPrice | number : vm.noOfDecimalsForRate }}</span> <span ng-show="vm.changeInPrice<=0">{{vm.changeInPrice | number : vm.noOfDecimalsForRate }}</span></td><td class="summaryLabel" data-translate="gatewayApp.marketMovement.changeInPercent"></td><td class="panel-lbl"><span ng-show="vm.changeInPercent!=null && vm.changeInPercent!=undefined && vm.changeInPercent>0">+{{vm.changeInPercent | number : vm.noOfDecimalsForAmount}} %</span> <span ng-show="vm.changeInPercent!=null && vm.changeInPercent!=undefined && vm.changeInPercent<=0">{{vm.changeInPercent | number : vm.noOfDecimalsForAmount}} %</span></td><td class="summaryLabel"></td><td class="panel-lbl"></td><td class="panel-lbl" style="border-right:1px solid white"></td></tr><tr class="lastRow"><td class="summaryLabel" style="border-left:1px solid white;border-bottom-left-radius:5px" data-translate="gatewayApp.marketMovement.tbq"></td><td class="panel-lbl">{{vm.tbq | number : vm.noOfDecimalsForAmount}}</td><td class="summaryLabel" data-translate="gatewayApp.marketMovement.toq"></td><td class="panel-lbl">{{vm.toq | number : vm.noOfDecimalsForAmount}}</td><td class="summaryLabel" data-translate="gatewayApp.marketMovement.ttq"></td><td class="panel-lbl">{{vm.ttq | number : vm.noOfDecimalsForAmount}}</td><td class="summaryLabel"></td><td class="panel-lbl"></td><td class="panel-lbl" style="border-right:1px solid white;border-bottom-right-radius:5px"></td></tr><!--two empty rows between summary and environmentName --><tr><td></td></tr><tr><td></td></tr></tfoot></table></div><!-- Panel --> <!-- <div class="panel panel-default">\r\n    <div class="panel-body">\r\n    <div class="row">\r\n    <div class="col-sm-3 col-xs-12">\r\n    <div class="col-sm-6 text-right col-xs-6">\r\n    <label class="control-label text-right" data-translate="gatewayApp.marketMovement.prevClose">Prev Close</label></div>\r\n    <div class="col-sm-6  col-xs-6">\r\n    <label class="panel-lbl ">{{(vm.prevClose | number : vm.noOfDecimalsForRate) || \'-\'}}</label>\r\n    </div>\r\n    </div>\r\n     \r\n     <div class="col-sm-3 col-xs-12">\r\n      <div class="col-sm-6 col-xs-6 text-right">\r\n    <label class="control-label text-right" data-translate="gatewayApp.marketMovement.open">Open</label>\r\n    </div>\r\n     <div class="col-sm-6 col-xs-6">\r\n  <label  class="panel-lbl">{{vm.marketMovement[0].intervalOpenExchangeRate | number : vm.noOfDecimalsForRate }}</label>\r\n  </div>\r\n    </div>\r\n    \r\n     <div class="col-sm-3 col-xs-12">\r\n      <div class="col-sm-6 text-right col-xs-6">\r\n    <label class="control-label text-right" data-translate="gatewayApp.marketMovement.high">High</label>\r\n    </div>\r\n     <div class="col-sm-6 col-xs-6">\r\n   <label  class="panel-lbl">{{vm.high | number : vm.noOfDecimalsForRate }}</label>\r\n   </div>\r\n    </div>\r\n     <div class="col-sm-3 col-xs-12">\r\n      <div class="col-sm-6 text-right col-xs-6">\r\n    <label class="control-label text-right" data-translate="gatewayApp.marketMovement.low">Low</label>\r\n    </div>\r\n     <div class="col-sm-6 col-xs-6">\r\n    <label  class="panel-lbl">{{vm.low | number : vm.noOfDecimalsForRate }}</label>\r\n    </div>\r\n    </div>\r\n    </div>\r\n\r\n    \r\n    <div class="row">\r\n     <div class="col-sm-3 col-xs-12">\r\n    <div class="col-sm-6 text-right col-xs-6">\r\n    <label class="control-label text-right" data-translate="gatewayApp.marketMovement.ltp">LTP</label></div>\r\n    <div class="col-sm-6 col-xs-6">\r\n    <label  class="panel-lbl">{{vm.marketMovement[vm.marketMovement.length-1].intervalCloseExchangeRate | number : vm.noOfDecimalsForRate }}</label>\r\n    </div>\r\n    </div>\r\n\r\n     <div class="col-sm-3 col-xs-12">\r\n    <div class="col-sm-6 text-right col-xs-6">\r\n    <label class="control-label text-right" data-translate="gatewayApp.marketMovement.change">Change</label></div>\r\n    <div class="col-sm-6 col-xs-6">\r\n    <label  class="panel-lbl"><span ng-show="vm.changeInPrice>0">+</span>{{vm.changeInPrice | number : vm.noOfDecimalsForRate }}</label>\r\n    </div>\r\n    </div>\r\n\r\n     <div class="col-sm-3 col-xs-12">\r\n    <div class="col-sm-6 text-right col-xs-6">\r\n    <label class="control-label text-right" data-translate="gatewayApp.marketMovement.changeInPercent">Change %</label></div>\r\n    <div class="col-sm-6 col-xs-6">\r\n    <label  class="panel-lbl"><span ng-show="vm.changeInPercent>0">+</span>{{vm.changeInPercent | number : vm.noOfDecimalsForAmount}}<span ng-show="vm.changeInPercent!=null && vm.changeInPercent!=undefined">%</span></label>\r\n    </div>\r\n    </div>\r\n    </div>\r\n\r\n    <div class="row">\r\n    <div class="col-sm-3 col-xs-12">\r\n    <div class="col-sm-6 text-right col-xs-6">\r\n    <label class="control-label text-right" data-translate="gatewayApp.marketMovement.tbq">TBQ</label></div>\r\n    <div class="col-sm-6 col-xs-6">\r\n    <label  class="panel-lbl">{{vm.tbq | number : vm.noOfDecimalsForAmount}}</label>\r\n    </div>\r\n    </div>\r\n     <div class="col-sm-3 col-xs-12">\r\n      <div class="col-sm-6 col-xs-6 text-right">\r\n    <label class="control-label text-right" data-translate="gatewayApp.marketMovement.toq">TOQ</label>\r\n    </div>\r\n     <div class="col-sm-6 col-xs-6">\r\n  <label  class="panel-lbl">{{vm.toq | number : vm.noOfDecimalsForAmount}}</label>\r\n  </div>\r\n    </div>\r\n     <div class="col-sm-3 col-xs-12">\r\n      <div class="col-sm-6 col-xs-6 text-right">\r\n    <label class="control-label text-right" data-translate="gatewayApp.marketMovement.ttq">TTQ</label>\r\n    </div>\r\n     <div class="col-sm-6 col-xs-6">\r\n   <label  class="panel-lbl">{{vm.ttq | number : vm.noOfDecimalsForAmount}}</label>\r\n    </div>\r\n    </div>\r\n    </div>\r\n    \r\n    </div>\r\n  </div>  --><div ng-show="vm.marketMovement.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/market-statistics/market-statistics.html','<style>font-size:11px;</style><form name="marketStatisticsForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span ng-if="vm.instrument==\'SPOT\'">Retail Spot - Statistics</span> <span ng-if="vm.instrument==\'InterbankSPOT\'">Interbank Spot - Statistics</span> <span ng-if="vm.instrument==\'BOTH\'">Statistics</span></h4></div><div class="modal-body" style="font-size:11px"><div class="stats" ng-if="vm.instrument==\'BOTH\'"><span class="stats-header">RETAIL SPOT</span></div><div class="content"><div class="row"><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6"><label class="control-label text-right smallerFont" style="text-align:right" data-translate="gatewayApp.marketMovement.prevClose">Prev. Close</label></div><div class="col-sm-6 col-xs-6"><label class="panel-lbl">{{(vm.prevClose | number : vm.noOfDecimalsForRate) || \'-\'}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6 borderLeft"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.open">Open</label></div><div class="col-sm-6 col-xs-6"><label class="panel-lbl">{{vm.openPrice | number : vm.noOfDecimalsForRate}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-7 text-right col-xs-7 borderLeft"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.high">High</label></div><div class="col-sm-5 col-xs-5"><label class="panel-lbl">{{vm.high | number : vm.noOfDecimalsForRate}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6 borderLeft"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.low">Low</label></div><div class="col-sm-6 col-xs-6"><label class="panel-lbl">{{vm.low | number : vm.noOfDecimalsForRate}}</label></div></div></div><div class="row"><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.ltp">LTP</label></div><div class="col-sm-6 col-xs-6"><label class="panel-lbl">{{vm.ltp | number : vm.noOfDecimalsForRate}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6 borderLeft"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.change">Change</label></div><div class="col-sm-6 col-xs-6"><label class="panel-lbl"><span ng-show="vm.changeInPrice>0">+</span>{{vm.changeInPrice | number : vm.noOfDecimalsForRate}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-7 text-right col-xs-7 borderLeft"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.changePer">Change %</label></div><div class="col-sm-5 col-xs-5"><label class="panel-lbl"><span ng-show="vm.changeInPercent>0">+</span>{{vm.changeInPercent | number : vm.noOfDecimalsForAmount}}<span ng-show="vm.changeInPercent!=null && vm.changeInPercent!=undefined">%</span></label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6 borderLeft"><label class="control-label text-right smallerFont" style="opacity:0.01">Low</label></div><div class="col-sm-6 col-xs-6"><label class="panel-lbl"></label></div></div></div><div class="row"><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.totalVol">Total Val</label></div><div class="col-sm-6 col-xs-4"><label class="panel-lbl">{{vm.totalVal | number : vm.noOfDecimalsForAmount}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6 borderLeft"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.totalBid">Total Bid</label></div><div class="col-sm-6 col-xs-4"><label class="panel-lbl">{{vm.tbq | number : vm.noOfDecimalsForAmount}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-7 text-right col-xs-7 borderLeft"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.totalOffer">Total Offer</label></div><div class="col-sm-5 col-xs-5"><label class="panel-lbl">{{vm.toq | number : vm.noOfDecimalsForAmount}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6 borderLeft"><label class="control-label text-right smallerFont" style="opacity:0.01">Low</label></div><div class="col-sm-6 col-xs-6"><label class="panel-lbl"></label></div></div></div></div><br><div class="stats" ng-if="vm.instrument==\'BOTH\'"><span class="stats-header">INTERBANK SPOT</span></div><div class="content" ng-if="vm.instrument==\'BOTH\'"><div class="row"><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6"><label class="control-label text-right smallerFont" style="text-align:right" data-translate="gatewayApp.marketMovement.prevClose">Prev. Close</label></div><div class="col-sm-6 col-xs-6"><label class="panel-lbl">{{(vm.prevCloseForIb | number : vm.noOfDecimalsForRate) || \'-\'}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6 borderLeft"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.open">Open</label></div><div class="col-sm-6 col-xs-6"><label class="panel-lbl">{{vm.openPriceForIb | number : vm.noOfDecimalsForRate}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-7 text-right col-xs-7 borderLeft"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.high">High</label></div><div class="col-sm-5 col-xs-5"><label class="panel-lbl">{{vm.highForIb | number : vm.noOfDecimalsForRate}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6 borderLeft"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.low">Low</label></div><div class="col-sm-6 col-xs-6"><label class="panel-lbl">{{vm.lowForIb | number : vm.noOfDecimalsForRate}}</label></div></div></div><div class="row"><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.ltp">LTP</label></div><div class="col-sm-6 col-xs-6"><label class="panel-lbl">{{vm.ltpForIb | number : vm.noOfDecimalsForRate}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6 borderLeft"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.change">Change</label></div><div class="col-sm-6 col-xs-6"><label class="panel-lbl"><span ng-show="vm.changeInPriceForIb>0">+</span>{{vm.changeInPriceForIb | number : vm.noOfDecimalsForRate}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-7 text-right col-xs-7 borderLeft"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.changePer">Change %</label></div><div class="col-sm-5 col-xs-5"><label class="panel-lbl"><span ng-show="vm.changeInPercentForIb>0">+</span>{{vm.changeInPercentForIb | number : vm.noOfDecimalsForAmount}}<span ng-show="vm.changeInPercentForIb!=null && vm.changeInPercentForIb!=undefined">%</span></label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6 borderLeft"><label class="control-label text-right smallerFont" style="opacity:0.01">Low</label></div><div class="col-sm-6 col-xs-6"><label class="panel-lbl"></label></div></div></div><div class="row"><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.totalVol">Total Val</label></div><div class="col-sm-6 col-xs-4"><label class="panel-lbl">{{vm.totalValForIb | number : vm.noOfDecimalsForAmount}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6 borderLeft"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.totalBid">Total Bid</label></div><div class="col-sm-6 col-xs-4"><label class="panel-lbl">{{vm.tbqForIb | number : vm.noOfDecimalsForAmount}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-7 text-right col-xs-7 borderLeft"><label class="control-label text-right smallerFont" data-translate="gatewayApp.marketMovement.totalOffer">Total Offer</label></div><div class="col-sm-5 col-xs-5"><label class="panel-lbl">{{vm.toqForIb | number : vm.noOfDecimalsForAmount}}</label></div></div><div class="col-sm-3 col-xs-12"><div class="col-sm-6 text-right col-xs-6 borderLeft"><label class="control-label text-right smallerFont" style="opacity:0.01">Low</label></div><div class="col-sm-6 col-xs-6"><label class="panel-lbl"></label></div></div></div></div></div></form>');
$templateCache.put('app/entities/markup-report/markup-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="gatewayApp.markupReport.title"></span></h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px;  margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapse = !vm.ExpandOrCollapse" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#MarkupReport"><img ng-src="{{vm.ExpandOrCollapse == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.markupReport.Criteria">Criteria</span></a></h4></div><div id="MarkupReport" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="markupReportForm"><div class="col-sm-6 col-centered"><div class="row" ng-if="!vm.disableBank"><label class="control-label"><span data-translate="gatewayApp.markupReport.bank"></span></label></div><div class="row" ng-if="!vm.disableBank"><div class="col-md-6 multi-col"><cspl-ach control-model="vm.bank" control-id="txtbank" control-disabled="vm.disableBank" lookup-name="{{vm.bankLookUpName}}" display-column="bankName" placeholder="" form="markupReportForm" filter-value="{{vm.bankFilter}}"></div></div><div class="row" ng-if="!vm.disableBranch"><label class="control-label"><span data-translate="gatewayApp.markupReport.branch"></span></label></div><div class="row" ng-if="!vm.disableBranch"><div class="col-md-6 multi-col"><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="branchesForBank" display-column="shortName" control-disabled="vm.disableBranch" form="markupReportForm" filter-value="{{vm.bank.id}}"></div></div><div class="row" ng-if="!vm.disableCustomer"><label class="control-label"><span data-translate="gatewayApp.markupReport.customer"></span></label></div><div class="row" ng-if="!vm.disableCustomer"><div class="col-md-6 multi-col"><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="nonPropCustomersForBranch" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" display-column="customerCode,customerName" control-place-holder="Enter Customer ID or Name" control-disabled="vm.disableCustomer" form="markupReportForm"></div></div><br><div class="col-md-12" style="padding-left:0"><div class="col-md-2" style="padding-left:0;margin-top: 10px"><input type="radio" name="optradio" id="radio1" ng-model="vm.historicalOrCurrent" style="margin-right:5px" value="Historical" form="markupReportForm"><label style="color:#FFFFFF" for="radio1" data-translate="gatewayApp.markupReport.historical"></label></div><div class="col-md-5"><cspl-dtp control-model="vm.fromDate" control-id="dtpFromDate" form="markupReportForm" required control-disabled="vm.historicalOrCurrent == \'Current\'" control-max-date="vm.yesterdayDate"></div><div class="col-md-5"><cspl-dtp control-model="vm.toDate" control-id="dtpToDate" form="markupReportForm" required control-disabled="vm.historicalOrCurrent == \'Current\'" control-max-date="vm.yesterdayDate"></div></div><div class="col-md-12" style="padding-left:0"><div class="col-md-2" style="padding-left:0;margin-top: 10px;padding-right:0"><input type="radio" name="optradio" id="radio2" ng-model="vm.historicalOrCurrent" style="margin-right:5px" value="Current" form="markupReportForm"><label style="color:#FFFFFF" for="radio2" data-translate="gatewayApp.markupReport.forToday"></label></div><div class="col-md-5" style="margin-top:10px"><label class="control-label"><span>{{vm.reportDate | date : \'dd-MMM-yyyy\'}}</span></label></div></div><div class="col-md-12" style="padding-left:0"><div class="col-md-2" style="padding-left:0"></div><div class="col-md-5"></div><div class="col-md-5"><button class="btn btn-info active" ng-disabled="vm.clicked;" ng-click="vm.loadHeader();" style="float:right" data-translate="entity.action.go" style="margin-top:0px" data-toggle="collapse" data-target="#MarkupReport"></button></div></div></div></form></div></div></div><div ng-show="vm.headerList.length>0"><div class="row"><div class="pull-left"><div class="dropdown col-md-3" style="width:10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border:none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive settlement-report-table"><table id="headerList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.markupReport.tradeDate"></th><th data-translate="gatewayApp.markupReport.relationshipBank"></th><th data-translate="gatewayApp.markupReport.tradingBranch"></th><th data-translate="gatewayApp.markupReport.customerId"></th><th data-translate="gatewayApp.markupReport.customerName"></th><th class="tableNumericColumn whiteSpaceWrap" data-translate="gatewayApp.markupReport.markupRate"></th><th class="tableNumericColumn whiteSpaceWrap" data-translate="gatewayApp.markupReport.totalMarkupValue"></th><th class="tableNumericColumn whiteSpaceWrap" data-translate="gatewayApp.markupReport.totalTax"></th><th class="tableNumericColumn whiteSpaceWrap" data-translate="gatewayApp.markupReport.totalMarkupPostTax"></th><th data-translate="gatewayApp.markupReport.source"></th><!-- <th  data-translate="gatewayApp.markupReport.source"></th> --></tr></thead><tbody><tr ng-repeat="markupHeader in filterData = (vm.headerList | filter : filterText) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)" ng-click="vm.getDetails(markupHeader);"><td><span ng-if="vm.historicalOrCurrent == \'Historical\'">{{markupHeader.businessDate|date:\'dd-MMM-yyyy\'}}</span> <span ng-if="vm.historicalOrCurrent == \'Current\'">{{vm.reportDate|date:\'dd-MMM-yyyy\'}}</span></td><td style="word-break:break-word">{{markupHeader.bankName}}</td><td style="word-break:break-word">{{markupHeader.branchName}}</td><td>{{markupHeader.custCode}}</td><td style="word-break:break-word">{{markupHeader.customerName}}</td><td class="tableNumericColumn"><span ng-if="markupHeader.markupType.toUpperCase() == vm.markupTypePaise.toUpperCase()">{{markupHeader.markupValue| currency:\'\' : vm.noOfDecimalsForAmount}}</span> <span ng-if="markupHeader.markupType.toUpperCase() == vm.markupTypePercentage.toUpperCase()">{{markupHeader.markupValue| currency:\'\' : vm.noOfDecimalsForPercent}}%</span></td><td class="tableNumericColumn">{{markupHeader.totalMarkup | currency:\'\' : vm.noOfDecimalsForAmount}}</td><td class="tableNumericColumn">{{markupHeader.totalTax | currency:\'\' : vm.noOfDecimalsForAmount}}</td><td class="tableNumericColumn">{{(markupHeader.totalMarkup + markupHeader.totalTax) | currency:\'\' : vm.noOfDecimalsForAmount}}</td><td style="word-break:break-word">{{markupHeader.custsourceAppName}}</td><!-- <td >{{markupHeader.sourceAppName}}</td> --></tr></tbody></table></div></div><div ng-show="filterData.length > 0"><span class="orderStatusInfo" data-translate="gatewayApp.markupReport.legend"></span></div></div><div ng-show="filterData.length == 0"><span>No record found</span></div><div ng-show="filterData.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><div ng-show="vm.buyDetailsList.length>0 || vm.sellDetailsList.length>0"><div class="row" ng-show="vm.showDetails"><cspl-table-search control-model="detailsFilterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive settlement-report-table" ng-show="vm.showDetails" style="overflow-x: auto; overflow-y: hidden"><table id="detailsList" class="dataTable table table-striped table-hover"><tbody class="group-header"><tr><td colspan="2"><span style="text-decoration:none;font-size:15px" data-translate="gatewayApp.markupReport.tradeDate"></span></td><td colspan="3"><span style="text-decoration:none;font-size:15px" ng-if="vm.businessDate != null && vm.businessDate != undefined">{{vm.businessDate | date : \'dd-MMM-yyyy\'}}</span> <span style="text-decoration:none;font-size:15px" ng-if="vm.businessDate == null || vm.businessDate == undefined">{{vm.reportDate | date : \'dd-MMM-yyyy\'}}</span></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr></tbody><tbody class="group-header"><tr><td colspan="2"><span style="text-decoration:none;font-size:14px" ng-if="vm.loggedinEntityOwnerType != \'MultiUserCustomer\' && vm.loggedinEntityOwnerType != \'SingleUserCustomer\'" data-translate="gatewayApp.markupReport.customerName">:</span></td><td colspan="3"><span style="text-decoration:none;font-size:14px" ng-if="vm.loggedinEntityOwnerType != \'MultiUserCustomer\' && vm.loggedinEntityOwnerType != \'SingleUserCustomer\'">{{vm.selectedHeaderCustomerName}}</span></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr></tbody><tbody class="group-header" ng-if="vm.buyDetailsList.length>0 && vm.showDetails"><tr ng-click="vm.expandBuyTrades=!vm.expandBuyTrades"><td><span class="buySellTrades">BUY</span> <span style="float:left" class="icon arrow_carrot-down" aria-hidden="true" ng-show="vm.expandBuyTrades"></span> <span style="float:left" class="icon arrow_carrot-right" aria-hidden="true" ng-show="!vm.expandBuyTrades"></span></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr></tbody><tbody ng-if="vm.buyDetailsList.length>0 && vm.showDetails && vm.expandBuyTrades"><tr class="thead"><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.sNo"></td><td data-translate="gatewayApp.markupReport.relationshipBank"></td><td data-translate="gatewayApp.markupReport.tradeNumber"></td><td data-translate="gatewayApp.markupReport.tradeType"></td><td data-translate="gatewayApp.markupReport.settlementLeg"></td><td data-translate="gatewayApp.markupReport.currencyPair"></td><td data-translate="gatewayApp.markupReport.instrument"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.tradedQuantity"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.tradePrice"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.equivalentSpotPrice"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.tradeValue"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.markupRate"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.netTradePricePostMarkup"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.tradeValuePostMarkup"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.markupValueRs"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.taxOnMarkupRs"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.markupValuePostTax"></td><td data-translate="gatewayApp.markupReport.tradeSettlementDateFrom"></td><td data-translate="gatewayApp.markupReport.settlementDate"></td><td data-translate="gatewayApp.markupReport.source"></td></tr></tbody><tbody><tr ng-if="vm.buyDetailsList.length>0 && vm.showDetails && vm.expandBuyTrades" ng-repeat="markupBuyDetails in filteredBuyDetailsData = ( vm.buyDetailsList | filter : detailsFilterText )"><td class="tableNumericColumn">{{markupBuyDetails.index}}</td><td>{{markupBuyDetails.bankName}}</td><td>{{markupBuyDetails.tradeNumber}}</td><td>{{markupBuyDetails.tradeTypeName}}</td><td>{{markupBuyDetails.settlementLegName}}</td><td>{{markupBuyDetails.currencyPairCode}}</td><td>{{markupBuyDetails.instrumentCode}}</td><td class="tableNumericColumn">{{markupBuyDetails.tradeAmount| currency:\'\' : vm.noOfDecimalsForAmount}}</td><td class="tableNumericColumn">{{markupBuyDetails.tradeRate| currency:\'\' : vm.noOfDecimalsForRate}}</td><td class="tableNumericColumn">{{markupBuyDetails.equivalentSpotPrice| currency:\'\' : vm.noOfDecimalsForRate}}</td><td class="tableNumericColumn">{{markupBuyDetails.tradeValue| currency:\'\' : vm.noOfDecimalsForAmount}}</td><td class="tableNumericColumn"><span ng-if="markupBuyDetails.markupType.toUpperCase() == vm.markupTypePaise.toUpperCase()">{{markupBuyDetails.markupRate| currency:\'\' : vm.noOfDecimalsForAmount}}</span> <span ng-if="markupBuyDetails.markupType.toUpperCase() == vm.markupTypePercentage.toUpperCase()">{{markupBuyDetails.markupRate| currency:\'\' : vm.noOfDecimalsForPercent}}%</span></td><td class="tableNumericColumn">{{markupBuyDetails.tradePriceWithMarkup| currency:\'\' : vm.noOfDecimalsForRate}}</td><td class="tableNumericColumn">{{markupBuyDetails.netTradedValue| currency:\'\' : vm.noOfDecimalsForAmount}}</td><td class="tableNumericColumn">{{markupBuyDetails.markupValue| currency:\'\' : vm.noOfDecimalsForAmount}}</td><td class="tableNumericColumn">{{markupBuyDetails.taxOnMarkup| currency:\'\' : vm.noOfDecimalsForAmount}}</td><td class="tableNumericColumn">{{markupBuyDetails.markupValuePostTax| currency:\'\' : vm.noOfDecimalsForAmount}}</td><td><span ng-if="markupBuyDetails.tradeSettlementDateFrom !=null">{{markupBuyDetails.tradeSettlementDateFrom| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="markupBuyDetails.tradeSettlementDateFrom ==null">{{\'\'}}</span></td><td>{{markupBuyDetails.settlementDate| date :\'dd-MMM-yyyy\'}}</td><td>{{markupBuyDetails.sourceAppName}}</td></tr><tr class="non-hoverable-tr" ng-if="vm.buyDetailsList.length>0 && vm.sellDetailsList.length==0"><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td colspan="3" class="control-label" style="text-align:right" data-translate="gatewayApp.markupReport.totalMarkupBuySell"></td><td class="control-label tableNumericColumn">{{vm.totalMarkupValue| currency:\'\' : vm.noOfDecimalsForAmount}}</td><td class="control-label tableNumericColumn">{{vm.totalTax| currency:\'\' : vm.noOfDecimalsForAmount}}</td><td class="control-label tableNumericColumn">{{vm.totalMarkupPostTax| currency:\'\' : vm.noOfDecimalsForAmount}}</td><td></td><td></td></tr></tbody><tbody class="group-header" ng-if="vm.sellDetailsList.length>0 && vm.showDetails"><tr ng-click="vm.expandSellTrades=!vm.expandSellTrades"><td><span class="buySellTrades">SELL</span> <span style="float:left" class="icon arrow_carrot-down" aria-hidden="true" ng-show="vm.expandSellTrades"></span> <span style="float:left" class="icon arrow_carrot-right" aria-hidden="true" ng-show="!vm.expandSellTrades"></span></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr></tbody><tbody ng-if="vm.sellDetailsList.length>0 && vm.showDetails && vm.expandSellTrades"><tr class="thead"><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.sNo"></td><td data-translate="gatewayApp.markupReport.relationshipBank"></td><td data-translate="gatewayApp.markupReport.tradeNumber"></td><td data-translate="gatewayApp.markupReport.tradeType"></td><td data-translate="gatewayApp.markupReport.settlementLeg"></td><td data-translate="gatewayApp.markupReport.currencyPair"></td><td data-translate="gatewayApp.markupReport.instrument"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.tradedQuantity"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.tradePrice"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.equivalentSpotPrice"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.tradeValue"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.markupRate"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.netTradePricePostMarkup"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.tradeValuePostMarkup"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.markupValueRs"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.taxOnMarkupRs"></td><td class="tableNumericColumn" data-translate="gatewayApp.markupReport.markupValuePostTax"></td><td data-translate="gatewayApp.markupReport.tradeSettlementDateFrom"></td><td data-translate="gatewayApp.markupReport.settlementDate"></td><td data-translate="gatewayApp.markupReport.source"></td></tr></tbody><tbody><tr ng-if="vm.sellDetailsList.length>0 && vm.showDetails && vm.expandSellTrades" ng-repeat="markupSellDetails in filteredSellDetailsData = ( vm.sellDetailsList | filter : detailsFilterText )"><td class="tableNumericColumn">{{markupSellDetails.index}}</td><td>{{markupSellDetails.bankName}}</td><td>{{markupSellDetails.tradeNumber}}</td><td>{{markupSellDetails.tradeTypeName}}</td><td>{{markupSellDetails.settlementLegName}}</td><td>{{markupSellDetails.currencyPairCode}}</td><td>{{markupSellDetails.instrumentCode}}</td><td class="tableNumericColumn">{{markupSellDetails.tradeAmount| currency:\'\' : vm.noOfDecimalsForAmount}}</td><td class="tableNumericColumn">{{markupSellDetails.tradeRate| currency:\'\' : vm.noOfDecimalsForRate}}</td><td class="tableNumericColumn">{{markupSellDetails.equivalentSpotPrice| currency:\'\' : vm.noOfDecimalsForRate}}</td><td class="tableNumericColumn">{{markupSellDetails.tradeValue| currency:\'\' : vm.noOfDecimalsForAmount}}</td><td class="tableNumericColumn"><span ng-if="markupSellDetails.markupType == \'Paise\'">{{markupSellDetails.markupRate| currency:\'\' : vm.noOfDecimalsForAmount}}</span> <span ng-if="markupSellDetails.markupType == \'Percentage\'">{{markupSellDetails.markupRate| currency:\'\' : vm.noOfDecimalsForPercent}}%</span> <span ng-if="markupSellDetails.markupType == \'\' || markupSellDetails.markupType == null">-</span></td><td class="tableNumericColumn">{{markupSellDetails.tradePriceWithMarkup| currency:\'\' : vm.noOfDecimalsForRate}}</td><td class="tableNumericColumn">{{markupSellDetails.netTradedValue| currency:\'\' : vm.noOfDecimalsForAmount}}</td><!-- <td class="tableNumericColumn "> {{markupSellDetails.markupValue|  currency:\'\' : vm.noOfDecimalsForAmount}}</td>\r\n\t\t\t\t\t\t\t\t<td class="tableNumericColumn "> {{markupSellDetails.taxOnMarkup|  currency:\'\' : vm.noOfDecimalsForAmount}}</td>\r\n\t\t\t\t\t\t\t\t<td class="tableNumericColumn "> {{markupSellDetails.markupValuePostTax|  currency:\'\' : vm.noOfDecimalsForAmount}}</td>\r\n\t\t\t\t\t\t\t\t --><td class="tableNumericColumn"><span ng-if="markupSellDetails.markupType != \'\' && markupSellDetails.markupType != null">{{markupSellDetails.markupValue| currency:\'\' : vm.noOfDecimalsForAmount}}</span> <span ng-if="markupSellDetails.markupType == \'\' || markupSellDetails.markupType == null">-</span></td><td class="tableNumericColumn"><span ng-if="markupSellDetails.markupType != \'\' && markupSellDetails.markupType != null">{{markupSellDetails.taxOnMarkup| currency:\'\' : vm.noOfDecimalsForAmount}}</span> <span ng-if="markupSellDetails.markupType == \'\' || markupSellDetails.markupType == null">-</span></td><td class="tableNumericColumn"><span ng-if="markupSellDetails.markupType != \'\' && markupSellDetails.markupType != null">{{markupSellDetails.markupValuePostTax| currency:\'\' : vm.noOfDecimalsForAmount}}</span> <span ng-if="markupSellDetails.markupType == \'\' || markupSellDetails.markupType == null">-</span></td><td><span ng-if="markupSellDetails.tradeSettlementDateFrom !=null">{{markupSellDetails.tradeSettlementDateFrom| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="markupSellDetails.tradeSettlementDateFrom ==null">{{\'\'}}</span></td><td>{{markupSellDetails.settlementDate| date :\'dd-MMM-yyyy\'}}</td><td>{{markupSellDetails.sourceAppName}}</td></tr><tr class="non-hoverable-tr" ng-if="vm.sellDetailsList.length>0"><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td colspan="3" style="text-align:right" class="control-label" data-translate="gatewayApp.markupReport.totalMarkupBuySell"></td><td class="control-label tableNumericColumn">{{vm.totalMarkupValue| currency:\'\' : vm.noOfDecimalsForAmount}}</td><td class="control-label tableNumericColumn">{{vm.totalTax| currency:\'\' : vm.noOfDecimalsForAmount}}</td><td class="control-label tableNumericColumn">{{vm.totalMarkupPostTax| currency:\'\' : vm.noOfDecimalsForAmount}}</td><td></td><td></td></tr></tbody></table></div></div><div></div><div ng-show="vm.detailsList.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/markup-settings/markup-settings-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="markupEditForm" role="form" novalidate><div class="modal-header"><span class="icon" style="float: right;margin-top :7px;margin-right:30px" ng-show="vm.markup.id==null && userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Add Mark-up" tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span><span class="icon" style="float: right;margin-top :7px;margin-right:30px" ng-show="vm.markup.id!=null && userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Edit Mark-up" tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span ng-show="vm.markup.id==null" data-translate="global.menu.markupSettings.addMarkup"></span> <span ng-show="vm.markup.id!=null" data-translate="global.menu.markupSettings.editMarkup"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset><br><div class="col-sm-6 col-centered"><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.markupSetting.bank"></span></label><cspl-text control-model="vm.bank.bankName" control-id="txtbank" control-disabled="true" form="markupEditForm" required></div><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.markupSetting.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="branch" filter-value="{{vm.orgId}}" display-column="branchName" control-disabled="vm.entityOwnerType==\'Branch\' || vm.markup.id!=null" form="markupEditForm" required></cspl-ach></div><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.markupSetting.customer"></span></label><cspl-ach control-model="vm.markup.customer" control-id="txtCustomer" lookup-name="nonPropCustomersForBranch" filter-value="{{vm.orgId}}~~{{vm.branch.id}}" control-place-holder="Enter Customer ID or Name" display-column="customerCode,customerName" control-disabled="vm.markup.id!=null" form="markupEditForm" required></cspl-ach><span class="cutomer-highlight" ng-show="vm.markup.customer.customerMiddleName!=null">{{vm.markup.customer.customerFirstName+\' \'+vm.markup.customer.customerMiddleName+\' \'+vm.markup.customer.customerLastName}}</span> <span class="cutomer-highlight" ng-show="vm.markup.customer.customerMiddleName==null">{{vm.markup.customer.customerFirstName+\' \'+vm.markup.customer.customerLastName}}</span></div><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered"><span data-translate="gatewayApp.markupSetting.markupValue"></span> <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Mark-up Value" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></label><div class="col-xs-12 col-md-6 multi-col"><select class="form-control select-style" name="markupType" ng-model="vm.markupType" ng-options="markupType.shortName for markupType in vm.markupTypes track by markupType.shortName" form="markupEditForm" required></select></div><div class="col-xs-10 col-md-5 multi-col" ng-show="vm.markupType.shortName!=\'Percentage\' "><cspl-numeric control-model="vm.markup.markupValue" control-id="txtMarkupValue1" no-of-decimals="{{vm.noOfDecimals}}" form="markupEditForm" control-min="0" control-max="999"></cspl-numeric></div><div class="col-xs-10 col-md-5 multi-col" ng-show="vm.markupType.shortName==\'Percentage\' "><cspl-numeric control-model="vm.markup.markupValue" control-id="txtMarkupValue2" no-of-decimals="{{vm.noOfDecimals}}" form="markupEditForm" control-min="0" control-max="100"></cspl-numeric></div><div class="col-xs-1 col-md-1" style="line-height:30px"><span ng-show="vm.markupType.shortName==\'Percentage\' ">%</span></div></div></div><br><div class="help-block-text"><span class="help-block" data-translate="gatewayApp.markupSetting.blank"></span> <span style="padding-top:5px" class="help-block" data-translate="gatewayApp.markupSetting.zero"></span></div><div class="col-xs-6 col-centered"><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered"><span data-translate="gatewayApp.markupSetting.taxOnMarkup"></span></label><div class="col-xs-12 col-md-6 multi-col"><cspl-numeric control-model="vm.markup.taxOnMarkup" control-id="txtTaxOnMarkup" no-of-decimals="{{vm.decimalsForPercent}}" control-disabled="vm.disableTax" form="markupEditForm" control-min="0" control-max="100"></cspl-numeric></div><div class="col-xs-1" style="line-height:30px"><span>%</span></div></div><div class="form-group"><label class="control-label col-xs-12 col-centered"><span data-translate="gatewayApp.markupSetting.roEdApplicability"></span>&nbsp;* <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Mark-up applicability for rollover (RO) & early delivery (ED). If selected Both legs means Mark-up will be charged on both legs and Rebooking leg only means Mark-up will be charged only on Rebooking leg." tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span><!-- <button ng-show="userPreference.showInfoIcon==\'yes\'" type="button" class="transparentbg transparent-border margin-right-25" data-toggle="popover" data-trigger="focus"  data-placement="right" \r\n\t\t\t\t\t\t\tdata-content="Mark-up applicability for rollover (RO) & early delivery (ED). If selected Both legs means Mark-up will be charged on both legs and Rebooking leg only means Mark-up will be charged only on Rebooking leg.">\r\n\t\t\t\t\t\t\tdata-content="<span style=\'color: #FFC000;\'>Both legs</span><br><span>The same Mark-up value as for normal trades will be charged for both cancellation & rebooking legs for Early Delivery and Rollover</span><br><br><span style=\'color: #FFC000;\'>Re-booking Leg Only</span><br><span>The same Mark-up value as for normal trades will be charged only for the rebooking legs for Early Delivery and Rollover</span>">\r\n\t\t\t\t\t\t\t\t<span class="icon" ><img class="width-height-20" src="assets/images/Info-24.png" /></span>\r\n\t\t\t\t\t\t\t</button> --></label><div class="col-xs-7 multi-col"><select class="form-control select-style" name="roEdApplicability" ng-model="vm.roEdApplicabilityMethod" ng-options="roEdApplicability.name for roEdApplicability in vm.roEdApplicabilityMethodList track by roEdApplicability.shortName" form="markupEditForm" required></select></div></div><div class="form-group"><label class="col-md-12 col-xs-12 col-centered control-label" cspl-mandatory><span data-translate="gatewayApp.markupSetting.effectiveFrom"></span></label><div class="col-md-7 col-xs-9 multi-col"><cspl-dtp control-model="vm.effectiveFromDateTime" control-id="dtpEffectiveFrom" form="markupEditForm" control-disabled="true" required></div></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showButton" class="btn btn-primary" ng-disabled="markupEditForm.$invalid || vm.clicked" ng-click="vm.resubmitMarkup();vm.clicked = true;"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="!showButton" ng-disabled="markupEditForm.$invalid || (vm.markup.id!=null && markupEditForm.$pristine) || vm.clicked" class="btn btn-info active" ng-click="vm.save();vm.clicked = true;"><span data-translate="entity.action.save">Save</span></button></div><div class="row"><span class="orderStatusInfo right-floating padding-top-0 italic-font" data-translate="gatewayApp.markupSetting.roEdHelpText"></span></div></div></form>');
$templateCache.put('app/entities/markup-settings/markup-settings-view-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="markupViewForm" role="form" novalidate><div class="modal-header"><span class="icon" style="float: right;margin-top :7px;margin-right:30px" ng-show="vm.markup.id!=null && userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Mark-up Settings" tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span><!-- <button ng-show="userPreference.showInfoIcon==\'yes\'" type="button" class="close" style="margin-right: 25px;" data-toggle="popover" data-trigger="focus"  data-placement="left" data-content="Mark-up Settings">\r\n\t\t<span class="icon" ><img class="width-height-20" src="assets/images/Info-24.png" /></span>\r\n\t</button> --> <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="global.menu.markupSettings.markup"></span></h4></div><div class="modal-body"><div class="content"><fieldset><br><div class="col-xs-6 col-centered"><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.markupSetting.bank"></span></label><cspl-text control-model="vm.bank.bankName" control-id="txtbank" control-disabled="true" form="markupViewForm" required></div><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.markupSetting.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="branch" filter-value="{{vm.orgId}}" display-column="branchName" control-disabled="true" form="markupViewForm" required></cspl-ach></div><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.markupSetting.customer"></span></label><cspl-ach control-model="vm.markup.customer" control-id="txtCustomer" lookup-name="nonPropCustomersForBranch" filter-value="{{vm.orgId}}~~{{vm.branch.id}}" display-column="customerCode,customerName" control-disabled="true" form="markupViewForm" required></cspl-ach><span class="cutomer-highlight" ng-show="vm.markup.customer.customerMiddleName!=null">{{vm.markup.customer.customerFirstName+\' \'+vm.markup.customer.customerMiddleName+\' \'+vm.markup.customer.customerLastName}}</span> <span class="cutomer-highlight" ng-show="vm.markup.customer.customerMiddleName==null">{{vm.markup.customer.customerFirstName+\' \'+vm.markup.customer.customerLastName}}</span></div><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered"><span data-translate="gatewayApp.markupSetting.markupValue"></span> <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Mark-up Value" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span><!-- <button ng-show="userPreference.showInfoIcon==\'yes\'" type="button" class="transparentbg transparent-border margin-right-25" data-toggle="popover" data-trigger="focus"  data-placement="right" data-content="Mark-up Value">\r\n\t\t\t\t\t\t\t<span class="icon" ><img class="width-height-20" src="assets/images/Info-24.png" /></span>\r\n\t\t\t\t\t\t</button> --></label><div class="col-xs-12 col-md-6 multi-col"><select class="form-control select-style" style="border-color:#BB8557" name="markupType" ng-model="vm.markupType" ng-options="markupType.shortName for markupType in vm.markupTypes track by markupType.shortName" ng-disabled="true" form="markupViewForm" required></select></div><div class="col-xs-10 col-md-5 multi-col"><cspl-numeric control-model="vm.markup.markupValue" control-id="txtMarkupValue" no-of-decimals="{{vm.noOfDecimals}}" form="markupViewForm" control-disabled="true"></cspl-numeric></div><div class="col-xs-1 col-md-1" style="line-height:30px"><span ng-show="vm.markupType.shortName==\'Percentage\' ">%</span></div></div></div><br><div class="help-block-text"><span class="help-block" data-translate="gatewayApp.markupSetting.blank"></span> <span style="padding-top:5px" class="help-block" data-translate="gatewayApp.markupSetting.zero"></span></div><div class="col-xs-6 col-centered"><div class="form-group"><label class="control-label col-xs-12 col-md-12 col-centered"><span data-translate="gatewayApp.markupSetting.taxOnMarkup"></span></label><div class="col-xs-12 col-md-6 multi-col"><cspl-numeric control-model="vm.markup.taxOnMarkup" control-id="txtTaxOnMarkup" no-of-decimals="{{vm.decimalsForPercent}}" form="markupViewForm" control-min="0" control-max="100" control-disabled="true"></cspl-numeric></div><div class="col-xs-1" style="line-height:30px"><span>%</span></div></div><div class="form-group" ng-hide="vm.roEdApplicabilityMethod==null && vm.hideRoEdApplicability"><label class="control-label col-xs-12 col-centered"><span data-translate="gatewayApp.markupSetting.roEdApplicability"></span>&nbsp;* <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Mark-up applicability for rollover (RO) & early delivery (ED). If selected Both legs means Mark-up will be charged on both legs and Rebooking leg only means Mark-up will be charged only on Rebooking leg." tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span><!-- <button ng-show="userPreference.showInfoIcon==\'yes\'" type="button" class="transparentbg transparent-border margin-right-25" data-toggle="popover" data-trigger="focus"  data-placement="right" \r\n\t\t\t\t\t\t\tdata-content="Mark-up applicability for rollover (RO) & early delivery (ED). If selected Both legs means Mark-up will be charged on both legs and Rebooking leg only means Mark-up will be charged only on Rebooking leg.">\r\n\t\t\t\t\t\t\t data-content="<span style=\'color: #FFC000;\'>Both legs</span><br><span>The same Mark-up value as for normal trades will be charged for both cancellation & rebooking legs for Early Delivery and Rollover</span><br><br><span style=\'color: #FFC000;\'>Re-booking Leg Only</span><br><span>The same Mark-up value as for normal trades will be charged only for the rebooking legs for Early Delivery and Rollover</span>">\r\n\t\t\t\t\t\t\t\t<span class="icon" ><img class="width-height-20" src="assets/images/Info-24.png" /></span>\r\n\t\t\t\t\t\t\t</button> --></label><div class="col-xs-7 multi-col"><select class="form-control select-style" name="roEdApplicability" ng-model="vm.roEdApplicabilityMethod" ng-options="roEdApplicability.name for roEdApplicability in vm.roEdApplicabilityMethodList track by roEdApplicability.shortName" ng-disabled="true" form="markupViewForm" required></select></div></div><div class="form-group"><label class="col-md-12 col-xs-12 col-centered control-label" cspl-mandatory><span data-translate="gatewayApp.markupSetting.effectiveFrom"></span></label><div class="col-md-6 col-xs-9 multi-col"><cspl-dtp control-model="vm.effectiveFromDateTime" control-id="dtpEffectiveFrom" form="markupViewForm" control-disabled="true" required></div></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>OK</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardMarkup()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showButton" class="btn btn-reject" ng-click="vm.rejectMarkup()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" autofocus class="btn btn-approve" ng-disabled="clicked" ng-click="vm.approveMarkup();clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div><div class="row"><span class="orderStatusInfo right-floating padding-top-0 italic-font" data-translate="gatewayApp.markupSetting.roEdHelpText"></span></div></div></form>');
$templateCache.put('app/entities/markup-settings/markup-settings.html','<script>$(\'[data-toggle="popover"]\').popover({\r\n    container: \'body\',\r\n\thtml: true\r\n \t})</script><div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.markupSettings.main">Markup Settings</h2><nmb-alert></nmb-alert><div><!-- <nmb-alert-error></nmb-alert-error> --></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row col-md-12" ng-show="vm.entityOwnerType==\'Bank\'"><form name="branchForm" role="form" novalidate><br><script>$(document).ready(function() {\r\n\t\t\t\t\t\t\t   $(\'#roEdApplicabilityPop\').popover({\r\n\t\t\t\t\t\t\t\t  container: \'body\',\r\n\t\t\t\t\t\t\t\t  html: true\r\n\t\t\t\t\t\t\t   })\r\n\t\t\t\t\t\t\t});</script><div class="row"><label class="col-md-1 col-xs-4 control-label" style="margin-top: 7px"><span data-translate="gatewayApp.markupSetting.branch"></span></label><div class="col-md-3 col-xs-10"><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="branch" filter-value="{{vm.bank.id}}" display-column="branchName" form="branchForm"></cspl-ach></div><div class="col-xs-1"><button type="button" class="btn btn-info active" ng-disabled="branchForm.$invalid||vm.clicked" ng-click="vm.loadCustomers(vm.branch);vm.clicked=true;">Go</button></div></div></form></div><div class="row"><div class="float-right"><button type="button" class="btn btn-info active" ng-hide="true" ng-click="vm.screenLog.screenLog(vm.screenName,0,vm.entityConstants.ENTITY_ACTION_TYPE.ADD);vm.launch()" ng-show="vm.permitMarkupSettingsAddEntityAction"><img ng-src="assets/images/Add.png"> <span data-translate="global.menu.markupSettings.newMarkup"></span></button></div><div class="float-right col-xs-10 col-sm-3 col-md-2"><cspl-table-search control-model="filterText"></cspl-table-search></div><div class="pull-left"><cspl-table-export table-name="markupSettings" total-record-count="vm.markup.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Markup_Settings"></cspl-table-export></div><div class="pull-left" style="margin-left: 0px" ng-show="vm.permitMarkupSettingsImportEntityAction"><cspl-table-import upload-type="MarkupImport" file-content=""></cspl-table-import></div></div><div class="bootstrap-tableresponsive"><table id="markupSettings" class="dataTable table table-striped table-hover"><thead><tr><th ng-show="vm.entityOwnerType==\'Bank\'" data-translate="gatewayApp.markupSetting.branch">Branch</th><th data-translate="gatewayApp.markupSetting.customerCode">Customer Code</th><th data-translate="gatewayApp.markupSetting.customerName">Customer Name</th><th data-translate="gatewayApp.markupSetting.markupType">Markup Type</th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.markupSetting.markupValue">Markup Value</th><th class="td-text-align-right" data-translate="gatewayApp.markupSetting.taxOnMarkup">Tax on Markup</th><th data-translate="gatewayApp.markupSetting.roEdApplicability">RO/ED Applicability</th><th data-translate="gatewayApp.markupSetting.source">source</th><th class="td-text-align-right" style="padding: 8px 10px"><span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Mark-up applicability for rollover (RO) & early delivery (ED). If selected Both legs means Mark-up will be charged on both legs and Rebooking leg only means Mark-up will be charged only on Rebooking leg." tooltip-position="left"><img class="width-height-20 info-tooltip-icon"></span><!-- <a ng-show="userPreference.showInfoIcon==\'yes\'" id="roEdApplicabilityPop" tabindex="0" data-toggle="popover" role="button" \r\n\t\t\t\t\t\tdata-trigger="focus" data-placement="left" data-content="Mark-up applicability for rollover (RO) & early delivery (ED). If selected Both legs means Mark-up will be charged on both legs and Rebooking leg only means Mark-up will be charged only on Rebooking leg." \r\n\t\t\t\t\t\tdata-template="<div class=\'mainViewPopover popover\' role=\'tooltip\'><div class=\'arrow\'></div><div class=\'popover-content\'></div></div>" >\r\n\t\t\t\t\t\t   <span class="icon"><img class="home-page-help-icon width-height-20" src="assets/images/Info-24.png" /></span>\r\n\t\t\t\t\t\t</a> --></th></tr></thead><tbody><tr ng-repeat="markup in filterData = (vm.markup | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td ng-show="vm.entityOwnerType==\'Bank\'" style="word-break:break-word">{{markup.branch.branchName}}</td><td>{{markup.customer.customerCode}}</td><td style="word-break:break-word" ng-show="markup.customer.customerMiddleName!=null">{{markup.customer.customerFirstName+\' \'+markup.customer.customerMiddleName+\' \'+markup.customer.customerLastName}}</td><td style="word-break:break-word" ng-show="markup.customer.customerMiddleName==null">{{markup.customer.customerFirstName+\' \'+markup.customer.customerLastName}}</td><td>{{markup.markupType}}</td><td ng-show="markup.markupType.toUpperCase()==\'PAISE\'" class="td-text-align-right noPaddingLeftRight">{{(markup.markupValue|number: vm.decimalForPaise)||\'-\'}}</td><td ng-show="markup.markupType.toUpperCase()==\'PERCENTAGE\'" class="td-text-align-right noPaddingLeftRight">{{(markup.markupValue|number: vm.decimalsForPercent)||\'-\'}}</td><td class="td-text-align-right">{{(markup.taxOnMarkup|number:vm.decimalsForPercent)||\'-\'}}</td><td>{{markup.roEdApplicabilityMethod.name}}</td><td>{{markup.sourceAppName}}</td><td width="10%" style="text-align:right"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitMarkupSettingsViewEntityAction"><a ui-sref="markup-view({id:markup.id})" ng-click="vm.screenLog.screenLog(vm.screenName, markup.id, vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitMarkupSettingsEditEntityAction"><a ui-sref="markup-edit({id:markup.id})" ng-click="vm.screenLog.screenLog(vm.screenName, markup.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table><div style="padding:5px" ng-show="vm.markup.length==0"><span>No record found</span></div><div ng-show="vm.markup.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="row"><span class="orderStatusInfo right-floating italic-font" data-translate="gatewayApp.markupSetting.roEdHelpText"></span></div><div class="row"><span class="orderStatusInfo right-floating italic-font" data-translate="gatewayApp.markupSetting.fcyBankFeeNote"></span></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/notification-settings/change-notification-setting.html','<form name="changesettingsForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="{{vm.headerLabel}}"></span></h4></div><div class="modal-body"><div class="content" style="min-height:15vh"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="col-md-4 col-centered" style="margin-top:10px"><div class="row"><label class="control-label" cspl-mandatory><span data-translate="{{vm.labelName}}"></span></label></div><div class="row"><div class="row" ng-show="vm.settingsType.localeCompare(\'yesorno\')==0"><div id="btnGroup" class=""><div class="btn-group"><label class="btn btn-primary" ng-model="vm.settingsValue" ng-disabled="vm.isDisabled" uib-btn-radio="\'Yes\'">Yes</label><label class="btn btn-primary" ng-model="vm.settingsValue" ng-disabled="vm.isDisabled" uib-btn-radio="\'No\'">No&nbsp;</label></div></div></div></div></div><!-- <div class="row">\r\n\t\t\t\t<label class="col-xs-7 col-xs-offset-3 control-label" cspl-mandatory><span\r\n\t\t\t\t\tdata-translate={{vm.labelName}}></span></label>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class="row">\r\n\t\t\t\t<div class="row" ng-show="vm.settingsType.localeCompare(\'yesorno\')==0">\r\n\t\t\t\t\t<div id="btnGroup" class="col-xs-5 col-md-offset-3">\r\n\t\t\t\t\t\t<div class="btn-group">\r\n\t\t\t\t\t\t\t<label class="btn btn-primary" ng-model="vm.settingsValue"\r\n\t\t\t\t\t\t\t\tng-disabled="vm.isDisabled" uib-btn-radio="\'Yes\'">Yes</label> <label\r\n\t\t\t\t\t\t\t\tclass="btn btn-primary" ng-model="vm.settingsValue" ng-disabled="vm.isDisabled"\r\n\t\t\t\t\t\t\t\tuib-btn-radio="\'No\'">No&nbsp;</label>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t</div> --><!-- <div style="margin-right:15px">\r\n\t\t\t\t  <span class="orderStatusInfo" data-translate="gatewayApp.notificationSettings.legend"></span>\r\n\t\t\t\t</div>\t --></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-hide="isShowOkButton" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-info" ng-show="isShowOkButton" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.ok">Ok</span></button> <button type="submit" ng-if="isShowResubmit" class="btn btn-primary" ng-disabled="changesettingsForm.$invalid || vm.clicked" ng-click="vm.clicked=true;vm.resubmitNotificationSettings();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" class="btn btn-info active" ng-if="isShowSaveButton" ng-disabled="changesettingsForm.$invalid || changesettingsForm.$pristine || vm.clicked" ng-click="vm.clicked=true;vm.saveNotificationSettings();"><span data-translate="entity.action.save"></span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardNotificationSettings()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-show="showButton" class="btn btn-reject" ng-click="vm.rejectNotificationSettings()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.clicked=true;vm.approveNotificationSettings();" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div><script type="text/javascript">$(\'.clockpicker\').clockpicker({\r\n\t\t\tafterDone : function() {\r\n\t\t\t\tclockpicker.val(round());\r\n\t\t\t}\r\n\t\t}).find(\'input\');</script></form>');
$templateCache.put('app/entities/notification-settings/notification-settings.html','<form name="notificationSettingsForm" role="form" novalidate><script src="app/app.module.js"></script><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="global.menu.notificationSettings.title"></span></h4></div><div class="modal-body"><div class="content" style="min-height:35vh"><nmb-alert></nmb-alert><div class="column" style="background-color: #000000; width: 30%;margin-top:20px"><div class="tab"><br><div class="img-with-text"><img src="assets/images/OrderSettingsCurrent.png" ng-show="vm.isShowOrderSettings" style="width: 40px; height: 40px"> <img src="assets/images/OrderSettings.png" ng-show="!vm.isShowOrderSettings" style="width: 40px; height: 40px" ng-click="vm.isShowOrderSettings=true;"><p style="text-align: center">Order Settings</p></div><br></div></div><div class="column" style="background-color: #000000; width: 70%;margin-top:40px"><div id="OrderSettings" ng-show="vm.isShowOrderSettings"><div class="row"><label class="col-xs-7 col-xs-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.notificationSettings.tradeEmailToBeSent"></span></label></div><div class="row"><div id="btnGroup" class="col-xs-4 col-xs-offset-1" style="padding-bottom:7px"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.notificationSettings.IsTradeEmailToBeSent" ng-disabled="true" uib-btn-radio="\'Yes\'">Yes</label><label class="btn btn-primary" ng-model="vm.notificationSettings.IsTradeEmailToBeSent" ng-disabled="true" uib-btn-radio="\'No\'">No&nbsp;</label></div></div><a style="text-decoration: none" title="Change Settings" ui-sref="change-notification-settings({headerLabel: \'Order Settings\',labelName: \'{{\'gatewayApp.notificationSettings.tradeEmailToBeSent\' | translate}}\' ,settingsName: \'IsTradeEmailToBeSent\' , settingsValue: vm.notificationSettings.IsTradeEmailToBeSent, settingsType : \'yesorno\', screenName : \'bankdealingadmin\'})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px;margin-top:6px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div></div></div></div></div><script>//$("#btntab1").focus();\r\n\t\topenTab(event, \'OrderSettings\');\r\n\r\n\t\tfunction openTab(evt, tabName) {\r\n\t\t\tvar i, tabcontent, tablinks;\r\n\t\t\ttabcontent = document.getElementsByClassName("tabcontent");\r\n\t\t\tfor (i = 0; i < tabcontent.length; i++) {\r\n\t\t\t\ttabcontent[i].style.display = "none";\r\n\t\t\t}\r\n\t\t\ttablinks = document.getElementsByClassName("tablinks");\r\n\t\t\tfor (i = 0; i < tablinks.length; i++) {\r\n\t\t\t\ttablinks[i].className = tablinks[i].className.replace(\r\n\t\t\t\t\t\t" active", "");\r\n\t\t\t}\r\n\t\t\tdocument.getElementById(tabName).style.display = "block";\r\n\t\t\t//evt.currentTarget.className += " active";\r\n\t\t}</script></form>');
$templateCache.put('app/entities/order-activity-log/order-activity-log.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.orderActivityLog.title"></span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><form class="" role="form" name="orderActivityLogForm"><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\'"><label class="control-label"><span data-translate="gatewayApp.orderActivityLog.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bank" display-column="bankName" placeholder="" form="orderActivityLogForm"></div><div class="form-group" ng-if="vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'"><label class="control-label"><span data-translate="gatewayApp.orderActivityLog.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtTradingbank" lookup-name="tradingBank" display-column="shortName" placeholder="" form="orderActivityLogForm" filter-value="{{vm.loggedInCustomer}}"></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\'"><label class="control-label"><span data-translate="gatewayApp.orderActivityLog.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="branchesForBank" display-column="branchName" placeholder="" form="orderActivityLogForm" filter-value="{{vm.bank.id}}"></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\'"><label class="control-label"><span data-translate="gatewayApp.orderActivityLog.customer"></span></label><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="allTypeCustomers" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" control-place-holder="Enter Customer ID or Name" display-column="customerCode,customerName" placeholder="" form="orderActivityLogForm"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.orderActivityLog.currencyPair"></span></label><cspl-ach control-model="vm.currencyPair" control-id="txtCurrencyPair" lookup-name="currencyPair" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}" control-place-holder="Enter Currency Pair" display-column="code" placeholder="" form="orderActivityLogForm"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.orderActivityLog.instrument"></span></label><cspl-ach control-model="vm.instrument" control-id="txtInstrument" lookup-name="marketInstrumentsCurrency" filter-value="{{ vm.currencyPair.id ? vm.currencyPair.id : 0 }}" display-column="instrumentCode" placeholder="" form="orderActivityLogForm"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.orderActivityLog.downloadFileType"></span></label><select class="form-control select-style select-notRequired" name="downloadFileType" ng-model="vm.downloadFileType" ng-options="downloadFileTypeIndicators for downloadFileTypeIndicators in vm.downloadFileTypeIndicators" form="orderActivityLogForm"></select></div></div><div class="form-group"><div class="row"><label class="col-md-offset-3 control-label col-xs-6 col-md-6" cspl-mandatory><span data-translate="gatewayApp.orderActivityLog.reportDate"></span></label><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><cspl-dtp control-model="vm.reportDate" control-id="dtpdate" control-min-date="vm.minDate" control-max-date="vm.maxDate" control-required="true"></cspl-dtp></div><div class="col-md-1 col-sm-1"><button class="btn btn-info active" data-translate="gatewayApp.orderActivityLog.download" ng-disabled="orderActivityLogForm.$invalid||vm.clicked" ng-click="vm.exportOrderActivityLogToFiles()" data-target="#OrderActivityLogLogReport"></button></div></div></div></form></div></div></section></div></div>');
$templateCache.put('app/entities/order-activity/order-activity.html','<form name="orderActivityForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="global.menu.orderActivityReport.title" data-translate-values="{value: {{vm.todayDate}}}"></span></h4></div><div class="modal-body"><div class="content"><div class="row"><cspl-table-export class="col-md-1 col-sm-1 col-xs-1" table-name="orderActivity" total-record-count="filterData.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="Order_Activity"></cspl-table-export><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><fieldset><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="orderActivity" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.orderActivity.bank"></th><th data-translate="gatewayApp.orderActivity.branch"></th><th data-translate="gatewayApp.orderActivity.branchId"></th><th data-translate="gatewayApp.orderActivity.custId"></th><th data-translate="gatewayApp.orderActivity.customer"></th><th data-translate="gatewayApp.orderActivity.currencyPair"></th><th data-translate="gatewayApp.orderActivity.instrument"></th><th data-translate="gatewayApp.orderActivity.orderType"></th><th data-translate="gatewayApp.orderActivity.buySell"></th><th data-translate="gatewayApp.orderActivity.settlementLegName"></th><th data-translate="gatewayApp.orderActivity.settlementStartDate"></th><th data-translate="gatewayApp.orderActivity.settlementDate"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.orderActivity.orderQuantity"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.orderActivity.tradedQuantity"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.orderActivity.pendingOrderQuantity"></th><th data-translate="gatewayApp.orderActivity.priceCondition"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.orderActivity.orderPrice"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.orderActivity.equivalentSpotPrice"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.orderActivity.swapPtsInPaise"></th><th data-translate="gatewayApp.orderActivity.timeCondition"></th><th data-translate="gatewayApp.orderActivity.orderDateTime"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.orderActivity.tradePrice"></th><th data-translate="gatewayApp.orderActivity.orderNumber"></th><th data-translate="gatewayApp.orderActivity.tradeNumber"></th><th data-translate="gatewayApp.orderActivity.sourceTradeNo"></th><th data-translate="gatewayApp.orderActivity.orderStatus"></th><th data-translate="gatewayApp.orderActivity.action"></th><th data-translate="gatewayApp.orderActivity.actionBy"></th><th data-translate="gatewayApp.orderActivity.actionDateTime"></th><th data-translate="gatewayApp.orderActivity.gttTime"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.orderActivity.triggerPrice"></th><th data-translate="gatewayApp.orderActivity.internalRemarks"></th><th data-translate="gatewayApp.orderActivity.exposureType"></th><th data-translate="gatewayApp.orderActivity.exposureSubType"></th><th style="min-width:360px" data-translate="gatewayApp.orderActivity.userRemarks1"></th><th style="min-width:360px" data-translate="gatewayApp.orderActivity.userRemarks2"></th><th style="min-width:360px" data-translate="gatewayApp.orderActivity.userRemarks3"></th><th style="min-width:360px" data-translate="gatewayApp.orderActivity.userRemarks4"></th><th data-translate="gatewayApp.orderActivity.placedAsSplitOrder"></th><th data-translate="gatewayApp.orderActivity.deliveryMode"></th><th data-translate="gatewayApp.orderActivity.source"></th></tr></thead><tbody><tr ng-repeat="orderActivity in filterData = (vm.orderActivityDetails | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{orderActivity.bankName}}</td><td>{{orderActivity.branchName}}</td><td>{{orderActivity.branchId}}</td><td>{{orderActivity.customerCode}}</td><td ng-if="orderActivity.customerMiddleName!=null && orderActivity.customerMiddleName!=\'\' && orderActivity.customerMiddleName!=undefined">{{orderActivity.customerFirstName + \' \' + orderActivity.customerMiddleName + \' \' + orderActivity.customerLastName}}</td><td ng-if="orderActivity.customerMiddleName==null || orderActivity.customerMiddleName==\'\' || orderActivity.customerMiddleName==undefined">{{orderActivity.customerFirstName + \' \' + orderActivity.customerLastName}}</td><td>{{orderActivity.currencyPairCode}}</td><td>{{orderActivity.instrumentCode}}</td><td>{{orderActivity.eventTypeName}}</td><td>{{orderActivity.buySellFlag}}</td><td>{{orderActivity.settlementLegName}}</td><td><span ng-if="orderActivity.tradeSettlementDateFrom!=null && orderActivity.tradeSettlementDateFrom!=undefined">{{orderActivity.tradeSettlementDateFrom | date:\'dd-MMM-yyyy\'}}</span><span ng-if="orderActivity.tradeSettlementDateFrom==null || orderActivity.tradeSettlementDateFrom==undefined"></span></td><td><span ng-if="orderActivity.tradeSettlementDate!=null && orderActivity.tradeSettlementDate!=undefined">{{orderActivity.tradeSettlementDate | date:\'dd-MMM-yyyy\'}}</span><span ng-if="orderActivity.tradeSettlementDate==null || orderActivity.tradeSettlementDate==undefined">-</span></td><td class="td-text-align-right noPaddingLeftRight">{{orderActivity.orderAmount | currency:"" : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right" style="padding-right:10px">{{orderActivity.tradedAmount| currency:"" : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right" style="padding-right:10px">{{orderActivity.remainingAmount| currency:"" : vm.noOfDecimalsForAmount }}</td><td align="center">{{orderActivity.priceConditionName}}</td><td class="td-text-align-right" style="padding-right:10px">{{orderActivity.limitExchangeRate| currency:"" : vm.noOfDecimalsForRate}}</td><td class="td-text-align-right noPaddingLeftRight">{{orderActivity.retailEquivalentSpotLimitPrice| currency:"" : vm.noOfDecimalsForRate}}</td><td class="td-text-align-right" style="padding-right:10px">{{vm.getSwapPoints(orderActivity.retailEquivalentSpotLimitPrice, orderActivity.limitExchangeRate) | currency:"" : vm.noOfDecimalsForAmount}}</td><td align="center"><span ng-show="orderActivity.timeLimitIndicator==\'DAYY\' || orderActivity.timeLimitIndicator==\'DAY\'">Day</span> <span ng-show="orderActivity.timeLimitIndicator==\'IOCC\' || orderActivity.timeLimitIndicator==\'IOC\'">IOC</span> <span ng-show="orderActivity.timeLimitIndicator==\'GTTM\' || orderActivity.timeLimitIndicator==\'GTT\'">GTT</span></td><td ng-show="orderActivity.orderStatusName!=\'Risk Validated\'" nowrap="nowrap">{{orderActivity.revisionTimeStamp | date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td ng-show="orderActivity.orderStatusName==\'Risk Validated\'" nowrap="nowrap">{{orderActivity.lastModifiedDateTime| date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td class="td-text-align-right noPaddingLeftRight">{{orderActivity.tradeExchangeRate | currency: "" : vm.noOfDecimalsForRate}}</td><td>{{orderActivity.orderSequenceNumber}}</td><td>{{orderActivity.tradeSequenceNumber||\'-\'}}</td><td ng-if="orderActivity.sourceTradeNo != null && orderActivity.sourceTradeNo != 0">{{orderActivity.sourceTradeNo}}</td><td ng-if="!(orderActivity.sourceTradeNo != null && orderActivity.sourceTradeNo != 0)">{{\' \'}}</td><td>{{orderActivity.orderStatusName}}</td><td>{{orderActivity.activityIndicator}}</td><td>{{orderActivity.retailUserLogin}}</td><td nowrap="nowrap">{{orderActivity.lastModifiedDateTime | date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td ng-class="{ \'td-text-align-center\': orderActivity.expiryTime==null}">{{(orderActivity.expiryTime | date:\'HH:mm\')||\'-\'}}</td><td ng-class="{ \'td-text-align-center\': orderActivity.stopExchangeRate==null, \'td-text-align-right\' : orderActivity.stopExchangeRate!=null}" style="padding-right:10px">{{(orderActivity.stopExchangeRate| currency:"" : vm.noOfDecimalsForRate)||\'-\'}}</td><td>{{orderActivity.internalRemarks||\'-\'}}</td><td>{{orderActivity.exposureType || \'-\'}}</td><td>{{orderActivity.exposureSubType || \'-\'}}</td><td style="min-width:360px">{{orderActivity.remarks||\'-\'}}</td><td style="min-width:360px">{{orderActivity.remarks2||\'-\'}}</td><td style="min-width:360px">{{orderActivity.remarks3||\'-\'}}</td><td style="min-width:360px">{{orderActivity.remarks4||\'-\'}}</td><td nowrap="nowrap" ng-show="orderActivity.isSplitOrder==true">Yes</td><td nowrap="nowrap" ng-show="orderActivity.isSplitOrder==false">No</td><td>{{orderActivity.deliveryMode}}</td><td>{{orderActivity.sourceAppName}}</td></tr></tbody></table></div><div ng-show="vm.orderActivityDetails.length > 0"><span class="help-block right-floating" data-translate="gatewayApp.orderActivity.originalTradeLegend"></span></div><div ng-show="vm.orderActivityDetails.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button></div></div></form>');
$templateCache.put('app/entities/order-config/order-config.html','<style>.red{\r\n\tborder: 1px solid #FF3737 !important;\r\n}</style><form name="orderConfigForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="gatewayApp.orderConfig.title"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="content"><div class="user-profile"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseUserProfile = !vm.ExpandOrCollapseUserProfile" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseone"><img ng-src="{{vm.ExpandOrCollapseUserProfile == false && \'assets/images/Accordion_collapse.png\' ||\'assets/images/Accordion_expand.png\'}}"> &nbsp; <span class="nav-label">User Preference</span></a></h4></div><div id="collapseone" class="panel-collapse collapse" style="background-color: black"><div class="accordion-content1"><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.defaultInstrumentPreference"></span></label></div><div class="row"><div id="btnGroup" class="col-md-10 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.userprofile.userInstrumentCode" uib-btn-radio="\'SPOT\'">SPOT</label><label class="btn btn-primary" ng-model="vm.userprofile.userInstrumentCode" uib-btn-radio="\'TOM\'">TOM&nbsp;</label><label class="btn btn-primary" ng-model="vm.userprofile.userInstrumentCode" uib-btn-radio="\'CASH\'">CASH&nbsp;</label><label class="btn btn-primary" ng-model="vm.userprofile.userInstrumentCode" uib-btn-radio="\'Forward\'">FORWARD&nbsp;</label></div></div></div><div class="row" style="margin-top:15px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.priceCondition"></span></label></div><div class="row"><div id="btnGroup" class="col-md-10 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.userprofile.userPriceCondition" uib-btn-radio="\'LIMT\'">Limit&nbsp;</label><label class="btn btn-primary" ng-model="vm.userprofile.userPriceCondition" ng-disabled="vm.isAllowMarketOrder!=\'Yes\'" uib-btn-radio="\'MRKT\'">Market&nbsp;</label><label class="btn btn-primary" ng-model="vm.userprofile.userPriceCondition" ng-disabled="vm.isAllowStopLoss!=\'Yes\'" uib-btn-radio="\'STLS\'">Stop Loss&nbsp;</label><label class="btn btn-primary" ng-model="vm.userprofile.userPriceCondition" ng-disabled="vm.isAllowTakeProfit!=\'Yes\'" uib-btn-radio="\'TKPR\'">Take Profit&nbsp;</label></div></div></div><div class="row" style="margin-top:15px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.timeCondition"></span></label></div><div class="row"><div id="btnGroup" class="col-md-6 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.userprofile.userTimeCondition" uib-btn-radio="\'DAYY\'">Day</label><label class="btn btn-primary" ng-model="vm.userprofile.userTimeCondition" uib-btn-radio="\'IOCC\'">IOC&nbsp;</label><label class="btn btn-primary" ng-model="vm.userprofile.userTimeCondition" uib-btn-radio="\'GTTM\'">GTT&nbsp;</label></div></div></div><div class="row" style="margin-top:15px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.orderValue"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-1"><cspl-numeric control-model="vm.userprofile.userOrderValue" control-min="0" control-max="999999999.99" control-id="txtorderValue" no-of-decimals="{{vm.noOfDecimalsForAmount}}" form="orderConfigForm" control-value-change="vm.validateOrderValue(vm.userprofile.userOrderValue)" currency-code="" required></cspl-numeric><span class="help-block-error" ng-show="vm.errorText1!=\'\'">{{vm.errorText1}}</span></div><span class="label-profile" style="display: block;padding-top:7px">USD/FCY</span></div><div class="row" style="margin-top:7px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.defaultExposureType"></span></label></div><div class="row"><div class="col-md-10 col-md-offset-1"><select class="form-control select-style" control-id="selExposureType" ng-model="vm.exposureType" name="exposureType" ng-options="exposureType.name for exposureType in vm.exposureTypes track by exposureType.id" ng-class="{red: orderConfigForm.exposureType.$invalid}" form="orderConfigForm" required></select><span class="help-block-error" ng-show="orderConfigForm.exposureType.$invalid">This field cannot be left blank</span></div></div><div class="row" style="margin-top:15px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.defaultExposureSubType"></span></label></div><div class="row"><div class="col-md-10 col-md-offset-1"><select class="form-control select-style" control-id="selExposureSubType" ng-model="vm.exposureSubType" name="exposureSubType" ng-options="exposureSubType.name for exposureSubType in vm.exposureSubTypes track by exposureSubType.id" ng-class="{red: orderConfigForm.exposureSubType.$invalid}" form="orderConfigForm" required></select><span class="help-block-error" ng-show="orderConfigForm.exposureSubType.$invalid">This field cannot be left blank</span></div></div><br></div></div><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseCurrencyPreferences = !vm.ExpandOrCollapseCurrencyPreferences" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseFive"><img ng-src="{{vm.ExpandOrCollapseCurrencyPreferences == false && \'assets/images/Accordion_collapse.png\' ||\'assets/images/Accordion_expand.png\'}}"> &nbsp; <span class="nav-label">Currency Wise User Preference</span></a></h4></div><div id="collapseFive" class="panel-collapse collapse" style="background-color: black"><div class="accordion-content1"><!-- <div class="row">\r\n\t\t\t\t\t\t\t<label class=" control-label   col-xs-1 col-md-1" style="margin-top: 3px;"><span\r\n\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.currencyPair"></span></label>\r\n\r\n\t\t\t\t\t\t\t<div class="col-md-5 col-sm-6 col-xs-10 col-lg-3">\r\n\t\t\t\t\t\t\t\t<cspl-ach control-model="vm.currencyPair" control-id="txtCurrencyPair"\r\n\t\t\t\t\t\t\t\t\tlookup-name="currencyPair" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}"\r\n\t\t\t\t\t\t\t\t\tcontrol-place-holder="Enter Currency Pair" display-column="code" placeholder=""\r\n\t\t\t\t\t\t\t\t\tform="configurationSettingsForm" />\r\n\t\t\t\t\t\t\t</div>--><div class="row" style="margin-top:7px"><label class="col-md-11 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.currencyPair"></span></label></div><div class="row"><div class="col-md-5 col-md-offset-1"><cspl-ach control-model="vm.currencyPair" lookup-name="currencyPair" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}" control-id="txtCurrencyPair" display-column="code" control-place-holder="Enter Currency Pair" form="myPreferencesForm" currency-code=""></cspl-ach></div><div class="col-md-1 col-sm-1"><button class="btn btn-info active" ng-disabled=" vm.currencyPair==null ||vm.clicked" ng-click="vm.getCurrencyWiseUserPreference(vm.currencyPair);vm.clicked=true;" data-toggle="collapse" data-target="#MarketMovement" data-translate="gatewayApp.userProfile.go"></button></div></div><div ng-if="vm.currencyWiseUserPreferenceSettings !=null && vm.currencyWiseUserPreferenceSettings !=undefined "><div class="row" style="margin-top:7px"><label class="col-md-11 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.allowedOrderPriceDeviationFromMarketPriceInPercentage"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.currencyWiseUserPreferenceSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage" control-min="0" control-max="100" control-id="txtpriceDeviationInPercent" no-of-decimals="{{vm.noOfDecimalsForPercent}}" form="myPreferencesForm" control-value-change="vm.validateAllowedOrderPriceDeviationFromMarketPriceInPercentage(vm.currencyWiseUserPreferenceSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage)" currency-code="" required></cspl-numeric><span class="help-block-error" ng-show="vm.errorText2!=\'\'">{{vm.errorText2}}</span></div><span class="label-profile" style="display: block;padding-top:7px">%</span></div><div class="row" style="margin-top:7px"><label class="col-md-11 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.allowedOrderPriceDeviationFromMarketPriceInPaise"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.currencyWiseUserPreferenceSettings.allowedOrderPriceDeviationFromMarketPriceInPaise" control-min="0" control-max="999" control-id="txtpriceDeviationInPaise" no-of-decimals="{{vm.noOfDecimalsForPaise}}" form="myPreferencesForm" control-value-change="vm.validateAllowedOrderPriceDeviationFromMarketPriceInPaise(vm.currencyWiseUserPreferenceSettings.allowedOrderPriceDeviationFromMarketPriceInPaise)" currency-code="" required></cspl-numeric><span class="help-block-error" ng-show="vm.errorText5!=\'\'">{{vm.errorText5}}</span></div><span class="label-profile" style="display: block;padding-top:7px">Paise</span></div><div class="row" style="margin-top:7px"><label class="col-md-11 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.maximumOrderValueHardCheck"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-1"><cspl-numeric control-model="vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck" control-min="0" control-max="999999999.99" control-id="txtmaximumOrderValueHardCheck" no-of-decimals="{{vm.noOfDecimalsForAmount}}" form="myPreferencesForm" control-value-change="vm.validateMaximumOrderValueHardCheck(vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck)" currency-code="" required></cspl-numeric><span class="help-block-error" ng-show="vm.errorText3!=\'\'">{{vm.errorText3}}</span></div><span class="label-profile" style="display: block;padding-top:7px">{{vm.currencyWiseUserPreferenceSettings.currencyPair.code}}</span></div><div class="row" style="margin-top:7px"><label class="col-md-11 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.maximumOrderValueSoftCheck"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-1"><cspl-numeric control-model="vm.currencyWiseUserPreferenceSettings.maximumOrderValueSoftCheck" control-min="0" control-max="999999999.99" control-id="txtmaximumOrderValueSoftCheck" no-of-decimals="{{vm.noOfDecimalsForAmount}}" form="myPreferencesForm" control-value-change="vm.validateMaximumOrderValueSoftCheck(vm.currencyWiseUserPreferenceSettings.maximumOrderValueSoftCheck)" currency-code="" required></cspl-numeric><span class="help-block-error" ng-show="vm.errorText4!=\'\'">{{vm.errorText4}}</span></div><span class="label-profile" style="display: block;padding-top:7px">{{vm.currencyWiseUserPreferenceSettings.currencyPair.code}}</span></div></div></div></div></div></div><div class="modal-footer"><!-- <button type="button" class="btn btn-info" data-dismiss="modal"\r\n\t\t\t\tng-click="vm.clear()" tabindex="-1">\r\n\t\t\t\t<span>Close</span>\r\n\t\t\t</button> --> <button type="submit" ng-disabled="orderConfigForm.$invalid || clicked || vm.errorText1!=\'\' || vm.errorText2!=\'\' || vm.errorText3!=\'\' || vm.errorText4!=\'\' || vm.errorText5!=\'\'" class="btn btn-info active" ng-click="clicked = true; vm.save();"><span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/order-server-manual-login/order-server-manual-login.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.orderServerManualLogin.title">Order Server Manual Login</h2><nmb-alert></nmb-alert><div></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="OrderServerManualLogin" style="text-align:center" class="row"><br><div class="col-md-6" style="text-align:right"><button class="btn btn-info active" ng-click="vm.orderServerManualLogin();vm.screenLog.screenLog(vm.screenName, 1, vm.entityConstants.ENTITY_ACTION_TYPE.LOGIN)" data-translate="global.menu.orderServerManualLogin.startRecovery">Start Recovery</button></div><div class="col-md-6" style="text-align:left"><span ng-show="vm.orderServerManualLoginStatus==\'PROGRESS\'"><img class="ProgressStatusImage" src="assets/images/Progress_bar.GIF"> </span><span ng-show="vm.orderServerManualLoginStatus==\'SUCCESS\'"><img class="statusImage" src="assets/images/EOD_Process_Success.png"> </span><span ng-show="vm.orderServerManualLoginStatus==\'FAILURE\'"><img class="statusImage" src="assets/images/EOD_Process_Error.png"></span></div></div></div></section></div></div>');
$templateCache.put('app/entities/order-upload/order-upload.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.orderUpload.title">Order Upload</span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><form class="" role="form" name="orderUploadForm"><div class="col-md-offset-3 col-md-6" style="margin-top:20px"><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-10"><label class="control-label" style="float: left"><span data-translate="gatewayApp.orderUpload.uploadOrderFile"></span></label><div class="col-md-6" style="position: relative;transform: translateY(-40%); z-index: 5"><div class="dropdown" style="width:10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border:none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.downloadOrderTemplate();">Download Template</a></li></ul></div></div></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-7" style="margin-bottom:8px;padding-bottom:6px"><div class="input-group"><input type="text" class="form-control fileOpen" ng-model="vm.inputFile" readonly="readonly"><label for="orderUpload" class="btn btn-primary fileUploadDark" ng-class="{\'block-upload\' : vm.selectedFilter == \'download\'}"><img src="assets/images/Open Path-26.png" style="height:20px;padding-bottom:2px;pointer-events:none"></label><input type="file" id="orderUpload" name="orderUpload" fileread="vm.orderUpload" accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" form="orderUploadForm" ng-hide="true"></div></div><div class="col-md-1"><button class="btn btn-info active" ng-disabled="vm.inputFile == null || vm.inputFile == undefined || vm.clicked" ng-click="vm.uploadOrderFile();vm.screenLog.screenLog(vm.screenName, 0 , vm.entityConstants.ENTITY_ACTION_TYPE.IMPORT)" data-translate="gatewayApp.orderUpload.upload"></button></div></div></div></form></div></div></section></div></div>');
$templateCache.put('app/entities/order-status-report/order-status-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.orderStatusReport.title" data-translate-values="{value: {{vm.todayDate}}}">Order Status Report</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px;  margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseOrderStatusReport = !vm.ExpandOrCollapseOrderStatusReport" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#OrderStatusReport"><img ng-src="{{vm.ExpandOrCollapseOrderStatusReport == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.orderStatusReport.criteria">Criteria</span></a></h4></div><div id="OrderStatusReport" class="collapse in" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="orderStatusReportForm"><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\'"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.orderStatusReport.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bank" display-column="bankName" placeholder="" form="orderStatusReportForm" control-required="vm.entityOwnerType==\'Clearcorp\'"></div><div class="form-group" ng-if="vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'"><label class="control-label"><span data-translate="gatewayApp.orderStatusReport.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtTradingbank" lookup-name="tradingBank" display-column="shortName" placeholder="" form="orderStatusReportForm" filter-value="{{vm.loggedInCustomer}}"></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\'"><label class="control-label"><span data-translate="gatewayApp.orderStatusReport.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="activeBranchesForBank" display-column="branchName" placeholder="" form="orderStatusReportForm" filter-value="{{vm.bank.id}}"></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\'"><label class="control-label"><span data-translate="gatewayApp.orderStatusReport.customer"></span></label><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="allTypeCustomers" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" control-place-holder="Enter Customer ID or Name" display-column="customerCode,customerName" placeholder="" form="orderStatusReportForm"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.orderStatusReport.currencyPair"></span></label><cspl-ach control-model="vm.currencyPair" control-id="txtCurrencyPair" lookup-name="currencyPair" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}" control-place-holder="Enter Currency Pair" display-column="code" placeholder="" form="orderStatusReportForm"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.orderStatusReport.instrument"></span></label><!-- <cspl-ach control-model="vm.instrument" control-id="txtInstrument"\t lookup-name="marketInstruments" \r\n\t\t\t\t\t\t\t\t\t\tdisplay-column="instrumentName" placeholder="" form="orderStatusReportForm" /> --><select name="select" class="form-control select-style non-mandatory" ng-model="vm.instrument" style="border-color:#595959" ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id"><option value="">--All--</option></select></div></div><div class="form-group"><div class="row"><label class="col-md-offset-3 control-label col-xs-6 col-md-6"><span data-translate="gatewayApp.orderStatusReport.orderStatus"></span></label><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><!-- <cspl-ach control-model="vm.orderStatus" control-id="txtOrderStatus"\t lookup-name="orderStatus" \r\n\t\t\t\t\t\t\t\t\t\tdisplay-column="name" placeholder="" form="orderStatusReportForm" />  --><select name="txtOrderStatus" class="form-control select-style non-mandatory" ng-model="vm.orderStatus" style="border-color:#595959" ng-options="orderStatus.name for orderStatus in vm.orderStatusList track by orderStatus.id"><option value="">--All--</option></select></div><div class="col-md-1 col-sm-1"><button class="btn btn-info active" ng-disabled="orderStatusReportForm.$invalid||vm.clicked;" ng-click="vm.getOrderStatusDetails();vm.clicked=true;" data-toggle="collapse" data-target="#OrderStatusReport" data-translate="gatewayApp.orderStatusReport.go"></button></div></div></div></form></div></div></div><div ng-show="vm.orderStatusDetails.length > 0"><div class="row"><div class="up-btn"><div class="dropdown" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportDataToCsvFile(filterData.length,noOfRecordsPerPage,page)">CSV</a></li><li><a ng-click="vm.exportDataToExcelFile(filterData.length,noOfRecordsPerPage,page);">XLS</a></li><li><a ng-click="vm.exportDataToPdfFile()">PDF</a></li></ul></div></div><!-- <cspl-table-export class="col-md-1 col-sm-1 col-xs-1" table-name="orderStatusReport" total-record-count="filterData.length" \r\n                    \tno-of-records-per-page="noOfRecordsPerPage"  page-no="page"  file-name="Order_Status_Report"></cspl-table-export> --><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="orderStatusReport" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.orderStatusReport.bank"></th><th data-translate="gatewayApp.orderStatusReport.branch"></th><th data-translate="gatewayApp.orderStatusReport.branchId"></th><th data-translate="gatewayApp.orderStatusReport.custId"></th><th data-translate="gatewayApp.orderStatusReport.customer"></th><th data-translate="gatewayApp.orderStatusReport.currencyPair"></th><th data-translate="gatewayApp.orderStatusReport.instrument"></th><th data-translate="gatewayApp.orderStatusReport.orderType"></th><th data-translate="gatewayApp.orderStatusReport.buySell"></th><th data-translate="gatewayApp.orderStatusReport.settlementStartDate"></th><th data-translate="gatewayApp.orderStatusReport.settlementDate"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.orderStatusReport.orderQuantity"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.orderStatusReport.tradedQuantity"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.orderStatusReport.pendingOrderQuantity"></th><th data-translate="gatewayApp.orderStatusReport.priceCondition"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.orderStatusReport.orderPrice"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.orderStatusReport.equivalentSpotPrice"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.orderStatusReport.swapPtsInPaise"></th><th data-translate="gatewayApp.orderStatusReport.timeCondition"></th><th data-translate="gatewayApp.orderStatusReport.orderDateTime"></th><th data-translate="gatewayApp.orderStatusReport.orderNumber"></th><th data-translate="gatewayApp.orderStatusReport.tradeNumber"></th><th data-translate="gatewayApp.orderStatusReport.sourceTradeNo"></th><th data-translate="gatewayApp.orderStatusReport.exposureType"></th><th data-translate="gatewayApp.orderStatusReport.exposureSubType"></th><th style="min-width:360px" data-translate="gatewayApp.orderStatusReport.userRemarks1"></th><th style="min-width:360px" data-translate="gatewayApp.orderStatusReport.userRemarks2"></th><th style="min-width:360px" data-translate="gatewayApp.orderStatusReport.userRemarks3"></th><th style="min-width:360px" data-translate="gatewayApp.orderStatusReport.userRemarks4"></th><th data-translate="gatewayApp.orderStatusReport.orderStatus"></th><th data-translate="gatewayApp.orderStatusReport.gttTime"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.orderStatusReport.triggerPrice"></th><th data-translate="gatewayApp.orderStatusReport.lastActionedBy"></th><th data-translate="gatewayApp.orderStatusReport.placedAsSplitOrder"></th><th data-translate="gatewayApp.orderStatusReport.deliveryMode"></th><th data-translate="gatewayApp.orderStatusReport.source"></th></tr></thead><tbody><tr ng-repeat="orderStatus in filterData = (vm.orderStatusDetails | filter : filterText | orderBy: \'-orderSequenceNumber\')| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{orderStatus.bank.bankName}}</td><td>{{orderStatus.branch.branchName}}</td><td>{{orderStatus.branch.branchId}}</td><td>{{orderStatus.customer.customerCode}}</td><td ng-if="orderStatus.customer.customerMiddleName!=null && orderStatus.customer.customerMiddleName!=\'\' && orderStatus.customer.customerMiddleName!=undefined">{{orderStatus.customer.customerFirstName + \' \' + orderStatus.customer.customerMiddleName + \' \' + orderStatus.customer.customerLastName}}</td><td ng-if="orderStatus.customer.customerMiddleName==null || orderStatus.customer.customerMiddleName==\'\' || orderStatus.customer.customerMiddleName==undefined">{{orderStatus.customer.customerFirstName + \' \' + orderStatus.customer.customerLastName}}</td><td>{{orderStatus.currencyPair.code}}</td><td>{{orderStatus.instrument.instrumentCode}}</td><td>{{orderStatus.eventType.name}}</td><td>{{orderStatus.buySellFlag}}</td><td><span ng-if="orderStatus.tradeSettlementDateFrom !=null">{{orderStatus.tradeSettlementDateFrom| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="orderStatus.tradeSettlementDateFrom ==null">{{\'\'}}</span></td><td><span ng-if="orderStatus.tradeSettlementDate!=null && orderStatus.tradeSettlementDate!=undefined">{{orderStatus.tradeSettlementDate | date:\'dd-MMM-yyyy\'}}</span><span ng-if="orderStatus.tradeSettlementDate==null || orderStatus.tradeSettlementDate==undefined">-</span></td><td class="td-text-align-right noPaddingLeftRight">{{(orderStatus.pendingOrderAmount + orderStatus.tradeAmount) | currency:"" : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right" style="padding-right:10px">{{orderStatus.tradeAmount| currency:"" : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right" style="padding-right:10px">{{orderStatus.pendingOrderAmount| currency:"" : vm.noOfDecimalsForAmount}}</td><td>{{orderStatus.priceCondition.name}}</td><td class="td-text-align-right" style="padding-right:10px">{{orderStatus.limitExchangeRate| currency:"" : vm.noOfDecimalsForRate}}</td><td class="td-text-align-right noPaddingLeftRight">{{orderStatus.retailEquivalentSpotLimitExchangeRate| currency:"" : vm.noOfDecimalsForRate}}</td><td class="td-text-align-right" style="padding-right:10px">{{vm.getSwapPoints(orderStatus.retailEquivalentSpotLimitExchangeRate, orderStatus.limitExchangeRate) | currency:"" : vm.noOfDecimalsForAmount}}</td><td align="center">{{orderStatus.timeCondition}}</td><td nowrap="nowrap" ng-show="orderStatus.orderStatus.name==\'Risk Validated\'">{{orderStatus.lastModifiedDate | date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td nowrap="nowrap" ng-show="orderStatus.orderStatus.name!=\'Risk Validated\'">{{orderStatus.revisionTimeStamp | date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td><a ui-sref="order-activity({orderNumber:orderStatus.orderSequenceNumber})" style="text-decoration:underline">{{orderStatus.orderSequenceNumber}}</a></td><td>{{orderStatus.lastTradeSequenceNumber||\'-\'}}</td><td ng-if="orderStatus.sourceTradeNumber != null && orderStatus.sourceTradeNumber != 0"><a ui-sref="order-activity({orderNumber:orderStatus.sourceorderNumber})" style="text-decoration:underline">{{orderStatus.sourceTradeNumber}}</a></td><td ng-if="!(orderStatus.sourceTradeNumber != null && orderStatus.sourceTradeNumber != 0)">{{\' \'}}</td><td>{{orderStatus.exposureType.name || \'-\'}}</td><td>{{orderStatus.exposureSubType.name || \'-\'}}</td><td style="min-width:360px">{{orderStatus.userRemarks || \'-\'}}</td><td style="min-width:360px">{{orderStatus.remarks2 || \'-\'}}</td><td style="min-width:360px">{{orderStatus.remarks3 || \'-\'}}</td><td style="min-width:360px">{{orderStatus.remarks4 || \'-\'}}</td><td align="center">{{orderStatus.orderStatus.name}}</td><td ng-class="{ \'td-text-align-center\': orderStatus.expiryTime==null}">{{(orderStatus.expiryTime | date:\'HH:mm\')||\'-\'}}</td><td ng-class="{ \'td-text-align-center\': orderStatus.stopExchangeRate==null,\'td-text-align-right noPaddingLeftRight\' : orderStatus.stopExchangeRate!=null}">{{(orderStatus.stopExchangeRate| currency:"" : vm.noOfDecimalsForRate)||\'-\'}}</td><td>{{orderStatus.user.login}}</td><td nowrap="nowrap" ng-show="orderStatus.isSplitOrder==true">Yes</td><td nowrap="nowrap" ng-show="orderStatus.isSplitOrder==false">No</td><td>{{orderStatus.deliveryMode || \'-\'}}</td><td>{{orderStatus.sourceApp.name}}</td></tr></tbody></table></div><div class="row"><span class="orderStatusInfo" data-translate="gatewayApp.orderStatusReport.legend"></span></div><div class="row"><span class="orderStatusInfo" data-translate="gatewayApp.orderStatusReport.originalTradeLegend"></span></div><div ng-show="vm.orderStatusDetails.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div><div class="table-responsive" ng-show="vm.orderStatusDetails.length==0"><span>No record found</span></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/order-upload-confirmation-status/order-upload-confirmation-status.html','<form name="orderUploadConfirmationStatusForm" role="form" novalidate><div class="modal-header"><!-- <button ng-if="vm.ScreenInfo== \'OrderSubmission\'"type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()" >&times;</button> --><h4 ng-if="vm.ScreenInfo== \'OrderConfirmation\'&& vm.viewFrom==\'SplitOrder\'" class="modal-title"><span data-translate="global.menu.splitOrderConfirmation"></span><span class="td-text-align-right"> <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="This Screen can be disabled from \'My Preferences\'" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></span></h4><h4 ng-if="vm.ScreenInfo== \'OrderSubmission\'&& vm.viewFrom==\'SplitOrder\'" class="modal-title"><span data-translate="global.menu.splitOrderStatus"></span></h4><h4 ng-if="vm.ScreenInfo== \'OrderConfirmation\'&& vm.viewFrom== \'OrderUpload\'" class="modal-title"><span data-translate="global.menu.orderUploadConfirmation"></span><span class="td-text-align-right"> <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="This Screen can be disabled from \'My Preferences\'" tooltip-position="right"><img class="width-height-20 info-tooltip-icon"></span></span></h4><h4 ng-if="vm.ScreenInfo== \'OrderSubmission\'&& vm.viewFrom== \'OrderUpload\'" class="modal-title"><span data-translate="global.menu.orderUploadStatus"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><div class="content"><div class="row"><!-- <cspl-table-export class="col-md-1 col-sm-1 col-xs-1" table-name="orderActivity" total-record-count="filterData.length" \r\n                    \tno-of-records-per-page="noOfRecordsPerPage"  page-no="page"  file-name="Order_Activity"></cspl-table-export> --></div><fieldset><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="orderUploadConfirmationStatus" class="dataTable table table-striped table-hover"><thead><tr><th ng-if="vm.ScreenInfo== \'OrderSubmission\'" data-translate="gatewayApp.orderUploadConfirmationStatus.orderSubmission"></th><th ng-if="vm.viewFrom== \'OrderUpload\'" data-translate="gatewayApp.orderUploadConfirmationStatus.orderUploadStatus"></th><th style="min-width:225px" ng-if="vm.viewFrom== \'OrderUpload\'" data-translate="gatewayApp.orderUploadConfirmationStatus.exceptionMessage"></th><th>S.No.</th><th data-translate="gatewayApp.orderUploadConfirmationStatus.custId"></th><th ng-if="vm.viewFrom==\'OrderUpload\'" data-translate="gatewayApp.orderUploadConfirmationStatus.bankNegotiationCode"></th><th ng-if="vm.viewFrom==\'SplitOrder\'" data-translate="gatewayApp.orderUploadConfirmationStatus.customer"></th><th ng-if="vm.viewFrom== \'SplitOrder\'" data-translate="gatewayApp.orderUploadConfirmationStatus.bankRelationship"></th><th data-translate="gatewayApp.orderUploadConfirmationStatus.currencyPair"></th><th data-translate="gatewayApp.orderUploadConfirmationStatus.instrument"></th><th data-translate="gatewayApp.orderUploadConfirmationStatus.buySell"></th><th data-translate="gatewayApp.orderUploadConfirmationStatus.orderType"></th><th class="tableNumericColumn" data-translate="gatewayApp.orderUploadConfirmationStatus.orderQuantity"></th><th class="tableNumericColumn" data-translate="gatewayApp.orderUploadConfirmationStatus.limitPrice"></th><th data-translate="gatewayApp.orderUploadConfirmationStatus.timeCondition"></th><th data-translate="gatewayApp.orderUploadConfirmationStatus.gttTime"></th><th data-translate="gatewayApp.orderUploadConfirmationStatus.settlementDate"></th><th data-translate="gatewayApp.orderUploadConfirmationStatus.exposureType"></th><th data-translate="gatewayApp.orderUploadConfirmationStatus.ExposureSubType"></th><th data-translate="gatewayApp.orderUploadConfirmationStatus.forwardType"></th><th style="min-width: 70px" data-translate="gatewayApp.orderUploadConfirmationStatus.startDate"></th><th style="min-width: 70px" data-translate="gatewayApp.orderUploadConfirmationStatus.endDate"></th><th data-translate="gatewayApp.orderUploadConfirmationStatus.remarks1"></th><th data-translate="gatewayApp.orderUploadConfirmationStatus.remarks2"></th><th data-translate="gatewayApp.orderUploadConfirmationStatus.remarks3"></th><th data-translate="gatewayApp.orderUploadConfirmationStatus.remarks4"></th></tr></thead><tbody><tr ng-repeat="orderDTOValue in vm.orderDTOList "><td ng-if="vm.ScreenInfo== \'OrderSubmission\'"><span ng-show="orderDTOValue.orderSubmission==\'SUCCESS\'" style="color: green">{{orderDTOValue.orderSubmission}}</span> <span ng-show="orderDTOValue.orderSubmission==\'FAILED\'" style="color: red">{{orderDTOValue.orderSubmission}}</span></td><td ng-if="vm.viewFrom== \'OrderUpload\'"><span ng-show="orderDTOValue.uploadStatus==\'SUCCESS\'" style="color: green">{{orderDTOValue.uploadStatus}}</span> <span ng-show="orderDTOValue.uploadStatus==\'FAILED\'" style="color: red">{{orderDTOValue.uploadStatus}}</span></td><td ng-if="vm.viewFrom== \'OrderUpload\'">{{orderDTOValue.exceptionMessage||\'-\'}}</td><td ng-if="vm.viewFrom== \'SplitOrder\'" class="tableNumericColumn">{{$index + 1}}</td><td ng-if="vm.viewFrom== \'OrderUpload\'" class="tableNumericColumn">{{orderDTOValue.serialNumber}}</td><td>{{orderDTOValue.customerCode}}</td><td ng-if="vm.viewFrom==\'OrderUpload\'">{{orderDTOValue.bankNegotiationCode||\'\'}}</td><td ng-if="vm.viewFrom==\'SplitOrder\'">{{orderDTOValue.customerName}}</td><td ng-if="vm.viewFrom==\'SplitOrder\'">{{orderDTOValue.bankName}}</td><td>{{orderDTOValue.currencyPairCode}}</td><td>{{orderDTOValue.instrumentCode}}</td><td><span ng-show="orderDTOValue.buySellIndicator==\'BUYY\'">Buy</span> <span ng-show="orderDTOValue.buySellIndicator==\'SELL\'">Sell</span> <span ng-show="orderDTOValue.buySellIndicator!=\'SELL\' && orderDTOValue.buySellIndicator!=\'BUYY\'">{{orderDTOValue.buySellIndicator}}</span></td><td><span ng-show="orderDTOValue.typeOfOrder==\'LIMT\'">Limit</span> <span ng-show="orderDTOValue.typeOfOrder==\'MRKT\'">Market</span> <span ng-show="orderDTOValue.typeOfOrder==\'STLS\'">Stop Loss</span> <span ng-show="orderDTOValue.typeOfOrder==\'TKPR\'">Take Profit</span> <span ng-if="vm.viewFrom==\'OrderUpload\'" ng-show="(orderDTOValue.typeOfOrder!=\'LIMT\' &&\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\torderDTOValue.typeOfOrder!=\'MRKT\')">{{orderDTOValue.typeOfOrder}}</span></td><td ng-show="vm.viewFrom== \'SplitOrder\'" class="tableNumericColumn">{{orderDTOValue.orderAmount | number:vm.noOfDecimalsForAmount}}</td><td ng-show="vm.viewFrom== \'OrderUpload\'" class="tableNumericColumn">{{orderDTOValue.orderAmount || \'\'}}</td><td ng-show="vm.viewFrom== \'SplitOrder\'" class="tableNumericColumn">{{orderDTOValue.limitExchangeRate | number:vm.noOfDecimalsForRate}}</td><td ng-show="vm.viewFrom== \'OrderUpload\'" class="tableNumericColumn">{{orderDTOValue.limitExchangeRate || \'\'}}</td><td align="center"><span ng-show="orderDTOValue.timeLimitIndicator==\'DAYY\' || orderDTOValue.timeLimitIndicator==\'DAY\'">Day</span> <span ng-show="orderDTOValue.timeLimitIndicator==\'IOCC\' || orderDTOValue.timeLimitIndicator==\'IOC\'">IOC</span> <span ng-show="orderDTOValue.timeLimitIndicator==\'GTTM\' || orderDTOValue.timeLimitIndicator==\'GTT\'">GTT</span></td><td ng-class="{ \'td-text-align-center\': orderDTOValue.expiryTime==null}"><span ng-if="orderDTOValue.expiryTime!=0">{{(orderDTOValue.expiryTimeString)||\'\'}}</span> <span ng-if="orderDTOValue.expiryTime == 0">{{\'\'}}</span></td><td><span ng-if="orderDTOValue.tradeSettlementDate != null && orderDTOValue.tradeSettlementDate!= undefined">{{orderDTOValue.tradeSettlementDate| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="orderDTOValue.tradeSettlementDate==null || orderDTOValue.tradeSettlementDate==\'\'">{{\'\'}}</span></td><td>{{orderDTOValue.exposureTypeName || \'-\'}}</td><td>{{orderDTOValue.exposureSubTypeName || \'-\'}}</td><td>{{orderDTOValue.forwardType || \'\'}}</td><td><span ng-if="orderDTOValue.tradeSettlementDateFrom !=null">{{orderDTOValue.tradeSettlementDateFrom|date:\'dd-MMM-yyyy\'}}</span> <span ng-if="orderDTOValue.tradeSettlementDateFrom ==null || orderDTOValue.tradeSettlementDateFrom==\'\'">{{\'\'}}</span></td><td><span ng-if="orderDTOValue.tradeSettlementDate != null && orderDTOValue.tradeSettlementDate\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t!= undefined">{{orderDTOValue.tradeSettlementDate| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="orderDTOValue.tradeSettlementDate==null || orderDTOValue.tradeSettlementDate==\'\'">{{\'\'}}</span></td><td>{{orderDTOValue.remarks || \'\'}}</td><td>{{orderDTOValue.remarks2 || \'\'}}</td><td>{{orderDTOValue.remarks3 || \'\'}}</td><td>{{orderDTOValue.remarks4 || \'\'}}</td></tr></tbody></table></div></fieldset></div><div class="modal-footer"><button ng-if="vm.ScreenInfo== \'OrderConfirmation\'" type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button ng-if="vm.ScreenInfo== \'OrderSubmission\'" type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.close">Close</span></button> <button ng-if="vm.ScreenInfo== \'OrderConfirmation\'" class="btn btn-info" data-dismiss="modal" ng-click="vm.submitplaceOrder()"><span data-translate="gatewayApp.orderUploadConfirmationStatus.placeOrder"></span></button> <button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.exportDataToExcelFile();" tabindex="-1"><span data-translate="gatewayApp.orderUploadConfirmationStatus.download"></span></button></div></div></form>');
$templateCache.put('app/entities/organisation/organisation-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.organisation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><nmb-alert-error></nmb-alert-error><p data-translate="gatewayApp.organisation.delete.question" translate-values="{id: \'{{vm.organisation.id}}\'}">Are you sure you want to delete this Organisation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/organisation/organisation-detail.html','<div><h2><span data-translate="gatewayApp.organisation.detail.title">Organisation</span> {{vm.organisation.id}}</h2><hr><nmb-alert-error></nmb-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="gatewayApp.organisation.shortName">Short Name</span></dt><dd><span>{{vm.organisation.shortName}}</span></dd><dt><span data-translate="gatewayApp.organisation.name">Name</span></dt><dd><span>{{vm.organisation.name}}</span></dd><dt><span data-translate="gatewayApp.organisation.address">Address</span></dt><dd><span>{{vm.organisation.address}}</span></dd><dt><span data-translate="gatewayApp.organisation.pincode">Pincode</span></dt><dd><span>{{vm.organisation.pincode}}</span></dd><dt><span data-translate="gatewayApp.organisation.orgType">Org Type</span></dt><dd><span>{{vm.organisation.orgType}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="organisation-detail.edit({id:vm.organisation.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/organisation/organisation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOrganisationLabel" data-translate="gatewayApp.organisation.home.createOrEditLabel">Create or edit a Organisation</h4></div><div class="modal-body"><nmb-alert-error></nmb-alert-error><div class="form-group" ng-show="vm.organisation.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.organisation.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="gatewayApp.organisation.shortName" for="field_shortName">Short Name</label><input type="text" class="form-control" name="shortName" id="field_shortName" ng-model="vm.organisation.shortName" required><div ng-show="editForm.shortName.$invalid"><p class="help-block" ng-show="editForm.shortName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="gatewayApp.organisation.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.organisation.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="gatewayApp.organisation.address" for="field_address">Address</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.organisation.address" required><div ng-show="editForm.address.$invalid"><p class="help-block" ng-show="editForm.address.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="gatewayApp.organisation.pincode" for="field_pincode">Pincode</label><input type="number" class="form-control" name="pincode" id="field_pincode" ng-model="vm.organisation.pincode" required><div ng-show="editForm.pincode.$invalid"><p class="help-block" ng-show="editForm.pincode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.pincode.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="gatewayApp.organisation.orgType" for="field_orgType">Org Type</label><input type="text" class="form-control" name="orgType" id="field_orgType" ng-model="vm.organisation.orgType" required><div ng-show="editForm.orgType.$invalid"><p class="help-block" ng-show="editForm.orgType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/organisation/organisations.html','<div><h2 data-translate="gatewayApp.organisation.home.title">Organisations</h2><nmb-alert></nmb-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="organisation.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gatewayApp.organisation.home.createLabel">Create new Organisation</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="shortName"><span data-translate="gatewayApp.organisation.shortName">Short Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="gatewayApp.organisation.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="address"><span data-translate="gatewayApp.organisation.address">Address</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pincode"><span data-translate="gatewayApp.organisation.pincode">Pincode</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="orgType"><span data-translate="gatewayApp.organisation.orgType">Org Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="organisation in vm.organisations track by organisation.id"><td><a ui-sref="organisation-detail({id:organisation.id})">{{organisation.id}}</a></td><td>{{organisation.shortName}}</td><td>{{organisation.name}}</td><td>{{organisation.address}}</td><td>{{organisation.pincode}}</td><td>{{organisation.orgType}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="organisation-detail({id:organisation.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="organisation.edit({id:organisation.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="organisation.delete({id:organisation.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><nmb-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></nmb-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/otp-confirm/otp-confirm.html','<form name="otpConfirmationForm"><div class="{{vm.theme}}"><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><img src="assets/images/Close.png"></button> <span data-translate="gatewayApp.otpConfirm.title"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.otpConfirm.otp"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3" id="txtotp" control-model="vm.otp" otp-input-directive options="otpInput"></div></div><div class="row"><label class="col-md-6 col-md-offset-3 text-right"><a style="margin-right:2%" href="" ng-click="vm.resendOTP()">Resend</a></label></div><div class="row"><label class="col-md-6 col-md-offset-3 text-right"><span class="help-block" data-translate="gatewayApp.otpConfirm.helpText"></span></label></div><div class="modal-footer"><button type="submit" ng-hide="showButton" class="btn btn-info active padding-xs" ng-disabled="vm.otp == null  || vm.clicked" ng-click="vm.verify();"><span data-translate="gatewayApp.otpConfirm.verify"></span></button></div></div></div></div></form>');
$templateCache.put('app/entities/otr-summary/otr-summary.html','<div class="container-fluid" ng-cloak><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.otrSummary.title"></h2><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseOTRSummary = !vm.ExpandOrCollapseOTRSummary" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#OTRSummary"><img ng-src="{{vm.ExpandOrCollapseOTRSummary == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.otrSummaryReport.criteria">Criteria</span></a></h4></div><div id="OTRSummary" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="otrSummaryForm"><div class="col-md-offset-2 col-lg-offset-3 col-sm-offset-1 col-md-5 col-sm-6 col-xs-10 col-lg-5"><div class="col-md-10"><label class="control-label"><span data-translate="gatewayApp.otrSummaryReport.bank"></span></label></div><div class="form-group col-sm-7 col-md-9 col-lg-7 col-xs-7" style="margin-bottom: 23px"><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bank" display-column="bankName" placeholder="" form="otrSummaryForm"></div><div class="form-group col-md-12" style="margin-bottom: 23px"><div id="btnGroup"><div class="btn-group"><label class="btn btn-primary" style="font-size: 12px" ng-model="vm.freshOrPrintOption" uib-btn-radio="\'PrintGeneratedInvoice\'">Print Generated Invoice</label><label class="btn btn-primary" style="font-size: 12px" ng-model="vm.freshOrPrintOption" uib-btn-radio="\'GenerateAfresh\'">Generate Afresh</label></div></div></div><div class="col-md-10" ng-show="vm.freshOrPrintOption != \'GenerateAfresh\'"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.otrSummaryReport.financialMonth"></span></label></div><div class="form-group col-sm-7 col-md-9 col-lg-7 col-xs-7" ng-show="vm.freshOrPrintOption != \'GenerateAfresh\'" style="margin-bottom: 23px"><select class="form-control select-style" name="financialMonth" ng-model="vm.financialMonth" ng-options="financialMonth.monthDisplay for financialMonth in vm.previousFiancialMonthOptions track by financialMonth.date" form="otrSummaryForm" required></select></div><div class="col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-left"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.otrSummaryReport.from"></span></label></span></div><div class="form-group col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-right no-padding-left"><cspl-dtp control-model="vm.fromDate" control-id="dtpFromDate" control-min-date="vm.minDate" control-max-date="vm.maxDate" control-disabled="vm.freshOrPrintOption ==\'PrintGeneratedInvoice\'" form="otrSummaryForm" required></cspl-dtp></span></div><div class="col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-left"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.otrSummaryReport.to"></span></label></span></div><div class="form-group col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-right no-padding-left"><cspl-dtp control-model="vm.toDate" control-id="dtpToDate" control-min-date="vm.minDate" control-max-date="vm.maxDate" control-disabled="vm.freshOrPrintOption ==\'PrintGeneratedInvoice\'" form="otrSummaryForm" required></cspl-dtp></span><span class="col-md-2 col-sm-2 col-xs-2" style="text-align:right"><button class="btn btn-info active" ng-disabled="otrSummaryForm.$invalid" ng-click="vm.getOTRSummary()" data-toggle="collapse" data-target="#OTRSummary" data-translate="gatewayApp.otrSummaryReport.go"></button></span></div></div></form></div></div></div><div ng-show="vm.otrSummaryDetails.headerList.length > 0"><div class="row"><div class="dropdown col-md-3" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportDataToFile(\'csv\')">CSV</a></li><li><a ng-click="vm.exportDataToFile(\'xls\');">XLS</a></li><li><a ng-click="vm.exportDataToFile(\'pdf\')">PDF</a></li></ul></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search><div class="col-xs-4 text-right pull-right" ng-show="vm.showDownloadEInvoice"><button type="button" class="btn btn-info active" id="btnDownloadEInvoice" style="margin: 0px;text-transform: none !important" ng-click="vm.downloadEInvoice()" ng-disabled="vm.eInvoiceDisable"><span data-translate="entity.action.downloadEInvoice"></span></button></div></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="otrSummaryHeader" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.otrSummaryReport.memberName"></th><th data-translate="gatewayApp.otrSummaryReport.membershipId"></th><th data-translate="gatewayApp.otrSummaryReport.invoiceNumber"></th><th style="min-width: 65px" data-translate="gatewayApp.otrSummaryReport.segment"></th><th style="min-width: 55px" data-translate="gatewayApp.otrSummaryReport.month"></th><th style="min-width: 80px" data-translate="gatewayApp.otrSummaryReport.from"></th><th style="min-width: 80px" data-translate="gatewayApp.otrSummaryReport.to"></th><th data-translate="gatewayApp.otrSummaryReport.bankStateName"></th><th data-translate="gatewayApp.otrSummaryReport.bankGSTIN"></th><th class="td-text-align-right" data-translate="gatewayApp.otrSummaryReport.stateCode"></th><th class="td-text-align-right" data-translate="gatewayApp.otrSummaryReport.charges"></th><th class="td-text-align-right" data-translate="gatewayApp.otrSummaryReport.cgst"></th><th class="td-text-align-right" data-translate="gatewayApp.otrSummaryReport.sgst"></th><th class="td-text-align-right" data-translate="gatewayApp.otrSummaryReport.igst"></th><th class="td-text-align-right" data-translate="gatewayApp.otrSummaryReport.utgst"></th><th class="td-text-align-right" data-translate="gatewayApp.otrSummaryReport.totalTax"></th><th class="td-text-align-right" data-translate="gatewayApp.otrSummaryReport.totalCharges"></th></tr></thead><tbody><tr ng-repeat="otrSummary in filterData = (vm.otrSummaryDetails.headerList| filter : filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)" ng-click="vm.getOTRSummaryDetails(otrSummary);"><td style="word-break: break-word">{{otrSummary.bankChargesDTO.bankName}}</td><td>{{otrSummary.bankChargesDTO.membershipID}}</td><td><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\'">{{otrSummary.invoiceNumber}}</span><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\'">-</span></td><td>{{vm.otrSummaryDetails.platformName}}</td><td>{{otrSummary.from | date : \'MMMM\'}}</td><td>{{otrSummary.from | date : \'dd-MMM-yyyy\'}}</td><td>{{otrSummary.to | date : \'dd-MMM-yyyy\'}}</td><td><span ng-show="otrSummary.bankChargesDTO.state != null && otrSummary.bankChargesDTO.state.length > 0">{{otrSummary.bankChargesDTO.state}}</span><span ng-show="otrSummary.bankChargesDTO.state == null || otrSummary.bankChargesDTO.state.length == 0">-</span></td><td><span ng-show="otrSummary.bankChargesDTO.gstin != null && otrSummary.bankChargesDTO.gstin.length > 0">{{otrSummary.bankChargesDTO.gstin}}</span><span ng-show="otrSummary.bankChargesDTO.gstin == null || otrSummary.bankChargesDTO.gstin.length == 0">-</span></td><td class="td-text-align-right"><span ng-show="otrSummary.bankChargesDTO.tinNumber != null && otrSummary.bankChargesDTO.tinNumber != 0">{{otrSummary.bankChargesDTO.tinNumber}}</span> <span ng-show="otrSummary.bankChargesDTO.tinNumber == null || otrSummary.bankChargesDTO.tinNumber == 0">-</span></td><td class="td-text-align-right">{{otrSummary.chargeDetails.grossCharges | currency:"" : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || otrSummary.bankChargesDTO.cgstPercent == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && otrSummary.bankChargesDTO.cgstPercent != null">{{otrSummary.chargeDetails.cgstAmount | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || otrSummary.bankChargesDTO.sgstPercent == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && otrSummary.bankChargesDTO.sgstPercent != null">{{otrSummary.chargeDetails.sgstAmount | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || otrSummary.bankChargesDTO.integratedTax == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && otrSummary.bankChargesDTO.integratedTax != null">{{otrSummary.chargeDetails.igstAmount | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || otrSummary.bankChargesDTO.utTaxPercent == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && otrSummary.bankChargesDTO.utTaxPercent != null">{{otrSummary.chargeDetails.utgstAmount | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' ||  ( otrSummary.bankChargesDTO.cgstPercent == null && otrSummary.bankChargesDTO.sgstPercent == null \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& otrSummary.bankChargesDTO.integratedTax == null && otrSummary.bankChargesDTO.utTaxPercent == null )">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && !( otrSummary.bankChargesDTO.cgstPercent == null && otrSummary.bankChargesDTO.sgstPercent == null \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& otrSummary.bankChargesDTO.integratedTax == null && otrSummary.bankChargesDTO.utTaxPercent == null )">{{otrSummary.chargeDetails.totalTaxAmount | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="otrSummary.chargeDetails.netCharges == null">-</span><span ng-show="otrSummary.chargeDetails.netCharges != null">{{otrSummary.chargeDetails.netCharges | currency:"" : vm.noOfDecimalsForAmount}}</span></td></tr></tbody><tfoot class="rounded-off-bar" ng-show="filterText == null || filterText.length == 0"><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td data-translate="gatewayApp.otrSummaryReport.grandTotal"></td><td class="td-text-align-right"><span ng-show=" vm.otrSummaryDetails.headerListGrandTotalCharges.grossCharges == null">-</span><span ng-show=" vm.otrSummaryDetails.headerListGrandTotalCharges.grossCharges != null">{{vm.otrSummaryDetails.headerListGrandTotalCharges.grossCharges | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || vm.otrSummaryDetails.headerListGrandTotalCharges.cgstAmount == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && vm.otrSummaryDetails.headerListGrandTotalCharges.cgstAmount != null">{{vm.otrSummaryDetails.headerListGrandTotalCharges.cgstAmount| currency:"" : vm.noOfDecimalsForAmount }}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || vm.otrSummaryDetails.headerListGrandTotalCharges.sgstAmount == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && vm.otrSummaryDetails.headerListGrandTotalCharges.sgstAmount != null">{{vm.otrSummaryDetails.headerListGrandTotalCharges.sgstAmount| currency:"" : vm.noOfDecimalsForAmount }}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || vm.otrSummaryDetails.headerListGrandTotalCharges.igstAmount == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && vm.otrSummaryDetails.headerListGrandTotalCharges.igstAmount != null">{{vm.otrSummaryDetails.headerListGrandTotalCharges.igstAmount| currency:"" : vm.noOfDecimalsForAmount }}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || vm.otrSummaryDetails.headerListGrandTotalCharges.utgstAmount == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && vm.otrSummaryDetails.headerListGrandTotalCharges.utgstAmount != null">{{vm.otrSummaryDetails.headerListGrandTotalCharges.utgstAmount| currency:"" : vm.noOfDecimalsForAmount }}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || vm.otrSummaryDetails.headerListGrandTotalCharges.totalTaxAmount == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && vm.otrSummaryDetails.headerListGrandTotalCharges.totalTaxAmount != null">{{vm.otrSummaryDetails.headerListGrandTotalCharges.totalTaxAmount| currency:"" : vm.noOfDecimalsForAmount }}</span></td><td class="td-text-align-right"><span ng-show=" vm.otrSummaryDetails.headerListGrandTotalCharges.netCharges == null">-</span><span ng-show=" vm.otrSummaryDetails.headerListGrandTotalCharges.netCharges != null">{{vm.otrSummaryDetails.headerListGrandTotalCharges.netCharges| currency:"" : vm.noOfDecimalsForAmount }}</span></td></tr></tfoot></table></div><div ng-show="filterData.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><div ng-show="vm.otrSummarySelected != null && vm.otrSummarySelected.length > 0"><h3 class="col-md-4 col-xs-5"><span data-translate="gatewayApp.otrSummaryReport.bankWiseCustomerDetails" class="details-table-header"></span></h3><div class="col-md-8 col-xs-7" style="margin-top:12px"><cspl-table-search control-model="filterTextSummary" class="col-md-3 col-sm-5 col-xs-6 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="otrSummaryDetails" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.otrSummaryReport.customerName"></th><th data-translate="gatewayApp.otrSummaryReport.customerType"></th><th data-translate="gatewayApp.otrSummaryReport.memberName"></th><th data-translate="gatewayApp.otrSummaryReport.bankStateName"></th><th data-translate="gatewayApp.otrSummaryReport.bankGSTIN"></th><th data-translate="gatewayApp.otrSummaryReport.customerRegisteredDate"></th><th class="td-text-align-right" data-translate="gatewayApp.otrSummaryReport.charges"></th></tr></thead><tbody><tr ng-repeat="otrHeaderSummarySelected in filterDataSummary = (vm.otrSummarySelected| filter : filterTextSummary )| limitTo:noOfRecordsPerPageSummary:noOfRecordsPerPageSummary*(pageSummary-1)"><td style="word-break: break-word">{{otrHeaderSummarySelected.customerName}}</td><td>{{otrHeaderSummarySelected.customerType}}</td><td style="word-break: break-word">{{otrHeaderSummarySelected.bankChargesDTO.bankName}}</td><td><span ng-show="otrHeaderSummarySelected.bankChargesDTO.state != null && otrHeaderSummarySelected.bankChargesDTO.state.length > 0 ">{{otrHeaderSummarySelected.bankChargesDTO.state}}</span><span ng-show="otrHeaderSummarySelected.bankChargesDTO.state == null || otrHeaderSummarySelected.bankChargesDTO.state.length == 0 ">-</span></td><td><span ng-show="otrHeaderSummarySelected.bankChargesDTO.gstin != null && otrHeaderSummarySelected.bankChargesDTO.gstin.length > 0"></span>{{otrHeaderSummarySelected.bankChargesDTO.gstin}}<span ng-show="otrHeaderSummarySelected.bankChargesDTO.gstin == null || otrHeaderSummarySelected.bankChargesDTO.gstin.length == 0">-</span></td><td>{{otrHeaderSummarySelected.customerRegisteredDate | date : \'dd-MMM-yyyy\'}}</td><td class="td-text-align-right"><span ng-show="otrHeaderSummarySelected.chargeOrSlabId == null">-</span><span ng-show="otrHeaderSummarySelected.chargeOrSlabId != null ">{{otrHeaderSummarySelected.chargeDetails.grossCharges| currency:"" : vm.noOfDecimalsForAmount }}</span></td></tr></tbody><tfoot class="grand-total-bar" ng-show="filterTextSummary == null || filterTextSummary.length == 0"><tr><td></td><td></td><td></td><td></td><td></td><td data-translate="gatewayApp.otrSummaryReport.grandTotal"></td><td class="td-text-align-right"><span ng-show="vm.otrSummaryCharges == null || vm.otrSummaryCharges.grossCharges == null">-</span><span ng-show="vm.otrSummaryCharges != null || vm.otrSummaryCharges.grossCharges != null">{{vm.otrSummaryCharges.grossCharges | currency:"" : vm.noOfDecimalsForAmount }}</span></td></tr></tfoot></table></div><div ng-show="filterDataSummary.length > 0"><cspl-pagination record-count="filterDataSummary.length" control-model="pageSummary" items-per-page="noOfRecordsPerPageSummary"></cspl-pagination></div></div></div><div class="table-responsive" ng-show="vm.issuePresent == true || vm.otrSummaryDetails.headerList.length == 0"><span>No record found</span></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/otr-summary-for-bank/otr-summary-for-bank.html','<div class="container-fluid" ng-cloak><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.otrSummary.title"></h2><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseOTRSummary = !vm.ExpandOrCollapseOTRSummary" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#OTRSummary"><img ng-src="{{vm.ExpandOrCollapseOTRSummary == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.otrSummaryReport.criteria">Criteria</span></a></h4></div><div id="OTRSummary" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="otrSummaryForBankForm"><div class="col-md-offset-2 col-lg-offset-3 col-sm-offset-1 col-md-5 col-sm-6 col-xs-10 col-lg-5"><div class="col-md-10"><label class="control-label"><span data-translate="gatewayApp.otrSummaryReport.bank"></span></label></div><div class="form-group col-sm-7 col-md-9 col-lg-7 col-xs-7" style="margin-bottom: 23px"><cspl-ach control-model="vm.OtrSummaryForBank" control-id="txtbank" lookup-name="bank" display-column="bankName" placeholder="" form="otrSummaryForBankForm" control-disabled="true"></div><div class="col-md-10"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.otrSummaryReport.financialMonth"></span></label></div><div class="form-group col-sm-7 col-md-9 col-lg-7 col-xs-7" style="margin-bottom: 23px"><select class="form-control select-style" name="financialMonth" ng-model="vm.financialMonth" ng-options="financialMonth.monthDisplay for financialMonth in vm.previousFiancialMonthOptions track by financialMonth.date" form="otrSummaryForBankForm" required></select></div><div class="col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-left"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.otrSummaryReport.from"></span></label></span></div><div class="form-group col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-right no-padding-left"><cspl-dtp control-model="vm.fromDate" control-id="dtpFromDate" control-min-date="vm.fromDate" control-max-date="vm.toDate" control-disabled="vm.isCurrenMonth" form="otrSummaryForBankForm" required></cspl-dtp></span></div><div class="col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-left"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.otrSummaryReport.to"></span></label></span></div><div class="form-group col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-right no-padding-left"><cspl-dtp control-model="vm.toDate" control-id="dtpToDate" control-min-date="vm.fromDate" control-max-date="vm.toDate" control-disabled="vm.isCurrenMonth" form="otrSummaryForBankForm" required></cspl-dtp></span><span class="col-md-2 col-sm-2 col-xs-2" style="text-align:right"><button class="btn btn-info active" ng-disabled="vm.clicked" ng-click="vm.getOTRSummaryForBank();" data-toggle="collapse" data-target="#OTRSummary" data-translate="gatewayApp.otrSummaryReport.go"></button></span></div></div></form></div></div></div><div ng-show="vm.otrSummaryDetails.length > 0"><div class="row"><div class="dropdown col-md-3" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportDataToFile(\'csv\')">CSV</a></li><li><a ng-click="vm.exportDataToFile(\'xls\');">XLS</a></li></ul></div><cspl-table-search control-model="filterTextSummary" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="otrSummaryDetails" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.otrSummaryReport.customerId"></th><th data-translate="gatewayApp.otrSummaryReport.customerName"></th><th data-translate="gatewayApp.otrSummaryReport.customerType"></th><th data-translate="gatewayApp.otrSummaryReport.customerAccountNumber"></th><th data-translate="gatewayApp.otrSummaryReport.branchName"></th><th data-translate="gatewayApp.otrSummaryReport.branchIFSCCode"></th><th data-translate="gatewayApp.otrSummaryReport.customerRegisteredDate"></th><th data-translate="gatewayApp.otrSummaryReport.customerApprovedDate"></th><th class="td-text-align-right" data-translate="gatewayApp.otrSummaryReport.charges"></th></tr></thead><tbody><tr ng-repeat="otrHeaderSummarySelected in filterDataSummary = (vm.otrSummaryDetails| filter : filterTextSummary )| limitTo:noOfRecordsPerPageSummary:noOfRecordsPerPageSummary*(pageSummary-1)"><td>{{otrHeaderSummarySelected.customerId}}</td><td style="word-break: break-word">{{otrHeaderSummarySelected.customerName}}</td><td>{{otrHeaderSummarySelected.customerType}}</td><td>{{otrHeaderSummarySelected.customerAccountNumber}}</td><td style="word-break: break-word">{{otrHeaderSummarySelected.branchName}}</td><td style="word-break: break-word">{{otrHeaderSummarySelected.branchIFSCCode}}</td><td>{{otrHeaderSummarySelected.customerRegisteredDate | date : \'dd-MMM-yyyy\'}}</td><td>{{otrHeaderSummarySelected.customerApprovedDate | date : \'dd-MMM-yyyy\'}}</td><td class="td-text-align-right"><span ng-show="otrHeaderSummarySelected.chargeOrSlabId == null">-</span><span ng-show="otrHeaderSummarySelected.chargeOrSlabId != null ">{{otrHeaderSummarySelected.chargeDetails.grossCharges| currency:"" : vm.noOfDecimalsForAmount }}</span></td></tr></tbody><tfoot class="grand-total-bar" ng-show="filterTextSummary == null || filterTextSummary.length == 0"><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td data-translate="gatewayApp.otrSummaryReport.grandTotal"></td><td class="td-text-align-right"><span ng-show="vm.otrSummaryCharges == null">-</span><span ng-show="vm.otrSummaryCharges!= null ">{{vm.otrSummaryCharges| currency:"" : vm.noOfDecimalsForAmount }}</span></td></tr></tfoot></table></div><div ng-show="filterDataSummary.length > 0"><cspl-pagination record-count="filterDataSummary.length" control-model="pageSummary" items-per-page="noOfRecordsPerPageSummary"></cspl-pagination></div></div></div><div class="table-responsive" ng-show="vm.otrSummaryDetails.length == 0"><span>No record found</span></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/pending-order-report/pending-order-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.pendingOrderReport.title" data-translate-values="{value: {{vm.todayDate}}}"></h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapsePendingOrder = !vm.ExpandOrCollapsePendingOrder" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#PendingOrder"><img ng-src="{{vm.ExpandOrCollapsePendingOrder == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.pendingOrder.criteria">Criteria</span></a></h4></div><div id="PendingOrder" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="pendingOrderForm"><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.pendingOrder.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bankDetails" display-column="bankName" placeholder="" form="pendingOrderForm"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.pendingOrder.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="validBranchDetailsForBank" display-column="branchName" placeholder="" form="pendingOrderForm" filter-value="{{vm.bank.id}}"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.pendingOrder.customer"></span></label><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="allNonTerminatedNonSuspendedCustomers" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" control-place-holder="Enter Customer ID or Name" display-column="customerCode,customerName" placeholder="" form="pendingOrderForm"><span class="cutomer-highlight" ng-if="vm.customer.customerMiddleName==null">{{vm.customer.customerFirstName+\' \'+vm.customer.customerLastName}}</span> <span class="cutomer-highlight" ng-if="vm.customer.customerMiddleName!=null">{{vm.customer.customerFirstName+\' \'+ vm.customer.customerMiddleName+\' \'+vm.customer.customerLastName}}</span></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.pendingOrder.currencyPair"></span></label><cspl-ach control-model="vm.currencyPair" control-id="txtcurrencyPair" lookup-name="currencyPair" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}" display-column="code" placeholder="" form="pendingOrderForm"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.pendingOrder.instrument"></span></label><cspl-ach control-model="vm.instrument" control-id="txtInstrument" lookup-name="marketInstrumentsCurrency" filter-value="{{ vm.currencyPair.id ? vm.currencyPair.id : 0 }}" display-column="instrumentCode" placeholder="" form="pendingOrderForm"></div></div><div class="form-group"><div class="row"><label class="col-md-offset-3 control-label col-xs-8 col-sm-7 col-md-6" cspl-mandatory><span data-translate="gatewayApp.pendingOrder.reportPeriod"></span></label><div class="col-md-offset-3 col-xs-10 col-sm-9 col-md-5"><!--<cspl-from-to-time-picker from-model = "vm.fromTime" to-model="vm.toTime"   time-difference=""  control-id = "timerTxt" control-required="true" max-value-for-from="vm.maxDate" \r\n \t\t\t\t\t\t\t\t\t\t\t\tcontrol-from-disabled= "false" control-to-disabled= "true" control24HrFormat = "false" form="pendingOrderForm" set-default-values="true">\r\n\t\t\t\t\t\t\t\t\t\t\t</cspl-from-to-time-picker>\t  --><div style="width:100%"><div style="width:50%;display:table-cell;padding-right:8px"><cspl-time-picker control-model="vm.fromTime" control-id="fromTimer" time-zone="timeZone" control-required="true" control-disabled="false" control24hrformat="false" form="pendingOrderForm" control-min-date="minValueForFrom" vertical-position="top"></cspl-time-picker></div><div style="width:50%;display:table-cell;padding-left:8px"><cspl-time-picker control-model="vm.toTime" control-id="toTimer" time-zone="timeZone" control-required="true" control-disabled="false" control24hrformat="false" form="pendingOrderForm" control-min-date="minValueForTo" vertical-position="top"></cspl-time-picker></div></div></div><div class="col-md-1 col-sm-1 col-xs-2"><button class="btn btn-info active" ng-disabled="pendingOrderForm.$invalid||vm.clicked" ng-click="vm.getPendingOrders();" data-toggle="collapse" data-target="#PendingOrder" data-translate="gatewayApp.pendingOrder.go"></button></div></div></div></form></div></div></div><div ng-show="vm.pendingOrderDetails.length > 0"><!-- ng-show="vm.pendingOrderDetails.length > 0" --><div class="row"><div class="up-btn"><div class="dropdown" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportDataToCsvFile()">CSV</a></li><li><a ng-click="vm.exportDataToExcelFile();">XLS</a></li><li><a ng-click="vm.exportDataToPdfFile()">PDF</a></li></ul></div></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="pendingOrder" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.pendingOrder.bank" style="min-width:90px"></th><th data-translate="gatewayApp.pendingOrder.branch" style="min-width:90px"></th><th data-translate="gatewayApp.pendingOrder.branchId"></th><th data-translate="gatewayApp.pendingOrder.custId"></th><th data-translate="gatewayApp.pendingOrder.customer" style="min-width:90px"></th><th data-translate="gatewayApp.pendingOrder.currencyPair"></th><th data-translate="gatewayApp.pendingOrder.inst"></th><th data-translate="gatewayApp.pendingOrder.orderType"></th><th data-translate="gatewayApp.pendingOrder.buySell"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.pendingOrder.orderQuantity"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.pendingOrder.tradedQuantity"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.pendingOrder.pendingOrderQuantity"></th><th data-translate="gatewayApp.pendingOrder.priceCondition"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.pendingOrder.orderPrice"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.pendingOrder.swapPtsInPaise"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.pendingOrder.equivalentSpotPrice"></th><th class="td-text-align-right" data-translate="gatewayApp.pendingOrder.triggerPrice" style="padding-right: 0px"></th><th class="td-text-align-right" data-translate="gatewayApp.pendingOrder.tradePriceGross" style="padding-right: 0px"></th><th data-translate="gatewayApp.pendingOrder.timeCondition"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.pendingOrder.gttTime"></th><th data-translate="gatewayApp.pendingOrder.tradeSettlementDateFrom"></th><th data-translate="gatewayApp.pendingOrder.settDate"></th><th data-translate="gatewayApp.pendingOrder.orderStatus"></th><th data-translate="gatewayApp.pendingOrder.orderNumber"></th><th data-translate="gatewayApp.pendingOrder.lastActionedBy"></th><th data-translate="gatewayApp.pendingOrder.orderDateTime"></th><th data-translate="gatewayApp.pendingOrder.userMobileNo"></th><th data-translate="gatewayApp.pendingOrder.placedAsSplitOrder"></th></tr></thead><tbody><tr ng-repeat="orderStatus in filterData = (vm.pendingOrderDetails | filter : filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break:break-word">{{orderStatus.bank.bankName}}</td><td style="word-break:break-word">{{orderStatus.branch.branchName}}</td><td>{{orderStatus.branch.branchId}}</td><td>{{orderStatus.customer.customerCode}}</td><td style="word-break:break-word" ng-if="orderStatus.customer.customerMiddleName!=null && orderStatus.customer.customerMiddleName!=\'\' && orderStatus.customer.customerMiddleName!=undefined">{{orderStatus.customer.customerFirstName + \' \' + orderStatus.customer.customerMiddleName + \' \' + orderStatus.customer.customerLastName}}</td><td style="word-break:break-word" ng-if="orderStatus.customer.customerMiddleName==null || orderStatus.customer.customerMiddleName==\'\' || orderStatus.customer.customerMiddleName==undefined">{{orderStatus.customer.customerFirstName + \' \' + orderStatus.customer.customerLastName}}</td><td>{{orderStatus.currencyPair.code}}</td><td>{{orderStatus.instrument.instrumentCode}}</td><td>{{orderStatus.eventType.name}}</td><td>{{orderStatus.buySellFlag}}</td><td class="td-text-align-right noPaddingLeftRight">{{(orderStatus.pendingOrderAmount + orderStatus.tradeAmount) | currency:"" : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right" style="padding-right:10px">{{orderStatus.tradeAmount| currency:"" : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right" style="padding-right:10px">{{orderStatus.pendingOrderAmount| currency:"" : vm.noOfDecimalsForAmount}}</td><td>{{orderStatus.priceCondition.name}}</td><td class="td-text-align-right" style="padding-right:10px">{{orderStatus.limitExchangeRate| currency:"" : vm.noOfDecimalsForRate}}</td><td class="td-text-align-right" style="padding-right:10px">{{vm.getSwapPoints(orderStatus.retailEquivalentSpotLimitExchangeRate,orderStatus.limitExchangeRate)| currency:"" : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right noPaddingLeftRight">{{orderStatus.retailEquivalentSpotLimitExchangeRate| currency:"" : vm.noOfDecimalsForRate}}</td><td ng-class="{ \'td-text-align-center\': orderStatus.stopExchangeRate==null,\'td-text-align-right noPaddingLeftRight\' : orderStatus.stopExchangeRate!=null}">{{(orderStatus.stopExchangeRate| currency:"" : vm.noOfDecimalsForRate)||\'-\'}}</td><td ng-if="(orderStatus.tradeExchangeRate==null || orderStatus.tradeExchangeRate==0)" class="td-text-align-center">-</td><td ng-if="(orderStatus.tradeExchangeRate!=null && orderStatus.tradeExchangeRate!=0)" class="td-text-align-right noPaddingLeftRight">{{(orderStatus.tradeExchangeRate| currency:"" : vm.noOfDecimalsForRate)||\'-\'}}</td><td align="center">{{orderStatus.timeCondition}}</td><td class="td-text-align-right">{{(orderStatus.expiryTime | date:\'HH:mm\')||\'-\'}}</td><td><span ng-if="orderStatus.tradeSettlementDateFrom !=null">{{orderStatus.tradeSettlementDateFrom| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="orderStatus.tradeSettlementDateFrom ==null">{{\'\'}}</span></td><td>{{orderStatus.tradeSettlementDate | date : \'dd-MMM-yyyy\' }}</td><td align="center">{{orderStatus.orderStatus.name}}</td><td><a ui-sref="order-activity-report({orderNumber:orderStatus.orderSequenceNumber})" style="text-decoration:underline">{{orderStatus.orderSequenceNumber}}</a></td><td style="word-break:break-word">{{orderStatus.user.login}}</td><td nowrap="nowrap" ng-show="orderStatus.orderStatus.name==\'Risk Validated\'">{{orderStatus.lastModifiedDate | date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td nowrap="nowrap" ng-show="orderStatus.orderStatus.name!=\'Risk Validated\'">{{orderStatus.revisionTimeStamp | date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td>{{orderStatus.user.mobileCountryCode}}-{{orderStatus.user.mobile}}</td><td nowrap="nowrap" ng-show="orderStatus.isSplitOrder==true">Yes</td><td nowrap="nowrap" ng-show="orderStatus.isSplitOrder==false">No</td></tr></tbody></table></div><div ng-show="vm.pendingOrderDetails.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="table-responsive" ng-show="vm.pendingOrderDetails.length==0"><span>No record found</span></div></div></section></div><script src="assets/js/tables.js"></script><style>.total-bar {\r\n\t\t\t\tbackground-color: #1a260e !important;\r\n\t\t\t}\r\n\r\n\t\t\t.total-bar:hover {\r\n\t\t\t\tbackground: #1a260e !important;\r\n\t\t\t\tcolor: #F2F2F2 !important;\r\n\t\t\t}</style></div>');
$templateCache.put('app/entities/pending-limit-requests-view/pending-limit-requests-view.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="gatewayApp.pendingLimitRequestsView.title"></span><span>{{vm.reportDate|date :\'dd-MMM-yyyy\'}}</span></h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapse = !vm.ExpandOrCollapse" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#PendingLimitRequestsView"><img ng-src="{{vm.ExpandOrCollapse == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.pendingLimitRequestsView.criteria">Criteria</span></a></h4></div><div id="PendingLimitRequestsView" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="pendingLimitRequestsViewForm"><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.pendingLimitRequestsView.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="nonTerminatedBanks" display-column="bankName" placeholder="" form="pendingLimitRequestsViewForm"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.pendingLimitRequestsView.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="activeBranchesForBank" display-column="branchName" placeholder="" form="pendingLimitRequestsViewForm" filter-value="{{vm.bank.id}}"></div></div><div class="form-group"><div class="row"><label class="col-md-offset-3 control-label col-xs-6 col-md-6"><span data-translate="gatewayApp.pendingLimitRequestsView.customer"></span></label><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="allNonTerminatedCustomers" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" control-place-holder="Enter Customer ID or Name" display-column="customerCode,customerName" placeholder="" form="pendingLimitRequestsViewForm"><span class="cutomer-highlight" ng-if="vm.customer.customerMiddleName==null">{{vm.customer.customerFirstName+\' \'+vm.customer.customerLastName}}</span> <span class="cutomer-highlight" ng-if="vm.customer.customerMiddleName!=null">{{vm.customer.customerFirstName+\' \'+ vm.customer.customerMiddleName+\' \'+vm.customer.customerLastName}}</span></div><div class="col-md-1 col-sm-1 col-xs-2"><button class="btn btn-info active" ng-disabled="pendingLimitRequestsViewForm.$invalid||vm.clicked" ng-click="vm.getPendingLimitRequestsView();vm.clicked=true;" data-toggle="collapse" data-target="#PendingLimitRequestsView" data-translate="gatewayApp.pendingLimitRequestsView.go"></button></div></div></div></form></div></div></div><div ng-show="vm.pendingLimitRequestsViewList.length > 0"><div class="row"><div class="up-btn"><div class="dropdown" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportDataToCsvFile()">CSV</a></li><li><a ng-click="vm.exportDataToExcelFile();">XLS</a></li></ul></div></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="pendingLimitRequestsView" class="dataTable table table-striped table-hover"><thead><tr><th class="min-width-100" data-translate="gatewayApp.pendingLimitRequestsView.bank"></th><th class="td-text-align-center" data-translate="gatewayApp.pendingLimitRequestsView.requestsInitiatedByCustomer"></th><th class="td-text-align-center" data-translate="gatewayApp.pendingLimitRequestsView.requestsInitiatedByBank"></th></tr></thead><tbody><tr ng-repeat="limitRequestSummaryDTO in filterData = (vm.pendingLimitRequestsViewList | filter : filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td><span>{{limitRequestSummaryDTO.bankName}}</span></td><td class="td-text-align-center"><span ng-if="limitRequestSummaryDTO.customerLimitRequestsCount>0" class="numericHyperlinkFont"><a href="" ng-click="vm.getPendingLimitRequestDetails(limitRequestSummaryDTO, \'CUSTOMER\');">{{limitRequestSummaryDTO.customerLimitRequestsCount | number: \'0\'}}</a> </span><span ng-if="limitRequestSummaryDTO.customerLimitRequestsCount==0" class="numericHyperlinkFont">0</span></td><td class="td-text-align-center"><span ng-if="limitRequestSummaryDTO.bankLimitRequestsCount>0" class="numericHyperlinkFont"><a href="" ng-click="vm.getPendingLimitRequestDetails(limitRequestSummaryDTO, \'BANK\');">{{limitRequestSummaryDTO.bankLimitRequestsCount | number: \'0\'}}</a> </span><span ng-if="limitRequestSummaryDTO.bankLimitRequestsCount==0" class="numericHyperlinkFont">0</span></td></tr></tbody><tfoot class="table-footer" ng-if="filterData.length>0"><tr><td class="td-text-align-left" data-translate="gatewayApp.pendingLimitRequestsView.total"></td><td class="td-text-align-center"><a href="" ng-click="vm.getTotalPendingLimitRequestDetails(\'CUSTOMER\');">{{vm.totalCustomerLimitRequests}}</a></td><td class="td-text-align-center"><a href="" ng-click="vm.getTotalPendingLimitRequestDetails(\'BANK\');">{{vm.totalBankLimitRequests}}</a></td></tr></tfoot></table></div><div ng-show="vm.pendingLimitRequestsViewList.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><div class="row" ng-show="vm.pendingRequestDetailsList.length > 0"><h3 class="col-md-7 margin-top-10"><span ng-if="vm.requestType!=\'BANK\'" data-translate="gatewayApp.pendingLimitRequestsView.requestsInitiatedByCustomer" class="details-table-header"></span> <span ng-if="vm.requestType==\'BANK\'" data-translate="gatewayApp.pendingLimitRequestsView.requestsInitiatedByBank" class="details-table-header"></span></h3><div ng-show="vm.pendingRequestDetailsList.length>0" class="col-md-2 col-sm-3 col-xs-4 right-floating"><cspl-table-search control-model="filterDetailsText"></cspl-table-search></div></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden" ng-show="vm.pendingRequestDetailsList.length > 0"><table id="pendingLimitRequestsView" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.pendingLimitRequestsView.dateOfRequest"></th><th class="td-text-align-center" data-translate="gatewayApp.pendingLimitRequestsView.noOfDaysInPipeline"></th><th class="min-width-100" data-translate="gatewayApp.pendingLimitRequestsView.bank"></th><th class="min-width-100" data-translate="gatewayApp.pendingLimitRequestsView.tradingBranchName"></th><th data-translate="gatewayApp.pendingLimitRequestsView.customerId"></th><th class="min-width-100" data-translate="gatewayApp.pendingLimitRequestsView.customerName"></th><th data-translate="gatewayApp.pendingLimitRequestsView.requestType"></th><th data-translate="gatewayApp.pendingLimitRequestsView.limitCCY"></th><th data-translate="gatewayApp.pendingLimitRequestsView.instrument"></th><th class="td-text-align-right padding-right-10" data-translate="gatewayApp.pendingLimitRequestsView.requestedLimit"></th><th data-translate="gatewayApp.pendingLimitRequestsView.limitType"></th><th data-translate="gatewayApp.pendingLimitRequestsView.limitReinstatementMethod"></th><th data-translate="gatewayApp.pendingLimitRequestsView.maximumTenor"></th><th data-translate="gatewayApp.pendingLimitRequestsView.maximumValueDate"></th><th class="min-width-75" data-translate="gatewayApp.pendingLimitRequestsView.from"></th><th class="min-width-75" data-translate="gatewayApp.pendingLimitRequestsView.to"></th><th ng-if="vm.requestType==\'CUSTOMER\'" data-translate="gatewayApp.pendingLimitRequestsView.customerRemarks"></th><th data-translate="gatewayApp.pendingLimitRequestsView.bankRemarks"></th><th data-translate="gatewayApp.pendingLimitRequestsView.rejectionComment"></th><th data-translate="gatewayApp.pendingLimitRequestsView.lastAcionedBy"></th><th data-translate="gatewayApp.pendingLimitRequestsView.homeBranchName"></th></tr></thead><tbody class="approvalPolicyTable" ng-repeat="limitRequestHeaderDTO in filterDetailsData = (vm.pendingRequestDetailsList | filter : filterDetailsText) | orderBy: [\'-dateOfRequest\',\'bankName\', \'branchName\',\'customerName\'] | limitTo:noOfRecordsPerPageDetail:noOfRecordsPerPageDetail*(pageDetail-1)"><tr><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.dateOfRequest | date: \'dd-MMM-yyyy\'}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}" class="td-text-align-center border-top-td">{{limitRequestHeaderDTO.noOfDaysInPipeline}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.bankName}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.branchName}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.customerCode}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.customerName}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.requestType}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.limitCCY}}</td><td class="border-top-td">{{limitRequestHeaderDTO.limitRequestDetailsDTOList[0].limitInstrumentType}}</td><td class="td-text-align-right border-top-td">{{limitRequestHeaderDTO.limitRequestDetailsDTOList[0].requestedLimit | number: vm.noOfDecimalsForAmount}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.limitType}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.limitReinstateType}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}" ng-if="limitRequestHeaderDTO.maximumTenorValue==null"></td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}" ng-if="limitRequestHeaderDTO.maximumTenorValue!=null && limitRequestHeaderDTO.maximumTenorType==\'Days\'">{{limitRequestHeaderDTO.maximumTenorValue | number:0}} Day(s)</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}" ng-if="limitRequestHeaderDTO.maximumTenorValue!=null && limitRequestHeaderDTO.maximumTenorType==\'Months\'">{{limitRequestHeaderDTO.maximumTenorValue | number:0}} Month(s)</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.maximumValueDate | date: \'dd-MMM-yyyy\'}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.effectiveFrom | date: \'dd-MMM-yyyy\'}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.effectiveTo | date: \'dd-MMM-yyyy\'}}</td><td class="border-top-td" ng-if="vm.requestType==\'CUSTOMER\'" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.customerRemarks}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.bankRemarks}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.rejectionReason}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.lastActionedBy}}</td><td class="border-top-td" rowspan="{{vm.getLength(limitRequestHeaderDTO)}}">{{limitRequestHeaderDTO.homeBranchName}}</td></tr><tr ng-repeat="limitRequestDetailsDTO in limitRequestHeaderDTO.limitRequestDetailsDTOList.slice(1)"><td>{{limitRequestDetailsDTO.limitInstrumentType}}</td><td class="td-text-align-right">{{limitRequestDetailsDTO.requestedLimit | number: vm.noOfDecimalsForAmount}}</td></tr></tbody></table></div><div ng-show="vm.pendingRequestDetailsList.length > 0"><cspl-pagination record-count="filterDetailsData.length" control-model="pageDetail" items-per-page="noOfRecordsPerPageDetail"></cspl-pagination></div></div><div class="table-responsive" ng-show="vm.pendingLimitRequestsViewList.length==0"><span>No record found</span></div></div></section></div><script src="assets/js/tables.js"></script><style>.total-bar {\r\n\tbackground-color: #1a260e !important;\r\n}\r\n\r\n.total-bar:hover {\r\n\tbackground: #1a260e !important;\r\n\tcolor: #F2F2F2 !important;\r\n}\r\ntbody.approvalPolicyTable:hover tr{\r\n\tbackground-color: #F0CBA6 !important;\r\n\tcolor:#0D0D0D !important;\r\n}\r\ntbody.approvalPolicyTable:hover tr td{\r\n\r\n}</style></div>');
$templateCache.put('app/entities/pre-order-confirmation/pre-order-confirmation.html','<form name="preOrderConfirmationForm" role="form" my-enter="vm.submitAction(vm.showPreOrderConfirmation, vm.showGTT, vm.showPasswordWindow);clicked=true;"><div class="modal-header"><h4 class="modal-title" ng-show="vm.showPreOrderConfirmation">Pre-Order Confirmation</h4><h4 class="modal-title" ng-show="vm.showGTT">Good Till Time</h4><h4 class="modal-title" ng-show="vm.showPasswordWindow">Password</h4></div><div class="modal-body" style="margin: 0px"><div class="content" ng-show="vm.showPasswordWindow"><div><nmb-alert-error></nmb-alert-error></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.loginPassword"></span></label></div><div class="row"><div class="form-group password"><label class="sr-only" for="login-password">Password</label><div class="col-md-6 col-md-offset-3"><input id="login-user-password" name="password" type="password" ng-model="vm.password" class="form-control login-password" form="preOrderConfirmationForm" autocomplete="off" required><label class="help-block"><span data-translate="gatewayApp.userProfile.loginPasswordHelpText"></span></label></div></div></div></div><div class="content pre-order-confirmation" ng-if="vm.showPreOrderConfirmation && !vm.showRollOverOrEarlyDelivery"><div class="alerts" ng-show="vm.errorMessage!=\'\'"><div class="alert alert-danger"><span>{{vm.errorMessage}}</span></div></div><div class="alerts" ng-show="vm.orderDTO.buySellIndicator!=\'SELLBUY\'"><div class="alert pre-order-alert" ng-class="{\'pre-order-sell\': vm.orderDTO.buySellIndicator==\'SELL\', \'pre-order-buy\': vm.orderDTO.buySellIndicator==\'BUYY\'}"><span ng-show="vm.orderDTO.activityIndicator==\'MDFY\'">MODIFY </span><span ng-show="vm.orderDTO.activityIndicator==\'CNCL\'">CANCEL </span>&nbsp <span ng-show="vm.orderDTO.buySellIndicator==\'SELL\'">SELL</span>&nbsp <span ng-show="vm.orderDTO.buySellIndicator==\'BUYY\'">BUY</span>&nbsp<br><span>{{vm.orderDTO.orderAmount | number:vm.noOfDecimalsForAmount}}</span><span style="font-size: 14px">&nbsp {{vm.currencyPairCode}}&nbsp @ &nbsp</span><span ng-show="vm.orderDTO.typeOfOrder!=\'MRKT\'">{{vm.orderDTO.limitExchangeRate | number:4}}</span><br><span ng-show="vm.orderDTO.typeOfOrder==\'MRKT\'">Market price</span></div></div><div class="row sell-buy" ng-show="vm.orderDTO.buySellIndicator==\'SELLBUY\'"><div class="col-sm-6" style="padding: 0"><div class="alerts"><div class="alert pre-order-alert-buysell pre-order-sell"><span>SELL</span><br><span>{{vm.orderDTO.orderAmount | number:vm.noOfDecimalsForAmount}}</span> <span style="font-size: 12px">&nbsp;{{vm.currencyPairCode}}&nbsp; @ </span><span ng-show="vm.orderDTO.typeOfOrder!=\'MRKT\'">{{vm.orderDTO.sellLimitExchangeRate | number:4}}</span><br><span ng-if="vm.splitedValue!=\'\'" style="font-size: 14px">{{vm.splitedOrderAmount}}&nbsp;qty per leg</span><br><span ng-show="vm.orderDTO.typeOfOrder==\'MRKT\'">Market price</span></div></div></div><div class="col-sm-6" style="padding: 0"><div class="alerts"><div class="alert pre-order-alert-buysell pre-order-buy"><span>BUY</span><br><span>{{vm.orderDTO.orderAmount | number:vm.noOfDecimalsForAmount}}</span> <span style="font-size: 12px">&nbsp;{{vm.currencyPairCode}}&nbsp; @ </span><span ng-show="vm.orderDTO.typeOfOrder!=\'MRKT\'">{{vm.orderDTO.buyLimitExchangeRate | number:4}}</span><br><span ng-if="vm.splitedValue!=\'\'" style="font-size: 14px">{{vm.splitedOrderAmount}}&nbsp;qty per leg</span> <span ng-show="vm.orderDTO.typeOfOrder==\'MRKT\'">Market price</span></div></div></div></div><br><div class="col-centered" style="font-size:18px"><div class="row"><label class="col-sm-6 control-label right-label">Order Type</label><label class="col-sm-6 left-label">{{vm.eventTypeName}}</label></div><div class="row"><label class="col-sm-6 control-label right-label">Instrument</label><label class="col-sm-6 left-label">{{vm.orderDTO.instrumentCode}}</label></div><div class="row" ng-show="vm.orderDTO.instrumentCode==\'Forward\'"><label class="col-sm-6 control-label right-label">Settlement Date/Period</label><label class="col-sm-6 left-label"><span ng-if="vm.orderDTO.isOptionPeriod==true">{{vm.orderDTO.tradeSettlementDateFrom | date:\'dd-MMM-yyyy\'}}</span> <span ng-if="vm.orderDTO.isOptionPeriod==true">{{\' To \'}}</span> <span>{{vm.orderDTO.tradeSettlementDate | date:\'dd-MMM-yyyy\'}}</span></label></div><div class="row"><label class="col-sm-6 control-label right-label">Price Condition</label><label class="col-sm-6 left-label"><span ng-show="vm.orderDTO.typeOfOrder==\'LIMT\'">Limit</span> <span ng-show="vm.orderDTO.typeOfOrder==\'MRKT\'">Market</span> <span ng-show="vm.orderDTO.typeOfOrder==\'STLS\'">Stop Loss</span> <span ng-show="vm.orderDTO.typeOfOrder==\'TKPR\'">Take Profit</span></label></div><div class="row" ng-if="vm.orderDTO.isSplitOrder==true && vm.orderDTO.activityIndicator==\'PLAC\'"><label class="col-sm-6 control-label right-label">No. Of Splits</label><label class="col-sm-6 left-label"><span>{{vm.noOfSplits}}</span></label></div><div class="row"><label class="col-sm-6 control-label right-label">Time Condition</label><label class="col-sm-6 left-label"><span ng-show="vm.orderDTO.timeLimitIndicator==\'DAYY\'">Day</span> <span ng-show="vm.orderDTO.timeLimitIndicator==\'IOCC\'">IOC</span> <span ng-show="vm.orderDTO.timeLimitIndicator==\'GTTM\'">GTT - <span>{{vm.expiryTimeString}}</span></span></label></div><div class="row"><label class="col-sm-6 control-label right-label">Customer ID</label><label class="col-sm-6 left-label">{{vm.orderDTO.customerCode}}</label></div><div class="row"><label class="col-sm-6 control-label right-label">Customer Name</label><label style="word-wrap: break-word" class="col-sm-6 left-label">{{vm.orderDTO.customerName}}</label></div><div class="row"><label class="col-sm-6 control-label right-label">Relationship Bank</label><label class="col-sm-6 left-label">{{vm.orderDTO.bankName}}</label></div></div></div><div class="content pre-order-confirmation" ng-if="vm.showPreOrderConfirmation  && vm.showRollOverOrEarlyDelivery"><div class="alerts" ng-show="vm.errorMessage!=\'\'"><div class="alert alert-danger"><span>{{vm.errorMessage}}</span></div></div><div class="row sell-buy"><div class="col-sm-6" style="padding: 0"><div class="alerts"><div class="pre-order-alert-buysell" ng-class=" {\'alert pre-order-sell\' : vm.orderDTO.cancelledLegBuySellIndicator ==\'SELL\' , \'alert pre-order-buy\' : vm.orderDTO.cancelledLegBuySellIndicator ==\'BUYY\' }"><span>Cancellation</span><br><span ng-if="vm.orderDTO.cancelledLegBuySellIndicator == \'BUYY\'">BUY</span> <span ng-if="vm.orderDTO.cancelledLegBuySellIndicator != \'BUYY\'">SELL</span><br><span>{{vm.orderDTO.orderAmount | number:vm.noOfDecimalsForAmount}}</span> <span style="font-size: 12px">&nbsp;{{vm.currencyPairCode}}&nbsp; @ </span><span ng-show="vm.orderDTO.typeOfOrder!=\'MRKT\'">{{vm.orderDTO.indicativeCancellationRate | number:4}}</span> <span ng-show="vm.orderDTO.typeOfOrder==\'MRKT\'">Market price</span></div></div></div><div class="col-sm-6" style="padding: 0"><div class="alerts"><div class="pre-order-alert-buysell" ng-class=" {\'alert pre-order-sell\' : vm.orderDTO.buySellIndicator ==\'SELL\' , \'alert pre-order-buy\' : vm.orderDTO.buySellIndicator ==\'BUYY\' }"><span>Rebooking</span><br><span ng-if="vm.orderDTO.buySellIndicator == \'BUYY\'">BUY</span> <span ng-if="vm.orderDTO.buySellIndicator != \'BUYY\'">SELL</span><br><span>{{vm.orderDTO.orderAmount | number:vm.noOfDecimalsForAmount}}</span> <span style="font-size: 12px">&nbsp;{{vm.currencyPairCode}}&nbsp; @ </span><span ng-show="vm.orderDTO.typeOfOrder!=\'MRKT\'">{{vm.orderDTO.limitExchangeRate | number:4}}</span> <span ng-show="vm.orderDTO.typeOfOrder==\'MRKT\'">Market price</span><br></div></div></div></div><br><div class="col-centered" style="font-size:18px"><div class="row"><label class="col-sm-6 control-label right-label">Order Type</label><label class="col-sm-6 left-label">{{vm.eventTypeName}}</label></div><div class="row"><label class="col-sm-6 control-label right-label">Cancellation Instrument</label><label class="col-sm-6 left-label">{{vm.orderDTO.cancelledLegInstrumentCode}}</label></div><div class="row"><label class="col-sm-6 control-label right-label">Cancellation Settlement Date</label><label class="col-sm-6 left-label">{{vm.orderDTO.cancellationTradeSettlementDate | date:\'dd-MMM-yyyy\'}}</label></div><div class="row"><label class="col-sm-6 control-label right-label">Rebooking Instrument</label><label class="col-sm-6 left-label">{{vm.orderDTO.instrumentCode}}</label></div><div class="row"><label class="col-sm-6 control-label right-label">Rebooking Settlement Date</label><label class="col-sm-6 left-label">{{vm.orderDTO.rebookingSettlementDate | date:\'dd-MMM-yyyy\'}}</label></div><div class="row"><label class="col-sm-6 control-label right-label">Price Condition</label><label class="col-sm-6 left-label"><span ng-show="vm.orderDTO.typeOfOrder==\'LIMT\'">Limit</span> <span ng-show="vm.orderDTO.typeOfOrder==\'MRKT\'">Market</span> <span ng-show="vm.orderDTO.typeOfOrder==\'STLS\'">Stop Loss</span> <span ng-show="vm.orderDTO.typeOfOrder==\'TKPR\'">Take Profit</span></label></div><div class="row"><label class="col-sm-6 control-label right-label">Time Condition</label><label class="col-sm-6 left-label"><span ng-show="vm.orderDTO.timeLimitIndicator==\'DAYY\'">Day</span> <span ng-show="vm.orderDTO.timeLimitIndicator==\'IOCC\'">IOC</span> <span ng-show="vm.orderDTO.timeLimitIndicator==\'GTTM\'">GTT - <span>{{vm.expiryTimeString}}</span></span></label></div><div class="row"><label class="col-sm-6 control-label right-label">Customer ID</label><label class="col-sm-6 left-label">{{vm.orderDTO.customerCode}}</label></div><div class="row"><label class="col-sm-6 control-label right-label">Customer Name</label><label class="col-sm-6 left-label">{{vm.orderDTO.customerName}}</label></div><div class="row"><label class="col-sm-6 control-label right-label">Relationship Bank</label><label class="col-sm-6 left-label">{{vm.orderDTO.bankName}}</label></div><div class="row"><span class="help-block-error" style="text-align: center">* Above Prices shown are indicative and can vary based on prevailing market rates</span></div></div></div><div class="content" ng-show="vm.showGTT" style="overflow: visible"><nmb-alert-error></nmb-alert-error><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.expiryTime.gtt"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-time-picker control-model="vm.expiryDateTime" control-id="dtpExpiryDateTimeForGTT" time-zone="vm.serverDateTimeZone" control24hrformat="true" form="preOrderConfirmationForm" required></cspl-time-picker><span class="help-block-error" ng-show="vm.errorString!=\'\'">{{vm.errorString}}</span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" id="submitBtn" ng-if="vm.showPreOrderConfirmation" class="btn btn-info active" ng-disabled="clicked" ng-click="vm.submit();clicked=true;" autofocus><span data-translate="entity.action.submit">SUBMIT</span></button> <button type="submit" id="addGTTBtn" ng-if="vm.showGTT" class="btn btn-info active" ng-disabled="vm.errorString!=\'\'" ng-click="vm.add()" autofocus><span>Ok</span></button> <button type="submit" id="verifyPasswordBtn" class="btn btn-info active" ng-if="vm.showPasswordWindow" ng-disabled="vm.password == null  || clicked" ng-click="vm.checkPassword();clicked=true;" autofocus><span data-translate="gatewayApp.userProfile.verify"></span></button></div></div></form>');
$templateCache.put('app/entities/refresh-limit/refresh-limit.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.refreshLimit.title"></span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><form class="" role="form" name="refreshLimitForm"><div class="content"><fieldset ng-disabled="vm.disableEdit"><br><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-6"><label class="control-label" data-translate="gatewayApp.refreshLimit.customerType"></label><div id="btnGroup"><div class="btn-group col-sm-10 col-xs-12 col-md-9 col-lg-10 noPaddingMargin" style="width: auto;margin-bottom:8px"><label class="btn btn-primary" ng-model="vm.selectedType" uib-btn-radio="\'customer\'" data-translate="gatewayApp.refreshLimit.SingleCustomer"></label><label class="btn btn-primary" ng-model="vm.selectedType" uib-btn-radio="\'bank\'" data-translate="gatewayApp.refreshLimit.BankWiseCustomer"></label><label class="btn btn-primary" ng-model="vm.selectedType" uib-btn-radio="\'all\'" data-translate="gatewayApp.refreshLimit.All"></label></div></div></div><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.refreshLimit.bank"></span> <span ng-show="vm.requiredBankControl" cspl-mandatory></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bank" control-disabled="vm.disableBankControl" display-column="bankName" placeholder="" form="refreshLimitForm" control-required="vm.requiredBankControl" control-place-holder="{{vm.bankHolder}}"></div><div class="form-group" style="margin-bottom:0px"><label class="control-label" for="txtCustomer"><span data-translate="gatewayApp.refreshLimit.customer"></span> <span ng-show="vm.requiredCustomerControl" cspl-mandatory></span></label><cspl-ach control-id="txtCustomer" control-place-holder="{{vm.customerHolder}}" control-required="vm.requiredCustomerControl" lookup-name="customersForBank" filter-value="{{vm.bank.id}}" control-disabled="vm.disableCustomerControl" display-column="customerCode,customerName" form="refreshLimitForm" control-model="vm.customer"></cspl-ach><span class="cutomer-highlight" ng-if="vm.customer.customerMiddleName==null">{{vm.customer.customerFirstName+\' \'+vm.customer.customerLastName}}</span> <span class="cutomer-highlight" ng-if="vm.customer.customerMiddleName!=null">{{vm.customer.customerFirstName+\' \'+ vm.customer.customerMiddleName+\' \'+vm.customer.customerLastName}}</span> <span ng-if="vm.isEODCompletedAndSessionIsOpen" class="justified-help-block" data-translate="gatewayApp.refreshLimit.eodAndSessionOpenCompletionError"></span></div><div><button class="btn btn-info active" ng-disabled="(refreshLimitForm.$invalid || vm.clicked)" class="btn btn-info active" ng-click="vm.submitRefreshLimit(); vm.clicked = true;" style="float:right"><span data-translate="gatewayApp.refreshLimit.submit"></span></button></div></div><!--customer input--></fieldset></div></form></div></div></section></div></div>');
$templateCache.put('app/entities/regular-holiday/regular-holiday-dialog.html','<form name="regularHolidayForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="gatewayApp.regularHolidays.home.title"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="col-md-offset-2 row"><h4>{{vm.regularHolidaysHeader.currency.code}}</h4></div><fieldset ng-disabled="vm.disableForm"><div class="row modal-div-margin" ng-repeat="day in vm.dayList" ng-init="outerIndex=$index"><label class="col-md-offset-2 col-md-3 control-label" style="text-align:left;padding-top: 1%"><input type="checkbox" checklist-model="vm.daySelectionNumberList[$index]" checklist-value="day" id="{{\'C\'+$index}}" ng-model=""><span style="margin-bottom:2px">&nbsp;{{day.shortName}}</span>&nbsp;&nbsp;&nbsp;&nbsp;</label><div class="col-md-6" style="background-color:#333333; border-radius: 6px"><label style="margin-top: 3px" ng-repeat="weekNumber in vm.weekNumberList | orderBy: \'shortName\'"><input type="checkbox" checklist-model="vm.weekSelectionNumberList[$parent.$index]" checklist-value="weekNumber" ng-disabled="!vm.enableFields(\'#C\'+outerIndex)"><span style="margin-bottom:2px;color:#F2F2F2">&nbsp;{{weekNumber.shortName}}</span>&nbsp;&nbsp;&nbsp;&nbsp;</label></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel"></span></button> <button type="button" ng-show="showButton" class="btn btn-primary" ng-disabled="regularholidayForm.$invalid || clicked" ng-click="vm.resubmitRegularHoliday();clicked = true;"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-hide="showButton" ng-disabled="(vm.regularHolidaysHeader.id == null && regularHolidayForm.$invalid) || (vm.regularHolidaysHeader.id != null && regularHolidayForm.$pristine) || clicked" class="btn btn-info active" ng-click="vm.save();clicked = true;"><span data-translate="entity.action.save"></span></button></div></div></div></form>');
$templateCache.put('app/entities/regular-holiday/regular-holiday-view-dialog.html','<form name="regularHolidayForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><span data-translate="gatewayApp.regularHolidays.home.title"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><div class="col-md-offset-2 row"><h4>{{vm.regularHolidaysHeader.currency.code}}</h4></div><fieldset ng-disabled="vm.disableForm"><div class="row modal-div-margin" ng-repeat="day in vm.dayList"><label class="col-md-offset-2 col-md-3 control-label" style="text-align:left;padding-top: 1%"><input type="checkbox" checklist-model="vm.daySelectionNumberList[$index]" checklist-value="day" ng-disabled="true"><span style="margin-bottom:2px">&nbsp;{{day.shortName}}</span>&nbsp;&nbsp;&nbsp;&nbsp;</label><div class="col-md-6" style="background-color:#333333; border-radius: 6px" ng-disabled="!vm.daySelectionNumberList[$index]"><label style="margin-top: 3px" ng-repeat="weekNumber in vm.weekNumberList | orderBy: \'shortName\'"><input type="checkbox" checklist-model="vm.weekSelectionNumberList[$parent.$index]" checklist-value="weekNumber" ng-disabled="true"><span style="margin-bottom:2px;color:#F2F2F2">&nbsp;{{weekNumber.shortName}}</span>&nbsp;&nbsp;&nbsp;&nbsp;</label></div></div></fieldset><div><nmb-alert-error></nmb-alert-error></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button> <button type="button" ng-show="showDiscardButton" class="btn btn-reject" ng-click="vm.discardRegularHoliday()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-show="showButton" class="btn btn-reject" ng-click="vm.rejectRegularHoliday()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-show="showButton" class="btn btn-approve" ng-disabled="clicked" ng-click="vm.approveRegularHoliday();clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div></div></div></form>');
$templateCache.put('app/entities/regular-holiday/regular-holiday.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="gatewayApp.regularHolidays.home.title"></span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><!-- <div class="row">\r\n                    <div class="pull-right"> \r\n                        <button type="button" class="btn btn-info active " ng-click="vm.screenLog.screenLog(vm.screenName, 0, \'ADD\'); vm.launch()" ng-show="vm.permitRegularHolidayCreateEntityAction">\r\n                           \t<span class="glyphicon glyphicon-plus"></span>\r\n\t\t\t\t\t\t \t<span data-translate="gatewayApp.regularHolidays.regularHolidays"></span>\r\n\t\t\t\t\t\t</button>\r\n                    </div>\r\n                 </div>\r\n                  <br>  --><div class="bootstrap-tableresponsive"><div class="row"><cspl-table-export class="col-md-1 col-sm-1 col-xs-1" table-name="regularHolidayList" total-record-count="filterData.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" ng-show="vm.regularHolidaysHeader.length > 0"></cspl-table-export><cspl-table-search control-model="filterText" ng-show="vm.regularHolidaysHeader.length > 0" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><table id="regularHolidayList" class="dataTable table table-striped table-hover" ng-show="vm.regularHolidaysHeader.length > 0"><thead><tr><th><cspl-table-sort sort-type-model="sortType" default-sort="asc" sort-type-name="currencyCode" sort-reverse-model="sortReverse" header-text="\'gatewayApp.regularHolidays.currency\'|translate"></th><th></th></tr></thead><tbody><tr ng-repeat="regularHoliday in filterData = (vm.regularHolidaysHeader | filter : filterText | orderBy : \'currency.code\' : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{regularHoliday.currency.code | date:\'dd-MMM-yyyy\'}}</td><td style="text-align:center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitRegularHolidayViewEntityAction"><a ui-sref="regular-holiday.view({id: regularHoliday.id})" ng-click="vm.screenLog.screenLog(vm.screenName, regularHoliday.id, vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span class="" data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitRegularHolidayEditEntityAction"><a ui-sref="regular-holiday.edit({id: regularHoliday.id})" ng-click="vm.screenLog.screenLog(vm.screenName, regularHoliday.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span class="" data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="filterData.length == 0"><span>No record found</span></div><div ng-show="filterData.length > noOfRecordsPerPage"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/relationship-bank-fees-charge-view/relationship-bank-fees-charge-view.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.relationshipBankFeesAndCharges.title"></h2><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="module-wrapper"><section class="module"><div class="module-inner"><div><div class="row"><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="relationshipBankFeeTable" total-record-count="vm.bankFeeChargeDetails.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="vm.filterText" page-no="page" file-name="Relationship_Bank_Fee"></cspl-table-export></div><div class="float-right col-md-2 col-sm-3 col-xs-4"><cspl-table-search control-model="vm.filterText"></cspl-table-search></div></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="relationshipBankFeeTable" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.relationshipBankFeesChargesView.relationshipBankName">Relationship Bank</th><th data-translate="gatewayApp.relationshipBankFeesChargesView.lastUploadedDateTime">Last Uploaded Date Time</th><th></th><th></th></tr></thead><tbody><tr class="relationship-bank-fee-table-body" ng-repeat="relationshipBank in filterData = ( vm.bankFeeChargeDetails | filter : vm.filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td width="20%"><span>{{relationshipBank.bankName}}</span></td><td width="25%"><span ng-show="relationshipBank.createdDateTime != null && relationshipBank.fileContent != null">{{relationshipBank.createdDateTime | date:\'dd-MMM-yyyy hh:mm:ss a\'}}</span><span ng-show="relationshipBank.createdDateTime == null || relationshipBank.fileContent == null">-</span></td><td width="10%" ng-show="relationshipBank.fileContent != null"><span style="color: #FFAA1D" ng-show="relationshipBank.fileContent != null" class="glyphicon glyphicon-file" ng-click="vm.openBankFeesChargesPreview(relationshipBank.fileContent)" title="View Relationship Bank Fee & Charges"></span></td><td></td></tr></tbody></table></div><div ng-show="vm.bankFeeChargeDetails.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div></div>');
$templateCache.put('app/entities/request-reference-number/request-reference-number.html','<form name="requestReferenceForm"><div class="{{vm.theme}}"><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><img src="assets/images/Close.png"></button> <span data-translate="gatewayApp.requestReferenceNumber.label"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><!-- <div class="row">\r\n\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"><span\r\n\t\t\t\t\tdata-translate="gatewayApp.requestReferenceNumber.label"></span></label>\r\n\t\t\t</div> --><br><div class="col-sm-7 col-centered"><div class="form-group"><input id="ref-no" name="refNo" type="text" ng-model="vm.refNo" class="form-control ref-no" placeholder="Enter Reference No." maxlength="20" autocomplete="off" required> <span class="help-block margin-top-7" data-translate="gatewayApp.requestReferenceNumber.helpText" style="text-align: right">Enter CRR Number of Rejected,SelfWithdrawn,Withdrawn by System Application</span></div><div class="form-group modal-footer fetch-btn" ng-if="vm.isOTPSend==false"><button type="submit" style="padding:5px; width: 100px" class="btn btn-info lighttheme" ng-disabled="vm.disableGenerateOTP || vm.refNo==null || vm.refNo==undefined || vm.refNo==\'\'" ng-click="vm.disableGenerateOTP = true;vm.generateOTP();"><span data-translate="gatewayApp.requestReferenceNumber.fetch"></span></button></div><div class="form-group" ng-if="vm.isOTPSend"><div class="col-md-12" id="otp" control-model="vm.otp" otp-input-directive options="otpInput"></div><div class="row"><label class="help-block col-md-12"><a href="" ng-click="vm.resendOTP()">Resend</a></label></div></div><div class="form-group" ng-if="vm.isOTPSend"><div class="col-md-12"><span class="help-block" style="text-align: left" data-translate="gatewayApp.requestReferenceNumber.otpHelpText"></span></div></div><div class="form-group modal-footer fetch-btn" ng-if="vm.isOTPSend"><button type="submit" style="padding:5px" class="btn btn-info lighttheme" ng-disabled="vm.disableFetch || vm.otp==null || vm.otp==undefined || vm.otp==\'\'" ng-click="vm.disableFetch=true;vm.fetch();"><span data-translate="gatewayApp.requestReferenceNumber.verify"></span></button></div></div><br></div></div></div></form>');
$templateCache.put('app/entities/role-definition/manage-role.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title">Manage Roles</h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="pull-right"><button type="button" class="btn btn-info active" ng-click="vm.screenLog.screenLog(vm.screenName, 0, vm.entityConstants.ENTITY_ACTION_TYPE.ADD); vm.launch()" ng-show="vm.permitOrganisationRoleCreateEntityAction"><img ng-src="assets/images/Add.png"> <span>Role</span></button><div class="col-md-6 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="tblUserRole" total-record-count="vm.roles.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="Roles"></cspl-table-export></div><div class="table-responsive"><table id="tblUserRole" class="dataTable table table-striped table-hover"><thead><tr><th>Short Name</th><th>Long Name</th><th></th></tr></thead><tbody><tr ng-repeat="role in filterData = (vm.roles | filter : filterText)"><td>{{role.shortName}}</td><td>{{role.name}}</td><td style="text-align:center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitOrganisationRoleViewEntityAction"><a ui-sref="manage-role.view({id:role.id})" ng-click="vm.screenLog.screenLog(vm.screenName, role.id, vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitOrganisationRoleEditEntityAction"><a ui-sref="manage-role.edit({id:role.id})" ng-click="vm.screenLog.screenLog(vm.screenName, role.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></a></li><li ng-show="vm.permitOrganisationRoleDeleteEntityAction"><a ui-sref="manage-role.delete({id:role.id})" ng-click="vm.screenLog.screenLog(vm.screenName, role.id, vm.entityConstants.ENTITY_ACTION_TYPE.DELETE)"><span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/role-definition/role-delete-dialog.html','<form name="deleteForm" ng-submit="clicked=true;vm.confirmDelete(vm.role.id)"><div class="modal-header-red"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" style="text-align:left;padding-left:3%">Are you sure?</h4></div><div class="modal-body"><nmb-alert-error></nmb-alert-error><p><textarea class="form-control modal-header-red" rows="6" ng-model="vm.reason" placeholder="Please provide a reason" required></textarea></p><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger" ng-disabled="clicked"><span data-translate="entity.action.delete">Delete</span></button></div></div></div></form>');
$templateCache.put('app/entities/role-definition/role-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="roleForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title">Role</h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="row"><div class="row" style="align-items:center; display: flex"><label class="col-md-4 control-label" cspl-mandatory>Short Name</label><div class="col-md-6"><cspl-text control-model="vm.role.shortName" control-type="ShortName" control-maxlength="20" control-id="txtRoleShortName" form="roleForm" required></div></div><div class="row" style="align-items:center; display: flex"><label class="col-md-4 control-label" cspl-mandatory>Long Name</label><div class="col-md-6"><cspl-text control-model="vm.role.name" control-id="txtRoleName" control-maxlength="100" form="roleForm" required></div></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showButton" class="btn btn-primary" ng-disabled="vm.clicked" ng-click="vm.clicked=true;vm.resubmitRole();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="!showButton" ng-disabled="roleForm.$invalid || ( vm.role.id!=null && !roleForm.$dirty) || vm.clicked" class="btn btn-info active" ng-click="vm.clicked=true;vm.save();"><span data-translate="entity.action.save">Save</span></button></div></div></div></div></form>');
$templateCache.put('app/entities/role-definition/role-view-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="roleForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title">Role</h4></div><div class="modal-body"><div class="content"><div class="row"><div class="row" style="align-items:center; display: flex"><label class="col-md-4 control-label">Short Name</label><div class="col-md-6"><cspl-text control-model="vm.role.shortName" control-id="txtRoleShortName" control-disabled="true"></div></div><div class="row" style="align-items:center; display: flex"><label class="col-md-4 control-label">Full Name</label><div class="col-md-6"><cspl-text control-model="vm.role.name" control-id="txtRoleName" control-disabled="true"></div></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardRole()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showButton" class="btn btn-reject" ng-click="vm.rejectRole()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" autofocus class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.clicked=true;vm.approveRole();"><span data-translate="entity.action.approve">Approve</span></button></div></div></div></div></form>');
$templateCache.put('app/entities/security-policy/security-policy-dialog.html','<form name="securityPolicyForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title">Assign Roles</h4></div><div class="modal-body"><div class="content"><nmb-alert-error></nmb-alert-error><div class="row"><fieldset ng-disabled="vm.ViewDisable"><div class="row"><b>{{vm.securityPolicyDTO.themeShortName}}</b></div><br><div class="col-md-8 col-md-offset-2"><table class="datatables-nosort table table-striped table-hover"><thead><tr><th></th><th>Role</th></tr></thead><tbody><tr ng-repeat="role in vm.roles" ng-hide="role.systemGenerated"><td>&nbsp; <input type="checkbox" checklist-model="vm.selected.orgRoleID" checklist-value="role.id" ng-model="justAnotherCheckedVar"></td><td>{{role.name}}</td></tr></tbody></table></div><br><br></fieldset></div><div class="modal-footer"><button type="button" ng-show="showCancelButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-show="vm.btnClose" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span>Close</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-click="vm.clicked=true;vm.resubmitSecurityPolicy()" ng-disabled="vm.clicked"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardSecurityPolicy()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="vm.btnApproveReject" class="btn btn-reject" ng-click="vm.rejectSecurityPolicy()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="vm.btnApproveReject" class="btn btn-approve" ng-click="vm.clicked=true;vm.approveSecurityPolicy()" ng-disabled="vm.clicked" autofocus><span data-translate="entity.action.approve">Approve</span></button> <button type="submit" ng-if="showSaveButton" class="btn btn-info active" ng-click="vm.clicked=true;vm.save()" ng-disabled="securityPolicyForm.$pristine || vm.clicked"><span data-translate="entity.action.save">Save</span></button></div></div></div></form>');
$templateCache.put('app/entities/security-policy/security-policy.html','<style>.pagination {width: 100%; text-align: center; float:right;}</style><div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.securityPolicy.home.setupLabel">Security Policy</h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="pull-right"><div class="col-md-6 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="tblSecurityPolicy" total-record-count="vm.securityPolicies.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="Security_Policy"></cspl-table-export></div></div><div class="table-responsive"><table id="tblSecurityPolicy" class="dataTable table table-striped table-hover"><thead><tr><th><cspl-table-sort sort-type-model="sortType" default-sort="asc" sort-type-name="themeShortName" sort-reverse-model="sortReverse" header-text="\'global.securityPolicy.ThemeActions\' | translate"></th><th ng-hide="true"><cspl-table-sort sort-type-model="sortType" sort-type-name="entityOwnerTypes" sort-reverse-model="sortReverse" header-text="\'global.securityPolicy.OwnerType\' | translate"></th><th data-translate="global.securityPolicy.Roles">Can be performed by</th><th style="min-width:30px"></th></tr></thead><tbody><tr ng-repeat="securityPolicy in filterData = (vm.securityPolicies | filter : filterText | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{securityPolicy.themeShortName}}</td><td ng-hide="true">{{securityPolicy.entityOwnerTypes.join(\', \')}}</td><td>{{securityPolicy.orgRoleNames.join(\', \')}}</td><td><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitSecurityPolicyMapEntityAction"><a ui-sref="security-policy.new({id:securityPolicy.themeID})"><span class="hidden-xs hidden-sm" data-translate="entity.action.assignRoles"></span></a></li></ul></div></td></tr></tbody></table><div stlye=""><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div></div><script src="assets/js/tables.js"></script>');
$templateCache.put('app/entities/server-component-status/server-component-status.html','<div ncy-breadcrumb class="row" style="margin-left: 10px"></div><nmb-alert></nmb-alert><div class="row" style="padding: 5px"></div><div class="row" style="margin-left: 10px"><div class="col-lg-12"><div class="row"><div class="col-md-12"><div ng-hide="!vm.isRefreshCompelete" style="text-align: right"><h6>Auto refresh in {{vm.autoRefreshCountDown}} secs.</h6></div><div ng-hide="vm.isRefreshCompelete" style="text-align: right"><h6>Refreshing...</h6></div></div></div><section class="item" style="padding: 5px"><div class="panel panel-primary componentStatusBox"><div class="panel-heading text-left"><span data-translate="gatewayApp.servercomponent.title"></span><!-- <a href="" style="position: relative;float:right;  color: #fff;" ng-class="{\'linkDisabled\' : vm.isRefreshDisabled}"  ><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="!vm.isRefreshDisabled?refresh():\'\';" style="font-size:20px;" ></i></a>\r\n\t\t\t\t\t\t                      --></div><div class="panel-body" id="componentsbox"><div class="module-content-inner"><div class="row" style="width: 100%"><div class="leftLableRow"><label class="component-label left-align-label" style="float:left;padding-right:5px"><span data-translate="gatewayApp.servercomponent.connectedSite"></span></label><div id="btnGroup" class="col-md-4" style="border-radius:5px"><div class="btn-group"><label class="btn btn-primary connectedSiteBtn" ng-model="vm.connectedSite" style="pointer-events:none;border-radius:4px" uib-btn-radio="1">Primary Server</label><label class="btn btn-primary connectedSiteBtn" ng-model="vm.connectedSite" style="pointer-events:none" uib-btn-radio="2">Secondary Server</label></div></div></div><div class="lableRow" width="30%"><label class="component-label left-align-label" style="padding-right:10px"><span data-translate="gatewayApp.servercomponent.key"></span></label><div class="labelBox serverSuccessKey" style="width: 55%" ng-if="vm.connectedSite==1"><span data-translate="gatewayApp.servercomponent.successStatusKey"></span></div><div class="labelBox secondaryServerSuccessKey" style="width: 50%" ng-if="vm.connectedSite==2"><span data-translate="gatewayApp.servercomponent.successStatusKey"></span></div><div class="labelseparator"></div><div class="labelBox serverErrorKey" style="width: 30%"><span data-translate="gatewayApp.servercomponent.failureStatusKey"></span></div></div></div><br><div class="row serverContainer" align="center"><div class="col-md-1" ng-class="{\'primaryServerBox\' : vm.serverComponentStatus[\'HEC\'].isActive == true &&  vm.serverComponentStatus[\'OPS\'].activeNode == 1,\r\n\t\t\t\t\t\t\t\t\'serverErrorBox\' :  vm.serverComponentStatus[\'HEC\'].isActive == false,\r\n\t\t\t\t\t\t\t\t\'secondaryServerBox\' : vm.serverComponentStatus[\'HEC\'].isActive == true &&  vm.serverComponentStatus[\'OPS\'].activeNode == 2}"><div class="serverBoxContent" data-translate="gatewayApp.servercomponent.heConnectivity" class="component-text"></div></div><div class="col-md-1" ng-class="{\'primaryServerBox\' : vm.serverComponentStatus[\'QRS\'].isActive == true &&  vm.serverComponentStatus[\'QRS\'].activeNode == 1\r\n\t\t\t\t\t\t\t\t,\'serverErrorBox\' :  vm.serverComponentStatus[\'QRS\'].isActive == false,\r\n\t\t\t\t\t\t\t\t\'secondaryServerBox\' : vm.serverComponentStatus[\'QRS\'].isActive == true &&  vm.serverComponentStatus[\'QRS\'].activeNode == 2}"><div class="serverBoxContent" data-translate="gatewayApp.servercomponent.queryServerService" class="component-text"></div></div><div class="col-md-1" ng-class="{\'primaryServerBox\' : vm.serverComponentStatus[\'OPS\'].isActive == true \r\n\t\t\t\t\t\t\t\t&&  vm.serverComponentStatus[\'OPS\'].activeNode == 1,\'serverErrorBox\' :  vm.serverComponentStatus[\'OPS\'].isActive == false,\r\n\t\t\t\t\t\t\t\t\'secondaryServerBox\' : vm.serverComponentStatus[\'OPS\'].isActive == true &&  vm.serverComponentStatus[\'OPS\'].activeNode == 2}"><div class="serverBoxContent" data-translate="gatewayApp.servercomponent.orderProcessingServer" class="component-text"></div></div><div class="col-md-1" ng-class="{\'primaryServerBox\' : vm.serverComponentStatus[\'PNS\'].isActive == true &&  vm.serverComponentStatus[\'PNS\'].activeNode == 1\r\n\t\t\t\t\t\t\t\t,\'serverErrorBox\' :  vm.serverComponentStatus[\'PNS\'].isActive == false,\r\n\t\t\t\t\t\t\t\t\'secondaryServerBox\' : vm.serverComponentStatus[\'PNS\'].isActive == true &&  vm.serverComponentStatus[\'PNS\'].activeNode == 2}"><div class="serverBoxContent" data-translate="gatewayApp.servercomponent.pushNotificationServer" class="component-text"></div></div><div class="col-md-1" ng-class="{\'primaryServerBox\' : vm.serverComponentStatus[\'WBS\'].isActive == true &&  vm.serverComponentStatus[\'WBS\'].activeNode == 1\r\n\t\t\t\t\t\t\t\t,\'serverErrorBox\' :  vm.serverComponentStatus[\'WBS\'].isActive == false,\r\n\t\t\t\t\t\t\t\t\'secondaryServerBox\' : vm.serverComponentStatus[\'WBS\'].isActive == true &&  vm.serverComponentStatus[\'WBS\'].activeNode == 2}"><div class="serverBoxContent" data-translate="gatewayApp.servercomponent.webServer" class="component-text"></div></div><div class="col-md-1" ng-class="{\'primaryServerBox\' : vm.serverComponentStatus[\'DBW\'].isActive == true &&  vm.serverComponentStatus[\'DBW\'].activeNode == 1\r\n\t\t\t\t\t\t\t\t,\'serverErrorBox\' :  vm.serverComponentStatus[\'DBW\'].isActive == false,\r\n\t\t\t\t\t\t\t\t\'secondaryServerBox\' : vm.serverComponentStatus[\'DBW\'].isActive == true &&  vm.serverComponentStatus[\'DBW\'].activeNode == 2}"><div class="serverBoxContent" data-translate="gatewayApp.servercomponent.dbWriterServer" class="component-text"></div></div><div class="col-md-1" ng-class="{\'primaryServerBox\' : vm.serverComponentStatus[\'APS\'].isActive == true &&  vm.serverComponentStatus[\'APS\'].activeNode == 1\r\n\t\t\t\t\t\t\t\t,\'serverErrorBox\' :  vm.serverComponentStatus[\'APS\'].isActive == false,\r\n\t\t\t\t\t\t\t\t\'secondaryServerBox\' : vm.serverComponentStatus[\'APS\'].isActive == true &&  vm.serverComponentStatus[\'APS\'].activeNode == 2}"><div class="serverBoxContent" data-translate="gatewayApp.servercomponent.apiServer" class="component-text"></div></div><div class="col-md-1" ng-class="{\'primaryServerBox\' : vm.serverComponentStatus[\'AIS\'].isActive == true &&  vm.serverComponentStatus[\'AIS\'].activeNode == 1\r\n\t\t\t\t\t\t\t\t,\'serverErrorBox\' :  vm.serverComponentStatus[\'AIS\'].isActive == false,\r\n\t\t\t\t\t\t\t\t\'secondaryServerBox\' : vm.serverComponentStatus[\'AIS\'].isActive == true &&  vm.serverComponentStatus[\'AIS\'].activeNode == 2}"><div class="serverBoxContent" data-translate="gatewayApp.servercomponent.apiIntegrationServer" class="component-text"></div></div></div></div></div></div><div class="componentActionBox" id="componentsActionbox"><div class="panel panel-primary action-box"><div class="panel-heading text-left" id="heBox"><span data-translate="gatewayApp.servercomponent.heStatusUpdate"></span><!-- <a href="" style="position: relative;float:right;  color: #fff;" ng-class="{\'linkDisabled\' : vm.isRefreshDisabled}"  ><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="!vm.isRefreshDisabled?refresh():\'\';" style="font-size:20px;" ></i></a>\r\n\t\t\t\t\t\t                      --></div><div class="panel-body" style="height: 28vh"><div class="module-content-inner"><div class="row" style="width: 50%"><label class="col-md-5 component-label left-align-label" style="padding-left: 0px"><span data-translate="gatewayApp.servercomponent.currentStatus"></span></label><div class="labelBox" style="width: 70%" ng-class="{\'component-success-box\' : vm.currentStatus==\'Online\' ,\'component-error-box\' : vm.currentStatus!=\'Online\'}"><span ng-if="vm.currentStatus==\'Online\'" data-translate="gatewayApp.servercomponent.online"></span> <span ng-if="vm.currentStatus!=\'Online\'" data-translate="gatewayApp.servercomponent.offline"></span></div></div><div class="component-container-row"><button ng-if="vm.currentStatus==\'Online\'" class="btn btn-info active offline-text online-offline-btn" ng-disabled="vm.orderServerManualLoginStatus==\'PROGRESS\' || vm.heStatusUpdate==\'PROGRESS\'" ng-click="vm.sendHEStatusUpdate();" data-translate="gatewayApp.servercomponent.changeStatusToOffline"></button> <button ng-if="vm.currentStatus!=\'Online\'" class="btn btn-info active online-text online-offline-btn" ng-disabled="vm.orderServerManualLoginStatus==\'PROGRESS\' || vm.heStatusUpdate==\'PROGRESS\'" ng-click="vm.sendHEStatusUpdate();" data-translate="gatewayApp.servercomponent.changeStatusToOnline"></button><br><div style="text-align: center" ng-show="vm.heStatusUpdate==\'PROGRESS\'"><span data-translate="gatewayApp.servercomponent.workingOnIt"></span><br><img class="ProgressStatusImage" src="assets/images/Progress_bar.GIF"></div></div></div></div></div><div class="panel separator"></div><div class="panel panel-primary action-box" style="padding-left: 2px"><div class="panel-heading text-left" id="orderserverBox"><span data-translate="gatewayApp.servercomponent.orderServerManualLogin"></span><!-- <a href="" style="position: relative;float:right;  color: #fff;" ng-class="{\'linkDisabled\' : vm.isRefreshDisabled}"  ><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="!vm.isRefreshDisabled?refresh():\'\';" style="font-size:20px;" ></i></a>\r\n\t\t\t\t\t\t                      --></div><div class="panel-body" style="height: 28vh"><div class="module-content-inner"><div class="component-container-row" style="padding-top: 10px"><label class="component-label left-align-label"><span data-translate="gatewayApp.servercomponent.note1"></span></label><br><br><button class="btn btn-info active online-offline-btn" ng-disabled="vm.orderServerManualLoginStatus==\'PROGRESS\' || vm.heStatusUpdate==\'PROGRESS\'" ng-click="vm.orderServerManualLogin();" data-translate="gatewayApp.servercomponent.startRecovery"></button><br><div style="text-align: center;padding-top:10px" ng-show="vm.orderServerManualLoginStatus==\'PROGRESS\'"><span data-translate="gatewayApp.servercomponent.recoveryInProgress"></span><br><img class="ProgressStatusImage" src="assets/images/Progress_bar.GIF"></div></div></div></div></div></div></section></div></div><script src="assets/js/tables.js"></script>');
$templateCache.put('app/entities/session-log-report/session-log-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.AuditLog.sessionLog"></span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><form name="sessionLogForm" role="form" novalidate><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseSessionLog = !vm.ExpandOrCollapseSessionLog" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#SessionLogReport"><img ng-src="{{vm.ExpandOrCollapseSessionLog == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.SessionLog.criteria">Criteria</span></a></h4></div><div id="SessionLogReport" ng-class="{\'accordion-body collapse\':vm.valid}" style="background-color: black"><div class="accordion-content1"><div class="row" ng-show="vm.userEntityOwnerType == \'Clearcorp\'"><cspl-entity-lookup user-entity-owner-type="vm.userEntityOwnerType" selected-entity-owner-type="vm.selectedEntityOwnerType" bank-value="vm.bankValue" branch-value="vm.branchValue" customer-value="vm.customerValue" user-value="vm.userValue" user-list-value="vm.userListValue" control-class="col-md-3  col-sm-12 col-md-offset-3" control-form="sessionLogForm"></cspl-entity-lookup></div><div class="row" ng-show="vm.userEntityOwnerType != \'Clearcorp\'"><label class="col-md-offset-3 col-md-3 control-label"><span data-translate="gatewayApp.SessionLog.user"></span></label></div><div class="row" ng-show="vm.userEntityOwnerType != \'Clearcorp\'"><div class="col-md-offset-3 col-md-3"><cspl-ach control-model="vm.user" control-id="txtUser" lookup-name="allUsersForOrganisation" display-column="login" form="sessionLogForm"></cspl-ach></div></div><!-- <div class="row">\r\n\t\t\t\t\t\t\t\t\t<label class="col-md-offset-3 col-md-3 control-label"\r\n\t\t\t\t\t\t\t\t\t\tcspl-mandatory> <span\r\n\t\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.SessionLog.fromDate"></span>\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-3 col-md-offset-3">\r\n\t\t\t\t\t\t\t\t\t\t<cspl-dtp control-model="vm.fromDate" control-id="dtpFromDate"\r\n\t\t\t\t\t\t\t\t\t\t\tform="sessionLogForm" required />\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<label class="col-md-3 control-label col-md-offset-3"\r\n\t\t\t\t\t\t\t\t\t\tcspl-mandatory> <span\r\n\t\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.SessionLog.toDate"></span>\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-3  col-md-offset-3">\r\n\t\t\t\t\t\t\t\t\t\t<cspl-dtp control-model="vm.toDate" control-id="dtpToDate"\r\n\t\t\t\t\t\t\t\t\t\t\tform="sessionLogForm" required />\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t\t\t<button class=" btn btn-info active"\r\n\t\t\t\t\t\t\t\t\t\t\tng-disabled="sessionLogForm.$invalid" data-toggle="collapse"\r\n\t\t\t\t\t\t\t\t\t\t\tng-click="vm.getSessionLogDetails()"\r\n\t\t\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.SessionLog.go"></button>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> --><div class="col-sm-6 col-centered" style="margin-top: 10px"><div class="col-md-12" style="padding-left: 0"><div class="col-md-2" style="padding-left: 0; margin-top: 10px"><input type="radio" name="optradio" id="radio1" ng-model="vm.historicalOrCurrent" style="margin-right: 5px" value="Historical" form="sessionLogForm"><label style="color: #FFFFFF" for="radio1" data-translate="gatewayApp.SessionLog.historical"></label></div><div class="col-md-5"><cspl-dtp control-model="vm.fromDate" control-id="dtpFromDate" form="sessionLogForm" control-required="vm.historicalOrCurrent != \'Current\'" control-disabled="vm.historicalOrCurrent == \'Current\'" control-max-date="vm.yesterdayDate"></div><div class="col-md-5"><cspl-dtp control-model="vm.toDate" control-id="dtpToDate" form="sessionLogForm" control-required="vm.historicalOrCurrent != \'Current\'" control-disabled="vm.historicalOrCurrent == \'Current\'" control-max-date="vm.yesterdayDate"></div></div><div class="col-md-12" style="padding-left: 0"><div class="col-md-2" style="padding-left: 0; margin-top: 10px; padding-right: 0"><input type="radio" name="optradio" id="radio2" ng-model="vm.historicalOrCurrent" style="margin-right: 5px" value="Current" form="sessionLogForm"><label style="color: #FFFFFF" for="radio2" data-translate="gatewayApp.SessionLog.forToday"></label></div><div class="col-md-5" style="margin-top: 10px"><label class="control-label"><span>{{vm.reportDate\t| date : \'dd-MMM-yyyy\'}}</span></label></div></div><div class="col-md-12" style="padding-left: 0"><div class="col-md-2" style="padding-left: 0"></div><div class="col-md-5"></div><div class="col-md-5"><button class="btn btn-info active" ng-click="vm.getSessionLogDetails();" ng-disabled="sessionLogForm.$invalid||vm.clicked" style="float: right; margin-top:0px" data-translate="entity.action.go" data-toggle="collapse" data-target="#SessionLogReport"></button></div></div></div></div></div></div></form><div ng-show="vm.sessionLogDetails.length > 0"><div class="row"><div class="pull-right"><div class="col-md-6 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><cspl-table-export table-name="SessionLogDetails" total-record-count="filterData.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="Session_Log_Report"></cspl-table-export><br></div></div><div class="table-responsive"><table id="SessionLogDetails" class="datatables-nosort table table-striped table-hover"><thead><tr><th style="padding-left: 20px" data-translate="gatewayApp.SessionLog.userName"></th><th data-translate="gatewayApp.SessionLog.loggedInDateTime"></th><th data-translate="gatewayApp.SessionLog.email"></th><th data-translate="gatewayApp.SessionLog.mobile"></th><th data-translate="gatewayApp.SessionLog.ipAddress"></th><th data-translate="gatewayApp.SessionLog.loginSuccess"></th></tr></thead><tbody><tr ng-repeat="sessionLogDetail in filterData = (vm.sessionLogDetails | filter : filterText | orderBy  : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="padding-left: 20px"><span ng-show="vm.selectedHistoryOrCurrent != \'Current\'"><a ui-sref="session-manage-users-view({id: sessionLogDetail.userId})">{{sessionLogDetail.login}} </a></span><span ng-show="vm.selectedHistoryOrCurrent == \'Current\'"><a ui-sref="session-manage-users-view({id: sessionLogDetail.user.id})">{{sessionLogDetail.login}}</a></span></td><td>{{sessionLogDetail.loggedInDateTime|date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td>{{sessionLogDetail.userEmail}}</td><td>{{sessionLogDetail.userMobileCountryCode+\'-\'+sessionLogDetail.userMobile}}</td><td>{{sessionLogDetail.ipAddress}}</td><td style="padding-left: 20px" ng-show="sessionLogDetail.loginSuccess==true"><span style="opacity: 0.001">{{sessionLogDetail.loginSuccess}}</span><span class="icon icon_check"></span></td></tr></tbody></table></div></div><div class="table-responsive" ng-show="vm.sessionLogDetails.length==0"><span>No record found</span></div><div ng-show="vm.sessionLogDetails.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></section></div></div>');
$templateCache.put('app/entities/settlement-report/settlement-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.settlementReport.title" data-translate-values="{value: {{vm.businessDate}}}">Settlement Report</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px;  margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapse = !vm.ExpandOrCollapse" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#TradesToBeSettledReport"><img ng-src="{{vm.ExpandOrCollapse == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.settlementReport.criteria">Criteria</span></a></h4></div><div id="TradesToBeSettledReport" class="collapse in" style="background-color: black"><div class="accordion-content1"><form name="settlementReportForm" role="form" novalidate><div class="col-sm-6 col-centered"><div class="row"><div class="col-md-12" ng-if="vm.entityOwnerType == \'Clearcorp\'"><div class="col-md-6"><label class="control-label" style="text-align:right;padding-top:5px"><span data-translate="gatewayApp.settlementReport.viewFor"></span></label></div></div><div class="col-md-12" ng-if="vm.entityOwnerType == \'Clearcorp\'"><div id="btnGroup" class="col-md-6" style="border-radius:5px"><div class="btn-group noPaddingMargin" style="width: auto;margin-bottom:8px;border-radius:4px"><label class="btn btn-primary connectedSiteBtn viewForBtn" ng-model="vm.viewFor" style="border-radius:4px" uib-btn-radio="\'CUSTOMER\'">CUSTOMER</label><label class="btn btn-primary connectedSiteBtn viewForBtn" ng-model="vm.viewFor" style="border-radius:4px" uib-btn-radio="\'BANKBRANCH\'">BANK/BRANCH</label></div></div></div><div class="col-md-12" ng-if="vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'CUSTOMER\'"><div class="col-md-6"><label class="control-label" style="text-align:right;padding-top:5px"><span data-translate="gatewayApp.settlementReport.customer"></span></label></div></div><div class="col-md-12" ng-if="vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'CUSTOMER\'"><div class="col-md-6"><cspl-ach control-model="vm.customer" control-id="txtcustomer" lookup-name="AllCustomersNonProp" display-column="customerCode,customerName" form="settlementReportForm"></cspl-ach><span class="help-block" ng-show="vm.customer!=null && vm.customer!=undefined" title="{{vm.customer.customerName}}">{{vm.customer.customerName}}</span></div></div><div class="col-md-12" ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\'"><div class="col-md-6"><label class="control-label" style="text-align:right;padding-top:5px"><span data-translate="gatewayApp.settlementReport.customerName"></span></label></div><div class="col-md-4"><label class="control-label" style="text-align:right;padding-top:5px"><span data-translate="gatewayApp.settlementReport.customerId"></span></label></div></div><div class="col-md-12" ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\'"><div class="col-md-6"><cspl-text control-model="vm.customer.customerName" control-id="txtCustomerName" control-disabled="true" form="settlementReportForm" required></div><div class="col-md-4"><cspl-text control-model="vm.customer.customerCode" control-id="txtCustomerId" control-disabled="true" form="settlementReportForm" required></div></div><div class="col-md-12" ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\'\r\n\t\t\t\t\t\t\t\t|| (vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'CUSTOMER\')"><div class="col-md-5"><label class="control-label" style="text-align:right;padding-top:5px"><span data-translate="gatewayApp.settlementReport.relationshipBank"></span></label></div></div><div class="col-md-12" ng-if="(vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'CUSTOMER\')"><div class="col-md-7"><cspl-ach control-model="vm.bank" control-id="txtRelationshipBank" lookup-name="tradingBankAllStatus" filter-value="{{vm.customer.id}}" display-column="bankName" form="settlementReportForm"></cspl-ach></div></div><div class="col-md-12" ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\'"><div class="col-md-7"><cspl-ach control-model="vm.bank" control-id="txtRelationBank" lookup-name="tradingBankAllStatus" filter-value="{{vm.globalValues.getOrgId()}}" display-column="bankName" form="settlementReportForm"></cspl-ach></div></div><div class="col-md-12" ng-if="vm.entityOwnerType==\'Bank\' || (vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'BANKBRANCH\')"><div class="col-md-5"><label class="control-label" style="text-align:right;padding-top:5px"><span data-translate="gatewayApp.settlementReport.bank"></span></label></div></div><div class="col-md-12" ng-if="vm.entityOwnerType==\'Bank\'"><div class="col-md-7"><cspl-text control-model="vm.bank.bankName" control-id="txtBankName" control-disabled="true" form="settlementReportForm" required></div></div><div class="col-md-12" ng-if="(vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'BANKBRANCH\')"><div class="col-md-7"><cspl-ach control-model="vm.bank" control-id="txtBank" lookup-name="bank" display-column="bankName" form="settlementReportForm"></cspl-ach></div></div><div class="col-md-12" ng-if="vm.entityOwnerType==\'Bank\' || (vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'BANKBRANCH\')"><div class="col-md-5"><label class="control-label" style="text-align:right;padding-top:5px"><span data-translate="gatewayApp.settlementReport.branch"></span></label></div></div><div class="col-md-12" ng-if="vm.entityOwnerType==\'Bank\'"><div class="col-md-7"><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="activeBranchesForBank" display-column="branchId,branchName" form="settlementReportForm"></cspl-ach></div></div><div class="col-md-12" ng-if="(vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'BANKBRANCH\')"><div class="col-md-7"><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="activeBranchesForBank" filter-value="{{vm.bank.id}}" display-column="branchId,branchName" form="settlementReportForm"></cspl-ach></div></div><div class="col-md-12" ng-if="vm.entityOwnerType==\'Branch\'"><div class="col-md-5"><label class="control-label" style="text-align:right;padding-top:5px"><span data-translate="gatewayApp.settlementReport.branch"></span></label></div></div><div class="col-md-12" ng-if="vm.entityOwnerType==\'Branch\'"><div class="col-md-7"><cspl-text control-model="vm.branch.branchName" control-id="txtBranchName" control-disabled="true" form="settlementReportForm" required></div></div><div class="col-md-12" ng-if="vm.entityOwnerType==\'Bank\'  || vm.entityOwnerType == \'Branch\' || \r\n\t\t\t\t\t\t\t\t(vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'BANKBRANCH\')"><div class="col-md-5"><label class="control-label" style="text-align:right;padding-top:5px"><span data-translate="gatewayApp.settlementReport.filterBy"></span></label></div><div class="col-md-5"><label class="control-label" style="text-align:right;padding-top:5px"><span data-translate="gatewayApp.settlementReport.customer"></span></label></div></div><div class="col-md-12" ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType == \'Branch\' "><div class="col-md-5"><select name="filterBy" class="form-control select-style" ng-model="vm.selectedFilterBy" ng-options="filterBy.name for filterBy in vm.filterBy track by filterBy.id"><option selected="selected" disabled="disabled" hidden style="display: none" value=""></option></select></div><div class="col-md-5 custom-ach" ng-if="vm.branch != null"><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="allTypeCustomersNonProp" filter-value="{{vm.globalValues.getOrganisation().id}}~~{{vm.branch.id}}" display-column="customerCode,customerName" form="settlementReportForm" control-disabled="vm.selectedFilterBy.name != \'All Customer\'"></cspl-ach><span class="help-block" ng-show="vm.customer!=null && vm.customer!=undefined" title="{{vm.customer.customerName}}">{{vm.customer.customerName}}</span></div><div class="col-md-5 custom-ach" ng-if="vm.branch == null"><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="customersForBankNonProp" filter-value="{{vm.globalValues.getOrganisation().id}}" display-column="customerCode,customerName" form="settlementReportForm" control-disabled="vm.selectedFilterBy.name != \'All Customer\'"></cspl-ach><span class="help-block" ng-show="vm.customer!=null && vm.customer!=undefined" title="{{vm.customer.customerName}}">{{vm.customer.customerName}}</span></div></div><div class="col-md-12" ng-if="(vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'BANKBRANCH\')"><div class="col-md-5"><select name="filterBy" class="form-control select-style" ng-model="vm.selectedFilterBy" ng-options="filterBy.name for filterBy in vm.filterBy track by filterBy.id"><option selected="selected" disabled="disabled" hidden style="display: none" value=""></option></select></div><div class="col-md-5 custom-ach" ng-if="vm.branch != null && vm.bank != null"><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="allTypeCustomersNonProp" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" display-column="customerCode,customerName" form="settlementReportForm" control-disabled="vm.selectedFilterBy.name != \'All Customer\'"></cspl-ach><span class="help-block" ng-show="vm.customer!=null && vm.customer!=undefined" title="{{vm.customer.customerName}}">{{vm.customer.customerName}}</span></div><div class="col-md-5 custom-ach" ng-if="vm.bank!= null && vm.branch == null"><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="customersForBankNonProp" filter-value="{{vm.bank.id}}" display-column="customerCode,customerName" form="settlementReportForm" control-disabled="vm.selectedFilterBy.name != \'All Customer\'"></cspl-ach><span class="help-block" ng-show="vm.customer!=null && vm.customer!=undefined" title="{{vm.customer.customerName}}">{{vm.customer.customerName}}</span></div><div class="col-md-5 custom-ach" ng-if="vm.bank== null && vm.branch == null"><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="AllCustomersNonProp" display-column="customerCode,customerName" form="settlementReportForm" control-disabled="vm.selectedFilterBy.name != \'All Customer\'"></cspl-ach><span class="help-block" ng-show="vm.customer!=null && vm.customer!=undefined" title="{{vm.customer.customerName}}">{{vm.customer.customerName}}</span></div></div><div class="col-md-12"><div class="col-md-5"><label class="control-label" style="text-align:right;padding-top:5px"><span data-translate="gatewayApp.settlementReport.currencyPair"></span></label></div></div><div class="col-md-12"><div class="col-md-7"><cspl-ach control-model="vm.currencyPair" control-id="txtcurrencyPair" lookup-name="currencyPair" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}" display-column="code" form="settlementReportForm"></cspl-ach></div></div><div class="col-md-12"><div class="col-md-5"><label class="control-label" style="text-align:right;padding-top:5px"><span data-translate="gatewayApp.settlementReport.instrument"></span></label></div></div><div class="col-md-12"><div class="col-md-5"><select name="select" class="form-control select-style" ng-model="vm.instrument" ng-options="instrumentType.instrumentCode for instrumentType in vm.instrumentTypes track by instrumentType.id"><option value="">--All--</option></select></div></div><div class="col-md-12 margin-top-10"><div class="col-md-5"><label class="control-label" style="text-align:right;padding-top:5px"><span data-translate="gatewayApp.settlementReport.tradeType"></span></label></div></div><div class="col-md-12"><div class="col-md-5"><select name="select" class="form-control select-style" ng-model="vm.tradeType" ng-options="eventType.name for eventType in vm.eventTypes track by eventType.id"><option value="">--All--</option></select></div></div><div class="col-md-12 margin-top-10"><div class="col-md-5"><label class="control-label" style="padding-top:5px" cspl-mandatory><span data-translate="gatewayApp.settlementReport.reportPeriod"></span></label></div></div><div class="col-md-12"><div class="col-md-4"><cspl-dtp control-model="vm.fromSetDate" control-id="dtpFromDate" form="settlementReportForm" control-min-date="vm.currentDate" required></div><div class="col-md-4"><cspl-dtp control-model="vm.toSetDate" control-min-date="vm.currentDate" control-id="dtpToDate" form="settlementReportForm" required></div><div class="col-lg-1"><button class="btn btn-info active" style="float: right" ng-disabled="settlementReportForm.$invalid||vm.clicked" ng-click="vm.getSettlementReport();" data-toggle="collapse" data-target="#TradesToBeSettledReport" data-translate="gatewayApp.settlementReport.go"></button></div></div><!-- <div class="col-md-12" ng-if="!(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'CUSTOMER\')">\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class = "col-md-10">\r\n\t\t\t\t\t\t\t\t\t\t<button class=" btn btn-info active" style="float:right"\r\n\t\t\t\t\t\t\t\t\t\t\tng-disabled="settlementReportForm.$invalid"\r\n\t\t\t\t\t\t\t\t\t\t\tng-click="vm.getSettlementReport();" data-toggle="collapse" \r\n\t\t\t\t\t\t\t\t\t\t\t\tdata-target="#TradesToBeSettledReport"\r\n\t\t\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.settlementReport.go">\r\n\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-12" ng-if="(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'CUSTOMER\')">\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class = "col-md-7">\r\n\t\t\t\t\t\t\t\t\t\t<button class=" btn btn-info active" style="float:right"\r\n\t\t\t\t\t\t\t\t\t\t\tng-disabled="settlementReportForm.$invalid"\r\n\t\t\t\t\t\t\t\t\t\t\tng-click="vm.getSettlementReport();" data-toggle="collapse" \r\n\t\t\t\t\t\t\t\t\t\t\t\tdata-target="#TradesToBeSettledReport"\r\n\t\t\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.settlementReport.go">\r\n\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t --></div></div></form></div></div></div><div class="row" ng-if="vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0].tradeDTOList.length>0 \r\n\t\t\t\t\t\t|| vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].tradeDTOList.length>0\r\n\t\t\t\t\t\t|| vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1].tradeDTOList.length>0 \r\n\t\t\t\t\t\t|| vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].tradeDTOList.length>0"><div class="dropdown col-md-3" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div><cspl-table-search control-model="vm.filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="row"><div class="table-responsive settlement-report-table"><table class="dataTable table table-striped table-hover" id="settlementReportView" ng-if="vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0].tradeDTOList.length>0 \r\n\t\t\t\t\t\t|| vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].tradeDTOList.length>0\r\n\t\t\t\t\t\t|| vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1].tradeDTOList.length>0 \r\n\t\t\t\t\t\t|| vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].tradeDTOList.length>0"><tbody class="group-header" ng-if="vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0].tradeDTOList.length>0 || vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1].tradeDTOList.length>0"><tr><td ng-if="vm.entityOwnerType!=\'SingleUserCustomer\'  && vm.entityOwnerType!=\'MultiUserCustomer\'" style="font-size:14px">{{vm.settlementReportSummaryDTOList[0].type}}</td><td></td><td></td><td></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td></td><td></td><td></td><td></td><td></td></tr></tbody><tbody class="group-header" ng-if="vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0].tradeDTOList.length>0"><tr ng-click="vm.expandBuyTrades=!vm.expandBuyTrades"><td><span class="buySellTrades" ng-if="vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0].orderType==\'BUY\'">BUY TRADES</span> <span style="float:left" class="icon arrow_carrot-down" aria-hidden="true" ng-show="vm.expandBuyTrades"></span> <span style="float:left" class="icon arrow_carrot-right" aria-hidden="true" ng-show="!vm.expandBuyTrades"></span></td><td></td><td></td><td></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td></td><td></td><td></td><td></td><td></td></tr></tbody><tbody ng-if="vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0].tradeDTOList.length>0"><tr class="thead"><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.srNo"></td><td style="min-width:80px" data-translate="gatewayApp.settlementReport.tradeDate"></td><td data-translate="gatewayApp.settlementReport.currencyPair"></td><td data-translate="gatewayApp.settlementReport.instrument"></td><td data-translate="gatewayApp.settlementReport.tradeNo"></td><td data-translate="gatewayApp.settlementReport.tradeType"></td><td data-translate="gatewayApp.settlementReport.settlementLeg"></td><td data-translate="gatewayApp.settlementReport.sourceTradeNo"></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')" data-translate="gatewayApp.settlementReport.relationshipBank"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.customerId"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.customerName"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )" data-translate="gatewayApp.settlementReport.counterPartyId"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )" data-translate="gatewayApp.settlementReport.counterPartyName"></td><!-- <td ng-if="vm.entityOwnerType!=\'SingleUserCustomer\' && vm.entityOwnerType!=\'MultiUserCustomer\'" data-translate="gatewayApp.settlementReport.custId"></td>\r\n\t\t\t\t\t\t\t\t\t<td ng-if="vm.entityOwnerType!=\'SingleUserCustomer\' && vm.entityOwnerType!=\'MultiUserCustomer\'" data-translate="gatewayApp.settlementReport.customerName"></td> --><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.tradedQuantity"></td><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.grossRate"></td><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.netRate"></td><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.netINRRate"></td><td style="min-width:80px" data-translate="gatewayApp.settlementReport.settlementStartDate"></td><td style="min-width:80px" data-translate="gatewayApp.settlementReport.settlementDate"></td><td style="min-width:100px" data-translate="gatewayApp.settlementReport.dateTime"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks1"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks2"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks3"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks4"></td><td data-translate="gatewayApp.settlementReport.exposureType"></td><td data-translate="gatewayApp.settlementReport.exposureSubType"></td><td data-translate="gatewayApp.settlementReport.deliveryMode"></td><td data-translate="gatewayApp.settlementReport.source"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.fcyInrPrice"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.fcyUsdPrice"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.adjustedUsdInr"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.fcyUsdSwapPoints"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.usdInrSwapPoints"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.uniqueRequestId"></td></tr></tbody><tbody class="table-container-box" ng-if="vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0].tradeDTOList.length>0 && vm.expandBuyTrades"><tr ng-repeat="tradeDTO in vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0].tradeDTOList | filter : vm.filterText"><td class="tableNumericColumn">{{tradeDTO.index}}</td><td>{{tradeDTO.tradeDate | date:\'dd-MMM-yyyy\'}}</td><td>{{tradeDTO.currencyPairCode || \'-\'}}</td><td>{{tradeDTO.instrumentCode}}</td><td ng-if="vm.entityOwnerType == \'SingleUserCustomer\' || vm.entityOwnerType == \'MultiUserCustomer\'\r\n\t\t\t\t\t\t\t\t\t|| (vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'CUSTOMER\')">{{tradeDTO.tradeSequenceNumber}}</td><td ng-if="vm.entityOwnerType == \'Bank\' || vm.entityOwnerType == \'Branch\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'BANKBRANCH\')">{{tradeDTO.tradeSequenceNumberHOView}}</td><td>{{tradeDTO.tradeTypeName}}</td><td>{{tradeDTO.settlementLegName}}</td><td ng-if="tradeDTO.sourceTradeNo != null && tradeDTO.sourceTradeNo !=0"><a ui-sref="trade-activity({orderNumber:tradeDTO.sourceOrderNo})" style="text-decoration:underline">{{tradeDTO.sourceTradeNo}}</a></td><td ng-if="!(tradeDTO.sourceTradeNo != null && tradeDTO.sourceTradeNo !=0)">{{\' \'}}</td><td class="bank-name" ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"><span title="{{tradeDTO.bankName}}">{{tradeDTO.bankName}}</span></td><!-- <td class="bank-name" ng-if="vm.entityOwnerType==\'Bank\'"><span title="{{tradeDTO.branchName}}">{{tradeDTO.branchName}}</span></td> --><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.customerCode}}</td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.customerName}}</td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )">{{tradeDTO.counterPartyId}}</td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )">{{tradeDTO.counterPartyName}}</td><!-- <td ng-if="vm.entityOwnerType!=\'SingleUserCustomer\' && vm.entityOwnerType!=\'MultiUserCustomer\'">{{tradeDTO.customerName}}</td> --><td class="tableNumericColumn">{{tradeDTO.usdAmount | number:vm.noOfDecimalsForAmount}}</td><td class="tableNumericColumn">{{tradeDTO.grossRate | number:vm.noOfDecimalsForRate}}</td><td class="tableNumericColumn">{{tradeDTO.netRate | number:vm.noOfDecimalsForRate}}</td><td class="tableNumericColumn">{{tradeDTO.netINRAmount | number:vm.noOfDecimalsForAmount}}</td><td><span ng-if="tradeDTO.tradeSettlementDateFrom !=null">{{tradeDTO.tradeSettlementDateFrom| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="tradeDTO.tradeSettlementDateFrom ==null">{{\'\'}}</span></td><td>{{tradeDTO.settlementDate | date:\'dd-MMM-yyyy\'}}</td><td>{{tradeDTO.tradeTimeString|date:\'dd-MMM-yyyy\' }}</td><td style="min-width:360px">{{tradeDTO.userRemarks || \'-\'}}</td><td style="min-width:360px">{{tradeDTO.remarks2 || \'-\'}}</td><td style="min-width:360px">{{tradeDTO.remarks3 || \'-\'}}</td><td style="min-width:360px">{{tradeDTO.remarks4 || \'-\'}}</td><td>{{tradeDTO.exposureTypeName || \'-\'}}</td><td>{{tradeDTO.exposureSubTypeName || \'-\'}}</td><td>{{tradeDTO.deliveryMode || \'-\'}}</td><td>{{tradeDTO.sourceAppName || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.fcyInrPrice || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.fcyUsdPrice || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.adjustedUsdInr || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.fcyUsdSwapPoints || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.usdInrSwapPoints || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.uniqueRequestId || \'-\'}}</td></tr></tbody><tbody ng-if="vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0].tradeDTOList.length>0  && (vm.filterText==undefined || vm.filterText==null || vm.filterText==\'\')"><tr class="non-hoverable-tr"><td class="sub-header control-label">TOTAL</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td class="tableNumericColumn sub-header control-label">{{vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0].totalUSDAmount | number:vm.noOfDecimalsForAmount}}</td><td></td><td></td><td class="tableNumericColumn sub-header control-label">{{vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0].totalNetINRAmount | number:vm.noOfDecimalsForAmount}}</td><td></td></tr></tbody><tbody class="group-header" ng-if="vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0].tradeDTOList.length>0 && vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1].tradeDTOList.length>0"><tr><td></td><td></td><td></td><td></td><td></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td></td><td></td><td></td><td></td><td></td></tr></tbody><tbody class="group-header" ng-if="vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1].tradeDTOList.length>0"><tr ng-click="vm.expandSellTrades=!vm.expandSellTrades"><td><span class="buySellTrades" ng-if="vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1].orderType==\'SELL\'">SELL TRADES</span> <span style="float:left" class="icon arrow_carrot-down" aria-hidden="true" ng-show="vm.expandSellTrades"></span> <span style="float:left" class="icon arrow_carrot-right" aria-hidden="true" ng-show="!vm.expandSellTrades"></span></td><td></td><td></td><td></td><td></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td></td><td></td><td></td><td></td><td></td></tr></tbody><tbody ng-if="vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1].tradeDTOList.length>0 "><tr class="thead"><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.srNo"></td><td data-translate="gatewayApp.settlementReport.tradeDate"></td><td data-translate="gatewayApp.settlementReport.currencyPair"></td><td data-translate="gatewayApp.settlementReport.instrument"></td><td data-translate="gatewayApp.settlementReport.tradeNo"></td><td data-translate="gatewayApp.settlementReport.tradeType"></td><td data-translate="gatewayApp.settlementReport.settlementLeg"></td><td data-translate="gatewayApp.settlementReport.sourceTradeNo"></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')" data-translate="gatewayApp.settlementReport.relationshipBank"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.customerId"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.customerName"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )" data-translate="gatewayApp.settlementReport.counterPartyId"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )" data-translate="gatewayApp.settlementReport.counterPartyName"></td><!-- <td ng-if="vm.entityOwnerType!=\'SingleUserCustomer\' && vm.entityOwnerType!=\'MultiUserCustomer\'" data-translate="gatewayApp.settlementReport.custId"></td>\r\n\t\t\t\t\t\t\t\t\t<td ng-if="vm.entityOwnerType!=\'SingleUserCustomer\' && vm.entityOwnerType!=\'MultiUserCustomer\'" data-translate="gatewayApp.settlementReport.customerName"></td> --><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.tradedQuantity"></td><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.grossRate"></td><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.netRate"></td><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.netINRRate"></td><td data-translate="gatewayApp.settlementReport.settlementStartDate"></td><td data-translate="gatewayApp.settlementReport.settlementDate"></td><td style="min-width:100px" data-translate="gatewayApp.settlementReport.dateTime"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks1"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks2"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks3"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks4"></td><td data-translate="gatewayApp.settlementReport.exposureType"></td><td data-translate="gatewayApp.settlementReport.exposureSubType"></td><td data-translate="gatewayApp.settlementReport.deliveryMode"></td><td data-translate="gatewayApp.settlementReport.source"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.fcyInrPrice"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.fcyUsdPrice"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.adjustedUsdInr"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.fcyUsdSwapPoints"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.usdInrSwapPoints"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.uniqueRequestId"></td></tr></tbody><tbody class="table-container-box" ng-if="vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1].tradeDTOList.length>0 && vm.expandSellTrades"><tr ng-repeat="tradeDTO in vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1].tradeDTOList | filter : vm.filterText"><td class="tableNumericColumn">{{tradeDTO.index}}</td><td>{{tradeDTO.tradeDate | date:\'dd-MMM-yyyy\'}}</td><td>{{tradeDTO.currencyPairCode || \'-\'}}</td><td>{{tradeDTO.instrumentCode}}</td><td ng-if="vm.entityOwnerType == \'SingleUserCustomer\' || vm.entityOwnerType == \'MultiUserCustomer\'\r\n\t\t\t\t\t\t\t\t\t|| (vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'CUSTOMER\')">{{tradeDTO.tradeSequenceNumber}}</td><td ng-if="vm.entityOwnerType == \'Bank\' || vm.entityOwnerType == \'Branch\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'BANKBRANCH\')">{{tradeDTO.tradeSequenceNumberHOView}}</td><td>{{tradeDTO.tradeTypeName}}</td><td>{{tradeDTO.settlementLegName}}</td><td ng-if="tradeDTO.sourceTradeNo != null && tradeDTO.sourceTradeNo !=0"><a ui-sref="trade-activity({orderNumber:tradeDTO.sourceOrderNo})" style="text-decoration:underline">{{tradeDTO.sourceTradeNo}}</a></td><td ng-if="!(tradeDTO.sourceTradeNo != null && tradeDTO.sourceTradeNo != 0)">{{\' \'}}</td><td class="bank-name" ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"><span title="{{tradeDTO.bankName}}">{{tradeDTO.bankName}}</span></td><!-- <td class="bank-name" ng-if="vm.entityOwnerType==\'Bank\'"><span title="{{tradeDTO.branchName}}">{{tradeDTO.branchName}}</span></td> --><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.customerCode}}</td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.customerName}}</td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )">{{tradeDTO.counterPartyId}}</td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )">{{tradeDTO.counterPartyName}}</td><!-- <td ng-if="vm.entityOwnerType!=\'SingleUserCustomer\' && vm.entityOwnerType!=\'MultiUserCustomer\'">{{tradeDTO.customerName}}</td> --><td class="tableNumericColumn">{{tradeDTO.usdAmount | number:vm.noOfDecimalsForAmount}}</td><td class="tableNumericColumn">{{tradeDTO.grossRate | number:vm.noOfDecimalsForRate}}</td><td class="tableNumericColumn">{{tradeDTO.netRate | number:vm.noOfDecimalsForRate}}</td><td class="tableNumericColumn">{{tradeDTO.netINRAmount | number:vm.noOfDecimalsForAmount}}</td><td><span ng-if="tradeDTO.tradeSettlementDateFrom !=null">{{tradeDTO.tradeSettlementDateFrom| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="tradeDTO.tradeSettlementDateFrom ==null">{{\'\'}}</span></td><td>{{tradeDTO.settlementDate | date:\'dd-MMM-yyyy\'}}</td><td>{{tradeDTO.tradeTimeString|date:\'dd-MMM-yyyy\' }}</td><td style="min-width:360px">{{tradeDTO.userRemarks || \'-\'}}</td><td style="min-width:360px">{{tradeDTO.remarks2 || \'-\'}}</td><td style="min-width:360px">{{tradeDTO.remarks3 || \'-\'}}</td><td style="min-width:360px">{{tradeDTO.remarks4 || \'-\'}}</td><td>{{tradeDTO.exposureTypeName || \'-\'}}</td><td>{{tradeDTO.exposureSubTypeName || \'-\'}}</td><td>{{tradeDTO.deliveryMode || \'-\'}}</td><td>{{tradeDTO.sourceAppName || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.fcyInrPrice || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.fcyUsdPrice || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.adjustedUsdInr || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.fcyUsdSwapPoints || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.usdInrSwapPoints || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.uniqueRequestId || \'-\'}}</td></tr></tbody><tbody ng-if="vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1].tradeDTOList.length>0 && (vm.filterText==undefined || vm.filterText==null || vm.filterText==\'\')"><tr class="non-hoverable-tr"><td class="sub-header control-label">TOTAL</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td class="tableNumericColumn sub-header control-label">{{vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1].totalUSDAmount | number:vm.noOfDecimalsForAmount}}</td><td></td><td></td><td class="tableNumericColumn sub-header control-label">{{vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1].totalNetINRAmount | number:vm.noOfDecimalsForAmount}}</td><td></td></tr></tbody><tbody class="group-header" ng-if="(vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].tradeDTOList.length>0 || vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].tradeDTOList.length>0) && (vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].tradeDTOList.length>0 || vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].tradeDTOList.length>0)"><tr><td></td><td></td><td></td><td></td><td></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td></td><td></td><td></td><td></td><td></td></tr></tbody><tbody class="group-header" ng-if="vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].tradeDTOList.length>0 || vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].tradeDTOList.length>0"><tr><td style="font-size:14px">{{vm.settlementReportSummaryDTOList[1].type}}</td><td></td><td></td><td></td><td></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td></td><td></td><td></td><td></td><td></td></tr></tbody><tbody class="group-header" ng-if="vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].tradeDTOList.length>0"><tr ng-click="vm.expandPropBuyTrades=!vm.expandPropBuyTrades"><td><span class="buySellTrades" ng-if="vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].orderType==\'BUY\'">BUY TRADES</span> <span style="float:left" class="icon arrow_carrot-down" aria-hidden="true" ng-show="vm.expandPropBuyTrades"></span> <span style="float:left" class="icon arrow_carrot-right" aria-hidden="true" ng-show="!vm.expandPropBuyTrades"></span></td><td></td><td></td><td></td><td></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td></td><td></td><td></td><td></td><td></td></tr></tbody><tbody ng-if="vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].tradeDTOList.length>0"><tr class="thead"><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.srNo"></td><td style="min-width:80px" data-translate="gatewayApp.settlementReport.tradeDate"></td><td data-translate="gatewayApp.settlementReport.currencyPair"></td><td data-translate="gatewayApp.settlementReport.instrument"></td><td data-translate="gatewayApp.settlementReport.tradeNo"></td><td data-translate="gatewayApp.settlementReport.tradeType"></td><td data-translate="gatewayApp.settlementReport.settlementLeg"></td><td data-translate="gatewayApp.settlementReport.sourceTradeNo"></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')" data-translate="gatewayApp.settlementReport.relationshipBank"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.customerId"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.customerName"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )" data-translate="gatewayApp.settlementReport.counterPartyBranchId"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )" data-translate="gatewayApp.settlementReport.counterPartyBranchName"></td><!-- <td ng-if="vm.entityOwnerType!=\'SingleUserCustomer\' && vm.entityOwnerType!=\'MultiUserCustomer\'" data-translate="gatewayApp.settlementReport.custId"></td>\r\n\t\t\t\t\t\t\t\t\t<td ng-if="vm.entityOwnerType!=\'SingleUserCustomer\' && vm.entityOwnerType!=\'MultiUserCustomer\'" data-translate="gatewayApp.settlementReport.customerName"></td> --><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.tradedQuantity"></td><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.grossRate"></td><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.netRate"></td><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.netINRRate"></td><td style="min-width:80px" data-translate="gatewayApp.settlementReport.settlementStartDate"></td><td style="min-width:80px" data-translate="gatewayApp.settlementReport.settlementDate"></td><td style="min-width:100px" data-translate="gatewayApp.settlementReport.dateTime"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks1"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks2"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks3"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks4"></td><td data-translate="gatewayApp.settlementReport.exposureType"></td><td data-translate="gatewayApp.settlementReport.exposureSubType"></td><td data-translate="gatewayApp.settlementReport.deliveryMode"></td><td data-translate="gatewayApp.settlementReport.source"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.fcyInrPrice"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.fcyUsdPrice"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.adjustedUsdInr"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.fcyUsdSwapPoints"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.usdInrSwapPoints"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.uniqueRequestId"></td></tr></tbody><tbody class="table-container-box" ng-if="vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].tradeDTOList.length>0 && vm.expandPropBuyTrades"><tr ng-repeat="tradeDTO in vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].tradeDTOList | filter : vm.filterText"><td class="tableNumericColumn">{{tradeDTO.index}}</td><td>{{tradeDTO.tradeDate | date:\'dd-MMM-yyyy\'}}</td><td>{{tradeDTO.currencyPairCode || \'-\'}}</td><td>{{tradeDTO.instrumentCode}}</td><td ng-if="vm.entityOwnerType == \'SingleUserCustomer\' || vm.entityOwnerType == \'MultiUserCustomer\'\r\n\t\t\t\t\t\t\t\t\t|| (vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'CUSTOMER\')">{{tradeDTO.tradeSequenceNumber}}</td><td ng-if="vm.entityOwnerType == \'Bank\' || vm.entityOwnerType == \'Branch\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'BANKBRANCH\')">{{tradeDTO.tradeSequenceNumberHOView}}</td><td>{{tradeDTO.tradeTypeName}}</td><td>{{tradeDTO.settlementLegName}}</td><td ng-if="tradeDTO.sourceTradeNo != null && tradeDTO.sourceTradeNo !=0">{{tradeDTO.sourceTradeNo}}</td><td ng-if="!(tradeDTO.sourceTradeNo != null && tradeDTO.sourceTradeNo !=0)">{{\' \'}}</td><td class="bank-name" ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"><span title="{{tradeDTO.bankName}}">{{tradeDTO.bankName}}</span></td><!-- <td class="bank-name" ng-if="vm.entityOwnerType==\'Bank\'"><span title="{{tradeDTO.branchName}}">{{tradeDTO.branchName}}</span></td> --><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.customerCode}}</td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.customerName}}</td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )">{{tradeDTO.counterPartyId}}</td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )">{{tradeDTO.counterPartyName}}</td><!-- <td ng-if="vm.entityOwnerType!=\'SingleUserCustomer\' && vm.entityOwnerType!=\'MultiUserCustomer\'">{{tradeDTO.customerName}}</td> --><td class="tableNumericColumn">{{tradeDTO.usdAmount | number:vm.noOfDecimalsForAmount}}</td><td class="tableNumericColumn">{{tradeDTO.grossRate | number:vm.noOfDecimalsForRate}}</td><td class="tableNumericColumn">{{tradeDTO.netRate | number:vm.noOfDecimalsForRate}}</td><td class="tableNumericColumn">{{tradeDTO.netINRAmount | number:vm.noOfDecimalsForAmount}}</td><td><span ng-if="tradeDTO.tradeSettlementDateFrom !=null">{{tradeDTO.tradeSettlementDateFrom| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="tradeDTO.tradeSettlementDateFrom ==null">{{\'\'}}</span></td><td>{{tradeDTO.settlementDate | date:\'dd-MMM-yyyy\'}}</td><td>{{tradeDTO.tradeTimeString|date:\'dd-MMM-yyyy\' }}</td><td style="min-width:360px">{{tradeDTO.userRemarks || \'-\'}}</td><td style="min-width:360px">{{tradeDTO.remarks2 || \'-\'}}</td><td style="min-width:360px">{{tradeDTO.remarks3 || \'-\'}}</td><td style="min-width:360px">{{tradeDTO.remarks4 || \'-\'}}</td><td>{{tradeDTO.exposureTypeName || \'-\'}}</td><td>{{tradeDTO.exposureSubTypeName || \'-\'}}</td><td>{{tradeDTO.deliveryMode || \'-\'}}</td><td>{{tradeDTO.sourceAppName || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.fcyInrPrice || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.fcyUsdPrice || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.adjustedUsdInr || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.fcyUsdSwapPoints || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.usdInrSwapPoints || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.uniqueRequestId || \'-\'}}</td></tr></tbody><tbody ng-if="vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].tradeDTOList.length>0 && (vm.filterText==undefined || vm.filterText==null || vm.filterText==\'\')"><tr class="non-hoverable-tr"><td class="sub-header control-label">TOTAL</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td class="tableNumericColumn sub-header control-label">{{vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].totalUSDAmount | number:vm.noOfDecimalsForAmount}}</td><td></td><!-- <td class="tableNumericColumn sub-header">{{vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].totalGrossINRAmount | number:vm.noOfDecimalsForAmount}}</td> --><td></td><td class="tableNumericColumn sub-header control-label">{{vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].totalNetINRAmount | number:vm.noOfDecimalsForAmount}}</td><td></td></tr></tbody><tbody class="group-header" ng-if="vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].tradeDTOList.length>0 && vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].tradeDTOList.length>0"><tr><td></td><td></td><td></td><td></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td></td><td></td><td></td><td></td><td></td></tr></tbody><tbody class="group-header" ng-if="vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].tradeDTOList.length>0"><tr ng-click="vm.expandPropSellTrades=!vm.expandPropSellTrades"><td><span class="buySellTrades" ng-if="vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].orderType==\'SELL\'">SELL TRADES</span> <span style="float:left" class="icon arrow_carrot-down" aria-hidden="true" ng-show="vm.expandPropSellTrades"></span> <span style="float:left" class="icon arrow_carrot-right" aria-hidden="true" ng-show="!vm.expandPropSellTrades"></span></td><td></td><td></td><td></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td></td><td></td><td></td><td></td><td></td></tr></tbody><tbody ng-if="vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].tradeDTOList.length>0 "><tr class="thead"><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.srNo"></td><td data-translate="gatewayApp.settlementReport.tradeDate"></td><td data-translate="gatewayApp.settlementReport.currencyPair"></td><td data-translate="gatewayApp.settlementReport.instrument"></td><td data-translate="gatewayApp.settlementReport.tradeNo"></td><td data-translate="gatewayApp.settlementReport.tradeType"></td><td data-translate="gatewayApp.settlementReport.settlementLeg"></td><td data-translate="gatewayApp.settlementReport.sourceTradeNo"></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')" data-translate="gatewayApp.settlementReport.relationshipBank"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.customerId"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.customerName"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )" data-translate="gatewayApp.settlementReport.counterPartyBranchId"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )" data-translate="gatewayApp.settlementReport.counterPartyBranchName"></td><!-- <td ng-if="vm.entityOwnerType!=\'SingleUserCustomer\' && vm.entityOwnerType!=\'MultiUserCustomer\'" data-translate="gatewayApp.settlementReport.custId"></td>\r\n\t\t\t\t\t\t\t\t\t<td ng-if="vm.entityOwnerType!=\'SingleUserCustomer\' && vm.entityOwnerType!=\'MultiUserCustomer\'" data-translate="gatewayApp.settlementReport.customerName"></td> --><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.tradedQuantity"></td><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.grossRate"></td><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.netRate"></td><td class="tableNumericColumn" data-translate="gatewayApp.settlementReport.netINRRate"></td><td data-translate="gatewayApp.settlementReport.settlementStartDate"></td><td data-translate="gatewayApp.settlementReport.settlementDate"></td><td style="min-width:100px" data-translate="gatewayApp.settlementReport.dateTime"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks1"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks2"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks3"></td><td style="min-width:360px" data-translate="gatewayApp.settlementReport.userRemarks4"></td><td data-translate="gatewayApp.settlementReport.exposureType"></td><td data-translate="gatewayApp.settlementReport.exposureSubType"></td><td data-translate="gatewayApp.settlementReport.deliveryMode"></td><td data-translate="gatewayApp.settlementReport.source"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.fcyInrPrice"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.fcyUsdPrice"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.adjustedUsdInr"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.fcyUsdSwapPoints"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.usdInrSwapPoints"></td><td ng-if="vm.entityOwnerType==\'Clearcorp\'" data-translate="gatewayApp.settlementReport.uniqueRequestId"></td></tr></tbody><tbody class="table-container-box" ng-if="vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].tradeDTOList.length>0 && vm.expandPropSellTrades"><tr ng-repeat="tradeDTO in vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].tradeDTOList | filter : vm.filterText"><td class="tableNumericColumn">{{tradeDTO.index}}</td><td>{{tradeDTO.tradeDate | date:\'dd-MMM-yyyy\'}}</td><td>{{tradeDTO.currencyPairCode || \'-\'}}</td><td>{{tradeDTO.instrumentCode}}</td><td ng-if="vm.entityOwnerType == \'SingleUserCustomer\' || vm.entityOwnerType == \'MultiUserCustomer\'\r\n\t\t\t\t\t\t\t\t\t|| (vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'CUSTOMER\')">{{tradeDTO.tradeSequenceNumber}}</td><td ng-if="vm.entityOwnerType == \'Bank\' || vm.entityOwnerType == \'Branch\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType == \'Clearcorp\' && vm.viewFor == \'BANKBRANCH\')">{{tradeDTO.tradeSequenceNumberHOView}}</td><td>{{tradeDTO.tradeTypeName}}</td><td>{{tradeDTO.settlementLegName}}</td><td ng-if="tradeDTO.sourceTradeNo != null && tradeDTO.sourceTradeNo !=0">{{tradeDTO.sourceTradeNo}}</td><td ng-if="!(tradeDTO.sourceTradeNo != null && tradeDTO.sourceTradeNo !=0)">{{\' \'}}</td><td class="bank-name" ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"><span title="{{tradeDTO.bankName}}">{{tradeDTO.bankName}}</span></td><!-- <td class="bank-name" ng-if="vm.entityOwnerType==\'Bank\'"><span title="{{tradeDTO.branchName}}">{{tradeDTO.branchName}}</span></td> --><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.customerCode}}</td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.customerName}}</td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )">{{tradeDTO.counterPartyId}}</td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )">{{tradeDTO.counterPartyName}}</td><!-- <td ng-if="vm.entityOwnerType!=\'SingleUserCustomer\' && vm.entityOwnerType!=\'MultiUserCustomer\'">{{tradeDTO.customerName}}</td> --><td class="tableNumericColumn">{{tradeDTO.usdAmount | number:vm.noOfDecimalsForAmount}}</td><td class="tableNumericColumn">{{tradeDTO.grossRate | number:vm.noOfDecimalsForRate}}</td><td class="tableNumericColumn">{{tradeDTO.netRate | number:vm.noOfDecimalsForRate}}</td><td class="tableNumericColumn">{{tradeDTO.netINRAmount | number:vm.noOfDecimalsForAmount}}</td><td><span ng-if="tradeDTO.tradeSettlementDateFrom !=null">{{tradeDTO.tradeSettlementDateFrom| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="tradeDTO.tradeSettlementDateFrom ==null">{{\'\'}}</span></td><td>{{tradeDTO.settlementDate | date:\'dd-MMM-yyyy\'}}</td><td>{{tradeDTO.tradeTimeString|date:\'dd-MMM-yyyy\' }}</td><td style="min-width:360px">{{tradeDTO.userRemarks || \'-\'}}</td><td style="min-width:360px">{{tradeDTO.remarks2 || \'-\'}}</td><td style="min-width:360px">{{tradeDTO.remarks3 || \'-\'}}</td><td style="min-width:360px">{{tradeDTO.remarks4 || \'-\'}}</td><td>{{tradeDTO.exposureTypeName || \'-\'}}</td><td>{{tradeDTO.exposureSubTypeName || \'-\'}}</td><td>{{tradeDTO.deliveryMode || \'-\'}}</td><td>{{tradeDTO.sourceAppName || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.fcyInrPrice || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.fcyUsdPrice || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.adjustedUsdInr || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.fcyUsdSwapPoints || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.usdInrSwapPoints || \'-\'}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\'">{{tradeDTO.uniqueRequestId || \'-\'}}</td></tr></tbody><tbody ng-if="vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].tradeDTOList.length>0  && (vm.filterText==undefined || vm.filterText==null || vm.filterText==\'\')"><tr class="non-hoverable-tr"><td class="sub-header control-label">TOTAL</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="vm.entityOwnerType==\'SingleUserCustomer\' || vm.entityOwnerType==\'MultiUserCustomer\' || \r\n\t\t\t\t\t\t\t\t\t(vm.entityOwnerType==\'Clearcorp\' && vm.viewFor== \'CUSTOMER\')"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || (vm.entityOwnerType==\'Clearcorp\' && vm.viewFor == \'BANKBRANCH\' )"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td ng-if="vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'Clearcorp\'"></td><td class="tableNumericColumn sub-header control-label">{{vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].totalUSDAmount | number:vm.noOfDecimalsForAmount}}</td><td></td><!-- <td class="tableNumericColumn sub-header">{{vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].totalGrossINRAmount | number:vm.noOfDecimalsForAmount}}</td> --><td></td><td class="tableNumericColumn sub-header control-label">{{vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].totalNetINRAmount | number:vm.noOfDecimalsForAmount}}</td><td></td></tr></tbody></table></div><br><div class="row padding-top-10" ng-if="vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[0].tradeDTOList.length>0 \r\n\t\t\t\t\t\t|| vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[0].tradeDTOList.length>0\r\n\t\t\t\t\t\t|| vm.settlementReportSummaryDTOList[0].settlementReportDetailsDTOList[1].tradeDTOList.length>0 \r\n\t\t\t\t\t\t|| vm.settlementReportSummaryDTOList[1].settlementReportDetailsDTOList[1].tradeDTOList.length>0"><span class="help-block right-floating" data-translate="gatewayApp.settlementReport.originalTradeLegend"></span></div><br><div ng-if="  vm.checkForNoRecords()"><span>No record found</span></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/sms-failure-report/sms-failure-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.SMSSettings.manageSMSReport"></span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseSMSReport = !vm.ExpandOrCollapseSMSReport" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#SMSReport"><img ng-src="{{vm.ExpandOrCollapseSMSReport == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.FailureReport.criteria">Criteria</span></a></h4></div><div id="SMSReport" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="smsReportForm"><div class="col-sm-6 col-centered"><div class="row"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.FailureReport.alertType"></span></label></div><div class="row"><div class="col-md-5 multi-col"><select name="alertType" class="form-control select-style" ng-model="vm.alertType" ng-options="alertType.alertTypeName for alertType in vm.alertTypes track by alertType.id"><option value="">--All--</option></select></div></div><div class="row" style="margin-top:7px"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.FailureReport.status"></span></label></div><div class="row"><div class="col-md-5" style="padding-left:0px"><div id="btnGroup" style="border-radius:5px"><div class="btn-group noPaddingMargin" style="width: auto;border-radius:4px"><label class="btn btn-primary status-toggle" ng-model="vm.status" style="border-radius:4px" uib-btn-radio="\'ALL\'">ALL</label><label class="btn btn-primary status-toggle" ng-model="vm.status" style="border-radius:4px" uib-btn-radio="\'SUCCESS\'">SUCCESS</label><label class="btn btn-primary status-toggle" ng-model="vm.status" style="border-radius:4px" uib-btn-radio="\'FAILURE\'">FAILURE</label></div></div></div></div><!-- <div class="row" style="margin-top:10px">\r\n\t\t\t\t\t\t\t\t\t\t<label class="control-label " cspl-mandatory><span data-translate="gatewayApp.FailureReport.period"></span></label>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class="row" >\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-5 multi-col">\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-dtp control-model = "vm.fromDate" control-id="dtpFromDate"  form="smsReportForm" required/>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-5">\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-dtp control-model = "vm.toDate" control-id="dtpToDate"  form="smsReportForm" required/>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<button class=" btn btn-info active"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="smsReportForm.$invalid"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.getSMSFailureReport();vm.screenLog.screenLog(\'SMSFailureReport\',0,\'VIEW\')" data-toggle="collapse" \r\n\t\t\t\t\t\t\t\t\t\t\t\tdata-target="#SMSReport"\r\n\t\t\t\t\t\t\t\t\t\t\t\t data-translate="gatewayApp.FailureReport.go">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t</div> --><div class="row" style="padding-left: 0;margin-top:17px"><div class="col-md-2" style="padding-left: 0; margin-top: 10px"><input type="radio" name="optradio" id="radio1" ng-model="vm.historicalOrCurrent" style="margin-right: 5px" value="Historical" form="smsReportForm"><label style="color: #FFFFFF" for="radio1" data-translate="gatewayApp.FailureReport.historical"></label></div><div class="col-md-5"><cspl-dtp control-model="vm.fromDate" control-id="dtpFromDate" form="smsReportForm" control-required="vm.historicalOrCurrent != \'Current\'" control-disabled="vm.historicalOrCurrent == \'Current\'" control-max-date="vm.yesterdayDate"></div><div class="col-md-5"><cspl-dtp control-model="vm.toDate" control-id="dtpToDate" form="smsReportForm" control-required="vm.historicalOrCurrent != \'Current\'" control-disabled="vm.historicalOrCurrent == \'Current\'" control-max-date="vm.yesterdayDate"></div></div><div class="row" style="padding-left: 0; margin-top:7px"><div class="col-md-2" style="padding-left: 0; padding-right: 0"><input type="radio" name="optradio" id="radio2" ng-model="vm.historicalOrCurrent" style="margin-right: 5px" value="Current" form="smsReportForm"><label style="color: #FFFFFF" for="radio2" data-translate="gatewayApp.FailureReport.forToday"></label></div><div class="col-md-5"><label class="control-label"><span>{{vm.reportDate\t| date : \'dd-MMM-yyyy\'}}</span></label></div></div><div class="col-md-12" style="padding-left: 0"><div class="col-md-2" style="padding-left: 0"></div><div class="col-md-5"></div><div class="col-md-5"><button class="btn btn-info active" ng-disabled="smsReportForm.$invalid||vm.clicked" ng-click="vm.getSMSFailureReport();vm.screenLog.screenLog(\'SMSFailureReport\',0,\'VIEW\');" style="float: right; margin-top:0px" data-translate="entity.action.go" data-toggle="collapse" data-target="#SMSReport"></button></div></div></div></form></div></div></div><div ng-show="vm.smsDetails.length > 0"><div class="row"><!-- \t<button class=" btn btn-info active" ng-click="vm.clearData();vm.screenLog.screenLog(vm.screenName, 0, vm.entityConstants.ENTITY_ACTION_TYPE.CLEARDATA)" data-translate="gatewayApp.FailureReport.clearData"></button>\r\n\t\t\t\t\t --><cspl-table-export class="col-md-1 col-sm-1 col-xs-1" table-name="smsDetails" total-record-count="filterData.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="SMS_Status_Report"></cspl-table-export><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="bootstrap-tableresponsive" style="overflow-x: auto; overflow-y: hidden"><table id="smsDetails" class="dataTable table table-striped table-hover smsDetailsTable"><thead><tr><th data-translate="gatewayApp.FailureReport.receiver"></th><th data-translate="gatewayApp.FailureReport.mobileNumber"></th><th data-translate="gatewayApp.FailureReport.messageType"></th><th data-translate="gatewayApp.FailureReport.sentTime"></th><th style="text-align:center" data-translate="gatewayApp.FailureReport.status"></th><th data-translate="gatewayApp.FailureReport.errorMessage"></th><th data-translate="gatewayApp.FailureReport.emailID"></th><th class="tableNumericColumn" data-translate="gatewayApp.FailureReport.numberOfAttempts"></th><th class="sticky-resend" style="background: #333333 !important"></th></tr></thead><tbody><tr ng-repeat="smsDetail in filterData = (vm.smsDetails | filter : filterText) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)" ng-class="{\'colored-failure-row\' : !smsDetail.isSuccess}"><td style="white-space:nowrap;min-width:250px"><span ng-if="smsDetail.smsAlertTypeName ==\'Trade Confirmation\'">{{smsDetail.organisationName || \'-\'}}</span> <span ng-if="smsDetail.smsAlertTypeName !=\'Trade Confirmation\'">{{smsDetail.receiver || \'-\'}}</span></td><td>{{smsDetail.mobileCountryCode + smsDetail.mobileNo}}</td><td style="white-space:nowrap;min-width:150px">{{smsDetail.smsAlertTypeName}}</td><td style="white-space:nowrap;min-width:150px">{{smsDetail.lastModifiedDate|date:\'dd-MMM-yyyy HH:mm a\'}}</td><td style="text-align:center;min-width:175px"><span ng-if="smsDetail.isSuccess" class="success-status-span">Success</span> <span ng-if="!smsDetail.isSuccess" class="failure-status-span">Failed</span></td><td style="min-width:275px"><span ng-if="!smsDetail.isSuccess">{{smsDetail.failureReason}}</span> <span ng-if="smsDetail.isSuccess">-</span></td><td style="min-width:200px">{{smsDetail.emailId || \'-\'}}</td><td class="tableNumericColumn">{{smsDetail.noOfAttempts}}</td><td class="sticky-resend"><span class="resend-block" ng-show="smsDetail.isToResendSMS && !smsDetail.isSuccess" ng-click="vm.resend(smsDetail.id);vm.screenLog.screenLog(vm.screenName,smsDetail.id,vm.entityConstants.ENTITY_ACTION_TYPE.RESEND)">RESEND</span></td><!--  <td >\r\n                                                <div class="btn-group utility" uib-dropdown ng-show="smsDetail.smsalert.isToResendSMS && !smsDetail.isSuccess">\r\n                                                       <span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span>\r\n                                                    <ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu >\r\n                                                       <li>\r\n                                                           <a href="" ng-click="vm.resend(smsDetail.id);vm.screenLog.screenLog(vm.screenName,smsDetail.id,vm.entityConstants.ENTITY_ACTION_TYPE.RESEND)">\r\n                                                            <span class="hidden-xs hidden-sm" data-translate="gatewayApp.FailureReport.resend"></span> \r\n                                                        </a>\r\n                                                    </li>\r\n                                            \r\n                                                   </ul>\r\n                                                </div>\r\n                                            </td> --></tr></tbody></table><div ng-show="vm.smsDetails.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></div><div ng-show="vm.smsDetails.length==0"><span>No record found</span></div></section></div></div>');
$templateCache.put('app/entities/sms-settings/sms-settings-edit-dialog.html','<form name="smsSettingsForm" role="form" novalidate><div class="modal-header"><div class="modal-title"><span data-translate="global.menu.SMSSettings.main"></span></div></div><div class="modal-body"><div><nmb-alert-error></nmb-alert-error></div><div class="content"><nmb-alert></nmb-alert><fieldset ng-disabled="vm.disableForm"><div class="row"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="gatewayApp.SMSSettings.alertType"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.smsSettings.alertType" control-id="txtAlertType" form="smsSettingsForm" control-disabled="true"></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="gatewayApp.SMSSettings.messageTags"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.smsSettings.messageTags" control-id="txtMessageTags" control-disabled="true" form="smsSettingsForm"></div></div><!-- \t<div class="row" style="margin-top:8px" > \r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"  cspl-mandatory><span data-translate="gatewayApp.SMSSettings.sender" ></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-2 col-md-offset-3">\r\n\t\t\t\t\t\t<cspl-text control-model="vm.smsSettings.sender"  control-id="txtSender" form="smsSettingsForm" control-maxlength="6" required />\r\n\t\t\t\t\t\t \r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div> --><div class="row" style="margin-top:8px"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.SMSSettings.messageContent"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-multiline-text control-model="vm.smsSettings.messageContent" control-id="txtMessageContent" control-maxlength="700" form="smsSettingsForm" control-type="SMSSettings" required></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label" cspl-mandatory><span data-translate="gatewayApp.SMSSettings.dltTeId"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.smsSettings.dltTeId" control-type="Alphanumeric" control-id="txtDltTeId" control-maxlength="255" form="smsSettingsForm" required></div></div><div class="row" style="margin-top:8px"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="gatewayApp.SMSSettings.Messagedescription"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-multiline-text control-model="vm.smsSettings.description" control-id="txtDescription" form="smsSettingsViewForm" control-rows="6" control-disabled="true"></div></div><div class="row"><label for="blockAlert" class="col-md-2 col-md-offset-3 control-label"><input type="checkbox" style="margin-top:10px" ng-model="vm.smsSettings.blockAlert" form="smsSettingsViewForm" id="blockAlert"> <span data-translate="gatewayApp.SMSSettings.blockalert"></span></label><div ng-hide="vm.smsSettings.alertType==\'OTP SMS\'"><label for="isToResendSMS" class="col-md-3 col-md-offset-1 control-label"><input type="checkbox" style="margin-top:10px" ng-model="vm.smsSettings.isToResendSMS" form="smsSettingsViewForm" id="isToResendSMS"> <span data-translate="gatewayApp.SMSSettings.isToResendSMS"></span></label></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showButton" class="btn btn-primary" ng-disabled="smsSettingsForm.$invalid || vm.clicked" ng-click="vm.clicked=true;vm.resubmitSMSSettings();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="!showButton" ng-disabled="smsSettingsForm.$invalid || (vm.smsSettings.id != null &&  !smsSettingsForm.$dirty) || vm.clicked" class="btn btn-info active" ng-click="vm.clicked=true;vm.save();"><span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/sms-settings/sms-settings-view-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="smsSettingsViewForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><span data-translate="global.menu.SMSSettings.main"></span></h4></div><div class="modal-body"><div class="content"><fieldset><div class="row"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="gatewayApp.SMSSettings.alertType"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.smsSettings.alertType" control-disabled="true" control-id="txtAlertType" form="smsSettingsViewForm"></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="gatewayApp.SMSSettings.messageTags"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.smsSettings.messageTags" control-id="txtMessageTags" control-disabled="true" form="smsSettingsViewForm"></div></div><!-- <div class="row" style="margin-top:8px"> \r\n\t\t\t\t\t<label class="col-md-6 col-md-offset-3 control-label"  ><span data-translate="gatewayApp.SMSSettings.sender" ></span></label>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-md-2 col-md-offset-3" >\r\n\t\t\t\t\t\t<cspl-text control-model="vm.smsSettings.sender"  control-id="txtSender" control-disabled="true" form="smsSettingsViewForm"  ></cspl-text>\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div> --><div class="row" style="margin-top:8px"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="gatewayApp.SMSSettings.messageContent"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-multiline-text control-model="vm.smsSettings.messageContent" control-id="txtMessageContent" form="smsSettingsViewForm" control-rows="6" control-type="SMSSettings" control-disabled="true"></div></div><div class="row"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="gatewayApp.SMSSettings.dltTeId"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-text control-model="vm.smsSettings.dltTeId" control-id="txtDltTeId" form="smsSettingsForm" control-disabled="true"></div></div><div class="row" style="margin-top:8px"><label class="col-md-6 col-md-offset-3 control-label"><span data-translate="gatewayApp.SMSSettings.Messagedescription"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-3"><cspl-multiline-text control-model="vm.smsSettings.description" control-id="txtDescription" form="smsSettingsViewForm" control-rows="6" control-disabled="true"></div></div><div class="row"><label for="blockAlert" class="col-md-2 col-md-offset-3 control-label"><input type="checkbox" style="margin-top:10px" ng-model="vm.smsSettings.blockAlert" ng-disabled="vm.disable" form="smsSettingsViewForm" id="blockAlert"> <span data-translate="gatewayApp.SMSSettings.blockalert"></span></label><div ng-hide="vm.smsSettings.alertType==\'OTP SMS\'"><label for="isToResend" class="col-md-3 col-md-offset-1 control-label"><input type="checkbox" style="margin-top:10px" ng-model="vm.smsSettings.isToResendSMS" ng-disabled="vm.disable" form="smsSettingsViewForm" id="isToResendSMS"> <span data-translate="gatewayApp.SMSSettings.isToResendSMS"></span></label></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>OK</span></button> <button type="button" ng-if="showDiscardButton" autofocus class="btn btn-reject" ng-click="vm.discardSMSSettings()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showButton" class="btn btn-reject" ng-click="vm.rejectSMSSettings()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" class="btn autofocus btn-approve" ng-disabled="clicked" ng-click="clicked=true;vm.approveSMSSettings();"><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/sms-settings/sms-settings.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.SMSSettings.manageSMSSettings"></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="pull-right"><div class="col-md-6 pull-right"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="tblsmsSettings" total-record-count="vm.SMSSettings.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="SMS_Settings"></cspl-table-export></div></div><div class="table-responsive" style="overflow:auto"><table id="tblsmsSettings" class="datatables-nosort table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.SMSSettings.alertType"></th><!-- <th data-translate="gatewayApp.SMSSettings.sender"></th> --><th data-translate="gatewayApp.SMSSettings.messageContent"></th><th data-translate="gatewayApp.SMSSettings.dltTeId"></th><th data-translate="gatewayApp.SMSSettings.blockAlert"></th><th></th></tr></thead><tbody><tr ng-repeat="SMSSetting in filterData = (vm.SMSSettings | filter : filterText | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{SMSSetting.alertType}}</td><!-- <td>{{SMSSetting.sender}}</td> --><td>{{SMSSetting.messageContent}}</td><td style="width: 25%;word-break: break-word">{{SMSSetting.dltTeId}}</td><td>{{SMSSetting.blockAlert}}</td><td style="text-align:center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li><a ui-sref="sms-settings.view({id:SMSSetting.id})" ng-click="vm.screenLog.screenLog(vm.screenName,SMSSetting.id,vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></a></li><li><a ui-sref="sms-settings.edit({id:SMSSetting.id})" ng-click="vm.screenLog.screenLog(vm.screenName,SMSSetting.id,vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/sod-process/sod-process.html','<div ncy-breadcrumb class="row" style="margin-left: 10px"></div><nmb-alert></nmb-alert><div class="row" style="padding:5px"></div><div class="row" style="margin-left: 10px"><nmb-aler-error><div class="col-lg-12"><section class="item" style="padding:5px"><div class="panel panel-primary"><div class="panel-heading text-left"><span data-translate="gatewayApp.sodProcess.title"></span> <a href="" style="position: relative;float:right;  color: #fff" ng-class="{\'linkDisabled\' : vm.isRefreshDisabled}"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="!vm.isRefreshDisabled?refresh():\'\';" style="font-size:20px"></i></a></div><div class="panel-body"><div class="module-content-inner"><br><div class="row"><label class="col-md-2 control-label left-align-label"><span data-translate="gatewayApp.sodProcess.currentSystemDate"></span></label><div class="col-md-3"><cspl-dtp control-model="vm.currentBusinessDate" control-id="selectedDate" control-disabled="true"></div><div class="col-md-1"><button class="btn btn-info active" ng-click="vm.beginSODProcess()" ng-disabled="vm.disbleSod" data-translate="gatewayApp.sodProcess.start" ng-show="vm.permitSODProcessAddEntityAction"></button></div></div><div class="row bootstrap-tableresponsive"><table id="sodProcess" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.sodProcess.process"></th><th data-translate="gatewayApp.sodProcess.status"></th><th data-translate="gatewayApp.sodProcess.remarks"></th></tr></thead><tbody><tr ng-repeat="process in vm.sodProcessList"><td>{{process.description}}</td><td><span ng-if="process.status==vm.NOTSTARTED" aria-hidden="true" class="icon"></span> <span ng-if="process.status==vm.INPROGRESS" aria-hidden="true" class="icon"><img src="assets/images/Progress_bar.GIF"> </span><span ng-if="process.status==vm.COMPLETED" aria-hidden="true" class="icon"><img src="assets/images/EOD_Process_Success.png"> </span><span ng-if="process.status==vm.FAILED" aria-hidden="true" class="icon"><img src="assets/images/EOD_Process_Error.png"></span></td><td>{{process.remarks}}</td></tr></tbody></table></div></div></div></div></section></div></nmb-aler-error></div><script src="assets/js/tables.js"></script>');
$templateCache.put('app/entities/special-holidays/special-holidays-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.specialHolidays.id)"><div class="modal-header-red"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" style="text-align:left;padding-left:3%">Are you sure?</h4></div><div class="modal-body"><nmb-alert-error></nmb-alert-error><p><textarea class="form-control modal-header-red" rows="6" ng-model="vm.reason" placeholder="Please provide a reason" required></textarea></p><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span data-translate="entity.action.delete">Delete</span></button></div></div></div></form>');
$templateCache.put('app/entities/special-holidays/special-holidays-detail.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="specialHolidaysViewForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><span data-translate="global.menu.specialHolidays.main"></span></h4></div><div class="modal-body"><div class="content"><br><div class="row"><div class="row"><label class="col-md-4 control-label"><span data-translate="gatewayApp.specialHolidays.currencyCode"></span></label><div class="col-md-6"><cspl-ach control-model="vm.specialHolidays.currency" control-id="txtCurrencyCode" lookup-name="currency" display-column="code" control-disabled="true" control-required="false"></cspl-ach></div></div><div class="row"><label class="col-md-4 control-label"><span data-translate="gatewayApp.specialHolidays.holidayDate"></span></label><div class="col-md-6"><cspl-dtp control-model="vm.specialHolidays.holidayDate" control-id="dtpholidayDate" form="specialholidaysForm" control-disabled="true" control-required="false"></div></div><div class="row"><label class="col-md-4 control-label"><span data-translate="gatewayApp.specialHolidays.reason"></span></label><div class="col-md-6"><cspl-text control-model="vm.specialHolidays.reason" control-id="txtreason" placeholder="" form="specialholidaysForm" control-disabled="true" control-required="false"></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button> <button type="button" ng-show="showDiscardButton" class="btn btn-reject" ng-click="vm.discardSpecialHolidays()"><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-show="showButton" class="btn btn-reject" ng-click="vm.rejectSpecialHolidays()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-show="showButton" class="btn btn-approve" ng-disabled="clicked" ng-click="vm.approveSpecialHolidays();clicked=true;"><span data-translate="entity.action.approve">Approve</span></button></div></div></div></div></form>');
$templateCache.put('app/entities/special-holidays/special-holidays-dialog.html','<form name="specialholidaysForm" role="form" novalidate><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><span data-translate="global.menu.specialHolidays.main"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><fieldset ng-disabled="vm.disableForm"><br><div class="row"><label class="col-md-4 control-label"><span data-translate="gatewayApp.specialHolidays.currencyCode"></span></label><div class="col-md-6"><cspl-ach control-model="vm.specialHolidays.currency" control-id="txtCurrencyCode" lookup-name="currency" display-column="code" form="specialholidaysForm" control-required="vm.specialHolidays.id==null" control-disabled="vm.specialHolidays.id!=null"></cspl-ach></div></div><div class="row"><label class="col-md-4 control-label" cspl-mandatory><span data-translate="gatewayApp.specialHolidays.holidayDate"></span></label><div class="col-md-6"><cspl-dtp control-model="vm.specialHolidays.holidayDate" control-id="dtpholidayDate" control-disabled="vm.specialHolidays.id!=null" form="specialholidaysForm" control-required="vm.specialHolidays.id==null"></div></div><div class="row"><label class="col-md-4 control-label" cspl-mandatory><span data-translate="gatewayApp.specialHolidays.reason"></span></label><div class="col-md-6"><cspl-text control-model="vm.specialHolidays.reason" control-id="txtreason" placeholder="" form="specialholidaysForm" control-maxlength="255" required></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-show="showButton" class="btn btn-primary" ng-disabled="specialholidaysForm.$invalid || clicked" ng-click="vm.resubmitSpecialHolidays();clicked = true;"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-hide="showButton" ng-disabled="specialholidaysForm.$invalid || (vm.specialHolidays.id == null && specialholidaysForm.$invalid) || (vm.specialHolidays.id != null && specialholidaysForm.$pristine) || clicked" class="btn btn-info active" ng-click="clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button></div></div></div></form>');
$templateCache.put('app/entities/special-holidays/special-holidays.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="gatewayApp.specialHolidays.home.title"></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><br><!-- <div class="row center-module-inner-content" >\r\n\t\t\t\t\t\t<label class="col-md-2  control-label left-align-label"  ><span data-translate="gatewayApp.specialHolidays.currencyCode"></span></label>\r\n\t\t\t\t\t\t<div class="col-md-2" >\r\n\t\t\t\t\t\t\t<cspl-ach control-model="vm.currencyCode"  control-id="txtCurrencyCode" lookup-name="currency"  display-column="code" required></cspl-ach>\r\n \t\t\t\t\t\t</div>\r\n \t\t\t\t\t\t<button type="button" class="btn btn-info active "  ng-disabled="vm.currencyCode==null" ng-click="vm.loadAll()">\r\n \t\t\t\t\t\t\t\t\t\t<span  data-translate="entity.action.go"></span> </button>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<br> --><div class="bootstrap-tableresponsive"><div class="row"><cspl-table-export class="col-md-1 col-sm-1 col-xs-2" table-name="tblspecialholidays" total-record-count="vm.specialHolidays.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" style="padding-top: 1%"></cspl-table-export><div class="col-md-6 col-sm-7 col-xs-10 right-floating"><button type="button" class="btn btn-info active right-floating" ng-click="vm.screenLog.screenLog(vm.screenName, 0,vm.entityConstants.ENTITY_ACTION_TYPE.ADD); vm.launch()" ng-show="vm.permitSpecialHolidaysCreateEntityAction"><span class="glyphicon glyphicon-plus"></span> <span data-translate="global.menu.specialHolidays.main"></span></button><cspl-table-search class="col-md-3 col-sm-4 col-xs-5 right-floating" control-model="filterText"></cspl-table-search></div></div><table id="tblspecialholidays" class="dataTable table table-striped table-hover"><thead><tr><th><cspl-table-sort sort-type-model="sortType" default-sort="asc" sort-type-name="currencyCode" sort-reverse-model="sortReverse" header-text="\'gatewayApp.specialHolidays.currencyCode\'|translate"></th><th data-translate="gatewayApp.specialHolidays.holidayDate"></th><th data-translate="gatewayApp.specialHolidays.reason"></th><th></th></tr></thead><tbody><tr ng-repeat="specialholidays in filterData = (vm.specialHolidays | filter : filterText | orderBy : sortType : sortReverse) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{specialholidays.currency.code }}</td><td>{{specialholidays.holidayDate | date:\'dd-MMM-yyyy\'}}</td><td style="word-break:break-word">{{specialholidays.reason}}</td><td style="text-align:center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitSpecialHolidaysViewEntityAction"><a ui-sref="special-holidays.view({id: specialholidays.id})" ng-click="vm.screenLog.screenLog(vm.screenName, specialholidays.id, vm.entityConstants.ENTITY_ACTION_TYPE.VIEW_DETAILS)"><span class="" data-translate="entity.action.view"></span></a></li><li ng-show="vm.permitSpecialHolidaysEditEntityAction"><a ui-sref="special-holidays.edit({id: specialholidays.id})" ng-click="vm.screenLog.screenLog(vm.screenName, specialholidays.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span class="" data-translate="entity.action.edit"></span></a></li><li ng-show="vm.permitSpecialHolidaysDeleteEntityAction"><a ui-sref="special-holidays.delete({id: specialholidays.id})" ng-click="vm.screenLog.screenLog(vm.screenName, specialholidays.id, vm.entityConstants.ENTITY_ACTION_TYPE.DELETE)"><span class="" data-translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="filterData.length == 0"><span>No record found</span></div><div ng-show="filterData.length > noOfRecordsPerPage"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div></div><script src="assets/js/tables.js"></script>');
$templateCache.put('app/entities/standard-tenor-view/standard-tenor-view.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.standardTenor.title"></span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><br><form class="" role="form" name="StandardTenorViewForm"><div class="row col-md-12"><div class="row"><label class="col-md-2 col-xs-6 col-sm-2 control-label margin-top-7" cspl-mandatory><span data-translate="gatewayApp.standardTenorView.businessDate"></span></label><div class="col-md-2 col-xs-10"><cspl-dtp control-model="vm.businessDate" control-id="dtpFromDate" form="StandardTenorViewForm" control-disabled="true" required></cspl-dtp></div></div></div></form><div class="row"><div class="dropdown col-md-3" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div><cspl-table-search control-model="vm.filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><!-- <div class="row">\r\n\t\t\t\t\t\t<div class="col-md-12">\r\n\t\t\t\t\t\t\t<div class="pull-left">\r\n\t\t\t\t\t\t\t\t<div class="dropdown col-md-3" style="width: 10%;">\r\n\t\t\t\t\t\t\t\t\t<div class="dropdown-toggle" id="dropdownMenu-user"\r\n\t\t\t\t\t\t\t\t\t\tdata-toggle="dropdown" aria-expanded="true" role="button">\r\n\t\t\t\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t\t\t\t\tclass="btn btn-primary btn-sm dropdown-toggle importExport"\r\n\t\t\t\t\t\t\t\t\t\t\tstyle="border: none;">\r\n\t\t\t\t\t\t\t\t\t\t\t<img src="assets/images/Export_01.png" />\r\n\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<ul class="dropdown-menu" role="menu"\r\n\t\t\t\t\t\t\t\t\t\taria-labelledby="dropdownMenu-user">\r\n\t\t\t\t\t\t\t\t\t\t<li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li>\r\n\t\t\t\t\t\t\t\t\t\t<li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li>\r\n\t\t\t\t\t\t\t\t\t</ul>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class="col-md-2 col-sm-3 col-xs-4 float-right">\r\n\t\t\t\t\t\t\t\t<cspl-table-search control-model="vm.filterText"></cspl-table-search>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div> --><div><div class="bootstrap-tableresponsive" style="overflow-x: auto; overflow-y: hidden"><table id="standardTenorList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.standardTenorView.Instrument"></th><th data-translate="gatewayApp.standardTenorView.SettlementDate"></th></tr></thead><tbody><tr ng-repeat="standardTenor in filterData = (vm.standardTenorList | filter : vm.filterText) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break: break-word">{{standardTenor.tenorName}}</td><td ng-if="standardTenor.active">{{standardTenor.settlementDate | date: \'dd-MMM-yyyy\'}}</td><td ng-if="!standardTenor.active">-</td></tr></tbody></table><div ng-show="vm.standardTenorList.length > noOfRecordsPerPage"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></div><div ng-show="vm.standardTenorList.length==0"><span>No record found</span></div></section></div></div>');
$templateCache.put('app/entities/swap-quotes/swap-quotes-dialog.html','<div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="gatewayApp.swapQuotes.home.editSwapQuote"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><form name="swapQuotesForm" role="form" novalidate><div class="form-group col-xs-5"><label class="control-label left-align-label"><span data-translate="gatewayApp.swapQuotes.businessDate"></span></label><cspl-dtp control-model="vm.businessDate" control-id="businessDate" control-disabled="true"></div><div class="form-group col-xs-6"><label class="control-label left-align-label"><span data-translate="gatewayApp.swapQuotes.bank"></span></label><cspl-text class="" control-model="vm.swapQuotes.bank.bankName" control-disabled="true" form="swapQuotesForm" control-id="txtBankName"></div><div class="form-group"><table id="swapQuotesList" class="dataTable table table-striped"><thead><tr><th colspan="2" class="td-text-align-center">{{\'gatewayApp.swapQuotes.cashSpot\'| translate}} - <span ng-hide="vm.disableCashSpread" style="font-size: 12px">{{vm.cashSettlementDate |date:\'dd-MMM-yyyy\' | uppercase }}</span></th><th colspan="2" class="td-text-align-center">{{\'gatewayApp.swapQuotes.tomSpot\'| translate}} - <span ng-hide="vm.disableTOMSpread" style="font-size: 12px">{{vm.tomSettlementDate |date:\'dd-MMM-yyyy\' | uppercase }}</span></th></tr><tr><th class="td-text-align-right" data-translate="gatewayApp.swapQuotes.bidSpread"></th><th class="td-text-align-right" data-translate="gatewayApp.swapQuotes.offerSpread"></th><th class="td-text-align-right" data-translate="gatewayApp.swapQuotes.bidSpread"></th><th class="td-text-align-right" data-translate="gatewayApp.swapQuotes.offerSpread"></th></tr></thead><tr><td><cspl-numeric control-model="vm.swapQuotes.cashSpotBidSpread" control-id="cashBidSpread" control-type="Number" no-of-decimals="2" control-max="999.75" autocomplete="" control-min="-999.75" form="swapQuotesForm" control-invalid="vm.showcashBidError" control-disabled="vm.disableSpread || vm.disableCashSpread" class="td-text-align-right"></cspl-numeric><span ng-show="vm.showcashBidError" class="help-block-error" style="text-align:left" data-translate="gatewayApp.swapQuotes.cashBidTickSizeError" data-translate-values="{value:vm.cashTickSize}"></span></td><td><cspl-numeric control-model="vm.swapQuotes.cashSpotOfferSpread" control-type="Number" no-of-decimals="2" control-max="999.75" autocomplete="" control-min="-999.75" control-invalid="vm.showcashOfferError" form="swapQuotesForm" autocomplete="" control-id="cashOfferSpread" control-disabled="vm.disableSpread ||  vm.disableCashSpread"></cspl-numeric><span ng-show="vm.showcashOfferError" class="help-block-error" style="text-align:left" data-translate="gatewayApp.swapQuotes.cashOfferTickSizeError" data-translate-values="{value:vm.cashTickSize}"></span></td><td><cspl-numeric control-model="vm.swapQuotes.tomSpotBidSpread" control-type="Number" no-of-decimals="2" control-max="999.75" autocomplete="" control-min="-999.75" form="swapQuotesForm" control-invalid="vm.showtomBidError" control-id="tomBidSpread" control-disabled="vm.disableSpread || vm.disableTOMSpread"></cspl-numeric><span ng-show="vm.showtomBidError" class="help-block-error" style="text-align:left" data-translate="gatewayApp.swapQuotes.tomBidTickSizeError" data-translate-values="{value:vm.tomTickSize}"></span></td><td><cspl-numeric control-model="vm.swapQuotes.tomSpotOfferSpread" control-type="Number" control-id="tomOfferSpread" control-invalid="vm.showtomOfferError" no-of-decimals="2" control-max="999.75" control-min="-999.75" form="swapQuotesForm" autocomplete="" control-disabled="vm.disableSpread|| vm.disableTOMSpread"></cspl-numeric><span ng-show="vm.showtomOfferError" class="help-block-error" style="text-align:left" data-translate="gatewayApp.swapQuotes.tomOfferTickSizeError" data-translate-values="{value:vm.tomTickSize}"></span></td></tr></table><div class="row"><span class="help-block right-floating" data-translate="gatewayApp.swapQuotes.valuesTakenInPaise"></span></div><div class="row"><span class="help-block right-floating" data-translate="gatewayApp.swapQuotes.nullSpread"></span></div><div class="row"><span class="help-block right-floating" data-translate="gatewayApp.swapQuotes.zeroSpread"></span></div></div></form><div class="modal-footer"><button type="button" ng-show="showDiscardButton || showApproveRejectButton" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button> <button type="button" ng-show="showButton || showResubmitButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="swapQuotesForm.$invalid || vm.clicked || vm.disableSpread ||  (vm.showcashBidError || vm.showcashOfferError || vm.showtomBidError || vm.showtomOfferError )" ng-click="vm.clicked = true;vm.resubmitSwapQuotes();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="swapQuotesForm.$invalid || (vm.swapQuotes.id == null && swapQuotesForm.$invalid) ||  (vm.swapQuotes.id != null && swapQuotesForm.$pristine)|| (vm.showcashBidError || vm.showcashOfferError || vm.showtomBidError || vm.showtomOfferError ) || vm.clicked" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardSwapQuotes()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectSwapQuotes()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveSwapQuotes();vm.clicked=true;" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></div>');
$templateCache.put('app/entities/swap-quotes/swap-quotes.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="gatewayApp.swapQuotes.home.title"></span></h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><form class="form"><div class="form-group col-md-3"><label class="control-label left-align-label"><span data-translate="gatewayApp.swapQuotes.from"></span></label><cspl-dtp control-model="vm.fromDate" control-id="selectedDate" control-max-date="vm.currentDate"></div><div class="form-group col-md-3"><label class="control-label left-align-label"><span data-translate="gatewayApp.swapQuotes.to"></span></label><cspl-dtp control-model="vm.toDate" control-id="selectedDate" control-max-date="vm.currentDate"></div><button class="form-go-button-alignment btn btn-info active" ng-click="vm.loadAll()" data-translate="entity.action.go"></button><div class="row"><span class="date-range-label" style="" data-translate="gatewayApp.swapQuotes.dateViewLabel"></span></div></form></div><br><div class="row" ng-show="vm.swapQuotes.length>0"><cspl-table-export class="col-md-1 col-sm-1 col-xs-1" table-name="swapQuotesList" total-record-count="filterData.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="Swap_Quotes"></cspl-table-export><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="bootstrap-tableresponsive" ng-show="vm.swapQuotes.length>0"><table id="swapQuotesList" class="dataTable table table-striped table-hover"><thead><tr><th></th><th colspan="2" class="td-padding1" data-translate="gatewayApp.swapQuotes.cashSpot"></th><th colspan="2" data-translate="gatewayApp.swapQuotes.tomSpot" class="td-padding2"></th><th></th></tr><tr><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.swapQuotes.bidSpread"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.swapQuotes.offerSpread"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.swapQuotes.bidSpread"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.swapQuotes.offerSpread"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.swapQuotes.date"></th><th></th></tr></thead><tbody><tr ng-repeat="swapQuote in filterData = (vm.swapQuotes | filter : filterText) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td class="td-text-align-right noPaddingLeftRight" ng-if="swapQuote.cashSpotBidSpread != null">{{swapQuote.cashSpotBidSpread}}</td><td class="td-text-align-right noPaddingLeftRight" ng-if="swapQuote.cashSpotBidSpread == null">{{"-"}}</td><td class="td-text-align-right noPaddingLeftRight" ng-if="swapQuote.cashSpotOfferSpread != null">{{swapQuote.cashSpotOfferSpread}}</td><td class="td-text-align-right noPaddingLeftRight" ng-if="swapQuote.cashSpotOfferSpread == null">{{"-"}}</td><td class="td-text-align-right noPaddingLeftRight" ng-if="swapQuote.tomSpotBidSpread != null">{{swapQuote.tomSpotBidSpread}}</td><td class="td-text-align-right noPaddingLeftRight" ng-if="swapQuote.tomSpotBidSpread == null">{{"-"}}</td><td class="td-text-align-right noPaddingLeftRight" ng-if="swapQuote.tomSpotOfferSpread != null">{{swapQuote.tomSpotOfferSpread}}</td><td class="td-text-align-right noPaddingLeftRight" ng-if="swapQuote.tomSpotOfferSpread == null">{{"-"}}</td><td class="td-text-align-right noPaddingLeftRight">{{swapQuote.businessDate | date:\'dd-MMM-yyyy\'}}</td><td style="text-align:center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><!--  ng-show="vm.permitSwapQuotesEditEntityAction" --><li ng-show="vm.permitSwapQuotesEditEntityAction"><a ng-click="vm.editSwapQuotes(swapQuote,$event)"><span class="" data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table></div><div ng-show="filterData.length == 0"><span>No record found</span></div><div class="row"><span class="help-block right-floating" data-translate="gatewayApp.swapQuotes.valuesInPaise"></span></div><div ng-show="filterData.length > noOfRecordsPerPage"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/swap-quotes-for-tenor-date/swap-quotes-for-tenor-date.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="gatewayApp.swapQuotes.home.title"></span></h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><form class="form"><div class="form-group col-md-3"><label class="control-label left-align-label"><span data-translate="gatewayApp.swapQuotes.from"></span></label><cspl-dtp control-model="vm.fromDate" control-id="selectedDate" control-max-date="vm.currentDate" required></cspl-dtp></div><div class="form-group col-md-3"><label class="control-label left-align-label"><span data-translate="gatewayApp.swapQuotes.to"></span></label><cspl-dtp control-model="vm.toDate" control-id="selectedDate" control-max-date="vm.currentDate" required></cspl-dtp></div><button class="form-go-button-alignment btn btn-info active" ng-disabled="vm.clicked" ng-click="vm.loadAll()" data-translate="entity.action.go"></button><div class="row"><span class="date-range-label" style="" data-translate="gatewayApp.swapQuotes.dateViewLabel"></span></div></form></div><br><div class="row" ng-show="vm.swapQuotesForTenorDates.length>0"><div class="col-md-12"><div class="pull-left"><cspl-table-export table-name="swapQuotesList" total-record-count="filterData.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="Swap_Quotes"></cspl-table-export></div><div class="pull-left" style="margin-left: 0px"><div class="dropdown" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Import_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><input type="file" id="uploadFile" name="uploadFile" fileread="vm.uploadedData" accept=".csv" ng-hide="true"><label for="uploadFile"><span class="importfile" style="cursor: pointer">Import File</span></label></li><li><a ng-click="vm.generateSwapQuotesTemplate()">Generate Template</a></li></ul></div></div><!-- <div class="input-group">\r\n\t\t\t\t\t\t<input type="text" class="form-control fileOpen"\r\n\t\t\t\t\t\t\tng-model="vm.inputFile" readonly> <label\r\n\t\t\t\t\t\t\tfor="certificate" class="btn btn-primary fileUploadDark"\r\n\t\t\t\t\t\t\tng-class="{\'block-upload\' : vm.selectedFilter == \'download\'}">\r\n\r\n\t\t\t\t\t\t\t<img src="assets/images/Open Path-26.png"\r\n\t\t\t\t\t\t\tstyle="height: 20px; padding-bottom: 2px; pointer-events: none" />\r\n\t\t\t\t\t\t</label> <input type="file" id="certificate" name="certificate"\r\n\t\t\t\t\t\t\tfileread="vm.certificate" accept="application/cer"\r\n\t\t\t\t\t\t\tform="uploadDownloadForm" ng-hide="true" />\r\n\t\t\t\t\t</div> --><div class="float-right col-xs-10 col-sm-3 col-md-2"><cspl-table-search control-model="filterText"></cspl-table-search></div></div><!-- <cspl-table-search control-model="filterText"\r\n\t\t\t\t\t\tclass=" col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search> --></div><div class="bootstrap-tableresponsive" ng-show="vm.swapQuotesForTenorDates.length>0"><table id="swapQuotesList" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.swapQuotes.Instrument"></th><th class="" data-translate="gatewayApp.swapQuotes.SettlementDate"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.swapQuotes.bidSpread"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.swapQuotes.offerSpread"></th><th class="padding-left-30" data-translate="gatewayApp.swapQuotes.date"></th><th></th></tr></thead><tbody><tr ng-repeat="swapQuote in filterData = (vm.swapQuotesForTenorDates | filter : filterText) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td class="imp-column"><span ng-if="swapQuote.tenorName == \'CASH\'">CASH/SPOT</span> <span ng-if="swapQuote.tenorName == \'TOM\'">TOM/SPOT</span> <span ng-if="swapQuote.tenorName != \'TOM\' && swapQuote.tenorName != \'CASH\'">{{swapQuote.tenorName}}</span></td><td class="" ng-if="swapQuote.isTenorActive != false && swapQuote.settlementDate!=null">{{swapQuote.settlementDate | date:\'dd-MMM-yyyy\'}}</td><td class="" ng-if="swapQuote.isTenorActive == false || swapQuote.settlementDate==null">{{"-"}}</td><td class="td-text-align-right noPaddingLeftRight" ng-if="swapQuote.bidSpread != null">{{swapQuote.bidSpread | number:vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right noPaddingLeftRight" ng-if="swapQuote.bidSpread == null">{{"-"}}</td><td class="td-text-align-right noPaddingLeftRight" ng-if="swapQuote.offerSpread != null">{{swapQuote.offerSpread | number:vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right noPaddingLeftRight" ng-if="swapQuote.offerSpread == null">{{"-"}}</td><td class="padding-left-30">{{swapQuote.businessDate | date:\'dd-MMM-yyyy\'}}</td><td style="text-align: center"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitSwapQuotesEditEntityAction"><a ng-click="vm.editSwapQuotes(swapQuote,$event)"><span class="" data-translate="entity.action.edit"></span></a></li></ul></div></td></tr></tbody></table><div class="row"><span class="help-block right-floating" data-translate="gatewayApp.swapQuotes.valuesInPaise"></span></div><div class="row"><span class="help-block right-floating" data-translate="gatewayApp.swapQuotes.nullSpread"></span></div><div class="row"><span class="help-block right-floating" data-translate="gatewayApp.swapQuotes.zeroSpread"></span></div><div class="row"><span class="help-block right-floating" data-translate="gatewayApp.swapQuotes.quotesInterpolated"></span></div><div ng-show="filterData.length > noOfRecordsPerPage"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div ng-show="filterData.length == 0"><span>No record found</span></div></div></section></div><script src="assets/js/tables.js"></script></div><style>.importfile:hover {\r\n\tbackground: #000000;\r\n\tcolor: #F0CBA6;\r\n}\r\n\r\n.importfile {\r\n\tpadding: 2px 85px 6px 7px;\r\n\tcolor: #D9D9D9;\r\n\tbackground: #0D0D0D;\r\n}</style>');
$templateCache.put('app/entities/swap-quotes-for-tenor-date/swap-quotes-for-tenor-dates-dialog.html','<div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="gatewayApp.swapQuotes.home.editSwapQuote"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><form name="swapQuotesForm" role="form" novalidate><div class="row"><div class="form-group col-xs-5 no-margin-bottom"><label class="control-label left-align-label"><span data-translate="gatewayApp.swapQuotes.businessDate"></span></label></div><div class="form-group col-xs-5 no-margin-bottom"><label class="control-label left-align-label"><span data-translate="gatewayApp.swapQuotes.bank"></span></label></div></div><div class="row"><div class="form-group col-xs-5 no-margin-bottom"><cspl-dtp control-model="vm.businessDate" control-id="businessDate" control-disabled="true"></div><div class="form-group col-xs-6 no-margin-bottom"><cspl-text class="" control-model="vm.bank.bankName" control-disabled="true" form="swapQuotesForm" control-id="txtBankName"></div></div><div class="row" ng-if="vm.isNotNewEdit"><span class="right-floating field-highlighted-legend legend-blue-color" data-translate="gatewayApp.swapQuotes.highlightedFiledLegend"></span></div><div class="form-group col-md-12"><div><table class="dataTable table table-striped table-hover"><thead><tr><th class="col-md-2" data-translate="gatewayApp.swapQuotes.Instrument"></th><th class="col-md-2" data-translate="gatewayApp.swapQuotes.SettlementDate"></th><th class="col-md-4 td-text-align-right" data-translate="gatewayApp.swapQuotes.bidSpread"></th><th class="col-md-4 td-text-align-right" data-translate="gatewayApp.swapQuotes.offerSpread"></th></tr></thead></table></div><div class="non-scrollable"><table id="swapQuotesList" class="dataTable table table-striped table-hover"><tbody><tr ng-repeat="swapQuote in filterData = (vm.swapQuotesForTenorDatesList) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td class="line-height-2 col-md-2 imp-column"><span ng-if="swapQuote.tenorName == \'CASH\'">CASH/SPOT</span> <span ng-if="swapQuote.tenorName == \'TOM\'">TOM/SPOT</span> <span ng-if="swapQuote.tenorName != \'TOM\' && swapQuote.tenorName != \'CASH\'">{{swapQuote.tenorName}}</span></td><td class="line-height-2 col-md-2" ng-if="swapQuote.isTenorActive == true && swapQuote.settlementDate!=null"><span>{{swapQuote.settlementDate | date:\'dd-MMM-yyyy\'}}</span></td><td class="line-height-2 col-md-2" ng-if="swapQuote.isTenorActive == false || swapQuote.settlementDate==null"><span>{{"-"}}</span></td><td class="col-md-4 no-padding-bottom"><cspl-numeric control-model="swapQuote.bidSpread" control-id="BidSpread_{{$index}}" control-type="Number" no-of-decimals="2" control-max="999.75" autocomplete="" control-min="-999.75" form="swapQuotesForm" control-invalid="swapQuote.bidError == true" control-disabled="swapQuote.isTenorActive == false || vm.disableSpread" class="td-text-align-right height-30" control-value-change="vm.onSpreadValueChange($index,swapQuote.bidSpread,\'Bid\',swapQuote)" control-modified="vm.isModified(swapQuote.isBidSpreadModified)"></cspl-numeric><span ng-show="swapQuote.bidError == true && swapQuote.tenorName == \'CASH\'" class="help-block-error" style="text-align: left" data-translate="gatewayApp.swapQuotes.cashBidTickSizeError" data-translate-values="{value:vm.cashTickSize}"></span> <span ng-show="swapQuote.bidError == true && swapQuote.tenorName == \'TOM\'" class="help-block-error" style="text-align: left" data-translate="gatewayApp.swapQuotes.tomBidTickSizeError" data-translate-values="{value:vm.tomTickSize}"></span> <span ng-show="swapQuote.bidError == true &&  ( swapQuote.tenorName != \'CASH\' && swapQuote.tenorName != \'TOM\')" class="help-block-error" style="text-align: left" data-translate="gatewayApp.swapQuotes.fwdBidTickSizeError" data-translate-values="{value:vm.forwardTickSize}"></span></td><td class="col-md-4 no-padding-bottom"><cspl-numeric control-model="swapQuote.offerSpread" control-id="OfferSpread_{{$index}}" control-type="Number" no-of-decimals="2" control-max="999.75" autocomplete="" control-min="-999.75" form="swapQuotesForm" control-invalid="swapQuote.offerError == true" control-disabled="swapQuote.isTenorActive == false || vm.disableSpread" class="td-text-align-right height-30" control-value-change="vm.onSpreadValueChange($index,swapQuote.offerSpread,\'Offer\',swapQuote)" control-modified="vm.isModified(swapQuote.isOfferSpreadModified)"></cspl-numeric><!-- show-modification="true" --> <span ng-show="swapQuote.offerError == true && swapQuote.tenorName == \'CASH\'" class="help-block-error" style="text-align: left" data-translate="gatewayApp.swapQuotes.cashBidTickSizeError" data-translate-values="{value:vm.cashTickSize}"></span> <span ng-show="swapQuote.offerError == true && swapQuote.tenorName == \'TOM\'" class="help-block-error" style="text-align: left" data-translate="gatewayApp.swapQuotes.tomBidTickSizeError" data-translate-values="{value:vm.tomTickSize}"></span> <span ng-show="swapQuote.offerError == true && ( swapQuote.tenorName != \'CASH\' && swapQuote.tenorName != \'TOM\')" class="help-block-error" style="text-align: left" data-translate="gatewayApp.swapQuotes.fwdBidTickSizeError" data-translate-values="{value:vm.forwardTickSize}"></span></td></tr></tbody></table></div></div><div class="col-md-12"><div class="row"><span class="help-block right-floating" data-translate="gatewayApp.swapQuotes.valuesInPaise"></span></div><div class="row"><span class="help-block right-floating" data-translate="gatewayApp.swapQuotes.nullSpread"></span></div><div class="row"><span class="help-block right-floating" data-translate="gatewayApp.swapQuotes.zeroSpread"></span></div><div class="row"><span class="help-block right-floating" data-translate="gatewayApp.swapQuotes.quotesInterpolated"></span></div><br></div></form><div class="modal-footer"><button type="button" ng-show="showDiscardButton || showApproveRejectButton || vm.disableSpread" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button> <button type="button" ng-show="showButton || showResubmitButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="swapQuotesForm.$invalid || vm.clicked ||  vm.bidErrorList.length > 0 || vm.offerErrorList.length > 0" ng-click="vm.clicked = true;vm.resubmitSwapQuotes();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="swapQuotesForm.$invalid || swapQuotesForm.$pristine || vm.bidErrorList.length > 0 || vm.offerErrorList.length > 0|| vm.clicked" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardSwapQuotes()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectSwapQuotes()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveSwapQuotes();vm.clicked=true;" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></div>');
$templateCache.put('app/entities/swap-quotes-view/swap-quotes-home-page.html','<form name="swapQuotesHomePageForm" role="form" novalidate><div class="swap-ext"><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span ng-if="vm.account.organisation.organisationType.shortName!=\'BANK\'">Bank Comparative Quotes</span><span ng-if="vm.account.organisation.organisationType.shortName==\'BANK\'">Swap Quote</span></h4></div><div class="modal-body" ng-class="{\'clearcorp-view\': vm.account.organisation.organisationType.shortName==\'CLEARCORP\'}"><div class="content dashboard swap-quote-expand" style="max-height: inherit"><div ng-include="\'app/entities/swap-quotes-view/swap-quotes-report-view.html\'"></div></div></div></div></form>');
$templateCache.put('app/entities/swap-quotes-view/swap-quotes-report-view.html','<script>$(document).ready(function() {\r\n  $(\'#swapquotepaise\').scroll(function(e) { //detect a scroll event on the tbody\r\n   /*\r\n    Setting the thead left value to the negative valule of tbody.scrollLeft will make it track the movement\r\n    of the tbody element. Setting an elements left value to that of the tbody.scrollLeft left makes it maintain         it\'s relative position at the left of the table.    \r\n    */\r\n    $(\'#swapquotepaise_head thead\').css("left", -$("#swapquotepaise").scrollLeft()); //fix the thead relative to the body scrolling\r\n    $(\'#swapquotepaise_head1\').css("left", $("#swapquotepaise").scrollLeft()); //fix the first cell of the header\r\n    $(\'#swapquotepaise_head2\').css("left", $("#swapquotepaise").scrollLeft()); //fix the first cell of the header\r\n    $(\'#swapquotepaise td:nth-child(1)\').css("left", $("#swapquotepaise").scrollLeft()); //fix the first column of tdbody\r\n  });\r\n  $(\'#swapquoteprice\').scroll(function(e) { //detect a scroll event on the tbody\r\n   /*\r\n    Setting the thead left value to the negative valule of tbody.scrollLeft will make it track the movement\r\n    of the tbody element. Setting an elements left value to that of the tbody.scrollLeft left makes it maintain         it\'s relative position at the left of the table.    \r\n    */\r\n    $(\'#swapquoteprice_head thead\').css("left", -$("#swapquoteprice").scrollLeft()); //fix the thead relative to the body scrolling\r\n    $(\'#swapquoteprice_head1\').css("left", $("#swapquoteprice").scrollLeft()); //fix the first cell of the header\r\n    $(\'#swapquoteprice_head2\').css("left", $("#swapquoteprice").scrollLeft()); //fix the first cell of the header\r\n    $(\'#swapquoteprice td:nth-child(1)\').css("left", $("#swapquoteprice").scrollLeft()); //fix the first column of tdbody\r\n\r\n  });\r\n  $(\'#roEdApplicabilityPop\').popover({\r\n      container: \'body\',\r\n      html: true\r\n  })\r\n});</script><div class="market-depth markup"><div ng-class="{\'bank-branch-view\': vm.account.organisation.organisationType.shortName==\'BANK\'}"><h3></h3><ul class="market-depth-tab nav nav-tabs" role="tablist" style="float: left; margin-top: -10px"><li role="presentation" class="statistics-tab" ng-class="{\'active\': (vm.defaultTab==\'comparitive_tab1\' || vm.defaultTab==\'comparitive_tab2\' || vm.defaultTab==\'comparitive_tab3\' || vm.defaultTab==\'comparitive_tab4\')}"><a aria-controls="home" role="tab" aria-label="Bank Comparative Quotes" ng-click="vm.showPriceIcon=true; vm.defaultTab=\'comparitive_tab1\'" data-toggle="tab"><span class="icon-tab-head" ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'">Bank Comparative Quotes</span> <span class="icon-tab-head" ng-show="vm.account.organisation.organisationType.shortName==\'BANK\'">Swap Quote</span></a></li><!-- <li role="presentation" class="statistics-tab"  ng-class="{\'active\': vm.defaultTab==\'markup_tab\'}"\r\n            ng-show="vm.account.organisation.organisationType.shortName == \'CUSTOMER\'"><a\r\n            href="#markup_tab" aria-controls="home" role="tab" aria-label="Markup"\r\n            ng-click="vm.showPriceIcon=false;vm.defaultTab=\'markup_tab\';" data-toggle="tab"> <span\r\n            class="icon-tab-head">Markup</span>\r\n            </a>\r\n         </li> --></ul><div class="bcq-head" ng-if="vm.showPriceIcon"><div class="bcq-head-icons"><ul class="nav nav-tabs" role="tablist" ng-show="vm.account.organisation.organisationType.shortName != \'BANK\'"><li role="presentation" ng-class="{\'active\': vm.defaultTab==\'comparitive_tab1\'}"><a data-toggle="tab" role="tab" aria-label="Quotes In Paise" href="#comparitive_tab1" ng-click="vm.defaultTab=\'comparitive_tab1\'" class="bcq-icon1" title="Quotes In Paise"></a></li><li role="presentation" ng-class="{\'active\': vm.defaultTab==\'comparitive_tab2\'}"><a data-toggle="tab" role="tab" aria-label="Quotes In Price" href="#comparitive_tab2" ng-click="vm.defaultTab=\'comparitive_tab2\'" class="bcq-icon2" title="Quotes In Price"></a></li></ul><ul class="nav nav-tabs" role="tablist" ng-show="vm.account.organisation.organisationType.shortName == \'BANK\'"><li role="presentation" ng-class="{\'active\': vm.defaultTab==\'comparitive_tab3\'}"><a data-toggle="tab" role="tab" aria-label="Quotes In Paise" href="#comparitive_tab3" ng-click="vm.defaultTab=\'comparitive_tab3\'" class="bcq-icon1" title="Quotes In Paise"></a></li><li role="presentation" ng-class="{\'active\': vm.defaultTab==\'comparitive_tab4\'}"><a data-toggle="tab" role="tab" aria-label="Quotes In Price" href="#comparitive_tab4" ng-click="vm.defaultTab=\'comparitive_tab4\'" class="bcq-icon2" title="Quotes In Price"></a></li></ul><ul class="nav nav-tabs" role="tablist" ng-show="vm.showExpandIcon"><li role="presentation"><a data-toggle="tab" role="tab" aria-label="Expand view" class="bcq-icon3" title="Expand view" ng-click="vm.expandSwapQuote()"></a></li></ul></div></div><div class="bcq-head" ng-if="!vm.showPriceIcon && vm.showExpandIcon"><div class="bcq-head-icons"><ul class="nav nav-tabs" role="tablist"><li role="presentation"><a data-toggle="tab" role="tab" aria-label="Expand view" class="bcq-icon3" title="Expand view" ng-click="vm.expandSwapQuote()"></a></li></ul></div></div><div class="tab-content market-depth-contents"><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultTab==\'comparitive_tab1\'}" id="comparitive_tab1" ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'"><div class="bank-comparitive-contents"><div class="bank-comparitive-contents-freeze"><div class=""><table ng-show="bankComparativeDTO!=null && bankComparativeDTO!=undefined && bankComparativeDTO.header.length>0" id="swapquotepaise_head"><thead><tr class="inst"><td id="swapquotepaise_head1" ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class="background-black">&nbsp;&nbsp;</td><td align="center" class="headerRow bankComparitiveColor" colspan="2" ng-repeat-start="header in bankComparativeDTO.header"><span ng-if="header==\'CASH\' || header==\'TOM\'">{{header}}/SPOT </span><span ng-if="header!=\'CASH\' && header!=\'TOM\'">{{header}}</span></td><td ng-show="false" ng-repeat-end></td><td ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction" class="freeze-column background-black">&nbsp;&nbsp;</td></tr><tr class="thead"><td id="swapquotepaise_head2" ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class="">Bank</td><td class="text-right no-padding-right" ng-repeat-start="header in bankComparativeDTO.header">Bid</td><td class="text-right right-border padding-left-5">Offer</td><td ng-show="false" ng-repeat-end></td><td class="text-right freeze-column" ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction">&nbsp;&nbsp;</td></tr></thead><tbody id="swapquotepaise"><tr ng-repeat="swapQuotes in bankComparativeDTO.swapQuotesTenorDateDTOList"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class=""><span class="comp-name" ng-class="{\'selected\': swapQuotes.bank.bankName==vm.defaultTradingBank.bankName && vm.account.organisation.organisationType.shortName!=\'BANK\'}" ng-click="vm.onChangingBankInSwapQuotes(swapQuotes.bank)" title="{{swapQuotes.bank.bankName}}">{{swapQuotes.bank.bankName}}</span></td><td class="text-right cell-padding-3" ng-repeat-start="swapQuotesForTenorDates in swapQuotes.swapQuotesForTenorDatesList"><span class="bid-spread" ng-class="{\'selected\': swapQuotesForTenorDates.isBestBid && vm.account.organisation.organisationType.shortName!=\'BANK\'}">{{swapQuotesForTenorDates.bidSpread | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right cell-padding-3 right-border"><span class="offer-spread margin-right-xs" ng-class="{\'selected\': swapQuotesForTenorDates.isBestOffer && vm.account.organisation.organisationType.shortName!=\'BANK\'}">{{swapQuotesForTenorDates.offerSpread | number:vm.noOfDecimalsForAmount}}</span></td><td ng-show="false" ng-repeat-end></td><td align="center" ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction" class="freeze-column"><span class="edit-row"><img src="assets/images/edit-icon.png" alt="Edit" ng-click="vm.editSwapQuotes()"></span></td></tr><tr ng-show="bankComparativeDTO!= null && bankComparativeDTO!= undefined && bankComparativeDTO.swapQuotesTenorDateDTOList != null && bankComparativeDTO.swapQuotesTenorDateDTOList != undefined && bankComparativeDTO.swapQuotesTenorDateDTOList.length<2"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class=""></td><td ng-repeat-start="swapQuotesForTenorDates in swapQuotes.swapQuotesForTenorDatesList"></td><td class="right-border"></td><td ng-show="false" ng-repeat-end></td><td ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction" class="freeze-column">&nbsp;&nbsp;</td></tr><tr ng-show="bankComparativeDTO!= null && bankComparativeDTO!= undefined && bankComparativeDTO.swapQuotesTenorDateDTOList != null && bankComparativeDTO.swapQuotesTenorDateDTOList != undefined && bankComparativeDTO.swapQuotesTenorDateDTOList.length<3"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class=""></td><td ng-repeat-start="swapQuotesForTenorDates in swapQuotes.swapQuotesForTenorDatesList"></td><td class="right-border"></td><td ng-show="false" ng-repeat-end></td><td ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction" class="freeze-column">&nbsp;&nbsp;</td></tr></tbody></table><span ng-show="bankComparativeDTO!=null && bankComparativeDTO!=undefined && bankComparativeDTO.header.length>0" class="price-unit-val text-right">(Val in Paise)</span></div><div class="clearfix"></div></div></div></div><!--Bank Comparitive Tab 1 CLOSED--><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultTab==\'comparitive_tab2\'}" id="comparitive_tab2" ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'"><div class="bank-comparitive-contents"><div class="bank-comparitive-contents-freeze"><div class=""><table class="" ng-show="bankComparativeDTOInPrice!=null && bankComparativeDTOInPrice!=undefined && bankComparativeDTOInPrice.header.length>0" id="swapquoteprice_head"><thead><tr class="inst"><td id="swapquoteprice_head1" ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class="background-black">&nbsp;&nbsp;</td><td align="center" class="headerRow bankComparitiveColor" colspan="2" ng-repeat-start="header in bankComparativeDTOInPrice.header"><span ng-if="header==\'CASH\' || header==\'TOM\'">{{header}}/SPOT </span><span ng-if="header!=\'CASH\' && header!=\'TOM\'">{{header}}</span></td><td ng-show="false" ng-repeat-end></td></tr><tr class="thead"><td id="swapquoteprice_head2" ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'">Bank</td><td class="text-right" ng-repeat-start="header in bankComparativeDTOInPrice.header">Bid</td><td class="text-right right-border">Offer</td><td ng-show="false" ng-repeat-end></td></tr></thead><tbody id="swapquoteprice"><tr ng-repeat="swapQuotes in bankComparativeDTOInPrice.swapQuotesTenorDateDTOList"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'"><span class="comp-name" ng-class="{\'selected\': swapQuotes.bank.bankName==vm.defaultTradingBank.bankName && vm.account.organisation.organisationType.shortName!=\'BANK\'}" ng-click="vm.onChangingBankInSwapQuotes(swapQuotes.bank)" title="{{swapQuotes.bank.bankName}}">{{swapQuotes.bank.bankName}}</span></td><td class="text-right" ng-repeat-start="swapQuotesForTenorDates in swapQuotes.swapQuotesForTenorDatesList"><span class="bid-spread" ng-class="{\'selected\': swapQuotesForTenorDates.isBestBid && swapQuotesForTenorDates.bidSpread !=null && vm.account.organisation.organisationType.shortName!=\'BANK\'}">{{swapQuotesForTenorDates.bidSpread | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right right-border"><span class="offer-spread margin-right-xs" ng-class="{\'selected\': swapQuotesForTenorDates.isBestOffer && swapQuotesForTenorDates.offerSpread != null && vm.account.organisation.organisationType.shortName!=\'BANK\'}">{{swapQuotesForTenorDates.offerSpread | number:vm.noOfDecimalsForRate}}</span></td><td ng-show="false" ng-repeat-end></td></tr><tr ng-show="bankComparativeDTOInPrice!= null && bankComparativeDTOInPrice!= undefined && bankComparativeDTOInPrice.swapQuotesTenorDateDTOList != null && bankComparativeDTOInPrice.swapQuotesTenorDateDTOList != undefined && bankComparativeDTOInPrice.swapQuotesTenorDateDTOList.length<2"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'"></td><td ng-repeat-start="swapQuotesForTenorDates in swapQuotes.swapQuotesForTenorDatesList"></td><td class="right-border"></td><td ng-show="false" ng-repeat-end></td></tr><tr ng-show="bankComparativeDTOInPrice!= null && bankComparativeDTOInPrice!= undefined && bankComparativeDTOInPrice.swapQuotesTenorDateDTOList != null && bankComparativeDTOInPrice.swapQuotesTenorDateDTOList != undefined && bankComparativeDTOInPrice.swapQuotesTenorDateDTOList.length<3"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'"></td><td ng-repeat-start="swapQuotesForTenorDates in swapQuotes.swapQuotesForTenorDatesList"></td><td class="right-border"></td><td ng-show="false" ng-repeat-end></td></tr></tbody></table><span ng-show="bankComparativeDTOInPrice!=null && bankComparativeDTOInPrice!=undefined && bankComparativeDTOInPrice.header.length>0" class="price-unit-val text-right">&nbsp;</span></div><div class="clearfix"></div></div></div></div><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultTab==\'comparitive_tab3\'}" id="comparitive_tab3" ng-show="vm.account.organisation.organisationType.shortName==\'BANK\'"><div class="bank-comparitive-contents"><div class="table-responsive table-fixed" tabindex="0"><table class="table table-striped" ng-class="{\'scrollbar\': (bankComparativeDTO.swapQuotesTenorDateDTOList.length>3)}" ng-show="bankComparativeDTO!=null && bankComparativeDTO!=undefined && bankComparativeDTO.header.length>0"><thead><tr class="inst"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class="freeze-col-swap-quote-bank background-black" ng-class="{\'freeze-column-pending-order\': vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"></td><td align="center" class="headerRow bankComparitiveColor" colspan="2" ng-repeat-start="header in bankComparativeDTO.header"><span ng-if="header==\'CASH\' || header==\'TOM\'">{{header}}/SPOT </span><span ng-if="header!=\'CASH\' && header!=\'TOM\'">{{header}}</span></td><td ng-show="false" ng-repeat-end></td><td ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction" class="freeze-column freeze-col-swap-quote-edit background-black"></td></tr><tr class="thead"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class="freeze-col-swap-quote-bank" ng-class="{\'freeze-column-pending-order\': vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}">Bank</td><td class="text-right no-padding-right" ng-repeat-start="header in bankComparativeDTO.header">Bid</td><td class="text-right right-border padding-left-5">Offer</td><td ng-show="false" ng-repeat-end></td><td class="text-right freeze-column freeze-col-swap-quote-edit" ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction"></td></tr></thead><tbody><tr ng-repeat="swapQuotes in bankComparativeDTO.swapQuotesTenorDateDTOList"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class="freeze-col-swap-quote-bank" ng-class="{\'freeze-column-pending-order\': vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span class="comp-name" ng-class="{\'selected\': swapQuotes.bank.bankName==vm.defaultTradingBank.bankName && vm.account.organisation.organisationType.shortName!=\'BANK\'}" ng-click="vm.onChangingBankInSwapQuotes(swapQuotes.bank)" title="{{swapQuotes.bank.bankName}}">{{swapQuotes.bank.bankName}}</span></td><td class="text-right cell-padding-3" ng-repeat-start="swapQuotesForTenorDates in swapQuotes.swapQuotesForTenorDatesList"><span class="bid-spread" ng-class="{\'selected\': swapQuotesForTenorDates.isBestBid && vm.account.organisation.organisationType.shortName!=\'BANK\'}">{{swapQuotesForTenorDates.bidSpread | number:vm.noOfDecimalsForAmount}}</span></td><td class="text-right cell-padding-3 right-border"><span class="offer-spread margin-right-xs" ng-class="{\'selected\': swapQuotesForTenorDates.isBestOffer && vm.account.organisation.organisationType.shortName!=\'BANK\'}">{{swapQuotesForTenorDates.offerSpread | number:vm.noOfDecimalsForAmount}}</span></td><td ng-show="false" ng-repeat-end></td><td align="center" ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction" class="freeze-column freeze-col-swap-quote-edit"><span class="edit-row"><img src="assets/images/edit-icon.png" alt="Edit" ng-click="vm.editSwapQuotes()"></span></td></tr><tr ng-show="bankComparativeDTO!= null && bankComparativeDTO!= undefined && bankComparativeDTO.swapQuotesTenorDateDTOList != null && bankComparativeDTO.swapQuotesTenorDateDTOList != undefined && bankComparativeDTO.swapQuotesTenorDateDTOList.length<2"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class="freeze-col-swap-quote-bank" ng-class="{\'freeze-column-pending-order\': vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"></td><td ng-repeat-start="swapQuotesForTenorDates in swapQuotes.swapQuotesForTenorDatesList"></td><td class="right-border"></td><td ng-show="false" ng-repeat-end></td><td ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction" class="freeze-column freeze-col-swap-quote-edit"></td></tr><tr ng-show="bankComparativeDTO!= null && bankComparativeDTO!= undefined && bankComparativeDTO.swapQuotesTenorDateDTOList != null && bankComparativeDTO.swapQuotesTenorDateDTOList != undefined && bankComparativeDTO.swapQuotesTenorDateDTOList.length<3"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class="freeze-col-swap-quote-bank" ng-class="{\'freeze-column-pending-order\': vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"></td><td ng-repeat-start="swapQuotesForTenorDates in swapQuotes.swapQuotesForTenorDatesList"></td><td class="right-border"></td><td ng-show="false" ng-repeat-end></td><td ng-show="vm.account.organisation.organisationType.shortName==\'BANK\' && vm.permitSwapQuotesEditEntityAction" class="freeze-column freeze-col-swap-quote-edit"></td></tr></tbody></table></div><div class="clearfix"><span ng-show="bankComparativeDTO!=null && bankComparativeDTO!=undefined && bankComparativeDTO.header.length>0" class="price-unit-val text-right">(Val in Paise)</span></div></div></div><!--Bank Comparitive Tab 1 CLOSED--><div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultTab==\'comparitive_tab4\'}" id="comparitive_tab4" ng-show="vm.account.organisation.organisationType.shortName==\'BANK\'"><div class="bank-comparitive-contents"><div class="table-responsive table-fixed" tabindex="0"><table class="table table-striped" ng-class="{\'scrollbar\': (bankComparativeDTOInPrice.swapQuotesTenorDateDTOList.length>3)}" ng-show="bankComparativeDTOInPrice!=null && bankComparativeDTOInPrice!=undefined && bankComparativeDTOInPrice.header.length>0"><thead><tr class="inst"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class="freeze-col-swap-quote-bank background-black" ng-class="{\'freeze-column-pending-order\': vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"></td><td align="center" class="headerRow bankComparitiveColor" colspan="2" ng-repeat-start="header in bankComparativeDTOInPrice.header"><span ng-if="header==\'CASH\' || header==\'TOM\'">{{header}}/SPOT </span><span ng-if="header!=\'CASH\' && header!=\'TOM\'">{{header}}</span></td><td ng-show="false" ng-repeat-end></td></tr><tr class="thead"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class="freeze-col-swap-quote-bank" ng-class="{\'freeze-column-pending-order\': vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}">Bank</td><td class="text-right" ng-repeat-start="header in bankComparativeDTOInPrice.header">Bid</td><td class="text-right right-border">Offer</td><td ng-show="false" ng-repeat-end></td></tr></thead><tbody><tr ng-repeat="swapQuotes in bankComparativeDTOInPrice.swapQuotesTenorDateDTOList"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class="freeze-col-swap-quote-bank" ng-class="{\'freeze-column-pending-order\': vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"><span class="comp-name" ng-class="{\'selected\': swapQuotes.bank.bankName==vm.defaultTradingBank.bankName && vm.account.organisation.organisationType.shortName!=\'BANK\'}" ng-click="vm.onChangingBankInSwapQuotes(swapQuotes.bank)" title="{{swapQuotes.bank.bankName}}">{{swapQuotes.bank.bankName}}</span></td><td class="text-right" ng-repeat-start="swapQuotesForTenorDates in swapQuotes.swapQuotesForTenorDatesList"><span class="bid-spread" ng-class="{\'selected\': swapQuotesForTenorDates.isBestBid && swapQuotesForTenorDates.bidSpread !=null && vm.account.organisation.organisationType.shortName!=\'BANK\'}">{{swapQuotesForTenorDates.bidSpread | number:vm.noOfDecimalsForRate}}</span></td><td class="text-right right-border"><span class="offer-spread margin-right-xs" ng-class="{\'selected\': swapQuotesForTenorDates.isBestOffer && swapQuotesForTenorDates.offerSpread != null && vm.account.organisation.organisationType.shortName!=\'BANK\'}">{{swapQuotesForTenorDates.offerSpread | number:vm.noOfDecimalsForRate}}</span></td><td ng-show="false" ng-repeat-end></td></tr><tr ng-show="bankComparativeDTOInPrice!= null && bankComparativeDTOInPrice!= undefined && bankComparativeDTOInPrice.swapQuotesTenorDateDTOList != null && bankComparativeDTOInPrice.swapQuotesTenorDateDTOList != undefined && bankComparativeDTOInPrice.swapQuotesTenorDateDTOList.length<2"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class="freeze-col-swap-quote-bank" ng-class="{\'freeze-column-pending-order\': vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"></td><td ng-repeat-start="swapQuotesForTenorDates in swapQuotes.swapQuotesForTenorDatesList"></td><td class="right-border"></td><td ng-show="false" ng-repeat-end></td></tr><tr ng-show="bankComparativeDTOInPrice!= null && bankComparativeDTOInPrice!= undefined && bankComparativeDTOInPrice.swapQuotesTenorDateDTOList != null && bankComparativeDTOInPrice.swapQuotesTenorDateDTOList != undefined && bankComparativeDTOInPrice.swapQuotesTenorDateDTOList.length<3"><td ng-show="vm.account.organisation.organisationType.shortName!=\'BANK\'" class="freeze-col-swap-quote-bank" ng-class="{\'freeze-column-pending-order\': vm.account.organisation.organisationType.shortName!=\'CLEARCORP\'}"></td><td ng-repeat-start="swapQuotesForTenorDates in swapQuotes.swapQuotesForTenorDatesList"></td><td class="right-border"></td><td ng-show="false" ng-repeat-end></td></tr></tbody></table><span ng-show="bankComparativeDTOInPrice!=null && bankComparativeDTOInPrice!=undefined && bankComparativeDTOInPrice.header.length>0" class="price-unit-val text-right">&nbsp;</span></div><div class="clearfix"></div></div></div><!-- <div role="tabpanel" class="tab-pane" ng-class="{\'active\': vm.defaultTab==\'markup_tab\'}" id="markup_tab">\r\n            <div class="bank-comparitive-contents mark-up">\r\n               <div class="table-responsive table-fixed" tabindex="0"\r\n                  ng-class="{\'table-container\': vm.account.organisation.organisationType.shortName!=\'BANK\'}">\r\n                  <table class="table table-striped">\r\n                     <thead class="width-100">\r\n                        <tr>\r\n                           <td style="width: 20%"></td>\r\n                           <td style="width: 16%"></td>\r\n                           <td></td>\r\n                        </tr>\r\n                        <tr>\r\n                           <th>Bank&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</th>\r\n                           <th >Markup Type</th>\r\n                           <th class="text-right" style="width: 100px;">Markup Value</th>\r\n                           <th>\r\n                              <span>RO/ED Applicability</span>\r\n                              <span class="icon" ng-show="userPreference.showInfoIcon==\'yes\'" cspl-info-tooltip="Both legs means Mark-up will be charged on the Rebooking as well as on Cancellation Leg. Rebooking leg only means Mark-up will be charged on the Rebooking leg only" tooltip-position="left"><img class="width-height-20 info-tooltip-icon"/></span>\r\n                           </th>\r\n                        </tr>\r\n                     </thead>\r\n                     <tbody class="tbody-mark-up">\r\n                        <tr class="width-100" ng-repeat="markup in markupSettings">\r\n                           <td style="width: 20%"><span class="comp-name" \r\n                              ng-class="{\'selected\': markup.bankName==vm.defaultTradingBank.bankName && vm.account.organisation.organisationType.shortName!=\'BANK\'}"\r\n                              ng-click="vm.onChangingBankInMarkup(markup.bankName)"\r\n                              title="{{markup.bankName}}">{{markup.bankName}}</span></td>\r\n                           <td style="width: 16%"><span class="mdc-highlighted-txt" >{{markup.markupType}}</span></td>\r\n                           <td class="text-right padding-right-8"><span\r\n                               ng-show="markup.markupType.toLowerCase()==\'Paise\'.toLowerCase()">{{markup.markupValue\r\n                              | number:vm.noOfDecimalsForAmount}}</span> <span\r\n                                 ng-show="markup.markupType.toLowerCase()==\'Percentage\'.toLowerCase()">{{markup.markupValue|\r\n                              number:vm.noOfDecimalsForPercent}}</span>\r\n                           </td>\r\n                           <td>{{markup.roEdApplicabilityMethodName}}</td>\r\n                        </tr>\r\n                        <tr class="width-100"\r\n                           ng-show="markupSettings.length<2 && vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'">\r\n                           <td></td>\r\n                           <td></td>\r\n                           <td></td>\r\n                           <td></td>\r\n                        </tr>\r\n                        <tr class="width-100"\r\n                           ng-show="markupSettings.length<3 && vm.account.organisation.organisationType.shortName!=\'CUSTOMER\'">\r\n                           <td></td>\r\n                           <td></td>\r\n                           <td></td>\r\n                           <td></td>\r\n                        </tr>\r\n                     </tbody>\r\n                  </table>\r\n               </div>\r\n               <div class="clearfix"></div>\r\n            </div>\r\n         </div> --><!--Bank Comparitive Tab 2 CLOSED--></div></div></div>');
$templateCache.put('app/entities/swap-quotes-view/swap-quotes-view.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.swapQuotesView.title"></span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseSwapQuotesView = !vm.ExpandOrCollapseSwapQuotesView" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#SwapQuotesView"><img ng-src="{{vm.ExpandOrCollapseSwapQuotesView == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}">&nbsp;<span data-translate="gatewayApp.swapQuotesView.criteria">Criteria</span></a></h4></div><div id="SwapQuotesView" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="SwapQuotesViewForm"><div class="col-sm-6 col-centered"><div class="row"><label class="control-label col-md-3"><span data-translate="gatewayApp.swapQuotesView.bank"></span></label></div><div class="row"><div class="col-md-5"><cspl-ach control-model="vm.bank" control-id="txtTradingbank" lookup-name="nonTerminatedBanks" display-column="shortName" placeholder="" form="swapQuotesViewForm"></div></div><div class="row" style="margin-top: 7px"><label class="control-label col-md-3" cspl-mandatory><span data-translate="gatewayApp.swapQuotesView.from"></span></label></div><div class="row"><div class="col-md-5"><cspl-dtp control-model="vm.fromDate" control-min-date="vm.minDate" control-id="dtpFromDate" form="SwapQuotesViewForm" required></cspl-dtp></div></div><div class="row"><label class="control-label col-md-3" cspl-mandatory><span data-translate="gatewayApp.swapQuotesView.to"></span></label></div><div class="row"><div class="col-md-5"><cspl-dtp control-model="vm.toDate" control-id="dtpToDate" control-min-date="vm.minDate" form="SwapQuotesViewForm" required></cspl-dtp></div><div class="col-md-2"><button class="btn btn-info active" ng-disabled="SwapQuotesViewForm.$invalid||vm.clicked" ng-click="vm.getSwapQuotesView();vm.screenLog.screenLog(\'SwapQuotesView\',0,\'VIEW\');" data-toggle="collapse" data-target="#SwapQuotesView" data-translate="gatewayApp.swapQuotesView.go"></button></div></div></div></form></div></div></div><div ng-show="vm.swapQuotesList.length>0"><div class="row"><div class="pull-left"><div class="dropdown col-md-3" style="width:10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border:none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li><li><a ng-click="vm.exportToFile(\'pdf\');">PDF</a></li></ul></div></div><div class="col-md-2 col-sm-3 col-xs-4 right-floating"><cspl-table-search control-model="vm.filterText"></cspl-table-search></div></div><div class="swapQuotes"><div class="bootstrap-tableresponsive" style="overflow-x: auto; overflow-y: hidden"><table id="swapQuotesList" class="dataTable table table-striped table-hover swapQuotesListTable"><thead><tr><th class="" data-translate="gatewayApp.swapQuotesView.bank"></th><th class="" data-translate="gatewayApp.swapQuotesView.instrument"></th><th class="text-right noPaddingLeftRight" data-translate="gatewayApp.swapQuotesView.bidSpread"></th><th class="text-right noPaddingLeftRight" data-translate="gatewayApp.swapQuotesView.offerSpread"></th><th class="padding-left-30" data-translate="gatewayApp.swapQuotesView.businessDate"></th><th data-translate="gatewayApp.swapQuotesView.modifiedTime"></th></tr></thead><tbody><tr ng-repeat="swapQuotes in filterData = (vm.swapQuotesList | filter : vm.filterText) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td style="word-break:break-word">{{swapQuotes.bank.bankName}}</td><td style="word-break: break-word"><span ng-if="swapQuotes.tenorName == \'CASH\'">CASH/SPOT</span> <span ng-if="swapQuotes.tenorName == \'TOM\'">TOM/SPOT</span> <span ng-if="swapQuotes.tenorName != \'TOM\' && swapQuotes.tenorName != \'CASH\'">{{swapQuotes.tenorName}}</span></td><td class="text-right"><span ng-if="swapQuotes.bidSpread != null && swapQuotes.bidSpread != undefined">{{swapQuotes.bidSpread | number:vm.noOfDecimalsForAmount}}</span> <span ng-if="swapQuotes.bidSpread == null || swapQuotes.bidSpread == undefined">-</span></td><td class="text-right"><span ng-if="swapQuotes.offerSpread != null && swapQuotes.offerSpread != undefined">{{swapQuotes.offerSpread | number:vm.noOfDecimalsForAmount}}</span> <span ng-if="swapQuotes.offerSpread == null || swapQuotes.offerSpread == undefined">-</span></td><td class="padding-left-30">{{swapQuotes.businessDate | date: \'dd-MMM-yyyy\'}}</td><td>{{swapQuotes.lastModifiedDate | date: \'h:mm:ss a\'}}</td></tr></tbody></table><div ng-show="vm.swapQuotesList.length > noOfRecordsPerPage"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></div></div><div ng-show="vm.swapQuotesList.length==0"><span>No record found</span></div></section></div></div>');
$templateCache.put('app/entities/system-amended-trades/system-amended-trades.html','<div class="container-fluid" ng-cloak><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.systemAmendedTrades.title">System Amended Trades</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseSystemAmendedTrades = !vm.ExpandOrCollapseSystemAmendedTrades" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#SystemAmendedTradesReport"><img ng-src="{{vm.ExpandOrCollapseSystemAmendedTrades == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.systemAmendedTrades.criteria">Criteria</span></a></h4></div><div id="SystemAmendedTradesReport" class="collapse in" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="systemAmendedTradesReportForm"><div class="col-md-12"><div class="col-sm-offset-3 col-md-8 col-sm-8 col-xs-10 col-lg-3"><div class="row"><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\'"><label class="control-label"><span data-translate="gatewayApp.systemAmendedTrades.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bank" display-column="bankName" placeholder="" form="systemAmendedTradesReportForm"></div></div><div class="row"><div class="form-group" ng-if="vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'"><label class="control-label"><span data-translate="gatewayApp.systemAmendedTrades.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtTradingbank" lookup-name="tradingBank" display-column="shortName" placeholder="" form="systemAmendedTradesReportForm" filter-value="{{vm.loggedInCustomer}}"></div></div><div class="row"><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\'"><label class="control-label"><span data-translate="gatewayApp.systemAmendedTrades.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="branchesForBank" display-column="branchName" placeholder="" form="systemAmendedTradesReportForm" filter-value="{{vm.bank.id}}"></div></div><div class="row"><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\'"><label class="control-label"><span data-translate="gatewayApp.systemAmendedTrades.customer"></span></label><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="allTypeCustomers" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" control-place-holder="Enter Customer ID or Name" display-column="customerCode,customerName" placeholder="" form="systemAmendedTradesReportForm"></div></div><!-- <div class="row ">\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="control-label "><span\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.systemAmendedTrades.currencyPair"></span></label>\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t\t<cspl-ach control-model="vm.currencyPair"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tcontrol-id="txtcurrencyPair" lookup-name="currencyPair"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tfilter-value="{{ vm.bank.id ? vm.bank.id : 0 }}"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tcontrol-place-holder="Enter Currency Pair"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay-column="code" placeholder=""\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tform="systemAmendedTradesReportForm" />\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div> --></div></div><div class="col-md-12"><div class="col-sm-offset-3 col-xs-6 col-lg-3 col-sm-3"><div class="row"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.systemAmendedTrades.periodFrom"></span></label></div></div></div><div class="col-md-12"><div class="col-sm-offset-3 col-sm-3 col-lg-3 col-xs-10"><div class="row"><cspl-dtp control-model="vm.fromDate" control-id="dtpFromDate" form="systemAmendedTradesReportForm" control-min-date="vm.currentBusinessDate" required></cspl-dtp></div></div></div><div class="col-md-12"><div class="col-sm-offset-3 col-sm-3 col-xs-6"><div class="row"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.systemAmendedTrades.periodTo"></span></label></div></div></div><div class="col-md-12"><div class="col-sm-offset-3 col-sm-3 col-lg-3 col-xs-10"><div class="row"><cspl-dtp control-model="vm.toDate" control-id="dtpToDate" form="systemAmendedTradesReportForm" control-min-date="vm.currentBusinessDate" required></cspl-dtp></div></div><div class="col-md-1 col-sm-1"><div class="row"><button class="btn btn-info active" ng-disabled="systemAmendedTradesReportForm.$invalid||vm.clicked" ng-click="vm.loadAll();" data-toggle="collapse" data-translate="gatewayApp.systemAmendedTrades.go"></button></div></div></div></form></div></div></div><div ng-if="vm.systemAmendedtradesDetails.length > 0"><div class="row"><cspl-table-export class="col-md-1 col-sm-1 col-xs-1" table-name="SystemAmendedTradesReports" total-record-count="filterData.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="System_Amended_Trades"></cspl-table-export><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="SystemAmendedTradesReports" class="dataTable table table-striped table-hover"><thead><tr><th ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'" data-translate="gatewayApp.systemAmendedTrades.bank"></th><th ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'" data-translate="gatewayApp.systemAmendedTrades.branch"></th><th ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'" data-translate="gatewayApp.systemAmendedTrades.custId"></th><th ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'" data-translate="gatewayApp.systemAmendedTrades.customer"></th><th data-translate="gatewayApp.systemAmendedTrades.currencyPair"></th><th data-translate="gatewayApp.systemAmendedTrades.instrument"></th><th data-translate="gatewayApp.systemAmendedTrades.tradeType"></th><th data-translate="gatewayApp.systemAmendedTrades.settlementLeg"></th><th data-translate="gatewayApp.systemAmendedTrades.tradeNo"></th><th data-translate="gatewayApp.systemAmendedTrades.buySell"></th><th class="td-text-align-right" data-translate="gatewayApp.systemAmendedTrades.tradedQuantity"></th><th class="td-text-align-right" data-translate="gatewayApp.systemAmendedTrades.tradePrice"></th><th data-translate="gatewayApp.systemAmendedTrades.tradeDateTime"></th><th data-translate="gatewayApp.systemAmendedTrades.amendedDate"></th><th data-translate="gatewayApp.systemAmendedTrades.oldSettlementStartDate"></th><th data-translate="gatewayApp.systemAmendedTrades.oldSettlementEndDate"></th><th data-translate="gatewayApp.systemAmendedTrades.newSettlementStartDate"></th><th data-translate="gatewayApp.systemAmendedTrades.newSettlementEndDate"></th><th data-translate="gatewayApp.systemAmendedTrades.holidayDescription"></th></tr></thead><tbody><tr ng-repeat="systemAmendedTrades in filterData = (vm.systemAmendedtradesDetails | filter : filterText | orderBy: \'\')| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'">{{systemAmendedTrades.bank.bankName}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'">{{systemAmendedTrades.branch.branchName}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'">{{systemAmendedTrades.customer.customerCode}}</td><td ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\' || vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'">{{systemAmendedTrades.customer.customerName}}</td><td>{{systemAmendedTrades.currencyPair.code}}</td><td>{{systemAmendedTrades.instrument.instrumentCode}}</td><td>{{systemAmendedTrades.eventType.name}}</td><td><span ng-if="systemAmendedTrades.settlementLeg!=null && systemAmendedTrades.settlementLeg!=undefined">{{systemAmendedTrades.settlementLeg.name}}</span></td><td>{{systemAmendedTrades.tradeSequenceNumber}}</td><td ng-if="systemAmendedTrades.buySellFlag == \'BUYY\'">Buy</td><td ng-if="systemAmendedTrades.buySellFlag == \'SELL\'">Sell</td><td class="td-text-align-right" style="padding-right: 10px">{{systemAmendedTrades.tradeAmount| currency:"" : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right" style="padding-right: 10px">{{systemAmendedTrades.tradeExchangeRate| currency:"" : vm.noOfDecimalsForRate}}</td><td>{{systemAmendedTrades.tradeTime | date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td>{{systemAmendedTrades.businessDate | date:\'dd-MMM-yyyy\'}}</td><td>{{(systemAmendedTrades.oldTradeSettlementDateFrom | date:\'dd-MMM-yyyy\') ||\' \'}}</td><td>{{(systemAmendedTrades.oldTradeSettlementDate | date:\'dd-MMM-yyyy\') ||\' \'}}</td><td>{{(systemAmendedTrades.newTradeSettlementDateFrom | date:\'dd-MMM-yyyy\') ||\' \'}}</td><td>{{(systemAmendedTrades.newTradeSettlementDate | date:\'dd-MMM-yyyy\') ||\' \'}}</td><td>{{systemAmendedTrades.holidayDescription}}</td></tr></tbody></table></div><div ng-if="vm.systemAmendedtradesDetails.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div><div class="table-responsive" ng-if="vm.systemAmendedtradesDetails.length==0"><span>No record found</span></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/tac-view/tac-view.html','<style>body {\r\n      margin: 0;\r\n      padding: 0;\r\n      height: 100vh;\r\n      background: white;\r\n      background-size: cover;\r\n      font-family: sans-serif;\r\n    }\r\n\r\n    .pdf-container {\r\n      position: absolute;\r\n      top: 10%;\r\n      left: 10%;\r\n      width: 80%;\r\n      height: 80%;\r\n      background: white;\r\n      box-shadow: 0 0 20px rgba(0,0,0,0.4);\r\n    }</style><div class="clearcorp-tac-view"><section class="customer-registration-section customer-onboarding"><div class="row"><!-- <div class="form-box col-md-6 col-md-offset-3">\r\n                         <div class="form-box-heading">\r\n                            <img class="customer-page-logo" src="assets/images/CC_Logo.png" />\r\n                            <img class="customer-page-header" src="assets/images/Forex_Trading_Screen_Customer_Registration.png" />\r\n                               <span ng-if="vm.environmentName!=\'\' &&  vm.environmentName!=undefined &&  vm.environmentName!=null" style="margin-bottom: 30px;" class="btn-reg fw-bolder environment-name">{{vm.environmentName}}</span> \r\n                    </div> \r\n                </div> --><!-- <div ng-repeat="page in vm.pages">\r\n    <img ng-src="{{page}}" style="width: 100%; display: block; margin-bottom: 20px;" />\r\n</div> --><div id="pdfContainer" style="width:100%; height:90vh; border:1px solid #ccc"></div></div></section></div>');
$templateCache.put('app/entities/tac-view-for-entities/tac-agree-confirmation-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()" style="color:#F2F2F2">&times;</button><h4 class="modal-title">Terms and Conditions</h4></div><div class="modal-body"><div class="content"><div class="row"><input type="checkbox" class="col-xs-1" style="margin-top: 1%" id="tacDeclaration" ng-model="vm.isTacDeclared" required><label class="col-sm-10 justified-tac-label" for="tacDeclaration"><span ng-if="vm.isTACForCCIL" data-translate="gatewayApp.tacViewForEntities.tacDeclarationForCCIL"></span> <span ng-if="!vm.isTACForCCIL" data-translate="gatewayApp.tacViewForEntities.tacDeclarationForBank"></span></label></div><div class="row"><span class="col-xs-1"></span> <span ng-if="vm.showClearcorpTACHelpText" class="justified-help-block col-sm-10" data-translate="gatewayApp.tacViewForEntities.tacDeclarationHelpTextForCCIL"></span></div></div><div class="modal-footer"><button type="button" ng-if="!vm.isViewFromToDo" class="btn btn-approve" ng-disabled="clicked || !vm.isTacDeclared" ng-click="clicked = true;vm.agreeTAC();"><span data-translate="entity.action.agree">Agree</span></button> <button type="button" ng-if="vm.isViewFromToDo" class="btn btn-approve" ng-disabled="clicked || !vm.isTacDeclared" ng-click="clicked = true;vm.approve();"><span data-translate="entity.action.approve">Approve</span></button> <button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button></div></div>');
$templateCache.put('app/entities/tac-view-for-entities/tac-view-for-entities-todo-dialog.html','<div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span ng-if="showDiscardButton || showResubmitButton || showOk" data-translate="global.menu.tacViewForEntities.title"></span> <span ng-if="showApproveRejectButton" data-translate="global.menu.tacViewForEntities.approvalTitle"></span></h4></div><div class="modal-body"><div class="content"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="row"><form class="" name="entityTacViewToDoForm"><div class="col-md-offset-2 col-sm-offset-2 col-xs-offset-2 col-lg-offset-2 col-md-8 col-sm-8 col-xs-8 col-lg-8"><div class="form-group" style="margin-top:10px"><label class="control-label left-align-label"><span ng-if="vm.isTACForCCIL" data-translate="gatewayApp.tacViewForEntities.entityName"></span> <span ng-if="!vm.isTACForCCIL" data-translate="gatewayApp.tacViewForEntities.bankName"></span></label><cspl-text control-model="vm.tacAgreedEntityDetails.tacProviderName" control-id="latstRevisionDate" control-disabled="true"></div><div class="form-group" style="margin-top:10px"><label class="control-label left-align-label"><span data-translate="gatewayApp.tacViewForEntities.latestRevisionDate"></span></label><cspl-text control-model="vm.latestRevisionDateTime" control-id="latstRevisionDate" control-disabled="true"></div><div class="form-group" style="margin-top:10px"><label class="control-label left-align-label"><span data-translate="gatewayApp.tacViewForEntities.enforcingDate"></span></label><cspl-dtp control-model="vm.enforcingDate" control-id="enforcingDate" control-disabled="true"></cspl-dtp></div><div class="form-group"><div class="row" style="margin-left: -1px"><button class="col-sm-5 btn btn-info active" ng-click="vm.preview()" data-translate="entity.action.preview"></button></div></div><div class="form-group" ng-if="showApproveRejectButton || showResubmitButton"><input type="checkbox" class="col-xs-1" style="margin-top: 1%;margin-left: -7px" id="tacDeclaration" ng-model="vm.istacDeclared"><label for="tacDeclaration" class="col-sm-11 justified-tac-label"><span ng-if="vm.isTACForCCIL" data-translate="gatewayApp.tacViewForEntities.tacDeclarationForCCIL"></span> <span ng-if="!vm.isTACForCCIL" data-translate="gatewayApp.tacViewForEntities.tacDeclarationForBank"></span></label></div><div class="form-group" style="margin-top: 1%;margin-left: -8px" ng-if="vm.showClearcorpTACHelpText && (showApproveRejectButton || showResubmitButton)"><span class="col-xs-1"></span> <span class="justified-help-block col-sm-11" data-translate="gatewayApp.tacViewForEntities.tacDeclarationHelpTextForCCIL"></span></div></div></form></div></div><div class="modal-footer"><button type="button" ng-show="showDiscardButton || showApproveRejectButton || showOk" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button> <button type="button" ng-show="showResubmitButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="!vm.istacDeclared || entityTacViewToDoForm.$invalid || vm.clicked" ng-click="vm.clicked = true;vm.resubmit();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discard()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.reject()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-approve" ng-disabled="!vm.istacDeclared || entityTacViewToDoForm.$invalid || vm.clicked" ng-click="vm.approve();vm.clicked=true;" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div>');
$templateCache.put('app/entities/tac-view-for-entities/tac-view-for-entities.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.tacViewForEntities.title"></span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div ng-show="tacList.length>0"><div class="row"><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><!-- <div class="up-btn"> --><div class="dropdown" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\')">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div><!-- </div> --></div><div class="float-right col-md-2 col-sm-3 col-xs-4"><cspl-table-search control-model="vm.filterText"></cspl-table-search></div></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="tblTac" class="dataTable table table-striped table-hover"><thead><tr><!-- <th class="" ng-if="vm.isCustomerEntity" data-translate="gatewayApp.tacViewForEntities.clearcorpOrRelatioshipBank"></th> --><th class="" data-translate="gatewayApp.tacViewForEntities.latestRevisionDate"></th><th class="" data-translate="gatewayApp.tacViewForEntities.enforcingDate"></th><th class="" data-translate="gatewayApp.tacViewForEntities.agreed"></th><th class="" data-translate="gatewayApp.tacViewForEntities.agreedDate"></th><th class="" data-translate="gatewayApp.tacViewForEntities.agreedBy"></th><th></th></tr></thead><tbody><tr ng-repeat="tacDetail in filterData = (tacList | filter : vm.filterText) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><!-- <td ng-if="vm.isCustomerEntity" style="word-break:break-word;height: inherit;">{{tacDetail.tacProviderName}}</td> --><td style="height: inherit">{{ tacDetail.latestRevisionTime | date: \'dd-MMM-yyyy hh:mm:ss a\'}}</td><td style="height: inherit">{{ tacDetail.enforcingDate | date: \'dd-MMM-yyyy\'}}</td><td style="height: inherit">{{ tacDetail.isAgreed }}</td><td style="height: inherit"><span ng-if="tacDetail.agreedDateTime!=null && tacDetail.agreedDateTime!=\'\'">{{ tacDetail.agreedDateTime | date: \'dd-MMM-yyyy hh:mm:ss a\'}}</span> <span ng-if="tacDetail.agreedDateTime==null || tacDetail.agreedDateTime==\'\'">-</span></td><td style="height: inherit">{{ tacDetail.userFullName ||\'-\' }}</td><td class="sticky-col" style="text-align: right;width: 3%"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitTACAgreeEntityAction && tacDetail.isAgreed==\'No\'"><a ng-click="vm.confirmAgreeTAC(tacDetail)"><span class="hidden-xs hidden-sm" data-translate="entity.action.agree"></span></a></li><li ng-show="vm.permitTACViewEntityAction"><a ng-click="vm.previewTAC(tacDetail)"><span class="hidden-xs hidden-sm" data-translate="entity.action.preview"></span></a></li></ul></div></td></tr></tbody></table><div ng-show="tacList.length > noOfRecordsPerPage"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></div><div ng-show="tacList.length==0"><span>No record found</span></div></section></div></div>');
$templateCache.put('app/entities/terms-and-conditions/password-policy.html','<div class="{{vm.theme}}"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()" style="color:#F2F2F2">&times;</button><h4 class="modal-title">Password Policy</h4></div><div class="modal-body"><div class="content" id="passwordPolicy" style="line-height:2"><style>.terms-conditions-heading {\r\n\ttext-align: center;\r\n\tfont-family: segoe ui;\r\n\tfont-weight: bold;\r\n\ttext-decoration: underline;\r\n\tfont-size: 18px;\r\n}\r\n.alignContent\r\n{\r\n\ttext-align: justify;\r\n}\r\n.modal-footer {\r\n\tbackground: #000000;\r\n\tborder-top: 1px solid #000000;\r\n}\r\n\r\n.pwHeading{\r\n\t\r\n\tfont-weight:bold;\r\n\ttext-align: justify;\r\n}\r\n.light .pwHeading {\r\nbackground: #fff;\r\nline-height:2;\r\n}\r\n\r\n.dark .pwHeading{\r\n\tcolor:#ffffff;\r\n}\r\n\r\n.btn-primary .active{\r\n\tbackground: #2462EC !important;\r\n\tcolor: #FFFFFF;\r\n}\r\n\r\n.printContents{\r\n\tline-height:2 ;\r\n}\r\n\r\n.activeButton{\r\n\r\nbackground: #2462EC !important;\r\ncolor:#FFFFFF !important;\r\nborder:#2462EC !important;\r\n}\r\n\r\n@media print {\r\n\t.pwHeading{\r\n\t\tcolor:black !important;\r\n\t\tbackground:white !important;\r\n\t}\r\n}</style><div class="{{vm.theme}}"><div class="printContents"><div class="terms-conditions-heading" style="text-align:left;margin-bottom:10px">FX-Retail Password Policy:</div><ul><li class="pwHeading">User has to change the default password at the time of first login/Reset/Unlock.</li><li class="pwHeading">The password should contain minimum 8 and maximum 30 characters.</li><li class="pwHeading">The password should be alphanumeric and should contain both upper and lower case characters.</li><li class="pwHeading">The password should also contain at least one special character (such as !, @, #, ^, &, *, (, ), -, ., _ , : , ;). For example - Abcd@123.</li><li class="pwHeading">User should not reuse any of the previous 5 passwords.</li><li class="pwHeading">User account will get locked after 4 unsuccessful login attempts. The same will be get automatically unlocked after 24 hours.</li><li class="pwHeading">The user needs to change the password every 30 days. A system would display an expiry 3 days advance of expiry day.</li><li class="pwHeading">Password should not contain User ID.</li><li class="pwHeading">If the user does not login for 30 days; the user will get Dormant/Locked. To unlock, the user needs to click on &ldquo;Unlock my Account&rdquo; on the login page. The user has to enter the registered email id and mobile number on the Unlock Account screen. On clicking on &rdquo;Unlock&rdquo;, the new password will be sent to the registered email id.</li></ul></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary secondaryAction" data-dismiss="modal" ng-click="vm.printPage()" style="width:75px"><span>Print</span></button> <button type="button" class="btn btn-primary active" ng-class="{\'activeButton\' : vm.theme == \'light\'}" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>OK</span></button></div></div></div>');
$templateCache.put('app/entities/terms-and-conditions/schedule-of-fees.html','<div class="{{vm.theme}}"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()" style="color:#F2F2F2">&times;</button><h4 class="modal-title">Clearcorp\'s FX-Retail Fees and Charges</h4></div><div class="modal-body"><div class="content" id="scheduleOfFees"><style>.terms-conditions-heading{\r\n\ttext-align: center;\r\n    font-family: segoe ui;\r\n    font-weight: bold;\r\n    text-decoration: underline;\r\n    font-size: 18px;\r\n}\r\n\t\t\r\n\t\t\r\n.light .scheduleOfFeesTable .scheduleFeesCharges thead,.light .scheduleOfFeesTable .scheduleFeesCharges th,.light .scheduleOfFeesTable .scheduleFeesCharges tr,.light .scheduleOfFeesTable .scheduleFeesCharges td{\r\n\tborder: 2px solid black;\r\n} \r\n\r\n .scheduleOfFeesTable .scheduleFeesCharges thead, .scheduleOfFeesTable .scheduleFeesCharges th, .scheduleOfFeesTable .scheduleFeesCharges tr,.scheduleOfFeesTable .scheduleFeesCharges td{\r\n\tborder: 2px solid black;\r\n\tborder-collapse:collapse;\r\n} \r\n\r\n\r\n.dark .scheduleOfFeesTable .scheduleFeesCharges thead,.dark .scheduleOfFeesTable .scheduleFeesCharges th,.dark .scheduleOfFeesTable .scheduleFeesCharges tr,.dark .scheduleOfFeesTable .scheduleFeesCharges td{\r\n\tborder: 2px solid white;\r\n} \r\n\r\n.dark .scheduleOfFeesTable .scheduleFeesCharges td, .light .scheduleOfFeesTable .scheduleFeesCharges td, .dark .scheduleOfFeesTable .scheduleFeesCharges th, .light .scheduleOfFeesTable .scheduleFeesCharges th{\r\n\tpadding:5px;\r\n}\r\n\r\n.scheduleOfFeesTable .scheduleFeesCharges td,  .scheduleOfFeesTable .scheduleFeesCharges td,  .scheduleOfFeesTable .scheduleFeesCharges th,  .scheduleOfFeesTable .scheduleFeesCharges th{\r\n\tpadding:5px;\r\n}\r\n\r\n\r\n.schedule-content{\r\n\t    white-space: nowrap;\r\n    font-weight: bolder;\r\n    font-family: segoe ui;\r\n    font-size:15px;\r\n}\r\n.modal-footer {\r\n\tbackground: #000000;\r\n\tborder-top: 1px solid #000000;\r\n}</style><div class="terms-conditions-heading" style="margin-top:10px">FX-Retail Platform</div><div class="scheduleOfFeesTable"><table style="margin:auto;margin-top:20px;border: 2px solid black" class="scheduleFeesCharges"><thead><tr><th colspan="2" style="text-align:center" class="schedule-content">FX-Retail Fees and Charges</th></tr><tr><th style="text-align:center" class="schedule-content">Particulars</th><th style="text-align:center" class="schedule-content">Charges</th></tr></thead><tbody><tr><td class="schedule-content">One Time Customer Registration Charges**</td><td></td></tr><tr><td style="padding-left: 30px">a. Individual(Resident), Non-Resident Individual,<br>&nbsp;&nbsp;&nbsp;Sole Proprietorship and Hindu Undivided Family</td><td>NIL</td></tr><tr><td style="padding-left: 30px">b. Other Categories</td><td>NIL</td></tr><tr><td class="schedule-content">Transaction Charges</td><td>NIL</td></tr><!-- <tr>\r\n\t\t\t\t\t<th style="text-align:center" class="schedule-content">Monthly Turnover</th>\r\n\t\t\t\t\t<th style="text-align:center" class="schedule-content">Charges&nbsp;&#40;applicable on the total INR Value&#41;</th>\r\n\t\t\t\t</tr>\r\n\t\t\t\t\r\n\t\t\t\t<tr>\r\n\t\t\t\t\t<td style="padding-left: 30px;">a. Turnover &#60; USD 200 million</td>\r\n\t\t\t\t\t<td>0.0004%</td>\r\n\t\t\t\t</tr>\r\n\t\t\t\t<tr>\r\n\t\t\t\t\t<td style="padding-left: 30px;">b. Turnover &#62;&#61; USD 200 million &#38; &#60; USD 350 million</td>\r\n\t\t\t\t\t<td>0.0003%</td>\r\n\t\t\t\t</tr>\r\n\t\t\t\t<tr>\r\n\t\t\t\t\t<td style="padding-left: 30px;">c. Turnover &#62;&#61; USD 350 million &#38; &#60; USD 500 million</td>\r\n\t\t\t\t\t<td>0.0002%</td>\r\n\t\t\t\t</tr>\r\n\t\t\t\t<tr>\r\n\t\t\t\t\t<td style="padding-left: 30px;">d. Turnover &#62;&#61; USD 500 million</td>\r\n\t\t\t\t\t<td>NIL</td>\r\n\t\t\t\t</tr> --><!-- \t<tr>\r\n\t\t\t\t\t<td style="padding-left: 30px;">b. Above USD 50,000 in a day</td>\r\n\t\t\t\t\t<td>0.0004% on the entire Transaction value in INR terms*</td>\r\n\t\t\t\t</tr> --></tbody></table></div><div class="row" style="margin-top:10px; margin-bottom:20px"><div class="col-md-7"><!-- <div style="margin-top: 20px;margin-left: 30px;" class="schedule-content">* GST is applicable on the above charges</div>\r\n\t\t<div style="margin-left: 23px;" class="schedule-content">** One Time Customer Registration charges</div>\t\r\n\t\t<div type="" style="margin-left: 10%; margin-top:2px; margin-right:16%">\r\n\t\t<div>One Time Registration Charges is not applicable</div>\r\n\t\t<div> for Add Relationship Bank application.</div>  --><!-- <li style="margin-top:5px;">\r\n\t\tIndividual category includes Resident Individual, NRI, HUF and Sole Proprietor. All other customer categories are included under Non individual category.\r\n\t\t</li> --></div></div><div class="col-md-12" style="margin-top: 20px"><div style="float:right" ng-if="vm.displayPrint"><button type="button" class="btn btn-primary secondaryAction" data-dismiss="modal" ng-click="vm.printPage()" style="width:75px"><span>Print</span></button> <button type="button" class="btn btn-primary active" ng-class="{\'activeButton\' : vm.theme == \'light\'}" data-dismiss="modal" ng-click="vm.clear()"><span>OK</span></button></div></div></div><!-- <div class="modal-footer" >\r\n\t\t\t\t\t\t<button type="button" class="btn btn-primary secondaryAction" data-dismiss="modal" ng-click="vm.printPage()" style="width:75px">\r\n\t\t\t\t\t\t<span>Print</span>\r\n\t\t\t\t\t </button>\r\n\t\t\t\t\t \r\n\t\t\t\t\r\n\t\t\t\t\t\t  <button type="button" class="btn btn-primary active" ng-class="{\'activeButton\' : vm.theme == \'light\'}" data-dismiss="modal" ng-click="vm.clear()" >\r\n\t\t\t\t\t\t\t<span>OK</span>\r\n\t\t\t\t\t </button>\r\n\t\t\t\t\t \r\n                                       \r\n\t\t\t</div>\r\n --></div></div>');
$templateCache.put('app/entities/terms-and-conditions/terms-and-conditions-member.html','<div class="{{vm.theme}}"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()" style="color:#F2F2F2">&times;</button><h4 class="modal-title">Terms And Conditions</h4></div><div class="modal-body"><div class="content terms" id="printPage"><style>.termsField{\r\n\tline-height:2;\r\n}\r\n\r\n.termsField li, p{\r\n\tline-height:2;\r\n}\r\n\r\n.termsField li{\r\n\tpadding-left:10px;\r\n\tmargin-bottom:10px;\r\n}\r\n.HeaderWaterMark{\r\n\tcolor:#808080;\r\n\tfloat:right;\r\n\tpadding-top:10px;\r\n}\r\n\r\n.footerWaterMark{\r\n\tcolor:#808080;\r\n\ttext-align:center;\r\n}\r\n\r\n\r\n.terms-conditions-heading{\r\n\ttext-align: center;\r\n    font-family: segoe ui;\r\n    font-weight: bold;\r\n    text-decoration: underline;\r\n    font-size: 18px;\r\n}\r\n.alignContent\r\n{\r\n\ttext-align: justify;\r\n} \r\n.modal-footer {\r\n\tbackground: #000000;\r\n\tborder-top: 1px solid #000000;\r\n}</style><fieldset class="termsField"><img style="height:50px" src="assets/images/CCIL Logo_Symbol_small.png"><div class="HeaderWaterMark">FX-Retail Platform Terms and Conditions for Member</div><div class="terms-conditions-heading">FX-RETAIL PLATFORM</div><div class="terms-conditions-heading">Terms and Conditions for Members for approval of Customer to provide access of FX-Retail Platform</div><ol><li><p class="alignContent">Customer: For the purpose of this document, a Customer is a person or an entity which holds an account relationship with a Member Bank and intends to trade through the web based front end of FX-Retail Platform.</p></li><li><p class="alignContent">Clearcorp provides a facility to its members to approve / reject the request for Registration by their Customers to provide them access of Forex dealing in USD/INR currency pair through a web based front end of the FX-Retail Platform.</p></li><li><p class="alignContent">We confirm that the Customer holds an account relationship with us and is eligible to avail the trading facilities provided by the FX-Retail Platform.</p></li><li><p class="alignContent">We are aware that access of the FX-Retail Platform to the Customer will be available only during our active membership to FX-CLEAR Dealing Segment.</p></li><li><p class="alignContent">We understand that the compliance of KYC requirements under applicable laws in respect of the Customer is our sole responsibility and Clearcorp shall in no manner be responsible for the same. We hereby confirm that the Customer has completed all the required Know Your Customer (KYC) formalities with us as per the applicable laws.We shall also ensure the ongoing compliance of KYC requirements by the Customer as required under applicable laws.</p></li><li><p class="alignContent">We hereby confirm that we shall ensure due compliance with the applicable laws including but not limited to Information Technology Act, 2000 and Rules and Regulations thereunder with respect to the information of the Customer.</p></li><li><p class="alignContent">We hereby declare that the information provided by the Customer above at the time of Registration is true, correct and complete to the best of our knowledge and information. We agree that we are wholly responsible to verify the accuracy of the information provided by the Customer at the time of Registration. We affirm that Clearcorp shall not be responsible for any incorrect/inaccurate information provided by the Customer in this regard.</p></li><li><p class="alignContent">We confirm that the necessary internal approvals as required have been obtained for approving the Customer for the FX-Retail Platform. We confirm that the approval of Customers shall be made on an objective, fair and transparent manner.</p></li><li><p class="alignContent">We undertake that information (if any) will be provided to Customers in a fair and non-discriminatory basis.</p></li><li><p class="alignContent">We undertake to input the required trading/dealing limit values prior to commencement of dealing by the Customer. We confirm that we are wholly responsible for setting and modification of the limits for our Customers for trading on the FX-Retail Platform. Further, we are also aware that individual orders of a Customer would be validated against the applicable limits set by us and that any order violating the limit values would be rejected by the FX-Retail Platform.</p></li><li><p class="alignContent">We undertake to enter the swap quotes required for the final calculation of cash, tom rates for our Customers\uFFFD trades on the FX-Retail Platform. We are aware that our failure to enter the swap quotes would amount to the cash and tom instruments being unavailable for trading for the Customers.</p></li><li><p class="alignContent">We are aware that we are responsible for all actions of our Customers with respect to their dealing activities on the FX-Retail Platform.</p></li><li><p class="alignContent">We are aware that we have the facility to place orders on behalf of the Customers on the FX-Retail Platform based on their request. Further, we are also aware that individual orders placed by the Customer on the FX-Retail Platform can be modified or cancelled by us on behalf of the Customer based on a request.</p></li><li><p class="alignContent">We are aware that individual orders of the Customer that successfully pass through the limits set by us on the FX-Retail Platform would then be passed on to FX-CLEAR Dealing System and would be liable for matching like any other order received by FX-CLEAR Dealing System subject to the extant order matching rules and processes at the point of time.</p></li><li><p class="alignContent">We are aware that the trades concluded by the Customer on the FX-Retail Platform have to be bilaterally settled with the Customer and we shall not hold Clearcorp responsible for any delay or losses incurred in relation to the settlement of these trades.</p></li><li><p class="alignContent">We undertake to make timely payment to Clearcorp, of all the charges as may be payable by the Customer in relation to the FX-Retail Platform.</p></li><li><p class="alignContent">We undertake to suspend the Customer in case of disqualification of the Customer by any statutory/regulatory authority or an order of similar effect.</p></li><li><p class="alignContent">We undertake to ensure that access to information about Customers orders and trades that may be available to us on the FX-Retail Platform shall always be treated as confidential information received in good faith in the normal course of business. We further confirm that we shall ensure that such information shall not be used and/or taken advantage of at any time in any manner whatsoever.</p></li><li><p class="alignContent">We undertake that all data relating to Customer shall be maintained in easily retrievable media for at least 10 years. Without prejudice to the minimum requirement for storage of data, the data sought for any investigation by the Reserve Bank of India or any other authority as required under Indian laws or regulations shall be maintained for three years from the date of completion of the investigation.</p></li><li><p class="alignContent">We declare that we shall comply with and be bound by the Byelaws, Rules and Regulations as in existence or as may be modified/amended by the Clearcorp from time to time and/or any notification issued and/ or as maybe modified or amended from time to time by Clearcorp.</p></li><li><p class="alignContent">We confirm that we have the power to enter into and perform, and have taken all necessary action to authorize the entry into, performance and delivery of our obligations herein and the transactions contemplated by these Terms and Conditions;</p></li><li><p class="alignContent">These terms and conditions will constitute a legal, valid and binding obligation enforceable in accordance with its terms, subject to relevant laws;</p></li><li><p class="alignContent">All authorizations required or desirable in connection with the entry into, performance, validity and enforceability of, these Terms and Conditions, have been obtained or effected (as appropriate) and are in full force and effect.</p></li><li><p class="alignContent">The executant of this Terms and Conditions, is duly authorised by the Member to bind it for the purposes of giving effect to these Terms and Conditions.</p></li></ol><p style="font-weight:bold;font-family: segoe ui;padding-left:20px">We hereby confirm that we have read and understood the above terms and conditions contained herein above and agree to abide by the same at all times.</p></fieldset><div class="footerWaterMark">Confidential - Clearcorp Dealing Systems (India) Limited</div></div><div class="modal-footer"><button type="button" class="btn btn-primary secondaryAction" data-dismiss="modal" ng-click="vm.printPage()" style="width:75px"><span>Print</span></button> <button type="button" class="btn btn-primary active" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>OK</span></button></div></div></div>');
$templateCache.put('app/entities/terms-and-conditions/terms-and-conditions.html','<link rel="stylesheet" href="assets/css/styles.css"><div class="{{vm.theme}}"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()" style="color:#F2F2F2">&times;</button><h4 class="modal-title">Terms And Conditions</h4></div><div class="modal-body"><div class="content terms" id="printPage" style="-webkit-print-color-adjust:exact"><style>.termsField{\r\n\tline-height:2;\r\n}\r\n\r\n.termsField li, p{\r\n\tline-height:2;\r\n}\r\n\r\n.termsField li{\r\n\tpadding-left:10px;\r\n\tmargin-bottom:10px;\r\n}\r\n\r\n.HeaderWaterMark{\r\n\tcolor:#808080;\r\n\tfloat:right;\r\n\tpadding-top:10px;\r\n}\r\n\r\n.footerWaterMark{\r\n\tcolor:#808080;\r\n\ttext-align:center;\r\n}\r\n\r\n\r\n.terms-conditions-heading{\r\n\ttext-align: center;\r\n    font-family: segoe ui;\r\n    font-weight: bold;\r\n    text-decoration: underline;\r\n    font-size: 18px;\r\n}\r\n.termsHeading{\r\n\t\r\n\tfont-weight:bold;\r\n\tfont-size:18px;\r\n\r\n}\r\n.dark .termsHeading{\r\n\tcolor : #f0cba6;\r\n}\r\n.light .termsHeading{\r\n\tcolor: black;\r\n    background: #dcdcdc;\r\n    padding: 5px;\r\n}\r\n\r\n\r\n.alignContent\r\n{\r\n\ttext-align: justify;\r\n} \r\n\r\n.btn-primary .active{\r\n\tbackground: #2462EC !important;\r\n\tcolor: #FFFFFF;\r\n}\r\n\r\n.activeButton{\r\n\r\nbackground: #2462EC !important;\r\ncolor:#FFFFFF !important;\r\nborder:#2462EC !important;\r\n}\r\n\r\n@media print{\r\n\t.termsHeading{\r\n\t\tcolor:black !important;\r\n\t}\r\n}</style><div class="{{vm.theme}}"><fieldset class="termsField"><img style="height:50px" src="assets/images/CCIL Logo_Symbol_small.png"><div class="HeaderWaterMark">FX-Retail Platform Terms and Conditions for Customer</div><div class="terms-conditions-heading">FX-RETAIL PLATFORM</div><div class="terms-conditions-heading">TERMS & CONDITIONS FOR CUSTOMERS</div><ol><li><h1 class="termsHeading">Scope of this document</h1><p class="alignContent">This document lays down the terms and conditions between the Relationship Bank and the Customer for the usage of FX-Retail Platform by the Customer. The FX-Retail Platform is owned and operated by Clearcorp Dealing Systems (India) Limited [Clearcorp] and provides access to Forex dealing in USD/INR currency pair through an Internet based application.</p></li><li><h1 class="termsHeading">Customer</h1><p class="alignContent">For the purpose of this document, a Customer is a person or an entity which holds an account relationship with a Relationship Bank and intends to trade through the web based front end of FX-Retail Platform subject to these terms and conditions.</p></li><li><h1 class="termsHeading">Relationship Bank</h1><p class="alignContent">Relationship Bank is a FX-CLEAR Member of Clearcorp with which the Customer holds an account relationship. The Relationship Bank is solely entitled to approve the registration of its Customers on the basis of which access is provided to the web based front end of FX-Retail Platform subject to these terms and conditions.</p></li><li><h1 class="termsHeading">Registration and Approval</h1><ol type="i"><li class="alignContent">I/We hereby declare that the details furnished at the time of Registration for the FX-Retail Platform are true and correct to the best of my/our knowledge and belief.</li><li class="alignContent">I/We am/are aware that these details shall be submitted to my/our Relationship Bank for the purpose of approval of my/our Registration and shall be held in accordance with applicable laws and the applicable privacy policy (ies).</li><li class="alignContent">I/We agree that the decision regarding the approval for registration and access to the platform wholly rests with the Relationship Bank and would not hold Clearcorp responsible for any delay or whatsoever in this regard.</li><li class="alignContent">I/We agree that access to the trading platform through web based front end shall be provided to me/us based on the approval of the Registration by the Relationship Bank. The right of use of the trading platform is not transferable by me / us under any circumstance and shall be used by me / us only.</li></ol></li><li><h1 class="termsHeading">Password Policy</h1><ol type="i"><li class="alignContent">I/We have fully understood the Password Policy for accessing the FX-Retail Platform <a ng-click="vm.viewPasswordPolicy()">(For information on Password Policy, please click on link)</a> and undertake that the password policy shall be adhered to at all times.</li><li class="alignContent">I/We agree that I/We am/are solely responsible for keeping the user/login and password details confidential and shall not hold Clearcorp responsible for any losses arising out of the unauthorized use of the login details.</li><li class="alignContent">I/We am/are fully aware and understand the risks associated with using the FX-Retail Platform, over the internet and shall be fully liable and responsible for any or all acts done using my / our user/login details.</li></ol></li><li><h1 class="termsHeading">Trading days and timings</h1><ol type="i"><li class="alignContent">I/We am/are aware that the FX-Retail Platform shall normally function on all days except Saturdays, Sundays and those days that are declared as holidays under the Negotiable Instruments Act,1881 in the state of Maharashtra and such holidays as Clearcorp may declare from time to time.</li><li class="alignContent">I/We am/are aware that at the instance of RBI or any other regulatory authority authorized to so direct, Clearcorp may not operate the FX-Retail Platform on days other than or in addition to scheduled holidays or may operate the same on the days originally declared to be holidays and such decision shall be final and binding on me/us;</li><li class="alignContent">I/We am/are aware that the FX-Retail Platform shall be available for trading during the trading session timings set by Clearcorp and Clearcorp may extend, advance or reduce dealing hours by notifying as and when it deems fit and necessary in this regard;</li><li class="alignContent">I/We am/are aware that any order outstanding at the time of the session close would be automatically cancelled by the system.</li></ol></li><li><h1 class="termsHeading">Instruments</h1><ol type="i"><li class="alignContent">I/We agree that I/We shall be entitled to transact only in those instruments that are made available to Customers on the FX-Retail platform by Clearcorp.</li><li class="alignContent">I/We am/are aware that Clearcorp or my/our Relationship Bank may suspend dealing in a particular instrument as it deems fit and such suspension shall take effect as decided by Clearcorp or my/our Relationship Bank.</li><li class="alignContent">I/We am/are aware that I/We shall be allowed to access only the Retail Market for trading and the Inter-bank Spot market watch on the FX-Retail Platform is available to me / us only for view purpose.</li></ol></li><li><h1 class="termsHeading">Swap Quotes</h1><p class="alignContent">I/We am/are aware that the swap quotes for deriving the price for Cash and Tom would be as defined by the Relationship Bank. In case the swap quotes are modified by the Relationship Bank, it may result in modification/revision of the corresponding spot prices of our outstanding Cash and Tom orders.</p></li><li><h1 class="termsHeading">Order Validation</h1><ol type="i"><li class="alignContent">I/We am/are aware that orders entered into the FX-Retail Platform shall be subject to such validations as may be prescribed by Clearcorp from time to time including Order (price time and both) conditions and other dealing parameters.</li><li class="alignContent">I/We am/are aware that Orders that do not meet the validation requirements applicable to that type of Order will be rejected.</li><li class="alignContent">I/We am/are aware that the Relationship Bank has the facility to place, modify and cancel orders on my/our behalf based on my/our request.</li></ol></li><li><h1 class="termsHeading">Modification and Cancellation of Orders</h1><ol type="i"><li class="alignContent">I/We am/are aware that Orders shall be modified by effecting changes in the input parameters in the manner and subject to such conditions, as may be prescribed by Clearcorp from time to time.</li><li class="alignContent">I/We am/are aware that the modified Order may lose its time priority as per the dealing parameters.</li><li class="alignContent">I/We am/are aware that in the event of any technical issue or failure of connectivity (not attributable to any act or omission), Clearcorp or my/our Relationship Bank may on behalf of me/us cancel all my/our outstanding Orders; and I/We shall be accountable for the activity carried out by Clearcorp or Relationship Bank on my/our behalf. Clearcorp or Relationship Bank shall not be liable to me/us for any losses or costs if such Orders get matched before execution of the cancellation by Clearcorp or Relationship Bank.</li></ol></li><li><h1 class="termsHeading">Order Matching and Trading parameters</h1><ol type="i"><li class="alignContent">I/We am/are aware that Clearcorp may specify from time to time various Trading parameters which may include the types of Orders that can be placed on the FX-Retail Platform, lot size, Price Bands, Order Matching Rules and such other parameters as may be applicable.</li><li class="alignContent">I/We am/are aware that the orders can be placed on the FX-Retail platformas per the lot size and minimum lot size defined by Clearcorp.</li><li class="alignContent">I/We am/are aware that the orders cannot be placed beyond the maximum order size as may be defined by Clearcorp.</li><li class="alignContent">I/We am/are aware that Clearcorp may notify the Order Matching Rules from time to time which shall include the following:<ol type="a"><li class="alignContent">Orders shall be matched on the basis of Price-time priority;</li><li class="alignContent">The time recorded at FX-Retail Platform shall be the basis for determining time priority;</li><li class="alignContent">If the Order matches, then the Trade shall take place for the lower of the Order quantity placed between the Members;</li><li class="alignContent">The Best Bid Order shall match with the Best Offer Order. For dealing on Price, the best Bid Order shall be the one with the highest Price and the best Offer Order shall be the one with the lowest Price;</li><li class="alignContent">Such other Rules as may be notified from time to time by Clearcorp.</li></ol></li><li class="alignContent">I/We am/are aware that orders placed on the FX-Retail Platform may not be traded or may be traded partially or fully, based on the order quantity of the matching orders available at that point in time.</li><li class="alignContent">I/We am/are aware that a Helpdesk to address issues specifically related to the FX-Retail Platform is available to me/us and for any other issues, I/ We shall approach my/our Relationship Bank.</li></ol></li><li><h1 class="termsHeading">Trading Limits</h1><ol type="i"><li class="alignContent">I/We am/are fully aware that the Relationship Bank shall set the limits for trading on the platform for a particular time period and orders will be validated against these limits. Orders would get placed based on successful validation against the available limits for the instruments at that point in time.</li><li class="alignContent">I/We am/are fully aware that in case of limit inadequacy in a particular instrument or all instruments, the respective instrument/s shall be unavailable for trading on the FX-Retail platform and any order placed by me/us in such instrument/s shall be rejected by the system.</li></ol></li><li><h1 class="termsHeading">Rejection of Orders/Trades</h1><p>I/We am/are aware that Clearcorp may reject the Orders/Trades for any of the following conditions:</p><ol type="i"><li class="alignContent">When the Orders/Trades are not adequately covered by adequate limits as set by my/our Relationship Bank</li><li class="alignContent">When Orders are not as per the terms and conditions as applicable to such Orders;</li><li class="alignContent">In the event of declaration of unscheduled holiday or sudden development including failure of systems and applications whereby dealing operations for a particular Settlement Date have been temporarily suspended;</li><li class="alignContent">Trades at Off Market Prices;</li><li class="alignContent">In the event of Force Majeure.</li><li class="alignContent">Such other instances as may be specified by Clearcorp from time to time.</li></ol></li><li><h1 class="termsHeading">Settlement</h1><p class="alignContent">I/We am/are fully aware that the trades concluded on the FX-Retail Platform have to be bilaterally settled with my/our Relationship Bank. I/We shall not hold Clearcorp responsible for any delay or losses incurred in relation to the settlement of these trades.</p></li><li><h1 class="termsHeading">SMS and Email</h1><p class="alignContent">I/We agree to receive SMS and Email containing information pertaining to my/our usage of the FX-Retail Platform on the mobile number and email address provided at the time of Registration for the platform. I/We also agree that consent given by me / us herein shall override any of my/our previous DND request (if any) registered with my / our telecom service provider.</p></li><li><h1 class="termsHeading">Suspension</h1><p class="alignContent">I/We am/are fully aware and agree that my/or Relationship Bank has the right to suspend me/us from the FX-Retail Platform in case of my/or disqualification by any statutory/regulatory authority or an order of similar effect.</p></li><li><h1 class="termsHeading">Disputes</h1><ol type="i"><li class="alignContent">I/We am/are fully aware and agree that I/We shall approach only my/our Relationship Bank for resolution of any dispute/s arising from my/our dealing with the Relationship Bank in respect of FX-Retail Platform. Such disputes may be settled amicably and where no settlement is achieved, through arbitration.</li><li class="alignContent">I/We hereby acknowledge, agree and covenant that Clearcorp shall not be liable for any reason whatsoever.</li><li class="alignContent">For the limited process of arbitral dispute, if required, Clearcorp shall provide the record from its central processing unit to the Relationship Bank or me/us, on written request.</li></ol></li><li><h1 class="termsHeading">Fees And Charges</h1><p class="alignContent">I/We am/are aware and agree to pay the charges (including Registration charges and Transaction charges) to the Relationship Bank, as may be charged by Clearcorp at the time of registration and for using the trading facilities offered on the FX-Retail platform.</p><p class="alignContent"><a ng-click="vm.viewScheduleOfFees()">(For information on Fees and Charges, please click on link)</a></p></li><li><h1 class="termsHeading">Other Terms</h1><ol type="i"><li class="alignContent">I/We am/are fully aware that the FX-Retail Platform is being provided over the Internet which is susceptible to interruptions and failures. I/We shall not hold Clearcorp responsible for unavailability of the FX-Retail Platform as a result of internet failure or any other reason whatsoever.</li><li class="alignContent">I/We am/are fully aware that the technical pre-requisites as prescribed by Clearcorp, are necessary for the smooth functioning of the FX-Retail Platform and shall not hold Clearcorp responsible for any unexpected behavior of the platform resulting from non-fulfillment of the recommended technical pre-requisites.</li><li class="alignContent">I/We agree and am/are fully aware that Clearcorp does not, in any manner, warrant that the access of the FX-Retail Platform will be error-free and/or uninterrupted.</li><li class="alignContent">I/We am/are fully aware and agree that these terms and conditions are in addition to the terms and conditions agreed by me/us with my/our Relationship Bank, provided however that such terms and conditions are not in derogation of the terms and conditions herein.</li><li class="alignContent">I/We agree and undertake that I/We shall not publish, supply, show or make available to any other person/entity the facilities/data available on the FX-Retail Platform or the information provided by the FX-Retail Platform except with the explicit approval of Clearcorp. I / We shall not attempt to modify, translate, disassemble, decompile or reverse engineer the software underlying FX-Retail Platform or create any derivative product based on that software.</li><li class="alignContent">I/We fully agree and am/are aware that Clearcorp shall not in any way be liable for any loss suffered by me/us as a result of using the trading facilities on the FX-Retail Platform. Notwithstanding any other provisions of these Terms and Conditions, Clearcorp or my/our Relationship Bank has the right to withdraw my/our access to the Platform for breach of these Terms and Conditions, or if it is detrimental to the interest/reputation of the Clearcorp or the Relationship Bank.</li><li class="alignContent">I/We undertake that neither Clearcorp nor the directors, managers, officers, employees or agents of Clearcorp guarantee the functioning of the FX-Retail Platform or uninterrupted connectivity to the FX-Retail Platform. Clearcorp and the directors, managers, officers, employees and agents of Clearcorp shall not be liable in any way to us or any other party for any issue or any underperformance or interruption of FX-Retail Platform or for any damages, consequential or otherwise, arising therefrom or occasioned thereby. No proceedings shall be initiated by me/us or any third party against Clearcorp or against any of its directors, managers, officers or employees of Clearcorp for any act of commission or omission done in discharge of their official functions.</li><li class="alignContent">I/We undertake that Clearcorp shall, in no way, be liable for any direct and / or indirect damage, costs, claims and/or expenses whatsoever, in connection with<ol type="a"><li class="alignContent">Mechanical or electrical or network breakdown or power failure or malfunction of any of the servers or auxiliary equipment used by me/us and/ or any other cause beyond the reasonable control of Clearcorp.</li><li class="alignContent">Special direct/indirect economic or consequential loss or damage including, but not limited to loss of profit, business revenue, opportunity costs, goodwill or anticipated saving.</li><li class="alignContent">Any event of a Force Majeure. For the purpose of this clause, &ldquo;Force Majeure\t&rdquo; means and includes wars, insurrections, revolution, fires, floods, epidemic quarantine restrictions, declared general strikes in relevant industries, Act of God, Act of the Government of India and/or any concerned State Government and any such other acts or events beyond the control of Clearcorp.</li></ol></li></ol></li><li><h1 class="termsHeading">Governing Law</h1><p class="alignContent">These terms and conditions and / or the use of the services provided through FX-Retail Platform shall be governed by the laws of the Republic of India and no other nation. The mere fact that FX-Retail Platform can be accessed through Internet by a Customer in a country other than India shall not be interpreted to imply that the laws of the said country govern these terms and conditions.</p></li></ol><p style="font-weight:bold;font-family: segoe ui;padding-left:20px">I/We hereby confirm that I/We have read and understood the Terms and Conditions contained herein above and agree to abide by the same at all times.</p></fieldset></div><div class="footerWaterMark">Confidential - Clearcorp Dealing Systems (India) Limited</div></div><div class="modal-footer"><button type="button" class="btn btn-primary secondaryAction" data-dismiss="modal" ng-click="vm.printPage()" style="width:75px"><span>Print</span></button> <button type="button" class="btn btn-primary active" ng-class="{\'activeButton\' : vm.theme == \'light\'}" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>OK</span></button></div></div></div>');
$templateCache.put('app/entities/terms-and-conditions-approval/terms-and-conditions-approval.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()" style="color:#F2F2F2">&times;</button><h4 class="modal-title">Terms And Conditions Approval</h4></div><div class="modal-body"><div class="content"><input type="checkbox" style="vertical-align: middle;margin-bottom: 3px;margin-right: 1%" id="termsAndConditionsApproval" ng-model="vm.termsAndConditionsApproval"><label for="termsAndConditionsApproval"><a ui-sref="terms-and-conditions-checker-approval({theme:\'dark\'})"><span data-translate="gatewayApp.customerRegistration.termsAndConditions"></span></a></label></div><div class="modal-footer"><button type="button" class="btn btn-approve" ng-disabled="clicked || !vm.termsAndConditionsApproval" ng-click="clicked = true;vm.approve();"><span data-translate="entity.action.approve">Approve</span></button> <button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button></div></div>');
$templateCache.put('app/entities/trade-history/trade-history.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.tradeHistory.title">Trade History</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px;  margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseTradeHistory = !vm.ExpandOrCollapseTradeHistory" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#TradeHistory"><img ng-src="{{vm.ExpandOrCollapseTradeHistory == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.tradeHistory.criteria">Criteria</span></a></h4></div><div id="TradeHistory" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="tradeHistoryForm"><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\'"><label class="control-label"><span data-translate="gatewayApp.tradeHistory.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bank" display-column="bankName" placeholder="" form="tradeHistoryForm"></div><div class="form-group" ng-if="vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'"><label class="control-label"><span data-translate="gatewayApp.tradeHistory.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtTradingbank" lookup-name="tradingBank" display-column="shortName" placeholder="" form="tradeHistoryForm" filter-value="{{vm.loggedInCustomer}}"></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\'"><label class="control-label"><span data-translate="gatewayApp.tradeHistory.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="branchesForBank" display-column="branchName" placeholder="" form="tradeHistoryForm" filter-value="{{vm.bank.id}}"></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\'"><label class="control-label"><span data-translate="gatewayApp.tradeHistory.customer"></span></label><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="allTypeCustomers" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" control-place-holder="Enter Customer ID or Name" display-column="customerCode,customerName" placeholder="" form="tradeHistoryForm"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.tradeHistory.currencyPair"></span></label><cspl-ach control-model="vm.currencyPair" control-id="txtCurrencyPair" lookup-name="currencyPair" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}" display-column="code" placeholder="" form="tradeHistoryForm"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.tradeHistory.instrument"></span></label><cspl-ach control-model="vm.instrument" control-id="txtInstrument" lookup-name="marketInstrumentsCurrency" filter-value="{{ vm.currencyPair.id ? vm.currencyPair.id : 0 }}" display-column="instrumentCode" placeholder="" form="tradeHistoryForm"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.tradeHistory.buySell"></span></label><select class="form-control select-style select-notRequired" name="buySell" ng-model="vm.buySell" ng-options="buySell for buySell in vm.buySellIndicators" form="tradeHistoryForm"><option value="">--ALL--</option></select></div></div><div class="form-group"><div class="row"><label class="col-md-offset-3 control-label col-xs-6 col-md-6" cspl-mandatory><span data-translate="gatewayApp.tradeHistory.reportPeriod"></span></label><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><cspl-dtp control-model="vm.fromDate" control-id="dtpFromDate" form="tradeHistoryForm" control-min-date="vm.minDate" control-max-date="vm.yesterdayDate" required></div><div class="col-md-5 col-sm-6 col-xs-10 col-lg-3"><cspl-dtp control-model="vm.toDate" control-id="dtpToDate" form="tradeHistoryForm" control-min-date="vm.minDate" required></div><div class="col-md-1 col-sm-1"><button class="btn btn-info active" ng-disabled="tradeHistoryForm.$invalid||vm.clicked" ng-click="vm.getTradeHistory();" data-toggle="collapse" data-target="#TradeHistory" data-translate="gatewayApp.tradeHistory.go"></button></div></div><div class="row"><div class="col-md-offset-3 col-md-6 justified-help-block" style="padding-left:7px"><span data-translate="gatewayApp.tradeHistory.helpText"></span></div></div></div></form></div></div></div><div ng-show="vm.tradeHistory.length > 0"><div class="row"><cspl-table-export class="col-md-1 col-sm-1 col-xs-1" table-name="tradeHistory" total-record-count="filterData.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="Trade_History"></cspl-table-export><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="tradeHistory" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.tradeHistory.bank"></th><th data-translate="gatewayApp.tradeHistory.branch"></th><th data-translate="gatewayApp.tradeHistory.branchId"></th><th data-translate="gatewayApp.tradeHistory.custId"></th><th data-translate="gatewayApp.tradeHistory.customer"></th><th data-translate="gatewayApp.tradeHistory.currencyPair"></th><th data-translate="gatewayApp.tradeHistory.instrument"></th><th data-translate="gatewayApp.tradeHistory.tradeType"></th><th data-translate="gatewayApp.tradeHistory.settlementLeg"></th><th data-translate="gatewayApp.tradeHistory.buySell"></th><th data-translate="gatewayApp.tradeHistory.settlementStartDate"></th><th data-translate="gatewayApp.tradeHistory.settlementDate"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.tradeHistory.tradedQuantity"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.tradeHistory.tradePrice"></th><th class="td-text-align-right padding-right-0" data-translate="gatewayApp.tradeHistory.netTradePrice"></th><th class="td-text-align-right padding-right-0" data-translate="gatewayApp.tradeHistory.equivalentSpotTradePrice"></th><th class="td-text-align-right padding-right-0" data-translate="gatewayApp.tradeHistory.swapPtsInPaise"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.tradeHistory.tradeValue"></th><th data-translate="gatewayApp.tradeHistory.tradeDateTime"></th><th data-translate="gatewayApp.tradeHistory.tradeNumber"></th><th data-translate="gatewayApp.tradeHistory.orderNumber"></th><th data-translate="gatewayApp.tradeHistory.originalTradeNo"></th><th style="min-width:360px" data-translate="gatewayApp.tradeHistory.userRemarks1"></th><th style="min-width:360px" data-translate="gatewayApp.tradeHistory.userRemarks2"></th><th style="min-width:360px" data-translate="gatewayApp.tradeHistory.userRemarks3"></th><th style="min-width:360px" data-translate="gatewayApp.tradeHistory.userRemarks4"></th><th data-translate="gatewayApp.tradeHistory.exposureType"></th><th data-translate="gatewayApp.tradeHistory.exposureSubType"></th><th data-translate="gatewayApp.tradeHistory.deliveryMode"></th><th data-translate="gatewayApp.tradeHistory.source"></th><th ng-if="vm.entityOwnerType == \'Clearcorp\'" data-translate="gatewayApp.tradeHistory.fcyInrPrice"></th><th ng-if="vm.entityOwnerType == \'Clearcorp\'" data-translate="gatewayApp.tradeHistory.fcyUsdPrice"></th><th ng-if="vm.entityOwnerType == \'Clearcorp\'" data-translate="gatewayApp.tradeHistory.adjustedUsdInr"></th><th ng-if="vm.entityOwnerType == \'Clearcorp\'" data-translate="gatewayApp.tradeHistory.fcyUsdSwapPoints"></th><th ng-if="vm.entityOwnerType == \'Clearcorp\'" data-translate="gatewayApp.tradeHistory.usdInrSwapPoints"></th><th ng-if="vm.entityOwnerType == \'Clearcorp\'" data-translate="gatewayApp.tradeHistory.uniqueRequestId"></th></tr></thead><tbody><tr ng-repeat="tradeHistory in filterData = (vm.tradeHistory | filter : filterText | orderBy: \'-tradeSequenceNumber\')| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{tradeHistory.bankName}}</td><td>{{tradeHistory.branchName}}</td><td>{{tradeHistory.branchCode}}</td><td>{{tradeHistory.customerCode}}</td><td>{{tradeHistory.customerName}}</td><td>{{tradeHistory.currencyPairCode}}</td><td>{{tradeHistory.instrumentCode}}</td><td>{{tradeHistory.tradeTypeName}}</td><td>{{tradeHistory.settlementLegName}}</td><td>{{tradeHistory.buySellIndicator}}</td><td><span ng-if="tradeHistory.settlementStartDate !=null">{{tradeHistory.settlementStartDate| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="tradeHistory.settlementStartDate ==null">{{\'\'}}</span></td><td><span ng-if="tradeHistory.settlementDate != null && tradeHistory.settlementDate != undefined">{{tradeHistory.settlementDate | date:\'dd-MMM-yyyy\'}}</span></td><td class="td-text-align-right" style="padding-right:10px">{{tradeHistory.tradedQuantity| number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right noPaddingLeftRight">{{tradeHistory.tradedPrice| number : vm.noOfDecimalsForRate}}</td><!-- <td class="td-text-align-right padding-right-0">\r\n\t\t\t\t\t<span ng-if="tradeHistory.buySellIndicator==\'BUYY\'">{{tradeHistory.tradedPrice\r\n\t\t\t\t\t\t+ trade.markupRate | number:vm.noOfDecimalsForRate}}</span> <span\r\n\t\t\t\t\tng-if="tradeHistory.buySellIndicator==\'SELL\'">{{tradeHistory.tradedPrice\r\n\t\t\t\t\t\t- trade.markupRate | number:vm.noOfDecimalsForRate}}</span>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class="td-text-align-right padding-right-0">{{tradeHistory.spotTradeExchangeRate| number : vm.noOfDecimalsForRate}}</td> --><td class="td-text-align-right"><span ng-if="tradeHistory.netTradePrice != null && tradeHistory.netTradePrice != undefined">{{tradeHistory.netTradePrice| number:vm.noOfDecimalsForRate}}</span></td><td class="td-text-align-right"><span ng-if="tradeHistory.spotTradeExchangeRate != null && tradeHistory.spotTradeExchangeRate != 0">{{tradeHistory.spotTradeExchangeRate| number:vm.noOfDecimalsForRate}}</span></td><td class="td-text-align-right padding-right-0">{{vm.getSwapPoints(tradeHistory.spotTradeExchangeRate,tradeHistory.tradedPrice)| number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right" style="padding-right:10px">{{tradeHistory.tradedValue| number : vm.noOfDecimalsForAmount}}</td><td>{{tradeHistory.tradeDateTime | date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td>{{tradeHistory.tradeSequenceNumber}}</td><td><a ui-sref="order-activity-trade-history({orderNumber:tradeHistory.orderSequenceNumber})" style="text-decoration:underline">{{tradeHistory.orderSequenceNumber}}</a></td><td><a ui-sref="order-activity-trade-history({orderNumber:tradeHistory.originalOrderNo})" style="text-decoration:underline" ng-if="tradeHistory.originalTradeNo != null && tradeHistory.originalTradeNo != 0">{{tradeHistory.originalTradeNo}}</a></td><td style="min-width:360px">{{tradeHistory.userRemarks || \'-\'}}</td><td style="min-width:360px">{{tradeHistory.remarks2 || \'-\'}}</td><td style="min-width:360px">{{tradeHistory.remarks3 || \'-\'}}</td><td style="min-width:360px">{{tradeHistory.remarks4 || \'-\'}}</td><td>{{tradeHistory.exposureTypeName || \'-\'}}</td><td>{{tradeHistory.exposureSubTypeName || \'-\'}}</td><td>{{tradeHistory.deliveryMode || \'-\'}}</td><td>{{tradeHistory.sourceAppName}}</td><td ng-if="vm.entityOwnerType == \'Clearcorp\'">{{tradeHistory.fcyInrPrice}}</td><td ng-if="vm.entityOwnerType == \'Clearcorp\'">{{tradeHistory.fcyUsdPrice}}</td><td ng-if="vm.entityOwnerType == \'Clearcorp\'">{{tradeHistory.adjustedUsdInr}}</td><td ng-if="vm.entityOwnerType == \'Clearcorp\'">{{tradeHistory.fcyUsdSwapPoints}}</td><td ng-if="vm.entityOwnerType == \'Clearcorp\'">{{tradeHistory.usdInrSwapPoints}}</td><td ng-if="vm.entityOwnerType == \'Clearcorp\'">{{tradeHistory.uniqueRequestId}}</td></tr></tbody></table></div><div class="row padding-top-10"><span class="help-block right-floating" data-translate="gatewayApp.tradeHistory.originalTradeLegend"></span></div><div ng-show="vm.tradeHistory.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div><div class="table-responsive" ng-show="vm.tradeHistory.length==0"><span>No record found</span></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/trades-download/trades-download.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span data-translate="global.menu.tradesDownlaod.main"></span></h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><form class="form-horizontal" name="tradeDownloadForm" style="margin-left: 25%;    margin-right: 25%;    width: 50%"><div class="form-group col-sm-5 col-xs-10 col-lg-5 col-md-5 col-centered"><label class="control-label left-align-label" style="padding-bottom:7px"><span data-translate="gatewayApp.tradesDownload.forTheDay"></span></label><cspl-dtp control-model="vm.currentDate" control-id="currentDate" control-disabled="true" form="tradeDownloadForm"></div><div class="form-group col-sm-5 col-xs-10 col-lg-5 col-md-5 col-centered" style="padding-bottom:0px"><input id="selectTime" class="checkbox col-sm-2" name="selectTime" ng-model="vm.selectTime" type="checkbox" style="margin-top: 2%;  width: 6%;  margin-right:4%" ng-click="vm.checkSelection($event)"><label class="control-label" class="col-space" for="selectTime"><span data-translate="gatewayApp.tradesDownload.forTheDayTiming"></span></label></div><div class="form-group col-sm-4 col-xs-9 col-lg-4 col-md-4 col-centered" style="margin-left:2%;padding-bottom:0px"><label class="control-label" style="padding-bottom:7px"><span data-translate="gatewayApp.tradesDownload.fromTime"></span></label><div><cspl-time-picker control-model="vm.fromTime" control-id="dtpfromTime" control-max-date="vm.maxDateTime" control-min-date="vm.minDateTime" control24hrformat="false" form="tradeDownloadForm" control-disabled="vm.disableTime"></div></div><div class="form-group col-sm-4 col-xs-9 col-lg-4 col-md-4 col-centered" style="margin-left:2%;padding-bottom:0px"><label class="control-label" style="padding-bottom:7px"><span data-translate="gatewayApp.tradesDownload.toTime"></span></label><div class=""><cspl-time-picker control-model="vm.toTime" control-id="dtpToTime" control-max-date="vm.maxDateTime" control-min-date="vm.minDateTime" control24hrformat="false" form="tradeDownloadForm" control-disabled="vm.disableTime"></div></div><div class="form-group col-sm-7 col-xs-12 col-lg-8 col-md-7 col-centered" style="text-align: right"><button class="form-go-button-alignment btn btn-info active" ng-disabled="vm.clicked" ng-click="vm.downloadInCSV();vm.clicked=true;" data-translate="gatewayApp.tradesDownload.csvDownload"></button> <button class="form-go-button-alignment btn btn-info active" ng-disabled="vm.clicked" ng-click="vm.downloadInFIX();vm.clicked=true;" data-translate="gatewayApp.tradesDownload.fixDownlaod"></button></div></form></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/transaction-charges-report/transaction-charges-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.transactionCharges.title">Trade History</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseTransactionCharges = !vm.ExpandOrCollapseTransactionCharges" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#TransactionCharges"><img ng-src="{{vm.ExpandOrCollapseTransactionCharges == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.transactionCharges.criteria">Criteria</span></a></h4></div><div id="TransactionCharges" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="transactionChargesForm"><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\'"><label class="control-label"><span data-translate="gatewayApp.transactionCharges.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bank" display-column="bankName" placeholder="" form="transactionChargesForm"></div><div class="form-group" ng-if="vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'"><label class="control-label"><span data-translate="gatewayApp.transactionCharges.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtTradingbank" lookup-name="tradingBank" display-column="shortName" placeholder="" form="transactionChargesForm" filter-value="{{vm.loggedInCustomer}}"></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\'"><label class="control-label"><span data-translate="gatewayApp.transactionCharges.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="branchesForBank" display-column="branchName" placeholder="" form="transactionChargesForm" filter-value="{{vm.bank.id}}"></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\'"><label class="control-label"><span data-translate="gatewayApp.transactionCharges.customer"></span></label><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="allTypeCustomers" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" control-place-holder="Enter Customer ID or Name" display-column="customerCode,customerName" placeholder="" form="transactionChargesForm"></div></div><div class="form-group"><div class="row"><label class="col-md-offset-3 control-label col-xs-6 col-md-6" cspl-mandatory><span data-translate="gatewayApp.transactionCharges.reportPeriod"></span></label><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><cspl-dtp control-model="vm.fromDate" control-id="dtpFromDate" form="transactionChargesForm" control-min-date="vm.minDate" control-max-date="vm.yesterdayDate" required></div><div class="col-md-5 col-sm-6 col-xs-10 col-lg-3"><cspl-dtp control-model="vm.toDate" control-id="dtpToDate" form="transactionChargesForm" control-min-date="vm.minDate" control-max-date="vm.yesterdayDate" required></div><div class="col-md-1 col-sm-1"><button class="btn btn-info active" ng-disabled="transactionChargesForm.$invalid||vm.clicked" ng-click="vm.getTransactionHeader();" data-toggle="collapse" data-target="#TransactionCharges" data-translate="gatewayApp.transactionCharges.go"></button></div></div></div></form></div></div><div class="row"><div class="col-md-3 right-floating text-align-right" style="margin-bottom: 20px"><a class="clickable-link" ui-sref="schedule-of-fees-transaction-charges-report({theme:\'dark\'})"><span data-translate="gatewayApp.transactionCharges.scheduleOfFeesAndCharges"></span></a></div></div></div><div ng-show="vm.transactionCharges.length > 0"><div class="row"><div class="dropdown col-md-3" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="transactionCharges" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.transactionCharges.bank"></th><th data-translate="gatewayApp.transactionCharges.branch"></th><th data-translate="gatewayApp.transactionCharges.branchId"></th><th data-translate="gatewayApp.transactionCharges.customer"></th><th data-translate="gatewayApp.transactionCharges.custId"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionCharges.totalUSDQnty"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionCharges.totalINRValue"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionCharges.totalCharges"></th><!-- <th class="td-text-align-right "\r\n\t\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.transactionCharges.roundOffTo"></th> --><!-- <th\r\n\t\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.transactionCharges.source"></th> --></tr></thead><tbody><tr ng-repeat="transactionCharges in filterData = (vm.transactionCharges | filter : filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)" ng-click="vm.getTransctionDetails(transactionCharges);"><td>{{transactionCharges.bankName}}</td><td>{{transactionCharges.branchName}}</td><td>{{transactionCharges.branchID}}</td><td>{{transactionCharges.customerName}}</td><td>{{transactionCharges.customerCode}}</td><td class="td-text-align-right" style="padding-right: 10px">{{transactionCharges.totalCustomerWiseUSDQnty| number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{transactionCharges.totalCustomerWiseINRValue| number : vm.noOfDecimalsForAmount}}</td><!-- <td class="td-text-align-right ">{{transactionCharges.totalCustomerWiseTransactionCharges|\r\n\t\t\t\t\t\t\t\t\t\tnumber : vm.noOfDecimalsForAmount}}</td> --><td class="td-text-align-right">{{transactionCharges.totalRoundedOffTransactionCharges | number : vm.noOfDecimalsForAmount}}</td><!-- <td>{{transactionCharges.sourceAppName}}</td> --></tr></tbody><tfoot class="rounded-off-bar"><tr><td colspan="6" class="td-text-align-right" data-translate="gatewayApp.transactionCharges.grandTotal"></td><td class="td-text-align-right">{{vm.invoiceDTO.totalInrTradedValue | number : vm.noOfDecimalsForAmount}}</td><!-- <td class="td-text-align-right ">{{vm.invoiceDTO.totalChargesBeforeRoundingOFf\r\n\t\t\t\t\t\t\t\t\t\t| number : vm.noOfDecimalsForAmount}}</td> --><td class="td-text-align-right">{{vm.invoiceDTO.grossCharges | number : vm.noOfDecimalsForAmount}}</td></tr></tfoot></table></div><div ng-show="filterData.length>0"><span class="orderStatusInfo" data-translate="gatewayApp.transactionCharges.legend"></span></div><div ng-show="filterData.length>0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><div ng-show="vm.showDetails"><div class="row" ng-if="vm.entityOwnerType!=\'MultiUserCustomer\' && vm.entityOwnerType!=\'SingleUserCustomer\'"><h3 class="col-md-12"><span data-translate="gatewayApp.transactionCharges.customerWiseTradeDetails" class="details-table-header"></span></h3><label class="details-label col-md-2"><span data-translate="gatewayApp.transactionCharges.customerName"></span></label><label class="control-label col-md-9"><span>{{vm.selectedCustomerTransaction.customerName + \' (\' + vm.selectedCustomerTransaction.customerCode+ \')\'}}</span></label><label class="details-label col-md-2"><span data-translate="gatewayApp.transactionCharges.branchDetails"></span></label><label class="control-label col-md-9"><span>{{vm.selectedCustomerTransaction.branchName +\' - \' + vm.selectedCustomerTransaction.branchID}}</span></label><label class="details-label col-md-2"><span data-translate="gatewayApp.transactionCharges.customerAccountNumber"></span></label><label class="control-label col-md-9"><span>{{vm.selectedCustomerTransaction.customerAccountNumber}}</span></label><label class="details-label col-md-2"><span data-translate="gatewayApp.transactionCharges.customerDateOfJoining"></span></label><label class="control-label col-md-9"><span>{{vm.selectedCustomerTransaction.customerDateOfJoiningString}}</span></label></div><div class="row" ng-if="vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'"><h3 class="col-md-12"><span class="details-table-header">Trade Details</span></h3><label class="details-label col-md-2"><span data-translate="gatewayApp.transactionCharges.bankName"></span></label><label class="control-label col-md-9"><span>{{vm.selectedCustomerTransaction.bankName}}</span></label><label class="details-label col-md-2"><span data-translate="gatewayApp.transactionCharges.branchDetails"></span></label><label class="control-label col-md-9"><span>{{vm.selectedCustomerTransaction.branchName +\' - \' + vm.selectedCustomerTransaction.branchID}}</span></label><label class="details-label col-md-2"><span data-translate="gatewayApp.transactionCharges.customerAccountNumber"></span></label><label class="control-label col-md-9"><span>{{vm.selectedCustomerTransaction.customerAccountNumber}}</span></label><label class="details-label col-md-2"><span data-translate="gatewayApp.transactionCharges.customerDateOfJoining"></span></label><label class="control-label col-md-9"><span>{{vm.selectedCustomerTransaction.customerDateOfJoiningString}}</span></label></div><div class="table-responsive" style="overflow-x: auto; overflow-y: auto; max-height: 500px !important"><div class="row"></div><table id="customerWiseTransactionCharges" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.transactionCharges.currencyPair"></th><th data-translate="gatewayApp.transactionCharges.instrument"></th><th data-translate="gatewayApp.transactionCharges.tradeType"></th><th data-translate="gatewayApp.transactionCharges.settlementLeg"></th><th style="min-width:80px" data-translate="gatewayApp.transactionCharges.tradeDate"></th><th style="min-width:80px" data-translate="gatewayApp.transactionCharges.tradeSettlementDateFrom"></th><th style="min-width:80px" data-translate="gatewayApp.transactionCharges.settlementDate"></th><th data-translate="gatewayApp.transactionCharges.tradeNumber"></th><th data-translate="gatewayApp.transactionCharges.originalTradeNumber"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionCharges.tradeQuantityInUSD"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionCharges.tradePrice"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionCharges.tradeQuantityInINR"></th><th class="td-text-align-right">Charges</th><th class="td-text-align-right" data-translate="gatewayApp.transactionCharges.roundOffTo"></th><th data-translate="gatewayApp.transactionCharges.source"></th></tr></thead><tbody ng-repeat="(key, value) in vm.selectedCustomerTransaction.dailyTransactionDetailsList"><tr ng-repeat="val in value"><td>{{val.currencyPairCode}}</td><td>{{val.instrumentName}}</td><td>{{val.tradeTypeName}}</td><td>{{val.settlementLegName}}</td><td>{{val.tradeDate | date:\'dd-MMM-yyyy\'}}</td><td><span ng-if="val.tradeSettlementDateFrom !=null">{{val.tradeSettlementDateFrom| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="val.tradeSettlementDateFrom ==null">{{\'\'}}</span></td><td>{{val.settlementDate | date:\'dd-MMM-yyyy\'}}</td><td>{{val.tradeNumber}}</td><td ng-if="val.originalTradeNo != null && val.originalTradeNo != 0">{{val.originalTradeNo}}</td><td ng-if="!(val.originalTradeNo != null && val.originalTradeNo != 0)">{{\' \'}}</td><td class="td-text-align-right">{{val.tradeQuantityInUSD | number : vm.noOfDecimalsForAmount }}</td><td class="td-text-align-right">{{val.tradePrice| number : vm.noOfDecimalsForRate}}</td><td class="td-text-align-right">{{val.tradeQuantityInINR | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right"></td><td class="td-text-align-right"></td><td>{{val.sourceAppName}}</td></tr><tr class="total-bar"><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td data-translate="gatewayApp.transactionCharges.dayTotalUSDQnty"></td><td class="td-text-align-right">{{vm.dailyTransaction[key].totalUsdTradedQuantity | number : vm.noOfDecimalsForAmount}}</td><td data-translate="gatewayApp.transactionCharges.dayTotalINRValue"></td><td class="td-text-align-right">{{vm.dailyTransaction[key].totalInrTradedQuantity | number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right">{{vm.dailyTransaction[key].totalChargesComputed | number : vm.noOfDecimalsForAmount | charges:vm.dailyTransaction[key].chargePercentageApplied }}</td><td class="td-text-align-right">{{vm.dailyTransaction[key].totalChargesRoundedOff | number : vm.noOfDecimalsForAmount}}</td></tr></tbody><tfoot class="row grand-total-bar"><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td class="td-text-align-right">Total Charges</td><!-- <td class="td-text-align-right ">{{vm.selectedCustomerTransaction.totalCustomerWiseTransactionCharges| number : vm.noOfDecimalsForAmount}}</td> --><td class="td-text-align-right">{{vm.selectedCustomerTransaction.totalRoundedOffTransactionCharges| number : vm.noOfDecimalsForAmount}}</td></tr></tfoot></table></div><br><div class="row"><span class="roundOffLegend" data-translate="gatewayApp.transactionCharges.roundedOffLegend"></span></div><div class="row"><span class="orderStatusInfo right-floating" data-translate="gatewayApp.transactionCharges.originalTradeLegend"></span></div><br></div></div><div class="table-responsive" ng-show="vm.transactionCharges.length==0"><span>No record found</span></div></div></section></div><script src="assets/js/tables.js"></script><style>.total-bar {\r\n\tbackground-color: #1a260e !important;\r\n}\r\n\r\n.total-bar:hover {\r\n\tbackground: #1a260e !important;\r\n\tcolor: #F2F2F2 !important;\r\n}</style></div>');
$templateCache.put('app/entities/transaction-charges-settings/transaction-charges-settings-delete-dialog.html','<form name="deleteForm" ng-submit="clicked=true;vm.confirmDelete(vm.transactionCharges.id)"><div class="modal-header-red"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" style="text-align:left;padding-left:3%">Are you sure?</h4></div><div class="modal-body"><nmb-alert-error></nmb-alert-error><p><textarea class="form-control modal-header-red" rows="6" ng-model="vm.reason" placeholder="Please provide a reason" required></textarea></p><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger" ng-disabled="clicked"><span data-translate="entity.action.delete">Delete</span></button></div></div></div></form>');
$templateCache.put('app/entities/transaction-charges-settings/transaction-charges-settings-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="transactionChargesSettingsForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span ng-show="vm.transactionCharges.id==null" data-translate="global.menu.transactionChargesSettings.addNewTransactionCharges"></span> <span ng-show="vm.transactionCharges.id!=null" data-translate="global.menu.transactionChargesSettings.editTransactionCharges"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><br><div class="row"><div class="col-sm-4 right-label-div"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.transactionChargesSettings.customerType"></span></label></div><div class="col-sm-4"><cspl-ach control-model="vm.transactionCharges.customerType" control-id="txtCustomerType" placeholder="" form="transactionChargesSettingsForm" lookup-name="AllCustomerTypes" display-column="name" control-required="true" control-disabled="vm.viewMode || (vm.transactionCharges.id!=null || showResubmitButton)"></cspl-ach></div></div><br><div><div class="row"><table class="dataTable table table-striped table-hover"><thead><tr><th class="td-text-align-right" data-translate="gatewayApp.transactionChargesSettings.minTransactionAmount"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionChargesSettings.maxTransactionAmount"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionChargesSettings.charges"></th><th></th></tr></thead><tbody><tr ng-repeat="charge in vm.transactionChargesDetailsList"><td class="td-text-align-right" style="padding-bottom:0px !important"><span ng-hide="charge.editable">{{charge.minimumTradedValue | number: vm.noOfDecimals}}</span><div ng-show="charge.editable"><cspl-numeric control-model="charge.minimumTradedValue" control-id="txtMinValue" no-of-decimals="{{vm.noOfDecimals}}" form="transactionChargesSettingsForm" control-required="true" control-disabled="true"></cspl-numeric></div></td><td class="td-text-align-right" style="padding-bottom:0px !important"><span ng-hide="charge.editable">{{charge.maximumTradedValue | number: vm.noOfDecimals}}</span><div ng-show="charge.editable"><cspl-numeric control-model="charge.maximumTradedValue" control-id="txtMaxValue_{{$index}}" control-min="0" no-of-decimals="{{vm.noOfDecimals}}" control-max="999999999999.99" form="transactionChargesSettingsForm" control-required="true"></cspl-numeric><span class="help-block-warning-error" ng-show="errorMessage!=\'\' && errorMessage!=undefined && errorMessage!=null">{{errorMessage}}</span></div></td><td class="td-text-align-right" style="padding-bottom:0px !important"><span ng-hide="charge.editable">{{charge.charges | number : 4}}</span><div ng-show="charge.editable"><cspl-numeric control-model="charge.charges" control-id="txtCharges_{{$index}}" control-min="0" control-max="100" no-of-decimals="4" form="transactionChargesSettingsForm" control-required="true"></cspl-numeric></div></td><td style="padding-bottom:5px !important; padding-top:5px" nowrap="nowrap"><div><button class="btn btn-xs btn-primary btn-no-border" ng-show="!charge.editable" ng-click="vm.editCharges($index)" ng-disabled="DisabledControl"><span class="glyphicon glyphicon-pencil" title="Edit"></span></button> <button class="btn btn-xs btn-primary btn-no-border" ng-show="!charge.editable" ng-click="vm.removeCharges($index)" ng-disabled="DisabledControl"><span class="glyphicon glyphicon-trash" title="Delete"></span></button> <button style="margin-top:9px" class="btn btn-xs btn-primary btn-no-border" ng-show="charge.editable" ng-click="vm.addCharges($index)" ng-disabled="charge.minimumTradedValue == null|| charge.maximumTradedValue == null || charge.charges == null"><span class="glyphicon glyphicon-ok" ng-class="{\'glyphicon-ok-colored\': charge.minimumTradedValue != null && charge.maximumTradedValue != null && charge.charges != null}" title="Add"></span></button> <button style="margin-top:9px" class="btn btn-xs btn-primary btn-no-border" ng-show="charge.editable" ng-click="vm.resetCharges($index)" ng-disabled="charge.minimumTradedValue == null|| charge.maximumTradedValue == null || charge.charges == null"><span class="glyphicon glyphicon-remove" ng-class="{\'glyphicon-remove-colored\': charge.minimumTradedValue != null && charge.maximumTradedValue != null && charge.charges != null}" title="Remove"></span></button></div></td></tr></tbody></table><div class="row"><span class="help-block left-floating ng-scope" data-translate="gatewayApp.transactionChargesSettings.legend"></span></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="showResubmitButton" class="btn btn-primary" ng-disabled="vm.transactionCharges.customerType == null || vm.clicked || vm.transactionChargesDetailsList.length <2" ng-click="vm.clicked = true;vm.resubmitCharges();"><span data-translate="entity.action.resubmit">Resubmit</span></button> <button type="submit" ng-if="showButton" ng-disabled="vm.transactionCharges.customerType == null  || vm.clicked || vm.transactionChargesDetailsList.length <2" class="btn btn-info active" ng-click="vm.clicked = true;vm.save();"><span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardCharges()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectCharges()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveCharges();vm.clicked=true;" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/transaction-charges-settings/transaction-charges-settings.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.transactionChargesSettings.title">Transaction Charges Settings</h2><nmb-alert></nmb-alert><div><!-- <nmb-alert-error></nmb-alert-error>  --></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><div class="float-right"><button type="button" class="btn btn-info active" ng-click="vm.screenLog.screenLog(vm.screenName,0,vm.entityConstants.ENTITY_ACTION_TYPE.ADD);vm.launch()" ng-show="vm.permitTransactionChargesAddEntityAction"><img ng-src="assets/images/Add.png"> <span data-translate="gatewayApp.transactionChargesSettings.addCharges"></span></button></div><div class="float-right col-xs-10 col-sm-3 col-md-2"><cspl-table-search control-model="filterText"></cspl-table-search></div><div class="pull-left"><a href="" style="color: #fff;vertical-align:-19px"><i class="fa" ng-class="{ \'fa-refresh\': toggle, \'fa-refresh fa-spin\': !toggle }" ng-click="refresh()" style="font-size:20px"></i></a></div><span class="partition">|</span><div class="pull-left"><cspl-table-export table-name="transactionCharges" total-record-count="vm.transactionCharges.length" no-of-records-per-page="noOfRecordsPerPage" filter-text="filterText" page-no="page" file-name="Transaction_Charges_Settings"></cspl-table-export></div><div class="pull-left" style="margin-left: 0px" ng-show="vm.permitTransactionChargesImportEntityAction"><cspl-table-import upload-type="TransactionChargesImport" file-content=""></cspl-table-import></div></div><div class="bootstrap-tableresponsive"><table id="transactionCharges" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.transactionChargesSettings.customerType">Customer Type</th><th class="tableNumericColumn" data-translate="gatewayApp.transactionChargesSettings.minTransactionAmount">Min. Transaction Charges</th><th class="tableNumericColumn" data-translate="gatewayApp.transactionChargesSettings.maxTransactionAmount">Max. Transaction Charges</th><th class="tableNumericColumn" data-translate="gatewayApp.transactionChargesSettings.charges">Charges %</th><th></th></tr></thead><tbody><tr ng-repeat="transactionCharges in filterData = (vm.transactionCharges| filter : filterText | orderBy : \'transactionChargesSlabHeader.customerType.name\'\r\n\t\t\t)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{transactionCharges.transactionChargesSlabHeader.customerType.name}}</td><td class="tableNumericColumn">{{transactionCharges.minimumTradedValue | number : vm.noOfDecimalsForAmount}}</td><td class="tableNumericColumn">{{transactionCharges.maximumTradedValue | number : vm.noOfDecimalsForAmount}}</td><td class="tableNumericColumn">{{transactionCharges.charges | number : 4}}</td><td width="10%" style="text-align:right"><div class="btn-group utility" uib-dropdown><span class="glyphicon glyphicon-option-horizontal dropdown-toggle optionsMenu" uib-dropdown-toggle></span><ul class="dropdown-menu dropdownOptionsMenu dropdownOptionsMenualignment" uib-dropdown-menu><li ng-show="vm.permitTransactionChargesEditEntityAction"><a ui-sref="transaction-charges-settings-edit({id:transactionCharges.transactionChargesSlabHeader.id})" ng-click="vm.screenLog.screenLog(vm.screenName, transactionCharges.id, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT)"><span data-translate="entity.action.edit"></span></a></li><li ng-show="vm.permitTransactionChargesDeleteEntityAction"><a ui-sref="transaction-charges-settings-delete({id:transactionCharges.transactionChargesSlabHeader.id})" ng-click="vm.screenLog.screenLog(vm.screenName, transactionCharges.id, vm.entityConstants.ENTITY_ACTION_TYPE.DELETE)"><span data-translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table><div style="padding:5px" ng-show="vm.transactionCharges.length==0"><span>No record found</span></div><div ng-show="vm.transactionCharges.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/transaction-charges-summary/transaction-charges-summary.html','<div class="container-fluid" ng-cloak><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.transactionChargesSummary.title"></h2><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseTransactionChargesSummary = !vm.ExpandOrCollapseTransactionChargesSummary" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#TransactionChargesSummary"><img ng-src="{{vm.ExpandOrCollapseTransactionChargesSummary == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.transactionChargesSummary.criteria">Criteria</span></a></h4></div><div id="TransactionChargesSummary" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="transactionChargesSummaryForm"><div class="col-md-offset-2 col-lg-offset-3 col-sm-offset-1 col-md-5 col-sm-6 col-xs-10 col-lg-5"><div class="col-md-10"><label class="control-label"><span data-translate="gatewayApp.transactionChargesSummary.bank"></span></label></div><div class="form-group col-sm-7 col-md-9 col-lg-7 col-xs-7" style="margin-bottom: 23px"><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bank" display-column="bankName" placeholder="" form="transactionChargesSummaryForm"></div><div class="form-group col-md-12" style="margin-bottom: 23px"><div id="btnGroup"><div class="btn-group"><label class="btn btn-primary" style="font-size: 12px" ng-model="vm.freshOrPrintOption" uib-btn-radio="\'PrintGeneratedInvoice\'">Print Generated Invoice</label><label class="btn btn-primary" style="font-size: 12px" ng-model="vm.freshOrPrintOption" uib-btn-radio="\'GenerateAfresh\'">Generate Afresh</label></div></div></div><div class="col-md-10" ng-show="vm.freshOrPrintOption != \'GenerateAfresh\'"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.transactionChargesSummary.financialMonth"></span></label></div><div class="form-group col-sm-7 col-md-9 col-lg-7 col-xs-7" style="margin-bottom: 23px" ng-show="vm.freshOrPrintOption != \'GenerateAfresh\'"><select class="form-control select-style" name="financialMonth" ng-model="vm.financialMonth" ng-options="financialMonth.monthDisplay for financialMonth in vm.previousFiancialMonthOptions track by financialMonth.date" form="transactionChargesSummaryForm" required></select></div><div class="col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-left"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.transactionChargesSummary.from"></span></label></span></div><div class="form-group col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-right no-padding-left"><cspl-dtp control-model="vm.fromDate" control-id="dtpFromDate" control-min-date="vm.minDate" control-max-date="vm.maxDate" control-disabled="vm.freshOrPrintOption ==\'PrintGeneratedInvoice\'" form="transactionChargesSummaryForm" required></cspl-dtp></span></div><div class="col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-left"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.transactionChargesSummary.to"></span></label></span></div><div class="form-group col-md-12"><span class="col-md-5 col-sm-5 col-xs-5 no-padding-right no-padding-left"><cspl-dtp control-model="vm.toDate" control-id="dtpToDate" control-min-date="vm.minDate" control-max-date="vm.maxDate" control-disabled="vm.freshOrPrintOption ==\'PrintGeneratedInvoice\'" form="transactionChargesSummaryForm" required></cspl-dtp></span><span class="col-md-2 col-sm-2 col-xs-2" style="text-align: right"><button class="btn btn-info active" ng-disabled="transactionChargesSummaryForm.$invalid||vm.clicked" ng-click="vm.getTransactionChargesSummary()" data-toggle="collapse" data-target="#TransactionChargesSummary" data-translate="gatewayApp.transactionChargesSummary.go"></button></span></div></div></form></div></div></div><div ng-show="vm.transactionChargesSummaryDetails.headerList.length > 0"><div class="row"><div class="dropdown col-md-3" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportDataToFile(\'csv\')">CSV</a></li><li><a ng-click="vm.exportDataToFile(\'xls\');">XLS</a></li><li><a ng-click="vm.exportDataToFile(\'pdf\')">PDF</a></li></ul></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search><div class="col-xs-4 text-right pull-right" ng-show="vm.showDownloadEInvoice"><button type="button" class="btn btn-info active" id="btnDownloadEInvoice" style="margin: 0px;text-transform: none !important" ng-click="vm.downloadEInvoice()" ng-disabled="vm.eInvoiceDisable"><span data-translate="entity.action.downloadEInvoice"></span></button></div></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="transactionChargesSummaryHeader" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.transactionChargesSummary.memberName"></th><th data-translate="gatewayApp.transactionChargesSummary.membershipId"></th><th data-translate="gatewayApp.transactionChargesSummary.invoiceNumber"></th><th style="min-width: 65px" data-translate="gatewayApp.transactionChargesSummary.segment"></th><th style="min-width: 55px" data-translate="gatewayApp.transactionChargesSummary.month"></th><th style="min-width: 80px" data-translate="gatewayApp.transactionChargesSummary.from"></th><th style="min-width: 80px" data-translate="gatewayApp.transactionChargesSummary.to"></th><th data-translate="gatewayApp.transactionChargesSummary.bankStateName"></th><th data-translate="gatewayApp.transactionChargesSummary.bankGSTIN"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionChargesSummary.stateCode"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionChargesSummary.charges"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionChargesSummary.cgst"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionChargesSummary.sgst"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionChargesSummary.igst"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionChargesSummary.utgst"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionChargesSummary.totalTax"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionChargesSummary.totalCharges"></th></tr></thead><tbody><tr ng-repeat="transactionChargesSummary in filterData = (vm.transactionChargesSummaryDetails.headerList| filter : filterText )| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)" ng-click="vm.getTransactionChargesSummaryDetails(transactionChargesSummary);"><td style="word-break: break-word">{{transactionChargesSummary.bankChargesDTO.bankName}}</td><td>{{transactionChargesSummary.bankChargesDTO.membershipID}}</td><td><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\'">{{transactionChargesSummary.invoiceNumber}}</span><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\'">-</span></td><td>{{vm.transactionChargesSummaryDetails.platformName}}</td><td>{{transactionChargesSummary.from | date : \'MMMM\'}}</td><td>{{transactionChargesSummary.from | date : \'dd-MMM-yyyy\'}}</td><td>{{transactionChargesSummary.to | date : \'dd-MMM-yyyy\'}}</td><td><span ng-show="transactionChargesSummary.bankChargesDTO.state != null && transactionChargesSummary.bankChargesDTO.state.length > 0">{{transactionChargesSummary.bankChargesDTO.state}}</span><span ng-show="transactionChargesSummary.bankChargesDTO.state == null || transactionChargesSummary.bankChargesDTO.state.length == 0">-</span></td><td><span ng-show="transactionChargesSummary.bankChargesDTO.gstin != null && transactionChargesSummary.bankChargesDTO.gstin.length > 0">{{transactionChargesSummary.bankChargesDTO.gstin}}</span><span ng-show="transactionChargesSummary.bankChargesDTO.gstin == null || transactionChargesSummary.bankChargesDTO.gstin.length == 0">-</span></td><td class="td-text-align-right"><span ng-show="transactionChargesSummary.bankChargesDTO.tinNumber != null && transactionChargesSummary.bankChargesDTO.tinNumber != 0">{{transactionChargesSummary.bankChargesDTO.tinNumber}}</span><span ng-show="transactionChargesSummary.bankChargesDTO.tinNumber == null || transactionChargesSummary.bankChargesDTO.tinNumber == 0">-</span></td><td class="td-text-align-right">{{transactionChargesSummary.chargeDetails.grossCharges | currency:"" : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || transactionChargesSummary.bankChargesDTO.cgstPercent == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && transactionChargesSummary.bankChargesDTO.cgstPercent != null">{{transactionChargesSummary.chargeDetails.cgstAmount | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || transactionChargesSummary.bankChargesDTO.sgstPercent == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && transactionChargesSummary.bankChargesDTO.sgstPercent != null">{{transactionChargesSummary.chargeDetails.sgstAmount | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || transactionChargesSummary.bankChargesDTO.integratedTax == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && transactionChargesSummary.bankChargesDTO.integratedTax != null">{{transactionChargesSummary.chargeDetails.igstAmount | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || transactionChargesSummary.bankChargesDTO.utTaxPercent == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && transactionChargesSummary.bankChargesDTO.utTaxPercent != null">{{transactionChargesSummary.chargeDetails.utgstAmount | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' ||  ( transactionChargesSummary.bankChargesDTO.cgstPercent == null && transactionChargesSummary.bankChargesDTO.sgstPercent == null \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& transactionChargesSummary.bankChargesDTO.integratedTax == null && transactionChargesSummary.bankChargesDTO.utTaxPercent == null )">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && !( transactionChargesSummary.bankChargesDTO.cgstPercent == null && transactionChargesSummary.bankChargesDTO.sgstPercent == null \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& transactionChargesSummary.bankChargesDTO.integratedTax == null && transactionChargesSummary.bankChargesDTO.utTaxPercent == null )">{{transactionChargesSummary.chargeDetails.totalTaxAmount | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="transactionChargesSummary.chargeDetails.netCharges == null">-</span><span ng-show="transactionChargesSummary.chargeDetails.netCharges != null">{{transactionChargesSummary.chargeDetails.netCharges | currency:"" : vm.noOfDecimalsForAmount}}</span></td></tr></tbody><tfoot class="rounded-off-bar" ng-show="filterText == null || filterText.length == 0"><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td data-translate="gatewayApp.transactionChargesSummary.grandTotal"></td><td class="td-text-align-right"><span ng-show=" vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.grossCharges == null">-</span><span ng-show=" vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.grossCharges != null">{{vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.grossCharges | currency:"" : vm.noOfDecimalsForAmount}}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.cgstAmount == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.cgstAmount != null">{{vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.cgstAmount| currency:"" : vm.noOfDecimalsForAmount }}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.sgstAmount == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.sgstAmount != null">{{vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.sgstAmount| currency:"" : vm.noOfDecimalsForAmount }}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.igstAmount == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.igstAmount != null">{{vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.igstAmount| currency:"" : vm.noOfDecimalsForAmount }}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.utgstAmount == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.utgstAmount != null">{{vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.utgstAmount| currency:"" : vm.noOfDecimalsForAmount }}</span></td><td class="td-text-align-right"><span ng-show="vm.selectedPrintorRefresh == \'GenerateAfresh\' || vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.totalTaxAmount == null">-</span><span ng-show="vm.selectedPrintorRefresh != \'GenerateAfresh\' && vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.totalTaxAmount != null">{{vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.totalTaxAmount| currency:"" : vm.noOfDecimalsForAmount }}</span></td><td class="td-text-align-right"><span ng-show=" vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.netCharges == null">-</span><span ng-show=" vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.netCharges != null">{{vm.transactionChargesSummaryDetails.headerListGrandTotalCharges.netCharges| currency:"" : vm.noOfDecimalsForAmount }}</span></td></tr></tfoot></table></div><div ng-show="filterData.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><div ng-show="vm.transactionChargesSummarySelected != null && vm.transactionChargesSummarySelected.length > 0"><h3 class="col-md-4 col-xs-5"><span data-translate="gatewayApp.transactionChargesSummary.bankWiseCustomerDetails" class="details-table-header"></span></h3><div class="col-md-8 col-xs-7" style="margin-top:12px"><cspl-table-search control-model="filterTextSummary" class="col-md-3 col-sm-5 col-xs-6 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="transactionChargesSummaryDetails" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.transactionChargesSummary.customerName"></th><th data-translate="gatewayApp.transactionChargesSummary.customerType"></th><th data-translate="gatewayApp.transactionChargesSummary.memberName"></th><th data-translate="gatewayApp.transactionChargesSummary.bankStateName"></th><th data-translate="gatewayApp.transactionChargesSummary.bankGSTIN"></th><th data-translate="gatewayApp.transactionChargesSummary.customerDateOfJoining"></th><th class="td-text-align-right" data-translate="gatewayApp.transactionChargesSummary.charges"></th></tr></thead><tbody><tr ng-repeat="transactionChargesHeaderSummarySelected in filterDataSummary = (vm.transactionChargesSummarySelected| filter : filterTextSummary )| limitTo:noOfRecordsPerPageSummary:noOfRecordsPerPageSummary*(pageSummary-1)"><td style="word-break: break-word">{{transactionChargesHeaderSummarySelected.customerName}}</td><td>{{transactionChargesHeaderSummarySelected.customerType}}</td><td style="word-break: break-word">{{transactionChargesHeaderSummarySelected.bankChargesDTO.bankName}}</td><td><span ng-show="transactionChargesHeaderSummarySelected.bankChargesDTO.state != null && transactionChargesHeaderSummarySelected.bankChargesDTO.state.length > 0 ">{{transactionChargesHeaderSummarySelected.bankChargesDTO.state}}</span><span ng-show="transactionChargesHeaderSummarySelected.bankChargesDTO.state == null || transactionChargesHeaderSummarySelected.bankChargesDTO.state.length == 0 ">-</span></td><td><span ng-show="transactionChargesHeaderSummarySelected.bankChargesDTO.gstin != null && transactionChargesHeaderSummarySelected.bankChargesDTO.gstin.length > 0"></span>{{transactionChargesHeaderSummarySelected.bankChargesDTO.gstin}}<span ng-show="transactionChargesHeaderSummarySelected.bankChargesDTO.gstin == null || transactionChargesHeaderSummarySelected.bankChargesDTO.gstin.length == 0">-</span></td><td><span>{{transactionChargesHeaderSummarySelected.customerFormatedApprovedDate}}</span></td><td class="td-text-align-right"><span ng-show="transactionChargesHeaderSummarySelected.chargeOrSlabId == null">-</span><span ng-show="transactionChargesHeaderSummarySelected.chargeOrSlabId != null ">{{transactionChargesHeaderSummarySelected.chargeDetails.grossCharges| currency:"" : vm.noOfDecimalsForAmount }}</span></td></tr></tbody><tfoot class="grand-total-bar" ng-show="filterTextSummary == null || filterTextSummary.length == 0"><tr><td></td><td></td><td></td><td></td><td></td><td data-translate="gatewayApp.transactionChargesSummary.grandTotal"></td><td class="td-text-align-right"><span ng-show="vm.transactionChargesSummaryCharges == null || vm.transactionChargesSummaryCharges.grossCharges == null">-</span><span ng-show="vm.transactionChargesSummaryCharges != null || vm.transactionChargesSummaryCharges.grossCharges != null">{{vm.transactionChargesSummaryCharges.grossCharges | currency:"" : vm.noOfDecimalsForAmount }}</span></td></tr></tfoot></table></div><div ng-show="filterDataSummary.length > 0"><cspl-pagination record-count="filterDataSummary.length" control-model="pageSummary" items-per-page="noOfRecordsPerPageSummary"></cspl-pagination></div></div></div><div class="table-responsive" ng-show="vm.issuePresent == true || vm.transactionChargesSummaryDetails.headerList.length == 0"><span>No record found</span></div></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/entities/upload/upload-dialog.html','<form name="frmUploadDialog" role="form" novalidate><div class="modal-header"><h4 ng-if="vm.messageType!=\'Cancel Order\'" class="modal-title"><span>Import</span></h4><h4 ng-if="vm.messageType==\'Cancel Order\'" class="modal-title"><span>Pending Orders</span></h4></div><div class="modal-body"><div class="content"><fieldset><div class="row" ng-if="vm.messageType!=\'Cancel Order\'"><label class="col-sm-1 control-label no-padding-right" style="margin-top:5px"><span>Import Type</span></label><div class="col-md-4 padding-right-20"><cspl-text control-model="vm.messageType" control-id="txtshortName" control-disabled="true"></div><label class="col-sm-1 control-label no-padding-left no-padding-right" style="margin-top:5px" ng-if="vm.messageType==\'SwapQuotesImport\'"><span>Business Date</span></label><div class="col-md-2" ng-if="vm.messageType==\'SwapQuotesImport\'"><cspl-dtp control-model="vm.businessDate" control-id="businessDate" control-disabled="true"></div></div></fieldset></div><div class="row" ng-show="vm.uploadData.length > 0"><div class="table-responsive"><table id="tblUploadChecker" class="dataTable table table-striped table-hover"><thead><tr><th nowrap="nowrap" ng-repeat="columnHeader in vm.header.split(vm.dataColumnSeperator)" ng-class="{\'td-text-align-right\': vm.alignmentArray[$index] == \'right\'}">{{vm.globalValues.formatCamelCaseToStringWithSpace(columnHeader)}}</th></tr></thead><tbody><tr ng-repeat="rowValue in filterData = (vm.uploadData) | limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td ng-repeat="cellValue in rowValue.split(vm.dataColumnSeperator) track by $index" ng-class="{\'td-text-align-right\': vm.alignmentArray[$index] == \'right\'}"><span ng-if="vm.messageType==\'SwapQuotesImport\' && cellValue == \'CASH\'">CASH/SPOT</span> <span ng-if="vm.messageType==\'SwapQuotesImport\' && cellValue == \'TOM\'">TOM/SPOT</span> <span ng-if="vm.messageType==\'SwapQuotesImport\' && cellValue != \'CASH\' && cellValue != \'TOM\'">{{cellValue}}</span> <span ng-if="vm.messageType!=\'SwapQuotesImport\'">{{cellValue}}</span></td></tr></tbody></table></div><div stlye=""><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div class="row" ng-show="vm.uploadData.length == 0">No Records Found</div><div><nmb-alert-error></nmb-alert-error></div></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span>Close</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discard()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showButton" class="btn btn-reject" ng-click="vm.reject()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showButton" class="btn btn-approve" ng-disabled="clicked" ng-click="clicked = true;vm.approve();" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></form>');
$templateCache.put('app/entities/upload-download-participant-certificate/participant-certificate-dialog.html','<style>.btn-reject {background-color:#f34743; border:1px solid #f34743;color:white;}\r\n.btn-approve {background-color:#37a36a; border:1px solid #37a36a;color:white;}</style><form name="participantCertificateForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="global.menu.uploadDownloadCertificates.participantCertificate"></span></h4></div><div class="modal-body"><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="content"><fieldset><br><div class="col-sm-7 col-centered"><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.uploadDownloadCertificates.participantId"></span></label><cspl-text control-model="vm.certificate.participantCode" control-id="txtParticipantCode" control-disabled="true" form="participantCertificateForm" required><span class="cutomer-highlight" ng-show="vm.organisation != \'CLEARCORP\'">{{vm.certificate.organisationName}}</span></div><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.uploadDownloadCertificates.participantName"></span></label><cspl-text control-model="vm.certificate.organisationName" control-id="txtParticipantName" control-disabled="true" form="participantCertificateForm" required></div><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.uploadDownloadCertificates.fileName"></span></label><cspl-text control-model="vm.certificate.fileName" control-id="txtFileName" control-disabled="true" form="participantCertificateForm" required></div><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.uploadDownloadCertificates.expiryDate"></span></label><cspl-text control-model="vm.certificate.expiryDate" control-id="txtExpiryDate" control-disabled="true" form="participantCertificateForm" required></div><div class="form-group"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.uploadDownloadCertificates.issueDate"></span></label><cspl-text control-model="vm.certificate.issueDate" control-id="txtIssueDate" control-disabled="true" form="participantCertificateForm" required></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.uploadDownloadCertificates.password"></span></label><cspl-text control-model="vm.certificate.password" control-id="txtPassword" control-disabled="true" form="participantCertificateForm"></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" tabindex="-1"><span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-if="showDiscardButton" class="btn btn-reject" ng-click="vm.discardCertificate()" autofocus><span data-translate="entity.action.discard">Discard</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-reject" ng-click="vm.rejectCertificate()"><span data-translate="entity.action.reject">Reject</span></button> <button type="button" ng-if="showApproveRejectButton" class="btn btn-approve" ng-disabled="vm.clicked" ng-click="vm.approveCertificate();vm.clicked=true;" autofocus><span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/upload-download-participant-certificate/upload-download-participant-certificate.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title"><span ng-if="vm.entityOwnerType != \'Clearcorp\'" data-translate="global.menu.uploadDownloadCertificates.title">Upload/Download Certificates</span> <span ng-if="vm.entityOwnerType == \'Clearcorp\'" data-translate="global.menu.uploadDownloadCertificates.ccTitle">Upload Certificates</span></h2><nmb-alert></nmb-alert><div><nmb-alert-error></nmb-alert-error></div><div class="module-wrapper"><section class="module"><div class="module-inner"><div class="row"><form class="" role="form" name="uploadDownloadForm"><div class="col-md-offset-3 col-md-6" style="margin-top:20px"><div class="col-md-12" ng-if="vm.organisation != \'CLEARCORP\'"><div class="col-md-1" style="padding-right:0px"><input type="radio" name="optradio" id="radio1" class="radio" ng-model="vm.selectedFilter" value="upload" style="float:right;margin-top: 5px" form="uploadDownloadForm"></div><div class="col-md-11" style="margin-bottom:8px;padding-bottom:6px"><label class="control-label" for="radio1" style="color:#ffffff"><span data-translate="gatewayApp.uploadDownloadCertificates.uploadParticipantCertificate"></span></label></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-5"><label class="control-label"><span data-translate="gatewayApp.uploadDownloadCertificates.participantId"></span></label></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-5"><cspl-text control-model="vm.participantCode" control-id="txtParticipantCode" control-disabled="true" form="uploadDownloadForm" required><span class="cutomer-highlight" ng-show="vm.organisation != \'CLEARCORP\'">{{vm.participantName}}</span></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-11"><label class="control-label"><span data-translate="gatewayApp.uploadDownloadCertificates.keyFile"></span></label></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-7" style="margin-bottom:8px;padding-bottom:6px"><div class="input-group"><input type="text" class="form-control fileOpen" ng-model="vm.inputFile" readonly="readonly"><label for="certificate" class="btn btn-primary fileUploadDark" ng-class="{\'block-upload\' : vm.selectedFilter == \'download\'}"><img src="assets/images/Open Path-26.png" style="height:20px;padding-bottom:2px;pointer-events:none"></label><input type="file" id="certificate" name="certificate" fileread="vm.certificate" accept="application/cer" form="uploadDownloadForm" ng-hide="true"></div></div><div class="col-md-1"><button class="btn btn-info active" ng-disabled="vm.selectedFilter == \'download\' || vm.inputFile == null || vm.inputFile == undefined || vm.clicked" ng-click="vm.clicked = true;vm.uploadCertificate();vm.screenLog.screenLog(vm.screenName, 0 , vm.entityConstants.ENTITY_ACTION_TYPE.UPLOAD)" data-translate="gatewayApp.uploadDownloadCertificates.upload"></button></div></div><div ng-if="vm.organisation != \'CLEARCORP\'"><div class="col-md-12"><div class="col-md-1" style="padding-right:0px"><input type="radio" name="optradio" id="radio2" class="radio" style="float:right;margin-top:5px" ng-model="vm.selectedFilter" value="download" form="uploadDownloadForm"></div><div class="col-md-10"><label class="control-label" for="radio2" style="color:#ffffff"><span data-translate="gatewayApp.uploadDownloadCertificates.donwloadServerCertificate"></span></label></div><div class="col-md-1"></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-11" style="margin-top:10px;margin-bottom:10px"><button class="btn btn-info active" ng-disabled="vm.selectedFilter == \'upload\'||vm.clicked" ng-click="vm.downloadCertificate();vm.screenLog.screenLog(vm.screenName, 0 , vm.entityConstants.ENTITY_ACTION_TYPE.DOWNLOAD);vm.clicked=true;" data-translate="gatewayApp.uploadDownloadCertificates.download"></button></div></div></div></div></form></div></div></section></div></div>');
$templateCache.put('app/entities/user-access-view/user-access-view.html','<div class="container-fluid" ng-cloak><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.userAccessView.title" data-translate-values="{value: {{vm.todayDate}}}">User Access View</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseUserAccessView = !vm.ExpandOrCollapseUserAccessView" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#UserAccessView"><img ng-src="{{vm.ExpandOrCollapseUserAccessView == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.userAccessView.criteria">Criteria</span></a></h4></div><div id="UserAccessView" class="user-access-view collapse in" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="frmuseraccessview"><div class="row"><div class="col-md-offset-3 col-xs-6 col-md-6"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.userAccessView.entityOwnerType"></span></label></div></div><div class="row"><div id="btnGroup"><div class="btnGroup col-md-offset-3 col-md-6"><div class="btn-group noPaddingMargin" style="width: auto; margin-bottom: 8px"><label class="btn btn-primary" ng-model="vm.selectedEntityOwnerType" uib-btn-radio="\'Bank\'"><span data-translate="gatewayApp.userAccessView.bank"></span></label><label class="btn btn-primary" ng-model="vm.selectedEntityOwnerType" uib-btn-radio="\'MultiUserCustomer\'"><span data-translate="gatewayApp.userAccessView.multiUserCustomer"></span></label></div></div></div></div><div class="row margin-top-7" ng-show="vm.selectedEntityOwnerType == \'Bank\' && vm.entityOwnerType == \'Clearcorp\'"><div class="col-md-offset-3 col-xs-3 col-md-3"><label class="control-label" for="txtbank" cspl-mandatory><span data-translate="gatewayApp.userAccessView.bank"></span></label></div></div><div class="row" ng-show="vm.selectedEntityOwnerType == \'Bank\' && vm.entityOwnerType == \'Clearcorp\'"><div class="col-md-offset-3 col-xs-8 col-sm-5 col-md-3 col-lg-3"><cspl-ach control-id="txtbank" control-model="vm.bank" lookup-name="bankWithStatus" display-column="bankName" control-required="vm.selectedEntityOwnerType == \'Bank\'" form="frmuseraccessview"></cspl-ach><span class="help-block" ng-show="vm.bank!=null && vm.bank!=undefined"><span ng-if="vm.bank.bankStatus==\'Terminate\'">Terminated</span><span ng-if="vm.bank.bankStatus==\'Suspend\'">Suspended</span><span ng-if="vm.bank.bankStatus!=\'Terminate\' && vm.bank.bankStatus!=\'Suspend\'">{{vm.bank.bankStatus}}</span></span></div></div><div class="row margin-top-7" ng-show="vm.selectedEntityOwnerType == \'Bank\'"><div class="col-md-offset-3 col-xs-8 col-sm-5 col-md-3 col-lg-3"><label class="control-label" for="txtbranch"><span data-translate="gatewayApp.userAccessView.branch"></span></label></div></div><div class="row" ng-show="vm.selectedEntityOwnerType == \'Bank\'"><div class="col-md-offset-3 col-xs-8 col-sm-5 col-md-3 col-lg-3"><cspl-ach control-id="txtbranch" control-model="vm.branch" lookup-name="branchWithStatus" filter-value="{{vm.bank.id}}" display-column="branchName" control-required="false" form="frmuseraccessview"></cspl-ach><span class="help-block" ng-show="vm.branch!=null && vm.branch!=undefined"><span ng-if="vm.branch.branchStatus==\'Terminate\'">Terminated</span><span ng-if="vm.branch.branchStatus==\'Suspend\'">Suspended</span><span ng-if="vm.branch.branchStatus!=\'Terminate\' && vm.branch.branchStatus!=\'Suspend\'">{{vm.branch.branchStatus}}</span></span></div></div><div class="row margin-top-7" ng-show="vm.selectedEntityOwnerType == \'MultiUserCustomer\'"><div class="col-md-offset-3 col-xs-8 col-sm-5 col-md-3"><label class="control-label" for="txtCustomer" cspl-mandatory><span data-translate="gatewayApp.userAccessView.customer"></span></label></div></div><div class="row" ng-show="vm.selectedEntityOwnerType == \'MultiUserCustomer\' && vm.entityOwnerType == \'Clearcorp\'"><div class="col-md-offset-3 col-xs-8 col-sm-5 col-md-3 col-lg-3"><cspl-ach control-id="txtClearcorpCustomer" control-model="vm.customer" lookup-name="allNonPropCustomers" filter-value="{{2}}" display-column="customerCode,customerName" control-required="vm.selectedEntityOwnerType == \'MultiUserCustomer\' && vm.entityOwnerType == \'Clearcorp\'" form="frmuseraccessview"></cspl-ach><span class="help-block" ng-show="vm.customer!=null && vm.customer!=undefined"><span ng-if="vm.customer.entityRestrictionStatus.displayName==\'Terminate\'">Terminated</span><span ng-if="vm.customer.entityRestrictionStatus.displayName==\'Suspend\'">Suspended</span><span ng-if="vm.customer.entityRestrictionStatus.displayName!=\'Terminate\' && vm.customer.entityRestrictionStatus.displayName!=\'Suspend\'">{{vm.customer.entityRestrictionStatus.displayName}}</span></span></div></div><div class="row" ng-show="vm.selectedEntityOwnerType == \'MultiUserCustomer\' && vm.entityOwnerType == \'Bank\'"><div class="col-md-offset-3 col-xs-8 col-sm-5 col-md-3 col-lg-3"><cspl-ach control-id="txtCustomer" control-model="vm.customer" lookup-name="allNonPropCustomersForBank" filter-value="{{vm.bank.id}}~~{{2}}" display-column="customerCode,customerName" control-required="vm.selectedEntityOwnerType == \'MultiUserCustomer\' && vm.entityOwnerType == \'Bank\'" form="frmuseraccessview"></cspl-ach><span class="help-block" ng-show="vm.customer!=null && vm.customer!=undefined"><span ng-if="vm.customer.entityRestrictionStatus.displayName==\'Terminate\'">Terminated</span><span ng-if="vm.customer.entityRestrictionStatus.displayName==\'Suspend\'">Suspended</span><span ng-if="vm.customer.entityRestrictionStatus.displayName!=\'Terminate\' && vm.customer.entityRestrictionStatus.displayName!=\'Suspend\'">{{vm.customer.entityRestrictionStatus.displayName}}</span></span></div></div><div class="row margin-top-7"><div class="col-md-offset-3 col-xs-6 col-md-6"><label class="control-label" cspl-mandatory><span data-translate="gatewayApp.userAccessView.policyType"></span></label></div></div><div class="row"><div id="btnGroup"><div class="btnGroup col-md-offset-3 col-md-6"><div class="btn-group noPaddingMargin" style="width: auto; margin-bottom: 8px"><label class="btn btn-primary" ng-model="vm.policyType" uib-btn-radio="\'SecurityPolicy\'"><span data-translate="gatewayApp.userAccessView.securityPolicy"></span></label><label class="btn btn-primary" ng-model="vm.policyType" uib-btn-radio="\'ApprovalPolicy\'"><span data-translate="gatewayApp.userAccessView.approvalPolicy"></span></label></div></div></div></div><div class="row margin-top-7 col-md-offset-3" style="margin-top: 17px !important"><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title" style="width: 400px;padding-left:8px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseFilterBy = !vm.ExpandOrCollapseFilterBy" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseFilter"><img ng-src="{{vm.ExpandOrCollapseFilterBy == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="nav-label">Filter By</span></a></h4></div><div id="collapseFilter" class="panel-collapse collapse" style="background-color: black; height: 240px"><div class="accordion-content" style="margin-left:0px;margin-top:0px"><div class="row margin-top-7"><div class="col-xs-8 col-sm-5 col-md-3"><label class="control-label" for="txtuser"><span data-translate="gatewayApp.userAccessView.userLogin"></span></label></div></div><div class="row" ng-show="vm.selectedEntityOwnerType == \'MultiUserCustomer\'"><div class="col-xs-8 col-sm-5 col-md-4"><cspl-ach control-id="txtuser" control-model="vm.user" lookup-name="usersForGivenOrganisation" filter-value="{{vm.customer.id}}~~{{vm.selectedEntityOwnerType}}" display-column="login" control-required="false" form="frmuseraccessview"></div></div><div class="row" ng-show="vm.selectedEntityOwnerType == \'Bank\' && vm.branch == null"><div class="col-xs-8 col-sm-5 col-md-4"><cspl-ach control-id="txtuser" control-model="vm.user" lookup-name="usersForGivenOrganisation" filter-value="{{vm.bank.id}}~~{{vm.selectedEntityOwnerType}}" display-column="login" control-required="false" form="frmuseraccessview"></div></div><div class="row" ng-show="vm.selectedEntityOwnerType == \'Bank\' && vm.bank!=null && vm.branch!= null"><div class="col-xs-8 col-sm-5 col-md-4"><cspl-ach control-id="txtuser" control-model="vm.user" lookup-name="nonDelinkedUsersForGivenBranch" filter-value="{{vm.branch.id}}~~{{vm.selectedEntityOwnerType}}" display-column="login" control-required="false" form="frmuseraccessview"></div></div><div class="row margin-top-7"><div class="col-xs-8 col-sm-5 col-md-4"><label class="control-label" for="txtrole"><span data-translate="gatewayApp.userAccessView.role"></span></label></div></div><div class="row" ng-show="vm.selectedEntityOwnerType==\'Bank\'"><div class="col-xs-8 col-sm-5 col-md-4"><cspl-ach control-id="txtrole" control-model="vm.role" lookup-name="Role" filter-value="{{vm.bank.id}}~~{{vm.selectedEntityOwnerType}}" display-column="name" control-required="false" form="frmuseraccessview"></div></div><div class="row" ng-show="vm.selectedEntityOwnerType==\'MultiUserCustomer\'"><div class="col-xs-8 col-sm-5 col-md-4"><cspl-ach control-id="txtrole" control-model="vm.role" lookup-name="Role" filter-value="{{vm.customer.id}}~~{{vm.selectedEntityOwnerType}}" display-column="name" control-required="false" form="frmuseraccessview"></div></div><div class="row margin-top-7" ng-show="vm.policyType==\'SecurityPolicy\'"><div class="col-xs-8 col-sm-5 col-md-4"><label class="control-label" for="txttheme"><span data-translate="gatewayApp.userAccessView.theme"></span></label></div></div><div class="row" ng-show="vm.selectedEntityOwnerType==\'Bank\' && vm.policyType==\'SecurityPolicy\'"><div class="col-xs-8 col-sm-6 col-md-5"><cspl-ach control-id="txttheme" control-model="vm.theme" lookup-name="theme" filter-value="{{vm.bank.id}}~~{{vm.selectedEntityOwnerType}}" display-column="shortName" control-required="false" form="frmuseraccessview"></div></div><div class="row" ng-show="vm.selectedEntityOwnerType==\'MultiUserCustomer\' && vm.policyType==\'SecurityPolicy\'"><div class="col-xs-8 col-sm-6 col-md-5"><cspl-ach control-id="txttheme" control-model="vm.theme" lookup-name="theme" filter-value="{{vm.customer.id}}~~{{vm.selectedEntityOwnerType}}" display-column="shortName" control-required="false" form="frmuseraccessview"></div></div><div class="row margin-top-7" ng-show="vm.policyType==\'ApprovalPolicy\'"><div class="col-xs-8 col-sm-5 col-md-4"><label class="control-label" for="txtpolicy"><span data-translate="gatewayApp.userAccessView.policy"></span></label></div></div><div class="row" ng-show="vm.selectedEntityOwnerType==\'Bank\' && vm.policyType==\'ApprovalPolicy\'"><div class="col-xs-8 col-sm-6 col-md-5"><cspl-ach control-id="txtpolicy" control-model="vm.policy" lookup-name="policy" filter-value="{{vm.bank.id}}~~{{vm.selectedEntityOwnerType}}" display-column="shortName" control-required="false" form="frmuseraccessview"></div></div><div class="row" ng-show="vm.selectedEntityOwnerType==\'MultiUserCustomer\' && vm.policyType==\'ApprovalPolicy\'"><div class="col-xs-8 col-sm-6 col-md-5"><cspl-ach control-id="txtpolicy" control-model="vm.policy" lookup-name="policy" filter-value="{{vm.customer.id}}~~{{vm.selectedEntityOwnerType}}" display-column="shortName" control-required="false" form="frmuseraccessview"></div></div><div class="row margin-top-7"><div class="col-xs-8 col-sm-5 col-md-4"><label class="control-label" for="txtaction"><span data-translate="gatewayApp.userAccessView.action"></span></label></div></div><div class="row"><div class="col-xs-8 col-sm-6 col-md-5" ng-show="vm.policyType==\'SecurityPolicy\' && vm.selectedEntityOwnerType==\'Bank\' && vm.theme==null"><cspl-ach control-id="txtaction" control-model="vm.action" lookup-name="actionsForOrgAndTheme" filter-value="{{vm.bank.id}}~~{{0}}~~{{vm.selectedEntityOwnerType}}~~{{vm.policyType}}" display-column="shortName" control-required="false" form="frmuseraccessview"></div><div class="col-xs-8 col-sm-6 col-md-5" ng-show="vm.policyType==\'SecurityPolicy\' && vm.selectedEntityOwnerType==\'Bank\' && vm.theme!=null"><cspl-ach control-id="txtaction" control-model="vm.action" lookup-name="actionsForOrgAndTheme" filter-value="{{vm.bank.id}}~~{{vm.theme.id}}~~{{vm.selectedEntityOwnerType}}~~{{vm.policyType}}" display-column="shortName" control-required="false" form="frmuseraccessview"></div><div class="col-xs-8 col-sm-6 col-md-5" ng-show="vm.policyType==\'SecurityPolicy\' && vm.selectedEntityOwnerType==\'MultiUserCustomer\' && vm.theme==null"><cspl-ach control-id="txtaction" control-model="vm.action" lookup-name="actionsForOrgAndTheme" filter-value="{{vm.customer.id}}~~{{0}}~~{{vm.selectedEntityOwnerType}}~~{{vm.policyType}}" display-column="shortName" control-required="false" form="frmuseraccessview"></div><div class="col-xs-8 col-sm-6 col-md-5" ng-show="vm.policyType==\'SecurityPolicy\' && vm.selectedEntityOwnerType==\'MultiUserCustomer\' && vm.theme!=null"><cspl-ach control-id="txtaction" control-model="vm.action" lookup-name="actionsForOrgAndTheme" filter-value="{{vm.customer.id}}~~{{vm.theme.id}}~~{{vm.selectedEntityOwnerType}}~~{{vm.policyType}}" display-column="shortName" control-required="false" form="frmuseraccessview"></div><div class="col-xs-8 col-sm-6 col-md-5" ng-show="vm.policyType==\'ApprovalPolicy\' && vm.selectedEntityOwnerType==\'Bank\' && vm.policy==null"><cspl-ach control-id="txtaction" control-model="vm.action" lookup-name="actionsForOrgAndPolicy" filter-value="{{vm.bank.id}}~~{{0}}~~{{vm.selectedEntityOwnerType}}~~{{vm.policyType}}" display-column="shortName" control-required="false" form="frmuseraccessview"></div><div class="col-xs-8 col-sm-6 col-md-5" ng-show="vm.policyType==\'ApprovalPolicy\' && vm.selectedEntityOwnerType==\'Bank\' && vm.policy!=null"><cspl-ach control-id="txtaction" control-model="vm.action" lookup-name="actionsForOrgAndPolicy" filter-value="{{vm.bank.id}}~~{{vm.policy.id}}~~{{vm.selectedEntityOwnerType}}~~{{vm.policyType}}" display-column="shortName" control-required="false" form="frmuseraccessview"></div><div class="col-xs-8 col-sm-6 col-md-5" ng-show="vm.policyType==\'ApprovalPolicy\' && vm.selectedEntityOwnerType==\'MultiUserCustomer\' && vm.policy==null"><cspl-ach control-id="txtaction" control-model="vm.action" lookup-name="actionsForOrgAndPolicy" filter-value="{{vm.customer.id}}~~{{0}}~~{{vm.selectedEntityOwnerType}}~~{{vm.policyType}}" display-column="shortName" control-required="false" form="frmuseraccessview"></div><div class="col-xs-8 col-sm-6 col-md-5" ng-show="vm.policyType==\'ApprovalPolicy\' && vm.selectedEntityOwnerType==\'MultiUserCustomer\' && vm.policy!=null"><cspl-ach control-id="txtaction" control-model="vm.action" lookup-name="actionsForOrgAndPolicy" filter-value="{{vm.customer.id}}~~{{vm.policy.id}}~~{{vm.selectedEntityOwnerType}}~~{{vm.policyType}}" display-column="shortName" control-required="false" form="frmuseraccessview"></div><!-- <div class="col-md-1 col-sm-1"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-show="vm.policyType==\'ApprovalPolicy\'">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="btn btn-info active"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="frmuseraccessview.$invalid"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.getUserAccessView();vm.ExpandOrCollapseUserAccessView=false;"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tdata-toggle="collapse" data-target="#UserAccessView"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.userAccessView.go"></button>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</div> --></div><div class="row margin-top-7" ng-show="vm.policyType==\'SecurityPolicy\'"><div class="col-xs-8 col-sm-5 col-md-4"><label class="control-label" for="txtUserStatus"><span data-translate="gatewayApp.userAccessView.userStatus"></span></label></div></div><div class="row" ng-show="vm.policyType==\'SecurityPolicy\'"><div class="col-xs-8 col-sm-5 col-md-4"><select class="form-control select-style" ng-required="false" control-id="txtUserStatus" ng-model="vm.userStatus" ng-selected="vm.userStatus" ng-options="userStatus.displayName for userStatus in vm.userStatusList track by userStatus.id"><option value="">--All--</option></select></div><!-- <div class="col-md-1 col-sm-1">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="btn btn-info active"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="frmuseraccessview.$invalid"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.getUserAccessView();" data-toggle="collapse"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tdata-target="#UserAccessView"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.userAccessView.go"></button>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</div> --></div></div></div></div></div><div class="col-md-1 col-sm-1" ng-class="{\'col-md-offset-7\':vm.ExpandOrCollapseFilterBy == true && vm.selectedEntityOwnerType == \'Bank\',\'col-md-offset-6\':vm.ExpandOrCollapseFilterBy == false && vm.selectedEntityOwnerType == \'Bank\',\'col-xs-offset-7 no-padding-left\':  vm.selectedEntityOwnerType != \'Bank\'}" ng-show="vm.policyType==\'ApprovalPolicy\'"><button class="btn btn-info active" ng-disabled="frmuseraccessview.$invalid||vm.clicked" ng-click="vm.getUserAccessView();vm.ExpandOrCollapseUserAccessView=false;vm.clicked=true;" data-toggle="collapse" data-target="#UserAccessView" data-translate="gatewayApp.userAccessView.go"></button></div><div class="col-md-1 col-sm-1" ng-class="{\'col-xs-offset-7\':vm.ExpandOrCollapseFilterBy == true && vm.selectedEntityOwnerType == \'Bank\',\'col-xs-offset-6\':vm.ExpandOrCollapseFilterBy == false && vm.selectedEntityOwnerType == \'Bank\',\'col-xs-offset-7 no-padding-left\':  vm.selectedEntityOwnerType != \'Bank\'}" ng-show="vm.policyType==\'SecurityPolicy\'"><button class="btn btn-info active" ng-disabled="frmuseraccessview.$invalid||vm.clicked" ng-click="vm.getUserAccessView();vm.clicked=true;" data-toggle="collapse" data-target="#UserAccessView" data-translate="gatewayApp.userAccessView.go"></button></div></form></div></div></div><br><div ng-show="vm.policyType==\'SecurityPolicy\' && vm.securityPolicies.length > 0"><div class="row"><div class="dropdown col-md-3" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportSecurityPolicyData(\'csv\')">CSV</a></li><li><a ng-click="vm.exportSecurityPolicyData(\'xls\');">XLS</a></li></ul></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="securityPolicyView" class="dataTable table table-striped table-hover"><thead><tr><th ng-show="vm.selectedEntityOwnerType==\'Bank\'" data-translate="gatewayApp.userAccessView.branch"></th><th data-translate="gatewayApp.userAccessView.userLogin"></th><th data-translate="gatewayApp.userAccessView.role"></th><th data-translate="gatewayApp.userAccessView.roleAssignmentDate"></th><th data-translate="gatewayApp.userAccessView.theme"></th><th data-translate="gatewayApp.userAccessView.action"></th></tr></thead><tbody><tr ng-repeat="securityPolicy in filterData = (vm.securityPolicies | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td ng-show="vm.selectedEntityOwnerType==\'Bank\'">{{securityPolicy.branchName || \'-\'}}</td><td>{{securityPolicy.login || \'-\'}}</td><td>{{securityPolicy.role}}</td><td>{{(securityPolicy.roleAssignedDate | date:\'dd-MMM-yyyy HH:mm:ss\') || \'-\'}}</td><td>{{securityPolicy.theme}}</td><td>{{securityPolicy.action}}</td></tr></tbody></table></div><div ng-show="vm.policyType==\'SecurityPolicy\' && vm.securityPolicies.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div><div ng-show="vm.policyType==\'ApprovalPolicy\' && vm.approvalPolicies.length > 0"><div class="row"><div class="dropdown col-md-3" style="width: 10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border: none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportApprovalPolicyData(\'csv\')">CSV</a></li><li><a ng-click="vm.exportApprovalPolicyData(\'xls\');">XLS</a></li></ul></div><cspl-table-search control-model="filterText1" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="securityPolicyView" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.userAccessView.approvalPolicy"></th><th data-translate="gatewayApp.userAccessView.action"></th><th data-translate="gatewayApp.userAccessView.associatedRole"></th><th data-translate="gatewayApp.userAccessView.noOfApprovals" style="text-align:center"></th><th data-translate="gatewayApp.userAccessView.linkedUser"></th><th data-translate="gatewayApp.userAccessView.linkedBranch"></th></tr></thead><tbody class="approvalPolicyTable" ng-repeat="approvalPolicy in filterData1 = (vm.approvalPolicies | filter : filterText1)| limitTo:noOfRecordsPerPage1:noOfRecordsPerPage1*(page1-1)"><tr><td style="border-top: 1px solid #333333" rowspan="{{vm.getLength(approvalPolicy)}}">{{approvalPolicy.approvalPolicyName}}</td><td style="border-top: 1px solid #333333" rowspan="{{vm.getLength(approvalPolicy)}}">{{approvalPolicy.action}}</td><td style="border-top: 1px solid #333333" rowspan="{{approvalPolicy.approvalPolicyViewRoleDetailsDTOList[0].approvalPolicyViewDetailsDTOList.length}}">{{approvalPolicy.approvalPolicyViewRoleDetailsDTOList[0].associatedRole}}</td><td style="border-top: 1px solid #333333;text-align:center" rowspan="{{approvalPolicy.approvalPolicyViewRoleDetailsDTOList[0].approvalPolicyViewDetailsDTOList.length}}">{{approvalPolicy.approvalPolicyViewRoleDetailsDTOList[0].noOfApprovals}}</td><td style="border-top: 1px solid #333333">{{approvalPolicy.approvalPolicyViewRoleDetailsDTOList[0].approvalPolicyViewDetailsDTOList[0].linkedUser || \'-\'}}</td><td style="border-top: 1px solid #333333">{{approvalPolicy.approvalPolicyViewRoleDetailsDTOList[0].approvalPolicyViewDetailsDTOList[0].linkedBranch || \'-\'}}</td></tr><tr ng-repeat="approvalPolicyViewDetails in approvalPolicy.approvalPolicyViewRoleDetailsDTOList[0].approvalPolicyViewDetailsDTOList.slice(1)"><td>{{approvalPolicyViewDetails.linkedUser || \'-\'}}</td><td>{{approvalPolicyViewDetails.linkedBranch || \'-\'}}</td></tr><tr ng-repeat-start="approvalPolicyViewRoleDetails in approvalPolicy.approvalPolicyViewRoleDetailsDTOList.slice(1)"><td style="border-top: 1px solid #333333" rowspan="{{approvalPolicyViewRoleDetails.approvalPolicyViewDetailsDTOList.length}}">{{approvalPolicyViewRoleDetails.associatedRole}}</td><td style="border-top: 1px solid #333333; text-align:center" rowspan="{{approvalPolicyViewRoleDetails.approvalPolicyViewDetailsDTOList.length}}">{{approvalPolicyViewRoleDetails.noOfApprovals}}</td><td style="border-top: 1px solid #333333">{{approvalPolicyViewRoleDetails.approvalPolicyViewDetailsDTOList[0].linkedUser || \'-\'}}</td><td style="border-top: 1px solid #333333">{{approvalPolicyViewRoleDetails.approvalPolicyViewDetailsDTOList[0].linkedBranch}}</td></tr><tr ng-repeat="approvalPolicyViewDetails in approvalPolicyViewRoleDetails.approvalPolicyViewDetailsDTOList.slice(1)" ng-repeat-end><td>{{approvalPolicyViewDetails.linkedUser || \'-\'}}</td><td>{{approvalPolicyViewDetails.linkedBranch || \'-\'}}</td></tr></tbody></table></div><div ng-show="vm.policyType==\'ApprovalPolicy\' && vm.approvalPolicies.length > 0"><cspl-pagination record-count="filterData1.length" control-model="page1" items-per-page="noOfRecordsPerPage1"></cspl-pagination></div></div></div><div class="table-responsive" ng-show="vm.policyType==\'SecurityPolicy\' && vm.securityPolicies.length==0"><span>No record found</span></div><div class="table-responsive" ng-show="vm.policyType==\'ApprovalPolicy\' && vm.approvalPolicies.length==0"><span>No record found</span></div></section></div></div><script src="assets/js/tables.js"></script><style>tbody.approvalPolicyTable:hover tr{\r\nbackground-color: #F0CBA6 !important;\r\ncolor:#0D0D0D !important;\r\n}\r\n\r\n tbody.approvalPolicyTable:hover tr td{\r\n\r\n}</style>');
$templateCache.put('app/entities/user-profile-preferences/user-profile-pan-image-dialog.html','<style>.modal-header-red {background-color:#292929; padding:0px; height:50px; border: 1px solid #292929; border-top-left-radius:3px; border-top-right-radius:3px;}\r\n .modal-title {color:#FFF; vertical-align:middle; line-height:50px;}\r\n .modal-header button.close {color:#FFF; vertical-align:middle;}\r\n .modal-body {padding:20px;}</style><form name="panimage"><div><div class="modal-header modal-header-red"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()" style="color:black">&times;</button><h4 class="modal-title" style="text-align:left;padding-left:3%">Pan Image</h4></div><div class="modal-body"><img ng-src="data:image/JPEG;base64,{{vm.image}}" class="panImage"></div><nmb-alert-error></nmb-alert-error></div></form>');
$templateCache.put('app/entities/user-profile-preferences/user-profile.html','<style>.red{\r\n\tborder: 1px solid #FF3737 !important;\r\n}</style><div class="user-profile"><div class="modal-header"><h4 class="modal-title"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <span data-translate="global.menu.userProfile.myAccount"></span></h4></div><script src="app/app.module.js"></script><div class="column" style="background-color: #000000; text-align: center; width: 20%; overflow: hidden"><img ng-src="data:image/JPEG;base64,{{vm.user.image}}" ng-show="vm.user.image != null" class="img-circular" style="width: 100px; height: 100px"> <img ng-src="assets/images/ProfileLarge.png" ng-show="vm.user.image == null" class="img-circular" style="width: 100px; height: 100px"><br><br><div style="display:table"><button ng-click="vm.uploadImage()" class="btn btn-info active updateimagebutton" style=""><span class="imageupdatebuttoncontent">UPDATE IMAGE</span></button> <button ng-click="vm.removeImage()" ng-disabled="vm.user.image==null" class="btn btn-info active removeImageButton" style=""><span class="imageupdatebuttoncontent">REMOVE IMAGE</span></button></div><div class="row"><span class="file-help-text">Allowed file types: .png, .jpg, .jpeg</span></div><input type="file" style="display: none" id="txtpanCardUpload" form="userprofileForm" fileread="vm.panCardUpload" accept="image/*"><div class="row" style="margin-top: 8px"><label class="label-profile"><span>{{vm.displayFirstName + \' \' + vm.displayMiddleName + \' \' + vm.displayLastName }}</span></label></div><!-- <div class="row" ><span class="person-help-text">{{vm.user.personId}}</span> </div>  --><div class="row" style="margin-top: 4px"><label class="control-label"><span data-translate="gatewayApp.userProfile.lastLogin"></span></label></div><div class="row" style="margin-top: 2px"><label class="label-profile"><span>{{vm.userprofile.lastSuccessfulLogin|date:\'dd-MMM-yyyy HH:mm:ss\'}}</span></label></div><div class="row" style="margin-top: 4px"><label class="control-label"><span data-translate="gatewayApp.userProfile.lastUnsuccessfulLogin"></span></label></div><div class="row" style="margin-top: 2px"><label class="label-profile"><span>{{vm.userprofile.lastUnsuccessfulLogin|date:\'dd-MMM-yyyy HH:mm:ss\'}}</span></label></div></div><div class="column" style="background-color: #000000; width: 80%"><div class="modal-body"><nmb-alert></nmb-alert><nmb-alert-error></nmb-alert-error><div class="content" style="min-height: 72vh; max-height: 72vh"><div class="tab"><button id="btntab1" class="tablinks" ng-click="vm.checkForChange(\'myprofile\');" ng-style="{ background: showMyProfile  ? \'#333333\' : \'#000000\' }">My Profile</button> <button id="btntab2" class="tablinks" ng-show="vm.isShowPreferences" ng-click="vm.checkForChange(\'mypreference\'); " ng-style="{ background: showMyPreferences ? \'#333333\' : \'#000000\' }">My Preferences</button> <button id="btntab3" class="tablinks" ng-show="vm.hasCustomerInfoPermission" ng-style="{ background: showCustomerInfo  ? \'#333333\' : \'#000000\' }" ng-click="vm.checkForChange(\'customerinfo\')">Customer Profile</button></div><br><br><div id="MyProfile" ng-show="showMyProfile"><form name="userprofileForm" role="form" novalidate ng-show="showMyProfile"><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseMyProfileDetails = !vm.ExpandOrCollapseMyProfileDetails" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseThree"><img ng-src="{{vm.ExpandOrCollapseMyProfileDetails == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="label-profile">Personal Info</span></a></h4></div><div id="collapseThree" class="panel-collapse collapse" style="background-color: black"><div class="accordion-content1"><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.personalId"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.user.personId" control-disabled="true" control-id="txtpersonalId" control-type="Alphanumeric" form="userprofileForm"></div></div><div class="row" style="margin-top: 8px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.firstName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.user.firstName" control-id="txtUserProfilefirstName" control-type="AlphaWithSpace" control-maxlength="100" form="userprofileForm" control-disabled="true" required></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label"><span data-translate="userManagement.middleName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.user.middleName" control-maxlength="100" control-type="AlphaWithSpace" control-id="txtUserProfilemiddleName" form="userprofileForm"></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.lastName"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.user.lastName" control-id="txtUserProfilelastName" control-maxlength="100" control-type="AlphaWithSpace" control-disabled="vm.disablePID" form="userprofileForm" required></div></div><!-- <div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" ><span\r\n\t\t\t\t\t\t\t\t\t\t\tdata-translate="userManagement.aadharNumber"></span></label>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-text control-model="vm.user.aadharNumber" control-type="Number"\r\n\t\t\t\t\t\t\t\t\t\t\t\tcontrol-id="txtUserProfileaadharNumber" control-minlength="12"\r\n\t\t\t\t\t\t\t\t\t\t\t\tcontrol-maxlength="12"\r\n\t\t\t\t\t\t\t\t\t\t\t\thelp-text="{{\'userManagement.helpText.aadharNumber\' | translate}}"\r\n\t\t\t\t\t\t\t\t\t\t\t\tcontrol-disabled="vm.disablePID" form="userprofileForm" />\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div> --><!-- <div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\t\t\t\t\tdata-translate="userManagement.gender"></span></label>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div id="btnGroup" class="col-md-6 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="btn-group">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="btn btn-primary" ng-model="vm.user.gender"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="vm.disablePID" uib-btn-radio="\'M\'">M</label> <label\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tclass="btn btn-primary" ng-model="vm.user.gender" ng-disabled="vm.disablePID"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tuib-btn-radio="\'F\'">F&nbsp;</label>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<label\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tclass="btn btn-primary" ng-model="vm.user.gender" ng-disabled="vm.disablePID"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tuib-btn-radio="\'O\'">O&nbsp;</label>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div> --><div class="row" style="margin-top: 8px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.dob"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-dtp control-model="vm.user.dob" control-id="dtpuserdob" form="userprofileForm" required></cspl-dtp></div></div><!-- <div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\t\t\t\t\tdata-translate="userManagement.address1"></span></label>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-text control-model="vm.user.address1" control-id="txtUserProfileaddress1"\r\n\t\t\t\t\t\t\t\t\t\t\t\tcontrol-maxlength="255" control-disabled="vm.disablePID"\r\n\t\t\t\t\t\t\t\t\t\t\t\tform="userprofileForm" required />\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label"><span\r\n\t\t\t\t\t\t\t\t\t\t\tdata-translate="userManagement.address2"></span></label>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-text control-model="vm.user.address2" control-id="txtUserProfileaddress2"\r\n\t\t\t\t\t\t\t\t\t\t\t\tcontrol-maxlength="255" control-disabled="vm.disablePID"\r\n\t\t\t\t\t\t\t\t\t\t\t\tform="userprofileForm" />\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\t\t\t\t\tdata-translate="userManagement.city"></span></label>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6 col-md-offset-1 ">\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-text control-model="vm.user.city" control-id="txtUserProfilecity"\r\n\t\t\t\t\t\t\t\t\t\t\t\tcontrol-maxlength="255" control-disabled="vm.disablePID"\r\n\t\t\t\t\t\t\t\t\t\t\t\tform="userprofileForm" required />\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\t\t\t\t\tdata-translate="userManagement.country"></span></label>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-4 col-md-offset-1 ">\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-ach control-model="vm.user.country" control-id="txtUserProfileCountry"\r\n\t\t\t\t\t\t\t\t\t\t\t\tlookup-name="country" display-column="shortName"\r\n\t\t\t\t\t\t\t\t\t\t\t\tcontrol-disabled="vm.disablePID" form="userprofileForm" required></cspl-ach>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\t\t\t\t\tdata-translate="userManagement.state"></span></label>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6 col-md-offset-1 ">\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-ach control-model="vm.user.state" control-id="txtUserProfilestate"\r\n\t\t\t\t\t\t\t\t\t\t\t\tlookup-name="state" display-column="shortName"\r\n\t\t\t\t\t\t\t\t\t\t\t\tfilter-value="{{vm.user.country.id}}" control-disabled="vm.disablePID"\r\n\t\t\t\t\t\t\t\t\t\t\t\tform="userprofileForm" required></cspl-ach>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row" style="margin-top: 8px">\r\n\t\t\t\t\t\t\t\t\t\t<label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span\r\n\t\t\t\t\t\t\t\t\t\t\tdata-translate="userManagement.pincode"></span></label>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6 col-md-offset-1 ">\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-text control-model="vm.user.pincode" control-id="txtUserProfilepincode"\r\n\t\t\t\t\t\t\t\t\t\t\t\tcontrol-type="Alphanumeric"  control-maxlength="7"\r\n\t\t\t\t\t\t\t\t\t\t\t\tform="userprofileForm" control-disabled="vm.disablePID" required />\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div> --></div></div></div><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseLoginInfo = !vm.ExpandOrCollapseLoginInfo" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseOne"><img ng-src="{{vm.ExpandOrCollapseLoginInfo == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp; <span class="label-profile">Login Info</span></a></h4></div><div id="collapseOne" class="panel-collapse collapse" style="background-color: black"><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.login"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.user.login" control-disabled="true" control-id="txtLogin" control-type="Small" control-maxlength="100" form="userprofileForm" required></div></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.email"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.user.email" control-type="Email" control-id="txtemail" control-maxlength=" 100" control-disabled="true" form="userprofileForm" required></div><!-- <a style="text-decoration: none;" title="Change Email"\r\n\t\t\t\t\t\t\t\t\t\t\tui-sref="change-email({userId: vm.userId,email: vm.user.email, mode: \'userProfile\', customerId: 0 })"> --> <img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px; border:0px" title="Change Email" ng-click="vm.openChangeEmail()"><!-- </a> --></div><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="userManagement.mobile"></span></label></div><div class="row"><div class="col-lg-1 col-md-offset-1"><cspl-numeric control-model="vm.user.mobileCountryCode" control-disabled="true" control-max="999" control-id="txtMobileCountryCode" no-of-decimals="0" form="userprofileForm" required></div><div class="col-md-3"><cspl-text control-model="vm.user.mobile" control-disabled="true" control-type="Number" control-id="txtMobile" control-maxlength="15" form="userprofileForm" required></div><!-- <a style="text-decoration: none;" title="Change Mobile"\r\n\t\t\t\t\t\t\t\t\t\t\tui-sref="change-mobile({userId: vm.userId,mobile: vm.user.mobile,mode: \'userProfile\', customerId: 0 })"> --> <img src="assets/images/EditProfile.png" alt="Avatar" title="Change Mobile" style="width: 25px; height: 25px" ng-click="vm.openChangeMobile()"></div></div></div><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseChangePassword= !vm.ExpandOrCollapseChangePassword" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseTwo"><img ng-src="{{vm.ExpandOrCollapseChangePassword== false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}" class="icon"> &nbsp; <span class="label-profile">Change Password</span></a></h4></div><div id="collapseTwo" class="panel-collapse collapse" style="background-color: black; height: 240px"><div class="row"><div class="row"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.loginPassword"></span></label></div><div class="row"><div class="form-group password"><label class="sr-only" for="login-password">Change Password</label><div class="col-md-6 col-md-offset-1"><input id="login-password" name="password" type="password" ng-disabled="true" ng-model="vm.password" class="form-control login-password"></div><a style="text-decoration: none" title="Change Password" ui-sref="change-password-user-profile({login: vm.user.login})"><img src="assets/images/EditProfile.png" alt="Avatar" style="width: 25px; height: 25px">&nbsp;<span aria-hidden="true" class="icon"></span></a></div></div></div></div></div></form></div><div id="MyPreferences" ng-show="showMyPreferences"><form name="myPreferencesForm" role="form" novalidate ng-show="showMyPreferences"><br><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseMyPreferences = !vm.ExpandOrCollapseMyPreferences" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapsefour"><img ng-src="{{vm.ExpandOrCollapseMyPreferences == false && \'assets/images/Accordion_collapse.png\' ||\'assets/images/Accordion_expand.png\'}}"> &nbsp; <span class="nav-label">My Preferences</span></a></h4></div><div id="collapsefour" class="panel-collapse collapse" style="background-color: black"><div class="accordion-content1"><div class="row" ng-if="vm.isShowTradingBank"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.tradingBank"></span></label><div class="col-md-6 col-md-offset-1"><cspl-ach control-model="vm.tradingBank" control-id="txtbank" control-disabled="vm.isBankDisabled" form="myPreferencesForm" lookup-name="tradingBank" display-column="shortName" filter-value="{{vm.globalValues.getOrganisation().id}}" placeholder="" control-required="vm.isShowTradingBank"></div></div><div class="row" style="margin-top:7px" ng-if="vm.isShowTradingBranch"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.tradingBranch"></span></label><div class="col-md-6 col-md-offset-1"><cspl-ach control-model="vm.tradingBranch" control-id="txtbranch" control-disabled="true" lookup-name="activeBranchesForBank" form="myPreferencesForm" display-column="branchName" control-disabled="vm.isTradingBranchDisabled" placeholder="" control-required="vm.isShowTradingBranch"></div></div><div class="row" style="margin-top:7px" ng-if="vm.isShowBank"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.tradingBank"></span></label><div class="col-md-6 col-md-offset-1"><cspl-ach control-model="vm.tradingBank" control-id="txtbank1" control-disabled="vm.isBankDisabled" form="myPreferencesForm" lookup-name="bank" display-column="bankName" placeholder="" control-required="vm.isShowBank"></div></div><div class="row" style="margin-top:7px" ng-if="vm.isShowBranch"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.tradingBranch"></span></label><div class="col-md-6 col-md-offset-1"><cspl-ach control-model="vm.tradingBranch" control-disabled="vm.isTradingBranchDisabled" control-id="txtbranch1" lookup-name="activeBranch" display-column="shortName" filter-value="{{vm.tradingBank.id}}" form="myPreferencesForm" placeholder="" control-required="vm.isShowBranch"></div></div><div class="row" style="margin-top:7px" ng-if="vm.isShowCustomer"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.tradingCustomer"></span></label><div class="col-md-6 col-md-offset-1"><cspl-ach control-model="vm.tradingCustomer" control-id="txtcustomer" lookup-name="customer" filter-value="{{vm.tradingBank.id}}~~{{vm.tradingBranch.id}}~~{{0}}" display-column="customerCode,customerFirstName" form="myPreferencesForm" placeholder="" control-required="vm.isShowCustomer"></cspl-ach></div></div><div class="row" style="margin-top:7px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.instrumentCode"></span></label></div><div class="row"><div id="btnGroup" class="col-md-7 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.userprofile.userInstrumentCode" uib-btn-radio="\'SPOT\'">SPOT</label><label class="btn btn-primary" ng-model="vm.userprofile.userInstrumentCode" uib-btn-radio="\'TOM\'">TOM&nbsp;</label><label class="btn btn-primary" ng-model="vm.userprofile.userInstrumentCode" uib-btn-radio="\'CASH\'">CASH&nbsp;</label><label class="btn btn-primary" ng-model="vm.userprofile.userInstrumentCode" uib-btn-radio="\'Forward\'">FORWARD&nbsp;</label></div></div></div><div class="row" style="margin-top:15px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.priceCondition"></span></label></div><div class="row"><div id="btnGroup" class="col-md-7 col-md-offset-1"><div class="btn-group"><!-- <label class="btn btn-primary" ng-model="vm.userprofile.userPriceCondition"\r\n\t\t\t\t\t\t\t\t\tuib-btn-radio="\'MRKT\'">Market</label> --><label class="btn btn-primary" ng-model="vm.userprofile.userPriceCondition" uib-btn-radio="\'LIMT\'">Limit&nbsp;</label><label class="btn btn-primary" ng-model="vm.userprofile.userPriceCondition" ng-disabled="vm.isAllowMarketOrder!=\'Yes\'" uib-btn-radio="\'MRKT\'">Market&nbsp;</label><label class="btn btn-primary" ng-model="vm.userprofile.userPriceCondition" ng-disabled="vm.isAllowStopLoss!=\'Yes\'" uib-btn-radio="\'STLS\'">Stop Loss&nbsp;</label><label class="btn btn-primary" ng-model="vm.userprofile.userPriceCondition" ng-disabled="vm.isAllowTakeProfit!=\'Yes\'" uib-btn-radio="\'TKPR\'">Take Profit&nbsp;</label></div></div></div><div class="row" style="margin-top:15px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.timeCondition"></span></label></div><div class="row"><div id="btnGroup" class="col-md-7 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.userprofile.userTimeCondition" uib-btn-radio="\'DAYY\'">Day</label><label class="btn btn-primary" ng-model="vm.userprofile.userTimeCondition" uib-btn-radio="\'IOCC\'">IOC&nbsp;</label><label class="btn btn-primary" ng-model="vm.userprofile.userTimeCondition" uib-btn-radio="\'GTTM\'">GTT&nbsp;</label></div></div></div><div class="row" style="margin-top:15px"><label class="col-md-4 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.orderValue"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.userprofile.userOrderValue" control-min="0" control-max="999999999.99" control-id="txtorderValue" no-of-decimals="{{vm.noOfDecimalsForAmount}}" form="myPreferencesForm" control-value-change="vm.validateOrderValue(vm.userprofile.userOrderValue)" currency-code="" required></cspl-numeric><span class="help-block-error" ng-show="vm.errorText1!=\'\'">{{vm.errorText1}}</span></div><span class="label-profile" style="display: block;padding-top:7px"></span></div><div class="row" style="margin-top:7px" ng-if="false"><label class="col-md-6 col-md-offset-1 control-label" ng-show="false" cspl-mandatory><span data-translate="gatewayApp.userProfile.disclosedValue"></span></label></div><div class="row" ng-if="false"><div class="col-md-4 col-md-offset-1"><cspl-numeric control-model="vm.userprofile.userDisclosedValue" ng-show="false" control-id="txtdisclosedValue" no-of-decimals="{{}}" form="myPreferencesForm" control-min="0" currency-code="" required></div><span class="label-profile" style="display: block;padding-top:7px" ng-show="false">USD</span></div><div class="row" style="margin-top:7px" ng-if="false"><label class="col-md-6 col-md-offset-1 control-label" ng-show="false" cspl-mandatory><span data-translate="gatewayApp.userProfile.minimumFillValue"></span></label></div><div class="row" ng-if="false"><div class="col-md-4 col-md-offset-1"><cspl-numeric control-model="vm.userprofile.userMinimumFillValue" ng-show="false" control-min="0" control-id="txtminimumFillValue" no-of-decimals="{{}}" form="myPreferencesForm" currency-code="" required></div><span class="label-profile" ng-show="false" style="display: block;padding-top:7px">USD</span></div><div class="row" style="margin-top:7px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.bidText"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.userprofile.userBidSpread" control-id="txtbidText" control-max="99.9999" control-min="-99.9999" no-of-decimals="{{4}}" form="myPreferencesForm" currency-code="" required></div></div><div class="row" style="margin-top:7px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.defaultExposureType"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-1"><select class="form-control select-style" control-id="selExposureType" ng-model="vm.exposureType" name="exposureType" ng-options="exposureType.name for exposureType in vm.exposureTypes track by exposureType.id" ng-class="{red: myPreferencesForm.exposureType.$invalid}" form="myPreferencesForm" required></select><span class="help-block-error" ng-show="myPreferencesForm.exposureType.$invalid">This field cannot be left blank</span></div></div><div class="row" style="margin-top:15px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.defaultExposureSubType"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-1"><select class="form-control select-style" control-id="selExposureSubType" ng-model="vm.exposureSubType" name="exposureSubType" ng-options="exposureSubType.name for exposureSubType in vm.exposureSubTypes track by exposureSubType.id" ng-class="{red: myPreferencesForm.exposureSubType.$invalid}" form="myPreferencesForm" required></select><span class="help-block-error" ng-show="myPreferencesForm.exposureSubType.$invalid">This field cannot be left blank</span></div></div><div class="row" style="margin-top:7px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.defaultForeignCurrencyPair"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-1"><cspl-ach control-model="vm.defaultForeignCurrencyPair" control-id="txtCurrecyPair" lookup-name="orderCurrencyPair" filter-value="{{vm.tradingBank && vm.tradingBank.id || 0}}" display-column="code" form="myPreferencesForm" required></cspl-ach><span ng-show="vm.tradingBank == null || vm.tradingBank ==\'\'"><span class="help-block-error">Trading Bank cannot be empty. Kindly set it first.</span></span></div></div><div class="row" style="margin-top:15px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.InteractiveMsgPopup"></span></label></div><div class="row"><div id="btnGroup" class="col-md-7 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.userprofile.showInteractiveMsgPopup" uib-btn-radio="\'yes\'">Yes</label><label class="btn btn-primary" ng-model="vm.userprofile.showInteractiveMsgPopup" uib-btn-radio="\'no\'">No&nbsp;</label></div></div></div><div class="row" style="margin-top:15px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.preOrderConfirmation"></span></label></div><div class="row"><div id="btnGroup" class="col-md-3 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.userprofile.showPreOrderConfirmation" uib-btn-radio="\'yes\'">Yes</label><label class="btn btn-primary" ng-model="vm.userprofile.showPreOrderConfirmation" uib-btn-radio="\'no\'">No&nbsp;</label></div></div></div><div class="row" style="margin-top:15px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.showOrderConfirmationForSplitOrder"></span></label></div><div class="row"><div id="btnGroup" class="col-md-3 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.userprofile.showOrderConfirmationForSplitOrder" uib-btn-radio="\'yes\'">Yes</label><label class="btn btn-primary" ng-model="vm.userprofile.showOrderConfirmationForSplitOrder" uib-btn-radio="\'no\'">No&nbsp;</label></div></div></div><div class="row" style="margin-top:15px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.showOrderConfirmationForBulkOrder"></span></label></div><div class="row"><div id="btnGroup" class="col-md-3 col-md-offset-1"><div class="btn-group"><label class="btn btn-primary" ng-model="vm.userprofile.showOrderConfirmationForBulkOrder" uib-btn-radio="\'yes\'">Yes</label><label class="btn btn-primary" ng-model="vm.userprofile.showOrderConfirmationForBulkOrder" uib-btn-radio="\'no\'">No&nbsp;</label></div></div></div><br></div></div><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseCurrencyPreferences = !vm.ExpandOrCollapseCurrencyPreferences" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#collapseFive"><img ng-src="{{vm.ExpandOrCollapseCurrencyPreferences == false && \'assets/images/Accordion_collapse.png\' ||\'assets/images/Accordion_expand.png\'}}"> &nbsp; <span class="nav-label">Currency Wise User Preference</span></a></h4></div><div id="collapseFive" class="panel-collapse collapse" style="background-color: black"><div class="accordion-content1"><!-- <div class="row">\r\n\t\t\t\t\t\t\t<label class=" control-label   col-xs-1 col-md-1" style="margin-top: 3px;"><span\r\n\t\t\t\t\t\t\t\t\tdata-translate="gatewayApp.applicationWideSettings.currencyPair"></span></label>\r\n\r\n\t\t\t\t\t\t\t<div class="col-md-5 col-sm-6 col-xs-10 col-lg-3">\r\n\t\t\t\t\t\t\t\t<cspl-ach control-model="vm.currencyPair" control-id="txtCurrencyPair"\r\n\t\t\t\t\t\t\t\t\tlookup-name="currencyPair" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}"\r\n\t\t\t\t\t\t\t\t\tcontrol-place-holder="Enter Currency Pair" display-column="code" placeholder=""\r\n\t\t\t\t\t\t\t\t\tform="configurationSettingsForm" />\r\n\t\t\t\t\t\t\t</div>--><div class="row" style="margin-top:7px"><label class="col-md-8 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.currencyPair"></span></label></div><div class="row"><div class="col-md-5 col-md-offset-1"><cspl-ach control-model="vm.currencyPair" lookup-name="currencyPair" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}" control-id="txtCurrencyPair" display-column="code" control-place-holder="Enter Currency Pair" form="myPreferencesForm" currency-code=""></cspl-ach></div><div class="col-md-1 col-sm-1"><button class="btn btn-info active" ng-disabled=" vm.currencyPair==null ||vm.clicked" ng-click="vm.getCurrencyWiseUserPreference(vm.currencyPair);vm.clicked=true;" data-toggle="collapse" data-target="#MarketMovement" data-translate="gatewayApp.userProfile.go"></button></div></div><div ng-if="vm.currencyWiseUserPreferenceSettings !=null && vm.currencyWiseUserPreferenceSettings !=undefined "><div class="row" style="margin-top:7px"><label class="col-md-8 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.allowedOrderPriceDeviationFromMarketPriceInPercentage"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.currencyWiseUserPreferenceSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage" control-min="0" control-max="100" control-id="txtpriceDeviationInPercent" no-of-decimals="{{vm.noOfDecimalsForPercent}}" form="myPreferencesForm" control-value-change="vm.validateAllowedOrderPriceDeviationFromMarketPriceInPercentage(vm.currencyWiseUserPreferenceSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage)" currency-code="" required></cspl-numeric><span class="help-block-error" ng-show="vm.errorText2!=\'\'">{{vm.errorText2}}</span></div><span class="label-profile" style="display: block;padding-top:7px">%</span></div><div class="row" style="margin-top:7px"><label class="col-md-8 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.allowedOrderPriceDeviationFromMarketPriceInPaise"></span></label></div><div class="row"><div class="col-md-2 col-md-offset-1"><cspl-numeric control-model="vm.currencyWiseUserPreferenceSettings.allowedOrderPriceDeviationFromMarketPriceInPaise" control-min="0" control-max="999" control-id="txtpriceDeviationInPaise" no-of-decimals="{{vm.noOfDecimalsForPaise}}" form="myPreferencesForm" control-value-change="vm.validateAllowedOrderPriceDeviationFromMarketPriceInPaise(vm.currencyWiseUserPreferenceSettings.allowedOrderPriceDeviationFromMarketPriceInPaise)" currency-code="" required></cspl-numeric><span class="help-block-error" ng-show="vm.errorText5!=\'\'">{{vm.errorText5}}</span></div><span class="label-profile" style="display: block;padding-top:7px">Paise</span></div><div class="row" style="margin-top:7px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.maximumOrderValueHardCheck"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck" control-min="0" control-max="999999999.99" control-id="txtmaximumOrderValueHardCheck" no-of-decimals="{{vm.noOfDecimalsForAmount}}" form="myPreferencesForm" control-value-change="vm.validateMaximumOrderValueHardCheck(vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck)" currency-code="" required></cspl-numeric><span class="help-block-error" ng-show="vm.errorText3!=\'\'">{{vm.errorText3}}</span></div><span class="label-profile" style="display: block;padding-top:7px">{{vm.currencyWiseUserPreferenceSettings.currencyPair.code}}</span></div><div class="row" style="margin-top:7px"><label class="col-md-6 col-md-offset-1 control-label" cspl-mandatory><span data-translate="gatewayApp.userProfile.maximumOrderValueSoftCheck"></span></label></div><div class="row"><div class="col-md-3 col-md-offset-1"><cspl-numeric control-model="vm.currencyWiseUserPreferenceSettings.maximumOrderValueSoftCheck" control-min="0" control-max="999999999.99" control-id="txtmaximumOrderValueSoftCheck" no-of-decimals="{{vm.noOfDecimalsForAmount}}" form="myPreferencesForm" control-value-change="vm.validateMaximumOrderValueSoftCheck(vm.currencyWiseUserPreferenceSettings.maximumOrderValueSoftCheck)" currency-code="" required></cspl-numeric><span class="help-block-error" ng-show="vm.errorText4!=\'\'">{{vm.errorText4}}</span></div><span class="label-profile" style="display: block;padding-top:7px">{{vm.currencyWiseUserPreferenceSettings.currencyPair.code}}</span></div></div></div></div></form></div><div id="CustomerProfile" ng-show="showCustomerInfo"><form name="customerInfo" role="form" novalidate><div id="accordion"><div style="background-color: black; color: white"><h4 class="panel-title col-md-offset-1" style="width: 400px; margin-top: 20px; margin-bottom: 10px"><span class="label-profile" data-translate="gatewayApp.customerInfo.customerInfo"></span></h4></div><div id="collapseThree" class="panel-collapse collapse in" style="background-color: black"><div class="accordion-content1"><div class="row" style="margin-top: 8px"><label class="col-md-6 control-label col-md-offset-1"><span data-translate="gatewayApp.customerRegistration.customerType"></span></label><label class="col-md-2 control-label"><span data-translate="gatewayApp.customerRegistration.customerCode"></span></label></div><div class="row" style="margin-bottom:8px"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.customerInfo.customer.customerType.name" control-id="txtCustomerType" form="customerInfo" control-disabled="true"></div><div class="col-md-3"><cspl-text control-model="vm.customerInfo.customer.customerCode" control-id="txtCustomerCode" form="customerInfo" control-disabled="true"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-1" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex].display" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.companyName"></span></label><label class="col-md-6 control-label col-md-offset-1" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex].display" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.firstName"></span></label></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[entityNameIndex].display"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.customerInfo.customer.customerFirstName" control-id="txtfirstName" control-type="StringWithoutCommaWithScriptValidation" control-maxlength="100" form="customerInfo" control-required="vm.inputDetailsForSelectedCustType[entityNameIndex].display && vm.inputDetailsForSelectedCustType[entityNameIndex].isMandatory"></div></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[firstNameIndex].display"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.customerInfo.customer.customerFirstName" control-id="txtfirstName" form="customerInfo" control-maxlength="100" control-type="AlphaWithSpace" control-required="vm.inputDetailsForSelectedCustType[firstNameIndex].display && vm.inputDetailsForSelectedCustType[firstNameIndex].isMandatory"></div></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex].display"><label class="col-md-6 control-label col-md-offset-1"><span data-translate="gatewayApp.customerRegistration.middleName"></span></label></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[middleNameIndex].display"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.customerInfo.customer.customerMiddleName" control-id="txtmiddleName" control-maxlength="100" control-type="AlphaWithSpace" form="customerInfo"></div></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex].display"><label class="col-md-6 control-label col-md-offset-1" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.lastName"></span></label></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex].display"><div class="col-md-6 col-md-offset-1" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex].display"><cspl-text control-model="vm.customerInfo.customer.customerLastName" control-id="txtLastName" form="customerInfo" control-maxlength="100" control-type="AlphaWithSpace" control-required="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[lastNameIndex].display"></div></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex].display"><label class="col-md-6 control-label col-md-offset-1"><span data-translate="gatewayApp.customerRegistration.panNo"></span></label></div><div class="row" style="margin-bottom:10px" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panNoIndex].display"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.customerInfo.customer.panNumber" control-id="txtPanNo" control-minlength="10" control-maxlength="10" form="customerInfo" control-disabled="true"></div><div class="col-md-2" style="margin-top:5px"><a ng-click="vm.viewPanImage()"><img ng-src="assets/images/panImage.png"></a></div></div><div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panImageIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[panImageIndex].display"><div class="row"><label class="col-md-7 col-md-offset-1 control-label"><span data-translate="gatewayApp.customerRegistration.panImageUpload"></span></label></div><div class="row" style="margin-bottom:10px"><div class="col-md-7 col-md-offset-1"><div class="input-group"><input type="text" class="form-control fileOpen" ng-model="vm.inputPanImage" ng-blur="vm.checkPanImage=true;" readonly="readonly"><label for="panImageFile" class="btn btn-primary fileUploadDark"><img src="assets/images/Open Path-26.png" style="pointer-events:none"></label><input type="file" id="panImageFile" name="panImageUpload" fileread="vm.image" accept="image/x-png,image/jpg,image/jpeg,application/pdf" form="customerInfo" ng-hide="true"> <span class="help-block-error" ng-show="vm.invalidPanImageSize"><!-- PAN image size should not be greater than 100 kb. -->{{ vm.invalidPanImageSixeText}}</span> <span class="help-block-error" ng-show="vm.invalidPanImage">{{vm.invalidPanImageText}}</span> <span class="help-block-error" ng-show="vm.invalidPanFileName">{{vm.invalidPanImageFileNameText}}</span></div></div></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex].display"><label class="col-md-6 control-label col-md-offset-1"><span data-translate="gatewayApp.customerRegistration.legalEntityIdentifier"></span></label><label class="col-md-3 control-label"><span data-translate="gatewayApp.customerRegistration.validUpto"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[legalEntityIdentifierIndex].display"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.customerInfo.customer.legalEntityIdentifier" control-id="txtlegalEntityIdentifier" control-disabled="true" form="customerInfo" control-type="Alphanumeric" control-minlength="20" control-maxlength="20"></div><div class="col-md-4" style="width: 28%"><cspl-dtp ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[leiExpiryDateIndex].display" control-id="txtlegalEntityExpiry" control-disabled="true" control-model="vm.customerInfo.leiExpiryDate" form="customerInfo"></cspl-dtp></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[cinIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[cinIndex].display"><label class="col-md-6 control-label col-md-offset-1"><span data-translate="gatewayApp.customerRegistration.corporateIdentificationNumber"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[cinIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[cinIndex].display"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.customerInfo.customer.corporateIdentificationNumber" control-id="txtcorporateIdentificationNumber" control-disabled="true" form="customerInfo" control-type="Alphanumeric" control-minlength="21" control-maxlength="21"></div></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex].display"><label class="col-md-6 control-label col-md-offset-1"><span data-translate="gatewayApp.customerRegistration.gstinAndStateCode"></span></label></div><div class="row" ng-show="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[gstinIndex].display"><div class="col-md-3 col-md-offset-1"><cspl-text control-model="vm.customerInfo.customer.gstin" control-id="txtgstin" form="customerInfo" control-minlength="15" control-maxlength="15" control-type="Alphanumeric"></div><div class="col-lg-1"><cspl-text control-model="vm.customerInfo.customer.stateCode" control-id="txtstateCode" form="customerInfo" control-minlength="2" control-maxlength="2"></div></div><!-- <div class="row" > \r\n\t\t\t\t\t\t\t\t<label ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex].display && vm.customerInfo.customer.customerType.customerUserType.shortName!=\'MultiUserCustomer\'" class="col-md-6 control-label col-md-offset-1"  ><span data-translate="gatewayApp.customerRegistration.dob" ></span></label>\r\n\t\t\t\t\t\t\t\t<label ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex].display && vm.customerInfo.customer.customerType.customerUserType.shortName==\'MultiUserCustomer\'" class="col-md-6 control-label col-md-offset-1" ><span data-translate="gatewayApp.customerInfo.dateOFIncorporation" ></span></label>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t<div class="row" ng-if="vm.inputDetailsForSelectedCustType!=null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex]!= null \r\n\t\t\t\t\t\t\t&& vm.inputDetailsForSelectedCustType[dobDoiIndex].display">\r\n\t\t\t\t\t\t\t\t<div class="col-md-3 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t<cspl-dtp  control-model="vm.customerInfo.dobOrDoi" control-id="dtpDOBorDOI" form="customerInfo" control-disabled="true" ></cspl-dtp>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div> --><div class="" style="display: block; align: center; margin-top: 20px; margin-bottom: 10px"><div class="row"><label class="label-profile panel-title col-md-offset-1"><span data-translate="gatewayApp.customerInfo.contactInfo" style="background-color: black"></span></label></div><div class="row"><label class="col-md-6 control-label col-md-offset-1" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.address1"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.customerInfo.customer.address1" control-id="txtcustomeraddress1" control-maxlength="255" form="customerInfo" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-1"><span data-translate="gatewayApp.customerRegistration.address2"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.customerInfo.customer.address2" control-id="txtcustomeraddress2" control-maxlength="255" form="customerInfo"></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-1" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.city"></span></label></div><div class="row"><div class="col-md-6 col-md-offset-1"><cspl-text control-model="vm.customerInfo.customer.city" control-id="txtcustomercity" control-maxlength="255" form="customerInfo" required></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-1"><span data-translate="gatewayApp.customerRegistration.country"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-1"><cspl-ach control-model="vm.customerInfo.customer.country" control-id="txtcustomerCountry" lookup-name="country" control-disabled="true" display-column="shortName" form="customerInfo"></cspl-ach></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-1" cspl-mandatory><span data-translate="gatewayApp.customerRegistration.state"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-1"><cspl-ach control-model="vm.customerInfo.customer.state" control-id="txtcuState" lookup-name="state" display-column="shortName" form="customerInfo" required filter-value="{{vm.customerInfo.customer.country.id}}"></cspl-ach></div></div><div class="row"><label class="col-md-6 control-label col-md-offset-1" cspl-mandatory><span data-translate="gatewayApp.customerInfo.postalCode"></span></label></div><div class="row"><div class="col-md-4 col-md-offset-1"><cspl-text control-model="vm.customerInfo.customer.pincode" control-id="txtcustomerpincode" control-type="Alphanumeric" control-maxlength="7" form="customerInfo" required></div></div></div><!-- <div class="" style="display: block; align: center; margin-top: 20px; margin-bottom: 10px;">\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<label class="label-profile panel-title col-md-offset-1" ><span data-translate="gatewayApp.customerInfo.primaryContactInfo" ></span></label> <br>\r\n\t\t\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t\t \t\t<div class="row" > \r\n\t\t\t\t\t\t\t\t\t\t<label class="col-md-3 control-label col-md-offset-1" cspl-mandatory ><span data-translate="gatewayApp.customerRegistration.name" ></span></label>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t\t\t<cspl-text  control-model = "vm.customerInfo.customer.primaryContactName" control-id="txtprimaeryContactName"  control-type="AlphaWithSpace"  control-maxlength="100" form="customerInfo" required /> \r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row"> \r\n\t\t\t\t\t\t\t\t\t\t<label class="col-md-3 control-label col-md-offset-1" cspl-mandatory ><span data-translate="gatewayApp.customerRegistration.email" ></span></label>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t\t\t<cspl-text  control-model = "vm.customerInfo.customer.primaryEmail" control-type="Email" control-id="txtprimaryemail" control-maxlength=" 100"  control-disabled= "true"   form="customerInfo" required /> \r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<img src="assets/images/EditProfile.png" alt="Avatar"\r\n\t\t\t\t\t\t\t\t\t\t\tstyle="width: 25px; height: 25px; border:0px;" title="Change Email" ng-click="vm.openChangeEmailForCustomer()">\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row"> \r\n\t\t\t\t\t\t\t\t\t\t<label class="col-md-3 control-label col-md-offset-1"  cspl-mandatory><span data-translate="gatewayApp.customerRegistration.mobile" ></span></label>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-lg-2 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t\t\t<cspl-numeric control-model = "vm.customerInfo.customer.primaryMobileCountryCode" control-id="txtprimaryMobileCountryCode"  control-disabled= "true" no-of-decimals="0" control-max="999" form="customerInfo" required /> \r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-4 ">\r\n\t\t\t\t\t\t\t\t\t\t<cspl-text  control-model = "vm.customerInfo.customer.primaryMobile" control-type="Number" control-id="txtprimaryMobile"  control-disabled= "true"\r\n\t\t\t\t\t\t\t\t\t\t\t control-maxlength="15" form="customerInfo" required/> \r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<img src="assets/images/EditProfile.png" alt="Avatar" title="Change Mobile"\r\n\t\t\t\t\t\t\t\t\t\t\tstyle="width: 25px; height: 25px" ng-click="vm.openChangeMobileForCustomer()">\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div> \t\r\n\t\t\t\t\r\n\t\t\t\t\t\t\t<div class="" style="display: block; align: center; margin-top: 20px; margin-bottom: 10px;">\r\n\t\t\t\t\t\t\t\t\t\t<div class="row" > \r\n\t\t\t\t\t\t\t\t\t\t\t<label class="label-profile panel-title col-md-offset-1" ><span data-translate="gatewayApp.customerInfo.alternateContactInfo" ></span></label> <br>\r\n\t\t\t\t\t\t\t\t \t\t</div>\r\n\t\t\t\t\t\t\t\t \t\t<div class="row" > \r\n\t\t\t\t\t\t\t\t \t\t\t<span  class="icon"><img  style="float:left;margin-left:4vh"  src="assets/images/Cust_Onboarding_Accordion_1_22_Dark theme.png" /></span>\r\n\t\t\t\t\t\t\t\t\t\t\t<label style="margin-left:3vh" class="col-md-7 control-label"  ><span data-translate="gatewayApp.customerRegistration.name" ></span></label>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-1">\r\n\t\t\t\t\t\t\t\t\t\t\t<span  class="icon" ><img class="accordionExpansion"  src="assets/images/Accordion_Expand_Line_Dark theme_Lighter shade.png" /></span>\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-9">\r\n\t\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-md-8 " style="padding-left:0vh">\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-text control-model = "vm.customerInfo.customer.alternateContactName1" control-id="txtalternateName1" control-type="AlphaWithSpace"  control-maxlength="100"  form="customerInfo" /> \r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="row"> \r\n\t\t\t\t\t\t\t\t\t\t\t<label class="col-md-3 control-label" style="padding-left:0vh" ><span data-translate="gatewayApp.customerRegistration.email" ></span></label>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-md-8" style="padding-left:0vh">\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-text  control-model = "vm.customerInfo.customer.alternateEmail1" control-type="Email" control-id="txtemail11" control-maxlength=" 100" form="customerInfo" /> \r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="row"> \r\n\t\t\t\t\t\t\t\t\t\t\t<label class="col-md-3 control-label "  style="padding-left:0vh"><span data-translate="gatewayApp.customerRegistration.mobile" ></span></label>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-lg-2 " style="padding-left:0vh">\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-numeric  control-model = "vm.customerInfo.customer.alternateMobileCountryCode1" control-id="txtalternateMobileCountryCode1"  no-of-decimals="0" control-max="999"  control-min="1" form="customerInfo" /> \r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-md-4 ">\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-text control-model = "vm.customerInfo.customer.alternateMobile1" control-type="Number" control-maxlength="15" control-id="txtalternateMobile1" \r\n\t\t\t\t\t\t\t\t\t\t\t\t form="customerInfo" /> \r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<br/>\r\n\t\t\t\t\t\t\t\t \t\t<div class="row" > \r\n\t\t\t\t\t\t\t\t \t\t\t<span  class="icon"><img  style="float:left;margin-left:4vh"  src="assets/images/Cust_Onboarding_Accordion_2_22_Dark theme.png" /></span>\r\n\t\t\t\t\t\t\t\t\t\t\t<label class="col-md-7 control-label" style="margin-left:3vh" ><span data-translate="gatewayApp.customerRegistration.name" ></span></label>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-1">\r\n\t\t\t\t\t\t\t\t\t\t\t<span  class="icon" ><img class="accordionExpansion"  src="assets/images/Accordion_Expand_Line_Dark theme_Lighter shade.png" /></span>\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-9">\r\n\t\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-md-8 " style="padding-left:0vh">\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-text  control-model = "vm.customerInfo.customer.alternateContactName2" control-id="txtalternateName2" control-type="AlphaWithSpace" control-maxlength="100"   form="customerInfo" /> \r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="row"> \r\n\t\t\t\t\t\t\t\t\t\t\t<label class="col-md-3 control-label "  style="padding-left:0vh"><span data-translate="gatewayApp.customerRegistration.email" ></span></label>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-md-8" style="padding-left:0vh">\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-text control-model = "vm.customerInfo.customer.alternateEmail2" control-type="Email" control-id="txtemail12"  control-maxlength=" 100"  form="customerInfo" /> \r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="row"> \r\n\t\t\t\t\t\t\t\t\t\t\t<label class="col-md-3 control-label"  style="padding-left:0vh"><span data-translate="gatewayApp.customerRegistration.mobile" ></span></label>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-lg-2 " style="padding-left:0vh">\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-numeric control-model = "vm.customerInfo.customer.alternateMobileCountryCode2" control-id="txtalternateMobileCountryCode2" control-max="999" control-min="1" no-of-decimals="0" form="customerInfo" /> \r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-md-4">\r\n\t\t\t\t\t\t\t\t\t\t\t<cspl-text  control-model = "vm.customerInfo.customer.alternateMobile2" control-type="Number" control-id="txtalternateMobile2"\r\n\t\t\t\t\t\t\t\t\t\t\t\t control-maxlength="15" form="customerInfo" /> \r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> \r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> --></div></div></div></form></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="clicked" ng-show="showMyProfile" class="btn btn-info active" ng-click="clicked = true;vm.save();" ng-disabled="userprofileForm.$invalid "><span>Save Changes</span></button> <button type="submit" ng-disabled="clicked" ng-show="showMyPreferences" class="btn btn-info active" ng-click="vm.restoreDefault();clicked = true;"><span>RESTORE DEFAULT</span></button> <button type="submit" ng-show="showMyPreferences" class="btn btn-info active" ng-disabled="myPreferencesForm.$invalid || vm.errorText1!=\'\' || vm.errorText2!=\'\' || vm.errorText3!=\'\' || vm.errorText4!=\'\' || vm.errorText5!=\'\'||clicked" ng-click="clicked = true;vm.savePreferences();clicked = true;"><span>Save Changes</span></button> <button type="submit" ng-if="showMyPreferences==false && showMyProfile==false" ng-disabled="customerInfo.$invalid||clicked" class="btn btn-info active" ng-click="vm.saveCustomerInfo();"><span>Save Changes</span></button></div></div>');
$templateCache.put('app/entities/userwise-turnover-report/userwise-turnover-report.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.userwiseTurnoverReport.title" data-translate-values="{value: {{vm.todayDate}}}">Userwise Turnover Report</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion" ng-if="vm.userEntityOwnerType !=\'SingleUserCustomer\'"><div class="criteria"><h4 class="panel-title" style="width: 400px;  margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseUserwiseTurnoverReport = !vm.ExpandOrCollapseUserwiseTurnoverReport" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#UserwiseTurnoverReport"><img ng-src="{{vm.ExpandOrCollapseUserwiseTurnoverReport == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.userwiseTurnoverReport.criteria">Criteria</span></a></h4></div><div id="UserwiseTurnoverReport" class="collapse in" style="background-color: black" ng-if="vm.userEntityOwnerType !=\'SingleUserCustomer\'"><div class="accordion-content1"><form class="" role="form" name="userwiseTurnoverReportForm"><div class="row"><cspl-entity-lookup user-entity-owner-type="vm.userEntityOwnerType" show-clear-corp="vm.showCCIL" selected-entity-owner-type="vm.selectedEntityOwnerType" show-user="vm.hideUser" user-lookup="vm.userLookup" bank-value="vm.bankValue" branch-value="vm.branchValue" customer-value="vm.customerValue" user-value="vm.userValue" user-list-value="vm.userListValue" show-terminated-branch="false" control-class="col-md-offset-3 col-md-3" control-form="userwiseTurnoverReportForm"></cspl-entity-lookup></div><div class="form-group"><div class="row"><label class="col-md-offset-3 control-label col-xs-6 col-md-6"><span data-translate="gatewayApp.userwiseTurnoverReport.date"></span></label><div class="col-md-offset-3 col-md-3"><cspl-dtp control-model="vm.todayDate" control-id="dtpdate" control-disabled="true" required></cspl-dtp></div><div class="col-md-1 col-sm-1"><button class="btn btn-info active" ng-disabled="userwiseTurnoverReportForm.$invalid||vm.clicked" ng-click="vm.getUserWiseTurnover();vm.clicked=true;" data-toggle="collapse" data-target="#UserwiseTurnoverReport" data-translate="gatewayApp.userwiseTurnoverReport.go"></button></div></div></div></form></div></div></div><div ng-show="vm.userwiseTurnoverHeader.length > 0"><div class="row"><div class="dropdown col-md-3" style="width:10%"><div class="dropdown-toggle" id="dropdownMenu-user" data-toggle="dropdown" aria-expanded="true" role="button"><button class="btn btn-primary btn-sm dropdown-toggle importExport" style="border:none"><img src="assets/images/Export_01.png"></button></div><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu-user"><li><a ng-click="vm.exportToFile(\'csv\');">CSV</a></li><li><a ng-click="vm.exportToFile(\'excel\');">XLS</a></li></ul></div></div><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="userwiseTurnoverHeader" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.userwiseTurnoverReport.bank"></th><th data-translate="gatewayApp.userwiseTurnoverReport.branch"></th><th data-translate="gatewayApp.userwiseTurnoverReport.user"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.userwiseTurnoverReport.buyTrades"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.userwiseTurnoverReport.totalBuyQuantity"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.userwiseTurnoverReport.sellTrades"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.userwiseTurnoverReport.totalSellQuantity"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.userwiseTurnoverReport.totalTrades"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.userwiseTurnoverReport.totalTurnover"></th></tr></thead><tbody><tr ng-repeat="userwiseTurnover in filterData = (vm.userwiseTurnoverHeader | filter : filterText)| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)" ng-click="vm.getUserwiseTurnoverDetails(userwiseTurnover)"><td>{{userwiseTurnover.bankName}}</td><td>{{userwiseTurnover.branchName}}</td><td>{{userwiseTurnover.login}}</td><td class="td-text-align-right noPaddingLeftRight">{{userwiseTurnover.totalBuyTrades}}</td><td class="td-text-align-right" style="padding-right:10px">{{userwiseTurnover.usd_buy_total|number:vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right noPaddingLeftRight">{{userwiseTurnover.totalSellTrades}}</td><td class="td-text-align-right" style="padding-right:10px">{{userwiseTurnover.usd_sell_total|number:vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right noPaddingLeftRight">{{userwiseTurnover.totalTrades}}</td><td class="td-text-align-right" style="padding-right:10px">{{userwiseTurnover.total_turnover|number:vm.noOfDecimalsForAmount}}</td></tr></tbody></table></div></div><div ng-show="vm.userwiseTurnoverHeader.length > 0"><span class="orderStatusInfo" data-translate="gatewayApp.userwiseTurnoverReport.legend"></span></div></div><div ng-show="vm.userwiseTurnoverHeader.length == 0"><span>No record found</span></div><div ng-show="vm.userwiseTurnoverHeader.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div><div ng-show="vm.userwiseTurnoverDetails.length>0" style="padding-right: 10px;padding-left: 10px"><div class="row"><cspl-table-search control-model="filterTextForDetails" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden" ng-show="vm.isShowDetails"><table id="userwiseTurnoverDetails" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.userwiseTurnoverReport.bank"></th><th data-translate="gatewayApp.userwiseTurnoverReport.branch"></th><th data-translate="gatewayApp.userwiseTurnoverReport.custId"></th><th data-translate="gatewayApp.userwiseTurnoverReport.customerName"></th><th data-translate="gatewayApp.userwiseTurnoverReport.user"></th><th data-translate="gatewayApp.userwiseTurnoverReport.buySellFlag"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.userwiseTurnoverReport.tradeAmount"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.userwiseTurnoverReport.tradeExchangeRate"></th><th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.userwiseTurnoverReport.currencyPair"></th></tr></thead><tbody><tr ng-repeat="userwiseTurnoverDetail in filterDeatilData = (vm.userwiseTurnoverDetails | filter : filterTextForDetails)| limitTo:noOfRecordsPerPage1:noOfRecordsPerPage1*(page1-1)"><td>{{userwiseTurnoverDetail.bank.bankName}}</td><td>{{userwiseTurnoverDetail.branch.branchName}}</td><td>{{userwiseTurnoverDetail.customer.customerCode}}</td><td ng-show="userwiseTurnoverDetail.customer.customerMiddleName!=null">{{userwiseTurnoverDetail.customer.customerFirstName+\' \'+userwiseTurnoverDetail.customer.customerMiddleName+\' \'+userwiseTurnoverDetail.customer.customerLastName}}</td><td ng-show="userwiseTurnoverDetail.customer.customerMiddleName==null">{{userwiseTurnoverDetail.customer.customerFirstName+\' \'+userwiseTurnoverDetail.customer.customerLastName}}</td><td>{{userwiseTurnoverDetail.retailUser.login}}</td><td>{{userwiseTurnoverDetail.buySellFlag}}</td><td class="td-text-align-right noPaddingLeftRight">{{userwiseTurnoverDetail.tradeAmount|number:vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right" style="padding-right:10px">{{userwiseTurnoverDetail.tradeExchangeRate|number:vm.noOfDecimalsForRate}}</td><td class="td-text-align-right" style="padding-right:10px">{{userwiseTurnoverDetail.currencyPair.code}}</td></tr></tbody></table></div></div><div ng-show="vm.userwiseTurnoverDetails.length > 0"><cspl-pagination record-count="filterDeatilData.length" control-model="page1" items-per-page="noOfRecordsPerPage1"></cspl-pagination></div></section></div><script src="assets/js/tables.js"></script></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<style>.form-control {\r\n\tpadding-left: 30px;\r\n}</style><div class="layout-no-leftnav"><section class="login-section auth-section"><div class="container"><div class="row"><div class="form-box col-md-5 col-md-offset-3"><h1 class="form-box-heading text-center"><span class=""></span><span><img src="assets/images/Logo_And_Text.png" style="height: 55px; border-bottom: 15px"></span></h1><div class="form-box-inner"><div class="row"><form ng-show="!vm.success" name="form" role="form" novalidate show-validation><label class="col-sm-6 col-md-offset-3 Control-Label" ng-show="!vm.IsPendingEmailChangeAlreadyDiscarded"><span data-translate="gatewayApp.userProfile.changeEmailVerification"></span></label><label class="col-sm-6 col-md-offset-3 Control-Label" ng-show="vm.IsPendingEmailChangeAlreadyDiscarded"><span data-translate="gatewayApp.userProfile.changeEmailDiscarded"></span></label></form></div></div></div></div></div></section></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<style>.form-control {\r\n  padding-left: 30px;\r\n}</style><div class="layout-no-leftnav"><section class="login-section auth-section"><div class="container"><div class="row"><div class="form-box"><h1 class="form-box-heading"><span class=""></span><span><img src="assets/images/ClearCorp.png" style="height:46px;border-bottom:15px;margin-left:16px"> <img style="margin-left: 13%;border-bottom: 15px" src="assets/images/FX_CR.png"> <span ng-if="vm.environmentName!=\'\' &&  vm.environmentName!=undefined &&  vm.environmentName!=null" style="margin-bottom: 30px" class="btn-reg fw-bolder environment-name">{{vm.environmentName}}</span></span></h1><div class="form-box-inner"><h2 class="title text-center" data-translate="reset.request.title" ng-show="vm.action==\'RESET\'">Reset your password</h2><h2 class="title text-center" data-translate="reset.request.title1" ng-show="vm.action==\'UNLOCK\'">Unlock your account</h2><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailOrMobileNotExists"><strong>E-mail address or mobile isn\'t registered!</strong><br>Please check and try again.</div><div class="alert alert-danger" data-translate="reset.request.messages.attemptsBreached" ng-show="vm.errorEmailSendAttemptsBreached"><strong>Maximum attempts to send Email is Breached..!</strong><br>Please try after sometime.</div><div class="alert alert-danger" data-translate="reset.request.messages.notlocked" ng-show="vm.errorUserNotLocked && vm.success != \'OK\'"><strong>This user is not locked!</strong></div><div class="row"><div class="auth-section-form-container"><form name="form" role="form" novalidate show-validation><div class="form-group email"><span class="fa fa-envelope icon"></span> <input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" class="form-control" ng-model="vm.resetAccount.email" autocomplete="off" required></div><div class="form-group email"><span class="fa fa-phone icon"></span> <input type="text" class="form-control" id="mobile" name="mobile" placeholder="{{\'global.form.mobile.placeholderWithLabel\' | translate}}" maxlength="15" class="form-control" ng-model="vm.resetAccount.mobile" autocomplete="off" required></div><div class="modal-footer"><!-- \t\t\t\t\t\t\t\t\t \t<button type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.login()">\r\n\t\t\t\t\t\t\t\t\t\t\t<span data-translate="reset.request.form.cancelbutton">Cancel</span>\r\n\t\t\t\t\t\t\t\t\t\t</button> --> <button type="submit" ng-if="vm.action==\'RESET\'" ng-disabled="form.$invalid ||(vm.success == \'OK\' && vm.action==\'RESET\') || vm.clicked" class="btn btn-primary" ng-click="vm.clicked = true;vm.requestReset();"><span data-translate="reset.request.form.button">Reset</span></button> <button type="submit" ng-if="vm.action==\'UNLOCK\'" ng-disabled="form.$invalid || (vm.success == \'OK\' && vm.action==\'UNLOCK\') || vm.clicked" class="btn btn-primary" ng-click="vm.clicked = true;vm.requestUnlock();"><span data-translate="reset.request.form.unlock">Unlock</span></button></div></form></div></div><br><div class="alert alert-info" ng-show="vm.success == \'OK\' && vm.action==\'UNLOCK\'"><p data-translate="reset.request.messages.successUnlock">Your account has been unlocked and new password credentials will be sent to your registered mail ID shortly</p></div><div class="alert alert-info" ng-show="vm.success == \'OK\' && vm.action==\'RESET\'"><p data-translate="reset.request.messages.successReset">New password credentials will be sent to your registered mail ID shortly</p></div></div></div></div></div></section></div>');
$templateCache.put('app/account/reset/customerEmailChange/reset.finish.html','<style>.form-control {\r\n\tpadding-left: 30px;\r\n}</style><div class="layout-no-leftnav"><section class="login-section auth-section"><div class="container"><div class="row"><div class="form-box col-md-5 col-md-offset-3"><h1 class="form-box-heading text-center"><span class=""></span><span><img src="assets/images/Logo_And_Text.png" style="height: 55px; border-bottom: 15px"></span></h1><div class="form-box-inner"><div class="row"><form ng-show="!vm.success" name="form" role="form" novalidate show-validation><label class="col-sm-6 col-md-offset-3 Control-Label" ng-show="!vm.IsPendingEmailChangeAlreadyDiscarded"><span data-translate="gatewayApp.userProfile.changeEmailVerificationForCustomer"></span></label><label class="col-sm-6 col-md-offset-3 Control-Label" ng-show="vm.IsPendingEmailChangeAlreadyDiscarded"><span data-translate="gatewayApp.userProfile.changeEmailDiscarded"></span></label></form></div></div></div></div></div></section></div>');
$templateCache.put('app/components/cspl-controls/cspl-checkbox/cspl-checkbox.html','<label for="id" style="word-wrap:break-word" ng-attr-style="color:{{color}};"><input type="checkbox" ng-model="value" id="id" ng-checked="value" class="glyphicon" ng-class="{ \'icon_box-empty\': !value, \'icon_box-checked\': value }" ng-disabled="{{ngDisabled}}" ng-change="onChange()">&nbsp;<span style="vertical-align: bottom">{{labelValue}}</span></label>');
$templateCache.put('app/entities/order-history/order-history.html','<div class="container-fluid"><div ncy-breadcrumb></div><h2 class="view-title" data-translate="global.menu.orderHistory.title">Order History</h2><nmb-alert></nmb-alert><div class="module-wrapper"><section class="module"><div class="module-inner"><div id="accordion"><div class="criteria"><h4 class="panel-title" style="width: 400px; margin-bottom: 10px"><a href="javascript:;" ng-click="vm.ExpandOrCollapseOrderHistory = !vm.ExpandOrCollapseOrderHistory" style="background-color: black; color: white; text-decoration: none" data-toggle="collapse" data-parent="#accordion" data-target="#OrderHistory"><img ng-src="{{vm.ExpandOrCollapseOrderHistory == false && \'assets/images/Accordion_expand.png\' || \'assets/images/Accordion_collapse.png\'}}"> &nbsp;<span data-translate="gatewayApp.orderHistory.criteria">Criteria</span></a></h4></div><div id="OrderHistory" ng-class="{\'collapse in\':vm.valid}" style="background-color: black"><div class="accordion-content1"><form class="" role="form" name="orderHistoryForm"><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\'"><label class="control-label"><span data-translate="gatewayApp.orderHistory.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtbank" lookup-name="bank" display-column="bankName" placeholder="" form="orderHistoryForm"></div><div class="form-group" ng-if="vm.entityOwnerType==\'MultiUserCustomer\' || vm.entityOwnerType==\'SingleUserCustomer\'"><label class="control-label"><span data-translate="gatewayApp.orderHistory.bank"></span></label><cspl-ach control-model="vm.bank" control-id="txtTradingbank" lookup-name="tradingBank" display-column="shortName" placeholder="" form="orderHistoryForm" filter-value="{{vm.loggedInCustomer}}"></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\'"><label class="control-label"><span data-translate="gatewayApp.orderHistory.branch"></span></label><cspl-ach control-model="vm.branch" control-id="txtBranch" lookup-name="branchesForBank" display-column="branchName" placeholder="" form="orderHistoryForm" filter-value="{{vm.bank.id}}"></div><div class="form-group" ng-if="vm.entityOwnerType==\'Clearcorp\' || vm.entityOwnerType==\'Bank\' || vm.entityOwnerType==\'Branch\'"><label class="control-label"><span data-translate="gatewayApp.orderHistory.customer"></span></label><cspl-ach control-model="vm.customer" control-id="txtCustomer" lookup-name="allTypeCustomers" filter-value="{{vm.bank.id}}~~{{vm.branch.id}}" control-place-holder="Enter Customer ID or Name" display-column="customerCode,customerName" placeholder="" form="orderHistoryForm"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.orderHistory.currencyPair"></span></label><cspl-ach control-model="vm.currencyPair" control-id="txtCurrencyPair" lookup-name="currencyPair" display-column="code" placeholder="" form="orderHistoryForm" filter-value="{{ vm.bank.id ? vm.bank.id : 0 }}"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.orderHistory.instrument"></span></label><cspl-ach control-model="vm.instrument" control-id="txtInstrument" lookup-name="marketInstrumentsCurrency" filter-value="{{ vm.currencyPair.id ? vm.currencyPair.id : 0 }}" display-column="instrumentCode" placeholder="" form="orderHistoryForm"></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.orderHistory.buySell"></span></label><select class="form-control select-style select-notRequired" name="buySell" ng-model="vm.buySell" ng-options="buySell for buySell in vm.buySellIndicators" form="orderHistoryForm"><option value="">--ALL--</option></select></div><div class="form-group"><label class="control-label"><span data-translate="gatewayApp.orderHistory.orderStatus"></span></label><cspl-ach control-model="vm.orderStatus" control-id="txtOrderStatus" lookup-name="orderStatus" display-column="name" placeholder="" form="orderHistoryForm"></div></div><div class="form-group"><div class="row"><label class="col-md-offset-3 control-label col-xs-6 col-md-6" cspl-mandatory><span data-translate="gatewayApp.orderHistory.reportPeriod"></span></label><div class="col-md-offset-3 col-md-5 col-sm-6 col-xs-10 col-lg-3"><cspl-dtp control-model="vm.fromDate" control-id="dtpFromDate" form="orderHistoryForm" control-min-date="vm.minDate" control-max-date="vm.yesterdayDate" required></div><div class="col-md-5 col-sm-6 col-xs-10 col-lg-3"><cspl-dtp control-model="vm.toDate" control-id="dtpToDate" form="orderHistoryForm" control-min-date="vm.minDate" required></div><div class="col-md-1 col-sm-1"><button class="btn btn-info active" ng-disabled="orderHistoryForm.$invalid||vm.clicked" ng-click="vm.getOrderHistory();" data-toggle="collapse" data-target="#OrderHistory" data-translate="gatewayApp.orderHistory.go"></button></div></div><div class="row"><div class="col-md-offset-3 col-md-6 justified-help-block" style="padding-left:7px"><span data-translate="gatewayApp.orderHistory.helpText"></span></div></div></div></form></div></div></div><div ng-show="vm.orderHistory.length > 0"><div class="row"><cspl-table-export class="col-md-1 col-sm-1 col-xs-1" table-name="orderHistory" total-record-count="filterData.length" no-of-records-per-page="noOfRecordsPerPage" page-no="page" file-name="Order_History"></cspl-table-export><cspl-table-search control-model="filterText" class="col-md-2 col-sm-3 col-xs-4 right-floating"></cspl-table-search></div><div class="table-responsive" style="overflow-x: auto; overflow-y: hidden"><table id="orderHistory" class="dataTable table table-striped table-hover"><thead><tr><th data-translate="gatewayApp.orderHistory.bank"></th><th data-translate="gatewayApp.orderHistory.branch"></th><th data-translate="gatewayApp.orderHistory.branchId"></th><th data-translate="gatewayApp.orderHistory.custId"></th><th data-translate="gatewayApp.orderHistory.customer"></th><th data-translate="gatewayApp.orderHistory.currencyPair"></th><th data-translate="gatewayApp.orderHistory.instrument"></th><th data-translate="gatewayApp.orderHistory.orderType"></th><th data-translate="gatewayApp.orderHistory.buySell"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.orderHistory.orderQuantity"></th><th class="td-text-align-right" style="padding-right: 10px" data-translate="gatewayApp.orderHistory.tradedQuantity"></th><th data-translate="gatewayApp.orderHistory.priceCondition"></th><th class="td-text-align-right noPaddingLeftRight" data-translate="gatewayApp.orderHistory.orderPrice"></th><th class="td-text-align-right padding-right-0" data-translate="gatewayApp.orderHistory.swapPtsInPaise"></th><th class="td-text-align-right padding-right-0" data-translate="gatewayApp.orderHistory.equivalentSpotPrice"></th><th data-translate="gatewayApp.orderHistory.timeCondition"></th><th data-translate="gatewayApp.orderHistory.orderDateTime"></th><th data-translate="gatewayApp.orderHistory.orderNumber"></th><th data-translate="gatewayApp.orderHistory.settlementStartDate"></th><th data-translate="gatewayApp.orderHistory.settlementDate"></th><th data-translate="gatewayApp.orderHistory.orderStatus"></th><th data-translate="gatewayApp.orderHistory.actionBy"></th><th data-translate="gatewayApp.orderHistory.userRemarks1"></th><th data-translate="gatewayApp.orderHistory.userRemarks2"></th><th data-translate="gatewayApp.orderHistory.userRemarks3"></th><th data-translate="gatewayApp.orderHistory.userRemarks4"></th><th data-translate="gatewayApp.orderHistory.exposureType"></th><th data-translate="gatewayApp.orderHistory.exposureSubType"></th><th data-translate="gatewayApp.orderHistory.placedAsSplitOrder"></th><th data-translate="gatewayApp.orderHistory.deliveryMode"></th><th data-translate="gatewayApp.orderHistory.source"></th><!-- <th data-translate="gatewayApp.orderHistory.gttTime"></th>\r\n\t\t\t\t\t<th class="td-text-align-right" style="padding-right:10px" data-translate="gatewayApp.orderHistory.triggerPrice"></th> --></tr></thead><tbody><tr ng-repeat="orderHistory in filterData = (vm.orderHistory | filter : filterText | orderBy: \'-orderSequenceNumber\')| limitTo:noOfRecordsPerPage:noOfRecordsPerPage*(page-1)"><td>{{orderHistory.bankName}}</td><td>{{orderHistory.branchName}}</td><td>{{orderHistory.branchCode}}</td><td>{{orderHistory.customerCode}}</td><td>{{orderHistory.customerName}}</td><td style="padding-right: 10px">{{orderHistory.currencyPairCode}}</td><td>{{orderHistory.instrumentCode}}</td><td>{{orderHistory.orderTypeName}}</td><td>{{orderHistory.buySellIndicator}}</td><td class="td-text-align-right noPaddingLeftRight">{{orderHistory.orderQuantity| number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right" style="padding-right: 10px">{{orderHistory.tradedValue | number : vm.noOfDecimalsForAmount}}</td><td>{{orderHistory.priceCondition}}</td><td class="td-text-align-right noPaddingLeftRight">{{orderHistory.orderPrice| number : vm.noOfDecimalsForRate}}</td><td class="td-text-align-right noPaddingLeftRight">{{vm.getSwapPoints(orderHistory.equivalentSpotPrice,orderHistory.orderPrice)| number : vm.noOfDecimalsForAmount}}</td><td class="td-text-align-right noPaddingLeftRight">{{orderHistory.equivalentSpotPrice| number : vm.noOfDecimalsForRate}}</td><td align="center">{{orderHistory.timeCondition | limitTo: 3}}</td><td nowrap="nowrap">{{orderHistory.orderDateTime | date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td><a ui-sref="order-activity-order-history({orderNumber:orderHistory.orderSequenceNumber})" style="text-decoration:underline">{{orderHistory.orderSequenceNumber}}</a></td><td><span ng-if="orderHistory.settlementStartDate !=null">{{orderHistory.settlementStartDate| date:\'dd-MMM-yyyy\'}}</span> <span ng-if="orderHistory.settlementStartDate ==null">{{\'\'}}</span></td><td><span ng-if="orderHistory.settlementDate != null && orderHistory.settlementDate != undefined">{{orderHistory.settlementDate | date:\'dd-MMM-yyyy\'}}</span></td><td align="center">{{orderHistory.orderStatus}}</td><td>{{orderHistory.actionBy}}</td><td>{{orderHistory.userRemarks || \'-\'}}</td><td>{{orderHistory.remarks2 || \'-\'}}</td><td>{{orderHistory.remarks3 || \'-\'}}</td><td>{{orderHistory.remarks4 || \'-\'}}</td><td>{{orderHistory.exposureTypeName || \'-\'}}</td><td>{{orderHistory.exposureSubTypeName || \'-\'}}</td><td nowrap="nowrap" ng-show="orderHistory.isSplitOrder==true">Yes</td><td nowrap="nowrap" ng-show="orderHistory.isSplitOrder==false">No</td><!-- <td>{{(orderHistory.gttTime| date:\'HH:mm\') || \'-\'}}</td>\r\n\t\t\t\t<td class="td-text-align-right" style="padding-right:10px" >{{(orderHistory.triggerPrice| number : vm.noOfDecimalsForRate) || \'-\'}}</td> --><td style="padding-right: 10px">{{orderHistory.deliveryMode || \'-\'}}</td><td style="padding-right: 10px">{{orderHistory.sourceAppName}}</td></tr></tbody></table></div><br><div ng-show="vm.orderHistory.length > 0"><cspl-pagination record-count="filterData.length" control-model="page" items-per-page="noOfRecordsPerPage"></cspl-pagination></div></div></div><div class="table-responsive" ng-show="vm.orderHistory.length==0"><span>No record found</span></div></section></div><script src="assets/js/tables.js"></script></div>');}]);})();